var $E = Object.defineProperty;
var _E = (e, t, s) => t in e ? $E(e, t, { enumerable: !0, configurable: !0, writable: !0, value: s }) : e[t] = s;
var Xe = (e, t, s) => _E(e, typeof t != "symbol" ? t + "" : t, s);
import X, { isAxiosError as Yh } from "axios";
import { Chart as Rt, BarController as Xr, LinearScale as qr, CategoryScale as Qr, BarElement as Kr, LineController as Zr, PointElement as Jr, LineElement as $r, PieController as eI, DoughnutController as Pi, ArcElement as ki, Title as Ei, Tooltip as Ii, Legend as Ti, Filler as Oi, registerables as tP } from "chart.js";
import { defineComponent as me, createElementBlock as h, openBlock as p, Fragment as A, createElementVNode as a, renderSlot as Ot, mergeProps as Rs, createApp as tI, markRaw as Ki, toRaw as jr, nextTick as Vc, ref as Ds, computed as Ke, watch as Jn, createCommentVNode as P, normalizeClass as z, renderList as D, toDisplayString as g, resolveComponent as pe, withDirectives as V, vModelText as _e, createStaticVNode as Bt, createVNode as N, createTextVNode as y, vModelCheckbox as Ue, createBlock as Fe, withCtx as ve, resolveDynamicComponent as lu, vShow as Us, withModifiers as mn, normalizeStyle as rn, Transition as ks, vModelSelect as We, resolveDirective as Za, withKeys as wo, vModelRadio as Mt, mergeModels as hd, useModel as sd, inject as sP, useTemplateRef as rv, onMounted as aP, unref as st, createSlots as nP, toValue as md, shallowRef as sI, watchEffect as aI, getCurrentInstance as nI, provide as rI, useId as oI, h as rP, Teleport as iI, normalizeProps as Mr, guardReactiveProps as oP, useSlots as iP } from "vue";
import { defineStore as _r, mapState as q, mapStores as at, storeToRefs as Mm, mapWritableState as xm } from "pinia";
import lI from "./assets/images/logo-rescover-ab22af0a.svg";
import dI from "./assets/images/logo-rescover-white-cf05e874.svg";
import Wo from "primevue/tooltip";
import lP from "primevue/listbox";
import cI from "./assets/images/model-leasing-69d8fcac.png";
import uI from "./assets/images/model-stabilization-358e16c8.png";
import pI from "./assets/images/model-vacancy-50840c4a.png";
import yn from "primevue/datatable";
import bn from "primevue/column";
import hl from "primevue/select";
import Fm from "./assets/images/icon-rescover-8d529166.svg";
import hI from "./assets/images/logo-rescover-ab22af0a.svg?no-inline";
import Vm from "primevue/paginator";
import mI from "primevue/overlaypanel";
import fI from "./assets/images/tile-existing-investment-dc33ea7f.png";
import gI from "./assets/images/logo-LeadSimple-d6feea26.svg?no-inline";
import _y from "primevue/progressbar";
import vI from "shepherd.js";
import yI from "primevue/button";
import e1 from "primevue/autocomplete";
import bI from "./assets/portfolio-finder/for-sale-32-e3f342d0.png";
import AI from "./assets/portfolio-finder/sold-32-f9c5c9b3.png";
import wI from "./assets/portfolio-finder/for-rent-32-3131944f.png";
import CI from "./assets/images/logo-ActiveCampaign-d2011cde.svg?no-inline";
import SI from "primevue/carousel";
import { default as dcs } from "primevue/config";
let t1 = class {
  static format(t, s, n, r, i) {
    var o = Array.prototype.slice.call(arguments);
    return o.shift(), [...o].reduce((l, d) => l.replace(/%s/, d ?? ""), t).replace(/%s/, "");
  }
}, $d;
function dP(e) {
  const t = {
    languageCodeOnly: !1,
    ...e
  };
  if ($d = $d ?? (navigator.languages === void 0 ? [navigator.language] : [...navigator.languages]), !(!$d || $d.length == 0))
    return $d.map((s) => {
      const n = s.trim();
      return t.languageCodeOnly ? n.split(/-|_/)[0] : n;
    });
}
function cP(e) {
  return (dP() ?? [e])[0];
}
const sA = 100;
function PI(e, t, s) {
  const n = e * 1e3 * 6 / sA;
  let r = 0;
  return new Promise((i) => {
    const o = setInterval(() => {
      r += 6, r >= n && (clearInterval(o), i(s)), t && t(Math.trunc(r / n * 100));
    }, sA);
  });
}
const Dc = {
  validateStatus: (e) => e < 400 || e == 400 || e == 500
};
let _u;
function Kp() {
  if (_u != null) return _u;
  try {
    var e = window.localStorage, t = "__storage_test__";
    return e.setItem(t, t), e.removeItem(t), _u = !0;
  } catch (s) {
    return _u = s instanceof DOMException && // everything except Firefox
    (s.code === 22 || // Firefox
    s.code === 1014 || // test name field too, because code might not be present
    // everything except Firefox
    s.name === "QuotaExceededError" || // Firefox
    s.name === "NS_ERROR_DOM_QUOTA_REACHED") && // acknowledge QuotaExceededError only if there's something already stored
    window.localStorage && window.localStorage.length !== 0;
  }
}
const G = "https://api.rescover.com/v2".replace(/\/+$/, "");
class Fn {
  constructor(t, s = G, n = X) {
    Xe(this, "configuration");
    this.basePath = s, this.axios = n, t && (this.configuration = t, this.basePath = t.basePath ?? s);
  }
}
let kI = class extends Error {
  constructor(t, s) {
    super(s), this.field = t, this.name = "RequiredError";
  }
};
const Q = {}, K = "https://example.com", se = function(e, t, s) {
  if (s == null)
    throw new kI(t, `Required parameter ${t} was null or undefined when calling ${e}.`);
}, Lt = async function(e, t, s) {
  if (s && s.apiKey) {
    const n = typeof s.apiKey == "function" ? await s.apiKey(t) : await s.apiKey;
    n && (e[t] = n);
  }
}, ee = async function(e, t) {
  if (t && t.accessToken) {
    const s = typeof t.accessToken == "function" ? await t.accessToken() : await t.accessToken;
    s && (e.Authorization = "Bearer " + s);
  }
};
function ov(e, t, s = "") {
  t != null && (typeof t == "object" ? Array.isArray(t) ? t.forEach((n) => ov(e, n, s)) : Object.keys(t).forEach(
    (n) => ov(e, t[n], `${s}${s !== "" ? "." : ""}${n}`)
  ) : e.has(s) ? e.append(s, t) : e.set(s, t));
}
const Z = function(e, ...t) {
  const s = new URLSearchParams(e.search);
  ov(s, t), e.search = s.toString();
}, kt = function(e, t, s) {
  const n = typeof e != "string";
  return (n && s && s.isJsonMime ? s.isJsonMime(t.headers["Content-Type"]) : n) ? JSON.stringify(e !== void 0 ? e : {}) : e || "";
}, J = function(e) {
  return e.pathname + e.search + e.hash;
}, _ = function(e, t, s, n) {
  return (r = t, i = s) => {
    const o = { ...e.options, url: (r.defaults.baseURL ? "" : (n == null ? void 0 : n.basePath) ?? i) + e.url };
    return r.request(o);
  };
}, EI = function(e) {
  return {
    /**
     * 
     * @summary Retrieve access list for user.
     * @param {string} [mls] MLS to check if user is entitled.
     * @param {string} [t] Random number to force refresh
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    access: async (t, s, n = {}) => {
      const r = "/account/access", i = new URL(r, K);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "GET", ...o, ...n }, d = {}, c = {};
      await Lt(d, "x-api-key", e), await ee(d, e), t !== void 0 && (c.mls = t), s !== void 0 && (c.t = s), Z(i, c);
      let u = o && o.headers ? o.headers : {};
      return l.headers = { ...d, ...u, ...n.headers }, {
        url: J(i),
        options: l
      };
    },
    /**
     * 
     * @summary Add ZipCode to users featured list
     * @param {string} zipCode 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addFeaturedZipCode: async (t, s = {}) => {
      se("addFeaturedZipCode", "zipCode", t);
      const n = "/account/featured/zip-codes/{zipCode}".replace("{zipCode}", encodeURIComponent(String(t))), r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "POST", ...i, ...s }, l = {}, d = {};
      await ee(l, e), Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, {
        url: J(r),
        options: o
      };
    },
    /**
     * 
     * @summary Get AVM adjustment settings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAvmAdjustmentSettings: async (t = {}) => {
      const s = "/account/avm-adjustments", n = new URL(s, K);
      let r;
      e && (r = e.baseOptions);
      const i = { method: "GET", ...r, ...t }, o = {}, l = {};
      await Lt(o, "x-api-key", e), await ee(o, e), Z(n, l);
      let d = r && r.headers ? r.headers : {};
      return i.headers = { ...o, ...d, ...t.headers }, {
        url: J(n),
        options: i
      };
    },
    /**
     * 
     * @summary List account\'s marketing boundaries.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getBoundaries: async (t = {}) => {
      const s = "/account/boundaries", n = new URL(s, K);
      let r;
      e && (r = e.baseOptions);
      const i = { method: "GET", ...r, ...t }, o = {}, l = {};
      await ee(o, e), Z(n, l);
      let d = r && r.headers ? r.headers : {};
      return i.headers = { ...o, ...d, ...t.headers }, {
        url: J(n),
        options: i
      };
    },
    /**
     * 
     * @summary List clients featured zip codes.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getFeaturedZipCodes: async (t = {}) => {
      const s = "/account/featured/zip-codes", n = new URL(s, K);
      let r;
      e && (r = e.baseOptions);
      const i = { method: "GET", ...r, ...t }, o = {}, l = {};
      await ee(o, e), Z(n, l);
      let d = r && r.headers ? r.headers : {};
      return i.headers = { ...o, ...d, ...t.headers }, {
        url: J(n),
        options: i
      };
    },
    /**
     * 
     * @summary Get options for account settings.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getOptions: async (t = {}) => {
      const s = "/account/options", n = new URL(s, K);
      let r;
      e && (r = e.baseOptions);
      const i = { method: "GET", ...r, ...t }, o = {}, l = {};
      await ee(o, e), Z(n, l);
      let d = r && r.headers ? r.headers : {};
      return i.headers = { ...o, ...d, ...t.headers }, {
        url: J(n),
        options: i
      };
    },
    /**
     * 
     * @summary Get info for account.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    info: async (t = {}) => {
      const s = "/account/info", n = new URL(s, K);
      let r;
      e && (r = e.baseOptions);
      const i = { method: "GET", ...r, ...t }, o = {}, l = {};
      await ee(o, e), Z(n, l);
      let d = r && r.headers ? r.headers : {};
      return i.headers = { ...o, ...d, ...t.headers }, {
        url: J(n),
        options: i
      };
    },
    /**
     * 
     * @param {LoginRouteModel} [loginRouteModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loginRoute: async (t, s = {}) => {
      const n = "/account/login-route", r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "POST", ...i, ...s }, l = {}, d = {};
      l["Content-Type"] = "application/json", Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, o.data = kt(t, o, e), {
        url: J(r),
        options: o
      };
    },
    /**
     * 
     * @summary Simple ping to test if still valid.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    ping: async (t = {}) => {
      const s = "/account/ping", n = new URL(s, K);
      let r;
      e && (r = e.baseOptions);
      const i = { method: "GET", ...r, ...t }, o = {}, l = {};
      await ee(o, e), Z(n, l);
      let d = r && r.headers ? r.headers : {};
      return i.headers = { ...o, ...d, ...t.headers }, {
        url: J(n),
        options: i
      };
    },
    /**
     * 
     * @summary Remove ZipCode to users featured list
     * @param {string} zipCode 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    removeFeaturedZipCode: async (t, s = {}) => {
      se("removeFeaturedZipCode", "zipCode", t);
      const n = "/account/featured/zip-codes/{zipCode}".replace("{zipCode}", encodeURIComponent(String(t))), r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "DELETE", ...i, ...s }, l = {}, d = {};
      await ee(l, e), Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, {
        url: J(r),
        options: o
      };
    },
    /**
     * 
     * @summary 
     * @param {IndustryDesignationRequest} [industryDesignationRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    requestIndustryDesignation: async (t, s = {}) => {
      const n = "/account/options/industry-designations", r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "POST", ...i, ...s }, l = {}, d = {};
      await ee(l, e), l["Content-Type"] = "application/json", Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, o.data = kt(t, o, e), {
        url: J(r),
        options: o
      };
    },
    /**
     * 
     * @summary Save Account Schedule Link
     * @param {string} [scheduleLink] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    setScheduleLink: async (t, s = {}) => {
      const n = "/account/schedule-link", r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "POST", ...i, ...s }, l = {}, d = {};
      await ee(l, e), t !== void 0 && (d.scheduleLink = t), Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, {
        url: J(r),
        options: o
      };
    },
    /**
     * 
     * @param {string} token 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    signupInvite: async (t, s = {}) => {
      se("signupInvite", "token", t);
      const n = "/account/signup/{token}".replace("{token}", encodeURIComponent(String(t))), r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "GET", ...i, ...s }, l = {}, d = {};
      await ee(l, e), Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, {
        url: J(r),
        options: o
      };
    },
    /**
     * 
     * @summary Update Rental Rate Forecast Settings
     * @param {UpdateAvmAdjustmentSettingsRequest} [updateAvmAdjustmentSettingsRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateAvmAdjustmentSettings: async (t, s = {}) => {
      const n = "/account/avm-adjustments", r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "POST", ...i, ...s }, l = {}, d = {};
      await ee(l, e), l["Content-Type"] = "application/json", Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, o.data = kt(t, o, e), {
        url: J(r),
        options: o
      };
    }
  };
}, II = function(e) {
  const t = EI(e);
  return {
    /**
     * 
     * @summary Retrieve access list for user.
     * @param {string} [mls] MLS to check if user is entitled.
     * @param {string} [t] Random number to force refresh
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async access(s, n, r) {
      var d, c;
      const i = await t.access(s, n, r), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (c = (d = Q["AccountApi.access"]) == null ? void 0 : d[o]) == null ? void 0 : c.url;
      return (u, m) => _(i, X, G, e)(u, l || m);
    },
    /**
     * 
     * @summary Add ZipCode to users featured list
     * @param {string} zipCode 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async addFeaturedZipCode(s, n) {
      var l, d;
      const r = await t.addFeaturedZipCode(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["AccountApi.addFeaturedZipCode"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    },
    /**
     * 
     * @summary Get AVM adjustment settings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getAvmAdjustmentSettings(s) {
      var o, l;
      const n = await t.getAvmAdjustmentSettings(s), r = (e == null ? void 0 : e.serverIndex) ?? 0, i = (l = (o = Q["AccountApi.getAvmAdjustmentSettings"]) == null ? void 0 : o[r]) == null ? void 0 : l.url;
      return (d, c) => _(n, X, G, e)(d, i || c);
    },
    /**
     * 
     * @summary List account\'s marketing boundaries.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getBoundaries(s) {
      var o, l;
      const n = await t.getBoundaries(s), r = (e == null ? void 0 : e.serverIndex) ?? 0, i = (l = (o = Q["AccountApi.getBoundaries"]) == null ? void 0 : o[r]) == null ? void 0 : l.url;
      return (d, c) => _(n, X, G, e)(d, i || c);
    },
    /**
     * 
     * @summary List clients featured zip codes.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getFeaturedZipCodes(s) {
      var o, l;
      const n = await t.getFeaturedZipCodes(s), r = (e == null ? void 0 : e.serverIndex) ?? 0, i = (l = (o = Q["AccountApi.getFeaturedZipCodes"]) == null ? void 0 : o[r]) == null ? void 0 : l.url;
      return (d, c) => _(n, X, G, e)(d, i || c);
    },
    /**
     * 
     * @summary Get options for account settings.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getOptions(s) {
      var o, l;
      const n = await t.getOptions(s), r = (e == null ? void 0 : e.serverIndex) ?? 0, i = (l = (o = Q["AccountApi.getOptions"]) == null ? void 0 : o[r]) == null ? void 0 : l.url;
      return (d, c) => _(n, X, G, e)(d, i || c);
    },
    /**
     * 
     * @summary Get info for account.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async info(s) {
      var o, l;
      const n = await t.info(s), r = (e == null ? void 0 : e.serverIndex) ?? 0, i = (l = (o = Q["AccountApi.info"]) == null ? void 0 : o[r]) == null ? void 0 : l.url;
      return (d, c) => _(n, X, G, e)(d, i || c);
    },
    /**
     * 
     * @param {LoginRouteModel} [loginRouteModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async loginRoute(s, n) {
      var l, d;
      const r = await t.loginRoute(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["AccountApi.loginRoute"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    },
    /**
     * 
     * @summary Simple ping to test if still valid.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async ping(s) {
      var o, l;
      const n = await t.ping(s), r = (e == null ? void 0 : e.serverIndex) ?? 0, i = (l = (o = Q["AccountApi.ping"]) == null ? void 0 : o[r]) == null ? void 0 : l.url;
      return (d, c) => _(n, X, G, e)(d, i || c);
    },
    /**
     * 
     * @summary Remove ZipCode to users featured list
     * @param {string} zipCode 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async removeFeaturedZipCode(s, n) {
      var l, d;
      const r = await t.removeFeaturedZipCode(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["AccountApi.removeFeaturedZipCode"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    },
    /**
     * 
     * @summary 
     * @param {IndustryDesignationRequest} [industryDesignationRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async requestIndustryDesignation(s, n) {
      var l, d;
      const r = await t.requestIndustryDesignation(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["AccountApi.requestIndustryDesignation"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    },
    /**
     * 
     * @summary Save Account Schedule Link
     * @param {string} [scheduleLink] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async setScheduleLink(s, n) {
      var l, d;
      const r = await t.setScheduleLink(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["AccountApi.setScheduleLink"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    },
    /**
     * 
     * @param {string} token 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async signupInvite(s, n) {
      var l, d;
      const r = await t.signupInvite(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["AccountApi.signupInvite"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    },
    /**
     * 
     * @summary Update Rental Rate Forecast Settings
     * @param {UpdateAvmAdjustmentSettingsRequest} [updateAvmAdjustmentSettingsRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateAvmAdjustmentSettings(s, n) {
      var l, d;
      const r = await t.updateAvmAdjustmentSettings(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["AccountApi.updateAvmAdjustmentSettings"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    }
  };
}, TI = function(e, t, s) {
  const n = II(e);
  return {
    /**
     * 
     * @summary Retrieve access list for user.
     * @param {string} [mls] MLS to check if user is entitled.
     * @param {string} [t] Random number to force refresh
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    access(r, i, o) {
      return n.access(r, i, o).then((l) => l(s, t));
    },
    /**
     * 
     * @summary Add ZipCode to users featured list
     * @param {string} zipCode 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addFeaturedZipCode(r, i) {
      return n.addFeaturedZipCode(r, i).then((o) => o(s, t));
    },
    /**
     * 
     * @summary Get AVM adjustment settings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAvmAdjustmentSettings(r) {
      return n.getAvmAdjustmentSettings(r).then((i) => i(s, t));
    },
    /**
     * 
     * @summary List account\'s marketing boundaries.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getBoundaries(r) {
      return n.getBoundaries(r).then((i) => i(s, t));
    },
    /**
     * 
     * @summary List clients featured zip codes.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getFeaturedZipCodes(r) {
      return n.getFeaturedZipCodes(r).then((i) => i(s, t));
    },
    /**
     * 
     * @summary Get options for account settings.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getOptions(r) {
      return n.getOptions(r).then((i) => i(s, t));
    },
    /**
     * 
     * @summary Get info for account.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    info(r) {
      return n.info(r).then((i) => i(s, t));
    },
    /**
     * 
     * @param {LoginRouteModel} [loginRouteModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loginRoute(r, i) {
      return n.loginRoute(r, i).then((o) => o(s, t));
    },
    /**
     * 
     * @summary Simple ping to test if still valid.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    ping(r) {
      return n.ping(r).then((i) => i(s, t));
    },
    /**
     * 
     * @summary Remove ZipCode to users featured list
     * @param {string} zipCode 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    removeFeaturedZipCode(r, i) {
      return n.removeFeaturedZipCode(r, i).then((o) => o(s, t));
    },
    /**
     * 
     * @summary 
     * @param {IndustryDesignationRequest} [industryDesignationRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    requestIndustryDesignation(r, i) {
      return n.requestIndustryDesignation(r, i).then((o) => o(s, t));
    },
    /**
     * 
     * @summary Save Account Schedule Link
     * @param {string} [scheduleLink] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    setScheduleLink(r, i) {
      return n.setScheduleLink(r, i).then((o) => o(s, t));
    },
    /**
     * 
     * @param {string} token 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    signupInvite(r, i) {
      return n.signupInvite(r, i).then((o) => o(s, t));
    },
    /**
     * 
     * @summary Update Rental Rate Forecast Settings
     * @param {UpdateAvmAdjustmentSettingsRequest} [updateAvmAdjustmentSettingsRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateAvmAdjustmentSettings(r, i) {
      return n.updateAvmAdjustmentSettings(r, i).then((o) => o(s, t));
    }
  };
}, OI = function(e) {
  return {
    /**
     * 
     * @summary Get a user\'s branding settings.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getBranding: async (t = {}) => {
      const s = "/account/branding", n = new URL(s, K);
      let r;
      e && (r = e.baseOptions);
      const i = { method: "GET", ...r, ...t }, o = {}, l = {};
      await Lt(o, "x-api-key", e), await ee(o, e), Z(n, l);
      let d = r && r.headers ? r.headers : {};
      return i.headers = { ...o, ...d, ...t.headers }, {
        url: J(n),
        options: i
      };
    },
    /**
     * 
     * @param {string} mlsSource 
     * @param {string} mlsNumber 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getBrandingMls: async (t, s, n = {}) => {
      se("getBrandingMls", "mlsSource", t), se("getBrandingMls", "mlsNumber", s);
      const r = "/{mlsSource}/{mlsNumber}/branding".replace("{mlsSource}", encodeURIComponent(String(t))).replace("{mlsNumber}", encodeURIComponent(String(s))), i = new URL(r, K);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "GET", ...o, ...n }, d = {}, c = {};
      await ee(d, e), Z(i, c);
      let u = o && o.headers ? o.headers : {};
      return l.headers = { ...d, ...u, ...n.headers }, {
        url: J(i),
        options: l
      };
    },
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getDomainBranding: async (t = {}) => {
      const s = "/account/branding/domain", n = new URL(s, K);
      let r;
      e && (r = e.baseOptions);
      const i = { method: "GET", ...r, ...t }, o = {};
      Z(n, {});
      let d = r && r.headers ? r.headers : {};
      return i.headers = { ...o, ...d, ...t.headers }, {
        url: J(n),
        options: i
      };
    },
    /**
     * 
     * @param {string} token 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getInviteBranding: async (t, s = {}) => {
      se("getInviteBranding", "token", t);
      const n = "/account/branding/invite/{token}".replace("{token}", encodeURIComponent(String(t))), r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "GET", ...i, ...s }, l = {};
      Z(r, {});
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, {
        url: J(r),
        options: o
      };
    },
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getMyBranding: async (t = {}) => {
      const s = "/account/branding/my", n = new URL(s, K);
      let r;
      e && (r = e.baseOptions);
      const i = { method: "GET", ...r, ...t }, o = {}, l = {};
      await ee(o, e), Z(n, l);
      let d = r && r.headers ? r.headers : {};
      return i.headers = { ...o, ...d, ...t.headers }, {
        url: J(n),
        options: i
      };
    },
    /**
     * 
     * @summary Update a user\'s branding settings.
     * @param {BrandingModel} [brandingModel] Contact values to update
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateBranding: async (t, s = {}) => {
      const n = "/account/branding/my", r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "POST", ...i, ...s }, l = {}, d = {};
      await ee(l, e), l["Content-Type"] = "application/json", Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, o.data = kt(t, o, e), {
        url: J(r),
        options: o
      };
    },
    /**
     * 
     * @summary Update a user\'s branding company logo.
     * @param {File} file PNG/JPEG image for company logo.
     * @param {number} width 
     * @param {number} height 
     * @param {number} [top] 
     * @param {number} [left] 
     * @param {boolean} [dark] Is image for dark theme
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateBrandingCompanyPhoto: async (t, s, n, r, i, o, l = {}) => {
      se("updateBrandingCompanyPhoto", "file", t), se("updateBrandingCompanyPhoto", "width", s), se("updateBrandingCompanyPhoto", "height", n);
      const d = "/account/branding/company-logo", c = new URL(d, K);
      let u;
      e && (u = e.baseOptions);
      const m = { method: "POST", ...u, ...l }, f = {}, v = {}, b = new (e && e.formDataCtor || FormData)();
      await ee(f, e), t !== void 0 && b.append("file", t), s !== void 0 && b.append("Width", s), n !== void 0 && b.append("Height", n), r !== void 0 && b.append("Top", r), i !== void 0 && b.append("Left", i), o !== void 0 && b.append("dark", String(o)), f["Content-Type"] = "multipart/form-data", Z(c, v);
      let w = u && u.headers ? u.headers : {};
      return m.headers = { ...f, ...w, ...l.headers }, m.data = b, {
        url: J(c),
        options: m
      };
    },
    /**
     * 
     * @summary Update a user\'s branding head-shot photo.
     * @param {File} file PNG/JPEG image for head-shot photo.
     * @param {number} width 
     * @param {number} height 
     * @param {number} [top] 
     * @param {number} [left] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateBrandingHeadshotPhoto: async (t, s, n, r, i, o = {}) => {
      se("updateBrandingHeadshotPhoto", "file", t), se("updateBrandingHeadshotPhoto", "width", s), se("updateBrandingHeadshotPhoto", "height", n);
      const l = "/account/branding/head-shot", d = new URL(l, K);
      let c;
      e && (c = e.baseOptions);
      const u = { method: "POST", ...c, ...o }, m = {}, f = {}, v = new (e && e.formDataCtor || FormData)();
      await ee(m, e), t !== void 0 && v.append("file", t), s !== void 0 && v.append("Width", s), n !== void 0 && v.append("Height", n), r !== void 0 && v.append("Top", r), i !== void 0 && v.append("Left", i), m["Content-Type"] = "multipart/form-data", Z(d, f);
      let b = c && c.headers ? c.headers : {};
      return u.headers = { ...m, ...b, ...o.headers }, u.data = v, {
        url: J(d),
        options: u
      };
    }
  };
}, RI = function(e) {
  const t = OI(e);
  return {
    /**
     * 
     * @summary Get a user\'s branding settings.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getBranding(s) {
      var o, l;
      const n = await t.getBranding(s), r = (e == null ? void 0 : e.serverIndex) ?? 0, i = (l = (o = Q["AccountBrandingApi.getBranding"]) == null ? void 0 : o[r]) == null ? void 0 : l.url;
      return (d, c) => _(n, X, G, e)(d, i || c);
    },
    /**
     * 
     * @param {string} mlsSource 
     * @param {string} mlsNumber 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getBrandingMls(s, n, r) {
      var d, c;
      const i = await t.getBrandingMls(s, n, r), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (c = (d = Q["AccountBrandingApi.getBrandingMls"]) == null ? void 0 : d[o]) == null ? void 0 : c.url;
      return (u, m) => _(i, X, G, e)(u, l || m);
    },
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getDomainBranding(s) {
      var o, l;
      const n = await t.getDomainBranding(s), r = (e == null ? void 0 : e.serverIndex) ?? 0, i = (l = (o = Q["AccountBrandingApi.getDomainBranding"]) == null ? void 0 : o[r]) == null ? void 0 : l.url;
      return (d, c) => _(n, X, G, e)(d, i || c);
    },
    /**
     * 
     * @param {string} token 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getInviteBranding(s, n) {
      var l, d;
      const r = await t.getInviteBranding(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["AccountBrandingApi.getInviteBranding"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    },
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getMyBranding(s) {
      var o, l;
      const n = await t.getMyBranding(s), r = (e == null ? void 0 : e.serverIndex) ?? 0, i = (l = (o = Q["AccountBrandingApi.getMyBranding"]) == null ? void 0 : o[r]) == null ? void 0 : l.url;
      return (d, c) => _(n, X, G, e)(d, i || c);
    },
    /**
     * 
     * @summary Update a user\'s branding settings.
     * @param {BrandingModel} [brandingModel] Contact values to update
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateBranding(s, n) {
      var l, d;
      const r = await t.updateBranding(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["AccountBrandingApi.updateBranding"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    },
    /**
     * 
     * @summary Update a user\'s branding company logo.
     * @param {File} file PNG/JPEG image for company logo.
     * @param {number} width 
     * @param {number} height 
     * @param {number} [top] 
     * @param {number} [left] 
     * @param {boolean} [dark] Is image for dark theme
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateBrandingCompanyPhoto(s, n, r, i, o, l, d) {
      var f, v;
      const c = await t.updateBrandingCompanyPhoto(s, n, r, i, o, l, d), u = (e == null ? void 0 : e.serverIndex) ?? 0, m = (v = (f = Q["AccountBrandingApi.updateBrandingCompanyPhoto"]) == null ? void 0 : f[u]) == null ? void 0 : v.url;
      return (b, w) => _(c, X, G, e)(b, m || w);
    },
    /**
     * 
     * @summary Update a user\'s branding head-shot photo.
     * @param {File} file PNG/JPEG image for head-shot photo.
     * @param {number} width 
     * @param {number} height 
     * @param {number} [top] 
     * @param {number} [left] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateBrandingHeadshotPhoto(s, n, r, i, o, l) {
      var m, f;
      const d = await t.updateBrandingHeadshotPhoto(s, n, r, i, o, l), c = (e == null ? void 0 : e.serverIndex) ?? 0, u = (f = (m = Q["AccountBrandingApi.updateBrandingHeadshotPhoto"]) == null ? void 0 : m[c]) == null ? void 0 : f.url;
      return (v, b) => _(d, X, G, e)(v, u || b);
    }
  };
}, LI = function(e, t, s) {
  const n = RI(e);
  return {
    /**
     * 
     * @summary Get a user\'s branding settings.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getBranding(r) {
      return n.getBranding(r).then((i) => i(s, t));
    },
    /**
     * 
     * @param {string} mlsSource 
     * @param {string} mlsNumber 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getBrandingMls(r, i, o) {
      return n.getBrandingMls(r, i, o).then((l) => l(s, t));
    },
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getDomainBranding(r) {
      return n.getDomainBranding(r).then((i) => i(s, t));
    },
    /**
     * 
     * @param {string} token 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getInviteBranding(r, i) {
      return n.getInviteBranding(r, i).then((o) => o(s, t));
    },
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getMyBranding(r) {
      return n.getMyBranding(r).then((i) => i(s, t));
    },
    /**
     * 
     * @summary Update a user\'s branding settings.
     * @param {BrandingModel} [brandingModel] Contact values to update
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateBranding(r, i) {
      return n.updateBranding(r, i).then((o) => o(s, t));
    },
    /**
     * 
     * @summary Update a user\'s branding company logo.
     * @param {File} file PNG/JPEG image for company logo.
     * @param {number} width 
     * @param {number} height 
     * @param {number} [top] 
     * @param {number} [left] 
     * @param {boolean} [dark] Is image for dark theme
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateBrandingCompanyPhoto(r, i, o, l, d, c, u) {
      return n.updateBrandingCompanyPhoto(r, i, o, l, d, c, u).then((m) => m(s, t));
    },
    /**
     * 
     * @summary Update a user\'s branding head-shot photo.
     * @param {File} file PNG/JPEG image for head-shot photo.
     * @param {number} width 
     * @param {number} height 
     * @param {number} [top] 
     * @param {number} [left] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateBrandingHeadshotPhoto(r, i, o, l, d, c) {
      return n.updateBrandingHeadshotPhoto(r, i, o, l, d, c).then((u) => u(s, t));
    }
  };
}, BI = function(e) {
  return {
    /**
     * 
     * @summary Returns a collection of checklist items.
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCheckListItems: async (t, s, n = {}) => {
      const r = "/account/check-list", i = new URL(r, K);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "GET", ...o, ...n }, d = {}, c = {};
      await ee(d, e), t !== void 0 && (c.page = t), s !== void 0 && (c.pageSize = s), Z(i, c);
      let u = o && o.headers ? o.headers : {};
      return l.headers = { ...d, ...u, ...n.headers }, {
        url: J(i),
        options: l
      };
    }
  };
}, MI = function(e) {
  const t = BI(e);
  return {
    /**
     * 
     * @summary Returns a collection of checklist items.
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getCheckListItems(s, n, r) {
      var d, c;
      const i = await t.getCheckListItems(s, n, r), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (c = (d = Q["AccountCheckListApi.getCheckListItems"]) == null ? void 0 : d[o]) == null ? void 0 : c.url;
      return (u, m) => _(i, X, G, e)(u, l || m);
    }
  };
};
class xI extends Fn {
  /**
   * 
   * @summary Returns a collection of checklist items.
   * @param {number} [page] 
   * @param {number} [pageSize] 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountCheckListApi
   */
  getCheckListItems(t, s, n) {
    return MI(this.configuration).getCheckListItems(t, s, n).then((r) => r(this.axios, this.basePath));
  }
}
const FI = function(e) {
  return {
    /**
     * 
     * @summary Activates a guest client for the specified account.
     * @param {number} id The unique identifier of the guest client to activate.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    activateGuestClient: async (t, s = {}) => {
      se("activateGuestClient", "id", t);
      const n = "/account/clients/{id}/activate".replace("{id}", encodeURIComponent(String(t))), r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "POST", ...i, ...s }, l = {}, d = {};
      await ee(l, e), Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, {
        url: J(r),
        options: o
      };
    },
    /**
     * 
     * @summary Add a client and optionally send a invite email.
     * @param {AddClientModel} [addClientModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addClient: async (t, s = {}) => {
      const n = "/account/clients/add", r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "POST", ...i, ...s }, l = {}, d = {};
      await ee(l, e), l["Content-Type"] = "application/json", Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, o.data = kt(t, o, e), {
        url: J(r),
        options: o
      };
    },
    /**
     * 
     * @summary Deactivates a guest client associated with the specified account.
     * @param {number} id The unique identifier of the guest client to deactivate.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deactivateGuestClient: async (t, s = {}) => {
      se("deactivateGuestClient", "id", t);
      const n = "/account/clients/{id}/deactivate".replace("{id}", encodeURIComponent(String(t))), r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "POST", ...i, ...s }, l = {}, d = {};
      await ee(l, e), Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, {
        url: J(r),
        options: o
      };
    },
    /**
     * 
     * @summary List clients associated with agent.
     * @param {number} [page] Current page of clients to return.
     * @param {number} [pageSize] Total clients per page.
     * @param {LicensedProducts} [license] Filter client\&#39;s by granted license
     * @param {ClientRelationshipType} [type] Filter client\&#39;s by relationship type
     * @param {ClientRelationshipSort} [sort] 
     * @param {SortDirection} [sortDirection] 
     * @param {string} [filter] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getClients: async (t, s, n, r, i, o, l, d = {}) => {
      const c = "/account/clients", u = new URL(c, K);
      let m;
      e && (m = e.baseOptions);
      const f = { method: "GET", ...m, ...d }, v = {}, b = {};
      await ee(v, e), t !== void 0 && (b.page = t), s !== void 0 && (b.pageSize = s), n !== void 0 && (b.license = n), r !== void 0 && (b.type = r), i !== void 0 && (b.sort = i), o !== void 0 && (b.sortDirection = o), l !== void 0 && (b.filter = l), Z(u, b);
      let w = m && m.headers ? m.headers : {};
      return f.headers = { ...v, ...w, ...d.headers }, {
        url: J(u),
        options: f
      };
    },
    /**
     * 
     * @summary Remove client link to agent account.
     * @param {string} [email] Email of account to unlink. No email means unlink current account from agent.
     * @param {number} [parentId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    unlinkClient: async (t, s, n = {}) => {
      const r = "/account/clients/unlink", i = new URL(r, K);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "POST", ...o, ...n }, d = {}, c = {}, u = new (e && e.formDataCtor || FormData)();
      await ee(d, e), t !== void 0 && u.append("email", t), s !== void 0 && u.append("parentId", s), d["Content-Type"] = "multipart/form-data", Z(i, c);
      let m = o && o.headers ? o.headers : {};
      return l.headers = { ...d, ...m, ...n.headers }, l.data = u, {
        url: J(i),
        options: l
      };
    }
  };
}, VI = function(e) {
  const t = FI(e);
  return {
    /**
     * 
     * @summary Activates a guest client for the specified account.
     * @param {number} id The unique identifier of the guest client to activate.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async activateGuestClient(s, n) {
      var l, d;
      const r = await t.activateGuestClient(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["AccountClientsApi.activateGuestClient"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    },
    /**
     * 
     * @summary Add a client and optionally send a invite email.
     * @param {AddClientModel} [addClientModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async addClient(s, n) {
      var l, d;
      const r = await t.addClient(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["AccountClientsApi.addClient"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    },
    /**
     * 
     * @summary Deactivates a guest client associated with the specified account.
     * @param {number} id The unique identifier of the guest client to deactivate.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deactivateGuestClient(s, n) {
      var l, d;
      const r = await t.deactivateGuestClient(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["AccountClientsApi.deactivateGuestClient"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    },
    /**
     * 
     * @summary List clients associated with agent.
     * @param {number} [page] Current page of clients to return.
     * @param {number} [pageSize] Total clients per page.
     * @param {LicensedProducts} [license] Filter client\&#39;s by granted license
     * @param {ClientRelationshipType} [type] Filter client\&#39;s by relationship type
     * @param {ClientRelationshipSort} [sort] 
     * @param {SortDirection} [sortDirection] 
     * @param {string} [filter] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getClients(s, n, r, i, o, l, d, c) {
      var v, b;
      const u = await t.getClients(s, n, r, i, o, l, d, c), m = (e == null ? void 0 : e.serverIndex) ?? 0, f = (b = (v = Q["AccountClientsApi.getClients"]) == null ? void 0 : v[m]) == null ? void 0 : b.url;
      return (w, S) => _(u, X, G, e)(w, f || S);
    },
    /**
     * 
     * @summary Remove client link to agent account.
     * @param {string} [email] Email of account to unlink. No email means unlink current account from agent.
     * @param {number} [parentId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async unlinkClient(s, n, r) {
      var d, c;
      const i = await t.unlinkClient(s, n, r), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (c = (d = Q["AccountClientsApi.unlinkClient"]) == null ? void 0 : d[o]) == null ? void 0 : c.url;
      return (u, m) => _(i, X, G, e)(u, l || m);
    }
  };
}, DI = function(e, t, s) {
  const n = VI(e);
  return {
    /**
     * 
     * @summary Activates a guest client for the specified account.
     * @param {number} id The unique identifier of the guest client to activate.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    activateGuestClient(r, i) {
      return n.activateGuestClient(r, i).then((o) => o(s, t));
    },
    /**
     * 
     * @summary Add a client and optionally send a invite email.
     * @param {AddClientModel} [addClientModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addClient(r, i) {
      return n.addClient(r, i).then((o) => o(s, t));
    },
    /**
     * 
     * @summary Deactivates a guest client associated with the specified account.
     * @param {number} id The unique identifier of the guest client to deactivate.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deactivateGuestClient(r, i) {
      return n.deactivateGuestClient(r, i).then((o) => o(s, t));
    },
    /**
     * 
     * @summary List clients associated with agent.
     * @param {number} [page] Current page of clients to return.
     * @param {number} [pageSize] Total clients per page.
     * @param {LicensedProducts} [license] Filter client\&#39;s by granted license
     * @param {ClientRelationshipType} [type] Filter client\&#39;s by relationship type
     * @param {ClientRelationshipSort} [sort] 
     * @param {SortDirection} [sortDirection] 
     * @param {string} [filter] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getClients(r, i, o, l, d, c, u, m) {
      return n.getClients(r, i, o, l, d, c, u, m).then((f) => f(s, t));
    },
    /**
     * 
     * @summary Remove client link to agent account.
     * @param {string} [email] Email of account to unlink. No email means unlink current account from agent.
     * @param {number} [parentId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    unlinkClient(r, i, o) {
      return n.unlinkClient(r, i, o).then((l) => l(s, t));
    }
  };
}, NI = function(e) {
  return {
    /**
     * 
     * @param {string} token 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    acceptClientInvite: async (t, s = {}) => {
      se("acceptClientInvite", "token", t);
      const n = "/account/clients/invite/{token}".replace("{token}", encodeURIComponent(String(t))), r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "POST", ...i, ...s }, l = {};
      Z(r, {});
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, {
        url: J(r),
        options: o
      };
    },
    /**
     * 
     * @param {string} token 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    declineClientInvite: async (t, s = {}) => {
      se("declineClientInvite", "token", t);
      const n = "/account/clients/invite/{token}".replace("{token}", encodeURIComponent(String(t))), r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "DELETE", ...i, ...s }, l = {}, d = {};
      await ee(l, e), Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, {
        url: J(r),
        options: o
      };
    },
    /**
     * 
     * @param {string} token 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getClientInvite: async (t, s = {}) => {
      se("getClientInvite", "token", t);
      const n = "/account/clients/invite/{token}".replace("{token}", encodeURIComponent(String(t))), r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "GET", ...i, ...s }, l = {}, d = {};
      await ee(l, e), Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, {
        url: J(r),
        options: o
      };
    },
    /**
     * 
     * @summary Send a existing client a invite email.
     * @param {InviteClientModel} [inviteClientModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sendInvite: async (t, s = {}) => {
      const n = "/account/clients/invite/send", r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "POST", ...i, ...s }, l = {}, d = {};
      await ee(l, e), l["Content-Type"] = "application/json", Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, o.data = kt(t, o, e), {
        url: J(r),
        options: o
      };
    }
  };
}, ep = function(e) {
  const t = NI(e);
  return {
    /**
     * 
     * @param {string} token 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async acceptClientInvite(s, n) {
      var l, d;
      const r = await t.acceptClientInvite(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["AccountClientsInviteApi.acceptClientInvite"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    },
    /**
     * 
     * @param {string} token 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async declineClientInvite(s, n) {
      var l, d;
      const r = await t.declineClientInvite(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["AccountClientsInviteApi.declineClientInvite"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    },
    /**
     * 
     * @param {string} token 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getClientInvite(s, n) {
      var l, d;
      const r = await t.getClientInvite(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["AccountClientsInviteApi.getClientInvite"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    },
    /**
     * 
     * @summary Send a existing client a invite email.
     * @param {InviteClientModel} [inviteClientModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async sendInvite(s, n) {
      var l, d;
      const r = await t.sendInvite(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["AccountClientsInviteApi.sendInvite"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    }
  };
};
class jI extends Fn {
  /**
   * 
   * @param {string} token 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountClientsInviteApi
   */
  acceptClientInvite(t, s) {
    return ep(this.configuration).acceptClientInvite(t, s).then((n) => n(this.axios, this.basePath));
  }
  /**
   * 
   * @param {string} token 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountClientsInviteApi
   */
  declineClientInvite(t, s) {
    return ep(this.configuration).declineClientInvite(t, s).then((n) => n(this.axios, this.basePath));
  }
  /**
   * 
   * @param {string} token 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountClientsInviteApi
   */
  getClientInvite(t, s) {
    return ep(this.configuration).getClientInvite(t, s).then((n) => n(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Send a existing client a invite email.
   * @param {InviteClientModel} [inviteClientModel] 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountClientsInviteApi
   */
  sendInvite(t, s) {
    return ep(this.configuration).sendInvite(t, s).then((n) => n(this.axios, this.basePath));
  }
}
const HI = function(e) {
  return {
    /**
     * 
     * @summary List account\'s lead assignments.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getLeadAssignments: async (t = {}) => {
      const s = "/account/idx/lead-assignments", n = new URL(s, K);
      let r;
      e && (r = e.baseOptions);
      const i = { method: "GET", ...r, ...t }, o = {}, l = {};
      await ee(o, e), Z(n, l);
      let d = r && r.headers ? r.headers : {};
      return i.headers = { ...o, ...d, ...t.headers }, {
        url: J(n),
        options: i
      };
    },
    /**
     * 
     * @summary Update account\'s lead assignments.
     * @param {UpdateLeadAssignmentsModel} updateLeadAssignmentsModel 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateLeadAssignments: async (t, s = {}) => {
      se("updateLeadAssignments", "updateLeadAssignmentsModel", t);
      const n = "/account/idx/lead-assignments", r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "POST", ...i, ...s }, l = {}, d = {};
      await ee(l, e), l["Content-Type"] = "application/json", Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, o.data = kt(t, o, e), {
        url: J(r),
        options: o
      };
    }
  };
}, UI = function(e) {
  const t = HI(e);
  return {
    /**
     * 
     * @summary List account\'s lead assignments.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getLeadAssignments(s) {
      var o, l;
      const n = await t.getLeadAssignments(s), r = (e == null ? void 0 : e.serverIndex) ?? 0, i = (l = (o = Q["AccountIDXApi.getLeadAssignments"]) == null ? void 0 : o[r]) == null ? void 0 : l.url;
      return (d, c) => _(n, X, G, e)(d, i || c);
    },
    /**
     * 
     * @summary Update account\'s lead assignments.
     * @param {UpdateLeadAssignmentsModel} updateLeadAssignmentsModel 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateLeadAssignments(s, n) {
      var l, d;
      const r = await t.updateLeadAssignments(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["AccountIDXApi.updateLeadAssignments"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    }
  };
}, zI = function(e, t, s) {
  const n = UI(e);
  return {
    /**
     * 
     * @summary List account\'s lead assignments.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getLeadAssignments(r) {
      return n.getLeadAssignments(r).then((i) => i(s, t));
    },
    /**
     * 
     * @summary Update account\'s lead assignments.
     * @param {UpdateLeadAssignmentsModel} updateLeadAssignmentsModel 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateLeadAssignments(r, i) {
      return n.updateLeadAssignments(r, i).then((o) => o(s, t));
    }
  };
}, WI = function(e) {
  return {
    /**
     * 
     * @summary Add agent to agent roster.
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addAgent: async (t, s = {}) => {
      se("addAgent", "id", t);
      const n = "/account/idx/agents/{id}".replace("{id}", encodeURIComponent(String(t))), r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "POST", ...i, ...s }, l = {}, d = {};
      await ee(l, e), Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, {
        url: J(r),
        options: o
      };
    },
    /**
     * 
     * @summary List accounts not enabled with agent role.
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAccounts: async (t, s, n = {}) => {
      const r = "/account/idx/agents/accounts", i = new URL(r, K);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "GET", ...o, ...n }, d = {}, c = {};
      await ee(d, e), t !== void 0 && (c.page = t), s !== void 0 && (c.pageSize = s), Z(i, c);
      let u = o && o.headers ? o.headers : {};
      return l.headers = { ...d, ...u, ...n.headers }, {
        url: J(i),
        options: l
      };
    },
    /**
     * 
     * @summary List accounts enabled with agent role.
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAgents: async (t, s, n = {}) => {
      const r = "/account/idx/agents", i = new URL(r, K);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "GET", ...o, ...n }, d = {}, c = {};
      await ee(d, e), t !== void 0 && (c.page = t), s !== void 0 && (c.pageSize = s), Z(i, c);
      let u = o && o.headers ? o.headers : {};
      return l.headers = { ...d, ...u, ...n.headers }, {
        url: J(i),
        options: l
      };
    },
    /**
     * 
     * @summary Remove agent from agent roster.
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    removeAgent: async (t, s = {}) => {
      se("removeAgent", "id", t);
      const n = "/account/idx/agents/{id}".replace("{id}", encodeURIComponent(String(t))), r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "DELETE", ...i, ...s }, l = {}, d = {};
      await ee(l, e), Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, {
        url: J(r),
        options: o
      };
    }
  };
}, GI = function(e) {
  const t = WI(e);
  return {
    /**
     * 
     * @summary Add agent to agent roster.
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async addAgent(s, n) {
      var l, d;
      const r = await t.addAgent(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["AccountIDXAgentsApi.addAgent"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    },
    /**
     * 
     * @summary List accounts not enabled with agent role.
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getAccounts(s, n, r) {
      var d, c;
      const i = await t.getAccounts(s, n, r), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (c = (d = Q["AccountIDXAgentsApi.getAccounts"]) == null ? void 0 : d[o]) == null ? void 0 : c.url;
      return (u, m) => _(i, X, G, e)(u, l || m);
    },
    /**
     * 
     * @summary List accounts enabled with agent role.
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getAgents(s, n, r) {
      var d, c;
      const i = await t.getAgents(s, n, r), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (c = (d = Q["AccountIDXAgentsApi.getAgents"]) == null ? void 0 : d[o]) == null ? void 0 : c.url;
      return (u, m) => _(i, X, G, e)(u, l || m);
    },
    /**
     * 
     * @summary Remove agent from agent roster.
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async removeAgent(s, n) {
      var l, d;
      const r = await t.removeAgent(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["AccountIDXAgentsApi.removeAgent"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    }
  };
}, YI = function(e, t, s) {
  const n = GI(e);
  return {
    /**
     * 
     * @summary Add agent to agent roster.
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addAgent(r, i) {
      return n.addAgent(r, i).then((o) => o(s, t));
    },
    /**
     * 
     * @summary List accounts not enabled with agent role.
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAccounts(r, i, o) {
      return n.getAccounts(r, i, o).then((l) => l(s, t));
    },
    /**
     * 
     * @summary List accounts enabled with agent role.
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAgents(r, i, o) {
      return n.getAgents(r, i, o).then((l) => l(s, t));
    },
    /**
     * 
     * @summary Remove agent from agent roster.
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    removeAgent(r, i) {
      return n.removeAgent(r, i).then((o) => o(s, t));
    }
  };
}, XI = function(e) {
  return {
    /**
     * 
     * @summary Get account\'s search parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSearchParameters: async (t = {}) => {
      const s = "/account/idx/parameters/defaults", n = new URL(s, K);
      let r;
      e && (r = e.baseOptions);
      const i = { method: "GET", ...r, ...t }, o = {}, l = {};
      await ee(o, e), Z(n, l);
      let d = r && r.headers ? r.headers : {};
      return i.headers = { ...o, ...d, ...t.headers }, {
        url: J(n),
        options: i
      };
    },
    /**
     * 
     * @summary Update account\'s default financial parameters.
     * @param {FinancialParametersModel} financialParametersModel 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateFinancialParameters: async (t, s = {}) => {
      se("updateFinancialParameters", "financialParametersModel", t);
      const n = "/account/idx/parameters/defaults/financial-parameters", r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "POST", ...i, ...s }, l = {}, d = {};
      await ee(l, e), l["Content-Type"] = "application/json", Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, o.data = kt(t, o, e), {
        url: J(r),
        options: o
      };
    }
  };
}, aA = function(e) {
  const t = XI(e);
  return {
    /**
     * 
     * @summary Get account\'s search parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getSearchParameters(s) {
      var o, l;
      const n = await t.getSearchParameters(s), r = (e == null ? void 0 : e.serverIndex) ?? 0, i = (l = (o = Q["AccountIDXParametersApi.getSearchParameters"]) == null ? void 0 : o[r]) == null ? void 0 : l.url;
      return (d, c) => _(n, X, G, e)(d, i || c);
    },
    /**
     * 
     * @summary Update account\'s default financial parameters.
     * @param {FinancialParametersModel} financialParametersModel 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateFinancialParameters(s, n) {
      var l, d;
      const r = await t.updateFinancialParameters(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["AccountIDXParametersApi.updateFinancialParameters"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    }
  };
};
class qI extends Fn {
  /**
   * 
   * @summary Get account\'s search parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountIDXParametersApi
   */
  getSearchParameters(t) {
    return aA(this.configuration).getSearchParameters(t).then((s) => s(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Update account\'s default financial parameters.
   * @param {FinancialParametersModel} financialParametersModel 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountIDXParametersApi
   */
  updateFinancialParameters(t, s) {
    return aA(this.configuration).updateFinancialParameters(t, s).then((n) => n(this.axios, this.basePath));
  }
}
const QI = function(e) {
  return {
    /**
     * 
     * @param {AddMlsIdentifierRequest} [addMlsIdentifierRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addIdentifier: async (t, s = {}) => {
      const n = "/account/mls/identifiers", r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "POST", ...i, ...s }, l = {}, d = {};
      await ee(l, e), l["Content-Type"] = "application/json", Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, o.data = kt(t, o, e), {
        url: J(r),
        options: o
      };
    },
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAccessMatrix: async (t = {}) => {
      const s = "/account/mls/access/matrix", n = new URL(s, K);
      let r;
      e && (r = e.baseOptions);
      const i = { method: "GET", ...r, ...t }, o = {}, l = {};
      await ee(o, e), Z(n, l);
      let d = r && r.headers ? r.headers : {};
      return i.headers = { ...o, ...d, ...t.headers }, {
        url: J(n),
        options: i
      };
    },
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listIdentifiers: async (t = {}) => {
      const s = "/account/mls/identifiers", n = new URL(s, K);
      let r;
      e && (r = e.baseOptions);
      const i = { method: "GET", ...r, ...t }, o = {}, l = {};
      await ee(o, e), Z(n, l);
      let d = r && r.headers ? r.headers : {};
      return i.headers = { ...o, ...d, ...t.headers }, {
        url: J(n),
        options: i
      };
    },
    /**
     * 
     * @summary List all MLS user has access to.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listMls: async (t = {}) => {
      const s = "/account/mls", n = new URL(s, K);
      let r;
      e && (r = e.baseOptions);
      const i = { method: "GET", ...r, ...t }, o = {}, l = {};
      await ee(o, e), Z(n, l);
      let d = r && r.headers ? r.headers : {};
      return i.headers = { ...o, ...d, ...t.headers }, {
        url: J(n),
        options: i
      };
    },
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listSponsors: async (t = {}) => {
      const s = "/account/mls/access/sponsors", n = new URL(s, K);
      let r;
      e && (r = e.baseOptions);
      const i = { method: "GET", ...r, ...t }, o = {}, l = {};
      await ee(o, e), Z(n, l);
      let d = r && r.headers ? r.headers : {};
      return i.headers = { ...o, ...d, ...t.headers }, {
        url: J(n),
        options: i
      };
    },
    /**
     * 
     * @summary List sub-accounts that have MLS entitlements granted.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listUsers: async (t = {}) => {
      const s = "/account/mls/access", n = new URL(s, K);
      let r;
      e && (r = e.baseOptions);
      const i = { method: "GET", ...r, ...t }, o = {}, l = {};
      await ee(o, e), Z(n, l);
      let d = r && r.headers ? r.headers : {};
      return i.headers = { ...o, ...d, ...t.headers }, {
        url: J(n),
        options: i
      };
    },
    /**
     * 
     * @param {number} mlsId 
     * @param {MlsEntityType} type 
     * @param {string} identifier 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    removeIdentifier: async (t, s, n, r = {}) => {
      se("removeIdentifier", "mlsId", t), se("removeIdentifier", "type", s), se("removeIdentifier", "identifier", n);
      const i = "/account/mls/identifiers/{mlsId}/{type}/{identifier}".replace("{mlsId}", encodeURIComponent(String(t))).replace("{type}", encodeURIComponent(String(s))).replace("{identifier}", encodeURIComponent(String(n))), o = new URL(i, K);
      let l;
      e && (l = e.baseOptions);
      const d = { method: "DELETE", ...l, ...r }, c = {}, u = {};
      await ee(c, e), Z(o, u);
      let m = l && l.headers ? l.headers : {};
      return d.headers = { ...c, ...m, ...r.headers }, {
        url: J(o),
        options: d
      };
    },
    /**
     * 
     * @param {number} mlsId 
     * @param {number} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    removeUserAccess: async (t, s, n = {}) => {
      se("removeUserAccess", "mlsId", t), se("removeUserAccess", "userId", s);
      const r = "/account/mls/access/{mlsId}/{userId}".replace("{mlsId}", encodeURIComponent(String(t))).replace("{userId}", encodeURIComponent(String(s))), i = new URL(r, K);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "DELETE", ...o, ...n }, d = {}, c = {};
      await ee(d, e), Z(i, c);
      let u = o && o.headers ? o.headers : {};
      return l.headers = { ...d, ...u, ...n.headers }, {
        url: J(i),
        options: l
      };
    },
    /**
     * 
     * @param {number} mlsId 
     * @param {UpdateMlsUserRequest} [updateMlsUserRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateUserAccess: async (t, s, n = {}) => {
      se("updateUserAccess", "mlsId", t);
      const r = "/account/mls/access/{mlsId}".replace("{mlsId}", encodeURIComponent(String(t))), i = new URL(r, K);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "PATCH", ...o, ...n }, d = {}, c = {};
      await ee(d, e), d["Content-Type"] = "application/json", Z(i, c);
      let u = o && o.headers ? o.headers : {};
      return l.headers = { ...d, ...u, ...n.headers }, l.data = kt(s, l, e), {
        url: J(i),
        options: l
      };
    }
  };
}, ro = function(e) {
  const t = QI(e);
  return {
    /**
     * 
     * @param {AddMlsIdentifierRequest} [addMlsIdentifierRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async addIdentifier(s, n) {
      var l, d;
      const r = await t.addIdentifier(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["AccountMLSApi.addIdentifier"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    },
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getAccessMatrix(s) {
      var o, l;
      const n = await t.getAccessMatrix(s), r = (e == null ? void 0 : e.serverIndex) ?? 0, i = (l = (o = Q["AccountMLSApi.getAccessMatrix"]) == null ? void 0 : o[r]) == null ? void 0 : l.url;
      return (d, c) => _(n, X, G, e)(d, i || c);
    },
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async listIdentifiers(s) {
      var o, l;
      const n = await t.listIdentifiers(s), r = (e == null ? void 0 : e.serverIndex) ?? 0, i = (l = (o = Q["AccountMLSApi.listIdentifiers"]) == null ? void 0 : o[r]) == null ? void 0 : l.url;
      return (d, c) => _(n, X, G, e)(d, i || c);
    },
    /**
     * 
     * @summary List all MLS user has access to.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async listMls(s) {
      var o, l;
      const n = await t.listMls(s), r = (e == null ? void 0 : e.serverIndex) ?? 0, i = (l = (o = Q["AccountMLSApi.listMls"]) == null ? void 0 : o[r]) == null ? void 0 : l.url;
      return (d, c) => _(n, X, G, e)(d, i || c);
    },
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async listSponsors(s) {
      var o, l;
      const n = await t.listSponsors(s), r = (e == null ? void 0 : e.serverIndex) ?? 0, i = (l = (o = Q["AccountMLSApi.listSponsors"]) == null ? void 0 : o[r]) == null ? void 0 : l.url;
      return (d, c) => _(n, X, G, e)(d, i || c);
    },
    /**
     * 
     * @summary List sub-accounts that have MLS entitlements granted.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async listUsers(s) {
      var o, l;
      const n = await t.listUsers(s), r = (e == null ? void 0 : e.serverIndex) ?? 0, i = (l = (o = Q["AccountMLSApi.listUsers"]) == null ? void 0 : o[r]) == null ? void 0 : l.url;
      return (d, c) => _(n, X, G, e)(d, i || c);
    },
    /**
     * 
     * @param {number} mlsId 
     * @param {MlsEntityType} type 
     * @param {string} identifier 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async removeIdentifier(s, n, r, i) {
      var c, u;
      const o = await t.removeIdentifier(s, n, r, i), l = (e == null ? void 0 : e.serverIndex) ?? 0, d = (u = (c = Q["AccountMLSApi.removeIdentifier"]) == null ? void 0 : c[l]) == null ? void 0 : u.url;
      return (m, f) => _(o, X, G, e)(m, d || f);
    },
    /**
     * 
     * @param {number} mlsId 
     * @param {number} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async removeUserAccess(s, n, r) {
      var d, c;
      const i = await t.removeUserAccess(s, n, r), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (c = (d = Q["AccountMLSApi.removeUserAccess"]) == null ? void 0 : d[o]) == null ? void 0 : c.url;
      return (u, m) => _(i, X, G, e)(u, l || m);
    },
    /**
     * 
     * @param {number} mlsId 
     * @param {UpdateMlsUserRequest} [updateMlsUserRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateUserAccess(s, n, r) {
      var d, c;
      const i = await t.updateUserAccess(s, n, r), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (c = (d = Q["AccountMLSApi.updateUserAccess"]) == null ? void 0 : d[o]) == null ? void 0 : c.url;
      return (u, m) => _(i, X, G, e)(u, l || m);
    }
  };
};
class KI extends Fn {
  /**
   * 
   * @param {AddMlsIdentifierRequest} [addMlsIdentifierRequest] 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountMLSApi
   */
  addIdentifier(t, s) {
    return ro(this.configuration).addIdentifier(t, s).then((n) => n(this.axios, this.basePath));
  }
  /**
   * 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountMLSApi
   */
  getAccessMatrix(t) {
    return ro(this.configuration).getAccessMatrix(t).then((s) => s(this.axios, this.basePath));
  }
  /**
   * 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountMLSApi
   */
  listIdentifiers(t) {
    return ro(this.configuration).listIdentifiers(t).then((s) => s(this.axios, this.basePath));
  }
  /**
   * 
   * @summary List all MLS user has access to.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountMLSApi
   */
  listMls(t) {
    return ro(this.configuration).listMls(t).then((s) => s(this.axios, this.basePath));
  }
  /**
   * 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountMLSApi
   */
  listSponsors(t) {
    return ro(this.configuration).listSponsors(t).then((s) => s(this.axios, this.basePath));
  }
  /**
   * 
   * @summary List sub-accounts that have MLS entitlements granted.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountMLSApi
   */
  listUsers(t) {
    return ro(this.configuration).listUsers(t).then((s) => s(this.axios, this.basePath));
  }
  /**
   * 
   * @param {number} mlsId 
   * @param {MlsEntityType} type 
   * @param {string} identifier 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountMLSApi
   */
  removeIdentifier(t, s, n, r) {
    return ro(this.configuration).removeIdentifier(t, s, n, r).then((i) => i(this.axios, this.basePath));
  }
  /**
   * 
   * @param {number} mlsId 
   * @param {number} userId 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountMLSApi
   */
  removeUserAccess(t, s, n) {
    return ro(this.configuration).removeUserAccess(t, s, n).then((r) => r(this.axios, this.basePath));
  }
  /**
   * 
   * @param {number} mlsId 
   * @param {UpdateMlsUserRequest} [updateMlsUserRequest] 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountMLSApi
   */
  updateUserAccess(t, s, n) {
    return ro(this.configuration).updateUserAccess(t, s, n).then((r) => r(this.axios, this.basePath));
  }
}
const ZI = function(e) {
  return {
    /**
     * 
     * @summary Retrieve Management Territory coverage.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    coverageByCounty: async (t = {}) => {
      const s = "/account/portfolio-finder/coverage/county", n = new URL(s, K);
      let r;
      e && (r = e.baseOptions);
      const i = { method: "GET", ...r, ...t }, o = {}, l = {};
      await ee(o, e), Z(n, l);
      let d = r && r.headers ? r.headers : {};
      return i.headers = { ...o, ...d, ...t.headers }, {
        url: J(n),
        options: i
      };
    },
    /**
     * 
     * @summary Retrieve Management Territory coverage.
     * @param {Array<string>} [zipCodes] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    coverageByZip: async (t, s = {}) => {
      const n = "/account/portfolio-finder/coverage/zip", r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "GET", ...i, ...s }, l = {}, d = {};
      await ee(l, e), t && (d.zipCodes = t), Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, {
        url: J(r),
        options: o
      };
    },
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSettings: async (t = {}) => {
      const s = "/account/portfolio-finder/settings", n = new URL(s, K);
      let r;
      e && (r = e.baseOptions);
      const i = { method: "GET", ...r, ...t }, o = {}, l = {};
      await ee(o, e), Z(n, l);
      let d = r && r.headers ? r.headers : {};
      return i.headers = { ...o, ...d, ...t.headers }, {
        url: J(n),
        options: i
      };
    },
    /**
     * 
     * @param {PfSettingsModel} [pfSettingsModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateSettings: async (t, s = {}) => {
      const n = "/account/portfolio-finder/settings", r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "PATCH", ...i, ...s }, l = {}, d = {};
      await ee(l, e), l["Content-Type"] = "application/json", Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, o.data = kt(t, o, e), {
        url: J(r),
        options: o
      };
    }
  };
}, tp = function(e) {
  const t = ZI(e);
  return {
    /**
     * 
     * @summary Retrieve Management Territory coverage.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async coverageByCounty(s) {
      var o, l;
      const n = await t.coverageByCounty(s), r = (e == null ? void 0 : e.serverIndex) ?? 0, i = (l = (o = Q["AccountPortfolioFinderApi.coverageByCounty"]) == null ? void 0 : o[r]) == null ? void 0 : l.url;
      return (d, c) => _(n, X, G, e)(d, i || c);
    },
    /**
     * 
     * @summary Retrieve Management Territory coverage.
     * @param {Array<string>} [zipCodes] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async coverageByZip(s, n) {
      var l, d;
      const r = await t.coverageByZip(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["AccountPortfolioFinderApi.coverageByZip"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    },
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getSettings(s) {
      var o, l;
      const n = await t.getSettings(s), r = (e == null ? void 0 : e.serverIndex) ?? 0, i = (l = (o = Q["AccountPortfolioFinderApi.getSettings"]) == null ? void 0 : o[r]) == null ? void 0 : l.url;
      return (d, c) => _(n, X, G, e)(d, i || c);
    },
    /**
     * 
     * @param {PfSettingsModel} [pfSettingsModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateSettings(s, n) {
      var l, d;
      const r = await t.updateSettings(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["AccountPortfolioFinderApi.updateSettings"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    }
  };
};
class JI extends Fn {
  /**
   * 
   * @summary Retrieve Management Territory coverage.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountPortfolioFinderApi
   */
  coverageByCounty(t) {
    return tp(this.configuration).coverageByCounty(t).then((s) => s(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Retrieve Management Territory coverage.
   * @param {Array<string>} [zipCodes] 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountPortfolioFinderApi
   */
  coverageByZip(t, s) {
    return tp(this.configuration).coverageByZip(t, s).then((n) => n(this.axios, this.basePath));
  }
  /**
   * 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountPortfolioFinderApi
   */
  getSettings(t) {
    return tp(this.configuration).getSettings(t).then((s) => s(this.axios, this.basePath));
  }
  /**
   * 
   * @param {PfSettingsModel} [pfSettingsModel] 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountPortfolioFinderApi
   */
  updateSettings(t, s) {
    return tp(this.configuration).updateSettings(t, s).then((n) => n(this.axios, this.basePath));
  }
}
const $I = function(e) {
  return {
    /**
     * 
     * @summary Retrieve Management Territory coverage.
     * @param {Array<string>} [keys] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    coverageByCounty: async (t, s = {}) => {
      const n = "/account/territory/coverage/county", r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "GET", ...i, ...s }, l = {}, d = {};
      await ee(l, e), t && (d.keys = t), Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, {
        url: J(r),
        options: o
      };
    },
    /**
     * 
     * @summary Retrieve Management Territory coverage.
     * @param {Array<string>} [zipCodes] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    coverageByZip: async (t, s = {}) => {
      const n = "/account/territory/coverage/zip", r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "GET", ...i, ...s }, l = {}, d = {};
      await ee(l, e), t && (d.zipCodes = t), Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, {
        url: J(r),
        options: o
      };
    }
  };
}, nA = function(e) {
  const t = $I(e);
  return {
    /**
     * 
     * @summary Retrieve Management Territory coverage.
     * @param {Array<string>} [keys] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async coverageByCounty(s, n) {
      var l, d;
      const r = await t.coverageByCounty(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["AccountTerritoryApi.coverageByCounty"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    },
    /**
     * 
     * @summary Retrieve Management Territory coverage.
     * @param {Array<string>} [zipCodes] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async coverageByZip(s, n) {
      var l, d;
      const r = await t.coverageByZip(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["AccountTerritoryApi.coverageByZip"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    }
  };
};
class _I extends Fn {
  /**
   * 
   * @summary Retrieve Management Territory coverage.
   * @param {Array<string>} [keys] 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountTerritoryApi
   */
  coverageByCounty(t, s) {
    return nA(this.configuration).coverageByCounty(t, s).then((n) => n(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Retrieve Management Territory coverage.
   * @param {Array<string>} [zipCodes] 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountTerritoryApi
   */
  coverageByZip(t, s) {
    return nA(this.configuration).coverageByZip(t, s).then((n) => n(this.axios, this.basePath));
  }
}
const e6 = function(e) {
  return {
    /**
     * 
     * @summary Add Analysis Request to CRM
     * @param {string} token 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addCrm: async (t, s = {}) => {
      se("addCrm", "token", t);
      const n = "/account/analysis-requests/crm/{token}/add".replace("{token}", encodeURIComponent(String(t))), r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "POST", ...i, ...s }, l = {}, d = {};
      await ee(l, e), Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, {
        url: J(r),
        options: o
      };
    },
    /**
     * 
     * @summary Archive RequestAnalysis
     * @param {number} requestId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    archive: async (t, s = {}) => {
      se("archive", "requestId", t);
      const n = "/account/analysis-requests/{requestId}/archive".replace("{requestId}", encodeURIComponent(String(t))), r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "POST", ...i, ...s }, l = {}, d = {};
      await ee(l, e), Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, {
        url: J(r),
        options: o
      };
    },
    /**
     * 
     * @summary Assign current user to rental analysis.
     * @param {string} token 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    assign: async (t, s = {}) => {
      se("assign", "token", t);
      const n = "/account/analysis-requests/{token}/assign".replace("{token}", encodeURIComponent(String(t))), r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "POST", ...i, ...s }, l = {}, d = {};
      await ee(l, e), Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, {
        url: J(r),
        options: o
      };
    },
    /**
     * 
     * @summary Get user\'s automation settings for rental analysis management
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAutomationSettings: async (t = {}) => {
      const s = "/account/analysis-requests/automation-settings", n = new URL(s, K);
      let r;
      e && (r = e.baseOptions);
      const i = { method: "GET", ...r, ...t }, o = {}, l = {};
      await ee(o, e), Z(n, l);
      let d = r && r.headers ? r.headers : {};
      return i.headers = { ...o, ...d, ...t.headers }, {
        url: J(n),
        options: i
      };
    },
    /**
     * 
     * @summary Get client value for FRA property.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getClientValue: async (t = {}) => {
      const s = "/account/analysis-requests/client-value", n = new URL(s, K);
      let r;
      e && (r = e.baseOptions);
      const i = { method: "GET", ...r, ...t }, o = {}, l = {};
      await Lt(o, "x-api-key", e), await ee(o, e), Z(n, l);
      let d = r && r.headers ? r.headers : {};
      return i.headers = { ...o, ...d, ...t.headers }, {
        url: J(n),
        options: i
      };
    },
    /**
     * 
     * @summary Get analysis default email template.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getEmailTemplate: async (t = {}) => {
      const s = "/account/analysis-requests/email-template", n = new URL(s, K);
      let r;
      e && (r = e.baseOptions);
      const i = { method: "GET", ...r, ...t }, o = {}, l = {};
      await ee(o, e), Z(n, l);
      let d = r && r.headers ? r.headers : {};
      return i.headers = { ...o, ...d, ...t.headers }, {
        url: J(n),
        options: i
      };
    },
    /**
     * 
     * @summary List account\'s lead assignments.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getLeadAssignments: async (t = {}) => {
      const s = "/account/analysis-requests/lead-assignments", n = new URL(s, K);
      let r;
      e && (r = e.baseOptions);
      const i = { method: "GET", ...r, ...t }, o = {}, l = {};
      await ee(o, e), Z(n, l);
      let d = r && r.headers ? r.headers : {};
      return i.headers = { ...o, ...d, ...t.headers }, {
        url: J(n),
        options: i
      };
    },
    /**
     * 
     * @summary Get analysis email notification style.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getNotificationStyle: async (t = {}) => {
      const s = "/account/analysis-requests/notification-style", n = new URL(s, K);
      let r;
      e && (r = e.baseOptions);
      const i = { method: "GET", ...r, ...t }, o = {}, l = {};
      await ee(o, e), Z(n, l);
      let d = r && r.headers ? r.headers : {};
      return i.headers = { ...o, ...d, ...t.headers }, {
        url: J(n),
        options: i
      };
    },
    /**
     * 
     * @summary Retrieve property analysis request via context of current property page view.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getRequest: async (t = {}) => {
      const s = "/account/analysis-requests/request", n = new URL(s, K);
      let r;
      e && (r = e.baseOptions);
      const i = { method: "GET", ...r, ...t }, o = {}, l = {};
      await Lt(o, "x-api-key", e), await ee(o, e), Z(n, l);
      let d = r && r.headers ? r.headers : {};
      return i.headers = { ...o, ...d, ...t.headers }, {
        url: J(n),
        options: i
      };
    },
    /**
     * 
     * @summary Retrieve list of property analysis requests.
     * @param {number} [page] Current page of property analysis to return.
     * @param {number} [pageSize] Total property analysis per page.
     * @param {boolean} [archived] Show archived
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getRequests: async (t, s, n, r = {}) => {
      const i = "/account/analysis-requests", o = new URL(i, K);
      let l;
      e && (l = e.baseOptions);
      const d = { method: "GET", ...l, ...r }, c = {}, u = {};
      await ee(c, e), t !== void 0 && (u.page = t), s !== void 0 && (u.pageSize = s), n !== void 0 && (u.archived = n), Z(o, u);
      let m = l && l.headers ? l.headers : {};
      return d.headers = { ...c, ...m, ...r.headers }, {
        url: J(o),
        options: d
      };
    },
    /**
     * 
     * @summary Get user\'s settings for rental analysis management
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSettings: async (t = {}) => {
      const s = "/account/analysis-requests/settings", n = new URL(s, K);
      let r;
      e && (r = e.baseOptions);
      const i = { method: "GET", ...r, ...t }, o = {}, l = {};
      await ee(o, e), Z(n, l);
      let d = r && r.headers ? r.headers : {};
      return i.headers = { ...o, ...d, ...t.headers }, {
        url: J(n),
        options: i
      };
    },
    /**
     * 
     * @summary Get analysis default widget template texts.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getWidgetSettings: async (t = {}) => {
      const s = "/account/analysis-requests/widget-settings", n = new URL(s, K);
      let r;
      e && (r = e.baseOptions);
      const i = { method: "GET", ...r, ...t }, o = {}, l = {};
      await ee(o, e), Z(n, l);
      let d = r && r.headers ? r.headers : {};
      return i.headers = { ...o, ...d, ...t.headers }, {
        url: J(n),
        options: i
      };
    },
    /**
     * 
     * @summary Share a request analysis with a potential client.
     * @param {string} token Token of request analysis to share.
     * @param {ShareAnalysisModel} shareAnalysisModel 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    share: async (t, s, n = {}) => {
      se("share", "token", t), se("share", "shareAnalysisModel", s);
      const r = "/account/analysis-requests/{token}/share".replace("{token}", encodeURIComponent(String(t))), i = new URL(r, K);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "POST", ...o, ...n }, d = {}, c = {};
      await ee(d, e), d["Content-Type"] = "application/json", Z(i, c);
      let u = o && o.headers ? o.headers : {};
      return l.headers = { ...d, ...u, ...n.headers }, l.data = kt(s, l, e), {
        url: J(i),
        options: l
      };
    },
    /**
     * 
     * @summary Skip Trace Analysis Request
     * @param {string} token 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    skipTrace: async (t, s = {}) => {
      se("skipTrace", "token", t);
      const n = "/account/analysis-requests/{token}/skip-trace".replace("{token}", encodeURIComponent(String(t))), r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "POST", ...i, ...s }, l = {}, d = {};
      await ee(l, e), Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, {
        url: J(r),
        options: o
      };
    },
    /**
     * 
     * @summary Track FRA page View
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    trackPageView: async (t = {}) => {
      const s = "/account/analysis-requests/track", n = new URL(s, K);
      let r;
      e && (r = e.baseOptions);
      const i = { method: "GET", ...r, ...t }, o = {}, l = {};
      await Lt(o, "x-api-key", e), await ee(o, e), Z(n, l);
      let d = r && r.headers ? r.headers : {};
      return i.headers = { ...o, ...d, ...t.headers }, {
        url: J(n),
        options: i
      };
    },
    /**
     * 
     * @summary Update automation settings.
     * @param {AnalysisAutomationSettingsModel} analysisAutomationSettingsModel 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateAutomationSettings: async (t, s = {}) => {
      se("updateAutomationSettings", "analysisAutomationSettingsModel", t);
      const n = "/account/analysis-requests/automation-settings", r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "POST", ...i, ...s }, l = {}, d = {};
      await ee(l, e), l["Content-Type"] = "application/json", Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, o.data = kt(t, o, e), {
        url: J(r),
        options: o
      };
    },
    /**
     * 
     * @summary Update analysis default email template.
     * @param {string} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateEmailTemplate: async (t, s = {}) => {
      se("updateEmailTemplate", "body", t);
      const n = "/account/analysis-requests/email-template", r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "POST", ...i, ...s }, l = {}, d = {};
      await ee(l, e), l["Content-Type"] = "application/json", Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, o.data = kt(t, o, e), {
        url: J(r),
        options: o
      };
    },
    /**
     * 
     * @summary Update account\'s lead assignments.
     * @param {UpdateLeadAssignmentsModel} updateLeadAssignmentsModel 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateLeadAssignments: async (t, s = {}) => {
      se("updateLeadAssignments", "updateLeadAssignmentsModel", t);
      const n = "/account/analysis-requests/lead-assignments", r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "POST", ...i, ...s }, l = {}, d = {};
      await ee(l, e), l["Content-Type"] = "application/json", Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, o.data = kt(t, o, e), {
        url: J(r),
        options: o
      };
    },
    /**
     * 
     * @summary Update analysis email notification style.
     * @param {NotificationStyleModel} notificationStyleModel 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateNotificationStyle: async (t, s = {}) => {
      se("updateNotificationStyle", "notificationStyleModel", t);
      const n = "/account/analysis-requests/notification-style", r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "POST", ...i, ...s }, l = {}, d = {};
      await ee(l, e), l["Content-Type"] = "application/json", Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, o.data = kt(t, o, e), {
        url: J(r),
        options: o
      };
    },
    /**
     * 
     * @summary Update analysis default widget template.
     * @param {PPESettingsModel} [pPESettingsModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateWidgetSettings: async (t, s = {}) => {
      const n = "/account/analysis-requests/widget-settings", r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "POST", ...i, ...s }, l = {}, d = {};
      await ee(l, e), l["Content-Type"] = "application/json", Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, o.data = kt(t, o, e), {
        url: J(r),
        options: o
      };
    },
    /**
     * 
     * @summary Get original values submitted by user.
     * @param {string} token Analysis request token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    view: async (t, s = {}) => {
      se("view", "token", t);
      const n = "/account/analysis-requests/{token}/view".replace("{token}", encodeURIComponent(String(t))), r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "GET", ...i, ...s }, l = {}, d = {};
      await ee(l, e), Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, {
        url: J(r),
        options: o
      };
    }
  };
}, t6 = function(e) {
  const t = e6(e);
  return {
    /**
     * 
     * @summary Add Analysis Request to CRM
     * @param {string} token 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async addCrm(s, n) {
      var l, d;
      const r = await t.addCrm(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["AnalysisRequestsApi.addCrm"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    },
    /**
     * 
     * @summary Archive RequestAnalysis
     * @param {number} requestId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async archive(s, n) {
      var l, d;
      const r = await t.archive(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["AnalysisRequestsApi.archive"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    },
    /**
     * 
     * @summary Assign current user to rental analysis.
     * @param {string} token 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async assign(s, n) {
      var l, d;
      const r = await t.assign(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["AnalysisRequestsApi.assign"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    },
    /**
     * 
     * @summary Get user\'s automation settings for rental analysis management
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getAutomationSettings(s) {
      var o, l;
      const n = await t.getAutomationSettings(s), r = (e == null ? void 0 : e.serverIndex) ?? 0, i = (l = (o = Q["AnalysisRequestsApi.getAutomationSettings"]) == null ? void 0 : o[r]) == null ? void 0 : l.url;
      return (d, c) => _(n, X, G, e)(d, i || c);
    },
    /**
     * 
     * @summary Get client value for FRA property.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getClientValue(s) {
      var o, l;
      const n = await t.getClientValue(s), r = (e == null ? void 0 : e.serverIndex) ?? 0, i = (l = (o = Q["AnalysisRequestsApi.getClientValue"]) == null ? void 0 : o[r]) == null ? void 0 : l.url;
      return (d, c) => _(n, X, G, e)(d, i || c);
    },
    /**
     * 
     * @summary Get analysis default email template.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getEmailTemplate(s) {
      var o, l;
      const n = await t.getEmailTemplate(s), r = (e == null ? void 0 : e.serverIndex) ?? 0, i = (l = (o = Q["AnalysisRequestsApi.getEmailTemplate"]) == null ? void 0 : o[r]) == null ? void 0 : l.url;
      return (d, c) => _(n, X, G, e)(d, i || c);
    },
    /**
     * 
     * @summary List account\'s lead assignments.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getLeadAssignments(s) {
      var o, l;
      const n = await t.getLeadAssignments(s), r = (e == null ? void 0 : e.serverIndex) ?? 0, i = (l = (o = Q["AnalysisRequestsApi.getLeadAssignments"]) == null ? void 0 : o[r]) == null ? void 0 : l.url;
      return (d, c) => _(n, X, G, e)(d, i || c);
    },
    /**
     * 
     * @summary Get analysis email notification style.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getNotificationStyle(s) {
      var o, l;
      const n = await t.getNotificationStyle(s), r = (e == null ? void 0 : e.serverIndex) ?? 0, i = (l = (o = Q["AnalysisRequestsApi.getNotificationStyle"]) == null ? void 0 : o[r]) == null ? void 0 : l.url;
      return (d, c) => _(n, X, G, e)(d, i || c);
    },
    /**
     * 
     * @summary Retrieve property analysis request via context of current property page view.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getRequest(s) {
      var o, l;
      const n = await t.getRequest(s), r = (e == null ? void 0 : e.serverIndex) ?? 0, i = (l = (o = Q["AnalysisRequestsApi.getRequest"]) == null ? void 0 : o[r]) == null ? void 0 : l.url;
      return (d, c) => _(n, X, G, e)(d, i || c);
    },
    /**
     * 
     * @summary Retrieve list of property analysis requests.
     * @param {number} [page] Current page of property analysis to return.
     * @param {number} [pageSize] Total property analysis per page.
     * @param {boolean} [archived] Show archived
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getRequests(s, n, r, i) {
      var c, u;
      const o = await t.getRequests(s, n, r, i), l = (e == null ? void 0 : e.serverIndex) ?? 0, d = (u = (c = Q["AnalysisRequestsApi.getRequests"]) == null ? void 0 : c[l]) == null ? void 0 : u.url;
      return (m, f) => _(o, X, G, e)(m, d || f);
    },
    /**
     * 
     * @summary Get user\'s settings for rental analysis management
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getSettings(s) {
      var o, l;
      const n = await t.getSettings(s), r = (e == null ? void 0 : e.serverIndex) ?? 0, i = (l = (o = Q["AnalysisRequestsApi.getSettings"]) == null ? void 0 : o[r]) == null ? void 0 : l.url;
      return (d, c) => _(n, X, G, e)(d, i || c);
    },
    /**
     * 
     * @summary Get analysis default widget template texts.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getWidgetSettings(s) {
      var o, l;
      const n = await t.getWidgetSettings(s), r = (e == null ? void 0 : e.serverIndex) ?? 0, i = (l = (o = Q["AnalysisRequestsApi.getWidgetSettings"]) == null ? void 0 : o[r]) == null ? void 0 : l.url;
      return (d, c) => _(n, X, G, e)(d, i || c);
    },
    /**
     * 
     * @summary Share a request analysis with a potential client.
     * @param {string} token Token of request analysis to share.
     * @param {ShareAnalysisModel} shareAnalysisModel 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async share(s, n, r) {
      var d, c;
      const i = await t.share(s, n, r), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (c = (d = Q["AnalysisRequestsApi.share"]) == null ? void 0 : d[o]) == null ? void 0 : c.url;
      return (u, m) => _(i, X, G, e)(u, l || m);
    },
    /**
     * 
     * @summary Skip Trace Analysis Request
     * @param {string} token 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async skipTrace(s, n) {
      var l, d;
      const r = await t.skipTrace(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["AnalysisRequestsApi.skipTrace"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    },
    /**
     * 
     * @summary Track FRA page View
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async trackPageView(s) {
      var o, l;
      const n = await t.trackPageView(s), r = (e == null ? void 0 : e.serverIndex) ?? 0, i = (l = (o = Q["AnalysisRequestsApi.trackPageView"]) == null ? void 0 : o[r]) == null ? void 0 : l.url;
      return (d, c) => _(n, X, G, e)(d, i || c);
    },
    /**
     * 
     * @summary Update automation settings.
     * @param {AnalysisAutomationSettingsModel} analysisAutomationSettingsModel 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateAutomationSettings(s, n) {
      var l, d;
      const r = await t.updateAutomationSettings(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["AnalysisRequestsApi.updateAutomationSettings"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    },
    /**
     * 
     * @summary Update analysis default email template.
     * @param {string} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateEmailTemplate(s, n) {
      var l, d;
      const r = await t.updateEmailTemplate(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["AnalysisRequestsApi.updateEmailTemplate"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    },
    /**
     * 
     * @summary Update account\'s lead assignments.
     * @param {UpdateLeadAssignmentsModel} updateLeadAssignmentsModel 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateLeadAssignments(s, n) {
      var l, d;
      const r = await t.updateLeadAssignments(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["AnalysisRequestsApi.updateLeadAssignments"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    },
    /**
     * 
     * @summary Update analysis email notification style.
     * @param {NotificationStyleModel} notificationStyleModel 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateNotificationStyle(s, n) {
      var l, d;
      const r = await t.updateNotificationStyle(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["AnalysisRequestsApi.updateNotificationStyle"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    },
    /**
     * 
     * @summary Update analysis default widget template.
     * @param {PPESettingsModel} [pPESettingsModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateWidgetSettings(s, n) {
      var l, d;
      const r = await t.updateWidgetSettings(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["AnalysisRequestsApi.updateWidgetSettings"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    },
    /**
     * 
     * @summary Get original values submitted by user.
     * @param {string} token Analysis request token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async view(s, n) {
      var l, d;
      const r = await t.view(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["AnalysisRequestsApi.view"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    }
  };
}, s6 = function(e, t, s) {
  const n = t6(e);
  return {
    /**
     * 
     * @summary Add Analysis Request to CRM
     * @param {string} token 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addCrm(r, i) {
      return n.addCrm(r, i).then((o) => o(s, t));
    },
    /**
     * 
     * @summary Archive RequestAnalysis
     * @param {number} requestId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    archive(r, i) {
      return n.archive(r, i).then((o) => o(s, t));
    },
    /**
     * 
     * @summary Assign current user to rental analysis.
     * @param {string} token 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    assign(r, i) {
      return n.assign(r, i).then((o) => o(s, t));
    },
    /**
     * 
     * @summary Get user\'s automation settings for rental analysis management
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAutomationSettings(r) {
      return n.getAutomationSettings(r).then((i) => i(s, t));
    },
    /**
     * 
     * @summary Get client value for FRA property.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getClientValue(r) {
      return n.getClientValue(r).then((i) => i(s, t));
    },
    /**
     * 
     * @summary Get analysis default email template.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getEmailTemplate(r) {
      return n.getEmailTemplate(r).then((i) => i(s, t));
    },
    /**
     * 
     * @summary List account\'s lead assignments.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getLeadAssignments(r) {
      return n.getLeadAssignments(r).then((i) => i(s, t));
    },
    /**
     * 
     * @summary Get analysis email notification style.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getNotificationStyle(r) {
      return n.getNotificationStyle(r).then((i) => i(s, t));
    },
    /**
     * 
     * @summary Retrieve property analysis request via context of current property page view.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getRequest(r) {
      return n.getRequest(r).then((i) => i(s, t));
    },
    /**
     * 
     * @summary Retrieve list of property analysis requests.
     * @param {number} [page] Current page of property analysis to return.
     * @param {number} [pageSize] Total property analysis per page.
     * @param {boolean} [archived] Show archived
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getRequests(r, i, o, l) {
      return n.getRequests(r, i, o, l).then((d) => d(s, t));
    },
    /**
     * 
     * @summary Get user\'s settings for rental analysis management
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSettings(r) {
      return n.getSettings(r).then((i) => i(s, t));
    },
    /**
     * 
     * @summary Get analysis default widget template texts.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getWidgetSettings(r) {
      return n.getWidgetSettings(r).then((i) => i(s, t));
    },
    /**
     * 
     * @summary Share a request analysis with a potential client.
     * @param {string} token Token of request analysis to share.
     * @param {ShareAnalysisModel} shareAnalysisModel 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    share(r, i, o) {
      return n.share(r, i, o).then((l) => l(s, t));
    },
    /**
     * 
     * @summary Skip Trace Analysis Request
     * @param {string} token 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    skipTrace(r, i) {
      return n.skipTrace(r, i).then((o) => o(s, t));
    },
    /**
     * 
     * @summary Track FRA page View
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    trackPageView(r) {
      return n.trackPageView(r).then((i) => i(s, t));
    },
    /**
     * 
     * @summary Update automation settings.
     * @param {AnalysisAutomationSettingsModel} analysisAutomationSettingsModel 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateAutomationSettings(r, i) {
      return n.updateAutomationSettings(r, i).then((o) => o(s, t));
    },
    /**
     * 
     * @summary Update analysis default email template.
     * @param {string} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateEmailTemplate(r, i) {
      return n.updateEmailTemplate(r, i).then((o) => o(s, t));
    },
    /**
     * 
     * @summary Update account\'s lead assignments.
     * @param {UpdateLeadAssignmentsModel} updateLeadAssignmentsModel 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateLeadAssignments(r, i) {
      return n.updateLeadAssignments(r, i).then((o) => o(s, t));
    },
    /**
     * 
     * @summary Update analysis email notification style.
     * @param {NotificationStyleModel} notificationStyleModel 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateNotificationStyle(r, i) {
      return n.updateNotificationStyle(r, i).then((o) => o(s, t));
    },
    /**
     * 
     * @summary Update analysis default widget template.
     * @param {PPESettingsModel} [pPESettingsModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateWidgetSettings(r, i) {
      return n.updateWidgetSettings(r, i).then((o) => o(s, t));
    },
    /**
     * 
     * @summary Get original values submitted by user.
     * @param {string} token Analysis request token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    view(r, i) {
      return n.view(r, i).then((o) => o(s, t));
    }
  };
}, a6 = function(e) {
  return {
    /**
     * 
     * @summary Add a payment method.
     * @param {string} methodId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addPaymentMethod: async (t, s = {}) => {
      se("addPaymentMethod", "methodId", t);
      const n = "/account/billing/payment-methods/{methodId}".replace("{methodId}", encodeURIComponent(String(t))), r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "POST", ...i, ...s }, l = {}, d = {};
      await ee(l, e), Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, {
        url: J(r),
        options: o
      };
    },
    /**
     * 
     * @summary List add-ons available for package.
     * @param {number} packageId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAddOns: async (t, s = {}) => {
      se("getAddOns", "packageId", t);
      const n = "/account/billing/packages/{packageId}/add-ons".replace("{packageId}", encodeURIComponent(String(t))), r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "GET", ...i, ...s }, l = {}, d = {};
      await ee(l, e), Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, {
        url: J(r),
        options: o
      };
    },
    /**
     * 
     * @param {string} bundlePath 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getBundle: async (t, s = {}) => {
      se("getBundle", "bundlePath", t);
      const n = "/account/billing/bundles/{bundlePath}".replace("{bundlePath}", encodeURIComponent(String(t))), r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "GET", ...i, ...s }, l = {}, d = {};
      await ee(l, e), Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, {
        url: J(r),
        options: o
      };
    },
    /**
     * 
     * @summary List invoices for user.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getInvoices: async (t = {}) => {
      const s = "/account/billing/invoices", n = new URL(s, K);
      let r;
      e && (r = e.baseOptions);
      const i = { method: "GET", ...r, ...t }, o = {}, l = {};
      await ee(o, e), Z(n, l);
      let d = r && r.headers ? r.headers : {};
      return i.headers = { ...o, ...d, ...t.headers }, {
        url: J(n),
        options: i
      };
    },
    /**
     * 
     * @summary List available packages to purchase
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPackages: async (t = {}) => {
      const s = "/account/billing/packages", n = new URL(s, K);
      let r;
      e && (r = e.baseOptions);
      const i = { method: "GET", ...r, ...t }, o = {}, l = {};
      await ee(o, e), Z(n, l);
      let d = r && r.headers ? r.headers : {};
      return i.headers = { ...o, ...d, ...t.headers }, {
        url: J(n),
        options: i
      };
    },
    /**
     * 
     * @summary List payment methods for user.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPaymentMethods: async (t = {}) => {
      const s = "/account/billing/payment-methods", n = new URL(s, K);
      let r;
      e && (r = e.baseOptions);
      const i = { method: "GET", ...r, ...t }, o = {}, l = {};
      await ee(o, e), Z(n, l);
      let d = r && r.headers ? r.headers : {};
      return i.headers = { ...o, ...d, ...t.headers }, {
        url: J(n),
        options: i
      };
    },
    /**
     * 
     * @summary Remove a payment method.
     * @param {string} methodId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    removePaymentMethod: async (t, s = {}) => {
      se("removePaymentMethod", "methodId", t);
      const n = "/account/billing/payment-methods/{methodId}".replace("{methodId}", encodeURIComponent(String(t))), r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "DELETE", ...i, ...s }, l = {}, d = {};
      await ee(l, e), Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, {
        url: J(r),
        options: o
      };
    },
    /**
     * 
     * @summary Set a payment method as default.
     * @param {string} methodId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    setDefaultPaymentMethod: async (t, s = {}) => {
      se("setDefaultPaymentMethod", "methodId", t);
      const n = "/account/billing/payment-methods/{methodId}/default".replace("{methodId}", encodeURIComponent(String(t))), r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "POST", ...i, ...s }, l = {}, d = {};
      await ee(l, e), Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, {
        url: J(r),
        options: o
      };
    },
    /**
     * 
     * @summary Subscribe to a bundle.
     * @param {string} bundlePath Unique bundle path id.
     * @param {SubscribeRequest} [subscribeRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    subscribeBundle: async (t, s, n = {}) => {
      se("subscribeBundle", "bundlePath", t);
      const r = "/account/billing/bundles/{bundlePath}/subscribe".replace("{bundlePath}", encodeURIComponent(String(t))), i = new URL(r, K);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "POST", ...o, ...n }, d = {}, c = {};
      await ee(d, e), d["Content-Type"] = "application/json", Z(i, c);
      let u = o && o.headers ? o.headers : {};
      return l.headers = { ...d, ...u, ...n.headers }, l.data = kt(s, l, e), {
        url: J(i),
        options: l
      };
    },
    /**
     * 
     * @summary Validates a coupon code.
     * @param {string} code Coupon code
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    validateCoupon: async (t, s = {}) => {
      se("validateCoupon", "code", t);
      const n = "/account/billing/coupon/{code}".replace("{code}", encodeURIComponent(String(t))), r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "POST", ...i, ...s }, l = {}, d = {};
      await ee(l, e), Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, {
        url: J(r),
        options: o
      };
    }
  };
}, n6 = function(e) {
  const t = a6(e);
  return {
    /**
     * 
     * @summary Add a payment method.
     * @param {string} methodId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async addPaymentMethod(s, n) {
      var l, d;
      const r = await t.addPaymentMethod(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["BillingApi.addPaymentMethod"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    },
    /**
     * 
     * @summary List add-ons available for package.
     * @param {number} packageId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getAddOns(s, n) {
      var l, d;
      const r = await t.getAddOns(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["BillingApi.getAddOns"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    },
    /**
     * 
     * @param {string} bundlePath 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getBundle(s, n) {
      var l, d;
      const r = await t.getBundle(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["BillingApi.getBundle"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    },
    /**
     * 
     * @summary List invoices for user.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getInvoices(s) {
      var o, l;
      const n = await t.getInvoices(s), r = (e == null ? void 0 : e.serverIndex) ?? 0, i = (l = (o = Q["BillingApi.getInvoices"]) == null ? void 0 : o[r]) == null ? void 0 : l.url;
      return (d, c) => _(n, X, G, e)(d, i || c);
    },
    /**
     * 
     * @summary List available packages to purchase
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getPackages(s) {
      var o, l;
      const n = await t.getPackages(s), r = (e == null ? void 0 : e.serverIndex) ?? 0, i = (l = (o = Q["BillingApi.getPackages"]) == null ? void 0 : o[r]) == null ? void 0 : l.url;
      return (d, c) => _(n, X, G, e)(d, i || c);
    },
    /**
     * 
     * @summary List payment methods for user.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getPaymentMethods(s) {
      var o, l;
      const n = await t.getPaymentMethods(s), r = (e == null ? void 0 : e.serverIndex) ?? 0, i = (l = (o = Q["BillingApi.getPaymentMethods"]) == null ? void 0 : o[r]) == null ? void 0 : l.url;
      return (d, c) => _(n, X, G, e)(d, i || c);
    },
    /**
     * 
     * @summary Remove a payment method.
     * @param {string} methodId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async removePaymentMethod(s, n) {
      var l, d;
      const r = await t.removePaymentMethod(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["BillingApi.removePaymentMethod"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    },
    /**
     * 
     * @summary Set a payment method as default.
     * @param {string} methodId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async setDefaultPaymentMethod(s, n) {
      var l, d;
      const r = await t.setDefaultPaymentMethod(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["BillingApi.setDefaultPaymentMethod"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    },
    /**
     * 
     * @summary Subscribe to a bundle.
     * @param {string} bundlePath Unique bundle path id.
     * @param {SubscribeRequest} [subscribeRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async subscribeBundle(s, n, r) {
      var d, c;
      const i = await t.subscribeBundle(s, n, r), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (c = (d = Q["BillingApi.subscribeBundle"]) == null ? void 0 : d[o]) == null ? void 0 : c.url;
      return (u, m) => _(i, X, G, e)(u, l || m);
    },
    /**
     * 
     * @summary Validates a coupon code.
     * @param {string} code Coupon code
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async validateCoupon(s, n) {
      var l, d;
      const r = await t.validateCoupon(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["BillingApi.validateCoupon"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    }
  };
}, r6 = function(e, t, s) {
  const n = n6(e);
  return {
    /**
     * 
     * @summary Add a payment method.
     * @param {string} methodId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addPaymentMethod(r, i) {
      return n.addPaymentMethod(r, i).then((o) => o(s, t));
    },
    /**
     * 
     * @summary List add-ons available for package.
     * @param {number} packageId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAddOns(r, i) {
      return n.getAddOns(r, i).then((o) => o(s, t));
    },
    /**
     * 
     * @param {string} bundlePath 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getBundle(r, i) {
      return n.getBundle(r, i).then((o) => o(s, t));
    },
    /**
     * 
     * @summary List invoices for user.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getInvoices(r) {
      return n.getInvoices(r).then((i) => i(s, t));
    },
    /**
     * 
     * @summary List available packages to purchase
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPackages(r) {
      return n.getPackages(r).then((i) => i(s, t));
    },
    /**
     * 
     * @summary List payment methods for user.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPaymentMethods(r) {
      return n.getPaymentMethods(r).then((i) => i(s, t));
    },
    /**
     * 
     * @summary Remove a payment method.
     * @param {string} methodId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    removePaymentMethod(r, i) {
      return n.removePaymentMethod(r, i).then((o) => o(s, t));
    },
    /**
     * 
     * @summary Set a payment method as default.
     * @param {string} methodId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    setDefaultPaymentMethod(r, i) {
      return n.setDefaultPaymentMethod(r, i).then((o) => o(s, t));
    },
    /**
     * 
     * @summary Subscribe to a bundle.
     * @param {string} bundlePath Unique bundle path id.
     * @param {SubscribeRequest} [subscribeRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    subscribeBundle(r, i, o) {
      return n.subscribeBundle(r, i, o).then((l) => l(s, t));
    },
    /**
     * 
     * @summary Validates a coupon code.
     * @param {string} code Coupon code
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    validateCoupon(r, i) {
      return n.validateCoupon(r, i).then((o) => o(s, t));
    }
  };
}, o6 = function(e) {
  return {
    /**
     * 
     * @param {string} groupPath 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProductGroup: async (t, s = {}) => {
      se("getProductGroup", "groupPath", t);
      const n = "/account/billing/group/{groupPath}".replace("{groupPath}", encodeURIComponent(String(t))), r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "GET", ...i, ...s }, l = {}, d = {};
      await ee(l, e), Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, {
        url: J(r),
        options: o
      };
    },
    /**
     * 
     * @param {string} groupPath 
     * @param {GroupSubscription} [groupSubscription] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    subscribeGroup: async (t, s, n = {}) => {
      se("subscribeGroup", "groupPath", t);
      const r = "/account/billing/group/{groupPath}/subscribe".replace("{groupPath}", encodeURIComponent(String(t))), i = new URL(r, K);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "POST", ...o, ...n }, d = {}, c = {};
      await ee(d, e), d["Content-Type"] = "application/json", Z(i, c);
      let u = o && o.headers ? o.headers : {};
      return l.headers = { ...d, ...u, ...n.headers }, l.data = kt(s, l, e), {
        url: J(i),
        options: l
      };
    }
  };
}, rA = function(e) {
  const t = o6(e);
  return {
    /**
     * 
     * @param {string} groupPath 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getProductGroup(s, n) {
      var l, d;
      const r = await t.getProductGroup(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["BillingProductGroupsApi.getProductGroup"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    },
    /**
     * 
     * @param {string} groupPath 
     * @param {GroupSubscription} [groupSubscription] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async subscribeGroup(s, n, r) {
      var d, c;
      const i = await t.subscribeGroup(s, n, r), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (c = (d = Q["BillingProductGroupsApi.subscribeGroup"]) == null ? void 0 : d[o]) == null ? void 0 : c.url;
      return (u, m) => _(i, X, G, e)(u, l || m);
    }
  };
};
class i6 extends Fn {
  /**
   * 
   * @param {string} groupPath 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BillingProductGroupsApi
   */
  getProductGroup(t, s) {
    return rA(this.configuration).getProductGroup(t, s).then((n) => n(this.axios, this.basePath));
  }
  /**
   * 
   * @param {string} groupPath 
   * @param {GroupSubscription} [groupSubscription] 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BillingProductGroupsApi
   */
  subscribeGroup(t, s, n) {
    return rA(this.configuration).subscribeGroup(t, s, n).then((r) => r(this.axios, this.basePath));
  }
}
const l6 = function(e) {
  return {
    /**
     * 
     * @summary Accept user brand request
     * @param {number} requesterId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    acceptUserRequest: async (t, s = {}) => {
      se("acceptUserRequest", "requesterId", t);
      const n = "/brand/accept/{requesterId}".replace("{requesterId}", encodeURIComponent(String(t))), r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "POST", ...i, ...s }, l = {}, d = {};
      await ee(l, e), Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, {
        url: J(r),
        options: o
      };
    },
    /**
     * 
     * @summary Invite Brand Admin
     * @param {AddBrandAdminModel} [addBrandAdminModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addBrandAdmin: async (t, s = {}) => {
      const n = "/brand/add-admin", r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "POST", ...i, ...s }, l = {}, d = {};
      await ee(l, e), l["Content-Type"] = "application/json", Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, o.data = kt(t, o, e), {
        url: J(r),
        options: o
      };
    },
    /**
     * 
     * @summary Asso
     * @param {string} linkKey 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    associateAccount: async (t, s = {}) => {
      se("associateAccount", "linkKey", t);
      const n = "/brand/associate/{linkKey}".replace("{linkKey}", encodeURIComponent(String(t))), r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "POST", ...i, ...s }, l = {}, d = {};
      await ee(l, e), Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, {
        url: J(r),
        options: o
      };
    },
    /**
     * 
     * @summary Get Brand users
     * @param {number} [page] Current page of clients to return.
     * @param {number} [pageSize] Total clients per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getBrandAdmins: async (t, s, n = {}) => {
      const r = "/brand/admins", i = new URL(r, K);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "GET", ...o, ...n }, d = {}, c = {};
      await ee(d, e), t !== void 0 && (c.page = t), s !== void 0 && (c.pageSize = s), Z(i, c);
      let u = o && o.headers ? o.headers : {};
      return l.headers = { ...d, ...u, ...n.headers }, {
        url: J(i),
        options: l
      };
    },
    /**
     * 
     * @summary Get User Organization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getBrandInfo: async (t = {}) => {
      const s = "/brand/info", n = new URL(s, K);
      let r;
      e && (r = e.baseOptions);
      const i = { method: "GET", ...r, ...t }, o = {}, l = {};
      await ee(o, e), Z(n, l);
      let d = r && r.headers ? r.headers : {};
      return i.headers = { ...o, ...d, ...t.headers }, {
        url: J(n),
        options: i
      };
    },
    /**
     * 
     * @summary Get Brand users
     * @param {number} [page] Current page of clients to return.
     * @param {number} [pageSize] Total clients per page.
     * @param {boolean} [subAccounts] Show only subaccounts
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getBrandMembers: async (t, s, n, r = {}) => {
      const i = "/brand/members", o = new URL(i, K);
      let l;
      e && (l = e.baseOptions);
      const d = { method: "GET", ...l, ...r }, c = {}, u = {};
      await ee(c, e), t !== void 0 && (u.page = t), s !== void 0 && (u.pageSize = s), n !== void 0 && (u.subAccounts = n), Z(o, u);
      let m = l && l.headers ? l.headers : {};
      return d.headers = { ...c, ...m, ...r.headers }, {
        url: J(o),
        options: d
      };
    },
    /**
     * 
     * @summary Invite Brand Member
     * @param {InviteBrandMemberModel} [inviteBrandMemberModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    inviteBrandMember: async (t, s = {}) => {
      const n = "/brand/invite", r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "POST", ...i, ...s }, l = {}, d = {};
      await ee(l, e), l["Content-Type"] = "application/json", Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, o.data = kt(t, o, e), {
        url: J(r),
        options: o
      };
    },
    /**
     * 
     * @summary Reject user brand request
     * @param {number} requesterId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    rejectUserRequest: async (t, s = {}) => {
      se("rejectUserRequest", "requesterId", t);
      const n = "/brand/reject/{requesterId}".replace("{requesterId}", encodeURIComponent(String(t))), r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "POST", ...i, ...s }, l = {}, d = {};
      await ee(l, e), Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, {
        url: J(r),
        options: o
      };
    },
    /**
     * 
     * @summary Unlink Brand Administrator
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    removeBrandAdmin: async (t, s = {}) => {
      se("removeBrandAdmin", "id", t);
      const n = "/brand/remove-admin/{id}".replace("{id}", encodeURIComponent(String(t))), r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "POST", ...i, ...s }, l = {}, d = {};
      await ee(l, e), Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, {
        url: J(r),
        options: o
      };
    },
    /**
     * 
     * @summary Unlink Brand Member
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    removeBrandMember: async (t, s = {}) => {
      se("removeBrandMember", "id", t);
      const n = "/brand/remove/{id}".replace("{id}", encodeURIComponent(String(t))), r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "POST", ...i, ...s }, l = {}, d = {};
      await ee(l, e), Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, {
        url: J(r),
        options: o
      };
    },
    /**
     * 
     * @summary Invite Brand Member
     * @param {number} inviteId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    resendMemberInvite: async (t, s = {}) => {
      se("resendMemberInvite", "inviteId", t);
      const n = "/brand/resend-invite/{inviteId}".replace("{inviteId}", encodeURIComponent(String(t))), r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "POST", ...i, ...s }, l = {}, d = {};
      await ee(l, e), Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, {
        url: J(r),
        options: o
      };
    }
  };
}, d6 = function(e) {
  const t = l6(e);
  return {
    /**
     * 
     * @summary Accept user brand request
     * @param {number} requesterId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async acceptUserRequest(s, n) {
      var l, d;
      const r = await t.acceptUserRequest(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["BrandApi.acceptUserRequest"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    },
    /**
     * 
     * @summary Invite Brand Admin
     * @param {AddBrandAdminModel} [addBrandAdminModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async addBrandAdmin(s, n) {
      var l, d;
      const r = await t.addBrandAdmin(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["BrandApi.addBrandAdmin"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    },
    /**
     * 
     * @summary Asso
     * @param {string} linkKey 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async associateAccount(s, n) {
      var l, d;
      const r = await t.associateAccount(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["BrandApi.associateAccount"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    },
    /**
     * 
     * @summary Get Brand users
     * @param {number} [page] Current page of clients to return.
     * @param {number} [pageSize] Total clients per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getBrandAdmins(s, n, r) {
      var d, c;
      const i = await t.getBrandAdmins(s, n, r), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (c = (d = Q["BrandApi.getBrandAdmins"]) == null ? void 0 : d[o]) == null ? void 0 : c.url;
      return (u, m) => _(i, X, G, e)(u, l || m);
    },
    /**
     * 
     * @summary Get User Organization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getBrandInfo(s) {
      var o, l;
      const n = await t.getBrandInfo(s), r = (e == null ? void 0 : e.serverIndex) ?? 0, i = (l = (o = Q["BrandApi.getBrandInfo"]) == null ? void 0 : o[r]) == null ? void 0 : l.url;
      return (d, c) => _(n, X, G, e)(d, i || c);
    },
    /**
     * 
     * @summary Get Brand users
     * @param {number} [page] Current page of clients to return.
     * @param {number} [pageSize] Total clients per page.
     * @param {boolean} [subAccounts] Show only subaccounts
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getBrandMembers(s, n, r, i) {
      var c, u;
      const o = await t.getBrandMembers(s, n, r, i), l = (e == null ? void 0 : e.serverIndex) ?? 0, d = (u = (c = Q["BrandApi.getBrandMembers"]) == null ? void 0 : c[l]) == null ? void 0 : u.url;
      return (m, f) => _(o, X, G, e)(m, d || f);
    },
    /**
     * 
     * @summary Invite Brand Member
     * @param {InviteBrandMemberModel} [inviteBrandMemberModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async inviteBrandMember(s, n) {
      var l, d;
      const r = await t.inviteBrandMember(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["BrandApi.inviteBrandMember"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    },
    /**
     * 
     * @summary Reject user brand request
     * @param {number} requesterId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async rejectUserRequest(s, n) {
      var l, d;
      const r = await t.rejectUserRequest(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["BrandApi.rejectUserRequest"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    },
    /**
     * 
     * @summary Unlink Brand Administrator
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async removeBrandAdmin(s, n) {
      var l, d;
      const r = await t.removeBrandAdmin(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["BrandApi.removeBrandAdmin"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    },
    /**
     * 
     * @summary Unlink Brand Member
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async removeBrandMember(s, n) {
      var l, d;
      const r = await t.removeBrandMember(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["BrandApi.removeBrandMember"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    },
    /**
     * 
     * @summary Invite Brand Member
     * @param {number} inviteId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async resendMemberInvite(s, n) {
      var l, d;
      const r = await t.resendMemberInvite(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["BrandApi.resendMemberInvite"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    }
  };
}, c6 = function(e, t, s) {
  const n = d6(e);
  return {
    /**
     * 
     * @summary Accept user brand request
     * @param {number} requesterId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    acceptUserRequest(r, i) {
      return n.acceptUserRequest(r, i).then((o) => o(s, t));
    },
    /**
     * 
     * @summary Invite Brand Admin
     * @param {AddBrandAdminModel} [addBrandAdminModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addBrandAdmin(r, i) {
      return n.addBrandAdmin(r, i).then((o) => o(s, t));
    },
    /**
     * 
     * @summary Asso
     * @param {string} linkKey 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    associateAccount(r, i) {
      return n.associateAccount(r, i).then((o) => o(s, t));
    },
    /**
     * 
     * @summary Get Brand users
     * @param {number} [page] Current page of clients to return.
     * @param {number} [pageSize] Total clients per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getBrandAdmins(r, i, o) {
      return n.getBrandAdmins(r, i, o).then((l) => l(s, t));
    },
    /**
     * 
     * @summary Get User Organization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getBrandInfo(r) {
      return n.getBrandInfo(r).then((i) => i(s, t));
    },
    /**
     * 
     * @summary Get Brand users
     * @param {number} [page] Current page of clients to return.
     * @param {number} [pageSize] Total clients per page.
     * @param {boolean} [subAccounts] Show only subaccounts
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getBrandMembers(r, i, o, l) {
      return n.getBrandMembers(r, i, o, l).then((d) => d(s, t));
    },
    /**
     * 
     * @summary Invite Brand Member
     * @param {InviteBrandMemberModel} [inviteBrandMemberModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    inviteBrandMember(r, i) {
      return n.inviteBrandMember(r, i).then((o) => o(s, t));
    },
    /**
     * 
     * @summary Reject user brand request
     * @param {number} requesterId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    rejectUserRequest(r, i) {
      return n.rejectUserRequest(r, i).then((o) => o(s, t));
    },
    /**
     * 
     * @summary Unlink Brand Administrator
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    removeBrandAdmin(r, i) {
      return n.removeBrandAdmin(r, i).then((o) => o(s, t));
    },
    /**
     * 
     * @summary Unlink Brand Member
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    removeBrandMember(r, i) {
      return n.removeBrandMember(r, i).then((o) => o(s, t));
    },
    /**
     * 
     * @summary Invite Brand Member
     * @param {number} inviteId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    resendMemberInvite(r, i) {
      return n.resendMemberInvite(r, i).then((o) => o(s, t));
    }
  };
}, u6 = function(e) {
  return {
    /**
     * 
     * @summary Create/Update real estate agent in CRM.
     * @param {string} provider CRM provider.
     * @param {string} source MLS Agent belongs to.
     * @param {string} agentId ID of agent.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createAgentLead: async (t, s, n, r = {}) => {
      se("createAgentLead", "provider", t), se("createAgentLead", "source", s), se("createAgentLead", "agentId", n);
      const i = "/leads/crm/{provider}/agents/{source}/{agentId}".replace("{provider}", encodeURIComponent(String(t))).replace("{source}", encodeURIComponent(String(s))).replace("{agentId}", encodeURIComponent(String(n))), o = new URL(i, K);
      let l;
      e && (l = e.baseOptions);
      const d = { method: "POST", ...l, ...r }, c = {}, u = {};
      await ee(c, e), Z(o, u);
      let m = l && l.headers ? l.headers : {};
      return d.headers = { ...c, ...m, ...r.headers }, {
        url: J(o),
        options: d
      };
    },
    /**
     * 
     * @summary Create/Update lead in CRM base on portfolio owner.
     * @param {string} provider CRM provider.
     * @param {number} ownerId ID of portfolio owner.
     * @param {CreateLeadRequest} [createLeadRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createLead: async (t, s, n, r = {}) => {
      se("createLead", "provider", t), se("createLead", "ownerId", s);
      const i = "/leads/crm/{provider}/owner/{ownerId}".replace("{provider}", encodeURIComponent(String(t))).replace("{ownerId}", encodeURIComponent(String(s))), o = new URL(i, K);
      let l;
      e && (l = e.baseOptions);
      const d = { method: "POST", ...l, ...r }, c = {}, u = {};
      await ee(c, e), c["Content-Type"] = "application/json", Z(o, u);
      let m = l && l.headers ? l.headers : {};
      return d.headers = { ...c, ...m, ...r.headers }, d.data = kt(n, d, e), {
        url: J(o),
        options: d
      };
    },
    /**
     * 
     * @summary Create/Update lead in CRM based on single property.
     * @param {string} provider CRM provider.
     * @param {number} propId ID of owner.
     * @param {CreateLeadRequest} [createLeadRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createPropertyOwnerLead: async (t, s, n, r = {}) => {
      se("createPropertyOwnerLead", "provider", t), se("createPropertyOwnerLead", "propId", s);
      const i = "/leads/crm/{provider}/property-owner/{propId}".replace("{provider}", encodeURIComponent(String(t))).replace("{propId}", encodeURIComponent(String(s))), o = new URL(i, K);
      let l;
      e && (l = e.baseOptions);
      const d = { method: "POST", ...l, ...r }, c = {}, u = {};
      await ee(c, e), c["Content-Type"] = "application/json", Z(o, u);
      let m = l && l.headers ? l.headers : {};
      return d.headers = { ...c, ...m, ...r.headers }, d.data = kt(n, d, e), {
        url: J(o),
        options: d
      };
    },
    /**
     * 
     * @summary Retrieve list of campaigns available for lead.
     * @param {string} provider CRM provider.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCampaigns: async (t, s = {}) => {
      se("getCampaigns", "provider", t);
      const n = "/leads/crm/{provider}/campaigns".replace("{provider}", encodeURIComponent(String(t))), r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "GET", ...i, ...s }, l = {}, d = {};
      await ee(l, e), Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, {
        url: J(r),
        options: o
      };
    },
    /**
     * 
     * @summary Retrieve list of options available for field.
     * @param {string} provider CRM provider.
     * @param {string} fieldId ID of field for provider.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getFieldOptions: async (t, s, n = {}) => {
      se("getFieldOptions", "provider", t), se("getFieldOptions", "fieldId", s);
      const r = "/leads/crm/{provider}/fields/{fieldId}/options".replace("{provider}", encodeURIComponent(String(t))).replace("{fieldId}", encodeURIComponent(String(s))), i = new URL(r, K);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "GET", ...o, ...n }, d = {}, c = {};
      await ee(d, e), Z(i, c);
      let u = o && o.headers ? o.headers : {};
      return l.headers = { ...d, ...u, ...n.headers }, {
        url: J(i),
        options: l
      };
    },
    /**
     * 
     * @summary Settings for CRM.
     * @param {string} provider 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getIdxSettings: async (t, s = {}) => {
      se("getIdxSettings", "provider", t);
      const n = "/leads/crm/{provider}/idx-settings".replace("{provider}", encodeURIComponent(String(t))), r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "GET", ...i, ...s }, l = {}, d = {};
      await ee(l, e), Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, {
        url: J(r),
        options: o
      };
    },
    /**
     * 
     * @summary Retrieve lead from CRM.
     * @param {string} provider CRM Provider
     * @param {number} ownerId ID of owner.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getLead: async (t, s, n = {}) => {
      se("getLead", "provider", t), se("getLead", "ownerId", s);
      const r = "/leads/crm/{provider}/owner/{ownerId}".replace("{provider}", encodeURIComponent(String(t))).replace("{ownerId}", encodeURIComponent(String(s))), i = new URL(r, K);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "GET", ...o, ...n }, d = {}, c = {};
      await ee(d, e), Z(i, c);
      let u = o && o.headers ? o.headers : {};
      return l.headers = { ...d, ...u, ...n.headers }, {
        url: J(i),
        options: l
      };
    },
    /**
     * 
     * @summary Retrieve list of pipelines from CRM.
     * @param {string} provider 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPipelines: async (t, s = {}) => {
      se("getPipelines", "provider", t);
      const n = "/leads/crm/{provider}/pipelines".replace("{provider}", encodeURIComponent(String(t))), r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "GET", ...i, ...s }, l = {}, d = {};
      await ee(l, e), Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, {
        url: J(r),
        options: o
      };
    },
    /**
     * 
     * @summary Get PPE settings for CRM.
     * @param {string} provider 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPpeSettings: async (t, s = {}) => {
      se("getPpeSettings", "provider", t);
      const n = "/leads/crm/{provider}/ppe-settings".replace("{provider}", encodeURIComponent(String(t))), r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "GET", ...i, ...s }, l = {}, d = {};
      await ee(l, e), Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, {
        url: J(r),
        options: o
      };
    },
    /**
     * 
     * @summary Settings for CRM.
     * @param {string} provider 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSettings: async (t, s = {}) => {
      se("getSettings", "provider", t);
      const n = "/leads/crm/{provider}/settings".replace("{provider}", encodeURIComponent(String(t))), r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "GET", ...i, ...s }, l = {}, d = {};
      await ee(l, e), Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, {
        url: J(r),
        options: o
      };
    },
    /**
     * 
     * @summary Retrieve list of sources for a pipeline from CRM.
     * @param {string} pipelineId Pipeline Id to list sources for.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSources: async (t, s = {}) => {
      se("getSources", "pipelineId", t);
      const n = "/leads/crm/lead-simple/pipelines/{pipelineId}/sources".replace("{pipelineId}", encodeURIComponent(String(t))), r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "GET", ...i, ...s }, l = {}, d = {};
      await ee(l, e), Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, {
        url: J(r),
        options: o
      };
    },
    /**
     * 
     * @summary Retrieve list of stages for a pipeline from CRM.
     * @param {string} provider 
     * @param {string} pipelineId Pipeline Id to list stages.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getStages: async (t, s, n = {}) => {
      se("getStages", "provider", t), se("getStages", "pipelineId", s);
      const r = "/leads/crm/{provider}/pipelines/{pipelineId}/stages".replace("{provider}", encodeURIComponent(String(t))).replace("{pipelineId}", encodeURIComponent(String(s))), i = new URL(r, K);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "GET", ...o, ...n }, d = {}, c = {};
      await ee(d, e), Z(i, c);
      let u = o && o.headers ? o.headers : {};
      return l.headers = { ...d, ...u, ...n.headers }, {
        url: J(i),
        options: l
      };
    },
    /**
     * 
     * @summary List account\'s CRM user assignments.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUserAssignments: async (t = {}) => {
      const s = "/leads/crm/users", n = new URL(s, K);
      let r;
      e && (r = e.baseOptions);
      const i = { method: "GET", ...r, ...t }, o = {}, l = {};
      await ee(o, e), Z(n, l);
      let d = r && r.headers ? r.headers : {};
      return i.headers = { ...o, ...d, ...t.headers }, {
        url: J(n),
        options: i
      };
    },
    /**
     * 
     * @summary Retrieve list of users from configured CRM.
     * @param {string} provider 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUsers: async (t, s = {}) => {
      se("getUsers", "provider", t);
      const n = "/leads/crm/{provider}/users".replace("{provider}", encodeURIComponent(String(t))), r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "GET", ...i, ...s }, l = {}, d = {};
      await ee(l, e), Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, {
        url: J(r),
        options: o
      };
    },
    /**
     * 
     * @summary Is CRM provider configured.
     * @param {string} provider CRM provider.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    isConfigured: async (t, s = {}) => {
      se("isConfigured", "provider", t);
      const n = "/leads/crm/{provider}/is-configured".replace("{provider}", encodeURIComponent(String(t))), r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "GET", ...i, ...s }, l = {}, d = {};
      await ee(l, e), Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, {
        url: J(r),
        options: o
      };
    },
    /**
     * 
     * @summary Unlink CRM from rescover.
     * @param {string} provider CRM provider.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    unlink: async (t, s = {}) => {
      se("unlink", "provider", t);
      const n = "/leads/crm/{provider}/unlink".replace("{provider}", encodeURIComponent(String(t))), r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "POST", ...i, ...s }, l = {}, d = {};
      await ee(l, e), Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, {
        url: J(r),
        options: o
      };
    },
    /**
     * 
     * @summary Update settings for CRM.
     * @param {string} provider CRM provider.
     * @param {UpdateCrmSettings} [updateCrmSettings] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateIdxSettings: async (t, s, n = {}) => {
      se("updateIdxSettings", "provider", t);
      const r = "/leads/crm/{provider}/idx-settings".replace("{provider}", encodeURIComponent(String(t))), i = new URL(r, K);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "POST", ...o, ...n }, d = {}, c = {};
      await ee(d, e), d["Content-Type"] = "application/json", Z(i, c);
      let u = o && o.headers ? o.headers : {};
      return l.headers = { ...d, ...u, ...n.headers }, l.data = kt(s, l, e), {
        url: J(i),
        options: l
      };
    },
    /**
     * 
     * @summary Update settings for CRM.
     * @param {string} provider CRM provider.
     * @param {UpdateCrmSettings} [updateCrmSettings] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updatePpeSettings: async (t, s, n = {}) => {
      se("updatePpeSettings", "provider", t);
      const r = "/leads/crm/{provider}/ppe-settings".replace("{provider}", encodeURIComponent(String(t))), i = new URL(r, K);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "POST", ...o, ...n }, d = {}, c = {};
      await ee(d, e), d["Content-Type"] = "application/json", Z(i, c);
      let u = o && o.headers ? o.headers : {};
      return l.headers = { ...d, ...u, ...n.headers }, l.data = kt(s, l, e), {
        url: J(i),
        options: l
      };
    },
    /**
     * 
     * @summary Update settings for CRM.
     * @param {string} provider CRM provider.
     * @param {UpdateCrmSettings} [updateCrmSettings] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateSettings: async (t, s, n = {}) => {
      se("updateSettings", "provider", t);
      const r = "/leads/crm/{provider}/settings".replace("{provider}", encodeURIComponent(String(t))), i = new URL(r, K);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "POST", ...o, ...n }, d = {}, c = {};
      await ee(d, e), d["Content-Type"] = "application/json", Z(i, c);
      let u = o && o.headers ? o.headers : {};
      return l.headers = { ...d, ...u, ...n.headers }, l.data = kt(s, l, e), {
        url: J(i),
        options: l
      };
    },
    /**
     * 
     * @summary Update account\'s CRM user assignments.
     * @param {CrmUpdateUserAssignments} [crmUpdateUserAssignments] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateUserAssignments: async (t, s = {}) => {
      const n = "/leads/crm/users", r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "POST", ...i, ...s }, l = {}, d = {};
      await ee(l, e), l["Content-Type"] = "application/json", Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, o.data = kt(t, o, e), {
        url: J(r),
        options: o
      };
    },
    /**
     * 
     * @summary Verify connection to CRM is valid.
     * @param {string} provider 
     * @param {{ [key: string]: string; }} [requestBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    verifyConnection: async (t, s, n = {}) => {
      se("verifyConnection", "provider", t);
      const r = "/leads/crm/{provider}/verify-connection".replace("{provider}", encodeURIComponent(String(t))), i = new URL(r, K);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "POST", ...o, ...n }, d = {}, c = {};
      await ee(d, e), d["Content-Type"] = "application/json", Z(i, c);
      let u = o && o.headers ? o.headers : {};
      return l.headers = { ...d, ...u, ...n.headers }, l.data = kt(s, l, e), {
        url: J(i),
        options: l
      };
    }
  };
}, p6 = function(e) {
  const t = u6(e);
  return {
    /**
     * 
     * @summary Create/Update real estate agent in CRM.
     * @param {string} provider CRM provider.
     * @param {string} source MLS Agent belongs to.
     * @param {string} agentId ID of agent.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createAgentLead(s, n, r, i) {
      var c, u;
      const o = await t.createAgentLead(s, n, r, i), l = (e == null ? void 0 : e.serverIndex) ?? 0, d = (u = (c = Q["CRMApi.createAgentLead"]) == null ? void 0 : c[l]) == null ? void 0 : u.url;
      return (m, f) => _(o, X, G, e)(m, d || f);
    },
    /**
     * 
     * @summary Create/Update lead in CRM base on portfolio owner.
     * @param {string} provider CRM provider.
     * @param {number} ownerId ID of portfolio owner.
     * @param {CreateLeadRequest} [createLeadRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createLead(s, n, r, i) {
      var c, u;
      const o = await t.createLead(s, n, r, i), l = (e == null ? void 0 : e.serverIndex) ?? 0, d = (u = (c = Q["CRMApi.createLead"]) == null ? void 0 : c[l]) == null ? void 0 : u.url;
      return (m, f) => _(o, X, G, e)(m, d || f);
    },
    /**
     * 
     * @summary Create/Update lead in CRM based on single property.
     * @param {string} provider CRM provider.
     * @param {number} propId ID of owner.
     * @param {CreateLeadRequest} [createLeadRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createPropertyOwnerLead(s, n, r, i) {
      var c, u;
      const o = await t.createPropertyOwnerLead(s, n, r, i), l = (e == null ? void 0 : e.serverIndex) ?? 0, d = (u = (c = Q["CRMApi.createPropertyOwnerLead"]) == null ? void 0 : c[l]) == null ? void 0 : u.url;
      return (m, f) => _(o, X, G, e)(m, d || f);
    },
    /**
     * 
     * @summary Retrieve list of campaigns available for lead.
     * @param {string} provider CRM provider.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getCampaigns(s, n) {
      var l, d;
      const r = await t.getCampaigns(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["CRMApi.getCampaigns"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    },
    /**
     * 
     * @summary Retrieve list of options available for field.
     * @param {string} provider CRM provider.
     * @param {string} fieldId ID of field for provider.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getFieldOptions(s, n, r) {
      var d, c;
      const i = await t.getFieldOptions(s, n, r), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (c = (d = Q["CRMApi.getFieldOptions"]) == null ? void 0 : d[o]) == null ? void 0 : c.url;
      return (u, m) => _(i, X, G, e)(u, l || m);
    },
    /**
     * 
     * @summary Settings for CRM.
     * @param {string} provider 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getIdxSettings(s, n) {
      var l, d;
      const r = await t.getIdxSettings(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["CRMApi.getIdxSettings"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    },
    /**
     * 
     * @summary Retrieve lead from CRM.
     * @param {string} provider CRM Provider
     * @param {number} ownerId ID of owner.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getLead(s, n, r) {
      var d, c;
      const i = await t.getLead(s, n, r), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (c = (d = Q["CRMApi.getLead"]) == null ? void 0 : d[o]) == null ? void 0 : c.url;
      return (u, m) => _(i, X, G, e)(u, l || m);
    },
    /**
     * 
     * @summary Retrieve list of pipelines from CRM.
     * @param {string} provider 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getPipelines(s, n) {
      var l, d;
      const r = await t.getPipelines(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["CRMApi.getPipelines"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    },
    /**
     * 
     * @summary Get PPE settings for CRM.
     * @param {string} provider 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getPpeSettings(s, n) {
      var l, d;
      const r = await t.getPpeSettings(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["CRMApi.getPpeSettings"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    },
    /**
     * 
     * @summary Settings for CRM.
     * @param {string} provider 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getSettings(s, n) {
      var l, d;
      const r = await t.getSettings(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["CRMApi.getSettings"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    },
    /**
     * 
     * @summary Retrieve list of sources for a pipeline from CRM.
     * @param {string} pipelineId Pipeline Id to list sources for.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getSources(s, n) {
      var l, d;
      const r = await t.getSources(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["CRMApi.getSources"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    },
    /**
     * 
     * @summary Retrieve list of stages for a pipeline from CRM.
     * @param {string} provider 
     * @param {string} pipelineId Pipeline Id to list stages.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getStages(s, n, r) {
      var d, c;
      const i = await t.getStages(s, n, r), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (c = (d = Q["CRMApi.getStages"]) == null ? void 0 : d[o]) == null ? void 0 : c.url;
      return (u, m) => _(i, X, G, e)(u, l || m);
    },
    /**
     * 
     * @summary List account\'s CRM user assignments.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getUserAssignments(s) {
      var o, l;
      const n = await t.getUserAssignments(s), r = (e == null ? void 0 : e.serverIndex) ?? 0, i = (l = (o = Q["CRMApi.getUserAssignments"]) == null ? void 0 : o[r]) == null ? void 0 : l.url;
      return (d, c) => _(n, X, G, e)(d, i || c);
    },
    /**
     * 
     * @summary Retrieve list of users from configured CRM.
     * @param {string} provider 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getUsers(s, n) {
      var l, d;
      const r = await t.getUsers(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["CRMApi.getUsers"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    },
    /**
     * 
     * @summary Is CRM provider configured.
     * @param {string} provider CRM provider.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async isConfigured(s, n) {
      var l, d;
      const r = await t.isConfigured(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["CRMApi.isConfigured"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    },
    /**
     * 
     * @summary Unlink CRM from rescover.
     * @param {string} provider CRM provider.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async unlink(s, n) {
      var l, d;
      const r = await t.unlink(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["CRMApi.unlink"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    },
    /**
     * 
     * @summary Update settings for CRM.
     * @param {string} provider CRM provider.
     * @param {UpdateCrmSettings} [updateCrmSettings] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateIdxSettings(s, n, r) {
      var d, c;
      const i = await t.updateIdxSettings(s, n, r), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (c = (d = Q["CRMApi.updateIdxSettings"]) == null ? void 0 : d[o]) == null ? void 0 : c.url;
      return (u, m) => _(i, X, G, e)(u, l || m);
    },
    /**
     * 
     * @summary Update settings for CRM.
     * @param {string} provider CRM provider.
     * @param {UpdateCrmSettings} [updateCrmSettings] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updatePpeSettings(s, n, r) {
      var d, c;
      const i = await t.updatePpeSettings(s, n, r), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (c = (d = Q["CRMApi.updatePpeSettings"]) == null ? void 0 : d[o]) == null ? void 0 : c.url;
      return (u, m) => _(i, X, G, e)(u, l || m);
    },
    /**
     * 
     * @summary Update settings for CRM.
     * @param {string} provider CRM provider.
     * @param {UpdateCrmSettings} [updateCrmSettings] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateSettings(s, n, r) {
      var d, c;
      const i = await t.updateSettings(s, n, r), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (c = (d = Q["CRMApi.updateSettings"]) == null ? void 0 : d[o]) == null ? void 0 : c.url;
      return (u, m) => _(i, X, G, e)(u, l || m);
    },
    /**
     * 
     * @summary Update account\'s CRM user assignments.
     * @param {CrmUpdateUserAssignments} [crmUpdateUserAssignments] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateUserAssignments(s, n) {
      var l, d;
      const r = await t.updateUserAssignments(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["CRMApi.updateUserAssignments"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    },
    /**
     * 
     * @summary Verify connection to CRM is valid.
     * @param {string} provider 
     * @param {{ [key: string]: string; }} [requestBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async verifyConnection(s, n, r) {
      var d, c;
      const i = await t.verifyConnection(s, n, r), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (c = (d = Q["CRMApi.verifyConnection"]) == null ? void 0 : d[o]) == null ? void 0 : c.url;
      return (u, m) => _(i, X, G, e)(u, l || m);
    }
  };
}, h6 = function(e, t, s) {
  const n = p6(e);
  return {
    /**
     * 
     * @summary Create/Update real estate agent in CRM.
     * @param {string} provider CRM provider.
     * @param {string} source MLS Agent belongs to.
     * @param {string} agentId ID of agent.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createAgentLead(r, i, o, l) {
      return n.createAgentLead(r, i, o, l).then((d) => d(s, t));
    },
    /**
     * 
     * @summary Create/Update lead in CRM base on portfolio owner.
     * @param {string} provider CRM provider.
     * @param {number} ownerId ID of portfolio owner.
     * @param {CreateLeadRequest} [createLeadRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createLead(r, i, o, l) {
      return n.createLead(r, i, o, l).then((d) => d(s, t));
    },
    /**
     * 
     * @summary Create/Update lead in CRM based on single property.
     * @param {string} provider CRM provider.
     * @param {number} propId ID of owner.
     * @param {CreateLeadRequest} [createLeadRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createPropertyOwnerLead(r, i, o, l) {
      return n.createPropertyOwnerLead(r, i, o, l).then((d) => d(s, t));
    },
    /**
     * 
     * @summary Retrieve list of campaigns available for lead.
     * @param {string} provider CRM provider.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCampaigns(r, i) {
      return n.getCampaigns(r, i).then((o) => o(s, t));
    },
    /**
     * 
     * @summary Retrieve list of options available for field.
     * @param {string} provider CRM provider.
     * @param {string} fieldId ID of field for provider.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getFieldOptions(r, i, o) {
      return n.getFieldOptions(r, i, o).then((l) => l(s, t));
    },
    /**
     * 
     * @summary Settings for CRM.
     * @param {string} provider 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getIdxSettings(r, i) {
      return n.getIdxSettings(r, i).then((o) => o(s, t));
    },
    /**
     * 
     * @summary Retrieve lead from CRM.
     * @param {string} provider CRM Provider
     * @param {number} ownerId ID of owner.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getLead(r, i, o) {
      return n.getLead(r, i, o).then((l) => l(s, t));
    },
    /**
     * 
     * @summary Retrieve list of pipelines from CRM.
     * @param {string} provider 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPipelines(r, i) {
      return n.getPipelines(r, i).then((o) => o(s, t));
    },
    /**
     * 
     * @summary Get PPE settings for CRM.
     * @param {string} provider 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPpeSettings(r, i) {
      return n.getPpeSettings(r, i).then((o) => o(s, t));
    },
    /**
     * 
     * @summary Settings for CRM.
     * @param {string} provider 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSettings(r, i) {
      return n.getSettings(r, i).then((o) => o(s, t));
    },
    /**
     * 
     * @summary Retrieve list of sources for a pipeline from CRM.
     * @param {string} pipelineId Pipeline Id to list sources for.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSources(r, i) {
      return n.getSources(r, i).then((o) => o(s, t));
    },
    /**
     * 
     * @summary Retrieve list of stages for a pipeline from CRM.
     * @param {string} provider 
     * @param {string} pipelineId Pipeline Id to list stages.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getStages(r, i, o) {
      return n.getStages(r, i, o).then((l) => l(s, t));
    },
    /**
     * 
     * @summary List account\'s CRM user assignments.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUserAssignments(r) {
      return n.getUserAssignments(r).then((i) => i(s, t));
    },
    /**
     * 
     * @summary Retrieve list of users from configured CRM.
     * @param {string} provider 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUsers(r, i) {
      return n.getUsers(r, i).then((o) => o(s, t));
    },
    /**
     * 
     * @summary Is CRM provider configured.
     * @param {string} provider CRM provider.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    isConfigured(r, i) {
      return n.isConfigured(r, i).then((o) => o(s, t));
    },
    /**
     * 
     * @summary Unlink CRM from rescover.
     * @param {string} provider CRM provider.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    unlink(r, i) {
      return n.unlink(r, i).then((o) => o(s, t));
    },
    /**
     * 
     * @summary Update settings for CRM.
     * @param {string} provider CRM provider.
     * @param {UpdateCrmSettings} [updateCrmSettings] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateIdxSettings(r, i, o) {
      return n.updateIdxSettings(r, i, o).then((l) => l(s, t));
    },
    /**
     * 
     * @summary Update settings for CRM.
     * @param {string} provider CRM provider.
     * @param {UpdateCrmSettings} [updateCrmSettings] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updatePpeSettings(r, i, o) {
      return n.updatePpeSettings(r, i, o).then((l) => l(s, t));
    },
    /**
     * 
     * @summary Update settings for CRM.
     * @param {string} provider CRM provider.
     * @param {UpdateCrmSettings} [updateCrmSettings] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateSettings(r, i, o) {
      return n.updateSettings(r, i, o).then((l) => l(s, t));
    },
    /**
     * 
     * @summary Update account\'s CRM user assignments.
     * @param {CrmUpdateUserAssignments} [crmUpdateUserAssignments] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateUserAssignments(r, i) {
      return n.updateUserAssignments(r, i).then((o) => o(s, t));
    },
    /**
     * 
     * @summary Verify connection to CRM is valid.
     * @param {string} provider 
     * @param {{ [key: string]: string; }} [requestBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    verifyConnection(r, i, o) {
      return n.verifyConnection(r, i, o).then((l) => l(s, t));
    }
  };
}, m6 = function(e) {
  return {
    /**
     * 
     * @summary Run rescover calculator against a single property.
     * @param {CalculatorRequest} calculatorRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    calculate: async (t, s = {}) => {
      se("calculate", "calculatorRequest", t);
      const n = "/calculator", r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "POST", ...i, ...s }, l = {}, d = {};
      await Lt(l, "x-api-key", e), await ee(l, e), l["Content-Type"] = "application/json", Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, o.data = kt(t, o, e), {
        url: J(r),
        options: o
      };
    },
    /**
     * 
     * @param {FlipCalculatorParameters} flipCalculatorParameters 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    calculateFlip: async (t, s = {}) => {
      se("calculateFlip", "flipCalculatorParameters", t);
      const n = "/calculator/flip", r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "POST", ...i, ...s }, l = {}, d = {};
      await Lt(l, "x-api-key", e), await ee(l, e), l["Content-Type"] = "application/json", Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, o.data = kt(t, o, e), {
        url: J(r),
        options: o
      };
    },
    /**
     * 
     * @summary Confirm purchase fact for a property
     * @param {number} propId 
     * @param {ConfirmedPurchaseFacts} [purchaseFacts] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    confirmPurchaseFact: async (t, s, n = {}) => {
      se("confirmPurchaseFact", "propId", t);
      const r = "/calculator/{propId}/purchase-facts/confirm".replace("{propId}", encodeURIComponent(String(t))), i = new URL(r, K);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "POST", ...o, ...n }, d = {}, c = {};
      await Lt(d, "x-api-key", e), await ee(d, e), s !== void 0 && (c.purchaseFacts = s), Z(i, c);
      let u = o && o.headers ? o.headers : {};
      return l.headers = { ...d, ...u, ...n.headers }, {
        url: J(i),
        options: l
      };
    },
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getInvestmentComparisons: async (t = {}) => {
      const s = "/calculator/investment-comparisons", n = new URL(s, K);
      let r;
      e && (r = e.baseOptions);
      const i = { method: "GET", ...r, ...t }, o = {}, l = {};
      await Lt(o, "x-api-key", e), await ee(o, e), Z(n, l);
      let d = r && r.headers ? r.headers : {};
      return i.headers = { ...o, ...d, ...t.headers }, {
        url: J(n),
        options: i
      };
    },
    /**
     * 
     * @summary Retrieve calculator parameters for a property, including any tweaks the user may have applied to it.
     * @param {number} propId 
     * @param {boolean} [useLedger] Use ledger entries from portfolio insights.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getParameters: async (t, s, n = {}) => {
      se("getParameters", "propId", t);
      const r = "/calculator/{propId}/parameters".replace("{propId}", encodeURIComponent(String(t))), i = new URL(r, K);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "GET", ...o, ...n }, d = {}, c = {};
      await Lt(d, "x-api-key", e), await ee(d, e), s !== void 0 && (c.useLedger = s), Z(i, c);
      let u = o && o.headers ? o.headers : {};
      return l.headers = { ...d, ...u, ...n.headers }, {
        url: J(i),
        options: l
      };
    },
    /**
     * 
     * @summary Retrieve calculator parameters for a property, including any tweaks the user may have applied to it.
     * @param {string} mlsSource 
     * @param {string} mlsNumber 
     * @param {boolean} [useLedger] Use ledger entries from portfolio insights.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getParametersMls: async (t, s, n, r = {}) => {
      se("getParametersMls", "mlsSource", t), se("getParametersMls", "mlsNumber", s);
      const i = "/calculator/{mlsSource}/{mlsNumber}/parameters".replace("{mlsSource}", encodeURIComponent(String(t))).replace("{mlsNumber}", encodeURIComponent(String(s))), o = new URL(i, K);
      let l;
      e && (l = e.baseOptions);
      const d = { method: "GET", ...l, ...r }, c = {}, u = {};
      await Lt(c, "x-api-key", e), await ee(c, e), n !== void 0 && (u.useLedger = n), Z(o, u);
      let m = l && l.headers ? l.headers : {};
      return d.headers = { ...c, ...m, ...r.headers }, {
        url: J(o),
        options: d
      };
    },
    /**
     * 
     * @summary Initialize purchase facts for property.
     * @param {number} propId 
     * @param {number} [rentalRate] 
     * @param {Date} [purchaseDate] 
     * @param {number} [purchaseAmount] 
     * @param {number} [loanTerm] 
     * @param {number} [loanAmount] 
     * @param {number} [loanInterestRate] 
     * @param {Date} [loanDate] 
     * @param {number} [annualExpenseGrowth] Estimated annual expense growth percentage
     * @param {number} [annualRentalGrowth] Estimated annual rental growth percentage
     * @param {number} [propertyAppreciation] Estimated property appreciation percentage
     * @param {number} [propertyValueEoY] Estimated property value at end of current year.
     * @param {number} [firstYearAsRental] 
     * @param {number} [propertyTax] 
     * @param {number} [associationFee] 
     * @param {number} [firstYearToAnalyze] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    initPurchaseFacts: async (t, s, n, r, i, o, l, d, c, u, m, f, v, b, w, S, I = {}) => {
      se("initPurchaseFacts", "propId", t);
      const T = "/calculator/{propId}/purchase-facts/init".replace("{propId}", encodeURIComponent(String(t))), x = new URL(T, K);
      let k;
      e && (k = e.baseOptions);
      const C = { method: "GET", ...k, ...I }, O = {}, E = {};
      await Lt(O, "x-api-key", e), await ee(O, e), s !== void 0 && (E.rentalRate = s), n !== void 0 && (E.purchaseDate = n instanceof Date ? n.toISOString().substring(0, 10) : n), r !== void 0 && (E.purchaseAmount = r), i !== void 0 && (E.loanTerm = i), o !== void 0 && (E.loanAmount = o), l !== void 0 && (E.loanInterestRate = l), d !== void 0 && (E.loanDate = d instanceof Date ? d.toISOString().substring(0, 10) : d), c !== void 0 && (E.annualExpenseGrowth = c), u !== void 0 && (E.annualRentalGrowth = u), m !== void 0 && (E.propertyAppreciation = m), f !== void 0 && (E.propertyValueEoY = f), v !== void 0 && (E.firstYearAsRental = v), b !== void 0 && (E.propertyTax = b), w !== void 0 && (E.associationFee = w), S !== void 0 && (E.firstYearToAnalyze = S), Z(x, E);
      let B = k && k.headers ? k.headers : {};
      return C.headers = { ...O, ...B, ...I.headers }, {
        url: J(x),
        options: C
      };
    },
    /**
     * 
     * @summary Delete user\'s saved tweaks for a property.
     * @param {number} propId Property Id to reset.
     * @param {boolean} [ei] Delete existing investment data as well.
     * @param {boolean} [useLedger] Use ledger entries from portfolio insights.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    reset: async (t, s, n, r = {}) => {
      se("reset", "propId", t);
      const i = "/calculator/{propId}/tweaks".replace("{propId}", encodeURIComponent(String(t))), o = new URL(i, K);
      let l;
      e && (l = e.baseOptions);
      const d = { method: "DELETE", ...l, ...r }, c = {}, u = {};
      await ee(c, e), s !== void 0 && (u.ei = s), n !== void 0 && (u.useLedger = n), Z(o, u);
      let m = l && l.headers ? l.headers : {};
      return d.headers = { ...c, ...m, ...r.headers }, {
        url: J(o),
        options: d
      };
    },
    /**
     * 
     * @summary Delete user\'s saved tweaks for a property.
     * @param {string} mlsSource 
     * @param {string} mlsNumber 
     * @param {boolean} [ei] Delete existing investment data as well.
     * @param {boolean} [useLedger] Use ledger entries from portfolio insights.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    resetMls: async (t, s, n, r, i = {}) => {
      se("resetMls", "mlsSource", t), se("resetMls", "mlsNumber", s);
      const o = "/calculator/{mlsSource}/{mlsNumber}/tweaks".replace("{mlsSource}", encodeURIComponent(String(t))).replace("{mlsNumber}", encodeURIComponent(String(s))), l = new URL(o, K);
      let d;
      e && (d = e.baseOptions);
      const c = { method: "DELETE", ...d, ...i }, u = {}, m = {};
      await ee(u, e), n !== void 0 && (m.ei = n), r !== void 0 && (m.useLedger = r), Z(l, m);
      let f = d && d.headers ? d.headers : {};
      return c.headers = { ...u, ...f, ...i.headers }, {
        url: J(l),
        options: c
      };
    },
    /**
     * 
     * @summary Confirm purchase fact for a property
     * @param {number} propId 
     * @param {ConfirmedPurchaseFacts} [purchaseFacts] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    unconfirmPurchaseFact: async (t, s, n = {}) => {
      se("unconfirmPurchaseFact", "propId", t);
      const r = "/calculator/{propId}/purchase-facts/unconfirm".replace("{propId}", encodeURIComponent(String(t))), i = new URL(r, K);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "POST", ...o, ...n }, d = {}, c = {};
      await Lt(d, "x-api-key", e), await ee(d, e), s !== void 0 && (c.purchaseFacts = s), Z(i, c);
      let u = o && o.headers ? o.headers : {};
      return l.headers = { ...d, ...u, ...n.headers }, {
        url: J(i),
        options: l
      };
    }
  };
}, f6 = function(e) {
  const t = m6(e);
  return {
    /**
     * 
     * @summary Run rescover calculator against a single property.
     * @param {CalculatorRequest} calculatorRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async calculate(s, n) {
      var l, d;
      const r = await t.calculate(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["CalculatorApi.calculate"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    },
    /**
     * 
     * @param {FlipCalculatorParameters} flipCalculatorParameters 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async calculateFlip(s, n) {
      var l, d;
      const r = await t.calculateFlip(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["CalculatorApi.calculateFlip"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    },
    /**
     * 
     * @summary Confirm purchase fact for a property
     * @param {number} propId 
     * @param {ConfirmedPurchaseFacts} [purchaseFacts] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async confirmPurchaseFact(s, n, r) {
      var d, c;
      const i = await t.confirmPurchaseFact(s, n, r), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (c = (d = Q["CalculatorApi.confirmPurchaseFact"]) == null ? void 0 : d[o]) == null ? void 0 : c.url;
      return (u, m) => _(i, X, G, e)(u, l || m);
    },
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getInvestmentComparisons(s) {
      var o, l;
      const n = await t.getInvestmentComparisons(s), r = (e == null ? void 0 : e.serverIndex) ?? 0, i = (l = (o = Q["CalculatorApi.getInvestmentComparisons"]) == null ? void 0 : o[r]) == null ? void 0 : l.url;
      return (d, c) => _(n, X, G, e)(d, i || c);
    },
    /**
     * 
     * @summary Retrieve calculator parameters for a property, including any tweaks the user may have applied to it.
     * @param {number} propId 
     * @param {boolean} [useLedger] Use ledger entries from portfolio insights.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getParameters(s, n, r) {
      var d, c;
      const i = await t.getParameters(s, n, r), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (c = (d = Q["CalculatorApi.getParameters"]) == null ? void 0 : d[o]) == null ? void 0 : c.url;
      return (u, m) => _(i, X, G, e)(u, l || m);
    },
    /**
     * 
     * @summary Retrieve calculator parameters for a property, including any tweaks the user may have applied to it.
     * @param {string} mlsSource 
     * @param {string} mlsNumber 
     * @param {boolean} [useLedger] Use ledger entries from portfolio insights.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getParametersMls(s, n, r, i) {
      var c, u;
      const o = await t.getParametersMls(s, n, r, i), l = (e == null ? void 0 : e.serverIndex) ?? 0, d = (u = (c = Q["CalculatorApi.getParametersMls"]) == null ? void 0 : c[l]) == null ? void 0 : u.url;
      return (m, f) => _(o, X, G, e)(m, d || f);
    },
    /**
     * 
     * @summary Initialize purchase facts for property.
     * @param {number} propId 
     * @param {number} [rentalRate] 
     * @param {Date} [purchaseDate] 
     * @param {number} [purchaseAmount] 
     * @param {number} [loanTerm] 
     * @param {number} [loanAmount] 
     * @param {number} [loanInterestRate] 
     * @param {Date} [loanDate] 
     * @param {number} [annualExpenseGrowth] Estimated annual expense growth percentage
     * @param {number} [annualRentalGrowth] Estimated annual rental growth percentage
     * @param {number} [propertyAppreciation] Estimated property appreciation percentage
     * @param {number} [propertyValueEoY] Estimated property value at end of current year.
     * @param {number} [firstYearAsRental] 
     * @param {number} [propertyTax] 
     * @param {number} [associationFee] 
     * @param {number} [firstYearToAnalyze] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async initPurchaseFacts(s, n, r, i, o, l, d, c, u, m, f, v, b, w, S, I, T) {
      var O, E;
      const x = await t.initPurchaseFacts(s, n, r, i, o, l, d, c, u, m, f, v, b, w, S, I, T), k = (e == null ? void 0 : e.serverIndex) ?? 0, C = (E = (O = Q["CalculatorApi.initPurchaseFacts"]) == null ? void 0 : O[k]) == null ? void 0 : E.url;
      return (B, M) => _(x, X, G, e)(B, C || M);
    },
    /**
     * 
     * @summary Delete user\'s saved tweaks for a property.
     * @param {number} propId Property Id to reset.
     * @param {boolean} [ei] Delete existing investment data as well.
     * @param {boolean} [useLedger] Use ledger entries from portfolio insights.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async reset(s, n, r, i) {
      var c, u;
      const o = await t.reset(s, n, r, i), l = (e == null ? void 0 : e.serverIndex) ?? 0, d = (u = (c = Q["CalculatorApi.reset"]) == null ? void 0 : c[l]) == null ? void 0 : u.url;
      return (m, f) => _(o, X, G, e)(m, d || f);
    },
    /**
     * 
     * @summary Delete user\'s saved tweaks for a property.
     * @param {string} mlsSource 
     * @param {string} mlsNumber 
     * @param {boolean} [ei] Delete existing investment data as well.
     * @param {boolean} [useLedger] Use ledger entries from portfolio insights.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async resetMls(s, n, r, i, o) {
      var u, m;
      const l = await t.resetMls(s, n, r, i, o), d = (e == null ? void 0 : e.serverIndex) ?? 0, c = (m = (u = Q["CalculatorApi.resetMls"]) == null ? void 0 : u[d]) == null ? void 0 : m.url;
      return (f, v) => _(l, X, G, e)(f, c || v);
    },
    /**
     * 
     * @summary Confirm purchase fact for a property
     * @param {number} propId 
     * @param {ConfirmedPurchaseFacts} [purchaseFacts] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async unconfirmPurchaseFact(s, n, r) {
      var d, c;
      const i = await t.unconfirmPurchaseFact(s, n, r), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (c = (d = Q["CalculatorApi.unconfirmPurchaseFact"]) == null ? void 0 : d[o]) == null ? void 0 : c.url;
      return (u, m) => _(i, X, G, e)(u, l || m);
    }
  };
}, g6 = function(e, t, s) {
  const n = f6(e);
  return {
    /**
     * 
     * @summary Run rescover calculator against a single property.
     * @param {CalculatorRequest} calculatorRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    calculate(r, i) {
      return n.calculate(r, i).then((o) => o(s, t));
    },
    /**
     * 
     * @param {FlipCalculatorParameters} flipCalculatorParameters 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    calculateFlip(r, i) {
      return n.calculateFlip(r, i).then((o) => o(s, t));
    },
    /**
     * 
     * @summary Confirm purchase fact for a property
     * @param {number} propId 
     * @param {ConfirmedPurchaseFacts} [purchaseFacts] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    confirmPurchaseFact(r, i, o) {
      return n.confirmPurchaseFact(r, i, o).then((l) => l(s, t));
    },
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getInvestmentComparisons(r) {
      return n.getInvestmentComparisons(r).then((i) => i(s, t));
    },
    /**
     * 
     * @summary Retrieve calculator parameters for a property, including any tweaks the user may have applied to it.
     * @param {number} propId 
     * @param {boolean} [useLedger] Use ledger entries from portfolio insights.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getParameters(r, i, o) {
      return n.getParameters(r, i, o).then((l) => l(s, t));
    },
    /**
     * 
     * @summary Retrieve calculator parameters for a property, including any tweaks the user may have applied to it.
     * @param {string} mlsSource 
     * @param {string} mlsNumber 
     * @param {boolean} [useLedger] Use ledger entries from portfolio insights.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getParametersMls(r, i, o, l) {
      return n.getParametersMls(r, i, o, l).then((d) => d(s, t));
    },
    /**
     * 
     * @summary Initialize purchase facts for property.
     * @param {number} propId 
     * @param {number} [rentalRate] 
     * @param {Date} [purchaseDate] 
     * @param {number} [purchaseAmount] 
     * @param {number} [loanTerm] 
     * @param {number} [loanAmount] 
     * @param {number} [loanInterestRate] 
     * @param {Date} [loanDate] 
     * @param {number} [annualExpenseGrowth] Estimated annual expense growth percentage
     * @param {number} [annualRentalGrowth] Estimated annual rental growth percentage
     * @param {number} [propertyAppreciation] Estimated property appreciation percentage
     * @param {number} [propertyValueEoY] Estimated property value at end of current year.
     * @param {number} [firstYearAsRental] 
     * @param {number} [propertyTax] 
     * @param {number} [associationFee] 
     * @param {number} [firstYearToAnalyze] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    initPurchaseFacts(r, i, o, l, d, c, u, m, f, v, b, w, S, I, T, x, k) {
      return n.initPurchaseFacts(r, i, o, l, d, c, u, m, f, v, b, w, S, I, T, x, k).then((C) => C(s, t));
    },
    /**
     * 
     * @summary Delete user\'s saved tweaks for a property.
     * @param {number} propId Property Id to reset.
     * @param {boolean} [ei] Delete existing investment data as well.
     * @param {boolean} [useLedger] Use ledger entries from portfolio insights.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    reset(r, i, o, l) {
      return n.reset(r, i, o, l).then((d) => d(s, t));
    },
    /**
     * 
     * @summary Delete user\'s saved tweaks for a property.
     * @param {string} mlsSource 
     * @param {string} mlsNumber 
     * @param {boolean} [ei] Delete existing investment data as well.
     * @param {boolean} [useLedger] Use ledger entries from portfolio insights.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    resetMls(r, i, o, l, d) {
      return n.resetMls(r, i, o, l, d).then((c) => c(s, t));
    },
    /**
     * 
     * @summary Confirm purchase fact for a property
     * @param {number} propId 
     * @param {ConfirmedPurchaseFacts} [purchaseFacts] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    unconfirmPurchaseFact(r, i, o) {
      return n.unconfirmPurchaseFact(r, i, o).then((l) => l(s, t));
    }
  };
}, v6 = function(e) {
  return {
    /**
     * 
     * @summary Community info for zip code
     * @param {string} zip Zip code to retrieve community data for.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    zip: async (t, s = {}) => {
      se("zip", "zip", t);
      const n = "/geo/community/{zip}".replace("{zip}", encodeURIComponent(String(t))), r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "GET", ...i, ...s }, l = {}, d = {};
      await Lt(l, "x-api-key", e), await ee(l, e), Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, {
        url: J(r),
        options: o
      };
    }
  };
}, y6 = function(e) {
  const t = v6(e);
  return {
    /**
     * 
     * @summary Community info for zip code
     * @param {string} zip Zip code to retrieve community data for.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async zip(s, n) {
      var l, d;
      const r = await t.zip(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["CommunityApi.zip"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    }
  };
}, b6 = function(e, t, s) {
  const n = y6(e);
  return {
    /**
     * 
     * @summary Community info for zip code
     * @param {string} zip Zip code to retrieve community data for.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    zip(r, i) {
      return n.zip(r, i).then((o) => o(s, t));
    }
  };
}, A6 = function(e) {
  return {
    /**
     * 
     * @summary Get dictionary term.
     * @param {string} term 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getTerm: async (t, s = {}) => {
      se("getTerm", "term", t);
      const n = "/manage/dictionary/terms/{term}".replace("{term}", encodeURIComponent(String(t))), r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "GET", ...i, ...s }, l = {}, d = {};
      await ee(l, e), Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, {
        url: J(r),
        options: o
      };
    },
    /**
     * 
     * @summary List dictionary terms.
     * @param {number} [page] Current page of records to return.
     * @param {number} [pageSize] Total records per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getTerms: async (t, s, n = {}) => {
      const r = "/manage/dictionary/terms", i = new URL(r, K);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "GET", ...o, ...n }, d = {}, c = {};
      await ee(d, e), t !== void 0 && (c.page = t), s !== void 0 && (c.pageSize = s), Z(i, c);
      let u = o && o.headers ? o.headers : {};
      return l.headers = { ...d, ...u, ...n.headers }, {
        url: J(i),
        options: l
      };
    },
    /**
     * 
     * @summary 
     * @param {DictionaryType} type 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    list: async (t, s = {}) => {
      se("list", "type", t);
      const n = "/dictionary/list/{type}".replace("{type}", encodeURIComponent(String(t))), r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "GET", ...i, ...s }, l = {}, d = {};
      await ee(l, e), Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, {
        url: J(r),
        options: o
      };
    },
    /**
     * 
     * @summary Create/Update dictionary term.
     * @param {string} term 
     * @param {DictionaryTerm} [dictionaryTerm] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateTerm: async (t, s, n = {}) => {
      se("updateTerm", "term", t);
      const r = "/manage/dictionary/terms/{term}".replace("{term}", encodeURIComponent(String(t))), i = new URL(r, K);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "POST", ...o, ...n }, d = {}, c = {};
      await ee(d, e), d["Content-Type"] = "application/json", Z(i, c);
      let u = o && o.headers ? o.headers : {};
      return l.headers = { ...d, ...u, ...n.headers }, l.data = kt(s, l, e), {
        url: J(i),
        options: l
      };
    }
  };
}, w6 = function(e) {
  const t = A6(e);
  return {
    /**
     * 
     * @summary Get dictionary term.
     * @param {string} term 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getTerm(s, n) {
      var l, d;
      const r = await t.getTerm(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["DictionaryApi.getTerm"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    },
    /**
     * 
     * @summary List dictionary terms.
     * @param {number} [page] Current page of records to return.
     * @param {number} [pageSize] Total records per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getTerms(s, n, r) {
      var d, c;
      const i = await t.getTerms(s, n, r), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (c = (d = Q["DictionaryApi.getTerms"]) == null ? void 0 : d[o]) == null ? void 0 : c.url;
      return (u, m) => _(i, X, G, e)(u, l || m);
    },
    /**
     * 
     * @summary 
     * @param {DictionaryType} type 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async list(s, n) {
      var l, d;
      const r = await t.list(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["DictionaryApi.list"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    },
    /**
     * 
     * @summary Create/Update dictionary term.
     * @param {string} term 
     * @param {DictionaryTerm} [dictionaryTerm] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateTerm(s, n, r) {
      var d, c;
      const i = await t.updateTerm(s, n, r), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (c = (d = Q["DictionaryApi.updateTerm"]) == null ? void 0 : d[o]) == null ? void 0 : c.url;
      return (u, m) => _(i, X, G, e)(u, l || m);
    }
  };
}, C6 = function(e, t, s) {
  const n = w6(e);
  return {
    /**
     * 
     * @summary Get dictionary term.
     * @param {string} term 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getTerm(r, i) {
      return n.getTerm(r, i).then((o) => o(s, t));
    },
    /**
     * 
     * @summary List dictionary terms.
     * @param {number} [page] Current page of records to return.
     * @param {number} [pageSize] Total records per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getTerms(r, i, o) {
      return n.getTerms(r, i, o).then((l) => l(s, t));
    },
    /**
     * 
     * @summary 
     * @param {DictionaryType} type 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    list(r, i) {
      return n.list(r, i).then((o) => o(s, t));
    },
    /**
     * 
     * @summary Create/Update dictionary term.
     * @param {string} term 
     * @param {DictionaryTerm} [dictionaryTerm] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateTerm(r, i, o) {
      return n.updateTerm(r, i, o).then((l) => l(s, t));
    }
  };
}, S6 = function(e) {
  return {
    /**
     * 
     * @summary Add existing property to user\'s portfolio.
     * @param {string} propId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addExistingProperty: async (t, s = {}) => {
      se("addExistingProperty", "propId", t);
      const n = "/account/folio/my-investments/property/{propId}".replace("{propId}", encodeURIComponent(String(t))), r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "PUT", ...i, ...s }, l = {}, d = {};
      await ee(l, e), Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, {
        url: J(r),
        options: o
      };
    },
    /**
     * 
     * @summary Add property to user\'s favorite list.
     * @param {number} propId Id of property to favorite.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addFavorite: async (t, s = {}) => {
      se("addFavorite", "propId", t);
      const n = "/account/folio/favorites/{propId}".replace("{propId}", encodeURIComponent(String(t))), r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "POST", ...i, ...s }, l = {}, d = {};
      await ee(l, e), Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, {
        url: J(r),
        options: o
      };
    },
    /**
     * 
     * @summary Add listing to user\'s favorite list.
     * @param {string} mlsSource MLS of listing to favorite
     * @param {string} mlsNumber MLS number of listing to favorite.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addFavoriteListing: async (t, s, n = {}) => {
      se("addFavoriteListing", "mlsSource", t), se("addFavoriteListing", "mlsNumber", s);
      const r = "/account/folio/favorites/{mlsSource}/{mlsNumber}".replace("{mlsSource}", encodeURIComponent(String(t))).replace("{mlsNumber}", encodeURIComponent(String(s))), i = new URL(r, K);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "POST", ...o, ...n }, d = {}, c = {};
      await ee(d, e), Z(i, c);
      let u = o && o.headers ? o.headers : {};
      return l.headers = { ...d, ...u, ...n.headers }, {
        url: J(i),
        options: l
      };
    },
    /**
     * 
     * @summary Add listing to user\'s featured properties list.
     * @param {string} mlsSource MLS source of listing to feature
     * @param {string} mlsNumber MLS number of listing to feature.
     * @param {FeaturedType} type Type of featured listing
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addFeaturedListing: async (t, s, n, r = {}) => {
      se("addFeaturedListing", "mlsSource", t), se("addFeaturedListing", "mlsNumber", s), se("addFeaturedListing", "type", n);
      const i = "/account/folio/featured/{mlsSource}/{mlsNumber}".replace("{mlsSource}", encodeURIComponent(String(t))).replace("{mlsNumber}", encodeURIComponent(String(s))), o = new URL(i, K);
      let l;
      e && (l = e.baseOptions);
      const d = { method: "POST", ...l, ...r }, c = {}, u = {};
      await ee(c, e), n !== void 0 && (u.type = n), Z(o, u);
      let m = l && l.headers ? l.headers : {};
      return d.headers = { ...c, ...m, ...r.headers }, {
        url: J(o),
        options: d
      };
    },
    /**
     * 
     * @summary Add property to user\'s ignore list.
     * @param {number} propId Id of property to favorite.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addIgnore: async (t, s = {}) => {
      se("addIgnore", "propId", t);
      const n = "/account/folio/ignored/{propId}".replace("{propId}", encodeURIComponent(String(t))), r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "POST", ...i, ...s }, l = {}, d = {};
      await ee(l, e), Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, {
        url: J(r),
        options: o
      };
    },
    /**
     * 
     * @summary Add listing to user\'s ignore list.
     * @param {string} mlsSource MLS of listing to ignore
     * @param {string} mlsNumber MLS number of listing to ignore.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addIgnoreListing: async (t, s, n = {}) => {
      se("addIgnoreListing", "mlsSource", t), se("addIgnoreListing", "mlsNumber", s);
      const r = "/account/folio/ignored/{mlsSource}/{mlsNumber}".replace("{mlsSource}", encodeURIComponent(String(t))).replace("{mlsNumber}", encodeURIComponent(String(s))), i = new URL(r, K);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "POST", ...o, ...n }, d = {}, c = {};
      await ee(d, e), Z(i, c);
      let u = o && o.headers ? o.headers : {};
      return l.headers = { ...d, ...u, ...n.headers }, {
        url: J(i),
        options: l
      };
    },
    /**
     * 
     * @summary Grant a sub-account to feature properties for the primary account.
     * @param {number} accountId Sub-account id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    allowToFeature: async (t, s = {}) => {
      se("allowToFeature", "accountId", t);
      const n = "/account/folio/featured/{accountId}/allow".replace("{accountId}", encodeURIComponent(String(t))), r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "POST", ...i, ...s }, l = {}, d = {};
      await ee(l, e), Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, {
        url: J(r),
        options: o
      };
    },
    /**
     * 
     * @summary Mark property for deletion, to be deleted 45 days once marked.
     * @param {string} propId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteExistingProperty: async (t, s = {}) => {
      se("deleteExistingProperty", "propId", t);
      const n = "/account/folio/my-investments/property/{propId}".replace("{propId}", encodeURIComponent(String(t))), r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "DELETE", ...i, ...s }, l = {}, d = {};
      await ee(l, e), Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, {
        url: J(r),
        options: o
      };
    },
    /**
     * 
     * @summary Deny a sub-account from featuring properties for the primary account.
     * @param {number} accountId Sub-account id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    denyToFeature: async (t, s = {}) => {
      se("denyToFeature", "accountId", t);
      const n = "/account/folio/featured/{accountId}/deny".replace("{accountId}", encodeURIComponent(String(t))), r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "POST", ...i, ...s }, l = {}, d = {};
      await ee(l, e), Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, {
        url: J(r),
        options: o
      };
    },
    /**
     * 
     * @summary List properties containing existing investment data.
     * @param {number} [p] Page
     * @param {number} [ps] Page Size
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getExistingInvestments: async (t, s, n = {}) => {
      const r = "/account/folio/existing-investments", i = new URL(r, K);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "GET", ...o, ...n }, d = {}, c = {};
      await ee(d, e), t !== void 0 && (c.p = t), s !== void 0 && (c.ps = s), Z(i, c);
      let u = o && o.headers ? o.headers : {};
      return l.headers = { ...d, ...u, ...n.headers }, {
        url: J(i),
        options: l
      };
    },
    /**
     * 
     * @summary List user\'s favorite properties.
     * @param {number} [p] Page
     * @param {number} [ps] Page Size
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getFavorites: async (t, s, n = {}) => {
      const r = "/account/folio/favorites", i = new URL(r, K);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "GET", ...o, ...n }, d = {}, c = {};
      await ee(d, e), t !== void 0 && (c.p = t), s !== void 0 && (c.ps = s), Z(i, c);
      let u = o && o.headers ? o.headers : {};
      return l.headers = { ...d, ...u, ...n.headers }, {
        url: J(i),
        options: l
      };
    },
    /**
     * 
     * @summary List featured properties.
     * @param {FeaturedType} type 
     * @param {number} [p] Page
     * @param {number} [ps] Page Size
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getFeatured: async (t, s, n, r = {}) => {
      se("getFeatured", "type", t);
      const i = "/account/folio/featured", o = new URL(i, K);
      let l;
      e && (l = e.baseOptions);
      const d = { method: "GET", ...l, ...r }, c = {}, u = {};
      await ee(c, e), t !== void 0 && (u.type = t), s !== void 0 && (u.p = s), n !== void 0 && (u.ps = n), Z(o, u);
      let m = l && l.headers ? l.headers : {};
      return d.headers = { ...c, ...m, ...r.headers }, {
        url: J(o),
        options: d
      };
    },
    /**
     * 
     * @summary List featured properties.
     * @param {FeaturedType} type 
     * @param {number} [p] Page
     * @param {number} [ps] Page Size
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getFeaturedForClient: async (t, s, n, r = {}) => {
      se("getFeaturedForClient", "type", t);
      const i = "/account/folio/featured/my-agents", o = new URL(i, K);
      let l;
      e && (l = e.baseOptions);
      const d = { method: "GET", ...l, ...r }, c = {}, u = {};
      await ee(c, e), t !== void 0 && (u.type = t), s !== void 0 && (u.p = s), n !== void 0 && (u.ps = n), Z(o, u);
      let m = l && l.headers ? l.headers : {};
      return d.headers = { ...c, ...m, ...r.headers }, {
        url: J(o),
        options: d
      };
    },
    /**
     * 
     * @summary List user\'s ignored properties.
     * @param {number} [p] Page
     * @param {number} [ps] Page Size
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getIgnored: async (t, s, n = {}) => {
      const r = "/account/folio/ignored", i = new URL(r, K);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "GET", ...o, ...n }, d = {}, c = {};
      await ee(d, e), t !== void 0 && (c.p = t), s !== void 0 && (c.ps = s), Z(i, c);
      let u = o && o.headers ? o.headers : {};
      return l.headers = { ...d, ...u, ...n.headers }, {
        url: J(i),
        options: l
      };
    },
    /**
     * 
     * @summary Return summary of user\'s existing investments.
     * @param {boolean} [c] Current year summary, false for previous year.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    getMyInvestmentsSummary: async (t, s = {}) => {
      const n = "/account/folio/my-investments", r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "GET", ...i, ...s }, l = {}, d = {};
      await ee(l, e), t !== void 0 && (d.c = t), Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, {
        url: J(r),
        options: o
      };
    },
    /**
     * 
     * @summary Remove property from user\'s favorite list.
     * @param {number} propId Id of property to favorite.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    removeFavorite: async (t, s = {}) => {
      se("removeFavorite", "propId", t);
      const n = "/account/folio/favorites/{propId}".replace("{propId}", encodeURIComponent(String(t))), r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "DELETE", ...i, ...s }, l = {}, d = {};
      await ee(l, e), Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, {
        url: J(r),
        options: o
      };
    },
    /**
     * 
     * @summary Remove listing from user\'s favorite list.
     * @param {string} mlsSource MLS of listing to unfavorite
     * @param {string} mlsNumber MLS number of listing to unfavorite.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    removeFavoriteListing: async (t, s, n = {}) => {
      se("removeFavoriteListing", "mlsSource", t), se("removeFavoriteListing", "mlsNumber", s);
      const r = "/account/folio/favorites/{mlsSource}/{mlsNumber}".replace("{mlsSource}", encodeURIComponent(String(t))).replace("{mlsNumber}", encodeURIComponent(String(s))), i = new URL(r, K);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "DELETE", ...o, ...n }, d = {}, c = {};
      await ee(d, e), Z(i, c);
      let u = o && o.headers ? o.headers : {};
      return l.headers = { ...d, ...u, ...n.headers }, {
        url: J(i),
        options: l
      };
    },
    /**
     * 
     * @summary Remove listing from user\'s featured list.
     * @param {string} mlsSource 
     * @param {string} mlsNumber 
     * @param {FeaturedType} [type] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    removeFeaturedListing: async (t, s, n, r = {}) => {
      se("removeFeaturedListing", "mlsSource", t), se("removeFeaturedListing", "mlsNumber", s);
      const i = "/account/folio/featured/{mlsSource}/{mlsNumber}".replace("{mlsSource}", encodeURIComponent(String(t))).replace("{mlsNumber}", encodeURIComponent(String(s))), o = new URL(i, K);
      let l;
      e && (l = e.baseOptions);
      const d = { method: "DELETE", ...l, ...r }, c = {}, u = {};
      await ee(c, e), n !== void 0 && (u.type = n), Z(o, u);
      let m = l && l.headers ? l.headers : {};
      return d.headers = { ...c, ...m, ...r.headers }, {
        url: J(o),
        options: d
      };
    },
    /**
     * 
     * @summary Remove property from user\'s ignore list.
     * @param {number} propId Id of property to favorite.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    removeIgnore: async (t, s = {}) => {
      se("removeIgnore", "propId", t);
      const n = "/account/folio/ignored/{propId}".replace("{propId}", encodeURIComponent(String(t))), r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "DELETE", ...i, ...s }, l = {}, d = {};
      await ee(l, e), Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, {
        url: J(r),
        options: o
      };
    },
    /**
     * 
     * @summary Remove listing from user\'s ignore list.
     * @param {string} mlsSource MLS of listing to ignore
     * @param {string} mlsNumber MLS number of listing to ignore.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    removeIgnoreListing: async (t, s, n = {}) => {
      se("removeIgnoreListing", "mlsSource", t), se("removeIgnoreListing", "mlsNumber", s);
      const r = "/account/folio/ignored/{mlsSource}/{mlsNumber}".replace("{mlsSource}", encodeURIComponent(String(t))).replace("{mlsNumber}", encodeURIComponent(String(s))), i = new URL(r, K);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "DELETE", ...o, ...n }, d = {}, c = {};
      await ee(d, e), Z(i, c);
      let u = o && o.headers ? o.headers : {};
      return l.headers = { ...d, ...u, ...n.headers }, {
        url: J(i),
        options: l
      };
    }
  };
}, P6 = function(e) {
  const t = S6(e);
  return {
    /**
     * 
     * @summary Add existing property to user\'s portfolio.
     * @param {string} propId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async addExistingProperty(s, n) {
      var l, d;
      const r = await t.addExistingProperty(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["FolioApi.addExistingProperty"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    },
    /**
     * 
     * @summary Add property to user\'s favorite list.
     * @param {number} propId Id of property to favorite.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async addFavorite(s, n) {
      var l, d;
      const r = await t.addFavorite(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["FolioApi.addFavorite"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    },
    /**
     * 
     * @summary Add listing to user\'s favorite list.
     * @param {string} mlsSource MLS of listing to favorite
     * @param {string} mlsNumber MLS number of listing to favorite.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async addFavoriteListing(s, n, r) {
      var d, c;
      const i = await t.addFavoriteListing(s, n, r), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (c = (d = Q["FolioApi.addFavoriteListing"]) == null ? void 0 : d[o]) == null ? void 0 : c.url;
      return (u, m) => _(i, X, G, e)(u, l || m);
    },
    /**
     * 
     * @summary Add listing to user\'s featured properties list.
     * @param {string} mlsSource MLS source of listing to feature
     * @param {string} mlsNumber MLS number of listing to feature.
     * @param {FeaturedType} type Type of featured listing
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async addFeaturedListing(s, n, r, i) {
      var c, u;
      const o = await t.addFeaturedListing(s, n, r, i), l = (e == null ? void 0 : e.serverIndex) ?? 0, d = (u = (c = Q["FolioApi.addFeaturedListing"]) == null ? void 0 : c[l]) == null ? void 0 : u.url;
      return (m, f) => _(o, X, G, e)(m, d || f);
    },
    /**
     * 
     * @summary Add property to user\'s ignore list.
     * @param {number} propId Id of property to favorite.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async addIgnore(s, n) {
      var l, d;
      const r = await t.addIgnore(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["FolioApi.addIgnore"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    },
    /**
     * 
     * @summary Add listing to user\'s ignore list.
     * @param {string} mlsSource MLS of listing to ignore
     * @param {string} mlsNumber MLS number of listing to ignore.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async addIgnoreListing(s, n, r) {
      var d, c;
      const i = await t.addIgnoreListing(s, n, r), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (c = (d = Q["FolioApi.addIgnoreListing"]) == null ? void 0 : d[o]) == null ? void 0 : c.url;
      return (u, m) => _(i, X, G, e)(u, l || m);
    },
    /**
     * 
     * @summary Grant a sub-account to feature properties for the primary account.
     * @param {number} accountId Sub-account id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async allowToFeature(s, n) {
      var l, d;
      const r = await t.allowToFeature(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["FolioApi.allowToFeature"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    },
    /**
     * 
     * @summary Mark property for deletion, to be deleted 45 days once marked.
     * @param {string} propId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deleteExistingProperty(s, n) {
      var l, d;
      const r = await t.deleteExistingProperty(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["FolioApi.deleteExistingProperty"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    },
    /**
     * 
     * @summary Deny a sub-account from featuring properties for the primary account.
     * @param {number} accountId Sub-account id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async denyToFeature(s, n) {
      var l, d;
      const r = await t.denyToFeature(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["FolioApi.denyToFeature"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    },
    /**
     * 
     * @summary List properties containing existing investment data.
     * @param {number} [p] Page
     * @param {number} [ps] Page Size
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getExistingInvestments(s, n, r) {
      var d, c;
      const i = await t.getExistingInvestments(s, n, r), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (c = (d = Q["FolioApi.getExistingInvestments"]) == null ? void 0 : d[o]) == null ? void 0 : c.url;
      return (u, m) => _(i, X, G, e)(u, l || m);
    },
    /**
     * 
     * @summary List user\'s favorite properties.
     * @param {number} [p] Page
     * @param {number} [ps] Page Size
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getFavorites(s, n, r) {
      var d, c;
      const i = await t.getFavorites(s, n, r), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (c = (d = Q["FolioApi.getFavorites"]) == null ? void 0 : d[o]) == null ? void 0 : c.url;
      return (u, m) => _(i, X, G, e)(u, l || m);
    },
    /**
     * 
     * @summary List featured properties.
     * @param {FeaturedType} type 
     * @param {number} [p] Page
     * @param {number} [ps] Page Size
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getFeatured(s, n, r, i) {
      var c, u;
      const o = await t.getFeatured(s, n, r, i), l = (e == null ? void 0 : e.serverIndex) ?? 0, d = (u = (c = Q["FolioApi.getFeatured"]) == null ? void 0 : c[l]) == null ? void 0 : u.url;
      return (m, f) => _(o, X, G, e)(m, d || f);
    },
    /**
     * 
     * @summary List featured properties.
     * @param {FeaturedType} type 
     * @param {number} [p] Page
     * @param {number} [ps] Page Size
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getFeaturedForClient(s, n, r, i) {
      var c, u;
      const o = await t.getFeaturedForClient(s, n, r, i), l = (e == null ? void 0 : e.serverIndex) ?? 0, d = (u = (c = Q["FolioApi.getFeaturedForClient"]) == null ? void 0 : c[l]) == null ? void 0 : u.url;
      return (m, f) => _(o, X, G, e)(m, d || f);
    },
    /**
     * 
     * @summary List user\'s ignored properties.
     * @param {number} [p] Page
     * @param {number} [ps] Page Size
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getIgnored(s, n, r) {
      var d, c;
      const i = await t.getIgnored(s, n, r), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (c = (d = Q["FolioApi.getIgnored"]) == null ? void 0 : d[o]) == null ? void 0 : c.url;
      return (u, m) => _(i, X, G, e)(u, l || m);
    },
    /**
     * 
     * @summary Return summary of user\'s existing investments.
     * @param {boolean} [c] Current year summary, false for previous year.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async getMyInvestmentsSummary(s, n) {
      var l, d;
      const r = await t.getMyInvestmentsSummary(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["FolioApi.getMyInvestmentsSummary"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    },
    /**
     * 
     * @summary Remove property from user\'s favorite list.
     * @param {number} propId Id of property to favorite.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async removeFavorite(s, n) {
      var l, d;
      const r = await t.removeFavorite(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["FolioApi.removeFavorite"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    },
    /**
     * 
     * @summary Remove listing from user\'s favorite list.
     * @param {string} mlsSource MLS of listing to unfavorite
     * @param {string} mlsNumber MLS number of listing to unfavorite.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async removeFavoriteListing(s, n, r) {
      var d, c;
      const i = await t.removeFavoriteListing(s, n, r), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (c = (d = Q["FolioApi.removeFavoriteListing"]) == null ? void 0 : d[o]) == null ? void 0 : c.url;
      return (u, m) => _(i, X, G, e)(u, l || m);
    },
    /**
     * 
     * @summary Remove listing from user\'s featured list.
     * @param {string} mlsSource 
     * @param {string} mlsNumber 
     * @param {FeaturedType} [type] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async removeFeaturedListing(s, n, r, i) {
      var c, u;
      const o = await t.removeFeaturedListing(s, n, r, i), l = (e == null ? void 0 : e.serverIndex) ?? 0, d = (u = (c = Q["FolioApi.removeFeaturedListing"]) == null ? void 0 : c[l]) == null ? void 0 : u.url;
      return (m, f) => _(o, X, G, e)(m, d || f);
    },
    /**
     * 
     * @summary Remove property from user\'s ignore list.
     * @param {number} propId Id of property to favorite.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async removeIgnore(s, n) {
      var l, d;
      const r = await t.removeIgnore(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["FolioApi.removeIgnore"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    },
    /**
     * 
     * @summary Remove listing from user\'s ignore list.
     * @param {string} mlsSource MLS of listing to ignore
     * @param {string} mlsNumber MLS number of listing to ignore.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async removeIgnoreListing(s, n, r) {
      var d, c;
      const i = await t.removeIgnoreListing(s, n, r), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (c = (d = Q["FolioApi.removeIgnoreListing"]) == null ? void 0 : d[o]) == null ? void 0 : c.url;
      return (u, m) => _(i, X, G, e)(u, l || m);
    }
  };
}, k6 = function(e, t, s) {
  const n = P6(e);
  return {
    /**
     * 
     * @summary Add existing property to user\'s portfolio.
     * @param {string} propId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addExistingProperty(r, i) {
      return n.addExistingProperty(r, i).then((o) => o(s, t));
    },
    /**
     * 
     * @summary Add property to user\'s favorite list.
     * @param {number} propId Id of property to favorite.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addFavorite(r, i) {
      return n.addFavorite(r, i).then((o) => o(s, t));
    },
    /**
     * 
     * @summary Add listing to user\'s favorite list.
     * @param {string} mlsSource MLS of listing to favorite
     * @param {string} mlsNumber MLS number of listing to favorite.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addFavoriteListing(r, i, o) {
      return n.addFavoriteListing(r, i, o).then((l) => l(s, t));
    },
    /**
     * 
     * @summary Add listing to user\'s featured properties list.
     * @param {string} mlsSource MLS source of listing to feature
     * @param {string} mlsNumber MLS number of listing to feature.
     * @param {FeaturedType} type Type of featured listing
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addFeaturedListing(r, i, o, l) {
      return n.addFeaturedListing(r, i, o, l).then((d) => d(s, t));
    },
    /**
     * 
     * @summary Add property to user\'s ignore list.
     * @param {number} propId Id of property to favorite.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addIgnore(r, i) {
      return n.addIgnore(r, i).then((o) => o(s, t));
    },
    /**
     * 
     * @summary Add listing to user\'s ignore list.
     * @param {string} mlsSource MLS of listing to ignore
     * @param {string} mlsNumber MLS number of listing to ignore.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addIgnoreListing(r, i, o) {
      return n.addIgnoreListing(r, i, o).then((l) => l(s, t));
    },
    /**
     * 
     * @summary Grant a sub-account to feature properties for the primary account.
     * @param {number} accountId Sub-account id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    allowToFeature(r, i) {
      return n.allowToFeature(r, i).then((o) => o(s, t));
    },
    /**
     * 
     * @summary Mark property for deletion, to be deleted 45 days once marked.
     * @param {string} propId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteExistingProperty(r, i) {
      return n.deleteExistingProperty(r, i).then((o) => o(s, t));
    },
    /**
     * 
     * @summary Deny a sub-account from featuring properties for the primary account.
     * @param {number} accountId Sub-account id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    denyToFeature(r, i) {
      return n.denyToFeature(r, i).then((o) => o(s, t));
    },
    /**
     * 
     * @summary List properties containing existing investment data.
     * @param {number} [p] Page
     * @param {number} [ps] Page Size
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getExistingInvestments(r, i, o) {
      return n.getExistingInvestments(r, i, o).then((l) => l(s, t));
    },
    /**
     * 
     * @summary List user\'s favorite properties.
     * @param {number} [p] Page
     * @param {number} [ps] Page Size
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getFavorites(r, i, o) {
      return n.getFavorites(r, i, o).then((l) => l(s, t));
    },
    /**
     * 
     * @summary List featured properties.
     * @param {FeaturedType} type 
     * @param {number} [p] Page
     * @param {number} [ps] Page Size
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getFeatured(r, i, o, l) {
      return n.getFeatured(r, i, o, l).then((d) => d(s, t));
    },
    /**
     * 
     * @summary List featured properties.
     * @param {FeaturedType} type 
     * @param {number} [p] Page
     * @param {number} [ps] Page Size
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getFeaturedForClient(r, i, o, l) {
      return n.getFeaturedForClient(r, i, o, l).then((d) => d(s, t));
    },
    /**
     * 
     * @summary List user\'s ignored properties.
     * @param {number} [p] Page
     * @param {number} [ps] Page Size
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getIgnored(r, i, o) {
      return n.getIgnored(r, i, o).then((l) => l(s, t));
    },
    /**
     * 
     * @summary Return summary of user\'s existing investments.
     * @param {boolean} [c] Current year summary, false for previous year.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    getMyInvestmentsSummary(r, i) {
      return n.getMyInvestmentsSummary(r, i).then((o) => o(s, t));
    },
    /**
     * 
     * @summary Remove property from user\'s favorite list.
     * @param {number} propId Id of property to favorite.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    removeFavorite(r, i) {
      return n.removeFavorite(r, i).then((o) => o(s, t));
    },
    /**
     * 
     * @summary Remove listing from user\'s favorite list.
     * @param {string} mlsSource MLS of listing to unfavorite
     * @param {string} mlsNumber MLS number of listing to unfavorite.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    removeFavoriteListing(r, i, o) {
      return n.removeFavoriteListing(r, i, o).then((l) => l(s, t));
    },
    /**
     * 
     * @summary Remove listing from user\'s featured list.
     * @param {string} mlsSource 
     * @param {string} mlsNumber 
     * @param {FeaturedType} [type] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    removeFeaturedListing(r, i, o, l) {
      return n.removeFeaturedListing(r, i, o, l).then((d) => d(s, t));
    },
    /**
     * 
     * @summary Remove property from user\'s ignore list.
     * @param {number} propId Id of property to favorite.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    removeIgnore(r, i) {
      return n.removeIgnore(r, i).then((o) => o(s, t));
    },
    /**
     * 
     * @summary Remove listing from user\'s ignore list.
     * @param {string} mlsSource MLS of listing to ignore
     * @param {string} mlsNumber MLS number of listing to ignore.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    removeIgnoreListing(r, i, o) {
      return n.removeIgnoreListing(r, i, o).then((l) => l(s, t));
    }
  };
}, E6 = function(e) {
  return {
    /**
     * 
     * @summary List all counties for state
     * @param {string} state 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    counties: async (t, s = {}) => {
      se("counties", "state", t);
      const n = "/geo/state/{state}/county".replace("{state}", encodeURIComponent(String(t))), r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "GET", ...i, ...s }, l = {}, d = {};
      await Lt(l, "x-api-key", e), await ee(l, e), Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, {
        url: J(r),
        options: o
      };
    },
    /**
     * 
     * @summary Retrieve list of counties for a state
     * @param {string} state 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    countiesForState: async (t, s = {}) => {
      se("countiesForState", "state", t);
      const n = "/geo/state/{state}/counties".replace("{state}", encodeURIComponent(String(t))), r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "GET", ...i, ...s }, l = {}, d = {};
      await Lt(l, "x-api-key", e), await ee(l, e), Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, {
        url: J(r),
        options: o
      };
    },
    /**
     * 
     * @summary Get geographic location info for user.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    location: async (t = {}) => {
      const s = "/geo/location", n = new URL(s, K);
      let r;
      e && (r = e.baseOptions);
      const i = { method: "GET", ...r, ...t }, o = {}, l = {};
      await ee(o, e), Z(n, l);
      let d = r && r.headers ? r.headers : {};
      return i.headers = { ...o, ...d, ...t.headers }, {
        url: J(n),
        options: i
      };
    },
    /**
     * 
     * @summary Retrieve property value metrics for county area.
     * @param {string} state State of the county to return property value metrics for.
     * @param {string} county County to return property value metrics for.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertyValueMetricsByCounty: async (t, s, n = {}) => {
      se("propertyValueMetricsByCounty", "state", t), se("propertyValueMetricsByCounty", "county", s);
      const r = "/geo/state/{state}/county/{county}/property-value-metrics".replace("{state}", encodeURIComponent(String(t))).replace("{county}", encodeURIComponent(String(s))), i = new URL(r, K);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "GET", ...o, ...n }, d = {}, c = {};
      await Lt(d, "x-api-key", e), await ee(d, e), Z(i, c);
      let u = o && o.headers ? o.headers : {};
      return l.headers = { ...d, ...u, ...n.headers }, {
        url: J(i),
        options: l
      };
    },
    /**
     * 
     * @summary Retrieve property value metrics for state area.
     * @param {string} state State to return property value metrics for.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertyValueMetricsByState: async (t, s = {}) => {
      se("propertyValueMetricsByState", "state", t);
      const n = "/geo/state/{state}/property-value-metrics".replace("{state}", encodeURIComponent(String(t))), r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "GET", ...i, ...s }, l = {}, d = {};
      await Lt(l, "x-api-key", e), await ee(l, e), Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, {
        url: J(r),
        options: o
      };
    },
    /**
     * 
     * @summary Retrieve property value metrics for zip code area.
     * @param {string} zip Zip code to return property value metrics for.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertyValueMetricsByZip: async (t, s = {}) => {
      se("propertyValueMetricsByZip", "zip", t);
      const n = "/geo/zip/{zip}/property-value-metrics".replace("{zip}", encodeURIComponent(String(t))), r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "GET", ...i, ...s }, l = {}, d = {};
      await Lt(l, "x-api-key", e), await ee(l, e), Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, {
        url: J(r),
        options: o
      };
    },
    /**
     * 
     * @summary Retrieve rental metrics for county area.
     * @param {string} state State of the county to return rental metrics for.
     * @param {string} county County to return rental metrics for.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    rentalMetricsByCounty: async (t, s, n = {}) => {
      se("rentalMetricsByCounty", "state", t), se("rentalMetricsByCounty", "county", s);
      const r = "/geo/state/{state}/county/{county}/rental-metrics".replace("{state}", encodeURIComponent(String(t))).replace("{county}", encodeURIComponent(String(s))), i = new URL(r, K);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "GET", ...o, ...n }, d = {}, c = {};
      await Lt(d, "x-api-key", e), await ee(d, e), Z(i, c);
      let u = o && o.headers ? o.headers : {};
      return l.headers = { ...d, ...u, ...n.headers }, {
        url: J(i),
        options: l
      };
    },
    /**
     * 
     * @summary Retrieve rental metrics for state area.
     * @param {string} state State to return rental metrics for.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    rentalMetricsByState: async (t, s = {}) => {
      se("rentalMetricsByState", "state", t);
      const n = "/geo/state/{state}/rental-metrics".replace("{state}", encodeURIComponent(String(t))), r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "GET", ...i, ...s }, l = {}, d = {};
      await Lt(l, "x-api-key", e), await ee(l, e), Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, {
        url: J(r),
        options: o
      };
    },
    /**
     * 
     * @summary Retrieve rental metrics for zip code area.
     * @param {string} zip Zip code to return rental metrics for.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    rentalMetricsByZip: async (t, s = {}) => {
      se("rentalMetricsByZip", "zip", t);
      const n = "/geo/zip/{zip}/rental-metrics".replace("{zip}", encodeURIComponent(String(t))), r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "GET", ...i, ...s }, l = {}, d = {};
      await Lt(l, "x-api-key", e), await ee(l, e), Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, {
        url: J(r),
        options: o
      };
    },
    /**
     * 
     * @summary Retrieve list of states.
     * @param {boolean} [leads] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    states: async (t, s = {}) => {
      const n = "/geo/state", r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "GET", ...i, ...s }, l = {}, d = {};
      await Lt(l, "x-api-key", e), await ee(l, e), t !== void 0 && (d.leads = t), Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, {
        url: J(r),
        options: o
      };
    },
    /**
     * 
     * @param {Array<string>} zip 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    zipInfo: async (t, s = {}) => {
      se("zipInfo", "zip", t);
      const n = "/geo/zip/info", r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "GET", ...i, ...s }, l = {}, d = {};
      await ee(l, e), t && (d.zip = t), Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, {
        url: J(r),
        options: o
      };
    },
    /**
     * 
     * @summary Lookup zip codes for auto-completion.
     * @param {string} zip 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    zipLookup: async (t, s = {}) => {
      se("zipLookup", "zip", t);
      const n = "/geo/zip-lookup", r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "GET", ...i, ...s }, l = {}, d = {};
      await Lt(l, "x-api-key", e), await ee(l, e), t !== void 0 && (d.zip = t), Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, {
        url: J(r),
        options: o
      };
    }
  };
}, I6 = function(e) {
  const t = E6(e);
  return {
    /**
     * 
     * @summary List all counties for state
     * @param {string} state 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async counties(s, n) {
      var l, d;
      const r = await t.counties(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["GeoApi.counties"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    },
    /**
     * 
     * @summary Retrieve list of counties for a state
     * @param {string} state 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async countiesForState(s, n) {
      var l, d;
      const r = await t.countiesForState(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["GeoApi.countiesForState"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    },
    /**
     * 
     * @summary Get geographic location info for user.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async location(s) {
      var o, l;
      const n = await t.location(s), r = (e == null ? void 0 : e.serverIndex) ?? 0, i = (l = (o = Q["GeoApi.location"]) == null ? void 0 : o[r]) == null ? void 0 : l.url;
      return (d, c) => _(n, X, G, e)(d, i || c);
    },
    /**
     * 
     * @summary Retrieve property value metrics for county area.
     * @param {string} state State of the county to return property value metrics for.
     * @param {string} county County to return property value metrics for.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async propertyValueMetricsByCounty(s, n, r) {
      var d, c;
      const i = await t.propertyValueMetricsByCounty(s, n, r), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (c = (d = Q["GeoApi.propertyValueMetricsByCounty"]) == null ? void 0 : d[o]) == null ? void 0 : c.url;
      return (u, m) => _(i, X, G, e)(u, l || m);
    },
    /**
     * 
     * @summary Retrieve property value metrics for state area.
     * @param {string} state State to return property value metrics for.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async propertyValueMetricsByState(s, n) {
      var l, d;
      const r = await t.propertyValueMetricsByState(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["GeoApi.propertyValueMetricsByState"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    },
    /**
     * 
     * @summary Retrieve property value metrics for zip code area.
     * @param {string} zip Zip code to return property value metrics for.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async propertyValueMetricsByZip(s, n) {
      var l, d;
      const r = await t.propertyValueMetricsByZip(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["GeoApi.propertyValueMetricsByZip"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    },
    /**
     * 
     * @summary Retrieve rental metrics for county area.
     * @param {string} state State of the county to return rental metrics for.
     * @param {string} county County to return rental metrics for.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async rentalMetricsByCounty(s, n, r) {
      var d, c;
      const i = await t.rentalMetricsByCounty(s, n, r), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (c = (d = Q["GeoApi.rentalMetricsByCounty"]) == null ? void 0 : d[o]) == null ? void 0 : c.url;
      return (u, m) => _(i, X, G, e)(u, l || m);
    },
    /**
     * 
     * @summary Retrieve rental metrics for state area.
     * @param {string} state State to return rental metrics for.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async rentalMetricsByState(s, n) {
      var l, d;
      const r = await t.rentalMetricsByState(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["GeoApi.rentalMetricsByState"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    },
    /**
     * 
     * @summary Retrieve rental metrics for zip code area.
     * @param {string} zip Zip code to return rental metrics for.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async rentalMetricsByZip(s, n) {
      var l, d;
      const r = await t.rentalMetricsByZip(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["GeoApi.rentalMetricsByZip"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    },
    /**
     * 
     * @summary Retrieve list of states.
     * @param {boolean} [leads] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async states(s, n) {
      var l, d;
      const r = await t.states(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["GeoApi.states"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    },
    /**
     * 
     * @param {Array<string>} zip 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async zipInfo(s, n) {
      var l, d;
      const r = await t.zipInfo(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["GeoApi.zipInfo"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    },
    /**
     * 
     * @summary Lookup zip codes for auto-completion.
     * @param {string} zip 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async zipLookup(s, n) {
      var l, d;
      const r = await t.zipLookup(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["GeoApi.zipLookup"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    }
  };
}, T6 = function(e, t, s) {
  const n = I6(e);
  return {
    /**
     * 
     * @summary List all counties for state
     * @param {string} state 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    counties(r, i) {
      return n.counties(r, i).then((o) => o(s, t));
    },
    /**
     * 
     * @summary Retrieve list of counties for a state
     * @param {string} state 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    countiesForState(r, i) {
      return n.countiesForState(r, i).then((o) => o(s, t));
    },
    /**
     * 
     * @summary Get geographic location info for user.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    location(r) {
      return n.location(r).then((i) => i(s, t));
    },
    /**
     * 
     * @summary Retrieve property value metrics for county area.
     * @param {string} state State of the county to return property value metrics for.
     * @param {string} county County to return property value metrics for.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertyValueMetricsByCounty(r, i, o) {
      return n.propertyValueMetricsByCounty(r, i, o).then((l) => l(s, t));
    },
    /**
     * 
     * @summary Retrieve property value metrics for state area.
     * @param {string} state State to return property value metrics for.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertyValueMetricsByState(r, i) {
      return n.propertyValueMetricsByState(r, i).then((o) => o(s, t));
    },
    /**
     * 
     * @summary Retrieve property value metrics for zip code area.
     * @param {string} zip Zip code to return property value metrics for.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertyValueMetricsByZip(r, i) {
      return n.propertyValueMetricsByZip(r, i).then((o) => o(s, t));
    },
    /**
     * 
     * @summary Retrieve rental metrics for county area.
     * @param {string} state State of the county to return rental metrics for.
     * @param {string} county County to return rental metrics for.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    rentalMetricsByCounty(r, i, o) {
      return n.rentalMetricsByCounty(r, i, o).then((l) => l(s, t));
    },
    /**
     * 
     * @summary Retrieve rental metrics for state area.
     * @param {string} state State to return rental metrics for.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    rentalMetricsByState(r, i) {
      return n.rentalMetricsByState(r, i).then((o) => o(s, t));
    },
    /**
     * 
     * @summary Retrieve rental metrics for zip code area.
     * @param {string} zip Zip code to return rental metrics for.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    rentalMetricsByZip(r, i) {
      return n.rentalMetricsByZip(r, i).then((o) => o(s, t));
    },
    /**
     * 
     * @summary Retrieve list of states.
     * @param {boolean} [leads] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    states(r, i) {
      return n.states(r, i).then((o) => o(s, t));
    },
    /**
     * 
     * @param {Array<string>} zip 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    zipInfo(r, i) {
      return n.zipInfo(r, i).then((o) => o(s, t));
    },
    /**
     * 
     * @summary Lookup zip codes for auto-completion.
     * @param {string} zip 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    zipLookup(r, i) {
      return n.zipLookup(r, i).then((o) => o(s, t));
    }
  };
}, O6 = function(e) {
  return {
    /**
     * 
     * @summary Create a share URL for a property.
     * @param {string} mlsSource 
     * @param {string} mlsNumber 
     * @param {number} [sqFt] 
     * @param {number} [associationFee] 
     * @param {number} [propertyValue] 
     * @param {number} [annualPropertyTax] 
     * @param {number} [rentEstimate] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createMlsShareUrl: async (t, s, n, r, i, o, l, d = {}) => {
      se("createMlsShareUrl", "mlsSource", t), se("createMlsShareUrl", "mlsNumber", s);
      const c = "/homes/{mlsSource}/{mlsNumber}/share/create".replace("{mlsSource}", encodeURIComponent(String(t))).replace("{mlsNumber}", encodeURIComponent(String(s))), u = new URL(c, K);
      let m;
      e && (m = e.baseOptions);
      const f = { method: "POST", ...m, ...d }, v = {}, b = {};
      await ee(v, e), n !== void 0 && (b.sqFt = n), r !== void 0 && (b.associationFee = r), i !== void 0 && (b.propertyValue = i), o !== void 0 && (b.annualPropertyTax = o), l !== void 0 && (b.rentEstimate = l), Z(u, b);
      let w = m && m.headers ? m.headers : {};
      return f.headers = { ...v, ...w, ...d.headers }, {
        url: J(u),
        options: f
      };
    },
    /**
     * 
     * @summary Create a share URL for a property.
     * @param {number} propId 
     * @param {number} [sqFt] 
     * @param {number} [associationFee] 
     * @param {number} [propertyValue] 
     * @param {number} [annualPropertyTax] 
     * @param {number} [rentEstimate] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createShareUrl: async (t, s, n, r, i, o, l = {}) => {
      se("createShareUrl", "propId", t);
      const d = "/homes/{propId}/share/create".replace("{propId}", encodeURIComponent(String(t))), c = new URL(d, K);
      let u;
      e && (u = e.baseOptions);
      const m = { method: "POST", ...u, ...l }, f = {}, v = {};
      await ee(f, e), s !== void 0 && (v.sqFt = s), n !== void 0 && (v.associationFee = n), r !== void 0 && (v.propertyValue = r), i !== void 0 && (v.annualPropertyTax = i), o !== void 0 && (v.rentEstimate = o), Z(c, v);
      let b = u && u.headers ? u.headers : {};
      return m.headers = { ...f, ...b, ...l.headers }, {
        url: J(c),
        options: m
      };
    },
    /**
     * 
     * @summary Retrieve possible contacts from previous skip trace.
     * @param {number} propId ID of property.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getOwnerNames: async (t, s = {}) => {
      se("getOwnerNames", "propId", t);
      const n = "/homes/{propId}/owners".replace("{propId}", encodeURIComponent(String(t))), r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "GET", ...i, ...s }, l = {}, d = {};
      await Lt(l, "x-api-key", e), await ee(l, e), Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, {
        url: J(r),
        options: o
      };
    },
    /**
     * 
     * @summary Returns property files used from last MLS listing.
     * @param {number} propId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPropertyFiles: async (t, s = {}) => {
      se("getPropertyFiles", "propId", t);
      const n = "/homes/{propId}/files".replace("{propId}", encodeURIComponent(String(t))), r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "GET", ...i, ...s }, l = {}, d = {};
      await Lt(l, "x-api-key", e), await ee(l, e), Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, {
        url: J(r),
        options: o
      };
    },
    /**
     * 
     * @summary Retrieve basic information for a property.
     * @param {number} propId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPropertyInfo: async (t, s = {}) => {
      se("getPropertyInfo", "propId", t);
      const n = "/homes/{propId}".replace("{propId}", encodeURIComponent(String(t))), r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "GET", ...i, ...s }, l = {}, d = {};
      await Lt(l, "x-api-key", e), await ee(l, e), Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, {
        url: J(r),
        options: o
      };
    },
    /**
     * 
     * @param {string} state 
     * @param {string} city 
     * @param {string} zip 
     * @param {string} address 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPropertyInfoByAddress: async (t, s, n, r, i = {}) => {
      se("getPropertyInfoByAddress", "state", t), se("getPropertyInfoByAddress", "city", s), se("getPropertyInfoByAddress", "zip", n), se("getPropertyInfoByAddress", "address", r);
      const o = "/homes/{state}/{city}/{zip}/{address}".replace("{state}", encodeURIComponent(String(t))).replace("{city}", encodeURIComponent(String(s))).replace("{zip}", encodeURIComponent(String(n))).replace("{address}", encodeURIComponent(String(r))), l = new URL(o, K);
      let d;
      e && (d = e.baseOptions);
      const c = { method: "GET", ...d, ...i }, u = {}, m = {};
      await Lt(u, "x-api-key", e), await ee(u, e), Z(l, m);
      let f = d && d.headers ? d.headers : {};
      return c.headers = { ...u, ...f, ...i.headers }, {
        url: J(l),
        options: c
      };
    },
    /**
     * 
     * @param {string} state 
     * @param {string} city 
     * @param {string} zip 
     * @param {string} address 
     * @param {string} unit 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPropertyInfoByAddressUnit: async (t, s, n, r, i, o = {}) => {
      se("getPropertyInfoByAddressUnit", "state", t), se("getPropertyInfoByAddressUnit", "city", s), se("getPropertyInfoByAddressUnit", "zip", n), se("getPropertyInfoByAddressUnit", "address", r), se("getPropertyInfoByAddressUnit", "unit", i);
      const l = "/homes/{state}/{city}/{zip}/{address}/unit/{unit}".replace("{state}", encodeURIComponent(String(t))).replace("{city}", encodeURIComponent(String(s))).replace("{zip}", encodeURIComponent(String(n))).replace("{address}", encodeURIComponent(String(r))).replace("{unit}", encodeURIComponent(String(i))), d = new URL(l, K);
      let c;
      e && (c = e.baseOptions);
      const u = { method: "GET", ...c, ...o }, m = {}, f = {};
      await Lt(m, "x-api-key", e), await ee(m, e), Z(d, f);
      let v = c && c.headers ? c.headers : {};
      return u.headers = { ...m, ...v, ...o.headers }, {
        url: J(d),
        options: u
      };
    },
    /**
     * 
     * @param {string} state 
     * @param {string} city 
     * @param {string} zip 
     * @param {string} address 
     * @param {string} id 
     * @param {string} unit 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPropertyInfoByAddressUnitWithId: async (t, s, n, r, i, o, l = {}) => {
      se("getPropertyInfoByAddressUnitWithId", "state", t), se("getPropertyInfoByAddressUnitWithId", "city", s), se("getPropertyInfoByAddressUnitWithId", "zip", n), se("getPropertyInfoByAddressUnitWithId", "address", r), se("getPropertyInfoByAddressUnitWithId", "id", i), se("getPropertyInfoByAddressUnitWithId", "unit", o);
      const d = "/homes/{state}/{city}/{zip}/{address}/unit/{unit}/{id}".replace("{state}", encodeURIComponent(String(t))).replace("{city}", encodeURIComponent(String(s))).replace("{zip}", encodeURIComponent(String(n))).replace("{address}", encodeURIComponent(String(r))).replace("{id}", encodeURIComponent(String(i))).replace("{unit}", encodeURIComponent(String(o))), c = new URL(d, K);
      let u;
      e && (u = e.baseOptions);
      const m = { method: "GET", ...u, ...l }, f = {}, v = {};
      await Lt(f, "x-api-key", e), await ee(f, e), Z(c, v);
      let b = u && u.headers ? u.headers : {};
      return m.headers = { ...f, ...b, ...l.headers }, {
        url: J(c),
        options: m
      };
    },
    /**
     * 
     * @param {string} state 
     * @param {string} city 
     * @param {string} zip 
     * @param {string} address 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPropertyInfoByAddressWithId: async (t, s, n, r, i, o = {}) => {
      se("getPropertyInfoByAddressWithId", "state", t), se("getPropertyInfoByAddressWithId", "city", s), se("getPropertyInfoByAddressWithId", "zip", n), se("getPropertyInfoByAddressWithId", "address", r), se("getPropertyInfoByAddressWithId", "id", i);
      const l = "/homes/{state}/{city}/{zip}/{address}/{id}".replace("{state}", encodeURIComponent(String(t))).replace("{city}", encodeURIComponent(String(s))).replace("{zip}", encodeURIComponent(String(n))).replace("{address}", encodeURIComponent(String(r))).replace("{id}", encodeURIComponent(String(i))), d = new URL(l, K);
      let c;
      e && (c = e.baseOptions);
      const u = { method: "GET", ...c, ...o }, m = {}, f = {};
      await Lt(m, "x-api-key", e), await ee(m, e), Z(d, f);
      let v = c && c.headers ? c.headers : {};
      return u.headers = { ...m, ...v, ...o.headers }, {
        url: J(d),
        options: u
      };
    },
    /**
     * 
     * @param {number} portfolioId 
     * @param {string} propId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPropertyInfoByPortfolio: async (t, s, n = {}) => {
      se("getPropertyInfoByPortfolio", "portfolioId", t), se("getPropertyInfoByPortfolio", "propId", s);
      const r = "/homes/{propId}/portfolio/{portfolioId}".replace("{portfolioId}", encodeURIComponent(String(t))).replace("{propId}", encodeURIComponent(String(s))), i = new URL(r, K);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "GET", ...o, ...n }, d = {}, c = {};
      await Lt(d, "x-api-key", e), await ee(d, e), Z(i, c);
      let u = o && o.headers ? o.headers : {};
      return l.headers = { ...d, ...u, ...n.headers }, {
        url: J(i),
        options: l
      };
    },
    /**
     * 
     * @summary Retrieve basic information for a property.
     * @param {string} mlsSource 
     * @param {string} mlsNumber 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPropertyInfoMls: async (t, s, n = {}) => {
      se("getPropertyInfoMls", "mlsSource", t), se("getPropertyInfoMls", "mlsNumber", s);
      const r = "/homes/{mlsSource}/{mlsNumber}".replace("{mlsSource}", encodeURIComponent(String(t))).replace("{mlsNumber}", encodeURIComponent(String(s))), i = new URL(r, K);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "GET", ...o, ...n }, d = {}, c = {};
      await Lt(d, "x-api-key", e), await ee(d, e), Z(i, c);
      let u = o && o.headers ? o.headers : {};
      return l.headers = { ...d, ...u, ...n.headers }, {
        url: J(i),
        options: l
      };
    },
    /**
     * 
     * @summary Delete user\'s saved tweaks for a property.
     * @param {number} propId Property Id to reset.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    reset: async (t, s = {}) => {
      se("reset", "propId", t);
      const n = "/homes/{propId}/tweaks".replace("{propId}", encodeURIComponent(String(t))), r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "DELETE", ...i, ...s }, l = {}, d = {};
      await ee(l, e), Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, {
        url: J(r),
        options: o
      };
    },
    /**
     * 
     * @summary Share a property with a friend or client.
     * @param {number} propId ID of property to share.
     * @param {ShareRequest} shareRequest 
     * @param {number} [sqFt] 
     * @param {number} [associationFee] 
     * @param {number} [propertyValue] 
     * @param {number} [annualPropertyTax] 
     * @param {number} [rentEstimate] 
     * @param {string} [token] Token from existing previous share.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    share: async (t, s, n, r, i, o, l, d, c = {}) => {
      se("share", "propId", t), se("share", "shareRequest", s);
      const u = "/homes/{propId}/share".replace("{propId}", encodeURIComponent(String(t))), m = new URL(u, K);
      let f;
      e && (f = e.baseOptions);
      const v = { method: "POST", ...f, ...c }, b = {}, w = {};
      await ee(b, e), n !== void 0 && (w.sqFt = n), r !== void 0 && (w.associationFee = r), i !== void 0 && (w.propertyValue = i), o !== void 0 && (w.annualPropertyTax = o), l !== void 0 && (w.rentEstimate = l), d !== void 0 && (w.token = d), b["Content-Type"] = "application/json", Z(m, w);
      let S = f && f.headers ? f.headers : {};
      return v.headers = { ...b, ...S, ...c.headers }, v.data = kt(s, v, e), {
        url: J(m),
        options: v
      };
    },
    /**
     * 
     * @summary Share a property with a friend or client.
     * @param {string} mlsSource 
     * @param {string} mlsNumber 
     * @param {ShareRequest} shareRequest 
     * @param {number} [sqFt] 
     * @param {number} [associationFee] 
     * @param {number} [propertyValue] 
     * @param {number} [annualPropertyTax] 
     * @param {number} [rentEstimate] 
     * @param {string} [token] Token from existing previous share.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    shareMls: async (t, s, n, r, i, o, l, d, c, u = {}) => {
      se("shareMls", "mlsSource", t), se("shareMls", "mlsNumber", s), se("shareMls", "shareRequest", n);
      const m = "/homes/{mlsSource}/{mlsNumber}/share".replace("{mlsSource}", encodeURIComponent(String(t))).replace("{mlsNumber}", encodeURIComponent(String(s))), f = new URL(m, K);
      let v;
      e && (v = e.baseOptions);
      const b = { method: "POST", ...v, ...u }, w = {}, S = {};
      await ee(w, e), r !== void 0 && (S.sqFt = r), i !== void 0 && (S.associationFee = i), o !== void 0 && (S.propertyValue = o), l !== void 0 && (S.annualPropertyTax = l), d !== void 0 && (S.rentEstimate = d), c !== void 0 && (S.token = c), w["Content-Type"] = "application/json", Z(f, S);
      let I = v && v.headers ? v.headers : {};
      return b.headers = { ...w, ...I, ...u.headers }, b.data = kt(n, b, e), {
        url: J(f),
        options: b
      };
    },
    /**
     * 
     * @summary Skip trace a property for owner contact information.
     * @param {number} propId ID of property.
     * @param {PropertyOwnerNameModel} [propertyOwnerNameModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    skipTraceOwnerName: async (t, s, n = {}) => {
      se("skipTraceOwnerName", "propId", t);
      const r = "/homes/{propId}/skip-trace".replace("{propId}", encodeURIComponent(String(t))), i = new URL(r, K);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "POST", ...o, ...n }, d = {}, c = {};
      await ee(d, e), d["Content-Type"] = "application/json", Z(i, c);
      let u = o && o.headers ? o.headers : {};
      return l.headers = { ...d, ...u, ...n.headers }, l.data = kt(s, l, e), {
        url: J(i),
        options: l
      };
    },
    /**
     * 
     * @summary System stats for homes.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    stats: async (t = {}) => {
      const s = "/homes/stats", n = new URL(s, K);
      let r;
      e && (r = e.baseOptions);
      const i = { method: "GET", ...r, ...t }, o = {}, l = {};
      await ee(o, e), Z(n, l);
      let d = r && r.headers ? r.headers : {};
      return i.headers = { ...o, ...d, ...t.headers }, {
        url: J(n),
        options: i
      };
    },
    /**
     * 
     * @summary Track property share view
     * @param {number} propId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    trackShare: async (t, s = {}) => {
      se("trackShare", "propId", t);
      const n = "/homes/{propId}/share/track".replace("{propId}", encodeURIComponent(String(t))), r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "POST", ...i, ...s }, l = {}, d = {};
      await Lt(l, "x-api-key", e), await ee(l, e), Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, {
        url: J(r),
        options: o
      };
    },
    /**
     * 
     * @param {number} propId 
     * @param {PropertyOwnerNameModel} [propertyOwnerNameModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateOwnerName: async (t, s, n = {}) => {
      se("updateOwnerName", "propId", t);
      const r = "/homes/{propId}/owner".replace("{propId}", encodeURIComponent(String(t))), i = new URL(r, K);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "PATCH", ...o, ...n }, d = {}, c = {};
      await ee(d, e), d["Content-Type"] = "application/json", Z(i, c);
      let u = o && o.headers ? o.headers : {};
      return l.headers = { ...d, ...u, ...n.headers }, l.data = kt(s, l, e), {
        url: J(i),
        options: l
      };
    }
  };
}, R6 = function(e) {
  const t = O6(e);
  return {
    /**
     * 
     * @summary Create a share URL for a property.
     * @param {string} mlsSource 
     * @param {string} mlsNumber 
     * @param {number} [sqFt] 
     * @param {number} [associationFee] 
     * @param {number} [propertyValue] 
     * @param {number} [annualPropertyTax] 
     * @param {number} [rentEstimate] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createMlsShareUrl(s, n, r, i, o, l, d, c) {
      var v, b;
      const u = await t.createMlsShareUrl(s, n, r, i, o, l, d, c), m = (e == null ? void 0 : e.serverIndex) ?? 0, f = (b = (v = Q["HomesApi.createMlsShareUrl"]) == null ? void 0 : v[m]) == null ? void 0 : b.url;
      return (w, S) => _(u, X, G, e)(w, f || S);
    },
    /**
     * 
     * @summary Create a share URL for a property.
     * @param {number} propId 
     * @param {number} [sqFt] 
     * @param {number} [associationFee] 
     * @param {number} [propertyValue] 
     * @param {number} [annualPropertyTax] 
     * @param {number} [rentEstimate] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createShareUrl(s, n, r, i, o, l, d) {
      var f, v;
      const c = await t.createShareUrl(s, n, r, i, o, l, d), u = (e == null ? void 0 : e.serverIndex) ?? 0, m = (v = (f = Q["HomesApi.createShareUrl"]) == null ? void 0 : f[u]) == null ? void 0 : v.url;
      return (b, w) => _(c, X, G, e)(b, m || w);
    },
    /**
     * 
     * @summary Retrieve possible contacts from previous skip trace.
     * @param {number} propId ID of property.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getOwnerNames(s, n) {
      var l, d;
      const r = await t.getOwnerNames(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["HomesApi.getOwnerNames"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    },
    /**
     * 
     * @summary Returns property files used from last MLS listing.
     * @param {number} propId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getPropertyFiles(s, n) {
      var l, d;
      const r = await t.getPropertyFiles(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["HomesApi.getPropertyFiles"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    },
    /**
     * 
     * @summary Retrieve basic information for a property.
     * @param {number} propId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getPropertyInfo(s, n) {
      var l, d;
      const r = await t.getPropertyInfo(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["HomesApi.getPropertyInfo"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    },
    /**
     * 
     * @param {string} state 
     * @param {string} city 
     * @param {string} zip 
     * @param {string} address 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getPropertyInfoByAddress(s, n, r, i, o) {
      var u, m;
      const l = await t.getPropertyInfoByAddress(s, n, r, i, o), d = (e == null ? void 0 : e.serverIndex) ?? 0, c = (m = (u = Q["HomesApi.getPropertyInfoByAddress"]) == null ? void 0 : u[d]) == null ? void 0 : m.url;
      return (f, v) => _(l, X, G, e)(f, c || v);
    },
    /**
     * 
     * @param {string} state 
     * @param {string} city 
     * @param {string} zip 
     * @param {string} address 
     * @param {string} unit 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getPropertyInfoByAddressUnit(s, n, r, i, o, l) {
      var m, f;
      const d = await t.getPropertyInfoByAddressUnit(s, n, r, i, o, l), c = (e == null ? void 0 : e.serverIndex) ?? 0, u = (f = (m = Q["HomesApi.getPropertyInfoByAddressUnit"]) == null ? void 0 : m[c]) == null ? void 0 : f.url;
      return (v, b) => _(d, X, G, e)(v, u || b);
    },
    /**
     * 
     * @param {string} state 
     * @param {string} city 
     * @param {string} zip 
     * @param {string} address 
     * @param {string} id 
     * @param {string} unit 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getPropertyInfoByAddressUnitWithId(s, n, r, i, o, l, d) {
      var f, v;
      const c = await t.getPropertyInfoByAddressUnitWithId(s, n, r, i, o, l, d), u = (e == null ? void 0 : e.serverIndex) ?? 0, m = (v = (f = Q["HomesApi.getPropertyInfoByAddressUnitWithId"]) == null ? void 0 : f[u]) == null ? void 0 : v.url;
      return (b, w) => _(c, X, G, e)(b, m || w);
    },
    /**
     * 
     * @param {string} state 
     * @param {string} city 
     * @param {string} zip 
     * @param {string} address 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getPropertyInfoByAddressWithId(s, n, r, i, o, l) {
      var m, f;
      const d = await t.getPropertyInfoByAddressWithId(s, n, r, i, o, l), c = (e == null ? void 0 : e.serverIndex) ?? 0, u = (f = (m = Q["HomesApi.getPropertyInfoByAddressWithId"]) == null ? void 0 : m[c]) == null ? void 0 : f.url;
      return (v, b) => _(d, X, G, e)(v, u || b);
    },
    /**
     * 
     * @param {number} portfolioId 
     * @param {string} propId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getPropertyInfoByPortfolio(s, n, r) {
      var d, c;
      const i = await t.getPropertyInfoByPortfolio(s, n, r), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (c = (d = Q["HomesApi.getPropertyInfoByPortfolio"]) == null ? void 0 : d[o]) == null ? void 0 : c.url;
      return (u, m) => _(i, X, G, e)(u, l || m);
    },
    /**
     * 
     * @summary Retrieve basic information for a property.
     * @param {string} mlsSource 
     * @param {string} mlsNumber 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getPropertyInfoMls(s, n, r) {
      var d, c;
      const i = await t.getPropertyInfoMls(s, n, r), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (c = (d = Q["HomesApi.getPropertyInfoMls"]) == null ? void 0 : d[o]) == null ? void 0 : c.url;
      return (u, m) => _(i, X, G, e)(u, l || m);
    },
    /**
     * 
     * @summary Delete user\'s saved tweaks for a property.
     * @param {number} propId Property Id to reset.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async reset(s, n) {
      var l, d;
      const r = await t.reset(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["HomesApi.reset"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    },
    /**
     * 
     * @summary Share a property with a friend or client.
     * @param {number} propId ID of property to share.
     * @param {ShareRequest} shareRequest 
     * @param {number} [sqFt] 
     * @param {number} [associationFee] 
     * @param {number} [propertyValue] 
     * @param {number} [annualPropertyTax] 
     * @param {number} [rentEstimate] 
     * @param {string} [token] Token from existing previous share.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async share(s, n, r, i, o, l, d, c, u) {
      var b, w;
      const m = await t.share(s, n, r, i, o, l, d, c, u), f = (e == null ? void 0 : e.serverIndex) ?? 0, v = (w = (b = Q["HomesApi.share"]) == null ? void 0 : b[f]) == null ? void 0 : w.url;
      return (S, I) => _(m, X, G, e)(S, v || I);
    },
    /**
     * 
     * @summary Share a property with a friend or client.
     * @param {string} mlsSource 
     * @param {string} mlsNumber 
     * @param {ShareRequest} shareRequest 
     * @param {number} [sqFt] 
     * @param {number} [associationFee] 
     * @param {number} [propertyValue] 
     * @param {number} [annualPropertyTax] 
     * @param {number} [rentEstimate] 
     * @param {string} [token] Token from existing previous share.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async shareMls(s, n, r, i, o, l, d, c, u, m) {
      var w, S;
      const f = await t.shareMls(s, n, r, i, o, l, d, c, u, m), v = (e == null ? void 0 : e.serverIndex) ?? 0, b = (S = (w = Q["HomesApi.shareMls"]) == null ? void 0 : w[v]) == null ? void 0 : S.url;
      return (I, T) => _(f, X, G, e)(I, b || T);
    },
    /**
     * 
     * @summary Skip trace a property for owner contact information.
     * @param {number} propId ID of property.
     * @param {PropertyOwnerNameModel} [propertyOwnerNameModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async skipTraceOwnerName(s, n, r) {
      var d, c;
      const i = await t.skipTraceOwnerName(s, n, r), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (c = (d = Q["HomesApi.skipTraceOwnerName"]) == null ? void 0 : d[o]) == null ? void 0 : c.url;
      return (u, m) => _(i, X, G, e)(u, l || m);
    },
    /**
     * 
     * @summary System stats for homes.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async stats(s) {
      var o, l;
      const n = await t.stats(s), r = (e == null ? void 0 : e.serverIndex) ?? 0, i = (l = (o = Q["HomesApi.stats"]) == null ? void 0 : o[r]) == null ? void 0 : l.url;
      return (d, c) => _(n, X, G, e)(d, i || c);
    },
    /**
     * 
     * @summary Track property share view
     * @param {number} propId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async trackShare(s, n) {
      var l, d;
      const r = await t.trackShare(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["HomesApi.trackShare"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    },
    /**
     * 
     * @param {number} propId 
     * @param {PropertyOwnerNameModel} [propertyOwnerNameModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateOwnerName(s, n, r) {
      var d, c;
      const i = await t.updateOwnerName(s, n, r), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (c = (d = Q["HomesApi.updateOwnerName"]) == null ? void 0 : d[o]) == null ? void 0 : c.url;
      return (u, m) => _(i, X, G, e)(u, l || m);
    }
  };
}, L6 = function(e, t, s) {
  const n = R6(e);
  return {
    /**
     * 
     * @summary Create a share URL for a property.
     * @param {string} mlsSource 
     * @param {string} mlsNumber 
     * @param {number} [sqFt] 
     * @param {number} [associationFee] 
     * @param {number} [propertyValue] 
     * @param {number} [annualPropertyTax] 
     * @param {number} [rentEstimate] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createMlsShareUrl(r, i, o, l, d, c, u, m) {
      return n.createMlsShareUrl(r, i, o, l, d, c, u, m).then((f) => f(s, t));
    },
    /**
     * 
     * @summary Create a share URL for a property.
     * @param {number} propId 
     * @param {number} [sqFt] 
     * @param {number} [associationFee] 
     * @param {number} [propertyValue] 
     * @param {number} [annualPropertyTax] 
     * @param {number} [rentEstimate] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createShareUrl(r, i, o, l, d, c, u) {
      return n.createShareUrl(r, i, o, l, d, c, u).then((m) => m(s, t));
    },
    /**
     * 
     * @summary Retrieve possible contacts from previous skip trace.
     * @param {number} propId ID of property.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getOwnerNames(r, i) {
      return n.getOwnerNames(r, i).then((o) => o(s, t));
    },
    /**
     * 
     * @summary Returns property files used from last MLS listing.
     * @param {number} propId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPropertyFiles(r, i) {
      return n.getPropertyFiles(r, i).then((o) => o(s, t));
    },
    /**
     * 
     * @summary Retrieve basic information for a property.
     * @param {number} propId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPropertyInfo(r, i) {
      return n.getPropertyInfo(r, i).then((o) => o(s, t));
    },
    /**
     * 
     * @param {string} state 
     * @param {string} city 
     * @param {string} zip 
     * @param {string} address 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPropertyInfoByAddress(r, i, o, l, d) {
      return n.getPropertyInfoByAddress(r, i, o, l, d).then((c) => c(s, t));
    },
    /**
     * 
     * @param {string} state 
     * @param {string} city 
     * @param {string} zip 
     * @param {string} address 
     * @param {string} unit 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPropertyInfoByAddressUnit(r, i, o, l, d, c) {
      return n.getPropertyInfoByAddressUnit(r, i, o, l, d, c).then((u) => u(s, t));
    },
    /**
     * 
     * @param {string} state 
     * @param {string} city 
     * @param {string} zip 
     * @param {string} address 
     * @param {string} id 
     * @param {string} unit 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPropertyInfoByAddressUnitWithId(r, i, o, l, d, c, u) {
      return n.getPropertyInfoByAddressUnitWithId(r, i, o, l, d, c, u).then((m) => m(s, t));
    },
    /**
     * 
     * @param {string} state 
     * @param {string} city 
     * @param {string} zip 
     * @param {string} address 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPropertyInfoByAddressWithId(r, i, o, l, d, c) {
      return n.getPropertyInfoByAddressWithId(r, i, o, l, d, c).then((u) => u(s, t));
    },
    /**
     * 
     * @param {number} portfolioId 
     * @param {string} propId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPropertyInfoByPortfolio(r, i, o) {
      return n.getPropertyInfoByPortfolio(r, i, o).then((l) => l(s, t));
    },
    /**
     * 
     * @summary Retrieve basic information for a property.
     * @param {string} mlsSource 
     * @param {string} mlsNumber 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPropertyInfoMls(r, i, o) {
      return n.getPropertyInfoMls(r, i, o).then((l) => l(s, t));
    },
    /**
     * 
     * @summary Delete user\'s saved tweaks for a property.
     * @param {number} propId Property Id to reset.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    reset(r, i) {
      return n.reset(r, i).then((o) => o(s, t));
    },
    /**
     * 
     * @summary Share a property with a friend or client.
     * @param {number} propId ID of property to share.
     * @param {ShareRequest} shareRequest 
     * @param {number} [sqFt] 
     * @param {number} [associationFee] 
     * @param {number} [propertyValue] 
     * @param {number} [annualPropertyTax] 
     * @param {number} [rentEstimate] 
     * @param {string} [token] Token from existing previous share.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    share(r, i, o, l, d, c, u, m, f) {
      return n.share(r, i, o, l, d, c, u, m, f).then((v) => v(s, t));
    },
    /**
     * 
     * @summary Share a property with a friend or client.
     * @param {string} mlsSource 
     * @param {string} mlsNumber 
     * @param {ShareRequest} shareRequest 
     * @param {number} [sqFt] 
     * @param {number} [associationFee] 
     * @param {number} [propertyValue] 
     * @param {number} [annualPropertyTax] 
     * @param {number} [rentEstimate] 
     * @param {string} [token] Token from existing previous share.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    shareMls(r, i, o, l, d, c, u, m, f, v) {
      return n.shareMls(r, i, o, l, d, c, u, m, f, v).then((b) => b(s, t));
    },
    /**
     * 
     * @summary Skip trace a property for owner contact information.
     * @param {number} propId ID of property.
     * @param {PropertyOwnerNameModel} [propertyOwnerNameModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    skipTraceOwnerName(r, i, o) {
      return n.skipTraceOwnerName(r, i, o).then((l) => l(s, t));
    },
    /**
     * 
     * @summary System stats for homes.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    stats(r) {
      return n.stats(r).then((i) => i(s, t));
    },
    /**
     * 
     * @summary Track property share view
     * @param {number} propId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    trackShare(r, i) {
      return n.trackShare(r, i).then((o) => o(s, t));
    },
    /**
     * 
     * @param {number} propId 
     * @param {PropertyOwnerNameModel} [propertyOwnerNameModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateOwnerName(r, i, o) {
      return n.updateOwnerName(r, i, o).then((l) => l(s, t));
    }
  };
}, B6 = function(e) {
  return {
    /**
     * 
     * @summary Add a client and optionally send a invite email.
     * @param {AddClientModel} [addClientModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addClient: async (t, s = {}) => {
      const n = "/idx/clients/add", r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "POST", ...i, ...s }, l = {}, d = {};
      await ee(l, e), l["Content-Type"] = "application/json", Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, o.data = kt(t, o, e), {
        url: J(r),
        options: o
      };
    },
    /**
     * 
     * @summary List investment gateway clients associated with agent.
     * @param {number} [page] Current page of clients to return.
     * @param {number} [pageSize] Total clients per page.
     * @param {ClientRelationshipType} [type] Filter client\&#39;s by relationship type
     * @param {ClientRelationshipSort} [sort] 
     * @param {SortDirection} [sortDirection] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getClients: async (t, s, n, r, i, o = {}) => {
      const l = "/idx/clients", d = new URL(l, K);
      let c;
      e && (c = e.baseOptions);
      const u = { method: "GET", ...c, ...o }, m = {}, f = {};
      await ee(m, e), t !== void 0 && (f.page = t), s !== void 0 && (f.pageSize = s), n !== void 0 && (f.type = n), r !== void 0 && (f.sort = r), i !== void 0 && (f.sortDirection = i), Z(d, f);
      let v = c && c.headers ? c.headers : {};
      return u.headers = { ...m, ...v, ...o.headers }, {
        url: J(d),
        options: u
      };
    },
    /**
     * 
     * @summary Send a existing client an invite email.
     * @param {InviteClientModel} [inviteClientModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sendClientInvite: async (t, s = {}) => {
      const n = "/idx/clients/invite", r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "POST", ...i, ...s }, l = {}, d = {};
      await ee(l, e), l["Content-Type"] = "application/json", Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, o.data = kt(t, o, e), {
        url: J(r),
        options: o
      };
    },
    /**
     * 
     * @summary Remove client link to agent account.
     * @param {number} [id] 
     * @param {number} [parentId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    unlinkClient: async (t, s, n = {}) => {
      const r = "/idx/clients/unlink", i = new URL(r, K);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "POST", ...o, ...n }, d = {}, c = {}, u = new (e && e.formDataCtor || FormData)();
      await ee(d, e), t !== void 0 && u.append("id", t), s !== void 0 && u.append("parentId", s), d["Content-Type"] = "multipart/form-data", Z(i, c);
      let m = o && o.headers ? o.headers : {};
      return l.headers = { ...d, ...m, ...n.headers }, l.data = u, {
        url: J(i),
        options: l
      };
    }
  };
}, M6 = function(e) {
  const t = B6(e);
  return {
    /**
     * 
     * @summary Add a client and optionally send a invite email.
     * @param {AddClientModel} [addClientModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async addClient(s, n) {
      var l, d;
      const r = await t.addClient(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["IDXClientsApi.addClient"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    },
    /**
     * 
     * @summary List investment gateway clients associated with agent.
     * @param {number} [page] Current page of clients to return.
     * @param {number} [pageSize] Total clients per page.
     * @param {ClientRelationshipType} [type] Filter client\&#39;s by relationship type
     * @param {ClientRelationshipSort} [sort] 
     * @param {SortDirection} [sortDirection] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getClients(s, n, r, i, o, l) {
      var m, f;
      const d = await t.getClients(s, n, r, i, o, l), c = (e == null ? void 0 : e.serverIndex) ?? 0, u = (f = (m = Q["IDXClientsApi.getClients"]) == null ? void 0 : m[c]) == null ? void 0 : f.url;
      return (v, b) => _(d, X, G, e)(v, u || b);
    },
    /**
     * 
     * @summary Send a existing client an invite email.
     * @param {InviteClientModel} [inviteClientModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async sendClientInvite(s, n) {
      var l, d;
      const r = await t.sendClientInvite(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["IDXClientsApi.sendClientInvite"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    },
    /**
     * 
     * @summary Remove client link to agent account.
     * @param {number} [id] 
     * @param {number} [parentId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async unlinkClient(s, n, r) {
      var d, c;
      const i = await t.unlinkClient(s, n, r), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (c = (d = Q["IDXClientsApi.unlinkClient"]) == null ? void 0 : d[o]) == null ? void 0 : c.url;
      return (u, m) => _(i, X, G, e)(u, l || m);
    }
  };
}, x6 = function(e, t, s) {
  const n = M6(e);
  return {
    /**
     * 
     * @summary Add a client and optionally send a invite email.
     * @param {AddClientModel} [addClientModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addClient(r, i) {
      return n.addClient(r, i).then((o) => o(s, t));
    },
    /**
     * 
     * @summary List investment gateway clients associated with agent.
     * @param {number} [page] Current page of clients to return.
     * @param {number} [pageSize] Total clients per page.
     * @param {ClientRelationshipType} [type] Filter client\&#39;s by relationship type
     * @param {ClientRelationshipSort} [sort] 
     * @param {SortDirection} [sortDirection] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getClients(r, i, o, l, d, c) {
      return n.getClients(r, i, o, l, d, c).then((u) => u(s, t));
    },
    /**
     * 
     * @summary Send a existing client an invite email.
     * @param {InviteClientModel} [inviteClientModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sendClientInvite(r, i) {
      return n.sendClientInvite(r, i).then((o) => o(s, t));
    },
    /**
     * 
     * @summary Remove client link to agent account.
     * @param {number} [id] 
     * @param {number} [parentId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    unlinkClient(r, i, o) {
      return n.unlinkClient(r, i, o).then((l) => l(s, t));
    }
  };
}, F6 = function(e) {
  return {
    /**
     * 
     * @summary Get list of images for property that user has access to.
     * @param {number} propId 
     * @param {boolean} [refresh] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getImages: async (t, s, n = {}) => {
      se("getImages", "propId", t);
      const r = "/property/{propId}/images".replace("{propId}", encodeURIComponent(String(t))), i = new URL(r, K);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "GET", ...o, ...n }, d = {}, c = {};
      await Lt(d, "x-api-key", e), await ee(d, e), s !== void 0 && (c.refresh = s), Z(i, c);
      let u = o && o.headers ? o.headers : {};
      return l.headers = { ...d, ...u, ...n.headers }, {
        url: J(i),
        options: l
      };
    },
    /**
     * 
     * @summary Get list of images for property that user has access to.
     * @param {string} mlsSource 
     * @param {string} mlsNumber 
     * @param {boolean} [refresh] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getImagesByMls: async (t, s, n, r = {}) => {
      se("getImagesByMls", "mlsSource", t), se("getImagesByMls", "mlsNumber", s);
      const i = "/mls/{mlsSource}/{mlsNumber}/images".replace("{mlsSource}", encodeURIComponent(String(t))).replace("{mlsNumber}", encodeURIComponent(String(s))), o = new URL(i, K);
      let l;
      e && (l = e.baseOptions);
      const d = { method: "GET", ...l, ...r }, c = {}, u = {};
      await Lt(c, "x-api-key", e), await ee(c, e), n !== void 0 && (u.refresh = n), Z(o, u);
      let m = l && l.headers ? l.headers : {};
      return d.headers = { ...c, ...m, ...r.headers }, {
        url: J(o),
        options: d
      };
    }
  };
}, V6 = function(e) {
  const t = F6(e);
  return {
    /**
     * 
     * @summary Get list of images for property that user has access to.
     * @param {number} propId 
     * @param {boolean} [refresh] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getImages(s, n, r) {
      var d, c;
      const i = await t.getImages(s, n, r), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (c = (d = Q["ImagesApi.getImages"]) == null ? void 0 : d[o]) == null ? void 0 : c.url;
      return (u, m) => _(i, X, G, e)(u, l || m);
    },
    /**
     * 
     * @summary Get list of images for property that user has access to.
     * @param {string} mlsSource 
     * @param {string} mlsNumber 
     * @param {boolean} [refresh] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getImagesByMls(s, n, r, i) {
      var c, u;
      const o = await t.getImagesByMls(s, n, r, i), l = (e == null ? void 0 : e.serverIndex) ?? 0, d = (u = (c = Q["ImagesApi.getImagesByMls"]) == null ? void 0 : c[l]) == null ? void 0 : u.url;
      return (m, f) => _(o, X, G, e)(m, d || f);
    }
  };
}, D6 = function(e, t, s) {
  const n = V6(e);
  return {
    /**
     * 
     * @summary Get list of images for property that user has access to.
     * @param {number} propId 
     * @param {boolean} [refresh] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getImages(r, i, o) {
      return n.getImages(r, i, o).then((l) => l(s, t));
    },
    /**
     * 
     * @summary Get list of images for property that user has access to.
     * @param {string} mlsSource 
     * @param {string} mlsNumber 
     * @param {boolean} [refresh] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getImagesByMls(r, i, o, l) {
      return n.getImagesByMls(r, i, o, l).then((d) => d(s, t));
    }
  };
}, N6 = function(e) {
  return {
    /**
     * 
     * @param {AddIncomeExpenseAccount} [addIncomeExpenseAccount] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addAccount: async (t, s = {}) => {
      const n = "/account/income-expense-accounts", r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "POST", ...i, ...s }, l = {}, d = {};
      await ee(l, e), l["Content-Type"] = "application/json", Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, o.data = kt(t, o, e), {
        url: J(r),
        options: o
      };
    },
    /**
     * 
     * @param {number} accountId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteAccount: async (t, s = {}) => {
      se("deleteAccount", "accountId", t);
      const n = "/account/income-expense-accounts/{accountId}".replace("{accountId}", encodeURIComponent(String(t))), r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "DELETE", ...i, ...s }, l = {}, d = {};
      await ee(l, e), Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, {
        url: J(r),
        options: o
      };
    },
    /**
     * 
     * @param {IncomeOrExpenseType} type 
     * @param {string} name 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    disableConventional: async (t, s, n = {}) => {
      se("disableConventional", "type", t), se("disableConventional", "name", s);
      const r = "/account/income-expense-accounts/{type}/{name}/conventional".replace("{type}", encodeURIComponent(String(t))).replace("{name}", encodeURIComponent(String(s))), i = new URL(r, K);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "DELETE", ...o, ...n }, d = {}, c = {};
      await ee(d, e), Z(i, c);
      let u = o && o.headers ? o.headers : {};
      return l.headers = { ...d, ...u, ...n.headers }, {
        url: J(i),
        options: l
      };
    },
    /**
     * 
     * @param {IncomeOrExpenseType} type 
     * @param {string} name 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    disableShortTerm: async (t, s, n = {}) => {
      se("disableShortTerm", "type", t), se("disableShortTerm", "name", s);
      const r = "/account/income-expense-accounts/{type}/{name}/short-term".replace("{type}", encodeURIComponent(String(t))).replace("{name}", encodeURIComponent(String(s))), i = new URL(r, K);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "DELETE", ...o, ...n }, d = {}, c = {};
      await ee(d, e), Z(i, c);
      let u = o && o.headers ? o.headers : {};
      return l.headers = { ...d, ...u, ...n.headers }, {
        url: J(i),
        options: l
      };
    },
    /**
     * 
     * @param {number} accountId 
     * @param {AddIncomeExpenseAccount} [addIncomeExpenseAccount] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    editAccount: async (t, s, n = {}) => {
      se("editAccount", "accountId", t);
      const r = "/account/income-expense-accounts/{accountId}".replace("{accountId}", encodeURIComponent(String(t))), i = new URL(r, K);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "POST", ...o, ...n }, d = {}, c = {};
      await ee(d, e), d["Content-Type"] = "application/json", Z(i, c);
      let u = o && o.headers ? o.headers : {};
      return l.headers = { ...d, ...u, ...n.headers }, l.data = kt(s, l, e), {
        url: J(i),
        options: l
      };
    },
    /**
     * 
     * @param {IncomeOrExpenseType} type 
     * @param {string} name 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    enableConventional: async (t, s, n = {}) => {
      se("enableConventional", "type", t), se("enableConventional", "name", s);
      const r = "/account/income-expense-accounts/{type}/{name}/conventional".replace("{type}", encodeURIComponent(String(t))).replace("{name}", encodeURIComponent(String(s))), i = new URL(r, K);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "POST", ...o, ...n }, d = {}, c = {};
      await ee(d, e), Z(i, c);
      let u = o && o.headers ? o.headers : {};
      return l.headers = { ...d, ...u, ...n.headers }, {
        url: J(i),
        options: l
      };
    },
    /**
     * 
     * @param {IncomeOrExpenseType} type 
     * @param {string} name 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    enableShortTerm: async (t, s, n = {}) => {
      se("enableShortTerm", "type", t), se("enableShortTerm", "name", s);
      const r = "/account/income-expense-accounts/{type}/{name}/short-term".replace("{type}", encodeURIComponent(String(t))).replace("{name}", encodeURIComponent(String(s))), i = new URL(r, K);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "POST", ...o, ...n }, d = {}, c = {};
      await ee(d, e), Z(i, c);
      let u = o && o.headers ? o.headers : {};
      return l.headers = { ...d, ...u, ...n.headers }, {
        url: J(i),
        options: l
      };
    },
    /**
     * 
     * @summary Get current user\'s account settings.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAccounts: async (t = {}) => {
      const s = "/account/income-expense-accounts", n = new URL(s, K);
      let r;
      e && (r = e.baseOptions);
      const i = { method: "GET", ...r, ...t }, o = {}, l = {};
      await Lt(o, "x-api-key", e), await ee(o, e), Z(n, l);
      let d = r && r.headers ? r.headers : {};
      return i.headers = { ...o, ...d, ...t.headers }, {
        url: J(n),
        options: i
      };
    },
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getGlAccounts: async (t = {}) => {
      const s = "/account/income-expense-accounts/gl-accounts", n = new URL(s, K);
      let r;
      e && (r = e.baseOptions);
      const i = { method: "GET", ...r, ...t }, o = {}, l = {};
      await ee(o, e), Z(n, l);
      let d = r && r.headers ? r.headers : {};
      return i.headers = { ...o, ...d, ...t.headers }, {
        url: J(n),
        options: i
      };
    },
    /**
     * 
     * @param {number} glAccountId 
     * @param {number} [incomeExpenseId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    mapGlAccount: async (t, s, n = {}) => {
      se("mapGlAccount", "glAccountId", t);
      const r = "/account/income-expense-accounts/gl-accounts/{glAccountId}".replace("{glAccountId}", encodeURIComponent(String(t))), i = new URL(r, K);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "PATCH", ...o, ...n }, d = {}, c = {};
      await ee(d, e), s !== void 0 && (c.incomeExpenseId = s), Z(i, c);
      let u = o && o.headers ? o.headers : {};
      return l.headers = { ...d, ...u, ...n.headers }, {
        url: J(i),
        options: l
      };
    },
    /**
     * 
     * @param {IncomeOrExpenseType} type 
     * @param {string} accountName 
     * @param {number} glAccountId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    mapGlAccountAsNew: async (t, s, n, r = {}) => {
      se("mapGlAccountAsNew", "type", t), se("mapGlAccountAsNew", "accountName", s), se("mapGlAccountAsNew", "glAccountId", n);
      const i = "/account/income-expense-accounts/gl-accounts/{type}/{accountName}/{glAccountId}".replace("{type}", encodeURIComponent(String(t))).replace("{accountName}", encodeURIComponent(String(s))).replace("{glAccountId}", encodeURIComponent(String(n))), o = new URL(i, K);
      let l;
      e && (l = e.baseOptions);
      const d = { method: "PATCH", ...l, ...r }, c = {}, u = {};
      await ee(c, e), Z(o, u);
      let m = l && l.headers ? l.headers : {};
      return d.headers = { ...c, ...m, ...r.headers }, {
        url: J(o),
        options: d
      };
    },
    /**
     * 
     * @summary Sync current user\'s GL accounts from remote system.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    syncGlAccounts: async (t = {}) => {
      const s = "/account/income-expense-accounts/gl-accounts/sync", n = new URL(s, K);
      let r;
      e && (r = e.baseOptions);
      const i = { method: "POST", ...r, ...t }, o = {}, l = {};
      await ee(o, e), Z(n, l);
      let d = r && r.headers ? r.headers : {};
      return i.headers = { ...o, ...d, ...t.headers }, {
        url: J(n),
        options: i
      };
    }
  };
}, j6 = function(e) {
  const t = N6(e);
  return {
    /**
     * 
     * @param {AddIncomeExpenseAccount} [addIncomeExpenseAccount] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async addAccount(s, n) {
      var l, d;
      const r = await t.addAccount(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["IncomeExpenseAccountsApi.addAccount"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    },
    /**
     * 
     * @param {number} accountId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deleteAccount(s, n) {
      var l, d;
      const r = await t.deleteAccount(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["IncomeExpenseAccountsApi.deleteAccount"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    },
    /**
     * 
     * @param {IncomeOrExpenseType} type 
     * @param {string} name 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async disableConventional(s, n, r) {
      var d, c;
      const i = await t.disableConventional(s, n, r), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (c = (d = Q["IncomeExpenseAccountsApi.disableConventional"]) == null ? void 0 : d[o]) == null ? void 0 : c.url;
      return (u, m) => _(i, X, G, e)(u, l || m);
    },
    /**
     * 
     * @param {IncomeOrExpenseType} type 
     * @param {string} name 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async disableShortTerm(s, n, r) {
      var d, c;
      const i = await t.disableShortTerm(s, n, r), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (c = (d = Q["IncomeExpenseAccountsApi.disableShortTerm"]) == null ? void 0 : d[o]) == null ? void 0 : c.url;
      return (u, m) => _(i, X, G, e)(u, l || m);
    },
    /**
     * 
     * @param {number} accountId 
     * @param {AddIncomeExpenseAccount} [addIncomeExpenseAccount] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async editAccount(s, n, r) {
      var d, c;
      const i = await t.editAccount(s, n, r), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (c = (d = Q["IncomeExpenseAccountsApi.editAccount"]) == null ? void 0 : d[o]) == null ? void 0 : c.url;
      return (u, m) => _(i, X, G, e)(u, l || m);
    },
    /**
     * 
     * @param {IncomeOrExpenseType} type 
     * @param {string} name 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async enableConventional(s, n, r) {
      var d, c;
      const i = await t.enableConventional(s, n, r), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (c = (d = Q["IncomeExpenseAccountsApi.enableConventional"]) == null ? void 0 : d[o]) == null ? void 0 : c.url;
      return (u, m) => _(i, X, G, e)(u, l || m);
    },
    /**
     * 
     * @param {IncomeOrExpenseType} type 
     * @param {string} name 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async enableShortTerm(s, n, r) {
      var d, c;
      const i = await t.enableShortTerm(s, n, r), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (c = (d = Q["IncomeExpenseAccountsApi.enableShortTerm"]) == null ? void 0 : d[o]) == null ? void 0 : c.url;
      return (u, m) => _(i, X, G, e)(u, l || m);
    },
    /**
     * 
     * @summary Get current user\'s account settings.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getAccounts(s) {
      var o, l;
      const n = await t.getAccounts(s), r = (e == null ? void 0 : e.serverIndex) ?? 0, i = (l = (o = Q["IncomeExpenseAccountsApi.getAccounts"]) == null ? void 0 : o[r]) == null ? void 0 : l.url;
      return (d, c) => _(n, X, G, e)(d, i || c);
    },
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getGlAccounts(s) {
      var o, l;
      const n = await t.getGlAccounts(s), r = (e == null ? void 0 : e.serverIndex) ?? 0, i = (l = (o = Q["IncomeExpenseAccountsApi.getGlAccounts"]) == null ? void 0 : o[r]) == null ? void 0 : l.url;
      return (d, c) => _(n, X, G, e)(d, i || c);
    },
    /**
     * 
     * @param {number} glAccountId 
     * @param {number} [incomeExpenseId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async mapGlAccount(s, n, r) {
      var d, c;
      const i = await t.mapGlAccount(s, n, r), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (c = (d = Q["IncomeExpenseAccountsApi.mapGlAccount"]) == null ? void 0 : d[o]) == null ? void 0 : c.url;
      return (u, m) => _(i, X, G, e)(u, l || m);
    },
    /**
     * 
     * @param {IncomeOrExpenseType} type 
     * @param {string} accountName 
     * @param {number} glAccountId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async mapGlAccountAsNew(s, n, r, i) {
      var c, u;
      const o = await t.mapGlAccountAsNew(s, n, r, i), l = (e == null ? void 0 : e.serverIndex) ?? 0, d = (u = (c = Q["IncomeExpenseAccountsApi.mapGlAccountAsNew"]) == null ? void 0 : c[l]) == null ? void 0 : u.url;
      return (m, f) => _(o, X, G, e)(m, d || f);
    },
    /**
     * 
     * @summary Sync current user\'s GL accounts from remote system.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async syncGlAccounts(s) {
      var o, l;
      const n = await t.syncGlAccounts(s), r = (e == null ? void 0 : e.serverIndex) ?? 0, i = (l = (o = Q["IncomeExpenseAccountsApi.syncGlAccounts"]) == null ? void 0 : o[r]) == null ? void 0 : l.url;
      return (d, c) => _(n, X, G, e)(d, i || c);
    }
  };
}, H6 = function(e, t, s) {
  const n = j6(e);
  return {
    /**
     * 
     * @param {AddIncomeExpenseAccount} [addIncomeExpenseAccount] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addAccount(r, i) {
      return n.addAccount(r, i).then((o) => o(s, t));
    },
    /**
     * 
     * @param {number} accountId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteAccount(r, i) {
      return n.deleteAccount(r, i).then((o) => o(s, t));
    },
    /**
     * 
     * @param {IncomeOrExpenseType} type 
     * @param {string} name 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    disableConventional(r, i, o) {
      return n.disableConventional(r, i, o).then((l) => l(s, t));
    },
    /**
     * 
     * @param {IncomeOrExpenseType} type 
     * @param {string} name 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    disableShortTerm(r, i, o) {
      return n.disableShortTerm(r, i, o).then((l) => l(s, t));
    },
    /**
     * 
     * @param {number} accountId 
     * @param {AddIncomeExpenseAccount} [addIncomeExpenseAccount] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    editAccount(r, i, o) {
      return n.editAccount(r, i, o).then((l) => l(s, t));
    },
    /**
     * 
     * @param {IncomeOrExpenseType} type 
     * @param {string} name 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    enableConventional(r, i, o) {
      return n.enableConventional(r, i, o).then((l) => l(s, t));
    },
    /**
     * 
     * @param {IncomeOrExpenseType} type 
     * @param {string} name 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    enableShortTerm(r, i, o) {
      return n.enableShortTerm(r, i, o).then((l) => l(s, t));
    },
    /**
     * 
     * @summary Get current user\'s account settings.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAccounts(r) {
      return n.getAccounts(r).then((i) => i(s, t));
    },
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getGlAccounts(r) {
      return n.getGlAccounts(r).then((i) => i(s, t));
    },
    /**
     * 
     * @param {number} glAccountId 
     * @param {number} [incomeExpenseId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    mapGlAccount(r, i, o) {
      return n.mapGlAccount(r, i, o).then((l) => l(s, t));
    },
    /**
     * 
     * @param {IncomeOrExpenseType} type 
     * @param {string} accountName 
     * @param {number} glAccountId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    mapGlAccountAsNew(r, i, o, l) {
      return n.mapGlAccountAsNew(r, i, o, l).then((d) => d(s, t));
    },
    /**
     * 
     * @summary Sync current user\'s GL accounts from remote system.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    syncGlAccounts(r) {
      return n.syncGlAccounts(r).then((i) => i(s, t));
    }
  };
}, U6 = function(e) {
  return {
    /**
     * 
     * @summary Add owner paid expense to GL account
     * @param {number} propId Property Id
     * @param {string} expenseAccount Expense account
     * @param {AddExpenseEntryModel} [addExpenseEntryModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addEntry: async (t, s, n, r = {}) => {
      se("addEntry", "propId", t), se("addEntry", "expenseAccount", s);
      const i = "/property/{propId}/ledger/{expenseAccount}/expense".replace("{propId}", encodeURIComponent(String(t))).replace("{expenseAccount}", encodeURIComponent(String(s))), o = new URL(i, K);
      let l;
      e && (l = e.baseOptions);
      const d = { method: "POST", ...l, ...r }, c = {}, u = {};
      await ee(c, e), c["Content-Type"] = "application/json", Z(o, u);
      let m = l && l.headers ? l.headers : {};
      return d.headers = { ...c, ...m, ...r.headers }, d.data = kt(n, d, e), {
        url: J(o),
        options: d
      };
    },
    /**
     * 
     * @summary Confirm expense entry in GL account
     * @param {number} propId Property Id
     * @param {string} expenseAccount Expense account
     * @param {number} entryId Unique entry Id
     * @param {UpdateExpenseEntryModel} [updateExpenseEntryModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    confirmEntry: async (t, s, n, r, i = {}) => {
      se("confirmEntry", "propId", t), se("confirmEntry", "expenseAccount", s), se("confirmEntry", "entryId", n);
      const o = "/property/{propId}/ledger/{expenseAccount}/expense/{entryId}/confirm".replace("{propId}", encodeURIComponent(String(t))).replace("{expenseAccount}", encodeURIComponent(String(s))).replace("{entryId}", encodeURIComponent(String(n))), l = new URL(o, K);
      let d;
      e && (d = e.baseOptions);
      const c = { method: "POST", ...d, ...i }, u = {}, m = {};
      await ee(u, e), u["Content-Type"] = "application/json", Z(l, m);
      let f = d && d.headers ? d.headers : {};
      return c.headers = { ...u, ...f, ...i.headers }, c.data = kt(r, c, e), {
        url: J(l),
        options: c
      };
    },
    /**
     * 
     * @summary Confirm mortgage details for loan entries. (Marks all loan entries as confirmed by owner)
     * @param {number} propId Property Id
     * @param {Date} loanDate Start date of loan
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    confirmMortgage: async (t, s, n = {}) => {
      se("confirmMortgage", "propId", t), se("confirmMortgage", "loanDate", s);
      const r = "/property/{propId}/ledger/mortgage/confirm".replace("{propId}", encodeURIComponent(String(t))), i = new URL(r, K);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "POST", ...o, ...n }, d = {}, c = {};
      await ee(d, e), s !== void 0 && (c.loanDate = s instanceof Date ? s.toISOString().substring(0, 10) : s), Z(i, c);
      let u = o && o.headers ? o.headers : {};
      return l.headers = { ...d, ...u, ...n.headers }, {
        url: J(i),
        options: l
      };
    },
    /**
     * 
     * @summary Update expense entry in GL account
     * @param {number} propId Property Id
     * @param {string} expenseAccount Expense account
     * @param {number} entryId Unique entry Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteEntry: async (t, s, n, r = {}) => {
      se("deleteEntry", "propId", t), se("deleteEntry", "expenseAccount", s), se("deleteEntry", "entryId", n);
      const i = "/property/{propId}/ledger/{expenseAccount}/expense/{entryId}".replace("{propId}", encodeURIComponent(String(t))).replace("{expenseAccount}", encodeURIComponent(String(s))).replace("{entryId}", encodeURIComponent(String(n))), o = new URL(i, K);
      let l;
      e && (l = e.baseOptions);
      const d = { method: "DELETE", ...l, ...r }, c = {}, u = {};
      await ee(c, e), Z(o, u);
      let m = l && l.headers ? l.headers : {};
      return d.headers = { ...c, ...m, ...r.headers }, {
        url: J(o),
        options: d
      };
    },
    /**
     * 
     * @summary List GL ledger entries for property
     * @param {number} propId Property Id
     * @param {GLEntryTypes} [entryTypes] Return only owner paid entries, synced, or all
     * @param {boolean} [expense] True for expense entries, false for income entries
     * @param {number} [page] Page of listings to retrieve
     * @param {number} [pageSize] Page record size
     * @param {boolean} [ilp] Include loan payment entries
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getEntries: async (t, s, n, r, i, o, l = {}) => {
      se("getEntries", "propId", t);
      const d = "/property/{propId}/ledger".replace("{propId}", encodeURIComponent(String(t))), c = new URL(d, K);
      let u;
      e && (u = e.baseOptions);
      const m = { method: "GET", ...u, ...l }, f = {}, v = {};
      await ee(f, e), s !== void 0 && (v.entryTypes = s), n !== void 0 && (v.expense = n), r !== void 0 && (v.page = r), i !== void 0 && (v.pageSize = i), o !== void 0 && (v.ilp = o), Z(c, v);
      let b = u && u.headers ? u.headers : {};
      return m.headers = { ...f, ...b, ...l.headers }, {
        url: J(c),
        options: m
      };
    },
    /**
     * 
     * @param {number} propId 
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getLedgerEntries: async (t, s, n, r = {}) => {
      se("getLedgerEntries", "propId", t);
      const i = "/property/{propId}/ledger/list".replace("{propId}", encodeURIComponent(String(t))), o = new URL(i, K);
      let l;
      e && (l = e.baseOptions);
      const d = { method: "GET", ...l, ...r }, c = {}, u = {};
      await ee(c, e), s !== void 0 && (u.page = s), n !== void 0 && (u.pageSize = n), Z(o, u);
      let m = l && l.headers ? l.headers : {};
      return d.headers = { ...c, ...m, ...r.headers }, {
        url: J(o),
        options: d
      };
    },
    /**
     * 
     * @summary Remove confirmation of mortgage details for loan entries. (Removes confirmation of all loan entries)
     * @param {number} propId Property Id
     * @param {Date} loanDate Start date of loan
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    unconfirmMortgage: async (t, s, n = {}) => {
      se("unconfirmMortgage", "propId", t), se("unconfirmMortgage", "loanDate", s);
      const r = "/property/{propId}/ledger/mortgage/confirm".replace("{propId}", encodeURIComponent(String(t))), i = new URL(r, K);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "DELETE", ...o, ...n }, d = {}, c = {};
      await ee(d, e), s !== void 0 && (c.loanDate = s instanceof Date ? s.toISOString().substring(0, 10) : s), Z(i, c);
      let u = o && o.headers ? o.headers : {};
      return l.headers = { ...d, ...u, ...n.headers }, {
        url: J(i),
        options: l
      };
    },
    /**
     * 
     * @summary Update expense entry in GL account
     * @param {number} propId Property Id
     * @param {string} expenseAccount Expense account
     * @param {number} entryId Unique entry Id
     * @param {UpdateExpenseEntryModel} [updateExpenseEntryModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateEntry: async (t, s, n, r, i = {}) => {
      se("updateEntry", "propId", t), se("updateEntry", "expenseAccount", s), se("updateEntry", "entryId", n);
      const o = "/property/{propId}/ledger/{expenseAccount}/expense/{entryId}".replace("{propId}", encodeURIComponent(String(t))).replace("{expenseAccount}", encodeURIComponent(String(s))).replace("{entryId}", encodeURIComponent(String(n))), l = new URL(o, K);
      let d;
      e && (d = e.baseOptions);
      const c = { method: "PATCH", ...d, ...i }, u = {}, m = {};
      await ee(u, e), u["Content-Type"] = "application/json", Z(l, m);
      let f = d && d.headers ? d.headers : {};
      return c.headers = { ...u, ...f, ...i.headers }, c.data = kt(r, c, e), {
        url: J(l),
        options: c
      };
    }
  };
}, z6 = function(e) {
  const t = U6(e);
  return {
    /**
     * 
     * @summary Add owner paid expense to GL account
     * @param {number} propId Property Id
     * @param {string} expenseAccount Expense account
     * @param {AddExpenseEntryModel} [addExpenseEntryModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async addEntry(s, n, r, i) {
      var c, u;
      const o = await t.addEntry(s, n, r, i), l = (e == null ? void 0 : e.serverIndex) ?? 0, d = (u = (c = Q["LedgerApi.addEntry"]) == null ? void 0 : c[l]) == null ? void 0 : u.url;
      return (m, f) => _(o, X, G, e)(m, d || f);
    },
    /**
     * 
     * @summary Confirm expense entry in GL account
     * @param {number} propId Property Id
     * @param {string} expenseAccount Expense account
     * @param {number} entryId Unique entry Id
     * @param {UpdateExpenseEntryModel} [updateExpenseEntryModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async confirmEntry(s, n, r, i, o) {
      var u, m;
      const l = await t.confirmEntry(s, n, r, i, o), d = (e == null ? void 0 : e.serverIndex) ?? 0, c = (m = (u = Q["LedgerApi.confirmEntry"]) == null ? void 0 : u[d]) == null ? void 0 : m.url;
      return (f, v) => _(l, X, G, e)(f, c || v);
    },
    /**
     * 
     * @summary Confirm mortgage details for loan entries. (Marks all loan entries as confirmed by owner)
     * @param {number} propId Property Id
     * @param {Date} loanDate Start date of loan
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async confirmMortgage(s, n, r) {
      var d, c;
      const i = await t.confirmMortgage(s, n, r), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (c = (d = Q["LedgerApi.confirmMortgage"]) == null ? void 0 : d[o]) == null ? void 0 : c.url;
      return (u, m) => _(i, X, G, e)(u, l || m);
    },
    /**
     * 
     * @summary Update expense entry in GL account
     * @param {number} propId Property Id
     * @param {string} expenseAccount Expense account
     * @param {number} entryId Unique entry Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deleteEntry(s, n, r, i) {
      var c, u;
      const o = await t.deleteEntry(s, n, r, i), l = (e == null ? void 0 : e.serverIndex) ?? 0, d = (u = (c = Q["LedgerApi.deleteEntry"]) == null ? void 0 : c[l]) == null ? void 0 : u.url;
      return (m, f) => _(o, X, G, e)(m, d || f);
    },
    /**
     * 
     * @summary List GL ledger entries for property
     * @param {number} propId Property Id
     * @param {GLEntryTypes} [entryTypes] Return only owner paid entries, synced, or all
     * @param {boolean} [expense] True for expense entries, false for income entries
     * @param {number} [page] Page of listings to retrieve
     * @param {number} [pageSize] Page record size
     * @param {boolean} [ilp] Include loan payment entries
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getEntries(s, n, r, i, o, l, d) {
      var f, v;
      const c = await t.getEntries(s, n, r, i, o, l, d), u = (e == null ? void 0 : e.serverIndex) ?? 0, m = (v = (f = Q["LedgerApi.getEntries"]) == null ? void 0 : f[u]) == null ? void 0 : v.url;
      return (b, w) => _(c, X, G, e)(b, m || w);
    },
    /**
     * 
     * @param {number} propId 
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getLedgerEntries(s, n, r, i) {
      var c, u;
      const o = await t.getLedgerEntries(s, n, r, i), l = (e == null ? void 0 : e.serverIndex) ?? 0, d = (u = (c = Q["LedgerApi.getLedgerEntries"]) == null ? void 0 : c[l]) == null ? void 0 : u.url;
      return (m, f) => _(o, X, G, e)(m, d || f);
    },
    /**
     * 
     * @summary Remove confirmation of mortgage details for loan entries. (Removes confirmation of all loan entries)
     * @param {number} propId Property Id
     * @param {Date} loanDate Start date of loan
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async unconfirmMortgage(s, n, r) {
      var d, c;
      const i = await t.unconfirmMortgage(s, n, r), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (c = (d = Q["LedgerApi.unconfirmMortgage"]) == null ? void 0 : d[o]) == null ? void 0 : c.url;
      return (u, m) => _(i, X, G, e)(u, l || m);
    },
    /**
     * 
     * @summary Update expense entry in GL account
     * @param {number} propId Property Id
     * @param {string} expenseAccount Expense account
     * @param {number} entryId Unique entry Id
     * @param {UpdateExpenseEntryModel} [updateExpenseEntryModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateEntry(s, n, r, i, o) {
      var u, m;
      const l = await t.updateEntry(s, n, r, i, o), d = (e == null ? void 0 : e.serverIndex) ?? 0, c = (m = (u = Q["LedgerApi.updateEntry"]) == null ? void 0 : u[d]) == null ? void 0 : m.url;
      return (f, v) => _(l, X, G, e)(f, c || v);
    }
  };
}, W6 = function(e, t, s) {
  const n = z6(e);
  return {
    /**
     * 
     * @summary Add owner paid expense to GL account
     * @param {number} propId Property Id
     * @param {string} expenseAccount Expense account
     * @param {AddExpenseEntryModel} [addExpenseEntryModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addEntry(r, i, o, l) {
      return n.addEntry(r, i, o, l).then((d) => d(s, t));
    },
    /**
     * 
     * @summary Confirm expense entry in GL account
     * @param {number} propId Property Id
     * @param {string} expenseAccount Expense account
     * @param {number} entryId Unique entry Id
     * @param {UpdateExpenseEntryModel} [updateExpenseEntryModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    confirmEntry(r, i, o, l, d) {
      return n.confirmEntry(r, i, o, l, d).then((c) => c(s, t));
    },
    /**
     * 
     * @summary Confirm mortgage details for loan entries. (Marks all loan entries as confirmed by owner)
     * @param {number} propId Property Id
     * @param {Date} loanDate Start date of loan
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    confirmMortgage(r, i, o) {
      return n.confirmMortgage(r, i, o).then((l) => l(s, t));
    },
    /**
     * 
     * @summary Update expense entry in GL account
     * @param {number} propId Property Id
     * @param {string} expenseAccount Expense account
     * @param {number} entryId Unique entry Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteEntry(r, i, o, l) {
      return n.deleteEntry(r, i, o, l).then((d) => d(s, t));
    },
    /**
     * 
     * @summary List GL ledger entries for property
     * @param {number} propId Property Id
     * @param {GLEntryTypes} [entryTypes] Return only owner paid entries, synced, or all
     * @param {boolean} [expense] True for expense entries, false for income entries
     * @param {number} [page] Page of listings to retrieve
     * @param {number} [pageSize] Page record size
     * @param {boolean} [ilp] Include loan payment entries
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getEntries(r, i, o, l, d, c, u) {
      return n.getEntries(r, i, o, l, d, c, u).then((m) => m(s, t));
    },
    /**
     * 
     * @param {number} propId 
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getLedgerEntries(r, i, o, l) {
      return n.getLedgerEntries(r, i, o, l).then((d) => d(s, t));
    },
    /**
     * 
     * @summary Remove confirmation of mortgage details for loan entries. (Removes confirmation of all loan entries)
     * @param {number} propId Property Id
     * @param {Date} loanDate Start date of loan
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    unconfirmMortgage(r, i, o) {
      return n.unconfirmMortgage(r, i, o).then((l) => l(s, t));
    },
    /**
     * 
     * @summary Update expense entry in GL account
     * @param {number} propId Property Id
     * @param {string} expenseAccount Expense account
     * @param {number} entryId Unique entry Id
     * @param {UpdateExpenseEntryModel} [updateExpenseEntryModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateEntry(r, i, o, l, d) {
      return n.updateEntry(r, i, o, l, d).then((c) => c(s, t));
    }
  };
}, G6 = function(e) {
  return {
    /**
     * 
     * @summary 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getReport: async (t = {}) => {
      const s = "/account/licensing/report", n = new URL(s, K);
      let r;
      e && (r = e.baseOptions);
      const i = { method: "GET", ...r, ...t }, o = {}, l = {};
      await ee(o, e), Z(n, l);
      let d = r && r.headers ? r.headers : {};
      return i.headers = { ...o, ...d, ...t.headers }, {
        url: J(n),
        options: i
      };
    }
  };
}, Y6 = function(e) {
  const t = G6(e);
  return {
    /**
     * 
     * @summary 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getReport(s) {
      var o, l;
      const n = await t.getReport(s), r = (e == null ? void 0 : e.serverIndex) ?? 0, i = (l = (o = Q["LicensingApi.getReport"]) == null ? void 0 : o[r]) == null ? void 0 : l.url;
      return (d, c) => _(n, X, G, e)(d, i || c);
    }
  };
};
class X6 extends Fn {
  /**
   * 
   * @summary 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof LicensingApi
   */
  getReport(t) {
    return Y6(this.configuration).getReport(t).then((s) => s(this.axios, this.basePath));
  }
}
const q6 = function(e) {
  return {
    /**
     * 
     * @summary Calculate MLS listings for search results.
     * @param {CalculateRequestModel} calculateRequestModel 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    calculate: async (t, s = {}) => {
      se("calculate", "calculateRequestModel", t);
      const n = "/mls/calculate", r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "POST", ...i, ...s }, l = {}, d = {};
      await ee(l, e), l["Content-Type"] = "application/json", Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, o.data = kt(t, o, e), {
        url: J(r),
        options: o
      };
    },
    /**
     * 
     * @summary Retrieve MLS available coverage.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    coverage: async (t = {}) => {
      const s = "/mls/coverage", n = new URL(s, K);
      let r;
      e && (r = e.baseOptions);
      const i = { method: "GET", ...r, ...t }, o = {}, l = {};
      await ee(o, e), Z(n, l);
      let d = r && r.headers ? r.headers : {};
      return i.headers = { ...o, ...d, ...t.headers }, {
        url: J(n),
        options: i
      };
    },
    /**
     * 
     * @summary List weekly featured listings.
     * @param {number} [m] Max listings to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    featured: async (t, s = {}) => {
      const n = "/mls/featured", r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "GET", ...i, ...s }, l = {}, d = {};
      await ee(l, e), t !== void 0 && (d.m = t), Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, {
        url: J(r),
        options: o
      };
    },
    /**
     * 
     * @summary Returns property files used from last MLS listing.
     * @param {string} mlsSource 
     * @param {string} mlsNumber 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getListingFiles: async (t, s, n = {}) => {
      se("getListingFiles", "mlsSource", t), se("getListingFiles", "mlsNumber", s);
      const r = "/mls/{mlsSource}/{mlsNumber}/files".replace("{mlsSource}", encodeURIComponent(String(t))).replace("{mlsNumber}", encodeURIComponent(String(s))), i = new URL(r, K);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "GET", ...o, ...n }, d = {}, c = {};
      await Lt(d, "x-api-key", e), await ee(d, e), Z(i, c);
      let u = o && o.headers ? o.headers : {};
      return l.headers = { ...d, ...u, ...n.headers }, {
        url: J(i),
        options: l
      };
    },
    /**
     * 
     * @summary Retrieve the history of a property\'s active MLS listing.
     * @param {number} propId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    history: async (t, s = {}) => {
      se("history", "propId", t);
      const n = "/mls/{propId}/history".replace("{propId}", encodeURIComponent(String(t))), r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "GET", ...i, ...s }, l = {}, d = {};
      await Lt(l, "x-api-key", e), await ee(l, e), Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, {
        url: J(r),
        options: o
      };
    },
    /**
     * 
     * @summary Retrieve a listing\'s historical MLS changes.
     * @param {string} mlsSource 
     * @param {string} mlsNumber 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listingHistory: async (t, s, n = {}) => {
      se("listingHistory", "mlsSource", t), se("listingHistory", "mlsNumber", s);
      const r = "/mls/{mlsSource}/{mlsNumber}/history".replace("{mlsSource}", encodeURIComponent(String(t))).replace("{mlsNumber}", encodeURIComponent(String(s))), i = new URL(r, K);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "GET", ...o, ...n }, d = {}, c = {};
      await Lt(d, "x-api-key", e), await ee(d, e), Z(i, c);
      let u = o && o.headers ? o.headers : {};
      return l.headers = { ...d, ...u, ...n.headers }, {
        url: J(i),
        options: l
      };
    },
    /**
     * 
     * @summary Local Search.
     * @param {string} zip Zip code to run local search with.
     * @param {boolean} [p] Include pending listings.
     * @param {number} [m] Max listings to return.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    localSearch: async (t, s, n, r = {}) => {
      se("localSearch", "zip", t);
      const i = "/mls/local-search", o = new URL(i, K);
      let l;
      e && (l = e.baseOptions);
      const d = { method: "GET", ...l, ...r }, c = {}, u = {};
      await ee(c, e), t !== void 0 && (u.zip = t), s !== void 0 && (u.p = s), n !== void 0 && (u.m = n), Z(o, u);
      let m = l && l.headers ? l.headers : {};
      return d.headers = { ...c, ...m, ...r.headers }, {
        url: J(o),
        options: d
      };
    },
    /**
     * 
     * @summary List weekly turnkey listings.
     * @param {number} [m] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    turnkey: async (t, s = {}) => {
      const n = "/mls/featured/turn-key", r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "GET", ...i, ...s }, l = {}, d = {};
      await ee(l, e), t !== void 0 && (d.m = t), Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, {
        url: J(r),
        options: o
      };
    }
  };
}, Q6 = function(e) {
  const t = q6(e);
  return {
    /**
     * 
     * @summary Calculate MLS listings for search results.
     * @param {CalculateRequestModel} calculateRequestModel 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async calculate(s, n) {
      var l, d;
      const r = await t.calculate(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["MLSApi.calculate"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    },
    /**
     * 
     * @summary Retrieve MLS available coverage.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async coverage(s) {
      var o, l;
      const n = await t.coverage(s), r = (e == null ? void 0 : e.serverIndex) ?? 0, i = (l = (o = Q["MLSApi.coverage"]) == null ? void 0 : o[r]) == null ? void 0 : l.url;
      return (d, c) => _(n, X, G, e)(d, i || c);
    },
    /**
     * 
     * @summary List weekly featured listings.
     * @param {number} [m] Max listings to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async featured(s, n) {
      var l, d;
      const r = await t.featured(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["MLSApi.featured"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    },
    /**
     * 
     * @summary Returns property files used from last MLS listing.
     * @param {string} mlsSource 
     * @param {string} mlsNumber 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getListingFiles(s, n, r) {
      var d, c;
      const i = await t.getListingFiles(s, n, r), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (c = (d = Q["MLSApi.getListingFiles"]) == null ? void 0 : d[o]) == null ? void 0 : c.url;
      return (u, m) => _(i, X, G, e)(u, l || m);
    },
    /**
     * 
     * @summary Retrieve the history of a property\'s active MLS listing.
     * @param {number} propId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async history(s, n) {
      var l, d;
      const r = await t.history(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["MLSApi.history"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    },
    /**
     * 
     * @summary Retrieve a listing\'s historical MLS changes.
     * @param {string} mlsSource 
     * @param {string} mlsNumber 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async listingHistory(s, n, r) {
      var d, c;
      const i = await t.listingHistory(s, n, r), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (c = (d = Q["MLSApi.listingHistory"]) == null ? void 0 : d[o]) == null ? void 0 : c.url;
      return (u, m) => _(i, X, G, e)(u, l || m);
    },
    /**
     * 
     * @summary Local Search.
     * @param {string} zip Zip code to run local search with.
     * @param {boolean} [p] Include pending listings.
     * @param {number} [m] Max listings to return.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async localSearch(s, n, r, i) {
      var c, u;
      const o = await t.localSearch(s, n, r, i), l = (e == null ? void 0 : e.serverIndex) ?? 0, d = (u = (c = Q["MLSApi.localSearch"]) == null ? void 0 : c[l]) == null ? void 0 : u.url;
      return (m, f) => _(o, X, G, e)(m, d || f);
    },
    /**
     * 
     * @summary List weekly turnkey listings.
     * @param {number} [m] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async turnkey(s, n) {
      var l, d;
      const r = await t.turnkey(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["MLSApi.turnkey"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    }
  };
}, K6 = function(e, t, s) {
  const n = Q6(e);
  return {
    /**
     * 
     * @summary Calculate MLS listings for search results.
     * @param {CalculateRequestModel} calculateRequestModel 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    calculate(r, i) {
      return n.calculate(r, i).then((o) => o(s, t));
    },
    /**
     * 
     * @summary Retrieve MLS available coverage.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    coverage(r) {
      return n.coverage(r).then((i) => i(s, t));
    },
    /**
     * 
     * @summary List weekly featured listings.
     * @param {number} [m] Max listings to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    featured(r, i) {
      return n.featured(r, i).then((o) => o(s, t));
    },
    /**
     * 
     * @summary Returns property files used from last MLS listing.
     * @param {string} mlsSource 
     * @param {string} mlsNumber 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getListingFiles(r, i, o) {
      return n.getListingFiles(r, i, o).then((l) => l(s, t));
    },
    /**
     * 
     * @summary Retrieve the history of a property\'s active MLS listing.
     * @param {number} propId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    history(r, i) {
      return n.history(r, i).then((o) => o(s, t));
    },
    /**
     * 
     * @summary Retrieve a listing\'s historical MLS changes.
     * @param {string} mlsSource 
     * @param {string} mlsNumber 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listingHistory(r, i, o) {
      return n.listingHistory(r, i, o).then((l) => l(s, t));
    },
    /**
     * 
     * @summary Local Search.
     * @param {string} zip Zip code to run local search with.
     * @param {boolean} [p] Include pending listings.
     * @param {number} [m] Max listings to return.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    localSearch(r, i, o, l) {
      return n.localSearch(r, i, o, l).then((d) => d(s, t));
    },
    /**
     * 
     * @summary List weekly turnkey listings.
     * @param {number} [m] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    turnkey(r, i) {
      return n.turnkey(r, i).then((o) => o(s, t));
    }
  };
}, Z6 = function(e) {
  return {
    /**
     * 
     * @summary Upload file for marketplace listing.
     * @param {string} mlsNumber Property id of listing.
     * @param {number} order Sort order file is for.
     * @param {File} file File of property.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addFile: async (t, s, n, r = {}) => {
      se("addFile", "mlsNumber", t), se("addFile", "order", s), se("addFile", "file", n);
      const i = "/marketplace/manage/{mlsNumber}/file/{order}".replace("{mlsNumber}", encodeURIComponent(String(t))).replace("{order}", encodeURIComponent(String(s))), o = new URL(i, K);
      let l;
      e && (l = e.baseOptions);
      const d = { method: "POST", ...l, ...r }, c = {}, u = {}, m = new (e && e.formDataCtor || FormData)();
      await ee(c, e), n !== void 0 && m.append("file", n), c["Content-Type"] = "multipart/form-data", Z(o, u);
      let f = l && l.headers ? l.headers : {};
      return d.headers = { ...c, ...f, ...r.headers }, d.data = m, {
        url: J(o),
        options: d
      };
    },
    /**
     * 
     * @summary Upload photo for marketplace listing.
     * @param {string} mlsNumber Property id of listing.
     * @param {number} order Sort order photo is for.
     * @param {File} file Image of property.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addPhoto: async (t, s, n, r = {}) => {
      se("addPhoto", "mlsNumber", t), se("addPhoto", "order", s), se("addPhoto", "file", n);
      const i = "/marketplace/manage/{mlsNumber}/photo/{order}".replace("{mlsNumber}", encodeURIComponent(String(t))).replace("{order}", encodeURIComponent(String(s))), o = new URL(i, K);
      let l;
      e && (l = e.baseOptions);
      const d = { method: "POST", ...l, ...r }, c = {}, u = {}, m = new (e && e.formDataCtor || FormData)();
      await ee(c, e), n !== void 0 && m.append("file", n), c["Content-Type"] = "multipart/form-data", Z(o, u);
      let f = l && l.headers ? l.headers : {};
      return d.headers = { ...c, ...f, ...r.headers }, d.data = m, {
        url: J(o),
        options: d
      };
    },
    /**
     * 
     * @summary Save user\'s marketplace listing.
     * @param {number} propId 
     * @param {MarketplaceProperty} [marketplaceProperty] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createListingFromPublicRecords: async (t, s, n = {}) => {
      se("createListingFromPublicRecords", "propId", t);
      const r = "/marketplace/manage/{propId}/create".replace("{propId}", encodeURIComponent(String(t))), i = new URL(r, K);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "POST", ...o, ...n }, d = {}, c = {};
      await ee(d, e), d["Content-Type"] = "application/json", Z(i, c);
      let u = o && o.headers ? o.headers : {};
      return l.headers = { ...d, ...u, ...n.headers }, l.data = kt(s, l, e), {
        url: J(i),
        options: l
      };
    },
    /**
     * 
     * @summary Delete a user\'s marketplace listing\'s file.
     * @param {string} mlsNumber Property id of listing.
     * @param {string} url Url of file to delete.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteFile: async (t, s, n = {}) => {
      se("deleteFile", "mlsNumber", t), se("deleteFile", "url", s);
      const r = "/marketplace/manage/{mlsNumber}/file".replace("{mlsNumber}", encodeURIComponent(String(t))), i = new URL(r, K);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "DELETE", ...o, ...n }, d = {}, c = {}, u = new (e && e.formDataCtor || FormData)();
      await ee(d, e), s !== void 0 && u.append("url", s), d["Content-Type"] = "multipart/form-data", Z(i, c);
      let m = o && o.headers ? o.headers : {};
      return l.headers = { ...d, ...m, ...n.headers }, l.data = u, {
        url: J(i),
        options: l
      };
    },
    /**
     * 
     * @summary Delete user\'s incomplete marketplace listing.
     * @param {string} mlsNumber Marketplace listing id with incomplete status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteListing: async (t, s = {}) => {
      se("deleteListing", "mlsNumber", t);
      const n = "/marketplace/manage/{mlsNumber}".replace("{mlsNumber}", encodeURIComponent(String(t))), r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "DELETE", ...i, ...s }, l = {}, d = {};
      await ee(l, e), Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, {
        url: J(r),
        options: o
      };
    },
    /**
     * 
     * @summary Delete a user\'s marketplace listing\'s photo.
     * @param {string} mlsNumber Property id of listing.
     * @param {string} url Url of photo to delete.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deletePhoto: async (t, s, n = {}) => {
      se("deletePhoto", "mlsNumber", t), se("deletePhoto", "url", s);
      const r = "/marketplace/manage/{mlsNumber}/photo".replace("{mlsNumber}", encodeURIComponent(String(t))), i = new URL(r, K);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "DELETE", ...o, ...n }, d = {}, c = {}, u = new (e && e.formDataCtor || FormData)();
      await ee(d, e), s !== void 0 && u.append("url", s), d["Content-Type"] = "multipart/form-data", Z(i, c);
      let m = o && o.headers ? o.headers : {};
      return l.headers = { ...d, ...m, ...n.headers }, l.data = u, {
        url: J(i),
        options: l
      };
    },
    /**
     * 
     * @summary Retrieve user\'s marketplace listing for editing
     * @param {string} mlsNumber 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getListingEdit: async (t, s = {}) => {
      se("getListingEdit", "mlsNumber", t);
      const n = "/marketplace/manage/{mlsNumber}/edit".replace("{mlsNumber}", encodeURIComponent(String(t))), r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "GET", ...i, ...s }, l = {}, d = {};
      await ee(l, e), Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, {
        url: J(r),
        options: o
      };
    },
    /**
     * 
     * @summary List all user\'s listings in marketplace.
     * @param {number} [page] Current page of listings to return.
     * @param {number} [pageSize] Total listings per page.
     * @param {boolean} [inactive] Include inactive listings in results
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    myListings: async (t, s, n, r = {}) => {
      const i = "/marketplace/manage/listings", o = new URL(i, K);
      let l;
      e && (l = e.baseOptions);
      const d = { method: "GET", ...l, ...r }, c = {}, u = {};
      await ee(c, e), t !== void 0 && (u.page = t), s !== void 0 && (u.pageSize = s), n !== void 0 && (u.inactive = n), Z(o, u);
      let m = l && l.headers ? l.headers : {};
      return d.headers = { ...c, ...m, ...r.headers }, {
        url: J(o),
        options: d
      };
    },
    /**
     * 
     * @summary Retrieve marketplace listing with default values.
     * @param {number} propId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    prepareListing: async (t, s = {}) => {
      se("prepareListing", "propId", t);
      const n = "/marketplace/manage/{propId}/prepare".replace("{propId}", encodeURIComponent(String(t))), r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "GET", ...i, ...s }, l = {}, d = {};
      await ee(l, e), Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, {
        url: J(r),
        options: o
      };
    },
    /**
     * 
     * @summary Save user\'s marketplace listing.
     * @param {string} mlsNumber 
     * @param {boolean} [activate] 
     * @param {MarketplaceProperty} [marketplaceProperty] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    saveListing: async (t, s, n, r = {}) => {
      se("saveListing", "mlsNumber", t);
      const i = "/marketplace/manage/{mlsNumber}".replace("{mlsNumber}", encodeURIComponent(String(t))), o = new URL(i, K);
      let l;
      e && (l = e.baseOptions);
      const d = { method: "POST", ...l, ...r }, c = {}, u = {};
      await ee(c, e), s !== void 0 && (u.activate = s), c["Content-Type"] = "application/json", Z(o, u);
      let m = l && l.headers ? l.headers : {};
      return d.headers = { ...c, ...m, ...r.headers }, d.data = kt(n, d, e), {
        url: J(o),
        options: d
      };
    },
    /**
     * 
     * @summary Update a user\'s marketplace listing file\'s sort order.
     * @param {string} mlsNumber Property id of listing.
     * @param {number} order Sort order file is for.
     * @param {string} url Url of file to update sort order.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateFile: async (t, s, n, r = {}) => {
      se("updateFile", "mlsNumber", t), se("updateFile", "order", s), se("updateFile", "url", n);
      const i = "/marketplace/manage/{mlsNumber}/file/{order}".replace("{mlsNumber}", encodeURIComponent(String(t))).replace("{order}", encodeURIComponent(String(s))), o = new URL(i, K);
      let l;
      e && (l = e.baseOptions);
      const d = { method: "PATCH", ...l, ...r }, c = {}, u = {}, m = new (e && e.formDataCtor || FormData)();
      await ee(c, e), n !== void 0 && m.append("url", n), c["Content-Type"] = "multipart/form-data", Z(o, u);
      let f = l && l.headers ? l.headers : {};
      return d.headers = { ...c, ...f, ...r.headers }, d.data = m, {
        url: J(o),
        options: d
      };
    },
    /**
     * 
     * @summary Update a user\'s marketplace listing\'s photo\'s sort order.
     * @param {string} mlsNumber Property id of listing.
     * @param {number} order Sort order photo is for.
     * @param {string} url Url of photo to update sort order.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updatePhoto: async (t, s, n, r = {}) => {
      se("updatePhoto", "mlsNumber", t), se("updatePhoto", "order", s), se("updatePhoto", "url", n);
      const i = "/marketplace/manage/{mlsNumber}/photo/{order}".replace("{mlsNumber}", encodeURIComponent(String(t))).replace("{order}", encodeURIComponent(String(s))), o = new URL(i, K);
      let l;
      e && (l = e.baseOptions);
      const d = { method: "PATCH", ...l, ...r }, c = {}, u = {}, m = new (e && e.formDataCtor || FormData)();
      await ee(c, e), n !== void 0 && m.append("url", n), c["Content-Type"] = "multipart/form-data", Z(o, u);
      let f = l && l.headers ? l.headers : {};
      return d.headers = { ...c, ...f, ...r.headers }, d.data = m, {
        url: J(o),
        options: d
      };
    },
    /**
     * 
     * @summary Withdraw user\'s active marketplace listing.
     * @param {string} mlsNumber Marketplace listing id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    withdrawListing: async (t, s = {}) => {
      se("withdrawListing", "mlsNumber", t);
      const n = "/marketplace/manage/{mlsNumber}/withdraw".replace("{mlsNumber}", encodeURIComponent(String(t))), r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "POST", ...i, ...s }, l = {}, d = {};
      await ee(l, e), Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, {
        url: J(r),
        options: o
      };
    }
  };
}, J6 = function(e) {
  const t = Z6(e);
  return {
    /**
     * 
     * @summary Upload file for marketplace listing.
     * @param {string} mlsNumber Property id of listing.
     * @param {number} order Sort order file is for.
     * @param {File} file File of property.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async addFile(s, n, r, i) {
      var c, u;
      const o = await t.addFile(s, n, r, i), l = (e == null ? void 0 : e.serverIndex) ?? 0, d = (u = (c = Q["ManageMarketplaceApi.addFile"]) == null ? void 0 : c[l]) == null ? void 0 : u.url;
      return (m, f) => _(o, X, G, e)(m, d || f);
    },
    /**
     * 
     * @summary Upload photo for marketplace listing.
     * @param {string} mlsNumber Property id of listing.
     * @param {number} order Sort order photo is for.
     * @param {File} file Image of property.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async addPhoto(s, n, r, i) {
      var c, u;
      const o = await t.addPhoto(s, n, r, i), l = (e == null ? void 0 : e.serverIndex) ?? 0, d = (u = (c = Q["ManageMarketplaceApi.addPhoto"]) == null ? void 0 : c[l]) == null ? void 0 : u.url;
      return (m, f) => _(o, X, G, e)(m, d || f);
    },
    /**
     * 
     * @summary Save user\'s marketplace listing.
     * @param {number} propId 
     * @param {MarketplaceProperty} [marketplaceProperty] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createListingFromPublicRecords(s, n, r) {
      var d, c;
      const i = await t.createListingFromPublicRecords(s, n, r), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (c = (d = Q["ManageMarketplaceApi.createListingFromPublicRecords"]) == null ? void 0 : d[o]) == null ? void 0 : c.url;
      return (u, m) => _(i, X, G, e)(u, l || m);
    },
    /**
     * 
     * @summary Delete a user\'s marketplace listing\'s file.
     * @param {string} mlsNumber Property id of listing.
     * @param {string} url Url of file to delete.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deleteFile(s, n, r) {
      var d, c;
      const i = await t.deleteFile(s, n, r), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (c = (d = Q["ManageMarketplaceApi.deleteFile"]) == null ? void 0 : d[o]) == null ? void 0 : c.url;
      return (u, m) => _(i, X, G, e)(u, l || m);
    },
    /**
     * 
     * @summary Delete user\'s incomplete marketplace listing.
     * @param {string} mlsNumber Marketplace listing id with incomplete status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deleteListing(s, n) {
      var l, d;
      const r = await t.deleteListing(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["ManageMarketplaceApi.deleteListing"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    },
    /**
     * 
     * @summary Delete a user\'s marketplace listing\'s photo.
     * @param {string} mlsNumber Property id of listing.
     * @param {string} url Url of photo to delete.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deletePhoto(s, n, r) {
      var d, c;
      const i = await t.deletePhoto(s, n, r), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (c = (d = Q["ManageMarketplaceApi.deletePhoto"]) == null ? void 0 : d[o]) == null ? void 0 : c.url;
      return (u, m) => _(i, X, G, e)(u, l || m);
    },
    /**
     * 
     * @summary Retrieve user\'s marketplace listing for editing
     * @param {string} mlsNumber 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getListingEdit(s, n) {
      var l, d;
      const r = await t.getListingEdit(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["ManageMarketplaceApi.getListingEdit"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    },
    /**
     * 
     * @summary List all user\'s listings in marketplace.
     * @param {number} [page] Current page of listings to return.
     * @param {number} [pageSize] Total listings per page.
     * @param {boolean} [inactive] Include inactive listings in results
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async myListings(s, n, r, i) {
      var c, u;
      const o = await t.myListings(s, n, r, i), l = (e == null ? void 0 : e.serverIndex) ?? 0, d = (u = (c = Q["ManageMarketplaceApi.myListings"]) == null ? void 0 : c[l]) == null ? void 0 : u.url;
      return (m, f) => _(o, X, G, e)(m, d || f);
    },
    /**
     * 
     * @summary Retrieve marketplace listing with default values.
     * @param {number} propId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async prepareListing(s, n) {
      var l, d;
      const r = await t.prepareListing(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["ManageMarketplaceApi.prepareListing"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    },
    /**
     * 
     * @summary Save user\'s marketplace listing.
     * @param {string} mlsNumber 
     * @param {boolean} [activate] 
     * @param {MarketplaceProperty} [marketplaceProperty] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async saveListing(s, n, r, i) {
      var c, u;
      const o = await t.saveListing(s, n, r, i), l = (e == null ? void 0 : e.serverIndex) ?? 0, d = (u = (c = Q["ManageMarketplaceApi.saveListing"]) == null ? void 0 : c[l]) == null ? void 0 : u.url;
      return (m, f) => _(o, X, G, e)(m, d || f);
    },
    /**
     * 
     * @summary Update a user\'s marketplace listing file\'s sort order.
     * @param {string} mlsNumber Property id of listing.
     * @param {number} order Sort order file is for.
     * @param {string} url Url of file to update sort order.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateFile(s, n, r, i) {
      var c, u;
      const o = await t.updateFile(s, n, r, i), l = (e == null ? void 0 : e.serverIndex) ?? 0, d = (u = (c = Q["ManageMarketplaceApi.updateFile"]) == null ? void 0 : c[l]) == null ? void 0 : u.url;
      return (m, f) => _(o, X, G, e)(m, d || f);
    },
    /**
     * 
     * @summary Update a user\'s marketplace listing\'s photo\'s sort order.
     * @param {string} mlsNumber Property id of listing.
     * @param {number} order Sort order photo is for.
     * @param {string} url Url of photo to update sort order.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updatePhoto(s, n, r, i) {
      var c, u;
      const o = await t.updatePhoto(s, n, r, i), l = (e == null ? void 0 : e.serverIndex) ?? 0, d = (u = (c = Q["ManageMarketplaceApi.updatePhoto"]) == null ? void 0 : c[l]) == null ? void 0 : u.url;
      return (m, f) => _(o, X, G, e)(m, d || f);
    },
    /**
     * 
     * @summary Withdraw user\'s active marketplace listing.
     * @param {string} mlsNumber Marketplace listing id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async withdrawListing(s, n) {
      var l, d;
      const r = await t.withdrawListing(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["ManageMarketplaceApi.withdrawListing"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    }
  };
}, $6 = function(e, t, s) {
  const n = J6(e);
  return {
    /**
     * 
     * @summary Upload file for marketplace listing.
     * @param {string} mlsNumber Property id of listing.
     * @param {number} order Sort order file is for.
     * @param {File} file File of property.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addFile(r, i, o, l) {
      return n.addFile(r, i, o, l).then((d) => d(s, t));
    },
    /**
     * 
     * @summary Upload photo for marketplace listing.
     * @param {string} mlsNumber Property id of listing.
     * @param {number} order Sort order photo is for.
     * @param {File} file Image of property.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addPhoto(r, i, o, l) {
      return n.addPhoto(r, i, o, l).then((d) => d(s, t));
    },
    /**
     * 
     * @summary Save user\'s marketplace listing.
     * @param {number} propId 
     * @param {MarketplaceProperty} [marketplaceProperty] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createListingFromPublicRecords(r, i, o) {
      return n.createListingFromPublicRecords(r, i, o).then((l) => l(s, t));
    },
    /**
     * 
     * @summary Delete a user\'s marketplace listing\'s file.
     * @param {string} mlsNumber Property id of listing.
     * @param {string} url Url of file to delete.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteFile(r, i, o) {
      return n.deleteFile(r, i, o).then((l) => l(s, t));
    },
    /**
     * 
     * @summary Delete user\'s incomplete marketplace listing.
     * @param {string} mlsNumber Marketplace listing id with incomplete status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteListing(r, i) {
      return n.deleteListing(r, i).then((o) => o(s, t));
    },
    /**
     * 
     * @summary Delete a user\'s marketplace listing\'s photo.
     * @param {string} mlsNumber Property id of listing.
     * @param {string} url Url of photo to delete.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deletePhoto(r, i, o) {
      return n.deletePhoto(r, i, o).then((l) => l(s, t));
    },
    /**
     * 
     * @summary Retrieve user\'s marketplace listing for editing
     * @param {string} mlsNumber 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getListingEdit(r, i) {
      return n.getListingEdit(r, i).then((o) => o(s, t));
    },
    /**
     * 
     * @summary List all user\'s listings in marketplace.
     * @param {number} [page] Current page of listings to return.
     * @param {number} [pageSize] Total listings per page.
     * @param {boolean} [inactive] Include inactive listings in results
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    myListings(r, i, o, l) {
      return n.myListings(r, i, o, l).then((d) => d(s, t));
    },
    /**
     * 
     * @summary Retrieve marketplace listing with default values.
     * @param {number} propId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    prepareListing(r, i) {
      return n.prepareListing(r, i).then((o) => o(s, t));
    },
    /**
     * 
     * @summary Save user\'s marketplace listing.
     * @param {string} mlsNumber 
     * @param {boolean} [activate] 
     * @param {MarketplaceProperty} [marketplaceProperty] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    saveListing(r, i, o, l) {
      return n.saveListing(r, i, o, l).then((d) => d(s, t));
    },
    /**
     * 
     * @summary Update a user\'s marketplace listing file\'s sort order.
     * @param {string} mlsNumber Property id of listing.
     * @param {number} order Sort order file is for.
     * @param {string} url Url of file to update sort order.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateFile(r, i, o, l) {
      return n.updateFile(r, i, o, l).then((d) => d(s, t));
    },
    /**
     * 
     * @summary Update a user\'s marketplace listing\'s photo\'s sort order.
     * @param {string} mlsNumber Property id of listing.
     * @param {number} order Sort order photo is for.
     * @param {string} url Url of photo to update sort order.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updatePhoto(r, i, o, l) {
      return n.updatePhoto(r, i, o, l).then((d) => d(s, t));
    },
    /**
     * 
     * @summary Withdraw user\'s active marketplace listing.
     * @param {string} mlsNumber Marketplace listing id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    withdrawListing(r, i) {
      return n.withdrawListing(r, i).then((o) => o(s, t));
    }
  };
}, _6 = function(e) {
  return {
    /**
     * 
     * @param {string} zip 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    byZip: async (t, s = {}) => {
      se("byZip", "zip", t);
      const n = "/market-report/zip/{zip}".replace("{zip}", encodeURIComponent(String(t))), r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "GET", ...i, ...s }, l = {}, d = {};
      await Lt(l, "x-api-key", e), await ee(l, e), Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, {
        url: J(r),
        options: o
      };
    },
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    managementTerritory: async (t = {}) => {
      const s = "/market-report/management-territory", n = new URL(s, K);
      let r;
      e && (r = e.baseOptions);
      const i = { method: "GET", ...r, ...t }, o = {}, l = {};
      await ee(o, e), Z(n, l);
      let d = r && r.headers ? r.headers : {};
      return i.headers = { ...o, ...d, ...t.headers }, {
        url: J(n),
        options: i
      };
    }
  };
}, oA = function(e) {
  const t = _6(e);
  return {
    /**
     * 
     * @param {string} zip 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async byZip(s, n) {
      var l, d;
      const r = await t.byZip(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["MarketReportApi.byZip"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    },
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async managementTerritory(s) {
      var o, l;
      const n = await t.managementTerritory(s), r = (e == null ? void 0 : e.serverIndex) ?? 0, i = (l = (o = Q["MarketReportApi.managementTerritory"]) == null ? void 0 : o[r]) == null ? void 0 : l.url;
      return (d, c) => _(n, X, G, e)(d, i || c);
    }
  };
};
class eT extends Fn {
  /**
   * 
   * @param {string} zip 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MarketReportApi
   */
  byZip(t, s) {
    return oA(this.configuration).byZip(t, s).then((n) => n(this.axios, this.basePath));
  }
  /**
   * 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MarketReportApi
   */
  managementTerritory(t) {
    return oA(this.configuration).managementTerritory(t).then((s) => s(this.axios, this.basePath));
  }
}
const tT = function(e) {
  return {
    /**
     * 
     * @summary List active marketplace listings.
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {number} [latitude] 
     * @param {number} [longitude] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    activeListings: async (t, s, n, r, i = {}) => {
      const o = "/marketplace/listings/active", l = new URL(o, K);
      let d;
      e && (d = e.baseOptions);
      const c = { method: "GET", ...d, ...i }, u = {}, m = {};
      await Lt(u, "x-api-key", e), await ee(u, e), t !== void 0 && (m.page = t), s !== void 0 && (m.pageSize = s), n !== void 0 && (m.latitude = n), r !== void 0 && (m.longitude = r), Z(l, m);
      let f = d && d.headers ? d.headers : {};
      return c.headers = { ...u, ...f, ...i.headers }, {
        url: J(l),
        options: c
      };
    },
    /**
     * 
     * @param {number} [latitude] 
     * @param {number} [longitude] 
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    activeListingsForClient: async (t, s, n, r, i = {}) => {
      const o = "/marketplace/listings/my-agents", l = new URL(o, K);
      let d;
      e && (d = e.baseOptions);
      const c = { method: "GET", ...d, ...i }, u = {}, m = {};
      await ee(u, e), t !== void 0 && (m.latitude = t), s !== void 0 && (m.longitude = s), n !== void 0 && (m.page = n), r !== void 0 && (m.pageSize = r), Z(l, m);
      let f = d && d.headers ? d.headers : {};
      return c.headers = { ...u, ...f, ...i.headers }, {
        url: J(l),
        options: c
      };
    },
    /**
     * 
     * @summary List all brand\'s listings in marketplace.
     * @param {number} [latitude] 
     * @param {number} [longitude] 
     * @param {number} [page] Current page of listings to return.
     * @param {number} [pageSize] Total listings per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getMyBrandListings: async (t, s, n, r, i = {}) => {
      const o = "/marketplace/brand/listings", l = new URL(o, K);
      let d;
      e && (d = e.baseOptions);
      const c = { method: "GET", ...d, ...i }, u = {}, m = {};
      await Lt(u, "x-api-key", e), await ee(u, e), t !== void 0 && (m.latitude = t), s !== void 0 && (m.longitude = s), n !== void 0 && (m.page = n), r !== void 0 && (m.pageSize = r), Z(l, m);
      let f = d && d.headers ? d.headers : {};
      return c.headers = { ...u, ...f, ...i.headers }, {
        url: J(l),
        options: c
      };
    },
    /**
     * 
     * @summary List all user\'s listings in marketplace.
     * @param {number} [page] Current page of listings to return.
     * @param {number} [pageSize] Total listings per page.
     * @param {boolean} [onlyActive] Only return active listings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    myActiveListings: async (t, s, n, r = {}) => {
      const i = "/marketplace/listings/active/mine", o = new URL(i, K);
      let l;
      e && (l = e.baseOptions);
      const d = { method: "GET", ...l, ...r }, c = {}, u = {};
      await Lt(c, "x-api-key", e), await ee(c, e), t !== void 0 && (u.page = t), s !== void 0 && (u.pageSize = s), n !== void 0 && (u.onlyActive = n), Z(o, u);
      let m = l && l.headers ? l.headers : {};
      return d.headers = { ...c, ...m, ...r.headers }, {
        url: J(o),
        options: d
      };
    }
  };
}, sT = function(e) {
  const t = tT(e);
  return {
    /**
     * 
     * @summary List active marketplace listings.
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {number} [latitude] 
     * @param {number} [longitude] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async activeListings(s, n, r, i, o) {
      var u, m;
      const l = await t.activeListings(s, n, r, i, o), d = (e == null ? void 0 : e.serverIndex) ?? 0, c = (m = (u = Q["MarketplaceApi.activeListings"]) == null ? void 0 : u[d]) == null ? void 0 : m.url;
      return (f, v) => _(l, X, G, e)(f, c || v);
    },
    /**
     * 
     * @param {number} [latitude] 
     * @param {number} [longitude] 
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async activeListingsForClient(s, n, r, i, o) {
      var u, m;
      const l = await t.activeListingsForClient(s, n, r, i, o), d = (e == null ? void 0 : e.serverIndex) ?? 0, c = (m = (u = Q["MarketplaceApi.activeListingsForClient"]) == null ? void 0 : u[d]) == null ? void 0 : m.url;
      return (f, v) => _(l, X, G, e)(f, c || v);
    },
    /**
     * 
     * @summary List all brand\'s listings in marketplace.
     * @param {number} [latitude] 
     * @param {number} [longitude] 
     * @param {number} [page] Current page of listings to return.
     * @param {number} [pageSize] Total listings per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getMyBrandListings(s, n, r, i, o) {
      var u, m;
      const l = await t.getMyBrandListings(s, n, r, i, o), d = (e == null ? void 0 : e.serverIndex) ?? 0, c = (m = (u = Q["MarketplaceApi.getMyBrandListings"]) == null ? void 0 : u[d]) == null ? void 0 : m.url;
      return (f, v) => _(l, X, G, e)(f, c || v);
    },
    /**
     * 
     * @summary List all user\'s listings in marketplace.
     * @param {number} [page] Current page of listings to return.
     * @param {number} [pageSize] Total listings per page.
     * @param {boolean} [onlyActive] Only return active listings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async myActiveListings(s, n, r, i) {
      var c, u;
      const o = await t.myActiveListings(s, n, r, i), l = (e == null ? void 0 : e.serverIndex) ?? 0, d = (u = (c = Q["MarketplaceApi.myActiveListings"]) == null ? void 0 : c[l]) == null ? void 0 : u.url;
      return (m, f) => _(o, X, G, e)(m, d || f);
    }
  };
}, aT = function(e, t, s) {
  const n = sT(e);
  return {
    /**
     * 
     * @summary List active marketplace listings.
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {number} [latitude] 
     * @param {number} [longitude] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    activeListings(r, i, o, l, d) {
      return n.activeListings(r, i, o, l, d).then((c) => c(s, t));
    },
    /**
     * 
     * @param {number} [latitude] 
     * @param {number} [longitude] 
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    activeListingsForClient(r, i, o, l, d) {
      return n.activeListingsForClient(r, i, o, l, d).then((c) => c(s, t));
    },
    /**
     * 
     * @summary List all brand\'s listings in marketplace.
     * @param {number} [latitude] 
     * @param {number} [longitude] 
     * @param {number} [page] Current page of listings to return.
     * @param {number} [pageSize] Total listings per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getMyBrandListings(r, i, o, l, d) {
      return n.getMyBrandListings(r, i, o, l, d).then((c) => c(s, t));
    },
    /**
     * 
     * @summary List all user\'s listings in marketplace.
     * @param {number} [page] Current page of listings to return.
     * @param {number} [pageSize] Total listings per page.
     * @param {boolean} [onlyActive] Only return active listings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    myActiveListings(r, i, o, l) {
      return n.myActiveListings(r, i, o, l).then((d) => d(s, t));
    }
  };
}, nT = function(e) {
  return {
    /**
     * 
     * @summary Generate PDF download token url for property.
     * @param {number} propId 
     * @param {number} portfolioId 
     * @param {boolean} [shortTerm] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    portfolioPropertyAnalysis: async (t, s, n, r = {}) => {
      se("portfolioPropertyAnalysis", "propId", t), se("portfolioPropertyAnalysis", "portfolioId", s);
      const i = "/pdf/portfolio-insights/{portfolioId}/{propId}".replace("{propId}", encodeURIComponent(String(t))).replace("{portfolioId}", encodeURIComponent(String(s))), o = new URL(i, K);
      let l;
      e && (l = e.baseOptions);
      const d = { method: "POST", ...l, ...r }, c = {}, u = {};
      await Lt(c, "x-api-key", e), await ee(c, e), n !== void 0 && (u.shortTerm = n), Z(o, u);
      let m = l && l.headers ? l.headers : {};
      return d.headers = { ...c, ...m, ...r.headers }, {
        url: J(o),
        options: d
      };
    },
    /**
     * 
     * @summary Generate PDF download token url for property.
     * @param {number} propId 
     * @param {boolean} [shortTerm] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    property: async (t, s, n = {}) => {
      se("property", "propId", t);
      const r = "/pdf/property/{propId}".replace("{propId}", encodeURIComponent(String(t))), i = new URL(r, K);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "POST", ...o, ...n }, d = {}, c = {};
      await Lt(d, "x-api-key", e), await ee(d, e), s !== void 0 && (c.shortTerm = s), Z(i, c);
      let u = o && o.headers ? o.headers : {};
      return l.headers = { ...d, ...u, ...n.headers }, {
        url: J(i),
        options: l
      };
    },
    /**
     * 
     * @summary Generate PDF download token url for property.
     * @param {string} mlsSource 
     * @param {string} mlsNumber 
     * @param {boolean} [shortTerm] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertyMls: async (t, s, n, r = {}) => {
      se("propertyMls", "mlsSource", t), se("propertyMls", "mlsNumber", s);
      const i = "/pdf/mls/{mlsSource}/{mlsNumber}".replace("{mlsSource}", encodeURIComponent(String(t))).replace("{mlsNumber}", encodeURIComponent(String(s))), o = new URL(i, K);
      let l;
      e && (l = e.baseOptions);
      const d = { method: "POST", ...l, ...r }, c = {}, u = {};
      await Lt(c, "x-api-key", e), await ee(c, e), n !== void 0 && (u.shortTerm = n), Z(o, u);
      let m = l && l.headers ? l.headers : {};
      return d.headers = { ...c, ...m, ...r.headers }, {
        url: J(o),
        options: d
      };
    }
  };
}, rT = function(e) {
  const t = nT(e);
  return {
    /**
     * 
     * @summary Generate PDF download token url for property.
     * @param {number} propId 
     * @param {number} portfolioId 
     * @param {boolean} [shortTerm] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async portfolioPropertyAnalysis(s, n, r, i) {
      var c, u;
      const o = await t.portfolioPropertyAnalysis(s, n, r, i), l = (e == null ? void 0 : e.serverIndex) ?? 0, d = (u = (c = Q["PdfApi.portfolioPropertyAnalysis"]) == null ? void 0 : c[l]) == null ? void 0 : u.url;
      return (m, f) => _(o, X, G, e)(m, d || f);
    },
    /**
     * 
     * @summary Generate PDF download token url for property.
     * @param {number} propId 
     * @param {boolean} [shortTerm] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async property(s, n, r) {
      var d, c;
      const i = await t.property(s, n, r), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (c = (d = Q["PdfApi.property"]) == null ? void 0 : d[o]) == null ? void 0 : c.url;
      return (u, m) => _(i, X, G, e)(u, l || m);
    },
    /**
     * 
     * @summary Generate PDF download token url for property.
     * @param {string} mlsSource 
     * @param {string} mlsNumber 
     * @param {boolean} [shortTerm] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async propertyMls(s, n, r, i) {
      var c, u;
      const o = await t.propertyMls(s, n, r, i), l = (e == null ? void 0 : e.serverIndex) ?? 0, d = (u = (c = Q["PdfApi.propertyMls"]) == null ? void 0 : c[l]) == null ? void 0 : u.url;
      return (m, f) => _(o, X, G, e)(m, d || f);
    }
  };
}, oT = function(e, t, s) {
  const n = rT(e);
  return {
    /**
     * 
     * @summary Generate PDF download token url for property.
     * @param {number} propId 
     * @param {number} portfolioId 
     * @param {boolean} [shortTerm] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    portfolioPropertyAnalysis(r, i, o, l) {
      return n.portfolioPropertyAnalysis(r, i, o, l).then((d) => d(s, t));
    },
    /**
     * 
     * @summary Generate PDF download token url for property.
     * @param {number} propId 
     * @param {boolean} [shortTerm] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    property(r, i, o) {
      return n.property(r, i, o).then((l) => l(s, t));
    },
    /**
     * 
     * @summary Generate PDF download token url for property.
     * @param {string} mlsSource 
     * @param {string} mlsNumber 
     * @param {boolean} [shortTerm] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertyMls(r, i, o, l) {
      return n.propertyMls(r, i, o, l).then((d) => d(s, t));
    }
  };
}, iT = function(e) {
  return {
    /**
     * 
     * @summary Reassign properties to custom lead.
     * @param {AssignOwnerRequest} [assignOwnerRequest] Create owner model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    assignOwner: async (t, s = {}) => {
      const n = "/portfolio-finder/assign", r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "POST", ...i, ...s }, l = {}, d = {};
      await ee(l, e), l["Content-Type"] = "application/json", Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, o.data = kt(t, o, e), {
        url: J(r),
        options: o
      };
    },
    /**
     * 
     * @summary Retrieve list of counties enabled for portfolio finder.
     * @param {string} state 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    counties: async (t, s = {}) => {
      se("counties", "state", t);
      const n = "/portfolio-finder/states/{state}/counties".replace("{state}", encodeURIComponent(String(t))), r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "GET", ...i, ...s }, l = {}, d = {};
      await ee(l, e), Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, {
        url: J(r),
        options: o
      };
    },
    /**
     * 
     * @summary Create custom lead for user and reassign properties to it.
     * @param {CreateOwnerRequest} [createOwnerRequest] Create owner model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createOwner: async (t, s = {}) => {
      const n = "/portfolio-finder/create", r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "POST", ...i, ...s }, l = {}, d = {};
      await ee(l, e), l["Content-Type"] = "application/json", Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, o.data = kt(t, o, e), {
        url: J(r),
        options: o
      };
    },
    /**
     * 
     * @summary List leads favorite by user.
     * @param {string} key 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    downloadExport: async (t, s = {}) => {
      se("downloadExport", "key", t);
      const n = "/portfolio-finder/export/{key}".replace("{key}", encodeURIComponent(String(t))), r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "GET", ...i, ...s }, l = {}, d = {};
      await ee(l, e), Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, {
        url: J(r),
        options: o
      };
    },
    /**
     * 
     * @summary List leads favorite by user.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    exportFavorites: async (t = {}) => {
      const s = "/portfolio-finder/export", n = new URL(s, K);
      let r;
      e && (r = e.baseOptions);
      const i = { method: "POST", ...r, ...t }, o = {}, l = {};
      await ee(o, e), Z(n, l);
      let d = r && r.headers ? r.headers : {};
      return i.headers = { ...o, ...d, ...t.headers }, {
        url: J(n),
        options: i
      };
    },
    /**
     * 
     * @summary Lead set as favorite.
     * @param {number} ownerId ID of lead owner.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    favoriteOwner: async (t, s = {}) => {
      se("favoriteOwner", "ownerId", t);
      const n = "/portfolio-finder/{ownerId}/favorite".replace("{ownerId}", encodeURIComponent(String(t))), r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "POST", ...i, ...s }, l = {}, d = {};
      await ee(l, e), Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, {
        url: J(r),
        options: o
      };
    },
    /**
     * 
     * @summary Retrieve owner\'s agents.
     * @param {number} ownerId ID of lead owner.
     * @param {number} [p] Page
     * @param {number} [ps] Page size
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAgents: async (t, s, n, r = {}) => {
      se("getAgents", "ownerId", t);
      const i = "/portfolio-finder/{ownerId}/agents".replace("{ownerId}", encodeURIComponent(String(t))), o = new URL(i, K);
      let l;
      e && (l = e.baseOptions);
      const d = { method: "GET", ...l, ...r }, c = {}, u = {};
      await ee(c, e), s !== void 0 && (u.p = s), n !== void 0 && (u.ps = n), Z(o, u);
      let m = l && l.headers ? l.headers : {};
      return d.headers = { ...c, ...m, ...r.headers }, {
        url: J(o),
        options: d
      };
    },
    /**
     * 
     * @summary Retrieve owner\'s potential client value.
     * @param {number} ownerId ID of lead owner.
     * @param {PropertyGroupType} [type] Property type to summarize by.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getClientValue: async (t, s, n = {}) => {
      se("getClientValue", "ownerId", t);
      const r = "/portfolio-finder/{ownerId}/client-values".replace("{ownerId}", encodeURIComponent(String(t))), i = new URL(r, K);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "GET", ...o, ...n }, d = {}, c = {};
      await ee(d, e), s !== void 0 && (c.type = s), Z(i, c);
      let u = o && o.headers ? o.headers : {};
      return l.headers = { ...d, ...u, ...n.headers }, {
        url: J(i),
        options: l
      };
    },
    /**
     * 
     * @summary Retrieve a single lead contact for owner.
     * @param {number} ownerId ID of lead owner.
     * @param {number} id ID OR priority of owner contact.
     * @param {boolean} [isPriority] Is ID priority number.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getContact: async (t, s, n, r = {}) => {
      se("getContact", "ownerId", t), se("getContact", "id", s);
      const i = "/portfolio-finder/{ownerId}/contacts/{id}".replace("{ownerId}", encodeURIComponent(String(t))).replace("{id}", encodeURIComponent(String(s))), o = new URL(i, K);
      let l;
      e && (l = e.baseOptions);
      const d = { method: "GET", ...l, ...r }, c = {}, u = {};
      await ee(c, e), n !== void 0 && (u.isPriority = n), Z(o, u);
      let m = l && l.headers ? l.headers : {};
      return d.headers = { ...c, ...m, ...r.headers }, {
        url: J(o),
        options: d
      };
    },
    /**
     * 
     * @summary Retrieve lead contacts for owner.
     * @param {number} ownerId ID of lead owner.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getContacts: async (t, s = {}) => {
      se("getContacts", "ownerId", t);
      const n = "/portfolio-finder/{ownerId}/contacts".replace("{ownerId}", encodeURIComponent(String(t))), r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "GET", ...i, ...s }, l = {}, d = {};
      await ee(l, e), Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, {
        url: J(r),
        options: o
      };
    },
    /**
     * 
     * @summary List leads favorite by user.
     * @param {number} [page] Current page to return of owner\&#39;s properties.
     * @param {number} [pageSize] Total properties per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getFavorites: async (t, s, n = {}) => {
      const r = "/portfolio-finder/favorites", i = new URL(r, K);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "GET", ...o, ...n }, d = {}, c = {};
      await ee(d, e), t !== void 0 && (c.page = t), s !== void 0 && (c.pageSize = s), Z(i, c);
      let u = o && o.headers ? o.headers : {};
      return l.headers = { ...d, ...u, ...n.headers }, {
        url: J(i),
        options: l
      };
    },
    /**
     * 
     * @summary List leads ignored by user.
     * @param {number} [page] Current page to return of owner\&#39;s properties.
     * @param {number} [pageSize] Total properties per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getFiduciaryOwners: async (t, s, n = {}) => {
      const r = "/portfolio-finder/fiduciaries", i = new URL(r, K);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "GET", ...o, ...n }, d = {}, c = {};
      await ee(d, e), t !== void 0 && (c.page = t), s !== void 0 && (c.pageSize = s), Z(i, c);
      let u = o && o.headers ? o.headers : {};
      return l.headers = { ...d, ...u, ...n.headers }, {
        url: J(i),
        options: l
      };
    },
    /**
     * 
     * @summary List leads ignored by user.
     * @param {number} [page] Current page to return of owner\&#39;s properties.
     * @param {number} [pageSize] Total properties per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getIgnored: async (t, s, n = {}) => {
      const r = "/portfolio-finder/ignored", i = new URL(r, K);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "GET", ...o, ...n }, d = {}, c = {};
      await ee(d, e), t !== void 0 && (c.page = t), s !== void 0 && (c.pageSize = s), Z(i, c);
      let u = o && o.headers ? o.headers : {};
      return l.headers = { ...d, ...u, ...n.headers }, {
        url: J(i),
        options: l
      };
    },
    /**
     * 
     * @summary List agents marked as investment managers.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getInvestmentManagers: async (t = {}) => {
      const s = "/portfolio-finder/investment-managers", n = new URL(s, K);
      let r;
      e && (r = e.baseOptions);
      const i = { method: "GET", ...r, ...t }, o = {}, l = {};
      await ee(o, e), Z(n, l);
      let d = r && r.headers ? r.headers : {};
      return i.headers = { ...o, ...d, ...t.headers }, {
        url: J(n),
        options: i
      };
    },
    /**
     * 
     * @summary List leads created by user.
     * @param {number} [page] Current page to return of owner\&#39;s properties.
     * @param {number} [pageSize] Total properties per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getLeadCustomOwners: async (t, s, n = {}) => {
      const r = "/portfolio-finder/custom-owners", i = new URL(r, K);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "GET", ...o, ...n }, d = {}, c = {};
      await ee(d, e), t !== void 0 && (c.page = t), s !== void 0 && (c.pageSize = s), Z(i, c);
      let u = o && o.headers ? o.headers : {};
      return l.headers = { ...d, ...u, ...n.headers }, {
        url: J(i),
        options: l
      };
    },
    /**
     * 
     * @summary Retrieve lead owner\'s information.
     * @param {number} ownerId ID of lead owner.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getOwner: async (t, s = {}) => {
      se("getOwner", "ownerId", t);
      const n = "/portfolio-finder/{ownerId}".replace("{ownerId}", encodeURIComponent(String(t))), r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "GET", ...i, ...s }, l = {}, d = {};
      await ee(l, e), Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, {
        url: J(r),
        options: o
      };
    },
    /**
     * 
     * @summary Retrieve owner\'s properties.
     * @param {number} ownerId ID of lead owner.
     * @param {number} [page] Current page to return of owner\&#39;s properties.
     * @param {number} [pageSize] Total properties per page.
     * @param {PropertyGroupType} [type] Property group type.
     * @param {boolean} [pmArea] Filter in PM Area only
     * @param {boolean} [c] Is id a custom owner id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProperties: async (t, s, n, r, i, o, l = {}) => {
      se("getProperties", "ownerId", t);
      const d = "/portfolio-finder/{ownerId}/properties".replace("{ownerId}", encodeURIComponent(String(t))), c = new URL(d, K);
      let u;
      e && (u = e.baseOptions);
      const m = { method: "GET", ...u, ...l }, f = {}, v = {};
      await ee(f, e), s !== void 0 && (v.page = s), n !== void 0 && (v.pageSize = n), r !== void 0 && (v.type = r), i !== void 0 && (v.pmArea = i), o !== void 0 && (v.c = o), Z(c, v);
      let b = u && u.headers ? u.headers : {};
      return m.headers = { ...f, ...b, ...l.headers }, {
        url: J(c),
        options: m
      };
    },
    /**
     * 
     * @summary Retrieve owner\'s properties geographic locations.
     * @param {number} ownerId ID of lead owner.
     * @param {PropertyGroupType} [type] Property type to list.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPropertiesGeo: async (t, s, n = {}) => {
      se("getPropertiesGeo", "ownerId", t);
      const r = "/portfolio-finder/{ownerId}/properties/geo".replace("{ownerId}", encodeURIComponent(String(t))), i = new URL(r, K);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "GET", ...o, ...n }, d = {}, c = {};
      await ee(d, e), s !== void 0 && (c.type = s), Z(i, c);
      let u = o && o.headers ? o.headers : {};
      return l.headers = { ...d, ...u, ...n.headers }, {
        url: J(i),
        options: l
      };
    },
    /**
     * 
     * @summary List agents marked as property managers.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPropertyManagers: async (t = {}) => {
      const s = "/portfolio-finder/property-managers", n = new URL(s, K);
      let r;
      e && (r = e.baseOptions);
      const i = { method: "GET", ...r, ...t }, o = {}, l = {};
      await ee(o, e), Z(n, l);
      let d = r && r.headers ? r.headers : {};
      return i.headers = { ...o, ...d, ...t.headers }, {
        url: J(n),
        options: i
      };
    },
    /**
     * 
     * @summary Retrieve owner\'s property types.
     * @param {number} ownerId ID of lead owner.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPropertyTypes: async (t, s = {}) => {
      se("getPropertyTypes", "ownerId", t);
      const n = "/portfolio-finder/{ownerId}/property-types".replace("{ownerId}", encodeURIComponent(String(t))), r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "GET", ...i, ...s }, l = {}, d = {};
      await ee(l, e), Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, {
        url: J(r),
        options: o
      };
    },
    /**
     * 
     * @summary Statistics for potential leads in users management area
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getStats: async (t = {}) => {
      const s = "/portfolio-finder/stats", n = new URL(s, K);
      let r;
      e && (r = e.baseOptions);
      const i = { method: "GET", ...r, ...t }, o = {}, l = {};
      await ee(o, e), Z(n, l);
      let d = r && r.headers ? r.headers : {};
      return i.headers = { ...o, ...d, ...t.headers }, {
        url: J(n),
        options: i
      };
    },
    /**
     * 
     * @summary Ignore a lead from showing up in searches.
     * @param {number} ownerId ID of lead owner.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    ignoreOwner: async (t, s = {}) => {
      se("ignoreOwner", "ownerId", t);
      const n = "/portfolio-finder/{ownerId}/ignore".replace("{ownerId}", encodeURIComponent(String(t))), r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "POST", ...i, ...s }, l = {}, d = {};
      await ee(l, e), Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, {
        url: J(r),
        options: o
      };
    },
    /**
     * 
     * @summary Retrieve owner\'s names.
     * @param {number} ownerId ID of lead owner.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    ownerNames: async (t, s = {}) => {
      se("ownerNames", "ownerId", t);
      const n = "/portfolio-finder/{ownerId}/names".replace("{ownerId}", encodeURIComponent(String(t))), r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "GET", ...i, ...s }, l = {}, d = {};
      await ee(l, e), Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, {
        url: J(r),
        options: o
      };
    },
    /**
     * 
     * @summary Lead remove all user favorites.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    removeAllFavorite: async (t = {}) => {
      const s = "/portfolio-finder/favorite", n = new URL(s, K);
      let r;
      e && (r = e.baseOptions);
      const i = { method: "DELETE", ...r, ...t }, o = {}, l = {};
      await ee(o, e), Z(n, l);
      let d = r && r.headers ? r.headers : {};
      return i.headers = { ...o, ...d, ...t.headers }, {
        url: J(n),
        options: i
      };
    },
    /**
     * 
     * @summary Lead unset as favorite.
     * @param {number} ownerId ID of lead owner.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    removeFavoriteOwner: async (t, s = {}) => {
      se("removeFavoriteOwner", "ownerId", t);
      const n = "/portfolio-finder/{ownerId}/favorite".replace("{ownerId}", encodeURIComponent(String(t))), r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "DELETE", ...i, ...s }, l = {}, d = {};
      await ee(l, e), Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, {
        url: J(r),
        options: o
      };
    },
    /**
     * 
     * @summary Remove a lead Ignore.
     * @param {number} ownerId ID of lead owner.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    removeOwnerIgnore: async (t, s = {}) => {
      se("removeOwnerIgnore", "ownerId", t);
      const n = "/portfolio-finder/{ownerId}/ignore".replace("{ownerId}", encodeURIComponent(String(t))), r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "DELETE", ...i, ...s }, l = {}, d = {};
      await ee(l, e), Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, {
        url: J(r),
        options: o
      };
    },
    /**
     * 
     * @summary Search for lead owners.
     * @param {LeadsSearchModel} [leadsSearchModel] Search model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    search: async (t, s = {}) => {
      const n = "/portfolio-finder/search", r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "POST", ...i, ...s }, l = {}, d = {};
      await ee(l, e), l["Content-Type"] = "application/json", Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, o.data = kt(t, o, e), {
        url: J(r),
        options: o
      };
    },
    /**
     * 
     * @summary Set agent characteristics.
     * @param {string} mlsSource MLS source of agent.
     * @param {string} agentId ID of mls agent.
     * @param {boolean} [pm] Agent is part of a property management company.
     * @param {boolean} [ia] Agent is part of a investor management
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    setAgent: async (t, s, n, r, i = {}) => {
      se("setAgent", "mlsSource", t), se("setAgent", "agentId", s);
      const o = "/portfolio-finder/{mlsSource}/{agentId}/agent".replace("{mlsSource}", encodeURIComponent(String(t))).replace("{agentId}", encodeURIComponent(String(s))), l = new URL(o, K);
      let d;
      e && (d = e.baseOptions);
      const c = { method: "POST", ...d, ...i }, u = {}, m = {}, f = new (e && e.formDataCtor || FormData)();
      await ee(u, e), n !== void 0 && f.append("pm", String(n)), r !== void 0 && f.append("ia", String(r)), u["Content-Type"] = "multipart/form-data", Z(l, m);
      let v = d && d.headers ? d.headers : {};
      return c.headers = { ...u, ...v, ...i.headers }, c.data = f, {
        url: J(l),
        options: c
      };
    },
    /**
     * 
     * @summary Toggle lead as being a fiduciary.
     * @param {number} ownerId ID of lead owner.
     * @param {boolean} [fiduciary] Set owner as fiduciary or not.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    setFiduciary: async (t, s, n = {}) => {
      se("setFiduciary", "ownerId", t);
      const r = "/portfolio-finder/{ownerId}/fiduciary".replace("{ownerId}", encodeURIComponent(String(t))), i = new URL(r, K);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "POST", ...o, ...n }, d = {}, c = {};
      await ee(d, e), s !== void 0 && (c.fiduciary = s), Z(i, c);
      let u = o && o.headers ? o.headers : {};
      return l.headers = { ...d, ...u, ...n.headers }, {
        url: J(i),
        options: l
      };
    },
    /**
     * 
     * @summary Change a lead\'s name.
     * @param {number} ownerId ID of lead owner.
     * @param {string} [body] New lead name.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    setName: async (t, s, n = {}) => {
      se("setName", "ownerId", t);
      const r = "/portfolio-finder/{ownerId}/save".replace("{ownerId}", encodeURIComponent(String(t))), i = new URL(r, K);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "POST", ...o, ...n }, d = {}, c = {};
      await ee(d, e), d["Content-Type"] = "application/json", Z(i, c);
      let u = o && o.headers ? o.headers : {};
      return l.headers = { ...d, ...u, ...n.headers }, l.data = kt(s, l, e), {
        url: J(i),
        options: l
      };
    },
    /**
     * 
     * @summary Skip trace a owner\'s contact name for contact information.
     * @param {number} ownerId ID of lead owner.
     * @param {number} id ID OR priority of owner contact.
     * @param {boolean} [isPriority] Is ID priority number.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    skipTraceContact: async (t, s, n, r = {}) => {
      se("skipTraceContact", "ownerId", t), se("skipTraceContact", "id", s);
      const i = "/portfolio-finder/{ownerId}/contacts/{id}/skip-trace".replace("{ownerId}", encodeURIComponent(String(t))).replace("{id}", encodeURIComponent(String(s))), o = new URL(i, K);
      let l;
      e && (l = e.baseOptions);
      const d = { method: "POST", ...l, ...r }, c = {}, u = {};
      await ee(c, e), n !== void 0 && (u.isPriority = n), Z(o, u);
      let m = l && l.headers ? l.headers : {};
      return d.headers = { ...c, ...m, ...r.headers }, {
        url: J(o),
        options: d
      };
    },
    /**
     * 
     * @summary Retrieve list of states enabled for portfolio finder.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    states: async (t = {}) => {
      const s = "/portfolio-finder/states", n = new URL(s, K);
      let r;
      e && (r = e.baseOptions);
      const i = { method: "GET", ...r, ...t }, o = {}, l = {};
      await ee(o, e), Z(n, l);
      let d = r && r.headers ? r.headers : {};
      return i.headers = { ...o, ...d, ...t.headers }, {
        url: J(n),
        options: i
      };
    },
    /**
     * 
     * @summary Retrieve possible contacts from previous skip trace.
     * @param {number} ownerId ID of lead owner.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    tracedContacts: async (t, s = {}) => {
      se("tracedContacts", "ownerId", t);
      const n = "/portfolio-finder/{ownerId}/contacts/skip-traced".replace("{ownerId}", encodeURIComponent(String(t))), r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "GET", ...i, ...s }, l = {}, d = {};
      await ee(l, e), Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, {
        url: J(r),
        options: o
      };
    },
    /**
     * 
     * @summary Unassign properties from custom lead.
     * @param {number} ownerId 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    unassignOwner: async (t, s, n = {}) => {
      se("unassignOwner", "ownerId", t), se("unassignOwner", "id", s);
      const r = "/portfolio-finder/{ownerId}/{id}/unassign".replace("{ownerId}", encodeURIComponent(String(t))).replace("{id}", encodeURIComponent(String(s))), i = new URL(r, K);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "POST", ...o, ...n }, d = {}, c = {};
      await ee(d, e), Z(i, c);
      let u = o && o.headers ? o.headers : {};
      return l.headers = { ...d, ...u, ...n.headers }, {
        url: J(i),
        options: l
      };
    },
    /**
     * 
     * @summary Update contact information for a owner.
     * @param {number} ownerId ID of lead owner.
     * @param {ContactModel} [contactModel] Contact values to update
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateContact: async (t, s, n = {}) => {
      se("updateContact", "ownerId", t);
      const r = "/portfolio-finder/{ownerId}/contacts".replace("{ownerId}", encodeURIComponent(String(t))), i = new URL(r, K);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "POST", ...o, ...n }, d = {}, c = {};
      await ee(d, e), d["Content-Type"] = "application/json", Z(i, c);
      let u = o && o.headers ? o.headers : {};
      return l.headers = { ...d, ...u, ...n.headers }, l.data = kt(s, l, e), {
        url: J(i),
        options: l
      };
    },
    /**
     * 
     * @summary Update a lead owner\'s notes.
     * @param {number} ownerId ID of lead owner.
     * @param {string} [body] Notes to update
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateNotes: async (t, s, n = {}) => {
      se("updateNotes", "ownerId", t);
      const r = "/portfolio-finder/{ownerId}/notes".replace("{ownerId}", encodeURIComponent(String(t))), i = new URL(r, K);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "POST", ...o, ...n }, d = {}, c = {};
      await ee(d, e), d["Content-Type"] = "application/json", Z(i, c);
      let u = o && o.headers ? o.headers : {};
      return l.headers = { ...d, ...u, ...n.headers }, l.data = kt(s, l, e), {
        url: J(i),
        options: l
      };
    },
    /**
     * 
     * @summary Lookup zip codes for auto-completion.
     * @param {string} state 
     * @param {string} zip 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    zipLookup: async (t, s, n = {}) => {
      se("zipLookup", "state", t), se("zipLookup", "zip", s);
      const r = "/portfolio-finder/lookup/zip/{state}/{zip}".replace("{state}", encodeURIComponent(String(t))).replace("{zip}", encodeURIComponent(String(s))), i = new URL(r, K);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "GET", ...o, ...n }, d = {}, c = {};
      await ee(d, e), Z(i, c);
      let u = o && o.headers ? o.headers : {};
      return l.headers = { ...d, ...u, ...n.headers }, {
        url: J(i),
        options: l
      };
    }
  };
}, lT = function(e) {
  const t = iT(e);
  return {
    /**
     * 
     * @summary Reassign properties to custom lead.
     * @param {AssignOwnerRequest} [assignOwnerRequest] Create owner model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async assignOwner(s, n) {
      var l, d;
      const r = await t.assignOwner(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["PortfolioFinderApi.assignOwner"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    },
    /**
     * 
     * @summary Retrieve list of counties enabled for portfolio finder.
     * @param {string} state 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async counties(s, n) {
      var l, d;
      const r = await t.counties(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["PortfolioFinderApi.counties"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    },
    /**
     * 
     * @summary Create custom lead for user and reassign properties to it.
     * @param {CreateOwnerRequest} [createOwnerRequest] Create owner model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createOwner(s, n) {
      var l, d;
      const r = await t.createOwner(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["PortfolioFinderApi.createOwner"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    },
    /**
     * 
     * @summary List leads favorite by user.
     * @param {string} key 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async downloadExport(s, n) {
      var l, d;
      const r = await t.downloadExport(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["PortfolioFinderApi.downloadExport"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    },
    /**
     * 
     * @summary List leads favorite by user.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async exportFavorites(s) {
      var o, l;
      const n = await t.exportFavorites(s), r = (e == null ? void 0 : e.serverIndex) ?? 0, i = (l = (o = Q["PortfolioFinderApi.exportFavorites"]) == null ? void 0 : o[r]) == null ? void 0 : l.url;
      return (d, c) => _(n, X, G, e)(d, i || c);
    },
    /**
     * 
     * @summary Lead set as favorite.
     * @param {number} ownerId ID of lead owner.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async favoriteOwner(s, n) {
      var l, d;
      const r = await t.favoriteOwner(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["PortfolioFinderApi.favoriteOwner"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    },
    /**
     * 
     * @summary Retrieve owner\'s agents.
     * @param {number} ownerId ID of lead owner.
     * @param {number} [p] Page
     * @param {number} [ps] Page size
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getAgents(s, n, r, i) {
      var c, u;
      const o = await t.getAgents(s, n, r, i), l = (e == null ? void 0 : e.serverIndex) ?? 0, d = (u = (c = Q["PortfolioFinderApi.getAgents"]) == null ? void 0 : c[l]) == null ? void 0 : u.url;
      return (m, f) => _(o, X, G, e)(m, d || f);
    },
    /**
     * 
     * @summary Retrieve owner\'s potential client value.
     * @param {number} ownerId ID of lead owner.
     * @param {PropertyGroupType} [type] Property type to summarize by.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getClientValue(s, n, r) {
      var d, c;
      const i = await t.getClientValue(s, n, r), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (c = (d = Q["PortfolioFinderApi.getClientValue"]) == null ? void 0 : d[o]) == null ? void 0 : c.url;
      return (u, m) => _(i, X, G, e)(u, l || m);
    },
    /**
     * 
     * @summary Retrieve a single lead contact for owner.
     * @param {number} ownerId ID of lead owner.
     * @param {number} id ID OR priority of owner contact.
     * @param {boolean} [isPriority] Is ID priority number.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getContact(s, n, r, i) {
      var c, u;
      const o = await t.getContact(s, n, r, i), l = (e == null ? void 0 : e.serverIndex) ?? 0, d = (u = (c = Q["PortfolioFinderApi.getContact"]) == null ? void 0 : c[l]) == null ? void 0 : u.url;
      return (m, f) => _(o, X, G, e)(m, d || f);
    },
    /**
     * 
     * @summary Retrieve lead contacts for owner.
     * @param {number} ownerId ID of lead owner.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getContacts(s, n) {
      var l, d;
      const r = await t.getContacts(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["PortfolioFinderApi.getContacts"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    },
    /**
     * 
     * @summary List leads favorite by user.
     * @param {number} [page] Current page to return of owner\&#39;s properties.
     * @param {number} [pageSize] Total properties per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getFavorites(s, n, r) {
      var d, c;
      const i = await t.getFavorites(s, n, r), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (c = (d = Q["PortfolioFinderApi.getFavorites"]) == null ? void 0 : d[o]) == null ? void 0 : c.url;
      return (u, m) => _(i, X, G, e)(u, l || m);
    },
    /**
     * 
     * @summary List leads ignored by user.
     * @param {number} [page] Current page to return of owner\&#39;s properties.
     * @param {number} [pageSize] Total properties per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getFiduciaryOwners(s, n, r) {
      var d, c;
      const i = await t.getFiduciaryOwners(s, n, r), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (c = (d = Q["PortfolioFinderApi.getFiduciaryOwners"]) == null ? void 0 : d[o]) == null ? void 0 : c.url;
      return (u, m) => _(i, X, G, e)(u, l || m);
    },
    /**
     * 
     * @summary List leads ignored by user.
     * @param {number} [page] Current page to return of owner\&#39;s properties.
     * @param {number} [pageSize] Total properties per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getIgnored(s, n, r) {
      var d, c;
      const i = await t.getIgnored(s, n, r), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (c = (d = Q["PortfolioFinderApi.getIgnored"]) == null ? void 0 : d[o]) == null ? void 0 : c.url;
      return (u, m) => _(i, X, G, e)(u, l || m);
    },
    /**
     * 
     * @summary List agents marked as investment managers.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getInvestmentManagers(s) {
      var o, l;
      const n = await t.getInvestmentManagers(s), r = (e == null ? void 0 : e.serverIndex) ?? 0, i = (l = (o = Q["PortfolioFinderApi.getInvestmentManagers"]) == null ? void 0 : o[r]) == null ? void 0 : l.url;
      return (d, c) => _(n, X, G, e)(d, i || c);
    },
    /**
     * 
     * @summary List leads created by user.
     * @param {number} [page] Current page to return of owner\&#39;s properties.
     * @param {number} [pageSize] Total properties per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getLeadCustomOwners(s, n, r) {
      var d, c;
      const i = await t.getLeadCustomOwners(s, n, r), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (c = (d = Q["PortfolioFinderApi.getLeadCustomOwners"]) == null ? void 0 : d[o]) == null ? void 0 : c.url;
      return (u, m) => _(i, X, G, e)(u, l || m);
    },
    /**
     * 
     * @summary Retrieve lead owner\'s information.
     * @param {number} ownerId ID of lead owner.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getOwner(s, n) {
      var l, d;
      const r = await t.getOwner(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["PortfolioFinderApi.getOwner"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    },
    /**
     * 
     * @summary Retrieve owner\'s properties.
     * @param {number} ownerId ID of lead owner.
     * @param {number} [page] Current page to return of owner\&#39;s properties.
     * @param {number} [pageSize] Total properties per page.
     * @param {PropertyGroupType} [type] Property group type.
     * @param {boolean} [pmArea] Filter in PM Area only
     * @param {boolean} [c] Is id a custom owner id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getProperties(s, n, r, i, o, l, d) {
      var f, v;
      const c = await t.getProperties(s, n, r, i, o, l, d), u = (e == null ? void 0 : e.serverIndex) ?? 0, m = (v = (f = Q["PortfolioFinderApi.getProperties"]) == null ? void 0 : f[u]) == null ? void 0 : v.url;
      return (b, w) => _(c, X, G, e)(b, m || w);
    },
    /**
     * 
     * @summary Retrieve owner\'s properties geographic locations.
     * @param {number} ownerId ID of lead owner.
     * @param {PropertyGroupType} [type] Property type to list.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getPropertiesGeo(s, n, r) {
      var d, c;
      const i = await t.getPropertiesGeo(s, n, r), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (c = (d = Q["PortfolioFinderApi.getPropertiesGeo"]) == null ? void 0 : d[o]) == null ? void 0 : c.url;
      return (u, m) => _(i, X, G, e)(u, l || m);
    },
    /**
     * 
     * @summary List agents marked as property managers.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getPropertyManagers(s) {
      var o, l;
      const n = await t.getPropertyManagers(s), r = (e == null ? void 0 : e.serverIndex) ?? 0, i = (l = (o = Q["PortfolioFinderApi.getPropertyManagers"]) == null ? void 0 : o[r]) == null ? void 0 : l.url;
      return (d, c) => _(n, X, G, e)(d, i || c);
    },
    /**
     * 
     * @summary Retrieve owner\'s property types.
     * @param {number} ownerId ID of lead owner.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getPropertyTypes(s, n) {
      var l, d;
      const r = await t.getPropertyTypes(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["PortfolioFinderApi.getPropertyTypes"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    },
    /**
     * 
     * @summary Statistics for potential leads in users management area
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getStats(s) {
      var o, l;
      const n = await t.getStats(s), r = (e == null ? void 0 : e.serverIndex) ?? 0, i = (l = (o = Q["PortfolioFinderApi.getStats"]) == null ? void 0 : o[r]) == null ? void 0 : l.url;
      return (d, c) => _(n, X, G, e)(d, i || c);
    },
    /**
     * 
     * @summary Ignore a lead from showing up in searches.
     * @param {number} ownerId ID of lead owner.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async ignoreOwner(s, n) {
      var l, d;
      const r = await t.ignoreOwner(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["PortfolioFinderApi.ignoreOwner"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    },
    /**
     * 
     * @summary Retrieve owner\'s names.
     * @param {number} ownerId ID of lead owner.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async ownerNames(s, n) {
      var l, d;
      const r = await t.ownerNames(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["PortfolioFinderApi.ownerNames"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    },
    /**
     * 
     * @summary Lead remove all user favorites.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async removeAllFavorite(s) {
      var o, l;
      const n = await t.removeAllFavorite(s), r = (e == null ? void 0 : e.serverIndex) ?? 0, i = (l = (o = Q["PortfolioFinderApi.removeAllFavorite"]) == null ? void 0 : o[r]) == null ? void 0 : l.url;
      return (d, c) => _(n, X, G, e)(d, i || c);
    },
    /**
     * 
     * @summary Lead unset as favorite.
     * @param {number} ownerId ID of lead owner.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async removeFavoriteOwner(s, n) {
      var l, d;
      const r = await t.removeFavoriteOwner(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["PortfolioFinderApi.removeFavoriteOwner"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    },
    /**
     * 
     * @summary Remove a lead Ignore.
     * @param {number} ownerId ID of lead owner.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async removeOwnerIgnore(s, n) {
      var l, d;
      const r = await t.removeOwnerIgnore(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["PortfolioFinderApi.removeOwnerIgnore"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    },
    /**
     * 
     * @summary Search for lead owners.
     * @param {LeadsSearchModel} [leadsSearchModel] Search model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async search(s, n) {
      var l, d;
      const r = await t.search(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["PortfolioFinderApi.search"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    },
    /**
     * 
     * @summary Set agent characteristics.
     * @param {string} mlsSource MLS source of agent.
     * @param {string} agentId ID of mls agent.
     * @param {boolean} [pm] Agent is part of a property management company.
     * @param {boolean} [ia] Agent is part of a investor management
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async setAgent(s, n, r, i, o) {
      var u, m;
      const l = await t.setAgent(s, n, r, i, o), d = (e == null ? void 0 : e.serverIndex) ?? 0, c = (m = (u = Q["PortfolioFinderApi.setAgent"]) == null ? void 0 : u[d]) == null ? void 0 : m.url;
      return (f, v) => _(l, X, G, e)(f, c || v);
    },
    /**
     * 
     * @summary Toggle lead as being a fiduciary.
     * @param {number} ownerId ID of lead owner.
     * @param {boolean} [fiduciary] Set owner as fiduciary or not.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async setFiduciary(s, n, r) {
      var d, c;
      const i = await t.setFiduciary(s, n, r), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (c = (d = Q["PortfolioFinderApi.setFiduciary"]) == null ? void 0 : d[o]) == null ? void 0 : c.url;
      return (u, m) => _(i, X, G, e)(u, l || m);
    },
    /**
     * 
     * @summary Change a lead\'s name.
     * @param {number} ownerId ID of lead owner.
     * @param {string} [body] New lead name.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async setName(s, n, r) {
      var d, c;
      const i = await t.setName(s, n, r), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (c = (d = Q["PortfolioFinderApi.setName"]) == null ? void 0 : d[o]) == null ? void 0 : c.url;
      return (u, m) => _(i, X, G, e)(u, l || m);
    },
    /**
     * 
     * @summary Skip trace a owner\'s contact name for contact information.
     * @param {number} ownerId ID of lead owner.
     * @param {number} id ID OR priority of owner contact.
     * @param {boolean} [isPriority] Is ID priority number.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async skipTraceContact(s, n, r, i) {
      var c, u;
      const o = await t.skipTraceContact(s, n, r, i), l = (e == null ? void 0 : e.serverIndex) ?? 0, d = (u = (c = Q["PortfolioFinderApi.skipTraceContact"]) == null ? void 0 : c[l]) == null ? void 0 : u.url;
      return (m, f) => _(o, X, G, e)(m, d || f);
    },
    /**
     * 
     * @summary Retrieve list of states enabled for portfolio finder.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async states(s) {
      var o, l;
      const n = await t.states(s), r = (e == null ? void 0 : e.serverIndex) ?? 0, i = (l = (o = Q["PortfolioFinderApi.states"]) == null ? void 0 : o[r]) == null ? void 0 : l.url;
      return (d, c) => _(n, X, G, e)(d, i || c);
    },
    /**
     * 
     * @summary Retrieve possible contacts from previous skip trace.
     * @param {number} ownerId ID of lead owner.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async tracedContacts(s, n) {
      var l, d;
      const r = await t.tracedContacts(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["PortfolioFinderApi.tracedContacts"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    },
    /**
     * 
     * @summary Unassign properties from custom lead.
     * @param {number} ownerId 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async unassignOwner(s, n, r) {
      var d, c;
      const i = await t.unassignOwner(s, n, r), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (c = (d = Q["PortfolioFinderApi.unassignOwner"]) == null ? void 0 : d[o]) == null ? void 0 : c.url;
      return (u, m) => _(i, X, G, e)(u, l || m);
    },
    /**
     * 
     * @summary Update contact information for a owner.
     * @param {number} ownerId ID of lead owner.
     * @param {ContactModel} [contactModel] Contact values to update
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateContact(s, n, r) {
      var d, c;
      const i = await t.updateContact(s, n, r), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (c = (d = Q["PortfolioFinderApi.updateContact"]) == null ? void 0 : d[o]) == null ? void 0 : c.url;
      return (u, m) => _(i, X, G, e)(u, l || m);
    },
    /**
     * 
     * @summary Update a lead owner\'s notes.
     * @param {number} ownerId ID of lead owner.
     * @param {string} [body] Notes to update
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateNotes(s, n, r) {
      var d, c;
      const i = await t.updateNotes(s, n, r), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (c = (d = Q["PortfolioFinderApi.updateNotes"]) == null ? void 0 : d[o]) == null ? void 0 : c.url;
      return (u, m) => _(i, X, G, e)(u, l || m);
    },
    /**
     * 
     * @summary Lookup zip codes for auto-completion.
     * @param {string} state 
     * @param {string} zip 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async zipLookup(s, n, r) {
      var d, c;
      const i = await t.zipLookup(s, n, r), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (c = (d = Q["PortfolioFinderApi.zipLookup"]) == null ? void 0 : d[o]) == null ? void 0 : c.url;
      return (u, m) => _(i, X, G, e)(u, l || m);
    }
  };
}, iA = function(e, t, s) {
  const n = lT(e);
  return {
    /**
     * 
     * @summary Reassign properties to custom lead.
     * @param {AssignOwnerRequest} [assignOwnerRequest] Create owner model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    assignOwner(r, i) {
      return n.assignOwner(r, i).then((o) => o(s, t));
    },
    /**
     * 
     * @summary Retrieve list of counties enabled for portfolio finder.
     * @param {string} state 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    counties(r, i) {
      return n.counties(r, i).then((o) => o(s, t));
    },
    /**
     * 
     * @summary Create custom lead for user and reassign properties to it.
     * @param {CreateOwnerRequest} [createOwnerRequest] Create owner model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createOwner(r, i) {
      return n.createOwner(r, i).then((o) => o(s, t));
    },
    /**
     * 
     * @summary List leads favorite by user.
     * @param {string} key 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    downloadExport(r, i) {
      return n.downloadExport(r, i).then((o) => o(s, t));
    },
    /**
     * 
     * @summary List leads favorite by user.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    exportFavorites(r) {
      return n.exportFavorites(r).then((i) => i(s, t));
    },
    /**
     * 
     * @summary Lead set as favorite.
     * @param {number} ownerId ID of lead owner.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    favoriteOwner(r, i) {
      return n.favoriteOwner(r, i).then((o) => o(s, t));
    },
    /**
     * 
     * @summary Retrieve owner\'s agents.
     * @param {number} ownerId ID of lead owner.
     * @param {number} [p] Page
     * @param {number} [ps] Page size
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAgents(r, i, o, l) {
      return n.getAgents(r, i, o, l).then((d) => d(s, t));
    },
    /**
     * 
     * @summary Retrieve owner\'s potential client value.
     * @param {number} ownerId ID of lead owner.
     * @param {PropertyGroupType} [type] Property type to summarize by.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getClientValue(r, i, o) {
      return n.getClientValue(r, i, o).then((l) => l(s, t));
    },
    /**
     * 
     * @summary Retrieve a single lead contact for owner.
     * @param {number} ownerId ID of lead owner.
     * @param {number} id ID OR priority of owner contact.
     * @param {boolean} [isPriority] Is ID priority number.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getContact(r, i, o, l) {
      return n.getContact(r, i, o, l).then((d) => d(s, t));
    },
    /**
     * 
     * @summary Retrieve lead contacts for owner.
     * @param {number} ownerId ID of lead owner.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getContacts(r, i) {
      return n.getContacts(r, i).then((o) => o(s, t));
    },
    /**
     * 
     * @summary List leads favorite by user.
     * @param {number} [page] Current page to return of owner\&#39;s properties.
     * @param {number} [pageSize] Total properties per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getFavorites(r, i, o) {
      return n.getFavorites(r, i, o).then((l) => l(s, t));
    },
    /**
     * 
     * @summary List leads ignored by user.
     * @param {number} [page] Current page to return of owner\&#39;s properties.
     * @param {number} [pageSize] Total properties per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getFiduciaryOwners(r, i, o) {
      return n.getFiduciaryOwners(r, i, o).then((l) => l(s, t));
    },
    /**
     * 
     * @summary List leads ignored by user.
     * @param {number} [page] Current page to return of owner\&#39;s properties.
     * @param {number} [pageSize] Total properties per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getIgnored(r, i, o) {
      return n.getIgnored(r, i, o).then((l) => l(s, t));
    },
    /**
     * 
     * @summary List agents marked as investment managers.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getInvestmentManagers(r) {
      return n.getInvestmentManagers(r).then((i) => i(s, t));
    },
    /**
     * 
     * @summary List leads created by user.
     * @param {number} [page] Current page to return of owner\&#39;s properties.
     * @param {number} [pageSize] Total properties per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getLeadCustomOwners(r, i, o) {
      return n.getLeadCustomOwners(r, i, o).then((l) => l(s, t));
    },
    /**
     * 
     * @summary Retrieve lead owner\'s information.
     * @param {number} ownerId ID of lead owner.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getOwner(r, i) {
      return n.getOwner(r, i).then((o) => o(s, t));
    },
    /**
     * 
     * @summary Retrieve owner\'s properties.
     * @param {number} ownerId ID of lead owner.
     * @param {number} [page] Current page to return of owner\&#39;s properties.
     * @param {number} [pageSize] Total properties per page.
     * @param {PropertyGroupType} [type] Property group type.
     * @param {boolean} [pmArea] Filter in PM Area only
     * @param {boolean} [c] Is id a custom owner id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProperties(r, i, o, l, d, c, u) {
      return n.getProperties(r, i, o, l, d, c, u).then((m) => m(s, t));
    },
    /**
     * 
     * @summary Retrieve owner\'s properties geographic locations.
     * @param {number} ownerId ID of lead owner.
     * @param {PropertyGroupType} [type] Property type to list.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPropertiesGeo(r, i, o) {
      return n.getPropertiesGeo(r, i, o).then((l) => l(s, t));
    },
    /**
     * 
     * @summary List agents marked as property managers.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPropertyManagers(r) {
      return n.getPropertyManagers(r).then((i) => i(s, t));
    },
    /**
     * 
     * @summary Retrieve owner\'s property types.
     * @param {number} ownerId ID of lead owner.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPropertyTypes(r, i) {
      return n.getPropertyTypes(r, i).then((o) => o(s, t));
    },
    /**
     * 
     * @summary Statistics for potential leads in users management area
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getStats(r) {
      return n.getStats(r).then((i) => i(s, t));
    },
    /**
     * 
     * @summary Ignore a lead from showing up in searches.
     * @param {number} ownerId ID of lead owner.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    ignoreOwner(r, i) {
      return n.ignoreOwner(r, i).then((o) => o(s, t));
    },
    /**
     * 
     * @summary Retrieve owner\'s names.
     * @param {number} ownerId ID of lead owner.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    ownerNames(r, i) {
      return n.ownerNames(r, i).then((o) => o(s, t));
    },
    /**
     * 
     * @summary Lead remove all user favorites.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    removeAllFavorite(r) {
      return n.removeAllFavorite(r).then((i) => i(s, t));
    },
    /**
     * 
     * @summary Lead unset as favorite.
     * @param {number} ownerId ID of lead owner.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    removeFavoriteOwner(r, i) {
      return n.removeFavoriteOwner(r, i).then((o) => o(s, t));
    },
    /**
     * 
     * @summary Remove a lead Ignore.
     * @param {number} ownerId ID of lead owner.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    removeOwnerIgnore(r, i) {
      return n.removeOwnerIgnore(r, i).then((o) => o(s, t));
    },
    /**
     * 
     * @summary Search for lead owners.
     * @param {LeadsSearchModel} [leadsSearchModel] Search model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    search(r, i) {
      return n.search(r, i).then((o) => o(s, t));
    },
    /**
     * 
     * @summary Set agent characteristics.
     * @param {string} mlsSource MLS source of agent.
     * @param {string} agentId ID of mls agent.
     * @param {boolean} [pm] Agent is part of a property management company.
     * @param {boolean} [ia] Agent is part of a investor management
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    setAgent(r, i, o, l, d) {
      return n.setAgent(r, i, o, l, d).then((c) => c(s, t));
    },
    /**
     * 
     * @summary Toggle lead as being a fiduciary.
     * @param {number} ownerId ID of lead owner.
     * @param {boolean} [fiduciary] Set owner as fiduciary or not.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    setFiduciary(r, i, o) {
      return n.setFiduciary(r, i, o).then((l) => l(s, t));
    },
    /**
     * 
     * @summary Change a lead\'s name.
     * @param {number} ownerId ID of lead owner.
     * @param {string} [body] New lead name.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    setName(r, i, o) {
      return n.setName(r, i, o).then((l) => l(s, t));
    },
    /**
     * 
     * @summary Skip trace a owner\'s contact name for contact information.
     * @param {number} ownerId ID of lead owner.
     * @param {number} id ID OR priority of owner contact.
     * @param {boolean} [isPriority] Is ID priority number.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    skipTraceContact(r, i, o, l) {
      return n.skipTraceContact(r, i, o, l).then((d) => d(s, t));
    },
    /**
     * 
     * @summary Retrieve list of states enabled for portfolio finder.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    states(r) {
      return n.states(r).then((i) => i(s, t));
    },
    /**
     * 
     * @summary Retrieve possible contacts from previous skip trace.
     * @param {number} ownerId ID of lead owner.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    tracedContacts(r, i) {
      return n.tracedContacts(r, i).then((o) => o(s, t));
    },
    /**
     * 
     * @summary Unassign properties from custom lead.
     * @param {number} ownerId 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    unassignOwner(r, i, o) {
      return n.unassignOwner(r, i, o).then((l) => l(s, t));
    },
    /**
     * 
     * @summary Update contact information for a owner.
     * @param {number} ownerId ID of lead owner.
     * @param {ContactModel} [contactModel] Contact values to update
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateContact(r, i, o) {
      return n.updateContact(r, i, o).then((l) => l(s, t));
    },
    /**
     * 
     * @summary Update a lead owner\'s notes.
     * @param {number} ownerId ID of lead owner.
     * @param {string} [body] Notes to update
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateNotes(r, i, o) {
      return n.updateNotes(r, i, o).then((l) => l(s, t));
    },
    /**
     * 
     * @summary Lookup zip codes for auto-completion.
     * @param {string} state 
     * @param {string} zip 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    zipLookup(r, i, o) {
      return n.zipLookup(r, i, o).then((l) => l(s, t));
    }
  };
}, dT = function(e) {
  return {
    /**
     * 
     * @summary Add new member to portfolio.
     * @param {number} portfolioId 
     * @param {AddClientModel} [addClientModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addMember: async (t, s, n = {}) => {
      se("addMember", "portfolioId", t);
      const r = "/portfolio-insights/portfolios/{portfolioId}/add-member".replace("{portfolioId}", encodeURIComponent(String(t))), i = new URL(r, K);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "POST", ...o, ...n }, d = {}, c = {};
      await ee(d, e), d["Content-Type"] = "application/json", Z(i, c);
      let u = o && o.headers ? o.headers : {};
      return l.headers = { ...d, ...u, ...n.headers }, l.data = kt(s, l, e), {
        url: J(i),
        options: l
      };
    },
    /**
     * 
     * @summary Add new portfolio for client
     * @param {CreatePortfolioModel} [createPortfolioModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addPortfolio: async (t, s = {}) => {
      const n = "/portfolio-insights/portfolios/add", r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "POST", ...i, ...s }, l = {}, d = {};
      await ee(l, e), l["Content-Type"] = "application/json", Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, o.data = kt(t, o, e), {
        url: J(r),
        options: o
      };
    },
    /**
     * 
     * @summary Add property to portfolio.
     * @param {number} portfolioId Unique portfolio ID
     * @param {string} propId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addProperty: async (t, s, n = {}) => {
      se("addProperty", "portfolioId", t), se("addProperty", "propId", s);
      const r = "/portfolio-insights/portfolios/{portfolioId}/property/{propId}".replace("{portfolioId}", encodeURIComponent(String(t))).replace("{propId}", encodeURIComponent(String(s))), i = new URL(r, K);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "POST", ...o, ...n }, d = {}, c = {};
      await ee(d, e), Z(i, c);
      let u = o && o.headers ? o.headers : {};
      return l.headers = { ...d, ...u, ...n.headers }, {
        url: J(i),
        options: l
      };
    },
    /**
     * 
     * @summary Delete portfolio
     * @param {number} portfolioId Portfolio ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deletePortfolio: async (t, s = {}) => {
      se("deletePortfolio", "portfolioId", t);
      const n = "/portfolio-insights/portfolios/{portfolioId}".replace("{portfolioId}", encodeURIComponent(String(t))), r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "DELETE", ...i, ...s }, l = {}, d = {};
      await ee(l, e), Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, {
        url: J(r),
        options: o
      };
    },
    /**
     * 
     * @summary Edit portfolio.
     * @param {number} portfolioId Unique portfolio ID
     * @param {EditPortfolioModel} [editPortfolioModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    editPortfolio: async (t, s, n = {}) => {
      se("editPortfolio", "portfolioId", t);
      const r = "/portfolio-insights/portfolios/{portfolioId}".replace("{portfolioId}", encodeURIComponent(String(t))), i = new URL(r, K);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "PATCH", ...o, ...n }, d = {}, c = {};
      await ee(d, e), d["Content-Type"] = "application/json", Z(i, c);
      let u = o && o.headers ? o.headers : {};
      return l.headers = { ...d, ...u, ...n.headers }, l.data = kt(s, l, e), {
        url: J(i),
        options: l
      };
    },
    /**
     * 
     * @summary Find property from address.
     * @param {AddPropertyModel} [addPropertyModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    findProperty: async (t, s = {}) => {
      const n = "/portfolio-insights/client/property/find", r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "POST", ...i, ...s }, l = {}, d = {};
      await ee(l, e), l["Content-Type"] = "application/json", Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, o.data = kt(t, o, e), {
        url: J(r),
        options: o
      };
    },
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getMySummary: async (t = {}) => {
      const s = "/portfolio-insights/portfolios/summary", n = new URL(s, K);
      let r;
      e && (r = e.baseOptions);
      const i = { method: "GET", ...r, ...t }, o = {}, l = {};
      await ee(o, e), Z(n, l);
      let d = r && r.headers ? r.headers : {};
      return i.headers = { ...o, ...d, ...t.headers }, {
        url: J(n),
        options: i
      };
    },
    /**
     * 
     * @param {number} portfolioId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getOwnerChecklist: async (t, s = {}) => {
      se("getOwnerChecklist", "portfolioId", t);
      const n = "/portfolio-insights/portfolios/{portfolioId}/owner-checklist".replace("{portfolioId}", encodeURIComponent(String(t))), r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "POST", ...i, ...s }, l = {}, d = {};
      await ee(l, e), Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, {
        url: J(r),
        options: o
      };
    },
    /**
     * 
     * @summary Retrieve a single portfolio.
     * @param {number} portfolioId Unique portfolio ID
     * @param {boolean} [s] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPortfolio: async (t, s, n = {}) => {
      se("getPortfolio", "portfolioId", t);
      const r = "/portfolio-insights/portfolios/{portfolioId}".replace("{portfolioId}", encodeURIComponent(String(t))), i = new URL(r, K);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "GET", ...o, ...n }, d = {}, c = {};
      await ee(d, e), s !== void 0 && (c.s = s), Z(i, c);
      let u = o && o.headers ? o.headers : {};
      return l.headers = { ...d, ...u, ...n.headers }, {
        url: J(i),
        options: l
      };
    },
    /**
     * 
     * @summary List properties for portfolio.
     * @param {number} portfolioId Unique portfolio ID
     * @param {boolean} [d] Include properties marked for deletion.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPortfolioProperties: async (t, s, n = {}) => {
      se("getPortfolioProperties", "portfolioId", t);
      const r = "/portfolio-insights/portfolios/{portfolioId}/properties".replace("{portfolioId}", encodeURIComponent(String(t))), i = new URL(r, K);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "GET", ...o, ...n }, d = {}, c = {};
      await ee(d, e), s !== void 0 && (c.d = s), Z(i, c);
      let u = o && o.headers ? o.headers : {};
      return l.headers = { ...d, ...u, ...n.headers }, {
        url: J(i),
        options: l
      };
    },
    /**
     * 
     * @param {number} portfolioId 
     * @param {number} propId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPortfolioProperty: async (t, s, n = {}) => {
      se("getPortfolioProperty", "portfolioId", t), se("getPortfolioProperty", "propId", s);
      const r = "/portfolio-insights/portfolios/{portfolioId}/properties/{propId}".replace("{portfolioId}", encodeURIComponent(String(t))).replace("{propId}", encodeURIComponent(String(s))), i = new URL(r, K);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "GET", ...o, ...n }, d = {}, c = {};
      await ee(d, e), Z(i, c);
      let u = o && o.headers ? o.headers : {};
      return l.headers = { ...d, ...u, ...n.headers }, {
        url: J(i),
        options: l
      };
    },
    /**
     * 
     * @summary List portfolios associated with agent/broker.
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {boolean} [sortAsc] Sort ascending, else descending
     * @param {string} [searchBy] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPortfolios: async (t, s, n, r, i = {}) => {
      const o = "/portfolio-insights/portfolios", l = new URL(o, K);
      let d;
      e && (d = e.baseOptions);
      const c = { method: "GET", ...d, ...i }, u = {}, m = {};
      await ee(u, e), t !== void 0 && (m.page = t), s !== void 0 && (m.pageSize = s), n !== void 0 && (m.sortAsc = n), r !== void 0 && (m.searchBy = r), Z(l, m);
      let f = d && d.headers ? d.headers : {};
      return c.headers = { ...u, ...f, ...i.headers }, {
        url: J(l),
        options: c
      };
    },
    /**
     * 
     * @summary Remove member from portfolio.
     * @param {number} portfolioId 
     * @param {number} [memberId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    removeMember: async (t, s, n = {}) => {
      se("removeMember", "portfolioId", t);
      const r = "/portfolio-insights/portfolios/{portfolioId}/remove-member".replace("{portfolioId}", encodeURIComponent(String(t))), i = new URL(r, K);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "POST", ...o, ...n }, d = {}, c = {}, u = new (e && e.formDataCtor || FormData)();
      await ee(d, e), s !== void 0 && u.append("memberId", s), d["Content-Type"] = "multipart/form-data", Z(i, c);
      let m = o && o.headers ? o.headers : {};
      return l.headers = { ...d, ...m, ...n.headers }, l.data = u, {
        url: J(i),
        options: l
      };
    },
    /**
     * 
     * @summary Mark property for deletion, to be deleted 45 days once marked.
     * @param {number} portfolioId Unique portfolio ID
     * @param {string} propId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    removeProperty: async (t, s, n = {}) => {
      se("removeProperty", "portfolioId", t), se("removeProperty", "propId", s);
      const r = "/portfolio-insights/portfolios/{portfolioId}/property/{propId}".replace("{portfolioId}", encodeURIComponent(String(t))).replace("{propId}", encodeURIComponent(String(s))), i = new URL(r, K);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "DELETE", ...o, ...n }, d = {}, c = {};
      await ee(d, e), Z(i, c);
      let u = o && o.headers ? o.headers : {};
      return l.headers = { ...d, ...u, ...n.headers }, {
        url: J(i),
        options: l
      };
    },
    /**
     * 
     * @summary Restore property from being deleted.
     * @param {number} portfolioId Unique portfolio ID
     * @param {string} propId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    restoreProperty: async (t, s, n = {}) => {
      se("restoreProperty", "portfolioId", t), se("restoreProperty", "propId", s);
      const r = "/portfolio-insights/portfolios/{portfolioId}/property/{propId}/restore".replace("{portfolioId}", encodeURIComponent(String(t))).replace("{propId}", encodeURIComponent(String(s))), i = new URL(r, K);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "POST", ...o, ...n }, d = {}, c = {};
      await ee(d, e), Z(i, c);
      let u = o && o.headers ? o.headers : {};
      return l.headers = { ...d, ...u, ...n.headers }, {
        url: J(i),
        options: l
      };
    }
  };
}, cT = function(e) {
  const t = dT(e);
  return {
    /**
     * 
     * @summary Add new member to portfolio.
     * @param {number} portfolioId 
     * @param {AddClientModel} [addClientModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async addMember(s, n, r) {
      var d, c;
      const i = await t.addMember(s, n, r), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (c = (d = Q["PortfolioInsightsApi.addMember"]) == null ? void 0 : d[o]) == null ? void 0 : c.url;
      return (u, m) => _(i, X, G, e)(u, l || m);
    },
    /**
     * 
     * @summary Add new portfolio for client
     * @param {CreatePortfolioModel} [createPortfolioModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async addPortfolio(s, n) {
      var l, d;
      const r = await t.addPortfolio(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["PortfolioInsightsApi.addPortfolio"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    },
    /**
     * 
     * @summary Add property to portfolio.
     * @param {number} portfolioId Unique portfolio ID
     * @param {string} propId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async addProperty(s, n, r) {
      var d, c;
      const i = await t.addProperty(s, n, r), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (c = (d = Q["PortfolioInsightsApi.addProperty"]) == null ? void 0 : d[o]) == null ? void 0 : c.url;
      return (u, m) => _(i, X, G, e)(u, l || m);
    },
    /**
     * 
     * @summary Delete portfolio
     * @param {number} portfolioId Portfolio ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deletePortfolio(s, n) {
      var l, d;
      const r = await t.deletePortfolio(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["PortfolioInsightsApi.deletePortfolio"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    },
    /**
     * 
     * @summary Edit portfolio.
     * @param {number} portfolioId Unique portfolio ID
     * @param {EditPortfolioModel} [editPortfolioModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async editPortfolio(s, n, r) {
      var d, c;
      const i = await t.editPortfolio(s, n, r), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (c = (d = Q["PortfolioInsightsApi.editPortfolio"]) == null ? void 0 : d[o]) == null ? void 0 : c.url;
      return (u, m) => _(i, X, G, e)(u, l || m);
    },
    /**
     * 
     * @summary Find property from address.
     * @param {AddPropertyModel} [addPropertyModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async findProperty(s, n) {
      var l, d;
      const r = await t.findProperty(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["PortfolioInsightsApi.findProperty"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    },
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getMySummary(s) {
      var o, l;
      const n = await t.getMySummary(s), r = (e == null ? void 0 : e.serverIndex) ?? 0, i = (l = (o = Q["PortfolioInsightsApi.getMySummary"]) == null ? void 0 : o[r]) == null ? void 0 : l.url;
      return (d, c) => _(n, X, G, e)(d, i || c);
    },
    /**
     * 
     * @param {number} portfolioId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getOwnerChecklist(s, n) {
      var l, d;
      const r = await t.getOwnerChecklist(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["PortfolioInsightsApi.getOwnerChecklist"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    },
    /**
     * 
     * @summary Retrieve a single portfolio.
     * @param {number} portfolioId Unique portfolio ID
     * @param {boolean} [s] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getPortfolio(s, n, r) {
      var d, c;
      const i = await t.getPortfolio(s, n, r), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (c = (d = Q["PortfolioInsightsApi.getPortfolio"]) == null ? void 0 : d[o]) == null ? void 0 : c.url;
      return (u, m) => _(i, X, G, e)(u, l || m);
    },
    /**
     * 
     * @summary List properties for portfolio.
     * @param {number} portfolioId Unique portfolio ID
     * @param {boolean} [d] Include properties marked for deletion.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getPortfolioProperties(s, n, r) {
      var d, c;
      const i = await t.getPortfolioProperties(s, n, r), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (c = (d = Q["PortfolioInsightsApi.getPortfolioProperties"]) == null ? void 0 : d[o]) == null ? void 0 : c.url;
      return (u, m) => _(i, X, G, e)(u, l || m);
    },
    /**
     * 
     * @param {number} portfolioId 
     * @param {number} propId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getPortfolioProperty(s, n, r) {
      var d, c;
      const i = await t.getPortfolioProperty(s, n, r), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (c = (d = Q["PortfolioInsightsApi.getPortfolioProperty"]) == null ? void 0 : d[o]) == null ? void 0 : c.url;
      return (u, m) => _(i, X, G, e)(u, l || m);
    },
    /**
     * 
     * @summary List portfolios associated with agent/broker.
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {boolean} [sortAsc] Sort ascending, else descending
     * @param {string} [searchBy] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getPortfolios(s, n, r, i, o) {
      var u, m;
      const l = await t.getPortfolios(s, n, r, i, o), d = (e == null ? void 0 : e.serverIndex) ?? 0, c = (m = (u = Q["PortfolioInsightsApi.getPortfolios"]) == null ? void 0 : u[d]) == null ? void 0 : m.url;
      return (f, v) => _(l, X, G, e)(f, c || v);
    },
    /**
     * 
     * @summary Remove member from portfolio.
     * @param {number} portfolioId 
     * @param {number} [memberId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async removeMember(s, n, r) {
      var d, c;
      const i = await t.removeMember(s, n, r), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (c = (d = Q["PortfolioInsightsApi.removeMember"]) == null ? void 0 : d[o]) == null ? void 0 : c.url;
      return (u, m) => _(i, X, G, e)(u, l || m);
    },
    /**
     * 
     * @summary Mark property for deletion, to be deleted 45 days once marked.
     * @param {number} portfolioId Unique portfolio ID
     * @param {string} propId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async removeProperty(s, n, r) {
      var d, c;
      const i = await t.removeProperty(s, n, r), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (c = (d = Q["PortfolioInsightsApi.removeProperty"]) == null ? void 0 : d[o]) == null ? void 0 : c.url;
      return (u, m) => _(i, X, G, e)(u, l || m);
    },
    /**
     * 
     * @summary Restore property from being deleted.
     * @param {number} portfolioId Unique portfolio ID
     * @param {string} propId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async restoreProperty(s, n, r) {
      var d, c;
      const i = await t.restoreProperty(s, n, r), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (c = (d = Q["PortfolioInsightsApi.restoreProperty"]) == null ? void 0 : d[o]) == null ? void 0 : c.url;
      return (u, m) => _(i, X, G, e)(u, l || m);
    }
  };
}, uT = function(e, t, s) {
  const n = cT(e);
  return {
    /**
     * 
     * @summary Add new member to portfolio.
     * @param {number} portfolioId 
     * @param {AddClientModel} [addClientModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addMember(r, i, o) {
      return n.addMember(r, i, o).then((l) => l(s, t));
    },
    /**
     * 
     * @summary Add new portfolio for client
     * @param {CreatePortfolioModel} [createPortfolioModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addPortfolio(r, i) {
      return n.addPortfolio(r, i).then((o) => o(s, t));
    },
    /**
     * 
     * @summary Add property to portfolio.
     * @param {number} portfolioId Unique portfolio ID
     * @param {string} propId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addProperty(r, i, o) {
      return n.addProperty(r, i, o).then((l) => l(s, t));
    },
    /**
     * 
     * @summary Delete portfolio
     * @param {number} portfolioId Portfolio ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deletePortfolio(r, i) {
      return n.deletePortfolio(r, i).then((o) => o(s, t));
    },
    /**
     * 
     * @summary Edit portfolio.
     * @param {number} portfolioId Unique portfolio ID
     * @param {EditPortfolioModel} [editPortfolioModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    editPortfolio(r, i, o) {
      return n.editPortfolio(r, i, o).then((l) => l(s, t));
    },
    /**
     * 
     * @summary Find property from address.
     * @param {AddPropertyModel} [addPropertyModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    findProperty(r, i) {
      return n.findProperty(r, i).then((o) => o(s, t));
    },
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getMySummary(r) {
      return n.getMySummary(r).then((i) => i(s, t));
    },
    /**
     * 
     * @param {number} portfolioId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getOwnerChecklist(r, i) {
      return n.getOwnerChecklist(r, i).then((o) => o(s, t));
    },
    /**
     * 
     * @summary Retrieve a single portfolio.
     * @param {number} portfolioId Unique portfolio ID
     * @param {boolean} [s] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPortfolio(r, i, o) {
      return n.getPortfolio(r, i, o).then((l) => l(s, t));
    },
    /**
     * 
     * @summary List properties for portfolio.
     * @param {number} portfolioId Unique portfolio ID
     * @param {boolean} [d] Include properties marked for deletion.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPortfolioProperties(r, i, o) {
      return n.getPortfolioProperties(r, i, o).then((l) => l(s, t));
    },
    /**
     * 
     * @param {number} portfolioId 
     * @param {number} propId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPortfolioProperty(r, i, o) {
      return n.getPortfolioProperty(r, i, o).then((l) => l(s, t));
    },
    /**
     * 
     * @summary List portfolios associated with agent/broker.
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {boolean} [sortAsc] Sort ascending, else descending
     * @param {string} [searchBy] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPortfolios(r, i, o, l, d) {
      return n.getPortfolios(r, i, o, l, d).then((c) => c(s, t));
    },
    /**
     * 
     * @summary Remove member from portfolio.
     * @param {number} portfolioId 
     * @param {number} [memberId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    removeMember(r, i, o) {
      return n.removeMember(r, i, o).then((l) => l(s, t));
    },
    /**
     * 
     * @summary Mark property for deletion, to be deleted 45 days once marked.
     * @param {number} portfolioId Unique portfolio ID
     * @param {string} propId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    removeProperty(r, i, o) {
      return n.removeProperty(r, i, o).then((l) => l(s, t));
    },
    /**
     * 
     * @summary Restore property from being deleted.
     * @param {number} portfolioId Unique portfolio ID
     * @param {string} propId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    restoreProperty(r, i, o) {
      return n.restoreProperty(r, i, o).then((l) => l(s, t));
    }
  };
}, pT = function(e) {
  return {
    /**
     * 
     * @summary Add a Portfolio Insights client and optionally send a invite email.
     * @param {AddClientModel} [addClientModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addClient: async (t, s = {}) => {
      const n = "/portfolio-insights/clients/add", r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "POST", ...i, ...s }, l = {}, d = {};
      await ee(l, e), l["Content-Type"] = "application/json", Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, o.data = kt(t, o, e), {
        url: J(r),
        options: o
      };
    },
    /**
     * 
     * @summary List Portfolio Insights clients associated with agent.
     * @param {number} [page] Current page of clients to return.
     * @param {number} [pageSize] Total clients per page.
     * @param {string} [s] Search name and email
     * @param {boolean} [i] Include clients with inactive portfolios.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getClients: async (t, s, n, r, i = {}) => {
      const o = "/portfolio-insights/clients", l = new URL(o, K);
      let d;
      e && (d = e.baseOptions);
      const c = { method: "GET", ...d, ...i }, u = {}, m = {};
      await ee(u, e), t !== void 0 && (m.page = t), s !== void 0 && (m.pageSize = s), n !== void 0 && (m.s = n), r !== void 0 && (m.i = r), Z(l, m);
      let f = d && d.headers ? d.headers : {};
      return c.headers = { ...u, ...f, ...i.headers }, {
        url: J(l),
        options: c
      };
    },
    /**
     * 
     * @summary Send a existing client a invite email.
     * @param {InviteClientModel} [inviteClientModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sendClientInvite: async (t, s = {}) => {
      const n = "/portfolio-insights/clients/invite", r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "POST", ...i, ...s }, l = {}, d = {};
      await ee(l, e), l["Content-Type"] = "application/json", Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, o.data = kt(t, o, e), {
        url: J(r),
        options: o
      };
    },
    /**
     * 
     * @summary Send welcome email to client(s)
     * @param {Array<number>} [clientIds] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sendWelcome: async (t, s = {}) => {
      const n = "/portfolio-insights/clients/welcome", r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "POST", ...i, ...s }, l = {}, d = {}, c = new (e && e.formDataCtor || FormData)();
      await ee(l, e), t && t.forEach((m) => {
        c.append("clientIds", m);
      }), l["Content-Type"] = "multipart/form-data", Z(r, d);
      let u = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...u, ...s.headers }, o.data = c, {
        url: J(r),
        options: o
      };
    },
    /**
     * 
     * @summary Remove client link to agent account.
     * @param {string} [email] Email of account to unlink. No email means unlink current account from agent.
     * @param {number} [parentId] 
     * @param {boolean} [notify] Notify user of unlink. Notify is auto opt-in, only setting false will stop email notification.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    unlinkClient: async (t, s, n, r = {}) => {
      const i = "/portfolio-insights/clients/unlink", o = new URL(i, K);
      let l;
      e && (l = e.baseOptions);
      const d = { method: "POST", ...l, ...r }, c = {}, u = {}, m = new (e && e.formDataCtor || FormData)();
      await ee(c, e), t !== void 0 && m.append("email", t), s !== void 0 && m.append("parentId", s), n !== void 0 && m.append("notify", String(n)), c["Content-Type"] = "multipart/form-data", Z(o, u);
      let f = l && l.headers ? l.headers : {};
      return d.headers = { ...c, ...f, ...r.headers }, d.data = m, {
        url: J(o),
        options: d
      };
    }
  };
}, hT = function(e) {
  const t = pT(e);
  return {
    /**
     * 
     * @summary Add a Portfolio Insights client and optionally send a invite email.
     * @param {AddClientModel} [addClientModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async addClient(s, n) {
      var l, d;
      const r = await t.addClient(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["PortfolioInsightsClientsApi.addClient"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    },
    /**
     * 
     * @summary List Portfolio Insights clients associated with agent.
     * @param {number} [page] Current page of clients to return.
     * @param {number} [pageSize] Total clients per page.
     * @param {string} [s] Search name and email
     * @param {boolean} [i] Include clients with inactive portfolios.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getClients(s, n, r, i, o) {
      var u, m;
      const l = await t.getClients(s, n, r, i, o), d = (e == null ? void 0 : e.serverIndex) ?? 0, c = (m = (u = Q["PortfolioInsightsClientsApi.getClients"]) == null ? void 0 : u[d]) == null ? void 0 : m.url;
      return (f, v) => _(l, X, G, e)(f, c || v);
    },
    /**
     * 
     * @summary Send a existing client a invite email.
     * @param {InviteClientModel} [inviteClientModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async sendClientInvite(s, n) {
      var l, d;
      const r = await t.sendClientInvite(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["PortfolioInsightsClientsApi.sendClientInvite"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    },
    /**
     * 
     * @summary Send welcome email to client(s)
     * @param {Array<number>} [clientIds] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async sendWelcome(s, n) {
      var l, d;
      const r = await t.sendWelcome(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["PortfolioInsightsClientsApi.sendWelcome"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    },
    /**
     * 
     * @summary Remove client link to agent account.
     * @param {string} [email] Email of account to unlink. No email means unlink current account from agent.
     * @param {number} [parentId] 
     * @param {boolean} [notify] Notify user of unlink. Notify is auto opt-in, only setting false will stop email notification.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async unlinkClient(s, n, r, i) {
      var c, u;
      const o = await t.unlinkClient(s, n, r, i), l = (e == null ? void 0 : e.serverIndex) ?? 0, d = (u = (c = Q["PortfolioInsightsClientsApi.unlinkClient"]) == null ? void 0 : c[l]) == null ? void 0 : u.url;
      return (m, f) => _(o, X, G, e)(m, d || f);
    }
  };
}, mT = function(e, t, s) {
  const n = hT(e);
  return {
    /**
     * 
     * @summary Add a Portfolio Insights client and optionally send a invite email.
     * @param {AddClientModel} [addClientModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addClient(r, i) {
      return n.addClient(r, i).then((o) => o(s, t));
    },
    /**
     * 
     * @summary List Portfolio Insights clients associated with agent.
     * @param {number} [page] Current page of clients to return.
     * @param {number} [pageSize] Total clients per page.
     * @param {string} [s] Search name and email
     * @param {boolean} [i] Include clients with inactive portfolios.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getClients(r, i, o, l, d) {
      return n.getClients(r, i, o, l, d).then((c) => c(s, t));
    },
    /**
     * 
     * @summary Send a existing client a invite email.
     * @param {InviteClientModel} [inviteClientModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sendClientInvite(r, i) {
      return n.sendClientInvite(r, i).then((o) => o(s, t));
    },
    /**
     * 
     * @summary Send welcome email to client(s)
     * @param {Array<number>} [clientIds] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sendWelcome(r, i) {
      return n.sendWelcome(r, i).then((o) => o(s, t));
    },
    /**
     * 
     * @summary Remove client link to agent account.
     * @param {string} [email] Email of account to unlink. No email means unlink current account from agent.
     * @param {number} [parentId] 
     * @param {boolean} [notify] Notify user of unlink. Notify is auto opt-in, only setting false will stop email notification.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    unlinkClient(r, i, o, l) {
      return n.unlinkClient(r, i, o, l).then((d) => d(s, t));
    }
  };
}, fT = function(e) {
  return {
    /**
     * 
     * @summary Retrieve list of pre-foreclosure properties for a county.
     * @param {string} state 
     * @param {string} county 
     * @param {number} [m] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    areaByCounty: async (t, s, n, r = {}) => {
      se("areaByCounty", "state", t), se("areaByCounty", "county", s);
      const i = "/pre-foreclosure/area/{state}/{county}".replace("{state}", encodeURIComponent(String(t))).replace("{county}", encodeURIComponent(String(s))), o = new URL(i, K);
      let l;
      e && (l = e.baseOptions);
      const d = { method: "GET", ...l, ...r }, c = {}, u = {};
      await ee(c, e), n !== void 0 && (u.m = n), Z(o, u);
      let m = l && l.headers ? l.headers : {};
      return d.headers = { ...c, ...m, ...r.headers }, {
        url: J(o),
        options: d
      };
    },
    /**
     * 
     * @summary Retrieve list of pre-foreclosure properties for zip code.
     * @param {string} zip 
     * @param {number} [m] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    areaByZip: async (t, s, n = {}) => {
      se("areaByZip", "zip", t);
      const r = "/pre-foreclosure/area/{zip}".replace("{zip}", encodeURIComponent(String(t))), i = new URL(r, K);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "GET", ...o, ...n }, d = {}, c = {};
      await ee(d, e), s !== void 0 && (c.m = s), Z(i, c);
      let u = o && o.headers ? o.headers : {};
      return l.headers = { ...d, ...u, ...n.headers }, {
        url: J(i),
        options: l
      };
    },
    /**
     * 
     * @summary Calculate Pre-Foreclosure listings from search results.
     * @param {CalculateRequestModel} calculateRequestModel 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    calculate: async (t, s = {}) => {
      se("calculate", "calculateRequestModel", t);
      const n = "/pre-foreclosure/calculate", r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "POST", ...i, ...s }, l = {}, d = {};
      await ee(l, e), l["Content-Type"] = "application/json", Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, o.data = kt(t, o, e), {
        url: J(r),
        options: o
      };
    },
    /**
     * 
     * @summary Retrieve pre-foreclosure filings for a property
     * @param {number} propId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    filings: async (t, s = {}) => {
      se("filings", "propId", t);
      const n = "/pre-foreclosure/{propId}/filings".replace("{propId}", encodeURIComponent(String(t))), r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "GET", ...i, ...s }, l = {}, d = {};
      await ee(l, e), Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, {
        url: J(r),
        options: o
      };
    },
    /**
     * 
     * @summary Retrieve pre-foreclosure filings for a listing
     * @param {string} mlsSource 
     * @param {string} mlsNumber 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listingFilings: async (t, s, n = {}) => {
      se("listingFilings", "mlsSource", t), se("listingFilings", "mlsNumber", s);
      const r = "/pre-foreclosure/{mlsSource}/{mlsNumber}/filings".replace("{mlsSource}", encodeURIComponent(String(t))).replace("{mlsNumber}", encodeURIComponent(String(s))), i = new URL(r, K);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "GET", ...o, ...n }, d = {}, c = {};
      await ee(d, e), Z(i, c);
      let u = o && o.headers ? o.headers : {};
      return l.headers = { ...d, ...u, ...n.headers }, {
        url: J(i),
        options: l
      };
    },
    /**
     * 
     * @summary Search Pre-Foreclosure listings.
     * @param {SearchRequestModel} searchRequestModel 
     * @param {boolean} [p] Include pending listings.
     * @param {boolean} [m] Include mobile home listings.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    search: async (t, s, n, r = {}) => {
      se("search", "searchRequestModel", t);
      const i = "/pre-foreclosure/search", o = new URL(i, K);
      let l;
      e && (l = e.baseOptions);
      const d = { method: "POST", ...l, ...r }, c = {}, u = {};
      await ee(c, e), s !== void 0 && (u.p = s), n !== void 0 && (u.m = n), c["Content-Type"] = "application/json", Z(o, u);
      let m = l && l.headers ? l.headers : {};
      return d.headers = { ...c, ...m, ...r.headers }, d.data = kt(t, d, e), {
        url: J(o),
        options: d
      };
    },
    /**
     * 
     * @summary Retrieve pre-foreclosure stats for counties.
     * @param {number} [m] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    statsByCounty: async (t, s = {}) => {
      const n = "/pre-foreclosure/stats/counties", r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "GET", ...i, ...s }, l = {}, d = {};
      await ee(l, e), t !== void 0 && (d.m = t), Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, {
        url: J(r),
        options: o
      };
    },
    /**
     * 
     * @summary Retrieve pre-foreclosure stats for counties in a single state.
     * @param {string} state 
     * @param {number} [m] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    statsByState: async (t, s, n = {}) => {
      se("statsByState", "state", t);
      const r = "/pre-foreclosure/stats/{state}/counties".replace("{state}", encodeURIComponent(String(t))), i = new URL(r, K);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "GET", ...o, ...n }, d = {}, c = {};
      await ee(d, e), s !== void 0 && (c.m = s), Z(i, c);
      let u = o && o.headers ? o.headers : {};
      return l.headers = { ...d, ...u, ...n.headers }, {
        url: J(i),
        options: l
      };
    },
    /**
     * 
     * @summary Retrieve pre-foreclosure stats for states.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    statsByStates: async (t = {}) => {
      const s = "/pre-foreclosure/stats/states", n = new URL(s, K);
      let r;
      e && (r = e.baseOptions);
      const i = { method: "GET", ...r, ...t }, o = {}, l = {};
      await ee(o, e), Z(n, l);
      let d = r && r.headers ? r.headers : {};
      return i.headers = { ...o, ...d, ...t.headers }, {
        url: J(n),
        options: i
      };
    },
    /**
     * 
     * @summary Retrieve pre-foreclosure stats for single county.
     * @param {string} state 
     * @param {string} county 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    statsForCounty: async (t, s, n = {}) => {
      se("statsForCounty", "state", t), se("statsForCounty", "county", s);
      const r = "/pre-foreclosure/stats/{state}/{county}".replace("{state}", encodeURIComponent(String(t))).replace("{county}", encodeURIComponent(String(s))), i = new URL(r, K);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "GET", ...o, ...n }, d = {}, c = {};
      await ee(d, e), Z(i, c);
      let u = o && o.headers ? o.headers : {};
      return l.headers = { ...d, ...u, ...n.headers }, {
        url: J(i),
        options: l
      };
    }
  };
}, gT = function(e) {
  const t = fT(e);
  return {
    /**
     * 
     * @summary Retrieve list of pre-foreclosure properties for a county.
     * @param {string} state 
     * @param {string} county 
     * @param {number} [m] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async areaByCounty(s, n, r, i) {
      var c, u;
      const o = await t.areaByCounty(s, n, r, i), l = (e == null ? void 0 : e.serverIndex) ?? 0, d = (u = (c = Q["PreForeclosureApi.areaByCounty"]) == null ? void 0 : c[l]) == null ? void 0 : u.url;
      return (m, f) => _(o, X, G, e)(m, d || f);
    },
    /**
     * 
     * @summary Retrieve list of pre-foreclosure properties for zip code.
     * @param {string} zip 
     * @param {number} [m] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async areaByZip(s, n, r) {
      var d, c;
      const i = await t.areaByZip(s, n, r), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (c = (d = Q["PreForeclosureApi.areaByZip"]) == null ? void 0 : d[o]) == null ? void 0 : c.url;
      return (u, m) => _(i, X, G, e)(u, l || m);
    },
    /**
     * 
     * @summary Calculate Pre-Foreclosure listings from search results.
     * @param {CalculateRequestModel} calculateRequestModel 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async calculate(s, n) {
      var l, d;
      const r = await t.calculate(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["PreForeclosureApi.calculate"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    },
    /**
     * 
     * @summary Retrieve pre-foreclosure filings for a property
     * @param {number} propId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async filings(s, n) {
      var l, d;
      const r = await t.filings(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["PreForeclosureApi.filings"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    },
    /**
     * 
     * @summary Retrieve pre-foreclosure filings for a listing
     * @param {string} mlsSource 
     * @param {string} mlsNumber 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async listingFilings(s, n, r) {
      var d, c;
      const i = await t.listingFilings(s, n, r), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (c = (d = Q["PreForeclosureApi.listingFilings"]) == null ? void 0 : d[o]) == null ? void 0 : c.url;
      return (u, m) => _(i, X, G, e)(u, l || m);
    },
    /**
     * 
     * @summary Search Pre-Foreclosure listings.
     * @param {SearchRequestModel} searchRequestModel 
     * @param {boolean} [p] Include pending listings.
     * @param {boolean} [m] Include mobile home listings.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async search(s, n, r, i) {
      var c, u;
      const o = await t.search(s, n, r, i), l = (e == null ? void 0 : e.serverIndex) ?? 0, d = (u = (c = Q["PreForeclosureApi.search"]) == null ? void 0 : c[l]) == null ? void 0 : u.url;
      return (m, f) => _(o, X, G, e)(m, d || f);
    },
    /**
     * 
     * @summary Retrieve pre-foreclosure stats for counties.
     * @param {number} [m] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async statsByCounty(s, n) {
      var l, d;
      const r = await t.statsByCounty(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["PreForeclosureApi.statsByCounty"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    },
    /**
     * 
     * @summary Retrieve pre-foreclosure stats for counties in a single state.
     * @param {string} state 
     * @param {number} [m] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async statsByState(s, n, r) {
      var d, c;
      const i = await t.statsByState(s, n, r), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (c = (d = Q["PreForeclosureApi.statsByState"]) == null ? void 0 : d[o]) == null ? void 0 : c.url;
      return (u, m) => _(i, X, G, e)(u, l || m);
    },
    /**
     * 
     * @summary Retrieve pre-foreclosure stats for states.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async statsByStates(s) {
      var o, l;
      const n = await t.statsByStates(s), r = (e == null ? void 0 : e.serverIndex) ?? 0, i = (l = (o = Q["PreForeclosureApi.statsByStates"]) == null ? void 0 : o[r]) == null ? void 0 : l.url;
      return (d, c) => _(n, X, G, e)(d, i || c);
    },
    /**
     * 
     * @summary Retrieve pre-foreclosure stats for single county.
     * @param {string} state 
     * @param {string} county 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async statsForCounty(s, n, r) {
      var d, c;
      const i = await t.statsForCounty(s, n, r), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (c = (d = Q["PreForeclosureApi.statsForCounty"]) == null ? void 0 : d[o]) == null ? void 0 : c.url;
      return (u, m) => _(i, X, G, e)(u, l || m);
    }
  };
}, vT = function(e, t, s) {
  const n = gT(e);
  return {
    /**
     * 
     * @summary Retrieve list of pre-foreclosure properties for a county.
     * @param {string} state 
     * @param {string} county 
     * @param {number} [m] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    areaByCounty(r, i, o, l) {
      return n.areaByCounty(r, i, o, l).then((d) => d(s, t));
    },
    /**
     * 
     * @summary Retrieve list of pre-foreclosure properties for zip code.
     * @param {string} zip 
     * @param {number} [m] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    areaByZip(r, i, o) {
      return n.areaByZip(r, i, o).then((l) => l(s, t));
    },
    /**
     * 
     * @summary Calculate Pre-Foreclosure listings from search results.
     * @param {CalculateRequestModel} calculateRequestModel 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    calculate(r, i) {
      return n.calculate(r, i).then((o) => o(s, t));
    },
    /**
     * 
     * @summary Retrieve pre-foreclosure filings for a property
     * @param {number} propId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    filings(r, i) {
      return n.filings(r, i).then((o) => o(s, t));
    },
    /**
     * 
     * @summary Retrieve pre-foreclosure filings for a listing
     * @param {string} mlsSource 
     * @param {string} mlsNumber 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listingFilings(r, i, o) {
      return n.listingFilings(r, i, o).then((l) => l(s, t));
    },
    /**
     * 
     * @summary Search Pre-Foreclosure listings.
     * @param {SearchRequestModel} searchRequestModel 
     * @param {boolean} [p] Include pending listings.
     * @param {boolean} [m] Include mobile home listings.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    search(r, i, o, l) {
      return n.search(r, i, o, l).then((d) => d(s, t));
    },
    /**
     * 
     * @summary Retrieve pre-foreclosure stats for counties.
     * @param {number} [m] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    statsByCounty(r, i) {
      return n.statsByCounty(r, i).then((o) => o(s, t));
    },
    /**
     * 
     * @summary Retrieve pre-foreclosure stats for counties in a single state.
     * @param {string} state 
     * @param {number} [m] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    statsByState(r, i, o) {
      return n.statsByState(r, i, o).then((l) => l(s, t));
    },
    /**
     * 
     * @summary Retrieve pre-foreclosure stats for states.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    statsByStates(r) {
      return n.statsByStates(r).then((i) => i(s, t));
    },
    /**
     * 
     * @summary Retrieve pre-foreclosure stats for single county.
     * @param {string} state 
     * @param {string} county 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    statsForCounty(r, i, o) {
      return n.statsForCounty(r, i, o).then((l) => l(s, t));
    }
  };
}, yT = function(e) {
  return {
    /**
     * 
     * @summary Property Details
     * @param {number} propId Property Id.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPropertyDetails: async (t, s = {}) => {
      se("getPropertyDetails", "propId", t);
      const n = "/property/{propId}/details".replace("{propId}", encodeURIComponent(String(t))), r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "GET", ...i, ...s }, l = {}, d = {};
      await Lt(l, "x-api-key", e), await ee(l, e), Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, {
        url: J(r),
        options: o
      };
    },
    /**
     * 
     * @summary Property Details
     * @param {string} mlsSource 
     * @param {string} mlsNumber 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPropertyDetailsMls: async (t, s, n = {}) => {
      se("getPropertyDetailsMls", "mlsSource", t), se("getPropertyDetailsMls", "mlsNumber", s);
      const r = "/property/{mlsSource}/{mlsNumber}/details".replace("{mlsSource}", encodeURIComponent(String(t))).replace("{mlsNumber}", encodeURIComponent(String(s))), i = new URL(r, K);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "GET", ...o, ...n }, d = {}, c = {};
      await Lt(d, "x-api-key", e), await ee(d, e), Z(i, c);
      let u = o && o.headers ? o.headers : {};
      return l.headers = { ...d, ...u, ...n.headers }, {
        url: J(i),
        options: l
      };
    },
    /**
     * 
     * @summary Property Details
     * @param {number} propId Property Id.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPropertyPhoto: async (t, s = {}) => {
      se("getPropertyPhoto", "propId", t);
      const n = "/property/{propId}/photo".replace("{propId}", encodeURIComponent(String(t))), r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "GET", ...i, ...s }, l = {}, d = {};
      await ee(l, e), Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, {
        url: J(r),
        options: o
      };
    },
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    lookupToken: async (t = {}) => {
      const s = "/property/lookup", n = new URL(s, K);
      let r;
      e && (r = e.baseOptions);
      const i = { method: "GET", ...r, ...t }, o = {}, l = {};
      await Lt(o, "x-api-key", e), await ee(o, e), Z(n, l);
      let d = r && r.headers ? r.headers : {};
      return i.headers = { ...o, ...d, ...t.headers }, {
        url: J(n),
        options: i
      };
    },
    /**
     * 
     * @summary Retrieve property value for property.
     * @param {number} propId Property id to return property value for.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertyValue: async (t, s = {}) => {
      se("propertyValue", "propId", t);
      const n = "/property/{propId}/property-value".replace("{propId}", encodeURIComponent(String(t))), r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "GET", ...i, ...s }, l = {}, d = {};
      await Lt(l, "x-api-key", e), await ee(l, e), Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, {
        url: J(r),
        options: o
      };
    },
    /**
     * 
     * @summary Retrieve rental rate for property.
     * @param {number} propId Property id to return rental rate for.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    rentalRate: async (t, s = {}) => {
      se("rentalRate", "propId", t);
      const n = "/property/{propId}/rental-rate".replace("{propId}", encodeURIComponent(String(t))), r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "GET", ...i, ...s }, l = {}, d = {};
      await Lt(l, "x-api-key", e), await ee(l, e), Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, {
        url: J(r),
        options: o
      };
    },
    /**
     * 
     * @summary Retrieve rental rate for property.
     * @param {string} mlsSource 
     * @param {string} mlsNumber 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    rentalRateMls: async (t, s, n = {}) => {
      se("rentalRateMls", "mlsSource", t), se("rentalRateMls", "mlsNumber", s);
      const r = "/property/{mlsSource}/{mlsNumber}/rental-rate".replace("{mlsSource}", encodeURIComponent(String(t))).replace("{mlsNumber}", encodeURIComponent(String(s))), i = new URL(r, K);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "GET", ...o, ...n }, d = {}, c = {};
      await Lt(d, "x-api-key", e), await ee(d, e), Z(i, c);
      let u = o && o.headers ? o.headers : {};
      return l.headers = { ...d, ...u, ...n.headers }, {
        url: J(i),
        options: l
      };
    },
    /**
     * 
     * @summary Report issue with property
     * @param {number} propId 
     * @param {ReportPropertyModel} [reportPropertyModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    report: async (t, s, n = {}) => {
      se("report", "propId", t);
      const r = "/property/{propId}/report".replace("{propId}", encodeURIComponent(String(t))), i = new URL(r, K);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "POST", ...o, ...n }, d = {}, c = {};
      await Lt(d, "x-api-key", e), await ee(d, e), d["Content-Type"] = "application/json", Z(i, c);
      let u = o && o.headers ? o.headers : {};
      return l.headers = { ...d, ...u, ...n.headers }, l.data = kt(s, l, e), {
        url: J(i),
        options: l
      };
    },
    /**
     * 
     * @summary Property Details
     * @param {number} propId Property Id.
     * @param {UpdatePropertyDetailsRequest} [updatePropertyDetailsRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updatePropertyDetails: async (t, s, n = {}) => {
      se("updatePropertyDetails", "propId", t);
      const r = "/property/{propId}/details".replace("{propId}", encodeURIComponent(String(t))), i = new URL(r, K);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "POST", ...o, ...n }, d = {}, c = {};
      await ee(d, e), d["Content-Type"] = "application/json", Z(i, c);
      let u = o && o.headers ? o.headers : {};
      return l.headers = { ...d, ...u, ...n.headers }, l.data = kt(s, l, e), {
        url: J(i),
        options: l
      };
    },
    /**
     * 
     * @summary Validate property address.
     * @param {string} a Street number &amp; name
     * @param {string} c City
     * @param {string} s State
     * @param {string} z Zip
     * @param {string} [u] Unit
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    validateAddress: async (t, s, n, r, i, o = {}) => {
      se("validateAddress", "a", t), se("validateAddress", "c", s), se("validateAddress", "s", n), se("validateAddress", "z", r);
      const l = "/property/validate-address", d = new URL(l, K);
      let c;
      e && (c = e.baseOptions);
      const u = { method: "GET", ...c, ...o }, m = {}, f = {};
      await ee(m, e), t !== void 0 && (f.a = t), s !== void 0 && (f.c = s), n !== void 0 && (f.s = n), r !== void 0 && (f.z = r), i !== void 0 && (f.u = i), Z(d, f);
      let v = c && c.headers ? c.headers : {};
      return u.headers = { ...m, ...v, ...o.headers }, {
        url: J(d),
        options: u
      };
    }
  };
}, bT = function(e) {
  const t = yT(e);
  return {
    /**
     * 
     * @summary Property Details
     * @param {number} propId Property Id.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getPropertyDetails(s, n) {
      var l, d;
      const r = await t.getPropertyDetails(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["PropertyApi.getPropertyDetails"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    },
    /**
     * 
     * @summary Property Details
     * @param {string} mlsSource 
     * @param {string} mlsNumber 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getPropertyDetailsMls(s, n, r) {
      var d, c;
      const i = await t.getPropertyDetailsMls(s, n, r), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (c = (d = Q["PropertyApi.getPropertyDetailsMls"]) == null ? void 0 : d[o]) == null ? void 0 : c.url;
      return (u, m) => _(i, X, G, e)(u, l || m);
    },
    /**
     * 
     * @summary Property Details
     * @param {number} propId Property Id.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getPropertyPhoto(s, n) {
      var l, d;
      const r = await t.getPropertyPhoto(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["PropertyApi.getPropertyPhoto"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    },
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async lookupToken(s) {
      var o, l;
      const n = await t.lookupToken(s), r = (e == null ? void 0 : e.serverIndex) ?? 0, i = (l = (o = Q["PropertyApi.lookupToken"]) == null ? void 0 : o[r]) == null ? void 0 : l.url;
      return (d, c) => _(n, X, G, e)(d, i || c);
    },
    /**
     * 
     * @summary Retrieve property value for property.
     * @param {number} propId Property id to return property value for.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async propertyValue(s, n) {
      var l, d;
      const r = await t.propertyValue(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["PropertyApi.propertyValue"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    },
    /**
     * 
     * @summary Retrieve rental rate for property.
     * @param {number} propId Property id to return rental rate for.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async rentalRate(s, n) {
      var l, d;
      const r = await t.rentalRate(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["PropertyApi.rentalRate"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    },
    /**
     * 
     * @summary Retrieve rental rate for property.
     * @param {string} mlsSource 
     * @param {string} mlsNumber 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async rentalRateMls(s, n, r) {
      var d, c;
      const i = await t.rentalRateMls(s, n, r), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (c = (d = Q["PropertyApi.rentalRateMls"]) == null ? void 0 : d[o]) == null ? void 0 : c.url;
      return (u, m) => _(i, X, G, e)(u, l || m);
    },
    /**
     * 
     * @summary Report issue with property
     * @param {number} propId 
     * @param {ReportPropertyModel} [reportPropertyModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async report(s, n, r) {
      var d, c;
      const i = await t.report(s, n, r), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (c = (d = Q["PropertyApi.report"]) == null ? void 0 : d[o]) == null ? void 0 : c.url;
      return (u, m) => _(i, X, G, e)(u, l || m);
    },
    /**
     * 
     * @summary Property Details
     * @param {number} propId Property Id.
     * @param {UpdatePropertyDetailsRequest} [updatePropertyDetailsRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updatePropertyDetails(s, n, r) {
      var d, c;
      const i = await t.updatePropertyDetails(s, n, r), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (c = (d = Q["PropertyApi.updatePropertyDetails"]) == null ? void 0 : d[o]) == null ? void 0 : c.url;
      return (u, m) => _(i, X, G, e)(u, l || m);
    },
    /**
     * 
     * @summary Validate property address.
     * @param {string} a Street number &amp; name
     * @param {string} c City
     * @param {string} s State
     * @param {string} z Zip
     * @param {string} [u] Unit
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async validateAddress(s, n, r, i, o, l) {
      var m, f;
      const d = await t.validateAddress(s, n, r, i, o, l), c = (e == null ? void 0 : e.serverIndex) ?? 0, u = (f = (m = Q["PropertyApi.validateAddress"]) == null ? void 0 : m[c]) == null ? void 0 : f.url;
      return (v, b) => _(d, X, G, e)(v, u || b);
    }
  };
}, AT = function(e, t, s) {
  const n = bT(e);
  return {
    /**
     * 
     * @summary Property Details
     * @param {number} propId Property Id.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPropertyDetails(r, i) {
      return n.getPropertyDetails(r, i).then((o) => o(s, t));
    },
    /**
     * 
     * @summary Property Details
     * @param {string} mlsSource 
     * @param {string} mlsNumber 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPropertyDetailsMls(r, i, o) {
      return n.getPropertyDetailsMls(r, i, o).then((l) => l(s, t));
    },
    /**
     * 
     * @summary Property Details
     * @param {number} propId Property Id.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPropertyPhoto(r, i) {
      return n.getPropertyPhoto(r, i).then((o) => o(s, t));
    },
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    lookupToken(r) {
      return n.lookupToken(r).then((i) => i(s, t));
    },
    /**
     * 
     * @summary Retrieve property value for property.
     * @param {number} propId Property id to return property value for.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertyValue(r, i) {
      return n.propertyValue(r, i).then((o) => o(s, t));
    },
    /**
     * 
     * @summary Retrieve rental rate for property.
     * @param {number} propId Property id to return rental rate for.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    rentalRate(r, i) {
      return n.rentalRate(r, i).then((o) => o(s, t));
    },
    /**
     * 
     * @summary Retrieve rental rate for property.
     * @param {string} mlsSource 
     * @param {string} mlsNumber 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    rentalRateMls(r, i, o) {
      return n.rentalRateMls(r, i, o).then((l) => l(s, t));
    },
    /**
     * 
     * @summary Report issue with property
     * @param {number} propId 
     * @param {ReportPropertyModel} [reportPropertyModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    report(r, i, o) {
      return n.report(r, i, o).then((l) => l(s, t));
    },
    /**
     * 
     * @summary Property Details
     * @param {number} propId Property Id.
     * @param {UpdatePropertyDetailsRequest} [updatePropertyDetailsRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updatePropertyDetails(r, i, o) {
      return n.updatePropertyDetails(r, i, o).then((l) => l(s, t));
    },
    /**
     * 
     * @summary Validate property address.
     * @param {string} a Street number &amp; name
     * @param {string} c City
     * @param {string} s State
     * @param {string} z Zip
     * @param {string} [u] Unit
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    validateAddress(r, i, o, l, d, c) {
      return n.validateAddress(r, i, o, l, d, c).then((u) => u(s, t));
    }
  };
}, wT = function(e) {
  return {
    /**
     * 
     * @summary Retrieve tax assessor info for a property.
     * @param {number} propId Property Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    countyInfo: async (t, s = {}) => {
      se("countyInfo", "propId", t);
      const n = "/property/records/{propId}/county-info".replace("{propId}", encodeURIComponent(String(t))), r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "GET", ...i, ...s }, l = {}, d = {};
      await Lt(l, "x-api-key", e), await ee(l, e), Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, {
        url: J(r),
        options: o
      };
    },
    /**
     * 
     * @summary Retrieve specific county record for a property.
     * @param {number} propId Property id to return county records for.
     * @param {number} recordId Record id to retrieve.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    countyRecord: async (t, s, n = {}) => {
      se("countyRecord", "propId", t), se("countyRecord", "recordId", s);
      const r = "/property/records/{propId}/county-records/{recordId}".replace("{propId}", encodeURIComponent(String(t))).replace("{recordId}", encodeURIComponent(String(s))), i = new URL(r, K);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "GET", ...o, ...n }, d = {}, c = {};
      await Lt(d, "x-api-key", e), await ee(d, e), Z(i, c);
      let u = o && o.headers ? o.headers : {};
      return l.headers = { ...d, ...u, ...n.headers }, {
        url: J(i),
        options: l
      };
    },
    /**
     * 
     * @summary Retrieve county records for a property.
     * @param {number} propId Property id to return county records for.
     * @param {number} [page] Current page of records to return.
     * @param {number} [pageSize] Total records per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    countyRecords: async (t, s, n, r = {}) => {
      se("countyRecords", "propId", t);
      const i = "/property/records/{propId}/county-records".replace("{propId}", encodeURIComponent(String(t))), o = new URL(i, K);
      let l;
      e && (l = e.baseOptions);
      const d = { method: "GET", ...l, ...r }, c = {}, u = {};
      await Lt(c, "x-api-key", e), await ee(c, e), s !== void 0 && (u.page = s), n !== void 0 && (u.pageSize = n), Z(o, u);
      let m = l && l.headers ? l.headers : {};
      return d.headers = { ...c, ...m, ...r.headers }, {
        url: J(o),
        options: d
      };
    },
    /**
     * 
     * @summary Retrieve latest foreclosure record for property.
     * @param {number} propId Property id to return foreclosure record for.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    foreclosure: async (t, s = {}) => {
      se("foreclosure", "propId", t);
      const n = "/property/records/{propId}/foreclosure".replace("{propId}", encodeURIComponent(String(t))), r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "GET", ...i, ...s }, l = {}, d = {};
      await Lt(l, "x-api-key", e), await ee(l, e), Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, {
        url: J(r),
        options: o
      };
    },
    /**
     * 
     * @summary Retrieve latest mortgage record for property.
     * @param {number} propId Property id to return mortgage record for.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    mortgage: async (t, s = {}) => {
      se("mortgage", "propId", t);
      const n = "/property/records/{propId}/mortgage".replace("{propId}", encodeURIComponent(String(t))), r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "GET", ...i, ...s }, l = {}, d = {};
      await Lt(l, "x-api-key", e), await ee(l, e), Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, {
        url: J(r),
        options: o
      };
    },
    /**
     * 
     * @summary Retrieve latest ownership record for property.
     * @param {number} propId Property id to return ownership record for.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    ownership: async (t, s = {}) => {
      se("ownership", "propId", t);
      const n = "/property/records/{propId}/ownership".replace("{propId}", encodeURIComponent(String(t))), r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "GET", ...i, ...s }, l = {}, d = {};
      await Lt(l, "x-api-key", e), await ee(l, e), Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, {
        url: J(r),
        options: o
      };
    },
    /**
     * 
     * @summary Retrieve ownership record for property.
     * @param {number} propId Property id to return ownership record for.
     * @param {number} recordId Record Id.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    ownershipById: async (t, s, n = {}) => {
      se("ownershipById", "propId", t), se("ownershipById", "recordId", s);
      const r = "/property/records/{propId}/ownership/{recordId}".replace("{propId}", encodeURIComponent(String(t))).replace("{recordId}", encodeURIComponent(String(s))), i = new URL(r, K);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "GET", ...o, ...n }, d = {}, c = {};
      await Lt(d, "x-api-key", e), await ee(d, e), Z(i, c);
      let u = o && o.headers ? o.headers : {};
      return l.headers = { ...d, ...u, ...n.headers }, {
        url: J(i),
        options: l
      };
    }
  };
}, CT = function(e) {
  const t = wT(e);
  return {
    /**
     * 
     * @summary Retrieve tax assessor info for a property.
     * @param {number} propId Property Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async countyInfo(s, n) {
      var l, d;
      const r = await t.countyInfo(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["RecordsApi.countyInfo"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    },
    /**
     * 
     * @summary Retrieve specific county record for a property.
     * @param {number} propId Property id to return county records for.
     * @param {number} recordId Record id to retrieve.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async countyRecord(s, n, r) {
      var d, c;
      const i = await t.countyRecord(s, n, r), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (c = (d = Q["RecordsApi.countyRecord"]) == null ? void 0 : d[o]) == null ? void 0 : c.url;
      return (u, m) => _(i, X, G, e)(u, l || m);
    },
    /**
     * 
     * @summary Retrieve county records for a property.
     * @param {number} propId Property id to return county records for.
     * @param {number} [page] Current page of records to return.
     * @param {number} [pageSize] Total records per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async countyRecords(s, n, r, i) {
      var c, u;
      const o = await t.countyRecords(s, n, r, i), l = (e == null ? void 0 : e.serverIndex) ?? 0, d = (u = (c = Q["RecordsApi.countyRecords"]) == null ? void 0 : c[l]) == null ? void 0 : u.url;
      return (m, f) => _(o, X, G, e)(m, d || f);
    },
    /**
     * 
     * @summary Retrieve latest foreclosure record for property.
     * @param {number} propId Property id to return foreclosure record for.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async foreclosure(s, n) {
      var l, d;
      const r = await t.foreclosure(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["RecordsApi.foreclosure"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    },
    /**
     * 
     * @summary Retrieve latest mortgage record for property.
     * @param {number} propId Property id to return mortgage record for.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async mortgage(s, n) {
      var l, d;
      const r = await t.mortgage(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["RecordsApi.mortgage"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    },
    /**
     * 
     * @summary Retrieve latest ownership record for property.
     * @param {number} propId Property id to return ownership record for.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async ownership(s, n) {
      var l, d;
      const r = await t.ownership(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["RecordsApi.ownership"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    },
    /**
     * 
     * @summary Retrieve ownership record for property.
     * @param {number} propId Property id to return ownership record for.
     * @param {number} recordId Record Id.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async ownershipById(s, n, r) {
      var d, c;
      const i = await t.ownershipById(s, n, r), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (c = (d = Q["RecordsApi.ownershipById"]) == null ? void 0 : d[o]) == null ? void 0 : c.url;
      return (u, m) => _(i, X, G, e)(u, l || m);
    }
  };
}, ST = function(e, t, s) {
  const n = CT(e);
  return {
    /**
     * 
     * @summary Retrieve tax assessor info for a property.
     * @param {number} propId Property Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    countyInfo(r, i) {
      return n.countyInfo(r, i).then((o) => o(s, t));
    },
    /**
     * 
     * @summary Retrieve specific county record for a property.
     * @param {number} propId Property id to return county records for.
     * @param {number} recordId Record id to retrieve.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    countyRecord(r, i, o) {
      return n.countyRecord(r, i, o).then((l) => l(s, t));
    },
    /**
     * 
     * @summary Retrieve county records for a property.
     * @param {number} propId Property id to return county records for.
     * @param {number} [page] Current page of records to return.
     * @param {number} [pageSize] Total records per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    countyRecords(r, i, o, l) {
      return n.countyRecords(r, i, o, l).then((d) => d(s, t));
    },
    /**
     * 
     * @summary Retrieve latest foreclosure record for property.
     * @param {number} propId Property id to return foreclosure record for.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    foreclosure(r, i) {
      return n.foreclosure(r, i).then((o) => o(s, t));
    },
    /**
     * 
     * @summary Retrieve latest mortgage record for property.
     * @param {number} propId Property id to return mortgage record for.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    mortgage(r, i) {
      return n.mortgage(r, i).then((o) => o(s, t));
    },
    /**
     * 
     * @summary Retrieve latest ownership record for property.
     * @param {number} propId Property id to return ownership record for.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    ownership(r, i) {
      return n.ownership(r, i).then((o) => o(s, t));
    },
    /**
     * 
     * @summary Retrieve ownership record for property.
     * @param {number} propId Property id to return ownership record for.
     * @param {number} recordId Record Id.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    ownershipById(r, i, o) {
      return n.ownershipById(r, i, o).then((l) => l(s, t));
    }
  };
}, PT = function(e) {
  return {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    managementTerritory: async (t = {}) => {
      const s = "/rental-scout/management-territory", n = new URL(s, K);
      let r;
      e && (r = e.baseOptions);
      const i = { method: "GET", ...r, ...t }, o = {}, l = {};
      await ee(o, e), Z(n, l);
      let d = r && r.headers ? r.headers : {};
      return i.headers = { ...o, ...d, ...t.headers }, {
        url: J(n),
        options: i
      };
    },
    /**
     * 
     * @param {RentalScoutSearchModel} [rentalScoutSearchModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    search: async (t, s = {}) => {
      const n = "/rental-scout/search", r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "POST", ...i, ...s }, l = {}, d = {};
      await ee(l, e), l["Content-Type"] = "application/json", Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, o.data = kt(t, o, e), {
        url: J(r),
        options: o
      };
    }
  };
}, lA = function(e) {
  const t = PT(e);
  return {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async managementTerritory(s) {
      var o, l;
      const n = await t.managementTerritory(s), r = (e == null ? void 0 : e.serverIndex) ?? 0, i = (l = (o = Q["RentalScoutApi.managementTerritory"]) == null ? void 0 : o[r]) == null ? void 0 : l.url;
      return (d, c) => _(n, X, G, e)(d, i || c);
    },
    /**
     * 
     * @param {RentalScoutSearchModel} [rentalScoutSearchModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async search(s, n) {
      var l, d;
      const r = await t.search(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["RentalScoutApi.search"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    }
  };
};
class kT extends Fn {
  /**
   * 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RentalScoutApi
   */
  managementTerritory(t) {
    return lA(this.configuration).managementTerritory(t).then((s) => s(this.axios, this.basePath));
  }
  /**
   * 
   * @param {RentalScoutSearchModel} [rentalScoutSearchModel] 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RentalScoutApi
   */
  search(t, s) {
    return lA(this.configuration).search(t, s).then((n) => n(this.axios, this.basePath));
  }
}
const ET = function(e) {
  return {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    disconnect: async (t = {}) => {
      const s = "/integrations/rentvine/settings", n = new URL(s, K);
      let r;
      e && (r = e.baseOptions);
      const i = { method: "DELETE", ...r, ...t }, o = {}, l = {};
      await ee(o, e), Z(n, l);
      let d = r && r.headers ? r.headers : {};
      return i.headers = { ...o, ...d, ...t.headers }, {
        url: J(n),
        options: i
      };
    },
    /**
     * 
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {number} [filterType] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getLogs: async (t, s, n, r = {}) => {
      const i = "/integrations/rentvine/logs", o = new URL(i, K);
      let l;
      e && (l = e.baseOptions);
      const d = { method: "GET", ...l, ...r }, c = {}, u = {};
      await ee(c, e), t !== void 0 && (u.page = t), s !== void 0 && (u.pageSize = s), n !== void 0 && (u.filterType = n), Z(o, u);
      let m = l && l.headers ? l.headers : {};
      return d.headers = { ...c, ...m, ...r.headers }, {
        url: J(o),
        options: d
      };
    },
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSettings: async (t = {}) => {
      const s = "/integrations/rentvine/settings", n = new URL(s, K);
      let r;
      e && (r = e.baseOptions);
      const i = { method: "GET", ...r, ...t }, o = {}, l = {};
      await ee(o, e), Z(n, l);
      let d = r && r.headers ? r.headers : {};
      return i.headers = { ...o, ...d, ...t.headers }, {
        url: J(n),
        options: i
      };
    },
    /**
     * 
     * @param {RentvineSettings} [rentvineSettings] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateSettings: async (t, s = {}) => {
      const n = "/integrations/rentvine/settings", r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "POST", ...i, ...s }, l = {}, d = {};
      await ee(l, e), l["Content-Type"] = "application/json", Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, o.data = kt(t, o, e), {
        url: J(r),
        options: o
      };
    }
  };
}, IT = function(e) {
  const t = ET(e);
  return {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async disconnect(s) {
      var o, l;
      const n = await t.disconnect(s), r = (e == null ? void 0 : e.serverIndex) ?? 0, i = (l = (o = Q["RentvineApi.disconnect"]) == null ? void 0 : o[r]) == null ? void 0 : l.url;
      return (d, c) => _(n, X, G, e)(d, i || c);
    },
    /**
     * 
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {number} [filterType] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getLogs(s, n, r, i) {
      var c, u;
      const o = await t.getLogs(s, n, r, i), l = (e == null ? void 0 : e.serverIndex) ?? 0, d = (u = (c = Q["RentvineApi.getLogs"]) == null ? void 0 : c[l]) == null ? void 0 : u.url;
      return (m, f) => _(o, X, G, e)(m, d || f);
    },
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getSettings(s) {
      var o, l;
      const n = await t.getSettings(s), r = (e == null ? void 0 : e.serverIndex) ?? 0, i = (l = (o = Q["RentvineApi.getSettings"]) == null ? void 0 : o[r]) == null ? void 0 : l.url;
      return (d, c) => _(n, X, G, e)(d, i || c);
    },
    /**
     * 
     * @param {RentvineSettings} [rentvineSettings] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateSettings(s, n) {
      var l, d;
      const r = await t.updateSettings(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["RentvineApi.updateSettings"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    }
  };
}, TT = function(e, t, s) {
  const n = IT(e);
  return {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    disconnect(r) {
      return n.disconnect(r).then((i) => i(s, t));
    },
    /**
     * 
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {number} [filterType] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getLogs(r, i, o, l) {
      return n.getLogs(r, i, o, l).then((d) => d(s, t));
    },
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSettings(r) {
      return n.getSettings(r).then((i) => i(s, t));
    },
    /**
     * 
     * @param {RentvineSettings} [rentvineSettings] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateSettings(r, i) {
      return n.updateSettings(r, i).then((o) => o(s, t));
    }
  };
}, OT = function(e) {
  return {
    /**
     * 
     * @summary Retrieve school info & stats.
     * @param {Array<string>} nces List of NCES IDs of schools to retrieve.
     * @param {boolean} [census] To include school census data in response.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    info: async (t, s, n = {}) => {
      se("info", "nces", t);
      const r = "/schools/info", i = new URL(r, K);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "GET", ...o, ...n }, d = {}, c = {};
      await Lt(d, "x-api-key", e), await ee(d, e), t && (c.nces = t), s !== void 0 && (c.census = s), Z(i, c);
      let u = o && o.headers ? o.headers : {};
      return l.headers = { ...d, ...u, ...n.headers }, {
        url: J(i),
        options: l
      };
    },
    /**
     * 
     * @summary Retrieve school info & stats for listing.
     * @param {string} mlsSource 
     * @param {string} mlsNumber 
     * @param {boolean} [census] To include school census data in response.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listing: async (t, s, n, r = {}) => {
      se("listing", "mlsSource", t), se("listing", "mlsNumber", s);
      const i = "/mls/{mlsSource}/{mlsNumber}/schools".replace("{mlsSource}", encodeURIComponent(String(t))).replace("{mlsNumber}", encodeURIComponent(String(s))), o = new URL(i, K);
      let l;
      e && (l = e.baseOptions);
      const d = { method: "GET", ...l, ...r }, c = {}, u = {};
      await Lt(c, "x-api-key", e), await ee(c, e), n !== void 0 && (u.census = n), Z(o, u);
      let m = l && l.headers ? l.headers : {};
      return d.headers = { ...c, ...m, ...r.headers }, {
        url: J(o),
        options: d
      };
    },
    /**
     * 
     * @summary Retrieve school info & stats for listing.
     * @param {number} propId 
     * @param {boolean} [census] To include school census data in response.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    property: async (t, s, n = {}) => {
      se("property", "propId", t);
      const r = "/homes/{propId}/schools".replace("{propId}", encodeURIComponent(String(t))), i = new URL(r, K);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "GET", ...o, ...n }, d = {}, c = {};
      await Lt(d, "x-api-key", e), await ee(d, e), s !== void 0 && (c.census = s), Z(i, c);
      let u = o && o.headers ? o.headers : {};
      return l.headers = { ...d, ...u, ...n.headers }, {
        url: J(i),
        options: l
      };
    }
  };
}, RT = function(e) {
  const t = OT(e);
  return {
    /**
     * 
     * @summary Retrieve school info & stats.
     * @param {Array<string>} nces List of NCES IDs of schools to retrieve.
     * @param {boolean} [census] To include school census data in response.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async info(s, n, r) {
      var d, c;
      const i = await t.info(s, n, r), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (c = (d = Q["SchoolsApi.info"]) == null ? void 0 : d[o]) == null ? void 0 : c.url;
      return (u, m) => _(i, X, G, e)(u, l || m);
    },
    /**
     * 
     * @summary Retrieve school info & stats for listing.
     * @param {string} mlsSource 
     * @param {string} mlsNumber 
     * @param {boolean} [census] To include school census data in response.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async listing(s, n, r, i) {
      var c, u;
      const o = await t.listing(s, n, r, i), l = (e == null ? void 0 : e.serverIndex) ?? 0, d = (u = (c = Q["SchoolsApi.listing"]) == null ? void 0 : c[l]) == null ? void 0 : u.url;
      return (m, f) => _(o, X, G, e)(m, d || f);
    },
    /**
     * 
     * @summary Retrieve school info & stats for listing.
     * @param {number} propId 
     * @param {boolean} [census] To include school census data in response.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async property(s, n, r) {
      var d, c;
      const i = await t.property(s, n, r), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (c = (d = Q["SchoolsApi.property"]) == null ? void 0 : d[o]) == null ? void 0 : c.url;
      return (u, m) => _(i, X, G, e)(u, l || m);
    }
  };
}, LT = function(e, t, s) {
  const n = RT(e);
  return {
    /**
     * 
     * @summary Retrieve school info & stats.
     * @param {Array<string>} nces List of NCES IDs of schools to retrieve.
     * @param {boolean} [census] To include school census data in response.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    info(r, i, o) {
      return n.info(r, i, o).then((l) => l(s, t));
    },
    /**
     * 
     * @summary Retrieve school info & stats for listing.
     * @param {string} mlsSource 
     * @param {string} mlsNumber 
     * @param {boolean} [census] To include school census data in response.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listing(r, i, o, l) {
      return n.listing(r, i, o, l).then((d) => d(s, t));
    },
    /**
     * 
     * @summary Retrieve school info & stats for listing.
     * @param {number} propId 
     * @param {boolean} [census] To include school census data in response.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    property(r, i, o) {
      return n.property(r, i, o).then((l) => l(s, t));
    }
  };
}, BT = function(e) {
  return {
    /**
     * 
     * @summary Searches predefined scoped areas.
     * @param {string} bounds Geographic polygon to search
     * @param {number} level Zoom level
     * @param {number} [priceMin] 
     * @param {number} [priceMax] 
     * @param {number} [bedroomsMin] 
     * @param {number} [bathroomsMin] 
     * @param {number} [sqftMin] 
     * @param {number} [sqftMax] 
     * @param {number} [lotMin] 
     * @param {number} [lotMax] 
     * @param {number} [yearMin] 
     * @param {number} [yearMax] 
     * @param {number} [storiesMax] 
     * @param {number} [t] 
     * @param {boolean} [b] 
     * @param {boolean} [pp] 
     * @param {number} [dor] 
     * @param {boolean} [l] 
     * @param {boolean} [m] 
     * @param {boolean} [to] 
     * @param {boolean} [p] 
     * @param {number} [downPayment] 
     * @param {number} [interestRate] 
     * @param {number} [amortizationPeriod] 
     * @param {number} [loanFees] 
     * @param {boolean} [interestOnlyLoan] 
     * @param {number} [interestOnlyTerm] 
     * @param {number} [titleCharges] 
     * @param {number} [averageLengthOfStay] 
     * @param {number} [timeBetweenTenants] 
     * @param {number} [costOfSale] 
     * @param {number} [annualRentalGrowth] 
     * @param {number} [annualExpenseGrowth] 
     * @param {number} [propertyAppreciation] 
     * @param {boolean} [stabilizationReserve] 
     * @param {number} [minCapRate] 
     * @param {number} [minCoC] 
     * @param {number} [minCoCAfterTax] 
     * @param {number} [minIRR] 
     * @param {number} [minIRRAfterTax] 
     * @param {number} [hold] 
     * @param {BlueChipFilters} [blueChipFilters] 
     * @param {StandardIncomeExpenseAccounts} [percentageLongTermFields] 
     * @param {number} [managementFee] 
     * @param {number} [leaseCommission] 
     * @param {number} [leaseRenewalFee] 
     * @param {number} [platformServiceFees] 
     * @param {number} [maintenance] 
     * @param {number} [utilityExpenses] 
     * @param {number} [furnishingExpenses] 
     * @param {number} [consumableExpenses] 
     * @param {number} [cleaningExpenses] 
     * @param {number} [otherExpense] 
     * @param {number} [capitalExpenditures] 
     * @param {number} [otherIncome] 
     * @param {StandardIncomeExpenseAccounts} [percentageShortTermFields] 
     * @param {number} [strManagementFee] 
     * @param {number} [strLeaseCommission] 
     * @param {number} [strLeaseRenewalFee] 
     * @param {number} [strPlatformServiceFees] 
     * @param {number} [strMaintenance] 
     * @param {number} [strUtilityExpenses] 
     * @param {number} [strFurnishingExpenses] 
     * @param {number} [strConsumableExpenses] 
     * @param {number} [strCleaningExpenses] 
     * @param {number} [strOtherExpense] 
     * @param {number} [strCapitalExpenditures] 
     * @param {number} [strOtherIncome] 
     * @param {number} [strWorkingCapitalReserve] 
     * @param {number} [strDaysOccupiedPerYear] 
     * @param {number} [strDaysAvailablePerYear] 
     * @param {number} [strAnnualRentalGrowth] 
     * @param {number} [strAnnualExpenseGrowth] 
     * @param {number} [strPropertyAppreciation] 
     * @param {StandardIncomeExpenseAccounts} [percentagePadSplitFields] 
     * @param {number} [padSplitWorkingCapitalReserve] 
     * @param {number} [padSplitAnnualVacancyRate] 
     * @param {number} [padSplitMaintenance] 
     * @param {number} [padSplitFurnishingExpenses] 
     * @param {number} [padSplitConsumableExpenses] 
     * @param {number} [padSplitUtilityExpenses] 
     * @param {number} [padSplitCleaningExpenses] 
     * @param {number} [padSplitPlatformServiceFees] 
     * @param {number} [padSplitManagementFee] 
     * @param {number} [padSplitAnnualRentalGrowth] 
     * @param {number} [padSplitAnnualExpenseGrowth] 
     * @param {number} [padSplitPropertyAppreciation] 
     * @param {boolean} [padSplitOtherExpensePercentage] 
     * @param {number} [padSplitLeaseCommission] 
     * @param {number} [padSplitLeaseRenewalFee] 
     * @param {number} [padSplitOtherExpense] 
     * @param {number} [padSplitCapitalExpenditures] 
     * @param {number} [padSplitOtherIncome] 
     * @param {number} [padSplitBookingFeeDays] 
     * @param {number} [padSplitAverageLengthOfStay] 
     * @param {Array<CalculatorOtherAccountValue>} [otherExpensesLongTerm] 
     * @param {Array<CalculatorOtherAccountValue>} [otherExpensesShortTerm] 
     * @param {Array<CalculatorOtherAccountValue>} [otherExpensesPadSplit] 
     * @param {Array<CalculatorOtherAccountValue>} [otherIncomesLongTerm] 
     * @param {Array<CalculatorOtherAccountValue>} [otherIncomesShortTerm] 
     * @param {Array<CalculatorOtherAccountValue>} [otherIncomesPadSplit] 
     * @param {string} [s] Name of saved search
     * @param {number} [id] Id of existing saved search to base query from and update
     * @param {boolean} [r] Return listing data
     * @param {boolean} [mb] 
     * @param {number} [cb] Random number to force refresh, avoid cache.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    areaSearch: async (t, s, n, r, i, o, l, d, c, u, m, f, v, b, w, S, I, T, x, k, C, O, E, B, M, R, F, L, j, H, te, re, le, ie, ye, Y, ae, ke, ue, oe, fe, we, Ie, be, Oe, ze, Re, ge, he, Me, Ne, $e, mt, yt, Ct, gt, Ge, Ee, Ce, xe, Pe, it, lt, dt, vt, It, Dt, ht, _t, fs, Hs, Fs, Ts, Ps, Bs, qt, Os, Ms, ts, gs, xs, Be, Ye, Je, At, Tt, Yt, bs, us, Nt, Gs, Qs, Ks, Zs, Js, $s, _s, ea, ta, sa, aa, na, ra, oa, ia, la, da = {}) => {
      se("areaSearch", "bounds", t), se("areaSearch", "level", s);
      const wa = "/search/mls/area", ma = new URL(wa, K);
      let ws;
      e && (ws = e.baseOptions);
      const zs = { method: "GET", ...ws, ...da }, va = {}, ne = {};
      await ee(va, e), t !== void 0 && (ne.bounds = t), s !== void 0 && (ne.level = s), n !== void 0 && (ne.priceMin = n), r !== void 0 && (ne.priceMax = r), i !== void 0 && (ne.bedroomsMin = i), o !== void 0 && (ne.bathroomsMin = o), l !== void 0 && (ne.sqftMin = l), d !== void 0 && (ne.sqftMax = d), c !== void 0 && (ne.lotMin = c), u !== void 0 && (ne.lotMax = u), m !== void 0 && (ne.yearMin = m), f !== void 0 && (ne.yearMax = f), v !== void 0 && (ne.storiesMax = v), b !== void 0 && (ne.t = b), w !== void 0 && (ne.b = w), S !== void 0 && (ne.pp = S), I !== void 0 && (ne.dor = I), T !== void 0 && (ne.l = T), x !== void 0 && (ne.m = x), k !== void 0 && (ne.to = k), C !== void 0 && (ne.p = C), O !== void 0 && (ne.DownPayment = O), E !== void 0 && (ne.InterestRate = E), B !== void 0 && (ne.AmortizationPeriod = B), M !== void 0 && (ne.LoanFees = M), R !== void 0 && (ne.InterestOnlyLoan = R), F !== void 0 && (ne.InterestOnlyTerm = F), L !== void 0 && (ne.TitleCharges = L), j !== void 0 && (ne.AverageLengthOfStay = j), H !== void 0 && (ne.TimeBetweenTenants = H), te !== void 0 && (ne.CostOfSale = te), re !== void 0 && (ne.AnnualRentalGrowth = re), le !== void 0 && (ne.AnnualExpenseGrowth = le), ie !== void 0 && (ne.PropertyAppreciation = ie), ye !== void 0 && (ne.StabilizationReserve = ye), Y !== void 0 && (ne.MinCapRate = Y), ae !== void 0 && (ne.MinCoC = ae), ke !== void 0 && (ne.MinCoCAfterTax = ke), ue !== void 0 && (ne.MinIRR = ue), oe !== void 0 && (ne.MinIRRAfterTax = oe), fe !== void 0 && (ne.Hold = fe), we !== void 0 && (ne.BlueChipFilters = we), Ie !== void 0 && (ne.PercentageLongTermFields = Ie), be !== void 0 && (ne.ManagementFee = be), Oe !== void 0 && (ne.LeaseCommission = Oe), ze !== void 0 && (ne.LeaseRenewalFee = ze), Re !== void 0 && (ne.PlatformServiceFees = Re), ge !== void 0 && (ne.Maintenance = ge), he !== void 0 && (ne.UtilityExpenses = he), Me !== void 0 && (ne.FurnishingExpenses = Me), Ne !== void 0 && (ne.ConsumableExpenses = Ne), $e !== void 0 && (ne.CleaningExpenses = $e), mt !== void 0 && (ne.OtherExpense = mt), yt !== void 0 && (ne.CapitalExpenditures = yt), Ct !== void 0 && (ne.OtherIncome = Ct), gt !== void 0 && (ne.PercentageShortTermFields = gt), Ge !== void 0 && (ne.StrManagementFee = Ge), Ee !== void 0 && (ne.StrLeaseCommission = Ee), Ce !== void 0 && (ne.StrLeaseRenewalFee = Ce), xe !== void 0 && (ne.StrPlatformServiceFees = xe), Pe !== void 0 && (ne.StrMaintenance = Pe), it !== void 0 && (ne.StrUtilityExpenses = it), lt !== void 0 && (ne.StrFurnishingExpenses = lt), dt !== void 0 && (ne.StrConsumableExpenses = dt), vt !== void 0 && (ne.StrCleaningExpenses = vt), It !== void 0 && (ne.StrOtherExpense = It), Dt !== void 0 && (ne.StrCapitalExpenditures = Dt), ht !== void 0 && (ne.StrOtherIncome = ht), _t !== void 0 && (ne.StrWorkingCapitalReserve = _t), fs !== void 0 && (ne.StrDaysOccupiedPerYear = fs), Hs !== void 0 && (ne.StrDaysAvailablePerYear = Hs), Fs !== void 0 && (ne.StrAnnualRentalGrowth = Fs), Ts !== void 0 && (ne.StrAnnualExpenseGrowth = Ts), Ps !== void 0 && (ne.StrPropertyAppreciation = Ps), Bs !== void 0 && (ne.PercentagePadSplitFields = Bs), qt !== void 0 && (ne.PadSplitWorkingCapitalReserve = qt), Os !== void 0 && (ne.PadSplitAnnualVacancyRate = Os), Ms !== void 0 && (ne.PadSplitMaintenance = Ms), ts !== void 0 && (ne.PadSplitFurnishingExpenses = ts), gs !== void 0 && (ne.PadSplitConsumableExpenses = gs), xs !== void 0 && (ne.PadSplitUtilityExpenses = xs), Be !== void 0 && (ne.PadSplitCleaningExpenses = Be), Ye !== void 0 && (ne.PadSplitPlatformServiceFees = Ye), Je !== void 0 && (ne.PadSplitManagementFee = Je), At !== void 0 && (ne.PadSplitAnnualRentalGrowth = At), Tt !== void 0 && (ne.PadSplitAnnualExpenseGrowth = Tt), Yt !== void 0 && (ne.PadSplitPropertyAppreciation = Yt), bs !== void 0 && (ne.PadSplitOtherExpensePercentage = bs), us !== void 0 && (ne.PadSplitLeaseCommission = us), Nt !== void 0 && (ne.PadSplitLeaseRenewalFee = Nt), Gs !== void 0 && (ne.PadSplitOtherExpense = Gs), Qs !== void 0 && (ne.PadSplitCapitalExpenditures = Qs), Ks !== void 0 && (ne.PadSplitOtherIncome = Ks), Zs !== void 0 && (ne.PadSplitBookingFeeDays = Zs), Js !== void 0 && (ne.PadSplitAverageLengthOfStay = Js), $s && (ne["OtherExpenses.LongTerm"] = $s), _s && (ne["OtherExpenses.ShortTerm"] = _s), ea && (ne["OtherExpenses.PadSplit"] = ea), ta && (ne["OtherIncomes.LongTerm"] = ta), sa && (ne["OtherIncomes.ShortTerm"] = sa), aa && (ne["OtherIncomes.PadSplit"] = aa), na !== void 0 && (ne.s = na), ra !== void 0 && (ne.id = ra), oa !== void 0 && (ne.r = oa), ia !== void 0 && (ne.mb = ia), la !== void 0 && (ne.cb = la), Z(ma, ne);
      let et = ws && ws.headers ? ws.headers : {};
      return zs.headers = { ...va, ...et, ...da.headers }, {
        url: J(ma),
        options: zs
      };
    },
    /**
     * 
     * @summary Searches predefined scoped areas.
     * @param {string} bounds Geographic polygon to search
     * @param {number} level Zoom level
     * @param {number} [priceMin] 
     * @param {number} [priceMax] 
     * @param {number} [bedroomsMin] 
     * @param {number} [bathroomsMin] 
     * @param {number} [sqftMin] 
     * @param {number} [sqftMax] 
     * @param {number} [lotMin] 
     * @param {number} [lotMax] 
     * @param {number} [yearMin] 
     * @param {number} [yearMax] 
     * @param {number} [storiesMax] 
     * @param {number} [t] 
     * @param {boolean} [b] 
     * @param {boolean} [pp] 
     * @param {number} [dor] 
     * @param {boolean} [l] 
     * @param {boolean} [m] 
     * @param {boolean} [to] 
     * @param {boolean} [p] 
     * @param {number} [downPayment] 
     * @param {number} [interestRate] 
     * @param {number} [amortizationPeriod] 
     * @param {number} [loanFees] 
     * @param {boolean} [interestOnlyLoan] 
     * @param {number} [interestOnlyTerm] 
     * @param {number} [titleCharges] 
     * @param {number} [averageLengthOfStay] 
     * @param {number} [timeBetweenTenants] 
     * @param {number} [costOfSale] 
     * @param {number} [annualRentalGrowth] 
     * @param {number} [annualExpenseGrowth] 
     * @param {number} [propertyAppreciation] 
     * @param {boolean} [stabilizationReserve] 
     * @param {number} [minCapRate] 
     * @param {number} [minCoC] 
     * @param {number} [minCoCAfterTax] 
     * @param {number} [minIRR] 
     * @param {number} [minIRRAfterTax] 
     * @param {number} [hold] 
     * @param {BlueChipFilters} [blueChipFilters] 
     * @param {StandardIncomeExpenseAccounts} [percentageLongTermFields] 
     * @param {number} [managementFee] 
     * @param {number} [leaseCommission] 
     * @param {number} [leaseRenewalFee] 
     * @param {number} [platformServiceFees] 
     * @param {number} [maintenance] 
     * @param {number} [utilityExpenses] 
     * @param {number} [furnishingExpenses] 
     * @param {number} [consumableExpenses] 
     * @param {number} [cleaningExpenses] 
     * @param {number} [otherExpense] 
     * @param {number} [capitalExpenditures] 
     * @param {number} [otherIncome] 
     * @param {StandardIncomeExpenseAccounts} [percentageShortTermFields] 
     * @param {number} [strManagementFee] 
     * @param {number} [strLeaseCommission] 
     * @param {number} [strLeaseRenewalFee] 
     * @param {number} [strPlatformServiceFees] 
     * @param {number} [strMaintenance] 
     * @param {number} [strUtilityExpenses] 
     * @param {number} [strFurnishingExpenses] 
     * @param {number} [strConsumableExpenses] 
     * @param {number} [strCleaningExpenses] 
     * @param {number} [strOtherExpense] 
     * @param {number} [strCapitalExpenditures] 
     * @param {number} [strOtherIncome] 
     * @param {number} [strWorkingCapitalReserve] 
     * @param {number} [strDaysOccupiedPerYear] 
     * @param {number} [strDaysAvailablePerYear] 
     * @param {number} [strAnnualRentalGrowth] 
     * @param {number} [strAnnualExpenseGrowth] 
     * @param {number} [strPropertyAppreciation] 
     * @param {StandardIncomeExpenseAccounts} [percentagePadSplitFields] 
     * @param {number} [padSplitWorkingCapitalReserve] 
     * @param {number} [padSplitAnnualVacancyRate] 
     * @param {number} [padSplitMaintenance] 
     * @param {number} [padSplitFurnishingExpenses] 
     * @param {number} [padSplitConsumableExpenses] 
     * @param {number} [padSplitUtilityExpenses] 
     * @param {number} [padSplitCleaningExpenses] 
     * @param {number} [padSplitPlatformServiceFees] 
     * @param {number} [padSplitManagementFee] 
     * @param {number} [padSplitAnnualRentalGrowth] 
     * @param {number} [padSplitAnnualExpenseGrowth] 
     * @param {number} [padSplitPropertyAppreciation] 
     * @param {boolean} [padSplitOtherExpensePercentage] 
     * @param {number} [padSplitLeaseCommission] 
     * @param {number} [padSplitLeaseRenewalFee] 
     * @param {number} [padSplitOtherExpense] 
     * @param {number} [padSplitCapitalExpenditures] 
     * @param {number} [padSplitOtherIncome] 
     * @param {number} [padSplitBookingFeeDays] 
     * @param {number} [padSplitAverageLengthOfStay] 
     * @param {Array<CalculatorOtherAccountValue>} [otherExpensesLongTerm] 
     * @param {Array<CalculatorOtherAccountValue>} [otherExpensesShortTerm] 
     * @param {Array<CalculatorOtherAccountValue>} [otherExpensesPadSplit] 
     * @param {Array<CalculatorOtherAccountValue>} [otherIncomesLongTerm] 
     * @param {Array<CalculatorOtherAccountValue>} [otherIncomesShortTerm] 
     * @param {Array<CalculatorOtherAccountValue>} [otherIncomesPadSplit] 
     * @param {string} [s] Name of saved search
     * @param {number} [id] Id of existing saved search to base query from and update
     * @param {boolean} [r] Return listing data
     * @param {boolean} [save] Save filters/parameters as saved search
     * @param {boolean} [mb] Is bounds a map bound(true) or a drawn polygon bound.
     * @param {number} [cb] Random number to force refresh, avoid cache.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    areaSearchFeatured: async (t, s, n, r, i, o, l, d, c, u, m, f, v, b, w, S, I, T, x, k, C, O, E, B, M, R, F, L, j, H, te, re, le, ie, ye, Y, ae, ke, ue, oe, fe, we, Ie, be, Oe, ze, Re, ge, he, Me, Ne, $e, mt, yt, Ct, gt, Ge, Ee, Ce, xe, Pe, it, lt, dt, vt, It, Dt, ht, _t, fs, Hs, Fs, Ts, Ps, Bs, qt, Os, Ms, ts, gs, xs, Be, Ye, Je, At, Tt, Yt, bs, us, Nt, Gs, Qs, Ks, Zs, Js, $s, _s, ea, ta, sa, aa, na, ra, oa, ia, la, da, wa = {}) => {
      se("areaSearchFeatured", "bounds", t), se("areaSearchFeatured", "level", s);
      const ma = "/search/mls/featured", ws = new URL(ma, K);
      let zs;
      e && (zs = e.baseOptions);
      const va = { method: "GET", ...zs, ...wa }, ne = {}, et = {};
      await ee(ne, e), t !== void 0 && (et.bounds = t), s !== void 0 && (et.level = s), n !== void 0 && (et.priceMin = n), r !== void 0 && (et.priceMax = r), i !== void 0 && (et.bedroomsMin = i), o !== void 0 && (et.bathroomsMin = o), l !== void 0 && (et.sqftMin = l), d !== void 0 && (et.sqftMax = d), c !== void 0 && (et.lotMin = c), u !== void 0 && (et.lotMax = u), m !== void 0 && (et.yearMin = m), f !== void 0 && (et.yearMax = f), v !== void 0 && (et.storiesMax = v), b !== void 0 && (et.t = b), w !== void 0 && (et.b = w), S !== void 0 && (et.pp = S), I !== void 0 && (et.dor = I), T !== void 0 && (et.l = T), x !== void 0 && (et.m = x), k !== void 0 && (et.to = k), C !== void 0 && (et.p = C), O !== void 0 && (et.DownPayment = O), E !== void 0 && (et.InterestRate = E), B !== void 0 && (et.AmortizationPeriod = B), M !== void 0 && (et.LoanFees = M), R !== void 0 && (et.InterestOnlyLoan = R), F !== void 0 && (et.InterestOnlyTerm = F), L !== void 0 && (et.TitleCharges = L), j !== void 0 && (et.AverageLengthOfStay = j), H !== void 0 && (et.TimeBetweenTenants = H), te !== void 0 && (et.CostOfSale = te), re !== void 0 && (et.AnnualRentalGrowth = re), le !== void 0 && (et.AnnualExpenseGrowth = le), ie !== void 0 && (et.PropertyAppreciation = ie), ye !== void 0 && (et.StabilizationReserve = ye), Y !== void 0 && (et.MinCapRate = Y), ae !== void 0 && (et.MinCoC = ae), ke !== void 0 && (et.MinCoCAfterTax = ke), ue !== void 0 && (et.MinIRR = ue), oe !== void 0 && (et.MinIRRAfterTax = oe), fe !== void 0 && (et.Hold = fe), we !== void 0 && (et.BlueChipFilters = we), Ie !== void 0 && (et.PercentageLongTermFields = Ie), be !== void 0 && (et.ManagementFee = be), Oe !== void 0 && (et.LeaseCommission = Oe), ze !== void 0 && (et.LeaseRenewalFee = ze), Re !== void 0 && (et.PlatformServiceFees = Re), ge !== void 0 && (et.Maintenance = ge), he !== void 0 && (et.UtilityExpenses = he), Me !== void 0 && (et.FurnishingExpenses = Me), Ne !== void 0 && (et.ConsumableExpenses = Ne), $e !== void 0 && (et.CleaningExpenses = $e), mt !== void 0 && (et.OtherExpense = mt), yt !== void 0 && (et.CapitalExpenditures = yt), Ct !== void 0 && (et.OtherIncome = Ct), gt !== void 0 && (et.PercentageShortTermFields = gt), Ge !== void 0 && (et.StrManagementFee = Ge), Ee !== void 0 && (et.StrLeaseCommission = Ee), Ce !== void 0 && (et.StrLeaseRenewalFee = Ce), xe !== void 0 && (et.StrPlatformServiceFees = xe), Pe !== void 0 && (et.StrMaintenance = Pe), it !== void 0 && (et.StrUtilityExpenses = it), lt !== void 0 && (et.StrFurnishingExpenses = lt), dt !== void 0 && (et.StrConsumableExpenses = dt), vt !== void 0 && (et.StrCleaningExpenses = vt), It !== void 0 && (et.StrOtherExpense = It), Dt !== void 0 && (et.StrCapitalExpenditures = Dt), ht !== void 0 && (et.StrOtherIncome = ht), _t !== void 0 && (et.StrWorkingCapitalReserve = _t), fs !== void 0 && (et.StrDaysOccupiedPerYear = fs), Hs !== void 0 && (et.StrDaysAvailablePerYear = Hs), Fs !== void 0 && (et.StrAnnualRentalGrowth = Fs), Ts !== void 0 && (et.StrAnnualExpenseGrowth = Ts), Ps !== void 0 && (et.StrPropertyAppreciation = Ps), Bs !== void 0 && (et.PercentagePadSplitFields = Bs), qt !== void 0 && (et.PadSplitWorkingCapitalReserve = qt), Os !== void 0 && (et.PadSplitAnnualVacancyRate = Os), Ms !== void 0 && (et.PadSplitMaintenance = Ms), ts !== void 0 && (et.PadSplitFurnishingExpenses = ts), gs !== void 0 && (et.PadSplitConsumableExpenses = gs), xs !== void 0 && (et.PadSplitUtilityExpenses = xs), Be !== void 0 && (et.PadSplitCleaningExpenses = Be), Ye !== void 0 && (et.PadSplitPlatformServiceFees = Ye), Je !== void 0 && (et.PadSplitManagementFee = Je), At !== void 0 && (et.PadSplitAnnualRentalGrowth = At), Tt !== void 0 && (et.PadSplitAnnualExpenseGrowth = Tt), Yt !== void 0 && (et.PadSplitPropertyAppreciation = Yt), bs !== void 0 && (et.PadSplitOtherExpensePercentage = bs), us !== void 0 && (et.PadSplitLeaseCommission = us), Nt !== void 0 && (et.PadSplitLeaseRenewalFee = Nt), Gs !== void 0 && (et.PadSplitOtherExpense = Gs), Qs !== void 0 && (et.PadSplitCapitalExpenditures = Qs), Ks !== void 0 && (et.PadSplitOtherIncome = Ks), Zs !== void 0 && (et.PadSplitBookingFeeDays = Zs), Js !== void 0 && (et.PadSplitAverageLengthOfStay = Js), $s && (et["OtherExpenses.LongTerm"] = $s), _s && (et["OtherExpenses.ShortTerm"] = _s), ea && (et["OtherExpenses.PadSplit"] = ea), ta && (et["OtherIncomes.LongTerm"] = ta), sa && (et["OtherIncomes.ShortTerm"] = sa), aa && (et["OtherIncomes.PadSplit"] = aa), na !== void 0 && (et.s = na), ra !== void 0 && (et.id = ra), oa !== void 0 && (et.r = oa), ia !== void 0 && (et.save = ia), la !== void 0 && (et.mb = la), da !== void 0 && (et.cb = da), Z(ws, et);
      let no = zs && zs.headers ? zs.headers : {};
      return va.headers = { ...ne, ...no, ...wa.headers }, {
        url: J(ws),
        options: va
      };
    },
    /**
     * 
     * @summary Client\'s agent\'s configured IDX default saved search.
     * @param {number} [m] Max results to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    defaultSearchForClient: async (t, s = {}) => {
      const n = "/search/mls/default/my-agents", r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "GET", ...i, ...s }, l = {}, d = {};
      await ee(l, e), t !== void 0 && (d.m = t), Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, {
        url: J(r),
        options: o
      };
    },
    /**
     * 
     * @summary Delete a users saved search.
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteSavedSearch: async (t, s = {}) => {
      se("deleteSavedSearch", "id", t);
      const n = "/search/mls/searches/{id}".replace("{id}", encodeURIComponent(String(t))), r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "DELETE", ...i, ...s }, l = {}, d = {};
      await ee(l, e), Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, {
        url: J(r),
        options: o
      };
    },
    /**
     * 
     * @summary Get account\'s search parameters.
     * @param {number} [id] Id of saved search
     * @param {number} [t] Random number to force refresh, avoid cache.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSearchParameters: async (t, s, n = {}) => {
      const r = "/search/mls/searches/parameters", i = new URL(r, K);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "GET", ...o, ...n }, d = {}, c = {};
      await ee(d, e), t !== void 0 && (c.id = t), s !== void 0 && (c.t = s), Z(i, c);
      let u = o && o.headers ? o.headers : {};
      return l.headers = { ...d, ...u, ...n.headers }, {
        url: J(i),
        options: l
      };
    },
    /**
     * 
     * @param {string} bounds 
     * @param {number} level 
     * @param {number} [priceMin] 
     * @param {number} [priceMax] 
     * @param {number} [bedroomsMin] 
     * @param {number} [bathroomsMin] 
     * @param {number} [sqftMin] 
     * @param {number} [sqftMax] 
     * @param {number} [lotMin] 
     * @param {number} [lotMax] 
     * @param {number} [yearMin] 
     * @param {number} [yearMax] 
     * @param {number} [storiesMax] 
     * @param {number} [t] 
     * @param {boolean} [b] 
     * @param {boolean} [pp] 
     * @param {number} [dor] 
     * @param {boolean} [l] 
     * @param {boolean} [m] 
     * @param {boolean} [to] 
     * @param {boolean} [p] 
     * @param {number} [downPayment] 
     * @param {number} [interestRate] 
     * @param {number} [amortizationPeriod] 
     * @param {number} [loanFees] 
     * @param {boolean} [interestOnlyLoan] 
     * @param {number} [interestOnlyTerm] 
     * @param {number} [titleCharges] 
     * @param {number} [averageLengthOfStay] 
     * @param {number} [timeBetweenTenants] 
     * @param {number} [costOfSale] 
     * @param {number} [annualRentalGrowth] 
     * @param {number} [annualExpenseGrowth] 
     * @param {number} [propertyAppreciation] 
     * @param {boolean} [stabilizationReserve] 
     * @param {number} [minCapRate] 
     * @param {number} [minCoC] 
     * @param {number} [minCoCAfterTax] 
     * @param {number} [minIRR] 
     * @param {number} [minIRRAfterTax] 
     * @param {number} [hold] 
     * @param {BlueChipFilters} [blueChipFilters] 
     * @param {StandardIncomeExpenseAccounts} [percentageLongTermFields] 
     * @param {number} [managementFee] 
     * @param {number} [leaseCommission] 
     * @param {number} [leaseRenewalFee] 
     * @param {number} [platformServiceFees] 
     * @param {number} [maintenance] 
     * @param {number} [utilityExpenses] 
     * @param {number} [furnishingExpenses] 
     * @param {number} [consumableExpenses] 
     * @param {number} [cleaningExpenses] 
     * @param {number} [otherExpense] 
     * @param {number} [capitalExpenditures] 
     * @param {number} [otherIncome] 
     * @param {StandardIncomeExpenseAccounts} [percentageShortTermFields] 
     * @param {number} [strManagementFee] 
     * @param {number} [strLeaseCommission] 
     * @param {number} [strLeaseRenewalFee] 
     * @param {number} [strPlatformServiceFees] 
     * @param {number} [strMaintenance] 
     * @param {number} [strUtilityExpenses] 
     * @param {number} [strFurnishingExpenses] 
     * @param {number} [strConsumableExpenses] 
     * @param {number} [strCleaningExpenses] 
     * @param {number} [strOtherExpense] 
     * @param {number} [strCapitalExpenditures] 
     * @param {number} [strOtherIncome] 
     * @param {number} [strWorkingCapitalReserve] 
     * @param {number} [strDaysOccupiedPerYear] 
     * @param {number} [strDaysAvailablePerYear] 
     * @param {number} [strAnnualRentalGrowth] 
     * @param {number} [strAnnualExpenseGrowth] 
     * @param {number} [strPropertyAppreciation] 
     * @param {StandardIncomeExpenseAccounts} [percentagePadSplitFields] 
     * @param {number} [padSplitWorkingCapitalReserve] 
     * @param {number} [padSplitAnnualVacancyRate] 
     * @param {number} [padSplitMaintenance] 
     * @param {number} [padSplitFurnishingExpenses] 
     * @param {number} [padSplitConsumableExpenses] 
     * @param {number} [padSplitUtilityExpenses] 
     * @param {number} [padSplitCleaningExpenses] 
     * @param {number} [padSplitPlatformServiceFees] 
     * @param {number} [padSplitManagementFee] 
     * @param {number} [padSplitAnnualRentalGrowth] 
     * @param {number} [padSplitAnnualExpenseGrowth] 
     * @param {number} [padSplitPropertyAppreciation] 
     * @param {boolean} [padSplitOtherExpensePercentage] 
     * @param {number} [padSplitLeaseCommission] 
     * @param {number} [padSplitLeaseRenewalFee] 
     * @param {number} [padSplitOtherExpense] 
     * @param {number} [padSplitCapitalExpenditures] 
     * @param {number} [padSplitOtherIncome] 
     * @param {number} [padSplitBookingFeeDays] 
     * @param {number} [padSplitAverageLengthOfStay] 
     * @param {Array<CalculatorOtherAccountValue>} [otherExpensesLongTerm] 
     * @param {Array<CalculatorOtherAccountValue>} [otherExpensesShortTerm] 
     * @param {Array<CalculatorOtherAccountValue>} [otherExpensesPadSplit] 
     * @param {Array<CalculatorOtherAccountValue>} [otherIncomesLongTerm] 
     * @param {Array<CalculatorOtherAccountValue>} [otherIncomesShortTerm] 
     * @param {Array<CalculatorOtherAccountValue>} [otherIncomesPadSplit] 
     * @param {string} [s] 
     * @param {number} [id] 
     * @param {boolean} [r] 
     * @param {boolean} [mb] 
     * @param {number} [cb] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    saveAreaSearch: async (t, s, n, r, i, o, l, d, c, u, m, f, v, b, w, S, I, T, x, k, C, O, E, B, M, R, F, L, j, H, te, re, le, ie, ye, Y, ae, ke, ue, oe, fe, we, Ie, be, Oe, ze, Re, ge, he, Me, Ne, $e, mt, yt, Ct, gt, Ge, Ee, Ce, xe, Pe, it, lt, dt, vt, It, Dt, ht, _t, fs, Hs, Fs, Ts, Ps, Bs, qt, Os, Ms, ts, gs, xs, Be, Ye, Je, At, Tt, Yt, bs, us, Nt, Gs, Qs, Ks, Zs, Js, $s, _s, ea, ta, sa, aa, na, ra, oa, ia, la, da = {}) => {
      se("saveAreaSearch", "bounds", t), se("saveAreaSearch", "level", s);
      const wa = "/search/mls/area", ma = new URL(wa, K);
      let ws;
      e && (ws = e.baseOptions);
      const zs = { method: "POST", ...ws, ...da }, va = {}, ne = {};
      await ee(va, e), t !== void 0 && (ne.bounds = t), s !== void 0 && (ne.level = s), n !== void 0 && (ne.priceMin = n), r !== void 0 && (ne.priceMax = r), i !== void 0 && (ne.bedroomsMin = i), o !== void 0 && (ne.bathroomsMin = o), l !== void 0 && (ne.sqftMin = l), d !== void 0 && (ne.sqftMax = d), c !== void 0 && (ne.lotMin = c), u !== void 0 && (ne.lotMax = u), m !== void 0 && (ne.yearMin = m), f !== void 0 && (ne.yearMax = f), v !== void 0 && (ne.storiesMax = v), b !== void 0 && (ne.t = b), w !== void 0 && (ne.b = w), S !== void 0 && (ne.pp = S), I !== void 0 && (ne.dor = I), T !== void 0 && (ne.l = T), x !== void 0 && (ne.m = x), k !== void 0 && (ne.to = k), C !== void 0 && (ne.p = C), O !== void 0 && (ne.DownPayment = O), E !== void 0 && (ne.InterestRate = E), B !== void 0 && (ne.AmortizationPeriod = B), M !== void 0 && (ne.LoanFees = M), R !== void 0 && (ne.InterestOnlyLoan = R), F !== void 0 && (ne.InterestOnlyTerm = F), L !== void 0 && (ne.TitleCharges = L), j !== void 0 && (ne.AverageLengthOfStay = j), H !== void 0 && (ne.TimeBetweenTenants = H), te !== void 0 && (ne.CostOfSale = te), re !== void 0 && (ne.AnnualRentalGrowth = re), le !== void 0 && (ne.AnnualExpenseGrowth = le), ie !== void 0 && (ne.PropertyAppreciation = ie), ye !== void 0 && (ne.StabilizationReserve = ye), Y !== void 0 && (ne.MinCapRate = Y), ae !== void 0 && (ne.MinCoC = ae), ke !== void 0 && (ne.MinCoCAfterTax = ke), ue !== void 0 && (ne.MinIRR = ue), oe !== void 0 && (ne.MinIRRAfterTax = oe), fe !== void 0 && (ne.Hold = fe), we !== void 0 && (ne.BlueChipFilters = we), Ie !== void 0 && (ne.PercentageLongTermFields = Ie), be !== void 0 && (ne.ManagementFee = be), Oe !== void 0 && (ne.LeaseCommission = Oe), ze !== void 0 && (ne.LeaseRenewalFee = ze), Re !== void 0 && (ne.PlatformServiceFees = Re), ge !== void 0 && (ne.Maintenance = ge), he !== void 0 && (ne.UtilityExpenses = he), Me !== void 0 && (ne.FurnishingExpenses = Me), Ne !== void 0 && (ne.ConsumableExpenses = Ne), $e !== void 0 && (ne.CleaningExpenses = $e), mt !== void 0 && (ne.OtherExpense = mt), yt !== void 0 && (ne.CapitalExpenditures = yt), Ct !== void 0 && (ne.OtherIncome = Ct), gt !== void 0 && (ne.PercentageShortTermFields = gt), Ge !== void 0 && (ne.StrManagementFee = Ge), Ee !== void 0 && (ne.StrLeaseCommission = Ee), Ce !== void 0 && (ne.StrLeaseRenewalFee = Ce), xe !== void 0 && (ne.StrPlatformServiceFees = xe), Pe !== void 0 && (ne.StrMaintenance = Pe), it !== void 0 && (ne.StrUtilityExpenses = it), lt !== void 0 && (ne.StrFurnishingExpenses = lt), dt !== void 0 && (ne.StrConsumableExpenses = dt), vt !== void 0 && (ne.StrCleaningExpenses = vt), It !== void 0 && (ne.StrOtherExpense = It), Dt !== void 0 && (ne.StrCapitalExpenditures = Dt), ht !== void 0 && (ne.StrOtherIncome = ht), _t !== void 0 && (ne.StrWorkingCapitalReserve = _t), fs !== void 0 && (ne.StrDaysOccupiedPerYear = fs), Hs !== void 0 && (ne.StrDaysAvailablePerYear = Hs), Fs !== void 0 && (ne.StrAnnualRentalGrowth = Fs), Ts !== void 0 && (ne.StrAnnualExpenseGrowth = Ts), Ps !== void 0 && (ne.StrPropertyAppreciation = Ps), Bs !== void 0 && (ne.PercentagePadSplitFields = Bs), qt !== void 0 && (ne.PadSplitWorkingCapitalReserve = qt), Os !== void 0 && (ne.PadSplitAnnualVacancyRate = Os), Ms !== void 0 && (ne.PadSplitMaintenance = Ms), ts !== void 0 && (ne.PadSplitFurnishingExpenses = ts), gs !== void 0 && (ne.PadSplitConsumableExpenses = gs), xs !== void 0 && (ne.PadSplitUtilityExpenses = xs), Be !== void 0 && (ne.PadSplitCleaningExpenses = Be), Ye !== void 0 && (ne.PadSplitPlatformServiceFees = Ye), Je !== void 0 && (ne.PadSplitManagementFee = Je), At !== void 0 && (ne.PadSplitAnnualRentalGrowth = At), Tt !== void 0 && (ne.PadSplitAnnualExpenseGrowth = Tt), Yt !== void 0 && (ne.PadSplitPropertyAppreciation = Yt), bs !== void 0 && (ne.PadSplitOtherExpensePercentage = bs), us !== void 0 && (ne.PadSplitLeaseCommission = us), Nt !== void 0 && (ne.PadSplitLeaseRenewalFee = Nt), Gs !== void 0 && (ne.PadSplitOtherExpense = Gs), Qs !== void 0 && (ne.PadSplitCapitalExpenditures = Qs), Ks !== void 0 && (ne.PadSplitOtherIncome = Ks), Zs !== void 0 && (ne.PadSplitBookingFeeDays = Zs), Js !== void 0 && (ne.PadSplitAverageLengthOfStay = Js), $s && (ne["OtherExpenses.LongTerm"] = $s), _s && (ne["OtherExpenses.ShortTerm"] = _s), ea && (ne["OtherExpenses.PadSplit"] = ea), ta && (ne["OtherIncomes.LongTerm"] = ta), sa && (ne["OtherIncomes.ShortTerm"] = sa), aa && (ne["OtherIncomes.PadSplit"] = aa), na !== void 0 && (ne.s = na), ra !== void 0 && (ne.id = ra), oa !== void 0 && (ne.r = oa), ia !== void 0 && (ne.mb = ia), la !== void 0 && (ne.cb = la), Z(ma, ne);
      let et = ws && ws.headers ? ws.headers : {};
      return zs.headers = { ...va, ...et, ...da.headers }, {
        url: J(ma),
        options: zs
      };
    },
    /**
     * 
     * @summary Searches predefined saved search.
     * @param {number} id Id of existing saved search to base query from and update
     * @param {number} [m] Max results to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    savedSearch: async (t, s, n = {}) => {
      se("savedSearch", "id", t);
      const r = "/search/mls/saved/{id}".replace("{id}", encodeURIComponent(String(t))), i = new URL(r, K);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "GET", ...o, ...n }, d = {}, c = {};
      await ee(d, e), s !== void 0 && (c.m = s), Z(i, c);
      let u = o && o.headers ? o.headers : {};
      return l.headers = { ...d, ...u, ...n.headers }, {
        url: J(i),
        options: l
      };
    },
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    savedSearchStats: async (t = {}) => {
      const s = "/search/mls/search-stats", n = new URL(s, K);
      let r;
      e && (r = e.baseOptions);
      const i = { method: "GET", ...r, ...t }, o = {}, l = {};
      await ee(o, e), Z(n, l);
      let d = r && r.headers ? r.headers : {};
      return i.headers = { ...o, ...d, ...t.headers }, {
        url: J(n),
        options: i
      };
    },
    /**
     * 
     * @summary List account\'s saved searches.
     * @param {number} [id] Id of sub account to list saved searches
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {number} [t] Random number to force cache not to be used.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    savedSearches: async (t, s, n, r, i = {}) => {
      const o = "/search/mls/searches", l = new URL(o, K);
      let d;
      e && (d = e.baseOptions);
      const c = { method: "GET", ...d, ...i }, u = {}, m = {};
      await ee(u, e), t !== void 0 && (m.id = t), s !== void 0 && (m.page = s), n !== void 0 && (m.pageSize = n), r !== void 0 && (m.t = r), Z(l, m);
      let f = d && d.headers ? d.headers : {};
      return c.headers = { ...u, ...f, ...i.headers }, {
        url: J(l),
        options: c
      };
    },
    /**
     * 
     * @summary Searches predefined scoped areas.
     * @param {Array<string>} area Geographic areas to search
     * @param {number} level Zoom level
     * @param {number} [priceMin] 
     * @param {number} [priceMax] 
     * @param {number} [bedroomsMin] 
     * @param {number} [bathroomsMin] 
     * @param {number} [sqftMin] 
     * @param {number} [sqftMax] 
     * @param {number} [lotMin] 
     * @param {number} [lotMax] 
     * @param {number} [yearMin] 
     * @param {number} [yearMax] 
     * @param {number} [storiesMax] 
     * @param {number} [t] 
     * @param {boolean} [b] 
     * @param {boolean} [pp] 
     * @param {number} [dor] 
     * @param {boolean} [l] 
     * @param {boolean} [m] 
     * @param {boolean} [to] 
     * @param {boolean} [p] 
     * @param {number} [downPayment] 
     * @param {number} [interestRate] 
     * @param {number} [amortizationPeriod] 
     * @param {number} [loanFees] 
     * @param {boolean} [interestOnlyLoan] 
     * @param {number} [interestOnlyTerm] 
     * @param {number} [titleCharges] 
     * @param {number} [averageLengthOfStay] 
     * @param {number} [timeBetweenTenants] 
     * @param {number} [costOfSale] 
     * @param {number} [annualRentalGrowth] 
     * @param {number} [annualExpenseGrowth] 
     * @param {number} [propertyAppreciation] 
     * @param {boolean} [stabilizationReserve] 
     * @param {number} [minCapRate] 
     * @param {number} [minCoC] 
     * @param {number} [minCoCAfterTax] 
     * @param {number} [minIRR] 
     * @param {number} [minIRRAfterTax] 
     * @param {number} [hold] 
     * @param {BlueChipFilters} [blueChipFilters] 
     * @param {StandardIncomeExpenseAccounts} [percentageLongTermFields] 
     * @param {number} [managementFee] 
     * @param {number} [leaseCommission] 
     * @param {number} [leaseRenewalFee] 
     * @param {number} [platformServiceFees] 
     * @param {number} [maintenance] 
     * @param {number} [utilityExpenses] 
     * @param {number} [furnishingExpenses] 
     * @param {number} [consumableExpenses] 
     * @param {number} [cleaningExpenses] 
     * @param {number} [otherExpense] 
     * @param {number} [capitalExpenditures] 
     * @param {number} [otherIncome] 
     * @param {StandardIncomeExpenseAccounts} [percentageShortTermFields] 
     * @param {number} [strManagementFee] 
     * @param {number} [strLeaseCommission] 
     * @param {number} [strLeaseRenewalFee] 
     * @param {number} [strPlatformServiceFees] 
     * @param {number} [strMaintenance] 
     * @param {number} [strUtilityExpenses] 
     * @param {number} [strFurnishingExpenses] 
     * @param {number} [strConsumableExpenses] 
     * @param {number} [strCleaningExpenses] 
     * @param {number} [strOtherExpense] 
     * @param {number} [strCapitalExpenditures] 
     * @param {number} [strOtherIncome] 
     * @param {number} [strWorkingCapitalReserve] 
     * @param {number} [strDaysOccupiedPerYear] 
     * @param {number} [strDaysAvailablePerYear] 
     * @param {number} [strAnnualRentalGrowth] 
     * @param {number} [strAnnualExpenseGrowth] 
     * @param {number} [strPropertyAppreciation] 
     * @param {StandardIncomeExpenseAccounts} [percentagePadSplitFields] 
     * @param {number} [padSplitWorkingCapitalReserve] 
     * @param {number} [padSplitAnnualVacancyRate] 
     * @param {number} [padSplitMaintenance] 
     * @param {number} [padSplitFurnishingExpenses] 
     * @param {number} [padSplitConsumableExpenses] 
     * @param {number} [padSplitUtilityExpenses] 
     * @param {number} [padSplitCleaningExpenses] 
     * @param {number} [padSplitPlatformServiceFees] 
     * @param {number} [padSplitManagementFee] 
     * @param {number} [padSplitAnnualRentalGrowth] 
     * @param {number} [padSplitAnnualExpenseGrowth] 
     * @param {number} [padSplitPropertyAppreciation] 
     * @param {boolean} [padSplitOtherExpensePercentage] 
     * @param {number} [padSplitLeaseCommission] 
     * @param {number} [padSplitLeaseRenewalFee] 
     * @param {number} [padSplitOtherExpense] 
     * @param {number} [padSplitCapitalExpenditures] 
     * @param {number} [padSplitOtherIncome] 
     * @param {number} [padSplitBookingFeeDays] 
     * @param {number} [padSplitAverageLengthOfStay] 
     * @param {Array<CalculatorOtherAccountValue>} [otherExpensesLongTerm] 
     * @param {Array<CalculatorOtherAccountValue>} [otherExpensesShortTerm] 
     * @param {Array<CalculatorOtherAccountValue>} [otherExpensesPadSplit] 
     * @param {Array<CalculatorOtherAccountValue>} [otherIncomesLongTerm] 
     * @param {Array<CalculatorOtherAccountValue>} [otherIncomesShortTerm] 
     * @param {Array<CalculatorOtherAccountValue>} [otherIncomesPadSplit] 
     * @param {string} [s] Name of saved search
     * @param {number} [id] Id of existing saved search to base query from and update
     * @param {boolean} [r] Return listing data
     * @param {boolean} [save] Save filters/parameters as saved search
     * @param {number} [cb] Random number to force refresh, avoid cache.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    scopedSearch: async (t, s, n, r, i, o, l, d, c, u, m, f, v, b, w, S, I, T, x, k, C, O, E, B, M, R, F, L, j, H, te, re, le, ie, ye, Y, ae, ke, ue, oe, fe, we, Ie, be, Oe, ze, Re, ge, he, Me, Ne, $e, mt, yt, Ct, gt, Ge, Ee, Ce, xe, Pe, it, lt, dt, vt, It, Dt, ht, _t, fs, Hs, Fs, Ts, Ps, Bs, qt, Os, Ms, ts, gs, xs, Be, Ye, Je, At, Tt, Yt, bs, us, Nt, Gs, Qs, Ks, Zs, Js, $s, _s, ea, ta, sa, aa, na, ra, oa, ia, la, da = {}) => {
      se("scopedSearch", "area", t), se("scopedSearch", "level", s);
      const wa = "/search/mls/scoped", ma = new URL(wa, K);
      let ws;
      e && (ws = e.baseOptions);
      const zs = { method: "GET", ...ws, ...da }, va = {}, ne = {};
      await Lt(va, "x-api-key", e), await ee(va, e), t && (ne.area = t), s !== void 0 && (ne.level = s), n !== void 0 && (ne.priceMin = n), r !== void 0 && (ne.priceMax = r), i !== void 0 && (ne.bedroomsMin = i), o !== void 0 && (ne.bathroomsMin = o), l !== void 0 && (ne.sqftMin = l), d !== void 0 && (ne.sqftMax = d), c !== void 0 && (ne.lotMin = c), u !== void 0 && (ne.lotMax = u), m !== void 0 && (ne.yearMin = m), f !== void 0 && (ne.yearMax = f), v !== void 0 && (ne.storiesMax = v), b !== void 0 && (ne.t = b), w !== void 0 && (ne.b = w), S !== void 0 && (ne.pp = S), I !== void 0 && (ne.dor = I), T !== void 0 && (ne.l = T), x !== void 0 && (ne.m = x), k !== void 0 && (ne.to = k), C !== void 0 && (ne.p = C), O !== void 0 && (ne.DownPayment = O), E !== void 0 && (ne.InterestRate = E), B !== void 0 && (ne.AmortizationPeriod = B), M !== void 0 && (ne.LoanFees = M), R !== void 0 && (ne.InterestOnlyLoan = R), F !== void 0 && (ne.InterestOnlyTerm = F), L !== void 0 && (ne.TitleCharges = L), j !== void 0 && (ne.AverageLengthOfStay = j), H !== void 0 && (ne.TimeBetweenTenants = H), te !== void 0 && (ne.CostOfSale = te), re !== void 0 && (ne.AnnualRentalGrowth = re), le !== void 0 && (ne.AnnualExpenseGrowth = le), ie !== void 0 && (ne.PropertyAppreciation = ie), ye !== void 0 && (ne.StabilizationReserve = ye), Y !== void 0 && (ne.MinCapRate = Y), ae !== void 0 && (ne.MinCoC = ae), ke !== void 0 && (ne.MinCoCAfterTax = ke), ue !== void 0 && (ne.MinIRR = ue), oe !== void 0 && (ne.MinIRRAfterTax = oe), fe !== void 0 && (ne.Hold = fe), we !== void 0 && (ne.BlueChipFilters = we), Ie !== void 0 && (ne.PercentageLongTermFields = Ie), be !== void 0 && (ne.ManagementFee = be), Oe !== void 0 && (ne.LeaseCommission = Oe), ze !== void 0 && (ne.LeaseRenewalFee = ze), Re !== void 0 && (ne.PlatformServiceFees = Re), ge !== void 0 && (ne.Maintenance = ge), he !== void 0 && (ne.UtilityExpenses = he), Me !== void 0 && (ne.FurnishingExpenses = Me), Ne !== void 0 && (ne.ConsumableExpenses = Ne), $e !== void 0 && (ne.CleaningExpenses = $e), mt !== void 0 && (ne.OtherExpense = mt), yt !== void 0 && (ne.CapitalExpenditures = yt), Ct !== void 0 && (ne.OtherIncome = Ct), gt !== void 0 && (ne.PercentageShortTermFields = gt), Ge !== void 0 && (ne.StrManagementFee = Ge), Ee !== void 0 && (ne.StrLeaseCommission = Ee), Ce !== void 0 && (ne.StrLeaseRenewalFee = Ce), xe !== void 0 && (ne.StrPlatformServiceFees = xe), Pe !== void 0 && (ne.StrMaintenance = Pe), it !== void 0 && (ne.StrUtilityExpenses = it), lt !== void 0 && (ne.StrFurnishingExpenses = lt), dt !== void 0 && (ne.StrConsumableExpenses = dt), vt !== void 0 && (ne.StrCleaningExpenses = vt), It !== void 0 && (ne.StrOtherExpense = It), Dt !== void 0 && (ne.StrCapitalExpenditures = Dt), ht !== void 0 && (ne.StrOtherIncome = ht), _t !== void 0 && (ne.StrWorkingCapitalReserve = _t), fs !== void 0 && (ne.StrDaysOccupiedPerYear = fs), Hs !== void 0 && (ne.StrDaysAvailablePerYear = Hs), Fs !== void 0 && (ne.StrAnnualRentalGrowth = Fs), Ts !== void 0 && (ne.StrAnnualExpenseGrowth = Ts), Ps !== void 0 && (ne.StrPropertyAppreciation = Ps), Bs !== void 0 && (ne.PercentagePadSplitFields = Bs), qt !== void 0 && (ne.PadSplitWorkingCapitalReserve = qt), Os !== void 0 && (ne.PadSplitAnnualVacancyRate = Os), Ms !== void 0 && (ne.PadSplitMaintenance = Ms), ts !== void 0 && (ne.PadSplitFurnishingExpenses = ts), gs !== void 0 && (ne.PadSplitConsumableExpenses = gs), xs !== void 0 && (ne.PadSplitUtilityExpenses = xs), Be !== void 0 && (ne.PadSplitCleaningExpenses = Be), Ye !== void 0 && (ne.PadSplitPlatformServiceFees = Ye), Je !== void 0 && (ne.PadSplitManagementFee = Je), At !== void 0 && (ne.PadSplitAnnualRentalGrowth = At), Tt !== void 0 && (ne.PadSplitAnnualExpenseGrowth = Tt), Yt !== void 0 && (ne.PadSplitPropertyAppreciation = Yt), bs !== void 0 && (ne.PadSplitOtherExpensePercentage = bs), us !== void 0 && (ne.PadSplitLeaseCommission = us), Nt !== void 0 && (ne.PadSplitLeaseRenewalFee = Nt), Gs !== void 0 && (ne.PadSplitOtherExpense = Gs), Qs !== void 0 && (ne.PadSplitCapitalExpenditures = Qs), Ks !== void 0 && (ne.PadSplitOtherIncome = Ks), Zs !== void 0 && (ne.PadSplitBookingFeeDays = Zs), Js !== void 0 && (ne.PadSplitAverageLengthOfStay = Js), $s && (ne["OtherExpenses.LongTerm"] = $s), _s && (ne["OtherExpenses.ShortTerm"] = _s), ea && (ne["OtherExpenses.PadSplit"] = ea), ta && (ne["OtherIncomes.LongTerm"] = ta), sa && (ne["OtherIncomes.ShortTerm"] = sa), aa && (ne["OtherIncomes.PadSplit"] = aa), na !== void 0 && (ne.s = na), ra !== void 0 && (ne.id = ra), oa !== void 0 && (ne.r = oa), ia !== void 0 && (ne.save = ia), la !== void 0 && (ne.cb = la), Z(ma, ne);
      let et = ws && ws.headers ? ws.headers : {};
      return zs.headers = { ...va, ...et, ...da.headers }, {
        url: J(ma),
        options: zs
      };
    },
    /**
     * 
     * @summary Subscribe Saved Search
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    subscribeSavedSearch: async (t, s = {}) => {
      se("subscribeSavedSearch", "id", t);
      const n = "/search/mls/{id}/subscribe".replace("{id}", encodeURIComponent(String(t))), r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "POST", ...i, ...s }, l = {}, d = {};
      await ee(l, e), Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, {
        url: J(r),
        options: o
      };
    },
    /**
     * 
     * @summary Saved Search Subscription Frequency
     * @param {number} id 
     * @param {ReportFrequency} frequency 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    subscriptionFrequency: async (t, s, n = {}) => {
      se("subscriptionFrequency", "id", t), se("subscriptionFrequency", "frequency", s);
      const r = "/search/mls/{id}/frequency".replace("{id}", encodeURIComponent(String(t))), i = new URL(r, K);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "POST", ...o, ...n }, d = {}, c = {};
      await ee(d, e), s !== void 0 && (c.frequency = s), Z(i, c);
      let u = o && o.headers ? o.headers : {};
      return l.headers = { ...d, ...u, ...n.headers }, {
        url: J(i),
        options: l
      };
    },
    /**
     * 
     * @summary Unsubscribe Saved Search
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    unsubscribeSavedSearch: async (t, s = {}) => {
      se("unsubscribeSavedSearch", "id", t);
      const n = "/search/mls/{id}/unsubscribe".replace("{id}", encodeURIComponent(String(t))), r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "DELETE", ...i, ...s }, l = {}, d = {};
      await ee(l, e), Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, {
        url: J(r),
        options: o
      };
    }
  };
}, MT = function(e) {
  const t = BT(e);
  return {
    /**
     * 
     * @summary Searches predefined scoped areas.
     * @param {string} bounds Geographic polygon to search
     * @param {number} level Zoom level
     * @param {number} [priceMin] 
     * @param {number} [priceMax] 
     * @param {number} [bedroomsMin] 
     * @param {number} [bathroomsMin] 
     * @param {number} [sqftMin] 
     * @param {number} [sqftMax] 
     * @param {number} [lotMin] 
     * @param {number} [lotMax] 
     * @param {number} [yearMin] 
     * @param {number} [yearMax] 
     * @param {number} [storiesMax] 
     * @param {number} [t] 
     * @param {boolean} [b] 
     * @param {boolean} [pp] 
     * @param {number} [dor] 
     * @param {boolean} [l] 
     * @param {boolean} [m] 
     * @param {boolean} [to] 
     * @param {boolean} [p] 
     * @param {number} [downPayment] 
     * @param {number} [interestRate] 
     * @param {number} [amortizationPeriod] 
     * @param {number} [loanFees] 
     * @param {boolean} [interestOnlyLoan] 
     * @param {number} [interestOnlyTerm] 
     * @param {number} [titleCharges] 
     * @param {number} [averageLengthOfStay] 
     * @param {number} [timeBetweenTenants] 
     * @param {number} [costOfSale] 
     * @param {number} [annualRentalGrowth] 
     * @param {number} [annualExpenseGrowth] 
     * @param {number} [propertyAppreciation] 
     * @param {boolean} [stabilizationReserve] 
     * @param {number} [minCapRate] 
     * @param {number} [minCoC] 
     * @param {number} [minCoCAfterTax] 
     * @param {number} [minIRR] 
     * @param {number} [minIRRAfterTax] 
     * @param {number} [hold] 
     * @param {BlueChipFilters} [blueChipFilters] 
     * @param {StandardIncomeExpenseAccounts} [percentageLongTermFields] 
     * @param {number} [managementFee] 
     * @param {number} [leaseCommission] 
     * @param {number} [leaseRenewalFee] 
     * @param {number} [platformServiceFees] 
     * @param {number} [maintenance] 
     * @param {number} [utilityExpenses] 
     * @param {number} [furnishingExpenses] 
     * @param {number} [consumableExpenses] 
     * @param {number} [cleaningExpenses] 
     * @param {number} [otherExpense] 
     * @param {number} [capitalExpenditures] 
     * @param {number} [otherIncome] 
     * @param {StandardIncomeExpenseAccounts} [percentageShortTermFields] 
     * @param {number} [strManagementFee] 
     * @param {number} [strLeaseCommission] 
     * @param {number} [strLeaseRenewalFee] 
     * @param {number} [strPlatformServiceFees] 
     * @param {number} [strMaintenance] 
     * @param {number} [strUtilityExpenses] 
     * @param {number} [strFurnishingExpenses] 
     * @param {number} [strConsumableExpenses] 
     * @param {number} [strCleaningExpenses] 
     * @param {number} [strOtherExpense] 
     * @param {number} [strCapitalExpenditures] 
     * @param {number} [strOtherIncome] 
     * @param {number} [strWorkingCapitalReserve] 
     * @param {number} [strDaysOccupiedPerYear] 
     * @param {number} [strDaysAvailablePerYear] 
     * @param {number} [strAnnualRentalGrowth] 
     * @param {number} [strAnnualExpenseGrowth] 
     * @param {number} [strPropertyAppreciation] 
     * @param {StandardIncomeExpenseAccounts} [percentagePadSplitFields] 
     * @param {number} [padSplitWorkingCapitalReserve] 
     * @param {number} [padSplitAnnualVacancyRate] 
     * @param {number} [padSplitMaintenance] 
     * @param {number} [padSplitFurnishingExpenses] 
     * @param {number} [padSplitConsumableExpenses] 
     * @param {number} [padSplitUtilityExpenses] 
     * @param {number} [padSplitCleaningExpenses] 
     * @param {number} [padSplitPlatformServiceFees] 
     * @param {number} [padSplitManagementFee] 
     * @param {number} [padSplitAnnualRentalGrowth] 
     * @param {number} [padSplitAnnualExpenseGrowth] 
     * @param {number} [padSplitPropertyAppreciation] 
     * @param {boolean} [padSplitOtherExpensePercentage] 
     * @param {number} [padSplitLeaseCommission] 
     * @param {number} [padSplitLeaseRenewalFee] 
     * @param {number} [padSplitOtherExpense] 
     * @param {number} [padSplitCapitalExpenditures] 
     * @param {number} [padSplitOtherIncome] 
     * @param {number} [padSplitBookingFeeDays] 
     * @param {number} [padSplitAverageLengthOfStay] 
     * @param {Array<CalculatorOtherAccountValue>} [otherExpensesLongTerm] 
     * @param {Array<CalculatorOtherAccountValue>} [otherExpensesShortTerm] 
     * @param {Array<CalculatorOtherAccountValue>} [otherExpensesPadSplit] 
     * @param {Array<CalculatorOtherAccountValue>} [otherIncomesLongTerm] 
     * @param {Array<CalculatorOtherAccountValue>} [otherIncomesShortTerm] 
     * @param {Array<CalculatorOtherAccountValue>} [otherIncomesPadSplit] 
     * @param {string} [s] Name of saved search
     * @param {number} [id] Id of existing saved search to base query from and update
     * @param {boolean} [r] Return listing data
     * @param {boolean} [mb] 
     * @param {number} [cb] Random number to force refresh, avoid cache.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async areaSearch(s, n, r, i, o, l, d, c, u, m, f, v, b, w, S, I, T, x, k, C, O, E, B, M, R, F, L, j, H, te, re, le, ie, ye, Y, ae, ke, ue, oe, fe, we, Ie, be, Oe, ze, Re, ge, he, Me, Ne, $e, mt, yt, Ct, gt, Ge, Ee, Ce, xe, Pe, it, lt, dt, vt, It, Dt, ht, _t, fs, Hs, Fs, Ts, Ps, Bs, qt, Os, Ms, ts, gs, xs, Be, Ye, Je, At, Tt, Yt, bs, us, Nt, Gs, Qs, Ks, Zs, Js, $s, _s, ea, ta, sa, aa, na, ra, oa, ia, la, da, wa) {
      var va, ne;
      const ma = await t.areaSearch(s, n, r, i, o, l, d, c, u, m, f, v, b, w, S, I, T, x, k, C, O, E, B, M, R, F, L, j, H, te, re, le, ie, ye, Y, ae, ke, ue, oe, fe, we, Ie, be, Oe, ze, Re, ge, he, Me, Ne, $e, mt, yt, Ct, gt, Ge, Ee, Ce, xe, Pe, it, lt, dt, vt, It, Dt, ht, _t, fs, Hs, Fs, Ts, Ps, Bs, qt, Os, Ms, ts, gs, xs, Be, Ye, Je, At, Tt, Yt, bs, us, Nt, Gs, Qs, Ks, Zs, Js, $s, _s, ea, ta, sa, aa, na, ra, oa, ia, la, da, wa), ws = (e == null ? void 0 : e.serverIndex) ?? 0, zs = (ne = (va = Q["SearchMlsApi.areaSearch"]) == null ? void 0 : va[ws]) == null ? void 0 : ne.url;
      return (et, no) => _(ma, X, G, e)(et, zs || no);
    },
    /**
     * 
     * @summary Searches predefined scoped areas.
     * @param {string} bounds Geographic polygon to search
     * @param {number} level Zoom level
     * @param {number} [priceMin] 
     * @param {number} [priceMax] 
     * @param {number} [bedroomsMin] 
     * @param {number} [bathroomsMin] 
     * @param {number} [sqftMin] 
     * @param {number} [sqftMax] 
     * @param {number} [lotMin] 
     * @param {number} [lotMax] 
     * @param {number} [yearMin] 
     * @param {number} [yearMax] 
     * @param {number} [storiesMax] 
     * @param {number} [t] 
     * @param {boolean} [b] 
     * @param {boolean} [pp] 
     * @param {number} [dor] 
     * @param {boolean} [l] 
     * @param {boolean} [m] 
     * @param {boolean} [to] 
     * @param {boolean} [p] 
     * @param {number} [downPayment] 
     * @param {number} [interestRate] 
     * @param {number} [amortizationPeriod] 
     * @param {number} [loanFees] 
     * @param {boolean} [interestOnlyLoan] 
     * @param {number} [interestOnlyTerm] 
     * @param {number} [titleCharges] 
     * @param {number} [averageLengthOfStay] 
     * @param {number} [timeBetweenTenants] 
     * @param {number} [costOfSale] 
     * @param {number} [annualRentalGrowth] 
     * @param {number} [annualExpenseGrowth] 
     * @param {number} [propertyAppreciation] 
     * @param {boolean} [stabilizationReserve] 
     * @param {number} [minCapRate] 
     * @param {number} [minCoC] 
     * @param {number} [minCoCAfterTax] 
     * @param {number} [minIRR] 
     * @param {number} [minIRRAfterTax] 
     * @param {number} [hold] 
     * @param {BlueChipFilters} [blueChipFilters] 
     * @param {StandardIncomeExpenseAccounts} [percentageLongTermFields] 
     * @param {number} [managementFee] 
     * @param {number} [leaseCommission] 
     * @param {number} [leaseRenewalFee] 
     * @param {number} [platformServiceFees] 
     * @param {number} [maintenance] 
     * @param {number} [utilityExpenses] 
     * @param {number} [furnishingExpenses] 
     * @param {number} [consumableExpenses] 
     * @param {number} [cleaningExpenses] 
     * @param {number} [otherExpense] 
     * @param {number} [capitalExpenditures] 
     * @param {number} [otherIncome] 
     * @param {StandardIncomeExpenseAccounts} [percentageShortTermFields] 
     * @param {number} [strManagementFee] 
     * @param {number} [strLeaseCommission] 
     * @param {number} [strLeaseRenewalFee] 
     * @param {number} [strPlatformServiceFees] 
     * @param {number} [strMaintenance] 
     * @param {number} [strUtilityExpenses] 
     * @param {number} [strFurnishingExpenses] 
     * @param {number} [strConsumableExpenses] 
     * @param {number} [strCleaningExpenses] 
     * @param {number} [strOtherExpense] 
     * @param {number} [strCapitalExpenditures] 
     * @param {number} [strOtherIncome] 
     * @param {number} [strWorkingCapitalReserve] 
     * @param {number} [strDaysOccupiedPerYear] 
     * @param {number} [strDaysAvailablePerYear] 
     * @param {number} [strAnnualRentalGrowth] 
     * @param {number} [strAnnualExpenseGrowth] 
     * @param {number} [strPropertyAppreciation] 
     * @param {StandardIncomeExpenseAccounts} [percentagePadSplitFields] 
     * @param {number} [padSplitWorkingCapitalReserve] 
     * @param {number} [padSplitAnnualVacancyRate] 
     * @param {number} [padSplitMaintenance] 
     * @param {number} [padSplitFurnishingExpenses] 
     * @param {number} [padSplitConsumableExpenses] 
     * @param {number} [padSplitUtilityExpenses] 
     * @param {number} [padSplitCleaningExpenses] 
     * @param {number} [padSplitPlatformServiceFees] 
     * @param {number} [padSplitManagementFee] 
     * @param {number} [padSplitAnnualRentalGrowth] 
     * @param {number} [padSplitAnnualExpenseGrowth] 
     * @param {number} [padSplitPropertyAppreciation] 
     * @param {boolean} [padSplitOtherExpensePercentage] 
     * @param {number} [padSplitLeaseCommission] 
     * @param {number} [padSplitLeaseRenewalFee] 
     * @param {number} [padSplitOtherExpense] 
     * @param {number} [padSplitCapitalExpenditures] 
     * @param {number} [padSplitOtherIncome] 
     * @param {number} [padSplitBookingFeeDays] 
     * @param {number} [padSplitAverageLengthOfStay] 
     * @param {Array<CalculatorOtherAccountValue>} [otherExpensesLongTerm] 
     * @param {Array<CalculatorOtherAccountValue>} [otherExpensesShortTerm] 
     * @param {Array<CalculatorOtherAccountValue>} [otherExpensesPadSplit] 
     * @param {Array<CalculatorOtherAccountValue>} [otherIncomesLongTerm] 
     * @param {Array<CalculatorOtherAccountValue>} [otherIncomesShortTerm] 
     * @param {Array<CalculatorOtherAccountValue>} [otherIncomesPadSplit] 
     * @param {string} [s] Name of saved search
     * @param {number} [id] Id of existing saved search to base query from and update
     * @param {boolean} [r] Return listing data
     * @param {boolean} [save] Save filters/parameters as saved search
     * @param {boolean} [mb] Is bounds a map bound(true) or a drawn polygon bound.
     * @param {number} [cb] Random number to force refresh, avoid cache.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async areaSearchFeatured(s, n, r, i, o, l, d, c, u, m, f, v, b, w, S, I, T, x, k, C, O, E, B, M, R, F, L, j, H, te, re, le, ie, ye, Y, ae, ke, ue, oe, fe, we, Ie, be, Oe, ze, Re, ge, he, Me, Ne, $e, mt, yt, Ct, gt, Ge, Ee, Ce, xe, Pe, it, lt, dt, vt, It, Dt, ht, _t, fs, Hs, Fs, Ts, Ps, Bs, qt, Os, Ms, ts, gs, xs, Be, Ye, Je, At, Tt, Yt, bs, us, Nt, Gs, Qs, Ks, Zs, Js, $s, _s, ea, ta, sa, aa, na, ra, oa, ia, la, da, wa, ma) {
      var ne, et;
      const ws = await t.areaSearchFeatured(s, n, r, i, o, l, d, c, u, m, f, v, b, w, S, I, T, x, k, C, O, E, B, M, R, F, L, j, H, te, re, le, ie, ye, Y, ae, ke, ue, oe, fe, we, Ie, be, Oe, ze, Re, ge, he, Me, Ne, $e, mt, yt, Ct, gt, Ge, Ee, Ce, xe, Pe, it, lt, dt, vt, It, Dt, ht, _t, fs, Hs, Fs, Ts, Ps, Bs, qt, Os, Ms, ts, gs, xs, Be, Ye, Je, At, Tt, Yt, bs, us, Nt, Gs, Qs, Ks, Zs, Js, $s, _s, ea, ta, sa, aa, na, ra, oa, ia, la, da, wa, ma), zs = (e == null ? void 0 : e.serverIndex) ?? 0, va = (et = (ne = Q["SearchMlsApi.areaSearchFeatured"]) == null ? void 0 : ne[zs]) == null ? void 0 : et.url;
      return (no, JE) => _(ws, X, G, e)(no, va || JE);
    },
    /**
     * 
     * @summary Client\'s agent\'s configured IDX default saved search.
     * @param {number} [m] Max results to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async defaultSearchForClient(s, n) {
      var l, d;
      const r = await t.defaultSearchForClient(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["SearchMlsApi.defaultSearchForClient"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    },
    /**
     * 
     * @summary Delete a users saved search.
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deleteSavedSearch(s, n) {
      var l, d;
      const r = await t.deleteSavedSearch(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["SearchMlsApi.deleteSavedSearch"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    },
    /**
     * 
     * @summary Get account\'s search parameters.
     * @param {number} [id] Id of saved search
     * @param {number} [t] Random number to force refresh, avoid cache.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getSearchParameters(s, n, r) {
      var d, c;
      const i = await t.getSearchParameters(s, n, r), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (c = (d = Q["SearchMlsApi.getSearchParameters"]) == null ? void 0 : d[o]) == null ? void 0 : c.url;
      return (u, m) => _(i, X, G, e)(u, l || m);
    },
    /**
     * 
     * @param {string} bounds 
     * @param {number} level 
     * @param {number} [priceMin] 
     * @param {number} [priceMax] 
     * @param {number} [bedroomsMin] 
     * @param {number} [bathroomsMin] 
     * @param {number} [sqftMin] 
     * @param {number} [sqftMax] 
     * @param {number} [lotMin] 
     * @param {number} [lotMax] 
     * @param {number} [yearMin] 
     * @param {number} [yearMax] 
     * @param {number} [storiesMax] 
     * @param {number} [t] 
     * @param {boolean} [b] 
     * @param {boolean} [pp] 
     * @param {number} [dor] 
     * @param {boolean} [l] 
     * @param {boolean} [m] 
     * @param {boolean} [to] 
     * @param {boolean} [p] 
     * @param {number} [downPayment] 
     * @param {number} [interestRate] 
     * @param {number} [amortizationPeriod] 
     * @param {number} [loanFees] 
     * @param {boolean} [interestOnlyLoan] 
     * @param {number} [interestOnlyTerm] 
     * @param {number} [titleCharges] 
     * @param {number} [averageLengthOfStay] 
     * @param {number} [timeBetweenTenants] 
     * @param {number} [costOfSale] 
     * @param {number} [annualRentalGrowth] 
     * @param {number} [annualExpenseGrowth] 
     * @param {number} [propertyAppreciation] 
     * @param {boolean} [stabilizationReserve] 
     * @param {number} [minCapRate] 
     * @param {number} [minCoC] 
     * @param {number} [minCoCAfterTax] 
     * @param {number} [minIRR] 
     * @param {number} [minIRRAfterTax] 
     * @param {number} [hold] 
     * @param {BlueChipFilters} [blueChipFilters] 
     * @param {StandardIncomeExpenseAccounts} [percentageLongTermFields] 
     * @param {number} [managementFee] 
     * @param {number} [leaseCommission] 
     * @param {number} [leaseRenewalFee] 
     * @param {number} [platformServiceFees] 
     * @param {number} [maintenance] 
     * @param {number} [utilityExpenses] 
     * @param {number} [furnishingExpenses] 
     * @param {number} [consumableExpenses] 
     * @param {number} [cleaningExpenses] 
     * @param {number} [otherExpense] 
     * @param {number} [capitalExpenditures] 
     * @param {number} [otherIncome] 
     * @param {StandardIncomeExpenseAccounts} [percentageShortTermFields] 
     * @param {number} [strManagementFee] 
     * @param {number} [strLeaseCommission] 
     * @param {number} [strLeaseRenewalFee] 
     * @param {number} [strPlatformServiceFees] 
     * @param {number} [strMaintenance] 
     * @param {number} [strUtilityExpenses] 
     * @param {number} [strFurnishingExpenses] 
     * @param {number} [strConsumableExpenses] 
     * @param {number} [strCleaningExpenses] 
     * @param {number} [strOtherExpense] 
     * @param {number} [strCapitalExpenditures] 
     * @param {number} [strOtherIncome] 
     * @param {number} [strWorkingCapitalReserve] 
     * @param {number} [strDaysOccupiedPerYear] 
     * @param {number} [strDaysAvailablePerYear] 
     * @param {number} [strAnnualRentalGrowth] 
     * @param {number} [strAnnualExpenseGrowth] 
     * @param {number} [strPropertyAppreciation] 
     * @param {StandardIncomeExpenseAccounts} [percentagePadSplitFields] 
     * @param {number} [padSplitWorkingCapitalReserve] 
     * @param {number} [padSplitAnnualVacancyRate] 
     * @param {number} [padSplitMaintenance] 
     * @param {number} [padSplitFurnishingExpenses] 
     * @param {number} [padSplitConsumableExpenses] 
     * @param {number} [padSplitUtilityExpenses] 
     * @param {number} [padSplitCleaningExpenses] 
     * @param {number} [padSplitPlatformServiceFees] 
     * @param {number} [padSplitManagementFee] 
     * @param {number} [padSplitAnnualRentalGrowth] 
     * @param {number} [padSplitAnnualExpenseGrowth] 
     * @param {number} [padSplitPropertyAppreciation] 
     * @param {boolean} [padSplitOtherExpensePercentage] 
     * @param {number} [padSplitLeaseCommission] 
     * @param {number} [padSplitLeaseRenewalFee] 
     * @param {number} [padSplitOtherExpense] 
     * @param {number} [padSplitCapitalExpenditures] 
     * @param {number} [padSplitOtherIncome] 
     * @param {number} [padSplitBookingFeeDays] 
     * @param {number} [padSplitAverageLengthOfStay] 
     * @param {Array<CalculatorOtherAccountValue>} [otherExpensesLongTerm] 
     * @param {Array<CalculatorOtherAccountValue>} [otherExpensesShortTerm] 
     * @param {Array<CalculatorOtherAccountValue>} [otherExpensesPadSplit] 
     * @param {Array<CalculatorOtherAccountValue>} [otherIncomesLongTerm] 
     * @param {Array<CalculatorOtherAccountValue>} [otherIncomesShortTerm] 
     * @param {Array<CalculatorOtherAccountValue>} [otherIncomesPadSplit] 
     * @param {string} [s] 
     * @param {number} [id] 
     * @param {boolean} [r] 
     * @param {boolean} [mb] 
     * @param {number} [cb] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async saveAreaSearch(s, n, r, i, o, l, d, c, u, m, f, v, b, w, S, I, T, x, k, C, O, E, B, M, R, F, L, j, H, te, re, le, ie, ye, Y, ae, ke, ue, oe, fe, we, Ie, be, Oe, ze, Re, ge, he, Me, Ne, $e, mt, yt, Ct, gt, Ge, Ee, Ce, xe, Pe, it, lt, dt, vt, It, Dt, ht, _t, fs, Hs, Fs, Ts, Ps, Bs, qt, Os, Ms, ts, gs, xs, Be, Ye, Je, At, Tt, Yt, bs, us, Nt, Gs, Qs, Ks, Zs, Js, $s, _s, ea, ta, sa, aa, na, ra, oa, ia, la, da, wa) {
      var va, ne;
      const ma = await t.saveAreaSearch(s, n, r, i, o, l, d, c, u, m, f, v, b, w, S, I, T, x, k, C, O, E, B, M, R, F, L, j, H, te, re, le, ie, ye, Y, ae, ke, ue, oe, fe, we, Ie, be, Oe, ze, Re, ge, he, Me, Ne, $e, mt, yt, Ct, gt, Ge, Ee, Ce, xe, Pe, it, lt, dt, vt, It, Dt, ht, _t, fs, Hs, Fs, Ts, Ps, Bs, qt, Os, Ms, ts, gs, xs, Be, Ye, Je, At, Tt, Yt, bs, us, Nt, Gs, Qs, Ks, Zs, Js, $s, _s, ea, ta, sa, aa, na, ra, oa, ia, la, da, wa), ws = (e == null ? void 0 : e.serverIndex) ?? 0, zs = (ne = (va = Q["SearchMlsApi.saveAreaSearch"]) == null ? void 0 : va[ws]) == null ? void 0 : ne.url;
      return (et, no) => _(ma, X, G, e)(et, zs || no);
    },
    /**
     * 
     * @summary Searches predefined saved search.
     * @param {number} id Id of existing saved search to base query from and update
     * @param {number} [m] Max results to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async savedSearch(s, n, r) {
      var d, c;
      const i = await t.savedSearch(s, n, r), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (c = (d = Q["SearchMlsApi.savedSearch"]) == null ? void 0 : d[o]) == null ? void 0 : c.url;
      return (u, m) => _(i, X, G, e)(u, l || m);
    },
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async savedSearchStats(s) {
      var o, l;
      const n = await t.savedSearchStats(s), r = (e == null ? void 0 : e.serverIndex) ?? 0, i = (l = (o = Q["SearchMlsApi.savedSearchStats"]) == null ? void 0 : o[r]) == null ? void 0 : l.url;
      return (d, c) => _(n, X, G, e)(d, i || c);
    },
    /**
     * 
     * @summary List account\'s saved searches.
     * @param {number} [id] Id of sub account to list saved searches
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {number} [t] Random number to force cache not to be used.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async savedSearches(s, n, r, i, o) {
      var u, m;
      const l = await t.savedSearches(s, n, r, i, o), d = (e == null ? void 0 : e.serverIndex) ?? 0, c = (m = (u = Q["SearchMlsApi.savedSearches"]) == null ? void 0 : u[d]) == null ? void 0 : m.url;
      return (f, v) => _(l, X, G, e)(f, c || v);
    },
    /**
     * 
     * @summary Searches predefined scoped areas.
     * @param {Array<string>} area Geographic areas to search
     * @param {number} level Zoom level
     * @param {number} [priceMin] 
     * @param {number} [priceMax] 
     * @param {number} [bedroomsMin] 
     * @param {number} [bathroomsMin] 
     * @param {number} [sqftMin] 
     * @param {number} [sqftMax] 
     * @param {number} [lotMin] 
     * @param {number} [lotMax] 
     * @param {number} [yearMin] 
     * @param {number} [yearMax] 
     * @param {number} [storiesMax] 
     * @param {number} [t] 
     * @param {boolean} [b] 
     * @param {boolean} [pp] 
     * @param {number} [dor] 
     * @param {boolean} [l] 
     * @param {boolean} [m] 
     * @param {boolean} [to] 
     * @param {boolean} [p] 
     * @param {number} [downPayment] 
     * @param {number} [interestRate] 
     * @param {number} [amortizationPeriod] 
     * @param {number} [loanFees] 
     * @param {boolean} [interestOnlyLoan] 
     * @param {number} [interestOnlyTerm] 
     * @param {number} [titleCharges] 
     * @param {number} [averageLengthOfStay] 
     * @param {number} [timeBetweenTenants] 
     * @param {number} [costOfSale] 
     * @param {number} [annualRentalGrowth] 
     * @param {number} [annualExpenseGrowth] 
     * @param {number} [propertyAppreciation] 
     * @param {boolean} [stabilizationReserve] 
     * @param {number} [minCapRate] 
     * @param {number} [minCoC] 
     * @param {number} [minCoCAfterTax] 
     * @param {number} [minIRR] 
     * @param {number} [minIRRAfterTax] 
     * @param {number} [hold] 
     * @param {BlueChipFilters} [blueChipFilters] 
     * @param {StandardIncomeExpenseAccounts} [percentageLongTermFields] 
     * @param {number} [managementFee] 
     * @param {number} [leaseCommission] 
     * @param {number} [leaseRenewalFee] 
     * @param {number} [platformServiceFees] 
     * @param {number} [maintenance] 
     * @param {number} [utilityExpenses] 
     * @param {number} [furnishingExpenses] 
     * @param {number} [consumableExpenses] 
     * @param {number} [cleaningExpenses] 
     * @param {number} [otherExpense] 
     * @param {number} [capitalExpenditures] 
     * @param {number} [otherIncome] 
     * @param {StandardIncomeExpenseAccounts} [percentageShortTermFields] 
     * @param {number} [strManagementFee] 
     * @param {number} [strLeaseCommission] 
     * @param {number} [strLeaseRenewalFee] 
     * @param {number} [strPlatformServiceFees] 
     * @param {number} [strMaintenance] 
     * @param {number} [strUtilityExpenses] 
     * @param {number} [strFurnishingExpenses] 
     * @param {number} [strConsumableExpenses] 
     * @param {number} [strCleaningExpenses] 
     * @param {number} [strOtherExpense] 
     * @param {number} [strCapitalExpenditures] 
     * @param {number} [strOtherIncome] 
     * @param {number} [strWorkingCapitalReserve] 
     * @param {number} [strDaysOccupiedPerYear] 
     * @param {number} [strDaysAvailablePerYear] 
     * @param {number} [strAnnualRentalGrowth] 
     * @param {number} [strAnnualExpenseGrowth] 
     * @param {number} [strPropertyAppreciation] 
     * @param {StandardIncomeExpenseAccounts} [percentagePadSplitFields] 
     * @param {number} [padSplitWorkingCapitalReserve] 
     * @param {number} [padSplitAnnualVacancyRate] 
     * @param {number} [padSplitMaintenance] 
     * @param {number} [padSplitFurnishingExpenses] 
     * @param {number} [padSplitConsumableExpenses] 
     * @param {number} [padSplitUtilityExpenses] 
     * @param {number} [padSplitCleaningExpenses] 
     * @param {number} [padSplitPlatformServiceFees] 
     * @param {number} [padSplitManagementFee] 
     * @param {number} [padSplitAnnualRentalGrowth] 
     * @param {number} [padSplitAnnualExpenseGrowth] 
     * @param {number} [padSplitPropertyAppreciation] 
     * @param {boolean} [padSplitOtherExpensePercentage] 
     * @param {number} [padSplitLeaseCommission] 
     * @param {number} [padSplitLeaseRenewalFee] 
     * @param {number} [padSplitOtherExpense] 
     * @param {number} [padSplitCapitalExpenditures] 
     * @param {number} [padSplitOtherIncome] 
     * @param {number} [padSplitBookingFeeDays] 
     * @param {number} [padSplitAverageLengthOfStay] 
     * @param {Array<CalculatorOtherAccountValue>} [otherExpensesLongTerm] 
     * @param {Array<CalculatorOtherAccountValue>} [otherExpensesShortTerm] 
     * @param {Array<CalculatorOtherAccountValue>} [otherExpensesPadSplit] 
     * @param {Array<CalculatorOtherAccountValue>} [otherIncomesLongTerm] 
     * @param {Array<CalculatorOtherAccountValue>} [otherIncomesShortTerm] 
     * @param {Array<CalculatorOtherAccountValue>} [otherIncomesPadSplit] 
     * @param {string} [s] Name of saved search
     * @param {number} [id] Id of existing saved search to base query from and update
     * @param {boolean} [r] Return listing data
     * @param {boolean} [save] Save filters/parameters as saved search
     * @param {number} [cb] Random number to force refresh, avoid cache.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async scopedSearch(s, n, r, i, o, l, d, c, u, m, f, v, b, w, S, I, T, x, k, C, O, E, B, M, R, F, L, j, H, te, re, le, ie, ye, Y, ae, ke, ue, oe, fe, we, Ie, be, Oe, ze, Re, ge, he, Me, Ne, $e, mt, yt, Ct, gt, Ge, Ee, Ce, xe, Pe, it, lt, dt, vt, It, Dt, ht, _t, fs, Hs, Fs, Ts, Ps, Bs, qt, Os, Ms, ts, gs, xs, Be, Ye, Je, At, Tt, Yt, bs, us, Nt, Gs, Qs, Ks, Zs, Js, $s, _s, ea, ta, sa, aa, na, ra, oa, ia, la, da, wa) {
      var va, ne;
      const ma = await t.scopedSearch(s, n, r, i, o, l, d, c, u, m, f, v, b, w, S, I, T, x, k, C, O, E, B, M, R, F, L, j, H, te, re, le, ie, ye, Y, ae, ke, ue, oe, fe, we, Ie, be, Oe, ze, Re, ge, he, Me, Ne, $e, mt, yt, Ct, gt, Ge, Ee, Ce, xe, Pe, it, lt, dt, vt, It, Dt, ht, _t, fs, Hs, Fs, Ts, Ps, Bs, qt, Os, Ms, ts, gs, xs, Be, Ye, Je, At, Tt, Yt, bs, us, Nt, Gs, Qs, Ks, Zs, Js, $s, _s, ea, ta, sa, aa, na, ra, oa, ia, la, da, wa), ws = (e == null ? void 0 : e.serverIndex) ?? 0, zs = (ne = (va = Q["SearchMlsApi.scopedSearch"]) == null ? void 0 : va[ws]) == null ? void 0 : ne.url;
      return (et, no) => _(ma, X, G, e)(et, zs || no);
    },
    /**
     * 
     * @summary Subscribe Saved Search
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async subscribeSavedSearch(s, n) {
      var l, d;
      const r = await t.subscribeSavedSearch(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["SearchMlsApi.subscribeSavedSearch"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    },
    /**
     * 
     * @summary Saved Search Subscription Frequency
     * @param {number} id 
     * @param {ReportFrequency} frequency 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async subscriptionFrequency(s, n, r) {
      var d, c;
      const i = await t.subscriptionFrequency(s, n, r), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (c = (d = Q["SearchMlsApi.subscriptionFrequency"]) == null ? void 0 : d[o]) == null ? void 0 : c.url;
      return (u, m) => _(i, X, G, e)(u, l || m);
    },
    /**
     * 
     * @summary Unsubscribe Saved Search
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async unsubscribeSavedSearch(s, n) {
      var l, d;
      const r = await t.unsubscribeSavedSearch(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["SearchMlsApi.unsubscribeSavedSearch"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    }
  };
}, xT = function(e, t, s) {
  const n = MT(e);
  return {
    /**
     * 
     * @summary Searches predefined scoped areas.
     * @param {string} bounds Geographic polygon to search
     * @param {number} level Zoom level
     * @param {number} [priceMin] 
     * @param {number} [priceMax] 
     * @param {number} [bedroomsMin] 
     * @param {number} [bathroomsMin] 
     * @param {number} [sqftMin] 
     * @param {number} [sqftMax] 
     * @param {number} [lotMin] 
     * @param {number} [lotMax] 
     * @param {number} [yearMin] 
     * @param {number} [yearMax] 
     * @param {number} [storiesMax] 
     * @param {number} [t] 
     * @param {boolean} [b] 
     * @param {boolean} [pp] 
     * @param {number} [dor] 
     * @param {boolean} [l] 
     * @param {boolean} [m] 
     * @param {boolean} [to] 
     * @param {boolean} [p] 
     * @param {number} [downPayment] 
     * @param {number} [interestRate] 
     * @param {number} [amortizationPeriod] 
     * @param {number} [loanFees] 
     * @param {boolean} [interestOnlyLoan] 
     * @param {number} [interestOnlyTerm] 
     * @param {number} [titleCharges] 
     * @param {number} [averageLengthOfStay] 
     * @param {number} [timeBetweenTenants] 
     * @param {number} [costOfSale] 
     * @param {number} [annualRentalGrowth] 
     * @param {number} [annualExpenseGrowth] 
     * @param {number} [propertyAppreciation] 
     * @param {boolean} [stabilizationReserve] 
     * @param {number} [minCapRate] 
     * @param {number} [minCoC] 
     * @param {number} [minCoCAfterTax] 
     * @param {number} [minIRR] 
     * @param {number} [minIRRAfterTax] 
     * @param {number} [hold] 
     * @param {BlueChipFilters} [blueChipFilters] 
     * @param {StandardIncomeExpenseAccounts} [percentageLongTermFields] 
     * @param {number} [managementFee] 
     * @param {number} [leaseCommission] 
     * @param {number} [leaseRenewalFee] 
     * @param {number} [platformServiceFees] 
     * @param {number} [maintenance] 
     * @param {number} [utilityExpenses] 
     * @param {number} [furnishingExpenses] 
     * @param {number} [consumableExpenses] 
     * @param {number} [cleaningExpenses] 
     * @param {number} [otherExpense] 
     * @param {number} [capitalExpenditures] 
     * @param {number} [otherIncome] 
     * @param {StandardIncomeExpenseAccounts} [percentageShortTermFields] 
     * @param {number} [strManagementFee] 
     * @param {number} [strLeaseCommission] 
     * @param {number} [strLeaseRenewalFee] 
     * @param {number} [strPlatformServiceFees] 
     * @param {number} [strMaintenance] 
     * @param {number} [strUtilityExpenses] 
     * @param {number} [strFurnishingExpenses] 
     * @param {number} [strConsumableExpenses] 
     * @param {number} [strCleaningExpenses] 
     * @param {number} [strOtherExpense] 
     * @param {number} [strCapitalExpenditures] 
     * @param {number} [strOtherIncome] 
     * @param {number} [strWorkingCapitalReserve] 
     * @param {number} [strDaysOccupiedPerYear] 
     * @param {number} [strDaysAvailablePerYear] 
     * @param {number} [strAnnualRentalGrowth] 
     * @param {number} [strAnnualExpenseGrowth] 
     * @param {number} [strPropertyAppreciation] 
     * @param {StandardIncomeExpenseAccounts} [percentagePadSplitFields] 
     * @param {number} [padSplitWorkingCapitalReserve] 
     * @param {number} [padSplitAnnualVacancyRate] 
     * @param {number} [padSplitMaintenance] 
     * @param {number} [padSplitFurnishingExpenses] 
     * @param {number} [padSplitConsumableExpenses] 
     * @param {number} [padSplitUtilityExpenses] 
     * @param {number} [padSplitCleaningExpenses] 
     * @param {number} [padSplitPlatformServiceFees] 
     * @param {number} [padSplitManagementFee] 
     * @param {number} [padSplitAnnualRentalGrowth] 
     * @param {number} [padSplitAnnualExpenseGrowth] 
     * @param {number} [padSplitPropertyAppreciation] 
     * @param {boolean} [padSplitOtherExpensePercentage] 
     * @param {number} [padSplitLeaseCommission] 
     * @param {number} [padSplitLeaseRenewalFee] 
     * @param {number} [padSplitOtherExpense] 
     * @param {number} [padSplitCapitalExpenditures] 
     * @param {number} [padSplitOtherIncome] 
     * @param {number} [padSplitBookingFeeDays] 
     * @param {number} [padSplitAverageLengthOfStay] 
     * @param {Array<CalculatorOtherAccountValue>} [otherExpensesLongTerm] 
     * @param {Array<CalculatorOtherAccountValue>} [otherExpensesShortTerm] 
     * @param {Array<CalculatorOtherAccountValue>} [otherExpensesPadSplit] 
     * @param {Array<CalculatorOtherAccountValue>} [otherIncomesLongTerm] 
     * @param {Array<CalculatorOtherAccountValue>} [otherIncomesShortTerm] 
     * @param {Array<CalculatorOtherAccountValue>} [otherIncomesPadSplit] 
     * @param {string} [s] Name of saved search
     * @param {number} [id] Id of existing saved search to base query from and update
     * @param {boolean} [r] Return listing data
     * @param {boolean} [mb] 
     * @param {number} [cb] Random number to force refresh, avoid cache.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    areaSearch(r, i, o, l, d, c, u, m, f, v, b, w, S, I, T, x, k, C, O, E, B, M, R, F, L, j, H, te, re, le, ie, ye, Y, ae, ke, ue, oe, fe, we, Ie, be, Oe, ze, Re, ge, he, Me, Ne, $e, mt, yt, Ct, gt, Ge, Ee, Ce, xe, Pe, it, lt, dt, vt, It, Dt, ht, _t, fs, Hs, Fs, Ts, Ps, Bs, qt, Os, Ms, ts, gs, xs, Be, Ye, Je, At, Tt, Yt, bs, us, Nt, Gs, Qs, Ks, Zs, Js, $s, _s, ea, ta, sa, aa, na, ra, oa, ia, la, da, wa, ma, ws) {
      return n.areaSearch(r, i, o, l, d, c, u, m, f, v, b, w, S, I, T, x, k, C, O, E, B, M, R, F, L, j, H, te, re, le, ie, ye, Y, ae, ke, ue, oe, fe, we, Ie, be, Oe, ze, Re, ge, he, Me, Ne, $e, mt, yt, Ct, gt, Ge, Ee, Ce, xe, Pe, it, lt, dt, vt, It, Dt, ht, _t, fs, Hs, Fs, Ts, Ps, Bs, qt, Os, Ms, ts, gs, xs, Be, Ye, Je, At, Tt, Yt, bs, us, Nt, Gs, Qs, Ks, Zs, Js, $s, _s, ea, ta, sa, aa, na, ra, oa, ia, la, da, wa, ma, ws).then((zs) => zs(s, t));
    },
    /**
     * 
     * @summary Searches predefined scoped areas.
     * @param {string} bounds Geographic polygon to search
     * @param {number} level Zoom level
     * @param {number} [priceMin] 
     * @param {number} [priceMax] 
     * @param {number} [bedroomsMin] 
     * @param {number} [bathroomsMin] 
     * @param {number} [sqftMin] 
     * @param {number} [sqftMax] 
     * @param {number} [lotMin] 
     * @param {number} [lotMax] 
     * @param {number} [yearMin] 
     * @param {number} [yearMax] 
     * @param {number} [storiesMax] 
     * @param {number} [t] 
     * @param {boolean} [b] 
     * @param {boolean} [pp] 
     * @param {number} [dor] 
     * @param {boolean} [l] 
     * @param {boolean} [m] 
     * @param {boolean} [to] 
     * @param {boolean} [p] 
     * @param {number} [downPayment] 
     * @param {number} [interestRate] 
     * @param {number} [amortizationPeriod] 
     * @param {number} [loanFees] 
     * @param {boolean} [interestOnlyLoan] 
     * @param {number} [interestOnlyTerm] 
     * @param {number} [titleCharges] 
     * @param {number} [averageLengthOfStay] 
     * @param {number} [timeBetweenTenants] 
     * @param {number} [costOfSale] 
     * @param {number} [annualRentalGrowth] 
     * @param {number} [annualExpenseGrowth] 
     * @param {number} [propertyAppreciation] 
     * @param {boolean} [stabilizationReserve] 
     * @param {number} [minCapRate] 
     * @param {number} [minCoC] 
     * @param {number} [minCoCAfterTax] 
     * @param {number} [minIRR] 
     * @param {number} [minIRRAfterTax] 
     * @param {number} [hold] 
     * @param {BlueChipFilters} [blueChipFilters] 
     * @param {StandardIncomeExpenseAccounts} [percentageLongTermFields] 
     * @param {number} [managementFee] 
     * @param {number} [leaseCommission] 
     * @param {number} [leaseRenewalFee] 
     * @param {number} [platformServiceFees] 
     * @param {number} [maintenance] 
     * @param {number} [utilityExpenses] 
     * @param {number} [furnishingExpenses] 
     * @param {number} [consumableExpenses] 
     * @param {number} [cleaningExpenses] 
     * @param {number} [otherExpense] 
     * @param {number} [capitalExpenditures] 
     * @param {number} [otherIncome] 
     * @param {StandardIncomeExpenseAccounts} [percentageShortTermFields] 
     * @param {number} [strManagementFee] 
     * @param {number} [strLeaseCommission] 
     * @param {number} [strLeaseRenewalFee] 
     * @param {number} [strPlatformServiceFees] 
     * @param {number} [strMaintenance] 
     * @param {number} [strUtilityExpenses] 
     * @param {number} [strFurnishingExpenses] 
     * @param {number} [strConsumableExpenses] 
     * @param {number} [strCleaningExpenses] 
     * @param {number} [strOtherExpense] 
     * @param {number} [strCapitalExpenditures] 
     * @param {number} [strOtherIncome] 
     * @param {number} [strWorkingCapitalReserve] 
     * @param {number} [strDaysOccupiedPerYear] 
     * @param {number} [strDaysAvailablePerYear] 
     * @param {number} [strAnnualRentalGrowth] 
     * @param {number} [strAnnualExpenseGrowth] 
     * @param {number} [strPropertyAppreciation] 
     * @param {StandardIncomeExpenseAccounts} [percentagePadSplitFields] 
     * @param {number} [padSplitWorkingCapitalReserve] 
     * @param {number} [padSplitAnnualVacancyRate] 
     * @param {number} [padSplitMaintenance] 
     * @param {number} [padSplitFurnishingExpenses] 
     * @param {number} [padSplitConsumableExpenses] 
     * @param {number} [padSplitUtilityExpenses] 
     * @param {number} [padSplitCleaningExpenses] 
     * @param {number} [padSplitPlatformServiceFees] 
     * @param {number} [padSplitManagementFee] 
     * @param {number} [padSplitAnnualRentalGrowth] 
     * @param {number} [padSplitAnnualExpenseGrowth] 
     * @param {number} [padSplitPropertyAppreciation] 
     * @param {boolean} [padSplitOtherExpensePercentage] 
     * @param {number} [padSplitLeaseCommission] 
     * @param {number} [padSplitLeaseRenewalFee] 
     * @param {number} [padSplitOtherExpense] 
     * @param {number} [padSplitCapitalExpenditures] 
     * @param {number} [padSplitOtherIncome] 
     * @param {number} [padSplitBookingFeeDays] 
     * @param {number} [padSplitAverageLengthOfStay] 
     * @param {Array<CalculatorOtherAccountValue>} [otherExpensesLongTerm] 
     * @param {Array<CalculatorOtherAccountValue>} [otherExpensesShortTerm] 
     * @param {Array<CalculatorOtherAccountValue>} [otherExpensesPadSplit] 
     * @param {Array<CalculatorOtherAccountValue>} [otherIncomesLongTerm] 
     * @param {Array<CalculatorOtherAccountValue>} [otherIncomesShortTerm] 
     * @param {Array<CalculatorOtherAccountValue>} [otherIncomesPadSplit] 
     * @param {string} [s] Name of saved search
     * @param {number} [id] Id of existing saved search to base query from and update
     * @param {boolean} [r] Return listing data
     * @param {boolean} [save] Save filters/parameters as saved search
     * @param {boolean} [mb] Is bounds a map bound(true) or a drawn polygon bound.
     * @param {number} [cb] Random number to force refresh, avoid cache.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    areaSearchFeatured(r, i, o, l, d, c, u, m, f, v, b, w, S, I, T, x, k, C, O, E, B, M, R, F, L, j, H, te, re, le, ie, ye, Y, ae, ke, ue, oe, fe, we, Ie, be, Oe, ze, Re, ge, he, Me, Ne, $e, mt, yt, Ct, gt, Ge, Ee, Ce, xe, Pe, it, lt, dt, vt, It, Dt, ht, _t, fs, Hs, Fs, Ts, Ps, Bs, qt, Os, Ms, ts, gs, xs, Be, Ye, Je, At, Tt, Yt, bs, us, Nt, Gs, Qs, Ks, Zs, Js, $s, _s, ea, ta, sa, aa, na, ra, oa, ia, la, da, wa, ma, ws, zs) {
      return n.areaSearchFeatured(r, i, o, l, d, c, u, m, f, v, b, w, S, I, T, x, k, C, O, E, B, M, R, F, L, j, H, te, re, le, ie, ye, Y, ae, ke, ue, oe, fe, we, Ie, be, Oe, ze, Re, ge, he, Me, Ne, $e, mt, yt, Ct, gt, Ge, Ee, Ce, xe, Pe, it, lt, dt, vt, It, Dt, ht, _t, fs, Hs, Fs, Ts, Ps, Bs, qt, Os, Ms, ts, gs, xs, Be, Ye, Je, At, Tt, Yt, bs, us, Nt, Gs, Qs, Ks, Zs, Js, $s, _s, ea, ta, sa, aa, na, ra, oa, ia, la, da, wa, ma, ws, zs).then((va) => va(s, t));
    },
    /**
     * 
     * @summary Client\'s agent\'s configured IDX default saved search.
     * @param {number} [m] Max results to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    defaultSearchForClient(r, i) {
      return n.defaultSearchForClient(r, i).then((o) => o(s, t));
    },
    /**
     * 
     * @summary Delete a users saved search.
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteSavedSearch(r, i) {
      return n.deleteSavedSearch(r, i).then((o) => o(s, t));
    },
    /**
     * 
     * @summary Get account\'s search parameters.
     * @param {number} [id] Id of saved search
     * @param {number} [t] Random number to force refresh, avoid cache.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSearchParameters(r, i, o) {
      return n.getSearchParameters(r, i, o).then((l) => l(s, t));
    },
    /**
     * 
     * @param {string} bounds 
     * @param {number} level 
     * @param {number} [priceMin] 
     * @param {number} [priceMax] 
     * @param {number} [bedroomsMin] 
     * @param {number} [bathroomsMin] 
     * @param {number} [sqftMin] 
     * @param {number} [sqftMax] 
     * @param {number} [lotMin] 
     * @param {number} [lotMax] 
     * @param {number} [yearMin] 
     * @param {number} [yearMax] 
     * @param {number} [storiesMax] 
     * @param {number} [t] 
     * @param {boolean} [b] 
     * @param {boolean} [pp] 
     * @param {number} [dor] 
     * @param {boolean} [l] 
     * @param {boolean} [m] 
     * @param {boolean} [to] 
     * @param {boolean} [p] 
     * @param {number} [downPayment] 
     * @param {number} [interestRate] 
     * @param {number} [amortizationPeriod] 
     * @param {number} [loanFees] 
     * @param {boolean} [interestOnlyLoan] 
     * @param {number} [interestOnlyTerm] 
     * @param {number} [titleCharges] 
     * @param {number} [averageLengthOfStay] 
     * @param {number} [timeBetweenTenants] 
     * @param {number} [costOfSale] 
     * @param {number} [annualRentalGrowth] 
     * @param {number} [annualExpenseGrowth] 
     * @param {number} [propertyAppreciation] 
     * @param {boolean} [stabilizationReserve] 
     * @param {number} [minCapRate] 
     * @param {number} [minCoC] 
     * @param {number} [minCoCAfterTax] 
     * @param {number} [minIRR] 
     * @param {number} [minIRRAfterTax] 
     * @param {number} [hold] 
     * @param {BlueChipFilters} [blueChipFilters] 
     * @param {StandardIncomeExpenseAccounts} [percentageLongTermFields] 
     * @param {number} [managementFee] 
     * @param {number} [leaseCommission] 
     * @param {number} [leaseRenewalFee] 
     * @param {number} [platformServiceFees] 
     * @param {number} [maintenance] 
     * @param {number} [utilityExpenses] 
     * @param {number} [furnishingExpenses] 
     * @param {number} [consumableExpenses] 
     * @param {number} [cleaningExpenses] 
     * @param {number} [otherExpense] 
     * @param {number} [capitalExpenditures] 
     * @param {number} [otherIncome] 
     * @param {StandardIncomeExpenseAccounts} [percentageShortTermFields] 
     * @param {number} [strManagementFee] 
     * @param {number} [strLeaseCommission] 
     * @param {number} [strLeaseRenewalFee] 
     * @param {number} [strPlatformServiceFees] 
     * @param {number} [strMaintenance] 
     * @param {number} [strUtilityExpenses] 
     * @param {number} [strFurnishingExpenses] 
     * @param {number} [strConsumableExpenses] 
     * @param {number} [strCleaningExpenses] 
     * @param {number} [strOtherExpense] 
     * @param {number} [strCapitalExpenditures] 
     * @param {number} [strOtherIncome] 
     * @param {number} [strWorkingCapitalReserve] 
     * @param {number} [strDaysOccupiedPerYear] 
     * @param {number} [strDaysAvailablePerYear] 
     * @param {number} [strAnnualRentalGrowth] 
     * @param {number} [strAnnualExpenseGrowth] 
     * @param {number} [strPropertyAppreciation] 
     * @param {StandardIncomeExpenseAccounts} [percentagePadSplitFields] 
     * @param {number} [padSplitWorkingCapitalReserve] 
     * @param {number} [padSplitAnnualVacancyRate] 
     * @param {number} [padSplitMaintenance] 
     * @param {number} [padSplitFurnishingExpenses] 
     * @param {number} [padSplitConsumableExpenses] 
     * @param {number} [padSplitUtilityExpenses] 
     * @param {number} [padSplitCleaningExpenses] 
     * @param {number} [padSplitPlatformServiceFees] 
     * @param {number} [padSplitManagementFee] 
     * @param {number} [padSplitAnnualRentalGrowth] 
     * @param {number} [padSplitAnnualExpenseGrowth] 
     * @param {number} [padSplitPropertyAppreciation] 
     * @param {boolean} [padSplitOtherExpensePercentage] 
     * @param {number} [padSplitLeaseCommission] 
     * @param {number} [padSplitLeaseRenewalFee] 
     * @param {number} [padSplitOtherExpense] 
     * @param {number} [padSplitCapitalExpenditures] 
     * @param {number} [padSplitOtherIncome] 
     * @param {number} [padSplitBookingFeeDays] 
     * @param {number} [padSplitAverageLengthOfStay] 
     * @param {Array<CalculatorOtherAccountValue>} [otherExpensesLongTerm] 
     * @param {Array<CalculatorOtherAccountValue>} [otherExpensesShortTerm] 
     * @param {Array<CalculatorOtherAccountValue>} [otherExpensesPadSplit] 
     * @param {Array<CalculatorOtherAccountValue>} [otherIncomesLongTerm] 
     * @param {Array<CalculatorOtherAccountValue>} [otherIncomesShortTerm] 
     * @param {Array<CalculatorOtherAccountValue>} [otherIncomesPadSplit] 
     * @param {string} [s] 
     * @param {number} [id] 
     * @param {boolean} [r] 
     * @param {boolean} [mb] 
     * @param {number} [cb] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    saveAreaSearch(r, i, o, l, d, c, u, m, f, v, b, w, S, I, T, x, k, C, O, E, B, M, R, F, L, j, H, te, re, le, ie, ye, Y, ae, ke, ue, oe, fe, we, Ie, be, Oe, ze, Re, ge, he, Me, Ne, $e, mt, yt, Ct, gt, Ge, Ee, Ce, xe, Pe, it, lt, dt, vt, It, Dt, ht, _t, fs, Hs, Fs, Ts, Ps, Bs, qt, Os, Ms, ts, gs, xs, Be, Ye, Je, At, Tt, Yt, bs, us, Nt, Gs, Qs, Ks, Zs, Js, $s, _s, ea, ta, sa, aa, na, ra, oa, ia, la, da, wa, ma, ws) {
      return n.saveAreaSearch(r, i, o, l, d, c, u, m, f, v, b, w, S, I, T, x, k, C, O, E, B, M, R, F, L, j, H, te, re, le, ie, ye, Y, ae, ke, ue, oe, fe, we, Ie, be, Oe, ze, Re, ge, he, Me, Ne, $e, mt, yt, Ct, gt, Ge, Ee, Ce, xe, Pe, it, lt, dt, vt, It, Dt, ht, _t, fs, Hs, Fs, Ts, Ps, Bs, qt, Os, Ms, ts, gs, xs, Be, Ye, Je, At, Tt, Yt, bs, us, Nt, Gs, Qs, Ks, Zs, Js, $s, _s, ea, ta, sa, aa, na, ra, oa, ia, la, da, wa, ma, ws).then((zs) => zs(s, t));
    },
    /**
     * 
     * @summary Searches predefined saved search.
     * @param {number} id Id of existing saved search to base query from and update
     * @param {number} [m] Max results to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    savedSearch(r, i, o) {
      return n.savedSearch(r, i, o).then((l) => l(s, t));
    },
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    savedSearchStats(r) {
      return n.savedSearchStats(r).then((i) => i(s, t));
    },
    /**
     * 
     * @summary List account\'s saved searches.
     * @param {number} [id] Id of sub account to list saved searches
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {number} [t] Random number to force cache not to be used.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    savedSearches(r, i, o, l, d) {
      return n.savedSearches(r, i, o, l, d).then((c) => c(s, t));
    },
    /**
     * 
     * @summary Searches predefined scoped areas.
     * @param {Array<string>} area Geographic areas to search
     * @param {number} level Zoom level
     * @param {number} [priceMin] 
     * @param {number} [priceMax] 
     * @param {number} [bedroomsMin] 
     * @param {number} [bathroomsMin] 
     * @param {number} [sqftMin] 
     * @param {number} [sqftMax] 
     * @param {number} [lotMin] 
     * @param {number} [lotMax] 
     * @param {number} [yearMin] 
     * @param {number} [yearMax] 
     * @param {number} [storiesMax] 
     * @param {number} [t] 
     * @param {boolean} [b] 
     * @param {boolean} [pp] 
     * @param {number} [dor] 
     * @param {boolean} [l] 
     * @param {boolean} [m] 
     * @param {boolean} [to] 
     * @param {boolean} [p] 
     * @param {number} [downPayment] 
     * @param {number} [interestRate] 
     * @param {number} [amortizationPeriod] 
     * @param {number} [loanFees] 
     * @param {boolean} [interestOnlyLoan] 
     * @param {number} [interestOnlyTerm] 
     * @param {number} [titleCharges] 
     * @param {number} [averageLengthOfStay] 
     * @param {number} [timeBetweenTenants] 
     * @param {number} [costOfSale] 
     * @param {number} [annualRentalGrowth] 
     * @param {number} [annualExpenseGrowth] 
     * @param {number} [propertyAppreciation] 
     * @param {boolean} [stabilizationReserve] 
     * @param {number} [minCapRate] 
     * @param {number} [minCoC] 
     * @param {number} [minCoCAfterTax] 
     * @param {number} [minIRR] 
     * @param {number} [minIRRAfterTax] 
     * @param {number} [hold] 
     * @param {BlueChipFilters} [blueChipFilters] 
     * @param {StandardIncomeExpenseAccounts} [percentageLongTermFields] 
     * @param {number} [managementFee] 
     * @param {number} [leaseCommission] 
     * @param {number} [leaseRenewalFee] 
     * @param {number} [platformServiceFees] 
     * @param {number} [maintenance] 
     * @param {number} [utilityExpenses] 
     * @param {number} [furnishingExpenses] 
     * @param {number} [consumableExpenses] 
     * @param {number} [cleaningExpenses] 
     * @param {number} [otherExpense] 
     * @param {number} [capitalExpenditures] 
     * @param {number} [otherIncome] 
     * @param {StandardIncomeExpenseAccounts} [percentageShortTermFields] 
     * @param {number} [strManagementFee] 
     * @param {number} [strLeaseCommission] 
     * @param {number} [strLeaseRenewalFee] 
     * @param {number} [strPlatformServiceFees] 
     * @param {number} [strMaintenance] 
     * @param {number} [strUtilityExpenses] 
     * @param {number} [strFurnishingExpenses] 
     * @param {number} [strConsumableExpenses] 
     * @param {number} [strCleaningExpenses] 
     * @param {number} [strOtherExpense] 
     * @param {number} [strCapitalExpenditures] 
     * @param {number} [strOtherIncome] 
     * @param {number} [strWorkingCapitalReserve] 
     * @param {number} [strDaysOccupiedPerYear] 
     * @param {number} [strDaysAvailablePerYear] 
     * @param {number} [strAnnualRentalGrowth] 
     * @param {number} [strAnnualExpenseGrowth] 
     * @param {number} [strPropertyAppreciation] 
     * @param {StandardIncomeExpenseAccounts} [percentagePadSplitFields] 
     * @param {number} [padSplitWorkingCapitalReserve] 
     * @param {number} [padSplitAnnualVacancyRate] 
     * @param {number} [padSplitMaintenance] 
     * @param {number} [padSplitFurnishingExpenses] 
     * @param {number} [padSplitConsumableExpenses] 
     * @param {number} [padSplitUtilityExpenses] 
     * @param {number} [padSplitCleaningExpenses] 
     * @param {number} [padSplitPlatformServiceFees] 
     * @param {number} [padSplitManagementFee] 
     * @param {number} [padSplitAnnualRentalGrowth] 
     * @param {number} [padSplitAnnualExpenseGrowth] 
     * @param {number} [padSplitPropertyAppreciation] 
     * @param {boolean} [padSplitOtherExpensePercentage] 
     * @param {number} [padSplitLeaseCommission] 
     * @param {number} [padSplitLeaseRenewalFee] 
     * @param {number} [padSplitOtherExpense] 
     * @param {number} [padSplitCapitalExpenditures] 
     * @param {number} [padSplitOtherIncome] 
     * @param {number} [padSplitBookingFeeDays] 
     * @param {number} [padSplitAverageLengthOfStay] 
     * @param {Array<CalculatorOtherAccountValue>} [otherExpensesLongTerm] 
     * @param {Array<CalculatorOtherAccountValue>} [otherExpensesShortTerm] 
     * @param {Array<CalculatorOtherAccountValue>} [otherExpensesPadSplit] 
     * @param {Array<CalculatorOtherAccountValue>} [otherIncomesLongTerm] 
     * @param {Array<CalculatorOtherAccountValue>} [otherIncomesShortTerm] 
     * @param {Array<CalculatorOtherAccountValue>} [otherIncomesPadSplit] 
     * @param {string} [s] Name of saved search
     * @param {number} [id] Id of existing saved search to base query from and update
     * @param {boolean} [r] Return listing data
     * @param {boolean} [save] Save filters/parameters as saved search
     * @param {number} [cb] Random number to force refresh, avoid cache.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    scopedSearch(r, i, o, l, d, c, u, m, f, v, b, w, S, I, T, x, k, C, O, E, B, M, R, F, L, j, H, te, re, le, ie, ye, Y, ae, ke, ue, oe, fe, we, Ie, be, Oe, ze, Re, ge, he, Me, Ne, $e, mt, yt, Ct, gt, Ge, Ee, Ce, xe, Pe, it, lt, dt, vt, It, Dt, ht, _t, fs, Hs, Fs, Ts, Ps, Bs, qt, Os, Ms, ts, gs, xs, Be, Ye, Je, At, Tt, Yt, bs, us, Nt, Gs, Qs, Ks, Zs, Js, $s, _s, ea, ta, sa, aa, na, ra, oa, ia, la, da, wa, ma, ws) {
      return n.scopedSearch(r, i, o, l, d, c, u, m, f, v, b, w, S, I, T, x, k, C, O, E, B, M, R, F, L, j, H, te, re, le, ie, ye, Y, ae, ke, ue, oe, fe, we, Ie, be, Oe, ze, Re, ge, he, Me, Ne, $e, mt, yt, Ct, gt, Ge, Ee, Ce, xe, Pe, it, lt, dt, vt, It, Dt, ht, _t, fs, Hs, Fs, Ts, Ps, Bs, qt, Os, Ms, ts, gs, xs, Be, Ye, Je, At, Tt, Yt, bs, us, Nt, Gs, Qs, Ks, Zs, Js, $s, _s, ea, ta, sa, aa, na, ra, oa, ia, la, da, wa, ma, ws).then((zs) => zs(s, t));
    },
    /**
     * 
     * @summary Subscribe Saved Search
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    subscribeSavedSearch(r, i) {
      return n.subscribeSavedSearch(r, i).then((o) => o(s, t));
    },
    /**
     * 
     * @summary Saved Search Subscription Frequency
     * @param {number} id 
     * @param {ReportFrequency} frequency 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    subscriptionFrequency(r, i, o) {
      return n.subscriptionFrequency(r, i, o).then((l) => l(s, t));
    },
    /**
     * 
     * @summary Unsubscribe Saved Search
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    unsubscribeSavedSearch(r, i) {
      return n.unsubscribeSavedSearch(r, i).then((o) => o(s, t));
    }
  };
}, FT = function(e) {
  return {
    /**
     * 
     * @param {string} token 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    acceptInvite: async (t, s = {}) => {
      se("acceptInvite", "token", t);
      const n = "/account/sub-accounts/invite/{token}".replace("{token}", encodeURIComponent(String(t))), r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "POST", ...i, ...s }, l = {};
      Z(r, {});
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, {
        url: J(r),
        options: o
      };
    },
    /**
     * 
     * @summary Link account to primary account.
     * @param {AddAccountModel} [addAccountModel] Email of account to invite to link.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addAccount: async (t, s = {}) => {
      const n = "/account/sub-accounts", r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "POST", ...i, ...s }, l = {}, d = {};
      await ee(l, e), l["Content-Type"] = "application/json", Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, o.data = kt(t, o, e), {
        url: J(r),
        options: o
      };
    },
    /**
     * 
     * @param {string} token 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    declineInvite: async (t, s = {}) => {
      se("declineInvite", "token", t);
      const n = "/account/sub-accounts/invite/{token}".replace("{token}", encodeURIComponent(String(t))), r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "DELETE", ...i, ...s }, l = {};
      Z(r, {});
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, {
        url: J(r),
        options: o
      };
    },
    /**
     * 
     * @summary List sub accounts userMember to current account.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSubAccounts: async (t = {}) => {
      const s = "/account/sub-accounts", n = new URL(s, K);
      let r;
      e && (r = e.baseOptions);
      const i = { method: "GET", ...r, ...t }, o = {}, l = {};
      await ee(o, e), Z(n, l);
      let d = r && r.headers ? r.headers : {};
      return i.headers = { ...o, ...d, ...t.headers }, {
        url: J(n),
        options: i
      };
    },
    /**
     * 
     * @summary Send account invite to sub-account.
     * @param {number} id Id of invite to resend.
     * @param {boolean} [isInvite] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    invite: async (t, s, n = {}) => {
      se("invite", "id", t);
      const r = "/account/sub-accounts/{id}/invite".replace("{id}", encodeURIComponent(String(t))), i = new URL(r, K);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "POST", ...o, ...n }, d = {}, c = {};
      await ee(d, e), s !== void 0 && (c.isInvite = s), Z(i, c);
      let u = o && o.headers ? o.headers : {};
      return l.headers = { ...d, ...u, ...n.headers }, {
        url: J(i),
        options: l
      };
    },
    /**
     * 
     * @summary Remove account link to account.
     * @param {number} id Id of user to unlink. No id means unlink current account from parent.
     * @param {boolean} [isInvite] Is id a invite id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    removeAccount: async (t, s, n = {}) => {
      se("removeAccount", "id", t);
      const r = "/account/sub-accounts/{id}".replace("{id}", encodeURIComponent(String(t))), i = new URL(r, K);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "DELETE", ...o, ...n }, d = {}, c = {};
      await ee(d, e), s !== void 0 && (c.isInvite = s), Z(i, c);
      let u = o && o.headers ? o.headers : {};
      return l.headers = { ...d, ...u, ...n.headers }, {
        url: J(i),
        options: l
      };
    },
    /**
     * 
     * @summary Remove account link to primary account.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    removeMe: async (t = {}) => {
      const s = "/account/sub-accounts/me", n = new URL(s, K);
      let r;
      e && (r = e.baseOptions);
      const i = { method: "DELETE", ...r, ...t }, o = {}, l = {};
      await ee(o, e), Z(n, l);
      let d = r && r.headers ? r.headers : {};
      return i.headers = { ...o, ...d, ...t.headers }, {
        url: J(n),
        options: i
      };
    },
    /**
     * 
     * @summary Remove admin role from sub-account.
     * @param {number} subAccountId Id of sub-account to set as admin.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    unsetAdmin: async (t, s = {}) => {
      se("unsetAdmin", "subAccountId", t);
      const n = "/account/sub-accounts/{subAccountId}/admin".replace("{subAccountId}", encodeURIComponent(String(t))), r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "DELETE", ...i, ...s }, l = {}, d = {};
      await ee(l, e), Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, {
        url: J(r),
        options: o
      };
    },
    /**
     * This method allows an administrator to update the role, license, and data access              settings of a user in the account. The caller must be authenticated and have administrative privileges              within the account.
     * @summary Updates the account information for a specified user within the current account.
     * @param {number} userId The ID of the user whose account information is being updated.
     * @param {EditAccountModel} [editAccountModel] An Rescover.API.Models.Account.EditAccountModel containing the updated account details, such as role name, license, and              data access settings.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateAccount: async (t, s, n = {}) => {
      se("updateAccount", "userId", t);
      const r = "/account/sub-accounts/{userId}".replace("{userId}", encodeURIComponent(String(t))), i = new URL(r, K);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "PATCH", ...o, ...n }, d = {}, c = {};
      await ee(d, e), d["Content-Type"] = "application/json", Z(i, c);
      let u = o && o.headers ? o.headers : {};
      return l.headers = { ...d, ...u, ...n.headers }, l.data = kt(s, l, e), {
        url: J(i),
        options: l
      };
    }
  };
}, oo = function(e) {
  const t = FT(e);
  return {
    /**
     * 
     * @param {string} token 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async acceptInvite(s, n) {
      var l, d;
      const r = await t.acceptInvite(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["SubAccountsApi.acceptInvite"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    },
    /**
     * 
     * @summary Link account to primary account.
     * @param {AddAccountModel} [addAccountModel] Email of account to invite to link.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async addAccount(s, n) {
      var l, d;
      const r = await t.addAccount(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["SubAccountsApi.addAccount"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    },
    /**
     * 
     * @param {string} token 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async declineInvite(s, n) {
      var l, d;
      const r = await t.declineInvite(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["SubAccountsApi.declineInvite"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    },
    /**
     * 
     * @summary List sub accounts userMember to current account.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getSubAccounts(s) {
      var o, l;
      const n = await t.getSubAccounts(s), r = (e == null ? void 0 : e.serverIndex) ?? 0, i = (l = (o = Q["SubAccountsApi.getSubAccounts"]) == null ? void 0 : o[r]) == null ? void 0 : l.url;
      return (d, c) => _(n, X, G, e)(d, i || c);
    },
    /**
     * 
     * @summary Send account invite to sub-account.
     * @param {number} id Id of invite to resend.
     * @param {boolean} [isInvite] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async invite(s, n, r) {
      var d, c;
      const i = await t.invite(s, n, r), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (c = (d = Q["SubAccountsApi.invite"]) == null ? void 0 : d[o]) == null ? void 0 : c.url;
      return (u, m) => _(i, X, G, e)(u, l || m);
    },
    /**
     * 
     * @summary Remove account link to account.
     * @param {number} id Id of user to unlink. No id means unlink current account from parent.
     * @param {boolean} [isInvite] Is id a invite id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async removeAccount(s, n, r) {
      var d, c;
      const i = await t.removeAccount(s, n, r), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (c = (d = Q["SubAccountsApi.removeAccount"]) == null ? void 0 : d[o]) == null ? void 0 : c.url;
      return (u, m) => _(i, X, G, e)(u, l || m);
    },
    /**
     * 
     * @summary Remove account link to primary account.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async removeMe(s) {
      var o, l;
      const n = await t.removeMe(s), r = (e == null ? void 0 : e.serverIndex) ?? 0, i = (l = (o = Q["SubAccountsApi.removeMe"]) == null ? void 0 : o[r]) == null ? void 0 : l.url;
      return (d, c) => _(n, X, G, e)(d, i || c);
    },
    /**
     * 
     * @summary Remove admin role from sub-account.
     * @param {number} subAccountId Id of sub-account to set as admin.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async unsetAdmin(s, n) {
      var l, d;
      const r = await t.unsetAdmin(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["SubAccountsApi.unsetAdmin"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    },
    /**
     * This method allows an administrator to update the role, license, and data access              settings of a user in the account. The caller must be authenticated and have administrative privileges              within the account.
     * @summary Updates the account information for a specified user within the current account.
     * @param {number} userId The ID of the user whose account information is being updated.
     * @param {EditAccountModel} [editAccountModel] An Rescover.API.Models.Account.EditAccountModel containing the updated account details, such as role name, license, and              data access settings.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateAccount(s, n, r) {
      var d, c;
      const i = await t.updateAccount(s, n, r), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (c = (d = Q["SubAccountsApi.updateAccount"]) == null ? void 0 : d[o]) == null ? void 0 : c.url;
      return (u, m) => _(i, X, G, e)(u, l || m);
    }
  };
};
class VT extends Fn {
  /**
   * 
   * @param {string} token 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SubAccountsApi
   */
  acceptInvite(t, s) {
    return oo(this.configuration).acceptInvite(t, s).then((n) => n(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Link account to primary account.
   * @param {AddAccountModel} [addAccountModel] Email of account to invite to link.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SubAccountsApi
   */
  addAccount(t, s) {
    return oo(this.configuration).addAccount(t, s).then((n) => n(this.axios, this.basePath));
  }
  /**
   * 
   * @param {string} token 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SubAccountsApi
   */
  declineInvite(t, s) {
    return oo(this.configuration).declineInvite(t, s).then((n) => n(this.axios, this.basePath));
  }
  /**
   * 
   * @summary List sub accounts userMember to current account.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SubAccountsApi
   */
  getSubAccounts(t) {
    return oo(this.configuration).getSubAccounts(t).then((s) => s(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Send account invite to sub-account.
   * @param {number} id Id of invite to resend.
   * @param {boolean} [isInvite] 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SubAccountsApi
   */
  invite(t, s, n) {
    return oo(this.configuration).invite(t, s, n).then((r) => r(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Remove account link to account.
   * @param {number} id Id of user to unlink. No id means unlink current account from parent.
   * @param {boolean} [isInvite] Is id a invite id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SubAccountsApi
   */
  removeAccount(t, s, n) {
    return oo(this.configuration).removeAccount(t, s, n).then((r) => r(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Remove account link to primary account.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SubAccountsApi
   */
  removeMe(t) {
    return oo(this.configuration).removeMe(t).then((s) => s(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Remove admin role from sub-account.
   * @param {number} subAccountId Id of sub-account to set as admin.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SubAccountsApi
   */
  unsetAdmin(t, s) {
    return oo(this.configuration).unsetAdmin(t, s).then((n) => n(this.axios, this.basePath));
  }
  /**
   * This method allows an administrator to update the role, license, and data access              settings of a user in the account. The caller must be authenticated and have administrative privileges              within the account.
   * @summary Updates the account information for a specified user within the current account.
   * @param {number} userId The ID of the user whose account information is being updated.
   * @param {EditAccountModel} [editAccountModel] An Rescover.API.Models.Account.EditAccountModel containing the updated account details, such as role name, license, and              data access settings.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SubAccountsApi
   */
  updateAccount(t, s, n) {
    return oo(this.configuration).updateAccount(t, s, n).then((r) => r(this.axios, this.basePath));
  }
}
const DT = function(e) {
  return {
    /**
     * 
     * @summary Cancel a subscription.
     * @param {number} subscriptionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cancel: async (t, s = {}) => {
      se("cancel", "subscriptionId", t);
      const n = "/account/billing/subscriptions/{subscriptionId}".replace("{subscriptionId}", encodeURIComponent(String(t))), r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "DELETE", ...i, ...s }, l = {}, d = {};
      await ee(l, e), Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, {
        url: J(r),
        options: o
      };
    },
    /**
     * 
     * @param {number} id 
     * @param {string} [o] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSubscription: async (t, s, n = {}) => {
      se("getSubscription", "id", t);
      const r = "/account/billing/subscriptions/{id}".replace("{id}", encodeURIComponent(String(t))), i = new URL(r, K);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "GET", ...o, ...n }, d = {}, c = {};
      await ee(d, e), s !== void 0 && (c.o = s), Z(i, c);
      let u = o && o.headers ? o.headers : {};
      return l.headers = { ...d, ...u, ...n.headers }, {
        url: J(i),
        options: l
      };
    },
    /**
     * 
     * @summary List subscriptions for user.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSubscriptions: async (t = {}) => {
      const s = "/account/billing/subscriptions", n = new URL(s, K);
      let r;
      e && (r = e.baseOptions);
      const i = { method: "GET", ...r, ...t }, o = {}, l = {};
      await ee(o, e), Z(n, l);
      let d = r && r.headers ? r.headers : {};
      return i.headers = { ...o, ...d, ...t.headers }, {
        url: J(n),
        options: i
      };
    },
    /**
     * 
     * @param {number} id 
     * @param {GroupSubscription} [groupSubscription] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    previewUpdate: async (t, s, n = {}) => {
      se("previewUpdate", "id", t);
      const r = "/account/billing/subscriptions/{id}/preview".replace("{id}", encodeURIComponent(String(t))), i = new URL(r, K);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "POST", ...o, ...n }, d = {}, c = {};
      await ee(d, e), d["Content-Type"] = "application/json", Z(i, c);
      let u = o && o.headers ? o.headers : {};
      return l.headers = { ...d, ...u, ...n.headers }, l.data = kt(s, l, e), {
        url: J(i),
        options: l
      };
    },
    /**
     * 
     * @summary Resume a subscription.
     * @param {number} subscriptionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    resume: async (t, s = {}) => {
      se("resume", "subscriptionId", t);
      const n = "/account/billing/subscriptions/{subscriptionId}/resume".replace("{subscriptionId}", encodeURIComponent(String(t))), r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "POST", ...i, ...s }, l = {}, d = {};
      await ee(l, e), Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, {
        url: J(r),
        options: o
      };
    },
    /**
     * 
     * @summary Subscribe to a package.
     * @param {number} packageId Package\&#39;s id that you want to subscribe or upgrade/downgrade to.
     * @param {SubscribeRequest} [subscribeRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    subscribe: async (t, s, n = {}) => {
      se("subscribe", "packageId", t);
      const r = "/account/billing/packages/{packageId}/subscribe".replace("{packageId}", encodeURIComponent(String(t))), i = new URL(r, K);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "POST", ...o, ...n }, d = {}, c = {};
      await ee(d, e), d["Content-Type"] = "application/json", Z(i, c);
      let u = o && o.headers ? o.headers : {};
      return l.headers = { ...d, ...u, ...n.headers }, l.data = kt(s, l, e), {
        url: J(i),
        options: l
      };
    },
    /**
     * 
     * @summary Subscribe to a brand\'s bundle.
     * @param {string} brandPath Unique brand path id.
     * @param {SubscribeRequest} [subscribeRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    subscribeBrandBundle: async (t, s, n = {}) => {
      se("subscribeBrandBundle", "brandPath", t);
      const r = "/account/billing/brand/{brandPath}/subscribe".replace("{brandPath}", encodeURIComponent(String(t))), i = new URL(r, K);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "POST", ...o, ...n }, d = {}, c = {};
      await ee(d, e), d["Content-Type"] = "application/json", Z(i, c);
      let u = o && o.headers ? o.headers : {};
      return l.headers = { ...d, ...u, ...n.headers }, l.data = kt(s, l, e), {
        url: J(i),
        options: l
      };
    },
    /**
     * 
     * @param {number} id 
     * @param {GroupSubscription} [groupSubscription] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateSubscription: async (t, s, n = {}) => {
      se("updateSubscription", "id", t);
      const r = "/account/billing/subscriptions/{id}".replace("{id}", encodeURIComponent(String(t))), i = new URL(r, K);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "PATCH", ...o, ...n }, d = {}, c = {};
      await ee(d, e), d["Content-Type"] = "application/json", Z(i, c);
      let u = o && o.headers ? o.headers : {};
      return l.headers = { ...d, ...u, ...n.headers }, l.data = kt(s, l, e), {
        url: J(i),
        options: l
      };
    }
  };
}, Xo = function(e) {
  const t = DT(e);
  return {
    /**
     * 
     * @summary Cancel a subscription.
     * @param {number} subscriptionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async cancel(s, n) {
      var l, d;
      const r = await t.cancel(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["SubscriptionsApi.cancel"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    },
    /**
     * 
     * @param {number} id 
     * @param {string} [o] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getSubscription(s, n, r) {
      var d, c;
      const i = await t.getSubscription(s, n, r), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (c = (d = Q["SubscriptionsApi.getSubscription"]) == null ? void 0 : d[o]) == null ? void 0 : c.url;
      return (u, m) => _(i, X, G, e)(u, l || m);
    },
    /**
     * 
     * @summary List subscriptions for user.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getSubscriptions(s) {
      var o, l;
      const n = await t.getSubscriptions(s), r = (e == null ? void 0 : e.serverIndex) ?? 0, i = (l = (o = Q["SubscriptionsApi.getSubscriptions"]) == null ? void 0 : o[r]) == null ? void 0 : l.url;
      return (d, c) => _(n, X, G, e)(d, i || c);
    },
    /**
     * 
     * @param {number} id 
     * @param {GroupSubscription} [groupSubscription] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async previewUpdate(s, n, r) {
      var d, c;
      const i = await t.previewUpdate(s, n, r), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (c = (d = Q["SubscriptionsApi.previewUpdate"]) == null ? void 0 : d[o]) == null ? void 0 : c.url;
      return (u, m) => _(i, X, G, e)(u, l || m);
    },
    /**
     * 
     * @summary Resume a subscription.
     * @param {number} subscriptionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async resume(s, n) {
      var l, d;
      const r = await t.resume(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["SubscriptionsApi.resume"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    },
    /**
     * 
     * @summary Subscribe to a package.
     * @param {number} packageId Package\&#39;s id that you want to subscribe or upgrade/downgrade to.
     * @param {SubscribeRequest} [subscribeRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async subscribe(s, n, r) {
      var d, c;
      const i = await t.subscribe(s, n, r), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (c = (d = Q["SubscriptionsApi.subscribe"]) == null ? void 0 : d[o]) == null ? void 0 : c.url;
      return (u, m) => _(i, X, G, e)(u, l || m);
    },
    /**
     * 
     * @summary Subscribe to a brand\'s bundle.
     * @param {string} brandPath Unique brand path id.
     * @param {SubscribeRequest} [subscribeRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async subscribeBrandBundle(s, n, r) {
      var d, c;
      const i = await t.subscribeBrandBundle(s, n, r), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (c = (d = Q["SubscriptionsApi.subscribeBrandBundle"]) == null ? void 0 : d[o]) == null ? void 0 : c.url;
      return (u, m) => _(i, X, G, e)(u, l || m);
    },
    /**
     * 
     * @param {number} id 
     * @param {GroupSubscription} [groupSubscription] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateSubscription(s, n, r) {
      var d, c;
      const i = await t.updateSubscription(s, n, r), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (c = (d = Q["SubscriptionsApi.updateSubscription"]) == null ? void 0 : d[o]) == null ? void 0 : c.url;
      return (u, m) => _(i, X, G, e)(u, l || m);
    }
  };
};
class NT extends Fn {
  /**
   * 
   * @summary Cancel a subscription.
   * @param {number} subscriptionId 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SubscriptionsApi
   */
  cancel(t, s) {
    return Xo(this.configuration).cancel(t, s).then((n) => n(this.axios, this.basePath));
  }
  /**
   * 
   * @param {number} id 
   * @param {string} [o] 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SubscriptionsApi
   */
  getSubscription(t, s, n) {
    return Xo(this.configuration).getSubscription(t, s, n).then((r) => r(this.axios, this.basePath));
  }
  /**
   * 
   * @summary List subscriptions for user.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SubscriptionsApi
   */
  getSubscriptions(t) {
    return Xo(this.configuration).getSubscriptions(t).then((s) => s(this.axios, this.basePath));
  }
  /**
   * 
   * @param {number} id 
   * @param {GroupSubscription} [groupSubscription] 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SubscriptionsApi
   */
  previewUpdate(t, s, n) {
    return Xo(this.configuration).previewUpdate(t, s, n).then((r) => r(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Resume a subscription.
   * @param {number} subscriptionId 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SubscriptionsApi
   */
  resume(t, s) {
    return Xo(this.configuration).resume(t, s).then((n) => n(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Subscribe to a package.
   * @param {number} packageId Package\&#39;s id that you want to subscribe or upgrade/downgrade to.
   * @param {SubscribeRequest} [subscribeRequest] 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SubscriptionsApi
   */
  subscribe(t, s, n) {
    return Xo(this.configuration).subscribe(t, s, n).then((r) => r(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Subscribe to a brand\'s bundle.
   * @param {string} brandPath Unique brand path id.
   * @param {SubscribeRequest} [subscribeRequest] 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SubscriptionsApi
   */
  subscribeBrandBundle(t, s, n) {
    return Xo(this.configuration).subscribeBrandBundle(t, s, n).then((r) => r(this.axios, this.basePath));
  }
  /**
   * 
   * @param {number} id 
   * @param {GroupSubscription} [groupSubscription] 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SubscriptionsApi
   */
  updateSubscription(t, s, n) {
    return Xo(this.configuration).updateSubscription(t, s, n).then((r) => r(this.axios, this.basePath));
  }
}
const jT = function(e) {
  return {
    /**
     * 
     * @param {string} [email] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createEmailValidation: async (t, s = {}) => {
      const n = "/account/user/validate/email/create", r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "POST", ...i, ...s }, l = {}, d = {};
      await ee(l, e), t !== void 0 && (d.email = t), Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, {
        url: J(r),
        options: o
      };
    },
    /**
     * 
     * @summary Get current user\'s account settings.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSettings: async (t = {}) => {
      const s = "/account/user/settings", n = new URL(s, K);
      let r;
      e && (r = e.baseOptions);
      const i = { method: "GET", ...r, ...t }, o = {}, l = {};
      await ee(o, e), Z(n, l);
      let d = r && r.headers ? r.headers : {};
      return i.headers = { ...o, ...d, ...t.headers }, {
        url: J(n),
        options: i
      };
    },
    /**
     * 
     * @summary Update default settings for account.
     * @param {UpdateSettingsModel} updateSettingsModel User settings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateSettings: async (t, s = {}) => {
      se("updateSettings", "updateSettingsModel", t);
      const n = "/account/user/settings", r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "PATCH", ...i, ...s }, l = {}, d = {};
      await ee(l, e), l["Content-Type"] = "application/json", Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, o.data = kt(t, o, e), {
        url: J(r),
        options: o
      };
    },
    /**
     * 
     * @param {string} [email] 
     * @param {number} [code] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    validateEmail: async (t, s, n = {}) => {
      const r = "/account/user/validate/email", i = new URL(r, K);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "POST", ...o, ...n }, d = {}, c = {};
      await ee(d, e), t !== void 0 && (c.email = t), s !== void 0 && (c.code = s), Z(i, c);
      let u = o && o.headers ? o.headers : {};
      return l.headers = { ...d, ...u, ...n.headers }, {
        url: J(i),
        options: l
      };
    }
  };
}, HT = function(e) {
  const t = jT(e);
  return {
    /**
     * 
     * @param {string} [email] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createEmailValidation(s, n) {
      var l, d;
      const r = await t.createEmailValidation(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["UserApi.createEmailValidation"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    },
    /**
     * 
     * @summary Get current user\'s account settings.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getSettings(s) {
      var o, l;
      const n = await t.getSettings(s), r = (e == null ? void 0 : e.serverIndex) ?? 0, i = (l = (o = Q["UserApi.getSettings"]) == null ? void 0 : o[r]) == null ? void 0 : l.url;
      return (d, c) => _(n, X, G, e)(d, i || c);
    },
    /**
     * 
     * @summary Update default settings for account.
     * @param {UpdateSettingsModel} updateSettingsModel User settings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateSettings(s, n) {
      var l, d;
      const r = await t.updateSettings(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["UserApi.updateSettings"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    },
    /**
     * 
     * @param {string} [email] 
     * @param {number} [code] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async validateEmail(s, n, r) {
      var d, c;
      const i = await t.validateEmail(s, n, r), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (c = (d = Q["UserApi.validateEmail"]) == null ? void 0 : d[o]) == null ? void 0 : c.url;
      return (u, m) => _(i, X, G, e)(u, l || m);
    }
  };
}, UT = function(e, t, s) {
  const n = HT(e);
  return {
    /**
     * 
     * @param {string} [email] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createEmailValidation(r, i) {
      return n.createEmailValidation(r, i).then((o) => o(s, t));
    },
    /**
     * 
     * @summary Get current user\'s account settings.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSettings(r) {
      return n.getSettings(r).then((i) => i(s, t));
    },
    /**
     * 
     * @summary Update default settings for account.
     * @param {UpdateSettingsModel} updateSettingsModel User settings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateSettings(r, i) {
      return n.updateSettings(r, i).then((o) => o(s, t));
    },
    /**
     * 
     * @param {string} [email] 
     * @param {number} [code] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    validateEmail(r, i, o) {
      return n.validateEmail(r, i, o).then((l) => l(s, t));
    }
  };
}, zT = function(e) {
  return {
    /**
     * 
     * @summary Get user\'s default parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getMyDefaults: async (t = {}) => {
      const s = "/user/parameters/defaults", n = new URL(s, K);
      let r;
      e && (r = e.baseOptions);
      const i = { method: "GET", ...r, ...t }, o = {}, l = {};
      await ee(o, e), Z(n, l);
      let d = r && r.headers ? r.headers : {};
      return i.headers = { ...o, ...d, ...t.headers }, {
        url: J(n),
        options: i
      };
    },
    /**
     * 
     * @summary Update user\'s default filter parameters.
     * @param {FilterParametersModel} filterParametersModel 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateFilterParameters: async (t, s = {}) => {
      se("updateFilterParameters", "filterParametersModel", t);
      const n = "/user/parameters/defaults/filter-parameters", r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "POST", ...i, ...s }, l = {}, d = {};
      await ee(l, e), l["Content-Type"] = "application/json", Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, o.data = kt(t, o, e), {
        url: J(r),
        options: o
      };
    },
    /**
     * 
     * @summary Update user\'s default financial parameters.
     * @param {FinancialParametersModel} financialParametersModel 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateFinancialParameters: async (t, s = {}) => {
      se("updateFinancialParameters", "financialParametersModel", t);
      const n = "/user/parameters/defaults/financial-parameters", r = new URL(n, K);
      let i;
      e && (i = e.baseOptions);
      const o = { method: "POST", ...i, ...s }, l = {}, d = {};
      await ee(l, e), l["Content-Type"] = "application/json", Z(r, d);
      let c = i && i.headers ? i.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, o.data = kt(t, o, e), {
        url: J(r),
        options: o
      };
    }
  };
}, Tf = function(e) {
  const t = zT(e);
  return {
    /**
     * 
     * @summary Get user\'s default parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getMyDefaults(s) {
      var o, l;
      const n = await t.getMyDefaults(s), r = (e == null ? void 0 : e.serverIndex) ?? 0, i = (l = (o = Q["UserParametersApi.getMyDefaults"]) == null ? void 0 : o[r]) == null ? void 0 : l.url;
      return (d, c) => _(n, X, G, e)(d, i || c);
    },
    /**
     * 
     * @summary Update user\'s default filter parameters.
     * @param {FilterParametersModel} filterParametersModel 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateFilterParameters(s, n) {
      var l, d;
      const r = await t.updateFilterParameters(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["UserParametersApi.updateFilterParameters"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    },
    /**
     * 
     * @summary Update user\'s default financial parameters.
     * @param {FinancialParametersModel} financialParametersModel 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateFinancialParameters(s, n) {
      var l, d;
      const r = await t.updateFinancialParameters(s, n), i = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = Q["UserParametersApi.updateFinancialParameters"]) == null ? void 0 : l[i]) == null ? void 0 : d.url;
      return (c, u) => _(r, X, G, e)(c, o || u);
    }
  };
};
class WT extends Fn {
  /**
   * 
   * @summary Get user\'s default parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserParametersApi
   */
  getMyDefaults(t) {
    return Tf(this.configuration).getMyDefaults(t).then((s) => s(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Update user\'s default filter parameters.
   * @param {FilterParametersModel} filterParametersModel 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserParametersApi
   */
  updateFilterParameters(t, s) {
    return Tf(this.configuration).updateFilterParameters(t, s).then((n) => n(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Update user\'s default financial parameters.
   * @param {FinancialParametersModel} financialParametersModel 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserParametersApi
   */
  updateFinancialParameters(t, s) {
    return Tf(this.configuration).updateFinancialParameters(t, s).then((n) => n(this.axios, this.basePath));
  }
}
const GT = function(e) {
  return {
    /**
     * 
     * @param {FeaturedType} [type] 
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {boolean} [bm] 
     * @param {number} [latitude] 
     * @param {number} [longitude] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getFeaturedListings: async (t, s, n, r, i, o, l = {}) => {
      const d = "/widget/idx/featured-listings", c = new URL(d, K);
      let u;
      e && (u = e.baseOptions);
      const m = { method: "GET", ...u, ...l }, f = {}, v = {};
      await Lt(f, "x-api-key", e), await ee(f, e), t !== void 0 && (v.type = t), s !== void 0 && (v.page = s), n !== void 0 && (v.pageSize = n), r !== void 0 && (v.bm = r), i !== void 0 && (v.latitude = i), o !== void 0 && (v.longitude = o), Z(c, v);
      let b = u && u.headers ? u.headers : {};
      return m.headers = { ...f, ...b, ...l.headers }, {
        url: J(c),
        options: m
      };
    }
  };
}, YT = function(e) {
  const t = GT(e);
  return {
    /**
     * 
     * @param {FeaturedType} [type] 
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {boolean} [bm] 
     * @param {number} [latitude] 
     * @param {number} [longitude] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getFeaturedListings(s, n, r, i, o, l, d) {
      var f, v;
      const c = await t.getFeaturedListings(s, n, r, i, o, l, d), u = (e == null ? void 0 : e.serverIndex) ?? 0, m = (v = (f = Q["WidgetIdxApi.getFeaturedListings"]) == null ? void 0 : f[u]) == null ? void 0 : v.url;
      return (b, w) => _(c, X, G, e)(b, m || w);
    }
  };
};
class XT extends Fn {
  /**
   * 
   * @param {FeaturedType} [type] 
   * @param {number} [page] 
   * @param {number} [pageSize] 
   * @param {boolean} [bm] 
   * @param {number} [latitude] 
   * @param {number} [longitude] 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof WidgetIdxApi
   */
  getFeaturedListings(t, s, n, r, i, o, l) {
    return YT(this.configuration).getFeaturedListings(t, s, n, r, i, o, l).then((d) => d(this.axios, this.basePath));
  }
}
let qT = class {
  constructor(t = {}) {
    /**
     * parameter for apiKey security
     * @param name security name
     * @memberof Configuration
     */
    Xe(this, "apiKey");
    /**
     * parameter for basic security
     *
     * @type {string}
     * @memberof Configuration
     */
    Xe(this, "username");
    /**
     * parameter for basic security
     *
     * @type {string}
     * @memberof Configuration
     */
    Xe(this, "password");
    /**
     * parameter for oauth2 security
     * @param name security name
     * @param scopes oauth2 scope
     * @memberof Configuration
     */
    Xe(this, "accessToken");
    /**
     * override base path
     *
     * @type {string}
     * @memberof Configuration
     */
    Xe(this, "basePath");
    /**
     * override server index
     *
     * @type {number}
     * @memberof Configuration
     */
    Xe(this, "serverIndex");
    /**
     * base options for axios calls
     *
     * @type {any}
     * @memberof Configuration
     */
    Xe(this, "baseOptions");
    /**
     * The FormData constructor that will be used to create multipart form data
     * requests. You can inject this here so that execution environments that
     * do not support the FormData class can still run the generated client.
     *
     * @type {new () => FormData}
     */
    Xe(this, "formDataCtor");
    var s;
    this.apiKey = t.apiKey, this.username = t.username, this.password = t.password, this.accessToken = t.accessToken, this.basePath = t.basePath, this.serverIndex = t.serverIndex, this.baseOptions = {
      ...t.baseOptions,
      headers: {
        ...(s = t.baseOptions) == null ? void 0 : s.headers
      }
    }, this.formDataCtor = t.formDataCtor;
  }
  /**
   * Check if the given MIME is a JSON MIME.
   * JSON MIME examples:
   *   application/json
   *   application/json; charset=UTF8
   *   APPLICATION/JSON
   *   application/vnd.company+json
   * @param mime - MIME (Multipurpose Internet Mail Extensions)
   * @return True if the given MIME is JSON, false otherwise.
   */
  isJsonMime(t) {
    const s = new RegExp("^(application/json|[^;/ 	]+/[^;/ 	]+[+]json)[ 	]*(;.*)?$", "i");
    return t !== null && (s.test(t) || t.toLowerCase() === "application/json-patch+json");
  }
};
const Of = {
  Admin: "admin",
  User: "user",
  Client: "client"
}, Hn = {
  Advanced: "advanced",
  Basic: "basic"
}, Qt = {
  None: 0,
  Weekly: 1,
  Monthly: 2,
  Quarterly: 4,
  SemiAnnually: 8,
  Annually: 16,
  Biennially: 32
}, Va = {
  CapRate: 1,
  CashOnCash: 2,
  IRR: 4,
  CashOnCashAfterTax: 8,
  IRRAfterTax: 16
}, fd = {
  New: "new",
  Pending: "pending",
  Accepted: "accepted",
  Rejected: "rejected"
}, QT = {
  Name: "name",
  LastLogin: "last-login"
}, Il = {
  Unknown: "unknown",
  Investor: "investor",
  ReferralPartner: "referral-partner"
}, Pt = {
  None: 0,
  PurchasePrice: 1,
  PurchaseDate: 2,
  FirstRented: 4,
  Rehab: 8,
  WorkingCapital: 16,
  LoanInfo: 32,
  LoanPaidOffInfo: 64,
  PreviousLoanInfo: 128,
  PreviousLoanPaidOffInfo: 256,
  InvestmentBasis: 512,
  ALL: 1023
}, Rf = {
  Once: "once",
  Repeating: "repeating"
}, Kc = {
  Amount: "amount",
  Percent: "percent"
}, bt = {
  LeadSimple: "lead-simple",
  Zoho: "zoho",
  ActiveCampaign: "active-campaign"
}, Iis = {
  Construction: "construction",
  Cooling: "cooling",
  Fireplace: "fireplace",
  FlooringMaterial: "flooringMaterial",
  Foundation: "foundation",
  Heating: "heating",
  RoofMaterial: "roofMaterial",
  StructureStyle: "structureStyle"
}, Ga = {
  None: 0,
  Investment: 1,
  Residence: 2
}, Oa = {
  None: 0,
  FavoriteProperty: 1,
  AnalyzeOffMarket: 2,
  FinancialAnalysis: 4,
  Unused03: 8,
  AdvancedCalculator: 16,
  GreatSchoolsRating: 32,
  RentVsSell: 64,
  PortfolioInsights: 128,
  PDF: 256,
  ExistingInvestment: 512,
  MarketDataInsights: 1024,
  ViewTaxAssessor: 2048,
  ViewCourthouseRecords: 4096,
  IDX: 8192,
  ViewPreForeclosure: 16384,
  SearchPreForeclosure: 32768,
  SearchMls: 65536,
  Leads: 131072,
  LeadsSearch: 262144,
  LeadsZips: 524288,
  LeadsStates: 1048576,
  LeadsNames: 2097152,
  LeadsAddresses: 4194304,
  Unused04: 8388608,
  Unused05: 16777216,
  LeadsCounties: 33554432,
  PropertyMetrics: 67108864,
  SkipTrace: 134217728,
  BrandedPDF: 268435456,
  BrandedPortal: 536870912,
  ManageClients: 1073741824,
  FeatureProperties: 2147483648,
  FreeRentalAnalysis: 4294967296,
  AddMarketplaceListing: 8589934592,
  ManageSubAccounts: 17179869184,
  Integrations: 34359738368,
  OtherAnalysisStyles: 68719476736,
  BrandPortal: 137438953472,
  ManageIEAccounts: 274877906944,
  FlipCalculator: 549755813888
}, xr = {
  Lis: "lis",
  Nos: "nos",
  Reo: "reo",
  Nts: "nts",
  Nod: "nod"
}, Zp = {
  NotSynced: "not-synced",
  Synced: "synced",
  All: "all"
}, qo = {
  Point: "Point",
  MultiPoint: "MultiPoint",
  Polygon: "Polygon",
  MultiPolygon: "MultiPolygon",
  LineString: "LineString"
}, Ar = {
  Unknown: 0,
  Confirmed: 1,
  Synced: 2,
  Estimated: 4,
  Calculated: 8
}, ln = {
  Income: "income",
  OtherIncome: "otherIncome",
  RentalIncome: "rentalIncome",
  Expense: "expense",
  OtherExpense: "otherExpense",
  PropertyTax: "propertyTax",
  PropertyInsurance: "propertyInsurance",
  Hoa: "hoa",
  PropertyManagement: "propertyManagement",
  LeasingCommissions: "leasingCommissions",
  PlatformServiceFees: "platformServiceFees",
  PropertyMaintenance: "propertyMaintenance",
  UtilityExpenses: "utilityExpenses",
  FurnishingExpenses: "furnishingExpenses",
  ConsumableExpenses: "consumableExpenses",
  CleaningExpenses: "cleaningExpenses",
  LoanPayment: "loanPayment",
  NonOperatingExpense: "nonOperatingExpense",
  OtherNonOperatingExpense: "otherNonOperatingExpense",
  CapitalExpenditures: "capitalExpenditures"
}, Ra = {
  Income: "income",
  Expense: "expense",
  NonOperatingExpense: "nonOperatingExpense"
}, $n = {
  NewPurchase: "newPurchase",
  Flip: "flip",
  RentVsSell: "rentVsSell",
  ExistingInvestment: "existingInvestment"
}, sp = {
  None: 0,
  InvestmentGateway: 1,
  PortfolioInsights: 2
}, Xh = {
  Unknown: "unknown",
  NewlyListed: "newlyListed",
  PriceIncrease: "priceIncrease",
  PriceDecrease: "priceDecrease",
  OptionPending: "optionPending",
  Pending: "pending",
  ReturnToActive: "returnToActive",
  Sold: "sold",
  Removed: "removed"
}, Tis = {
  Unknown: "unknown",
  Incomplete: "incomplete",
  Active: "active",
  OptionPending: "optionPending",
  Pending: "pending",
  Closed: "closed",
  Withdrawn: "withdrawn"
}, Jp = {
  Fixed: "fixed",
  MaxLtv: "max-ltv"
}, Qo = {
  Zip: "zip",
  County: "county"
}, uP = {
  Pending: "pending",
  Accepted: "accepted"
}, Ois = {
  Unknown: "unknown",
  Broker: "broker",
  Agent: "agent"
}, Lf = {
  None: "none",
  Mass: "mass",
  RoundRobin: "roundRobin"
}, Ris = {
  Off: "off",
  Immediate: "immediate",
  After60Minutes: "after60Minutes"
}, iv = {
  ConfirmInvestmentDetails: "confirmInvestmentDetails"
}, Xt = {
  Unknown: "unknown",
  SingleFamily: "singleFamily",
  Commercial: "commercial",
  MultiFamily: "multiFamily",
  MobileHomeParks: "mobileHomeParks",
  Retail: "retail",
  Residential24Family: "residential24Family",
  RvParksCampground: "rvParksCampground",
  SelfStorage: "selfStorage",
  Land: "land",
  Industrial: "industrial"
}, ri = {
  Flat: "flat",
  Percentage: "percentage"
}, Qa = {
  SingleFamily: "singleFamily",
  MultiFamily: "multiFamily",
  Commercial: "commercial"
}, Vt = {
  Cash: "cash",
  CashToPermanentLoan: "cash-to-permanent-loan",
  BridgeToPermanentLoan: "bridge-to-permanent-loan",
  PermanentLoan: "permanent-loan"
}, $p = {
  TotalCost: "total-cost",
  PerSquareFoot: "per-square-foot"
}, dA = {
  TotalAnnualIncome: "totalAnnualIncome",
  MonthlyLessVacancy: "monthlyLessVacancy"
}, Ut = {
  LongTerm: "long-term",
  ShortTerm: "short-term",
  PadSplit: "pad-split"
}, nt = {
  None: 0,
  LongTerm: 1,
  ShortTerm: 2,
  PadSplit: 4
}, cA = {
  Unspecified: "unspecified",
  Hourly: "hourly",
  TwiceDaily: "twiceDaily",
  Daily: "daily",
  Weekly: "weekly"
}, de = {
  Success: "success",
  Failure: "failure",
  Error: "error"
}, pP = {
  Zip: "zip",
  Names: "names",
  Address: "address",
  State: "state",
  County: "county"
}, Or = {
  Unknown: "unknown",
  GeoArea: "geoArea",
  Zip: "zip",
  Map: "map",
  County: "county",
  Featured: "featured"
}, KT = {
  Asc: "asc",
  Desc: "desc"
}, U = {
  None: 0,
  RentalIncome: 1,
  OtherIncome: 2,
  PropertyTax: 4,
  PropertyInsurance: 8,
  AssociationFees: 16,
  PropertyManagement: 32,
  LeasingCommissions: 64,
  LeaseRenewalFee: 128,
  PlatformServiceFees: 256,
  PropertyMaintenance: 512,
  UtilityExpenses: 1024,
  FurnishingExpenses: 2048,
  ConsumableExpenses: 4096,
  CleaningExpenses: 8192,
  OtherExpense: 16384,
  OtherNonOperatingExpense: 32768,
  CapitalExpenditures: 65536
}, lv = {
  Before: "before",
  After: "after"
}, _p = {
  None: "none",
  PropertySuitePro: "property-suite-pro",
  RosterMemberOnly: "roster-member-only"
}, ur = 2147483648, vo = 1073741824, ZT = 1073741823, _n = {
  UnknownError: 0,
  UnknownFriendlyError: 1,
  NotFound: 3,
  InvalidPurchasePrice: 4,
  AccessDenied: 6,
  InvalidLoanInfo: 7,
  InvalidPropertyValue: 8,
  UnitsError: 9,
  InvalidPurchaseDate: 10,
  ServiceNotRegistered: 11,
  CrmError: 12,
  CrmPipelineNotFound: 13,
  CrmStageNotFound: 14,
  CrmUserNotFound: 15,
  CrmLeadNotFound: 16,
  CrmCampaignNotFound: 17,
  CrmConnectionError: 18,
  //#region Calculator Errors (10,000 - 20,000)
  CalculatorError: 1e4 | ur,
  ExistingInvestmentError: 10001 | ur,
  InvalidRentalRate: 10002 | ur,
  BookingFeesZero: 10003 | vo,
  AverageLengthOfStayZero: 10004 | vo,
  RentalRate: 10005 | vo,
  //#region Income & Expense Account Errors (10,100 - 10,399)
  IncomeExpenseAccountError: 10100 | ur,
  IncomeExpenseAccountNotSet: 10101 | vo,
  //#endregion
  //#region Financial History Errors (10,500 - 10,799)
  FinancialHistoryError: 10500 | ur,
  FinancialHistoryLoanError: 10501 | ur,
  FinancialHistoryLoanInfoNotSet: 10502 | vo,
  FinancialHistoryPurchasePriceError: 10503 | ur,
  FinancialHistoryRentalRateNotSet: 10504 | vo,
  FinancialHistoryRentalRateError: 10505 | ur,
  FinancialHistoryPropertyValueNotSet: 10506 | vo,
  FinancialHistoryPropertyValueError: 10507 | ur
  //#endregion
  //#endregion
};
function pi(e) {
  return (e & 1073741823) >= 10100 && (e & 1073741823) < 10400;
}
function uA(e) {
  return e != null && (e & vo) === vo;
}
function pA(e) {
  return e != null && (e & ur) === ur;
}
function hA(e) {
  return e & ZT;
}
const mA = "RescoverException";
class Le extends Error {
  constructor(s, n, r) {
    var t = (...ccs) => (super(...ccs), Xe(this, "typeOf", mA), Xe(this, "handled"), Xe(this, "errorId"), Xe(this, "properties"), Xe(this, "status"), Xe(this, "statusText"), this);
    if (typeof s == "object" && hP(s))
      if (Le.hasRescoverErrorId(s.data))
        t(s.data.message), this.errorId = s.data.errorId ?? _n.UnknownError, this.properties = s.data.properties, this.status = s.status, this.statusText = s.statusText;
      else if (Le.hasRescoverError(s.data) || Le.hasRescoverWarning(s.data))
        t(s.data.message), this.errorId = n ?? _n.UnknownError, this.properties = r, this.status = s.status, this.statusText = s.statusText;
      else
        throw new Error("Invalid Exception. Use isRescoverError to test object first.");
    else
      t(s), this.errorId = n ?? _n.UnknownError, this.properties = r;
    Object.setPrototypeOf(this, new.target.prototype);
  }
  static hasRescoverErrorId(s) {
    return s !== null && typeof s == "object" && "errorId" in s;
  }
  static hasRescoverError(s) {
    return s !== null && typeof s == "object" && "message" in s && "status" in s && (s.status == "error" || s.status == "failure");
  }
  static hasRescoverWarning(s) {
    return s !== null && typeof s == "object" && "message" in s && "status" in s && s.status == "warning";
  }
  static isRescoverError(s) {
    return s !== null && typeof s == "object" && "typeOf" in s && s.typeOf == mA;
  }
  static createInterceptor(s) {
    return s.interceptors.response.use(
      (n) => n,
      (n) => {
        if (Yh(n) && n.response && (Le.hasRescoverError(n.response.data) || Le.hasRescoverErrorId(n.response.data)))
          throw new Le(n.response);
        return Promise.reject(n);
      }
    );
  }
}
function hP(e) {
  return e !== null && typeof e == "object" && "request" in e && "data" in e;
}
class Zt extends Error {
  constructor(s, n) {
    var t = (...ucs) => (super(...ucs), Xe(this, "traceId"), Xe(this, "errors"), Xe(this, "status"), Xe(this, "title"), this);
    var r, i, o, l, d;
    if (Zt.isModelStateAxiosError(s))
      t((r = s.response) == null ? void 0 : r.data.title), this.traceId = (i = s.response) == null ? void 0 : i.data.traceId, this.status = (o = s.response) == null ? void 0 : o.data.status, this.title = (l = s.response) == null ? void 0 : l.data.title, this.errors = (d = s.response) == null ? void 0 : d.data.errors;
    else if (Zt.isModelStateException(s))
      t(s.title), this.traceId = s.traceId, this.status = s.status, this.title = s.title, this.errors = s.errors;
    else if (s && typeof s == "string" && n)
      t(s), this.title = s, this.errors = n;
    else
      throw new Error("Invalid ModelStateException. Use isModelStateException to test object first.");
    Object.setPrototypeOf(this, new.target.prototype);
  }
  static isModelStateException(s) {
    return s !== null && typeof s == "object" && ("traceId" in s && "status" in s || Object.getPrototypeOf(s) == Zt.prototype);
  }
  static isModelStateAxiosError(s) {
    return s !== null && Yh(s) && typeof s.response.data == "object" && "traceId" in s.response.data && "status" in s.response.data;
  }
  static clearModelStateErrors(s) {
    s ?? (s = document), s.querySelectorAll("[data-val-summary]").forEach((n) => n.classList.add("d-none")), s.querySelectorAll("[data-model-state].is-invalid").forEach((n) => n.classList.remove("is-invalid"));
  }
  showFormErrors(s, n = !0, r = 4) {
    if (!this.errors && !this.title) return !1;
    let i = null, o = !1;
    if (typeof s == "string")
      i = document.querySelector(s);
    else if ((fA(s) || gA(s)) && JT(s)) {
      const u = s.dataset.validate;
      u && (i = s.closest(u), i ?? (i = s.ownerDocument.querySelector(u)), o = s.dataset.summary == "true");
    } else if (gA(s) || fA(s)) {
      const u = s.closest(".card");
      if (u) {
        const m = e9(s, u);
        m >= 0 && m <= r && (i = u);
      }
      i ?? (i = s.closest(".modal")), i ?? (i = s.closest("body")), i && (o = s.dataset.summary == "true");
    } else s instanceof Element && (i = s);
    if (!i || !("querySelectorAll" in i))
      return console.warn("Parent element not found", s), !1;
    i.querySelectorAll("[data-model-state].is-invalid").forEach((u) => u.classList.remove("is-invalid")), console.info("Parent element found", i), i && i.dataset.summary == "true" && (o = !0);
    let l = !1, d = !1;
    const c = [];
    if (this.errors)
      for (const u in this.errors) {
        if (this.errors[u].length == 0) continue;
        const m = $T(CSS.escape(u));
        let f = i.querySelector(`[data-val-id=${m}]`);
        f ?? (f = i.querySelector(`#${CSS.escape(m)}`)), f ? d = Zt.setFieldInvalid(f, this.errors[u][0]) : (console.warn(`Could not find input field with data-val-id ${m} or id ${m}!`, this.errors[u][0]), c.some((v) => v == this.errors[u][0]) == !1 && c.push(this.errors[u][0]));
      }
    if (this.title && (i.querySelectorAll("[data-val-summary]").forEach((u) => {
      vA(u, this.title, c, d) && (l = !0);
    }), n && !l && !d && (i.classList.contains("card") || i.classList.contains("modal")) || o && !l)) {
      const u = o ? i : i.querySelector(".card-body") ?? i.querySelector(".modal-body"), m = _T(u);
      m && (l = vA(m, this.title, c, d));
    }
    return d || l;
  }
  static setFieldInvalid(s, n) {
    var r, i, o;
    if ((((r = s.parentElement) == null ? void 0 : r.classList.contains("check-group")) == !0 || ((i = s.parentElement) == null ? void 0 : i.classList.contains("input-group")) == !0) && (s.dataset.modelState = "true", s.classList.add("is-invalid"), s = s.parentElement), ((o = s.nextElementSibling) == null ? void 0 : o.tagName) == "DIV" && s.nextElementSibling.dataset.validation == "true")
      return s.dataset.modelState = "true", s.classList.add("is-invalid"), s.nextElementSibling.classList.add("invalid-feedback"), s.nextElementSibling.innerText = n, !0;
    {
      s.dataset.modelState = "true";
      const l = document.createElement("div");
      return l.setAttribute("data-validation", "true"), l.classList.add("invalid-feedback"), l.innerText = n, s.classList.add("is-invalid"), s.insertAdjacentElement("afterend", l), !0;
    }
  }
  static createInterceptor(s) {
    return s.interceptors.response.use(
      (n) => (Zt.clearModelStateErrors(), n),
      (n) => {
        if (Yh(n) && n.response && Zt.isModelStateException(n.response.data))
          throw new Zt(n);
        return Promise.reject(n);
      }
    );
  }
}
function fA(e) {
  return e !== null && typeof e == "object" && "tagName" in e && e.tagName == "BUTTON";
}
function gA(e) {
  return e !== null && typeof e == "object" && "tagName" in e && e.tagName == "A";
}
function JT(e) {
  return "validate" in e.dataset && typeof e.dataset.validate == "string";
}
function $T(e) {
  return e.replace(/(?:^\w|[A-Z]|\b\w)/g, function(t, s) {
    return s == 0 ? t.toLowerCase() : t.toUpperCase();
  }).replace(/\s+/g, "");
}
function vA(e, t, s, n = !1) {
  if (!e) return !1;
  if (e.innerHTML = "", e.classList.contains("d-none") && e.classList.remove("d-none"), e.innerText = t, n && (e.innerText += " Please review the form fields and correct any issue."), s && s.length > 0) {
    const r = document.createElement("ul");
    s.forEach((i) => {
      const o = document.createElement("li");
      o.innerText = i, r.appendChild(o);
    }), e.appendChild(r);
  }
  return !0;
}
function _T(e) {
  if (!e) return;
  const t = document.createElement("div");
  return t.role = "alert", t.classList.add("alert", "alert-danger", "d-none"), t.setAttribute("data-val-summary", "true"), e.classList.contains("modal-body") ? (t.classList.add("mt-3"), e.append(t)) : (t.classList.add("mb-3"), e.prepend(t)), t;
}
function e9(e, t) {
  let s = 0, n = e;
  for (; n && n !== t && n !== document.body; )
    n = n.parentElement, s++;
  return n === t ? s : -1;
}
const t9 = {
  statusCodes: [401],
  pauseInstanceWhileRefreshing: !1
};
function s9(e, t) {
  return {
    ...e,
    pauseInstanceWhileRefreshing: t.skipWhileRefreshing,
    ...t
  };
}
function a9(e, t, s, n) {
  var r, i;
  return !e || (r = e.config) != null && r.skipAuthRefresh || !(t.interceptNetworkError && !e.response && e.request.status === 0) && (!e.response || (t != null && t.shouldRefresh ? !t.shouldRefresh(e) : !((i = t.statusCodes) != null && i.includes(parseInt(e.response.status))))) ? !1 : (e.response || (e.response = {
    config: e.config
  }), !t.pauseInstanceWhileRefreshing || !n.skipInstances.includes(s));
}
function n9(e, t, s) {
  return !s.refreshCall && (s.refreshCall = t(e), typeof s.refreshCall.then != "function") ? (console.warn("axios-auth-refresh requires `refreshTokenCall` to return a promise."), Promise.reject()) : s.refreshCall;
}
function r9(e, t, s) {
  return typeof t.requestQueueInterceptorId > "u" && (t.requestQueueInterceptorId = e.interceptors.request.use((n) => t.refreshCall.catch(() => {
    throw new X.Cancel("Request call failed");
  }).then(() => s.onRetry ? s.onRetry(n) : n))), t.requestQueueInterceptorId;
}
function o9(e, t) {
  e.interceptors.request.eject(t.requestQueueInterceptorId), t.requestQueueInterceptorId = void 0, t.refreshCall = void 0, t.skipInstances = t.skipInstances.filter((s) => s !== e);
}
function i9(e, t) {
  return t.retryInstance || e;
}
function l9(e, t) {
  return e.config.skipAuthRefresh = !0, t(e.response.config);
}
function d9(e, t, s = {}) {
  if (typeof t != "function")
    throw new Error("axios-auth-refresh requires `refreshAuthCall` to be a function that returns a promise.");
  const n = {
    skipInstances: [],
    refreshCall: void 0,
    requestQueueInterceptorId: void 0
  };
  return e.interceptors.response.use(
    (r) => r,
    (r) => {
      if (s = s9(t9, s), !a9(r, s, e, n))
        return Promise.reject(r);
      s.pauseInstanceWhileRefreshing && n.skipInstances.push(e);
      const i = n9(r, t, n);
      return r9(e, n, s), i.catch((o) => Promise.reject(o)).then(() => l9(r, i9(e, s))).finally(() => o9(e, n));
    }
  );
}
var c9 = /* @__PURE__ */ Object.freeze({
  __proto__: null
});
const mP = (e) => encodeURIComponent(e).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape), fP = (e) => encodeURIComponent(e).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent), s1 = decodeURIComponent, a1 = (e) => (e[0] === '"' && (e = e.slice(1, -1)), e.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent));
function u9(e) {
  return e = Object.assign({}, e), typeof e.expires == "number" && (e.expires = new Date(Date.now() + e.expires * 864e5)), e.expires != null && (e.expires = e.expires.toUTCString()), Object.entries(e).filter(([t, s]) => s != null && s !== !1).map(([t, s]) => s === !0 ? `; ${t}` : `; ${t}=${s.split(";")[0]}`).join("");
}
function gP(e, t, s) {
  const n = /(?:^|; )([^=]*)=([^;]*)/g, r = {};
  let i;
  for (; (i = n.exec(document.cookie)) != null; )
    try {
      const o = s(i[1]);
      if (r[o] = t(i[2], o), e === o)
        break;
    } catch {
    }
  return e != null ? r[e] : r;
}
const dv = Object.freeze({
  decodeName: s1,
  decodeValue: a1,
  encodeName: mP,
  encodeValue: fP
}), Dm = Object.freeze({
  path: "/"
});
function eo(e, t, s = Dm, { encodeValue: n = fP, encodeName: r = mP } = {}) {
  return document.cookie = `${r(e)}=${n(t, e)}${u9(s)}`;
}
function Go(e, { decodeValue: t = a1, decodeName: s = s1 } = {}) {
  return gP(e, t, s);
}
function vP({ decodeValue: e = a1, decodeName: t = s1 } = {}) {
  return gP(void 0, e, t);
}
function yP(e, t = Dm) {
  eo(e, "", Object.assign({}, t, {
    expires: -1
  }));
}
function cv(e, t) {
  const s = {
    set: function(r, i, o) {
      return eo(r, i, Object.assign({}, this.attributes, o), {
        encodeValue: this.converter.write
      });
    },
    get: function(r) {
      if (arguments.length === 0)
        return vP(this.converter.read);
      if (r != null)
        return Go(r, this.converter.read);
    },
    remove: function(r, i) {
      yP(r, Object.assign({}, this.attributes, i));
    },
    withAttributes: function(r) {
      return cv(this.converter, Object.assign({}, this.attributes, r));
    },
    withConverter: function(r) {
      return cv(Object.assign({}, this.converter, r), this.attributes);
    }
  }, n = {
    attributes: { value: Object.freeze(t) },
    converter: { value: Object.freeze(e) }
  };
  return Object.create(s, n);
}
var p9 = cv({ read: dv.decodeValue, write: dv.encodeValue }, Dm);
const h9 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Cookies: p9,
  DEFAULT_ATTRIBUTES: Dm,
  DEFAULT_CODEC: dv,
  Types: c9,
  getCookie: Go,
  getCookies: vP,
  removeCookie: yP,
  setCookie: eo
}, Symbol.toStringTag, { value: "Module" })), $a = [];
for (let e = 0; e < 256; ++e)
  $a.push((e + 256).toString(16).slice(1));
function m9(e, t = 0) {
  return ($a[e[t + 0]] + $a[e[t + 1]] + $a[e[t + 2]] + $a[e[t + 3]] + "-" + $a[e[t + 4]] + $a[e[t + 5]] + "-" + $a[e[t + 6]] + $a[e[t + 7]] + "-" + $a[e[t + 8]] + $a[e[t + 9]] + "-" + $a[e[t + 10]] + $a[e[t + 11]] + $a[e[t + 12]] + $a[e[t + 13]] + $a[e[t + 14]] + $a[e[t + 15]]).toLowerCase();
}
let Bf;
const f9 = new Uint8Array(16);
function g9() {
  if (!Bf) {
    if (typeof crypto > "u" || !crypto.getRandomValues)
      throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    Bf = crypto.getRandomValues.bind(crypto);
  }
  return Bf(f9);
}
const v9 = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), yA = { randomUUID: v9 };
function n1(e, t, s) {
  var r;
  if (yA.randomUUID && !e)
    return yA.randomUUID();
  e = e || {};
  const n = e.random ?? ((r = e.rng) == null ? void 0 : r.call(e)) ?? g9();
  if (n.length < 16)
    throw new Error("Random bytes length must be >= 16");
  return n[6] = n[6] & 15 | 64, n[8] = n[8] & 63 | 128, m9(n);
}
const zt = typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__, As = globalThis, Zi = "9.40.0";
function ml() {
  return Nm(As), As;
}
function Nm(e) {
  const t = e.__SENTRY__ = e.__SENTRY__ || {};
  return t.version = t.version || Zi, t[Zi] = t[Zi] || {};
}
function Lu(e, t, s = As) {
  const n = s.__SENTRY__ = s.__SENTRY__ || {}, r = n[Zi] = n[Zi] || {};
  return r[e] || (r[e] = t());
}
const y9 = [
  "debug",
  "info",
  "warn",
  "error",
  "log",
  "assert",
  "trace"
], b9 = "Sentry Logger ", qh = {};
function Yo(e) {
  if (!("console" in As))
    return e();
  const t = As.console, s = {}, n = Object.keys(qh);
  n.forEach((r) => {
    const i = qh[r];
    s[r] = t[r], t[r] = i;
  });
  try {
    return e();
  } finally {
    n.forEach((r) => {
      t[r] = s[r];
    });
  }
}
function A9() {
  o1().enabled = !0;
}
function w9() {
  o1().enabled = !1;
}
function bP() {
  return o1().enabled;
}
function C9(...e) {
  r1("log", ...e);
}
function S9(...e) {
  r1("warn", ...e);
}
function P9(...e) {
  r1("error", ...e);
}
function r1(e, ...t) {
  zt && bP() && Yo(() => {
    As.console[e](`${b9}[${e}]:`, ...t);
  });
}
function o1() {
  return zt ? Lu("loggerSettings", () => ({ enabled: !1 })) : { enabled: !1 };
}
const ot = {
  /** Enable logging. */
  enable: A9,
  /** Disable logging. */
  disable: w9,
  /** Check if logging is enabled. */
  isEnabled: bP,
  /** Log a message. */
  log: C9,
  /** Log a warning. */
  warn: S9,
  /** Log an error. */
  error: P9
}, AP = 50, al = "?", bA = /\(error: (.*)\)/, AA = /captureMessage|captureException/;
function wP(...e) {
  const t = e.sort((s, n) => s[0] - n[0]).map((s) => s[1]);
  return (s, n = 0, r = 0) => {
    const i = [], o = s.split(`
`);
    for (let l = n; l < o.length; l++) {
      const d = o[l];
      if (d.length > 1024)
        continue;
      const c = bA.test(d) ? d.replace(bA, "$1") : d;
      if (!c.match(/\S*Error: /)) {
        for (const u of t) {
          const m = u(c);
          if (m) {
            i.push(m);
            break;
          }
        }
        if (i.length >= AP + r)
          break;
      }
    }
    return E9(i.slice(r));
  };
}
function k9(e) {
  return Array.isArray(e) ? wP(...e) : e;
}
function E9(e) {
  if (!e.length)
    return [];
  const t = Array.from(e);
  return /sentryWrapped/.test(ap(t).function || "") && t.pop(), t.reverse(), AA.test(ap(t).function || "") && (t.pop(), AA.test(ap(t).function || "") && t.pop()), t.slice(0, AP).map((s) => ({
    ...s,
    filename: s.filename || ap(t).filename,
    function: s.function || al
  }));
}
function ap(e) {
  return e[e.length - 1] || {};
}
const Mf = "<anonymous>";
function Lo(e) {
  try {
    return !e || typeof e != "function" ? Mf : e.name || Mf;
  } catch {
    return Mf;
  }
}
function uv(e) {
  const t = e.exception;
  if (t) {
    const s = [];
    try {
      return t.values.forEach((n) => {
        n.stacktrace.frames && s.push(...n.stacktrace.frames);
      }), s;
    } catch {
      return;
    }
  }
}
const eh = {}, wA = {};
function Ri(e, t) {
  eh[e] = eh[e] || [], eh[e].push(t);
}
function Li(e, t) {
  if (!wA[e]) {
    wA[e] = !0;
    try {
      t();
    } catch (s) {
      zt && ot.error(`Error while instrumenting ${e}`, s);
    }
  }
}
function nr(e, t) {
  const s = e && eh[e];
  if (s)
    for (const n of s)
      try {
        n(t);
      } catch (r) {
        zt && ot.error(
          `Error while triggering instrumentation handler.
Type: ${e}
Name: ${Lo(n)}
Error:`,
          r
        );
      }
}
let xf = null;
function CP(e) {
  const t = "error";
  Ri(t, e), Li(t, I9);
}
function I9() {
  xf = As.onerror, As.onerror = function(e, t, s, n, r) {
    return nr("error", {
      column: n,
      error: r,
      line: s,
      msg: e,
      url: t
    }), xf ? xf.apply(this, arguments) : !1;
  }, As.onerror.__SENTRY_INSTRUMENTED__ = !0;
}
let Ff = null;
function SP(e) {
  const t = "unhandledrejection";
  Ri(t, e), Li(t, T9);
}
function T9() {
  Ff = As.onunhandledrejection, As.onunhandledrejection = function(e) {
    return nr("unhandledrejection", e), Ff ? Ff.apply(this, arguments) : !0;
  }, As.onunhandledrejection.__SENTRY_INSTRUMENTED__ = !0;
}
const PP = Object.prototype.toString;
function i1(e) {
  switch (PP.call(e)) {
    case "[object Error]":
    case "[object Exception]":
    case "[object DOMException]":
    case "[object WebAssembly.Exception]":
      return !0;
    default:
      return Bo(e, Error);
  }
}
function zd(e, t) {
  return PP.call(e) === `[object ${t}]`;
}
function kP(e) {
  return zd(e, "ErrorEvent");
}
function CA(e) {
  return zd(e, "DOMError");
}
function O9(e) {
  return zd(e, "DOMException");
}
function Eo(e) {
  return zd(e, "String");
}
function l1(e) {
  return typeof e == "object" && e !== null && "__sentry_template_string__" in e && "__sentry_template_values__" in e;
}
function du(e) {
  return e === null || l1(e) || typeof e != "object" && typeof e != "function";
}
function cu(e) {
  return zd(e, "Object");
}
function jm(e) {
  return typeof Event < "u" && Bo(e, Event);
}
function R9(e) {
  return typeof Element < "u" && Bo(e, Element);
}
function L9(e) {
  return zd(e, "RegExp");
}
function Bu(e) {
  return !!(e != null && e.then && typeof e.then == "function");
}
function B9(e) {
  return cu(e) && "nativeEvent" in e && "preventDefault" in e && "stopPropagation" in e;
}
function Bo(e, t) {
  try {
    return e instanceof t;
  } catch {
    return !1;
  }
}
function EP(e) {
  return !!(typeof e == "object" && e !== null && (e.__isVue || e._isVue));
}
function IP(e) {
  return typeof Request < "u" && Bo(e, Request);
}
const d1 = As, M9 = 80;
function or(e, t = {}) {
  if (!e)
    return "<unknown>";
  try {
    let s = e;
    const n = 5, r = [];
    let i = 0, o = 0;
    const l = " > ", d = l.length;
    let c;
    const u = Array.isArray(t) ? t : t.keyAttrs, m = !Array.isArray(t) && t.maxStringLength || M9;
    for (; s && i++ < n && (c = x9(s, u), !(c === "html" || i > 1 && o + r.length * d + c.length >= m)); )
      r.push(c), o += c.length, s = s.parentNode;
    return r.reverse().join(l);
  } catch {
    return "<unknown>";
  }
}
function x9(e, t) {
  const s = e, n = [];
  if (!(s != null && s.tagName))
    return "";
  if (d1.HTMLElement && s instanceof HTMLElement && s.dataset) {
    if (s.dataset.sentryComponent)
      return s.dataset.sentryComponent;
    if (s.dataset.sentryElement)
      return s.dataset.sentryElement;
  }
  n.push(s.tagName.toLowerCase());
  const r = t != null && t.length ? t.filter((o) => s.getAttribute(o)).map((o) => [o, s.getAttribute(o)]) : null;
  if (r != null && r.length)
    r.forEach((o) => {
      n.push(`[${o[0]}="${o[1]}"]`);
    });
  else {
    s.id && n.push(`#${s.id}`);
    const o = s.className;
    if (o && Eo(o)) {
      const l = o.split(/\s+/);
      for (const d of l)
        n.push(`.${d}`);
    }
  }
  const i = ["aria-label", "type", "name", "title", "alt"];
  for (const o of i) {
    const l = s.getAttribute(o);
    l && n.push(`[${o}="${l}"]`);
  }
  return n.join("");
}
function fl() {
  try {
    return d1.document.location.href;
  } catch {
    return "";
  }
}
function TP(e) {
  if (!d1.HTMLElement)
    return null;
  let t = e;
  const s = 5;
  for (let n = 0; n < s; n++) {
    if (!t)
      return null;
    if (t instanceof HTMLElement) {
      if (t.dataset.sentryComponent)
        return t.dataset.sentryComponent;
      if (t.dataset.sentryElement)
        return t.dataset.sentryElement;
    }
    t = t.parentNode;
  }
  return null;
}
function Qh(e, t = 0) {
  return typeof e != "string" || t === 0 || e.length <= t ? e : `${e.slice(0, t)}...`;
}
function SA(e, t) {
  if (!Array.isArray(e))
    return "";
  const s = [];
  for (let n = 0; n < e.length; n++) {
    const r = e[n];
    try {
      EP(r) ? s.push("[VueViewModel]") : s.push(String(r));
    } catch {
      s.push("[value cannot be serialized]");
    }
  }
  return s.join(t);
}
function F9(e, t, s = !1) {
  return Eo(e) ? L9(t) ? t.test(e) : Eo(t) ? s ? e === t : e.includes(t) : !1 : !1;
}
function Io(e, t = [], s = !1) {
  return t.some((n) => F9(e, n, s));
}
function In(e, t, s) {
  if (!(t in e))
    return;
  const n = e[t];
  if (typeof n != "function")
    return;
  const r = s(n);
  typeof r == "function" && OP(r, n);
  try {
    e[t] = r;
  } catch {
    zt && ot.log(`Failed to replace method "${t}" in object`, e);
  }
}
function Un(e, t, s) {
  try {
    Object.defineProperty(e, t, {
      // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
      value: s,
      writable: !0,
      configurable: !0
    });
  } catch {
    zt && ot.log(`Failed to add non-enumerable property "${t}" to object`, e);
  }
}
function OP(e, t) {
  try {
    const s = t.prototype || {};
    e.prototype = t.prototype = s, Un(e, "__sentry_original__", t);
  } catch {
  }
}
function c1(e) {
  return e.__sentry_original__;
}
function RP(e) {
  if (i1(e))
    return {
      message: e.message,
      name: e.name,
      stack: e.stack,
      ...kA(e)
    };
  if (jm(e)) {
    const t = {
      type: e.type,
      target: PA(e.target),
      currentTarget: PA(e.currentTarget),
      ...kA(e)
    };
    return typeof CustomEvent < "u" && Bo(e, CustomEvent) && (t.detail = e.detail), t;
  } else
    return e;
}
function PA(e) {
  try {
    return R9(e) ? or(e) : Object.prototype.toString.call(e);
  } catch {
    return "<unknown>";
  }
}
function kA(e) {
  if (typeof e == "object" && e !== null) {
    const t = {};
    for (const s in e)
      Object.prototype.hasOwnProperty.call(e, s) && (t[s] = e[s]);
    return t;
  } else
    return {};
}
function V9(e, t = 40) {
  const s = Object.keys(RP(e));
  s.sort();
  const n = s[0];
  if (!n)
    return "[object has no keys]";
  if (n.length >= t)
    return Qh(n, t);
  for (let r = s.length; r > 0; r--) {
    const i = s.slice(0, r).join(", ");
    if (!(i.length > t))
      return r === s.length ? i : Qh(i, t);
  }
  return "";
}
function D9() {
  const e = As;
  return e.crypto || e.msCrypto;
}
function gn(e = D9()) {
  let t = () => Math.random() * 16;
  try {
    if (e != null && e.randomUUID)
      return e.randomUUID().replace(/-/g, "");
    e != null && e.getRandomValues && (t = () => {
      const s = new Uint8Array(1);
      return e.getRandomValues(s), s[0];
    });
  } catch {
  }
  return ("10000000100040008000" + 1e11).replace(
    /[018]/g,
    (s) => (
      // eslint-disable-next-line no-bitwise
      (s ^ (t() & 15) >> s / 4).toString(16)
    )
  );
}
function LP(e) {
  var t, s;
  return (s = (t = e.exception) == null ? void 0 : t.values) == null ? void 0 : s[0];
}
function ji(e) {
  const { message: t, event_id: s } = e;
  if (t)
    return t;
  const n = LP(e);
  return n ? n.type && n.value ? `${n.type}: ${n.value}` : n.type || n.value || s || "<unknown>" : s || "<unknown>";
}
function pv(e, t, s) {
  const n = e.exception = e.exception || {}, r = n.values = n.values || [], i = r[0] = r[0] || {};
  i.value || (i.value = t || ""), i.type || (i.type = "Error");
}
function gd(e, t) {
  const s = LP(e);
  if (!s)
    return;
  const n = { type: "generic", handled: !0 }, r = s.mechanism;
  if (s.mechanism = { ...n, ...r, ...t }, t && "data" in t) {
    const i = { ...r == null ? void 0 : r.data, ...t.data };
    s.mechanism.data = i;
  }
}
function EA(e) {
  if (N9(e))
    return !0;
  try {
    Un(e, "__sentry_captured__", !0);
  } catch {
  }
  return !1;
}
function N9(e) {
  try {
    return e.__sentry_captured__;
  } catch {
  }
}
const BP = 1e3;
function gl() {
  return Date.now() / BP;
}
function j9() {
  const { performance: e } = As;
  if (!(e != null && e.now) || !e.timeOrigin)
    return gl;
  const t = e.timeOrigin;
  return () => (t + e.now()) / BP;
}
let IA;
function Ea() {
  return (IA ?? (IA = j9()))();
}
let Vf;
function H9() {
  var u;
  const { performance: e } = As;
  if (!(e != null && e.now))
    return [void 0, "none"];
  const t = 3600 * 1e3, s = e.now(), n = Date.now(), r = e.timeOrigin ? Math.abs(e.timeOrigin + s - n) : t, i = r < t, o = (u = e.timing) == null ? void 0 : u.navigationStart, d = typeof o == "number" ? Math.abs(o + s - n) : t, c = d < t;
  return i || c ? r <= d ? [e.timeOrigin, "timeOrigin"] : [o, "navigationStart"] : [n, "dateNow"];
}
function on() {
  return Vf || (Vf = H9()), Vf[0];
}
function U9(e) {
  const t = Ea(), s = {
    sid: gn(),
    init: !0,
    timestamp: t,
    started: t,
    duration: 0,
    status: "ok",
    errors: 0,
    ignoreDuration: !1,
    toJSON: () => W9(s)
  };
  return e && vd(s, e), s;
}
function vd(e, t = {}) {
  if (t.user && (!e.ipAddress && t.user.ip_address && (e.ipAddress = t.user.ip_address), !e.did && !t.did && (e.did = t.user.id || t.user.email || t.user.username)), e.timestamp = t.timestamp || Ea(), t.abnormal_mechanism && (e.abnormal_mechanism = t.abnormal_mechanism), t.ignoreDuration && (e.ignoreDuration = t.ignoreDuration), t.sid && (e.sid = t.sid.length === 32 ? t.sid : gn()), t.init !== void 0 && (e.init = t.init), !e.did && t.did && (e.did = `${t.did}`), typeof t.started == "number" && (e.started = t.started), e.ignoreDuration)
    e.duration = void 0;
  else if (typeof t.duration == "number")
    e.duration = t.duration;
  else {
    const s = e.timestamp - e.started;
    e.duration = s >= 0 ? s : 0;
  }
  t.release && (e.release = t.release), t.environment && (e.environment = t.environment), !e.ipAddress && t.ipAddress && (e.ipAddress = t.ipAddress), !e.userAgent && t.userAgent && (e.userAgent = t.userAgent), typeof t.errors == "number" && (e.errors = t.errors), t.status && (e.status = t.status);
}
function z9(e, t) {
  let s = {};
  e.status === "ok" && (s = { status: "exited" }), vd(e, s);
}
function W9(e) {
  return {
    sid: `${e.sid}`,
    init: e.init,
    // Make sure that sec is converted to ms for date constructor
    started: new Date(e.started * 1e3).toISOString(),
    timestamp: new Date(e.timestamp * 1e3).toISOString(),
    status: e.status,
    errors: e.errors,
    did: typeof e.did == "number" || typeof e.did == "string" ? `${e.did}` : void 0,
    duration: e.duration,
    abnormal_mechanism: e.abnormal_mechanism,
    attrs: {
      release: e.release,
      environment: e.environment,
      ip_address: e.ipAddress,
      user_agent: e.userAgent
    }
  };
}
function Mu(e, t, s = 2) {
  if (!t || typeof t != "object" || s <= 0)
    return t;
  if (e && Object.keys(t).length === 0)
    return e;
  const n = { ...e };
  for (const r in t)
    Object.prototype.hasOwnProperty.call(t, r) && (n[r] = Mu(n[r], t[r], s - 1));
  return n;
}
function vi() {
  return gn();
}
function xu() {
  return gn().substring(16);
}
const hv = "_sentrySpan";
function yd(e, t) {
  t ? Un(e, hv, t) : delete e[hv];
}
function Kh(e) {
  return e[hv];
}
const G9 = 100;
class Wr {
  /** Flag if notifying is happening. */
  /** Callback for client to receive scope changes. */
  /** Callback list that will be called during event processing. */
  /** Array of breadcrumbs. */
  /** User */
  /** Tags */
  /** Extra */
  /** Contexts */
  /** Attachments */
  /** Propagation Context for distributed tracing */
  /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */
  /** Fingerprint */
  /** Severity */
  /**
   * Transaction Name
   *
   * IMPORTANT: The transaction name on the scope has nothing to do with root spans/transaction objects.
   * It's purpose is to assign a transaction to the scope that's added to non-transaction events.
   */
  /** Session */
  /** The client on this scope */
  /** Contains the last event id of a captured event.  */
  // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
  constructor() {
    this._notifyingListeners = !1, this._scopeListeners = [], this._eventProcessors = [], this._breadcrumbs = [], this._attachments = [], this._user = {}, this._tags = {}, this._extra = {}, this._contexts = {}, this._sdkProcessingMetadata = {}, this._propagationContext = {
      traceId: vi(),
      sampleRand: Math.random()
    };
  }
  /**
   * Clone all data from this scope into a new scope.
   */
  clone() {
    const t = new Wr();
    return t._breadcrumbs = [...this._breadcrumbs], t._tags = { ...this._tags }, t._extra = { ...this._extra }, t._contexts = { ...this._contexts }, this._contexts.flags && (t._contexts.flags = {
      values: [...this._contexts.flags.values]
    }), t._user = this._user, t._level = this._level, t._session = this._session, t._transactionName = this._transactionName, t._fingerprint = this._fingerprint, t._eventProcessors = [...this._eventProcessors], t._attachments = [...this._attachments], t._sdkProcessingMetadata = { ...this._sdkProcessingMetadata }, t._propagationContext = { ...this._propagationContext }, t._client = this._client, t._lastEventId = this._lastEventId, yd(t, Kh(this)), t;
  }
  /**
   * Update the client assigned to this scope.
   * Note that not every scope will have a client assigned - isolation scopes & the global scope will generally not have a client,
   * as well as manually created scopes.
   */
  setClient(t) {
    this._client = t;
  }
  /**
   * Set the ID of the last captured error event.
   * This is generally only captured on the isolation scope.
   */
  setLastEventId(t) {
    this._lastEventId = t;
  }
  /**
   * Get the client assigned to this scope.
   */
  getClient() {
    return this._client;
  }
  /**
   * Get the ID of the last captured error event.
   * This is generally only available on the isolation scope.
   */
  lastEventId() {
    return this._lastEventId;
  }
  /**
   * @inheritDoc
   */
  addScopeListener(t) {
    this._scopeListeners.push(t);
  }
  /**
   * Add an event processor that will be called before an event is sent.
   */
  addEventProcessor(t) {
    return this._eventProcessors.push(t), this;
  }
  /**
   * Set the user for this scope.
   * Set to `null` to unset the user.
   */
  setUser(t) {
    return this._user = t || {
      email: void 0,
      id: void 0,
      ip_address: void 0,
      username: void 0
    }, this._session && vd(this._session, { user: t }), this._notifyScopeListeners(), this;
  }
  /**
   * Get the user from this scope.
   */
  getUser() {
    return this._user;
  }
  /**
   * Set an object that will be merged into existing tags on the scope,
   * and will be sent as tags data with the event.
   */
  setTags(t) {
    return this._tags = {
      ...this._tags,
      ...t
    }, this._notifyScopeListeners(), this;
  }
  /**
   * Set a single tag that will be sent as tags data with the event.
   */
  setTag(t, s) {
    return this._tags = { ...this._tags, [t]: s }, this._notifyScopeListeners(), this;
  }
  /**
   * Set an object that will be merged into existing extra on the scope,
   * and will be sent as extra data with the event.
   */
  setExtras(t) {
    return this._extra = {
      ...this._extra,
      ...t
    }, this._notifyScopeListeners(), this;
  }
  /**
   * Set a single key:value extra entry that will be sent as extra data with the event.
   */
  setExtra(t, s) {
    return this._extra = { ...this._extra, [t]: s }, this._notifyScopeListeners(), this;
  }
  /**
   * Sets the fingerprint on the scope to send with the events.
   * @param {string[]} fingerprint Fingerprint to group events in Sentry.
   */
  setFingerprint(t) {
    return this._fingerprint = t, this._notifyScopeListeners(), this;
  }
  /**
   * Sets the level on the scope for future events.
   */
  setLevel(t) {
    return this._level = t, this._notifyScopeListeners(), this;
  }
  /**
   * Sets the transaction name on the scope so that the name of e.g. taken server route or
   * the page location is attached to future events.
   *
   * IMPORTANT: Calling this function does NOT change the name of the currently active
   * root span. If you want to change the name of the active root span, use
   * `Sentry.updateSpanName(rootSpan, 'new name')` instead.
   *
   * By default, the SDK updates the scope's transaction name automatically on sensible
   * occasions, such as a page navigation or when handling a new request on the server.
   */
  setTransactionName(t) {
    return this._transactionName = t, this._notifyScopeListeners(), this;
  }
  /**
   * Sets context data with the given name.
   * Data passed as context will be normalized. You can also pass `null` to unset the context.
   * Note that context data will not be merged - calling `setContext` will overwrite an existing context with the same key.
   */
  setContext(t, s) {
    return s === null ? delete this._contexts[t] : this._contexts[t] = s, this._notifyScopeListeners(), this;
  }
  /**
   * Set the session for the scope.
   */
  setSession(t) {
    return t ? this._session = t : delete this._session, this._notifyScopeListeners(), this;
  }
  /**
   * Get the session from the scope.
   */
  getSession() {
    return this._session;
  }
  /**
   * Updates the scope with provided data. Can work in three variations:
   * - plain object containing updatable attributes
   * - Scope instance that'll extract the attributes from
   * - callback function that'll receive the current scope as an argument and allow for modifications
   */
  update(t) {
    if (!t)
      return this;
    const s = typeof t == "function" ? t(this) : t, n = s instanceof Wr ? s.getScopeData() : cu(s) ? t : void 0, { tags: r, extra: i, user: o, contexts: l, level: d, fingerprint: c = [], propagationContext: u } = n || {};
    return this._tags = { ...this._tags, ...r }, this._extra = { ...this._extra, ...i }, this._contexts = { ...this._contexts, ...l }, o && Object.keys(o).length && (this._user = o), d && (this._level = d), c.length && (this._fingerprint = c), u && (this._propagationContext = u), this;
  }
  /**
   * Clears the current scope and resets its properties.
   * Note: The client will not be cleared.
   */
  clear() {
    return this._breadcrumbs = [], this._tags = {}, this._extra = {}, this._user = {}, this._contexts = {}, this._level = void 0, this._transactionName = void 0, this._fingerprint = void 0, this._session = void 0, yd(this, void 0), this._attachments = [], this.setPropagationContext({ traceId: vi(), sampleRand: Math.random() }), this._notifyScopeListeners(), this;
  }
  /**
   * Adds a breadcrumb to the scope.
   * By default, the last 100 breadcrumbs are kept.
   */
  addBreadcrumb(t, s) {
    var i;
    const n = typeof s == "number" ? s : G9;
    if (n <= 0)
      return this;
    const r = {
      timestamp: gl(),
      ...t,
      // Breadcrumb messages can theoretically be infinitely large and they're held in memory so we truncate them not to leak (too much) memory
      message: t.message ? Qh(t.message, 2048) : t.message
    };
    return this._breadcrumbs.push(r), this._breadcrumbs.length > n && (this._breadcrumbs = this._breadcrumbs.slice(-n), (i = this._client) == null || i.recordDroppedEvent("buffer_overflow", "log_item")), this._notifyScopeListeners(), this;
  }
  /**
   * Get the last breadcrumb of the scope.
   */
  getLastBreadcrumb() {
    return this._breadcrumbs[this._breadcrumbs.length - 1];
  }
  /**
   * Clear all breadcrumbs from the scope.
   */
  clearBreadcrumbs() {
    return this._breadcrumbs = [], this._notifyScopeListeners(), this;
  }
  /**
   * Add an attachment to the scope.
   */
  addAttachment(t) {
    return this._attachments.push(t), this;
  }
  /**
   * Clear all attachments from the scope.
   */
  clearAttachments() {
    return this._attachments = [], this;
  }
  /**
   * Get the data of this scope, which should be applied to an event during processing.
   */
  getScopeData() {
    return {
      breadcrumbs: this._breadcrumbs,
      attachments: this._attachments,
      contexts: this._contexts,
      tags: this._tags,
      extra: this._extra,
      user: this._user,
      level: this._level,
      fingerprint: this._fingerprint || [],
      eventProcessors: this._eventProcessors,
      propagationContext: this._propagationContext,
      sdkProcessingMetadata: this._sdkProcessingMetadata,
      transactionName: this._transactionName,
      span: Kh(this)
    };
  }
  /**
   * Add data which will be accessible during event processing but won't get sent to Sentry.
   */
  setSDKProcessingMetadata(t) {
    return this._sdkProcessingMetadata = Mu(this._sdkProcessingMetadata, t, 2), this;
  }
  /**
   * Add propagation context to the scope, used for distributed tracing
   */
  setPropagationContext(t) {
    return this._propagationContext = t, this;
  }
  /**
   * Get propagation context from the scope, used for distributed tracing
   */
  getPropagationContext() {
    return this._propagationContext;
  }
  /**
   * Capture an exception for this scope.
   *
   * @returns {string} The id of the captured Sentry event.
   */
  captureException(t, s) {
    const n = (s == null ? void 0 : s.event_id) || gn();
    if (!this._client)
      return zt && ot.warn("No client configured on scope - will not capture exception!"), n;
    const r = new Error("Sentry syntheticException");
    return this._client.captureException(
      t,
      {
        originalException: t,
        syntheticException: r,
        ...s,
        event_id: n
      },
      this
    ), n;
  }
  /**
   * Capture a message for this scope.
   *
   * @returns {string} The id of the captured message.
   */
  captureMessage(t, s, n) {
    const r = (n == null ? void 0 : n.event_id) || gn();
    if (!this._client)
      return zt && ot.warn("No client configured on scope - will not capture message!"), r;
    const i = new Error(t);
    return this._client.captureMessage(
      t,
      s,
      {
        originalException: t,
        syntheticException: i,
        ...n,
        event_id: r
      },
      this
    ), r;
  }
  /**
   * Capture a Sentry event for this scope.
   *
   * @returns {string} The id of the captured event.
   */
  captureEvent(t, s) {
    const n = (s == null ? void 0 : s.event_id) || gn();
    return this._client ? (this._client.captureEvent(t, { ...s, event_id: n }, this), n) : (zt && ot.warn("No client configured on scope - will not capture event!"), n);
  }
  /**
   * This will be called on every set call.
   */
  _notifyScopeListeners() {
    this._notifyingListeners || (this._notifyingListeners = !0, this._scopeListeners.forEach((t) => {
      t(this);
    }), this._notifyingListeners = !1);
  }
}
function Y9() {
  return Lu("defaultCurrentScope", () => new Wr());
}
function X9() {
  return Lu("defaultIsolationScope", () => new Wr());
}
class q9 {
  constructor(t, s) {
    let n;
    t ? n = t : n = new Wr();
    let r;
    s ? r = s : r = new Wr(), this._stack = [{ scope: n }], this._isolationScope = r;
  }
  /**
   * Fork a scope for the stack.
   */
  withScope(t) {
    const s = this._pushScope();
    let n;
    try {
      n = t(s);
    } catch (r) {
      throw this._popScope(), r;
    }
    return Bu(n) ? n.then(
      (r) => (this._popScope(), r),
      (r) => {
        throw this._popScope(), r;
      }
    ) : (this._popScope(), n);
  }
  /**
   * Get the client of the stack.
   */
  getClient() {
    return this.getStackTop().client;
  }
  /**
   * Returns the scope of the top stack.
   */
  getScope() {
    return this.getStackTop().scope;
  }
  /**
   * Get the isolation scope for the stack.
   */
  getIsolationScope() {
    return this._isolationScope;
  }
  /**
   * Returns the topmost scope layer in the order domain > local > process.
   */
  getStackTop() {
    return this._stack[this._stack.length - 1];
  }
  /**
   * Push a scope to the stack.
   */
  _pushScope() {
    const t = this.getScope().clone();
    return this._stack.push({
      client: this.getClient(),
      scope: t
    }), t;
  }
  /**
   * Pop a scope from the stack.
   */
  _popScope() {
    return this._stack.length <= 1 ? !1 : !!this._stack.pop();
  }
}
function bd() {
  const e = ml(), t = Nm(e);
  return t.stack = t.stack || new q9(Y9(), X9());
}
function Q9(e) {
  return bd().withScope(e);
}
function K9(e, t) {
  const s = bd();
  return s.withScope(() => (s.getStackTop().scope = e, t(e)));
}
function TA(e) {
  return bd().withScope(() => e(bd().getIsolationScope()));
}
function Z9() {
  return {
    withIsolationScope: TA,
    withScope: Q9,
    withSetScope: K9,
    withSetIsolationScope: (e, t) => TA(t),
    getCurrentScope: () => bd().getScope(),
    getIsolationScope: () => bd().getIsolationScope()
  };
}
function Wd(e) {
  const t = Nm(e);
  return t.acs ? t.acs : Z9();
}
function Is() {
  const e = ml();
  return Wd(e).getCurrentScope();
}
function Wn() {
  const e = ml();
  return Wd(e).getIsolationScope();
}
function MP() {
  return Lu("globalScope", () => new Wr());
}
function Hm(...e) {
  const t = ml(), s = Wd(t);
  if (e.length === 2) {
    const [n, r] = e;
    return n ? s.withSetScope(n, r) : s.withScope(r);
  }
  return s.withScope(e[0]);
}
function ds() {
  return Is().getClient();
}
function J9(e) {
  const t = e.getPropagationContext(), { traceId: s, parentSpanId: n, propagationSpanId: r } = t, i = {
    trace_id: s,
    span_id: r || xu()
  };
  return n && (i.parent_span_id = n), i;
}
const Tn = "sentry.source", u1 = "sentry.sample_rate", xP = "sentry.previous_trace_sample_rate", Mo = "sentry.op", Ca = "sentry.origin", Zh = "sentry.idle_span_finish_reason", Fu = "sentry.measurement_unit", Vu = "sentry.measurement_value", OA = "sentry.custom_span_name", p1 = "sentry.profile_id", Gd = "sentry.exclusive_time", $9 = "sentry.link.type", _9 = 0, FP = 1, ja = 2;
function eO(e) {
  if (e < 400 && e >= 100)
    return { code: FP };
  if (e >= 400 && e < 500)
    switch (e) {
      case 401:
        return { code: ja, message: "unauthenticated" };
      case 403:
        return { code: ja, message: "permission_denied" };
      case 404:
        return { code: ja, message: "not_found" };
      case 409:
        return { code: ja, message: "already_exists" };
      case 413:
        return { code: ja, message: "failed_precondition" };
      case 429:
        return { code: ja, message: "resource_exhausted" };
      case 499:
        return { code: ja, message: "cancelled" };
      default:
        return { code: ja, message: "invalid_argument" };
    }
  if (e >= 500 && e < 600)
    switch (e) {
      case 501:
        return { code: ja, message: "unimplemented" };
      case 503:
        return { code: ja, message: "unavailable" };
      case 504:
        return { code: ja, message: "deadline_exceeded" };
      default:
        return { code: ja, message: "internal_error" };
    }
  return { code: ja, message: "unknown_error" };
}
function VP(e, t) {
  e.setAttribute("http.response.status_code", t);
  const s = eO(t);
  s.message !== "unknown_error" && e.setStatus(s);
}
const DP = "_sentryScope", NP = "_sentryIsolationScope";
function tO(e, t, s) {
  e && (Un(e, NP, s), Un(e, DP, t));
}
function Jh(e) {
  return {
    scope: e[DP],
    isolationScope: e[NP]
  };
}
const h1 = "sentry-", sO = /^sentry-/, aO = 8192;
function jP(e) {
  const t = rO(e);
  if (!t)
    return;
  const s = Object.entries(t).reduce((n, [r, i]) => {
    if (r.match(sO)) {
      const o = r.slice(h1.length);
      n[o] = i;
    }
    return n;
  }, {});
  if (Object.keys(s).length > 0)
    return s;
}
function nO(e) {
  if (!e)
    return;
  const t = Object.entries(e).reduce(
    (s, [n, r]) => (r && (s[`${h1}${n}`] = r), s),
    {}
  );
  return oO(t);
}
function rO(e) {
  if (!(!e || !Eo(e) && !Array.isArray(e)))
    return Array.isArray(e) ? e.reduce((t, s) => {
      const n = RA(s);
      return Object.entries(n).forEach(([r, i]) => {
        t[r] = i;
      }), t;
    }, {}) : RA(e);
}
function RA(e) {
  return e.split(",").map(
    (t) => t.split("=").map((s) => {
      try {
        return decodeURIComponent(s.trim());
      } catch {
        return;
      }
    })
  ).reduce((t, [s, n]) => (s && n && (t[s] = n), t), {});
}
function oO(e) {
  if (Object.keys(e).length !== 0)
    return Object.entries(e).reduce((t, [s, n], r) => {
      const i = `${encodeURIComponent(s)}=${encodeURIComponent(n)}`, o = r === 0 ? i : `${t},${i}`;
      return o.length > aO ? (zt && ot.warn(
        `Not adding key: ${s} with val: ${n} to baggage header due to exceeding baggage size limits.`
      ), t) : o;
    }, "");
}
function nl(e) {
  if (typeof e == "boolean")
    return Number(e);
  const t = typeof e == "string" ? parseFloat(e) : e;
  if (!(typeof t != "number" || isNaN(t) || t < 0 || t > 1))
    return t;
}
const HP = new RegExp(
  "^[ \\t]*([0-9a-f]{32})?-?([0-9a-f]{16})?-?([01])?[ \\t]*$"
  // whitespace
);
function iO(e) {
  if (!e)
    return;
  const t = e.match(HP);
  if (!t)
    return;
  let s;
  return t[3] === "1" ? s = !0 : t[3] === "0" && (s = !1), {
    traceId: t[1],
    parentSampled: s,
    parentSpanId: t[2]
  };
}
function lO(e, t) {
  const s = iO(e), n = jP(t);
  if (!(s != null && s.traceId))
    return {
      traceId: vi(),
      sampleRand: Math.random()
    };
  const r = dO(s, n);
  n && (n.sample_rand = r.toString());
  const { traceId: i, parentSpanId: o, parentSampled: l } = s;
  return {
    traceId: i,
    parentSpanId: o,
    sampled: l,
    dsc: n || {},
    // If we have traceparent data but no DSC it means we are not head of trace and we must freeze it
    sampleRand: r
  };
}
function UP(e = vi(), t = xu(), s) {
  let n = "";
  return s !== void 0 && (n = s ? "-1" : "-0"), `${e}-${t}${n}`;
}
function dO(e, t) {
  const s = nl(t == null ? void 0 : t.sample_rand);
  if (s !== void 0)
    return s;
  const n = nl(t == null ? void 0 : t.sample_rate);
  return n && (e == null ? void 0 : e.parentSampled) !== void 0 ? e.parentSampled ? (
    // Returns a sample rand with positive sampling decision [0, sampleRate)
    Math.random() * n
  ) : (
    // Returns a sample rand with negative sampling decision [sampleRate, 1)
    n + Math.random() * (1 - n)
  ) : Math.random();
}
const zP = 0, m1 = 1;
let LA = !1;
function cO(e) {
  const { spanId: t, traceId: s } = e.spanContext(), { data: n, op: r, parent_span_id: i, status: o, origin: l, links: d } = ms(e);
  return {
    parent_span_id: i,
    span_id: t,
    trace_id: s,
    data: n,
    op: r,
    status: o,
    origin: l,
    links: d
  };
}
function uO(e) {
  const { spanId: t, traceId: s, isRemote: n } = e.spanContext(), r = n ? t : ms(e).parent_span_id, i = Jh(e).scope, o = n ? (i == null ? void 0 : i.getPropagationContext().propagationSpanId) || xu() : t;
  return {
    parent_span_id: r,
    span_id: o,
    trace_id: s
  };
}
function pO(e) {
  const { traceId: t, spanId: s } = e.spanContext(), n = vl(e);
  return UP(t, s, n);
}
function WP(e) {
  if (e && e.length > 0)
    return e.map(({ context: { spanId: t, traceId: s, traceFlags: n, ...r }, attributes: i }) => ({
      span_id: t,
      trace_id: s,
      sampled: n === m1,
      attributes: i,
      ...r
    }));
}
function Ji(e) {
  return typeof e == "number" ? BA(e) : Array.isArray(e) ? e[0] + e[1] / 1e9 : e instanceof Date ? BA(e.getTime()) : Ea();
}
function BA(e) {
  return e > 9999999999 ? e / 1e3 : e;
}
function ms(e) {
  var n;
  if (mO(e))
    return e.getSpanJSON();
  const { spanId: t, traceId: s } = e.spanContext();
  if (hO(e)) {
    const { attributes: r, startTime: i, name: o, endTime: l, status: d, links: c } = e, u = "parentSpanId" in e ? e.parentSpanId : "parentSpanContext" in e ? (n = e.parentSpanContext) == null ? void 0 : n.spanId : void 0;
    return {
      span_id: t,
      trace_id: s,
      data: r,
      description: o,
      parent_span_id: u,
      start_timestamp: Ji(i),
      // This is [0,0] by default in OTEL, in which case we want to interpret this as no end time
      timestamp: Ji(l) || void 0,
      status: GP(d),
      op: r[Mo],
      origin: r[Ca],
      links: WP(c)
    };
  }
  return {
    span_id: t,
    trace_id: s,
    start_timestamp: 0,
    data: {}
  };
}
function hO(e) {
  const t = e;
  return !!t.attributes && !!t.startTime && !!t.name && !!t.endTime && !!t.status;
}
function mO(e) {
  return typeof e.getSpanJSON == "function";
}
function vl(e) {
  const { traceFlags: t } = e.spanContext();
  return t === m1;
}
function GP(e) {
  if (!(!e || e.code === _9))
    return e.code === FP ? "ok" : e.message || "unknown_error";
}
const $i = "_sentryChildSpans", mv = "_sentryRootSpan";
function YP(e, t) {
  const s = e[mv] || e;
  Un(t, mv, s), e[$i] ? e[$i].add(t) : Un(e, $i, /* @__PURE__ */ new Set([t]));
}
function fO(e, t) {
  e[$i] && e[$i].delete(t);
}
function th(e) {
  const t = /* @__PURE__ */ new Set();
  function s(n) {
    if (!t.has(n) && vl(n)) {
      t.add(n);
      const r = n[$i] ? Array.from(n[$i]) : [];
      for (const i of r)
        s(i);
    }
  }
  return s(e), Array.from(t);
}
function Wa(e) {
  return e[mv] || e;
}
function Ja() {
  const e = ml(), t = Wd(e);
  return t.getActiveSpan ? t.getActiveSpan() : Kh(Is());
}
function fv() {
  LA || (Yo(() => {
    console.warn(
      "[Sentry] Returning null from `beforeSendSpan` is disallowed. To drop certain spans, configure the respective integrations directly."
    );
  }), LA = !0);
}
let MA = !1;
function gO() {
  if (MA)
    return;
  function e() {
    const t = Ja(), s = t && Wa(t);
    if (s) {
      const n = "internal_error";
      zt && ot.log(`[Tracing] Root span: ${n} -> Global error occurred`), s.setStatus({ code: ja, message: n });
    }
  }
  e.tag = "sentry_tracingErrorCallback", MA = !0, CP(e), SP(e);
}
function xo(e) {
  var s;
  if (typeof __SENTRY_TRACING__ == "boolean" && !__SENTRY_TRACING__)
    return !1;
  const t = e || ((s = ds()) == null ? void 0 : s.getOptions());
  return !!t && // Note: This check is `!= null`, meaning "nullish". `0` is not "nullish", `undefined` and `null` are. (This comment was brought to you by 15 minutes of questioning life)
  (t.tracesSampleRate != null || !!t.tracesSampler);
}
const Um = "production", vO = /^o(\d+)\./, yO = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)([\w.-]+)(?::(\d+))?\/(.+)/;
function bO(e) {
  return e === "http" || e === "https";
}
function Yd(e, t = !1) {
  const { host: s, path: n, pass: r, port: i, projectId: o, protocol: l, publicKey: d } = e;
  return `${l}://${d}${t && r ? `:${r}` : ""}@${s}${i ? `:${i}` : ""}/${n && `${n}/`}${o}`;
}
function AO(e) {
  const t = yO.exec(e);
  if (!t) {
    Yo(() => {
      console.error(`Invalid Sentry Dsn: ${e}`);
    });
    return;
  }
  const [s, n, r = "", i = "", o = "", l = ""] = t.slice(1);
  let d = "", c = l;
  const u = c.split("/");
  if (u.length > 1 && (d = u.slice(0, -1).join("/"), c = u.pop()), c) {
    const m = c.match(/^\d+/);
    m && (c = m[0]);
  }
  return XP({ host: i, pass: r, path: d, projectId: c, port: o, protocol: s, publicKey: n });
}
function XP(e) {
  return {
    protocol: e.protocol,
    publicKey: e.publicKey || "",
    pass: e.pass || "",
    host: e.host,
    port: e.port || "",
    path: e.path || "",
    projectId: e.projectId
  };
}
function wO(e) {
  if (!zt)
    return !0;
  const { port: t, projectId: s, protocol: n } = e;
  return ["protocol", "publicKey", "host", "projectId"].find((o) => e[o] ? !1 : (ot.error(`Invalid Sentry Dsn: ${o} missing`), !0)) ? !1 : s.match(/^\d+$/) ? bO(n) ? t && isNaN(parseInt(t, 10)) ? (ot.error(`Invalid Sentry Dsn: Invalid port ${t}`), !1) : !0 : (ot.error(`Invalid Sentry Dsn: Invalid protocol ${n}`), !1) : (ot.error(`Invalid Sentry Dsn: Invalid projectId ${s}`), !1);
}
function CO(e) {
  const t = e.match(vO);
  return t == null ? void 0 : t[1];
}
function qP(e) {
  const t = typeof e == "string" ? AO(e) : XP(e);
  if (!(!t || !wO(t)))
    return t;
}
const QP = "_frozenDsc";
function sh(e, t) {
  Un(e, QP, t);
}
function KP(e, t) {
  const s = t.getOptions(), { publicKey: n, host: r } = t.getDsn() || {};
  let i;
  s.orgId ? i = String(s.orgId) : r && (i = CO(r));
  const o = {
    environment: s.environment || Um,
    release: s.release,
    public_key: n,
    trace_id: e,
    org_id: i
  };
  return t.emit("createDsc", o), o;
}
function ZP(e, t) {
  const s = t.getPropagationContext();
  return s.dsc || KP(s.traceId, e);
}
function Fo(e) {
  var b;
  const t = ds();
  if (!t)
    return {};
  const s = Wa(e), n = ms(s), r = n.data, i = s.spanContext().traceState, o = (i == null ? void 0 : i.get("sentry.sample_rate")) ?? r[u1] ?? r[xP];
  function l(w) {
    return (typeof o == "number" || typeof o == "string") && (w.sample_rate = `${o}`), w;
  }
  const d = s[QP];
  if (d)
    return l(d);
  const c = i == null ? void 0 : i.get("sentry.dsc"), u = c && jP(c);
  if (u)
    return l(u);
  const m = KP(e.spanContext().traceId, t), f = r[Tn], v = n.description;
  return f !== "url" && v && (m.transaction = v), xo() && (m.sampled = String(vl(s)), m.sample_rand = // In OTEL we store the sample rand on the trace state because we cannot access scopes for NonRecordingSpans
  // The Sentry OTEL SpanSampler takes care of writing the sample rand on the root span
  (i == null ? void 0 : i.get("sentry.sample_rand")) ?? // On all other platforms we can actually get the scopes from a root span (we use this as a fallback)
  ((b = Jh(s).scope) == null ? void 0 : b.getPropagationContext().sampleRand.toString())), l(m), t.emit("createDsc", m, s), m;
}
class yi {
  constructor(t = {}) {
    this._traceId = t.traceId || vi(), this._spanId = t.spanId || xu();
  }
  /** @inheritdoc */
  spanContext() {
    return {
      spanId: this._spanId,
      traceId: this._traceId,
      traceFlags: zP
    };
  }
  /** @inheritdoc */
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  end(t) {
  }
  /** @inheritdoc */
  setAttribute(t, s) {
    return this;
  }
  /** @inheritdoc */
  setAttributes(t) {
    return this;
  }
  /** @inheritdoc */
  setStatus(t) {
    return this;
  }
  /** @inheritdoc */
  updateName(t) {
    return this;
  }
  /** @inheritdoc */
  isRecording() {
    return !1;
  }
  /** @inheritdoc */
  addEvent(t, s, n) {
    return this;
  }
  /** @inheritDoc */
  addLink(t) {
    return this;
  }
  /** @inheritDoc */
  addLinks(t) {
    return this;
  }
  /**
   * This should generally not be used,
   * but we need it for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */
  recordException(t, s) {
  }
}
function pr(e, t = 100, s = 1 / 0) {
  try {
    return gv("", e, t, s);
  } catch (n) {
    return { ERROR: `**non-serializable** (${n})` };
  }
}
function JP(e, t = 3, s = 100 * 1024) {
  const n = pr(e, t);
  return EO(n) > s ? JP(e, t - 1, s) : n;
}
function gv(e, t, s = 1 / 0, n = 1 / 0, r = IO()) {
  const [i, o] = r;
  if (t == null || // this matches null and undefined -> eqeq not eqeqeq
  ["boolean", "string"].includes(typeof t) || typeof t == "number" && Number.isFinite(t))
    return t;
  const l = SO(e, t);
  if (!l.startsWith("[object "))
    return l;
  if (t.__sentry_skip_normalization__)
    return t;
  const d = typeof t.__sentry_override_normalization_depth__ == "number" ? t.__sentry_override_normalization_depth__ : s;
  if (d === 0)
    return l.replace("object ", "");
  if (i(t))
    return "[Circular ~]";
  const c = t;
  if (c && typeof c.toJSON == "function")
    try {
      const v = c.toJSON();
      return gv("", v, d - 1, n, r);
    } catch {
    }
  const u = Array.isArray(t) ? [] : {};
  let m = 0;
  const f = RP(t);
  for (const v in f) {
    if (!Object.prototype.hasOwnProperty.call(f, v))
      continue;
    if (m >= n) {
      u[v] = "[MaxProperties ~]";
      break;
    }
    const b = f[v];
    u[v] = gv(v, b, d - 1, n, r), m++;
  }
  return o(t), u;
}
function SO(e, t) {
  try {
    if (e === "domain" && t && typeof t == "object" && t._events)
      return "[Domain]";
    if (e === "domainEmitter")
      return "[DomainEmitter]";
    if (typeof global < "u" && t === global)
      return "[Global]";
    if (typeof window < "u" && t === window)
      return "[Window]";
    if (typeof document < "u" && t === document)
      return "[Document]";
    if (EP(t))
      return "[VueViewModel]";
    if (B9(t))
      return "[SyntheticEvent]";
    if (typeof t == "number" && !Number.isFinite(t))
      return `[${t}]`;
    if (typeof t == "function")
      return `[Function: ${Lo(t)}]`;
    if (typeof t == "symbol")
      return `[${String(t)}]`;
    if (typeof t == "bigint")
      return `[BigInt: ${String(t)}]`;
    const s = PO(t);
    return /^HTML(\w*)Element$/.test(s) ? `[HTMLElement: ${s}]` : `[object ${s}]`;
  } catch (s) {
    return `**non-serializable** (${s})`;
  }
}
function PO(e) {
  const t = Object.getPrototypeOf(e);
  return t != null && t.constructor ? t.constructor.name : "null prototype";
}
function kO(e) {
  return ~-encodeURI(e).split(/%..|./).length;
}
function EO(e) {
  return kO(JSON.stringify(e));
}
function IO() {
  const e = /* @__PURE__ */ new WeakSet();
  function t(n) {
    return e.has(n) ? !0 : (e.add(n), !1);
  }
  function s(n) {
    e.delete(n);
  }
  return [t, s];
}
function yl(e, t = []) {
  return [e, t];
}
function TO(e, t) {
  const [s, n] = e;
  return [s, [...n, t]];
}
function $h(e, t) {
  const s = e[1];
  for (const n of s) {
    const r = n[0].type;
    if (t(n, r))
      return !0;
  }
  return !1;
}
function vv(e) {
  const t = Nm(As);
  return t.encodePolyfill ? t.encodePolyfill(e) : new TextEncoder().encode(e);
}
function OO(e) {
  const [t, s] = e;
  let n = JSON.stringify(t);
  function r(i) {
    typeof n == "string" ? n = typeof i == "string" ? n + i : [vv(n), i] : n.push(typeof i == "string" ? vv(i) : i);
  }
  for (const i of s) {
    const [o, l] = i;
    if (r(`
${JSON.stringify(o)}
`), typeof l == "string" || l instanceof Uint8Array)
      r(l);
    else {
      let d;
      try {
        d = JSON.stringify(l);
      } catch {
        d = JSON.stringify(pr(l));
      }
      r(d);
    }
  }
  return typeof n == "string" ? n : RO(n);
}
function RO(e) {
  const t = e.reduce((r, i) => r + i.length, 0), s = new Uint8Array(t);
  let n = 0;
  for (const r of e)
    s.set(r, n), n += r.length;
  return s;
}
function LO(e) {
  return [{
    type: "span"
  }, e];
}
function BO(e) {
  const t = typeof e.data == "string" ? vv(e.data) : e.data;
  return [
    {
      type: "attachment",
      length: t.length,
      filename: e.filename,
      content_type: e.contentType,
      attachment_type: e.attachmentType
    },
    t
  ];
}
const MO = {
  session: "session",
  sessions: "session",
  attachment: "attachment",
  transaction: "transaction",
  event: "error",
  client_report: "internal",
  user_report: "default",
  profile: "profile",
  profile_chunk: "profile",
  replay_event: "replay",
  replay_recording: "replay",
  check_in: "monitor",
  feedback: "feedback",
  span: "span",
  raw_security: "security",
  log: "log_item"
};
function xA(e) {
  return MO[e];
}
function f1(e) {
  if (!(e != null && e.sdk))
    return;
  const { name: t, version: s } = e.sdk;
  return { name: t, version: s };
}
function $P(e, t, s, n) {
  var i;
  const r = (i = e.sdkProcessingMetadata) == null ? void 0 : i.dynamicSamplingContext;
  return {
    event_id: e.event_id,
    sent_at: (/* @__PURE__ */ new Date()).toISOString(),
    ...t && { sdk: t },
    ...!!s && n && { dsn: Yd(n) },
    ...r && {
      trace: r
    }
  };
}
function xO(e, t) {
  return t && (e.sdk = e.sdk || {}, e.sdk.name = e.sdk.name || t.name, e.sdk.version = e.sdk.version || t.version, e.sdk.integrations = [...e.sdk.integrations || [], ...t.integrations || []], e.sdk.packages = [...e.sdk.packages || [], ...t.packages || []]), e;
}
function FO(e, t, s, n) {
  const r = f1(s), i = {
    sent_at: (/* @__PURE__ */ new Date()).toISOString(),
    ...r && { sdk: r },
    ...!!n && t && { dsn: Yd(t) }
  }, o = "aggregates" in e ? [{ type: "sessions" }, e] : [{ type: "session" }, e.toJSON()];
  return yl(i, [o]);
}
function VO(e, t, s, n) {
  const r = f1(s), i = e.type && e.type !== "replay_event" ? e.type : "event";
  xO(e, s == null ? void 0 : s.sdk);
  const o = $P(e, r, n, t);
  return delete e.sdkProcessingMetadata, yl(o, [[{ type: i }, e]]);
}
function DO(e, t) {
  function s(u) {
    return !!u.trace_id && !!u.public_key;
  }
  const n = Fo(e[0]), r = t == null ? void 0 : t.getDsn(), i = t == null ? void 0 : t.getOptions().tunnel, o = {
    sent_at: (/* @__PURE__ */ new Date()).toISOString(),
    ...s(n) && { trace: n },
    ...!!i && r && { dsn: Yd(r) }
  }, l = t == null ? void 0 : t.getOptions().beforeSendSpan, d = l ? (u) => {
    const m = ms(u), f = l(m);
    return f || (fv(), m);
  } : ms, c = [];
  for (const u of e) {
    const m = d(u);
    m && c.push(LO(m));
  }
  return yl(o, c);
}
function NO(e) {
  if (!zt) return;
  const { description: t = "< unknown name >", op: s = "< unknown op >", parent_span_id: n } = ms(e), { spanId: r } = e.spanContext(), i = vl(e), o = Wa(e), l = o === e, d = `[Tracing] Starting ${i ? "sampled" : "unsampled"} ${l ? "root " : ""}span`, c = [`op: ${s}`, `name: ${t}`, `ID: ${r}`];
  if (n && c.push(`parent ID: ${n}`), !l) {
    const { op: u, description: m } = ms(o);
    c.push(`root ID: ${o.spanContext().spanId}`), u && c.push(`root op: ${u}`), m && c.push(`root description: ${m}`);
  }
  ot.log(`${d}
  ${c.join(`
  `)}`);
}
function jO(e) {
  if (!zt) return;
  const { description: t = "< unknown name >", op: s = "< unknown op >" } = ms(e), { spanId: n } = e.spanContext(), i = Wa(e) === e, o = `[Tracing] Finishing "${s}" ${i ? "root " : ""}span "${t}" with ID ${n}`;
  ot.log(o);
}
function HO(e, t, s, n = Ja()) {
  const r = n && Wa(n);
  r && (zt && ot.log(`[Measurement] Setting measurement on root span: ${e} = ${t} ${s}`), r.addEvent(e, {
    [Vu]: t,
    [Fu]: s
  }));
}
function FA(e) {
  if (!e || e.length === 0)
    return;
  const t = {};
  return e.forEach((s) => {
    const n = s.attributes || {}, r = n[Fu], i = n[Vu];
    typeof r == "string" && typeof i == "number" && (t[s.name] = { value: i, unit: r });
  }), t;
}
const VA = 1e3;
class zm {
  /** Epoch timestamp in seconds when the span started. */
  /** Epoch timestamp in seconds when the span ended. */
  /** Internal keeper of the status */
  /** The timed events added to this span. */
  /** if true, treat span as a standalone span (not part of a transaction) */
  /**
   * You should never call the constructor manually, always use `Sentry.startSpan()`
   * or other span methods.
   * @internal
   * @hideconstructor
   * @hidden
   */
  constructor(t = {}) {
    this._traceId = t.traceId || vi(), this._spanId = t.spanId || xu(), this._startTime = t.startTimestamp || Ea(), this._links = t.links, this._attributes = {}, this.setAttributes({
      [Ca]: "manual",
      [Mo]: t.op,
      ...t.attributes
    }), this._name = t.name, t.parentSpanId && (this._parentSpanId = t.parentSpanId), "sampled" in t && (this._sampled = t.sampled), t.endTimestamp && (this._endTime = t.endTimestamp), this._events = [], this._isStandaloneSpan = t.isStandalone, this._endTime && this._onSpanEnded();
  }
  /** @inheritDoc */
  addLink(t) {
    return this._links ? this._links.push(t) : this._links = [t], this;
  }
  /** @inheritDoc */
  addLinks(t) {
    return this._links ? this._links.push(...t) : this._links = t, this;
  }
  /**
   * This should generally not be used,
   * but it is needed for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */
  recordException(t, s) {
  }
  /** @inheritdoc */
  spanContext() {
    const { _spanId: t, _traceId: s, _sampled: n } = this;
    return {
      spanId: t,
      traceId: s,
      traceFlags: n ? m1 : zP
    };
  }
  /** @inheritdoc */
  setAttribute(t, s) {
    return s === void 0 ? delete this._attributes[t] : this._attributes[t] = s, this;
  }
  /** @inheritdoc */
  setAttributes(t) {
    return Object.keys(t).forEach((s) => this.setAttribute(s, t[s])), this;
  }
  /**
   * This should generally not be used,
   * but we need it for browser tracing where we want to adjust the start time afterwards.
   * USE THIS WITH CAUTION!
   *
   * @hidden
   * @internal
   */
  updateStartTime(t) {
    this._startTime = Ji(t);
  }
  /**
   * @inheritDoc
   */
  setStatus(t) {
    return this._status = t, this;
  }
  /**
   * @inheritDoc
   */
  updateName(t) {
    return this._name = t, this.setAttribute(Tn, "custom"), this;
  }
  /** @inheritdoc */
  end(t) {
    this._endTime || (this._endTime = Ji(t), jO(this), this._onSpanEnded());
  }
  /**
   * Get JSON representation of this span.
   *
   * @hidden
   * @internal This method is purely for internal purposes and should not be used outside
   * of SDK code. If you need to get a JSON representation of a span,
   * use `spanToJSON(span)` instead.
   */
  getSpanJSON() {
    return {
      data: this._attributes,
      description: this._name,
      op: this._attributes[Mo],
      parent_span_id: this._parentSpanId,
      span_id: this._spanId,
      start_timestamp: this._startTime,
      status: GP(this._status),
      timestamp: this._endTime,
      trace_id: this._traceId,
      origin: this._attributes[Ca],
      profile_id: this._attributes[p1],
      exclusive_time: this._attributes[Gd],
      measurements: FA(this._events),
      is_segment: this._isStandaloneSpan && Wa(this) === this || void 0,
      segment_id: this._isStandaloneSpan ? Wa(this).spanContext().spanId : void 0,
      links: WP(this._links)
    };
  }
  /** @inheritdoc */
  isRecording() {
    return !this._endTime && !!this._sampled;
  }
  /**
   * @inheritdoc
   */
  addEvent(t, s, n) {
    zt && ot.log("[Tracing] Adding an event to span:", t);
    const r = DA(s) ? s : n || Ea(), i = DA(s) ? {} : s || {}, o = {
      name: t,
      time: Ji(r),
      attributes: i
    };
    return this._events.push(o), this;
  }
  /**
   * This method should generally not be used,
   * but for now we need a way to publicly check if the `_isStandaloneSpan` flag is set.
   * USE THIS WITH CAUTION!
   * @internal
   * @hidden
   * @experimental
   */
  isStandaloneSpan() {
    return !!this._isStandaloneSpan;
  }
  /** Emit `spanEnd` when the span is ended. */
  _onSpanEnded() {
    const t = ds();
    if (t && t.emit("spanEnd", this), !(this._isStandaloneSpan || this === Wa(this)))
      return;
    if (this._isStandaloneSpan) {
      this._sampled ? zO(DO([this], t)) : (zt && ot.log("[Tracing] Discarding standalone span because its trace was not chosen to be sampled."), t && t.recordDroppedEvent("sample_rate", "span"));
      return;
    }
    const n = this._convertSpanToTransaction();
    n && (Jh(this).scope || Is()).captureEvent(n);
  }
  /**
   * Finish the transaction & prepare the event to send to Sentry.
   */
  _convertSpanToTransaction() {
    var u;
    if (!NA(ms(this)))
      return;
    this._name || (zt && ot.warn("Transaction has no name, falling back to `<unlabeled transaction>`."), this._name = "<unlabeled transaction>");
    const { scope: t, isolationScope: s } = Jh(this), n = (u = t == null ? void 0 : t.getScopeData().sdkProcessingMetadata) == null ? void 0 : u.normalizedRequest;
    if (this._sampled !== !0)
      return;
    const i = th(this).filter((m) => m !== this && !UO(m)).map((m) => ms(m)).filter(NA), o = this._attributes[Tn];
    delete this._attributes[OA], i.forEach((m) => {
      delete m.data[OA];
    });
    const l = {
      contexts: {
        trace: cO(this)
      },
      spans: (
        // spans.sort() mutates the array, but `spans` is already a copy so we can safely do this here
        // we do not use spans anymore after this point
        i.length > VA ? i.sort((m, f) => m.start_timestamp - f.start_timestamp).slice(0, VA) : i
      ),
      start_timestamp: this._startTime,
      timestamp: this._endTime,
      transaction: this._name,
      type: "transaction",
      sdkProcessingMetadata: {
        capturedSpanScope: t,
        capturedSpanIsolationScope: s,
        dynamicSamplingContext: Fo(this)
      },
      request: n,
      ...o && {
        transaction_info: {
          source: o
        }
      }
    }, d = FA(this._events);
    return d && Object.keys(d).length && (zt && ot.log(
      "[Measurements] Adding measurements to transaction event",
      JSON.stringify(d, void 0, 2)
    ), l.measurements = d), l;
  }
}
function DA(e) {
  return e && typeof e == "number" || e instanceof Date || Array.isArray(e);
}
function NA(e) {
  return !!e.start_timestamp && !!e.timestamp && !!e.span_id && !!e.trace_id;
}
function UO(e) {
  return e instanceof zm && e.isStandaloneSpan();
}
function zO(e) {
  const t = ds();
  if (!t)
    return;
  const s = e[1];
  if (!s || s.length === 0) {
    t.recordDroppedEvent("before_send", "span");
    return;
  }
  t.sendEnvelope(e);
}
function WO(e, t, s = () => {
}) {
  let n;
  try {
    n = e();
  } catch (r) {
    throw t(r), s(), r;
  }
  return GO(n, t, s);
}
function GO(e, t, s) {
  return Bu(e) ? e.then(
    (n) => (s(), n),
    (n) => {
      throw t(n), s(), n;
    }
  ) : (s(), e);
}
function YO(e, t, s) {
  if (!xo(e))
    return [!1];
  let n, r;
  typeof e.tracesSampler == "function" ? (r = e.tracesSampler({
    ...t,
    inheritOrSampleWith: (l) => typeof t.parentSampleRate == "number" ? t.parentSampleRate : typeof t.parentSampled == "boolean" ? Number(t.parentSampled) : l
  }), n = !0) : t.parentSampled !== void 0 ? r = t.parentSampled : typeof e.tracesSampleRate < "u" && (r = e.tracesSampleRate, n = !0);
  const i = nl(r);
  if (i === void 0)
    return zt && ot.warn(
      `[Tracing] Discarding root span because of invalid sample rate. Sample rate must be a boolean or a number between 0 and 1. Got ${JSON.stringify(
        r
      )} of type ${JSON.stringify(typeof r)}.`
    ), [!1];
  if (!i)
    return zt && ot.log(
      `[Tracing] Discarding transaction because ${typeof e.tracesSampler == "function" ? "tracesSampler returned 0 or false" : "a negative sampling decision was inherited or tracesSampleRate is set to 0"}`
    ), [!1, i, n];
  const o = s < i;
  return o || zt && ot.log(
    `[Tracing] Discarding transaction because it's not included in the random sample (sampling rate = ${Number(
      r
    )})`
  ), [o, i, n];
}
const _P = "__SENTRY_SUPPRESS_TRACING__";
function XO(e, t) {
  const s = v1();
  if (s.startSpan)
    return s.startSpan(e, t);
  const n = t3(e), { forceTransaction: r, parentSpan: i, scope: o } = e, l = o == null ? void 0 : o.clone();
  return Hm(l, () => QO(i)(() => {
    const c = Is(), u = s3(c, i), f = e.onlyIfParent && !u ? new yi() : e3({
      parentSpan: u,
      spanArguments: n,
      forceTransaction: r,
      scope: c
    });
    return yd(c, f), WO(
      () => t(f),
      () => {
        const { status: v } = ms(f);
        f.isRecording() && (!v || v === "ok") && f.setStatus({ code: ja, message: "internal_error" });
      },
      () => {
        f.end();
      }
    );
  }));
}
function bi(e) {
  const t = v1();
  if (t.startInactiveSpan)
    return t.startInactiveSpan(e);
  const s = t3(e), { forceTransaction: n, parentSpan: r } = e;
  return (e.scope ? (o) => Hm(e.scope, o) : r !== void 0 ? (o) => g1(r, o) : (o) => o())(() => {
    const o = Is(), l = s3(o, r);
    return e.onlyIfParent && !l ? new yi() : e3({
      parentSpan: l,
      spanArguments: s,
      forceTransaction: n,
      scope: o
    });
  });
}
function g1(e, t) {
  const s = v1();
  return s.withActiveSpan ? s.withActiveSpan(e, t) : Hm((n) => (yd(n, e || void 0), t(n)));
}
function e3({
  parentSpan: e,
  spanArguments: t,
  forceTransaction: s,
  scope: n
}) {
  if (!xo()) {
    const o = new yi();
    if (s || !e) {
      const l = {
        sampled: "false",
        sample_rate: "0",
        transaction: t.name,
        ...Fo(o)
      };
      sh(o, l);
    }
    return o;
  }
  const r = Wn();
  let i;
  if (e && !s)
    i = qO(e, n, t), YP(e, i);
  else if (e) {
    const o = Fo(e), { traceId: l, spanId: d } = e.spanContext(), c = vl(e);
    i = jA(
      {
        traceId: l,
        parentSpanId: d,
        ...t
      },
      n,
      c
    ), sh(i, o);
  } else {
    const {
      traceId: o,
      dsc: l,
      parentSpanId: d,
      sampled: c
    } = {
      ...r.getPropagationContext(),
      ...n.getPropagationContext()
    };
    i = jA(
      {
        traceId: o,
        parentSpanId: d,
        ...t
      },
      n,
      c
    ), l && sh(i, l);
  }
  return NO(i), tO(i, n, r), i;
}
function t3(e) {
  const s = {
    isStandalone: (e.experimental || {}).standalone,
    ...e
  };
  if (e.startTime) {
    const n = { ...s };
    return n.startTimestamp = Ji(e.startTime), delete n.startTime, n;
  }
  return s;
}
function v1() {
  const e = ml();
  return Wd(e);
}
function jA(e, t, s) {
  var b;
  const n = ds(), r = (n == null ? void 0 : n.getOptions()) || {}, { name: i = "" } = e, o = { spanAttributes: { ...e.attributes }, spanName: i, parentSampled: s };
  n == null || n.emit("beforeSampling", o, { decision: !1 });
  const l = o.parentSampled ?? s, d = o.spanAttributes, c = t.getPropagationContext(), [u, m, f] = t.getScopeData().sdkProcessingMetadata[_P] ? [!1] : YO(
    r,
    {
      name: i,
      parentSampled: l,
      attributes: d,
      parentSampleRate: nl((b = c.dsc) == null ? void 0 : b.sample_rate)
    },
    c.sampleRand
  ), v = new zm({
    ...e,
    attributes: {
      [Tn]: "custom",
      [u1]: m !== void 0 && f ? m : void 0,
      ...d
    },
    sampled: u
  });
  return !u && n && (zt && ot.log("[Tracing] Discarding root span because its trace was not chosen to be sampled."), n.recordDroppedEvent("sample_rate", "transaction")), n && n.emit("spanStart", v), v;
}
function qO(e, t, s) {
  const { spanId: n, traceId: r } = e.spanContext(), i = t.getScopeData().sdkProcessingMetadata[_P] ? !1 : vl(e), o = i ? new zm({
    ...s,
    parentSpanId: n,
    traceId: r,
    sampled: i
  }) : new yi({ traceId: r });
  YP(e, o);
  const l = ds();
  return l && (l.emit("spanStart", o), s.endTimestamp && l.emit("spanEnd", o)), o;
}
function s3(e, t) {
  if (t)
    return t;
  if (t === null)
    return;
  const s = Kh(e);
  if (!s)
    return;
  const n = ds();
  return (n ? n.getOptions() : {}).parentSpanIsAlwaysRootSpan ? Wa(s) : s;
}
function QO(e) {
  return e !== void 0 ? (t) => g1(e, t) : (t) => t();
}
const ah = {
  idleTimeout: 1e3,
  finalTimeout: 3e4,
  childSpanTimeout: 15e3
}, KO = "heartbeatFailed", ZO = "idleTimeout", JO = "finalTimeout", $O = "externalFinish";
function a3(e, t = {}) {
  const s = /* @__PURE__ */ new Map();
  let n = !1, r, i = $O, o = !t.disableAutoFinish;
  const l = [], {
    idleTimeout: d = ah.idleTimeout,
    finalTimeout: c = ah.finalTimeout,
    childSpanTimeout: u = ah.childSpanTimeout,
    beforeSpanEnd: m
  } = t, f = ds();
  if (!f || !xo()) {
    const O = new yi(), E = {
      sample_rate: "0",
      sampled: "false",
      ...Fo(O)
    };
    return sh(O, E), O;
  }
  const v = Is(), b = Ja(), w = _O(e);
  w.end = new Proxy(w.end, {
    apply(O, E, B) {
      if (m && m(w), E instanceof yi)
        return;
      const [M, ...R] = B, F = M || Ea(), L = Ji(F), j = th(w).filter((ie) => ie !== w);
      if (!j.length)
        return C(L), Reflect.apply(O, E, [L, ...R]);
      const H = j.map((ie) => ms(ie).timestamp).filter((ie) => !!ie), te = H.length ? Math.max(...H) : void 0, re = ms(w).start_timestamp, le = Math.min(
        re ? re + c / 1e3 : 1 / 0,
        Math.max(re || -1 / 0, Math.min(L, te || 1 / 0))
      );
      return C(le), Reflect.apply(O, E, [le, ...R]);
    }
  });
  function S() {
    r && (clearTimeout(r), r = void 0);
  }
  function I(O) {
    S(), r = setTimeout(() => {
      !n && s.size === 0 && o && (i = ZO, w.end(O));
    }, d);
  }
  function T(O) {
    r = setTimeout(() => {
      !n && o && (i = KO, w.end(O));
    }, u);
  }
  function x(O) {
    S(), s.set(O, !0);
    const E = Ea();
    T(E + u / 1e3);
  }
  function k(O) {
    if (s.has(O) && s.delete(O), s.size === 0) {
      const E = Ea();
      I(E + d / 1e3);
    }
  }
  function C(O) {
    n = !0, s.clear(), l.forEach((L) => L()), yd(v, b);
    const E = ms(w), { start_timestamp: B } = E;
    if (!B)
      return;
    E.data[Zh] || w.setAttribute(Zh, i), ot.log(`[Tracing] Idle span "${E.op}" finished`);
    const R = th(w).filter((L) => L !== w);
    let F = 0;
    R.forEach((L) => {
      L.isRecording() && (L.setStatus({ code: ja, message: "cancelled" }), L.end(O), zt && ot.log("[Tracing] Cancelling span since span ended early", JSON.stringify(L, void 0, 2)));
      const j = ms(L), { timestamp: H = 0, start_timestamp: te = 0 } = j, re = te <= O, le = (c + d) / 1e3, ie = H - te <= le;
      if (zt) {
        const ye = JSON.stringify(L, void 0, 2);
        re ? ie || ot.log("[Tracing] Discarding span since it finished after idle span final timeout", ye) : ot.log("[Tracing] Discarding span since it happened after idle span was finished", ye);
      }
      (!ie || !re) && (fO(w, L), F++);
    }), F > 0 && w.setAttribute("sentry.idle_span_discarded_spans", F);
  }
  return l.push(
    f.on("spanStart", (O) => {
      if (n || O === w || ms(O).timestamp || O instanceof zm && O.isStandaloneSpan())
        return;
      th(w).includes(O) && x(O.spanContext().spanId);
    })
  ), l.push(
    f.on("spanEnd", (O) => {
      n || k(O.spanContext().spanId);
    })
  ), l.push(
    f.on("idleSpanEnableAutoFinish", (O) => {
      O === w && (o = !0, I(), s.size && T());
    })
  ), t.disableAutoFinish || I(), setTimeout(() => {
    n || (w.setStatus({ code: ja, message: "deadline_exceeded" }), i = JO, w.end());
  }, c), w;
}
function _O(e) {
  const t = bi(e);
  return yd(Is(), t), zt && ot.log("[Tracing] Started span is an idle span"), t;
}
const Df = 0, HA = 1, UA = 2;
function Vo(e) {
  return new Ai((t) => {
    t(e);
  });
}
function _h(e) {
  return new Ai((t, s) => {
    s(e);
  });
}
class Ai {
  constructor(t) {
    this._state = Df, this._handlers = [], this._runExecutor(t);
  }
  /** @inheritdoc */
  then(t, s) {
    return new Ai((n, r) => {
      this._handlers.push([
        !1,
        (i) => {
          if (!t)
            n(i);
          else
            try {
              n(t(i));
            } catch (o) {
              r(o);
            }
        },
        (i) => {
          if (!s)
            r(i);
          else
            try {
              n(s(i));
            } catch (o) {
              r(o);
            }
        }
      ]), this._executeHandlers();
    });
  }
  /** @inheritdoc */
  catch(t) {
    return this.then((s) => s, t);
  }
  /** @inheritdoc */
  finally(t) {
    return new Ai((s, n) => {
      let r, i;
      return this.then(
        (o) => {
          i = !1, r = o, t && t();
        },
        (o) => {
          i = !0, r = o, t && t();
        }
      ).then(() => {
        if (i) {
          n(r);
          return;
        }
        s(r);
      });
    });
  }
  /** Excute the resolve/reject handlers. */
  _executeHandlers() {
    if (this._state === Df)
      return;
    const t = this._handlers.slice();
    this._handlers = [], t.forEach((s) => {
      s[0] || (this._state === HA && s[1](this._value), this._state === UA && s[2](this._value), s[0] = !0);
    });
  }
  /** Run the executor for the SyncPromise. */
  _runExecutor(t) {
    const s = (i, o) => {
      if (this._state === Df) {
        if (Bu(o)) {
          o.then(n, r);
          return;
        }
        this._state = i, this._value = o, this._executeHandlers();
      }
    }, n = (i) => {
      s(HA, i);
    }, r = (i) => {
      s(UA, i);
    };
    try {
      t(n, r);
    } catch (i) {
      r(i);
    }
  }
}
function yv(e, t, s, n = 0) {
  return new Ai((r, i) => {
    const o = e[n];
    if (t === null || typeof o != "function")
      r(t);
    else {
      const l = o({ ...t }, s);
      zt && o.id && l === null && ot.log(`Event processor "${o.id}" dropped event`), Bu(l) ? l.then((d) => yv(e, d, s, n + 1).then(r)).then(null, i) : yv(e, l, s, n + 1).then(r).then(null, i);
    }
  });
}
function e7(e, t) {
  const { fingerprint: s, span: n, breadcrumbs: r, sdkProcessingMetadata: i } = t;
  t7(e, t), n && n7(e, n), r7(e, s), s7(e, r), a7(e, i);
}
function zA(e, t) {
  const {
    extra: s,
    tags: n,
    user: r,
    contexts: i,
    level: o,
    sdkProcessingMetadata: l,
    breadcrumbs: d,
    fingerprint: c,
    eventProcessors: u,
    attachments: m,
    propagationContext: f,
    transactionName: v,
    span: b
  } = t;
  np(e, "extra", s), np(e, "tags", n), np(e, "user", r), np(e, "contexts", i), e.sdkProcessingMetadata = Mu(e.sdkProcessingMetadata, l, 2), o && (e.level = o), v && (e.transactionName = v), b && (e.span = b), d.length && (e.breadcrumbs = [...e.breadcrumbs, ...d]), c.length && (e.fingerprint = [...e.fingerprint, ...c]), u.length && (e.eventProcessors = [...e.eventProcessors, ...u]), m.length && (e.attachments = [...e.attachments, ...m]), e.propagationContext = { ...e.propagationContext, ...f };
}
function np(e, t, s) {
  e[t] = Mu(e[t], s, 1);
}
function t7(e, t) {
  const { extra: s, tags: n, user: r, contexts: i, level: o, transactionName: l } = t;
  Object.keys(s).length && (e.extra = { ...s, ...e.extra }), Object.keys(n).length && (e.tags = { ...n, ...e.tags }), Object.keys(r).length && (e.user = { ...r, ...e.user }), Object.keys(i).length && (e.contexts = { ...i, ...e.contexts }), o && (e.level = o), l && e.type !== "transaction" && (e.transaction = l);
}
function s7(e, t) {
  const s = [...e.breadcrumbs || [], ...t];
  e.breadcrumbs = s.length ? s : void 0;
}
function a7(e, t) {
  e.sdkProcessingMetadata = {
    ...e.sdkProcessingMetadata,
    ...t
  };
}
function n7(e, t) {
  e.contexts = {
    trace: uO(t),
    ...e.contexts
  }, e.sdkProcessingMetadata = {
    dynamicSamplingContext: Fo(t),
    ...e.sdkProcessingMetadata
  };
  const s = Wa(t), n = ms(s).description;
  n && !e.transaction && e.type === "transaction" && (e.transaction = n);
}
function r7(e, t) {
  e.fingerprint = e.fingerprint ? Array.isArray(e.fingerprint) ? e.fingerprint : [e.fingerprint] : [], t && (e.fingerprint = e.fingerprint.concat(t)), e.fingerprint.length || delete e.fingerprint;
}
let rp, WA, op;
function n3(e) {
  const t = As._sentryDebugIds;
  if (!t)
    return {};
  const s = Object.keys(t);
  return op && s.length === WA || (WA = s.length, op = s.reduce((n, r) => {
    rp || (rp = {});
    const i = rp[r];
    if (i)
      n[i[0]] = i[1];
    else {
      const o = e(r);
      for (let l = o.length - 1; l >= 0; l--) {
        const d = o[l], c = d == null ? void 0 : d.filename, u = t[r];
        if (c && u) {
          n[c] = u, rp[r] = [c, u];
          break;
        }
      }
    }
    return n;
  }, {})), op;
}
function o7(e, t) {
  const s = n3(e);
  if (!s)
    return [];
  const n = [];
  for (const r of t)
    r && s[r] && n.push({
      type: "sourcemap",
      code_file: r,
      debug_id: s[r]
    });
  return n;
}
function r3(e, t, s, n, r, i) {
  const { normalizeDepth: o = 3, normalizeMaxBreadth: l = 1e3 } = e, d = {
    ...t,
    event_id: t.event_id || s.event_id || gn(),
    timestamp: t.timestamp || gl()
  }, c = s.integrations || e.integrations.map((S) => S.name);
  i7(d, e), c7(d, c), r && r.emit("applyFrameMetadata", t), t.type === void 0 && l7(d, e.stackParser);
  const u = p7(n, s.captureContext);
  s.mechanism && gd(d, s.mechanism);
  const m = r ? r.getEventProcessors() : [], f = MP().getScopeData();
  if (i) {
    const S = i.getScopeData();
    zA(f, S);
  }
  if (u) {
    const S = u.getScopeData();
    zA(f, S);
  }
  const v = [...s.attachments || [], ...f.attachments];
  v.length && (s.attachments = v), e7(d, f);
  const b = [
    ...m,
    // Run scope event processors _after_ all other processors
    ...f.eventProcessors
  ];
  return yv(b, d, s).then((S) => (S && d7(S), typeof o == "number" && o > 0 ? u7(S, o, l) : S));
}
function i7(e, t) {
  const { environment: s, release: n, dist: r, maxValueLength: i = 250 } = t;
  e.environment = e.environment || s || Um, !e.release && n && (e.release = n), !e.dist && r && (e.dist = r);
  const o = e.request;
  o != null && o.url && (o.url = Qh(o.url, i));
}
function l7(e, t) {
  var n, r;
  const s = n3(t);
  (r = (n = e.exception) == null ? void 0 : n.values) == null || r.forEach((i) => {
    var o, l;
    (l = (o = i.stacktrace) == null ? void 0 : o.frames) == null || l.forEach((d) => {
      d.filename && (d.debug_id = s[d.filename]);
    });
  });
}
function d7(e) {
  var n, r;
  const t = {};
  if ((r = (n = e.exception) == null ? void 0 : n.values) == null || r.forEach((i) => {
    var o, l;
    (l = (o = i.stacktrace) == null ? void 0 : o.frames) == null || l.forEach((d) => {
      d.debug_id && (d.abs_path ? t[d.abs_path] = d.debug_id : d.filename && (t[d.filename] = d.debug_id), delete d.debug_id);
    });
  }), Object.keys(t).length === 0)
    return;
  e.debug_meta = e.debug_meta || {}, e.debug_meta.images = e.debug_meta.images || [];
  const s = e.debug_meta.images;
  Object.entries(t).forEach(([i, o]) => {
    s.push({
      type: "sourcemap",
      code_file: i,
      debug_id: o
    });
  });
}
function c7(e, t) {
  t.length > 0 && (e.sdk = e.sdk || {}, e.sdk.integrations = [...e.sdk.integrations || [], ...t]);
}
function u7(e, t, s) {
  var r, i;
  if (!e)
    return null;
  const n = {
    ...e,
    ...e.breadcrumbs && {
      breadcrumbs: e.breadcrumbs.map((o) => ({
        ...o,
        ...o.data && {
          data: pr(o.data, t, s)
        }
      }))
    },
    ...e.user && {
      user: pr(e.user, t, s)
    },
    ...e.contexts && {
      contexts: pr(e.contexts, t, s)
    },
    ...e.extra && {
      extra: pr(e.extra, t, s)
    }
  };
  return (r = e.contexts) != null && r.trace && n.contexts && (n.contexts.trace = e.contexts.trace, e.contexts.trace.data && (n.contexts.trace.data = pr(e.contexts.trace.data, t, s))), e.spans && (n.spans = e.spans.map((o) => ({
    ...o,
    ...o.data && {
      data: pr(o.data, t, s)
    }
  }))), (i = e.contexts) != null && i.flags && n.contexts && (n.contexts.flags = pr(e.contexts.flags, 3, s)), n;
}
function p7(e, t) {
  if (!t)
    return e;
  const s = e ? e.clone() : new Wr();
  return s.update(t), s;
}
function h7(e) {
  if (e)
    return m7(e) ? { captureContext: e } : g7(e) ? {
      captureContext: e
    } : e;
}
function m7(e) {
  return e instanceof Wr || typeof e == "function";
}
const f7 = [
  "user",
  "level",
  "extra",
  "contexts",
  "tags",
  "fingerprint",
  "propagationContext"
];
function g7(e) {
  return Object.keys(e).some((t) => f7.includes(t));
}
function Ns(e, t) {
  return Is().captureException(e, h7(t));
}
function o3(e, t) {
  return Is().captureEvent(e, t);
}
function v7(e, t) {
  Wn().setContext(e, t);
}
function y7(e) {
  Wn().setUser(e);
}
function b7() {
  return Wn().lastEventId();
}
function bv() {
  const e = ds();
  return (e == null ? void 0 : e.getOptions().enabled) !== !1 && !!(e != null && e.getTransport());
}
function A7(e) {
  Wn().addEventProcessor(e);
}
function GA(e) {
  const t = Wn(), s = Is(), { userAgent: n } = As.navigator || {}, r = U9({
    user: s.getUser() || t.getUser(),
    ...n && { userAgent: n },
    ...e
  }), i = t.getSession();
  return (i == null ? void 0 : i.status) === "ok" && vd(i, { status: "exited" }), i3(), t.setSession(r), r;
}
function i3() {
  const e = Wn(), s = Is().getSession() || e.getSession();
  s && z9(s), l3(), e.setSession();
}
function l3() {
  const e = Wn(), t = ds(), s = e.getSession();
  s && t && t.captureSession(s);
}
function YA(e = !1) {
  if (e) {
    i3();
    return;
  }
  l3();
}
const w7 = "7";
function d3(e) {
  const t = e.protocol ? `${e.protocol}:` : "", s = e.port ? `:${e.port}` : "";
  return `${t}//${e.host}${s}${e.path ? `/${e.path}` : ""}/api/`;
}
function C7(e) {
  return `${d3(e)}${e.projectId}/envelope/`;
}
function S7(e, t) {
  const s = {
    sentry_version: w7
  };
  return e.publicKey && (s.sentry_key = e.publicKey), t && (s.sentry_client = `${t.name}/${t.version}`), new URLSearchParams(s).toString();
}
function P7(e, t, s) {
  return t || `${C7(e)}?${S7(e, s)}`;
}
function k7(e, t) {
  const s = qP(e);
  if (!s)
    return "";
  const n = `${d3(s)}embed/error-page/`;
  let r = `dsn=${Yd(s)}`;
  for (const i in t)
    if (i !== "dsn" && i !== "onClose")
      if (i === "user") {
        const o = t.user;
        if (!o)
          continue;
        o.name && (r += `&name=${encodeURIComponent(o.name)}`), o.email && (r += `&email=${encodeURIComponent(o.email)}`);
      } else
        r += `&${encodeURIComponent(i)}=${encodeURIComponent(t[i])}`;
  return `${n}?${r}`;
}
const XA = [];
function E7(e) {
  const t = {};
  return e.forEach((s) => {
    const { name: n } = s, r = t[n];
    r && !r.isDefaultInstance && s.isDefaultInstance || (t[n] = s);
  }), Object.values(t);
}
function I7(e) {
  const t = e.defaultIntegrations || [], s = e.integrations;
  t.forEach((r) => {
    r.isDefaultInstance = !0;
  });
  let n;
  if (Array.isArray(s))
    n = [...t, ...s];
  else if (typeof s == "function") {
    const r = s(t);
    n = Array.isArray(r) ? r : [r];
  } else
    n = t;
  return E7(n);
}
function T7(e, t) {
  const s = {};
  return t.forEach((n) => {
    n && c3(e, n, s);
  }), s;
}
function qA(e, t) {
  for (const s of t)
    s != null && s.afterAllSetup && s.afterAllSetup(e);
}
function c3(e, t, s) {
  if (s[t.name]) {
    zt && ot.log(`Integration skipped because it was already installed: ${t.name}`);
    return;
  }
  if (s[t.name] = t, XA.indexOf(t.name) === -1 && typeof t.setupOnce == "function" && (t.setupOnce(), XA.push(t.name)), t.setup && typeof t.setup == "function" && t.setup(e), typeof t.preprocessEvent == "function") {
    const n = t.preprocessEvent.bind(t);
    e.on("preprocessEvent", (r, i) => n(r, i, e));
  }
  if (typeof t.processEvent == "function") {
    const n = t.processEvent.bind(t), r = Object.assign((i, o) => n(i, o, e), {
      id: t.name
    });
    e.addEventProcessor(r);
  }
  zt && ot.log(`Integration installed: ${t.name}`);
}
function QA(e) {
  const t = ds();
  if (!t) {
    zt && ot.warn(`Cannot add integration "${e.name}" because no SDK Client is available.`);
    return;
  }
  t.addIntegration(e);
}
function O7(e, t, s) {
  const n = [
    { type: "client_report" },
    {
      timestamp: gl(),
      discarded_events: e
    }
  ];
  return yl(t ? { dsn: t } : {}, [n]);
}
function u3(e) {
  const t = [];
  e.message && t.push(e.message);
  try {
    const s = e.exception.values[e.exception.values.length - 1];
    s != null && s.value && (t.push(s.value), s.type && t.push(`${s.type}: ${s.value}`));
  } catch {
  }
  return t;
}
function R7(e) {
  var d;
  const { trace_id: t, parent_span_id: s, span_id: n, status: r, origin: i, data: o, op: l } = ((d = e.contexts) == null ? void 0 : d.trace) ?? {};
  return {
    data: o ?? {},
    description: e.transaction,
    op: l,
    parent_span_id: s,
    span_id: n ?? "",
    start_timestamp: e.start_timestamp ?? 0,
    status: r,
    timestamp: e.timestamp,
    trace_id: t ?? "",
    origin: i,
    profile_id: o == null ? void 0 : o[p1],
    exclusive_time: o == null ? void 0 : o[Gd],
    measurements: e.measurements,
    is_segment: !0
  };
}
function L7(e) {
  return {
    type: "transaction",
    timestamp: e.timestamp,
    start_timestamp: e.start_timestamp,
    transaction: e.description,
    contexts: {
      trace: {
        trace_id: e.trace_id,
        span_id: e.span_id,
        parent_span_id: e.parent_span_id,
        op: e.op,
        status: e.status,
        origin: e.origin,
        data: {
          ...e.data,
          ...e.profile_id && { [p1]: e.profile_id },
          ...e.exclusive_time && { [Gd]: e.exclusive_time }
        }
      }
    },
    measurements: e.measurements
  };
}
const KA = "Not capturing exception because it's already been captured.", ZA = "Discarded session because of missing or non-string release", p3 = Symbol.for("SentryInternalError"), h3 = Symbol.for("SentryDoNotSendEventError");
function nh(e) {
  return {
    message: e,
    [p3]: !0
  };
}
function Nf(e) {
  return {
    message: e,
    [h3]: !0
  };
}
function JA(e) {
  return !!e && typeof e == "object" && p3 in e;
}
function $A(e) {
  return !!e && typeof e == "object" && h3 in e;
}
class B7 {
  /** Options passed to the SDK. */
  /** The client Dsn, if specified in options. Without this Dsn, the SDK will be disabled. */
  /** Array of set up integrations. */
  /** Number of calls being processed */
  /** Holds flushable  */
  // eslint-disable-next-line @typescript-eslint/ban-types
  /**
   * Initializes this client instance.
   *
   * @param options Options for the client.
   */
  constructor(t) {
    if (this._options = t, this._integrations = {}, this._numProcessing = 0, this._outcomes = {}, this._hooks = {}, this._eventProcessors = [], t.dsn ? this._dsn = qP(t.dsn) : zt && ot.warn("No DSN provided, client will not send events."), this._dsn) {
      const s = P7(
        this._dsn,
        t.tunnel,
        t._metadata ? t._metadata.sdk : void 0
      );
      this._transport = t.transport({
        tunnel: this._options.tunnel,
        recordDroppedEvent: this.recordDroppedEvent.bind(this),
        ...t.transportOptions,
        url: s
      });
    }
  }
  /**
   * Captures an exception event and sends it to Sentry.
   *
   * Unlike `captureException` exported from every SDK, this method requires that you pass it the current scope.
   */
  captureException(t, s, n) {
    const r = gn();
    if (EA(t))
      return zt && ot.log(KA), r;
    const i = {
      event_id: r,
      ...s
    };
    return this._process(
      this.eventFromException(t, i).then(
        (o) => this._captureEvent(o, i, n)
      )
    ), i.event_id;
  }
  /**
   * Captures a message event and sends it to Sentry.
   *
   * Unlike `captureMessage` exported from every SDK, this method requires that you pass it the current scope.
   */
  captureMessage(t, s, n, r) {
    const i = {
      event_id: gn(),
      ...n
    }, o = l1(t) ? t : String(t), l = du(t) ? this.eventFromMessage(o, s, i) : this.eventFromException(t, i);
    return this._process(l.then((d) => this._captureEvent(d, i, r))), i.event_id;
  }
  /**
   * Captures a manually created event and sends it to Sentry.
   *
   * Unlike `captureEvent` exported from every SDK, this method requires that you pass it the current scope.
   */
  captureEvent(t, s, n) {
    const r = gn();
    if (s != null && s.originalException && EA(s.originalException))
      return zt && ot.log(KA), r;
    const i = {
      event_id: r,
      ...s
    }, o = t.sdkProcessingMetadata || {}, l = o.capturedSpanScope, d = o.capturedSpanIsolationScope;
    return this._process(
      this._captureEvent(t, i, l || n, d)
    ), i.event_id;
  }
  /**
   * Captures a session.
   */
  captureSession(t) {
    this.sendSession(t), vd(t, { init: !1 });
  }
  /**
   * Create a cron monitor check in and send it to Sentry. This method is not available on all clients.
   *
   * @param checkIn An object that describes a check in.
   * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
   * to create a monitor automatically when sending a check in.
   * @param scope An optional scope containing event metadata.
   * @returns A string representing the id of the check in.
   */
  /**
   * Get the current Dsn.
   */
  getDsn() {
    return this._dsn;
  }
  /**
   * Get the current options.
   */
  getOptions() {
    return this._options;
  }
  /**
   * Get the SDK metadata.
   * @see SdkMetadata
   */
  getSdkMetadata() {
    return this._options._metadata;
  }
  /**
   * Returns the transport that is used by the client.
   * Please note that the transport gets lazy initialized so it will only be there once the first event has been sent.
   */
  getTransport() {
    return this._transport;
  }
  /**
   * Wait for all events to be sent or the timeout to expire, whichever comes first.
   *
   * @param timeout Maximum time in ms the client should wait for events to be flushed. Omitting this parameter will
   *   cause the client to wait until all events are sent before resolving the promise.
   * @returns A promise that will resolve with `true` if all events are sent before the timeout, or `false` if there are
   * still events in the queue when the timeout is reached.
   */
  flush(t) {
    const s = this._transport;
    return s ? (this.emit("flush"), this._isClientDoneProcessing(t).then((n) => s.flush(t).then((r) => n && r))) : Vo(!0);
  }
  /**
   * Flush the event queue and set the client to `enabled = false`. See {@link Client.flush}.
   *
   * @param {number} timeout Maximum time in ms the client should wait before shutting down. Omitting this parameter will cause
   *   the client to wait until all events are sent before disabling itself.
   * @returns {Promise<boolean>} A promise which resolves to `true` if the flush completes successfully before the timeout, or `false` if
   * it doesn't.
   */
  close(t) {
    return this.flush(t).then((s) => (this.getOptions().enabled = !1, this.emit("close"), s));
  }
  /**
   * Get all installed event processors.
   */
  getEventProcessors() {
    return this._eventProcessors;
  }
  /**
   * Adds an event processor that applies to any event processed by this client.
   */
  addEventProcessor(t) {
    this._eventProcessors.push(t);
  }
  /**
   * Initialize this client.
   * Call this after the client was set on a scope.
   */
  init() {
    (this._isEnabled() || // Force integrations to be setup even if no DSN was set when we have
    // Spotlight enabled. This is particularly important for browser as we
    // don't support the `spotlight` option there and rely on the users
    // adding the `spotlightBrowserIntegration()` to their integrations which
    // wouldn't get initialized with the check below when there's no DSN set.
    this._options.integrations.some(({ name: t }) => t.startsWith("Spotlight"))) && this._setupIntegrations();
  }
  /**
   * Gets an installed integration by its name.
   *
   * @returns {Integration|undefined} The installed integration or `undefined` if no integration with that `name` was installed.
   */
  getIntegrationByName(t) {
    return this._integrations[t];
  }
  /**
   * Add an integration to the client.
   * This can be used to e.g. lazy load integrations.
   * In most cases, this should not be necessary,
   * and you're better off just passing the integrations via `integrations: []` at initialization time.
   * However, if you find the need to conditionally load & add an integration, you can use `addIntegration` to do so.
   */
  addIntegration(t) {
    const s = this._integrations[t.name];
    c3(this, t, this._integrations), s || qA(this, [t]);
  }
  /**
   * Send a fully prepared event to Sentry.
   */
  sendEvent(t, s = {}) {
    this.emit("beforeSendEvent", t, s);
    let n = VO(t, this._dsn, this._options._metadata, this._options.tunnel);
    for (const i of s.attachments || [])
      n = TO(n, BO(i));
    const r = this.sendEnvelope(n);
    r && r.then((i) => this.emit("afterSendEvent", t, i), null);
  }
  /**
   * Send a session or session aggregrates to Sentry.
   */
  sendSession(t) {
    const { release: s, environment: n = Um } = this._options;
    if ("aggregates" in t) {
      const i = t.attrs || {};
      if (!i.release && !s) {
        zt && ot.warn(ZA);
        return;
      }
      i.release = i.release || s, i.environment = i.environment || n, t.attrs = i;
    } else {
      if (!t.release && !s) {
        zt && ot.warn(ZA);
        return;
      }
      t.release = t.release || s, t.environment = t.environment || n;
    }
    this.emit("beforeSendSession", t);
    const r = FO(t, this._dsn, this._options._metadata, this._options.tunnel);
    this.sendEnvelope(r);
  }
  /**
   * Record on the client that an event got dropped (ie, an event that will not be sent to Sentry).
   */
  recordDroppedEvent(t, s, n = 1) {
    if (this._options.sendClientReports) {
      const r = `${t}:${s}`;
      zt && ot.log(`Recording outcome: "${r}"${n > 1 ? ` (${n} times)` : ""}`), this._outcomes[r] = (this._outcomes[r] || 0) + n;
    }
  }
  /* eslint-disable @typescript-eslint/unified-signatures */
  /**
   * Register a callback for whenever a span is started.
   * Receives the span as argument.
   * @returns {() => void} A function that, when executed, removes the registered callback.
   */
  /**
   * Register a hook on this client.
   */
  on(t, s) {
    const n = this._hooks[t] = this._hooks[t] || [];
    return n.push(s), () => {
      const r = n.indexOf(s);
      r > -1 && n.splice(r, 1);
    };
  }
  /** Fire a hook whenever a span starts. */
  /**
   * Emit a hook that was previously registered via `on()`.
   */
  emit(t, ...s) {
    const n = this._hooks[t];
    n && n.forEach((r) => r(...s));
  }
  /**
   * Send an envelope to Sentry.
   */
  sendEnvelope(t) {
    return this.emit("beforeEnvelope", t), this._isEnabled() && this._transport ? this._transport.send(t).then(null, (s) => (zt && ot.error("Error while sending envelope:", s), s)) : (zt && ot.error("Transport disabled"), Vo({}));
  }
  /* eslint-enable @typescript-eslint/unified-signatures */
  /** Setup integrations for this client. */
  _setupIntegrations() {
    const { integrations: t } = this._options;
    this._integrations = T7(this, t), qA(this, t);
  }
  /** Updates existing session based on the provided event */
  _updateSessionFromEvent(t, s) {
    var d;
    let n = s.level === "fatal", r = !1;
    const i = (d = s.exception) == null ? void 0 : d.values;
    if (i) {
      r = !0;
      for (const c of i) {
        const u = c.mechanism;
        if ((u == null ? void 0 : u.handled) === !1) {
          n = !0;
          break;
        }
      }
    }
    const o = t.status === "ok";
    (o && t.errors === 0 || o && n) && (vd(t, {
      ...n && { status: "crashed" },
      errors: t.errors || Number(r || n)
    }), this.captureSession(t));
  }
  /**
   * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
   * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
   * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
   * `false` otherwise
   */
  _isClientDoneProcessing(t) {
    return new Ai((s) => {
      let n = 0;
      const r = 1, i = setInterval(() => {
        this._numProcessing == 0 ? (clearInterval(i), s(!0)) : (n += r, t && n >= t && (clearInterval(i), s(!1)));
      }, r);
    });
  }
  /** Determines whether this SDK is enabled and a transport is present. */
  _isEnabled() {
    return this.getOptions().enabled !== !1 && this._transport !== void 0;
  }
  /**
   * Adds common information to events.
   *
   * The information includes release and environment from `options`,
   * breadcrumbs and context (extra, tags and user) from the scope.
   *
   * Information that is already present in the event is never overwritten. For
   * nested objects, such as the context, keys are merged.
   *
   * @param event The original event.
   * @param hint May contain additional information about the original exception.
   * @param currentScope A scope containing event metadata.
   * @returns A new event with more information.
   */
  _prepareEvent(t, s, n, r) {
    const i = this.getOptions(), o = Object.keys(this._integrations);
    return !s.integrations && (o != null && o.length) && (s.integrations = o), this.emit("preprocessEvent", t, s), t.type || r.setLastEventId(t.event_id || s.event_id), r3(i, t, s, n, this, r).then((l) => {
      if (l === null)
        return l;
      this.emit("postprocessEvent", l, s), l.contexts = {
        trace: J9(n),
        ...l.contexts
      };
      const d = ZP(this, n);
      return l.sdkProcessingMetadata = {
        dynamicSamplingContext: d,
        ...l.sdkProcessingMetadata
      }, l;
    });
  }
  /**
   * Processes the event and logs an error in case of rejection
   * @param event
   * @param hint
   * @param scope
   */
  _captureEvent(t, s = {}, n = Is(), r = Wn()) {
    return zt && Av(t) && ot.log(`Captured error event \`${u3(t)[0] || "<unknown>"}\``), this._processEvent(t, s, n, r).then(
      (i) => i.event_id,
      (i) => {
        zt && ($A(i) ? ot.log(i.message) : JA(i) ? ot.warn(i.message) : ot.warn(i));
      }
    );
  }
  /**
   * Processes an event (either error or message) and sends it to Sentry.
   *
   * This also adds breadcrumbs and context information to the event. However,
   * platform specific meta data (such as the User's IP address) must be added
   * by the SDK implementor.
   *
   *
   * @param event The event to send to Sentry.
   * @param hint May contain additional information about the original exception.
   * @param currentScope A scope containing event metadata.
   * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
   */
  _processEvent(t, s, n, r) {
    const i = this.getOptions(), { sampleRate: o } = i, l = m3(t), d = Av(t), c = t.type || "error", u = `before send for type \`${c}\``, m = typeof o > "u" ? void 0 : nl(o);
    if (d && typeof m == "number" && Math.random() > m)
      return this.recordDroppedEvent("sample_rate", "error"), _h(
        Nf(
          `Discarding event because it's not included in the random sample (sampling rate = ${o})`
        )
      );
    const f = c === "replay_event" ? "replay" : c;
    return this._prepareEvent(t, s, n, r).then((v) => {
      if (v === null)
        throw this.recordDroppedEvent("event_processor", f), Nf("An event processor returned `null`, will not send event.");
      if (s.data && s.data.__sentry__ === !0)
        return v;
      const w = x7(this, i, v, s);
      return M7(w, u);
    }).then((v) => {
      var S;
      if (v === null) {
        if (this.recordDroppedEvent("before_send", f), l) {
          const T = 1 + (t.spans || []).length;
          this.recordDroppedEvent("before_send", "span", T);
        }
        throw Nf(`${u} returned \`null\`, will not send event.`);
      }
      const b = n.getSession() || r.getSession();
      if (d && b && this._updateSessionFromEvent(b, v), l) {
        const I = ((S = v.sdkProcessingMetadata) == null ? void 0 : S.spanCountBeforeProcessing) || 0, T = v.spans ? v.spans.length : 0, x = I - T;
        x > 0 && this.recordDroppedEvent("before_send", "span", x);
      }
      const w = v.transaction_info;
      if (l && w && v.transaction !== t.transaction) {
        const I = "custom";
        v.transaction_info = {
          ...w,
          source: I
        };
      }
      return this.sendEvent(v, s), v;
    }).then(null, (v) => {
      throw $A(v) || JA(v) ? v : (this.captureException(v, {
        data: {
          __sentry__: !0
        },
        originalException: v
      }), nh(
        `Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.
Reason: ${v}`
      ));
    });
  }
  /**
   * Occupies the client with processing and event
   */
  _process(t) {
    this._numProcessing++, t.then(
      (s) => (this._numProcessing--, s),
      (s) => (this._numProcessing--, s)
    );
  }
  /**
   * Clears outcomes on this client and returns them.
   */
  _clearOutcomes() {
    const t = this._outcomes;
    return this._outcomes = {}, Object.entries(t).map(([s, n]) => {
      const [r, i] = s.split(":");
      return {
        reason: r,
        category: i,
        quantity: n
      };
    });
  }
  /**
   * Sends client reports as an envelope.
   */
  _flushOutcomes() {
    zt && ot.log("Flushing outcomes...");
    const t = this._clearOutcomes();
    if (t.length === 0) {
      zt && ot.log("No outcomes to send");
      return;
    }
    if (!this._dsn) {
      zt && ot.log("No dsn provided, will not send outcomes");
      return;
    }
    zt && ot.log("Sending outcomes:", t);
    const s = O7(t, this._options.tunnel && Yd(this._dsn));
    this.sendEnvelope(s);
  }
  /**
   * Creates an {@link Event} from all inputs to `captureException` and non-primitive inputs to `captureMessage`.
   */
}
function M7(e, t) {
  const s = `${t} must return \`null\` or a valid event.`;
  if (Bu(e))
    return e.then(
      (n) => {
        if (!cu(n) && n !== null)
          throw nh(s);
        return n;
      },
      (n) => {
        throw nh(`${t} rejected with ${n}`);
      }
    );
  if (!cu(e) && e !== null)
    throw nh(s);
  return e;
}
function x7(e, t, s, n) {
  const { beforeSend: r, beforeSendTransaction: i, beforeSendSpan: o } = t;
  let l = s;
  if (Av(l) && r)
    return r(l, n);
  if (m3(l)) {
    if (o) {
      const d = o(R7(l));
      if (d ? l = Mu(s, L7(d)) : fv(), l.spans) {
        const c = [];
        for (const u of l.spans) {
          const m = o(u);
          m ? c.push(m) : (fv(), c.push(u));
        }
        l.spans = c;
      }
    }
    if (i) {
      if (l.spans) {
        const d = l.spans.length;
        l.sdkProcessingMetadata = {
          ...s.sdkProcessingMetadata,
          spanCountBeforeProcessing: d
        };
      }
      return i(l, n);
    }
  }
  return l;
}
function Av(e) {
  return e.type === void 0;
}
function m3(e) {
  return e.type === "transaction";
}
function F7(e) {
  return [
    {
      type: "log",
      item_count: e.length,
      content_type: "application/vnd.sentry.items.log+json"
    },
    {
      items: e
    }
  ];
}
function V7(e, t, s, n) {
  const r = {};
  return t != null && t.sdk && (r.sdk = {
    name: t.sdk.name,
    version: t.sdk.version
  }), s && n && (r.dsn = Yd(n)), yl(r, [F7(e)]);
}
function jf(e, t) {
  const s = D7(e) ?? [];
  if (s.length === 0)
    return;
  const n = e.getOptions(), r = V7(s, n._metadata, n.tunnel, e.getDsn());
  f3().set(e, []), e.emit("flushLogs"), e.sendEnvelope(r);
}
function D7(e) {
  return f3().get(e);
}
function f3() {
  return Lu("clientToLogBufferMap", () => /* @__PURE__ */ new WeakMap());
}
function N7(e, t) {
  t.debug === !0 && (zt ? ot.enable() : Yo(() => {
    console.warn("[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.");
  })), Is().update(t.initialScope);
  const n = new e(t);
  return j7(n), n.init(), n;
}
function j7(e) {
  Is().setClient(e);
}
const g3 = Symbol.for("SentryBufferFullError");
function H7(e) {
  const t = [];
  function s() {
    return e === void 0 || t.length < e;
  }
  function n(o) {
    return t.splice(t.indexOf(o), 1)[0] || Promise.resolve(void 0);
  }
  function r(o) {
    if (!s())
      return _h(g3);
    const l = o();
    return t.indexOf(l) === -1 && t.push(l), l.then(() => n(l)).then(
      null,
      () => n(l).then(null, () => {
      })
    ), l;
  }
  function i(o) {
    return new Ai((l, d) => {
      let c = t.length;
      if (!c)
        return l(!0);
      const u = setTimeout(() => {
        o && o > 0 && l(!1);
      }, o);
      t.forEach((m) => {
        Vo(m).then(() => {
          --c || (clearTimeout(u), l(!0));
        }, d);
      });
    });
  }
  return {
    $: t,
    add: r,
    drain: i
  };
}
const U7 = 60 * 1e3;
function z7(e, t = Date.now()) {
  const s = parseInt(`${e}`, 10);
  if (!isNaN(s))
    return s * 1e3;
  const n = Date.parse(`${e}`);
  return isNaN(n) ? U7 : n - t;
}
function W7(e, t) {
  return e[t] || e.all || 0;
}
function v3(e, t, s = Date.now()) {
  return W7(e, t) > s;
}
function y3(e, { statusCode: t, headers: s }, n = Date.now()) {
  const r = {
    ...e
  }, i = s == null ? void 0 : s["x-sentry-rate-limits"], o = s == null ? void 0 : s["retry-after"];
  if (i)
    for (const l of i.trim().split(",")) {
      const [d, c, , , u] = l.split(":", 5), m = parseInt(d, 10), f = (isNaN(m) ? 60 : m) * 1e3;
      if (!c)
        r.all = n + f;
      else
        for (const v of c.split(";"))
          v === "metric_bucket" ? (!u || u.split(";").includes("custom")) && (r[v] = n + f) : r[v] = n + f;
    }
  else o ? r.all = n + z7(o, n) : t === 429 && (r.all = n + 60 * 1e3);
  return r;
}
const G7 = 64;
function Y7(e, t, s = H7(
  e.bufferSize || G7
)) {
  let n = {};
  const r = (o) => s.drain(o);
  function i(o) {
    const l = [];
    if ($h(o, (m, f) => {
      const v = xA(f);
      v3(n, v) ? e.recordDroppedEvent("ratelimit_backoff", v) : l.push(m);
    }), l.length === 0)
      return Vo({});
    const d = yl(o[0], l), c = (m) => {
      $h(d, (f, v) => {
        e.recordDroppedEvent(m, xA(v));
      });
    }, u = () => t({ body: OO(d) }).then(
      (m) => (m.statusCode !== void 0 && (m.statusCode < 200 || m.statusCode >= 300) && zt && ot.warn(`Sentry responded with status code ${m.statusCode} to sent event.`), n = y3(n, m), m),
      (m) => {
        throw c("network_error"), zt && ot.error("Encountered error running transport request:", m), m;
      }
    );
    return s.add(u).then(
      (m) => m,
      (m) => {
        if (m === g3)
          return zt && ot.error("Skipped sending event because buffer is full."), c("queue_overflow"), Vo({});
        throw m;
      }
    );
  }
  return {
    send: i,
    flush: r
  };
}
function X7(e, t) {
  const s = t == null ? void 0 : t.getDsn(), n = t == null ? void 0 : t.getOptions().tunnel;
  return Q7(e, s) || q7(e, n);
}
function q7(e, t) {
  return t ? _A(e) === _A(t) : !1;
}
function Q7(e, t) {
  return t ? e.includes(t.host) : !1;
}
function _A(e) {
  return e[e.length - 1] === "/" ? e.slice(0, -1) : e;
}
function K7(e) {
  var t;
  ((t = e.user) == null ? void 0 : t.ip_address) === void 0 && (e.user = {
    ...e.user,
    ip_address: "{{auto}}"
  });
}
function Z7(e) {
  var t;
  "aggregates" in e ? ((t = e.attrs) == null ? void 0 : t.ip_address) === void 0 && (e.attrs = {
    ...e.attrs,
    ip_address: "{{auto}}"
  }) : e.ipAddress === void 0 && (e.ipAddress = "{{auto}}");
}
function b3(e, t, s = [t], n = "npm") {
  const r = e._metadata || {};
  r.sdk || (r.sdk = {
    name: `sentry.javascript.${t}`,
    packages: s.map((i) => ({
      name: `${n}:@sentry/${i}`,
      version: Zi
    })),
    version: Zi
  }), e._metadata = r;
}
function A3(e = {}) {
  const t = e.client || ds();
  if (!bv() || !t)
    return {};
  const s = ml(), n = Wd(s);
  if (n.getTraceData)
    return n.getTraceData(e);
  const r = e.scope || Is(), i = e.span || Ja(), o = i ? pO(i) : J7(r), l = i ? Fo(i) : ZP(t, r), d = nO(l);
  return HP.test(o) ? {
    "sentry-trace": o,
    baggage: d
  } : (ot.warn("Invalid sentry-trace data. Cannot generate trace data"), {});
}
function J7(e) {
  const { traceId: t, sampled: s, propagationSpanId: n } = e.getPropagationContext();
  return UP(t, n, s);
}
function $7(e, t, s) {
  let n, r, i;
  const o = s != null && s.maxWait ? Math.max(s.maxWait, t) : 0, l = (s == null ? void 0 : s.setTimeoutImpl) || setTimeout;
  function d() {
    return c(), n = e(), n;
  }
  function c() {
    r !== void 0 && clearTimeout(r), i !== void 0 && clearTimeout(i), r = i = void 0;
  }
  function u() {
    return r !== void 0 || i !== void 0 ? d() : n;
  }
  function m() {
    return r && clearTimeout(r), r = l(d, t), o && i === void 0 && (i = l(d, o)), n;
  }
  return m.cancel = c, m.flush = u, m;
}
const _7 = 100;
function wi(e, t) {
  const s = ds(), n = Wn();
  if (!s) return;
  const { beforeBreadcrumb: r = null, maxBreadcrumbs: i = _7 } = s.getOptions();
  if (i <= 0) return;
  const l = { timestamp: gl(), ...e }, d = r ? Yo(() => r(l, t)) : l;
  d !== null && (s.emit && s.emit("beforeAddBreadcrumb", d, t), n.addBreadcrumb(d, i));
}
let e0;
const eR = "FunctionToString", t0 = /* @__PURE__ */ new WeakMap(), tR = () => ({
  name: eR,
  setupOnce() {
    e0 = Function.prototype.toString;
    try {
      Function.prototype.toString = function(...e) {
        const t = c1(this), s = t0.has(ds()) && t !== void 0 ? t : this;
        return e0.apply(s, e);
      };
    } catch {
    }
  },
  setup(e) {
    t0.set(e, !0);
  }
}), sR = tR, aR = [
  /^Script error\.?$/,
  /^Javascript error: Script error\.? on line 0$/,
  /^ResizeObserver loop completed with undelivered notifications.$/,
  // The browser logs this when a ResizeObserver handler takes a bit longer. Usually this is not an actual issue though. It indicates slowness.
  /^Cannot redefine property: googletag$/,
  // This is thrown when google tag manager is used in combination with an ad blocker
  /^Can't find variable: gmo$/,
  // Error from Google Search App https://issuetracker.google.com/issues/396043331
  /^undefined is not an object \(evaluating 'a\.[A-Z]'\)$/,
  // Random error that happens but not actionable or noticeable to end-users.
  `can't redefine non-configurable property "solana"`,
  // Probably a browser extension or custom browser (Brave) throwing this error
  "vv().getRestrictions is not a function. (In 'vv().getRestrictions(1,a)', 'vv().getRestrictions' is undefined)",
  // Error thrown by GTM, seemingly not affecting end-users
  "Can't find variable: _AutofillCallbackHandler",
  // Unactionable error in instagram webview https://developers.facebook.com/community/threads/320013549791141/
  /^Non-Error promise rejection captured with value: Object Not Found Matching Id:\d+, MethodName:simulateEvent, ParamCount:\d+$/,
  // unactionable error from CEFSharp, a .NET library that embeds chromium in .NET apps
  /^Java exception was raised during method invocation$/
  // error from Facebook Mobile browser (https://github.com/getsentry/sentry-javascript/issues/15065)
], nR = "EventFilters", rR = (e = {}) => {
  let t;
  return {
    name: nR,
    setup(s) {
      const n = s.getOptions();
      t = s0(e, n);
    },
    processEvent(s, n, r) {
      if (!t) {
        const i = r.getOptions();
        t = s0(e, i);
      }
      return iR(s, t) ? null : s;
    }
  };
}, oR = (e = {}) => ({
  ...rR(e),
  name: "InboundFilters"
});
function s0(e = {}, t = {}) {
  return {
    allowUrls: [...e.allowUrls || [], ...t.allowUrls || []],
    denyUrls: [...e.denyUrls || [], ...t.denyUrls || []],
    ignoreErrors: [
      ...e.ignoreErrors || [],
      ...t.ignoreErrors || [],
      ...e.disableErrorDefaults ? [] : aR
    ],
    ignoreTransactions: [...e.ignoreTransactions || [], ...t.ignoreTransactions || []]
  };
}
function iR(e, t) {
  if (e.type) {
    if (e.type === "transaction" && dR(e, t.ignoreTransactions))
      return zt && ot.warn(
        `Event dropped due to being matched by \`ignoreTransactions\` option.
Event: ${ji(e)}`
      ), !0;
  } else {
    if (lR(e, t.ignoreErrors))
      return zt && ot.warn(
        `Event dropped due to being matched by \`ignoreErrors\` option.
Event: ${ji(e)}`
      ), !0;
    if (hR(e))
      return zt && ot.warn(
        `Event dropped due to not having an error message, error type or stacktrace.
Event: ${ji(
          e
        )}`
      ), !0;
    if (cR(e, t.denyUrls))
      return zt && ot.warn(
        `Event dropped due to being matched by \`denyUrls\` option.
Event: ${ji(
          e
        )}.
Url: ${em(e)}`
      ), !0;
    if (!uR(e, t.allowUrls))
      return zt && ot.warn(
        `Event dropped due to not being matched by \`allowUrls\` option.
Event: ${ji(
          e
        )}.
Url: ${em(e)}`
      ), !0;
  }
  return !1;
}
function lR(e, t) {
  return t != null && t.length ? u3(e).some((s) => Io(s, t)) : !1;
}
function dR(e, t) {
  if (!(t != null && t.length))
    return !1;
  const s = e.transaction;
  return s ? Io(s, t) : !1;
}
function cR(e, t) {
  if (!(t != null && t.length))
    return !1;
  const s = em(e);
  return s ? Io(s, t) : !1;
}
function uR(e, t) {
  if (!(t != null && t.length))
    return !0;
  const s = em(e);
  return s ? Io(s, t) : !0;
}
function pR(e = []) {
  for (let t = e.length - 1; t >= 0; t--) {
    const s = e[t];
    if (s && s.filename !== "<anonymous>" && s.filename !== "[native code]")
      return s.filename || null;
  }
  return null;
}
function em(e) {
  var t, s;
  try {
    const n = [...((t = e.exception) == null ? void 0 : t.values) ?? []].reverse().find((i) => {
      var o, l, d;
      return ((o = i.mechanism) == null ? void 0 : o.parent_id) === void 0 && ((d = (l = i.stacktrace) == null ? void 0 : l.frames) == null ? void 0 : d.length);
    }), r = (s = n == null ? void 0 : n.stacktrace) == null ? void 0 : s.frames;
    return r ? pR(r) : null;
  } catch {
    return zt && ot.error(`Cannot extract url for event ${ji(e)}`), null;
  }
}
function hR(e) {
  var t, s;
  return (s = (t = e.exception) == null ? void 0 : t.values) != null && s.length ? (
    // No top-level message
    !e.message && // There are no exception values that have a stacktrace, a non-generic-Error type or value
    !e.exception.values.some((n) => n.stacktrace || n.type && n.type !== "Error" || n.value)
  ) : !1;
}
function mR(e, t, s, n, r, i) {
  var l;
  if (!((l = r.exception) != null && l.values) || !i || !Bo(i.originalException, Error))
    return;
  const o = r.exception.values.length > 0 ? r.exception.values[r.exception.values.length - 1] : void 0;
  o && (r.exception.values = wv(
    e,
    t,
    n,
    i.originalException,
    s,
    r.exception.values,
    o,
    0
  ));
}
function wv(e, t, s, n, r, i, o, l) {
  if (i.length >= s + 1)
    return i;
  let d = [...i];
  if (Bo(n[r], Error)) {
    a0(o, l);
    const c = e(t, n[r]), u = d.length;
    n0(c, r, u, l), d = wv(
      e,
      t,
      s,
      n[r],
      r,
      [c, ...d],
      c,
      u
    );
  }
  return Array.isArray(n.errors) && n.errors.forEach((c, u) => {
    if (Bo(c, Error)) {
      a0(o, l);
      const m = e(t, c), f = d.length;
      n0(m, `errors[${u}]`, f, l), d = wv(
        e,
        t,
        s,
        c,
        r,
        [m, ...d],
        m,
        f
      );
    }
  }), d;
}
function a0(e, t) {
  e.mechanism = e.mechanism || { type: "generic", handled: !0 }, e.mechanism = {
    ...e.mechanism,
    ...e.type === "AggregateError" && { is_exception_group: !0 },
    exception_id: t
  };
}
function n0(e, t, s, n) {
  e.mechanism = e.mechanism || { type: "generic", handled: !0 }, e.mechanism = {
    ...e.mechanism,
    type: "chained",
    source: t,
    exception_id: s,
    parent_id: n
  };
}
const w3 = /* @__PURE__ */ new Map(), r0 = /* @__PURE__ */ new Set();
function fR(e) {
  if (As._sentryModuleMetadata)
    for (const t of Object.keys(As._sentryModuleMetadata)) {
      const s = As._sentryModuleMetadata[t];
      if (r0.has(t))
        continue;
      r0.add(t);
      const n = e(t);
      for (const r of n.reverse())
        if (r.filename) {
          w3.set(r.filename, s);
          break;
        }
    }
}
function gR(e, t) {
  return fR(e), w3.get(t);
}
function vR(e, t) {
  try {
    t.exception.values.forEach((s) => {
      if (s.stacktrace)
        for (const n of s.stacktrace.frames || []) {
          if (!n.filename || n.module_metadata)
            continue;
          const r = gR(e, n.filename);
          r && (n.module_metadata = r);
        }
    });
  } catch {
  }
}
function yR(e) {
  try {
    e.exception.values.forEach((t) => {
      if (t.stacktrace)
        for (const s of t.stacktrace.frames || [])
          delete s.module_metadata;
    });
  } catch {
  }
}
function bR(e) {
  const t = "console";
  Ri(t, e), Li(t, AR);
}
function AR() {
  "console" in As && y9.forEach(function(e) {
    e in As.console && In(As.console, e, function(t) {
      return qh[e] = t, function(...s) {
        nr("console", { args: s, level: e });
        const r = qh[e];
        r == null || r.apply(As.console, s);
      };
    });
  });
}
function C3(e) {
  return e === "warn" ? "warning" : ["fatal", "error", "warning", "log", "info", "debug"].includes(e) ? e : "log";
}
const wR = "Dedupe", CR = () => {
  let e;
  return {
    name: wR,
    processEvent(t) {
      if (t.type)
        return t;
      try {
        if (PR(t, e))
          return zt && ot.warn("Event dropped due to being a duplicate of previously captured event."), null;
      } catch {
      }
      return e = t;
    }
  };
}, SR = CR;
function PR(e, t) {
  return t ? !!(kR(e, t) || ER(e, t)) : !1;
}
function kR(e, t) {
  const s = e.message, n = t.message;
  return !(!s && !n || s && !n || !s && n || s !== n || !P3(e, t) || !S3(e, t));
}
function ER(e, t) {
  const s = o0(t), n = o0(e);
  return !(!s || !n || s.type !== n.type || s.value !== n.value || !P3(e, t) || !S3(e, t));
}
function S3(e, t) {
  let s = uv(e), n = uv(t);
  if (!s && !n)
    return !0;
  if (s && !n || !s && n || (s = s, n = n, n.length !== s.length))
    return !1;
  for (let r = 0; r < n.length; r++) {
    const i = n[r], o = s[r];
    if (i.filename !== o.filename || i.lineno !== o.lineno || i.colno !== o.colno || i.function !== o.function)
      return !1;
  }
  return !0;
}
function P3(e, t) {
  let s = e.fingerprint, n = t.fingerprint;
  if (!s && !n)
    return !0;
  if (s && !n || !s && n)
    return !1;
  s = s, n = n;
  try {
    return s.join("") === n.join("");
  } catch {
    return !1;
  }
}
function o0(e) {
  var t, s;
  return (s = (t = e.exception) == null ? void 0 : t.values) == null ? void 0 : s[0];
}
const IR = (e) => ({
  name: "ThirdPartyErrorsFilter",
  setup(t) {
    t.on("beforeEnvelope", (s) => {
      $h(s, (n, r) => {
        if (r === "event") {
          const i = Array.isArray(n) ? n[1] : void 0;
          i && (yR(i), n[1] = i);
        }
      });
    }), t.on("applyFrameMetadata", (s) => {
      if (s.type)
        return;
      const n = t.getOptions().stackParser;
      vR(n, s);
    });
  },
  processEvent(t) {
    const s = TR(t);
    if (s) {
      const n = e.behaviour === "drop-error-if-contains-third-party-frames" || e.behaviour === "apply-tag-if-contains-third-party-frames" ? "some" : "every";
      if (s[n]((i) => !i.some((o) => e.filterKeys.includes(o)))) {
        if (e.behaviour === "drop-error-if-contains-third-party-frames" || e.behaviour === "drop-error-if-exclusively-contains-third-party-frames")
          return null;
        t.tags = {
          ...t.tags,
          third_party_code: !0
        };
      }
    }
    return t;
  }
});
function TR(e) {
  const t = uv(e);
  if (t)
    return t.filter((s) => !!s.filename).map((s) => s.module_metadata ? Object.keys(s.module_metadata).filter((n) => n.startsWith(i0)).map((n) => n.slice(i0.length)) : []);
}
const i0 = "_sentryBundlerPluginAppKey:", OR = "thismessage:/";
function k3(e) {
  return "isRelative" in e;
}
function E3(e, t) {
  const s = e.indexOf("://") <= 0 && e.indexOf("//") !== 0, n = s ? OR : void 0;
  try {
    if ("canParse" in URL && !URL.canParse(e, n))
      return;
    const r = new URL(e, n);
    return s ? {
      isRelative: s,
      pathname: r.pathname,
      search: r.search,
      hash: r.hash
    } : r;
  } catch {
  }
}
function RR(e) {
  if (k3(e))
    return e.pathname;
  const t = new URL(e);
  return t.search = "", t.hash = "", ["80", "443"].includes(t.port) && (t.port = ""), t.password && (t.password = "%filtered%"), t.username && (t.username = "%filtered%"), t.toString();
}
function _i(e) {
  if (!e)
    return {};
  const t = e.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
  if (!t)
    return {};
  const s = t[6] || "", n = t[8] || "";
  return {
    host: t[4],
    path: t[5],
    protocol: t[2],
    search: s,
    hash: n,
    relative: t[5] + s + n
    // everything minus origin
  };
}
function LR(e) {
  return e.split(/[?#]/, 1)[0];
}
function BR(e, t, s, n, r = "auto.http.browser") {
  if (!e.fetchData)
    return;
  const { method: i, url: o } = e.fetchData, l = xo() && t(o);
  if (e.endTimestamp && l) {
    const m = e.fetchData.__span;
    if (!m) return;
    const f = n[m];
    f && (xR(f, e), delete n[m]);
    return;
  }
  const d = !!Ja(), c = l && d ? bi(VR(o, i, r)) : new yi();
  if (e.fetchData.__span = c.spanContext().spanId, n[c.spanContext().spanId] = c, s(e.fetchData.url)) {
    const m = e.args[0], f = e.args[1] || {}, v = MR(
      m,
      f,
      // If performance is disabled (TWP) or there's no active root span (pageload/navigation/interaction),
      // we do not want to use the span as base for the trace headers,
      // which means that the headers will be generated from the scope and the sampling decision is deferred
      xo() && d ? c : void 0
    );
    v && (e.args[1] = f, f.headers = v);
  }
  const u = ds();
  if (u) {
    const m = {
      input: e.args,
      response: e.response,
      startTimestamp: e.startTimestamp,
      endTimestamp: e.endTimestamp
    };
    u.emit("beforeOutgoingRequestSpan", c, m);
  }
  return c;
}
function MR(e, t, s) {
  const n = A3({ span: s }), r = n["sentry-trace"], i = n.baggage;
  if (!r)
    return;
  const o = t.headers || (IP(e) ? e.headers : void 0);
  if (o)
    if (FR(o)) {
      const l = new Headers(o);
      if (l.get("sentry-trace") || l.set("sentry-trace", r), i) {
        const d = l.get("baggage");
        d ? ip(d) || l.set("baggage", `${d},${i}`) : l.set("baggage", i);
      }
      return l;
    } else if (Array.isArray(o)) {
      const l = [...o];
      o.find((c) => c[0] === "sentry-trace") || l.push(["sentry-trace", r]);
      const d = o.find(
        (c) => c[0] === "baggage" && ip(c[1])
      );
      return i && !d && l.push(["baggage", i]), l;
    } else {
      const l = "sentry-trace" in o ? o["sentry-trace"] : void 0, d = "baggage" in o ? o.baggage : void 0, c = d ? Array.isArray(d) ? [...d] : [d] : [], u = d && (Array.isArray(d) ? d.find((m) => ip(m)) : ip(d));
      return i && !u && c.push(i), {
        ...o,
        "sentry-trace": l ?? r,
        baggage: c.length > 0 ? c.join(",") : void 0
      };
    }
  else return { ...n };
}
function xR(e, t) {
  var s, n;
  if (t.response) {
    VP(e, t.response.status);
    const r = (n = (s = t.response) == null ? void 0 : s.headers) == null ? void 0 : n.get("content-length");
    if (r) {
      const i = parseInt(r);
      i > 0 && e.setAttribute("http.response_content_length", i);
    }
  } else t.error && e.setStatus({ code: ja, message: "internal_error" });
  e.end();
}
function ip(e) {
  return e.split(",").some((t) => t.trim().startsWith(h1));
}
function FR(e) {
  return typeof Headers < "u" && Bo(e, Headers);
}
function VR(e, t, s) {
  const n = E3(e);
  return {
    name: n ? `${t} ${RR(n)}` : t,
    attributes: DR(e, n, t, s)
  };
}
function DR(e, t, s, n) {
  const r = {
    url: e,
    type: "fetch",
    "http.method": s,
    [Ca]: n,
    [Mo]: "http.client"
  };
  return t && (k3(t) || (r["http.url"] = t.href, r["server.address"] = t.host), t.search && (r["http.query"] = t.search), t.hash && (r["http.fragment"] = t.hash)), r;
}
function NR(e, t = {}, s = Is()) {
  const { message: n, name: r, email: i, url: o, source: l, associatedEventId: d, tags: c } = e, u = {
    contexts: {
      feedback: {
        contact_email: i,
        name: r,
        message: n,
        url: o,
        source: l,
        associated_event_id: d
      }
    },
    type: "feedback",
    level: "info",
    tags: c
  }, m = (s == null ? void 0 : s.getClient()) || ds();
  return m && m.emit("beforeSendFeedback", u, t), s.captureEvent(u, t);
}
function I3(e) {
  if (e !== void 0)
    return e >= 400 && e < 500 ? "warning" : e >= 500 ? "error" : void 0;
}
const uu = As;
function jR() {
  return "history" in uu && !!uu.history;
}
function HR() {
  if (!("fetch" in uu))
    return !1;
  try {
    return new Headers(), new Request("http://www.example.com"), new Response(), !0;
  } catch {
    return !1;
  }
}
function Cv(e) {
  return e && /^function\s+\w+\(\)\s+\{\s+\[native code\]\s+\}$/.test(e.toString());
}
function UR() {
  var s;
  if (typeof EdgeRuntime == "string")
    return !0;
  if (!HR())
    return !1;
  if (Cv(uu.fetch))
    return !0;
  let e = !1;
  const t = uu.document;
  if (t && typeof t.createElement == "function")
    try {
      const n = t.createElement("iframe");
      n.hidden = !0, t.head.appendChild(n), (s = n.contentWindow) != null && s.fetch && (e = Cv(n.contentWindow.fetch)), t.head.removeChild(n);
    } catch (n) {
      zt && ot.warn("Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ", n);
    }
  return e;
}
function T3(e, t) {
  const s = "fetch";
  Ri(s, e), Li(s, () => O3(void 0, t));
}
function zR(e) {
  const t = "fetch-body-resolved";
  Ri(t, e), Li(t, () => O3(GR));
}
function O3(e, t = !1) {
  t && !UR() || In(As, "fetch", function(s) {
    return function(...n) {
      const r = new Error(), { method: i, url: o } = YR(n), l = {
        args: n,
        fetchData: {
          method: i,
          url: o
        },
        startTimestamp: Ea() * 1e3,
        // // Adding the error to be able to fingerprint the failed fetch event in HttpClient instrumentation
        virtualError: r,
        headers: XR(n)
      };
      return e || nr("fetch", {
        ...l
      }), s.apply(As, n).then(
        async (d) => (e ? e(d) : nr("fetch", {
          ...l,
          endTimestamp: Ea() * 1e3,
          response: d
        }), d),
        (d) => {
          if (nr("fetch", {
            ...l,
            endTimestamp: Ea() * 1e3,
            error: d
          }), i1(d) && d.stack === void 0 && (d.stack = r.stack, Un(d, "framesToPop", 1)), d instanceof TypeError && (d.message === "Failed to fetch" || d.message === "Load failed" || d.message === "NetworkError when attempting to fetch resource."))
            try {
              const c = new URL(l.fetchData.url);
              d.message = `${d.message} (${c.host})`;
            } catch {
            }
          throw d;
        }
      );
    };
  });
}
async function WR(e, t) {
  if (e != null && e.body) {
    const s = e.body, n = s.getReader(), r = setTimeout(
      () => {
        s.cancel().then(null, () => {
        });
      },
      90 * 1e3
      // 90s
    );
    let i = !0;
    for (; i; ) {
      let o;
      try {
        o = setTimeout(() => {
          s.cancel().then(null, () => {
          });
        }, 5e3);
        const { done: l } = await n.read();
        clearTimeout(o), l && (t(), i = !1);
      } catch {
        i = !1;
      } finally {
        clearTimeout(o);
      }
    }
    clearTimeout(r), n.releaseLock(), s.cancel().then(null, () => {
    });
  }
}
function GR(e) {
  let t;
  try {
    t = e.clone();
  } catch {
    return;
  }
  WR(t, () => {
    nr("fetch-body-resolved", {
      endTimestamp: Ea() * 1e3,
      response: e
    });
  });
}
function Sv(e, t) {
  return !!e && typeof e == "object" && !!e[t];
}
function l0(e) {
  return typeof e == "string" ? e : e ? Sv(e, "url") ? e.url : e.toString ? e.toString() : "" : "";
}
function YR(e) {
  if (e.length === 0)
    return { method: "GET", url: "" };
  if (e.length === 2) {
    const [s, n] = e;
    return {
      url: l0(s),
      method: Sv(n, "method") ? String(n.method).toUpperCase() : "GET"
    };
  }
  const t = e[0];
  return {
    url: l0(t),
    method: Sv(t, "method") ? String(t.method).toUpperCase() : "GET"
  };
}
function XR(e) {
  const [t, s] = e;
  try {
    if (typeof s == "object" && s !== null && "headers" in s && s.headers)
      return new Headers(s.headers);
    if (IP(t))
      return new Headers(t.headers);
  } catch {
  }
}
function qR() {
  return typeof __SENTRY_BROWSER_BUNDLE__ < "u" && !!__SENTRY_BROWSER_BUNDLE__;
}
function QR() {
  return "npm";
}
function KR() {
  return !qR() && Object.prototype.toString.call(typeof process < "u" ? process : 0) === "[object process]";
}
function Pv() {
  return typeof window < "u" && (!KR() || ZR());
}
function ZR() {
  const e = As.process;
  return (e == null ? void 0 : e.type) === "renderer";
}
const mr = As, ca = mr.document, Nc = mr.navigator, R3 = "Report a Bug", JR = "Cancel", $R = "Send Bug Report", _R = "Confirm", eL = "Report a Bug", tL = "your.email@example.org", sL = "Email", aL = "What's the bug? What did you expect?", nL = "Description", rL = "Your Name", oL = "Name", iL = "Thank you for your report!", lL = "(required)", dL = "Add a screenshot", cL = "Remove screenshot", uL = "widget", pL = "api", hL = 5e3, mL = (e, t = { includeReplay: !0 }) => {
  if (!e.message)
    throw new Error("Unable to submit feedback with empty message");
  const s = ds();
  if (!s)
    throw new Error("No client setup, cannot send feedback.");
  e.tags && Object.keys(e.tags).length && Is().setTags(e.tags);
  const n = NR(
    {
      source: pL,
      url: fl(),
      ...e
    },
    t
  );
  return new Promise((r, i) => {
    const o = setTimeout(() => i("Unable to determine if Feedback was correctly sent."), 3e4), l = s.on("afterSendEvent", (d, c) => {
      if (d.event_id === n)
        return clearTimeout(o), l(), c && typeof c.statusCode == "number" && c.statusCode >= 200 && c.statusCode < 300 ? r(n) : c && typeof c.statusCode == "number" && c.statusCode === 0 ? i(
          "Unable to send Feedback. This is because of network issues, or because you are using an ad-blocker."
        ) : c && typeof c.statusCode == "number" && c.statusCode === 403 ? i(
          "Unable to send Feedback. This could be because this domain is not in your list of allowed domains."
        ) : i(
          "Unable to send Feedback. This could be because of network issues, or because you are using an ad-blocker"
        );
    });
  });
}, rh = typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__;
function fL() {
  return !(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(Nc.userAgent) || /Macintosh/i.test(Nc.userAgent) && Nc.maxTouchPoints && Nc.maxTouchPoints > 1 || !isSecureContext);
}
function lp(e, t) {
  return {
    ...e,
    ...t,
    tags: {
      ...e.tags,
      ...t.tags
    },
    onFormOpen: () => {
      var s, n;
      (s = t.onFormOpen) == null || s.call(t), (n = e.onFormOpen) == null || n.call(e);
    },
    onFormClose: () => {
      var s, n;
      (s = t.onFormClose) == null || s.call(t), (n = e.onFormClose) == null || n.call(e);
    },
    onSubmitSuccess: (s, n) => {
      var r, i;
      (r = t.onSubmitSuccess) == null || r.call(t, s, n), (i = e.onSubmitSuccess) == null || i.call(e, s, n);
    },
    onSubmitError: (s) => {
      var n, r;
      (n = t.onSubmitError) == null || n.call(t, s), (r = e.onSubmitError) == null || r.call(e, s);
    },
    onFormSubmitted: () => {
      var s, n;
      (s = t.onFormSubmitted) == null || s.call(t), (n = e.onFormSubmitted) == null || n.call(e);
    },
    themeDark: {
      ...e.themeDark,
      ...t.themeDark
    },
    themeLight: {
      ...e.themeLight,
      ...t.themeLight
    }
  };
}
function gL(e) {
  const t = ca.createElement("style");
  return t.textContent = `
.widget__actor {
  position: fixed;
  z-index: var(--z-index);
  margin: var(--page-margin);
  inset: var(--actor-inset);

  display: flex;
  align-items: center;
  gap: 8px;
  padding: 16px;

  font-family: inherit;
  font-size: var(--font-size);
  font-weight: 600;
  line-height: 1.14em;
  text-decoration: none;

  background: var(--actor-background, var(--background));
  border-radius: var(--actor-border-radius, 1.7em/50%);
  border: var(--actor-border, var(--border));
  box-shadow: var(--actor-box-shadow, var(--box-shadow));
  color: var(--actor-color, var(--foreground));
  fill: var(--actor-color, var(--foreground));
  cursor: pointer;
  opacity: 1;
  transition: transform 0.2s ease-in-out;
  transform: translate(0, 0) scale(1);
}
.widget__actor[aria-hidden="true"] {
  opacity: 0;
  pointer-events: none;
  visibility: hidden;
  transform: translate(0, 16px) scale(0.98);
}

.widget__actor:hover {
  background: var(--actor-hover-background, var(--background));
  filter: var(--interactive-filter);
}

.widget__actor svg {
  width: 1.14em;
  height: 1.14em;
}

@media (max-width: 600px) {
  .widget__actor span {
    display: none;
  }
}
`, e && t.setAttribute("nonce", e), t;
}
function Nn(e, t) {
  return Object.entries(t).forEach(([s, n]) => {
    e.setAttributeNS(null, s, n);
  }), e;
}
const Tl = 20, vL = "http://www.w3.org/2000/svg";
function yL() {
  const e = (l) => mr.document.createElementNS(vL, l), t = Nn(e("svg"), {
    width: `${Tl}`,
    height: `${Tl}`,
    viewBox: `0 0 ${Tl} ${Tl}`,
    fill: "var(--actor-color, var(--foreground))"
  }), s = Nn(e("g"), {
    clipPath: "url(#clip0_57_80)"
  }), n = Nn(e("path"), {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M15.6622 15H12.3997C12.2129 14.9959 12.031 14.9396 11.8747 14.8375L8.04965 12.2H7.49956V19.1C7.4875 19.3348 7.3888 19.5568 7.22256 19.723C7.05632 19.8892 6.83435 19.9879 6.59956 20H2.04956C1.80193 19.9968 1.56535 19.8969 1.39023 19.7218C1.21511 19.5467 1.1153 19.3101 1.11206 19.0625V12.2H0.949652C0.824431 12.2017 0.700142 12.1783 0.584123 12.1311C0.468104 12.084 0.362708 12.014 0.274155 11.9255C0.185602 11.8369 0.115689 11.7315 0.0685419 11.6155C0.0213952 11.4995 -0.00202913 11.3752 -0.00034808 11.25V3.75C-0.00900498 3.62067 0.0092504 3.49095 0.0532651 3.36904C0.0972798 3.24712 0.166097 3.13566 0.255372 3.04168C0.344646 2.94771 0.452437 2.87327 0.571937 2.82307C0.691437 2.77286 0.82005 2.74798 0.949652 2.75H8.04965L11.8747 0.1625C12.031 0.0603649 12.2129 0.00407221 12.3997 0H15.6622C15.9098 0.00323746 16.1464 0.103049 16.3215 0.278167C16.4966 0.453286 16.5964 0.689866 16.5997 0.9375V3.25269C17.3969 3.42959 18.1345 3.83026 18.7211 4.41679C19.5322 5.22788 19.9878 6.32796 19.9878 7.47502C19.9878 8.62209 19.5322 9.72217 18.7211 10.5333C18.1345 11.1198 17.3969 11.5205 16.5997 11.6974V14.0125C16.6047 14.1393 16.5842 14.2659 16.5395 14.3847C16.4948 14.5035 16.4268 14.6121 16.3394 14.7042C16.252 14.7962 16.147 14.8698 16.0307 14.9206C15.9144 14.9714 15.7891 14.9984 15.6622 15ZM1.89695 10.325H1.88715V4.625H8.33715C8.52423 4.62301 8.70666 4.56654 8.86215 4.4625L12.6872 1.875H14.7247V13.125H12.6872L8.86215 10.4875C8.70666 10.3835 8.52423 10.327 8.33715 10.325H2.20217C2.15205 10.3167 2.10102 10.3125 2.04956 10.3125C1.9981 10.3125 1.94708 10.3167 1.89695 10.325ZM2.98706 12.2V18.1625H5.66206V12.2H2.98706ZM16.5997 9.93612V5.01393C16.6536 5.02355 16.7072 5.03495 16.7605 5.04814C17.1202 5.13709 17.4556 5.30487 17.7425 5.53934C18.0293 5.77381 18.2605 6.06912 18.4192 6.40389C18.578 6.73866 18.6603 7.10452 18.6603 7.47502C18.6603 7.84552 18.578 8.21139 18.4192 8.54616C18.2605 8.88093 18.0293 9.17624 17.7425 9.41071C17.4556 9.64518 17.1202 9.81296 16.7605 9.90191C16.7072 9.91509 16.6536 9.9265 16.5997 9.93612Z"
  });
  t.appendChild(s).appendChild(n);
  const r = e("defs"), i = Nn(e("clipPath"), {
    id: "clip0_57_80"
  }), o = Nn(e("rect"), {
    width: `${Tl}`,
    height: `${Tl}`,
    fill: "white"
  });
  return i.appendChild(o), r.appendChild(i), t.appendChild(r).appendChild(i).appendChild(o), t;
}
function bL({ triggerLabel: e, triggerAriaLabel: t, shadow: s, styleNonce: n }) {
  const r = ca.createElement("button");
  if (r.type = "button", r.className = "widget__actor", r.ariaHidden = "false", r.ariaLabel = t || e || R3, r.appendChild(yL()), e) {
    const o = ca.createElement("span");
    o.appendChild(ca.createTextNode(e)), r.appendChild(o);
  }
  const i = gL(n);
  return {
    el: r,
    appendToDom() {
      s.appendChild(i), s.appendChild(r);
    },
    removeFromDom() {
      r.remove(), i.remove();
    },
    show() {
      r.ariaHidden = "false";
    },
    hide() {
      r.ariaHidden = "true";
    }
  };
}
const L3 = "rgba(88, 74, 192, 1)", AL = {
  foreground: "#2b2233",
  background: "#ffffff",
  accentForeground: "white",
  accentBackground: L3,
  successColor: "#268d75",
  errorColor: "#df3338",
  border: "1.5px solid rgba(41, 35, 47, 0.13)",
  boxShadow: "0px 4px 24px 0px rgba(43, 34, 51, 0.12)",
  outline: "1px auto var(--accent-background)",
  interactiveFilter: "brightness(95%)"
}, d0 = {
  foreground: "#ebe6ef",
  background: "#29232f",
  accentForeground: "white",
  accentBackground: L3,
  successColor: "#2da98c",
  errorColor: "#f55459",
  border: "1.5px solid rgba(235, 230, 239, 0.15)",
  boxShadow: "0px 4px 24px 0px rgba(43, 34, 51, 0.12)",
  outline: "1px auto var(--accent-background)",
  interactiveFilter: "brightness(150%)"
};
function c0(e) {
  return `
  --foreground: ${e.foreground};
  --background: ${e.background};
  --accent-foreground: ${e.accentForeground};
  --accent-background: ${e.accentBackground};
  --success-color: ${e.successColor};
  --error-color: ${e.errorColor};
  --border: ${e.border};
  --box-shadow: ${e.boxShadow};
  --outline: ${e.outline};
  --interactive-filter: ${e.interactiveFilter};
  `;
}
function wL({
  colorScheme: e,
  themeDark: t,
  themeLight: s,
  styleNonce: n
}) {
  const r = ca.createElement("style");
  return r.textContent = `
:host {
  --font-family: system-ui, 'Helvetica Neue', Arial, sans-serif;
  --font-size: 14px;
  --z-index: 100000;

  --page-margin: 16px;
  --inset: auto 0 0 auto;
  --actor-inset: var(--inset);

  font-family: var(--font-family);
  font-size: var(--font-size);

  ${e !== "system" ? "color-scheme: only light;" : ""}

  ${c0(
    e === "dark" ? { ...d0, ...t } : { ...AL, ...s }
  )}
}

${e === "system" ? `
@media (prefers-color-scheme: dark) {
  :host {
    ${c0({ ...d0, ...t })}
  }
}` : ""}
}
`, n && r.setAttribute("nonce", n), r;
}
const CL = ({
  lazyLoadIntegration: e,
  getModalIntegration: t,
  getScreenshotIntegration: s
}) => ({
  // FeedbackGeneralConfiguration
  id: r = "sentry-feedback",
  autoInject: i = !0,
  showBranding: o = !0,
  isEmailRequired: l = !1,
  isNameRequired: d = !1,
  showEmail: c = !0,
  showName: u = !0,
  enableScreenshot: m = !0,
  useSentryUser: f = {
    email: "email",
    name: "username"
  },
  tags: v,
  styleNonce: b,
  scriptNonce: w,
  // FeedbackThemeConfiguration
  colorScheme: S = "system",
  themeLight: I = {},
  themeDark: T = {},
  // FeedbackTextConfiguration
  addScreenshotButtonLabel: x = dL,
  cancelButtonLabel: k = JR,
  confirmButtonLabel: C = _R,
  emailLabel: O = sL,
  emailPlaceholder: E = tL,
  formTitle: B = eL,
  isRequiredLabel: M = lL,
  messageLabel: R = nL,
  messagePlaceholder: F = aL,
  nameLabel: L = oL,
  namePlaceholder: j = rL,
  removeScreenshotButtonLabel: H = cL,
  submitButtonLabel: te = $R,
  successMessageText: re = iL,
  triggerLabel: le = R3,
  triggerAriaLabel: ie = "",
  // FeedbackCallbacks
  onFormOpen: ye,
  onFormClose: Y,
  onSubmitSuccess: ae,
  onSubmitError: ke,
  onFormSubmitted: ue
} = {}) => {
  const oe = {
    id: r,
    autoInject: i,
    showBranding: o,
    isEmailRequired: l,
    isNameRequired: d,
    showEmail: c,
    showName: u,
    enableScreenshot: m,
    useSentryUser: f,
    tags: v,
    styleNonce: b,
    scriptNonce: w,
    colorScheme: S,
    themeDark: T,
    themeLight: I,
    triggerLabel: le,
    triggerAriaLabel: ie,
    cancelButtonLabel: k,
    submitButtonLabel: te,
    confirmButtonLabel: C,
    formTitle: B,
    emailLabel: O,
    emailPlaceholder: E,
    messageLabel: R,
    messagePlaceholder: F,
    nameLabel: L,
    namePlaceholder: j,
    successMessageText: re,
    isRequiredLabel: M,
    addScreenshotButtonLabel: x,
    removeScreenshotButtonLabel: H,
    onFormClose: Y,
    onFormOpen: ye,
    onSubmitError: ke,
    onSubmitSuccess: ae,
    onFormSubmitted: ue
  };
  let fe = null, we = [];
  const Ie = (Re) => {
    if (!fe) {
      const ge = ca.createElement("div");
      ge.id = String(Re.id), ca.body.appendChild(ge), fe = ge.attachShadow({ mode: "open" }), fe.appendChild(wL(Re));
    }
    return fe;
  }, be = async (Re) => {
    const ge = Re.enableScreenshot && fL();
    let he, Me;
    try {
      he = (t ? t() : await e("feedbackModalIntegration", w))(), QA(he);
    } catch {
      throw rh && ot.error(
        "[Feedback] Error when trying to load feedback integrations. Try using `feedbackSyncIntegration` in your `Sentry.init`."
      ), new Error("[Feedback] Missing feedback modal integration!");
    }
    try {
      const $e = ge ? s ? s() : await e("feedbackScreenshotIntegration", w) : void 0;
      $e && (Me = $e(), QA(Me));
    } catch {
      rh && ot.error("[Feedback] Missing feedback screenshot integration. Proceeding without screenshots.");
    }
    const Ne = he.createDialog({
      options: {
        ...Re,
        onFormClose: () => {
          var $e;
          Ne == null || Ne.close(), ($e = Re.onFormClose) == null || $e.call(Re);
        },
        onFormSubmitted: () => {
          var $e;
          Ne == null || Ne.close(), ($e = Re.onFormSubmitted) == null || $e.call(Re);
        }
      },
      screenshotIntegration: Me,
      sendFeedback: mL,
      shadow: Ie(Re)
    });
    return Ne;
  }, Oe = (Re, ge = {}) => {
    const he = lp(oe, ge), Me = typeof Re == "string" ? ca.querySelector(Re) : typeof Re.addEventListener == "function" ? Re : null;
    if (!Me)
      throw rh && ot.error("[Feedback] Unable to attach to target element"), new Error("Unable to attach to target element");
    let Ne = null;
    const $e = async () => {
      Ne || (Ne = await be({
        ...he,
        onFormSubmitted: () => {
          var yt;
          Ne == null || Ne.removeFromDom(), (yt = he.onFormSubmitted) == null || yt.call(he);
        }
      })), Ne.appendToDom(), Ne.open();
    };
    Me.addEventListener("click", $e);
    const mt = () => {
      we = we.filter((yt) => yt !== mt), Ne == null || Ne.removeFromDom(), Ne = null, Me.removeEventListener("click", $e);
    };
    return we.push(mt), mt;
  }, ze = (Re = {}) => {
    const ge = lp(oe, Re), he = Ie(ge), Me = bL({
      triggerLabel: ge.triggerLabel,
      triggerAriaLabel: ge.triggerAriaLabel,
      shadow: he,
      styleNonce: b
    });
    return Oe(Me.el, {
      ...ge,
      onFormOpen() {
        Me.hide();
      },
      onFormClose() {
        Me.show();
      },
      onFormSubmitted() {
        Me.show();
      }
    }), Me;
  };
  return {
    name: "Feedback",
    setupOnce() {
      !Pv() || !oe.autoInject || (ca.readyState === "loading" ? ca.addEventListener("DOMContentLoaded", () => ze().appendToDom()) : ze().appendToDom());
    },
    /**
     * Adds click listener to the element to open a feedback dialog
     *
     * The returned function can be used to remove the click listener
     */
    attachTo: Oe,
    /**
     * Creates a new widget which is composed of a Button which triggers a Dialog.
     * Accepts partial options to override any options passed to constructor.
     */
    createWidget(Re = {}) {
      const ge = ze(lp(oe, Re));
      return ge.appendToDom(), ge;
    },
    /**
     * Creates a new Form which you can
     * Accepts partial options to override any options passed to constructor.
     */
    async createForm(Re = {}) {
      return be(lp(oe, Re));
    },
    /**
     * Removes the Feedback integration (including host, shadow DOM, and all widgets)
     */
    remove() {
      var Re;
      fe && ((Re = fe.parentElement) == null || Re.remove(), fe = null), we.forEach((ge) => ge()), we = [];
    }
  };
};
var Wm, pa, B3, Hi, u0, M3, kv, pu = {}, y1 = [], SL = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i, b1 = Array.isArray;
function li(e, t) {
  for (var s in t) e[s] = t[s];
  return e;
}
function x3(e) {
  var t = e.parentNode;
  t && t.removeChild(e);
}
function hs(e, t, s) {
  var n, r, i, o = {};
  for (i in t) i == "key" ? n = t[i] : i == "ref" ? r = t[i] : o[i] = t[i];
  if (arguments.length > 2 && (o.children = arguments.length > 3 ? Wm.call(arguments, 2) : s), typeof e == "function" && e.defaultProps != null) for (i in e.defaultProps) o[i] === void 0 && (o[i] = e.defaultProps[i]);
  return oh(e, o, n, r, null);
}
function oh(e, t, s, n, r) {
  var i = { type: e, props: t, key: s, ref: n, __k: null, __: null, __b: 0, __e: null, __d: void 0, __c: null, constructor: void 0, __v: r ?? ++B3, __i: -1, __u: 0 };
  return r == null && pa.vnode != null && pa.vnode(i), i;
}
function Du(e) {
  return e.children;
}
function ih(e, t) {
  this.props = e, this.context = t;
}
function Ad(e, t) {
  if (t == null) return e.__ ? Ad(e.__, e.__i + 1) : null;
  for (var s; t < e.__k.length; t++) if ((s = e.__k[t]) != null && s.__e != null) return s.__e;
  return typeof e.type == "function" ? Ad(e) : null;
}
function PL(e, t, s) {
  var n, r = e.__v, i = r.__e, o = e.__P;
  if (o) return (n = li({}, r)).__v = r.__v + 1, pa.vnode && pa.vnode(n), A1(o, n, r, e.__n, o.ownerSVGElement !== void 0, 32 & r.__u ? [i] : null, t, i ?? Ad(r), !!(32 & r.__u), s), n.__.__k[n.__i] = n, n.__d = void 0, n.__e != i && F3(n), n;
}
function F3(e) {
  var t, s;
  if ((e = e.__) != null && e.__c != null) {
    for (e.__e = e.__c.base = null, t = 0; t < e.__k.length; t++) if ((s = e.__k[t]) != null && s.__e != null) {
      e.__e = e.__c.base = s.__e;
      break;
    }
    return F3(e);
  }
}
function p0(e) {
  (!e.__d && (e.__d = !0) && Hi.push(e) && !tm.__r++ || u0 !== pa.debounceRendering) && ((u0 = pa.debounceRendering) || M3)(tm);
}
function tm() {
  var e, t, s, n = [], r = [];
  for (Hi.sort(kv); e = Hi.shift(); ) e.__d && (s = Hi.length, t = PL(e, n, r) || t, s === 0 || Hi.length > s ? (Ev(n, t, r), r.length = n.length = 0, t = void 0, Hi.sort(kv)) : t && pa.__c && pa.__c(t, y1));
  t && Ev(n, t, r), tm.__r = 0;
}
function V3(e, t, s, n, r, i, o, l, d, c, u) {
  var m, f, v, b, w, S = n && n.__k || y1, I = t.length;
  for (s.__d = d, kL(s, t, S), d = s.__d, m = 0; m < I; m++) (v = s.__k[m]) != null && typeof v != "boolean" && typeof v != "function" && (f = v.__i === -1 ? pu : S[v.__i] || pu, v.__i = m, A1(e, v, f, r, i, o, l, d, c, u), b = v.__e, v.ref && f.ref != v.ref && (f.ref && w1(f.ref, null, v), u.push(v.ref, v.__c || b, v)), w == null && b != null && (w = b), 65536 & v.__u || f.__k === v.__k ? d = D3(v, d, e) : typeof v.type == "function" && v.__d !== void 0 ? d = v.__d : b && (d = b.nextSibling), v.__d = void 0, v.__u &= -196609);
  s.__d = d, s.__e = w;
}
function kL(e, t, s) {
  var n, r, i, o, l, d = t.length, c = s.length, u = c, m = 0;
  for (e.__k = [], n = 0; n < d; n++) (r = e.__k[n] = (r = t[n]) == null || typeof r == "boolean" || typeof r == "function" ? null : typeof r == "string" || typeof r == "number" || typeof r == "bigint" || r.constructor == String ? oh(null, r, null, null, r) : b1(r) ? oh(Du, { children: r }, null, null, null) : r.constructor === void 0 && r.__b > 0 ? oh(r.type, r.props, r.key, r.ref ? r.ref : null, r.__v) : r) != null ? (r.__ = e, r.__b = e.__b + 1, l = EL(r, s, o = n + m, u), r.__i = l, i = null, l !== -1 && (u--, (i = s[l]) && (i.__u |= 131072)), i == null || i.__v === null ? (l == -1 && m--, typeof r.type != "function" && (r.__u |= 65536)) : l !== o && (l === o + 1 ? m++ : l > o ? u > d - o ? m += l - o : m-- : m = l < o && l == o - 1 ? l - o : 0, l !== n + m && (r.__u |= 65536))) : (i = s[n]) && i.key == null && i.__e && (i.__e == e.__d && (e.__d = Ad(i)), Iv(i, i, !1), s[n] = null, u--);
  if (u) for (n = 0; n < c; n++) (i = s[n]) != null && (131072 & i.__u) == 0 && (i.__e == e.__d && (e.__d = Ad(i)), Iv(i, i));
}
function D3(e, t, s) {
  var n, r;
  if (typeof e.type == "function") {
    for (n = e.__k, r = 0; n && r < n.length; r++) n[r] && (n[r].__ = e, t = D3(n[r], t, s));
    return t;
  }
  e.__e != t && (s.insertBefore(e.__e, t || null), t = e.__e);
  do
    t = t && t.nextSibling;
  while (t != null && t.nodeType === 8);
  return t;
}
function EL(e, t, s, n) {
  var r = e.key, i = e.type, o = s - 1, l = s + 1, d = t[s];
  if (d === null || d && r == d.key && i === d.type) return s;
  if (n > (d != null && (131072 & d.__u) == 0 ? 1 : 0)) for (; o >= 0 || l < t.length; ) {
    if (o >= 0) {
      if ((d = t[o]) && (131072 & d.__u) == 0 && r == d.key && i === d.type) return o;
      o--;
    }
    if (l < t.length) {
      if ((d = t[l]) && (131072 & d.__u) == 0 && r == d.key && i === d.type) return l;
      l++;
    }
  }
  return -1;
}
function h0(e, t, s) {
  t[0] === "-" ? e.setProperty(t, s ?? "") : e[t] = s == null ? "" : typeof s != "number" || SL.test(t) ? s : s + "px";
}
function dp(e, t, s, n, r) {
  var i;
  e: if (t === "style") if (typeof s == "string") e.style.cssText = s;
  else {
    if (typeof n == "string" && (e.style.cssText = n = ""), n) for (t in n) s && t in s || h0(e.style, t, "");
    if (s) for (t in s) n && s[t] === n[t] || h0(e.style, t, s[t]);
  }
  else if (t[0] === "o" && t[1] === "n") i = t !== (t = t.replace(/(PointerCapture)$|Capture$/i, "$1")), t = t.toLowerCase() in e ? t.toLowerCase().slice(2) : t.slice(2), e.l || (e.l = {}), e.l[t + i] = s, s ? n ? s.u = n.u : (s.u = Date.now(), e.addEventListener(t, i ? f0 : m0, i)) : e.removeEventListener(t, i ? f0 : m0, i);
  else {
    if (r) t = t.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
    else if (t !== "width" && t !== "height" && t !== "href" && t !== "list" && t !== "form" && t !== "tabIndex" && t !== "download" && t !== "rowSpan" && t !== "colSpan" && t !== "role" && t in e) try {
      e[t] = s ?? "";
      break e;
    } catch {
    }
    typeof s == "function" || (s == null || s === !1 && t[4] !== "-" ? e.removeAttribute(t) : e.setAttribute(t, s));
  }
}
function m0(e) {
  if (this.l) {
    var t = this.l[e.type + !1];
    if (e.t) {
      if (e.t <= t.u) return;
    } else e.t = Date.now();
    return t(pa.event ? pa.event(e) : e);
  }
}
function f0(e) {
  if (this.l) return this.l[e.type + !0](pa.event ? pa.event(e) : e);
}
function A1(e, t, s, n, r, i, o, l, d, c) {
  var u, m, f, v, b, w, S, I, T, x, k, C, O, E, B, M = t.type;
  if (t.constructor !== void 0) return null;
  128 & s.__u && (d = !!(32 & s.__u), i = [l = t.__e = s.__e]), (u = pa.__b) && u(t);
  e: if (typeof M == "function") try {
    if (I = t.props, T = (u = M.contextType) && n[u.__c], x = u ? T ? T.props.value : u.__ : n, s.__c ? S = (m = t.__c = s.__c).__ = m.__E : ("prototype" in M && M.prototype.render ? t.__c = m = new M(I, x) : (t.__c = m = new ih(I, x), m.constructor = M, m.render = TL), T && T.sub(m), m.props = I, m.state || (m.state = {}), m.context = x, m.__n = n, f = m.__d = !0, m.__h = [], m._sb = []), m.__s == null && (m.__s = m.state), M.getDerivedStateFromProps != null && (m.__s == m.state && (m.__s = li({}, m.__s)), li(m.__s, M.getDerivedStateFromProps(I, m.__s))), v = m.props, b = m.state, m.__v = t, f) M.getDerivedStateFromProps == null && m.componentWillMount != null && m.componentWillMount(), m.componentDidMount != null && m.__h.push(m.componentDidMount);
    else {
      if (M.getDerivedStateFromProps == null && I !== v && m.componentWillReceiveProps != null && m.componentWillReceiveProps(I, x), !m.__e && (m.shouldComponentUpdate != null && m.shouldComponentUpdate(I, m.__s, x) === !1 || t.__v === s.__v)) {
        for (t.__v !== s.__v && (m.props = I, m.state = m.__s, m.__d = !1), t.__e = s.__e, t.__k = s.__k, t.__k.forEach(function(R) {
          R && (R.__ = t);
        }), k = 0; k < m._sb.length; k++) m.__h.push(m._sb[k]);
        m._sb = [], m.__h.length && o.push(m);
        break e;
      }
      m.componentWillUpdate != null && m.componentWillUpdate(I, m.__s, x), m.componentDidUpdate != null && m.__h.push(function() {
        m.componentDidUpdate(v, b, w);
      });
    }
    if (m.context = x, m.props = I, m.__P = e, m.__e = !1, C = pa.__r, O = 0, "prototype" in M && M.prototype.render) {
      for (m.state = m.__s, m.__d = !1, C && C(t), u = m.render(m.props, m.state, m.context), E = 0; E < m._sb.length; E++) m.__h.push(m._sb[E]);
      m._sb = [];
    } else do
      m.__d = !1, C && C(t), u = m.render(m.props, m.state, m.context), m.state = m.__s;
    while (m.__d && ++O < 25);
    m.state = m.__s, m.getChildContext != null && (n = li(li({}, n), m.getChildContext())), f || m.getSnapshotBeforeUpdate == null || (w = m.getSnapshotBeforeUpdate(v, b)), V3(e, b1(B = u != null && u.type === Du && u.key == null ? u.props.children : u) ? B : [B], t, s, n, r, i, o, l, d, c), m.base = t.__e, t.__u &= -161, m.__h.length && o.push(m), S && (m.__E = m.__ = null);
  } catch (R) {
    t.__v = null, d || i != null ? (t.__e = l, t.__u |= d ? 160 : 32, i[i.indexOf(l)] = null) : (t.__e = s.__e, t.__k = s.__k), pa.__e(R, t, s);
  }
  else i == null && t.__v === s.__v ? (t.__k = s.__k, t.__e = s.__e) : t.__e = IL(s.__e, t, s, n, r, i, o, d, c);
  (u = pa.diffed) && u(t);
}
function Ev(e, t, s) {
  for (var n = 0; n < s.length; n++) w1(s[n], s[++n], s[++n]);
  pa.__c && pa.__c(t, e), e.some(function(r) {
    try {
      e = r.__h, r.__h = [], e.some(function(i) {
        i.call(r);
      });
    } catch (i) {
      pa.__e(i, r.__v);
    }
  });
}
function IL(e, t, s, n, r, i, o, l, d) {
  var c, u, m, f, v, b, w, S = s.props, I = t.props, T = t.type;
  if (T === "svg" && (r = !0), i != null) {
    for (c = 0; c < i.length; c++) if ((v = i[c]) && "setAttribute" in v == !!T && (T ? v.localName === T : v.nodeType === 3)) {
      e = v, i[c] = null;
      break;
    }
  }
  if (e == null) {
    if (T === null) return document.createTextNode(I);
    e = r ? document.createElementNS("http://www.w3.org/2000/svg", T) : document.createElement(T, I.is && I), i = null, l = !1;
  }
  if (T === null) S === I || l && e.data === I || (e.data = I);
  else {
    if (i = i && Wm.call(e.childNodes), S = s.props || pu, !l && i != null) for (S = {}, c = 0; c < e.attributes.length; c++) S[(v = e.attributes[c]).name] = v.value;
    for (c in S) v = S[c], c == "children" || (c == "dangerouslySetInnerHTML" ? m = v : c === "key" || c in I || dp(e, c, null, v, r));
    for (c in I) v = I[c], c == "children" ? f = v : c == "dangerouslySetInnerHTML" ? u = v : c == "value" ? b = v : c == "checked" ? w = v : c === "key" || l && typeof v != "function" || S[c] === v || dp(e, c, v, S[c], r);
    if (u) l || m && (u.__html === m.__html || u.__html === e.innerHTML) || (e.innerHTML = u.__html), t.__k = [];
    else if (m && (e.innerHTML = ""), V3(e, b1(f) ? f : [f], t, s, n, r && T !== "foreignObject", i, o, i ? i[0] : s.__k && Ad(s, 0), l, d), i != null) for (c = i.length; c--; ) i[c] != null && x3(i[c]);
    l || (c = "value", b !== void 0 && (b !== e[c] || T === "progress" && !b || T === "option" && b !== S[c]) && dp(e, c, b, S[c], !1), c = "checked", w !== void 0 && w !== e[c] && dp(e, c, w, S[c], !1));
  }
  return e;
}
function w1(e, t, s) {
  try {
    typeof e == "function" ? e(t) : e.current = t;
  } catch (n) {
    pa.__e(n, s);
  }
}
function Iv(e, t, s) {
  var n, r;
  if (pa.unmount && pa.unmount(e), (n = e.ref) && (n.current && n.current !== e.__e || w1(n, null, t)), (n = e.__c) != null) {
    if (n.componentWillUnmount) try {
      n.componentWillUnmount();
    } catch (i) {
      pa.__e(i, t);
    }
    n.base = n.__P = null, e.__c = void 0;
  }
  if (n = e.__k) for (r = 0; r < n.length; r++) n[r] && Iv(n[r], t, s || typeof e.type != "function");
  s || e.__e == null || x3(e.__e), e.__ = e.__e = e.__d = void 0;
}
function TL(e, t, s) {
  return this.constructor(e, s);
}
function OL(e, t, s) {
  var n, r, i, o;
  pa.__ && pa.__(e, t), r = (n = !1) ? null : t.__k, i = [], o = [], A1(t, e = t.__k = hs(Du, null, [e]), r || pu, pu, t.ownerSVGElement !== void 0, r ? null : t.firstChild ? Wm.call(t.childNodes) : null, i, r ? r.__e : t.firstChild, n, o), e.__d = void 0, Ev(i, e, o);
}
Wm = y1.slice, pa = { __e: function(e, t, s, n) {
  for (var r, i, o; t = t.__; ) if ((r = t.__c) && !r.__) try {
    if ((i = r.constructor) && i.getDerivedStateFromError != null && (r.setState(i.getDerivedStateFromError(e)), o = r.__d), r.componentDidCatch != null && (r.componentDidCatch(e, n || {}), o = r.__d), o) return r.__E = r;
  } catch (l) {
    e = l;
  }
  throw e;
} }, B3 = 0, ih.prototype.setState = function(e, t) {
  var s;
  s = this.__s != null && this.__s !== this.state ? this.__s : this.__s = li({}, this.state), typeof e == "function" && (e = e(li({}, s), this.props)), e && li(s, e), e != null && this.__v && (t && this._sb.push(t), p0(this));
}, ih.prototype.forceUpdate = function(e) {
  this.__v && (this.__e = !0, e && this.__h.push(e), p0(this));
}, ih.prototype.render = Du, Hi = [], M3 = typeof Promise == "function" ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, kv = function(e, t) {
  return e.__v.__b - t.__v.__b;
}, tm.__r = 0;
var Do, ua, Hf, g0, wd = 0, N3 = [], lh = [], Pa = pa, v0 = Pa.__b, y0 = Pa.__r, b0 = Pa.diffed, A0 = Pa.__c, w0 = Pa.unmount, C0 = Pa.__;
function bl(e, t) {
  Pa.__h && Pa.__h(ua, e, wd || t), wd = 0;
  var s = ua.__H || (ua.__H = { __: [], __h: [] });
  return e >= s.__.length && s.__.push({ __V: lh }), s.__[e];
}
function Wi(e) {
  return wd = 1, j3(U3, e);
}
function j3(e, t, s) {
  var n = bl(Do++, 2);
  if (n.t = e, !n.__c && (n.__ = [s ? s(t) : U3(void 0, t), function(l) {
    var d = n.__N ? n.__N[0] : n.__[0], c = n.t(d, l);
    d !== c && (n.__N = [c, n.__[1]], n.__c.setState({}));
  }], n.__c = ua, !ua.u)) {
    var r = function(l, d, c) {
      if (!n.__c.__H) return !0;
      var u = n.__c.__H.__.filter(function(f) {
        return !!f.__c;
      });
      if (u.every(function(f) {
        return !f.__N;
      })) return !i || i.call(this, l, d, c);
      var m = !1;
      return u.forEach(function(f) {
        if (f.__N) {
          var v = f.__[0];
          f.__ = f.__N, f.__N = void 0, v !== f.__[0] && (m = !0);
        }
      }), !(!m && n.__c.props === l) && (!i || i.call(this, l, d, c));
    };
    ua.u = !0;
    var i = ua.shouldComponentUpdate, o = ua.componentWillUpdate;
    ua.componentWillUpdate = function(l, d, c) {
      if (this.__e) {
        var u = i;
        i = void 0, r(l, d, c), i = u;
      }
      o && o.call(this, l, d, c);
    }, ua.shouldComponentUpdate = r;
  }
  return n.__N || n.__;
}
function RL(e, t) {
  var s = bl(Do++, 3);
  !Pa.__s && C1(s.__H, t) && (s.__ = e, s.i = t, ua.__H.__h.push(s));
}
function H3(e, t) {
  var s = bl(Do++, 4);
  !Pa.__s && C1(s.__H, t) && (s.__ = e, s.i = t, ua.__h.push(s));
}
function LL(e) {
  return wd = 5, Nu(function() {
    return { current: e };
  }, []);
}
function BL(e, t, s) {
  wd = 6, H3(function() {
    return typeof e == "function" ? (e(t()), function() {
      return e(null);
    }) : e ? (e.current = t(), function() {
      return e.current = null;
    }) : void 0;
  }, s == null ? s : s.concat(e));
}
function Nu(e, t) {
  var s = bl(Do++, 7);
  return C1(s.__H, t) ? (s.__V = e(), s.i = t, s.__h = e, s.__V) : s.__;
}
function ad(e, t) {
  return wd = 8, Nu(function() {
    return e;
  }, t);
}
function ML(e) {
  var t = ua.context[e.__c], s = bl(Do++, 9);
  return s.c = e, t ? (s.__ == null && (s.__ = !0, t.sub(ua)), t.props.value) : e.__;
}
function xL(e, t) {
  Pa.useDebugValue && Pa.useDebugValue(t ? t(e) : e);
}
function FL(e) {
  var t = bl(Do++, 10), s = Wi();
  return t.__ = e, ua.componentDidCatch || (ua.componentDidCatch = function(n, r) {
    t.__ && t.__(n, r), s[1](n);
  }), [s[0], function() {
    s[1](void 0);
  }];
}
function VL() {
  var e = bl(Do++, 11);
  if (!e.__) {
    for (var t = ua.__v; t !== null && !t.__m && t.__ !== null; ) t = t.__;
    var s = t.__m || (t.__m = [0, 0]);
    e.__ = "P" + s[0] + "-" + s[1]++;
  }
  return e.__;
}
function DL() {
  for (var e; e = N3.shift(); ) if (e.__P && e.__H) try {
    e.__H.__h.forEach(dh), e.__H.__h.forEach(Tv), e.__H.__h = [];
  } catch (t) {
    e.__H.__h = [], Pa.__e(t, e.__v);
  }
}
Pa.__b = function(e) {
  ua = null, v0 && v0(e);
}, Pa.__ = function(e, t) {
  t.__k && t.__k.__m && (e.__m = t.__k.__m), C0 && C0(e, t);
}, Pa.__r = function(e) {
  y0 && y0(e), Do = 0;
  var t = (ua = e.__c).__H;
  t && (Hf === ua ? (t.__h = [], ua.__h = [], t.__.forEach(function(s) {
    s.__N && (s.__ = s.__N), s.__V = lh, s.__N = s.i = void 0;
  })) : (t.__h.forEach(dh), t.__h.forEach(Tv), t.__h = [], Do = 0)), Hf = ua;
}, Pa.diffed = function(e) {
  b0 && b0(e);
  var t = e.__c;
  t && t.__H && (t.__H.__h.length && (N3.push(t) !== 1 && g0 === Pa.requestAnimationFrame || ((g0 = Pa.requestAnimationFrame) || NL)(DL)), t.__H.__.forEach(function(s) {
    s.i && (s.__H = s.i), s.__V !== lh && (s.__ = s.__V), s.i = void 0, s.__V = lh;
  })), Hf = ua = null;
}, Pa.__c = function(e, t) {
  t.some(function(s) {
    try {
      s.__h.forEach(dh), s.__h = s.__h.filter(function(n) {
        return !n.__ || Tv(n);
      });
    } catch (n) {
      t.some(function(r) {
        r.__h && (r.__h = []);
      }), t = [], Pa.__e(n, s.__v);
    }
  }), A0 && A0(e, t);
}, Pa.unmount = function(e) {
  w0 && w0(e);
  var t, s = e.__c;
  s && s.__H && (s.__H.__.forEach(function(n) {
    try {
      dh(n);
    } catch (r) {
      t = r;
    }
  }), s.__H = void 0, t && Pa.__e(t, s.__v));
};
var S0 = typeof requestAnimationFrame == "function";
function NL(e) {
  var t, s = function() {
    clearTimeout(n), S0 && cancelAnimationFrame(t), setTimeout(e);
  }, n = setTimeout(s, 100);
  S0 && (t = requestAnimationFrame(s));
}
function dh(e) {
  var t = ua, s = e.__c;
  typeof s == "function" && (e.__c = void 0, s()), ua = t;
}
function Tv(e) {
  var t = ua;
  e.__c = e.__(), ua = t;
}
function C1(e, t) {
  return !e || e.length !== t.length || t.some(function(s, n) {
    return s !== e[n];
  });
}
function U3(e, t) {
  return typeof t == "function" ? t(e) : t;
}
const jL = /* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  useCallback: ad,
  useContext: ML,
  useDebugValue: xL,
  useEffect: RL,
  useErrorBoundary: FL,
  useId: VL,
  useImperativeHandle: BL,
  useLayoutEffect: H3,
  useMemo: Nu,
  useReducer: j3,
  useRef: LL,
  useState: Wi
}, Symbol.toStringTag, { value: "Module" }), HL = "http://www.w3.org/2000/svg";
function UL() {
  const e = (n) => ca.createElementNS(HL, n), t = Nn(e("svg"), {
    width: "32",
    height: "30",
    viewBox: "0 0 72 66",
    fill: "inherit"
  }), s = Nn(e("path"), {
    transform: "translate(11, 11)",
    d: "M29,2.26a4.67,4.67,0,0,0-8,0L14.42,13.53A32.21,32.21,0,0,1,32.17,40.19H27.55A27.68,27.68,0,0,0,12.09,17.47L6,28a15.92,15.92,0,0,1,9.23,12.17H4.62A.76.76,0,0,1,4,39.06l2.94-5a10.74,10.74,0,0,0-3.36-1.9l-2.91,5a4.54,4.54,0,0,0,1.69,6.24A4.66,4.66,0,0,0,4.62,44H19.15a19.4,19.4,0,0,0-8-17.31l2.31-4A23.87,23.87,0,0,1,23.76,44H36.07a35.88,35.88,0,0,0-16.41-31.8l4.67-8a.77.77,0,0,1,1.05-.27c.53.29,20.29,34.77,20.66,35.17a.76.76,0,0,1-.68,1.13H40.6q.09,1.91,0,3.81h4.78A4.59,4.59,0,0,0,50,39.43a4.49,4.49,0,0,0-.62-2.28Z"
  });
  return t.appendChild(s), t;
}
function zL({ options: e }) {
  const t = Nu(() => ({ __html: UL().outerHTML }), []);
  return hs(
    "h2",
    { class: "dialog__header" },
    hs("span", { class: "dialog__title" }, e.formTitle),
    e.showBranding ? hs(
      "a",
      {
        class: "brand-link",
        target: "_blank",
        href: "https://sentry.io/welcome/",
        title: "Powered by Sentry",
        rel: "noopener noreferrer",
        dangerouslySetInnerHTML: t
      }
    ) : null
  );
}
function WL(e, t) {
  const s = [];
  return t.isNameRequired && !e.name && s.push(t.nameLabel), t.isEmailRequired && !e.email && s.push(t.emailLabel), e.message || s.push(t.messageLabel), s;
}
function Uf(e, t) {
  const s = e.get(t);
  return typeof s == "string" ? s.trim() : "";
}
function GL({
  options: e,
  defaultEmail: t,
  defaultName: s,
  onFormClose: n,
  onSubmit: r,
  onSubmitSuccess: i,
  onSubmitError: o,
  showEmail: l,
  showName: d,
  screenshotInput: c
}) {
  const {
    tags: u,
    addScreenshotButtonLabel: m,
    removeScreenshotButtonLabel: f,
    cancelButtonLabel: v,
    emailLabel: b,
    emailPlaceholder: w,
    isEmailRequired: S,
    isNameRequired: I,
    messageLabel: T,
    messagePlaceholder: x,
    nameLabel: k,
    namePlaceholder: C,
    submitButtonLabel: O,
    isRequiredLabel: E
  } = e, [B, M] = Wi(!1), [R, F] = Wi(null), [L, j] = Wi(!1), H = c == null ? void 0 : c.input, [te, re] = Wi(null), le = ad((Y) => {
    re(Y), j(!1);
  }, []), ie = ad(
    (Y) => {
      const ae = WL(Y, {
        emailLabel: b,
        isEmailRequired: S,
        isNameRequired: I,
        messageLabel: T,
        nameLabel: k
      });
      return ae.length > 0 ? F(`Please enter in the following required fields: ${ae.join(", ")}`) : F(null), ae.length === 0;
    },
    [b, S, I, T, k]
  ), ye = ad(
    async (Y) => {
      M(!0);
      try {
        if (Y.preventDefault(), !(Y.target instanceof HTMLFormElement))
          return;
        const ae = new FormData(Y.target), ke = await (c && L ? c.value() : void 0), ue = {
          name: Uf(ae, "name"),
          email: Uf(ae, "email"),
          message: Uf(ae, "message"),
          attachments: ke ? [ke] : void 0
        };
        if (!ie(ue))
          return;
        try {
          const oe = await r(
            {
              name: ue.name,
              email: ue.email,
              message: ue.message,
              source: uL,
              tags: u
            },
            { attachments: ue.attachments }
          );
          i(ue, oe);
        } catch (oe) {
          rh && ot.error(oe), F(oe), o(oe);
        }
      } finally {
        M(!1);
      }
    },
    [c && L, i, o]
  );
  return hs(
    "form",
    { class: "form", onSubmit: ye },
    H && L ? hs(H, { onError: le }) : null,
    hs(
      "fieldset",
      { class: "form__right", "data-sentry-feedback": !0, disabled: B },
      hs(
        "div",
        { class: "form__top" },
        R ? hs("div", { class: "form__error-container" }, R) : null,
        d ? hs(
          "label",
          { for: "name", class: "form__label" },
          hs(zf, { label: k, isRequiredLabel: E, isRequired: I }),
          hs(
            "input",
            {
              class: "form__input",
              defaultValue: s,
              id: "name",
              name: "name",
              placeholder: C,
              required: I,
              type: "text"
            }
          )
        ) : hs("input", { "aria-hidden": !0, value: s, name: "name", type: "hidden" }),
        l ? hs(
          "label",
          { for: "email", class: "form__label" },
          hs(zf, { label: b, isRequiredLabel: E, isRequired: S }),
          hs(
            "input",
            {
              class: "form__input",
              defaultValue: t,
              id: "email",
              name: "email",
              placeholder: w,
              required: S,
              type: "email"
            }
          )
        ) : hs("input", { "aria-hidden": !0, value: t, name: "email", type: "hidden" }),
        hs(
          "label",
          { for: "message", class: "form__label" },
          hs(zf, { label: T, isRequiredLabel: E, isRequired: !0 }),
          hs(
            "textarea",
            {
              autoFocus: !0,
              class: "form__input form__input--textarea",
              id: "message",
              name: "message",
              placeholder: x,
              required: !0,
              rows: 5
            }
          )
        ),
        H ? hs(
          "label",
          { for: "screenshot", class: "form__label" },
          hs(
            "button",
            {
              class: "btn btn--default",
              disabled: B,
              type: "button",
              onClick: () => {
                re(null), j((Y) => !Y);
              }
            },
            L ? f : m
          ),
          te ? hs("div", { class: "form__error-container" }, te.message) : null
        ) : null
      ),
      hs(
        "div",
        { class: "btn-group" },
        hs(
          "button",
          { class: "btn btn--primary", disabled: B, type: "submit" },
          O
        ),
        hs(
          "button",
          { class: "btn btn--default", disabled: B, type: "button", onClick: n },
          v
        )
      )
    )
  );
}
function zf({
  label: e,
  isRequired: t,
  isRequiredLabel: s
}) {
  return hs(
    "span",
    { class: "form__label__text" },
    e,
    t && hs("span", { class: "form__label__text--required" }, s)
  );
}
const cp = 16, P0 = 17, YL = "http://www.w3.org/2000/svg";
function XL() {
  const e = (d) => mr.document.createElementNS(YL, d), t = Nn(e("svg"), {
    width: `${cp}`,
    height: `${P0}`,
    viewBox: `0 0 ${cp} ${P0}`,
    fill: "inherit"
  }), s = Nn(e("g"), {
    clipPath: "url(#clip0_57_156)"
  }), n = Nn(e("path"), {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M3.55544 15.1518C4.87103 16.0308 6.41775 16.5 8 16.5C10.1217 16.5 12.1566 15.6571 13.6569 14.1569C15.1571 12.6566 16 10.6217 16 8.5C16 6.91775 15.5308 5.37103 14.6518 4.05544C13.7727 2.73985 12.5233 1.71447 11.0615 1.10897C9.59966 0.503466 7.99113 0.34504 6.43928 0.653721C4.88743 0.962403 3.46197 1.72433 2.34315 2.84315C1.22433 3.96197 0.462403 5.38743 0.153721 6.93928C-0.15496 8.49113 0.00346625 10.0997 0.608967 11.5615C1.21447 13.0233 2.23985 14.2727 3.55544 15.1518ZM4.40546 3.1204C5.46945 2.40946 6.72036 2.03 8 2.03C9.71595 2.03 11.3616 2.71166 12.575 3.92502C13.7883 5.13838 14.47 6.78405 14.47 8.5C14.47 9.77965 14.0905 11.0306 13.3796 12.0945C12.6687 13.1585 11.6582 13.9878 10.476 14.4775C9.29373 14.9672 7.99283 15.0953 6.73777 14.8457C5.48271 14.596 4.32987 13.9798 3.42502 13.075C2.52018 12.1701 1.90397 11.0173 1.65432 9.76224C1.40468 8.50718 1.5328 7.20628 2.0225 6.02404C2.5122 4.8418 3.34148 3.83133 4.40546 3.1204Z"
  }), r = Nn(e("path"), {
    d: "M6.68775 12.4297C6.78586 12.4745 6.89218 12.4984 7 12.5C7.11275 12.4955 7.22315 12.4664 7.32337 12.4145C7.4236 12.3627 7.51121 12.2894 7.58 12.2L12 5.63999C12.0848 5.47724 12.1071 5.28902 12.0625 5.11098C12.0178 4.93294 11.9095 4.77744 11.7579 4.67392C11.6064 4.57041 11.4221 4.52608 11.24 4.54931C11.0579 4.57254 10.8907 4.66173 10.77 4.79999L6.88 10.57L5.13 8.56999C5.06508 8.49566 4.98613 8.43488 4.89768 8.39111C4.80922 8.34735 4.713 8.32148 4.61453 8.31498C4.51605 8.30847 4.41727 8.32147 4.32382 8.35322C4.23038 8.38497 4.14413 8.43484 4.07 8.49999C3.92511 8.63217 3.83692 8.81523 3.82387 9.01092C3.81083 9.2066 3.87393 9.39976 4 9.54999L6.43 12.24C6.50187 12.3204 6.58964 12.385 6.68775 12.4297Z"
  });
  t.appendChild(s).append(r, n);
  const i = e("defs"), o = Nn(e("clipPath"), {
    id: "clip0_57_156"
  }), l = Nn(e("rect"), {
    width: `${cp}`,
    height: `${cp}`,
    fill: "white",
    transform: "translate(0 0.5)"
  });
  return o.appendChild(l), i.appendChild(o), t.appendChild(i).appendChild(o).appendChild(l), t;
}
function qL({ open: e, onFormSubmitted: t, ...s }) {
  const n = s.options, r = Nu(() => ({ __html: XL().outerHTML }), []), [i, o] = Wi(null), l = ad(() => {
    i && (clearTimeout(i), o(null)), t();
  }, [i]), d = ad(
    (c, u) => {
      s.onSubmitSuccess(c, u), o(
        setTimeout(() => {
          t(), o(null);
        }, hL)
      );
    },
    [t]
  );
  return hs(
    Du,
    null,
    i ? hs(
      "div",
      { class: "success__position", onClick: l },
      hs(
        "div",
        { class: "success__content" },
        n.successMessageText,
        hs("span", { class: "success__icon", dangerouslySetInnerHTML: r })
      )
    ) : hs(
      "dialog",
      { class: "dialog", onClick: n.onFormClose, open: e },
      hs(
        "div",
        { class: "dialog__position" },
        hs(
          "div",
          {
            class: "dialog__content",
            onClick: (c) => {
              c.stopPropagation();
            }
          },
          hs(zL, { options: n }),
          hs(GL, { ...s, onSubmitSuccess: d })
        )
      )
    )
  );
}
const QL = `
.dialog {
  position: fixed;
  z-index: var(--z-index);
  margin: 0;
  inset: 0;

  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  height: 100vh;
  width: 100vw;

  color: var(--dialog-color, var(--foreground));
  fill: var(--dialog-color, var(--foreground));
  line-height: 1.75em;

  background-color: rgba(0, 0, 0, 0.05);
  border: none;
  inset: 0;
  opacity: 1;
  transition: opacity 0.2s ease-in-out;
}

.dialog__position {
  position: fixed;
  z-index: var(--z-index);
  inset: var(--dialog-inset);
  padding: var(--page-margin);
  display: flex;
  max-height: calc(100vh - (2 * var(--page-margin)));
}
@media (max-width: 600px) {
  .dialog__position {
    inset: var(--page-margin);
    padding: 0;
  }
}

.dialog__position:has(.editor) {
  inset: var(--page-margin);
  padding: 0;
}

.dialog:not([open]) {
  opacity: 0;
  pointer-events: none;
  visibility: hidden;
}
.dialog:not([open]) .dialog__content {
  transform: translate(0, -16px) scale(0.98);
}

.dialog__content {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: var(--dialog-padding, 24px);
  max-width: 100%;
  width: 100%;
  max-height: 100%;
  overflow: auto;

  background: var(--dialog-background, var(--background));
  border-radius: var(--dialog-border-radius, 20px);
  border: var(--dialog-border, var(--border));
  box-shadow: var(--dialog-box-shadow, var(--box-shadow));
  transform: translate(0, 0) scale(1);
  transition: transform 0.2s ease-in-out;
}

`, KL = `
.dialog__header {
  display: flex;
  gap: 4px;
  justify-content: space-between;
  font-weight: var(--dialog-header-weight, 600);
  margin: 0;
}
.dialog__title {
  align-self: center;
  width: var(--form-width, 272px);
}

@media (max-width: 600px) {
  .dialog__title {
    width: auto;
  }
}

.dialog__position:has(.editor) .dialog__title {
  width: auto;
}


.brand-link {
  display: inline-flex;
}
.brand-link:focus-visible {
  outline: var(--outline);
}
`, ZL = `
.form {
  display: flex;
  overflow: auto;
  flex-direction: row;
  gap: 16px;
  flex: 1 0;
}

.form fieldset {
  border: none;
  margin: 0;
  padding: 0;
}

.form__right {
  flex: 0 0 auto;
  display: flex;
  overflow: auto;
  flex-direction: column;
  justify-content: space-between;
  gap: 20px;
  width: var(--form-width, 100%);
}

.dialog__position:has(.editor) .form__right {
  width: var(--form-width, 272px);
}

.form__top {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.form__error-container {
  color: var(--error-color);
  fill: var(--error-color);
}

.form__label {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin: 0px;
}

.form__label__text {
  display: flex;
  gap: 4px;
  align-items: center;
}

.form__label__text--required {
  font-size: 0.85em;
}

.form__input {
  font-family: inherit;
  line-height: inherit;
  background: transparent;
  box-sizing: border-box;
  border: var(--input-border, var(--border));
  border-radius: var(--input-border-radius, 6px);
  color: var(--input-color, inherit);
  fill: var(--input-color, inherit);
  font-size: var(--input-font-size, inherit);
  font-weight: var(--input-font-weight, 500);
  padding: 6px 12px;
}

.form__input::placeholder {
  opacity: 0.65;
  color: var(--input-placeholder-color, inherit);
  filter: var(--interactive-filter);
}

.form__input:focus-visible {
  outline: var(--input-focus-outline, var(--outline));
}

.form__input--textarea {
  font-family: inherit;
  resize: vertical;
}

.error {
  color: var(--error-color);
  fill: var(--error-color);
}
`, JL = `
.btn-group {
  display: grid;
  gap: 8px;
}

.btn {
  line-height: inherit;
  border: var(--button-border, var(--border));
  border-radius: var(--button-border-radius, 6px);
  cursor: pointer;
  font-family: inherit;
  font-size: var(--button-font-size, inherit);
  font-weight: var(--button-font-weight, 600);
  padding: var(--button-padding, 6px 16px);
}
.btn[disabled] {
  opacity: 0.6;
  pointer-events: none;
}

.btn--primary {
  color: var(--button-primary-color, var(--accent-foreground));
  fill: var(--button-primary-color, var(--accent-foreground));
  background: var(--button-primary-background, var(--accent-background));
  border: var(--button-primary-border, var(--border));
  border-radius: var(--button-primary-border-radius, 6px);
  font-weight: var(--button-primary-font-weight, 500);
}
.btn--primary:hover {
  color: var(--button-primary-hover-color, var(--accent-foreground));
  fill: var(--button-primary-hover-color, var(--accent-foreground));
  background: var(--button-primary-hover-background, var(--accent-background));
  filter: var(--interactive-filter);
}
.btn--primary:focus-visible {
  background: var(--button-primary-hover-background, var(--accent-background));
  filter: var(--interactive-filter);
  outline: var(--button-primary-focus-outline, var(--outline));
}

.btn--default {
  color: var(--button-color, var(--foreground));
  fill: var(--button-color, var(--foreground));
  background: var(--button-background, var(--background));
  border: var(--button-border, var(--border));
  border-radius: var(--button-border-radius, 6px);
  font-weight: var(--button-font-weight, 500);
}
.btn--default:hover {
  color: var(--button-color, var(--foreground));
  fill: var(--button-color, var(--foreground));
  background: var(--button-hover-background, var(--background));
  filter: var(--interactive-filter);
}
.btn--default:focus-visible {
  background: var(--button-hover-background, var(--background));
  filter: var(--interactive-filter);
  outline: var(--button-focus-outline, var(--outline));
}
`, $L = `
.success__position {
  position: fixed;
  inset: var(--dialog-inset);
  padding: var(--page-margin);
  z-index: var(--z-index);
}
.success__content {
  background: var(--success-background, var(--background));
  border: var(--success-border, var(--border));
  border-radius: var(--success-border-radius, 1.7em/50%);
  box-shadow: var(--success-box-shadow, var(--box-shadow));
  font-weight: var(--success-font-weight, 600);
  color: var(--success-color);
  fill: var(--success-color);
  padding: 12px 24px;
  line-height: 1.75em;

  display: grid;
  align-items: center;
  grid-auto-flow: column;
  gap: 6px;
  cursor: default;
}

.success__icon {
  display: flex;
}
`;
function _L(e) {
  const t = ca.createElement("style");
  return t.textContent = `
:host {
  --dialog-inset: var(--inset);
}

${QL}
${KL}
${ZL}
${JL}
${$L}
`, e && t.setAttribute("nonce", e), t;
}
function eB() {
  const e = Is().getUser(), t = Wn().getUser(), s = MP().getUser();
  return e && Object.keys(e).length ? e : t && Object.keys(t).length ? t : s;
}
const tB = () => ({
  name: "FeedbackModal",
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  setupOnce() {
  },
  createDialog: ({ options: e, screenshotIntegration: t, sendFeedback: s, shadow: n }) => {
    const r = n, i = e.useSentryUser, o = eB(), l = ca.createElement("div"), d = _L(e.styleNonce);
    let c = "";
    const u = {
      get el() {
        return l;
      },
      appendToDom() {
        !r.contains(d) && !r.contains(l) && (r.appendChild(d), r.appendChild(l));
      },
      removeFromDom() {
        l.remove(), d.remove(), ca.body.style.overflow = c;
      },
      open() {
        var v, b;
        f(!0), (v = e.onFormOpen) == null || v.call(e), (b = ds()) == null || b.emit("openFeedbackWidget"), c = ca.body.style.overflow, ca.body.style.overflow = "hidden";
      },
      close() {
        f(!1), ca.body.style.overflow = c;
      }
    }, m = t == null ? void 0 : t.createInput({ h: hs, hooks: jL, dialog: u, options: e }), f = (v) => {
      OL(
        hs(
          qL,
          {
            options: e,
            screenshotInput: m,
            showName: e.showName || e.isNameRequired,
            showEmail: e.showEmail || e.isEmailRequired,
            defaultName: i && (o == null ? void 0 : o[i.name]) || "",
            defaultEmail: i && (o == null ? void 0 : o[i.email]) || "",
            onFormClose: () => {
              var b;
              f(!1), (b = e.onFormClose) == null || b.call(e);
            },
            onSubmit: s,
            onSubmitSuccess: (b, w) => {
              var S;
              f(!1), (S = e.onSubmitSuccess) == null || S.call(e, b, w);
            },
            onSubmitError: (b) => {
              var w;
              (w = e.onSubmitError) == null || w.call(e, b);
            },
            onFormSubmitted: () => {
              var b;
              (b = e.onFormSubmitted) == null || b.call(e);
            },
            open: v
          }
        ),
        l
      );
    };
    return u;
  }
});
function sB({
  h: e
  // eslint-disable-line @typescript-eslint/no-unused-vars
}) {
  return function() {
    return e(
      "svg",
      { "data-test-id": "icon-close", viewBox: "0 0 16 16", fill: "#2B2233", height: "25px", width: "25px" },
      e("circle", { r: "7", cx: "8", cy: "8", fill: "white" }),
      e(
        "path",
        {
          strokeWidth: "1.5",
          d: "M8,16a8,8,0,1,1,8-8A8,8,0,0,1,8,16ZM8,1.53A6.47,6.47,0,1,0,14.47,8,6.47,6.47,0,0,0,8,1.53Z"
        }
      ),
      e(
        "path",
        {
          strokeWidth: "1.5",
          d: "M5.34,11.41a.71.71,0,0,1-.53-.22.74.74,0,0,1,0-1.06l5.32-5.32a.75.75,0,0,1,1.06,1.06L5.87,11.19A.74.74,0,0,1,5.34,11.41Z"
        }
      ),
      e(
        "path",
        {
          strokeWidth: "1.5",
          d: "M10.66,11.41a.74.74,0,0,1-.53-.22L4.81,5.87A.75.75,0,0,1,5.87,4.81l5.32,5.32a.74.74,0,0,1,0,1.06A.71.71,0,0,1,10.66,11.41Z"
        }
      )
    );
  };
}
function aB(e) {
  const t = ca.createElement("style"), s = "#1A141F", n = "#302735";
  return t.textContent = `
.editor {
  display: flex;
  flex-grow: 1;
  flex-direction: column;
}

.editor__image-container {
  justify-items: center;
  padding: 15px;
  position: relative;
  height: 100%;
  border-radius: var(--menu-border-radius, 6px);

  background-color: ${s};
  background-image: repeating-linear-gradient(
      -145deg,
      transparent,
      transparent 8px,
      ${s} 8px,
      ${s} 11px
    ),
    repeating-linear-gradient(
      -45deg,
      transparent,
      transparent 15px,
      ${n} 15px,
      ${n} 16px
    );
}

.editor__canvas-container {
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.editor__canvas-container > * {
  object-fit: contain;
  position: absolute;
}

.editor__tool-container {
  padding-top: 8px;
  display: flex;
  justify-content: center;
}

.editor__tool-bar {
  display: flex;
  gap: 8px;
}

.editor__tool {
  display: flex;
  padding: 8px 12px;
  justify-content: center;
  align-items: center;
  border: var(--button-border, var(--border));
  border-radius: var(--button-border-radius, 6px);
  background: var(--button-background, var(--background));
  color: var(--button-color, var(--foreground));
}

.editor__tool--active {
  background: var(--button-primary-background, var(--accent-background));
  color: var(--button-primary-color, var(--accent-foreground));
}

.editor__rect {
  position: absolute;
  z-index: 2;
}

.editor__rect button {
  opacity: 0;
  position: absolute;
  top: -12px;
  right: -12px;
  cursor: pointer;
  padding: 0;
  z-index: 3;
  border: none;
  background: none;
}

.editor__rect:hover button {
  opacity: 1;
}
`, e && t.setAttribute("nonce", e), t;
}
function nB({
  h: e
  // eslint-disable-line @typescript-eslint/no-unused-vars
}) {
  return function({
    action: s,
    setAction: n
  }) {
    return e(
      "div",
      { class: "editor__tool-container" },
      e(
        "div",
        { class: "editor__tool-bar" },
        e(
          "button",
          {
            type: "button",
            class: `editor__tool ${s === "highlight" ? "editor__tool--active" : ""}`,
            onClick: () => {
              n(s === "highlight" ? "" : "highlight");
            }
          },
          "Highlight"
        ),
        e(
          "button",
          {
            type: "button",
            class: `editor__tool ${s === "hide" ? "editor__tool--active" : ""}`,
            onClick: () => {
              n(s === "hide" ? "" : "hide");
            }
          },
          "Hide"
        )
      )
    );
  };
}
function rB({ hooks: e }) {
  function t() {
    const [s, n] = e.useState(mr.devicePixelRatio ?? 1);
    return e.useEffect(() => {
      const r = () => {
        n(mr.devicePixelRatio);
      }, i = matchMedia(`(resolution: ${mr.devicePixelRatio}dppx)`);
      return i.addEventListener("change", r), () => {
        i.removeEventListener("change", r);
      };
    }, []), s;
  }
  return function({ onBeforeScreenshot: n, onScreenshot: r, onAfterScreenshot: i, onError: o }) {
    const l = t();
    e.useEffect(() => {
      (async () => {
        n();
        const c = await Nc.mediaDevices.getDisplayMedia({
          video: {
            width: mr.innerWidth * l,
            height: mr.innerHeight * l
          },
          audio: !1,
          // @ts-expect-error experimental flags: https://developer.mozilla.org/en-US/docs/Web/API/MediaDevices/getDisplayMedia#prefercurrenttab
          monitorTypeSurfaces: "exclude",
          preferCurrentTab: !0,
          selfBrowserSurface: "include",
          surfaceSwitching: "exclude"
        }), u = ca.createElement("video");
        await new Promise((m, f) => {
          u.srcObject = c, u.onloadedmetadata = () => {
            r(u, l), c.getTracks().forEach((v) => v.stop()), m();
          }, u.play().catch(f);
        }), i();
      })().catch(o);
    }, []);
  };
}
function oB(e, t, s) {
  switch (e.type) {
    case "highlight": {
      t.shadowColor = "rgba(0, 0, 0, 0.7)", t.shadowBlur = 50, t.fillStyle = s, t.fillRect(e.x - 1, e.y - 1, e.w + 2, e.h + 2), t.clearRect(e.x, e.y, e.w, e.h);
      break;
    }
    case "hide":
      t.fillStyle = "rgb(0, 0, 0)", t.fillRect(e.x, e.y, e.w, e.h);
      break;
  }
}
function ei(e, t, s) {
  if (!e)
    return;
  const n = e.getContext("2d", t);
  n && s(e, n);
}
function Wf(e, t) {
  ei(e, { alpha: !0 }, (s, n) => {
    n.drawImage(t, 0, 0, t.width, t.height, 0, 0, s.width, s.height);
  });
}
function Gf(e, t, s) {
  ei(e, { alpha: !0 }, (n, r) => {
    s.length && (r.fillStyle = "rgba(0, 0, 0, 0.25)", r.fillRect(0, 0, n.width, n.height)), s.forEach((i) => {
      oB(i, r, t);
    });
  });
}
function iB({
  h: e,
  hooks: t,
  outputBuffer: s,
  dialog: n,
  options: r
}) {
  const i = rB({ hooks: t }), o = nB({ h: e }), l = sB({ h: e }), d = { __html: aB(r.styleNonce).innerText }, c = n.el.style, u = ({ screenshot: m }) => {
    const [f, v] = t.useState("highlight"), [b, w] = t.useState([]), S = t.useRef(null), I = t.useRef(null), T = t.useRef(null), x = t.useRef(null), [k, C] = t.useState(1), O = t.useMemo(() => {
      const L = ca.getElementById(r.id);
      if (!L)
        return "white";
      const j = getComputedStyle(L);
      return j.getPropertyValue("--button-primary-background") || j.getPropertyValue("--accent-background");
    }, [r.id]);
    t.useLayoutEffect(() => {
      const L = () => {
        const j = S.current;
        j && (ei(m.canvas, { alpha: !1 }, (H) => {
          const te = Math.min(
            j.clientWidth / H.width,
            j.clientHeight / H.height
          );
          C(te);
        }), (j.clientHeight === 0 || j.clientWidth === 0) && setTimeout(L, 0));
      };
      return L(), mr.addEventListener("resize", L), () => {
        mr.removeEventListener("resize", L);
      };
    }, [m]);
    const E = t.useCallback(
      (L, j) => {
        ei(L, { alpha: !0 }, (H, te) => {
          te.scale(j, j), H.width = m.canvas.width, H.height = m.canvas.height;
        });
      },
      [m]
    );
    t.useEffect(() => {
      E(I.current, m.dpi), Wf(I.current, m.canvas);
    }, [m]), t.useEffect(() => {
      E(T.current, m.dpi), ei(T.current, { alpha: !0 }, (L, j) => {
        j.clearRect(0, 0, L.width, L.height);
      }), Gf(T.current, O, b);
    }, [b, O]), t.useEffect(() => {
      E(s, m.dpi), Wf(s, m.canvas), ei(ca.createElement("canvas"), { alpha: !0 }, (L, j) => {
        j.scale(m.dpi, m.dpi), L.width = m.canvas.width, L.height = m.canvas.height, Gf(L, O, b), Wf(s, L);
      });
    }, [b, m, O]);
    const B = (L) => {
      if (!f || !x.current)
        return;
      const j = x.current.getBoundingClientRect(), H = {
        type: f,
        x: L.offsetX / k,
        y: L.offsetY / k
      }, te = (ie, ye) => {
        const Y = (ye.clientX - j.x) / k, ae = (ye.clientY - j.y) / k;
        return {
          type: ie.type,
          x: Math.min(ie.x, Y),
          y: Math.min(ie.y, ae),
          w: Math.abs(Y - ie.x),
          h: Math.abs(ae - ie.y)
        };
      }, re = (ie) => {
        ei(T.current, { alpha: !0 }, (ye, Y) => {
          Y.clearRect(0, 0, ye.width, ye.height);
        }), Gf(T.current, O, [...b, te(H, ie)]);
      }, le = (ie) => {
        const ye = te(H, ie);
        ye.w * k >= 1 && ye.h * k >= 1 && w((Y) => [...Y, ye]), ca.removeEventListener("mousemove", re), ca.removeEventListener("mouseup", le);
      };
      ca.addEventListener("mousemove", re), ca.addEventListener("mouseup", le);
    }, M = t.useCallback((L) => (j) => {
      j.preventDefault(), j.stopPropagation(), w((H) => {
        const te = [...H];
        return te.splice(L, 1), te;
      });
    }, []), R = {
      width: `${m.canvas.width * k}px`,
      height: `${m.canvas.height * k}px`
    }, F = (L) => {
      L.stopPropagation();
    };
    return e(
      "div",
      { class: "editor" },
      e("style", { nonce: r.styleNonce, dangerouslySetInnerHTML: d }),
      e(
        "div",
        { class: "editor__image-container" },
        e(
          "div",
          { class: "editor__canvas-container", ref: S },
          e("canvas", { ref: I, id: "background", style: R }),
          e("canvas", { ref: T, id: "foreground", style: R }),
          e(
            "div",
            { ref: x, onMouseDown: B, style: R },
            b.map((L, j) => e(
              "div",
              {
                key: j,
                class: "editor__rect",
                style: {
                  top: `${L.y * k}px`,
                  left: `${L.x * k}px`,
                  width: `${L.w * k}px`,
                  height: `${L.h * k}px`
                }
              },
              e(
                "button",
                {
                  "aria-label": "Remove",
                  onClick: M(j),
                  onMouseDown: F,
                  onMouseUp: F,
                  type: "button"
                },
                e(l, null)
              )
            ))
          )
        )
      ),
      e(o, { action: f, setAction: v })
    );
  };
  return function({ onError: f }) {
    const [v, b] = t.useState();
    return i({
      onBeforeScreenshot: t.useCallback(() => {
        c.display = "none";
      }, []),
      onScreenshot: t.useCallback((w, S) => {
        ei(ca.createElement("canvas"), { alpha: !1 }, (I, T) => {
          T.scale(S, S), I.width = w.videoWidth, I.height = w.videoHeight, T.drawImage(w, 0, 0, I.width, I.height), b({ canvas: I, dpi: S });
        }), s.width = w.videoWidth, s.height = w.videoHeight;
      }, []),
      onAfterScreenshot: t.useCallback(() => {
        c.display = "block";
      }, []),
      onError: t.useCallback((w) => {
        c.display = "block", f(w);
      }, [])
    }), v ? e(u, { screenshot: v }) : e("div", null);
  };
}
const lB = () => ({
  name: "FeedbackScreenshot",
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  setupOnce() {
  },
  createInput: ({ h: e, hooks: t, dialog: s, options: n }) => {
    const r = ca.createElement("canvas");
    return {
      input: iB({
        h: e,
        hooks: t,
        outputBuffer: r,
        dialog: s,
        options: n
      }),
      // eslint-disable-line @typescript-eslint/no-explicit-any
      value: async () => {
        const i = await new Promise((o) => {
          r.toBlob(o, "image/png");
        });
        if (i)
          return {
            data: new Uint8Array(await i.arrayBuffer()),
            filename: "screenshot.png",
            contentType: "application/png"
            // attachmentType?: string;
          };
      }
    };
  }
}), ls = As;
let Ov = 0;
function z3() {
  return Ov > 0;
}
function dB() {
  Ov++, setTimeout(() => {
    Ov--;
  });
}
function Cd(e, t = {}) {
  function s(r) {
    return typeof r == "function";
  }
  if (!s(e))
    return e;
  try {
    const r = e.__sentry_wrapped__;
    if (r)
      return typeof r == "function" ? r : e;
    if (c1(e))
      return e;
  } catch {
    return e;
  }
  const n = function(...r) {
    try {
      const i = r.map((o) => Cd(o, t));
      return e.apply(this, i);
    } catch (i) {
      throw dB(), Hm((o) => {
        o.addEventProcessor((l) => (t.mechanism && (pv(l, void 0), gd(l, t.mechanism)), l.extra = {
          ...l.extra,
          arguments: r
        }, l)), Ns(i);
      }), i;
    }
  };
  try {
    for (const r in e)
      Object.prototype.hasOwnProperty.call(e, r) && (n[r] = e[r]);
  } catch {
  }
  OP(n, e), Un(e, "__sentry_wrapped__", n);
  try {
    Object.getOwnPropertyDescriptor(n, "name").configurable && Object.defineProperty(n, "name", {
      get() {
        return e.name;
      }
    });
  } catch {
  }
  return n;
}
function S1() {
  const e = fl(), { referrer: t } = ls.document || {}, { userAgent: s } = ls.navigator || {}, n = {
    ...t && { Referer: t },
    ...s && { "User-Agent": s }
  };
  return {
    url: e,
    headers: n
  };
}
const cB = CL({
  getModalIntegration: () => tB,
  getScreenshotIntegration: () => lB
});
function P1(e, t) {
  const s = k1(e, t), n = {
    type: fB(t),
    value: gB(t)
  };
  return s.length && (n.stacktrace = { frames: s }), n.type === void 0 && n.value === "" && (n.value = "Unrecoverable error caught"), n;
}
function uB(e, t, s, n) {
  const r = ds(), i = r == null ? void 0 : r.getOptions().normalizeDepth, o = wB(t), l = {
    __serialized__: JP(t, i)
  };
  if (o)
    return {
      exception: {
        values: [P1(e, o)]
      },
      extra: l
    };
  const d = {
    exception: {
      values: [
        {
          type: jm(t) ? t.constructor.name : n ? "UnhandledRejection" : "Error",
          value: bB(t, { isUnhandledRejection: n })
        }
      ]
    },
    extra: l
  };
  if (s) {
    const c = k1(e, s);
    c.length && (d.exception.values[0].stacktrace = { frames: c });
  }
  return d;
}
function Yf(e, t) {
  return {
    exception: {
      values: [P1(e, t)]
    }
  };
}
function k1(e, t) {
  const s = t.stacktrace || t.stack || "", n = hB(t), r = mB(t);
  try {
    return e(s, n, r);
  } catch {
  }
  return [];
}
const pB = /Minified React error #\d+;/i;
function hB(e) {
  return e && pB.test(e.message) ? 1 : 0;
}
function mB(e) {
  return typeof e.framesToPop == "number" ? e.framesToPop : 0;
}
function W3(e) {
  return typeof WebAssembly < "u" && typeof WebAssembly.Exception < "u" ? e instanceof WebAssembly.Exception : !1;
}
function fB(e) {
  const t = e == null ? void 0 : e.name;
  return !t && W3(e) ? e.message && Array.isArray(e.message) && e.message.length == 2 ? e.message[0] : "WebAssembly.Exception" : t;
}
function gB(e) {
  const t = e == null ? void 0 : e.message;
  return W3(e) ? Array.isArray(e.message) && e.message.length == 2 ? e.message[1] : "wasm exception" : t ? t.error && typeof t.error.message == "string" ? t.error.message : t : "No error message";
}
function vB(e, t, s, n) {
  const r = (s == null ? void 0 : s.syntheticException) || void 0, i = E1(e, t, r, n);
  return gd(i), i.level = "error", s != null && s.event_id && (i.event_id = s.event_id), Vo(i);
}
function yB(e, t, s = "info", n, r) {
  const i = (n == null ? void 0 : n.syntheticException) || void 0, o = Rv(e, t, i, r);
  return o.level = s, n != null && n.event_id && (o.event_id = n.event_id), Vo(o);
}
function E1(e, t, s, n, r) {
  let i;
  if (kP(t) && t.error)
    return Yf(e, t.error);
  if (CA(t) || O9(t)) {
    const o = t;
    if ("stack" in t)
      i = Yf(e, t);
    else {
      const l = o.name || (CA(o) ? "DOMError" : "DOMException"), d = o.message ? `${l}: ${o.message}` : l;
      i = Rv(e, d, s, n), pv(i, d);
    }
    return "code" in o && (i.tags = { ...i.tags, "DOMException.code": `${o.code}` }), i;
  }
  return i1(t) ? Yf(e, t) : cu(t) || jm(t) ? (i = uB(e, t, s, r), gd(i, {
    synthetic: !0
  }), i) : (i = Rv(e, t, s, n), pv(i, `${t}`), gd(i, {
    synthetic: !0
  }), i);
}
function Rv(e, t, s, n) {
  const r = {};
  if (n && s) {
    const i = k1(e, s);
    i.length && (r.exception = {
      values: [{ value: t, stacktrace: { frames: i } }]
    }), gd(r, { synthetic: !0 });
  }
  if (l1(t)) {
    const { __sentry_template_string__: i, __sentry_template_values__: o } = t;
    return r.logentry = {
      message: i,
      params: o
    }, r;
  }
  return r.message = t, r;
}
function bB(e, { isUnhandledRejection: t }) {
  const s = V9(e), n = t ? "promise rejection" : "exception";
  return kP(e) ? `Event \`ErrorEvent\` captured as ${n} with message \`${e.message}\`` : jm(e) ? `Event \`${AB(e)}\` (type=${e.type}) captured as ${n}` : `Object captured as ${n} with keys: ${s}`;
}
function AB(e) {
  try {
    const t = Object.getPrototypeOf(e);
    return t ? t.constructor.name : void 0;
  } catch {
  }
}
function wB(e) {
  for (const t in e)
    if (Object.prototype.hasOwnProperty.call(e, t)) {
      const s = e[t];
      if (s instanceof Error)
        return s;
    }
}
const CB = 5e3;
class SB extends B7 {
  /**
   * Creates a new Browser SDK instance.
   *
   * @param options Configuration options for this SDK.
   */
  constructor(t) {
    const s = PB(t), n = ls.SENTRY_SDK_SOURCE || QR();
    b3(s, "browser", ["browser"], n), super(s);
    const { sendDefaultPii: r, sendClientReports: i, _experiments: o } = this._options, l = o == null ? void 0 : o.enableLogs;
    ls.document && (i || l) && ls.document.addEventListener("visibilitychange", () => {
      ls.document.visibilityState === "hidden" && (i && this._flushOutcomes(), l && jf(this));
    }), l && (this.on("flush", () => {
      jf(this);
    }), this.on("afterCaptureLog", () => {
      this._logFlushIdleTimeout && clearTimeout(this._logFlushIdleTimeout), this._logFlushIdleTimeout = setTimeout(() => {
        jf(this);
      }, CB);
    })), r && (this.on("postprocessEvent", K7), this.on("beforeSendSession", Z7));
  }
  /**
   * @inheritDoc
   */
  eventFromException(t, s) {
    return vB(this._options.stackParser, t, s, this._options.attachStacktrace);
  }
  /**
   * @inheritDoc
   */
  eventFromMessage(t, s = "info", n) {
    return yB(this._options.stackParser, t, s, n, this._options.attachStacktrace);
  }
  /**
   * @inheritDoc
   */
  _prepareEvent(t, s, n, r) {
    return t.platform = t.platform || "javascript", super._prepareEvent(t, s, n, r);
  }
}
function PB(e) {
  var t;
  return {
    release: typeof __SENTRY_RELEASE__ == "string" ? __SENTRY_RELEASE__ : (t = ls.SENTRY_RELEASE) == null ? void 0 : t.id,
    // This supports the variable that sentry-webpack-plugin injects
    sendClientReports: !0,
    // We default this to true, as it is the safer scenario
    parentSpanIsAlwaysRootSpan: !0,
    ...e
  };
}
const Sd = typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__, es = As, kB = (e, t) => e > t[1] ? "poor" : e > t[0] ? "needs-improvement" : "good", Xd = (e, t, s, n) => {
  let r, i;
  return (o) => {
    t.value >= 0 && (o || n) && (i = t.value - (r ?? 0), (i || r === void 0) && (r = t.value, t.delta = i, t.rating = kB(t.value, s), e(t)));
  };
}, EB = () => `v5-${Date.now()}-${Math.floor(Math.random() * (9e12 - 1)) + 1e12}`, ju = (e = !0) => {
  var s, n;
  const t = (n = (s = es.performance) == null ? void 0 : s.getEntriesByType) == null ? void 0 : n.call(s, "navigation")[0];
  if (
    // sentry-specific change:
    // We don't want to check for responseStart for our own use of `getNavigationEntry`
    !e || t && t.responseStart > 0 && t.responseStart < performance.now()
  )
    return t;
}, qd = () => {
  const e = ju();
  return (e == null ? void 0 : e.activationStart) ?? 0;
}, Qd = (e, t = -1) => {
  var i, o;
  const s = ju();
  let n = "navigate";
  return s && ((i = es.document) != null && i.prerendering || qd() > 0 ? n = "prerender" : (o = es.document) != null && o.wasDiscarded ? n = "restore" : s.type && (n = s.type.replace(/_/g, "-"))), {
    name: e,
    value: t,
    rating: "good",
    // If needed, will be updated when reported. `const` to keep the type from widening to `string`.
    delta: 0,
    entries: [],
    id: EB(),
    navigationType: n
  };
}, Xf = /* @__PURE__ */ new WeakMap();
function I1(e, t) {
  return Xf.get(e) || Xf.set(e, new t()), Xf.get(e);
}
class sm {
  constructor() {
    sm.prototype.__init.call(this), sm.prototype.__init2.call(this);
  }
  // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility
  // eslint-disable-next-line @sentry-internal/sdk/no-class-field-initializers, @typescript-eslint/explicit-member-accessibility
  __init() {
    this._sessionValue = 0;
  }
  // eslint-disable-next-line @sentry-internal/sdk/no-class-field-initializers, @typescript-eslint/explicit-member-accessibility
  __init2() {
    this._sessionEntries = [];
  }
  // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility
  _processEntry(t) {
    var r;
    if (t.hadRecentInput) return;
    const s = this._sessionEntries[0], n = this._sessionEntries[this._sessionEntries.length - 1];
    this._sessionValue && s && n && t.startTime - n.startTime < 1e3 && t.startTime - s.startTime < 5e3 ? (this._sessionValue += t.value, this._sessionEntries.push(t)) : (this._sessionValue = t.value, this._sessionEntries = [t]), (r = this._onAfterProcessingUnexpectedShift) == null || r.call(this, t);
  }
}
const Al = (e, t, s = {}) => {
  try {
    if (PerformanceObserver.supportedEntryTypes.includes(e)) {
      const n = new PerformanceObserver((r) => {
        Promise.resolve().then(() => {
          t(r.getEntries());
        });
      });
      return n.observe({ type: e, buffered: !0, ...s }), n;
    }
  } catch {
  }
}, Gm = (e) => {
  let t = !1;
  return () => {
    t || (e(), t = !0);
  };
};
let Zc = -1;
const IB = () => {
  var e, t;
  return ((e = es.document) == null ? void 0 : e.visibilityState) === "hidden" && !((t = es.document) != null && t.prerendering) ? 0 : 1 / 0;
}, am = (e) => {
  es.document.visibilityState === "hidden" && Zc > -1 && (Zc = e.type === "visibilitychange" ? e.timeStamp : 0, OB());
}, TB = () => {
  addEventListener("visibilitychange", am, !0), addEventListener("prerenderingchange", am, !0);
}, OB = () => {
  removeEventListener("visibilitychange", am, !0), removeEventListener("prerenderingchange", am, !0);
}, Ym = () => {
  var e;
  if (es.document && Zc < 0) {
    const t = qd();
    Zc = (es.document.prerendering || (e = globalThis.performance.getEntriesByType("visibility-state").filter((n) => n.name === "hidden" && n.startTime > t)[0]) == null ? void 0 : e.startTime) ?? IB(), TB();
  }
  return {
    get firstHiddenTime() {
      return Zc;
    }
  };
}, Hu = (e) => {
  var t;
  (t = es.document) != null && t.prerendering ? addEventListener("prerenderingchange", () => e(), !0) : e();
}, RB = [1800, 3e3], LB = (e, t = {}) => {
  Hu(() => {
    const s = Ym(), n = Qd("FCP");
    let r;
    const o = Al("paint", (l) => {
      for (const d of l)
        d.name === "first-contentful-paint" && (o.disconnect(), d.startTime < s.firstHiddenTime && (n.value = Math.max(d.startTime - qd(), 0), n.entries.push(d), r(!0)));
    });
    o && (r = Xd(e, n, RB, t.reportAllChanges));
  });
}, BB = [0.1, 0.25], MB = (e, t = {}) => {
  LB(
    Gm(() => {
      var l, d;
      const s = Qd("CLS", 0);
      let n;
      const r = I1(t, sm), i = (c) => {
        for (const u of c)
          r._processEntry(u);
        r._sessionValue > s.value && (s.value = r._sessionValue, s.entries = r._sessionEntries, n());
      }, o = Al("layout-shift", i);
      o && (n = Xd(e, s, BB, t.reportAllChanges), (l = es.document) == null || l.addEventListener("visibilitychange", () => {
        var c;
        ((c = es.document) == null ? void 0 : c.visibilityState) === "hidden" && (i(o.takeRecords()), n(!0));
      }), (d = es == null ? void 0 : es.setTimeout) == null || d.call(es, n));
    })
  );
}, Xm = (e) => {
  const t = (s) => {
    var n;
    (s.type === "pagehide" || ((n = es.document) == null ? void 0 : n.visibilityState) === "hidden") && e(s);
  };
  es.document && (addEventListener("visibilitychange", t, !0), addEventListener("pagehide", t, !0));
}, xB = [100, 300], FB = (e, t = {}) => {
  Hu(() => {
    const s = Ym(), n = Qd("FID");
    let r;
    const i = (d) => {
      d.startTime < s.firstHiddenTime && (n.value = d.processingStart - d.startTime, n.entries.push(d), r(!0));
    }, o = (d) => {
      d.forEach(i);
    }, l = Al("first-input", o);
    r = Xd(e, n, xB, t.reportAllChanges), l && Xm(
      Gm(() => {
        o(l.takeRecords()), l.disconnect();
      })
    );
  });
};
let G3 = 0, qf = 1 / 0, up = 0;
const VB = (e) => {
  e.forEach((t) => {
    t.interactionId && (qf = Math.min(qf, t.interactionId), up = Math.max(up, t.interactionId), G3 = up ? (up - qf) / 7 + 1 : 0);
  });
};
let Lv;
const Y3 = () => Lv ? G3 : performance.interactionCount || 0, DB = () => {
  "interactionCount" in performance || Lv || (Lv = Al("event", VB, {
    type: "event",
    buffered: !0,
    durationThreshold: 0
  }));
}, Qf = 10;
let X3 = 0;
const NB = () => Y3() - X3;
class nm {
  constructor() {
    nm.prototype.__init.call(this), nm.prototype.__init2.call(this);
  }
  /**
   * A list of longest interactions on the page (by latency) sorted so the
   * longest one is first. The list is at most MAX_INTERACTIONS_TO_CONSIDER
   * long.
   */
  // eslint-disable-next-line @sentry-internal/sdk/no-class-field-initializers, @typescript-eslint/explicit-member-accessibility
  __init() {
    this._longestInteractionList = [];
  }
  /**
   * A mapping of longest interactions by their interaction ID.
   * This is used for faster lookup.
   */
  // eslint-disable-next-line @sentry-internal/sdk/no-class-field-initializers, @typescript-eslint/explicit-member-accessibility
  __init2() {
    this._longestInteractionMap = /* @__PURE__ */ new Map();
  }
  // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility
  // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility
  // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility, jsdoc/require-jsdoc
  _resetInteractions() {
    X3 = Y3(), this._longestInteractionList.length = 0, this._longestInteractionMap.clear();
  }
  /**
   * Returns the estimated p98 longest interaction based on the stored
   * interaction candidates and the interaction count for the current page.
   */
  // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility
  _estimateP98LongestInteraction() {
    const t = Math.min(
      this._longestInteractionList.length - 1,
      Math.floor(NB() / 50)
    );
    return this._longestInteractionList[t];
  }
  /**
   * Takes a performance entry and adds it to the list of worst interactions
   * if its duration is long enough to make it among the worst. If the
   * entry is part of an existing interaction, it is merged and the latency
   * and entries list is updated as needed.
   */
  // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility
  _processEntry(t) {
    var r, i;
    if ((r = this._onBeforeProcessingEntry) == null || r.call(this, t), !(t.interactionId || t.entryType === "first-input")) return;
    const s = this._longestInteractionList.at(-1);
    let n = this._longestInteractionMap.get(t.interactionId);
    if (n || this._longestInteractionList.length < Qf || // If the above conditions are false, `minLongestInteraction` will be set.
    t.duration > s._latency) {
      if (n ? t.duration > n._latency ? (n.entries = [t], n._latency = t.duration) : t.duration === n._latency && t.startTime === n.entries[0].startTime && n.entries.push(t) : (n = {
        id: t.interactionId,
        entries: [t],
        _latency: t.duration
      }, this._longestInteractionMap.set(n.id, n), this._longestInteractionList.push(n)), this._longestInteractionList.sort((o, l) => l._latency - o._latency), this._longestInteractionList.length > Qf) {
        const o = this._longestInteractionList.splice(Qf);
        for (const l of o)
          this._longestInteractionMap.delete(l.id);
      }
      (i = this._onAfterProcessingINPCandidate) == null || i.call(this, n);
    }
  }
}
const q3 = (e) => {
  var s;
  const t = es.requestIdleCallback || es.setTimeout;
  ((s = es.document) == null ? void 0 : s.visibilityState) === "hidden" ? e() : (e = Gm(e), t(e), Xm(e));
}, jB = [200, 500], HB = 40, UB = (e, t = {}) => {
  globalThis.PerformanceEventTiming && "interactionId" in PerformanceEventTiming.prototype && Hu(() => {
    DB();
    const s = Qd("INP");
    let n;
    const r = I1(t, nm), i = (l) => {
      q3(() => {
        for (const c of l)
          r._processEntry(c);
        const d = r._estimateP98LongestInteraction();
        d && d._latency !== s.value && (s.value = d._latency, s.entries = d.entries, n());
      });
    }, o = Al("event", i, {
      // Event Timing entries have their durations rounded to the nearest 8ms,
      // so a duration of 40ms would be any event that spans 2.5 or more frames
      // at 60Hz. This threshold is chosen to strike a balance between usefulness
      // and performance. Running this callback for any interaction that spans
      // just one or two frames is likely not worth the insight that could be
      // gained.
      durationThreshold: t.durationThreshold ?? HB
    });
    n = Xd(e, s, jB, t.reportAllChanges), o && (o.observe({ type: "first-input", buffered: !0 }), Xm(() => {
      i(o.takeRecords()), n(!0);
    }));
  });
};
class zB {
  // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility
  // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility, jsdoc/require-jsdoc
  _processEntry(t) {
    var s;
    (s = this._onBeforeProcessingEntry) == null || s.call(this, t);
  }
}
const WB = [2500, 4e3], GB = (e, t = {}) => {
  Hu(() => {
    const s = Ym(), n = Qd("LCP");
    let r;
    const i = I1(t, zB), o = (d) => {
      t.reportAllChanges || (d = d.slice(-1));
      for (const c of d)
        i._processEntry(c), c.startTime < s.firstHiddenTime && (n.value = Math.max(c.startTime - qd(), 0), n.entries = [c], r());
    }, l = Al("largest-contentful-paint", o);
    if (l) {
      r = Xd(e, n, WB, t.reportAllChanges);
      const d = Gm(() => {
        o(l.takeRecords()), l.disconnect(), r(!0);
      });
      for (const c of ["keydown", "click", "visibilitychange"])
        es.document && addEventListener(c, () => q3(d), {
          capture: !0,
          once: !0
        });
    }
  });
}, YB = [800, 1800], Bv = (e) => {
  var t, s;
  (t = es.document) != null && t.prerendering ? Hu(() => Bv(e)) : ((s = es.document) == null ? void 0 : s.readyState) !== "complete" ? addEventListener("load", () => Bv(e), !0) : setTimeout(e);
}, XB = (e, t = {}) => {
  const s = Qd("TTFB"), n = Xd(e, s, YB, t.reportAllChanges);
  Bv(() => {
    const r = ju();
    r && (s.value = Math.max(r.responseStart - qd(), 0), s.entries = [r], n(!0));
  });
}, Jc = {}, rm = {};
let Q3, K3, Z3, J3, $3;
function T1(e, t = !1) {
  return Uu("cls", e, QB, Q3, t);
}
function O1(e, t = !1) {
  return Uu("lcp", e, ZB, Z3, t);
}
function _3(e) {
  return Uu("fid", e, KB, K3);
}
function qB(e) {
  return Uu("ttfb", e, JB, J3);
}
function e8(e) {
  return Uu("inp", e, $B, $3);
}
function rl(e, t) {
  return t8(e, t), rm[e] || (_B(e), rm[e] = !0), s8(e, t);
}
function Kd(e, t) {
  const s = Jc[e];
  if (s != null && s.length)
    for (const n of s)
      try {
        n(t);
      } catch (r) {
        Sd && ot.error(
          `Error while triggering instrumentation handler.
Type: ${e}
Name: ${Lo(n)}
Error:`,
          r
        );
      }
}
function QB() {
  return MB(
    (e) => {
      Kd("cls", {
        metric: e
      }), Q3 = e;
    },
    // We want the callback to be called whenever the CLS value updates.
    // By default, the callback is only called when the tab goes to the background.
    { reportAllChanges: !0 }
  );
}
function KB() {
  return FB((e) => {
    Kd("fid", {
      metric: e
    }), K3 = e;
  });
}
function ZB() {
  return GB(
    (e) => {
      Kd("lcp", {
        metric: e
      }), Z3 = e;
    },
    // We want the callback to be called whenever the LCP value updates.
    // By default, the callback is only called when the tab goes to the background.
    { reportAllChanges: !0 }
  );
}
function JB() {
  return XB((e) => {
    Kd("ttfb", {
      metric: e
    }), J3 = e;
  });
}
function $B() {
  return UB((e) => {
    Kd("inp", {
      metric: e
    }), $3 = e;
  });
}
function Uu(e, t, s, n, r = !1) {
  t8(e, t);
  let i;
  return rm[e] || (i = s(), rm[e] = !0), n && t({ metric: n }), s8(e, t, r ? i : void 0);
}
function _B(e) {
  const t = {};
  e === "event" && (t.durationThreshold = 0), Al(
    e,
    (s) => {
      Kd(e, { entries: s });
    },
    t
  );
}
function t8(e, t) {
  Jc[e] = Jc[e] || [], Jc[e].push(t);
}
function s8(e, t, s) {
  return () => {
    s && s();
    const n = Jc[e];
    if (!n)
      return;
    const r = n.indexOf(t);
    r !== -1 && n.splice(r, 1);
  };
}
function eM(e) {
  return "duration" in e;
}
function Kf(e) {
  return typeof e == "number" && isFinite(e);
}
function No(e, t, s, { ...n }) {
  const r = ms(e).start_timestamp;
  return r && r > t && typeof e.updateStartTime == "function" && e.updateStartTime(t), g1(e, () => {
    const i = bi({
      startTime: t,
      ...n
    });
    return i && i.end(s), i;
  });
}
function R1(e) {
  var S;
  const t = ds();
  if (!t)
    return;
  const { name: s, transaction: n, attributes: r, startTime: i } = e, { release: o, environment: l, sendDefaultPii: d } = t.getOptions(), c = t.getIntegrationByName("Replay"), u = c == null ? void 0 : c.getReplayId(), m = Is(), f = m.getUser(), v = f !== void 0 ? f.email || f.id || f.ip_address : void 0;
  let b;
  try {
    b = m.getScopeData().contexts.profile.profile_id;
  } catch {
  }
  const w = {
    release: o,
    environment: l,
    user: v || void 0,
    profile_id: b || void 0,
    replay_id: u || void 0,
    transaction: n,
    // Web vital score calculation relies on the user agent to account for different
    // browsers setting different thresholds for what is considered a good/meh/bad value.
    // For example: Chrome vs. Chrome Mobile
    "user_agent.original": (S = es.navigator) == null ? void 0 : S.userAgent,
    // This tells Sentry to infer the IP address from the request
    "client.address": d ? "{{auto}}" : void 0,
    ...r
  };
  return bi({
    name: s,
    attributes: w,
    startTime: i,
    experimental: {
      standalone: !0
    }
  });
}
function qm() {
  return es.addEventListener && es.performance;
}
function ya(e) {
  return e / 1e3;
}
function a8(e) {
  let t = "unknown", s = "unknown", n = "";
  for (const r of e) {
    if (r === "/") {
      [t, s] = e.split("/");
      break;
    }
    if (!isNaN(Number(r))) {
      t = n === "h" ? "http" : n, s = e.split(n)[1];
      break;
    }
    n += r;
  }
  return n === e && (t = n), { name: t, version: s };
}
function n8(e) {
  try {
    return PerformanceObserver.supportedEntryTypes.includes(e);
  } catch {
    return !1;
  }
}
function r8(e, t) {
  let s, n = !1;
  function r(l) {
    !n && s && t(l, s), n = !0;
  }
  Xm(() => {
    r("pagehide");
  });
  const i = e.on("beforeStartNavigationSpan", (l, d) => {
    d != null && d.isRedirect || (r("navigation"), i == null || i(), o == null || o());
  }), o = e.on("afterStartPageLoadSpan", (l) => {
    s = l.spanContext().spanId, o == null || o();
  });
}
function tM(e) {
  let t = 0, s;
  if (!n8("layout-shift"))
    return;
  const n = T1(({ metric: r }) => {
    const i = r.entries[r.entries.length - 1];
    i && (t = r.value, s = i);
  }, !0);
  r8(e, (r, i) => {
    sM(t, s, i, r), n();
  });
}
function sM(e, t, s, n) {
  var c;
  Sd && ot.log(`Sending CLS span (${e})`);
  const r = ya((on() || 0) + ((t == null ? void 0 : t.startTime) || 0)), i = Is().getScopeData().transactionName, o = t ? or((c = t.sources[0]) == null ? void 0 : c.node) : "Layout shift", l = {
    [Ca]: "auto.http.browser.cls",
    [Mo]: "ui.webvital.cls",
    [Gd]: (t == null ? void 0 : t.duration) || 0,
    // attach the pageload span id to the CLS span so that we can link them in the UI
    "sentry.pageload.span_id": s,
    // describes what triggered the web vital to be reported
    "sentry.report_event": n
  };
  t != null && t.sources && t.sources.forEach((u, m) => {
    l[`cls.source.${m + 1}`] = or(u.node);
  });
  const d = R1({
    name: o,
    transaction: i,
    attributes: l,
    startTime: r
  });
  d && (d.addEvent("cls", {
    [Fu]: "",
    [Vu]: e
  }), d.end(r));
}
function aM(e) {
  let t = 0, s;
  if (!n8("largest-contentful-paint"))
    return;
  const n = O1(({ metric: r }) => {
    const i = r.entries[r.entries.length - 1];
    i && (t = r.value, s = i);
  }, !0);
  r8(e, (r, i) => {
    nM(t, s, i, r), n();
  });
}
function nM(e, t, s, n) {
  Sd && ot.log(`Sending LCP span (${e})`);
  const r = ya((on() || 0) + ((t == null ? void 0 : t.startTime) || 0)), i = Is().getScopeData().transactionName, o = t ? or(t.element) : "Largest contentful paint", l = {
    [Ca]: "auto.http.browser.lcp",
    [Mo]: "ui.webvital.lcp",
    [Gd]: 0,
    // LCP is a point-in-time metric
    // attach the pageload span id to the LCP span so that we can link them in the UI
    "sentry.pageload.span_id": s,
    // describes what triggered the web vital to be reported
    "sentry.report_event": n
  };
  t && (t.element && (l["lcp.element"] = or(t.element)), t.id && (l["lcp.id"] = t.id), t.url && (l["lcp.url"] = t.url.trim().slice(0, 200)), t.loadTime != null && (l["lcp.loadTime"] = t.loadTime), t.renderTime != null && (l["lcp.renderTime"] = t.renderTime), t.size != null && (l["lcp.size"] = t.size));
  const d = R1({
    name: o,
    transaction: i,
    attributes: l,
    startTime: r
  });
  d && (d.addEvent("lcp", {
    [Fu]: "millisecond",
    [Vu]: e
  }), d.end(r));
}
const rM = 2147483647;
let k0 = 0, Xa = {}, An, Ql;
function oM({
  recordClsStandaloneSpans: e,
  recordLcpStandaloneSpans: t,
  client: s
}) {
  const n = qm();
  if (n && on()) {
    n.mark && es.performance.mark("sentry-tracing-init");
    const r = pM(), i = t ? aM(s) : uM(), o = hM(), l = e ? tM(s) : cM();
    return () => {
      r(), i == null || i(), o(), l == null || l();
    };
  }
  return () => {
  };
}
function iM() {
  rl("longtask", ({ entries: e }) => {
    const t = Ja();
    if (!t)
      return;
    const { op: s, start_timestamp: n } = ms(t);
    for (const r of e) {
      const i = ya(on() + r.startTime), o = ya(r.duration);
      s === "navigation" && n && i < n || No(t, i, i + o, {
        name: "Main UI thread blocked",
        op: "ui.long-task",
        attributes: {
          [Ca]: "auto.ui.browser.metrics"
        }
      });
    }
  });
}
function lM() {
  new PerformanceObserver((t) => {
    const s = Ja();
    if (s)
      for (const n of t.getEntries()) {
        if (!n.scripts[0])
          continue;
        const r = ya(on() + n.startTime), { start_timestamp: i, op: o } = ms(s);
        if (o === "navigation" && i && r < i)
          continue;
        const l = ya(n.duration), d = {
          [Ca]: "auto.ui.browser.metrics"
        }, c = n.scripts[0], { invoker: u, invokerType: m, sourceURL: f, sourceFunctionName: v, sourceCharPosition: b } = c;
        d["browser.script.invoker"] = u, d["browser.script.invoker_type"] = m, f && (d["code.filepath"] = f), v && (d["code.function"] = v), b !== -1 && (d["browser.script.source_char_position"] = b), No(s, r, r + l, {
          name: "Main UI thread blocked",
          op: "ui.long-animation-frame",
          attributes: d
        });
      }
  }).observe({ type: "long-animation-frame", buffered: !0 });
}
function dM() {
  rl("event", ({ entries: e }) => {
    const t = Ja();
    if (t) {
      for (const s of e)
        if (s.name === "click") {
          const n = ya(on() + s.startTime), r = ya(s.duration), i = {
            name: or(s.target),
            op: `ui.interaction.${s.name}`,
            startTime: n,
            attributes: {
              [Ca]: "auto.ui.browser.metrics"
            }
          }, o = TP(s.target);
          o && (i.attributes["ui.component_name"] = o), No(t, n, n + r, i);
        }
    }
  });
}
function cM() {
  return T1(({ metric: e }) => {
    const t = e.entries[e.entries.length - 1];
    t && (Xa.cls = { value: e.value, unit: "" }, Ql = t);
  }, !0);
}
function uM() {
  return O1(({ metric: e }) => {
    const t = e.entries[e.entries.length - 1];
    t && (Xa.lcp = { value: e.value, unit: "millisecond" }, An = t);
  }, !0);
}
function pM() {
  return _3(({ metric: e }) => {
    const t = e.entries[e.entries.length - 1];
    if (!t)
      return;
    const s = ya(on()), n = ya(t.startTime);
    Xa.fid = { value: e.value, unit: "millisecond" }, Xa["mark.fid"] = { value: s + n, unit: "second" };
  });
}
function hM() {
  return qB(({ metric: e }) => {
    e.entries[e.entries.length - 1] && (Xa.ttfb = { value: e.value, unit: "millisecond" });
  });
}
function mM(e, t) {
  const s = qm(), n = on();
  if (!(s != null && s.getEntries) || !n)
    return;
  const r = ya(n), i = s.getEntries(), { op: o, start_timestamp: l } = ms(e);
  if (i.slice(k0).forEach((d) => {
    const c = ya(d.startTime), u = ya(
      // Inexplicably, Chrome sometimes emits a negative duration. We need to work around this.
      // There is a SO post attempting to explain this, but it leaves one with open questions: https://stackoverflow.com/questions/23191918/peformance-getentries-and-negative-duration-display
      // The way we clamp the value is probably not accurate, since we have observed this happen for things that may take a while to load, like for example the replay worker.
      // TODO: Investigate why this happens and how to properly mitigate. For now, this is a workaround to prevent transactions being dropped due to negative duration spans.
      Math.max(0, d.duration)
    );
    if (!(o === "navigation" && l && r + c < l))
      switch (d.entryType) {
        case "navigation": {
          vM(e, d, r);
          break;
        }
        case "mark":
        case "paint":
        case "measure": {
          fM(e, d, c, u, r, t.ignorePerformanceApiSpans);
          const m = Ym(), f = d.startTime < m.firstHiddenTime;
          d.name === "first-paint" && f && (Xa.fp = { value: d.startTime, unit: "millisecond" }), d.name === "first-contentful-paint" && f && (Xa.fcp = { value: d.startTime, unit: "millisecond" });
          break;
        }
        case "resource": {
          AM(
            e,
            d,
            d.name,
            c,
            u,
            r,
            t.ignoreResourceSpans
          );
          break;
        }
      }
  }), k0 = Math.max(i.length - 1, 0), wM(e), o === "pageload") {
    SM(Xa);
    const d = Xa["mark.fid"];
    d && Xa.fid && (No(e, d.value, d.value + ya(Xa.fid.value), {
      name: "first input delay",
      op: "ui.action",
      attributes: {
        [Ca]: "auto.ui.browser.metrics"
      }
    }), delete Xa["mark.fid"]), (!("fcp" in Xa) || !t.recordClsOnPageloadSpan) && delete Xa.cls, t.recordLcpOnPageloadSpan || delete Xa.lcp, Object.entries(Xa).forEach(([c, u]) => {
      HO(c, u.value, u.unit);
    }), e.setAttribute("performance.timeOrigin", r), e.setAttribute("performance.activationStart", qd()), CM(e, t);
  }
  An = void 0, Ql = void 0, Xa = {};
}
function fM(e, t, s, n, r, i) {
  if (["mark", "measure"].includes(t.entryType) && Io(t.name, i))
    return;
  const o = ju(!1), l = ya(o ? o.requestStart : 0), d = r + Math.max(s, l), c = r + s, u = c + n, m = {
    [Ca]: "auto.resource.browser.metrics"
  };
  d !== c && (m["sentry.browser.measure_happened_before_request"] = !0, m["sentry.browser.measure_start_time"] = d), gM(m, t), d <= u && No(e, d, u, {
    name: t.name,
    op: t.entryType,
    attributes: m
  });
}
function gM(e, t) {
  try {
    const s = t.detail;
    if (!s)
      return;
    if (typeof s == "object") {
      for (const [n, r] of Object.entries(s))
        if (r && du(r))
          e[`sentry.browser.measure.detail.${n}`] = r;
        else if (r !== void 0)
          try {
            e[`sentry.browser.measure.detail.${n}`] = JSON.stringify(r);
          } catch {
          }
      return;
    }
    if (du(s)) {
      e["sentry.browser.measure.detail"] = s;
      return;
    }
    try {
      e["sentry.browser.measure.detail"] = JSON.stringify(s);
    } catch {
    }
  } catch {
  }
}
function vM(e, t, s) {
  ["unloadEvent", "redirect", "domContentLoadedEvent", "loadEvent", "connect"].forEach((n) => {
    pp(e, t, n, s);
  }), pp(e, t, "secureConnection", s, "TLS/SSL"), pp(e, t, "fetch", s, "cache"), pp(e, t, "domainLookup", s, "DNS"), bM(e, t, s);
}
function pp(e, t, s, n, r = s) {
  const i = yM(s), o = t[i], l = t[`${s}Start`];
  !l || !o || No(e, n + ya(l), n + ya(o), {
    op: `browser.${r}`,
    name: t.name,
    attributes: {
      [Ca]: "auto.ui.browser.metrics",
      ...s === "redirect" && t.redirectCount != null ? { "http.redirect_count": t.redirectCount } : {}
    }
  });
}
function yM(e) {
  return e === "secureConnection" ? "connectEnd" : e === "fetch" ? "domainLookupStart" : `${e}End`;
}
function bM(e, t, s) {
  const n = s + ya(t.requestStart), r = s + ya(t.responseEnd), i = s + ya(t.responseStart);
  t.responseEnd && (No(e, n, r, {
    op: "browser.request",
    name: t.name,
    attributes: {
      [Ca]: "auto.ui.browser.metrics"
    }
  }), No(e, i, r, {
    op: "browser.response",
    name: t.name,
    attributes: {
      [Ca]: "auto.ui.browser.metrics"
    }
  }));
}
function AM(e, t, s, n, r, i, o) {
  if (t.initiatorType === "xmlhttprequest" || t.initiatorType === "fetch")
    return;
  const l = t.initiatorType ? `resource.${t.initiatorType}` : "resource.other";
  if (o != null && o.includes(l))
    return;
  const d = _i(s), c = {
    [Ca]: "auto.resource.browser.metrics"
  };
  Zf(c, t, "transferSize", "http.response_transfer_size"), Zf(c, t, "encodedBodySize", "http.response_content_length"), Zf(c, t, "decodedBodySize", "http.decoded_response_content_length");
  const u = t.deliveryType;
  u != null && (c["http.response_delivery_type"] = u);
  const m = t.renderBlockingStatus;
  if (m && (c["resource.render_blocking_status"] = m), d.protocol && (c["url.scheme"] = d.protocol.split(":").pop()), d.host && (c["server.address"] = d.host), c["url.same_origin"] = s.includes(es.location.origin), t.nextHopProtocol != null) {
    const { name: b, version: w } = a8(t.nextHopProtocol);
    c["network.protocol.name"] = b, c["network.protocol.version"] = w;
  }
  const f = i + n, v = f + r;
  No(e, f, v, {
    name: s.replace(es.location.origin, ""),
    op: l,
    attributes: c
  });
}
function wM(e) {
  const t = es.navigator;
  if (!t)
    return;
  const s = t.connection;
  s && (s.effectiveType && e.setAttribute("effectiveConnectionType", s.effectiveType), s.type && e.setAttribute("connectionType", s.type), Kf(s.rtt) && (Xa["connection.rtt"] = { value: s.rtt, unit: "millisecond" })), Kf(t.deviceMemory) && e.setAttribute("deviceMemory", `${t.deviceMemory} GB`), Kf(t.hardwareConcurrency) && e.setAttribute("hardwareConcurrency", String(t.hardwareConcurrency));
}
function CM(e, t) {
  An && t.recordLcpOnPageloadSpan && (An.element && e.setAttribute("lcp.element", or(An.element)), An.id && e.setAttribute("lcp.id", An.id), An.url && e.setAttribute("lcp.url", An.url.trim().slice(0, 200)), An.loadTime != null && e.setAttribute("lcp.loadTime", An.loadTime), An.renderTime != null && e.setAttribute("lcp.renderTime", An.renderTime), e.setAttribute("lcp.size", An.size)), Ql != null && Ql.sources && t.recordClsOnPageloadSpan && Ql.sources.forEach(
    (s, n) => e.setAttribute(`cls.source.${n + 1}`, or(s.node))
  );
}
function Zf(e, t, s, n) {
  const r = t[s];
  r != null && r < rM && (e[n] = r);
}
function SM(e) {
  const t = ju(!1);
  if (!t)
    return;
  const { responseStart: s, requestStart: n } = t;
  n <= s && (e["ttfb.requestTime"] = {
    value: s - n,
    unit: "millisecond"
  });
}
function PM() {
  return qm() && on() ? rl("element", kM) : () => {
  };
}
const kM = ({ entries: e }) => {
  const t = Ja(), s = t ? Wa(t) : void 0, n = s ? ms(s).description : Is().getScopeData().transactionName;
  e.forEach((r) => {
    var v, b;
    const i = r;
    if (!i.identifier)
      return;
    const o = i.name, l = i.renderTime, d = i.loadTime, [c, u] = d ? [ya(d), "load-time"] : l ? [ya(l), "render-time"] : [Ea(), "entry-emission"], m = o === "image-paint" ? (
      // for image paints, we can acually get a duration because image-paint entries also have a `loadTime`
      // and `renderTime`. `loadTime` is the time when the image finished loading and `renderTime` is the
      // time when the image finished rendering.
      ya(Math.max(0, (l ?? 0) - (d ?? 0)))
    ) : (
      // for `'text-paint'` entries, we can't get a duration because the `loadTime` is always zero.
      0
    ), f = {
      [Ca]: "auto.ui.browser.elementtiming",
      [Mo]: "ui.elementtiming",
      // name must be user-entered, so we can assume low cardinality
      [Tn]: "component",
      // recording the source of the span start time, as it varies depending on available data
      "sentry.span_start_time_source": u,
      "sentry.transaction_name": n,
      "element.id": i.id,
      "element.type": ((b = (v = i.element) == null ? void 0 : v.tagName) == null ? void 0 : b.toLowerCase()) || "unknown",
      "element.size": i.naturalWidth && i.naturalHeight ? `${i.naturalWidth}x${i.naturalHeight}` : void 0,
      "element.render_time": l,
      "element.load_time": d,
      // `url` is `0`(number) for text paints (hence we fall back to undefined)
      "element.url": i.url || void 0,
      "element.identifier": i.identifier,
      "element.paint_type": o
    };
    XO(
      {
        name: `element[${i.identifier}]`,
        attributes: f,
        startTime: c,
        onlyIfParent: !0
      },
      (w) => {
        w.end(c + m);
      }
    );
  });
}, EM = 1e3;
let E0, Mv, xv;
function o8(e) {
  Ri("dom", e), Li("dom", IM);
}
function IM() {
  if (!es.document)
    return;
  const e = nr.bind(null, "dom"), t = I0(e, !0);
  es.document.addEventListener("click", t, !1), es.document.addEventListener("keypress", t, !1), ["EventTarget", "Node"].forEach((s) => {
    var i, o;
    const r = (i = es[s]) == null ? void 0 : i.prototype;
    (o = r == null ? void 0 : r.hasOwnProperty) != null && o.call(r, "addEventListener") && (In(r, "addEventListener", function(l) {
      return function(d, c, u) {
        if (d === "click" || d == "keypress")
          try {
            const m = this.__sentry_instrumentation_handlers__ = this.__sentry_instrumentation_handlers__ || {}, f = m[d] = m[d] || { refCount: 0 };
            if (!f.handler) {
              const v = I0(e);
              f.handler = v, l.call(this, d, v, u);
            }
            f.refCount++;
          } catch {
          }
        return l.call(this, d, c, u);
      };
    }), In(
      r,
      "removeEventListener",
      function(l) {
        return function(d, c, u) {
          if (d === "click" || d == "keypress")
            try {
              const m = this.__sentry_instrumentation_handlers__ || {}, f = m[d];
              f && (f.refCount--, f.refCount <= 0 && (l.call(this, d, f.handler, u), f.handler = void 0, delete m[d]), Object.keys(m).length === 0 && delete this.__sentry_instrumentation_handlers__);
            } catch {
            }
          return l.call(this, d, c, u);
        };
      }
    ));
  });
}
function TM(e) {
  if (e.type !== Mv)
    return !1;
  try {
    if (!e.target || e.target._sentryId !== xv)
      return !1;
  } catch {
  }
  return !0;
}
function OM(e, t) {
  return e !== "keypress" ? !1 : t != null && t.tagName ? !(t.tagName === "INPUT" || t.tagName === "TEXTAREA" || t.isContentEditable) : !0;
}
function I0(e, t = !1) {
  return (s) => {
    if (!s || s._sentryCaptured)
      return;
    const n = RM(s);
    if (OM(s.type, n))
      return;
    Un(s, "_sentryCaptured", !0), n && !n._sentryId && Un(n, "_sentryId", gn());
    const r = s.type === "keypress" ? "input" : s.type;
    TM(s) || (e({ event: s, name: r, global: t }), Mv = s.type, xv = n ? n._sentryId : void 0), clearTimeout(E0), E0 = es.setTimeout(() => {
      xv = void 0, Mv = void 0;
    }, EM);
  };
}
function RM(e) {
  try {
    return e.target;
  } catch {
    return null;
  }
}
let hp;
function Qm(e) {
  const t = "history";
  Ri(t, e), Li(t, LM);
}
function LM() {
  if (es.addEventListener("popstate", () => {
    const t = es.location.href, s = hp;
    if (hp = t, s === t)
      return;
    nr("history", { from: s, to: t });
  }), !jR())
    return;
  function e(t) {
    return function(...s) {
      const n = s.length > 2 ? s[2] : void 0;
      if (n) {
        const r = hp, i = BM(String(n));
        if (hp = i, r === i)
          return t.apply(this, s);
        nr("history", { from: r, to: i });
      }
      return t.apply(this, s);
    };
  }
  In(es.history, "pushState", e), In(es.history, "replaceState", e);
}
function BM(e) {
  try {
    return new URL(e, es.location.origin).toString();
  } catch {
    return e;
  }
}
const ch = {};
function i8(e) {
  const t = ch[e];
  if (t)
    return t;
  let s = es[e];
  if (Cv(s))
    return ch[e] = s.bind(es);
  const n = es.document;
  if (n && typeof n.createElement == "function")
    try {
      const r = n.createElement("iframe");
      r.hidden = !0, n.head.appendChild(r);
      const i = r.contentWindow;
      i != null && i[e] && (s = i[e]), n.head.removeChild(r);
    } catch (r) {
      Sd && ot.warn(`Could not create sandbox iframe for ${e} check, bailing to window.${e}: `, r);
    }
  return s && (ch[e] = s.bind(es));
}
function T0(e) {
  ch[e] = void 0;
}
function zu(...e) {
  return i8("setTimeout")(...e);
}
const Gi = "__sentry_xhr_v3__";
function l8(e) {
  Ri("xhr", e), Li("xhr", MM);
}
function MM() {
  if (!es.XMLHttpRequest)
    return;
  const e = XMLHttpRequest.prototype;
  e.open = new Proxy(e.open, {
    apply(t, s, n) {
      const r = new Error(), i = Ea() * 1e3, o = Eo(n[0]) ? n[0].toUpperCase() : void 0, l = xM(n[1]);
      if (!o || !l)
        return t.apply(s, n);
      s[Gi] = {
        method: o,
        url: l,
        request_headers: {}
      }, o === "POST" && l.match(/sentry_key/) && (s.__sentry_own_request__ = !0);
      const d = () => {
        const c = s[Gi];
        if (c && s.readyState === 4) {
          try {
            c.status_code = s.status;
          } catch {
          }
          const u = {
            endTimestamp: Ea() * 1e3,
            startTimestamp: i,
            xhr: s,
            virtualError: r
          };
          nr("xhr", u);
        }
      };
      return "onreadystatechange" in s && typeof s.onreadystatechange == "function" ? s.onreadystatechange = new Proxy(s.onreadystatechange, {
        apply(c, u, m) {
          return d(), c.apply(u, m);
        }
      }) : s.addEventListener("readystatechange", d), s.setRequestHeader = new Proxy(s.setRequestHeader, {
        apply(c, u, m) {
          const [f, v] = m, b = u[Gi];
          return b && Eo(f) && Eo(v) && (b.request_headers[f.toLowerCase()] = v), c.apply(u, m);
        }
      }), t.apply(s, n);
    }
  }), e.send = new Proxy(e.send, {
    apply(t, s, n) {
      const r = s[Gi];
      if (!r)
        return t.apply(s, n);
      n[0] !== void 0 && (r.body = n[0]);
      const i = {
        startTimestamp: Ea() * 1e3,
        xhr: s
      };
      return nr("xhr", i), t.apply(s, n);
    }
  });
}
function xM(e) {
  if (Eo(e))
    return e;
  try {
    return e.toString();
  } catch {
  }
}
function d8(e) {
  return new URLSearchParams(e).toString();
}
function c8(e, t = ot) {
  try {
    if (typeof e == "string")
      return [e];
    if (e instanceof URLSearchParams)
      return [e.toString()];
    if (e instanceof FormData)
      return [d8(e)];
    if (!e)
      return [void 0];
  } catch (s) {
    return Sd && t.error(s, "Failed to serialize body", e), [void 0, "BODY_PARSE_ERROR"];
  }
  return Sd && t.log("Skipping network body because of body type", e), [void 0, "UNPARSEABLE_BODY_TYPE"];
}
function u8(e = []) {
  if (!(e.length !== 2 || typeof e[1] != "object"))
    return e[1].body;
}
const Jf = [], uh = /* @__PURE__ */ new Map(), FM = 60;
function VM() {
  if (qm() && on()) {
    const t = DM();
    return () => {
      t();
    };
  }
  return () => {
  };
}
const O0 = {
  click: "click",
  pointerdown: "click",
  pointerup: "click",
  mousedown: "click",
  mouseup: "click",
  touchstart: "click",
  touchend: "click",
  mouseover: "hover",
  mouseout: "hover",
  mouseenter: "hover",
  mouseleave: "hover",
  pointerover: "hover",
  pointerout: "hover",
  pointerenter: "hover",
  pointerleave: "hover",
  dragstart: "drag",
  dragend: "drag",
  drag: "drag",
  dragenter: "drag",
  dragleave: "drag",
  dragover: "drag",
  drop: "drag",
  keydown: "press",
  keyup: "press",
  keypress: "press",
  input: "press"
};
function DM() {
  return e8(NM);
}
const NM = ({ metric: e }) => {
  if (e.value == null)
    return;
  const t = ya(e.value);
  if (t > FM)
    return;
  const s = e.entries.find((b) => b.duration === e.value && O0[b.name]);
  if (!s)
    return;
  const { interactionId: n } = s, r = O0[s.name], i = ya(on() + s.startTime), o = Ja(), l = o ? Wa(o) : void 0, c = (n != null ? uh.get(n) : void 0) || l, u = c ? ms(c).description : Is().getScopeData().transactionName, m = or(s.target), f = {
    [Ca]: "auto.http.browser.inp",
    [Mo]: `ui.interaction.${r}`,
    [Gd]: s.duration
  }, v = R1({
    name: m,
    transaction: u,
    attributes: f,
    startTime: i
  });
  v && (v.addEvent("inp", {
    [Fu]: "millisecond",
    [Vu]: e.value
  }), v.end(i + t));
};
function jM() {
  const e = ({ entries: t }) => {
    const s = Ja(), n = s && Wa(s);
    t.forEach((r) => {
      if (!eM(r) || !n)
        return;
      const i = r.interactionId;
      if (i != null && !uh.has(i)) {
        if (Jf.length > 10) {
          const o = Jf.shift();
          uh.delete(o);
        }
        Jf.push(i), uh.set(i, n);
      }
    });
  };
  rl("event", e), rl("first-input", e);
}
function HM(e, t = i8("fetch")) {
  let s = 0, n = 0;
  function r(i) {
    const o = i.body.length;
    s += o, n++;
    const l = {
      body: i.body,
      method: "POST",
      referrerPolicy: "strict-origin",
      headers: e.headers,
      // Outgoing requests are usually cancelled when navigating to a different page, causing a "TypeError: Failed to
      // fetch" error and sending a "network_error" client-outcome - in Chrome, the request status shows "(cancelled)".
      // The `keepalive` flag keeps outgoing requests alive, even when switching pages. We want this since we're
      // frequently sending events right before the user is switching pages (eg. when finishing navigation transactions).
      // Gotchas:
      // - `keepalive` isn't supported by Firefox
      // - As per spec (https://fetch.spec.whatwg.org/#http-network-or-cache-fetch):
      //   If the sum of contentLength and inflightKeepaliveBytes is greater than 64 kibibytes, then return a network error.
      //   We will therefore only activate the flag when we're below that limit.
      // There is also a limit of requests that can be open at the same time, so we also limit this to 15
      // See https://github.com/getsentry/sentry-javascript/pull/7553 for details
      keepalive: s <= 6e4 && n < 15,
      ...e.fetchOptions
    };
    if (!t)
      return T0("fetch"), _h("No fetch implementation available");
    try {
      return t(e.url, l).then((d) => (s -= o, n--, {
        statusCode: d.status,
        headers: {
          "x-sentry-rate-limits": d.headers.get("X-Sentry-Rate-Limits"),
          "retry-after": d.headers.get("Retry-After")
        }
      }));
    } catch (d) {
      return T0("fetch"), s -= o, n--, _h(d);
    }
  }
  return Y7(e, r);
}
const UM = 30, zM = 50;
function Fv(e, t, s, n) {
  const r = {
    filename: e,
    function: t === "<anonymous>" ? al : t,
    in_app: !0
    // All browser frames are considered in_app
  };
  return s !== void 0 && (r.lineno = s), n !== void 0 && (r.colno = n), r;
}
const WM = /^\s*at (\S+?)(?::(\d+))(?::(\d+))\s*$/i, GM = /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i, YM = /\((\S*)(?::(\d+))(?::(\d+))\)/, XM = (e) => {
  const t = WM.exec(e);
  if (t) {
    const [, n, r, i] = t;
    return Fv(n, al, +r, +i);
  }
  const s = GM.exec(e);
  if (s) {
    if (s[2] && s[2].indexOf("eval") === 0) {
      const o = YM.exec(s[2]);
      o && (s[2] = o[1], s[3] = o[2], s[4] = o[3]);
    }
    const [r, i] = p8(s[1] || al, s[2]);
    return Fv(i, r, s[3] ? +s[3] : void 0, s[4] ? +s[4] : void 0);
  }
}, qM = [UM, XM], QM = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i, KM = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i, ZM = (e) => {
  const t = QM.exec(e);
  if (t) {
    if (t[3] && t[3].indexOf(" > eval") > -1) {
      const i = KM.exec(t[3]);
      i && (t[1] = t[1] || "eval", t[3] = i[1], t[4] = i[2], t[5] = "");
    }
    let n = t[3], r = t[1] || al;
    return [r, n] = p8(r, n), Fv(n, r, t[4] ? +t[4] : void 0, t[5] ? +t[5] : void 0);
  }
}, JM = [zM, ZM], $M = [qM, JM], _M = wP(...$M), p8 = (e, t) => {
  const s = e.indexOf("safari-extension") !== -1, n = e.indexOf("safari-web-extension") !== -1;
  return s || n ? [
    e.indexOf("@") !== -1 ? e.split("@")[0] : al,
    s ? `safari-extension:${t}` : `safari-web-extension:${t}`
  ] : [e, t];
}, Es = typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__, mp = 1024, ex = "Breadcrumbs", tx = (e = {}) => {
  const t = {
    console: !0,
    dom: !0,
    fetch: !0,
    history: !0,
    sentry: !0,
    xhr: !0,
    ...e
  };
  return {
    name: ex,
    setup(s) {
      t.console && bR(rx(s)), t.dom && o8(nx(s, t.dom)), t.xhr && l8(ox(s)), t.fetch && T3(ix(s)), t.history && Qm(lx(s)), t.sentry && s.on("beforeSendEvent", ax(s));
    }
  };
}, sx = tx;
function ax(e) {
  return function(s) {
    ds() === e && wi(
      {
        category: `sentry.${s.type === "transaction" ? "transaction" : "event"}`,
        event_id: s.event_id,
        level: s.level,
        message: ji(s)
      },
      {
        event: s
      }
    );
  };
}
function nx(e, t) {
  return function(n) {
    if (ds() !== e)
      return;
    let r, i, o = typeof t == "object" ? t.serializeAttribute : void 0, l = typeof t == "object" && typeof t.maxStringLength == "number" ? t.maxStringLength : void 0;
    l && l > mp && (Es && ot.warn(
      `\`dom.maxStringLength\` cannot exceed ${mp}, but a value of ${l} was configured. Sentry will use ${mp} instead.`
    ), l = mp), typeof o == "string" && (o = [o]);
    try {
      const c = n.event, u = dx(c) ? c.target : c;
      r = or(u, { keyAttrs: o, maxStringLength: l }), i = TP(u);
    } catch {
      r = "<unknown>";
    }
    if (r.length === 0)
      return;
    const d = {
      category: `ui.${n.name}`,
      message: r
    };
    i && (d.data = { "ui.component_name": i }), wi(d, {
      event: n.event,
      name: n.name,
      global: n.global
    });
  };
}
function rx(e) {
  return function(s) {
    if (ds() !== e)
      return;
    const n = {
      category: "console",
      data: {
        arguments: s.args,
        logger: "console"
      },
      level: C3(s.level),
      message: SA(s.args, " ")
    };
    if (s.level === "assert")
      if (s.args[0] === !1)
        n.message = `Assertion failed: ${SA(s.args.slice(1), " ") || "console.assert"}`, n.data.arguments = s.args.slice(1);
      else
        return;
    wi(n, {
      input: s.args,
      level: s.level
    });
  };
}
function ox(e) {
  return function(s) {
    if (ds() !== e)
      return;
    const { startTimestamp: n, endTimestamp: r } = s, i = s.xhr[Gi];
    if (!n || !r || !i)
      return;
    const { method: o, url: l, status_code: d, body: c } = i, u = {
      method: o,
      url: l,
      status_code: d
    }, m = {
      xhr: s.xhr,
      input: c,
      startTimestamp: n,
      endTimestamp: r
    }, f = {
      category: "xhr",
      data: u,
      type: "http",
      level: I3(d)
    };
    e.emit("beforeOutgoingRequestBreadcrumb", f, m), wi(f, m);
  };
}
function ix(e) {
  return function(s) {
    if (ds() !== e)
      return;
    const { startTimestamp: n, endTimestamp: r } = s;
    if (r && !(s.fetchData.url.match(/sentry_key/) && s.fetchData.method === "POST"))
      if (s.fetchData.method, s.fetchData.url, s.error) {
        const i = s.fetchData, o = {
          data: s.error,
          input: s.args,
          startTimestamp: n,
          endTimestamp: r
        }, l = {
          category: "fetch",
          data: i,
          level: "error",
          type: "http"
        };
        e.emit("beforeOutgoingRequestBreadcrumb", l, o), wi(l, o);
      } else {
        const i = s.response, o = {
          ...s.fetchData,
          status_code: i == null ? void 0 : i.status
        };
        s.fetchData.request_body_size, s.fetchData.response_body_size, i == null || i.status;
        const l = {
          input: s.args,
          response: i,
          startTimestamp: n,
          endTimestamp: r
        }, d = {
          category: "fetch",
          data: o,
          type: "http",
          level: I3(o.status_code)
        };
        e.emit("beforeOutgoingRequestBreadcrumb", d, l), wi(d, l);
      }
  };
}
function lx(e) {
  return function(s) {
    if (ds() !== e)
      return;
    let n = s.from, r = s.to;
    const i = _i(ls.location.href);
    let o = n ? _i(n) : void 0;
    const l = _i(r);
    o != null && o.path || (o = i), i.protocol === l.protocol && i.host === l.host && (r = l.relative), i.protocol === o.protocol && i.host === o.host && (n = o.relative), wi({
      category: "navigation",
      data: {
        from: n,
        to: r
      }
    });
  };
}
function dx(e) {
  return !!e && !!e.target;
}
const cx = [
  "EventTarget",
  "Window",
  "Node",
  "ApplicationCache",
  "AudioTrackList",
  "BroadcastChannel",
  "ChannelMergerNode",
  "CryptoOperation",
  "EventSource",
  "FileReader",
  "HTMLUnknownElement",
  "IDBDatabase",
  "IDBRequest",
  "IDBTransaction",
  "KeyOperation",
  "MediaController",
  "MessagePort",
  "ModalWindow",
  "Notification",
  "SVGElementInstance",
  "Screen",
  "SharedWorker",
  "TextTrack",
  "TextTrackCue",
  "TextTrackList",
  "WebSocket",
  "WebSocketWorker",
  "Worker",
  "XMLHttpRequest",
  "XMLHttpRequestEventTarget",
  "XMLHttpRequestUpload"
], ux = "BrowserApiErrors", px = (e = {}) => {
  const t = {
    XMLHttpRequest: !0,
    eventTarget: !0,
    requestAnimationFrame: !0,
    setInterval: !0,
    setTimeout: !0,
    unregisterOriginalCallbacks: !1,
    ...e
  };
  return {
    name: ux,
    // TODO: This currently only works for the first client this is setup
    // We may want to adjust this to check for client etc.
    setupOnce() {
      t.setTimeout && In(ls, "setTimeout", R0), t.setInterval && In(ls, "setInterval", R0), t.requestAnimationFrame && In(ls, "requestAnimationFrame", mx), t.XMLHttpRequest && "XMLHttpRequest" in ls && In(XMLHttpRequest.prototype, "send", fx);
      const s = t.eventTarget;
      s && (Array.isArray(s) ? s : cx).forEach((r) => gx(r, t));
    }
  };
}, hx = px;
function R0(e) {
  return function(...t) {
    const s = t[0];
    return t[0] = Cd(s, {
      mechanism: {
        data: { function: Lo(e) },
        handled: !1,
        type: "instrument"
      }
    }), e.apply(this, t);
  };
}
function mx(e) {
  return function(t) {
    return e.apply(this, [
      Cd(t, {
        mechanism: {
          data: {
            function: "requestAnimationFrame",
            handler: Lo(e)
          },
          handled: !1,
          type: "instrument"
        }
      })
    ]);
  };
}
function fx(e) {
  return function(...t) {
    const s = this;
    return ["onload", "onerror", "onprogress", "onreadystatechange"].forEach((r) => {
      r in s && typeof s[r] == "function" && In(s, r, function(i) {
        const o = {
          mechanism: {
            data: {
              function: r,
              handler: Lo(i)
            },
            handled: !1,
            type: "instrument"
          }
        }, l = c1(i);
        return l && (o.mechanism.data.handler = Lo(l)), Cd(i, o);
      });
    }), e.apply(this, t);
  };
}
function gx(e, t) {
  var r, i;
  const n = (r = ls[e]) == null ? void 0 : r.prototype;
  (i = n == null ? void 0 : n.hasOwnProperty) != null && i.call(n, "addEventListener") && (In(n, "addEventListener", function(o) {
    return function(l, d, c) {
      try {
        vx(d) && (d.handleEvent = Cd(d.handleEvent, {
          mechanism: {
            data: {
              function: "handleEvent",
              handler: Lo(d),
              target: e
            },
            handled: !1,
            type: "instrument"
          }
        }));
      } catch {
      }
      return t.unregisterOriginalCallbacks && yx(this, l, d), o.apply(this, [
        l,
        Cd(d, {
          mechanism: {
            data: {
              function: "addEventListener",
              handler: Lo(d),
              target: e
            },
            handled: !1,
            type: "instrument"
          }
        }),
        c
      ]);
    };
  }), In(n, "removeEventListener", function(o) {
    return function(l, d, c) {
      try {
        const u = d.__sentry_wrapped__;
        u && o.call(this, l, u, c);
      } catch {
      }
      return o.call(this, l, d, c);
    };
  }));
}
function vx(e) {
  return typeof e.handleEvent == "function";
}
function yx(e, t, s) {
  e && typeof e == "object" && "removeEventListener" in e && typeof e.removeEventListener == "function" && e.removeEventListener(t, s);
}
const bx = () => ({
  name: "BrowserSession",
  setupOnce() {
    if (typeof ls.document > "u") {
      Es && ot.warn("Using the `browserSessionIntegration` in non-browser environments is not supported.");
      return;
    }
    GA({ ignoreDuration: !0 }), YA(), Qm(({ from: e, to: t }) => {
      e !== void 0 && e !== t && (GA({ ignoreDuration: !0 }), YA());
    });
  }
}), Ax = "GlobalHandlers", wx = (e = {}) => {
  const t = {
    onerror: !0,
    onunhandledrejection: !0,
    ...e
  };
  return {
    name: Ax,
    setupOnce() {
      Error.stackTraceLimit = 50;
    },
    setup(s) {
      t.onerror && (Sx(s), L0("onerror")), t.onunhandledrejection && (Px(s), L0("onunhandledrejection"));
    }
  };
}, Cx = wx;
function Sx(e) {
  CP((t) => {
    const { stackParser: s, attachStacktrace: n } = h8();
    if (ds() !== e || z3())
      return;
    const { msg: r, url: i, line: o, column: l, error: d } = t, c = Ix(
      E1(s, d || r, void 0, n, !1),
      i,
      o,
      l
    );
    c.level = "error", o3(c, {
      originalException: d,
      mechanism: {
        handled: !1,
        type: "onerror"
      }
    });
  });
}
function Px(e) {
  SP((t) => {
    const { stackParser: s, attachStacktrace: n } = h8();
    if (ds() !== e || z3())
      return;
    const r = kx(t), i = du(r) ? Ex(r) : E1(s, r, void 0, n, !0);
    i.level = "error", o3(i, {
      originalException: r,
      mechanism: {
        handled: !1,
        type: "onunhandledrejection"
      }
    });
  });
}
function kx(e) {
  if (du(e))
    return e;
  try {
    if ("reason" in e)
      return e.reason;
    if ("detail" in e && "reason" in e.detail)
      return e.detail.reason;
  } catch {
  }
  return e;
}
function Ex(e) {
  return {
    exception: {
      values: [
        {
          type: "UnhandledRejection",
          // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
          value: `Non-Error promise rejection captured with value: ${String(e)}`
        }
      ]
    }
  };
}
function Ix(e, t, s, n) {
  const r = e.exception = e.exception || {}, i = r.values = r.values || [], o = i[0] = i[0] || {}, l = o.stacktrace = o.stacktrace || {}, d = l.frames = l.frames || [], c = n, u = s, m = Eo(t) && t.length > 0 ? t : fl();
  return d.length === 0 && d.push({
    colno: c,
    filename: m,
    function: al,
    in_app: !0,
    lineno: u
  }), e;
}
function L0(e) {
  Es && ot.log(`Global Handler attached: ${e}`);
}
function h8() {
  const e = ds();
  return (e == null ? void 0 : e.getOptions()) || {
    stackParser: () => [],
    attachStacktrace: !1
  };
}
const Tx = () => ({
  name: "HttpContext",
  preprocessEvent(e) {
    var n;
    if (!ls.navigator && !ls.location && !ls.document)
      return;
    const t = S1(), s = {
      ...t.headers,
      ...(n = e.request) == null ? void 0 : n.headers
    };
    e.request = {
      ...t,
      ...e.request,
      headers: s
    };
  }
}), Ox = "cause", Rx = 5, Lx = "LinkedErrors", Bx = (e = {}) => {
  const t = e.limit || Rx, s = e.key || Ox;
  return {
    name: Lx,
    preprocessEvent(n, r, i) {
      const o = i.getOptions();
      mR(
        // This differs from the LinkedErrors integration in core by using a different exceptionFromError function
        P1,
        o.stackParser,
        s,
        t,
        n,
        r
      );
    }
  };
}, Mx = Bx;
function xx() {
  return Fx() ? (Es && Yo(() => {
    console.error(
      "[Sentry] You cannot use Sentry.init() in a browser extension, see: https://docs.sentry.io/platforms/javascript/best-practices/browser-extensions/"
    );
  }), !0) : !1;
}
function Fx() {
  var i;
  if (typeof ls.window > "u")
    return !1;
  const e = ls;
  if (e.nw)
    return !1;
  const t = e.chrome || e.browser;
  if (!((i = t == null ? void 0 : t.runtime) != null && i.id))
    return !1;
  const s = fl(), n = ["chrome-extension", "moz-extension", "ms-browser-extension", "safari-web-extension"];
  return !(ls === ls.top && n.some((o) => s.startsWith(`${o}://`)));
}
function m8(e) {
  return [
    // TODO(v10): Replace with `eventFiltersIntegration` once we remove the deprecated `inboundFiltersIntegration`
    // eslint-disable-next-line deprecation/deprecation
    oR(),
    sR(),
    hx(),
    sx(),
    Cx(),
    Mx(),
    SR(),
    Tx(),
    bx()
  ];
}
function Vx(e = {}) {
  const t = !e.skipBrowserExtensionCheck && xx(), s = {
    ...e,
    enabled: t ? !1 : e.enabled,
    stackParser: k9(e.stackParser || _M),
    integrations: I7({
      integrations: e.integrations,
      defaultIntegrations: e.defaultIntegrations == null ? m8() : e.defaultIntegrations
    }),
    transport: e.transport || HM
  };
  return N7(SB, s);
}
function Dx(e = {}) {
  const t = ls.document, s = (t == null ? void 0 : t.head) || (t == null ? void 0 : t.body);
  if (!s) {
    Es && ot.error("[showReportDialog] Global document not defined");
    return;
  }
  const n = Is(), r = ds(), i = r == null ? void 0 : r.getDsn();
  if (!i) {
    Es && ot.error("[showReportDialog] DSN not configured");
    return;
  }
  const o = {
    ...e,
    user: {
      ...n.getUser(),
      ...e.user
    },
    eventId: e.eventId || b7()
  }, l = ls.document.createElement("script");
  l.async = !0, l.crossOrigin = "anonymous", l.src = k7(i, o);
  const { onLoad: d, onClose: c } = o;
  if (d && (l.onload = d), c) {
    const u = (m) => {
      if (m.data === "__sentry_reportdialog_closed__")
        try {
          c();
        } finally {
          ls.removeEventListener("message", u);
        }
    };
    ls.addEventListener("message", u);
  }
  s.appendChild(l);
}
const ga = As, L1 = "sentryReplaySession", Nx = "replay_event", B1 = "Unable to send Replay", jx = 3e5, Hx = 9e5, Ux = 5e3, zx = 5500, Wx = 6e4, Gx = 5e3, Yx = 3, B0 = 15e4, fp = 5e3, Xx = 3e3, qx = 300, M1 = 2e7, Qx = 4999, Kx = 15e3, M0 = 36e5;
var Zx = Object.defineProperty, Jx = (e, t, s) => t in e ? Zx(e, t, { enumerable: !0, configurable: !0, writable: !0, value: s }) : e[t] = s, x0 = (e, t, s) => Jx(e, typeof t != "symbol" ? t + "" : t, s), Ka = /* @__PURE__ */ ((e) => (e[e.Document = 0] = "Document", e[e.DocumentType = 1] = "DocumentType", e[e.Element = 2] = "Element", e[e.Text = 3] = "Text", e[e.CDATA = 4] = "CDATA", e[e.Comment = 5] = "Comment", e))(Ka || {});
function $x(e) {
  return e.nodeType === e.ELEMENT_NODE;
}
function $c(e) {
  const t = e == null ? void 0 : e.host;
  return (t == null ? void 0 : t.shadowRoot) === e;
}
function _c(e) {
  return Object.prototype.toString.call(e) === "[object ShadowRoot]";
}
function _x(e) {
  return e.includes(" background-clip: text;") && !e.includes(" -webkit-background-clip: text;") && (e = e.replace(
    /\sbackground-clip:\s*text;/g,
    " -webkit-background-clip: text; background-clip: text;"
  )), e;
}
function eF(e) {
  const { cssText: t } = e;
  if (t.split('"').length < 3) return t;
  const s = ["@import", `url(${JSON.stringify(e.href)})`];
  return e.layerName === "" ? s.push("layer") : e.layerName && s.push(`layer(${e.layerName})`), e.supportsText && s.push(`supports(${e.supportsText})`), e.media.length && s.push(e.media.mediaText), s.join(" ") + ";";
}
function om(e) {
  try {
    const t = e.rules || e.cssRules;
    return t ? _x(
      Array.from(t, f8).join("")
    ) : null;
  } catch {
    return null;
  }
}
function tF(e) {
  let t = "";
  for (let s = 0; s < e.style.length; s++) {
    const n = e.style, r = n[s], i = n.getPropertyPriority(r);
    t += `${r}:${n.getPropertyValue(r)}${i ? " !important" : ""};`;
  }
  return `${e.selectorText} { ${t} }`;
}
function f8(e) {
  let t;
  if (aF(e))
    try {
      t = // for same-origin stylesheets,
      // we can access the imported stylesheet rules directly
      om(e.styleSheet) || // work around browser issues with the raw string `@import url(...)` statement
      eF(e);
    } catch {
    }
  else if (nF(e)) {
    let s = e.cssText;
    const n = e.selectorText.includes(":"), r = typeof e.style.all == "string" && e.style.all;
    if (r && (s = tF(e)), n && (s = sF(s)), n || r)
      return s;
  }
  return t || e.cssText;
}
function sF(e) {
  const t = /(\[(?:[\w-]+)[^\\])(:(?:[\w-]+)\])/gm;
  return e.replace(t, "$1\\$2");
}
function aF(e) {
  return "styleSheet" in e;
}
function nF(e) {
  return "selectorText" in e;
}
let g8 = class {
  constructor() {
    x0(this, "idNodeMap", /* @__PURE__ */ new Map()), x0(this, "nodeMetaMap", /* @__PURE__ */ new WeakMap());
  }
  getId(t) {
    var n;
    return t ? ((n = this.getMeta(t)) == null ? void 0 : n.id) ?? -1 : -1;
  }
  getNode(t) {
    return this.idNodeMap.get(t) || null;
  }
  getIds() {
    return Array.from(this.idNodeMap.keys());
  }
  getMeta(t) {
    return this.nodeMetaMap.get(t) || null;
  }
  // removes the node from idNodeMap
  // doesn't remove the node from nodeMetaMap
  removeNodeFromMap(t) {
    const s = this.getId(t);
    this.idNodeMap.delete(s), t.childNodes && t.childNodes.forEach(
      (n) => this.removeNodeFromMap(n)
    );
  }
  has(t) {
    return this.idNodeMap.has(t);
  }
  hasNode(t) {
    return this.nodeMetaMap.has(t);
  }
  add(t, s) {
    const n = s.id;
    this.idNodeMap.set(n, t), this.nodeMetaMap.set(t, s);
  }
  replace(t, s) {
    const n = this.getNode(t);
    if (n) {
      const r = this.nodeMetaMap.get(n);
      r && this.nodeMetaMap.set(s, r);
    }
    this.idNodeMap.set(t, s);
  }
  reset() {
    this.idNodeMap = /* @__PURE__ */ new Map(), this.nodeMetaMap = /* @__PURE__ */ new WeakMap();
  }
};
function rF() {
  return new g8();
}
function Km({
  maskInputOptions: e,
  tagName: t,
  type: s
}) {
  return t === "OPTION" && (t = "SELECT"), !!(e[t.toLowerCase()] || s && e[s] || s === "password" || // Default to "text" option for inputs without a "type" attribute defined
  t === "INPUT" && !s && e.text);
}
function hu({
  isMasked: e,
  element: t,
  value: s,
  maskInputFn: n
}) {
  let r = s || "";
  return e ? (n && (r = n(r, t)), "*".repeat(r.length)) : r;
}
function Pd(e) {
  return e.toLowerCase();
}
function Vv(e) {
  return e.toUpperCase();
}
const F0 = "__rrweb_original__";
function oF(e) {
  const t = e.getContext("2d");
  if (!t) return !0;
  const s = 50;
  for (let n = 0; n < e.width; n += s)
    for (let r = 0; r < e.height; r += s) {
      const i = t.getImageData, o = F0 in i ? i[F0] : i;
      if (new Uint32Array(
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-member-access
        o.call(
          t,
          n,
          r,
          Math.min(s, e.width - n),
          Math.min(s, e.height - r)
        ).data.buffer
      ).some((d) => d !== 0)) return !1;
    }
  return !0;
}
function x1(e) {
  const t = e.type;
  return e.hasAttribute("data-rr-is-password") ? "password" : t ? (
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
    Pd(t)
  ) : null;
}
function im(e, t, s) {
  return t === "INPUT" && (s === "radio" || s === "checkbox") ? e.getAttribute("value") || "" : e.value;
}
function v8(e, t) {
  let s;
  try {
    s = new URL(e, t ?? window.location.href);
  } catch {
    return null;
  }
  const n = /\.([0-9a-z]+)(?:$)/i, r = s.pathname.match(n);
  return (r == null ? void 0 : r[1]) ?? null;
}
const V0 = {};
function y8(e) {
  const t = V0[e];
  if (t)
    return t;
  const s = window.document;
  let n = window[e];
  if (s && typeof s.createElement == "function")
    try {
      const r = s.createElement("iframe");
      r.hidden = !0, s.head.appendChild(r);
      const i = r.contentWindow;
      i && i[e] && (n = // eslint-disable-next-line @typescript-eslint/unbound-method
      i[e]), s.head.removeChild(r);
    } catch {
    }
  return V0[e] = n.bind(
    window
  );
}
function Dv(...e) {
  return y8("setTimeout")(...e);
}
function b8(...e) {
  return y8("clearTimeout")(...e);
}
function A8(e) {
  try {
    return e.contentDocument;
  } catch {
  }
}
let iF = 1;
const lF = new RegExp("[^a-z0-9-_:]"), mu = -2;
function F1() {
  return iF++;
}
function dF(e) {
  if (e instanceof HTMLFormElement)
    return "form";
  const t = Pd(e.tagName);
  return lF.test(t) ? "div" : t;
}
function cF(e) {
  let t = "";
  return e.indexOf("//") > -1 ? t = e.split("/").slice(0, 3).join("/") : t = e.split("/")[0], t = t.split("?")[0], t;
}
let Ol, D0;
const uF = /url\((?:(')([^']*)'|(")(.*?)"|([^)]*))\)/gm, pF = /^(?:[a-z+]+:)?\/\//i, hF = /^www\..*/i, mF = /^(data:)([^,]*),(.*)/i;
function lm(e, t) {
  return (e || "").replace(
    uF,
    (s, n, r, i, o, l) => {
      const d = r || o || l, c = n || i || "";
      if (!d)
        return s;
      if (pF.test(d) || hF.test(d))
        return `url(${c}${d}${c})`;
      if (mF.test(d))
        return `url(${c}${d}${c})`;
      if (d[0] === "/")
        return `url(${c}${cF(t) + d}${c})`;
      const u = t.split("/"), m = d.split("/");
      u.pop();
      for (const f of m)
        f !== "." && (f === ".." ? u.pop() : u.push(f));
      return `url(${c}${u.join("/")}${c})`;
    }
  );
}
const fF = /^[^ \t\n\r\u000c]+/, gF = /^[, \t\n\r\u000c]+/;
function vF(e, t) {
  if (t.trim() === "")
    return t;
  let s = 0;
  function n(i) {
    let o;
    const l = i.exec(t.substring(s));
    return l ? (o = l[0], s += o.length, o) : "";
  }
  const r = [];
  for (; n(gF), !(s >= t.length); ) {
    let i = n(fF);
    if (i.slice(-1) === ",")
      i = Kl(e, i.substring(0, i.length - 1)), r.push(i);
    else {
      let o = "";
      i = Kl(e, i);
      let l = !1;
      for (; ; ) {
        const d = t.charAt(s);
        if (d === "") {
          r.push((i + o).trim());
          break;
        } else if (l)
          d === ")" && (l = !1);
        else if (d === ",") {
          s += 1, r.push((i + o).trim());
          break;
        } else d === "(" && (l = !0);
        o += d, s += 1;
      }
    }
  }
  return r.join(", ");
}
const N0 = /* @__PURE__ */ new WeakMap();
function Kl(e, t) {
  return !t || t.trim() === "" ? t : Zm(e, t);
}
function yF(e) {
  return !!(e.tagName === "svg" || e.ownerSVGElement);
}
function Zm(e, t) {
  let s = N0.get(e);
  if (s || (s = e.createElement("a"), N0.set(e, s)), !t)
    t = "";
  else if (t.startsWith("blob:") || t.startsWith("data:"))
    return t;
  return s.setAttribute("href", t), s.href;
}
function w8(e, t, s, n, r, i) {
  return n && (s === "src" || s === "href" && !(t === "use" && n[0] === "#") || s === "xlink:href" && n[0] !== "#" || s === "background" && (t === "table" || t === "td" || t === "th") ? Kl(e, n) : s === "srcset" ? vF(e, n) : s === "style" ? lm(n, Zm(e)) : t === "object" && s === "data" ? Kl(e, n) : typeof i == "function" ? i(s, n, r) : n);
}
function C8(e, t, s) {
  return (e === "video" || e === "audio") && t === "autoplay";
}
function S8(e, t, s, n) {
  try {
    if (n && e.matches(n))
      return !1;
    if (typeof t == "string") {
      if (e.classList.contains(t))
        return !0;
    } else
      for (let r = e.classList.length; r--; ) {
        const i = e.classList[r];
        if (t.test(i))
          return !0;
      }
    if (s)
      return e.matches(s);
  } catch {
  }
  return !1;
}
function bF(e, t) {
  for (let s = e.classList.length; s--; ) {
    const n = e.classList[s];
    if (t.test(n))
      return !0;
  }
  return !1;
}
function Yi(e, t, s = 1 / 0, n = 0) {
  return !e || e.nodeType !== e.ELEMENT_NODE || n > s ? -1 : t(e) ? n : Yi(e.parentNode, t, s, n + 1);
}
function Zl(e, t) {
  return (s) => {
    const n = s;
    if (n === null) return !1;
    try {
      if (e) {
        if (typeof e == "string") {
          if (n.matches(`.${e}`)) return !0;
        } else if (bF(n, e))
          return !0;
      }
      return !!(t && n.matches(t));
    } catch {
      return !1;
    }
  };
}
function kd(e, t, s, n, r, i) {
  try {
    const o = e.nodeType === e.ELEMENT_NODE ? e : e.parentElement;
    if (o === null) return !1;
    if (o.tagName === "INPUT") {
      const c = o.getAttribute("autocomplete");
      if ([
        "current-password",
        "new-password",
        "cc-number",
        "cc-exp",
        "cc-exp-month",
        "cc-exp-year",
        "cc-csc"
      ].includes(c))
        return !0;
    }
    let l = -1, d = -1;
    if (i) {
      if (d = Yi(
        o,
        Zl(n, r)
      ), d < 0)
        return !0;
      l = Yi(
        o,
        Zl(t, s),
        d >= 0 ? d : 1 / 0
      );
    } else {
      if (l = Yi(
        o,
        Zl(t, s)
      ), l < 0)
        return !1;
      d = Yi(
        o,
        Zl(n, r),
        l >= 0 ? l : 1 / 0
      );
    }
    return l >= 0 ? d >= 0 ? l <= d : !0 : d >= 0 ? !1 : !!i;
  } catch {
  }
  return !!i;
}
function AF(e, t, s) {
  const n = e.contentWindow;
  if (!n)
    return;
  let r = !1, i;
  try {
    i = n.document.readyState;
  } catch {
    return;
  }
  if (i !== "complete") {
    const l = Dv(() => {
      r || (t(), r = !0);
    }, s);
    e.addEventListener("load", () => {
      b8(l), r = !0, t();
    });
    return;
  }
  const o = "about:blank";
  if (n.location.href !== o || e.src === o || e.src === "")
    return Dv(t, 0), e.addEventListener("load", t);
  e.addEventListener("load", t);
}
function wF(e, t, s) {
  let n = !1, r;
  try {
    r = e.sheet;
  } catch {
    return;
  }
  if (r) return;
  const i = Dv(() => {
    n || (t(), n = !0);
  }, s);
  e.addEventListener("load", () => {
    b8(i), n = !0, t();
  });
}
function CF(e, t) {
  const {
    doc: s,
    mirror: n,
    blockClass: r,
    blockSelector: i,
    unblockSelector: o,
    maskAllText: l,
    maskAttributeFn: d,
    maskTextClass: c,
    unmaskTextClass: u,
    maskTextSelector: m,
    unmaskTextSelector: f,
    inlineStylesheet: v,
    maskInputOptions: b = {},
    maskTextFn: w,
    maskInputFn: S,
    dataURLOptions: I = {},
    inlineImages: T,
    recordCanvas: x,
    keepIframeSrcFn: k,
    newlyAddedElement: C = !1
  } = t, O = SF(s, n);
  switch (e.nodeType) {
    case e.DOCUMENT_NODE:
      return e.compatMode !== "CSS1Compat" ? {
        type: Ka.Document,
        childNodes: [],
        compatMode: e.compatMode
        // probably "BackCompat"
      } : {
        type: Ka.Document,
        childNodes: []
      };
    case e.DOCUMENT_TYPE_NODE:
      return {
        type: Ka.DocumentType,
        name: e.name,
        publicId: e.publicId,
        systemId: e.systemId,
        rootId: O
      };
    case e.ELEMENT_NODE:
      return kF(e, {
        doc: s,
        blockClass: r,
        blockSelector: i,
        unblockSelector: o,
        inlineStylesheet: v,
        maskAttributeFn: d,
        maskInputOptions: b,
        maskInputFn: S,
        dataURLOptions: I,
        inlineImages: T,
        recordCanvas: x,
        keepIframeSrcFn: k,
        newlyAddedElement: C,
        rootId: O,
        maskTextClass: c,
        unmaskTextClass: u,
        maskTextSelector: m,
        unmaskTextSelector: f
      });
    case e.TEXT_NODE:
      return PF(e, {
        doc: s,
        maskAllText: l,
        maskTextClass: c,
        unmaskTextClass: u,
        maskTextSelector: m,
        unmaskTextSelector: f,
        maskTextFn: w,
        maskInputOptions: b,
        maskInputFn: S,
        rootId: O
      });
    case e.CDATA_SECTION_NODE:
      return {
        type: Ka.CDATA,
        textContent: "",
        rootId: O
      };
    case e.COMMENT_NODE:
      return {
        type: Ka.Comment,
        textContent: e.textContent || "",
        rootId: O
      };
    default:
      return !1;
  }
}
function SF(e, t) {
  if (!t.hasNode(e)) return;
  const s = t.getId(e);
  return s === 1 ? void 0 : s;
}
function PF(e, t) {
  var I;
  const {
    maskAllText: s,
    maskTextClass: n,
    unmaskTextClass: r,
    maskTextSelector: i,
    unmaskTextSelector: o,
    maskTextFn: l,
    maskInputOptions: d,
    maskInputFn: c,
    rootId: u
  } = t, m = e.parentNode && e.parentNode.tagName;
  let f = e.textContent;
  const v = m === "STYLE" ? !0 : void 0, b = m === "SCRIPT" ? !0 : void 0, w = m === "TEXTAREA" ? !0 : void 0;
  if (v && f) {
    try {
      e.nextSibling || e.previousSibling || (I = e.parentNode.sheet) != null && I.cssRules && (f = om(
        e.parentNode.sheet
      ));
    } catch (T) {
      console.warn(
        `Cannot get CSS styles from text's parentNode. Error: ${T}`,
        e
      );
    }
    f = lm(f, Zm(t.doc));
  }
  b && (f = "SCRIPT_PLACEHOLDER");
  const S = kd(
    e,
    n,
    i,
    r,
    o,
    s
  );
  if (!v && !b && !w && f && S && (f = l ? l(f, e.parentElement) : f.replace(/[\S]/g, "*")), w && f && (d.textarea || S) && (f = c ? c(f, e.parentNode) : f.replace(/[\S]/g, "*")), m === "OPTION" && f) {
    const T = Km({
      type: null,
      tagName: m,
      maskInputOptions: d
    });
    f = hu({
      isMasked: kd(
        e,
        n,
        i,
        r,
        o,
        T
      ),
      element: e,
      value: f,
      maskInputFn: c
    });
  }
  return {
    type: Ka.Text,
    textContent: f || "",
    isStyle: v,
    rootId: u
  };
}
function kF(e, t) {
  const {
    doc: s,
    blockClass: n,
    blockSelector: r,
    unblockSelector: i,
    inlineStylesheet: o,
    maskInputOptions: l = {},
    maskAttributeFn: d,
    maskInputFn: c,
    dataURLOptions: u = {},
    inlineImages: m,
    recordCanvas: f,
    keepIframeSrcFn: v,
    newlyAddedElement: b = !1,
    rootId: w,
    maskTextClass: S,
    unmaskTextClass: I,
    maskTextSelector: T,
    unmaskTextSelector: x
  } = t, k = S8(
    e,
    n,
    r,
    i
  ), C = dF(e);
  let O = {};
  const E = e.attributes.length;
  for (let M = 0; M < E; M++) {
    const R = e.attributes[M];
    R.name && !C8(C, R.name, R.value) && (O[R.name] = w8(
      s,
      C,
      Pd(R.name),
      R.value,
      e,
      d
    ));
  }
  if (C === "link" && o) {
    const M = Array.from(s.styleSheets).find((F) => F.href === e.href);
    let R = null;
    M && (R = om(M)), R && (O.rel = null, O.href = null, O.crossorigin = null, O._cssText = lm(R, M.href));
  }
  if (C === "style" && e.sheet && // TODO: Currently we only try to get dynamic stylesheet when it is an empty style element
  !(e.innerText || e.textContent || "").trim().length) {
    const M = om(
      e.sheet
    );
    M && (O._cssText = lm(M, Zm(s)));
  }
  if (C === "input" || C === "textarea" || C === "select" || C === "option") {
    const M = e, R = x1(M), F = im(M, Vv(C), R), L = M.checked;
    if (R !== "submit" && R !== "button" && F) {
      const j = kd(
        M,
        S,
        T,
        I,
        x,
        Km({
          type: R,
          tagName: Vv(C),
          maskInputOptions: l
        })
      );
      O.value = hu({
        isMasked: j,
        element: M,
        value: F,
        maskInputFn: c
      });
    }
    L && (O.checked = L);
  }
  if (C === "option" && (e.selected && !l.select ? O.selected = !0 : delete O.selected), C === "canvas" && f) {
    if (e.__context === "2d")
      oF(e) || (O.rr_dataURL = e.toDataURL(
        u.type,
        u.quality
      ));
    else if (!("__context" in e)) {
      const M = e.toDataURL(
        u.type,
        u.quality
      ), R = s.createElement("canvas");
      R.width = e.width, R.height = e.height;
      const F = R.toDataURL(
        u.type,
        u.quality
      );
      M !== F && (O.rr_dataURL = M);
    }
  }
  if (C === "img" && m) {
    Ol || (Ol = s.createElement("canvas"), D0 = Ol.getContext("2d"));
    const M = e, R = M.currentSrc || M.getAttribute("src") || "<unknown-src>", F = M.crossOrigin, L = () => {
      M.removeEventListener("load", L);
      try {
        Ol.width = M.naturalWidth, Ol.height = M.naturalHeight, D0.drawImage(M, 0, 0), O.rr_dataURL = Ol.toDataURL(
          u.type,
          u.quality
        );
      } catch (j) {
        if (M.crossOrigin !== "anonymous") {
          M.crossOrigin = "anonymous", M.complete && M.naturalWidth !== 0 ? L() : M.addEventListener("load", L);
          return;
        } else
          console.warn(
            `Cannot inline img src=${R}! Error: ${j}`
          );
      }
      M.crossOrigin === "anonymous" && (F ? O.crossOrigin = F : M.removeAttribute("crossorigin"));
    };
    M.complete && M.naturalWidth !== 0 ? L() : M.addEventListener("load", L);
  }
  if ((C === "audio" || C === "video") && (O.rr_mediaState = e.paused ? "paused" : "played", O.rr_mediaCurrentTime = e.currentTime), b || (e.scrollLeft && (O.rr_scrollLeft = e.scrollLeft), e.scrollTop && (O.rr_scrollTop = e.scrollTop)), k) {
    const { width: M, height: R } = e.getBoundingClientRect();
    O = {
      class: O.class,
      rr_width: `${M}px`,
      rr_height: `${R}px`
    };
  }
  C === "iframe" && !v(O.src) && (!k && !A8(e) && (O.rr_src = O.src), delete O.src);
  let B;
  try {
    customElements.get(C) && (B = !0);
  } catch {
  }
  return {
    type: Ka.Element,
    tagName: C,
    attributes: O,
    childNodes: [],
    isSVG: yF(e) || void 0,
    needBlock: k,
    rootId: w,
    isCustom: B
  };
}
function fa(e) {
  return e == null ? "" : e.toLowerCase();
}
function EF(e, t) {
  if (t.comment && e.type === Ka.Comment)
    return !0;
  if (e.type === Ka.Element) {
    if (t.script && // script tag
    (e.tagName === "script" || // (module)preload link
    e.tagName === "link" && (e.attributes.rel === "preload" || e.attributes.rel === "modulepreload") || // prefetch link
    e.tagName === "link" && e.attributes.rel === "prefetch" && typeof e.attributes.href == "string" && v8(e.attributes.href) === "js"))
      return !0;
    if (t.headFavicon && (e.tagName === "link" && e.attributes.rel === "shortcut icon" || e.tagName === "meta" && (fa(e.attributes.name).match(
      /^msapplication-tile(image|color)$/
    ) || fa(e.attributes.name) === "application-name" || fa(e.attributes.rel) === "icon" || fa(e.attributes.rel) === "apple-touch-icon" || fa(e.attributes.rel) === "shortcut icon")))
      return !0;
    if (e.tagName === "meta") {
      if (t.headMetaDescKeywords && fa(e.attributes.name).match(/^description|keywords$/))
        return !0;
      if (t.headMetaSocial && (fa(e.attributes.property).match(/^(og|twitter|fb):/) || // og = opengraph (facebook)
      fa(e.attributes.name).match(/^(og|twitter):/) || fa(e.attributes.name) === "pinterest"))
        return !0;
      if (t.headMetaRobots && (fa(e.attributes.name) === "robots" || fa(e.attributes.name) === "googlebot" || fa(e.attributes.name) === "bingbot"))
        return !0;
      if (t.headMetaHttpEquiv && e.attributes["http-equiv"] !== void 0)
        return !0;
      if (t.headMetaAuthorship && (fa(e.attributes.name) === "author" || fa(e.attributes.name) === "generator" || fa(e.attributes.name) === "framework" || fa(e.attributes.name) === "publisher" || fa(e.attributes.name) === "progid" || fa(e.attributes.property).match(/^article:/) || fa(e.attributes.property).match(/^product:/)))
        return !0;
      if (t.headMetaVerification && (fa(e.attributes.name) === "google-site-verification" || fa(e.attributes.name) === "yandex-verification" || fa(e.attributes.name) === "csrf-token" || fa(e.attributes.name) === "p:domain_verify" || fa(e.attributes.name) === "verify-v1" || fa(e.attributes.name) === "verification" || fa(e.attributes.name) === "shopify-checkout-api-token"))
        return !0;
    }
  }
  return !1;
}
function Jl(e, t) {
  const {
    doc: s,
    mirror: n,
    blockClass: r,
    blockSelector: i,
    unblockSelector: o,
    maskAllText: l,
    maskTextClass: d,
    unmaskTextClass: c,
    maskTextSelector: u,
    unmaskTextSelector: m,
    skipChild: f = !1,
    inlineStylesheet: v = !0,
    maskInputOptions: b = {},
    maskAttributeFn: w,
    maskTextFn: S,
    maskInputFn: I,
    slimDOMOptions: T,
    dataURLOptions: x = {},
    inlineImages: k = !1,
    recordCanvas: C = !1,
    onSerialize: O,
    onIframeLoad: E,
    iframeLoadTimeout: B = 5e3,
    onStylesheetLoad: M,
    stylesheetLoadTimeout: R = 5e3,
    keepIframeSrcFn: F = () => !1,
    newlyAddedElement: L = !1
  } = t;
  let { preserveWhiteSpace: j = !0 } = t;
  const H = CF(e, {
    doc: s,
    mirror: n,
    blockClass: r,
    blockSelector: i,
    maskAllText: l,
    unblockSelector: o,
    maskTextClass: d,
    unmaskTextClass: c,
    maskTextSelector: u,
    unmaskTextSelector: m,
    inlineStylesheet: v,
    maskInputOptions: b,
    maskAttributeFn: w,
    maskTextFn: S,
    maskInputFn: I,
    dataURLOptions: x,
    inlineImages: k,
    recordCanvas: C,
    keepIframeSrcFn: F,
    newlyAddedElement: L
  });
  if (!H)
    return console.warn(e, "not serialized"), null;
  let te;
  n.hasNode(e) ? te = n.getId(e) : EF(H, T) || !j && H.type === Ka.Text && !H.isStyle && !H.textContent.replace(/^\s+|\s+$/gm, "").length ? te = mu : te = F1();
  const re = Object.assign(H, { id: te });
  if (n.add(e, re), te === mu)
    return null;
  O && O(e);
  let le = !f;
  if (re.type === Ka.Element) {
    le = le && !re.needBlock, delete re.needBlock;
    const ie = e.shadowRoot;
    ie && _c(ie) && (re.isShadowHost = !0);
  }
  if ((re.type === Ka.Document || re.type === Ka.Element) && le) {
    T.headWhitespace && re.type === Ka.Element && re.tagName === "head" && (j = !1);
    const ie = {
      doc: s,
      mirror: n,
      blockClass: r,
      blockSelector: i,
      maskAllText: l,
      unblockSelector: o,
      maskTextClass: d,
      unmaskTextClass: c,
      maskTextSelector: u,
      unmaskTextSelector: m,
      skipChild: f,
      inlineStylesheet: v,
      maskInputOptions: b,
      maskAttributeFn: w,
      maskTextFn: S,
      maskInputFn: I,
      slimDOMOptions: T,
      dataURLOptions: x,
      inlineImages: k,
      recordCanvas: C,
      preserveWhiteSpace: j,
      onSerialize: O,
      onIframeLoad: E,
      iframeLoadTimeout: B,
      onStylesheetLoad: M,
      stylesheetLoadTimeout: R,
      keepIframeSrcFn: F
    };
    for (const ye of Array.from(e.childNodes)) {
      const Y = Jl(ye, ie);
      Y && re.childNodes.push(Y);
    }
    if ($x(e) && e.shadowRoot)
      for (const ye of Array.from(e.shadowRoot.childNodes)) {
        const Y = Jl(ye, ie);
        Y && (_c(e.shadowRoot) && (Y.isShadow = !0), re.childNodes.push(Y));
      }
  }
  return e.parentNode && $c(e.parentNode) && _c(e.parentNode) && (re.isShadow = !0), re.type === Ka.Element && re.tagName === "iframe" && !S8(
    e,
    r,
    i,
    o
  ) && AF(
    e,
    () => {
      const ie = A8(e);
      if (ie && E) {
        const ye = Jl(ie, {
          doc: ie,
          mirror: n,
          blockClass: r,
          blockSelector: i,
          unblockSelector: o,
          maskAllText: l,
          maskTextClass: d,
          unmaskTextClass: c,
          maskTextSelector: u,
          unmaskTextSelector: m,
          skipChild: !1,
          inlineStylesheet: v,
          maskInputOptions: b,
          maskAttributeFn: w,
          maskTextFn: S,
          maskInputFn: I,
          slimDOMOptions: T,
          dataURLOptions: x,
          inlineImages: k,
          recordCanvas: C,
          preserveWhiteSpace: j,
          onSerialize: O,
          onIframeLoad: E,
          iframeLoadTimeout: B,
          onStylesheetLoad: M,
          stylesheetLoadTimeout: R,
          keepIframeSrcFn: F
        });
        ye && E(
          e,
          ye
        );
      }
    },
    B
  ), re.type === Ka.Element && re.tagName === "link" && typeof re.attributes.rel == "string" && (re.attributes.rel === "stylesheet" || re.attributes.rel === "preload" && typeof re.attributes.href == "string" && v8(re.attributes.href) === "css") && wF(
    e,
    () => {
      if (M) {
        const ie = Jl(e, {
          doc: s,
          mirror: n,
          blockClass: r,
          blockSelector: i,
          unblockSelector: o,
          maskAllText: l,
          maskTextClass: d,
          unmaskTextClass: c,
          maskTextSelector: u,
          unmaskTextSelector: m,
          skipChild: !1,
          inlineStylesheet: v,
          maskInputOptions: b,
          maskAttributeFn: w,
          maskTextFn: S,
          maskInputFn: I,
          slimDOMOptions: T,
          dataURLOptions: x,
          inlineImages: k,
          recordCanvas: C,
          preserveWhiteSpace: j,
          onSerialize: O,
          onIframeLoad: E,
          iframeLoadTimeout: B,
          onStylesheetLoad: M,
          stylesheetLoadTimeout: R,
          keepIframeSrcFn: F
        });
        ie && M(
          e,
          ie
        );
      }
    },
    R
  ), re;
}
function IF(e, t) {
  const {
    mirror: s = new g8(),
    blockClass: n = "rr-block",
    blockSelector: r = null,
    unblockSelector: i = null,
    maskAllText: o = !1,
    maskTextClass: l = "rr-mask",
    unmaskTextClass: d = null,
    maskTextSelector: c = null,
    unmaskTextSelector: u = null,
    inlineStylesheet: m = !0,
    inlineImages: f = !1,
    recordCanvas: v = !1,
    maskAllInputs: b = !1,
    maskAttributeFn: w,
    maskTextFn: S,
    maskInputFn: I,
    slimDOM: T = !1,
    dataURLOptions: x,
    preserveWhiteSpace: k,
    onSerialize: C,
    onIframeLoad: O,
    iframeLoadTimeout: E,
    onStylesheetLoad: B,
    stylesheetLoadTimeout: M,
    keepIframeSrcFn: R = () => !1
  } = t || {};
  return Jl(e, {
    doc: e,
    mirror: s,
    blockClass: n,
    blockSelector: r,
    unblockSelector: i,
    maskAllText: o,
    maskTextClass: l,
    unmaskTextClass: d,
    maskTextSelector: c,
    unmaskTextSelector: u,
    skipChild: !1,
    inlineStylesheet: m,
    maskInputOptions: b === !0 ? {
      color: !0,
      date: !0,
      "datetime-local": !0,
      email: !0,
      month: !0,
      number: !0,
      range: !0,
      search: !0,
      tel: !0,
      text: !0,
      time: !0,
      url: !0,
      week: !0,
      textarea: !0,
      select: !0
    } : b === !1 ? {} : b,
    maskAttributeFn: w,
    maskTextFn: S,
    maskInputFn: I,
    slimDOMOptions: T === !0 || T === "all" ? (
      // if true: set of sensible options that should not throw away any information
      {
        script: !0,
        comment: !0,
        headFavicon: !0,
        headWhitespace: !0,
        headMetaDescKeywords: T === "all",
        // destructive
        headMetaSocial: !0,
        headMetaRobots: !0,
        headMetaHttpEquiv: !0,
        headMetaAuthorship: !0,
        headMetaVerification: !0
      }
    ) : T === !1 ? {} : T,
    dataURLOptions: x,
    inlineImages: f,
    recordCanvas: v,
    preserveWhiteSpace: k,
    onSerialize: C,
    onIframeLoad: O,
    iframeLoadTimeout: E,
    onStylesheetLoad: B,
    stylesheetLoadTimeout: M,
    keepIframeSrcFn: R,
    newlyAddedElement: !1
  });
}
function hn(e, t, s = document) {
  const n = { capture: !0, passive: !0 };
  return s.addEventListener(e, t, n), () => s.removeEventListener(e, t, n);
}
const Hl = `Please stop import mirror directly. Instead of that,\r
now you can use replayer.getMirror() to access the mirror instance of a replayer,\r
or you can use record.mirror to access the mirror instance during recording.`;
let j0 = {
  map: {},
  getId() {
    return console.error(Hl), -1;
  },
  getNode() {
    return console.error(Hl), null;
  },
  removeNodeFromMap() {
    console.error(Hl);
  },
  has() {
    return console.error(Hl), !1;
  },
  reset() {
    console.error(Hl);
  }
};
typeof window < "u" && window.Proxy && window.Reflect && (j0 = new Proxy(j0, {
  get(e, t, s) {
    return t === "map" && console.error(Hl), Reflect.get(e, t, s);
  }
}));
function fu(e, t, s = {}) {
  let n = null, r = 0;
  return function(...i) {
    const o = Date.now();
    !r && s.leading === !1 && (r = o);
    const l = t - (o - r), d = this;
    l <= 0 || l > t ? (n && (xF(n), n = null), r = o, e.apply(d, i)) : !n && s.trailing !== !1 && (n = Jm(() => {
      r = s.leading === !1 ? 0 : Date.now(), n = null, e.apply(d, i);
    }, l));
  };
}
function P8(e, t, s, n, r = window) {
  const i = r.Object.getOwnPropertyDescriptor(e, t);
  return r.Object.defineProperty(
    e,
    t,
    n ? s : {
      set(o) {
        Jm(() => {
          s.set.call(this, o);
        }, 0), i && i.set && i.set.call(this, o);
      }
    }
  ), () => P8(e, t, i || {}, !0);
}
function V1(e, t, s) {
  try {
    if (!(t in e))
      return () => {
      };
    const n = e[t], r = s(n);
    return typeof r == "function" && (r.prototype = r.prototype || {}, Object.defineProperties(r, {
      __rrweb_original__: {
        enumerable: !1,
        value: n
      }
    })), e[t] = r, () => {
      e[t] = n;
    };
  } catch {
    return () => {
    };
  }
}
let dm = Date.now;
/* @__PURE__ */ /[1-9][0-9]{12}/.test(Date.now().toString()) || (dm = () => (/* @__PURE__ */ new Date()).getTime());
function k8(e) {
  var s, n, r, i, o, l;
  const t = e.document;
  return {
    left: t.scrollingElement ? t.scrollingElement.scrollLeft : e.pageXOffset !== void 0 ? e.pageXOffset : (t == null ? void 0 : t.documentElement.scrollLeft) || ((n = (s = t == null ? void 0 : t.body) == null ? void 0 : s.parentElement) == null ? void 0 : n.scrollLeft) || ((r = t == null ? void 0 : t.body) == null ? void 0 : r.scrollLeft) || 0,
    top: t.scrollingElement ? t.scrollingElement.scrollTop : e.pageYOffset !== void 0 ? e.pageYOffset : (t == null ? void 0 : t.documentElement.scrollTop) || ((o = (i = t == null ? void 0 : t.body) == null ? void 0 : i.parentElement) == null ? void 0 : o.scrollTop) || ((l = t == null ? void 0 : t.body) == null ? void 0 : l.scrollTop) || 0
  };
}
function E8() {
  return window.innerHeight || document.documentElement && document.documentElement.clientHeight || document.body && document.body.clientHeight;
}
function I8() {
  return window.innerWidth || document.documentElement && document.documentElement.clientWidth || document.body && document.body.clientWidth;
}
function T8(e) {
  if (!e)
    return null;
  try {
    return e.nodeType === e.ELEMENT_NODE ? e : e.parentElement;
  } catch {
    return null;
  }
}
function Dn(e, t, s, n, r) {
  if (!e)
    return !1;
  const i = T8(e);
  if (!i)
    return !1;
  const o = Zl(t, s);
  if (!r) {
    const c = n && i.matches(n);
    return o(i) && !c;
  }
  const l = Yi(i, o);
  let d = -1;
  return l < 0 ? !1 : (n && (d = Yi(
    i,
    Zl(null, n)
  )), l > -1 && d < 0 ? !0 : l < d);
}
function TF(e, t) {
  return t.getId(e) !== -1;
}
function $f(e, t) {
  return t.getId(e) === mu;
}
function O8(e, t) {
  if ($c(e))
    return !1;
  const s = t.getId(e);
  return t.has(s) ? e.parentNode && e.parentNode.nodeType === e.DOCUMENT_NODE ? !1 : e.parentNode ? O8(e.parentNode, t) : !0 : !0;
}
function Nv(e) {
  return !!e.changedTouches;
}
function OF(e = window) {
  "NodeList" in e && !e.NodeList.prototype.forEach && (e.NodeList.prototype.forEach = Array.prototype.forEach), "DOMTokenList" in e && !e.DOMTokenList.prototype.forEach && (e.DOMTokenList.prototype.forEach = Array.prototype.forEach), Node.prototype.contains || (Node.prototype.contains = (...t) => {
    let s = t[0];
    if (!(0 in t))
      throw new TypeError("1 argument is required");
    do
      if (this === s)
        return !0;
    while (s = s && s.parentNode);
    return !1;
  });
}
function R8(e, t) {
  return !!(e.nodeName === "IFRAME" && t.getMeta(e));
}
function L8(e, t) {
  return !!(e.nodeName === "LINK" && e.nodeType === e.ELEMENT_NODE && e.getAttribute && e.getAttribute("rel") === "stylesheet" && t.getMeta(e));
}
function jv(e) {
  return !!(e != null && e.shadowRoot);
}
class RF {
  constructor() {
    this.id = 1, this.styleIDMap = /* @__PURE__ */ new WeakMap(), this.idStyleMap = /* @__PURE__ */ new Map();
  }
  getId(t) {
    return this.styleIDMap.get(t) ?? -1;
  }
  has(t) {
    return this.styleIDMap.has(t);
  }
  /**
   * @returns If the stylesheet is in the mirror, returns the id of the stylesheet. If not, return the new assigned id.
   */
  add(t, s) {
    if (this.has(t)) return this.getId(t);
    let n;
    return s === void 0 ? n = this.id++ : n = s, this.styleIDMap.set(t, n), this.idStyleMap.set(n, t), n;
  }
  getStyle(t) {
    return this.idStyleMap.get(t) || null;
  }
  reset() {
    this.styleIDMap = /* @__PURE__ */ new WeakMap(), this.idStyleMap = /* @__PURE__ */ new Map(), this.id = 1;
  }
  generateId() {
    return this.id++;
  }
}
function B8(e) {
  var s, n;
  let t = null;
  return ((n = (s = e.getRootNode) == null ? void 0 : s.call(e)) == null ? void 0 : n.nodeType) === Node.DOCUMENT_FRAGMENT_NODE && e.getRootNode().host && (t = e.getRootNode().host), t;
}
function LF(e) {
  let t = e, s;
  for (; s = B8(t); )
    t = s;
  return t;
}
function BF(e) {
  const t = e.ownerDocument;
  if (!t) return !1;
  const s = LF(e);
  return t.contains(s);
}
function M8(e) {
  const t = e.ownerDocument;
  return t ? t.contains(e) || BF(e) : !1;
}
const H0 = {};
function D1(e) {
  const t = H0[e];
  if (t)
    return t;
  const s = window.document;
  let n = window[e];
  if (s && typeof s.createElement == "function")
    try {
      const r = s.createElement("iframe");
      r.hidden = !0, s.head.appendChild(r);
      const i = r.contentWindow;
      i && i[e] && (n = // eslint-disable-next-line @typescript-eslint/unbound-method
      i[e]), s.head.removeChild(r);
    } catch {
    }
  return H0[e] = n.bind(
    window
  );
}
function MF(...e) {
  return D1("requestAnimationFrame")(...e);
}
function Jm(...e) {
  return D1("setTimeout")(...e);
}
function xF(...e) {
  return D1("clearTimeout")(...e);
}
var ps = /* @__PURE__ */ ((e) => (e[e.DomContentLoaded = 0] = "DomContentLoaded", e[e.Load = 1] = "Load", e[e.FullSnapshot = 2] = "FullSnapshot", e[e.IncrementalSnapshot = 3] = "IncrementalSnapshot", e[e.Meta = 4] = "Meta", e[e.Custom = 5] = "Custom", e[e.Plugin = 6] = "Plugin", e))(ps || {}), ss = /* @__PURE__ */ ((e) => (e[e.Mutation = 0] = "Mutation", e[e.MouseMove = 1] = "MouseMove", e[e.MouseInteraction = 2] = "MouseInteraction", e[e.Scroll = 3] = "Scroll", e[e.ViewportResize = 4] = "ViewportResize", e[e.Input = 5] = "Input", e[e.TouchMove = 6] = "TouchMove", e[e.MediaInteraction = 7] = "MediaInteraction", e[e.StyleSheetRule = 8] = "StyleSheetRule", e[e.CanvasMutation = 9] = "CanvasMutation", e[e.Font = 10] = "Font", e[e.Log = 11] = "Log", e[e.Drag = 12] = "Drag", e[e.StyleDeclaration = 13] = "StyleDeclaration", e[e.Selection = 14] = "Selection", e[e.AdoptedStyleSheet = 15] = "AdoptedStyleSheet", e[e.CustomElement = 16] = "CustomElement", e))(ss || {}), dn = /* @__PURE__ */ ((e) => (e[e.MouseUp = 0] = "MouseUp", e[e.MouseDown = 1] = "MouseDown", e[e.Click = 2] = "Click", e[e.ContextMenu = 3] = "ContextMenu", e[e.DblClick = 4] = "DblClick", e[e.Focus = 5] = "Focus", e[e.Blur = 6] = "Blur", e[e.TouchStart = 7] = "TouchStart", e[e.TouchMove_Departed = 8] = "TouchMove_Departed", e[e.TouchEnd = 9] = "TouchEnd", e[e.TouchCancel = 10] = "TouchCancel", e))(dn || {}), ho = /* @__PURE__ */ ((e) => (e[e.Mouse = 0] = "Mouse", e[e.Pen = 1] = "Pen", e[e.Touch = 2] = "Touch", e))(ho || {}), Ul = /* @__PURE__ */ ((e) => (e[e.Play = 0] = "Play", e[e.Pause = 1] = "Pause", e[e.Seeked = 2] = "Seeked", e[e.VolumeChange = 3] = "VolumeChange", e[e.RateChange = 4] = "RateChange", e))(Ul || {});
function N1(e) {
  try {
    return e.contentDocument;
  } catch {
  }
}
function FF(e) {
  try {
    return e.contentWindow;
  } catch {
  }
}
function U0(e) {
  return "__ln" in e;
}
class VF {
  constructor() {
    this.length = 0, this.head = null, this.tail = null;
  }
  get(t) {
    if (t >= this.length)
      throw new Error("Position outside of list range");
    let s = this.head;
    for (let n = 0; n < t; n++)
      s = (s == null ? void 0 : s.next) || null;
    return s;
  }
  addNode(t) {
    const s = {
      value: t,
      previous: null,
      next: null
    };
    if (t.__ln = s, t.previousSibling && U0(t.previousSibling)) {
      const n = t.previousSibling.__ln.next;
      s.next = n, s.previous = t.previousSibling.__ln, t.previousSibling.__ln.next = s, n && (n.previous = s);
    } else if (t.nextSibling && U0(t.nextSibling) && t.nextSibling.__ln.previous) {
      const n = t.nextSibling.__ln.previous;
      s.previous = n, s.next = t.nextSibling.__ln, t.nextSibling.__ln.previous = s, n && (n.next = s);
    } else
      this.head && (this.head.previous = s), s.next = this.head, this.head = s;
    s.next === null && (this.tail = s), this.length++;
  }
  removeNode(t) {
    const s = t.__ln;
    this.head && (s.previous ? (s.previous.next = s.next, s.next ? s.next.previous = s.previous : this.tail = s.previous) : (this.head = s.next, this.head ? this.head.previous = null : this.tail = null), t.__ln && delete t.__ln, this.length--);
  }
}
const z0 = (e, t) => `${e}@${t}`;
class DF {
  constructor() {
    this.frozen = !1, this.locked = !1, this.texts = [], this.attributes = [], this.attributeMap = /* @__PURE__ */ new WeakMap(), this.removes = [], this.mapRemoves = [], this.movedMap = {}, this.addedSet = /* @__PURE__ */ new Set(), this.movedSet = /* @__PURE__ */ new Set(), this.droppedSet = /* @__PURE__ */ new Set(), this.processMutations = (t) => {
      t.forEach(this.processMutation), this.emit();
    }, this.emit = () => {
      if (this.frozen || this.locked)
        return;
      const t = [], s = /* @__PURE__ */ new Set(), n = new VF(), r = (d) => {
        let c = d, u = mu;
        for (; u === mu; )
          c = c && c.nextSibling, u = c && this.mirror.getId(c);
        return u;
      }, i = (d) => {
        if (!d.parentNode || !M8(d))
          return;
        const c = $c(d.parentNode) ? this.mirror.getId(B8(d)) : this.mirror.getId(d.parentNode), u = r(d);
        if (c === -1 || u === -1)
          return n.addNode(d);
        const m = Jl(d, {
          doc: this.doc,
          mirror: this.mirror,
          blockClass: this.blockClass,
          blockSelector: this.blockSelector,
          maskAllText: this.maskAllText,
          unblockSelector: this.unblockSelector,
          maskTextClass: this.maskTextClass,
          unmaskTextClass: this.unmaskTextClass,
          maskTextSelector: this.maskTextSelector,
          unmaskTextSelector: this.unmaskTextSelector,
          skipChild: !0,
          newlyAddedElement: !0,
          inlineStylesheet: this.inlineStylesheet,
          maskInputOptions: this.maskInputOptions,
          maskAttributeFn: this.maskAttributeFn,
          maskTextFn: this.maskTextFn,
          maskInputFn: this.maskInputFn,
          slimDOMOptions: this.slimDOMOptions,
          dataURLOptions: this.dataURLOptions,
          recordCanvas: this.recordCanvas,
          inlineImages: this.inlineImages,
          onSerialize: (f) => {
            R8(f, this.mirror) && !Dn(
              f,
              this.blockClass,
              this.blockSelector,
              this.unblockSelector,
              !1
            ) && this.iframeManager.addIframe(f), L8(f, this.mirror) && this.stylesheetManager.trackLinkElement(
              f
            ), jv(d) && this.shadowDomManager.addShadowRoot(d.shadowRoot, this.doc);
          },
          onIframeLoad: (f, v) => {
            Dn(
              f,
              this.blockClass,
              this.blockSelector,
              this.unblockSelector,
              !1
            ) || (this.iframeManager.attachIframe(f, v), f.contentWindow && this.canvasManager.addWindow(f.contentWindow), this.shadowDomManager.observeAttachShadow(f));
          },
          onStylesheetLoad: (f, v) => {
            this.stylesheetManager.attachLinkElement(f, v);
          }
        });
        m && (t.push({
          parentId: c,
          nextId: u,
          node: m
        }), s.add(m.id));
      };
      for (; this.mapRemoves.length; )
        this.mirror.removeNodeFromMap(this.mapRemoves.shift());
      for (const d of this.movedSet)
        W0(this.removes, d, this.mirror) && !this.movedSet.has(d.parentNode) || i(d);
      for (const d of this.addedSet)
        !G0(this.droppedSet, d) && !W0(this.removes, d, this.mirror) || G0(this.movedSet, d) ? i(d) : this.droppedSet.add(d);
      let o = null;
      for (; n.length; ) {
        let d = null;
        if (o) {
          const c = this.mirror.getId(o.value.parentNode), u = r(o.value);
          c !== -1 && u !== -1 && (d = o);
        }
        if (!d) {
          let c = n.tail;
          for (; c; ) {
            const u = c;
            if (c = c.previous, u) {
              const m = this.mirror.getId(u.value.parentNode);
              if (r(u.value) === -1) continue;
              if (m !== -1) {
                d = u;
                break;
              } else {
                const v = u.value;
                if (v.parentNode && v.parentNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
                  const b = v.parentNode.host;
                  if (this.mirror.getId(b) !== -1) {
                    d = u;
                    break;
                  }
                }
              }
            }
          }
        }
        if (!d) {
          for (; n.head; )
            n.removeNode(n.head.value);
          break;
        }
        o = d.previous, n.removeNode(d.value), i(d.value);
      }
      const l = {
        texts: this.texts.map((d) => ({
          id: this.mirror.getId(d.node),
          value: d.value
        })).filter((d) => !s.has(d.id)).filter((d) => this.mirror.has(d.id)),
        attributes: this.attributes.map((d) => {
          const { attributes: c } = d;
          if (typeof c.style == "string") {
            const u = JSON.stringify(d.styleDiff), m = JSON.stringify(d._unchangedStyles);
            u.length < c.style.length && (u + m).split("var(").length === c.style.split("var(").length && (c.style = d.styleDiff);
          }
          return {
            id: this.mirror.getId(d.node),
            attributes: c
          };
        }).filter((d) => !s.has(d.id)).filter((d) => this.mirror.has(d.id)),
        removes: this.removes,
        adds: t
      };
      !l.texts.length && !l.attributes.length && !l.removes.length && !l.adds.length || (this.texts = [], this.attributes = [], this.attributeMap = /* @__PURE__ */ new WeakMap(), this.removes = [], this.addedSet = /* @__PURE__ */ new Set(), this.movedSet = /* @__PURE__ */ new Set(), this.droppedSet = /* @__PURE__ */ new Set(), this.movedMap = {}, this.mutationCb(l));
    }, this.processMutation = (t) => {
      if (!$f(t.target, this.mirror))
        switch (t.type) {
          case "characterData": {
            const s = t.target.textContent;
            !Dn(
              t.target,
              this.blockClass,
              this.blockSelector,
              this.unblockSelector,
              !1
            ) && s !== t.oldValue && this.texts.push({
              value: kd(
                t.target,
                this.maskTextClass,
                this.maskTextSelector,
                this.unmaskTextClass,
                this.unmaskTextSelector,
                this.maskAllText
              ) && s ? this.maskTextFn ? this.maskTextFn(s, T8(t.target)) : s.replace(/[\S]/g, "*") : s,
              node: t.target
            });
            break;
          }
          case "attributes": {
            const s = t.target;
            let n = t.attributeName, r = t.target.getAttribute(n);
            if (n === "value") {
              const o = x1(s), l = s.tagName;
              r = im(s, l, o);
              const d = Km({
                maskInputOptions: this.maskInputOptions,
                tagName: l,
                type: o
              }), c = kd(
                t.target,
                this.maskTextClass,
                this.maskTextSelector,
                this.unmaskTextClass,
                this.unmaskTextSelector,
                d
              );
              r = hu({
                isMasked: c,
                element: s,
                value: r,
                maskInputFn: this.maskInputFn
              });
            }
            if (Dn(
              t.target,
              this.blockClass,
              this.blockSelector,
              this.unblockSelector,
              !1
            ) || r === t.oldValue)
              return;
            let i = this.attributeMap.get(t.target);
            if (s.tagName === "IFRAME" && n === "src" && !this.keepIframeSrcFn(r))
              if (!N1(
                s
              ))
                n = "rr_src";
              else
                return;
            if (i || (i = {
              node: t.target,
              attributes: {},
              styleDiff: {},
              _unchangedStyles: {}
            }, this.attributes.push(i), this.attributeMap.set(t.target, i)), n === "type" && s.tagName === "INPUT" && (t.oldValue || "").toLowerCase() === "password" && s.setAttribute("data-rr-is-password", "true"), !C8(s.tagName, n) && (i.attributes[n] = w8(
              this.doc,
              Pd(s.tagName),
              Pd(n),
              r,
              s,
              this.maskAttributeFn
            ), n === "style")) {
              if (!this.unattachedDoc)
                try {
                  this.unattachedDoc = document.implementation.createHTMLDocument();
                } catch {
                  this.unattachedDoc = this.doc;
                }
              const o = this.unattachedDoc.createElement("span");
              t.oldValue && o.setAttribute("style", t.oldValue);
              for (const l of Array.from(s.style)) {
                const d = s.style.getPropertyValue(l), c = s.style.getPropertyPriority(l);
                d !== o.style.getPropertyValue(l) || c !== o.style.getPropertyPriority(l) ? c === "" ? i.styleDiff[l] = d : i.styleDiff[l] = [d, c] : i._unchangedStyles[l] = [d, c];
              }
              for (const l of Array.from(o.style))
                s.style.getPropertyValue(l) === "" && (i.styleDiff[l] = !1);
            }
            break;
          }
          case "childList": {
            if (Dn(
              t.target,
              this.blockClass,
              this.blockSelector,
              this.unblockSelector,
              !0
            ))
              return;
            t.addedNodes.forEach((s) => this.genAdds(s, t.target)), t.removedNodes.forEach((s) => {
              const n = this.mirror.getId(s), r = $c(t.target) ? this.mirror.getId(t.target.host) : this.mirror.getId(t.target);
              Dn(
                t.target,
                this.blockClass,
                this.blockSelector,
                this.unblockSelector,
                !1
              ) || $f(s, this.mirror) || !TF(s, this.mirror) || (this.addedSet.has(s) ? (Hv(this.addedSet, s), this.droppedSet.add(s)) : this.addedSet.has(t.target) && n === -1 || O8(t.target, this.mirror) || (this.movedSet.has(s) && this.movedMap[z0(n, r)] ? Hv(this.movedSet, s) : this.removes.push({
                parentId: r,
                id: n,
                isShadow: $c(t.target) && _c(t.target) ? !0 : void 0
              })), this.mapRemoves.push(s));
            });
            break;
          }
        }
    }, this.genAdds = (t, s) => {
      if (!this.processedNodeManager.inOtherBuffer(t, this) && !(this.addedSet.has(t) || this.movedSet.has(t))) {
        if (this.mirror.hasNode(t)) {
          if ($f(t, this.mirror))
            return;
          this.movedSet.add(t);
          let n = null;
          s && this.mirror.hasNode(s) && (n = this.mirror.getId(s)), n && n !== -1 && (this.movedMap[z0(this.mirror.getId(t), n)] = !0);
        } else
          this.addedSet.add(t), this.droppedSet.delete(t);
        Dn(
          t,
          this.blockClass,
          this.blockSelector,
          this.unblockSelector,
          !1
        ) || (t.childNodes.forEach((n) => this.genAdds(n)), jv(t) && t.shadowRoot.childNodes.forEach((n) => {
          this.processedNodeManager.add(n, this), this.genAdds(n, t);
        }));
      }
    };
  }
  init(t) {
    [
      "mutationCb",
      "blockClass",
      "blockSelector",
      "unblockSelector",
      "maskAllText",
      "maskTextClass",
      "unmaskTextClass",
      "maskTextSelector",
      "unmaskTextSelector",
      "inlineStylesheet",
      "maskInputOptions",
      "maskAttributeFn",
      "maskTextFn",
      "maskInputFn",
      "keepIframeSrcFn",
      "recordCanvas",
      "inlineImages",
      "slimDOMOptions",
      "dataURLOptions",
      "doc",
      "mirror",
      "iframeManager",
      "stylesheetManager",
      "shadowDomManager",
      "canvasManager",
      "processedNodeManager"
    ].forEach((s) => {
      this[s] = t[s];
    });
  }
  freeze() {
    this.frozen = !0, this.canvasManager.freeze();
  }
  unfreeze() {
    this.frozen = !1, this.canvasManager.unfreeze(), this.emit();
  }
  isFrozen() {
    return this.frozen;
  }
  lock() {
    this.locked = !0, this.canvasManager.lock();
  }
  unlock() {
    this.locked = !1, this.canvasManager.unlock(), this.emit();
  }
  reset() {
    this.shadowDomManager.reset(), this.canvasManager.reset();
  }
}
function Hv(e, t) {
  e.delete(t), t.childNodes.forEach((s) => Hv(e, s));
}
function W0(e, t, s) {
  return e.length === 0 ? !1 : NF(e, t, s);
}
function NF(e, t, s) {
  let n = t.parentNode;
  for (; n; ) {
    const r = s.getId(n);
    if (e.some((i) => i.id === r))
      return !0;
    n = n.parentNode;
  }
  return !1;
}
function G0(e, t) {
  return e.size === 0 ? !1 : x8(e, t);
}
function x8(e, t) {
  const { parentNode: s } = t;
  return s ? e.has(s) ? !0 : x8(e, s) : !1;
}
let eu;
function jF(e) {
  eu = e;
}
function HF() {
  eu = void 0;
}
const Ls = (e) => eu ? (...s) => {
  try {
    return e(...s);
  } catch (n) {
    if (eu && eu(n) === !0)
      return () => {
      };
    throw n;
  }
} : e, $l = [];
function Wu(e) {
  try {
    if ("composedPath" in e) {
      const t = e.composedPath();
      if (t.length)
        return t[0];
    } else if ("path" in e && e.path.length)
      return e.path[0];
  } catch {
  }
  return e && e.target;
}
function F8(e, t) {
  var o, l;
  const s = new DF();
  $l.push(s), s.init(e);
  let n = window.MutationObserver || /**
  * Some websites may disable MutationObserver by removing it from the window object.
  * If someone is using rrweb to build a browser extention or things like it, they
  * could not change the website's code but can have an opportunity to inject some
  * code before the website executing its JS logic.
  * Then they can do this to store the native MutationObserver:
  * window.__rrMutationObserver = MutationObserver
  */
  window.__rrMutationObserver;
  const r = (l = (o = window == null ? void 0 : window.Zone) == null ? void 0 : o.__symbol__) == null ? void 0 : l.call(o, "MutationObserver");
  r && window[r] && (n = window[r]);
  const i = new n(
    Ls((d) => {
      e.onMutation && e.onMutation(d) === !1 || s.processMutations.bind(s)(d);
    })
  );
  return i.observe(t, {
    attributes: !0,
    attributeOldValue: !0,
    characterData: !0,
    characterDataOldValue: !0,
    childList: !0,
    subtree: !0
  }), i;
}
function UF({
  mousemoveCb: e,
  sampling: t,
  doc: s,
  mirror: n
}) {
  if (t.mousemove === !1)
    return () => {
    };
  const r = typeof t.mousemove == "number" ? t.mousemove : 50, i = typeof t.mousemoveCallback == "number" ? t.mousemoveCallback : 500;
  let o = [], l;
  const d = fu(
    Ls(
      (m) => {
        const f = Date.now() - l;
        e(
          o.map((v) => (v.timeOffset -= f, v)),
          m
        ), o = [], l = null;
      }
    ),
    i
  ), c = Ls(
    fu(
      Ls((m) => {
        const f = Wu(m), { clientX: v, clientY: b } = Nv(m) ? m.changedTouches[0] : m;
        l || (l = dm()), o.push({
          x: v,
          y: b,
          id: n.getId(f),
          timeOffset: dm() - l
        }), d(
          typeof DragEvent < "u" && m instanceof DragEvent ? ss.Drag : m instanceof MouseEvent ? ss.MouseMove : ss.TouchMove
        );
      }),
      r,
      {
        trailing: !1
      }
    )
  ), u = [
    hn("mousemove", c, s),
    hn("touchmove", c, s),
    hn("drag", c, s)
  ];
  return Ls(() => {
    u.forEach((m) => m());
  });
}
function zF({
  mouseInteractionCb: e,
  doc: t,
  mirror: s,
  blockClass: n,
  blockSelector: r,
  unblockSelector: i,
  sampling: o
}) {
  if (o.mouseInteraction === !1)
    return () => {
    };
  const l = o.mouseInteraction === !0 || o.mouseInteraction === void 0 ? {} : o.mouseInteraction, d = [];
  let c = null;
  const u = (m) => (f) => {
    const v = Wu(f);
    if (Dn(v, n, r, i, !0))
      return;
    let b = null, w = m;
    if ("pointerType" in f) {
      switch (f.pointerType) {
        case "mouse":
          b = ho.Mouse;
          break;
        case "touch":
          b = ho.Touch;
          break;
        case "pen":
          b = ho.Pen;
          break;
      }
      b === ho.Touch ? dn[m] === dn.MouseDown ? w = "TouchStart" : dn[m] === dn.MouseUp && (w = "TouchEnd") : ho.Pen;
    } else Nv(f) && (b = ho.Touch);
    b !== null ? (c = b, (w.startsWith("Touch") && b === ho.Touch || w.startsWith("Mouse") && b === ho.Mouse) && (b = null)) : dn[m] === dn.Click && (b = c, c = null);
    const S = Nv(f) ? f.changedTouches[0] : f;
    if (!S)
      return;
    const I = s.getId(v), { clientX: T, clientY: x } = S;
    Ls(e)({
      type: dn[w],
      id: I,
      x: T,
      y: x,
      ...b !== null && { pointerType: b }
    });
  };
  return Object.keys(dn).filter(
    (m) => Number.isNaN(Number(m)) && !m.endsWith("_Departed") && l[m] !== !1
  ).forEach((m) => {
    let f = Pd(m);
    const v = u(m);
    if (window.PointerEvent)
      switch (dn[m]) {
        case dn.MouseDown:
        case dn.MouseUp:
          f = f.replace(
            "mouse",
            "pointer"
          );
          break;
        case dn.TouchStart:
        case dn.TouchEnd:
          return;
      }
    d.push(hn(f, v, t));
  }), Ls(() => {
    d.forEach((m) => m());
  });
}
function V8({
  scrollCb: e,
  doc: t,
  mirror: s,
  blockClass: n,
  blockSelector: r,
  unblockSelector: i,
  sampling: o
}) {
  const l = Ls(
    fu(
      Ls((d) => {
        const c = Wu(d);
        if (!c || Dn(
          c,
          n,
          r,
          i,
          !0
        ))
          return;
        const u = s.getId(c);
        if (c === t && t.defaultView) {
          const m = k8(t.defaultView);
          e({
            id: u,
            x: m.left,
            y: m.top
          });
        } else
          e({
            id: u,
            x: c.scrollLeft,
            y: c.scrollTop
          });
      }),
      o.scroll || 100
    )
  );
  return hn("scroll", l, t);
}
function WF({ viewportResizeCb: e }, { win: t }) {
  let s = -1, n = -1;
  const r = Ls(
    fu(
      Ls(() => {
        const i = E8(), o = I8();
        (s !== i || n !== o) && (e({
          width: Number(o),
          height: Number(i)
        }), s = i, n = o);
      }),
      200
    )
  );
  return hn("resize", r, t);
}
const GF = ["INPUT", "TEXTAREA", "SELECT"], Y0 = /* @__PURE__ */ new WeakMap();
function YF({
  inputCb: e,
  doc: t,
  mirror: s,
  blockClass: n,
  blockSelector: r,
  unblockSelector: i,
  ignoreClass: o,
  ignoreSelector: l,
  maskInputOptions: d,
  maskInputFn: c,
  sampling: u,
  userTriggeredOnInput: m,
  maskTextClass: f,
  unmaskTextClass: v,
  maskTextSelector: b,
  unmaskTextSelector: w
}) {
  function S(E) {
    let B = Wu(E);
    const M = E.isTrusted, R = B && Vv(B.tagName);
    if (R === "OPTION" && (B = B.parentElement), !B || !R || GF.indexOf(R) < 0 || Dn(
      B,
      n,
      r,
      i,
      !0
    ))
      return;
    const F = B;
    if (F.classList.contains(o) || l && F.matches(l))
      return;
    const L = x1(B);
    let j = im(F, R, L), H = !1;
    const te = Km({
      maskInputOptions: d,
      tagName: R,
      type: L
    }), re = kd(
      B,
      f,
      b,
      v,
      w,
      te
    );
    (L === "radio" || L === "checkbox") && (H = B.checked), j = hu({
      isMasked: re,
      element: B,
      value: j,
      maskInputFn: c
    }), I(
      B,
      m ? { text: j, isChecked: H, userTriggered: M } : { text: j, isChecked: H }
    );
    const le = B.name;
    L === "radio" && le && H && t.querySelectorAll(`input[type="radio"][name="${le}"]`).forEach((ie) => {
      if (ie !== B) {
        const ye = hu({
          // share mask behavior of `target`
          isMasked: re,
          element: ie,
          value: im(ie, R, L),
          maskInputFn: c
        });
        I(
          ie,
          m ? { text: ye, isChecked: !H, userTriggered: !1 } : { text: ye, isChecked: !H }
        );
      }
    });
  }
  function I(E, B) {
    const M = Y0.get(E);
    if (!M || M.text !== B.text || M.isChecked !== B.isChecked) {
      Y0.set(E, B);
      const R = s.getId(E);
      Ls(e)({
        ...B,
        id: R
      });
    }
  }
  const x = (u.input === "last" ? ["change"] : ["input", "change"]).map(
    (E) => hn(E, Ls(S), t)
  ), k = t.defaultView;
  if (!k)
    return () => {
      x.forEach((E) => E());
    };
  const C = k.Object.getOwnPropertyDescriptor(
    k.HTMLInputElement.prototype,
    "value"
  ), O = [
    [k.HTMLInputElement.prototype, "value"],
    [k.HTMLInputElement.prototype, "checked"],
    [k.HTMLSelectElement.prototype, "value"],
    [k.HTMLTextAreaElement.prototype, "value"],
    // Some UI library use selectedIndex to set select value
    [k.HTMLSelectElement.prototype, "selectedIndex"],
    [k.HTMLOptionElement.prototype, "selected"]
  ];
  return C && C.set && x.push(
    ...O.map(
      (E) => P8(
        E[0],
        E[1],
        {
          set() {
            Ls(S)({
              target: this,
              isTrusted: !1
              // userTriggered to false as this could well be programmatic
            });
          }
        },
        !1,
        k
      )
    )
  ), Ls(() => {
    x.forEach((E) => E());
  });
}
function cm(e) {
  const t = [];
  function s(n, r) {
    if (gp("CSSGroupingRule") && n.parentRule instanceof CSSGroupingRule || gp("CSSMediaRule") && n.parentRule instanceof CSSMediaRule || gp("CSSSupportsRule") && n.parentRule instanceof CSSSupportsRule || gp("CSSConditionRule") && n.parentRule instanceof CSSConditionRule) {
      const o = Array.from(
        n.parentRule.cssRules
      ).indexOf(n);
      r.unshift(o);
    } else if (n.parentStyleSheet) {
      const o = Array.from(n.parentStyleSheet.cssRules).indexOf(n);
      r.unshift(o);
    }
    return r;
  }
  return s(e, t);
}
function ti(e, t, s) {
  let n, r;
  return e ? (e.ownerNode ? n = t.getId(e.ownerNode) : r = s.getId(e), {
    styleId: r,
    id: n
  }) : {};
}
function XF({ styleSheetRuleCb: e, mirror: t, stylesheetManager: s }, { win: n }) {
  if (!n.CSSStyleSheet || !n.CSSStyleSheet.prototype)
    return () => {
    };
  const r = n.CSSStyleSheet.prototype.insertRule;
  n.CSSStyleSheet.prototype.insertRule = new Proxy(r, {
    apply: Ls(
      (u, m, f) => {
        const [v, b] = f, { id: w, styleId: S } = ti(
          m,
          t,
          s.styleMirror
        );
        return (w && w !== -1 || S && S !== -1) && e({
          id: w,
          styleId: S,
          adds: [{ rule: v, index: b }]
        }), u.apply(m, f);
      }
    )
  });
  const i = n.CSSStyleSheet.prototype.deleteRule;
  n.CSSStyleSheet.prototype.deleteRule = new Proxy(i, {
    apply: Ls(
      (u, m, f) => {
        const [v] = f, { id: b, styleId: w } = ti(
          m,
          t,
          s.styleMirror
        );
        return (b && b !== -1 || w && w !== -1) && e({
          id: b,
          styleId: w,
          removes: [{ index: v }]
        }), u.apply(m, f);
      }
    )
  });
  let o;
  n.CSSStyleSheet.prototype.replace && (o = n.CSSStyleSheet.prototype.replace, n.CSSStyleSheet.prototype.replace = new Proxy(o, {
    apply: Ls(
      (u, m, f) => {
        const [v] = f, { id: b, styleId: w } = ti(
          m,
          t,
          s.styleMirror
        );
        return (b && b !== -1 || w && w !== -1) && e({
          id: b,
          styleId: w,
          replace: v
        }), u.apply(m, f);
      }
    )
  }));
  let l;
  n.CSSStyleSheet.prototype.replaceSync && (l = n.CSSStyleSheet.prototype.replaceSync, n.CSSStyleSheet.prototype.replaceSync = new Proxy(l, {
    apply: Ls(
      (u, m, f) => {
        const [v] = f, { id: b, styleId: w } = ti(
          m,
          t,
          s.styleMirror
        );
        return (b && b !== -1 || w && w !== -1) && e({
          id: b,
          styleId: w,
          replaceSync: v
        }), u.apply(m, f);
      }
    )
  }));
  const d = {};
  vp("CSSGroupingRule") ? d.CSSGroupingRule = n.CSSGroupingRule : (vp("CSSMediaRule") && (d.CSSMediaRule = n.CSSMediaRule), vp("CSSConditionRule") && (d.CSSConditionRule = n.CSSConditionRule), vp("CSSSupportsRule") && (d.CSSSupportsRule = n.CSSSupportsRule));
  const c = {};
  return Object.entries(d).forEach(([u, m]) => {
    c[u] = {
      // eslint-disable-next-line @typescript-eslint/unbound-method
      insertRule: m.prototype.insertRule,
      // eslint-disable-next-line @typescript-eslint/unbound-method
      deleteRule: m.prototype.deleteRule
    }, m.prototype.insertRule = new Proxy(
      c[u].insertRule,
      {
        apply: Ls(
          (f, v, b) => {
            const [w, S] = b, { id: I, styleId: T } = ti(
              v.parentStyleSheet,
              t,
              s.styleMirror
            );
            return (I && I !== -1 || T && T !== -1) && e({
              id: I,
              styleId: T,
              adds: [
                {
                  rule: w,
                  index: [
                    ...cm(v),
                    S || 0
                    // defaults to 0
                  ]
                }
              ]
            }), f.apply(v, b);
          }
        )
      }
    ), m.prototype.deleteRule = new Proxy(
      c[u].deleteRule,
      {
        apply: Ls(
          (f, v, b) => {
            const [w] = b, { id: S, styleId: I } = ti(
              v.parentStyleSheet,
              t,
              s.styleMirror
            );
            return (S && S !== -1 || I && I !== -1) && e({
              id: S,
              styleId: I,
              removes: [
                { index: [...cm(v), w] }
              ]
            }), f.apply(v, b);
          }
        )
      }
    );
  }), Ls(() => {
    n.CSSStyleSheet.prototype.insertRule = r, n.CSSStyleSheet.prototype.deleteRule = i, o && (n.CSSStyleSheet.prototype.replace = o), l && (n.CSSStyleSheet.prototype.replaceSync = l), Object.entries(d).forEach(([u, m]) => {
      m.prototype.insertRule = c[u].insertRule, m.prototype.deleteRule = c[u].deleteRule;
    });
  });
}
function D8({
  mirror: e,
  stylesheetManager: t
}, s) {
  var o, l, d;
  let n = null;
  s.nodeName === "#document" ? n = e.getId(s) : n = e.getId(s.host);
  const r = s.nodeName === "#document" ? (o = s.defaultView) == null ? void 0 : o.Document : (d = (l = s.ownerDocument) == null ? void 0 : l.defaultView) == null ? void 0 : d.ShadowRoot, i = r != null && r.prototype ? Object.getOwnPropertyDescriptor(
    r == null ? void 0 : r.prototype,
    "adoptedStyleSheets"
  ) : void 0;
  return n === null || n === -1 || !r || !i ? () => {
  } : (Object.defineProperty(s, "adoptedStyleSheets", {
    configurable: i.configurable,
    enumerable: i.enumerable,
    get() {
      var c;
      return (c = i.get) == null ? void 0 : c.call(this);
    },
    set(c) {
      var m;
      const u = (m = i.set) == null ? void 0 : m.call(this, c);
      if (n !== null && n !== -1)
        try {
          t.adoptStyleSheets(c, n);
        } catch {
        }
      return u;
    }
  }), Ls(() => {
    Object.defineProperty(s, "adoptedStyleSheets", {
      configurable: i.configurable,
      enumerable: i.enumerable,
      // eslint-disable-next-line @typescript-eslint/unbound-method
      get: i.get,
      // eslint-disable-next-line @typescript-eslint/unbound-method
      set: i.set
    });
  }));
}
function qF({
  styleDeclarationCb: e,
  mirror: t,
  ignoreCSSAttributes: s,
  stylesheetManager: n
}, { win: r }) {
  const i = r.CSSStyleDeclaration.prototype.setProperty;
  r.CSSStyleDeclaration.prototype.setProperty = new Proxy(i, {
    apply: Ls(
      (l, d, c) => {
        var w;
        const [u, m, f] = c;
        if (s.has(u))
          return i.apply(d, [u, m, f]);
        const { id: v, styleId: b } = ti(
          (w = d.parentRule) == null ? void 0 : w.parentStyleSheet,
          t,
          n.styleMirror
        );
        return (v && v !== -1 || b && b !== -1) && e({
          id: v,
          styleId: b,
          set: {
            property: u,
            value: m,
            priority: f
          },
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          index: cm(d.parentRule)
        }), l.apply(d, c);
      }
    )
  });
  const o = r.CSSStyleDeclaration.prototype.removeProperty;
  return r.CSSStyleDeclaration.prototype.removeProperty = new Proxy(o, {
    apply: Ls(
      (l, d, c) => {
        var v;
        const [u] = c;
        if (s.has(u))
          return o.apply(d, [u]);
        const { id: m, styleId: f } = ti(
          (v = d.parentRule) == null ? void 0 : v.parentStyleSheet,
          t,
          n.styleMirror
        );
        return (m && m !== -1 || f && f !== -1) && e({
          id: m,
          styleId: f,
          remove: {
            property: u
          },
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          index: cm(d.parentRule)
        }), l.apply(d, c);
      }
    )
  }), Ls(() => {
    r.CSSStyleDeclaration.prototype.setProperty = i, r.CSSStyleDeclaration.prototype.removeProperty = o;
  });
}
function QF({
  mediaInteractionCb: e,
  blockClass: t,
  blockSelector: s,
  unblockSelector: n,
  mirror: r,
  sampling: i,
  doc: o
}) {
  const l = Ls(
    (c) => fu(
      Ls((u) => {
        const m = Wu(u);
        if (!m || Dn(
          m,
          t,
          s,
          n,
          !0
        ))
          return;
        const { currentTime: f, volume: v, muted: b, playbackRate: w } = m;
        e({
          type: c,
          id: r.getId(m),
          currentTime: f,
          volume: v,
          muted: b,
          playbackRate: w
        });
      }),
      i.media || 500
    )
  ), d = [
    hn("play", l(Ul.Play), o),
    hn("pause", l(Ul.Pause), o),
    hn("seeked", l(Ul.Seeked), o),
    hn("volumechange", l(Ul.VolumeChange), o),
    hn("ratechange", l(Ul.RateChange), o)
  ];
  return Ls(() => {
    d.forEach((c) => c());
  });
}
function KF({ fontCb: e, doc: t }) {
  const s = t.defaultView;
  if (!s)
    return () => {
    };
  const n = [], r = /* @__PURE__ */ new WeakMap(), i = s.FontFace;
  s.FontFace = function(d, c, u) {
    const m = new i(d, c, u);
    return r.set(m, {
      family: d,
      buffer: typeof c != "string",
      descriptors: u,
      fontSource: typeof c == "string" ? c : JSON.stringify(Array.from(new Uint8Array(c)))
    }), m;
  };
  const o = V1(
    t.fonts,
    "add",
    function(l) {
      return function(d) {
        return Jm(
          Ls(() => {
            const c = r.get(d);
            c && (e(c), r.delete(d));
          }),
          0
        ), l.apply(this, [d]);
      };
    }
  );
  return n.push(() => {
    s.FontFace = i;
  }), n.push(o), Ls(() => {
    n.forEach((l) => l());
  });
}
function ZF(e) {
  const {
    doc: t,
    mirror: s,
    blockClass: n,
    blockSelector: r,
    unblockSelector: i,
    selectionCb: o
  } = e;
  let l = !0;
  const d = Ls(() => {
    const c = t.getSelection();
    if (!c || l && (c != null && c.isCollapsed)) return;
    l = c.isCollapsed || !1;
    const u = [], m = c.rangeCount || 0;
    for (let f = 0; f < m; f++) {
      const v = c.getRangeAt(f), { startContainer: b, startOffset: w, endContainer: S, endOffset: I } = v;
      Dn(
        b,
        n,
        r,
        i,
        !0
      ) || Dn(
        S,
        n,
        r,
        i,
        !0
      ) || u.push({
        start: s.getId(b),
        startOffset: w,
        end: s.getId(S),
        endOffset: I
      });
    }
    o({ ranges: u });
  });
  return d(), hn("selectionchange", d);
}
function JF({
  doc: e,
  customElementCb: t
}) {
  const s = e.defaultView;
  return !s || !s.customElements ? () => {
  } : V1(
    s.customElements,
    "define",
    function(r) {
      return function(i, o, l) {
        try {
          t({
            define: {
              name: i
            }
          });
        } catch {
        }
        return r.apply(this, [i, o, l]);
      };
    }
  );
}
function $F(e, t = {}) {
  const s = e.doc.defaultView;
  if (!s)
    return () => {
    };
  let n;
  e.recordDOM && (n = F8(e, e.doc));
  const r = UF(e), i = zF(e), o = V8(e), l = WF(e, {
    win: s
  }), d = YF(e), c = QF(e);
  let u = () => {
  }, m = () => {
  }, f = () => {
  }, v = () => {
  };
  e.recordDOM && (u = XF(e, { win: s }), m = D8(e, e.doc), f = qF(e, {
    win: s
  }), e.collectFonts && (v = KF(e)));
  const b = ZF(e), w = JF(e), S = [];
  for (const I of e.plugins)
    S.push(
      I.observer(I.callback, s, I.options)
    );
  return Ls(() => {
    $l.forEach((I) => I.reset()), n == null || n.disconnect(), r(), i(), o(), l(), d(), c(), u(), m(), f(), v(), b(), w(), S.forEach((I) => I());
  });
}
function gp(e) {
  return typeof window[e] < "u";
}
function vp(e) {
  return !!(typeof window[e] < "u" && // Note: Generally, this check _shouldn't_ be necessary
  // However, in some scenarios (e.g. jsdom) this can sometimes fail, so we check for it here
  window[e].prototype && "insertRule" in window[e].prototype && "deleteRule" in window[e].prototype);
}
class Uv {
  constructor(t) {
    this.generateIdFn = t, this.iframeIdToRemoteIdMap = /* @__PURE__ */ new WeakMap(), this.iframeRemoteIdToIdMap = /* @__PURE__ */ new WeakMap();
  }
  getId(t, s, n, r) {
    const i = n || this.getIdToRemoteIdMap(t), o = r || this.getRemoteIdToIdMap(t);
    let l = i.get(s);
    return l || (l = this.generateIdFn(), i.set(s, l), o.set(l, s)), l;
  }
  getIds(t, s) {
    const n = this.getIdToRemoteIdMap(t), r = this.getRemoteIdToIdMap(t);
    return s.map(
      (i) => this.getId(t, i, n, r)
    );
  }
  getRemoteId(t, s, n) {
    const r = n || this.getRemoteIdToIdMap(t);
    if (typeof s != "number") return s;
    const i = r.get(s);
    return i || -1;
  }
  getRemoteIds(t, s) {
    const n = this.getRemoteIdToIdMap(t);
    return s.map((r) => this.getRemoteId(t, r, n));
  }
  reset(t) {
    if (!t) {
      this.iframeIdToRemoteIdMap = /* @__PURE__ */ new WeakMap(), this.iframeRemoteIdToIdMap = /* @__PURE__ */ new WeakMap();
      return;
    }
    this.iframeIdToRemoteIdMap.delete(t), this.iframeRemoteIdToIdMap.delete(t);
  }
  getIdToRemoteIdMap(t) {
    let s = this.iframeIdToRemoteIdMap.get(t);
    return s || (s = /* @__PURE__ */ new Map(), this.iframeIdToRemoteIdMap.set(t, s)), s;
  }
  getRemoteIdToIdMap(t) {
    let s = this.iframeRemoteIdToIdMap.get(t);
    return s || (s = /* @__PURE__ */ new Map(), this.iframeRemoteIdToIdMap.set(t, s)), s;
  }
}
class _F {
  constructor() {
    this.crossOriginIframeMirror = new Uv(F1), this.crossOriginIframeRootIdMap = /* @__PURE__ */ new WeakMap();
  }
  addIframe() {
  }
  addLoadListener() {
  }
  attachIframe() {
  }
}
class eV {
  constructor(t) {
    this.iframes = /* @__PURE__ */ new WeakMap(), this.crossOriginIframeMap = /* @__PURE__ */ new WeakMap(), this.crossOriginIframeMirror = new Uv(F1), this.crossOriginIframeRootIdMap = /* @__PURE__ */ new WeakMap(), this.mutationCb = t.mutationCb, this.wrappedEmit = t.wrappedEmit, this.stylesheetManager = t.stylesheetManager, this.recordCrossOriginIframes = t.recordCrossOriginIframes, this.crossOriginIframeStyleMirror = new Uv(
      this.stylesheetManager.styleMirror.generateId.bind(
        this.stylesheetManager.styleMirror
      )
    ), this.mirror = t.mirror, this.recordCrossOriginIframes && window.addEventListener("message", this.handleMessage.bind(this));
  }
  addIframe(t) {
    this.iframes.set(t, !0), t.contentWindow && this.crossOriginIframeMap.set(t.contentWindow, t);
  }
  addLoadListener(t) {
    this.loadListener = t;
  }
  attachIframe(t, s) {
    var r, i;
    this.mutationCb({
      adds: [
        {
          parentId: this.mirror.getId(t),
          nextId: null,
          node: s
        }
      ],
      removes: [],
      texts: [],
      attributes: [],
      isAttachIframe: !0
    }), this.recordCrossOriginIframes && ((r = t.contentWindow) == null || r.addEventListener(
      "message",
      this.handleMessage.bind(this)
    )), (i = this.loadListener) == null || i.call(this, t);
    const n = N1(t);
    n && n.adoptedStyleSheets && n.adoptedStyleSheets.length > 0 && this.stylesheetManager.adoptStyleSheets(
      n.adoptedStyleSheets,
      this.mirror.getId(n)
    );
  }
  handleMessage(t) {
    const s = t;
    if (s.data.type !== "rrweb" || // To filter out the rrweb messages which are forwarded by some sites.
    s.origin !== s.data.origin || !t.source) return;
    const r = this.crossOriginIframeMap.get(t.source);
    if (!r) return;
    const i = this.transformCrossOriginEvent(
      r,
      s.data.event
    );
    i && this.wrappedEmit(
      i,
      s.data.isCheckout
    );
  }
  transformCrossOriginEvent(t, s) {
    var n;
    switch (s.type) {
      case ps.FullSnapshot: {
        this.crossOriginIframeMirror.reset(t), this.crossOriginIframeStyleMirror.reset(t), this.replaceIdOnNode(s.data.node, t);
        const r = s.data.node.id;
        return this.crossOriginIframeRootIdMap.set(t, r), this.patchRootIdOnNode(s.data.node, r), {
          timestamp: s.timestamp,
          type: ps.IncrementalSnapshot,
          data: {
            source: ss.Mutation,
            adds: [
              {
                parentId: this.mirror.getId(t),
                nextId: null,
                node: s.data.node
              }
            ],
            removes: [],
            texts: [],
            attributes: [],
            isAttachIframe: !0
          }
        };
      }
      case ps.Meta:
      case ps.Load:
      case ps.DomContentLoaded:
        return !1;
      case ps.Plugin:
        return s;
      case ps.Custom:
        return this.replaceIds(
          s.data.payload,
          t,
          ["id", "parentId", "previousId", "nextId"]
        ), s;
      case ps.IncrementalSnapshot:
        switch (s.data.source) {
          case ss.Mutation:
            return s.data.adds.forEach((r) => {
              this.replaceIds(r, t, [
                "parentId",
                "nextId",
                "previousId"
              ]), this.replaceIdOnNode(r.node, t);
              const i = this.crossOriginIframeRootIdMap.get(t);
              i && this.patchRootIdOnNode(r.node, i);
            }), s.data.removes.forEach((r) => {
              this.replaceIds(r, t, ["parentId", "id"]);
            }), s.data.attributes.forEach((r) => {
              this.replaceIds(r, t, ["id"]);
            }), s.data.texts.forEach((r) => {
              this.replaceIds(r, t, ["id"]);
            }), s;
          case ss.Drag:
          case ss.TouchMove:
          case ss.MouseMove:
            return s.data.positions.forEach((r) => {
              this.replaceIds(r, t, ["id"]);
            }), s;
          case ss.ViewportResize:
            return !1;
          case ss.MediaInteraction:
          case ss.MouseInteraction:
          case ss.Scroll:
          case ss.CanvasMutation:
          case ss.Input:
            return this.replaceIds(s.data, t, ["id"]), s;
          case ss.StyleSheetRule:
          case ss.StyleDeclaration:
            return this.replaceIds(s.data, t, ["id"]), this.replaceStyleIds(s.data, t, ["styleId"]), s;
          case ss.Font:
            return s;
          case ss.Selection:
            return s.data.ranges.forEach((r) => {
              this.replaceIds(r, t, ["start", "end"]);
            }), s;
          case ss.AdoptedStyleSheet:
            return this.replaceIds(s.data, t, ["id"]), this.replaceStyleIds(s.data, t, ["styleIds"]), (n = s.data.styles) == null || n.forEach((r) => {
              this.replaceStyleIds(r, t, ["styleId"]);
            }), s;
        }
    }
    return !1;
  }
  replace(t, s, n, r) {
    for (const i of r)
      !Array.isArray(s[i]) && typeof s[i] != "number" || (Array.isArray(s[i]) ? s[i] = t.getIds(
        n,
        s[i]
      ) : s[i] = t.getId(n, s[i]));
    return s;
  }
  replaceIds(t, s, n) {
    return this.replace(this.crossOriginIframeMirror, t, s, n);
  }
  replaceStyleIds(t, s, n) {
    return this.replace(this.crossOriginIframeStyleMirror, t, s, n);
  }
  replaceIdOnNode(t, s) {
    this.replaceIds(t, s, ["id", "rootId"]), "childNodes" in t && t.childNodes.forEach((n) => {
      this.replaceIdOnNode(n, s);
    });
  }
  patchRootIdOnNode(t, s) {
    t.type !== Ka.Document && !t.rootId && (t.rootId = s), "childNodes" in t && t.childNodes.forEach((n) => {
      this.patchRootIdOnNode(n, s);
    });
  }
}
class tV {
  init() {
  }
  addShadowRoot() {
  }
  observeAttachShadow() {
  }
  reset() {
  }
}
class sV {
  constructor(t) {
    this.shadowDoms = /* @__PURE__ */ new WeakSet(), this.restoreHandlers = [], this.mutationCb = t.mutationCb, this.scrollCb = t.scrollCb, this.bypassOptions = t.bypassOptions, this.mirror = t.mirror, this.init();
  }
  init() {
    this.reset(), this.patchAttachShadow(Element, document);
  }
  addShadowRoot(t, s) {
    if (!_c(t) || this.shadowDoms.has(t)) return;
    this.shadowDoms.add(t), this.bypassOptions.canvasManager.addShadowRoot(t);
    const n = F8(
      {
        ...this.bypassOptions,
        doc: s,
        mutationCb: this.mutationCb,
        mirror: this.mirror,
        shadowDomManager: this
      },
      t
    );
    this.restoreHandlers.push(() => n.disconnect()), this.restoreHandlers.push(
      V8({
        ...this.bypassOptions,
        scrollCb: this.scrollCb,
        // https://gist.github.com/praveenpuglia/0832da687ed5a5d7a0907046c9ef1813
        // scroll is not allowed to pass the boundary, so we need to listen the shadow document
        doc: t,
        mirror: this.mirror
      })
    ), Jm(() => {
      t.adoptedStyleSheets && t.adoptedStyleSheets.length > 0 && this.bypassOptions.stylesheetManager.adoptStyleSheets(
        t.adoptedStyleSheets,
        this.mirror.getId(t.host)
      ), this.restoreHandlers.push(
        D8(
          {
            mirror: this.mirror,
            stylesheetManager: this.bypassOptions.stylesheetManager
          },
          t
        )
      );
    }, 0);
  }
  /**
   * Monkey patch 'attachShadow' of an IFrameElement to observe newly added shadow doms.
   */
  observeAttachShadow(t) {
    const s = N1(t), n = FF(t);
    !s || !n || this.patchAttachShadow(
      n.Element,
      s
    );
  }
  /**
   * Patch 'attachShadow' to observe newly added shadow doms.
   */
  patchAttachShadow(t, s) {
    const n = this;
    this.restoreHandlers.push(
      V1(
        t.prototype,
        "attachShadow",
        function(r) {
          return function(i) {
            const o = r.call(this, i);
            return this.shadowRoot && M8(this) && n.addShadowRoot(this.shadowRoot, s), o;
          };
        }
      )
    );
  }
  reset() {
    this.restoreHandlers.forEach((t) => {
      try {
        t();
      } catch {
      }
    }), this.restoreHandlers = [], this.shadowDoms = /* @__PURE__ */ new WeakSet(), this.bypassOptions.canvasManager.resetShadowRoots();
  }
}
var X0 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", aV = typeof Uint8Array > "u" ? [] : new Uint8Array(256);
for (var yp = 0; yp < X0.length; yp++)
  aV[X0.charCodeAt(yp)] = yp;
class q0 {
  reset() {
  }
  freeze() {
  }
  unfreeze() {
  }
  lock() {
  }
  unlock() {
  }
  snapshot() {
  }
  addWindow() {
  }
  addShadowRoot() {
  }
  resetShadowRoots() {
  }
}
class nV {
  constructor(t) {
    this.trackedLinkElements = /* @__PURE__ */ new WeakSet(), this.styleMirror = new RF(), this.mutationCb = t.mutationCb, this.adoptedStyleSheetCb = t.adoptedStyleSheetCb;
  }
  attachLinkElement(t, s) {
    "_cssText" in s.attributes && this.mutationCb({
      adds: [],
      removes: [],
      texts: [],
      attributes: [
        {
          id: s.id,
          attributes: s.attributes
        }
      ]
    }), this.trackLinkElement(t);
  }
  trackLinkElement(t) {
    this.trackedLinkElements.has(t) || (this.trackedLinkElements.add(t), this.trackStylesheetInLinkElement(t));
  }
  adoptStyleSheets(t, s) {
    if (t.length === 0) return;
    const n = {
      id: s,
      styleIds: []
    }, r = [];
    for (const i of t) {
      let o;
      this.styleMirror.has(i) ? o = this.styleMirror.getId(i) : (o = this.styleMirror.add(i), r.push({
        styleId: o,
        rules: Array.from(i.rules || CSSRule, (l, d) => ({
          rule: f8(l),
          index: d
        }))
      })), n.styleIds.push(o);
    }
    r.length > 0 && (n.styles = r), this.adoptedStyleSheetCb(n);
  }
  reset() {
    this.styleMirror.reset(), this.trackedLinkElements = /* @__PURE__ */ new WeakSet();
  }
  // TODO: take snapshot on stylesheet reload by applying event listener
  trackStylesheetInLinkElement(t) {
  }
}
class rV {
  constructor() {
    this.nodeMap = /* @__PURE__ */ new WeakMap(), this.active = !1;
  }
  inOtherBuffer(t, s) {
    const n = this.nodeMap.get(t);
    return n && Array.from(n).some((r) => r !== s);
  }
  add(t, s) {
    this.active || (this.active = !0, MF(() => {
      this.nodeMap = /* @__PURE__ */ new WeakMap(), this.active = !1;
    })), this.nodeMap.set(t, (this.nodeMap.get(t) || /* @__PURE__ */ new Set()).add(s));
  }
  destroy() {
  }
}
let Ia, um;
var $S;
try {
  if (Array.from([1], (e) => e * 2)[0] !== 2) {
    const e = document.createElement("iframe");
    document.body.appendChild(e), Array.from = (($S = e.contentWindow) == null ? void 0 : $S.Array.from) || Array.from, document.body.removeChild(e);
  }
} catch (e) {
  console.debug("Unable to override Array.from", e);
}
const lr = rF();
function To(e = {}) {
  const {
    emit: t,
    checkoutEveryNms: s,
    checkoutEveryNth: n,
    blockClass: r = "rr-block",
    blockSelector: i = null,
    unblockSelector: o = null,
    ignoreClass: l = "rr-ignore",
    ignoreSelector: d = null,
    maskAllText: c = !1,
    maskTextClass: u = "rr-mask",
    unmaskTextClass: m = null,
    maskTextSelector: f = null,
    unmaskTextSelector: v = null,
    inlineStylesheet: b = !0,
    maskAllInputs: w,
    maskInputOptions: S,
    slimDOMOptions: I,
    maskAttributeFn: T,
    maskInputFn: x,
    maskTextFn: k,
    maxCanvasSize: C = null,
    packFn: O,
    sampling: E = {},
    dataURLOptions: B = {},
    mousemoveWait: M,
    recordDOM: R = !0,
    recordCanvas: F = !1,
    recordCrossOriginIframes: L = !1,
    recordAfter: j = e.recordAfter === "DOMContentLoaded" ? e.recordAfter : "load",
    userTriggeredOnInput: H = !1,
    collectFonts: te = !1,
    inlineImages: re = !1,
    plugins: le,
    keepIframeSrcFn: ie = () => !1,
    ignoreCSSAttributes: ye = /* @__PURE__ */ new Set([]),
    errorHandler: Y,
    onMutation: ae,
    getCanvasManager: ke
  } = e;
  jF(Y);
  const ue = L ? window.parent === window : !0;
  let oe = !1;
  if (!ue)
    try {
      window.parent.document && (oe = !1);
    } catch {
      oe = !0;
    }
  if (ue && !t)
    throw new Error("emit function is required");
  if (!ue && !oe)
    return () => {
    };
  M !== void 0 && E.mousemove === void 0 && (E.mousemove = M), lr.reset();
  const fe = w === !0 ? {
    color: !0,
    date: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0,
    textarea: !0,
    select: !0,
    radio: !0,
    checkbox: !0
  } : S !== void 0 ? S : {}, we = I === !0 || I === "all" ? {
    script: !0,
    comment: !0,
    headFavicon: !0,
    headWhitespace: !0,
    headMetaSocial: !0,
    headMetaRobots: !0,
    headMetaHttpEquiv: !0,
    headMetaVerification: !0,
    // the following are off for slimDOMOptions === true,
    // as they destroy some (hidden) info:
    headMetaAuthorship: I === "all",
    headMetaDescKeywords: I === "all"
  } : I || {};
  OF();
  let Ie, be = 0;
  const Oe = (gt) => {
    for (const Ge of le || [])
      Ge.eventProcessor && (gt = Ge.eventProcessor(gt));
    return O && // Disable packing events which will be emitted to parent frames.
    !oe && (gt = O(gt)), gt;
  };
  Ia = (gt, Ge) => {
    var Ce;
    const Ee = gt;
    if (Ee.timestamp = dm(), (Ce = $l[0]) != null && Ce.isFrozen() && Ee.type !== ps.FullSnapshot && !(Ee.type === ps.IncrementalSnapshot && Ee.data.source === ss.Mutation) && $l.forEach((xe) => xe.unfreeze()), ue)
      t == null || t(Oe(Ee), Ge);
    else if (oe) {
      const xe = {
        type: "rrweb",
        event: Oe(Ee),
        origin: window.location.origin,
        isCheckout: Ge
      };
      window.parent.postMessage(xe, "*");
    }
    if (Ee.type === ps.FullSnapshot)
      Ie = Ee, be = 0;
    else if (Ee.type === ps.IncrementalSnapshot) {
      if (Ee.data.source === ss.Mutation && Ee.data.isAttachIframe)
        return;
      be++;
      const xe = n && be >= n, Pe = s && Ie && Ee.timestamp - Ie.timestamp > s;
      (xe || Pe) && Ct(!0);
    }
  };
  const ze = (gt) => {
    Ia({
      type: ps.IncrementalSnapshot,
      data: {
        source: ss.Mutation,
        ...gt
      }
    });
  }, Re = (gt) => Ia({
    type: ps.IncrementalSnapshot,
    data: {
      source: ss.Scroll,
      ...gt
    }
  }), ge = (gt) => Ia({
    type: ps.IncrementalSnapshot,
    data: {
      source: ss.CanvasMutation,
      ...gt
    }
  }), he = (gt) => Ia({
    type: ps.IncrementalSnapshot,
    data: {
      source: ss.AdoptedStyleSheet,
      ...gt
    }
  }), Me = new nV({
    mutationCb: ze,
    adoptedStyleSheetCb: he
  }), Ne = typeof __RRWEB_EXCLUDE_IFRAME__ == "boolean" && __RRWEB_EXCLUDE_IFRAME__ ? new _F() : new eV({
    mirror: lr,
    mutationCb: ze,
    stylesheetManager: Me,
    recordCrossOriginIframes: L,
    wrappedEmit: Ia
  });
  for (const gt of le || [])
    gt.getMirror && gt.getMirror({
      nodeMirror: lr,
      crossOriginIframeMirror: Ne.crossOriginIframeMirror,
      crossOriginIframeStyleMirror: Ne.crossOriginIframeStyleMirror
    });
  const $e = new rV(), mt = iV(
    ke,
    {
      mirror: lr,
      win: window,
      mutationCb: (gt) => Ia({
        type: ps.IncrementalSnapshot,
        data: {
          source: ss.CanvasMutation,
          ...gt
        }
      }),
      recordCanvas: F,
      blockClass: r,
      blockSelector: i,
      unblockSelector: o,
      maxCanvasSize: C,
      sampling: E.canvas,
      dataURLOptions: B,
      errorHandler: Y
    }
  ), yt = typeof __RRWEB_EXCLUDE_SHADOW_DOM__ == "boolean" && __RRWEB_EXCLUDE_SHADOW_DOM__ ? new tV() : new sV({
    mutationCb: ze,
    scrollCb: Re,
    bypassOptions: {
      onMutation: ae,
      blockClass: r,
      blockSelector: i,
      unblockSelector: o,
      maskAllText: c,
      maskTextClass: u,
      unmaskTextClass: m,
      maskTextSelector: f,
      unmaskTextSelector: v,
      inlineStylesheet: b,
      maskInputOptions: fe,
      dataURLOptions: B,
      maskAttributeFn: T,
      maskTextFn: k,
      maskInputFn: x,
      recordCanvas: F,
      inlineImages: re,
      sampling: E,
      slimDOMOptions: we,
      iframeManager: Ne,
      stylesheetManager: Me,
      canvasManager: mt,
      keepIframeSrcFn: ie,
      processedNodeManager: $e
    },
    mirror: lr
  }), Ct = (gt = !1) => {
    if (!R)
      return;
    Ia(
      {
        type: ps.Meta,
        data: {
          href: window.location.href,
          width: I8(),
          height: E8()
        }
      },
      gt
    ), Me.reset(), yt.init(), $l.forEach((Ee) => Ee.lock());
    const Ge = IF(document, {
      mirror: lr,
      blockClass: r,
      blockSelector: i,
      unblockSelector: o,
      maskAllText: c,
      maskTextClass: u,
      unmaskTextClass: m,
      maskTextSelector: f,
      unmaskTextSelector: v,
      inlineStylesheet: b,
      maskAllInputs: fe,
      maskAttributeFn: T,
      maskInputFn: x,
      maskTextFn: k,
      slimDOM: we,
      dataURLOptions: B,
      recordCanvas: F,
      inlineImages: re,
      onSerialize: (Ee) => {
        R8(Ee, lr) && Ne.addIframe(Ee), L8(Ee, lr) && Me.trackLinkElement(Ee), jv(Ee) && yt.addShadowRoot(Ee.shadowRoot, document);
      },
      onIframeLoad: (Ee, Ce) => {
        Ne.attachIframe(Ee, Ce), Ee.contentWindow && mt.addWindow(Ee.contentWindow), yt.observeAttachShadow(Ee);
      },
      onStylesheetLoad: (Ee, Ce) => {
        Me.attachLinkElement(Ee, Ce);
      },
      keepIframeSrcFn: ie
    });
    if (!Ge)
      return console.warn("Failed to snapshot the document");
    Ia({
      type: ps.FullSnapshot,
      data: {
        node: Ge,
        initialOffset: k8(window)
      }
    }), $l.forEach((Ee) => Ee.unlock()), document.adoptedStyleSheets && document.adoptedStyleSheets.length > 0 && Me.adoptStyleSheets(
      document.adoptedStyleSheets,
      lr.getId(document)
    );
  };
  um = Ct;
  try {
    const gt = [], Ge = (Ce) => {
      var xe;
      return Ls($F)(
        {
          onMutation: ae,
          mutationCb: ze,
          mousemoveCb: (Pe, it) => Ia({
            type: ps.IncrementalSnapshot,
            data: {
              source: it,
              positions: Pe
            }
          }),
          mouseInteractionCb: (Pe) => Ia({
            type: ps.IncrementalSnapshot,
            data: {
              source: ss.MouseInteraction,
              ...Pe
            }
          }),
          scrollCb: Re,
          viewportResizeCb: (Pe) => Ia({
            type: ps.IncrementalSnapshot,
            data: {
              source: ss.ViewportResize,
              ...Pe
            }
          }),
          inputCb: (Pe) => Ia({
            type: ps.IncrementalSnapshot,
            data: {
              source: ss.Input,
              ...Pe
            }
          }),
          mediaInteractionCb: (Pe) => Ia({
            type: ps.IncrementalSnapshot,
            data: {
              source: ss.MediaInteraction,
              ...Pe
            }
          }),
          styleSheetRuleCb: (Pe) => Ia({
            type: ps.IncrementalSnapshot,
            data: {
              source: ss.StyleSheetRule,
              ...Pe
            }
          }),
          styleDeclarationCb: (Pe) => Ia({
            type: ps.IncrementalSnapshot,
            data: {
              source: ss.StyleDeclaration,
              ...Pe
            }
          }),
          canvasMutationCb: ge,
          fontCb: (Pe) => Ia({
            type: ps.IncrementalSnapshot,
            data: {
              source: ss.Font,
              ...Pe
            }
          }),
          selectionCb: (Pe) => {
            Ia({
              type: ps.IncrementalSnapshot,
              data: {
                source: ss.Selection,
                ...Pe
              }
            });
          },
          customElementCb: (Pe) => {
            Ia({
              type: ps.IncrementalSnapshot,
              data: {
                source: ss.CustomElement,
                ...Pe
              }
            });
          },
          blockClass: r,
          ignoreClass: l,
          ignoreSelector: d,
          maskAllText: c,
          maskTextClass: u,
          unmaskTextClass: m,
          maskTextSelector: f,
          unmaskTextSelector: v,
          maskInputOptions: fe,
          inlineStylesheet: b,
          sampling: E,
          recordDOM: R,
          recordCanvas: F,
          inlineImages: re,
          userTriggeredOnInput: H,
          collectFonts: te,
          doc: Ce,
          maskAttributeFn: T,
          maskInputFn: x,
          maskTextFn: k,
          keepIframeSrcFn: ie,
          blockSelector: i,
          unblockSelector: o,
          slimDOMOptions: we,
          dataURLOptions: B,
          mirror: lr,
          iframeManager: Ne,
          stylesheetManager: Me,
          shadowDomManager: yt,
          processedNodeManager: $e,
          canvasManager: mt,
          ignoreCSSAttributes: ye,
          plugins: ((xe = le == null ? void 0 : le.filter((Pe) => Pe.observer)) == null ? void 0 : xe.map((Pe) => ({
            observer: Pe.observer,
            options: Pe.options,
            callback: (it) => Ia({
              type: ps.Plugin,
              data: {
                plugin: Pe.name,
                payload: it
              }
            })
          }))) || []
        },
        {}
      );
    };
    Ne.addLoadListener((Ce) => {
      try {
        gt.push(Ge(Ce.contentDocument));
      } catch (xe) {
        console.warn(xe);
      }
    });
    const Ee = () => {
      Ct(), gt.push(Ge(document));
    };
    return document.readyState === "interactive" || document.readyState === "complete" ? Ee() : (gt.push(
      hn("DOMContentLoaded", () => {
        Ia({
          type: ps.DomContentLoaded,
          data: {}
        }), j === "DOMContentLoaded" && Ee();
      })
    ), gt.push(
      hn(
        "load",
        () => {
          Ia({
            type: ps.Load,
            data: {}
          }), j === "load" && Ee();
        },
        window
      )
    )), () => {
      gt.forEach((Ce) => Ce()), $e.destroy(), um = void 0, HF();
    };
  } catch (gt) {
    console.warn(gt);
  }
}
function oV(e) {
  if (!um)
    throw new Error("please take full snapshot after start recording");
  um(e);
}
To.mirror = lr;
To.takeFullSnapshot = oV;
function iV(e, t) {
  try {
    return e ? e(t) : new q0();
  } catch {
    return console.warn("Unable to initialize CanvasManager"), new q0();
  }
}
var Q0;
(function(e) {
  e[e.NotStarted = 0] = "NotStarted", e[e.Running = 1] = "Running", e[e.Stopped = 2] = "Stopped";
})(Q0 || (Q0 = {}));
const lV = 3, dV = 5;
function j1(e) {
  return e > 9999999999 ? e : e * 1e3;
}
function _f(e) {
  return e > 9999999999 ? e / 1e3 : e;
}
function Gu(e, t) {
  t.category !== "sentry.transaction" && (["ui.click", "ui.input"].includes(t.category) ? e.triggerUserActivity() : e.checkAndHandleExpiredSession(), e.addUpdate(() => (e.throttledAddEvent({
    type: ps.Custom,
    // TODO: We were converting from ms to seconds for breadcrumbs, spans,
    // but maybe we should just keep them as milliseconds
    timestamp: (t.timestamp || 0) * 1e3,
    data: {
      tag: "breadcrumb",
      // normalize to max. 10 depth and 1_000 properties per object
      payload: pr(t, 10, 1e3)
    }
  }), t.category === "console")));
}
const cV = "button,a";
function N8(e) {
  return e.closest(cV) || e;
}
function j8(e) {
  const t = H8(e);
  return !t || !(t instanceof Element) ? t : N8(t);
}
function H8(e) {
  return uV(e) ? e.target : e;
}
function uV(e) {
  return typeof e == "object" && !!e && "target" in e;
}
let si;
function pV(e) {
  return si || (si = [], hV()), si.push(e), () => {
    const t = si ? si.indexOf(e) : -1;
    t > -1 && si.splice(t, 1);
  };
}
function hV() {
  In(ga, "open", function(e) {
    return function(...t) {
      if (si)
        try {
          si.forEach((s) => s());
        } catch {
        }
      return e.apply(ga, t);
    };
  });
}
const mV = /* @__PURE__ */ new Set([
  ss.Mutation,
  ss.StyleSheetRule,
  ss.StyleDeclaration,
  ss.AdoptedStyleSheet,
  ss.CanvasMutation,
  ss.Selection,
  ss.MediaInteraction
]);
function fV(e, t, s) {
  e.handleClick(t, s);
}
class gV {
  // protected for testing
  constructor(t, s, n = Gu) {
    this._lastMutation = 0, this._lastScroll = 0, this._clicks = [], this._timeout = s.timeout / 1e3, this._threshold = s.threshold / 1e3, this._scrollTimeout = s.scrollTimeout / 1e3, this._replay = t, this._ignoreSelector = s.ignoreSelector, this._addBreadcrumbEvent = n;
  }
  /** Register click detection handlers on mutation or scroll. */
  addListeners() {
    const t = pV(() => {
      this._lastMutation = K0();
    });
    this._teardown = () => {
      t(), this._clicks = [], this._lastMutation = 0, this._lastScroll = 0;
    };
  }
  /** Clean up listeners. */
  removeListeners() {
    this._teardown && this._teardown(), this._checkClickTimeout && clearTimeout(this._checkClickTimeout);
  }
  /** @inheritDoc */
  handleClick(t, s) {
    if (yV(s, this._ignoreSelector) || !bV(t))
      return;
    const n = {
      timestamp: _f(t.timestamp),
      clickBreadcrumb: t,
      // Set this to 0 so we know it originates from the click breadcrumb
      clickCount: 0,
      node: s
    };
    this._clicks.some((r) => r.node === n.node && Math.abs(r.timestamp - n.timestamp) < 1) || (this._clicks.push(n), this._clicks.length === 1 && this._scheduleCheckClicks());
  }
  /** @inheritDoc */
  registerMutation(t = Date.now()) {
    this._lastMutation = _f(t);
  }
  /** @inheritDoc */
  registerScroll(t = Date.now()) {
    this._lastScroll = _f(t);
  }
  /** @inheritDoc */
  registerClick(t) {
    const s = N8(t);
    this._handleMultiClick(s);
  }
  /** Count multiple clicks on elements. */
  _handleMultiClick(t) {
    this._getClicks(t).forEach((s) => {
      s.clickCount++;
    });
  }
  /** Get all pending clicks for a given node. */
  _getClicks(t) {
    return this._clicks.filter((s) => s.node === t);
  }
  /** Check the clicks that happened. */
  _checkClicks() {
    const t = [], s = K0();
    this._clicks.forEach((n) => {
      !n.mutationAfter && this._lastMutation && (n.mutationAfter = n.timestamp <= this._lastMutation ? this._lastMutation - n.timestamp : void 0), !n.scrollAfter && this._lastScroll && (n.scrollAfter = n.timestamp <= this._lastScroll ? this._lastScroll - n.timestamp : void 0), n.timestamp + this._timeout <= s && t.push(n);
    });
    for (const n of t) {
      const r = this._clicks.indexOf(n);
      r > -1 && (this._generateBreadcrumbs(n), this._clicks.splice(r, 1));
    }
    this._clicks.length && this._scheduleCheckClicks();
  }
  /** Generate matching breadcrumb(s) for the click. */
  _generateBreadcrumbs(t) {
    const s = this._replay, n = t.scrollAfter && t.scrollAfter <= this._scrollTimeout, r = t.mutationAfter && t.mutationAfter <= this._threshold, i = !n && !r, { clickCount: o, clickBreadcrumb: l } = t;
    if (i) {
      const d = Math.min(t.mutationAfter || this._timeout, this._timeout) * 1e3, c = d < this._timeout * 1e3 ? "mutation" : "timeout", u = {
        type: "default",
        message: l.message,
        timestamp: l.timestamp,
        category: "ui.slowClickDetected",
        data: {
          ...l.data,
          url: ga.location.href,
          route: s.getCurrentRoute(),
          timeAfterClickMs: d,
          endReason: c,
          // If clickCount === 0, it means multiClick was not correctly captured here
          // - we still want to send 1 in this case
          clickCount: o || 1
        }
      };
      this._addBreadcrumbEvent(s, u);
      return;
    }
    if (o > 1) {
      const d = {
        type: "default",
        message: l.message,
        timestamp: l.timestamp,
        category: "ui.multiClick",
        data: {
          ...l.data,
          url: ga.location.href,
          route: s.getCurrentRoute(),
          clickCount: o,
          metric: !0
        }
      };
      this._addBreadcrumbEvent(s, d);
    }
  }
  /** Schedule to check current clicks. */
  _scheduleCheckClicks() {
    this._checkClickTimeout && clearTimeout(this._checkClickTimeout), this._checkClickTimeout = zu(() => this._checkClicks(), 1e3);
  }
}
const vV = ["A", "BUTTON", "INPUT"];
function yV(e, t) {
  return !!(!vV.includes(e.tagName) || e.tagName === "INPUT" && !["submit", "button"].includes(e.getAttribute("type") || "") || e.tagName === "A" && (e.hasAttribute("download") || e.hasAttribute("target") && e.getAttribute("target") !== "_self") || t && e.matches(t));
}
function bV(e) {
  return !!(e.data && typeof e.data.nodeId == "number" && e.timestamp);
}
function K0() {
  return Date.now() / 1e3;
}
function AV(e, t) {
  try {
    if (!wV(t))
      return;
    const { source: s } = t.data;
    if (mV.has(s) && e.registerMutation(t.timestamp), s === ss.Scroll && e.registerScroll(t.timestamp), CV(t)) {
      const { type: n, id: r } = t.data, i = To.mirror.getNode(r);
      i instanceof HTMLElement && n === dn.Click && e.registerClick(i);
    }
  } catch {
  }
}
function wV(e) {
  return e.type === lV;
}
function CV(e) {
  return e.data.source === ss.MouseInteraction;
}
function Nr(e) {
  return {
    timestamp: Date.now() / 1e3,
    type: "default",
    ...e
  };
}
var H1 = /* @__PURE__ */ ((e) => (e[e.Document = 0] = "Document", e[e.DocumentType = 1] = "DocumentType", e[e.Element = 2] = "Element", e[e.Text = 3] = "Text", e[e.CDATA = 4] = "CDATA", e[e.Comment = 5] = "Comment", e))(H1 || {});
const SV = /* @__PURE__ */ new Set([
  "id",
  "class",
  "aria-label",
  "role",
  "name",
  "alt",
  "title",
  "data-test-id",
  "data-testid",
  "disabled",
  "aria-disabled",
  "data-sentry-component"
]);
function PV(e) {
  const t = {};
  !e["data-sentry-component"] && e["data-sentry-element"] && (e["data-sentry-component"] = e["data-sentry-element"]);
  for (const s in e)
    if (SV.has(s)) {
      let n = s;
      (s === "data-testid" || s === "data-test-id") && (n = "testId"), t[n] = e[s];
    }
  return t;
}
const kV = (e) => (t) => {
  if (!e.isEnabled())
    return;
  const s = EV(t);
  if (!s)
    return;
  const n = t.name === "click", r = n ? t.event : void 0;
  n && e.clickDetector && (r != null && r.target) && !r.altKey && !r.metaKey && !r.ctrlKey && !r.shiftKey && fV(
    e.clickDetector,
    s,
    j8(t.event)
  ), Gu(e, s);
};
function U8(e, t) {
  const s = To.mirror.getId(e), n = s && To.mirror.getNode(s), r = n && To.mirror.getMeta(n), i = r && TV(r) ? r : null;
  return {
    message: t,
    data: i ? {
      nodeId: s,
      node: {
        id: s,
        tagName: i.tagName,
        textContent: Array.from(i.childNodes).map((o) => o.type === H1.Text && o.textContent).filter(Boolean).map((o) => o.trim()).join(""),
        attributes: PV(i.attributes)
      }
    } : {}
  };
}
function EV(e) {
  const { target: t, message: s } = IV(e);
  return Nr({
    category: `ui.${e.name}`,
    ...U8(t, s)
  });
}
function IV(e) {
  const t = e.name === "click";
  let s, n = null;
  try {
    n = t ? j8(e.event) : H8(e.event), s = or(n, { maxStringLength: 200 }) || "<unknown>";
  } catch {
    s = "<unknown>";
  }
  return { target: n, message: s };
}
function TV(e) {
  return e.type === H1.Element;
}
function OV(e, t) {
  if (!e.isEnabled())
    return;
  e.updateUserActivity();
  const s = RV(t);
  s && Gu(e, s);
}
function RV(e) {
  const { metaKey: t, shiftKey: s, ctrlKey: n, altKey: r, key: i, target: o } = e;
  if (!o || LV(o) || !i)
    return null;
  const l = t || n || r, d = i.length === 1;
  if (!l && d)
    return null;
  const c = or(o, { maxStringLength: 200 }) || "<unknown>", u = U8(o, c);
  return Nr({
    category: "ui.keyDown",
    message: c,
    data: {
      ...u.data,
      metaKey: t,
      shiftKey: s,
      ctrlKey: n,
      altKey: r,
      key: i
    }
  });
}
function LV(e) {
  return e.tagName === "INPUT" || e.tagName === "TEXTAREA" || e.isContentEditable;
}
const BV = {
  // @ts-expect-error TODO: entry type does not fit the create* functions entry type
  resource: DV,
  paint: FV,
  // @ts-expect-error TODO: entry type does not fit the create* functions entry type
  navigation: VV
};
function bp(e, t) {
  return ({ metric: s }) => void t.replayPerformanceEntries.push(e(s));
}
function MV(e) {
  return e.map(xV).filter(Boolean);
}
function xV(e) {
  const t = BV[e.entryType];
  return t ? t(e) : null;
}
function Ed(e) {
  return ((on() || ga.performance.timeOrigin) + e) / 1e3;
}
function FV(e) {
  const { duration: t, entryType: s, name: n, startTime: r } = e, i = Ed(r);
  return {
    type: s,
    name: n,
    start: i,
    end: i + t,
    data: void 0
  };
}
function VV(e) {
  const {
    entryType: t,
    name: s,
    decodedBodySize: n,
    duration: r,
    domComplete: i,
    encodedBodySize: o,
    domContentLoadedEventStart: l,
    domContentLoadedEventEnd: d,
    domInteractive: c,
    loadEventStart: u,
    loadEventEnd: m,
    redirectCount: f,
    startTime: v,
    transferSize: b,
    type: w
  } = e;
  return r === 0 ? null : {
    type: `${t}.${w}`,
    start: Ed(v),
    end: Ed(i),
    name: s,
    data: {
      size: b,
      decodedBodySize: n,
      encodedBodySize: o,
      duration: r,
      domInteractive: c,
      domContentLoadedEventStart: l,
      domContentLoadedEventEnd: d,
      loadEventStart: u,
      loadEventEnd: m,
      domComplete: i,
      redirectCount: f
    }
  };
}
function DV(e) {
  const {
    entryType: t,
    initiatorType: s,
    name: n,
    responseEnd: r,
    startTime: i,
    decodedBodySize: o,
    encodedBodySize: l,
    responseStatus: d,
    transferSize: c
  } = e;
  return ["fetch", "xmlhttprequest"].includes(s) ? null : {
    type: `${t}.${s}`,
    start: Ed(i),
    end: Ed(r),
    name: n,
    data: {
      size: c,
      statusCode: d,
      decodedBodySize: o,
      encodedBodySize: l
    }
  };
}
function NV(e) {
  const t = e.entries[e.entries.length - 1], s = t != null && t.element ? [t.element] : void 0;
  return $m(e, "largest-contentful-paint", s);
}
function jV(e) {
  return e.sources !== void 0;
}
function HV(e) {
  const t = [], s = [];
  for (const n of e.entries)
    if (jV(n)) {
      const r = [];
      for (const i of n.sources)
        if (i.node) {
          s.push(i.node);
          const o = To.mirror.getId(i.node);
          o && r.push(o);
        }
      t.push({ value: n.value, nodeIds: r.length ? r : void 0 });
    }
  return $m(e, "cumulative-layout-shift", s, t);
}
function UV(e) {
  const t = e.entries[e.entries.length - 1], s = t != null && t.target ? [t.target] : void 0;
  return $m(e, "first-input-delay", s);
}
function zV(e) {
  const t = e.entries[e.entries.length - 1], s = t != null && t.target ? [t.target] : void 0;
  return $m(e, "interaction-to-next-paint", s);
}
function $m(e, t, s, n) {
  const r = e.value, i = e.rating, o = Ed(r);
  return {
    type: "web-vital",
    name: t,
    start: o,
    end: o,
    data: {
      value: r,
      size: r,
      rating: i,
      nodeIds: s ? s.map((l) => To.mirror.getId(l)) : void 0,
      attributions: n
    }
  };
}
function WV(e) {
  function t(r) {
    e.performanceEntries.includes(r) || e.performanceEntries.push(r);
  }
  function s({ entries: r }) {
    r.forEach(t);
  }
  const n = [];
  return ["navigation", "paint", "resource"].forEach((r) => {
    n.push(rl(r, s));
  }), n.push(
    O1(bp(NV, e)),
    T1(bp(HV, e)),
    _3(bp(UV, e)),
    e8(bp(zV, e))
  ), () => {
    n.forEach((r) => r());
  };
}
const Jt = typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__, GV = 'var t=Uint8Array,n=Uint16Array,r=Int32Array,e=new t([0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0,0,0,0]),i=new t([0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13,0,0]),s=new t([16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15]),a=function(t,e){for(var i=new n(31),s=0;s<31;++s)i[s]=e+=1<<t[s-1];var a=new r(i[30]);for(s=1;s<30;++s)for(var o=i[s];o<i[s+1];++o)a[o]=o-i[s]<<5|s;return{b:i,r:a}},o=a(e,2),h=o.b,f=o.r;h[28]=258,f[258]=28;for(var l=a(i,0).r,u=new n(32768),c=0;c<32768;++c){var v=(43690&c)>>1|(21845&c)<<1;v=(61680&(v=(52428&v)>>2|(13107&v)<<2))>>4|(3855&v)<<4,u[c]=((65280&v)>>8|(255&v)<<8)>>1}var d=function(t,r,e){for(var i=t.length,s=0,a=new n(r);s<i;++s)t[s]&&++a[t[s]-1];var o,h=new n(r);for(s=1;s<r;++s)h[s]=h[s-1]+a[s-1]<<1;if(e){o=new n(1<<r);var f=15-r;for(s=0;s<i;++s)if(t[s])for(var l=s<<4|t[s],c=r-t[s],v=h[t[s]-1]++<<c,d=v|(1<<c)-1;v<=d;++v)o[u[v]>>f]=l}else for(o=new n(i),s=0;s<i;++s)t[s]&&(o[s]=u[h[t[s]-1]++]>>15-t[s]);return o},p=new t(288);for(c=0;c<144;++c)p[c]=8;for(c=144;c<256;++c)p[c]=9;for(c=256;c<280;++c)p[c]=7;for(c=280;c<288;++c)p[c]=8;var g=new t(32);for(c=0;c<32;++c)g[c]=5;var w=d(p,9,0),y=d(g,5,0),m=function(t){return(t+7)/8|0},b=function(n,r,e){return(null==e||e>n.length)&&(e=n.length),new t(n.subarray(r,e))},M=["unexpected EOF","invalid block type","invalid length/literal","invalid distance","stream finished","no stream handler",,"no callback","invalid UTF-8 data","extra field too long","date not in range 1980-2099","filename too long","stream finishing","invalid zip data"],E=function(t,n,r){var e=new Error(n||M[t]);if(e.code=t,Error.captureStackTrace&&Error.captureStackTrace(e,E),!r)throw e;return e},z=function(t,n,r){r<<=7&n;var e=n/8|0;t[e]|=r,t[e+1]|=r>>8},_=function(t,n,r){r<<=7&n;var e=n/8|0;t[e]|=r,t[e+1]|=r>>8,t[e+2]|=r>>16},x=function(r,e){for(var i=[],s=0;s<r.length;++s)r[s]&&i.push({s:s,f:r[s]});var a=i.length,o=i.slice();if(!a)return{t:F,l:0};if(1==a){var h=new t(i[0].s+1);return h[i[0].s]=1,{t:h,l:1}}i.sort(function(t,n){return t.f-n.f}),i.push({s:-1,f:25001});var f=i[0],l=i[1],u=0,c=1,v=2;for(i[0]={s:-1,f:f.f+l.f,l:f,r:l};c!=a-1;)f=i[i[u].f<i[v].f?u++:v++],l=i[u!=c&&i[u].f<i[v].f?u++:v++],i[c++]={s:-1,f:f.f+l.f,l:f,r:l};var d=o[0].s;for(s=1;s<a;++s)o[s].s>d&&(d=o[s].s);var p=new n(d+1),g=A(i[c-1],p,0);if(g>e){s=0;var w=0,y=g-e,m=1<<y;for(o.sort(function(t,n){return p[n.s]-p[t.s]||t.f-n.f});s<a;++s){var b=o[s].s;if(!(p[b]>e))break;w+=m-(1<<g-p[b]),p[b]=e}for(w>>=y;w>0;){var M=o[s].s;p[M]<e?w-=1<<e-p[M]++-1:++s}for(;s>=0&&w;--s){var E=o[s].s;p[E]==e&&(--p[E],++w)}g=e}return{t:new t(p),l:g}},A=function(t,n,r){return-1==t.s?Math.max(A(t.l,n,r+1),A(t.r,n,r+1)):n[t.s]=r},D=function(t){for(var r=t.length;r&&!t[--r];);for(var e=new n(++r),i=0,s=t[0],a=1,o=function(t){e[i++]=t},h=1;h<=r;++h)if(t[h]==s&&h!=r)++a;else{if(!s&&a>2){for(;a>138;a-=138)o(32754);a>2&&(o(a>10?a-11<<5|28690:a-3<<5|12305),a=0)}else if(a>3){for(o(s),--a;a>6;a-=6)o(8304);a>2&&(o(a-3<<5|8208),a=0)}for(;a--;)o(s);a=1,s=t[h]}return{c:e.subarray(0,i),n:r}},T=function(t,n){for(var r=0,e=0;e<n.length;++e)r+=t[e]*n[e];return r},k=function(t,n,r){var e=r.length,i=m(n+2);t[i]=255&e,t[i+1]=e>>8,t[i+2]=255^t[i],t[i+3]=255^t[i+1];for(var s=0;s<e;++s)t[i+s+4]=r[s];return 8*(i+4+e)},U=function(t,r,a,o,h,f,l,u,c,v,m){z(r,m++,a),++h[256];for(var b=x(h,15),M=b.t,E=b.l,A=x(f,15),U=A.t,C=A.l,F=D(M),I=F.c,S=F.n,L=D(U),O=L.c,j=L.n,q=new n(19),B=0;B<I.length;++B)++q[31&I[B]];for(B=0;B<O.length;++B)++q[31&O[B]];for(var G=x(q,7),H=G.t,J=G.l,K=19;K>4&&!H[s[K-1]];--K);var N,P,Q,R,V=v+5<<3,W=T(h,p)+T(f,g)+l,X=T(h,M)+T(f,U)+l+14+3*K+T(q,H)+2*q[16]+3*q[17]+7*q[18];if(c>=0&&V<=W&&V<=X)return k(r,m,t.subarray(c,c+v));if(z(r,m,1+(X<W)),m+=2,X<W){N=d(M,E,0),P=M,Q=d(U,C,0),R=U;var Y=d(H,J,0);z(r,m,S-257),z(r,m+5,j-1),z(r,m+10,K-4),m+=14;for(B=0;B<K;++B)z(r,m+3*B,H[s[B]]);m+=3*K;for(var Z=[I,O],$=0;$<2;++$){var tt=Z[$];for(B=0;B<tt.length;++B){var nt=31&tt[B];z(r,m,Y[nt]),m+=H[nt],nt>15&&(z(r,m,tt[B]>>5&127),m+=tt[B]>>12)}}}else N=w,P=p,Q=y,R=g;for(B=0;B<u;++B){var rt=o[B];if(rt>255){_(r,m,N[(nt=rt>>18&31)+257]),m+=P[nt+257],nt>7&&(z(r,m,rt>>23&31),m+=e[nt]);var et=31&rt;_(r,m,Q[et]),m+=R[et],et>3&&(_(r,m,rt>>5&8191),m+=i[et])}else _(r,m,N[rt]),m+=P[rt]}return _(r,m,N[256]),m+P[256]},C=new r([65540,131080,131088,131104,262176,1048704,1048832,2114560,2117632]),F=new t(0),I=function(){for(var t=new Int32Array(256),n=0;n<256;++n){for(var r=n,e=9;--e;)r=(1&r&&-306674912)^r>>>1;t[n]=r}return t}(),S=function(){var t=1,n=0;return{p:function(r){for(var e=t,i=n,s=0|r.length,a=0;a!=s;){for(var o=Math.min(a+2655,s);a<o;++a)i+=e+=r[a];e=(65535&e)+15*(e>>16),i=(65535&i)+15*(i>>16)}t=e,n=i},d:function(){return(255&(t%=65521))<<24|(65280&t)<<8|(255&(n%=65521))<<8|n>>8}}},L=function(s,a,o,h,u){if(!u&&(u={l:1},a.dictionary)){var c=a.dictionary.subarray(-32768),v=new t(c.length+s.length);v.set(c),v.set(s,c.length),s=v,u.w=c.length}return function(s,a,o,h,u,c){var v=c.z||s.length,d=new t(h+v+5*(1+Math.ceil(v/7e3))+u),p=d.subarray(h,d.length-u),g=c.l,w=7&(c.r||0);if(a){w&&(p[0]=c.r>>3);for(var y=C[a-1],M=y>>13,E=8191&y,z=(1<<o)-1,_=c.p||new n(32768),x=c.h||new n(z+1),A=Math.ceil(o/3),D=2*A,T=function(t){return(s[t]^s[t+1]<<A^s[t+2]<<D)&z},F=new r(25e3),I=new n(288),S=new n(32),L=0,O=0,j=c.i||0,q=0,B=c.w||0,G=0;j+2<v;++j){var H=T(j),J=32767&j,K=x[H];if(_[J]=K,x[H]=J,B<=j){var N=v-j;if((L>7e3||q>24576)&&(N>423||!g)){w=U(s,p,0,F,I,S,O,q,G,j-G,w),q=L=O=0,G=j;for(var P=0;P<286;++P)I[P]=0;for(P=0;P<30;++P)S[P]=0}var Q=2,R=0,V=E,W=J-K&32767;if(N>2&&H==T(j-W))for(var X=Math.min(M,N)-1,Y=Math.min(32767,j),Z=Math.min(258,N);W<=Y&&--V&&J!=K;){if(s[j+Q]==s[j+Q-W]){for(var $=0;$<Z&&s[j+$]==s[j+$-W];++$);if($>Q){if(Q=$,R=W,$>X)break;var tt=Math.min(W,$-2),nt=0;for(P=0;P<tt;++P){var rt=j-W+P&32767,et=rt-_[rt]&32767;et>nt&&(nt=et,K=rt)}}}W+=(J=K)-(K=_[J])&32767}if(R){F[q++]=268435456|f[Q]<<18|l[R];var it=31&f[Q],st=31&l[R];O+=e[it]+i[st],++I[257+it],++S[st],B=j+Q,++L}else F[q++]=s[j],++I[s[j]]}}for(j=Math.max(j,B);j<v;++j)F[q++]=s[j],++I[s[j]];w=U(s,p,g,F,I,S,O,q,G,j-G,w),g||(c.r=7&w|p[w/8|0]<<3,w-=7,c.h=x,c.p=_,c.i=j,c.w=B)}else{for(j=c.w||0;j<v+g;j+=65535){var at=j+65535;at>=v&&(p[w/8|0]=g,at=v),w=k(p,w+1,s.subarray(j,at))}c.i=v}return b(d,0,h+m(w)+u)}(s,null==a.level?6:a.level,null==a.mem?u.l?Math.ceil(1.5*Math.max(8,Math.min(13,Math.log(s.length)))):20:12+a.mem,o,h,u)},O=function(t,n,r){for(;r;++n)t[n]=r,r>>>=8},j=function(){function n(n,r){if("function"==typeof n&&(r=n,n={}),this.ondata=r,this.o=n||{},this.s={l:0,i:32768,w:32768,z:32768},this.b=new t(98304),this.o.dictionary){var e=this.o.dictionary.subarray(-32768);this.b.set(e,32768-e.length),this.s.i=32768-e.length}}return n.prototype.p=function(t,n){this.ondata(L(t,this.o,0,0,this.s),n)},n.prototype.push=function(n,r){this.ondata||E(5),this.s.l&&E(4);var e=n.length+this.s.z;if(e>this.b.length){if(e>2*this.b.length-32768){var i=new t(-32768&e);i.set(this.b.subarray(0,this.s.z)),this.b=i}var s=this.b.length-this.s.z;this.b.set(n.subarray(0,s),this.s.z),this.s.z=this.b.length,this.p(this.b,!1),this.b.set(this.b.subarray(-32768)),this.b.set(n.subarray(s),32768),this.s.z=n.length-s+32768,this.s.i=32766,this.s.w=32768}else this.b.set(n,this.s.z),this.s.z+=n.length;this.s.l=1&r,(this.s.z>this.s.w+8191||r)&&(this.p(this.b,r||!1),this.s.w=this.s.i,this.s.i-=2)},n.prototype.flush=function(){this.ondata||E(5),this.s.l&&E(4),this.p(this.b,!1),this.s.w=this.s.i,this.s.i-=2},n}();function q(t,n){n||(n={});var r=function(){var t=-1;return{p:function(n){for(var r=t,e=0;e<n.length;++e)r=I[255&r^n[e]]^r>>>8;t=r},d:function(){return~t}}}(),e=t.length;r.p(t);var i,s=L(t,n,10+((i=n).filename?i.filename.length+1:0),8),a=s.length;return function(t,n){var r=n.filename;if(t[0]=31,t[1]=139,t[2]=8,t[8]=n.level<2?4:9==n.level?2:0,t[9]=3,0!=n.mtime&&O(t,4,Math.floor(new Date(n.mtime||Date.now())/1e3)),r){t[3]=8;for(var e=0;e<=r.length;++e)t[e+10]=r.charCodeAt(e)}}(s,n),O(s,a-8,r.d()),O(s,a-4,e),s}var B=function(){function t(t,n){this.c=S(),this.v=1,j.call(this,t,n)}return t.prototype.push=function(t,n){this.c.p(t),j.prototype.push.call(this,t,n)},t.prototype.p=function(t,n){var r=L(t,this.o,this.v&&(this.o.dictionary?6:2),n&&4,this.s);this.v&&(function(t,n){var r=n.level,e=0==r?0:r<6?1:9==r?3:2;if(t[0]=120,t[1]=e<<6|(n.dictionary&&32),t[1]|=31-(t[0]<<8|t[1])%31,n.dictionary){var i=S();i.p(n.dictionary),O(t,2,i.d())}}(r,this.o),this.v=0),n&&O(r,r.length-4,this.c.d()),this.ondata(r,n)},t.prototype.flush=function(){j.prototype.flush.call(this)},t}(),G="undefined"!=typeof TextEncoder&&new TextEncoder,H="undefined"!=typeof TextDecoder&&new TextDecoder;try{H.decode(F,{stream:!0})}catch(t){}var J=function(){function t(t){this.ondata=t}return t.prototype.push=function(t,n){this.ondata||E(5),this.d&&E(4),this.ondata(K(t),this.d=n||!1)},t}();function K(n,r){if(G)return G.encode(n);for(var e=n.length,i=new t(n.length+(n.length>>1)),s=0,a=function(t){i[s++]=t},o=0;o<e;++o){if(s+5>i.length){var h=new t(s+8+(e-o<<1));h.set(i),i=h}var f=n.charCodeAt(o);f<128||r?a(f):f<2048?(a(192|f>>6),a(128|63&f)):f>55295&&f<57344?(a(240|(f=65536+(1047552&f)|1023&n.charCodeAt(++o))>>18),a(128|f>>12&63),a(128|f>>6&63),a(128|63&f)):(a(224|f>>12),a(128|f>>6&63),a(128|63&f))}return b(i,0,s)}const N=new class{constructor(){this._init()}clear(){this._init()}addEvent(t){if(!t)throw new Error("Adding invalid event");const n=this._hasEvents?",":"";this.stream.push(n+t),this._hasEvents=!0}finish(){this.stream.push("]",!0);const t=function(t){let n=0;for(const r of t)n+=r.length;const r=new Uint8Array(n);for(let n=0,e=0,i=t.length;n<i;n++){const i=t[n];r.set(i,e),e+=i.length}return r}(this._deflatedData);return this._init(),t}_init(){this._hasEvents=!1,this._deflatedData=[],this.deflate=new B,this.deflate.ondata=(t,n)=>{this._deflatedData.push(t)},this.stream=new J((t,n)=>{this.deflate.push(t,n)}),this.stream.push("[")}},P={clear:()=>{N.clear()},addEvent:t=>N.addEvent(t),finish:()=>N.finish(),compress:t=>function(t){return q(K(t))}(t)};addEventListener("message",function(t){const n=t.data.method,r=t.data.id,e=t.data.arg;if(n in P&&"function"==typeof P[n])try{const t=P[n](e);postMessage({id:r,method:n,success:!0,response:t})}catch(t){postMessage({id:r,method:n,success:!1,response:t.message}),console.error(t)}}),postMessage({id:void 0,method:"init",success:!0,response:void 0});';
function YV() {
  const e = new Blob([GV]);
  return URL.createObjectURL(e);
}
const Z0 = ["log", "warn", "error"], ph = "[Replay] ";
function eg(e, t = "info") {
  wi(
    {
      category: "console",
      data: {
        logger: "replay"
      },
      level: t,
      message: `${ph}${e}`
    },
    { level: t }
  );
}
function XV() {
  let e = !1, t = !1;
  const s = {
    exception: () => {
    },
    infoTick: () => {
    },
    setConfig: (n) => {
      e = !!n.captureExceptions, t = !!n.traceInternals;
    }
  };
  return Jt ? (Z0.forEach((n) => {
    s[n] = (...r) => {
      ot[n](ph, ...r), t && eg(r.join(""), C3(n));
    };
  }), s.exception = (n, ...r) => {
    r.length && s.error && s.error(...r), ot.error(ph, n), e ? Ns(n) : t && eg(n, "error");
  }, s.infoTick = (...n) => {
    ot.log(ph, ...n), t && setTimeout(() => eg(n[0]), 0);
  }) : Z0.forEach((n) => {
    s[n] = () => {
    };
  }), s;
}
const $t = XV();
class U1 extends Error {
  constructor() {
    super(`Event buffer exceeded maximum size of ${M1}.`);
  }
}
class z8 {
  /** All the events that are buffered to be sent. */
  /** @inheritdoc */
  /** @inheritdoc */
  constructor() {
    this.events = [], this._totalSize = 0, this.hasCheckout = !1, this.waitForCheckout = !1;
  }
  /** @inheritdoc */
  get hasEvents() {
    return this.events.length > 0;
  }
  /** @inheritdoc */
  get type() {
    return "sync";
  }
  /** @inheritdoc */
  destroy() {
    this.events = [];
  }
  /** @inheritdoc */
  async addEvent(t) {
    const s = JSON.stringify(t).length;
    if (this._totalSize += s, this._totalSize > M1)
      throw new U1();
    this.events.push(t);
  }
  /** @inheritdoc */
  finish() {
    return new Promise((t) => {
      const s = this.events;
      this.clear(), t(JSON.stringify(s));
    });
  }
  /** @inheritdoc */
  clear() {
    this.events = [], this._totalSize = 0, this.hasCheckout = !1;
  }
  /** @inheritdoc */
  getEarliestTimestamp() {
    const t = this.events.map((s) => s.timestamp).sort()[0];
    return t ? j1(t) : null;
  }
}
class qV {
  constructor(t) {
    this._worker = t, this._id = 0;
  }
  /**
   * Ensure the worker is ready (or not).
   * This will either resolve when the worker is ready, or reject if an error occurred.
   */
  ensureReady() {
    return this._ensureReadyPromise ? this._ensureReadyPromise : (this._ensureReadyPromise = new Promise((t, s) => {
      this._worker.addEventListener(
        "message",
        ({ data: n }) => {
          n.success ? t() : s();
        },
        { once: !0 }
      ), this._worker.addEventListener(
        "error",
        (n) => {
          s(n);
        },
        { once: !0 }
      );
    }), this._ensureReadyPromise);
  }
  /**
   * Destroy the worker.
   */
  destroy() {
    Jt && $t.log("Destroying compression worker"), this._worker.terminate();
  }
  /**
   * Post message to worker and wait for response before resolving promise.
   */
  postMessage(t, s) {
    const n = this._getAndIncrementId();
    return new Promise((r, i) => {
      const o = ({ data: l }) => {
        const d = l;
        if (d.method === t && d.id === n) {
          if (this._worker.removeEventListener("message", o), !d.success) {
            Jt && $t.error("Error in compression worker: ", d.response), i(new Error("Error in compression worker"));
            return;
          }
          r(d.response);
        }
      };
      this._worker.addEventListener("message", o), this._worker.postMessage({ id: n, method: t, arg: s });
    });
  }
  /** Get the current ID and increment it for the next call. */
  _getAndIncrementId() {
    return this._id++;
  }
}
class QV {
  /** @inheritdoc */
  /** @inheritdoc */
  constructor(t) {
    this._worker = new qV(t), this._earliestTimestamp = null, this._totalSize = 0, this.hasCheckout = !1, this.waitForCheckout = !1;
  }
  /** @inheritdoc */
  get hasEvents() {
    return !!this._earliestTimestamp;
  }
  /** @inheritdoc */
  get type() {
    return "worker";
  }
  /**
   * Ensure the worker is ready (or not).
   * This will either resolve when the worker is ready, or reject if an error occurred.
   */
  ensureReady() {
    return this._worker.ensureReady();
  }
  /**
   * Destroy the event buffer.
   */
  destroy() {
    this._worker.destroy();
  }
  /**
   * Add an event to the event buffer.
   *
   * Returns true if event was successfully received and processed by worker.
   */
  addEvent(t) {
    const s = j1(t.timestamp);
    (!this._earliestTimestamp || s < this._earliestTimestamp) && (this._earliestTimestamp = s);
    const n = JSON.stringify(t);
    return this._totalSize += n.length, this._totalSize > M1 ? Promise.reject(new U1()) : this._sendEventToWorker(n);
  }
  /**
   * Finish the event buffer and return the compressed data.
   */
  finish() {
    return this._finishRequest();
  }
  /** @inheritdoc */
  clear() {
    this._earliestTimestamp = null, this._totalSize = 0, this.hasCheckout = !1, this._worker.postMessage("clear").then(null, (t) => {
      Jt && $t.exception(t, 'Sending "clear" message to worker failed', t);
    });
  }
  /** @inheritdoc */
  getEarliestTimestamp() {
    return this._earliestTimestamp;
  }
  /**
   * Send the event to the worker.
   */
  _sendEventToWorker(t) {
    return this._worker.postMessage("addEvent", t);
  }
  /**
   * Finish the request and return the compressed data from the worker.
   */
  async _finishRequest() {
    const t = await this._worker.postMessage("finish");
    return this._earliestTimestamp = null, this._totalSize = 0, t;
  }
}
class KV {
  constructor(t) {
    this._fallback = new z8(), this._compression = new QV(t), this._used = this._fallback, this._ensureWorkerIsLoadedPromise = this._ensureWorkerIsLoaded();
  }
  /** @inheritdoc */
  get waitForCheckout() {
    return this._used.waitForCheckout;
  }
  /** @inheritdoc */
  get type() {
    return this._used.type;
  }
  /** @inheritDoc */
  get hasEvents() {
    return this._used.hasEvents;
  }
  /** @inheritdoc */
  get hasCheckout() {
    return this._used.hasCheckout;
  }
  /** @inheritdoc */
  set hasCheckout(t) {
    this._used.hasCheckout = t;
  }
  /** @inheritdoc */
  // eslint-disable-next-line @typescript-eslint/adjacent-overload-signatures
  set waitForCheckout(t) {
    this._used.waitForCheckout = t;
  }
  /** @inheritDoc */
  destroy() {
    this._fallback.destroy(), this._compression.destroy();
  }
  /** @inheritdoc */
  clear() {
    return this._used.clear();
  }
  /** @inheritdoc */
  getEarliestTimestamp() {
    return this._used.getEarliestTimestamp();
  }
  /**
   * Add an event to the event buffer.
   *
   * Returns true if event was successfully added.
   */
  addEvent(t) {
    return this._used.addEvent(t);
  }
  /** @inheritDoc */
  async finish() {
    return await this.ensureWorkerIsLoaded(), this._used.finish();
  }
  /** Ensure the worker has loaded. */
  ensureWorkerIsLoaded() {
    return this._ensureWorkerIsLoadedPromise;
  }
  /** Actually check if the worker has been loaded. */
  async _ensureWorkerIsLoaded() {
    try {
      await this._compression.ensureReady();
    } catch (t) {
      Jt && $t.exception(t, "Failed to load the compression worker, falling back to simple buffer");
      return;
    }
    await this._switchToCompressionWorker();
  }
  /** Switch the used buffer to the compression worker. */
  async _switchToCompressionWorker() {
    const { events: t, hasCheckout: s, waitForCheckout: n } = this._fallback, r = [];
    for (const i of t)
      r.push(this._compression.addEvent(i));
    this._compression.hasCheckout = s, this._compression.waitForCheckout = n, this._used = this._compression;
    try {
      await Promise.all(r), this._fallback.clear();
    } catch (i) {
      Jt && $t.exception(i, "Failed to add events when switching buffers.");
    }
  }
}
function ZV({
  useCompression: e,
  workerUrl: t
}) {
  if (e && // eslint-disable-next-line no-restricted-globals
  window.Worker) {
    const s = JV(t);
    if (s)
      return s;
  }
  return Jt && $t.log("Using simple buffer"), new z8();
}
function JV(e) {
  try {
    const t = e || $V();
    if (!t)
      return;
    Jt && $t.log(`Using compression worker${e ? ` from ${e}` : ""}`);
    const s = new Worker(t);
    return new KV(s);
  } catch (t) {
    Jt && $t.exception(t, "Failed to create compression worker");
  }
}
function $V() {
  return typeof __SENTRY_EXCLUDE_REPLAY_WORKER__ > "u" || !__SENTRY_EXCLUDE_REPLAY_WORKER__ ? YV() : "";
}
function z1() {
  try {
    return "sessionStorage" in ga && !!ga.sessionStorage;
  } catch {
    return !1;
  }
}
function _V(e) {
  eD(), e.session = void 0;
}
function eD() {
  if (z1())
    try {
      ga.sessionStorage.removeItem(L1);
    } catch {
    }
}
function W8(e) {
  return e === void 0 ? !1 : Math.random() < e;
}
function W1(e) {
  if (z1())
    try {
      ga.sessionStorage.setItem(L1, JSON.stringify(e));
    } catch {
    }
}
function G8(e) {
  const t = Date.now(), s = e.id || gn(), n = e.started || t, r = e.lastActivity || t, i = e.segmentId || 0, o = e.sampled, l = e.previousSessionId;
  return {
    id: s,
    started: n,
    lastActivity: r,
    segmentId: i,
    sampled: o,
    previousSessionId: l
  };
}
function tD(e, t) {
  return W8(e) ? "session" : t ? "buffer" : !1;
}
function J0({ sessionSampleRate: e, allowBuffering: t, stickySession: s = !1 }, { previousSessionId: n } = {}) {
  const r = tD(e, t), i = G8({
    sampled: r,
    previousSessionId: n
  });
  return s && W1(i), i;
}
function sD() {
  if (!z1())
    return null;
  try {
    const e = ga.sessionStorage.getItem(L1);
    if (!e)
      return null;
    const t = JSON.parse(e);
    return Jt && $t.infoTick("Loading existing session"), G8(t);
  } catch {
    return null;
  }
}
function zv(e, t, s = +/* @__PURE__ */ new Date()) {
  return e === null || t === void 0 || t < 0 ? !0 : t === 0 ? !1 : e + t <= s;
}
function Y8(e, {
  maxReplayDuration: t,
  sessionIdleExpire: s,
  targetTime: n = Date.now()
}) {
  return (
    // First, check that maximum session length has not been exceeded
    zv(e.started, t, n) || // check that the idle timeout has not been exceeded (i.e. user has
    // performed an action within the last `sessionIdleExpire` ms)
    zv(e.lastActivity, s, n)
  );
}
function X8(e, { sessionIdleExpire: t, maxReplayDuration: s }) {
  return !(!Y8(e, { sessionIdleExpire: t, maxReplayDuration: s }) || e.sampled === "buffer" && e.segmentId === 0);
}
function tg({
  sessionIdleExpire: e,
  maxReplayDuration: t,
  previousSessionId: s
}, n) {
  const r = n.stickySession && sD();
  return r ? X8(r, { sessionIdleExpire: e, maxReplayDuration: t }) ? (Jt && $t.infoTick("Session in sessionStorage is expired, creating new one..."), J0(n, { previousSessionId: r.id })) : r : (Jt && $t.infoTick("Creating new session"), J0(n, { previousSessionId: s }));
}
function aD(e) {
  return e.type === ps.Custom;
}
function G1(e, t, s) {
  return Q8(e, t) ? (q8(e, t, s), !0) : !1;
}
function nD(e, t, s) {
  return Q8(e, t) ? q8(e, t, s) : Promise.resolve(null);
}
async function q8(e, t, s) {
  const { eventBuffer: n } = e;
  if (!n || n.waitForCheckout && !s)
    return null;
  const r = e.recordingMode === "buffer";
  try {
    s && r && n.clear(), s && (n.hasCheckout = !0, n.waitForCheckout = !1);
    const i = e.getOptions(), o = rD(t, i.beforeAddRecordingEvent);
    return o ? await n.addEvent(o) : void 0;
  } catch (i) {
    const o = i && i instanceof U1, l = o ? "addEventSizeExceeded" : "addEvent";
    if (o && r)
      return n.clear(), n.waitForCheckout = !0, null;
    e.handleException(i), await e.stop({ reason: l });
    const d = ds();
    d && d.recordDroppedEvent("internal_sdk_error", "replay");
  }
}
function Q8(e, t) {
  if (!e.eventBuffer || e.isPaused() || !e.isEnabled())
    return !1;
  const s = j1(t.timestamp);
  return s + e.timeouts.sessionIdlePause < Date.now() ? !1 : s > e.getContext().initialTimestamp + e.getOptions().maxReplayDuration ? (Jt && $t.infoTick(`Skipping event with timestamp ${s} because it is after maxReplayDuration`), !1) : !0;
}
function rD(e, t) {
  try {
    if (typeof t == "function" && aD(e))
      return t(e);
  } catch (s) {
    return Jt && $t.exception(s, "An error occurred in the `beforeAddRecordingEvent` callback, skipping the event..."), null;
  }
  return e;
}
function Y1(e) {
  return !e.type;
}
function Wv(e) {
  return e.type === "transaction";
}
function oD(e) {
  return e.type === "replay_event";
}
function $0(e) {
  return e.type === "feedback";
}
function iD(e) {
  return (t, s) => {
    if (!e.isEnabled() || !Y1(t) && !Wv(t))
      return;
    const n = s == null ? void 0 : s.statusCode;
    if (!(!n || n < 200 || n >= 300)) {
      if (Wv(t)) {
        lD(e, t);
        return;
      }
      dD(e, t);
    }
  };
}
function lD(e, t) {
  var n, r;
  const s = e.getContext();
  (r = (n = t.contexts) == null ? void 0 : n.trace) != null && r.trace_id && s.traceIds.size < 100 && s.traceIds.add(t.contexts.trace.trace_id);
}
function dD(e, t) {
  const s = e.getContext();
  if (t.event_id && s.errorIds.size < 100 && s.errorIds.add(t.event_id), e.recordingMode !== "buffer" || !t.tags || !t.tags.replayId)
    return;
  const { beforeErrorSampling: n } = e.getOptions();
  typeof n == "function" && !n(t) || zu(async () => {
    try {
      await e.sendBufferedReplayOrFlush();
    } catch (r) {
      e.handleException(r);
    }
  });
}
function cD(e) {
  return (t) => {
    !e.isEnabled() || !Y1(t) || uD(e, t);
  };
}
function uD(e, t) {
  var n, r, i;
  const s = (i = (r = (n = t.exception) == null ? void 0 : n.values) == null ? void 0 : r[0]) == null ? void 0 : i.value;
  if (typeof s == "string" && // Only matches errors in production builds of react-dom
  // Example https://reactjs.org/docs/error-decoder.html?invariant=423
  // With newer React versions, the messages changed to a different website https://react.dev/errors/418
  (s.match(
    /(reactjs\.org\/docs\/error-decoder\.html\?invariant=|react\.dev\/errors\/)(418|419|422|423|425)/
  ) || // Development builds of react-dom
  // Error 1: Hydration failed because the initial UI does not match what was rendered on the server.
  // Error 2: Text content does not match server-rendered HTML. Warning: Text content did not match.
  s.match(/(does not match server-rendered HTML|Hydration failed because)/i))) {
    const o = Nr({
      category: "replay.hydrate-error",
      data: {
        url: fl()
      }
    });
    Gu(e, o);
  }
}
function pD(e) {
  const t = ds();
  t && t.on("beforeAddBreadcrumb", (s) => hD(e, s));
}
function hD(e, t) {
  if (!e.isEnabled() || !K8(t))
    return;
  const s = mD(t);
  s && Gu(e, s);
}
function mD(e) {
  return !K8(e) || [
    // fetch & xhr are handled separately,in handleNetworkBreadcrumbs
    "fetch",
    "xhr",
    // These two are breadcrumbs for emitted sentry events, we don't care about them
    "sentry.event",
    "sentry.transaction"
  ].includes(e.category) || // We capture UI breadcrumbs separately
  e.category.startsWith("ui.") ? null : e.category === "console" ? fD(e) : Nr(e);
}
function fD(e) {
  var r;
  const t = (r = e.data) == null ? void 0 : r.arguments;
  if (!Array.isArray(t) || t.length === 0)
    return Nr(e);
  let s = !1;
  const n = t.map((i) => {
    if (!i)
      return i;
    if (typeof i == "string")
      return i.length > fp ? (s = !0, `${i.slice(0, fp)}…`) : i;
    if (typeof i == "object")
      try {
        const o = pr(i, 7);
        return JSON.stringify(o).length > fp ? (s = !0, `${JSON.stringify(o, null, 2).slice(0, fp)}…`) : o;
      } catch {
      }
    return i;
  });
  return Nr({
    ...e,
    data: {
      ...e.data,
      arguments: n,
      ...s ? { _meta: { warnings: ["CONSOLE_ARG_TRUNCATED"] } } : {}
    }
  });
}
function K8(e) {
  return !!e.category;
}
function gD(e, t) {
  var s, n, r;
  return e.type || !((n = (s = e.exception) == null ? void 0 : s.values) != null && n.length) ? !1 : !!((r = t.originalException) != null && r.__rrweb__);
}
function Z8() {
  const e = Is().getPropagationContext().dsc;
  e && delete e.replay_id;
  const t = Ja();
  if (t) {
    const s = Fo(t);
    delete s.replay_id;
  }
}
function vD(e, t) {
  e.triggerUserActivity(), e.addUpdate(() => t.timestamp ? (e.throttledAddEvent({
    type: ps.Custom,
    timestamp: t.timestamp * 1e3,
    data: {
      tag: "breadcrumb",
      payload: {
        timestamp: t.timestamp,
        type: "default",
        category: "sentry.feedback",
        data: {
          feedbackId: t.event_id
        }
      }
    }
  }), !1) : !0);
}
function yD(e, t) {
  return e.recordingMode !== "buffer" || t.message === B1 || !t.exception || t.type ? !1 : W8(e.getOptions().errorSampleRate);
}
function bD(e) {
  return Object.assign(
    (t, s) => !e.isEnabled() || e.isPaused() ? t : oD(t) ? (delete t.breadcrumbs, t) : !Y1(t) && !Wv(t) && !$0(t) ? t : e.checkAndHandleExpiredSession() ? $0(t) ? (e.flush(), t.contexts.feedback.replay_id = e.getSessionId(), vD(e, t), t) : gD(t, s) && !e.getOptions()._experiments.captureExceptions ? (Jt && $t.log("Ignoring error from rrweb internals", t), null) : ((yD(e, t) || e.recordingMode === "session") && (t.tags = { ...t.tags, replayId: e.getSessionId() }), t) : (Z8(), t),
    { id: "Replay" }
  );
}
function _m(e, t) {
  return t.map(({ type: s, start: n, end: r, name: i, data: o }) => {
    const l = e.throttledAddEvent({
      type: ps.Custom,
      timestamp: n,
      data: {
        tag: "performanceSpan",
        payload: {
          op: s,
          description: i,
          startTimestamp: n,
          endTimestamp: r,
          data: o
        }
      }
    });
    return typeof l == "string" ? Promise.resolve(null) : l;
  });
}
function AD(e) {
  const { from: t, to: s } = e, n = Date.now() / 1e3;
  return {
    type: "navigation.push",
    start: n,
    end: n,
    name: s,
    data: {
      previous: t
    }
  };
}
function wD(e) {
  return (t) => {
    if (!e.isEnabled())
      return;
    const s = AD(t);
    s !== null && (e.getContext().urls.push(s.name), e.triggerUserActivity(), e.addUpdate(() => (_m(e, [s]), !1)));
  };
}
function CD(e, t) {
  return Jt && e.getOptions()._experiments.traceInternals ? !1 : X7(t, ds());
}
function J8(e, t) {
  e.isEnabled() && t !== null && (CD(e, t.name) || e.addUpdate(() => (_m(e, [t]), !0)));
}
function ef(e) {
  if (!e)
    return;
  const t = new TextEncoder();
  try {
    if (typeof e == "string")
      return t.encode(e).length;
    if (e instanceof URLSearchParams)
      return t.encode(e.toString()).length;
    if (e instanceof FormData) {
      const s = d8(e);
      return t.encode(s).length;
    }
    if (e instanceof Blob)
      return e.size;
    if (e instanceof ArrayBuffer)
      return e.byteLength;
  } catch {
  }
}
function $8(e) {
  if (!e)
    return;
  const t = parseInt(e, 10);
  return isNaN(t) ? void 0 : t;
}
function pm(e, t) {
  if (!e)
    return {
      headers: {},
      size: void 0,
      _meta: {
        warnings: [t]
      }
    };
  const s = { ...e._meta }, n = s.warnings || [];
  return s.warnings = [...n, t], e._meta = s, e;
}
function _8(e, t) {
  if (!t)
    return null;
  const { startTimestamp: s, endTimestamp: n, url: r, method: i, statusCode: o, request: l, response: d } = t;
  return {
    type: e,
    start: s / 1e3,
    end: n / 1e3,
    name: r,
    data: {
      method: i,
      statusCode: o,
      request: l,
      response: d
    }
  };
}
function gu(e) {
  return {
    headers: {},
    size: e,
    _meta: {
      warnings: ["URL_SKIPPED"]
    }
  };
}
function hi(e, t, s) {
  if (!t && Object.keys(e).length === 0)
    return;
  if (!t)
    return {
      headers: e
    };
  if (!s)
    return {
      headers: e,
      size: t
    };
  const n = {
    headers: e,
    size: t
  }, { body: r, warnings: i } = SD(s);
  return n.body = r, i != null && i.length && (n._meta = {
    warnings: i
  }), n;
}
function Gv(e, t) {
  return Object.entries(e).reduce((s, [n, r]) => {
    const i = n.toLowerCase();
    return t.includes(i) && e[n] && (s[i] = r), s;
  }, {});
}
function SD(e) {
  if (!e || typeof e != "string")
    return {
      body: e
    };
  const t = e.length > B0, s = PD(e);
  if (t) {
    const n = e.slice(0, B0);
    return s ? {
      body: n,
      warnings: ["MAYBE_JSON_TRUNCATED"]
    } : {
      body: `${n}…`,
      warnings: ["TEXT_TRUNCATED"]
    };
  }
  if (s)
    try {
      return {
        body: JSON.parse(e)
      };
    } catch {
    }
  return {
    body: e
  };
}
function PD(e) {
  const t = e[0], s = e[e.length - 1];
  return t === "[" && s === "]" || t === "{" && s === "}";
}
function hm(e, t) {
  const s = kD(e);
  return Io(s, t);
}
function kD(e, t = ga.document.baseURI) {
  if (e.startsWith("http://") || e.startsWith("https://") || e.startsWith(ga.location.origin))
    return e;
  const s = new URL(e, t);
  if (s.origin !== new URL(t).origin)
    return e;
  const n = s.href;
  return !e.endsWith("/") && n.endsWith("/") ? n.slice(0, -1) : n;
}
async function ED(e, t, s) {
  try {
    const n = await TD(e, t, s), r = _8("resource.fetch", n);
    J8(s.replay, r);
  } catch (n) {
    Jt && $t.exception(n, "Failed to capture fetch breadcrumb");
  }
}
function ID(e, t) {
  const { input: s, response: n } = t, r = s ? u8(s) : void 0, i = ef(r), o = n ? $8(n.headers.get("content-length")) : void 0;
  i !== void 0 && (e.data.request_body_size = i), o !== void 0 && (e.data.response_body_size = o);
}
async function TD(e, t, s) {
  const n = Date.now(), { startTimestamp: r = n, endTimestamp: i = n } = t, {
    url: o,
    method: l,
    status_code: d = 0,
    request_body_size: c,
    response_body_size: u
  } = e.data, m = hm(o, s.networkDetailAllowUrls) && !hm(o, s.networkDetailDenyUrls), f = m ? OD(s, t.input, c) : gu(c), v = await RD(m, s, t.response, u);
  return {
    startTimestamp: r,
    endTimestamp: i,
    url: o,
    method: l,
    statusCode: d,
    request: f,
    response: v
  };
}
function OD({ networkCaptureBodies: e, networkRequestHeaders: t }, s, n) {
  const r = s ? MD(s, t) : {};
  if (!e)
    return hi(r, n, void 0);
  const i = u8(s), [o, l] = c8(i, $t), d = hi(r, n, o);
  return l ? pm(d, l) : d;
}
async function RD(e, {
  networkCaptureBodies: t,
  networkResponseHeaders: s
}, n, r) {
  if (!e && r !== void 0)
    return gu(r);
  const i = n ? e4(n.headers, s) : {};
  if (!n || !t && r !== void 0)
    return hi(i, r, void 0);
  const [o, l] = await BD(n), d = LD(o, {
    networkCaptureBodies: t,
    responseBodySize: r,
    captureDetails: e,
    headers: i
  });
  return l ? pm(d, l) : d;
}
function LD(e, {
  networkCaptureBodies: t,
  responseBodySize: s,
  captureDetails: n,
  headers: r
}) {
  try {
    const i = e != null && e.length && s === void 0 ? ef(e) : s;
    return n ? t ? hi(r, i, e) : hi(r, i, void 0) : gu(i);
  } catch (i) {
    return Jt && $t.exception(i, "Failed to serialize response body"), hi(r, s, void 0);
  }
}
async function BD(e) {
  const t = xD(e);
  if (!t)
    return [void 0, "BODY_PARSE_ERROR"];
  try {
    return [await FD(t)];
  } catch (s) {
    return s instanceof Error && s.message.indexOf("Timeout") > -1 ? (Jt && $t.warn("Parsing text body from response timed out"), [void 0, "BODY_PARSE_TIMEOUT"]) : (Jt && $t.exception(s, "Failed to get text body from response"), [void 0, "BODY_PARSE_ERROR"]);
  }
}
function e4(e, t) {
  const s = {};
  return t.forEach((n) => {
    e.get(n) && (s[n] = e.get(n));
  }), s;
}
function MD(e, t) {
  return e.length === 1 && typeof e[0] != "string" ? _0(e[0], t) : e.length === 2 ? _0(e[1], t) : {};
}
function _0(e, t) {
  if (!e)
    return {};
  const s = e.headers;
  return s ? s instanceof Headers ? e4(s, t) : Array.isArray(s) ? {} : Gv(s, t) : {};
}
function xD(e) {
  try {
    return e.clone();
  } catch (t) {
    Jt && $t.exception(t, "Failed to clone response body");
  }
}
function FD(e) {
  return new Promise((t, s) => {
    const n = zu(() => s(new Error("Timeout while trying to read response body")), 500);
    VD(e).then(
      (r) => t(r),
      (r) => s(r)
    ).finally(() => clearTimeout(n));
  });
}
async function VD(e) {
  return await e.text();
}
async function DD(e, t, s) {
  try {
    const n = jD(e, t, s), r = _8("resource.xhr", n);
    J8(s.replay, r);
  } catch (n) {
    Jt && $t.exception(n, "Failed to capture xhr breadcrumb");
  }
}
function ND(e, t) {
  const { xhr: s, input: n } = t;
  if (!s)
    return;
  const r = ef(n), i = s.getResponseHeader("content-length") ? $8(s.getResponseHeader("content-length")) : WD(s.response, s.responseType);
  r !== void 0 && (e.data.request_body_size = r), i !== void 0 && (e.data.response_body_size = i);
}
function jD(e, t, s) {
  const n = Date.now(), { startTimestamp: r = n, endTimestamp: i = n, input: o, xhr: l } = t, {
    url: d,
    method: c,
    status_code: u = 0,
    request_body_size: m,
    response_body_size: f
  } = e.data;
  if (!d)
    return null;
  if (!l || !hm(d, s.networkDetailAllowUrls) || hm(d, s.networkDetailDenyUrls)) {
    const O = gu(m), E = gu(f);
    return {
      startTimestamp: r,
      endTimestamp: i,
      url: d,
      method: c,
      statusCode: u,
      request: O,
      response: E
    };
  }
  const v = l[Gi], b = v ? Gv(v.request_headers, s.networkRequestHeaders) : {}, w = Gv(HD(l), s.networkResponseHeaders), [S, I] = s.networkCaptureBodies ? c8(o, $t) : [void 0], [T, x] = s.networkCaptureBodies ? UD(l) : [void 0], k = hi(b, m, S), C = hi(w, f, T);
  return {
    startTimestamp: r,
    endTimestamp: i,
    url: d,
    method: c,
    statusCode: u,
    request: I ? pm(k, I) : k,
    response: x ? pm(C, x) : C
  };
}
function HD(e) {
  const t = e.getAllResponseHeaders();
  return t ? t.split(`\r
`).reduce((s, n) => {
    const [r, i] = n.split(": ");
    return i && (s[r.toLowerCase()] = i), s;
  }, {}) : {};
}
function UD(e) {
  const t = [];
  try {
    return [e.responseText];
  } catch (s) {
    t.push(s);
  }
  try {
    return zD(e.response, e.responseType);
  } catch (s) {
    t.push(s);
  }
  return Jt && $t.warn("Failed to get xhr response body", ...t), [void 0];
}
function zD(e, t) {
  try {
    if (typeof e == "string")
      return [e];
    if (e instanceof Document)
      return [e.body.outerHTML];
    if (t === "json" && e && typeof e == "object")
      return [JSON.stringify(e)];
    if (!e)
      return [void 0];
  } catch (s) {
    return Jt && $t.exception(s, "Failed to serialize body", e), [void 0, "BODY_PARSE_ERROR"];
  }
  return Jt && $t.log("Skipping network body because of body type", e), [void 0, "UNPARSEABLE_BODY_TYPE"];
}
function WD(e, t) {
  try {
    const s = t === "json" && e && typeof e == "object" ? JSON.stringify(e) : e;
    return ef(s);
  } catch {
    return;
  }
}
function GD(e) {
  const t = ds();
  try {
    const {
      networkDetailAllowUrls: s,
      networkDetailDenyUrls: n,
      networkCaptureBodies: r,
      networkRequestHeaders: i,
      networkResponseHeaders: o
    } = e.getOptions(), l = {
      replay: e,
      networkDetailAllowUrls: s,
      networkDetailDenyUrls: n,
      networkCaptureBodies: r,
      networkRequestHeaders: i,
      networkResponseHeaders: o
    };
    t && t.on("beforeAddBreadcrumb", (d, c) => YD(l, d, c));
  } catch {
  }
}
function YD(e, t, s) {
  if (t.data)
    try {
      XD(t) && QD(s) && (ND(t, s), DD(t, s, e)), qD(t) && KD(s) && (ID(t, s), ED(t, s, e));
    } catch (n) {
      Jt && $t.exception(n, "Error when enriching network breadcrumb");
    }
}
function XD(e) {
  return e.category === "xhr";
}
function qD(e) {
  return e.category === "fetch";
}
function QD(e) {
  return e == null ? void 0 : e.xhr;
}
function KD(e) {
  return e == null ? void 0 : e.response;
}
function ZD(e, { autoFlushOnFeedback: t }) {
  const s = ds();
  o8(kV(e)), Qm(wD(e)), pD(e), GD(e);
  const n = bD(e);
  A7(n), s && (s.on("beforeSendEvent", cD(e)), s.on("afterSendEvent", iD(e)), s.on("createDsc", (r) => {
    const i = e.getSessionId();
    i && e.isEnabled() && e.recordingMode === "session" && e.checkAndHandleExpiredSession() && (r.replay_id = i);
  }), s.on("spanStart", (r) => {
    e.lastActiveSpan = r;
  }), s.on("spanEnd", (r) => {
    e.lastActiveSpan = r;
  }), s.on("beforeSendFeedback", async (r, i) => {
    var l;
    const o = e.getSessionId();
    i != null && i.includeReplay && e.isEnabled() && o && ((l = r.contexts) != null && l.feedback) && (r.contexts.feedback.source === "api" && t && await e.flush(), r.contexts.feedback.replay_id = o);
  }), t && s.on("openFeedbackWidget", async () => {
    await e.flush();
  }));
}
async function JD(e) {
  try {
    return Promise.all(
      _m(e, [
        // @ts-expect-error memory doesn't exist on type Performance as the API is non-standard (we check that it exists above)
        $D(ga.performance.memory)
      ])
    );
  } catch {
    return [];
  }
}
function $D(e) {
  const { jsHeapSizeLimit: t, totalJSHeapSize: s, usedJSHeapSize: n } = e, r = Date.now() / 1e3;
  return {
    type: "memory",
    name: "memory",
    start: r,
    end: r,
    data: {
      memory: {
        jsHeapSizeLimit: t,
        totalJSHeapSize: s,
        usedJSHeapSize: n
      }
    }
  };
}
function _D(e, t, s) {
  return $7(e, t, {
    ...s,
    // @ts-expect-error - Not quite sure why these types do not match, but this is fine
    setTimeoutImpl: zu
  });
}
const Yn = As.navigator;
function eN() {
  return /iPhone|iPad|iPod/i.test((Yn == null ? void 0 : Yn.userAgent) ?? "") || /Macintosh/i.test((Yn == null ? void 0 : Yn.userAgent) ?? "") && (Yn != null && Yn.maxTouchPoints) && (Yn == null ? void 0 : Yn.maxTouchPoints) > 1 ? {
    sampling: {
      mousemove: !1
    }
  } : {};
}
function tN(e) {
  let t = !1;
  return (s, n) => {
    if (!e.checkAndHandleExpiredSession()) {
      Jt && $t.warn("Received replay event after session expired.");
      return;
    }
    const r = n || !t;
    t = !0, e.clickDetector && AV(e.clickDetector, s), e.addUpdate(() => {
      if (e.recordingMode === "buffer" && r && e.setInitialState(), !G1(e, s, r))
        return !0;
      if (!r)
        return !1;
      const i = e.session;
      if (aN(e, r), e.recordingMode === "buffer" && i && e.eventBuffer) {
        const o = e.eventBuffer.getEarliestTimestamp();
        o && (Jt && $t.log(`Updating session start time to earliest event in buffer to ${new Date(o)}`), i.started = o, e.getOptions().stickySession && W1(i));
      }
      return i != null && i.previousSessionId || e.recordingMode === "session" && e.flush(), !0;
    });
  };
}
function sN(e) {
  const t = e.getOptions();
  return {
    type: ps.Custom,
    timestamp: Date.now(),
    data: {
      tag: "options",
      payload: {
        shouldRecordCanvas: e.isRecordingCanvas(),
        sessionSampleRate: t.sessionSampleRate,
        errorSampleRate: t.errorSampleRate,
        useCompressionOption: t.useCompression,
        blockAllMedia: t.blockAllMedia,
        maskAllText: t.maskAllText,
        maskAllInputs: t.maskAllInputs,
        useCompression: e.eventBuffer ? e.eventBuffer.type === "worker" : !1,
        networkDetailHasUrls: t.networkDetailAllowUrls.length > 0,
        networkCaptureBodies: t.networkCaptureBodies,
        networkRequestHasHeaders: t.networkRequestHeaders.length > 0,
        networkResponseHasHeaders: t.networkResponseHeaders.length > 0
      }
    }
  };
}
function aN(e, t) {
  !t || !e.session || e.session.segmentId !== 0 || G1(e, sN(e), !1);
}
function nN(e) {
  if (!e)
    return null;
  try {
    return e.nodeType === e.ELEMENT_NODE ? e : e.parentElement;
  } catch {
    return null;
  }
}
function rN(e, t, s, n) {
  return yl(
    $P(e, f1(e), n, s),
    [
      [{ type: "replay_event" }, e],
      [
        {
          type: "replay_recording",
          // If string then we need to encode to UTF8, otherwise will have
          // wrong size. TextEncoder has similar browser support to
          // MutationObserver, although it does not accept IE11.
          length: typeof t == "string" ? new TextEncoder().encode(t).length : t.length
        },
        t
      ]
    ]
  );
}
function oN({
  recordingData: e,
  headers: t
}) {
  let s;
  const n = `${JSON.stringify(t)}
`;
  if (typeof e == "string")
    s = `${n}${e}`;
  else {
    const i = new TextEncoder().encode(n);
    s = new Uint8Array(i.length + e.length), s.set(i), s.set(e, i.length);
  }
  return s;
}
async function iN({
  client: e,
  scope: t,
  replayId: s,
  event: n
}) {
  const r = typeof e._integrations == "object" && e._integrations !== null && !Array.isArray(e._integrations) ? Object.keys(e._integrations) : void 0, i = { event_id: s, integrations: r };
  e.emit("preprocessEvent", n, i);
  const o = await r3(
    e.getOptions(),
    n,
    i,
    t,
    e,
    Wn()
  );
  if (!o)
    return null;
  e.emit("postprocessEvent", o, i), o.platform = o.platform || "javascript";
  const l = e.getSdkMetadata(), { name: d, version: c } = (l == null ? void 0 : l.sdk) || {};
  return o.sdk = {
    ...o.sdk,
    name: d || "sentry.javascript.unknown",
    version: c || "0.0.0"
  }, o;
}
async function lN({
  recordingData: e,
  replayId: t,
  segmentId: s,
  eventContext: n,
  timestamp: r,
  session: i
}) {
  const o = oN({
    recordingData: e,
    headers: {
      segment_id: s
    }
  }), { urls: l, errorIds: d, traceIds: c, initialTimestamp: u } = n, m = ds(), f = Is(), v = m == null ? void 0 : m.getTransport(), b = m == null ? void 0 : m.getDsn();
  if (!m || !v || !b || !i.sampled)
    return Vo({});
  const w = {
    type: Nx,
    replay_start_timestamp: u / 1e3,
    timestamp: r / 1e3,
    error_ids: d,
    trace_ids: c,
    urls: l,
    replay_id: t,
    segment_id: s,
    replay_type: i.sampled
  }, S = await iN({ scope: f, client: m, replayId: t, event: w });
  if (!S)
    return m.recordDroppedEvent("event_processor", "replay"), Jt && $t.log("An event processor returned `null`, will not send event."), Vo({});
  delete S.sdkProcessingMetadata;
  const I = rN(S, o, b, m.getOptions().tunnel);
  let T;
  try {
    T = await v.send(I);
  } catch (k) {
    const C = new Error(B1);
    try {
      C.cause = k;
    } catch {
    }
    throw C;
  }
  if (typeof T.statusCode == "number" && (T.statusCode < 200 || T.statusCode >= 300))
    throw new t4(T.statusCode);
  const x = y3({}, T);
  if (v3(x, "replay"))
    throw new X1(x);
  return T;
}
class t4 extends Error {
  constructor(t) {
    super(`Transport returned status code ${t}`);
  }
}
class X1 extends Error {
  constructor(t) {
    super("Rate limit hit"), this.rateLimits = t;
  }
}
async function s4(e, t = {
  count: 0,
  interval: Gx
}) {
  const { recordingData: s, onError: n } = e;
  if (s.length)
    try {
      return await lN(e), !0;
    } catch (r) {
      if (r instanceof t4 || r instanceof X1)
        throw r;
      if (v7("Replays", {
        _retryCount: t.count
      }), n && n(r), t.count >= Yx) {
        const i = new Error(`${B1} - max retries exceeded`);
        try {
          i.cause = r;
        } catch {
        }
        throw i;
      }
      return t.interval *= ++t.count, new Promise((i, o) => {
        zu(async () => {
          try {
            await s4(e, t), i(!0);
          } catch (l) {
            o(l);
          }
        }, t.interval);
      });
    }
}
const a4 = "__THROTTLED", dN = "__SKIPPED";
function cN(e, t, s) {
  const n = /* @__PURE__ */ new Map(), r = (l) => {
    const d = l - s;
    n.forEach((c, u) => {
      u < d && n.delete(u);
    });
  }, i = () => [...n.values()].reduce((l, d) => l + d, 0);
  let o = !1;
  return (...l) => {
    const d = Math.floor(Date.now() / 1e3);
    if (r(d), i() >= t) {
      const u = o;
      return o = !0, u ? dN : a4;
    }
    o = !1;
    const c = n.get(d) || 0;
    return n.set(d, c + 1), e(...l);
  };
}
class uN {
  /**
   * Recording can happen in one of two modes:
   *   - session: Record the whole session, sending it continuously
   *   - buffer: Always keep the last 60s of recording, requires:
   *     - having replaysOnErrorSampleRate > 0 to capture replay when an error occurs
   *     - or calling `flush()` to send the replay
   */
  /**
   * The current or last active span.
   * This is only available when performance is enabled.
   */
  /**
   * These are here so we can overwrite them in tests etc.
   * @hidden
   */
  /** The replay has to be manually started, because no sample rate (neither session or error) was provided. */
  /**
   * Options to pass to `rrweb.record()`
   */
  /**
   * Timestamp of the last user activity. This lives across sessions.
   */
  /**
   * Is the integration currently active?
   */
  /**
   * Paused is a state where:
   * - DOM Recording is not listening at all
   * - Nothing will be added to event buffer (e.g. core SDK events)
   */
  /**
   * Have we attached listeners to the core SDK?
   * Note we have to track this as there is no way to remove instrumentation handlers.
   */
  /**
   * Function to stop recording
   */
  /**
   * Internal use for canvas recording options
   */
  /**
   * Handle when visibility of the page content changes. Opening a new tab will
   * cause the state to change to hidden because of content of current page will
   * be hidden. Likewise, moving a different window to cover the contents of the
   * page will also trigger a change to a hidden state.
   */
  /**
   * Handle when page is blurred
   */
  /**
   * Handle when page is focused
   */
  /** Ensure page remains active when a key is pressed. */
  constructor({
    options: t,
    recordingOptions: s
  }) {
    this.eventBuffer = null, this.performanceEntries = [], this.replayPerformanceEntries = [], this.recordingMode = "session", this.timeouts = {
      sessionIdlePause: jx,
      sessionIdleExpire: Hx
    }, this._lastActivity = Date.now(), this._isEnabled = !1, this._isPaused = !1, this._requiresManualStart = !1, this._hasInitializedCoreListeners = !1, this._context = {
      errorIds: /* @__PURE__ */ new Set(),
      traceIds: /* @__PURE__ */ new Set(),
      urls: [],
      initialTimestamp: Date.now(),
      initialUrl: ""
    }, this._recordingOptions = s, this._options = t, this._debouncedFlush = _D(() => this._flush(), this._options.flushMinDelay, {
      maxWait: this._options.flushMaxDelay
    }), this._throttledAddEvent = cN(
      (o, l) => nD(this, o, l),
      // Max 300 events...
      300,
      // ... per 5s
      5
    );
    const { slowClickTimeout: n, slowClickIgnoreSelectors: r } = this.getOptions(), i = n ? {
      threshold: Math.min(Xx, n),
      timeout: n,
      scrollTimeout: qx,
      ignoreSelector: r ? r.join(",") : ""
    } : void 0;
    if (i && (this.clickDetector = new gV(this, i)), Jt) {
      const o = t._experiments;
      $t.setConfig({
        captureExceptions: !!o.captureExceptions,
        traceInternals: !!o.traceInternals
      });
    }
    this._handleVisibilityChange = () => {
      ga.document.visibilityState === "visible" ? this._doChangeToForegroundTasks() : this._doChangeToBackgroundTasks();
    }, this._handleWindowBlur = () => {
      const o = Nr({
        category: "ui.blur"
      });
      this._doChangeToBackgroundTasks(o);
    }, this._handleWindowFocus = () => {
      const o = Nr({
        category: "ui.focus"
      });
      this._doChangeToForegroundTasks(o);
    }, this._handleKeyboardEvent = (o) => {
      OV(this, o);
    };
  }
  /** Get the event context. */
  getContext() {
    return this._context;
  }
  /** If recording is currently enabled. */
  isEnabled() {
    return this._isEnabled;
  }
  /** If recording is currently paused. */
  isPaused() {
    return this._isPaused;
  }
  /**
   * Determine if canvas recording is enabled
   */
  isRecordingCanvas() {
    return !!this._canvas;
  }
  /** Get the replay integration options. */
  getOptions() {
    return this._options;
  }
  /** A wrapper to conditionally capture exceptions. */
  handleException(t) {
    Jt && $t.exception(t), this._options.onError && this._options.onError(t);
  }
  /**
   * Initializes the plugin based on sampling configuration. Should not be
   * called outside of constructor.
   */
  initializeSampling(t) {
    const { errorSampleRate: s, sessionSampleRate: n } = this._options, r = s <= 0 && n <= 0;
    if (this._requiresManualStart = r, !r) {
      if (this._initializeSessionForSampling(t), !this.session) {
        Jt && $t.exception(new Error("Unable to initialize and create session"));
        return;
      }
      this.session.sampled !== !1 && (this.recordingMode = this.session.sampled === "buffer" && this.session.segmentId === 0 ? "buffer" : "session", Jt && $t.infoTick(`Starting replay in ${this.recordingMode} mode`), this._initializeRecording());
    }
  }
  /**
   * Start a replay regardless of sampling rate. Calling this will always
   * create a new session. Will log a message if replay is already in progress.
   *
   * Creates or loads a session, attaches listeners to varying events (DOM,
   * _performanceObserver, Recording, Sentry SDK, etc)
   */
  start() {
    if (this._isEnabled && this.recordingMode === "session") {
      Jt && $t.log("Recording is already in progress");
      return;
    }
    if (this._isEnabled && this.recordingMode === "buffer") {
      Jt && $t.log("Buffering is in progress, call `flush()` to save the replay");
      return;
    }
    Jt && $t.infoTick("Starting replay in session mode"), this._updateUserActivity();
    const t = tg(
      {
        maxReplayDuration: this._options.maxReplayDuration,
        sessionIdleExpire: this.timeouts.sessionIdleExpire
      },
      {
        stickySession: this._options.stickySession,
        // This is intentional: create a new session-based replay when calling `start()`
        sessionSampleRate: 1,
        allowBuffering: !1
      }
    );
    this.session = t, this._initializeRecording();
  }
  /**
   * Start replay buffering. Buffers until `flush()` is called or, if
   * `replaysOnErrorSampleRate` > 0, an error occurs.
   */
  startBuffering() {
    if (this._isEnabled) {
      Jt && $t.log("Buffering is in progress, call `flush()` to save the replay");
      return;
    }
    Jt && $t.infoTick("Starting replay in buffer mode");
    const t = tg(
      {
        sessionIdleExpire: this.timeouts.sessionIdleExpire,
        maxReplayDuration: this._options.maxReplayDuration
      },
      {
        stickySession: this._options.stickySession,
        sessionSampleRate: 0,
        allowBuffering: !0
      }
    );
    this.session = t, this.recordingMode = "buffer", this._initializeRecording();
  }
  /**
   * Start recording.
   *
   * Note that this will cause a new DOM checkout
   */
  startRecording() {
    try {
      const t = this._canvas;
      this._stopRecording = To({
        ...this._recordingOptions,
        // When running in error sampling mode, we need to overwrite `checkoutEveryNms`
        // Without this, it would record forever, until an error happens, which we don't want
        // instead, we'll always keep the last 60 seconds of replay before an error happened
        ...this.recordingMode === "buffer" ? { checkoutEveryNms: Wx } : (
          // Otherwise, use experimental option w/ min checkout time of 6 minutes
          // This is to improve playback seeking as there could potentially be
          // less mutations to process in the worse cases.
          //
          // checkout by "N" events is probably ideal, but means we have less
          // control about the number of checkouts we make (which generally
          // increases replay size)
          this._options._experiments.continuousCheckout && {
            // Minimum checkout time is 6 minutes
            checkoutEveryNms: Math.max(36e4, this._options._experiments.continuousCheckout)
          }
        ),
        emit: tN(this),
        ...eN(),
        onMutation: this._onMutationHandler.bind(this),
        ...t ? {
          recordCanvas: t.recordCanvas,
          getCanvasManager: t.getCanvasManager,
          sampling: t.sampling,
          dataURLOptions: t.dataURLOptions
        } : {}
      });
    } catch (t) {
      this.handleException(t);
    }
  }
  /**
   * Stops the recording, if it was running.
   *
   * Returns true if it was previously stopped, or is now stopped,
   * otherwise false.
   */
  stopRecording() {
    try {
      return this._stopRecording && (this._stopRecording(), this._stopRecording = void 0), !0;
    } catch (t) {
      return this.handleException(t), !1;
    }
  }
  /**
   * Currently, this needs to be manually called (e.g. for tests). Sentry SDK
   * does not support a teardown
   */
  async stop({ forceFlush: t = !1, reason: s } = {}) {
    var n;
    if (this._isEnabled) {
      this._isEnabled = !1;
      try {
        Jt && $t.log(`Stopping Replay${s ? ` triggered by ${s}` : ""}`), Z8(), this._removeListeners(), this.stopRecording(), this._debouncedFlush.cancel(), t && await this._flush({ force: !0 }), (n = this.eventBuffer) == null || n.destroy(), this.eventBuffer = null, _V(this);
      } catch (r) {
        this.handleException(r);
      }
    }
  }
  /**
   * Pause some replay functionality. See comments for `_isPaused`.
   * This differs from stop as this only stops DOM recording, it is
   * not as thorough of a shutdown as `stop()`.
   */
  pause() {
    this._isPaused || (this._isPaused = !0, this.stopRecording(), Jt && $t.log("Pausing replay"));
  }
  /**
   * Resumes recording, see notes for `pause().
   *
   * Note that calling `startRecording()` here will cause a
   * new DOM checkout.`
   */
  resume() {
    !this._isPaused || !this._checkSession() || (this._isPaused = !1, this.startRecording(), Jt && $t.log("Resuming replay"));
  }
  /**
   * If not in "session" recording mode, flush event buffer which will create a new replay.
   * Unless `continueRecording` is false, the replay will continue to record and
   * behave as a "session"-based replay.
   *
   * Otherwise, queue up a flush.
   */
  async sendBufferedReplayOrFlush({ continueRecording: t = !0 } = {}) {
    if (this.recordingMode === "session")
      return this.flushImmediate();
    const s = Date.now();
    Jt && $t.log("Converting buffer to session"), await this.flushImmediate();
    const n = this.stopRecording();
    !t || !n || this.recordingMode !== "session" && (this.recordingMode = "session", this.session && (this._updateUserActivity(s), this._updateSessionActivity(s), this._maybeSaveSession()), this.startRecording());
  }
  /**
   * We want to batch uploads of replay events. Save events only if
   * `<flushMinDelay>` milliseconds have elapsed since the last event
   * *OR* if `<flushMaxDelay>` milliseconds have elapsed.
   *
   * Accepts a callback to perform side-effects and returns true to stop batch
   * processing and hand back control to caller.
   */
  addUpdate(t) {
    const s = t();
    this.recordingMode !== "buffer" && s !== !0 && this._debouncedFlush();
  }
  /**
   * Updates the user activity timestamp and resumes recording. This should be
   * called in an event handler for a user action that we consider as the user
   * being "active" (e.g. a mouse click).
   */
  triggerUserActivity() {
    if (this._updateUserActivity(), !this._stopRecording) {
      if (!this._checkSession())
        return;
      this.resume();
      return;
    }
    this.checkAndHandleExpiredSession(), this._updateSessionActivity();
  }
  /**
   * Updates the user activity timestamp *without* resuming
   * recording. Some user events (e.g. keydown) can be create
   * low-value replays that only contain the keypress as a
   * breadcrumb. Instead this would require other events to
   * create a new replay after a session has expired.
   */
  updateUserActivity() {
    this._updateUserActivity(), this._updateSessionActivity();
  }
  /**
   * Only flush if `this.recordingMode === 'session'`
   */
  conditionalFlush() {
    return this.recordingMode === "buffer" ? Promise.resolve() : this.flushImmediate();
  }
  /**
   * Flush using debounce flush
   */
  flush() {
    return this._debouncedFlush();
  }
  /**
   * Always flush via `_debouncedFlush` so that we do not have flushes triggered
   * from calling both `flush` and `_debouncedFlush`. Otherwise, there could be
   * cases of multiple flushes happening closely together.
   */
  flushImmediate() {
    return this._debouncedFlush(), this._debouncedFlush.flush();
  }
  /**
   * Cancels queued up flushes.
   */
  cancelFlush() {
    this._debouncedFlush.cancel();
  }
  /** Get the current session (=replay) ID */
  getSessionId() {
    var t;
    return (t = this.session) == null ? void 0 : t.id;
  }
  /**
   * Checks if recording should be stopped due to user inactivity. Otherwise
   * check if session is expired and create a new session if so. Triggers a new
   * full snapshot on new session.
   *
   * Returns true if session is not expired, false otherwise.
   * @hidden
   */
  checkAndHandleExpiredSession() {
    if (this._lastActivity && zv(this._lastActivity, this.timeouts.sessionIdlePause) && this.session && this.session.sampled === "session") {
      this.pause();
      return;
    }
    return !!this._checkSession();
  }
  /**
   * Capture some initial state that can change throughout the lifespan of the
   * replay. This is required because otherwise they would be captured at the
   * first flush.
   */
  setInitialState() {
    const t = `${ga.location.pathname}${ga.location.hash}${ga.location.search}`, s = `${ga.location.origin}${t}`;
    this.performanceEntries = [], this.replayPerformanceEntries = [], this._clearContext(), this._context.initialUrl = s, this._context.initialTimestamp = Date.now(), this._context.urls.push(s);
  }
  /**
   * Add a breadcrumb event, that may be throttled.
   * If it was throttled, we add a custom breadcrumb to indicate that.
   */
  throttledAddEvent(t, s) {
    const n = this._throttledAddEvent(t, s);
    if (n === a4) {
      const r = Nr({
        category: "replay.throttled"
      });
      this.addUpdate(() => !G1(this, {
        type: dV,
        timestamp: r.timestamp || 0,
        data: {
          tag: "breadcrumb",
          payload: r,
          metric: !0
        }
      }));
    }
    return n;
  }
  /**
   * This will get the parametrized route name of the current page.
   * This is only available if performance is enabled, and if an instrumented router is used.
   */
  getCurrentRoute() {
    const t = this.lastActiveSpan || Ja(), s = t && Wa(t), r = (s && ms(s).data || {})[Tn];
    if (!(!s || !r || !["route", "custom"].includes(r)))
      return ms(s).description;
  }
  /**
   * Initialize and start all listeners to varying events (DOM,
   * Performance Observer, Recording, Sentry SDK, etc)
   */
  _initializeRecording() {
    this.setInitialState(), this._updateSessionActivity(), this.eventBuffer = ZV({
      useCompression: this._options.useCompression,
      workerUrl: this._options.workerUrl
    }), this._removeListeners(), this._addListeners(), this._isEnabled = !0, this._isPaused = !1, this.startRecording();
  }
  /**
   * Loads (or refreshes) the current session.
   */
  _initializeSessionForSampling(t) {
    const s = this._options.errorSampleRate > 0, n = tg(
      {
        sessionIdleExpire: this.timeouts.sessionIdleExpire,
        maxReplayDuration: this._options.maxReplayDuration,
        previousSessionId: t
      },
      {
        stickySession: this._options.stickySession,
        sessionSampleRate: this._options.sessionSampleRate,
        allowBuffering: s
      }
    );
    this.session = n;
  }
  /**
   * Checks and potentially refreshes the current session.
   * Returns false if session is not recorded.
   */
  _checkSession() {
    if (!this.session)
      return !1;
    const t = this.session;
    return X8(t, {
      sessionIdleExpire: this.timeouts.sessionIdleExpire,
      maxReplayDuration: this._options.maxReplayDuration
    }) ? (this._refreshSession(t), !1) : !0;
  }
  /**
   * Refresh a session with a new one.
   * This stops the current session (without forcing a flush, as that would never work since we are expired),
   * and then does a new sampling based on the refreshed session.
   */
  async _refreshSession(t) {
    this._isEnabled && (await this.stop({ reason: "refresh session" }), this.initializeSampling(t.id));
  }
  /**
   * Adds listeners to record events for the replay
   */
  _addListeners() {
    try {
      ga.document.addEventListener("visibilitychange", this._handleVisibilityChange), ga.addEventListener("blur", this._handleWindowBlur), ga.addEventListener("focus", this._handleWindowFocus), ga.addEventListener("keydown", this._handleKeyboardEvent), this.clickDetector && this.clickDetector.addListeners(), this._hasInitializedCoreListeners || (ZD(this, { autoFlushOnFeedback: this._options._experiments.autoFlushOnFeedback }), this._hasInitializedCoreListeners = !0);
    } catch (t) {
      this.handleException(t);
    }
    this._performanceCleanupCallback = WV(this);
  }
  /**
   * Cleans up listeners that were created in `_addListeners`
   */
  _removeListeners() {
    try {
      ga.document.removeEventListener("visibilitychange", this._handleVisibilityChange), ga.removeEventListener("blur", this._handleWindowBlur), ga.removeEventListener("focus", this._handleWindowFocus), ga.removeEventListener("keydown", this._handleKeyboardEvent), this.clickDetector && this.clickDetector.removeListeners(), this._performanceCleanupCallback && this._performanceCleanupCallback();
    } catch (t) {
      this.handleException(t);
    }
  }
  /**
   * Tasks to run when we consider a page to be hidden (via blurring and/or visibility)
   */
  _doChangeToBackgroundTasks(t) {
    !this.session || Y8(this.session, {
      maxReplayDuration: this._options.maxReplayDuration,
      sessionIdleExpire: this.timeouts.sessionIdleExpire
    }) || (t && this._createCustomBreadcrumb(t), this.conditionalFlush());
  }
  /**
   * Tasks to run when we consider a page to be visible (via focus and/or visibility)
   */
  _doChangeToForegroundTasks(t) {
    if (!this.session)
      return;
    if (!this.checkAndHandleExpiredSession()) {
      Jt && $t.log("Document has become active, but session has expired");
      return;
    }
    t && this._createCustomBreadcrumb(t);
  }
  /**
   * Update user activity (across session lifespans)
   */
  _updateUserActivity(t = Date.now()) {
    this._lastActivity = t;
  }
  /**
   * Updates the session's last activity timestamp
   */
  _updateSessionActivity(t = Date.now()) {
    this.session && (this.session.lastActivity = t, this._maybeSaveSession());
  }
  /**
   * Helper to create (and buffer) a replay breadcrumb from a core SDK breadcrumb
   */
  _createCustomBreadcrumb(t) {
    this.addUpdate(() => {
      this.throttledAddEvent({
        type: ps.Custom,
        timestamp: t.timestamp || 0,
        data: {
          tag: "breadcrumb",
          payload: t
        }
      });
    });
  }
  /**
   * Observed performance events are added to `this.performanceEntries`. These
   * are included in the replay event before it is finished and sent to Sentry.
   */
  _addPerformanceEntries() {
    let t = MV(this.performanceEntries).concat(this.replayPerformanceEntries);
    if (this.performanceEntries = [], this.replayPerformanceEntries = [], this._requiresManualStart) {
      const s = this._context.initialTimestamp / 1e3;
      t = t.filter((n) => n.start >= s);
    }
    return Promise.all(_m(this, t));
  }
  /**
   * Clear _context
   */
  _clearContext() {
    this._context.errorIds.clear(), this._context.traceIds.clear(), this._context.urls = [];
  }
  /** Update the initial timestamp based on the buffer content. */
  _updateInitialTimestampFromEventBuffer() {
    const { session: t, eventBuffer: s } = this;
    if (!t || !s || this._requiresManualStart || t.segmentId)
      return;
    const n = s.getEarliestTimestamp();
    n && n < this._context.initialTimestamp && (this._context.initialTimestamp = n);
  }
  /**
   * Return and clear _context
   */
  _popEventContext() {
    const t = {
      initialTimestamp: this._context.initialTimestamp,
      initialUrl: this._context.initialUrl,
      errorIds: Array.from(this._context.errorIds),
      traceIds: Array.from(this._context.traceIds),
      urls: this._context.urls
    };
    return this._clearContext(), t;
  }
  /**
   * Flushes replay event buffer to Sentry.
   *
   * Performance events are only added right before flushing - this is
   * due to the buffered performance observer events.
   *
   * Should never be called directly, only by `flush`
   */
  async _runFlush() {
    var s;
    const t = this.getSessionId();
    if (!this.session || !this.eventBuffer || !t) {
      Jt && $t.error("No session or eventBuffer found to flush.");
      return;
    }
    if (await this._addPerformanceEntries(), !!((s = this.eventBuffer) != null && s.hasEvents) && (await JD(this), !!this.eventBuffer && t === this.getSessionId()))
      try {
        this._updateInitialTimestampFromEventBuffer();
        const n = Date.now();
        if (n - this._context.initialTimestamp > this._options.maxReplayDuration + 3e4)
          throw new Error("Session is too long, not sending replay");
        const r = this._popEventContext(), i = this.session.segmentId++;
        this._maybeSaveSession();
        const o = await this.eventBuffer.finish();
        await s4({
          replayId: t,
          recordingData: o,
          segmentId: i,
          eventContext: r,
          session: this.session,
          timestamp: n,
          onError: (l) => this.handleException(l)
        });
      } catch (n) {
        this.handleException(n), this.stop({ reason: "sendReplay" });
        const r = ds();
        if (r) {
          const i = n instanceof X1 ? "ratelimit_backoff" : "send_error";
          r.recordDroppedEvent(i, "replay");
        }
      }
  }
  /**
   * Flush recording data to Sentry. Creates a lock so that only a single flush
   * can be active at a time. Do not call this directly.
   */
  async _flush({
    force: t = !1
  } = {}) {
    if (!this._isEnabled && !t)
      return;
    if (!this.checkAndHandleExpiredSession()) {
      Jt && $t.error("Attempting to finish replay event after session expired.");
      return;
    }
    if (!this.session)
      return;
    const s = this.session.started, r = Date.now() - s;
    this._debouncedFlush.cancel();
    const i = r < this._options.minReplayDuration, o = r > this._options.maxReplayDuration + 5e3;
    if (i || o) {
      Jt && $t.log(
        `Session duration (${Math.floor(r / 1e3)}s) is too ${i ? "short" : "long"}, not sending replay.`
      ), i && this._debouncedFlush();
      return;
    }
    const l = this.eventBuffer;
    l && this.session.segmentId === 0 && !l.hasCheckout && Jt && $t.log("Flushing initial segment without checkout.");
    const d = !!this._flushLock;
    this._flushLock || (this._flushLock = this._runFlush());
    try {
      await this._flushLock;
    } catch (c) {
      this.handleException(c);
    } finally {
      this._flushLock = void 0, d && this._debouncedFlush();
    }
  }
  /** Save the session, if it is sticky */
  _maybeSaveSession() {
    this.session && this._options.stickySession && W1(this.session);
  }
  /** Handler for rrweb.record.onMutation */
  _onMutationHandler(t) {
    const { ignoreMutations: s } = this._options._experiments;
    if (s != null && s.length && t.some((l) => {
      const d = nN(l.target), c = s.join(",");
      return d == null ? void 0 : d.matches(c);
    }))
      return !1;
    const n = t.length, r = this._options.mutationLimit, i = this._options.mutationBreadcrumbLimit, o = r && n > r;
    if (n > i || o) {
      const l = Nr({
        category: "replay.mutations",
        data: {
          count: n,
          limit: o
        }
      });
      this._createCustomBreadcrumb(l);
    }
    return o ? (this.stop({ reason: "mutationLimit", forceFlush: this.recordingMode === "session" }), !1) : !0;
  }
}
function _d(e, t) {
  return [
    ...e,
    // sentry defaults
    ...t
  ].join(",");
}
function pN({ mask: e, unmask: t, block: s, unblock: n, ignore: r }) {
  const i = ["base", "iframe[srcdoc]:not([src])"], o = _d(e, [".sentry-mask", "[data-sentry-mask]"]), l = _d(t, []);
  return {
    // We are making the decision to make text and input selectors the same
    maskTextSelector: o,
    unmaskTextSelector: l,
    blockSelector: _d(s, [".sentry-block", "[data-sentry-block]", ...i]),
    unblockSelector: _d(n, []),
    ignoreSelector: _d(r, [".sentry-ignore", "[data-sentry-ignore]", 'input[type="file"]'])
  };
}
function hN({
  el: e,
  key: t,
  maskAttributes: s,
  maskAllText: n,
  privacyOptions: r,
  value: i
}) {
  return !n || r.unmaskTextSelector && e.matches(r.unmaskTextSelector) ? i : s.includes(t) || // Need to mask `value` attribute for `<input>` if it's a button-like
  // type
  t === "value" && e.tagName === "INPUT" && ["submit", "button"].includes(e.getAttribute("type") || "") ? i.replace(/[\S]/g, "*") : i;
}
const ew = 'img,image,svg,video,object,picture,embed,map,audio,link[rel="icon"],link[rel="apple-touch-icon"]', mN = ["content-length", "content-type", "accept"];
let tw = !1;
const fN = (e) => new gN(e);
class gN {
  /**
   * @inheritDoc
   */
  /**
   * Options to pass to `rrweb.record()`
   */
  /**
   * Initial options passed to the replay integration, merged with default values.
   * Note: `sessionSampleRate` and `errorSampleRate` are not required here, as they
   * can only be finally set when setupOnce() is called.
   *
   * @private
   */
  constructor({
    flushMinDelay: t = Ux,
    flushMaxDelay: s = zx,
    minReplayDuration: n = Qx,
    maxReplayDuration: r = M0,
    stickySession: i = !0,
    useCompression: o = !0,
    workerUrl: l,
    _experiments: d = {},
    maskAllText: c = !0,
    maskAllInputs: u = !0,
    blockAllMedia: m = !0,
    mutationBreadcrumbLimit: f = 750,
    mutationLimit: v = 1e4,
    slowClickTimeout: b = 7e3,
    slowClickIgnoreSelectors: w = [],
    networkDetailAllowUrls: S = [],
    networkDetailDenyUrls: I = [],
    networkCaptureBodies: T = !0,
    networkRequestHeaders: x = [],
    networkResponseHeaders: k = [],
    mask: C = [],
    maskAttributes: O = ["title", "placeholder", "aria-label"],
    unmask: E = [],
    block: B = [],
    unblock: M = [],
    ignore: R = [],
    maskFn: F,
    beforeAddRecordingEvent: L,
    beforeErrorSampling: j,
    onError: H
  } = {}) {
    this.name = "Replay";
    const te = pN({
      mask: C,
      unmask: E,
      block: B,
      unblock: M,
      ignore: R
    });
    if (this._recordingOptions = {
      maskAllInputs: u,
      maskAllText: c,
      maskInputOptions: { password: !0 },
      maskTextFn: F,
      maskInputFn: F,
      maskAttributeFn: (re, le, ie) => hN({
        maskAttributes: O,
        maskAllText: c,
        privacyOptions: te,
        key: re,
        value: le,
        el: ie
      }),
      ...te,
      // Our defaults
      slimDOMOptions: "all",
      inlineStylesheet: !0,
      // Disable inline images as it will increase segment/replay size
      inlineImages: !1,
      // collect fonts, but be aware that `sentry.io` needs to be an allowed
      // origin for playback
      collectFonts: !0,
      errorHandler: (re) => {
        try {
          re.__rrweb__ = !0;
        } catch {
        }
      },
      // experimental support for recording iframes from different origins
      recordCrossOriginIframes: !!d.recordCrossOriginIframes
    }, this._initialOptions = {
      flushMinDelay: t,
      flushMaxDelay: s,
      minReplayDuration: Math.min(n, Kx),
      maxReplayDuration: Math.min(r, M0),
      stickySession: i,
      useCompression: o,
      workerUrl: l,
      blockAllMedia: m,
      maskAllInputs: u,
      maskAllText: c,
      mutationBreadcrumbLimit: f,
      mutationLimit: v,
      slowClickTimeout: b,
      slowClickIgnoreSelectors: w,
      networkDetailAllowUrls: S,
      networkDetailDenyUrls: I,
      networkCaptureBodies: T,
      networkRequestHeaders: sw(x),
      networkResponseHeaders: sw(k),
      beforeAddRecordingEvent: L,
      beforeErrorSampling: j,
      onError: H,
      _experiments: d
    }, this._initialOptions.blockAllMedia && (this._recordingOptions.blockSelector = this._recordingOptions.blockSelector ? `${this._recordingOptions.blockSelector},${ew}` : ew), this._isInitialized && Pv())
      throw new Error("Multiple Sentry Session Replay instances are not supported");
    this._isInitialized = !0;
  }
  /** If replay has already been initialized */
  get _isInitialized() {
    return tw;
  }
  /** Update _isInitialized */
  set _isInitialized(t) {
    tw = t;
  }
  /**
   * Setup and initialize replay container
   */
  afterAllSetup(t) {
    !Pv() || this._replay || (this._setup(t), this._initialize(t));
  }
  /**
   * Start a replay regardless of sampling rate. Calling this will always
   * create a new session. Will log a message if replay is already in progress.
   *
   * Creates or loads a session, attaches listeners to varying events (DOM,
   * PerformanceObserver, Recording, Sentry SDK, etc)
   */
  start() {
    this._replay && this._replay.start();
  }
  /**
   * Start replay buffering. Buffers until `flush()` is called or, if
   * `replaysOnErrorSampleRate` > 0, until an error occurs.
   */
  startBuffering() {
    this._replay && this._replay.startBuffering();
  }
  /**
   * Currently, this needs to be manually called (e.g. for tests). Sentry SDK
   * does not support a teardown
   */
  stop() {
    return this._replay ? this._replay.stop({ forceFlush: this._replay.recordingMode === "session" }) : Promise.resolve();
  }
  /**
   * If not in "session" recording mode, flush event buffer which will create a new replay.
   * If replay is not enabled, a new session replay is started.
   * Unless `continueRecording` is false, the replay will continue to record and
   * behave as a "session"-based replay.
   *
   * Otherwise, queue up a flush.
   */
  flush(t) {
    return this._replay ? this._replay.isEnabled() ? this._replay.sendBufferedReplayOrFlush(t) : (this._replay.start(), Promise.resolve()) : Promise.resolve();
  }
  /**
   * Get the current session ID.
   */
  getReplayId() {
    var t;
    if ((t = this._replay) != null && t.isEnabled())
      return this._replay.getSessionId();
  }
  /**
   * Get the current recording mode. This can be either `session` or `buffer`.
   *
   * `session`: Recording the whole session, sending it continuously
   * `buffer`: Always keeping the last 60s of recording, requires:
   *   - having replaysOnErrorSampleRate > 0 to capture replay when an error occurs
   *   - or calling `flush()` to send the replay
   */
  getRecordingMode() {
    var t;
    if ((t = this._replay) != null && t.isEnabled())
      return this._replay.recordingMode;
  }
  /**
   * Initializes replay.
   */
  _initialize(t) {
    this._replay && (this._maybeLoadFromReplayCanvasIntegration(t), this._replay.initializeSampling());
  }
  /** Setup the integration. */
  _setup(t) {
    const s = vN(this._initialOptions, t);
    this._replay = new uN({
      options: s,
      recordingOptions: this._recordingOptions
    });
  }
  /** Get canvas options from ReplayCanvas integration, if it is also added. */
  _maybeLoadFromReplayCanvasIntegration(t) {
    try {
      const s = t.getIntegrationByName("ReplayCanvas");
      if (!s)
        return;
      this._replay._canvas = s.getOptions();
    } catch {
    }
  }
}
function vN(e, t) {
  const s = t.getOptions(), n = {
    sessionSampleRate: 0,
    errorSampleRate: 0,
    ...e
  }, r = nl(s.replaysSessionSampleRate), i = nl(s.replaysOnErrorSampleRate);
  return r == null && i == null && Yo(() => {
    console.warn(
      "Replay is disabled because neither `replaysSessionSampleRate` nor `replaysOnErrorSampleRate` are set."
    );
  }), r != null && (n.sessionSampleRate = r), i != null && (n.errorSampleRate = i), n;
}
function sw(e) {
  return [...mN, ...e.map((t) => t.toLowerCase())];
}
var yN = Object.defineProperty, bN = (e, t, s) => t in e ? yN(e, t, { enumerable: !0, configurable: !0, writable: !0, value: s }) : e[t] = s, aw = (e, t, s) => bN(e, typeof t != "symbol" ? t + "" : t, s);
class AN {
  constructor() {
    aw(this, "idNodeMap", /* @__PURE__ */ new Map()), aw(this, "nodeMetaMap", /* @__PURE__ */ new WeakMap());
  }
  getId(t) {
    var n;
    return t ? ((n = this.getMeta(t)) == null ? void 0 : n.id) ?? -1 : -1;
  }
  getNode(t) {
    return this.idNodeMap.get(t) || null;
  }
  getIds() {
    return Array.from(this.idNodeMap.keys());
  }
  getMeta(t) {
    return this.nodeMetaMap.get(t) || null;
  }
  // removes the node from idNodeMap
  // doesn't remove the node from nodeMetaMap
  removeNodeFromMap(t) {
    const s = this.getId(t);
    this.idNodeMap.delete(s), t.childNodes && t.childNodes.forEach(
      (n) => this.removeNodeFromMap(n)
    );
  }
  has(t) {
    return this.idNodeMap.has(t);
  }
  hasNode(t) {
    return this.nodeMetaMap.has(t);
  }
  add(t, s) {
    const n = s.id;
    this.idNodeMap.set(n, t), this.nodeMetaMap.set(t, s);
  }
  replace(t, s) {
    const n = this.getNode(t);
    if (n) {
      const r = this.nodeMetaMap.get(n);
      r && this.nodeMetaMap.set(s, r);
    }
    this.idNodeMap.set(t, s);
  }
  reset() {
    this.idNodeMap = /* @__PURE__ */ new Map(), this.nodeMetaMap = /* @__PURE__ */ new WeakMap();
  }
}
function wN() {
  return new AN();
}
function CN(e, t) {
  for (let s = e.classList.length; s--; ) {
    const n = e.classList[s];
    if (t.test(n))
      return !0;
  }
  return !1;
}
function Yv(e, t, s = 1 / 0, n = 0) {
  return !e || e.nodeType !== e.ELEMENT_NODE || n > s ? -1 : t(e) ? n : Yv(e.parentNode, t, s, n + 1);
}
function nw(e, t) {
  return (s) => {
    const n = s;
    if (n === null) return !1;
    try {
      if (e) {
        if (typeof e == "string") {
          if (n.matches(`.${e}`)) return !0;
        } else if (CN(n, e))
          return !0;
      }
      return !!(t && n.matches(t));
    } catch {
      return !1;
    }
  };
}
const zl = `Please stop import mirror directly. Instead of that,\r
now you can use replayer.getMirror() to access the mirror instance of a replayer,\r
or you can use record.mirror to access the mirror instance during recording.`;
let rw = {
  map: {},
  getId() {
    return console.error(zl), -1;
  },
  getNode() {
    return console.error(zl), null;
  },
  removeNodeFromMap() {
    console.error(zl);
  },
  has() {
    return console.error(zl), !1;
  },
  reset() {
    console.error(zl);
  }
};
typeof window < "u" && window.Proxy && window.Reflect && (rw = new Proxy(rw, {
  get(e, t, s) {
    return t === "map" && console.error(zl), Reflect.get(e, t, s);
  }
}));
function q1(e, t, s, n, r = window) {
  const i = r.Object.getOwnPropertyDescriptor(e, t);
  return r.Object.defineProperty(
    e,
    t,
    n ? s : {
      set(o) {
        r4(() => {
          s.set.call(this, o);
        }, 0), i && i.set && i.set.call(this, o);
      }
    }
  ), () => q1(e, t, i || {}, !0);
}
function Q1(e, t, s) {
  try {
    if (!(t in e))
      return () => {
      };
    const n = e[t], r = s(n);
    return typeof r == "function" && (r.prototype = r.prototype || {}, Object.defineProperties(r, {
      __rrweb_original__: {
        enumerable: !1,
        value: n
      }
    })), e[t] = r, () => {
      e[t] = n;
    };
  } catch {
    return () => {
    };
  }
}
Date.now().toString();
function SN(e) {
  if (!e)
    return null;
  try {
    return e.nodeType === e.ELEMENT_NODE ? e : e.parentElement;
  } catch {
    return null;
  }
}
function tf(e, t, s, n, r) {
  if (!e)
    return !1;
  const i = SN(e);
  if (!i)
    return !1;
  const o = nw(t, s), l = Yv(i, o);
  let d = -1;
  return l < 0 ? !1 : (n && (d = Yv(
    i,
    nw(null, n)
  )), l > -1 && d < 0 ? !0 : l < d);
}
const ow = {};
function n4(e) {
  const t = ow[e];
  if (t)
    return t;
  const s = window.document;
  let n = window[e];
  if (s && typeof s.createElement == "function")
    try {
      const r = s.createElement("iframe");
      r.hidden = !0, s.head.appendChild(r);
      const i = r.contentWindow;
      i && i[e] && (n = // eslint-disable-next-line @typescript-eslint/unbound-method
      i[e]), s.head.removeChild(r);
    } catch {
    }
  return ow[e] = n.bind(
    window
  );
}
function Fi(...e) {
  return n4("requestAnimationFrame")(...e);
}
function r4(...e) {
  return n4("setTimeout")(...e);
}
var Id = /* @__PURE__ */ ((e) => (e[e["2D"] = 0] = "2D", e[e.WebGL = 1] = "WebGL", e[e.WebGL2 = 2] = "WebGL2", e))(Id || {});
let hh;
function PN(e) {
  hh = e;
}
const sg = (e) => hh ? (...s) => {
  try {
    return e(...s);
  } catch (n) {
    if (hh && hh(n) === !0)
      return () => {
      };
    throw n;
  }
} : e;
var _l = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", kN = typeof Uint8Array > "u" ? [] : new Uint8Array(256);
for (var Ap = 0; Ap < _l.length; Ap++)
  kN[_l.charCodeAt(Ap)] = Ap;
var EN = function(e) {
  var t = new Uint8Array(e), s, n = t.length, r = "";
  for (s = 0; s < n; s += 3)
    r += _l[t[s] >> 2], r += _l[(t[s] & 3) << 4 | t[s + 1] >> 4], r += _l[(t[s + 1] & 15) << 2 | t[s + 2] >> 6], r += _l[t[s + 2] & 63];
  return n % 3 === 2 ? r = r.substring(0, r.length - 1) + "=" : n % 3 === 1 && (r = r.substring(0, r.length - 2) + "=="), r;
};
const iw = /* @__PURE__ */ new Map();
function IN(e, t) {
  let s = iw.get(e);
  return s || (s = /* @__PURE__ */ new Map(), iw.set(e, s)), s.has(t) || s.set(t, []), s.get(t);
}
const o4 = (e, t, s) => {
  if (!e || !(l4(e, t) || typeof e == "object"))
    return;
  const n = e.constructor.name, r = IN(s, n);
  let i = r.indexOf(e);
  return i === -1 && (i = r.length, r.push(e)), i;
};
function mh(e, t, s) {
  if (e instanceof Array)
    return e.map((n) => mh(n, t, s));
  if (e === null)
    return e;
  if (e instanceof Float32Array || e instanceof Float64Array || e instanceof Int32Array || e instanceof Uint32Array || e instanceof Uint8Array || e instanceof Uint16Array || e instanceof Int16Array || e instanceof Int8Array || e instanceof Uint8ClampedArray)
    return {
      rr_type: e.constructor.name,
      args: [Object.values(e)]
    };
  if (
    // SharedArrayBuffer disabled on most browsers due to spectre.
    // More info: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/SharedArrayBuffer/SharedArrayBuffer
    // value instanceof SharedArrayBuffer ||
    e instanceof ArrayBuffer
  ) {
    const n = e.constructor.name, r = EN(e);
    return {
      rr_type: n,
      base64: r
    };
  } else {
    if (e instanceof DataView)
      return {
        rr_type: e.constructor.name,
        args: [
          mh(e.buffer, t, s),
          e.byteOffset,
          e.byteLength
        ]
      };
    if (e instanceof HTMLImageElement) {
      const n = e.constructor.name, { src: r } = e;
      return {
        rr_type: n,
        src: r
      };
    } else if (e instanceof HTMLCanvasElement) {
      const n = "HTMLImageElement", r = e.toDataURL();
      return {
        rr_type: n,
        src: r
      };
    } else {
      if (e instanceof ImageData)
        return {
          rr_type: e.constructor.name,
          args: [mh(e.data, t, s), e.width, e.height]
        };
      if (l4(e, t) || typeof e == "object") {
        const n = e.constructor.name, r = o4(e, t, s);
        return {
          rr_type: n,
          index: r
        };
      }
    }
  }
  return e;
}
const i4 = (e, t, s) => e.map((n) => mh(n, t, s)), l4 = (e, t) => !![
  "WebGLActiveInfo",
  "WebGLBuffer",
  "WebGLFramebuffer",
  "WebGLProgram",
  "WebGLRenderbuffer",
  "WebGLShader",
  "WebGLShaderPrecisionFormat",
  "WebGLTexture",
  "WebGLUniformLocation",
  "WebGLVertexArrayObject",
  // In old Chrome versions, value won't be an instanceof WebGLVertexArrayObject.
  "WebGLVertexArrayObjectOES"
].filter(
  (r) => typeof t[r] == "function"
).find(
  (r) => e instanceof t[r]
);
function TN(e, t, s, n, r) {
  const i = [], o = Object.getOwnPropertyNames(
    t.CanvasRenderingContext2D.prototype
  );
  for (const l of o)
    try {
      if (typeof t.CanvasRenderingContext2D.prototype[l] != "function")
        continue;
      const d = Q1(
        t.CanvasRenderingContext2D.prototype,
        l,
        function(c) {
          return function(...u) {
            return tf(
              this.canvas,
              s,
              n,
              r,
              !0
            ) || r4(() => {
              const m = i4(u, t, this);
              e(this.canvas, {
                type: Id["2D"],
                property: l,
                args: m
              });
            }, 0), c.apply(this, u);
          };
        }
      );
      i.push(d);
    } catch {
      const d = q1(
        t.CanvasRenderingContext2D.prototype,
        l,
        {
          set(c) {
            e(this.canvas, {
              type: Id["2D"],
              property: l,
              args: [c],
              setter: !0
            });
          }
        }
      );
      i.push(d);
    }
  return () => {
    i.forEach((l) => l());
  };
}
function ON(e) {
  return e === "experimental-webgl" ? "webgl" : e;
}
function lw(e, t, s, n, r) {
  const i = [];
  try {
    const o = Q1(
      e.HTMLCanvasElement.prototype,
      "getContext",
      function(l) {
        return function(d, ...c) {
          if (!tf(this, t, s, n, !0)) {
            const u = ON(d);
            if ("__context" in this || (this.__context = u), r && ["webgl", "webgl2"].includes(u))
              if (c[0] && typeof c[0] == "object") {
                const m = c[0];
                m.preserveDrawingBuffer || (m.preserveDrawingBuffer = !0);
              } else
                c.splice(0, 1, {
                  preserveDrawingBuffer: !0
                });
          }
          return l.apply(this, [d, ...c]);
        };
      }
    );
    i.push(o);
  } catch {
    console.error("failed to patch HTMLCanvasElement.prototype.getContext");
  }
  return () => {
    i.forEach((o) => o());
  };
}
function dw(e, t, s, n, r, i, o, l) {
  const d = [], c = Object.getOwnPropertyNames(e);
  for (const u of c)
    if (
      //prop.startsWith('get') ||  // e.g. getProgramParameter, but too risky
      ![
        "isContextLost",
        "canvas",
        "drawingBufferWidth",
        "drawingBufferHeight"
      ].includes(u)
    )
      try {
        if (typeof e[u] != "function")
          continue;
        const m = Q1(
          e,
          u,
          function(f) {
            return function(...v) {
              const b = f.apply(this, v);
              if (o4(b, l, this), "tagName" in this.canvas && !tf(
                this.canvas,
                n,
                r,
                i,
                !0
              )) {
                const w = i4(v, l, this), S = {
                  type: t,
                  property: u,
                  args: w
                };
                s(this.canvas, S);
              }
              return b;
            };
          }
        );
        d.push(m);
      } catch {
        const m = q1(e, u, {
          set(f) {
            s(this.canvas, {
              type: t,
              property: u,
              args: [f],
              setter: !0
            });
          }
        });
        d.push(m);
      }
  return d;
}
function RN(e, t, s, n, r, i) {
  const o = [];
  return o.push(
    ...dw(
      t.WebGLRenderingContext.prototype,
      Id.WebGL,
      e,
      s,
      n,
      r,
      i,
      t
    )
  ), typeof t.WebGL2RenderingContext < "u" && o.push(
    ...dw(
      t.WebGL2RenderingContext.prototype,
      Id.WebGL2,
      e,
      s,
      n,
      r,
      i,
      t
    )
  ), () => {
    o.forEach((l) => l());
  };
}
const LN = 'for(var e="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",t="undefined"==typeof Uint8Array?[]:new Uint8Array(256),a=0;a<64;a++)t[e.charCodeAt(a)]=a;var n=function(t){var a,n=new Uint8Array(t),r=n.length,s="";for(a=0;a<r;a+=3)s+=e[n[a]>>2],s+=e[(3&n[a])<<4|n[a+1]>>4],s+=e[(15&n[a+1])<<2|n[a+2]>>6],s+=e[63&n[a+2]];return r%3==2?s=s.substring(0,s.length-1)+"=":r%3==1&&(s=s.substring(0,s.length-2)+"=="),s};const r=new Map,s=new Map;const i=self;i.onmessage=async function(e){if(!("OffscreenCanvas"in globalThis))return i.postMessage({id:e.data.id});{const{id:t,bitmap:a,width:o,height:f,maxCanvasSize:c,dataURLOptions:g}=e.data,u=async function(e,t,a){const r=e+"-"+t;if("OffscreenCanvas"in globalThis){if(s.has(r))return s.get(r);const i=new OffscreenCanvas(e,t);i.getContext("2d");const o=await i.convertToBlob(a),f=await o.arrayBuffer(),c=n(f);return s.set(r,c),c}return""}(o,f,g),[h,d]=function(e,t,a){if(!a)return[e,t];const[n,r]=a;if(e<=n&&t<=r)return[e,t];let s=e,i=t;return s>n&&(i=Math.floor(n*t/e),s=n),i>r&&(s=Math.floor(r*e/t),i=r),[s,i]}(o,f,c),l=new OffscreenCanvas(h,d),w=l.getContext("bitmaprenderer"),p=h===o&&d===f?a:await createImageBitmap(a,{resizeWidth:h,resizeHeight:d,resizeQuality:"low"});w.transferFromImageBitmap(p),a.close();const y=await l.convertToBlob(g),v=y.type,b=await y.arrayBuffer(),m=n(b);if(p.close(),!r.has(t)&&await u===m)return r.set(t,m),i.postMessage({id:t});if(r.get(t)===m)return i.postMessage({id:t});i.postMessage({id:t,type:v,base64:m,width:o,height:f}),r.set(t,m)}};';
function BN() {
  const e = new Blob([LN]);
  return URL.createObjectURL(e);
}
class MN {
  constructor(t) {
    this.pendingCanvasMutations = /* @__PURE__ */ new Map(), this.rafStamps = { latestId: 0, invokeId: null }, this.shadowDoms = /* @__PURE__ */ new Set(), this.windowsSet = /* @__PURE__ */ new WeakSet(), this.windows = [], this.restoreHandlers = [], this.frozen = !1, this.locked = !1, this.snapshotInProgressMap = /* @__PURE__ */ new Map(), this.worker = null, this.lastSnapshotTime = 0, this.processMutation = (m, f) => {
      (this.rafStamps.invokeId && this.rafStamps.latestId !== this.rafStamps.invokeId || !this.rafStamps.invokeId) && (this.rafStamps.invokeId = this.rafStamps.latestId), this.pendingCanvasMutations.has(m) || this.pendingCanvasMutations.set(m, []), this.pendingCanvasMutations.get(m).push(f);
    };
    const {
      sampling: s = "all",
      win: n,
      blockClass: r,
      blockSelector: i,
      unblockSelector: o,
      maxCanvasSize: l,
      recordCanvas: d,
      dataURLOptions: c,
      errorHandler: u
    } = t;
    this.mutationCb = t.mutationCb, this.mirror = t.mirror, this.options = t, u && PN(u), (d && typeof s == "number" || t.enableManualSnapshot) && (this.worker = this.initFPSWorker()), this.addWindow(n), !t.enableManualSnapshot && sg(() => {
      d && s === "all" && (this.startRAFTimestamping(), this.startPendingCanvasMutationFlusher()), d && typeof s == "number" && this.initCanvasFPSObserver(
        s,
        r,
        i,
        o,
        l,
        {
          dataURLOptions: c
        }
      );
    })();
  }
  reset() {
    var t;
    this.pendingCanvasMutations.clear(), this.restoreHandlers.forEach((s) => {
      try {
        s();
      } catch {
      }
    }), this.restoreHandlers = [], this.windowsSet = /* @__PURE__ */ new WeakSet(), this.windows = [], this.shadowDoms = /* @__PURE__ */ new Set(), (t = this.worker) == null || t.terminate(), this.worker = null, this.snapshotInProgressMap = /* @__PURE__ */ new Map();
  }
  freeze() {
    this.frozen = !0;
  }
  unfreeze() {
    this.frozen = !1;
  }
  lock() {
    this.locked = !0;
  }
  unlock() {
    this.locked = !1;
  }
  addWindow(t) {
    const {
      sampling: s = "all",
      blockClass: n,
      blockSelector: r,
      unblockSelector: i,
      recordCanvas: o,
      enableManualSnapshot: l
    } = this.options;
    if (!this.windowsSet.has(t)) {
      if (l) {
        this.windowsSet.add(t), this.windows.push(new WeakRef(t));
        return;
      }
      sg(() => {
        if (o && s === "all" && this.initCanvasMutationObserver(
          t,
          n,
          r,
          i
        ), o && typeof s == "number") {
          const d = lw(
            t,
            n,
            r,
            i,
            !0
          );
          this.restoreHandlers.push(() => {
            d();
          });
        }
      })(), this.windowsSet.add(t), this.windows.push(new WeakRef(t));
    }
  }
  addShadowRoot(t) {
    this.shadowDoms.add(new WeakRef(t));
  }
  resetShadowRoots() {
    this.shadowDoms = /* @__PURE__ */ new Set();
  }
  initFPSWorker() {
    const t = new Worker(BN());
    return t.onmessage = (s) => {
      const n = s.data, { id: r } = n;
      if (this.snapshotInProgressMap.set(r, !1), !("base64" in n)) return;
      const { base64: i, type: o, width: l, height: d } = n;
      this.mutationCb({
        id: r,
        type: Id["2D"],
        commands: [
          {
            property: "clearRect",
            // wipe canvas
            args: [0, 0, l, d]
          },
          {
            property: "drawImage",
            // draws (semi-transparent) image
            args: [
              {
                rr_type: "ImageBitmap",
                args: [
                  {
                    rr_type: "Blob",
                    data: [{ rr_type: "ArrayBuffer", base64: i }],
                    type: o
                  }
                ]
              },
              0,
              0,
              // The below args are needed if we enforce a max size, we want to
              // retain the original size when drawing the image (which should be smaller)
              l,
              d
            ]
          }
        ]
      });
    }, t;
  }
  initCanvasFPSObserver(t, s, n, r, i, o) {
    const l = this.takeSnapshot(
      !1,
      t,
      s,
      n,
      r,
      i,
      o.dataURLOptions
    );
    this.restoreHandlers.push(() => {
      cancelAnimationFrame(l);
    });
  }
  initCanvasMutationObserver(t, s, n, r) {
    const i = lw(
      t,
      s,
      n,
      r,
      !1
    ), o = TN(
      this.processMutation.bind(this),
      t,
      s,
      n,
      r
    ), l = RN(
      this.processMutation.bind(this),
      t,
      s,
      n,
      r,
      this.mirror
    );
    this.restoreHandlers.push(() => {
      i(), o(), l();
    });
  }
  snapshot(t) {
    const { options: s } = this, n = this.takeSnapshot(
      !0,
      s.sampling === "all" ? 2 : s.sampling || 2,
      s.blockClass,
      s.blockSelector,
      s.unblockSelector,
      s.maxCanvasSize,
      s.dataURLOptions,
      t
    );
    this.restoreHandlers.push(() => {
      cancelAnimationFrame(n);
    });
  }
  takeSnapshot(t, s, n, r, i, o, l, d) {
    const c = 1e3 / s;
    let u;
    const m = (v) => {
      if (v)
        return [v];
      const b = [], w = (S) => {
        S.querySelectorAll("canvas").forEach((I) => {
          tf(I, n, r, i) || b.push(I);
        });
      };
      for (const S of this.windows) {
        const I = S.deref();
        let T;
        try {
          T = I && I.document;
        } catch {
        }
        T && w(T);
      }
      for (const S of this.shadowDoms) {
        const I = S.deref();
        I && w(I);
      }
      return b;
    }, f = (v) => {
      if (this.windows.length) {
        if (this.lastSnapshotTime && v - this.lastSnapshotTime < c) {
          u = Fi(f);
          return;
        }
        this.lastSnapshotTime = v, m(d).forEach((b) => {
          var S;
          if (!this.mirror.hasNode(b))
            return;
          const w = this.mirror.getId(b);
          if (!this.snapshotInProgressMap.get(w) && !(!b.width || !b.height)) {
            if (this.snapshotInProgressMap.set(w, !0), !t && ["webgl", "webgl2"].includes(b.__context)) {
              const I = b.getContext(b.__context);
              ((S = I == null ? void 0 : I.getContextAttributes()) == null ? void 0 : S.preserveDrawingBuffer) === !1 && I.clear(I.COLOR_BUFFER_BIT);
            }
            createImageBitmap(b).then((I) => {
              var T;
              (T = this.worker) == null || T.postMessage(
                {
                  id: w,
                  bitmap: I,
                  width: b.width,
                  height: b.height,
                  dataURLOptions: l,
                  maxCanvasSize: o
                },
                [I]
              );
            }).catch((I) => {
              sg(() => {
                throw I;
              })();
            });
          }
        }), t || (u = Fi(f));
      }
    };
    return u = Fi(f), u;
  }
  startPendingCanvasMutationFlusher() {
    Fi(() => this.flushPendingCanvasMutations());
  }
  startRAFTimestamping() {
    const t = (s) => {
      this.rafStamps.latestId = s, Fi(t);
    };
    Fi(t);
  }
  flushPendingCanvasMutations() {
    this.pendingCanvasMutations.forEach(
      (t, s) => {
        const n = this.mirror.getId(s);
        this.flushPendingCanvasMutationFor(s, n);
      }
    ), Fi(() => this.flushPendingCanvasMutations());
  }
  flushPendingCanvasMutationFor(t, s) {
    if (this.frozen || this.locked)
      return;
    const n = this.pendingCanvasMutations.get(t);
    if (!n || s === -1) return;
    const r = n.map((o) => {
      const { type: l, ...d } = o;
      return d;
    }), { type: i } = n[0];
    this.mutationCb({ id: s, type: i, commands: r }), this.pendingCanvasMutations.delete(t);
  }
}
var _S;
try {
  if (Array.from([1], (e) => e * 2)[0] !== 2) {
    const e = document.createElement("iframe");
    document.body.appendChild(e), Array.from = ((_S = e.contentWindow) == null ? void 0 : _S.Array.from) || Array.from, document.body.removeChild(e);
  }
} catch (e) {
  console.debug("Unable to override Array.from", e);
}
wN();
var cw;
(function(e) {
  e[e.NotStarted = 0] = "NotStarted", e[e.Running = 1] = "Running", e[e.Stopped = 2] = "Stopped";
})(cw || (cw = {}));
const uw = {
  low: {
    sampling: {
      canvas: 1
    },
    dataURLOptions: {
      type: "image/webp",
      quality: 0.25
    }
  },
  medium: {
    sampling: {
      canvas: 2
    },
    dataURLOptions: {
      type: "image/webp",
      quality: 0.4
    }
  },
  high: {
    sampling: {
      canvas: 4
    },
    dataURLOptions: {
      type: "image/webp",
      quality: 0.5
    }
  }
}, xN = "ReplayCanvas", wp = 1280, FN = (e = {}) => {
  const [t, s] = e.maxCanvasSize || [], n = {
    quality: e.quality || "medium",
    enableManualSnapshot: e.enableManualSnapshot,
    maxCanvasSize: [
      t ? Math.min(t, wp) : wp,
      s ? Math.min(s, wp) : wp
    ]
  };
  let r;
  const i = new Promise((o) => r = o);
  return {
    name: xN,
    getOptions() {
      const { quality: o, enableManualSnapshot: l, maxCanvasSize: d } = n;
      return {
        enableManualSnapshot: l,
        recordCanvas: !0,
        getCanvasManager: (c) => {
          const u = new MN({
            ...c,
            enableManualSnapshot: l,
            maxCanvasSize: d,
            errorHandler: (m) => {
              try {
                typeof m == "object" && (m.__rrweb__ = !0);
              } catch {
              }
            }
          });
          return r(u), u;
        },
        ...uw[o] || uw.medium
      };
    },
    async snapshot(o) {
      (await i).snapshot(o);
    }
  };
}, VN = FN;
function wr(e = 0) {
  return ((on() || performance.timeOrigin) + e) / 1e3;
}
function DN(e) {
  const t = [];
  if (e.nextHopProtocol != null) {
    const { name: s, version: n } = a8(e.nextHopProtocol);
    t.push(["network.protocol.version", n], ["network.protocol.name", s]);
  }
  return on() ? [
    ...t,
    ["http.request.redirect_start", wr(e.redirectStart)],
    ["http.request.fetch_start", wr(e.fetchStart)],
    ["http.request.domain_lookup_start", wr(e.domainLookupStart)],
    ["http.request.domain_lookup_end", wr(e.domainLookupEnd)],
    ["http.request.connect_start", wr(e.connectStart)],
    ["http.request.secure_connection_start", wr(e.secureConnectionStart)],
    ["http.request.connection_end", wr(e.connectEnd)],
    ["http.request.request_start", wr(e.requestStart)],
    ["http.request.response_start", wr(e.responseStart)],
    ["http.request.response_end", wr(e.responseEnd)]
  ] : t;
}
const pw = /* @__PURE__ */ new WeakMap(), ag = /* @__PURE__ */ new Map(), d4 = {
  traceFetch: !0,
  traceXHR: !0,
  enableHTTPTimings: !0,
  trackFetchStreamPerformance: !1
};
function NN(e, t) {
  const {
    traceFetch: s,
    traceXHR: n,
    trackFetchStreamPerformance: r,
    shouldCreateSpanForRequest: i,
    enableHTTPTimings: o,
    tracePropagationTargets: l,
    onRequestSpanStart: d
  } = {
    ...d4,
    ...t
  }, c = typeof i == "function" ? i : (f) => !0, u = (f) => HN(f, l), m = {};
  s && (e.addEventProcessor((f) => (f.type === "transaction" && f.spans && f.spans.forEach((v) => {
    if (v.op === "http.client") {
      const b = ag.get(v.span_id);
      b && (v.timestamp = b / 1e3, ag.delete(v.span_id));
    }
  }), f)), r && zR((f) => {
    if (f.response) {
      const v = pw.get(f.response);
      v && f.endTimestamp && ag.set(v, f.endTimestamp);
    }
  }), T3((f) => {
    const v = BR(f, c, u, m);
    if (f.response && f.fetchData.__span && pw.set(f.response, f.fetchData.__span), v) {
      const b = c4(f.fetchData.url), w = b ? _i(b).host : void 0;
      v.setAttributes({
        "http.url": b,
        "server.address": w
      }), o && hw(v), d == null || d(v, { headers: f.headers });
    }
  })), n && l8((f) => {
    var b;
    const v = UN(f, c, u, m);
    if (v) {
      o && hw(v);
      let w;
      try {
        w = new Headers((b = f.xhr.__sentry_xhr_v3__) == null ? void 0 : b.request_headers);
      } catch {
      }
      d == null || d(v, { headers: w });
    }
  });
}
function jN(e) {
  return e.entryType === "resource" && "initiatorType" in e && typeof e.nextHopProtocol == "string" && (e.initiatorType === "fetch" || e.initiatorType === "xmlhttprequest");
}
function hw(e) {
  const { url: t } = ms(e).data;
  if (!t || typeof t != "string")
    return;
  const s = rl("resource", ({ entries: n }) => {
    n.forEach((r) => {
      jN(r) && r.name.endsWith(t) && (DN(r).forEach((o) => e.setAttribute(...o)), setTimeout(s));
    });
  });
}
function HN(e, t) {
  const s = fl();
  if (s) {
    let n, r;
    try {
      n = new URL(e, s), r = new URL(s).origin;
    } catch {
      return !1;
    }
    const i = n.origin === r;
    return t ? Io(n.toString(), t) || i && Io(n.pathname, t) : i;
  } else {
    const n = !!e.match(/^\/(?!\/)/);
    return t ? Io(e, t) : n;
  }
}
function UN(e, t, s, n) {
  const r = e.xhr, i = r == null ? void 0 : r[Gi];
  if (!r || r.__sentry_own_request__ || !i)
    return;
  const { url: o, method: l } = i, d = xo() && t(o);
  if (e.endTimestamp && d) {
    const w = r.__sentry_xhr_span_id__;
    if (!w) return;
    const S = n[w];
    S && i.status_code !== void 0 && (VP(S, i.status_code), S.end(), delete n[w]);
    return;
  }
  const c = c4(o), u = _i(c || o), m = LR(o), f = !!Ja(), v = d && f ? bi({
    name: `${l} ${m}`,
    attributes: {
      url: o,
      type: "xhr",
      "http.method": l,
      "http.url": c,
      "server.address": u == null ? void 0 : u.host,
      [Ca]: "auto.http.browser",
      [Mo]: "http.client",
      ...(u == null ? void 0 : u.search) && { "http.query": u == null ? void 0 : u.search },
      ...(u == null ? void 0 : u.hash) && { "http.fragment": u == null ? void 0 : u.hash }
    }
  }) : new yi();
  r.__sentry_xhr_span_id__ = v.spanContext().spanId, n[r.__sentry_xhr_span_id__] = v, s(o) && zN(
    r,
    // If performance is disabled (TWP) or there's no active root span (pageload/navigation/interaction),
    // we do not want to use the span as base for the trace headers,
    // which means that the headers will be generated from the scope and the sampling decision is deferred
    xo() && f ? v : void 0
  );
  const b = ds();
  return b && b.emit("beforeOutgoingRequestSpan", v, e), v;
}
function zN(e, t) {
  const { "sentry-trace": s, baggage: n } = A3({ span: t });
  s && WN(e, s, n);
}
function WN(e, t, s) {
  var r;
  const n = (r = e.__sentry_xhr_v3__) == null ? void 0 : r.request_headers;
  if (!(n != null && n["sentry-trace"]))
    try {
      if (e.setRequestHeader("sentry-trace", t), s) {
        const i = n == null ? void 0 : n.baggage;
        (!i || !GN(i)) && e.setRequestHeader("baggage", s);
      }
    } catch {
    }
}
function GN(e) {
  return e.split(",").some((t) => t.trim().startsWith("sentry-"));
}
function c4(e) {
  try {
    return new URL(e, ls.location.origin).href;
  } catch {
    return;
  }
}
function YN() {
  ls.document ? ls.document.addEventListener("visibilitychange", () => {
    const e = Ja();
    if (!e)
      return;
    const t = Wa(e);
    if (ls.document.hidden && t) {
      const s = "cancelled", { op: n, status: r } = ms(t);
      Es && ot.log(`[Tracing] Transaction: ${s} -> since tab moved to the background, op: ${n}`), r || t.setStatus({ code: ja, message: s }), t.setAttribute("sentry.cancellation_reason", "document.hidden"), t.end();
    }
  }) : Es && ot.warn("[Tracing] Could not set up background tab detection due to lack of global document");
}
const XN = 3600, u4 = "sentry_previous_trace", qN = "sentry.previous_trace";
function QN(e, {
  linkPreviousTrace: t,
  consistentTraceSampling: s
}) {
  const n = t === "session-storage";
  let r = n ? JN() : void 0;
  e.on("spanStart", (o) => {
    if (Wa(o) !== o)
      return;
    const l = Is().getPropagationContext();
    r = KN(r, o, l), n && ZN(r);
  });
  let i = !0;
  s && e.on("beforeSampling", (o) => {
    if (!r)
      return;
    const l = Is(), d = l.getPropagationContext();
    if (i && d.parentSpanId) {
      i = !1;
      return;
    }
    l.setPropagationContext({
      ...d,
      dsc: {
        ...d.dsc,
        sample_rate: String(r.sampleRate),
        sampled: String(Xv(r.spanContext))
      },
      sampleRand: r.sampleRand
    }), o.parentSampled = Xv(r.spanContext), o.parentSampleRate = r.sampleRate, o.spanAttributes = {
      ...o.spanAttributes,
      [xP]: r.sampleRate
    };
  });
}
function KN(e, t, s) {
  const n = ms(t);
  function r() {
    var l, d;
    try {
      return Number((l = s.dsc) == null ? void 0 : l.sample_rate) ?? Number((d = n.data) == null ? void 0 : d[u1]);
    } catch {
      return 0;
    }
  }
  const i = {
    spanContext: t.spanContext(),
    startTimestamp: n.start_timestamp,
    sampleRate: r(),
    sampleRand: s.sampleRand
  };
  if (!e)
    return i;
  const o = e.spanContext;
  return o.traceId === n.trace_id ? e : (Date.now() / 1e3 - e.startTimestamp <= XN && (Es && ot.log(
    `Adding previous_trace ${o} link to span ${{
      op: n.op,
      ...t.spanContext()
    }}`
  ), t.addLink({
    context: o,
    attributes: {
      [$9]: "previous_trace"
    }
  }), t.setAttribute(
    qN,
    `${o.traceId}-${o.spanId}-${Xv(o) ? 1 : 0}`
  )), i);
}
function ZN(e) {
  try {
    ls.sessionStorage.setItem(u4, JSON.stringify(e));
  } catch (t) {
    Es && ot.warn("Could not store previous trace in sessionStorage", t);
  }
}
function JN() {
  var e;
  try {
    const t = (e = ls.sessionStorage) == null ? void 0 : e.getItem(u4);
    return JSON.parse(t);
  } catch {
    return;
  }
}
function Xv(e) {
  return e.traceFlags === 1;
}
const $N = "BrowserTracing", _N = {
  ...ah,
  instrumentNavigation: !0,
  instrumentPageLoad: !0,
  markBackgroundSpan: !0,
  enableLongTask: !0,
  enableLongAnimationFrame: !0,
  enableInp: !0,
  enableElementTiming: !0,
  ignoreResourceSpans: [],
  ignorePerformanceApiSpans: [],
  detectRedirects: !0,
  linkPreviousTrace: "in-memory",
  consistentTraceSampling: !1,
  _experiments: {},
  ...d4
}, mw = (e = {}) => {
  const t = {
    name: void 0,
    source: void 0
  }, s = ls.document, {
    enableInp: n,
    enableElementTiming: r,
    enableLongTask: i,
    enableLongAnimationFrame: o,
    _experiments: { enableInteractions: l, enableStandaloneClsSpans: d, enableStandaloneLcpSpans: c },
    beforeStartSpan: u,
    idleTimeout: m,
    finalTimeout: f,
    childSpanTimeout: v,
    markBackgroundSpan: b,
    traceFetch: w,
    traceXHR: S,
    trackFetchStreamPerformance: I,
    shouldCreateSpanForRequest: T,
    enableHTTPTimings: x,
    ignoreResourceSpans: k,
    ignorePerformanceApiSpans: C,
    instrumentPageLoad: O,
    instrumentNavigation: E,
    detectRedirects: B,
    linkPreviousTrace: M,
    consistentTraceSampling: R,
    onRequestSpanStart: F
  } = {
    ..._N,
    ...e
  };
  let L, j;
  function H(te, re, le = !0) {
    const ie = re.op === "pageload", ye = u ? u(re) : re, Y = ye.attributes || {};
    if (re.name !== ye.name && (Y[Tn] = "custom", ye.attributes = Y), !le) {
      const ue = gl();
      bi({
        ...ye,
        startTime: ue
      }).end(ue);
      return;
    }
    t.name = ye.name, t.source = Y[Tn];
    const ae = a3(ye, {
      idleTimeout: m,
      finalTimeout: f,
      childSpanTimeout: v,
      // should wait for finish signal if it's a pageload transaction
      disableAutoFinish: ie,
      beforeSpanEnd: (ue) => {
        L == null || L(), mM(ue, {
          recordClsOnPageloadSpan: !d,
          recordLcpOnPageloadSpan: !c,
          ignoreResourceSpans: k,
          ignorePerformanceApiSpans: C
        }), gw(te, void 0);
        const oe = Is(), fe = oe.getPropagationContext();
        oe.setPropagationContext({
          ...fe,
          traceId: ae.spanContext().traceId,
          sampled: vl(ae),
          dsc: Fo(ue)
        });
      }
    });
    gw(te, ae);
    function ke() {
      s && ["interactive", "complete"].includes(s.readyState) && te.emit("idleSpanEnableAutoFinish", ae);
    }
    ie && s && (s.addEventListener("readystatechange", () => {
      ke();
    }), ke());
  }
  return {
    name: $N,
    setup(te) {
      if (gO(), L = oM({
        recordClsStandaloneSpans: d || !1,
        recordLcpStandaloneSpans: c || !1,
        client: te
      }), n && VM(), r && PM(), o && As.PerformanceObserver && PerformanceObserver.supportedEntryTypes && PerformanceObserver.supportedEntryTypes.includes("long-animation-frame") ? lM() : i && iM(), l && dM(), B && s) {
        const le = () => {
          j = Ea();
        };
        addEventListener("click", le, { capture: !0 }), addEventListener("keydown", le, { capture: !0, passive: !0 });
      }
      function re() {
        const le = vu(te);
        le && !ms(le).timestamp && (Es && ot.log(`[Tracing] Finishing current active span with op: ${ms(le).op}`), le.setAttribute(Zh, "cancelled"), le.end());
      }
      te.on("startNavigationSpan", (le, ie) => {
        if (ds() !== te)
          return;
        if (ie != null && ie.isRedirect) {
          Es && ot.warn("[Tracing] Detected redirect, navigation span will not be the root span, but a child span."), H(
            te,
            {
              op: "navigation.redirect",
              ...le
            },
            !1
          );
          return;
        }
        re(), Wn().setPropagationContext({ traceId: vi(), sampleRand: Math.random() });
        const ye = Is();
        ye.setPropagationContext({ traceId: vi(), sampleRand: Math.random() }), ye.setSDKProcessingMetadata({
          normalizedRequest: void 0
        }), H(te, {
          op: "navigation",
          ...le
        });
      }), te.on("startPageLoadSpan", (le, ie = {}) => {
        if (ds() !== te)
          return;
        re();
        const ye = ie.sentryTrace || fw("sentry-trace"), Y = ie.baggage || fw("baggage"), ae = lO(ye, Y), ke = Is();
        ke.setPropagationContext(ae), ke.setSDKProcessingMetadata({
          normalizedRequest: S1()
        }), H(te, {
          op: "pageload",
          ...le
        });
      });
    },
    afterAllSetup(te) {
      let re = fl();
      if (M !== "off" && QN(te, { linkPreviousTrace: M, consistentTraceSampling: R }), ls.location) {
        if (O) {
          const le = on();
          ej(te, {
            name: ls.location.pathname,
            // pageload should always start at timeOrigin (and needs to be in s, not ms)
            startTime: le ? le / 1e3 : void 0,
            attributes: {
              [Tn]: "url",
              [Ca]: "auto.pageload.browser"
            }
          });
        }
        E && Qm(({ to: le, from: ie }) => {
          if (ie === void 0 && (re == null ? void 0 : re.indexOf(le)) !== -1) {
            re = void 0;
            return;
          }
          re = void 0;
          const ye = E3(le), Y = vu(te), ae = Y && B && sj(Y, j);
          p4(
            te,
            {
              name: (ye == null ? void 0 : ye.pathname) || ls.location.pathname,
              attributes: {
                [Tn]: "url",
                [Ca]: "auto.navigation.browser"
              }
            },
            { url: le, isRedirect: ae }
          );
        });
      }
      b && YN(), l && tj(te, m, f, v, t), n && jM(), NN(te, {
        traceFetch: w,
        traceXHR: S,
        trackFetchStreamPerformance: I,
        tracePropagationTargets: te.getOptions().tracePropagationTargets,
        shouldCreateSpanForRequest: T,
        enableHTTPTimings: x,
        onRequestSpanStart: F
      });
    }
  };
};
function ej(e, t, s) {
  e.emit("startPageLoadSpan", t, s), Is().setTransactionName(t.name);
  const n = vu(e);
  return n && e.emit("afterStartPageLoadSpan", n), n;
}
function p4(e, t, s) {
  const { url: n, isRedirect: r } = s || {};
  e.emit("beforeStartNavigationSpan", t, { isRedirect: r }), e.emit("startNavigationSpan", t, { isRedirect: r });
  const i = Is();
  return i.setTransactionName(t.name), n && !r && i.setSDKProcessingMetadata({
    normalizedRequest: {
      ...S1(),
      url: n
    }
  }), vu(e);
}
function fw(e) {
  const t = ls.document, s = t == null ? void 0 : t.querySelector(`meta[name=${e}]`);
  return (s == null ? void 0 : s.getAttribute("content")) || void 0;
}
function tj(e, t, s, n, r) {
  const i = ls.document;
  let o;
  const l = () => {
    const d = "ui.action.click", c = vu(e);
    if (c) {
      const u = ms(c).op;
      if (["navigation", "pageload"].includes(u)) {
        Es && ot.warn(`[Tracing] Did not create ${d} span because a pageload or navigation span is in progress.`);
        return;
      }
    }
    if (o && (o.setAttribute(Zh, "interactionInterrupted"), o.end(), o = void 0), !r.name) {
      Es && ot.warn(`[Tracing] Did not create ${d} transaction because _latestRouteName is missing.`);
      return;
    }
    o = a3(
      {
        name: r.name,
        op: d,
        attributes: {
          [Tn]: r.source || "url"
        }
      },
      {
        idleTimeout: t,
        finalTimeout: s,
        childSpanTimeout: n
      }
    );
  };
  i && addEventListener("click", l, { capture: !0 });
}
const h4 = "_sentry_idleSpan";
function vu(e) {
  return e[h4];
}
function gw(e, t) {
  Un(e, h4, t);
}
const vw = 0.3;
function sj(e, t) {
  const s = ms(e), n = gl(), r = s.start_timestamp;
  return !(n - r > vw || t && n - t <= vw);
}
const yw = 1e6, fh = String(0), aj = "main", er = ls.navigator;
let m4 = "", f4 = "", g4 = "", qv = (er == null ? void 0 : er.userAgent) || "", v4 = "";
var eP;
const nj = (er == null ? void 0 : er.language) || ((eP = er == null ? void 0 : er.languages) == null ? void 0 : eP[0]) || "";
function rj(e) {
  return typeof e == "object" && e !== null && "getHighEntropyValues" in e;
}
const bw = er == null ? void 0 : er.userAgentData;
rj(bw) && bw.getHighEntropyValues(["architecture", "model", "platform", "platformVersion", "fullVersionList"]).then((e) => {
  var t;
  if (m4 = e.platform || "", g4 = e.architecture || "", v4 = e.model || "", f4 = e.platformVersion || "", (t = e.fullVersionList) != null && t.length) {
    const s = e.fullVersionList[e.fullVersionList.length - 1];
    qv = `${s.brand} ${s.version}`;
  }
}).catch((e) => {
});
function oj(e) {
  return !("thread_metadata" in e);
}
function ij(e) {
  return oj(e) ? cj(e) : e;
}
function lj(e) {
  var s, n;
  const t = (n = (s = e.contexts) == null ? void 0 : s.trace) == null ? void 0 : n.trace_id;
  return typeof t == "string" && t.length !== 32 && Es && ot.log(`[Profiling] Invalid traceId: ${t} on profiled event`), typeof t != "string" ? "" : t;
}
function dj(e, t, s, n) {
  if (n.type !== "transaction")
    throw new TypeError("Profiling events may only be attached to transactions, this should never occur.");
  if (s == null)
    throw new TypeError(
      `Cannot construct profiling event envelope without a valid profile. Got ${s} instead.`
    );
  const r = lj(n), i = ij(s), o = t || (typeof n.start_timestamp == "number" ? n.start_timestamp * 1e3 : Ea() * 1e3), l = typeof n.timestamp == "number" ? n.timestamp * 1e3 : Ea() * 1e3;
  return {
    event_id: e,
    timestamp: new Date(o).toISOString(),
    platform: "javascript",
    version: "1",
    release: n.release || "",
    environment: n.environment || Um,
    runtime: {
      name: "javascript",
      version: ls.navigator.userAgent
    },
    os: {
      name: m4,
      version: f4,
      build_number: qv
    },
    device: {
      locale: nj,
      model: v4,
      manufacturer: qv,
      architecture: g4,
      is_emulator: !1
    },
    debug_meta: {
      images: hj(s.resources)
    },
    profile: i,
    transactions: [
      {
        name: n.transaction || "",
        id: n.event_id || gn(),
        trace_id: r,
        active_thread_id: fh,
        relative_start_ns: "0",
        relative_end_ns: ((l - o) * 1e6).toFixed(0)
      }
    ]
  };
}
function y4(e) {
  return ms(e).op === "pageload";
}
function cj(e) {
  let t, s = 0;
  const n = {
    samples: [],
    stacks: [],
    frames: [],
    thread_metadata: {
      [fh]: { name: aj }
    }
  }, r = e.samples[0];
  if (!r)
    return n;
  const i = r.timestamp, o = on(), l = typeof performance.timeOrigin == "number" ? performance.timeOrigin : o || 0, d = l - (o || l);
  return e.samples.forEach((c, u) => {
    if (c.stackId === void 0) {
      t === void 0 && (t = s, n.stacks[t] = [], s++), n.samples[u] = {
        // convert ms timestamp to ns
        elapsed_since_start_ns: ((c.timestamp + d - i) * yw).toFixed(0),
        stack_id: t,
        thread_id: fh
      };
      return;
    }
    let m = e.stacks[c.stackId];
    const f = [];
    for (; m; ) {
      f.push(m.frameId);
      const b = e.frames[m.frameId];
      b && n.frames[m.frameId] === void 0 && (n.frames[m.frameId] = {
        function: b.name,
        abs_path: typeof b.resourceId == "number" ? e.resources[b.resourceId] : void 0,
        lineno: b.line,
        colno: b.column
      }), m = m.parentId === void 0 ? void 0 : e.stacks[m.parentId];
    }
    const v = {
      // convert ms timestamp to ns
      elapsed_since_start_ns: ((c.timestamp + d - i) * yw).toFixed(0),
      stack_id: s,
      thread_id: fh
    };
    n.stacks[s] = f, n.samples[u] = v, s++;
  }), n;
}
function uj(e, t) {
  if (!t.length)
    return e;
  for (const s of t)
    e[1].push([{ type: "profile" }, s]);
  return e;
}
function pj(e) {
  const t = [];
  return $h(e, (s, n) => {
    var r, i;
    if (n === "transaction")
      for (let o = 1; o < s.length; o++) {
        const l = s[o];
        (i = (r = l == null ? void 0 : l.contexts) == null ? void 0 : r.profile) != null && i.profile_id && t.push(s[o]);
      }
  }), t;
}
function hj(e) {
  const t = ds(), s = t == null ? void 0 : t.getOptions(), n = s == null ? void 0 : s.stackParser;
  return n ? o7(n, e) : [];
}
function mj(e) {
  return typeof e != "number" && typeof e != "boolean" || typeof e == "number" && isNaN(e) ? (Es && ot.warn(
    `[Profiling] Invalid sample rate. Sample rate must be a boolean or a number between 0 and 1. Got ${JSON.stringify(
      e
    )} of type ${JSON.stringify(typeof e)}.`
  ), !1) : e === !0 || e === !1 ? !0 : e < 0 || e > 1 ? (Es && ot.warn(`[Profiling] Invalid sample rate. Sample rate must be between 0 and 1. Got ${e}.`), !1) : !0;
}
function fj(e) {
  return e.samples.length < 2 ? (Es && ot.log("[Profiling] Discarding profile because it contains less than 2 samples"), !1) : e.frames.length ? !0 : (Es && ot.log("[Profiling] Discarding profile because it contains no frames"), !1);
}
let b4 = !1;
const A4 = 3e4;
function gj(e) {
  return typeof e == "function";
}
function vj() {
  const e = ls.Profiler;
  if (!gj(e)) {
    Es && ot.log("[Profiling] Profiling is not supported by this browser, Profiler interface missing on window object.");
    return;
  }
  const t = 10, s = Math.floor(A4 / t);
  try {
    return new e({ sampleInterval: t, maxBufferSize: s });
  } catch {
    Es && (ot.log(
      "[Profiling] Failed to initialize the Profiling constructor, this is likely due to a missing 'Document-Policy': 'js-profiling' header."
    ), ot.log("[Profiling] Disabling profiling for current user session.")), b4 = !0;
  }
}
function Aw(e) {
  if (b4)
    return Es && ot.log("[Profiling] Profiling has been disabled for the duration of the current user session."), !1;
  if (!e.isRecording())
    return Es && ot.log("[Profiling] Discarding profile because transaction was not sampled."), !1;
  const t = ds(), s = t == null ? void 0 : t.getOptions();
  if (!s)
    return Es && ot.log("[Profiling] Profiling disabled, no options found."), !1;
  const n = s.profilesSampleRate;
  return mj(n) ? n ? (n === !0 ? !0 : Math.random() < n) ? !0 : (Es && ot.log(
    `[Profiling] Discarding profile because it's not included in the random sample (sampling rate = ${Number(
      n
    )})`
  ), !1) : (Es && ot.log(
    "[Profiling] Discarding profile because a negative sampling decision was inherited or profileSampleRate is set to 0"
  ), !1) : (Es && ot.warn("[Profiling] Discarding profile because of invalid sample rate."), !1);
}
function yj(e, t, s, n) {
  return fj(s) ? dj(e, t, s, n) : null;
}
const Xi = /* @__PURE__ */ new Map();
function bj() {
  return Xi.size;
}
function Aj(e) {
  const t = Xi.get(e);
  return t && Xi.delete(e), t;
}
function wj(e, t) {
  if (Xi.set(e, t), Xi.size > 30) {
    const s = Xi.keys().next().value;
    Xi.delete(s);
  }
}
function ww(e) {
  let t;
  y4(e) && (t = Ea() * 1e3);
  const s = vj();
  if (!s)
    return;
  Es && ot.log(`[Profiling] started profiling span: ${ms(e).description}`);
  const n = gn();
  Is().setContext("profile", {
    profile_id: n,
    start_timestamp: t
  });
  async function r() {
    if (e && s)
      return s.stop().then((d) => {
        if (i && (ls.clearTimeout(i), i = void 0), Es && ot.log(`[Profiling] stopped profiling of span: ${ms(e).description}`), !d) {
          Es && ot.log(
            `[Profiling] profiler returned null profile for: ${ms(e).description}`,
            "this may indicate an overlapping span or a call to stopProfiling with a profile title that was never started"
          );
          return;
        }
        wj(n, d);
      }).catch((d) => {
        Es && ot.log("[Profiling] error while stopping profiler:", d);
      });
  }
  let i = ls.setTimeout(() => {
    Es && ot.log("[Profiling] max profile duration elapsed, stopping profiling for:", ms(e).description), r();
  }, A4);
  const o = e.end.bind(e);
  function l() {
    return e ? (r().then(
      () => {
        o();
      },
      () => {
        o();
      }
    ), e) : o();
  }
  e.end = l;
}
const Cj = "BrowserProfiling", Sj = () => ({
  name: Cj,
  setup(e) {
    const t = Ja(), s = t && Wa(t);
    s && y4(s) && Aw(s) && ww(s), e.on("spanStart", (n) => {
      n === Wa(n) && Aw(n) && ww(n);
    }), e.on("beforeEnvelope", (n) => {
      var o, l;
      if (!bj())
        return;
      const r = pj(n);
      if (!r.length)
        return;
      const i = [];
      for (const d of r) {
        const c = d == null ? void 0 : d.contexts, u = (o = c == null ? void 0 : c.profile) == null ? void 0 : o.profile_id, m = (l = c == null ? void 0 : c.profile) == null ? void 0 : l.start_timestamp;
        if (typeof u != "string") {
          Es && ot.log("[Profiling] cannot find profile for a span without a profile context");
          continue;
        }
        if (!u) {
          Es && ot.log("[Profiling] cannot find profile for a span without a profile context");
          continue;
        }
        c != null && c.profile && delete c.profile;
        const f = Aj(u);
        if (!f) {
          Es && ot.log(`[Profiling] Could not retrieve profile for span: ${u}`);
          continue;
        }
        const v = yj(
          u,
          m,
          f,
          d
        );
        v && i.push(v);
      }
      uj(n, i);
    });
  }
}), Pj = Sj;
function K1(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var ng, Cw;
function kj() {
  if (Cw) return ng;
  Cw = 1;
  const e = /* @__PURE__ */ new Set([
    "ENOTFOUND",
    "ENETUNREACH",
    // SSL errors from https://github.com/nodejs/node/blob/fc8e3e2cdc521978351de257030db0076d79e0ab/src/crypto/crypto_common.cc#L301-L328
    "UNABLE_TO_GET_ISSUER_CERT",
    "UNABLE_TO_GET_CRL",
    "UNABLE_TO_DECRYPT_CERT_SIGNATURE",
    "UNABLE_TO_DECRYPT_CRL_SIGNATURE",
    "UNABLE_TO_DECODE_ISSUER_PUBLIC_KEY",
    "CERT_SIGNATURE_FAILURE",
    "CRL_SIGNATURE_FAILURE",
    "CERT_NOT_YET_VALID",
    "CERT_HAS_EXPIRED",
    "CRL_NOT_YET_VALID",
    "CRL_HAS_EXPIRED",
    "ERROR_IN_CERT_NOT_BEFORE_FIELD",
    "ERROR_IN_CERT_NOT_AFTER_FIELD",
    "ERROR_IN_CRL_LAST_UPDATE_FIELD",
    "ERROR_IN_CRL_NEXT_UPDATE_FIELD",
    "OUT_OF_MEM",
    "DEPTH_ZERO_SELF_SIGNED_CERT",
    "SELF_SIGNED_CERT_IN_CHAIN",
    "UNABLE_TO_GET_ISSUER_CERT_LOCALLY",
    "UNABLE_TO_VERIFY_LEAF_SIGNATURE",
    "CERT_CHAIN_TOO_LONG",
    "CERT_REVOKED",
    "INVALID_CA",
    "PATH_LENGTH_EXCEEDED",
    "INVALID_PURPOSE",
    "CERT_UNTRUSTED",
    "CERT_REJECTED",
    "HOSTNAME_MISMATCH"
  ]);
  return ng = (t) => !e.has(t && t.code), ng;
}
var Ej = kj();
const Ij = /* @__PURE__ */ K1(Ej), Z1 = "axios-retry";
function w4(e) {
  const t = ["ERR_CANCELED", "ECONNABORTED"];
  return e.response || !e.code || t.includes(e.code) ? !1 : Ij(e);
}
const C4 = ["get", "head", "options"], Tj = C4.concat(["put", "delete"]);
function J1(e) {
  return e.code !== "ECONNABORTED" && (!e.response || e.response.status === 429 || e.response.status >= 500 && e.response.status <= 599);
}
function Oj(e) {
  var t;
  return (t = e.config) != null && t.method ? J1(e) && C4.indexOf(e.config.method) !== -1 : !1;
}
function S4(e) {
  var t;
  return (t = e.config) != null && t.method ? J1(e) && Tj.indexOf(e.config.method) !== -1 : !1;
}
function P4(e) {
  return w4(e) || S4(e);
}
function $1(e = void 0) {
  var n;
  const t = (n = e == null ? void 0 : e.response) == null ? void 0 : n.headers["retry-after"];
  if (!t)
    return 0;
  let s = (Number(t) || 0) * 1e3;
  return s === 0 && (s = (new Date(t).valueOf() || 0) - Date.now()), Math.max(0, s);
}
function Rj(e = 0, t = void 0) {
  return Math.max(0, $1(t));
}
function Lj(e = 0, t = void 0, s = 100) {
  const n = 2 ** e * s, r = Math.max(n, $1(t)), i = r * 0.2 * Math.random();
  return r + i;
}
function Bj(e = 100) {
  return (t = 0, s = void 0) => {
    const n = t * e;
    return Math.max(n, $1(s));
  };
}
const Mj = {
  retries: 3,
  retryCondition: P4,
  retryDelay: Rj,
  shouldResetTimeout: !1,
  onRetry: () => {
  },
  onMaxRetryTimesExceeded: () => {
  },
  validateResponse: null
};
function xj(e, t) {
  return { ...Mj, ...t, ...e[Z1] };
}
function Sw(e, t, s = !1) {
  const n = xj(e, t || {});
  return n.retryCount = n.retryCount || 0, (!n.lastRequestTime || s) && (n.lastRequestTime = Date.now()), e[Z1] = n, n;
}
function Fj(e, t) {
  e.defaults.agent === t.agent && delete t.agent, e.defaults.httpAgent === t.httpAgent && delete t.httpAgent, e.defaults.httpsAgent === t.httpsAgent && delete t.httpsAgent;
}
async function Vj(e, t) {
  const { retries: s, retryCondition: n } = e, r = (e.retryCount || 0) < s && n(t);
  if (typeof r == "object")
    try {
      return await r !== !1;
    } catch {
      return !1;
    }
  return r;
}
async function Dj(e, t, s, n) {
  var d;
  t.retryCount += 1;
  const { retryDelay: r, shouldResetTimeout: i, onRetry: o } = t, l = r(t.retryCount, s);
  if (Fj(e, n), !i && n.timeout && t.lastRequestTime) {
    const c = Date.now() - t.lastRequestTime, u = n.timeout - c - l;
    if (u <= 0)
      return Promise.reject(s);
    n.timeout = u;
  }
  return n.transformRequest = [(c) => c], await o(t.retryCount, s, n), (d = n.signal) != null && d.aborted ? Promise.resolve(e(n)) : new Promise((c) => {
    var f;
    const u = () => {
      clearTimeout(m), c(e(n));
    }, m = setTimeout(() => {
      var v;
      c(e(n)), (v = n.signal) != null && v.removeEventListener && n.signal.removeEventListener("abort", u);
    }, l);
    (f = n.signal) != null && f.addEventListener && n.signal.addEventListener("abort", u, { once: !0 });
  });
}
async function Nj(e, t) {
  e.retryCount >= e.retries && await e.onMaxRetryTimesExceeded(t, e.retryCount);
}
const gr = (e, t) => {
  const s = e.interceptors.request.use((r) => {
    var i;
    return Sw(r, t, !0), (i = r[Z1]) != null && i.validateResponse && (r.validateStatus = () => !1), r;
  }), n = e.interceptors.response.use(null, async (r) => {
    var l;
    const { config: i } = r;
    if (!i)
      return Promise.reject(r);
    const o = Sw(i, t);
    return r.response && ((l = o.validateResponse) != null && l.call(o, r.response)) ? r.response : await Vj(o, r) ? Dj(e, o, r, i) : (await Nj(o, r), Promise.reject(r));
  });
  return { requestInterceptorId: s, responseInterceptorId: n };
};
gr.isNetworkError = w4;
gr.isSafeRequestError = Oj;
gr.isIdempotentRequestError = S4;
gr.isNetworkOrIdempotentRequestError = P4;
gr.exponentialDelay = Lj;
gr.linearDelay = Bj;
gr.isRetryableError = J1;
const jj = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d*)?(?:[-+]\d{2}:?\d{2}|Z)?$/, Hj = /^\d{4}-\d{2}-\d{2}$/, _1 = "clientToken", Uj = 20, k4 = 1 / 24, rg = /* @__PURE__ */ new Date(), eb = fk(rg) ? rb(rg) : rg.getTimezoneOffset(), E4 = Math.trunc(Math.abs(eb) / 60), zj = Math.abs(eb) - E4 * 60, og = "x-account-d", Pw = "x-client-id";
class I4 {
  constructor(t, s, n, r) {
    Xe(this, "_httpClient");
    Xe(this, "_apiConfig");
    Xe(this, "_account");
    Xe(this, "_subAccounts");
    Xe(this, "_accountBranding");
    Xe(this, "_accountIdx");
    Xe(this, "_accountIdxAgents");
    Xe(this, "_accountClients");
    Xe(this, "_accountPortfolioFinder");
    Xe(this, "_accountMLS");
    Xe(this, "_accountClientsInvite");
    Xe(this, "_portfolioInsightsClients");
    Xe(this, "_idxClients");
    Xe(this, "_homes");
    Xe(this, "_portfolioFinder");
    Xe(this, "_pdf");
    Xe(this, "_analysisRequests");
    Xe(this, "_property");
    Xe(this, "_geo");
    Xe(this, "_calculator");
    Xe(this, "_schools");
    Xe(this, "_community");
    Xe(this, "_records");
    Xe(this, "_dictionary");
    Xe(this, "_folio");
    Xe(this, "_marketplace");
    Xe(this, "_manageMarketplace");
    Xe(this, "_mls");
    Xe(this, "_images");
    Xe(this, "_searchMls");
    Xe(this, "_billing");
    Xe(this, "_billingProductGroups");
    Xe(this, "_subscriptions");
    Xe(this, "_widgetIdx");
    Xe(this, "_rentalScout");
    Xe(this, "_crm");
    Xe(this, "_user");
    Xe(this, "_preForeclosure");
    Xe(this, "_portfolioInsights");
    Xe(this, "_brand");
    Xe(this, "_incomeExpenseAccounts");
    Xe(this, "_ledger");
    Xe(this, "_rentvineIntegration");
    Xe(this, "_marketReport");
    Xe(this, "_accountTerritory");
    Xe(this, "_licensing");
    Xe(this, "_userParameters");
    Xe(this, "_accountIDXParameters");
    Xe(this, "_accountCheckList");
    Xe(this, "_tokenRefreshedEvents", []);
    Xe(this, "_id", n1());
    Xe(this, "_apiKey");
    Xe(this, "_accessTokenCallback");
    s ? (console.error("Invalid use of deprecated analysisKey parameter, please use apiKey parameter instead!"), this.ApiKey = s) : n ? (console.error("Invalid use of deprecated shareKey parameter, please use apiKey parameter instead!"), this.ApiKey = n) : t && (this.ApiKey = t);
    const i = {
      accessToken: async (o, l) => {
        if (this._accessTokenCallback)
          return await this._accessTokenCallback(o, l);
        if (window.anonymous)
          return;
        let d = Wj(_1);
        if (d != null && d.expires && mm(Date.now(), d.expires * 1e3) < Uj && (d = await Qv(), this._tokenRefreshedEvents.forEach((c) => {
          c(d);
        })), !(d != null && d.result) || d.result == "" || d.result == null)
          try {
            if (d = await Gj(), (d == null ? void 0 : d.result) == "anonymous") {
              window.anonymous = !0;
              return;
            }
          } catch {
            Se("An error occurred trying to authenticate your session. Please refresh the page to re-authenticate.", jo.Right, !0);
          }
        return d == null ? void 0 : d.result;
      },
      apiKey: (o) => {
        switch (o) {
          case "x-analysis-token":
          case "x-share-token":
          case "x-api-key":
            return this._apiKey;
        }
      }
    };
    this._apiConfig = new qT(i), this.env = window.api_env, r || (r = X.create({
      validateStatus(o) {
        return o >= 200 && o < 300 || o == 403;
      }
    }), gr(r, { retries: 5, retryDelay: gr.exponentialDelay })), d9(r, (o) => this.refreshAuthLogic(o)), r.interceptors.response.use((o) => (this.handleResponseTypes(o.data), o)), Zt.createInterceptor(r), Le.createInterceptor(r), r.interceptors.request.use(
      (o) => (this._apiKey && (o.headers["x-api-key"] = this._apiKey), o),
      (o) => Promise.reject(o)
    ), this._httpClient = r;
  }
  get account() {
    return this._account || (this._account = TI(this._apiConfig, G, this._httpClient)), this._account;
  }
  get subAccounts() {
    return this._subAccounts || (this._subAccounts = new VT(this._apiConfig, G, this._httpClient)), this._subAccounts;
  }
  get accountBranding() {
    return this._accountBranding || (this._accountBranding = LI(this._apiConfig, G, this._httpClient)), this._accountBranding;
  }
  get accountIdx() {
    return this._accountIdx || (this._accountIdx = zI(this._apiConfig, G, this._httpClient)), this._accountIdx;
  }
  get accountIdxAgents() {
    return this._accountIdxAgents || (this._accountIdxAgents = YI(this._apiConfig, G, this._httpClient)), this._accountIdxAgents;
  }
  get accountClients() {
    return this._accountClients || (this._accountClients = DI(this._apiConfig, G, this._httpClient)), this._accountClients;
  }
  get accountClientsInvite() {
    return this._accountClientsInvite || (this._accountClientsInvite = new jI(this._apiConfig, G, this._httpClient)), this._accountClientsInvite;
  }
  get accountPortfolioFinder() {
    return this._accountPortfolioFinder || (this._accountPortfolioFinder = new JI(this._apiConfig, G, this._httpClient)), this._accountPortfolioFinder;
  }
  get accountMLS() {
    return this._accountMLS || (this._accountMLS = new KI(this._apiConfig, G, this._httpClient)), this._accountMLS;
  }
  get idxClients() {
    return this._idxClients || (this._idxClients = x6(this._apiConfig, G, this._httpClient)), this._idxClients;
  }
  get portfolioInsightsClients() {
    return this._portfolioInsightsClients || (this._portfolioInsightsClients = mT(this._apiConfig, G, this._httpClient)), this._portfolioInsightsClients;
  }
  get homes() {
    return this._homes || (this._homes = L6(this._apiConfig, G, this._httpClient)), this._homes;
  }
  /**
   * @deprecated Calling deprecated leads api! Use portfolioFinder
   */
  get leads() {
    return console.warn("Calling deprecated leads api, change to portfolioFinder api ASAP."), this._portfolioFinder || (this._portfolioFinder = iA(this._apiConfig, G, this._httpClient)), this._portfolioFinder;
  }
  get portfolioFinder() {
    return this._portfolioFinder || (this._portfolioFinder = iA(this._apiConfig, G, this._httpClient)), this._portfolioFinder;
  }
  get pdf() {
    return this._pdf || (this._pdf = oT(this._apiConfig, G, this._httpClient)), this._pdf;
  }
  get property() {
    return this._property || (this._property = AT(this._apiConfig, G, this._httpClient)), this._property;
  }
  get analysisRequests() {
    return this._analysisRequests || (this._analysisRequests = s6(this._apiConfig, G, this._httpClient)), this._analysisRequests;
  }
  get folio() {
    return this._folio || (this._folio = k6(this._apiConfig, G, this._httpClient)), this._folio;
  }
  get geo() {
    return this._geo || (this._geo = T6(this._apiConfig, G, this._httpClient)), this._geo;
  }
  get calculator() {
    return this._calculator || (this._calculator = g6(this._apiConfig, G, this._httpClient)), this._calculator;
  }
  get schools() {
    return this._schools || (this._schools = LT(this._apiConfig, G, this._httpClient)), this._schools;
  }
  get community() {
    return this._community || (this._community = b6(this._apiConfig, G, this._httpClient)), this._community;
  }
  get records() {
    return this._records || (this._records = ST(this._apiConfig, G, this._httpClient)), this._records;
  }
  get dictionary() {
    return this._dictionary || (this._dictionary = C6(this._apiConfig, G, this._httpClient)), this._dictionary;
  }
  get marketplace() {
    return this._marketplace || (this._marketplace = aT(this._apiConfig, G, this._httpClient)), this._marketplace;
  }
  get manageMarketplace() {
    return this._manageMarketplace || (this._manageMarketplace = $6(this._apiConfig, G, this._httpClient)), this._manageMarketplace;
  }
  get mls() {
    return this._mls || (this._mls = K6(this._apiConfig, G, this._httpClient)), this._mls;
  }
  get images() {
    return this._images || (this._images = D6(this._apiConfig, G, this._httpClient)), this._images;
  }
  get searchMls() {
    return this._searchMls || (this._searchMls = xT(this._apiConfig, G, this._httpClient)), this._searchMls;
  }
  get preForeclosure() {
    return this._preForeclosure || (this._preForeclosure = vT(this._apiConfig, G, this._httpClient)), this._preForeclosure;
  }
  get portfolioInsights() {
    return this._portfolioInsights || (this._portfolioInsights = uT(this._apiConfig, G, this._httpClient)), this._portfolioInsights;
  }
  get billing() {
    return this._billing || (this._billing = r6(this._apiConfig, G, this._httpClient)), this._billing;
  }
  get billingProductGroups() {
    return this._billingProductGroups || (this._billingProductGroups = new i6(this._apiConfig, G, this._httpClient)), this._billingProductGroups;
  }
  get subscriptions() {
    return this._subscriptions || (this._subscriptions = new NT(this._apiConfig, G, this._httpClient)), this._subscriptions;
  }
  get widgetIdx() {
    return this._widgetIdx || (this._widgetIdx = new XT(this._apiConfig, G, this._httpClient)), this._widgetIdx;
  }
  get rentalScout() {
    return this._rentalScout || (this._rentalScout = new kT(this._apiConfig, G, this._httpClient)), this._rentalScout;
  }
  get crm() {
    return this._crm || (this._crm = h6(this._apiConfig, G, this._httpClient)), this._crm;
  }
  get user() {
    return this._user || (this._user = UT(this._apiConfig, G, this._httpClient)), this._user;
  }
  get brand() {
    return this._brand || (this._brand = c6(this._apiConfig, G, this._httpClient)), this._brand;
  }
  get incomeExpenseAccounts() {
    return this._incomeExpenseAccounts || (this._incomeExpenseAccounts = H6(this._apiConfig, G, this._httpClient)), this._incomeExpenseAccounts;
  }
  get ledger() {
    return this._ledger || (this._ledger = W6(this._apiConfig, G, this._httpClient)), this._ledger;
  }
  get rentvineIntegration() {
    return this._rentvineIntegration || (this._rentvineIntegration = TT(this._apiConfig, G, this._httpClient)), this._rentvineIntegration;
  }
  get marketReport() {
    return this._marketReport || (this._marketReport = new eT(this._apiConfig, G, this._httpClient)), this._marketReport;
  }
  get licensing() {
    return this._licensing || (this._licensing = new X6(this._apiConfig, G, this._httpClient)), this._licensing;
  }
  get userParameters() {
    return this._userParameters || (this._userParameters = new WT(this._apiConfig, G, this._httpClient)), this._userParameters;
  }
  get accountIDXParameters() {
    return this._accountIDXParameters || (this._accountIDXParameters = new qI(this._apiConfig, G, this._httpClient)), this._accountIDXParameters;
  }
  get accountCheckList() {
    return this._accountCheckList || (this._accountCheckList = new xI(this._apiConfig, G, this._httpClient)), this._accountCheckList;
  }
  get accountTerritory() {
    return this._accountTerritory || (this._accountTerritory = new _I(this._apiConfig, G, this._httpClient)), this._accountTerritory;
  }
  get id() {
    return this._id;
  }
  addTokenRefreshedEventListener(t) {
    this._tokenRefreshedEvents.push(t);
  }
  set clientId(t) {
    this._httpClient.defaults.headers.common[Pw] = t;
  }
  get hasClientId() {
    return this._httpClient.defaults.headers.common[Pw] != null;
  }
  set accountDomain(t) {
    console.warn("Account Domain Changed", t, new Error("Account Domain Changed")), this._httpClient.defaults.headers.common[og] = t;
  }
  get accountDomain() {
    return this._httpClient.defaults.headers.common[og];
  }
  get hasAccountDomain() {
    return this._httpClient.defaults.headers.common[og] != null;
  }
  set env(t) {
    if (console.warn("ApiEnv Changed", t, new Error("ApiEnv Changed")), !t) {
      this._apiConfig.basePath = void 0;
      return;
    }
    switch (t == "local" && (this._apiConfig.basePath = void 0), t) {
      case "local":
        this._apiConfig.basePath = "https://api.rescover.local";
        break;
      case "apicom":
        this._apiConfig.basePath = "https://api.rescover.com/v2";
        break;
      case "apinet":
        this._apiConfig.basePath = "https://api.rescover.net/v2";
        break;
      case "apidev":
        this._apiConfig.basePath = "https://api.rescover.dev/v2";
        break;
      case "uat":
        this._apiConfig.basePath = "https://uat.rescover.com/api/v2";
        break;
      case "dev":
        this._apiConfig.basePath = "https://dev.rescover.com/api/v2";
        break;
      case "devnet":
        this._apiConfig.basePath = "https://dev.rescover.net/api/v2";
        break;
      case "preview":
        this._apiConfig.basePath = "https://preview.rescover.com/api/v2";
        break;
      case "beta":
        this._apiConfig.basePath = "https://beta.rescover.com/api/v2";
        break;
    }
  }
  set ApiKey(t) {
    this._apiKey = t;
  }
  get ApiKey() {
    return this._apiKey;
  }
  set accessTokenCallback(t) {
    this._accessTokenCallback = t;
  }
  get accessTokenCallback() {
    return this._accessTokenCallback;
  }
  async refreshAuthLogic(t) {
    if (this._accessTokenCallback)
      return await this._accessTokenCallback();
    const s = await Qv();
    return this._tokenRefreshedEvents.forEach((n) => {
      n(s);
    }), s != null && s.result && s.result != "anonymous" ? (t.response.config.headers.Authorization = "Bearer " + s.result, s.result) : Promise.reject(t);
  }
  handleResponseTypes(t) {
    if (!(t == null || typeof t != "object"))
      for (const s of Object.keys(t)) {
        const n = t[s];
        if (this.isIsoDateString(n))
          t[s] = new Date(n);
        else if (this.isIsoDateOnlyString(n)) {
          let r = "+";
          eb > 0 && (r = "-"), t[s] = /* @__PURE__ */ new Date(`${n}T00:00:00${r}${kw(E4, 2)}${kw(zj, 2)}`);
        } else typeof n == "object" && (this.handleResponseTypes(n), t[s] = n);
      }
  }
  isIsoDateString(t) {
    return this.isString(t) && jj.test(t);
  }
  isIsoDateOnlyString(t) {
    return this.isString(t) && Hj.test(t);
  }
  isString(t) {
    return t && typeof t == "string" || t instanceof String;
  }
}
function kw(e, t) {
  return String(e).padStart(t, "0");
}
function Wj(e) {
  const t = Go(e);
  try {
    if (t)
      return JSON.parse(t);
  } catch (s) {
    Ns(s, {
      extra: {
        name: "getCookie.parse",
        json: t
      }
    });
  }
}
function T4(e, t, s) {
  t && (delete t.errorNumber, delete t.message, delete t.status, eo(e, JSON.stringify(t), s));
}
async function Gj() {
  const e = await X.get("/api/v1/account/token"), t = e.data.expires ? new Date(e.data.expires * 1e3) : null;
  return e.data.result && e.data.result != "anonymous" && T4(_1, e.data, { path: "/", secure: !0, sameSite: "strict", expires: t ?? k4 }), e.data;
}
async function Qv() {
  try {
    const e = await X.post("/api/v1/account/refresh-token"), t = e.data.expires ? new Date(e.data.expires * 1e3) : null;
    return e.data.result && e.data.result != "anonymous" && T4(_1, e.data, { path: "/", secure: !0, sameSite: "strict", expires: t ?? k4 }), e.data;
  } catch (e) {
    if (e.response.status != 401) throw e;
    return;
  }
}
window.rescoverClient = new I4();
let Kv;
const Yj = new Promise((e) => Kv = e), W = {
  get api() {
    return window.rescoverClient || (window.rescoverClient = new I4()), window.rescoverClient;
  },
  get apiKey() {
    return this.api.ApiKey;
  },
  set apiKey(e) {
    this.api.ApiKey = e;
  },
  get accessTokenCallback() {
    return this.api.accessTokenCallback;
  },
  set accessTokenCallback(e) {
    this.api.accessTokenCallback = e, Kv(!0);
  },
  get accessTokenReady() {
    return Yj;
  },
  setAccessTokenReady() {
    Kv(!0);
  },
  get env() {
    return this.api.env;
  },
  set env(e) {
    this.api.env = e;
  },
  get accountDomain() {
    return this.api.accountDomain;
  },
  set accountDomain(e) {
    this.api.accountDomain = e;
  }
};
let Cp;
async function Td() {
  if (Cp)
    return console.info("Location from local cache"), Cp;
  try {
    const e = await W.api.geo.location();
    if (e.data.status == de.Success)
      return Cp = e.data;
  } catch (e) {
    console.error("Failed to find current location via primary", e);
  }
  try {
    console.warn("Failed to find current location, trying backup method.");
    const e = await X.get("https://pro.ip-api.com/json?fields=500&key=undefined");
    if (e.status < 300)
      return Cp = {
        status: de.Success,
        postalCode: e.data.zip,
        latitude: e.data.lat,
        longitude: e.data.lon,
        cities: {
          en: e.data.city
        },
        locale: "en",
        stateIso: e.data.region,
        timeZone: e.data.timezone
      };
  } catch (e) {
    console.error("Failed to find current location via backup", e);
  }
}
function tu(e, t, s, n, r, i = 0) {
  r = Math.round(r * 100) / 100;
  let o = e;
  const l = s * n, d = [];
  for (let c = 0; c < l; c++) {
    let u, m;
    c < i ? (u = e * (t / s), m = 0) : (u = o * (t / s), m = r - u);
    const f = o, v = o -= Math.round(m * 100) / 100, b = {
      month: c + 1,
      // Month
      principalPaid: Math.round(m * 100) / 100,
      // Principal Paid
      interestPaid: Math.round(u * 100) / 100,
      // Interest Paid
      remainingPrincipalBeforePayment: Math.round(f * 100) / 100,
      // Remaining Principal Before Payment
      remainingPrincipalAfterPayment: Math.round(v * 100) / 100
      // Remaining Principal After Payment
    };
    if (b.remainingPrincipalAfterPayment < 0 && (b.remainingPrincipalAfterPayment = 0), d.push(b), b.remainingPrincipalAfterPayment == 0)
      break;
  }
  if (d.length > 0 && d[d.length - 1].remainingPrincipalAfterPayment > 0) {
    const c = d[d.length - 1];
    c.principalPaid += c.remainingPrincipalAfterPayment, c.remainingPrincipalAfterPayment = 0, d[d.length - 1] = c;
  }
  return d;
}
function Xj(e) {
  return e == null || e == null || (e == null ? void 0 : e.length) === 0 || (e == null ? void 0 : e.trim()) == "";
}
function qj(e) {
  return e == null ? void 0 : e.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#039;");
}
const O4 = 1e3, R4 = 60 * O4, Qj = 60 * R4;
function sf(e, t) {
  if (!e)
    return 0;
  t == null && (t = Date.now());
  let s = 0, n = 0;
  return typeof e == "number" ? s = e : s = e.getTime(), typeof t == "number" ? n = t : n = t.getTime(), Math.abs(n - s);
}
function Zv(e, t = void 0) {
  if (!e || !t)
    return 0;
  const s = sf(e, t);
  return Math.ceil(s / O4);
}
function mm(e, t) {
  if (!e || !t)
    return 0;
  const s = sf(e, t);
  return Math.ceil(s / R4);
}
function Kj(e, t) {
  if (!e || !t)
    return 0;
  const s = sf(e, t);
  return Math.ceil(s / Qj);
}
function Zj(e, t) {
  let s;
  return (...n) => {
    clearTimeout(s), s = setTimeout(() => {
      e(...n);
    }, t);
  };
}
const L4 = ["activate", "mount"], B4 = typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__, Jj = /(?:^|[-_])(\w)/g, $j = (e) => e.replace(Jj, (t) => t.toUpperCase()).replace(/[-_]/g, ""), _j = "<Root>", ig = "<Anonymous>", eH = (e, t) => e.repeat(t), su = (e, t) => {
  if (!e)
    return ig;
  if (e.$root === e)
    return _j;
  if (!e.$options)
    return ig;
  const s = e.$options;
  let n = s.name || s._componentTag || s.__name;
  const r = s.__file;
  if (!n && r) {
    const i = r.match(/([^/\\]+)\.vue$/);
    i && (n = i[1]);
  }
  return (n ? `<${$j(n)}>` : ig) + (r && t !== !1 ? ` at ${r}` : "");
}, tH = (e) => {
  if (e && (e._isVue || e.__isVue) && e.$parent) {
    const t = [];
    let s = 0;
    for (; e; ) {
      if (t.length > 0) {
        const r = t[t.length - 1];
        if (r.constructor === e.constructor) {
          s++, e = e.$parent;
          continue;
        } else s > 0 && (t[t.length - 1] = [r, s], s = 0);
      }
      t.push(e), e = e.$parent;
    }
    return `

found in

${t.map(
      (r, i) => `${(i === 0 ? "---> " : eH(" ", 5 + i * 2)) + (Array.isArray(r) ? `${su(r[0])}... (${r[1]} recursive calls)` : su(r))}`
    ).join(`
`)}`;
  }
  return `

(found in ${su(e)})`;
}, sH = (e, t) => {
  const { errorHandler: s } = e.config;
  e.config.errorHandler = (n, r, i) => {
    var c;
    const o = su(r, !1), l = r ? tH(r) : "", d = {
      componentName: o,
      lifecycleHook: i,
      trace: l
    };
    if (t.attachProps && r && ((c = r.$options) != null && c.propsData ? d.propsData = r.$options.propsData : r.$props && (d.propsData = r.$props)), setTimeout(() => {
      Ns(n, {
        captureContext: { contexts: { vue: d } },
        mechanism: { handled: !!s, type: "vue" }
      });
    }), typeof s == "function" && e.config.errorHandler)
      s.call(e, n, r, i);
    else
      throw n;
  };
}, Ew = "ui.vue", aH = {
  activate: ["activated", "deactivated"],
  create: ["beforeCreate", "created"],
  // Vue 3
  unmount: ["beforeUnmount", "unmounted"],
  // Vue 2
  destroy: ["beforeDestroy", "destroyed"],
  mount: ["beforeMount", "mounted"],
  update: ["beforeUpdate", "updated"]
};
function lg(e, t, s) {
  e.$_sentryRootComponentSpanTimer && clearTimeout(e.$_sentryRootComponentSpanTimer), e.$_sentryRootComponentSpanTimer = setTimeout(() => {
    var n;
    (n = e.$root) != null && n.$_sentryRootComponentSpan && (e.$root.$_sentryRootComponentSpan.end(t), e.$root.$_sentryRootComponentSpan = void 0);
  }, s);
}
function nH(e, t) {
  function s(r) {
    return r.replace(/^<([^\s]*)>(?: at [^\s]*)?$/, "$1");
  }
  return e.some((r) => s(t) === s(r));
}
const rH = (e = {}) => {
  const t = (e.hooks || []).concat(L4).filter((r, i, o) => o.indexOf(r) === i), s = {}, n = e.timeout || 2e3;
  for (const r of t) {
    const i = aH[r];
    if (!i) {
      B4 && ot.warn(`Unknown hook: ${r}`);
      continue;
    }
    for (const o of i)
      s[o] = function() {
        var f;
        const l = this.$root === this;
        l && (this.$_sentryRootComponentSpan = this.$_sentryRootComponentSpan || bi({
          name: "Application Render",
          op: `${Ew}.render`,
          attributes: {
            [Ca]: "auto.ui.vue"
          },
          onlyIfParent: !0
        }), lg(this, Ea(), n));
        const d = su(this, !1);
        if (!(l || // We always want to track the root component
        (Array.isArray(e.trackComponents) ? nH(e.trackComponents, d) : e.trackComponents))) {
          lg(this, Ea(), n);
          return;
        }
        this.$_sentryComponentSpans = this.$_sentryComponentSpans || {};
        const u = o === i[0], m = ((f = this.$root) == null ? void 0 : f.$_sentryRootComponentSpan) || Ja();
        if (u) {
          if (m) {
            const v = this.$_sentryComponentSpans[r];
            v && v.end(), this.$_sentryComponentSpans[r] = bi({
              name: `Vue ${d}`,
              op: `${Ew}.${r}`,
              attributes: {
                [Ca]: "auto.ui.vue"
              },
              // UI spans should only be created if there is an active root span (transaction)
              onlyIfParent: !0
            });
          }
        } else {
          const v = this.$_sentryComponentSpans[r];
          if (!v) return;
          v.end(), lg(this, Ea(), n);
        }
      };
  }
  return s;
}, oH = As, iH = {
  Vue: oH.Vue,
  attachProps: !0,
  attachErrorHandler: !0,
  tracingOptions: {
    hooks: L4,
    timeout: 2e3,
    trackComponents: !1
  }
}, lH = "Vue", M4 = (e = {}) => ({
  name: lH,
  setup(t) {
    const s = { ...iH, ...t.getOptions(), ...e };
    if (!s.Vue && !s.app) {
      Yo(() => {
        console.warn(
          "[@sentry/vue]: Misconfigured SDK. Vue specific errors will not be captured. Update your `Sentry.init` call with an appropriate config option: `app` (Application Instance - Vue 3) or `Vue` (Vue Constructor - Vue 2)."
        );
      });
      return;
    }
    s.app ? (Array.isArray(s.app) ? s.app : [s.app]).forEach((r) => Iw(r, s)) : s.Vue && Iw(s.Vue, s);
  }
}), Iw = (e, t) => {
  var s;
  B4 && ((s = e._instance) == null ? void 0 : s.isMounted) === !0 && Yo(() => {
    console.warn(
      "[@sentry/vue]: Misconfigured SDK. Vue app is already mounted. Make sure to call `app.mount()` after `Sentry.init()`."
    );
  }), t.attachErrorHandler && sH(e, t), xo(t) && e.mixin(rH(t.tracingOptions));
};
function dH(e = {}) {
  const t = {
    defaultIntegrations: [...m8(), M4()],
    ...e
  };
  return b3(t, "vue"), Vx(t);
}
function cH(e, t, s) {
  let n = !1;
  e.onError((r) => Ns(r, { mechanism: { handled: !1 } })), e.beforeEach((r, i, o) => {
    const l = n ? void 0 : uH(), d = {};
    for (const m of Object.keys(r.params))
      d[`url.path.parameter.${m}`] = r.params[m], d[`params.${m}`] = r.params[m];
    for (const m of Object.keys(r.query)) {
      const f = r.query[m];
      f && (d[`query.${m}`] = f);
    }
    let c = r.path, u = "url";
    if (r.name && t.routeLabel !== "path")
      c = r.name.toString(), u = "custom";
    else if (r.matched.length > 0) {
      const m = r.matched.length - 1;
      c = r.matched[m].path, u = "route";
    }
    Is().setTransactionName(c), t.instrumentPageLoad && l && (ms(l).data[Tn] !== "custom" && (l.updateName(c), l.setAttribute(Tn, u)), l.setAttributes({
      ...d,
      [Ca]: "auto.pageload.vue"
    }), n = !0), t.instrumentNavigation && !l && s({
      name: c,
      op: "navigation",
      attributes: {
        ...d,
        [Ca]: "auto.navigation.vue",
        [Tn]: u
      }
    }), o && o();
  });
}
function uH() {
  const e = Ja(), t = e && Wa(e);
  return t && ms(t).op === "pageload" ? t : void 0;
}
function pH(e = {}) {
  if (!e.router)
    return mw(e);
  const t = mw({
    ...e,
    instrumentNavigation: !1
  }), { router: s, instrumentNavigation: n = !0, instrumentPageLoad: r = !0, routeLabel: i = "name" } = e;
  return {
    ...t,
    afterAllSetup(o) {
      t.afterAllSetup(o), cH(s, { routeLabel: i, instrumentNavigation: n, instrumentPageLoad: r }, (d) => {
        p4(o, d);
      });
    }
  };
}
const hH = "en", Tw = ["ar", "cy", "da", "de", "en", "es", "fr", "hi", "ja", "ko", "mi", "nl", "pt", "sv", "tr", "zh"], mH = [
  { code: "ar-sa", dir: "rtl", name: "العربية (المملكة العربية السعودية)" },
  { code: "cy-gb", dir: "ltr", name: "Cymraeg (Y Deyrnas Unedig)" },
  { code: "da-dk", dir: "ltr", name: "Dansk (danmark)" },
  { code: "de-de", dir: "ltr", name: "Deutsch (Deutschland)" },
  { code: "en-ca", dir: "ltr", name: "English (Canada)" },
  { code: "en-gb", dir: "ltr", name: "English (United Kingdom)" },
  { code: "en-us", dir: "ltr", name: "English (United States)" },
  { code: "es-es", dir: "ltr", name: "Español (España)" },
  { code: "es-mx", dir: "ltr", name: "Español (Latinoamérica)" },
  { code: "fr-ca", dir: "ltr", name: "Français (Canada)" },
  { code: "fr-fr", dir: "ltr", name: "Français (France)" },
  { code: "fr-on", dir: "ltr", name: "Français (Ontario)" },
  { code: "hi-in", dir: "ltr", name: "हिंदी (भारत)" },
  { code: "ja-jp", dir: "ltr", name: "日本語 (日本)" },
  { code: "ko-kr", dir: "ltr", name: "한국어 (대한민국)" },
  { code: "mi-nz", dir: "ltr", name: "Māori (Aotearoa)" },
  { code: "nl-nl", dir: "ltr", name: "Nederlands (Nederland)" },
  { code: "pt-br", dir: "ltr", name: "Português (Brasil)" },
  { code: "sv-se", dir: "ltr", name: "Svenska (Sverige)" },
  { code: "tr-tr", dir: "ltr", name: "Türkçe (Türkiye)" },
  { code: "zh-cn", dir: "ltr", name: "中文(简体)" },
  { code: "zh-tw", dir: "ltr", name: "中文(繁体)" }
], fH = mH.map((e) => e.code);
function Ow(e) {
  if (e == null) return null;
  if (fH.indexOf(e) > -1)
    return e;
  const t = e.split("-");
  return t.length < 2 ? Tw.indexOf(e) > -1 ? e : null : Tw.indexOf(t[0]) > -1 ? t[0] : null;
}
function gH() {
  const e = F4();
  return Ow(e.language) || Ow(e.fallbackLanguage) || hH;
}
function x4(e, t) {
  if (!(t == null || typeof t != "object"))
    for (const s in t)
      e.hasOwnProperty(s) && (typeof t[s] == "object" && typeof e[s] == "object" ? x4(e[s], t[s]) : e[s] = t[s]);
}
class vH {
  constructor() {
    Xe(this, "_cache");
    Xe(this, "_htmlElem");
    Xe(this, "_listeners");
    Xe(this, "_overrides");
    Xe(this, "_observer");
    Xe(this, "_languageInitial");
    Xe(this, "_language");
    Xe(this, "_fallbackLanguage");
    Xe(this, "timezone");
    Xe(this, "oslo");
    this._cache = /* @__PURE__ */ new Map(), this._htmlElem = window.document.getElementsByTagName("html")[0], this._listeners = [], this._overrides = {}, this._observer = new MutationObserver(this._handleObserverChange.bind(this)), this._observer.observe(this._htmlElem, { attributes: !0 }), this.sync(), this._languageInitial = this._language;
  }
  get fallbackLanguage() {
    return this._fallbackLanguage;
  }
  set fallbackLanguage(t) {
    const s = this._normalize(t);
    s !== this._fallbackLanguage && (this._cache.clear(), this._fallbackLanguage = s, this._listeners.forEach((n) => n()));
  }
  get language() {
    return this._language;
  }
  set language(t) {
    const s = this._normalize(t);
    s !== this._language && (this._cache.clear(), this._language = s, this._listeners.forEach((n) => n()));
  }
  get overrides() {
    return this._overrides;
  }
  set overrides(t) {
    t.date && (t.date.calendar && delete t.date.calendar.dayPeriods, t.date.formats && delete t.date.formats.timeFormats), this._cache.clear(), this._overrides = t, this._listeners.forEach((s) => s());
  }
  addChangeListener(t) {
    this._listeners.push(t);
  }
  getCacheItem(t, s) {
    return this._cache.has(t) || this._cache.set(t, s()), this._cache.get(t);
  }
  removeChangeListener(t) {
    const s = this._listeners.indexOf(t);
    s < 0 || this._listeners.splice(s, 1);
  }
  reset() {
    this._cache.clear(), this._language = this._languageInitial, this._fallbackLanguage = null, this.overrides = {}, this.timezone = { name: "", identifier: "" }, this._listeners = [], this.oslo = { batch: null, collection: null, version: null };
  }
  sync() {
    this.language = this._htmlElem.getAttribute("lang"), this.fallbackLanguage = this._htmlElem.getAttribute("data-lang-default"), this.overrides = this._tryParseHtmlElemAttr("data-intl-overrides", {}), this.timezone = this._tryParseHtmlElemAttr("data-timezone", { name: "", identifier: "" }), this.oslo = this._tryParseHtmlElemAttr("data-oslo", { batch: null, collection: null, version: null });
  }
  _handleObserverChange(t) {
    let s = !1;
    for (let n = 0; n < t.length; n++) {
      const r = t[n];
      r.attributeName === "lang" ? this.language = this._htmlElem.getAttribute("lang") : r.attributeName === "data-lang-default" ? this.fallbackLanguage = this._htmlElem.getAttribute("data-lang-default") : r.attributeName === "data-intl-overrides" ? this.overrides = this._tryParseHtmlElemAttr("data-intl-overrides", {}) : r.attributeName === "data-timezone" ? (this.timezone = this._tryParseHtmlElemAttr("data-timezone", { name: "", identifier: "" }), s = !0) : r.attributeName === "data-oslo" && (this.oslo = this._tryParseHtmlElemAttr("data-oslo", { batch: null, collection: null, version: null }), s = !0);
    }
    s && this._listeners.forEach((n) => n());
  }
  _normalize(t) {
    if (t == null) return null;
    t = t.trim().toLowerCase();
    const s = t.split("-");
    return s.length < 2 ? t : `${s[0]}-${s[s.length - 1]}`;
  }
  _tryParseHtmlElemAttr(t, s) {
    if (this._htmlElem.hasAttribute(t))
      try {
        return JSON.parse(this._htmlElem.getAttribute(t));
      } catch {
      }
    return s;
  }
}
let dg = null;
function F4() {
  return dg === null && (dg = new vH()), dg;
}
function yH(e) {
  if (e == null)
    return 0;
  const t = bH();
  if (e = e.replace(
    new RegExp(`\\s|[${t.symbols.group}]`, "g"),
    ""
  ), e === "")
    return 0;
  let s = "", n = !1, r = !1, i = !1;
  for (let l = 0; l < e.length; l++) {
    const d = e.charAt(l);
    switch (d) {
      case t.symbols.decimal:
        s += r ? "" : ".", r = !0;
        break;
      case t.symbols.negative:
      case "(":
      case ")":
        n = !0;
        break;
      default: {
        const c = parseInt(d);
        !isNaN(c) && c >= 0 && c <= 9 ? s += d : i = !0;
      }
    }
    if (i)
      break;
  }
  if (s.length === 0)
    return NaN;
  let o = parseFloat(s);
  return n && (o = o * -1), o;
}
function bH() {
  const e = gH(), s = e.split("-")[0];
  let n = "-{number}";
  s === "ar" && (n = "{number}-");
  let r = "{number} %", i = "-{number} %";
  switch (s) {
    case "es":
    case "hi":
    case "ja":
    case "mi":
    case "pt":
    case "zh":
      r = "{number}%", i = "-{number}%";
      break;
    case "tr":
      r = "%{number}", i = "-%{number}";
      break;
  }
  let o = ".", l = ",";
  switch (s) {
    case "da":
    case "de":
    case "es":
    case "nl":
    case "pt":
    case "tr":
      o = ",", l = ".";
      break;
    case "fr":
    case "sv":
      o = ",", l = " ";
      break;
  }
  switch (e) {
    case "es-mx":
      o = ".", l = ",";
      break;
  }
  const d = {
    groupSize: 3,
    patterns: {
      decimal: {
        positivePattern: "{number}",
        negativePattern: n
      },
      percent: {
        positivePattern: r,
        negativePattern: i
      }
    },
    symbols: {
      decimal: o,
      group: l,
      negative: "-",
      percent: "%"
    }
  }, c = F4();
  return c.overrides.number && x4(d, c.overrides.number), d;
}
const AH = "array", wH = "bit", Rw = "bits", CH = "byte", Lw = "bytes", bo = "", SH = "exponent", PH = "function", Bw = "iec", kH = "Invalid number", EH = "Invalid rounding method", cg = "jedec", IH = "object", Mw = ".", V4 = "round", TH = "s", OH = "si", RH = "kbit", LH = "kB", D4 = " ", N4 = "string", BH = "0", ug = {
  symbol: {
    iec: {
      bits: ["bit", "Kibit", "Mibit", "Gibit", "Tibit", "Pibit", "Eibit", "Zibit", "Yibit"],
      bytes: ["B", "KiB", "MiB", "GiB", "TiB", "PiB", "EiB", "ZiB", "YiB"]
    },
    jedec: {
      bits: ["bit", "Kbit", "Mbit", "Gbit", "Tbit", "Pbit", "Ebit", "Zbit", "Ybit"],
      bytes: ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]
    }
  },
  fullform: {
    iec: ["", "kibi", "mebi", "gibi", "tebi", "pebi", "exbi", "zebi", "yobi"],
    jedec: ["", "kilo", "mega", "giga", "tera", "peta", "exa", "zetta", "yotta"]
  }
};
function MH(e, {
  bits: t = !1,
  pad: s = !1,
  base: n = -1,
  round: r = 2,
  locale: i = bo,
  localeOptions: o = {},
  separator: l = bo,
  spacer: d = D4,
  symbols: c = {},
  standard: u = bo,
  output: m = N4,
  fullform: f = !1,
  fullforms: v = [],
  exponent: b = -1,
  roundingMethod: w = V4,
  precision: S = 0
} = {}) {
  let I = b, T = Number(e), x = [], k = 0, C = bo;
  u === OH ? (n = 10, u = cg) : u === Bw || u === cg ? n = 2 : n === 2 ? u = Bw : (n = 10, u = cg);
  const O = n === 10 ? 1e3 : 1024, E = f === !0, B = T < 0, M = Math[w];
  if (typeof e != "bigint" && isNaN(e))
    throw new TypeError(kH);
  if (typeof M !== PH)
    throw new TypeError(EH);
  if (B && (T = -T), (I === -1 || isNaN(I)) && (I = Math.floor(Math.log(T) / Math.log(O)), I < 0 && (I = 0)), I > 8 && (S > 0 && (S += 8 - I), I = 8), m === SH)
    return I;
  if (T === 0)
    x[0] = 0, C = x[1] = ug.symbol[u][t ? Rw : Lw][I];
  else {
    k = T / (n === 2 ? Math.pow(2, I * 10) : Math.pow(1e3, I)), t && (k = k * 8, k >= O && I < 8 && (k = k / O, I++));
    const R = Math.pow(10, I > 0 ? r : 0);
    x[0] = M(k * R) / R, x[0] === O && I < 8 && b === -1 && (x[0] = 1, I++), C = x[1] = n === 10 && I === 1 ? t ? RH : LH : ug.symbol[u][t ? Rw : Lw][I];
  }
  if (B && (x[0] = -x[0]), S > 0 && (x[0] = x[0].toPrecision(S)), x[1] = c[x[1]] || x[1], i === !0 ? x[0] = x[0].toLocaleString() : i.length > 0 ? x[0] = x[0].toLocaleString(i, o) : l.length > 0 && (x[0] = x[0].toString().replace(Mw, l)), s && r > 0) {
    const R = x[0].toString(), F = l || (R.match(/(\D)/g) || []).pop() || Mw, L = R.toString().split(F), j = L[1] || bo, H = j.length, te = r - H;
    x[0] = `${L[0]}${F}${j.padEnd(H + te, BH)}`;
  }
  return E && (x[1] = v[I] ? v[I] : ug.fullform[u][I] + (t ? wH : CH) + (x[0] === 1 ? bo : TH)), m === AH ? x : m === IH ? {
    value: x[0],
    symbol: x[1],
    exponent: I,
    unit: C
  } : x.join(d);
}
function tb({
  bits: e = !1,
  pad: t = !1,
  base: s = -1,
  round: n = 2,
  locale: r = bo,
  localeOptions: i = {},
  separator: o = bo,
  spacer: l = D4,
  symbols: d = {},
  standard: c = bo,
  output: u = N4,
  fullform: m = !1,
  fullforms: f = [],
  exponent: v = -1,
  roundingMethod: b = V4,
  precision: w = 0
} = {}) {
  return (S) => MH(S, {
    bits: e,
    pad: t,
    base: s,
    round: n,
    locale: r,
    localeOptions: i,
    separator: o,
    spacer: l,
    symbols: d,
    standard: c,
    output: u,
    fullform: m,
    fullforms: f,
    exponent: v,
    roundingMethod: b,
    precision: w
  });
}
const xH = /^\d[\d,.]*$/s, Jv = new Intl.NumberFormat("en-US", {
  minimumFractionDigits: 0,
  maximumFractionDigits: 0
}), j4 = new Intl.NumberFormat("en-US", {
  minimumFractionDigits: 0,
  maximumFractionDigits: 1
}), H4 = new Intl.NumberFormat("en-US", {
  minimumFractionDigits: 0,
  maximumFractionDigits: 2
}), FH = new Intl.NumberFormat("en-US", {
  minimumFractionDigits: 0,
  maximumFractionDigits: 3
}), U4 = new Intl.DateTimeFormat("en-US", {
  year: "numeric",
  month: "numeric",
  day: "numeric"
}), VH = new Intl.DateTimeFormat("en-US", {
  year: "numeric",
  month: "numeric",
  day: "numeric",
  timeZone: "UTC"
}), z4 = new Intl.DateTimeFormat("en-US", {
  dateStyle: "medium"
}), DH = new Intl.DateTimeFormat("en-US", {
  timeZone: "UTC"
  //dateStyle: 'long'
}), NH = Intl.DateTimeFormat("en-US", {
  month: "short"
}), jH = Intl.DateTimeFormat("en-US", {
  month: "long"
}), HH = new Intl.DateTimeFormat("en-US", {
  year: "numeric",
  month: "numeric",
  day: "numeric",
  hour: "numeric",
  minute: "numeric",
  hour12: !0
}), UH = new Intl.DateTimeFormat("en-US", {
  year: "numeric",
  month: "numeric",
  day: "numeric",
  hour: "numeric",
  minute: "numeric",
  hour12: !0,
  timeZone: "UTC"
}), zH = new Intl.DateTimeFormat("en-US", {
  dateStyle: "medium",
  timeStyle: "medium",
  hour12: !0
}), WH = new Intl.DateTimeFormat("en-US", {
  timeZone: "UTC",
  dateStyle: "medium",
  timeStyle: "medium",
  hourCycle: "h12"
  //dateStyle: 'long'
}), fm = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 0,
  maximumFractionDigits: 0
}), gm = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
}), GH = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 1,
  maximumFractionDigits: 1
}), YH = new Intl.NumberFormat("en-US", {
  style: "percent",
  minimumFractionDigits: 0
}), XH = new Intl.NumberFormat("en-US", {
  style: "percent",
  minimumFractionDigits: 1,
  /* @ts-expect-error roundingMode is newish */
  roundingMode: "trunc"
}), qH = new Intl.NumberFormat("en-US", {
  style: "percent",
  minimumFractionDigits: 2,
  /* @ts-expect-error roundingMode is newish */
  roundingMode: "trunc"
}), QH = new Intl.NumberFormat("en-US", {
  style: "percent",
  minimumFractionDigits: 3,
  /* @ts-expect-error roundingMode is newish */
  roundingMode: "trunc"
}), KH = tb({ round: 0 }), ZH = tb({ round: 1 }), JH = tb({ round: 2 });
function W4(e, t = 0, s = "") {
  if (e == null || isNaN(e))
    return s;
  switch (t) {
    case 1:
      return ZH(e);
    case 2:
      return JH(e);
    default:
      return KH(e);
  }
}
function Ve(e, t = 0, s = "") {
  if (e == null || isNaN(e))
    return s;
  switch (t) {
    case 1:
      return j4.format(e);
    case 2:
      return H4.format(e);
    case 3:
      return FH.format(e);
    default:
      return Jv.format(e);
  }
}
function vr(e, t = "") {
  return e == null || isNaN(e) ? t : e >= 99e4 || e <= -99e4 ? H4.format(e / 1e6) + "M" : e >= 1e4 || e <= -1e4 ? Jv.format(e / 1e3) + "K" : e >= 1e3 || e <= -1e3 ? j4.format(Math.trunc(e / 100) / 10) + "K" : Jv.format(e);
}
function af(e, t = 2) {
  let s = "", n = 0;
  return e.years && (e.years == 1 ? s += e.years + " year, " : s += e.years + " years, ", n++), n >= t || (e.months && (e.months == 1 ? s += e.months + " month, " : s += e.months + " months, ", n++), n >= t) || (e.weeks && (e.weeks == 1 ? s += e.weeks + " week, " : s += e.weeks + " weeks, ", n++), n >= t) || (e.days && (e.days == 1 ? s += e.days + " day, " : s += e.days + " days, ", n++), n >= t) || (e.hours && (e.hours == 1 ? s += e.hours + " hour, " : s += e.hours + " hours, ", n++), n >= t) ? s.substring(0, s.length - 2) : ((e.hours ?? 0) < 1 && e.minutes && (e.minutes == 1 ? s += e.minutes + " minute, " : s += e.minutes + " minutes, "), s.endsWith(", ") && (s = s.substring(0, s.length - 2)), s || "No time difference");
}
function ka(e, t = "") {
  return e == null || isNaN(e) ? t : e >= 99e7 || e <= -99e7 ? gm.format(e / 1e9) + "B" : e >= 99e4 || e <= -99e4 ? gm.format(e / 1e6) + "M" : e >= 1e5 || e <= -1e5 ? fm.format(e / 1e3) + "K" : e >= 1e4 || e <= -1e4 ? GH.format(e / 1e3) + "K" : fm.format(e);
}
function sb(e, t = !1) {
  return console.warn("Calling deprecated formatters.formatDate() function! Use formatters.date()"), !e || Number.isFinite(e) && e == 0 || e instanceof Date && e.getTime() == 0 ? "" : t ? z4.format(e) : U4.format(e);
}
function cs(e, t = !1, s = "") {
  return !e || Number.isFinite(e) && e == 0 || e instanceof Date && e.getTime() == 0 ? s : t ? z4.format(e) : U4.format(e);
}
function G4(e, t = !1, s = "") {
  return !e || Number.isFinite(e) && e == 0 || e instanceof Date && e.getTime() == 0 ? s : (typeof e == "number" && (e = new Date(2024, e - 1)), t ? jH.format(e) : NH.format(e));
}
function Y4(e, t = !1, s = "") {
  return !e || Number.isFinite(e) && e == 0 || e instanceof Date && e.getTime() == 0 ? s : t ? DH.format(e) : VH.format(e);
}
function nf(e, t = !1, s = "") {
  return !e || Number.isFinite(e) && e == 0 || e instanceof Date && e.getTime() == 0 ? s : t ? zH.format(e) : HH.format(e);
}
function $H(e, t = !1, s = "") {
  return !e || Number.isFinite(e) && e == 0 || e instanceof Date && e.getTime() == 0 ? s : t ? WH.format(e) : UH.format(e);
}
function Ze(e, t = !1, s = "", n = !1) {
  return e == null || isNaN(e) || e == 0 && n ? s : t ? gm.format(e) : fm.format(Math.trunc(e));
}
function Yu(e, t = "", s = !1) {
  return e == null || isNaN(e) || e == 0 && s ? t : Math.trunc(e) - e != 0 ? gm.format(e) : fm.format(Math.trunc(e));
}
function Wt(e, t = 0, s = "", n = !1) {
  if (e == null || isNaN(e))
    return s;
  switch (n && Math.trunc(e * 100) - e * 100 != 0 && (t = 1), t) {
    case 1:
      return XH.format(e);
    case 2:
      return qH.format(e);
    case 3:
      return QH.format(e);
    default:
      return YH.format(e);
  }
}
function X4(e, t = "") {
  return Wt(e, 0, t, !0);
}
function vs(e) {
  return typeof e == "number" ? e : yH(e);
}
function Jo(e) {
  return xH.test(e);
}
const Bis = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  currency: Ze,
  currencyOptCents: Yu,
  date: cs,
  dateTime: nf,
  dateTimeUTC: $H,
  dateUTC: Y4,
  fileSize: W4,
  formatDate: sb,
  formatDuration: af,
  month: G4,
  number: Ve,
  parse: vs,
  percent: Wt,
  percentAutoDec: X4,
  shortCurrency: ka,
  shortNumber: vr,
  test: Jo
}, Symbol.toStringTag, { value: "Module" }));
var Zn = function() {
  return Zn = Object.assign || function(t) {
    for (var s, n = 1, r = arguments.length; n < r; n++) {
      s = arguments[n];
      for (var i in s) Object.prototype.hasOwnProperty.call(s, i) && (t[i] = s[i]);
    }
    return t;
  }, Zn.apply(this, arguments);
}, _H = (
  /** @class */
  function() {
    function e(t) {
      this.options = t, this.listeners = {};
    }
    return e.prototype.on = function(t, s) {
      var n = this.listeners[t] || [];
      this.listeners[t] = n.concat([s]);
    }, e.prototype.triggerEvent = function(t, s) {
      var n = this, r = this.listeners[t] || [];
      r.forEach(function(i) {
        return i({ target: n, event: s });
      });
    }, e;
  }()
), Od;
(function(e) {
  e[e.Add = 0] = "Add", e[e.Remove = 1] = "Remove";
})(Od || (Od = {}));
var eU = (
  /** @class */
  function() {
    function e() {
      this.notifications = [];
    }
    return e.prototype.push = function(t) {
      this.notifications.push(t), this.updateFn(t, Od.Add, this.notifications);
    }, e.prototype.splice = function(t, s) {
      var n = this.notifications.splice(t, s)[0];
      return this.updateFn(n, Od.Remove, this.notifications), n;
    }, e.prototype.indexOf = function(t) {
      return this.notifications.indexOf(t);
    }, e.prototype.onUpdate = function(t) {
      this.updateFn = t;
    }, e;
  }()
), di;
(function(e) {
  e.Dismiss = "dismiss", e.Click = "click";
})(di || (di = {}));
var xw = {
  types: [
    {
      type: "success",
      className: "notyf__toast--success",
      backgroundColor: "#3dc763",
      icon: {
        className: "notyf__icon--success",
        tagName: "i"
      }
    },
    {
      type: "error",
      className: "notyf__toast--error",
      backgroundColor: "#ed3d3d",
      icon: {
        className: "notyf__icon--error",
        tagName: "i"
      }
    }
  ],
  duration: 2e3,
  ripple: !0,
  position: {
    x: "right",
    y: "bottom"
  },
  dismissible: !1
}, tU = (
  /** @class */
  function() {
    function e() {
      this.notifications = [], this.events = {}, this.X_POSITION_FLEX_MAP = {
        left: "flex-start",
        center: "center",
        right: "flex-end"
      }, this.Y_POSITION_FLEX_MAP = {
        top: "flex-start",
        center: "center",
        bottom: "flex-end"
      };
      var t = document.createDocumentFragment(), s = this._createHTMLElement({ tagName: "div", className: "notyf" });
      t.appendChild(s), document.body.appendChild(t), this.container = s, this.animationEndEventName = this._getAnimationEndEventName(), this._createA11yContainer();
    }
    return e.prototype.on = function(t, s) {
      var n;
      this.events = Zn(Zn({}, this.events), (n = {}, n[t] = s, n));
    }, e.prototype.update = function(t, s) {
      s === Od.Add ? this.addNotification(t) : s === Od.Remove && this.removeNotification(t);
    }, e.prototype.removeNotification = function(t) {
      var s = this, n = this._popRenderedNotification(t), r;
      if (n) {
        r = n.node, r.classList.add("notyf__toast--disappear");
        var i;
        r.addEventListener(this.animationEndEventName, i = function(o) {
          o.target === r && (r.removeEventListener(s.animationEndEventName, i), s.container.removeChild(r));
        });
      }
    }, e.prototype.addNotification = function(t) {
      var s = this._renderNotification(t);
      this.notifications.push({ notification: t, node: s }), this._announce(t.options.message || "Notification");
    }, e.prototype._renderNotification = function(t) {
      var s, n = this._buildNotificationCard(t), r = t.options.className;
      return r && (s = n.classList).add.apply(s, r.split(" ")), this.container.appendChild(n), n;
    }, e.prototype._popRenderedNotification = function(t) {
      for (var s = -1, n = 0; n < this.notifications.length && s < 0; n++)
        this.notifications[n].notification === t && (s = n);
      if (s !== -1)
        return this.notifications.splice(s, 1)[0];
    }, e.prototype.getXPosition = function(t) {
      var s;
      return ((s = t == null ? void 0 : t.position) === null || s === void 0 ? void 0 : s.x) || "right";
    }, e.prototype.getYPosition = function(t) {
      var s;
      return ((s = t == null ? void 0 : t.position) === null || s === void 0 ? void 0 : s.y) || "bottom";
    }, e.prototype.adjustContainerAlignment = function(t) {
      var s = this.X_POSITION_FLEX_MAP[this.getXPosition(t)], n = this.Y_POSITION_FLEX_MAP[this.getYPosition(t)], r = this.container.style;
      r.setProperty("justify-content", n), r.setProperty("align-items", s);
    }, e.prototype._buildNotificationCard = function(t) {
      var s = this, n = t.options, r = n.icon;
      this.adjustContainerAlignment(n);
      var i = this._createHTMLElement({ tagName: "div", className: "notyf__toast" }), o = this._createHTMLElement({ tagName: "div", className: "notyf__ripple" }), l = this._createHTMLElement({ tagName: "div", className: "notyf__wrapper" }), d = this._createHTMLElement({ tagName: "div", className: "notyf__message" });
      d.innerHTML = n.message || "";
      var c = n.background || n.backgroundColor;
      if (r) {
        var u = this._createHTMLElement({ tagName: "div", className: "notyf__icon" });
        if ((typeof r == "string" || r instanceof String) && (u.innerHTML = new String(r).valueOf()), typeof r == "object") {
          var m = r.tagName, f = m === void 0 ? "i" : m, v = r.className, b = r.text, w = r.color, S = w === void 0 ? c : w, I = this._createHTMLElement({ tagName: f, className: v, text: b });
          S && (I.style.color = S), u.appendChild(I);
        }
        l.appendChild(u);
      }
      if (l.appendChild(d), i.appendChild(l), c && (n.ripple ? (o.style.background = c, i.appendChild(o)) : i.style.background = c), n.dismissible) {
        var T = this._createHTMLElement({ tagName: "div", className: "notyf__dismiss" }), x = this._createHTMLElement({
          tagName: "button",
          className: "notyf__dismiss-btn"
        });
        T.appendChild(x), l.appendChild(T), i.classList.add("notyf__toast--dismissible"), x.addEventListener("click", function(C) {
          var O, E;
          (E = (O = s.events)[di.Dismiss]) === null || E === void 0 || E.call(O, { target: t, event: C }), C.stopPropagation();
        });
      }
      i.addEventListener("click", function(C) {
        var O, E;
        return (E = (O = s.events)[di.Click]) === null || E === void 0 ? void 0 : E.call(O, { target: t, event: C });
      });
      var k = this.getYPosition(n) === "top" ? "upper" : "lower";
      return i.classList.add("notyf__toast--" + k), i;
    }, e.prototype._createHTMLElement = function(t) {
      var s = t.tagName, n = t.className, r = t.text, i = document.createElement(s);
      return n && (i.className = n), i.textContent = r || null, i;
    }, e.prototype._createA11yContainer = function() {
      var t = this._createHTMLElement({ tagName: "div", className: "notyf-announcer" });
      t.setAttribute("aria-atomic", "true"), t.setAttribute("aria-live", "polite"), t.style.border = "0", t.style.clip = "rect(0 0 0 0)", t.style.height = "1px", t.style.margin = "-1px", t.style.overflow = "hidden", t.style.padding = "0", t.style.position = "absolute", t.style.width = "1px", t.style.outline = "0", document.body.appendChild(t), this.a11yContainer = t;
    }, e.prototype._announce = function(t) {
      var s = this;
      this.a11yContainer.textContent = "", setTimeout(function() {
        s.a11yContainer.textContent = t;
      }, 100);
    }, e.prototype._getAnimationEndEventName = function() {
      var t = document.createElement("_fake"), s = {
        MozTransition: "animationend",
        OTransition: "oAnimationEnd",
        WebkitTransition: "webkitAnimationEnd",
        transition: "animationend"
      }, n;
      for (n in s)
        if (t.style[n] !== void 0)
          return s[n];
      return "animationend";
    }, e;
  }()
), sU = (
  /** @class */
  function() {
    function e(t) {
      var s = this;
      this.dismiss = this._removeNotification, this.notifications = new eU(), this.view = new tU();
      var n = this.registerTypes(t);
      this.options = Zn(Zn({}, xw), t), this.options.types = n, this.notifications.onUpdate(function(r, i) {
        return s.view.update(r, i);
      }), this.view.on(di.Dismiss, function(r) {
        var i = r.target, o = r.event;
        s._removeNotification(i), i.triggerEvent(di.Dismiss, o);
      }), this.view.on(di.Click, function(r) {
        var i = r.target, o = r.event;
        return i.triggerEvent(di.Click, o);
      });
    }
    return e.prototype.error = function(t) {
      var s = this.normalizeOptions("error", t);
      return this.open(s);
    }, e.prototype.success = function(t) {
      var s = this.normalizeOptions("success", t);
      return this.open(s);
    }, e.prototype.open = function(t) {
      var s = this.options.types.find(function(i) {
        var o = i.type;
        return o === t.type;
      }) || {}, n = Zn(Zn({}, s), t);
      this.assignProps(["ripple", "position", "dismissible"], n);
      var r = new _H(n);
      return this._pushNotification(r), r;
    }, e.prototype.dismissAll = function() {
      for (; this.notifications.splice(0, 1); )
        ;
    }, e.prototype.assignProps = function(t, s) {
      var n = this;
      t.forEach(function(r) {
        s[r] = s[r] == null ? n.options[r] : s[r];
      });
    }, e.prototype._pushNotification = function(t) {
      var s = this;
      this.notifications.push(t);
      var n = t.options.duration !== void 0 ? t.options.duration : this.options.duration;
      n && setTimeout(function() {
        return s._removeNotification(t);
      }, n);
    }, e.prototype._removeNotification = function(t) {
      var s = this.notifications.indexOf(t);
      s !== -1 && this.notifications.splice(s, 1);
    }, e.prototype.normalizeOptions = function(t, s) {
      var n = { type: t };
      return typeof s == "string" ? n.message = s : typeof s == "object" && (n = Zn(Zn({}, n), s)), n;
    }, e.prototype.registerTypes = function(t) {
      var s = (t && t.types || []).slice(), n = xw.types.map(function(r) {
        var i = -1;
        s.forEach(function(l, d) {
          l.type === r.type && (i = d);
        });
        var o = i !== -1 ? s.splice(i, 1)[0] : {};
        return Zn(Zn({}, r), o);
      });
      return n.concat(s);
    }, e;
  }()
);
const nd = {}, au = {};
let aU = 0;
function q4(e, t = !0, s = !0, n = "footer", r = !0) {
  const i = document.getElementsByTagName(n);
  if (i.length == 1) {
    const o = `egg${aU++}`, l = document.createElement("div");
    l.classList.add("position-absolute", "bottom-0"), r ? l.classList.add("end-0", "pe-2") : l.classList.add("start-0", "ps-2");
    const d = document.createElement("i");
    return d.classList.add("fa-duotone", "fa-pi", "fa-xs"), d.addEventListener("click", (c) => {
      t && !c.ctrlKey || s && !c.shiftKey || e(c);
    }), l.appendChild(d), i[0].appendChild(l), au[o] = {
      element: l,
      abort: new AbortController()
    }, au[o].abort.signal.onabort = (c) => {
      i[0].removeChild(l);
    }, o;
  }
}
function nU(e) {
  if (!(e in au)) {
    console.warn(`Egg not found for ${e} key`);
    return;
  }
  au[e].abort.abort(), delete au[e];
}
async function Hr(e, t, s = !1, n = !0, r = !1, i = !1, o = !1) {
  if (e in nd) {
    console.warn(`Global Key Press event already registered for ${e}`);
    return;
  }
  nd[e] = new AbortController(), document.addEventListener("keydown", (l) => {
    var d;
    ((d = l.key) == null ? void 0 : d.toLocaleLowerCase()) == e.toLocaleLowerCase() && (!r || r && l.shiftKey) && (!n || n && l.ctrlKey) && (!i || i && l.altKey) && (!o || o && l.metaKey) && (s && l.preventDefault(), t(l));
  }, {
    signal: nd[e].signal
  });
}
function rU(e) {
  if (!(e in nd)) {
    console.warn(`Key press event not found for ${e} key`);
    return;
  }
  nd[e].abort(), delete nd[e];
}
const oU = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  addEgg: q4,
  addKeyPress: Hr,
  removeEgg: nU,
  removeKeyPress: rU
}, Symbol.toStringTag, { value: "Module" })), iU = new Error("request for lock canceled");
var lU = function(e, t, s, n) {
  function r(i) {
    return i instanceof s ? i : new s(function(o) {
      o(i);
    });
  }
  return new (s || (s = Promise))(function(i, o) {
    function l(u) {
      try {
        c(n.next(u));
      } catch (m) {
        o(m);
      }
    }
    function d(u) {
      try {
        c(n.throw(u));
      } catch (m) {
        o(m);
      }
    }
    function c(u) {
      u.done ? i(u.value) : r(u.value).then(l, d);
    }
    c((n = n.apply(e, t || [])).next());
  });
};
class dU {
  constructor(t, s = iU) {
    this._value = t, this._cancelError = s, this._queue = [], this._weightedWaiters = [];
  }
  acquire(t = 1, s = 0) {
    if (t <= 0)
      throw new Error(`invalid weight ${t}: must be positive`);
    return new Promise((n, r) => {
      const i = { resolve: n, reject: r, weight: t, priority: s }, o = Q4(this._queue, (l) => s <= l.priority);
      o === -1 && t <= this._value ? this._dispatchItem(i) : this._queue.splice(o + 1, 0, i);
    });
  }
  runExclusive(t) {
    return lU(this, arguments, void 0, function* (s, n = 1, r = 0) {
      const [i, o] = yield this.acquire(n, r);
      try {
        return yield s(i);
      } finally {
        o();
      }
    });
  }
  waitForUnlock(t = 1, s = 0) {
    if (t <= 0)
      throw new Error(`invalid weight ${t}: must be positive`);
    return this._couldLockImmediately(t, s) ? Promise.resolve() : new Promise((n) => {
      this._weightedWaiters[t - 1] || (this._weightedWaiters[t - 1] = []), cU(this._weightedWaiters[t - 1], { resolve: n, priority: s });
    });
  }
  isLocked() {
    return this._value <= 0;
  }
  getValue() {
    return this._value;
  }
  setValue(t) {
    this._value = t, this._dispatchQueue();
  }
  release(t = 1) {
    if (t <= 0)
      throw new Error(`invalid weight ${t}: must be positive`);
    this._value += t, this._dispatchQueue();
  }
  cancel() {
    this._queue.forEach((t) => t.reject(this._cancelError)), this._queue = [];
  }
  _dispatchQueue() {
    for (this._drainUnlockWaiters(); this._queue.length > 0 && this._queue[0].weight <= this._value; )
      this._dispatchItem(this._queue.shift()), this._drainUnlockWaiters();
  }
  _dispatchItem(t) {
    const s = this._value;
    this._value -= t.weight, t.resolve([s, this._newReleaser(t.weight)]);
  }
  _newReleaser(t) {
    let s = !1;
    return () => {
      s || (s = !0, this.release(t));
    };
  }
  _drainUnlockWaiters() {
    if (this._queue.length === 0)
      for (let t = this._value; t > 0; t--) {
        const s = this._weightedWaiters[t - 1];
        s && (s.forEach((n) => n.resolve()), this._weightedWaiters[t - 1] = []);
      }
    else {
      const t = this._queue[0].priority;
      for (let s = this._value; s > 0; s--) {
        const n = this._weightedWaiters[s - 1];
        if (!n)
          continue;
        const r = n.findIndex((i) => i.priority <= t);
        (r === -1 ? n : n.splice(0, r)).forEach((i) => i.resolve());
      }
    }
  }
  _couldLockImmediately(t, s) {
    return (this._queue.length === 0 || this._queue[0].priority < s) && t <= this._value;
  }
}
function cU(e, t) {
  const s = Q4(e, (n) => t.priority <= n.priority);
  e.splice(s + 1, 0, t);
}
function Q4(e, t) {
  for (let s = e.length - 1; s >= 0; s--)
    if (t(e[s]))
      return s;
  return -1;
}
var uU = function(e, t, s, n) {
  function r(i) {
    return i instanceof s ? i : new s(function(o) {
      o(i);
    });
  }
  return new (s || (s = Promise))(function(i, o) {
    function l(u) {
      try {
        c(n.next(u));
      } catch (m) {
        o(m);
      }
    }
    function d(u) {
      try {
        c(n.throw(u));
      } catch (m) {
        o(m);
      }
    }
    function c(u) {
      u.done ? i(u.value) : r(u.value).then(l, d);
    }
    c((n = n.apply(e, t || [])).next());
  });
};
class xa {
  constructor(t) {
    this._semaphore = new dU(1, t);
  }
  acquire() {
    return uU(this, arguments, void 0, function* (t = 0) {
      const [, s] = yield this._semaphore.acquire(1, t);
      return s;
    });
  }
  runExclusive(t, s = 0) {
    return this._semaphore.runExclusive(() => t(), 1, s);
  }
  isLocked() {
    return this._semaphore.isLocked();
  }
  waitForUnlock(t = 0) {
    return this._semaphore.waitForUnlock(1, t);
  }
  release() {
    this._semaphore.isLocked() && this._semaphore.release();
  }
  cancel() {
    return this._semaphore.cancel();
  }
}
class Na {
  constructor(t, s) {
    Xe(this, "Debug", !1);
    Xe(this, "_name", "");
    Xe(this, "_milliseconds");
    Xe(this, "_lastExec", null);
    Xe(this, "_mutex", new xa());
    Xe(this, "_lastResponse");
    this._name = s, this._milliseconds = t, this._mutex = new xa();
  }
  get Name() {
    return this._name;
  }
  async limit(t) {
    return await this._mutex.runExclusive(() => this._lastExec && Fw(this._lastExec) < this._milliseconds ? (this.Debug && console.warn(`rateLimit hit for ${this._name}`, Fw(this._lastExec)), this._lastResponse) : (this._lastResponse = t(), this._lastExec = /* @__PURE__ */ new Date(), this._lastResponse), 1);
  }
}
function Fw(e, t) {
  return (t ?? /* @__PURE__ */ new Date()).getTime() - e.getTime();
}
function pU(e) {
  var t, s;
  if (document.addEventListener("shown.bs.tab", function(n) {
    console.log("trackTabs.shown", n);
    const r = n.target;
    r.dataset.bsTrack && (window.location.hash = `${r.dataset.bsTarget}Tab`);
  }), (t = window.location.hash) != null && t.endsWith("Tab")) {
    const n = (s = window.location.hash.substring(1)) == null ? void 0 : s.replace("Tab", "");
    rf(n) == !1 && e && e();
  } else e && e();
}
function rf(e) {
  let t = !1, s;
  if (typeof e == "string")
    s = [...document.querySelectorAll(`[role="tablist"] [data-bs-target="#${e}"]`)];
  else if (typeof e == "object")
    s = [e];
  else
    throw new Error("Unsupported id type");
  if (console.log(`trackTabs: Attempting to show \`#${e}\` tab`, s), s && s.length > 0)
    for (const n of s) {
      const r = n.closest('[role="tabpanel"]');
      r != null && r.id && rf(r.id);
      const i = n.closest("[data-bs-parent]");
      i && bootstrap.Collapse.getOrCreateInstance(i).show(), bootstrap.Tab.getOrCreateInstance(n).show(), t = !0;
    }
  return t;
}
const Vw = [
  {
    featureType: "all",
    elementType: "geometry.fill",
    stylers: [
      {
        visibility: "on"
      }
    ]
  },
  {
    featureType: "administrative",
    elementType: "all",
    stylers: [
      {
        color: "#f2f2f2"
      }
    ]
  },
  {
    featureType: "administrative",
    elementType: "labels.text.fill",
    stylers: [
      {
        color: "#686868"
      },
      {
        visibility: "on"
      }
    ]
  },
  {
    featureType: "landscape",
    elementType: "all",
    stylers: [
      {
        color: "#f2f2f2"
      }
    ]
  },
  {
    featureType: "poi",
    elementType: "all",
    stylers: [
      {
        visibility: "off"
      }
    ]
  },
  {
    featureType: "poi.park",
    elementType: "all",
    stylers: [
      {
        visibility: "on"
      }
    ]
  },
  {
    featureType: "poi.park",
    elementType: "labels.icon",
    stylers: [
      {
        visibility: "off"
      }
    ]
  },
  {
    featureType: "road",
    elementType: "all",
    stylers: [
      {
        saturation: -100
      },
      {
        lightness: 45
      }
    ]
  },
  {
    featureType: "road.highway",
    elementType: "all",
    stylers: [
      {
        visibility: "simplified"
      }
    ]
  },
  {
    featureType: "road.highway",
    elementType: "geometry.fill",
    stylers: [
      {
        lightness: "-22"
      },
      {
        visibility: "on"
      },
      {
        color: "#b4b4b4"
      }
    ]
  },
  {
    featureType: "road.highway",
    elementType: "geometry.stroke",
    stylers: [
      {
        saturation: "-51"
      },
      {
        lightness: "11"
      }
    ]
  },
  {
    featureType: "road.highway",
    elementType: "labels.text",
    stylers: [
      {
        saturation: "3"
      },
      {
        lightness: "-56"
      },
      {
        visibility: "simplified"
      }
    ]
  },
  {
    featureType: "road.highway",
    elementType: "labels.text.fill",
    stylers: [
      {
        lightness: "-52"
      },
      {
        color: "#9094a0"
      },
      {
        visibility: "simplified"
      }
    ]
  },
  {
    featureType: "road.highway",
    elementType: "labels.text.stroke",
    stylers: [
      {
        weight: "6.13"
      }
    ]
  },
  {
    featureType: "road.highway",
    elementType: "labels.icon",
    stylers: [
      {
        weight: "1.24"
      },
      {
        saturation: "-100"
      },
      {
        lightness: "-10"
      },
      {
        gamma: "0.94"
      },
      {
        visibility: "off"
      }
    ]
  },
  {
    featureType: "road.highway.controlled_access",
    elementType: "geometry.fill",
    stylers: [
      {
        visibility: "on"
      },
      {
        color: "#b4b4b4"
      },
      {
        weight: "5.40"
      },
      {
        lightness: "7"
      }
    ]
  },
  {
    featureType: "road.highway.controlled_access",
    elementType: "labels.text",
    stylers: [
      {
        visibility: "simplified"
      },
      {
        color: "#231f1f"
      }
    ]
  },
  {
    featureType: "road.highway.controlled_access",
    elementType: "labels.text.fill",
    stylers: [
      {
        visibility: "simplified"
      },
      {
        color: "#595151"
      }
    ]
  },
  {
    featureType: "road.arterial",
    elementType: "geometry",
    stylers: [
      {
        lightness: "-16"
      }
    ]
  },
  {
    featureType: "road.arterial",
    elementType: "geometry.fill",
    stylers: [
      {
        visibility: "on"
      },
      {
        color: "#d7d7d7"
      }
    ]
  },
  {
    featureType: "road.arterial",
    elementType: "labels.text",
    stylers: [
      {
        color: "#282626"
      },
      {
        visibility: "simplified"
      }
    ]
  },
  {
    featureType: "road.arterial",
    elementType: "labels.text.fill",
    stylers: [
      {
        saturation: "-41"
      },
      {
        lightness: "-41"
      },
      {
        color: "#2a4592"
      },
      {
        visibility: "simplified"
      }
    ]
  },
  {
    featureType: "road.arterial",
    elementType: "labels.text.stroke",
    stylers: [
      {
        weight: "1.10"
      },
      {
        color: "#ffffff"
      }
    ]
  },
  {
    featureType: "road.arterial",
    elementType: "labels.icon",
    stylers: [
      {
        visibility: "on"
      }
    ]
  },
  {
    featureType: "road.local",
    elementType: "geometry.fill",
    stylers: [
      {
        lightness: "-16"
      },
      {
        weight: "0.72"
      }
    ]
  },
  {
    featureType: "road.local",
    elementType: "labels.text.fill",
    stylers: [
      {
        lightness: "-37"
      },
      {
        color: "#2a4592"
      }
    ]
  },
  {
    featureType: "transit",
    elementType: "all",
    stylers: [
      {
        visibility: "off"
      }
    ]
  },
  {
    featureType: "transit.line",
    elementType: "geometry.fill",
    stylers: [
      {
        visibility: "off"
      },
      {
        color: "#eeed6a"
      }
    ]
  },
  {
    featureType: "transit.line",
    elementType: "geometry.stroke",
    stylers: [
      {
        visibility: "off"
      },
      {
        color: "#0a0808"
      }
    ]
  },
  {
    featureType: "water",
    elementType: "all",
    stylers: [
      {
        color: "#b7e4f4"
      },
      {
        visibility: "on"
      }
    ]
  }
], hU = [
  {
    featureType: "poi.business",
    stylers: [
      {
        visibility: "off"
      }
    ]
  },
  {
    featureType: "poi.park",
    //labels: "labels.text",
    stylers: [
      {
        visibility: "off"
      }
    ]
  }
], mU = [
  {
    featureType: "all",
    elementType: "all",
    stylers: [
      {
        invert_lightness: !0
      },
      {
        saturation: 10
      },
      {
        lightness: 30
      },
      {
        gamma: 0.5
      },
      {
        hue: "#435158"
      }
    ]
  }
], fU = [
  {
    stylers: [
      {
        hue: "#ff1a00"
      },
      {
        invert_lightness: !0
      },
      {
        saturation: -100
      },
      {
        lightness: 33
      },
      {
        gamma: 0.5
      }
    ]
  },
  {
    featureType: "water",
    elementType: "geometry",
    stylers: [
      {
        color: "#2D333C"
      }
    ]
  }
], gU = [
  {
    featureType: "all",
    elementType: "labels.text.fill",
    stylers: [
      {
        color: "#ffffff"
      }
    ]
  },
  {
    featureType: "all",
    elementType: "labels.text.stroke",
    stylers: [
      {
        color: "#000000"
      },
      {
        lightness: 13
      }
    ]
  },
  {
    featureType: "administrative",
    elementType: "geometry.fill",
    stylers: [
      {
        color: "#000000"
      }
    ]
  },
  {
    featureType: "administrative",
    elementType: "geometry.stroke",
    stylers: [
      {
        color: "#144b53"
      },
      {
        lightness: 14
      },
      {
        weight: 1.4
      }
    ]
  },
  {
    featureType: "landscape",
    elementType: "all",
    stylers: [
      {
        color: "#08304b"
      }
    ]
  },
  {
    featureType: "poi",
    elementType: "geometry",
    stylers: [
      {
        color: "#0c4152"
      },
      {
        lightness: 5
      }
    ]
  },
  {
    featureType: "road.highway",
    elementType: "geometry.fill",
    stylers: [
      {
        color: "#000000"
      }
    ]
  },
  {
    featureType: "road.highway",
    elementType: "geometry.stroke",
    stylers: [
      {
        color: "#0b434f"
      },
      {
        lightness: 25
      }
    ]
  },
  {
    featureType: "road.arterial",
    elementType: "geometry.fill",
    stylers: [
      {
        color: "#000000"
      }
    ]
  },
  {
    featureType: "road.arterial",
    elementType: "geometry.stroke",
    stylers: [
      {
        color: "#0b3d51"
      },
      {
        lightness: 16
      }
    ]
  },
  {
    featureType: "road.local",
    elementType: "geometry",
    stylers: [
      {
        color: "#000000"
      }
    ]
  },
  {
    featureType: "transit",
    elementType: "all",
    stylers: [
      {
        color: "#146474"
      }
    ]
  },
  {
    featureType: "water",
    elementType: "all",
    stylers: [
      {
        color: "#021019"
      }
    ]
  }
], vU = [
  {
    featureType: "all",
    elementType: "geometry",
    stylers: [
      {
        color: "#202c3e"
      }
    ]
  },
  {
    featureType: "all",
    elementType: "labels.text.fill",
    stylers: [
      {
        gamma: 0.01
      },
      {
        lightness: 20
      },
      {
        weight: "1.39"
      },
      {
        color: "#ffffff"
      }
    ]
  },
  {
    featureType: "all",
    elementType: "labels.text.stroke",
    stylers: [
      {
        weight: "0.96"
      },
      {
        saturation: "9"
      },
      {
        visibility: "on"
      },
      {
        color: "#000000"
      }
    ]
  },
  {
    featureType: "all",
    elementType: "labels.icon",
    stylers: [
      {
        visibility: "off"
      }
    ]
  },
  {
    featureType: "landscape",
    elementType: "geometry",
    stylers: [
      {
        lightness: 30
      },
      {
        saturation: "9"
      },
      {
        color: "#29446b"
      }
    ]
  },
  {
    featureType: "poi",
    elementType: "geometry",
    stylers: [
      {
        saturation: 20
      }
    ]
  },
  {
    featureType: "poi.park",
    elementType: "geometry",
    stylers: [
      {
        lightness: 20
      },
      {
        saturation: -20
      }
    ]
  },
  {
    featureType: "road",
    elementType: "geometry",
    stylers: [
      {
        lightness: 10
      },
      {
        saturation: -30
      }
    ]
  },
  {
    featureType: "road",
    elementType: "geometry.fill",
    stylers: [
      {
        color: "#193a55"
      }
    ]
  },
  {
    featureType: "road",
    elementType: "geometry.stroke",
    stylers: [
      {
        saturation: 25
      },
      {
        lightness: 25
      },
      {
        weight: "0.01"
      }
    ]
  },
  {
    featureType: "water",
    elementType: "all",
    stylers: [
      {
        lightness: -20
      }
    ]
  }
];
var $v;
((e) => {
  e.Default = Vw, e.AG = Vw, e.Cobalt = mU, e.LunarLandscape = fU, e.MidnightCommander = gU, e.Modest = vU, e.Original = hU;
})($v || ($v = {}));
var _v;
((e) => {
  e.UsBounds = {
    north: 49.3467868,
    west: -124.7844079,
    east: -66.9513812,
    south: 24.7433195
  }, e.ClusterLargeColor = "#ff0080", e.ClusterSmallColor = "#0000ff", e.Styles = $v;
})(_v || (_v = {}));
var De;
((e) => {
  ((t) => {
    ((s) => {
      s.Curated = "/folio/curated", s.Favorites = "/folio/favorites", s.Ignored = "/folio/ignored", s.Marketplace = "/folio/marketplace", s.SavedSearches = "/folio/saved-searches";
    })(t.Folio || (t.Folio = {})), ((s) => {
      s.Public = "/marketplace", s.Add = "/marketplace/%s/add", s.Edit = "/marketplace/%s/edit", s.Review = "/marketplace/%s/review", s.Preview = "/marketplace/%s/preview";
    })(t.Marketplace || (t.Marketplace = {})), ((s) => {
      s.ClientById = "/portfolio-insights/%s/client", s.ClientPropertyById = "/portfolio-insights/%s/client/%s", s.ClientPortfoliosPageRgx = /\/clients\/portfolio-insights\/([^/]+)\/portfolios/i, s.ClientPortfolioPageRgx = /\/clients\/portfolio-insights\/([^/]+)\/portfolios\/([^/]+)\/portfolio/i, s.PropertyPageRgx = /\/portfolio-insights\/([^/]+)\/client\/([a-z0-9]+)/i;
    })(t.PortfolioInsights || (t.PortfolioInsights = {})), ((s) => {
      s.ById = "/homes/%s%s", s.ByAddress = "/homes/%s/%s/%s%s", s.ByAddressZip = "/homes/%s/%s/%s/%s%s", s.PropertyPageRgx = /\/homes\/[a-z]+\/[a-z-]+\/\d+\/[\d\-a-z]*/i;
    })(t.Property || (t.Property = {})), ((s) => {
      s.ListingPageRgx = /\/mls\/[a-z0-9-]+\/[a-z0-9-]+/i;
    })(t.Listing || (t.Listing = {})), ((s) => {
      s.Saved = "/search/saved/%s/%s";
    })(t.Search || (t.Search = {}));
  })(e.URL || (e.URL = {})), ((t) => {
    t.RentlyzerBlue = "#132844", t.RentlyzerOrange = "#F26E34", t.ChartGray1 = "#D8D8D8", t.ChartGray = "#F8F9FA", t.ChartDarkGray = "#F8F9FA", t.ChartGreen = "#21B7A8", t.ChartLiteBlue = "#34AEF2", t.ChartDarkBlue = "#132844", t.ChartDarkGreen = "#17524C", t.ChartTurquoise = "#21B7A8", t.ChartLiteOrange = "#F9AA34", t.ChartOrange = "#F26E34", t.grey1 = "#DADADA", t.grey2 = "#E4E4E4", t.grey3 = "#D0D0D0", ((s) => {
      s.DarkEclipse = "#132844", s.BeeCluster = "#F9AA34", s.LightSlateGrey = "#7E8CA3", s.PeachYellow = "#FADCA0", s.Green = "#23B14C", s.Red = "#EE1C25", s.Blue = "#3C67BE", s.Black = "#000000", s.LightBlue = "#00A2E8", s.DarkBlue = "#132844", s.NeonGreen = "#B5E61D", s.Softblue = "#7092BF", s.Orange = "#E76627", s.Yellow = "#FFC023", s.Purple = "#A34AA4", s.Grey1 = "#DADADA", s.Grey2 = "#E4E4E4", s.Grey3 = "#D0D0D0";
    })(t.Charts || (t.Charts = {})), ((s) => {
      s.NoCoverage = "#000000", s.County = "#000000", s.Zip = "#592693";
    })(t.Maps || (t.Maps = {}));
  })(e.Colors || (e.Colors = {})), ((t) => {
    t.MapPropId = "propId", t.DisableSearchTour = "disableSearchTour";
  })(e.VariableNames || (e.VariableNames = {})), ((t) => {
    ((s) => {
      s.LastState = "portfoliofinder-state", s.LastCounty = "portfoliofinder-county", s.LastPropertyType = "portfoliofinder-property-type", s.LastMinProperties = "portfoliofinder-min-properties", s.LastMaxProperties = "portfoliofinder-max-properties";
    })(t.PortfolioFinder || (t.PortfolioFinder = {}));
  })(e.StorageKeys || (e.StorageKeys = {})), e.Map = _v;
})(De || (De = {}));
const K4 = {
  id: "centerText",
  beforeDatasetsDraw(e) {
    const { ctx: t, data: s, options: n } = e, r = n.plugins.centerText, i = s.datasets[r.datasetIndex ?? 0].label;
    if (!i) return;
    t.save();
    const o = e.getDatasetMeta(0).data[0].x + (r.xAdjust ?? 0), l = e.getDatasetMeta(0).data[0].y + (r.yAdjust ?? 0);
    t.textAlign = r.textAlign ?? "center", t.textBaseline = r.textBaseline ?? "middle", t.font = `${r.fontWeight ?? "700"} ${r.fontSize ?? "16px"} ${r.font ?? "sans-serif"}`, t.fillText(i, o, l);
  }
};
function yU() {
  return {
    name: "ClarityIntegration",
    preprocessEvent(e, t) {
      var s, n, r, i, o, l;
      e != null && e.event_id && window.clarity && (window.clarity("set", "event_id", e.event_id), (n = (s = e.contexts) == null ? void 0 : s.trace) != null && n.trace_id && window.clarity("set", "trace_id", e.contexts.trace.trace_id), (i = (r = e.contexts) == null ? void 0 : r.trace) != null && i.span_id && window.clarity("set", "span_id", e.contexts.trace.span_id), (o = e.user) != null && o.email && window.clarity("identify", e.user.email, void 0, void 0, (l = e.user) == null ? void 0 : l.fullName));
    }
  };
}
const bU = yU, Mis = {
  install(e, t) {
    console.log("SentryPlugin.install");
    const s = {
      enabled: !1,
      dsn: "https://de89826ee9bdff5b43af783fb2e65737@o4507196311142400.ingest.us.sentry.io/4507196884320256",
      /* @ts-expect-error non-typed global variable */
      environment: window.rsc_environment ?? "production",
      release: void 0,
      // Performance Monitoring
      tracesSampleRate: 0.5,
      //  Capture 100% of the transactions
      profilesSampleRate: 1,
      // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
      // Session Replay
      replaysSessionSampleRate: 0.05,
      // This sets the sample rate at 5%. You may want to change it to 100% while in development and then sample at a lower rate in production.
      replaysOnErrorSampleRate: 1,
      // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
      ...t,
      integrations: [
        pH(),
        Pj(),
        fN({
          maskAllInputs: !1,
          maskAllText: !1,
          blockAllMedia: !1
        }),
        VN(),
        cB({
          autoInject: (t == null ? void 0 : t.autoInject) ?? !0,
          isEmailRequired: !0,
          isNameRequired: !0,
          showBranding: !1,
          colorScheme: "light",
          useSentryUser: {
            name: "fullName",
            email: "email"
          }
        }),
        IR({
          // Specify the application keys that you specified in the Sentry bundler plugin
          filterKeys: ["174A591D-430E-4BBF-B26C-3A06C85FE3D4"],
          // Defines how to handle errors that contain third party stack frames.
          // Possible values are:
          // - 'drop-error-if-contains-third-party-frames'
          // - 'drop-error-if-exclusively-contains-third-party-frames'
          // - 'apply-tag-if-contains-third-party-frames'
          // - 'apply-tag-if-exclusively-contains-third-party-frames'
          behaviour: "apply-tag-if-contains-third-party-frames"
        }),
        bU(),
        M4({
          tracingOptions: {
            trackComponents: !0,
            timeout: 500
            //    hooks: ['mount', 'update'],
          }
        })
      ],
      ignoreErrors: [
        `undefined is not an object (evaluating 'r["@context"].toLowerCase')`,
        'Object.prototype.hasOwnProperty.call(o, "telephone")'
      ],
      tracePropagationTargets: [
        /localhost/,
        /^https:\/\/www\.rescover\.com\/api/,
        /^https:\/\/preview\.rescover\.com\/api/,
        /^https:\/\/uat\.rescover\.com\/api/,
        /^https:\/\/dev\.rescover\.net\/api/,
        /^https:\/\/beta\.rescover\.com\/api/
      ],
      beforeSend(n, r) {
        var o, l;
        const i = r.originalException;
        return n.exception && n.event_id && (i != null && i.vua_app_error) && (console.log("SentryPlugin.beforeSend", n, r), Dx({
          eventId: n.event_id,
          user: {
            email: (o = n.user) == null ? void 0 : o.email,
            name: (l = n.user) == null ? void 0 : l.fullName
          }
        })), n;
      }
    };
    t != null && t.integrations && Array.isArray(t.integrations) && s.integrations.push(...t.integrations), t != null && t.ignoreErrors && s.ignoreErrors.push(...t.ignoreErrors), t != null && t.tracePropagationTargets && s.tracePropagationTargets.push(...t.tracePropagationTargets), dH({
      app: e,
      ...s
    }), e.config.errorHandler = (n, r, i) => {
      throw console.log("SentryPlugin.errorHandler", n, r, i), n.vua_app_error = !0, Ns(n), n;
    };
  }
}, Z4 = (e, t, s) => {
  var n;
  for (const r of s) {
    const i = `on${r.charAt(0).toUpperCase()}${r.slice(1)}`.replace(
      /[-_]+(.)?/g,
      (o, l) => l ? l.toUpperCase() : ""
    );
    console.log(`${e.$options.name}.bindEvent`, r), e.$props[i] || e.$attrs[i] ? (console.log(`${e.$options.name}.addListener`, r), t.addListener(r, (o) => {
      console.log(`${e.$options.name}.${r}`, o, Yz), e.$emit(r, o);
    })) : ((n = e.$gmapOptions) != null && n.autobindAllEvents || e.$attrs[r]) && (console.log(`${e.$options.name}.addListener(autobound)`, r), t.addListener(r, (o) => {
      console.log(`${e.$options.name}.${r}(autobound)`, o), e.$emit(r, o);
    }));
  }
};
function J4(e, t, s, n = !1) {
  let r = !1;
  function i() {
    r || (r = !0, e.$nextTick(() => {
      r = !1, s();
    }));
  }
  for (const o of t)
    e.$watch(o, i, { immediate: n });
}
class Dw {
  static capitalizeFirstLetter(t) {
    return t.charAt(0).toUpperCase() + t.slice(1);
  }
}
function ey(e, t) {
  return Object.keys(t).reduce((s, n) => (e[n] !== void 0 && (s[n] = e[n]), s), {});
}
function $4(e, t, s) {
  var n, r;
  for (const i in s) {
    const { twoWay: o, type: l, trackProperties: d, noBind: c } = s[i];
    if (c) continue;
    const u = "set" + Dw.capitalizeFirstLetter(i), m = "get" + Dw.capitalizeFirstLetter(i), f = i.toLowerCase() + "_changed", v = e[i];
    if (typeof t[u] > "u" && typeof t[i] > "u")
      throw new Error(
        `${u} is not a method of (the Maps object corresponding to) ${e.$options._componentTag}`
      );
    l !== Object || !d ? e.$watch(
      i,
      () => {
        const b = e[i];
        t[i] ? t[i] = b : t[u] && t[u](b);
      },
      {
        immediate: typeof v < "u",
        deep: l === Object
      }
    ) : J4(
      e,
      d.map((b) => `${i}.${b}`),
      () => {
        t[i] ? t[i] = e[i] : t[u] && t[u](e[i]);
      },
      // @ts-ignore
      e[i] !== void 0
    ), o && ((n = e.$gmapOptions) != null && n.autobindAllEvents || e.$attrs[f]) && (console.log(`${e.$options.name}.addListener(TwoWay)`, f, (r = e.$gmapOptions) == null ? void 0 : r.autobindAllEvents), t.addListener(f, () => {
      console.log(`${e.$options.name}.${f}(TwoWay)`), e.$emit(f, e[i] ?? t[m]());
    }));
  }
}
const AU = me({
  props: {
    resizeBus: Object
  },
  data() {
    return {
      _actualResizeBus: void 0
    };
  },
  watch: {
    resizeBus(e) {
      this._actualResizeBus = e;
    },
    _actualResizeBus(e, t) {
      t && t.off("resize", this._delayedResizeCallback), e && e.on("resize", this._delayedResizeCallback);
    }
  },
  created() {
    typeof this.resizeBus > "u" ? this._actualResizeBus = this.$gmapDefaultResizeBus : this._actualResizeBus = this.resizeBus;
  },
  unmounted() {
    this._actualResizeBus && wU(this._actualResizeBus.off) && this._actualResizeBus.off("resize", this._delayedResizeCallback);
  },
  methods: {
    _resizeCallback() {
      this.resize();
    },
    _delayedResizeCallback() {
      this.$nextTick(() => this._resizeCallback());
    }
  }
});
function wU(e) {
  return e && {}.toString.call(e) === "[object Function]";
}
function CU(e) {
  let t = 0;
  e(
    () => {
      t += 1;
    },
    () => {
      t = Math.max(0, t - 1);
    },
    () => t === 0
  );
}
const SU = me({
  inject: {
    $mapPromise: { default: "abcdef" }
  },
  provide() {
    return this.$mapPromise.then((e) => {
      this.$map = e;
    }), {};
  }
});
function of(e) {
  const { mappedProps: t, name: s, ctr: n, ctrArgs: r, events: i, beforeCreate: o, afterCreate: l, props: d, ...c } = e, u = `$${s}Promise`, m = `$${s}Object`;
  return PU(!(d instanceof Array), "`props` should be an object, not Array"), me({
    name: s,
    // @ts-ignore
    ...typeof GENERATE_DOC < "u" ? { $vgmOptions: e } : {},
    mixins: [SU],
    props: {
      ...d,
      ..._4(t)
    },
    render() {
      return "";
    },
    provide() {
      const f = this.$mapPromise.then((v) => {
        this.$map = v;
        const b = {
          // @ts-ignore
          ...this.options,
          map: v,
          ...ey(this, t)
        };
        if (delete b.options, o) {
          const w = o.bind(this)(b);
          if (w instanceof Promise)
            return w.then(() => ({ options: b }));
        }
        return { options: b };
      }).then(({ options: v }) => {
        const b = n();
        return this[m] = r ? new (Function.prototype.bind.call(
          b,
          null,
          ...r(v, ey(this, d || {}))
        ))() : new b(v), $4(this, this[m], t), Z4(this, this[m], i), l && l.bind(this)(this[m]), this[m];
      });
      return this[u] = f, { [u]: f };
    },
    unmounted() {
      this[m] && this[m].setMap && this[m].setMap(null);
    },
    ...c
  });
}
function PU(e, t) {
  if (!e) throw new Error(t);
}
function _4(e) {
  return Object.entries(e).map(([t, s]) => {
    const n = {};
    return "type" in s && (n.type = s.type), "default" in s && (n.default = s.default), "required" in s && (n.required = s.required), [t, n];
  }).reduce((t, [s, n]) => (t[s] = n, t), {});
}
const pg = {
  center: {
    default: { lat: 0, lng: 0 },
    twoWay: !0,
    type: Object,
    noBind: !0
  },
  zoom: {
    required: !1,
    twoWay: !0,
    type: Number,
    noBind: !0
  },
  maxZoom: {
    required: !1,
    twoWay: !0,
    type: Number,
    noBind: !0
  },
  heading: {
    type: Number,
    twoWay: !0
  },
  mapTypeId: {
    twoWay: !0,
    type: String
  },
  tilt: {
    twoWay: !0,
    type: Number
  },
  options: {
    type: Object,
    default() {
      return {};
    }
  }
}, Nw = [
  "bounds_changed",
  "click",
  "dblclick",
  "drag",
  "dragend",
  "dragstart",
  "idle",
  "mousemove",
  "mouseout",
  "mouseover",
  "resize",
  "rightclick",
  "tilesloaded"
], kU = ["panBy", "panTo", "panToBounds", "fitBounds"].reduce((e, t) => (e[t] = function() {
  this.$mapObject && this.$mapObject[t].apply(this.$mapObject, arguments);
}, e), {}), EU = {
  resize() {
    this.$mapObject && google.maps.event.trigger(this.$mapObject, "resize");
  },
  resizePreserveCenter() {
    if (!this.$mapObject)
      return;
    const e = this.$mapObject.getCenter();
    google.maps.event.trigger(this.$mapObject, "resize"), this.$mapObject.setCenter(e);
  },
  /// Override mountableMixin::_resizeCallback
  /// because resizePreserveCenter is usually the
  /// expected behaviour
  _resizeCallback() {
    this.resizePreserveCenter();
  }
}, IU = me({
  name: "GMapMap",
  mixins: [
    AU
  ],
  props: {
    ..._4({
      ...pg,
      ...Nw.reduce(
        (e, t) => ({
          ...e,
          [`on${t.charAt(0).toUpperCase()}${t.slice(1)}`.replace(
            /[-_]+(.)?/g,
            (s, n) => n ? n.toUpperCase() : ""
          )]: Function
        }),
        {}
      )
    }),
    mapId: {
      type: String
    },
    options: {
      type: Object,
      default() {
        return {};
      }
    },
    center: {
      type: Object,
      default: {
        lat: 0,
        lng: 0
      }
    }
  },
  inheritAttrs: !1,
  provide() {
    return this.$mapPromise = new Promise((e, t) => {
      this.$mapPromiseDeferred = { resolve: e, reject: t };
    }), {
      $mapPromise: this.$mapPromise
    };
  },
  emits: ["center_changed", "zoom_changed", "bounds_changed", "pano_visible_changed", "map_created"],
  computed: {
    finalLat() {
      return this.center && typeof this.center.lat == "function" ? this.center.lat() : this.center.lat;
    },
    finalLng() {
      return this.center && typeof this.center.lng == "function" ? this.center.lng() : this.center.lng;
    },
    finalLatLng() {
      return {
        lat: this.finalLat,
        lng: this.finalLng
      };
    }
  },
  watch: {
    zoom(e) {
      this.$mapObject && this.$mapObject.setZoom(e);
    }
  },
  beforeMount() {
    return console.log("map.mounted"), this.$gmapApiPromiseLazy().then(() => {
      const e = this.$refs.vueMap;
      let t = {
        mapId: this.mapId,
        ...this.options,
        ...ey(this, pg)
      };
      return delete t.options, console.log("map.mounted.$gmapApiPromiseLazy.then", t), this.$mapObject = new google.maps.Map(e, t), $4(this, this.$mapObject, pg), Z4(this, this.$mapObject, Nw), CU((s, n, r) => {
        this.$mapObject.addListener("center_changed", (o) => {
          r() && (console.log(`${this.$options.name}.center_changed`, o), this.$emit("center_changed", this.$mapObject.getCenter())), n();
        }), J4(this, ["finalLat", "finalLng"], () => {
          s(), this.$mapObject.setCenter(this.finalLatLng);
        });
      }), this.$mapObject.addListener("zoom_changed", (s) => {
        console.log(`${this.$options.name}.zoom_changed`, s), this.$emit("zoom_changed", this.$mapObject.getZoom());
      }), this.$mapObject.addListener("bounds_changed", () => {
        console.log(`${this.$options.name}.bounds_changed`), this.$emit("bounds_changed", this.$mapObject.getBounds(), this.$mapObject.getTilt() !== 0);
      }), this.$mapObject.getStreetView().addListener("visible_changed", (s) => {
        console.log(`${this.$options.name}.pano_visible_changed`, s), this.$emit("pano_visible_changed", this.$mapObject.getStreetView());
      }), this.$mapPromiseDeferred.resolve(this.$mapObject), this.$mapObject;
    }).catch((e) => {
      throw e;
    });
  },
  methods: {
    ...EU,
    ...kU
  }
}), Ae = (e, t) => {
  const s = e.__vccOpts || e;
  for (const [n, r] of t)
    s[n] = r;
  return s;
}, TU = { class: "vue-map-hidden" };
function OU(e, t, s, n, r, i) {
  return p(), h(A, null, [
    a("div", Rs({ ref: "vueMap" }, e.$attrs), null, 16),
    a("div", TU, [
      Ot(e.$slots, "default")
    ]),
    Ot(e.$slots, "visible")
  ], 64);
}
const RU = /* @__PURE__ */ Ae(IU, [["render", OU]]), LU = {
  animation: {
    twoWay: !0,
    type: Number
  },
  attribution: {
    type: Object
  },
  clickable: {
    type: Boolean,
    twoWay: !0,
    default: !0
  },
  cursor: {
    type: String,
    twoWay: !0
  },
  draggable: {
    type: Boolean,
    twoWay: !0,
    default: !1
  },
  icon: {
    twoWay: !0
  },
  label: {},
  opacity: {
    type: Number,
    default: 1
  },
  options: {
    type: Object
  },
  place: {
    type: Object
  },
  position: {
    type: Object,
    twoWay: !0
  },
  shape: {
    type: Object,
    twoWay: !0
  },
  title: {
    type: String,
    twoWay: !0
  },
  zIndex: {
    type: Number,
    twoWay: !0
  },
  visible: {
    twoWay: !0,
    default: !0
  }
}, hg = [
  "click",
  "rightclick",
  "dblclick",
  "drag",
  "dragstart",
  "dragend",
  "mouseup",
  "mousedown",
  "mouseover",
  "mouseout"
], BU = of({
  mappedProps: LU,
  events: hg,
  name: "marker",
  ctr: () => google.maps.Marker,
  inject: {
    $clusterPromise: {
      default: null
    }
  },
  emits: hg,
  unmounted() {
    console.log(`${this.$options.name}.unmounted`), this.$markerObject && (this.$clusterObject ? this.$clusterObject.removeMarker(this.$markerObject, !0) : this.$markerObject.setMap(null));
  },
  beforeCreate(e) {
    return console.log(`${this.$options.name}.beforeCreate`), this.$clusterPromise && (e.map = null), this.$clusterPromise;
  },
  afterCreate(e) {
    console.log(`${this.$options.name}.afterCreate`), hg.forEach((t) => {
      e.addListener(t, (s) => {
        this.$emit(t, s, e);
      });
    }), this.$clusterPromise && this.$clusterPromise.then((t) => {
      this.$clusterObject = t, t.addMarker(e);
    });
  }
});
function MU(e, t, s, n, r, i) {
  return p(), h("div", {
    onClick: t[0] || (t[0] = () => {
      console.log("sdfsd");
    })
  }, [
    Ot(e.$slots, "default")
  ]);
}
const xU = /* @__PURE__ */ Ae(BU, [["render", MU]]), FU = {
  //animation: {
  //   twoWay: true,
  //   type: Number,
  //},
  //attribution: {
  //   type: Object,
  //},
  gmpClickable: {
    type: Boolean,
    twoWay: !0,
    default: !0
  },
  //cursor: {
  //   type: String,
  //   twoWay: true,
  //},
  gmpDraggable: {
    type: Boolean,
    twoWay: !0,
    default: !1
  },
  //icon: {
  //   twoWay: true,
  //},
  //label: {},
  //opacity: {
  //   type: Number,
  //   default: 1,
  //},
  content: {
    type: Object
  },
  //place: {
  //   type: Object,
  //},
  position: {
    type: Object,
    twoWay: !0
  },
  //shape: {
  //   type: Object,
  //   twoWay: true,
  //},
  title: {
    type: String,
    twoWay: !0
  },
  zIndex: {
    type: Number,
    twoWay: !0
  }
  //   visible: {
  //      twoWay: true,
  //      default: true,
  //   },
}, mg = [
  "click",
  "change",
  "rightclick",
  "dblclick",
  "drag",
  "dragstart",
  "dragend",
  "mouseup",
  "mousedown",
  "mouseover",
  "mouseout"
], VU = of({
  mappedProps: FU,
  events: mg,
  name: "AdvancedMarker",
  ctr: () => google.maps.marker.AdvancedMarkerElement,
  ctrArgs: ({ map: e, ...t }) => [{ map: e, ...t }],
  inject: {
    $clusterPromise: {
      default: null
    }
  },
  emits: mg,
  unmounted() {
    console.log(`${this.$options.name}.unmounted`), this.$AdvancedMarkerObject && (this.$clusterObject ? this.$clusterObject.removeMarker(this.$AdvancedMarkerObject, !0) : this.$AdvancedMarkerObject.setMap(null));
  },
  beforeCreate(e) {
    return console.log(`${this.$options.name}.beforeCreate`), this.$clusterPromise && (e.map = null), this.$clusterPromise;
  },
  afterCreate(e) {
    console.log(`${this.$options.name}.afterCreate`), mg.forEach((t) => {
      e.addListener(t, (s) => {
        this.$emit(t, s, e);
      });
    }), this.$clusterPromise && this.$clusterPromise.then((t) => {
      this.$clusterObject = t, t.addMarker(e);
    });
  }
});
function DU(e, t, s, n, r, i) {
  return p(), h("div", {
    onClick: t[0] || (t[0] = () => {
      console.log("sdfsd");
    })
  }, [
    Ot(e.$slots, "default")
  ]);
}
const NU = /* @__PURE__ */ Ae(VU, [["render", DU]]);
var jU = Object.getOwnPropertyNames, HU = Object.getOwnPropertySymbols, UU = Object.prototype.hasOwnProperty;
function jw(e, t) {
  return function(n, r, i) {
    return e(n, r, i) && t(n, r, i);
  };
}
function Sp(e) {
  return function(s, n, r) {
    if (!s || !n || typeof s != "object" || typeof n != "object")
      return e(s, n, r);
    var i = r.cache, o = i.get(s), l = i.get(n);
    if (o && l)
      return o === n && l === s;
    i.set(s, n), i.set(n, s);
    var d = e(s, n, r);
    return i.delete(s), i.delete(n), d;
  };
}
function Hw(e) {
  return jU(e).concat(HU(e));
}
var zU = Object.hasOwn || function(e, t) {
  return UU.call(e, t);
};
function wl(e, t) {
  return e === t || !e && !t && e !== e && t !== t;
}
var WU = "__v", GU = "__o", YU = "_owner", Uw = Object.getOwnPropertyDescriptor, zw = Object.keys;
function XU(e, t, s) {
  var n = e.length;
  if (t.length !== n)
    return !1;
  for (; n-- > 0; )
    if (!s.equals(e[n], t[n], n, n, e, t, s))
      return !1;
  return !0;
}
function qU(e, t) {
  return wl(e.getTime(), t.getTime());
}
function QU(e, t) {
  return e.name === t.name && e.message === t.message && e.cause === t.cause && e.stack === t.stack;
}
function KU(e, t) {
  return e === t;
}
function Ww(e, t, s) {
  var n = e.size;
  if (n !== t.size)
    return !1;
  if (!n)
    return !0;
  for (var r = new Array(n), i = e.entries(), o, l, d = 0; (o = i.next()) && !o.done; ) {
    for (var c = t.entries(), u = !1, m = 0; (l = c.next()) && !l.done; ) {
      if (r[m]) {
        m++;
        continue;
      }
      var f = o.value, v = l.value;
      if (s.equals(f[0], v[0], d, m, e, t, s) && s.equals(f[1], v[1], f[0], v[0], e, t, s)) {
        u = r[m] = !0;
        break;
      }
      m++;
    }
    if (!u)
      return !1;
    d++;
  }
  return !0;
}
var ZU = wl;
function JU(e, t, s) {
  var n = zw(e), r = n.length;
  if (zw(t).length !== r)
    return !1;
  for (; r-- > 0; )
    if (!ek(e, t, s, n[r]))
      return !1;
  return !0;
}
function ec(e, t, s) {
  var n = Hw(e), r = n.length;
  if (Hw(t).length !== r)
    return !1;
  for (var i, o, l; r-- > 0; )
    if (i = n[r], !ek(e, t, s, i) || (o = Uw(e, i), l = Uw(t, i), (o || l) && (!o || !l || o.configurable !== l.configurable || o.enumerable !== l.enumerable || o.writable !== l.writable)))
      return !1;
  return !0;
}
function $U(e, t) {
  return wl(e.valueOf(), t.valueOf());
}
function _U(e, t) {
  return e.source === t.source && e.flags === t.flags;
}
function Gw(e, t, s) {
  var n = e.size;
  if (n !== t.size)
    return !1;
  if (!n)
    return !0;
  for (var r = new Array(n), i = e.values(), o, l; (o = i.next()) && !o.done; ) {
    for (var d = t.values(), c = !1, u = 0; (l = d.next()) && !l.done; ) {
      if (!r[u] && s.equals(o.value, l.value, o.value, l.value, e, t, s)) {
        c = r[u] = !0;
        break;
      }
      u++;
    }
    if (!c)
      return !1;
  }
  return !0;
}
function ez(e, t) {
  var s = e.length;
  if (t.length !== s)
    return !1;
  for (; s-- > 0; )
    if (e[s] !== t[s])
      return !1;
  return !0;
}
function tz(e, t) {
  return e.hostname === t.hostname && e.pathname === t.pathname && e.protocol === t.protocol && e.port === t.port && e.hash === t.hash && e.username === t.username && e.password === t.password;
}
function ek(e, t, s, n) {
  return (n === YU || n === GU || n === WU) && (e.$$typeof || t.$$typeof) ? !0 : zU(t, n) && s.equals(e[n], t[n], n, n, e, t, s);
}
var sz = "[object Arguments]", az = "[object Boolean]", nz = "[object Date]", rz = "[object Error]", oz = "[object Map]", iz = "[object Number]", lz = "[object Object]", dz = "[object RegExp]", cz = "[object Set]", uz = "[object String]", pz = "[object URL]", hz = Array.isArray, Yw = typeof ArrayBuffer == "function" && ArrayBuffer.isView ? ArrayBuffer.isView : null, Xw = Object.assign, mz = Object.prototype.toString.call.bind(Object.prototype.toString);
function fz(e) {
  var t = e.areArraysEqual, s = e.areDatesEqual, n = e.areErrorsEqual, r = e.areFunctionsEqual, i = e.areMapsEqual, o = e.areNumbersEqual, l = e.areObjectsEqual, d = e.arePrimitiveWrappersEqual, c = e.areRegExpsEqual, u = e.areSetsEqual, m = e.areTypedArraysEqual, f = e.areUrlsEqual;
  return function(b, w, S) {
    if (b === w)
      return !0;
    if (b == null || w == null)
      return !1;
    var I = typeof b;
    if (I !== typeof w)
      return !1;
    if (I !== "object")
      return I === "number" ? o(b, w, S) : I === "function" ? r(b, w, S) : !1;
    var T = b.constructor;
    if (T !== w.constructor)
      return !1;
    if (T === Object)
      return l(b, w, S);
    if (hz(b))
      return t(b, w, S);
    if (Yw != null && Yw(b))
      return m(b, w, S);
    if (T === Date)
      return s(b, w, S);
    if (T === RegExp)
      return c(b, w, S);
    if (T === Map)
      return i(b, w, S);
    if (T === Set)
      return u(b, w, S);
    var x = mz(b);
    return x === nz ? s(b, w, S) : x === dz ? c(b, w, S) : x === oz ? i(b, w, S) : x === cz ? u(b, w, S) : x === lz ? typeof b.then != "function" && typeof w.then != "function" && l(b, w, S) : x === pz ? f(b, w, S) : x === rz ? n(b, w, S) : x === sz ? l(b, w, S) : x === az || x === iz || x === uz ? d(b, w, S) : !1;
  };
}
function gz(e) {
  var t = e.circular, s = e.createCustomConfig, n = e.strict, r = {
    areArraysEqual: n ? ec : XU,
    areDatesEqual: qU,
    areErrorsEqual: QU,
    areFunctionsEqual: KU,
    areMapsEqual: n ? jw(Ww, ec) : Ww,
    areNumbersEqual: ZU,
    areObjectsEqual: n ? ec : JU,
    arePrimitiveWrappersEqual: $U,
    areRegExpsEqual: _U,
    areSetsEqual: n ? jw(Gw, ec) : Gw,
    areTypedArraysEqual: n ? ec : ez,
    areUrlsEqual: tz
  };
  if (s && (r = Xw({}, r, s(r))), t) {
    var i = Sp(r.areArraysEqual), o = Sp(r.areMapsEqual), l = Sp(r.areObjectsEqual), d = Sp(r.areSetsEqual);
    r = Xw({}, r, {
      areArraysEqual: i,
      areMapsEqual: o,
      areObjectsEqual: l,
      areSetsEqual: d
    });
  }
  return r;
}
function vz(e) {
  return function(t, s, n, r, i, o, l) {
    return e(t, s, l);
  };
}
function yz(e) {
  var t = e.circular, s = e.comparator, n = e.createState, r = e.equals, i = e.strict;
  if (n)
    return function(d, c) {
      var u = n(), m = u.cache, f = m === void 0 ? t ? /* @__PURE__ */ new WeakMap() : void 0 : m, v = u.meta;
      return s(d, c, {
        cache: f,
        equals: r,
        meta: v,
        strict: i
      });
    };
  if (t)
    return function(d, c) {
      return s(d, c, {
        cache: /* @__PURE__ */ new WeakMap(),
        equals: r,
        meta: void 0,
        strict: i
      });
    };
  var o = {
    cache: void 0,
    equals: r,
    meta: void 0,
    strict: i
  };
  return function(d, c) {
    return s(d, c, o);
  };
}
var qw = Bi();
Bi({ strict: !0 });
Bi({ circular: !0 });
Bi({
  circular: !0,
  strict: !0
});
Bi({
  createInternalComparator: function() {
    return wl;
  }
});
Bi({
  strict: !0,
  createInternalComparator: function() {
    return wl;
  }
});
Bi({
  circular: !0,
  createInternalComparator: function() {
    return wl;
  }
});
Bi({
  circular: !0,
  createInternalComparator: function() {
    return wl;
  },
  strict: !0
});
function Bi(e) {
  e === void 0 && (e = {});
  var t = e.circular, s = t === void 0 ? !1 : t, n = e.createInternalComparator, r = e.createState, i = e.strict, o = i === void 0 ? !1 : i, l = gz(e), d = fz(l), c = n ? n(d) : vz(d);
  return yz({ circular: s, comparator: d, createState: r, equals: c, strict: o });
}
const Qw = [
  Int8Array,
  Uint8Array,
  Uint8ClampedArray,
  Int16Array,
  Uint16Array,
  Int32Array,
  Uint32Array,
  Float32Array,
  Float64Array
], fg = 1, tc = 8;
class ab {
  /**
   * Creates an index from raw `ArrayBuffer` data.
   * @param {ArrayBuffer} data
   */
  static from(t) {
    if (!(t instanceof ArrayBuffer))
      throw new Error("Data must be an instance of ArrayBuffer.");
    const [s, n] = new Uint8Array(t, 0, 2);
    if (s !== 219)
      throw new Error("Data does not appear to be in a KDBush format.");
    const r = n >> 4;
    if (r !== fg)
      throw new Error(`Got v${r} data when expected v${fg}.`);
    const i = Qw[n & 15];
    if (!i)
      throw new Error("Unrecognized array type.");
    const [o] = new Uint16Array(t, 2, 1), [l] = new Uint32Array(t, 4, 1);
    return new ab(l, o, i, t);
  }
  /**
   * Creates an index that will hold a given number of items.
   * @param {number} numItems
   * @param {number} [nodeSize=64] Size of the KD-tree node (64 by default).
   * @param {TypedArrayConstructor} [ArrayType=Float64Array] The array type used for coordinates storage (`Float64Array` by default).
   * @param {ArrayBuffer} [data] (For internal use only)
   */
  constructor(t, s = 64, n = Float64Array, r) {
    if (isNaN(t) || t < 0) throw new Error(`Unpexpected numItems value: ${t}.`);
    this.numItems = +t, this.nodeSize = Math.min(Math.max(+s, 2), 65535), this.ArrayType = n, this.IndexArrayType = t < 65536 ? Uint16Array : Uint32Array;
    const i = Qw.indexOf(this.ArrayType), o = t * 2 * this.ArrayType.BYTES_PER_ELEMENT, l = t * this.IndexArrayType.BYTES_PER_ELEMENT, d = (8 - l % 8) % 8;
    if (i < 0)
      throw new Error(`Unexpected typed array class: ${n}.`);
    r && r instanceof ArrayBuffer ? (this.data = r, this.ids = new this.IndexArrayType(this.data, tc, t), this.coords = new this.ArrayType(this.data, tc + l + d, t * 2), this._pos = t * 2, this._finished = !0) : (this.data = new ArrayBuffer(tc + o + l + d), this.ids = new this.IndexArrayType(this.data, tc, t), this.coords = new this.ArrayType(this.data, tc + l + d, t * 2), this._pos = 0, this._finished = !1, new Uint8Array(this.data, 0, 2).set([219, (fg << 4) + i]), new Uint16Array(this.data, 2, 1)[0] = s, new Uint32Array(this.data, 4, 1)[0] = t);
  }
  /**
   * Add a point to the index.
   * @param {number} x
   * @param {number} y
   * @returns {number} An incremental index associated with the added item (starting from `0`).
   */
  add(t, s) {
    const n = this._pos >> 1;
    return this.ids[n] = n, this.coords[this._pos++] = t, this.coords[this._pos++] = s, n;
  }
  /**
   * Perform indexing of the added points.
   */
  finish() {
    const t = this._pos >> 1;
    if (t !== this.numItems)
      throw new Error(`Added ${t} items when expected ${this.numItems}.`);
    return ty(this.ids, this.coords, this.nodeSize, 0, this.numItems - 1, 0), this._finished = !0, this;
  }
  /**
   * Search the index for items within a given bounding box.
   * @param {number} minX
   * @param {number} minY
   * @param {number} maxX
   * @param {number} maxY
   * @returns {number[]} An array of indices correponding to the found items.
   */
  range(t, s, n, r) {
    if (!this._finished) throw new Error("Data not yet indexed - call index.finish().");
    const { ids: i, coords: o, nodeSize: l } = this, d = [0, i.length - 1, 0], c = [];
    for (; d.length; ) {
      const u = d.pop() || 0, m = d.pop() || 0, f = d.pop() || 0;
      if (m - f <= l) {
        for (let S = f; S <= m; S++) {
          const I = o[2 * S], T = o[2 * S + 1];
          I >= t && I <= n && T >= s && T <= r && c.push(i[S]);
        }
        continue;
      }
      const v = f + m >> 1, b = o[2 * v], w = o[2 * v + 1];
      b >= t && b <= n && w >= s && w <= r && c.push(i[v]), (u === 0 ? t <= b : s <= w) && (d.push(f), d.push(v - 1), d.push(1 - u)), (u === 0 ? n >= b : r >= w) && (d.push(v + 1), d.push(m), d.push(1 - u));
    }
    return c;
  }
  /**
   * Search the index for items within a given radius.
   * @param {number} qx
   * @param {number} qy
   * @param {number} r Query radius.
   * @returns {number[]} An array of indices correponding to the found items.
   */
  within(t, s, n) {
    if (!this._finished) throw new Error("Data not yet indexed - call index.finish().");
    const { ids: r, coords: i, nodeSize: o } = this, l = [0, r.length - 1, 0], d = [], c = n * n;
    for (; l.length; ) {
      const u = l.pop() || 0, m = l.pop() || 0, f = l.pop() || 0;
      if (m - f <= o) {
        for (let S = f; S <= m; S++)
          Kw(i[2 * S], i[2 * S + 1], t, s) <= c && d.push(r[S]);
        continue;
      }
      const v = f + m >> 1, b = i[2 * v], w = i[2 * v + 1];
      Kw(b, w, t, s) <= c && d.push(r[v]), (u === 0 ? t - n <= b : s - n <= w) && (l.push(f), l.push(v - 1), l.push(1 - u)), (u === 0 ? t + n >= b : s + n >= w) && (l.push(v + 1), l.push(m), l.push(1 - u));
    }
    return d;
  }
}
function ty(e, t, s, n, r, i) {
  if (r - n <= s) return;
  const o = n + r >> 1;
  tk(e, t, o, n, r, i), ty(e, t, s, n, o - 1, 1 - i), ty(e, t, s, o + 1, r, 1 - i);
}
function tk(e, t, s, n, r, i) {
  for (; r > n; ) {
    if (r - n > 600) {
      const c = r - n + 1, u = s - n + 1, m = Math.log(c), f = 0.5 * Math.exp(2 * m / 3), v = 0.5 * Math.sqrt(m * f * (c - f) / c) * (u - c / 2 < 0 ? -1 : 1), b = Math.max(n, Math.floor(s - u * f / c + v)), w = Math.min(r, Math.floor(s + (c - u) * f / c + v));
      tk(e, t, s, b, w, i);
    }
    const o = t[2 * s + i];
    let l = n, d = r;
    for (sc(e, t, n, s), t[2 * r + i] > o && sc(e, t, n, r); l < d; ) {
      for (sc(e, t, l, d), l++, d--; t[2 * l + i] < o; ) l++;
      for (; t[2 * d + i] > o; ) d--;
    }
    t[2 * n + i] === o ? sc(e, t, n, d) : (d++, sc(e, t, d, r)), d <= s && (n = d + 1), s <= d && (r = d - 1);
  }
}
function sc(e, t, s, n) {
  gg(e, s, n), gg(t, 2 * s, 2 * n), gg(t, 2 * s + 1, 2 * n + 1);
}
function gg(e, t, s) {
  const n = e[t];
  e[t] = e[s], e[s] = n;
}
function Kw(e, t, s, n) {
  const r = e - s, i = t - n;
  return r * r + i * i;
}
const bz = {
  minZoom: 0,
  // min zoom to generate clusters on
  maxZoom: 16,
  // max zoom level to cluster the points on
  minPoints: 2,
  // minimum points to form a cluster
  radius: 40,
  // cluster radius in pixels
  extent: 512,
  // tile extent (radius is calculated relative to it)
  nodeSize: 64,
  // size of the KD-tree leaf node, affects performance
  log: !1,
  // whether to log timing info
  // whether to generate numeric ids for input features (in vector tiles)
  generateId: !1,
  // a reduce function for calculating custom cluster properties
  reduce: null,
  // (accumulated, props) => { accumulated.sum += props.sum; }
  // properties to use for individual points when running the reducer
  map: (e) => e
  // props => ({sum: props.my_value})
}, Zw = Math.fround || /* @__PURE__ */ ((e) => (t) => (e[0] = +t, e[0]))(new Float32Array(1)), Vi = 2, ai = 3, vg = 4, $o = 5, sk = 6;
class Az {
  constructor(t) {
    this.options = Object.assign(Object.create(bz), t), this.trees = new Array(this.options.maxZoom + 1), this.stride = this.options.reduce ? 7 : 6, this.clusterProps = [];
  }
  load(t) {
    const { log: s, minZoom: n, maxZoom: r } = this.options;
    s && console.time("total time");
    const i = `prepare ${t.length} points`;
    s && console.time(i), this.points = t;
    const o = [];
    for (let d = 0; d < t.length; d++) {
      const c = t[d];
      if (!c.geometry) continue;
      const [u, m] = c.geometry.coordinates, f = Zw(Pp(u)), v = Zw(kp(m));
      o.push(
        f,
        v,
        // projected point coordinates
        1 / 0,
        // the last zoom the point was processed at
        d,
        // index of the source feature in the original input array
        -1,
        // parent cluster id
        1
        // number of points in a cluster
      ), this.options.reduce && o.push(0);
    }
    let l = this.trees[r + 1] = this._createTree(o);
    s && console.timeEnd(i);
    for (let d = r; d >= n; d--) {
      const c = +Date.now();
      l = this.trees[d] = this._createTree(this._cluster(l, d)), s && console.log("z%d: %d clusters in %dms", d, l.numItems, +Date.now() - c);
    }
    return s && console.timeEnd("total time"), this;
  }
  getClusters(t, s) {
    let n = ((t[0] + 180) % 360 + 360) % 360 - 180;
    const r = Math.max(-90, Math.min(90, t[1]));
    let i = t[2] === 180 ? 180 : ((t[2] + 180) % 360 + 360) % 360 - 180;
    const o = Math.max(-90, Math.min(90, t[3]));
    if (t[2] - t[0] >= 360)
      n = -180, i = 180;
    else if (n > i) {
      const m = this.getClusters([n, r, 180, o], s), f = this.getClusters([-180, r, i, o], s);
      return m.concat(f);
    }
    const l = this.trees[this._limitZoom(s)], d = l.range(Pp(n), kp(o), Pp(i), kp(r)), c = l.data, u = [];
    for (const m of d) {
      const f = this.stride * m;
      u.push(c[f + $o] > 1 ? Jw(c, f, this.clusterProps) : this.points[c[f + ai]]);
    }
    return u;
  }
  getChildren(t) {
    const s = this._getOriginId(t), n = this._getOriginZoom(t), r = "No cluster with the specified id.", i = this.trees[n];
    if (!i) throw new Error(r);
    const o = i.data;
    if (s * this.stride >= o.length) throw new Error(r);
    const l = this.options.radius / (this.options.extent * Math.pow(2, n - 1)), d = o[s * this.stride], c = o[s * this.stride + 1], u = i.within(d, c, l), m = [];
    for (const f of u) {
      const v = f * this.stride;
      o[v + vg] === t && m.push(o[v + $o] > 1 ? Jw(o, v, this.clusterProps) : this.points[o[v + ai]]);
    }
    if (m.length === 0) throw new Error(r);
    return m;
  }
  getLeaves(t, s, n) {
    s = s || 10, n = n || 0;
    const r = [];
    return this._appendLeaves(r, t, s, n, 0), r;
  }
  getTile(t, s, n) {
    const r = this.trees[this._limitZoom(t)], i = Math.pow(2, t), { extent: o, radius: l } = this.options, d = l / o, c = (n - d) / i, u = (n + 1 + d) / i, m = {
      features: []
    };
    return this._addTileFeatures(
      r.range((s - d) / i, c, (s + 1 + d) / i, u),
      r.data,
      s,
      n,
      i,
      m
    ), s === 0 && this._addTileFeatures(
      r.range(1 - d / i, c, 1, u),
      r.data,
      i,
      n,
      i,
      m
    ), s === i - 1 && this._addTileFeatures(
      r.range(0, c, d / i, u),
      r.data,
      -1,
      n,
      i,
      m
    ), m.features.length ? m : null;
  }
  getClusterExpansionZoom(t) {
    let s = this._getOriginZoom(t) - 1;
    for (; s <= this.options.maxZoom; ) {
      const n = this.getChildren(t);
      if (s++, n.length !== 1) break;
      t = n[0].properties.cluster_id;
    }
    return s;
  }
  _appendLeaves(t, s, n, r, i) {
    const o = this.getChildren(s);
    for (const l of o) {
      const d = l.properties;
      if (d && d.cluster ? i + d.point_count <= r ? i += d.point_count : i = this._appendLeaves(t, d.cluster_id, n, r, i) : i < r ? i++ : t.push(l), t.length === n) break;
    }
    return i;
  }
  _createTree(t) {
    const s = new ab(t.length / this.stride | 0, this.options.nodeSize, Float32Array);
    for (let n = 0; n < t.length; n += this.stride) s.add(t[n], t[n + 1]);
    return s.finish(), s.data = t, s;
  }
  _addTileFeatures(t, s, n, r, i, o) {
    for (const l of t) {
      const d = l * this.stride, c = s[d + $o] > 1;
      let u, m, f;
      if (c)
        u = ak(s, d, this.clusterProps), m = s[d], f = s[d + 1];
      else {
        const w = this.points[s[d + ai]];
        u = w.properties;
        const [S, I] = w.geometry.coordinates;
        m = Pp(S), f = kp(I);
      }
      const v = {
        type: 1,
        geometry: [[
          Math.round(this.options.extent * (m * i - n)),
          Math.round(this.options.extent * (f * i - r))
        ]],
        tags: u
      };
      let b;
      c || this.options.generateId ? b = s[d + ai] : b = this.points[s[d + ai]].id, b !== void 0 && (v.id = b), o.features.push(v);
    }
  }
  _limitZoom(t) {
    return Math.max(this.options.minZoom, Math.min(Math.floor(+t), this.options.maxZoom + 1));
  }
  _cluster(t, s) {
    const { radius: n, extent: r, reduce: i, minPoints: o } = this.options, l = n / (r * Math.pow(2, s)), d = t.data, c = [], u = this.stride;
    for (let m = 0; m < d.length; m += u) {
      if (d[m + Vi] <= s) continue;
      d[m + Vi] = s;
      const f = d[m], v = d[m + 1], b = t.within(d[m], d[m + 1], l), w = d[m + $o];
      let S = w;
      for (const I of b) {
        const T = I * u;
        d[T + Vi] > s && (S += d[T + $o]);
      }
      if (S > w && S >= o) {
        let I = f * w, T = v * w, x, k = -1;
        const C = ((m / u | 0) << 5) + (s + 1) + this.points.length;
        for (const O of b) {
          const E = O * u;
          if (d[E + Vi] <= s) continue;
          d[E + Vi] = s;
          const B = d[E + $o];
          I += d[E] * B, T += d[E + 1] * B, d[E + vg] = C, i && (x || (x = this._map(d, m, !0), k = this.clusterProps.length, this.clusterProps.push(x)), i(x, this._map(d, E)));
        }
        d[m + vg] = C, c.push(I / S, T / S, 1 / 0, C, -1, S), i && c.push(k);
      } else {
        for (let I = 0; I < u; I++) c.push(d[m + I]);
        if (S > 1)
          for (const I of b) {
            const T = I * u;
            if (!(d[T + Vi] <= s)) {
              d[T + Vi] = s;
              for (let x = 0; x < u; x++) c.push(d[T + x]);
            }
          }
      }
    }
    return c;
  }
  // get index of the point from which the cluster originated
  _getOriginId(t) {
    return t - this.points.length >> 5;
  }
  // get zoom of the point from which the cluster originated
  _getOriginZoom(t) {
    return (t - this.points.length) % 32;
  }
  _map(t, s, n) {
    if (t[s + $o] > 1) {
      const o = this.clusterProps[t[s + sk]];
      return n ? Object.assign({}, o) : o;
    }
    const r = this.points[t[s + ai]].properties, i = this.options.map(r);
    return n && i === r ? Object.assign({}, i) : i;
  }
}
function Jw(e, t, s) {
  return {
    type: "Feature",
    id: e[t + ai],
    properties: ak(e, t, s),
    geometry: {
      type: "Point",
      coordinates: [wz(e[t]), Cz(e[t + 1])]
    }
  };
}
function ak(e, t, s) {
  const n = e[t + $o], r = n >= 1e4 ? `${Math.round(n / 1e3)}k` : n >= 1e3 ? `${Math.round(n / 100) / 10}k` : n, i = e[t + sk], o = i === -1 ? {} : Object.assign({}, s[i]);
  return Object.assign(o, {
    cluster: !0,
    cluster_id: e[t + ai],
    point_count: n,
    point_count_abbreviated: r
  });
}
function Pp(e) {
  return e / 360 + 0.5;
}
function kp(e) {
  const t = Math.sin(e * Math.PI / 180), s = 0.5 - 0.25 * Math.log((1 + t) / (1 - t)) / Math.PI;
  return s < 0 ? 0 : s > 1 ? 1 : s;
}
function wz(e) {
  return (e - 0.5) * 360;
}
function Cz(e) {
  const t = (180 - e * 360) * Math.PI / 180;
  return 360 * Math.atan(Math.exp(t)) / Math.PI - 90;
}
function Sz(e, t) {
  var s = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (s[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var r = 0, n = Object.getOwnPropertySymbols(e); r < n.length; r++)
      t.indexOf(n[r]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[r]) && (s[n[r]] = e[n[r]]);
  return s;
}
class kn {
  static isAdvancedMarkerAvailable(t) {
    return google.maps.marker && t.getMapCapabilities().isAdvancedMarkersAvailable === !0;
  }
  static isAdvancedMarker(t) {
    return google.maps.marker && t instanceof google.maps.marker.AdvancedMarkerElement;
  }
  static setMap(t, s) {
    this.isAdvancedMarker(t) ? t.map = s : t.setMap(s);
  }
  static getPosition(t) {
    if (this.isAdvancedMarker(t)) {
      if (t.position) {
        if (t.position instanceof google.maps.LatLng)
          return t.position;
        if (Number.isFinite(t.position.lat) && Number.isFinite(t.position.lng))
          return new google.maps.LatLng(t.position.lat, t.position.lng);
      }
      return new google.maps.LatLng(null);
    }
    return t.getPosition();
  }
  static getVisible(t) {
    return this.isAdvancedMarker(t) ? !0 : t.getVisible();
  }
}
class sy {
  constructor({ markers: t, position: s }) {
    this.markers = [], t && (this.markers = t), s && (s instanceof google.maps.LatLng ? this._position = s : this._position = new google.maps.LatLng(s));
  }
  get bounds() {
    if (this.markers.length === 0 && !this._position)
      return;
    const t = new google.maps.LatLngBounds(this._position, this._position);
    for (const s of this.markers)
      t.extend(kn.getPosition(s));
    return t;
  }
  get position() {
    return this._position || this.bounds.getCenter();
  }
  /**
   * Get the count of **visible** markers.
   */
  get count() {
    return this.markers.filter((t) => kn.getVisible(t)).length;
  }
  /**
   * Add a marker to the cluster.
   */
  push(t) {
    this.markers.push(t);
  }
  /**
   * Cleanup references and remove marker from map.
   */
  delete() {
    this.marker && (kn.setMap(this.marker, null), this.marker = void 0), this.markers.length = 0;
  }
}
function ay(e, t = "assertion failed") {
  if (e == null)
    throw Error(t);
}
class Pz {
  constructor({ maxZoom: t = 16 }) {
    this.maxZoom = t;
  }
  /**
   * Helper function to bypass clustering based upon some map state such as
   * zoom, number of markers, etc.
   *
   * ```typescript
   *  cluster({markers, map}: AlgorithmInput): Cluster[] {
   *    if (shouldBypassClustering(map)) {
   *      return this.noop({markers})
   *    }
   * }
   * ```
   */
  noop({ markers: t }) {
    return kz(t);
  }
}
const kz = (e) => e.map((s) => new sy({
  position: kn.getPosition(s),
  markers: [s]
}));
class nk extends Pz {
  constructor(t) {
    var { maxZoom: s, radius: n = 60 } = t, r = Sz(t, ["maxZoom", "radius"]);
    super({ maxZoom: s }), this.markers = [], this.clusters = [], this.state = { zoom: -1 }, this.superCluster = new Az(Object.assign({ maxZoom: this.maxZoom, radius: n }, r));
  }
  calculate(t) {
    let s = !1, n = t.map.getZoom();
    ay(n), n = Math.round(n);
    const r = { zoom: n };
    if (!qw(t.markers, this.markers)) {
      s = !0, this.markers = [...t.markers];
      const i = this.markers.map((o) => {
        const l = kn.getPosition(o);
        return {
          type: "Feature",
          geometry: { type: "Point", coordinates: [l.lng(), l.lat()] },
          properties: { marker: o }
        };
      });
      this.superCluster.load(i);
    }
    return s || (this.state.zoom <= this.maxZoom || r.zoom <= this.maxZoom) && (s = !qw(this.state, r)), this.state = r, t.markers.length === 0 ? (this.clusters = [], { clusters: this.clusters, changed: s }) : (s && (this.clusters = this.cluster(t)), { clusters: this.clusters, changed: s });
  }
  cluster({ map: t }) {
    const s = t.getZoom();
    return ay(s), this.superCluster.getClusters([-180, -90, 180, 90], Math.round(s)).map((n) => this.transformCluster(n));
  }
  transformCluster({ geometry: { coordinates: [t, s] }, properties: n }) {
    if (n.cluster)
      return new sy({
        markers: this.superCluster.getLeaves(n.cluster_id, 1 / 0).map((i) => i.properties.marker),
        position: { lat: s, lng: t }
      });
    const r = n.marker;
    return new sy({
      markers: [r],
      position: kn.getPosition(r)
    });
  }
}
class Ez {
  constructor(t, s) {
    this.markers = { sum: t.length };
    const n = s.map((i) => i.count), r = n.reduce((i, o) => i + o, 0);
    this.clusters = {
      count: s.length,
      markers: {
        mean: r / s.length,
        sum: r,
        min: Math.min(...n),
        max: Math.max(...n)
      }
    };
  }
}
class rk {
  /**
   * The default render function for the library used by {@link MarkerClusterer}.
   *
   * Currently set to use the following:
   *
   * ```typescript
   * // change color if this cluster has more markers than the mean cluster
   * const color =
   *   count > Math.max(10, stats.clusters.markers.mean)
   *     ? "#ff0000"
   *     : "#0000ff";
   *
   * // create svg url with fill color
   * const svg = window.btoa(`
   * <svg fill="${color}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240">
   *   <circle cx="120" cy="120" opacity=".6" r="70" />
   *   <circle cx="120" cy="120" opacity=".3" r="90" />
   *   <circle cx="120" cy="120" opacity=".2" r="110" />
   *   <circle cx="120" cy="120" opacity=".1" r="130" />
   * </svg>`);
   *
   * // create marker using svg icon
   * return new google.maps.Marker({
   *   position,
   *   icon: {
   *     url: `data:image/svg+xml;base64,${svg}`,
   *     scaledSize: new google.maps.Size(45, 45),
   *   },
   *   label: {
   *     text: String(count),
   *     color: "rgba(255,255,255,0.9)",
   *     fontSize: "12px",
   *   },
   *   // adjust zIndex to be above other markers
   *   zIndex: 1000 + count,
   * });
   * ```
   */
  render({ count: t, position: s }, n, r) {
    const o = `<svg fill="${t > Math.max(10, n.clusters.markers.mean) ? "#ff0000" : "#0000ff"}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240" width="50" height="50">
<circle cx="120" cy="120" opacity=".6" r="70" />
<circle cx="120" cy="120" opacity=".3" r="90" />
<circle cx="120" cy="120" opacity=".2" r="110" />
<text x="50%" y="50%" style="fill:#fff" text-anchor="middle" font-size="50" dominant-baseline="middle" font-family="roboto,arial,sans-serif">${t}</text>
</svg>`, l = `Cluster of ${t} markers`, d = Number(google.maps.Marker.MAX_ZINDEX) + t;
    if (kn.isAdvancedMarkerAvailable(r)) {
      const m = new DOMParser().parseFromString(o, "image/svg+xml").documentElement;
      m.setAttribute("transform", "translate(0 25)");
      const f = {
        map: r,
        position: s,
        zIndex: d,
        title: l,
        content: m
      };
      return new google.maps.marker.AdvancedMarkerElement(f);
    }
    const c = {
      position: s,
      zIndex: d,
      title: l,
      icon: {
        url: `data:image/svg+xml;base64,${btoa(o)}`,
        anchor: new google.maps.Point(25, 25)
      }
    };
    return new google.maps.Marker(c);
  }
}
function Iz(e, t) {
  for (let s in t.prototype)
    e.prototype[s] = t.prototype[s];
}
class nb {
  constructor() {
    Iz(nb, google.maps.OverlayView);
  }
}
var Ui;
(function(e) {
  e.CLUSTERING_BEGIN = "clusteringbegin", e.CLUSTERING_END = "clusteringend", e.CLUSTER_CLICK = "click", e.GMP_CLICK = "gmp-click";
})(Ui || (Ui = {}));
const Tz = (e, t, s) => {
  t.bounds && s.fitBounds(t.bounds);
};
class $w extends nb {
  constructor({ map: t, markers: s = [], algorithmOptions: n = {}, algorithm: r = new nk(n), renderer: i = new rk(), onClusterClick: o = Tz }) {
    super(), this.map = null, this.idleListener = null, this.markers = [...s], this.clusters = [], this.algorithm = r, this.renderer = i, this.onClusterClick = o, t && this.setMap(t);
  }
  addMarker(t, s) {
    this.markers.includes(t) || (this.markers.push(t), s || this.render());
  }
  addMarkers(t, s) {
    t.forEach((n) => {
      this.addMarker(n, !0);
    }), s || this.render();
  }
  removeMarker(t, s) {
    const n = this.markers.indexOf(t);
    return n === -1 ? !1 : (kn.setMap(t, null), this.markers.splice(n, 1), s || this.render(), !0);
  }
  removeMarkers(t, s) {
    let n = !1;
    return t.forEach((r) => {
      n = this.removeMarker(r, !0) || n;
    }), n && !s && this.render(), n;
  }
  clearMarkers(t) {
    this.markers.length = 0, t || this.render();
  }
  /**
   * Recalculates and draws all the marker clusters.
   */
  render() {
    const t = this.getMap();
    if (t instanceof google.maps.Map && t.getProjection()) {
      google.maps.event.trigger(this, Ui.CLUSTERING_BEGIN, this);
      const { clusters: s, changed: n } = this.algorithm.calculate({
        markers: this.markers,
        map: t,
        mapCanvasProjection: this.getProjection()
      });
      if (n || n == null) {
        const r = /* @__PURE__ */ new Set();
        for (const o of s)
          o.markers.length == 1 && r.add(o.markers[0]);
        const i = [];
        for (const o of this.clusters)
          o.marker != null && (o.markers.length == 1 ? r.has(o.marker) || kn.setMap(o.marker, null) : i.push(o.marker));
        this.clusters = s, this.renderClusters(), requestAnimationFrame(() => i.forEach((o) => kn.setMap(o, null)));
      }
      google.maps.event.trigger(this, Ui.CLUSTERING_END, this);
    }
  }
  onAdd() {
    const t = this.getMap();
    ay(t), this.idleListener = t.addListener("idle", this.render.bind(this)), this.render();
  }
  onRemove() {
    this.idleListener && google.maps.event.removeListener(this.idleListener), this.reset();
  }
  reset() {
    this.markers.forEach((t) => kn.setMap(t, null)), this.clusters.forEach((t) => t.delete()), this.clusters = [];
  }
  renderClusters() {
    const t = new Ez(this.markers, this.clusters), s = this.getMap();
    this.clusters.forEach((n) => {
      if (n.markers.length === 1)
        n.marker = n.markers[0];
      else if (n.marker = this.renderer.render(n, t, s), n.markers.forEach((r) => kn.setMap(r, null)), this.onClusterClick) {
        const r = kn.isAdvancedMarker(n.marker) ? Ui.GMP_CLICK : Ui.CLUSTER_CLICK;
        n.marker.addListener(
          r,
          /* istanbul ignore next */
          (i) => {
            google.maps.event.trigger(this, Ui.CLUSTER_CLICK, n), this.onClusterClick(i, n, s);
          }
        );
      }
      kn.setMap(n.marker, s);
    });
  }
}
class Oz extends nk {
  //public calculate(input: AlgorithmInput): AlgorithmOutput {
  //    return super.calculate({ ...input, markers: input.markers.filter(m => m.getVisible()) });
  //}
}
const yg = {
  algorithm: {
    type: Object,
    default: new Oz({}),
    noBind: !0
  },
  renderer: {
    type: Object,
    default: new rk(),
    noBind: !0
  },
  largeClusterColor: {
    type: String,
    noBind: !0
  },
  smallClusterColor: {
    type: String,
    noBind: !0
  }
}, Rz = ["clusteringbegin", "clusteringend"], Lz = of({
  mappedProps: yg,
  events: Rz,
  name: "cluster",
  ctr: () => {
    if (typeof $w > "u") {
      const e = "MarkerClusterer is not installed!";
      throw console.error(e), new Error(e);
    }
    return $w;
  },
  ctrArgs: ({ map: e, ...t }) => [{ map: e, ...t }],
  afterCreate(e) {
    console.log(`${this.$options.name}.afterCreate`, e);
    const t = () => {
      console.log(`${this.$options.name}.reinsertMarkers`, e);
      const s = e.getMarkers();
      console.log("reinsertMarkers", s), e.clearMarkers(), e.addMarkers(s);
    };
    for (let s in yg)
      yg[s].twoWay && this.$on(s.toLowerCase() + "_changed", t);
  },
  updated() {
    this.$clusterObject && this.$clusterObject.render();
  },
  beforeUnmount() {
    console.log(`${this.$options.name}.beforeUnmount`), this.$children && this.$children.length && this.$children.forEach((e) => {
      e.$clusterObject === this.$clusterObject && (e.$clusterObject = null);
    }), this.$clusterObject && this.$clusterObject.clearMarkers();
  }
});
function Bz(e, t, s, n, r, i) {
  return p(), h("div", null, [
    Ot(e.$slots, "default")
  ]);
}
const Mz = /* @__PURE__ */ Ae(Lz, [["render", Bz]]), xz = {
  options: {
    type: Object,
    required: !1,
    default() {
      return {};
    }
  },
  position: {
    type: Object,
    twoWay: !0
  },
  zIndex: {
    type: Number,
    twoWay: !0
  }
}, _w = ["domready", "click", "closeclick", "content_changed"], Fz = of({
  mappedProps: xz,
  events: _w,
  name: "infoWindow",
  ctr: () => google.maps.InfoWindow,
  props: {
    opened: {
      type: Boolean,
      default: !0
    }
  },
  inject: {
    $markerPromise: {
      default: null
    }
  },
  mounted() {
    const e = this.$refs.infoWindow;
    e.parentNode.removeChild(e);
  },
  beforeCreate(e) {
    if (e.content = this.$refs.infoWindow, this.$markerPromise)
      return delete e.position, this.$markerPromise.then((t) => (this.$markerObject = t, t));
  },
  emits: ["closeclick", "open"],
  methods: {
    _openInfoWindow(e = !1) {
      this.$infoWindowObject.close(), this.opened ? (this.$infoWindowObject.open(this.$map, this.$markerObject), this.$emit("open", this, this.$markerObject)) : e || this.$emit("closeclick", this, this.$markerObject);
    }
  },
  afterCreate(e) {
    _w.forEach((t) => {
      e.addListener(t, () => {
        this.$emit(t, this, this.$markerObject);
      });
    }), this._openInfoWindow(!0), this.$watch("opened", () => {
      this._openInfoWindow();
    });
  }
}), Vz = { ref: "infoWindow" };
function Dz(e, t, s, n, r, i) {
  return p(), h("div", Vz, [
    Ot(e.$slots, "default")
  ], 512);
}
const Nz = /* @__PURE__ */ Ae(Fz, [["render", Dz]]);
function e2(e) {
  let t = !1, s;
  return () => (t || (t = !0, s = e()), s);
}
class ny {
  static isServer() {
    return typeof document > "u";
  }
}
const jz = "https://maps.googleapis.com/maps/api/js?";
function Hz(e) {
  if (typeof e != "object")
    throw new Error("options should be an object");
  Array.prototype.isPrototypeOf(e.libraries) && (e.libraries = e.libraries.join(",")), e.callback = "vueGoogleMapsInit", e.loading = "async";
  const t = jz + Object.keys(e).map((n) => encodeURIComponent(n) + "=" + encodeURIComponent(e[n])).join("&"), s = document.createElement("script");
  return s.src = t, s.async = !0, s.defer = !0, s;
}
let t2 = !1;
function Uz(e) {
  if (ny.isServer() != !0) {
    if (t2)
      throw new Error("You already started the loading of google maps");
    {
      t2 = !0;
      const t = Hz(e);
      document.head.appendChild(t);
    }
  }
}
var Ep = { exports: {} }, s2;
function zz() {
  if (s2) return Ep.exports;
  s2 = 1;
  function e() {
  }
  return e.prototype = {
    on: function(t, s, n) {
      var r = this.e || (this.e = {});
      return (r[t] || (r[t] = [])).push({
        fn: s,
        ctx: n
      }), this;
    },
    once: function(t, s, n) {
      var r = this;
      function i() {
        r.off(t, i), s.apply(n, arguments);
      }
      return i._ = s, this.on(t, i, n);
    },
    emit: function(t) {
      var s = [].slice.call(arguments, 1), n = ((this.e || (this.e = {}))[t] || []).slice(), r = 0, i = n.length;
      for (r; r < i; r++)
        n[r].fn.apply(n[r].ctx, s);
      return this;
    },
    off: function(t, s) {
      var n = this.e || (this.e = {}), r = n[t], i = [];
      if (r && s)
        for (var o = 0, l = r.length; o < l; o++)
          r[o].fn !== s && r[o].fn._ !== s && i.push(r[o]);
      return i.length ? n[t] = i : delete n[t], this;
    }
  }, Ep.exports = e, Ep.exports.TinyEmitter = e, Ep.exports;
}
var Wz = zz();
let ok;
const ik = Symbol("gmapApiPromiseLazy");
function Gz(e) {
  function t() {
    return console.log("VueGoogleMapsPlugin (google maps loaded)", !!window.google), ok.gmapApi = {}, !!window.google;
  }
  if (e.load)
    return e2(() => ny.isServer() ? new Promise(() => {
    }).then(t) : new Promise((s, n) => {
      try {
        window.vueGoogleMapsInit = s, Uz(e.load);
      } catch (r) {
        n(r);
      }
    }).then(t));
  {
    const s = new Promise((n) => {
      ny.isServer() || (window.vueGoogleMapsInit = n);
    }).then(t);
    return e2(() => s);
  }
}
const xis = {
  install(e, t) {
    console.log("VueGoogleMapsPlugin.install"), t = {
      /* @ts-expect-error Default value */
      installComponents: !0,
      /* @ts-expect-error Default value */
      autobindAllEvents: !1,
      ...t
    }, ok = tI({
      data: function() {
        return {
          gmapApi: null
        };
      }
    });
    const s = new Wz.TinyEmitter(), n = Gz(t);
    e.mixin({
      created() {
        this.$gmapOptions = t, this.$gmapDefaultResizeBus = s, this.$gmapApiPromiseLazy = n;
      }
    }), e.provide(ik, n), e.config.globalProperties.$gmapOptions = t, e.config.globalProperties.$gmapDefaultResizeBus = s, e.config.globalProperties.$gmapApiPromiseLazy = n, t.installComponents && (e.component("GMapMap", RU), e.component("GMapMarker", xU), e.component("GMapAdvMarker", NU), e.component("GMapInfoWindow", Nz), e.component("GMapCluster", Mz));
  }
}, Yz = !0, Ma = 1e3;
function Rd() {
  return {
    id: "barMarkerText",
    afterDatasetDraw: () => {
    }
  };
}
function Ld() {
  return {
    labels: ["2022", "2023", "2024", "2025", "2026", "2027", "2028"],
    datasets: [
      {
        label: "Before Tax",
        data: [19e4, 21e4, 23e4, 255e3, 28e4, 31e4, 325e3],
        backgroundColor: [
          De.Colors.Charts.LightBlue,
          De.Colors.Charts.LightBlue,
          De.Colors.Charts.DarkBlue,
          De.Colors.Charts.DarkEclipse,
          De.Colors.Charts.DarkEclipse,
          De.Colors.Charts.DarkEclipse,
          De.Colors.Charts.DarkEclipse
        ]
      },
      {
        label: "After Tax",
        data: [19e4, 21e4, 23e4, 255e3, 28e4, 31e4, 325e3],
        backgroundColor: [
          De.Colors.Charts.LightBlue,
          De.Colors.Charts.LightBlue,
          De.Colors.Charts.DarkBlue,
          De.Colors.Charts.BeeCluster,
          De.Colors.Charts.BeeCluster,
          De.Colors.Charts.BeeCluster,
          De.Colors.Charts.BeeCluster
        ]
      }
    ]
  };
}
function Bd() {
  return {
    indexAxis: "x",
    scales: {
      y: {
        beginAtZero: !0,
        ticks: {
          callback: function(e) {
            return Ze(e);
          }
        }
      }
    },
    plugins: {
      legend: {
        display: !1
      },
      tooltip: {
        mode: "index",
        intersect: !1,
        callbacks: {
          label(e) {
            let t = e.dataset.label ?? "";
            const s = ": " + Ze(e.dataset.data[e.dataIndex]);
            return t += s, t;
          }
        }
      },
      /* @ts-expect-error custom options for plugin */
      barMarkerText: {
        //borderColor: 'aqua',
        //borderWidth: 15,
        text: "You are here",
        color: "white",
        fontWeight: "bold",
        fontSize: 11
      }
    }
  };
}
function lk() {
  return {
    labels: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
    datasets: [
      {
        label: "Effective Rental Income",
        data: [15 * Ma, 16 * Ma, 17 * Ma, 18 * Ma, 19 * Ma, 20 * Ma, 21 * Ma, 22 * Ma, 23 * Ma, 24 * Ma],
        backgroundColor: De.Colors.Charts.Grey1
      },
      {
        label: "Total Expenses",
        data: [11 * Ma, 12 * Ma, 13 * Ma, 14 * Ma, 15 * Ma, 16 * Ma, 17 * Ma, 18 * Ma, 19 * Ma, 20 * Ma],
        backgroundColor: De.Colors.Charts.Grey2
      },
      {
        label: "Annual Cash Flow",
        data: [-1720, 2730, -1384, 3253, -1033, 3798, -668, 4365, -288, 4956],
        backgroundColor: De.Colors.Charts.Grey3
      }
    ]
  };
}
function dk() {
  return {
    responsive: !0,
    maintainAspectRatio: !0,
    plugins: {
      title: {
        display: !1,
        text: "Income & Expenses"
      },
      legend: {
        display: !1,
        position: "bottom",
        maxHeight: 100,
        labels: {
          boxWidth: 10
        }
      },
      tooltip: {
        mode: "index",
        intersect: !1,
        callbacks: {
          label: function(e) {
            let t = e.dataset.label;
            const s = ": " + Ze(e.dataset.data[e.dataIndex]);
            return t += s, t;
          }
        }
      }
    },
    scales: {
      y: {
        beginAtZero: !0,
        ticks: {
          callback: function(e) {
            return Ze(e);
          }
        }
      }
    }
  };
}
function ck() {
  return {
    labels: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
    datasets: [
      {
        label: "Purchase Price",
        data: [0, 0, 24e-4, 0.052, 0.0647, 0.0828, 0.0859, 0.0943, 0.0945, 0.0988],
        type: "line",
        backgroundColor: De.Colors.Charts.Grey1,
        borderColor: De.Colors.Charts.Grey1,
        borderWidth: 1,
        pointRadius: 1,
        fill: !1,
        tension: 0.4,
        yAxisID: "y"
      },
      {
        label: "Property Value",
        data: [0, 0, 24e-4, 0.052, 0.0647, 0.0828, 0.0859, 0.0943, 0.0945, 0.0988],
        type: "line",
        backgroundColor: De.Colors.Charts.Grey1,
        borderColor: De.Colors.Charts.Grey1,
        borderWidth: 1,
        pointRadius: 1,
        fill: !1,
        tension: 0.4,
        yAxisID: "y"
      },
      {
        label: "Net Gain on Investment",
        data: [0, 0, 24e-4, 0.052, 0.0647, 0.0828, 0.0859, 0.0943, 0.0945, 0.0988],
        type: "bar",
        backgroundColor: De.Colors.Charts.Grey1,
        yAxisID: "y2"
      }
    ]
  };
}
function uk() {
  return {
    responsive: !0,
    maintainAspectRatio: !0,
    plugins: {
      title: {
        display: !1,
        text: "RTP Ratio"
      },
      legend: {
        display: !1,
        position: "bottom",
        maxHeight: 100,
        labels: {
          boxWidth: 10
        }
      },
      tooltip: {
        mode: "index",
        intersect: !1,
        callbacks: {
          label(e) {
            let t = e.dataset.label ?? "";
            return e.datasetIndex < 2 ? t += `: ${Wt(e.dataset.data[e.dataIndex], 1)}` : t += `: ${Ze(e.dataset.data[e.dataIndex])}`, t;
          }
        }
      }
    },
    scales: {
      y: {
        stacked: !1,
        beginAtZero: !0,
        ticks: {
          callback(e) {
            return Wt(e);
          }
        },
        grid: {
          lineWidth: ({ tick: e }) => e.value == 0 ? 2 : 1,
          color: ({ tick: e }) => e.value == 0 ? "rgba(0, 0, 0, 0.3)" : Rt.defaults.backgroundColor.toString()
        }
      },
      y2: {
        position: "right",
        ticks: {
          callback: function(e) {
            return ka(e);
          }
        }
      }
    }
  };
}
function lf() {
  return {
    labels: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
    datasets: [
      {
        label: "Cash on Cash",
        data: [74e-4, 0.0116, 0.0158, 0.0202, 0.0246, 0.0291, 0.0337, 0.0384, 0.0432, 0.0481],
        type: "line",
        backgroundColor: De.Colors.Charts.Grey1,
        borderColor: De.Colors.Charts.Grey1,
        borderWidth: 1,
        pointRadius: 1,
        fill: !1,
        tension: 0.4
      },
      {
        label: "Cash on Cash (After Tax)",
        data: [74e-4, 0.0116, 0.0158, 0.0202, 0.0246, 0.0291, 0.0337, 0.0384, 0.0432, 0.0481],
        type: "line",
        backgroundColor: De.Colors.Charts.Grey1,
        borderColor: De.Colors.Charts.Grey1,
        borderWidth: 1,
        pointRadius: 1,
        fill: !1,
        tension: 0.4
      },
      {
        label: "Return on Equity",
        data: [0.0161, 0.0183, 0.0199, 0.021, 0.0219, 0.0225, 0.023, 0.0234, 0.0237, 0.0239],
        type: "line",
        backgroundColor: De.Colors.Charts.Grey3,
        borderColor: De.Colors.Charts.Grey3,
        borderWidth: 1,
        pointRadius: 1,
        fill: !1,
        tension: 0.4
      }
    ]
  };
}
function df() {
  return {
    responsive: !0,
    maintainAspectRatio: !0,
    plugins: {
      title: {
        display: !1,
        text: "Cash on Cash Return"
      },
      legend: {
        display: !1,
        position: "bottom",
        maxHeight: 100,
        labels: {
          boxWidth: 10
        }
      },
      tooltip: {
        mode: "index",
        intersect: !1,
        callbacks: {
          label: function(e) {
            let t = e.dataset.label;
            const s = ": " + Wt(e.dataset.data[e.dataIndex], 2);
            return t += s, t;
          }
        }
      }
    },
    scales: {
      y: {
        stacked: !1,
        beginAtZero: !0,
        ticks: {
          callback: function(e) {
            return Wt(e, 1);
          }
        },
        grid: {
          lineWidth: ({ tick: e }) => e.value == 0 ? 2 : 1,
          color: ({ tick: e }) => e.value == 0 ? "rgba(0, 0, 0, 0.3)" : Rt.defaults.backgroundColor.toString()
        }
      }
    }
  };
}
function pk() {
  return {
    labels: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
    datasets: [
      {
        label: "Total",
        data: [34666, 46951, 55476, 69004, 78627, 93477, 104271, 120527, 132574, 150327],
        type: "line",
        backgroundColor: De.Colors.Charts.Grey1,
        fill: !1,
        borderColor: De.Colors.Charts.Grey1,
        pointBorderColor: De.Colors.Charts.Grey1,
        pointBackgroundColor: De.Colors.Charts.Grey1,
        pointRadius: 0,
        pointHoverRadius: 0
      },
      {
        type: "bar",
        label: "Cumulative Cash Flow",
        backgroundColor: De.Colors.Charts.Grey2,
        stack: "Stack 0",
        data: [-1720, 1010, -374, 2879, 1846, 5644, 4975, 9340, 9052, 14009]
      },
      {
        type: "bar",
        label: "Initial Equity",
        backgroundColor: De.Colors.Charts.Grey3,
        stack: "Stack 0",
        data: [36386, 43703, 50525, 50525, 50525, 50525, 50525, 50525, 50525, 50525]
      },
      {
        type: "bar",
        label: "Net Appreciation",
        backgroundColor: De.Colors.Charts.Grey1,
        stack: "Stack 0",
        data: [0, 0, 745, 8572, 16667, 25040, 33701, 42661, 51931, 61521]
      },
      {
        type: "bar",
        label: "Principal Reduction",
        backgroundColor: De.Colors.Charts.Grey2,
        stack: "Stack 0",
        data: [0, 2238, 4580, 7028, 9589, 12268, 15070, 18001, 21066, 24272]
      }
    ]
  };
}
function hk() {
  return {
    responsive: !0,
    maintainAspectRatio: !0,
    plugins: {
      title: {
        display: !1,
        text: "Projected Appreciation of Wealth"
      },
      legend: {
        display: !1,
        position: "bottom",
        maxHeight: 100,
        labels: {
          boxWidth: 10,
          filter: function(e) {
            return e.text != "Total";
          }
        }
      },
      tooltip: {
        mode: "index",
        intersect: !1,
        callbacks: {
          label: function(e) {
            const t = e.label;
            document.querySelectorAll(".mlse-column").forEach((r) => {
              r.classList.remove("hover");
            }), document.querySelectorAll(`.mlse-column[data-count="${t}"]`).forEach((r) => {
              r.classList.add("hover");
            });
            let s = e.dataset.label ?? "";
            const n = ": " + Ze(e.dataset.data[e.dataIndex]);
            return s += n, s;
          }
        }
      }
    },
    scales: {
      x: {
        stacked: !0
      },
      y: {
        stacked: !0,
        ticks: {
          callback: function(e) {
            return Ze(e);
          }
        }
      }
    }
  };
}
function tr(e, t, s, n) {
  return {
    type: e,
    data: t,
    options: s,
    plugins: n
  };
}
const Xz = () => ({
  type: "doughnut",
  data: {
    labels: [],
    datasets: [{
      data: [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
      backgroundColor: [De.Colors.Charts.Grey1]
    }]
  },
  options: {
    circumference: 180,
    rotation: -90,
    cutoutPercentage: 60,
    responsive: !1,
    plugins: {
      tooltip: {
        enabled: !0,
        callbacks: {
          label(e) {
            return e.label;
          }
        }
      },
      legend: {
        display: !1
      },
      title: {
        display: !1
      },
      centerText: {
        datasetIndex: 0,
        fontWeight: "700",
        fontSize: "16px",
        font: "Lato, sans-serif",
        yAdjust: -5
      }
    },
    animation: {
      animateScale: !1,
      animateRotate: !0
    }
  },
  plugins: [
    K4
  ]
});
function mk(e, t, s, n = "#d65302") {
  class r extends google.maps.OverlayView {
    /**
     * Creates a new Map Label
     * @param options
     */
    constructor(l) {
      super();
      Xe(this, "canvas_");
      this.set("fontFamily", "sans-serif"), this.set("fontSize", 12), this.set("fontColor", "#000000"), this.set("strokeWeight", 4), this.set("strokeColor", "#ffffff"), this.set("align", "center"), this.set("zIndex", 1e3), this.setValues(l);
    }
    changed(l) {
      switch (l) {
        case "fontFamily":
        case "fontSize":
        case "fontColor":
        case "strokeWeight":
        case "strokeColor":
        case "align":
        case "text":
          return this.drawCanvas_();
        case "maxZoom":
        case "minZoom":
        case "position":
          return this.draw();
      }
    }
    /**
     * Draws the label to the canvas 2d context.
     */
    drawCanvas_() {
      const l = this.canvas_;
      if (!l) return;
      const d = l.style;
      d.zIndex = /** @type number */
      this.get("zIndex");
      const c = l.getContext("2d");
      c.clearRect(0, 0, l.width, l.height), c.strokeStyle = this.get("strokeColor"), c.fillStyle = this.get("fontColor"), c.font = `${this.get("fontSize")}px ${this.get("fontFamily")}`;
      const u = Number(this.get("strokeWeight")), m = this.get("text");
      if (m) {
        u && (c.lineWidth = u, c.strokeText(m, u, u)), c.fillText(m, u, u);
        const v = c.measureText(m).width + u;
        d.marginLeft = `${this.getMarginLeft_(v)}px`, d.marginTop = "-0.4em";
      }
    }
    /**
     * @inheritDoc
     */
    onAdd() {
      const l = this.canvas_ = document.createElement("canvas"), d = l.style;
      d.position = "absolute";
      const c = l.getContext("2d");
      c.lineJoin = "round", c.textBaseline = "top", this.drawCanvas_();
      const u = this.getPanes();
      u && u.mapPane.appendChild(l);
    }
    /**
     * @inheritDoc
     */
    onRemove() {
      const l = this.canvas_;
      l && l.parentNode && l.parentNode.removeChild(l);
    }
    /**
     * Gets the appropriate margin-left for the canvas.
     * 
     * @param textWidth the width of the text, in pixels.
     * @return the margin-left, in pixels.
     */
    getMarginLeft_(l) {
      switch (this.get("align")) {
        case "left":
          return 0;
        case "right":
          return -l;
      }
      return l / -2;
    }
    /**
     * @inheritDoc
     */
    draw() {
      const l = this.getProjection();
      if (!l || !this.canvas_)
        return;
      const d = (
        /** @type {google.maps.LatLng} */
        this.get("position")
      );
      if (!d)
        return;
      const c = l.fromLatLngToDivPixel(d), u = this.canvas_.style;
      u.top = `${c.y}px`, u.left = `${c.x}px`, u.visibility = this.getVisible_();
    }
    /**
     * Get the visibility of the label.
     * 
     * @return blank string if visible, 'hidden' if invisible.
     */
    getVisible_() {
      const l = (
        /** @type number */
        this.get("minZoom")
      ), d = (
        /** @type number */
        this.get("maxZoom")
      );
      if (l === void 0 && d === void 0)
        return "";
      const c = this.getMap();
      if (!c)
        return "";
      const u = c.getZoom();
      return u != null && (u < l || u > d) ? "hidden" : "";
    }
  }
  return new r({
    text: e,
    position: t,
    map: s,
    fontSize: 13,
    fontFamily: "sans-serif",
    fontColor: n,
    strokeWeight: 0,
    strokeColor: "#fce303",
    align: "center",
    zIndex: 1e3,
    minZoom: 11
    //maxZoom: 10
  });
}
class En {
  static parseGeoJsonDataGeometry(t) {
    if (t.type === qo.Polygon)
      return console.log("GoogleMapUtility.parseGeoJsonGeometry", t.type), En.geoJsonPolygonToGDataPolygon(t.coordinates);
    if (t.type === qo.MultiPoint)
      return console.log("GoogleMapUtility.parseGeoJsonGeometry", t.type), En.geoJsonMultiPointToGDataMultiPoint(t.coordinates);
    if (t.type === qo.LineString)
      return console.log("GoogleMapUtility.parseGeoJsonGeometry", t.type), En.geoJsonLineStringToGDataLineString(t.coordinates);
    if (t.type === qo.MultiPolygon) {
      console.log("GoogleMapUtility.parseGeoJsonGeometry", t.type);
      const s = new Array();
      return t.coordinates.forEach((n) => {
        const r = En.geoJsonPolygonToGDataPolygon(n);
        s.push(r);
      }), new google.maps.Data.MultiPolygon(s);
    }
  }
  static geoJsonLineStringToGDataLineString(t) {
    const s = t.map((r) => ({
      lat: r[1],
      lng: r[0]
    }));
    return new google.maps.Data.LineString(s);
  }
  static geoJsonPolygonToGDataPolygon(t) {
    const s = t.map((r) => r.map((i) => ({
      lat: i[1],
      lng: i[0]
    })));
    return new google.maps.Data.Polygon(s);
  }
  static geoJsonMultiPointToGDataMultiPoint(t) {
    const s = t.map((r) => ({
      lat: r[1],
      lng: r[0]
    }));
    return new google.maps.Data.MultiPoint(s);
  }
  static parseGeoJsonGeometry(t) {
    if (t.type === qo.Polygon)
      return console.log("GoogleMapUtility.parseGeoJsonGeometry", t.type), En.geoJsonPolygonToGPolygon(t.coordinates);
    if (t.type === qo.MultiPolygon) {
      console.log("GoogleMapUtility.parseGeoJsonGeometry", t.type);
      const s = new Array();
      return t.coordinates.forEach((n) => {
        const r = En.geoJsonPolygonToGPolygon(n);
        s.push(r);
      }), s;
    }
  }
  static geoJsonPolygonToGPolygon(t) {
    const s = t.map((r) => r.map((i) => ({
      lat: i[1],
      lng: i[0]
    })));
    return new google.maps.Polygon({
      paths: s
    });
  }
  parseGeoJsonGeometry(t, s, n, r, i, o = "#0082fc", l = 0.15, d = "#d65302") {
    if (s.type === qo.Polygon) {
      console.log("GoogleMapUtility.parseGeoJsonGeometry", s.type);
      const c = this.geoJsonPolygonToGPolygon(t, s.coordinates, n, r, i, o, l, d);
      return t && c.setMap(t), c;
    } else if (s.type === qo.MultiPolygon) {
      console.log("GoogleMapUtility.parseGeoJsonGeometry", s.type);
      const c = new Array();
      return s.coordinates.forEach((u) => {
        const m = this.geoJsonPolygonToGPolygon(t, u, n, r, i, o, l, d);
        t && m.setMap(t), c.push(m);
      }), c;
    }
  }
  geoJsonPolygonToGPolygon(t, s, n, r, i, o = "#0082fc", l = 0.15, d = "#d65302") {
    const c = s.map((m) => m.map((f) => new google.maps.LatLng(f[1], f[0]))), u = new google.maps.Polygon({
      paths: c,
      strokeColor: o,
      strokeOpacity: 0.8,
      strokeWeight: 1,
      fillColor: o,
      fillOpacity: l
    });
    if (t && n) {
      let m;
      if (r && i)
        m = new google.maps.LatLng(r, i);
      else {
        const v = new google.maps.LatLngBounds();
        u.getPath().forEach((w) => {
          v.extend(w);
        }), m = v.getCenter();
      }
      mk(n, m, t, d).set("position", m);
    }
    return u;
  }
}
const Et = (/* @__PURE__ */ new Date()).getFullYear(), Xu = (/* @__PURE__ */ new Date()).getMonth() + 1, rd = /^\d{1,2}\/\d{1,2}\/\d{4}$/, od = /^\d{4}-\d{2}-\d{2}$/;
function qz() {
  return !0;
}
function rb(e) {
  var t = new Date(e.getFullYear(), 0, 1), s = new Date(e.getFullYear(), 6, 1);
  return Math.max(t.getTimezoneOffset(), s.getTimezoneOffset());
}
function fk(e) {
  return e.getTimezoneOffset() < rb(e);
}
let ob = !1;
function dr(e, t, ...s) {
  for (const n of [e, t, ...s])
    if (n && n != "")
      return n;
}
function ry(e, t, ...s) {
  for (const n of [e, t, ...s])
    if (n && n.length > 0)
      return n;
}
function Ws(e, t, ...s) {
  for (const n of [e, t, ...s])
    if (n && n != 0)
      return n;
}
function Qz(e, t) {
  return Promise.race([
    e,
    new Promise((s, n) => setTimeout(() => n(new Error("Timeout")), t))
  ]);
}
function Kz(e) {
  ob = e;
}
const ib = new sU({
  duration: 5e3,
  ripple: !1,
  position: {
    x: "right",
    y: "top"
  },
  dismissible: !0,
  types: [
    {
      type: "warning",
      backgroundColor: "rgb(255, 193, 7)",
      className: "text-warning-emphasis",
      icon: {
        color: "#664D03",
        tagName: "i",
        className: "fa-light fa-triangle-exclamation"
      }
    }
  ]
});
var fn = /* @__PURE__ */ ((e) => (e.success = "success", e.warning = "warning", e.error = "error", e))(fn || {}), jo = /* @__PURE__ */ ((e) => (e.Center = "center", e.Left = "left", e.Right = "right", e))(jo || {});
class Cs {
  /**
   *
   * @param {string} title Title of alert.
   * @param {string} message Message content of alert.
   * @param {AlertType} type Type of alert. (error(default), success)
   * @param {AlertPosition} position Expected position of alert on page. (Default: Right)
   * @param {boolean} stay Is permanent until user closes. (Default: false)
   */
  constructor(t, s, n = "error", r = "right", i = !1) {
    Xe(this, "title");
    Xe(this, "message");
    Xe(this, "type");
    Xe(this, "position");
    Xe(this, "stay");
    this.title = t, this.message = s, this.type = n, this.position = r, this.stay = i;
  }
}
function Ss(e) {
  return e.stay, e.type == "success" ? wt(e.message) : e.type == "warning" ? Mi(e.message) : e.type == "error" && Se(e.message), !0;
}
function Se(e, t = "right", s = !1) {
  if (lb(e)) {
    if (console.error("showError", e), Yh(e))
      switch (e.status) {
        case 401:
          return;
      }
    Ns(e);
  } else vm(e) && (console.error("showError", new Error(e)), Ns(e));
  t ?? (t = "right");
  let n = 5e3;
  return s && (n = 0), ib.error({
    message: vm(e) ? e : e.message,
    duration: n
  }), !0;
}
function Mi(e, t = "right", s = !1) {
  let n = 5e3;
  return ob && console.warn("showWarning", e), s && (n = 0), ib.open({
    type: "warning",
    message: e,
    duration: n
  }), !0;
}
function wt(e, t = "right", s = !1) {
  let n = 5e3;
  return ob && console.info("showSuccess", e), s && (n = 0), ib.success({
    message: e,
    duration: n
  }), !0;
}
function jn(e, t = "reportError") {
  lb(e) ? (console.error(t, e), bv() && Ns(e)) : vm(e) && (console.error(t, new Error(e)), bv() && Ns(e));
}
function is(e, t) {
  return e == null ? !1 : (BigInt(e) & BigInt(t)) == BigInt(t);
}
function Zz(e, t) {
  return e > t ? 1 : e < t ? -1 : 0;
}
function vm(e) {
  return typeof e == "string";
}
function lb(e) {
  return e instanceof Error;
}
function Jz(e) {
  return new Promise((t) => {
    setTimeout(() => {
      t();
    }, e);
  });
}
function pn(e, t, s, n = 0, r = 0) {
  if (e == 0)
    return -(s + n) / t;
  const i = Math.pow(1 + e, t);
  let o = e * s * (i + n) / (i - 1);
  return r == 1 && (o /= 1 + e), o;
}
function ol(e, t) {
  return e ? ((t ?? /* @__PURE__ */ new Date()).getTime() - e.getTime()) / 864e5 : 0;
}
function cf(e, t) {
  return e ? ((t ?? /* @__PURE__ */ new Date()).getTime() - e.getTime()) / 36e5 : 0;
}
function gk(e, t) {
  return ((t ?? /* @__PURE__ */ new Date()).getTime() - e.getTime()) / 6e4;
}
function $z(e, t) {
  return ((t ?? /* @__PURE__ */ new Date()).getTime() - e.getTime()) / 1e3;
}
function db(e, t) {
  if (!e) return "";
  const s = ol(e, t);
  if (s < 1) {
    const n = cf(e, t);
    if (n < 1) {
      const r = gk(e, t);
      return r < 2 ? "1 Minute" : `${Ve(r, 0)} Minutes`;
    }
    return n < 2 ? "1 Hour" : `${Ve(n, 0)} Hours`;
  }
  return s < 2 ? "1 Day" : `${Ve(s, 0)} Days`;
}
function _z(e, t) {
  const s = new Date(e);
  return s.setDate(s.getDate() + t), s;
}
function eW(e, t, s) {
  return e.slice((t - 1) * s, t * s);
}
function gh(e) {
  return e === 0 && 1 / e === -1 / 0;
}
const Fis = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Alert: Cs,
  AlertPosition: jo,
  AlertType: fn,
  ComputeAmortizationSchedule: tu,
  EasterEgg: oU,
  GoogleMapUtility: En,
  HandleErrors: Dc,
  PMT: pn,
  RateLimit: Na,
  Str: t1,
  addDays: _z,
  coalesceArray: ry,
  coalesceEmpty: dr,
  coalesceZero: Ws,
  cookies: h9,
  createAnnualCashFlowBarData: Ld,
  createAnnualCashFlowBarOptions: Bd,
  createAppreciationOfWealthData: pk,
  createAppreciationOfWealthOptions: hk,
  createBarMarkerTextPlugin: Rd,
  createChartConfig: tr,
  createCoCLineData: lf,
  createCoCOptions: df,
  createIRRAndOnePercentRuleLineData: ck,
  createIRRAndOnePercentRuleLineOptions: uk,
  createIncomeAndExpensesBarData: lk,
  createIncomeAndExpensesBarOptions: dk,
  currentMonth: Xu,
  currentYear: Et,
  dateFormat: rd,
  daysSince: ol,
  debounce: Zj,
  dummy: qz,
  escapeHtml: qj,
  findMyLocation: Td,
  gaugeOptions: Xz,
  getBrowserLocales: dP,
  getDefaultBrowserLocale: cP,
  hasBits: is,
  hoursSince: cf,
  isDstObserved: fk,
  isEmpty: Xj,
  isError: lb,
  isNegativeZero: gh,
  isText: vm,
  isoDateFormat: od,
  kilo: Ma,
  minutesSince: gk,
  paginate: eW,
  promiseTimeout: Qz,
  reportError: jn,
  secondsSince: $z,
  setDebugConsole: Kz,
  showAlert: Ss,
  showError: Se,
  showSuccess: wt,
  showTab: rf,
  showWarning: Mi,
  sortNumbers: Zz,
  startCountDown: PI,
  stdTimezoneOffset: rb,
  storageAvailable: Kp,
  timeSince: db,
  totalHours: Kj,
  totalMillisecond: sf,
  totalMinutes: mm,
  totalSeconds: Zv,
  trackTabs: pU,
  waitTimeout: Jz
}, Symbol.toStringTag, { value: "Module" })), Zd = Symbol("rscConfig"), Vis = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  rscConfigKey: Zd
}, Symbol.toStringTag, { value: "Module" })), vk = "https://expressentry.melissadata.net/web".replace(/\/+$/, "");
class tW extends Error {
  constructor(t, s) {
    super(s), this.field = t, this.name = "RequiredError";
  }
}
const sW = {}, aW = "https://example.com", bg = function(e, t, s) {
  if (s == null)
    throw new tW(t, `Required parameter ${t} was null or undefined when calling ${e}.`);
};
function oy(e, t, s = "") {
  t != null && (typeof t == "object" ? Array.isArray(t) ? t.forEach((n) => oy(e, n, s)) : Object.keys(t).forEach(
    (n) => oy(e, t[n], `${s}${s !== "" ? "." : ""}${n}`)
  ) : e.has(s) ? e.append(s, t) : e.set(s, t));
}
const nW = function(e, ...t) {
  const s = new URLSearchParams(e.search);
  oy(s, t), e.search = s.toString();
}, rW = function(e) {
  return e.pathname + e.search + e.hash;
}, oW = function(e, t, s, n) {
  return (r = t, i = s) => {
    const o = { ...e.options, url: (r.defaults.baseURL ? "" : (n == null ? void 0 : n.basePath) ?? i) + e.url };
    return r.request(o);
  };
}, iW = function(e) {
  return {
    /**
     * The ExpressFreeForm endpoint is provided as a means of retrieving all available U.S. address elements with a Free Form query. ExpressFreeForm returns AddressLine1, City, State, PostalCode, AddressKey, SuiteName, and SuiteCount and the SuiteList and PlusFour lists.
     * @param {ExpressFreeFormFormatEnum} format The return format of the request.
     * @param {string} id The License Key or token
     * @param {string} ff The service uses a word-distance algorithm to find and display matches in an intuitive order.
     * @param {number} [maxrecords] The maximum number of records to return (required). (Default 10, Maximum 100)
     * @param {ExpressFreeFormColsEnum} [cols] Return Address Object result codes for each address in the Extras field.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    expressFreeForm: async (t, s, n, r, i, o = {}) => {
      bg("expressFreeForm", "format", t), bg("expressFreeForm", "id", s), bg("expressFreeForm", "ff", n);
      const l = "/ExpressFreeForm", d = new URL(l, aW);
      let c;
      e && (c = e.baseOptions);
      const u = { method: "GET", ...c, ...o }, m = {}, f = {};
      t !== void 0 && (f.format = t), s !== void 0 && (f.id = s), n !== void 0 && (f.ff = n), r !== void 0 && (f.maxrecords = r), i !== void 0 && (f.cols = i), nW(d, f);
      let v = c && c.headers ? c.headers : {};
      return u.headers = { ...m, ...v, ...o.headers }, {
        url: rW(d),
        options: u
      };
    }
  };
}, lW = function(e) {
  const t = iW(e);
  return {
    /**
     * The ExpressFreeForm endpoint is provided as a means of retrieving all available U.S. address elements with a Free Form query. ExpressFreeForm returns AddressLine1, City, State, PostalCode, AddressKey, SuiteName, and SuiteCount and the SuiteList and PlusFour lists.
     * @param {ExpressFreeFormFormatEnum} format The return format of the request.
     * @param {string} id The License Key or token
     * @param {string} ff The service uses a word-distance algorithm to find and display matches in an intuitive order.
     * @param {number} [maxrecords] The maximum number of records to return (required). (Default 10, Maximum 100)
     * @param {ExpressFreeFormColsEnum} [cols] Return Address Object result codes for each address in the Extras field.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async expressFreeForm(s, n, r, i, o, l) {
      var m, f;
      const d = await t.expressFreeForm(s, n, r, i, o, l), c = (e == null ? void 0 : e.serverIndex) ?? 0, u = (f = (m = sW["ExpressEntryApi.expressFreeForm"]) == null ? void 0 : m[c]) == null ? void 0 : f.url;
      return (v, b) => oW(d, X, vk, e)(v, u || b);
    }
  };
}, dW = function(e, t, s) {
  const n = lW(e);
  return {
    /**
     * The ExpressFreeForm endpoint is provided as a means of retrieving all available U.S. address elements with a Free Form query. ExpressFreeForm returns AddressLine1, City, State, PostalCode, AddressKey, SuiteName, and SuiteCount and the SuiteList and PlusFour lists.
     * @param {ExpressEntryApiExpressFreeFormRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    expressFreeForm(r, i) {
      return n.expressFreeForm(r.format, r.id, r.ff, r.maxrecords, r.cols, i).then((o) => o(s, t));
    }
  };
}, cW = {
  Json: "json",
  Xml: "xml"
}, uW = {
  Results: "results"
};
class pW {
  constructor(t = {}) {
    /**
     * parameter for apiKey security
     * @param name security name
     * @memberof Configuration
     */
    Xe(this, "apiKey");
    /**
     * parameter for basic security
     *
     * @type {string}
     * @memberof Configuration
     */
    Xe(this, "username");
    /**
     * parameter for basic security
     *
     * @type {string}
     * @memberof Configuration
     */
    Xe(this, "password");
    /**
     * parameter for oauth2 security
     * @param name security name
     * @param scopes oauth2 scope
     * @memberof Configuration
     */
    Xe(this, "accessToken");
    /**
     * override base path
     *
     * @type {string}
     * @memberof Configuration
     */
    Xe(this, "basePath");
    /**
     * override server index
     *
     * @type {number}
     * @memberof Configuration
     */
    Xe(this, "serverIndex");
    /**
     * base options for axios calls
     *
     * @type {any}
     * @memberof Configuration
     */
    Xe(this, "baseOptions");
    /**
     * The FormData constructor that will be used to create multipart form data
     * requests. You can inject this here so that execution environments that
     * do not support the FormData class can still run the generated client.
     *
     * @type {new () => FormData}
     */
    Xe(this, "formDataCtor");
    this.apiKey = t.apiKey, this.username = t.username, this.password = t.password, this.accessToken = t.accessToken, this.basePath = t.basePath, this.serverIndex = t.serverIndex, this.baseOptions = t.baseOptions, this.formDataCtor = t.formDataCtor;
  }
  /**
   * Check if the given MIME is a JSON MIME.
   * JSON MIME examples:
   *   application/json
   *   application/json; charset=UTF8
   *   APPLICATION/JSON
   *   application/vnd.company+json
   * @param mime - MIME (Multipurpose Internet Mail Extensions)
   * @return True if the given MIME is JSON, false otherwise.
   */
  isJsonMime(t) {
    const s = new RegExp("^(application/json|[^;/ 	]+/[^;/ 	]+[+]json)[ 	]*(;.*)?$", "i");
    return t !== null && (s.test(t) || t.toLowerCase() === "application/json-patch+json");
  }
}
class yk {
  constructor(t) {
    Xe(this, "_httpClient");
    Xe(this, "_apiConfig");
    Xe(this, "_expressEntry");
    this._apiConfig = new pW({}), t || (t = X.create(), gr(t, { retries: 5, retryDelay: gr.exponentialDelay })), this._httpClient = t;
  }
  get expressEntry() {
    return this._expressEntry || (this._expressEntry = dW(this._apiConfig, vk, this._httpClient)), this._expressEntry;
  }
}
function hW(e) {
  return e !== null && typeof e == "object" && "Address" in e;
}
let Ag;
const mW = {
  get api() {
    return Ag || (Ag = new yk()), Ag;
  }
}, Dis = W;
var ym;
((e) => {
  e.melissaDataApi = mW, e.MelissaDataClient = yk, e.isMelissaObjectResponse = hW, e.ExpressFreeFormColsEnum = uW, e.ExpressFreeFormFormatEnum = cW;
})(ym || (ym = {}));
const il = _r("cache", {
  state: () => ({
    mlsSearch: void 0,
    featuredListings: [],
    featuredListingsBusy: !1,
    marketplaceListings: [],
    marketplaceListingsBusy: !1,
    listingType: "marketplace"
  }),
  getters: {
    mlsSearchCache() {
      return this.mlsSearch == null && Kp() == !0 && localStorage.getItem("mls-search-cache-buster") && (this.mlsSearch = parseInt(localStorage.getItem("mls-search-cache-buster") ?? "0")), this.mlsSearch;
    }
  },
  actions: {
    incrementMlsSearchCache() {
      this.mlsSearch == null ? Kp() == !0 ? this.mlsSearch = parseInt(localStorage.getItem("mls-search-cache-buster") ?? "0") : this.mlsSearch = 0 : this.mlsSearch++, Kp() == !0 && localStorage.setItem("mls-search-cache-buster", `${this.mlsSearch}`);
    },
    setListingType(e) {
      this.listingType = e;
    },
    async loadFeaturedListings() {
      this.featuredListingsBusy = !0;
      try {
        const e = await Td(), t = await W.api.widgetIdx.getFeaturedListings(Ga.Investment, 1, 7, !0, e == null ? void 0 : e.latitude, e == null ? void 0 : e.longitude);
        if (t.data.status != de.Success)
          throw new Le(t);
        this.featuredListings.length = 0, t.data.page && this.featuredListings.push(...t.data.page), this.featuredListingsBusy = !1;
      } catch (e) {
        throw console.error(e), this.featuredListingsBusy = !1, e;
      }
    },
    async loadMarketplace() {
      this.marketplaceListingsBusy = !0;
      try {
        const e = await Td(), t = await W.api.marketplace.activeListings(1, 100, e == null ? void 0 : e.latitude, e == null ? void 0 : e.longitude);
        if (t.data.status != de.Success)
          throw new Le(t);
        this.marketplaceListings.length = 0, t.data.properties && this.marketplaceListings.push(...t.data.properties), this.marketplaceListingsBusy = !1;
      } catch (e) {
        console.error(e), this.marketplaceListingsBusy = !1;
      }
    }
  }
}), a2 = !1;
let bk;
const fW = new Promise((e) => bk = e), gW = new Na(15 * 1e3, "IEAccounts"), n2 = new Na(2 * 1e3, "userSettings"), vW = new Na(2 * 1e3, "subAccount"), yW = new Na(2 * 1e3, "licenseReport"), wg = new Na(2 * 1e3, "myParameters"), bW = new Na(2 * 1e3, "defaultSearch"), r2 = new Na(2 * 1e3, "idxSearch"), Ip = new Na(2 * 1e3, "accountIdxAgent"), AW = new Na(15 * 1e3, "AccountsOptions"), wW = new Na(1 * 1e3, "UpdateAccount"), CW = new Na(2 * 1e3, "FetchBranding"), ct = _r("account", {
  state: () => ({
    account: void 0,
    profileLoading: !1,
    accountLoaded: fW,
    initialized: !1,
    branding: void 0,
    myBranding: void 0,
    brandingLoading: !0,
    searchParameters: void 0,
    idxSearchParameters: void 0,
    incomeAccounts: [],
    expenseAccounts: [],
    nonOperatingExpenseAccounts: [],
    _glAccounts: [],
    agentRoster: [],
    agentRosterTotal: void 0,
    agentRosterPage: 1,
    agentRosterPageSize: 25,
    prospectiveAgentRoster: [],
    prospectiveAgentRosterTotal: void 0,
    prospectiveAgentRosterPage: 1,
    prospectiveAgentRosterPageSize: 25,
    userInfo: void 0,
    isUserLoading: !0,
    subAccounts: [],
    parentAccount: void 0,
    optionsLoading: !0,
    industryDesignations: [],
    myParameters: void 0,
    licenseReport: void 0,
    sponsors: [],
    sponsorsLoading: !1,
    selectedSponsor: void 0,
    profileLoaded: !1,
    profileLoadFailed: !1
  }),
  getters: {
    firstname(e) {
      var t;
      return (t = e.account) == null ? void 0 : t.firstName;
    },
    lastname(e) {
      var t;
      return (t = e.account) == null ? void 0 : t.lastName;
    },
    email(e) {
      var t;
      return (t = e.account) == null ? void 0 : t.email;
    },
    isAdvancedMode() {
      var e;
      return ((e = this.account) == null ? void 0 : e.defaultAnalysisMode) == Hn.Advanced;
    },
    showAfterTax() {
      var e;
      return ((e = this.account) == null ? void 0 : e.defaultTaxMetrics) == lv.After;
    },
    otherIncomeAccounts() {
      return this.incomeAccounts.filter((e) => e.isCustom == !0).sort((e, t) => e.name.localeCompare(t.name));
    },
    otherExpenseAccounts() {
      return this.expenseAccounts.filter((e) => e.isCustom == !0).sort((e, t) => e.name.localeCompare(t.name));
    },
    otherNonOperatingExpenseAccounts() {
      return this.nonOperatingExpenseAccounts.filter((e) => e.isCustom == !0).sort((e, t) => e.name.localeCompare(t.name));
    },
    incomeAccountsSorted() {
      return this.incomeAccounts.sort((e, t) => o2(e, t, (s, n) => Rl(s, n, (r, i) => r.name.localeCompare(i.name))));
    },
    //expenseAccountsSorted(): Array<IncomeExpenseAccount> {
    //    return this.expenseAccounts.sort((a, b) => sortNonOperating(a, b, (c, d) => sortCustom(c, d, (e, f) => e.name.localeCompare(f.name))));
    //},
    operatingExpenseAccountsSorted() {
      return this.expenseAccounts.sort((e, t) => Cg(e, t, (s, n) => Rl(s, n, (r, i) => r.name.localeCompare(i.name))));
    },
    nonOperatingExpenseAccountsSorted() {
      return this.nonOperatingExpenseAccounts.sort((e, t) => SW(e, t, (s, n) => Rl(s, n, (r, i) => r.name.localeCompare(i.name))));
    },
    glAccounts() {
      return this._glAccounts;
    },
    crmProvider() {
      var e;
      switch ((e = this.userInfo) == null ? void 0 : e.crmProvider) {
        case "active-campaign":
          return bt.ActiveCampaign;
        case "lead-simple":
          return bt.LeadSimple;
        case "zoho":
          return bt.Zoho;
      }
    },
    canManageFraCrmSettings() {
      var t, s;
      return ((s = (t = Te().access) == null ? void 0 : t.properties) == null ? void 0 : s.rentalAnalysis) == !0 && this.crmProvider != bt.ActiveCampaign && this.crmProvider != null;
    }
  },
  actions: {
    async fetchAccountOptions() {
      const e = Te();
      if (await e.aclLoaded, !e.access.isAuthenticated) {
        console.warn("User not authenticated!", e.access);
        return;
      }
      await AW.limit(async () => {
        try {
          this.optionsLoading = !0;
          const t = await W.api.account.getOptions();
          if (t.data.status != de.Success)
            throw new Le(t);
          this.industryDesignations.length = 0, this.industryDesignations.push(...t.data.industryDesignations);
        } catch (t) {
          throw console.error("fetchAccountOptions", t), t;
        }
      }).finally(() => {
        this.optionsLoading = !1;
      });
    },
    async requestIndustryDesignation(e) {
      const t = Te();
      if (await t.aclLoaded, !t.access.isAuthenticated) {
        console.warn("User not authenticated!", t.access);
        return;
      }
      await wW.limit(async () => {
        try {
          this.optionsLoading = !0;
          const s = await W.api.account.requestIndustryDesignation(e);
          if (s.data.status != de.Success)
            throw new Le(s);
        } catch (s) {
          throw console.error("requestIndustryDesignation", s), s;
        }
      }).finally(() => {
        this.optionsLoading = !1;
      });
    },
    async fetchUserSettings() {
      const e = Te();
      if (await e.aclLoaded, !e.access.isAuthenticated) {
        console.warn("User not authenticated!", e.access);
        return;
      }
      await n2.limit(async () => {
        try {
          this.isUserLoading = !0;
          const t = await W.api.user.getSettings();
          if (t.data.status != de.Success)
            throw new Le(t);
          this.userInfo = t.data.settings;
        } catch (t) {
          throw console.error("fetchUserSettings", t), t;
        }
      }).finally(() => {
        this.isUserLoading = !1;
      });
    },
    async updateUserSettings() {
      await n2.limit(async () => {
        try {
          this.isUserLoading = !0;
          const e = await W.api.user.updateSettings(this.userInfo);
          if (e.data.status != de.Success)
            throw new Le(e);
        } catch (e) {
          throw console.log("updateUserSettings", e), e;
        }
      }).finally(() => {
        this.isUserLoading = !1;
      });
    },
    async fetchIncomeExpenseAccounts() {
      try {
        const e = Te();
        if (await e.aclLoaded, !e.access.isAuthenticated) {
          console.warn("User not authenticated!");
          return;
        }
        await gW.limit(async () => {
          this.incomeAccounts.length = 0, this.expenseAccounts.length = 0;
          const t = await W.api.incomeExpenseAccounts.getAccounts();
          if (t.data.status != de.Success)
            throw new Le(t);
          this.incomeAccounts.push(...t.data.income.sort((s, n) => o2(s, n, (r, i) => Rl(r, i, (o, l) => o.name.localeCompare(l.name))))), this.expenseAccounts.push(...t.data.expense.filter((s) => s.nonOperating != !0).sort((s, n) => Cg(s, n, (r, i) => Rl(r, i, (o, l) => o.name.localeCompare(l.name))))), this.nonOperatingExpenseAccounts.push(...t.data.expense.filter((s) => s.nonOperating == !0).sort((s, n) => Cg(s, n, (r, i) => Rl(r, i, (o, l) => o.name.localeCompare(l.name)))));
        });
      } catch (e) {
        console.error("fetchIncomeExpenseAccounts", e);
      }
    },
    async fetchGlAccounts() {
      try {
        const e = await W.api.incomeExpenseAccounts.getGlAccounts();
        if (e.data.status != de.Success)
          throw new Error(e.data.message);
        this._glAccounts.length = 0, this._glAccounts.push(...e.data.accounts);
      } catch (e) {
        throw console.error("fetchGlAccounts", e), e;
      }
    },
    async addIncomeExpenseAccount(e, t) {
      try {
        const s = {
          name: e,
          type: t
        }, n = await W.api.incomeExpenseAccounts.addAccount(s);
        if (n.data.status != de.Success)
          throw new Le(n);
        return t == Ra.Income ? this.incomeAccounts.push(n.data.account) : t == Ra.Expense ? this.expenseAccounts.push(n.data.account) : t == Ra.NonOperatingExpense && this.nonOperatingExpenseAccounts.push(n.data.account), n.data.account.id;
      } catch (s) {
        throw console.error("addIncomeExpenseAccount", s), s;
      }
    },
    async editIncomeExpenseAccount(e, t) {
      try {
        const s = {
          name: t
        }, n = await W.api.incomeExpenseAccounts.editAccount(e, s);
        if (n.data.status != de.Success)
          throw new Le(n);
        let r = this.incomeAccounts.find((i) => i.id == e);
        r ?? (r = this.expenseAccounts.find((i) => i.id == e)), r ?? (r = this.nonOperatingExpenseAccounts.find((i) => i.id == e)), r && (r.name = t);
      } catch (s) {
        throw console.error("editIncomeExpenseAccount", s), s;
      }
    },
    async deleteIncomeExpenseAccount(e) {
      try {
        const t = await W.api.incomeExpenseAccounts.deleteAccount(e);
        if (t.data.status != de.Success)
          throw new Le(t);
        this.incomeAccounts = this.incomeAccounts.filter((s) => s.id != e), this.expenseAccounts = this.expenseAccounts.filter((s) => s.id != e), this.nonOperatingExpenseAccounts = this.nonOperatingExpenseAccounts.filter((s) => s.id != e);
      } catch (t) {
        throw console.error("deleteIncomeExpenseAccount", t), t;
      }
    },
    async setConventional(e, t, s) {
      try {
        let n;
        if (s ? n = await W.api.incomeExpenseAccounts.enableConventional(e, t) : n = await W.api.incomeExpenseAccounts.disableConventional(e, t), n.data.status != de.Success)
          throw new Le(n);
      } catch (n) {
        throw console.error("setConventional", n), n;
      }
    },
    async setShortTerm(e, t, s) {
      try {
        let n;
        if (s ? n = await W.api.incomeExpenseAccounts.enableShortTerm(e, t) : n = await W.api.incomeExpenseAccounts.disableShortTerm(e, t), n.data.status != de.Success)
          throw new Le(n);
      } catch (n) {
        throw console.error("setShortTerm", n), n;
      }
    },
    async syncGlAccounts() {
      try {
        const e = await W.api.incomeExpenseAccounts.syncGlAccounts();
        if (e.data.status != de.Success)
          throw new Le(e);
      } catch (e) {
        throw console.error("syncGlAccounts", e), e;
      }
    },
    async fetchBranding() {
      try {
        return this.brandingLoading = !0, await CW.limit(async () => {
          const e = await W.api.accountBranding.getBranding();
          if (e.data.status != de.Success)
            throw new Le(e);
          this.branding = e.data.branding;
        }), !0;
      } catch (e) {
        throw jn(e, "fetchBranding"), e;
      } finally {
        this.brandingLoading = !1;
      }
      return !1;
    },
    async fetchInviteBranding(e) {
      try {
        const t = await W.api.accountBranding.getInviteBranding(e);
        if (t.data.status != de.Success)
          throw new Le(t);
        return t.data.branding;
      } catch (t) {
        throw console.error("getInviteBranding", t), t;
      }
    },
    async fetchMyBranding() {
      try {
        this.brandingLoading = !0;
        const e = await W.api.accountBranding.getMyBranding();
        if (e.data.status != de.Success)
          throw new Le(e);
        this.myBranding = e.data.branding ?? {};
      } catch (e) {
        throw console.error("fetchBranding", e), e;
      } finally {
        this.brandingLoading = !1;
      }
    },
    async updateBranding() {
      try {
        this.brandingLoading = !0;
        const e = await W.api.accountBranding.updateBranding(this.myBranding);
        if (e.data.status != de.Success)
          throw new Error(e.data.message);
        this.myBranding = e.data.branding;
      } catch (e) {
        throw console.error("updateBranding", e), e;
      } finally {
        this.brandingLoading = !1;
      }
    },
    async updateCompanyLogo(e, t, s, n, r, i) {
      try {
        this.brandingLoading = !0;
        const o = await W.api.accountBranding.updateBrandingCompanyPhoto(e, t, s, n, r, i);
        if (o.data.status != de.Success)
          throw new Error(o.data.message);
        this.myBranding = o.data.branding, await this.fetchBranding();
      } catch (o) {
        throw console.error("updateCompanyLogo", o), o;
      } finally {
        this.brandingLoading = !1;
      }
    },
    async updateHeadshotPhoto(e, t, s, n, r) {
      try {
        this.brandingLoading = !0;
        const i = await W.api.accountBranding.updateBrandingHeadshotPhoto(e, t, s, n, r);
        if (i.data.status != de.Success)
          throw new Error(i.data.message);
        this.myBranding = i.data.branding;
      } catch (i) {
        throw console.error("updateHeadshotPhoto", i), i;
      } finally {
        this.brandingLoading = !1;
      }
    },
    async fetchMyParameters() {
      await wg.limit(async () => {
        try {
          const e = await W.api.userParameters.getMyDefaults();
          if (e.data.status != de.Success)
            throw new Le(e);
          this.myParameters = e.data.parameters;
        } catch (e) {
          throw console.error("fetchMyDefaultParameters", e), e;
        }
      });
    },
    async updateMyFinancialParameters() {
      await wg.limit(async () => {
        try {
          const e = i2(this.myParameters), t = await W.api.userParameters.updateFinancialParameters(e);
          if (t.data.status != de.Success)
            throw new Le(t);
        } catch (e) {
          throw console.error("updateMyFinancialParameters", e), e;
        }
      });
    },
    async updateMyFilterParameters() {
      await wg.limit(async () => {
        try {
          const e = PW(this.myParameters), t = await W.api.userParameters.updateFilterParameters(e);
          if (t.data.status != de.Success)
            throw new Le(t);
        } catch (e) {
          throw console.error("updateMyFilterParameters", e), e;
        }
      });
    },
    //#region Account Idx Agents
    /**
     * Add an agent to the agent roster and update related state.
     */
    async addAgentToRoster(e) {
      await Ip.limit(async () => {
        const t = await W.api.accountIdxAgents.addAgent(e);
        if (t.data.status != de.Success)
          throw new Le(t);
        const s = this.prospectiveAgentRoster.find((n) => n.id === e);
        s && (this.agentRoster.push(s), this.agentRosterTotal = (this.agentRosterTotal ?? 0) + 1, this.prospectiveAgentRoster = this.prospectiveAgentRoster.filter((n) => n.id !== e));
      });
    },
    /**
     * Remove an agent from the agent roster and update related state.
     */
    async removeAgentFromRoster(e) {
      await Ip.limit(async () => {
        const t = await W.api.accountIdxAgents.removeAgent(e);
        if (t.data.status != de.Success)
          throw new Le(t);
        const s = this.agentRoster.find((n) => n.id === e);
        s && (this.prospectiveAgentRoster.push(s), this.agentRoster = this.agentRoster.filter((n) => n.id !== e), this.agentRosterTotal = (this.agentRosterTotal ?? 1) - 1);
      });
    },
    //#region Account Idx Agents
    async fetchAgentRoster(e = void 0, t = void 0) {
      await Ip.limit(async () => {
        this.agentRosterPage = e ?? this.agentRosterPage, this.agentRosterPageSize = t ?? this.agentRosterPageSize;
        const s = await W.api.accountIdxAgents.getAgents(this.agentRosterPage, this.agentRosterPageSize);
        if (s.data.status != de.Success)
          throw new Le(s);
        this.agentRoster.length = 0, s.data.page && this.agentRoster.push(...s.data.page), this.agentRosterTotal = s.data.total;
      });
    },
    async fetchProspectiveAgentRoster(e = void 0, t = void 0) {
      await Ip.limit(async () => {
        this.prospectiveAgentRosterPage = e ?? this.prospectiveAgentRosterPage, this.prospectiveAgentRosterPageSize = t ?? this.prospectiveAgentRosterPageSize;
        const s = await W.api.accountIdxAgents.getAccounts(this.prospectiveAgentRosterPage, this.prospectiveAgentRosterPageSize);
        if (s.data.status != de.Success)
          throw new Le(s);
        this.prospectiveAgentRoster.length = 0, s.data.page && this.prospectiveAgentRoster.push(...s.data.page), this.prospectiveAgentRosterTotal = s.data.total;
      });
    },
    //#endregion
    //#region Search Parameters
    async fetchDefaultSearchParameters() {
      await bW.limit(async () => {
        try {
          const e = await W.api.searchMls.getSearchParameters();
          if (e.data.status != de.Success)
            throw new Le(e);
          this.searchParameters = e.data.parameters;
        } catch (e) {
          throw console.error("fetchDefaultSearchParameters", e), e;
        }
      });
    },
    async fetchIdxSearchParameters() {
      await r2.limit(async () => {
        try {
          const e = await W.api.accountIDXParameters.getSearchParameters();
          if (e.data.status != de.Success)
            throw new Le(e);
          this.idxSearchParameters = e.data.parameters;
        } catch (e) {
          throw console.error("fetchIdxSearchParameters", e), e;
        }
      });
    },
    async updateIdxSearchParameters() {
      await r2.limit(async () => {
        const e = i2(this.idxSearchParameters), t = await W.api.accountIDXParameters.updateFinancialParameters(e);
        if (t.data.status != de.Success)
          throw new Le(t);
      });
    },
    //#endregion
    async fetchLicenseReport() {
      await yW.limit(async () => {
        const e = await W.api.licensing.getReport();
        if (e.data.status != de.Success)
          throw new Le(e);
        this.licenseReport = {
          ...e.data.report
        };
      });
    },
    //#region Guest users
    async acceptGuestInvite(e) {
      try {
        const t = await W.api.accountClientsInvite.acceptClientInvite(e);
        if (t.data.status != de.Success)
          throw new Le(t);
        return t.data.redirect ? (document.location.href = t.data.redirect, !0) : !1;
      } catch (t) {
        throw console.error("acceptGuestInvite", t), t;
      }
    },
    async declineGuestInvite(e) {
      try {
        const t = await W.api.accountClientsInvite.declineClientInvite(e);
        if (t.data.status != de.Success)
          throw new Le(t);
      } catch (t) {
        throw console.error("declineGuestInvite", t), t;
      }
    },
    //#endregion
    //#region Sub Accounts
    async fetchSubAccounts() {
      await vW.limit(async () => {
        try {
          const e = await W.api.subAccounts.getSubAccounts();
          if (e.data.status != de.Success)
            throw new Le(e);
          this.subAccounts.length = 0, e.data.page && this.subAccounts.push(...e.data.page), this.parentAccount = e.data.parentAccount;
        } catch (e) {
          throw console.error("fetchSubAccounts", e), e;
        }
      });
    },
    async addSubAccount(e) {
      try {
        const t = await W.api.subAccounts.addAccount(e);
        if (t.data.status != de.Success)
          throw new Le(t);
        await this.fetchSubAccounts(), await this.fetchAgentRoster(), await this.fetchProspectiveAgentRoster();
      } catch (t) {
        throw console.error("addSubAccount", t), t;
      }
    },
    async updateAccount(e) {
      const t = {
        idxDataAccess: e.idxDataAccess == !0,
        roleName: e.roleName ?? "User",
        license: e.license ?? _p.None
      }, s = await W.api.subAccounts.updateAccount(e.id, t);
      if (s.data.status != de.Success)
        throw new Le(s);
      await this.fetchSubAccounts();
    },
    async removeSubAccount(e) {
      const t = e.type == "Invite" ? !0 : void 0, s = await W.api.subAccounts.removeAccount(e.id, t);
      if (s.data.status != de.Success)
        throw new Le(s);
      await this.fetchSubAccounts();
    },
    async removeMeAsSubAccount() {
      const e = await W.api.subAccounts.removeMe();
      if (e.data.status != de.Success)
        throw new Le(e);
      await this.fetchSubAccounts();
    },
    async sendSubAccountInvite(e) {
      const t = e.type == "Invite" ? void 0 : !1, s = await W.api.subAccounts.invite(e.id, t);
      if (s.data.status != de.Success)
        throw new Le(s);
    },
    async featureAccess(e, t) {
      try {
        let s;
        if (e ? s = await W.api.folio.allowToFeature(t.id) : s = await W.api.folio.denyToFeature(t.id), s.data.status != de.Success)
          throw new Le(s);
      } catch (s) {
        throw console.error("featureAccess", s), s;
      }
    },
    async acceptInvite(e) {
      try {
        const t = await W.api.subAccounts.acceptInvite(e);
        if (t.data.status != de.Success)
          throw new Le(t);
        return t.data.redirect ? (document.location.href = t.data.redirect, !0) : !1;
      } catch (t) {
        throw console.error("getInviteBranding", t), t;
      }
    },
    async declineInvite(e) {
      try {
        const t = await W.api.subAccounts.declineInvite(e);
        if (t.data.status != de.Success)
          throw new Le(t);
      } catch (t) {
        throw console.error("getInviteBranding", t), t;
      }
    },
    /**
     * Fetch the list of MLS sponsors for the account.
     */
    async fetchSponsors() {
      this.sponsorsLoading = !0;
      try {
        const e = await W.api.accountMLS.listSponsors();
        if (e.data.status != de.Success)
          throw new Le(e);
        return this.sponsors.length = 0, e.data.page && this.sponsors.push(...e.data.page), !0;
      } catch (e) {
        throw jn(e, "fetchSponsors"), this.sponsors.length = 0, e;
      } finally {
        this.sponsorsLoading = !1;
      }
      return !1;
    },
    async loadProfile() {
      try {
        if ((await Promise.allSettled([
          this.getAccountInfo(),
          this.fetchSponsors(),
          this.fetchBranding()
        ]))[0].status != "fulfilled") {
          this.profileLoadFailed = !0;
          return;
        }
        this.profileLoaded = !0;
      } catch (e) {
        jn(e, "loadProfile"), this.profileLoadFailed = !0;
      } finally {
      }
    },
    async getAccountInfo() {
      var e, t, s, n;
      this.profileLoading = !0;
      try {
        const r = Te();
        if (((e = r.access) == null ? void 0 : e.isAnonymous) != !0 && ((t = r.access) == null ? void 0 : t.isShare) != !0 && ((s = r.access) == null ? void 0 : s.isIdx) != !0 && ((n = r.access) == null ? void 0 : n.isAnalysis) != !0) {
          const i = await W.api.account.info();
          if (this.account = i.data.info, this.account && (y7({
            id: this.account.id,
            fullName: `${this.account.firstName} ${this.account.lastName}`,
            email: this.account.email
          }), window.clarity)) {
            let o = document.location.pathname;
            De.URL.Property.PropertyPageRgx.test(window.location.pathname) || De.URL.Listing.ListingPageRgx.test(window.location.pathname) || De.URL.PortfolioInsights.PropertyPageRgx.test(window.location.pathname) ? o = "property-view-page" : De.URL.PortfolioInsights.ClientPortfolioPageRgx.test(window.location.pathname) ? o = "client-portfolio-page" : De.URL.PortfolioInsights.ClientPortfoliosPageRgx.test(window.location.pathname) && (o = "client-portfolios-page"), await window.clarity("identify", this.account.email, void 0, o, `${this.account.firstName} ${this.account.lastName}`);
          }
        } else
          this.account = {
            defaultAnalysisMode: Hn.Advanced,
            defaultTaxMetrics: lv.Before
          };
        return !0;
      } catch (r) {
        jn(r, "getAccountInfo"), this.account = {
          defaultAnalysisMode: Hn.Advanced
        };
      } finally {
        this.profileLoading = !1, bk(!0);
      }
      return !1;
    },
    async initializeAccount(e, t) {
      return this.initialized !== !0 && (await this.getAccountInfo().then(async () => {
        await Te().updateAcl(t, e);
      }), W.api.addTokenRefreshedEventListener((s) => {
        const n = Te();
        s != null && s.expires && n.access && (n.access.expires = s == null ? void 0 : s.expires);
      }), this.initialized = !0), this.account;
    }
    //#endregion
  }
});
function o2(e, t, s) {
  return e.nameUrl != "other-income" && t.nameUrl != "other-income" ? s ? s(e, t) : 0 : e.nameUrl == "other-income" ? 1 : -1;
}
function Cg(e, t, s) {
  return e.nameUrl != "other-expense" && t.nameUrl != "other-expense" ? s ? s(e, t) : 0 : e.nameUrl == "other-expense" ? 1 : -1;
}
function SW(e, t, s) {
  return e.nameUrl != "other-non-operating-expense" && t.nameUrl != "other-non-operating-expense" ? s ? s(e, t) : 0 : e.nameUrl == "other-non-operating-expense" ? 1 : -1;
}
function Rl(e, t, s) {
  return e.isCustom == !1 && t.isCustom == !1 ? s ? s(e, t) : 0 : e.isCustom ? 1 : -1;
}
function Nis(e, t, s) {
  return e.nonOperating != !0 && t.nonOperating != !0 ? s ? s(e, t) : 0 : e.isCustom ? 1 : -1;
}
function i2(e) {
  return {
    // Financial Model Assumptions
    amortizationPeriod: e.amortizationPeriod,
    annualExpenseGrowth: e.annualExpenseGrowth,
    annualRentalGrowth: e.annualRentalGrowth,
    capitalExpenditures: e.capitalExpenditures,
    costOfSale: e.costOfSale,
    downPayment: e.downpayment,
    interestOnlyLoan: e.interestOnlyLoan,
    interestOnlyTerm: e.interestOnlyTerm,
    interestRate: e.interestRate,
    leaseCommission: e.leaseCommission,
    leaseRenewalFee: e.leaseRenewalFee,
    loanFees: e.loanFees,
    maintenance: e.maintenance,
    managementFee: e.managementFee,
    propertyAppreciation: e.propertyAppreciation,
    stabilizationReserve: e.stabilizationReserve,
    timeBetweenTenants: e.timeBetweenTenants,
    titleCharges: e.titleCharges,
    // Blue Chip House Performance
    minCapRate: e.minCapRate,
    minCoC: e.minCoC,
    minCoCAfterTax: e.minCoCAfterTax,
    minIRR: e.minIRR,
    minIRRAfterTax: e.minIRRAfterTax,
    hold: e.hold,
    blueChipFilters: e.blueChipFilters,
    averageLengthOfStay: e.averageLengthOfStay,
    cleaningExpenses: e.cleaningExpenses,
    consumableExpenses: e.consumableExpenses,
    furnishingExpenses: e.furnishingExpenses,
    otherExpense: e.otherExpense,
    percentageLongTermFields: e.percentageLongTermFields,
    platformServiceFees: e.platformServiceFees,
    utilityExpenses: e.utilityExpenses,
    otherExpenses: e.otherExpenses,
    percentageShortTermFields: e.percentageShortTermFields,
    strAnnualExpenseGrowth: e.strAnnualExpenseGrowth,
    strAnnualRentalGrowth: e.strAnnualRentalGrowth,
    strCapitalExpenditures: e.strCapitalExpenditures,
    strCleaningExpenses: e.strCleaningExpenses,
    strConsumableExpenses: e.strConsumableExpenses,
    strDaysAvailablePerYear: e.strDaysAvailablePerYear,
    strDaysOccupiedPerYear: e.strDaysOccupiedPerYear,
    strFurnishingExpenses: e.strFurnishingExpenses,
    strLeaseCommission: e.strLeaseCommission,
    strLeaseRenewalFee: e.strLeaseRenewalFee,
    strMaintenance: e.strMaintenance,
    strManagementFee: e.strManagementFee,
    strOtherExpense: e.strOtherExpense,
    strPlatformServiceFees: e.strPlatformServiceFees,
    strPropertyAppreciation: e.strPropertyAppreciation,
    strUtilityExpenses: e.strUtilityExpenses,
    strWorkingCapitalReserve: e.strWorkingCapitalReserve,
    padSplitAnnualExpenseGrowth: e.padSplitAnnualExpenseGrowth,
    padSplitAnnualRentalGrowth: e.padSplitAnnualRentalGrowth,
    padSplitCapitalExpenditures: e.padSplitCapitalExpenditures,
    padSplitCleaningExpenses: e.padSplitCleaningExpenses,
    padSplitConsumableExpenses: e.padSplitConsumableExpenses,
    padSplitFurnishingExpenses: e.padSplitFurnishingExpenses,
    padSplitLeaseCommission: e.padSplitLeaseCommission,
    padSplitLeaseRenewalFee: e.padSplitLeaseRenewalFee,
    padSplitMaintenance: e.padSplitMaintenance,
    padSplitManagementFee: e.padSplitManagementFee,
    padSplitOtherExpense: e.padSplitOtherExpense,
    padSplitPlatformServiceFees: e.padSplitPlatformServiceFees,
    padSplitPropertyAppreciation: e.padSplitPropertyAppreciation,
    padSplitUtilityExpenses: e.padSplitUtilityExpenses,
    padSplitWorkingCapitalReserve: e.padSplitWorkingCapitalReserve,
    padSplitAnnualVacancyRate: e.padSplitAnnualVacancyRate,
    padSplitAverageLengthOfStay: e.padSplitAverageLengthOfStay,
    padSplitBookingFeeDays: e.padSplitBookingFeeDays,
    percentagePadSplitFields: e.percentagePadSplitFields
  };
}
function PW(e) {
  return {
    bathroomsMin: e.minBathrooms,
    bedroomsMin: e.minBedrooms,
    dor: e.daysOnRescover,
    lotMax: e.maxLotSize,
    lotMin: e.minLotSize,
    priceMax: e.maxPrice,
    priceMin: e.minPrice,
    sqftMax: e.maxSqft,
    sqftMin: e.minSqft,
    storiesMax: e.maxStories,
    yearMax: e.maxYearbuilt,
    yearMin: e.minYearbuilt
  };
}
function jis(e, t) {
  var s, n, r;
  t.amortizationPeriod = e.amortizationPeriod, t.annualExpenseGrowth = e.annualExpenseGrowth, t.annualRentalGrowth = e.annualRentalGrowth, t.capitalExpenditures = e.capitalExpenditures, t.costOfSale = e.costOfSale, t.downpayment = e.downpayment, t.interestOnlyLoan = e.interestOnlyLoan, t.interestOnlyTerm = e.interestOnlyTerm, t.interestRate = e.interestRate, t.leaseCommission = e.leaseCommission, t.leaseRenewalFee = e.leaseRenewalFee, t.loanFees = e.loanFees, t.maintenance = e.maintenance, t.managementFee = e.managementFee, t.propertyAppreciation = e.propertyAppreciation, t.stabilizationReserve = e.stabilizationReserve, t.timeBetweenTenants = e.timeBetweenTenants, t.titleCharges = e.titleCharges, t.minCapRate = e.minCapRate, t.minCoC = e.minCoC, t.minIRR = e.minIRR, t.hold = e.hold, t.averageLengthOfStay = e.averageLengthOfStay, t.cleaningExpenses = e.cleaningExpenses, t.consumableExpenses = e.consumableExpenses, t.furnishingExpenses = e.furnishingExpenses, t.otherExpense = e.otherExpense, t.percentageLongTermFields = e.percentageLongTermFields, t.platformServiceFees = e.platformServiceFees, t.otherExpenses = {
    longTerm: [],
    shortTerm: [],
    padSplit: []
  }, (s = e.otherExpenses) != null && s.longTerm && t.otherExpenses.longTerm.push(...e.otherExpenses.longTerm.map((i) => ({ ...i }))), (n = e.otherExpenses) != null && n.shortTerm && t.otherExpenses.shortTerm.push(...e.otherExpenses.shortTerm.map((i) => ({ ...i }))), (r = e.otherExpenses) != null && r.padSplit && t.otherExpenses.padSplit.push(...e.otherExpenses.padSplit.map((i) => ({ ...i }))), t.percentageShortTermFields = e.percentageShortTermFields, t.strAnnualExpenseGrowth = e.strAnnualExpenseGrowth, t.strAnnualRentalGrowth = e.strAnnualRentalGrowth, t.strCapitalExpenditures = e.strCapitalExpenditures, t.strCleaningExpenses = e.strCleaningExpenses, t.strConsumableExpenses = e.strConsumableExpenses, t.strDaysAvailablePerYear = e.strDaysAvailablePerYear, t.strDaysOccupiedPerYear = e.strDaysOccupiedPerYear, t.strFurnishingExpenses = e.strFurnishingExpenses, t.strLeaseCommission = e.strLeaseCommission, t.strLeaseRenewalFee = e.strLeaseRenewalFee, t.strMaintenance = e.strMaintenance, t.strManagementFee = e.strManagementFee, t.strOtherExpense = e.strOtherExpense, t.strPlatformServiceFees = e.strPlatformServiceFees, t.strPropertyAppreciation = e.strPropertyAppreciation, t.strUtilityExpenses = e.strUtilityExpenses, t.strWorkingCapitalReserve = e.strWorkingCapitalReserve, t.utilityExpenses = e.utilityExpenses, t.percentagePadSplitFields = e.percentagePadSplitFields, t.padSplitAnnualExpenseGrowth = e.padSplitAnnualExpenseGrowth, t.padSplitAnnualRentalGrowth = e.padSplitAnnualRentalGrowth, t.padSplitCapitalExpenditures = e.padSplitCapitalExpenditures, t.padSplitCleaningExpenses = e.padSplitCleaningExpenses, t.padSplitConsumableExpenses = e.padSplitConsumableExpenses, t.padSplitFurnishingExpenses = e.padSplitFurnishingExpenses, t.padSplitLeaseCommission = e.padSplitLeaseCommission, t.padSplitLeaseRenewalFee = e.padSplitLeaseRenewalFee, t.padSplitMaintenance = e.padSplitMaintenance, t.padSplitManagementFee = e.padSplitManagementFee, t.padSplitOtherExpense = e.padSplitOtherExpense, t.padSplitPlatformServiceFees = e.padSplitPlatformServiceFees, t.padSplitPropertyAppreciation = e.padSplitPropertyAppreciation, t.padSplitUtilityExpenses = e.padSplitUtilityExpenses, t.padSplitWorkingCapitalReserve = e.padSplitWorkingCapitalReserve, t.padSplitAnnualVacancyRate = e.padSplitAnnualVacancyRate, t.padSplitAverageLengthOfStay = e.padSplitAverageLengthOfStay, t.padSplitBookingFeeDays = e.padSplitBookingFeeDays;
}
let Ak;
const kW = new Promise((e) => Ak = e), Te = _r("auth", {
  state: () => ({
    acl: void 0,
    access: void 0,
    aclLoaded: Ki(kW),
    lastIncludeCounties: void 0,
    lastMls: void 0,
    previewMode: !1
  }),
  getters: {
    enterprise(e) {
      var t, s, n, r, i;
      return ((s = (t = e.access) == null ? void 0 : t.leads) == null ? void 0 : s.leads) == !0 || ((n = e.access) == null ? void 0 : n.portfolioInsights) == !0 || ((i = (r = e.access) == null ? void 0 : r.freeRentalAnalysis) == null ? void 0 : i.access) == !0;
    },
    hasMlsEntitlements() {
      var e, t;
      return ((t = (e = this.access) == null ? void 0 : e.mls) == null ? void 0 : t.hasEntitlements) == !0;
    },
    hasBrandedPortalFeature(e) {
      var t;
      return is((t = e.access) == null ? void 0 : t.acl, Oa.BrandedPortal);
    },
    hasPpeFeature(e) {
      var t;
      return is((t = e.access) == null ? void 0 : t.acl, Oa.FreeRentalAnalysis);
    },
    hasPortfolioFinderFeature(e) {
      var t;
      return is((t = e.access) == null ? void 0 : t.acl, Oa.Leads);
    },
    hasPortfolioInsightsFeature(e) {
      var t;
      return is((t = e.access) == null ? void 0 : t.acl, Oa.PortfolioInsights);
    },
    hasMarketDataInsightsFeature(e) {
      var t;
      return is((t = e.access) == null ? void 0 : t.acl, Oa.MarketDataInsights);
    },
    hasInvestmentGatewayFeature() {
      var e;
      return is((e = this.access) == null ? void 0 : e.acl, Oa.IDX);
    },
    hasSearchMlsFeature() {
      var e;
      return is((e = this.access) == null ? void 0 : e.acl, Oa.SearchMls);
    },
    hasFlipCalculatorFeature() {
      var e;
      return is((e = this.access) == null ? void 0 : e.acl, Oa.FlipCalculator);
    },
    hasOtherAnalysisStylesFeature() {
      var e;
      return is((e = this.access) == null ? void 0 : e.acl, Oa.OtherAnalysisStyles);
    },
    hasAdvancedCalculatorFeature() {
      var e;
      return is((e = this.access) == null ? void 0 : e.acl, Oa.AdvancedCalculator);
    },
    hasSearchPreForeclosureFeature() {
      var e;
      return is((e = this.access) == null ? void 0 : e.acl, Oa.SearchPreForeclosure);
    },
    hasFeaturePropertiesFeature() {
      var e;
      return is((e = this.access) == null ? void 0 : e.acl, Oa.FeatureProperties);
    },
    hasFavoritePropertyFeature() {
      var e;
      return is((e = this.access) == null ? void 0 : e.acl, Oa.FavoriteProperty);
    },
    hasMarketplaceListingFeature() {
      var e;
      return is((e = this.access) == null ? void 0 : e.acl, Oa.AddMarketplaceListing);
    },
    hasExistingInvestmentFeature() {
      var e;
      return is((e = this.access) == null ? void 0 : e.acl, Oa.ExistingInvestment);
    },
    hasRentVsSellFeature() {
      var e;
      return is((e = this.access) == null ? void 0 : e.acl, Oa.RentVsSell);
    },
    hasFinancialAnalysisFeature() {
      var e;
      return is((e = this.access) == null ? void 0 : e.acl, Oa.FinancialAnalysis);
    },
    canSaveParameters() {
      var e, t;
      return (((e = this.access) == null ? void 0 : e.isAuthenticated) == !0 || ((t = this.access) == null ? void 0 : t.isShare) == !0) && window.isIdx != !0;
    },
    hasAdvanced() {
      var e, t;
      return ((t = (e = this.access) == null ? void 0 : e.calculator) == null ? void 0 : t.advanced) == !0;
    },
    isAnonymous() {
      var e;
      return ((e = this.access) == null ? void 0 : e.isAnonymous) == !0;
    },
    isAdmin() {
      var e;
      return ((e = this.access) == null ? void 0 : e.role) == Of.Admin;
    },
    isUser() {
      var e;
      return ((e = this.access) == null ? void 0 : e.role) == Of.User;
    },
    isClient() {
      var e;
      return ((e = this.access) == null ? void 0 : e.role) == Of.Client;
    },
    isShare() {
      var e;
      return ((e = this.access) == null ? void 0 : e.isShare) == !0;
    },
    isAnalysisRequest() {
      var e;
      return ((e = this.access) == null ? void 0 : e.isAnalysis) == !0;
    },
    isIdx() {
      var e;
      return ((e = this.access) == null ? void 0 : e.isIdx) == !0;
    },
    canManageIEAccounts() {
      var e, t;
      return is((e = this.access) == null ? void 0 : e.acl, Oa.ManageIEAccounts) && !((t = this.access) != null && t.isAnonymous);
    },
    canOtherAnalysisStyles() {
      var e, t;
      return is((e = this.access) == null ? void 0 : e.acl, Oa.OtherAnalysisStyles) && !((t = this.access) != null && t.isAnonymous);
    },
    /**
     * Use hasRentVsSellFeature
     * @deprecated
     */
    canRentVsSell() {
      var e;
      return is((e = this.access) == null ? void 0 : e.acl, Oa.RentVsSell);
    },
    account() {
      const e = ct();
      return console.log("authStore.account called, migrate to accountStore", new Error()), e.account;
    }
  },
  actions: {
    async updateAcl(e, t) {
      return this.lastMls = e, this.lastIncludeCounties = t, await this.refreshAcl();
    },
    async refreshAcl() {
      let e = !1;
      try {
        const t = await W.api.account.access(this.lastMls);
        this.access = t.data.result, e = !0;
      } catch (t) {
        console.error("refreshAcl", t), this.access = {
          leads: {},
          properties: {},
          marketplace: {},
          calculator: {},
          isAnonymous: !0
        };
      } finally {
        this.acl = this.access, Ak(e);
      }
      return this.access;
    }
  }
});
function Xn(e, t) {
  return (e & t) == t;
}
var EW = /* @__PURE__ */ ((e) => (e.Information = "info", e.Warning = "warning", e.Error = "error", e))(EW || {});
const ac = new xa(), Ci = _r("notifications", {
  state: () => ({
    notifications: [],
    currentId: 0
  }),
  getters: {
    informationAlerts() {
      return this.notifications.filter(
        (e) => e.severity == "info"
        /* Information */
      );
    },
    warningAlerts() {
      return this.notifications.filter((e) => e.severity == "warning" || uA(e.eventId));
    },
    errorAlerts() {
      return this.notifications.filter((e) => e.severity == "error" || pA(e.eventId));
    },
    hasErrorAlerts() {
      return this.errorAlerts.length > 0;
    }
  },
  actions: {
    async addInfo(e, t = void 0) {
      return await this.addNotification({
        message: e,
        severity: "info",
        eventId: t
      });
    },
    async addWarning(e, t = void 0) {
      return await this.addNotification({
        message: e,
        severity: "warning",
        eventId: t
      });
    },
    async addError(e, t = void 0) {
      return await this.addNotification({
        message: e,
        severity: "error",
        eventId: t
      });
    },
    async addCalculatorIssue(e) {
      let t = "info";
      return pA(e.errorId) ? t = "error" : uA(e.errorId) && (t = "warning"), await this.addNotification({
        message: e.message,
        severity: t,
        eventId: e.errorId,
        properties: e.properties ?? void 0
      });
    },
    async addNotification(e) {
      return await ac.runExclusive(() => (this.currentId++, e.id = this.currentId, this.notifications.push(e), e.id));
    },
    async removeById(e) {
      await ac.runExclusive(() => {
        this.notifications = this.notifications.filter((t) => t.id !== e);
      });
    },
    async removeByEventId(e) {
      await ac.runExclusive(() => {
        this.notifications = this.notifications.filter((t) => t.eventId !== e);
      });
    },
    async removeByEventIds(e) {
      await ac.runExclusive(() => {
        this.notifications = this.notifications.filter((t) => !e.includes(t.eventId));
      });
    },
    async removeByEventIdRange(e, t) {
      await ac.runExclusive(() => {
        this.notifications = this.notifications.filter((s) => hA(s.eventId) < e && hA(s.eventId) > t);
      });
    },
    containsEventId(e) {
      return this.notifications.some((t) => t.eventId == e);
    }
  }
});
function vh(e) {
  return e == null || e == null || (e == null ? void 0 : e.length) === 0 || (e == null ? void 0 : e.trim()) == "";
}
function IW(e) {
  return e == null ? void 0 : e.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#039;");
}
const Sg = !0;
let yh, l2 = new Promise((e) => yh = e), bh, d2 = new Promise((e) => bh = e), Ah, c2 = new Promise((e) => Ah = e);
var TW = /* @__PURE__ */ ((e) => (e[e.IncomeAndExpenseAccounts = 0] = "IncomeAndExpenseAccounts", e))(TW || {});
const OW = new xa(), RW = new xa(), LW = new xa(), u2 = new xa(), p2 = new Na(3 * 1e3, "PropertyDetails"), BW = /* @__PURE__ */ new Date(), MW = U.PropertyTax | U.AssociationFees | U.PropertyInsurance | U.UtilityExpenses, qe = _r("property", {
  state: () => ({
    propertyLoaded: !1,
    loading: !0,
    initializing: !1,
    propertyInitialized: Ki(l2),
    propertyDetailsLoaded: Ki(d2),
    isIdx: !1,
    isSaving: !1,
    calculating: !0,
    publicProperty: void 0,
    settings: void 0,
    calcParams: {},
    calcParamsOrig: void 0,
    calculatedResults: {},
    purchaseFacts: void 0,
    populatingLoans: !1,
    buildingYears: !1,
    monthlyRentalsFirstOriginal: 0,
    propertyUnits: void 0,
    calculatorDoneEvents: [],
    discarded: !1,
    ledger: [],
    totalLedgerEntries: 0,
    loadingLedger: !0,
    ledgerErrorMessage: void 0,
    requireCalculateAndSave: !1,
    hasChanges: !1,
    autoCalculateLoanFees: !0,
    recordsLoading: !1,
    mortgageRecord: void 0,
    mortgage1TermEstimated: !1,
    mortgage2TermEstimated: !1,
    retrievingCountyRecords: !1,
    publicRecords: [],
    cachedPublicRecords: {},
    retrievingTaxAssessorInfo: !1,
    taxInfo: void 0,
    taxInfoInitialized: Ki(c2),
    amortizationSchedule: void 0,
    //#region Flip
    flipCalculatorDoneEvents: [],
    flipParams: {
      purchaseMethod: Vt.BridgeToPermanentLoan,
      renovationCost: 25,
      renovationCostMethod: $p.PerSquareFoot,
      monthsUntilSold: 4,
      afterRepairValue: void 0,
      autoCalculateLoanAmount: !0,
      includeAcquisitionClosingCosts: !0,
      includeRehab: !0,
      loanToPriceLimit: 0.9,
      bridgeLoan: {
        amortizationYears: 30,
        interestRate: 0.12,
        loanAmount: 25e4,
        loanFees: 0.02,
        loanTerm: 24,
        interestOnly: !0
      },
      permanentLoan: {
        loanAmountMethod: Jp.MaxLtv
      },
      cashOutIfPossible: !1,
      maxLTV: 0.75,
      monthsUntilRefinance: 6,
      monthsUntilRent: 6,
      carryingCostExpenses: MW,
      carryingCostOtherExpenses: []
    },
    flipResults: void 0,
    flipBridgeLoanPayment: void 0,
    flipLoanPayment: void 0,
    flipAmortizationSchedule: void 0,
    flipEventRegistered: !1,
    //#endregion
    propertyDetails: void 0,
    //#region Rent vs Sell
    comparisons: [],
    alternativeOne: 1,
    alternativeTwo: 5,
    alternativeThree: 7,
    //#endregion
    sharingProperty: !1,
    shareUrl: void 0,
    shareToken: void 0,
    photos: [],
    photoSource: void 0,
    //#region Schools
    schoolLoading: !0,
    schoolInfo: void 0,
    //#endregion
    blueChipCriteria: void 0,
    mlsHistory: [],
    $property: void 0,
    multiple: []
  }),
  getters: {
    property() {
      var e, t, s, n, r, i, o, l, d, c, u, m, f, v, b, w, S, I, T;
      return this.$property || (this.$property = {
        ...this.publicProperty
      }, (e = this.$property).facts ?? (e.facts = {}), this.$property.facts.bathrooms = Ws((t = this.propertyDetails) == null ? void 0 : t.bathrooms, this.$property.facts.bathrooms), this.$property.facts.bedrooms = Ws((s = this.propertyDetails) == null ? void 0 : s.bedrooms, this.$property.facts.bedrooms), this.$property.facts.construction = dr((n = this.propertyDetails) == null ? void 0 : n.construction, this.$property.facts.construction), this.$property.facts.cooling = dr((r = this.propertyDetails) == null ? void 0 : r.cooling, this.$property.facts.cooling), this.$property.facts.fireplaces = Ws((i = this.propertyDetails) == null ? void 0 : i.fireplaces, this.$property.facts.fireplaces), this.$property.facts.flooring = dr((o = this.propertyDetails) == null ? void 0 : o.flooring, this.$property.facts.flooring), this.$property.facts.foundation = dr((l = this.propertyDetails) == null ? void 0 : l.foundation, this.$property.facts.foundation), this.$property.facts.garageSpaces = Ws((d = this.propertyDetails) == null ? void 0 : d.garageSpaces, this.$property.facts.garageSpaces), this.$property.facts.heating = dr((c = this.propertyDetails) == null ? void 0 : c.heating, this.$property.facts.heating), this.$property.facts.lotSize = dr(`${(u = this.propertyDetails) == null ? void 0 : u.lotSize}`, this.$property.facts.lotSize), this.$property.facts.poolFeatures = ry((m = this.propertyDetails) == null ? void 0 : m.poolFeatures, this.$property.facts.poolFeatures), this.$property.facts.propertyType = dr((f = this.propertyDetails) == null ? void 0 : f.propertyType, this.$property.facts.propertyType), this.$property.facts.roof = ry((v = this.propertyDetails) == null ? void 0 : v.roof, this.$property.facts.roof), this.$property.facts.source = dr((b = this.propertyDetails) == null ? void 0 : b.source, this.$property.facts.source), this.$property.facts.squareFootage = Ws((w = this.propertyDetails) == null ? void 0 : w.sqFt, this.$property.facts.squareFootage), this.$property.facts.stories = Ws((S = this.propertyDetails) == null ? void 0 : S.stories, this.$property.facts.stories), this.$property.facts.style = dr((I = this.propertyDetails) == null ? void 0 : I.style, this.$property.facts.style), this.$property.facts.year = Ws((T = this.propertyDetails) == null ? void 0 : T.yearBuilt, this.$property.facts.year)), this.$property;
    },
    /**
     * 
     * @summary Shortcut to -> property.propId value. (This is deprecated, please use direct path property.propId instead)
     * @deprecated
     */
    propId() {
      var e;
      return (e = this.property) == null ? void 0 : e.propId;
    },
    firstYearRaw() {
      var e, t;
      return (t = (e = this.calculatedResults) == null ? void 0 : e.raw) == null ? void 0 : t.find((s) => s.isProformaYear && s.year == 1);
    },
    /**
     * First year to show in tables.
     * Existing investment modes will show last two years based on first year as rental or the year the user set as first year to analyze, whichever is newer.
     * All other modes will start from the current year.
     */
    firstTableYear() {
      var e, t, s, n;
      if (this.isExistingInvestment) {
        const i = ((e = Te().account) == null ? void 0 : e.defaultAnalysisMode) == Hn.Advanced ? 2 : 1;
        let o = Et;
        switch (this.calcParams.rentalType) {
          case Ut.LongTerm:
            o = Math.min(...((t = this.normalized) == null ? void 0 : t.filter((l) => l.fiscalYear >= Et - i && l.fiscalYear <= Et).map((l) => l.fiscalYear)) ?? [Et]);
            break;
          case Ut.ShortTerm:
            o = Math.min(...((s = this.shortTerm) == null ? void 0 : s.filter((l) => l.fiscalYear >= Et - i && l.fiscalYear <= Et).map((l) => l.fiscalYear)) ?? [Et]);
            break;
          case Ut.PadSplit:
            o = Math.min(...((n = this.padSplit) == null ? void 0 : n.filter((l) => l.fiscalYear >= Et - i && l.fiscalYear <= Et).map((l) => l.fiscalYear)) ?? [Et]);
            break;
        }
        return this.firstAnalyzedYear > o ? this.firstAnalyzedYear : o;
      }
      return Et;
    },
    yearsToShow() {
      var t, s;
      return ct().isAdvancedMode ? ((s = (t = this.calculatedResults) == null ? void 0 : t.raw) == null ? void 0 : s.length) ?? 0 : 5;
    },
    rentalTypeResultYears() {
      var e, t, s;
      switch (this.calcParams.rentalType) {
        case Ut.LongTerm:
          return ((e = this.calculatedResults) == null ? void 0 : e.raw) ?? [];
        case Ut.ShortTerm:
          return ((t = this.calculatedResults) == null ? void 0 : t.shortTerm) ?? [];
        case Ut.PadSplit:
          return ((s = this.calculatedResults) == null ? void 0 : s.padSplit) ?? [];
      }
      return [];
    },
    //#region Existing Investments
    isAtPurchase() {
      return this.calcParams.investmentStrategy == $n.RentVsSell ? !1 : this.firstYearAsRental == this.purchaseYear;
    },
    isCurrentYear() {
      return this.firstYearAsRental == Et;
    },
    purchaseYear() {
      var e, t;
      return (t = (e = this.purchaseFacts) == null ? void 0 : e.purchaseDate) == null ? void 0 : t.getFullYear();
    },
    /**
     * Purchase fact years from first year as rental to current year
     */
    purchaseFactsYears() {
      var s, n, r, i, o;
      const e = Math.max(((s = this.purchaseFacts) == null ? void 0 : s.firstYearAsRental) ?? 0, ((r = (n = this.purchaseFacts) == null ? void 0 : n.purchaseDate) == null ? void 0 : r.getFullYear()) ?? 0) ?? Et, t = Et - 1;
      return ((o = (i = this.purchaseFacts) == null ? void 0 : i.years) == null ? void 0 : o.filter((l) => l.year >= e && l.year <= t).sort((l, d) => l.year - d.year)) ?? [];
    },
    /**
     * Property value from first year as rental
     */
    propertyValueFirstRented() {
      var e;
      return (e = this.purchaseFactsYears.find((t) => {
        var s;
        return t.year == ((s = this.purchaseFacts) == null ? void 0 : s.firstYearAsRental);
      })) == null ? void 0 : e.propertyValue;
    },
    /**
     * @deprecated Use firstYearAsRental
     */
    firstYear() {
      return this.firstYearAsRental;
    },
    firstYearAsRental() {
      var e;
      return ((e = this.purchaseFacts) == null ? void 0 : e.firstYearAsRental) ?? 0;
    },
    firstAnalyzedYear() {
      var e, t;
      return ((e = this.purchaseFacts) == null ? void 0 : e.firstYearToAnalyze) ?? ((t = this.purchaseFacts) == null ? void 0 : t.firstYearAsRental) ?? Et;
    },
    hasInvestmentGap() {
      var e, t;
      return ((e = this.purchaseFacts) == null ? void 0 : e.firstYearAsRental) < ((t = this.purchaseFacts) == null ? void 0 : t.firstYearToAnalyze);
    },
    /**
     * First Proforma Year as Index
     */
    firstProformaYear() {
      return this.calculatedResults.firstProformaYear ?? 1;
    },
    firstProformaYearRaw() {
      var e, t;
      return (t = (e = this.calculatedResults) == null ? void 0 : e.raw) == null ? void 0 : t.find((s) => {
        var n;
        return s.year == ((n = this.calculatedResults) == null ? void 0 : n.firstProformaYear);
      });
    },
    isExistingInvestment() {
      return this.calcParams.investmentStrategy == $n.ExistingInvestment || this.calcParams.investmentStrategy == $n.RentVsSell;
    },
    isNewPurchase() {
      return this.calcParams.investmentStrategy == $n.NewPurchase;
    },
    isFlip() {
      return this.calcParams.investmentStrategy == $n.Flip;
    },
    refiCashOut() {
      var t, s, n, r;
      const e = Ws((t = this.flipResults) == null ? void 0 : t.permanentLoanAmount, 0) - Ws((s = this.flipResults) == null ? void 0 : s.bridgeLoanAmount, 0) - Ws((n = this.flipResults) == null ? void 0 : n.permanentLoanAmount, 0) * Ws((r = this.calcParams) == null ? void 0 : r.loanfees, 0);
      return Math.trunc(e) === 0 ? 0 : e;
    },
    hasShortFall() {
      return this.totalShortfall > 0;
    },
    totalShortfall() {
      var e, t, s, n, r, i;
      return this.isShortTerm ? ((t = (e = this.calculatedResults) == null ? void 0 : e.shortTermSummary) == null ? void 0 : t.totalShortfall) ?? 0 : this.isPadSplit ? ((n = (s = this.calculatedResults) == null ? void 0 : s.padSplitSummary) == null ? void 0 : n.totalShortfall) ?? 0 : ((i = (r = this.calculatedResults) == null ? void 0 : r.longTermSummary) == null ? void 0 : i.totalShortfall) ?? 0;
    },
    totalShortfallAfterTax() {
      var e, t, s, n, r, i;
      return this.isShortTerm ? ((t = (e = this.calculatedResults) == null ? void 0 : e.shortTermSummary) == null ? void 0 : t.totalShortfallAfterTax) ?? 0 : this.isPadSplit ? ((n = (s = this.calculatedResults) == null ? void 0 : s.padSplitSummary) == null ? void 0 : n.totalShortfallAfterTax) ?? 0 : ((i = (r = this.calculatedResults) == null ? void 0 : r.longTermSummary) == null ? void 0 : i.totalShortfallAfterTax) ?? 0;
    },
    totalInvestmentWithShortFall() {
      var e, t, s;
      return this.isFlip ? this.totalShortfall + -this.refiCashOut + Ws(this.flipTotalCashInvested, 0) : this.isExistingInvestment && !this.isAtPurchase ? this.totalShortfall + Ws((s = (t = (e = this.calculatedResults) == null ? void 0 : e.existingInvestmentSummary) == null ? void 0 : t.investmentBasis) == null ? void 0 : s.total, 0) : this.totalShortfall + Ws(this.initialInvestment, 0);
    },
    totalInvestmentWithShortFallAfterTax() {
      var e, t, s;
      return this.isFlip ? this.totalShortfallAfterTax + -this.refiCashOut + Ws(this.flipTotalCashInvested, 0) : this.isExistingInvestment && !this.isAtPurchase ? this.totalShortfallAfterTax + Ws((s = (t = (e = this.calculatedResults) == null ? void 0 : e.existingInvestmentSummary) == null ? void 0 : t.investmentBasis) == null ? void 0 : s.total, 0) : this.totalShortfallAfterTax + Ws(this.initialInvestment, 0);
    },
    isRentVsSell() {
      return this.calcParams.investmentStrategy == $n.RentVsSell;
    },
    isPerformaceReview() {
      return this.calcParams.investmentStrategy == $n.ExistingInvestment;
    },
    isPmSynced() {
      var e;
      return ((e = this.purchaseFacts) == null ? void 0 : e.years.some((t) => t.synced == !0)) == !0;
    },
    // These two functions should mirror same functions in ExistingInvestment.vue
    askIfPreviousLoan() {
      var e, t, s, n;
      return this.purchaseFacts && ((e = this.purchaseFacts) == null ? void 0 : e.purchaseDate) && ((t = this.purchaseFacts) == null ? void 0 : t.hasCurrentLoan) == !0 && ((n = (s = this.purchaseFacts) == null ? void 0 : s.loan) == null ? void 0 : n.date) && Math.round((this.purchaseFacts.loan.date.getTime() - this.purchaseFacts.purchaseDate.getTime()) / 864e5) > 60;
    },
    cantAutoPopulate() {
      var e, t, s, n, r, i, o, l, d, c, u, m, f;
      return (this.calcParams.propertyValueEoY ?? 0) <= 0 || (((e = this.purchaseFacts) == null ? void 0 : e.investmentBasis) ?? 0) <= 0 || (((t = this.purchaseFacts) == null ? void 0 : t.purchasePrice) ?? 0) <= 0 || ((s = this.purchaseFacts) == null ? void 0 : s.purchaseDate) == null || ((n = this.purchaseFacts) == null ? void 0 : n.hasCurrentLoan) == !0 && ((((r = this.purchaseFacts.loan) == null ? void 0 : r.amount) ?? 0) <= 0 || ((i = this.purchaseFacts.loan) == null ? void 0 : i.date) == null || (((o = this.purchaseFacts.loan) == null ? void 0 : o.term) ?? 0) <= 0 || (((l = this.purchaseFacts.loan) == null ? void 0 : l.interestRate) ?? 0) <= 0) || ((d = this.purchaseFacts) == null ? void 0 : d.hasPreviousLoan) == !0 && this.askIfPreviousLoan && ((((c = this.purchaseFacts.previousLoan) == null ? void 0 : c.amount) ?? 0) <= 0 || ((u = this.purchaseFacts.previousLoan) == null ? void 0 : u.date) == null || (((m = this.purchaseFacts.previousLoan) == null ? void 0 : m.term) ?? 0) <= 0 || (((f = this.purchaseFacts.previousLoan) == null ? void 0 : f.interestRate) ?? 0) <= 0);
    },
    hasExistingInvestment() {
      return this.purchaseFacts != null;
    },
    //#endregion
    //#region Units
    requireUnits() {
      var e, t;
      return ((e = this.property) == null ? void 0 : e.propertyType) == "multiFamily" || ((t = this.property) == null ? void 0 : t.propertyType) == "commercial";
    },
    totalUnitsAdded() {
      var e;
      return ((e = this.propertyUnits) == null ? void 0 : e.length) > 0 ? this.propertyUnits.map((t) => t.quantity ?? 0).reduce((t, s) => t + s) ?? 0 : 0;
    },
    unitsTotalRentalRate() {
      var e;
      return ((e = this.propertyUnits) == null ? void 0 : e.length) > 0 ? this.propertyUnits.map((t) => (t.quantity ?? 0) * (t.rentalRate ?? 0)).reduce((t, s) => t + s) ?? 0 : 0;
    },
    unitsAllContainRentalRate() {
      var e;
      return ((e = this.propertyUnits) == null ? void 0 : e.length) > 0 ? this.propertyUnits.every((t) => (t.rentalRate ?? 0) > 0) : !1;
    },
    unitsStrTotalRentalRate() {
      var e;
      return ((e = this.propertyUnits) == null ? void 0 : e.length) > 0 ? this.propertyUnits.map((t) => (t.quantity ?? 0) * (t.strRentalRate ?? 0)).reduce((t, s) => t + s) ?? 0 : 0;
    },
    totalUnitsRequired() {
      var e;
      return ((e = this.property) == null ? void 0 : e.unitCount) ?? 0;
    },
    hasUnitErrors() {
      return this.requireUnits && (this.totalUnitsAdded != this.totalUnitsRequired || this.unitsAllContainRentalRate == !1 || this.unitsTotalRentalRate <= 0);
    },
    //#endregion
    isSingleFamily() {
      var e, t;
      return !((e = this.property) != null && e.propertyType) || ((t = this.property) == null ? void 0 : t.propertyType) == Qa.SingleFamily;
    },
    isMultiFamily() {
      var e;
      return ((e = this.property) == null ? void 0 : e.propertyType) == Qa.MultiFamily;
    },
    isCommercial() {
      var e;
      return ((e = this.property) == null ? void 0 : e.propertyType) == Qa.Commercial;
    },
    propertyTypeOverriden() {
      var e;
      return ((e = this.property) == null ? void 0 : e.propertyType) && this.property.propertyType != Qa.SingleFamily;
    },
    isLongTerm() {
      var e;
      return ((e = this.calcParams) == null ? void 0 : e.rentalType) == Ut.LongTerm;
    },
    isShortTerm() {
      var e;
      return ((e = this.calcParams) == null ? void 0 : e.rentalType) == Ut.ShortTerm;
    },
    isPadSplit() {
      var e;
      return ((e = this.calcParams) == null ? void 0 : e.rentalType) == Ut.PadSplit;
    },
    hasLongTerm() {
      return this.isLongTerm || (this.calcParams.rentalTypeComparisons & nt.LongTerm) == nt.LongTerm;
    },
    hasShortTerm() {
      return this.isShortTerm || (this.calcParams.rentalTypeComparisons & nt.ShortTerm) == nt.ShortTerm;
    },
    hasPadSplit() {
      return this.isPadSplit || (this.calcParams.rentalTypeComparisons & nt.PadSplit) == nt.PadSplit;
    },
    hasLongTermResults() {
      var e, t;
      return this.isLongTerm && ((t = (e = this.calculatedResults) == null ? void 0 : e.normalized) == null ? void 0 : t.length) > 1;
    },
    hasShortTermResults() {
      var e, t;
      return this.isShortTerm && ((t = (e = this.calculatedResults) == null ? void 0 : e.shortTerm) == null ? void 0 : t.length) > 1;
    },
    hasPadSplitResults() {
      var e, t;
      return this.isPadSplit && ((t = (e = this.calculatedResults) == null ? void 0 : e.padSplit) == null ? void 0 : t.length) > 1;
    },
    isMarketplace() {
      var e, t;
      return ((t = (e = this.property) == null ? void 0 : e.mlsSource) == null ? void 0 : t.isActiveMarketplaceListing) == !0;
    },
    isHoldYearAuto() {
      var e;
      return ((e = this.calcParams) == null ? void 0 : e.hold) == 0;
    },
    canSaveChanges() {
      return Te().canSaveParameters == !0 && this.isIdx != !0;
    },
    normalized() {
      var e, t;
      return (e = this.calculatedResults) != null && e.normalized ? (t = this.calculatedResults) == null ? void 0 : t.normalized.filter((s) => s.fiscalYear > 0).sort((s, n) => s.fiscalYear - n.fiscalYear) : [];
    },
    raw() {
      var e, t;
      return (e = this.calculatedResults) != null && e.raw ? (t = this.calculatedResults) == null ? void 0 : t.raw.filter((s) => s.fiscalYear > 0).sort((s, n) => s.fiscalYear - n.fiscalYear) : [];
    },
    shortTerm() {
      var e, t;
      return (e = this.calculatedResults) != null && e.shortTerm ? (t = this.calculatedResults) == null ? void 0 : t.shortTerm.filter((s) => s.fiscalYear > 0).sort((s, n) => s.fiscalYear - n.fiscalYear) : [];
    },
    padSplit() {
      var e;
      return (e = this.calculatedResults) != null && e.padSplit ? this.calculatedResults.padSplit.filter((t) => t.fiscalYear > 0).sort((t, s) => t.fiscalYear - s.fiscalYear) : [];
    },
    /**
     * @deprecated Use ignoreHistoricalOperatingIncome
     */
    fastForwardAnalysis() {
      return this.ignoreHistoricalOperatingIncome;
    },
    ignoreHistoricalOperatingIncome() {
      var e;
      return ((e = this.purchaseFacts) == null ? void 0 : e.ignoreHistoricalOperatingIncome) == !0;
    },
    delayedInService() {
      var e, t;
      return ((t = (e = this.calculatedResults) == null ? void 0 : e.existingInvestmentSummary) == null ? void 0 : t.delayedInService) == !0;
    },
    initialInvestmentDescribed() {
      var e, t, s;
      return this.isExistingInvestment && !this.isAtPurchase ? "Existing Investment's total investment basis at start of rental" : this.ignoreHistoricalOperatingIncome && ((s = (t = (e = this.calculatedResults) == null ? void 0 : e.existingInvestmentSummary) == null ? void 0 : t.previousYear) == null ? void 0 : s.netEquity) != null ? "Previous year's Net Equity" : this.delayedInService ? "Delayed In Service: Service Start EoY's Property Value - Loan Balance - Cost Of Sale + Rehab Amount + Working Capital Reserve" : this.isShortTerm ? "Short Term's Initial Investment" : this.isPadSplit ? "PadSplit's Initial Investment" : "Initial Investment";
    },
    initialInvestment() {
      var e, t, s, n, r, i, o, l, d, c, u, m, f, v, b, w, S, I, T, x, k, C, O, E, B, M, R;
      return this.isExistingInvestment && !this.isAtPurchase ? (s = (t = (e = this.calculatedResults) == null ? void 0 : e.existingInvestmentSummary) == null ? void 0 : t.investmentBasis) == null ? void 0 : s.total : this.ignoreHistoricalOperatingIncome && ((i = (r = (n = this.calculatedResults) == null ? void 0 : n.existingInvestmentSummary) == null ? void 0 : r.previousYear) == null ? void 0 : i.netEquity) != null ? this.calculatedResults.existingInvestmentSummary.previousYear.netEquity : this.delayedInService ? (((d = (l = (o = this.calculatedResults) == null ? void 0 : o.existingInvestmentSummary) == null ? void 0 : l.serviceStartEoY) == null ? void 0 : d.propertyValue) ?? 0) - (((m = (u = (c = this.calculatedResults) == null ? void 0 : c.existingInvestmentSummary) == null ? void 0 : u.serviceStartEoY) == null ? void 0 : m.loanBalance) ?? 0) - (((b = (v = (f = this.calculatedResults) == null ? void 0 : f.existingInvestmentSummary) == null ? void 0 : v.serviceStartEoY) == null ? void 0 : b.costOfSale) ?? 0) + (((I = (S = (w = this.calculatedResults) == null ? void 0 : w.existingInvestmentSummary) == null ? void 0 : S.serviceStartEoY) == null ? void 0 : I.rehabAmount) ?? 0) + (((k = (x = (T = this.calculatedResults) == null ? void 0 : T.existingInvestmentSummary) == null ? void 0 : x.serviceStartEoY) == null ? void 0 : k.workingCapitalReserve) ?? 0) : this.isShortTerm ? (O = (C = this.calculatedResults) == null ? void 0 : C.shortTermSummary) == null ? void 0 : O.initialInvestment : this.isPadSplit ? (B = (E = this.calculatedResults) == null ? void 0 : E.padSplitSummary) == null ? void 0 : B.initialInvestment : (R = (M = this.calculatedResults) == null ? void 0 : M.longTermSummary) == null ? void 0 : R.initialInvestment;
    },
    initialInvestmentLongTerm() {
      var e, t, s, n, r, i, o, l, d, c, u, m, f, v, b, w, S, I, T, x;
      if (this.ignoreHistoricalOperatingIncome && ((s = (t = (e = this.calculatedResults) == null ? void 0 : e.existingInvestmentSummary) == null ? void 0 : t.previousYear) == null ? void 0 : s.netEquity) != null)
        return this.calculatedResults.existingInvestmentSummary.previousYear.netEquity;
      if (this.delayedInService)
        return (((i = (r = (n = this.calculatedResults) == null ? void 0 : n.existingInvestmentSummary) == null ? void 0 : r.serviceStartEoY) == null ? void 0 : i.propertyValue) ?? 0) - (((d = (l = (o = this.calculatedResults) == null ? void 0 : o.existingInvestmentSummary) == null ? void 0 : l.serviceStartEoY) == null ? void 0 : d.loanBalance) ?? 0) - (((m = (u = (c = this.calculatedResults) == null ? void 0 : c.existingInvestmentSummary) == null ? void 0 : u.serviceStartEoY) == null ? void 0 : m.costOfSale) ?? 0) + (((b = (v = (f = this.calculatedResults) == null ? void 0 : f.existingInvestmentSummary) == null ? void 0 : v.serviceStartEoY) == null ? void 0 : b.rehabAmount) ?? 0) + (((I = (S = (w = this.calculatedResults) == null ? void 0 : w.existingInvestmentSummary) == null ? void 0 : S.serviceStartEoY) == null ? void 0 : I.workingCapitalReserve) ?? 0);
      if ((x = (T = this.calculatedResults) == null ? void 0 : T.longTermSummary) != null && x.initialInvestment)
        return this.calculatedResults.longTermSummary.initialInvestment;
    },
    initialInvestmentShortTerm() {
      var e, t, s, n, r, i, o, l, d, c, u, m, f, v, b, w, S, I, T, x;
      if (this.ignoreHistoricalOperatingIncome && ((s = (t = (e = this.calculatedResults) == null ? void 0 : e.existingInvestmentSummary) == null ? void 0 : t.previousYear) == null ? void 0 : s.netEquity) != null)
        return this.calculatedResults.existingInvestmentSummary.previousYear.netEquity;
      if (this.delayedInService)
        return (((i = (r = (n = this.calculatedResults) == null ? void 0 : n.existingInvestmentSummary) == null ? void 0 : r.serviceStartEoY) == null ? void 0 : i.propertyValue) ?? 0) - (((d = (l = (o = this.calculatedResults) == null ? void 0 : o.existingInvestmentSummary) == null ? void 0 : l.serviceStartEoY) == null ? void 0 : d.loanBalance) ?? 0) - (((m = (u = (c = this.calculatedResults) == null ? void 0 : c.existingInvestmentSummary) == null ? void 0 : u.serviceStartEoY) == null ? void 0 : m.costOfSale) ?? 0) + (((b = (v = (f = this.calculatedResults) == null ? void 0 : f.existingInvestmentSummary) == null ? void 0 : v.serviceStartEoY) == null ? void 0 : b.rehabAmount) ?? 0) + (((I = (S = (w = this.calculatedResults) == null ? void 0 : w.existingInvestmentSummary) == null ? void 0 : S.serviceStartEoY) == null ? void 0 : I.workingCapitalReserve) ?? 0);
      if (((x = (T = this.calculatedResults) == null ? void 0 : T.shortTermSummary) == null ? void 0 : x.initialInvestment) != null)
        return this.calculatedResults.shortTermSummary.initialInvestment;
    },
    initialInvestmentPadSplit() {
      var e, t, s, n, r, i, o, l, d, c, u, m, f, v, b, w, S, I, T, x;
      if (this.ignoreHistoricalOperatingIncome && ((s = (t = (e = this.calculatedResults) == null ? void 0 : e.existingInvestmentSummary) == null ? void 0 : t.previousYear) == null ? void 0 : s.netEquity) != null)
        return this.calculatedResults.existingInvestmentSummary.previousYear.netEquity;
      if (this.delayedInService)
        return (((i = (r = (n = this.calculatedResults) == null ? void 0 : n.existingInvestmentSummary) == null ? void 0 : r.serviceStartEoY) == null ? void 0 : i.propertyValue) ?? 0) - (((d = (l = (o = this.calculatedResults) == null ? void 0 : o.existingInvestmentSummary) == null ? void 0 : l.serviceStartEoY) == null ? void 0 : d.loanBalance) ?? 0) - (((m = (u = (c = this.calculatedResults) == null ? void 0 : c.existingInvestmentSummary) == null ? void 0 : u.serviceStartEoY) == null ? void 0 : m.costOfSale) ?? 0) + (((b = (v = (f = this.calculatedResults) == null ? void 0 : f.existingInvestmentSummary) == null ? void 0 : v.serviceStartEoY) == null ? void 0 : b.rehabAmount) ?? 0) + (((I = (S = (w = this.calculatedResults) == null ? void 0 : w.existingInvestmentSummary) == null ? void 0 : S.serviceStartEoY) == null ? void 0 : I.workingCapitalReserve) ?? 0);
      if (((x = (T = this.calculatedResults) == null ? void 0 : T.padSplitSummary) == null ? void 0 : x.initialInvestment) != null)
        return this.calculatedResults.padSplitSummary.initialInvestment;
    },
    /**
     * @deprecated Use isSyncedExpenses
     */
    isSyncedProperty() {
      return this.isSyncedExpenses;
    },
    isSyncedExpenses() {
      var e, t, s, n;
      return ((t = (e = this.purchaseFacts) == null ? void 0 : e.years) == null ? void 0 : t.some((r) => r.synced == !0)) == !0 || ((n = (s = this.purchaseFacts) == null ? void 0 : s.mpod) == null ? void 0 : n.some((r) => r.synced == !0)) == !0;
    },
    hideIrr() {
      var e, t;
      return ((t = (e = this.calculatedResults) == null ? void 0 : e.existingInvestmentSummary) == null ? void 0 : t.irrTimeGap) > 0;
    },
    accountsLedger() {
      return this.ledger.sort((e, t) => t.when.getTime() - e.when.getTime());
    },
    //#region Public Records
    mortgage1() {
      var e;
      return (e = this.mortgageRecord) == null ? void 0 : e.mortgage1;
    },
    mortgage2() {
      var e;
      return (e = this.mortgageRecord) == null ? void 0 : e.mortgage2;
    },
    //#endregion
    isActive() {
      var e, t;
      return ((t = (e = this.property) == null ? void 0 : e.mlsSource) == null ? void 0 : t.isActive) == !0;
    },
    onePercentRule() {
      var t, s, n, r, i, o;
      if (this.isShortTerm) {
        const l = (s = (t = this.calculatedResults) == null ? void 0 : t.shortTerm) == null ? void 0 : s.find((d) => d.year == this.firstProformaYear);
        return (l && l.rentalRate / l.propertyValue) ?? 0;
      }
      if (this.isPadSplit) {
        const l = (r = (n = this.calculatedResults) == null ? void 0 : n.padSplit) == null ? void 0 : r.find((d) => d.year == this.firstProformaYear);
        return (l && l.rentalRate / l.propertyValue) ?? 0;
      }
      const e = (o = (i = this.calculatedResults) == null ? void 0 : i.raw) == null ? void 0 : o.find((l) => l.isProformaYear && l.year == this.firstProformaYear);
      return (e && e.rentalRate / e.propertyValue) ?? 0;
    },
    hasAlternatives() {
      var e;
      return ((e = this.calcParams) == null ? void 0 : e.rentalTypeComparisons) > nt.None;
    },
    rentalTypes() {
      var t, s, n, r, i, o, l, d;
      const e = [];
      return (t = this.calcParams) != null && t.rentalType && e.push(this.calcParams.rentalType), ((s = this.calcParams) == null ? void 0 : s.rentalTypeComparisons) == nt.None || ((((n = this.calcParams) == null ? void 0 : n.rentalTypeComparisons) & nt.LongTerm) == nt.LongTerm && ((r = this.calcParams) == null ? void 0 : r.rentalType) != Ut.LongTerm && e.push(Ut.LongTerm), (((i = this.calcParams) == null ? void 0 : i.rentalTypeComparisons) & nt.ShortTerm) == nt.ShortTerm && ((o = this.calcParams) == null ? void 0 : o.rentalType) != Ut.ShortTerm && e.push(Ut.ShortTerm), (((l = this.calcParams) == null ? void 0 : l.rentalTypeComparisons) & nt.PadSplit) == nt.PadSplit && ((d = this.calcParams) == null ? void 0 : d.rentalType) != Ut.PadSplit && e.push(Ut.PadSplit)), e;
    },
    squareFootageValid() {
      var e;
      return (((e = this.propertyDetails) == null ? void 0 : e.sqFt) ?? 0) > 0;
    },
    //#region Flip
    flipTotalCosts() {
      var e, t, s;
      return ((e = this.flipResults) == null ? void 0 : e.purchasePrice) + ((t = this.flipResults) == null ? void 0 : t.rehab) + ((s = this.flipResults) == null ? void 0 : s.acquisitionClosingCosts) + this.flipLoanFees;
    },
    flipLoanFees() {
      var e, t;
      return this.flipParams.purchaseMethod == Vt.PermanentLoan ? ((e = this.flipResults) == null ? void 0 : e.permanentLoanFees) ?? 0 : this.flipParams.purchaseMethod == Vt.BridgeToPermanentLoan ? ((t = this.flipResults) == null ? void 0 : t.bridgeLoanFees) ?? 0 : 0;
    },
    flipLoanAmount() {
      var e, t;
      return this.flipParams.purchaseMethod == Vt.PermanentLoan ? ((e = this.flipResults) == null ? void 0 : e.permanentLoanAmount) ?? 0 : this.flipParams.purchaseMethod == Vt.BridgeToPermanentLoan ? ((t = this.flipResults) == null ? void 0 : t.bridgeLoanAmount) ?? 0 : 0;
    },
    flipTotalCashInvested() {
      var t, s;
      let e = 0;
      switch (this.flipParams.purchaseMethod) {
        case Vt.BridgeToPermanentLoan:
          e = this.flipTotalCosts - ((t = this.flipResults) == null ? void 0 : t.bridgeLoanAmount) + this.flipBridgeCarryingCost * (this.flipDispositionMonth + 1) - this.flipProRatedTax;
          break;
        case Vt.Cash:
        case Vt.CashToPermanentLoan:
          e = this.flipTotalCosts + this.flipBridgeCarryingCost * (this.flipDispositionMonth + 1) - this.flipProRatedTax;
          break;
        case Vt.PermanentLoan:
          e = this.flipTotalCosts - ((s = this.flipResults) == null ? void 0 : s.permanentLoanAmount) + this.flipBridgeCarryingCost * (this.flipDispositionMonth + 1) - this.flipProRatedTax;
          break;
      }
      return e < 1 ? 0 : e;
    },
    flipDispositionMonth() {
      var e;
      return ((e = this.flipParams) == null ? void 0 : e.monthsUntilSold) + 1;
    },
    flipProRatedTax() {
      var s, n;
      const e = (n = (s = this.calculatedResults) == null ? void 0 : s.raw) == null ? void 0 : n.find((r) => r.isProformaYear && r.year == 1);
      let t = 0;
      return this.flipParams.includeTaxInCashRequired || (t = (e == null ? void 0 : e.propertyTax) / 12 * this.flipParams.monthsUntilSold), t;
    },
    flipBridgeCarryingCost() {
      var s, n, r, i;
      const e = (n = (s = this.calculatedResults) == null ? void 0 : s.raw) == null ? void 0 : n.find((o) => o.isProformaYear && o.year == 1);
      let t = 0;
      return Xn(this.flipParams.carryingCostExpenses, U.PropertyTax) && (t += e == null ? void 0 : e.propertyTax), Xn(this.flipParams.carryingCostExpenses, U.AssociationFees) && (t += e == null ? void 0 : e.hoa), Xn(this.flipParams.carryingCostExpenses, U.PropertyInsurance) && (t += e == null ? void 0 : e.propertyInsurance), Xn(this.flipParams.carryingCostExpenses, U.PropertyManagement) && (t += e == null ? void 0 : e.propertyManagement), Xn(this.flipParams.carryingCostExpenses, U.LeasingCommissions) && (t += e == null ? void 0 : e.leasingCommissions), Xn(this.flipParams.carryingCostExpenses, U.PlatformServiceFees) && (t += e == null ? void 0 : e.platformServiceFees), Xn(this.flipParams.carryingCostExpenses, U.PropertyMaintenance) && (t += e == null ? void 0 : e.propertyMaintenance), Xn(this.flipParams.carryingCostExpenses, U.UtilityExpenses) && (t += e == null ? void 0 : e.utilityExpenses), Xn(this.flipParams.carryingCostExpenses, U.FurnishingExpenses) && (t += e == null ? void 0 : e.furnishingExpenses), Xn(this.flipParams.carryingCostExpenses, U.ConsumableExpenses) && (t += e == null ? void 0 : e.consumableExpenses), Xn(this.flipParams.carryingCostExpenses, U.CleaningExpenses) && (t += e == null ? void 0 : e.cleaningExpenses), Xn(this.flipParams.carryingCostExpenses, U.OtherExpense) && (t += e == null ? void 0 : e.otherExpense), (r = e == null ? void 0 : e.otherExpenses) == null || r.filter((o) => {
        var l;
        return (l = this.flipParams.carryingCostOtherExpenses) == null ? void 0 : l.some((d) => d == o.id);
      }).map((o) => t += o.total), (i = e == null ? void 0 : e.otherNonOperatingExpenses) == null || i.filter((o) => {
        var l;
        return (l = this.flipParams.carryingCostOtherExpenses) == null ? void 0 : l.some((d) => d == o.id);
      }).map((o) => t += o.total), t > 0 && (t /= 12), this.flipIsPermanentLoan ? t += this.flipLoanPayment : this.flipHasBridgeLoan && (t += this.flipBridgeLoanPayment), t;
    },
    flipNetProfit() {
      var t, s, n, r, i, o, l, d, c, u, m, f, v, b;
      let e = (s = (t = this.flipAmortizationSchedule) == null ? void 0 : t.find((w) => w.month == this.flipDispositionMonth)) == null ? void 0 : s.remainingPrincipalAfterPayment;
      switch ((n = this.flipParams) == null ? void 0 : n.purchaseMethod) {
        case Vt.BridgeToPermanentLoan:
          return (i = (r = this.flipParams) == null ? void 0 : r.bridgeLoan) != null && i.interestOnly && (e = (o = this.flipResults) == null ? void 0 : o.bridgeLoanAmount), ((l = this.flipResults) == null ? void 0 : l.afterRepairValue) - ((d = this.flipResults) == null ? void 0 : d.resaleCosts) - this.flipProRatedTax - e - this.flipTotalCashInvested;
        case Vt.Cash:
        case Vt.CashToPermanentLoan:
          return ((c = this.flipResults) == null ? void 0 : c.afterRepairValue) - ((u = this.flipResults) == null ? void 0 : u.resaleCosts) - this.flipProRatedTax - this.flipTotalCashInvested;
        case Vt.PermanentLoan:
          return ((m = this.flipResults) == null ? void 0 : m.afterRepairValue) - ((f = this.flipResults) == null ? void 0 : f.resaleCosts) - this.flipBridgeCarryingCost * (this.flipDispositionMonth + 1) - e - this.flipTotalCashInvested;
        default:
          return ((v = this.flipResults) == null ? void 0 : v.afterRepairValue) - ((b = this.flipResults) == null ? void 0 : b.resaleCosts) - this.flipBridgeCarryingCost * (this.flipDispositionMonth + 1) - e - this.flipTotalCashInvested;
      }
    },
    flipHasBridgeLoan() {
      return this.flipParams.purchaseMethod == Vt.BridgeToPermanentLoan;
    },
    flipIsPermanentLoan() {
      return this.flipParams.purchaseMethod == Vt.PermanentLoan;
    },
    flipCashInOut() {
      var e, t, s, n;
      return ((e = this.flipResults) == null ? void 0 : e.permanentLoanAmount) - ((t = this.flipResults) == null ? void 0 : t.bridgeLoanAmount) - ((s = this.flipResults) == null ? void 0 : s.permanentLoanAmount) * ((n = this.calcParams) == null ? void 0 : n.loanfees);
    },
    flipAnnualLoanPayments() {
      return this.flipBridgeLoanPayment * this.flipParams.monthsUntilRefinance + this.flipLoanPayment * (12 - this.flipParams.monthsUntilRefinance);
    },
    flipTotalOperatingExpensesAnnual() {
      const e = this.firstYearRaw;
      let t = (e == null ? void 0 : e.propertyTax) + (e == null ? void 0 : e.propertyInsurance) + (e == null ? void 0 : e.hoa);
      return t += e == null ? void 0 : e.utilityExpenses, t += (e == null ? void 0 : e.propertyManagement) / 12 * (12 - this.flipParams.monthsUntilRent), t += e == null ? void 0 : e.leasingCommissions, t;
    },
    flipEffectiveRentalIncomeAnnual() {
      return this.flipParams.afterRepairRentPrice * 12 - this.flipParams.afterRepairRentPrice * this.flipParams.monthsUntilRent;
    },
    flipYear1Shortfall() {
      const e = Math.abs(this.flipEffectiveRentalIncomeAnnual - this.flipTotalOperatingExpensesAnnual - this.flipAnnualLoanPayments), t = this.flipBridgeCarryingCost * (this.flipDispositionMonth + 1) - this.flipProRatedTax;
      return e - t;
    },
    flipInvestmentBasisAsRental() {
      var t, s, n, r;
      let e = this.flipTotalCashInvested - ((t = this.flipResults) == null ? void 0 : t.permanentLoanAmount) + ((s = this.flipResults) == null ? void 0 : s.bridgeLoanAmount) + ((n = this.flipResults) == null ? void 0 : n.permanentLoanAmount) * ((r = this.calcParams) == null ? void 0 : r.loanfees) + this.flipYear1Shortfall;
      return (this.flipParams.purchaseMethod == Vt.Cash || this.flipParams.purchaseMethod == Vt.PermanentLoan) && (e = this.flipTotalCashInvested + this.flipYear1Shortfall), e < 1 ? 0 : e;
    },
    flipNetInvestmentAfterRefi() {
      return this.flipTotalCashInvested - this.flipCashInOut + this.flipYear1Shortfall;
    },
    //#endregion
    loanAmount() {
      var e, t;
      return this.isExistingInvestment ? (t = (e = this.purchaseFacts) == null ? void 0 : e.loan) == null ? void 0 : t.amount : this.calcParams.loanAmount;
    },
    loanBalanceEoY() {
      var e, t, s, n, r, i;
      if (this.ignoreHistoricalOperatingIncome && ((s = (t = (e = this.calculatedResults) == null ? void 0 : e.existingInvestmentSummary) == null ? void 0 : t.currentYear) == null ? void 0 : s.loanBalance) != null)
        return this.calculatedResults.existingInvestmentSummary.currentYear.loanBalance;
      if (this.delayedInService && ((i = (r = (n = this.calculatedResults) == null ? void 0 : n.existingInvestmentSummary) == null ? void 0 : r.serviceStartEoY) == null ? void 0 : i.loanBalance) != null)
        return this.calculatedResults.existingInvestmentSummary.serviceStartEoY.loanBalance;
    },
    costOfSale() {
      var e, t, s, n, r, i;
      if (this.ignoreHistoricalOperatingIncome && ((s = (t = (e = this.calculatedResults) == null ? void 0 : e.existingInvestmentSummary) == null ? void 0 : t.previousYear) == null ? void 0 : s.costOfSale) != null)
        return this.calculatedResults.existingInvestmentSummary.previousYear.costOfSale;
      if (this.delayedInService && ((i = (r = (n = this.calculatedResults) == null ? void 0 : n.existingInvestmentSummary) == null ? void 0 : r.serviceStartEoY) == null ? void 0 : i.costOfSale) != null)
        return this.calculatedResults.existingInvestmentSummary.serviceStartEoY.costOfSale;
    },
    rehabExpense() {
      var e, t, s;
      return this.isShortTerm ? (t = (e = this.calculatedResults) == null ? void 0 : e.shortTermSummary) == null ? void 0 : t.rehab : (s = this.calculatedResults) == null ? void 0 : s.rehab;
    },
    workingCapital() {
      var t, s, n;
      let e = 0;
      return this.isShortTerm ? (t = this.calcParams) != null && t.strWorkingCapitalReserve && (e += this.calcParams.strWorkingCapitalReserve) : ((s = this.calculatedResults) != null && s.stabilizationReserve && (e += this.calculatedResults.stabilizationReserve), (n = this.calcParams) != null && n.workingCapitalReserve && (e += this.calcParams.workingCapitalReserve)), e;
    },
    currentEquity() {
      return this.calcParams.propertyValueEoY - this.loanBalanceEoY - this.costOfSale;
    },
    //#region Investment Basis
    initialInvestmentCostOfSale() {
      return this.calcParams.propertyValueEoY * this.calcParams.costofsale;
    },
    initialInvestmentLoanBalance() {
      var e, t, s;
      return ((s = (t = (e = this.calculatedResults) == null ? void 0 : e.existingInvestmentSummary) == null ? void 0 : t.investmentBasis) == null ? void 0 : s.loanBalance) ?? 0;
    },
    initialInvestmentEquity() {
      return this.calcParams.propertyValueEoY - this.initialInvestmentLoanBalance - this.initialInvestmentCostOfSale;
    },
    investmentBasis() {
      return this.initialInvestmentEquity + this.rehabExpense + this.workingCapital;
    },
    /**
     * Cost Basis
     */
    costBasis() {
      var e, t, s, n, r, i, o, l, d;
      return this.isExistingInvestment ? ((s = (t = (e = this.calculatedResults) == null ? void 0 : e.existingInvestmentSummary) == null ? void 0 : t.investmentBasis) == null ? void 0 : s.propertyValue) ?? 0 : this.isShortTerm ? ((r = (n = this.calculatedResults) == null ? void 0 : n.shortTermSummary) == null ? void 0 : r.totalCost) ?? 0 : this.isPadSplit ? ((o = (i = this.calculatedResults) == null ? void 0 : i.padSplitSummary) == null ? void 0 : o.totalCost) ?? 0 : ((d = (l = this.calculatedResults) == null ? void 0 : l.longTermSummary) == null ? void 0 : d.totalCost) ?? 0;
    },
    //#endregion
    /**
     * Returns the analysis year for calculations.
     * If the current month is November or later, returns next year;
     * otherwise, returns the current year.
     * @returns The year used for analysis
     */
    analysisYear() {
      return Xu >= 11 ? Et + 1 : Et;
    },
    /**
     * Calculates the monthly mortgage payment for the property.
     * @returns The monthly mortgage payment or undefined if not applicable.
     */
    mortgagePayment() {
      var e, t, s;
      return this.isExistingInvestment ? ((e = this.purchaseFacts) == null ? void 0 : e.hasCurrentLoan) == !0 && ((t = this.purchaseFacts) != null && t.loan) ? pn(
        this.purchaseFacts.loan.interestRate / 12,
        this.purchaseFacts.loan.term * 12,
        this.purchaseFacts.loan.amount
      ) : 0 : (s = this.calculatedResults) == null ? void 0 : s.monthlyPayment;
    },
    /**
     * Retrieves and returns the estimated monthly property tax.
     * @returns {number | undefined} Estimated monthly property tax or undefined if the calculation is unavailable.
     */
    estimatedPropertyTax() {
      var e, t, s, n, r, i, o, l, d;
      return this.isShortTerm ? Ws((s = (t = (e = this.calculatedResults) == null ? void 0 : e.shortTerm) == null ? void 0 : t.find((c) => c.fiscalYear == this.analysisYear)) == null ? void 0 : s.propertyTax, 0) / 12 : this.isPadSplit ? Ws((i = (r = (n = this.calculatedResults) == null ? void 0 : n.padSplit) == null ? void 0 : r.find((c) => c.fiscalYear == this.analysisYear)) == null ? void 0 : i.propertyTax, 0) / 12 : Ws((d = (l = (o = this.calculatedResults) == null ? void 0 : o.raw) == null ? void 0 : l.find((c) => c.fiscalYear == this.analysisYear)) == null ? void 0 : d.propertyTax, 0) / 12;
    },
    /**
     * Calculates the estimated monthly property insurance cost based on the current analysis year.
     * @returns {number | undefined} The monthly property insurance, or undefined if no insurance data is available.
     */
    estimatedPropertyInsurance() {
      var e, t, s, n, r, i, o, l, d;
      return this.isShortTerm ? Ws((s = (t = (e = this.calculatedResults) == null ? void 0 : e.shortTerm) == null ? void 0 : t.find((c) => c.fiscalYear == this.analysisYear)) == null ? void 0 : s.propertyInsurance, 0) / 12 : this.isPadSplit ? Ws((i = (r = (n = this.calculatedResults) == null ? void 0 : n.padSplit) == null ? void 0 : r.find((c) => c.fiscalYear == this.analysisYear)) == null ? void 0 : i.propertyInsurance, 0) / 12 : Ws((d = (l = (o = this.calculatedResults) == null ? void 0 : o.raw) == null ? void 0 : l.find((c) => c.fiscalYear == this.analysisYear)) == null ? void 0 : d.propertyInsurance, 0) / 12;
    },
    accumulationOfWealth() {
      var e, t, s, n, r, i;
      return this.isShortTerm ? ((t = (e = this.calculatedResults) == null ? void 0 : e.shortTermSummary) == null ? void 0 : t.accumulationOfWealth) ?? 0 : this.isPadSplit ? ((n = (s = this.calculatedResults) == null ? void 0 : s.padSplitSummary) == null ? void 0 : n.accumulationOfWealth) ?? 0 : ((i = (r = this.calculatedResults) == null ? void 0 : r.longTermSummary) == null ? void 0 : i.accumulationOfWealth) ?? 0;
    },
    accumulationOfWealthAfterTax() {
      var e, t, s, n, r, i;
      return this.isShortTerm ? ((t = (e = this.calculatedResults) == null ? void 0 : e.shortTermSummary) == null ? void 0 : t.accumulationOfWealthAfterTax) ?? 0 : this.isPadSplit ? ((n = (s = this.calculatedResults) == null ? void 0 : s.padSplitSummary) == null ? void 0 : n.accumulationOfWealthAfterTax) ?? 0 : ((i = (r = this.calculatedResults) == null ? void 0 : r.longTermSummary) == null ? void 0 : i.accumulationOfWealthAfterTax) ?? 0;
    },
    netGainOnInvestment() {
      var e, t, s, n, r, i;
      return this.isShortTerm ? (t = (e = this.calculatedResults) == null ? void 0 : e.shortTermSummary) == null ? void 0 : t.netGainOnInvestment : this.isPadSplit ? (n = (s = this.calculatedResults) == null ? void 0 : s.padSplitSummary) == null ? void 0 : n.netGainOnInvestment : (i = (r = this.calculatedResults) == null ? void 0 : r.longTermSummary) == null ? void 0 : i.netGainOnInvestment;
    },
    netGainOnInvestmentAfterTax() {
      var e, t, s, n, r, i;
      return this.isShortTerm ? (t = (e = this.calculatedResults) == null ? void 0 : e.shortTermSummary) == null ? void 0 : t.netGainOnInvestmentAfterTax : this.isPadSplit ? (n = (s = this.calculatedResults) == null ? void 0 : s.padSplitSummary) == null ? void 0 : n.netGainOnInvestmentAfterTax : (i = (r = this.calculatedResults) == null ? void 0 : r.longTermSummary) == null ? void 0 : i.netGainOnInvestmentAfterTax;
    },
    capRate() {
      var e, t, s, n, r, i, o, l, d;
      if (this.calculatedResults)
        return this.isShortTerm ? (s = (t = (e = this.calculatedResults) == null ? void 0 : e.shortTerm) == null ? void 0 : t.find((c) => c.year == this.firstProformaYear)) == null ? void 0 : s.capRate : this.isPadSplit ? (i = (r = (n = this.calculatedResults) == null ? void 0 : n.padSplit) == null ? void 0 : r.find((c) => c.year == this.firstProformaYear)) == null ? void 0 : i.capRate : (d = (l = (o = this.calculatedResults) == null ? void 0 : o.normalized) == null ? void 0 : l.find((c) => c.year == this.firstProformaYear)) == null ? void 0 : d.capRate;
    },
    coc() {
      var e, t, s, n, r, i, o, l, d, c, u;
      if (this.isSyncedExpenses) {
        const m = (t = (e = this.purchaseFacts) == null ? void 0 : e.mpod) == null ? void 0 : t.reduce((f, v) => f + Ws(v.cashFlow, 0), 0);
        return m && this.initialInvestment && this.initialInvestment > 0 ? m / this.initialInvestment : void 0;
      }
      return this.isShortTerm ? (r = (n = (s = this.calculatedResults) == null ? void 0 : s.shortTerm) == null ? void 0 : n.find((m) => m.year == this.firstProformaYear)) == null ? void 0 : r.coc : this.isPadSplit ? (l = (o = (i = this.calculatedResults) == null ? void 0 : i.padSplit) == null ? void 0 : o.find((m) => m.year == this.firstProformaYear)) == null ? void 0 : l.coc : (u = (c = (d = this.calculatedResults) == null ? void 0 : d.normalized) == null ? void 0 : c.find((m) => m.year == this.firstProformaYear)) == null ? void 0 : u.coc;
    },
    cocAfterTax() {
      var e, t, s, n, r, i, o, l, d, c, u;
      if (this.isSyncedExpenses) {
        const m = (t = (e = this.purchaseFacts) == null ? void 0 : e.mpod) == null ? void 0 : t.reduce((f, v) => f + Ws(v.cashFlow, 0), 0);
        return m && this.initialInvestment && this.initialInvestment > 0 ? m / this.initialInvestment : void 0;
      }
      return this.isShortTerm ? (r = (n = (s = this.calculatedResults) == null ? void 0 : s.shortTerm) == null ? void 0 : n.find((m) => m.year == this.firstProformaYear)) == null ? void 0 : r.cocAfterTax : this.isPadSplit ? (l = (o = (i = this.calculatedResults) == null ? void 0 : i.padSplit) == null ? void 0 : o.find((m) => m.year == this.firstProformaYear)) == null ? void 0 : l.cocAfterTax : (u = (c = (d = this.calculatedResults) == null ? void 0 : d.normalized) == null ? void 0 : c.find((m) => m.year == this.firstProformaYear)) == null ? void 0 : u.cocAfterTax;
    },
    idealHoldYear() {
      var e, t, s, n, r, i;
      return this.hasShortTermResults ? (t = (e = this.calculatedResults) == null ? void 0 : e.shortTermSummary) == null ? void 0 : t.idealHoldYear : this.hasPadSplitResults ? (n = (s = this.calculatedResults) == null ? void 0 : s.padSplitSummary) == null ? void 0 : n.idealHoldYear : (i = (r = this.calculatedResults) == null ? void 0 : r.longTermSummary) == null ? void 0 : i.idealHoldYear;
    },
    holdYear() {
      var e;
      return this.isHoldYearAuto ? this.idealHoldYear : (e = this.calculatedResults) == null ? void 0 : e.hold;
    },
    holdPeriod() {
      var t, s, n, r, i, o;
      let e;
      if (this.calculatedResults)
        return this.isShortTerm ? e = (s = (t = this.calculatedResults) == null ? void 0 : t.shortTerm) == null ? void 0 : s.find((l) => l.year == this.holdYear) : this.isPadSplit ? e = (r = (n = this.calculatedResults) == null ? void 0 : n.padSplit) == null ? void 0 : r.find((l) => l.year == this.holdYear) : e = (o = (i = this.calculatedResults) == null ? void 0 : i.normalized) == null ? void 0 : o.find((l) => l.year == this.holdYear), e ? {
          holdPeriod: this.holdYear,
          coc: e.coc ?? void 0,
          cocAfterTax: e.cocAfterTax ?? void 0,
          irr: e.irr,
          irrAfterTax: e.irrAfterTax,
          capRate: e.capRate,
          netGainOnInvestment: e.netGainOnInvestment,
          netGainOnInvestmentAfterTax: e.netGainOnInvestmentAfterTax
        } : void 0;
    },
    //#region Rent vs Sell
    rehabAmountForSelling() {
      return this.calcParams.rehabAmountForSelling ?? 0;
    },
    sellInvestmentBasis() {
      var e, t, s;
      return ((s = (t = (e = this.calculatedResults) == null ? void 0 : e.existingInvestmentSummary) == null ? void 0 : t.investmentBasis) == null ? void 0 : s.total) - this.rehabAmountForSelling;
    },
    //#endregion
    downpayment() {
      var e, t, s, n, r;
      if (this.isExistingInvestment) {
        const i = ((e = this.purchaseFacts) == null ? void 0 : e.purchasePrice) ?? 0, o = ((s = (t = this.purchaseFacts) == null ? void 0 : t.loan) == null ? void 0 : s.amount) ?? 0;
        if (i > 0)
          return 1 - o / i;
      }
      return (n = this.calculatedResults) != null && n.downpayment && this.calculatedResults.downpayment > 1 ? this.calculatedResults.downpayment / 100 : (r = this.calculatedResults) == null ? void 0 : r.downpayment;
    },
    propertyValue() {
      var e, t, s;
      return this.isExistingInvestment ? (e = this.calcParams) == null ? void 0 : e.propertyValueEoY : (s = (t = this.property) == null ? void 0 : t.financial) == null ? void 0 : s.propertyValue;
    },
    netEquity() {
      var e, t, s;
      return this.isExistingInvestment == !0 && ((e = this.calculatedResults) != null && e.existingInvestmentSummary) ? (t = this.calculatedResults.existingInvestmentSummary.currentYear) == null ? void 0 : t.netEquity : (s = this.firstProformaYearRaw) == null ? void 0 : s.netEquity;
    },
    rentalSF() {
      var e, t, s, n;
      if ((e = this.calcParams) != null && e.monthlyRentalYear1 && ((s = (t = this.property) == null ? void 0 : t.facts) != null && s.squareFootage) && ((n = this.calcParams) == null ? void 0 : n.monthlyRentalYear1) >= 1)
        return this.calcParams.monthlyRentalYear1 / this.property.facts.squareFootage;
    },
    //#region Schools
    hasSchools() {
      return this.schoolInfo != null && this.schoolInfo.length > 0;
    },
    elementary() {
      var e;
      return (e = this.schoolInfo) == null ? void 0 : e.find((t) => (t == null ? void 0 : t.isElementary) == !0 && t.level_start != null && t.level_start <= 1);
    },
    intermediate() {
      var e;
      return (e = this.schoolInfo) == null ? void 0 : e.find((t) => (t.isElementary || t.isMiddle) && (t.level_start === 5 || t.level_start === 6));
    },
    jrHigh() {
      var e;
      return (e = this.schoolInfo) == null ? void 0 : e.find((t) => !((t.isElementary || t.isMiddle) && (t.level_start === 5 || t.level_start === 6)) && t.isMiddle);
    },
    high() {
      var e;
      return (e = this.schoolInfo) == null ? void 0 : e.find((t) => t.isHigh);
    }
    //#endregion
  },
  actions: {
    reset() {
      l2 = new Promise((e) => yh = e), d2 = new Promise((e) => bh = e), c2 = new Promise((e) => Ah = e), this.$reset();
    },
    /**
     * Initialize the property store
     * @param input The property identifier OR a property lookup object that contains the property identifiers
     * @param mlsSource The MLS source name (Obsolete, use PropertyLookup object)
     * @param mlsNumber The MLS number (Obsolete, use PropertyLookup object)
     * @param useLedger Use the ledger to calculate the property parameters
     */
    async initialize(e, t, s, n) {
      var r, i, o, l, d, c, u, m, f, v;
      this.initializing = !0;
      try {
        Sg && console.log("propertyStore.initialize"), this.propertyLoaded = !1, this.multiple.length = 0;
        let b;
        if (typeof e == "number")
          b = {
            propId: e
          };
        else if (!e && typeof t == "string" && typeof s == "string")
          b = {
            mlsSource: t,
            mlsNumber: s
          };
        else if (typeof e == "object")
          b = e;
        else
          throw new Le("Invalid input");
        let w;
        if (b.propId && b.propId > 0)
          w = await W.api.homes.getPropertyInfo(b.propId);
        else if (b.mlsSource && b.mlsNumber)
          w = await W.api.homes.getPropertyInfoMls(b.mlsSource, b.mlsNumber);
        else if (b.state)
          w = await W.api.homes.getPropertyInfoByAddress(
            b.state,
            b.city,
            b.zip,
            b.address
          );
        else
          throw new Le("Missing identifier");
        if (w.data.status != de.Success && w.data.hasMultiple)
          throw this.multiple.length = 0, this.multiple.push(...w.data.multiple), this.publicProperty = w.data.property, new FW(w, w.data.hasMultiple);
        if (w.data.status != de.Success)
          throw new Le(w);
        this.publicProperty = w.data.property, this.$property = void 0, this.settings = w.data.settings;
        let S;
        if ((r = this.property) != null && r.propId)
          S = await W.api.calculator.getParameters(this.property.propId, n);
        else if ((o = (i = this.property) == null ? void 0 : i.mlsSource) != null && o.source && ((l = this.property) != null && l.mlsSource.number))
          S = await W.api.calculator.getParametersMls(this.property.mlsSource.source, this.property.mlsSource.number, n);
        else
          throw new Le("Missing identifier");
        if (S.data.status != de.Success)
          throw new Le(S);
        if (this.blueChipCriteria = S.data.blueChipCriteria, this.calcParams = S.data.parameters, S.data.flipParams && (this.flipParams = {
          ...this.flipParams,
          ...S.data.flipParams
        }), this.calcParams.monthlyRentalYear1 > 0 && (this.monthlyRentalsFirstOriginal = this.calcParams.monthlyRentalYear1), !S.data.flipParams && this.calcParams.arv && this.calcParams.arv > 0 ? this.flipParams.afterRepairValue = this.calcParams.arv : S.data.flipParams || (this.flipParams.afterRepairValue = this.calcParams.purchaseprice * 1.3), this.parseQueryString(), !((d = S.data.purchaseFacts) != null && d.firstYearToAnalyze) && ((c = S.data.purchaseFacts) == null ? void 0 : c.firstYearAsRental) > 0 && (S.data.purchaseFacts.firstYearToAnalyze = S.data.purchaseFacts.firstYearAsRental), this.purchaseFacts = S.data.purchaseFacts, this.propertyUnits = S.data.propertyUnits, (m = (u = this.purchaseFacts) == null ? void 0 : u.loan) != null && m.amount && ((v = (f = this.purchaseFacts) == null ? void 0 : f.loan) != null && v.closingCosts)) {
          const I = Math.trunc(this.calcParams.loanfees * 1e4), T = Math.trunc(this.purchaseFacts.loan.closingCosts / this.purchaseFacts.loan.amount * 1e4);
          this.autoCalculateLoanFees = I == T;
        }
        this.calcParams.loanAmount || (this.calcParams.loanAmount = Math.trunc(this.calcParams.purchaseprice * (1 - this.calcParams.downpayment))), typeof window.structuredClone < "u" ? this.calcParamsOrig = structuredClone(jr(this.calcParams)) : this.calcParamsOrig = Object.assign({}, this.calcParams), this.propertyLoaded = !0;
      } finally {
        yh && yh(!0), Vc(() => {
          console.log("propertyStore.initialize.finally"), this.initializing = !1, this.loading = !1;
        });
      }
    },
    async updateMpod() {
      var e, t, s, n, r;
      try {
        let i;
        if ((e = this.property) != null && e.propId)
          i = await W.api.calculator.getParameters(this.property.propId, !0);
        else if ((s = (t = this.property) == null ? void 0 : t.mlsSource) != null && s.source && ((n = this.property) != null && n.mlsSource.number))
          i = await W.api.calculator.getParametersMls(this.property.mlsSource.source, this.property.mlsSource.number, !0);
        else
          throw new Le("Missing identifier");
        this.purchaseFacts && ((r = i.data.purchaseFacts) != null && r.mpod) ? (this.purchaseFacts.mpod && (this.purchaseFacts.mpod.length = 0), this.purchaseFacts.mpod = [...i.data.purchaseFacts.mpod]) : this.purchaseFacts = i.data.purchaseFacts;
      } catch (i) {
        console.error(i);
      }
    },
    setIdx() {
      this.isIdx = !0;
    },
    parseQueryString() {
      try {
        const e = new URLSearchParams(window.location.search);
        for (const [t, s] of e)
          this.calcParams[t] ? this.calcParams[t] = h2(this.calcParams[t], s) : this.calcParams[t.toLowerCase()] && (this.calcParams[t.toLowerCase()] = h2(this.calcParams[t.toLowerCase()], s));
        this.calcParams.loanAmount = Math.trunc(this.calcParams.purchaseprice * (1 - this.calcParams.downpayment));
      } catch (e) {
        console.error("propertyStore.parseQueryString", e);
      }
    },
    async favoriteListing() {
      return await RW.runExclusive(async () => {
        var t, s, n, r, i, o, l, d, c, u, m;
        this.isSaving = !0;
        let e;
        if ((t = this.settings) != null && t.isFavorite)
          if ((s = this.property) != null && s.propId)
            e = await W.api.folio.removeFavorite(this.property.propId);
          else if ((r = (n = this.property) == null ? void 0 : n.mlsSource) != null && r.source && ((o = (i = this.property) == null ? void 0 : i.mlsSource) != null && o.number))
            e = await W.api.folio.removeFavoriteListing(this.property.mlsSource.source, this.property.mlsSource.number);
          else
            throw new Le("Could not favorite property. Missing identifier");
        else if ((l = this.property) != null && l.propId)
          e = await W.api.folio.addFavorite(this.property.propId);
        else if ((c = (d = this.property) == null ? void 0 : d.mlsSource) != null && c.source && ((m = (u = this.property) == null ? void 0 : u.mlsSource) != null && m.number))
          e = await W.api.folio.addFavoriteListing(this.property.mlsSource.source, this.property.mlsSource.number);
        else
          throw new Le("Could not unfavorite property. Missing identifier");
        if (e.data.status != de.Success)
          throw new Le(e);
        return this.settings.isFavorite = !this.settings.isFavorite, e.data.message;
      }).finally(() => {
        this.isSaving = !1;
      });
    },
    async ignoreListing() {
      return await LW.runExclusive(async () => {
        var t, s, n, r, i, o, l, d, c, u, m;
        this.isSaving = !0;
        let e;
        if ((t = this.settings) != null && t.isIgnored)
          if ((s = this.property) != null && s.propId)
            e = await W.api.folio.removeIgnore(this.property.propId);
          else if ((r = (n = this.property) == null ? void 0 : n.mlsSource) != null && r.source && ((o = (i = this.property) == null ? void 0 : i.mlsSource) != null && o.number))
            e = await W.api.folio.removeIgnoreListing(this.property.mlsSource.source, this.property.mlsSource.number);
          else
            throw new Le("Could not ignore property. Missing identifier");
        else if ((l = this.property) != null && l.propId)
          e = await W.api.folio.addIgnore(this.property.propId);
        else if ((c = (d = this.property) == null ? void 0 : d.mlsSource) != null && c.source && ((m = (u = this.property) == null ? void 0 : u.mlsSource) != null && m.number))
          e = await W.api.folio.addIgnoreListing(this.property.mlsSource.source, this.property.mlsSource.number);
        else
          throw new Le("Could not unignore property. Missing identifier");
        if (e.data.status != de.Success)
          throw new Le(e);
        return this.settings.isIgnored = !this.settings.isIgnored, e.data.message;
      }).finally(() => {
        this.isSaving = !1;
      });
    },
    async featureProperty(e) {
      return await OW.runExclusive(async () => {
        var s, n, r, i;
        this.isSaving = !0;
        let t;
        if (!((n = (s = this.property) == null ? void 0 : s.mlsSource) != null && n.source) || !((i = (r = this.property) == null ? void 0 : r.mlsSource) != null && i.number))
          throw new Le("Could not feature listing. Missing identifier");
        if ((this.settings.featuredType & e) == e ? (t = await W.api.folio.removeFeaturedListing(this.property.mlsSource.source, this.property.mlsSource.number, e), this.settings.featuredType &= ~e) : (t = await W.api.folio.addFeaturedListing(this.property.mlsSource.source, this.property.mlsSource.number, e), this.settings.featuredType |= e), t.data.status != de.Success)
          throw new Le(t);
        return t.data.message;
      }).finally(() => {
        this.isSaving = !1;
      });
    },
    forceUpdateValues() {
      const e = (this.calcParams.downpayment * 100).toString();
      this.calcParams.downpayment = vs(e) / 100, this.calcParams.loanAmount = Math.trunc(this.calcParams.purchaseprice * (1 - this.calcParams.downpayment)), this.calcParams.strRentalRate && (this.calcParams.strRentalRate = Math.trunc(this.calcParams.strRentalRate));
    },
    addCalculatorEventListener(e) {
      this.calculatorDoneEvents.push(e);
    },
    //#region Existing Investments
    async initPurchaseFacts() {
      this.calculating = !0;
      try {
        if (!this.purchaseFacts) {
          const e = await W.api.calculator.initPurchaseFacts(
            this.property.propId,
            this.calcParams.monthlyRentalYear1,
            void 0,
            // Purchase Date
            void 0,
            // Purchase Amount
            void 0,
            // Loan Term
            void 0,
            // Loan Amount
            void 0,
            // Loan Interest Rate
            void 0,
            // Loan Date
            void 0,
            // Annual Expense Growth
            this.calcParams.annualrentalgrowth,
            void 0,
            // Property Appreciation
            this.calcParams.propertyValueEoY,
            this.firstYearAsRental > 0 ? this.firstYearAsRental : void 0
          );
          if (e.data.status != de.Success)
            throw new Le(e);
          this.purchaseFacts = e.data.purchaseFacts, this.populateLoans();
        }
        this.validateFirstYearAsRental(), this.buildYears();
      } finally {
        this.calculating = !1;
      }
    },
    autoPopulateValueEquity(e, t, s, n, r) {
      if (console.log(`${this.$id}.autoPopulateValueEquity`, this.cantAutoPopulate, e, t, s, n, r), this.cantAutoPopulate)
        return;
      this.purchaseFacts.years || (this.purchaseFacts.years = []);
      const i = Math.trunc((s - e) / (n - t + 1));
      let o = e;
      for (let l = t; l <= n && !(r && l == n); l++) {
        let d = this.purchaseFacts.years.find((c) => c.year == l);
        d || (d = { year: l }, this.purchaseFacts.years.push(d)), d.propertyValue = o += i;
      }
      this.populateLoans();
    },
    populateLoans(e = !0) {
      var t, s, n, r;
      if (console.log("propertyStore.populateLoans", e), !this.cantAutoPopulate && !(!((t = this.purchaseFacts.loan) != null && t.date) || !((s = this.purchaseFacts.loan) != null && s.interestRate) || !((n = this.purchaseFacts.loan) != null && n.term) || !((r = this.purchaseFacts.loan) != null && r.amount))) {
        this.populatingLoans = !0;
        try {
          this.purchaseFacts.years || (this.purchaseFacts.years = []), this.purchaseFacts.years.forEach((i) => i.loanBalance = void 0), this.purchaseFacts.hasPreviousLoan && this.populateLoanBalances(this.purchaseFacts.previousLoan, !0), this.populateLoanBalances(this.purchaseFacts.loan);
        } catch {
        }
        this.populatingLoans = !1, e && (this.purchaseFacts.loan.amount += 1e-3, this.purchaseFacts.loan.amount = Math.trunc(this.purchaseFacts.loan.amount));
      }
    },
    populateLoanBalances(e, t = !1) {
      var l, d;
      if (this.cantAutoPopulate || !e || !e.date || !e.interestRate || !e.term || !e.amount)
        return;
      let s = this.firstYearAsRental;
      s == 0 && e.date && (s = e.date.getFullYear()), console.log("populateLoanBalances", jr(e), t, s), this.purchaseFacts.years || (this.purchaseFacts.years = []);
      const n = /* @__PURE__ */ new Date(), r = 12 - e.date.getMonth(), i = e.date.getFullYear();
      this.populateAmortizationSchedule({
        amortizationYears: e.term,
        interestOnly: this.calcParams.interestOnlyLoan,
        interestOnlyTerm: this.calcParams.interestOnlyTerm,
        interestRate: e.interestRate,
        loanAmount: e.amount
      });
      let o = 0;
      for (let c = s; c < n.getFullYear(); c++) {
        if (console.log("populateLoanBalances.year", c, i, (l = e.datePaidOff) == null ? void 0 : l.getFullYear(), o), c >= i && o == 0)
          o = r + (c - i) * 12;
        else if (e.datePaidOff && c == e.datePaidOff.getFullYear())
          o -= 12 - e.datePaidOff.getMonth();
        else if (e.datePaidOff && c >= e.datePaidOff.getFullYear())
          return;
        let u = this.purchaseFacts.years.find((f) => f.year == c);
        u || (u = { year: c }, this.purchaseFacts.years.push(u));
        const m = ((d = this.amortizationSchedule.find((f) => f.month == o)) == null ? void 0 : d.remainingPrincipalBeforePayment) ?? 0;
        i <= c && m > 0 ? u.loanBalance = Math.trunc(m) : t && c < i && m == 0 && (u.loanBalance = void 0), o += 12, o >= this.amortizationSchedule.length && (o = this.amortizationSchedule.length - 1);
      }
    },
    populateAmortizationSchedule(e) {
      if (e == null) {
        console.error("propertyStore.populateAmortizationSchedule", "loan is undefined");
        return;
      }
      const t = pn(e.interestRate / 12, e.amortizationYears * 12, e.loanAmount);
      this.amortizationSchedule = tu(e.loanAmount, e.interestRate, 12, e.amortizationYears, t, e.interestOnly ? e.interestOnlyTerm : 0);
    },
    getEoYAmortizationInfo(e, t = !1) {
      console.log("propertyStore.getEoYAmortizationInfo", e, t, this.amortizationSchedule);
      let s = this.purchaseFacts.loan;
      t && (s = this.purchaseFacts.previousLoan), this.amortizationSchedule || this.populateAmortizationSchedule({
        amortizationYears: s == null ? void 0 : s.term,
        interestOnly: this.calcParams.interestOnlyLoan,
        interestOnlyTerm: this.calcParams.interestOnlyTerm,
        interestRate: s == null ? void 0 : s.interestRate,
        loanAmount: s == null ? void 0 : s.amount
      });
      const n = s.date.getFullYear(), i = 12 - s.date.getMonth() + (e - n) * 12;
      if (!(i >= this.amortizationSchedule.length))
        return this.amortizationSchedule.find((o) => o.month == i);
    },
    validateFirstYearAsRental() {
      var e;
      (((e = this.purchaseFacts) == null ? void 0 : e.firstYearAsRental) ?? 0) < this.purchaseFacts.purchaseDate.getFullYear() && (this.purchaseFacts.firstYearAsRental = this.purchaseFacts.purchaseDate.getFullYear() + 1);
    },
    buildYears() {
      var e, t, s;
      if (!this.buildingYears && this.purchaseFacts) {
        if (this.buildingYears = !0, console.log("propertyStore.buildYears"), (e = this.purchaseFacts) != null && e.years || (this.purchaseFacts.years = []), (t = this.purchaseFacts) != null && t.purchaseDate) {
          const n = Math.max(((s = this.purchaseFacts) == null ? void 0 : s.firstYearAsRental) ?? 0, this.purchaseFacts.purchaseDate.getFullYear());
          let r = Et - 1;
          BW.getMonth() == 12 && (r = Et);
          for (let i = n; i <= r; i++) {
            if (this.firstYearAsRental > i) return;
            this.purchaseFacts.years.find((l) => l.year == i) || this.purchaseFacts.years.push({
              year: i
            });
          }
          console.log("propertyStore.buildYears", n, r), this.purchaseFacts.years = this.purchaseFacts.years.sort((i, o) => i.year > o.year ? 1 : -1);
        }
        this.buildingYears = !1;
      }
    },
    calculateLoanPaidOffBalance(e, t, s) {
      var n, r;
      if (console.log(`${this.$id}.calculateLoanPaidOffBalance`, e, t, s, m2(e)), xW(e) && s) {
        const i = pn(e.interestRate / 12, e.term * 12, e.amount), o = tu(e.amount, e.interestRate, 12, e.term, i, 0), l = s.getMonth() - t.getMonth() + 12 * (s.getFullYear() - t.getFullYear());
        if (console.log(`${this.$id}.calculateLoanPaidOffBalance`, o.length, l, i, e), l > 0 && o.length > l) {
          const d = (n = o.find((c) => c.month == l)) == null ? void 0 : n.remainingPrincipalBeforePayment;
          return d ? Math.trunc(d) : void 0;
        }
      }
      if (m2(e) && s) {
        const i = pn(e.interestRate / 12, e.amortizationYears * 12, e.loanAmount), o = tu(e.loanAmount, e.interestRate, 12, e.amortizationYears, i, e.interestOnly ? e.interestOnlyTerm : 0), l = s.getMonth() - t.getMonth() + 12 * (s.getFullYear() - t.getFullYear());
        if (console.log(`${this.$id}.calculateLoanPaidOffBalance`, o.length, l, i, e), l > 0 && o.length > l) {
          const d = (r = o.find((c) => c.month == l)) == null ? void 0 : r.remainingPrincipalBeforePayment;
          return d ? Math.trunc(d) : void 0;
        }
      }
    },
    //#endregion
    async calculate(e = !1) {
      return await this.calculateProforma(e);
    },
    async calculateProforma(e = !1) {
      var n, r, i, o, l, d, c, u, m, f, v, b, w, S, I, T, x, k, C, O, E, B, M, R, F, L, j, H, te, re, le, ie, ye, Y, ae, ke, ue, oe, fe, we, Ie, be, Oe, ze, Re, ge, he, Me, Ne, $e, mt, yt, Ct, gt, Ge, Ee, Ce, xe, Pe, it, lt, dt, vt, It, Dt;
      console.log("propertyStore.calculate", e, this.calcParams);
      const t = Ci();
      if (await t.removeByEventIdRange(_n.CalculatorError, 2e4), this.hasPadSplit && ((this.calcParams.padSplitRentalRate ?? 0) <= 0 || (this.calcParams.padSplitRooms ?? 0) <= 0) && await t.addError("Please enter valid rental rate and number of rooms for PadSplit.", _n.InvalidRentalRate), this.hasShortTerm && (this.calcParams.strRentalRate ?? 0) <= 0 && await t.addError("Please enter valid rental rate for Short Term.", _n.InvalidRentalRate), this.hasLongTerm && (this.calcParams.monthlyRentalYear1 ?? 0) <= 0 && await t.addError("Please enter valid rental rate for Long Term.", _n.InvalidRentalRate), t.hasErrorAlerts)
        return console.warn("Has error alerts, not running calculator. User needs to fix errors!", t.errorAlerts), this.calculating = !1, !1;
      this.calculating = !0, (n = this.calcParams).customRentalAvm ?? (n.customRentalAvm = !1), (r = this.calcParams).hideRentalForecastData ?? (r.hideRentalForecastData = !1), (i = this.calcParams).customSaleAvm ?? (i.customSaleAvm = !1), (o = this.calcParams).hideSaleForecastData ?? (o.hideSaleForecastData = !1), this.calcParams.strRentalRate = Math.trunc(this.calcParams.strRentalRate);
      const s = {
        propId: (l = this.property) == null ? void 0 : l.propId,
        mlsSource: (c = (d = this.property) == null ? void 0 : d.mlsSource) == null ? void 0 : c.source,
        mlsNumber: (m = (u = this.property) == null ? void 0 : u.mlsSource) == null ? void 0 : m.number,
        property: {
          associationFee: (f = this.property) == null ? void 0 : f.financial.associationFee,
          isActive: ((b = (v = this.property) == null ? void 0 : v.mlsSource) == null ? void 0 : b.isActive) == !0,
          taxAnnualAmount: (S = (w = this.property) == null ? void 0 : w.financial) == null ? void 0 : S.propertyTax,
          isPending: ((T = (I = this.property) == null ? void 0 : I.mlsSource) == null ? void 0 : T.isPending) == !0,
          zip: (k = (x = this.property) == null ? void 0 : x.address) == null ? void 0 : k.zip,
          city: (O = (C = this.property) == null ? void 0 : C.address) == null ? void 0 : O.city,
          state: (B = (E = this.property) == null ? void 0 : E.address) == null ? void 0 : B.state,
          county: dr((R = (M = this.property) == null ? void 0 : M.address) == null ? void 0 : R.county, "N/A"),
          listPrice: (L = (F = this.property) == null ? void 0 : F.mlsSource) == null ? void 0 : L.listPrice,
          propertyValue: (H = (j = this.property) == null ? void 0 : j.financial) == null ? void 0 : H.propertyValue,
          sellEstimate: (re = (te = this.property) == null ? void 0 : te.financial) == null ? void 0 : re.sellEstimate,
          sqFt: Ws((ie = (le = this.property) == null ? void 0 : le.facts) == null ? void 0 : ie.squareFootage, (ye = this.propertyDetails) == null ? void 0 : ye.sqFt),
          propertyType: (Y = this.property) == null ? void 0 : Y.propertyType,
          unitCount: (ae = this.property) == null ? void 0 : ae.unitCount,
          units: this.propertyUnits
        },
        tweaks: this.calcParams,
        save: this.canSaveChanges && e === !0,
        purchaseFacts: this.purchaseFacts
      };
      console.log("propertyStore.calc.params", s, this.purchaseFacts);
      try {
        this.isFlip && (this.populateFlipParams(), s.flipParameters = this.flipParams, s.tweaks.arv = this.flipParams.afterRepairValue), Sg && this.isFlip && console.log("propertyStore.calculate.FlipParams", this.flipParams), this.isFlip && this.flipTotalCashInvested && (s.brrrrFacts = {
          initialCashInvestment: Math.trunc(this.flipTotalCashInvested),
          cashInOut: Math.trunc(-this.flipCashInOut),
          // We swap polarity because BRRRR subtracts this and calc adds it.
          year1Shortfall: Math.trunc(this.flipYear1Shortfall)
        });
        const ht = await W.api.calculator.calculate(s);
        if (ht.data.status != de.Success)
          throw new Le(ht);
        if ((ke = ht.data.calculation) != null && ke.issues)
          for (const _t of ht.data.calculation.issues)
            await t.addCalculatorIssue(_t);
        if (this.calcParams.purchaseprice = (ue = ht.data.calculation) == null ? void 0 : ue.purchasePrice, ht.data.saved && (typeof window.structuredClone < "u" ? this.calcParamsOrig = structuredClone(jr(this.calcParams)) : this.calcParamsOrig = Object.assign({}, this.calcParams)), this.calculatedResults = ht.data.calculation, (oe = this.calculatedResults) != null && oe.existingInvestmentNeedsAttention && await t.addError("Your existing investment needs attention. Please open Financial History to review and update your investment.", _n.ExistingInvestmentError), this.isFlip) {
          if (this.flipParams.purchaseMethod == Vt.BridgeToPermanentLoan) {
            if (this.flipParams.bridgeLoan.loanAmount = (we = (fe = ht.data.calculation) == null ? void 0 : fe.flip) == null ? void 0 : we.bridgeLoanAmount, this.flipParams.permanentLoan.loanAmount = (be = (Ie = ht.data.calculation) == null ? void 0 : Ie.flip) == null ? void 0 : be.permanentLoanAmount, this.calcParams.loanAmount = (Oe = this.flipParams.permanentLoan) == null ? void 0 : Oe.loanAmount, ((Re = (ze = this.flipParams) == null ? void 0 : ze.bridgeLoan) == null ? void 0 : Re.interestOnly) != !0) {
              const fs = Ll({
                amortizationYears: (ge = this.flipParams.bridgeLoan) == null ? void 0 : ge.amortizationYears,
                loanAmount: (he = this.flipParams.bridgeLoan) == null ? void 0 : he.loanAmount,
                interestRate: (Me = this.flipParams.bridgeLoan) == null ? void 0 : Me.interestRate,
                loanFees: (Ne = this.flipParams.bridgeLoan) == null ? void 0 : Ne.loanFees
              });
              this.flipBridgeLoanPayment = fs.payment, this.flipAmortizationSchedule = fs.schedule;
            } else
              this.flipBridgeLoanPayment = pn(this.flipParams.bridgeLoan.interestRate / 12, this.flipParams.bridgeLoan.amortizationYears * 12, this.flipParams.bridgeLoan.loanAmount);
            const _t = Ll({
              amortizationYears: ($e = this.flipParams.permanentLoan) == null ? void 0 : $e.amortizationYears,
              loanAmount: (mt = this.flipParams.permanentLoan) == null ? void 0 : mt.loanAmount,
              interestRate: (yt = this.flipParams.permanentLoan) == null ? void 0 : yt.interestRate,
              loanFees: (Ct = this.flipParams.permanentLoan) == null ? void 0 : Ct.loanFees,
              interestOnly: (gt = this.flipParams.permanentLoan) == null ? void 0 : gt.interestOnly,
              interestOnlyTerm: (Ge = this.flipParams.permanentLoan) == null ? void 0 : Ge.interestOnlyTerm
            });
            this.flipLoanPayment = _t.payment, this.flipAmortizationSchedule = _t.schedule;
          } else if (this.flipParams.purchaseMethod == Vt.PermanentLoan || this.flipParams.purchaseMethod == Vt.CashToPermanentLoan) {
            this.flipParams.permanentLoan.loanAmount = (Ce = (Ee = ht.data.calculation) == null ? void 0 : Ee.flip) == null ? void 0 : Ce.permanentLoanAmount, this.calcParams.loanAmount = (xe = this.flipParams.permanentLoan) == null ? void 0 : xe.loanAmount;
            const _t = Ll({
              amortizationYears: (Pe = this.flipParams.permanentLoan) == null ? void 0 : Pe.amortizationYears,
              loanAmount: (it = this.flipParams.permanentLoan) == null ? void 0 : it.loanAmount,
              interestRate: (lt = this.flipParams.permanentLoan) == null ? void 0 : lt.interestRate,
              loanFees: (dt = this.flipParams.permanentLoan) == null ? void 0 : dt.loanFees,
              interestOnly: (vt = this.flipParams.permanentLoan) == null ? void 0 : vt.interestOnly,
              interestOnlyTerm: (It = this.flipParams.permanentLoan) == null ? void 0 : It.interestOnlyTerm
            });
            this.flipLoanPayment = _t.payment, this.flipBridgeLoanPayment = 0, this.flipAmortizationSchedule = _t.schedule;
          } else
            this.flipLoanPayment = 0, this.flipBridgeLoanPayment = 0, this.flipAmortizationSchedule = void 0;
          this.flipResults = (Dt = ht.data.calculation) == null ? void 0 : Dt.flip, this.flipCalculatorDoneEvents.forEach((_t) => {
            _t();
          });
        }
        return this.calculatorDoneEvents.forEach((_t) => {
          _t(this.calculatedResults);
        }), this.hasChanges && ht.data.saved && (this.hasChanges = !1), ht.data.saved;
      } catch (ht) {
        throw Le.hasRescoverError(ht) && (await t.addError(ht.message, _n.CalculatorError), ht.handled = !0), ht;
      } finally {
        this.calculating = !1;
      }
    },
    populateFlipParams() {
      var e, t, s, n;
      this.flipParams.purchasePrice = this.calcParams.purchaseprice, this.flipParams.acquisitionClosingCosts = this.calcParams.titlecharges, this.flipParams.sqFt = ((e = this.propertyDetails) == null ? void 0 : e.sqFt) ?? ((s = (t = this.property) == null ? void 0 : t.facts) == null ? void 0 : s.squareFootage), (n = this.flipParams).permanentLoan ?? (n.permanentLoan = {}), this.flipParams.permanentLoan.amortizationYears = this.calcParams.loanterm, this.flipParams.permanentLoan.interestOnly = this.calcParams.interestOnlyLoan, this.flipParams.permanentLoan.interestOnlyTerm = this.calcParams.interestOnlyTerm, this.flipParams.permanentLoan.interestRate = this.calcParams.interestrate, this.flipParams.permanentLoan.loanFees = this.calcParams.loanfees, this.flipParams.dispositionClosingCosts = this.calcParams.costofsale, this.flipParams.afterRepairRentPrice = this.calcParams.monthlyRentalYear1, this.flipParams.carryingCosts = Math.trunc(this.flipBridgeCarryingCost * (this.flipDispositionMonth + 1)) - this.flipProRatedTax;
    },
    async calculateFlip() {
      var t, s, n, r, i, o, l, d, c, u, m, f, v, b, w, S, I, T, x;
      console.log("propertyStore.calculateFlip", this.calcParams);
      const e = Ci();
      this.calculating = !0, this.populateFlipParams(), console.log("propertyStore.calculateFlip.params", this.flipParams);
      try {
        const k = await W.api.calculator.calculateFlip(this.flipParams);
        if (k.data.status != de.Success)
          throw new Le(k);
        if (this.flipParams.purchaseMethod == Vt.BridgeToPermanentLoan) {
          if (this.flipParams.bridgeLoan.loanAmount = k.data.bridgeLoanAmount, this.flipParams.permanentLoan.loanAmount = k.data.permanentLoanAmount, this.calcParams.loanAmount = this.flipParams.permanentLoan.loanAmount, ((s = (t = this.flipParams) == null ? void 0 : t.bridgeLoan) == null ? void 0 : s.interestOnly) != !0) {
            const O = Ll({
              amortizationYears: (n = this.flipParams.bridgeLoan) == null ? void 0 : n.amortizationYears,
              loanAmount: (r = this.flipParams.bridgeLoan) == null ? void 0 : r.loanAmount,
              interestRate: (i = this.flipParams.bridgeLoan) == null ? void 0 : i.interestRate,
              loanFees: (o = this.flipParams.bridgeLoan) == null ? void 0 : o.loanFees
            });
            this.flipBridgeLoanPayment = O.payment, this.flipAmortizationSchedule = O.schedule;
          } else
            this.flipBridgeLoanPayment = pn(this.flipParams.bridgeLoan.interestRate / 12, this.flipParams.bridgeLoan.amortizationYears * 12, this.flipParams.bridgeLoan.loanAmount);
          const C = Ll({
            amortizationYears: (l = this.flipParams.permanentLoan) == null ? void 0 : l.amortizationYears,
            loanAmount: (d = this.flipParams.permanentLoan) == null ? void 0 : d.loanAmount,
            interestRate: (c = this.flipParams.permanentLoan) == null ? void 0 : c.interestRate,
            loanFees: (u = this.flipParams.permanentLoan) == null ? void 0 : u.loanFees,
            interestOnly: (m = this.flipParams.permanentLoan) == null ? void 0 : m.interestOnly,
            interestOnlyTerm: (f = this.flipParams.permanentLoan) == null ? void 0 : f.interestOnlyTerm
          });
          this.flipLoanPayment = C.payment, this.flipAmortizationSchedule = C.schedule;
        } else if (this.flipParams.purchaseMethod == Vt.PermanentLoan || this.flipParams.purchaseMethod == Vt.CashToPermanentLoan) {
          this.flipParams.permanentLoan.loanAmount = k.data.permanentLoanAmount, this.calcParams.loanAmount = (v = this.flipParams.permanentLoan) == null ? void 0 : v.loanAmount;
          const C = Ll({
            amortizationYears: (b = this.flipParams.permanentLoan) == null ? void 0 : b.amortizationYears,
            loanAmount: (w = this.flipParams.permanentLoan) == null ? void 0 : w.loanAmount,
            interestRate: (S = this.flipParams.permanentLoan) == null ? void 0 : S.interestRate,
            loanFees: (I = this.flipParams.permanentLoan) == null ? void 0 : I.loanFees,
            interestOnly: (T = this.flipParams.permanentLoan) == null ? void 0 : T.interestOnly,
            interestOnlyTerm: (x = this.flipParams.permanentLoan) == null ? void 0 : x.interestOnlyTerm
          });
          this.flipLoanPayment = C.payment, this.flipBridgeLoanPayment = 0, this.flipAmortizationSchedule = C.schedule;
        } else
          this.flipLoanPayment = 0, this.flipBridgeLoanPayment = 0, this.flipAmortizationSchedule = void 0;
        return this.flipResults = k.data, this.flipCalculatorDoneEvents.forEach((C) => {
          C();
        }), !0;
      } catch (k) {
        throw Le.hasRescoverError(k) && (await e.addError(k.message, _n.CalculatorError), k.handled = !0), k;
      } finally {
        this.calculating = !1;
      }
    },
    payoff(e) {
      var t, s;
      return ((s = (t = this.amortizationSchedule) == null ? void 0 : t.find((n) => n.month == e)) == null ? void 0 : s.remainingPrincipalAfterPayment) ?? 0;
    },
    flipPayoff(e) {
      var t, s;
      return ((s = (t = this.flipAmortizationSchedule) == null ? void 0 : t.find((n) => n.month == e)) == null ? void 0 : s.remainingPrincipalAfterPayment) ?? 0;
    },
    async resetListing(e = !1) {
      var t, s, n, r, i;
      console.log("propertyStore.resetListing", e, this.canSaveChanges), this.calculating = !0;
      try {
        if (this.canSaveChanges) {
          this.discarded = !0;
          let o;
          if ((s = (t = this.property) == null ? void 0 : t.mlsSource) != null && s.source && ((r = (n = this.property) == null ? void 0 : n.mlsSource) != null && r.number))
            o = await W.api.calculator.resetMls(this.property.mlsSource.source, this.property.mlsSource.number, e);
          else if ((i = this.property) != null && i.propId)
            o = await W.api.calculator.reset(this.property.propId, e);
          else
            throw new Le("Could not reset listing. Missing identifier");
          if (o.data.status != de.Success)
            throw new Le(o);
          this.calcParams = o.data.parameters, this.purchaseFacts = o.data.purchaseFacts, this.calcParams.loanAmount || (this.calcParams.loanAmount = Math.trunc(this.calcParams.purchaseprice * (1 - this.calcParams.downpayment))), this.calcParamsOrig = Object.assign({}, this.calcParams);
        } else
          this.calcParams = Object.assign({}, this.calcParamsOrig);
        this.hasChanges = !1, await this.calculate(!1);
      } finally {
        this.calculating = !1, this.discarded = !1;
      }
    },
    async resetParamsToDefault() {
      console.log("propertyStore.resetParamsToDefault");
      const e = await W.api.searchMls.getSearchParameters();
      if (e.data.status != de.Success)
        throw new Le(e.data.message);
      this.calcParams.annualexpensegrowth = e.data.parameters.annualExpenseGrowth, this.calcParams.annualrentalgrowth = e.data.parameters.annualRentalGrowth, this.calcParams.averagelengthofstay = e.data.parameters.averageLengthOfStay, this.calcParams.capitalExpenditures = e.data.parameters.capitalExpenditures, this.calcParams.cleaningExpenses = e.data.parameters.cleaningExpenses, this.calcParams.consumableExpenses = e.data.parameters.consumableExpenses, this.calcParams.costofsale = e.data.parameters.costOfSale, this.calcParams.furnishingExpenses = e.data.parameters.furnishingExpenses, this.calcParams.hold = e.data.parameters.hold, this.calcParams.leasecommission = e.data.parameters.leaseCommission, this.calcParams.leaserenewalfee = e.data.parameters.leaseRenewalFee, this.calcParams.maintenance = e.data.parameters.maintenance, this.calcParams.managementfee = e.data.parameters.managementFee, this.calcParams.otherExpense = e.data.parameters.otherExpense, this.calcParams.otherExpenses = e.data.parameters.otherExpenses, this.calcParams.percentageLongTermFields = e.data.parameters.percentageLongTermFields, this.calcParams.percentageShortTermFields = e.data.parameters.percentageShortTermFields, this.calcParams.platformServiceFees = e.data.parameters.platformServiceFees, this.calcParams.propertyappreciation = e.data.parameters.propertyAppreciation, this.calcParams.strAnnualExpenseGrowth = e.data.parameters.strAnnualExpenseGrowth, this.calcParams.strAnnualRentalGrowth = e.data.parameters.strAnnualRentalGrowth, this.calcParams.strCapitalExpenditures = e.data.parameters.strCapitalExpenditures, this.calcParams.strCleaningExpenses = e.data.parameters.strCleaningExpenses, this.calcParams.strConsumableExpenses = e.data.parameters.strConsumableExpenses, this.calcParams.strDaysAvailablePerYear = e.data.parameters.strDaysAvailablePerYear, this.calcParams.strFurnishingExpenses = e.data.parameters.strFurnishingExpenses, this.calcParams.strLeaseCommission = e.data.parameters.strLeaseCommission, this.calcParams.strLeaseRenewalFee = e.data.parameters.strLeaseRenewalFee, this.calcParams.strMaintenance = e.data.parameters.strMaintenance, this.calcParams.strManagementFee = e.data.parameters.strManagementFee, this.calcParams.strOtherExpense = e.data.parameters.strOtherExpense, this.calcParams.strPlatformServiceFees = e.data.parameters.strPlatformServiceFees, this.calcParams.strPropertyAppreciation = e.data.parameters.strPropertyAppreciation, this.calcParams.strUtilityExpenses = e.data.parameters.strUtilityExpenses, this.calcParams.utilityExpenses = e.data.parameters.utilityExpenses, this.calcParamsOrig = Object.assign({}, this.calcParams), await this.calculate(!1);
    },
    //#region Units
    addUnit(e) {
      if (this.propertyUnits || (this.propertyUnits = []), this.propertyUnits.some((t) => t.name == e.name))
        throw new Error("Unit with same name alreday exists");
      this.propertyUnits.push(e);
    },
    removeUnit(e) {
      this.propertyUnits || (this.propertyUnits = []), this.propertyUnits = this.propertyUnits.filter((t) => t.name != e.name && t.quantity != e.quantity && t.rentalRate != t.rentalRate);
    },
    //#endregion
    //#region Confirm
    async confirmPurchaseFact(e) {
      return await u2.runExclusive(async () => {
        var s;
        if (this.isSaving = !0, !this.purchaseFacts)
          throw new Le("Purchase Facts not initialized");
        const t = await W.api.calculator.confirmPurchaseFact(this.property.propId, e);
        if (t.data.status != de.Success)
          throw new Le(t);
        switch ((s = this.purchaseFacts).factsConfirmed ?? (s.factsConfirmed = 0), e) {
          case Pt.PurchasePrice:
            this.purchaseFacts.factsConfirmed |= Pt.PurchasePrice;
            break;
          case Pt.PurchaseDate:
            this.purchaseFacts.factsConfirmed |= Pt.PurchaseDate;
            break;
          case Pt.FirstRented:
            this.purchaseFacts.factsConfirmed |= Pt.FirstRented;
            break;
          case Pt.Rehab:
            this.purchaseFacts.factsConfirmed |= Pt.Rehab;
            break;
          case Pt.WorkingCapital:
            this.purchaseFacts.factsConfirmed |= Pt.WorkingCapital;
            break;
          case Pt.LoanInfo:
            this.purchaseFacts.factsConfirmed |= Pt.LoanInfo, this.purchaseFacts.hasCurrentLoan && await W.api.ledger.confirmMortgage(this.property.propId, this.purchaseFacts.loan.date);
            break;
          case Pt.LoanPaidOffInfo:
            this.purchaseFacts.factsConfirmed |= Pt.LoanPaidOffInfo;
            break;
          case Pt.PreviousLoanInfo:
            this.purchaseFacts.factsConfirmed |= Pt.PreviousLoanInfo, this.purchaseFacts.hasPreviousLoan && await W.api.ledger.confirmMortgage(this.property.propId, this.purchaseFacts.previousLoan.date);
            break;
          case Pt.PreviousLoanPaidOffInfo:
            this.purchaseFacts.factsConfirmed |= Pt.PreviousLoanPaidOffInfo;
            break;
          case Pt.InvestmentBasis:
            this.purchaseFacts.factsConfirmed |= Pt.InvestmentBasis;
            break;
        }
        return !0;
      }).finally(() => {
        this.isSaving = !1;
      });
    },
    async unconfirmPurchaseFact(e) {
      return await u2.runExclusive(async () => {
        var s, n, r, i;
        this.isSaving = !0;
        const t = await W.api.calculator.unconfirmPurchaseFact(this.property.propId, e);
        if (t.data.status != de.Success)
          throw new Le(t);
        switch (e) {
          case Pt.PurchasePrice:
            this.purchaseFacts.factsConfirmed &= ~Pt.PurchasePrice;
            break;
          case Pt.PurchaseDate:
            this.purchaseFacts.factsConfirmed &= ~Pt.PurchaseDate;
            break;
          case Pt.FirstRented:
            this.purchaseFacts.factsConfirmed &= ~Pt.FirstRented;
            break;
          case Pt.Rehab:
            this.purchaseFacts.factsConfirmed &= ~Pt.Rehab;
            break;
          case Pt.WorkingCapital:
            this.purchaseFacts.factsConfirmed &= ~Pt.WorkingCapital;
            break;
          case Pt.LoanInfo:
            this.purchaseFacts.factsConfirmed &= ~Pt.LoanInfo, this.purchaseFacts.hasCurrentLoan && await W.api.ledger.unconfirmMortgage(this.property.propId, (n = (s = this.purchaseFacts) == null ? void 0 : s.loan) == null ? void 0 : n.date);
            break;
          case Pt.LoanPaidOffInfo:
            this.purchaseFacts.factsConfirmed &= ~Pt.LoanPaidOffInfo;
            break;
          case Pt.PreviousLoanInfo:
            this.purchaseFacts.factsConfirmed &= ~Pt.PreviousLoanInfo, this.purchaseFacts.hasPreviousLoan && await W.api.ledger.unconfirmMortgage(this.property.propId, (i = (r = this.purchaseFacts) == null ? void 0 : r.previousLoan) == null ? void 0 : i.date);
            break;
          case Pt.PreviousLoanPaidOffInfo:
            this.purchaseFacts.factsConfirmed &= ~Pt.PreviousLoanPaidOffInfo;
            break;
          case Pt.InvestmentBasis:
            this.purchaseFacts.factsConfirmed &= ~Pt.InvestmentBasis;
            break;
        }
        return !0;
      }).finally(() => {
        this.isSaving = !1;
      });
    },
    isConfirmed(e) {
      var t, s, n, r, i, o, l, d, c, u;
      switch (e) {
        case Pt.PurchasePrice:
          return (((t = this.purchaseFacts) == null ? void 0 : t.factsConfirmed) & Pt.PurchasePrice) == Pt.PurchasePrice;
        case Pt.PurchaseDate:
          return (((s = this.purchaseFacts) == null ? void 0 : s.factsConfirmed) & Pt.PurchaseDate) == Pt.PurchaseDate;
        case Pt.FirstRented:
          return (((n = this.purchaseFacts) == null ? void 0 : n.factsConfirmed) & Pt.FirstRented) == Pt.FirstRented;
        case Pt.Rehab:
          return (((r = this.purchaseFacts) == null ? void 0 : r.factsConfirmed) & Pt.Rehab) == Pt.Rehab;
        case Pt.WorkingCapital:
          return (((i = this.purchaseFacts) == null ? void 0 : i.factsConfirmed) & Pt.WorkingCapital) == Pt.WorkingCapital;
        case Pt.LoanInfo:
          return (((o = this.purchaseFacts) == null ? void 0 : o.factsConfirmed) & Pt.LoanInfo) == Pt.LoanInfo;
        case Pt.LoanPaidOffInfo:
          return (((l = this.purchaseFacts) == null ? void 0 : l.factsConfirmed) & Pt.LoanPaidOffInfo) == Pt.LoanPaidOffInfo;
        case Pt.PreviousLoanInfo:
          return (((d = this.purchaseFacts) == null ? void 0 : d.factsConfirmed) & Pt.PreviousLoanInfo) == Pt.PreviousLoanInfo;
        case Pt.PreviousLoanPaidOffInfo:
          return (((c = this.purchaseFacts) == null ? void 0 : c.factsConfirmed) & Pt.PreviousLoanPaidOffInfo) == Pt.PreviousLoanPaidOffInfo;
        case Pt.InvestmentBasis:
          return (((u = this.purchaseFacts) == null ? void 0 : u.factsConfirmed) & Pt.InvestmentBasis) == Pt.InvestmentBasis;
      }
      return !1;
    },
    //#endregion
    //#region Ledger
    async loadLedger(e, t, s) {
      var n;
      this.loadingLedger = !0, this.ledgerErrorMessage = void 0;
      try {
        if ((n = this.property) != null && n.propId) {
          let r;
          if (s == Zp.Synced ? r = await W.api.ledger.getLedgerEntries(this.property.propId, e > 1 ? e : void 0, t != 25 ? t : void 0) : r = await W.api.ledger.getEntries(this.property.propId, s, !0, e > 1 ? e : void 0, t != 25 ? t : void 0), r.data.status != de.Success)
            throw new Le(r);
          this.ledger.length = 0, this.ledger.push(...r.data.page), this.totalLedgerEntries = r.data.total;
        }
      } catch (r) {
        this.ledgerErrorMessage = r.message, jn(r);
      }
      this.loadingLedger = !1;
    },
    async addLedgerEntry(e, t) {
      var s, n, r, i, o, l, d, c, u, m, f, v, b, w, S, I, T;
      this.loadingLedger = !0, this.ledgerErrorMessage = void 0;
      try {
        const x = await W.api.ledger.addEntry((s = this.property) == null ? void 0 : s.propId, e, t);
        if (x.data.status != de.Success)
          throw new Le(x);
        if (t.includeInExpenses) {
          const k = (n = this.purchaseFacts) == null ? void 0 : n.years.find((C) => C.year == t.when.getFullYear());
          switch (x.data.entry.categoryType) {
            case ln.CapitalExpenditures:
              k.capitalExpenditures += (r = x.data.factEntry) == null ? void 0 : r.total;
              break;
            case ln.CleaningExpenses:
              k.cleaningExpenses += (i = x.data.factEntry) == null ? void 0 : i.total;
              break;
            case ln.ConsumableExpenses:
              k.consumableExpenses += (o = x.data.factEntry) == null ? void 0 : o.total;
              break;
            case ln.OtherExpense:
              k.otherExpense += (l = x.data.factEntry) == null ? void 0 : l.total;
              break;
            case ln.FurnishingExpenses:
              k.furnishingExpenses += (d = x.data.factEntry) == null ? void 0 : d.total;
              break;
            case ln.Hoa:
              k.associationFees += (c = x.data.factEntry) == null ? void 0 : c.total;
              break;
            case ln.LeasingCommissions:
              k.commission += (u = x.data.factEntry) == null ? void 0 : u.total;
              break;
            case ln.PlatformServiceFees:
              k.platformServiceFees += (m = x.data.factEntry) == null ? void 0 : m.total;
              break;
            case ln.PropertyInsurance:
              k.insurance += (f = x.data.factEntry) == null ? void 0 : f.total;
              break;
            case ln.PropertyMaintenance:
              k.maintenance += (v = x.data.factEntry) == null ? void 0 : v.total;
              break;
            case ln.PropertyManagement:
              k.management += (b = x.data.factEntry) == null ? void 0 : b.total;
              break;
            case ln.PropertyTax:
              k.tax += (w = x.data.factEntry) == null ? void 0 : w.total;
              break;
            case ln.UtilityExpenses:
              k.utilityExpenses += (S = x.data.factEntry) == null ? void 0 : S.total;
              break;
            default:
              if (x.data.entry.expense) {
                const C = k == null ? void 0 : k.otherExpenses.find((O) => O.id == x.data.factEntry.id);
                C ? C.total += (I = x.data.factEntry) == null ? void 0 : I.total : k == null || k.otherExpenses.push(x.data.factEntry);
              } else {
                const C = k == null ? void 0 : k.otherIncomes.find((O) => O.id == x.data.factEntry.id);
                C ? C.total += (T = x.data.factEntry) == null ? void 0 : T.total : k.otherIncomes.push(x.data.factEntry);
              }
              break;
          }
        }
        await this.calculate();
      } catch (x) {
        throw x;
      }
      this.loadingLedger = !1;
    },
    async confirmEntry(e, t, s) {
      var n;
      this.loadingLedger = !0, this.ledgerErrorMessage = void 0;
      try {
        const r = await W.api.ledger.confirmEntry((n = this.property) == null ? void 0 : n.propId, e, t, s);
        if (r.data.status != de.Success)
          throw new Le(r);
        return !0;
      } catch (r) {
        this.ledgerErrorMessage = r.message, jn(r);
      }
      return this.loadingLedger = !1, !1;
    },
    async deleteLedgerEntry(e, t) {
      var s;
      this.loadingLedger = !0, this.ledgerErrorMessage = void 0;
      try {
        const n = await W.api.ledger.deleteEntry((s = this.property) == null ? void 0 : s.propId, e, t);
        if (n.data.status != de.Success)
          throw new Le(n);
        return !0;
      } catch (n) {
        this.ledgerErrorMessage = n.message, jn(n);
      }
      return this.loadingLedger = !1, !1;
    },
    //#endregion
    //#region Property Records
    async retrieveMortgageRecord() {
      var t, s;
      const e = Te();
      if ((t = this.property) != null && t.propId && ((s = e.access) != null && s.properties.records || this.isMarketplace)) {
        try {
          this.recordsLoading = !0;
          const n = await W.api.records.mortgage(this.property.propId);
          this.mortgageRecord = n.data.record, this.mortgage1 && (!this.mortgage1.term || this.mortgage1.term == 0) && (this.mortgage1.term = 360, this.mortgage1TermEstimated = !0), this.mortgage2 && (!this.mortgage2.term || this.mortgage2.term == 0) && (this.mortgage2.term = 360, this.mortgage2TermEstimated = !0);
        } catch (n) {
          console.log("propertyStore.retrieveMortgageRecord", n);
        }
        this.recordsLoading = !1;
      }
    },
    async retrievePublicRecords() {
      var t, s, n;
      const e = Te();
      if ((t = this.property) != null && t.propId && ((n = (s = e.access) == null ? void 0 : s.properties) != null && n.records || this.isMarketplace)) {
        try {
          this.retrievingCountyRecords = !0;
          const r = await W.api.records.countyRecords(this.property.propId);
          this.publicRecords = r.data.records;
        } catch (r) {
          console.log("propertyStore.retrieveCountyRecords", r);
        }
        this.retrievingCountyRecords = !1;
      }
    },
    async getPublicRecord(e) {
      var s, n, r;
      const t = Te();
      if ((s = this.property) != null && s.propId && ((r = (n = t.access) == null ? void 0 : n.properties) != null && r.records || this.isMarketplace)) {
        try {
          if (!this.cachedPublicRecords[`${e}`]) {
            const i = await W.api.records.countyRecord(this.property.propId, e);
            if (i.data.status != de.Success)
              throw new Le(i);
            this.cachedPublicRecords[`${e}`] = i.data.record;
          }
          return this.cachedPublicRecords[`${e}`];
        } catch (i) {
          console.log("propertyStore.getPublicRecord", i);
        }
        return;
      }
    },
    async retrieveCountyInfo() {
      var t, s, n;
      const e = Te();
      try {
        if ((t = this.property) != null && t.propId && ((n = (s = e.access) == null ? void 0 : s.properties) != null && n.taxAssessor || this.isMarketplace)) {
          try {
            this.retrievingTaxAssessorInfo = !0;
            const r = await W.api.records.countyInfo(this.property.propId);
            if (r.data.status != de.Success)
              throw new Le(r);
            this.taxInfo = r.data.info;
          } catch (r) {
            Sg && console.log("propertyStore.retrieveCountyInfo", r);
          }
          return this.retrievingTaxAssessorInfo = !1, this.taxInfo;
        }
      } finally {
        Ah && Ah(!0);
      }
    },
    //#endregion
    setRequireCalculateAndSave(e) {
      this.requireCalculateAndSave = e;
    },
    setHasChanges() {
      this.hasChanges = !0;
    },
    async retrieveMlsHistory() {
      var e;
      if ((e = this.property) != null && e.propId)
        try {
          const t = await W.api.mls.history(this.property.propId);
          if (t.data.status != de.Success)
            throw new Le(t);
          this.mlsHistory.length = 0, t.data.results && this.mlsHistory.push(...t.data.results);
        } catch (t) {
          throw jn(t), t;
        }
    },
    async getPropertyDetails() {
      console.log("propertyStore.getPropertyDetails");
      try {
        await p2.limit(async () => {
          var t, s, n, r, i;
          let e;
          if ((s = (t = this.property) == null ? void 0 : t.mlsSource) != null && s.source && ((r = (n = this.property) == null ? void 0 : n.mlsSource) != null && r.number))
            e = await W.api.property.getPropertyDetailsMls(this.property.mlsSource.source, this.property.mlsSource.number);
          else if ((i = this.property) != null && i.propId)
            e = await W.api.property.getPropertyDetails(this.property.propId);
          else
            throw new Le("No property id or mls source");
          if (e.data.status != de.Success)
            throw new Le(e);
          this.propertyDetails = e.data.details, this.$property = void 0;
        });
      } catch (e) {
        throw jn(e), e;
      } finally {
        bh && bh(!0);
      }
    },
    async updatePropertyDetails() {
      try {
        await p2.limit(async () => {
          var r, i, o, l, d, c, u, m, f, v, b, w, S, I, T, x, k, C;
          const e = Math.trunc((r = this.propertyDetails) == null ? void 0 : r.bathrooms), t = Math.trunc((e - ((i = this.propertyDetails) == null ? void 0 : i.bathrooms)) * 10), s = {
            bathroomsFull: Math.abs(e),
            bathroomsHalf: Math.abs(t),
            bedrooms: (o = this.propertyDetails) == null ? void 0 : o.bedrooms,
            construction: (l = this.propertyDetails) == null ? void 0 : l.construction,
            cooling: (d = this.propertyDetails) == null ? void 0 : d.cooling,
            fireplaces: (c = this.propertyDetails) == null ? void 0 : c.fireplaces,
            flooring: (u = this.propertyDetails) == null ? void 0 : u.flooring,
            foundation: (m = this.propertyDetails) == null ? void 0 : m.foundation,
            garageSpaces: (f = this.propertyDetails) == null ? void 0 : f.garageSpaces,
            heating: (v = this.propertyDetails) == null ? void 0 : v.heating,
            lotSize: (b = this.propertyDetails) == null ? void 0 : b.lotSize,
            poolFeatures: (w = this.propertyDetails) == null ? void 0 : w.poolFeatures,
            propertyType: (S = this.propertyDetails) == null ? void 0 : S.propertyType,
            roof: (I = this.propertyDetails) == null ? void 0 : I.roof,
            sqFt: (T = this.propertyDetails) == null ? void 0 : T.sqFt,
            stories: (x = this.propertyDetails) == null ? void 0 : x.stories,
            style: (k = this.propertyDetails) == null ? void 0 : k.style,
            yearBuilt: (C = this.propertyDetails) == null ? void 0 : C.yearBuilt
          }, n = await W.api.property.updatePropertyDetails(this.property.propId, s);
          if (n.data.status != de.Success)
            throw new Error(n.data.message);
        });
      } catch (e) {
        throw jn(e), e;
      }
    },
    recalculateDownpaymentPercentage() {
      this.calcParams.downpayment = (this.calcParams.purchaseprice - this.calcParams.loanAmount) / this.calcParams.purchaseprice;
    },
    //#region Rent vs Sell
    async getInvestmentComparisons() {
      const e = await W.api.calculator.getInvestmentComparisons();
      if (e.data.status != de.Success)
        throw new Le(e);
      this.comparisons.push(...e.data.comparisons);
    },
    sellInvestmentBasisYear(e) {
      var s;
      return ((s = this.raw.find((n) => n.year == e)) == null ? void 0 : s.netequity) - this.rehabAmountForSelling;
    },
    /**
     * Calculates projected wealth accumulation for an alternative investment.
     * @param {number} [id] - Unique identifier for the investment.
     * @param {number} [years] - Number of years to project growth. Defaults to store's holdYear.
     * @returns {number | undefined} The total wealth accumulation or undefined if the investment is not found.
     */
    alternativeWealthAccumulation(e, t) {
      if (!e) return;
      t = Ws(t, this.holdYear, 0);
      const s = this.comparisons.find((n) => n.id == e);
      return this.sellInvestmentBasis * Math.pow(1 + (s == null ? void 0 : s.forwardLookingReturn), t);
    },
    //#endregion
    async shareListing(e = !1, t) {
      var r, i, o;
      const s = t.split(/[,; ]/).filter((l) => vh(l) === !1);
      if (s.length === 0 && e === !1)
        throw new Le("No email given.");
      const n = s.filter((l) => /@/.test(l) === !1);
      if (n.length > 0)
        throw new Le(`Invalid email , ${IW(n[0])}.`);
      this.sharingProperty = !0;
      try {
        const l = {
          addresses: s,
          self: e
        }, d = await W.api.homes.share((r = this.property) == null ? void 0 : r.propId, l, (o = (i = this.property) == null ? void 0 : i.facts) == null ? void 0 : o.squareFootage, this.calcParams.associationfee, this.propertyValue, this.calcParams.propertytax, this.calcParams.monthlyRentalYear1, this.shareToken);
        if (d.data.status != de.Success)
          throw new Le(d);
        this.shareToken = d.data.token, this.shareUrl = d.data.shareUrl;
      } finally {
        this.sharingProperty = !1;
      }
    },
    async createShareUrl() {
      var e, t, s;
      this.sharingProperty = !0;
      try {
        const n = await W.api.homes.createShareUrl((e = this.property) == null ? void 0 : e.propId, (s = (t = this.property) == null ? void 0 : t.facts) == null ? void 0 : s.squareFootage, this.calcParams.associationfee, this.propertyValue, this.calcParams.propertytax, this.calcParams.monthlyRentalYear1);
        if (n.data.status != de.Success)
          throw new Le(n);
        this.shareToken = n.data.token, this.shareUrl = n.data.shareUrl;
      } finally {
        this.sharingProperty = !1;
      }
    },
    async retrievePhotos() {
      var t, s, n, r, i;
      await this.propertyInitialized;
      let e;
      if ((s = (t = this.property) == null ? void 0 : t.mlsSource) != null && s.source && ((r = (n = this.property) == null ? void 0 : n.mlsSource) != null && r.number))
        e = await W.api.images.getImagesByMls(this.property.mlsSource.source, this.property.mlsSource.number);
      else if ((i = this.property) != null && i.propId)
        e = await W.api.images.getImages(this.property.propId);
      else
        throw new Le("No property id or mls source");
      if (e.data.status != de.Success)
        throw new Error(e.data.message);
      this.photoSource = e.data.source, this.photos.length = 0, e.data.images && this.photos.push(...e.data.images);
    },
    //#region Schools
    async retrieveSchoolInfo(e) {
      var t, s, n, r, i, o;
      try {
        this.schoolLoading = !0, await this.propertyInitialized;
        let l;
        if ((s = (t = this.property) == null ? void 0 : t.mlsSource) != null && s.source && ((r = (n = this.property) == null ? void 0 : n.mlsSource) != null && r.number))
          l = await W.api.schools.listing(this.property.mlsSource.source, this.property.mlsSource.number, e);
        else if ((i = this.property) != null && i.propId)
          l = await W.api.schools.property(this.property.propId, e);
        else
          throw new Le("No property id or mls source");
        this.schoolInfo = l.data.schools, (o = this.schoolInfo) == null || o.sort((d, c) => (d.level_start ?? 0) - (c.level_start ?? 0));
      } finally {
        this.schoolLoading = !1;
      }
    },
    //#endregion
    setDownpayment(e) {
      console.log(`${this.$id}.setDownpayment`, e), this.calcParams.downpayment = e, this.calcParams.purchaseprice ? this.calcParams.loanAmount = Math.trunc(this.calcParams.purchaseprice * (1 - this.calcParams.downpayment)) : this.calcParams.loanAmount = void 0;
    }
  }
});
function h2(e, t) {
  return typeof e == "number" ? vs(t) : typeof e == "boolean" ? /true/i.test(t) : t;
}
function xW(e) {
  return typeof e == "object" && "amount" in e && "date" in e && "term" in e && "interestRate" in e && e.amount > 0 && e.date != null && e.term > 0 && e.interestRate > 0;
}
function m2(e) {
  return typeof e == "object" && "loanAmount" in e && "amortizationYears" in e && "interestRate" in e && e.loanAmount > 0 && e.amortizationYears > 0 && e.interestRate > 0;
}
function Ll(e) {
  const t = pn((e == null ? void 0 : e.interestRate) / 12, (e == null ? void 0 : e.amortizationYears) * 12, e == null ? void 0 : e.loanAmount);
  return {
    payment: t,
    schedule: tu(e == null ? void 0 : e.loanAmount, e == null ? void 0 : e.interestRate, 12, e == null ? void 0 : e.amortizationYears, t, e != null && e.interestOnly ? e == null ? void 0 : e.interestOnlyTerm : 0)
  };
}
class FW extends Le {
  constructor(s, n, r) {
    var t = (...pcs) => (super(...pcs), Xe(this, "hasMultiple"), this);
    typeof s == "object" && hP(s) ? (t(s), this.hasMultiple = n === !0) : t(s, n, r), Object.setPrototypeOf(this, new.target.prototype);
  }
}
const VW = new Na(2 * 1e3, "crmUsers"), DW = new Na(2 * 1e3, "crmSettings"), NW = new Na(2 * 1e3, "crmPipelines"), jW = new Na(2 * 1e3, "crmStages"), f2 = new Na(2 * 1e3, "crmCreateLead"), Mn = _r("crm", {
  state: () => ({
    isCrmLoading: !0,
    isCrmBusy: !0,
    isConfigured: !1,
    managedBy: void 0,
    crmSettings: void 0,
    crmUsers: [],
    crmPipelines: [],
    crmStages: []
  }),
  getters: {},
  actions: {
    async fetchSettings() {
      await DW.limit(async () => {
        var e;
        try {
          this.isCrmLoading = !0;
          const t = ct();
          if (await t.fetchUserSettings(), !t.crmProvider) {
            console.warn("Missing CRM provider, not fetching CRM settings");
            return;
          }
          if ((e = t.userInfo) != null && e.crmProvider) {
            const s = await W.api.crm.isConfigured(t.crmProvider);
            if (s.data.status != de.Success)
              throw new Le(s);
            if (this.isConfigured = s.data.result == !0, this.isConfigured) {
              const n = await W.api.crm.getSettings(t.crmProvider);
              if (n.data.status != de.Success)
                throw new Le(n);
              this.managedBy = n.data.managedBy, this.crmSettings = n.data.settings;
            }
          }
        } catch (t) {
          throw console.error("fetchSettings", t), Ns(t), t;
        }
      }).finally(() => {
        this.isCrmLoading = !1;
      });
    },
    async fetchCrmUsers() {
      await VW.limit(async () => {
        try {
          this.isCrmLoading = !0;
          const e = ct();
          if (await e.fetchUserSettings(), !e.crmProvider) {
            console.warn("Missing CRM provider, not fetching CRM users");
            return;
          }
          this.crmUsers.length = 0;
          const t = await W.api.crm.getUsers(e.crmProvider);
          if (t.data.status != de.Success)
            throw new Error(t.data.message);
          this.crmUsers.push(...t.data.results), this.crmUsers.sort((s, n) => (s.name ?? "").localeCompare(n.name ?? ""));
        } catch (e) {
          throw console.error("fetchCrmUsers", e), Ns(e), e;
        }
      }).finally(() => {
        this.isCrmLoading = !1;
      });
    },
    async fetchCrmPipelines() {
      await NW.limit(async () => {
        try {
          this.isCrmLoading = !0;
          const e = ct();
          if (await e.fetchUserSettings(), !e.crmProvider) {
            console.warn("Missing CRM provider, not fetching CRM pipelines");
            return;
          }
          this.crmPipelines.length = 0;
          const t = await W.api.crm.getPipelines(e.crmProvider);
          if (t.data.status != de.Success)
            throw new Le(t);
          this.crmPipelines.push(...t.data.pipelines);
        } catch (e) {
          throw console.error("fetchCrmPipelines", e), Ns(e), e;
        }
      }).finally(() => {
        this.isCrmLoading = !1;
      });
    },
    async fetchCrmStages(e) {
      e && await jW.limit(async () => {
        try {
          this.isCrmLoading = !0;
          const t = ct();
          if (await t.fetchUserSettings(), !t.crmProvider) {
            console.warn("Missing CRM provider, not fetching CRM stages");
            return;
          }
          this.crmStages.length = 0;
          const s = await W.api.crm.getStages(t.crmProvider, e);
          if (s.data.status != de.Success)
            throw new Le(s);
          this.crmStages.push(...s.data.stages);
        } catch (t) {
          throw Ns(t), t;
        }
      }).finally(() => {
        this.isCrmLoading = !1;
      });
    },
    async createLead(e, t) {
      return await f2.limit(async () => {
        try {
          this.isCrmLoading = !0;
          const s = ct();
          if (await s.fetchUserSettings(), !s.crmProvider) {
            console.warn("Missing CRM provider, not creating CRM lead");
            return;
          }
          const n = await W.api.crm.createLead(s.crmProvider, e, t);
          if (n.data.status != de.Success)
            throw new Le(n);
          return n.data.lead;
        } catch (s) {
          throw Ns(s), s;
        }
      }).finally(() => {
        this.isCrmLoading = !1;
      });
    },
    async createPropertyOwnerLead(e, t) {
      return await f2.limit(async () => {
        try {
          this.isCrmBusy = !0;
          const s = ct();
          if (await s.fetchUserSettings(), !s.crmProvider) {
            console.warn("Missing CRM provider, cannot create CRM lead");
            return;
          }
          const n = await W.api.crm.createPropertyOwnerLead(s.crmProvider, e, t);
          if (n.data.status != de.Success)
            throw new Le(n);
          return n.data.lead;
        } catch (s) {
          throw Ns(s), s;
        }
      }).finally(() => {
        this.isCrmBusy = !1;
      });
    }
  }
}), bm = _r("analysisRequests", {
  state: () => ({
    loadingAnalysisRequests: !1,
    sharingAnalysisRequest: !1,
    assigningAnalysisRequest: !1,
    archivingAnalysisRequest: !1,
    crmAnalysisRequest: !1,
    analysisRequests: [],
    totalRequests: 0,
    currentPage: 1,
    pageSize: 25,
    showArchived: !1,
    hasSchedulingLink: !1,
    messageTemplate: "",
    analysisRequestsError: void 0,
    view: void 0,
    analysisRequestInfo: void 0,
    managementTerritory: void 0
  }),
  getters: {
    analysisRequestBusy() {
      return this.loadingAnalysisRequests == !0 || this.sharingAnalysisRequest == !0 || this.assigningAnalysisRequest == !0 || this.archivingAnalysisRequest == !0 || this.crmAnalysisRequest == !0;
    }
  },
  actions: {
    async getSettings() {
      try {
        const e = await W.api.analysisRequests.getSettings();
        if (e.data.status != de.Success)
          throw new Error(e.data.message);
        this.hasSchedulingLink = e.data.hasSchedulingLink, this.messageTemplate = e.data.messageTemplate;
      } catch (e) {
        this.analysisRequestsError = e.message;
      }
    },
    async getRequests(e) {
      this.loadingAnalysisRequests = !0;
      try {
        e && (this.currentPage = e);
        const t = this.currentPage == 1 ? void 0 : this.currentPage, s = this.pageSize == 25 ? void 0 : this.pageSize, n = this.showArchived != !0 ? void 0 : !0, r = await W.api.analysisRequests.getRequests(t, s, n);
        if (r.data.status != de.Success)
          throw new Error(r.data.message);
        this.analysisRequests.length = 0, this.totalRequests = r.data.total, this.analysisRequests.push(...r.data.requests);
      } catch (t) {
        console.log("getRequests", t.message), this.analysisRequestsError = t.message;
      }
      this.loadingAnalysisRequests = !1;
    },
    async shareRequest(e, t) {
      try {
        this.sharingAnalysisRequest = !0;
        const s = await W.api.analysisRequests.share(e, t);
        if (s.data.status != de.Success)
          throw new Error(s.data.message);
        return this.analysisRequests.forEach((n, r) => {
          n.token == e && (this.analysisRequests[r] = s.data.request);
        }), !0;
      } catch (s) {
        return this.analysisRequestsError = s.message, !1;
      } finally {
        this.sharingAnalysisRequest = !1;
      }
    },
    async assignToMe(e) {
      try {
        this.assigningAnalysisRequest = !0;
        const t = await W.api.analysisRequests.assign(e);
        if (t.data.status != de.Success)
          throw new Error(t.data.message);
        return this.analysisRequests.forEach((s, n) => {
          s.token == e && (this.analysisRequests[n] = t.data.request);
        }), !0;
      } catch (t) {
        return this.analysisRequestsError = t.message, !1;
      } finally {
        this.assigningAnalysisRequest = !1;
      }
    },
    async archiveRequest(e) {
      try {
        this.archivingAnalysisRequest = !0;
        const t = await W.api.analysisRequests.archive(e);
        if (t.data.status != de.Success)
          throw new Error(t.data.message);
        const s = this.analysisRequests.findIndex((n) => n.id == e);
        return s > -1 && this.analysisRequests.splice(s, 1), !0;
      } catch (t) {
        return this.analysisRequestsError = t.message, !1;
      } finally {
        this.archivingAnalysisRequest = !1;
      }
    },
    async addCrm(e) {
      try {
        this.crmAnalysisRequest = !0;
        const t = await W.api.analysisRequests.addCrm(e);
        if (t.data.status != de.Success)
          throw new Error(t.data.message);
        return this.analysisRequests.forEach((s, n) => {
          s.token == e && (this.analysisRequests[n].isCrmCreated = !0);
        }), !0;
      } catch (t) {
        return this.analysisRequestsError = t.message, !1;
      } finally {
        this.crmAnalysisRequest = !1;
      }
    },
    async skipTrace(e) {
      try {
        this.crmAnalysisRequest = !0;
        const t = await W.api.analysisRequests.skipTrace(e);
        if (t.data.status != de.Success)
          throw new Error(t.data.message);
        return this.analysisRequests.forEach((s, n) => {
          s.token == e && (this.analysisRequests[n] = t.data.request);
        }), !0;
      } catch (t) {
        return this.analysisRequestsError = t.message, console.log("Skip Trace", this.analysisRequestsError), !1;
      } finally {
        this.crmAnalysisRequest = !1;
      }
    },
    async getRequestView(e, t) {
      try {
        if (this.assigningAnalysisRequest = !0, !this.view || t == !0) {
          const s = await W.api.analysisRequests.view(e);
          if (s.data.status != de.Success)
            throw new Error(s.data.message);
          this.view = s.data.request;
        }
        return !0;
      } catch (s) {
        return this.analysisRequestsError = s.message, !1;
      } finally {
        this.assigningAnalysisRequest = !1;
      }
    },
    async getCurrentRequest() {
      try {
        this.analysisRequestsError = void 0;
        const e = await W.api.analysisRequests.getRequest();
        if (e.data.status != de.Success)
          throw new Error(e.data.message);
        return this.analysisRequestInfo = e.data.request, !0;
      } catch (e) {
        return this.analysisRequestsError = e.message, !1;
      }
    },
    async getCurrentClientValue() {
      var e;
      try {
        this.analysisRequestsError = void 0;
        const t = await W.api.analysisRequests.getClientValue();
        if (t.data.status != de.Success)
          throw new Error(t.data.message);
        return this.managementTerritory = ((e = t.data) == null ? void 0 : e.inPmArea) ?? 0, !0;
      } catch (t) {
        return this.analysisRequestsError = t.message, !1;
      }
    },
    async trackCurrentView() {
      try {
        const e = await W.api.analysisRequests.trackPageView();
        e.data.status != de.Success && console.warn(e.data.message);
      } catch (e) {
        console.error(e);
      }
    }
  }
}), g2 = new Na(2e3, "OwnerNames");
let wh = () => {
}, v2 = new Promise((e) => wh = e), iy = () => {
}, y2 = new Promise((e) => iy = e);
const Ba = _r("portfolioFinder", {
  state: () => ({
    lastOwnerNameCall: void 0,
    ownerNamesLoaded: Ki(v2),
    loadingOwnerNames: !1,
    ownerParties: [],
    propertyOwnerNames: [],
    owner: void 0,
    ownerLoading: !1,
    ownerLoaded: Ki(y2),
    contactsLoading: !1,
    leadContacts: [],
    traceHistory: [],
    propertyLocationsLoading: !0,
    propertyLocations: [],
    propertyLocationsBounds: void 0,
    propertyTypes: [],
    propertiesLoading: !1,
    properties: [],
    propertyTotal: void 0,
    propertyFiltered: void 0,
    propertyAbsenteeOwnedCount: void 0,
    propertyHomesteadCount: void 0,
    agents: [],
    loadingAgents: !1,
    agentPage: 0,
    agentPageSize: 100,
    agentHasMore: !1,
    skipTraceStats: void 0
  }),
  getters: {
    isLoading() {
      return this.loadingAgents || this.loadingOwnerNames || this.contactsLoading || this.propertyLocationsLoading || this.ownerLoading || this.propertiesLoading;
    },
    leadName() {
      var e, t, s, n;
      return this.owner ? (e = this.owner) != null && e.firstName ? `${(s = this.owner) == null ? void 0 : s.firstName} ${(n = this.owner) == null ? void 0 : n.lastName}` : `${(t = this.owner) == null ? void 0 : t.lastName}` : "";
    },
    agentsGroups() {
      if (this.agents.length == 0)
        return [];
      const e = this.agents.filter((n) => n.listDate != null), t = HW(e, (n) => n.groupId);
      return UW(t, (n, r) => {
        const i = r[0];
        return {
          agentId: i.agentId,
          mlsSource: i.mlsSource,
          groupId: i.groupId,
          firstName: i.firstName,
          lastName: i.lastName,
          broker: i.broker,
          email: i.email,
          office: i.office,
          propertyManagement: i.propertyManagement,
          investorManagement: i.investorManagement,
          properties: r
        };
      }).sort((n, r) => {
        const i = n.properties.reduce((l, d) => l && l.listDate > d.listDate ? l : d).listDate, o = r.properties.reduce((l, d) => l && l.listDate > d.listDate ? l : d).listDate;
        return i < o ? 1 : i > o ? -1 : 0;
      });
    },
    selectedProperties() {
      return this.properties.filter((e) => e.selected);
    }
  },
  actions: {
    reset() {
      v2 = new Promise((e) => wh = e), y2 = new Promise((e) => iy = e), this.$reset();
    },
    async loadOwnerNames(e) {
      await this.refreshOwnerNames(e);
    },
    async refreshOwnerNames(e) {
      try {
        await g2.limit(async () => {
          if (this.lastOwnerNameCall && Zv(this.lastOwnerNameCall) < 30)
            return;
          this.loadingOwnerNames = !0, this.ownerParties.length = 0;
          const t = await W.api.portfolioFinder.ownerNames(e ?? 1);
          if (t.data.status != de.Success)
            throw new Error(t.data.message);
          this.ownerParties.push(...t.data.names), this.lastOwnerNameCall = /* @__PURE__ */ new Date();
        });
      } finally {
        wh(!0), this.loadingOwnerNames = !1;
      }
    },
    async loadOwnerNamesFromProperty(e) {
      await this.refreshOwnerNamesFromProperty(e);
    },
    async refreshOwnerNamesFromProperty(e) {
      try {
        await g2.limit(async () => {
          if (this.lastOwnerNameCall && Zv(this.lastOwnerNameCall) < 30)
            return;
          this.loadingOwnerNames = !0, this.propertyOwnerNames.length = 0;
          const t = await W.api.homes.getOwnerNames(e ?? 1);
          if (t.data.status != de.Success)
            throw new Error(t.data.message);
          this.propertyOwnerNames.push(...t.data.names), this.lastOwnerNameCall = /* @__PURE__ */ new Date();
        });
      } finally {
        wh(!0), this.loadingOwnerNames = !1;
      }
    },
    async loadOwner(e) {
      this.ownerLoading = !0;
      let t = !1;
      try {
        const s = await W.api.portfolioFinder.getOwner(e);
        if (s.data.status != de.Success)
          throw new Le(s);
        t = !0, this.owner = s.data.owner;
        const n = await zW(`${this.owner.address} ${this.owner.city}, ${this.owner.state} ${this.owner.zip}`);
        if (n) {
          this.propertyLocationsBounds ?? (this.propertyLocationsBounds = new google.maps.LatLngBounds()), this.propertyLocationsBounds.extend(n);
          const r = new google.maps.marker.PinElement({
            //   glyphColor: '#b5abda',
            //   background: '#8e7cc3',
            //   borderColor: '#8e7cc3',
          }).element;
          this.propertyLocations.push({
            position: n,
            title: `Mailing Address\r
${this.owner.address}\r
${this.owner.city}, ${this.owner.state} ${this.owner.zip}`,
            content: r,
            zIndex: 1
          });
        }
      } finally {
        iy(t), this.ownerLoading = !1;
      }
    },
    async refreshOwnerContacts() {
      var e, t;
      try {
        this.contactsLoading = !0, this.leadContacts.length = 0;
        const s = await W.api.portfolioFinder.getContacts(this.owner.id);
        if (((e = s.data) == null ? void 0 : e.status) != de.Success)
          throw new Error(s.data.message);
        (t = s.data) != null && t.contacts && this.leadContacts.push(...s.data.contacts), this.skipTraceStats = s.data.skipTrace;
      } finally {
        this.contactsLoading = !1;
      }
    },
    async refreshPropertyGroups() {
      var t;
      this.propertyTypes.length = 0;
      const e = await W.api.portfolioFinder.getPropertyTypes(this.owner.id);
      if (((t = e.data) == null ? void 0 : t.status) != de.Success)
        throw new Error(e.data.message);
      this.propertyTypes.push(...e.data.propertyTypes);
    },
    async getProperties(e, t, s, n) {
      var r;
      try {
        this.propertiesLoading = !0, this.properties.length = 0;
        const i = await W.api.portfolioFinder.getProperties(this.owner.id, e, t, s, n, this.owner.custom ? !0 : void 0);
        if (((r = i.data) == null ? void 0 : r.status) != de.Success)
          throw new Error(i.data.message);
        this.properties.push(...i.data.page), this.propertyFiltered = i.data.filtered, this.propertyTotal = i.data.total, this.propertyAbsenteeOwnedCount = i.data.absenteeOwnedCount, this.propertyHomesteadCount = i.data.homesteadCount;
      } finally {
        this.propertiesLoading = !1;
      }
    },
    async loadNextAgents() {
      var e;
      try {
        this.loadingAgents = !0, this.agentPage == 0 && (this.agents.length = 0), this.agentPage++;
        const t = await W.api.portfolioFinder.getAgents(this.owner.id, this.agentPage, this.agentPageSize);
        if (((e = t.data) == null ? void 0 : e.status) != de.Success)
          throw new Error(t.data.message);
        this.agents.push(...t.data.page), this.agentHasMore = this.agents.length < t.data.total;
      } finally {
        this.loadingAgents = !1;
      }
    },
    async loadPropertiesGeo(e) {
      this.propertyLocationsLoading = !0;
      try {
        const t = await W.api.portfolioFinder.getPropertiesGeo(e);
        this.propertyLocationsBounds ?? (this.propertyLocationsBounds = new google.maps.LatLngBounds());
        const s = t.data.properties.map((n) => {
          this.propertyLocationsBounds.extend({
            lat: n.latitude,
            lng: n.longitude
          });
          const r = new google.maps.marker.PinElement({
            glyphColor: "#b5abda",
            background: "#8e7cc3",
            borderColor: "#8e7cc3"
          }).element;
          return {
            position: {
              lat: n.latitude,
              lng: n.longitude
            },
            title: `${n.address}`,
            content: r,
            zIndex: -999999
          };
        });
        this.propertyLocations.push(...s);
      } finally {
        this.propertyLocationsLoading = !1;
      }
    },
    async createOwner(e) {
      console.log("portfolioFinder.createOwner");
      try {
        const t = this.selectedProperties.map((n) => n.id).filter((n) => n !== void 0);
        if (t.length == 0) return "";
        e.propertyIds = t;
        const s = await W.api.portfolioFinder.createOwner(e);
        if (s.data.status != de.Success)
          throw new Le(s);
        return this.properties = this.properties.filter((n) => !n.selected), s.data.ownerId ?? "";
      } catch (t) {
        throw jn(t), t;
      }
    },
    async assignOwner(e) {
      console.log("portfolioFinder.assignOwner");
      try {
        const t = this.selectedProperties.map((n) => n.id).filter((n) => n !== void 0);
        if (t.length == 0) return;
        e.propertyIds = t;
        const s = await W.api.portfolioFinder.assignOwner(e);
        if (s.data.status != de.Success)
          throw new Le(s);
        this.properties = this.properties.filter((n) => !n.selected);
      } catch (t) {
        throw jn(t), t;
      }
    }
    //async getSkipTraceHistory() {
    //   const resp = await rescoverApi.api.portfolioFinder.tracedContacts(this.owner!.id!);
    //   if (resp.data.status != RequestStatus.Success)
    //      throw new Exception(resp);
    //   this.traceHistory.length = 0;
    //   this.traceHistory.push(...resp.data.page!);
    //},
  }
});
function HW(e, t) {
  return e.reduce((s, n) => {
    const r = t(n);
    return s[r] = [...s[r] || [], n], s;
  }, {});
}
function UW(e, t) {
  const s = Object.entries(e), n = [];
  return s.forEach(([r, i]) => {
    n.push(t(r, i));
  }), n;
}
let Pg;
async function zW(e) {
  var n;
  let t = {
    address: e
  };
  if (Pg = new google.maps.Geocoder(), !Pg) {
    console.error("geocoder is undefined");
    return;
  }
  const s = await Pg.geocode(t);
  if ((((n = s.results) == null ? void 0 : n.length) ?? 0) > 0)
    return s.results[0].geometry.location;
  console.error("Geocode was not successful", s);
}
const wk = new Na(2 * 1e3, "refreshPortfolio");
wk.Debug = !0;
let Ch, b2 = new Promise((e) => Ch = e);
const ba = _r("portfolioInsights", {
  state: () => ({
    portfolios: [],
    portfoliosPage: 1,
    portfoliosPageSize: 25,
    totalPortfolios: 0,
    portfolioLoaded: Ki(b2),
    portfolioId: void 0,
    portfolioName: void 0,
    portfolioOwner: void 0,
    portfolioSummary: void 0,
    financialOverview: [],
    financialIndicators: [],
    hasMultiple: void 0,
    clientsInfo: [],
    showDeleted: !1,
    properties: [],
    portfolioInsightsErrorMessage: void 0,
    isActive: void 0,
    currentLease: void 0,
    runningTasks: 0
  }),
  getters: {
    hasAssets() {
      var e;
      return ((e = this.portfolioSummary) == null ? void 0 : e.assets) > 0 || this.properties.length > 0;
    },
    portfoliosLoading() {
      return this.runningTasks > 0;
    }
  },
  actions: {
    reset() {
      b2 = new Promise((e) => Ch = e), this.$reset();
    },
    async getPortfolios(e) {
      this.runningTasks++;
      try {
        this.portfolios.length = 0;
        const t = this.portfoliosPage > 1 ? this.portfoliosPage : void 0, s = this.portfoliosPageSize != 25 ? this.portfoliosPageSize : void 0, n = await W.api.portfolioInsights.getPortfolios(t, s, void 0, e);
        if (n.data.status != de.Success)
          throw new Le(n);
        this.portfolioOwner = n.data.owner, this.totalPortfolios = n.data.total, n.data.page && this.portfolios.push(...n.data.page);
      } finally {
        this.runningTasks--;
      }
    },
    async loadPortfolio(e, t = !1) {
      try {
        this.runningTasks++, e && (this.portfolioId = e), await this.refreshPortfolio(t);
      } finally {
        this.runningTasks--;
      }
    },
    async refreshPortfolio(e = !1) {
      await wk.limit(async () => {
        var t, s;
        if (this.runningTasks++, this.portfolioId) {
          const n = await W.api.portfolioInsights.getPortfolio(this.portfolioId, e);
          if (n.data.status != de.Success)
            throw new Le(n);
          if (this.portfolioName = n.data.name, this.clientName = ((t = n.data.owner) == null ? void 0 : t.name) ?? void 0, this.portfolioOwner = n.data.owner, this.portfolioSummary = n.data.portfolioSummary, this.hasMultiple = n.data.multiple, !e) {
            this.financialIndicators.length = 0, n.data.financialIndicators && this.financialIndicators.push(...n.data.financialIndicators), n.data.financialOverview && (this.financialOverview = n.data.financialOverview), this.clientsInfo.length = 0, (s = this.clientsInfo) == null || s.push(...n.data.members);
            const r = await W.api.portfolioInsights.getPortfolioProperties(this.portfolioId, this.showDeleted ? this.showDeleted : void 0);
            if (r.data.status != de.Success)
              throw new Le(r);
            this.properties = r.data.properties;
          }
        } else
          this.portfolioInsightsErrorMessage = "Portfolio Id missing";
      }).finally(() => {
        Ch && Ch(!0), this.runningTasks--;
      });
    },
    async getPortfolioProperty(e) {
      try {
        if (this.runningTasks++, this.portfolioId) {
          const t = await W.api.portfolioInsights.getPortfolioProperty(this.portfolioId, e);
          if (t.data.status != de.Success)
            throw new Le(t);
          this.currentLease = t.data.lease, this.isActive = t.data.isActive;
        }
      } finally {
        this.runningTasks--;
      }
    },
    clearCurrentPortfolio() {
      this.portfolioOwner = void 0, this.portfolioId = void 0, this.portfolioName = void 0, this.clientName = void 0, this.portfolioSummary = void 0, this.hasMultiple = void 0, this.financialIndicators.length = 0, this.financialOverview.length = 0, this.clientsInfo.length = 0, this.properties.length = 0;
    }
  }
}), WW = new xa(), vn = _r("subscription", () => {
  const e = Ds(), t = Ds(), s = Ds(!1), n = Ds(), r = Ds([]), i = Ds(), o = Ds(Qt.Monthly), l = Ds(), d = Ds([]), c = Ds(!0), u = Ds([]), m = Ds(), f = Ds(), v = Ds(), b = Ds(0), w = Ds(), S = Ds(), I = Ds(), T = Ke(() => r.value.map((Be) => Be.qty)), x = Ke(() => {
    var Be;
    return ((((Be = n.value) == null ? void 0 : Be.billingPeriods) ?? Qt.None) & Qt.Monthly) == Qt.Monthly;
  }), k = Ke(() => {
    var Be;
    return ((((Be = n.value) == null ? void 0 : Be.billingPeriods) ?? Qt.None) & Qt.Annually) == Qt.Annually;
  }), C = Ke(() => o.value == Qt.Annually), O = Ke(() => r.value.filter((Be) => Be.mainProduct && Be.billingPeriod == Qt.Monthly).sort((Be, Ye) => Be.price - Ye.price) ?? []), E = Ke(() => r.value.filter((Be) => Be.billingPeriod == Qt.Monthly && Be.qty && Be.qty > 0).reduce((Be, Ye) => Be + yo(Ye, r.value, o.value, "", !0), 0)), B = Ke(() => {
    const Be = E.value - Me.value;
    return b.value >= 0 && Be < 0 ? 0 : Be;
  }), M = Ke(() => {
    const Be = E.value - Me.value;
    return Be < 0 ? 0 : Be * 12;
  }), R = Ke(() => {
    var Be;
    return (Be = r.value) == null ? void 0 : Be.filter((Ye) => Ye.billingPeriod == Qt.Annually && Ye.qty && Ye.qty > 0).reduce((Ye, Je) => Ye + yo(Je, r.value, o.value, "", !0), 0);
  }), F = Ke(() => (b.value >= 0, R.value - he.value)), L = Ke(() => {
    var Be;
    return (Be = r.value) == null ? void 0 : Be.filter((Ye) => Ye.qty && Ye.qty > 0).sort((Ye, Je) => Ye.order - Je.order);
  }), j = Ke(() => {
    var Be;
    return (Be = r.value) == null ? void 0 : Be.filter((Ye) => Ye.billingPeriod == o.value && !Ye.addOn && Ye.qty && Ye.qty > 0).sort((Ye, Je) => Ye.order - Je.order);
  }), H = Ke(() => {
    var Be;
    return (Be = r.value) == null ? void 0 : Be.filter((Ye) => Ye.addOn && (Ye.billingPeriod == o.value || Ye.requiredBillingPeriod) && !gs(Ye)).sort((Ye, Je) => Ye.order - Je.order);
  }), te = Ke(() => {
    var Ye, Je;
    const Be = (Ye = r.value) == null ? void 0 : Ye.filter((At) => At.billingPeriod == o.value && !At.addOn && At.qty && At.qty > 0 && At.includes && At.includes.length > 0);
    return (Je = r.value) == null ? void 0 : Je.filter((At) => At.billingPeriod == o.value && At.addOn && (At.qty && At.qty > 0 || Be.some((Tt) => {
      var Yt;
      return (Yt = Tt.includes) == null ? void 0 : Yt.some((bs) => bs.includesId == At.billingPeriodMainId);
    }))).sort((At, Tt) => At.order - Tt.order);
  }), re = Ke(() => {
    var Be;
    return (Be = H.value) == null ? void 0 : Be.filter((Ye) => {
      var Yt, bs;
      const Je = (Yt = r.value) == null ? void 0 : Yt.find((us) => us.id == Ye.billingPeriodMainId), At = (((bs = Je == null ? void 0 : Je.requires) == null ? void 0 : bs.length) ?? 0) > 0, Tt = r.value.filter((us) => {
        var Nt;
        return ((Nt = Je == null ? void 0 : Je.requires) == null ? void 0 : Nt.some((Gs) => Gs == us.id)) == !0 && !us.addOn && us.qty && us.qty > 0;
      }).length > 0;
      return !At || Tt;
    }).sort((Ye, Je) => Ye.order - Je.order);
  }), le = Ke(() => b.value >= 0 && d.value.length > 0 ? d.value.filter((Be) => Be.withDiscount == !0) : []), ie = Ke(() => b.value >= 0 && d.value.length > 0 ? d.value.filter((Be) => Be.withDiscount != !0) : []), ye = Ke(() => {
    var Be, Ye;
    if (!(l.value == null || mt.value && !s.value))
      for (const Je of l.value)
        switch (Je.type) {
          case "quantity": {
            const At = Vn(Je.coupons), Tt = (Be = r.value) == null ? void 0 : Be.filter((Yt) => {
              var bs;
              return Yt.billingPeriod == o.value && Yt.qty && Yt.qty > 0 && yo(Yt, r.value, o.value, At) > 0 && ((bs = Je.productIds) == null ? void 0 : bs.some((us) => us == Yt.billingPeriodMainId));
            }).length;
            return (Ye = Je.coupons) == null ? void 0 : Ye.find((Yt) => Yt.qty == Tt);
          }
        }
  }), Y = Ke(() => {
    if (b.value >= 0 && ye.value) {
      const Be = [ye.value, ...le.value], Ye = Vn(Be);
      return io(Ye, ye.value, Qt.Annually);
    }
    return 0;
  }), ae = Ke(() => {
    if (b.value >= 0 && ye.value) {
      const Be = [ye.value, ...le.value], Ye = Vn(Be);
      return io(Ye, ye.value, Qt.Monthly);
    }
    return 0;
  }), ke = Ke(() => {
    if (b.value >= 0 && d.value.length > 0) {
      const Be = Vn(d.value);
      return d.value.reduce((Ye, Je) => Ye + io(Be, Je, Qt.Annually), 0);
    }
    return 0;
  }), ue = Ke(() => {
    if (b.value >= 0 && ie.value.length > 0) {
      const Be = Vn(ie.value);
      return ie.value.reduce((Ye, Je) => Ye + io(Be, Je, Qt.Annually), 0);
    }
    return 0;
  }), oe = Ke(() => {
    if (b.value >= 0 && le.value.length > 0) {
      const Be = [...le.value];
      ye.value && Be.push(ye.value);
      const Ye = Vn(Be);
      return le.value.reduce((Je, At) => Je + io(Ye, At, Qt.Annually), 0);
    }
    return 0;
  }), fe = Ke(() => {
    if (d.value.length > 0) {
      const Be = Vn(d.value);
      return d.value.reduce((Ye, Je) => Ye + io(Be, Je, Qt.Monthly), 0);
    }
    return 0;
  }), we = Ke(() => {
    if (ie.value.length > 0) {
      const Be = Vn(ie.value);
      return ie.value.reduce((Ye, Je) => Ye + io(Be, Je, Qt.Monthly), 0);
    }
    return 0;
  }), Ie = Ke(() => {
    if (le.value.length > 0) {
      const Be = [...le.value];
      ye.value && Be.push(ye.value);
      const Ye = Vn(Be);
      return le.value.reduce((Je, At) => Je + io(Ye, At, Qt.Monthly), 0);
    }
    return 0;
  }), be = Ke(() => b.value >= 0 && C.value ? Y.value <= 0 || ue.value > Y.value : ae.value <= 0 || we.value > ae.value), Oe = Ke(() => be.value ? d.value : ye.value ? [ye.value, ...le.value] : le.value), ze = Ke(() => d.value.some((Be) => Be.durationType == Rf.Once)), Re = Ke(() => d.value.some((Be) => Be.durationType == Rf.Repeating)), ge = Ke(() => {
    var Be;
    return ((Be = d.value.find((Ye) => Ye.durationType == Rf.Repeating)) == null ? void 0 : Be.duration) ?? void 0;
  }), he = Ke(() => b.value >= 0 && !be.value ? Y.value + oe.value : ke.value), Me = Ke(() => b.value >= 0 && !be.value ? ae.value + Ie.value : fe.value), Ne = Ke(() => M.value - F.value), $e = Ke(() => {
    const Be = E.value - Me.value;
    return Be < 0 ? 0 : Be;
  }), mt = Ke(() => (t.value ?? 0) > 0), yt = Ke(() => [...new Set(r.value.filter((Be) => (Be.qty ?? 0) > 0).map((Be) => Be.billingPeriodMainId))]);
  async function Ct(Be) {
    var Ye;
    try {
      c.value = !0;
      const Je = await W.api.billingProductGroups.getProductGroup(Be ?? "default");
      if (Je.data.status != de.Success)
        throw new Le(Je);
      return e.value = Be ?? "default", n.value = Je.data.group, r.value = Je.data.products, i.value = Je.data.groups, l.value = Je.data.discounts, d.value = Je.data.appliedDiscounts ?? [], o.value = ((Ye = Je.data.group) == null ? void 0 : Ye.defaultBillingPeriod) ?? o.value, Je.data.user;
    } catch (Je) {
      throw console.error("loadProductGroup", Je), Je;
    } finally {
      c.value = !1;
    }
  }
  async function gt(Be) {
    var Ye;
    try {
      c.value = !0;
      const Je = new URLSearchParams(window.location.search), At = await W.api.subscriptions.getSubscription(Be, Je.get("o") ?? void 0);
      if (At.data.status != de.Success)
        throw new Le(At);
      return t.value = Be, n.value = At.data.group, r.value = At.data.products, i.value = At.data.groups, l.value = At.data.discounts, d.value = At.data.appliedDiscounts ?? [], o.value = ((Ye = At.data.group) == null ? void 0 : Ye.defaultBillingPeriod) ?? o.value, w.value = At.data.defaultPaymentMethod ?? void 0, At.data.user;
    } catch (Je) {
      throw console.error("loadSubscription", Je), Je;
    } finally {
      c.value = !1;
    }
  }
  async function Ge() {
    try {
      c.value = !0;
      const Be = await W.api.subscriptions.getSubscriptions();
      if (Be.data.status != de.Success)
        throw new Le(Be);
      m.value = Be.data.courtesyOf, f.value = Be.data.isClientAccount ?? void 0, v.value = Be.data.isSubAccount ?? void 0, u.value.length = 0, Be.data.subscriptions && u.value.push(...Be.data.subscriptions);
    } catch (Be) {
      throw console.error("loadSubscriptions", Be), Be;
    } finally {
      c.value = !1;
    }
  }
  async function Ee(Be) {
    return (await W.api.user.createEmailValidation(Be)).data.status == de.Success;
  }
  async function Ce(Be, Ye) {
    const Je = await W.api.user.validateEmail(Be, Ye);
    if (Je.data.status != de.Success)
      throw new Le(Je);
    return Je.data;
  }
  async function xe(Be, Ye, Je) {
    const At = await W.api.billingProductGroups.subscribeGroup(e.value, {
      confirmationToken: Be,
      couponCodes: d.value.filter((Tt) => Tt.code && (Tt.id ?? 0) <= 0).map((Tt) => Tt.code),
      couponIds: d.value.filter((Tt) => Tt.id && Tt.id > 0).map((Tt) => Tt.id),
      client: {
        firstName: Je.firstName,
        lastName: Je.lastName,
        phone: Je.phone,
        email: Ye
      },
      address: {
        line1: Je.address.line1,
        line2: Je.address.line2,
        city: Je.address.city,
        state: Je.address.state,
        postalCode: Je.address.postal_code,
        country: Je.address.country
      },
      billingPeriod: o.value,
      products: r.value
    });
    if (At.data.status != de.Success)
      throw new Le(At);
    return At.data;
  }
  async function Pe() {
    I.value ?? (I.value = /* @__PURE__ */ new Date());
    const Be = await W.api.subscriptions.previewUpdate(t.value, {
      //confirmationToken: confirmationTokenId,
      couponCodes: d.value.filter((Ye) => Ye.code && (Ye.id ?? 0) <= 0).map((Ye) => Ye.code),
      couponIds: d.value.filter((Ye) => Ye.id && Ye.id > 0).map((Ye) => Ye.id),
      prorationDate: I.value,
      //client: {
      //   firstName: value.firstName,
      //   lastName: value.lastName,
      //   phone: value.phone,
      //   email: email
      //},
      //address: {
      //   line1: value.address.line1,
      //   line2: value.address.line2,
      //   city: value.address.city,
      //   state: value.address.state,
      //   postalCode: value.address.postal_code,
      //   country: value.address.country
      //},
      billingPeriod: o.value,
      products: r.value
    });
    if (Be.data.status != de.Success)
      throw new Le(Be);
    S.value = {
      subtotal: Be.data.subtotalExcludingTax ?? 0,
      total: Be.data.total ?? 0,
      due: Be.data.amountDue ?? 0,
      lines: Be.data.lines,
      credits: Be.data.credits ?? void 0,
      appliedBalance: Be.data.appliedBalance ?? void 0
    };
  }
  async function it(Be) {
    I.value ?? (I.value = /* @__PURE__ */ new Date());
    const Ye = await W.api.subscriptions.updateSubscription(t.value, {
      confirmationToken: Be,
      couponCodes: d.value.filter((Je) => Je.code && (Je.id ?? 0) <= 0).map((Je) => Je.code),
      couponIds: d.value.filter((Je) => Je.id && Je.id > 0).map((Je) => Je.id),
      prorationDate: I.value,
      //client: {
      //   firstName: value.firstName,
      //   lastName: value.lastName,
      //   phone: value.phone,
      //   email: email
      //},
      //address: {
      //   line1: value.address.line1,
      //   line2: value.address.line2,
      //   city: value.address.city,
      //   state: value.address.state,
      //   postalCode: value.address.postal_code,
      //   country: value.address.country
      //},
      billingPeriod: o.value,
      products: r.value
    });
    if (Ye.data.status != de.Success)
      throw new Le(Ye);
  }
  function lt(Be) {
    r.value.filter((Ye) => [...yt.value, (Be == null ? void 0 : Be.id) ?? -123].some((Je) => Je == Ye.billingPeriodMainId)).forEach((Ye) => {
      var Je;
      (Je = Ye.includes) == null || Je.forEach((At) => {
        var Tt = r.value.find((us) => us.id == At.includesId);
        if (Tt != null && Tt.optionId) {
          if (r.value.some((Nt) => Nt.optionId == Tt.optionId && (Nt.qty ?? 0) > 0) && (Be == null ? void 0 : Be.qty) == 0) {
            var Yt = r.value.find((Nt) => Nt.optionId == Tt.optionId && Nt.mainProduct && Nt.recommended === !0);
            if (Yt) {
              r.value.filter((Nt) => Nt.optionId == Tt.optionId).forEach((Nt) => Nt.qty = 0), r.value.filter((Nt) => Nt.billingPeriodMainId == (Yt == null ? void 0 : Yt.billingPeriodMainId)).forEach((Nt) => Nt.qty = 1), dt(Yt);
              return;
            }
          }
          r.value.filter((Nt) => Nt.optionId == Tt.optionId && Nt.order < ((Tt == null ? void 0 : Tt.order) ?? 0)).forEach((Nt) => Nt.qty = 0);
          var bs = r.value.find((Nt) => Nt.optionId == Tt.optionId && Nt.order > ((Tt == null ? void 0 : Tt.order) ?? 0) && Nt.qty > 0);
          bs || (r.value.filter((Nt) => Nt.billingPeriodMainId == Tt.billingPeriodMainId).forEach((Nt) => Nt.qty = 1), dt(Tt));
        }
      });
    });
  }
  function dt(Be) {
    r.value.filter((Ye) => {
      var Je;
      return ((Je = Ye.incompatible) == null ? void 0 : Je.some((At) => At == Be.billingPeriodMainId)) == !0;
    }).forEach((Ye) => Ye.qty = 0);
  }
  function vt(Be, Ye) {
    if (!Be) return 0;
    const Je = Ye ? "" : Vn(Oe.value);
    return yo(Be, r.value, o.value, Je, Ye);
  }
  function It(Be) {
    return GW(Be, r.value, o.value);
  }
  function Dt(Be) {
    return YW(Be, r.value, o.value);
  }
  function ht(Be) {
    return r.value.find((Ye) => Ye.id == Be.billingPeriodMainId);
  }
  function _t(Be) {
    var Ye;
    return ((Ye = ht(Be)) == null ? void 0 : Ye.billingPeriod) == o.value;
  }
  function fs(Be) {
    var Je;
    const Ye = Vn(Oe.value);
    if (((Je = ht(Be)) == null ? void 0 : Je.billingPeriod) == o.value)
      return yo(Be, r.value, o.value, Ye);
    switch (o.value) {
      case Qt.Annually:
        return yo(Be, r.value, o.value, Ye) / 12;
    }
    return yo(Be, r.value, o.value, Ye);
  }
  function Hs(Be) {
    return cb(Be, r.value, o.value);
  }
  function Fs(Be) {
    switch (Be == null ? void 0 : Be.billingPeriod) {
      case Qt.Monthly:
        return "mo";
      case Qt.Annually:
        return "yr";
    }
  }
  async function Ts(Be) {
    try {
      const Ye = await W.api.billing.validateCoupon(Be);
      if (Ye.data.status != de.Success)
        throw new Error(Ye.data.message);
      d.value.push(Ye.data.coupon);
    } catch {
    }
  }
  function Ps(Be) {
    d.value = d.value.filter((Ye) => Ye.id != Be);
  }
  function Bs(Be) {
    var Ye;
    if (((Ye = ht(Be)) == null ? void 0 : Ye.billingPeriod) == o.value)
      return Be.price;
    switch (o.value) {
      case Qt.Annually:
        return Be.price / 12;
    }
    return Be.price;
  }
  function qt(Be) {
    return qW(R.value, Be, [...j.value, ...te.value]);
  }
  function Os(Be, Ye) {
    const Je = Vn(Be);
    return io(Je, Ye, o.value);
  }
  function Ms() {
    if (s.value = !s.value, s.value == !0) {
      const Be = d.value.filter((Ye) => {
        var Je;
        return (Je = l.value) == null ? void 0 : Je.some((At) => {
          var Tt;
          return (Tt = At.coupons) == null ? void 0 : Tt.some((Yt) => Yt.id == Ye.id);
        });
      });
      Be.length > 0 && (d.value = d.value.filter((Ye) => Be.some((Je) => Je.id == Ye.id) == !1), b.value++);
    }
  }
  async function ts() {
    await WW.runExclusive(() => {
      var Je;
      KW(), ZW();
      const Be = [];
      A2(r.value, d.value), Be.push(...d.value.map((At) => At.id)), (((Je = l.value) == null ? void 0 : Je.flatMap((At) => At.coupons)) ?? []).forEach((At) => {
        if (Be.some((Tt) => Tt == At.id) == !1) {
          const Tt = [At, ...le.value];
          A2(r.value, Tt), Be.push(...Tt.map((Yt) => Yt.id));
        } else
          console.warn("Coupon attempted twice!");
      });
    }), b.value++;
  }
  function gs(Be) {
    return Be.archived == !0 && (!Be.qty || Be.qty == 0);
  }
  Jn(T, () => {
    ts().then(() => {
      b.value++;
    });
  }), Jn(d, () => {
    ts().then(() => {
      b.value++;
    });
  }, { deep: !0 });
  function xs() {
    e.value = void 0, t.value = void 0, s.value = !1, n.value = void 0, r.value = [], i.value = void 0, o.value = Qt.Monthly, l.value = void 0, d.value = [], c.value = !0, u.value = [], m.value = void 0, f.value = void 0, v.value = void 0, b.value = 0, w.value = void 0, S.value = void 0, I.value = void 0;
  }
  return {
    groupPath: e,
    subscriptionId: t,
    managingSubscription: s,
    productGroup: n,
    products: r,
    productGroupings: i,
    chosenBillingPeriod: o,
    discounts: l,
    userAppliedCoupons: d,
    loading: c,
    subscriptions: u,
    courtesyOf: m,
    isClientAccount: f,
    isSubAccount: v,
    cacheBuster: b,
    defaultPaymentMethod: w,
    subPreview: S,
    //Computed
    hasMonthly: x,
    hasAnnually: k,
    isAnnually: C,
    mainProducts: O,
    monthlySubTotal: E,
    monthlyTotal: B,
    monthlyAnnualTotal: M,
    annualSubTotal: R,
    annualTotal: F,
    selectedProdcutsAll: L,
    selectedProdcuts: j,
    addOns: H,
    selectedAddOns: te,
    selectableAddOns: re,
    automaticDiscount: ye,
    automaticDiscountAnnualAmount: Y,
    automaticDiscountMonthlyAmount: ae,
    appliedCouponsAnnualAmount: ke,
    appliedCouponsMonthlyAmount: fe,
    appliedCouponsBetter: be,
    currentDiscounts: Oe,
    isCurrentDiscountsOnce: ze,
    isCurrentDiscountsRepeating: Re,
    currentDiscountsDuration: ge,
    activeDiscountAnnualAmount: he,
    activeDiscountMonthlyAmount: Me,
    billingPeriodSavings: Ne,
    firstMonthTotal: $e,
    existingSubscription: mt,
    compatibleUserCoupons: le,
    compatibleUserCouponsAnnualAmount: oe,
    compatibleUserCouponsMonthlyAmount: Ie,
    nonCompatibleUserCoupons: ie,
    nonCompatibleUserCouponsAnnualAmount: ue,
    nonCompatibleUserCouponsMonthlyAmount: we,
    //Actions
    $reset: xs,
    loadProductGroup: Ct,
    loadSubscription: gt,
    loadSubscriptions: Ge,
    createEmailValidation: Ee,
    validateEmail: Ce,
    subscribeGroup: xe,
    preview: Pe,
    productPrice: vt,
    isIncluded: It,
    includedWith: Dt,
    mainBillingPeriodProduct: ht,
    isMainBillingPeriod: _t,
    monthlyProductPrice: fs,
    includesQty: Hs,
    billFreq: Fs,
    applyCoupon: Ts,
    removeCoupon: Ps,
    optionPrice: Bs,
    discountAnnualAmount: qt,
    getDiscountPrice: Os,
    toggleManageSubscription: Ms,
    updateSubscription: it,
    applyProductIncludes: lt,
    removeIncompatible: dt,
    isArchivedDisabled: gs,
    calculatePricesAndDiscounts: ts
  };
});
function GW(e, t, s) {
  return cb(e, t, s) > 0;
}
function yo(e, t, s, n, r) {
  const i = cb(e, t, s), o = r ? e.price ?? 0 : mo(e, n);
  if (i > 0) {
    let l = o * e.qty - i * o;
    return e.addOn && (l = o * (e.qty + i) - i * o), l < 0 ? 0 : l;
  }
  return e.tiers ? XW(e) : o * e.qty;
}
function cb(e, t, s) {
  if (!t) return 0;
  const n = t.filter((o) => {
    var l;
    return o.billingPeriod == s && !o.addOn && o.qty && o.qty > 0 && ((l = o.includes) == null ? void 0 : l.some((d) => d.includesId == e.billingPeriodMainId)) == !0;
  }).map((o) => o.includes);
  if (n.length == 0) return 0;
  const i = (n.reduce((o, l) => o.concat(l)) ?? []).filter((o) => o.qty && o.qty > 0 && o.includesId == e.billingPeriodMainId);
  return i && (i == null ? void 0 : i.length) > 0 ? i.map((o) => o.qty).reduce((o, l) => o + l) : 0;
}
function YW(e, t, s) {
  if (t)
    return t.filter((n) => {
      var r;
      return n.billingPeriod == s && !n.addOn && n.qty && n.qty > 0 && ((r = n.includes) == null ? void 0 : r.some((i) => i.includesId == e.billingPeriodMainId)) == !0;
    }).sort((n, r) => r.price - n.price).find(() => !0);
}
function XW(e) {
  var r;
  let t = e.qty, s = 0, n = 0;
  (r = e.tiers) == null || r.sort((i, o) => (i.upTo ?? 1e4) - (o.upTo ?? 1e4));
  for (const i of e.tiers)
    if (t > (i.upTo ?? 1e4) ? (n = i.upTo ?? 1e4, t -= i.upTo ?? 1e4) : t <= (i.upTo ?? 1e4) && (n = t, t = 0), i.flat == !0 ? s += i.amount ?? 0 : s += (i.amount ?? 0) * n, t == 0)
      break;
  return s;
}
function qW(e, t, s) {
  if (t.type == Kc.Amount) {
    if (t.appliesTo) {
      let n = 0;
      for (const r of s)
        t.appliesTo.find((o) => o == r.productId) && (n += t.value);
      return n;
    }
    return t.value;
  }
  if (t.type == Kc.Percent) {
    if (t.appliesTo) {
      let n = 0;
      for (const r of s)
        t.appliesTo.find((o) => o == r.productId) && (n += t.value * r.price);
      return n;
    }
    return t.value * e;
  }
  return 0;
}
function Vn(e) {
  return e.map((t) => t.id).sort().join(":");
}
function A2(e, t) {
  const s = Vn(t);
  for (const n of t)
    QW(n, e, s);
}
function QW(e, t, s) {
  const n = {};
  n[`${Qt.Annually}`] = 0, n[`${Qt.Monthly}`] = 0, e.type == Kc.Amount && (n[`${Qt.Annually}`] = e.value ?? 0, n[`${Qt.Monthly}`] = e.value ?? 0);
  for (const r of t) {
    const i = yo(r, t, r.billingPeriod, s);
    e.type == Kc.Amount ? e.appliesTo ? e.appliesTo.find((l) => l == r.productId) && (n[`${r.billingPeriod}`] > mo(r, s) ? ((r.qty ?? 0) > 0 && (Ml(s, e, r.billingPeriod, mo(r, s)), n[`${r.billingPeriod}`] -= mo(r, s)), Bl(r, s, 0)) : ((r.qty ?? 0) > 0 && (Ml(s, e, r.billingPeriod, n[`${r.billingPeriod}`]), n[`${r.billingPeriod}`] = 0), Bl(r, s, mo(r, s) - n[`${r.billingPeriod}`]))) : n[`${r.billingPeriod}`] > mo(r, s) ? ((r.qty ?? 0) > 0 && (Ml(s, e, r.billingPeriod, mo(r, s)), n[`${r.billingPeriod}`] -= mo(r, s)), Bl(r, s, 0)) : ((r.qty ?? 0) > 0 && (Ml(s, e, r.billingPeriod, n[`${r.billingPeriod}`]), n[`${r.billingPeriod}`] = 0), Bl(r, s, mo(r, s) - n[`${r.billingPeriod}`])) : e.type == Kc.Percent && (e.appliesTo ? e.appliesTo.find((l) => l == r.productId) && ((r.qty ?? 0) > 0 && Ml(s, e, r.billingPeriod, e.value * i), Bl(r, s, i - e.value * i)) : ((r.qty ?? 0) > 0 && Ml(s, e, r.billingPeriod, e.value * i), Bl(r, s, i - e.value * i))), r.billingPeriod == 16 && r.qty > 0 && yo(r, t, r.billingPeriod, s), console.log("break");
  }
}
let ub = Ds({});
function KW() {
  ub.value = {};
}
function mo(e, t) {
  return ub.value[`${e.id}:${t}`] ?? e.price ?? 0;
}
function Bl(e, t, s) {
  ub.value[`${e.id}:${t}`] = s;
}
let Am = Ds({});
function ZW() {
  Am.value = {};
}
function io(e, t, s) {
  return Am.value[`${e}:${t.id}:${s}`] ?? 0;
}
function Ml(e, t, s, n, r) {
  var o;
  const i = `${e}:${t.id}:${s}`;
  (o = Am.value)[i] ?? (o[i] = 0), Am.value[i] += n;
}
const JW = me({
  name: "Pagination",
  props: {
    page: {
      type: Object,
      required: !0,
      default: 1
    },
    pageSize: {
      type: Object,
      default: 25
    },
    total: {
      type: Object,
      default: 0
    }
  },
  emits: [
    "change-page"
  ],
  computed: {
    canPrev() {
      return this.page > 1;
    },
    canNext() {
      return this.page < this.totalPages;
    },
    displayPages() {
      let e = this.page - 2;
      e < 1 && (e = 1);
      let t = this.page + 2;
      return t > this.totalPages && (t = this.totalPages), Array.from({ length: t - e + 1 }, (s, n) => e + n);
    },
    totalPages() {
      return this.total && this.total > 1 ? Math.ceil(this.total / this.pageSize) : 0;
    }
  },
  methods: {
    number: Ve,
    pageinateStyle(e) {
      return {
        "page-item": !0,
        active: e == this.page
      };
    },
    gotoPage(e) {
      this.$emit("change-page", e, this.pageSize);
    }
  }
}), $W = { "aria-label": "Page navigation" }, _W = { class: "pagination pagination-sm justify-content-center" }, eG = ["disabled"], tG = {
  key: 0,
  class: "page-item"
}, sG = ["onClick"], aG = {
  key: 1,
  class: "page-item"
}, nG = ["disabled"];
function rG(e, t, s, n, r, i) {
  return p(), h("nav", $W, [
    a("ul", _W, [
      a("li", {
        class: z(["page-item", { disabled: !e.canPrev }])
      }, [
        a("button", {
          class: "page-link",
          onClick: t[0] || (t[0] = (o) => e.gotoPage(this.page - 1)),
          disabled: !e.canPrev
        }, "Previous", 8, eG)
      ], 2),
      e.page - 2 > 1 ? (p(), h("li", tG, t[2] || (t[2] = [
        a("a", { class: "page-link" }, "...", -1)
      ]))) : P("", !0),
      (p(!0), h(A, null, D(e.displayPages, (o) => (p(), h("li", {
        class: z(e.pageinateStyle(o))
      }, [
        a("button", {
          onClick: (l) => e.gotoPage(o),
          class: "page-link"
        }, g(e.number(o)), 9, sG)
      ], 2))), 256)),
      e.page + 2 < e.totalPages ? (p(), h("li", aG, t[3] || (t[3] = [
        a("a", { class: "page-link" }, "...", -1)
      ]))) : P("", !0),
      a("li", {
        class: z(["page-item", { disabled: !e.canNext }])
      }, [
        a("button", {
          class: "page-link",
          onClick: t[1] || (t[1] = (o) => e.gotoPage(this.page + 1)),
          disabled: !e.canNext
        }, "Next", 8, nG)
      ], 2)
    ])
  ]);
}
const Ck = /* @__PURE__ */ Ae(JW, [["render", rG]]), oG = me({
  name: "BrandAdministrators",
  directives: {},
  props: {},
  components: {
    Pagination: Ck
  },
  data() {
    return {
      loadingAdmins: !0,
      admins: [],
      totalAdmins: 0,
      adminToAdd: {
        email: ""
      },
      busy: !1,
      currentPage: 1,
      pageSize: 25
    };
  },
  computed: {},
  watch: {},
  methods: {
    async loadBrandAdmins() {
      try {
        this.loadingAdmins = !0;
        const e = await W.api.brand.getBrandAdmins(this.currentPage, this.pageSize);
        if (e.data.status != de.Success)
          throw new Le(e);
        this.admins.length = 0, this.admins.push(...e.data.admins), this.totalAdmins = e.data.total ?? 0;
      } catch (e) {
        Se(e);
      }
      this.loadingAdmins = !1;
    },
    async addAdmin() {
      try {
        if (this.busy = !0, !this.adminToAdd.email)
          throw new Error("Invalid email");
        const e = await W.api.brand.addBrandAdmin(this.adminToAdd);
        if (e.data.status != de.Success)
          throw new Le(e);
        this.adminToAdd.email = "", wt("Brand admin added"), await this.loadBrandAdmins();
      } catch (e) {
        Se(e);
      }
      this.busy = !1;
    },
    async removeAdmin(e) {
      try {
        this.busy = !0;
        const t = await W.api.brand.removeBrandAdmin(e.id);
        if (t.data.status != de.Success)
          throw new Le(t);
        wt(`${e.name} removed as brand administrator successfully!`), await this.loadBrandAdmins();
      } catch (t) {
        Se(t);
      }
      this.busy = !1;
    },
    async gotoPage(e, t) {
      this.currentPage = e, await this.loadBrandAdmins();
    }
  },
  mounted() {
    this.loadBrandAdmins();
  }
}), iG = { class: "card shadow-sm mb-3" }, lG = { class: "card-body pt-0" }, dG = { class: "row" }, cG = { class: "col" }, uG = { class: "input-group" }, pG = { class: "col-lg-2 d-flex justify-content-end justify-content-lg-start align-items-lg-end" }, hG = ["disabled"], mG = {
  class: "card shadow-sm overflow-hidden",
  style: { "min-height": "200px" }
}, fG = {
  key: 0,
  class: "loads text-center d-flex flex-column justify-content-center align-items-center position-absolute w-100 h-100"
}, gG = { key: 1 }, vG = { class: "table mb-3" }, yG = ["onClick", "disabled"];
function bG(e, t, s, n, r, i) {
  const o = pe("pagination");
  return p(), h("div", null, [
    t[8] || (t[8] = a("h2", { class: "fw-bold fs-5" }, "Brand Administrators", -1)),
    a("div", iG, [
      t[4] || (t[4] = a("div", { class: "card-header d-flex justify-content-between align-items-center border-0 bg-white" }, [
        a("div", { class: "fw-bold fs-5" }, " Add Administrator ")
      ], -1)),
      a("div", lG, [
        a("div", dG, [
          a("div", cG, [
            t[3] || (t[3] = a("label", { class: "col-form-label" }, "Email", -1)),
            a("div", uG, [
              t[2] || (t[2] = a("span", {
                class: "input-group-text",
                id: "basic-addon1"
              }, [
                a("i", { class: "fa-light fa-envelope" })
              ], -1)),
              V(a("input", {
                type: "email",
                "onUpdate:modelValue": t[0] || (t[0] = (l) => e.adminToAdd.email = l),
                class: "form-control",
                "aria-label": "Username",
                "aria-describedby": "basic-addon1"
              }, null, 512), [
                [_e, e.adminToAdd.email]
              ])
            ])
          ]),
          a("div", pG, [
            a("button", {
              type: "button",
              onClick: t[1] || (t[1] = (...l) => e.addAdmin && e.addAdmin(...l)),
              disabled: e.busy,
              class: "btn btn-eclipse"
            }, "Add", 8, hG)
          ])
        ])
      ])
    ]),
    a("div", mG, [
      e.loadingAdmins ? (p(), h("div", fG, t[5] || (t[5] = [
        Bt('<svg class="loader" width="50" height="50" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 340 340"><circle cx="170" cy="170" r="160" stroke="#F26E34"></circle><circle cx="170" cy="170" r="135" stroke="#132844"></circle><circle cx="170" cy="170" r="110" stroke="#F26E34"></circle><circle cx="170" cy="170" r="85" stroke="#132844"></circle></svg><br><span class="fw-bold h5 mb-0"> Loading... </span>', 3)
      ]))) : (p(), h("div", gG, [
        a("table", vG, [
          t[7] || (t[7] = a("thead", null, [
            a("tr", null, [
              a("th", null, " Name "),
              a("th", null, " Email "),
              a("th")
            ])
          ], -1)),
          a("tbody", null, [
            (p(!0), h(A, null, D(e.admins, (l) => (p(), h("tr", {
              key: l.id
            }, [
              a("td", null, g(l.name), 1),
              a("td", null, g(l.email), 1),
              a("td", null, [
                a("button", {
                  type: "button",
                  onClick: (d) => e.removeAdmin(l),
                  disabled: e.busy,
                  class: "btn btn-danger btn-sm"
                }, t[6] || (t[6] = [
                  a("i", { class: "fa-duotone fa-solid fa-link-slash me-2" }, null, -1),
                  y(" Remove")
                ]), 8, yG)
              ])
            ]))), 128))
          ])
        ]),
        N(o, {
          page: e.currentPage,
          "page-size": e.pageSize,
          total: e.totalAdmins,
          onChangePage: e.gotoPage
        }, null, 8, ["page", "page-size", "total", "onChangePage"])
      ]))
    ])
  ]);
}
const AG = /* @__PURE__ */ Ae(oG, [["render", bG]]), wG = me({
  name: "BrandMembers",
  directives: {},
  props: {},
  components: {
    Pagination: Ck
  },
  data() {
    return {
      loadingMembers: !0,
      members: [],
      totalMembers: 0,
      totalOffice: 0,
      memberToInvite: {
        name: "",
        email: ""
      },
      busy: !1,
      showSubAccount: !1,
      currentPage: 1,
      pageSize: 25,
      myBrand: void 0
    };
  },
  computed: {
    hasBrand() {
      return this.myBrand != null;
    }
  },
  watch: {
    async showSubAccount() {
      await this.loadBrandMembers();
    }
  },
  methods: {
    async loadBrandMembers() {
      try {
        this.loadingMembers = !0;
        const e = await W.api.brand.getBrandMembers(this.currentPage, this.pageSize, this.showSubAccount);
        if (e.data.status != de.Success)
          throw new Le(e);
        this.members.length = 0, this.members.push(...e.data.members), this.totalMembers = e.data.total ?? 0, this.totalOffice = e.data.totalOffice ?? 0;
      } catch (e) {
        Se(e);
      }
      this.loadingMembers = !1;
    },
    async inviteMember() {
      try {
        this.busy = !0;
        const e = await W.api.brand.inviteBrandMember(this.memberToInvite);
        if (e.data.status != de.Success)
          throw new Le(e);
        this.memberToInvite.name = "", this.memberToInvite.email = "", wt("Member invited"), await this.loadBrandMembers();
      } catch (e) {
        Se(e);
      }
      this.busy = !1;
    },
    async unlinkMember(e) {
      try {
        this.busy = !0;
        const t = await W.api.brand.removeBrandMember(e.id);
        if (t.data.status != de.Success)
          throw new Le(t);
        wt("Member removed"), await this.loadBrandMembers();
      } catch (t) {
        Se(t);
      }
      this.busy = !1;
    },
    async resendMemberInvite(e) {
      try {
        this.busy = !0;
        const t = await W.api.brand.resendMemberInvite(e.id);
        if (t.data.status != de.Success)
          throw new Le(t);
        wt("Invite Resent");
      } catch (t) {
        Se(t);
      }
      this.busy = !1;
    },
    memberTypeStyle(e) {
      return {
        badge: !0,
        "text-bg-dark": e.type == "Parent",
        "text-bg-secondary": e.type == "Sub-Account"
      };
    },
    async gotoPage(e) {
      this.currentPage = e, await this.loadBrandMembers();
    },
    async getBrand() {
      try {
        const e = await W.api.brand.getBrandInfo();
        if (e.data.status != de.Success)
          throw new Le(e);
        this.myBrand = e.data.myBrand;
      } catch (e) {
        Se(e);
      }
    },
    async approveRequest(e) {
      try {
        this.busy = !0;
        const t = await W.api.brand.acceptUserRequest(e.id);
        if (t.data.status != de.Success)
          throw new Le(t);
        wt("Request Accepted"), await this.loadBrandMembers();
      } catch (t) {
        Se(t);
      }
      this.busy = !1;
    },
    async rejectRequest(e) {
      try {
        this.busy = !0;
        const t = await W.api.brand.rejectUserRequest(e.id);
        if (t.data.status != de.Success)
          throw new Le(t);
        wt("Request Rejected"), await this.loadBrandMembers();
      } catch (t) {
        Se(t);
      }
      this.busy = !1;
    }
  },
  created() {
  },
  mounted() {
    this.loadBrandMembers().then(async () => await this.getBrand());
  }
}), CG = { class: "card shadow-sm mb-3" }, SG = { class: "card-body pt-0" }, PG = { class: "row" }, kG = { class: "col-lg-4" }, EG = { class: "col-lg-4 mb-3 mb-lg-0" }, IG = { class: "input-group" }, TG = { class: "col-lg-4 d-flex justify-content-end justify-content-lg-start align-items-end" }, OG = ["disabled"], RG = {
  key: 0,
  class: "card shadow-sm mb-3"
}, LG = { class: "card-body pt-0" }, BG = { class: "bg-light rounded p-4 d-flex align-items-center flex-row" }, MG = { class: "m-0" }, xG = {
  class: "card shadow-sm overflow-hidden",
  style: { "min-height": "200px" }
}, FG = {
  key: 0,
  class: "loads text-center d-flex flex-column justify-content-center align-items-center position-absolute w-100 h-100"
}, VG = { key: 1 }, DG = { class: "card-header d-flex flex-column flex-lg-row justify-content-lg-between align-items-center" }, NG = { class: "d-flex justify-content-between justify-content-lg-start w-100 mb-2 mb-lg-0" }, jG = { class: "me-lg-4" }, HG = { class: "form-check form-switch form-check-reverse flex-shrink-0" }, UG = ["disabled"], zG = { class: "table mb-3" }, WG = {
  key: 0,
  class: "badge text-bg-warning"
}, GG = {
  key: 1,
  class: "badge text-bg-warning"
}, YG = {
  key: 2,
  class: "badge text-bg-success"
}, XG = ["onClick", "disabled"], qG = {
  key: 1,
  class: "d-flex flex-row justify-content-between"
}, QG = ["onClick", "disabled"], KG = ["onClick", "disabled"], ZG = ["onClick", "disabled"];
function JG(e, t, s, n, r, i) {
  var l;
  const o = pe("pagination");
  return p(), h(A, null, [
    t[16] || (t[16] = a("h2", { class: "fw-bold fs-5" }, "Network Members", -1)),
    t[17] || (t[17] = a("p", null, "Use this portal to manage members of your brand network. When you invite new members, if they are already a Rescover user, their account will be linked. If they are not a Rescover user, they will be given an invitation to join and link with the brand.", -1)),
    a("div", CG, [
      t[7] || (t[7] = a("div", { class: "card-header d-flex justify-content-between align-items-center border-0 bg-white" }, [
        a("div", { class: "fw-bold fs-5" }, " Invite Network Member ")
      ], -1)),
      a("div", SG, [
        a("div", PG, [
          a("div", kG, [
            t[4] || (t[4] = a("label", { class: "col-form-label" }, "Name", -1)),
            V(a("input", {
              type: "text",
              "onUpdate:modelValue": t[0] || (t[0] = (d) => e.memberToInvite.name = d),
              class: "form-control"
            }, null, 512), [
              [_e, e.memberToInvite.name]
            ])
          ]),
          a("div", EG, [
            t[6] || (t[6] = a("label", { class: "col-form-label" }, "Email", -1)),
            a("div", IG, [
              t[5] || (t[5] = a("span", {
                class: "input-group-text",
                id: "basic-addon1"
              }, [
                a("i", { class: "fa-light fa-envelope" })
              ], -1)),
              V(a("input", {
                type: "email",
                "onUpdate:modelValue": t[1] || (t[1] = (d) => e.memberToInvite.email = d),
                class: "form-control",
                "aria-label": "Username",
                "aria-describedby": "basic-addon1"
              }, null, 512), [
                [_e, e.memberToInvite.email]
              ])
            ])
          ]),
          a("div", TG, [
            a("button", {
              type: "button",
              onClick: t[2] || (t[2] = (...d) => e.inviteMember && e.inviteMember(...d)),
              disabled: e.busy,
              class: "btn btn-eclipse"
            }, "Invite", 8, OG)
          ])
        ])
      ])
    ]),
    (l = e.myBrand) != null && l.linkKey ? (p(), h("div", RG, [
      t[9] || (t[9] = a("div", { class: "card-header border-0 bg-white" }, [
        a("p", { class: "fw-bold fs-5" }, " Brand Linking Key "),
        a("p", { class: "mb-0" }, " This is your brand linking key code you need to provide your network members. ")
      ], -1)),
      a("div", LG, [
        a("div", BG, [
          t[8] || (t[8] = a("i", { class: "fa-light fa-key me-4 fs-4" }, null, -1)),
          a("pre", MG, [
            a("code", null, g(e.myBrand.linkKey), 1)
          ])
        ])
      ])
    ])) : P("", !0),
    a("div", xG, [
      e.loadingMembers ? (p(), h("div", FG, t[10] || (t[10] = [
        Bt('<svg class="loader" width="50" height="50" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 340 340"><circle cx="170" cy="170" r="160" stroke="#F26E34"></circle><circle cx="170" cy="170" r="135" stroke="#132844"></circle><circle cx="170" cy="170" r="110" stroke="#F26E34"></circle><circle cx="170" cy="170" r="85" stroke="#132844"></circle></svg><br><span class="fw-bold fs-5 mb-0"> Loading... </span>', 3)
      ]))) : (p(), h("div", VG, [
        a("div", DG, [
          a("div", NG, [
            a("span", jG, [
              t[11] || (t[11] = y("Total Office Accounts: ")),
              a("b", null, g(e.totalOffice), 1)
            ]),
            a("span", null, [
              t[12] || (t[12] = y("Total Users: ")),
              a("b", null, g(e.totalMembers), 1)
            ])
          ]),
          a("div", HG, [
            V(a("input", {
              class: "form-check-input",
              disabled: e.busy,
              type: "checkbox",
              role: "switch",
              "onUpdate:modelValue": t[3] || (t[3] = (d) => e.showSubAccount = d),
              id: "flexSwitchCheckDefault"
            }, null, 8, UG), [
              [Ue, e.showSubAccount]
            ]),
            t[13] || (t[13] = a("label", {
              class: "form-check-label",
              for: "flexSwitchCheckDefault"
            }, "Show Sub-Accounts", -1))
          ])
        ]),
        a("table", zG, [
          t[15] || (t[15] = a("thead", null, [
            a("tr", null, [
              a("th", null, " Office Name "),
              a("th", null, " Account Name "),
              a("th", null, " Email "),
              a("th", null, " Status "),
              a("th", null, " Type "),
              a("th")
            ])
          ], -1)),
          a("tbody", null, [
            (p(!0), h(A, null, D(e.members, (d) => (p(), h("tr", {
              key: d.id
            }, [
              a("td", null, [
                d.type == "Parent" ? (p(), h(A, { key: 0 }, [
                  y(g(d.company), 1)
                ], 64)) : P("", !0)
              ]),
              a("td", null, g(d.name), 1),
              a("td", null, g(d.email), 1),
              a("td", null, [
                d.type == "Request" ? (p(), h("span", WG, " Requested ")) : P("", !0),
                d.type == "Invite" ? (p(), h("span", GG, " Invited ")) : d.type == "Parent" ? (p(), h("span", YG, " Joined ")) : P("", !0)
              ]),
              a("td", null, [
                a("span", {
                  class: z(e.memberTypeStyle(d))
                }, g(d.type), 3)
              ]),
              a("td", null, [
                d.type == "Invite" ? (p(), h("button", {
                  key: 0,
                  type: "button",
                  onClick: (c) => e.resendMemberInvite(d),
                  disabled: e.busy,
                  class: "btn btn-success btn-sm"
                }, "Re-Send", 8, XG)) : d.type == "Request" ? (p(), h("div", qG, [
                  a("button", {
                    type: "button",
                    onClick: (c) => e.approveRequest(d),
                    disabled: e.busy,
                    class: "btn btn-success btn-sm"
                  }, "Approve", 8, QG),
                  a("button", {
                    type: "button",
                    onClick: (c) => e.rejectRequest(d),
                    disabled: e.busy,
                    class: "btn btn-danger btn-sm"
                  }, "Reject", 8, KG)
                ])) : d.type == "Parent" ? (p(), h("button", {
                  key: 2,
                  type: "button",
                  onClick: (c) => e.unlinkMember(d),
                  disabled: e.busy,
                  class: "btn btn-danger btn-sm"
                }, t[14] || (t[14] = [
                  a("i", { class: "fa-duotone fa-solid fa-link-slash me-2" }, null, -1),
                  y(" Remove")
                ]), 8, ZG)) : P("", !0)
              ])
            ]))), 128))
          ])
        ]),
        N(o, {
          total: e.totalMembers,
          page: e.currentPage,
          "page-size": e.pageSize,
          onChangePage: e.gotoPage
        }, null, 8, ["total", "page", "page-size", "onChangePage"])
      ]))
    ])
  ], 64);
}
const $G = /* @__PURE__ */ Ae(wG, [["render", JG]]), _G = me({
  name: "BrandIntegration",
  inject: {
    rscConfig: {
      from: Zd
    }
  },
  data() {
    return {
      widgetKey: void 0,
      cdnBase: `https://${this.rscConfig.CdnDomain}`,
      isPrivateKey: !1
    };
  },
  computed: {
    ...q(Te, ["access", "aclLoaded"])
  },
  watch: {},
  methods: {
    async loadInfo() {
      var t;
      try {
        var e = await W.api.account.info();
        if (e.data.status != de.Success)
          throw new Le(e);
        this.widgetKey = ((t = e.data.info) == null ? void 0 : t.widgetApiKey) ?? void 0;
      } catch (s) {
        Se(s);
      }
    }
  },
  created() {
  },
  mounted() {
    this.aclLoaded.then(async () => await this.loadInfo());
  }
}), eY = { class: "card shadow mb-3" }, tY = { class: "card-body" }, sY = {
  key: 0,
  class: "alert alert-warning"
}, aY = { class: "bg-light rounded p-4" }, nY = { class: "m-0" }, rY = { class: "card shadow mb-3" }, oY = { class: "card-header bg-white border-0 pb-0 d-flex justify-content-between align-items-center" }, iY = { class: "card-body" }, lY = { class: "bg-dark text-white rounded p-4" }, dY = { class: "bg-dark text-white rounded p-4" }, cY = {
  class: "modal fade",
  ref: "previewMarketplaceModal",
  id: "previewMarketplaceModal",
  tabindex: "-1",
  "aria-labelledby": "previewMarketplaceModalLabel",
  "aria-hidden": "true"
}, uY = { class: "modal-dialog modal-xl modal-dialog-centered" }, pY = { class: "modal-content bg-gradient-alphabet rounded" }, hY = {
  ref: "previewMarketplaceModalBody",
  class: "modal-body"
};
function mY(e, t, s, n, r, i) {
  return p(), h(A, null, [
    t[7] || (t[7] = a("h2", { class: "fw-bold fs-5" }, "Organization Marketplace Website Integration", -1)),
    a("div", eY, [
      t[2] || (t[2] = a("div", { class: "card-header bg-white border-0 py-3 fw-bold fs-5" }, " Access Keys ", -1)),
      a("div", tY, [
        e.isPrivateKey ? (p(), h("div", sY, t[0] || (t[0] = [
          a("i", { class: "fa-light fa-key me-2" }, null, -1),
          y("This key provide API access, keep it safe and secure. ")
        ]))) : P("", !0),
        a("div", aY, [
          t[1] || (t[1] = a("p", { class: "fw-bold" }, "Widget API Key:", -1)),
          a("pre", nY, [
            a("code", null, g(e.widgetKey), 1)
          ])
        ])
      ])
    ]),
    a("div", rY, [
      a("div", oY, [
        t[3] || (t[3] = a("div", null, [
          a("span", { class: "fw-bold fs-5" }, " Marketplace Website Widget "),
          a("br"),
          y(" Copy and paste this code where you want the Marketplace Widget appear on your site."),
          a("br"),
          y(" Help and documentation can be "),
          a("a", {
            href: "https://support.rescover.com/knowledge/idx-investment-gateway-website-integration",
            target: "_blank"
          }, "found here...")
        ], -1)),
        P("", !0)
      ]),
      a("div", iY, [
        t[4] || (t[4] = a("p", { class: "fw-bold fs-6 mb-2" }, "Slide Widget", -1)),
        a("pre", lY, [
          a("code", null, '<script src="' + g(e.cdnBase) + `/widgets/widgets-lib.min.js"><\/script>
<property-list api-key="` + g(e.widgetKey) + '" list-type="brand"></property-list>', 1)
        ]),
        t[5] || (t[5] = a("p", { class: "fw-bold fs-6 mb-2" }, "Tiled Widget", -1)),
        a("pre", dY, [
          a("code", null, '<script src="' + g(e.cdnBase) + `/widgets/widgets-lib.min.js"><\/script>
<property-list-tiled api-key="` + g(e.widgetKey) + '" list-type="brand"></property-list-tiled>', 1)
        ])
      ])
    ]),
    a("div", cY, [
      a("div", uY, [
        a("div", pY, [
          t[6] || (t[6] = a("div", { class: "modal-header border-0 pb-0" }, [
            a("span", {
              class: "fw-bold fs-5 modal-title",
              id: "previewMarketplaceModalLabel"
            }, "Marketplace"),
            a("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            })
          ], -1)),
          a("div", hY, null, 512)
        ])
      ])
    ], 512)
  ], 64);
}
const fY = /* @__PURE__ */ Ae(_G, [["render", mY]]), gY = me({
  name: "BrandPortal",
  inject: {
    rscConfig: {
      from: Zd
    }
  },
  components: {
    Administrators: AG,
    Members: $G,
    Integrations: fY
  },
  data() {
    return {
      cdnBase: `https://${this.rscConfig.CdnDomain}`
    };
  },
  computed: {
    ...q(Te, ["access"])
  }
}), vY = { class: "container py-4 py-lg-5" }, yY = { class: "row" }, bY = { class: "col-lg-3 mb-4 mb-lg-0" }, AY = {
  id: "sidebar",
  class: "nav flex-row flex-lg-column nav-pills",
  role: "tablist"
}, wY = {
  key: 0,
  type: "button",
  id: "network-tab",
  class: "nav-link mb-lg-2",
  "data-bs-toggle": "pill",
  "data-bs-target": "#network",
  role: "tab",
  "aria-controls": "network",
  "aria-selected": "true"
}, CY = { class: "col-lg-9" }, SY = {
  id: "sidebarContent",
  class: "tab-content"
}, PY = {
  id: "integrations",
  class: "tab-pane fade show active",
  role: "tabpanel",
  "aria-labelledby": "integrations-tab"
}, kY = {
  key: 0,
  id: "network",
  class: "tab-pane fade",
  role: "tabpanel",
  "aria-labelledby": "network-tab"
};
function EY(e, t, s, n, r, i) {
  var d, c;
  const o = pe("integrations"), l = pe("members");
  return pe("administrators"), p(), h("div", vY, [
    a("div", yY, [
      a("div", bY, [
        t[3] || (t[3] = a("div", { class: "d-flex justify-content-between align-items-center" }, [
          a("h1", { class: "fs-3 fw-bold mb-2 mb-lg-4" }, "Brand Portal")
        ], -1)),
        a("div", AY, [
          t[2] || (t[2] = a("button", {
            type: "button",
            id: "integrations-tab",
            class: "nav-link mb-lg-2 active",
            "data-bs-toggle": "pill",
            "data-bs-target": "#integrations",
            role: "tab",
            "aria-controls": "integrations",
            "aria-selected": "false"
          }, [
            a("span", { class: "d-none d-md-inline-block" }, "Website "),
            y(" Integrations "),
            a("i", { class: "fa-light fa-angle-right d-none d-lg-block" })
          ], -1)),
          ((d = e.access) == null ? void 0 : d.brandPortalAdmin) == !0 ? (p(), h("button", wY, t[0] || (t[0] = [
            a("span", { class: "d-none d-md-inline-block" }, "Brand ", -1),
            y(" Network "),
            a("i", { class: "fa-light fa-angle-right d-none d-lg-block" }, null, -1)
          ]))) : P("", !0),
          P("", !0)
        ])
      ]),
      a("div", CY, [
        a("div", SY, [
          a("div", PY, [
            N(o)
          ]),
          ((c = e.access) == null ? void 0 : c.brandPortalAdmin) == !0 ? (p(), h("div", kY, [
            N(l)
          ])) : P("", !0),
          P("", !0)
        ])
      ])
    ])
  ]);
}
const His = /* @__PURE__ */ Ae(gY, [["render", EY]]);
var w2 = function() {
  return Math.random().toString(36).substring(2);
}, Sa = me({
  name: "ContentLoader",
  props: {
    width: {
      type: [Number, String]
    },
    height: {
      type: [Number, String]
    },
    viewBox: {
      type: String
    },
    preserveAspectRatio: {
      type: String,
      default: "xMidYMid meet"
    },
    speed: {
      type: Number,
      default: 2
    },
    baseUrl: {
      type: String,
      default: ""
    },
    primaryColor: {
      type: String,
      default: "#f9f9f9"
    },
    secondaryColor: {
      type: String,
      default: "#ecebeb"
    },
    primaryOpacity: {
      type: Number,
      default: 1
    },
    secondaryOpacity: {
      type: Number,
      default: 1
    },
    uniqueKey: {
      type: String
    },
    animate: {
      type: Boolean,
      default: !0
    }
  },
  setup: function(t) {
    var s = Ke(function() {
      return t.uniqueKey ? "".concat(t.uniqueKey, "-idClip") : w2();
    }), n = Ke(function() {
      return t.uniqueKey ? "".concat(t.uniqueKey, "-idGradient") : w2();
    }), r = Ke(function() {
      var l;
      return (l = t.width) !== null && l !== void 0 ? l : 400;
    }), i = Ke(function() {
      var l;
      return (l = t.height) !== null && l !== void 0 ? l : 130;
    }), o = Ke(function() {
      var l;
      return (l = t.viewBox) !== null && l !== void 0 ? l : "0 0 ".concat(r.value, " ").concat(i.value);
    });
    return {
      idClip: s,
      idGradient: n,
      computedViewBox: o
    };
  },
  render: function() {
    return N("svg", {
      width: this.width,
      height: this.height,
      viewBox: this.computedViewBox,
      version: "1.1",
      preserveAspectRatio: this.preserveAspectRatio
    }, [N("rect", {
      style: {
        fill: "url(".concat(this.baseUrl, "#").concat(this.idGradient, ")")
      },
      "clip-path": "url(".concat(this.baseUrl, "#").concat(this.idClip, ")"),
      x: "0",
      y: "0",
      width: "100%",
      height: "100%"
    }, null), N("defs", null, [N("clipPath", {
      id: this.idClip
    }, [this.$slots.default ? this.$slots.default() : N("rect", {
      x: "0",
      y: "0",
      rx: "5",
      ry: "5",
      width: "100%",
      height: "100%"
    }, null)]), N("linearGradient", {
      id: this.idGradient
    }, [N("stop", {
      offset: "0%",
      "stop-color": this.primaryColor,
      "stop-opacity": this.primaryOpacity
    }, [this.animate ? N("animate", {
      attributeName: "offset",
      values: "-2; 1",
      dur: "".concat(this.speed, "s"),
      repeatCount: "indefinite"
    }, null) : null]), N("stop", {
      offset: "50%",
      "stop-color": this.secondaryColor,
      "stop-opacity": this.secondaryOpacity
    }, [this.animate ? N("animate", {
      attributeName: "offset",
      values: "-1.5; 1.5",
      dur: "".concat(this.speed, "s"),
      repeatCount: "indefinite"
    }, null) : null]), N("stop", {
      offset: "100%",
      "stop-color": this.primaryColor,
      "stop-opacity": this.primaryOpacity
    }, [this.animate ? N("animate", {
      attributeName: "offset",
      values: "-1; 2",
      dur: "".concat(this.speed, "s"),
      repeatCount: "indefinite"
    }, null) : null])])])]);
  }
});
me(function(e, t) {
  var s = t.attrs;
  return function() {
    return N(Sa, s, {
      default: function() {
        return [N("circle", {
          cx: "10",
          cy: "20",
          r: "8"
        }, null), N("rect", {
          x: "25",
          y: "15",
          rx: "5",
          ry: "5",
          width: "220",
          height: "10"
        }, null), N("circle", {
          cx: "10",
          cy: "50",
          r: "8"
        }, null), N("rect", {
          x: "25",
          y: "45",
          rx: "5",
          ry: "5",
          width: "220",
          height: "10"
        }, null), N("circle", {
          cx: "10",
          cy: "80",
          r: "8"
        }, null), N("rect", {
          x: "25",
          y: "75",
          rx: "5",
          ry: "5",
          width: "220",
          height: "10"
        }, null), N("circle", {
          cx: "10",
          cy: "110",
          r: "8"
        }, null), N("rect", {
          x: "25",
          y: "105",
          rx: "5",
          ry: "5",
          width: "220",
          height: "10"
        }, null)];
      }
    });
  };
});
var pb = me(function(e, t) {
  var s = t.attrs;
  return function() {
    return N(Sa, s, {
      default: function() {
        return [N("rect", {
          x: "0",
          y: "0",
          rx: "3",
          ry: "3",
          width: "70",
          height: "10"
        }, null), N("rect", {
          x: "80",
          y: "0",
          rx: "3",
          ry: "3",
          width: "100",
          height: "10"
        }, null), N("rect", {
          x: "190",
          y: "0",
          rx: "3",
          ry: "3",
          width: "10",
          height: "10"
        }, null), N("rect", {
          x: "15",
          y: "20",
          rx: "3",
          ry: "3",
          width: "130",
          height: "10"
        }, null), N("rect", {
          x: "155",
          y: "20",
          rx: "3",
          ry: "3",
          width: "130",
          height: "10"
        }, null), N("rect", {
          x: "15",
          y: "40",
          rx: "3",
          ry: "3",
          width: "90",
          height: "10"
        }, null), N("rect", {
          x: "115",
          y: "40",
          rx: "3",
          ry: "3",
          width: "60",
          height: "10"
        }, null), N("rect", {
          x: "185",
          y: "40",
          rx: "3",
          ry: "3",
          width: "60",
          height: "10"
        }, null), N("rect", {
          x: "0",
          y: "60",
          rx: "3",
          ry: "3",
          width: "30",
          height: "10"
        }, null)];
      }
    });
  };
});
me(function(e, t) {
  var s = t.attrs;
  return function() {
    return N(Sa, s, {
      default: function() {
        return [N("rect", {
          x: "70",
          y: "15",
          rx: "4",
          ry: "4",
          width: "117",
          height: "6.4"
        }, null), N("rect", {
          x: "70",
          y: "35",
          rx: "3",
          ry: "3",
          width: "85",
          height: "6.4"
        }, null), N("rect", {
          x: "0",
          y: "80",
          rx: "3",
          ry: "3",
          width: "350",
          height: "6.4"
        }, null), N("rect", {
          x: "0",
          y: "100",
          rx: "3",
          ry: "3",
          width: "380",
          height: "6.4"
        }, null), N("rect", {
          x: "0",
          y: "120",
          rx: "3",
          ry: "3",
          width: "201",
          height: "6.4"
        }, null), N("circle", {
          cx: "30",
          cy: "30",
          r: "30"
        }, null)];
      }
    });
  };
});
var uf = me(function(e, t) {
  var s = t.attrs;
  return function() {
    return N(Sa, s, {
      default: function() {
        return [N("rect", {
          x: "0",
          y: "0",
          rx: "3",
          ry: "3",
          width: "250",
          height: "10"
        }, null), N("rect", {
          x: "20",
          y: "20",
          rx: "3",
          ry: "3",
          width: "220",
          height: "10"
        }, null), N("rect", {
          x: "20",
          y: "40",
          rx: "3",
          ry: "3",
          width: "170",
          height: "10"
        }, null), N("rect", {
          x: "0",
          y: "60",
          rx: "3",
          ry: "3",
          width: "250",
          height: "10"
        }, null), N("rect", {
          x: "20",
          y: "80",
          rx: "3",
          ry: "3",
          width: "200",
          height: "10"
        }, null), N("rect", {
          x: "20",
          y: "100",
          rx: "3",
          ry: "3",
          width: "80",
          height: "10"
        }, null)];
      }
    });
  };
}), IY = me(function(e, t) {
  var s = t.attrs;
  return function() {
    return N(Sa, Rs(s, {
      viewBox: "0 0 400 480"
    }), {
      default: function() {
        return [N("circle", {
          cx: "30",
          cy: "30",
          r: "30"
        }, null), N("rect", {
          x: "75",
          y: "13",
          rx: "4",
          ry: "4",
          width: "100",
          height: "13"
        }, null), N("rect", {
          x: "75",
          y: "37",
          rx: "4",
          ry: "4",
          width: "50",
          height: "8"
        }, null), N("rect", {
          x: "0",
          y: "70",
          rx: "5",
          ry: "5",
          width: "400",
          height: "400"
        }, null)];
      }
    });
  };
});
function C2(e, t) {
  var s = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), s.push.apply(s, n);
  }
  return s;
}
function Vs(e) {
  for (var t = 1; t < arguments.length; t++) {
    var s = arguments[t] != null ? arguments[t] : {};
    t % 2 ? C2(Object(s), !0).forEach(function(n) {
      ar(e, n, s[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(s)) : C2(Object(s)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(s, n));
    });
  }
  return e;
}
function ar(e, t, s) {
  return t in e ? Object.defineProperty(e, t, { value: s, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = s, e;
}
function TY(e, t) {
  if (e == null) return {};
  var s, n, r = function(o, l) {
    if (o == null) return {};
    var d, c, u = {}, m = Object.keys(o);
    for (c = 0; c < m.length; c++) d = m[c], l.indexOf(d) >= 0 || (u[d] = o[d]);
    return u;
  }(e, t);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (n = 0; n < i.length; n++) s = i[n], t.indexOf(s) >= 0 || Object.prototype.propertyIsEnumerable.call(e, s) && (r[s] = e[s]);
  }
  return r;
}
function ll(e) {
  return function(t) {
    if (Array.isArray(t)) return kg(t);
  }(e) || function(t) {
    if (typeof Symbol < "u" && t[Symbol.iterator] != null || t["@@iterator"] != null) return Array.from(t);
  }(e) || function(t, s) {
    if (t) {
      if (typeof t == "string") return kg(t, s);
      var n = Object.prototype.toString.call(t).slice(8, -1);
      if (n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set") return Array.from(t);
      if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return kg(t, s);
    }
  }(e) || function() {
    throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }();
}
function kg(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var s = 0, n = new Array(t); s < t; s++) n[s] = e[s];
  return n;
}
var S2, OY, Tp, Ua = (S2 = function(e) {
  (function() {
    var t = {}.hasOwnProperty;
    function s() {
      for (var n = [], r = 0; r < arguments.length; r++) {
        var i = arguments[r];
        if (i) {
          var o = typeof i;
          if (o === "string" || o === "number") n.push(i);
          else if (Array.isArray(i)) {
            if (i.length) {
              var l = s.apply(null, i);
              l && n.push(l);
            }
          } else if (o === "object") if (i.toString === Object.prototype.toString) for (var d in i) t.call(i, d) && i[d] && n.push(d);
          else n.push(i.toString());
        }
      }
      return n.join(" ");
    }
    e.exports ? (s.default = s, e.exports = s) : window.classNames = s;
  })();
}, S2(Tp = { path: OY, exports: {}, require: function(e, t) {
  return function() {
    throw new Error("Dynamic requires are not currently supported by @rollup/plugin-commonjs");
  }(t == null && Tp.path);
} }, Tp.exports), Tp.exports), yr = function(e) {
  return function(t, s) {
    if (!t) return e;
    var n;
    typeof t == "string" ? n = t : s = t;
    var r = e;
    return n && (r += "__" + n), r + (s ? Object.keys(s).reduce(function(i, o) {
      var l = s[o];
      return l && (i += " " + (typeof l == "boolean" ? r + "--" + o : r + "--" + o + "_" + l)), i;
    }, "") : "");
  };
};
function ly(e, t, s) {
  var n, r, i, o, l;
  function d() {
    var u = Date.now() - o;
    u < t && u >= 0 ? n = setTimeout(d, t - u) : (n = null, s || (l = e.apply(i, r), i = r = null));
  }
  t == null && (t = 100);
  var c = function() {
    i = this, r = arguments, o = Date.now();
    var u = s && !n;
    return n || (n = setTimeout(d, t)), u && (l = e.apply(i, r), i = r = null), l;
  };
  return c.clear = function() {
    n && (clearTimeout(n), n = null);
  }, c.flush = function() {
    n && (l = e.apply(i, r), i = r = null, clearTimeout(n), n = null);
  }, c;
}
ly.debounce = ly;
var dy = ly, Gt = function() {
  return Gt = Object.assign || function(e) {
    for (var t, s = 1, n = arguments.length; s < n; s++) for (var r in t = arguments[s]) Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
    return e;
  }, Gt.apply(this, arguments);
};
function Sk(e, t) {
  var s, n;
  return e && t ? (s = "" + e + t[0].toUpperCase() + t.slice(1), n = e + "-" + t) : (s = e || t, n = e || t), { name: s, classname: n };
}
function Pk(e) {
  return /^blob:/.test(e);
}
function P2(e) {
  return Pk(e) || function(t) {
    return /^data:/.test(t);
  }(e);
}
function xl(e) {
  return !!(e && e.constructor && e.call && e.apply);
}
function Ya(e) {
  return e === void 0;
}
function Sh(e) {
  return typeof e == "object" && e !== null;
}
function cy(e, t, s) {
  var n = {};
  return Sh(e) ? (Object.keys(t).forEach(function(r) {
    Ya(e[r]) ? n[r] = t[r] : Sh(t[r]) ? Sh(e[r]) ? n[r] = cy(e[r], t[r], s[r]) : n[r] = e[r] ? t[r] : s[r] : t[r] === !0 || t[r] === !1 ? n[r] = !!e[r] : n[r] = e[r];
  }), n) : e ? t : s;
}
function Op(e) {
  var t = Number(e);
  return Number.isNaN(t) ? e : t;
}
function k2(e) {
  return typeof (e == "number" || /* @__PURE__ */ function(t) {
    return typeof t == "object" && t !== null;
  }(e) && toString.call(e) == "[object Number]") && !kk(e);
}
function kk(e) {
  return e != e;
}
function Ek(e, t) {
  return Math.sqrt(Math.pow(e.x - t.x, 2) + Math.pow(e.y - t.y, 2));
}
var nu = function(e, t) {
  e === void 0 && (e = {}), t === void 0 && (t = {}), this.type = "manipulateImage", this.move = e, this.scale = t;
}, Ik = function(e, t) {
  t === void 0 && (t = {}), this.type = "resize", this.directions = e, this.params = t;
}, hb = function(e) {
  this.type = "move", this.directions = e;
}, RY = function() {
  function e(t, s, n, r, i) {
    this.type = "drag", this.nativeEvent = t, this.position = n, this.previousPosition = r, this.element = s, this.anchor = i;
  }
  return e.prototype.shift = function() {
    var t = this, s = t.element, n = t.anchor, r = t.position;
    if (s) {
      var i = s.getBoundingClientRect(), o = i.left, l = i.top;
      return { left: r.left - o - n.left, top: r.top - l - n.top };
    }
    return { left: 0, top: 0 };
  }, e;
}(), pf = { name: "DraggableElement", props: { classname: { type: String } }, beforeMount: function() {
  window.addEventListener("mouseup", this.onMouseUp, { passive: !1 }), window.addEventListener("mousemove", this.onMouseMove, { passive: !1 }), window.addEventListener("touchmove", this.onTouchMove, { passive: !1 }), window.addEventListener("touchend", this.onTouchEnd, { passive: !1 });
}, beforeUnmount: function() {
  window.removeEventListener("mouseup", this.onMouseUp), window.removeEventListener("mousemove", this.onMouseMove), window.removeEventListener("touchmove", this.onTouchMove), window.removeEventListener("touchend", this.onTouchEnd);
}, mounted: function() {
  if (!this.$refs.draggable) throw new Error('You should add ref "draggable" to your root element to use draggable mixin');
  this.touches = [], this.hovered = !1;
}, methods: { onMouseOver: function() {
  this.hovered || (this.hovered = !0, this.$emit("enter"));
}, onMouseLeave: function() {
  this.hovered && !this.touches.length && (this.hovered = !1, this.$emit("leave"));
}, onTouchStart: function(e) {
  e.cancelable && !this.disabled && e.touches.length === 1 && (this.touches = ll(e.touches), this.hovered || (this.$emit("enter"), this.hovered = !0), e.touches.length && this.initAnchor(this.touches.reduce(function(t, s) {
    return { clientX: t.clientX + s.clientX / e.touches.length, clientY: t.clientY + s.clientY / e.touches.length };
  }, { clientX: 0, clientY: 0 })), e.preventDefault && e.preventDefault(), e.stopPropagation());
}, onTouchEnd: function() {
  this.processEnd();
}, onTouchMove: function(e) {
  this.touches.length && (this.processMove(e, e.touches), e.preventDefault && e.preventDefault(), e.stopPropagation && e.stopPropagation());
}, onMouseDown: function(e) {
  if (!this.disabled) {
    var t = { fake: !0, clientX: e.clientX, clientY: e.clientY };
    this.touches = [t], this.initAnchor(t), e.stopPropagation();
  }
}, onMouseMove: function(e) {
  this.touches.length && (this.processMove(e, [{ fake: !0, clientX: e.clientX, clientY: e.clientY }]), e.preventDefault && e.preventDefault());
}, onMouseUp: function() {
  this.processEnd();
}, initAnchor: function(e) {
  var t = this.$refs.draggable.getBoundingClientRect(), s = t.left, n = t.right, r = t.bottom, i = t.top;
  this.anchor = { left: e.clientX - s, top: e.clientY - i, bottom: r - e.clientY, right: n - e.clientX };
}, processMove: function(e, t) {
  var s = ll(t);
  if (this.touches.length) {
    if (this.touches.length === 1 && s.length === 1) {
      var n = this.$refs.draggable;
      this.$emit("drag", new RY(e, n, { left: s[0].clientX, top: s[0].clientY }, { left: this.touches[0].clientX, top: this.touches[0].clientY }, this.anchor));
    }
    this.touches = s;
  }
}, processEnd: function() {
  this.touches.length && this.$emit("drag-end"), this.hovered && (this.$emit("leave"), this.hovered = !1), this.touches = [];
} }, emits: ["drag", "drag-end", "leave", "enter"] };
pf.render = function(e, t, s, n, r, i) {
  return p(), Fe("div", { ref: "draggable", class: s.classname, onTouchstart: t[1] || (t[1] = function() {
    return i.onTouchStart && i.onTouchStart.apply(i, arguments);
  }), onMousedown: t[2] || (t[2] = function() {
    return i.onMouseDown && i.onMouseDown.apply(i, arguments);
  }), onMouseover: t[3] || (t[3] = function() {
    return i.onMouseOver && i.onMouseOver.apply(i, arguments);
  }), onMouseleave: t[4] || (t[4] = function() {
    return i.onMouseLeave && i.onMouseLeave.apply(i, arguments);
  }) }, [Ot(e.$slots, "default")], 34);
};
var Eg = yr("vue-handler-wrapper"), Tk = { name: "HandlerWrapper", components: { DraggableElement: pf }, props: { horizontalPosition: { type: String }, verticalPosition: { type: String }, disabled: { type: Boolean, default: !1 } }, computed: { classes: function() {
  var e;
  if (this.horizontalPosition || this.verticalPosition) {
    var t, s = Sk(this.horizontalPosition, this.verticalPosition);
    e = Eg((ar(t = {}, s.classname, !0), ar(t, "disabled", this.disabled), t));
  } else e = Eg({ disabled: this.disabled });
  return { root: e, draggable: Eg("draggable") };
} }, emits: ["leave", "enter", "drag", "drag-end"] };
Tk.render = function(e, t, s, n, r, i) {
  var o = pe("DraggableElement");
  return p(), Fe("div", { class: i.classes.root }, [N(o, { class: i.classes.draggable, onDrag: t[1] || (t[1] = function(l) {
    return e.$emit("drag", l);
  }), onDragEnd: t[2] || (t[2] = function(l) {
    return e.$emit("drag-end");
  }), onLeave: t[3] || (t[3] = function(l) {
    return e.$emit("leave");
  }), onEnter: t[4] || (t[4] = function(l) {
    return e.$emit("enter");
  }) }, { default: ve(function() {
    return [Ot(e.$slots, "default")];
  }), _: 3 }, 8, ["class"])], 2);
};
var LY = yr("vue-line-wrapper"), Ok = { name: "LineWrapper", components: { DraggableElement: pf }, props: { position: { type: String, required: !0 }, disabled: { type: Boolean, default: !1 } }, computed: { classname: function() {
  var e;
  return LY((ar(e = {}, this.position, !0), ar(e, "disabled", this.disabled), e));
} }, emits: ["leave", "enter", "drag", "drag-end"] };
Ok.render = function(e, t, s, n, r, i) {
  var o = pe("DraggableElement");
  return p(), Fe(o, { class: i.classname, onDrag: t[1] || (t[1] = function(l) {
    return e.$emit("drag", l);
  }), onDragEnd: t[2] || (t[2] = function(l) {
    return e.$emit("drag-end");
  }), onLeave: t[3] || (t[3] = function(l) {
    return e.$emit("leave");
  }), onEnter: t[4] || (t[4] = function(l) {
    return e.$emit("enter");
  }) }, { default: ve(function() {
    return [Ot(e.$slots, "default")];
  }), _: 3 }, 8, ["class"]);
};
var Fr = ["left", "right", "top", "bottom"], BY = ["left", "right"], MY = ["top", "bottom"], xY = ["left", "top"], FY = ["fill-area", "fit-area", "stencil", "none"], E2 = { left: 0, top: 0, width: 0, height: 0 };
function I2(e, t, s) {
  return !(s = s || ["width", "height", "left", "top"]).some(function(n) {
    return e[n] !== t[n];
  });
}
function Gr(e) {
  return { left: e.left, top: e.top, right: e.left + e.width, bottom: e.top + e.height };
}
function Md(e, t) {
  return { left: e.left - t.left, top: e.top - t.top };
}
function _a(e) {
  return { left: e.left + e.width / 2, top: e.top + e.height / 2 };
}
function yu(e, t) {
  var s = { left: 0, top: 0, right: 0, bottom: 0 };
  return Fr.forEach(function(n) {
    var r = t[n], i = Gr(e)[n];
    s[n] = r !== void 0 && i !== void 0 ? n === "left" || n === "top" ? Math.max(0, r - i) : Math.max(0, i - r) : 0;
  }), s;
}
function Lr(e, t) {
  return { left: e.left - t.left, top: e.top - t.top, width: e.width + t.left + t.right, height: e.height + t.top + t.bottom };
}
function hf(e) {
  return { left: -e.left, top: -e.top };
}
function Rn(e, t) {
  return Gt(Gt({}, e), { left: e.left + t.left, top: e.top + t.top });
}
function rr(e, t, s, n) {
  if (t !== 1) {
    if (s) {
      var r = _a(e);
      return { width: e.width * t, height: e.height * t, left: e.left + e.width * (1 - t) / 2 + (s.left - r.left) * (1 - t), top: e.top + e.height * (1 - t) / 2 + (s.top - r.top) * (1 - t) };
    }
    return { width: e.width * t, height: e.height * t, left: e.left + e.width * (1 - t) / 2, top: e.top + e.height * (1 - t) / 2 };
  }
  return e;
}
function js(e) {
  return e.width / e.height;
}
function xd(e, t) {
  return Math.min(t.right !== void 0 && t.left !== void 0 ? (t.right - t.left) / e.width : 1 / 0, t.bottom !== void 0 && t.top !== void 0 ? (t.bottom - t.top) / e.height : 1 / 0);
}
function Fd(e, t) {
  var s = { left: 0, top: 0 }, n = yu(e, t);
  return n.left && n.left > 0 ? s.left = n.left : n.right && n.right > 0 && (s.left = -n.right), n.top && n.top > 0 ? s.top = n.top : n.bottom && n.bottom > 0 && (s.top = -n.bottom), s;
}
function Ig(e, t) {
  var s;
  return t.minimum && e < t.minimum ? s = t.minimum : t.maximum && e > t.maximum && (s = t.maximum), s;
}
function Rk(e, t) {
  var s = js(e), n = js(t);
  return t.width < 1 / 0 && t.height < 1 / 0 ? s > n ? { width: t.width, height: t.width / s } : { width: t.height * s, height: t.height } : t.width < 1 / 0 ? { width: t.width, height: t.width / s } : t.height < 1 / 0 ? { width: t.height * s, height: t.height } : e;
}
function Lk(e, t) {
  var s = t * Math.PI / 180;
  return { width: Math.abs(e.width * Math.cos(s)) + Math.abs(e.height * Math.sin(s)), height: Math.abs(e.width * Math.sin(s)) + Math.abs(e.height * Math.cos(s)) };
}
function oi(e, t) {
  var s = t * Math.PI / 180;
  return { left: e.left * Math.cos(s) - e.top * Math.sin(s), top: e.left * Math.sin(s) + e.top * Math.cos(s) };
}
function mf(e, t) {
  var s = yu(en(e, t), t);
  return s.left + s.right + s.top + s.bottom ? s.left + s.right > s.top + s.bottom ? Math.min((e.width + s.left + s.right) / e.width, xd(e, t)) : Math.min((e.height + s.top + s.bottom) / e.height, xd(e, t)) : 1;
}
function en(e, t, s) {
  s === void 0 && (s = !1);
  var n = Fd(e, t);
  return Rn(e, s ? hf(n) : n);
}
function uy(e) {
  return { width: e.right !== void 0 && e.left !== void 0 ? e.right - e.left : 1 / 0, height: e.bottom !== void 0 && e.top !== void 0 ? e.bottom - e.top : 1 / 0 };
}
function VY(e, t) {
  return Gt(Gt({}, e), { minWidth: Math.min(t.width, e.minWidth), minHeight: Math.min(t.height, e.minHeight), maxWidth: Math.min(t.width, e.maxWidth), maxHeight: Math.min(t.height, e.maxHeight) });
}
function Bk(e, t, s) {
  s === void 0 && (s = !0);
  var n = {};
  return Fr.forEach(function(r) {
    var i = e[r], o = t[r];
    i !== void 0 && o !== void 0 ? n[r] = r === "left" || r === "top" ? s ? Math.max(i, o) : Math.min(i, o) : s ? Math.min(i, o) : Math.max(i, o) : o !== void 0 ? n[r] = o : i !== void 0 && (n[r] = i);
  }), n;
}
function ff(e, t) {
  return Bk(e, t, !0);
}
function T2(e) {
  var t = e.size, s = e.aspectRatio, n = e.ignoreMinimum, r = e.sizeRestrictions;
  return !!((t.correctRatio || js(t) >= s.minimum && js(t) <= s.maximum) && t.height <= r.maxHeight && t.width <= r.maxWidth && t.width && t.height && (n || t.height >= r.minHeight && t.width >= r.minWidth));
}
function O2(e, t) {
  return Math.pow(e.width - t.width, 2) + Math.pow(e.height - t.height, 2);
}
function Co(e) {
  var t = e.width, s = e.height, n = e.sizeRestrictions, r = { minimum: e.aspectRatio && e.aspectRatio.minimum || 0, maximum: e.aspectRatio && e.aspectRatio.maximum || 1 / 0 }, i = { width: Math.max(n.minWidth, Math.min(n.maxWidth, t)), height: Math.max(n.minHeight, Math.min(n.maxHeight, s)) };
  function o(c, u) {
    return u === void 0 && (u = !1), c.reduce(function(m, f) {
      return T2({ size: f, aspectRatio: r, sizeRestrictions: n, ignoreMinimum: u }) && (!m || O2(f, { width: t, height: s }) < O2(m, { width: t, height: s })) ? f : m;
    }, null);
  }
  var l = [];
  r && [r.minimum, r.maximum].forEach(function(c) {
    c && l.push({ width: i.width, height: i.width / c, correctRatio: !0 }, { width: i.height * c, height: i.height, correctRatio: !0 });
  }), T2({ size: i, aspectRatio: r, sizeRestrictions: n }) && l.push(i);
  var d = o(l) || o(l, !0);
  return d && { width: d.width, height: d.height };
}
function py(e) {
  var t = e.event, s = e.coordinates, n = e.positionRestrictions, r = n === void 0 ? {} : n, i = Rn(s, t.directions);
  return Rn(i, Fd(i, r));
}
function DY(e) {
  var t = e.coordinates, s = e.transform, n = e.imageSize, r = e.sizeRestrictions, i = e.positionRestrictions, o = e.aspectRatio, l = e.visibleArea, d = function(u, m) {
    return py({ coordinates: u, positionRestrictions: i, event: new hb({ left: m.left - u.left, top: m.top - u.top }) });
  }, c = Gt({}, t);
  return (Array.isArray(s) ? s : [s]).forEach(function(u) {
    var m = {};
    Ya((m = typeof u == "function" ? u({ coordinates: c, imageSize: n, visibleArea: l }) : u).width) && Ya(m.height) || (c = function(f, v) {
      var b = Gt(Gt(Gt({}, f), Co({ width: v.width, height: v.height, sizeRestrictions: r, aspectRatio: o })), { left: 0, top: 0 });
      return d(b, { left: f.left, top: f.top });
    }(c, Gt(Gt({}, c), m))), Ya(m.left) && Ya(m.top) || (c = d(c, Gt(Gt({}, c), m)));
  }), c;
}
function NY(e) {
  e.event;
  var t = e.getAreaRestrictions, s = e.boundaries, n = e.coordinates, r = e.visibleArea;
  e.aspectRatio;
  var i = e.stencilSize, o = e.sizeRestrictions, l = e.positionRestrictions;
  e.stencilReference;
  var d, c, u, m = Gt({}, n), f = Gt({}, r), v = Gt({}, i);
  d = js(v), c = js(m), u === void 0 && (u = 1e-3), (d === 0 || c === 0 ? Math.abs(c - d) < u : Math.abs(c / d) < 1 + u && Math.abs(c / d) > 1 - u) || (m = Gt(Gt({}, m), Co({ sizeRestrictions: o, width: m.width, height: m.height, aspectRatio: { minimum: js(v), maximum: js(v) } })));
  var b = mf(f = rr(f, m.width * s.width / (f.width * v.width)), t({ visibleArea: f, type: "resize" }));
  return b !== 1 && (f = rr(f, b), m = rr(m, b)), f = en(f = Rn(f, Md(_a(m), _a(f))), t({ visibleArea: f, type: "move" })), { coordinates: m = en(m, ff(Gr(f), l)), visibleArea: f };
}
function jY(e) {
  var t = e.event, s = e.getAreaRestrictions, n = e.boundaries, r = e.coordinates, i = e.visibleArea;
  e.aspectRatio, e.stencilSize, e.sizeRestrictions;
  var o = e.positionRestrictions;
  e.stencilReference;
  var l = Gt({}, r), d = Gt({}, i);
  if (r && i && t.type !== "manipulateImage") {
    var c = { width: 0, height: 0 };
    d.width, n.width, js(n) > js(l) ? (c.height = 0.8 * n.height, c.width = c.height * js(l)) : (c.width = 0.8 * n.width, c.height = c.width * js(l));
    var u = mf(d = rr(d, l.width * n.width / (d.width * c.width)), s({ visibleArea: d, type: "resize" }));
    d = rr(d, u), u !== 1 && (c.height /= u, c.width /= u), d = en(d = Rn(d, Md(_a(l), _a(d))), s({ visibleArea: d, type: "move" })), l = en(l, ff(Gr(d), o));
  }
  return { coordinates: l, visibleArea: d };
}
function HY(e) {
  var t = e.event, s = e.coordinates, n = e.visibleArea, r = e.getAreaRestrictions, i = Gt({}, n), o = Gt({}, s);
  if (t.type === "setCoordinates") {
    var l = Math.max(0, o.width - i.width), d = Math.max(0, o.height - i.height);
    l > d ? i = rr(i, Math.min(o.width / i.width, xd(i, r({ visibleArea: i, type: "resize" })))) : d > l && (i = rr(i, Math.min(o.height / i.height, xd(i, r({ visibleArea: i, type: "resize" }))))), i = en(i = Rn(i, hf(Fd(o, Gr(i)))), r({ visibleArea: i, type: "move" }));
  }
  return { visibleArea: i, coordinates: o };
}
function UY(e) {
  var t = e.imageSize, s = e.visibleArea, n = e.coordinates, r = s || t;
  return { left: (s ? s.left : 0) + r.width / 2 - n.width / 2, top: (s ? s.top : 0) + r.height / 2 - n.height / 2 };
}
function zY(e) {
  var t = e.imageSize, s = e.visibleArea, n = e.aspectRatio, r = e.sizeRestrictions, i = s || t, o = Math.min(n.maximum || 1 / 0, Math.max(n.minimum || 0, js(i))), l = i.width < i.height ? { width: 0.8 * i.width, height: 0.8 * i.width / o } : { height: 0.8 * i.height, width: 0.8 * i.height * o };
  return Co(Gt(Gt({}, l), { aspectRatio: n, sizeRestrictions: r }));
}
function WY(e) {
  var t, s, n = e.imageSize, r = e.visibleArea, i = e.boundaries, o = e.aspectRatio, l = e.sizeRestrictions, d = e.stencilSize, c = r || n;
  return js(c) > js(i) ? s = (t = d.height * c.height / i.height) * js(d) : t = (s = d.width * c.width / i.width) / js(d), Co({ width: s, height: t, aspectRatio: o, sizeRestrictions: l });
}
function GY(e) {
  var t = e.getAreaRestrictions, s = e.coordinates, n = e.imageSize, r = js(e.boundaries);
  if (s) {
    var i = { height: Math.max(s.height, n.height), width: Math.max(s.width, n.width) }, o = Rk({ width: js(i) > r ? i.width : i.height * r, height: js(i) > r ? i.width / r : i.height }, uy(t())), l = { left: s.left + s.width / 2 - o.width / 2, top: s.top + s.height / 2 - o.height / 2, width: o.width, height: o.height }, d = yu(s, Gr(Gt({ left: 0, top: 0 }, n))), c = {};
    return !d.left && !d.right && l.width <= n.width && (c.left = 0, c.right = n.width), !d.top && !d.bottom && l.height <= n.height && (c.top = 0, c.bottom = n.height), en(l, c);
  }
  var u = js(n);
  return o = { height: u > r ? n.height : n.width / r, width: u > r ? n.height * r : n.width }, { left: n.width / 2 - o.width / 2, top: n.height / 2 - o.height / 2, width: o.width, height: o.height };
}
function Rp(e, t) {
  return Bk(e, Gr(t));
}
function YY(e) {
  var t = e.event, s = e.coordinates, n = e.visibleArea, r = e.sizeRestrictions, i = e.getAreaRestrictions, o = e.positionRestrictions, l = e.adjustStencil, d = t.scale, c = t.move, u = Gt({}, n), m = Gt({}, s), f = 1, v = 1, b = d.factor && Math.abs(d.factor - 1) > 1e-3;
  u = Rn(u, { left: c.left || 0, top: c.top || 0 });
  var w = { stencil: { minimum: Math.max(r.minWidth ? r.minWidth / m.width : 0, r.minHeight ? r.minHeight / m.height : 0), maximum: Math.min(r.maxWidth ? r.maxWidth / m.width : 1 / 0, r.maxHeight ? r.maxHeight / m.height : 1 / 0, xd(m, o)) }, area: { maximum: xd(u, i({ visibleArea: u, type: "resize" })) } };
  d.factor && b && (d.factor < 1 ? (v = Math.max(d.factor, w.stencil.minimum)) > 1 && (v = 1) : d.factor > 1 && (v = Math.min(d.factor, Math.min(w.area.maximum, w.stencil.maximum))) < 1 && (v = 1)), v && (u = rr(u, v, d.center));
  var S = s.left - n.left, I = n.width + n.left - (s.width + s.left), T = s.top - n.top, x = n.height + n.top - (s.height + s.top);
  return u = en(u = Rn(u, Fd(u, { left: o.left !== void 0 ? o.left - S * v : void 0, top: o.top !== void 0 ? o.top - T * v : void 0, bottom: o.bottom !== void 0 ? o.bottom + x * v : void 0, right: o.right !== void 0 ? o.right + I * v : void 0 })), i({ visibleArea: u, type: "move" })), m.width = m.width * v, m.height = m.height * v, m.left = u.left + S * v, m.top = u.top + T * v, m = en(m, ff(Gr(u), o)), d.factor && b && l && (d.factor > 1 ? f = Math.min(w.area.maximum, d.factor) / v : d.factor < 1 && (f = Math.max(m.height / u.height, m.width / u.width, d.factor / v)), f !== 1 && (u = Rn(u = en(u = rr(u, f, d.factor > 1 ? d.center : _a(m)), i({ visibleArea: u, type: "move" })), hf(Fd(m, Gr(u)))))), { coordinates: m, visibleArea: u };
}
function XY(e) {
  var t = e.aspectRatio, s = e.getAreaRestrictions, n = e.coordinates, r = e.visibleArea, i = e.sizeRestrictions, o = e.positionRestrictions, l = e.imageSize, d = e.previousImageSize, c = e.angle, u = Gt({}, n), m = Gt({}, r), f = oi(_a(Gt({ left: 0, top: 0 }, d)), c);
  return (u = Gt(Gt({}, Co({ sizeRestrictions: i, aspectRatio: t, width: u.width, height: u.height })), oi(_a(u), c))).left -= f.left - l.width / 2 + u.width / 2, u.top -= f.top - l.height / 2 + u.height / 2, m = rr(m, mf(m, s({ visibleArea: m, type: "resize" }))), { coordinates: u = en(u, o), visibleArea: m = en(m = Rn(m, Md(_a(u), _a(n))), s({ visibleArea: m, type: "move" })) };
}
function qY(e) {
  var t = e.flip, s = e.previousFlip, n = e.rotate, r = e.getAreaRestrictions, i = e.coordinates, o = e.visibleArea, l = e.imageSize, d = Gt({}, i), c = Gt({}, o), u = s.horizontal !== t.horizontal, m = s.vertical !== t.vertical;
  if (u || m) {
    var f = oi({ left: l.width / 2, top: l.height / 2 }, -n), v = oi(_a(d), -n), b = oi({ left: u ? f.left - (v.left - f.left) : v.left, top: m ? f.top - (v.top - f.top) : v.top }, n);
    d = Rn(d, Md(b, _a(d))), v = oi(_a(c), -n), c = en(c = Rn(c, Md(b = oi({ left: u ? f.left - (v.left - f.left) : v.left, top: m ? f.top - (v.top - f.top) : v.top }, n), _a(c))), r({ visibleArea: c, type: "move" }));
  }
  return { coordinates: d, visibleArea: c };
}
function R2(e) {
  var t = e.directions, s = e.coordinates, n = e.positionRestrictions, r = n === void 0 ? {} : n, i = e.sizeRestrictions, o = e.preserveRatio, l = e.compensate, d = Gt({}, t), c = Lr(s, d).width, u = Lr(s, d).height;
  c < 0 && (d.left < 0 && d.right < 0 ? (d.left = -(s.width - i.minWidth) / (d.left / d.right), d.right = -(s.width - i.minWidth) / (d.right / d.left)) : d.left < 0 ? d.left = -(s.width - i.minWidth) : d.right < 0 && (d.right = -(s.width - i.minWidth))), u < 0 && (d.top < 0 && d.bottom < 0 ? (d.top = -(s.height - i.minHeight) / (d.top / d.bottom), d.bottom = -(s.height - i.minHeight) / (d.bottom / d.top)) : d.top < 0 ? d.top = -(s.height - i.minHeight) : d.bottom < 0 && (d.bottom = -(s.height - i.minHeight)));
  var m = yu(Lr(s, d), r);
  l && (m.left && m.left > 0 && m.right === 0 ? (d.right += m.left, d.left -= m.left) : m.right && m.right > 0 && m.left === 0 && (d.left += m.right, d.right -= m.right), m.top && m.top > 0 && m.bottom === 0 ? (d.bottom += m.top, d.top -= m.top) : m.bottom && m.bottom > 0 && m.top === 0 && (d.top += m.bottom, d.bottom -= m.bottom), m = yu(Lr(s, d), r));
  var f = { width: 1 / 0, height: 1 / 0, left: 1 / 0, right: 1 / 0, top: 1 / 0, bottom: 1 / 0 };
  if (Fr.forEach(function(w) {
    var S = m[w];
    S && d[w] && (f[w] = Math.max(0, 1 - S / d[w]));
  }), o) {
    var v = Math.min.apply(null, Fr.map(function(w) {
      return f[w];
    }));
    v !== 1 / 0 && Fr.forEach(function(w) {
      d[w] *= v;
    });
  } else Fr.forEach(function(w) {
    f[w] !== 1 / 0 && (d[w] *= f[w]);
  });
  if (c = Lr(s, d).width, u = Lr(s, d).height, d.right + d.left && (c > i.maxWidth ? f.width = (i.maxWidth - s.width) / (d.right + d.left) : c < i.minWidth && (f.width = (i.minWidth - s.width) / (d.right + d.left))), d.bottom + d.top && (u > i.maxHeight ? f.height = (i.maxHeight - s.height) / (d.bottom + d.top) : u < i.minHeight && (f.height = (i.minHeight - s.height) / (d.bottom + d.top))), o) {
    var b = Math.min(f.width, f.height);
    b !== 1 / 0 && Fr.forEach(function(w) {
      d[w] *= b;
    });
  } else f.width !== 1 / 0 && BY.forEach(function(w) {
    d[w] *= f.width;
  }), f.height !== 1 / 0 && MY.forEach(function(w) {
    d[w] *= f.height;
  });
  return d;
}
function Lp(e, t, s) {
  return t == 0 && s == 0 ? e / 2 : t == 0 ? 0 : s == 0 ? e : e * Math.abs(t / (t + s));
}
var QY = yr("vue-simple-handler"), KY = yr("vue-simple-handler-wrapper"), mb = { name: "SimpleHandler", components: { HandlerWrapper: Tk }, props: { defaultClass: { type: String }, hoverClass: { type: String }, wrapperClass: { type: String }, horizontalPosition: { type: String }, verticalPosition: { type: String }, disabled: { type: Boolean, default: !1 } }, data: function() {
  return { hover: !1 };
}, computed: { classes: function() {
  var e, t = (ar(e = {}, this.horizontalPosition, !!this.horizontalPosition), ar(e, this.verticalPosition, !!this.verticalPosition), ar(e, "".concat(this.horizontalPosition, "-").concat(this.verticalPosition), !!(this.verticalPosition && this.horizontalPosition)), ar(e, "hover", this.hover), e);
  return { default: Ua(QY(t), this.defaultClass, this.hover && this.hoverClass), wrapper: Ua(KY(t), this.wrapperClass) };
} }, methods: { onDrag: function(e) {
  this.$emit("drag", e);
}, onEnter: function() {
  this.hover = !0;
}, onLeave: function() {
  this.hover = !1;
}, onDragEnd: function() {
  this.$emit("drag-end");
} }, emits: ["drag", "drag-end"] };
mb.render = function(e, t, s, n, r, i) {
  var o = pe("HandlerWrapper");
  return p(), Fe(o, { class: i.classes.wrapper, "vertical-position": s.verticalPosition, "horizontal-position": s.horizontalPosition, disabled: s.disabled, onDrag: i.onDrag, onDragEnd: i.onDragEnd, onEnter: i.onEnter, onLeave: i.onLeave }, { default: ve(function() {
    return [N("div", { class: i.classes.default }, null, 2)];
  }), _: 1 }, 8, ["class", "vertical-position", "horizontal-position", "disabled", "onDrag", "onDragEnd", "onEnter", "onLeave"]);
};
var ZY = yr("vue-simple-line"), JY = yr("vue-simple-line-wrapper"), fb = { name: "SimpleLine", components: { LineWrapper: Ok }, props: { defaultClass: { type: String }, hoverClass: { type: String }, wrapperClass: { type: String }, position: { type: String }, disabled: { type: Boolean, default: !1 } }, data: function() {
  return { hover: !1 };
}, computed: { classes: function() {
  return { root: Ua(ZY(ar({}, this.position, !0)), this.defaultClass, this.hover && this.hoverClass), wrapper: Ua(JY(ar({}, this.position, !0)), this.wrapperClass) };
} }, methods: { onDrag: function(e) {
  this.$emit("drag", e);
}, onEnter: function() {
  this.hover = !0;
}, onLeave: function() {
  this.hover = !1;
}, onDragEnd: function() {
  this.$emit("drag-end");
} }, emits: ["drag", "drag-end"] };
fb.render = function(e, t, s, n, r, i) {
  var o = pe("LineWrapper");
  return p(), Fe(o, { class: i.classes.wrapper, position: s.position, disabled: s.disabled, onDrag: i.onDrag, onDragEnd: i.onDragEnd, onEnter: i.onEnter, onLeave: i.onLeave }, { default: ve(function() {
    return [N("div", { class: i.classes.root }, null, 2)];
  }), _: 1 }, 8, ["class", "position", "disabled", "onDrag", "onDragEnd", "onEnter", "onLeave"]);
};
var Tg = yr("vue-bounding-box"), $Y = ["east", "west", null], _Y = ["south", "north", null], Mk = { name: "BoundingBox", props: { width: { type: Number }, height: { type: Number }, transitions: { type: Object }, handlers: { type: Object, default: function() {
  return { eastNorth: !0, north: !0, westNorth: !0, west: !0, westSouth: !0, south: !0, eastSouth: !0, east: !0 };
} }, handlersComponent: { type: [Object, String], default: function() {
  return mb;
} }, handlersClasses: { type: Object, default: function() {
  return {};
} }, handlersWrappersClasses: { type: Object, default: function() {
  return {};
} }, lines: { type: Object, default: function() {
  return { west: !0, north: !0, east: !0, south: !0 };
} }, linesComponent: { type: [Object, String], default: function() {
  return fb;
} }, linesClasses: { type: Object, default: function() {
  return {};
} }, linesWrappersClasses: { type: Object, default: function() {
  return {};
} }, resizable: { type: Boolean, default: !0 } }, data: function() {
  var e = [];
  return $Y.forEach(function(t) {
    _Y.forEach(function(s) {
      if (t !== s) {
        var n = Sk(t, s), r = n.name, i = n.classname;
        e.push({ name: r, classname: i, verticalDirection: s, horizontalDirection: t });
      }
    });
  }), { points: e };
}, computed: { style: function() {
  var e = {};
  return this.width && this.height && (e.width = "".concat(this.width, "px"), e.height = "".concat(this.height, "px"), this.transitions && this.transitions.enabled && (e.transition = "".concat(this.transitions.time, "ms ").concat(this.transitions.timingFunction))), e;
}, classes: function() {
  var e = this.handlersClasses, t = this.handlersWrappersClasses, s = this.linesClasses, n = this.linesWrappersClasses;
  return { root: Tg(), handlers: e, handlersWrappers: t, lines: s, linesWrappers: n };
}, lineNodes: function() {
  var e = this, t = [];
  return this.points.forEach(function(s) {
    s.horizontalDirection && s.verticalDirection || !e.lines[s.name] || t.push({ name: s.name, component: e.linesComponent, class: Ua(e.classes.lines.default, e.classes.lines[s.name], !e.resizable && e.classes.lines.disabled), wrapperClass: Ua(e.classes.linesWrappers.default, e.classes.linesWrappers[s.name], !e.resizable && e.classes.linesWrappers.disabled), hoverClass: e.classes.lines.hover, verticalDirection: s.verticalDirection, horizontalDirection: s.horizontalDirection, disabled: !e.resizable });
  }), t;
}, handlerNodes: function() {
  var e = this, t = [], s = this.width, n = this.height;
  return this.points.forEach(function(r) {
    if (e.handlers[r.name]) {
      var i = { name: r.name, component: e.handlersComponent, class: Ua(e.classes.handlers.default, e.classes.handlers[r.name]), wrapperClass: Ua(e.classes.handlersWrappers.default, e.classes.handlersWrappers[r.name]), hoverClass: e.classes.handlers.hover, verticalDirection: r.verticalDirection, horizontalDirection: r.horizontalDirection, disabled: !e.resizable };
      if (s && n) {
        var o = r.horizontalDirection, l = r.verticalDirection, d = o === "east" ? s : o === "west" ? 0 : s / 2, c = l === "south" ? n : l === "north" ? 0 : n / 2;
        i.wrapperClass = Tg("handler"), i.wrapperStyle = { transform: "translate(".concat(d, "px, ").concat(c, "px)") }, e.transitions && e.transitions.enabled && (i.wrapperStyle.transition = "".concat(e.transitions.time, "ms ").concat(e.transitions.timingFunction));
      } else i.wrapperClass = Tg("handler", ar({}, r.classname, !0));
      t.push(i);
    }
  }), t;
} }, beforeMount: function() {
  window.addEventListener("mouseup", this.onMouseUp, { passive: !1 }), window.addEventListener("mousemove", this.onMouseMove, { passive: !1 }), window.addEventListener("touchmove", this.onTouchMove, { passive: !1 }), window.addEventListener("touchend", this.onTouchEnd, { passive: !1 });
}, beforeUnmount: function() {
  window.removeEventListener("mouseup", this.onMouseUp), window.removeEventListener("mousemove", this.onMouseMove), window.removeEventListener("touchmove", this.onTouchMove), window.removeEventListener("touchend", this.onTouchEnd);
}, mounted: function() {
  this.touches = [];
}, methods: { onEnd: function() {
  this.$emit("resize-end");
}, onHandlerDrag: function(e, t, s) {
  var n, r = e.shift(), i = r.left, o = r.top, l = { left: 0, right: 0, top: 0, bottom: 0 };
  t === "west" ? l.left -= i : t === "east" && (l.right += i), s === "north" ? l.top -= o : s === "south" && (l.bottom += o), !s && t ? n = "width" : s && !t && (n = "height"), this.resizable && this.$emit("resize", new Ik(l, { allowedDirections: { left: t === "west" || !t, right: t === "east" || !t, bottom: s === "south" || !s, top: s === "north" || !s }, preserveAspectRatio: e.nativeEvent && e.nativeEvent.shiftKey, respectDirection: n }));
} }, emits: ["resize", "resize-end"] };
Mk.render = function(e, t, s, n, r, i) {
  return p(), Fe("div", { ref: "box", class: i.classes.root, style: i.style }, [Ot(e.$slots, "default"), N("div", null, [(p(!0), Fe(A, null, D(i.lineNodes, function(o) {
    return p(), Fe(lu(o.component), { key: o.name, "default-class": o.class, "hover-class": o.hoverClass, "wrapper-class": o.wrapperClass, position: o.name, disabled: o.disabled, onDrag: function(l) {
      return i.onHandlerDrag(l, o.horizontalDirection, o.verticalDirection);
    }, onDragEnd: t[1] || (t[1] = function(l) {
      return i.onEnd();
    }) }, null, 8, ["default-class", "hover-class", "wrapper-class", "position", "disabled", "onDrag"]);
  }), 128))]), (p(!0), Fe(A, null, D(i.handlerNodes, function(o) {
    return p(), Fe("div", { key: o.name, style: o.wrapperStyle, class: o.wrapperClass }, [(p(), Fe(lu(o.component), { "default-class": o.class, "hover-class": o.hoverClass, "wrapper-class": o.wrapperClass, "horizontal-position": o.horizontalDirection, "vertical-position": o.verticalDirection, disabled: o.disabled, onDrag: function(l) {
      return i.onHandlerDrag(l, o.horizontalDirection, o.verticalDirection);
    }, onDragEnd: t[2] || (t[2] = function(l) {
      return i.onEnd();
    }) }, null, 8, ["default-class", "hover-class", "wrapper-class", "horizontal-position", "vertical-position", "disabled", "onDrag"]))], 6);
  }), 128))], 6);
};
var eX = yr("vue-draggable-area"), gb = { name: "DraggableArea", props: { movable: { type: Boolean, default: !0 }, activationDistance: { type: Number, default: 20 } }, computed: { classnames: function() {
  return { default: eX() };
} }, beforeMount: function() {
  window.addEventListener("mouseup", this.onMouseUp, { passive: !1 }), window.addEventListener("mousemove", this.onMouseMove, { passive: !1 }), window.addEventListener("touchmove", this.onTouchMove, { passive: !1 }), window.addEventListener("touchend", this.onTouchEnd, { passive: !1 });
}, beforeUnmount: function() {
  window.removeEventListener("mouseup", this.onMouseUp), window.removeEventListener("mousemove", this.onMouseMove), window.removeEventListener("touchmove", this.onTouchMove), window.removeEventListener("touchend", this.onTouchEnd);
}, mounted: function() {
  this.touches = [], this.touchStarted = !1;
}, methods: { onTouchStart: function(e) {
  if (e.cancelable) {
    var t = this.movable && e.touches.length === 1;
    t && (this.touches = ll(e.touches)), (this.touchStarted || t) && (e.preventDefault(), e.stopPropagation());
  }
}, onTouchEnd: function() {
  this.touchStarted = !1, this.processEnd();
}, onTouchMove: function(e) {
  this.touches.length >= 1 && (this.touchStarted ? (this.processMove(e, e.touches), e.preventDefault(), e.stopPropagation()) : Ek({ x: this.touches[0].clientX, y: this.touches[0].clientY }, { x: e.touches[0].clientX, y: e.touches[0].clientY }) > this.activationDistance && (this.initAnchor({ clientX: e.touches[0].clientX, clientY: e.touches[0].clientY }), this.touchStarted = !0));
}, onMouseDown: function(e) {
  if (this.movable && e.button === 0) {
    var t = { fake: !0, clientX: e.clientX, clientY: e.clientY };
    this.touches = [t], this.initAnchor(t), e.stopPropagation();
  }
}, onMouseMove: function(e) {
  this.touches.length && (this.processMove(e, [{ fake: !0, clientX: e.clientX, clientY: e.clientY }]), e.preventDefault && e.cancelable && e.preventDefault(), e.stopPropagation());
}, onMouseUp: function() {
  this.processEnd();
}, initAnchor: function(e) {
  var t = this.$refs.container.getBoundingClientRect(), s = t.left, n = t.top;
  this.anchor = { x: e.clientX - s, y: e.clientY - n };
}, processMove: function(e, t) {
  var s = ll(t);
  if (this.touches.length) {
    var n = this.$refs.container.getBoundingClientRect(), r = n.left, i = n.top;
    this.touches.length === 1 && s.length === 1 && this.$emit("move", new hb({ left: s[0].clientX - (r + this.anchor.x), top: s[0].clientY - (i + this.anchor.y) }));
  }
}, processEnd: function() {
  this.touches.length && this.$emit("move-end"), this.touches = [];
} }, emits: ["move", "move-end"] };
gb.render = function(e, t, s, n, r, i) {
  return p(), Fe("div", { ref: "container", onTouchstart: t[1] || (t[1] = function() {
    return i.onTouchStart && i.onTouchStart.apply(i, arguments);
  }), onMousedown: t[2] || (t[2] = function() {
    return i.onMouseDown && i.onMouseDown.apply(i, arguments);
  }) }, [Ot(e.$slots, "default")], 544);
};
function Og(e) {
  var t, s;
  return { rotate: e.rotate || 0, flip: { horizontal: ((t = e == null ? void 0 : e.flip) === null || t === void 0 ? void 0 : t.horizontal) || !1, vertical: ((s = e == null ? void 0 : e.flip) === null || s === void 0 ? void 0 : s.vertical) || !1 } };
}
function tX(e) {
  return new Promise(function(t, s) {
    try {
      if (e) if (/^data:/i.test(e)) t(function(d) {
        d = d.replace(/^data:([^;]+);base64,/gim, "");
        for (var c = atob(d), u = c.length, m = new ArrayBuffer(u), f = new Uint8Array(m), v = 0; v < u; v++) f[v] = c.charCodeAt(v);
        return m;
      }(e));
      else if (/^blob:/i.test(e)) {
        var n = new FileReader();
        n.onload = function(d) {
          t(d.target.result);
        }, i = e, o = function(d) {
          n.readAsArrayBuffer(d);
        }, (l = new XMLHttpRequest()).open("GET", i, !0), l.responseType = "blob", l.onload = function() {
          this.status != 200 && this.status !== 0 || o(this.response);
        }, l.send();
      } else {
        var r = new XMLHttpRequest();
        r.onreadystatechange = function() {
          r.readyState === 4 && (r.status === 200 || r.status === 0 ? t(r.response) : s("Warning: could not load an image to parse its orientation"), r = null);
        }, r.onprogress = function() {
          r.getResponseHeader("content-type") !== "image/jpeg" && r.abort();
        }, r.withCredentials = !1, r.open("GET", e, !0), r.responseType = "arraybuffer", r.send(null);
      }
      else s("Error: the image is empty");
    } catch (d) {
      s(d);
    }
    var i, o, l;
  });
}
function xk(e) {
  var t = e.rotate, s = e.flip, n = e.scaleX, r = e.scaleY, i = "";
  return i += " rotate(" + t + "deg) ", i += " scaleX(" + n * (s.horizontal ? -1 : 1) + ") ", i += " scaleY(" + r * (s.vertical ? -1 : 1) + ") ";
}
function sX(e) {
  try {
    var t, s = new DataView(e), n = void 0, r = void 0, i = void 0, o = void 0;
    if (s.getUint8(0) === 255 && s.getUint8(1) === 216) for (var l = s.byteLength, d = 2; d + 1 < l; ) {
      if (s.getUint8(d) === 255 && s.getUint8(d + 1) === 225) {
        i = d;
        break;
      }
      d++;
    }
    if (i && (n = i + 10, function(v, b, w) {
      var S, I = "";
      for (S = b, w += b; S < w; S++) I += String.fromCharCode(v.getUint8(S));
      return I;
    }(s, i + 4, 4) === "Exif")) {
      var c = s.getUint16(n);
      if (((r = c === 18761) || c === 19789) && s.getUint16(n + 2, r) === 42) {
        var u = s.getUint32(n + 4, r);
        u >= 8 && (o = n + u);
      }
    }
    if (o) {
      for (var m = s.getUint16(o, r), f = 0; f < m; f++)
        if (d = o + 12 * f + 2, s.getUint16(d, r) === 274) {
          d += 8, t = s.getUint16(d, r), s.setUint16(d, 1, r);
          break;
        }
    }
    return t;
  } catch {
    return null;
  }
}
function L2(e, t) {
  var s = t.getBoundingClientRect(), n = s.left, r = s.top, i = { left: 0, top: 0 }, o = 0;
  return e.forEach(function(l) {
    i.left += (l.clientX - n) / e.length, i.top += (l.clientY - r) / e.length;
  }), e.forEach(function(l) {
    o += Ek({ x: i.left, y: i.top }, { x: l.clientX - n, y: l.clientY - r });
  }), { centerMass: i, spread: o, count: e.length };
}
var Fk = { props: { touchMove: { type: Boolean, required: !0 }, mouseMove: { type: Boolean, required: !0 }, touchResize: { type: Boolean, required: !0 }, wheelResize: { type: [Boolean, Object], required: !0 }, eventsFilter: { type: Function, required: !1 } }, beforeMount: function() {
  window.addEventListener("mouseup", this.onMouseUp, { passive: !1 }), window.addEventListener("mousemove", this.onMouseMove, { passive: !1 }), window.addEventListener("touchmove", this.onTouchMove, { passive: !1 }), window.addEventListener("touchend", this.onTouchEnd, { passive: !1 });
}, beforeUnmount: function() {
  window.removeEventListener("mouseup", this.onMouseUp), window.removeEventListener("mousemove", this.onMouseMove), window.removeEventListener("touchmove", this.onTouchMove), window.removeEventListener("touchend", this.onTouchEnd);
}, created: function() {
  this.transforming = !1, this.debouncedProcessEnd = dy(this.processEnd), this.touches = [];
}, methods: { processMove: function(e, t) {
  if (this.touches.length) {
    if (this.touches.length === 1 && t.length === 1) this.$emit("move", new nu({ left: this.touches[0].clientX - t[0].clientX, top: this.touches[0].clientY - t[0].clientY }));
    else if (this.touches.length > 1 && this.touchResize) {
      var s = L2(t, this.$refs.container), n = this.oldGeometricProperties;
      n.count === s.count && n.count > 1 && this.$emit("resize", new nu({ left: n.centerMass.left - s.centerMass.left, top: n.centerMass.top - s.centerMass.top }, { factor: n.spread / s.spread, center: s.centerMass })), this.oldGeometricProperties = s;
    }
    this.touches = t;
  }
}, processEnd: function() {
  this.transforming && (this.transforming = !1, this.$emit("transform-end"));
}, processStart: function() {
  this.transforming = !0, this.debouncedProcessEnd.clear();
}, processEvent: function(e) {
  return this.eventsFilter ? this.eventsFilter(e, this.transforming) !== !1 : (e.preventDefault(), e.stopPropagation(), !0);
}, onTouchStart: function(e) {
  if (e.cancelable && (this.touchMove || this.touchResize && e.touches.length > 1) && this.processEvent(e)) {
    var t = this.$refs.container, s = t.getBoundingClientRect(), n = s.left, r = s.top, i = s.bottom, o = s.right;
    this.touches = ll(e.touches).filter(function(l) {
      return l.clientX > n && l.clientX < o && l.clientY > r && l.clientY < i;
    }), this.oldGeometricProperties = L2(this.touches, t);
  }
}, onTouchEnd: function(e) {
  e.touches.length === 0 && (this.touches = [], this.processEnd());
}, onTouchMove: function(e) {
  var t = this;
  if (this.touches.length) {
    var s = ll(e.touches).filter(function(n) {
      return !n.identifier || t.touches.find(function(r) {
        return r.identifier === n.identifier;
      });
    });
    this.processEvent(e) && (this.processMove(e, s), this.processStart());
  }
}, onMouseDown: function(e) {
  if (this.mouseMove && "buttons" in e && e.buttons === 1 && this.processEvent(e)) {
    var t = { fake: !0, clientX: e.clientX, clientY: e.clientY };
    this.touches = [t], this.processStart();
  }
}, onMouseMove: function(e) {
  this.touches.length && this.processEvent(e) && this.processMove(e, [{ clientX: e.clientX, clientY: e.clientY }]);
}, onMouseUp: function() {
  this.touches = [], this.processEnd();
}, onWheel: function(e) {
  if (this.wheelResize && this.processEvent(e)) {
    var t = this.$refs.container.getBoundingClientRect(), s = t.left, n = t.top, r = 1 + this.wheelResize.ratio * (o = e.deltaY || e.detail || e.wheelDelta, (l = +o) == 0 || kk(l) ? l : l > 0 ? 1 : -1), i = { left: e.clientX - s, top: e.clientY - n };
    this.$emit("resize", new nu({}, { factor: r, center: i })), this.touches.length || this.debouncedProcessEnd();
  }
  var o, l;
} }, emits: ["resize", "move", "transform-end"] };
Fk.render = function(e, t, s, n, r, i) {
  return p(), Fe("div", { ref: "container", onTouchstart: t[1] || (t[1] = function() {
    return i.onTouchStart && i.onTouchStart.apply(i, arguments);
  }), onMousedown: t[2] || (t[2] = function() {
    return i.onMouseDown && i.onMouseDown.apply(i, arguments);
  }), onWheel: t[3] || (t[3] = function() {
    return i.onWheel && i.onWheel.apply(i, arguments);
  }) }, [Ot(e.$slots, "default")], 544);
};
var hy = { components: { TransformableImage: Fk }, props: { touchMove: { type: Boolean, required: !0 }, mouseMove: { type: Boolean, required: !0 }, touchResize: { type: Boolean, required: !0 }, wheelResize: { type: [Boolean, Object], required: !0 } }, emits: ["resize", "move"] };
hy.render = function(e, t, s, n, r, i) {
  var o = pe("transformable-image");
  return p(), Fe(o, { "touch-move": s.touchMove, "touch-resize": s.touchResize, "mouse-move": s.mouseMove, "wheel-resize": s.wheelResize, onMove: t[1] || (t[1] = function(l) {
    return e.$emit("move", l);
  }), onResize: t[2] || (t[2] = function(l) {
    return e.$emit("resize", l);
  }) }, { default: ve(function() {
    return [Ot(e.$slots, "default")];
  }), _: 3 }, 8, ["touch-move", "touch-resize", "mouse-move", "wheel-resize"]);
};
var Bp = yr("vue-preview"), Vk = { props: { coordinates: { type: Object }, transitions: { type: Object }, image: { type: Object, default: function() {
  return {};
} }, imageClass: { type: String }, width: { type: Number }, height: { type: Number }, fill: { type: Boolean } }, data: function() {
  return { calculatedImageSize: { width: 0, height: 0 }, calculatedSize: { width: 0, height: 0 } };
}, computed: { classes: function() {
  return { root: Bp({ fill: this.fill }), wrapper: Bp("wrapper"), imageWrapper: Bp("image-wrapper"), image: Ua(Bp("image"), this.imageClass) };
}, style: function() {
  if (this.fill) return {};
  var e = {};
  return this.width && (e.width = "".concat(this.size.width, "px")), this.height && (e.height = "".concat(this.size.height, "px")), this.transitions && this.transitions.enabled && (e.transition = "".concat(this.transitions.time, "ms ").concat(this.transitions.timingFunction)), e;
}, wrapperStyle: function() {
  var e = { width: "".concat(this.size.width, "px"), height: "".concat(this.size.height, "px"), left: "calc(50% - ".concat(this.size.width / 2, "px)"), top: "calc(50% - ".concat(this.size.height / 2, "px)") };
  return this.transitions && this.transitions.enabled && (e.transition = "".concat(this.transitions.time, "ms ").concat(this.transitions.timingFunction)), e;
}, imageStyle: function() {
  if (this.coordinates && this.image) {
    var e = this.coordinates.width / this.size.width, t = Vs(Vs({ rotate: 0, flip: { horizontal: !1, vertical: !1 } }, this.image.transforms), {}, { scaleX: 1 / e, scaleY: 1 / e }), s = this.imageSize.width, n = this.imageSize.height, r = Lk({ width: s, height: n }, t.rotate), i = { width: "".concat(s, "px"), height: "".concat(n, "px"), left: "0px", top: "0px" }, o = { rotate: { left: (s - r.width) * t.scaleX / 2, top: (n - r.height) * t.scaleY / 2 }, scale: { left: (1 - t.scaleX) * s / 2, top: (1 - t.scaleY) * n / 2 } };
    return i.transform = `translate(
				`.concat(-this.coordinates.left / e - o.rotate.left - o.scale.left, "px,").concat(-this.coordinates.top / e - o.rotate.top - o.scale.top, "px) ") + xk(t), this.transitions && this.transitions.enabled && (i.transition = "".concat(this.transitions.time, "ms ").concat(this.transitions.timingFunction)), i;
  }
  return {};
}, size: function() {
  return { width: this.width || this.calculatedSize.width, height: this.height || this.calculatedSize.height };
}, imageSize: function() {
  return { width: this.image.width || this.calculatedImageSize.width, height: this.image.height || this.calculatedImageSize.height };
} }, watch: { image: function(e) {
  (e.width || e.height) && this.onChangeImage();
} }, mounted: function() {
  var e = this;
  this.onChangeImage(), this.$refs.image.addEventListener("load", function() {
    e.refreshImage();
  }), window.addEventListener("resize", this.refresh), window.addEventListener("orientationchange", this.refresh);
}, unmounted: function() {
  window.removeEventListener("resize", this.refresh), window.removeEventListener("orientationchange", this.refresh);
}, methods: { refreshImage: function() {
  var e = this.$refs.image;
  this.calculatedImageSize.height = e.naturalHeight, this.calculatedImageSize.width = e.naturalWidth;
}, refresh: function() {
  var e = this.$refs.root;
  this.width || (this.calculatedSize.width = e.clientWidth), this.height || (this.calculatedSize.height = e.clientHeight);
}, onChangeImage: function() {
  var e = this.$refs.image;
  e && e.complete && this.refreshImage(), this.refresh();
} } };
Vk.render = function(e, t, s, n, r, i) {
  return p(), Fe("div", { ref: "root", class: i.classes.root, style: i.style }, [N("div", { ref: "wrapper", class: i.classes.wrapper, style: i.wrapperStyle }, [V(N("img", { ref: "image", src: s.image && s.image.src, class: i.classes.image, style: i.imageStyle }, null, 14, ["src"]), [[Us, s.image && s.image.src]])], 6)], 6);
};
var vb = { components: { Preview: Vk }, inheritAttrs: !1 };
vb.render = function(e, t, s, n, r, i) {
  var o = pe("preview");
  return p(), Fe(o, Rs(e.$attrs, { fill: !0 }), null, 16);
};
var Rg = yr("vue-rectangle-stencil"), Dk = { name: "RectangleStencil", components: { StencilPreview: vb, BoundingBox: Mk, DraggableArea: gb }, props: { image: { type: Object }, coordinates: { type: Object }, stencilCoordinates: { type: Object }, handlers: { type: Object }, handlersComponent: { type: [Object, String], default: function() {
  return mb;
} }, lines: { type: Object }, linesComponent: { type: [Object, String], default: function() {
  return fb;
} }, aspectRatio: { type: [Number, String] }, minAspectRatio: { type: [Number, String] }, maxAspectRatio: { type: [Number, String] }, movable: { type: Boolean, default: !0 }, resizable: { type: Boolean, default: !0 }, transitions: { type: Object }, movingClass: { type: String }, resizingClass: { type: String }, previewClass: { type: String }, boundingBoxClass: { type: String }, linesClasses: { type: Object, default: function() {
  return {};
} }, linesWrappersClasses: { type: Object, default: function() {
  return {};
} }, handlersClasses: { type: Object, default: function() {
  return {};
} }, handlersWrappersClasses: { type: Object, default: function() {
  return {};
} } }, data: function() {
  return { moving: !1, resizing: !1 };
}, computed: { classes: function() {
  return { stencil: Ua(Rg({ movable: this.movable, moving: this.moving, resizing: this.resizing }), this.moving && this.movingClass, this.resizing && this.resizingClass), preview: Ua(Rg("preview"), this.previewClass), boundingBox: Ua(Rg("bounding-box"), this.boundingBoxClass) };
}, style: function() {
  var e = this.stencilCoordinates, t = e.height, s = e.width, n = e.left, r = e.top, i = { width: "".concat(s, "px"), height: "".concat(t, "px"), transform: "translate(".concat(n, "px, ").concat(r, "px)") };
  return this.transitions && this.transitions.enabled && (i.transition = "".concat(this.transitions.time, "ms ").concat(this.transitions.timingFunction)), i;
} }, methods: { onMove: function(e) {
  this.$emit("move", e), this.moving = !0;
}, onMoveEnd: function() {
  this.$emit("move-end"), this.moving = !1;
}, onResize: function(e) {
  this.$emit("resize", e), this.resizing = !0;
}, onResizeEnd: function() {
  this.$emit("resize-end"), this.resizing = !1;
}, aspectRatios: function() {
  return { minimum: this.aspectRatio || this.minAspectRatio, maximum: this.aspectRatio || this.maxAspectRatio };
} }, emits: ["resize", "resize-end", "move", "move-end"] };
Dk.render = function(e, t, s, n, r, i) {
  var o = pe("stencil-preview"), l = pe("draggable-area"), d = pe("bounding-box");
  return p(), Fe("div", { class: i.classes.stencil, style: i.style }, [N(d, { width: s.stencilCoordinates.width, height: s.stencilCoordinates.height, transitions: s.transitions, class: i.classes.boundingBox, handlers: s.handlers, "handlers-component": s.handlersComponent, "handlers-classes": s.handlersClasses, "handlers-wrappers-classes": s.handlersWrappersClasses, lines: s.lines, "lines-component": s.linesComponent, "lines-classes": s.linesClasses, "lines-wrappers-classes": s.linesWrappersClasses, resizable: s.resizable, onResize: i.onResize, onResizeEnd: i.onResizeEnd }, { default: ve(function() {
    return [N(l, { movable: s.movable, onMove: i.onMove, onMoveEnd: i.onMoveEnd }, { default: ve(function() {
      return [N(o, { image: s.image, coordinates: s.coordinates, width: s.stencilCoordinates.width, height: s.stencilCoordinates.height, class: i.classes.preview, transitions: s.transitions }, null, 8, ["image", "coordinates", "width", "height", "class", "transitions"])];
    }), _: 1 }, 8, ["movable", "onMove", "onMoveEnd"])];
  }), _: 1 }, 8, ["width", "height", "transitions", "class", "handlers", "handlers-component", "handlers-classes", "handlers-wrappers-classes", "lines", "lines-component", "lines-classes", "lines-wrappers-classes", "resizable", "onResize", "onResizeEnd"])], 6);
};
var aX = ["transitions"], lo = yr("vue-advanced-cropper"), yb = { name: "Cropper", components: { BackgroundWrapper: hy }, props: { src: { type: String, default: null }, stencilComponent: { type: [Object, String], default: function() {
  return Dk;
} }, backgroundWrapperComponent: { type: [Object, String], default: function() {
  return hy;
} }, stencilProps: { type: Object, default: function() {
  return {};
} }, autoZoom: { type: Boolean, default: !1 }, imageClass: { type: String }, boundariesClass: { type: String }, backgroundClass: { type: String }, foregroundClass: { type: String }, minWidth: { type: [Number, String] }, minHeight: { type: [Number, String] }, maxWidth: { type: [Number, String] }, maxHeight: { type: [Number, String] }, debounce: { type: [Boolean, Number], default: 500 }, transitions: { type: Boolean, default: !0 }, checkOrientation: { type: Boolean, default: !0 }, canvas: { type: [Object, Boolean], default: !0 }, crossOrigin: { type: [Boolean, String], default: void 0 }, transitionTime: { type: Number, default: 300 }, imageRestriction: { type: String, default: "fit-area", validator: function(e) {
  return FY.indexOf(e) !== -1;
} }, roundResult: { type: Boolean, default: !0 }, defaultSize: { type: [Function, Object] }, defaultPosition: { type: [Function, Object] }, defaultVisibleArea: { type: [Function, Object] }, defaultTransforms: { type: [Function, Object] }, defaultBoundaries: { type: [Function, String], validator: function(e) {
  return !(typeof e == "string" && e !== "fill" && e !== "fit");
} }, priority: { type: String, default: "coordinates" }, stencilSize: { type: [Object, Function] }, resizeImage: { type: [Boolean, Object], default: !0 }, moveImage: { type: [Boolean, Object], default: !0 }, autoZoomAlgorithm: { type: Function }, resizeAlgorithm: { type: Function, default: function(e) {
  var t = e.event, s = e.coordinates, n = e.aspectRatio, r = e.positionRestrictions, i = e.sizeRestrictions, o = Gt(Gt({}, s), { right: s.left + s.width, bottom: s.top + s.height }), l = t.params || {}, d = Gt({}, t.directions), c = l.allowedDirections || { left: !0, right: !0, bottom: !0, top: !0 };
  i.widthFrozen && (d.left = 0, d.right = 0), i.heightFrozen && (d.top = 0, d.bottom = 0), Fr.forEach(function(k) {
    c[k] || (d[k] = 0);
  });
  var u = Lr(o, d = R2({ coordinates: o, directions: d, sizeRestrictions: i, positionRestrictions: r })).width, m = Lr(o, d).height, f = l.preserveRatio ? js(o) : Ig(u / m, n);
  if (f) {
    var v = l.respectDirection;
    if (v || (v = o.width >= o.height || f === 1 ? "width" : "height"), v === "width") {
      var b = u / f - o.height;
      if (c.top && c.bottom) {
        var w = d.top, S = d.bottom;
        d.bottom = Lp(b, S, w), d.top = Lp(b, w, S);
      } else c.bottom ? d.bottom = b : c.top ? d.top = b : c.right ? d.right = 0 : c.left && (d.left = 0);
    } else if (v === "height") {
      var I = o.width - m * f;
      if (c.left && c.right) {
        var T = d.left, x = d.right;
        d.left = -Lp(I, T, x), d.right = -Lp(I, x, T);
      } else c.left ? d.left = -I : c.right ? d.right = -I : c.top ? d.top = 0 : c.bottom && (d.bottom = 0);
    }
    d = R2({ directions: d, coordinates: o, sizeRestrictions: i, positionRestrictions: r, preserveRatio: !0, compensate: l.compensate });
  }
  return u = Lr(o, d).width, m = Lr(o, d).height, (f = l.preserveRatio ? js(o) : Ig(u / m, n)) && Math.abs(f - u / m) > 1e-3 && Fr.forEach(function(k) {
    c[k] || (d[k] = 0);
  }), py({ event: new hb({ left: -d.left, top: -d.top }), coordinates: { width: s.width + d.right + d.left, height: s.height + d.top + d.bottom, left: s.left, top: s.top }, positionRestrictions: r });
} }, moveAlgorithm: { type: Function, default: py }, initStretcher: { type: Function, default: function(e) {
  var t = e.stretcher, s = e.imageSize, n = js(s);
  t.style.width = s.width + "px", t.style.height = t.clientWidth / n + "px", t.style.width = t.clientWidth + "px";
} }, fitCoordinates: { type: Function, default: function(e) {
  var t = e.visibleArea, s = e.coordinates, n = e.aspectRatio, r = e.sizeRestrictions, i = e.positionRestrictions, o = Gt(Gt({}, s), Co({ width: s.width, height: s.height, aspectRatio: n, sizeRestrictions: { maxWidth: t.width, maxHeight: t.height, minHeight: Math.min(t.height, r.minHeight), minWidth: Math.min(t.width, r.minWidth) } }));
  return o = en(o = Rn(o, Md(_a(s), _a(o))), ff(Gr(t), i));
} }, fitVisibleArea: { type: Function, default: function(e) {
  var t = e.visibleArea, s = e.boundaries, n = e.getAreaRestrictions, r = e.coordinates, i = Gt({}, t);
  i.height = i.width / js(s), i.top += (t.height - i.height) / 2, (r.height - i.height > 0 || r.width - i.width > 0) && (i = rr(i, Math.max(r.height / i.height, r.width / i.width)));
  var o = hf(Fd(r, Gr(i = rr(i, mf(i, n({ visibleArea: i, type: "resize" }))))));
  return i.width < r.width && (o.left = 0), i.height < r.height && (o.top = 0), i = en(i = Rn(i, o), n({ visibleArea: i, type: "move" }));
} }, areaRestrictionsAlgorithm: { type: Function, default: function(e) {
  var t = e.visibleArea, s = e.boundaries, n = e.imageSize, r = e.imageRestriction, i = e.type, o = {};
  return r === "fill-area" ? o = { left: 0, top: 0, right: n.width, bottom: n.height } : r === "fit-area" && (js(s) > js(n) ? (o = { top: 0, bottom: n.height }, t && i === "move" && (t.width > n.width ? (o.left = -(t.width - n.width) / 2, o.right = n.width - o.left) : (o.left = 0, o.right = n.width))) : (o = { left: 0, right: n.width }, t && i === "move" && (t.height > n.height ? (o.top = -(t.height - n.height) / 2, o.bottom = n.height - o.top) : (o.top = 0, o.bottom = n.height)))), o;
} }, sizeRestrictionsAlgorithm: { type: Function, default: function(e) {
  return { minWidth: e.minWidth, minHeight: e.minHeight, maxWidth: e.maxWidth, maxHeight: e.maxHeight };
} }, positionRestrictionsAlgorithm: { type: Function, default: function(e) {
  var t = e.imageSize, s = {};
  return e.imageRestriction !== "none" && (s = { left: 0, top: 0, right: t.width, bottom: t.height }), s;
} } }, data: function() {
  return { transitionsActive: !1, imageLoaded: !1, imageAttributes: { width: null, height: null, crossOrigin: null, src: null }, defaultImageTransforms: { rotate: 0, flip: { horizontal: !1, vertical: !1 } }, appliedImageTransforms: { rotate: 0, flip: { horizontal: !1, vertical: !1 } }, boundaries: { width: 0, height: 0 }, visibleArea: null, coordinates: Vs({}, E2) };
}, computed: { image: function() {
  return { src: this.imageAttributes.src, width: this.imageAttributes.width, height: this.imageAttributes.height, transforms: this.imageTransforms };
}, imageTransforms: function() {
  return { rotate: this.appliedImageTransforms.rotate, flip: { horizontal: this.appliedImageTransforms.flip.horizontal, vertical: this.appliedImageTransforms.flip.vertical }, translateX: this.visibleArea ? this.visibleArea.left / this.coefficient : 0, translateY: this.visibleArea ? this.visibleArea.top / this.coefficient : 0, scaleX: 1 / this.coefficient, scaleY: 1 / this.coefficient };
}, imageSize: function() {
  var e = function(t) {
    return t * Math.PI / 180;
  }(this.imageTransforms.rotate);
  return { width: Math.abs(this.imageAttributes.width * Math.cos(e)) + Math.abs(this.imageAttributes.height * Math.sin(e)), height: Math.abs(this.imageAttributes.width * Math.sin(e)) + Math.abs(this.imageAttributes.height * Math.cos(e)) };
}, initialized: function() {
  return !!(this.visibleArea && this.imageLoaded);
}, settings: function() {
  var e = cy(this.resizeImage, { touch: !0, wheel: { ratio: 0.1 }, adjustStencil: !0 }, { touch: !1, wheel: !1, adjustStencil: !1 });
  return { moveImage: cy(this.moveImage, { touch: !0, mouse: !0 }, { touch: !1, mouse: !1 }), resizeImage: e };
}, coefficient: function() {
  return this.visibleArea ? this.visibleArea.width / this.boundaries.width : 0;
}, areaRestrictions: function() {
  return this.imageLoaded ? this.areaRestrictionsAlgorithm({ imageSize: this.imageSize, imageRestriction: this.imageRestriction, boundaries: this.boundaries }) : {};
}, transitionsOptions: function() {
  return { enabled: this.transitionsActive, timingFunction: "ease-in-out", time: 350 };
}, sizeRestrictions: function() {
  if (this.boundaries.width && this.boundaries.height && this.imageSize.width && this.imageSize.height) {
    var e = this.sizeRestrictionsAlgorithm({ imageSize: this.imageSize, minWidth: Ya(this.minWidth) ? 0 : Op(this.minWidth), minHeight: Ya(this.minHeight) ? 0 : Op(this.minHeight), maxWidth: Ya(this.maxWidth) ? 1 / 0 : Op(this.maxWidth), maxHeight: Ya(this.maxHeight) ? 1 / 0 : Op(this.maxHeight) });
    if (e = function(n) {
      var r = n.areaRestrictions, i = n.sizeRestrictions, o = n.boundaries, l = n.positionRestrictions, d = Gt(Gt({}, i), { minWidth: i.minWidth !== void 0 ? i.minWidth : 0, minHeight: i.minHeight !== void 0 ? i.minHeight : 0, maxWidth: i.maxWidth !== void 0 ? i.maxWidth : 1 / 0, maxHeight: i.maxHeight !== void 0 ? i.maxHeight : 1 / 0 });
      l.left !== void 0 && l.right !== void 0 && (d.maxWidth = Math.min(d.maxWidth, l.right - l.left)), l.bottom !== void 0 && l.top !== void 0 && (d.maxHeight = Math.min(d.maxHeight, l.bottom - l.top));
      var c = uy(r), u = Rk(o, c);
      return c.width < 1 / 0 && (!d.maxWidth || d.maxWidth > u.width) && (d.maxWidth = Math.min(d.maxWidth, u.width)), c.height < 1 / 0 && (!d.maxHeight || d.maxHeight > u.height) && (d.maxHeight = Math.min(d.maxHeight, u.height)), d.minWidth > d.maxWidth && (d.minWidth = d.maxWidth, d.widthFrozen = !0), d.minHeight > d.maxHeight && (d.minHeight = d.maxHeight, d.heightFrozen = !0), d;
    }({ sizeRestrictions: e, areaRestrictions: this.getAreaRestrictions({ visibleArea: this.visibleArea, type: "resize" }), imageSize: this.imageSize, boundaries: this.boundaries, positionRestrictions: this.positionRestrictions, imageRestriction: this.imageRestriction, visibleArea: this.visibleArea, stencilSize: this.getStencilSize() }), this.visibleArea && this.stencilSize) {
      var t = this.getStencilSize(), s = uy(this.getAreaRestrictions({ visibleArea: this.visibleArea, type: "resize" }));
      e.maxWidth = Math.min(e.maxWidth, s.width * t.width / this.boundaries.width), e.maxHeight = Math.min(e.maxHeight, s.height * t.height / this.boundaries.height), e.maxWidth < e.minWidth && (e.minWidth = e.maxWidth), e.maxHeight < e.minHeight && (e.minHeight = e.maxHeight);
    }
    return e;
  }
  return { minWidth: 0, minHeight: 0, maxWidth: 0, maxHeight: 0 };
}, positionRestrictions: function() {
  return this.positionRestrictionsAlgorithm({ imageSize: this.imageSize, imageRestriction: this.imageRestriction });
}, classes: function() {
  return { cropper: lo(), image: Ua(lo("image"), this.imageClass), stencil: lo("stencil"), boundaries: Ua(lo("boundaries"), this.boundariesClass), stretcher: Ua(lo("stretcher")), background: Ua(lo("background"), this.backgroundClass), foreground: Ua(lo("foreground"), this.foregroundClass), imageWrapper: Ua(lo("image-wrapper")), cropperWrapper: Ua(lo("cropper-wrapper")) };
}, stencilCoordinates: function() {
  if (this.initialized) {
    var e = this.coordinates, t = e.width, s = e.height, n = e.left, r = e.top;
    return { width: t / this.coefficient, height: s / this.coefficient, left: (n - this.visibleArea.left) / this.coefficient, top: (r - this.visibleArea.top) / this.coefficient };
  }
  return this.defaultCoordinates();
}, boundariesStyle: function() {
  var e = { width: this.boundaries.width ? "".concat(Math.round(this.boundaries.width), "px") : "auto", height: this.boundaries.height ? "".concat(Math.round(this.boundaries.height), "px") : "auto", transition: "opacity ".concat(this.transitionTime, "ms"), pointerEvents: this.imageLoaded ? "all" : "none" };
  return this.imageLoaded || (e.opacity = "0"), e;
}, imageStyle: function() {
  var e = this.imageAttributes.width > this.imageAttributes.height ? { width: Math.min(1024, this.imageAttributes.width), height: Math.min(1024, this.imageAttributes.width) / (this.imageAttributes.width / this.imageAttributes.height) } : { height: Math.min(1024, this.imageAttributes.height), width: Math.min(1024, this.imageAttributes.height) * (this.imageAttributes.width / this.imageAttributes.height) }, t = { left: (e.width - this.imageSize.width) / (2 * this.coefficient), top: (e.height - this.imageSize.height) / (2 * this.coefficient) }, s = { left: (1 - 1 / this.coefficient) * e.width / 2, top: (1 - 1 / this.coefficient) * e.height / 2 }, n = Vs(Vs({}, this.imageTransforms), {}, { scaleX: this.imageTransforms.scaleX * (this.imageAttributes.width / e.width), scaleY: this.imageTransforms.scaleY * (this.imageAttributes.height / e.height) }), r = { width: "".concat(e.width, "px"), height: "".concat(e.height, "px"), left: "0px", top: "0px", transform: "translate(".concat(-t.left - s.left - this.imageTransforms.translateX, "px, ").concat(-t.top - s.top - this.imageTransforms.translateY, "px)") + xk(n) };
  return this.transitionsOptions.enabled && (r.transition = "".concat(this.transitionsOptions.time, "ms ").concat(this.transitionsOptions.timingFunction)), r;
} }, watch: { src: function() {
  this.onChangeImage();
}, stencilComponent: function() {
  var e = this;
  this.$nextTick(function() {
    e.resetCoordinates(), e.runAutoZoom("setCoordinates"), e.onChange();
  });
}, minWidth: function() {
  this.onPropsChange();
}, maxWidth: function() {
  this.onPropsChange();
}, minHeight: function() {
  this.onPropsChange();
}, maxHeight: function() {
  this.onPropsChange();
}, imageRestriction: function() {
  this.reset();
}, stencilProps: function(e, t) {
  ["aspectRatio", "minAspectRatio", "maxAspectRatio"].find(function(s) {
    return e[s] !== t[s];
  }) && this.$nextTick(this.onPropsChange);
} }, created: function() {
  this.debouncedUpdate = dy(this.update, this.debounce), this.debouncedDisableTransitions = dy(this.disableTransitions, this.transitionsOptions.time), this.awaiting = !1;
}, mounted: function() {
  this.$refs.image.addEventListener("load", this.onSuccessLoadImage), this.$refs.image.addEventListener("error", this.onFailLoadImage), this.onChangeImage(), window.addEventListener("resize", this.refresh), window.addEventListener("orientationchange", this.refresh);
}, unmounted: function() {
  window.removeEventListener("resize", this.refresh), window.removeEventListener("orientationchange", this.refresh), this.imageAttributes.revoke && this.imageAttributes.src && URL.revokeObjectURL(this.imageAttributes.src), this.debouncedUpdate.clear(), this.debouncedDisableTransitions.clear();
}, methods: { getResult: function() {
  var e = this.initialized ? this.prepareResult(Vs({}, this.coordinates)) : this.defaultCoordinates(), t = { rotate: this.imageTransforms.rotate % 360, flip: Vs({}, this.imageTransforms.flip) };
  if (this.src && this.imageLoaded) {
    var s = this;
    return { image: this.image, coordinates: e, visibleArea: this.visibleArea ? Vs({}, this.visibleArea) : null, imageTransforms: t, get canvas() {
      return s.canvas ? s.getCanvas() : void 0;
    } };
  }
  return { image: this.image, coordinates: e, visibleArea: this.visibleArea ? Vs({}, this.visibleArea) : null, canvas: void 0, imageTransforms: t };
}, zoom: function(e, t) {
  var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, n = s.transitions, r = n === void 0 || n;
  this.onManipulateImage(new nu({}, { factor: 1 / e, center: t }), { normalize: !1, transitions: r });
}, move: function(e, t) {
  var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, n = s.transitions, r = n === void 0 || n;
  this.onManipulateImage(new nu({ left: e || 0, top: t || 0 }), { normalize: !1, transitions: r });
}, setCoordinates: function(e) {
  var t = this, s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = s.autoZoom, r = n === void 0 || n, i = s.transitions, o = i === void 0 || i;
  this.$nextTick(function() {
    t.imageLoaded ? (t.transitionsActive || (o && t.enableTransitions(), t.coordinates = t.applyTransform(e), r && t.runAutoZoom("setCoordinates"), o && t.debouncedDisableTransitions()), t.onChange()) : t.delayedTransforms = e;
  });
}, refresh: function() {
  var e = this, t = this.$refs.image;
  if (this.src && t) return this.initialized ? this.updateVisibleArea().then(function() {
    e.onChange();
  }) : this.resetVisibleArea().then(function() {
    e.onChange();
  });
}, reset: function() {
  var e = this;
  return this.resetVisibleArea().then(function() {
    e.onChange(!1);
  });
}, awaitRender: function(e) {
  var t = this;
  this.awaiting || (this.awaiting = !0, this.$nextTick(function() {
    e(), t.awaiting = !1;
  }));
}, prepareResult: function(e) {
  return this.roundResult ? function(t) {
    var s = t.coordinates, n = t.sizeRestrictions, r = t.positionRestrictions, i = { width: Math.round(s.width), height: Math.round(s.height), left: Math.round(s.left), top: Math.round(s.top) };
    return i.width > n.maxWidth ? i.width = Math.floor(s.width) : i.width < n.minWidth && (i.width = Math.ceil(s.width)), i.height > n.maxHeight ? i.height = Math.floor(s.height) : i.height < n.minHeight && (i.height = Math.ceil(s.height)), en(i, r);
  }(Vs(Vs({}, this.getPublicProperties()), {}, { positionRestrictions: Rp(this.positionRestrictions, this.visibleArea), coordinates: e })) : e;
}, processAutoZoom: function(e, t, s, n) {
  var r = this.autoZoomAlgorithm;
  r || (r = this.stencilSize ? NY : this.autoZoom ? jY : HY);
  var i = r({ event: { type: e, params: n }, visibleArea: t, coordinates: s, boundaries: this.boundaries, aspectRatio: this.getAspectRatio(), positionRestrictions: this.positionRestrictions, getAreaRestrictions: this.getAreaRestrictions, sizeRestrictions: this.sizeRestrictions, stencilSize: this.getStencilSize() });
  return Vs(Vs({}, i), {}, { changed: !I2(i.visibleArea, t) || !I2(i.coordinates, s) });
}, runAutoZoom: function(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, s = t.transitions, n = s !== void 0 && s, r = TY(t, aX), i = this.processAutoZoom(e, this.visibleArea, this.coordinates, r), o = i.visibleArea, l = i.coordinates, d = i.changed;
  n && d && this.enableTransitions(), this.visibleArea = o, this.coordinates = l, n && d && this.debouncedDisableTransitions();
}, normalizeEvent: function(e) {
  return function(t) {
    var s = t.event, n = t.visibleArea, r = t.coefficient;
    if (s.type === "manipulateImage") return Gt(Gt({}, s), { move: { left: s.move && s.move.left ? r * s.move.left : 0, top: s.move && s.move.top ? r * s.move.top : 0 }, scale: { factor: s.scale && s.scale.factor ? s.scale.factor : 1, center: s.scale && s.scale.center ? { left: s.scale.center.left * r + n.left, top: s.scale.center.top * r + n.top } : null } });
    if (s.type === "resize") {
      var i = Gt(Gt({}, s), { directions: Gt({}, s.directions) });
      return Fr.forEach(function(l) {
        i.directions[l] *= r;
      }), i;
    }
    if (s.type === "move") {
      var o = Gt(Gt({}, s), { directions: Gt({}, s.directions) });
      return xY.forEach(function(l) {
        o.directions[l] *= r;
      }), o;
    }
    return s;
  }(Vs(Vs({}, this.getPublicProperties()), {}, { event: e }));
}, getCanvas: function() {
  if (this.$refs.canvas) {
    var e = this.$refs.canvas, t = this.$refs.image, s = this.imageTransforms.rotate !== 0 || this.imageTransforms.flip.horizontal || this.imageTransforms.flip.vertical ? function(l, d, c) {
      var u = c.rotate, m = c.flip, f = { width: d.naturalWidth, height: d.naturalHeight }, v = Lk(f, u), b = l.getContext("2d");
      l.height = v.height, l.width = v.width, b.save();
      var w = oi(_a(Gt({ left: 0, top: 0 }, f)), u);
      return b.translate(-(w.left - v.width / 2), -(w.top - v.height / 2)), b.rotate(u * Math.PI / 180), b.translate(m.horizontal ? f.width : 0, m.vertical ? f.height : 0), b.scale(m.horizontal ? -1 : 1, m.vertical ? -1 : 1), b.drawImage(d, 0, 0, f.width, f.height), b.restore(), l;
    }(this.$refs.sourceCanvas, t, this.imageTransforms) : t, n = Vs({ minWidth: 0, minHeight: 0, maxWidth: 1 / 0, maxHeight: 1 / 0, maxArea: this.maxCanvasSize, imageSmoothingEnabled: !0, imageSmoothingQuality: "high", fillColor: "transparent" }, this.canvas), r = function(l) {
      return l.find(function(d) {
        return c = d, !Number.isNaN(parseFloat(c)) && isFinite(c);
        var c;
      });
    }, i = Co({ sizeRestrictions: { minWidth: r([n.width, n.minWidth]) || 0, minHeight: r([n.height, n.minHeight]) || 0, maxWidth: r([n.width, n.maxWidth]) || 1 / 0, maxHeight: r([n.height, n.maxHeight]) || 1 / 0 }, width: this.coordinates.width, height: this.coordinates.height, aspectRatio: { minimum: this.coordinates.width / this.coordinates.height, maximum: this.coordinates.width / this.coordinates.height } });
    if (n.maxArea && i.width * i.height > n.maxArea) {
      var o = Math.sqrt(n.maxArea / (i.width * i.height));
      i = { width: Math.round(o * i.width), height: Math.round(o * i.height) };
    }
    return function(l, d, c, u, m) {
      l.width = u ? u.width : c.width, l.height = u ? u.height : c.height;
      var f = l.getContext("2d");
      f.clearRect(0, 0, l.width, l.height), m && (m.imageSmoothingEnabled && (f.imageSmoothingEnabled = m.imageSmoothingEnabled), m.imageSmoothingQuality && (f.imageSmoothingQuality = m.imageSmoothingQuality), m.fillColor && (f.fillStyle = m.fillColor, f.fillRect(0, 0, l.width, l.height), f.save()));
      var v = c.left < 0 ? -c.left : 0, b = c.top < 0 ? -c.top : 0;
      f.drawImage(d, c.left + v, c.top + b, c.width, c.height, v * (l.width / c.width), b * (l.height / c.height), l.width, l.height);
    }(e, s, this.coordinates, i, n), e;
  }
}, update: function() {
  this.$emit("change", this.getResult());
}, applyTransform: function(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 && arguments[1], s = this.visibleArea && t ? VY(this.sizeRestrictions, this.visibleArea) : this.sizeRestrictions, n = this.visibleArea && t ? Rp(this.positionRestrictions, this.visibleArea) : this.positionRestrictions;
  return DY({ transform: e, coordinates: this.coordinates, imageSize: this.imageSize, sizeRestrictions: s, positionRestrictions: n, aspectRatio: this.getAspectRatio(), visibleArea: this.visibleArea });
}, resetCoordinates: function() {
  var e = this;
  if (this.$refs.image) {
    this.$refs.cropper, this.$refs.image;
    var t = this.defaultSize;
    t || (t = this.stencilSize ? WY : zY);
    var s = this.sizeRestrictions;
    s.minWidth, s.minHeight, s.maxWidth, s.maxHeight;
    var n = xl(t) ? t({ boundaries: this.boundaries, imageSize: this.imageSize, aspectRatio: this.getAspectRatio(), sizeRestrictions: this.sizeRestrictions, stencilSize: this.getStencilSize(), visibleArea: this.visibleArea }) : t, r = this.defaultPosition || UY, i = [n, function(o) {
      var l = o.coordinates;
      return Vs({}, xl(r) ? r({ coordinates: l, imageSize: e.imageSize, visibleArea: e.visibleArea }) : e.defaultPosition);
    }];
    this.delayedTransforms && i.push.apply(i, ll(Array.isArray(this.delayedTransforms) ? this.delayedTransforms : [this.delayedTransforms])), this.coordinates = this.applyTransform(i, !0), this.delayedTransforms = null;
  }
}, clearImage: function() {
  var e = this;
  this.imageLoaded = !1, setTimeout(function() {
    var t = e.$refs.stretcher;
    t && (t.style.height = "auto", t.style.width = "auto"), e.coordinates = e.defaultCoordinates(), e.boundaries = { width: 0, height: 0 };
  }, this.transitionTime);
}, enableTransitions: function() {
  this.transitions && (this.transitionsActive = !0);
}, disableTransitions: function() {
  this.transitionsActive = !1;
}, updateBoundaries: function() {
  var e = this, t = this.$refs.stretcher, s = this.$refs.cropper;
  return this.initStretcher({ cropper: s, stretcher: t, imageSize: this.imageSize }), this.$nextTick().then(function() {
    var n = { cropper: s, imageSize: e.imageSize };
    if (xl(e.defaultBoundaries) ? e.boundaries = e.defaultBoundaries(n) : e.defaultBoundaries === "fit" ? e.boundaries = function(r) {
      var i = r.cropper, o = r.imageSize, l = i.clientHeight, d = i.clientWidth, c = l, u = o.width * l / o.height;
      return u > d && (u = d, c = o.height * d / o.width), { width: u, height: c };
    }(n) : e.boundaries = function(r) {
      var i = r.cropper;
      return { width: i.clientWidth, height: i.clientHeight };
    }(n), !e.boundaries.width || !e.boundaries.height) throw new Error("It's impossible to fit the cropper in the current container");
  });
}, resetVisibleArea: function() {
  var e = this;
  return this.appliedImageTransforms = Vs(Vs({}, this.defaultImageTransforms), {}, { flip: Vs({}, this.defaultImageTransforms.flip) }), this.updateBoundaries().then(function() {
    e.priority !== "visible-area" && (e.visibleArea = null, e.resetCoordinates());
    var t, s, n, r, i, o, l = e.defaultVisibleArea || GY;
    e.visibleArea = xl(l) ? l({ imageSize: e.imageSize, boundaries: e.boundaries, coordinates: e.priority !== "visible-area" ? e.coordinates : null, getAreaRestrictions: e.getAreaRestrictions, stencilSize: e.getStencilSize() }) : e.defaultVisibleArea, e.visibleArea = (t = { visibleArea: e.visibleArea, boundaries: e.boundaries, getAreaRestrictions: e.getAreaRestrictions }, s = t.visibleArea, n = t.boundaries, r = t.getAreaRestrictions, i = Gt({}, s), o = js(n), i.width / i.height !== o && (i.height = i.width / o), en(i, r({ visibleArea: i, type: "move" }))), e.priority === "visible-area" ? e.resetCoordinates() : e.coordinates = e.fitCoordinates({ visibleArea: e.visibleArea, coordinates: e.coordinates, aspectRatio: e.getAspectRatio(), positionRestrictions: e.positionRestrictions, sizeRestrictions: e.sizeRestrictions }), e.runAutoZoom("resetVisibleArea");
  }).catch(function() {
    e.visibleArea = null;
  });
}, updateVisibleArea: function() {
  var e = this;
  return this.updateBoundaries().then(function() {
    e.visibleArea = e.fitVisibleArea({ imageSize: e.imageSize, boundaries: e.boundaries, visibleArea: e.visibleArea, coordinates: e.coordinates, getAreaRestrictions: e.getAreaRestrictions }), e.coordinates = e.fitCoordinates({ visibleArea: e.visibleArea, coordinates: e.coordinates, aspectRatio: e.getAspectRatio(), positionRestrictions: e.positionRestrictions, sizeRestrictions: e.sizeRestrictions }), e.runAutoZoom("updateVisibleArea");
  }).catch(function() {
    e.visibleArea = null;
  });
}, onChange: function() {
  var e = !(arguments.length > 0 && arguments[0] !== void 0) || arguments[0];
  e && this.debounce ? this.debouncedUpdate() : this.update();
}, onChangeImage: function() {
  var e, t = this;
  if (this.imageLoaded = !1, this.delayedTransforms = null, this.src) {
    if (function(r) {
      if (P2(r)) return !1;
      var i = window.location, o = /(\w+:)?(?:\/\/)([\w.-]+)?(?::(\d+))?\/?/.exec(r) || [], l = { protocol: o[1] || "", host: o[2] || "", port: o[3] || "" }, d = function(c) {
        return c.port || ((c.protocol || i.protocol) === "http" ? 80 : 433);
      };
      return !(!l.protocol && !l.host && !l.port || l.protocol && l.protocol == i.protocol && l.host && l.host == i.host && l.host && d(l) == d(i));
    }(this.src)) {
      var s = Ya(this.crossOrigin) ? this.canvas : this.crossOrigin;
      s === !0 && (s = "anonymous"), this.imageAttributes.crossOrigin = s || null;
    }
    if (this.checkOrientation) {
      var n = (e = this.src, new Promise(function(r) {
        tX(e).then(function(i) {
          var o = sX(i);
          r(i ? { source: e, arrayBuffer: i, orientation: o } : { source: e, arrayBuffer: null, orientation: null });
        }).catch(function(i) {
          console.warn(i), r({ source: e, arrayBuffer: null, orientation: null });
        });
      }));
      setTimeout(function() {
        n.then(t.onParseImage);
      }, this.transitionTime);
    } else setTimeout(function() {
      t.onParseImage({ source: t.src });
    }, this.transitionTime);
  } else this.clearImage();
}, onFailLoadImage: function() {
  this.imageAttributes.src && (this.clearImage(), this.$emit("error"));
}, onSuccessLoadImage: function() {
  var e = this, t = this.$refs.image;
  t && !this.imageLoaded && (this.imageAttributes.height = t.naturalHeight, this.imageAttributes.width = t.naturalWidth, this.imageLoaded = !0, this.resetVisibleArea().then(function() {
    e.$emit("ready"), e.onChange(!1);
  }));
}, onParseImage: function(e) {
  var t = this, s = e.source, n = e.arrayBuffer, r = e.orientation;
  this.imageAttributes.revoke && this.imageAttributes.src && URL.revokeObjectURL(this.imageAttributes.src), this.imageAttributes.revoke = !1, n && r && r > 1 ? Pk(s) || !P2(s) ? (this.imageAttributes.src = URL.createObjectURL(new Blob([n])), this.imageAttributes.revoke = !0) : this.imageAttributes.src = function(i) {
    for (var o = [], l = new Uint8Array(i); l.length > 0; ) {
      var d = l.subarray(0, 8192);
      o.push(String.fromCharCode.apply(null, Array.from ? Array.from(d) : d.slice())), l = l.subarray(8192);
    }
    return "data:image/jpeg;base64," + btoa(o.join(""));
  }(n) : this.imageAttributes.src = s, xl(this.defaultTransforms) ? this.appliedImageTransforms = Og(this.defaultTransforms()) : Sh(this.defaultTransforms) ? this.appliedImageTransforms = Og(this.defaultTransforms) : this.appliedImageTransforms = function(i) {
    var o = Og({});
    if (i) switch (i) {
      case 2:
        o.flip.horizontal = !0;
        break;
      case 3:
        o.rotate = -180;
        break;
      case 4:
        o.flip.vertical = !0;
        break;
      case 5:
        o.rotate = 90, o.flip.vertical = !0;
        break;
      case 6:
        o.rotate = 90;
        break;
      case 7:
        o.rotate = 90, o.flip.horizontal = !0;
        break;
      case 8:
        o.rotate = -90;
    }
    return o;
  }(r), this.defaultImageTransforms = Vs(Vs({}, this.appliedImageTransforms), {}, { flip: Vs({}, this.appliedImageTransforms.flip) }), this.$nextTick(function() {
    var i = t.$refs.image;
    i && i.complete && (function(o) {
      return !!o.naturalWidth;
    }(i) ? t.onSuccessLoadImage() : t.onFailLoadImage());
  });
}, onResizeEnd: function() {
  this.runAutoZoom("resize", { transitions: !0 });
}, onMoveEnd: function() {
  this.runAutoZoom("move", { transitions: !0 });
}, onMove: function(e) {
  var t = this;
  this.transitionsOptions.enabled || this.awaitRender(function() {
    t.coordinates = t.moveAlgorithm(Vs(Vs({}, t.getPublicProperties()), {}, { positionRestrictions: Rp(t.positionRestrictions, t.visibleArea), coordinates: t.coordinates, event: t.normalizeEvent(e) })), t.onChange();
  });
}, onResize: function(e) {
  var t = this;
  this.transitionsOptions.enabled || this.stencilSize && !this.autoZoom || this.awaitRender(function() {
    var s = t.sizeRestrictions, n = Math.min(t.coordinates.width, t.coordinates.height, 20 * t.coefficient);
    t.coordinates = t.resizeAlgorithm(Vs(Vs({}, t.getPublicProperties()), {}, { positionRestrictions: Rp(t.positionRestrictions, t.visibleArea), sizeRestrictions: { maxWidth: Math.min(s.maxWidth, t.visibleArea.width), maxHeight: Math.min(s.maxHeight, t.visibleArea.height), minWidth: Math.max(s.minWidth, n), minHeight: Math.max(s.minHeight, n) }, event: t.normalizeEvent(e) })), t.onChange(), t.ticking = !1;
  });
}, onManipulateImage: function(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  if (!this.transitionsOptions.enabled) {
    var s = t.transitions, n = s !== void 0 && s, r = t.normalize, i = r === void 0 || r;
    n && this.enableTransitions();
    var o = YY(Vs(Vs({}, this.getPublicProperties()), {}, { event: i ? this.normalizeEvent(e) : e, getAreaRestrictions: this.getAreaRestrictions, imageRestriction: this.imageRestriction, adjustStencil: !this.stencilSize && this.settings.resizeImage.adjustStencil })), l = o.visibleArea, d = o.coordinates;
    this.visibleArea = l, this.coordinates = d, this.runAutoZoom("manipulateImage"), this.onChange(), n && this.debouncedDisableTransitions();
  }
}, onPropsChange: function() {
  this.coordinates = this.applyTransform(this.coordinates, !0), this.onChange(!1);
}, getAreaRestrictions: function() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = e.visibleArea, s = e.type, n = s === void 0 ? "move" : s;
  return this.areaRestrictionsAlgorithm({ boundaries: this.boundaries, imageSize: this.imageSize, imageRestriction: this.imageRestriction, visibleArea: t, type: n });
}, getAspectRatio: function(e) {
  var t, s, n = this.stencilProps, r = n.aspectRatio, i = n.minAspectRatio, o = n.maxAspectRatio;
  if (this.$refs.stencil && this.$refs.stencil.aspectRatios) {
    var l = this.$refs.stencil.aspectRatios();
    t = l.minimum, s = l.maximum;
  }
  if (Ya(t) && (t = Ya(r) ? i : r), Ya(s) && (s = Ya(r) ? o : r), !e && (Ya(t) || Ya(s))) {
    var d = this.getStencilSize(), c = d ? js(d) : null;
    Ya(t) && (t = k2(c) ? c : void 0), Ya(s) && (s = k2(c) ? c : void 0);
  }
  return { minimum: t, maximum: s };
}, getStencilSize: function() {
  if (this.stencilSize) return e = { currentStencilSize: { width: this.stencilCoordinates.width, height: this.stencilCoordinates.height }, stencilSize: this.stencilSize, boundaries: this.boundaries, coefficient: this.coefficient, coordinates: this.coordinates, aspectRatio: this.getAspectRatio(!0) }, t = e.boundaries, s = e.stencilSize, n = e.aspectRatio, Ig(js(r = xl(s) ? s({ boundaries: t, aspectRatio: n }) : s), n) && (r = Co({ sizeRestrictions: { maxWidth: t.width, maxHeight: t.height, minWidth: 0, minHeight: 0 }, width: r.width, height: r.height, aspectRatio: { minimum: n.minimum, maximum: n.maximum } })), (r.width > t.width || r.height > t.height) && (r = Co({ sizeRestrictions: { maxWidth: t.width, maxHeight: t.height, minWidth: 0, minHeight: 0 }, width: r.width, height: r.height, aspectRatio: { minimum: js(r), maximum: js(r) } })), r;
  var e, t, s, n, r;
}, getPublicProperties: function() {
  return { coefficient: this.coefficient, visibleArea: this.visibleArea, coordinates: this.coordinates, boundaries: this.boundaries, sizeRestrictions: this.sizeRestrictions, positionRestrictions: this.positionRestrictions, aspectRatio: this.getAspectRatio(), imageRestriction: this.imageRestriction };
}, defaultCoordinates: function() {
  return Vs({}, E2);
}, flip: function(e, t) {
  var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, n = s.transitions, r = n === void 0 || n;
  if (!this.transitionsActive) {
    r && this.enableTransitions();
    var i = Vs({}, this.imageTransforms.flip), o = qY({ flip: { horizontal: e ? !i.horizontal : i.horizontal, vertical: t ? !i.vertical : i.vertical }, previousFlip: i, rotate: this.imageTransforms.rotate, visibleArea: this.visibleArea, coordinates: this.coordinates, imageSize: this.imageSize, positionRestrictions: this.positionRestrictions, sizeRestrictions: this.sizeRestrictions, getAreaRestrictions: this.getAreaRestrictions, aspectRatio: this.getAspectRatio() }), l = o.visibleArea, d = o.coordinates;
    e && (this.appliedImageTransforms.flip.horizontal = !this.appliedImageTransforms.flip.horizontal), t && (this.appliedImageTransforms.flip.vertical = !this.appliedImageTransforms.flip.vertical), this.visibleArea = l, this.coordinates = d, this.onChange(), r && this.debouncedDisableTransitions();
  }
}, rotate: function(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, s = t.transitions, n = s === void 0 || s;
  if (!this.transitionsActive) {
    n && this.enableTransitions();
    var r = Vs({}, this.imageSize);
    this.appliedImageTransforms.rotate += e;
    var i = XY({ visibleArea: this.visibleArea, coordinates: this.coordinates, previousImageSize: r, imageSize: this.imageSize, angle: e, positionRestrictions: this.positionRestrictions, sizeRestrictions: this.sizeRestrictions, getAreaRestrictions: this.getAreaRestrictions, aspectRatio: this.getAspectRatio() }), o = i.visibleArea, l = i.coordinates, d = this.processAutoZoom("rotateImage", o, l);
    o = d.visibleArea, l = d.coordinates, this.visibleArea = o, this.coordinates = l, this.onChange(), n && this.debouncedDisableTransitions();
  }
} }, emits: ["change", "error", "ready"] }, nX = { key: 0, ref: "canvas", style: { display: "none" } }, rX = { key: 1, ref: "sourceCanvas", style: { display: "none" } };
yb.render = function(e, t, s, n, r, i) {
  return p(), Fe("div", { ref: "cropper", class: i.classes.cropper }, [N("div", { ref: "stretcher", class: i.classes.stretcher }, null, 2), N("div", { class: i.classes.boundaries, style: i.boundariesStyle }, [(p(), Fe(lu(s.backgroundWrapperComponent), { class: i.classes.cropperWrapper, "wheel-resize": i.settings.resizeImage.wheel, "touch-resize": i.settings.resizeImage.touch, "touch-move": i.settings.moveImage.touch, "mouse-move": i.settings.moveImage.mouse, onMove: i.onManipulateImage, onResize: i.onManipulateImage }, { default: ve(function() {
    return [N("div", { class: i.classes.background, style: i.boundariesStyle }, null, 6), N("div", { class: i.classes.imageWrapper }, [N("img", { ref: "image", crossorigin: r.imageAttributes.crossOrigin, src: r.imageAttributes.src, class: i.classes.image, style: i.imageStyle, onMousedown: t[1] || (t[1] = mn(function() {
    }, ["prevent"])) }, null, 46, ["crossorigin", "src"])], 2), N("div", { class: i.classes.foreground, style: i.boundariesStyle }, null, 6), V((p(), Fe(lu(s.stencilComponent), Rs({ ref: "stencil", image: i.image, coordinates: r.coordinates, "stencil-coordinates": i.stencilCoordinates, transitions: i.transitionsOptions }, s.stencilProps, { onResize: i.onResize, onResizeEnd: i.onResizeEnd, onMove: i.onMove, onMoveEnd: i.onMoveEnd }), null, 16, ["image", "coordinates", "stencil-coordinates", "transitions", "onResize", "onResizeEnd", "onMove", "onMoveEnd"])), [[Us, r.imageLoaded]]), s.canvas ? (p(), Fe("canvas", nX, null, 512)) : P("", !0), s.canvas ? (p(), Fe("canvas", rX, null, 512)) : P("", !0)];
  }), _: 1 }, 8, ["class", "wheel-resize", "touch-resize", "touch-move", "mouse-move", "onMove", "onResize"]))], 6)], 2);
};
const oX = me({
  components: {
    StencilPreview: vb,
    DraggableArea: gb,
    DraggableElement: pf
  },
  emits: [
    "move",
    "move-end",
    "resize",
    "resize-end"
  ],
  props: {
    image: {
      type: Object
    },
    coordinates: {
      type: Object
    },
    transitions: {
      type: Object
    },
    stencilCoordinates: {
      type: Object
    }
  },
  computed: {
    style() {
      const { height: e, width: t, left: s, top: n } = this.stencilCoordinates, r = {
        width: `${t}px`,
        height: `${e}px`,
        transform: `translate(${s}px, ${n}px)`,
        transition: void 0
      };
      return this.transitions && this.transitions.enabled && (r.transition = `${this.transitions.time}ms ${this.transitions.timingFunction}`), r;
    }
  },
  methods: {
    onMove(e) {
      this.$emit("move", e);
    },
    onMoveEnd() {
      this.$emit("move-end");
    },
    onResize(e) {
      const t = e.shift(), s = t.left, n = -t.top, r = new Ik(
        {
          left: s,
          right: s,
          top: n,
          bottom: n
        },
        {
          compensate: !0
        }
      );
      this.$emit("resize", r);
    },
    onResizeEnd() {
      this.$emit("resize-end");
    },
    aspectRatios() {
      return {
        minimum: 1,
        maximum: 1
      };
    }
  }
}), iX = "data:image/svg+xml,%3c?xml%20version='1.0'%20encoding='utf-8'?%3e%3c!--%20Generator:%20Adobe%20Illustrator%2018.0.0,%20SVG%20Export%20Plug-In%20.%20SVG%20Version:%206.00%20Build%200)%20--%3e%3c!DOCTYPE%20svg%20PUBLIC%20'-//W3C//DTD%20SVG%201.1//EN'%20'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3e%3csvg%20version='1.1'%20id='Isolation_Mode'%20xmlns='http://www.w3.org/2000/svg'%20xmlns:xlink='http://www.w3.org/1999/xlink'%20x='0px'%20y='0px'%20width='26.7px'%20height='26.3px'%20viewBox='0%200%2026.7%2026.3'%20enable-background='new%200%200%2026.7%2026.3'%20xml:space='preserve'%3e%3cpolygon%20fill='%23FFFFFF'%20points='15.1,4.7%2018.3,6%2015.1,9.3%2017.4,11.6%2020.7,8.3%2022,11.6%2026.7,0%20'/%3e%3cpolygon%20fill='%23FFFFFF'%20points='9.3,14.7%206,18%204.7,14.7%200,26.3%2011.6,21.6%208.3,20.3%2011.6,17%20'/%3e%3c/svg%3e";
function lX(e, t, s, n, r, i) {
  const o = pe("draggable-element"), l = pe("stencil-preview"), d = pe("draggable-area");
  return p(), h("div", {
    class: "circle-stencil",
    style: rn(e.style)
  }, [
    N(o, {
      class: "circle-stencil__handler",
      onDrag: e.onResize,
      onDragEnd: e.onResizeEnd
    }, {
      default: ve(() => [
        a("img", {
          src: iX,
          onMousedown: t[0] || (t[0] = mn(() => {
          }, ["prevent"]))
        }, null, 32)
      ]),
      _: 1
    }, 8, ["onDrag", "onDragEnd"]),
    N(d, {
      onMove: e.onMove,
      onMoveEnd: e.onMoveEnd
    }, {
      default: ve(() => [
        N(l, {
          class: "circle-stencil__preview",
          image: e.image,
          coordinates: e.coordinates,
          width: e.stencilCoordinates.width,
          height: e.stencilCoordinates.height,
          transitions: e.transitions
        }, null, 8, ["image", "coordinates", "width", "height", "transitions"])
      ]),
      _: 1
    }, 8, ["onMove", "onMoveEnd"])
  ], 4);
}
const dX = /* @__PURE__ */ Ae(oX, [["render", lX]]), Lg = 3, cX = me({
  name: "IndustryDesignation",
  props: {},
  components: {},
  data() {
    return {
      requestNew: !1,
      maxIndustryDesignations: Lg,
      request: {
        description: "",
        website: ""
      }
    };
  },
  computed: {
    maxSelected() {
      var e;
      return ((e = this.myBranding.industryDesignations) == null ? void 0 : e.length) >= Lg;
    },
    noneSelected() {
      var e;
      return !this.myBranding.industryDesignations || ((e = this.myBranding.industryDesignations) == null ? void 0 : e.length) == 0;
    },
    ...at(Te, ct),
    ...q(Te, ["access", "aclLoaded"]),
    ...q(ct, ["myBranding", "brandingLoading", "industryDesignations", "optionsLoading"])
  },
  methods: {
    async loadAccountOptions() {
      try {
        await this.accountStore.fetchAccountOptions();
      } catch (e) {
        Se(e);
      }
    },
    async updateBranding(e) {
      try {
        await this.accountStore.updateBranding(), wt("Your branding has been updated.");
      } catch (t) {
        (!Zt.isModelStateException(t) || !t.showFormErrors(e.target)) && Se(t);
      }
    },
    showIndustryDesignationDialog() {
      var e;
      this.requestNew = !1, this.request = {}, Zt.clearModelStateErrors(this.$refs.dialogAddIndustryDesignation), (e = bootstrap.Modal.getOrCreateInstance(this.$refs.dialogAddIndustryDesignation)) == null || e.show();
    },
    addIndustryDesignation(e) {
      var t;
      this.myBranding.industryDesignations || (this.myBranding.industryDesignations = []), !(this.myBranding.industryDesignations.indexOf(e) >= 0) && (this.myBranding.industryDesignations.length < Lg && this.myBranding.industryDesignations.push(e), (t = bootstrap.Modal.getOrCreateInstance(this.$refs.dialogAddIndustryDesignation)) == null || t.hide());
    },
    removeDesignation(e) {
      var t;
      this.myBranding.industryDesignations = (t = this.myBranding.industryDesignations) == null ? void 0 : t.filter((s) => s != e);
    },
    async requestNewDesignation(e) {
      var t;
      try {
        await this.accountStore.requestIndustryDesignation(this.request), (t = bootstrap.Modal.getOrCreateInstance(this.$refs.dialogAddIndustryDesignation)) == null || t.hide(), this.requestNew = !1;
      } catch (s) {
        (!Zt.isModelStateException(s) || !s.showFormErrors(e.target)) && Se(s);
      }
    },
    designationTitle(e) {
      var t;
      return (t = this.industryDesignations.find((s) => s.abbreviation == e)) == null ? void 0 : t.title;
    },
    designationLogo(e) {
      return `https://cdn03.rescover.com/widgets/content/images/${e}.png`;
    },
    designationOptionClass(e) {
      var t;
      return {
        "custom-control-label": !0,
        card: !0,
        "card-designation": !0,
        "card-designation-added": e && ((t = this.myBranding.industryDesignations) == null ? void 0 : t.indexOf(e.abbreviation)) >= 0,
        rounded: !0,
        "h-100": !0,
        "d-flex": !0,
        "align-items-center": !0,
        "justify-content-center": !0,
        "flex-column": !0
      };
    }
  },
  mounted() {
    this.aclLoaded.then(async () => await this.loadAccountOptions());
  }
}), Nk = "data:image/png;base64,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", uX = { class: "card shadow-sm" }, pX = { class: "card-header bg-white border-0 d-flex justify-content-between align-items-center flex-row" }, hX = { class: "text-secondary" }, mX = {
  key: 0,
  class: "card-body pt-0"
}, fX = { class: "text-center p-5 d-flex flex-column align-items-center bg-light rounded" }, gX = {
  key: 1,
  class: "card-body row row-cols-1 row-cols-lg-3 g-2 g-lg-3"
}, vX = { class: "col" }, yX = { class: "card card-designed bg-light h-100" }, bX = { class: "card-body d-flex flex-column justify-content-center align-items-center" }, AX = ["onClick"], wX = ["src", "alt", "title"], CX = { class: "text-center" }, SX = {
  class: "modal fade",
  ref: "dialogAddIndustryDesignation",
  id: "dialogAddIndustryDesignation",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}, PX = { class: "modal-dialog modal-dialog-centered modal-lg" }, kX = { class: "modal-content bg-gradient-alphabet rounded" }, EX = { class: "modal-header border-0" }, IX = ["disabled"], TX = { class: "modal-body p-3 py-0" }, OX = {
  key: 0,
  class: "bg-white bg-opacity-50 p-5 rounded"
}, RX = { class: "row row-cols-1 row-cols-lg-3 g-3" }, LX = { class: "col" }, BX = ["title", "onClick"], MX = ["src", "alt", "title"], xX = { class: "text-center" }, FX = { key: 1 }, VX = { class: "row mb-3" }, DX = { class: "col-sm-9" }, NX = ["disabled"], jX = { class: "row" }, HX = { class: "col-sm-9" }, UX = { class: "input-group" }, zX = ["disabled"], WX = { class: "modal-footer bg-transparent justify-content-between border-0" }, GX = {
  key: 0,
  type: "button",
  class: "btn btn-secondary me-auto",
  "data-bs-dismiss": "modal"
}, YX = ["disabled"], XX = ["disabled"];
function qX(e, t, s, n, r, i) {
  return p(), h(A, null, [
    a("div", uX, [
      a("div", pX, [
        a("div", null, [
          t[7] || (t[7] = a("span", { class: "fw-bold fs-5" }, "Industry Designation", -1)),
          t[8] || (t[8] = a("br", null, null, -1)),
          a("span", hX, "Select up to " + g(e.maxIndustryDesignations), 1)
        ]),
        !e.maxSelected && !e.noneSelected ? (p(), h("button", {
          key: 0,
          type: "button",
          onClick: t[0] || (t[0] = (...o) => e.showIndustryDesignationDialog && e.showIndustryDesignationDialog(...o)),
          class: "btn btn-outline-eclipse"
        }, t[9] || (t[9] = [
          a("i", { class: "fa-light fa-plus me-2" }, null, -1),
          y("Add")
        ]))) : P("", !0)
      ]),
      e.noneSelected ? (p(), h("div", mX, [
        a("div", fX, [
          t[11] || (t[11] = a("span", { class: "mb-2" }, "Start by adding one", -1)),
          a("button", {
            type: "button",
            onClick: t[1] || (t[1] = (...o) => e.showIndustryDesignationDialog && e.showIndustryDesignationDialog(...o)),
            class: "btn btn-outline-eclipse"
          }, t[10] || (t[10] = [
            a("i", { class: "fa-light fa-plus me-2" }, null, -1),
            y("Add Designation")
          ]))
        ])
      ])) : (p(), h("div", gX, [
        (p(!0), h(A, null, D(e.myBranding.industryDesignations, (o) => (p(), h("div", vX, [
          a("div", yX, [
            a("div", bX, [
              a("div", {
                onClick: (l) => e.removeDesignation(o),
                class: "btn-icon-round btn-icon-round-danger position-absolute top-0 start-100 translate-middle justify-content-center align-items-center d-flex"
              }, t[12] || (t[12] = [
                a("i", { class: "fa-light fa-xmark text-white" }, null, -1)
              ]), 8, AX),
              a("img", {
                src: e.designationLogo(o),
                alt: e.designationTitle(o),
                title: e.designationTitle(o),
                loading: "lazy",
                class: "img-fluid mb-3",
                width: "100",
                height: "85"
              }, null, 8, wX),
              a("small", CX, g(e.designationTitle(o)), 1)
            ])
          ])
        ]))), 256))
      ]))
    ]),
    a("div", SX, [
      a("div", PX, [
        a("div", kX, [
          a("div", EX, [
            t[13] || (t[13] = a("h1", {
              class: "fw-bold fs-5 modal-title",
              id: "modalHeadshotLabel"
            }, "Industry Designation", -1)),
            a("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close",
              disabled: e.optionsLoading
            }, null, 8, IX)
          ]),
          a("div", TX, [
            t[22] || (t[22] = a("div", {
              class: "alert alert-warning d-none",
              "data-val-summary": ""
            }, " There seems to be an issue. Please try again. ", -1)),
            N(ks, {
              name: "slide",
              mode: "out-in-out"
            }, {
              default: ve(() => [
                e.requestNew ? (p(), h("div", FX, [
                  t[21] || (t[21] = a("p", null, "Tell us which new industry designation you are interested in:", -1)),
                  a("div", VX, [
                    t[17] || (t[17] = a("label", {
                      class: "col-sm-3 col-form-label fw-bold",
                      for: "description"
                    }, "Description", -1)),
                    a("div", DX, [
                      V(a("textarea", {
                        class: "form-control",
                        id: "description",
                        maxlength: "500",
                        "onUpdate:modelValue": t[3] || (t[3] = (o) => e.request.description = o),
                        "data-val-id": "description",
                        disabled: e.optionsLoading
                      }, null, 8, NX), [
                        [_e, e.request.description]
                      ]),
                      t[16] || (t[16] = a("span", { class: "form-text" }, "Describe the industry designation you are requesting for us to add.", -1))
                    ])
                  ]),
                  a("div", jX, [
                    t[20] || (t[20] = a("label", {
                      class: "col-sm-3 col-form-label fw-bold",
                      for: "websiteUrl"
                    }, " Website URL ", -1)),
                    a("div", HX, [
                      a("div", UX, [
                        t[18] || (t[18] = a("span", {
                          class: "input-group-text",
                          id: "basic-addon1"
                        }, [
                          a("i", { class: "fa-light fa-globe-pointer" })
                        ], -1)),
                        V(a("input", {
                          type: "text",
                          class: "form-control",
                          id: "websiteUrl",
                          maxlength: "250",
                          "onUpdate:modelValue": t[4] || (t[4] = (o) => e.request.website = o),
                          "data-val-id": "website",
                          disabled: e.optionsLoading
                        }, null, 8, zX), [
                          [_e, e.request.website]
                        ])
                      ]),
                      t[19] || (t[19] = a("span", { class: "form-text" }, " The website containing more information about industry designation. ", -1))
                    ])
                  ])
                ])) : (p(), h("div", OX, [
                  a("div", RX, [
                    (p(!0), h(A, null, D(e.industryDesignations, (o) => (p(), h("div", LX, [
                      a("div", {
                        class: "custom-control custom-checkbox image-checkbox",
                        title: o.title,
                        onClick: (l) => e.addIndustryDesignation(o.abbreviation)
                      }, [
                        a("label", {
                          class: z(e.designationOptionClass(o))
                        }, [
                          t[14] || (t[14] = a("span", { class: "btn-icon-round bg-primary position-absolute top-0 start-100 translate-middle justify-content-center align-items-center" }, [
                            a("i", { class: "fa-light fa-plus text-white" })
                          ], -1)),
                          a("img", {
                            src: e.designationLogo(o.abbreviation),
                            alt: o.title,
                            title: o.title,
                            class: "img-fluid mb-3",
                            width: "100",
                            height: "85"
                          }, null, 8, MX),
                          a("small", xX, g(o.title), 1)
                        ], 2)
                      ], 8, BX)
                    ]))), 256)),
                    a("div", {
                      class: "col",
                      onClick: t[2] || (t[2] = (o) => e.requestNew = !0)
                    }, t[15] || (t[15] = [
                      a("div", { class: "card card-designation card-designation-request" }, [
                        a("div", { class: "card-body d-flex flex-column align-items-center justify-content-center" }, [
                          a("img", {
                            src: Nk,
                            alt: "rescover",
                            title: "rescover",
                            loading: "lazy",
                            class: "img-fluid mb-4",
                            width: "50",
                            height: "50"
                          }),
                          a("button", {
                            type: "button",
                            class: "btn btn-outline-eclipse btn-sm"
                          }, "Request New")
                        ])
                      ], -1)
                    ]))
                  ])
                ]))
              ]),
              _: 1
            })
          ]),
          a("div", WX, [
            e.requestNew ? (p(), h(A, { key: 1 }, [
              a("button", {
                type: "button",
                class: "btn btn-secondary",
                onClick: t[5] || (t[5] = (o) => e.requestNew = !1),
                disabled: e.optionsLoading
              }, t[23] || (t[23] = [
                a("i", { class: "fa-light fa-angle-left me-2" }, null, -1),
                y("Go back ")
              ]), 8, YX),
              a("button", {
                type: "button",
                class: "btn btn-lava",
                onClick: t[6] || (t[6] = (...o) => e.requestNewDesignation && e.requestNewDesignation(...o)),
                disabled: e.optionsLoading
              }, " Send ", 8, XX)
            ], 64)) : (p(), h("button", GX, "Cancel"))
          ])
        ])
      ])
    ], 512)
  ], 64);
}
const QX = /* @__PURE__ */ Ae(cX, [["render", qX]]);
var Ph = { exports: {} };
var KX = Ph.exports, B2;
function ZX() {
  return B2 || (B2 = 1, function(e, t) {
    (function(s, n) {
      e.exports = n();
    })(typeof self < "u" ? self : KX, function() {
      return function() {
        var s = {
          3976: function(o, l) {
            Object.defineProperty(l, "__esModule", {
              value: !0
            }), l.default = void 0, l.default = {
              _maxTestPos: 500,
              placeholder: "_",
              optionalmarker: ["[", "]"],
              quantifiermarker: ["{", "}"],
              groupmarker: ["(", ")"],
              alternatormarker: "|",
              escapeChar: "\\",
              mask: null,
              regex: null,
              oncomplete: function() {
              },
              onincomplete: function() {
              },
              oncleared: function() {
              },
              repeat: 0,
              greedy: !1,
              autoUnmask: !1,
              removeMaskOnSubmit: !1,
              clearMaskOnLostFocus: !0,
              insertMode: !0,
              insertModeVisual: !0,
              clearIncomplete: !1,
              alias: null,
              onKeyDown: function() {
              },
              onBeforeMask: null,
              onBeforePaste: function(d, c) {
                return typeof c.onBeforeMask == "function" ? c.onBeforeMask.call(this, d, c) : d;
              },
              onBeforeWrite: null,
              onUnMask: null,
              showMaskOnFocus: !0,
              showMaskOnHover: !0,
              onKeyValidation: function() {
              },
              skipOptionalPartCharacter: " ",
              numericInput: !1,
              rightAlign: !1,
              undoOnEscape: !0,
              radixPoint: "",
              _radixDance: !1,
              groupSeparator: "",
              keepStatic: null,
              positionCaretOnTab: !0,
              tabThrough: !1,
              supportsInputType: ["text", "tel", "url", "password", "search"],
              isComplete: null,
              preValidation: null,
              postValidation: null,
              staticDefinitionSymbol: void 0,
              jitMasking: !1,
              nullable: !0,
              inputEventOnly: !1,
              noValuePatching: !1,
              positionCaretOnClick: "lvp",
              casing: null,
              inputmode: "text",
              importDataAttributes: !0,
              shiftPositions: !0,
              usePrototypeDefinitions: !0,
              validationEventTimeOut: 3e3,
              substitutes: {}
            };
          },
          7392: function(o, l) {
            Object.defineProperty(l, "__esModule", {
              value: !0
            }), l.default = void 0, l.default = {
              9: {
                validator: "[0-9０-９]",
                definitionSymbol: "*"
              },
              a: {
                validator: "[A-Za-zА-яЁёÀ-ÿµ]",
                definitionSymbol: "*"
              },
              "*": {
                validator: "[0-9０-９A-Za-zА-яЁёÀ-ÿµ]"
              }
            };
          },
          253: function(o, l) {
            Object.defineProperty(l, "__esModule", {
              value: !0
            }), l.default = function(d, c, u) {
              if (u === void 0) return d.__data ? d.__data[c] : null;
              d.__data = d.__data || {}, d.__data[c] = u;
            };
          },
          3776: function(o, l, d) {
            Object.defineProperty(l, "__esModule", {
              value: !0
            }), l.Event = void 0, l.off = function(T, x) {
              var k, C;
              return S(this[0]) && T && (k = this[0].eventRegistry, C = this[0], T.split(" ").forEach(function(O) {
                var E = f(O.split("."), 2);
                (function(B, M) {
                  var R, F, L = [];
                  if (B.length > 0) if (x === void 0) for (R = 0, F = k[B][M].length; R < F; R++) L.push({
                    ev: B,
                    namespace: M && M.length > 0 ? M : "global",
                    handler: k[B][M][R]
                  });
                  else L.push({
                    ev: B,
                    namespace: M && M.length > 0 ? M : "global",
                    handler: x
                  });
                  else if (M.length > 0) {
                    for (var j in k) for (var H in k[j]) if (H === M) if (x === void 0) for (R = 0, F = k[j][H].length; R < F; R++) L.push({
                      ev: j,
                      namespace: H,
                      handler: k[j][H][R]
                    });
                    else L.push({
                      ev: j,
                      namespace: H,
                      handler: x
                    });
                  }
                  return L;
                })(E[0], E[1]).forEach(function(B) {
                  var M = B.ev, R = B.handler;
                  (function(F, L, j) {
                    if (F in k == 1) if (C.removeEventListener ? C.removeEventListener(F, j, !1) : C.detachEvent && C.detachEvent("on".concat(F), j), L === "global") for (var H in k[F]) k[F][H].splice(k[F][H].indexOf(j), 1);
                    else k[F][L].splice(k[F][L].indexOf(j), 1);
                  })(M, B.namespace, R);
                });
              })), this;
            }, l.on = function(T, x) {
              if (S(this[0])) {
                var k = this[0].eventRegistry, C = this[0];
                T.split(" ").forEach(function(O) {
                  var E = f(O.split("."), 2), B = E[0], M = E[1];
                  (function(R, F) {
                    C.addEventListener ? C.addEventListener(R, x, !1) : C.attachEvent && C.attachEvent("on".concat(R), x), k[R] = k[R] || {}, k[R][F] = k[R][F] || [], k[R][F].push(x);
                  })(B, M === void 0 ? "global" : M);
                });
              }
              return this;
            }, l.trigger = function(T) {
              var x = arguments;
              if (S(this[0])) for (var k = this[0].eventRegistry, C = this[0], O = typeof T == "string" ? T.split(" ") : [T.type], E = 0; E < O.length; E++) {
                var B = O[E].split("."), M = B[0], R = B[1] || "global";
                if (w !== void 0 && R === "global") {
                  var F, L = {
                    bubbles: !0,
                    cancelable: !0,
                    composed: !0,
                    detail: arguments[1]
                  };
                  if (w.createEvent) {
                    try {
                      M === "input" ? (L.inputType = "insertText", F = new InputEvent(M, L)) : F = new CustomEvent(M, L);
                    } catch {
                      (F = w.createEvent("CustomEvent")).initCustomEvent(M, L.bubbles, L.cancelable, L.detail);
                    }
                    T.type && (0, u.default)(F, T), C.dispatchEvent(F);
                  } else (F = w.createEventObject()).eventType = M, F.detail = arguments[1], T.type && (0, u.default)(F, T), C.fireEvent("on" + F.eventType, F);
                } else if (k[M] !== void 0) {
                  arguments[0] = arguments[0].type ? arguments[0] : m.default.Event(arguments[0]), arguments[0].detail = arguments.slice(1);
                  var j = k[M];
                  (R === "global" ? Object.values(j).flat() : j[R]).forEach(function(H) {
                    return H.apply(C, x);
                  });
                }
              }
              return this;
            };
            var c = b(d(9380)), u = b(d(600)), m = b(d(4963));
            function f(T, x) {
              return function(k) {
                if (Array.isArray(k)) return k;
              }(T) || function(k, C) {
                var O = k == null ? null : typeof Symbol < "u" && k[Symbol.iterator] || k["@@iterator"];
                if (O != null) {
                  var E, B, M, R, F = [], L = !0, j = !1;
                  try {
                    if (M = (O = O.call(k)).next, C !== 0) for (; !(L = (E = M.call(O)).done) && (F.push(E.value), F.length !== C); L = !0) ;
                  } catch (H) {
                    j = !0, B = H;
                  } finally {
                    try {
                      if (!L && O.return != null && (R = O.return(), Object(R) !== R)) return;
                    } finally {
                      if (j) throw B;
                    }
                  }
                  return F;
                }
              }(T, x) || function(k, C) {
                if (k) {
                  if (typeof k == "string") return v(k, C);
                  var O = Object.prototype.toString.call(k).slice(8, -1);
                  if (O === "Object" && k.constructor && (O = k.constructor.name), O === "Map" || O === "Set") return Array.from(k);
                  if (O === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(O)) return v(k, C);
                }
              }(T, x) || function() {
                throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
              }();
            }
            function v(T, x) {
              (x == null || x > T.length) && (x = T.length);
              for (var k = 0, C = new Array(x); k < x; k++) C[k] = T[k];
              return C;
            }
            function b(T) {
              return T && T.__esModule ? T : {
                default: T
              };
            }
            var w = c.default.document;
            function S(T) {
              return T instanceof Element;
            }
            var I = l.Event = void 0;
            typeof c.default.CustomEvent == "function" ? l.Event = I = c.default.CustomEvent : c.default.Event && w && w.createEvent ? (l.Event = I = function(T, x) {
              x = x || {
                bubbles: !1,
                cancelable: !1,
                composed: !0,
                detail: void 0
              };
              var k = w.createEvent("CustomEvent");
              return k.initCustomEvent(T, x.bubbles, x.cancelable, x.detail), k;
            }, I.prototype = c.default.Event.prototype) : typeof Event < "u" && (l.Event = I = Event);
          },
          600: function(o, l) {
            function d(c) {
              return d = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(u) {
                return typeof u;
              } : function(u) {
                return u && typeof Symbol == "function" && u.constructor === Symbol && u !== Symbol.prototype ? "symbol" : typeof u;
              }, d(c);
            }
            Object.defineProperty(l, "__esModule", {
              value: !0
            }), l.default = function c() {
              var u, m, f, v, b, w, S = arguments[0] || {}, I = 1, T = arguments.length, x = !1;
              for (typeof S == "boolean" && (x = S, S = arguments[I] || {}, I++), d(S) !== "object" && typeof S != "function" && (S = {}); I < T; I++) if ((u = arguments[I]) != null) for (m in u) f = S[m], S !== (v = u[m]) && (x && v && (Object.prototype.toString.call(v) === "[object Object]" || (b = Array.isArray(v))) ? (b ? (b = !1, w = f && Array.isArray(f) ? f : []) : w = f && Object.prototype.toString.call(f) === "[object Object]" ? f : {}, S[m] = c(x, w, v)) : v !== void 0 && (S[m] = v));
              return S;
            };
          },
          4963: function(o, l, d) {
            Object.defineProperty(l, "__esModule", {
              value: !0
            }), l.default = void 0;
            var c = v(d(9380)), u = v(d(253)), m = d(3776), f = v(d(600));
            function v(S) {
              return S && S.__esModule ? S : {
                default: S
              };
            }
            var b = c.default.document;
            function w(S) {
              return S instanceof w ? S : this instanceof w ? void (S != null && S !== c.default && (this[0] = S.nodeName ? S : S[0] !== void 0 && S[0].nodeName ? S[0] : b.querySelector(S), this[0] !== void 0 && this[0] !== null && (this[0].eventRegistry = this[0].eventRegistry || {}))) : new w(S);
            }
            w.prototype = {
              on: m.on,
              off: m.off,
              trigger: m.trigger
            }, w.extend = f.default, w.data = u.default, w.Event = m.Event, l.default = w;
          },
          9845: function(o, l, d) {
            Object.defineProperty(l, "__esModule", {
              value: !0
            }), l.mobile = l.iphone = l.ie = void 0;
            var c, u = (c = d(9380)) && c.__esModule ? c : {
              default: c
            }, m = u.default.navigator && u.default.navigator.userAgent || "";
            l.ie = m.indexOf("MSIE ") > 0 || m.indexOf("Trident/") > 0, l.mobile = u.default.navigator && u.default.navigator.userAgentData && u.default.navigator.userAgentData.mobile || u.default.navigator && u.default.navigator.maxTouchPoints || "ontouchstart" in u.default, l.iphone = /iphone/i.test(m);
          },
          7184: function(o, l) {
            Object.defineProperty(l, "__esModule", {
              value: !0
            }), l.default = function(c) {
              return c.replace(d, "\\$1");
            };
            var d = new RegExp("(\\" + ["/", ".", "*", "+", "?", "|", "(", ")", "[", "]", "{", "}", "\\", "$", "^"].join("|\\") + ")", "gim");
          },
          6030: function(o, l, d) {
            function c(M) {
              return c = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(R) {
                return typeof R;
              } : function(R) {
                return R && typeof Symbol == "function" && R.constructor === Symbol && R !== Symbol.prototype ? "symbol" : typeof R;
              }, c(M);
            }
            Object.defineProperty(l, "__esModule", {
              value: !0
            }), l.EventHandlers = void 0;
            var u, m = d(9845), f = (u = d(9380)) && u.__esModule ? u : {
              default: u
            }, v = d(7760), b = d(2839), w = d(8711), S = d(7215), I = d(4713);
            function T() {
              T = function() {
                return R;
              };
              var M, R = {}, F = Object.prototype, L = F.hasOwnProperty, j = Object.defineProperty || function(Ge, Ee, Ce) {
                Ge[Ee] = Ce.value;
              }, H = typeof Symbol == "function" ? Symbol : {}, te = H.iterator || "@@iterator", re = H.asyncIterator || "@@asyncIterator", le = H.toStringTag || "@@toStringTag";
              function ie(Ge, Ee, Ce) {
                return Object.defineProperty(Ge, Ee, {
                  value: Ce,
                  enumerable: !0,
                  configurable: !0,
                  writable: !0
                }), Ge[Ee];
              }
              try {
                ie({}, "");
              } catch {
                ie = function(Ee, Ce, xe) {
                  return Ee[Ce] = xe;
                };
              }
              function ye(Ge, Ee, Ce, xe) {
                var Pe = Ee && Ee.prototype instanceof we ? Ee : we, it = Object.create(Pe.prototype), lt = new Ct(xe || []);
                return j(it, "_invoke", {
                  value: Ne(Ge, Ce, lt)
                }), it;
              }
              function Y(Ge, Ee, Ce) {
                try {
                  return {
                    type: "normal",
                    arg: Ge.call(Ee, Ce)
                  };
                } catch (xe) {
                  return {
                    type: "throw",
                    arg: xe
                  };
                }
              }
              R.wrap = ye;
              var ae = "suspendedStart", ke = "suspendedYield", ue = "executing", oe = "completed", fe = {};
              function we() {
              }
              function Ie() {
              }
              function be() {
              }
              var Oe = {};
              ie(Oe, te, function() {
                return this;
              });
              var ze = Object.getPrototypeOf, Re = ze && ze(ze(gt([])));
              Re && Re !== F && L.call(Re, te) && (Oe = Re);
              var ge = be.prototype = we.prototype = Object.create(Oe);
              function he(Ge) {
                ["next", "throw", "return"].forEach(function(Ee) {
                  ie(Ge, Ee, function(Ce) {
                    return this._invoke(Ee, Ce);
                  });
                });
              }
              function Me(Ge, Ee) {
                function Ce(Pe, it, lt, dt) {
                  var vt = Y(Ge[Pe], Ge, it);
                  if (vt.type !== "throw") {
                    var It = vt.arg, Dt = It.value;
                    return Dt && c(Dt) == "object" && L.call(Dt, "__await") ? Ee.resolve(Dt.__await).then(function(ht) {
                      Ce("next", ht, lt, dt);
                    }, function(ht) {
                      Ce("throw", ht, lt, dt);
                    }) : Ee.resolve(Dt).then(function(ht) {
                      It.value = ht, lt(It);
                    }, function(ht) {
                      return Ce("throw", ht, lt, dt);
                    });
                  }
                  dt(vt.arg);
                }
                var xe;
                j(this, "_invoke", {
                  value: function(Pe, it) {
                    function lt() {
                      return new Ee(function(dt, vt) {
                        Ce(Pe, it, dt, vt);
                      });
                    }
                    return xe = xe ? xe.then(lt, lt) : lt();
                  }
                });
              }
              function Ne(Ge, Ee, Ce) {
                var xe = ae;
                return function(Pe, it) {
                  if (xe === ue) throw new Error("Generator is already running");
                  if (xe === oe) {
                    if (Pe === "throw") throw it;
                    return {
                      value: M,
                      done: !0
                    };
                  }
                  for (Ce.method = Pe, Ce.arg = it; ; ) {
                    var lt = Ce.delegate;
                    if (lt) {
                      var dt = $e(lt, Ce);
                      if (dt) {
                        if (dt === fe) continue;
                        return dt;
                      }
                    }
                    if (Ce.method === "next") Ce.sent = Ce._sent = Ce.arg;
                    else if (Ce.method === "throw") {
                      if (xe === ae) throw xe = oe, Ce.arg;
                      Ce.dispatchException(Ce.arg);
                    } else Ce.method === "return" && Ce.abrupt("return", Ce.arg);
                    xe = ue;
                    var vt = Y(Ge, Ee, Ce);
                    if (vt.type === "normal") {
                      if (xe = Ce.done ? oe : ke, vt.arg === fe) continue;
                      return {
                        value: vt.arg,
                        done: Ce.done
                      };
                    }
                    vt.type === "throw" && (xe = oe, Ce.method = "throw", Ce.arg = vt.arg);
                  }
                };
              }
              function $e(Ge, Ee) {
                var Ce = Ee.method, xe = Ge.iterator[Ce];
                if (xe === M) return Ee.delegate = null, Ce === "throw" && Ge.iterator.return && (Ee.method = "return", Ee.arg = M, $e(Ge, Ee), Ee.method === "throw") || Ce !== "return" && (Ee.method = "throw", Ee.arg = new TypeError("The iterator does not provide a '" + Ce + "' method")), fe;
                var Pe = Y(xe, Ge.iterator, Ee.arg);
                if (Pe.type === "throw") return Ee.method = "throw", Ee.arg = Pe.arg, Ee.delegate = null, fe;
                var it = Pe.arg;
                return it ? it.done ? (Ee[Ge.resultName] = it.value, Ee.next = Ge.nextLoc, Ee.method !== "return" && (Ee.method = "next", Ee.arg = M), Ee.delegate = null, fe) : it : (Ee.method = "throw", Ee.arg = new TypeError("iterator result is not an object"), Ee.delegate = null, fe);
              }
              function mt(Ge) {
                var Ee = {
                  tryLoc: Ge[0]
                };
                1 in Ge && (Ee.catchLoc = Ge[1]), 2 in Ge && (Ee.finallyLoc = Ge[2], Ee.afterLoc = Ge[3]), this.tryEntries.push(Ee);
              }
              function yt(Ge) {
                var Ee = Ge.completion || {};
                Ee.type = "normal", delete Ee.arg, Ge.completion = Ee;
              }
              function Ct(Ge) {
                this.tryEntries = [{
                  tryLoc: "root"
                }], Ge.forEach(mt, this), this.reset(!0);
              }
              function gt(Ge) {
                if (Ge || Ge === "") {
                  var Ee = Ge[te];
                  if (Ee) return Ee.call(Ge);
                  if (typeof Ge.next == "function") return Ge;
                  if (!isNaN(Ge.length)) {
                    var Ce = -1, xe = function Pe() {
                      for (; ++Ce < Ge.length; ) if (L.call(Ge, Ce)) return Pe.value = Ge[Ce], Pe.done = !1, Pe;
                      return Pe.value = M, Pe.done = !0, Pe;
                    };
                    return xe.next = xe;
                  }
                }
                throw new TypeError(c(Ge) + " is not iterable");
              }
              return Ie.prototype = be, j(ge, "constructor", {
                value: be,
                configurable: !0
              }), j(be, "constructor", {
                value: Ie,
                configurable: !0
              }), Ie.displayName = ie(be, le, "GeneratorFunction"), R.isGeneratorFunction = function(Ge) {
                var Ee = typeof Ge == "function" && Ge.constructor;
                return !!Ee && (Ee === Ie || (Ee.displayName || Ee.name) === "GeneratorFunction");
              }, R.mark = function(Ge) {
                return Object.setPrototypeOf ? Object.setPrototypeOf(Ge, be) : (Ge.__proto__ = be, ie(Ge, le, "GeneratorFunction")), Ge.prototype = Object.create(ge), Ge;
              }, R.awrap = function(Ge) {
                return {
                  __await: Ge
                };
              }, he(Me.prototype), ie(Me.prototype, re, function() {
                return this;
              }), R.AsyncIterator = Me, R.async = function(Ge, Ee, Ce, xe, Pe) {
                Pe === void 0 && (Pe = Promise);
                var it = new Me(ye(Ge, Ee, Ce, xe), Pe);
                return R.isGeneratorFunction(Ee) ? it : it.next().then(function(lt) {
                  return lt.done ? lt.value : it.next();
                });
              }, he(ge), ie(ge, le, "Generator"), ie(ge, te, function() {
                return this;
              }), ie(ge, "toString", function() {
                return "[object Generator]";
              }), R.keys = function(Ge) {
                var Ee = Object(Ge), Ce = [];
                for (var xe in Ee) Ce.push(xe);
                return Ce.reverse(), function Pe() {
                  for (; Ce.length; ) {
                    var it = Ce.pop();
                    if (it in Ee) return Pe.value = it, Pe.done = !1, Pe;
                  }
                  return Pe.done = !0, Pe;
                };
              }, R.values = gt, Ct.prototype = {
                constructor: Ct,
                reset: function(Ge) {
                  if (this.prev = 0, this.next = 0, this.sent = this._sent = M, this.done = !1, this.delegate = null, this.method = "next", this.arg = M, this.tryEntries.forEach(yt), !Ge) for (var Ee in this) Ee.charAt(0) === "t" && L.call(this, Ee) && !isNaN(+Ee.slice(1)) && (this[Ee] = M);
                },
                stop: function() {
                  this.done = !0;
                  var Ge = this.tryEntries[0].completion;
                  if (Ge.type === "throw") throw Ge.arg;
                  return this.rval;
                },
                dispatchException: function(Ge) {
                  if (this.done) throw Ge;
                  var Ee = this;
                  function Ce(vt, It) {
                    return it.type = "throw", it.arg = Ge, Ee.next = vt, It && (Ee.method = "next", Ee.arg = M), !!It;
                  }
                  for (var xe = this.tryEntries.length - 1; xe >= 0; --xe) {
                    var Pe = this.tryEntries[xe], it = Pe.completion;
                    if (Pe.tryLoc === "root") return Ce("end");
                    if (Pe.tryLoc <= this.prev) {
                      var lt = L.call(Pe, "catchLoc"), dt = L.call(Pe, "finallyLoc");
                      if (lt && dt) {
                        if (this.prev < Pe.catchLoc) return Ce(Pe.catchLoc, !0);
                        if (this.prev < Pe.finallyLoc) return Ce(Pe.finallyLoc);
                      } else if (lt) {
                        if (this.prev < Pe.catchLoc) return Ce(Pe.catchLoc, !0);
                      } else {
                        if (!dt) throw new Error("try statement without catch or finally");
                        if (this.prev < Pe.finallyLoc) return Ce(Pe.finallyLoc);
                      }
                    }
                  }
                },
                abrupt: function(Ge, Ee) {
                  for (var Ce = this.tryEntries.length - 1; Ce >= 0; --Ce) {
                    var xe = this.tryEntries[Ce];
                    if (xe.tryLoc <= this.prev && L.call(xe, "finallyLoc") && this.prev < xe.finallyLoc) {
                      var Pe = xe;
                      break;
                    }
                  }
                  Pe && (Ge === "break" || Ge === "continue") && Pe.tryLoc <= Ee && Ee <= Pe.finallyLoc && (Pe = null);
                  var it = Pe ? Pe.completion : {};
                  return it.type = Ge, it.arg = Ee, Pe ? (this.method = "next", this.next = Pe.finallyLoc, fe) : this.complete(it);
                },
                complete: function(Ge, Ee) {
                  if (Ge.type === "throw") throw Ge.arg;
                  return Ge.type === "break" || Ge.type === "continue" ? this.next = Ge.arg : Ge.type === "return" ? (this.rval = this.arg = Ge.arg, this.method = "return", this.next = "end") : Ge.type === "normal" && Ee && (this.next = Ee), fe;
                },
                finish: function(Ge) {
                  for (var Ee = this.tryEntries.length - 1; Ee >= 0; --Ee) {
                    var Ce = this.tryEntries[Ee];
                    if (Ce.finallyLoc === Ge) return this.complete(Ce.completion, Ce.afterLoc), yt(Ce), fe;
                  }
                },
                catch: function(Ge) {
                  for (var Ee = this.tryEntries.length - 1; Ee >= 0; --Ee) {
                    var Ce = this.tryEntries[Ee];
                    if (Ce.tryLoc === Ge) {
                      var xe = Ce.completion;
                      if (xe.type === "throw") {
                        var Pe = xe.arg;
                        yt(Ce);
                      }
                      return Pe;
                    }
                  }
                  throw new Error("illegal catch attempt");
                },
                delegateYield: function(Ge, Ee, Ce) {
                  return this.delegate = {
                    iterator: gt(Ge),
                    resultName: Ee,
                    nextLoc: Ce
                  }, this.method === "next" && (this.arg = M), fe;
                }
              }, R;
            }
            function x(M, R) {
              var F = typeof Symbol < "u" && M[Symbol.iterator] || M["@@iterator"];
              if (!F) {
                if (Array.isArray(M) || (F = function(le, ie) {
                  if (le) {
                    if (typeof le == "string") return k(le, ie);
                    var ye = Object.prototype.toString.call(le).slice(8, -1);
                    if (ye === "Object" && le.constructor && (ye = le.constructor.name), ye === "Map" || ye === "Set") return Array.from(le);
                    if (ye === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(ye)) return k(le, ie);
                  }
                }(M)) || R) {
                  F && (M = F);
                  var L = 0, j = function() {
                  };
                  return {
                    s: j,
                    n: function() {
                      return L >= M.length ? {
                        done: !0
                      } : {
                        done: !1,
                        value: M[L++]
                      };
                    },
                    e: function(le) {
                      throw le;
                    },
                    f: j
                  };
                }
                throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
              }
              var H, te = !0, re = !1;
              return {
                s: function() {
                  F = F.call(M);
                },
                n: function() {
                  var le = F.next();
                  return te = le.done, le;
                },
                e: function(le) {
                  re = !0, H = le;
                },
                f: function() {
                  try {
                    te || F.return == null || F.return();
                  } finally {
                    if (re) throw H;
                  }
                }
              };
            }
            function k(M, R) {
              (R == null || R > M.length) && (R = M.length);
              for (var F = 0, L = new Array(R); F < R; F++) L[F] = M[F];
              return L;
            }
            function C(M, R, F, L, j, H, te) {
              try {
                var re = M[H](te), le = re.value;
              } catch (ie) {
                return void F(ie);
              }
              re.done ? R(le) : Promise.resolve(le).then(L, j);
            }
            var O, E, B = l.EventHandlers = {
              keyEvent: function(M, R, F, L, j) {
                var H = this.inputmask, te = H.opts, re = H.dependencyLib, le = H.maskset, ie = this, ye = re(ie), Y = M.key, ae = w.caret.call(H, ie), ke = te.onKeyDown.call(this, M, w.getBuffer.call(H), ae, te);
                if (ke !== void 0) return ke;
                if (Y === b.keys.Backspace || Y === b.keys.Delete || m.iphone && Y === b.keys.BACKSPACE_SAFARI || M.ctrlKey && Y === b.keys.x && !("oncut" in ie)) M.preventDefault(), S.handleRemove.call(H, ie, Y, ae), (0, v.writeBuffer)(ie, w.getBuffer.call(H, !0), le.p, M, ie.inputmask._valueGet() !== w.getBuffer.call(H).join(""));
                else if (Y === b.keys.End || Y === b.keys.PageDown) {
                  M.preventDefault();
                  var ue = w.seekNext.call(H, w.getLastValidPosition.call(H));
                  w.caret.call(H, ie, M.shiftKey ? ae.begin : ue, ue, !0);
                } else Y === b.keys.Home && !M.shiftKey || Y === b.keys.PageUp ? (M.preventDefault(), w.caret.call(H, ie, 0, M.shiftKey ? ae.begin : 0, !0)) : te.undoOnEscape && Y === b.keys.Escape && M.altKey !== !0 ? ((0, v.checkVal)(ie, !0, !1, H.undoValue.split("")), ye.trigger("click")) : Y !== b.keys.Insert || M.shiftKey || M.ctrlKey || H.userOptions.insertMode !== void 0 ? te.tabThrough === !0 && Y === b.keys.Tab ? M.shiftKey === !0 ? (ae.end = w.seekPrevious.call(H, ae.end, !0), I.getTest.call(H, ae.end - 1).match.static === !0 && ae.end--, ae.begin = w.seekPrevious.call(H, ae.end, !0), ae.begin >= 0 && ae.end > 0 && (M.preventDefault(), w.caret.call(H, ie, ae.begin, ae.end))) : (ae.begin = w.seekNext.call(H, ae.begin, !0), ae.end = w.seekNext.call(H, ae.begin, !0), ae.end < le.maskLength && ae.end--, ae.begin <= le.maskLength && (M.preventDefault(), w.caret.call(H, ie, ae.begin, ae.end))) : M.shiftKey || (te.insertModeVisual && te.insertMode === !1 ? Y === b.keys.ArrowRight ? setTimeout(function() {
                  var oe = w.caret.call(H, ie);
                  w.caret.call(H, ie, oe.begin);
                }, 0) : Y === b.keys.ArrowLeft && setTimeout(function() {
                  var oe = w.translatePosition.call(H, ie.inputmask.caretPos.begin);
                  w.translatePosition.call(H, ie.inputmask.caretPos.end), H.isRTL ? w.caret.call(H, ie, oe + (oe === le.maskLength ? 0 : 1)) : w.caret.call(H, ie, oe - (oe === 0 ? 0 : 1));
                }, 0) : H.keyEventHook === void 0 || H.keyEventHook(M)) : S.isSelection.call(H, ae) ? te.insertMode = !te.insertMode : (te.insertMode = !te.insertMode, w.caret.call(H, ie, ae.begin, ae.begin));
                return H.isComposing = Y == b.keys.Process || Y == b.keys.Unidentified, H.ignorable = Y.length > 1 && !(ie.tagName.toLowerCase() === "textarea" && Y == b.keys.Enter), B.keypressEvent.call(this, M, R, F, L, j);
              },
              keypressEvent: function(M, R, F, L, j) {
                var H = this.inputmask || this, te = H.opts, re = H.dependencyLib, le = H.maskset, ie = H.el, ye = re(ie), Y = M.key;
                if (R === !0 || M.ctrlKey && M.altKey && !H.ignorable || !(M.ctrlKey || M.metaKey || H.ignorable)) {
                  if (Y) {
                    var ae, ke = R ? {
                      begin: j,
                      end: j
                    } : w.caret.call(H, ie);
                    R || (Y = te.substitutes[Y] || Y), le.writeOutBuffer = !0;
                    var ue = S.isValid.call(H, ke, Y, L, void 0, void 0, void 0, R);
                    if (ue !== !1 && (w.resetMaskSet.call(H, !0), ae = ue.caret !== void 0 ? ue.caret : w.seekNext.call(H, ue.pos.begin ? ue.pos.begin : ue.pos), le.p = ae), ae = te.numericInput && ue.caret === void 0 ? w.seekPrevious.call(H, ae) : ae, F !== !1 && (setTimeout(function() {
                      te.onKeyValidation.call(ie, Y, ue);
                    }, 0), le.writeOutBuffer && ue !== !1)) {
                      var oe = w.getBuffer.call(H);
                      (0, v.writeBuffer)(ie, oe, ae, M, R !== !0);
                    }
                    if (M.preventDefault(), R) return ue !== !1 && (ue.forwardPosition = ae), ue;
                  }
                } else Y === b.keys.Enter && H.undoValue !== H._valueGet(!0) && (H.undoValue = H._valueGet(!0), setTimeout(function() {
                  ye.trigger("change");
                }, 0));
              },
              pasteEvent: (O = T().mark(function M(R) {
                var F, L, j, H, te, re;
                return T().wrap(function(le) {
                  for (; ; ) switch (le.prev = le.next) {
                    case 0:
                      F = function(ie, ye, Y, ae, ke) {
                        var ue = w.caret.call(ie, ye, void 0, void 0, !0), oe = Y.substr(0, ue.begin), fe = Y.substr(ue.end, Y.length);
                        if (oe == (ie.isRTL ? w.getBufferTemplate.call(ie).slice().reverse() : w.getBufferTemplate.call(ie)).slice(0, ue.begin).join("") && (oe = ""), fe == (ie.isRTL ? w.getBufferTemplate.call(ie).slice().reverse() : w.getBufferTemplate.call(ie)).slice(ue.end).join("") && (fe = ""), ae = oe + ae + fe, ie.isRTL && H.numericInput !== !0) {
                          ae = ae.split("");
                          var we, Ie = x(w.getBufferTemplate.call(ie));
                          try {
                            for (Ie.s(); !(we = Ie.n()).done; ) {
                              var be = we.value;
                              ae[0] === be && ae.shift();
                            }
                          } catch (ze) {
                            Ie.e(ze);
                          } finally {
                            Ie.f();
                          }
                          ae = ae.reverse().join("");
                        }
                        var Oe = ae;
                        if (typeof ke == "function") {
                          if ((Oe = ke.call(ie, Oe, H)) === !1) return !1;
                          Oe || (Oe = Y);
                        }
                        (0, v.checkVal)(ye, !0, !1, Oe.toString().split(""), R);
                      }, L = this, j = this.inputmask, H = j.opts, te = j._valueGet(!0), j.skipInputEvent = !0, R.clipboardData && R.clipboardData.getData ? re = R.clipboardData.getData("text/plain") : f.default.clipboardData && f.default.clipboardData.getData && (re = f.default.clipboardData.getData("Text")), F(j, L, te, re, H.onBeforePaste), R.preventDefault();
                    case 7:
                    case "end":
                      return le.stop();
                  }
                }, M, this);
              }), E = function() {
                var M = this, R = arguments;
                return new Promise(function(F, L) {
                  var j = O.apply(M, R);
                  function H(re) {
                    C(j, F, L, H, te, "next", re);
                  }
                  function te(re) {
                    C(j, F, L, H, te, "throw", re);
                  }
                  H(void 0);
                });
              }, function(M) {
                return E.apply(this, arguments);
              }),
              inputFallBackEvent: function(M) {
                var R = this.inputmask, F = R.opts, L = R.dependencyLib, j, H = this, te = H.inputmask._valueGet(!0), re = (R.isRTL ? w.getBuffer.call(R).slice().reverse() : w.getBuffer.call(R)).join(""), le = w.caret.call(R, H, void 0, void 0, !0);
                if (re !== te) {
                  if (j = function(ye, Y, ae) {
                    for (var ke, ue, oe, fe = ye.substr(0, ae.begin).split(""), we = ye.substr(ae.begin).split(""), Ie = Y.substr(0, ae.begin).split(""), be = Y.substr(ae.begin).split(""), Oe = fe.length >= Ie.length ? fe.length : Ie.length, ze = we.length >= be.length ? we.length : be.length, Re = "", ge = [], he = "~"; fe.length < Oe; ) fe.push(he);
                    for (; Ie.length < Oe; ) Ie.push(he);
                    for (; we.length < ze; ) we.unshift(he);
                    for (; be.length < ze; ) be.unshift(he);
                    var Me = fe.concat(we), Ne = Ie.concat(be);
                    for (ue = 0, ke = Me.length; ue < ke; ue++) switch (oe = I.getPlaceholder.call(R, w.translatePosition.call(R, ue)), Re) {
                      case "insertText":
                        Ne[ue - 1] === Me[ue] && ae.begin == Me.length - 1 && ge.push(Me[ue]), ue = ke;
                        break;
                      case "insertReplacementText":
                      case "deleteContentBackward":
                        Me[ue] === he ? ae.end++ : ue = ke;
                        break;
                      default:
                        Me[ue] !== Ne[ue] && (Me[ue + 1] !== he && Me[ue + 1] !== oe && Me[ue + 1] !== void 0 || (Ne[ue] !== oe || Ne[ue + 1] !== he) && Ne[ue] !== he ? Ne[ue + 1] === he && Ne[ue] === Me[ue + 1] ? (Re = "insertText", ge.push(Me[ue]), ae.begin--, ae.end--) : Me[ue] !== oe && Me[ue] !== he && (Me[ue + 1] === he || Ne[ue] !== Me[ue] && Ne[ue + 1] === Me[ue + 1]) ? (Re = "insertReplacementText", ge.push(Me[ue]), ae.begin--) : Me[ue] === he ? (Re = "deleteContentBackward", (w.isMask.call(R, w.translatePosition.call(R, ue), !0) || Ne[ue] === F.radixPoint) && ae.end++) : ue = ke : (Re = "insertText", ge.push(Me[ue]), ae.begin--, ae.end--));
                    }
                    return {
                      action: Re,
                      data: ge,
                      caret: ae
                    };
                  }(te, re, le), (H.inputmask.shadowRoot || H.ownerDocument).activeElement !== H && H.focus(), (0, v.writeBuffer)(H, w.getBuffer.call(R)), w.caret.call(R, H, le.begin, le.end, !0), !m.mobile && R.skipNextInsert && M.inputType === "insertText" && j.action === "insertText" && R.isComposing) return !1;
                  switch (M.inputType === "insertCompositionText" && j.action === "insertText" && R.isComposing ? R.skipNextInsert = !0 : R.skipNextInsert = !1, j.action) {
                    case "insertText":
                    case "insertReplacementText":
                      j.data.forEach(function(ye, Y) {
                        var ae = new L.Event("keypress");
                        ae.key = ye, R.ignorable = !1, B.keypressEvent.call(H, ae);
                      }), setTimeout(function() {
                        R.$el.trigger("keyup");
                      }, 0);
                      break;
                    case "deleteContentBackward":
                      var ie = new L.Event("keydown");
                      ie.key = b.keys.Backspace, B.keyEvent.call(H, ie);
                      break;
                    default:
                      (0, v.applyInputValue)(H, te), w.caret.call(R, H, le.begin, le.end, !0);
                  }
                  M.preventDefault();
                }
              },
              setValueEvent: function(M) {
                var R = this.inputmask, F = R.dependencyLib, L = this, j = M && M.detail ? M.detail[0] : arguments[1];
                j === void 0 && (j = L.inputmask._valueGet(!0)), (0, v.applyInputValue)(L, j, new F.Event("input")), (M.detail && M.detail[1] !== void 0 || arguments[2] !== void 0) && w.caret.call(R, L, M.detail ? M.detail[1] : arguments[2]);
              },
              focusEvent: function(M) {
                var R = this.inputmask, F = R.opts, L = R && R._valueGet();
                F.showMaskOnFocus && L !== w.getBuffer.call(R).join("") && (0, v.writeBuffer)(this, w.getBuffer.call(R), w.seekNext.call(R, w.getLastValidPosition.call(R))), F.positionCaretOnTab !== !0 || R.mouseEnter !== !1 || S.isComplete.call(R, w.getBuffer.call(R)) && w.getLastValidPosition.call(R) !== -1 || B.clickEvent.apply(this, [M, !0]), R.undoValue = R && R._valueGet(!0);
              },
              invalidEvent: function(M) {
                this.inputmask.validationEvent = !0;
              },
              mouseleaveEvent: function() {
                var M = this.inputmask, R = M.opts, F = this;
                M.mouseEnter = !1, R.clearMaskOnLostFocus && (F.inputmask.shadowRoot || F.ownerDocument).activeElement !== F && (0, v.HandleNativePlaceholder)(F, M.originalPlaceholder);
              },
              clickEvent: function(M, R) {
                var F = this.inputmask;
                F.clicked++;
                var L = this;
                if ((L.inputmask.shadowRoot || L.ownerDocument).activeElement === L) {
                  var j = w.determineNewCaretPosition.call(F, w.caret.call(F, L), R);
                  j !== void 0 && w.caret.call(F, L, j);
                }
              },
              cutEvent: function(M) {
                var R = this.inputmask, F = R.maskset, L = this, j = w.caret.call(R, L), H = R.isRTL ? w.getBuffer.call(R).slice(j.end, j.begin) : w.getBuffer.call(R).slice(j.begin, j.end), te = R.isRTL ? H.reverse().join("") : H.join("");
                f.default.navigator && f.default.navigator.clipboard ? f.default.navigator.clipboard.writeText(te) : f.default.clipboardData && f.default.clipboardData.getData && f.default.clipboardData.setData("Text", te), S.handleRemove.call(R, L, b.keys.Delete, j), (0, v.writeBuffer)(L, w.getBuffer.call(R), F.p, M, R.undoValue !== R._valueGet(!0));
              },
              blurEvent: function(M) {
                var R = this.inputmask, F = R.opts, L = R.dependencyLib;
                R.clicked = 0;
                var j = L(this), H = this;
                if (H.inputmask) {
                  (0, v.HandleNativePlaceholder)(H, R.originalPlaceholder);
                  var te = H.inputmask._valueGet(), re = w.getBuffer.call(R).slice();
                  te !== "" && (F.clearMaskOnLostFocus && (w.getLastValidPosition.call(R) === -1 && te === w.getBufferTemplate.call(R).join("") ? re = [] : v.clearOptionalTail.call(R, re)), S.isComplete.call(R, re) === !1 && (setTimeout(function() {
                    j.trigger("incomplete");
                  }, 0), F.clearIncomplete && (w.resetMaskSet.call(R, !1), re = F.clearMaskOnLostFocus ? [] : w.getBufferTemplate.call(R).slice())), (0, v.writeBuffer)(H, re, void 0, M)), te = R._valueGet(!0), R.undoValue !== te && (te != "" || R.undoValue != w.getBufferTemplate.call(R).join("") || R.undoValue == w.getBufferTemplate.call(R).join("") && R.maskset.validPositions.length > 0) && (R.undoValue = te, j.trigger("change"));
                }
              },
              mouseenterEvent: function() {
                var M = this.inputmask, R = M.opts.showMaskOnHover, F = this;
                if (M.mouseEnter = !0, (F.inputmask.shadowRoot || F.ownerDocument).activeElement !== F) {
                  var L = (M.isRTL ? w.getBufferTemplate.call(M).slice().reverse() : w.getBufferTemplate.call(M)).join("");
                  R && (0, v.HandleNativePlaceholder)(F, L);
                }
              },
              submitEvent: function() {
                var M = this.inputmask, R = M.opts;
                M.undoValue !== M._valueGet(!0) && M.$el.trigger("change"), w.getLastValidPosition.call(M) === -1 && M._valueGet && M._valueGet() === w.getBufferTemplate.call(M).join("") && M._valueSet(""), R.clearIncomplete && S.isComplete.call(M, w.getBuffer.call(M)) === !1 && M._valueSet(""), R.removeMaskOnSubmit && (M._valueSet(M.unmaskedvalue(), !0), setTimeout(function() {
                  (0, v.writeBuffer)(M.el, w.getBuffer.call(M));
                }, 0));
              },
              resetEvent: function() {
                var M = this.inputmask;
                M.refreshValue = !0, setTimeout(function() {
                  (0, v.applyInputValue)(M.el, M._valueGet(!0));
                }, 0);
              }
            };
          },
          9716: function(o, l, d) {
            Object.defineProperty(l, "__esModule", {
              value: !0
            }), l.EventRuler = void 0;
            var c, u = d(7760), m = (c = d(2394)) && c.__esModule ? c : {
              default: c
            }, f = d(2839), v = d(8711);
            l.EventRuler = {
              on: function(b, w, S) {
                var I = b.inputmask.dependencyLib, T = function(x) {
                  x.originalEvent && (x = x.originalEvent || x, arguments[0] = x);
                  var k, C = this, O = C.inputmask, E = O ? O.opts : void 0;
                  if (O === void 0 && this.nodeName !== "FORM") {
                    var B = I.data(C, "_inputmask_opts");
                    I(C).off(), B && new m.default(B).mask(C);
                  } else {
                    if (["submit", "reset", "setvalue"].includes(x.type) || this.nodeName === "FORM" || !(C.disabled || C.readOnly && !(x.type === "keydown" && x.ctrlKey && x.key === f.keys.c || E.tabThrough === !1 && x.key === f.keys.Tab))) {
                      switch (x.type) {
                        case "input":
                          if (O.skipInputEvent === !0) return O.skipInputEvent = !1, x.preventDefault();
                          break;
                        case "click":
                        case "focus":
                          return O.validationEvent ? (O.validationEvent = !1, b.blur(), (0, u.HandleNativePlaceholder)(b, (O.isRTL ? v.getBufferTemplate.call(O).slice().reverse() : v.getBufferTemplate.call(O)).join("")), setTimeout(function() {
                            b.focus();
                          }, E.validationEventTimeOut), !1) : (k = arguments, void setTimeout(function() {
                            b.inputmask && S.apply(C, k);
                          }, 0));
                      }
                      var M = S.apply(C, arguments);
                      return M === !1 && (x.preventDefault(), x.stopPropagation()), M;
                    }
                    x.preventDefault();
                  }
                };
                ["submit", "reset"].includes(w) ? (T = T.bind(b), b.form !== null && I(b.form).on(w, T)) : I(b).on(w, T), b.inputmask.events[w] = b.inputmask.events[w] || [], b.inputmask.events[w].push(T);
              },
              off: function(b, w) {
                if (b.inputmask && b.inputmask.events) {
                  var S = b.inputmask.dependencyLib, I = b.inputmask.events;
                  for (var T in w && ((I = [])[w] = b.inputmask.events[w]), I) {
                    for (var x = I[T]; x.length > 0; ) {
                      var k = x.pop();
                      ["submit", "reset"].includes(T) ? b.form !== null && S(b.form).off(T, k) : S(b).off(T, k);
                    }
                    delete b.inputmask.events[T];
                  }
                }
              }
            };
          },
          219: function(o, l, d) {
            var c = T(d(7184)), u = T(d(2394)), m = d(2839), f = d(8711), v = d(4713);
            function b(Y, ae) {
              return function(ke) {
                if (Array.isArray(ke)) return ke;
              }(Y) || function(ke, ue) {
                var oe = ke == null ? null : typeof Symbol < "u" && ke[Symbol.iterator] || ke["@@iterator"];
                if (oe != null) {
                  var fe, we, Ie, be, Oe = [], ze = !0, Re = !1;
                  try {
                    if (Ie = (oe = oe.call(ke)).next, ue !== 0) for (; !(ze = (fe = Ie.call(oe)).done) && (Oe.push(fe.value), Oe.length !== ue); ze = !0) ;
                  } catch (ge) {
                    Re = !0, we = ge;
                  } finally {
                    try {
                      if (!ze && oe.return != null && (be = oe.return(), Object(be) !== be)) return;
                    } finally {
                      if (Re) throw we;
                    }
                  }
                  return Oe;
                }
              }(Y, ae) || function(ke, ue) {
                if (ke) {
                  if (typeof ke == "string") return w(ke, ue);
                  var oe = Object.prototype.toString.call(ke).slice(8, -1);
                  if (oe === "Object" && ke.constructor && (oe = ke.constructor.name), oe === "Map" || oe === "Set") return Array.from(ke);
                  if (oe === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(oe)) return w(ke, ue);
                }
              }(Y, ae) || function() {
                throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
              }();
            }
            function w(Y, ae) {
              (ae == null || ae > Y.length) && (ae = Y.length);
              for (var ke = 0, ue = new Array(ae); ke < ae; ke++) ue[ke] = Y[ke];
              return ue;
            }
            function S(Y) {
              return S = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(ae) {
                return typeof ae;
              } : function(ae) {
                return ae && typeof Symbol == "function" && ae.constructor === Symbol && ae !== Symbol.prototype ? "symbol" : typeof ae;
              }, S(Y);
            }
            function I(Y, ae) {
              for (var ke = 0; ke < ae.length; ke++) {
                var ue = ae[ke];
                ue.enumerable = ue.enumerable || !1, ue.configurable = !0, "value" in ue && (ue.writable = !0), Object.defineProperty(Y, (oe = ue.key, fe = void 0, fe = function(we, Ie) {
                  if (S(we) !== "object" || we === null) return we;
                  var be = we[Symbol.toPrimitive];
                  if (be !== void 0) {
                    var Oe = be.call(we, Ie);
                    if (S(Oe) !== "object") return Oe;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                  }
                  return (Ie === "string" ? String : Number)(we);
                }(oe, "string"), S(fe) === "symbol" ? fe : String(fe)), ue);
              }
              var oe, fe;
            }
            function T(Y) {
              return Y && Y.__esModule ? Y : {
                default: Y
              };
            }
            d(1313);
            var x = u.default.dependencyLib, k = function() {
              function Y(ue, oe, fe, we) {
                (function(Ie, be) {
                  if (!(Ie instanceof be)) throw new TypeError("Cannot call a class as a function");
                })(this, Y), this.mask = ue, this.format = oe, this.opts = fe, this.inputmask = we, this._date = new Date(1, 0, 1), this.initDateObject(ue, this.opts, this.inputmask);
              }
              var ae, ke;
              return ae = Y, (ke = [{
                key: "date",
                get: function() {
                  return this._date === void 0 && (this._date = new Date(1, 0, 1), this.initDateObject(void 0, this.opts, this.inputmask)), this._date;
                }
              }, {
                key: "initDateObject",
                value: function(ue, oe, fe) {
                  var we;
                  for (j(oe).lastIndex = 0; we = j(oe).exec(this.format); ) {
                    var Ie = /\d+$/.exec(we[0]), be = Ie ? we[0][0] + "x" : we[0], Oe = void 0;
                    if (ue !== void 0) {
                      if (Ie) {
                        var ze = j(oe).lastIndex, Re = ye.call(fe, we.index, oe, fe && fe.maskset);
                        j(oe).lastIndex = ze, Oe = ue.slice(0, ue.indexOf(Re.nextMatch[0]));
                      } else {
                        for (var ge = we[0][0], he = we.index; fe && (oe.placeholder[v.getTest.call(fe, he).match.placeholder] || v.getTest.call(fe, he).match.placeholder) === ge; ) he++;
                        var Me = he - we.index;
                        Oe = ue.slice(0, Me || B[be] && B[be][4] || be.length);
                      }
                      ue = ue.slice(Oe.length);
                    }
                    Object.prototype.hasOwnProperty.call(B, be) && this.setValue(this, Oe, be, B[be][2], B[be][1]);
                  }
                }
              }, {
                key: "setValue",
                value: function(ue, oe, fe, we, Ie) {
                  if (oe !== void 0) switch (we) {
                    case "ampm":
                      ue[we] = oe, ue["raw" + we] = oe.replace(/\s/g, "_");
                      break;
                    case "month":
                      if (fe === "mmm" || fe === "mmmm") {
                        ue[we] = re(fe === "mmm" ? O.monthNames.slice(0, 12).findIndex(function(Oe) {
                          return oe.toLowerCase() === Oe.toLowerCase();
                        }) + 1 : O.monthNames.slice(12, 24).findIndex(function(Oe) {
                          return oe.toLowerCase() === Oe.toLowerCase();
                        }) + 1, 2), ue[we] = ue[we] === "00" ? "" : ue[we].toString(), ue["raw" + we] = ue[we];
                        break;
                      }
                    default:
                      ue[we] = oe.replace(/[^0-9]/g, "0"), ue["raw" + we] = oe.replace(/\s/g, "_");
                  }
                  if (Ie !== void 0) {
                    var be = ue[we];
                    (we === "day" && parseInt(be) === 29 || we === "month" && parseInt(be) === 2) && (parseInt(ue.day) !== 29 || parseInt(ue.month) !== 2 || ue.year !== "" && ue.year !== void 0 || ue._date.setFullYear(2012, 1, 29)), we === "day" && (E = !0, parseInt(be) === 0 && (be = 1)), we === "month" && (E = !0), we === "year" && (E = !0, be.length < B[fe][4] && (be = re(be, B[fe][4], !0))), (be !== "" && !isNaN(be) || we === "ampm") && Ie.call(ue._date, be);
                  }
                }
              }, {
                key: "reset",
                value: function() {
                  this._date = new Date(1, 0, 1);
                }
              }, {
                key: "reInit",
                value: function() {
                  this._date = void 0, this.date;
                }
              }]) && I(ae.prototype, ke), Object.defineProperty(ae, "prototype", {
                writable: !1
              }), Y;
            }(), C = (/* @__PURE__ */ new Date()).getFullYear(), O = u.default.prototype.i18n, E = !1, B = {
              d: ["[1-9]|[12][0-9]|3[01]", Date.prototype.setDate, "day", Date.prototype.getDate],
              dd: ["0[1-9]|[12][0-9]|3[01]", Date.prototype.setDate, "day", function() {
                return re(Date.prototype.getDate.call(this), 2);
              }],
              ddd: [""],
              dddd: [""],
              m: ["[1-9]|1[012]", function(Y) {
                var ae = Y ? parseInt(Y) : 0;
                return ae > 0 && ae--, Date.prototype.setMonth.call(this, ae);
              }, "month", function() {
                return Date.prototype.getMonth.call(this) + 1;
              }],
              mm: ["0[1-9]|1[012]", function(Y) {
                var ae = Y ? parseInt(Y) : 0;
                return ae > 0 && ae--, Date.prototype.setMonth.call(this, ae);
              }, "month", function() {
                return re(Date.prototype.getMonth.call(this) + 1, 2);
              }],
              mmm: [O.monthNames.slice(0, 12).join("|"), function(Y) {
                var ae = O.monthNames.slice(0, 12).findIndex(function(ke) {
                  return Y.toLowerCase() === ke.toLowerCase();
                });
                return ae !== -1 && Date.prototype.setMonth.call(this, ae);
              }, "month", function() {
                return O.monthNames.slice(0, 12)[Date.prototype.getMonth.call(this)];
              }],
              mmmm: [O.monthNames.slice(12, 24).join("|"), function(Y) {
                var ae = O.monthNames.slice(12, 24).findIndex(function(ke) {
                  return Y.toLowerCase() === ke.toLowerCase();
                });
                return ae !== -1 && Date.prototype.setMonth.call(this, ae);
              }, "month", function() {
                return O.monthNames.slice(12, 24)[Date.prototype.getMonth.call(this)];
              }],
              yy: ["[0-9]{2}", function(Y) {
                var ae = (/* @__PURE__ */ new Date()).getFullYear().toString().slice(0, 2);
                Date.prototype.setFullYear.call(this, "".concat(ae).concat(Y));
              }, "year", function() {
                return re(Date.prototype.getFullYear.call(this), 2);
              }, 2],
              yyyy: ["[0-9]{4}", Date.prototype.setFullYear, "year", function() {
                return re(Date.prototype.getFullYear.call(this), 4);
              }, 4],
              h: ["[1-9]|1[0-2]", Date.prototype.setHours, "hours", Date.prototype.getHours],
              hh: ["0[1-9]|1[0-2]", Date.prototype.setHours, "hours", function() {
                return re(Date.prototype.getHours.call(this), 2);
              }],
              hx: [function(Y) {
                return "[0-9]{".concat(Y, "}");
              }, Date.prototype.setHours, "hours", function(Y) {
                return Date.prototype.getHours;
              }],
              H: ["1?[0-9]|2[0-3]", Date.prototype.setHours, "hours", Date.prototype.getHours],
              HH: ["0[0-9]|1[0-9]|2[0-3]", Date.prototype.setHours, "hours", function() {
                return re(Date.prototype.getHours.call(this), 2);
              }],
              Hx: [function(Y) {
                return "[0-9]{".concat(Y, "}");
              }, Date.prototype.setHours, "hours", function(Y) {
                return function() {
                  return re(Date.prototype.getHours.call(this), Y);
                };
              }],
              M: ["[1-5]?[0-9]", Date.prototype.setMinutes, "minutes", Date.prototype.getMinutes],
              MM: ["0[0-9]|1[0-9]|2[0-9]|3[0-9]|4[0-9]|5[0-9]", Date.prototype.setMinutes, "minutes", function() {
                return re(Date.prototype.getMinutes.call(this), 2);
              }],
              s: ["[1-5]?[0-9]", Date.prototype.setSeconds, "seconds", Date.prototype.getSeconds],
              ss: ["0[0-9]|1[0-9]|2[0-9]|3[0-9]|4[0-9]|5[0-9]", Date.prototype.setSeconds, "seconds", function() {
                return re(Date.prototype.getSeconds.call(this), 2);
              }],
              l: ["[0-9]{3}", Date.prototype.setMilliseconds, "milliseconds", function() {
                return re(Date.prototype.getMilliseconds.call(this), 3);
              }, 3],
              L: ["[0-9]{2}", Date.prototype.setMilliseconds, "milliseconds", function() {
                return re(Date.prototype.getMilliseconds.call(this), 2);
              }, 2],
              t: ["[ap]", R, "ampm", F, 1],
              tt: ["[ap]m", R, "ampm", F, 2],
              T: ["[AP]", R, "ampm", F, 1],
              TT: ["[AP]M", R, "ampm", F, 2],
              Z: [".*", void 0, "Z", function() {
                var Y = this.toString().match(/\((.+)\)/)[1];
                return Y.includes(" ") && (Y = (Y = Y.replace("-", " ").toUpperCase()).split(" ").map(function(ae) {
                  return b(ae, 1)[0];
                }).join("")), Y;
              }],
              o: [""],
              S: [""]
            }, M = {
              isoDate: "yyyy-mm-dd",
              isoTime: "HH:MM:ss",
              isoDateTime: "yyyy-mm-dd'T'HH:MM:ss",
              isoUtcDateTime: "UTC:yyyy-mm-dd'T'HH:MM:ss'Z'"
            };
            function R(Y) {
              var ae = this.getHours();
              Y.toLowerCase().includes("p") ? this.setHours(ae + 12) : Y.toLowerCase().includes("a") && ae >= 12 && this.setHours(ae - 12);
            }
            function F() {
              var Y = this.getHours();
              return (Y = Y || 12) >= 12 ? "PM" : "AM";
            }
            function L(Y) {
              var ae = /\d+$/.exec(Y[0]);
              if (ae && ae[0] !== void 0) {
                var ke = B[Y[0][0] + "x"].slice("");
                return ke[0] = ke[0](ae[0]), ke[3] = ke[3](ae[0]), ke;
              }
              if (B[Y[0]]) return B[Y[0]];
            }
            function j(Y) {
              if (!Y.tokenizer) {
                var ae = [], ke = [];
                for (var ue in B) if (/\.*x$/.test(ue)) {
                  var oe = ue[0] + "\\d+";
                  ke.indexOf(oe) === -1 && ke.push(oe);
                } else ae.indexOf(ue[0]) === -1 && ae.push(ue[0]);
                Y.tokenizer = "(" + (ke.length > 0 ? ke.join("|") + "|" : "") + ae.join("+|") + ")+?|.", Y.tokenizer = new RegExp(Y.tokenizer, "g");
              }
              return Y.tokenizer;
            }
            function H(Y, ae, ke) {
              if (!E) return !0;
              if (Y.rawday === void 0 || !isFinite(Y.rawday) && new Date(Y.date.getFullYear(), isFinite(Y.rawmonth) ? Y.month : Y.date.getMonth() + 1, 0).getDate() >= Y.day || Y.day == "29" && (!isFinite(Y.rawyear) || Y.rawyear === void 0 || Y.rawyear === "") || new Date(Y.date.getFullYear(), isFinite(Y.rawmonth) ? Y.month : Y.date.getMonth() + 1, 0).getDate() >= Y.day) return ae;
              if (Y.day == "29") {
                var ue = ye.call(this, ae.pos, ke, this.maskset);
                if (ue.targetMatch && ue.targetMatch[0] === "yyyy" && ae.pos - ue.targetMatchIndex == 2) return ae.remove = ae.pos + 1, ae;
              } else if (Y.date.getMonth() == 2 && Y.day == "30" && ae.c !== void 0) return Y.day = "03", Y.date.setDate(3), Y.date.setMonth(1), ae.insert = [{
                pos: ae.pos,
                c: "0"
              }, {
                pos: ae.pos + 1,
                c: ae.c
              }], ae.caret = f.seekNext.call(this, ae.pos + 1), ae;
              return !1;
            }
            function te(Y, ae, ke, ue) {
              var oe, fe, we = "", Ie = 0, be = {};
              for (j(ke).lastIndex = 0; oe = j(ke).exec(Y); ) {
                if (ae === void 0) if (fe = L(oe)) we += "(" + fe[0] + ")", ke.placeholder && ke.placeholder !== "" ? (be[Ie] = ke.placeholder[oe.index % ke.placeholder.length], be[ke.placeholder[oe.index % ke.placeholder.length]] = oe[0].charAt(0)) : be[Ie] = oe[0].charAt(0);
                else switch (oe[0]) {
                  case "[":
                    we += "(";
                    break;
                  case "]":
                    we += ")?";
                    break;
                  default:
                    we += (0, c.default)(oe[0]), be[Ie] = oe[0].charAt(0);
                }
                else (fe = L(oe)) ? ue !== !0 && fe[3] ? we += fe[3].call(ae.date) : fe[2] ? we += ae["raw" + fe[2]] : we += oe[0] : we += oe[0];
                Ie++;
              }
              return ae === void 0 && (ke.placeholder = be), we;
            }
            function re(Y, ae, ke) {
              for (Y = String(Y), ae = ae || 2; Y.length < ae; ) Y = ke ? Y + "0" : "0" + Y;
              return Y;
            }
            function le(Y, ae, ke) {
              return typeof Y == "string" ? new k(Y, ae, ke, this) : Y && S(Y) === "object" && Object.prototype.hasOwnProperty.call(Y, "date") ? Y : void 0;
            }
            function ie(Y, ae) {
              return te(ae.inputFormat, {
                date: Y
              }, ae);
            }
            function ye(Y, ae, ke) {
              var ue, oe, fe = this, we = ke && ke.tests[Y] ? ae.placeholder[ke.tests[Y][0].match.placeholder] || ke.tests[Y][0].match.placeholder : "", Ie = 0, be = 0;
              for (j(ae).lastIndex = 0; oe = j(ae).exec(ae.inputFormat); ) {
                var Oe = /\d+$/.exec(oe[0]);
                if (Oe) be = parseInt(Oe[0]);
                else {
                  for (var ze = oe[0][0], Re = Ie; fe && (ae.placeholder[v.getTest.call(fe, Re).match.placeholder] || v.getTest.call(fe, Re).match.placeholder) === ze; ) Re++;
                  (be = Re - Ie) === 0 && (be = oe[0].length);
                }
                if (Ie += be, oe[0].indexOf(we) != -1 || Ie >= Y + 1) {
                  ue = oe, oe = j(ae).exec(ae.inputFormat);
                  break;
                }
              }
              return {
                targetMatchIndex: Ie - be,
                nextMatch: oe,
                targetMatch: ue
              };
            }
            u.default.extendAliases({
              datetime: {
                mask: function(Y) {
                  return Y.numericInput = !1, B.S = O.ordinalSuffix.join("|"), Y.inputFormat = M[Y.inputFormat] || Y.inputFormat, Y.displayFormat = M[Y.displayFormat] || Y.displayFormat || Y.inputFormat, Y.outputFormat = M[Y.outputFormat] || Y.outputFormat || Y.inputFormat, Y.regex = te(Y.inputFormat, void 0, Y), Y.min = le(Y.min, Y.inputFormat, Y), Y.max = le(Y.max, Y.inputFormat, Y), null;
                },
                placeholder: "",
                inputFormat: "isoDateTime",
                displayFormat: null,
                outputFormat: null,
                min: null,
                max: null,
                skipOptionalPartCharacter: "",
                preValidation: function(Y, ae, ke, ue, oe, fe, we, Ie) {
                  if (Ie) return !0;
                  if (isNaN(ke) && Y[ae] !== ke) {
                    var be = ye.call(this, ae, oe, fe);
                    if (be.nextMatch && be.nextMatch[0] === ke && be.targetMatch[0].length > 1) {
                      var Oe = L(be.targetMatch)[0];
                      if (new RegExp(Oe).test("0" + Y[ae - 1])) return Y[ae] = Y[ae - 1], Y[ae - 1] = "0", {
                        fuzzy: !0,
                        buffer: Y,
                        refreshFromBuffer: {
                          start: ae - 1,
                          end: ae + 1
                        },
                        pos: ae + 1
                      };
                    }
                  }
                  return !0;
                },
                postValidation: function(Y, ae, ke, ue, oe, fe, we, Ie) {
                  var be, Oe, ze = this;
                  if (we) return !0;
                  if (ue === !1 && (((be = ye.call(ze, ae + 1, oe, fe)).targetMatch && be.targetMatchIndex === ae && be.targetMatch[0].length > 1 && B[be.targetMatch[0]] !== void 0 || (be = ye.call(ze, ae + 2, oe, fe)).targetMatch && be.targetMatchIndex === ae + 1 && be.targetMatch[0].length > 1 && B[be.targetMatch[0]] !== void 0) && (Oe = L(be.targetMatch)[0]), Oe !== void 0 && (fe.validPositions[ae + 1] !== void 0 && new RegExp(Oe).test(ke + "0") ? (Y[ae] = ke, Y[ae + 1] = "0", ue = {
                    pos: ae + 2,
                    caret: ae
                  }) : new RegExp(Oe).test("0" + ke) && (Y[ae] = "0", Y[ae + 1] = ke, ue = {
                    pos: ae + 2
                  })), ue === !1)) return ue;
                  if (ue.fuzzy && (Y = ue.buffer, ae = ue.pos), (be = ye.call(ze, ae, oe, fe)).targetMatch && be.targetMatch[0] && B[be.targetMatch[0]] !== void 0) {
                    var Re = L(be.targetMatch);
                    Oe = Re[0];
                    var ge = Y.slice(be.targetMatchIndex, be.targetMatchIndex + be.targetMatch[0].length);
                    if (new RegExp(Oe).test(ge.join("")) === !1 && be.targetMatch[0].length === 2 && fe.validPositions[be.targetMatchIndex] && fe.validPositions[be.targetMatchIndex + 1] && (fe.validPositions[be.targetMatchIndex + 1].input = "0"), Re[2] == "year") for (var he = v.getMaskTemplate.call(ze, !1, 1, void 0, !0), Me = ae + 1; Me < Y.length; Me++) Y[Me] = he[Me], fe.validPositions.splice(ae + 1, 1);
                  }
                  var Ne = ue, $e = le.call(ze, Y.join(""), oe.inputFormat, oe);
                  return Ne && !isNaN($e.date.getTime()) && (oe.prefillYear && (Ne = function(mt, yt, Ct) {
                    if (mt.year !== mt.rawyear) {
                      var gt = C.toString(), Ge = mt.rawyear.replace(/[^0-9]/g, ""), Ee = gt.slice(0, Ge.length), Ce = gt.slice(Ge.length);
                      if (Ge.length === 2 && Ge === Ee) {
                        var xe = new Date(C, mt.month - 1, mt.day);
                        mt.day == xe.getDate() && (!Ct.max || Ct.max.date.getTime() >= xe.getTime()) && (mt.date.setFullYear(C), mt.year = gt, yt.insert = [{
                          pos: yt.pos + 1,
                          c: Ce[0]
                        }, {
                          pos: yt.pos + 2,
                          c: Ce[1]
                        }]);
                      }
                    }
                    return yt;
                  }($e, Ne, oe)), Ne = function(mt, yt, Ct, gt, Ge) {
                    if (!yt) return yt;
                    if (yt && Ct.min && !isNaN(Ct.min.date.getTime())) {
                      var Ee;
                      for (mt.reset(), j(Ct).lastIndex = 0; Ee = j(Ct).exec(Ct.inputFormat); ) {
                        var Ce;
                        if ((Ce = L(Ee)) && Ce[3]) {
                          for (var xe = Ce[1], Pe = mt[Ce[2]], it = Ct.min[Ce[2]], lt = Ct.max ? Ct.max[Ce[2]] : it + 1, dt = [], vt = !1, It = 0; It < it.length; It++) gt.validPositions[It + Ee.index] !== void 0 || vt ? (dt[It] = Pe[It], vt = vt || Pe[It] > it[It]) : (It + Ee.index == 0 && Pe[It] < it[It] ? (dt[It] = Pe[It], vt = !0) : dt[It] = it[It], Ce[2] === "year" && Pe.length - 1 == It && it != lt && (dt = (parseInt(dt.join("")) + 1).toString().split("")), Ce[2] === "ampm" && it != lt && Ct.min.date.getTime() > mt.date.getTime() && (dt[It] = lt[It]));
                          xe.call(mt._date, dt.join(""));
                        }
                      }
                      yt = Ct.min.date.getTime() <= mt.date.getTime(), mt.reInit();
                    }
                    return yt && Ct.max && (isNaN(Ct.max.date.getTime()) || (yt = Ct.max.date.getTime() >= mt.date.getTime())), yt;
                  }($e, Ne = H.call(ze, $e, Ne, oe), oe, fe)), ae !== void 0 && Ne && ue.pos !== ae ? {
                    buffer: te(oe.inputFormat, $e, oe).split(""),
                    refreshFromBuffer: {
                      start: ae,
                      end: ue.pos
                    },
                    pos: ue.caret || ue.pos
                  } : Ne;
                },
                onKeyDown: function(Y, ae, ke, ue) {
                  Y.ctrlKey && Y.key === m.keys.ArrowRight && (this.inputmask._valueSet(ie(/* @__PURE__ */ new Date(), ue)), x(this).trigger("setvalue"));
                },
                onUnMask: function(Y, ae, ke) {
                  return ae && te(ke.outputFormat, le.call(this, Y, ke.inputFormat, ke), ke, !0);
                },
                casing: function(Y, ae, ke, ue) {
                  if (ae.nativeDef.indexOf("[ap]") == 0) return Y.toLowerCase();
                  if (ae.nativeDef.indexOf("[AP]") == 0) return Y.toUpperCase();
                  var oe = v.getTest.call(this, [ke - 1]);
                  return oe.match.def.indexOf("[AP]") == 0 || ke === 0 || oe && oe.input === String.fromCharCode(m.keyCode.Space) || oe && oe.match.def === String.fromCharCode(m.keyCode.Space) ? Y.toUpperCase() : Y.toLowerCase();
                },
                onBeforeMask: function(Y, ae) {
                  return Object.prototype.toString.call(Y) === "[object Date]" && (Y = ie(Y, ae)), Y;
                },
                insertMode: !1,
                insertModeVisual: !1,
                shiftPositions: !1,
                keepStatic: !1,
                inputmode: "numeric",
                prefillYear: !0
              }
            });
          },
          1313: function(o, l, d) {
            var c, u = (c = d(2394)) && c.__esModule ? c : {
              default: c
            };
            u.default.dependencyLib.extend(!0, u.default.prototype.i18n, {
              dayNames: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
              monthNames: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec", "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
              ordinalSuffix: ["st", "nd", "rd", "th"]
            });
          },
          3851: function(o, l, d) {
            var c, u = (c = d(2394)) && c.__esModule ? c : {
              default: c
            }, m = d(8711), f = d(4713);
            function v(I) {
              return function(T) {
                if (Array.isArray(T)) return b(T);
              }(I) || function(T) {
                if (typeof Symbol < "u" && T[Symbol.iterator] != null || T["@@iterator"] != null) return Array.from(T);
              }(I) || function(T, x) {
                if (T) {
                  if (typeof T == "string") return b(T, x);
                  var k = Object.prototype.toString.call(T).slice(8, -1);
                  if (k === "Object" && T.constructor && (k = T.constructor.name), k === "Map" || k === "Set") return Array.from(T);
                  if (k === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(k)) return b(T, x);
                }
              }(I) || function() {
                throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
              }();
            }
            function b(I, T) {
              (T == null || T > I.length) && (T = I.length);
              for (var x = 0, k = new Array(T); x < T; x++) k[x] = I[x];
              return k;
            }
            u.default.extendDefinitions({
              A: {
                validator: "[A-Za-zА-яЁёÀ-ÿµ]",
                casing: "upper"
              },
              "&": {
                validator: "[0-9A-Za-zА-яЁёÀ-ÿµ]",
                casing: "upper"
              },
              "#": {
                validator: "[0-9A-Fa-f]",
                casing: "upper"
              }
            });
            var w = /25[0-5]|2[0-4][0-9]|[01][0-9][0-9]/;
            function S(I, T, x, k, C) {
              if (x - 1 > -1 && T.buffer[x - 1] !== "." ? (I = T.buffer[x - 1] + I, I = x - 2 > -1 && T.buffer[x - 2] !== "." ? T.buffer[x - 2] + I : "0" + I) : I = "00" + I, C.greedy && parseInt(I) > 255 && w.test("00" + I.charAt(2))) {
                var O = [].concat(v(T.buffer.slice(0, x)), [".", I.charAt(2)]);
                if (O.join("").match(/\./g).length < 4) return {
                  refreshFromBuffer: !0,
                  buffer: O,
                  caret: x + 2
                };
              }
              return w.test(I);
            }
            u.default.extendAliases({
              cssunit: {
                regex: "[+-]?[0-9]+\\.?([0-9]+)?(px|em|rem|ex|%|in|cm|mm|pt|pc)"
              },
              url: {
                regex: "(https?|ftp)://.*",
                autoUnmask: !1,
                keepStatic: !1,
                tabThrough: !0
              },
              ip: {
                mask: "i{1,3}.j{1,3}.k{1,3}.l{1,3}",
                definitions: {
                  i: {
                    validator: S
                  },
                  j: {
                    validator: S
                  },
                  k: {
                    validator: S
                  },
                  l: {
                    validator: S
                  }
                },
                onUnMask: function(I, T, x) {
                  return I;
                },
                inputmode: "decimal",
                substitutes: {
                  ",": "."
                }
              },
              email: {
                mask: function(I) {
                  var T = I.separator, x = I.quantifier, k = "*{1,64}[.*{1,64}][.*{1,64}][.*{1,63}]@-{1,63}.-{1,63}[.-{1,63}][.-{1,63}]", C = k;
                  if (T) for (var O = 0; O < x; O++) C += "[".concat(T).concat(k, "]");
                  return C;
                },
                greedy: !1,
                casing: "lower",
                separator: null,
                quantifier: 5,
                skipOptionalPartCharacter: "",
                onBeforePaste: function(I, T) {
                  return (I = I.toLowerCase()).replace("mailto:", "");
                },
                definitions: {
                  "*": {
                    validator: "[0-9１-９A-Za-zА-яЁёÀ-ÿµ!#$%&'*+/=?^_`{|}~-]"
                  },
                  "-": {
                    validator: "[0-9A-Za-z-]"
                  }
                },
                onUnMask: function(I, T, x) {
                  return I;
                },
                inputmode: "email"
              },
              mac: {
                mask: "##:##:##:##:##:##"
              },
              vin: {
                mask: "V{13}9{4}",
                definitions: {
                  V: {
                    validator: "[A-HJ-NPR-Za-hj-npr-z\\d]",
                    casing: "upper"
                  }
                },
                clearIncomplete: !0,
                autoUnmask: !0
              },
              ssn: {
                mask: "999-99-9999",
                postValidation: function(I, T, x, k, C, O, E) {
                  var B = f.getMaskTemplate.call(this, !0, m.getLastValidPosition.call(this), !0, !0);
                  return /^(?!219-09-9999|078-05-1120)(?!666|000|9.{2}).{3}-(?!00).{2}-(?!0{4}).{4}$/.test(B.join(""));
                }
              }
            });
          },
          207: function(o, l, d) {
            var c = v(d(7184)), u = v(d(2394)), m = d(2839), f = d(8711);
            function v(k) {
              return k && k.__esModule ? k : {
                default: k
              };
            }
            var b = u.default.dependencyLib;
            function w(k, C) {
              for (var O = "", E = 0; E < k.length; E++) u.default.prototype.definitions[k.charAt(E)] || C.definitions[k.charAt(E)] || C.optionalmarker[0] === k.charAt(E) || C.optionalmarker[1] === k.charAt(E) || C.quantifiermarker[0] === k.charAt(E) || C.quantifiermarker[1] === k.charAt(E) || C.groupmarker[0] === k.charAt(E) || C.groupmarker[1] === k.charAt(E) || C.alternatormarker === k.charAt(E) ? O += "\\" + k.charAt(E) : O += k.charAt(E);
              return O;
            }
            function S(k, C, O, E) {
              if (k.length > 0 && C > 0 && (!O.digitsOptional || E)) {
                var B = k.indexOf(O.radixPoint), M = !1;
                O.negationSymbol.back === k[k.length - 1] && (M = !0, k.length--), B === -1 && (k.push(O.radixPoint), B = k.length - 1);
                for (var R = 1; R <= C; R++) isFinite(k[B + R]) || (k[B + R] = "0");
              }
              return M && k.push(O.negationSymbol.back), k;
            }
            function I(k, C) {
              var O = 0;
              for (var E in k === "+" && (O = f.seekNext.call(this, C.validPositions.length - 1)), C.tests) if ((E = parseInt(E)) >= O) {
                for (var B = 0, M = C.tests[E].length; B < M; B++) if ((C.validPositions[E] === void 0 || k === "-") && C.tests[E][B].match.def === k) return E + (C.validPositions[E] !== void 0 && k !== "-" ? 1 : 0);
              }
              return O;
            }
            function T(k, C) {
              for (var O = -1, E = 0, B = C.validPositions.length; E < B; E++) {
                var M = C.validPositions[E];
                if (M && M.match.def === k) {
                  O = E;
                  break;
                }
              }
              return O;
            }
            function x(k, C, O, E, B) {
              var M = C.buffer ? C.buffer.indexOf(B.radixPoint) : -1, R = (M !== -1 || E && B.jitMasking) && new RegExp(B.definitions[9].validator).test(k);
              return !E && B._radixDance && M !== -1 && R && C.validPositions[M] == null ? {
                insert: {
                  pos: M === O ? M + 1 : M,
                  c: B.radixPoint
                },
                pos: O
              } : R;
            }
            u.default.extendAliases({
              numeric: {
                mask: function(k) {
                  k.repeat = 0, k.groupSeparator === k.radixPoint && k.digits && k.digits !== "0" && (k.radixPoint === "." ? k.groupSeparator = "," : k.radixPoint === "," ? k.groupSeparator = "." : k.groupSeparator = ""), k.groupSeparator === " " && (k.skipOptionalPartCharacter = void 0), k.placeholder.length > 1 && (k.placeholder = k.placeholder.charAt(0)), k.positionCaretOnClick === "radixFocus" && k.placeholder === "" && (k.positionCaretOnClick = "lvp");
                  var C = "0", O = k.radixPoint;
                  k.numericInput === !0 && k.__financeInput === void 0 ? (C = "1", k.positionCaretOnClick = k.positionCaretOnClick === "radixFocus" ? "lvp" : k.positionCaretOnClick, k.digitsOptional = !1, isNaN(k.digits) && (k.digits = 2), k._radixDance = !1, O = k.radixPoint === "," ? "?" : "!", k.radixPoint !== "" && k.definitions[O] === void 0 && (k.definitions[O] = {}, k.definitions[O].validator = "[" + k.radixPoint + "]", k.definitions[O].placeholder = k.radixPoint, k.definitions[O].static = !0, k.definitions[O].generated = !0)) : (k.__financeInput = !1, k.numericInput = !0);
                  var E, B = "[+]";
                  if (B += w(k.prefix, k), k.groupSeparator !== "" ? (k.definitions[k.groupSeparator] === void 0 && (k.definitions[k.groupSeparator] = {}, k.definitions[k.groupSeparator].validator = "[" + k.groupSeparator + "]", k.definitions[k.groupSeparator].placeholder = k.groupSeparator, k.definitions[k.groupSeparator].static = !0, k.definitions[k.groupSeparator].generated = !0), B += k._mask(k)) : B += "9{+}", k.digits !== void 0 && k.digits !== 0) {
                    var M = k.digits.toString().split(",");
                    isFinite(M[0]) && M[1] && isFinite(M[1]) ? B += O + C + "{" + k.digits + "}" : (isNaN(k.digits) || parseInt(k.digits) > 0) && (k.digitsOptional || k.jitMasking ? (E = B + O + C + "{0," + k.digits + "}", k.keepStatic = !0) : B += O + C + "{" + k.digits + "}");
                  } else k.inputmode = "numeric";
                  return B += w(k.suffix, k), B += "[-]", E && (B = [E + w(k.suffix, k) + "[-]", B]), k.greedy = !1, function(R) {
                    R.parseMinMaxOptions === void 0 && (R.min !== null && (R.min = R.min.toString().replace(new RegExp((0, c.default)(R.groupSeparator), "g"), ""), R.radixPoint === "," && (R.min = R.min.replace(R.radixPoint, ".")), R.min = isFinite(R.min) ? parseFloat(R.min) : NaN, isNaN(R.min) && (R.min = Number.MIN_VALUE)), R.max !== null && (R.max = R.max.toString().replace(new RegExp((0, c.default)(R.groupSeparator), "g"), ""), R.radixPoint === "," && (R.max = R.max.replace(R.radixPoint, ".")), R.max = isFinite(R.max) ? parseFloat(R.max) : NaN, isNaN(R.max) && (R.max = Number.MAX_VALUE)), R.parseMinMaxOptions = "done");
                  }(k), k.radixPoint !== "" && k.substituteRadixPoint && (k.substitutes[k.radixPoint == "." ? "," : "."] = k.radixPoint), B;
                },
                _mask: function(k) {
                  return "(" + k.groupSeparator + "999){+|1}";
                },
                digits: "*",
                digitsOptional: !0,
                enforceDigitsOnBlur: !1,
                radixPoint: ".",
                positionCaretOnClick: "radixFocus",
                _radixDance: !0,
                groupSeparator: "",
                allowMinus: !0,
                negationSymbol: {
                  front: "-",
                  back: ""
                },
                prefix: "",
                suffix: "",
                min: null,
                max: null,
                SetMaxOnOverflow: !1,
                step: 1,
                inputType: "text",
                unmaskAsNumber: !1,
                roundingFN: Math.round,
                inputmode: "decimal",
                shortcuts: {
                  k: "1000",
                  m: "1000000"
                },
                placeholder: "0",
                greedy: !1,
                rightAlign: !0,
                insertMode: !0,
                autoUnmask: !1,
                skipOptionalPartCharacter: "",
                usePrototypeDefinitions: !1,
                stripLeadingZeroes: !0,
                substituteRadixPoint: !0,
                definitions: {
                  0: {
                    validator: x
                  },
                  1: {
                    validator: x,
                    definitionSymbol: "9"
                  },
                  9: {
                    validator: "[0-9０-９٠-٩۰-۹]",
                    definitionSymbol: "*"
                  },
                  "+": {
                    validator: function(k, C, O, E, B) {
                      return B.allowMinus && (k === "-" || k === B.negationSymbol.front);
                    }
                  },
                  "-": {
                    validator: function(k, C, O, E, B) {
                      return B.allowMinus && k === B.negationSymbol.back;
                    }
                  }
                },
                preValidation: function(k, C, O, E, B, M, R, F) {
                  var L = this;
                  if (B.__financeInput !== !1 && O === B.radixPoint) return !1;
                  var j = k.indexOf(B.radixPoint), H = C;
                  if (C = function(ye, Y, ae, ke, ue) {
                    return ue._radixDance && ue.numericInput && Y !== ue.negationSymbol.back && ye <= ae && (ae > 0 || Y == ue.radixPoint) && (ke.validPositions[ye - 1] === void 0 || ke.validPositions[ye - 1].input !== ue.negationSymbol.back) && (ye -= 1), ye;
                  }(C, O, j, M, B), O === "-" || O === B.negationSymbol.front) {
                    if (B.allowMinus !== !0) return !1;
                    var te = !1, re = T("+", M), le = T("-", M);
                    return re !== -1 && (te = [re], le !== -1 && te.push(le)), te !== !1 ? {
                      remove: te,
                      caret: H - B.negationSymbol.back.length
                    } : {
                      insert: [{
                        pos: I.call(L, "+", M),
                        c: B.negationSymbol.front,
                        fromIsValid: !0
                      }, {
                        pos: I.call(L, "-", M),
                        c: B.negationSymbol.back,
                        fromIsValid: void 0
                      }],
                      caret: H + B.negationSymbol.back.length
                    };
                  }
                  if (O === B.groupSeparator) return {
                    caret: H
                  };
                  if (F) return !0;
                  if (j !== -1 && B._radixDance === !0 && E === !1 && O === B.radixPoint && B.digits !== void 0 && (isNaN(B.digits) || parseInt(B.digits) > 0) && j !== C) {
                    var ie = I.call(L, B.radixPoint, M);
                    return M.validPositions[ie] && (M.validPositions[ie].generatedInput = M.validPositions[ie].generated || !1), {
                      caret: B._radixDance && C === j - 1 ? j + 1 : j
                    };
                  }
                  if (B.__financeInput === !1) {
                    if (E) {
                      if (B.digitsOptional) return {
                        rewritePosition: R.end
                      };
                      if (!B.digitsOptional) {
                        if (R.begin > j && R.end <= j) return O === B.radixPoint ? {
                          insert: {
                            pos: j + 1,
                            c: "0",
                            fromIsValid: !0
                          },
                          rewritePosition: j
                        } : {
                          rewritePosition: j + 1
                        };
                        if (R.begin < j) return {
                          rewritePosition: R.begin - 1
                        };
                      }
                    } else if (!B.showMaskOnHover && !B.showMaskOnFocus && !B.digitsOptional && B.digits > 0 && this.__valueGet.call(this.el) === "") return {
                      rewritePosition: j
                    };
                  }
                  return {
                    rewritePosition: C
                  };
                },
                postValidation: function(k, C, O, E, B, M, R) {
                  if (E === !1) return E;
                  if (R) return !0;
                  if (B.min !== null || B.max !== null) {
                    var F = B.onUnMask(k.slice().reverse().join(""), void 0, b.extend({}, B, {
                      unmaskAsNumber: !0
                    }));
                    if (B.min !== null && F < B.min && (F.toString().length > B.min.toString().length || F < 0)) return !1;
                    if (B.max !== null && F > B.max) return !!B.SetMaxOnOverflow && {
                      refreshFromBuffer: !0,
                      buffer: S(B.max.toString().replace(".", B.radixPoint).split(""), B.digits, B).reverse()
                    };
                  }
                  return E;
                },
                onUnMask: function(k, C, O) {
                  if (C === "" && O.nullable === !0) return C;
                  var E = k.replace(O.prefix, "");
                  return E = (E = E.replace(O.suffix, "")).replace(new RegExp((0, c.default)(O.groupSeparator), "g"), ""), O.placeholder.charAt(0) !== "" && (E = E.replace(new RegExp(O.placeholder.charAt(0), "g"), "0")), O.unmaskAsNumber ? (O.radixPoint !== "" && E.indexOf(O.radixPoint) !== -1 && (E = E.replace(c.default.call(this, O.radixPoint), ".")), E = (E = E.replace(new RegExp("^" + (0, c.default)(O.negationSymbol.front)), "-")).replace(new RegExp((0, c.default)(O.negationSymbol.back) + "$"), ""), Number(E)) : E;
                },
                isComplete: function(k, C) {
                  var O = (C.numericInput ? k.slice().reverse() : k).join("");
                  return O = (O = (O = (O = (O = O.replace(new RegExp("^" + (0, c.default)(C.negationSymbol.front)), "-")).replace(new RegExp((0, c.default)(C.negationSymbol.back) + "$"), "")).replace(C.prefix, "")).replace(C.suffix, "")).replace(new RegExp((0, c.default)(C.groupSeparator) + "([0-9]{3})", "g"), "$1"), C.radixPoint === "," && (O = O.replace((0, c.default)(C.radixPoint), ".")), isFinite(O);
                },
                onBeforeMask: function(k, C) {
                  var O;
                  k = (O = k) !== null && O !== void 0 ? O : "";
                  var E = C.radixPoint || ",";
                  isFinite(C.digits) && (C.digits = parseInt(C.digits)), typeof k != "number" && C.inputType !== "number" || E === "" || (k = k.toString().replace(".", E));
                  var B = k.charAt(0) === "-" || k.charAt(0) === C.negationSymbol.front, M = k.split(E), R = M[0].replace(/[^\-0-9]/g, ""), F = M.length > 1 ? M[1].replace(/[^0-9]/g, "") : "", L = M.length > 1;
                  k = R + (F !== "" ? E + F : F);
                  var j = 0;
                  if (E !== "" && (j = C.digitsOptional ? C.digits < F.length ? C.digits : F.length : C.digits, F !== "" || !C.digitsOptional)) {
                    var H = Math.pow(10, j || 1);
                    k = k.replace((0, c.default)(E), "."), isNaN(parseFloat(k)) || (k = (C.roundingFN(parseFloat(k) * H) / H).toFixed(j)), k = k.toString().replace(".", E);
                  }
                  if (C.digits === 0 && k.indexOf(E) !== -1 && (k = k.substring(0, k.indexOf(E))), C.min !== null || C.max !== null) {
                    var te = k.toString().replace(E, ".");
                    C.min !== null && te < C.min ? k = C.min.toString().replace(".", E) : C.max !== null && te > C.max && (k = C.max.toString().replace(".", E));
                  }
                  return B && k.charAt(0) !== "-" && (k = "-" + k), S(k.toString().split(""), j, C, L).join("");
                },
                onBeforeWrite: function(k, C, O, E) {
                  function B(le, ie) {
                    if (E.__financeInput !== !1 || ie) {
                      var ye = le.indexOf(E.radixPoint);
                      ye !== -1 && le.splice(ye, 1);
                    }
                    if (E.groupSeparator !== "") for (; (ye = le.indexOf(E.groupSeparator)) !== -1; ) le.splice(ye, 1);
                    return le;
                  }
                  var M, R;
                  if (E.stripLeadingZeroes && (R = function(le, ie) {
                    var ye = new RegExp("(^" + (ie.negationSymbol.front !== "" ? (0, c.default)(ie.negationSymbol.front) + "?" : "") + (0, c.default)(ie.prefix) + ")(.*)(" + (0, c.default)(ie.suffix) + (ie.negationSymbol.back != "" ? (0, c.default)(ie.negationSymbol.back) + "?" : "") + "$)").exec(le.slice().reverse().join("")), Y = ye ? ye[2] : "", ae = !1;
                    return Y && (Y = Y.split(ie.radixPoint.charAt(0))[0], ae = new RegExp("^[0" + ie.groupSeparator + "]*").exec(Y)), !(!ae || !(ae[0].length > 1 || ae[0].length > 0 && ae[0].length < Y.length)) && ae;
                  }(C, E))) for (var F = C.join("").lastIndexOf(R[0].split("").reverse().join("")) - (R[0] == R.input ? 0 : 1), L = R[0] == R.input ? 1 : 0, j = R[0].length - L; j > 0; j--) this.maskset.validPositions.splice(F + j, 1), delete C[F + j];
                  if (k) switch (k.type) {
                    case "blur":
                    case "checkval":
                      if (E.min !== null) {
                        var H = E.onUnMask(C.slice().reverse().join(""), void 0, b.extend({}, E, {
                          unmaskAsNumber: !0
                        }));
                        if (E.min !== null && H < E.min) return {
                          refreshFromBuffer: !0,
                          buffer: S(E.min.toString().replace(".", E.radixPoint).split(""), E.digits, E).reverse()
                        };
                      }
                      if (C[C.length - 1] === E.negationSymbol.front) {
                        var te = new RegExp("(^" + (E.negationSymbol.front != "" ? (0, c.default)(E.negationSymbol.front) + "?" : "") + (0, c.default)(E.prefix) + ")(.*)(" + (0, c.default)(E.suffix) + (E.negationSymbol.back != "" ? (0, c.default)(E.negationSymbol.back) + "?" : "") + "$)").exec(B(C.slice(), !0).reverse().join(""));
                        (te ? te[2] : "") == 0 && (M = {
                          refreshFromBuffer: !0,
                          buffer: [0]
                        });
                      } else E.radixPoint !== "" && C.indexOf(E.radixPoint) === E.suffix.length && (M && M.buffer ? M.buffer.splice(0, 1 + E.suffix.length) : (C.splice(0, 1 + E.suffix.length), M = {
                        refreshFromBuffer: !0,
                        buffer: B(C)
                      }));
                      if (E.enforceDigitsOnBlur) {
                        var re = (M = M || {}) && M.buffer || C.slice().reverse();
                        M.refreshFromBuffer = !0, M.buffer = S(re, E.digits, E, !0).reverse();
                      }
                  }
                  return M;
                },
                onKeyDown: function(k, C, O, E) {
                  var B, M = b(this);
                  if (k.location != 3) {
                    var R, F = k.key;
                    if ((R = E.shortcuts && E.shortcuts[F]) && R.length > 1) return this.inputmask.__valueSet.call(this, parseFloat(this.inputmask.unmaskedvalue()) * parseInt(R)), M.trigger("setvalue"), !1;
                  }
                  if (k.ctrlKey) switch (k.key) {
                    case m.keys.ArrowUp:
                      return this.inputmask.__valueSet.call(this, parseFloat(this.inputmask.unmaskedvalue()) + parseInt(E.step)), M.trigger("setvalue"), !1;
                    case m.keys.ArrowDown:
                      return this.inputmask.__valueSet.call(this, parseFloat(this.inputmask.unmaskedvalue()) - parseInt(E.step)), M.trigger("setvalue"), !1;
                  }
                  if (!k.shiftKey && (k.key === m.keys.Delete || k.key === m.keys.Backspace || k.key === m.keys.BACKSPACE_SAFARI) && O.begin !== C.length) {
                    if (C[k.key === m.keys.Delete ? O.begin - 1 : O.end] === E.negationSymbol.front) return B = C.slice().reverse(), E.negationSymbol.front !== "" && B.shift(), E.negationSymbol.back !== "" && B.pop(), M.trigger("setvalue", [B.join(""), O.begin]), !1;
                    if (E._radixDance === !0) {
                      var L, j = C.indexOf(E.radixPoint);
                      if (E.digitsOptional) {
                        if (j === 0) return (B = C.slice().reverse()).pop(), M.trigger("setvalue", [B.join(""), O.begin >= B.length ? B.length : O.begin]), !1;
                      } else if (j !== -1 && (O.begin < j || O.end < j || k.key === m.keys.Delete && (O.begin === j || O.begin - 1 === j))) return O.begin === O.end && (k.key === m.keys.Backspace || k.key === m.keys.BACKSPACE_SAFARI ? O.begin++ : k.key === m.keys.Delete && O.begin - 1 === j && (L = b.extend({}, O), O.begin--, O.end--)), (B = C.slice().reverse()).splice(B.length - O.begin, O.begin - O.end + 1), B = S(B, E.digits, E).join(""), L && (O = L), M.trigger("setvalue", [B, O.begin >= B.length ? j + 1 : O.begin]), !1;
                    }
                  }
                }
              },
              currency: {
                prefix: "",
                groupSeparator: ",",
                alias: "numeric",
                digits: 2,
                digitsOptional: !1
              },
              decimal: {
                alias: "numeric"
              },
              integer: {
                alias: "numeric",
                inputmode: "numeric",
                digits: 0
              },
              percentage: {
                alias: "numeric",
                min: 0,
                max: 100,
                suffix: " %",
                digits: 0,
                allowMinus: !1
              },
              indianns: {
                alias: "numeric",
                _mask: function(k) {
                  return "(" + k.groupSeparator + "99){*|1}(" + k.groupSeparator + "999){1|1}";
                },
                groupSeparator: ",",
                radixPoint: ".",
                placeholder: "0",
                digits: 2,
                digitsOptional: !1
              }
            });
          },
          9380: function(o, l) {
            Object.defineProperty(l, "__esModule", {
              value: !0
            }), l.default = void 0;
            var d = !(typeof window > "u" || !window.document || !window.document.createElement);
            l.default = d ? window : {};
          },
          7760: function(o, l, d) {
            Object.defineProperty(l, "__esModule", {
              value: !0
            }), l.HandleNativePlaceholder = function(x, k) {
              var C = x ? x.inputmask : this;
              if (c.ie) {
                if (x.inputmask._valueGet() !== k && (x.placeholder !== k || x.placeholder === "")) {
                  var O = f.getBuffer.call(C).slice(), E = x.inputmask._valueGet();
                  if (E !== k) {
                    var B = f.getLastValidPosition.call(C);
                    B === -1 && E === f.getBufferTemplate.call(C).join("") ? O = [] : B !== -1 && S.call(C, O), T(x, O);
                  }
                }
              } else x.placeholder !== k && (x.placeholder = k, x.placeholder === "" && x.removeAttribute("placeholder"));
            }, l.applyInputValue = w, l.checkVal = I, l.clearOptionalTail = S, l.unmaskedvalue = function(x) {
              var k = x ? x.inputmask : this, C = k.opts, O = k.maskset;
              if (x) {
                if (x.inputmask === void 0) return x.value;
                x.inputmask && x.inputmask.refreshValue && w(x, x.inputmask._valueGet(!0));
              }
              for (var E = [], B = O.validPositions, M = 0, R = B.length; M < R; M++) B[M] && B[M].match && (B[M].match.static != 1 || Array.isArray(O.metadata) && B[M].generatedInput !== !0) && E.push(B[M].input);
              var F = E.length === 0 ? "" : (k.isRTL ? E.reverse() : E).join("");
              if (typeof C.onUnMask == "function") {
                var L = (k.isRTL ? f.getBuffer.call(k).slice().reverse() : f.getBuffer.call(k)).join("");
                F = C.onUnMask.call(k, L, F, C);
              }
              return F;
            }, l.writeBuffer = T;
            var c = d(9845), u = d(6030), m = d(2839), f = d(8711), v = d(7215), b = d(4713);
            function w(x, k, C) {
              var O = x ? x.inputmask : this, E = O.opts;
              x.inputmask.refreshValue = !1, typeof E.onBeforeMask == "function" && (k = E.onBeforeMask.call(O, k, E) || k), I(x, !0, !1, k = (k || "").toString().split(""), C), O.undoValue = O._valueGet(!0), (E.clearMaskOnLostFocus || E.clearIncomplete) && x.inputmask._valueGet() === f.getBufferTemplate.call(O).join("") && f.getLastValidPosition.call(O) === -1 && x.inputmask._valueSet("");
            }
            function S(x) {
              x.length = 0;
              for (var k, C = b.getMaskTemplate.call(this, !0, 0, !0, void 0, !0); (k = C.shift()) !== void 0; ) x.push(k);
              return x;
            }
            function I(x, k, C, O, E) {
              var B, M = x ? x.inputmask : this, R = M.maskset, F = M.opts, L = M.dependencyLib, j = O.slice(), H = "", te = -1, re = F.skipOptionalPartCharacter;
              F.skipOptionalPartCharacter = "", f.resetMaskSet.call(M, !1), M.clicked = 0, te = F.radixPoint ? f.determineNewCaretPosition.call(M, {
                begin: 0,
                end: 0
              }, !1, F.__financeInput === !1 ? "radixFocus" : void 0).begin : 0, R.p = te, M.caretPos = {
                begin: te
              };
              var le = [], ie = M.caretPos;
              if (j.forEach(function(oe, fe) {
                if (oe !== void 0) {
                  var we = new L.Event("_checkval");
                  we.key = oe, H += oe;
                  var Ie = f.getLastValidPosition.call(M, void 0, !0);
                  (function(be, Oe) {
                    for (var ze = b.getMaskTemplate.call(M, !0, 0).slice(be, f.seekNext.call(M, be, !1, !1)).join("").replace(/'/g, ""), Re = ze.indexOf(Oe); Re > 0 && ze[Re - 1] === " "; ) Re--;
                    var ge = Re === 0 && !f.isMask.call(M, be) && (b.getTest.call(M, be).match.nativeDef === Oe.charAt(0) || b.getTest.call(M, be).match.static === !0 && b.getTest.call(M, be).match.nativeDef === "'" + Oe.charAt(0) || b.getTest.call(M, be).match.nativeDef === " " && (b.getTest.call(M, be + 1).match.nativeDef === Oe.charAt(0) || b.getTest.call(M, be + 1).match.static === !0 && b.getTest.call(M, be + 1).match.nativeDef === "'" + Oe.charAt(0)));
                    if (!ge && Re > 0 && !f.isMask.call(M, be, !1, !0)) {
                      var he = f.seekNext.call(M, be);
                      M.caretPos.begin < he && (M.caretPos = {
                        begin: he
                      });
                    }
                    return ge;
                  })(te, H) ? B = u.EventHandlers.keypressEvent.call(M, we, !0, !1, C, Ie + 1) : (B = u.EventHandlers.keypressEvent.call(M, we, !0, !1, C, M.caretPos.begin)) && (te = M.caretPos.begin + 1, H = ""), B ? (B.pos !== void 0 && R.validPositions[B.pos] && R.validPositions[B.pos].match.static === !0 && R.validPositions[B.pos].alternation === void 0 && (le.push(B.pos), M.isRTL || (B.forwardPosition = B.pos + 1)), T.call(M, void 0, f.getBuffer.call(M), B.forwardPosition, we, !1), M.caretPos = {
                    begin: B.forwardPosition,
                    end: B.forwardPosition
                  }, ie = M.caretPos) : R.validPositions[fe] === void 0 && j[fe] === b.getPlaceholder.call(M, fe) && f.isMask.call(M, fe, !0) ? M.caretPos.begin++ : M.caretPos = ie;
                }
              }), le.length > 0) {
                var ye, Y, ae = f.seekNext.call(M, -1, void 0, !1);
                if (!v.isComplete.call(M, f.getBuffer.call(M)) && le.length <= ae || v.isComplete.call(M, f.getBuffer.call(M)) && le.length > 0 && le.length !== ae && le[0] === 0) {
                  for (var ke = ae; (ye = le.shift()) !== void 0; ) if (ye < ke) {
                    var ue = new L.Event("_checkval");
                    if ((Y = R.validPositions[ye]).generatedInput = !0, ue.key = Y.input, (B = u.EventHandlers.keypressEvent.call(M, ue, !0, !1, C, ke)) && B.pos !== void 0 && B.pos !== ye && R.validPositions[B.pos] && R.validPositions[B.pos].match.static === !0) le.push(B.pos);
                    else if (!B) break;
                    ke++;
                  }
                }
              }
              k && T.call(M, x, f.getBuffer.call(M), B ? B.forwardPosition : M.caretPos.begin, E || new L.Event("checkval"), E && (E.type === "input" && M.undoValue !== f.getBuffer.call(M).join("") || E.type === "paste")), F.skipOptionalPartCharacter = re;
            }
            function T(x, k, C, O, E) {
              var B = x ? x.inputmask : this, M = B.opts, R = B.dependencyLib;
              if (O && typeof M.onBeforeWrite == "function") {
                var F = M.onBeforeWrite.call(B, O, k, C, M);
                if (F) {
                  if (F.refreshFromBuffer) {
                    var L = F.refreshFromBuffer;
                    v.refreshFromBuffer.call(B, L === !0 ? L : L.start, L.end, F.buffer || k), k = f.getBuffer.call(B, !0);
                  }
                  C !== void 0 && (C = F.caret !== void 0 ? F.caret : C);
                }
              }
              if (x !== void 0 && (x.inputmask._valueSet(k.join("")), C === void 0 || O !== void 0 && O.type === "blur" || f.caret.call(B, x, C, void 0, void 0, O !== void 0 && O.type === "keydown" && (O.key === m.keys.Delete || O.key === m.keys.Backspace)), x.inputmask.writeBufferHook === void 0 || x.inputmask.writeBufferHook(C), E === !0)) {
                var j = R(x), H = x.inputmask._valueGet();
                x.inputmask.skipInputEvent = !0, j.trigger("input"), setTimeout(function() {
                  H === f.getBufferTemplate.call(B).join("") ? j.trigger("cleared") : v.isComplete.call(B, k) === !0 && j.trigger("complete");
                }, 0);
              }
            }
          },
          2394: function(o, l, d) {
            Object.defineProperty(l, "__esModule", {
              value: !0
            }), l.default = void 0;
            var c = C(d(3976)), u = C(d(7392)), m = C(d(4963)), f = d(9716), v = C(d(9380)), b = d(7760), w = d(157), S = d(2391), I = d(8711), T = d(7215), x = d(4713);
            function k(R) {
              return k = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(F) {
                return typeof F;
              } : function(F) {
                return F && typeof Symbol == "function" && F.constructor === Symbol && F !== Symbol.prototype ? "symbol" : typeof F;
              }, k(R);
            }
            function C(R) {
              return R && R.__esModule ? R : {
                default: R
              };
            }
            var O = v.default.document, E = "_inputmask_opts";
            function B(R, F, L) {
              if (!(this instanceof B)) return new B(R, F, L);
              this.dependencyLib = m.default, this.el = void 0, this.events = {}, this.maskset = void 0, L !== !0 && (Object.prototype.toString.call(R) === "[object Object]" ? F = R : (F = F || {}, R && (F.alias = R)), this.opts = m.default.extend(!0, {}, this.defaults, F), this.noMasksCache = F && F.definitions !== void 0, this.userOptions = F || {}, M(this.opts.alias, F, this.opts)), this.refreshValue = !1, this.undoValue = void 0, this.$el = void 0, this.skipInputEvent = !1, this.validationEvent = !1, this.ignorable = !1, this.maxLength, this.mouseEnter = !1, this.clicked = 0, this.originalPlaceholder = void 0, this.isComposing = !1, this.hasAlternator = !1;
            }
            function M(R, F, L) {
              var j = B.prototype.aliases[R];
              return j ? (j.alias && M(j.alias, void 0, L), m.default.extend(!0, L, j), m.default.extend(!0, L, F), !0) : (L.mask === null && (L.mask = R), !1);
            }
            B.prototype = {
              dataAttribute: "data-inputmask",
              defaults: c.default,
              definitions: u.default,
              aliases: {},
              masksCache: {},
              i18n: {},
              get isRTL() {
                return this.opts.isRTL || this.opts.numericInput;
              },
              mask: function(R) {
                var F = this;
                return typeof R == "string" && (R = O.getElementById(R) || O.querySelectorAll(R)), (R = R.nodeName ? [R] : Array.isArray(R) ? R : [].slice.call(R)).forEach(function(L, j) {
                  var H = m.default.extend(!0, {}, F.opts);
                  if (function(re, le, ie, ye) {
                    function Y(we, Ie) {
                      var be = ye === "" ? we : ye + "-" + we;
                      (Ie = Ie !== void 0 ? Ie : re.getAttribute(be)) !== null && (typeof Ie == "string" && (we.indexOf("on") === 0 ? Ie = v.default[Ie] : Ie === "false" ? Ie = !1 : Ie === "true" && (Ie = !0)), ie[we] = Ie);
                    }
                    if (le.importDataAttributes === !0) {
                      var ae, ke, ue, oe, fe = re.getAttribute(ye);
                      if (fe && fe !== "" && (fe = fe.replace(/'/g, '"'), ke = JSON.parse("{" + fe + "}")), ke) {
                        for (oe in ue = void 0, ke) if (oe.toLowerCase() === "alias") {
                          ue = ke[oe];
                          break;
                        }
                      }
                      for (ae in Y("alias", ue), ie.alias && M(ie.alias, ie, le), le) {
                        if (ke) {
                          for (oe in ue = void 0, ke) if (oe.toLowerCase() === ae.toLowerCase()) {
                            ue = ke[oe];
                            break;
                          }
                        }
                        Y(ae, ue);
                      }
                    }
                    return m.default.extend(!0, le, ie), (re.dir === "rtl" || le.rightAlign) && (re.style.textAlign = "right"), (re.dir === "rtl" || le.numericInput) && (re.dir = "ltr", re.removeAttribute("dir"), le.isRTL = !0), Object.keys(ie).length;
                  }(L, H, m.default.extend(!0, {}, F.userOptions), F.dataAttribute)) {
                    var te = (0, S.generateMaskSet)(H, F.noMasksCache);
                    te !== void 0 && (L.inputmask !== void 0 && (L.inputmask.opts.autoUnmask = !0, L.inputmask.remove()), L.inputmask = new B(void 0, void 0, !0), L.inputmask.opts = H, L.inputmask.noMasksCache = F.noMasksCache, L.inputmask.userOptions = m.default.extend(!0, {}, F.userOptions), L.inputmask.el = L, L.inputmask.$el = (0, m.default)(L), L.inputmask.maskset = te, m.default.data(L, E, F.userOptions), w.mask.call(L.inputmask));
                  }
                }), R && R[0] && R[0].inputmask || this;
              },
              option: function(R, F) {
                return typeof R == "string" ? this.opts[R] : k(R) === "object" ? (m.default.extend(this.userOptions, R), this.el && F !== !0 && this.mask(this.el), this) : void 0;
              },
              unmaskedvalue: function(R) {
                if (this.maskset = this.maskset || (0, S.generateMaskSet)(this.opts, this.noMasksCache), this.el === void 0 || R !== void 0) {
                  var F = (typeof this.opts.onBeforeMask == "function" && this.opts.onBeforeMask.call(this, R, this.opts) || R).split("");
                  b.checkVal.call(this, void 0, !1, !1, F), typeof this.opts.onBeforeWrite == "function" && this.opts.onBeforeWrite.call(this, void 0, I.getBuffer.call(this), 0, this.opts);
                }
                return b.unmaskedvalue.call(this, this.el);
              },
              remove: function() {
                if (this.el) {
                  m.default.data(this.el, E, null);
                  var R = this.opts.autoUnmask ? (0, b.unmaskedvalue)(this.el) : this._valueGet(this.opts.autoUnmask);
                  R !== I.getBufferTemplate.call(this).join("") ? this._valueSet(R, this.opts.autoUnmask) : this._valueSet(""), f.EventRuler.off(this.el), Object.getOwnPropertyDescriptor && Object.getPrototypeOf ? Object.getOwnPropertyDescriptor(Object.getPrototypeOf(this.el), "value") && this.__valueGet && Object.defineProperty(this.el, "value", {
                    get: this.__valueGet,
                    set: this.__valueSet,
                    configurable: !0
                  }) : O.__lookupGetter__ && this.el.__lookupGetter__("value") && this.__valueGet && (this.el.__defineGetter__("value", this.__valueGet), this.el.__defineSetter__("value", this.__valueSet)), this.el.inputmask = void 0;
                }
                return this.el;
              },
              getemptymask: function() {
                return this.maskset = this.maskset || (0, S.generateMaskSet)(this.opts, this.noMasksCache), (this.isRTL ? I.getBufferTemplate.call(this).reverse() : I.getBufferTemplate.call(this)).join("");
              },
              hasMaskedValue: function() {
                return !this.opts.autoUnmask;
              },
              isComplete: function() {
                return this.maskset = this.maskset || (0, S.generateMaskSet)(this.opts, this.noMasksCache), T.isComplete.call(this, I.getBuffer.call(this));
              },
              getmetadata: function() {
                if (this.maskset = this.maskset || (0, S.generateMaskSet)(this.opts, this.noMasksCache), Array.isArray(this.maskset.metadata)) {
                  var R = x.getMaskTemplate.call(this, !0, 0, !1).join("");
                  return this.maskset.metadata.forEach(function(F) {
                    return F.mask !== R || (R = F, !1);
                  }), R;
                }
                return this.maskset.metadata;
              },
              isValid: function(R) {
                if (this.maskset = this.maskset || (0, S.generateMaskSet)(this.opts, this.noMasksCache), R) {
                  var F = (typeof this.opts.onBeforeMask == "function" && this.opts.onBeforeMask.call(this, R, this.opts) || R).split("");
                  b.checkVal.call(this, void 0, !0, !1, F);
                } else R = this.isRTL ? I.getBuffer.call(this).slice().reverse().join("") : I.getBuffer.call(this).join("");
                for (var L = I.getBuffer.call(this), j = I.determineLastRequiredPosition.call(this), H = L.length - 1; H > j && !I.isMask.call(this, H); H--) ;
                return L.splice(j, H + 1 - j), T.isComplete.call(this, L) && R === (this.isRTL ? I.getBuffer.call(this).slice().reverse().join("") : I.getBuffer.call(this).join(""));
              },
              format: function(R, F) {
                this.maskset = this.maskset || (0, S.generateMaskSet)(this.opts, this.noMasksCache);
                var L = (typeof this.opts.onBeforeMask == "function" && this.opts.onBeforeMask.call(this, R, this.opts) || R).split("");
                b.checkVal.call(this, void 0, !0, !1, L);
                var j = this.isRTL ? I.getBuffer.call(this).slice().reverse().join("") : I.getBuffer.call(this).join("");
                return F ? {
                  value: j,
                  metadata: this.getmetadata()
                } : j;
              },
              setValue: function(R) {
                this.el && (0, m.default)(this.el).trigger("setvalue", [R]);
              },
              analyseMask: S.analyseMask
            }, B.extendDefaults = function(R) {
              m.default.extend(!0, B.prototype.defaults, R);
            }, B.extendDefinitions = function(R) {
              m.default.extend(!0, B.prototype.definitions, R);
            }, B.extendAliases = function(R) {
              m.default.extend(!0, B.prototype.aliases, R);
            }, B.format = function(R, F, L) {
              return B(F).format(R, L);
            }, B.unmask = function(R, F) {
              return B(F).unmaskedvalue(R);
            }, B.isValid = function(R, F) {
              return B(F).isValid(R);
            }, B.remove = function(R) {
              typeof R == "string" && (R = O.getElementById(R) || O.querySelectorAll(R)), (R = R.nodeName ? [R] : R).forEach(function(F) {
                F.inputmask && F.inputmask.remove();
              });
            }, B.setValue = function(R, F) {
              typeof R == "string" && (R = O.getElementById(R) || O.querySelectorAll(R)), (R = R.nodeName ? [R] : R).forEach(function(L) {
                L.inputmask ? L.inputmask.setValue(F) : (0, m.default)(L).trigger("setvalue", [F]);
              });
            }, B.dependencyLib = m.default, v.default.Inputmask = B, l.default = B;
          },
          5296: function(o, l, d) {
            function c(O) {
              return c = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(E) {
                return typeof E;
              } : function(E) {
                return E && typeof Symbol == "function" && E.constructor === Symbol && E !== Symbol.prototype ? "symbol" : typeof E;
              }, c(O);
            }
            var u = x(d(9380)), m = x(d(2394));
            function f(O, E) {
              for (var B = 0; B < E.length; B++) {
                var M = E[B];
                M.enumerable = M.enumerable || !1, M.configurable = !0, "value" in M && (M.writable = !0), Object.defineProperty(O, (R = M.key, F = void 0, F = function(L, j) {
                  if (c(L) !== "object" || L === null) return L;
                  var H = L[Symbol.toPrimitive];
                  if (H !== void 0) {
                    var te = H.call(L, j);
                    if (c(te) !== "object") return te;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                  }
                  return (j === "string" ? String : Number)(L);
                }(R, "string"), c(F) === "symbol" ? F : String(F)), M);
              }
              var R, F;
            }
            function v(O) {
              var E = S();
              return function() {
                var B, M = T(O);
                if (E) {
                  var R = T(this).constructor;
                  B = Reflect.construct(M, arguments, R);
                } else B = M.apply(this, arguments);
                return function(F, L) {
                  if (L && (c(L) === "object" || typeof L == "function")) return L;
                  if (L !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
                  return function(j) {
                    if (j === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return j;
                  }(F);
                }(this, B);
              };
            }
            function b(O) {
              var E = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
              return b = function(B) {
                if (B === null || !function(R) {
                  try {
                    return Function.toString.call(R).indexOf("[native code]") !== -1;
                  } catch {
                    return typeof R == "function";
                  }
                }(B)) return B;
                if (typeof B != "function") throw new TypeError("Super expression must either be null or a function");
                if (E !== void 0) {
                  if (E.has(B)) return E.get(B);
                  E.set(B, M);
                }
                function M() {
                  return w(B, arguments, T(this).constructor);
                }
                return M.prototype = Object.create(B.prototype, {
                  constructor: {
                    value: M,
                    enumerable: !1,
                    writable: !0,
                    configurable: !0
                  }
                }), I(M, B);
              }, b(O);
            }
            function w(O, E, B) {
              return w = S() ? Reflect.construct.bind() : function(M, R, F) {
                var L = [null];
                L.push.apply(L, R);
                var j = new (Function.bind.apply(M, L))();
                return F && I(j, F.prototype), j;
              }, w.apply(null, arguments);
            }
            function S() {
              if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
              if (typeof Proxy == "function") return !0;
              try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
                })), !0;
              } catch {
                return !1;
              }
            }
            function I(O, E) {
              return I = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(B, M) {
                return B.__proto__ = M, B;
              }, I(O, E);
            }
            function T(O) {
              return T = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(E) {
                return E.__proto__ || Object.getPrototypeOf(E);
              }, T(O);
            }
            function x(O) {
              return O && O.__esModule ? O : {
                default: O
              };
            }
            var k = u.default.document;
            if (k && k.head && k.head.attachShadow && u.default.customElements && u.default.customElements.get("input-mask") === void 0) {
              var C = function(O) {
                (function(F, L) {
                  if (typeof L != "function" && L !== null) throw new TypeError("Super expression must either be null or a function");
                  F.prototype = Object.create(L && L.prototype, {
                    constructor: {
                      value: F,
                      writable: !0,
                      configurable: !0
                    }
                  }), Object.defineProperty(F, "prototype", {
                    writable: !1
                  }), L && I(F, L);
                })(R, O);
                var E, B, M = v(R);
                function R() {
                  var F;
                  (function(re, le) {
                    if (!(re instanceof le)) throw new TypeError("Cannot call a class as a function");
                  })(this, R);
                  var L = (F = M.call(this)).getAttributeNames(), j = F.attachShadow({
                    mode: "closed"
                  });
                  for (var H in F.input = k.createElement("input"), F.input.type = "text", j.appendChild(F.input), L) Object.prototype.hasOwnProperty.call(L, H) && F.input.setAttribute(L[H], F.getAttribute(L[H]));
                  var te = new m.default();
                  return te.dataAttribute = "", te.mask(F.input), F.input.inputmask.shadowRoot = j, F;
                }
                return E = R, (B = [{
                  key: "attributeChangedCallback",
                  value: function(F, L, j) {
                    this.input.setAttribute(F, j);
                  }
                }, {
                  key: "value",
                  get: function() {
                    return this.input.value;
                  },
                  set: function(F) {
                    this.input.value = F;
                  }
                }]) && f(E.prototype, B), Object.defineProperty(E, "prototype", {
                  writable: !1
                }), R;
              }(b(HTMLElement));
              u.default.customElements.define("input-mask", C);
            }
          },
          2839: function(o, l) {
            function d(w) {
              return d = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(S) {
                return typeof S;
              } : function(S) {
                return S && typeof Symbol == "function" && S.constructor === Symbol && S !== Symbol.prototype ? "symbol" : typeof S;
              }, d(w);
            }
            function c(w, S) {
              return function(I) {
                if (Array.isArray(I)) return I;
              }(w) || function(I, T) {
                var x = I == null ? null : typeof Symbol < "u" && I[Symbol.iterator] || I["@@iterator"];
                if (x != null) {
                  var k, C, O, E, B = [], M = !0, R = !1;
                  try {
                    if (O = (x = x.call(I)).next, T !== 0) for (; !(M = (k = O.call(x)).done) && (B.push(k.value), B.length !== T); M = !0) ;
                  } catch (F) {
                    R = !0, C = F;
                  } finally {
                    try {
                      if (!M && x.return != null && (E = x.return(), Object(E) !== E)) return;
                    } finally {
                      if (R) throw C;
                    }
                  }
                  return B;
                }
              }(w, S) || function(I, T) {
                if (I) {
                  if (typeof I == "string") return u(I, T);
                  var x = Object.prototype.toString.call(I).slice(8, -1);
                  if (x === "Object" && I.constructor && (x = I.constructor.name), x === "Map" || x === "Set") return Array.from(I);
                  if (x === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(x)) return u(I, T);
                }
              }(w, S) || function() {
                throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
              }();
            }
            function u(w, S) {
              (S == null || S > w.length) && (S = w.length);
              for (var I = 0, T = new Array(S); I < S; I++) T[I] = w[I];
              return T;
            }
            function m(w, S) {
              var I = Object.keys(w);
              if (Object.getOwnPropertySymbols) {
                var T = Object.getOwnPropertySymbols(w);
                S && (T = T.filter(function(x) {
                  return Object.getOwnPropertyDescriptor(w, x).enumerable;
                })), I.push.apply(I, T);
              }
              return I;
            }
            function f(w, S, I) {
              return (S = function(T) {
                var x = function(k, C) {
                  if (d(k) !== "object" || k === null) return k;
                  var O = k[Symbol.toPrimitive];
                  if (O !== void 0) {
                    var E = O.call(k, C);
                    if (d(E) !== "object") return E;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                  }
                  return (C === "string" ? String : Number)(k);
                }(T, "string");
                return d(x) === "symbol" ? x : String(x);
              }(S)) in w ? Object.defineProperty(w, S, {
                value: I,
                enumerable: !0,
                configurable: !0,
                writable: !0
              }) : w[S] = I, w;
            }
            Object.defineProperty(l, "__esModule", {
              value: !0
            }), l.keys = l.keyCode = void 0, l.toKey = function(w, S) {
              return b[w] || (S ? String.fromCharCode(w) : String.fromCharCode(w).toLowerCase());
            }, l.toKeyCode = function(w) {
              return v[w];
            };
            var v = l.keyCode = function(w) {
              for (var S = 1; S < arguments.length; S++) {
                var I = arguments[S] != null ? arguments[S] : {};
                S % 2 ? m(Object(I), !0).forEach(function(T) {
                  f(w, T, I[T]);
                }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(w, Object.getOwnPropertyDescriptors(I)) : m(Object(I)).forEach(function(T) {
                  Object.defineProperty(w, T, Object.getOwnPropertyDescriptor(I, T));
                });
              }
              return w;
            }({
              c: 67,
              x: 88,
              z: 90,
              BACKSPACE_SAFARI: 127,
              Enter: 13,
              Meta_LEFT: 91,
              Meta_RIGHT: 92,
              Space: 32
            }, {
              Alt: 18,
              AltGraph: 18,
              ArrowDown: 40,
              ArrowLeft: 37,
              ArrowRight: 39,
              ArrowUp: 38,
              Backspace: 8,
              CapsLock: 20,
              Control: 17,
              ContextMenu: 93,
              Dead: 221,
              Delete: 46,
              End: 35,
              Escape: 27,
              F1: 112,
              F2: 113,
              F3: 114,
              F4: 115,
              F5: 116,
              F6: 117,
              F7: 118,
              F8: 119,
              F9: 120,
              F10: 121,
              F11: 122,
              F12: 123,
              Home: 36,
              Insert: 45,
              NumLock: 144,
              PageDown: 34,
              PageUp: 33,
              Pause: 19,
              PrintScreen: 44,
              Process: 229,
              Shift: 16,
              ScrollLock: 145,
              Tab: 9,
              Unidentified: 229
            }), b = Object.entries(v).reduce(function(w, S) {
              var I = c(S, 2), T = I[0], x = I[1];
              return w[x] = w[x] === void 0 ? T : w[x], w;
            }, {});
            l.keys = Object.entries(v).reduce(function(w, S) {
              var I = c(S, 2), T = I[0];
              return I[1], w[T] = T === "Space" ? " " : T, w;
            }, {});
          },
          2391: function(o, l, d) {
            Object.defineProperty(l, "__esModule", {
              value: !0
            }), l.analyseMask = function(S, I, T) {
              var x, k, C, O, E, B, M = /(?:[?*+]|\{[0-9+*]+(?:,[0-9+*]*)?(?:\|[0-9+*]*)?\})|[^.?*+^${[]()|\\]+|./g, R = /\[\^?]?(?:[^\\\]]+|\\[\S\s]?)*]?|\\(?:0(?:[0-3][0-7]{0,2}|[4-7][0-7]?)?|[1-9][0-9]*|x[0-9A-Fa-f]{2}|u[0-9A-Fa-f]{4}|c[A-Za-z]|[\S\s]?)|\((?:\?[:=!]?)?|(?:[?*+]|\{[0-9]+(?:,[0-9]*)?\})\??|[^.?*+^${[()|\\]+|./g, F = !1, L = new f.default(), j = [], H = [], te = !1;
              function re(Re, ge, he) {
                he = he !== void 0 ? he : Re.matches.length;
                var Me = Re.matches[he - 1];
                if (I) {
                  if (ge.indexOf("[") === 0 || F && /\\d|\\s|\\w|\\p/i.test(ge) || ge === ".") {
                    var Ne = T.casing ? "i" : "";
                    /\\p\{.*}/i.test(ge) && (Ne += "u"), Re.matches.splice(he++, 0, {
                      fn: new RegExp(ge, Ne),
                      static: !1,
                      optionality: !1,
                      newBlockMarker: Me === void 0 ? "master" : Me.def !== ge,
                      casing: null,
                      def: ge,
                      placeholder: v(T.placeholder) === "object" ? T.placeholder[L.matches.length] : void 0,
                      nativeDef: ge
                    });
                  } else F && (ge = ge[ge.length - 1]), ge.split("").forEach(function(mt, yt) {
                    Me = Re.matches[he - 1], Re.matches.splice(he++, 0, {
                      fn: /[a-z]/i.test(T.staticDefinitionSymbol || mt) ? new RegExp("[" + (T.staticDefinitionSymbol || mt) + "]", T.casing ? "i" : "") : null,
                      static: !0,
                      optionality: !1,
                      newBlockMarker: Me === void 0 ? "master" : Me.def !== mt && Me.static !== !0,
                      casing: null,
                      def: T.staticDefinitionSymbol || mt,
                      placeholder: T.staticDefinitionSymbol !== void 0 ? mt : v(T.placeholder) === "object" ? T.placeholder[L.matches.length] : void 0,
                      nativeDef: (F ? "'" : "") + mt
                    });
                  });
                  F = !1;
                } else {
                  var $e = T.definitions && T.definitions[ge] || T.usePrototypeDefinitions && m.default.prototype.definitions[ge];
                  $e && !F ? Re.matches.splice(he++, 0, {
                    fn: $e.validator ? typeof $e.validator == "string" ? new RegExp($e.validator, T.casing ? "i" : "") : new function() {
                      this.test = $e.validator;
                    }() : /./,
                    static: $e.static || !1,
                    optionality: $e.optional || !1,
                    defOptionality: $e.optional || !1,
                    newBlockMarker: Me === void 0 || $e.optional ? "master" : Me.def !== ($e.definitionSymbol || ge),
                    casing: $e.casing,
                    def: $e.definitionSymbol || ge,
                    placeholder: $e.placeholder,
                    nativeDef: ge,
                    generated: $e.generated
                  }) : (Re.matches.splice(he++, 0, {
                    fn: /[a-z]/i.test(T.staticDefinitionSymbol || ge) ? new RegExp("[" + (T.staticDefinitionSymbol || ge) + "]", T.casing ? "i" : "") : null,
                    static: !0,
                    optionality: !1,
                    newBlockMarker: Me === void 0 ? "master" : Me.def !== ge && Me.static !== !0,
                    casing: null,
                    def: T.staticDefinitionSymbol || ge,
                    placeholder: T.staticDefinitionSymbol !== void 0 ? ge : void 0,
                    nativeDef: (F ? "'" : "") + ge
                  }), F = !1);
                }
              }
              function le() {
                if (j.length > 0) {
                  if (re(O = j[j.length - 1], k), O.isAlternator) {
                    E = j.pop();
                    for (var Re = 0; Re < E.matches.length; Re++) E.matches[Re].isGroup && (E.matches[Re].isGroup = !1);
                    j.length > 0 ? (O = j[j.length - 1]).matches.push(E) : L.matches.push(E);
                  }
                } else re(L, k);
              }
              function ie(Re) {
                var ge = new f.default(!0);
                return ge.openGroup = !1, ge.matches = Re, ge;
              }
              function ye() {
                if ((C = j.pop()).openGroup = !1, C !== void 0) if (j.length > 0) {
                  if ((O = j[j.length - 1]).matches.push(C), O.isAlternator) {
                    E = j.pop();
                    for (var Re = 0; Re < E.matches.length; Re++) E.matches[Re].isGroup = !1, E.matches[Re].alternatorGroup = !1;
                    j.length > 0 ? (O = j[j.length - 1]).matches.push(E) : L.matches.push(E);
                  }
                } else L.matches.push(C);
                else le();
              }
              function Y(Re) {
                var ge = Re.pop();
                return ge.isQuantifier && (ge = ie([Re.pop(), ge])), ge;
              }
              for (I && (T.optionalmarker[0] = void 0, T.optionalmarker[1] = void 0); x = I ? R.exec(S) : M.exec(S); ) {
                if (k = x[0], I) {
                  switch (k.charAt(0)) {
                    case "?":
                      k = "{0,1}";
                      break;
                    case "+":
                    case "*":
                      k = "{" + k + "}";
                      break;
                    case "|":
                      if (j.length === 0) {
                        var ae = ie(L.matches);
                        ae.openGroup = !0, j.push(ae), L.matches = [], te = !0;
                      }
                  }
                  switch (k) {
                    case "\\d":
                      k = "[0-9]";
                      break;
                    case "\\p":
                      k += R.exec(S)[0], k += R.exec(S)[0];
                  }
                }
                if (F) le();
                else switch (k.charAt(0)) {
                  case "$":
                  case "^":
                    I || le();
                    break;
                  case T.escapeChar:
                    F = !0, I && le();
                    break;
                  case T.optionalmarker[1]:
                  case T.groupmarker[1]:
                    ye();
                    break;
                  case T.optionalmarker[0]:
                    j.push(new f.default(!1, !0));
                    break;
                  case T.groupmarker[0]:
                    j.push(new f.default(!0));
                    break;
                  case T.quantifiermarker[0]:
                    var ke = new f.default(!1, !1, !0), ue = (k = k.replace(/[{}?]/g, "")).split("|"), oe = ue[0].split(","), fe = isNaN(oe[0]) ? oe[0] : parseInt(oe[0]), we = oe.length === 1 ? fe : isNaN(oe[1]) ? oe[1] : parseInt(oe[1]), Ie = isNaN(ue[1]) ? ue[1] : parseInt(ue[1]);
                    fe !== "*" && fe !== "+" || (fe = we === "*" ? 0 : 1), ke.quantifier = {
                      min: fe,
                      max: we,
                      jit: Ie
                    };
                    var be = j.length > 0 ? j[j.length - 1].matches : L.matches;
                    (x = be.pop()).isGroup || (x = ie([x])), be.push(x), be.push(ke);
                    break;
                  case T.alternatormarker:
                    if (j.length > 0) {
                      var Oe = (O = j[j.length - 1]).matches[O.matches.length - 1];
                      B = O.openGroup && (Oe.matches === void 0 || Oe.isGroup === !1 && Oe.isAlternator === !1) ? j.pop() : Y(O.matches);
                    } else B = Y(L.matches);
                    if (B.isAlternator) j.push(B);
                    else if (B.alternatorGroup ? (E = j.pop(), B.alternatorGroup = !1) : E = new f.default(!1, !1, !1, !0), E.matches.push(B), j.push(E), B.openGroup) {
                      B.openGroup = !1;
                      var ze = new f.default(!0);
                      ze.alternatorGroup = !0, j.push(ze);
                    }
                    break;
                  default:
                    le();
                }
              }
              for (te && ye(); j.length > 0; ) C = j.pop(), L.matches.push(C);
              return L.matches.length > 0 && (function Re(ge) {
                ge && ge.matches && ge.matches.forEach(function(he, Me) {
                  var Ne = ge.matches[Me + 1];
                  (Ne === void 0 || Ne.matches === void 0 || Ne.isQuantifier === !1) && he && he.isGroup && (he.isGroup = !1, I || (re(he, T.groupmarker[0], 0), he.openGroup !== !0 && re(he, T.groupmarker[1]))), Re(he);
                });
              }(L), H.push(L)), (T.numericInput || T.isRTL) && function Re(ge) {
                for (var he in ge.matches = ge.matches.reverse(), ge.matches) if (Object.prototype.hasOwnProperty.call(ge.matches, he)) {
                  var Me = parseInt(he);
                  if (ge.matches[he].isQuantifier && ge.matches[Me + 1] && ge.matches[Me + 1].isGroup) {
                    var Ne = ge.matches[he];
                    ge.matches.splice(he, 1), ge.matches.splice(Me + 1, 0, Ne);
                  }
                  ge.matches[he].matches !== void 0 ? ge.matches[he] = Re(ge.matches[he]) : ge.matches[he] = (($e = ge.matches[he]) === T.optionalmarker[0] ? $e = T.optionalmarker[1] : $e === T.optionalmarker[1] ? $e = T.optionalmarker[0] : $e === T.groupmarker[0] ? $e = T.groupmarker[1] : $e === T.groupmarker[1] && ($e = T.groupmarker[0]), $e);
                }
                var $e;
                return ge;
              }(H[0]), H;
            }, l.generateMaskSet = function(S, I) {
              var T;
              function x(O, E) {
                var B = E.repeat, M = E.groupmarker, R = E.quantifiermarker, F = E.keepStatic;
                if (B > 0 || B === "*" || B === "+") {
                  var L = B === "*" ? 0 : B === "+" ? 1 : B;
                  if (L != B) O = M[0] + O + M[1] + R[0] + L + "," + B + R[1];
                  else for (var j = O, H = 1; H < L; H++) O += j;
                }
                if (F === !0) {
                  var te = O.match(new RegExp("(.)\\[([^\\]]*)\\]", "g"));
                  te && te.forEach(function(re, le) {
                    var ie = function(ae, ke) {
                      return function(ue) {
                        if (Array.isArray(ue)) return ue;
                      }(ae) || function(ue, oe) {
                        var fe = ue == null ? null : typeof Symbol < "u" && ue[Symbol.iterator] || ue["@@iterator"];
                        if (fe != null) {
                          var we, Ie, be, Oe, ze = [], Re = !0, ge = !1;
                          try {
                            if (be = (fe = fe.call(ue)).next, oe !== 0) for (; !(Re = (we = be.call(fe)).done) && (ze.push(we.value), ze.length !== oe); Re = !0) ;
                          } catch (he) {
                            ge = !0, Ie = he;
                          } finally {
                            try {
                              if (!Re && fe.return != null && (Oe = fe.return(), Object(Oe) !== Oe)) return;
                            } finally {
                              if (ge) throw Ie;
                            }
                          }
                          return ze;
                        }
                      }(ae, ke) || function(ue, oe) {
                        if (ue) {
                          if (typeof ue == "string") return b(ue, oe);
                          var fe = Object.prototype.toString.call(ue).slice(8, -1);
                          if (fe === "Object" && ue.constructor && (fe = ue.constructor.name), fe === "Map" || fe === "Set") return Array.from(ue);
                          if (fe === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(fe)) return b(ue, oe);
                        }
                      }(ae, ke) || function() {
                        throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
                      }();
                    }(re.split("["), 2), ye = ie[0], Y = ie[1];
                    Y = Y.replace("]", ""), O = O.replace(new RegExp("".concat((0, u.default)(ye), "\\[").concat((0, u.default)(Y), "\\]")), ye.charAt(0) === Y.charAt(0) ? "(".concat(ye, "|").concat(ye).concat(Y, ")") : "".concat(ye, "[").concat(Y, "]"));
                  });
                }
                return O;
              }
              function k(O, E, B) {
                var M, R, F = !1;
                return O !== null && O !== "" || ((F = B.regex !== null) ? O = (O = B.regex).replace(/^(\^)(.*)(\$)$/, "$2") : (F = !0, O = ".*")), O.length === 1 && B.greedy === !1 && B.repeat !== 0 && (B.placeholder = ""), O = x(O, B), R = F ? "regex_" + B.regex : B.numericInput ? O.split("").reverse().join("") : O, B.keepStatic !== null && (R = "ks_" + B.keepStatic + R), v(B.placeholder) === "object" && (R = "ph_" + JSON.stringify(B.placeholder) + R), m.default.prototype.masksCache[R] === void 0 || I === !0 ? (M = {
                  mask: O,
                  maskToken: m.default.prototype.analyseMask(O, F, B),
                  validPositions: [],
                  _buffer: void 0,
                  buffer: void 0,
                  tests: {},
                  excludes: {},
                  metadata: E,
                  maskLength: void 0,
                  jitOffset: {}
                }, I !== !0 && (m.default.prototype.masksCache[R] = M, M = c.default.extend(!0, {}, m.default.prototype.masksCache[R]))) : M = c.default.extend(!0, {}, m.default.prototype.masksCache[R]), M;
              }
              if (typeof S.mask == "function" && (S.mask = S.mask(S)), Array.isArray(S.mask)) {
                if (S.mask.length > 1) {
                  S.keepStatic === null && (S.keepStatic = !0);
                  var C = S.groupmarker[0];
                  return (S.isRTL ? S.mask.reverse() : S.mask).forEach(function(O) {
                    C.length > 1 && (C += S.alternatormarker), O.mask !== void 0 && typeof O.mask != "function" ? C += O.mask : C += O;
                  }), k(C += S.groupmarker[1], S.mask, S);
                }
                S.mask = S.mask.pop();
              }
              return T = S.mask && S.mask.mask !== void 0 && typeof S.mask.mask != "function" ? k(S.mask.mask, S.mask, S) : k(S.mask, S.mask, S), S.keepStatic === null && (S.keepStatic = !1), T;
            };
            var c = w(d(4963)), u = w(d(7184)), m = w(d(2394)), f = w(d(9695));
            function v(S) {
              return v = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(I) {
                return typeof I;
              } : function(I) {
                return I && typeof Symbol == "function" && I.constructor === Symbol && I !== Symbol.prototype ? "symbol" : typeof I;
              }, v(S);
            }
            function b(S, I) {
              (I == null || I > S.length) && (I = S.length);
              for (var T = 0, x = new Array(I); T < I; T++) x[T] = S[T];
              return x;
            }
            function w(S) {
              return S && S.__esModule ? S : {
                default: S
              };
            }
          },
          157: function(o, l, d) {
            Object.defineProperty(l, "__esModule", {
              value: !0
            }), l.mask = function() {
              var w = this, S = this.opts, I = this.el, T = this.dependencyLib;
              m.EventRuler.off(I);
              var x = function(O, E) {
                var B = O.getAttribute("type"), M = O.tagName.toLowerCase() === "input" && E.supportsInputType.includes(B) || O.isContentEditable || O.tagName.toLowerCase() === "textarea";
                if (!M) if (O.tagName.toLowerCase() === "input") {
                  var R = document.createElement("input");
                  R.setAttribute("type", B), M = R.type === "text", R = null;
                } else M = "partial";
                return M !== !1 ? function(F) {
                  var L, j;
                  function H() {
                    return this.inputmask ? this.inputmask.opts.autoUnmask ? this.inputmask.unmaskedvalue() : v.getLastValidPosition.call(w) !== -1 || E.nullable !== !0 ? (this.inputmask.shadowRoot || this.ownerDocument).activeElement === this && E.clearMaskOnLostFocus ? (w.isRTL ? f.clearOptionalTail.call(w, v.getBuffer.call(w).slice()).reverse() : f.clearOptionalTail.call(w, v.getBuffer.call(w).slice())).join("") : L.call(this) : "" : L.call(this);
                  }
                  function te(le) {
                    j.call(this, le), this.inputmask && (0, f.applyInputValue)(this, le);
                  }
                  if (!F.inputmask.__valueGet) {
                    if (E.noValuePatching !== !0) {
                      if (Object.getOwnPropertyDescriptor) {
                        var re = Object.getPrototypeOf ? Object.getOwnPropertyDescriptor(Object.getPrototypeOf(F), "value") : void 0;
                        re && re.get && re.set ? (L = re.get, j = re.set, Object.defineProperty(F, "value", {
                          get: H,
                          set: te,
                          configurable: !0
                        })) : F.tagName.toLowerCase() !== "input" && (L = function() {
                          return this.textContent;
                        }, j = function(le) {
                          this.textContent = le;
                        }, Object.defineProperty(F, "value", {
                          get: H,
                          set: te,
                          configurable: !0
                        }));
                      } else document.__lookupGetter__ && F.__lookupGetter__("value") && (L = F.__lookupGetter__("value"), j = F.__lookupSetter__("value"), F.__defineGetter__("value", H), F.__defineSetter__("value", te));
                      F.inputmask.__valueGet = L, F.inputmask.__valueSet = j;
                    }
                    F.inputmask._valueGet = function(le) {
                      return w.isRTL && le !== !0 ? L.call(this.el).split("").reverse().join("") : L.call(this.el);
                    }, F.inputmask._valueSet = function(le, ie) {
                      j.call(this.el, le == null ? "" : ie !== !0 && w.isRTL ? le.split("").reverse().join("") : le);
                    }, L === void 0 && (L = function() {
                      return this.value;
                    }, j = function(le) {
                      this.value = le;
                    }, function(le) {
                      if (T.valHooks && (T.valHooks[le] === void 0 || T.valHooks[le].inputmaskpatch !== !0)) {
                        var ie = T.valHooks[le] && T.valHooks[le].get ? T.valHooks[le].get : function(Y) {
                          return Y.value;
                        }, ye = T.valHooks[le] && T.valHooks[le].set ? T.valHooks[le].set : function(Y, ae) {
                          return Y.value = ae, Y;
                        };
                        T.valHooks[le] = {
                          get: function(Y) {
                            if (Y.inputmask) {
                              if (Y.inputmask.opts.autoUnmask) return Y.inputmask.unmaskedvalue();
                              var ae = ie(Y);
                              return v.getLastValidPosition.call(w, void 0, void 0, Y.inputmask.maskset.validPositions) !== -1 || E.nullable !== !0 ? ae : "";
                            }
                            return ie(Y);
                          },
                          set: function(Y, ae) {
                            var ke = ye(Y, ae);
                            return Y.inputmask && (0, f.applyInputValue)(Y, ae), ke;
                          },
                          inputmaskpatch: !0
                        };
                      }
                    }(F.type), function(le) {
                      m.EventRuler.on(le, "mouseenter", function() {
                        var ie = this, ye = ie.inputmask._valueGet(!0);
                        ye != (ie.inputmask.isRTL ? v.getBuffer.call(ie.inputmask).slice().reverse() : v.getBuffer.call(ie.inputmask)).join("") && (0, f.applyInputValue)(ie, ye);
                      });
                    }(F));
                  }
                }(O) : O.inputmask = void 0, M;
              }(I, S);
              if (x !== !1) {
                w.originalPlaceholder = I.placeholder, w.maxLength = I !== void 0 ? I.maxLength : void 0, w.maxLength === -1 && (w.maxLength = void 0), "inputMode" in I && I.getAttribute("inputmode") === null && (I.inputMode = S.inputmode, I.setAttribute("inputmode", S.inputmode)), x === !0 && (S.showMaskOnFocus = S.showMaskOnFocus && ["cc-number", "cc-exp"].indexOf(I.autocomplete) === -1, c.iphone && (S.insertModeVisual = !1, I.setAttribute("autocorrect", "off")), m.EventRuler.on(I, "submit", u.EventHandlers.submitEvent), m.EventRuler.on(I, "reset", u.EventHandlers.resetEvent), m.EventRuler.on(I, "blur", u.EventHandlers.blurEvent), m.EventRuler.on(I, "focus", u.EventHandlers.focusEvent), m.EventRuler.on(I, "invalid", u.EventHandlers.invalidEvent), m.EventRuler.on(I, "click", u.EventHandlers.clickEvent), m.EventRuler.on(I, "mouseleave", u.EventHandlers.mouseleaveEvent), m.EventRuler.on(I, "mouseenter", u.EventHandlers.mouseenterEvent), m.EventRuler.on(I, "paste", u.EventHandlers.pasteEvent), m.EventRuler.on(I, "cut", u.EventHandlers.cutEvent), m.EventRuler.on(I, "complete", S.oncomplete), m.EventRuler.on(I, "incomplete", S.onincomplete), m.EventRuler.on(I, "cleared", S.oncleared), S.inputEventOnly !== !0 && m.EventRuler.on(I, "keydown", u.EventHandlers.keyEvent), (c.mobile || S.inputEventOnly) && I.removeAttribute("maxLength"), m.EventRuler.on(I, "input", u.EventHandlers.inputFallBackEvent)), m.EventRuler.on(I, "setvalue", u.EventHandlers.setValueEvent), w.applyMaskHook === void 0 || w.applyMaskHook(), v.getBufferTemplate.call(w).join(""), w.undoValue = w._valueGet(!0);
                var k = (I.inputmask.shadowRoot || I.ownerDocument).activeElement;
                if (I.inputmask._valueGet(!0) !== "" || S.clearMaskOnLostFocus === !1 || k === I) {
                  (0, f.applyInputValue)(I, I.inputmask._valueGet(!0), S);
                  var C = v.getBuffer.call(w).slice();
                  b.isComplete.call(w, C) === !1 && S.clearIncomplete && v.resetMaskSet.call(w, !1), S.clearMaskOnLostFocus && k !== I && (v.getLastValidPosition.call(w) === -1 ? C = [] : f.clearOptionalTail.call(w, C)), (S.clearMaskOnLostFocus === !1 || S.showMaskOnFocus && k === I || I.inputmask._valueGet(!0) !== "") && (0, f.writeBuffer)(I, C), k === I && v.caret.call(w, I, v.seekNext.call(w, v.getLastValidPosition.call(w)));
                }
              }
            };
            var c = d(9845), u = d(6030), m = d(9716), f = d(7760), v = d(8711), b = d(7215);
          },
          9695: function(o, l) {
            Object.defineProperty(l, "__esModule", {
              value: !0
            }), l.default = function(d, c, u, m) {
              this.matches = [], this.openGroup = d || !1, this.alternatorGroup = !1, this.isGroup = d || !1, this.isOptional = c || !1, this.isQuantifier = u || !1, this.isAlternator = m || !1, this.quantifier = {
                min: 1,
                max: 1
              };
            };
          },
          3194: function() {
            Array.prototype.includes || Object.defineProperty(Array.prototype, "includes", {
              value: function(o, l) {
                if (this == null) throw new TypeError('"this" is null or not defined');
                var d = Object(this), c = d.length >>> 0;
                if (c === 0) return !1;
                for (var u = 0 | l, m = Math.max(u >= 0 ? u : c - Math.abs(u), 0); m < c; ) {
                  if (d[m] === o) return !0;
                  m++;
                }
                return !1;
              }
            });
          },
          9302: function() {
            var o = Function.bind.call(Function.call, Array.prototype.reduce), l = Function.bind.call(Function.call, Object.prototype.propertyIsEnumerable), d = Function.bind.call(Function.call, Array.prototype.concat), c = Object.keys;
            Object.entries || (Object.entries = function(u) {
              return o(c(u), function(m, f) {
                return d(m, typeof f == "string" && l(u, f) ? [[f, u[f]]] : []);
              }, []);
            });
          },
          7149: function() {
            function o(l) {
              return o = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(d) {
                return typeof d;
              } : function(d) {
                return d && typeof Symbol == "function" && d.constructor === Symbol && d !== Symbol.prototype ? "symbol" : typeof d;
              }, o(l);
            }
            typeof Object.getPrototypeOf != "function" && (Object.getPrototypeOf = o("test".__proto__) === "object" ? function(l) {
              return l.__proto__;
            } : function(l) {
              return l.constructor.prototype;
            });
          },
          4013: function() {
            String.prototype.includes || (String.prototype.includes = function(o, l) {
              return typeof l != "number" && (l = 0), !(l + o.length > this.length) && this.indexOf(o, l) !== -1;
            });
          },
          8711: function(o, l, d) {
            Object.defineProperty(l, "__esModule", {
              value: !0
            }), l.caret = function(T, x, k, C, O) {
              var E, B = this, M = this.opts;
              if (x === void 0) return "selectionStart" in T && "selectionEnd" in T ? (x = T.selectionStart, k = T.selectionEnd) : u.default.getSelection ? (E = u.default.getSelection().getRangeAt(0)).commonAncestorContainer.parentNode !== T && E.commonAncestorContainer !== T || (x = E.startOffset, k = E.endOffset) : document.selection && document.selection.createRange && (k = (x = 0 - (E = document.selection.createRange()).duplicate().moveStart("character", -T.inputmask._valueGet().length)) + E.text.length), {
                begin: C ? x : I.call(B, x),
                end: C ? k : I.call(B, k)
              };
              if (Array.isArray(x) && (k = B.isRTL ? x[0] : x[1], x = B.isRTL ? x[1] : x[0]), x.begin !== void 0 && (k = B.isRTL ? x.begin : x.end, x = B.isRTL ? x.end : x.begin), typeof x == "number") {
                x = C ? x : I.call(B, x), k = typeof (k = C ? k : I.call(B, k)) == "number" ? k : x;
                var R = parseInt(((T.ownerDocument.defaultView || u.default).getComputedStyle ? (T.ownerDocument.defaultView || u.default).getComputedStyle(T, null) : T.currentStyle).fontSize) * k;
                if (T.scrollLeft = R > T.scrollWidth ? R : 0, T.inputmask.caretPos = {
                  begin: x,
                  end: k
                }, M.insertModeVisual && M.insertMode === !1 && x === k && (O || k++), T === (T.inputmask.shadowRoot || T.ownerDocument).activeElement) {
                  if ("setSelectionRange" in T) T.setSelectionRange(x, k);
                  else if (u.default.getSelection) {
                    if (E = document.createRange(), T.firstChild === void 0 || T.firstChild === null) {
                      var F = document.createTextNode("");
                      T.appendChild(F);
                    }
                    E.setStart(T.firstChild, x < T.inputmask._valueGet().length ? x : T.inputmask._valueGet().length), E.setEnd(T.firstChild, k < T.inputmask._valueGet().length ? k : T.inputmask._valueGet().length), E.collapse(!0);
                    var L = u.default.getSelection();
                    L.removeAllRanges(), L.addRange(E);
                  } else T.createTextRange && ((E = T.createTextRange()).collapse(!0), E.moveEnd("character", k), E.moveStart("character", x), E.select());
                  T.inputmask.caretHook === void 0 || T.inputmask.caretHook.call(B, {
                    begin: x,
                    end: k
                  });
                }
              }
            }, l.determineLastRequiredPosition = function(T) {
              var x, k, C = this, O = C.maskset, E = C.dependencyLib, B = b.call(C), M = {}, R = O.validPositions[B], F = f.getMaskTemplate.call(C, !0, b.call(C), !0, !0), L = F.length, j = R !== void 0 ? R.locator.slice() : void 0;
              for (x = B + 1; x < F.length; x++) j = (k = f.getTestTemplate.call(C, x, j, x - 1)).locator.slice(), M[x] = E.extend(!0, {}, k);
              var H = R && R.alternation !== void 0 ? R.locator[R.alternation] : void 0;
              for (x = L - 1; x > B && ((k = M[x]).match.optionality || k.match.optionalQuantifier && k.match.newBlockMarker || H && (H !== M[x].locator[R.alternation] && k.match.static !== !0 || k.match.static === !0 && k.locator[R.alternation] && m.checkAlternationMatch.call(C, k.locator[R.alternation].toString().split(","), H.toString().split(",")) && f.getTests.call(C, x)[0].def !== "")) && F[x] === f.getPlaceholder.call(C, x, k.match); x--) L--;
              return T ? {
                l: L,
                def: M[L] ? M[L].match : void 0
              } : L;
            }, l.determineNewCaretPosition = function(T, x, k) {
              var C, O, E, B = this, M = B.maskset, R = B.opts;
              if (x && (B.isRTL ? T.end = T.begin : T.begin = T.end), T.begin === T.end) {
                switch (k = k || R.positionCaretOnClick) {
                  case "none":
                    break;
                  case "select":
                    T = {
                      begin: 0,
                      end: v.call(B).length
                    };
                    break;
                  case "ignore":
                    T.end = T.begin = S.call(B, b.call(B));
                    break;
                  case "radixFocus":
                    if (B.clicked > 1 && M.validPositions.length === 0) break;
                    if (function(re) {
                      if (R.radixPoint !== "" && R.digits !== 0) {
                        var le = M.validPositions;
                        if (le[re] === void 0 || le[re].input === void 0) {
                          if (re < S.call(B, -1)) return !0;
                          var ie = v.call(B).indexOf(R.radixPoint);
                          if (ie !== -1) {
                            for (var ye = 0, Y = le.length; ye < Y; ye++) if (le[ye] && ie < ye && le[ye].input !== f.getPlaceholder.call(B, ye)) return !1;
                            return !0;
                          }
                        }
                      }
                      return !1;
                    }(T.begin)) {
                      var F = v.call(B).join("").indexOf(R.radixPoint);
                      T.end = T.begin = R.numericInput ? S.call(B, F) : F;
                      break;
                    }
                  default:
                    if (C = T.begin, O = b.call(B, C, !0), C <= (E = S.call(B, O !== -1 || w.call(B, 0) ? O : -1))) T.end = T.begin = w.call(B, C, !1, !0) ? C : S.call(B, C);
                    else {
                      var L = M.validPositions[O], j = f.getTestTemplate.call(B, E, L ? L.match.locator : void 0, L), H = f.getPlaceholder.call(B, E, j.match);
                      if (H !== "" && v.call(B)[E] !== H && j.match.optionalQuantifier !== !0 && j.match.newBlockMarker !== !0 || !w.call(B, E, R.keepStatic, !0) && j.match.def === H) {
                        var te = S.call(B, E);
                        (C >= te || C === E) && (E = te);
                      }
                      T.end = T.begin = E;
                    }
                }
                return T;
              }
            }, l.getBuffer = v, l.getBufferTemplate = function() {
              var T = this.maskset;
              return T._buffer === void 0 && (T._buffer = f.getMaskTemplate.call(this, !1, 1), T.buffer === void 0 && (T.buffer = T._buffer.slice())), T._buffer;
            }, l.getLastValidPosition = b, l.isMask = w, l.resetMaskSet = function(T) {
              var x = this.maskset;
              x.buffer = void 0, T !== !0 && (x.validPositions = [], x.p = 0), T === !1 && (x.tests = {}, x.jitOffset = {});
            }, l.seekNext = S, l.seekPrevious = function(T, x) {
              var k = this, C = T - 1;
              if (T <= 0) return 0;
              for (; C > 0 && (x === !0 && (f.getTest.call(k, C).match.newBlockMarker !== !0 || !w.call(k, C, void 0, !0)) || x !== !0 && !w.call(k, C, void 0, !0)); ) C--;
              return C;
            }, l.translatePosition = I;
            var c, u = (c = d(9380)) && c.__esModule ? c : {
              default: c
            }, m = d(7215), f = d(4713);
            function v(T) {
              var x = this, k = x.maskset;
              return k.buffer !== void 0 && T !== !0 || (k.buffer = f.getMaskTemplate.call(x, !0, b.call(x), !0), k._buffer === void 0 && (k._buffer = k.buffer.slice())), k.buffer;
            }
            function b(T, x, k) {
              var C = this.maskset, O = -1, E = -1, B = k || C.validPositions;
              T === void 0 && (T = -1);
              for (var M = 0, R = B.length; M < R; M++) B[M] && (x || B[M].generatedInput !== !0) && (M <= T && (O = M), M >= T && (E = M));
              return O === -1 || O === T ? E : E === -1 || T - O < E - T ? O : E;
            }
            function w(T, x, k) {
              var C = this, O = this.maskset, E = f.getTestTemplate.call(C, T).match;
              if (E.def === "" && (E = f.getTest.call(C, T).match), E.static !== !0) return E.fn;
              if (k === !0 && O.validPositions[T] !== void 0 && O.validPositions[T].generatedInput !== !0) return !0;
              if (x !== !0 && T > -1) {
                if (k) {
                  var B = f.getTests.call(C, T);
                  return B.length > 1 + (B[B.length - 1].match.def === "" ? 1 : 0);
                }
                var M = f.determineTestTemplate.call(C, T, f.getTests.call(C, T)), R = f.getPlaceholder.call(C, T, M.match);
                return M.match.def !== R;
              }
              return !1;
            }
            function S(T, x, k) {
              var C = this;
              k === void 0 && (k = !0);
              for (var O = T + 1; f.getTest.call(C, O).match.def !== "" && (x === !0 && (f.getTest.call(C, O).match.newBlockMarker !== !0 || !w.call(C, O, void 0, !0)) || x !== !0 && !w.call(C, O, void 0, k)); ) O++;
              return O;
            }
            function I(T) {
              var x = this.opts, k = this.el;
              return !this.isRTL || typeof T != "number" || x.greedy && x.placeholder === "" || !k || (T = this._valueGet().length - T) < 0 && (T = 0), T;
            }
          },
          4713: function(o, l, d) {
            Object.defineProperty(l, "__esModule", {
              value: !0
            }), l.determineTestTemplate = I, l.getDecisionTaker = b, l.getMaskTemplate = function(C, O, E, B, M) {
              var R = this, F = this.opts, L = this.maskset, j = F.greedy;
              M && F.greedy && (F.greedy = !1, R.maskset.tests = {}), O = O || 0;
              var H, te, re, le, ie = [], ye = 0;
              do {
                if (C === !0 && L.validPositions[ye]) te = (re = M && L.validPositions[ye].match.optionality && L.validPositions[ye + 1] === void 0 && (L.validPositions[ye].generatedInput === !0 || L.validPositions[ye].input == F.skipOptionalPartCharacter && ye > 0) ? I.call(R, ye, k.call(R, ye, H, ye - 1)) : L.validPositions[ye]).match, H = re.locator.slice(), ie.push(E === !0 ? re.input : E === !1 ? te.nativeDef : w.call(R, ye, te));
                else {
                  te = (re = S.call(R, ye, H, ye - 1)).match, H = re.locator.slice();
                  var Y = B !== !0 && (F.jitMasking !== !1 ? F.jitMasking : te.jit);
                  (le = (le || L.validPositions[ye - 1]) && te.static && te.def !== F.groupSeparator && te.fn === null) || Y === !1 || Y === void 0 || typeof Y == "number" && isFinite(Y) && Y > ye ? ie.push(E === !1 ? te.nativeDef : w.call(R, ie.length, te)) : le = !1;
                }
                ye++;
              } while (te.static !== !0 || te.def !== "" || O > ye);
              return ie[ie.length - 1] === "" && ie.pop(), E === !1 && L.maskLength !== void 0 || (L.maskLength = ye - 1), F.greedy = j, ie;
            }, l.getPlaceholder = w, l.getTest = T, l.getTestTemplate = S, l.getTests = k, l.isSubsetOf = x;
            var c, u = (c = d(2394)) && c.__esModule ? c : {
              default: c
            }, m = d(8711);
            function f(C) {
              return f = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(O) {
                return typeof O;
              } : function(O) {
                return O && typeof Symbol == "function" && O.constructor === Symbol && O !== Symbol.prototype ? "symbol" : typeof O;
              }, f(C);
            }
            function v(C, O) {
              var E = (C.alternation != null ? C.mloc[b(C)] : C.locator).join("");
              if (E !== "") for (E = E.split(":")[0]; E.length < O; ) E += "0";
              return E;
            }
            function b(C) {
              var O = C.locator[C.alternation];
              return typeof O == "string" && O.length > 0 && (O = O.split(",")[0]), O !== void 0 ? O.toString() : "";
            }
            function w(C, O, E) {
              var B = this, M = this.opts, R = this.maskset;
              if ((O = O || T.call(B, C).match).placeholder !== void 0 || E === !0) {
                if (O.placeholder !== "" && O.static === !0 && O.generated !== !0) {
                  var F = m.getLastValidPosition.call(B, C), L = m.seekNext.call(B, F);
                  return (E ? C <= L : C < L) ? M.staticDefinitionSymbol && O.static ? O.nativeDef : O.def : typeof O.placeholder == "function" ? O.placeholder(M) : O.placeholder;
                }
                return typeof O.placeholder == "function" ? O.placeholder(M) : O.placeholder;
              }
              if (O.static === !0) {
                if (C > -1 && R.validPositions[C] === void 0) {
                  var j, H = k.call(B, C), te = [];
                  if (typeof M.placeholder == "string" && H.length > 1 + (H[H.length - 1].match.def === "" ? 1 : 0)) {
                    for (var re = 0; re < H.length; re++) if (H[re].match.def !== "" && H[re].match.optionality !== !0 && H[re].match.optionalQuantifier !== !0 && (H[re].match.static === !0 || j === void 0 || H[re].match.fn.test(j.match.def, R, C, !0, M) !== !1) && (te.push(H[re]), H[re].match.static === !0 && (j = H[re]), te.length > 1 && /[0-9a-bA-Z]/.test(te[0].match.def))) return M.placeholder.charAt(C % M.placeholder.length);
                  }
                }
                return O.def;
              }
              return f(M.placeholder) === "object" ? O.def : M.placeholder.charAt(C % M.placeholder.length);
            }
            function S(C, O, E) {
              return this.maskset.validPositions[C] || I.call(this, C, k.call(this, C, O && O.slice(), E));
            }
            function I(C, O) {
              var E = this.opts, B = 0, M = function(le, ie) {
                var ye = 0, Y = !1;
                return ie.forEach(function(ae) {
                  ae.match.optionality && (ye !== 0 && ye !== ae.match.optionality && (Y = !0), (ye === 0 || ye > ae.match.optionality) && (ye = ae.match.optionality));
                }), ye && (le == 0 || ie.length == 1 ? ye = 0 : Y || (ye = 0)), ye;
              }(C, O);
              C = C > 0 ? C - 1 : 0;
              var R, F, L, j = v(T.call(this, C));
              E.greedy && O.length > 1 && O[O.length - 1].match.def === "" && (B = 1);
              for (var H = 0; H < O.length - B; H++) {
                var te = O[H];
                R = v(te, j.length);
                var re = Math.abs(R - j);
                (te.unMatchedAlternationStopped !== !0 || O.filter(function(le) {
                  return le.unMatchedAlternationStopped !== !0;
                }).length <= 1) && (F === void 0 || R !== "" && re < F || L && !E.greedy && L.match.optionality && L.match.optionality - M > 0 && L.match.newBlockMarker === "master" && (!te.match.optionality || te.match.optionality - M < 1 || !te.match.newBlockMarker) || L && !E.greedy && L.match.optionalQuantifier && !te.match.optionalQuantifier) && (F = re, L = te);
              }
              return L;
            }
            function T(C, O) {
              var E = this.maskset;
              return E.validPositions[C] ? E.validPositions[C] : (O || k.call(this, C))[0];
            }
            function x(C, O, E) {
              function B(M) {
                for (var R, F = [], L = -1, j = 0, H = M.length; j < H; j++) if (M.charAt(j) === "-") for (R = M.charCodeAt(j + 1); ++L < R; ) F.push(String.fromCharCode(L));
                else L = M.charCodeAt(j), F.push(M.charAt(j));
                return F.join("");
              }
              return C.match.def === O.match.nativeDef || !(!(E.regex || C.match.fn instanceof RegExp && O.match.fn instanceof RegExp) || C.match.static === !0 || O.match.static === !0) && (O.match.fn.source === "." || B(O.match.fn.source.replace(/[[\]/]/g, "")).indexOf(B(C.match.fn.source.replace(/[[\]/]/g, ""))) !== -1);
            }
            function k(C, O, E) {
              var B, M, R = this, F = this.dependencyLib, L = this.maskset, j = this.opts, H = this.el, te = L.maskToken, re = O ? E : 0, le = O ? O.slice() : [0], ie = [], ye = !1, Y = O ? O.join("") : "", ae = !1;
              function ke(Ie, be, Oe, ze) {
                function Re(Me, Ne, $e) {
                  function mt(Ee, Ce) {
                    var xe = Ce.matches.indexOf(Ee) === 0;
                    return xe || Ce.matches.every(function(Pe, it) {
                      return Pe.isQuantifier === !0 ? xe = mt(Ee, Ce.matches[it - 1]) : Object.prototype.hasOwnProperty.call(Pe, "matches") && (xe = mt(Ee, Pe)), !xe;
                    }), xe;
                  }
                  function yt(Ee, Ce, xe) {
                    var Pe, it;
                    if ((L.tests[Ee] || L.validPositions[Ee]) && (L.validPositions[Ee] ? [L.validPositions[Ee]] : L.tests[Ee]).every(function(vt, It) {
                      if (vt.mloc[Ce]) return Pe = vt, !1;
                      var Dt = xe !== void 0 ? xe : vt.alternation, ht = vt.locator[Dt] !== void 0 ? vt.locator[Dt].toString().indexOf(Ce) : -1;
                      return (it === void 0 || ht < it) && ht !== -1 && (Pe = vt, it = ht), !0;
                    }), Pe) {
                      var lt = Pe.locator[Pe.alternation], dt = Pe.mloc[Ce] || Pe.mloc[lt] || Pe.locator;
                      return dt[dt.length - 1].toString().indexOf(":") !== -1 && dt.pop(), dt.slice((xe !== void 0 ? xe : Pe.alternation) + 1);
                    }
                    return xe !== void 0 ? yt(Ee, Ce) : void 0;
                  }
                  function Ct(Ee, Ce) {
                    return Ee.match.static === !0 && Ce.match.static !== !0 && Ce.match.fn.test(Ee.match.def, L, C, !1, j, !1);
                  }
                  function gt(Ee, Ce) {
                    var xe = Ee.alternation, Pe = Ce === void 0 || xe <= Ce.alternation && Ee.locator[xe].toString().indexOf(Ce.locator[xe]) === -1;
                    if (!Pe && xe > Ce.alternation) {
                      for (var it = 0; it < xe; it++) if (Ee.locator[it] !== Ce.locator[it]) {
                        xe = it, Pe = !0;
                        break;
                      }
                    }
                    return !!Pe && function(lt) {
                      Ee.mloc = Ee.mloc || {};
                      var dt = Ee.locator[lt];
                      if (dt !== void 0) {
                        if (typeof dt == "string" && (dt = dt.split(",")[0]), Ee.mloc[dt] === void 0 && (Ee.mloc[dt] = Ee.locator.slice(), Ee.mloc[dt].push(":".concat(Ee.alternation))), Ce !== void 0) {
                          for (var vt in Ce.mloc) typeof vt == "string" && (vt = parseInt(vt.split(",")[0])), Ee.mloc[vt + 0] = Ce.mloc[vt];
                          Ee.locator[lt] = Object.keys(Ee.mloc).join(",");
                        }
                        return Ee.alternation > lt && (Ee.alternation = lt), !0;
                      }
                      return Ee.alternation = void 0, !1;
                    }(xe);
                  }
                  function Ge(Ee, Ce) {
                    if (Ee.locator.length !== Ce.locator.length) return !1;
                    for (var xe = Ee.alternation + 1; xe < Ee.locator.length; xe++) if (Ee.locator[xe] !== Ce.locator[xe]) return !1;
                    return !0;
                  }
                  if (re > C + j._maxTestPos) throw new Error("Inputmask: There is probably an error in your mask definition or in the code. Create an issue on github with an example of the mask you are using. ".concat(L.mask));
                  if (re === C && Me.matches === void 0) {
                    if (ie.push({
                      match: Me,
                      locator: Ne.reverse(),
                      cd: Y,
                      mloc: {}
                    }), !Me.optionality || $e !== void 0 || !(j.definitions && j.definitions[Me.nativeDef] && j.definitions[Me.nativeDef].optional || u.default.prototype.definitions[Me.nativeDef] && u.default.prototype.definitions[Me.nativeDef].optional)) return !0;
                    ye = !0, re = C;
                  } else if (Me.matches !== void 0) {
                    if (Me.isGroup && $e !== Me) return function() {
                      if (Me = Re(Ie.matches[Ie.matches.indexOf(Me) + 1], Ne, $e)) return !0;
                    }();
                    if (Me.isOptional) return function() {
                      var Ee = Me, Ce = ie.length;
                      if (Me = ke(Me, be, Ne, $e), ie.length > 0) {
                        if (ie.forEach(function(xe, Pe) {
                          Pe >= Ce && (xe.match.optionality = xe.match.optionality ? xe.match.optionality + 1 : 1);
                        }), B = ie[ie.length - 1].match, $e !== void 0 || !mt(B, Ee)) return Me;
                        ye = !0, re = C;
                      }
                    }();
                    if (Me.isAlternator) return function() {
                      function Ee(gs) {
                        for (var xs, Be = gs.matches[0].matches ? gs.matches[0].matches.length : 1, Ye = 0; Ye < gs.matches.length && Be === (xs = gs.matches[Ye].matches ? gs.matches[Ye].matches.length : 1); Ye++) ;
                        return Be !== xs;
                      }
                      R.hasAlternator = !0;
                      var Ce, xe = Me, Pe = [], it = ie.slice(), lt = Ne.length, dt = be.length > 0 ? be.shift() : -1;
                      if (dt === -1 || typeof dt == "string") {
                        var vt, It = re, Dt = be.slice(), ht = [];
                        if (typeof dt == "string") ht = dt.split(",");
                        else for (vt = 0; vt < xe.matches.length; vt++) ht.push(vt.toString());
                        if (L.excludes[C] !== void 0) {
                          for (var _t = ht.slice(), fs = 0, Hs = L.excludes[C].length; fs < Hs; fs++) {
                            var Fs = L.excludes[C][fs].toString().split(":");
                            Ne.length == Fs[1] && ht.splice(ht.indexOf(Fs[0]), 1);
                          }
                          ht.length === 0 && (delete L.excludes[C], ht = _t);
                        }
                        (j.keepStatic === !0 || isFinite(parseInt(j.keepStatic)) && It >= j.keepStatic) && (ht = ht.slice(0, 1));
                        for (var Ts = 0; Ts < ht.length; Ts++) {
                          vt = parseInt(ht[Ts]), ie = [], be = typeof dt == "string" && yt(re, vt, lt) || Dt.slice();
                          var Ps = xe.matches[vt];
                          if (Ps && Re(Ps, [vt].concat(Ne), $e)) Me = !0;
                          else if (Ts === 0 && (ae = Ee(xe)), Ps && Ps.matches && Ps.matches.length > xe.matches[0].matches.length) break;
                          Ce = ie.slice(), re = It, ie = [];
                          for (var Bs = 0; Bs < Ce.length; Bs++) {
                            var qt = Ce[Bs], Os = !1;
                            qt.alternation = qt.alternation || lt, gt(qt);
                            for (var Ms = 0; Ms < Pe.length; Ms++) {
                              var ts = Pe[Ms];
                              if (typeof dt != "string" || qt.alternation !== void 0 && ht.includes(qt.locator[qt.alternation].toString())) {
                                if (qt.match.nativeDef === ts.match.nativeDef) {
                                  Os = !0, gt(ts, qt);
                                  break;
                                }
                                if (x(qt, ts, j)) {
                                  gt(qt, ts) && (Os = !0, Pe.splice(Pe.indexOf(ts), 0, qt));
                                  break;
                                }
                                if (x(ts, qt, j)) {
                                  gt(ts, qt);
                                  break;
                                }
                                if (Ct(qt, ts)) {
                                  Ge(qt, ts) || H.inputmask.userOptions.keepStatic !== void 0 ? gt(qt, ts) && (Os = !0, Pe.splice(Pe.indexOf(ts), 0, qt)) : j.keepStatic = !0;
                                  break;
                                }
                                if (Ct(ts, qt)) {
                                  gt(ts, qt);
                                  break;
                                }
                              }
                            }
                            Os || Pe.push(qt);
                          }
                        }
                        ie = it.concat(Pe), re = C, ye = ie.length > 0 && ae, Me = Pe.length > 0 && !ae, ae && ye && !Me && ie.forEach(function(gs, xs) {
                          gs.unMatchedAlternationStopped = !0;
                        }), be = Dt.slice();
                      } else Me = Re(xe.matches[dt] || Ie.matches[dt], [dt].concat(Ne), $e);
                      if (Me) return !0;
                    }();
                    if (Me.isQuantifier && $e !== Ie.matches[Ie.matches.indexOf(Me) - 1]) return function() {
                      for (var Ee = Me, Ce = !1, xe = be.length > 0 ? be.shift() : 0; xe < (isNaN(Ee.quantifier.max) ? xe + 1 : Ee.quantifier.max) && re <= C; xe++) {
                        var Pe = Ie.matches[Ie.matches.indexOf(Ee) - 1];
                        if (Me = Re(Pe, [xe].concat(Ne), Pe)) {
                          if (ie.forEach(function(it, lt) {
                            (B = ue(Pe, it.match) ? it.match : ie[ie.length - 1].match).optionalQuantifier = xe >= Ee.quantifier.min, B.jit = (xe + 1) * (Pe.matches.indexOf(B) + 1) > Ee.quantifier.jit, B.optionalQuantifier && mt(B, Pe) && (ye = !0, re = C, j.greedy && L.validPositions[C - 1] == null && xe > Ee.quantifier.min && ["*", "+"].indexOf(Ee.quantifier.max) != -1 && (ie.pop(), Y = void 0), Ce = !0, Me = !1), !Ce && B.jit && (L.jitOffset[C] = Pe.matches.length - Pe.matches.indexOf(B));
                          }), Ce) break;
                          return !0;
                        }
                      }
                    }();
                    if (Me = ke(Me, be, Ne, $e)) return !0;
                  } else re++;
                }
                for (var ge = be.length > 0 ? be.shift() : 0; ge < Ie.matches.length; ge++) if (Ie.matches[ge].isQuantifier !== !0) {
                  var he = Re(Ie.matches[ge], [ge].concat(Oe), ze);
                  if (he && re === C) return he;
                  if (re > C) break;
                }
              }
              function ue(Ie, be) {
                var Oe = Ie.matches.indexOf(be) != -1;
                return Oe || Ie.matches.forEach(function(ze, Re) {
                  ze.matches === void 0 || Oe || (Oe = ue(ze, be));
                }), Oe;
              }
              if (C > -1) {
                if (O === void 0) {
                  for (var oe, fe = C - 1; (oe = L.validPositions[fe] || L.tests[fe]) === void 0 && fe > -1; ) fe--;
                  oe !== void 0 && fe > -1 && (le = function(Ie, be) {
                    var Oe, ze = [];
                    return Array.isArray(be) || (be = [be]), be.length > 0 && (be[0].alternation === void 0 || j.keepStatic === !0 ? (ze = I.call(R, Ie, be.slice()).locator.slice()).length === 0 && (ze = be[0].locator.slice()) : be.forEach(function(Re) {
                      Re.def !== "" && (ze.length === 0 ? (Oe = Re.alternation, ze = Re.locator.slice()) : Re.locator[Oe] && ze[Oe].toString().indexOf(Re.locator[Oe]) === -1 && (ze[Oe] += "," + Re.locator[Oe]));
                    })), ze;
                  }(fe, oe), Y = le.join(""), re = fe);
                }
                if (L.tests[C] && L.tests[C][0].cd === Y) return L.tests[C];
                for (var we = le.shift(); we < te.length && !(ke(te[we], le, [we]) && re === C || re > C); we++)
                  ;
              }
              return (ie.length === 0 || ye) && ie.push({
                match: {
                  fn: null,
                  static: !0,
                  optionality: !1,
                  casing: null,
                  def: "",
                  placeholder: ""
                },
                locator: ae && ie.filter(function(Ie) {
                  return Ie.unMatchedAlternationStopped !== !0;
                }).length === 0 ? [0] : [],
                mloc: {},
                cd: Y
              }), O !== void 0 && L.tests[C] ? M = F.extend(!0, [], ie) : (L.tests[C] = F.extend(!0, [], ie), M = L.tests[C]), ie.forEach(function(Ie) {
                Ie.match.optionality = Ie.match.defOptionality || !1;
              }), M;
            }
          },
          7215: function(o, l, d) {
            Object.defineProperty(l, "__esModule", {
              value: !0
            }), l.alternate = v, l.checkAlternationMatch = function(O, E, B) {
              for (var M, R = this.opts.greedy ? E : E.slice(0, 1), F = !1, L = B !== void 0 ? B.split(",") : [], j = 0; j < L.length; j++) (M = O.indexOf(L[j])) !== -1 && O.splice(M, 1);
              for (var H = 0; H < O.length; H++) if (R.includes(O[H])) {
                F = !0;
                break;
              }
              return F;
            }, l.handleRemove = function(O, E, B, M, R) {
              var F = this, L = this.maskset, j = this.opts;
              if ((j.numericInput || F.isRTL) && (E === u.keys.Backspace ? E = u.keys.Delete : E === u.keys.Delete && (E = u.keys.Backspace), F.isRTL)) {
                var H = B.end;
                B.end = B.begin, B.begin = H;
              }
              var te, re = m.getLastValidPosition.call(F, void 0, !0);
              B.end >= m.getBuffer.call(F).length && re >= B.end && (B.end = re + 1), E === u.keys.Backspace ? B.end - B.begin < 1 && (B.begin = m.seekPrevious.call(F, B.begin)) : E === u.keys.Delete && B.begin === B.end && (B.end = m.isMask.call(F, B.end, !0, !0) ? B.end + 1 : m.seekNext.call(F, B.end) + 1), (te = C.call(F, B)) !== !1 && ((M !== !0 && j.keepStatic !== !1 || j.regex !== null && f.getTest.call(F, B.begin).match.def.indexOf("|") !== -1) && v.call(F, !0), M !== !0 && (L.p = E === u.keys.Delete ? B.begin + te : B.begin, L.p = m.determineNewCaretPosition.call(F, {
                begin: L.p,
                end: L.p
              }, !1, j.insertMode === !1 && E === u.keys.Backspace ? "none" : void 0).begin));
            }, l.isComplete = w, l.isSelection = S, l.isValid = I, l.refreshFromBuffer = x, l.revalidateMask = C;
            var c = d(6030), u = d(2839), m = d(8711), f = d(4713);
            function v(O, E, B, M, R, F) {
              var L = this, j = this.dependencyLib, H = this.opts, te = L.maskset;
              if (!L.hasAlternator) return !1;
              var re, le, ie, ye, Y, ae, ke, ue, oe, fe, we, Ie = j.extend(!0, [], te.validPositions), be = j.extend(!0, {}, te.tests), Oe = !1, ze = !1, Re = R !== void 0 ? R : m.getLastValidPosition.call(L);
              if (F && (fe = F.begin, we = F.end, F.begin > F.end && (fe = F.end, we = F.begin)), Re === -1 && R === void 0) re = 0, le = (ye = f.getTest.call(L, re)).alternation;
              else for (; Re >= 0; Re--) if ((ie = te.validPositions[Re]) && ie.alternation !== void 0) {
                if (Re <= (O || 0) && ye && ye.locator[ie.alternation] !== ie.locator[ie.alternation]) break;
                re = Re, le = te.validPositions[re].alternation, ye = ie;
              }
              if (le !== void 0) {
                ke = parseInt(re), te.excludes[ke] = te.excludes[ke] || [], O !== !0 && te.excludes[ke].push((0, f.getDecisionTaker)(ye) + ":" + ye.alternation);
                var ge = [], he = -1;
                for (Y = ke; ke < m.getLastValidPosition.call(L, void 0, !0) + 1; Y++) he === -1 && O <= Y && E !== void 0 && (ge.push(E), he = ge.length - 1), (ae = te.validPositions[ke]) && ae.generatedInput !== !0 && (F === void 0 || Y < fe || Y >= we) && ge.push(ae.input), te.validPositions.splice(ke, 1);
                for (he === -1 && E !== void 0 && (ge.push(E), he = ge.length - 1); te.excludes[ke] !== void 0 && te.excludes[ke].length < 10; ) {
                  for (te.tests = {}, m.resetMaskSet.call(L, !0), Oe = !0, Y = 0; Y < ge.length && (ue = Oe.caret || H.insertMode == 0 && ue != null ? m.seekNext.call(L, ue) : m.getLastValidPosition.call(L, void 0, !0) + 1, oe = ge[Y], Oe = I.call(L, ue, oe, !1, M, !0)); Y++) Y === he && (ze = Oe), O == 1 && Oe && (ze = {
                    caretPos: Y
                  });
                  if (Oe) break;
                  if (m.resetMaskSet.call(L), ye = f.getTest.call(L, ke), te.validPositions = j.extend(!0, [], Ie), te.tests = j.extend(!0, {}, be), !te.excludes[ke]) {
                    ze = v.call(L, O, E, B, M, ke - 1, F);
                    break;
                  }
                  if (ye.alternation != null) {
                    var Me = (0, f.getDecisionTaker)(ye);
                    if (te.excludes[ke].indexOf(Me + ":" + ye.alternation) !== -1) {
                      ze = v.call(L, O, E, B, M, ke - 1, F);
                      break;
                    }
                    for (te.excludes[ke].push(Me + ":" + ye.alternation), Y = ke; Y < m.getLastValidPosition.call(L, void 0, !0) + 1; Y++) te.validPositions.splice(ke);
                  } else delete te.excludes[ke];
                }
              }
              return ze && H.keepStatic === !1 || delete te.excludes[ke], ze;
            }
            function b(O, E, B) {
              var M = this.opts, R = this.maskset;
              switch (M.casing || E.casing) {
                case "upper":
                  O = O.toUpperCase();
                  break;
                case "lower":
                  O = O.toLowerCase();
                  break;
                case "title":
                  var F = R.validPositions[B - 1];
                  O = B === 0 || F && F.input === String.fromCharCode(u.keyCode.Space) ? O.toUpperCase() : O.toLowerCase();
                  break;
                default:
                  if (typeof M.casing == "function") {
                    var L = Array.prototype.slice.call(arguments);
                    L.push(R.validPositions), O = M.casing.apply(this, L);
                  }
              }
              return O;
            }
            function w(O) {
              var E = this, B = this.opts, M = this.maskset;
              if (typeof B.isComplete == "function") return B.isComplete(O, B);
              if (B.repeat !== "*") {
                var R = !1, F = m.determineLastRequiredPosition.call(E, !0), L = F.l;
                if (F.def === void 0 || F.def.newBlockMarker || F.def.optionality || F.def.optionalQuantifier) {
                  R = !0;
                  for (var j = 0; j <= L; j++) {
                    var H = f.getTestTemplate.call(E, j).match;
                    if (H.static !== !0 && M.validPositions[j] === void 0 && (H.optionality === !1 || H.optionality === void 0 || H.optionality && H.newBlockMarker == 0) && (H.optionalQuantifier === !1 || H.optionalQuantifier === void 0) || H.static === !0 && H.def != "" && O[j] !== f.getPlaceholder.call(E, j, H)) {
                      R = !1;
                      break;
                    }
                  }
                }
                return R;
              }
            }
            function S(O) {
              var E = this.opts.insertMode ? 0 : 1;
              return this.isRTL ? O.begin - O.end > E : O.end - O.begin > E;
            }
            function I(O, E, B, M, R, F, L) {
              var j = this, H = this.dependencyLib, te = this.opts, re = j.maskset;
              B = B === !0;
              var le = O;
              function ie(Oe) {
                if (Oe !== void 0) {
                  if (Oe.remove !== void 0 && (Array.isArray(Oe.remove) || (Oe.remove = [Oe.remove]), Oe.remove.sort(function(Re, ge) {
                    return j.isRTL ? Re.pos - ge.pos : ge.pos - Re.pos;
                  }).forEach(function(Re) {
                    C.call(j, {
                      begin: Re,
                      end: Re + 1
                    });
                  }), Oe.remove = void 0), Oe.insert !== void 0 && (Array.isArray(Oe.insert) || (Oe.insert = [Oe.insert]), Oe.insert.sort(function(Re, ge) {
                    return j.isRTL ? ge.pos - Re.pos : Re.pos - ge.pos;
                  }).forEach(function(Re) {
                    Re.c !== "" && I.call(j, Re.pos, Re.c, Re.strict === void 0 || Re.strict, Re.fromIsValid !== void 0 ? Re.fromIsValid : M);
                  }), Oe.insert = void 0), Oe.refreshFromBuffer && Oe.buffer) {
                    var ze = Oe.refreshFromBuffer;
                    x.call(j, ze === !0 ? ze : ze.start, ze.end, Oe.buffer), Oe.refreshFromBuffer = void 0;
                  }
                  Oe.rewritePosition !== void 0 && (le = Oe.rewritePosition, Oe = !0);
                }
                return Oe;
              }
              function ye(Oe, ze, Re) {
                var ge = !1;
                return f.getTests.call(j, Oe).every(function(he, Me) {
                  var Ne = he.match;
                  if (m.getBuffer.call(j, !0), (ge = (!Ne.jit || re.validPositions[m.seekPrevious.call(j, Oe)] !== void 0) && (Ne.fn != null ? Ne.fn.test(ze, re, Oe, Re, te, S.call(j, O)) : (ze === Ne.def || ze === te.skipOptionalPartCharacter) && Ne.def !== "" && {
                    c: f.getPlaceholder.call(j, Oe, Ne, !0) || Ne.def,
                    pos: Oe
                  })) !== !1) {
                    var $e = ge.c !== void 0 ? ge.c : ze, mt = Oe;
                    return $e = $e === te.skipOptionalPartCharacter && Ne.static === !0 ? f.getPlaceholder.call(j, Oe, Ne, !0) || Ne.def : $e, (ge = ie(ge)) !== !0 && ge.pos !== void 0 && ge.pos !== Oe && (mt = ge.pos), ge !== !0 && ge.pos === void 0 && ge.c === void 0 || C.call(j, O, H.extend({}, he, {
                      input: b.call(j, $e, Ne, mt)
                    }), M, mt) === !1 && (ge = !1), !1;
                  }
                  return !0;
                }), ge;
              }
              O.begin !== void 0 && (le = j.isRTL ? O.end : O.begin);
              var Y = !0, ae = H.extend(!0, [], re.validPositions);
              if (te.keepStatic === !1 && re.excludes[le] !== void 0 && R !== !0 && M !== !0) for (var ke = le; ke < (j.isRTL ? O.begin : O.end); ke++) re.excludes[ke] !== void 0 && (re.excludes[ke] = void 0, delete re.tests[ke]);
              if (typeof te.preValidation == "function" && M !== !0 && F !== !0 && (Y = ie(Y = te.preValidation.call(j, m.getBuffer.call(j), le, E, S.call(j, O), te, re, O, B || R))), Y === !0) {
                if (Y = ye(le, E, B), (!B || M === !0) && Y === !1 && F !== !0) {
                  var ue = re.validPositions[le];
                  if (!ue || ue.match.static !== !0 || ue.match.def !== E && E !== te.skipOptionalPartCharacter) {
                    if (te.insertMode || re.validPositions[m.seekNext.call(j, le)] === void 0 || O.end > le) {
                      var oe = !1;
                      if (re.jitOffset[le] && re.validPositions[m.seekNext.call(j, le)] === void 0 && (Y = I.call(j, le + re.jitOffset[le], E, !0, !0)) !== !1 && (R !== !0 && (Y.caret = le), oe = !0), O.end > le && (re.validPositions[le] = void 0), !oe && !m.isMask.call(j, le, te.keepStatic && le === 0)) {
                        for (var fe = le + 1, we = m.seekNext.call(j, le, !1, le !== 0); fe <= we; fe++) if ((Y = ye(fe, E, B)) !== !1) {
                          Y = k.call(j, le, Y.pos !== void 0 ? Y.pos : fe) || Y, le = fe;
                          break;
                        }
                      }
                    }
                  } else Y = {
                    caret: m.seekNext.call(j, le)
                  };
                }
                j.hasAlternator && R !== !0 && !B && (R = !0, Y === !1 && te.keepStatic && (w.call(j, m.getBuffer.call(j)) || le === 0) ? Y = v.call(j, le, E, B, M, void 0, O) : (S.call(j, O) && re.tests[le] && re.tests[le].length > 1 && te.keepStatic || Y == 1 && te.numericInput !== !0 && re.tests[le] && re.tests[le].length > 1 && m.getLastValidPosition.call(j, void 0, !0) > le) && (Y = v.call(j, !0))), Y === !0 && (Y = {
                  pos: le
                });
              }
              if (typeof te.postValidation == "function" && M !== !0 && F !== !0) {
                var Ie = te.postValidation.call(j, m.getBuffer.call(j, !0), O.begin !== void 0 ? j.isRTL ? O.end : O.begin : O, E, Y, te, re, B, L);
                Ie !== void 0 && (Y = Ie === !0 ? Y : Ie);
              }
              Y && Y.pos === void 0 && (Y.pos = le), Y === !1 || F === !0 ? (m.resetMaskSet.call(j, !0), re.validPositions = H.extend(!0, [], ae)) : k.call(j, void 0, le, !0);
              var be = ie(Y);
              return j.maxLength !== void 0 && m.getBuffer.call(j).length > j.maxLength && !M && (m.resetMaskSet.call(j, !0), re.validPositions = H.extend(!0, [], ae), be = !1), be;
            }
            function T(O, E, B) {
              for (var M = this.maskset, R = !1, F = f.getTests.call(this, O), L = 0; L < F.length; L++) {
                if (F[L].match && (F[L].match.nativeDef === E.match[B.shiftPositions ? "def" : "nativeDef"] && (!B.shiftPositions || !E.match.static) || F[L].match.nativeDef === E.match.nativeDef || B.regex && !F[L].match.static && F[L].match.fn.test(E.input, M, O, !1, B))) {
                  R = !0;
                  break;
                }
                if (F[L].match && F[L].match.def === E.match.nativeDef) {
                  R = void 0;
                  break;
                }
              }
              return R === !1 && M.jitOffset[O] !== void 0 && (R = T.call(this, O + M.jitOffset[O], E, B)), R;
            }
            function x(O, E, B) {
              var M, R, F = this, L = this.maskset, j = this.opts, H = this.dependencyLib, te = j.skipOptionalPartCharacter, re = F.isRTL ? B.slice().reverse() : B;
              if (j.skipOptionalPartCharacter = "", O === !0) m.resetMaskSet.call(F, !1), O = 0, E = B.length, R = m.determineNewCaretPosition.call(F, {
                begin: 0,
                end: 0
              }, !1).begin;
              else {
                for (M = O; M < E; M++) L.validPositions.splice(O, 0);
                R = O;
              }
              var le = new H.Event("keypress");
              for (M = O; M < E; M++) {
                le.key = re[M].toString(), F.ignorable = !1;
                var ie = c.EventHandlers.keypressEvent.call(F, le, !0, !1, !1, R);
                ie !== !1 && ie !== void 0 && (R = ie.forwardPosition);
              }
              j.skipOptionalPartCharacter = te;
            }
            function k(O, E, B) {
              var M = this, R = this.maskset, F = this.dependencyLib;
              if (O === void 0) for (O = E - 1; O > 0 && !R.validPositions[O]; O--) ;
              for (var L = O; L < E; L++)
                if (R.validPositions[L] === void 0 && !m.isMask.call(M, L, !1) && (L == 0 ? f.getTest.call(M, L) : R.validPositions[L - 1])) {
                  var j = f.getTests.call(M, L).slice();
                  j[j.length - 1].match.def === "" && j.pop();
                  var H, te = f.determineTestTemplate.call(M, L, j);
                  if (te && (te.match.jit !== !0 || te.match.newBlockMarker === "master" && (H = R.validPositions[L + 1]) && H.match.optionalQuantifier === !0) && ((te = F.extend({}, te, {
                    input: f.getPlaceholder.call(M, L, te.match, !0) || te.match.def
                  })).generatedInput = !0, C.call(M, L, te, !0), B !== !0)) {
                    var re = R.validPositions[E].input;
                    return R.validPositions[E] = void 0, I.call(M, E, re, !0, !0);
                  }
                }
            }
            function C(O, E, B, M) {
              var R = this, F = this.maskset, L = this.opts, j = this.dependencyLib;
              function H(be, Oe, ze) {
                var Re = Oe[be];
                if (Re !== void 0 && Re.match.static === !0 && Re.match.optionality !== !0 && (Oe[0] === void 0 || Oe[0].alternation === void 0)) {
                  var ge = ze.begin <= be - 1 ? Oe[be - 1] && Oe[be - 1].match.static === !0 && Oe[be - 1] : Oe[be - 1], he = ze.end > be + 1 ? Oe[be + 1] && Oe[be + 1].match.static === !0 && Oe[be + 1] : Oe[be + 1];
                  return ge && he;
                }
                return !1;
              }
              var te = 0, re = O.begin !== void 0 ? O.begin : O, le = O.end !== void 0 ? O.end : O, ie = !0;
              if (O.begin > O.end && (re = O.end, le = O.begin), M = M !== void 0 ? M : re, B === void 0 && (re !== le || L.insertMode && F.validPositions[M] !== void 0 || E === void 0 || E.match.optionalQuantifier || E.match.optionality)) {
                var ye, Y = j.extend(!0, [], F.validPositions), ae = m.getLastValidPosition.call(R, void 0, !0);
                F.p = re;
                var ke = S.call(R, O) ? re : M;
                for (ye = ae; ye >= ke; ye--) F.validPositions.splice(ye, 1), E === void 0 && delete F.tests[ye + 1];
                var ue, oe, fe = M, we = fe;
                for (E && (F.validPositions[M] = j.extend(!0, {}, E), we++, fe++), Y[le] == null && F.jitOffset[le] && (le += F.jitOffset[le] + 1), ye = E ? le : le - 1; ye <= ae; ye++) {
                  if ((ue = Y[ye]) !== void 0 && ue.generatedInput !== !0 && (ye >= le || ye >= re && H(ye, Y, {
                    begin: re,
                    end: le
                  }))) {
                    for (; f.getTest.call(R, we).match.def !== ""; ) {
                      if ((oe = T.call(R, we, ue, L)) !== !1 || ue.match.def === "+") {
                        ue.match.def === "+" && m.getBuffer.call(R, !0);
                        var Ie = I.call(R, we, ue.input, ue.match.def !== "+", !0);
                        if (ie = Ie !== !1, fe = (Ie.pos || we) + 1, !ie && oe) break;
                      } else ie = !1;
                      if (ie) {
                        E === void 0 && ue.match.static && ye === O.begin && te++;
                        break;
                      }
                      if (!ie && m.getBuffer.call(R), we > F.maskLength) break;
                      we++;
                    }
                    f.getTest.call(R, we).match.def == "" && (ie = !1), we = fe;
                  }
                  if (!ie) break;
                }
                if (!ie) return F.validPositions = j.extend(!0, [], Y), m.resetMaskSet.call(R, !0), !1;
              } else E && f.getTest.call(R, M).match.cd === E.match.cd && (F.validPositions[M] = j.extend(!0, {}, E));
              return m.resetMaskSet.call(R, !0), te;
            }
          }
        }, n = {};
        function r(o) {
          var l = n[o];
          if (l !== void 0) return l.exports;
          var d = n[o] = {
            exports: {}
          };
          return s[o](d, d.exports, r), d.exports;
        }
        var i = {};
        return function() {
          var o = i;
          Object.defineProperty(o, "__esModule", {
            value: !0
          }), o.default = void 0, r(7149), r(3194), r(9302), r(4013), r(3851), r(219), r(207), r(5296);
          var l, d = (l = r(2394)) && l.__esModule ? l : {
            default: l
          };
          o.default = d.default;
        }(), i;
      }();
    });
  }(Ph)), Ph.exports;
}
var JX = ZX();
const $X = /* @__PURE__ */ K1(JX), _X = me({
  name: "BrandingPreview",
  props: {
    show: {
      type: Boolean,
      default: !1
    }
  },
  emits: [
    "update:show"
  ],
  watch: {
    show(e) {
      var t, s;
      e ? (t = bootstrap.Modal.getOrCreateInstance(this.$refs.showBranding)) == null || t.show() : (s = bootstrap.Modal.getOrCreateInstance(this.$refs.showBranding)) == null || s.hide();
    }
  },
  computed: {
    ...q(ct, ["myBranding", "brandingLoading"])
  },
  methods: {},
  mounted() {
    this.$refs.showBranding.addEventListener("hidden.bs.modal", () => {
      this.$emit("update:show", !1);
    });
  }
}), eq = {
  class: "modal fade",
  id: "showBranding",
  ref: "showBranding",
  tabindex: "-1",
  "aria-labelledby": "showBrandingLabel",
  "aria-hidden": "true"
}, tq = { class: "modal-dialog modal-lg modal-dialog-centered" }, sq = { class: "modal-content bg-gradient-alphabet rounded" }, aq = { class: "modal-header border-0 pb-0" }, nq = {
  class: "fw-bold fs-5 modal-title",
  id: "showBrandingLabel"
}, rq = {
  key: 0,
  class: "modal-body"
}, oq = { class: "row mb-3" }, iq = { class: "col-lg-7" }, lq = { class: "fw-bold" }, dq = { class: "card shadow bg-eclipse text-white mb-3 mb-lg-0" }, cq = { class: "d-flex align-items-center card-body" }, uq = ["src"], pq = { class: "media-body flex-grow-1 ms-3" }, hq = { class: "m-0" }, mq = { class: "fs-5" }, fq = { class: "text-white text-opacity-50 fw-bold" }, gq = { class: "col-lg-5" }, vq = { class: "fw-bold" }, yq = { class: "card rounded-0 shadow bg-lava text-white" }, bq = { class: "card-body" }, Aq = { class: "fw-bold small" }, wq = { class: "media" }, Cq = ["src"], Sq = { class: "media-body" }, Pq = { class: "fw-bold fs-4 d-block" }, kq = { class: "d-block" }, Eq = { class: "d-block" }, Iq = { class: "mb-3" }, Tq = { class: "fw-bold" }, Oq = { class: "shadow border bg-white" }, Rq = { class: "p-2 d-flex align-items-center justify-content-between" }, Lq = ["src"], Bq = { class: "mb-3" }, Mq = { class: "fw-bold" }, xq = { class: "pdf-footer shadow" }, Fq = { class: "pdf-footer_data p-3 d-flex align-items-center" }, Vq = ["src"], Dq = { class: "pdf-footer_presented" }, Nq = { class: "pdf-footer_info" }, jq = { class: "pdf-footer_website text-truncate" }, Hq = { class: "pdf-footer_disclaimer" }, Uq = { class: "p-3" }, zq = { class: "mb-3" }, Wq = { class: "fw-bold" }, Gq = { class: "row" }, Yq = { class: "col-lg-10" }, Xq = { class: "shadow bg-eclipse text-white" }, qq = { class: "card-body p-2" }, Qq = { class: "row" }, Kq = { class: "col-3 col-md-12 col-lg-2" }, Zq = ["src"], Jq = { class: "col-9 col-md-6 col-lg-4" }, $q = { class: "fw-bold text-white text-opacity-50 d-block" }, _q = { class: "fw-bold fs-5 d-block" }, eQ = { class: "col mt-3 mt-lg-0" }, tQ = {
  key: 0,
  class: "d-block"
}, sQ = {
  key: 1,
  class: "d-block"
}, aQ = {
  key: 2,
  class: "text-truncate"
};
function nQ(e, t, s, n, r, i) {
  return p(), h("div", eq, [
    a("div", tq, [
      a("div", sq, [
        a("div", aq, [
          a("span", nq, g(e.$t("t-branding-preview")), 1),
          t[0] || (t[0] = a("button", {
            type: "button",
            class: "btn-close",
            "data-bs-dismiss": "modal",
            "aria-label": "Close"
          }, null, -1))
        ]),
        e.myBranding ? (p(), h("div", rq, [
          a("div", oq, [
            a("div", iq, [
              a("p", lq, g(e.$t("t-property-detail-page")), 1),
              a("div", dq, [
                a("div", cq, [
                  e.myBranding && e.myBranding.hasHeadshot ? (p(), h("img", {
                    key: 0,
                    src: e.myBranding.headshotPhotoUrl,
                    class: "rounded-circle flex-shrink-0",
                    alt: "Avatar",
                    height: "70"
                  }, null, 8, uq)) : P("", !0),
                  a("div", pq, [
                    a("p", null, g(e.$t("t-your-real-estate-pro")), 1),
                    a("p", hq, [
                      a("b", mq, g(e.myBranding.agentFirstName) + " " + g(e.myBranding.agentLastName), 1),
                      t[1] || (t[1] = a("br", null, null, -1)),
                      a("span", fq, g(e.myBranding.company), 1)
                    ])
                  ])
                ])
              ])
            ]),
            a("div", gq, [
              a("p", vq, g(e.$t("t-pdf-agent-card")), 1),
              a("div", yq, [
                a("div", bq, [
                  a("p", Aq, g(e.$t("t-property-analysis-presented-by")) + ": ", 1),
                  a("div", wq, [
                    e.myBranding && e.myBranding.hasHeadshot ? (p(), h("img", {
                      key: 0,
                      src: e.myBranding.headshotPhotoUrl,
                      class: "align-self-center me-3",
                      alt: "Avatar",
                      height: "100"
                    }, null, 8, Cq)) : P("", !0),
                    a("div", Sq, [
                      a("span", Pq, g(e.myBranding.agentFirstName) + " " + g(e.myBranding.agentLastName), 1),
                      a("span", kq, g(e.myBranding.company), 1),
                      a("span", Eq, g(e.myBranding.officePhone), 1),
                      y(" " + g(e.myBranding.website), 1)
                    ])
                  ])
                ])
              ])
            ])
          ]),
          a("div", Iq, [
            a("p", Tq, g(e.$t("t-pdf-header")), 1),
            a("div", Oq, [
              a("div", Rq, [
                e.myBranding && e.myBranding.hasCompanyLogo ? (p(), h("img", {
                  key: 0,
                  src: e.myBranding.companyLogoUrl,
                  alt: "{{myBranding.company}}",
                  height: "40"
                }, null, 8, Lq)) : P("", !0),
                t[2] || (t[2] = a("img", {
                  src: lI,
                  height: "40",
                  title: "Rescover",
                  alt: "Rescover"
                }, null, -1))
              ])
            ])
          ]),
          a("div", Bq, [
            a("p", Mq, g(e.$t("t-pdf-footer")), 1),
            a("div", xq, [
              a("div", Fq, [
                e.myBranding && e.myBranding.hasHeadshot ? (p(), h("img", {
                  key: 0,
                  src: e.myBranding.headshotPhotoUrl,
                  class: "pdf-footer_avatar",
                  alt: "Avatar",
                  height: "100"
                }, null, 8, Vq)) : P("", !0),
                a("div", null, [
                  a("div", Dq, g(e.$t("t-property-analysis-presented-by")) + ":", 1),
                  a("div", Nq, [
                    a("b", null, g(e.myBranding.agentFirstName) + " " + g(e.myBranding.agentLastName), 1),
                    t[3] || (t[3] = a("br", null, null, -1)),
                    y(" " + g(e.myBranding.company), 1),
                    t[4] || (t[4] = a("br", null, null, -1)),
                    y(" " + g(e.myBranding.officePhone), 1)
                  ]),
                  a("div", jq, g(e.myBranding.website), 1)
                ])
              ]),
              a("div", Hq, [
                a("div", Uq, [
                  t[5] || (t[5] = a("img", {
                    src: dI,
                    height: "30",
                    alt: "Rescover",
                    title: "Rescover",
                    class: "pdf-footer_disclaimer-logo d-block mb-2"
                  }, null, -1)),
                  a("span", null, g(e.$t("t-disclaimer")), 1)
                ])
              ])
            ])
          ]),
          a("div", zq, [
            a("p", Wq, g(e.$t("t-shared-listing-email-footer")), 1),
            a("div", Gq, [
              a("div", Yq, [
                a("div", Xq, [
                  a("div", qq, [
                    a("div", Qq, [
                      a("div", Kq, [
                        e.myBranding && e.myBranding.hasHeadshot ? (p(), h("img", {
                          key: 0,
                          src: e.myBranding.headshotPhotoUrl,
                          alt: "Avatar",
                          height: "75",
                          class: "mb-md-3 mb-lg-0"
                        }, null, 8, Zq)) : P("", !0)
                      ]),
                      a("div", Jq, [
                        a("span", $q, g(e.myBranding.company), 1),
                        a("span", _q, g(e.myBranding.agentFirstName) + " " + g(e.myBranding.agentLastName), 1),
                        y(" " + g(e.myBranding.email), 1)
                      ]),
                      a("div", eQ, [
                        e.myBranding.officePhone ? (p(), h("span", tQ, [
                          t[6] || (t[6] = a("i", { class: "fa-light fa-phone-office me-2 text-white text-opacity-50" }, null, -1)),
                          y(g(e.myBranding.officePhone), 1)
                        ])) : P("", !0),
                        e.myBranding.cellPhone ? (p(), h("span", sQ, [
                          t[7] || (t[7] = a("i", { class: "fa-light fa-mobile me-2 text-white text-opacity-50" }, null, -1)),
                          y(g(e.myBranding.cellPhone), 1)
                        ])) : P("", !0),
                        e.myBranding.website ? (p(), h("span", aQ, [
                          t[8] || (t[8] = a("i", { class: "fa-light fa-link me-2 text-white text-opacity-50" }, null, -1)),
                          y(g(e.myBranding.website), 1)
                        ])) : P("", !0)
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])) : P("", !0)
      ])
    ])
  ], 512);
}
const jk = /* @__PURE__ */ Ae(_X, [["render", nQ]]), rQ = me({
  name: "UsersBranding",
  props: {},
  components: {
    ContentLoader: Sa,
    Cropper: yb,
    IndustryDesignation: QX,
    BrandingPreview: jk
  },
  data() {
    return {
      companyLogo: void 0,
      headshotPhoto: void 0,
      stencil: dX,
      imageHeight: void 0,
      previewBranding: !1
    };
  },
  computed: {
    headshotPhotoName() {
      return this.headshotPhoto ? this.headshotPhoto.name : "Choose file";
    },
    headshotPhotoUrl() {
      return this.headshotPhoto ? URL.createObjectURL(this.headshotPhoto) : "";
    },
    notClient() {
      return this.isAdmin || this.isUser;
    },
    ...at(Te, ct),
    ...q(Te, ["access", "aclLoaded", "isClient", "isAdmin", "isUser"]),
    ...q(ct, ["myBranding", "brandingLoading"])
  },
  methods: {
    async loadBranding() {
      try {
        await this.accountStore.fetchMyBranding();
      } catch (e) {
        Se(e);
      }
    },
    async updateBranding(e) {
      try {
        await this.accountStore.updateBranding(), wt("Your branding has been updated.");
      } catch (t) {
        (!Zt.isModelStateException(t) || !t.showFormErrors(e.target)) && Se(t);
      }
    },
    async updateHeadshotPhoto(e) {
      var t;
      try {
        const s = this.$refs.cropper.getResult();
        this.myBranding.updated || await this.accountStore.updateBranding(), await this.accountStore.updateHeadshotPhoto(this.headshotPhoto, s.coordinates.width, s.coordinates.height, s.coordinates.top, s.coordinates.left), (t = bootstrap.Modal.getOrCreateInstance(this.$refs.mymodal)) == null || t.hide();
      } catch (s) {
        (!Zt.isModelStateException(s) || !s.showFormErrors(e.target)) && Se(s);
      }
    },
    handleHeadshotPhotoFile(e) {
      this.headshotPhoto = e.target.files[0];
    },
    editHeadshot() {
      var e;
      this.$refs.mymodal.addEventListener("shown.bs.modal", () => {
        this.$refs.cropper && this.$refs.cropper.refresh();
      }), (e = bootstrap.Modal.getOrCreateInstance(this.$refs.mymodal)) == null || e.show();
    },
    imageLoaded() {
      var t;
      Zt.clearModelStateErrors();
      const e = this.$refs.cropper.getResult();
      this.imageHeight = (t = e == null ? void 0 : e.image) == null ? void 0 : t.height, this.imageHeight && this.imageHeight < 300 && Zt.setFieldInvalid(this.$refs.logoFile, `Image is too small, it's height is ${this.imageHeight}px. Please upload an image that is at least 300px in height.`);
    }
  },
  mounted() {
    this.aclLoaded.then(async () => await this.loadBranding()).then(() => {
      const e = $X({ mask: "(999) 999-9999" });
      this.$refs.cellPhone && e.mask(this.$refs.cellPhone), this.$refs.officePhone && e.mask(this.$refs.officePhone);
    });
  }
}), Hk = "data:image/jpeg;base64,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", oQ = { class: "row mb-3" }, iQ = {
  key: 0,
  class: "col text-end d-flex align-items-center justify-content-end"
}, lQ = { key: 0 }, dQ = {
  class: "row mb-3 g-3",
  id: "brandingData"
}, cQ = { class: "col-12 col-md-6 col-xl-12" }, uQ = { class: "card shadow-sm" }, pQ = { class: "row" }, hQ = { class: "col-lg-4" }, mQ = { class: "p-4" }, fQ = {
  style: { "max-width": "150px", height: "150px" },
  class: "mx-auto position-relative mb-3"
}, gQ = ["src"], vQ = {
  key: 1,
  src: Hk,
  class: "rounded img-fluid",
  height: "150",
  width: "150"
}, yQ = { class: "mb-1 text-center fw-bold fs-6 text-truncate" }, bQ = { key: 0 }, AQ = { class: "col border-start-lg" }, wQ = { class: "p-4" }, CQ = { class: "row g-3 mb-3" }, SQ = { class: "col-md-6" }, PQ = ["disabled"], kQ = { class: "col-md-6" }, EQ = ["disabled"], IQ = {
  key: 0,
  class: "col-md-6"
}, TQ = { class: "input-group" }, OQ = ["disabled"], RQ = { class: "col-md-6" }, LQ = { class: "input-group" }, BQ = ["disabled"], MQ = { class: "col-md-12" }, xQ = { class: "input-group" }, FQ = ["disabled"], VQ = {
  key: 0,
  class: "col-12 col-md-6 col-xl-12"
}, DQ = { class: "card shadow-sm h-100" }, NQ = { class: "card-body" }, jQ = {
  key: 1,
  class: "col-lg-12"
}, HQ = { class: "text-end" }, UQ = ["disabled"], zQ = {
  ref: "mymodal",
  class: "modal fade",
  id: "modalHeadshot",
  tabindex: "-1",
  "aria-labelledby": "modalHeadshotLabel",
  "aria-hidden": "true"
}, WQ = { class: "modal-dialog modal-dialog-centered" }, GQ = { class: "modal-content bg-gradient-alphabet rounded" }, YQ = { class: "modal-header border-0 pb-0" }, XQ = ["disabled"], qQ = { class: "modal-body" }, QQ = { class: "d-flex justify-content-center mb-3" }, KQ = {
  class: "form-label",
  for: "headshotPhotoFile",
  "aria-describedby": "inputGroupFileAddon02"
}, ZQ = ["disabled"], JQ = { class: "text-secondary text-small" }, $Q = { class: "modal-footer border-0" }, _Q = ["disabled"], eK = ["disabled"], tK = {
  key: 1,
  class: "row"
}, sK = { class: "col" };
function aK(e, t, s, n, r, i) {
  var u;
  const o = pe("industry-designation"), l = pe("Cropper"), d = pe("content-loader"), c = pe("branding-preview");
  return p(), h(A, null, [
    a("div", oQ, [
      t[14] || (t[14] = a("div", { class: "col" }, [
        a("h2", { class: "fw-bold fs-3 mb-0" }, "Contact Information")
      ], -1)),
      e.notClient ? (p(), h("div", iQ, [
        a("button", {
          type: "button",
          class: "btn btn-outline-eclipse btn-sm",
          onClick: t[0] || (t[0] = (m) => e.previewBranding = !0)
        }, [
          t[13] || (t[13] = a("i", { class: "fa-thin fa-user-tie me-2" }, null, -1)),
          y(g(e.$t("t-show-branding-preview")), 1)
        ])
      ])) : P("", !0)
    ]),
    e.myBranding ? (p(), h("div", lQ, [
      a("div", dQ, [
        a("div", cQ, [
          a("div", uQ, [
            a("div", pQ, [
              a("div", hQ, [
                t[17] || (t[17] = a("div", { class: "card-header bg-transparent border-0" }, [
                  a("span", { class: "fw-bold fs-5" }, "Information")
                ], -1)),
                a("div", mQ, [
                  a("div", fQ, [
                    a("button", {
                      type: "button",
                      class: "btn btn-eclipse rounded-circle position-absolute top-0 start-100 translate-middle",
                      onClick: t[1] || (t[1] = (...m) => e.editHeadshot && e.editHeadshot(...m))
                    }, t[15] || (t[15] = [
                      a("i", { class: "fa-light fa-pencil" }, null, -1)
                    ])),
                    (u = e.myBranding) != null && u.hasHeadshot ? (p(), h("img", {
                      key: 0,
                      src: e.myBranding.headshotPhotoUrl,
                      class: "rounded img-fluid",
                      height: "150",
                      width: "150"
                    }, null, 8, gQ)) : (p(), h("img", vQ))
                  ]),
                  a("div", yQ, g(e.myBranding.company), 1),
                  e.notClient ? (p(), h("div", bQ, [
                    t[16] || (t[16] = a("label", {
                      class: "form-label",
                      for: "title"
                    }, "Title", -1)),
                    V(a("input", {
                      type: "text",
                      class: "form-control",
                      "onUpdate:modelValue": t[2] || (t[2] = (m) => e.myBranding.title = m),
                      maxlength: "75",
                      id: "title"
                    }, null, 512), [
                      [_e, e.myBranding.title]
                    ])
                  ])) : P("", !0)
                ])
              ]),
              a("div", AQ, [
                a("div", wQ, [
                  a("div", CQ, [
                    a("div", SQ, [
                      t[18] || (t[18] = a("label", {
                        for: "agentFirstName",
                        class: "form-label"
                      }, "First Name", -1)),
                      V(a("input", {
                        type: "text",
                        "onUpdate:modelValue": t[3] || (t[3] = (m) => e.myBranding.agentFirstName = m),
                        class: "form-control",
                        id: "agentFirstName",
                        maxlength: "75",
                        disabled: e.brandingLoading
                      }, null, 8, PQ), [
                        [_e, e.myBranding.agentFirstName]
                      ])
                    ]),
                    a("div", kQ, [
                      t[19] || (t[19] = a("label", {
                        for: "agentLastName",
                        class: "form-label"
                      }, "Last Name", -1)),
                      V(a("input", {
                        type: "text",
                        "onUpdate:modelValue": t[4] || (t[4] = (m) => e.myBranding.agentLastName = m),
                        class: "form-control",
                        id: "agentLastName",
                        maxlength: "75",
                        disabled: e.brandingLoading
                      }, null, 8, EQ), [
                        [_e, e.myBranding.agentLastName]
                      ])
                    ]),
                    e.notClient ? (p(), h("div", IQ, [
                      t[21] || (t[21] = a("label", {
                        for: "officePhone",
                        class: "form-label"
                      }, "Office Phone", -1)),
                      a("div", TQ, [
                        t[20] || (t[20] = a("span", {
                          class: "input-group-text",
                          id: "basic-addon1"
                        }, [
                          a("i", { class: "fa-light fa-phone" })
                        ], -1)),
                        V(a("input", {
                          ref: "officePhone",
                          type: "tel",
                          "onUpdate:modelValue": t[5] || (t[5] = (m) => e.myBranding.officePhone = m),
                          class: "form-control",
                          id: "officePhone",
                          maxlength: "25",
                          disabled: e.brandingLoading
                        }, null, 8, OQ), [
                          [_e, e.myBranding.officePhone]
                        ])
                      ])
                    ])) : P("", !0),
                    a("div", RQ, [
                      t[23] || (t[23] = a("label", {
                        for: "cellPhone",
                        class: "form-label"
                      }, "Mobile Phone", -1)),
                      a("div", LQ, [
                        t[22] || (t[22] = a("span", {
                          class: "input-group-text",
                          id: "basic-addon1"
                        }, [
                          a("i", { class: "fa-light fa-mobile" })
                        ], -1)),
                        V(a("input", {
                          ref: "cellPhone",
                          type: "tel",
                          "onUpdate:modelValue": t[6] || (t[6] = (m) => e.myBranding.cellPhone = m),
                          class: "form-control",
                          id: "cellPhone",
                          maxlength: "25",
                          disabled: e.brandingLoading
                        }, null, 8, BQ), [
                          [_e, e.myBranding.cellPhone]
                        ])
                      ])
                    ]),
                    a("div", MQ, [
                      t[25] || (t[25] = a("label", {
                        for: "email",
                        class: "form-label"
                      }, "Email Address", -1)),
                      a("div", xQ, [
                        t[24] || (t[24] = a("span", {
                          class: "input-group-text",
                          id: "basic-addon1"
                        }, [
                          a("i", { class: "fa-light fa-envelope" })
                        ], -1)),
                        V(a("input", {
                          type: "email",
                          inputmode: "email",
                          "onUpdate:modelValue": t[7] || (t[7] = (m) => e.myBranding.email = m),
                          class: "form-control",
                          id: "email",
                          maxlength: "250",
                          disabled: e.brandingLoading
                        }, null, 8, FQ), [
                          [_e, e.myBranding.email]
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]),
        e.notClient ? (p(), h("div", VQ, [
          a("div", DQ, [
            t[27] || (t[27] = a("div", { class: "card-header bg-transparent border-0" }, [
              a("span", { class: "fw-bold fs-5" }, "Bio")
            ], -1)),
            a("div", NQ, [
              t[26] || (t[26] = a("label", { class: "form-label visually-hidden" }, "Bio", -1)),
              V(a("textarea", {
                rows: "5",
                class: "form-control",
                maxlength: "1024",
                "onUpdate:modelValue": t[8] || (t[8] = (m) => e.myBranding.bio = m)
              }, null, 512), [
                [_e, e.myBranding.bio]
              ])
            ])
          ])
        ])) : P("", !0),
        e.notClient ? (p(), h("div", jQ, [
          N(o)
        ])) : P("", !0)
      ]),
      a("div", HQ, [
        a("a", {
          onClick: t[9] || (t[9] = (...m) => e.updateBranding && e.updateBranding(...m)),
          "data-validate": "#brandingData",
          class: "btn btn-lava",
          disabled: e.brandingLoading
        }, "Update", 8, UQ)
      ]),
      a("div", zQ, [
        a("div", WQ, [
          a("div", GQ, [
            a("div", YQ, [
              t[28] || (t[28] = a("h1", {
                class: "fw-bold fs-5 modal-title",
                id: "modalHeadshotLabel"
              }, "Headshot", -1)),
              a("button", {
                type: "button",
                class: "btn-close",
                "data-bs-dismiss": "modal",
                "aria-label": "Close",
                disabled: e.brandingLoading
              }, null, 8, XQ)
            ]),
            a("div", qQ, [
              a("div", QQ, [
                N(l, {
                  ref: "cropper",
                  class: "avatar-crop-user",
                  src: e.headshotPhotoUrl,
                  "stencil-component": e.stencil,
                  "stencil-props": { aspectRatio: 1 / 1 },
                  "min-height": 300,
                  onReady: e.imageLoaded,
                  disabled: e.brandingLoading
                }, null, 8, ["src", "stencil-component", "onReady", "disabled"])
              ]),
              a("div", null, [
                a("label", KQ, g(e.headshotPhotoName), 1),
                a("input", {
                  ref: "logoFile",
                  type: "file",
                  onChange: t[10] || (t[10] = (...m) => e.handleHeadshotPhotoFile && e.handleHeadshotPhotoFile(...m)),
                  class: "form-control mb-1",
                  id: "headshotPhotoFile",
                  "data-val-id": "file",
                  disabled: e.brandingLoading
                }, null, 40, ZQ),
                a("span", JQ, g(e.$t("t-headshot-photo-type")), 1)
              ])
            ]),
            a("div", $Q, [
              a("button", {
                type: "button",
                class: "btn btn-secondary",
                "data-bs-dismiss": "modal",
                disabled: e.brandingLoading
              }, "Cancel", 8, _Q),
              a("button", {
                type: "button",
                onClick: t[11] || (t[11] = (...m) => e.updateHeadshotPhoto && e.updateHeadshotPhoto(...m)),
                class: "btn btn-lava ms-auto",
                disabled: e.brandingLoading || !e.imageHeight || e.imageHeight < 300
              }, "Update Headshot Photo", 8, eK)
            ])
          ])
        ])
      ], 512)
    ])) : (p(), h("div", tK, [
      a("div", sK, [
        N(d, {
          width: 975,
          height: 732,
          speed: 2
        }, {
          default: ve(() => t[29] || (t[29] = [
            a("rect", {
              x: "0",
              y: "0",
              rx: "3",
              ry: "3",
              width: "975",
              height: "316"
            }, null, -1),
            a("rect", {
              x: "0",
              y: "396",
              rx: "3",
              ry: "3",
              width: "975",
              height: "336"
            }, null, -1)
          ])),
          _: 1,
          __: [29]
        })
      ])
    ])),
    N(c, {
      show: e.previewBranding,
      "onUpdate:show": t[12] || (t[12] = (m) => e.previewBranding = m)
    }, null, 8, ["show"])
  ], 64);
}
const Uis = /* @__PURE__ */ Ae(rQ, [["render", aK]]), nK = me({
  name: "UserOptions",
  data() {
    return {
      busy: !0
    };
  },
  computed: {
    ...at(ct),
    ...q(Te, ["access", "aclLoaded"]),
    ...q(ct, ["userInfo"])
  },
  methods: {
    number: Ve,
    async save() {
      try {
        this.busy = !0;
        const e = {
          defaultAnalysisMode: this.userInfo.defaultAnalysisMode,
          defaultTaxMetrics: this.userInfo.defaultTaxMetrics
        }, t = await W.api.user.updateSettings(e);
        if (t.data.status != de.Success)
          throw new Le(t);
        wt("Saved Sucessfully");
      } catch (e) {
        Se(e);
      }
      this.busy = !1;
    }
  },
  mounted() {
    this.aclLoaded.then(async () => await this.accountStore.fetchUserSettings()).then(() => this.busy = !1);
  }
}), rK = { class: "fw-bold fs-3 mb-3" }, oK = { class: "row g-3" }, iK = { class: "col-md-6" }, lK = { class: "card shadow-sm" }, dK = { class: "card-header fs-5 fw-bold bg-white pt-3 border-0 pb-0" }, cK = { class: "card-body" }, uK = {
  key: 0,
  class: "row"
}, pK = { class: "col-sm-9" }, hK = { value: "basic" }, mK = { value: "advanced" }, fK = { class: "col-md-6" }, gK = { class: "card shadow-sm" }, vK = { class: "card-header fs-5 fw-bold bg-white pt-3 border-0 pb-0" }, yK = { class: "card-body" }, bK = {
  key: 0,
  class: "row"
}, AK = { class: "col-sm-9" }, wK = { value: "after" }, CK = { value: "before" }, SK = { class: "col-md-12" }, PK = { class: "d-flex justify-content-end" }, kK = ["disabled"];
function EK(e, t, s, n, r, i) {
  return p(), h(A, null, [
    a("h2", rK, g(e.$t("t-user-options")), 1),
    a("div", oK, [
      a("div", iK, [
        a("div", lK, [
          a("div", dK, g(e.$t("t-default-analysis-mode")), 1),
          a("div", cK, [
            t[4] || (t[4] = a("p", null, " Choose your desiderd analysis mode, this view will be used whey looking at the financial tab on the properties. ", -1)),
            e.userInfo ? (p(), h("div", uK, [
              t[3] || (t[3] = a("label", {
                for: "url",
                class: "col-sm-3 col-form-label"
              }, "Mode", -1)),
              a("div", pK, [
                V(a("select", {
                  class: "form-select",
                  "onUpdate:modelValue": t[0] || (t[0] = (o) => e.userInfo.defaultAnalysisMode = o)
                }, [
                  a("option", hK, g(e.$t("t-simplified")), 1),
                  a("option", mK, g(e.$t("t-advanced")), 1)
                ], 512), [
                  [We, e.userInfo.defaultAnalysisMode]
                ])
              ])
            ])) : P("", !0)
          ])
        ])
      ]),
      a("div", fK, [
        a("div", gK, [
          a("div", vK, g(e.$t("After-tax Performance Metrics")), 1),
          a("div", yK, [
            t[6] || (t[6] = a("p", null, " Choose wether search results and property detail pages will feature before or after-tax metrics in primary display areas. ", -1)),
            e.userInfo ? (p(), h("div", bK, [
              t[5] || (t[5] = a("label", {
                for: "url",
                class: "col-sm-3 col-form-label"
              }, "Mode", -1)),
              a("div", AK, [
                V(a("select", {
                  class: "form-select",
                  "onUpdate:modelValue": t[1] || (t[1] = (o) => e.userInfo.defaultTaxMetrics = o)
                }, [
                  a("option", wK, g(e.$t("After Tax")), 1),
                  a("option", CK, g(e.$t("Before Tax")), 1)
                ], 512), [
                  [We, e.userInfo.defaultTaxMetrics]
                ])
              ])
            ])) : P("", !0)
          ])
        ])
      ]),
      a("div", SK, [
        a("div", PK, [
          a("button", {
            type: "button",
            class: "btn btn-lava",
            disabled: e.busy,
            onClick: t[2] || (t[2] = (...o) => e.save && e.save(...o))
          }, g(e.$t("t-save")), 9, kK)
        ])
      ])
    ])
  ], 64);
}
const zis = /* @__PURE__ */ Ae(nK, [["render", EK]]), IK = me({
  name: "SchedulingUrl",
  props: {},
  components: {},
  data() {
    return {
      accountInfo: void 0,
      busy: !1
    };
  },
  computed: {
    ...at(Te),
    ...q(Te, ["access", "aclLoaded"])
  },
  methods: {
    async loadAccountInfo() {
      try {
        const e = await W.api.account.info();
        this.accountInfo = e.data.info;
      } catch (e) {
        Se("My Account " + e.message);
      }
    },
    async save() {
      try {
        this.busy = !0, this.accountInfo && this.accountInfo.schedulingLink != null && this.accountInfo.schedulingLink != "" ? (await W.api.account.setScheduleLink(this.accountInfo.schedulingLink)).data.status == de.Success && wt("Schedule Url was saved successfully") : Se("Schedule Url is empty");
      } catch (e) {
        Se("My Account " + e.message);
      }
      this.busy = !1;
    }
  },
  created() {
  },
  async mounted() {
    this.aclLoaded.then(() => {
      this.loadAccountInfo();
    });
  }
}), TK = {
  key: 0,
  class: "card shadow-sm"
}, OK = { class: "card-body" }, RK = { class: "row g-3" }, LK = { class: "col" }, BK = { class: "input-group" }, MK = { class: "d-flex justify-content-end mt-5" }, xK = ["disabled"];
function FK(e, t, s, n, r, i) {
  return p(), h(A, null, [
    t[6] || (t[6] = a("div", { class: "row" }, [
      a("div", { class: "col" }, [
        a("h2", { class: "fw-bold fs-3 mb-3" }, "Meeting Request URL")
      ])
    ], -1)),
    e.accountInfo ? (p(), h("div", TK, [
      t[5] || (t[5] = a("div", { class: "card-header fs-5 fw-bold bg-white py-3 border-0" }, " Scheduling URL ", -1)),
      a("div", OK, [
        a("div", RK, [
          a("div", LK, [
            t[3] || (t[3] = a("label", {
              for: "url",
              class: "form-label"
            }, "Full URL", -1)),
            a("div", BK, [
              t[2] || (t[2] = a("span", {
                class: "input-group-text",
                id: "addonFullUrlGlobe"
              }, [
                a("i", { class: "fa-light fa-globe" })
              ], -1)),
              V(a("input", {
                type: "url",
                class: "form-control",
                name: "url",
                placeholder: "https://example.com",
                "aria-label": "url",
                "aria-describedby": "addonFullUrlGlobe addonFullUrl",
                id: "url",
                "onUpdate:modelValue": t[0] || (t[0] = (o) => e.accountInfo.schedulingLink = o)
              }, null, 512), [
                [_e, e.accountInfo.schedulingLink]
              ])
            ]),
            t[4] || (t[4] = a("div", {
              id: "addonFullUrl",
              class: "form-text"
            }, "This URL will be used when sending out to clients.", -1))
          ])
        ]),
        a("div", MK, [
          a("button", {
            type: "button",
            class: "btn btn-lava",
            disabled: e.busy,
            onClick: t[1] || (t[1] = (...o) => e.save && e.save(...o))
          }, " Save ", 8, xK)
        ])
      ])
    ])) : P("", !0)
  ], 64);
}
const Wis = /* @__PURE__ */ Ae(IK, [["render", FK]]), VK = me({
  name: "CompanyTeamMembers",
  emits: [
    "addUserLicense"
  ],
  directives: {
    Tooltip: Wo
  },
  enums: {
    UserLicense: _p
  },
  data() {
    return {
      busy: !0,
      loadingAccounts: !0,
      accountEdit: void 0,
      newLink: {
        idxDataAccess: !1,
        license: _p.None,
        roleName: "User"
      },
      accountDelete: void 0
    };
  },
  computed: {
    hasAvailableLicense() {
      var e, t, s, n;
      return ((e = this.licenseReport) == null ? void 0 : e.propertySuiteProUsed) < ((t = this.licenseReport) == null ? void 0 : t.propertySuitePro) || ((s = this.licenseReport) == null ? void 0 : s.rosterMemberOnlyUsed) < ((n = this.licenseReport) == null ? void 0 : n.rosterMemberOnly);
    },
    needsAdditionalLicense() {
      var e, t, s, n;
      return ((e = this.licenseReport) == null ? void 0 : e.propertySuiteProUsed) > ((t = this.licenseReport) == null ? void 0 : t.propertySuitePro) || ((s = this.licenseReport) == null ? void 0 : s.rosterMemberOnlyUsed) > ((n = this.licenseReport) == null ? void 0 : n.rosterMemberOnly);
    },
    canAdd() {
      return this.newLink && this.newLink.firstName != null && this.newLink.email != null;
    },
    addButtonStyle() {
      return {
        "btn-accent-glass": this.canAdd,
        "btn-secondary": !this.canAdd
      };
    },
    inviteTooltip() {
      return this.hasAvailableLicense ? "Resend invite" : "No available licenses";
    },
    ...at(Te, ct),
    ...q(Te, ["access", "aclLoaded", "isClient", "isAdmin", "isUser", "hasInvestmentGatewayFeature"]),
    ...q(ct, ["parentAccount", "subAccounts", "licenseReport"])
  },
  methods: {
    currency: Ze,
    number: Ve,
    badgeStyle(e) {
      return {
        badge: !0,
        "text-capitalize": !0,
        "text-bg-success": e.status == "accepted",
        "text-bg-warning": e.status == "pending"
      };
    },
    async loadLinkedAccounts() {
      try {
        this.busy = !0, this.loadingAccounts = !0, await this.accountStore.fetchLicenseReport(), await this.accountStore.fetchSubAccounts();
      } catch (e) {
        Se(e);
      }
      this.busy = !1, this.loadingAccounts = !1;
    },
    showAddUserAccount() {
      var t;
      const e = this.$refs.dialogAddUserAccount;
      e && typeof bootstrap < "u" && ((t = bootstrap.Modal.getOrCreateInstance(e)) == null || t.show());
    },
    async addUserAccount(e) {
      try {
        Zt.clearModelStateErrors(e.target), this.busy = !0, await this.accountStore.addSubAccount(this.newLink), await this.accountStore.fetchLicenseReport(), bootstrap.Modal.getOrCreateInstance(this.$refs.dialogAddUserAccount).hide(), this.newLink = {
          idxDataAccess: !1,
          license: _p.None,
          roleName: "User"
        };
      } catch (t) {
        (!Zt.isModelStateException(t) || !t.showFormErrors(e.target)) && Se(t);
      }
      this.busy = !1;
    },
    showRemoveAccount(e) {
      Zt.clearModelStateErrors(this.$refs.dialogEditCompanyUserAccount), this.accountDelete = e, bootstrap.Modal.getOrCreateInstance(this.$refs.dialogRemoveCompanyUserAccount).show();
    },
    async removeLink(e) {
      try {
        this.busy = !0, await this.accountStore.removeSubAccount(e), await this.accountStore.fetchLicenseReport(), bootstrap.Modal.getOrCreateInstance(this.$refs.dialogRemoveCompanyUserAccount).hide();
      } catch (t) {
        (!Zt.isModelStateException(t) || !t.showFormErrors(this.$refs.dialogRemoveCompanyUserAccount)) && Se(t);
      } finally {
        this.busy = !1;
      }
    },
    async sendInvite(e) {
      try {
        this.busy = !0, Zt.clearModelStateErrors(this.$refs.teamMembersContainer), await this.accountStore.sendSubAccountInvite(e), wt("Invite sent");
      } catch (t) {
        (!Zt.isModelStateException(t) || !t.showFormErrors(this.$refs.teamMembersContainer)) && Se(t);
      }
      this.busy = !1;
    },
    showEditAccount(e) {
      Zt.clearModelStateErrors(this.$refs.dialogEditCompanyUserAccount), this.accountEdit = {
        ...e
      }, bootstrap.Modal.getOrCreateInstance(this.$refs.dialogEditCompanyUserAccount).show();
    },
    async editAccount(e) {
      try {
        Zt.clearModelStateErrors(e), this.busy = !0, await this.accountStore.updateAccount(this.accountEdit), await this.accountStore.fetchLicenseReport(), await this.accountStore.fetchAgentRoster(), await this.accountStore.fetchProspectiveAgentRoster(), bootstrap.Modal.getOrCreateInstance(this.$refs.dialogEditCompanyUserAccount).hide(), this.accountEdit = void 0;
      } catch (t) {
        (!Zt.isModelStateException(t) || !t.showFormErrors(e)) && Se(t);
      }
      this.busy = !1;
    },
    addUserLicense() {
      this.$emit("addUserLicense");
    }
  },
  mounted() {
    this.aclLoaded.then(() => this.loadLinkedAccounts());
  }
}), DK = { class: "fw-bold fs-3 mb-4" }, NK = { class: "row row-cols-1 g-3" }, jK = { class: "col" }, HK = { class: "card shadow-sm" }, UK = { class: "card-header d-flex bg-transparent border-0 pb-0" }, zK = { class: "fw-bold" }, WK = { class: "card-body d-flex gap-2 text-center" }, GK = { class: "bg-light rounded p-2 flex-fill" }, YK = { class: "bg-light rounded p-2 flex-fill" }, XK = { class: "col" }, qK = {
  ref: "teamMembersContainer",
  class: "card shadow-sm overflow-hidden"
}, QK = { class: "card-header d-flex bg-transparent border-0" }, KK = {
  key: 0,
  class: "alert alert-warning mb-0 pt-1 pb-1"
}, ZK = { class: "d-flex ms-auto align-items-center" }, JK = ["disabled"], $K = ["disabled"], _K = {
  key: 0,
  class: "position-absolute top-0 bottom-0 w-100 h-100 d-flex align-items-center justify-content-center bg-white opacity-75 z-10"
}, eZ = {
  key: 1,
  class: "table-responsive"
}, tZ = { class: "table" }, sZ = { key: 0 }, aZ = { class: "d-flex align-items-center" }, nZ = { class: "flex-shrink-0" }, rZ = { class: "avatar rounded-circle overflow-hidden" }, oZ = ["src", "alt"], iZ = { class: "flex-grow-1 ms-3" }, lZ = { class: "d-flex justify-content-start align-items-center" }, dZ = {
  class: "text-truncate fw-bold me-2",
  style: { "max-width": "350px" }
}, cZ = { class: "text-body-secondary" }, uZ = { key: 0 }, pZ = {
  key: 0,
  class: "d-flex gap-2 justify-content-end"
}, hZ = ["disabled", "onClick"], mZ = ["onClick", "disabled"], fZ = ["onClick"], gZ = {
  key: 2,
  class: "card-body text-center"
}, vZ = {
  ref: "dialogAddUserAccount",
  class: "modal fade",
  id: "dialogAddUserAccount",
  tabindex: "-1",
  "aria-labelledby": "dialogAddCompanyUserAccountLabel",
  "aria-hidden": "true"
}, yZ = { class: "modal-dialog modal-dialog-centered" }, bZ = { class: "modal-content bg-gradient-alphabet rounded" }, AZ = { class: "modal-header border-0" }, wZ = {
  class: "modal-title fs-5 fw-bold",
  id: "dialogAddCompanyUserAccountLabel"
}, CZ = { class: "modal-body" }, SZ = { class: "row mb-3" }, PZ = {
  for: "accountName",
  class: "col-form-label col-sm-4"
}, kZ = { class: "col-sm-8" }, EZ = ["disabled"], IZ = { class: "row mb-3" }, TZ = {
  for: "accountEmail",
  class: "col-form-label col-sm-4"
}, OZ = { class: "col-sm-8" }, RZ = { class: "input-group" }, LZ = ["disabled"], BZ = { class: "row mb-3" }, MZ = { class: "col-sm-8" }, xZ = ["disabled"], FZ = { class: "row mb-3" }, VZ = { class: "col-sm-8" }, DZ = ["disabled"], NZ = ["value"], jZ = ["value", "disabled"], HZ = ["value", "disabled"], UZ = {
  key: 0,
  class: "row"
}, zZ = { class: "col-sm-8" }, WZ = { class: "form-check form-switch form-switch-double" }, GZ = ["disabled"], YZ = { class: "modal-footer border-0 justify-content-between" }, XZ = ["disabled"], qZ = ["disabled"], QZ = {
  class: "modal fade",
  ref: "dialogEditCompanyUserAccount",
  id: "dialogEditCompanyUserAccount",
  tabindex: "-1",
  "aria-labelledby": "dialogEditCompanyUserAccountLabel",
  "aria-hidden": "true"
}, KZ = { class: "modal-dialog modal-dialog-centered" }, ZZ = { class: "modal-content bg-gradient-alphabet rounded" }, JZ = {
  key: 0,
  class: "modal-body"
}, $Z = { class: "bg-white bg-opacity-50 rounded p-3 text-center mb-3" }, _Z = { class: "fw-bold fs-5" }, eJ = { class: "row mb-3" }, tJ = { class: "col-sm-8" }, sJ = ["disabled"], aJ = { class: "row mb-3" }, nJ = { class: "col-sm-8" }, rJ = ["disabled"], oJ = ["value"], iJ = ["value"], lJ = ["value"], dJ = {
  key: 0,
  class: "row"
}, cJ = { class: "col-sm-8" }, uJ = { class: "form-check form-switch form-switch-double" }, pJ = ["disabled"], hJ = { class: "modal-footer border-0 justify-content-between" }, mJ = ["disabled"], fJ = ["disabled"], gJ = {
  key: 0,
  class: "fa-duotone fa-solid fa-spinner fa-spin me-2"
}, vJ = {
  key: 1,
  class: "fa-light fa-save me-2"
}, yJ = {
  ref: "dialogRemoveCompanyUserAccount",
  class: "modal fade",
  id: "dialogRemoveCompanyUserAccount",
  tabindex: "-1",
  "aria-labelledby": "dialogRemoveCompanyUserAccountLabel",
  "aria-hidden": "true"
}, bJ = { class: "modal-dialog modal-dialog-centered" }, AJ = { class: "modal-content bg-gradient-alphabet rounded" }, wJ = { class: "modal-body text-center px-5 pb-5 pt-4" }, CJ = { class: "fs-5" }, SJ = { class: "d-flex gap-3 justify-content-center pt-3" }, PJ = ["disabled"], kJ = ["disabled"];
function EJ(e, t, s, n, r, i) {
  var l, d, c, u, m, f, v, b, w, S, I, T, x, k;
  const o = Za("tooltip");
  return p(), h(A, null, [
    a("h2", DK, g(e.$t("Company Team Members")), 1),
    a("div", NK, [
      a("div", jK, [
        a("div", HK, [
          a("div", UK, [
            a("span", zK, g(e.$t("User License Utilization")), 1)
          ]),
          a("div", WK, [
            a("div", GK, [
              t[14] || (t[14] = y(" Property Suite Pro: ")),
              a("b", null, g(e.number((l = e.licenseReport) == null ? void 0 : l.propertySuiteProUsed)) + "/" + g(e.number((d = e.licenseReport) == null ? void 0 : d.propertySuitePro)), 1)
            ]),
            a("div", YK, [
              e.hasInvestmentGatewayFeature ? (p(), h(A, { key: 0 }, [
                t[15] || (t[15] = y(" Roster Member Only: ")),
                a("b", null, g(e.number((c = e.licenseReport) == null ? void 0 : c.rosterMemberOnlyUsed)) + "/" + g(e.number((u = e.licenseReport) == null ? void 0 : u.rosterMemberOnly)), 1)
              ], 64)) : P("", !0)
            ])
          ])
        ])
      ]),
      a("div", XK, [
        a("div", qK, [
          a("div", QK, [
            !e.loadingAccounts && !e.hasAvailableLicense ? (p(), h("span", KK, "All available user licenses assigned. Please add additional licenses.")) : P("", !0),
            a("div", ZK, [
              V((p(), h("button", {
                type: "button",
                class: "btn btn-outline-secondary btn-sm me-2",
                onClick: t[0] || (t[0] = (...C) => e.loadLinkedAccounts && e.loadLinkedAccounts(...C)),
                disabled: e.busy || e.loadingAccounts
              }, t[16] || (t[16] = [
                a("i", { class: "fa fa-refresh" }, null, -1)
              ]), 8, JK)), [
                [
                  o,
                  "Refresh list",
                  void 0,
                  { top: !0 }
                ]
              ]),
              e.hasAvailableLicense ? (p(), h("button", {
                key: 0,
                type: "button",
                class: "btn btn-success btn-sm",
                onClick: t[1] || (t[1] = (...C) => e.showAddUserAccount && e.showAddUserAccount(...C)),
                disabled: !e.hasAvailableLicense
              }, t[17] || (t[17] = [
                a("i", { class: "fa-light fa-plus me-2" }, null, -1),
                y("Add Member")
              ]), 8, $K)) : (p(), h("button", {
                key: 1,
                type: "button",
                class: "btn btn-success btn-sm ms-auto",
                onClick: t[2] || (t[2] = (...C) => e.addUserLicense && e.addUserLicense(...C))
              }, [
                t[18] || (t[18] = a("i", { class: "fa-light fa-plus me-2" }, null, -1)),
                y(g(e.$t("Add licenses")), 1)
              ]))
            ])
          ]),
          e.busy ? (p(), h("div", _K, t[19] || (t[19] = [
            a("div", { class: "bg-accentgreenblue rounded-pill px-3 py-1 text-white" }, [
              a("span", {
                class: "spinner-border spinner-border-sm me-2",
                role: "status",
                "aria-hidden": "false"
              }),
              y("Loading ")
            ], -1)
          ]))) : P("", !0),
          e.loadingAccounts ? (p(), h("div", gZ, [
            t[25] || (t[25] = a("i", { class: "fa-duotone fa-solid fa-compass fa-spin me-2" }, null, -1)),
            y(g(e.$t("t-loading-user-accounts")), 1)
          ])) : (p(), h("div", eZ, [
            t[24] || (t[24] = a("div", {
              class: "alert alert-danger m-3 d-none",
              "data-val-summary": ""
            }, null, -1)),
            a("table", tZ, [
              a("thead", null, [
                a("tr", null, [
                  a("th", null, g(e.$t("Team Member")), 1),
                  a("th", null, g(e.$t("Privileges")), 1),
                  e.hasInvestmentGatewayFeature ? (p(), h("th", sZ, g(e.$t("IDX")), 1)) : P("", !0),
                  a("th", null, g(e.$t("User License")), 1),
                  t[20] || (t[20] = a("th", null, null, -1))
                ])
              ]),
              a("tbody", null, [
                (p(!0), h(A, null, D(e.subAccounts, (C) => (p(), h("tr", {
                  key: C.id
                }, [
                  a("td", null, [
                    a("div", aZ, [
                      a("div", nZ, [
                        a("div", rZ, [
                          a("img", {
                            src: C.photo,
                            alt: C.firstName,
                            class: "avatar-img"
                          }, null, 8, oZ)
                        ])
                      ]),
                      a("div", iZ, [
                        a("div", lZ, [
                          a("div", dZ, [
                            y(g(C.firstName) + " " + g(C.lastName) + " ", 1),
                            C.status == "pending" ? (p(), h("span", {
                              key: 0,
                              class: z(["ms-1", e.badgeStyle(C)])
                            }, g(C.status), 3)) : P("", !0)
                          ])
                        ]),
                        a("small", cZ, g(C.email), 1)
                      ])
                    ])
                  ]),
                  a("td", null, g(C.roleName), 1),
                  e.hasInvestmentGatewayFeature ? (p(), h("td", uZ, [
                    C.idxDataAccess ? (p(), h(A, { key: 0 }, [
                      y(" Yes ")
                    ], 64)) : (p(), h(A, { key: 1 }, [
                      y(" No ")
                    ], 64))
                  ])) : P("", !0),
                  a("td", null, [
                    C.license == e.UserLicense.PropertySuitePro ? (p(), h(A, { key: 0 }, [
                      y(" Property Suite Pro ")
                    ], 64)) : C.license == e.UserLicense.RosterMemberOnly ? (p(), h(A, { key: 1 }, [
                      y(" Roster Member Only ")
                    ], 64)) : (p(), h(A, { key: 2 }, [
                      y(" None ")
                    ], 64))
                  ]),
                  a("td", null, [
                    C.roleName != "Account Owner" ? (p(), h("div", pZ, [
                      e.isUser ? P("", !0) : V((p(), h("button", {
                        key: 0,
                        type: "button",
                        disabled: e.busy,
                        class: "btn btn-outline-danger btn-sm",
                        onClick: (O) => e.showRemoveAccount(C)
                      }, t[21] || (t[21] = [
                        a("i", { class: "fa-light fa-link-slash" }, null, -1)
                      ]), 8, hZ)), [
                        [
                          o,
                          "Remove account link...",
                          void 0,
                          { top: !0 }
                        ]
                      ]),
                      C.status == "pending" ? V((p(), h("button", {
                        key: 1,
                        type: "button",
                        onClick: (O) => e.sendInvite(C),
                        disabled: e.busy || e.needsAdditionalLicense,
                        class: "btn btn-outline-eclipse btn-sm"
                      }, t[22] || (t[22] = [
                        a("i", { class: "fa-light fa-envelope" }, null, -1)
                      ]), 8, mZ)), [
                        [
                          o,
                          e.inviteTooltip,
                          void 0,
                          { top: !0 }
                        ]
                      ]) : V((p(), h("button", {
                        key: 2,
                        class: "btn btn-outline-eclipse btn-sm",
                        onClick: (O) => e.showEditAccount(C)
                      }, t[23] || (t[23] = [
                        a("i", { class: "fa-light fa-pencil" }, null, -1)
                      ]), 8, fZ)), [
                        [
                          o,
                          "Edit",
                          void 0,
                          { top: !0 }
                        ]
                      ])
                    ])) : P("", !0)
                  ])
                ]))), 128))
              ])
            ])
          ]))
        ], 512)
      ])
    ]),
    a("div", vZ, [
      a("div", yZ, [
        a("div", bZ, [
          a("div", AZ, [
            a("p", wZ, g(e.$t("Add Member")), 1),
            t[26] || (t[26] = a("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            }, null, -1))
          ]),
          a("div", CZ, [
            a("div", SZ, [
              a("label", PZ, g(e.$t("t-name")), 1),
              a("div", kZ, [
                V(a("input", {
                  type: "text",
                  "onUpdate:modelValue": t[3] || (t[3] = (C) => e.newLink.firstName = C),
                  class: "form-control",
                  disabled: e.busy,
                  id: "firstName"
                }, null, 8, EZ), [
                  [_e, e.newLink.firstName]
                ])
              ])
            ]),
            a("div", IZ, [
              a("label", TZ, g(e.$t("t-email")), 1),
              a("div", OZ, [
                a("div", RZ, [
                  t[27] || (t[27] = a("span", { class: "input-group-text" }, [
                    a("i", { class: "fa-light fa-envelope" })
                  ], -1)),
                  V(a("input", {
                    id: "email",
                    type: "email",
                    "onUpdate:modelValue": t[4] || (t[4] = (C) => e.newLink.email = C),
                    class: "form-control",
                    disabled: e.busy
                  }, null, 8, LZ), [
                    [_e, e.newLink.email]
                  ])
                ])
              ])
            ]),
            a("div", BZ, [
              t[29] || (t[29] = a("label", {
                for: "accountPrivileges",
                class: "col-form-label col-sm-4"
              }, "Privileges", -1)),
              a("div", MZ, [
                V(a("select", {
                  id: "roleName",
                  class: "form-select",
                  "onUpdate:modelValue": t[5] || (t[5] = (C) => e.newLink.roleName = C),
                  disabled: e.busy
                }, t[28] || (t[28] = [
                  a("option", { value: "Admin" }, "Admin", -1),
                  a("option", { value: "User" }, "User", -1)
                ]), 8, xZ), [
                  [We, e.newLink.roleName]
                ])
              ])
            ]),
            a("div", FZ, [
              t[30] || (t[30] = a("label", {
                for: "accountUserLicense",
                class: "col-form-label col-sm-4"
              }, "User License", -1)),
              a("div", VZ, [
                V(a("select", {
                  class: "form-select",
                  "onUpdate:modelValue": t[6] || (t[6] = (C) => e.newLink.license = C),
                  id: "license",
                  disabled: e.busy
                }, [
                  a("option", {
                    value: e.UserLicense.None
                  }, "None", 8, NZ),
                  a("option", {
                    value: e.UserLicense.PropertySuitePro,
                    disabled: e.number(((m = e.licenseReport) == null ? void 0 : m.propertySuiteProUsed) ?? 0) >= e.number(((f = e.licenseReport) == null ? void 0 : f.propertySuitePro) ?? 0)
                  }, "Property Suite Pro", 8, jZ),
                  e.hasInvestmentGatewayFeature ? (p(), h("option", {
                    key: 0,
                    value: e.UserLicense.RosterMemberOnly,
                    disabled: e.number(((v = e.licenseReport) == null ? void 0 : v.rosterMemberOnlyUsed) ?? 0) >= e.number(((b = e.licenseReport) == null ? void 0 : b.rosterMemberOnly) ?? 0)
                  }, "Roster Member Only", 8, HZ)) : P("", !0)
                ], 8, DZ), [
                  [We, e.newLink.license]
                ])
              ])
            ]),
            e.hasInvestmentGatewayFeature ? (p(), h("div", UZ, [
              t[32] || (t[32] = a("label", {
                for: "accountIdxDataAccess",
                class: "form-label col-sm-4"
              }, "IDX Data Access", -1)),
              a("div", zZ, [
                a("div", WZ, [
                  V(a("input", {
                    class: "form-check-input",
                    type: "checkbox",
                    role: "switch",
                    id: "idxDataAccess",
                    "onUpdate:modelValue": t[7] || (t[7] = (C) => e.newLink.idxDataAccess = C),
                    disabled: e.busy
                  }, null, 8, GZ), [
                    [Ue, e.newLink.idxDataAccess]
                  ]),
                  t[31] || (t[31] = a("label", {
                    class: "form-check-label",
                    for: "idxDataAccess"
                  }, [
                    y("Yes"),
                    a("span", null, "No")
                  ], -1))
                ])
              ])
            ])) : P("", !0)
          ]),
          a("div", YZ, [
            a("button", {
              type: "button",
              class: "btn btn-outline-secondary",
              "data-bs-dismiss": "modal",
              disabled: e.busy
            }, g(e.$t("Close")), 9, XZ),
            a("button", {
              type: "button",
              "data-working": "Adding",
              class: z(["btn", e.addButtonStyle]),
              onClick: t[8] || (t[8] = (...C) => e.addUserAccount && e.addUserAccount(...C)),
              disabled: !e.canAdd || e.busy
            }, g(e.$t("t-invite")), 11, qZ)
          ])
        ])
      ])
    ], 512),
    a("div", QZ, [
      a("div", KZ, [
        a("div", ZZ, [
          t[40] || (t[40] = a("div", { class: "modal-header border-0 pb-0" }, [
            a("p", {
              class: "modal-title fs-5 fw-bold",
              id: "dialogEditCompanyUserAccountLabel"
            }, "Edit Company User Account"),
            a("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            })
          ], -1)),
          e.accountEdit ? (p(), h("div", JZ, [
            t[39] || (t[39] = a("div", {
              class: "alert alert-warning d-none",
              "data-val-summary": ""
            }, " There seems to be an issue. Please try again. ", -1)),
            a("div", $Z, [
              a("span", _Z, g(e.accountEdit.firstName) + " " + g(e.accountEdit.lastName), 1),
              t[33] || (t[33] = a("br", null, null, -1)),
              a("span", null, g(e.accountEdit.email), 1)
            ]),
            a("div", eJ, [
              t[35] || (t[35] = a("label", {
                for: "roleName",
                class: "col-form-label col-sm-4"
              }, "Privileges", -1)),
              a("div", tJ, [
                V(a("select", {
                  class: "form-select",
                  "onUpdate:modelValue": t[9] || (t[9] = (C) => e.accountEdit.roleName = C),
                  id: "roleName",
                  disabled: e.busy
                }, t[34] || (t[34] = [
                  a("option", { value: "Admin" }, "Admin", -1),
                  a("option", { value: "User" }, "User", -1)
                ]), 8, sJ), [
                  [We, e.accountEdit.roleName]
                ])
              ])
            ]),
            a("div", aJ, [
              t[36] || (t[36] = a("label", {
                for: "license",
                class: "col-form-label col-sm-4"
              }, "User License", -1)),
              a("div", nJ, [
                V(a("select", {
                  class: "form-select",
                  "onUpdate:modelValue": t[10] || (t[10] = (C) => e.accountEdit.license = C),
                  id: "license",
                  disabled: e.busy
                }, [
                  a("option", {
                    value: e.UserLicense.None
                  }, "None", 8, oJ),
                  e.accountEdit.license == e.UserLicense.PropertySuitePro || (((w = e.licenseReport) == null ? void 0 : w.propertySuiteProUsed) ?? 0) <= (((S = e.licenseReport) == null ? void 0 : S.propertySuitePro) ?? 0) ? (p(), h("option", {
                    key: 0,
                    value: e.UserLicense.PropertySuitePro
                  }, "Property Suite Pro", 8, iJ)) : P("", !0),
                  e.accountEdit.license == e.UserLicense.RosterMemberOnly || (((I = e.licenseReport) == null ? void 0 : I.rosterMemberOnlyUsed) ?? 0) <= (((T = e.licenseReport) == null ? void 0 : T.rosterMemberOnly) ?? 0) ? (p(), h("option", {
                    key: 1,
                    value: e.UserLicense.RosterMemberOnly
                  }, "Roster Member Only", 8, lJ)) : P("", !0)
                ], 8, rJ), [
                  [We, e.accountEdit.license]
                ])
              ])
            ]),
            e.hasInvestmentGatewayFeature ? (p(), h("div", dJ, [
              t[38] || (t[38] = a("label", {
                for: "idxDataAccess",
                class: "form-label col-sm-4"
              }, "IDX Data Access", -1)),
              a("div", cJ, [
                a("div", uJ, [
                  V(a("input", {
                    class: "form-check-input",
                    type: "checkbox",
                    role: "switch",
                    id: "idxDataAccess",
                    "onUpdate:modelValue": t[11] || (t[11] = (C) => e.accountEdit.idxDataAccess = C),
                    disabled: e.busy
                  }, null, 8, pJ), [
                    [Ue, e.accountEdit.idxDataAccess]
                  ]),
                  t[37] || (t[37] = a("label", {
                    class: "form-check-label",
                    for: "idxDataAccess"
                  }, [
                    y("Yes"),
                    a("span", null, "No")
                  ], -1))
                ])
              ])
            ])) : P("", !0)
          ])) : P("", !0),
          a("div", hJ, [
            a("button", {
              type: "button",
              class: "btn btn-outline-secondary",
              "data-bs-dismiss": "modal",
              disabled: e.busy
            }, g(e.$t("Close")), 9, mJ),
            a("button", {
              type: "button",
              class: "btn btn-success",
              onClick: t[12] || (t[12] = (C) => e.editAccount(e.$refs.dialogEditCompanyUserAccount)),
              disabled: e.busy
            }, [
              e.busy ? (p(), h("i", gJ)) : (p(), h("i", vJ)),
              y(g(e.$t("Save Changes")), 1)
            ], 8, fJ)
          ])
        ])
      ])
    ], 512),
    a("div", yJ, [
      a("div", bJ, [
        a("div", AJ, [
          t[45] || (t[45] = a("div", { class: "modal-header border-0" }, [
            a("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            })
          ], -1)),
          a("div", wJ, [
            t[41] || (t[41] = a("i", { class: "fa-duotone fa-link-slash mb-3 fa-3xl" }, null, -1)),
            t[42] || (t[42] = a("br", null, null, -1)),
            a("b", CJ, g(e.$t("Remove Team Member")), 1),
            t[43] || (t[43] = a("br", null, null, -1)),
            t[44] || (t[44] = a("br", null, null, -1)),
            a("p", null, "Are you sure you want to remove " + g((x = e.accountDelete) == null ? void 0 : x.firstName) + " " + g((k = e.accountDelete) == null ? void 0 : k.lastName) + " from the company account?", 1),
            a("div", SJ, [
              a("button", {
                type: "button",
                class: "btn btn-outline-secondary",
                "data-bs-dismiss": "modal",
                disabled: e.busy
              }, g(e.$t("Cancel")), 9, PJ),
              a("button", {
                type: "button",
                class: z(["btn", e.addButtonStyle]),
                onClick: t[13] || (t[13] = (C) => e.removeLink(e.accountDelete)),
                disabled: e.busy
              }, g(e.$t("t-yes-remove")), 11, kJ)
            ])
          ])
        ])
      ])
    ], 512)
  ], 64);
}
const Gis = /* @__PURE__ */ Ae(VK, [["render", EJ]]), IJ = me({
  name: "CompanyBranding",
  props: {},
  components: {
    ContentLoader: Sa,
    Cropper: yb,
    BrandingPreview: jk
  },
  data() {
    return {
      companyLogo: void 0,
      imageHeight: void 0,
      previewBranding: !1,
      companyLogoDark: !1
    };
  },
  computed: {
    companyLogoName() {
      return this.companyLogo ? this.companyLogo.name : "Choose file";
    },
    canManageCompanyBranding() {
      return this.isUser != !0;
    },
    companyLogoPhotoUrl() {
      return this.companyLogo ? URL.createObjectURL(this.companyLogo) : "";
    },
    cropperStyle() {
      return {
        "avatar-crop-company rounded overflow-hidden": !0,
        dark: this.companyLogoDark,
        light: !this.companyLogoDark
      };
    },
    ...at(Te, ct),
    ...q(Te, ["access", "aclLoaded", "isClient", "isAdmin", "isUser"]),
    ...q(ct, ["myBranding", "brandingLoading"])
  },
  methods: {
    async loadBranding() {
      try {
        await this.accountStore.fetchMyBranding();
      } catch (e) {
        Se(e);
      }
    },
    async updateBranding(e) {
      try {
        await this.accountStore.updateBranding(), wt("Company branding has been updated.");
      } catch (t) {
        (!Zt.isModelStateException(t) || !t.showFormErrors(e.target)) && Se(t);
      }
    },
    async updateCompanyLogo(e) {
      var t;
      try {
        this.myBranding.updated || await this.accountStore.updateBranding();
        const s = this.$refs.cropper.getResult(), n = await this.accountStore.updateCompanyLogo(this.companyLogo, s.coordinates.width, s.coordinates.height, s.coordinates.top, s.coordinates.left, this.companyLogoDark);
        (t = bootstrap.Modal.getOrCreateInstance(this.$refs.mymodal)) == null || t.hide();
      } catch (s) {
        (!Zt.isModelStateException(s) || !s.showFormErrors(e.target)) && Se(s);
      }
    },
    handleCompanyLogoFile(e) {
      this.companyLogo = e.target.files[0];
    },
    editCompanyLogo(e = !1) {
      var t;
      this.companyLogo = void 0, this.companyLogoDark = e == !0, this.$refs.mymodal.addEventListener("shown.bs.modal", () => {
        this.$refs.cropper && this.$refs.cropper.refresh();
      }), this.$refs.cropper.reset(), this.$refs.logoFile.value = "", (t = bootstrap.Modal.getOrCreateInstance(this.$refs.mymodal)) == null || t.show();
    },
    imageLoaded() {
      var t;
      Zt.clearModelStateErrors();
      const e = this.$refs.cropper.getResult();
      this.imageHeight = (t = e == null ? void 0 : e.image) == null ? void 0 : t.height, this.imageHeight && this.imageHeight < 150 && Zt.setFieldInvalid(this.$refs.logoFile, `Image is too small, it's height is ${this.imageHeight}px. Please upload an image that is at least 150px in height.`);
    }
  },
  mounted() {
    this.aclLoaded.then(() => this.loadBranding());
  }
}), TJ = { class: "row mb-3" }, OJ = { class: "col-xl-7" }, RJ = { class: "fw-bold fs-3 mb-0" }, LJ = { class: "col text-end" }, BJ = { key: 0 }, MJ = {
  class: "row mb-4",
  id: "brandingCompanyData"
}, xJ = { class: "col" }, FJ = { class: "card shadow-sm" }, VJ = { class: "row g-0" }, DJ = { class: "col-md-6" }, NJ = { class: "p-3" }, jJ = {
  class: "p-4 border rounded d-flex justify-content-center align-items-center position-relative",
  style: { "min-height": "150px", "max-height": "150px" }
}, HJ = ["disabled"], UJ = ["src"], zJ = {
  key: 2,
  src: "https://images.rescover.com/widgets/content/images/default-business-avatar.jpg",
  class: "img-fluid",
  height: "150",
  width: "150"
}, WJ = { class: "col-md-6 border-start-md" }, GJ = { class: "p-3" }, YJ = {
  class: "p-4 bg-eclipse rounded d-flex justify-content-center align-items-center position-relative",
  style: { "min-height": "150px", "max-height": "150px" }
}, XJ = ["disabled"], qJ = ["src"], QJ = {
  key: 2,
  src: "https://images.rescover.com/widgets/content/images/default-business-avatar.jpg",
  class: "img-fluid",
  height: "150",
  width: "150"
}, KJ = { class: "col-12 border-top" }, ZJ = { class: "card-body" }, JJ = { class: "mb-3" }, $J = {
  for: "bCompany",
  class: "form-label"
}, _J = ["disabled"], e$ = { class: "mb-3" }, t$ = {
  for: "website",
  class: "form-label"
}, s$ = { class: "input-group" }, a$ = ["disabled"], n$ = { class: "d-flex justify-content-between align-items-center gap-4" }, r$ = {
  key: 0,
  class: "alert alert-warning m-0 flex-fill p-2",
  role: "alert"
}, o$ = { class: "form-group m-0" }, i$ = { class: "form-check" }, l$ = ["disabled"], d$ = ["disabled"], c$ = {
  ref: "mymodal",
  class: "modal fade",
  id: "modalCompanyLogo",
  tabindex: "-1",
  "aria-labelledby": "modalCompanyLogoLabel",
  "aria-hidden": "true"
}, u$ = { class: "modal-dialog modal-dialog-centered" }, p$ = { class: "modal-content bg-gradient-alphabet rounded" }, h$ = { class: "modal-header border-0 pb-0" }, m$ = {
  class: "fw-bold fs-5 modal-title",
  id: "modalCompanyLogoLabel"
}, f$ = ["disabled"], g$ = { class: "modal-body" }, v$ = { class: "d-flex justify-content-center mb-3" }, y$ = {
  class: "form-label",
  for: "companyLogoFile",
  "aria-describedby": "inputGroupFileAddon02"
}, b$ = ["disabled"], A$ = { class: "text-secondary text-small" }, w$ = { class: "modal-footer border-0" }, C$ = ["disabled"], S$ = ["disabled"], P$ = {
  key: 1,
  class: "row"
}, k$ = { class: "col" };
function E$(e, t, s, n, r, i) {
  var c, u;
  const o = pe("branding-preview"), l = pe("Cropper"), d = pe("content-loader");
  return p(), h(A, null, [
    a("div", TJ, [
      a("div", OJ, [
        a("h2", RJ, g(e.$t("t-branding-information")), 1)
      ]),
      a("div", LJ, [
        a("button", {
          type: "button",
          class: "btn btn-outline-eclipse btn-sm",
          onClick: t[0] || (t[0] = (m) => e.previewBranding = !0)
        }, [
          t[10] || (t[10] = a("i", { class: "fa-thin fa-user-tie me-2" }, null, -1)),
          y(g(e.$t("t-show-branding-preview")), 1)
        ])
      ])
    ]),
    e.myBranding ? (p(), h("div", BJ, [
      a("div", MJ, [
        a("div", xJ, [
          a("div", FJ, [
            a("div", VJ, [
              a("div", DJ, [
                a("div", NJ, [
                  t[12] || (t[12] = a("p", { class: "fw-bold" }, "Dark Logo - Light Background", -1)),
                  a("div", jJ, [
                    e.canManageCompanyBranding ? (p(), h("button", {
                      key: 0,
                      type: "button",
                      onClick: t[1] || (t[1] = (m) => e.editCompanyLogo(!1)),
                      class: "btn btn-eclipse rounded-circle position-absolute top-0 start-100 translate-middle",
                      disabled: e.brandingLoading
                    }, t[11] || (t[11] = [
                      a("i", { class: "fa-light fa-pencil" }, null, -1)
                    ]), 8, HJ)) : P("", !0),
                    (c = e.myBranding) != null && c.hasCompanyLogo ? (p(), h("img", {
                      key: 1,
                      src: e.myBranding.companyLogoUrl,
                      class: "img-fluid",
                      height: "150",
                      width: "150"
                    }, null, 8, UJ)) : (p(), h("img", zJ))
                  ])
                ])
              ]),
              a("div", WJ, [
                a("div", GJ, [
                  t[14] || (t[14] = a("p", { class: "fw-bold" }, "Light Logo - Dark Background", -1)),
                  a("div", YJ, [
                    e.canManageCompanyBranding ? (p(), h("button", {
                      key: 0,
                      type: "button",
                      onClick: t[2] || (t[2] = (m) => e.editCompanyLogo(!0)),
                      class: "btn btn-eclipse rounded-circle position-absolute top-0 start-100 translate-middle",
                      disabled: e.brandingLoading
                    }, t[13] || (t[13] = [
                      a("i", { class: "fa-light fa-pencil" }, null, -1)
                    ]), 8, XJ)) : P("", !0),
                    (u = e.myBranding) != null && u.hasCompanyDarkLogo ? (p(), h("img", {
                      key: 1,
                      src: e.myBranding.companyDarkLogoUrl,
                      class: "img-fluid",
                      height: "150",
                      width: "150"
                    }, null, 8, qJ)) : (p(), h("img", QJ))
                  ])
                ])
              ]),
              a("div", KJ, [
                a("div", ZJ, [
                  a("div", JJ, [
                    a("label", $J, g(e.$t("t-company")), 1),
                    V(a("input", {
                      type: "text",
                      "onUpdate:modelValue": t[3] || (t[3] = (m) => e.myBranding.company = m),
                      class: "form-control",
                      id: "company",
                      maxlength: "150",
                      disabled: e.brandingLoading || !e.canManageCompanyBranding
                    }, null, 8, _J), [
                      [_e, e.myBranding.company]
                    ])
                  ]),
                  a("div", e$, [
                    a("label", t$, g(e.$t("t-website")), 1),
                    a("div", s$, [
                      t[15] || (t[15] = a("span", { class: "input-group-text" }, [
                        a("i", { class: "fa-light fa-globe" })
                      ], -1)),
                      V(a("input", {
                        type: "url",
                        "onUpdate:modelValue": t[4] || (t[4] = (m) => e.myBranding.website = m),
                        class: "form-control",
                        id: "website",
                        maxlength: "250",
                        disabled: e.brandingLoading || !e.canManageCompanyBranding
                      }, null, 8, a$), [
                        [_e, e.myBranding.website]
                      ])
                    ])
                  ]),
                  a("div", n$, [
                    e.canManageCompanyBranding ? (p(), h("div", r$, [
                      a("div", o$, [
                        a("div", i$, [
                          V(a("input", {
                            type: "checkbox",
                            "onUpdate:modelValue": t[5] || (t[5] = (m) => e.myBranding.enabled = m),
                            class: "form-check-input",
                            id: "enable",
                            disabled: e.brandingLoading
                          }, null, 8, l$), [
                            [Ue, e.myBranding.enabled]
                          ]),
                          t[16] || (t[16] = a("label", {
                            class: "form-check-label",
                            for: "enable"
                          }, " Enable Branding ", -1))
                        ])
                      ])
                    ])) : P("", !0),
                    e.canManageCompanyBranding ? (p(), h("button", {
                      key: 1,
                      type: "button",
                      onClick: t[6] || (t[6] = (...m) => e.updateBranding && e.updateBranding(...m)),
                      "data-validate": "#brandingCompanyData",
                      class: "btn btn-lava",
                      disabled: e.brandingLoading
                    }, g(e.$t("t-update-branding")), 9, d$)) : P("", !0)
                  ])
                ])
              ])
            ])
          ])
        ])
      ]),
      N(o, {
        show: e.previewBranding,
        "onUpdate:show": t[7] || (t[7] = (m) => e.previewBranding = m)
      }, null, 8, ["show"]),
      a("div", c$, [
        a("div", u$, [
          a("div", p$, [
            a("div", h$, [
              a("h1", m$, [
                t[17] || (t[17] = y("Company ")),
                e.companyLogoDark ? (p(), h(A, { key: 0 }, [
                  y("Dark")
                ], 64)) : P("", !0),
                t[18] || (t[18] = y(" Logo"))
              ]),
              a("button", {
                type: "button",
                class: "btn-close",
                "data-bs-dismiss": "modal",
                "aria-label": "Close",
                disabled: e.brandingLoading
              }, null, 8, f$)
            ]),
            a("div", g$, [
              a("div", v$, [
                N(l, {
                  ref: "cropper",
                  class: z(e.cropperStyle),
                  src: e.companyLogoPhotoUrl,
                  "stencil-props": { maxAspectRatio: 150 / 25 },
                  "min-height": 150,
                  onReady: e.imageLoaded,
                  disabled: e.brandingLoading
                }, null, 8, ["class", "src", "onReady", "disabled"])
              ]),
              a("div", null, [
                a("label", y$, g(e.companyLogoName), 1),
                a("input", {
                  ref: "logoFile",
                  type: "file",
                  onChange: t[8] || (t[8] = (...m) => e.handleCompanyLogoFile && e.handleCompanyLogoFile(...m)),
                  class: "form-control mb-1",
                  id: "companyLogoFile",
                  "data-val-id": "file",
                  disabled: e.brandingLoading
                }, null, 40, b$),
                a("span", A$, g(e.$t("t-company-photo-type")), 1)
              ])
            ]),
            a("div", w$, [
              a("button", {
                type: "button",
                class: "btn btn-secondary",
                "data-bs-dismiss": "modal",
                disabled: e.brandingLoading
              }, "Cancel", 8, C$),
              a("button", {
                type: "button",
                onClick: t[9] || (t[9] = (...m) => e.updateCompanyLogo && e.updateCompanyLogo(...m)),
                class: "btn btn-lava ms-auto",
                disabled: e.brandingLoading || !e.imageHeight || e.imageHeight < 150
              }, "Update Company Logo", 8, S$)
            ])
          ])
        ])
      ], 512)
    ])) : (p(), h("div", P$, [
      a("div", k$, [
        N(d, {
          width: 975,
          height: 732,
          speed: 2
        }, {
          default: ve(() => t[19] || (t[19] = [
            a("rect", {
              x: "0",
              y: "0",
              rx: "3",
              ry: "3",
              width: "975",
              height: "316"
            }, null, -1),
            a("rect", {
              x: "0",
              y: "396",
              rx: "3",
              ry: "3",
              width: "975",
              height: "336"
            }, null, -1)
          ])),
          _: 1,
          __: [19]
        })
      ])
    ]))
  ], 64);
}
const Yis = /* @__PURE__ */ Ae(IJ, [["render", E$]]);
var Bg, M2;
function I$() {
  return M2 || (M2 = 1, Bg = function e(t, s) {
    if (t === s) return !0;
    if (t && s && typeof t == "object" && typeof s == "object") {
      if (t.constructor !== s.constructor) return !1;
      var n, r, i;
      if (Array.isArray(t)) {
        if (n = t.length, n != s.length) return !1;
        for (r = n; r-- !== 0; )
          if (!e(t[r], s[r])) return !1;
        return !0;
      }
      if (t.constructor === RegExp) return t.source === s.source && t.flags === s.flags;
      if (t.valueOf !== Object.prototype.valueOf) return t.valueOf() === s.valueOf();
      if (t.toString !== Object.prototype.toString) return t.toString() === s.toString();
      if (i = Object.keys(t), n = i.length, n !== Object.keys(s).length) return !1;
      for (r = n; r-- !== 0; )
        if (!Object.prototype.hasOwnProperty.call(s, i[r])) return !1;
      for (r = n; r-- !== 0; ) {
        var o = i[r];
        if (!e(t[o], s[o])) return !1;
      }
      return !0;
    }
    return t !== t && s !== s;
  }), Bg;
}
var T$ = I$();
const Uk = /* @__PURE__ */ K1(T$), O$ = (e, t) => t.filter((s) => {
  const { text: n } = e;
  if (n === void 0) return !1;
  if (typeof s.rule == "string")
    return !new RegExp(s.rule).test(n);
  if (s.rule instanceof RegExp)
    return !s.rule.test(n);
  if ({}.toString.call(s.rule) === "[object Function]")
    return s.rule(e);
}).map((s) => s.classes), id = (e) => JSON.parse(JSON.stringify(e)), zk = (e, t, s = [], n) => {
  e.text === void 0 && (e = { text: e });
  const r = O$(e, s), i = t.findIndex((c) => c === e), o = id(t), l = i !== -1 ? o.splice(i, 1)[0] : id(e);
  return (n ? n(o, l) : o.map((c) => c.text).indexOf(l.text) !== -1) && r.push("ti-duplicate"), r.length === 0 ? r.push("ti-valid") : r.push("ti-invalid"), r;
}, Wl = (e, t, s = [], n) => {
  e.text === void 0 && (e = { text: e });
  const r = id(e);
  return r.tiClasses = zk(e, t, s), r;
}, R$ = (e, t = []) => e.map((s) => Wl(s, e, t)), L$ = me({
  name: "TagInput",
  props: {
    scope: {
      type: Object,
      required: !0
    }
  }
}), B$ = ["maxlength"];
function M$(e, t, s, n, r, i) {
  return e.scope.edit ? V((p(), h("input", {
    key: 0,
    "onUpdate:modelValue": t[0] || (t[0] = (o) => e.scope.tag.text = o),
    maxlength: e.scope.maxlength,
    type: "text",
    class: "ti-tag-input",
    size: "1",
    onInput: t[1] || (t[1] = (o) => e.scope.validateTag(e.scope.index, o)),
    onBlur: t[2] || (t[2] = (o) => e.scope.performCancelEdit(e.scope.index)),
    onKeydown: t[3] || (t[3] = (o) => e.scope.performSaveEdit(e.scope.index, o)),
    autocomplete: "off"
  }, null, 40, B$)), [
    [_e, e.scope.tag.text]
  ]) : P("", !0);
}
const x$ = /* @__PURE__ */ Ae(L$, [["render", M$], ["__scopeId", "data-v-1a0020c7"]]), x2 = (e) => !e.some((t) => {
  const s = !t.text;
  s && console.warn('Missing property "text"', t);
  let n = !1;
  return t.classes && (n = typeof t.classes != "string"), n && console.warn('Property "classes" must be type of string', t), s || n;
}), F2 = (e) => !e.some((t) => {
  if (typeof t == "number") {
    const s = isFinite(t) && Math.floor(t) === t;
    return s || console.warn("Only numerics are allowed for this prop. Found:", t), !s;
  } else if (typeof t == "string") {
    const s = /\W|[a-z]|!\d/i.test(t);
    return s || console.warn("Only alpha strings are allowed for this prop. Found:", t), !s;
  } else
    return console.warn("Only numeric and string values are allowed. Found:", t), !1;
}), F$ = {
  /**
   * @description Property to bind a model to the input.
     If the user changes the input value, the model updates, too.
     If the user presses enter with an valid input,
     a new tag is created with the value of this model.
     After creating the new tag, the model is cleared.
   * @property {props}
   * @required
   * @type {String}
   * @model
   * @default ''
   */
  modelValue: {
    type: String,
    default: "",
    required: !0
  },
  /**
   * @description Pass an array containing objects like in the example below.
     The properties 'style' and 'class' are optional. Of course it is possible to add custom
     properties to a tag object. vue-tags-input won't change the key and value.
   * @property {props}
   * @type {Array}
   * @sync
   * @default []
   * @example
    {
    &emsp;text: 'My tag value', &#47;* The visible text on display *&#47;
    &emsp;style: 'background-color: #ccc', &#47;* Adding inline styles is possible *&#47;
    &emsp;classes: 'custom-class another', &#47;* The value will be added as css classes *&#47;
    }
   */
  tags: {
    type: Object,
    default: () => [],
    validator: x2
  },
  /**
   * @description Expects an array containing objects inside. The objects
    can have the same properties as a tag object.
   * @property {props}
   * @type {Array}
   * @default []
   */
  autocompleteItems: {
    type: Array,
    default: () => [],
    validator: x2
  },
  /**
   * @description Defines whether a tag is editable after creation or not.
   * @property {props}
   * @type {Boolean}
   * @default false
   */
  allowEditTags: {
    type: Boolean,
    default: !1
  },
  /**
   * @description Defines if duplicate autocomplete items are filtered out from the view or not.
   * @property {props}
   * @type {Boolean}
   * @default true
   */
  autocompleteFilterDuplicates: {
    default: !0,
    type: Boolean
  },
  /**
   * @description If it's true, the user can add tags only via the autocomplete layer.
   * @property {props}
   * @type {Boolean}
   * @default false
   */
  addOnlyFromAutocomplete: {
    type: Boolean,
    default: !1
  },
  /**
   * @description The minimum character length which is required
     until the autocomplete layer is shown. If set to 0,
     then it'll be shown on focus.
   * @property {props}
   * @type {Number}
   * @default 1
   */
  autocompleteMinLength: {
    type: Number,
    default: 1
  },
  /**
   * @description If it's true, the autocomplete layer is always shown, regardless if
     an input or an autocomplete items exists.
   * @property {props}
   * @type {Boolean}
   * @default false
   */
  autocompleteAlwaysOpen: {
    type: Boolean,
    default: !1
  },
  /**
   * @description Property to disable vue-tags-input.
   * @property {props}
   * @type {Boolean}
   * @default false
   */
  disabled: {
    type: Boolean,
    default: !1
  },
  /**
   * @description The placeholder text which is shown in the input, when it's empty.
   * @property {props}
   * @type {String}
   * @default Add Tag
   */
  placeholder: {
    type: String,
    default: "Add Tag"
  },
  /**
   * @description Custom trigger key codes can be registrated. If the user presses one of these,
     a tag will be generated out of the input value. Can be either a numeric keyCode or the key
     as a string.
   * @property {props}
   * @type {Array}
   * @default [13]
   * @example add-on-key="[13, ':', ';']"
   */
  addOnKey: {
    type: Array,
    default: () => [13],
    validator: F2
  },
  /**
   * @description Custom trigger key codes can be registrated. If the user edits a tag
     and presses one of these, the edited tag will be saved.
     Can be either a numeric keyCode or the key as a string.
   * @property {props}
   * @type {Array}
   * @default [13]
   * @example save-on-key="[13, ':', ';']"
   */
  saveOnKey: {
    type: Array,
    default: () => [13],
    validator: F2
  },
  /**
   * @description The maximum amount the tags array is allowed to hold.
   * @property {props}
   * @type {Number}
   */
  maxTags: {
    type: Number
  },
  /**
   * @description The maximum amount of characters the input is allowed to hold.
   * @property {props}
   * @type {Number}
   */
  maxlength: {
    type: Number
  },
  /**
   * @description Pass an array containing objects like in the example below.
     The property 'classes' will be added as css classes, if the property 'rule' matches the text
     of a tag, an autocomplete item or the input. The property 'rule' can be type of
     RegExp or function. If the property 'disableAdd' is 'true', the item can't be added
     to the tags array, if the appropriated rule matches.
   * @property {props}
   * @type {Array}
   * @default []
   * @example
    {
    &ensp;classes: 'class', &#47;* css class *&#47;
    &ensp;rule: /^([^0-9]*)$/, &#47;* RegExp *&#47;
    }, {
    &ensp;classes: 'no-braces', &#47;* css class *&#47;
    &ensp;rule(text) { &#47;* function with text as param *&#47;
    &ensp;&ensp;return text.indexOf('{') !== -1 || text.indexOf('}') !== -1;
    &ensp;},
    &ensp;disableAdd: true, &#47;* if the rule matches, the item cannot be added *&#47;,
    },
   */
  validation: {
    type: Object,
    default: () => [],
    validator(e) {
      return !e.some((t) => {
        const s = !t.rule;
        s && console.warn('Property "rule" is missing', t);
        const n = t.rule && (typeof t.rule == "string" || t.rule instanceof RegExp || {}.toString.call(t.rule) === "[object Function]");
        n || console.warn(
          "A rule must be type of string, RegExp or function. Found:",
          JSON.stringify(t.rule)
        );
        const r = !t.classes;
        r && console.warn('Property "classes" is missing', t);
        const i = t.type && typeof t.type != "string";
        return i && console.warn('Property "type" must be type of string. Found:', t), !n || s || r || i;
      });
    }
  },
  /**
   * @description Defines the characters which splits a text into different pieces,
     to generate tags out of this pieces.
   * @property {props}
   * @type {Array}
   * @default [';']
   * @example
     separators: [';', ',']
     input: some; user input, has random; commas, an,d semicolons
     will split into: some - user input - has random - commas - an - d semicolons
   */
  separators: {
    type: Array,
    default: () => [";"],
    validator(e) {
      return !e.some((t) => {
        const s = typeof t != "string";
        return s && console.warn("Separators must be type of string. Found:", t), s;
      });
    }
  },
  /**
   * @description If it's true, the user can't add or save a tag,
     if another exists, with the same text value.
   * @property {props}
   * @type {Boolean}
   * @default true
   */
  avoidAddingDuplicates: {
    type: Boolean,
    default: !0
  },
  /**
   * @description If the input holds a value and loses the focus,
     a tag will be generated out of this value, if possible.
   * @property {props}
   * @type {Boolean}
   * @default true
   */
  addOnBlur: {
    type: Boolean,
    default: !0
  },
  /**
   * @description Custom function to detect duplicates. If the function returns 'true',
    the tag will be marked as duplicate.
   * @property {props}
   * @type {Function}
   * @param {Array} tagsarray The Array of tags minus the one which is edited/created.
   * @param {Object} tag The tag which is edited or should be added to the tags array.
   * @example
     // The duplicate function to recreate the default behaviour, would look like this:
     isDuplicate(tags, tag) {
     &ensp;return tags.map(t => t.text).indexOf(tag.text) !== -1;
    }
   */
  isDuplicate: {
    type: Function,
    default: null
  },
  /**
   * @description If it's true, the user can paste into the input element and
     vue-tags-input will create tags out of the incoming text.
   * @property {props}
   * @type {Boolean}
   * @default true
   */
  addFromPaste: {
    type: Boolean,
    default: !0
  },
  /**
   * @description Defines if it's possible to delete tags by pressing backspace.
     If so and the user wants to delete a tag,
     the tag gets the css class 'deletion-mark' for 1 second.
     If the user presses backspace again in that time period,
     the tag is removed from the tags array and the view.
   * @property {props}
   * @type {Boolean}
   * @default true
   */
  deleteOnBackspace: {
    default: !0,
    type: Boolean
  }
}, V$ = me({
  name: "VueTagsInput",
  components: {
    TagInput: x$
  },
  props: F$,
  emits: [
    "before-adding-tag",
    "before-deleting-tag",
    "before-editing-tag",
    "before-saving-tag",
    "max-tags-reached",
    "adding-duplicate",
    "saving-duplicate",
    "tag-clicked",
    "tags-changed",
    "blur",
    "focus",
    "update:modelValue",
    "update:tags"
  ],
  data() {
    return {
      newTag: void 0,
      tagsCopy: void 0,
      tagsEditStatus: void 0,
      deletionMark: void 0,
      deletionMarkTime: void 0,
      selectedItem: void 0,
      focused: void 0
    };
  },
  computed: {
    canAddMore() {
      var e;
      return !this.$props.maxTags || (((e = this.tagsCopy) == null ? void 0 : e.length) ?? 0) < this.$props.maxTags;
    },
    // Property which calculates if the autocomplete should be opened or not
    autocompleteOpen() {
      return this.autocompleteAlwaysOpen ? !0 : this.newTag !== void 0 && this.newTag.length >= this.autocompleteMinLength && this.filteredAutocompleteItems.length > 0 && this.focused;
    },
    // Returns validated autocomplete items. Maybe duplicates are filtered out
    filteredAutocompleteItems() {
      const e = this.$props.autocompleteItems.map((t) => Wl(t, this.$props.tags, this.$props.validation, this.isDuplicate));
      return this.$props.autocompleteFilterDuplicates ? e.filter(this.duplicateFilter) : e;
    }
  },
  methods: {
    createClasses: zk,
    // Returns the index which item should be selected, based on the parameter 'method'
    getSelectedIndex(e) {
      const t = this.filteredAutocompleteItems, s = this.selectedItem, n = t.length - 1;
      if (t.length !== 0)
        return s === void 0 ? 0 : e === "before" && s === 0 ? n : e === "after" && s === n ? 0 : e === "after" ? s + 1 : s - 1;
    },
    selectDefaultItem() {
      this.$props.addOnlyFromAutocomplete && this.filteredAutocompleteItems.length > 0 ? this.selectedItem = 0 : this.selectedItem = void 0;
    },
    selectItem(e, t) {
      e.preventDefault(), this.selectedItem = this.getSelectedIndex(t);
    },
    isSelected(e) {
      return this.selectedItem === e;
    },
    isMarked(e) {
      return this.deletionMark === e;
    },
    // Method which is called when the user presses backspace → remove the last tag
    invokeDelete() {
      if (!this.$props.deleteOnBackspace || this.newTag.length > 0)
        return;
      const e = this.tagsCopy.length - 1;
      this.deletionMark === void 0 ? (this.deletionMarkTime = setTimeout(() => this.deletionMark = void 0, 1e3), this.deletionMark = e) : this.performDeleteTag(e);
    },
    addTagsFromPaste() {
      this.$props.addFromPaste && setTimeout(() => this.performAddTags(this.newTag), 10);
    },
    // Method to call if a tag should switch to it's edit mode
    performEditTag(e) {
      this.$props.allowEditTags && (this.$attrs["before-editing-tag"] || this.editTag(e), this.$emit("before-editing-tag", {
        index: e,
        tag: this.tagsCopy[e],
        editTag: () => this.editTag(e)
      }));
    },
    // Opens the edit mode for a tag and focuses it
    editTag(e) {
      this.$props.allowEditTags && (this.toggleEditMode(e), this.focus(e));
    },
    // Toggles the edit mode for a tag
    toggleEditMode(e) {
      !this.$props.allowEditTags || this.$props.disabled || (this.tagsEditStatus[e] = !this.tagsEditStatus[e]);
    },
    // only called by the @input event from TagInput.
    // Creates a new tag model and applies it to this.tagsCopy[index]
    createChangedTag(e, t) {
      const s = this.tagsCopy[e];
      s.text = t ? t.target.value : this.tagsCopy[e].text, this.tagsCopy[e] = Wl(s, this.tagsCopy, this.$props.validation, this.$props.isDuplicate);
    },
    // Focuses the input of a tag
    focus(e) {
      this.$nextTick(() => {
        const t = this.$refs.tagCenter[e].querySelector("input.ti-tag-input");
        t && t.focus();
      });
    },
    quote(e) {
      return e.replace(/([()[{*+.$^\\|?])/g, "\\$1");
    },
    // Cancels the edit mode for a tag → resets the tag to it's original model!
    cancelEdit(e) {
      this.$props.tags[e] && (this.tagsCopy[e] = id(
        Wl(this.$props.tags[e], this.$props.tags, this.validation, this.isDuplicate)
      ), this.tagsEditStatus[e] = !1);
    },
    hasForbiddingAddRule(e) {
      return e.some((t) => {
        const s = this.$props.validation.find((n) => t === n.classes);
        return s ? s.disableAdd : !1;
      });
    },
    // Creates multiple tags out of a string, based on the prop separators
    createTagTexts(e) {
      const t = new RegExp(this.$props.separators.map((s) => this.quote(s)).join("|"));
      return e.split(t).map((s) => ({ text: s }));
    },
    // Method to call to delete a tag
    performDeleteTag(e) {
      this.$attrs.onBeforeDeletingTag || this.deleteTag(e), this.$emit("before-deleting-tag", {
        index: e,
        tag: this.tagsCopy[e],
        deleteTag: () => this.deleteTag(e)
      });
    },
    deleteTag(e) {
      this.disabled || (this.deletionMark = void 0, clearTimeout(this.deletionMarkTime), this.tagsCopy.splice(e, 1), this.$emit("update:tags", this.tagsCopy), this.$emit("tags-changed", this.tagsCopy));
    },
    // Decides whether the input keyCode is one, which is allowed to modify/add tags
    noTriggerKey(e, t) {
      const s = this[t].indexOf(e.keyCode) !== -1 || this[t].indexOf(e.key) !== -1;
      return s && e.preventDefault(), !s;
    },
    validationTrigger(e) {
      const t = e.target.value + (e.type == "keyup" ? "" : e.key);
      return this.validation.filter((n) => n.autoAdd).find((n) => {
        if (typeof n.rule == "string")
          return new RegExp(n.rule).test(t);
        if (n.rule instanceof RegExp)
          return n.rule.test(t);
        if ({}.toString.call(n.rule) === "[object Function]")
          return n.rule(t);
      }) != null;
    },
    autoAddTag(e, t, s) {
      if (this.validationTrigger(t)) {
        let n = [];
        typeof e == "object" && (n = [e]), typeof e == "string" && (n = this.createTagTexts(e)), n = n.filter((r) => r.text.trim().length > 0), n.forEach((r) => {
          r = Wl(r, this.$props.tags, this.$props.validation, this.$props.isDuplicate), this.$attrs.onBeforeAddingTag || this.addTag(r, s), this.$emit("before-adding-tag", {
            tag: r,
            addTag: () => this.addTag(r, s)
          });
        });
      }
    },
    // Method to call to add a tag
    performAddTags(e, t, s) {
      if (this.$props.disabled || t && this.noTriggerKey(t, "addOnKey"))
        return;
      let n = [];
      typeof e == "object" && (n = [e]), typeof e == "string" && (n = this.createTagTexts(e)), n = n.filter((r) => r.text.trim().length > 0), n.forEach((r) => {
        r = Wl(r, this.$props.tags, this.$props.validation, this.$props.isDuplicate), this.$attrs.onBeforeAddingTag || this.addTag(r, s), this.$emit("before-adding-tag", {
          tag: r,
          addTag: () => this.addTag(r, s)
        });
      });
    },
    duplicateFilter(e) {
      return this.tagsCopy == null ? !1 : this.isDuplicate ? !this.isDuplicate(this.tagsCopy, e) : !this.tagsCopy.find((t) => t.text === e.text);
    },
    addTag(e, t = "new-tag-input") {
      const s = this.filteredAutocompleteItems.map((n) => n.text);
      this.$props.addOnlyFromAutocomplete && s.indexOf(e.text) === -1 || this.$nextTick(() => {
        if (this.$props.maxTags && this.$props.maxTags <= this.tagsCopy.length)
          return this.$emit("max-tags-reached", e);
        if (this.$props.avoidAddingDuplicates && !this.duplicateFilter(e))
          return this.$emit("adding-duplicate", e);
        this.hasForbiddingAddRule(e.tiClasses) || (this.newTag = "", this.$emit("update:modelValue", ""), this.tagsCopy.push(e), this.$emit("update:tags", this.tagsCopy), t === "autocomplete" && this.$refs.newTagInput.focus(), this.$emit("tags-changed", this.tagsCopy));
      });
    },
    // Method to call to save a tag
    performSaveTag(e, t) {
      const s = this.tagsCopy[e];
      this.$props.disabled || t && this.noTriggerKey(t, "addOnKey") || s.text.trim().length !== 0 && (this.$attrs.onBeforeSavingTag || this.saveTag(e, s), this.$emit("before-saving-tag", {
        index: e,
        tag: s,
        saveTag: () => this.saveTag(e, s)
      }));
    },
    saveTag(e, t) {
      if (this.$props.avoidAddingDuplicates) {
        const s = id(this.tagsCopy), n = s.splice(e, 1)[0];
        if (this.isDuplicate ? this.isDuplicate(s, n) : s.map((i) => i.text).indexOf(n.text) !== -1)
          return this.$emit("saving-duplicate", t);
      }
      this.hasForbiddingAddRule(t.tiClasses) || (this.tagsCopy[e] = t, this.toggleEditMode(e), this.$emit("update:tags", this.tagsCopy), this.$emit("tags-changed", this.tagsCopy));
    },
    tagsEqual() {
      return !this.tagsCopy.some((e, t) => !Uk(e, this.$props.tags[t]));
    },
    updateNewTag(e) {
      const t = e.target.value;
      this.newTag = t, this.$emit("update:modelValue", t);
    },
    initTags() {
      this.tagsCopy = R$(this.$props.tags, this.$props.validation), this.tagsEditStatus = id(this.$props.tags).map(() => !1), this.tagsEqual() || this.$emit("update:tags", this.tagsCopy);
    },
    blurredOnClick(e) {
      this.$el.contains(e.target) || this.$el.contains(document.activeElement) || this.performBlur();
    },
    performBlur() {
      this.$props.addOnBlur && this.focused && this.performAddTags(this.newTag), this.focused = !1;
    }
  },
  watch: {
    modelValue(e) {
      this.$props.addOnlyFromAutocomplete || (this.selectedItem = void 0), this.newTag = e;
    },
    tags: {
      handler() {
        this.initTags();
      },
      deep: !0
    },
    autocompleteOpen: "selectDefaultItem"
  },
  created() {
    this.newTag = this.modelValue, this.initTags();
  },
  mounted() {
    this.selectDefaultItem(), document.addEventListener("click", this.blurredOnClick);
  },
  unmounted() {
    document.removeEventListener("click", this.blurredOnClick);
  }
}), D$ = { class: "ti-input" }, N$ = {
  key: 0,
  class: "ti-tags"
}, j$ = ["onClick"], H$ = { class: "ti-content" }, U$ = {
  key: 0,
  class: "ti-tag-left"
}, z$ = ["onClick"], W$ = {
  key: 1,
  class: "ti-tag-right"
}, G$ = { class: "ti-actions" }, Y$ = ["onClick"], X$ = ["onClick"], q$ = {
  key: 0,
  class: "ti-new-tag-input-wrapper"
}, Q$ = { autocomplete: "off" }, K$ = ["placeholder", "value", "maxlength", "disabled"], Z$ = ["onMouseover"], J$ = ["onClick"];
function $$(e, t, s, n, r, i) {
  const o = pe("tag-input");
  return p(), h("div", {
    class: z(["vue-tags-input", [{ "ti-disabled": e.disabled }, { "ti-focus": e.focused }]])
  }, [
    a("div", D$, [
      e.tagsCopy ? (p(), h("ul", N$, [
        (p(!0), h(A, null, D(e.tagsCopy, (l, d) => (p(), h("li", {
          key: d,
          style: rn(l.style),
          class: z([[
            { "ti-editing": e.tagsEditStatus[d] },
            l.tiClasses,
            l.classes,
            { "ti-deletion-mark": e.isMarked(d) }
          ], "ti-tag"]),
          tabindex: "0",
          onClick: (c) => e.$emit("tag-clicked", { tag: l, index: d })
        }, [
          a("div", H$, [
            e.$slots["tag-left"] ? (p(), h("div", U$, [
              Ot(e.$slots, "tag-left", {
                tag: l,
                index: d,
                edit: e.tagsEditStatus[d],
                performSaveEdit: e.performSaveTag,
                performDelete: e.performDeleteTag,
                performCancelEdit: e.cancelEdit,
                performOpenEdit: e.performEditTag,
                deletionMark: e.isMarked(d)
              })
            ])) : P("", !0),
            a("div", {
              ref_for: !0,
              ref: "tagCenter",
              class: "ti-tag-center"
            }, [
              e.$slots["tag-center"] ? P("", !0) : (p(), h("span", {
                key: 0,
                class: z({ "ti-hidden": e.tagsEditStatus[d] }),
                onClick: (c) => e.performEditTag(d)
              }, g(l.text), 11, z$)),
              e.$slots["tag-center"] ? P("", !0) : (p(), Fe(o, {
                key: 1,
                scope: {
                  edit: e.tagsEditStatus[d],
                  maxlength: e.maxlength,
                  tag: l,
                  index: d,
                  validateTag: e.createChangedTag,
                  performCancelEdit: e.cancelEdit,
                  performSaveEdit: e.performSaveTag
                }
              }, null, 8, ["scope"])),
              Ot(e.$slots, "tag-center", {
                tag: l,
                index: d,
                maxlength: e.maxlength,
                edit: e.tagsEditStatus[d],
                performSaveEdit: e.performSaveTag,
                performDelete: e.performDeleteTag,
                performCancelEdit: e.cancelEdit,
                validateTag: e.createChangedTag,
                performOpenEdit: e.performEditTag,
                deletionMark: e.isMarked(d)
              })
            ], 512),
            e.$slots["tag-right"] ? (p(), h("div", W$, [
              Ot(e.$slots, "tag-right", {
                tag: l,
                index: d,
                edit: e.tagsEditStatus[d],
                performSaveEdit: e.performSaveTag,
                performDelete: e.performDeleteTag,
                performCancelEdit: e.cancelEdit,
                performOpenEdit: e.performEditTag,
                deletionMark: e.isMarked(d)
              })
            ])) : P("", !0)
          ]),
          a("div", G$, [
            e.$slots["tag-actions"] ? P("", !0) : V((p(), h("i", {
              key: 0,
              class: "ti-icon-undo",
              onClick: (c) => e.cancelEdit(d)
            }, null, 8, Y$)), [
              [Us, e.tagsEditStatus[d]]
            ]),
            e.$slots["tag-actions"] ? P("", !0) : V((p(), h("i", {
              key: 1,
              class: "ti-icon-close",
              onClick: (c) => e.performDeleteTag(d)
            }, null, 8, X$)), [
              [Us, !e.tagsEditStatus[d]]
            ]),
            e.$slots["tag-actions"] ? Ot(e.$slots, "tag-actions", {
              key: 2,
              tag: l,
              index: d,
              edit: e.tagsEditStatus[d],
              performSaveEdit: e.performSaveTag,
              performDelete: e.performDeleteTag,
              performCancelEdit: e.cancelEdit,
              performOpenEdit: e.performEditTag,
              deletionMark: e.isMarked(d)
            }) : P("", !0)
          ])
        ], 14, j$))), 128)),
        e.canAddMore ? (p(), h("li", q$, [
          a("form", Q$, [
            a("input", Rs({ ref: "newTagInput" }, e.$attrs, {
              class: [[e.createClasses(e.newTag, e.tags, e.validation, e.isDuplicate)], "ti-new-tag-input"],
              placeholder: e.placeholder,
              value: e.newTag,
              maxlength: e.maxlength,
              disabled: e.disabled,
              type: "text",
              size: "1",
              autocomplete: "off",
              onKeydown: [
                t[0] || (t[0] = (l) => e.performAddTags(e.filteredAutocompleteItems[e.selectedItem] || e.newTag, l)),
                t[3] || (t[3] = wo((...l) => e.invokeDelete && e.invokeDelete(...l), ["delete"])),
                t[4] || (t[4] = wo((...l) => e.performBlur && e.performBlur(...l), ["tab"])),
                t[5] || (t[5] = wo((l) => e.selectItem(l, "before"), ["38"])),
                t[6] || (t[6] = wo((l) => e.selectItem(l, "after"), ["40"]))
              ],
              onKeyup: t[1] || (t[1] = (l) => e.autoAddTag(e.filteredAutocompleteItems[e.selectedItem] || e.newTag, l)),
              onPaste: t[2] || (t[2] = (...l) => e.addTagsFromPaste && e.addTagsFromPaste(...l)),
              onInput: t[7] || (t[7] = (...l) => e.updateNewTag && e.updateNewTag(...l)),
              onBlur: t[8] || (t[8] = (l) => e.$emit("blur", l)),
              onFocus: t[9] || (t[9] = (l) => {
                e.focused = !0, e.$emit("focus", l);
              }),
              onClick: t[10] || (t[10] = (l) => e.addOnlyFromAutocomplete ? !1 : e.selectedItem = void 0)
            }), null, 16, K$)
          ])
        ])) : P("", !0)
      ])) : P("", !0)
    ]),
    Ot(e.$slots, "between-elements"),
    e.autocompleteOpen ? (p(), h("div", {
      key: 0,
      class: "ti-autocomplete",
      onMouseout: t[11] || (t[11] = (l) => e.selectedItem = void 0)
    }, [
      Ot(e.$slots, "autocomplete-header"),
      a("ul", null, [
        (p(!0), h(A, null, D(e.filteredAutocompleteItems, (l, d) => (p(), h("li", {
          key: d,
          style: rn(l.style),
          class: z([[
            l.tiClasses,
            l.classes,
            { "ti-selected-item": e.isSelected(d) }
          ], "ti-item"]),
          onMouseover: (c) => e.disabled ? !1 : e.selectedItem = d
        }, [
          e.$slots["autocomplete-item"] ? Ot(e.$slots, "autocomplete-item", {
            key: 1,
            item: l,
            index: d,
            selected: e.isSelected(d),
            performAdd: (c) => e.performAddTags(c, void 0, "autocomplete")
          }) : (p(), h("div", {
            key: 0,
            onClick: (c) => e.performAddTags(l, void 0, "autocomplete")
          }, g(l.text), 9, J$))
        ], 46, Z$))), 128))
      ]),
      Ot(e.$slots, "autocomplete-footer")
    ], 32)) : P("", !0)
  ], 2);
}
const Wk = /* @__PURE__ */ Ae(V$, [["render", $$]]), _$ = !0, V2 = 1500;
let my = null;
const D2 = new Promise((e) => my = e), e_ = me({
  name: "ManagmenetTerritory",
  props: {},
  components: {
    VueTagsInput: Wk,
    Listbox: lP
  },
  data() {
    return {
      ignoreNextPmFee: !1,
      isLoaded: !1,
      isUpdating: !1,
      pmFee: 0,
      pmFeeType: ri.Flat,
      debounce: void 0,
      counties: [],
      states: [],
      // Management Area
      managementAreaState: "",
      managementAreaType: Qo.Zip,
      zips: [],
      zipLookup: void 0,
      zipAutocompleteItems: [],
      zipValidation: [
        {
          classes: "zip5-only",
          rule: /^([0-9]{5})$/,
          disableAdd: !0
        }
      ],
      areaCounties: [],
      selectedAreaCounties: [],
      //#region Map
      listingsMapOptions: void 0,
      center: void 0,
      currentZoom: 10
      //#endregion
    };
  },
  watch: {
    zipLookup: "initItems",
    pmFeeType: "pmFeeTypeChanged",
    managementAreaType(e) {
      switch (e) {
        case Qo.County:
          this.loadCountyCoverage();
          break;
        case Qo.Zip:
          this.loadZipCoverage();
          break;
      }
    },
    managementAreaState(e, t) {
      console.log("State changed from", t, "to", e), this.loadCounties();
    }
  },
  computed: {
    stateCounties() {
      return this.areaCounties.filter((e) => e.state == this.managementAreaState);
    },
    territoryDefined() {
      switch (this.managementAreaType) {
        case Qo.Zip:
          return this.zips.length > 0;
        case Qo.County:
          return this.areaCounties.length > 0;
        default:
          return !1;
      }
    },
    pmFeeFlat: {
      get() {
        return Ve(this.pmFee);
      },
      set(e) {
        this.pmFee = vs(`${e}`);
      }
    },
    pmFeePercent: {
      get() {
        return Ve(this.pmFee, 2);
      },
      set(e) {
        this.pmFee = vs(`${e}`);
      }
    },
    ...at(Te, ct),
    ...q(Te, ["access", "aclLoaded"]),
    ...q(ct, ["userInfo"])
  },
  methods: {
    clearSelections() {
      this.managementAreaType == Qo.County ? this.areaCounties.forEach((e, t) => {
        e.selected = !1;
      }) : this.zips.length = 0;
    },
    async loadStates() {
      try {
        const e = await W.api.geo.states();
        if (e.data.status != de.Success)
          throw new Le(e);
        this.states.length = 0, e.data.states && this.states.push(...e.data.states);
      } catch (e) {
        Se(e);
      }
    },
    async loadCounties() {
      try {
        if (!this.managementAreaState)
          return;
        const e = await W.api.geo.countiesForState(this.managementAreaState);
        if (e.data.status != de.Success)
          throw new Le(e);
        this.counties.length = 0, e.data.page && this.counties.push(...e.data.page);
      } catch (e) {
        Se(e);
      }
    },
    async loadCountyCoverage() {
      var e;
      try {
        if (this.managementAreaType != Qo.County)
          return;
        this.isUpdating = !0;
        const t = this.areaCounties.map((r) => r.key), s = await W.api.accountTerritory.coverageByCounty(t);
        if (s.data.status != de.Success)
          throw new Le(s);
        await D2;
        const n = ((e = s.data.coverage) == null ? void 0 : e.features.map((r) => r.id)) ?? [];
        this.map.data.forEach((r) => {
          (r.getProperty("type") != "county" || !n.find((o) => o == r.getId())) && this.map.data.remove(r);
        }), this.map.data.addGeoJson(s.data.coverage);
      } catch (t) {
        Se(t);
      } finally {
        this.isUpdating = !1;
      }
    },
    async loadZipCoverage() {
      var e;
      try {
        if (this.managementAreaType != Qo.Zip)
          return;
        this.isUpdating = !0;
        const t = this.zips.map((r) => r.text), s = await W.api.accountTerritory.coverageByZip(t);
        if (s.data.status != de.Success)
          throw new Le(s);
        await D2;
        const n = ((e = s.data.coverage) == null ? void 0 : e.features.map((r) => r.id)) ?? [];
        this.map.data.forEach((r) => {
          (r.getProperty("type") != "zip" || !n.find((o) => o == r.getId())) && this.map.data.remove(r);
        }), this.map.data.addGeoJson(s.data.coverage);
      } catch (t) {
        Se(t);
      } finally {
        this.isUpdating = !1;
      }
    },
    async loadSettings() {
      var e;
      this.isLoaded = !1, this.zips.length = 0;
      try {
        await this.accountStore.fetchUserSettings(), this.pmFeeType != ((e = this.userInfo) == null ? void 0 : e.propertyManagementFeeType) && (this.ignoreNextPmFee = !0), this.managementAreaType = this.userInfo.managementAreaType;
        let t = this.userInfo.propertyManagementFee;
        this.pmFeeType = this.userInfo.propertyManagementFeeType, this.pmFeeType == ri.Percentage && (t = t * 100), this.pmFee = t, this.userInfo.managementAreaZipcodes && this.zips.push(...this.userInfo.managementAreaZipcodes.map((s) => ({
          text: s
        }))), this.userInfo.managementAreaCounties && (this.areaCounties = [...this.userInfo.managementAreaCounties]), !this.managementAreaState && this.areaCounties.length > 0 && (this.managementAreaState = this.areaCounties[0].state), this.isLoaded = !0;
      } catch (t) {
        Se(t);
      }
    },
    update(e) {
      this.zipAutocompleteItems.length = 0, this.zips = e, this.loadZipCoverage();
    },
    initItems() {
      !this.zipLookup || this.zipLookup.length < 2 || (clearTimeout(this.debounce), this.debounce = setTimeout(async () => {
        try {
          this.zipAutocompleteItems.length = 0;
          const e = await W.api.geo.zipLookup(this.zipLookup);
          this.zipAutocompleteItems.push(...e.data.result.map((t) => ({
            text: t
          })));
        } catch (e) {
          Se("Zip Lookup Error " + e.message);
        }
      }, 600));
    },
    async updateSettings() {
      try {
        this.isUpdating = !0;
        const e = this.areaCounties, t = this.zips.map((i) => i.text);
        let s = this.pmFee;
        this.pmFeeType == ri.Percentage && (s = s / 100);
        let n = {
          managementAreaCounties: e,
          managementAreaType: this.managementAreaType,
          managementAreaZipcodes: t,
          propertyManagementFee: s,
          propertyManagementFeeType: this.pmFeeType
        };
        const r = await W.api.user.updateSettings(n);
        if (r.data.status != de.Success)
          throw new Le(r);
        _$ && console.info("updateSettings", r), wt("Settings saved successfully!");
      } catch (e) {
        Se(e);
      }
      this.isUpdating = !1;
    },
    pmFeeTypeChanged(e, t) {
      if (this.ignoreNextPmFee == !0) {
        this.ignoreNextPmFee = !1;
        return;
      }
      console.log(`${this.$options.name}.pmFeeTypeChanged`, e, t), e != t && (e == ri.Flat && (this.pmFee = this.pmFee / 100 * V2), e == ri.Percentage && (this.pmFee = this.pmFee / V2 * 100));
    },
    removeCounty(e) {
      e ? this.areaCounties = this.areaCounties.filter((t) => t.key != e.key) : this.areaCounties.length = 0;
    },
    //#region Map
    async mapInit() {
      this.center = {
        lat: 30.173937,
        lng: -95.505836
      }, this.listingsMapOptions = {
        zoom: this.currentZoom,
        disableDefaultUI: !0,
        streetViewControl: !0,
        streetViewControlOptions: {
          position: google.maps.ControlPosition.LEFT_BOTTOM
        },
        isFractionalZoomEnabled: !1
      }, this.map = this.$refs.gMap.$mapObject, this.map.data.addListener("addfeature", this.updateMapBounds), this.map.data.addListener("removefeature", this.updateMapBounds), this.map.data.addListener("setgeometry", this.updateMapBounds), this.map.data.addListener("mouseover", (e) => {
        const t = e.feature.getProperty("type"), s = e.feature.getProperty("name");
        if (s)
          switch (t) {
            case "zip":
              this.map.getDiv().setAttribute("title", `Zip: ${s}`);
              break;
            case "county":
              this.map.getDiv().setAttribute("title", `County: ${s}`);
              break;
            default:
              this.map.getDiv().setAttribute("title", s);
              break;
          }
      }), this.map.data.addListener("mouseout", (e) => {
        this.map.getDiv().removeAttribute("title");
      }), this.map.data.setStyle((e) => {
        let t = "black", s = 1, n = 0.15;
        switch (e.getProperty("type")) {
          case "clusterBound":
            t = "#0c78b4", s = 3;
            break;
          case "zip":
            t = De.Colors.Maps.Zip;
            break;
          case "county":
            t = De.Colors.Maps.County, n = 0.4;
            break;
        }
        return {
          strokeColor: t,
          strokeWeight: s,
          strokeOpacity: 0.8,
          fillColor: t,
          fillOpacity: n
        };
      }), my && my(!0);
    },
    updateMapBounds(e) {
      if (console.log(`${this.$options.name}.updateMapBounds`, e), e.feature.getProperty("type") == "clusterBound")
        return;
      const t = new google.maps.LatLngBounds();
      this.map.data.forEach((s) => {
        var n;
        (n = s.getGeometry()) == null || n.forEachLatLng((r) => {
          t.extend(r);
        });
      }), t.isEmpty() == !1 && this.map.fitBounds(t, 1);
    }
    //#endregion
  },
  mounted() {
    this.aclLoaded.then(() => this.loadSettings()).then(() => this.loadStates()).then(() => this.loadCountyCoverage()).then(() => this.loadZipCoverage()), this.$gmapApiPromiseLazy().then(async () => await this.mapInit());
  }
}), t_ = { class: "row g-3" }, s_ = { class: "col-12" }, a_ = { class: "fw-bold fs-3" }, n_ = { class: "card shadow-sm card-management-territory" }, r_ = { class: "territory-content row row-cols-1 row-cols-xl-2 g-0" }, o_ = { class: "col order-2 order-xl-1 d-flex flex-column" }, i_ = { class: "card-header bg-white border-0 pt-3 pb-0 d-flex justify-content-between align-items-center" }, l_ = { class: "fs-5 fw-bold" }, d_ = { class: "card-body" }, c_ = { class: "mb-4" }, u_ = {
  for: "managementAreaType",
  class: "form-label"
}, p_ = ["disabled"], h_ = { key: 0 }, m_ = {
  for: "new_zip",
  class: "form-label"
}, f_ = { key: 1 }, g_ = {
  for: "new_zip",
  class: "form-label"
}, v_ = ["disabled"], y_ = ["value"], b_ = {
  for: "new_zip",
  class: "form-label"
}, A_ = { class: "form-label" }, w_ = { class: "border rounded overflow-hidden" }, C_ = { class: "list-unstyled mb-0" }, S_ = { class: "d-flex justify-content-between align-items-center selected-counties-item p-2" }, P_ = ["onClick"], k_ = {
  key: 0,
  class: "alert alert-danger mt-3 mb-0",
  role: "alert"
}, E_ = { class: "card-footer d-flex justify-content-between" }, I_ = ["disabled"], T_ = ["disabled"], O_ = { class: "col order-1 order-xl-2 bg-secondary rounded-end" };
function R_(e, t, s, n, r, i) {
  const o = pe("vue-tags-input"), l = pe("Listbox"), d = pe("GMapMap");
  return p(), h("div", t_, [
    a("div", s_, [
      a("h2", a_, g(e.$t("t-company-territory")), 1),
      a("div", n_, [
        a("div", r_, [
          a("div", o_, [
            a("div", i_, [
              a("span", l_, g(e.$t("t-territory")), 1)
            ]),
            a("div", d_, [
              a("div", c_, [
                a("label", u_, g(e.$t("t-territory-defined-by")), 1),
                V(a("select", {
                  class: "form-select",
                  "onUpdate:modelValue": t[0] || (t[0] = (c) => e.managementAreaType = c),
                  id: "managementAreaType",
                  disabled: !e.isLoaded || e.isUpdating
                }, t[6] || (t[6] = [
                  a("option", { value: "zip" }, "Zip Codes", -1),
                  a("option", { value: "county" }, "Counties", -1)
                ]), 8, p_), [
                  [We, e.managementAreaType]
                ])
              ]),
              N(ks, {
                name: "slide",
                mode: "out-in"
              }, {
                default: ve(() => [
                  e.managementAreaType == "zip" ? (p(), h("div", h_, [
                    a("label", m_, g(e.$t("t-choose-your-zipcodes")), 1),
                    a("div", null, [
                      N(o, {
                        modelValue: e.zipLookup,
                        "onUpdate:modelValue": t[1] || (t[1] = (c) => e.zipLookup = c),
                        tags: e.zips,
                        "autocomplete-items": e.zipAutocompleteItems,
                        "add-only-from-autocomplete": !1,
                        validation: e.zipValidation,
                        "add-on-key": [13, " ", ",", ";"],
                        placeholder: "Add ZipCode",
                        separators: [" ", ",", ";"],
                        onTagsChanged: e.update,
                        disabled: !e.isLoaded || e.isUpdating
                      }, null, 8, ["modelValue", "tags", "autocomplete-items", "validation", "onTagsChanged", "disabled"])
                    ])
                  ])) : (p(), h("div", f_, [
                    a("label", g_, g(e.$t("t-select-state")), 1),
                    V(a("select", {
                      class: "form-select mb-4",
                      id: "new_zip",
                      "onUpdate:modelValue": t[2] || (t[2] = (c) => e.managementAreaState = c),
                      disabled: !e.isLoaded || e.isUpdating
                    }, [
                      (p(!0), h(A, null, D(e.states, (c) => (p(), h("option", {
                        key: c.abv,
                        value: c.abv
                      }, g(c.name), 9, y_))), 128))
                    ], 8, v_), [
                      [We, e.managementAreaState]
                    ]),
                    a("label", b_, g(e.$t("t-choose-your-counties")), 1),
                    N(l, {
                      modelValue: e.areaCounties,
                      "onUpdate:modelValue": t[3] || (t[3] = (c) => e.areaCounties = c),
                      options: e.counties,
                      optionLabel: "county",
                      listStyle: "height:250px",
                      emptyMessage: "Choose a state to show counties for.",
                      multiple: "",
                      filter: "",
                      dataKey: "key",
                      class: "mb-4",
                      onChange: e.loadCountyCoverage,
                      disabled: !e.isLoaded || e.isUpdating
                    }, {
                      option: ve((c) => [
                        y(g(c.option.county) + ", " + g(c.option.state), 1)
                      ]),
                      _: 1
                    }, 8, ["modelValue", "options", "onChange", "disabled"]),
                    a("label", A_, g(e.$t("t-selected-counties")), 1),
                    a("div", w_, [
                      a("ul", C_, [
                        (p(!0), h(A, null, D(e.areaCounties, (c) => (p(), h("li", S_, [
                          a("span", null, g(c.county) + ", " + g(c.state), 1),
                          a("button", {
                            class: "btn btn-link text-dark",
                            onClick: (u) => e.removeCounty(c)
                          }, t[7] || (t[7] = [
                            a("i", { class: "fa-light fa-xmark" }, null, -1)
                          ]), 8, P_)
                        ]))), 256))
                      ])
                    ])
                  ]))
                ]),
                _: 1
              }),
              !e.territoryDefined && e.isLoaded ? (p(), h("div", k_, [
                t[8] || (t[8] = a("i", { class: "fa-light fa-triangle-exclamation me-2" }, null, -1)),
                y(g(e.$t("t-territory-must-be-defined")), 1)
              ])) : P("", !0)
            ]),
            a("div", E_, [
              a("button", {
                type: "button",
                onClick: t[4] || (t[4] = (c) => e.removeCounty()),
                class: "btn btn-outline-eclipse",
                disabled: !e.isLoaded || e.isUpdating
              }, g(e.$t("t-clear-selections")), 9, I_),
              a("button", {
                type: "button",
                onClick: t[5] || (t[5] = (...c) => e.updateSettings && e.updateSettings(...c)),
                class: "btn btn-lava",
                disabled: !e.isLoaded || e.isUpdating || !e.territoryDefined
              }, "Update Territory", 8, T_)
            ])
          ]),
          a("div", O_, [
            N(d, {
              ref: "gMap",
              class: "territory-map",
              "map-id": "2ddbbe0dd6bcf8f9",
              center: e.center,
              options: e.listingsMapOptions
            }, null, 8, ["center", "options"])
          ])
        ])
      ])
    ])
  ]);
}
const Xis = /* @__PURE__ */ Ae(e_, [["render", R_]]), L_ = me({
  name: "LoadingStatus"
}), B_ = { class: "loads text-center d-flex flex-column justify-content-center align-items-center position-absolute w-100" };
function M_(e, t, s, n, r, i) {
  return p(), h("div", B_, t[0] || (t[0] = [
    Bt('<svg class="loader" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 340 340"><circle cx="170" cy="170" r="160" stroke="#F26E34"></circle><circle cx="170" cy="170" r="135" stroke="#132844"></circle><circle cx="170" cy="170" r="110" stroke="#F26E34"></circle><circle cx="170" cy="170" r="85" stroke="#132844"></circle></svg><br><span class="fw-bold h5 mb-0"> Loading... </span>', 3)
  ]));
}
const Gk = /* @__PURE__ */ Ae(L_, [["render", M_]]), x_ = me({
  name: "NumericalInput",
  props: {
    modelValue: Object,
    orignalValue: Object,
    class: String,
    placeholder: String,
    percent: Boolean,
    currency: Boolean,
    optionalType: Boolean,
    allowEmpty: Boolean,
    disabled: Boolean,
    locked: Boolean,
    checkUndefined: Boolean
  },
  emits: [
    "update:modelValue",
    "update:percent",
    "change"
  ],
  data() {
    return {
      id: n1(),
      value: void 0,
      percentage: this.percent,
      _orig: void 0,
      ignoreNextPercentChange: void 0
    };
  },
  watch: {
    modelValue(e) {
      this.value = e;
    },
    percent(e) {
      this.percentage != e && (this.ignoreNextPercentChange = !0, this.percentage = e == !0);
    },
    percentage(e, t) {
      e != t && this.ignoreNextPercentChange != !0 && (this.value = this.allowEmpty ? void 0 : 0, this.$emit("update:percent", e), this.$emit("update:modelValue", this.value)), this.ignoreNextPercentChange = void 0;
    }
  },
  computed: {
    inputGroupClass() {
      return {
        "input-group": !0,
        "input-numerical": !0,
        "input-group-optional": this.optionalType == !0,
        locked: this.locked == !0,
        changed: (this.orignalValue != null || this.checkUndefined == !0) && this.orignalValue != this.value
        //'verified': true,
      };
    },
    inputClass() {
      const e = {
        "input-numerical": this.currency != !0 && this.percentage != !0 && this.optionalType != !0,
        changed: (this.orignalValue != null || this.checkUndefined == !0) && this.orignalValue != this.value,
        "form-control": !0,
        locked: this.locked == !0
      };
      return this.class && this.class.split(" ").forEach((t) => e[t] = !0), e;
    },
    formated: {
      get() {
        return this.value == null && this.allowEmpty == !1 && (this.value = 0, this.$emit("update:modelValue", this.value)), this.value == null || this.value == null ? "" : this.percentage == !0 ? Ve(this.value * 100, 2) : Ve(this.value);
      },
      set(e) {
        this.allowEmpty == !0 && e == "" ? this.value = void 0 : e == "-" ? this.value = -0 : this.percentage == !0 ? this.value = vs(e) / 100 : this.value = vs(e), this.$emit("update:modelValue", this.value);
      }
    }
  },
  methods: {
    number: Ve,
    onFocus() {
      this._orig = this.value;
    },
    lostFocus() {
      this._orig != this.value && this.$emit("change", this.value), this._orig = void 0;
    }
  },
  created() {
    this.percentage = this.percent == !0, this.value = this.modelValue;
  },
  mounted() {
    document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach((e) => bootstrap.Tooltip.getOrCreateInstance(e));
  }
}), F_ = ["name", "id", "disabled"], V_ = ["for"], D_ = ["placeholder", "disabled"], N_ = ["name", "id", "disabled"], j_ = ["for"], H_ = {
  key: 0,
  class: "input-group-text border-start-0 locked ps-0"
}, U_ = ["placeholder", "disabled"], z_ = {
  key: 0,
  class: "input-group-text border-start-0 locked ps-0"
}, W_ = ["placeholder", "disabled"], G_ = {
  key: 0,
  class: "input-group-text border-start-0 locked ps-0"
}, Y_ = {
  key: 1,
  class: "input-group-text"
}, X_ = ["placeholder", "disabled"];
function q_(e, t, s, n, r, i) {
  return e.optionalType ? (p(), h("div", {
    key: 0,
    class: z(e.inputGroupClass)
  }, [
    V(a("input", {
      type: "radio",
      class: "btn-check",
      name: "option" + e.id,
      id: "optionD" + e.id,
      autocomplete: "off",
      value: !1,
      "onUpdate:modelValue": t[0] || (t[0] = (o) => e.percentage = o),
      disabled: e.disabled || e.locked,
      tabindex: "-1"
    }, null, 8, F_), [
      [Mt, e.percentage]
    ]),
    a("label", {
      class: "btn btn-outline-secondary rounded-start no-anim input-start",
      for: "optionD" + e.id
    }, "$", 8, V_),
    V(a("input", {
      type: "text",
      "onUpdate:modelValue": t[1] || (t[1] = (o) => e.formated = o),
      class: z(e.inputClass),
      placeholder: e.placeholder,
      onFocus: t[2] || (t[2] = (...o) => e.onFocus && e.onFocus(...o)),
      onBlur: t[3] || (t[3] = (...o) => e.lostFocus && e.lostFocus(...o)),
      disabled: e.disabled || e.locked,
      "data-clarity-unmask": "true"
    }, null, 42, D_), [
      [_e, e.formated]
    ]),
    V(a("input", {
      type: "radio",
      class: "btn-check",
      name: "option" + e.id,
      id: "optionP" + e.id,
      autocomplete: "off",
      value: !0,
      "onUpdate:modelValue": t[4] || (t[4] = (o) => e.percentage = o),
      disabled: e.disabled || e.locked,
      tabindex: "-1"
    }, null, 8, N_), [
      [Mt, e.percentage]
    ]),
    a("label", {
      class: "btn btn-outline-secondary no-anim input-end",
      for: "optionP" + e.id
    }, "%", 8, j_),
    e.locked ? (p(), h("div", H_, t[14] || (t[14] = [
      a("i", {
        class: "fa-duotone fa-lock-keyhole",
        "aria-hidden": "true"
      }, null, -1)
    ]))) : P("", !0)
  ], 2)) : e.currency ? (p(), h("div", {
    key: 1,
    class: z(e.inputGroupClass)
  }, [
    t[16] || (t[16] = a("div", { class: "input-group-text" }, "$", -1)),
    V(a("input", {
      type: "text",
      "onUpdate:modelValue": t[5] || (t[5] = (o) => e.formated = o),
      class: z(e.inputClass),
      placeholder: e.placeholder,
      onFocus: t[6] || (t[6] = (...o) => e.onFocus && e.onFocus(...o)),
      onBlur: t[7] || (t[7] = (...o) => e.lostFocus && e.lostFocus(...o)),
      disabled: e.disabled || e.locked,
      "data-clarity-unmask": "true"
    }, null, 42, U_), [
      [_e, e.formated]
    ]),
    e.locked ? (p(), h("div", z_, t[15] || (t[15] = [
      a("i", {
        class: "fa-duotone fa-lock-keyhole",
        "aria-hidden": "true"
      }, null, -1)
    ]))) : P("", !0)
  ], 2)) : e.percent ? (p(), h("div", {
    key: 2,
    class: z(e.inputGroupClass)
  }, [
    V(a("input", {
      type: "text",
      "onUpdate:modelValue": t[8] || (t[8] = (o) => e.formated = o),
      class: z(e.inputClass),
      placeholder: e.placeholder,
      onFocus: t[9] || (t[9] = (...o) => e.onFocus && e.onFocus(...o)),
      onBlur: t[10] || (t[10] = (...o) => e.lostFocus && e.lostFocus(...o)),
      disabled: e.disabled || e.locked,
      "data-clarity-unmask": "true"
    }, null, 42, W_), [
      [_e, e.formated]
    ]),
    e.locked ? (p(), h("div", G_, t[17] || (t[17] = [
      a("i", {
        class: "fa-duotone fa-lock-keyhole",
        "aria-hidden": "true"
      }, null, -1)
    ]))) : P("", !0),
    e.percentage ? (p(), h("div", Y_, "%")) : P("", !0)
  ], 2)) : V((p(), h("input", {
    key: 3,
    type: "text",
    "onUpdate:modelValue": t[11] || (t[11] = (o) => e.formated = o),
    class: z(e.inputClass),
    placeholder: e.placeholder,
    onFocus: t[12] || (t[12] = (...o) => e.onFocus && e.onFocus(...o)),
    onBlur: t[13] || (t[13] = (...o) => e.lostFocus && e.lostFocus(...o)),
    disabled: e.disabled || e.locked,
    "data-clarity-unmask": "true"
  }, null, 42, X_)), [
    [_e, e.formated]
  ]);
}
const Aa = /* @__PURE__ */ Ae(x_, [["render", q_]]), Q_ = ["id", "disabled"], K_ = "SaveButton", bb = /* @__PURE__ */ me({
  name: K_,
  __name: "SaveButton",
  props: /* @__PURE__ */ hd({
    id: {}
  }, {
    busy: { type: Boolean },
    busyModifiers: {},
    disabled: { type: Boolean },
    disabledModifiers: {}
  }),
  emits: /* @__PURE__ */ hd(["click"], ["update:busy", "update:disabled"]),
  setup(e, { emit: t }) {
    const s = t, n = sd(e, "busy"), r = sd(e, "disabled"), i = Ke(() => ({
      "fa-duotone": n.value,
      "fa-solid": n.value,
      "fa-spinner": n.value,
      "fa-spin": n.value,
      "fa-light": !n.value,
      "fa-save": !n.value,
      "me-2": !0
    }));
    function o(l) {
      n.value = !0, s("click", l);
    }
    return (l, d) => (p(), h("button", {
      type: "button",
      onClick: o,
      id: l.id,
      class: "btn btn-lava rounded",
      disabled: r.value || n.value
    }, [
      a("i", {
        class: z(i.value)
      }, null, 2),
      Ot(l.$slots, "default")
    ], 8, Q_));
  }
}), Z_ = me({
  name: "InvestorsDefaultFinancial",
  props: {
    idx: Boolean,
    busy: Boolean
  },
  data() {
    return {
      _busy: !1
    };
  },
  emits: [
    "update:busy"
  ],
  components: {
    LoadingStatus: Gk,
    NumericalInput: Aa,
    SaveButton: bb
  },
  watch: {
    busy(e) {
      this.busy != this._busy && (this._busy = e);
    },
    _busy(e) {
      this.busy != this._busy && this.$emit("update:busy", e);
    }
  },
  computed: {
    downpayment: {
      get() {
        var e;
        return ((e = this.parameters) == null ? void 0 : e.downpayment) * 100;
      },
      set(e) {
        this.parameters.downpayment = e / 100;
      }
    },
    accessIsFree() {
      var e;
      return ((e = this.access) == null ? void 0 : e.isFree) == !0;
    },
    isManagementFeePercent: {
      get() {
        return (this.parameters.percentageLongTermFields & U.PropertyManagement) == U.PropertyManagement;
      },
      set(e) {
        e ? this.parameters.percentageLongTermFields |= U.PropertyManagement : this.parameters.percentageLongTermFields &= ~U.PropertyManagement;
      }
    },
    isLeasingCommissionsPercent: {
      get() {
        return (this.parameters.percentageLongTermFields & U.LeasingCommissions) == U.LeasingCommissions;
      },
      set(e) {
        e ? this.parameters.percentageLongTermFields |= U.LeasingCommissions : this.parameters.percentageLongTermFields &= ~U.LeasingCommissions;
      }
    },
    isLeaseRenewalFeePercent: {
      get() {
        return (this.parameters.percentageLongTermFields & U.LeaseRenewalFee) == U.LeaseRenewalFee;
      },
      set(e) {
        e ? this.parameters.percentageLongTermFields |= U.LeaseRenewalFee : this.parameters.percentageLongTermFields &= ~U.LeaseRenewalFee;
      }
    },
    isPlatformServiceFeesPercent: {
      get() {
        return (this.parameters.percentageLongTermFields & U.PlatformServiceFees) == U.PlatformServiceFees;
      },
      set(e) {
        e ? this.parameters.percentageLongTermFields |= U.PlatformServiceFees : this.parameters.percentageLongTermFields &= ~U.PlatformServiceFees;
      }
    },
    isMaintenancePercent: {
      get() {
        return (this.parameters.percentageLongTermFields & U.PropertyMaintenance) == U.PropertyMaintenance;
      },
      set(e) {
        e ? this.parameters.percentageLongTermFields |= U.PropertyMaintenance : this.parameters.percentageLongTermFields &= ~U.PropertyMaintenance;
      }
    },
    isUtilityExpensesPercent: {
      get() {
        return (this.parameters.percentageLongTermFields & U.UtilityExpenses) == U.UtilityExpenses;
      },
      set(e) {
        e ? this.parameters.percentageLongTermFields |= U.UtilityExpenses : this.parameters.percentageLongTermFields &= ~U.UtilityExpenses;
      }
    },
    isFurnishingExpensesPercent: {
      get() {
        return (this.parameters.percentageLongTermFields & U.FurnishingExpenses) == U.FurnishingExpenses;
      },
      set(e) {
        e ? this.parameters.percentageLongTermFields |= U.FurnishingExpenses : this.parameters.percentageLongTermFields &= ~U.FurnishingExpenses;
      }
    },
    isConsumableExpensesPercent: {
      get() {
        return (this.parameters.percentageLongTermFields & U.ConsumableExpenses) == U.ConsumableExpenses;
      },
      set(e) {
        e ? this.parameters.percentageLongTermFields |= U.ConsumableExpenses : this.parameters.percentageLongTermFields &= ~U.ConsumableExpenses;
      }
    },
    isCleaningExpensesPercent: {
      get() {
        return (this.parameters.percentageLongTermFields & U.CleaningExpenses) == U.CleaningExpenses;
      },
      set(e) {
        e ? this.parameters.percentageLongTermFields |= U.CleaningExpenses : this.parameters.percentageLongTermFields &= ~U.CleaningExpenses;
      }
    },
    isOtherExpensePercent: {
      get() {
        return (this.parameters.percentageLongTermFields & U.OtherExpense) == U.OtherExpense;
      },
      set(e) {
        e ? this.parameters.percentageLongTermFields |= U.OtherExpense : this.parameters.percentageLongTermFields &= ~U.OtherExpense;
      }
    },
    isCapitalExpendituresPercent: {
      get() {
        return (this.parameters.percentageLongTermFields & U.CapitalExpenditures) == U.CapitalExpenditures;
      },
      set(e) {
        e ? this.parameters.percentageLongTermFields |= U.CapitalExpenditures : this.parameters.percentageLongTermFields &= ~U.CapitalExpenditures;
      }
    },
    //#region Short Term
    isStrManagementFeePercent: {
      get() {
        return (this.parameters.percentageShortTermFields & U.PropertyManagement) == U.PropertyManagement;
      },
      set(e) {
        e ? this.parameters.percentageShortTermFields |= U.PropertyManagement : this.parameters.percentageShortTermFields &= ~U.PropertyManagement;
      }
    },
    isStrLeasingCommissionsPercent: {
      get() {
        return (this.parameters.percentageShortTermFields & U.LeasingCommissions) == U.LeasingCommissions;
      },
      set(e) {
        e ? this.parameters.percentageShortTermFields |= U.LeasingCommissions : this.parameters.percentageShortTermFields &= ~U.LeasingCommissions;
      }
    },
    isStrPlatformServiceFeesPercent: {
      get() {
        return (this.parameters.percentageShortTermFields & U.PlatformServiceFees) == U.PlatformServiceFees;
      },
      set(e) {
        e ? this.parameters.percentageShortTermFields |= U.PlatformServiceFees : this.parameters.percentageShortTermFields &= ~U.PlatformServiceFees;
      }
    },
    isStrMaintenancePercent: {
      get() {
        return (this.parameters.percentageShortTermFields & U.PropertyMaintenance) == U.PropertyMaintenance;
      },
      set(e) {
        e ? this.parameters.percentageShortTermFields |= U.PropertyMaintenance : this.parameters.percentageShortTermFields &= ~U.PropertyMaintenance;
      }
    },
    isStrUtilityExpensesPercent: {
      get() {
        return (this.parameters.percentageShortTermFields & U.UtilityExpenses) == U.UtilityExpenses;
      },
      set(e) {
        e ? this.parameters.percentageShortTermFields |= U.UtilityExpenses : this.parameters.percentageShortTermFields &= ~U.UtilityExpenses;
      }
    },
    isStrFurnishingExpensesPercent: {
      get() {
        return (this.parameters.percentageShortTermFields & U.FurnishingExpenses) == U.FurnishingExpenses;
      },
      set(e) {
        e ? this.parameters.percentageShortTermFields |= U.FurnishingExpenses : this.parameters.percentageShortTermFields &= ~U.FurnishingExpenses;
      }
    },
    isStrConsumableExpensesPercent: {
      get() {
        return (this.parameters.percentageShortTermFields & U.ConsumableExpenses) == U.ConsumableExpenses;
      },
      set(e) {
        e ? this.parameters.percentageShortTermFields |= U.ConsumableExpenses : this.parameters.percentageShortTermFields &= ~U.ConsumableExpenses;
      }
    },
    isStrCleaningExpensesPercent: {
      get() {
        return (this.parameters.percentageShortTermFields & U.CleaningExpenses) == U.CleaningExpenses;
      },
      set(e) {
        e ? this.parameters.percentageShortTermFields |= U.CleaningExpenses : this.parameters.percentageShortTermFields &= ~U.CleaningExpenses;
      }
    },
    isStrOtherExpensePercent: {
      get() {
        return (this.parameters.percentageShortTermFields & U.OtherExpense) == U.OtherExpense;
      },
      set(e) {
        e ? this.parameters.percentageShortTermFields |= U.OtherExpense : this.parameters.percentageShortTermFields &= ~U.OtherExpense;
      }
    },
    isStrCapitalExpendituresPercent: {
      get() {
        return (this.parameters.percentageShortTermFields & U.CapitalExpenditures) == U.CapitalExpenditures;
      },
      set(e) {
        e ? this.parameters.percentageShortTermFields |= U.CapitalExpenditures : this.parameters.percentageShortTermFields &= ~U.CapitalExpenditures;
      }
    },
    //#endregion
    //#region PadSplit
    isPadSplitManagementFeePercent: {
      get() {
        return (this.parameters.percentagePadSplitFields & U.PropertyManagement) == U.PropertyManagement;
      },
      set(e) {
        e ? this.parameters.percentagePadSplitFields |= U.PropertyManagement : this.parameters.percentagePadSplitFields &= ~U.PropertyManagement;
      }
    },
    isPadSplitLeasingCommissionsPercent: {
      get() {
        return (this.parameters.percentagePadSplitFields & U.LeasingCommissions) == U.LeasingCommissions;
      },
      set(e) {
        e ? this.parameters.percentagePadSplitFields |= U.LeasingCommissions : this.parameters.percentagePadSplitFields &= ~U.LeasingCommissions;
      }
    },
    isPadSplitMaintenancePercent: {
      get() {
        return (this.parameters.percentagePadSplitFields & U.PropertyMaintenance) == U.PropertyMaintenance;
      },
      set(e) {
        e ? this.parameters.percentagePadSplitFields |= U.PropertyMaintenance : this.parameters.percentagePadSplitFields &= ~U.PropertyMaintenance;
      }
    },
    isPadSplitUtilityExpensesPercent: {
      get() {
        return (this.parameters.percentagePadSplitFields & U.UtilityExpenses) == U.UtilityExpenses;
      },
      set(e) {
        e ? this.parameters.percentagePadSplitFields |= U.UtilityExpenses : this.parameters.percentagePadSplitFields &= ~U.UtilityExpenses;
      }
    },
    isPadSplitFurnishingExpensesPercent: {
      get() {
        return (this.parameters.percentagePadSplitFields & U.FurnishingExpenses) == U.FurnishingExpenses;
      },
      set(e) {
        e ? this.parameters.percentagePadSplitFields |= U.FurnishingExpenses : this.parameters.percentagePadSplitFields &= ~U.FurnishingExpenses;
      }
    },
    isPadSplitConsumableExpensesPercent: {
      get() {
        return (this.parameters.percentagePadSplitFields & U.ConsumableExpenses) == U.ConsumableExpenses;
      },
      set(e) {
        e ? this.parameters.percentagePadSplitFields |= U.ConsumableExpenses : this.parameters.percentagePadSplitFields &= ~U.ConsumableExpenses;
      }
    },
    isPadSplitCleaningExpensesPercent: {
      get() {
        return (this.parameters.percentagePadSplitFields & U.CleaningExpenses) == U.CleaningExpenses;
      },
      set(e) {
        e ? this.parameters.percentagePadSplitFields |= U.CleaningExpenses : this.parameters.percentagePadSplitFields &= ~U.CleaningExpenses;
      }
    },
    isPadSplitOtherExpensePercent: {
      get() {
        return (this.parameters.percentagePadSplitFields & U.OtherExpense) == U.OtherExpense;
      },
      set(e) {
        e ? this.parameters.percentagePadSplitFields |= U.OtherExpense : this.parameters.percentagePadSplitFields &= ~U.OtherExpense;
      }
    },
    isPadSplitCapitalExpendituresPercent: {
      get() {
        return (this.parameters.percentagePadSplitFields & U.CapitalExpenditures) == U.CapitalExpenditures;
      },
      set(e) {
        e ? this.parameters.percentagePadSplitFields |= U.CapitalExpenditures : this.parameters.percentagePadSplitFields &= ~U.CapitalExpenditures;
      }
    },
    //#endregion
    canUseCalculatorAdvanced() {
      var e, t;
      return ((t = (e = this.access) == null ? void 0 : e.calculator) == null ? void 0 : t.advanced) == !0;
    },
    parameters() {
      return this.idx ? this.accountStore.idxSearchParameters : this.accountStore.myParameters;
    },
    ...q(ct, ["myParameters", "idxSearchParameters", "incomeAccountsSorted", "operatingExpenseAccountsSorted", "otherExpenseAccounts", "otherNonOperatingExpenseAccounts", "initialized"]),
    ...q(Te, ["access", "aclLoaded"]),
    ...at(ct)
  },
  methods: {
    async loadParameters() {
      var e, t, s, n;
      this.idx ? await this.accountStore.fetchIdxSearchParameters() : await this.accountStore.fetchMyParameters(), this.parameters && ((e = this.parameters).otherExpenses ?? (e.otherExpenses = {}), (t = this.parameters.otherExpenses).longTerm ?? (t.longTerm = []), (s = this.parameters.otherExpenses).shortTerm ?? (s.shortTerm = []), (n = this.parameters.otherExpenses).padSplit ?? (n.padSplit = []), this.otherExpenseAccounts.forEach((r) => {
        const i = this.parameters.otherExpenses.longTerm.find((d) => d.id == r.id), o = this.parameters.otherExpenses.shortTerm.find((d) => d.id == r.id), l = this.parameters.otherExpenses.padSplit.find((d) => d.id == r.id);
        i || this.parameters.otherExpenses.longTerm.push({
          id: r.id,
          nonOperating: r.nonOperating
        }), o || this.parameters.otherExpenses.shortTerm.push({
          id: r.id,
          nonOperating: r.nonOperating
        }), l || this.parameters.otherExpenses.padSplit.push({
          id: r.id,
          nonOperating: r.nonOperating
        });
      }));
    },
    async saveDefaults() {
      try {
        this.idx ? (await this.accountStore.updateIdxSearchParameters(), wt("Default IDX investment parameters have been saved.")) : (await this.accountStore.updateMyFinancialParameters(), wt("Residential Model Assumption parameters have been saved."));
      } catch (e) {
        (!Zt.isModelStateException(e) || !e.showFormErrors(this.$refs.investorsDefaultFinancial)) && Se(e);
      } finally {
        this.$emit("update:busy", !1), this._busy = !1;
      }
    },
    inputNumberStyle(e) {
      return {
        "form-control": !0,
        "text-end": e
      };
    },
    longTermOtherAccountValue(e) {
      var t, s, n, r, i, o;
      if (e)
        return this.idx ? (n = (s = (t = this.idxSearchParameters) == null ? void 0 : t.otherExpenses) == null ? void 0 : s.longTerm) == null ? void 0 : n.find((l) => l.id == e) : (o = (i = (r = this.myParameters) == null ? void 0 : r.otherExpenses) == null ? void 0 : i.longTerm) == null ? void 0 : o.find((l) => l.id == e);
    },
    shortTermOtherAccountValue(e) {
      var t, s, n, r, i, o;
      if (e)
        return this.idx ? (n = (s = (t = this.idxSearchParameters) == null ? void 0 : t.otherExpenses) == null ? void 0 : s.shortTerm) == null ? void 0 : n.find((l) => l.id == e) : (o = (i = (r = this.myParameters) == null ? void 0 : r.otherExpenses) == null ? void 0 : i.shortTerm) == null ? void 0 : o.find((l) => l.id == e);
    },
    padSplitOtherAccountValue(e) {
      var t, s, n, r, i, o;
      if (e)
        return this.idx ? (n = (s = (t = this.idxSearchParameters) == null ? void 0 : t.otherExpenses) == null ? void 0 : s.padSplit) == null ? void 0 : n.find((l) => l.id == e) : (o = (i = (r = this.myParameters) == null ? void 0 : r.otherExpenses) == null ? void 0 : i.padSplit) == null ? void 0 : o.find((l) => l.id == e);
    }
  },
  mounted() {
    this.aclLoaded.then(() => this.loadParameters());
  }
}), nn = "data:image/svg+xml,%3csvg%20width='243'%20height='43'%20viewBox='0%200%20243%2043'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cmask%20id='mask0'%20style='mask-type:alpha'%20maskUnits='userSpaceOnUse'%20x='2'%20y='0'%20width='27'%20height='25'%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M2%200.292023H28.761V24.5082H2V0.292023Z'%20fill='white'/%3e%3c/mask%3e%3cg%20mask='url(%23mask0)'%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M24.64%207.75364C24.0137%207.6284%2023.3767%207.57068%2022.7385%207.57992C22.1651%207.58857%2021.5952%207.65091%2021.0361%207.76692C21.2744%206.63105%2021.2726%205.46056%2021.0307%204.32585C21.6582%204.45052%2022.2982%204.50592%2022.9417%204.49842C23.514%204.48919%2024.0832%204.4257%2024.6412%204.30969C24.5307%204.83145%2024.4707%205.36244%2024.4617%205.89517C24.451%206.51966%2024.5111%207.14242%2024.64%207.75364ZM26.7532%200.292023C25.6896%201.20683%2024.3199%201.72282%2022.8949%201.74533C21.4706%201.78977%2020.0896%201.2986%2018.9986%200.424771L17.005%202.36463C18.8026%204.47244%2018.8507%207.45351%2017.1518%209.58095L9.13877%2017.364L7.31986%2015.5979L5.28288%2017.5759L7.10178%2019.3426L5.85571%2020.5529L4.03739%2018.7862L1.99982%2020.7647L5.85689%2024.5082L19.1454%2011.5981C21.3559%209.87934%2024.4352%209.89146%2026.6332%2011.6259L28.6268%209.68888C27.7456%208.63555%2027.2731%207.3046%2027.2957%205.9396C27.3189%204.57287%2027.8394%203.25404%2028.7611%202.22669L26.7532%200.292023Z'%20fill='%23ECBC3E'/%3e%3c/g%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M21.7266%2034.353C22.3983%2034.4808%2023.0815%2034.5405%2023.7659%2034.531C24.3809%2034.5222%2024.9921%2034.4577%2025.5918%2034.3394C25.3362%2035.5029%2025.3381%2036.7031%2025.5975%2037.8654C24.9252%2037.7382%2024.2382%2037.6814%2023.548%2037.6891C22.9343%2037.6986%2022.3238%2037.7637%2021.7254%2037.8826C21.8439%2037.3478%2021.9083%2036.803%2021.9178%2036.2577C21.9293%2035.6171%2021.8649%2034.9794%2021.7266%2034.353ZM19.4605%2042.0001C20.6012%2041.0625%2022.0701%2040.5337%2023.5983%2040.5107C25.1259%2040.4651%2026.607%2040.9685%2027.777%2041.8641L29.9151%2039.876C27.9873%2037.7158%2027.9357%2034.6606%2029.7584%2032.4803L38.3515%2024.5037L40.3022%2026.3137L42.4869%2024.2866L40.5361%2022.476L41.8725%2021.2356L43.8226%2023.0462L46.0079%2021.0185L41.8712%2017.1819L27.6196%2030.4129C25.2489%2032.1744%2021.9465%2032.162%2019.5892%2030.3845L17.4511%2032.3691C18.3962%2033.4486%2018.9035%2034.8132%2018.8786%2036.2115C18.8538%2037.6128%2018.2955%2038.9644%2017.3071%2040.0173L19.4605%2042.0001Z'%20fill='%23ECBC3E'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M219.071%207.39584L216.547%209.91966L214.024%207.39584L216.547%204.87201L219.071%207.39584Z'%20fill='%23171717'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M81.9369%2012.1049C81.9369%209.85536%2081.0928%208.98957%2078.8974%208.98957H68.2607V21.4504H78.8974C81.0928%2021.4504%2081.9369%2020.5852%2081.9369%2018.335V12.1049ZM79.0663%206.13394C83.0769%206.13394%2084.9764%208.0814%2084.9764%2012.191V18.2487C84.9764%2022.3589%2083.0769%2024.3057%2079.0663%2024.3057H68.2607V33.7374H73.1567V36.4199H61V33.7374H65.2213V8.81698H61V6.13394H79.0663Z'%20fill='%23171717'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M96.6005%2025.3361C94.338%2025.6009%2093.4332%2026.2181%2093.4332%2029.568C93.4332%2032.9173%2094.338%2033.9756%2097.5053%2033.9756C101.533%2033.9756%20103.523%2032.961%20106.193%2031.1103V24.2785L96.6005%2025.3361ZM113.071%2036.4428H106.193V33.1814C104.156%2035.5178%20101.894%2036.6191%2097.4599%2036.6191C92.3474%2036.6191%2090.3561%2034.5038%2090.3561%2029.568C90.3561%2024.6309%2092.3474%2023.2649%2096.5103%2022.8681C98.7273%2022.6477%20102.211%2022.3835%20106.193%2022.2073V18.3727C106.193%2016.1689%20105.288%2015.2869%20103.026%2015.2869H97.4151C95.1527%2015.2869%2094.2478%2016.1689%2094.2478%2018.3727V19.0342H91.1707V18.6369C91.1707%2014.5818%2093.162%2012.6428%2097.3243%2012.6428H103.116C107.279%2012.6428%20109.27%2014.5818%20109.27%2018.6369V33.8865H113.071V36.4428Z'%20fill='%23171717'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M134.027%2018.657C131.42%2016.8517%20129.475%2015.8628%20125.322%2015.8628C122.007%2015.8628%20121.123%2016.7229%20121.123%2018.8721V31.0785C121.123%2033.2276%20122.007%2034.0871%20125.322%2034.0871C129.475%2034.0871%20131.42%2033.0982%20134.027%2031.2935V18.657ZM140.833%2036.5801H134.027V33.3995C131.685%2035.3336%20129.829%2036.752%20125.277%2036.752C120.062%2036.752%20118.118%2034.861%20118.118%2030.9066V19.044C118.118%2015.0896%20120.062%2013.1986%20125.277%2013.1986C129.829%2013.1986%20131.685%2014.617%20134.027%2016.5511V7.69705H129.608V5.20413H137.032V34.0871H140.833V36.5801Z'%20fill='%23171717'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M162.65%2011.9317C162.65%209.68219%20161.816%208.81639%20159.647%208.81639H151.971C149.801%208.81639%20148.967%209.68219%20148.967%2011.9317V15.0037C148.967%2017.2966%20149.926%2018.0316%20151.971%2018.5079L160.064%2020.4548C163.318%2021.2332%20166.071%2022.099%20166.071%2026.6415V30.3622C166.071%2034.473%20164.194%2036.4199%20160.231%2036.4199H151.72C147.757%2036.4199%20145.88%2034.473%20145.88%2030.3622V27.2909H148.884V30.6221C148.884%2032.8722%20149.718%2033.7368%20151.887%2033.7368H160.064C162.233%2033.7368%20163.067%2032.8722%20163.067%2030.6221V26.9876C163.067%2024.6946%20162.108%2023.9597%20160.064%2023.4833L151.971%2021.5365C148.717%2020.7575%20145.964%2019.8923%20145.964%2015.3492V12.191C145.964%208.08082%20147.841%206.13394%20151.804%206.13394H159.813C163.776%206.13394%20165.654%208.08082%20165.654%2012.191V14.9603H162.65V11.9317Z'%20fill='%23171717'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M188.327%2018.3215C188.327%2016.1704%20187.45%2015.3095%20184.161%2015.3095C180.04%2015.3095%20178.11%2016.2999%20175.523%2018.1063V30.7543C178.11%2032.5613%20180.04%2033.5505%20184.161%2033.5505C187.45%2033.5505%20188.327%2032.6902%20188.327%2030.5391V18.3215ZM191.309%2018.4935V30.367C191.309%2034.325%20189.38%2036.2177%20184.205%2036.2177C179.689%2036.2177%20177.847%2034.798%20175.523%2032.8622V40.4341H180.171V42.9287H168.595V40.4341H172.541V15.3094H168.595V12.8148H175.523V15.9989C177.847%2014.0624%20179.689%2012.6428%20184.205%2012.6428C189.38%2012.6428%20191.309%2014.5354%20191.309%2018.4935Z'%20fill='%23171717'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M208.976%2036.5H197.619V34.0937H201.808V8.62041H197.619V6.2141H204.973V34.0937H208.976V36.5Z'%20fill='%23171717'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M224.119%2036.5002H212.762V34.0438H216.951V15.2174H212.762V12.6428H220.116V34.0438H224.119V36.5002Z'%20fill='%23171717'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M231.981%2031.2995C231.981%2033.4655%20232.872%2034.3318%20235.102%2034.3318H238V37.0176H235.012C230.911%2037.0176%20228.948%2035.1118%20228.948%2031.1263V16.2243H225.381V13.6254H228.948V7.99362H231.981V13.6254H238V16.2243H231.981V31.2995Z'%20fill='%23171717'/%3e%3c/svg%3e", J_ = {
  key: 1,
  ref: "investorsDefaultFinancial"
}, $_ = { class: "grid row g-4" }, __ = { class: "grid-item col-md-6" }, eee = { class: "card shadow-sm h-100" }, tee = { class: "card-body" }, see = { class: "row g-3" }, aee = { class: "col-sm-5" }, nee = ["disabled"], ree = ["value"], oee = { class: "col-sm-5" }, iee = { class: "col-sm-5" }, lee = { class: "grid-item col-md-6" }, dee = { class: "card shadow-sm" }, cee = { class: "card-header bg-white fw-bold pb-0 border-0" }, uee = {
  key: 0,
  class: "card-body"
}, pee = { class: "row g-3" }, hee = {
  for: "downpayment",
  class: "col-sm-7 col-form-label"
}, mee = { class: "col-sm-5" }, fee = { class: "input-group" }, gee = ["disabled"], vee = ["value"], yee = {
  for: "loanfees",
  class: "col-sm-7 col-form-label"
}, bee = { class: "col-sm-5" }, Aee = {
  for: "interestrate",
  class: "col-sm-7 col-form-label"
}, wee = { class: "col-sm-5" }, Cee = {
  for: "amortizationPeriod",
  class: "col-sm-7 col-form-label"
}, See = { class: "col-sm-5" }, Pee = { class: "grid-item col-md-12" }, kee = { class: "card shadow-sm" }, Eee = { class: "card-header bg-white fw-bold pb-0 border-0" }, Iee = { class: "card-body" }, Tee = { class: "row row-cols-1 row-cols-md-3" }, Oee = { class: "col" }, Ree = { class: "bg-light rounded p-3 h-100" }, Lee = { class: "fw-bold" }, Bee = { class: "mb-3" }, Mee = {
  for: "annualrentalgrowth",
  class: "form-label"
}, xee = { class: "mb-3" }, Fee = {
  for: "annualexpensegrowth",
  class: "form-label"
}, Vee = { class: "mb-3" }, Dee = {
  for: "propertyappreciation",
  class: "form-label"
}, Nee = { class: "col" }, jee = { class: "bg-light rounded p-3 h-100" }, Hee = { class: "fw-bold" }, Uee = { class: "mb-3" }, zee = {
  for: "annualrentalgrowth",
  class: "form-label"
}, Wee = { class: "mb-3" }, Gee = {
  for: "annualexpensegrowth",
  class: "form-label"
}, Yee = { class: "mb-3" }, Xee = {
  for: "propertyappreciation",
  class: "form-label"
}, qee = { class: "col" }, Qee = { class: "bg-light rounded p-3 h-100" }, Kee = { class: "mb-3" }, Zee = {
  for: "annualrentalgrowth",
  class: "form-label"
}, Jee = { class: "mb-3" }, $ee = {
  for: "annualexpensegrowth",
  class: "form-label"
}, _ee = { class: "mb-3" }, ete = {
  for: "propertyappreciation",
  class: "form-label"
}, tte = { class: "grid-item col-md-12 mb-4" }, ste = { class: "card shadow-sm" }, ate = { class: "card-header bg-white fw-bold pb-0 border-0" }, nte = {
  key: 0,
  class: "card-body"
}, rte = { class: "row row-cols-1 row-cols-md-3" }, ote = { class: "col" }, ite = { class: "bg-light rounded p-3 h-100" }, lte = { class: "fw-bold" }, dte = { class: "mb-3" }, cte = {
  for: "averagelengthofstay",
  class: "form-label"
}, ute = ["disabled"], pte = { value: 1 }, hte = { value: 2 }, mte = { value: 3 }, fte = { value: 4 }, gte = { value: 5 }, vte = { value: 6 }, yte = { value: 7 }, bte = { value: 8 }, Ate = { value: 9 }, wte = { value: 10 }, Cte = {
  for: "timebetweentenants",
  class: "form-label"
}, Ste = { class: "col" }, Pte = { class: "bg-light rounded p-3 h-100" }, kte = { class: "mb-3" }, Ete = { class: "col" }, Ite = { class: "bg-light rounded p-3 h-100" }, Tte = { class: "mb-3" }, Ote = { class: "fw-bold fs-5 text-secondary mb-4" }, Rte = { class: "table-responsive mb-5" }, Lte = { class: "table table-fixed table-sm table-operating-expenses table-transparent" }, Bte = { class: "text-center" }, Mte = { class: "align-middle" }, xte = { class: "border-back position-relative align-middle" }, Fte = { class: "d-flex justify-content-center" }, Vte = { class: "badge rounded-pill text-bg-eclipse" }, Dte = { class: "align-middle" }, Nte = { class: "border-back position-relative align-middle" }, jte = { class: "d-flex justify-content-center" }, Hte = { class: "badge rounded-pill text-bg-eclipse" }, Ute = { class: "align-middle" }, zte = { class: "border-back position-relative align-middle" }, Wte = { class: "d-flex justify-content-center" }, Gte = { class: "badge rounded-pill text-bg-eclipse" }, Yte = { class: "align-middle" }, Xte = { class: "text-end" }, qte = { class: "align-middle" }, Qte = {
  key: 0,
  class: "faded text-dark text-opacity-25"
}, Kte = { class: "align-middle" }, Zte = { class: "faded text-dark text-opacity-25" }, Jte = { class: "align-middle" }, $te = { class: "align-middle" }, _te = { class: "align-middle" }, ese = { class: "align-middle" }, tse = { class: "align-middle" }, sse = { class: "align-middle" }, ase = { class: "align-middle" }, nse = { class: "fw-bold fs-5 text-secondary mb-4" }, rse = { class: "table-responsive mb-5" }, ose = { class: "table table-fixed table-sm table-non-operating-expenses table-transparent" }, ise = { class: "text-center" }, lse = { class: "align-middle" }, dse = { class: "faded text-dark text-opacity-25" }, cse = { class: "text-end mt-3 mt-lg-5" }, use = {
  key: 2,
  class: "card shadow-sm card-guard-investment py-5 py-xl-10 mb-4"
}, pse = { class: "card-body" }, hse = { class: "row" }, mse = { class: "col-md-5 col-lg-6 text-center text-md-start py-3" }, fse = { class: "fw-bold fs-5" }, gse = {
  href: "https://www.rescover.com/signup",
  class: "btn btn-lava"
};
function vse(e, t, s, n, r, i) {
  const o = pe("loading-status"), l = pe("numerical-input"), d = pe("save-button");
  return e.parameters ? e.canUseCalculatorAdvanced ? (p(), h("div", J_, [
    a("div", $_, [
      a("div", __, [
        a("div", eee, [
          a("div", {
            class: "card-header bg-white fw-bold pb-0 border-0",
            onClick: t[0] || (t[0] = (...c) => e.loadParameters && e.loadParameters(...c))
          }, g(e.$t("t-hold-period-transaction-costs")), 1),
          a("div", tee, [
            a("div", see, [
              t[82] || (t[82] = a("label", {
                class: "col-sm-7 col-form-label",
                for: "lenghtoftime"
              }, "Length of Time", -1)),
              a("div", aee, [
                V(a("select", {
                  class: "form-select",
                  "onUpdate:modelValue": t[1] || (t[1] = (c) => e.parameters.hold = c),
                  id: "lenghtoftime",
                  disabled: e._busy
                }, [
                  t[81] || (t[81] = a("option", { value: 0 }, "Auto", -1)),
                  (p(), h(A, null, D(30, (c) => a("option", {
                    value: c,
                    key: c
                  }, g(c) + " Years", 9, ree)), 64))
                ], 8, nee), [
                  [We, e.parameters.hold]
                ])
              ]),
              t[83] || (t[83] = a("label", {
                class: "col-sm-7 col-form-label",
                for: "titlecharges"
              }, "Acquisition Closing Costs", -1)),
              a("div", oee, [
                N(l, {
                  modelValue: e.parameters.titleCharges,
                  "onUpdate:modelValue": t[2] || (t[2] = (c) => e.parameters.titleCharges = c),
                  currency: "",
                  placeholder: "",
                  class: "text-end",
                  disabled: e._busy
                }, null, 8, ["modelValue", "disabled"])
              ]),
              t[84] || (t[84] = a("label", {
                class: "col-sm-7 col-form-label",
                for: "costofsale"
              }, "Deposition Closing Costs", -1)),
              a("div", iee, [
                N(l, {
                  modelValue: e.parameters.costOfSale,
                  "onUpdate:modelValue": t[3] || (t[3] = (c) => e.parameters.costOfSale = c),
                  percent: "",
                  placeholder: "ie: 8",
                  class: "text-end",
                  disabled: e._busy
                }, null, 8, ["modelValue", "disabled"])
              ])
            ])
          ])
        ])
      ]),
      a("div", lee, [
        a("div", dee, [
          a("div", cee, g(e.$t("t-loan-details")), 1),
          e.parameters ? (p(), h("div", uee, [
            a("div", pee, [
              a("label", hee, g(e.$t("t-down-payment")), 1),
              a("div", mee, [
                a("div", fee, [
                  V(a("select", {
                    class: "form-select text-end",
                    id: "downpayment",
                    "onUpdate:modelValue": t[4] || (t[4] = (c) => e.downpayment = c),
                    disabled: e._busy
                  }, [
                    (p(), h(A, null, D(100 / 5, (c) => a("option", {
                      value: c * 5,
                      key: c
                    }, g(c * 5), 9, vee)), 64))
                  ], 8, gee), [
                    [We, e.downpayment]
                  ]),
                  t[85] || (t[85] = a("span", { class: "input-group-text" }, "%", -1))
                ])
              ]),
              a("label", yee, g(e.$t("t-loan-fees")), 1),
              a("div", bee, [
                N(l, {
                  modelValue: e.parameters.loanFees,
                  "onUpdate:modelValue": t[5] || (t[5] = (c) => e.parameters.loanFees = c),
                  percent: "",
                  class: "text-end",
                  disabled: e._busy
                }, null, 8, ["modelValue", "disabled"])
              ]),
              a("label", Aee, g(e.$t("t-interest-rate")), 1),
              a("div", wee, [
                N(l, {
                  modelValue: e.parameters.interestRate,
                  "onUpdate:modelValue": t[6] || (t[6] = (c) => e.parameters.interestRate = c),
                  percent: "",
                  class: "text-end",
                  disabled: e._busy
                }, null, 8, ["modelValue", "disabled"])
              ]),
              a("label", Cee, g(e.$t("t-amortization-period-years")), 1),
              a("div", See, [
                V(a("input", {
                  type: "text",
                  class: "form-control",
                  "onUpdate:modelValue": t[7] || (t[7] = (c) => e.parameters.amortizationPeriod = c)
                }, null, 512), [
                  [_e, e.parameters.amortizationPeriod]
                ])
              ])
            ])
          ])) : P("", !0)
        ])
      ]),
      a("div", Pee, [
        a("div", kee, [
          a("div", Eee, g(e.$t("t-inflation-appreciation")), 1),
          a("div", Iee, [
            a("div", Tee, [
              a("div", Oee, [
                a("div", Ree, [
                  a("p", Lee, [
                    t[86] || (t[86] = a("i", { class: "fa-light fa-calendar-range me-2" }, null, -1)),
                    y(g(e.$t("t-long-term")), 1)
                  ]),
                  a("div", Bee, [
                    a("label", Mee, g(e.$t("t-annual-rental-rate-increase")), 1),
                    N(l, {
                      modelValue: e.parameters.annualRentalGrowth,
                      "onUpdate:modelValue": t[8] || (t[8] = (c) => e.parameters.annualRentalGrowth = c),
                      percent: "",
                      class: "text-end",
                      disabled: e._busy
                    }, null, 8, ["modelValue", "disabled"])
                  ]),
                  a("div", xee, [
                    a("label", Fee, g(e.$t("t-annual-expense-inflation")), 1),
                    N(l, {
                      modelValue: e.parameters.annualExpenseGrowth,
                      "onUpdate:modelValue": t[9] || (t[9] = (c) => e.parameters.annualExpenseGrowth = c),
                      percent: "",
                      class: "text-end",
                      disabled: e._busy
                    }, null, 8, ["modelValue", "disabled"])
                  ]),
                  a("div", Vee, [
                    a("label", Dee, g(e.$t("t-annual-property-appreciation")), 1),
                    N(l, {
                      modelValue: e.parameters.propertyAppreciation,
                      "onUpdate:modelValue": t[10] || (t[10] = (c) => e.parameters.propertyAppreciation = c),
                      percent: "",
                      class: "text-end",
                      disabled: e._busy
                    }, null, 8, ["modelValue", "disabled"])
                  ])
                ])
              ]),
              a("div", Nee, [
                a("div", jee, [
                  a("p", Hee, [
                    t[87] || (t[87] = a("i", { class: "fa-light fa-timer me-2" }, null, -1)),
                    y(g(e.$t("t-short-term")), 1)
                  ]),
                  a("div", Uee, [
                    a("label", zee, g(e.$t("t-annual-rental-rate-increase")), 1),
                    N(l, {
                      modelValue: e.parameters.strAnnualRentalGrowth,
                      "onUpdate:modelValue": t[11] || (t[11] = (c) => e.parameters.strAnnualRentalGrowth = c),
                      percent: "",
                      class: "text-end",
                      disabled: e._busy
                    }, null, 8, ["modelValue", "disabled"])
                  ]),
                  a("div", Wee, [
                    a("label", Gee, g(e.$t("t-annual-expense-inflation")), 1),
                    N(l, {
                      modelValue: e.parameters.strAnnualExpenseGrowth,
                      "onUpdate:modelValue": t[12] || (t[12] = (c) => e.parameters.strAnnualExpenseGrowth = c),
                      percent: "",
                      class: "text-end",
                      disabled: e._busy
                    }, null, 8, ["modelValue", "disabled"])
                  ]),
                  a("div", Yee, [
                    a("label", Xee, g(e.$t("t-annual-property-appreciation")), 1),
                    N(l, {
                      modelValue: e.parameters.strPropertyAppreciation,
                      "onUpdate:modelValue": t[13] || (t[13] = (c) => e.parameters.strPropertyAppreciation = c),
                      percent: "",
                      class: "text-end",
                      disabled: e._busy
                    }, null, 8, ["modelValue", "disabled"])
                  ])
                ])
              ]),
              a("div", qee, [
                a("div", Qee, [
                  t[88] || (t[88] = a("p", { class: "fw-bold" }, [
                    a("img", {
                      src: nn,
                      alt: "PadSplit",
                      title: "PadSplit",
                      loading: "lazy",
                      class: "img-fluid",
                      width: "85"
                    })
                  ], -1)),
                  a("div", Kee, [
                    a("label", Zee, g(e.$t("t-annual-rental-rate-increase")), 1),
                    N(l, {
                      modelValue: e.parameters.padSplitAnnualRentalGrowth,
                      "onUpdate:modelValue": t[14] || (t[14] = (c) => e.parameters.padSplitAnnualRentalGrowth = c),
                      percent: "",
                      class: "text-end",
                      disabled: e._busy
                    }, null, 8, ["modelValue", "disabled"])
                  ]),
                  a("div", Jee, [
                    a("label", $ee, g(e.$t("t-annual-expense-inflation")), 1),
                    N(l, {
                      modelValue: e.parameters.padSplitAnnualExpenseGrowth,
                      "onUpdate:modelValue": t[15] || (t[15] = (c) => e.parameters.padSplitAnnualExpenseGrowth = c),
                      percent: "",
                      class: "text-end",
                      disabled: e._busy
                    }, null, 8, ["modelValue", "disabled"])
                  ]),
                  a("div", _ee, [
                    a("label", ete, g(e.$t("t-annual-property-appreciation")), 1),
                    N(l, {
                      modelValue: e.parameters.padSplitPropertyAppreciation,
                      "onUpdate:modelValue": t[16] || (t[16] = (c) => e.parameters.padSplitPropertyAppreciation = c),
                      percent: "",
                      class: "text-end",
                      disabled: e._busy
                    }, null, 8, ["modelValue", "disabled"])
                  ])
                ])
              ])
            ])
          ])
        ])
      ]),
      a("div", tte, [
        a("div", ste, [
          a("div", ate, g(e.$t("t-vacancy")), 1),
          e.parameters ? (p(), h("div", nte, [
            a("div", rte, [
              a("div", ote, [
                a("div", ite, [
                  a("p", lte, [
                    t[89] || (t[89] = a("i", { class: "fa-light fa-calendar-range me-2" }, null, -1)),
                    y(g(e.$t("t-long-term")), 1)
                  ]),
                  P("", !0),
                  a("div", dte, [
                    a("label", cte, g(e.$t("t-average-lenght-of-stay")), 1),
                    V(a("select", {
                      class: "form-select",
                      "onUpdate:modelValue": t[17] || (t[17] = (c) => e.parameters.averageLengthOfStay = c),
                      disabled: e._busy
                    }, [
                      a("option", pte, "1 " + g(e.$t("t-year")), 1),
                      a("option", hte, "2 " + g(e.$t("t-years")), 1),
                      a("option", mte, "3 " + g(e.$t("t-years")), 1),
                      a("option", fte, "4 " + g(e.$t("t-years")), 1),
                      a("option", gte, "5 " + g(e.$t("t-years")), 1),
                      a("option", vte, "6 " + g(e.$t("t-years")), 1),
                      a("option", yte, "7 " + g(e.$t("t-years")), 1),
                      a("option", bte, "8 " + g(e.$t("t-years")), 1),
                      a("option", Ate, "9 " + g(e.$t("t-years")), 1),
                      a("option", wte, "10 " + g(e.$t("t-years")), 1)
                    ], 8, ute), [
                      [
                        We,
                        e.parameters.averageLengthOfStay,
                        void 0,
                        { number: !0 }
                      ]
                    ])
                  ]),
                  a("div", null, [
                    a("label", Cte, g(e.$t("t-average-time-between-tenants-days")), 1),
                    N(l, {
                      modelValue: e.parameters.timeBetweenTenants,
                      "onUpdate:modelValue": t[18] || (t[18] = (c) => e.parameters.timeBetweenTenants = c),
                      class: "form-control",
                      disabled: e._busy
                    }, null, 8, ["modelValue", "disabled"])
                  ])
                ])
              ]),
              a("div", Ste, [
                a("div", Pte, [
                  t[94] || (t[94] = a("p", { class: "fw-bold" }, [
                    a("i", { class: "fa-light fa-timer me-2" }),
                    y("Short Term")
                  ], -1)),
                  P("", !0),
                  a("div", kte, [
                    t[92] || (t[92] = a("label", { class: "form-label" }, "Days Available per Year", -1)),
                    N(l, {
                      modelValue: e.parameters.strDaysAvailablePerYear,
                      "onUpdate:modelValue": t[19] || (t[19] = (c) => e.parameters.strDaysAvailablePerYear = c),
                      class: "form-control",
                      disabled: e._busy
                    }, null, 8, ["modelValue", "disabled"])
                  ]),
                  a("div", null, [
                    t[93] || (t[93] = a("label", { class: "form-label" }, "Days Occupied per Year", -1)),
                    N(l, {
                      modelValue: e.parameters.strDaysOccupiedPerYear,
                      "onUpdate:modelValue": t[20] || (t[20] = (c) => e.parameters.strDaysOccupiedPerYear = c),
                      class: "form-control",
                      disabled: e._busy
                    }, null, 8, ["modelValue", "disabled"])
                  ])
                ])
              ]),
              a("div", Ete, [
                a("div", Ite, [
                  t[98] || (t[98] = a("p", { class: "fw-bold" }, [
                    a("img", {
                      src: nn,
                      alt: "PadSplit",
                      title: "PadSplit",
                      loading: "lazy",
                      class: "img-fluid",
                      width: "85"
                    })
                  ], -1)),
                  P("", !0),
                  a("div", Tte, [
                    t[96] || (t[96] = a("label", { class: "form-label" }, "Annual Vacancy Rate", -1)),
                    N(l, {
                      modelValue: e.parameters.padSplitAnnualVacancyRate,
                      "onUpdate:modelValue": t[21] || (t[21] = (c) => e.parameters.padSplitAnnualVacancyRate = c),
                      percent: "",
                      class: "form-control",
                      disabled: e._busy
                    }, null, 8, ["modelValue", "disabled"])
                  ]),
                  a("div", null, [
                    t[97] || (t[97] = a("label", { class: "form-label" }, "Average Length of Stay (Months)", -1)),
                    N(l, {
                      modelValue: e.parameters.padSplitAverageLengthOfStay,
                      "onUpdate:modelValue": t[22] || (t[22] = (c) => e.parameters.padSplitAverageLengthOfStay = c),
                      class: "form-control",
                      disabled: e._busy
                    }, null, 8, ["modelValue", "disabled"])
                  ])
                ])
              ])
            ])
          ])) : P("", !0)
        ])
      ])
    ]),
    t[124] || (t[124] = a("p", null, " By default, the settings below will automatically apply to each analysis. If a checkbox is left unchecked, the corresponding parameter remains optional and won't be included automatically in the analysis. For instance, to include utility expeneses in all short-term and PadSplit analyses, check the respective box. If you prefer not to include utility expeneses automatically in every conventional rental analysis, leave the box unchecked. You can still manually enter utility expenses for individual properties as needed. ", -1)),
    a("h3", Ote, g(e.$t("t-operating-expenses")), 1),
    a("div", Rte, [
      a("table", Lte, [
        t[117] || (t[117] = a("colgroup", null, [
          a("col"),
          a("col", { class: "bg-body-secondary" }),
          a("col"),
          a("col", { class: "bg-body-secondary" })
        ], -1)),
        a("thead", null, [
          a("tr", Bte, [
            t[101] || (t[101] = a("th", null, null, -1)),
            a("th", null, [
              t[99] || (t[99] = a("i", { class: "fa-light fa-calendar-range me-2" }, null, -1)),
              y(g(e.$t("t-long-term")), 1)
            ]),
            a("th", null, [
              t[100] || (t[100] = a("i", { class: "fa-light fa-timer me-2" }, null, -1)),
              y(g(e.$t("t-short-term")), 1)
            ]),
            t[102] || (t[102] = a("th", null, [
              a("img", {
                src: nn,
                alt: "PadSplit",
                title: "PadSplit",
                loading: "lazy",
                class: "img-fluid",
                width: "85"
              })
            ], -1))
          ])
        ]),
        a("tbody", null, [
          a("tr", Mte, [
            a("th", null, g(e.$t("t-property-tax")), 1),
            t[103] || (t[103] = a("td", { class: "border-back position-relative" }, null, -1)),
            a("td", xte, [
              a("div", Fte, [
                a("span", Vte, g(e.$t("t-per-property")), 1)
              ])
            ]),
            t[104] || (t[104] = a("td", { class: "border-back position-relative" }, null, -1))
          ]),
          a("tr", Dte, [
            a("th", null, g(e.$t("t-hoa")), 1),
            t[105] || (t[105] = a("td", { class: "border-back position-relative" }, null, -1)),
            a("td", Nte, [
              a("div", jte, [
                a("span", Hte, g(e.$t("t-per-property")), 1)
              ])
            ]),
            t[106] || (t[106] = a("td", { class: "border-back position-relative" }, null, -1))
          ]),
          a("tr", Ute, [
            a("th", null, g(e.$t("t-property-insurance")), 1),
            t[107] || (t[107] = a("td", { class: "border-back position-relative" }, null, -1)),
            a("td", zte, [
              a("div", Wte, [
                a("span", Gte, g(e.$t("t-per-property")), 1)
              ])
            ]),
            t[108] || (t[108] = a("td", { class: "border-back position-relative" }, null, -1))
          ]),
          a("tr", Yte, [
            a("th", null, g(e.$t("t-property-management")), 1),
            a("td", Xte, [
              N(l, {
                modelValue: e.parameters.managementFee,
                "onUpdate:modelValue": t[23] || (t[23] = (c) => e.parameters.managementFee = c),
                percent: e.isManagementFeePercent,
                "onUpdate:percent": t[24] || (t[24] = (c) => e.isManagementFeePercent = c),
                "optional-type": "",
                placeholder: "Not Set",
                disabled: e._busy
              }, null, 8, ["modelValue", "percent", "disabled"])
            ]),
            a("td", null, [
              N(l, {
                modelValue: e.parameters.strManagementFee,
                "onUpdate:modelValue": t[25] || (t[25] = (c) => e.parameters.strManagementFee = c),
                percent: e.isStrManagementFeePercent,
                "onUpdate:percent": t[26] || (t[26] = (c) => e.isStrManagementFeePercent = c),
                "optional-type": "",
                placeholder: "Not Set",
                disabled: e._busy
              }, null, 8, ["modelValue", "percent", "disabled"])
            ]),
            a("td", null, [
              N(l, {
                modelValue: e.parameters.padSplitManagementFee,
                "onUpdate:modelValue": t[27] || (t[27] = (c) => e.parameters.padSplitManagementFee = c),
                percent: e.isPadSplitManagementFeePercent,
                "onUpdate:percent": t[28] || (t[28] = (c) => e.isPadSplitManagementFeePercent = c),
                "optional-type": "",
                placeholder: "Not Set",
                disabled: e._busy
              }, null, 8, ["modelValue", "percent", "disabled"])
            ])
          ]),
          a("tr", qte, [
            a("th", null, [
              y(g(e.$t("t-lease-comission")) + " ", 1),
              t[109] || (t[109] = a("br", null, null, -1)),
              e.isLeasingCommissionsPercent ? (p(), h("span", Qte, " (" + g(e.$t("t-one-months-rent")) + ") ", 1)) : P("", !0)
            ]),
            a("td", null, [
              N(l, {
                modelValue: e.parameters.leaseCommission,
                "onUpdate:modelValue": t[29] || (t[29] = (c) => e.parameters.leaseCommission = c),
                percent: e.isLeasingCommissionsPercent,
                "onUpdate:percent": t[30] || (t[30] = (c) => e.isLeasingCommissionsPercent = c),
                "optional-type": "",
                placeholder: "Not Set",
                disabled: e._busy
              }, null, 8, ["modelValue", "percent", "disabled"])
            ]),
            t[110] || (t[110] = a("td", null, null, -1)),
            t[111] || (t[111] = a("td", null, null, -1))
          ]),
          a("tr", Kte, [
            a("th", null, [
              y(g(e.$t("t-lease-renewal-fee")), 1),
              t[112] || (t[112] = a("br", null, null, -1)),
              a("span", Zte, " (" + g(e.$t("t-one-months-rent")) + ") ", 1)
            ]),
            a("td", null, [
              N(l, {
                modelValue: e.parameters.leaseRenewalFee,
                "onUpdate:modelValue": t[31] || (t[31] = (c) => e.parameters.leaseRenewalFee = c),
                percent: e.isLeaseRenewalFeePercent,
                "onUpdate:percent": t[32] || (t[32] = (c) => e.isLeaseRenewalFeePercent = c),
                "optional-type": "",
                placeholder: "Not Set",
                disabled: e._busy
              }, null, 8, ["modelValue", "percent", "disabled"])
            ]),
            t[113] || (t[113] = a("td", null, null, -1)),
            t[114] || (t[114] = a("td", null, null, -1))
          ]),
          a("tr", Jte, [
            a("th", null, g(e.$t("t-platform-booking-fees")), 1),
            a("td", null, [
              N(l, {
                modelValue: e.parameters.platformServiceFees,
                "onUpdate:modelValue": t[33] || (t[33] = (c) => e.parameters.platformServiceFees = c),
                percent: e.isPlatformServiceFeesPercent,
                "onUpdate:percent": t[34] || (t[34] = (c) => e.isPlatformServiceFeesPercent = c),
                "optional-type": "",
                placeholder: "Not Set",
                disabled: e._busy
              }, null, 8, ["modelValue", "percent", "disabled"])
            ]),
            a("td", null, [
              N(l, {
                modelValue: e.parameters.strPlatformServiceFees,
                "onUpdate:modelValue": t[35] || (t[35] = (c) => e.parameters.strPlatformServiceFees = c),
                percent: e.isStrPlatformServiceFeesPercent,
                "onUpdate:percent": t[36] || (t[36] = (c) => e.isStrPlatformServiceFeesPercent = c),
                "optional-type": "",
                placeholder: "Not Set",
                disabled: e._busy
              }, null, 8, ["modelValue", "percent", "disabled"])
            ]),
            a("td", null, [
              N(l, {
                modelValue: e.parameters.padSplitBookingFeeDays,
                "onUpdate:modelValue": t[37] || (t[37] = (c) => e.parameters.padSplitBookingFeeDays = c),
                placeholder: "Not Set",
                disabled: e._busy
              }, null, 8, ["modelValue", "disabled"])
            ])
          ]),
          a("tr", $te, [
            a("th", null, [
              y(g(e.$t("t-property-maintenance")), 1),
              t[115] || (t[115] = a("br", null, null, -1)),
              t[116] || (t[116] = a("span", { class: "faded text-dark text-opacity-25" }, " (% of Gross Income) ", -1))
            ]),
            a("td", null, [
              N(l, {
                modelValue: e.parameters.maintenance,
                "onUpdate:modelValue": t[38] || (t[38] = (c) => e.parameters.maintenance = c),
                percent: e.isMaintenancePercent,
                "onUpdate:percent": t[39] || (t[39] = (c) => e.isMaintenancePercent = c),
                "optional-type": "",
                placeholder: "Not Set",
                disabled: e._busy
              }, null, 8, ["modelValue", "percent", "disabled"])
            ]),
            a("td", null, [
              N(l, {
                modelValue: e.parameters.strMaintenance,
                "onUpdate:modelValue": t[40] || (t[40] = (c) => e.parameters.strMaintenance = c),
                percent: e.isStrMaintenancePercent,
                "onUpdate:percent": t[41] || (t[41] = (c) => e.isStrMaintenancePercent = c),
                "optional-type": "",
                placeholder: "Not Set",
                disabled: e._busy
              }, null, 8, ["modelValue", "percent", "disabled"])
            ]),
            a("td", null, [
              N(l, {
                modelValue: e.parameters.padSplitMaintenance,
                "onUpdate:modelValue": t[42] || (t[42] = (c) => e.parameters.padSplitMaintenance = c),
                percent: e.isPadSplitMaintenancePercent,
                "onUpdate:percent": t[43] || (t[43] = (c) => e.isPadSplitMaintenancePercent = c),
                "optional-type": "",
                placeholder: "Not Set",
                disabled: e._busy
              }, null, 8, ["modelValue", "percent", "disabled"])
            ])
          ]),
          a("tr", _te, [
            a("th", null, g(e.$t("t-utility-expenses")), 1),
            a("td", null, [
              N(l, {
                modelValue: e.parameters.utilityExpenses,
                "onUpdate:modelValue": t[44] || (t[44] = (c) => e.parameters.utilityExpenses = c),
                percent: e.isUtilityExpensesPercent,
                "onUpdate:percent": t[45] || (t[45] = (c) => e.isUtilityExpensesPercent = c),
                "optional-type": "",
                placeholder: "Not Set",
                disabled: e._busy
              }, null, 8, ["modelValue", "percent", "disabled"])
            ]),
            a("td", null, [
              N(l, {
                modelValue: e.parameters.strUtilityExpenses,
                "onUpdate:modelValue": t[46] || (t[46] = (c) => e.parameters.strUtilityExpenses = c),
                percent: e.isStrUtilityExpensesPercent,
                "onUpdate:percent": t[47] || (t[47] = (c) => e.isStrUtilityExpensesPercent = c),
                "optional-type": "",
                placeholder: "Not Set",
                disabled: e._busy
              }, null, 8, ["modelValue", "percent", "disabled"])
            ]),
            a("td", null, [
              N(l, {
                modelValue: e.parameters.padSplitUtilityExpenses,
                "onUpdate:modelValue": t[48] || (t[48] = (c) => e.parameters.padSplitUtilityExpenses = c),
                percent: e.isPadSplitUtilityExpensesPercent,
                "onUpdate:percent": t[49] || (t[49] = (c) => e.isPadSplitUtilityExpensesPercent = c),
                "optional-type": "",
                placeholder: "Not Set",
                disabled: e._busy
              }, null, 8, ["modelValue", "percent", "disabled"])
            ])
          ]),
          a("tr", ese, [
            a("th", null, g(e.$t("t-furnishing-expenses")), 1),
            a("td", null, [
              N(l, {
                modelValue: e.parameters.furnishingExpenses,
                "onUpdate:modelValue": t[50] || (t[50] = (c) => e.parameters.furnishingExpenses = c),
                percent: e.isFurnishingExpensesPercent,
                "onUpdate:percent": t[51] || (t[51] = (c) => e.isFurnishingExpensesPercent = c),
                "optional-type": "",
                placeholder: "Not Set",
                disabled: e._busy
              }, null, 8, ["modelValue", "percent", "disabled"])
            ]),
            a("td", null, [
              N(l, {
                modelValue: e.parameters.strFurnishingExpenses,
                "onUpdate:modelValue": t[52] || (t[52] = (c) => e.parameters.strFurnishingExpenses = c),
                percent: e.isStrFurnishingExpensesPercent,
                "onUpdate:percent": t[53] || (t[53] = (c) => e.isStrFurnishingExpensesPercent = c),
                "optional-type": "",
                placeholder: "Not Set",
                disabled: e._busy
              }, null, 8, ["modelValue", "percent", "disabled"])
            ]),
            a("td", null, [
              N(l, {
                modelValue: e.parameters.padSplitFurnishingExpenses,
                "onUpdate:modelValue": t[54] || (t[54] = (c) => e.parameters.padSplitFurnishingExpenses = c),
                percent: e.isPadSplitFurnishingExpensesPercent,
                "onUpdate:percent": t[55] || (t[55] = (c) => e.isPadSplitFurnishingExpensesPercent = c),
                "optional-type": "",
                placeholder: "Not Set",
                disabled: e._busy
              }, null, 8, ["modelValue", "percent", "disabled"])
            ])
          ]),
          a("tr", tse, [
            a("th", null, g(e.$t("t-consumable-expenses")), 1),
            a("td", null, [
              N(l, {
                modelValue: e.parameters.consumableExpenses,
                "onUpdate:modelValue": t[56] || (t[56] = (c) => e.parameters.consumableExpenses = c),
                percent: e.isConsumableExpensesPercent,
                "onUpdate:percent": t[57] || (t[57] = (c) => e.isConsumableExpensesPercent = c),
                "optional-type": "",
                placeholder: "Not Set",
                disabled: e._busy
              }, null, 8, ["modelValue", "percent", "disabled"])
            ]),
            a("td", null, [
              N(l, {
                modelValue: e.parameters.strConsumableExpenses,
                "onUpdate:modelValue": t[58] || (t[58] = (c) => e.parameters.strConsumableExpenses = c),
                percent: e.isStrConsumableExpensesPercent,
                "onUpdate:percent": t[59] || (t[59] = (c) => e.isStrConsumableExpensesPercent = c),
                "optional-type": "",
                placeholder: "Not Set",
                disabled: e._busy
              }, null, 8, ["modelValue", "percent", "disabled"])
            ]),
            a("td", null, [
              N(l, {
                modelValue: e.parameters.padSplitConsumableExpenses,
                "onUpdate:modelValue": t[60] || (t[60] = (c) => e.parameters.padSplitConsumableExpenses = c),
                percent: e.isPadSplitConsumableExpensesPercent,
                "onUpdate:percent": t[61] || (t[61] = (c) => e.isPadSplitConsumableExpensesPercent = c),
                "optional-type": "",
                placeholder: "Not Set",
                disabled: e._busy
              }, null, 8, ["modelValue", "percent", "disabled"])
            ])
          ]),
          a("tr", sse, [
            a("th", null, g(e.$t("t-cleaning-expenses")), 1),
            a("td", null, [
              N(l, {
                modelValue: e.parameters.cleaningExpenses,
                "onUpdate:modelValue": t[62] || (t[62] = (c) => e.parameters.cleaningExpenses = c),
                percent: e.isCleaningExpensesPercent,
                "onUpdate:percent": t[63] || (t[63] = (c) => e.isCleaningExpensesPercent = c),
                "optional-type": "",
                placeholder: "Not Set",
                disabled: e._busy
              }, null, 8, ["modelValue", "percent", "disabled"])
            ]),
            a("td", null, [
              N(l, {
                modelValue: e.parameters.strCleaningExpenses,
                "onUpdate:modelValue": t[64] || (t[64] = (c) => e.parameters.strCleaningExpenses = c),
                percent: e.isStrCleaningExpensesPercent,
                "onUpdate:percent": t[65] || (t[65] = (c) => e.isStrCleaningExpensesPercent = c),
                "optional-type": "",
                placeholder: "Not Set",
                disabled: e._busy
              }, null, 8, ["modelValue", "percent", "disabled"])
            ]),
            a("td", null, [
              N(l, {
                modelValue: e.parameters.padSplitCleaningExpenses,
                "onUpdate:modelValue": t[66] || (t[66] = (c) => e.parameters.padSplitCleaningExpenses = c),
                percent: e.isPadSplitCleaningExpensesPercent,
                "onUpdate:percent": t[67] || (t[67] = (c) => e.isPadSplitCleaningExpensesPercent = c),
                "optional-type": "",
                placeholder: "Not Set",
                disabled: e._busy
              }, null, 8, ["modelValue", "percent", "disabled"])
            ])
          ]),
          (p(!0), h(A, null, D(e.otherExpenseAccounts, (c) => (p(), h("tr", {
            class: "align-middle",
            key: c.id
          }, [
            a("th", null, g(c.name), 1),
            a("td", null, [
              e.longTermOtherAccountValue(c.id) ? (p(), Fe(l, {
                key: 0,
                modelValue: e.longTermOtherAccountValue(c.id).total,
                "onUpdate:modelValue": (u) => e.longTermOtherAccountValue(c.id).total = u,
                percent: e.longTermOtherAccountValue(c.id).percentage,
                "onUpdate:percent": (u) => e.longTermOtherAccountValue(c.id).percentage = u,
                placeholder: "Not Set",
                "optional-type": "",
                disabled: e._busy
              }, null, 8, ["modelValue", "onUpdate:modelValue", "percent", "onUpdate:percent", "disabled"])) : P("", !0)
            ]),
            a("td", null, [
              e.shortTermOtherAccountValue(c.id) ? (p(), Fe(l, {
                key: 0,
                modelValue: e.shortTermOtherAccountValue(c.id).total,
                "onUpdate:modelValue": (u) => e.shortTermOtherAccountValue(c.id).total = u,
                percent: e.shortTermOtherAccountValue(c.id).percentage,
                "onUpdate:percent": (u) => e.shortTermOtherAccountValue(c.id).percentage = u,
                placeholder: "Not Set",
                "optional-type": "",
                disabled: e._busy
              }, null, 8, ["modelValue", "onUpdate:modelValue", "percent", "onUpdate:percent", "disabled"])) : P("", !0)
            ]),
            a("td", null, [
              e.padSplitOtherAccountValue(c.id) ? (p(), Fe(l, {
                key: 0,
                modelValue: e.padSplitOtherAccountValue(c.id).total,
                "onUpdate:modelValue": (u) => e.padSplitOtherAccountValue(c.id).total = u,
                percent: e.padSplitOtherAccountValue(c.id).percentage,
                "onUpdate:percent": (u) => e.padSplitOtherAccountValue(c.id).percentage = u,
                placeholder: "Not Set",
                "optional-type": "",
                disabled: e._busy
              }, null, 8, ["modelValue", "onUpdate:modelValue", "percent", "onUpdate:percent", "disabled"])) : P("", !0)
            ])
          ]))), 128)),
          a("tr", ase, [
            a("th", null, g(e.$t("t-other-expenses")), 1),
            a("td", null, [
              N(l, {
                modelValue: e.parameters.otherExpense,
                "onUpdate:modelValue": t[68] || (t[68] = (c) => e.parameters.otherExpense = c),
                percent: e.isOtherExpensePercent,
                "onUpdate:percent": t[69] || (t[69] = (c) => e.isOtherExpensePercent = c),
                "optional-type": "",
                placeholder: "Not Set",
                disabled: e._busy
              }, null, 8, ["modelValue", "percent", "disabled"])
            ]),
            a("td", null, [
              N(l, {
                modelValue: e.parameters.strOtherExpense,
                "onUpdate:modelValue": t[70] || (t[70] = (c) => e.parameters.strOtherExpense = c),
                percent: e.isStrOtherExpensePercent,
                "onUpdate:percent": t[71] || (t[71] = (c) => e.isStrOtherExpensePercent = c),
                "optional-type": "",
                placeholder: "Not Set",
                disabled: e._busy
              }, null, 8, ["modelValue", "percent", "disabled"])
            ]),
            a("td", null, [
              N(l, {
                modelValue: e.parameters.padSplitOtherExpense,
                "onUpdate:modelValue": t[72] || (t[72] = (c) => e.parameters.padSplitOtherExpense = c),
                percent: e.isPadSplitOtherExpensePercent,
                "onUpdate:percent": t[73] || (t[73] = (c) => e.isPadSplitOtherExpensePercent = c),
                "optional-type": "",
                placeholder: "Not Set",
                disabled: e._busy
              }, null, 8, ["modelValue", "percent", "disabled"])
            ])
          ])
        ])
      ])
    ]),
    a("h3", nse, g(e.$t("t-non-operating-expenses")), 1),
    a("div", rse, [
      a("table", ose, [
        t[123] || (t[123] = a("colgroup", null, [
          a("col"),
          a("col", { class: "bg-body-secondary" }),
          a("col"),
          a("col", { class: "bg-body-secondary" })
        ], -1)),
        a("thead", null, [
          a("tr", ise, [
            t[120] || (t[120] = a("th", null, null, -1)),
            a("th", null, [
              t[118] || (t[118] = a("i", { class: "fa-light fa-calendar-range me-2" }, null, -1)),
              y(g(e.$t("t-long-term")), 1)
            ]),
            a("th", null, [
              t[119] || (t[119] = a("i", { class: "fa-light fa-timer me-2" }, null, -1)),
              y(g(e.$t("t-short-term")), 1)
            ]),
            t[121] || (t[121] = a("th", null, [
              a("img", {
                src: nn,
                alt: "PadSplit",
                title: "PadSplit",
                loading: "lazy",
                class: "img-fluid",
                width: "85"
              })
            ], -1))
          ])
        ]),
        a("tbody", null, [
          a("tr", lse, [
            a("th", null, [
              y(g(e.$t("t-capital-expenditures")), 1),
              t[122] || (t[122] = a("br", null, null, -1)),
              a("span", dse, " (" + g(e.$t("t-of-gross-income")) + ") ", 1)
            ]),
            a("td", null, [
              N(l, {
                modelValue: e.parameters.capitalExpenditures,
                "onUpdate:modelValue": t[74] || (t[74] = (c) => e.parameters.capitalExpenditures = c),
                percent: e.isCapitalExpendituresPercent,
                "onUpdate:percent": t[75] || (t[75] = (c) => e.isCapitalExpendituresPercent = c),
                "optional-type": "",
                placeholder: "Not Set",
                disabled: e._busy
              }, null, 8, ["modelValue", "percent", "disabled"])
            ]),
            a("td", null, [
              N(l, {
                modelValue: e.parameters.strCapitalExpenditures,
                "onUpdate:modelValue": t[76] || (t[76] = (c) => e.parameters.strCapitalExpenditures = c),
                percent: e.isStrCapitalExpendituresPercent,
                "onUpdate:percent": t[77] || (t[77] = (c) => e.isStrCapitalExpendituresPercent = c),
                "optional-type": "",
                placeholder: "Not Set",
                disabled: e._busy
              }, null, 8, ["modelValue", "percent", "disabled"])
            ]),
            a("td", null, [
              N(l, {
                modelValue: e.parameters.padSplitCapitalExpenditures,
                "onUpdate:modelValue": t[78] || (t[78] = (c) => e.parameters.padSplitCapitalExpenditures = c),
                percent: e.isPadSplitCapitalExpendituresPercent,
                "onUpdate:percent": t[79] || (t[79] = (c) => e.isPadSplitCapitalExpendituresPercent = c),
                "optional-type": "",
                placeholder: "Not Set",
                disabled: e._busy
              }, null, 8, ["modelValue", "percent", "disabled"])
            ])
          ]),
          (p(!0), h(A, null, D(e.otherNonOperatingExpenseAccounts, (c) => (p(), h("tr", {
            class: "align-middle",
            key: c.id
          }, [
            a("th", null, g(c.name), 1),
            a("td", null, [
              e.longTermOtherAccountValue(c.id) ? (p(), Fe(l, {
                key: 0,
                modelValue: e.longTermOtherAccountValue(c.id).total,
                "onUpdate:modelValue": (u) => e.longTermOtherAccountValue(c.id).total = u,
                percent: e.longTermOtherAccountValue(c.id).percentage,
                "onUpdate:percent": (u) => e.longTermOtherAccountValue(c.id).percentage = u,
                placeholder: "Not Set",
                "optional-type": "",
                disabled: e._busy
              }, null, 8, ["modelValue", "onUpdate:modelValue", "percent", "onUpdate:percent", "disabled"])) : P("", !0)
            ]),
            a("td", null, [
              e.shortTermOtherAccountValue(c.id) ? (p(), Fe(l, {
                key: 0,
                modelValue: e.shortTermOtherAccountValue(c.id).total,
                "onUpdate:modelValue": (u) => e.shortTermOtherAccountValue(c.id).total = u,
                percent: e.shortTermOtherAccountValue(c.id).percentage,
                "onUpdate:percent": (u) => e.shortTermOtherAccountValue(c.id).percentage = u,
                placeholder: "Not Set",
                "optional-type": "",
                disabled: e._busy
              }, null, 8, ["modelValue", "onUpdate:modelValue", "percent", "onUpdate:percent", "disabled"])) : P("", !0)
            ]),
            a("td", null, [
              e.padSplitOtherAccountValue(c.id) ? (p(), Fe(l, {
                key: 0,
                modelValue: e.padSplitOtherAccountValue(c.id).total,
                "onUpdate:modelValue": (u) => e.padSplitOtherAccountValue(c.id).total = u,
                percent: e.padSplitOtherAccountValue(c.id).percentage,
                "onUpdate:percent": (u) => e.padSplitOtherAccountValue(c.id).percentage = u,
                placeholder: "Not Set",
                "optional-type": "",
                disabled: e._busy
              }, null, 8, ["modelValue", "onUpdate:modelValue", "percent", "onUpdate:percent", "disabled"])) : P("", !0)
            ])
          ]))), 128))
        ])
      ])
    ]),
    a("div", cse, [
      N(d, {
        id: "btnSaveDefaults",
        onClick: e.saveDefaults,
        busy: e._busy,
        "onUpdate:busy": t[80] || (t[80] = (c) => e._busy = c),
        disabled: !e.canUseCalculatorAdvanced
      }, {
        default: ve(() => [
          y(g(e.$t("t-save-settings")), 1)
        ]),
        _: 1
      }, 8, ["onClick", "busy", "disabled"])
    ])
  ], 512)) : (p(), h("div", use, [
    a("div", pse, [
      a("div", hse, [
        t[125] || (t[125] = Bt('<div class="col-md-7 col-lg-6 d-none d-md-block"><div class="mb-5 mb-md-0 position-relative mini"><img class="position-absolute first" src="' + cI + '" alt="Leasing and Resale Expenses" title="Leasing and Resale Expenses" height="210" width="336" loading="lazy"><img class="position-absolute d-none d-xl-block middle" src="' + uI + '" alt="Make-ready and Stabilization" title="Make-ready and Stabilization" height="288" width="336" loading="lazy"><img class="position-absolute last" src="' + pI + '" alt="Vacancy" title="Vacancy" height="210" width="336" loading="lazy"></div></div>', 1)),
        a("div", mse, [
          a("p", fse, g(e.$t("t-upgrade-to-investor-plus-to-edit")), 1),
          a("a", gse, g(e.$t("t-upgrade-to-investor-plus")), 1)
        ])
      ])
    ])
  ])) : (p(), Fe(o, { key: 0 }));
}
const qis = /* @__PURE__ */ Ae(Z_, [["render", vse]]), yse = me({
  name: "InvestorsDefaultPerformance",
  props: {
    idx: Boolean,
    busy: Boolean
  },
  data() {
    return {
      _busy: !1
    };
  },
  emits: [
    "update:busy"
  ],
  components: {
    LoadingStatus: Gk,
    NumericalInput: Aa,
    SaveButton: bb
  },
  watch: {
    busy(e) {
      this.busy != this._busy && (this._busy = e);
    },
    _busy(e) {
      this.busy != this._busy && this.$emit("update:busy", e);
    }
  },
  computed: {
    accessIsFree() {
      var e;
      return ((e = this.access) == null ? void 0 : e.isFree) == !0;
    },
    canUseCalculatorAdvanced() {
      var e, t;
      return ((t = (e = this.access) == null ? void 0 : e.calculator) == null ? void 0 : t.advanced) == !0;
    },
    parameters() {
      return this.idx ? this.idxSearchParameters : this.myParameters;
    },
    capRateActive: {
      set(e) {
        e ? this.parameters.blueChipFilters |= Va.CapRate : this.parameters.blueChipFilters &= -2;
      },
      get() {
        return is(this.parameters.blueChipFilters, Va.CapRate);
      }
    },
    cocActive: {
      set(e) {
        e ? this.parameters.blueChipFilters |= Va.CashOnCash : this.parameters.blueChipFilters &= -3;
      },
      get() {
        return is(this.parameters.blueChipFilters, Va.CashOnCash);
      }
    },
    cocAfterTaxActive: {
      set(e) {
        e ? this.parameters.blueChipFilters |= Va.CashOnCashAfterTax : this.parameters.blueChipFilters &= -9;
      },
      get() {
        return is(this.parameters.blueChipFilters, Va.CashOnCashAfterTax);
      }
    },
    irrActive: {
      set(e) {
        e ? this.parameters.blueChipFilters |= Va.IRR : this.parameters.blueChipFilters &= -5;
      },
      get() {
        return is(this.parameters.blueChipFilters, Va.IRR);
      }
    },
    irrAfterTaxActive: {
      set(e) {
        e ? this.parameters.blueChipFilters |= Va.IRRAfterTax : this.parameters.blueChipFilters &= -17;
      },
      get() {
        return is(this.parameters.blueChipFilters, Va.IRRAfterTax);
      }
    },
    ...q(ct, ["myParameters", "idxSearchParameters", "accountLoaded", "initialized"]),
    ...q(Te, ["access"]),
    ...at(ct)
  },
  methods: {
    async saveDefaults() {
      try {
        this.idx ? await this.accountStore.updateIdxSearchParameters() : await this.accountStore.updateMyFinancialParameters(), wt("Blue Chip Criteria parameters have been saved.");
      } catch (e) {
        Se(e.message);
      } finally {
        this.$emit("update:busy", !1), this._busy = !1;
      }
    }
  },
  mounted() {
    this.accountLoaded.then(async () => {
      this.idx ? await this.accountStore.fetchIdxSearchParameters() : await this.accountStore.fetchMyParameters();
    });
  }
}), bse = {
  key: 1,
  class: "card shadow-sm"
}, Ase = { class: "card-body" }, wse = { class: "row g-3" }, Cse = { class: "col-md-6 d-flex justify-content-between align-items-center flex-column gap-2" }, Sse = { class: "fw-bold text-center" }, Pse = { class: "form-check form-switch form-switch-lg" }, kse = { class: "col-md-6" }, Ese = {
  for: "mincaprate",
  class: "form-label"
}, Ise = { class: "col-md-6 d-flex justify-content-center align-items-end pb-2" }, Tse = { class: "form-check form-switch form-switch-lg" }, Ose = { class: "col-md-6" }, Rse = {
  for: "mincoc",
  class: "form-label"
}, Lse = { class: "col-md-6 d-flex justify-content-center align-items-end pb-2" }, Bse = { class: "form-check form-switch form-switch-lg" }, Mse = { class: "col-md-6" }, xse = {
  for: "minirr",
  class: "form-label"
}, Fse = { class: "col-md-6 d-flex justify-content-center align-items-end pb-2" }, Vse = { class: "form-check form-switch form-switch-lg" }, Dse = { class: "col-md-6" }, Nse = {
  for: "mincoc",
  class: "form-label"
}, jse = { class: "col-md-6 d-flex justify-content-center align-items-end pb-2" }, Hse = { class: "form-check form-switch form-switch-lg" }, Use = { class: "col-md-6" }, zse = {
  for: "minirr",
  class: "form-label"
}, Wse = { class: "col-12 d-flex justify-content-end" };
function Gse(e, t, s, n, r, i) {
  const o = pe("loading-status"), l = pe("numerical-input"), d = pe("save-button");
  return e.parameters ? (p(), h("div", bse, [
    a("div", Ase, [
      a("div", wse, [
        a("div", Cse, [
          a("div", Sse, g(e.$t("Search Filter")), 1),
          a("div", Pse, [
            V(a("input", {
              class: "form-check-input",
              type: "checkbox",
              role: "switch",
              id: "switchCheckDefault",
              "onUpdate:modelValue": t[0] || (t[0] = (c) => e.capRateActive = c)
            }, null, 512), [
              [Ue, e.capRateActive]
            ])
          ])
        ]),
        a("div", kse, [
          a("label", Ese, g(e.$t("Cap Rate")), 1),
          N(l, {
            percent: "",
            placeholder: "Not Set",
            modelValue: e.parameters.minCapRate,
            "onUpdate:modelValue": t[1] || (t[1] = (c) => e.parameters.minCapRate = c)
          }, null, 8, ["modelValue"])
        ]),
        a("div", Ise, [
          a("div", Tse, [
            V(a("input", {
              class: "form-check-input",
              type: "checkbox",
              role: "switch",
              id: "switchCheckDefault2",
              "onUpdate:modelValue": t[2] || (t[2] = (c) => e.cocActive = c)
            }, null, 512), [
              [Ue, e.cocActive]
            ])
          ])
        ]),
        a("div", Ose, [
          a("label", Rse, g(e.$t("Before Tax Cash on Cash")), 1),
          N(l, {
            percent: "",
            placeholder: "Not Set",
            modelValue: e.parameters.minCoC,
            "onUpdate:modelValue": t[3] || (t[3] = (c) => e.parameters.minCoC = c)
          }, null, 8, ["modelValue"])
        ]),
        a("div", Lse, [
          a("div", Bse, [
            V(a("input", {
              class: "form-check-input",
              type: "checkbox",
              role: "switch",
              id: "switchCheckDefault3",
              "onUpdate:modelValue": t[4] || (t[4] = (c) => e.irrActive = c)
            }, null, 512), [
              [Ue, e.irrActive]
            ])
          ])
        ]),
        a("div", Mse, [
          a("label", xse, g(e.$t("Before Tax IRR")), 1),
          N(l, {
            percent: "",
            placeholder: "Not Set",
            modelValue: e.parameters.minIRR,
            "onUpdate:modelValue": t[5] || (t[5] = (c) => e.parameters.minIRR = c)
          }, null, 8, ["modelValue"])
        ]),
        a("div", Fse, [
          a("div", Vse, [
            V(a("input", {
              class: "form-check-input",
              type: "checkbox",
              role: "switch",
              id: "cocAfterTaxActive",
              "onUpdate:modelValue": t[6] || (t[6] = (c) => e.cocAfterTaxActive = c)
            }, null, 512), [
              [Ue, e.cocAfterTaxActive]
            ])
          ])
        ]),
        a("div", Dse, [
          a("label", Nse, g(e.$t("After Tax Cash on Cash")), 1),
          N(l, {
            percent: "",
            placeholder: "Not Set",
            modelValue: e.parameters.minCoCAfterTax,
            "onUpdate:modelValue": t[7] || (t[7] = (c) => e.parameters.minCoCAfterTax = c)
          }, null, 8, ["modelValue"])
        ]),
        a("div", jse, [
          a("div", Hse, [
            V(a("input", {
              class: "form-check-input",
              type: "checkbox",
              role: "switch",
              id: "irrAfterTaxActive",
              "onUpdate:modelValue": t[8] || (t[8] = (c) => e.irrAfterTaxActive = c)
            }, null, 512), [
              [Ue, e.irrAfterTaxActive]
            ])
          ])
        ]),
        a("div", Use, [
          a("label", zse, g(e.$t("After Tax IRR")), 1),
          N(l, {
            percent: "",
            placeholder: "Not Set",
            modelValue: e.parameters.minIRRAfterTax,
            "onUpdate:modelValue": t[9] || (t[9] = (c) => e.parameters.minIRRAfterTax = c)
          }, null, 8, ["modelValue"])
        ]),
        P("", !0),
        a("div", Wse, [
          N(d, {
            id: "btnSaveDefaults",
            onClick: e.saveDefaults,
            busy: e._busy,
            "onUpdate:busy": t[10] || (t[10] = (c) => e._busy = c),
            disabled: !e.canUseCalculatorAdvanced
          }, {
            default: ve(() => [
              y(g(e.$t("t-save-settings")), 1)
            ]),
            _: 1
          }, 8, ["onClick", "busy", "disabled"])
        ])
      ])
    ])
  ])) : (p(), Fe(o, { key: 0 }));
}
const Qis = /* @__PURE__ */ Ae(yse, [["render", Gse]]), Yse = me({
  name: "RentalRateAdjustment",
  props: {},
  components: {
    NumericalInput: Aa
  },
  data() {
    return {
      proForecastRentalOffset: 0,
      proForecastRentalThreshold: 0,
      enableProForecastThreshold: !1,
      busy: !1
    };
  },
  computed: {
    ...at(Te),
    ...q(Te, ["access", "aclLoaded"])
  },
  methods: {
    number: Ve,
    async getAvmAdjustmentSettings() {
      try {
        this.busy = !0;
        var e = await W.api.account.getAvmAdjustmentSettings();
        if (e.data.status != de.Success)
          throw new Error(e.data.message);
        this.enableProForecastThreshold = e.data.enableThreshold, this.proForecastRentalOffset = e.data.rentalOffset, this.proForecastRentalThreshold = e.data.rentalThreshold;
      } catch (t) {
        Se(t.message, jo.Right, !0);
      }
      this.busy = !1;
    },
    async updateAvmAdjustmentSettings() {
      try {
        this.busy = !0;
        const t = {
          enableThreshold: this.enableProForecastThreshold,
          rentalOffset: this.proForecastRentalOffset,
          rentalThreshold: this.proForecastRentalThreshold
        };
        var e = await W.api.account.updateAvmAdjustmentSettings(t);
        if (e.data.status != de.Success)
          throw new Error(e.data.message);
        wt("Settings Saved Successfully");
      } catch (t) {
        Se(t.message, jo.Right, !0);
      }
      this.busy = !1;
    }
  },
  created() {
  },
  async mounted() {
    this.aclLoaded.then(() => {
      this.getAvmAdjustmentSettings();
    });
  }
}), Xse = { class: "row" }, qse = { class: "col" }, Qse = { class: "fw-bold fs-3" }, Kse = { class: "card shadow col-lg-6 col-xl-7 mb-3" }, Zse = { class: "card-body" }, Jse = { class: "row g-3" }, $se = { class: "col-sm-3 align-items-center d-flex justify-content-end" }, _se = { class: "form-check form-switch form-switch-lg form-switch-basic" }, eae = ["disabled"], tae = {
  class: "form-check-label",
  for: "flexSwitchCheckDefault"
}, sae = {
  for: "inputThreshold",
  class: "col-sm-7 col-form-label"
}, aae = { class: "col-sm-5" }, nae = {
  for: "inputOffset",
  class: "col-sm-7 col-form-label"
}, rae = { class: "col-sm-5" }, oae = { class: "d-flex justify-content-end mt-5" }, iae = ["disabled"];
function lae(e, t, s, n, r, i) {
  const o = pe("numerical-input");
  return p(), h(A, null, [
    a("div", Xse, [
      a("div", qse, [
        a("h2", Qse, g(e.$t("t-rental-rate-forecast-settings")), 1),
        t[4] || (t[4] = a("p", null, 'Customize The Rental Rate Forecast: If you adjust the predicted rental rate by more than a certain percentage, the tile will update to display "{Your Company Name} Rental Rate Forecast" instead of "Rental Rate AVM Prediction", allowing you to hide incorrect AVM predictions and instead provide your own data for clients to view.', -1))
      ])
    ]),
    a("div", Kse, [
      a("div", Zse, [
        a("div", Jse, [
          t[5] || (t[5] = a("label", {
            class: "col-sm-9 col-form-label",
            for: "flexSwitchCheckDefault"
          }, "Auto-Convert AVM tile to Professional Estimate when Threshold Met?", -1)),
          a("div", $se, [
            a("div", _se, [
              V(a("input", {
                class: "form-check-input",
                type: "checkbox",
                role: "switch",
                id: "flexSwitchCheckDefault",
                "onUpdate:modelValue": t[0] || (t[0] = (l) => e.enableProForecastThreshold = l),
                disabled: e.busy
              }, null, 8, eae), [
                [Ue, e.enableProForecastThreshold]
              ]),
              a("label", tae, [
                y(g(e.$t("t-yes")), 1),
                a("span", null, g(e.$t("t-no")), 1)
              ])
            ])
          ]),
          a("label", sae, g(e.$t("t-adjustment-renta-rate-threshold")), 1),
          a("div", aae, [
            N(o, {
              modelValue: e.proForecastRentalThreshold,
              "onUpdate:modelValue": t[1] || (t[1] = (l) => e.proForecastRentalThreshold = l),
              percent: "",
              class: "text-end",
              disabled: e.busy
            }, null, 8, ["modelValue", "disabled"])
          ]),
          a("label", nae, g(e.$t("t-rental-rate-range-offset")), 1),
          a("div", rae, [
            N(o, {
              modelValue: e.proForecastRentalOffset,
              "onUpdate:modelValue": t[2] || (t[2] = (l) => e.proForecastRentalOffset = l),
              currency: "",
              class: "text-end",
              disabled: e.busy
            }, null, 8, ["modelValue", "disabled"])
          ])
        ]),
        a("div", oae, [
          a("button", {
            type: "button",
            onClick: t[3] || (t[3] = (...l) => e.updateAvmAdjustmentSettings && e.updateAvmAdjustmentSettings(...l)),
            disabled: e.busy,
            class: "btn btn-lava"
          }, g(e.$t("t-save")), 9, iae)
        ])
      ])
    ]),
    t[6] || (t[6] = a("div", {
      class: "alert alert-info",
      role: "alert"
    }, [
      a("p", { class: "alert-heading fw-bold mb-1" }, [
        a("i", { class: "fa-light fa-info-circle me-2" }),
        y(" For example:")
      ]),
      y(" With a 5% threshold and a $2,000 AVM rate, increasing it to $2,200 triggers the switch. Set a "),
      a("b", null, '"Rental Rate Range Offset +/-"'),
      y(" value (e.g., $125) to automatically define a range around your rate, presenting a range of $2,075 to $2,325. ")
    ], -1))
  ], 64);
}
const Kis = /* @__PURE__ */ Ae(Yse, [["render", lae]]), dae = me({
  name: "IncomeExpenseAccounts",
  props: {
    apiKey: {
      type: String,
      required: !1
    }
  },
  enums: {
    IncomeOrExpenseType: Ra
  },
  components: {},
  data() {
    return {
      newAccountName: "",
      newAccountType: "expense",
      busy: !1,
      editingEntry: !1
    };
  },
  computed: {
    canAddNew() {
      return this.busy == !1;
    },
    //incomeAccountsSorted() {
    //    return this.incomeAccounts.sort((a, b) => sortOtherIncome(a, b, (c, d) => sortCustom(c, d, (e, f) => e.name.localeCompare(f.name))));
    //},
    //expenseAccountsSorted() {
    //    return this.expenseAccounts.filter(q => q.nonOperating != true).sort((a, b) => sortOtherExpense(a, b, (c, d) => sortCustom(c, d, (e, f) => e.name.localeCompare(f.name))));
    //},
    //nonOperExpenseAccounts() {
    //    return this.eExpenseAccounts.filter(q => q.nonOperating == true).sort((a, b) => sortOtherExpense(a, b, (c, d) => sortCustom(c, d, (e, f) => e.name.localeCompare(f.name))));
    //},
    ...q(Te, ["access", "aclLoaded"]),
    ...q(ct, ["incomeAccountsSorted", "operatingExpenseAccountsSorted", "nonOperatingExpenseAccountsSorted"]),
    ...at(ct)
  },
  methods: {
    number: Ve,
    showAddAccountDialog(e = Ra.Expense) {
      var t;
      this.editingEntry = !1, this.newAccountType = e, (t = bootstrap.Modal.getOrCreateInstance(this.$refs.dialogAddAccount)) == null || t.show();
    },
    async addAccount() {
      var e;
      try {
        this.busy = !0, await this.accountStore.addIncomeExpenseAccount(this.newAccountName, this.newAccountType), this.newAccountType = Ra.Expense, this.newAccountName = "";
      } catch (t) {
        Se(t);
      }
      (e = bootstrap.Modal.getOrCreateInstance(this.$refs.dialogAddAccount)) == null || e.hide(), this.busy = !1;
    },
    async conventionalChanged(e) {
      try {
        const t = e.isIncome ? Ra.Income : Ra.Expense;
        await this.accountStore.setConventional(t, e.nameUrl, e.conventional);
      } catch (t) {
        Se(t);
      }
    },
    async shortTermChanged(e) {
      try {
        const t = e.isIncome ? Ra.Income : Ra.Expense;
        await this.accountStore.setShortTerm(t, e.nameUrl, e.shortTerm);
      } catch (t) {
        Se(t);
      }
    },
    tableStyles(e) {
      return {
        custom: e.isCustom
      };
    },
    showEditAccountDialog(e, t = Ra.Expense) {
      var s;
      this.editingEntry = !0, this.editAccountId = e.id, this.newAccountType = t, this.newAccountName = e.name, (s = bootstrap.Modal.getOrCreateInstance(this.$refs.dialogAddAccount)) == null || s.show();
    },
    async editAccount() {
      var e;
      try {
        this.busy = !0, await this.accountStore.editIncomeExpenseAccount(this.editAccountId, this.newAccountName), this.editAccountId = void 0, this.newAccountType = Ra.Expense, this.newAccountName = "";
      } catch (t) {
        Se(t);
      }
      (e = bootstrap.Modal.getOrCreateInstance(this.$refs.dialogAddAccount)) == null || e.hide(), this.busy = !1;
    },
    showDeleteAccountDialog(e) {
      var t;
      this.deleteAccountId = e.id, this.newAccountName = e.name, (t = bootstrap.Modal.getOrCreateInstance(this.$refs.dialogDeleteAccount)) == null || t.show();
    },
    async deleteAccount() {
      var e;
      try {
        this.busy = !0, await this.accountStore.deleteIncomeExpenseAccount(this.deleteAccountId), this.deleteAccountId = void 0, this.newAccountType = Ra.Expense, this.newAccountName = "";
      } catch (t) {
        Se(t);
      }
      (e = bootstrap.Modal.getOrCreateInstance(this.$refs.dialogDeleteAccount)) == null || e.hide(), this.busy = !1;
    }
  },
  mounted() {
    this.aclLoaded.then(this.accountStore.fetchIncomeExpenseAccounts);
  }
}), cae = { class: "row mb-3" }, uae = { class: "col" }, pae = { class: "card border mb-4" }, hae = { class: "fw-bold fs-6 card-header bg-white" }, mae = { class: "table-responsive" }, fae = { class: "table mb-0 table-fixed" }, gae = {
  colspan: "2",
  class: "text-center border-start"
}, vae = { class: "text-center border-start" }, yae = { class: "text-center" }, bae = { class: "badge rounded-pill text-bg-warning" }, Aae = {
  key: 0,
  class: "badge rounded-pill text-bg-lava"
}, wae = {
  key: 1,
  class: "badge rounded-pill text-bg-eclipse"
}, Cae = { class: "d-flex" }, Sae = {
  key: 0,
  class: "actions d-flex gap-2 ms-auto"
}, Pae = ["onClick"], kae = ["onClick"], Eae = { class: "text-center border-start" }, Iae = ["onChange"], Tae = { class: "card-footer border-0 bg-white" }, Oae = { class: "card border mb-4" }, Rae = { class: "fw-bold fs-6 card-header bg-white" }, Lae = { class: "table mb-0 table-fixed" }, Bae = {
  colspan: "2",
  class: "text-center border-start"
}, Mae = { class: "text-center border-start" }, xae = { class: "text-center" }, Fae = { class: "badge rounded-pill text-bg-warning" }, Vae = {
  key: 0,
  class: "badge rounded-pill text-bg-lava"
}, Dae = {
  key: 1,
  class: "badge rounded-pill text-bg-eclipse"
}, Nae = { class: "d-flex" }, jae = {
  key: 0,
  class: "actions d-flex gap-2 ms-auto"
}, Hae = ["onClick"], Uae = ["onClick"], zae = { class: "text-center border-start" }, Wae = ["onChange"], Gae = { class: "card-footer border-0 bg-white" }, Yae = { class: "card border" }, Xae = { class: "fw-bold fs-6 card-header bg-white" }, qae = { class: "table mb-0 table-fixed" }, Qae = {
  colspan: "2",
  class: "text-center border-start"
}, Kae = { class: "text-center border-start" }, Zae = { class: "text-center" }, Jae = { class: "badge rounded-pill text-bg-warning" }, $ae = {
  key: 0,
  class: "badge rounded-pill text-bg-lava"
}, _ae = {
  key: 1,
  class: "badge rounded-pill text-bg-eclipse"
}, ene = { class: "d-flex" }, tne = {
  key: 0,
  class: "actions d-flex gap-2 ms-auto"
}, sne = ["onClick"], ane = ["onClick"], nne = { class: "text-center border-start" }, rne = ["onChange"], one = { class: "card-footer border-0 bg-white" }, ine = {
  class: "modal fade",
  id: "dialogAddAccount",
  ref: "dialogAddAccount",
  tabindex: "-1",
  "aria-labelledby": "dialogAddAccountLabel",
  "aria-hidden": "true"
}, lne = { class: "modal-dialog modal-lg modal-dialog-centered" }, dne = { class: "modal-content bg-gradient-alphabet rounded" }, cne = { class: "modal-header border-0 pb-0" }, une = {
  class: "modal-title fs-5 fw-bold",
  id: "dialogAddAccountLabel"
}, pne = ["disabled"], hne = { class: "modal-body" }, mne = { class: "row" }, fne = { class: "col-sm-4" }, gne = ["disabled"], vne = { class: "col-sm-8" }, yne = ["disabled"], bne = { class: "modal-footer border-0 pt-0" }, Ane = ["disabled"], wne = ["disabled"], Cne = ["disabled"], Sne = {
  class: "modal fade",
  ref: "dialogDeleteAccount",
  id: "dialogDeleteAccount",
  tabindex: "-1",
  "aria-labelledby": "dialogDeleteAccountLabel",
  "aria-hidden": "true"
}, Pne = { class: "modal-dialog modal-dialog-centered" }, kne = { class: "modal-content bg-gradient-alphabet rounded" }, Ene = { class: "modal-body text-center px-5 pb-5 pt-0 d-flex flex-column align-items-center justify-content-center" }, Ine = ["disabled"];
function Tne(e, t, s, n, r, i) {
  return p(), h(A, null, [
    a("div", cae, [
      a("div", uae, [
        a("h2", {
          class: "fw-bold fs-3",
          onClick: t[0] || (t[0] = (...o) => e.accountStore.fetchIncomeExpenseAccounts && e.accountStore.fetchIncomeExpenseAccounts(...o))
        }, g(e.$t("t-income-expense-accounts")), 1),
        t[9] || (t[9] = a("p", null, " Configure Rescover's income and expense accounts to match your needs. Add accounts such as parking income, landscaping, or accounting fees to suit the analysis to your scenario. You are able to add up to 10 custom accounts for each type: Income, Expense & Non Operating Expense. ", -1))
      ])
    ]),
    a("div", pae, [
      a("p", hae, g(e.$t("t-income-accounts")), 1),
      a("div", mae, [
        a("table", fae, [
          a("thead", null, [
            a("tr", null, [
              t[10] || (t[10] = a("th", { style: { width: "100px" } }, null, -1)),
              t[11] || (t[11] = a("th", { style: { width: "300px" } }, null, -1)),
              a("th", gae, g(e.$t("t-applies-to")), 1)
            ]),
            a("tr", null, [
              a("th", null, g(e.$t("t-type")), 1),
              a("th", null, g(e.$t("t-name")), 1),
              a("th", vae, g(e.$t("t-residential")), 1),
              a("th", yae, [
                a("span", bae, [
                  t[12] || (t[12] = a("i", { class: "fa-light fa-hourglass-start me-1" }, null, -1)),
                  y(" " + g(e.$t("t-coming-soon")), 1)
                ]),
                t[13] || (t[13] = a("br", null, null, -1)),
                y(" " + g(e.$t("t-commercial")), 1)
              ])
            ])
          ]),
          a("tbody", null, [
            (p(!0), h(A, null, D(e.incomeAccountsSorted, (o) => (p(), h("tr", {
              key: o.id,
              class: z(e.tableStyles(o))
            }, [
              a("td", null, [
                o.isCustom ? (p(), h("span", Aae, g(e.$t("t-custom")), 1)) : (p(), h("span", wae, g(e.$t("t-standard")), 1))
              ]),
              a("td", Cae, [
                y(g(o.name) + " ", 1),
                o.isCustom ? (p(), h("div", Sae, [
                  a("button", {
                    type: "button",
                    class: "btn btn-outline-eclipse btn-sm ms-auto btn-edit",
                    onClick: (l) => e.showEditAccountDialog(o, e.IncomeOrExpenseType.Income)
                  }, t[14] || (t[14] = [
                    a("i", { class: "fa-light fa-pen" }, null, -1)
                  ]), 8, Pae),
                  a("button", {
                    type: "button",
                    class: "btn btn-outline-danger btn-sm ms-auto btn-delete",
                    onClick: (l) => e.showDeleteAccountDialog(o)
                  }, t[15] || (t[15] = [
                    a("i", { class: "fa-light fa-trash-can" }, null, -1)
                  ]), 8, kae)
                ])) : P("", !0)
              ]),
              a("td", Eae, [
                a("input", {
                  class: "form-check-input",
                  type: "checkbox",
                  id: "",
                  value: "",
                  "aria-label": "",
                  checked: "",
                  disabled: "",
                  onChange: (l) => e.conventionalChanged(o)
                }, null, 40, Iae)
              ]),
              t[16] || (t[16] = a("td", { class: "text-center" }, [
                a("input", {
                  class: "form-check-input",
                  type: "checkbox",
                  id: "",
                  value: "",
                  "aria-label": "",
                  disabled: ""
                })
              ], -1))
            ], 2))), 128))
          ])
        ])
      ]),
      a("div", Tae, [
        a("button", {
          type: "button",
          class: "btn btn-link",
          onClick: t[1] || (t[1] = (o) => e.showAddAccountDialog(e.IncomeOrExpenseType.Income))
        }, [
          t[17] || (t[17] = a("i", { class: "fa-light fa-plus me-2" }, null, -1)),
          y(" " + g(e.$t("t-add-new-account")), 1)
        ])
      ])
    ]),
    a("div", Oae, [
      a("p", Rae, g(e.$t("t-operating-expense-accounts")), 1),
      a("table", Lae, [
        a("thead", null, [
          a("tr", null, [
            t[18] || (t[18] = a("th", { style: { width: "100px" } }, null, -1)),
            t[19] || (t[19] = a("th", { style: { width: "300px" } }, null, -1)),
            a("th", Bae, g(e.$t("t-applies-to")), 1)
          ]),
          a("tr", null, [
            a("th", null, g(e.$t("t-type")), 1),
            a("th", null, g(e.$t("t-name")), 1),
            a("th", Mae, g(e.$t("t-residential")), 1),
            a("th", xae, [
              a("span", Fae, [
                t[20] || (t[20] = a("i", { class: "fa-light fa-hourglass-start me-1" }, null, -1)),
                y(" " + g(e.$t("t-coming-soon")), 1)
              ]),
              t[21] || (t[21] = a("br", null, null, -1)),
              y(" " + g(e.$t("t-commercial")), 1)
            ])
          ])
        ]),
        a("tbody", null, [
          (p(!0), h(A, null, D(e.operatingExpenseAccountsSorted, (o) => (p(), h("tr", {
            key: o.id,
            class: z(e.tableStyles(o))
          }, [
            a("td", null, [
              o.isCustom ? (p(), h("span", Vae, g(e.$t("t-custom")), 1)) : (p(), h("span", Dae, g(e.$t("t-standard")), 1))
            ]),
            a("td", Nae, [
              y(g(o.name) + " ", 1),
              o.isCustom ? (p(), h("div", jae, [
                a("button", {
                  type: "button",
                  class: "btn btn-outline-eclipse btn-sm btn-edit",
                  onClick: (l) => e.showEditAccountDialog(o, e.IncomeOrExpenseType.Expense)
                }, t[22] || (t[22] = [
                  a("i", { class: "fa-light fa-pen" }, null, -1)
                ]), 8, Hae),
                a("button", {
                  type: "button",
                  class: "btn btn-outline-danger btn-sm ms-auto btn-delete",
                  onClick: (l) => e.showDeleteAccountDialog(o)
                }, t[23] || (t[23] = [
                  a("i", { class: "fa-light fa-trash-can" }, null, -1)
                ]), 8, Uae)
              ])) : P("", !0)
            ]),
            a("td", zae, [
              a("input", {
                class: "form-check-input",
                type: "checkbox",
                id: "",
                value: "",
                "aria-label": "",
                checked: "",
                disabled: "",
                onChange: (l) => e.conventionalChanged(o)
              }, null, 40, Wae)
            ]),
            t[24] || (t[24] = a("td", { class: "text-center" }, [
              a("input", {
                class: "form-check-input",
                type: "checkbox",
                id: "",
                value: "",
                "aria-label": "",
                disabled: ""
              })
            ], -1))
          ], 2))), 128))
        ])
      ]),
      a("div", Gae, [
        a("button", {
          type: "button",
          class: "btn btn-link",
          onClick: t[2] || (t[2] = (o) => e.showAddAccountDialog(e.IncomeOrExpenseType.Expense))
        }, [
          t[25] || (t[25] = a("i", { class: "fa-light fa-plus me-2" }, null, -1)),
          y(" " + g(e.$t("t-add-new-account")), 1)
        ])
      ])
    ]),
    a("div", Yae, [
      a("p", Xae, g(e.$t("t-non-operating-expense-accounts")), 1),
      a("table", qae, [
        a("thead", null, [
          a("tr", null, [
            t[26] || (t[26] = a("th", { style: { width: "100px" } }, null, -1)),
            t[27] || (t[27] = a("th", { style: { width: "300px" } }, null, -1)),
            a("th", Qae, g(e.$t("t-applies-to")), 1)
          ]),
          a("tr", null, [
            a("th", null, g(e.$t("t-type")), 1),
            a("th", null, g(e.$t("t-name")), 1),
            a("th", Kae, g(e.$t("t-residential")), 1),
            a("th", Zae, [
              a("span", Jae, [
                t[28] || (t[28] = a("i", { class: "fa-light fa-hourglass-start me-1" }, null, -1)),
                y(" " + g(e.$t("t-coming-soon")), 1)
              ]),
              t[29] || (t[29] = a("br", null, null, -1)),
              y(" " + g(e.$t("t-commercial")), 1)
            ])
          ])
        ]),
        a("tbody", null, [
          (p(!0), h(A, null, D(e.nonOperatingExpenseAccountsSorted, (o) => (p(), h("tr", {
            key: o.id,
            class: z(e.tableStyles(o))
          }, [
            a("td", null, [
              o.isCustom ? (p(), h("span", $ae, g(e.$t("t-custom")), 1)) : (p(), h("span", _ae, g(e.$t("t-standard")), 1))
            ]),
            a("td", ene, [
              y(g(o.name) + " ", 1),
              o.isCustom ? (p(), h("div", tne, [
                a("button", {
                  type: "button",
                  class: "btn btn-outline-eclipse btn-sm ms-auto btn-edit",
                  onClick: (l) => e.showEditAccountDialog(o, e.IncomeOrExpenseType.NonOperatingExpense)
                }, t[30] || (t[30] = [
                  a("i", { class: "fa-light fa-pen" }, null, -1)
                ]), 8, sne),
                a("button", {
                  type: "button",
                  class: "btn btn-outline-danger btn-sm ms-auto btn-delete",
                  onClick: (l) => e.showDeleteAccountDialog(o)
                }, t[31] || (t[31] = [
                  a("i", { class: "fa-light fa-trash-can" }, null, -1)
                ]), 8, ane)
              ])) : P("", !0)
            ]),
            a("td", nne, [
              a("input", {
                class: "form-check-input",
                type: "checkbox",
                id: "",
                value: "",
                "aria-label": "",
                checked: "",
                disabled: "",
                onChange: (l) => e.conventionalChanged(o)
              }, null, 40, rne)
            ]),
            t[32] || (t[32] = a("td", { class: "text-center" }, [
              a("input", {
                class: "form-check-input",
                type: "checkbox",
                id: "",
                value: "",
                "aria-label": "",
                disabled: ""
              })
            ], -1))
          ], 2))), 128))
        ])
      ]),
      a("div", one, [
        a("button", {
          type: "button",
          class: "btn btn-link",
          onClick: t[3] || (t[3] = (o) => e.showAddAccountDialog(e.IncomeOrExpenseType.NonOperatingExpense))
        }, [
          t[33] || (t[33] = a("i", { class: "fa-light fa-plus me-2" }, null, -1)),
          y(" " + g(e.$t("t-add-new-account")), 1)
        ])
      ])
    ]),
    a("div", ine, [
      a("div", lne, [
        a("div", dne, [
          a("div", cne, [
            a("h1", une, [
              e.editingEntry ? (p(), h(A, { key: 0 }, [
                y(" Edit ")
              ], 64)) : (p(), h(A, { key: 1 }, [
                y(" Add ")
              ], 64)),
              t[34] || (t[34] = y(" Account "))
            ]),
            a("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close",
              disabled: !e.canAddNew
            }, null, 8, pne)
          ]),
          a("div", hne, [
            a("div", mne, [
              a("div", fne, [
                V(a("select", {
                  class: "form-select",
                  "onUpdate:modelValue": t[4] || (t[4] = (o) => e.newAccountType = o),
                  disabled: !e.canAddNew | e.editingEntry
                }, t[35] || (t[35] = [
                  a("option", { value: "income" }, "Income", -1),
                  a("option", { value: "expense" }, "Operating Expense", -1),
                  a("option", { value: "nonOperatingExpense" }, "Non-Operating Expense", -1)
                ]), 8, gne), [
                  [We, e.newAccountType]
                ])
              ]),
              a("div", vne, [
                V(a("input", {
                  type: "text",
                  class: "form-control",
                  "onUpdate:modelValue": t[5] || (t[5] = (o) => e.newAccountName = o),
                  disabled: !e.canAddNew
                }, null, 8, yne), [
                  [_e, e.newAccountName]
                ])
              ])
            ])
          ]),
          a("div", bne, [
            a("button", {
              type: "button",
              class: "btn btn-secondary",
              "data-bs-dismiss": "modal",
              disabled: !e.canAddNew
            }, g(e.$t("t-cancel")), 9, Ane),
            e.editingEntry ? (p(), h("button", {
              key: 0,
              type: "button",
              class: "btn btn-lava ms-auto",
              onClick: t[6] || (t[6] = (...o) => e.editAccount && e.editAccount(...o)),
              disabled: !e.canAddNew
            }, "Update", 8, wne)) : (p(), h("button", {
              key: 1,
              type: "button",
              class: "btn btn-lava ms-auto",
              onClick: t[7] || (t[7] = (...o) => e.addAccount && e.addAccount(...o)),
              disabled: !e.canAddNew
            }, g(e.$t("t-add")), 9, Cne))
          ])
        ])
      ])
    ], 512),
    a("div", Sne, [
      a("div", Pne, [
        a("div", kne, [
          t[39] || (t[39] = a("div", { class: "modal-header border-0" }, [
            a("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            })
          ], -1)),
          a("div", Ene, [
            t[36] || (t[36] = a("span", { class: "bg-danger rounded-circle mb-4 p-3 text-white" }, [
              a("i", { class: "fa-light fa-trash-can fa-2xl" })
            ], -1)),
            t[37] || (t[37] = a("p", { class: "fw-bold fs-4 mb-0" }, "Are you sure?", -1)),
            t[38] || (t[38] = a("p", { class: "mb-5" }, "Clicking Delete below will remove your Custom Account. This action cannot be undone.", -1)),
            a("button", {
              type: "button",
              class: "btn btn-danger",
              onClick: t[8] || (t[8] = (...o) => e.deleteAccount && e.deleteAccount(...o)),
              disabled: !e.canAddNew
            }, "Yes, Delete", 8, Ine)
          ])
        ])
      ])
    ], 512)
  ], 64);
}
const Zis = /* @__PURE__ */ Ae(dae, [["render", Tne]]), One = me({
  name: "ZohoConnection",
  props: {},
  data() {
    return {
      isLoading: !0,
      isConfigured: !1
    };
  },
  methods: {
    linkZoho() {
      window.location.href = "/crm/zoho/authorize";
    },
    async unlink() {
      try {
        this.isLoading = !0, await W.api.crm.unlink(bt.Zoho), this.isConfigured = !1;
      } catch (e) {
        Se(e);
      }
      this.isLoading = !1;
    },
    async save() {
      try {
        this.isLoading = !0;
        const e = await W.api.crm.updateSettings(bt.Zoho);
        if (e.data.status != de.Success)
          throw new Error(e.data.message);
        this.isConfigured = !0;
      } catch (e) {
        Se(e);
      }
      wt("CRM Settings Save successfully"), this.isLoading = !1;
    }
  },
  created() {
  },
  async mounted() {
    const e = await W.api.crm.isConfigured(bt.Zoho);
    this.isConfigured = e.data.result, this.isLoading = !1;
  }
}), Rne = { class: "card-body border-bottom" }, Lne = ["disabled"], Bne = {
  key: 1,
  class: "d-flex justify-content-justify align-items-center bg-success rounded p-1 text-white"
}, Mne = ["disabled"], xne = { class: "card-body d-flex justify-content-end" }, Fne = ["disabled"];
function Vne(e, t, s, n, r, i) {
  return p(), h(A, null, [
    a("div", Rne, [
      e.isConfigured ? (p(), h("div", Bne, [
        t[3] || (t[3] = a("div", { class: "ms-3 fw-bold" }, [
          a("i", { class: "fa-light fa-check-circle me-1" }),
          y("Zoho CRM Account linked! ")
        ], -1)),
        e.isConfigured ? (p(), h("button", {
          key: 0,
          class: "ms-auto btn btn-outline-danger",
          onClick: t[1] || (t[1] = (...o) => e.unlink && e.unlink(...o)),
          type: "button",
          disabled: e.isLoading
        }, "Remove", 8, Mne)) : P("", !0)
      ])) : (p(), h("button", {
        key: 0,
        onClick: t[0] || (t[0] = (...o) => e.linkZoho && e.linkZoho(...o)),
        class: "btn btn-accent-glass",
        disabled: e.isLoading
      }, "Authenticate with Zoho CRM", 8, Lne))
    ]),
    a("div", xne, [
      a("button", {
        type: "button",
        class: "btn btn-lava",
        onClick: t[2] || (t[2] = (...o) => e.save && e.save(...o)),
        disabled: e.isLoading
      }, "Save", 8, Fne)
    ])
  ], 64);
}
const Dne = /* @__PURE__ */ Ae(One, [["render", Vne]]), Nne = me({
  name: "LeadSimpleConnection",
  props: {},
  data() {
    return {
      isLoading: !0,
      api_key: void 0,
      api_key_verified: void 0
    };
  },
  computed: {
    keyLocked() {
      return this.isLoading || this.api_key_verified != null && this.api_key == this.api_key_verified;
    },
    ...at(Mn),
    ...q(Te, ["access", "aclLoaded", "isClient", "isAdmin", "isUser"]),
    ...q(Mn, ["crmUsers", "isConfigured"]),
    ...q(ct, ["userInfo", "account"])
  },
  methods: {
    async loadSettings() {
      try {
        if (this.isLoading = !0, await this.crmStore.fetchSettings(), this.isConfigured) {
          const e = await W.api.crm.getSettings(bt.LeadSimple);
          this.api_key = e.data.settings.apiKey, this.api_key_verified = e.data.settings.apiKey;
        }
      } catch (e) {
        Se(e);
      }
      this.isLoading = !1;
    },
    async verifyKey() {
      try {
        this.isLoading = !0;
        const e = await W.api.crm.verifyConnection(bt.LeadSimple, {
          apiKey: this.api_key
        });
        if (e.data.status != de.Success)
          throw new Error(e.data.message);
        const t = {
          apiKey: this.api_key
        };
        if ((await W.api.crm.updateSettings(bt.LeadSimple, t)).data.status != de.Success)
          throw new Error(e.data.message);
        await this.crmStore.fetchSettings(), this.api_key_verified = this.api_key;
      } catch (e) {
        Se(e);
      }
      this.isLoading = !1;
    },
    async unlink() {
      try {
        this.isLoading = !0, await W.api.crm.unlink(bt.LeadSimple), await this.crmStore.fetchSettings(), this.api_key = void 0, this.api_key_verified = void 0;
      } catch (e) {
        Se(e);
      }
      this.isLoading = !1;
    },
    async save() {
      try {
        this.isLoading = !0;
        const e = {
          crmUserId: this.userInfo.crmUserId
        };
        this.isUser == !1 && (e.apiKey = this.api_key);
        const t = await W.api.crm.updateSettings(bt.LeadSimple, e);
        if (t.data.status != de.Success)
          throw new Error(t.data.message);
        this.isConfigured = !0, this.api_key_verified = this.api_key;
      } catch (e) {
        Se(e);
      }
      wt("CRM Settings Save successfully"), this.isLoading = !1;
    }
  },
  created() {
  },
  mounted() {
    this.aclLoaded.then(this.loadSettings).then(this.crmStore.fetchCrmUsers);
  }
}), jne = { class: "card-body border-bottom" }, Hne = {
  key: 0,
  class: "mb-3"
}, Une = { class: "input-group" }, zne = ["disabled"], Wne = ["disabled"], Gne = ["disabled"], Yne = {
  key: 1,
  class: "mb-3"
}, Xne = ["disabled"], qne = ["value"], Qne = { class: "card-body d-flex justify-content-end" }, Kne = ["disabled"];
function Zne(e, t, s, n, r, i) {
  return p(), h(A, null, [
    a("div", jne, [
      e.isUser ? P("", !0) : (p(), h("div", Hne, [
        t[5] || (t[5] = a("label", {
          for: "api_key",
          class: "form-label"
        }, "API Key", -1)),
        a("div", Une, [
          V(a("input", {
            type: "text",
            id: "api_key",
            class: "form-control",
            placeholder: "LeadSimple API Key",
            "aria-label": "LeadSimple API Key",
            "onUpdate:modelValue": t[0] || (t[0] = (o) => e.api_key = o),
            disabled: e.keyLocked
          }, null, 8, zne), [
            [_e, e.api_key]
          ]),
          e.isConfigured ? (p(), h("button", {
            key: 0,
            class: "btn btn-outline-danger",
            onClick: t[1] || (t[1] = (...o) => e.unlink && e.unlink(...o)),
            type: "button",
            disabled: e.isLoading
          }, "Remove", 8, Wne)) : P("", !0),
          e.isConfigured ? P("", !0) : (p(), h("button", {
            key: 1,
            class: "btn btn-eclipse",
            onClick: t[2] || (t[2] = (...o) => e.verifyKey && e.verifyKey(...o)),
            disabled: e.isLoading
          }, "Verify", 8, Gne))
        ])
      ])),
      e.userInfo ? (p(), h("div", Yne, [
        t[7] || (t[7] = a("label", {
          for: "firstname",
          class: "form-label"
        }, "My CRM User / Username", -1)),
        V(a("select", {
          disabled: e.crmUsers.length == 0 || e.isLoading,
          "onUpdate:modelValue": t[3] || (t[3] = (o) => e.userInfo.crmUserId = o),
          class: "form-select",
          id: "firstname"
        }, [
          t[6] || (t[6] = a("option", {
            disabled: "",
            value: "",
            selected: ""
          }, "Please select one", -1)),
          (p(!0), h(A, null, D(e.crmUsers, (o) => (p(), h("option", {
            value: o.id
          }, g(o.name), 9, qne))), 256))
        ], 8, Xne), [
          [We, e.userInfo.crmUserId]
        ])
      ])) : P("", !0)
    ]),
    a("div", Qne, [
      a("button", {
        type: "button",
        class: "btn btn-lava",
        onClick: t[4] || (t[4] = (...o) => e.save && e.save(...o)),
        disabled: e.isLoading
      }, "Save", 8, Kne)
    ])
  ], 64);
}
const Jne = /* @__PURE__ */ Ae(Nne, [["render", Zne]]), $ne = me({
  name: "ActiveCampaignConnection",
  props: {},
  data() {
    return {
      isLoading: !0,
      isConfigured: !1,
      account: void 0,
      api_key: void 0,
      api_key_verified: void 0
    };
  },
  methods: {
    async verifyKey() {
      try {
        this.isLoading = !0;
        const e = await W.api.crm.verifyConnection(bt.ActiveCampaign, {
          account: this.account,
          apiKey: this.api_key
        });
        if (e.data.status != de.Success)
          throw new Error(e.data.message);
        this.account = e.data.properties.account, this.api_key = e.data.properties.apiKey;
        const t = {
          apiKey: this.api_key,
          additionalProperties: {
            account: this.account
          },
          defaultAgentAssignee: "",
          defaultOwnerAssignee: ""
        };
        if ((await W.api.crm.updateSettings(bt.ActiveCampaign, t)).data.status != de.Success)
          throw new Error(e.data.message);
        this.isConfigured = !0, this.api_key_verified = this.api_key;
      } catch (e) {
        Se(e);
      }
      this.isLoading = !1;
    },
    async unlink() {
      try {
        this.isLoading = !0, await W.api.crm.unlink(bt.ActiveCampaign), this.isConfigured = !1, this.api_key = void 0, this.api_key_verified = void 0;
      } catch (e) {
        Se(e);
      }
      this.isLoading = !1;
    },
    async save() {
      try {
        this.isLoading = !0;
        const e = {
          apiKey: this.api_key,
          additionalProperties: {
            account: this.account
          }
        }, t = await W.api.crm.updateSettings(bt.ActiveCampaign, e);
        if (t.data.status != de.Success)
          throw new Error(t.data.message);
        this.isConfigured = !0, this.api_key_verified = this.api_key;
      } catch (e) {
        Se(e);
      }
      wt("CRM Settings Save successfully"), this.isLoading = !1;
    }
  },
  computed: {
    keyLocked() {
      return this.isLoading || this.api_key_verified != null && this.api_key == this.api_key_verified;
    },
    ...q(Te, ["access", "aclLoaded", "isClient", "isAdmin", "isUser"])
  },
  async created() {
  },
  async mounted() {
    var t, s, n, r;
    const e = await W.api.crm.isConfigured(bt.ActiveCampaign);
    if (e.data.result) {
      const i = await W.api.crm.getSettings(bt.ActiveCampaign);
      this.isConfigured = e.data.result, this.managedBy = i.data.managedBy, this.account = (s = (t = i.data.settings) == null ? void 0 : t.additionalProperties) == null ? void 0 : s.account, this.api_key = (n = i.data.settings) == null ? void 0 : n.apiKey, this.api_key_verified = (r = i.data.settings) == null ? void 0 : r.apiKey;
    }
    this.isLoading = !1;
  }
}), _ne = { class: "card-body border-bottom" }, ere = { class: "mb-3" }, tre = { class: "input-group" }, sre = ["disabled"], are = { key: 0 }, nre = { class: "input-group" }, rre = ["disabled"], ore = ["disabled"], ire = ["disabled"], lre = { class: "card-body d-flex justify-content-end" }, dre = ["disabled"], cre = { key: 1 };
function ure(e, t, s, n, r, i) {
  var o, l;
  return p(), h(A, null, [
    a("div", _ne, [
      a("div", ere, [
        t[5] || (t[5] = a("label", {
          for: "api_key",
          class: "form-label"
        }, "Account Id", -1)),
        a("div", tre, [
          V(a("input", {
            type: "text",
            class: "form-control",
            placeholder: "ActiveCampaign Account Id",
            "aria-label": "ActiveCampaign Account Id",
            "onUpdate:modelValue": t[0] || (t[0] = (d) => e.account = d),
            disabled: e.keyLocked || e.managedBy
          }, null, 8, sre), [
            [_e, e.account]
          ])
        ])
      ]),
      e.managedBy ? P("", !0) : (p(), h("div", are, [
        t[6] || (t[6] = a("label", {
          for: "api_key",
          class: "form-label"
        }, "API Key", -1)),
        a("div", nre, [
          V(a("input", {
            type: "text",
            class: "form-control",
            id: "api_key",
            placeholder: "ActiveCampaign API Key",
            "aria-label": "ActiveCampaign API Key",
            "onUpdate:modelValue": t[1] || (t[1] = (d) => e.api_key = d),
            disabled: e.keyLocked
          }, null, 8, rre), [
            [_e, e.api_key]
          ]),
          e.isConfigured ? (p(), h("button", {
            key: 0,
            class: "btn btn-outline-danger",
            onClick: t[2] || (t[2] = (...d) => e.unlink && e.unlink(...d)),
            type: "button",
            disabled: e.isLoading
          }, "Remove", 8, ore)) : P("", !0),
          e.isConfigured ? P("", !0) : (p(), h("button", {
            key: 1,
            class: "btn btn-eclipse",
            onClick: t[3] || (t[3] = (...d) => e.verifyKey && e.verifyKey(...d)),
            disabled: e.isLoading
          }, "Verify", 8, ire))
        ])
      ]))
    ]),
    a("div", lre, [
      e.isUser ? (p(), h("span", cre, [
        t[7] || (t[7] = y(" Please contact the account owner, ")),
        a("b", null, g((o = e.managedBy) == null ? void 0 : o.firstName) + " " + g((l = e.managedBy) == null ? void 0 : l.lastName), 1),
        t[8] || (t[8] = y(", to modify this CRM connection. "))
      ])) : (p(), h("button", {
        key: 0,
        type: "button",
        class: "btn btn-lava",
        onClick: t[4] || (t[4] = (...d) => e.save && e.save(...d)),
        disabled: e.isLoading
      }, "Save", 8, dre))
    ])
  ], 64);
}
const pre = /* @__PURE__ */ Ae($ne, [["render", ure]]), hre = me({
  name: "CRMConnection",
  props: {},
  components: {
    ActiveCampaignConnection: pre,
    LeadSimpleConnection: Jne,
    ZohoConnection: Dne
  },
  data() {
    return {
      isUpdating: !1,
      crmProvider: void 0,
      isLoading: !1
    };
  },
  computed: {
    isActiveCampaign() {
      return this.crmProvider == bt.ActiveCampaign;
    },
    isLeadSimple() {
      return this.crmProvider == bt.LeadSimple;
    },
    isZoho() {
      return this.crmProvider == bt.Zoho;
    },
    ...at(Te, ct, Mn),
    ...q(Te, ["access", "aclLoaded", "isClient", "isAdmin", "isUser"]),
    ...q(ct, ["userInfo"]),
    ...q(Mn, ["isConfigured", "managedBy"])
  },
  methods: {
    async getSettings() {
      var e;
      try {
        await this.accountStore.fetchUserSettings(), await this.crmStore.fetchSettings(), this.crmProvider = (e = this.userInfo) == null ? void 0 : e.crmProvider;
      } catch (t) {
        Se(t);
      }
    },
    async unlink() {
      try {
        this.isLoading = !0, this.userInfo.crmProvider && await W.api.crm.unlink(this.userInfo.crmProvider), await this.crmStore.fetchSettings();
      } catch (e) {
        Se(e);
      }
      this.isLoading = !1;
    }
  },
  mounted() {
    this.aclLoaded.then(this.getSettings);
  }
}), mre = { class: "row" }, fre = { class: "col-md-6" }, gre = { class: "card shadow" }, vre = { class: "card-body pb-0" }, yre = {
  key: 0,
  class: "row"
}, bre = { class: "col-sm-8" }, Are = {
  key: 0,
  class: "form-control-plaintext fw-bold"
}, wre = {
  key: 1,
  class: "form-control-plaintext fw-bold"
}, Cre = {
  key: 2,
  class: "form-control-plaintext fw-bold"
}, Sre = { class: "col-sm-8" }, Pre = { class: "form-control-plaintext fw-bold" }, kre = ["disabled"], Ere = {
  key: 3,
  class: "card-body d-flex justify-content-end"
}, Ire = ["disabled"];
function Tre(e, t, s, n, r, i) {
  var c, u;
  const o = pe("active-campaign-connection"), l = pe("lead-simple-connection"), d = pe("zoho-connection");
  return p(), h("div", mre, [
    t[6] || (t[6] = a("div", { class: "col-12" }, [
      a("h2", { class: "fw-bold fs-3 mb-3" }, "CRM Connection")
    ], -1)),
    a("div", fre, [
      a("div", gre, [
        a("div", vre, [
          e.isUser ? (p(), h("div", yre, [
            t[2] || (t[2] = a("label", { class: "col-sm-4 col-form-label" }, "CRM Provider:", -1)),
            a("div", bre, [
              e.isActiveCampaign ? (p(), h("span", Are, "ActiveCampaign")) : e.isLeadSimple ? (p(), h("span", wre, "LeadSimple")) : e.isZoho ? (p(), h("span", Cre, "Zoho")) : P("", !0)
            ]),
            t[3] || (t[3] = a("label", { class: "col-sm-4 col-form-label" }, "Managed by:", -1)),
            a("div", Sre, [
              a("span", Pre, g((c = e.managedBy) == null ? void 0 : c.firstName) + " " + g((u = e.managedBy) == null ? void 0 : u.lastName), 1)
            ])
          ])) : (p(), h(A, { key: 1 }, [
            t[5] || (t[5] = a("label", {
              for: "crmProvider",
              class: "form-label"
            }, "CRM Provider", -1)),
            V(a("select", {
              "onUpdate:modelValue": t[0] || (t[0] = (m) => e.crmProvider = m),
              class: "form-select",
              id: "crmProvider",
              disabled: e.isConfigured
            }, t[4] || (t[4] = [
              a("option", { value: void 0 }, "None", -1),
              a("option", { value: "active-campaign" }, "ActiveCampaign", -1),
              a("option", { value: "lead-simple" }, "LeadSimple", -1),
              a("option", { value: "zoho" }, "Zoho CRM", -1)
            ]), 8, kre), [
              [We, e.crmProvider]
            ])
          ], 64))
        ]),
        e.isActiveCampaign ? (p(), Fe(o, { key: 0 })) : e.isLeadSimple ? (p(), Fe(l, { key: 1 })) : e.isZoho ? (p(), Fe(d, { key: 2 })) : e.isUser ? P("", !0) : (p(), h("div", Ere, [
          a("button", {
            type: "button",
            class: "btn btn-lava",
            onClick: t[1] || (t[1] = (...m) => e.unlink && e.unlink(...m)),
            disabled: e.isLoading
          }, "Remove Connection", 8, Ire)
        ]))
      ])
    ])
  ]);
}
const Jis = /* @__PURE__ */ Ae(hre, [["render", Tre]]), Ore = me({
  name: "LeadAssignment",
  props: {},
  data() {
    return {
      busy: !0,
      isLoading: !0,
      linked: []
    };
  },
  computed: {
    crmConfigured() {
      var e;
      return ((e = this.userInfo) == null ? void 0 : e.crmProvider) != null;
    },
    ...at(Te, ct, Mn),
    ...q(Te, ["access", "aclLoaded"]),
    ...q(ct, ["userInfo"]),
    ...q(Mn, ["crmUsers"])
  },
  methods: {
    isMe(e) {
      var t;
      return ((t = this.userInfo) == null ? void 0 : t.id) == e;
    },
    async loadCrmUsers() {
      var e;
      try {
        this.busy = !0, this.isLoading = !0, ((e = this.userInfo) == null ? void 0 : e.crmProvider) != null && await this.crmStore.fetchCrmUsers();
      } catch (t) {
        Se(t);
      }
      this.busy = !1, this.isLoading = !1;
    },
    async loadUserAssignments() {
      try {
        this.busy = !0, this.isLoading = !0;
        const e = await W.api.crm.getUserAssignments();
        if (e.data.status != de.Success)
          throw new Le(e);
        this.linked.length = 0, e.data.users && this.linked.push(...e.data.users);
      } catch (e) {
        Se(e.message);
      }
      this.busy = !1, this.isLoading = !1;
    },
    async saveUserAssignments() {
      try {
        this.busy = !0;
        const e = {
          users: this.linked.map((s) => ({
            id: s.id,
            crmId: s.crmId
          }))
        }, t = await W.api.crm.updateUserAssignments(e);
        if (t.data.status != de.Success)
          throw new Error(t.data.message);
        wt("Saved Sucessfully");
      } catch (e) {
        Se(e);
      }
      this.busy = !1;
    }
  },
  mounted() {
    this.aclLoaded.then(() => this.accountStore.fetchUserSettings()).then(() => this.loadCrmUsers()).then(() => this.loadUserAssignments()), document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach((e) => bootstrap.Tooltip.getOrCreateInstance(e));
  }
}), Rre = { class: "row" }, Lre = { class: "col" }, Bre = { class: "card shadow mb-3" }, Mre = {
  key: 0,
  class: "table-responsive"
}, xre = { class: "table" }, Fre = {
  key: 0,
  class: "badge rounded-pill text-bg-secondary"
}, Vre = ["onUpdate:modelValue", "disabled"], Dre = ["value"], Nre = {
  key: 1,
  class: "card-body"
}, jre = { class: "d-flex justify-content-end mb-3" }, Hre = ["disabled"];
function Ure(e, t, s, n, r, i) {
  return p(), h(A, null, [
    t[4] || (t[4] = a("div", { class: "row mb-3" }, [
      a("div", { class: "col" }, [
        a("h2", { class: "fw-bold fs-3 mb-0" }, "CRM Users")
      ])
    ], -1)),
    a("div", Rre, [
      a("div", Lre, [
        a("div", Bre, [
          e.isLoading ? (p(), h("div", Nre, t[3] || (t[3] = [
            a("i", { class: "fa-duotone fa-solid fa-compass fa-spin me-2" }, null, -1),
            y("Loading... ")
          ]))) : (p(), h("div", Mre, [
            a("table", xre, [
              t[2] || (t[2] = a("thead", null, [
                a("tr", null, [
                  a("th", null, "Rescover User"),
                  a("th", null, "Email"),
                  a("th", null, "CRM Account")
                ])
              ], -1)),
              a("tbody", null, [
                (p(!0), h(A, null, D(e.linked, (o) => (p(), h("tr", {
                  key: o.id
                }, [
                  a("td", null, [
                    y(g(o.firstName) + " " + g(o.lastName) + " ", 1),
                    e.isMe(o.id) ? (p(), h("span", Fre, "You")) : P("", !0)
                  ]),
                  a("td", null, g(o.email), 1),
                  a("td", null, [
                    V(a("select", {
                      "onUpdate:modelValue": (l) => o.crmId = l,
                      class: "form-select",
                      "aria-label": "CRM Account",
                      disabled: !e.crmConfigured || e.busy
                    }, [
                      t[1] || (t[1] = a("option", { value: void 0 }, "None", -1)),
                      (p(!0), h(A, null, D(e.crmUsers, (l) => (p(), h("option", {
                        value: l.id
                      }, g(l.name), 9, Dre))), 256))
                    ], 8, Vre), [
                      [We, o.crmId]
                    ])
                  ])
                ]))), 128))
              ])
            ])
          ]))
        ]),
        a("div", jre, [
          a("button", {
            type: "button",
            class: "btn btn-lava",
            onClick: t[0] || (t[0] = (...o) => e.saveUserAssignments && e.saveUserAssignments(...o)),
            disabled: e.busy
          }, "Save changes", 8, Hre)
        ])
      ])
    ])
  ], 64);
}
const $is = /* @__PURE__ */ Ae(Ore, [["render", Ure]]), zre = me({
  name: "RequiredFields",
  props: {
    requiredFields: {
      type: Array
    }
  },
  emits: [
    "update:requiredFields"
  ],
  data() {
    return {
      isLoading: !0
    };
  },
  methods: {},
  watch: {
    requiredFields: {
      deep: !0,
      handler(e, t) {
        console.log(`${this.$options.name}.watch.requiredFields`);
      }
    }
  },
  created() {
  },
  async mounted() {
    this.isLoading = !1;
  }
}), Wre = ["for"], Gre = ["disabled", "onUpdate:modelValue"];
function Yre(e, t, s, n, r, i) {
  return p(), h(A, null, [
    t[1] || (t[1] = a("div", { class: "col-md-12" }, [
      a("hr"),
      a("p", { class: "fw-bold fs-6 mb-3" }, "Required Fields Mapping")
    ], -1)),
    (p(!0), h(A, null, D(e.requiredFields, (o) => (p(), h("div", {
      class: "col-md-12",
      key: o.id
    }, [
      a("label", {
        for: o.id,
        class: "form-label"
      }, g(o.displayName), 9, Wre),
      V(a("select", {
        disabled: e.isLoading,
        "onUpdate:modelValue": (l) => o.map = l,
        class: "form-select"
      }, t[0] || (t[0] = [
        a("option", {
          disabled: "",
          value: "",
          selected: ""
        }, "Please select one", -1),
        a("option", { value: "empty" }, "<Empty Text>", -1),
        a("option", { value: "owner.FirstName" }, "First Name", -1),
        a("option", { value: "owner.LastName" }, "Last Name", -1)
      ]), 8, Gre), [
        [We, o.map]
      ])
    ]))), 128))
  ], 64);
}
const Yk = /* @__PURE__ */ Ae(zre, [["render", Yre]]), Xre = me({
  props: {},
  components: {
    RequiredFields: Yk
  },
  data() {
    return {
      isLoading: !0,
      isConfigured: !1,
      requiredFields: [],
      crm_users: [],
      leadStatuses: {},
      campaigns: [],
      default_owner_assignee: "",
      default_owner_lead_status: "",
      default_owner_campaign: "",
      default_agent_assignee: "",
      default_agent_lead_status: "",
      default_agent_campaign: ""
    };
  },
  methods: {
    linkZoho() {
      window.location.href = "/crm/zoho/authorize";
    },
    async updateZoho() {
      try {
        this.isLoading = !0;
        const e = {
          fields: this.requiredFields,
          defaultAgentAssignee: this.default_agent_assignee,
          defaultAgentLeadStatus: this.default_agent_lead_status,
          defaultAgentCampaign: this.default_agent_campaign,
          defaultOwnerAssignee: this.default_owner_assignee,
          defaultOwnerLeadStatus: this.default_owner_lead_status,
          defaultOwnerCampaign: this.default_owner_campaign
        }, t = await W.api.crm.updateSettings(bt.Zoho, e);
        if (t.data.status != de.Success)
          throw new Error(t.data.message);
        wt("Settings saved successfully!");
      } catch (e) {
        Se(e);
      }
      this.isLoading = !1;
    },
    configureCRMSettings() {
      var s, n;
      const e = document.querySelector('#accordionSettings button[data-bs-target="#crm-connection"]'), t = document.querySelector("#accordionSettings #collapsePersonalization");
      (s = bootstrap.Tab.getOrCreateInstance(e)) == null || s.show(), (n = bootstrap.Collapse.getOrCreateInstance(t)) == null || n.toggle();
    }
  },
  created() {
  },
  async mounted() {
    var t;
    const e = await W.api.crm.isConfigured(bt.Zoho);
    if (this.isConfigured = e.data.result, e.data.result)
      try {
        const s = await W.api.crm.getUsers(bt.Zoho);
        if (s.data.status != de.Success)
          throw new Error(s.data.message);
        this.crm_users.push(...s.data.results);
        const n = await W.api.crm.getSettings(bt.Zoho);
        if (n.data.status != de.Success)
          throw new Error(n.data.message);
        this.default_owner_assignee = n.data.settings.defaultOwnerAssignee, this.default_owner_lead_status = n.data.settings.defaultOwnerLeadStatus, this.default_owner_campaign = n.data.settings.defaultOwnerCampaign, this.default_agent_assignee = n.data.settings.defaultAgentAssignee, this.default_agent_lead_status = n.data.settings.defaultAgentLeadStatus, this.default_agent_campaign = n.data.settings.defaultAgentCampaign;
        const r = n.data.settings.fields.filter((l) => l.isRequired);
        this.requiredFields.push(...r);
        const i = await W.api.crm.getFieldOptions(bt.Zoho, "Lead_Status");
        if (i.data.status != de.Success)
          throw new Error(i.data.message);
        this.leadStatuses = i.data.options;
        const o = await W.api.crm.getCampaigns(bt.Zoho);
        if (o.data.status != de.Success)
          throw new Error(o.data.message);
        ((t = o.data.campaigns) == null ? void 0 : t.length) > 0 && this.campaigns.push(...o.data.campaigns);
      } catch (s) {
        Se(s);
      }
    this.isLoading = !1;
  }
}), qre = { class: "card-body border-bottom" }, Qre = { class: "mb-3" }, Kre = ["disabled"], Zre = ["value"], Jre = { class: "mb-3" }, $re = ["disabled"], _re = ["value"], eoe = ["disabled"], toe = ["value"], soe = { class: "card-body border-bottom" }, aoe = { class: "mb-3" }, noe = ["disabled"], roe = ["value"], ooe = { class: "mb-3" }, ioe = ["disabled"], loe = ["value"], doe = ["disabled"], coe = ["value"], uoe = { class: "card-body" }, poe = ["disabled"], hoe = {
  key: 1,
  class: "card-body bg-info-subtle rounded"
};
function moe(e, t, s, n, r, i) {
  return pe("required-fields"), e.isConfigured ? (p(), h(A, { key: 0 }, [
    a("div", qre, [
      t[15] || (t[15] = a("div", { class: "mb-3 d-flex justify-content-between align-items-center" }, [
        a("span", { class: "fs-6 fw-bold" }, "Targets"),
        a("button", {
          type: "button",
          class: "btn btn-success"
        }, "Refresh CRM Options")
      ], -1)),
      a("div", Qre, [
        t[10] || (t[10] = a("label", {
          for: "firstname",
          class: "form-label"
        }, "Default Assignee", -1)),
        V(a("select", {
          disabled: e.crm_users.length == 0 || e.isLoading,
          "onUpdate:modelValue": t[0] || (t[0] = (o) => e.default_owner_assignee = o),
          class: "form-select"
        }, [
          t[9] || (t[9] = a("option", {
            disabled: "",
            value: "",
            selected: ""
          }, "Please select one", -1)),
          (p(!0), h(A, null, D(e.crm_users, (o) => (p(), h("option", {
            value: o.id
          }, g(o.name), 9, Zre))), 256))
        ], 8, Kre), [
          [We, e.default_owner_assignee]
        ])
      ]),
      a("div", Jre, [
        t[12] || (t[12] = a("label", {
          for: "firstname",
          class: "form-label"
        }, "Default Lead Status", -1)),
        V(a("select", {
          disabled: e.isLoading,
          "onUpdate:modelValue": t[1] || (t[1] = (o) => e.default_owner_lead_status = o),
          class: "form-select"
        }, [
          t[11] || (t[11] = a("option", {
            disabled: "",
            value: "",
            selected: ""
          }, "Please select one", -1)),
          (p(!0), h(A, null, D(e.leadStatuses, (o) => (p(), h("option", { value: o }, g(o), 9, _re))), 256))
        ], 8, $re), [
          [We, e.default_owner_lead_status]
        ])
      ]),
      a("div", null, [
        t[14] || (t[14] = a("label", {
          for: "firstname",
          class: "form-label"
        }, "Default Campaign", -1)),
        V(a("select", {
          disabled: e.isLoading,
          "onUpdate:modelValue": t[2] || (t[2] = (o) => e.default_owner_campaign = o),
          class: "form-select"
        }, [
          t[13] || (t[13] = a("option", { value: "" }, "None", -1)),
          (p(!0), h(A, null, D(e.campaigns, (o) => (p(), h("option", {
            value: o.id
          }, g(o.name), 9, toe))), 256))
        ], 8, eoe), [
          [We, e.default_owner_campaign]
        ])
      ])
    ]),
    a("div", soe, [
      t[22] || (t[22] = a("p", { class: "fw-bold fs-6 mb-3" }, "Investor Agents", -1)),
      a("div", aoe, [
        t[17] || (t[17] = a("label", {
          for: "firstname",
          class: "form-label"
        }, "Default Assignee", -1)),
        V(a("select", {
          disabled: e.crm_users.length == 0 || e.isLoading,
          "onUpdate:modelValue": t[3] || (t[3] = (o) => e.default_agent_assignee = o),
          class: "form-select"
        }, [
          t[16] || (t[16] = a("option", {
            disabled: "",
            value: "",
            selected: ""
          }, "Please select one", -1)),
          (p(!0), h(A, null, D(e.crm_users, (o) => (p(), h("option", {
            value: o.id
          }, g(o.name), 9, roe))), 256))
        ], 8, noe), [
          [We, e.default_agent_assignee]
        ])
      ]),
      a("div", ooe, [
        t[19] || (t[19] = a("label", {
          for: "firstname",
          class: "form-label"
        }, "Default Lead Status", -1)),
        V(a("select", {
          disabled: e.isLoading,
          "onUpdate:modelValue": t[4] || (t[4] = (o) => e.default_agent_lead_status = o),
          class: "form-select"
        }, [
          t[18] || (t[18] = a("option", {
            disabled: "",
            value: "",
            selected: ""
          }, "Please select one", -1)),
          (p(!0), h(A, null, D(e.leadStatuses, (o) => (p(), h("option", { value: o }, g(o), 9, loe))), 256))
        ], 8, ioe), [
          [We, e.default_agent_lead_status]
        ])
      ]),
      a("div", null, [
        t[21] || (t[21] = a("label", {
          for: "firstname",
          class: "form-label"
        }, "Default Campaign", -1)),
        V(a("select", {
          disabled: e.isLoading,
          "onUpdate:modelValue": t[5] || (t[5] = (o) => e.default_agent_campaign = o),
          class: "form-select"
        }, [
          t[20] || (t[20] = a("option", { value: "" }, "None", -1)),
          (p(!0), h(A, null, D(e.campaigns, (o) => (p(), h("option", {
            value: o.id
          }, g(o.name), 9, coe))), 256))
        ], 8, doe), [
          [We, e.default_agent_campaign]
        ])
      ])
    ]),
    a("div", uoe, [
      P("", !0),
      e.isConfigured ? (p(), h("button", {
        key: 1,
        onClick: t[7] || (t[7] = (...o) => e.updateZoho && e.updateZoho(...o)),
        class: "btn btn-lava",
        disabled: e.isLoading
      }, "Save CRM Settings", 8, poe)) : P("", !0)
    ])
  ], 64)) : (p(), h("div", hoe, [
    t[23] || (t[23] = a("p", null, [
      a("i", { class: "fa-duotone fa-solid fa-info-circle me-2" }),
      y("Your CRM Connection isn't configured yet. ")
    ], -1)),
    a("button", {
      type: "button",
      class: "btn btn-lava",
      onClick: t[8] || (t[8] = (...o) => e.configureCRMSettings && e.configureCRMSettings(...o))
    }, "Configure")
  ]));
}
const foe = /* @__PURE__ */ Ae(Xre, [["render", moe]]), goe = me({
  name: "LeadSimpleSettings",
  props: {},
  data() {
    return {
      isLoading: !0,
      isConfigured: !1,
      api_key: void 0,
      api_key_verified: void 0,
      pipelines: [],
      ownerStages: [],
      ownerSources: [],
      default_owner_assignee: "",
      default_owner_pipeline: "",
      default_owner_source: "",
      default_owner_stage: "",
      agentStages: [],
      agentSources: [],
      default_agent_assignee: "",
      default_agent_pipeline: "",
      default_agent_source: "",
      default_agent_stage: ""
    };
  },
  computed: {
    keyLocked() {
      return this.isLoading || this.api_key_verified != null && this.api_key == this.api_key_verified;
    },
    ...at(Mn),
    ...q(Mn, ["crmUsers"])
  },
  methods: {
    async loadAllOptions() {
      await this.loadCrmUsers(), await this.loadPipelines(), await this.loadStages(
        0
        /* Owner */
      ), await this.loadSources(
        0
        /* Owner */
      ), await this.loadStages(
        1
        /* Agent */
      ), await this.loadSources(
        1
        /* Agent */
      );
    },
    async loadCrmUsers() {
      try {
        this.isLoading = !0, await this.crmStore.fetchCrmUsers();
      } catch (e) {
        Se(e);
      }
      this.isLoading = !1;
    },
    async loadPipelines() {
      try {
        this.isLoading = !0, this.pipelines.length = 0;
        const e = await W.api.crm.getPipelines(bt.LeadSimple);
        if (e.data.status != de.Success)
          throw new Error(e.data.message);
        this.pipelines.push(...e.data.pipelines);
      } catch (e) {
        Se(e);
      }
      this.isLoading = !1;
    },
    async pipelineChanged(e) {
      e === 0 ? this.default_owner_stage = "" : this.default_agent_stage = "", await this.loadSources(e), await this.loadStages(e);
    },
    async loadStages(e) {
      let t;
      if (e === 0 ? (this.ownerStages.length = 0, t = this.default_owner_pipeline) : (this.agentStages.length = 0, t = this.default_agent_pipeline), t) {
        try {
          this.isLoading = !0;
          const s = await W.api.crm.getStages(bt.LeadSimple, t);
          if (s.data.status != de.Success)
            throw new Error(s.data.message);
          e === 0 ? this.ownerStages.push(...s.data.stages) : this.agentStages.push(...s.data.stages);
        } catch (s) {
          Se(s);
        }
        this.isLoading = !1;
      }
    },
    async loadSources(e) {
      let t;
      if (e === 0 ? (this.ownerSources.length = 0, t = this.default_owner_pipeline) : (this.agentSources.length = 0, t = this.default_agent_pipeline), t) {
        try {
          this.isLoading = !0;
          const s = await W.api.crm.getSources(t);
          if (s.data.status != de.Success)
            throw new Error(s.data.message);
          e === 0 ? this.ownerSources.push(...s.data.sources) : this.agentSources.push(...s.data.sources);
        } catch (s) {
          Se(s);
        }
        this.isLoading = !1;
      }
    },
    async updateSettings() {
      try {
        this.isLoading = !0;
        const e = {
          apiKey: this.api_key,
          defaultAgentAssignee: this.default_agent_assignee,
          defaultAgentPipeline: this.default_agent_pipeline,
          defaultAgentStage: this.default_agent_stage,
          defaultAgentSource: this.default_agent_source,
          defaultOwnerAssignee: this.default_owner_assignee,
          defaultOwnerPipeline: this.default_owner_pipeline,
          defaultOwnerStage: this.default_owner_stage,
          defaultOwnerSource: this.default_owner_source
        }, t = await W.api.crm.updateSettings(bt.LeadSimple, e);
        if (t.data.status != de.Success)
          throw new Error(t.data.message);
        wt("Settings saved successfully!"), this.pipelines.length == 0 && await this.loadPipelines();
      } catch (e) {
        Se(e);
      }
      this.isLoading = !1;
    }
  },
  created() {
  },
  async mounted() {
    const e = await W.api.crm.isConfigured(bt.LeadSimple);
    if (e.data.result) {
      const t = await W.api.crm.getSettings(bt.LeadSimple);
      this.isConfigured = e.data.result, this.api_key = t.data.settings.apiKey, this.api_key_verified = t.data.settings.apiKey, this.default_owner_assignee = t.data.settings.defaultOwnerAssignee, this.default_owner_pipeline = t.data.settings.defaultOwnerPipeline, this.default_owner_source = t.data.settings.defaultOwnerSource, this.default_owner_stage = t.data.settings.defaultOwnerStage, this.default_agent_assignee = t.data.settings.defaultAgentAssignee, this.default_agent_pipeline = t.data.settings.defaultAgentPipeline, this.default_agent_source = t.data.settings.defaultAgentSource, this.default_agent_stage = t.data.settings.defaultAgentStage, await this.loadAllOptions();
    }
    this.isLoading = !1;
  }
}), voe = { class: "card-body border-bottom" }, yoe = { class: "mb-3 d-flex justify-content-between align-items-center" }, boe = { class: "mb-3" }, Aoe = ["disabled"], woe = ["value"], Coe = { class: "mb-3" }, Soe = ["disabled"], Poe = ["value"], koe = { class: "mb-3" }, Eoe = ["disabled"], Ioe = ["value"], Toe = ["disabled"], Ooe = ["value"], Roe = { class: "card-body border-bottom" }, Loe = { class: "mb-3" }, Boe = ["disabled"], Moe = ["value"], xoe = { class: "mb-3" }, Foe = ["disabled"], Voe = ["value"], Doe = { class: "mb-3" }, Noe = ["disabled"], joe = ["value"], Hoe = ["disabled"], Uoe = ["value"], zoe = {
  key: 0,
  class: "card-body"
}, Woe = ["disabled"];
function Goe(e, t, s, n, r, i) {
  return p(), h(A, null, [
    a("div", voe, [
      a("div", yoe, [
        t[12] || (t[12] = a("span", { class: "fs-6 fw-bold" }, "Targets", -1)),
        a("button", {
          type: "button",
          class: "btn btn-success",
          onClick: t[0] || (t[0] = (...o) => e.loadAllOptions && e.loadAllOptions(...o))
        }, "Refresh CRM Options")
      ]),
      a("div", boe, [
        t[14] || (t[14] = a("label", {
          for: "firstname",
          class: "form-label"
        }, "Default Assignee", -1)),
        V(a("select", {
          disabled: e.crmUsers.length == 0 || e.isLoading,
          "onUpdate:modelValue": t[1] || (t[1] = (o) => e.default_owner_assignee = o),
          class: "form-select"
        }, [
          t[13] || (t[13] = a("option", {
            disabled: "",
            value: "",
            selected: ""
          }, "Please select one", -1)),
          (p(!0), h(A, null, D(e.crmUsers, (o) => (p(), h("option", {
            value: o.id
          }, g(o.name), 9, woe))), 256))
        ], 8, Aoe), [
          [We, e.default_owner_assignee]
        ])
      ]),
      a("div", Coe, [
        t[16] || (t[16] = a("label", {
          for: "firstname",
          class: "form-label"
        }, "Default Pipeline", -1)),
        V(a("select", {
          disabled: e.pipelines.length == 0 || e.isLoading,
          "onUpdate:modelValue": t[2] || (t[2] = (o) => e.default_owner_pipeline = o),
          class: "form-select",
          onChange: t[3] || (t[3] = (o) => e.pipelineChanged(0)),
          ref: "drpPipeline"
        }, [
          t[15] || (t[15] = a("option", {
            disabled: "",
            value: "",
            selected: ""
          }, "Please select one", -1)),
          (p(!0), h(A, null, D(e.pipelines, (o) => (p(), h("option", {
            value: o.id
          }, g(o.name), 9, Poe))), 256))
        ], 40, Soe), [
          [We, e.default_owner_pipeline]
        ])
      ]),
      a("div", koe, [
        t[18] || (t[18] = a("label", {
          for: "ownerSource",
          class: "form-label"
        }, "Pipeline Source", -1)),
        V(a("select", {
          id: "ownerSource",
          disabled: e.ownerSources.length == 0 || e.isLoading,
          "onUpdate:modelValue": t[4] || (t[4] = (o) => e.default_owner_source = o),
          class: "form-select"
        }, [
          t[17] || (t[17] = a("option", {
            disabled: "",
            value: ""
          }, "Please select one", -1)),
          (p(!0), h(A, null, D(e.ownerSources, (o) => (p(), h("option", {
            value: o.id
          }, g(o.name), 9, Ioe))), 256))
        ], 8, Eoe), [
          [We, e.default_owner_source]
        ])
      ]),
      a("div", null, [
        t[20] || (t[20] = a("label", {
          for: "lastname",
          class: "form-label"
        }, "Default Stage", -1)),
        V(a("select", {
          disabled: e.ownerStages.length == 0 || e.isLoading,
          "onUpdate:modelValue": t[5] || (t[5] = (o) => e.default_owner_stage = o),
          class: "form-select",
          ref: "drpStage"
        }, [
          t[19] || (t[19] = a("option", {
            disabled: "",
            value: ""
          }, "Please select one", -1)),
          (p(!0), h(A, null, D(e.ownerStages, (o) => (p(), h("option", {
            value: o.id
          }, g(o.name), 9, Ooe))), 256))
        ], 8, Toe), [
          [We, e.default_owner_stage]
        ])
      ])
    ]),
    a("div", Roe, [
      t[29] || (t[29] = a("p", { class: "fw-bold fs-6 mb-3" }, "Investor Agents", -1)),
      a("div", Loe, [
        t[22] || (t[22] = a("label", {
          for: "firstname",
          class: "form-label"
        }, "Default Assignee", -1)),
        V(a("select", {
          disabled: e.crmUsers.length == 0 || e.isLoading,
          "onUpdate:modelValue": t[6] || (t[6] = (o) => e.default_agent_assignee = o),
          class: "form-select"
        }, [
          t[21] || (t[21] = a("option", {
            disabled: "",
            value: "",
            selected: ""
          }, "Please select one", -1)),
          (p(!0), h(A, null, D(e.crmUsers, (o) => (p(), h("option", {
            value: o.id
          }, g(o.name), 9, Moe))), 256))
        ], 8, Boe), [
          [We, e.default_agent_assignee]
        ])
      ]),
      a("div", xoe, [
        t[24] || (t[24] = a("label", {
          for: "firstname",
          class: "form-label"
        }, "Default Pipeline", -1)),
        V(a("select", {
          disabled: e.pipelines.length == 0 || e.isLoading,
          "onUpdate:modelValue": t[7] || (t[7] = (o) => e.default_agent_pipeline = o),
          class: "form-select",
          onChange: t[8] || (t[8] = (o) => e.pipelineChanged(1)),
          ref: "drpAgentPipeline"
        }, [
          t[23] || (t[23] = a("option", {
            disabled: "",
            value: "",
            selected: ""
          }, "Please select one", -1)),
          (p(!0), h(A, null, D(e.pipelines, (o) => (p(), h("option", {
            value: o.id
          }, g(o.name), 9, Voe))), 256))
        ], 40, Foe), [
          [We, e.default_agent_pipeline]
        ])
      ]),
      a("div", Doe, [
        t[26] || (t[26] = a("label", {
          for: "agentSource",
          class: "form-label"
        }, "Pipeline Source", -1)),
        V(a("select", {
          id: "agentSource",
          disabled: e.agentSources.length == 0 || e.isLoading,
          "onUpdate:modelValue": t[9] || (t[9] = (o) => e.default_agent_source = o),
          class: "form-select"
        }, [
          t[25] || (t[25] = a("option", {
            disabled: "",
            value: ""
          }, "Please select one", -1)),
          (p(!0), h(A, null, D(e.agentSources, (o) => (p(), h("option", {
            value: o.id
          }, g(o.name), 9, joe))), 256))
        ], 8, Noe), [
          [We, e.default_agent_source]
        ])
      ]),
      a("div", null, [
        t[28] || (t[28] = a("label", {
          for: "lastname",
          class: "form-label"
        }, "Default Stage", -1)),
        V(a("select", {
          disabled: e.agentStages.length == 0 || e.isLoading,
          "onUpdate:modelValue": t[10] || (t[10] = (o) => e.default_agent_stage = o),
          class: "form-select",
          ref: "drpAgentStage"
        }, [
          t[27] || (t[27] = a("option", {
            disabled: "",
            value: ""
          }, "Please select one", -1)),
          (p(!0), h(A, null, D(e.agentStages, (o) => (p(), h("option", {
            value: o.id
          }, g(o.name), 9, Uoe))), 256))
        ], 8, Hoe), [
          [We, e.default_agent_stage]
        ])
      ])
    ]),
    e.isConfigured ? (p(), h("div", zoe, [
      a("button", {
        onClick: t[11] || (t[11] = (...o) => e.updateSettings && e.updateSettings(...o)),
        class: "btn btn-lava",
        disabled: e.isLoading
      }, "Save CRM Settings", 8, Woe)
    ])) : P("", !0)
  ], 64);
}
const Yoe = /* @__PURE__ */ Ae(goe, [["render", Goe]]), Xoe = me({
  name: "ActiveCampaignSettings",
  props: {},
  data() {
    return {
      isLoading: !0,
      isConfigured: !1,
      account: void 0,
      api_key: void 0,
      api_key_verified: void 0,
      crm_users: [],
      default_owner_assignee: "",
      default_agent_assignee: ""
    };
  },
  methods: {
    async loadCrmUsers() {
      if (this.api_key) {
        try {
          this.crm_users.length = 0, this.isLoading = !0;
          const e = await W.api.crm.getUsers(bt.ActiveCampaign);
          if (e.data.status != de.Success)
            throw new Error(e.data.message);
          this.crm_users.push(...e.data.results);
        } catch (e) {
          Se(e);
        }
        this.isLoading = !1;
      }
    },
    async updateSettings() {
      try {
        this.isLoading = !0;
        const e = {
          apiKey: this.api_key,
          additionalProperties: {
            account: this.account
          },
          defaultAgentAssignee: this.default_agent_assignee,
          defaultOwnerAssignee: this.default_owner_assignee
        }, t = await W.api.crm.updateSettings(bt.ActiveCampaign, e);
        if (t.data.status != de.Success)
          throw new Error(t.data.message);
        wt("Settings saved successfully!");
      } catch (e) {
        Se(e);
      }
      this.isLoading = !1;
    }
  },
  computed: {
    keyLocked() {
      return this.isLoading || this.api_key_verified != null && this.api_key == this.api_key_verified;
    }
  },
  created() {
  },
  async mounted() {
    var t, s, n, r, i, o;
    const e = await W.api.crm.isConfigured(bt.ActiveCampaign);
    if (e.data.result) {
      const l = await W.api.crm.getSettings(bt.ActiveCampaign);
      this.isConfigured = e.data.result, this.managedBy = l.data.managedBy, this.account = (s = (t = l.data.settings) == null ? void 0 : t.additionalProperties) == null ? void 0 : s.account, this.api_key = (n = l.data.settings) == null ? void 0 : n.apiKey, this.api_key_verified = (r = l.data.settings) == null ? void 0 : r.apiKey, this.default_owner_assignee = (i = l.data.settings) == null ? void 0 : i.defaultOwnerAssignee, this.default_agent_assignee = (o = l.data.settings) == null ? void 0 : o.defaultAgentAssignee, await this.loadCrmUsers();
    }
    this.isLoading = !1;
  }
}), qoe = { class: "card-body border-bottom" }, Qoe = ["disabled"], Koe = ["value"], Zoe = { class: "card-body border-bottom" }, Joe = ["disabled"], $oe = ["value"], _oe = {
  key: 0,
  class: "card-body"
}, eie = ["disabled"];
function tie(e, t, s, n, r, i) {
  return p(), h(A, null, [
    a("div", qoe, [
      t[5] || (t[5] = a("div", { class: "mb-3 d-flex justify-content-between align-items-center" }, [
        a("span", { class: "fs-6 fw-bold" }, "Targets"),
        a("button", {
          type: "button",
          class: "btn btn-success"
        }, "Refresh CRM Options")
      ], -1)),
      a("div", null, [
        t[4] || (t[4] = a("label", {
          for: "firstname",
          class: "form-label"
        }, "Default Assignee", -1)),
        V(a("select", {
          disabled: e.crm_users.length == 0 || e.isLoading,
          "onUpdate:modelValue": t[0] || (t[0] = (o) => e.default_owner_assignee = o),
          class: "form-select"
        }, [
          t[3] || (t[3] = a("option", {
            disabled: "",
            value: "",
            selected: ""
          }, "Please select one", -1)),
          (p(!0), h(A, null, D(e.crm_users, (o) => (p(), h("option", {
            value: o.id
          }, g(o.name), 9, Koe))), 256))
        ], 8, Qoe), [
          [We, e.default_owner_assignee]
        ])
      ])
    ]),
    a("div", Zoe, [
      t[8] || (t[8] = a("p", { class: "fw-bold fs-6 mb-3" }, "Investor Agents", -1)),
      a("div", null, [
        t[7] || (t[7] = a("label", {
          for: "firstname",
          class: "form-label"
        }, "Default Assignee", -1)),
        V(a("select", {
          disabled: e.crm_users.length == 0 || e.isLoading,
          "onUpdate:modelValue": t[1] || (t[1] = (o) => e.default_agent_assignee = o),
          class: "form-select"
        }, [
          t[6] || (t[6] = a("option", {
            disabled: "",
            value: "",
            selected: ""
          }, "Please select one", -1)),
          (p(!0), h(A, null, D(e.crm_users, (o) => (p(), h("option", {
            value: o.id
          }, g(o.name), 9, $oe))), 256))
        ], 8, Joe), [
          [We, e.default_agent_assignee]
        ])
      ])
    ]),
    e.isConfigured ? (p(), h("div", _oe, [
      a("button", {
        onClick: t[2] || (t[2] = (...o) => e.updateSettings && e.updateSettings(...o)),
        class: "btn btn-lava",
        disabled: e.isLoading
      }, "Save CRM Settings", 8, eie)
    ])) : P("", !0)
  ], 64);
}
const sie = /* @__PURE__ */ Ae(Xoe, [["render", tie]]), aie = me({
  name: "CRMSettings",
  props: {},
  components: {
    ActiveCampaignSettings: sie,
    LeadSimpleSettings: Yoe,
    ZohoSettings: foe
  },
  data() {
    return {
      isUpdating: !1
    };
  },
  computed: {
    isActiveCampaign() {
      var e;
      return ((e = this.userInfo) == null ? void 0 : e.crmProvider) == bt.ActiveCampaign;
    },
    isLeadSimple() {
      var e;
      return ((e = this.userInfo) == null ? void 0 : e.crmProvider) == bt.LeadSimple;
    },
    isZoho() {
      var e;
      return ((e = this.userInfo) == null ? void 0 : e.crmProvider) == bt.Zoho;
    },
    isNotSet() {
      return this.isActiveCampaign == !1 && this.isLeadSimple == !1 && this.isZoho == !1;
    },
    ...at(Te, ct),
    ...q(Te, ["access", "aclLoaded"]),
    ...q(ct, ["userInfo"])
  },
  created() {
  },
  mounted() {
    this.aclLoaded.then(this.accountStore.fetchUserSettings);
  },
  methods: {}
}), nie = {
  key: 0,
  class: "row"
}, rie = {
  key: 1,
  class: "row"
}, oie = { class: "col-md-6 mb-4" }, iie = { class: "card shadow" };
function lie(e, t, s, n, r, i) {
  const o = pe("active-campaign-settings"), l = pe("lead-simple-settings"), d = pe("zoho-settings");
  return p(), h(A, null, [
    t[1] || (t[1] = a("div", { class: "row mb-3" }, [
      a("div", { class: "col" }, [
        a("h2", { class: "fw-bold fs-3 mb-0" }, "Portfolio Finder")
      ])
    ], -1)),
    e.isNotSet ? (p(), h("div", nie, t[0] || (t[0] = [
      a("div", { class: "col" }, [
        a("div", { class: "alert alert-warning" }, [
          a("i", { class: "fa-light fa-triangle-exclamation me-2" }),
          y("You need to add a "),
          a("a", { href: "/account/settings#crm-connectionTab" }, "CRM Connection"),
          y(" to configure the CRM Settings.")
        ])
      ], -1)
    ]))) : (p(), h("div", rie, [
      a("div", oie, [
        a("div", iie, [
          e.isActiveCampaign ? (p(), Fe(o, { key: 0 })) : P("", !0),
          e.isLeadSimple ? (p(), Fe(l, { key: 1 })) : P("", !0),
          e.isZoho ? (p(), Fe(d, { key: 2 })) : P("", !0)
        ])
      ])
    ]))
  ], 64);
}
const _is = /* @__PURE__ */ Ae(aie, [["render", lie]]), die = me({
  name: "ZohoIdxSettings",
  props: {},
  components: {
    RequiredFields: Yk
  },
  data() {
    return {
      isLoading: !0,
      isConfigured: !1,
      requiredFields: [],
      leadStatuses: {},
      campaigns: [],
      idx_contact_form_lead_status: "",
      idx_contact_form_campaign: ""
    };
  },
  methods: {
    linkZoho() {
      window.location.href = "/crm/zoho/authorize";
    },
    async updateZoho() {
      try {
        this.isLoading = !0;
        const e = {
          fields: this.requiredFields,
          idxContactFormLeadStatus: this.idx_contact_form_lead_status,
          idxContactFormCampaign: this.idx_contact_form_campaign
        }, t = await W.api.crm.updateIdxSettings(bt.Zoho, e);
        if (t.data.status != de.Success)
          throw new Error(t.data.message);
        wt("Settings saved successfully!");
      } catch (e) {
        Se(e);
      }
      this.isLoading = !1;
    },
    configureCRMSettings() {
      var s, n;
      const e = document.querySelector('#accordionSettings button[data-bs-target="#crm-connection"]'), t = document.querySelector("#accordionSettings #collapsePersonalization");
      (s = bootstrap.Tab.getOrCreateInstance(e)) == null || s.show(), (n = bootstrap.Collapse.getOrCreateInstance(t)) == null || n.toggle();
    }
  },
  created() {
  },
  async mounted() {
    var t;
    const e = await W.api.crm.isConfigured(bt.Zoho);
    if (this.isConfigured = e.data.result, e.data.result)
      try {
        const s = await W.api.crm.getIdxSettings(bt.Zoho);
        if (s.data.status != de.Success)
          throw new Error(s.data.message);
        this.idx_contact_form_campaign = s.data.settings.idxContactFormCampaign, this.idx_contact_form_lead_status = s.data.settings.idxContactFormLeadStatus;
        const n = s.data.settings.fields.filter((o) => o.isRequired);
        this.requiredFields.push(...n);
        const r = await W.api.crm.getFieldOptions(bt.Zoho, "Lead_Status");
        if (r.data.status != de.Success)
          throw new Error(r.data.message);
        this.leadStatuses = r.data.options;
        const i = await W.api.crm.getCampaigns(bt.Zoho);
        if (i.data.status != de.Success)
          throw new Error(i.data.message);
        ((t = i.data.campaigns) == null ? void 0 : t.length) > 0 && this.campaigns.push(...i.data.campaigns);
      } catch (s) {
        Se(s);
      }
    this.isLoading = !1;
  }
}), cie = { class: "card-body border-bottom" }, uie = { class: "mb-3" }, pie = ["disabled"], hie = ["value"], mie = ["disabled"], fie = ["value"], gie = { class: "card-body" }, vie = ["disabled"], yie = {
  key: 1,
  class: "card-body bg-info-subtle rounded"
};
function bie(e, t, s, n, r, i) {
  return pe("required-fields"), e.isConfigured ? (p(), h(A, { key: 0 }, [
    a("div", cie, [
      t[9] || (t[9] = a("div", { class: "mb-3 d-flex justify-content-between align-items-center" }, [
        a("span", { class: "fs-6 fw-bold" }, "Website Property Inquiries"),
        a("button", {
          type: "button",
          class: "btn btn-success"
        }, "Refresh CRM Options")
      ], -1)),
      t[10] || (t[10] = a("p", null, 'Website inquiries are assigned to users per the "Lead Assignment" settings in the Investment Gateway settings menu.', -1)),
      a("div", uie, [
        t[6] || (t[6] = a("label", {
          for: "firstname",
          class: "form-label"
        }, "Default Lead Status", -1)),
        V(a("select", {
          disabled: e.isLoading,
          "onUpdate:modelValue": t[0] || (t[0] = (o) => e.idx_contact_form_lead_status = o),
          class: "form-select"
        }, [
          t[5] || (t[5] = a("option", {
            disabled: "",
            value: "",
            selected: ""
          }, "Please select one", -1)),
          (p(!0), h(A, null, D(e.leadStatuses, (o) => (p(), h("option", { value: o }, g(o), 9, hie))), 256))
        ], 8, pie), [
          [We, e.idx_contact_form_lead_status]
        ])
      ]),
      a("div", null, [
        t[8] || (t[8] = a("label", {
          for: "firstname",
          class: "form-label"
        }, "Default Campaign", -1)),
        V(a("select", {
          disabled: e.isLoading,
          "onUpdate:modelValue": t[1] || (t[1] = (o) => e.idx_contact_form_campaign = o),
          class: "form-select"
        }, [
          t[7] || (t[7] = a("option", { value: "" }, "None", -1)),
          (p(!0), h(A, null, D(e.campaigns, (o) => (p(), h("option", {
            value: o.id
          }, g(o.name), 9, fie))), 256))
        ], 8, mie), [
          [We, e.idx_contact_form_campaign]
        ])
      ])
    ]),
    a("div", gie, [
      P("", !0),
      e.isConfigured ? (p(), h("button", {
        key: 1,
        onClick: t[3] || (t[3] = (...o) => e.updateZoho && e.updateZoho(...o)),
        class: "btn btn-lava",
        disabled: e.isLoading
      }, "Save CRM Settings", 8, vie)) : P("", !0)
    ])
  ], 64)) : (p(), h("div", yie, [
    t[11] || (t[11] = a("p", null, [
      a("i", { class: "fa-duotone fa-solid fa-info-circle me-2" }),
      y("Your CRM Connection isn't configured yet. ")
    ], -1)),
    a("button", {
      type: "button",
      class: "btn btn-lava",
      onClick: t[4] || (t[4] = (...o) => e.configureCRMSettings && e.configureCRMSettings(...o))
    }, "Configure")
  ]));
}
const Aie = /* @__PURE__ */ Ae(die, [["render", bie]]), wie = me({
  name: "LeadSimpleIdxSettings",
  props: {},
  data() {
    return {
      isLoading: !0,
      isConfigured: !1,
      pipelines: [],
      ownerStages: [],
      ownerSources: [],
      idx_contact_form_pipeline: "",
      idx_contact_form_source: "",
      idx_contact_form_stage: ""
    };
  },
  computed: {
    ...at(Mn),
    ...q(Mn, ["crmUsers"])
  },
  methods: {
    async loadAllOptions() {
      await this.loadCrmUsers(), await this.loadPipelines(), await this.loadStages(), await this.loadSources();
    },
    async loadCrmUsers() {
      try {
        this.isLoading = !0, await this.crmStore.fetchCrmUsers();
      } catch (e) {
        Se(e);
      }
      this.isLoading = !1;
    },
    async loadPipelines() {
      try {
        this.isLoading = !0, this.pipelines.length = 0;
        const e = await W.api.crm.getPipelines(bt.LeadSimple);
        if (e.data.status != de.Success)
          throw new Error(e.data.message);
        this.pipelines.push(...e.data.pipelines);
      } catch (e) {
        Se(e);
      }
      this.isLoading = !1;
    },
    async pipelineChanged() {
      await this.loadSources(), await this.loadStages();
    },
    async loadStages() {
      if (this.idx_contact_form_pipeline) {
        try {
          this.isLoading = !0;
          const e = await W.api.crm.getStages(bt.LeadSimple, this.idx_contact_form_pipeline);
          if (e.data.status != de.Success)
            throw new Error(e.data.message);
          this.ownerStages.push(...e.data.stages);
        } catch (e) {
          Se(e);
        }
        this.isLoading = !1;
      }
    },
    async loadSources() {
      if (this.idx_contact_form_pipeline) {
        try {
          this.isLoading = !0;
          const e = await W.api.crm.getSources(this.idx_contact_form_pipeline);
          if (e.data.status != de.Success)
            throw new Error(e.data.message);
          this.ownerSources.push(...e.data.sources);
        } catch (e) {
          Se(e);
        }
        this.isLoading = !1;
      }
    },
    async updateSettings() {
      try {
        this.isLoading = !0;
        const e = {
          idxContactFormPipeline: this.idx_contact_form_pipeline,
          idxContactFormSource: this.idx_contact_form_source,
          idxContactFormStage: this.idx_contact_form_stage
        }, t = await W.api.crm.updateIdxSettings(bt.LeadSimple, e);
        if (t.data.status != de.Success)
          throw new Error(t.data.message);
        wt("Settings saved successfully!"), this.pipelines.length == 0 && await this.loadPipelines();
      } catch (e) {
        Se(e);
      }
      this.isLoading = !1;
    }
  },
  created() {
  },
  async mounted() {
    const e = await W.api.crm.isConfigured(bt.LeadSimple);
    if (e.data.result) {
      const t = await W.api.crm.getIdxSettings(bt.LeadSimple);
      this.isConfigured = e.data.result, this.idx_contact_form_pipeline = t.data.settings.idxContactFormPipeline, this.idx_contact_form_source = t.data.settings.idxContactFormSource, this.idx_contact_form_stage = t.data.settings.idxContactFormStage, await this.loadAllOptions();
    }
    this.isLoading = !1;
  }
}), Cie = { class: "card-body border-bottom" }, Sie = { class: "mb-3 d-flex justify-content-between align-items-center" }, Pie = { class: "mb-3" }, kie = ["disabled"], Eie = ["value"], Iie = { class: "mb-3" }, Tie = ["disabled"], Oie = ["value"], Rie = ["disabled"], Lie = ["value"], Bie = {
  key: 0,
  class: "card-body"
}, Mie = ["disabled"];
function xie(e, t, s, n, r, i) {
  return p(), h(A, null, [
    a("div", Cie, [
      a("div", Sie, [
        t[6] || (t[6] = a("span", { class: "fs-6 fw-bold" }, "Website Property Inquiries", -1)),
        a("button", {
          type: "button",
          class: "btn btn-success",
          onClick: t[0] || (t[0] = (...o) => e.loadAllOptions && e.loadAllOptions(...o))
        }, "Refresh CRM Options")
      ]),
      t[13] || (t[13] = a("p", null, 'Website inquiries are assigned to users per the "Lead Assignment" settings in the Investment Gateway settings menu.', -1)),
      a("div", Pie, [
        t[8] || (t[8] = a("label", {
          for: "firstname",
          class: "form-label"
        }, "Default Pipeline", -1)),
        V(a("select", {
          disabled: e.pipelines.length == 0 || e.isLoading,
          "onUpdate:modelValue": t[1] || (t[1] = (o) => e.idx_contact_form_pipeline = o),
          class: "form-select",
          onChange: t[2] || (t[2] = (...o) => e.pipelineChanged && e.pipelineChanged(...o)),
          ref: "drpPipeline"
        }, [
          t[7] || (t[7] = a("option", {
            disabled: "",
            value: "",
            selected: ""
          }, "Please select one", -1)),
          (p(!0), h(A, null, D(e.pipelines, (o) => (p(), h("option", {
            value: o.id
          }, g(o.name), 9, Eie))), 256))
        ], 40, kie), [
          [We, e.idx_contact_form_pipeline]
        ])
      ]),
      a("div", Iie, [
        t[10] || (t[10] = a("label", {
          for: "ownerSource",
          class: "form-label"
        }, "Pipeline Source", -1)),
        V(a("select", {
          id: "ownerSource",
          disabled: e.ownerSources.length == 0 || e.isLoading,
          "onUpdate:modelValue": t[3] || (t[3] = (o) => e.idx_contact_form_source = o),
          class: "form-select"
        }, [
          t[9] || (t[9] = a("option", {
            disabled: "",
            value: ""
          }, "Please select one", -1)),
          (p(!0), h(A, null, D(e.ownerSources, (o) => (p(), h("option", {
            value: o.id
          }, g(o.name), 9, Oie))), 256))
        ], 8, Tie), [
          [We, e.idx_contact_form_source]
        ])
      ]),
      a("div", null, [
        t[12] || (t[12] = a("label", {
          for: "lastname",
          class: "form-label"
        }, "Default Stage", -1)),
        V(a("select", {
          disabled: e.ownerStages.length == 0 || e.isLoading,
          "onUpdate:modelValue": t[4] || (t[4] = (o) => e.idx_contact_form_stage = o),
          class: "form-select",
          ref: "drpStage"
        }, [
          t[11] || (t[11] = a("option", {
            disabled: "",
            value: ""
          }, "Please select one", -1)),
          (p(!0), h(A, null, D(e.ownerStages, (o) => (p(), h("option", {
            value: o.id
          }, g(o.name), 9, Lie))), 256))
        ], 8, Rie), [
          [We, e.idx_contact_form_stage]
        ])
      ])
    ]),
    e.isConfigured ? (p(), h("div", Bie, [
      a("button", {
        onClick: t[5] || (t[5] = (...o) => e.updateSettings && e.updateSettings(...o)),
        class: "btn btn-lava",
        disabled: e.isLoading
      }, "Save CRM Settings", 8, Mie)
    ])) : P("", !0)
  ], 64);
}
const Fie = /* @__PURE__ */ Ae(wie, [["render", xie]]), Vie = me({
  name: "ActiveCampaignIdxSettings",
  props: {},
  data() {
    return {
      isLoading: !0,
      isConfigured: !1,
      account: void 0,
      api_key: void 0,
      api_key_verified: void 0,
      crm_users: [],
      idx_contact_form_assignee: ""
    };
  },
  methods: {
    async loadCrmUsers() {
      if (this.api_key) {
        try {
          this.crm_users.length = 0, this.isLoading = !0;
          const e = await W.api.crm.getUsers(bt.ActiveCampaign);
          if (e.data.status != de.Success)
            throw new Error(e.data.message);
          this.crm_users.push(...e.data.results);
        } catch (e) {
          Se(e);
        }
        this.isLoading = !1;
      }
    },
    async updateSettings() {
      try {
        this.isLoading = !0;
        const e = {
          apiKey: this.api_key,
          additionalProperties: {
            account: this.account
          },
          idxContactFormAssignee: this.idx_contact_form_assignee
        }, t = await W.api.crm.updateIdxSettings(bt.ActiveCampaign, e);
        if (t.data.status != de.Success)
          throw new Error(t.data.message);
        wt("Settings saved successfully!");
      } catch (e) {
        Se(e);
      }
      this.isLoading = !1;
    }
  },
  computed: {
    keyLocked() {
      return this.isLoading || this.api_key_verified != null && this.api_key == this.api_key_verified;
    }
  },
  created() {
  },
  async mounted() {
    var t, s, n, r, i;
    const e = await W.api.crm.isConfigured(bt.ActiveCampaign);
    if (e.data.result) {
      const o = await W.api.crm.getIdxSettings(bt.ActiveCampaign);
      this.isConfigured = e.data.result, this.account = (s = (t = o.data.settings) == null ? void 0 : t.additionalProperties) == null ? void 0 : s.account, this.api_key = (n = o.data.settings) == null ? void 0 : n.apiKey, this.api_key_verified = (r = o.data.settings) == null ? void 0 : r.apiKey, this.idx_contact_form_assignee = (i = o.data.settings) == null ? void 0 : i.idxContactFormAssignee, await this.loadCrmUsers();
    }
    this.isLoading = !1;
  }
}), Die = { class: "card-body border-bottom" }, Nie = ["disabled"], jie = ["value"], Hie = {
  key: 0,
  class: "card-body"
}, Uie = ["disabled"];
function zie(e, t, s, n, r, i) {
  return p(), h(A, null, [
    a("div", Die, [
      t[4] || (t[4] = a("div", { class: "mb-3 d-flex justify-content-between align-items-center" }, [
        a("span", { class: "fs-6 fw-bold" }, "Website Property Inquiries"),
        a("button", {
          type: "button",
          class: "btn btn-success"
        }, "Refresh CRM Options")
      ], -1)),
      t[5] || (t[5] = a("p", null, 'Website inquiries are assigned to users per the "Lead Assignment" settings in the Investment Gateway settings menu.', -1)),
      a("div", null, [
        t[3] || (t[3] = a("label", {
          for: "firstname",
          class: "form-label"
        }, "Idx Contact Form Assignee", -1)),
        V(a("select", {
          disabled: e.crm_users.length == 0 || e.isLoading,
          "onUpdate:modelValue": t[0] || (t[0] = (o) => e.idx_contact_form_assignee = o),
          class: "form-select"
        }, [
          t[2] || (t[2] = a("option", {
            disabled: "",
            value: "",
            selected: ""
          }, "Please select one", -1)),
          (p(!0), h(A, null, D(e.crm_users, (o) => (p(), h("option", {
            value: o.id
          }, g(o.name), 9, jie))), 256))
        ], 8, Nie), [
          [We, e.idx_contact_form_assignee]
        ])
      ])
    ]),
    e.isConfigured ? (p(), h("div", Hie, [
      a("button", {
        onClick: t[1] || (t[1] = (...o) => e.updateSettings && e.updateSettings(...o)),
        class: "btn btn-lava",
        disabled: e.isLoading
      }, "Save CRM Settings", 8, Uie)
    ])) : P("", !0)
  ], 64);
}
const Wie = /* @__PURE__ */ Ae(Vie, [["render", zie]]), Gie = me({
  name: "CRMIdxSettings",
  props: {},
  components: {
    ActiveCampaignIdxSettings: Wie,
    LeadSimpleIdxSettings: Fie,
    ZohoIdxSettings: Aie
  },
  data() {
    return {
      isUpdating: !1
    };
  },
  computed: {
    isActiveCampaign() {
      var e;
      return ((e = this.userInfo) == null ? void 0 : e.crmProvider) == bt.ActiveCampaign;
    },
    isLeadSimple() {
      var e;
      return ((e = this.userInfo) == null ? void 0 : e.crmProvider) == bt.LeadSimple;
    },
    isZoho() {
      var e;
      return ((e = this.userInfo) == null ? void 0 : e.crmProvider) == bt.Zoho;
    },
    isNotSet() {
      return this.isActiveCampaign == !1 && this.isLeadSimple == !1 && this.isZoho == !1;
    },
    ...at(Te, ct),
    ...q(Te, ["access", "aclLoaded"]),
    ...q(ct, ["userInfo"])
  },
  created() {
  },
  async mounted() {
    this.aclLoaded.then(this.accountStore.fetchUserSettings);
  },
  methods: {}
}), Yie = { class: "row g-3" }, Xie = {
  key: 0,
  class: "col-12"
}, qie = {
  key: 1,
  class: "col-md-7 mb-4"
}, Qie = { class: "card shadow" };
function Kie(e, t, s, n, r, i) {
  const o = pe("active-campaign-idx-settings"), l = pe("lead-simple-idx-settings"), d = pe("zoho-idx-settings");
  return p(), h("div", Yie, [
    t[1] || (t[1] = a("div", { class: "col-12" }, [
      a("h2", { class: "fw-bold fs-3 mb-0" }, "CRM Settings")
    ], -1)),
    e.isNotSet ? (p(), h("div", Xie, t[0] || (t[0] = [
      a("div", { class: "alert alert-warning" }, [
        a("i", { class: "fa-light fa-triangle-exclamation me-2" }),
        y("You need to add a "),
        a("a", { href: "/account/settings#crm-connectionTab" }, "CRM Connection"),
        y(" to configure the CRM Settings.")
      ], -1)
    ]))) : (p(), h("div", qie, [
      a("div", Qie, [
        e.isActiveCampaign ? (p(), Fe(o, { key: 0 })) : P("", !0),
        e.isLeadSimple ? (p(), Fe(l, { key: 1 })) : P("", !0),
        e.isZoho ? (p(), Fe(d, { key: 2 })) : P("", !0)
      ])
    ]))
  ]);
}
const els = /* @__PURE__ */ Ae(Gie, [["render", Kie]]), Zie = me({
  name: "FraLeadSimpleSettings",
  props: {},
  data() {
    return {
      isLoading: !0,
      isConfigured: !1,
      pipelines: [],
      completeStages: [],
      abandonedStages: [],
      completeSources: [],
      abandonedSources: [],
      fra_complete_pipeline: "",
      fra_complete_stage: "",
      fra_complete_source: "",
      fra_abandoned_pipeline: "",
      fra_abandoned_stage: "",
      fra_abandoned_source: ""
    };
  },
  methods: {
    async loadAllOptions() {
      await this.loadPipelines(), await this.loadStages(
        0
        /* Complete */
      ), await this.loadSources(
        0
        /* Complete */
      ), await this.loadStages(
        1
        /* Abandoned */
      ), await this.loadSources(
        1
        /* Abandoned */
      );
    },
    async loadPipelines() {
      if (this.isConfigured) {
        try {
          this.isLoading = !0, this.pipelines.length = 0;
          const e = await W.api.crm.getPipelines(bt.LeadSimple);
          if (e.data.status != de.Success)
            throw new Error(e.data.message);
          this.pipelines.push(...e.data.pipelines);
        } catch (e) {
          Se(e);
        }
        this.isLoading = !1;
      }
    },
    async pipelineChanged(e) {
      e === 0 ? this.fra_complete_stage = "" : this.fra_abandoned_stage = "", await this.loadSources(e), await this.loadStages(e);
    },
    async loadStages(e) {
      if (!this.isConfigured)
        return;
      let t;
      if (e === 0 ? (this.completeStages.length = 0, t = this.fra_complete_pipeline) : (this.abandonedStages.length = 0, t = this.fra_abandoned_pipeline), t) {
        try {
          this.isLoading = !0;
          const s = await W.api.crm.getStages(bt.LeadSimple, t);
          if (s.data.status != de.Success)
            throw new Error(s.data.message);
          e === 0 ? this.completeStages.push(...s.data.stages) : this.abandonedStages.push(...s.data.stages);
        } catch (s) {
          Se(s);
        }
        this.isLoading = !1;
      }
    },
    async loadSources(e) {
      if (!this.isConfigured)
        return;
      let t;
      if (e === 0 ? (this.completeSources.length = 0, t = this.fra_complete_pipeline) : (this.abandonedSources.length = 0, t = this.fra_abandoned_pipeline), t) {
        try {
          this.isLoading = !0;
          const s = await W.api.crm.getSources(t);
          if (s.data.status != de.Success)
            throw new Error(s.data.message);
          e === 0 ? this.completeSources.push(...s.data.sources) : this.abandonedSources.push(...s.data.sources);
        } catch (s) {
          Se(s);
        }
        this.isLoading = !1;
      }
    },
    async updateSettings() {
      try {
        this.isLoading = !0;
        const e = {
          ppeCompletedPipeline: this.fra_complete_pipeline,
          ppeCompletedStage: this.fra_complete_stage,
          ppeCompletedSource: this.fra_complete_source,
          ppeAbandonedPipeline: this.fra_abandoned_pipeline,
          ppeAbandonedStage: this.fra_abandoned_stage,
          ppeAbandonedSource: this.fra_abandoned_source
        }, t = await W.api.crm.updatePpeSettings(bt.LeadSimple, e);
        if (t.data.status != de.Success)
          throw new Error(t.data.message);
        wt("Settings saved successfully!"), this.pipelines.length == 0 && await this.loadPipelines();
      } catch (e) {
        Se(e);
      }
      this.isLoading = !1;
    }
  },
  computed: {},
  created() {
  },
  async mounted() {
    const e = await W.api.crm.isConfigured(bt.LeadSimple);
    if (e.data.result) {
      const t = await W.api.crm.getPpeSettings(bt.LeadSimple);
      this.isConfigured = e.data.result, this.fra_complete_pipeline = t.data.settings.ppeCompletedPipeline, this.fra_complete_stage = t.data.settings.ppeCompletedStage, this.fra_complete_source = t.data.settings.ppeAbandonedSource, this.fra_abandoned_pipeline = t.data.settings.ppeAbandonedPipeline, this.fra_abandoned_stage = t.data.settings.ppeAbandonedStage, this.fra_abandoned_source = t.data.settings.ppeAbandonedSource, await this.loadAllOptions();
    }
    this.isLoading = !1;
  }
}), Jie = { class: "card-body border-bottom" }, $ie = { class: "mb-3 d-flex justify-content-between align-items-center" }, _ie = { class: "mb-3" }, ele = ["disabled"], tle = ["value"], sle = { class: "mb-3" }, ale = ["disabled"], nle = ["value"], rle = ["disabled"], ole = ["value"], ile = { class: "card-body border-bottom" }, lle = { class: "mb-3" }, dle = ["disabled"], cle = ["value"], ule = { class: "mb-3" }, ple = ["disabled"], hle = ["value"], mle = ["disabled"], fle = ["value"], gle = {
  key: 0,
  class: "card-body"
}, vle = ["disabled"];
function yle(e, t, s, n, r, i) {
  return p(), h(A, null, [
    a("div", Jie, [
      a("div", $ie, [
        t[10] || (t[10] = a("span", { class: "fs-6 fw-bold" }, "Completed Forms", -1)),
        a("button", {
          type: "button",
          class: "btn btn-success",
          onClick: t[0] || (t[0] = (...o) => e.loadAllOptions && e.loadAllOptions(...o))
        }, "Refresh CRM Options")
      ]),
      t[17] || (t[17] = a("p", null, ' Analysis requests are assigned to users per the "Lead Assignment" settings in the Property Performance Engine settings menu. ', -1)),
      a("div", _ie, [
        t[12] || (t[12] = a("label", {
          for: "firstname",
          class: "form-label"
        }, "Default Pipeline", -1)),
        V(a("select", {
          disabled: e.pipelines.length == 0 || e.isLoading,
          "onUpdate:modelValue": t[1] || (t[1] = (o) => e.fra_complete_pipeline = o),
          class: "form-select",
          onChange: t[2] || (t[2] = (o) => e.pipelineChanged(0)),
          ref: "drpPipeline"
        }, [
          t[11] || (t[11] = a("option", {
            disabled: "",
            value: "",
            selected: ""
          }, "Please select one", -1)),
          (p(!0), h(A, null, D(e.pipelines, (o) => (p(), h("option", {
            value: o.id
          }, g(o.name), 9, tle))), 256))
        ], 40, ele), [
          [We, e.fra_complete_pipeline]
        ])
      ]),
      a("div", sle, [
        t[14] || (t[14] = a("label", {
          for: "completeSource",
          class: "form-label"
        }, "Pipeline Source", -1)),
        V(a("select", {
          id: "completeSource",
          disabled: e.completeSources.length == 0 || e.isLoading,
          "onUpdate:modelValue": t[3] || (t[3] = (o) => e.fra_complete_source = o),
          class: "form-select"
        }, [
          t[13] || (t[13] = a("option", {
            disabled: "",
            value: ""
          }, "Please select one", -1)),
          (p(!0), h(A, null, D(e.completeSources, (o) => (p(), h("option", {
            value: o.id
          }, g(o.name), 9, nle))), 256))
        ], 8, ale), [
          [We, e.fra_complete_source]
        ])
      ]),
      a("div", null, [
        t[16] || (t[16] = a("label", {
          for: "lastname",
          class: "form-label"
        }, "Default Stage", -1)),
        V(a("select", {
          disabled: e.completeStages.length == 0 || e.isLoading,
          "onUpdate:modelValue": t[4] || (t[4] = (o) => e.fra_complete_stage = o),
          class: "form-select",
          ref: "drpStage"
        }, [
          t[15] || (t[15] = a("option", {
            disabled: "",
            value: ""
          }, "Please select one", -1)),
          (p(!0), h(A, null, D(e.completeStages, (o) => (p(), h("option", {
            value: o.id
          }, g(o.name), 9, ole))), 256))
        ], 8, rle), [
          [We, e.fra_complete_stage]
        ])
      ])
    ]),
    a("div", ile, [
      t[24] || (t[24] = a("p", { class: "fw-bold fs-6 mb-3" }, "Abandoned Forms", -1)),
      a("div", lle, [
        t[19] || (t[19] = a("label", {
          for: "firstname",
          class: "form-label"
        }, "Default Pipeline", -1)),
        V(a("select", {
          disabled: e.pipelines.length == 0 || e.isLoading,
          "onUpdate:modelValue": t[5] || (t[5] = (o) => e.fra_abandoned_pipeline = o),
          class: "form-select",
          onChange: t[6] || (t[6] = (o) => e.pipelineChanged(1)),
          ref: "drpAgentPipeline"
        }, [
          t[18] || (t[18] = a("option", {
            disabled: "",
            value: "",
            selected: ""
          }, "Please select one", -1)),
          (p(!0), h(A, null, D(e.pipelines, (o) => (p(), h("option", {
            value: o.id
          }, g(o.name), 9, cle))), 256))
        ], 40, dle), [
          [We, e.fra_abandoned_pipeline]
        ])
      ]),
      a("div", ule, [
        t[21] || (t[21] = a("label", {
          for: "abandonedSource",
          class: "form-label"
        }, "Pipeline Source", -1)),
        V(a("select", {
          id: "abandonedSource",
          disabled: e.abandonedSources.length == 0 || e.isLoading,
          "onUpdate:modelValue": t[7] || (t[7] = (o) => e.fra_abandoned_source = o),
          class: "form-select"
        }, [
          t[20] || (t[20] = a("option", {
            disabled: "",
            value: ""
          }, "Please select one", -1)),
          (p(!0), h(A, null, D(e.abandonedSources, (o) => (p(), h("option", {
            value: o.id
          }, g(o.name), 9, hle))), 256))
        ], 8, ple), [
          [We, e.fra_abandoned_source]
        ])
      ]),
      a("div", null, [
        t[23] || (t[23] = a("label", {
          for: "lastname",
          class: "form-label"
        }, "Default Stage", -1)),
        V(a("select", {
          disabled: e.abandonedStages.length == 0 || e.isLoading,
          "onUpdate:modelValue": t[8] || (t[8] = (o) => e.fra_abandoned_stage = o),
          class: "form-select",
          ref: "drpAgentStage"
        }, [
          t[22] || (t[22] = a("option", {
            disabled: "",
            value: ""
          }, "Please select one", -1)),
          (p(!0), h(A, null, D(e.abandonedStages, (o) => (p(), h("option", {
            value: o.id
          }, g(o.name), 9, fle))), 256))
        ], 8, mle), [
          [We, e.fra_abandoned_stage]
        ])
      ])
    ]),
    e.isConfigured ? (p(), h("div", gle, [
      a("button", {
        onClick: t[9] || (t[9] = (...o) => e.updateSettings && e.updateSettings(...o)),
        class: "btn btn-lava",
        disabled: e.isLoading
      }, "Save CRM Settings", 8, vle)
    ])) : P("", !0)
  ], 64);
}
const ble = /* @__PURE__ */ Ae(Zie, [["render", yle]]), Ale = me({
  name: "FraZohoSettings",
  props: {},
  data() {
    return {
      isLoading: !0,
      isConfigured: !1,
      leadStatuses: {},
      campaigns: [],
      fra_complete_lead_status: "",
      fra_complete_campaign: "",
      fra_abandoned_lead_status: "",
      fra_abandoned_campaign: ""
    };
  },
  methods: {
    async loadLeadStatus() {
      if (this.isConfigured) {
        try {
          const e = await W.api.crm.getFieldOptions(bt.Zoho, "Lead_Status");
          this.leadStatuses = e.data.options;
        } catch (e) {
          Se(e);
        }
        this.isLoading = !1;
      }
    },
    async loadCampaigns() {
      var e;
      if (this.isConfigured) {
        try {
          const t = await W.api.crm.getCampaigns(bt.Zoho);
          if (t.data.status != de.Success)
            throw new Error(t.data.message);
          ((e = t.data.campaigns) == null ? void 0 : e.length) > 0 && this.campaigns.push(...t.data.campaigns);
        } catch (t) {
          Se(t);
        }
        this.isLoading = !1;
      }
    },
    async updateSettings() {
      try {
        this.isLoading = !0;
        const e = {
          ppeCompletedLeadStatus: this.fra_complete_lead_status,
          ppeCompletedCampaign: this.fra_complete_campaign,
          ppeAbandonedLeadStatus: this.fra_abandoned_lead_status,
          ppeAbandonedCampaign: this.fra_abandoned_campaign
        }, t = await W.api.crm.updatePpeSettings(bt.Zoho, e);
        if (t.data.status != de.Success)
          throw new Error(t.data.message);
        wt("Settings saved successfully!");
      } catch (e) {
        Se(e);
      }
      this.isLoading = !1;
    }
  },
  computed: {
    keyLocked() {
      return this.isLoading;
    }
  },
  created() {
  },
  async mounted() {
    const e = await W.api.crm.isConfigured(bt.Zoho);
    if (e.data.result) {
      this.isConfigured = e.data.result;
      const t = await W.api.crm.getPpeSettings(bt.Zoho);
      this.fra_complete_lead_status = t.data.settings.ppeCompletedLeadStatus, this.fra_complete_campaign = t.data.settings.ppeCompletedCampaign, this.fra_abandoned_lead_status = t.data.settings.ppeAbandonedLeadStatus, this.fra_abandoned_campaign = t.data.settings.ppeAbandonedCampaign, await this.loadLeadStatus(), await this.loadCampaigns();
    }
    this.isLoading = !1;
  }
}), wle = { class: "card-body border-bottom" }, Cle = { class: "mb-3" }, Sle = ["disabled"], Ple = ["value"], kle = ["disabled"], Ele = ["value"], Ile = { class: "card-body border-bottom" }, Tle = { class: "mb-3" }, Ole = ["disabled"], Rle = ["value"], Lle = ["disabled"], Ble = ["value"], Mle = {
  key: 0,
  class: "card-body"
}, xle = ["disabled"];
function Fle(e, t, s, n, r, i) {
  return p(), h(A, null, [
    a("div", wle, [
      t[9] || (t[9] = a("div", { class: "mb-3 d-flex justify-content-between align-items-center" }, [
        a("span", { class: "fs-6 fw-bold" }, "Completed Forms"),
        a("button", {
          type: "button",
          class: "btn btn-success"
        }, "Refresh CRM Options")
      ], -1)),
      t[10] || (t[10] = a("p", null, ' Analysis requests are assigned to users per the "Lead Assignment" settings in the Property Performance Engine settings menu. ', -1)),
      a("div", Cle, [
        t[6] || (t[6] = a("label", {
          for: "firstname",
          class: "form-label"
        }, "Default Lead Status", -1)),
        V(a("select", {
          disabled: e.isLoading,
          "onUpdate:modelValue": t[0] || (t[0] = (o) => e.fra_complete_lead_status = o),
          class: "form-select"
        }, [
          t[5] || (t[5] = a("option", {
            disabled: "",
            value: "",
            selected: ""
          }, "Please select one", -1)),
          (p(!0), h(A, null, D(e.leadStatuses, (o) => (p(), h("option", { value: o }, g(o), 9, Ple))), 256))
        ], 8, Sle), [
          [We, e.fra_complete_lead_status]
        ])
      ]),
      a("div", null, [
        t[8] || (t[8] = a("label", {
          for: "firstname",
          class: "form-label"
        }, "Default Campaign", -1)),
        V(a("select", {
          disabled: e.isLoading,
          "onUpdate:modelValue": t[1] || (t[1] = (o) => e.fra_complete_campaign = o),
          class: "form-select"
        }, [
          t[7] || (t[7] = a("option", { value: "" }, "None", -1)),
          (p(!0), h(A, null, D(e.campaigns, (o) => (p(), h("option", {
            value: o.id
          }, g(o.name), 9, Ele))), 256))
        ], 8, kle), [
          [We, e.fra_complete_campaign]
        ])
      ])
    ]),
    a("div", Ile, [
      t[15] || (t[15] = a("p", { class: "fw-bold fs-6 mb-3" }, "Abandoned Forms", -1)),
      a("div", Tle, [
        t[12] || (t[12] = a("label", {
          for: "firstname",
          class: "form-label"
        }, "Default Lead Status", -1)),
        V(a("select", {
          disabled: e.isLoading,
          "onUpdate:modelValue": t[2] || (t[2] = (o) => e.fra_abandoned_lead_status = o),
          class: "form-select"
        }, [
          t[11] || (t[11] = a("option", {
            disabled: "",
            value: "",
            selected: ""
          }, "Please select one", -1)),
          (p(!0), h(A, null, D(e.leadStatuses, (o) => (p(), h("option", { value: o }, g(o), 9, Rle))), 256))
        ], 8, Ole), [
          [We, e.fra_abandoned_lead_status]
        ])
      ]),
      a("div", null, [
        t[14] || (t[14] = a("label", {
          for: "firstname",
          class: "form-label"
        }, "Default Campaign", -1)),
        V(a("select", {
          disabled: e.isLoading,
          "onUpdate:modelValue": t[3] || (t[3] = (o) => e.fra_abandoned_campaign = o),
          class: "form-select"
        }, [
          t[13] || (t[13] = a("option", { value: "" }, "None", -1)),
          (p(!0), h(A, null, D(e.campaigns, (o) => (p(), h("option", {
            value: o.id
          }, g(o.name), 9, Ble))), 256))
        ], 8, Lle), [
          [We, e.fra_abandoned_campaign]
        ])
      ])
    ]),
    e.isConfigured ? (p(), h("div", Mle, [
      a("button", {
        onClick: t[4] || (t[4] = (...o) => e.updateSettings && e.updateSettings(...o)),
        class: "btn btn-lava",
        disabled: e.isLoading
      }, "Save CRM Settings", 8, xle)
    ])) : P("", !0)
  ], 64);
}
const Vle = /* @__PURE__ */ Ae(Ale, [["render", Fle]]), Dle = me({
  name: "CrmPpeSettings",
  props: {},
  components: {
    LeadSimpleSettings: ble,
    ZohoSettings: Vle
  },
  data() {
    return {
      isUpdating: !1
    };
  },
  computed: {
    isActiveCampaign() {
      var e;
      return ((e = this.userInfo) == null ? void 0 : e.crmProvider) == bt.ActiveCampaign;
    },
    isLeadSimple() {
      var e;
      return ((e = this.userInfo) == null ? void 0 : e.crmProvider) == bt.LeadSimple;
    },
    isZoho() {
      var e;
      return ((e = this.userInfo) == null ? void 0 : e.crmProvider) == bt.Zoho;
    },
    isNotSet() {
      return this.isActiveCampaign == !1 && this.isLeadSimple == !1 && this.isZoho == !1;
    },
    ...at(Te, ct),
    ...q(Te, ["access", "aclLoaded"]),
    ...q(ct, ["userInfo"])
  },
  created() {
  },
  mounted() {
    this.aclLoaded.then(this.accountStore.fetchUserSettings);
  },
  methods: {}
}), Nle = { class: "row" }, jle = {
  key: 0,
  class: "col"
}, Hle = {
  key: 1,
  class: "col-md-9"
}, Ule = { class: "card shadow" };
function zle(e, t, s, n, r, i) {
  const o = pe("lead-simple-settings"), l = pe("zoho-settings");
  return p(), h("div", Nle, [
    t[1] || (t[1] = a("div", { class: "col-12" }, [
      a("h2", { class: "fw-bold fs-3" }, "Property Performance Engine")
    ], -1)),
    e.isNotSet ? (p(), h("div", jle, t[0] || (t[0] = [
      a("div", { class: "alert alert-warning" }, [
        a("i", { class: "fa-light fa-triangle-exclamation me-2" }),
        y(" You need to add a "),
        a("a", { href: "/account/settings#crm-connectionTab" }, "CRM Connection"),
        y(" to configure the CRM Settings. ")
      ], -1)
    ]))) : (p(), h("div", Hle, [
      a("div", Ule, [
        e.isLeadSimple ? (p(), Fe(o, { key: 0 })) : P("", !0),
        e.isZoho ? (p(), Fe(l, { key: 1 })) : P("", !0)
      ])
    ]))
  ]);
}
const tls = /* @__PURE__ */ Ae(Dle, [["render", zle]]), Wle = me({
  name: "SkipTraceSettings",
  data() {
    return {
      isBusy: !1
    };
  },
  computed: {
    ignoreDncStatus: {
      get() {
        var e;
        return ((e = this.userInfo) == null ? void 0 : e.honorDncStatus) == !1;
      },
      set(e) {
        this.userInfo.honorDncStatus = !e;
      }
    },
    ...at(ct),
    ...q(ct, ["userInfo"])
  },
  methods: {
    async saveChanges() {
      try {
        this.isBusy = !0, await this.accountStore.updateUserSettings(), wt("User settings updated");
      } catch (e) {
        Se(e);
      }
      this.isBusy = !1;
    }
  },
  mounted() {
    this.accountStore.fetchUserSettings();
  }
}), Gle = { class: "row" }, Yle = { class: "col-lg-7" }, Xle = { class: "card shadow" }, qle = { class: "card-body" }, Qle = { class: "row" }, Kle = { class: "col-sm-4 justify-content-end d-flex" }, Zle = { class: "form-check form-switch form-switch-lg form-switch-basic" }, Jle = ["disabled"], $le = {
  class: "form-check-label",
  for: "flexSwitchCheckDefault"
}, _le = { class: "card-footer border-0 d-flex justify-content-end bg-white" }, ede = ["disabled"];
function tde(e, t, s, n, r, i) {
  return p(), h("div", Gle, [
    t[3] || (t[3] = a("div", { class: "col-12 mb-3" }, [
      a("h2", { class: "fw-bold fs-3 mb-0" }, "Skip Trace Settings")
    ], -1)),
    a("div", Yle, [
      a("div", Xle, [
        a("div", qle, [
          a("div", Qle, [
            t[2] || (t[2] = a("label", {
              for: "userAccount",
              class: "col-sm-8 col-form-label"
            }, "Send Phone Numbers on Do Not Call list to CRM:", -1)),
            a("div", Kle, [
              a("div", Zle, [
                V(a("input", {
                  class: "form-check-input",
                  type: "checkbox",
                  role: "switch",
                  id: "flexSwitchCheckDefault",
                  "onUpdate:modelValue": t[0] || (t[0] = (o) => e.ignoreDncStatus = o),
                  disabled: e.isBusy
                }, null, 8, Jle), [
                  [Ue, e.ignoreDncStatus]
                ]),
                a("label", $le, [
                  y(g(e.$t("t-yes")), 1),
                  a("span", null, g(e.$t("t-no")), 1)
                ])
              ])
            ])
          ])
        ]),
        a("div", _le, [
          a("button", {
            type: "button",
            class: "btn btn-lava",
            onClick: t[1] || (t[1] = (...o) => e.saveChanges && e.saveChanges(...o)),
            disabled: e.isBusy
          }, "Save", 8, ede)
        ])
      ])
    ])
  ]);
}
const sls = /* @__PURE__ */ Ae(Wle, [["render", tde]]), N2 = 1500, sde = me({
  name: "ClientValue",
  components: {
    NumericalInput: Aa
  },
  data() {
    return {
      ignoreNextPmFee: !1,
      isLoaded: !1,
      isUpdating: !1,
      pmFee: 0,
      pmFeeType: ri.Flat
    };
  },
  watch: {
    pmFeeType: "pmFeeTypeChanged"
  },
  computed: {
    ...at(Te, ct),
    ...q(Te, ["access", "aclLoaded"]),
    ...q(ct, ["userInfo"])
  },
  methods: {
    async loadSettings() {
      this.isLoaded = !1;
      try {
        this.pmFeeType != this.userInfo.propertyManagementFeeType && (this.ignoreNextPmFee = !0), this.pmFee = this.userInfo.propertyManagementFee, this.pmFeeType = this.userInfo.propertyManagementFeeType, this.isLoaded = !0;
      } catch (e) {
        Se(e);
      }
    },
    async updateSettings() {
      try {
        this.isUpdating = !0;
        let e = {
          propertyManagementFee: this.pmFee,
          propertyManagementFeeType: this.pmFeeType,
          expectedClientTenure: this.userInfo.expectedClientTenure
        };
        const t = await W.api.user.updateSettings(e);
        if (t.data.status != de.Success)
          throw new Error(t.data.message);
        console.info("updateSettings", t), wt("Settings saved successfully!");
      } catch (e) {
        Se("Update Error " + e.message);
      }
      this.isUpdating = !1;
    },
    pmFeeTypeChanged(e, t) {
      if (this.ignoreNextPmFee == !0) {
        this.ignoreNextPmFee = !1;
        return;
      }
      console.log(`${this.$options.name}.pmFeeTypeChanged`, e, t), e != t && (e == ri.Flat && (this.pmFee = this.pmFee * N2), e == ri.Percentage && (this.pmFee = this.pmFee / N2));
    }
  },
  mounted() {
    try {
      this.aclLoaded.then(async () => await this.accountStore.fetchUserSettings()).then(async () => await this.loadSettings());
    } catch (e) {
      Se(e);
    }
  }
}), ade = { class: "row g-3" }, nde = { class: "col-12" }, rde = { class: "fw-bold fs-3 mb-0" }, ode = { class: "col-md-6" }, ide = { class: "card shadow-sm" }, lde = { class: "card-body" }, dde = { class: "mb-3" }, cde = {
  class: "form-label",
  for: "pmFeeType"
}, ude = ["disabled"], pde = { value: "flat" }, hde = { value: "percentage" }, mde = { class: "mb-3" }, fde = {
  for: "inputPmFeeFlat",
  class: "form-label"
}, gde = { key: 0 }, vde = {
  for: "expectedClientTenure",
  class: "form-label"
}, yde = ["disabled"], bde = { class: "card-footer text-end" }, Ade = ["disabled"];
function wde(e, t, s, n, r, i) {
  const o = pe("numerical-input");
  return p(), h("div", ade, [
    a("div", nde, [
      a("h2", rde, g(e.$t("t-client-value")), 1)
    ]),
    a("div", ode, [
      a("div", ide, [
        a("div", lde, [
          a("p", null, g(e.$t("t-for-estimating-client-value")), 1),
          a("div", dde, [
            a("label", cde, g(e.$t("t-revenue-projection-method")), 1),
            V(a("select", {
              class: "form-select",
              id: "pmFeeType",
              "onUpdate:modelValue": t[0] || (t[0] = (l) => e.pmFeeType = l),
              disabled: !e.isLoaded || e.isUpdating
            }, [
              a("option", pde, g(e.$t("t-flat")), 1),
              a("option", hde, g(e.$t("t-percentage")), 1)
            ], 8, ude), [
              [We, e.pmFeeType]
            ])
          ]),
          a("div", mde, [
            a("label", fde, [
              e.pmFeeType == "percentage" ? (p(), h(A, { key: 0 }, [
                y(g(e.$t("t-percent-rent-collected")), 1)
              ], 64)) : P("", !0),
              e.pmFeeType == "flat" ? (p(), h(A, { key: 1 }, [
                y(g(e.$t("t-estimated-monthly-revenue")), 1)
              ], 64)) : P("", !0)
            ]),
            N(o, {
              modelValue: e.pmFee,
              "onUpdate:modelValue": t[1] || (t[1] = (l) => e.pmFee = l),
              currency: e.pmFeeType == "flat",
              percent: e.pmFeeType == "percentage",
              disabled: !e.isLoaded || e.isUpdating
            }, null, 8, ["modelValue", "currency", "percent", "disabled"])
          ]),
          e.userInfo ? (p(), h("div", gde, [
            a("label", vde, g(e.$t("t-expected-client-tenure")), 1),
            V(a("select", {
              id: "expectedClientTenure",
              "onUpdate:modelValue": t[2] || (t[2] = (l) => e.userInfo.expectedClientTenure = l),
              class: "form-select",
              disabled: !e.isLoaded || e.isUpdating
            }, t[4] || (t[4] = [
              a("option", { value: 1 }, "1 Year", -1),
              a("option", { value: 2 }, "2 Years", -1),
              a("option", { value: 3 }, "3 Years", -1),
              a("option", { value: 4 }, "4 Years", -1),
              a("option", { value: 5 }, "5 Years", -1),
              a("option", { value: 6 }, "6 Years", -1),
              a("option", { value: 7 }, "7 Years", -1),
              a("option", { value: 8 }, "8 Years", -1),
              a("option", { value: 9 }, "9 Years", -1),
              a("option", { value: 10 }, "10 Years", -1)
            ]), 8, yde), [
              [We, e.userInfo.expectedClientTenure]
            ])
          ])) : P("", !0)
        ]),
        a("div", bde, [
          a("button", {
            type: "button",
            onClick: t[3] || (t[3] = (...l) => e.updateSettings && e.updateSettings(...l)),
            class: "btn btn-lava",
            disabled: !e.isLoaded || e.isUpdating
          }, g(e.$t("t-update-settings")), 9, Ade)
        ])
      ])
    ])
  ]);
}
const als = /* @__PURE__ */ Ae(sde, [["render", wde]]), Cde = { class: "card shadow-sm card-pf-search-area" }, Sde = {
  class: "row g-0",
  style: { "min-height": "700px" }
}, Pde = { class: "col d-flex flex-column" }, kde = { class: "card-body" }, Ede = { class: "alert alert-info" }, Ide = { class: "mb-4" }, Tde = ["value"], Ode = { class: "mb-4" }, Rde = { class: "form-label" }, Lde = {
  key: 0,
  class: "alert alert-warning"
}, Bde = {
  key: 1,
  class: "alert alert-warning"
}, Mde = {
  key: 2,
  class: "alert alert-warning"
}, xde = {
  key: 3,
  class: "alert alert-warning"
}, Fde = { class: "form-label" }, Vde = { class: "border rounded overflow-hidden" }, Dde = { class: "list-unstyled mb-0" }, Nde = { class: "d-flex justify-content-between align-items-center selected-counties-item p-2" }, jde = ["onClick"], Hde = {
  key: 0,
  class: "d-flex justify-content-between align-items-center selected-counties-item p-2"
}, Ude = { class: "card-footer d-flex justify-content-between mt-auto" }, zde = ["disabled"], Wde = { class: "col bg-secondary rouned-end" }, Gde = { class: "modal-dialog modal-dialog-centered" }, Yde = { class: "modal-content bg-gradient-alphabet rounded" }, Xde = { class: "modal-body p-5 text-center" }, qde = { class: "mb-0" }, Qde = "PortfolioFinderSearchArea", nls = /* @__PURE__ */ me({
  name: Qde,
  __name: "SearchArea",
  setup(e) {
    let t, s = null;
    const n = new Promise((ge) => s = ge), r = sP(ik), i = rv("dialogSearchAreaConfirmation"), o = rv("gMap"), l = Ds(void 0), d = Ds([]), c = Ds([]), u = Ds([]), m = Ds([]), f = Ds(void 0);
    Ds(void 0);
    const v = Ds({
      zoom: 10,
      disableDefaultUI: !0,
      streetViewControl: !0,
      streetViewControlOptions: {
        position: 15
        //google.maps.ControlPosition.LEFT_BOTTOM
      },
      isFractionalZoomEnabled: !1
    }), b = Ds({
      lat: 30.173937,
      lng: -95.505836
    }), w = Te(), { access: S, aclLoaded: I } = Mm(w);
    Jn(f, (ge, he) => {
      Y();
    });
    const T = Ke(() => [...u.value].sort((ge, he) => (ge.key ?? "").localeCompare(he.key ?? ""))), x = Ke(() => m.value.filter((ge) => ge.county == "*")), k = Ke(() => u.value.filter((ge) => ge.county == "*")), C = Ke(() => k.value.filter((ge) => x.value.some((he) => he.key == ge.key) == !1)), O = Ke(() => x.value.filter((ge) => k.value.some((he) => he.key == ge.key) == !1)), E = Ke(() => k.value.length), B = Ke(() => m.value.filter((ge) => ge.county != "*")), M = Ke(() => u.value.filter((ge) => ge.county != "*")), R = Ke(() => M.value.filter((ge) => B.value.some((he) => he.key == ge.key) == !1)), F = Ke(() => B.value.filter((ge) => M.value.some((he) => he.key == ge.key) == !1)), L = Ke(() => M.value.length), j = Ke(() => {
      var he;
      if (!((he = l.value) != null && he.stateChanged))
        return Ie;
      const ge = new Date(l.value.stateChanged);
      return ge.setFullYear(ge.getFullYear() + 1), ge;
    }), H = Ke(() => j.value <= Ie), te = Ke(() => {
      var he;
      if (!((he = l.value) != null && he.countyChanged))
        return Ie;
      const ge = new Date(l.value.countyChanged);
      return ge.setMonth(ge.getMonth() + 1), ge;
    }), re = Ke(() => te.value <= Ie), le = Ke(() => {
      var Me, Ne;
      const ge = ((Me = l.value) == null ? void 0 : Me.states) ?? 0, he = ((Ne = l.value) == null ? void 0 : Ne.counties) ?? 0;
      return E.value <= ge && L.value <= he;
    });
    async function ie() {
      var ge;
      try {
        const he = await W.api.accountPortfolioFinder.getSettings();
        if (he.data.status != de.Success)
          throw new Le(he);
        l.value = he.data.settings, (ge = he.data.settings) != null && ge.selected && (u.value = [...he.data.settings.selected], m.value = [...he.data.settings.selected]);
      } catch (he) {
        Se(he);
      }
    }
    async function ye() {
      try {
        const ge = await W.api.geo.states();
        if (ge.data.status != de.Success)
          throw new Le(ge);
        d.value.length = 0, ge.data.states && d.value.push(...ge.data.states);
      } catch (ge) {
        Se(ge);
      }
    }
    async function Y() {
      var ge, he;
      try {
        if (!f.value)
          return;
        const Me = await W.api.geo.countiesForState(f.value);
        if (Me.data.status != de.Success)
          throw new Le(Me);
        c.value.length = 0, ((ge = l.value) == null ? void 0 : ge.states) > 0 && c.value.push({
          county: "*",
          state: f.value,
          key: `${f.value}:*`
        }), Me.data.page && ((he = l.value) == null ? void 0 : he.counties) > 0 && c.value.push(...Me.data.page);
      } catch (Me) {
        Se(Me);
      }
    }
    async function ae() {
      var ge;
      try {
        const he = await W.api.accountPortfolioFinder.coverageByCounty();
        if (he.data.status != de.Success)
          throw new Le(he);
        await n;
        const Me = ((ge = he.data.coverage) == null ? void 0 : ge.features.filter((Ne) => Ne.id !== void 0).map((Ne) => Ne.id)) ?? [];
        t.data.forEach((Ne) => {
          (Ne.getProperty("type") != "county" || !Me.find((mt) => mt == Ne.getId())) && t.data.remove(Ne);
        }), t.data.addGeoJson(he.data.coverage);
      } catch (he) {
        Se(he);
      } finally {
      }
    }
    function ke(ge) {
      ge ? u.value = u.value.filter((he) => he.key != ge.key) : u.value = [];
    }
    function ue(ge) {
      var he;
      return ((he = d.value.find((Me) => Me.abv == ge)) == null ? void 0 : he.name) ?? ge;
    }
    async function oe() {
      var ge;
      try {
        const he = {
          searchArea: u.value
        }, Me = await W.api.accountPortfolioFinder.updateSettings(he);
        if (Me.data.status != de.Success)
          throw new Le(Me);
        m.value = [...u.value];
      } catch (he) {
        Se(he);
      } finally {
        (ge = bootstrap.Modal.getOrCreateInstance(i.value)) == null || ge.hide();
      }
    }
    async function fe() {
      b.value = {
        lat: 30.173937,
        lng: -95.505836
      }, v.value = {
        zoom: 10,
        disableDefaultUI: !0,
        streetViewControl: !0,
        streetViewControlOptions: {
          position: google.maps.ControlPosition.LEFT_BOTTOM
        },
        isFractionalZoomEnabled: !1
      }, t = o.value.$mapObject, t.data.addListener("addfeature", we), t.data.addListener("removefeature", we), t.data.addListener("setgeometry", we), t.data.addListener("mouseover", (ge) => {
        const he = ge.feature.getProperty("type"), Me = ge.feature.getProperty("name");
        if (Me)
          switch (he) {
            case "zip":
              t.getDiv().setAttribute("title", `Zip: ${Me}`);
              break;
            case "county":
              t.getDiv().setAttribute("title", `County: ${Me}`);
              break;
            default:
              t.getDiv().setAttribute("title", Me);
              break;
          }
      }), t.data.addListener("mouseout", (ge) => {
        t.getDiv().removeAttribute("title");
      }), t.data.setStyle((ge) => {
        let he = "black", Me = 1, Ne = 0.15;
        switch (ge.getProperty("type")) {
          case "clusterBound":
            he = "#0c78b4", Me = 3;
            break;
          case "zip":
            he = De.Colors.Maps.Zip;
            break;
          case "county":
            he = De.Colors.Maps.County, Ne = 0.4;
            break;
        }
        return {
          strokeColor: he,
          strokeWeight: Me,
          strokeOpacity: 0.8,
          fillColor: he,
          fillOpacity: Ne
        };
      }), s && s(!0);
    }
    function we(ge) {
      if (ge.feature.getProperty("type") == "clusterBound")
        return;
      const he = new google.maps.LatLngBounds();
      t.data.forEach((Me) => {
        var Ne;
        (Ne = Me.getGeometry()) == null || Ne.forEachLatLng(($e) => {
          he.extend($e);
        });
      }), he.isEmpty() == !1 && t.fitBounds(he, 1);
    }
    const Ie = /* @__PURE__ */ new Date(), be = new Date(Ie);
    be.setMonth(Ie.getMonth() + 1);
    const Oe = new Date(Ie);
    return Oe.setFullYear(Ie.getFullYear() + 1), new Date(Ie).setMonth(Ie.getMonth() - 1), new Date(Ie).setFullYear(Ie.getFullYear() - 1), aP(() => {
      I.value.then(() => ie()).then(async () => await ye()).then(async () => await ae()), r ? r().then(async () => await fe()).then(() => {
        console.log("mapApiLoaded");
      }) : Se("Google-Maps plugin not provided");
    }), (ge, he) => {
      var Ne, $e, mt, yt, Ct, gt, Ge, Ee, Ce, xe, Pe, it, lt, dt, vt, It, Dt;
      const Me = pe("GMapMap");
      return p(), h(A, null, [
        he[31] || (he[31] = a("h2", { class: "fw-bold fs-3 mb-3" }, "Portfolio Finder Search Area", -1)),
        a("div", Cde, [
          a("div", Sde, [
            a("div", Pde, [
              a("div", kde, [
                he[16] || (he[16] = a("p", null, "Your monthly Portfolio Finder subscription allows you to change your search area as often as every 30 days. Please select your search area below.", -1)),
                a("div", Ede, [
                  he[7] || (he[7] = y(" Your subscription allows you to choose up to ")),
                  ((Ne = l.value) == null ? void 0 : Ne.states) > 0 && (($e = l.value) == null ? void 0 : $e.counties) > 0 ? (p(), h(A, { key: 0 }, [
                    a("b", null, g((mt = l.value) == null ? void 0 : mt.states), 1),
                    he[3] || (he[3] = y(" states, and ")),
                    a("b", null, g((yt = l.value) == null ? void 0 : yt.counties), 1),
                    he[4] || (he[4] = y(" counties "))
                  ], 64)) : ((Ct = l.value) == null ? void 0 : Ct.states) > 0 ? (p(), h(A, { key: 1 }, [
                    a("b", null, g((gt = l.value) == null ? void 0 : gt.states), 1),
                    he[5] || (he[5] = y(" states "))
                  ], 64)) : (p(), h(A, { key: 2 }, [
                    a("b", null, g((Ge = l.value) == null ? void 0 : Ge.counties), 1),
                    he[6] || (he[6] = y(" counties. "))
                  ], 64))
                ]),
                a("div", Ide, [
                  he[9] || (he[9] = a("label", { class: "form-label" }, "Select State", -1)),
                  V(a("select", {
                    class: "form-select",
                    "onUpdate:modelValue": he[0] || (he[0] = (ht) => f.value = ht)
                  }, [
                    he[8] || (he[8] = a("option", { value: void 0 }, "Choose state...", -1)),
                    (p(!0), h(A, null, D(d.value, (ht) => (p(), h("option", {
                      key: ht.abv,
                      value: ht.abv
                    }, g(ht.name), 9, Tde))), 128))
                  ], 512), [
                    [We, f.value]
                  ])
                ]),
                a("div", Ode, [
                  a("label", Rde, [
                    ((Ee = l.value) == null ? void 0 : Ee.states) > 0 && ((Ce = l.value) == null ? void 0 : Ce.counties) > 0 ? (p(), h(A, { key: 0 }, [
                      y(" Choose your Counties or Entire State ")
                    ], 64)) : ((xe = l.value) == null ? void 0 : xe.states) > 0 ? (p(), h(A, { key: 1 }, [
                      y(" Choose your Entire State ")
                    ], 64)) : (p(), h(A, { key: 2 }, [
                      y(" Choose your Counties ")
                    ], 64))
                  ]),
                  N(st(lP), {
                    modelValue: u.value,
                    "onUpdate:modelValue": he[1] || (he[1] = (ht) => u.value = ht),
                    options: c.value,
                    optionLabel: "county",
                    listStyle: "height:250px",
                    emptyMessage: "Choose a state to show counties for.",
                    multiple: "",
                    filter: "",
                    dataKey: "key",
                    class: "mb-4"
                  }, {
                    option: ve((ht) => [
                      ht.option.county == "*" ? (p(), h(A, { key: 0 }, [
                        y(" Entire State of " + g(ue(ht.option.state)), 1)
                      ], 64)) : (p(), h(A, { key: 1 }, [
                        y(g(ht.option.county) + ", " + g(ht.option.state), 1)
                      ], 64))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "options"])
                ]),
                a("div", null, [
                  (C.value.length > 0 || O.value.length > 0) && !H.value ? (p(), h("div", Lde, [
                    he[10] || (he[10] = a("i", { class: "fa-light fa-triangle-exclamation me-2" }, null, -1)),
                    y("You are not able to change your state selection until " + g(st(cs)(j.value)), 1)
                  ])) : P("", !0),
                  ((Pe = l.value) == null ? void 0 : Pe.states) < E.value ? (p(), h("div", Bde, [
                    he[11] || (he[11] = a("i", { class: "fa-light fa-triangle-exclamation me-2" }, null, -1)),
                    y("Too many full states chosen. Please only choose up to " + g(st(Ve)((it = l.value) == null ? void 0 : it.states)) + " full states. ", 1)
                  ])) : P("", !0),
                  (R.value.length > 0 || F.value.length > 0) && !re.value ? (p(), h("div", Mde, [
                    he[12] || (he[12] = a("i", { class: "fa-light fa-triangle-exclamation me-2" }, null, -1)),
                    y("You are not able to change your county selection until " + g(st(cs)(te.value)), 1)
                  ])) : P("", !0),
                  ((lt = l.value) == null ? void 0 : lt.counties) < L.value ? (p(), h("div", xde, [
                    he[13] || (he[13] = a("i", { class: "fa-light fa-triangle-exclamation me-2" }, null, -1)),
                    y("Too many counties chosen. Please only choose up to " + g(st(Ve)((dt = l.value) == null ? void 0 : dt.counties)) + " counties. ", 1)
                  ])) : P("", !0)
                ]),
                a("div", null, [
                  a("label", Fde, [
                    ((vt = l.value) == null ? void 0 : vt.states) > 0 && ((It = l.value) == null ? void 0 : It.counties) > 0 ? (p(), h(A, { key: 0 }, [
                      y(" Selected Counties and/or States ")
                    ], 64)) : ((Dt = l.value) == null ? void 0 : Dt.states) > 0 ? (p(), h(A, { key: 1 }, [
                      y(" Selected States ")
                    ], 64)) : (p(), h(A, { key: 2 }, [
                      y(" Selected Counties ")
                    ], 64))
                  ]),
                  a("div", Vde, [
                    a("ul", Dde, [
                      (p(!0), h(A, null, D(T.value, (ht) => (p(), h("li", Nde, [
                        a("span", null, [
                          ht.county == "*" ? (p(), h(A, { key: 0 }, [
                            y(" Entire State of " + g(ue(ht.state)), 1)
                          ], 64)) : (p(), h(A, { key: 1 }, [
                            y(g(ht.county) + ", " + g(ht.state), 1)
                          ], 64))
                        ]),
                        a("button", {
                          class: "btn btn-link text-dark",
                          onClick: (_t) => ke(ht)
                        }, he[14] || (he[14] = [
                          a("i", {
                            class: "fa-light fa-xmark",
                            "aria-hidden": "true"
                          }, null, -1)
                        ]), 8, jde)
                      ]))), 256)),
                      u.value.length == 0 ? (p(), h("li", Hde, he[15] || (he[15] = [
                        a("span", null, "No county selected", -1)
                      ]))) : P("", !0)
                    ])
                  ])
                ])
              ]),
              a("div", Ude, [
                a("button", {
                  type: "button",
                  class: "btn btn-outline-eclipse",
                  onClick: he[2] || (he[2] = (ht) => ke())
                }, "Clear Selections"),
                a("button", {
                  type: "button",
                  class: "btn btn-success",
                  "data-bs-toggle": "modal",
                  "data-bs-target": "#dialogSearchAreaConfirmation",
                  disabled: !le.value
                }, "Save", 8, zde)
              ])
            ]),
            a("div", Wde, [
              N(Me, {
                ref_key: "gMap",
                ref: o,
                class: "h-100 w-100",
                "map-id": "2ddbbe0dd6bcf8f9",
                center: b.value,
                options: v.value
              }, null, 8, ["center", "options"])
            ])
          ])
        ]),
        a("div", {
          class: "modal fade",
          ref_key: "dialogSearchAreaConfirmation",
          ref: i,
          id: "dialogSearchAreaConfirmation",
          tabindex: "-1",
          "aria-labelledby": "dialogSearchAreaConfirmationLabel",
          "aria-hidden": "true"
        }, [
          a("div", Gde, [
            a("div", Yde, [
              a("div", Xde, [
                he[27] || (he[27] = a("button", {
                  type: "button",
                  class: "btn-close position-absolute top-10 end-10",
                  "data-bs-dismiss": "modal",
                  "aria-label": "Close"
                }, null, -1)),
                he[28] || (he[28] = a("i", { class: "fa-duotone fa-solid fa-map-location-dot mb-3 fa-4x" }, null, -1)),
                he[29] || (he[29] = a("p", { class: "fw-bold mb-5" }, "Confirm Search Area Selection", -1)),
                a("p", qde, [
                  he[25] || (he[25] = y(" You have selected ")),
                  u.value.length <= 3 ? (p(!0), h(A, { key: 0 }, D(u.value, (ht) => (p(), h("b", null, [
                    ht.county == "*" ? (p(), h(A, { key: 0 }, [
                      y(" Entire State of " + g(ue(ht.state)), 1)
                    ], 64)) : (p(), h(A, { key: 1 }, [
                      y(g(ht.county) + ", " + g(ht.state), 1)
                    ], 64))
                  ]))), 256)) : L.value > 0 && E.value > 0 ? (p(), h(A, { key: 1 }, [
                    a("b", null, g(st(Ve)(L.value)), 1),
                    he[17] || (he[17] = y(" counties and ")),
                    a("b", null, g(st(Ve)(E.value)), 1),
                    he[18] || (he[18] = y(" full states "))
                  ], 64)) : L.value > 0 ? (p(), h(A, { key: 2 }, [
                    a("b", null, g(st(Ve)(L.value)), 1),
                    he[19] || (he[19] = y(" counties "))
                  ], 64)) : E.value > 0 ? (p(), h(A, { key: 3 }, [
                    a("b", null, g(st(Ve)(E.value)), 1),
                    he[20] || (he[20] = y(" full states "))
                  ], 64)) : P("", !0),
                  he[26] || (he[26] = y(" for your search area. ")),
                  (R.value.length > 0 || F.value.length > 0) && (C.value.length > 0 || O.value.length > 0) ? (p(), h(A, { key: 4 }, [
                    he[21] || (he[21] = y(" You can update your counties selection on or after ")),
                    a("b", null, g(st(cs)(st(be))), 1),
                    he[22] || (he[22] = y(" and your states selection on or after ")),
                    a("b", null, g(st(cs)(st(Oe))), 1)
                  ], 64)) : R.value.length > 0 || F.value.length > 0 ? (p(), h(A, { key: 5 }, [
                    he[23] || (he[23] = y(" You can update your counties selection on or after ")),
                    a("b", null, g(st(cs)(st(be))), 1)
                  ], 64)) : C.value.length > 0 || O.value.length > 0 ? (p(), h(A, { key: 6 }, [
                    he[24] || (he[24] = y(" You can update your states selection on or after ")),
                    a("b", null, g(st(cs)(st(Oe))), 1)
                  ], 64)) : P("", !0)
                ])
              ]),
              a("div", { class: "modal-footer pt-0 border-0 justify-content-between" }, [
                he[30] || (he[30] = a("button", {
                  type: "button",
                  class: "btn btn-secondary",
                  "data-bs-dismiss": "modal"
                }, "Cancel", -1)),
                a("button", {
                  type: "button",
                  class: "btn btn-success",
                  onClick: oe
                }, "Confirm")
              ])
            ])
          ])
        ], 512)
      ], 64);
    };
  }
}), Kde = me({
  name: "AgentRoster",
  props: {},
  directives: {
    Tooltip: Wo
  },
  components: {
    DataTable: yn,
    Column: bn
  },
  data() {
    return {
      errorMessage: void 0,
      loading: !0,
      loadingAccounts: !0,
      newAgentId: void 0
    };
  },
  computed: {
    hasMissingContactInfo() {
      return this.accountStore.agentRoster.some((e) => !e.hasContactInfo);
    },
    ...at(ct),
    ...q(ct, ["agentRoster", "agentRosterTotal", "agentRosterPage", "agentRosterPageSize", "prospectiveAgentRoster", "prospectiveAgentRosterTotal"])
  },
  methods: {
    number: Ve,
    async onPage(e) {
      this.accountStore.agentRosterPage = e.page + 1, await this.loadAgents();
    },
    async onSort(e) {
      console.log(`${this.$options.name}.onSort`, e);
    },
    async loadAgents() {
      try {
        this.loading = !0, await this.accountStore.fetchAgentRoster();
      } catch (e) {
        this.errorMessage = e.message;
      }
      this.loading = !1;
    },
    async loadAccounts() {
      try {
        this.loadingAccounts = !0, await this.accountStore.fetchProspectiveAgentRoster();
      } catch (e) {
        this.errorMessage = e.message;
      }
      this.loadingAccounts = !1;
    },
    async addAgent() {
      try {
        this.loading = !0, await this.accountStore.addAgentToRoster(this.newAgentId);
        const e = this.accountStore.prospectiveAgentRoster.find((t) => t.id == this.newAgentId);
        e && (this.accountStore.agentRoster.push(e), this.accountStore.agentRosterTotal += 1);
      } catch (e) {
        this.errorMessage = e.message;
      } finally {
        this.loading = !1;
      }
    },
    async removeAgent(e) {
      try {
        this.loading = !0, await this.accountStore.removeAgentFromRoster(e);
        const t = this.accountStore.agentRoster.find((s) => s.id == e);
        t && this.accountStore.prospectiveAgentRoster.push(t);
      } catch (t) {
        this.errorMessage = t.message;
      } finally {
        this.loading = !1;
      }
    }
  },
  created() {
  },
  async mounted() {
    this.loadAgents(), this.loadAccounts();
  }
}), Zde = { class: "fw-bold fs-3 mb-3" }, Jde = { class: "row" }, $de = { class: "col" }, _de = {
  key: 0,
  class: "alert alert-danger mb-3",
  role: "alert"
}, ece = { class: "card shadow" }, tce = {
  key: 0,
  class: "badge text-bg-warning"
}, sce = ["onClick", "disabled"], ace = { class: "row" }, nce = { class: "col" }, rce = ["disabled"], oce = {
  key: 0,
  value: void 0,
  disabled: "",
  hidden: ""
}, ice = {
  key: 1,
  value: void 0,
  disabled: "",
  hidden: ""
}, lce = ["value"], dce = { class: "col" }, cce = {
  key: 0,
  class: "alert alert-warning mt-3 mb-0"
};
function uce(e, t, s, n, r, i) {
  const o = pe("Column"), l = pe("Button"), d = pe("data-table"), c = Za("tooltip");
  return p(), h(A, null, [
    a("h2", Zde, g(e.$t("t-agent-roster")), 1),
    a("div", Jde, [
      a("div", $de, [
        e.errorMessage ? (p(), h("div", _de, g(e.errorMessage), 1)) : P("", !0),
        a("div", ece, [
          N(d, {
            value: e.agentRoster,
            lazy: !0,
            paginator: !0,
            rows: e.agentRosterPageSize,
            dataKey: "id",
            totalRecords: e.agentRosterTotal,
            loading: e.loading,
            paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport",
            stripedRows: "",
            rowsPerPageOptions: [10, 25, 50],
            currentPageReportTemplate: "Showing {first} to {last} of {totalRecords} entries",
            onPage: t[1] || (t[1] = (u) => e.onPage(u)),
            onSort: t[2] || (t[2] = (u) => e.onSort(u)),
            sortField: "created",
            sortOrder: -1
          }, {
            empty: ve(() => t[3] || (t[3] = [
              y(" No agents found. ")
            ])),
            loading: ve(() => t[4] || (t[4] = [
              a("div", { class: "bg-accentgreenblue rounded-pill px-3 py-1 text-white" }, [
                a("span", {
                  class: "spinner-border spinner-border-sm me-2",
                  role: "status",
                  "aria-hidden": "true"
                }),
                y("Retrieving list of agents. ")
              ], -1)
            ])),
            header: ve(() => {
              var u, m, f;
              return [
                a("div", ace, [
                  t[7] || (t[7] = a("div", { class: "col-12" }, [
                    a("p", { class: "card-title fw-bold fs-5" }, "Manage Roster")
                  ], -1)),
                  a("div", nce, [
                    V(a("select", {
                      "onUpdate:modelValue": t[0] || (t[0] = (v) => e.newAgentId = v),
                      class: "form-select",
                      disabled: ((u = e.prospectiveAgentRoster) == null ? void 0 : u.length) == 0
                    }, [
                      ((m = e.prospectiveAgentRoster) == null ? void 0 : m.length) == 0 ? (p(), h("option", oce, "No Available Agents To Add")) : (p(), h("option", ice, "Select an Agent")),
                      (p(!0), h(A, null, D(e.prospectiveAgentRoster, (v) => (p(), h("option", {
                        key: v.id,
                        value: v.id
                      }, g(v.name) + " (" + g(v.email) + ")", 9, lce))), 128))
                    ], 8, rce), [
                      [We, e.newAgentId]
                    ])
                  ]),
                  a("div", dce, [
                    N(l, {
                      type: "button",
                      class: "btn btn-accent-glass",
                      onClick: e.addAgent,
                      disabled: ((f = e.prospectiveAgentRoster) == null ? void 0 : f.length) == 0
                    }, {
                      default: ve(() => [
                        t[6] || (t[6] = a("i", { class: "fa-light fa-plus me-1" }, null, -1)),
                        y(g(e.$t("Add")), 1)
                      ]),
                      _: 1,
                      __: [6]
                    }, 8, ["onClick", "disabled"])
                  ])
                ]),
                e.hasMissingContactInfo ? (p(), h("div", cce, t[8] || (t[8] = [
                  a("i", { class: "fa-duotone fa-solid fa-triangle-exclamation me-2" }, null, -1),
                  y("Agents with no contact info will "),
                  a("b", null, "not", -1),
                  y(" be displayed on your site until they have provided their contact information. Please request that they update their contact information by logging into their account and updating it. ")
                ]))) : P("", !0)
              ];
            }),
            default: ve(() => [
              N(o, {
                field: "name",
                header: "Name"
              }),
              N(o, {
                field: "email",
                header: "Email"
              }, {
                body: ve((u) => [
                  y(g(u.data.email) + " ", 1),
                  u.data.hasContactInfo ? P("", !0) : (p(), h("span", tce, "No Contact Info"))
                ]),
                _: 1
              }),
              N(o, {
                headerStyle: "width: 9rem; text-align: center",
                bodyStyle: "text-align: center; overflow: visible; text-wrap: nowrap"
              }, {
                body: ve((u) => [
                  V((p(), h("button", {
                    type: "button",
                    onClick: (m) => e.removeAgent(u.data.id),
                    class: "btn btn-outline-danger btn-sm",
                    disabled: e.loading
                  }, t[5] || (t[5] = [
                    a("i", { class: "fa-light fa-trash-can" }, null, -1)
                  ]), 8, sce)), [
                    [
                      c,
                      "Remove",
                      void 0,
                      { top: !0 }
                    ]
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["value", "rows", "totalRecords", "loading"])
        ])
      ])
    ])
  ], 64);
}
const rls = /* @__PURE__ */ Ae(Kde, [["render", uce]]), pce = me({
  name: "DefaultContactInfo",
  data() {
    return {
      busy: !0
    };
  },
  computed: {
    accounts() {
      return this.subAccounts.filter((e) => e.status != uP.Pending);
    },
    ...at(ct),
    ...q(Te, ["access", "aclLoaded"]),
    ...q(ct, ["subAccounts", "userInfo"])
  },
  methods: {
    async loadLinkedAccounts() {
      try {
        this.busy = !0, await this.accountStore.fetchSubAccounts();
      } catch (e) {
        Se(e);
      }
      this.busy = !1;
    },
    async saveUserSettings(e) {
      try {
        this.busy = !0, await this.accountStore.updateUserSettings(), wt("User settings saved");
      } catch (t) {
        (!Zt.isModelStateException(t) || !t.showFormErrors(e.target)) && Se(t);
      }
      this.busy = !1;
    }
  },
  mounted() {
    this.aclLoaded.then(this.loadLinkedAccounts), this.accountStore.fetchUserSettings();
  }
}), hce = { class: "row mb-3" }, mce = { class: "col-lg-7" }, fce = { class: "card shadow mb-3" }, gce = { class: "card-body pt-0 pt-lg-3" }, vce = { class: "row" }, yce = { class: "col-sm-8" }, bce = ["disabled"], Ace = ["value"], wce = { class: "card-footer border-0 d-flex justify-content-end bg-white" }, Cce = ["disabled"];
function Sce(e, t, s, n, r, i) {
  return p(), h("div", hce, [
    t[5] || (t[5] = a("div", { class: "col-12" }, [
      a("h2", { class: "fw-bold fs-3" }, "Default Contact Info"),
      a("p", null, "Define the agent in your office who's contact information should be displayed with listings by default. When visitors come to your website without first selecting an agent, this info will appear.")
    ], -1)),
    a("div", mce, [
      a("div", fce, [
        t[4] || (t[4] = a("div", { class: "card-header bg-transparent border-0 fw-bold fs-5" }, "Default Agent", -1)),
        a("div", gce, [
          a("div", vce, [
            t[3] || (t[3] = a("label", {
              for: "defaultContactUserId",
              class: "col-sm-4 col-form-label"
            }, "User Account:", -1)),
            a("div", yce, [
              e.userInfo ? V((p(), h("select", {
                key: 0,
                class: "form-select",
                id: "defaultContactUserId",
                "onUpdate:modelValue": t[0] || (t[0] = (o) => e.userInfo.defaultContactUserId = o),
                disabled: e.busy
              }, [
                t[2] || (t[2] = a("option", { value: 0 }, "Account Owner", -1)),
                (p(!0), h(A, null, D(e.accounts, (o) => (p(), h("option", {
                  key: o.id,
                  value: o.id
                }, g(o.firstName) + " " + g(o.lastName), 9, Ace))), 128))
              ], 8, bce)), [
                [We, e.userInfo.defaultContactUserId]
              ]) : P("", !0)
            ])
          ])
        ]),
        a("div", wce, [
          a("button", {
            type: "button",
            class: "btn btn-lava",
            onClick: t[1] || (t[1] = (...o) => e.saveUserSettings && e.saveUserSettings(...o)),
            disabled: e.busy
          }, "Save", 8, Cce)
        ])
      ])
    ])
  ]);
}
const ols = /* @__PURE__ */ Ae(pce, [["render", Sce]]), Pce = me({
  name: "DefaultSearchArea",
  props: {
    disableManageCompany: Boolean
  },
  data() {
    return {
      isBusy: !0,
      companySavedSearches: [],
      companySavedSearchId: void 0,
      companySavedSearchUserId: void 0,
      defaultSavedUseCompany: !1,
      defaultSavedSearches: [],
      defaultSavedSearchId: void 0
    };
  },
  computed: {
    canSaveChanges() {
      return !this.isBusy;
    },
    acceptedSubAccounts() {
      return this.subAccounts.filter((e) => e.status == uP.Accepted);
    },
    selectedCompanySavedSearch() {
      return this.companySavedSearches.find((e) => e.id == this.companySavedSearchId);
    },
    ...at(ct, Te),
    ...q(ct, ["subAccounts", "userInfo"]),
    ...q(Te, ["access", "aclLoaded"])
  },
  methods: {
    async loadLinkedAccounts() {
      try {
        await this.accountStore.fetchSubAccounts();
      } catch (e) {
        Se(e);
      }
    },
    async loadCompanySavedSearches(e) {
      if (!e) {
        this.companySavedSearches.length = 0;
        return;
      }
      try {
        const t = await W.api.searchMls.savedSearches(e, 1, 100);
        if (t.data.status != de.Success)
          throw new Le(t);
        this.companySavedSearches.length = 0, this.companySavedSearches.push(...t.data.page);
      } catch (t) {
        Se(t);
      }
    },
    async loadDefaultSavedSearches() {
      try {
        const e = await W.api.searchMls.savedSearches(void 0, 1, 100);
        if (e.data.status != de.Success)
          throw new Le(e);
        this.defaultSavedSearches.length = 0, this.defaultSavedSearches.push(...e.data.page);
      } catch (e) {
        Se(e);
      }
    },
    async loadUserSettings() {
      try {
        const e = await W.api.user.getSettings();
        if (e.data.status != de.Success)
          throw new Le(e);
        this.companySavedSearchId = e.data.settings.companySavedSearchId, this.defaultSavedSearchId = e.data.settings.defaultSavedSearchId, this.companySavedSearchUserId = e.data.settings.companySavedSearchUserId, this.defaultSavedUseCompany = e.data.settings.defaultSavedUseCompany;
      } catch (e) {
        Se(e);
      }
    },
    async saveChanges() {
      this.isBusy = !0;
      try {
        const e = {
          companySavedSearchId: this.companySavedSearchId,
          defaultSavedSearchId: this.defaultSavedSearchId,
          companySavedSearchUserId: this.companySavedSearchUserId,
          defaultSavedUseCompany: this.defaultSavedUseCompany
        }, t = await W.api.user.updateSettings(e);
        if (t.data.status != de.Success)
          throw new Le(t);
        wt("Default Search Area saved successfully");
      } catch (e) {
        Se(e);
      }
      this.isBusy = !1;
    }
  },
  watch: {
    companySavedSearchUserId(e, t) {
      this.isBusy = !0, this.loadCompanySavedSearches(e).then(() => {
        this.isBusy = !1;
      });
    }
  },
  mounted() {
    this.isBusy = !0, this.aclLoaded.then(() => this.loadLinkedAccounts()).then(() => this.loadDefaultSavedSearches()).then(() => this.loadUserSettings()).finally(() => {
      this.isBusy = !1;
    });
  }
}), kce = { class: "row g-3" }, Ece = {
  key: 0,
  class: "col-md-6"
}, Ice = { class: "card shadow-sm h-100" }, Tce = { class: "card-body" }, Oce = { class: "row g-3" }, Rce = { class: "col-6 col-sm-8" }, Lce = ["disabled"], Bce = ["value"], Mce = { class: "col-6 col-sm-8" }, xce = ["disabled"], Fce = ["value"], Vce = { class: "col-md-6" }, Dce = { class: "card shadow-sm" }, Nce = { class: "card-body" }, jce = { class: "row g-3" }, Hce = { class: "col-2 d-flex align-items-center" }, Uce = { class: "form-check form-switch form-switch-lg form-check-reverse text-start" }, zce = { class: "col-6 col-sm-8" }, Wce = ["disabled"], Gce = ["value"], Yce = { key: 1 }, Xce = { class: "col-12 text-end" }, qce = ["disabled"], Qce = {
  key: 0,
  class: "fa-duotone fa-solid fa-spinner fa-spin me-2"
}, Kce = {
  key: 1,
  class: "fa-light fa-save me-2"
};
function Zce(e, t, s, n, r, i) {
  var o;
  return p(), h(A, null, [
    t[17] || (t[17] = a("h2", { class: "fw-bold fs-3" }, "Default Search Area", -1)),
    t[18] || (t[18] = a("p", null, "Define the area that you would like the MLS search to show by default. This is particulary helpful if you focus on an area and want to highlight houses from that area instead of the entire coverage of your MLS.", -1)),
    a("div", kce, [
      e.disableManageCompany ? P("", !0) : (p(), h("div", Ece, [
        a("div", Ice, [
          a("div", Tce, [
            a("p", {
              class: "card-title fw-bold fs-6",
              onClick: t[0] || (t[0] = (...l) => e.loadUserSettings && e.loadUserSettings(...l))
            }, "Company search area"),
            t[10] || (t[10] = a("p", null, "When someone visits our site without first choosing an agent, this is the area I want to show by default:", -1)),
            a("div", Oce, [
              t[8] || (t[8] = a("label", {
                for: "inputUserAccount2",
                class: "col-6 col-sm-4 col-form-label"
              }, "User Account", -1)),
              a("div", Rce, [
                V(a("select", {
                  class: "form-select",
                  id: "inputUserAccount2",
                  "onUpdate:modelValue": t[1] || (t[1] = (l) => e.companySavedSearchUserId = l),
                  disabled: e.isBusy
                }, [
                  t[6] || (t[6] = a("option", { value: void 0 }, "None", -1)),
                  (p(!0), h(A, null, D(e.acceptedSubAccounts, (l) => {
                    var d;
                    return p(), h("option", {
                      value: l.id
                    }, [
                      y(g(l.firstName) + " " + g(l.lastName), 1),
                      l.id == ((d = e.userInfo) == null ? void 0 : d.id) ? (p(), h(A, { key: 0 }, [
                        y(" (Me)")
                      ], 64)) : P("", !0)
                    ], 8, Bce);
                  }), 256))
                ], 8, Lce), [
                  [We, e.companySavedSearchUserId]
                ])
              ]),
              t[9] || (t[9] = a("label", {
                for: "inputSavedSearch2",
                class: "col-6 col-sm-4 col-form-label"
              }, "Saved Search", -1)),
              a("div", Mce, [
                V(a("select", {
                  class: "form-select",
                  id: "inputSavedSearch2",
                  "onUpdate:modelValue": t[2] || (t[2] = (l) => e.companySavedSearchId = l),
                  disabled: e.isBusy || e.companySavedSearchUserId == null
                }, [
                  t[7] || (t[7] = a("option", { value: void 0 }, "None", -1)),
                  (p(!0), h(A, null, D(e.companySavedSearches, (l) => (p(), h("option", {
                    value: l.id,
                    key: l.id
                  }, g(l.name), 9, Fce))), 128))
                ], 8, xce), [
                  [We, e.companySavedSearchId]
                ])
              ])
            ])
          ])
        ])
      ])),
      a("div", Vce, [
        a("div", Dce, [
          a("div", Nce, [
            t[14] || (t[14] = a("p", { class: "card-title fw-bold fs-6" }, "My search Area", -1)),
            t[15] || (t[15] = a("p", null, "When someone chooses me as their agent, this is the area I want to show by default:", -1)),
            a("div", jce, [
              t[12] || (t[12] = a("label", {
                class: "col-10 col-form-label",
                for: "switchSetArea"
              }, "Set my area to the same as the company default", -1)),
              a("div", Hce, [
                a("div", Uce, [
                  V(a("input", {
                    class: "form-check-input",
                    type: "checkbox",
                    role: "switch",
                    id: "switchSetArea",
                    "onUpdate:modelValue": t[3] || (t[3] = (l) => e.defaultSavedUseCompany = l)
                  }, null, 512), [
                    [Ue, e.defaultSavedUseCompany]
                  ])
                ])
              ]),
              t[13] || (t[13] = a("label", {
                for: "inputSavedSearch3",
                class: "col-6 col-sm-4 col-form-label"
              }, "Saved Search", -1)),
              a("div", zce, [
                e.defaultSavedUseCompany ? (p(), h("b", Yce, g((o = e.selectedCompanySavedSearch) == null ? void 0 : o.name), 1)) : V((p(), h("select", {
                  key: 0,
                  class: "form-select",
                  id: "inputSavedSearch3",
                  "onUpdate:modelValue": t[4] || (t[4] = (l) => e.defaultSavedSearchId = l),
                  disabled: e.isBusy
                }, [
                  t[11] || (t[11] = a("option", { value: void 0 }, "None", -1)),
                  (p(!0), h(A, null, D(e.defaultSavedSearches, (l) => (p(), h("option", {
                    value: l.id
                  }, g(l.name), 9, Gce))), 256))
                ], 8, Wce)), [
                  [We, e.defaultSavedSearchId]
                ])
              ])
            ])
          ])
        ])
      ]),
      a("div", Xce, [
        a("button", {
          type: "button",
          onClick: t[5] || (t[5] = (...l) => e.saveChanges && e.saveChanges(...l)),
          id: "btnSaveDefaults",
          class: "btn btn-lava",
          disabled: !e.canSaveChanges
        }, [
          e.isBusy ? (p(), h("i", Qce)) : (p(), h("i", Kce)),
          t[16] || (t[16] = y(" Save "))
        ], 8, qce)
      ])
    ])
  ], 64);
}
const ils = /* @__PURE__ */ Ae(Pce, [["render", Zce]]), Jce = me({
  name: "ZipCodesSettings",
  props: {},
  components: {},
  data() {
    return {
      newZipCode: void 0,
      zipCodes: [],
      zipCodesToAdd: [],
      zipCodesToRemove: [],
      busy: !1
    };
  },
  computed: {
    ...at(Te),
    ...q(Te, ["access", "aclLoaded"])
  },
  methods: {
    async getZipCodes() {
      try {
        this.busy = !0;
        const e = await W.api.account.getFeaturedZipCodes();
        if (e.data.status != de.Success)
          throw new Error(e.data.message);
        this.zipCodes.push(...e.data.zipCodes);
      } catch (e) {
        Se("Getting Featured Zip Codes Error " + e.message);
      }
      this.busy = !1;
    },
    addZipCode() {
      !this.zipCodes.includes(this.newZipCode) && /(^\d{5}$)|(^\d{5}-\d{4}$)/.test(this.newZipCode) && (this.zipCodes.push(this.newZipCode), this.zipCodesToAdd.push(this.newZipCode), this.newZipCode = "");
    },
    removeZipCode(e) {
      !this.zipCodesToRemove.includes(e) && this.zipCodes.includes(e) && (this.zipCodes.splice(this.zipCodes.indexOf(e), 1), this.zipCodesToAdd.splice(this.zipCodesToAdd.indexOf(e), 1), this.zipCodesToRemove.push(e));
    },
    async saveSettings() {
      try {
        this.busy = !0;
        for (let e = 0; e < this.zipCodesToAdd.length; e++) {
          const t = await W.api.account.addFeaturedZipCode(this.zipCodesToAdd[e]);
          if (t.data.status != de.Success)
            throw new Error(t.data.message);
        }
        for (let e = 0; e < this.zipCodesToRemove.length; e++) {
          const t = await W.api.account.removeFeaturedZipCode(this.zipCodesToRemove[e]);
          if (t.data.status != de.Success)
            throw new Error(t.data.message);
        }
        wt("Featured Zip Codes Successfully Saved");
      } catch (e) {
        Se("Saving Featured Zip Codes Error " + e.message);
      }
      this.busy = !1;
    }
  },
  created() {
  },
  mounted() {
    this.aclLoaded.then(() => {
      this.getZipCodes();
    });
  }
}), $ce = { class: "row g-3" }, _ce = { class: "col-lg-7" }, eue = { class: "card shadow" }, tue = { class: "card-body" }, sue = { class: "input-group mb-3" }, aue = ["disabled"], nue = { class: "p-3 rounded bg-light" }, rue = { class: "list-inline mt-3" }, oue = { class: "list-inline-item mb-2" }, iue = ["onClick"], lue = { class: "d-flex justify-content-end mt-5" }, due = ["disabled"];
function cue(e, t, s, n, r, i) {
  return p(), h("div", $ce, [
    t[7] || (t[7] = a("div", { class: "col-12" }, [
      a("h2", { class: "fw-bold fs-3 mb-0" }, "Featured Zip Codes")
    ], -1)),
    a("div", _ce, [
      a("div", eue, [
        a("div", tue, [
          t[6] || (t[6] = a("p", null, "Input the zip codes you want to feature on your website to visitors. When they click the zip code, a search with matching results will launch.", -1)),
          a("div", sue, [
            V(a("input", {
              "onUpdate:modelValue": t[0] || (t[0] = (o) => e.newZipCode = o),
              type: "text",
              class: "form-control",
              placeholder: "Add Zip Code"
            }, null, 512), [
              [_e, e.newZipCode]
            ]),
            a("button", {
              type: "button",
              class: "btn btn-eclipse no-anim",
              onClick: t[1] || (t[1] = (...o) => e.addZipCode && e.addZipCode(...o)),
              disabled: e.busy
            }, t[3] || (t[3] = [
              a("i", { class: "fa-duotone fa-solid fa-plus me-2" }, null, -1),
              y("Add")
            ]), 8, aue)
          ]),
          a("div", nue, [
            t[5] || (t[5] = a("p", { class: "fw-bold mb-0" }, "Featured Zip Codes:", -1)),
            a("ul", rue, [
              (p(!0), h(A, null, D(e.zipCodes, (o) => (p(), h("li", oue, [
                a("button", {
                  type: "button",
                  class: "btn btn-secondary rounded-4 btn-sm",
                  onClick: (l) => e.removeZipCode(o)
                }, [
                  y(g(o) + " ", 1),
                  t[4] || (t[4] = a("i", { class: "fa-duotone fa-solid fa-times ms-2" }, null, -1))
                ], 8, iue)
              ]))), 256))
            ])
          ]),
          a("div", lue, [
            a("button", {
              onClick: t[2] || (t[2] = (...o) => e.saveSettings && e.saveSettings(...o)),
              type: "button",
              class: "btn btn-lava",
              disabled: e.busy
            }, "Save Settings", 8, due)
          ])
        ])
      ])
    ])
  ]);
}
const lls = /* @__PURE__ */ Ae(Jce, [["render", cue]]), uue = me({
  name: "LeadAssignment",
  props: {},
  data() {
    return {
      busy: !0,
      loadingAccounts: !0,
      linked: []
    };
  },
  computed: {
    ...at(Te, ct, Mn),
    ...q(Te, ["access", "aclLoaded"]),
    ...q(ct, ["userInfo"])
  },
  methods: {
    async loadLeadAssignments() {
      try {
        this.busy = !0, this.loadingAccounts = !0, this.linked.length = 0;
        const e = await W.api.accountIdx.getLeadAssignments();
        if (e.data.status != de.Success)
          throw new Error(e.data.message);
        e.data.accounts && this.linked.push(...e.data.accounts);
      } catch (e) {
        Se(e);
      }
      this.busy = !1, this.loadingAccounts = !1;
    },
    async updateLeadAssignments(e) {
      try {
        this.busy = !0;
        const t = {
          accounts: this.linked.map((n) => ({
            id: n.id,
            assignable: n.assignable
          }))
        }, s = await W.api.accountIdx.updateLeadAssignments(t);
        if (s.data.status != de.Success)
          throw new Error(s.data.message);
        wt("Saved Sucessfully");
      } catch (t) {
        (!Zt.isModelStateException(t) || !t.showFormErrors(e)) && Se(t);
      }
      this.busy = !1;
    }
  },
  mounted() {
    this.aclLoaded.then(() => this.accountStore.fetchUserSettings()).then(() => this.loadLeadAssignments()), document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach((e) => bootstrap.Tooltip.getOrCreateInstance(e));
  }
}), pue = { class: "row g-3" }, hue = {
  ref: "leadAssignmentContainer",
  class: "col-12",
  "data-summary": "true"
}, mue = { class: "card shadow" }, fue = {
  key: 0,
  class: "table-responsive"
}, gue = { class: "table" }, vue = { class: "text-center" }, yue = ["onUpdate:modelValue"], bue = {
  key: 1,
  class: "card-body"
}, Aue = { class: "col-12" }, wue = { class: "d-flex justify-content-end" }, Cue = ["disabled"];
function Sue(e, t, s, n, r, i) {
  return p(), h("div", pue, [
    t[3] || (t[3] = a("div", { class: "col-12" }, [
      a("h2", { class: "fw-bold fs-3 mb-0" }, "Lead Assignment")
    ], -1)),
    a("div", hue, [
      a("div", mue, [
        e.loadingAccounts ? (p(), h("div", bue, t[2] || (t[2] = [
          a("i", { class: "fa-duotone fa-solid fa-compass fa-spin me-2" }, null, -1),
          y("Loading lead assignments... ")
        ]))) : (p(), h("div", fue, [
          a("table", gue, [
            t[1] || (t[1] = a("thead", null, [
              a("tr", null, [
                a("th", null, "Name"),
                a("th", null, "Email"),
                a("th", { class: "text-center" }, "Assignable?")
              ])
            ], -1)),
            a("tbody", null, [
              (p(!0), h(A, null, D(e.linked, (o) => (p(), h("tr", {
                key: o.id
              }, [
                a("td", null, g(o.firstName) + " " + g(o.lastName), 1),
                a("td", null, g(o.email), 1),
                a("td", vue, [
                  V(a("input", {
                    class: "form-check-input",
                    type: "checkbox",
                    "onUpdate:modelValue": (l) => o.assignable = l,
                    id: "flexCheck",
                    "aria-label": "Assignable"
                  }, null, 8, yue), [
                    [Ue, o.assignable]
                  ])
                ])
              ]))), 128))
            ])
          ])
        ]))
      ])
    ], 512),
    a("div", Aue, [
      a("div", wue, [
        a("button", {
          type: "button",
          class: "btn btn-lava",
          onClick: t[0] || (t[0] = (o) => e.updateLeadAssignments(e.$refs.leadAssignmentContainer)),
          disabled: e.busy
        }, "Save changes", 8, Cue)
      ])
    ])
  ]);
}
const dls = /* @__PURE__ */ Ae(uue, [["render", Sue]]), Pue = {};
function kue(e, t) {
  return t[0] || (t[0] = Bt('<div class="row mb-3"><div class="col"><h2 class="fw-bold fs-3 mb-0">Featured Listings</h2></div></div><div class="row"><div class="col"><div class="card shadow mb-3"><div class="card-body border-bottom"><p>Configure default featured listings. All agents can select their own featured listings. However, only listings chosen by designated agents will be displayed as default featured listings to visitors who haven&#39;t selected a specific agent.</p><button type="button" class="btn btn-eclipse" data-bs-toggle="modal" data-bs-target="#selectAgents">Select Agents</button><table class="table"><tbody><tr><td> Morgan Cole </td><td> Steve Rowe </td><td> Erin Nave </td></tr></tbody></table></div></div></div></div><div class="modal fade" id="selectAgents" tabindex="-1" aria-labelledby="selectAgentsLabel" aria-hidden="true"><div class="modal-dialog modal-dialog-centered"><div class="modal-content bg-gradient-alphabet rounded"><div class="modal-header border-0 pb-0"><p class="modal-title fs-5 fw-bold" id="exampleModalLabel">Select Agents</p><button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button></div><div class="modal-body"> ... </div></div></div></div>', 3));
}
const cls = /* @__PURE__ */ Ae(Pue, [["render", kue]]), Eue = me({
  name: "NeighborhoodsSettings",
  props: {
    apiKey: {
      type: String,
      required: !1
    }
  },
  components: {},
  data() {
    return {};
  },
  computed: {
    ...at(Te),
    ...q(Te, ["access", "aclLoaded"])
  },
  methods: {
    number: Ve
  },
  created() {
  },
  mounted() {
    this.aclLoaded.then(() => {
    });
  }
});
function Iue(e, t, s, n, r, i) {
  return t[0] || (t[0] = Bt('<div class="row mb-3"><div class="col"><h2 class="fw-bold fs-3 mb-0">Featured Neighborhoods</h2></div></div><div class="row"><div class="col-lg-7"><div class="card shadow mb-3"><div class="card-body border-bottom"><p>Input the neighborhoods you want to feature on your website to visitors. When they click the neighborhood, a search with matching results will launch.</p><input type="text" class="form-control"></div><div class="card-body d-flex justify-content-end"><button type="button" class="btn btn-lava">Save Settings</button></div></div></div></div>', 2));
}
const uls = /* @__PURE__ */ Ae(Eue, [["render", Iue]]), Tue = me({
  name: "MlsAccess",
  props: {},
  directives: {
    Tooltip: Wo
  },
  components: {
    DataTable: yn,
    Column: bn
  },
  data() {
    return {
      loading: !0,
      editing: !1,
      selectedUserId: void 0,
      selectedMlsId: void 0,
      mlsAccessMatrix: [
        {
          name: "Loading..."
        }
      ],
      updateRequest: {},
      accountDelete: void 0,
      entitlementType: 1
    };
  },
  computed: {
    activeMls() {
      return this.mlsAccessMatrix.find((e) => e.id == this.selectedMlsId);
    },
    idxAccounts() {
      return this.subAccounts.filter((e) => e.idxDataAccess).sort((e, t) => `${e.firstName} ${e.lastName}`.localeCompare(`${t.firstName} ${t.lastName}`));
    },
    idxValidatedAccounts() {
      return this.subAccounts.filter((e) => e.idxDataAccess == !0 && this.mlsAccessMatrix.some((t) => {
        var s;
        return t.id == this.selectedMlsId && ((s = t.users) == null ? void 0 : s.some((n) => {
          var r;
          return n.userId == e.id && n.validated && ((r = n.mlsIdentifier) == null ? void 0 : r.length) > 1;
        }));
      }));
    },
    editingAccount() {
      return this.subAccounts.find((e) => e.id == this.selectedUserId);
    },
    editingMlsAccess() {
      var e, t;
      return (t = (e = this.activeMls) == null ? void 0 : e.users) == null ? void 0 : t.find((s) => s.userId == this.selectedUserId);
    },
    canAdd() {
      return this.idxAccounts.length > 0;
    },
    canSaveAccess() {
      return this.loading == !1 && this.selectedUserId > 0;
    },
    ...at(ct),
    ...q(Te, ["access", "aclLoaded"]),
    ...q(ct, ["subAccounts"])
  },
  methods: {
    number: Ve,
    closeDialog() {
      var e;
      this.editing = !1, (e = bootstrap.Modal.getOrCreateInstance(this.$refs.updateUserAccessDialog)) == null || e.hide();
    },
    async loadMlsAccess() {
      try {
        this.loading = !0;
        const e = await W.api.accountMLS.getAccessMatrix();
        if (e.data.status != de.Success)
          throw new Le(e);
        this.mlsAccessMatrix.length = 0, this.mlsAccessMatrix.push(...e.data.matrix), this.mlsAccessMatrix.sort((t, s) => t.name.localeCompare(s.name)), this.mlsAccessMatrix.length > 0 && this.mlsAccessMatrix.some((t) => t.id == this.selectedMlsId) == !1 && (this.selectedMlsId = this.mlsAccessMatrix[0].id);
      } catch (e) {
        Se(e);
      }
      this.loading = !1;
    },
    async loadSubAccounts() {
      try {
        await this.accountStore.fetchSubAccounts();
      } catch (e) {
        Se(e);
      }
    },
    showUpdateUserAccess(e) {
      var s, n, r, i;
      this.editing = !0, this.selectedUserId = e.id, this.updateRequest.userId = e.id;
      const t = (n = (s = this.activeMls) == null ? void 0 : s.users) == null ? void 0 : n.find((o) => o.userId == e.id);
      t ? (this.updateRequest.sponsorUserId = t.sponsorUserId, this.updateRequest.mlsIdentifier = t.mlsIdentifier) : ((r = this.activeMls).users ?? (r.users = []), this.activeMls.users.push({
        userId: e.id
      }), this.updateRequest.sponsorUserId = void 0, this.updateRequest.mlsIdentifier = void 0), this.entitlementType = `${this.updateRequest.mlsIdentifier}`.trim() == "" ? 2 : 1, Zt.clearModelStateErrors(this.$refs.updateUserAccessDialog), (i = bootstrap.Modal.getOrCreateInstance(this.$refs.updateUserAccessDialog)) == null || i.show();
    },
    async updateUserAccess() {
      if (this.canSaveAccess) {
        this.loading = !0;
        try {
          if (!this.activeMls)
            throw new Error("Please choose a MLS.");
          const e = await W.api.accountMLS.updateUserAccess(this.activeMls.id, this.updateRequest);
          if (e.data.status != de.Success)
            throw new Le(e);
          await this.loadMlsAccess(), this.closeDialog();
        } catch (e) {
          (!Zt.isModelStateException(e) || !e.showFormErrors(this.$refs.updateUserAccessDialog)) && Se(e);
          return;
        } finally {
          this.loading = !1;
        }
      }
    },
    showRemoveAccount(e) {
      console.debug("showRemoveAccount", e), Zt.clearModelStateErrors(this.$refs.dialogRemoveUserAccess), this.accountDelete = e, bootstrap.Modal.getOrCreateInstance(this.$refs.dialogRemoveUserAccess).show();
    },
    async removeUserAccess(e) {
      this.loading = !0;
      try {
        if (!this.activeMls)
          throw new Error("Please choose a MLS.");
        if (!e.id)
          throw new Error("Invalid user id, please contact support to remove user's access.");
        const t = await W.api.accountMLS.removeUserAccess(this.activeMls.id, e.id);
        if (t.data.status != de.Success)
          throw new Le(t);
        await this.loadMlsAccess();
      } catch (t) {
        Se(t);
      } finally {
        bootstrap.Modal.getOrCreateInstance(this.$refs.dialogRemoveUserAccess).hide(), this.loading = !1;
      }
    },
    isValidated(e) {
      return this.mlsAccessMatrix.some((t) => {
        var s;
        return t.id == this.selectedMlsId && ((s = t.users) == null ? void 0 : s.some((n) => n.userId == e.id && n.validated));
      });
    },
    userMlsAccess(e) {
      var t, s;
      return (s = (t = this.activeMls) == null ? void 0 : t.users) == null ? void 0 : s.find((n) => n.userId == e.id);
    }
  },
  mounted() {
    this.aclLoaded.then(() => this.loadSubAccounts()).then(() => this.loadMlsAccess());
  }
}), Oue = { class: "d-flex flex-column flex-md-row align-items-md-center justify-content-between mb-3 gap-2" }, Rue = { class: "fw-bold fs-4 mb-0 flex-shrink-0" }, Lue = { class: "d-flex gap-2 align-items-center ms-auto" }, Bue = {
  for: "mlsAccessMatrix",
  class: "form-label mb-0"
}, Mue = ["disabled"], xue = ["value"], Fue = { class: "row row-cols-1" }, Vue = { class: "col" }, Due = { class: "card shadow-sm overflow-hidden mb-3" }, Nue = { class: "bg-accentgreenblue rounded-pill px-3 py-1 text-white" }, jue = { class: "d-flex justify-content-end gap-2" }, Hue = ["onClick", "disabled"], Uue = ["onClick", "disabled"], zue = {
  ref: "updateUserAccessDialog",
  class: "modal fade",
  id: "updateUserAccessDialog",
  tabindex: "-1",
  "aria-labelledby": "dialogupdateUserAccessLabel",
  "aria-hidden": "true"
}, Wue = { class: "modal-dialog modal-dialog-centered" }, Gue = { class: "modal-content bg-gradient-alphabet rounded" }, Yue = { class: "modal-header border-0 pb-0" }, Xue = {
  class: "fw-bold fs-5 modal-title",
  id: "dialogupdateUserAccessLabel"
}, que = { class: "modal-body" }, Que = { class: "bg-white bg-opacity-50 rounded p-3 text-center mb-3" }, Kue = { class: "fw-bold fs-5" }, Zue = {
  class: "alert alert-warning d-none",
  "data-val-summary": ""
}, Jue = { class: "row mb-3" }, $ue = {
  for: "mls",
  class: "col-sm-4 col-form-label"
}, _ue = { class: "col-sm-8" }, epe = ["value"], tpe = { class: "row mb-3" }, spe = {
  for: "entitlementType",
  class: "col-sm-4 col-form-label"
}, ape = { class: "col-sm-8" }, npe = {
  key: 0,
  class: "row mb-3"
}, rpe = {
  for: "mlsIdentifier",
  class: "col-sm-4 col-form-label"
}, ope = { class: "col-sm-8" }, ipe = {
  key: 1,
  class: "row mb-3"
}, lpe = {
  for: "sponsorUserId",
  class: "col-sm-4 col-form-label"
}, dpe = { class: "col-sm-8" }, cpe = ["value"], upe = { class: "modal-footer border-0" }, ppe = ["disabled"], hpe = {
  key: 0,
  class: "fa-duotone fa-solid fa-spinner fa-spin me-2"
}, mpe = {
  ref: "dialogRemoveUserAccess",
  class: "modal fade",
  id: "dialogRemoveUserAccess",
  tabindex: "-1",
  "aria-labelledby": "dialogRemoveUserAccessLabel",
  "aria-hidden": "true"
}, fpe = { class: "modal-dialog modal-dialog-centered" }, gpe = { class: "modal-content bg-gradient-alphabet rounded" }, vpe = { class: "modal-body text-center px-5 pb-5 pt-4" }, ype = { class: "fs-5" }, bpe = { class: "d-flex gap-3 justify-content-center pt-3" }, Ape = ["disabled"], wpe = ["disabled"];
function Cpe(e, t, s, n, r, i) {
  var c, u, m, f, v, b, w;
  const o = pe("Column"), l = pe("data-table"), d = Za("tooltip");
  return p(), h(A, null, [
    a("div", Oue, [
      a("h2", Rue, g(e.$t("MLS Access")), 1),
      a("div", Lue, [
        a("label", Bue, g(e.$t("MLS")) + ":", 1),
        V(a("select", {
          id: "mlsAccessMatrix",
          class: "form-select",
          "onUpdate:modelValue": t[0] || (t[0] = (S) => e.selectedMlsId = S),
          disabled: e.loading
        }, [
          (p(!0), h(A, null, D(e.mlsAccessMatrix, (S) => (p(), h("option", {
            value: S.id
          }, g(S.name), 9, xue))), 256))
        ], 8, Mue), [
          [We, e.selectedMlsId]
        ])
      ])
    ]),
    a("div", Fue, [
      a("div", Vue, [
        a("div", Due, [
          N(l, {
            value: e.idxAccounts,
            loading: e.loading
          }, {
            empty: ve(() => [
              y(g(e.$t("No users granted IDX access.")), 1)
            ]),
            loading: ve(() => [
              a("div", Nue, [
                t[8] || (t[8] = a("span", {
                  class: "spinner-border spinner-border-sm me-2",
                  role: "status",
                  "aria-hidden": "true"
                }, null, -1)),
                y(g(e.$t("Retrieving list of users.")), 1)
              ])
            ]),
            default: ve(() => [
              N(o, {
                field: "name",
                header: "Name"
              }, {
                body: ve((S) => [
                  y(g(S.data.firstName) + " " + g(S.data.lastName), 1)
                ]),
                _: 1
              }),
              N(o, {
                field: "validated",
                header: "Validated"
              }, {
                body: ve((S) => [
                  e.isValidated(S.data) ? (p(), h(A, { key: 0 }, [
                    y(g(e.$t("Yes")), 1)
                  ], 64)) : (p(), h(A, { key: 1 }, [
                    y(g(e.$t("No")), 1)
                  ], 64))
                ]),
                _: 1
              }),
              N(o, { header: "MLS Data Sponsor" }, {
                body: ve((S) => {
                  var I;
                  return [
                    e.isValidated(S.data) == !1 ? (p(), h(A, { key: 0 }, [
                      y(g((I = e.userMlsAccess(S.data)) == null ? void 0 : I.sponsorName), 1)
                    ], 64)) : P("", !0)
                  ];
                }),
                _: 1
              }),
              N(o, { field: "actions" }, {
                body: ve((S) => {
                  var I;
                  return [
                    a("div", jue, [
                      (I = e.userMlsAccess(S.data)) != null && I.active ? V((p(), h("button", {
                        key: 0,
                        type: "button",
                        onClick: (T) => e.showRemoveAccount(S.data),
                        class: "btn btn-outline-danger btn-sm",
                        disabled: e.loading
                      }, t[9] || (t[9] = [
                        a("i", { class: "fa-light fa-trash-can" }, null, -1)
                      ]), 8, Hue)), [
                        [
                          d,
                          "Remove...",
                          void 0,
                          { top: !0 }
                        ]
                      ]) : P("", !0),
                      V((p(), h("button", {
                        type: "button",
                        onClick: (T) => e.showUpdateUserAccess(S.data),
                        class: "btn btn-outline-eclipse btn-sm",
                        disabled: e.loading
                      }, t[10] || (t[10] = [
                        a("i", { class: "fa-light fa-pencil" }, null, -1)
                      ]), 8, Uue)), [
                        [
                          d,
                          "Edit",
                          void 0,
                          { top: !0 }
                        ]
                      ])
                    ])
                  ];
                }),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["value", "loading"])
        ])
      ])
    ]),
    a("div", zue, [
      a("div", Wue, [
        a("div", Gue, [
          a("div", Yue, [
            a("p", Xue, g(e.$t("Edit Access")), 1),
            a("button", {
              type: "button",
              class: "btn-close",
              onClick: t[1] || (t[1] = (...S) => e.closeDialog && e.closeDialog(...S)),
              "aria-label": "Close"
            })
          ]),
          a("div", que, [
            a("div", Que, [
              a("span", Kue, g((c = e.editingAccount) == null ? void 0 : c.firstName) + " " + g((u = e.editingAccount) == null ? void 0 : u.lastName), 1),
              t[11] || (t[11] = a("br", null, null, -1)),
              a("span", null, g((m = e.editingAccount) == null ? void 0 : m.email), 1)
            ]),
            a("div", Zue, g(e.$t("There seems to be an issue. Please try again.")), 1),
            a("div", Jue, [
              a("label", $ue, g(e.$t("MLS")), 1),
              a("div", _ue, [
                a("input", {
                  type: "text",
                  readonly: "",
                  class: "form-control-plaintext",
                  id: "mls",
                  value: (f = e.activeMls) == null ? void 0 : f.name
                }, null, 8, epe)
              ])
            ]),
            a("div", tpe, [
              a("label", spe, g(e.$t("Entitlement")), 1),
              a("div", ape, [
                V(a("select", {
                  class: "form-select",
                  id: "entitlementType",
                  "onUpdate:modelValue": t[2] || (t[2] = (S) => e.entitlementType = S)
                }, t[12] || (t[12] = [
                  a("option", { value: 1 }, "MLS Member", -1),
                  a("option", { value: 2 }, "MLS Client Sponsored", -1)
                ]), 512), [
                  [We, e.entitlementType]
                ])
              ])
            ]),
            N(ks, {
              name: "slide",
              mode: "out-in"
            }, {
              default: ve(() => [
                e.entitlementType == 1 ? (p(), h("div", npe, [
                  a("label", rpe, g(e.$t("MLS Identifier")), 1),
                  a("div", ope, [
                    V(a("input", {
                      type: "text",
                      class: "form-control",
                      id: "mlsIdentifier",
                      "onUpdate:modelValue": t[3] || (t[3] = (S) => e.updateRequest.mlsIdentifier = S)
                    }, null, 512), [
                      [_e, e.updateRequest.mlsIdentifier]
                    ])
                  ])
                ])) : (p(), h("div", ipe, [
                  a("label", lpe, g(e.$t("MLS Data Sponsor")), 1),
                  a("div", dpe, [
                    V(a("select", {
                      class: "form-select",
                      id: "sponsorUserId",
                      "onUpdate:modelValue": t[4] || (t[4] = (S) => e.updateRequest.sponsorUserId = S)
                    }, [
                      t[13] || (t[13] = a("option", { value: void 0 }, "None", -1)),
                      (p(!0), h(A, null, D(e.idxValidatedAccounts, (S) => (p(), h("option", {
                        value: S.id
                      }, g(S.firstName) + " " + g(S.lastName) + " (" + g(S.email) + ")", 9, cpe))), 256))
                    ], 512), [
                      [We, e.updateRequest.sponsorUserId]
                    ])
                  ])
                ]))
              ]),
              _: 1
            })
          ]),
          a("div", upe, [
            a("button", {
              type: "button",
              class: "btn btn-secondary",
              onClick: t[5] || (t[5] = (...S) => e.closeDialog && e.closeDialog(...S))
            }, g(e.$t("Cancel")), 1),
            a("button", {
              type: "button",
              class: "btn btn-lava ms-auto",
              onClick: t[6] || (t[6] = (...S) => e.updateUserAccess && e.updateUserAccess(...S)),
              disabled: !e.canSaveAccess
            }, [
              e.loading ? (p(), h("i", hpe)) : P("", !0),
              y(g(e.$t("Save")), 1)
            ], 8, ppe)
          ])
        ])
      ])
    ], 512),
    a("div", mpe, [
      a("div", fpe, [
        a("div", gpe, [
          t[20] || (t[20] = a("div", { class: "modal-header border-0" }, [
            a("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            })
          ], -1)),
          a("div", vpe, [
            t[16] || (t[16] = a("i", { class: "fa-duotone fa-user-xmark mb-3 fa-3xl" }, null, -1)),
            t[17] || (t[17] = a("br", null, null, -1)),
            a("b", ype, g(e.$t("Remove MLS Access")), 1),
            t[18] || (t[18] = a("br", null, null, -1)),
            t[19] || (t[19] = a("br", null, null, -1)),
            a("p", null, [
              t[14] || (t[14] = y("Are you sure you want to remove ")),
              a("b", null, g((v = e.accountDelete) == null ? void 0 : v.firstName) + " " + g((b = e.accountDelete) == null ? void 0 : b.lastName), 1),
              t[15] || (t[15] = y(" from ")),
              a("b", null, g((w = e.activeMls) == null ? void 0 : w.name) + "?", 1)
            ]),
            a("div", bpe, [
              a("button", {
                type: "button",
                class: "btn btn-outline-secondary",
                "data-bs-dismiss": "modal",
                disabled: e.busy
              }, g(e.$t("Cancel")), 9, Ape),
              a("button", {
                type: "button",
                "data-working": "Adding",
                class: "btn btn-danger",
                onClick: t[7] || (t[7] = (S) => e.removeUserAccess(e.accountDelete)),
                disabled: e.busy
              }, g(e.$t("t-yes-remove")), 9, wpe)
            ])
          ])
        ])
      ])
    ], 512)
  ], 64);
}
const pls = /* @__PURE__ */ Ae(Tue, [["render", Cpe]]), Spe = me({
  name: "MlsIdentifiers",
  props: {},
  components: {},
  data() {
    return {
      mlses: [],
      mlsIdentifiers: [],
      identifier: "",
      mlsId: 0,
      type: "agent",
      loading: !1
    };
  },
  computed: {
    ...at(Te),
    ...q(Te, ["access", "aclLoaded", "isClient", "isAdmin", "isUser"])
  },
  methods: {
    async loadMyMlsAccess() {
      try {
        this.loading = !0, this.mlses.length = 0;
        const e = await W.api.accountMLS.listMls();
        if (e.data.status != de.Success)
          throw new Le(e);
        this.mlses.push(...e.data.page), this.mlses.sort((t, s) => t.name.localeCompare(s.name)), this.mlses.length > 0 && (this.mlsId = this.mlses[0].id);
      } catch (e) {
        Se(e);
      }
      this.loading = !1;
    },
    async loadMyMlsIdentifiers() {
      try {
        this.loading = !0, this.mlsIdentifiers.length = 0;
        const e = await W.api.accountMLS.listIdentifiers();
        if (e.data.status != de.Success)
          throw new Le(e);
        this.mlsIdentifiers.push(...e.data.page);
      } catch (e) {
        Se(e);
      }
      this.loading = !1;
    },
    async addMlsIdentifier() {
      try {
        this.loading = !0;
        const e = await W.api.accountMLS.addIdentifier({
          mlsId: this.mlsId,
          type: this.type,
          identifier: this.identifier
        });
        if (e.data.status != de.Success)
          throw new Le(e);
        const t = this.mlses.find((s) => s.id == this.mlsId);
        this.mlsIdentifiers.push({
          mls: t.name,
          type: this.type,
          identifier: this.identifier,
          mlsId: this.mlsId
        }), this.identifier = "";
      } catch (e) {
        Se(e);
      }
      this.loading = !1;
    },
    async removeMlsIdentifier(e) {
      try {
        this.loading = !0;
        const t = await W.api.accountMLS.removeIdentifier(e.mlsId, e.type, e.identifier);
        if (t.data.status != de.Success)
          throw new Le(t);
        this.mlsIdentifiers = this.mlsIdentifiers.filter((s) => !(s.mlsId == e.mlsId && s.identifier == e.identifier && s.type == e.type));
      } catch (t) {
        Se(t);
      }
      this.loading = !1;
    }
  },
  mounted() {
    this.aclLoaded.then(() => this.loadMyMlsAccess()).then(() => this.loadMyMlsIdentifiers());
  }
}), Ppe = { class: "row g-3" }, kpe = { class: "col-12" }, Epe = { class: "fw-bold fs-3 mb-0" }, Ipe = { class: "col-lg-10" }, Tpe = { class: "card shadow" }, Ope = { class: "card-body" }, Rpe = { class: "mb-3" }, Lpe = ["disabled"], Bpe = ["value"], Mpe = { class: "input-group mb-3" }, xpe = ["disabled"], Fpe = {
  key: 1,
  class: "input-group-text"
}, Vpe = ["disabled"], Dpe = ["disabled"], Npe = { class: "card border" }, jpe = { class: "card-body" }, Hpe = { class: "d-flex flex-column gap-2" }, Upe = { class: "d-flex align-items-center" }, zpe = ["onClick", "disabled"], Wpe = { key: 0 };
function Gpe(e, t, s, n, r, i) {
  return p(), h("div", Ppe, [
    a("div", kpe, [
      a("h2", Epe, g(e.$t("t-mls-identifiers")), 1)
    ]),
    a("div", Ipe, [
      a("div", Tpe, [
        a("div", Ope, [
          a("p", null, [
            e.isAdmin ? (p(), h(A, { key: 0 }, [
              y(" Add the broker and/or Agent ID for the MLSs you are member of. ")
            ], 64)) : P("", !0),
            e.isUser ? (p(), h(A, { key: 1 }, [
              y(" Add the Agent MLS ID for the MLSs you are a member of. ")
            ], 64)) : P("", !0)
          ]),
          a("div", Rpe, [
            V(a("select", {
              type: "text",
              class: "form-select",
              "onUpdate:modelValue": t[0] || (t[0] = (o) => e.mlsId = o),
              disabled: e.loading
            }, [
              (p(!0), h(A, null, D(e.mlses, (o) => (p(), h("option", {
                value: o.id
              }, g(o.name), 9, Bpe))), 256))
            ], 8, Lpe), [
              [We, e.mlsId]
            ])
          ]),
          a("div", Mpe, [
            e.isAdmin ? V((p(), h("select", {
              key: 0,
              type: "text",
              class: "form-select pe-5",
              "onUpdate:modelValue": t[1] || (t[1] = (o) => e.type = o),
              disabled: e.loading
            }, t[4] || (t[4] = [
              a("option", { value: "broker" }, "Broker ID", -1),
              a("option", { value: "agent" }, "Agent ID", -1)
            ]), 8, xpe)), [
              [We, e.type]
            ]) : P("", !0),
            e.isUser ? (p(), h("span", Fpe, "Agent ID")) : P("", !0),
            V(a("input", {
              type: "text",
              class: "form-control w-50",
              placeholder: "MLS Identifier",
              "onUpdate:modelValue": t[2] || (t[2] = (o) => e.identifier = o),
              disabled: e.loading
            }, null, 8, Vpe), [
              [_e, e.identifier]
            ]),
            a("button", {
              type: "button",
              class: "btn btn-eclipse no-anim rounded-end",
              onClick: t[3] || (t[3] = (...o) => e.addMlsIdentifier && e.addMlsIdentifier(...o)),
              disabled: e.loading
            }, t[5] || (t[5] = [
              a("i", { class: "fa-duotone fa-solid fa-plus me-2" }, null, -1),
              y("Add")
            ]), 8, Dpe)
          ]),
          a("div", Npe, [
            t[10] || (t[10] = a("p", { class: "card-header" }, "My MLS Identifiers:", -1)),
            a("div", jpe, [
              a("ul", Hpe, [
                (p(!0), h(A, null, D(e.mlsIdentifiers, (o) => (p(), h("li", Upe, [
                  a("b", null, g(o.mls), 1),
                  t[7] || (t[7] = y("  ")),
                  o.type == "broker" ? (p(), h(A, { key: 0 }, [
                    y(" Broker ")
                  ], 64)) : o.type == "agent" ? (p(), h(A, { key: 1 }, [
                    y(" Agent ")
                  ], 64)) : P("", !0),
                  t[8] || (t[8] = y(" Id: ")),
                  a("b", null, g(o.identifier), 1),
                  t[9] || (t[9] = y()),
                  a("button", {
                    type: "button",
                    class: "btn btn-danger btn-sm ms-auto",
                    onClick: (l) => e.removeMlsIdentifier(o),
                    disabled: e.loading
                  }, t[6] || (t[6] = [
                    a("i", { class: "fa-duotone fa-solid fa-times" }, null, -1)
                  ]), 8, zpe)
                ]))), 256)),
                e.mlsIdentifiers.length == 0 ? (p(), h("li", Wpe, "No identifiers added.")) : P("", !0)
              ])
            ])
          ])
        ])
      ])
    ])
  ]);
}
const hls = /* @__PURE__ */ Ae(Spe, [["render", Gpe]]), Ype = me({
  name: "GlAccountMapping",
  props: {},
  components: {
    Select: hl
  },
  data() {
    return {
      addingNew: !1,
      editingLink: !1,
      editError: void 0,
      selectedGlAccount: void 0,
      selectedAccount: void 0,
      newAccountName: void 0,
      newAccountType: Ra.Expense
    };
  },
  computed: {
    expenseAccountsSorted() {
      return [
        ...this.expenseAccounts,
        ...this.nonOperatingExpenseAccounts
      ].sort((e, t) => e.name.localeCompare(t.name));
    },
    selectedAccountType() {
      var e;
      return ((e = this.selectedAccount) == null ? void 0 : e.isIncome) == !0 ? Ra.Income : Ra.Expense;
    },
    ...q(Te, ["access", "aclLoaded"]),
    ...q(ct, ["incomeAccountsSorted", "operatingExpenseAccountsSorted", "nonOperatingExpenseAccountsSorted", "expenseAccounts", "nonOperatingExpenseAccounts", "glAccounts"]),
    ...at(ct)
  },
  methods: {
    number: Ve,
    assignedGlAccounts(e) {
      return this.glAccounts.filter((t) => t.incomeExpenseId == e).sort((t, s) => t.name.localeCompare(s.name));
    },
    addAccountFromGl(e, t) {
      var s, n, r;
      this.editError = void 0, this.addingNew = !0, this.selectedAccount = e, this.newAccountName = (n = (s = this.selectedGlAccount) == null ? void 0 : s.name) == null ? void 0 : n.replace(/^[\d\s\W]*/g, ""), this.newAccountType = t, (r = bootstrap.Modal.getOrCreateInstance(this.$refs.dialogAccountMapping)) == null || r.show();
    },
    linkAccountMap(e, t) {
      var s;
      this.editError = void 0, this.addingNew = !1, this.editingLink = !1, this.selectedGlAccount = e, this.selectedAccount = t, (s = bootstrap.Modal.getOrCreateInstance(this.$refs.dialogAccountMapping)) == null || s.show();
    },
    editAccountMap(e, t) {
      var s;
      this.editError = void 0, this.addingNew = !1, this.editingLink = !0, this.selectedGlAccount = e, this.selectedAccount = t, (s = bootstrap.Modal.getOrCreateInstance(this.$refs.dialogAccountMapping)) == null || s.show();
    },
    selectRescoverAccount(e) {
      this.selectedAccount = e;
    },
    async updateMapping() {
      var e, t, s;
      try {
        this.editError = void 0;
        let n;
        !((e = this.selectedAccount) != null && e.id) || ((t = this.selectedAccount) == null ? void 0 : t.id) == 0 ? (n = await W.api.incomeExpenseAccounts.mapGlAccountAsNew(this.selectedAccount.isIncome ? "income" : "expense", this.selectedAccount.nameUrl, this.selectedGlAccount.id), this.selectedAccount.id = n.data.account.id) : n = await W.api.incomeExpenseAccounts.mapGlAccount(this.selectedGlAccount.id, this.selectedAccount.id);
        const r = this.selectedAccount.id;
        if (n.data.status != de.Success)
          throw new Error(n.data.message);
        this.selectedGlAccount.incomeExpenseId = r, (s = bootstrap.Modal.getOrCreateInstance(this.$refs.dialogAccountMapping)) == null || s.hide();
      } catch (n) {
        this.editError = n.message;
      }
    },
    async addAndAssign() {
      var e;
      try {
        this.editError = void 0;
        const t = await this.accountStore.addIncomeExpenseAccount(this.newAccountName, this.newAccountType), s = await W.api.incomeExpenseAccounts.mapGlAccount(this.selectedGlAccount.id, t);
        if (s.data.status != de.Success)
          throw new Error(s.data.message);
        this.selectedGlAccount.incomeExpenseId = t, (e = bootstrap.Modal.getOrCreateInstance(this.$refs.dialogAccountMapping)) == null || e.hide();
      } catch (t) {
        this.editError = t.message;
      }
    }
  },
  created() {
  },
  mounted() {
    this.aclLoaded.then(this.accountStore.syncGlAccounts).then(this.accountStore.fetchGlAccounts).then(this.accountStore.fetchIncomeExpenseAccounts);
  }
}), Xpe = { class: "row" }, qpe = { class: "col" }, Qpe = { class: "card border" }, Kpe = { class: "card-body" }, Zpe = { class: "table" }, Jpe = { class: "table-group-divider" }, $pe = { class: "border-end" }, _pe = {
  key: 0,
  class: "text-secondary fst-italic d-block"
}, ehe = { class: "card-scroll card-scroll-no-head-foot" }, the = { class: "table table-hover table-sm mb-0" }, she = { class: "align-middle" }, ahe = { class: "d-flex gap-2 justify-content-end" }, nhe = ["onClick"], rhe = ["onClick"], ohe = {
  class: "modal fade",
  id: "dialogAccountMapping",
  ref: "dialogAccountMapping",
  tabindex: "-1",
  "aria-labelledby": "dialogAccountMappingLabel",
  "aria-hidden": "true"
}, ihe = { class: "modal-dialog modal-lg modal-dialog-centered" }, lhe = { class: "modal-content bg-gradient-alphabet rounded" }, dhe = { class: "modal-header border-0 pb-0" }, che = {
  class: "modal-title fs-5 fw-bold",
  id: "dialogAccountMappingLabel"
}, uhe = { class: "modal-body" }, phe = {
  key: 0,
  class: "alert alert-danger",
  role: "alert"
}, hhe = { class: "row mb-3" }, mhe = { class: "col-sm-9" }, fhe = { class: "form-control-plaintext" }, ghe = {
  key: 1,
  class: "row"
}, vhe = { class: "col-sm-3" }, yhe = { class: "col-sm-6" }, bhe = {
  key: 2,
  class: "row"
}, Ahe = { class: "col-sm-9" }, whe = { class: "modal-footer border-0 pt-0" };
function Che(e, t, s, n, r, i) {
  var l;
  const o = pe("Select");
  return p(), h(A, null, [
    a("div", Xpe, [
      t[9] || (t[9] = a("div", { class: "col-12" }, [
        a("h2", { class: "fw-bold fs-3" }, "Income Accounts"),
        a("p", null, 'Map the income and expense accounts in your property management software with their associated Rescover accounts. Any amounts retrieved via API within GL accounts which are not discretely matched will be placed into either "Other Income" or "Other Expense" accounts.')
      ], -1)),
      a("div", qpe, [
        a("div", Qpe, [
          a("div", Kpe, [
            a("table", Zpe, [
              t[8] || (t[8] = a("thead", null, [
                a("tr", null, [
                  a("th", { class: "border-end" }, "Rescover Account"),
                  a("th", null, "Rentvine GL Account")
                ])
              ], -1)),
              a("tbody", Jpe, [
                (p(!0), h(A, null, D(e.incomeAccountsSorted, (d) => (p(), h("tr", null, [
                  a("th", $pe, [
                    y(g(d.name) + " ", 1),
                    d.nameUrl == "other-income" ? (p(), h("small", _pe, "(Unmapped GL Accounts)")) : P("", !0)
                  ]),
                  a("td", null, [
                    a("div", ehe, [
                      a("table", the, [
                        a("tbody", null, [
                          (p(!0), h(A, null, D(e.assignedGlAccounts(d.id), (c) => (p(), h("tr", null, [
                            a("td", she, g(c.name), 1),
                            a("td", ahe, [
                              d.nameUrl == "other-income" ? (p(), h("button", {
                                key: 0,
                                type: "button",
                                class: "btn btn-outline-eclipse btn-sm",
                                onClick: (u) => e.linkAccountMap(c, d)
                              }, t[6] || (t[6] = [
                                a("i", { class: "fa-light fa-link me-2" }, null, -1),
                                y("Link")
                              ]), 8, nhe)) : (p(), h("button", {
                                key: 1,
                                type: "button",
                                class: "btn btn-outline-eclipse btn-sm",
                                onClick: (u) => e.editAccountMap(c, d)
                              }, t[7] || (t[7] = [
                                a("i", { class: "fa-light fa-pen-to-square me-2" }, null, -1),
                                y("Edit")
                              ]), 8, rhe))
                            ])
                          ]))), 256))
                        ])
                      ])
                    ])
                  ])
                ]))), 256))
              ])
            ])
          ])
        ])
      ])
    ]),
    a("div", ohe, [
      a("div", ihe, [
        a("div", lhe, [
          a("div", dhe, [
            a("h1", che, [
              e.addingNew ? (p(), h(A, { key: 0 }, [
                y(" Create new Rescover Account ")
              ], 64)) : e.editingLink ? (p(), h(A, { key: 1 }, [
                y(" Edit Account Mapping ")
              ], 64)) : (p(), h(A, { key: 2 }, [
                y(" Link GL Account to Rescover ")
              ], 64))
            ]),
            t[10] || (t[10] = a("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            }, null, -1))
          ]),
          a("div", uhe, [
            e.editError ? (p(), h("div", phe, g(e.editError), 1)) : P("", !0),
            a("div", hhe, [
              t[11] || (t[11] = a("label", { class: "col-sm-3 col-form-label fw-bold" }, " GL Account ", -1)),
              a("div", mhe, [
                a("div", fhe, g((l = e.selectedGlAccount) == null ? void 0 : l.name), 1)
              ])
            ]),
            e.addingNew ? (p(), h("div", ghe, [
              t[13] || (t[13] = a("label", { class: "col-sm-3 col-form-label fw-bold" }, " Create New ", -1)),
              a("div", vhe, [
                V(a("select", {
                  class: "form-select",
                  "onUpdate:modelValue": t[0] || (t[0] = (d) => e.newAccountType = d)
                }, t[12] || (t[12] = [
                  a("option", { value: "income" }, "Income", -1)
                ]), 512), [
                  [We, e.newAccountType]
                ])
              ]),
              a("div", yhe, [
                V(a("input", {
                  type: "text",
                  class: "form-control",
                  "onUpdate:modelValue": t[1] || (t[1] = (d) => e.newAccountName = d)
                }, null, 512), [
                  [_e, e.newAccountName]
                ])
              ])
            ])) : (p(), h("div", bhe, [
              t[17] || (t[17] = a("label", { class: "col-sm-3 col-form-label fw-bold" }, " Rescover Account ", -1)),
              a("div", Ahe, [
                e.expenseAccounts.length > 0 ? (p(), Fe(o, {
                  key: 0,
                  modelValue: e.selectedAccount,
                  "onUpdate:modelValue": t[2] || (t[2] = (d) => e.selectedAccount = d),
                  filter: "",
                  options: e.incomeAccountsSorted,
                  optionLabel: "name",
                  placeholder: "Select an Account",
                  class: "w-100"
                }, {
                  value: ve((d) => [
                    d.value ? (p(), h(A, { key: 0 }, [
                      t[14] || (t[14] = a("span", { class: "badge rounded-pill text-bg-success me-2" }, "Income", -1)),
                      y(" " + g(d.value.name), 1)
                    ], 64)) : (p(), h(A, { key: 1 }, [
                      y(g(d.placeholder), 1)
                    ], 64))
                  ]),
                  option: ve((d) => [
                    t[15] || (t[15] = a("span", { class: "badge rounded-pill text-bg-success me-2" }, "Income", -1)),
                    y(" " + g(d.option.name), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue", "options"])) : P("", !0),
                a("button", {
                  type: "button",
                  class: "btn btn-link",
                  onClick: t[3] || (t[3] = (d) => e.addAccountFromGl(e.account, "income"))
                }, t[16] || (t[16] = [
                  a("i", { class: "fa-light fa-plus me-2" }, null, -1),
                  y("Add new Rescover account ")
                ]))
              ])
            ]))
          ]),
          a("div", whe, [
            t[18] || (t[18] = a("button", {
              type: "button",
              class: "btn btn-secondary",
              "data-bs-dismiss": "modal"
            }, "Cancel", -1)),
            e.addingNew ? (p(), h("button", {
              key: 0,
              type: "button",
              class: "btn btn-lava ms-auto",
              onClick: t[4] || (t[4] = (...d) => e.addAndAssign && e.addAndAssign(...d))
            }, "Add & Assign")) : (p(), h("button", {
              key: 1,
              type: "button",
              class: "btn btn-lava ms-auto",
              onClick: t[5] || (t[5] = (...d) => e.updateMapping && e.updateMapping(...d))
            }, "Update"))
          ])
        ])
      ])
    ], 512)
  ], 64);
}
const mls = /* @__PURE__ */ Ae(Ype, [["render", Che]]), She = me({
  name: "GlOperatingExpense",
  props: {},
  components: {
    Select: hl
  },
  data() {
    return {
      addingNew: !1,
      editingLink: !1,
      editError: void 0,
      selectedGlAccount: void 0,
      selectedAccount: void 0,
      newAccountName: void 0,
      newAccountType: Ra.Expense
    };
  },
  computed: {
    expenseAccountsSorted() {
      return [
        ...this.expenseAccounts,
        ...this.nonOperatingExpenseAccounts
      ].sort((e, t) => e.name.localeCompare(t.name));
    },
    selectedAccountType() {
      var e;
      return ((e = this.selectedAccount) == null ? void 0 : e.isIncome) == !0 ? Ra.Income : Ra.Expense;
    },
    ...q(Te, ["access", "aclLoaded"]),
    ...q(ct, ["incomeAccountsSorted", "operatingExpenseAccountsSorted", "nonOperatingExpenseAccountsSorted", "expenseAccounts", "nonOperatingExpenseAccounts", "glAccounts"]),
    ...at(ct)
  },
  methods: {
    number: Ve,
    assignedGlAccounts(e) {
      return this.glAccounts.filter((t) => t.incomeExpenseId == e).sort((t, s) => t.name.localeCompare(s.name));
    },
    addAccountFromGl(e, t) {
      var s, n, r;
      this.editError = void 0, this.addingNew = !0, this.selectedAccount = e, this.newAccountName = (n = (s = this.selectedGlAccount) == null ? void 0 : s.name) == null ? void 0 : n.replace(/^[\d\s\W]*/g, ""), this.newAccountType = t, (r = bootstrap.Modal.getOrCreateInstance(this.$refs.dialogAccountMapping)) == null || r.show();
    },
    linkAccountMap(e, t) {
      var s;
      this.editError = void 0, this.addingNew = !1, this.editingLink = !1, this.selectedGlAccount = e, this.selectedAccount = t, (s = bootstrap.Modal.getOrCreateInstance(this.$refs.dialogAccountMapping)) == null || s.show();
    },
    editAccountMap(e, t) {
      var s;
      this.editError = void 0, this.addingNew = !1, this.editingLink = !0, this.selectedGlAccount = e, this.selectedAccount = t, (s = bootstrap.Modal.getOrCreateInstance(this.$refs.dialogAccountMapping)) == null || s.show();
    },
    selectRescoverAccount(e) {
      this.selectedAccount = e;
    },
    async updateMapping() {
      var e, t, s;
      try {
        this.editError = void 0;
        let n;
        !((e = this.selectedAccount) != null && e.id) || ((t = this.selectedAccount) == null ? void 0 : t.id) == 0 ? (n = await W.api.incomeExpenseAccounts.mapGlAccountAsNew(this.selectedAccount.isIncome ? "income" : "expense", this.selectedAccount.nameUrl, this.selectedGlAccount.id), this.selectedAccount.id = n.data.account.id) : n = await W.api.incomeExpenseAccounts.mapGlAccount(this.selectedGlAccount.id, this.selectedAccount.id);
        const r = this.selectedAccount.id;
        if (n.data.status != de.Success)
          throw new Error(n.data.message);
        this.selectedGlAccount.incomeExpenseId = r, (s = bootstrap.Modal.getOrCreateInstance(this.$refs.dialogAccountMapping)) == null || s.hide();
      } catch (n) {
        this.editError = n.message;
      }
    },
    async addAndAssign() {
      var e;
      try {
        this.editError = void 0;
        const t = await this.accountStore.addIncomeExpenseAccount(this.newAccountName, this.newAccountType), s = await W.api.incomeExpenseAccounts.mapGlAccount(this.selectedGlAccount.id, t);
        if (s.data.status != de.Success)
          throw new Error(s.data.message);
        this.selectedGlAccount.incomeExpenseId = t, (e = bootstrap.Modal.getOrCreateInstance(this.$refs.dialogAccountMapping)) == null || e.hide();
      } catch (t) {
        this.editError = t.message;
      }
    }
  },
  created() {
  },
  mounted() {
    this.aclLoaded.then(this.accountStore.syncGlAccounts).then(this.accountStore.fetchGlAccounts).then(this.accountStore.fetchIncomeExpenseAccounts);
  }
}), Phe = { class: "row" }, khe = { class: "col" }, Ehe = { class: "card border" }, Ihe = { class: "card-body" }, The = { class: "table" }, Ohe = { class: "table-group-divider" }, Rhe = { class: "border-end" }, Lhe = {
  key: 0,
  class: "text-secondary fst-italic d-block"
}, Bhe = { class: "card-scroll card-scroll-no-head-foot" }, Mhe = { class: "table table-hover table-sm mb-0" }, xhe = { class: "align-middle" }, Fhe = { class: "d-flex gap-2 justify-content-end" }, Vhe = ["onClick"], Dhe = ["onClick"], Nhe = {
  class: "modal fade",
  id: "dialogAccountMapping",
  ref: "dialogAccountMapping",
  tabindex: "-1",
  "aria-labelledby": "dialogAccountMappingLabel",
  "aria-hidden": "true"
}, jhe = { class: "modal-dialog modal-lg modal-dialog-centered" }, Hhe = { class: "modal-content bg-gradient-alphabet rounded" }, Uhe = { class: "modal-header border-0 pb-0" }, zhe = {
  class: "modal-title fs-5 fw-bold",
  id: "dialogAccountMappingLabel"
}, Whe = { class: "modal-body" }, Ghe = {
  key: 0,
  class: "alert alert-danger",
  role: "alert"
}, Yhe = { class: "row mb-3" }, Xhe = { class: "col-sm-9" }, qhe = { class: "form-control-plaintext" }, Qhe = {
  key: 1,
  class: "row"
}, Khe = { class: "col-sm-3" }, Zhe = { class: "col-sm-6" }, Jhe = {
  key: 2,
  class: "row"
}, $he = { class: "col-sm-9" }, _he = { class: "modal-footer border-0 pt-0" };
function eme(e, t, s, n, r, i) {
  var l;
  const o = pe("Select");
  return p(), h(A, null, [
    a("div", Phe, [
      t[9] || (t[9] = a("div", { class: "col-12" }, [
        a("h2", { class: "fw-bold fs-3" }, "Operating Expense Accounts"),
        a("p", null, 'Map the income and expense accounts in your property management software with their associated Rescover accounts. Any amounts retrieved via API within GL accounts which are not discretely matched will be placed into either "Other Income" or "Other Expense" accounts.')
      ], -1)),
      a("div", khe, [
        a("div", Ehe, [
          a("div", Ihe, [
            a("table", The, [
              t[8] || (t[8] = a("thead", null, [
                a("tr", null, [
                  a("th", { class: "border-end" }, "Rescover Account"),
                  a("th", null, "Rentvine GL Account")
                ])
              ], -1)),
              a("tbody", Ohe, [
                (p(!0), h(A, null, D(e.operatingExpenseAccountsSorted, (d) => (p(), h("tr", null, [
                  a("th", Rhe, [
                    y(g(d.name) + " ", 1),
                    d.nameUrl == "other-expense" ? (p(), h("small", Lhe, "(Unmapped GL Accounts)")) : P("", !0)
                  ]),
                  a("td", null, [
                    a("div", Bhe, [
                      a("table", Mhe, [
                        a("tbody", null, [
                          (p(!0), h(A, null, D(e.assignedGlAccounts(d.id), (c) => (p(), h("tr", null, [
                            a("td", xhe, g(c.name), 1),
                            a("td", Fhe, [
                              d.nameUrl == "other-expense" ? (p(), h("button", {
                                key: 0,
                                type: "button",
                                class: "btn btn-outline-eclipse btn-sm",
                                onClick: (u) => e.linkAccountMap(c, d)
                              }, t[6] || (t[6] = [
                                a("i", { class: "fa-light fa-link me-2" }, null, -1),
                                y("Link")
                              ]), 8, Vhe)) : (p(), h("button", {
                                key: 1,
                                type: "button",
                                class: "btn btn-outline-eclipse btn-sm",
                                onClick: (u) => e.editAccountMap(c, d)
                              }, t[7] || (t[7] = [
                                a("i", { class: "fa-light fa-pen-to-square me-2" }, null, -1),
                                y("Edit")
                              ]), 8, Dhe))
                            ])
                          ]))), 256))
                        ])
                      ])
                    ])
                  ])
                ]))), 256))
              ])
            ])
          ])
        ])
      ])
    ]),
    a("div", Nhe, [
      a("div", jhe, [
        a("div", Hhe, [
          a("div", Uhe, [
            a("h1", zhe, [
              e.addingNew ? (p(), h(A, { key: 0 }, [
                y(" Create new Rescover Account ")
              ], 64)) : e.editingLink ? (p(), h(A, { key: 1 }, [
                y(" Edit Account Mapping ")
              ], 64)) : (p(), h(A, { key: 2 }, [
                y(" Link GL Account to Rescover ")
              ], 64))
            ]),
            t[10] || (t[10] = a("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            }, null, -1))
          ]),
          a("div", Whe, [
            e.editError ? (p(), h("div", Ghe, g(e.editError), 1)) : P("", !0),
            a("div", Yhe, [
              t[11] || (t[11] = a("label", { class: "col-sm-3 col-form-label fw-bold" }, " GL Account ", -1)),
              a("div", Xhe, [
                a("div", qhe, g((l = e.selectedGlAccount) == null ? void 0 : l.name), 1)
              ])
            ]),
            e.addingNew ? (p(), h("div", Qhe, [
              t[13] || (t[13] = a("label", { class: "col-sm-3 col-form-label fw-bold" }, " Create New ", -1)),
              a("div", Khe, [
                V(a("select", {
                  class: "form-select",
                  "onUpdate:modelValue": t[0] || (t[0] = (d) => e.newAccountType = d)
                }, t[12] || (t[12] = [
                  a("option", { value: "expense" }, "Expense", -1),
                  a("option", { value: "nonOperatingExpense" }, "Non-Operating Expense", -1)
                ]), 512), [
                  [We, e.newAccountType]
                ])
              ]),
              a("div", Zhe, [
                V(a("input", {
                  type: "text",
                  class: "form-control",
                  "onUpdate:modelValue": t[1] || (t[1] = (d) => e.newAccountName = d)
                }, null, 512), [
                  [_e, e.newAccountName]
                ])
              ])
            ])) : (p(), h("div", Jhe, [
              t[17] || (t[17] = a("label", { class: "col-sm-3 col-form-label fw-bold" }, " Rescover Account ", -1)),
              a("div", $he, [
                e.expenseAccounts.length > 0 ? (p(), Fe(o, {
                  key: 0,
                  modelValue: e.selectedAccount,
                  "onUpdate:modelValue": t[2] || (t[2] = (d) => e.selectedAccount = d),
                  filter: "",
                  options: e.expenseAccountsSorted,
                  optionLabel: "name",
                  placeholder: "Select an Account",
                  "append-to": "self",
                  class: "w-100"
                }, {
                  value: ve((d) => [
                    d.value ? (p(), h(A, { key: 0 }, [
                      t[14] || (t[14] = a("span", { class: "badge rounded-pill text-bg-danger me-2" }, "Expense", -1)),
                      y(" " + g(d.value.name), 1)
                    ], 64)) : (p(), h(A, { key: 1 }, [
                      y(g(d.placeholder), 1)
                    ], 64))
                  ]),
                  option: ve((d) => [
                    t[15] || (t[15] = a("span", { class: "badge rounded-pill text-bg-danger me-2" }, "Expense", -1)),
                    y(" " + g(d.option.name), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue", "options"])) : P("", !0),
                a("button", {
                  type: "button",
                  class: "btn btn-link",
                  onClick: t[3] || (t[3] = (d) => e.addAccountFromGl(e.selectedAccount, "expense"))
                }, t[16] || (t[16] = [
                  a("i", { class: "fa-light fa-plus me-2" }, null, -1),
                  y("Add new Rescover account ")
                ]))
              ])
            ]))
          ]),
          a("div", _he, [
            t[18] || (t[18] = a("button", {
              type: "button",
              class: "btn btn-secondary",
              "data-bs-dismiss": "modal"
            }, "Cancel", -1)),
            e.addingNew ? (p(), h("button", {
              key: 0,
              type: "button",
              class: "btn btn-lava ms-auto",
              onClick: t[4] || (t[4] = (...d) => e.addAndAssign && e.addAndAssign(...d))
            }, "Add & Assign")) : (p(), h("button", {
              key: 1,
              type: "button",
              class: "btn btn-lava ms-auto",
              onClick: t[5] || (t[5] = (...d) => e.updateMapping && e.updateMapping(...d))
            }, "Update"))
          ])
        ])
      ])
    ], 512)
  ], 64);
}
const fls = /* @__PURE__ */ Ae(She, [["render", eme]]), tme = me({
  name: "GlNonOperatingExpense",
  props: {},
  components: {
    Select: hl
  },
  data() {
    return {
      addingNew: !1,
      editingLink: !1,
      editError: void 0,
      selectedGlAccount: void 0,
      selectedAccount: void 0,
      newAccountName: void 0,
      newAccountType: Ra.Expense
    };
  },
  computed: {
    expenseAccountsSorted() {
      return [
        ...this.expenseAccounts,
        ...this.nonOperatingExpenseAccounts
      ].sort((e, t) => e.name.localeCompare(t.name));
    },
    selectedAccountType() {
      var e;
      return ((e = this.selectedAccount) == null ? void 0 : e.isIncome) == !0 ? Ra.Income : Ra.Expense;
    },
    ...q(Te, ["access", "aclLoaded"]),
    ...q(ct, ["incomeAccountsSorted", "operatingExpenseAccountsSorted", "nonOperatingExpenseAccountsSorted", "expenseAccounts", "nonOperatingExpenseAccounts", "glAccounts"]),
    ...at(ct)
  },
  methods: {
    number: Ve,
    assignedGlAccounts(e) {
      return this.glAccounts.filter((t) => t.incomeExpenseId == e).sort((t, s) => t.name.localeCompare(s.name));
    },
    addAccountFromGl(e, t) {
      var s, n, r;
      this.editError = void 0, this.addingNew = !0, this.selectedAccount = e, this.newAccountName = (n = (s = this.selectedGlAccount) == null ? void 0 : s.name) == null ? void 0 : n.replace(/^[\d\s\W]*/g, ""), this.newAccountType = t, (r = bootstrap.Modal.getOrCreateInstance(this.$refs.dialogAccountMapping)) == null || r.show();
    },
    linkAccountMap(e, t) {
      var s;
      this.editError = void 0, this.addingNew = !1, this.editingLink = !1, this.selectedGlAccount = e, this.selectedAccount = t, (s = bootstrap.Modal.getOrCreateInstance(this.$refs.dialogAccountMapping)) == null || s.show();
    },
    editAccountMap(e, t) {
      var s;
      this.editError = void 0, this.addingNew = !1, this.editingLink = !0, this.selectedGlAccount = e, this.selectedAccount = t, (s = bootstrap.Modal.getOrCreateInstance(this.$refs.dialogAccountMapping)) == null || s.show();
    },
    selectRescoverAccount(e) {
      this.selectedAccount = e;
    },
    async updateMapping() {
      var e, t, s;
      try {
        this.editError = void 0;
        let n;
        !((e = this.selectedAccount) != null && e.id) || ((t = this.selectedAccount) == null ? void 0 : t.id) == 0 ? (n = await W.api.incomeExpenseAccounts.mapGlAccountAsNew(this.selectedAccount.isIncome ? "income" : "expense", this.selectedAccount.nameUrl, this.selectedGlAccount.id), this.selectedAccount.id = n.data.account.id) : n = await W.api.incomeExpenseAccounts.mapGlAccount(this.selectedGlAccount.id, this.selectedAccount.id);
        const r = this.selectedAccount.id;
        if (n.data.status != de.Success)
          throw new Error(n.data.message);
        this.selectedGlAccount.incomeExpenseId = r, (s = bootstrap.Modal.getOrCreateInstance(this.$refs.dialogAccountMapping)) == null || s.hide();
      } catch (n) {
        this.editError = n.message;
      }
    },
    async addAndAssign() {
      var e;
      try {
        this.editError = void 0;
        const t = await this.accountStore.addIncomeExpenseAccount(this.newAccountName, this.newAccountType), s = await W.api.incomeExpenseAccounts.mapGlAccount(this.selectedGlAccount.id, t);
        if (s.data.status != de.Success)
          throw new Error(s.data.message);
        this.selectedGlAccount.incomeExpenseId = t, (e = bootstrap.Modal.getOrCreateInstance(this.$refs.dialogAccountMapping)) == null || e.hide();
      } catch (t) {
        this.editError = t.message;
      }
    }
  },
  created() {
  },
  mounted() {
    this.aclLoaded.then(this.accountStore.syncGlAccounts).then(this.accountStore.fetchGlAccounts).then(this.accountStore.fetchIncomeExpenseAccounts);
  }
}), sme = { class: "row" }, ame = { class: "col" }, nme = { class: "card border" }, rme = { class: "card-body" }, ome = { class: "table" }, ime = { class: "table-group-divider" }, lme = { class: "border-end" }, dme = { class: "card-scroll card-scroll-no-head-foot" }, cme = { class: "table table-hover table-sm mb-0" }, ume = { class: "align-middle" }, pme = { class: "d-flex gap-2 justify-content-end" }, hme = ["onClick"], mme = ["onClick"], fme = {
  class: "modal fade",
  id: "dialogAccountMapping",
  ref: "dialogAccountMapping",
  tabindex: "-1",
  "aria-labelledby": "dialogAccountMappingLabel",
  "aria-hidden": "true"
}, gme = { class: "modal-dialog modal-lg modal-dialog-centered" }, vme = { class: "modal-content bg-gradient-alphabet rounded" }, yme = { class: "modal-header" }, bme = {
  class: "modal-title fs-5 fw-bold",
  id: "dialogAccountMappingLabel"
}, Ame = { class: "modal-body" }, wme = {
  key: 0,
  class: "alert alert-danger",
  role: "alert"
}, Cme = { class: "row mb-3" }, Sme = { class: "col-sm-9" }, Pme = { class: "form-control-plaintext" }, kme = {
  key: 1,
  class: "row mb-3"
}, Eme = { class: "col-sm-3" }, Ime = { class: "col-sm-6" }, Tme = {
  key: 2,
  class: "row mb-3"
}, Ome = { class: "col-sm-9" }, Rme = {
  key: 0,
  class: "dropdown dropdown-select"
}, Lme = {
  class: "btn btn-outline-secondary dropdown-toggle no-anim w-100 text-start d-flex align-items-center",
  type: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}, Bme = {
  key: 0,
  class: "badge rounded-pill text-bg-warning me-2"
}, Mme = {
  key: 1,
  class: "badge rounded-pill text-bg-danger me-2"
}, xme = {
  key: 2,
  class: "badge rounded-pill text-bg-danger me-2"
}, Fme = { class: "dropdown-menu shadow" }, Vme = ["onClick"], Dme = ["onClick"], Nme = {
  key: 0,
  class: "badge rounded-pill text-bg-danger me-2"
}, jme = {
  key: 1,
  class: "badge rounded-pill text-bg-danger me-2"
}, Hme = { class: "modal-footer" };
function Ume(e, t, s, n, r, i) {
  var l, d;
  const o = pe("Select");
  return p(), h(A, null, [
    a("div", sme, [
      t[11] || (t[11] = a("div", { class: "col-12" }, [
        a("h2", { class: "fw-bold fs-3" }, "Non-Operating Expense Accounts"),
        a("p", null, 'Map the income and expense accounts in your property management software with their associated Rescover accounts. Any amounts retrieved via API within GL accounts which are not discretely matched will be placed into either "Other Income" or "Other Expense" accounts.')
      ], -1)),
      a("div", ame, [
        a("div", nme, [
          a("div", rme, [
            a("table", ome, [
              t[10] || (t[10] = a("thead", null, [
                a("tr", null, [
                  a("th", { class: "border-end" }, "Rescover Account"),
                  a("th", null, "Rentvine GL Account")
                ])
              ], -1)),
              a("tbody", ime, [
                (p(!0), h(A, null, D(e.nonOperatingExpenseAccountsSorted, (c) => (p(), h("tr", null, [
                  a("th", lme, [
                    y(g(c.name) + " ", 1),
                    c.nameUrl == "other-non-operating-expense" ? (p(), h(A, { key: 0 }, [
                      t[6] || (t[6] = a("br", null, null, -1)),
                      t[7] || (t[7] = a("small", { class: "text-secondary fst-italic" }, "(Unmapped GL Accounts)", -1))
                    ], 64)) : P("", !0)
                  ]),
                  a("td", null, [
                    a("div", dme, [
                      a("table", cme, [
                        a("tbody", null, [
                          (p(!0), h(A, null, D(e.assignedGlAccounts(c.id), (u) => (p(), h("tr", null, [
                            a("td", ume, g(u.name), 1),
                            a("td", pme, [
                              c.nameUrl == "other-non-operating-expense" ? (p(), h("button", {
                                key: 0,
                                type: "button",
                                class: "btn btn-outline-eclipse btn-sm",
                                onClick: (m) => e.linkAccountMap(u, c)
                              }, t[8] || (t[8] = [
                                a("i", { class: "fa-light fa-link me-2" }, null, -1),
                                y("Link")
                              ]), 8, hme)) : (p(), h("button", {
                                key: 1,
                                type: "button",
                                class: "btn btn-outline-eclipse btn-sm",
                                onClick: (m) => e.editAccountMap(u, c)
                              }, t[9] || (t[9] = [
                                a("i", { class: "fa-light fa-pen-to-square me-2" }, null, -1),
                                y("Edit")
                              ]), 8, mme))
                            ])
                          ]))), 256))
                        ])
                      ])
                    ])
                  ])
                ]))), 256))
              ])
            ])
          ])
        ])
      ])
    ]),
    a("div", fme, [
      a("div", gme, [
        a("div", vme, [
          a("div", yme, [
            a("h1", bme, [
              e.addingNew ? (p(), h(A, { key: 0 }, [
                y(" Create new Rescover Account ")
              ], 64)) : e.editingLink ? (p(), h(A, { key: 1 }, [
                y(" Edit Account Mapping ")
              ], 64)) : (p(), h(A, { key: 2 }, [
                y(" Link GL Account to Rescover ")
              ], 64))
            ]),
            t[12] || (t[12] = a("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            }, null, -1))
          ]),
          a("div", Ame, [
            e.editError ? (p(), h("div", wme, g(e.editError), 1)) : P("", !0),
            a("div", Cme, [
              t[13] || (t[13] = a("label", { class: "col-sm-3 col-form-label fw-bold" }, " GL Account ", -1)),
              a("div", Sme, [
                a("div", Pme, g((l = e.selectedGlAccount) == null ? void 0 : l.name), 1)
              ])
            ]),
            e.addingNew ? (p(), h("div", kme, [
              t[15] || (t[15] = a("label", { class: "col-sm-3 col-form-label fw-bold" }, " Create New ", -1)),
              a("div", Eme, [
                V(a("select", {
                  class: "form-select",
                  "onUpdate:modelValue": t[0] || (t[0] = (c) => e.newAccountType = c)
                }, t[14] || (t[14] = [
                  a("option", { value: "expense" }, "Expense", -1),
                  a("option", { value: "nonOperatingExpense" }, "Non-Operating Expense", -1)
                ]), 512), [
                  [We, e.newAccountType]
                ])
              ]),
              a("div", Ime, [
                V(a("input", {
                  type: "text",
                  class: "form-control",
                  "onUpdate:modelValue": t[1] || (t[1] = (c) => e.newAccountName = c)
                }, null, 512), [
                  [_e, e.newAccountName]
                ])
              ])
            ])) : (p(), h("div", Tme, [
              t[20] || (t[20] = a("label", { class: "col-sm-3 col-form-label fw-bold" }, " Rescover Account ", -1)),
              a("div", Ome, [
                e.expenseAccounts.length > 0 ? (p(), h("div", Rme, [
                  a("button", Lme, [
                    e.selectedAccountType == "income" ? (p(), h("span", Bme, "Income")) : P("", !0),
                    e.selectedAccountType == "expense" ? (p(), h("span", Mme, "Expense")) : (p(), h("span", xme, "Non-Operating Expense")),
                    y(" " + g((d = e.selectedAccount) == null ? void 0 : d.name), 1)
                  ]),
                  a("ul", Fme, [
                    e.selectedAccountType == "income" ? (p(!0), h(A, { key: 0 }, D(e.incomeAccountsSorted, (c) => (p(), h("li", null, [
                      a("button", {
                        type: "button",
                        class: "dropdown-item",
                        onClick: (u) => e.selectRescoverAccount(c)
                      }, [
                        t[16] || (t[16] = a("span", { class: "badge rounded-pill text-bg-warning me-2" }, "Income", -1)),
                        y(" " + g(c.name), 1)
                      ], 8, Vme)
                    ]))), 256)) : (p(!0), h(A, { key: 1 }, D(e.expenseAccountsSorted, (c) => (p(), h("li", null, [
                      a("button", {
                        type: "button",
                        class: "dropdown-item",
                        onClick: (u) => e.selectRescoverAccount(c)
                      }, [
                        c.nonOperating ? (p(), h("span", Nme, "Non-Operating Expense")) : (p(), h("span", jme, "Expense")),
                        y(" " + g(c.name), 1)
                      ], 8, Dme)
                    ]))), 256))
                  ])
                ])) : P("", !0),
                e.expenseAccounts.length > 0 ? (p(), Fe(o, {
                  key: 1,
                  modelValue: e.selectedAccount,
                  "onUpdate:modelValue": t[2] || (t[2] = (c) => e.selectedAccount = c),
                  filter: "",
                  options: e.expenseAccountsSorted,
                  optionLabel: "name",
                  placeholder: "Select an Account",
                  "append-to": "self",
                  class: "w-100"
                }, {
                  value: ve((c) => [
                    c.value ? (p(), h(A, { key: 0 }, [
                      t[17] || (t[17] = a("span", { class: "badge rounded-pill text-bg-success me-2" }, "Income", -1)),
                      y(" " + g(c.value.name), 1)
                    ], 64)) : (p(), h(A, { key: 1 }, [
                      y(g(c.placeholder), 1)
                    ], 64))
                  ]),
                  option: ve((c) => [
                    t[18] || (t[18] = a("span", { class: "badge rounded-pill text-bg-success me-2" }, "Income", -1)),
                    y(" " + g(c.option.name), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue", "options"])) : P("", !0),
                a("button", {
                  type: "button",
                  class: "btn btn-link",
                  onClick: t[3] || (t[3] = (c) => e.addAccountFromGl(e.selectedAccount, "expense"))
                }, t[19] || (t[19] = [
                  a("i", { class: "fa-light fa-plus me-2" }, null, -1),
                  y("Add new Rescover account ")
                ]))
              ])
            ]))
          ]),
          a("div", Hme, [
            t[21] || (t[21] = a("button", {
              type: "button",
              class: "btn btn-secondary",
              "data-bs-dismiss": "modal"
            }, "Cancel", -1)),
            e.addingNew ? (p(), h("button", {
              key: 0,
              type: "button",
              class: "btn btn-lava ms-auto",
              onClick: t[4] || (t[4] = (...c) => e.addAndAssign && e.addAndAssign(...c))
            }, "Add & Assign")) : (p(), h("button", {
              key: 1,
              type: "button",
              class: "btn btn-lava ms-auto",
              onClick: t[5] || (t[5] = (...c) => e.updateMapping && e.updateMapping(...c))
            }, "Update"))
          ])
        ])
      ])
    ], 512)
  ], 64);
}
const gls = /* @__PURE__ */ Ae(tme, [["render", Ume]]), zme = me({
  name: "PmConnection",
  props: {},
  components: {
    DataTable: yn,
    Column: bn
  },
  data() {
    return {
      loading: !0,
      settings: {},
      page: 1,
      pageSize: 10,
      totalLogs: 0,
      logs: [],
      busy: !0
    };
  },
  computed: {},
  methods: {
    number: Ve,
    dateTime: nf,
    async loadRentvineSettings() {
      try {
        this.busy = !0;
        const e = await W.api.rentvineIntegration.getSettings();
        if (e.data.status != de.Success)
          throw new Error(e.data.message);
        this.settings = e.data.settings ?? {};
      } catch (e) {
        Se(e.message);
      } finally {
        this.busy = !1;
      }
    },
    async verifyRentvine(e) {
      try {
        this.busy = !0;
        const t = await W.api.rentvineIntegration.updateSettings(this.settings);
        if (t.data.status != de.Success)
          throw new Le(t);
        this.settings = t.data.settings ?? {}, wt("Rentvine successfully verified and saved!");
      } catch (t) {
        (!Zt.isModelStateException(t) || !t.showFormErrors(e.target)) && Se(t);
      } finally {
        this.busy = !1;
      }
    },
    async unlinkRentvine(e) {
      try {
        this.busy = !0;
        const t = await W.api.rentvineIntegration.disconnect();
        if (t.data.status != de.Success)
          throw new Le(t);
        this.settings.configured = !1, this.settings.apiSecret = void 0, this.settings.accountSynced = void 0, this.settings.clients = void 0, this.settings.nextSync = void 0, this.settings.portfolios = void 0, this.settings.properties = void 0, this.settings.transactionSynced = void 0;
      } catch (t) {
        (!Zt.isModelStateException(t) || !t.showFormErrors(e.target)) && Se(t);
      } finally {
        this.busy = !1;
      }
    },
    async onPage(e) {
      this.page = e.page + 1, await this.refreshLogs();
    },
    async onSort(e) {
      console.log(`${this.$options.name}.onSort`, e);
    },
    async refreshLogs() {
      try {
        this.loading = !0, this.logs.length = 0;
        const e = await W.api.rentvineIntegration.getLogs(this.page != 1 ? this.page : void 0, this.pageSize != 5 ? this.pageSize : void 0);
        if (e.data.status != de.Success)
          throw new Error(e.data.message);
        this.totalLogs = e.data.total, this.logs.length = 0, e.data.page && this.logs.push(...e.data.page);
      } catch (e) {
        Se(e);
      }
      this.loading = !1;
    }
  },
  mounted() {
    this.loadRentvineSettings(), this.refreshLogs();
  }
}), Wme = { class: "fw-bold fs-3 mb-3" }, Gme = { class: "row g-3 mb-3" }, Yme = { class: "col-lg-6" }, Xme = { class: "card shadow-sm h-100" }, qme = { class: "card-body" }, Qme = { class: "mb-3" }, Kme = { class: "input-group" }, Zme = ["disabled"], Jme = { class: "mb-3" }, $me = {
  class: "form-label",
  for: "apiKey"
}, _me = ["disabled"], efe = { class: "mb-3" }, tfe = {
  class: "form-label",
  for: "apiSecret"
}, sfe = { class: "input-group" }, afe = ["disabled"], nfe = ["disabled"], rfe = ["disabled"], ofe = { class: "col-lg-6" }, ife = { class: "card shadow-sm h-100" }, lfe = { class: "card-body" }, dfe = { class: "table table-bordered mb-0" }, cfe = { key: 0 }, ufe = { class: "card-body border-top" }, pfe = { class: "table table-bordered mb-0" }, hfe = { class: "row" }, mfe = { class: "col" }, ffe = { class: "card shadow-sm" }, gfe = { class: "card-body border-top" }, vfe = { class: "text-body-tertiary fw-bold" };
function yfe(e, t, s, n, r, i) {
  var d, c, u, m, f, v, b, w, S, I, T, x, k, C, O, E;
  const o = pe("Column"), l = pe("data-table");
  return p(), h(A, null, [
    a("h2", Wme, g(e.$t("t-pm-connection")), 1),
    a("div", Gme, [
      a("div", Yme, [
        a("div", Xme, [
          a("div", qme, [
            P("", !0),
            a("div", Qme, [
              t[10] || (t[10] = a("label", {
                class: "form-label",
                for: "accountName"
              }, "Rentvine Subdomain", -1)),
              a("div", Kme, [
                t[8] || (t[8] = a("span", { class: "input-group-text" }, [
                  a("i", { class: "fa-light fa-globe" })
                ], -1)),
                V(a("input", {
                  type: "text",
                  class: "form-control",
                  id: "accountName",
                  "onUpdate:modelValue": t[0] || (t[0] = (B) => e.settings.accountName = B),
                  placeholder: "ex. subdomain",
                  disabled: e.settings.configured
                }, null, 8, Zme), [
                  [_e, e.settings.accountName]
                ]),
                t[9] || (t[9] = a("span", { class: "input-group-text" }, ".rentvine.com", -1))
              ])
            ]),
            a("div", Jme, [
              a("label", $me, g(e.$t("t-api-key")), 1),
              V(a("input", {
                type: "text",
                class: "form-control",
                id: "apiKey",
                "onUpdate:modelValue": t[1] || (t[1] = (B) => e.settings.apiKey = B),
                placeholder: "API Key",
                disabled: e.settings.configured
              }, null, 8, _me), [
                [_e, e.settings.apiKey]
              ])
            ]),
            a("div", efe, [
              a("label", tfe, g(e.$t("t-api-secret")), 1),
              a("div", sfe, [
                V(a("input", {
                  type: "text",
                  class: "form-control",
                  id: "apiSecret",
                  "onUpdate:modelValue": t[2] || (t[2] = (B) => e.settings.apiSecret = B),
                  placeholder: "API Secret",
                  disabled: e.settings.configured
                }, null, 8, afe), [
                  [_e, e.settings.apiSecret]
                ]),
                e.settings.configured ? (p(), h("button", {
                  key: 0,
                  class: "btn btn-outline-danger",
                  onClick: t[3] || (t[3] = (...B) => e.unlinkRentvine && e.unlinkRentvine(...B)),
                  type: "button",
                  disabled: e.busy
                }, g(e.$t("Remove")), 9, nfe)) : (p(), h("button", {
                  key: 1,
                  class: "btn btn-eclipse",
                  onClick: t[4] || (t[4] = (...B) => e.verifyRentvine && e.verifyRentvine(...B)),
                  disabled: e.busy
                }, g(e.$t("Verify")), 9, rfe))
              ])
            ]),
            t[11] || (t[11] = a("div", {
              class: "alert alert-danger m-3 d-none",
              "data-val-summary": ""
            }, null, -1))
          ])
        ])
      ]),
      a("div", ofe, [
        a("div", ife, [
          a("div", lfe, [
            t[14] || (t[14] = a("p", { class: "fw-bold" }, [
              a("i", { class: "fa-light fa-arrows-rotate me-2" }),
              y("Sync Time")
            ], -1)),
            a("table", dfe, [
              a("tbody", null, [
                a("tr", null, [
                  t[12] || (t[12] = a("th", null, "Last Sync Time", -1)),
                  a("td", null, [
                    (d = e.settings) != null && d.accountSynced ? (p(), h(A, { key: 0 }, [
                      y(g(e.dateTime((c = e.settings) == null ? void 0 : c.accountSynced)), 1)
                    ], 64)) : (p(), h(A, { key: 1 }, [
                      y(" N/A ")
                    ], 64))
                  ])
                ]),
                (u = e.settings) != null && u.nextSync ? (p(), h("tr", cfe, [
                  t[13] || (t[13] = a("th", null, "Next Sync Time", -1)),
                  a("td", null, g(e.dateTime((m = e.settings) == null ? void 0 : m.nextSync)), 1)
                ])) : P("", !0)
              ])
            ])
          ]),
          a("div", ufe, [
            t[19] || (t[19] = a("p", { class: "fw-bold" }, [
              a("i", { class: "fa-light fa-cloud-arrow-down me-2" }),
              y("Imported")
            ], -1)),
            a("table", pfe, [
              t[18] || (t[18] = a("thead", null, [
                a("tr", null, [
                  a("th"),
                  a("th", null, "Total"),
                  a("th", null, "Imported")
                ])
              ], -1)),
              a("tbody", null, [
                a("tr", null, [
                  t[15] || (t[15] = a("th", null, "Clients", -1)),
                  a("td", null, g((v = (f = e.settings) == null ? void 0 : f.clients) == null ? void 0 : v.total), 1),
                  a("td", null, g((w = (b = e.settings) == null ? void 0 : b.clients) == null ? void 0 : w.imported), 1)
                ]),
                a("tr", null, [
                  t[16] || (t[16] = a("th", null, "Portfolios", -1)),
                  a("td", null, g((I = (S = e.settings) == null ? void 0 : S.portfolios) == null ? void 0 : I.total), 1),
                  a("td", null, g((x = (T = e.settings) == null ? void 0 : T.portfolios) == null ? void 0 : x.imported), 1)
                ]),
                a("tr", null, [
                  t[17] || (t[17] = a("th", null, "Properties", -1)),
                  a("td", null, g((C = (k = e.settings) == null ? void 0 : k.properties) == null ? void 0 : C.total), 1),
                  a("td", null, g((E = (O = e.settings) == null ? void 0 : O.properties) == null ? void 0 : E.imported), 1)
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    a("div", hfe, [
      a("div", mfe, [
        a("div", ffe, [
          a("div", gfe, [
            t[23] || (t[23] = a("p", { class: "fw-bold" }, [
              a("i", { class: "fa-light fa-not-equal me-2" }),
              y("Sync Logs")
            ], -1)),
            N(l, {
              value: e.logs,
              lazy: !0,
              paginator: !0,
              rows: e.pageSize,
              dataKey: "id",
              totalRecords: e.totalLogs,
              loading: e.loading,
              paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport",
              stripedRows: "",
              rowsPerPageOptions: [10, 25, 50],
              currentPageReportTemplate: "Showing {first} to {last} of {totalRecords} entries",
              onPage: t[5] || (t[5] = (B) => e.onPage(B)),
              onSort: t[6] || (t[6] = (B) => e.onSort(B)),
              sortField: "created",
              sortOrder: -1
            }, {
              empty: ve(() => t[20] || (t[20] = [
                y(" No logs found. ")
              ])),
              loading: ve(() => t[21] || (t[21] = [
                a("div", { class: "bg-accentgreenblue rounded-pill px-3 py-1 text-white" }, [
                  a("span", {
                    class: "spinner-border spinner-border-sm me-2",
                    role: "status",
                    "aria-hidden": "true"
                  }),
                  y("Retrieving logs. ")
                ], -1)
              ])),
              default: ve(() => [
                N(o, {
                  field: "name",
                  header: "Message"
                }, {
                  body: ve((B) => [
                    a("small", vfe, g(e.dateTime(B.data.created)), 1),
                    t[22] || (t[22] = a("br", null, null, -1)),
                    y(" " + g(B.data.message), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["value", "rows", "totalRecords", "loading"])
          ])
        ])
      ])
    ])
  ], 64);
}
const vls = /* @__PURE__ */ Ae(zme, [["render", yfe]]), bfe = me({
  name: "Personalization",
  props: {},
  data() {
    return {
      busy: !0,
      emailTemplate: void 0
    };
  },
  computed: {
    ...at(Te),
    ...q(Te, ["access", "aclLoaded"])
  },
  methods: {
    async loadEmailTemplate() {
      try {
        this.busy = !0;
        const e = await W.api.analysisRequests.getEmailTemplate();
        if (e.data.status != de.Success)
          throw new Error(e.data.message);
        this.emailTemplate = e.data.emailTemplate;
      } catch (e) {
        Se("List Linked Accounts Error " + e.message);
      }
      this.busy = !1;
    },
    async updateEmailTemplate() {
      try {
        this.busy = !0;
        const e = await W.api.analysisRequests.updateEmailTemplate(this.emailTemplate);
        if (e.data.status != de.Success)
          throw new Error(e.data.message);
        wt("Analysis Template Saved Sucessfully");
      } catch (e) {
        Se("Analysis Template Error " + e.message);
      }
      this.busy = !1;
    }
  },
  created() {
  },
  mounted() {
    this.aclLoaded.then(() => {
      this.loadEmailTemplate();
    });
  }
}), Afe = { class: "row g-3" }, wfe = { class: "col" }, Cfe = { class: "card shadow" }, Sfe = { class: "card-body" }, Pfe = { class: "d-flex justify-content-end mt-5" }, kfe = ["disabled"];
function Efe(e, t, s, n, r, i) {
  return p(), h("div", Afe, [
    t[4] || (t[4] = a("div", { class: "col-12" }, [
      a("h2", { class: "fw-bold fs-3 mb-0" }, "Property Performance Engine Default Message")
    ], -1)),
    a("div", wfe, [
      a("div", Cfe, [
        t[3] || (t[3] = a("div", { class: "card-header border-0 bg-white fw-bold fs-5 py-3" }, " Analysis Request Message Template ", -1)),
        a("div", Sfe, [
          a("div", null, [
            t[2] || (t[2] = a("label", {
              for: "exampleFormControlTextarea1",
              class: "form-label"
            }, "Message:", -1)),
            V(a("textarea", {
              class: "form-control",
              id: "exampleFormControlTextarea1",
              rows: "10",
              "onUpdate:modelValue": t[0] || (t[0] = (o) => e.emailTemplate = o)
            }, null, 512), [
              [_e, e.emailTemplate]
            ])
          ]),
          a("div", Pfe, [
            a("button", {
              type: "button",
              class: "btn btn-lava",
              onClick: t[1] || (t[1] = (...o) => e.updateEmailTemplate && e.updateEmailTemplate(...o)),
              disabled: e.busy
            }, "Save changes", 8, kfe)
          ])
        ])
      ])
    ])
  ]);
}
const yls = /* @__PURE__ */ Ae(bfe, [["render", Efe]]), Ife = me({
  name: "LeadAssignment",
  props: {},
  data() {
    return {
      busy: !0,
      loadingAccounts: !0,
      linked: [],
      notificationType: Lf.Mass
    };
  },
  computed: {
    crmConfigured() {
      var e;
      return ((e = this.userInfo) == null ? void 0 : e.crmProvider) != null;
    },
    disableNotificationStyle() {
      return this.linked.length <= 1;
    },
    notificationTypeValue: {
      get() {
        return this.notificationType;
      },
      set(e) {
        this.notificationType = this.disableNotificationStyle == !1 ? e : Lf.Mass;
      }
    },
    ...at(Te, ct, Mn),
    ...q(Te, ["access", "aclLoaded"]),
    ...q(ct, ["userInfo"])
  },
  methods: {
    async loadLeadAssignments() {
      try {
        this.busy = !0, this.loadingAccounts = !0, this.linked.length = 0;
        const e = await W.api.analysisRequests.getLeadAssignments();
        if (e.data.status != de.Success)
          throw new Error(e.data.message);
        e.data.accounts && this.linked.push(...e.data.accounts);
        const t = await W.api.analysisRequests.getNotificationStyle();
        if (t.data.status != de.Success)
          throw new Error(t.data.message);
        this.notificationType = t.data.notificationType ?? Lf.Mass;
      } catch (e) {
        Se(e);
      }
      this.busy = !1, this.loadingAccounts = !1;
    },
    async updateLeadAssignments() {
      try {
        this.busy = !0;
        const e = {
          accounts: this.linked.map((n) => ({
            id: n.id,
            isBdm: n.isBdm
          }))
        }, t = await W.api.analysisRequests.updateLeadAssignments(e);
        if (t.data.status != de.Success)
          throw new Error(t.data.message);
        const s = await W.api.analysisRequests.updateNotificationStyle({
          notificationType: this.notificationType
        });
        if (s.data.status != de.Success)
          throw new Error(s.data.message);
        wt("Saved Sucessfully");
      } catch (e) {
        Se(e.message);
      }
      this.busy = !1;
    }
  },
  created() {
  },
  mounted() {
    this.aclLoaded.then(this.accountStore.fetchUserSettings).then(this.loadLeadAssignments), document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach((e) => bootstrap.Tooltip.getOrCreateInstance(e));
  }
}), Tfe = { class: "row g-3" }, Ofe = { class: "col-12" }, Rfe = { class: "card shadow" }, Lfe = {
  key: 0,
  class: "table-responsive"
}, Bfe = { class: "table" }, Mfe = { class: "text-center" }, xfe = ["onUpdate:modelValue"], Ffe = {
  key: 1,
  class: "card-body"
}, Vfe = { class: "col-lg-6" }, Dfe = { class: "card shadow" }, Nfe = { class: "card-body" }, jfe = { class: "form-check" }, Hfe = ["disabled"], Ufe = { class: "form-check" }, zfe = ["disabled"], Wfe = { class: "col-12" }, Gfe = { class: "d-flex justify-content-end" }, Yfe = ["disabled"];
function Xfe(e, t, s, n, r, i) {
  return p(), h("div", Tfe, [
    t[9] || (t[9] = a("div", { class: "col-12" }, [
      a("h2", { class: "fw-bold fs-3 mb-0" }, "Lead Assignment")
    ], -1)),
    a("div", Ofe, [
      a("div", Rfe, [
        e.loadingAccounts ? (p(), h("div", Ffe, t[4] || (t[4] = [
          a("i", { class: "fa-duotone fa-solid fa-compass fa-spin me-2" }, null, -1),
          y("Loading lead assignments... ")
        ]))) : (p(), h("div", Lfe, [
          a("table", Bfe, [
            t[3] || (t[3] = a("thead", null, [
              a("tr", null, [
                a("th", null, "Name"),
                a("th", null, "Email"),
                a("th", { class: "text-center" }, "Assignable?")
              ])
            ], -1)),
            a("tbody", null, [
              (p(!0), h(A, null, D(e.linked, (o) => (p(), h("tr", {
                key: o.id
              }, [
                a("td", null, g(o.firstName) + " " + g(o.lastName), 1),
                a("td", null, g(o.email), 1),
                a("td", Mfe, [
                  V(a("input", {
                    class: "form-check-input",
                    type: "checkbox",
                    "onUpdate:modelValue": (l) => o.isBdm = l,
                    id: "flexCheck",
                    "aria-label": "Assignable"
                  }, null, 8, xfe), [
                    [Ue, o.isBdm]
                  ])
                ])
              ]))), 128))
            ])
          ])
        ]))
      ])
    ]),
    a("div", Vfe, [
      a("div", Dfe, [
        a("div", Nfe, [
          t[7] || (t[7] = a("p", { class: "card-title fw-bold fs-5" }, "Rental Request Notifications Style", -1)),
          t[8] || (t[8] = a("p", { class: "card-text" }, "Shotgun will send a notification to all assignable users, Round Robin will send a notification to the next assignable user.", -1)),
          a("div", jfe, [
            V(a("input", {
              class: "form-check-input",
              type: "radio",
              name: "rentalAnalysisNotification",
              id: "rentalAnalysisNotification1",
              "onUpdate:modelValue": t[0] || (t[0] = (o) => e.notificationTypeValue = o),
              value: "mass",
              disabled: e.disableNotificationStyle
            }, null, 8, Hfe), [
              [Mt, e.notificationTypeValue]
            ]),
            t[5] || (t[5] = a("label", {
              class: "form-check-label",
              for: "rentalAnalysisNotification1"
            }, " Shotgun ", -1))
          ]),
          a("div", Ufe, [
            V(a("input", {
              class: "form-check-input",
              type: "radio",
              name: "rentalAnalysisNotification",
              id: "rentalAnalysisNotification2",
              "onUpdate:modelValue": t[1] || (t[1] = (o) => e.notificationTypeValue = o),
              value: "roundRobin",
              disabled: e.disableNotificationStyle
            }, null, 8, zfe), [
              [Mt, e.notificationTypeValue]
            ]),
            t[6] || (t[6] = a("label", {
              class: "form-check-label",
              for: "rentalAnalysisNotification2"
            }, " Round Robin ", -1))
          ])
        ])
      ])
    ]),
    a("div", Wfe, [
      a("div", Gfe, [
        a("button", {
          type: "button",
          class: "btn btn-lava",
          onClick: t[2] || (t[2] = (...o) => e.updateLeadAssignments && e.updateLeadAssignments(...o)),
          disabled: e.busy
        }, "Save changes", 8, Yfe)
      ])
    ])
  ]);
}
const bls = /* @__PURE__ */ Ae(Ife, [["render", Xfe]]), qfe = me({
  name: "automation",
  props: {},
  data() {
    return {
      isLoading: !0,
      automationSettings: void 0
    };
  },
  computed: {
    isActiveCampaign() {
      var e;
      return ((e = this.userInfo) == null ? void 0 : e.crmProvider) == bt.ActiveCampaign;
    },
    disableAutoSendToCrm() {
      var e;
      return (e = this.automationSettings) == null ? void 0 : e.disableAutoSendToCrm;
    },
    skipTraceAbandoned: {
      get() {
        var e;
        return ((e = this.automationSettings) == null ? void 0 : e.skipTraceAbandoned) ?? !1;
      },
      set(e) {
        this.automationSettings.skipTraceAbandoned = e;
      }
    },
    autoRelease: {
      get() {
        var e;
        return ((e = this.automationSettings) == null ? void 0 : e.autoRelease) ?? "off";
      },
      set(e) {
        this.automationSettings.autoRelease = e;
      }
    },
    autoSendToCrm: {
      get() {
        var e;
        return ((e = this.automationSettings) == null ? void 0 : e.autoSendToCrm) ?? !1;
      },
      set(e) {
        this.automationSettings.autoSendToCrm = e;
      }
    },
    ...at(Te, ct),
    ...q(Te, ["access", "aclLoaded"]),
    ...q(ct, ["userInfo"])
  },
  methods: {
    async getSettings() {
      try {
        const e = await W.api.analysisRequests.getAutomationSettings();
        if (e.data.status != de.Success)
          throw new Error(e.data.message);
        this.automationSettings = e.data;
      } catch (e) {
        Se(e);
      }
      this.isLoading = !1;
    },
    async updateSettings() {
      try {
        this.isLoading = !0;
        const e = {
          autoSendToCrm: this.automationSettings.autoSendToCrm,
          skipTraceAbandoned: this.automationSettings.skipTraceAbandoned,
          autoRelease: this.automationSettings.autoRelease
        }, t = await W.api.analysisRequests.updateAutomationSettings(e);
        if (t.data.status != de.Success)
          throw new Error(t.data.message);
        wt("Settings saved successfully!");
      } catch (e) {
        Se(e);
      }
      this.isLoading = !1;
    }
  },
  created() {
  },
  mounted() {
    this.aclLoaded.then(this.accountStore.fetchUserSettings).then(this.getSettings);
  }
}), Qfe = { class: "row g-3" }, Kfe = { class: "col-lg-7" }, Zfe = { class: "card shadow" }, Jfe = { class: "card-body" }, $fe = { class: "form-check form-switch form-switch-lg form-check-reverse text-start" }, _fe = { class: "card-body border-top" }, ege = { class: "form-check form-switch form-switch-lg form-check-reverse text-start" }, tge = ["disabled"], sge = {
  key: 0,
  class: "alert alert-warning mt-2 mb-0"
}, age = { class: "card-body border-top" }, nge = { class: "row" }, rge = { class: "col" }, oge = { class: "card-footer bg-white d-flex justify-content-end" }, ige = ["disabled"];
function lge(e, t, s, n, r, i) {
  return p(), h("div", Qfe, [
    t[11] || (t[11] = a("div", { class: "col-12" }, [
      a("h2", { class: "fw-bold fs-3 mb-0" }, "Automation Settings")
    ], -1)),
    a("div", Kfe, [
      a("div", Zfe, [
        a("div", Jfe, [
          a("div", $fe, [
            t[4] || (t[4] = a("label", {
              for: "skiptrace",
              class: "form-check-label"
            }, "Auto Skip Trace abandoned forms?", -1)),
            V(a("input", {
              type: "checkbox",
              id: "skiptrace",
              class: "form-check-input",
              "onUpdate:modelValue": t[0] || (t[0] = (o) => e.skipTraceAbandoned = o)
            }, null, 512), [
              [Ue, e.skipTraceAbandoned]
            ])
          ]),
          t[5] || (t[5] = a("div", {
            class: "alert alert-warning mt-2 mb-0",
            role: "alert"
          }, [
            a("i", { class: "fa-duotone fa-solid fa-triangle-exclamation me-2" }),
            y("Enabling auto skip trace may charge up to 10¢ per valid skip trace. ")
          ], -1))
        ]),
        a("div", _fe, [
          a("div", ege, [
            t[6] || (t[6] = a("label", {
              for: "addcrm",
              class: "form-check-label"
            }, "Automatically add PPE leads to CRM?", -1)),
            V(a("input", {
              type: "checkbox",
              id: "addcrm",
              class: "form-check-input",
              "onUpdate:modelValue": t[1] || (t[1] = (o) => e.autoSendToCrm = o),
              disabled: e.disableAutoSendToCrm
            }, null, 8, tge), [
              [Ue, e.autoSendToCrm]
            ])
          ]),
          t[8] || (t[8] = a("ul", { class: "list-unstyled mb-0" }, [
            a("li", null, [
              a("i", { class: "fa-duotone fa-solid fa-caret-right me-2" }),
              y("Single-user or round robin assignment required.")
            ])
          ], -1)),
          e.isActiveCampaign ? (p(), h("div", sge, t[7] || (t[7] = [
            a("i", { class: "fa-light fa-triangle-exclamation me-2" }, null, -1),
            y("Contacts with missing email addresses will have randomly generated emails assigned to their lead to comply with Active Campaign requirements for creating leads.")
          ]))) : P("", !0)
        ]),
        a("div", age, [
          a("div", nge, [
            t[10] || (t[10] = a("label", {
              for: "autoRelease",
              class: "col-sm-6 col-form-label"
            }, "Auto release ", -1)),
            a("div", rge, [
              V(a("select", {
                class: "form-select",
                id: "autoRelease",
                "onUpdate:modelValue": t[2] || (t[2] = (o) => e.autoRelease = o)
              }, t[9] || (t[9] = [
                a("option", { value: "off" }, "Off", -1),
                a("option", { value: "immediate" }, "Immediate", -1),
                a("option", { value: "after60Minutes" }, "After 60 minutes", -1)
              ]), 512), [
                [We, e.autoRelease]
              ])
            ])
          ])
        ]),
        a("div", oge, [
          a("button", {
            type: "button",
            class: "btn btn-lava",
            onClick: t[3] || (t[3] = (...o) => e.updateSettings && e.updateSettings(...o)),
            disabled: e.isLoading
          }, "Save changes", 8, ige)
        ])
      ])
    ])
  ]);
}
const Als = /* @__PURE__ */ Ae(qfe, [["render", lge]]), dge = "How's My Property Performing?", cge = "Let our team create a comprehensive analysis of how your property will perform as a rental using our Property Performance Engine.", uge = "A member of our management team is reviewing your property and will send your analysis shortly!", pge = me({
  name: "WidgetSettings",
  props: {},
  data() {
    return {
      busy: !0,
      previousHeading: void 0,
      previousSubHeading: void 0,
      previousFinalMessage: void 0,
      env: window.api_env,
      widgetKey: void 0,
      widgetSettingsModel: {
        headingTemplate: void 0,
        subHeadingTemplate: void 0,
        finalMessageTemplate: void 0
      }
    };
  },
  computed: {
    heading: {
      get() {
        return this.widgetSettingsModel.headingTemplate ?? dge;
      },
      set(e) {
        this.widgetSettingsModel.headingTemplate = e, this.widgetSettingsModel.headingTemplate.length > 85 && (this.widgetSettingsModel.headingTemplate = this.widgetSettingsModel.headingTemplate.substring(0, 85));
      }
    },
    subHeading: {
      get() {
        return this.widgetSettingsModel.subHeadingTemplate ?? cge;
      },
      set(e) {
        this.widgetSettingsModel.subHeadingTemplate = e, this.widgetSettingsModel.subHeadingTemplate.length > 160 && (this.widgetSettingsModel.subHeadingTemplate = this.widgetSettingsModel.subHeadingTemplate.substring(0, 160));
      }
    },
    finalMessage: {
      get() {
        return this.widgetSettingsModel.finalMessageTemplate ?? uge;
      },
      set(e) {
        var t;
        this.widgetSettingsModel.finalMessageTemplate = e, ((t = this.widgetSettingsModel.finalMessageTemplate) == null ? void 0 : t.length) > 160 && (this.widgetSettingsModel.finalMessageTemplate = this.widgetSettingsModel.finalMessageTemplate.substring(0, 160));
      }
    },
    canPreview() {
      return this.widgetSettingsModel.headingTemplate != this.previousHeading || this.widgetSettingsModel.subHeadingTemplate != this.previousSubHeading || this.widgetSettingsModel.finalMessageTemplate != this.previousFinalMessage;
    },
    ...at(Te),
    ...q(Te, ["access", "aclLoaded"])
  },
  methods: {
    async loadWidgetKey() {
      try {
        const e = await W.api.account.info();
        if (e.data.status != de.Success)
          throw new Error(e.data.message);
        this.widgetKey = e.data.info.widgetApiKey;
      } catch (e) {
        Se(e.message);
      }
    },
    async loadWidgetTemplate() {
      try {
        this.busy = !0;
        const e = await W.api.analysisRequests.getWidgetSettings();
        if (e.data.status != de.Success)
          throw new Error(e.data.message);
        this.widgetSettingsModel.headingTemplate = e.data.header, this.widgetSettingsModel.subHeadingTemplate = e.data.subHeader, this.widgetSettingsModel.finalMessageTemplate = e.data.finalText, this.previousHeading = e.data.header, this.previousSubHeading = e.data.subHeader, this.previousFinalMessage = e.data.finalText;
      } catch (e) {
        Se("Get Widget Template Error " + e.message);
      }
      this.busy = !1;
    },
    async updateWidgetTemplate() {
      try {
        this.busy = !0;
        const e = await W.api.analysisRequests.updateWidgetSettings(this.widgetSettingsModel);
        if (e.data.status != de.Success)
          throw new Error(e.data.message);
        this.previousHeading = this.widgetSettingsModel.headingTemplate, this.previousSubHeading = this.widgetSettingsModel.subHeadingTemplate, this.previousFinalMessage = this.widgetSettingsModel.finalMessageTemplate, wt("Saved Sucessfully");
      } catch (e) {
        Se("Update Widget Template Error " + e.message);
      }
      this.busy = !1;
    },
    resetTemplate() {
      this.widgetSettingsModel.headingTemplate = void 0, this.widgetSettingsModel.subHeadingTemplate = void 0, this.widgetSettingsModel.finalMessageTemplate = void 0;
    },
    openPreviewModal() {
      const e = this.$refs.modalPreviewBody;
      e.firstChild && e.firstChild.remove();
      const t = document.createElement("rental-analysis");
      t.setAttribute("api-key", this.widgetKey), this.env && t.setAttribute("env", this.env), e.appendChild(t), bootstrap.Modal.getOrCreateInstance(this.$refs.previewPPEModal).show();
    }
  },
  created() {
  },
  mounted() {
    this.aclLoaded.then(() => {
      this.loadWidgetKey(), this.loadWidgetTemplate();
    });
  }
}), hge = { class: "row" }, mge = { class: "col" }, fge = { class: "card shadow mb-3" }, gge = { class: "card-body" }, vge = { class: "row mb-3" }, yge = { class: "col-md-10" }, bge = ["disabled"], Age = {
  id: "headingHelp",
  class: "form-text text-end"
}, wge = { class: "row mb-3" }, Cge = { class: "col-md-10" }, Sge = ["disabled"], Pge = {
  id: "subheadingHelp",
  class: "form-text text-end"
}, kge = { class: "row mb-3" }, Ege = { class: "col-md-10" }, Ige = ["disabled"], Tge = {
  id: "messageHelp",
  class: "form-text text-end"
}, Oge = { class: "d-flex gap-3" }, Rge = ["disabled"], Lge = ["disabled"], Bge = ["disabled"], Mge = {
  class: "modal fade",
  ref: "previewPPEModal",
  id: "previewPPEModal",
  tabindex: "-1",
  "aria-labelledby": "previewPPEModalLabel",
  "aria-hidden": "true"
}, xge = { class: "modal-dialog modal-xl modal-dialog-centered" }, Fge = { class: "modal-content bg-gradient-alphabet rounded" }, Vge = {
  ref: "modalPreviewBody",
  class: "modal-body"
};
function Dge(e, t, s, n, r, i) {
  return p(), h(A, null, [
    t[10] || (t[10] = a("div", { class: "row mb-3" }, [
      a("div", { class: "col" }, [
        a("h2", { class: "fw-bold fs-3 mb-0" }, "Widget Settings")
      ])
    ], -1)),
    a("div", hge, [
      a("div", mge, [
        a("div", fge, [
          a("div", gge, [
            a("div", vge, [
              t[6] || (t[6] = a("label", {
                for: "inputHeading",
                class: "col-md-2 col-form-label fw-bold"
              }, "Heading", -1)),
              a("div", yge, [
                V(a("textarea", {
                  class: "form-control",
                  id: "inputHeading",
                  rows: "2",
                  "onUpdate:modelValue": t[0] || (t[0] = (o) => e.heading = o),
                  disabled: e.busy,
                  maxlength: "85"
                }, null, 8, bge), [
                  [_e, e.heading]
                ]),
                a("div", Age, g(e.heading.length) + "/85 characters", 1)
              ])
            ]),
            a("div", wge, [
              t[7] || (t[7] = a("label", {
                for: "inputSubheading",
                class: "col-md-2 col-form-label fw-bold"
              }, "Subheading", -1)),
              a("div", Cge, [
                V(a("textarea", {
                  class: "form-control",
                  id: "inputSubheading",
                  rows: "3",
                  "onUpdate:modelValue": t[1] || (t[1] = (o) => e.subHeading = o),
                  disabled: e.busy,
                  maxlength: "160"
                }, null, 8, Sge), [
                  [_e, e.subHeading]
                ]),
                a("div", Pge, g(e.subHeading.length) + "/160 characters", 1)
              ])
            ]),
            a("div", kge, [
              t[8] || (t[8] = a("label", {
                for: "inputMessage",
                class: "col-md-2 col-form-label fw-bold"
              }, "Final Message", -1)),
              a("div", Ege, [
                V(a("textarea", {
                  class: "form-control",
                  id: "inputMessage",
                  rows: "3",
                  "onUpdate:modelValue": t[2] || (t[2] = (o) => e.finalMessage = o),
                  disabled: e.busy,
                  maxlenght: "160"
                }, null, 8, Ige), [
                  [_e, e.finalMessage]
                ]),
                a("div", Tge, g(e.finalMessage.length) + "/160 characters", 1)
              ])
            ])
          ])
        ]),
        a("div", Oge, [
          a("button", {
            type: "button",
            class: "btn btn-outline-eclipse",
            onClick: t[3] || (t[3] = (...o) => e.resetTemplate && e.resetTemplate(...o)),
            disabled: e.busy
          }, "Reset To Defaults", 8, Rge),
          a("button", {
            type: "button",
            onClick: t[4] || (t[4] = (...o) => e.openPreviewModal && e.openPreviewModal(...o)),
            class: "btn btn-bee ms-auto",
            disabled: e.busy || e.canPreview
          }, "Preview", 8, Lge),
          a("button", {
            type: "button",
            class: "btn btn-lava",
            onClick: t[5] || (t[5] = (...o) => e.updateWidgetTemplate && e.updateWidgetTemplate(...o)),
            disabled: e.busy
          }, "Save", 8, Bge)
        ])
      ])
    ]),
    a("div", Mge, [
      a("div", xge, [
        a("div", Fge, [
          t[9] || (t[9] = a("div", { class: "modal-header border-0 pb-0" }, [
            a("span", {
              class: "fw-bold fs-5 modal-title",
              id: "previewFreerentalModalLabel"
            }, "Property Performance Engine"),
            a("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            })
          ], -1)),
          a("div", Vge, null, 512)
        ])
      ])
    ], 512)
  ], 64);
}
const wls = /* @__PURE__ */ Ae(pge, [["render", Dge]]), Nge = me({
  name: "LoadingCard"
}), jge = { class: "align-items-center justify-content-center flex-column loader" };
function Hge(e, t, s, n, r, i) {
  return p(), h("div", jge, t[0] || (t[0] = [
    a("div", { class: "position-absolute top-50 start-50 translate-middle d-flex flex-column align-items-center" }, [
      a("i", { class: "fa-duotone fa-spin fa-compass mb-2" }),
      a("div", null, "Loading...")
    ], -1)
  ]));
}
const qu = /* @__PURE__ */ Ae(Nge, [["render", Hge], ["__scopeId", "data-v-f652dbbf"]]), Uge = "(?:[a-z](?=[A-Z])|[A-Z](?=[A-Z][a-z]))";
function zge(e, t) {
  for (let s = 0, n = e.length; s < n; s++) {
    const r = e[s], i = t[r] && String(t[r]);
    if (i !== void 0) {
      e = e.slice(0, s) + i + e.slice(s + 1);
      const o = i.length - 1;
      s += o, n += o;
    }
  }
  return e;
}
const Wge = (e, t) => e.join(t).toLowerCase(), Gge = /[\u0300-\u036F\u1AB0-\u1AFF\u1DC0-\u1DFF]+/g, Yge = /[A-Za-z\d]+/g, Xge = new RegExp("[A-Za-z\\d]*?" + Uge + "|[A-Za-z\\d]+", "g");
function ci(e, { camelCase: t = !0, dictionary: s, separator: n = "-", transformer: r = Wge } = {}) {
  const i = (s ? zge(String(e), s) : String(e)).normalize("NFKD").replace(Gge, "").match(t ? Xge : Yge);
  return i ? r ? r(i, String(n)) : i.join(String(n)) : "";
}
const Mp = {
  camelCase: !1
}, qge = me({
  name: "RentalAnalysisRequests",
  props: {
    compact: Boolean
  },
  components: {
    DataTable: yn,
    Column: bn,
    ListLoader: uf,
    LoadingCard: qu
  },
  directives: {
    Tooltip: Wo
  },
  data() {
    return {
      currentRequestEventLog: void 0,
      requestToSend: void 0,
      shareAnalysisModel: {
        message: null,
        attachPdf: !1,
        includeSchedulingLink: !1
      },
      skipTraceToken: void 0,
      isBusy: !1
    };
  },
  watch: {
    showArchived() {
      this.analysisRequestsStore.getRequests(1);
    }
  },
  computed: {
    canManageLeads() {
      var e, t;
      return ((t = (e = this.access) == null ? void 0 : e.leads) == null ? void 0 : t.leads) == !0 && this.isClient != !0;
    },
    disableSchedulingLink() {
      return this.hasSchedulingLink == !1;
    },
    ...q(Te, ["access", "aclLoaded", "isClient", "isAdmin", "isUser"]),
    ...q(bm, ["currentPage", "pageSize", "loadingAnalysisRequests", "totalRequests", "analysisRequests", "analysisRequestsError", "hasSchedulingLink", "messageTemplate", "analysisRequestBusy", "showArchived"]),
    ...at(Te, bm)
  },
  methods: {
    number: Ve,
    date: cs,
    async onPage(e) {
      await this.analysisRequestsStore.getRequests(e.page + 1);
    },
    async onSort(e) {
      console.log(`${this.$options.name}.onSort`, e);
    },
    closeRequest() {
      this.currentRequestEventLog = void 0;
    },
    verifySend(e) {
      var t;
      this.requestToSend = e, this.shareAnalysisModel.attachPdf = !1, this.shareAnalysisModel.message = this.messageTemplate, (t = bootstrap.Modal.getOrCreateInstance(this.$refs.modalRequestSend)) == null || t.show();
    },
    async sendRequest() {
      var e;
      try {
        const t = await this.analysisRequestsStore.shareRequest(this.requestToSend.token, this.shareAnalysisModel);
        (e = bootstrap.Modal.getOrCreateInstance(this.$refs.modalRequestSend)) == null || e.hide(), t == !0 && wt("Email sent successfully");
      } catch (t) {
        this.analysisRequestsError = t.message;
      }
    },
    async assignToMe(e) {
      try {
        await this.analysisRequestsStore.assignToMe(e.token) == !0 && wt("Request assigned to your account.");
      } catch (t) {
        this.analysisRequestsError = t.message;
      }
    },
    async archiveRequest(e) {
      try {
        await this.analysisRequestsStore.archiveRequest(e) == !0 && wt("Request archived successfully");
      } catch (t) {
        this.analysisRequestsError = t.message;
      }
    },
    async addCrm(e) {
      try {
        await this.analysisRequestsStore.addCrm(e) && wt("Add to Crm successfully");
      } catch (t) {
        this.analysisRequestsError = t.message;
      }
    },
    async showConfirmSkipTraceModal(e) {
      var t;
      this.skipTraceToken = e, Go("skip-trace-confirmed-v2") == "true" ? this.skipTrace() : (t = bootstrap.Modal.getOrCreateInstance(this.$refs.confirmSkipTraceModal)) == null || t.show();
    },
    async hideConfirmSkipTraceModal() {
      var e;
      this.skipTraceToken = void 0, (e = bootstrap.Modal.getOrCreateInstance(this.$refs.confirmSkipTraceModal)) == null || e.hide();
    },
    async skipTrace() {
      var e;
      try {
        (e = bootstrap.Modal.getOrCreateInstance(this.$refs.confirmSkipTraceModal)) == null || e.hide(), eo("skip-trace-confirmed-v2", !0), await this.analysisRequestsStore.skipTrace(this.skipTraceToken) && wt("Skip Trace successfully");
      } catch (t) {
        this.analysisRequestsError = t.message, console.log("Skip Trace", this.analysisRequestsError);
      }
    },
    viewAnalysis(e) {
      if (e != null && e.token && e.inProgress != !0)
        return `/analysis/${e.token}`;
    },
    viewRequestLogs(e) {
      var t;
      this.currentRequestEventLog = e, (t = bootstrap.Modal.getOrCreateInstance(this.$refs.modalEventLog)) == null || t.show();
    },
    incompleteInfo(e, t) {
      return e == "" && t == "";
    },
    canSend(e) {
      return e != "";
    },
    buildRouteParams(e) {
      return {
        analysisToken: e.token,
        address: ci(e.address, Mp),
        state: ci(e.state, Mp),
        city: ci(e.city, Mp),
        zip: ci(e.zip, Mp)
      };
    }
  },
  mounted() {
    this.compact && (this.analysisRequestsStore.pageSize = 5), this.aclLoaded.then(async () => await this.analysisRequestsStore.getSettings()).then(async () => await this.analysisRequestsStore.getRequests());
  }
}), Xk = "data:image/png;base64,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", Qge = {
  key: 0,
  class: "alert alert-danger"
}, Kge = ["aria-busy"], Zge = {
  key: 0,
  class: "card-header fw-bold border-0 bg-white fs-5 text-body-secondary pb-0 d-flex align-items-center"
}, Jge = { class: "card-body" }, $ge = {
  key: 0,
  class: "badge rounded-pill text-bg-inprogress"
}, _ge = {
  key: 1,
  class: "badge rounded-pill text-bg-incomplete"
}, eve = {
  key: 2,
  class: "badge rounded-pill text-bg-abandoned"
}, tve = {
  key: 3,
  class: "badge rounded-pill text-bg-complete"
}, sve = { class: "small mb-0" }, ave = {
  key: 0,
  class: "fa-duotone fa-solid fa-triangle-exclamation text-warning me-1"
}, nve = { key: 0 }, rve = { class: "d-block text-truncate" }, ove = { key: 0 }, ive = { class: "fa-duotone fa-solid fa-triangle-exclamation text-warning me-2" }, lve = { key: 1 }, dve = { class: "fa-duotone fa-solid fa-bolt-auto text-info me-2" }, cve = { class: "d-block text-truncate" }, uve = { key: 0 }, pve = { class: "fa-duotone fa-solid fa-triangle-exclamation text-warning me-2" }, hve = { key: 1 }, mve = { class: "fa-duotone fa-solid fa-bolt-auto text-info me-2" }, fve = { class: "d-block text-truncate" }, gve = { key: 0 }, vve = { class: "fa-duotone fa-solid fa-triangle-exclamation text-warning me-2" }, yve = {
  key: 1,
  class: "d-block text-truncate"
}, bve = ["disabled", "onClick"], Ave = { key: 0 }, wve = ["onClick"], Cve = ["onClick", "disabled"], Sve = {
  key: 3,
  class: "badge rounded-pill text-bg-warning d-block mb-1"
}, Pve = {
  key: 0,
  class: "fa-duotone fa-solid fa-circle-check text-success"
}, kve = ["onClick"], Eve = { key: 0 }, Ive = ["onClick", "disabled"], Tve = {
  key: 1,
  type: "button",
  class: "btn btn-outline-eclipse btn-sm me-2",
  "data-bs-toggle": "modal",
  "data-bs-target": "#modalPortfolioFinder"
}, Ove = ["onClick", "disabled"], Rve = {
  key: 1,
  class: "card-footer text-end bg-white border-0"
}, Lve = {
  class: "modal fade",
  id: "modalEventLog",
  ref: "modalEventLog",
  tabindex: "-1",
  "aria-labelledby": "modalEventLogLabel",
  "aria-hidden": "true"
}, Bve = { class: "modal-dialog" }, Mve = { class: "modal-content bg-gradient-alphabet rounded" }, xve = { class: "modal-header border-0 pb-0" }, Fve = {
  class: "modal fade",
  id: "modalRequestSend",
  ref: "modalRequestSend",
  tabindex: "-1",
  "aria-labelledby": "modalRequestSendLabel",
  "aria-hidden": "true"
}, Vve = { class: "modal-dialog modal-dialog-centered" }, Dve = { class: "modal-content bg-gradient-alphabet rounded" }, Nve = { class: "modal-body" }, jve = { class: "mb-3" }, Hve = {
  class: "form-label",
  for: "bdmMessage"
}, Uve = { class: "mb-3" }, zve = {
  class: "form-label",
  for: "bdmMessage"
}, Wve = { class: "mb-3" }, Gve = { class: "form-check mb-3" }, Yve = { class: "form-check mb-3" }, Xve = ["disabled"], qve = {
  class: "form-check-label",
  for: "checkScheduling"
}, Qve = {
  key: 0,
  class: "fa-light fa-info-circle ms-2"
}, Kve = { class: "d-flex justify-content-end" }, Zve = ["disabled"], Jve = {
  class: "modal fade",
  id: "confirmSkipTraceModal",
  ref: "confirmSkipTraceModal",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}, $ve = { class: "modal-dialog modal-dialog-centered" }, _ve = { class: "modal-content bg-gradient-alphabet rounded" }, eye = { class: "modal-body text-center px-5 pb-5 pt-4" }, tye = { class: "d-flex gap-3 justify-content-center pt-3" }, sye = {
  key: 0,
  class: "modal-footer text-center justify-content-center bg-accentgreenblue text-white"
};
function aye(e, t, s, n, r, i) {
  var m, f;
  const o = pe("loading-card"), l = pe("Column"), d = pe("router-link"), c = pe("DataTable"), u = Za("tooltip");
  return p(), h(A, null, [
    e.analysisRequestsError ? (p(), h("div", Qge, g(e.analysisRequestsError), 1)) : P("", !0),
    a("div", {
      class: "card shadow-sm overflow-hidden card-ppe-analysis-requests card-ppe",
      "aria-busy": e.loadingAnalysisRequests | e.analysisRequestBusy
    }, [
      N(o),
      e.compact ? (p(), h("div", Zge, t[9] || (t[9] = [
        a("img", {
          src: "https://cdn03.rescover.com/content/images/icons/property-performance-engine-color.svg",
          height: "17",
          class: "me-2 d-none"
        }, null, -1),
        y("PPE Analysis Requests ")
      ]))) : P("", !0),
      a("div", Jge, [
        N(c, {
          value: e.analysisRequests,
          lazy: !0,
          paginator: !e.compact,
          rows: e.pageSize,
          dataKey: "id",
          totalRecords: e.totalRequests,
          loading: e.loadingAnalysisRequests,
          paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport",
          rowsPerPageOptions: [10, 25, 50],
          currentPageReportTemplate: "Showing {first} to {last} of {totalRecords} entries",
          onPage: t[0] || (t[0] = (v) => e.onPage(v)),
          onSort: t[1] || (t[1] = (v) => e.onSort(v)),
          sortField: "created",
          sortOrder: -1
        }, {
          empty: ve(() => t[10] || (t[10] = [
            y(" No requests found. ")
          ])),
          loading: ve(() => t[11] || (t[11] = [
            a("div", { class: "bg-accentgreenblue rounded-pill px-3 py-1 text-white" }, [
              a("span", {
                class: "spinner-border spinner-border-sm me-2",
                role: "status",
                "aria-hidden": "true"
              }),
              y("Loading requests. Please wait... ")
            ], -1)
          ])),
          default: ve(() => [
            N(l, { header: "Requested" }, {
              body: ve((v) => [
                y(g(e.date(v.data.created)) + " ", 1),
                t[12] || (t[12] = a("br", null, null, -1)),
                v.data.inProgress ? (p(), h("span", $ge, "In Progress")) : v.data.incomplete ? (p(), h("span", _ge, "Incomplete")) : v.data.abandoned ? (p(), h("span", eve, "Abandoned")) : v.data.completed ? (p(), h("span", tve, "Completed")) : P("", !0)
              ]),
              _: 1
            }),
            N(l, { header: "Property Address" }, {
              body: ve((v) => {
                var b;
                return [
                  a("address", sve, [
                    v.data.propertyFound ? P("", !0) : (p(), h("i", ave)),
                    N(d, {
                      name: ((b = v.data) == null ? void 0 : b.inProgress) != !0 ? "analysis-view" : void 0,
                      params: e.buildRouteParams(v.data),
                      target: "_blank"
                    }, {
                      default: ve(() => [
                        y(g(v.data.address), 1),
                        t[13] || (t[13] = a("br", null, null, -1)),
                        y(" " + g(v.data.city) + ", " + g(v.data.state) + " " + g(v.data.zip), 1),
                        t[14] || (t[14] = a("br", null, null, -1))
                      ]),
                      _: 2,
                      __: [13, 14]
                    }, 1032, ["name", "params"])
                  ])
                ];
              }),
              _: 1
            }),
            N(l, {
              field: "name",
              header: "Name"
            }),
            N(l, { header: "Contact Info" }, {
              body: ve((v) => [
                v.data.isSkipTraced ? (p(), h("div", nve, [
                  a("div", rve, [
                    v.data.abandoned && v.data.email == "" && v.data.phone != "" ? (p(), h("span", ove, [
                      V(a("i", ive, null, 512), [
                        [
                          u,
                          "No email information was found via skip trace.",
                          void 0,
                          { top: !0 }
                        ]
                      ]),
                      t[15] || (t[15] = y("No email found"))
                    ])) : P("", !0),
                    v.data.email != "" ? (p(), h("span", lve, [
                      V(a("i", dve, null, 512), [
                        [
                          u,
                          "Contact information retrieved via Skip Trace",
                          void 0,
                          { top: !0 }
                        ]
                      ]),
                      y(g(v.data.email), 1)
                    ])) : P("", !0)
                  ]),
                  a("div", cve, [
                    v.data.abandoned && v.data.phone == "" && v.data.email != "" ? (p(), h("span", uve, [
                      V(a("i", pve, null, 512), [
                        [
                          u,
                          "No phone information was found via skip trace.",
                          void 0,
                          { top: !0 }
                        ]
                      ]),
                      t[16] || (t[16] = y("No phone found"))
                    ])) : P("", !0),
                    v.data.phone != "" ? (p(), h("span", hve, [
                      V(a("i", mve, null, 512), [
                        [
                          u,
                          "Phone information was found via skip trace.",
                          void 0,
                          { top: !0 }
                        ]
                      ]),
                      y(g(v.data.phone), 1)
                    ])) : P("", !0)
                  ]),
                  a("div", fve, [
                    v.data.email == "" && v.data.phone == "" ? (p(), h("span", gve, [
                      V(a("i", vve, null, 512), [
                        [
                          u,
                          "No contact information was found via skip trace.",
                          void 0,
                          { top: !0 }
                        ]
                      ]),
                      t[17] || (t[17] = y("No contact info found."))
                    ])) : P("", !0)
                  ])
                ])) : v.data.abandoned == !1 ? (p(), h("div", yve, [
                  a("span", null, g(v.data.email), 1),
                  t[18] || (t[18] = a("br", null, null, -1)),
                  a("span", null, g(v.data.phone), 1)
                ])) : P("", !0),
                v.data.abandoned && e.incompleteInfo(v.data.email, v.data.phone) && !v.data.isSkipTraced ? (p(), h("button", {
                  key: 2,
                  type: "button",
                  class: "btn btn-sm btn-outline-eclipse mt-2",
                  disabled: e.analysisRequestBusy,
                  onClick: (b) => e.showConfirmSkipTraceModal(v.data.token)
                }, " Skip Trace ", 8, bve)) : P("", !0)
              ]),
              _: 1
            }),
            N(l, {
              header: "Assignee",
              hidden: e.compact
            }, {
              body: ve((v) => [
                v.data.inProgress == !1 ? (p(), h("div", Ave, [
                  v.data.assignedTo ? (p(), h(A, { key: 0 }, [
                    y(g(v.data.assignedTo.firstName) + " " + g(v.data.assignedTo.lastName), 1)
                  ], 64)) : (p(), h("button", {
                    key: 1,
                    onClick: (b) => e.assignToMe(v.data),
                    class: "btn btn-link px-0"
                  }, "Assign to me", 8, wve)),
                  !v.data.isCrmCreated && !e.incompleteInfo(v.data.email, v.data.phone) ? (p(), h("button", {
                    key: 2,
                    onClick: (b) => e.addCrm(v.data.token),
                    disabled: e.analysisRequestBusy,
                    type: "button",
                    class: "btn btn-sm btn-success d-block mb-1"
                  }, "Add to CRM", 8, Cve)) : P("", !0),
                  v.data.isCrmCreated ? (p(), h("span", Sve, "Added to CRM")) : P("", !0)
                ])) : P("", !0)
              ]),
              _: 1
            }, 8, ["hidden"]),
            N(l, { header: "Sent" }, {
              body: ve((v) => [
                v.data.sent ? (p(), h("i", Pve)) : P("", !0)
              ]),
              _: 1
            }),
            N(l, {
              header: "Views",
              hidden: e.compact
            }, {
              body: ve((v) => [
                y(g(v.data.views) + " ", 1),
                V((p(), h("button", {
                  hidden: "",
                  onClick: (b) => e.viewRequestLogs(v.data),
                  type: "button",
                  class: "btn btn-outline-eclipse btn-sm me-2"
                }, t[19] || (t[19] = [
                  a("i", { class: "fa-light fa-clipboard-list" }, null, -1),
                  a("span", { class: "visually-hidden" }, "Event Log", -1)
                ]), 8, kve)), [
                  [
                    u,
                    "Event log",
                    void 0,
                    { top: !0 }
                  ]
                ])
              ]),
              _: 1
            }, 8, ["hidden"]),
            N(l, { header: "Actions" }, {
              body: ve((v) => {
                var b;
                return [
                  v.data.inProgress == !1 ? (p(), h("div", Eve, [
                    V((p(), Fe(d, {
                      name: ((b = v.data) == null ? void 0 : b.inProgress) != !0 ? "analysis-view" : void 0,
                      params: e.buildRouteParams(v.data),
                      class: "btn btn-outline-eclipse btn-sm me-2",
                      target: "_blank"
                    }, {
                      default: ve(() => t[20] || (t[20] = [
                        a("i", { class: "fa-light fa-eye" }, null, -1),
                        a("span", { class: "visually-hidden" }, "View Analysis", -1)
                      ])),
                      _: 2,
                      __: [20]
                    }, 1032, ["name", "params"])), [
                      [
                        u,
                        "View Analysis",
                        void 0,
                        { top: !0 }
                      ]
                    ]),
                    V((p(), h("button", {
                      onClick: (w) => e.verifySend(v.data),
                      type: "button",
                      class: "btn btn-outline-eclipse btn-sm me-2",
                      disabled: e.analysisRequestBusy || !e.canSend(v.data.email)
                    }, t[21] || (t[21] = [
                      a("i", { class: "fa-light fa-envelope" }, null, -1),
                      a("span", { class: "visually-hidden" }, "Send Analysis", -1)
                    ]), 8, Ive)), [
                      [
                        u,
                        "Send Analysis",
                        void 0,
                        { top: !0 }
                      ]
                    ]),
                    v.data.assignedOwnerId && e.canManageLeads ? V((p(), Fe(d, {
                      key: 0,
                      name: "portfolio-finder-owner",
                      params: { id: v.data.assignedOwnerId },
                      target: "_blank",
                      class: "btn btn-outline-eclipse btn-sm me-2"
                    }, {
                      default: ve(() => t[22] || (t[22] = [
                        a("i", { class: "fa-light fa-users-viewfinder" }, null, -1),
                        a("span", { class: "visually-hidden" }, "View Target", -1)
                      ])),
                      _: 2,
                      __: [22]
                    }, 1032, ["params"])), [
                      [
                        u,
                        "View Target",
                        void 0,
                        { top: !0 }
                      ]
                    ]) : e.canManageLeads ? P("", !0) : V((p(), h("button", Tve, t[23] || (t[23] = [
                      a("i", { class: "fa-light fa-users-viewfinder" }, null, -1),
                      a("span", { class: "visually-hidden" }, "View Target", -1)
                    ]))), [
                      [
                        u,
                        "View Target",
                        void 0,
                        { top: !0 }
                      ]
                    ]),
                    V((p(), h("button", {
                      onClick: (w) => e.archiveRequest(v.data.id),
                      type: "button",
                      class: "btn btn-outline-eclipse btn-sm me-2",
                      disabled: e.analysisRequestBusy || v.data.archived
                    }, t[24] || (t[24] = [
                      a("i", { class: "fa-light fa-box-archive" }, null, -1),
                      a("span", { class: "visually-hidden" }, "Archive Request", -1)
                    ]), 8, Ove)), [
                      [
                        u,
                        "Archive Request",
                        void 0,
                        { top: !0 }
                      ]
                    ])
                  ])) : P("", !0)
                ];
              }),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["value", "paginator", "rows", "totalRecords", "loading"])
      ]),
      e.compact ? (p(), h("div", Rve, [
        N(d, { name: "rental-analysis-requests" }, {
          default: ve(() => t[25] || (t[25] = [
            y("View All Analysis Requests "),
            a("i", { class: "fa-light fa-arrow-right-long ms-2" }, null, -1)
          ])),
          _: 1,
          __: [25]
        })
      ])) : P("", !0)
    ], 8, Kge),
    a("div", Lve, [
      a("div", Bve, [
        a("div", Mve, [
          a("div", xve, [
            t[26] || (t[26] = a("p", { class: "modal-title fw-bold fs-5 mb-3" }, " Analysis Request Event Logs ", -1)),
            a("button", {
              type: "button",
              onClick: t[2] || (t[2] = (...v) => e.closeRequest && e.closeRequest(...v)),
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            })
          ]),
          t[27] || (t[27] = a("div", { class: "modal-body" }, [
            a("div", { class: "mb-3" }, [
              a("table", { class: "table" }, [
                a("thead", null, [
                  a("tr", null, [
                    a("th", null, "Description"),
                    a("th", null, "Status"),
                    a("th", null, "Date")
                  ])
                ]),
                a("tbody", null, [
                  a("tr", null, [
                    a("td", null, " Assigned to Brock Purdy "),
                    a("td", null, "Complete"),
                    a("td", null, "08/02/2023 13:56")
                  ])
                ])
              ])
            ])
          ], -1))
        ])
      ])
    ], 512),
    a("div", Fve, [
      a("div", Vve, [
        a("div", Dve, [
          t[36] || (t[36] = a("div", { class: "modal-header border-0 pb-0" }, [
            a("p", { class: "modal-title fw-bold fs-5 mb-3" }, " Send to Prospect "),
            a("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            })
          ], -1)),
          a("div", Nve, [
            a("div", jve, [
              a("label", Hve, [
                t[28] || (t[28] = y("To: ")),
                t[29] || (t[29] = a("br", null, null, -1)),
                a("b", null, g((m = e.requestToSend) == null ? void 0 : m.name), 1)
              ])
            ]),
            a("div", Uve, [
              a("label", zve, [
                t[30] || (t[30] = y("Email: ")),
                t[31] || (t[31] = a("br", null, null, -1)),
                a("b", null, g((f = e.requestToSend) == null ? void 0 : f.email), 1)
              ])
            ]),
            a("div", Wve, [
              t[32] || (t[32] = a("label", {
                class: "form-label",
                for: "bdmMessage"
              }, "Message:", -1)),
              V(a("textarea", {
                class: "form-control",
                rows: "3",
                id: "bdmMessage",
                "onUpdate:modelValue": t[3] || (t[3] = (v) => e.shareAnalysisModel.message = v)
              }, null, 512), [
                [_e, e.shareAnalysisModel.message]
              ])
            ]),
            a("div", Gve, [
              V(a("input", {
                class: "form-check-input",
                type: "checkbox",
                "onUpdate:modelValue": t[4] || (t[4] = (v) => e.shareAnalysisModel.attachPdf = v),
                id: "checkPDF"
              }, null, 512), [
                [Ue, e.shareAnalysisModel.attachPdf]
              ]),
              t[33] || (t[33] = a("label", {
                class: "form-check-label",
                for: "checkPDF"
              }, " Include PDF with email ", -1))
            ]),
            a("div", Yve, [
              V(a("input", {
                class: "form-check-input",
                type: "checkbox",
                "onUpdate:modelValue": t[5] || (t[5] = (v) => e.shareAnalysisModel.includeSchedulingLink = v),
                id: "checkScheduling",
                disabled: e.disableSchedulingLink
              }, null, 8, Xve), [
                [Ue, e.shareAnalysisModel.includeSchedulingLink]
              ]),
              a("label", qve, [
                t[34] || (t[34] = y(" Include Scheduling Link ")),
                e.disableSchedulingLink ? V((p(), h("i", Qve, null, 512)), [
                  [
                    u,
                    "You can add a Scheduling Link on you Account Settings",
                    void 0,
                    { top: !0 }
                  ]
                ]) : P("", !0)
              ])
            ]),
            a("div", Kve, [
              a("button", {
                type: "button",
                class: "btn btn-lava",
                onClick: t[6] || (t[6] = (...v) => e.sendRequest && e.sendRequest(...v)),
                disabled: e.analysisRequestBusy
              }, t[35] || (t[35] = [
                a("i", { class: "fa-light fa-envelope me-2" }, null, -1),
                y("SEND")
              ]), 8, Zve)
            ])
          ])
        ])
      ])
    ], 512),
    t[45] || (t[45] = Bt('<div class="modal fade" id="modalPortfolioFinder" tabindex="-1" aria-labelledby="modalPortfolioFinderLabel" aria-hidden="true"><div class="modal-dialog modal-dialog-centered"><div class="modal-content bg-gradient-alphabet rounded"><div class="modal-header border-0 pb-0"><button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button></div><div class="px-4 pb-4 text-center"><img src="' + Xk + '" height="370"></div><div class="modal-body text-center"><p class="fs-5 mb-2 fw-bold">View Target on Portfolio Finder</p><p> Investigate the entire portfolio of leads who complete your rental analysis form and discover the whales you want to work with most. </p><a href="/enterprise/portfolio-finder" class="btn btn-lava mt-3">Learn more  <span class="d-none d-xxl-inline-block">about Portfolio Finder</span></a></div></div></div></div>', 1)),
    a("div", Jve, [
      a("div", $ve, [
        a("div", _ve, [
          t[44] || (t[44] = a("div", { class: "modal-header border-0 mb-0" }, [
            a("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            })
          ], -1)),
          a("div", eye, [
            t[37] || (t[37] = a("i", { class: "fa-duotone fa-search-location mb-3 fa-2x" }, null, -1)),
            t[38] || (t[38] = a("br", null, null, -1)),
            t[39] || (t[39] = a("b", { class: "fs-5" }, "Skip Trace Fee Acknowledgement", -1)),
            t[40] || (t[40] = a("br", null, null, -1)),
            t[41] || (t[41] = a("br", null, null, -1)),
            t[42] || (t[42] = a("p", null, " By initiating a skip trace, you acknowledge you'll be charged a flat fee of 8 cents if any phone numbers or email addresses are found. If no results are found, you won't be charged. ", -1)),
            a("div", tye, [
              a("button", {
                type: "button",
                class: "btn btn-outline-secondary",
                onClick: t[7] || (t[7] = (...v) => e.hideConfirmSkipTraceModal && e.hideConfirmSkipTraceModal(...v))
              }, "Cancel"),
              a("button", {
                type: "button",
                class: "btn btn-lava",
                onClick: t[8] || (t[8] = (...v) => e.skipTrace && e.skipTrace(...v))
              }, "Confirm")
            ])
          ]),
          e.isBusy ? (p(), h("div", sye, t[43] || (t[43] = [
            a("i", { class: "fa-duotone fa-solid fa-spinner-third fa-spin me-2" }, null, -1),
            y("Skip Tracing Contact... ")
          ]))) : P("", !0)
        ])
      ])
    ], 512)
  ], 64);
}
const Cls = /* @__PURE__ */ Ae(qge, [["render", aye]]), nye = me({
  name: "SubscriptionManagement",
  props: {
    product: {
      type: Object,
      required: !0
    },
    main: Boolean
  },
  components: {},
  data() {
    return {};
  },
  computed: {
    isMultipleProducts() {
      var e;
      return (((e = this.product) == null ? void 0 : e.optionId) ?? 0) > 0;
    },
    //#region Main Billing Period prod
    mainBillingPeriodProd() {
      return this.subscriptionStore.mainBillingPeriodProduct(this.product);
    },
    isMainBillingPeriod() {
      var e;
      return ((e = this.mainBillingPeriodProd) == null ? void 0 : e.billingPeriod) == this.chosenBillingPeriod;
    },
    mainBillingPeriodPrice() {
      var e;
      return (e = this.mainBillingPeriodProd) == null ? void 0 : e.price;
    },
    //#endregion
    productPrice() {
      var e;
      if (((e = this.mainBillingPeriodProd) == null ? void 0 : e.billingPeriod) == this.chosenBillingPeriod)
        return this.product.price;
      switch (this.chosenBillingPeriod) {
        case Qt.Annually:
          return this.product.price / 12;
      }
      return this.product.price;
    },
    productBillingPeriod() {
      var e;
      switch ((e = this.mainBillingPeriodProd) == null ? void 0 : e.billingPeriod) {
        case Qt.Monthly:
        case Qt.Annually:
          return "mo";
      }
      return "??";
    },
    //#region Options logic
    billingPeriodProductOptions() {
      return this.subscriptionStore.products.filter((e) => e.optionId == this.product.optionId && !e.addOn && e.billingPeriod == this.chosenBillingPeriod).sort((e, t) => e.price - t.price);
    },
    productOptions() {
      var e;
      return (((e = this.product) == null ? void 0 : e.optionId) ?? 0) == 0 ? [] : this.subscriptionStore.products.filter((t) => t.optionId == this.product.optionId && !t.addOn);
    },
    billingPeriodSelectedOption() {
      return this.billingPeriodProductOptions.find((e) => e.qty && e.qty > 0);
    },
    billingPeriodSelectedOptionPrice() {
      var e, t;
      return this.isAnnually ? (((e = this.billingPeriodSelectedOption) == null ? void 0 : e.price) ?? 0) / 12 : (t = this.billingPeriodSelectedOption) == null ? void 0 : t.price;
    },
    mainBillingPeriodSelectedOption() {
      if (this.billingPeriodSelectedOption)
        return this.subscriptionStore.mainBillingPeriodProduct(this.billingPeriodSelectedOption);
    },
    anyOptionSelected() {
      return this.billingPeriodProductOptions.some((e) => e.qty && e.qty > 0);
    },
    firstOption() {
      if (this.billingPeriodProductOptions.length > 0)
        return this.billingPeriodProductOptions.reduce((e, t) => e.price < t.price ? e : t);
    },
    firstOptionPrice() {
      var e, t;
      return this.isAnnually ? (((e = this.firstOption) == null ? void 0 : e.price) ?? 0) / 12 : (t = this.firstOption) == null ? void 0 : t.price;
    },
    mainBillingPeriodFirstOption() {
      if (this.firstOption)
        return this.products.find((e) => e.id == this.firstOption.billingPeriodMainId);
    },
    multipleProductStyle() {
      return {
        "d-flex": this.main == !1,
        "border-bottom": this.main == !1,
        "align-items-start": this.main == !1,
        "p-3": !0
      };
    },
    anyOptionSelectedStyle() {
      return {
        "btn btn-sm": !0,
        "btn-success": this.anyOptionSelected,
        "btn-outline-secondary": !this.anyOptionSelected
      };
    },
    mainProductIncluded() {
      if (this.billingPeriodProductOptions.some((t) => this.optionDisabled(t)))
        return this.billingPeriodProductOptions.find((t) => t.qty > 0);
    },
    //#endregion
    ...at(vn),
    ...q(vn, ["chosenBillingPeriod", "products", "isAnnually"])
  },
  methods: {
    currency: Yu,
    selectOption(e, t) {
      var r;
      const s = (r = t == null ? void 0 : t.target) == null ? void 0 : r.checked, n = this.products.find((i) => i.id == e.id);
      e.optionId && e.optionId > 0 ? (this.productOptions.filter((i) => i.billingPeriodMainId != e.billingPeriodMainId).forEach((i) => i.qty = 0), this.products.filter((i) => i.billingPeriodMainId == (n == null ? void 0 : n.billingPeriodMainId)).forEach((i) => {
        i.qty > 0 && s && !i.mainProduct ? i.qty = 0 : i.qty = s ? 1 : 0;
      })) : this.products.filter((i) => i.billingPeriodMainId == (n == null ? void 0 : n.billingPeriodMainId)).forEach((i) => i.qty = s ? 1 : 0), this.mainBillingPeriodProd && this.subscriptionStore.removeIncompatible(this.mainBillingPeriodProd), this.subscriptionStore.applyProductIncludes(e);
    },
    //removeIncompatible(product: ProductItem) {
    //   // Reset all billing period incompatible products qty to 0
    //   this.products.filter(q => q.incompatible?.some(id => product.billingPeriodMainId) == true).forEach(q => q.qty = 0);
    //},
    selectFirstOption(e) {
      const t = this.billingPeriodProductOptions[0];
      this.selectOption(t, e);
    },
    optionSelected(e) {
      var t;
      return (((t = this.products.find((s) => s.id == e.id)) == null ? void 0 : t.qty) ?? 0) >= 1;
    },
    // Possibly can be replace with optionPrice in subscriptionStore
    optionPrice(e) {
      var t;
      if (((t = this.mainBillingPeriodProd) == null ? void 0 : t.billingPeriod) == this.chosenBillingPeriod)
        return e.price;
      switch (this.chosenBillingPeriod) {
        case Qt.Annually:
          return e.price / 12;
      }
      return e.price;
    },
    optionBillingPeriod(e) {
      var t;
      switch ((t = this.mainBillingPeriodProd) == null ? void 0 : t.billingPeriod) {
        case Qt.Monthly:
        case Qt.Annually:
          return "mo";
      }
      return "??";
    },
    /**
     * Determines whether the given product option should be disabled for selection.
     * This can happen if there's already a product of the same option group selected
     * that is included with a higher order value, making this option incompatible.
     * Or, if the product is archived and has no qty choosen.
     *
     * @param {ProductItem} option - The product item to evaluate for disability.
     * @returns {boolean} True if the option is considered disabled; otherwise, false.
     */
    optionDisabled(e) {
      const t = this.products.filter((s) => {
        var n;
        return s.qty && s.qty > 0 && s.billingPeriod == this.chosenBillingPeriod && s.includes && ((n = s.includes) == null ? void 0 : n.length) > 0;
      }).flatMap((s) => s.includes).map((s) => s.includesId);
      return this.products.filter((s) => s.optionId == e.optionId && t.some((n) => n == s.id) == !0 && s.order > e.order).length > 0;
    },
    productPriceStyle(e) {
      return {
        "line-through": this.optionSelected(e) && this.subscriptionStore.isIncluded(e),
        "text-body-tertiary": this.optionSelected(e) && this.subscriptionStore.isIncluded(e)
      };
    },
    productPriceSelectedStyle(e) {
      return {
        "btn btn-sm": !0,
        "btn-success": this.optionSelected(e),
        "btn-outline-secondary": !this.optionSelected(e)
      };
    },
    productIconUrl(e) {
      return `https://images.rescover.com/content/images/icons/products/${e.icon}`;
    }
  }
}), rye = {
  key: 0,
  class: "mb-0 mb-lg-3"
}, oye = { class: "fw-bold product-name" }, iye = {
  key: 1,
  class: "d-flex flex-row gap-2"
}, lye = { class: "product-icon" }, dye = ["src"], cye = ["id", "checked", "disabled"], uye = ["for"], pye = ["for"], hye = { class: "me-3" }, mye = { class: "ms-auto d-flex justify-content-center flex-column align-items-end" }, fye = {
  key: 0,
  class: "fw-bold text-nowrap"
}, gye = {
  key: 1,
  style: { "margin-top": "-5px" },
  class: "text-decoration-line-through text-body-tertiary"
}, vye = { class: "fs-4" }, yye = { class: "fs-4" }, bye = {
  key: 0,
  class: "row g-3 mt-0 row-cols-1 row-cols-md-3"
}, Aye = { class: "col" }, wye = ["id", "name", "onClick", "checked", "disabled"], Cye = ["for"], Sye = {
  key: 0,
  class: "badge-popular position-absolute"
}, Pye = { class: "product-icon" }, kye = ["src"], Eye = { class: "mb-2" }, Iye = { class: "fs-4" }, Tye = {
  key: 0,
  class: "badge text-bg-success-subtle rounded-pill text-wrap mt-2"
}, Oye = {
  key: 1,
  class: "bg-light rounded border p-3 px-2 card-selected"
}, Rye = { class: "row g-0" }, Lye = { class: "col-md-3 d-flex align-items-center flex-column justify-content-center" }, Bye = ["src"], Mye = { class: "fs-4" }, xye = { class: "col-md-9 d-flex align-items-center" }, Fye = { class: "ps-2" }, Vye = {
  key: 1,
  class: "d-flex p-3 border-bottom align-items-start gap-2"
}, Dye = { class: "product-icon" }, Nye = ["src"], jye = ["id", "checked", "disabled"], Hye = ["for"], Uye = ["for"], zye = { class: "me-3" }, Wye = { class: "mb-0" }, Gye = {
  key: 0,
  class: "list-unstyled mb-0"
}, Yye = { class: "ms-auto d-flex justify-content-center flex-column align-items-end" }, Xye = {
  key: 0,
  class: "text-decoration-line-through text-body-tertiary mb-2"
}, qye = { class: "fs-4" };
function Qye(e, t, s, n, r, i) {
  var o, l, d, c, u, m, f, v;
  return e.isMultipleProducts ? (p(), h("div", {
    key: 0,
    class: z(e.multipleProductStyle)
  }, [
    a("div", {
      class: z({ "mb-3": e.main })
    }, [
      e.main ? (p(), h("p", rye, [
        a("span", oye, g((o = e.mainBillingPeriodProd) == null ? void 0 : o.name) + " Selection", 1),
        t[2] || (t[2] = a("br", null, null, -1)),
        y(" " + g((l = e.billingPeriodSelectedOption) == null ? void 0 : l.desc), 1)
      ])) : (p(), h("div", iye, [
        a("div", lye, [
          a("img", {
            src: e.productIconUrl(e.product),
            width: "80",
            class: "img-fluid mb-3"
          }, null, 8, dye),
          a("input", {
            type: "checkbox",
            class: "btn-check",
            id: "btn-check-rg" + e.product.id,
            autocomplete: "off",
            onClick: t[0] || (t[0] = (b) => e.selectFirstOption(b)),
            checked: e.anyOptionSelected,
            disabled: e.subscriptionStore.isArchivedDisabled(e.product)
          }, null, 8, cye),
          e.subscriptionStore.isArchivedDisabled(e.product) ? P("", !0) : (p(), h("label", {
            key: 0,
            for: "btn-check-rg" + e.product.id,
            class: z(e.anyOptionSelectedStyle)
          }, [
            e.anyOptionSelected ? (p(), h(A, { key: 0 }, [
              y(" Selected ")
            ], 64)) : (p(), h(A, { key: 1 }, [
              y(" Select ")
            ], 64))
          ], 10, uye))
        ]),
        a("label", {
          class: "d-flex flex-row w-100",
          for: "btn-check-rg" + e.product.id
        }, [
          a("span", hye, [
            a("b", null, g((d = e.mainBillingPeriodProd) == null ? void 0 : d.name), 1),
            t[3] || (t[3] = a("br", null, null, -1)),
            y(" " + g((c = e.mainBillingPeriodProd) == null ? void 0 : c.desc), 1)
          ]),
          a("span", mye, [
            e.anyOptionSelected ? P("", !0) : (p(), h("small", fye, "Starting at")),
            e.isMainBillingPeriod ? P("", !0) : (p(), h("span", gye, [
              e.anyOptionSelected ? (p(), h(A, { key: 1 }, [
                y(g(e.currency((m = e.mainBillingPeriodSelectedOption) == null ? void 0 : m.price)) + " ", 1),
                t[5] || (t[5] = a("small", null, "/mo", -1))
              ], 64)) : (p(), h(A, { key: 0 }, [
                y(g(e.currency((u = e.mainBillingPeriodFirstOption) == null ? void 0 : u.price)) + " ", 1),
                t[4] || (t[4] = a("small", null, "/mo", -1))
              ], 64))
            ])),
            a("span", {
              style: rn({ "margin-top": e.isMainBillingPeriod ? "" : "-7px" })
            }, [
              e.anyOptionSelected ? (p(), h(A, { key: 1 }, [
                a("span", yye, g(e.currency(e.billingPeriodSelectedOptionPrice)), 1),
                t[7] || (t[7] = a("small", null, "/mos", -1))
              ], 64)) : (p(), h(A, { key: 0 }, [
                a("span", vye, g(e.currency(e.firstOptionPrice)), 1),
                t[6] || (t[6] = a("small", null, "/mo", -1))
              ], 64))
            ], 4)
          ])
        ], 8, pye)
      ])),
      e.main || e.anyOptionSelected ? (p(), h(A, { key: 2 }, [
        e.mainProductIncluded ? (p(), h("div", Oye, [
          a("div", Rye, [
            a("div", Lye, [
              a("img", {
                src: e.productIconUrl(e.mainProductIncluded),
                class: "img-fluid mb-2",
                width: "80"
              }, null, 8, Bye),
              a("span", null, g(e.mainProductIncluded.optionName), 1),
              a("div", {
                class: z(e.productPriceStyle(e.mainProductIncluded))
              }, [
                a("span", Mye, [
                  y(g(e.currency(e.optionPrice(e.mainProductIncluded))), 1),
                  a("small", null, "/" + g(e.optionBillingPeriod(e.mainProductIncluded)), 1)
                ])
              ], 2)
            ]),
            a("div", xye, [
              a("div", Fye, [
                a("b", null, g(e.mainProductIncluded.optionName) + " is included with your selection Below", 1),
                t[8] || (t[8] = a("br", null, null, -1)),
                y(" " + g(e.mainProductIncluded.optionIncludedDescription), 1)
              ])
            ])
          ])
        ])) : (p(), h("div", bye, [
          (p(!0), h(A, null, D(e.billingPeriodProductOptions, (b) => {
            var w;
            return p(), h("div", Aye, [
              a("input", {
                type: "radio",
                class: "btn-check",
                id: "btn-check-property" + b.id,
                autocomplete: "off",
                name: "product-selection" + b.optionId,
                onClick: (S) => e.selectOption(b, S),
                checked: e.optionSelected(b),
                disabled: e.optionDisabled(b) || e.subscriptionStore.isArchivedDisabled(b)
              }, null, 8, wye),
              a("label", {
                class: z(["text-center btn-check-selection-item h-100 d-flex justify-content-center", { "most-popular": b.recommended }]),
                for: "btn-check-property" + b.id
              }, [
                b.recommended ? (p(), h("div", Sye, "MOST POPULAR")) : P("", !0),
                a("div", Pye, [
                  a("img", {
                    src: e.productIconUrl(b),
                    width: "60",
                    class: "img-fluid mb-2"
                  }, null, 8, kye),
                  a("div", Eye, g(b.optionName), 1),
                  a("div", {
                    class: z(e.productPriceStyle(b))
                  }, [
                    a("span", Iye, g(e.currency(e.optionPrice(b))), 1),
                    a("small", null, "/" + g(e.optionBillingPeriod(b)), 1)
                  ], 2),
                  e.optionSelected(b) && e.subscriptionStore.isIncluded(b) ? (p(), h("span", Tye, "Included with " + g((w = e.subscriptionStore.includedWith(b)) == null ? void 0 : w.name), 1)) : P("", !0)
                ])
              ], 10, Cye)
            ]);
          }), 256))
        ]))
      ], 64)) : P("", !0)
    ], 2)
  ], 2)) : e.product ? (p(), h("div", Vye, [
    a("div", Dye, [
      a("img", {
        src: e.productIconUrl(e.product),
        class: "img-fluid mb-3"
      }, null, 8, Nye),
      a("input", {
        type: "checkbox",
        class: "btn-check",
        id: "btn-check-rg" + e.product.id,
        autocomplete: "off",
        onClick: t[1] || (t[1] = (b) => e.selectOption(e.product, b)),
        checked: e.optionSelected(e.product),
        disabled: e.subscriptionStore.isArchivedDisabled(e.product)
      }, null, 8, jye),
      e.subscriptionStore.isArchivedDisabled(e.product) ? P("", !0) : (p(), h("label", {
        key: 0,
        for: "btn-check-rg" + e.product.id,
        class: z(e.productPriceSelectedStyle(e.product))
      }, [
        e.optionSelected(e.product) ? (p(), h(A, { key: 0 }, [
          y(" Selected ")
        ], 64)) : (p(), h(A, { key: 1 }, [
          y(" Select ")
        ], 64))
      ], 10, Hye))
    ]),
    a("label", {
      class: "d-flex flex-row w-100",
      for: "btn-check-rg" + e.product.id
    }, [
      a("span", zye, [
        a("span", Wye, [
          a("b", null, g(e.product.name), 1),
          t[9] || (t[9] = a("br", null, null, -1)),
          y(" " + g(e.product.desc), 1)
        ]),
        (((f = e.product.keyPoints) == null ? void 0 : f.length) ?? 0) > 0 ? (p(), h("ul", Gye, [
          (p(!0), h(A, null, D(e.product.keyPoints, (b, w) => (p(), h("li", { key: b }, [
            t[10] || (t[10] = a("i", { class: "fa-duotone fa-circle-check text-success me-2" }, null, -1)),
            y(g(w), 1)
          ]))), 128))
        ])) : P("", !0)
      ]),
      a("span", Yye, [
        e.isMainBillingPeriod ? P("", !0) : (p(), h("div", Xye, [
          y(g(e.currency((v = e.mainBillingPeriodProd) == null ? void 0 : v.price)), 1),
          a("small", null, "/" + g(e.subscriptionStore.billFreq(e.mainBillingPeriodProd)), 1)
        ])),
        a("div", null, [
          a("span", qye, g(e.currency(e.productPrice)), 1),
          a("small", null, "/" + g(e.productBillingPeriod), 1)
        ])
      ])
    ], 8, Uye)
  ])) : P("", !0);
}
const Kye = /* @__PURE__ */ Ae(nye, [["render", Qye], ["__scopeId", "data-v-d36dafa0"]]), Zye = me({
  name: "SubscriptionManagement",
  props: {
    product: {
      type: Object,
      required: !0
    },
    main: Boolean
  },
  enums: {
    BillingPeriods: Qt
  },
  watch: {
    "product.qty"(e) {
      e < 0 && (this.product.qty = 0), this.products.filter((t) => {
        var s;
        return t.id != this.product.id && t.billingPeriodMainId == ((s = this.product) == null ? void 0 : s.billingPeriodMainId);
      }).forEach((t) => t.qty = e);
    }
  },
  computed: {
    isMultipleProducts() {
      var e;
      return (((e = this.product) == null ? void 0 : e.optionId) ?? 0) > 0;
    },
    //#region Main Billing Period prod
    mainBillingPeriodProd() {
      return this.subscriptionStore.mainBillingPeriodProduct(this.product);
    },
    mainBillingPeriod() {
      var e;
      return (e = this.mainBillingPeriodProd) == null ? void 0 : e.billingPeriod;
    },
    isMainBillingPeriod() {
      return this.mainBillingPeriod == this.chosenBillingPeriod;
    },
    mainBillingPeriodPrice() {
      var e;
      return (e = this.mainBillingPeriodProd) == null ? void 0 : e.price;
    },
    //#endregion
    productPrice() {
      switch (this.chosenBillingPeriod) {
        case Qt.Monthly:
          switch (this.product.billingPeriod) {
            case Qt.Annually:
              return this.product.price / 12;
          }
          break;
        case Qt.Annually:
          return this.product.price / 12;
      }
      return this.product.price;
    },
    productBillingPeriod() {
      switch (this.mainBillingPeriod) {
        case Qt.Monthly:
        case Qt.Annually:
          return "mo";
      }
      return "??";
    },
    billingPeriodProductOptions() {
      return this.subscriptionStore.products.filter((e) => e.optionId == this.product.optionId && !e.addOn && e.billingPeriod == this.chosenBillingPeriod).sort((e, t) => e.price - t.price);
    },
    productOptions() {
      var e;
      return (((e = this.product) == null ? void 0 : e.optionId) ?? 0) == 0 ? [] : this.subscriptionStore.products.filter((t) => t.optionId == this.product.optionId && !t.addOn);
    },
    billingPeriodProduct() {
      return this.subscriptionStore.products.find((e) => e.id == this.product.id);
    },
    mainBillingPeriodProduct() {
      return this.products.find((e) => e.id == this.product.billingPeriodMainId);
    },
    multipleProductStyle() {
      return {
        "d-flex": this.main == !1,
        "border-bottom": this.main == !1,
        "align-items-start": this.main == !1,
        "p-3": !0
      };
    },
    includesQty() {
      return this.subscriptionStore.includesQty(this.product);
    },
    requiresProd() {
      var e, t;
      return (((t = (e = this.mainBillingPeriodProduct) == null ? void 0 : e.requires) == null ? void 0 : t.length) ?? 0) > 0;
    },
    hasRequiredProd() {
      return this.products.filter((t) => {
        var s, n;
        return ((n = (s = this.mainBillingPeriodProduct) == null ? void 0 : s.requires) == null ? void 0 : n.some((r) => r == t.id)) == !0 && !t.addOn && t.qty && t.qty > 0;
      }).length > 0;
    },
    hasIncompatibleProd() {
      return this.products.filter((t) => {
        var s, n;
        return ((n = (s = this.mainBillingPeriodProduct) == null ? void 0 : s.incompatible) == null ? void 0 : n.some((r) => r == t.id)) == !0 && !t.addOn && t.qty && t.qty > 0;
      }).length > 0;
    },
    requiredProd() {
      return this.products.find((t) => {
        var s, n;
        return ((n = (s = this.mainBillingPeriodProduct) == null ? void 0 : s.requires) == null ? void 0 : n.some((r) => r == t.id)) == !0 && !t.addOn;
      });
    },
    disableEditing() {
      return !!(this.product.archived || this.requiresProd && !this.hasRequiredProd || this.requireOtherBillingPeriod && !this.isRequiredBillingPeriod);
    },
    requireOtherBillingPeriod() {
      var e;
      return ((e = this.product) == null ? void 0 : e.requiredBillingPeriod) != null && this.product.requiredBillingPeriod != Qt.None;
    },
    isRequiredBillingPeriod() {
      return this.product.requiredBillingPeriod == this.chosenBillingPeriod;
    },
    requireBillingFreq() {
      switch (this.product.billingPeriod) {
        case Qt.Monthly:
          return "Monthly";
        case Qt.Annually:
          return "Annually";
      }
    },
    productSelected: {
      get() {
        var e;
        return (((e = this.product) == null ? void 0 : e.qty) ?? 0) > 0;
      },
      set(e) {
        this.product.qty = e ? 1 : 0;
      }
    },
    ...at(vn),
    ...q(vn, ["chosenBillingPeriod", "products"])
  },
  methods: {
    currency: Yu,
    selectOption(e, t) {
      var r;
      const s = (r = t == null ? void 0 : t.target) == null ? void 0 : r.checked, n = this.products.find((i) => i.id == e.id);
      e.optionId && e.optionId > 0 ? (this.productOptions.filter((i) => i.id != e.id).forEach((i) => i.qty = 0), this.products.filter((i) => i.billingPeriodMainId == (n == null ? void 0 : n.billingPeriodMainId)).forEach((i) => i.qty = s ? 1 : 0)) : (console.log("selectOption", jr(n), s, jr(this.products.filter((i) => i.billingPeriodMainId == (n == null ? void 0 : n.billingPeriodMainId)))), this.products.filter((i) => i.billingPeriodMainId == (n == null ? void 0 : n.billingPeriodMainId)).forEach((i) => i.qty = s ? 1 : 0));
    },
    optionSelected(e) {
      var t;
      return (((t = this.products.find((s) => s.id == e.id)) == null ? void 0 : t.qty) ?? 0) >= 1;
    },
    addQty() {
      this.product.qty || (this.product.qty = 0), this.product.qty++;
    },
    removeQty() {
      this.product.qty || (this.product.qty = 0), this.product.qty > 0 && this.product.qty--;
    },
    switchToRequiredBillingPeriod() {
      this.subscriptionStore.chosenBillingPeriod = this.product.billingPeriod;
    }
  }
}), Jye = {
  key: 0,
  class: "p-3 border-bottom row"
}, $ye = { class: "col-xl-6 pe-xl-4 mb-2 mb-lg-0" }, _ye = {
  key: 0,
  class: "badge text-bg-success-subtle rounded-pill ms-2"
}, e1e = {
  key: 1,
  class: "badge text-bg-warning rounded-pill ms-2"
}, t1e = { class: "col-6 col-xl-3 text-xl-end" }, s1e = { class: "mb-2 d-flex justify-content-center justify-content-lg-end gap-1" }, a1e = {
  key: 0,
  class: "badge rounded-pill text-bg-lava-subtle"
}, n1e = {
  key: 2,
  class: "badge rounded-pill text-bg-success-subtle"
}, r1e = { class: "d-flex flex-row align-items-baseline gap-2 justify-content-center justify-content-lg-end" }, o1e = {
  key: 0,
  class: "text-decoration-line-through text-body-tertiary"
}, i1e = { class: "fs-4" }, l1e = { key: 0 }, d1e = { class: "col-6 col-xl-3 text-center text-xl-end" }, c1e = {
  key: 0,
  class: "small fw-bold text-body-secondary mb-1"
}, u1e = { class: "input-selection d-flex justify-content-center justify-content-lg-end" }, p1e = {
  key: 0,
  class: "input-group input-quantity"
}, h1e = ["disabled"], m1e = ["disabled"], f1e = ["disabled"], g1e = { key: 1 }, v1e = { class: "form-check form-switch" };
function y1e(e, t, s, n, r, i) {
  var o, l;
  return !e.hasIncompatibleProd && (!e.requiresProd || e.hasRequiredProd) ? (p(), h("div", Jye, [
    a("div", $ye, [
      a("b", null, g(e.product.name), 1),
      e.product.tiers ? (p(), h("span", _ye, "Tiered Pricing")) : P("", !0),
      e.product.archived ? (p(), h("span", e1e, "Legacy")) : P("", !0),
      t[5] || (t[5] = a("br", null, null, -1)),
      y(" " + g(e.product.desc), 1)
    ]),
    a("div", t1e, [
      a("div", s1e, [
        e.requireOtherBillingPeriod ? (p(), h("span", a1e, "Only " + g(e.requireBillingFreq), 1)) : P("", !0),
        P("", !0),
        e.includesQty ? (p(), h("span", n1e, g(e.includesQty) + " included", 1)) : P("", !0)
      ]),
      a("div", r1e, [
        !e.isMainBillingPeriod && !((o = e.product) != null && o.requiredBillingPeriod) ? (p(), h("span", o1e, g(e.currency((l = e.mainBillingPeriodProd) == null ? void 0 : l.price)) + "/" + g(e.subscriptionStore.billFreq(e.mainBillingPeriodProd)), 1)) : P("", !0),
        a("span", null, [
          a("span", i1e, g(e.currency(e.productPrice)), 1),
          a("small", null, "/" + g(e.productBillingPeriod), 1)
        ])
      ]),
      e.requireOtherBillingPeriod && e.subscriptionStore.chosenBillingPeriod != e.product.billingPeriod ? (p(), h("div", l1e, [
        a("button", {
          type: "button",
          class: "btn btn-link btn-sm p-0",
          style: { color: "#F26E34" },
          onClick: t[0] || (t[0] = (...d) => e.switchToRequiredBillingPeriod && e.switchToRequiredBillingPeriod(...d))
        }, "Switch to " + g(e.requireBillingFreq), 1)
      ])) : P("", !0)
    ]),
    a("div", d1e, [
      e.product.multiple ? (p(), h("label", c1e, "Additional Licenses")) : P("", !0),
      a("div", u1e, [
        e.product.multiple ? (p(), h("div", p1e, [
          a("button", {
            type: "button",
            class: "btn btn-link",
            onClick: t[1] || (t[1] = (...d) => e.removeQty && e.removeQty(...d)),
            disabled: e.disableEditing
          }, t[6] || (t[6] = [
            a("i", { class: "fa-duotone fa-solid fa-circle-minus" }, null, -1)
          ]), 8, h1e),
          V(a("input", {
            type: "number",
            class: "form-control border-0 text-end bg-light rounded",
            placeholder: "0",
            "onUpdate:modelValue": t[2] || (t[2] = (d) => e.product.qty = d),
            disabled: e.disableEditing
          }, null, 8, m1e), [
            [_e, e.product.qty]
          ]),
          a("button", {
            type: "button",
            class: "btn btn-link",
            onClick: t[3] || (t[3] = (...d) => e.addQty && e.addQty(...d)),
            disabled: e.disableEditing
          }, t[7] || (t[7] = [
            a("i", { class: "fa-duotone fa-solid fa-circle-plus" }, null, -1)
          ]), 8, f1e)
        ])) : (p(), h("div", g1e, [
          a("div", v1e, [
            V(a("input", {
              class: "form-check-input",
              type: "checkbox",
              role: "switch",
              id: "flexSwitchCheckDefault",
              "onUpdate:modelValue": t[4] || (t[4] = (d) => e.productSelected = d)
            }, null, 512), [
              [Ue, e.productSelected]
            ])
          ])
        ]))
      ])
    ])
  ])) : P("", !0);
}
const b1e = /* @__PURE__ */ Ae(Zye, [["render", y1e], ["__scopeId", "data-v-b7a9655b"]]), A1e = me({
  name: "ProductSummary",
  props: {
    readOnly: Boolean
  },
  emits: [],
  data() {
    return {};
  },
  watch: {},
  computed: {
    annually: {
      get() {
        return this.chosenBillingPeriod == Qt.Annually;
      },
      set(e) {
        e ? this.chosenBillingPeriod = Qt.Annually : this.chosenBillingPeriod = Qt.Monthly;
      }
    },
    ...at(vn),
    ...q(vn, [
      "products",
      "annualSubTotal",
      "monthlySubTotal",
      "selectedProdcuts",
      "selectedAddOns",
      "loading",
      "isAnnually",
      "automaticDiscount",
      "appliedCouponsBetter",
      "currentDiscounts",
      "activeDiscountAnnualAmount",
      "activeDiscountMonthlyAmount",
      "annualTotal",
      "monthlyTotal",
      "userAppliedCoupons",
      "existingSubscription",
      "managingSubscription",
      "isCurrentDiscountsOnce",
      "isCurrentDiscountsRepeating",
      "currentDiscountsDuration"
    ]),
    ...xm(vn, ["chosenBillingPeriod"])
  },
  methods: {
    number: Ve,
    currency: Yu,
    currencyCents: Ze,
    tierStart(e, t) {
      if (!t) {
        const n = e.filter((r) => !0).sort((r, i) => (i.upTo ?? 0) - (r.upTo ?? 0)).find((r) => !0);
        return n == null ? 1 : (n.upTo ?? 0) + 1;
      }
      const s = e.filter((n) => (n.upTo ?? 1e4) < (t ?? 1e4)).sort((n, r) => (n.upTo ?? 1e4) - (r.upTo ?? 1e4)).find((n) => !0);
      return s == null ? 1 : (s.upTo ?? 0) + 1;
    }
  },
  created() {
  }
}), w1e = { class: "navbar-expand-lg rounded-bottom" }, C1e = { class: "card card-summary mb-3 border overflow-hidden" }, S1e = {
  key: 0,
  class: "loader position-absolute start-0 top-0 end-0 bottom-0 bg-white rounded"
}, P1e = { class: "card-body navbar-toggler p-3" }, k1e = { class: "d-flex justify-content-between align-items-center gap-1" }, E1e = { key: 0 }, I1e = {
  key: 1,
  class: "bg-lava text-white rounded-5 mx-auto p-2 fw-bold col-3 text-center"
}, T1e = {
  class: "btn btn-link text-dark text-decoration-none p-0",
  type: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#ticket",
  "aria-expanded": "false",
  "aria-controls": "ticket"
}, O1e = {
  key: 0,
  class: "text-decoration-line-through small text-body-secondary me-2"
}, R1e = { class: "fs-6 fw-bold" }, L1e = {
  class: "collapse navbar-collapse",
  id: "ticket"
}, B1e = { class: "flex-fill" }, M1e = { class: "card-body text-center border-bottom selected-product" }, x1e = {
  key: 0,
  class: "flex-fill"
}, F1e = { class: "fs-1 fw-bold" }, V1e = { key: 1 }, D1e = { key: 2 }, N1e = {
  key: 0,
  class: "text-body-secondary"
}, j1e = {
  key: 0,
  class: "mt-n4 mx-auto d-none d-md-block"
}, H1e = {
  key: 1,
  class: "mt-n4 bg-lava text-white rounded-5 mx-auto p-2 fw-bold col-3 text-center"
}, U1e = { class: "card-body border-bottom" }, z1e = { class: "table table-sm small" }, W1e = {
  key: 0,
  class: "text-end"
}, G1e = { key: 1 }, Y1e = { class: "card-body" }, X1e = { class: "table table-sm small mb-0" }, q1e = { class: "fw-bold text-end" }, Q1e = {
  key: 0,
  class: "badge text-bg-success-subtle rounded-pill ms-2"
}, K1e = {
  key: 1,
  class: "badge text-bg-success-subtle rounded-pill ms-2"
}, Z1e = {
  key: 0,
  class: "text-end"
}, J1e = { key: 0 }, $1e = {
  key: 0,
  class: "text-end"
}, _1e = { key: 1 }, ebe = {
  colspan: "2",
  class: "fw-bold"
}, tbe = { class: "text-end" }, sbe = { class: "fw-bold" }, abe = {
  colspan: "2",
  class: "text-success"
}, nbe = { key: 0 }, rbe = { key: 1 }, obe = { class: "text-success text-end" }, ibe = { class: "fw-bold" }, lbe = { class: "text-end" }, dbe = { class: "fs-5" }, cbe = {
  key: 2,
  class: "card-body"
};
function ube(e, t, s, n, r, i) {
  var o, l;
  return p(), h("div", w1e, [
    a("div", C1e, [
      e.loading ? (p(), h("div", S1e, t[3] || (t[3] = [
        a("div", { class: "position-absolute start-50 top-50 translate-middle fw-bold text-center" }, [
          a("i", { class: "fa-duotone fa-compass fa-spin text-lava fa-2x mb-2" }),
          a("br"),
          y("Loading ")
        ], -1)
      ]))) : P("", !0),
      a("div", P1e, [
        a("div", k1e, [
          t[8] || (t[8] = a("img", {
            src: Fm,
            alt: "Rescover",
            title: "Rescover",
            loading: "eager",
            height: "25",
            width: "25",
            class: "img-fluid"
          }, null, -1)),
          !e.existingSubscription || e.managingSubscription ? (p(), h("div", E1e, [
            V(a("input", {
              type: "checkbox",
              id: "toggle",
              class: "toggleCheckbox",
              "onUpdate:modelValue": t[0] || (t[0] = (d) => e.annually = d)
            }, null, 512), [
              [Ue, e.annually]
            ]),
            t[4] || (t[4] = a("label", {
              for: "toggle",
              class: "toggleContainer toggleContainer-sm"
            }, [
              a("div", null, "Month"),
              a("div", null, "Annual")
            ], -1))
          ])) : (p(), h("div", I1e, [
            e.isAnnually ? (p(), h(A, { key: 0 }, [
              y(" Annually ")
            ], 64)) : (p(), h(A, { key: 1 }, [
              y(" Monthly ")
            ], 64))
          ])),
          a("div", null, [
            a("button", T1e, [
              e.isAnnually ? (p(), h("span", O1e, g(e.currency(e.monthlyTotal)), 1)) : P("", !0),
              a("b", R1e, [
                e.isAnnually ? (p(), h(A, { key: 0 }, [
                  y(g(e.currency(e.annualTotal / 12)), 1)
                ], 64)) : (p(), h(A, { key: 1 }, [
                  y(g(e.currency(e.monthlyTotal)), 1)
                ], 64))
              ]),
              t[5] || (t[5] = a("small", null, "/mo", -1)),
              t[6] || (t[6] = y()),
              t[7] || (t[7] = a("i", { class: "fa-duotone fa-caret-down ms-1" }, null, -1))
            ])
          ])
        ])
      ]),
      a("div", L1e, [
        a("div", B1e, [
          a("div", M1e, [
            t[10] || (t[10] = a("div", null, " Subscription Summary ", -1)),
            e.readOnly ? P("", !0) : (p(), h("div", x1e, [
              a("span", F1e, [
                e.isAnnually ? (p(), h(A, { key: 0 }, [
                  y(g(e.currency(e.annualTotal / 12)), 1)
                ], 64)) : (p(), h(A, { key: 1 }, [
                  y(g(e.currency(e.monthlyTotal)), 1)
                ], 64))
              ]),
              t[9] || (t[9] = a("small", null, "/mo", -1))
            ])),
            !e.isAnnually && e.isCurrentDiscountsOnce ? (p(), h("div", V1e, " First month ")) : P("", !0),
            !e.isAnnually && e.isCurrentDiscountsRepeating ? (p(), h("div", D1e, " First " + g(e.currentDiscountsDuration) + " months ", 1)) : P("", !0),
            N(ks, {
              name: "slide",
              mode: "out-in"
            }, {
              default: ve(() => [
                e.isAnnually ? (p(), h("small", N1e, g(e.currency(e.annualTotal)) + " Billed Annually ", 1)) : P("", !0)
              ]),
              _: 1
            })
          ]),
          !e.existingSubscription || e.managingSubscription ? (p(), h("div", j1e, [
            V(a("input", {
              type: "checkbox",
              id: "toggle",
              class: "toggleCheckbox",
              "onUpdate:modelValue": t[1] || (t[1] = (d) => e.annually = d)
            }, null, 512), [
              [Ue, e.annually]
            ]),
            t[11] || (t[11] = a("label", {
              for: "toggle",
              class: "toggleContainer mx-auto"
            }, [
              a("div", null, "Monthly"),
              a("div", null, "Annually")
            ], -1))
          ])) : (p(), h("div", H1e, [
            e.isAnnually ? (p(), h(A, { key: 0 }, [
              y(" Annually ")
            ], 64)) : (p(), h(A, { key: 1 }, [
              y(" Monthly ")
            ], 64))
          ])),
          a("div", U1e, [
            a("table", z1e, [
              t[13] || (t[13] = a("thead", null, [
                a("tr", null, [
                  a("th", {
                    colspan: "2",
                    class: "fw-bold"
                  }, " PRODUCTS ")
                ])
              ], -1)),
              a("tbody", null, [
                ((o = e.selectedProdcuts) == null ? void 0 : o.length) > 0 ? (p(!0), h(A, { key: 0 }, D(e.selectedProdcuts, (d) => (p(), h("tr", null, [
                  a("td", null, [
                    d.optionId && !d.mainProduct ? (p(), h(A, { key: 0 }, [
                      y(g(d.name) + " - " + g(d.optionName), 1)
                    ], 64)) : (p(), h(A, { key: 1 }, [
                      y(g(d.optionName ?? d.name), 1)
                    ], 64))
                  ]),
                  e.readOnly ? P("", !0) : (p(), h("td", W1e, [
                    e.subscriptionStore.isIncluded(d) ? (p(), h(A, { key: 0 }, [
                      y(" Included ")
                    ], 64)) : (p(), h(A, { key: 1 }, [
                      e.isAnnually ? (p(), h(A, { key: 0 }, [
                        y(g(e.currency(e.subscriptionStore.productPrice(d, !0) / 12)) + "/mo ", 1)
                      ], 64)) : (p(), h(A, { key: 1 }, [
                        y(g(e.currency(e.subscriptionStore.productPrice(d, !0))) + "/mo ", 1)
                      ], 64))
                    ], 64))
                  ]))
                ]))), 256)) : (p(), h("tr", G1e, t[12] || (t[12] = [
                  a("td", {
                    colspan: "2",
                    class: "text-center"
                  }, " Select a product ", -1)
                ])))
              ])
            ])
          ]),
          a("div", Y1e, [
            a("table", X1e, [
              t[20] || (t[20] = a("thead", null, [
                a("tr", null, [
                  a("th", {
                    colspan: "3",
                    class: "fw-bold"
                  }, " ADD-ONS ")
                ])
              ], -1)),
              a("tbody", null, [
                (((l = e.selectedAddOns) == null ? void 0 : l.length) ?? 0) > 0 ? (p(!0), h(A, { key: 0 }, D(e.selectedAddOns, (d) => (p(), h(A, null, [
                  a("tr", null, [
                    a("td", q1e, g(e.number((d.qty ?? 0) + e.subscriptionStore.includesQty(d))), 1),
                    a("td", null, [
                      y(g(d.optionName ?? d.name) + " ", 1),
                      e.subscriptionStore.includesQty(d) ? (p(), h("span", Q1e, g(e.number(e.subscriptionStore.includesQty(d))) + " included", 1)) : P("", !0),
                      d.tiers ? (p(), h("span", K1e, "Tiered Pricing")) : P("", !0)
                    ]),
                    !d.tiers && !e.readOnly ? (p(), h("td", Z1e, [
                      e.isAnnually ? (p(), h(A, { key: 0 }, [
                        y(g(e.currency((d.qty > 0 ? d.price : 0) / 12)) + "/mo ", 1)
                      ], 64)) : (p(), h(A, { key: 1 }, [
                        y(g(e.currency(d.qty > 0 ? d.price : 0)) + "/mo ", 1)
                      ], 64))
                    ])) : P("", !0)
                  ]),
                  (p(!0), h(A, null, D(d.tiers, (c) => (p(), h(A, null, [
                    e.tierStart(d.tiers, c.upTo) <= d.qty ? (p(), h("tr", J1e, [
                      t[15] || (t[15] = a("td", null, null, -1)),
                      a("td", null, [
                        c.upTo ? (p(), h(A, { key: 0 }, [
                          y(g(e.tierStart(d.tiers, c.upTo)) + "-" + g(c.upTo), 1)
                        ], 64)) : (p(), h(A, { key: 1 }, [
                          y(g(e.tierStart(d.tiers, c.upTo)) + "+ ", 1)
                        ], 64)),
                        t[14] || (t[14] = y(" Units "))
                      ]),
                      e.readOnly ? P("", !0) : (p(), h("td", $1e, g(e.currency(c.amount)) + "/mo ", 1))
                    ])) : P("", !0)
                  ], 64))), 256))
                ], 64))), 256)) : (p(), h("tr", _1e, t[16] || (t[16] = [
                  a("td", {
                    colspan: "2",
                    class: "text-center"
                  }, " No add-ons selected. ", -1)
                ]))),
                e.readOnly ? P("", !0) : (p(), h(A, { key: 2 }, [
                  e.currentDiscounts ? (p(), h(A, { key: 0 }, [
                    a("tr", null, [
                      a("td", ebe, [
                        e.isAnnually ? (p(), h(A, { key: 1 }, [
                          y(" Subtotal ")
                        ], 64)) : (p(), h(A, { key: 0 }, [
                          y(" Total Monthly Cost ")
                        ], 64))
                      ]),
                      a("td", tbe, [
                        a("span", sbe, [
                          e.isAnnually ? (p(), h(A, { key: 0 }, [
                            y(g(e.currencyCents(e.annualSubTotal / 12, !0)), 1)
                          ], 64)) : (p(), h(A, { key: 1 }, [
                            y(g(e.currencyCents(e.monthlySubTotal, !0)), 1)
                          ], 64))
                        ]),
                        t[17] || (t[17] = a("small", null, "/mo", -1))
                      ])
                    ]),
                    (p(!0), h(A, null, D(e.currentDiscounts, (d) => (p(), h("tr", null, [
                      a("td", abe, [
                        y(g(d.description) + " ", 1),
                        !e.isAnnually && (d == null ? void 0 : d.durationType) == "once" ? (p(), h("span", nbe, " First month ")) : P("", !0),
                        !e.isAnnually && (d == null ? void 0 : d.durationType) == "repeating" ? (p(), h("span", rbe, " First " + g(d.duration) + " months ", 1)) : P("", !0)
                      ]),
                      a("td", obe, [
                        a("span", ibe, [
                          e.isAnnually ? (p(), h(A, { key: 0 }, [
                            y(g(e.currencyCents(-(e.subscriptionStore.getDiscountPrice(e.currentDiscounts, d) / 12), !0)), 1)
                          ], 64)) : (p(), h(A, { key: 1 }, [
                            y(g(e.currencyCents(-e.subscriptionStore.getDiscountPrice(e.currentDiscounts, d), !0)), 1)
                          ], 64))
                        ]),
                        t[18] || (t[18] = a("small", null, "/mo", -1))
                      ])
                    ]))), 256))
                  ], 64)) : P("", !0),
                  a("tr", null, [
                    a("td", {
                      colspan: "2",
                      class: "fw-bold fs-5",
                      onClick: t[2] || (t[2] = (d) => e.subscriptionStore.calculatePricesAndDiscounts())
                    }, [
                      !e.isAnnually && e.isCurrentDiscountsOnce ? (p(), h(A, { key: 0 }, [
                        y(" Total Due Today ")
                      ], 64)) : (p(), h(A, { key: 1 }, [
                        y(" Total Monthly Cost ")
                      ], 64))
                    ]),
                    a("td", lbe, [
                      a("b", dbe, [
                        e.isAnnually ? (p(), h(A, { key: 0 }, [
                          y(g(e.currencyCents(e.annualTotal / 12, !0)), 1)
                        ], 64)) : (p(), h(A, { key: 1 }, [
                          y(g(e.currencyCents(e.monthlyTotal, !0)), 1)
                        ], 64))
                      ]),
                      t[19] || (t[19] = a("small", null, "/mo", -1))
                    ])
                  ])
                ], 64))
              ])
            ])
          ]),
          !e.readOnly && !e.isAnnually && (!e.existingSubscription || e.managingSubscription) ? (p(), h("div", cbe, t[21] || (t[21] = [
            a("div", {
              class: "alert alert-info mb-0",
              role: "alert"
            }, [
              a("i", { class: "fa-duotone fa-info-circle me-2" }),
              y("Save 20% with annual billing. ")
            ], -1)
          ]))) : P("", !0)
        ])
      ])
    ])
  ]);
}
const pbe = /* @__PURE__ */ Ae(A1e, [["render", ube], ["__scopeId", "data-v-1299de14"]]);
var qk = "acacia", hbe = function(t) {
  return t === 3 ? "v3" : t;
}, Qk = "https://js.stripe.com", mbe = "".concat(Qk, "/").concat(qk, "/stripe.js"), fbe = /^https:\/\/js\.stripe\.com\/v3\/?(\?.*)?$/, gbe = /^https:\/\/js\.stripe\.com\/(v3|[a-z]+)\/stripe\.js(\?.*)?$/;
var vbe = function(t) {
  return fbe.test(t) || gbe.test(t);
}, ybe = function() {
  for (var t = document.querySelectorAll('script[src^="'.concat(Qk, '"]')), s = 0; s < t.length; s++) {
    var n = t[s];
    if (vbe(n.src))
      return n;
  }
  return null;
}, j2 = function(t) {
  var s = "", n = document.createElement("script");
  n.src = "".concat(mbe).concat(s);
  var r = document.head || document.body;
  if (!r)
    throw new Error("Expected document.body not to be null. Stripe.js requires a <body> element.");
  return r.appendChild(n), n;
}, bbe = function(t, s) {
  !t || !t._registerWrapper || t._registerWrapper({
    name: "stripe-js",
    version: "6.1.0",
    startTime: s
  });
}, nc = null, xp = null, Fp = null, Abe = function(t) {
  return function(s) {
    t(new Error("Failed to load Stripe.js", {
      cause: s
    }));
  };
}, wbe = function(t, s) {
  return function() {
    window.Stripe ? t(window.Stripe) : s(new Error("Stripe.js not available"));
  };
}, Cbe = function(t) {
  return nc !== null ? nc : (nc = new Promise(function(s, n) {
    if (typeof window > "u" || typeof document > "u") {
      s(null);
      return;
    }
    if (window.Stripe) {
      s(window.Stripe);
      return;
    }
    try {
      var r = ybe();
      if (!(r && t)) {
        if (!r)
          r = j2(t);
        else if (r && Fp !== null && xp !== null) {
          var i;
          r.removeEventListener("load", Fp), r.removeEventListener("error", xp), (i = r.parentNode) === null || i === void 0 || i.removeChild(r), r = j2(t);
        }
      }
      Fp = wbe(s, n), xp = Abe(n), r.addEventListener("load", Fp), r.addEventListener("error", xp);
    } catch (o) {
      n(o);
      return;
    }
  }), nc.catch(function(s) {
    return nc = null, Promise.reject(s);
  }));
}, Sbe = function(t, s, n) {
  if (t === null)
    return null;
  var r = s[0], i = r.match(/^pk_test/), o = hbe(t.version), l = qk;
  i && o !== l && console.warn("Stripe.js@".concat(o, " was loaded on the page, but @stripe/stripe-js@").concat("6.1.0", " expected Stripe.js@").concat(l, ". This may result in unexpected behavior. For more information, see https://docs.stripe.com/sdks/stripejs-versioning"));
  var d = t.apply(void 0, s);
  return bbe(d, n), d;
}, rc, Kk = !1, Zk = function() {
  return rc || (rc = Cbe(null).catch(function(t) {
    return rc = null, Promise.reject(t);
  }), rc);
};
Promise.resolve().then(function() {
  return Zk();
}).catch(function(e) {
  Kk || console.warn(e);
});
var Jk = function() {
  for (var t = arguments.length, s = new Array(t), n = 0; n < t; n++)
    s[n] = arguments[n];
  Kk = !0;
  var r = Date.now();
  return Zk().then(function(i) {
    return Sbe(i, s, r);
  });
};
const Xs = !0, Pbe = me({
  name: "SubscriptionManagement",
  components: {
    Product: Kye,
    Addon: b1e,
    ProductSummary: pbe
  },
  props: {
    groupPath: String,
    subscriptionId: Number,
    legacy: Boolean,
    readOnly: Boolean,
    isChild: Boolean,
    stripeKey: String
  },
  emits: [
    "complete"
  ],
  data() {
    return {
      loading: !0,
      busy: !0,
      currentStep: 1,
      cardLoaded: !1,
      cardError: void 0,
      cardType: void 0,
      savingPayment: !1,
      cardHolderName: void 0,
      payment_method: void 0,
      userInfo: void 0,
      emailVerified: !1,
      verifyingEmail: !1,
      email: void 0,
      emailCode: void 0,
      emailChanged: !1,
      validationBusy: !1,
      errorMessage: void 0,
      billingDetailsError: void 0,
      invalidCode: void 0,
      confirmationTokenId: void 0,
      couponCode: void 0,
      invalidCoupon: !1,
      completed: !1,
      redirectUrl: void 0,
      expressCheckoutLoaded: !1,
      direction: "right",
      cardOnFile: !1,
      previewSuccess: !1
    };
  },
  watch: {
    isAnnually(e) {
      this.updatePayment(e);
    },
    monthlySubTotal() {
      this.updatePayment(this.isAnnually);
    },
    annualSubTotal() {
      this.updatePayment(this.isAnnually);
    },
    defaultPaymentMethod(e) {
      this.cardOnFile = e != null;
    }
  },
  computed: {
    hasValidEmail() {
      return `${this.email}`.trim() != "" && /.+@.+\..+/i.test(this.email ?? "") == !0;
    },
    mainProduct() {
      if (this.mainProducts.length > 0)
        return this.mainProducts[0];
    },
    couponAmountStyle() {
      let e = !0;
      return this.appliedCouponsBetter && this.automaticDiscount && this.compatibleUserCoupons.length == 0 || this.userAppliedCoupons.length > 0 && this.automaticDiscount && this.compatibleUserCoupons.length > 0 ? e = !1 : this.userAppliedCoupons.length > 0 && this.automaticDiscount && (e = !0), {
        "d-flex": !0,
        "align-items-baseline": !0,
        "gap-2": !0,
        "py-2": !0,
        "me-3": !0,
        "line-through": e,
        "text-body-tertiary": e
      };
    },
    transitionName() {
      return `slide-${this.direction}`;
    },
    wrapperStyle() {
      return {
        wrapper: !0,
        expanded: this.managingSubscription && this.existingSubscription
      };
    },
    activeProductGroupings() {
      var e;
      return ((e = this.productGroupings) == null ? void 0 : e.filter((t) => this.productsForGrouping(t).length > 0)) ?? [];
    },
    shownCoupons() {
      return this.appliedCouponsBetter && this.automaticDiscount && this.compatibleUserCoupons.length == 0 ? this.userAppliedCoupons : this.userAppliedCoupons.length > 0 && this.automaticDiscount && this.compatibleUserCoupons.length > 0 ? this.currentDiscounts : this.userAppliedCoupons.length > 0 && this.automaticDiscount ? this.userAppliedCoupons : [];
    },
    ...at(vn, ct),
    ...q(vn, [
      "mainProducts",
      "productGroupings",
      "products",
      "addOns",
      "selectableAddOns",
      "monthlySubTotal",
      "annualSubTotal",
      "selectedProdcuts",
      "selectedAddOns",
      "isAnnually",
      "automaticDiscount",
      "appliedCouponsBetter",
      "userAppliedCoupons",
      "activeDiscountAnnualAmount",
      "activeDiscountMonthlyAmount",
      "annualTotal",
      "monthlyTotal",
      "currentDiscounts",
      "firstMonthTotal",
      "monthlyAnnualTotal",
      "subPreview",
      "defaultPaymentMethod",
      "existingSubscription",
      "managingSubscription",
      "isCurrentDiscountsOnce",
      "isCurrentDiscountsRepeating",
      "currentDiscountsDuration",
      "compatibleUserCoupons"
    ]),
    ...xm(vn, ["chosenBillingPeriod"])
  },
  methods: {
    currency: Yu,
    currencyCents: Ze,
    percent: X4,
    number: Ve,
    date: cs,
    productsForGrouping(e) {
      let t = -1e4;
      const s = this.products.filter((n) => n.group == e.name && !n.addOn && n.billingPeriod == this.chosenBillingPeriod && !this.subscriptionStore.isArchivedDisabled(n) && !this.hasActiveAlternative(n)).map((n) => [n.optionId ?? t++, n]);
      return [...new Map(s).values()].sort((n, r) => n.order - r.order);
    },
    hasActiveAlternative(e) {
      return this.products.some((t) => t.archived && t.alternativeId == e.id && t.qty && t.qty > 0);
    },
    async gotoStep(e) {
      switch (console.log("gotoStep", e, this.currentStep), e) {
        case 1:
          bootstrap.Collapse.getOrCreateInstance(this.$refs.collapseProducts).show(), this.currentStep = e;
          break;
        case 2:
          this.selectableAddOns.length == 0 ? this.gotoStep(3) : (bootstrap.Collapse.getOrCreateInstance(this.$refs.collapseAddOns).show(), this.currentStep = e);
          break;
        case 3:
          bootstrap.Collapse.getOrCreateInstance(this.$refs.collapseDiscounts).show(), this.currentStep = e;
          break;
        case 4:
          this.billingDetailsError = void 0, bootstrap.Collapse.getOrCreateInstance(this.$refs.collapsePayment).show(), this.currentStep = e;
          break;
        case 5:
          bootstrap.Collapse.getOrCreateInstance(this.$refs.collapseReview).show(), this.currentStep = e;
          break;
      }
    },
    async setupStripe() {
      var e, t, s, n, r;
      console.log("setupStripe");
      try {
        if (this.email = ((e = this.userInfo) == null ? void 0 : e.email) ?? void 0, !this.stripeKey) {
          this.errorMessage = "Stripe missing key";
          return;
        }
        if (window.stripeClient = await Jk(this.stripeKey), this.elementsOptions = {
          mode: "subscription",
          amount: 0,
          currency: "usd",
          paymentMethodCreation: "manual",
          customerSessionClientSecret: ((t = this.userInfo) == null ? void 0 : t.clientSecret) ?? void 0,
          paymentMethodOptions: {
            card: {
              require_cvc_recollection: !0
            }
          },
          // Fully customizable with appearance API.
          appearance: {
            /*...*/
          }
        }, this.stripeElements = window.stripeClient.elements(this.elementsOptions), this.$refs.paymentElement && !this.cardLoaded) {
          let i;
          (s = this.userInfo) != null && s.email && (i = {
            defaultValues: {
              email: this.userInfo.email
            }
          });
          const o = this.stripeElements.create("linkAuthentication", i);
          o.mount(this.$refs.linkAuthentication), o.on("change", (d) => {
            Xs && console.log("linkAuthentication.change", d), this.emailChanged = this.email !== d.value.email, this.email = d.value.email, this.emailChanged && (this.emailVerified = !1, this.verifyingEmail = !1, this.hasValidEmail && this.billingDetailsError && (this.billingDetailsError = void 0));
          }), o.on("blur", (d) => {
            Xs && console.log("linkAuthentication.blur", d);
          }), o.on("escape", (d) => {
            Xs && console.log("linkAuthentication.escape", d);
          }), o.on("focus", (d) => {
            Xs && console.log("linkAuthentication.focus", d);
          }), o.on("loaderror", (d) => {
            Xs && console.log("linkAuthentication.loaderror", d);
          }), o.on("loaderstart", (d) => {
            Xs && console.log("linkAuthentication.loaderstart", d);
          }), o.on("ready", (d) => {
            Xs && console.log("linkAuthentication.ready", d);
          }), this.addressElement = this.stripeElements.create("address", {
            mode: "billing",
            allowedCountries: ["US"],
            validation: {
              phone: {
                required: "always"
              }
            },
            defaultValues: {
              firstName: (n = this.userInfo) == null ? void 0 : n.firstName,
              lastName: (r = this.userInfo) == null ? void 0 : r.lastName
            },
            fields: {
              phone: "always"
            },
            display: {
              name: "split"
            }
            //   style: style,
            //   iconStyle: 'solid'
          }), this.addressElement.mount(this.$refs.addressElement), this.addressElement.on("blur", (d) => {
            Xs && console.log("address.blur", d);
          }), this.addressElement.on("change", (d) => {
            Xs && console.log("address.change", d);
          }), this.addressElement.on("escape", (d) => {
            Xs && console.log("address.escape", d);
          }), this.addressElement.on("focus", (d) => {
            Xs && console.log("address.focus", d);
          }), this.addressElement.on("loaderror", (d) => {
            Xs && console.log("address.loaderror", d);
          }), this.addressElement.on("loaderstart", (d) => {
            Xs && console.log("address.loaderstart", d);
          }), this.addressElement.on("ready", (d) => {
            Xs && console.log("address.ready", d);
          });
          const l = this.stripeElements.create("expressCheckout", {
            paymentMethods: {
              amazonPay: "auto",
              applePay: "always",
              googlePay: "always",
              link: "auto",
              paypal: "auto"
            },
            wallets: {
              applePay: "always",
              googlePay: "always"
            },
            buttonType: {
              applePay: "subscribe",
              googlePay: "subscribe"
            }
          });
          l.mount(this.$refs.expressCheckout), l.on("click", (d) => {
            Xs && console.log("expressCheckout.click", d);
            let c = "Monthly Subscription", u = Math.trunc(this.monthlyTotal * 100), m = "month";
            this.isAnnually && (c = "Annual Subscription", u = Math.trunc(this.annualTotal * 100), m = "year"), d.resolve({
              billingAddressRequired: !0,
              emailRequired: !0,
              phoneNumberRequired: !0,
              applePay: {
                recurringPaymentRequest: {
                  paymentDescription: c,
                  managementURL: "https://www.rescover.com/account/settings#subscriptionTab",
                  regularBilling: {
                    amount: u,
                    label: c,
                    recurringPaymentIntervalUnit: m,
                    recurringPaymentIntervalCount: 1
                  }
                }
              }
            });
          }), l.on("ready", ({ availablePaymentMethods: d }) => {
            Xs && console.log("expressCheckout.ready", d), this.updatePayment(this.isAnnually), d ? (this.expressCheckoutLoaded = !0, bootstrap.Collapse.getOrCreateInstance(this.$refs.collapseOne).hide()) : bootstrap.Collapse.getOrCreateInstance(this.$refs.collapseOne).show();
          }), l.on("confirm", async (d) => {
            Xs && console.log("expressCheckout.confirm", d);
            try {
              this.busy = !0, this.billingDetailsError = void 0, Ns(d);
              const c = await this.confirmPaymentMethod(d), u = {
                name: d.billingDetails.name,
                phone: d.billingDetails.phone,
                address: d.billingDetails.address
              };
              if (c) {
                const m = await this.subscriptionStore.subscribeGroup(this.confirmationTokenId, d.billingDetails.email, u);
                this.redirectUrl = m.redirectUrl, this.completed = !0, this.$emit("complete", m.redirectUrl);
              }
            } catch (c) {
              this.errorMessage = c.message, Ns(c);
            }
            this.busy = !1;
          }), l.on("blur", (d) => {
            Xs && console.log("expressCheckout.blur", d);
          }), l.on("cancel", (d) => {
            Xs && console.log("expressCheckout.cancel", d);
          }), l.on("escape", (d) => {
            Xs && console.log("expressCheckout.escape", d);
          }), l.on("focus", (d) => {
            Xs && console.log("expressCheckout.focus", d);
          }), l.on("loaderror", (d) => {
            Xs && console.log("expressCheckout.loaderror", d);
          }), this.paymentOptions = {
            fields: {
              billingDetails: {
                email: "auto",
                name: "auto",
                phone: "auto",
                address: "if_required"
              }
            },
            applePay: {
              recurringPaymentRequest: {
                paymentDescription: "Rescover Subscription",
                managementURL: "https://www.rescover.com/account/settings#subscriptionTab",
                regularBilling: {
                  amount: 0,
                  label: "Monthly Subscription",
                  recurringPaymentIntervalUnit: "month",
                  recurringPaymentIntervalCount: 1
                }
              }
            }
            //   style: style,
            //   iconStyle: 'solid'
          }, this.paymentElement = this.stripeElements.create("payment", this.paymentOptions), this.paymentElement.mount(this.$refs.paymentElement), this.paymentElement.on("change", this.cardChange), this.paymentElement.on("loaderror", (d) => {
            console.error("loaderror", d);
          }), this.paymentElement.on("blur", (d) => {
            Xs && console.log("payment.blur", d);
          }), this.paymentElement.on("carddetailschange", (d) => {
            Xs && console.log("payment.carddetailschange", d);
          }), this.paymentElement.on("escape", (d) => {
            Xs && console.log("payment.escape", d);
          }), this.paymentElement.on("focus", (d) => {
            Xs && console.log("payment.focus", d);
          }), this.paymentElement.on("loaderstart", (d) => {
            Xs && console.log("payment.loaderstart", d);
          }), this.paymentElement.on("ready", (d) => {
            Xs && console.log("payment.ready", d);
          }), this.cardLoaded = !0;
        }
      } catch (i) {
        console.error(i), this.errorMessage = "Stripe failed to load";
      }
    },
    cardChange(e) {
      console.log("payment.cardChange", e), e.complete || console.warn("payment.cardChange", e);
    },
    updatePayment(e) {
      var t, s;
      if (console.log("updatePayment", e, this.annualTotal, this.monthlyTotal), !(!this.elementsOptions || !this.paymentOptions)) {
        if (e) {
          const n = Math.trunc(this.annualTotal * 100);
          this.elementsOptions.amount = n, this.paymentOptions.applePay.recurringPaymentRequest.regularBilling.amount = n, this.paymentOptions.applePay.recurringPaymentRequest.regularBilling.recurringPaymentIntervalUnit = "year", this.paymentOptions.applePay.recurringPaymentRequest.regularBilling.recurringPaymentIntervalCount = 1;
        } else {
          const n = Math.trunc(this.monthlyTotal * 100);
          this.elementsOptions.amount = n, this.paymentOptions.applePay.recurringPaymentRequest.regularBilling.amount = n, this.paymentOptions.applePay.recurringPaymentRequest.regularBilling.recurringPaymentIntervalUnit = "month", this.paymentOptions.applePay.recurringPaymentRequest.regularBilling.recurringPaymentIntervalCount = 1;
        }
        (t = this.stripeElements) == null || t.update(this.elementsOptions), (s = this.paymentElement) == null || s.update(this.paymentOptions);
      }
    },
    async requestEmailValidation() {
      console.log("requestEmailValidation");
      try {
        this.errorMessage = void 0, this.invalidCode = void 0, this.validationBusy = !0, this.emailCode = void 0, this.verifyingEmail = await this.subscriptionStore.createEmailValidation(this.email), this.verifyingEmail != !0 && (this.errorMessage = "An error occured trying to send your validatation code. Please try again, or contact support.");
      } catch (e) {
        Ns(e), console.error(e);
      } finally {
        this.validationBusy = !1;
      }
    },
    async validateEmail() {
      console.log("validateEmail");
      try {
        this.errorMessage = void 0, this.invalidCode = void 0, this.validationBusy = !0;
        const e = await this.subscriptionStore.validateEmail(this.email, this.emailCode);
        this.emailVerified = e.status == de.Success, this.emailVerified != !0 ? this.invalidCode = e.message : this.verifyingEmail = !1;
      } catch (e) {
        Ns(e), console.error(e), this.errorMessage = "An error occured trying to validate your code. Please try again, or contact support.";
      } finally {
        this.validationBusy = !1;
      }
    },
    async confirmPaymentMethod(e) {
      console.log("confirmPaymentMethod");
      try {
        this.errorMessage = void 0;
        const { error: t } = await this.stripeElements.submit();
        if (t)
          return e && e.paymentFailed({ reason: "fail" }), Ns(t), this.errorMessage = t.message, !1;
        const { error: s, confirmationToken: n } = await window.stripeClient.createConfirmationToken({
          elements: this.stripeElements,
          params: {
            //return_url: 'https://example.com/order/123/complete'
          }
        });
        return s ? (Ns(s), this.errorMessage = s.message, !1) : (this.confirmationTokenId = n.id, !0);
      } catch (t) {
        this.errorMessage = t.message, Ns(t);
      }
      return !1;
    },
    async applyCoupon() {
      console.log("applyCoupon");
      try {
        this.busy = !0, this.errorMessage = void 0, this.couponCode && (await this.subscriptionStore.applyCoupon(this.couponCode), this.userAppliedCoupons.length > 0 ? this.invalidCoupon = !1 : this.invalidCoupon = !0);
      } catch (e) {
        this.errorMessage = e.message, Ns(e);
      }
      this.busy = !1;
    },
    removeCoupon(e) {
      console.log("removeCoupon");
      try {
        this.busy = !0, this.subscriptionStore.removeCoupon(e), this.invalidCoupon = !1, this.couponCode = void 0;
      } catch (t) {
        this.errorMessage = t.message, Ns(t);
      }
      this.busy = !1;
    },
    async subscribe() {
      console.log("subscribe");
      try {
        this.busy = !0, await this.subscribeLock.runExclusive(async () => {
          var t;
          if (this.errorMessage = void 0, !this.hasValidEmail) {
            this.billingDetailsError = "Email address is required.";
            return;
          }
          const e = await ((t = this.addressElement) == null ? void 0 : t.getValue());
          if (!(e != null && e.complete))
            this.billingDetailsError = "Please first complete the billing details.";
          else if (this.billingDetailsError = void 0, await this.confirmPaymentMethod()) {
            const n = await this.subscriptionStore.subscribeGroup(this.confirmationTokenId, this.email, e.value);
            this.redirectUrl = n.redirectUrl, this.completed = !0, this.$emit("complete", n.redirectUrl);
          }
        });
      } catch (e) {
        this.errorMessage = e.message, Ns(e);
      }
      this.busy = !1;
    },
    async preview() {
      console.log("preview");
      try {
        this.busy = !0, this.gotoStep(5), await this.subscribeLock.runExclusive(async () => {
          this.errorMessage = void 0;
          const e = await this.subscriptionStore.preview();
          this.previewSuccess = !0;
        });
      } catch (e) {
        this.previewSuccess = !1, this.errorMessage = e.message, Ns(e);
      }
      this.busy = !1;
    },
    async confirmChanges() {
      console.log("subscribe");
      try {
        this.busy = !0, await this.subscribeLock.runExclusive(async () => {
          this.errorMessage = void 0, this.billingDetailsError = void 0;
          const e = await this.subscriptionStore.updateSubscription(this.confirmationTokenId);
          this.completed = !0, this.$emit("complete");
        });
      } catch (e) {
        this.errorMessage = e.message, Ns(e);
      }
      this.busy = !1;
    },
    isAutomaticCoupon(e) {
      return this.userAppliedCoupons.some((t) => t.id == e.id) == !1;
    },
    async couponTyped(e) {
      e.key == "Enter" && await this.applyCoupon();
    },
    toggleDirection() {
      this.direction = this.managingSubscription ? "right" : "left", this.subscriptionStore.toggleManageSubscription();
    },
    convertToAnnual() {
      this.toggleDirection(), this.chosenBillingPeriod = Qt.Annually;
    }
  },
  mounted() {
    this.subscribeLock = new xa(), console.log("mounted"), this.accountStore.accountLoaded.then(async () => {
      this.subscriptionId ? this.userInfo = await this.subscriptionStore.loadSubscription(this.subscriptionId) : this.userInfo = await this.subscriptionStore.loadProductGroup(this.groupPath);
    }).then(async () => {
      const e = new URLSearchParams(window.location.search);
      this.couponCode = e.get("c"), this.couponCode && await this.applyCoupon();
    }).then(async () => await this.setupStripe()).catch(() => {
      this.errorMessage = "An error occured retrieving product selections, please try again after a few minutes or contact support.";
    }).finally(() => {
      this.loading = !1, this.busy = !1;
    }), this.$refs.emailCodeInput && this.$refs.emailCodeInput.addEventListener("input", (e) => e.target.style.setProperty("--_otp-digit", e.target.selectionStart));
  }
}), kbe = "/images/logo-stripe.svg?no-inline", Ebe = { class: "container" }, Ibe = {
  key: 0,
  class: "row"
}, Tbe = { class: "col" }, Obe = { class: "alert alert-danger" }, Rbe = {
  key: 1,
  class: "card-completed position-absolute top-50 start-50 translate-middle"
}, Lbe = { class: "col-12" }, Bbe = { class: "d-flex w-100 h-100 justify-content-center align-items-center" }, Mbe = { class: "card border shadow-lg card-complete" }, xbe = { class: "card-body p-5 text-center" }, Fbe = { class: "fw-bold fs-4 mt-4 mb-3" }, Vbe = ["href"], Dbe = {
  key: 1,
  class: "mb-0"
}, Nbe = {
  key: 2,
  class: "mb-0"
}, jbe = {
  key: 2,
  class: "row"
}, Hbe = { class: "col-lg-7 order-2 order-lg-1" }, Ube = {
  class: "accordion",
  id: "accordionSubscription",
  ref: "accordionSubscription"
}, zbe = { class: "accordion-item" }, Wbe = { class: "accordion-header" }, Gbe = { key: 0 }, Ybe = {
  key: 1,
  class: "fa-duotone fa-circle-check text-success"
}, Xbe = { class: "ms-2 flex-grow-1 d-flex align-items-center" }, qbe = {
  key: 0,
  type: "button",
  class: "btn btn-link btn-sm ms-auto"
}, Qbe = {
  id: "collapseProducts",
  ref: "collapseProducts",
  class: "accordion-collapse collapse show position-relative",
  "data-bs-parent": "#accordionSubscription"
}, Kbe = {
  key: 0,
  class: "loader position-absolute start-0 top-0 end-0 bottom-0 bg-white rounded-bottom p-5"
}, Zbe = { class: "accordion-body p-0" }, Jbe = { class: "bg-subheader fw-bold p-2" }, $be = {
  key: 0,
  class: "pt-3 px-3"
}, _be = {
  class: "alert alert-info mb-0",
  role: "alert"
}, eAe = { class: "d-flex p-3" }, tAe = { class: "accordion-item" }, sAe = { class: "accordion-header" }, aAe = ["disabled"], nAe = { key: 0 }, rAe = {
  key: 1,
  class: "fa-duotone fa-circle-check text-success"
}, oAe = { class: "ms-2 flex-grow-1 d-flex align-items-center" }, iAe = {
  key: 0,
  type: "button",
  class: "btn btn-link btn-sm ms-auto btn-edit"
}, lAe = {
  id: "collapseAddOns",
  ref: "collapseAddOns",
  class: "accordion-collapse collapse position-relative",
  "data-bs-parent": "#accordionSubscription"
}, dAe = {
  key: 0,
  class: "loader position-absolute start-0 top-0 end-0 bottom-0 bg-white rounded-bottom"
}, cAe = { class: "accordion-body p-0" }, uAe = { class: "d-flex border-top p-3" }, pAe = { class: "accordion-item" }, hAe = { class: "accordion-header" }, mAe = { key: 0 }, fAe = {
  key: 1,
  class: "fa-duotone fa-circle-check text-success"
}, gAe = { class: "ms-2 flex-grow-1 d-flex align-items-center" }, vAe = {
  key: 0,
  type: "button",
  class: "btn btn-link btn-sm ms-auto"
}, yAe = {
  id: "collapseDiscounts",
  ref: "collapseDiscounts",
  class: "accordion-collapse collapse position-relative",
  "data-bs-parent": "#accordionSubscription"
}, bAe = {
  key: 0,
  class: "loader position-absolute start-0 top-0 end-0 bottom-0 bg-white rounded-bottom"
}, AAe = { class: "accordion-body p-0" }, wAe = {
  key: 0,
  class: "col-12"
}, CAe = { class: "d-flex flex-row align-items-top text-success p-2 bg-success-subtle" }, SAe = {
  key: 1,
  class: "col-12"
}, PAe = { class: "d-flex flex-row align-items-top text-success p-2 bg-success-subtle" }, kAe = {
  key: 2,
  class: "col-12"
}, EAe = { class: "d-flex flex-row align-items-top text-success p-2 bg-success-subtle" }, IAe = {
  key: 3,
  class: "border-bottom"
}, TAe = { class: "row g-0" }, OAe = { class: "col-9 d-flex align-items-center" }, RAe = { class: "ps-3 py-2 d-flex flex-column" }, LAe = { class: "fw-bold text-success" }, BAe = { class: "col-3 d-flex align-items-center justify-content-end" }, MAe = { class: "d-flex align-items-baseline gap-2 py-2 pe-3 text-success" }, xAe = { class: "fs-4" }, FAe = { class: "row g-0" }, VAe = { class: "col-2 col-lg-1" }, DAe = { class: "border-end h-100 d-flex align-items-center justify-content-center" }, NAe = {
  key: 0,
  type: "button",
  class: "btn text-danger"
}, jAe = ["onClick"], HAe = { class: "col-7 col-lg-8 d-flex align-items-center" }, UAe = { class: "ps-3 py-2 d-flex flex-column" }, zAe = { class: "fw-bold" }, WAe = {
  key: 0,
  class: "text-body-secondary small"
}, GAe = {
  key: 1,
  class: "text-body-secondary small"
}, YAe = { class: "col-3 d-flex align-items-center justify-content-end" }, XAe = { class: "fs-4" }, qAe = {
  key: 4,
  class: "p-3 border-bottom"
}, QAe = { class: "row" }, KAe = { class: "col" }, ZAe = { class: "input-group" }, JAe = ["disabled"], $Ae = ["disabled"], _Ae = {
  key: 0,
  class: "col-12"
}, e0e = { class: "d-flex flex-row p-3 border-bottom" }, t0e = { class: "form-check me-2" }, s0e = {
  class: "d-flex flex-row flex-grow-1",
  for: "check-monthly"
}, a0e = { class: "d-flex flex-column align-items-end justify-content-end ms-auto" }, n0e = { class: "text-end fw-bold" }, r0e = { class: "fs-4" }, o0e = { class: "text-body-tertiary text-end" }, i0e = { key: 0 }, l0e = { key: 1 }, d0e = { class: "d-flex flex-row p-3" }, c0e = { class: "form-check me-2" }, u0e = {
  class: "d-flex flex-row flex-grow-1",
  for: "check-yearly"
}, p0e = { class: "d-flex flex-column align-items-end justify-content-end ms-auto" }, h0e = { class: "text-end fw-bold" }, m0e = { class: "fs-4" }, f0e = { class: "text-body-tertiary text-end" }, g0e = { class: "d-flex border-top p-3" }, v0e = ["disabled"], y0e = { class: "accordion-item accordion-item-payment" }, b0e = { class: "accordion-header" }, A0e = { key: 0 }, w0e = {
  key: 1,
  class: "fa-duotone fa-circle-check text-success"
}, C0e = { class: "ms-2 flex-grow-1 d-flex align-items-center" }, S0e = {
  key: 0,
  type: "button",
  class: "btn btn-link btn-sm ms-auto"
}, P0e = {
  id: "collapsePayment",
  ref: "collapsePayment",
  class: "accordion-collapse collapse position-relative",
  "data-bs-parent": "#accordionSubscription"
}, k0e = {
  key: 0,
  class: "loader position-absolute start-0 top-0 end-0 bottom-0 bg-white rounded-bottom"
}, E0e = {
  key: 1,
  class: "loader position-absolute start-0 top-0 end-0 bottom-0 bg-white rounded-bottom"
}, I0e = { class: "accordion-body p-0" }, T0e = { class: "row p-3 border-bottom align-items-center bg-light" }, O0e = {
  key: 0,
  class: "col-12 text-success small text-end"
}, R0e = { class: "col-6 text-end" }, L0e = {
  key: 0,
  class: "text-decoration-line-through text-body-secondary me-2"
}, B0e = { class: "fs-5" }, M0e = { class: "fw-bold" }, x0e = { class: "fw-bold" }, F0e = { key: 0 }, V0e = {
  key: 0,
  class: "d-flex flex-row p-3 border-bottom"
}, D0e = { class: "form-check me-2" }, N0e = {
  class: "d-flex flex-row flex-grow-1",
  for: "existing-card"
}, j0e = { class: "me-3" }, H0e = { class: "fw-bold" }, U0e = { class: "d-flex flex-row p-3 border-bottom" }, z0e = { class: "form-check me-2" }, W0e = { class: "p-3" }, G0e = { class: "mb-3" }, Y0e = {
  id: "express-checkout-element",
  ref: "expressCheckout"
}, X0e = { class: "accordion-item bg-light border-1 overflow-visible rounded" }, q0e = { class: "accordion-header text-center" }, Q0e = {
  key: 0,
  class: "bg-secondary rounded-circle small text-white position-absolute top-0 start-50 translate-middle p-2"
}, K0e = {
  id: "collapseOne",
  ref: "collapseOne",
  class: "accordion-collapse collapse border-0 show",
  "data-bs-parent": "#accordionManualCheckout"
}, Z0e = { class: "accordion-body" }, J0e = { class: "d-flex justify-content-between align-items-center mb-3" }, $0e = {
  id: "link-authentication-element",
  ref: "linkAuthentication",
  class: "flex-fill"
}, _0e = {
  id: "address-element",
  ref: "addressElement"
}, ewe = { class: "my-3" }, twe = {
  id: "card-element",
  ref: "paymentElement"
}, swe = {
  key: 1,
  class: "p-3"
}, awe = { class: "col" }, nwe = { class: "alert alert-danger" }, rwe = { class: "d-flex border-top p-3" }, owe = {
  key: 0,
  class: "text-danger"
}, iwe = ["disabled"], lwe = ["disabled"], dwe = {
  key: 0,
  class: "accordion-item accordion-item-review"
}, cwe = { class: "accordion-header" }, uwe = {
  class: "accordion-button collapsed",
  type: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#collapseReview",
  "aria-expanded": "false",
  "aria-controls": "collapseReview"
}, pwe = { key: 0 }, hwe = {
  key: 1,
  class: "fa-duotone fa-circle-check text-success"
}, mwe = { class: "ms-2 flex-grow-1 d-flex align-items-center" }, fwe = {
  key: 0,
  type: "button",
  class: "btn btn-link btn-sm ms-auto"
}, gwe = {
  id: "collapseReview",
  ref: "collapseReview",
  class: "accordion-collapse collapse position-relative",
  "data-bs-parent": "#accordionSubscription"
}, vwe = {
  key: 0,
  class: "loader position-absolute start-0 top-0 end-0 bottom-0 bg-white rounded-bottom"
}, ywe = {
  key: 1,
  class: "loader position-absolute start-0 top-0 end-0 bottom-0 bg-white rounded-bottom"
}, bwe = { class: "accordion-body p-0" }, Awe = { class: "px-3 py-2 border-bottom" }, wwe = { class: "row" }, Cwe = { class: "col-12 text-truncate" }, Swe = { class: "col-5 col-lg-6 text-body-secondary small text-truncate" }, Pwe = { class: "col-2 text-center" }, kwe = { class: "col-2 text-end" }, Ewe = { class: "col-3 col-lg-2 text-end" }, Iwe = { class: "px-3 py-2 border-bottom" }, Twe = { class: "row" }, Owe = { class: "col-7 col-lg-6 text-end" }, Rwe = { class: "px-3 py-2 border-bottom" }, Lwe = { class: "row" }, Bwe = { class: "col-9 col-lg-10 text-truncate" }, Mwe = { class: "col-3 col-lg-2 text-end" }, xwe = { class: "px-3 py-2 border-bottom" }, Fwe = { class: "row" }, Vwe = { class: "col-3 col-lg-2 text-end" }, Dwe = {
  key: 0,
  class: "px-3 py-2 border-bottom"
}, Nwe = { class: "row" }, jwe = { class: "col-3 col-lg-2 text-end" }, Hwe = { class: "px-3 py-2 fw-bold bg-light fs-4" }, Uwe = { class: "row" }, zwe = { class: "col-3 text-end" }, Wwe = {
  key: 1,
  class: "p-3"
}, Gwe = { class: "col" }, Ywe = {
  key: 0,
  class: "alert alert-info"
}, Xwe = {
  key: 1,
  class: "alert alert-danger"
}, qwe = { class: "d-flex border-top p-3" }, Qwe = ["disabled"], Kwe = { class: "col-lg-5 sticky-top flex-column order-1 order-lg-2" }, Zwe = {
  key: 0,
  class: "alert alert-info d-flex justify-content-between align-items-center gap-2 mt-3"
}, Jwe = {
  key: 1,
  class: "alert alert-info d-flex justify-content-between align-items-center gap-2 mt-3"
};
function $we(e, t, s, n, r, i) {
  const o = pe("product"), l = pe("addon"), d = pe("product-summary");
  return p(), h("div", {
    class: z(e.wrapperStyle)
  }, [
    a("div", Ebe, [
      e.errorMessage && e.currentStep < 4 ? (p(), h("div", Ibe, [
        a("div", Tbe, [
          a("div", Obe, [
            t[19] || (t[19] = a("i", { class: "fa-duotone fa-triangle-exclamation me-2" }, null, -1)),
            y(g(e.errorMessage), 1)
          ])
        ])
      ])) : P("", !0),
      e.completed ? (p(), h("div", Rbe, [
        a("div", Lbe, [
          a("div", Bbe, [
            a("div", Mbe, [
              a("div", xbe, [
                t[23] || (t[23] = a("img", {
                  src: hI,
                  alt: "Rescover",
                  title: "Rescover",
                  class: "img-fluid",
                  height: "100"
                }, null, -1)),
                a("h1", Fbe, [
                  t[20] || (t[20] = y("Subscription ")),
                  e.existingSubscription ? (p(), h(A, { key: 0 }, [
                    y("updated")
                  ], 64)) : (p(), h(A, { key: 1 }, [
                    y("complete")
                  ], 64))
                ]),
                e.redirectUrl && !e.isChild ? (p(), h(A, { key: 0 }, [
                  t[22] || (t[22] = a("p", { class: "mb-4" }, "Please use the following link to complete your account registration.", -1)),
                  a("a", {
                    href: e.redirectUrl,
                    class: "btn btn-lava text-white"
                  }, t[21] || (t[21] = [
                    y("Complete Account Signup "),
                    a("i", { class: "fa-duotone fa-solid fa-chevron-right ms-1" }, null, -1)
                  ]), 8, Vbe)
                ], 64)) : !e.isChild && !e.existingSubscription ? (p(), h("p", Dbe, "Please check your email to complete your account registration.")) : (p(), h("p", Nbe, "Your subscription has succesfully been updated."))
              ])
            ])
          ])
        ])
      ])) : (p(), h("div", jbe, [
        N(ks, { name: e.transitionName }, {
          default: ve(() => {
            var c, u, m, f, v, b, w, S, I, T, x, k, C, O;
            return [
              V(a("div", Hbe, [
                a("div", Ube, [
                  a("div", zbe, [
                    a("h2", Wbe, [
                      a("button", {
                        class: "accordion-button",
                        type: "button",
                        ref: "btnCollapseProducts",
                        onClick: t[0] || (t[0] = (E) => e.gotoStep(1)),
                        "data-bs-toggle": "collapse",
                        "data-bs-target": "#collapseProducts",
                        "aria-expanded": "true",
                        "aria-controls": "collapseProducts"
                      }, [
                        e.currentStep <= 1 ? (p(), h("span", Gbe, "1")) : (p(), h("i", Ybe)),
                        a("span", Xbe, [
                          t[24] || (t[24] = y(" Choose your products")),
                          e.currentStep > 1 ? (p(), h("span", qbe, "Edit")) : P("", !0)
                        ])
                      ], 512)
                    ]),
                    a("div", Qbe, [
                      e.loading ? (p(), h("div", Kbe, t[25] || (t[25] = [
                        a("div", { class: "position-absolute start-50 top-50 translate-middle fw-bold text-center" }, [
                          a("i", { class: "fa-duotone fa-compass fa-spin text-lava fa-2x mb-2" }),
                          a("br"),
                          y("Loading ")
                        ], -1)
                      ]))) : P("", !0),
                      a("div", Zbe, [
                        e.mainProduct ? (p(), Fe(o, {
                          key: 0,
                          product: e.mainProduct,
                          main: ""
                        }, null, 8, ["product"])) : P("", !0),
                        (p(!0), h(A, null, D(e.activeProductGroupings, (E) => (p(), h(A, null, [
                          a("div", Jbe, g(E.name), 1),
                          E.info ? (p(), h("div", $be, [
                            a("div", _be, [
                              t[26] || (t[26] = a("i", { class: "fa-duotone fa-info-circle me-2" }, null, -1)),
                              y(g(E.info), 1)
                            ])
                          ])) : P("", !0),
                          (p(!0), h(A, null, D(e.productsForGrouping(E), (B) => (p(), Fe(o, {
                            product: B,
                            key: B.id
                          }, null, 8, ["product"]))), 128))
                        ], 64))), 256)),
                        a("div", eAe, [
                          a("button", {
                            type: "button",
                            class: "btn btn-lava ms-auto",
                            onClick: t[1] || (t[1] = (E) => e.gotoStep(2))
                          }, "Continue")
                        ])
                      ])
                    ], 512)
                  ]),
                  a("div", tAe, [
                    a("h2", sAe, [
                      a("button", {
                        class: "accordion-button collapsed",
                        ref: "btnCollapseAddOns",
                        type: "button",
                        onClick: t[2] || (t[2] = (E) => e.gotoStep(2)),
                        "data-bs-toggle": "collapse",
                        "data-bs-target": "#collapseAddOns",
                        "aria-expanded": "false",
                        "aria-controls": "collapseAddOns",
                        disabled: e.selectableAddOns.length == 0
                      }, [
                        e.currentStep <= 2 ? (p(), h("span", nAe, "2")) : (p(), h("i", rAe)),
                        a("span", oAe, [
                          t[27] || (t[27] = y(" Choose your Add-ons")),
                          e.currentStep > 2 ? (p(), h("span", iAe, "Edit")) : P("", !0)
                        ])
                      ], 8, aAe)
                    ]),
                    a("div", lAe, [
                      e.loading ? (p(), h("div", dAe, t[28] || (t[28] = [
                        a("div", { class: "position-absolute start-50 top-50 translate-middle fw-bold text-center" }, [
                          a("i", { class: "fa-duotone fa-compass fa-spin text-lava fa-2x mb-2" }),
                          a("br"),
                          y("Loading ")
                        ], -1)
                      ]))) : P("", !0),
                      a("div", cAe, [
                        a("div", null, [
                          t[29] || (t[29] = a("div", { class: "d-flex justify-content-end p-2 border-bottom" }, [
                            a("span", { class: "text-body-secondary" }, "Prices are monthly per license")
                          ], -1)),
                          (p(!0), h(A, null, D(e.addOns, (E) => (p(), Fe(l, {
                            product: E,
                            key: E.id
                          }, null, 8, ["product"]))), 128))
                        ]),
                        a("div", uAe, [
                          a("button", {
                            type: "button",
                            class: "btn btn-lava ms-auto",
                            onClick: t[3] || (t[3] = (E) => e.gotoStep(3))
                          }, "Continue")
                        ])
                      ])
                    ], 512)
                  ]),
                  a("div", pAe, [
                    a("h2", hAe, [
                      a("button", {
                        class: "accordion-button collapsed",
                        type: "button",
                        onClick: t[4] || (t[4] = (E) => e.gotoStep(3)),
                        "data-bs-toggle": "collapse",
                        "data-bs-target": "#collapseDiscounts",
                        "aria-expanded": "false",
                        "aria-controls": "collapseDiscounts"
                      }, [
                        e.currentStep <= 3 ? (p(), h("span", mAe, "3")) : (p(), h("i", fAe)),
                        a("span", gAe, [
                          t[30] || (t[30] = y(" Discounts and Billing Cycle")),
                          e.currentStep > 3 ? (p(), h("span", vAe, "Edit")) : P("", !0)
                        ])
                      ])
                    ]),
                    a("div", yAe, [
                      e.loading ? (p(), h("div", bAe, t[31] || (t[31] = [
                        a("div", { class: "position-absolute start-50 top-50 translate-middle fw-bold text-center" }, [
                          a("i", { class: "fa-duotone fa-compass fa-spin text-lava fa-2x mb-2" }),
                          a("br"),
                          y("Loading ")
                        ], -1)
                      ]))) : P("", !0),
                      a("div", AAe, [
                        a("div", null, [
                          e.appliedCouponsBetter && e.automaticDiscount && e.compatibleUserCoupons.length == 0 ? (p(), h("div", wAe, [
                            a("div", CAe, [
                              t[34] || (t[34] = a("i", { class: "fa-duotone fa-tags me-2 mt-2" }, null, -1)),
                              a("span", null, [
                                t[32] || (t[32] = y("Congratulations, you have a great deal! We've replaced the ")),
                                a("b", null, "Automatic " + g((c = e.automaticDiscount) == null ? void 0 : c.description), 1),
                                t[33] || (t[33] = y(" with your coupon."))
                              ])
                            ])
                          ])) : e.userAppliedCoupons.length > 0 && e.automaticDiscount && e.compatibleUserCoupons.length > 0 ? (p(), h("div", SAe, [
                            a("div", PAe, [
                              t[38] || (t[38] = a("i", { class: "fa-duotone fa-tags me-2 mt-2" }, null, -1)),
                              a("span", null, [
                                t[35] || (t[35] = y(" Your automatic discount of ")),
                                a("b", null, [
                                  ((u = e.automaticDiscount) == null ? void 0 : u.type) == "amount" ? (p(), h(A, { key: 0 }, [
                                    y(g(e.currency((m = e.automaticDiscount) == null ? void 0 : m.value)), 1)
                                  ], 64)) : (p(), h(A, { key: 1 }, [
                                    y(g(e.percent((f = e.automaticDiscount) == null ? void 0 : f.value)), 1)
                                  ], 64))
                                ]),
                                t[36] || (t[36] = y(" off along with ")),
                                a("b", null, g(e.number(e.compatibleUserCoupons.length)), 1),
                                t[37] || (t[37] = y(" other coupon is a better deal! We've kept the automatic discount and other coupon applied. "))
                              ])
                            ])
                          ])) : e.userAppliedCoupons.length > 0 && e.automaticDiscount ? (p(), h("div", kAe, [
                            a("div", EAe, [
                              t[41] || (t[41] = a("i", { class: "fa-duotone fa-tags me-2 mt-2" }, null, -1)),
                              a("span", null, [
                                t[39] || (t[39] = y(" Your automatic discount of ")),
                                a("b", null, [
                                  ((v = e.automaticDiscount) == null ? void 0 : v.type) == "amount" ? (p(), h(A, { key: 0 }, [
                                    y(g(e.currency((b = e.automaticDiscount) == null ? void 0 : b.value)), 1)
                                  ], 64)) : (p(), h(A, { key: 1 }, [
                                    y(g(e.percent((w = e.automaticDiscount) == null ? void 0 : w.value)), 1)
                                  ], 64))
                                ]),
                                t[40] || (t[40] = y(" off is a better deal! We've kept the automatic discount applied. "))
                              ])
                            ])
                          ])) : e.automaticDiscount ? (p(), h("div", IAe, [
                            a("div", TAe, [
                              a("div", OAe, [
                                a("div", RAe, [
                                  a("span", LAe, [
                                    t[42] || (t[42] = a("i", { class: "fa-duotone fa-tags me-2 mt-2" }, null, -1)),
                                    y("Automatic " + g(e.automaticDiscount.description), 1)
                                  ])
                                ])
                              ]),
                              a("div", BAe, [
                                a("div", MAe, [
                                  a("span", xAe, [
                                    e.automaticDiscount.type == "amount" ? (p(), h(A, { key: 0 }, [
                                      y(g(e.currency(e.automaticDiscount.value)), 1)
                                    ], 64)) : P("", !0),
                                    y(" " + g(e.percent(e.automaticDiscount.value)), 1)
                                  ]),
                                  t[43] || (t[43] = y()),
                                  t[44] || (t[44] = a("small", null, "off", -1))
                                ])
                              ])
                            ])
                          ])) : P("", !0),
                          (p(!0), h(A, null, D(e.shownCoupons, (E) => (p(), h("div", {
                            class: "border-bottom",
                            key: E.id
                          }, [
                            a("div", FAe, [
                              a("div", VAe, [
                                a("div", DAe, [
                                  e.isAutomaticCoupon(E) ? P("", !0) : (p(), h("button", NAe, [
                                    a("i", {
                                      class: "fa-duotone fa-solid fa-trash-can",
                                      onClick: (B) => e.removeCoupon(E.id)
                                    }, null, 8, jAe)
                                  ]))
                                ])
                              ]),
                              a("div", HAe, [
                                a("div", UAe, [
                                  a("span", zAe, [
                                    t[45] || (t[45] = a("i", { class: "fa-duotone fa-solid fa-piggy-bank text-success me-2" }, null, -1)),
                                    y(g(E.description), 1)
                                  ]),
                                  E.durationType == "once" ? (p(), h("span", WAe, " First month ")) : P("", !0),
                                  E.durationType == "repeating" ? (p(), h("span", GAe, " First " + g(E.duration) + " months ", 1)) : P("", !0)
                                ])
                              ]),
                              a("div", YAe, [
                                a("div", {
                                  class: z(e.couponAmountStyle)
                                }, [
                                  a("span", XAe, [
                                    E.type == "amount" ? (p(), h(A, { key: 0 }, [
                                      y(g(e.currency(E.value)), 1)
                                    ], 64)) : (p(), h(A, { key: 1 }, [
                                      y(g(e.percent(E.value)), 1)
                                    ], 64))
                                  ]),
                                  t[46] || (t[46] = y()),
                                  t[47] || (t[47] = a("small", null, "off", -1))
                                ], 2)
                              ])
                            ])
                          ]))), 128)),
                          e.userAppliedCoupons.length == 0 ? (p(), h("div", qAe, [
                            a("div", QAe, [
                              a("div", KAe, [
                                a("div", ZAe, [
                                  V(a("input", {
                                    type: "text",
                                    class: "form-control",
                                    placeholder: "Coupon Code",
                                    "onUpdate:modelValue": t[5] || (t[5] = (E) => e.couponCode = E),
                                    disabled: e.userAppliedCoupons.length > 0,
                                    onKeyup: t[6] || (t[6] = (...E) => e.couponTyped && e.couponTyped(...E))
                                  }, null, 40, JAe), [
                                    [_e, e.couponCode]
                                  ]),
                                  a("button", {
                                    type: "button",
                                    class: "btn btn-success",
                                    onClick: t[7] || (t[7] = (...E) => e.applyCoupon && e.applyCoupon(...E)),
                                    disabled: e.busy || e.userAppliedCoupons.length > 0
                                  }, "Apply", 8, $Ae)
                                ])
                              ]),
                              e.invalidCoupon ? (p(), h("div", _Ae, t[48] || (t[48] = [
                                a("div", { class: "d-flex flex-row align-items-top text-danger mt-2" }, [
                                  a("i", { class: "fa-duotone fa-circle-exclamation me-2 mt-2" }),
                                  a("span", null, "Sorry, you entered an expired or invalid coupon code.")
                                ], -1)
                              ]))) : P("", !0)
                            ])
                          ])) : P("", !0),
                          a("div", e0e, [
                            a("div", t0e, [
                              V(a("input", {
                                type: "radio",
                                class: "form-check-input",
                                id: "check-monthly",
                                name: "contract",
                                value: 2,
                                "onUpdate:modelValue": t[8] || (t[8] = (E) => e.chosenBillingPeriod = E)
                              }, null, 512), [
                                [Mt, e.chosenBillingPeriod]
                              ])
                            ]),
                            a("label", s0e, [
                              t[50] || (t[50] = a("div", { class: "me-3" }, [
                                a("span", { class: "fw-bold" }, "Monthly"),
                                a("br"),
                                y(" Month to Month ")
                              ], -1)),
                              a("div", a0e, [
                                a("div", n0e, [
                                  a("span", r0e, g(e.currencyCents(e.firstMonthTotal, !0)), 1),
                                  t[49] || (t[49] = a("small", null, "/mo", -1))
                                ]),
                                a("span", o0e, [
                                  e.isCurrentDiscountsOnce ? (p(), h("span", i0e, " First month ")) : P("", !0),
                                  e.isCurrentDiscountsRepeating ? (p(), h("span", l0e, " First " + g(e.currentDiscountsDuration) + " months ", 1)) : P("", !0)
                                ])
                              ])
                            ])
                          ]),
                          a("div", d0e, [
                            a("div", c0e, [
                              V(a("input", {
                                type: "radio",
                                class: "form-check-input",
                                id: "check-yearly",
                                name: "contract",
                                value: 16,
                                "onUpdate:modelValue": t[9] || (t[9] = (E) => e.chosenBillingPeriod = E)
                              }, null, 512), [
                                [Mt, e.chosenBillingPeriod]
                              ])
                            ]),
                            a("label", u0e, [
                              t[52] || (t[52] = a("div", { class: "me-3" }, [
                                a("span", { class: "fw-bold" }, "Annual Pre-Pay"),
                                a("br"),
                                y(" Save 20% with annual billing ")
                              ], -1)),
                              a("div", p0e, [
                                a("div", h0e, [
                                  a("span", m0e, g(e.currencyCents(e.annualTotal / 12, !0)), 1),
                                  t[51] || (t[51] = a("small", null, "/mo", -1))
                                ]),
                                a("span", f0e, " Save " + g(e.currencyCents(e.subscriptionStore.billingPeriodSavings, !1)) + " when billed annually ", 1)
                              ])
                            ])
                          ])
                        ]),
                        a("div", g0e, [
                          a("button", {
                            type: "button",
                            class: "btn btn-lava ms-auto",
                            onClick: t[10] || (t[10] = (E) => e.gotoStep(4)),
                            disabled: e.busy
                          }, "Continue", 8, v0e)
                        ])
                      ])
                    ], 512)
                  ]),
                  a("div", y0e, [
                    a("h2", b0e, [
                      a("button", {
                        class: "accordion-button collapsed",
                        type: "button",
                        onClick: t[11] || (t[11] = (E) => e.gotoStep(4)),
                        "data-bs-toggle": "collapse",
                        "data-bs-target": "#collapsePayment",
                        "aria-expanded": "false",
                        "aria-controls": "collapsePayment"
                      }, [
                        e.currentStep <= 4 ? (p(), h("span", A0e, "4")) : (p(), h("i", w0e)),
                        a("span", C0e, [
                          t[53] || (t[53] = y(" Payment")),
                          e.currentStep > 4 ? (p(), h("span", S0e, "Edit")) : P("", !0)
                        ])
                      ])
                    ]),
                    a("div", P0e, [
                      e.loading ? (p(), h("div", k0e, t[54] || (t[54] = [
                        a("div", { class: "position-absolute start-50 top-50 translate-middle fw-bold text-center" }, [
                          a("i", { class: "fa-duotone fa-compass fa-spin text-lava fa-2x mb-2" }),
                          a("br"),
                          y("Loading ")
                        ], -1)
                      ]))) : e.busy ? (p(), h("div", E0e, t[55] || (t[55] = [
                        a("div", { class: "position-absolute start-50 top-50 translate-middle fw-bold text-center" }, [
                          a("i", { class: "fa-duotone fa-compass fa-spin text-lava fa-2x mb-2" }),
                          a("br"),
                          y("Creating Subscription... ")
                        ], -1)
                      ]))) : P("", !0),
                      a("div", I0e, [
                        a("div", T0e, [
                          e.isAnnually ? (p(), h("div", O0e, [
                            t[56] || (t[56] = a("i", { class: "fa-duotone fa-tags me-1" }, null, -1)),
                            y("You're saving " + g(e.currencyCents(e.subscriptionStore.billingPeriodSavings, !1)) + " with annual billing! ", 1)
                          ])) : P("", !0),
                          t[60] || (t[60] = a("div", { class: "col fw-bold fs-6" }, " Total Due ", -1)),
                          a("div", R0e, [
                            e.isAnnually ? (p(), h("span", L0e, [
                              y(g(e.currencyCents(e.monthlyAnnualTotal, !0)), 1),
                              t[57] || (t[57] = a("small", null, "/yr", -1))
                            ])) : P("", !0),
                            a("span", B0e, [
                              e.isAnnually ? (p(), h(A, { key: 0 }, [
                                a("span", M0e, g(e.currencyCents(e.annualTotal, !0)), 1),
                                t[58] || (t[58] = a("small", null, "/yr", -1))
                              ], 64)) : (p(), h(A, { key: 1 }, [
                                a("span", x0e, g(e.currencyCents(e.monthlyTotal, !0)), 1),
                                t[59] || (t[59] = a("small", null, "/mo", -1))
                              ], 64))
                            ])
                          ])
                        ]),
                        e.existingSubscription ? (p(), h("div", F0e, [
                          e.defaultPaymentMethod ? (p(), h("div", V0e, [
                            a("div", D0e, [
                              V(a("input", {
                                type: "radio",
                                class: "form-check-input",
                                id: "existing-card",
                                name: "payment-method",
                                value: !0,
                                "onUpdate:modelValue": t[12] || (t[12] = (E) => e.cardOnFile = E)
                              }, null, 512), [
                                [Mt, e.cardOnFile]
                              ])
                            ]),
                            a("label", N0e, [
                              a("div", j0e, [
                                a("span", H0e, "Existing card on file ending in " + g(e.defaultPaymentMethod.last4), 1),
                                t[61] || (t[61] = a("br", null, null, -1))
                              ])
                            ])
                          ])) : P("", !0),
                          a("div", U0e, [
                            a("div", z0e, [
                              V(a("input", {
                                type: "radio",
                                class: "form-check-input",
                                id: "new-card",
                                name: "payment-method",
                                value: !1,
                                "onUpdate:modelValue": t[13] || (t[13] = (E) => e.cardOnFile = E)
                              }, null, 512), [
                                [Mt, e.cardOnFile]
                              ])
                            ]),
                            t[62] || (t[62] = a("label", {
                              class: "d-flex flex-row flex-grow-1",
                              for: "new-card"
                            }, [
                              a("div", { class: "me-3" }, [
                                a("span", { class: "fw-bold" }, "Add new Card")
                              ])
                            ], -1))
                          ])
                        ])) : P("", !0),
                        a("div", W0e, [
                          V(a("div", G0e, [
                            t[63] || (t[63] = a("div", { class: "text-center fw-bold mb-3" }, " Express Checkout ", -1)),
                            a("div", Y0e, null, 512)
                          ], 512), [
                            [Us, !e.cardOnFile && e.expressCheckoutLoaded]
                          ]),
                          V(a("div", {
                            class: z(["accordion", { "mt-5": e.expressCheckoutLoaded }]),
                            id: "accordionManualCheckout"
                          }, [
                            a("div", X0e, [
                              a("h2", q0e, [
                                a("button", {
                                  class: z(["accordion-button bg-light fw-bold justify-content-center", { "pt-4": e.expressCheckoutLoaded }]),
                                  type: "button",
                                  "data-bs-toggle": "collapse",
                                  "data-bs-target": "#collapseOne",
                                  "aria-expanded": "true",
                                  "aria-controls": "collapseOne",
                                  style: { "box-shadow": "none" }
                                }, [
                                  e.expressCheckoutLoaded ? (p(), h("span", Q0e, "OR")) : P("", !0),
                                  t[64] || (t[64] = y(" Card & Bank Payment ")),
                                  t[65] || (t[65] = a("i", { class: "fa-duotone fa-solid fa-chevron-down ms-2" }, null, -1))
                                ], 2)
                              ]),
                              a("div", K0e, [
                                a("div", Z0e, [
                                  a("div", J0e, [
                                    a("div", $0e, null, 512)
                                  ]),
                                  a("div", _0e, null, 512),
                                  a("div", ewe, [
                                    a("div", twe, null, 512),
                                    e.cardError ? (p(), h("div", {
                                      key: 0,
                                      id: "card-errors",
                                      style: { color: "red" },
                                      ref: "cardErrors",
                                      role: "alert"
                                    }, g(e.cardError), 513)) : P("", !0)
                                  ])
                                ])
                              ], 512)
                            ])
                          ], 2), [
                            [Us, !e.cardOnFile]
                          ]),
                          t[66] || (t[66] = a("div", { class: "text-center" }, [
                            a("i", { class: "fa-duotone fa-circle-info me-2 text-info" }),
                            y("Payments are processed securely through "),
                            a("img", {
                              src: kbe,
                              alt: "stripe",
                              title: "stripe",
                              class: "img-fluid",
                              loading: "lazy",
                              width: "50"
                            })
                          ], -1))
                        ]),
                        e.errorMessage ? (p(), h("div", swe, [
                          a("div", awe, [
                            a("div", nwe, [
                              t[67] || (t[67] = a("i", { class: "fa-duotone fa-triangle-exclamation me-2" }, null, -1)),
                              y(g(e.errorMessage), 1)
                            ])
                          ])
                        ])) : P("", !0),
                        a("div", rwe, [
                          e.billingDetailsError ? (p(), h("div", owe, [
                            t[68] || (t[68] = a("i", { class: "fa-duotone fa-circle-exclamation me-2" }, null, -1)),
                            y(" " + g(e.billingDetailsError), 1)
                          ])) : P("", !0),
                          e.existingSubscription ? (p(), h("button", {
                            key: 2,
                            type: "button",
                            class: "btn btn-lava ms-auto",
                            onClick: t[15] || (t[15] = (...E) => e.preview && e.preview(...E)),
                            disabled: e.busy || e.completed
                          }, "Review & Confirm Changes", 8, lwe)) : (p(), h("button", {
                            key: 1,
                            type: "button",
                            class: "btn btn-lava ms-auto",
                            onClick: t[14] || (t[14] = (...E) => e.subscribe && e.subscribe(...E)),
                            disabled: e.busy || e.completed
                          }, "Subscribe", 8, iwe))
                        ])
                      ])
                    ], 512)
                  ]),
                  e.existingSubscription ? (p(), h("div", dwe, [
                    a("h2", cwe, [
                      a("button", uwe, [
                        e.currentStep <= 5 ? (p(), h("span", pwe, "5")) : (p(), h("i", hwe)),
                        a("span", mwe, [
                          t[69] || (t[69] = y(" Review & Confirm")),
                          e.currentStep > 5 ? (p(), h("span", fwe, "Edit")) : P("", !0)
                        ])
                      ])
                    ]),
                    a("div", gwe, [
                      e.loading ? (p(), h("div", vwe, t[70] || (t[70] = [
                        a("div", { class: "position-absolute start-50 top-50 translate-middle fw-bold text-center" }, [
                          a("i", { class: "fa-duotone fa-compass fa-spin text-lava fa-2x mb-2" }),
                          a("br"),
                          y("Loading ")
                        ], -1)
                      ]))) : e.busy ? (p(), h("div", ywe, t[71] || (t[71] = [
                        a("div", { class: "position-absolute start-50 top-50 translate-middle fw-bold text-center" }, [
                          a("i", { class: "fa-duotone fa-compass fa-spin text-lava fa-2x mb-2" }),
                          a("br"),
                          y("Calculating changes... ")
                        ], -1)
                      ]))) : P("", !0),
                      a("div", bwe, [
                        t[79] || (t[79] = a("div", { class: "p-3" }, [
                          a("span", { class: "fw-bold" }, "Effective changes as of today"),
                          a("br"),
                          a("small", null, "These changes will apply immediately, and you will be billed today.")
                        ], -1)),
                        t[80] || (t[80] = a("div", { class: "px-3 py-2 border-bottom fw-bold small text-uppercase text-body-tertiary" }, [
                          a("div", { class: "row" }, [
                            a("div", { class: "col-5 col-lg-6" }, "Description"),
                            a("div", { class: "col-2 text-center" }, "Qty"),
                            a("div", { class: "col-2 text-end" }, "Unit Price"),
                            a("div", { class: "col-3 col-lg-2 text-end" }, "Amount")
                          ])
                        ], -1)),
                        (p(!0), h(A, null, D((S = e.subPreview) == null ? void 0 : S.lines, (E) => (p(), h("div", Awe, [
                          a("div", wwe, [
                            a("div", Cwe, g(E.description), 1),
                            a("div", Swe, [
                              t[72] || (t[72] = a("span", { class: "d-none d-lg-inline-block" }, "Period:", -1)),
                              y(" " + g(e.date(E.start, !0)) + " - " + g(e.date(E.end, !0)), 1)
                            ]),
                            a("div", Pwe, g(e.number(E.qty)), 1),
                            a("div", kwe, g(e.currency(E.unitAmount)), 1),
                            a("div", Ewe, g(e.currency(E.amount)), 1)
                          ])
                        ]))), 256)),
                        a("div", Iwe, [
                          a("div", Twe, [
                            t[73] || (t[73] = a("div", { class: "col-5 col-lg-6 fw-bold" }, " Subtotal ", -1)),
                            a("div", Owe, g(e.currency((I = e.subPreview) == null ? void 0 : I.subtotal)), 1)
                          ])
                        ]),
                        a("div", Rwe, [
                          (p(!0), h(A, null, D((T = e.subPreview) == null ? void 0 : T.credits, (E) => (p(), h("div", Lwe, [
                            a("div", Bwe, g(E.description), 1),
                            a("div", Mwe, g(e.currency(E.amount)), 1)
                          ]))), 256))
                        ]),
                        a("div", xwe, [
                          a("div", Fwe, [
                            t[74] || (t[74] = a("div", { class: "col-9 col-lg-10 fw-bold" }, " Total ", -1)),
                            a("div", Vwe, g(e.currency((x = e.subPreview) == null ? void 0 : x.total)), 1)
                          ])
                        ]),
                        (k = e.subPreview) != null && k.appliedBalance && e.subPreview.appliedBalance != 0 ? (p(), h("div", Dwe, [
                          a("div", Nwe, [
                            t[75] || (t[75] = a("div", { class: "col-9 col-lg-10 fw-bold" }, " Applied Balance ", -1)),
                            a("div", jwe, g(e.currency((C = e.subPreview) == null ? void 0 : C.appliedBalance)), 1)
                          ])
                        ])) : P("", !0),
                        a("div", Hwe, [
                          a("div", Uwe, [
                            t[76] || (t[76] = a("div", { class: "col-9" }, " Amount Due ", -1)),
                            a("div", zwe, g(e.currency((O = e.subPreview) == null ? void 0 : O.due)), 1)
                          ])
                        ]),
                        e.errorMessage || !e.previewSuccess ? (p(), h("div", Wwe, [
                          a("div", Gwe, [
                            e.previewSuccess ? P("", !0) : (p(), h("div", Ywe, t[77] || (t[77] = [
                              a("i", { class: "fa-duotone fa-circle-exclamation me-2" }, null, -1),
                              y("Please review and confirm payment method first. ")
                            ]))),
                            e.errorMessage ? (p(), h("div", Xwe, [
                              t[78] || (t[78] = a("i", { class: "fa-duotone fa-triangle-exclamation me-2" }, null, -1)),
                              y(g(e.errorMessage), 1)
                            ])) : P("", !0)
                          ])
                        ])) : P("", !0),
                        a("div", qwe, [
                          a("button", {
                            type: "button",
                            class: "btn btn-lava ms-auto",
                            onClick: t[16] || (t[16] = (...E) => e.confirmChanges && e.confirmChanges(...E)),
                            disabled: e.busy || e.completed || !e.previewSuccess
                          }, "Confirm Changes", 8, Qwe)
                        ])
                      ])
                    ], 512)
                  ])) : P("", !0)
                ], 512)
              ], 512), [
                [Us, !e.existingSubscription || e.managingSubscription]
              ])
            ];
          }),
          _: 1
        }, 8, ["name"]),
        a("div", Kwe, [
          N(d, { "read-only": e.readOnly }, null, 8, ["read-only"]),
          e.legacy ? (p(), h("span", Zwe, t[81] || (t[81] = [
            a("i", { class: "fa-solid fa-duotone fa-info-circle me-2" }, null, -1),
            y("Your Rescover subscription includes legacy products and pricing. Please contact support to make changes. ")
          ]))) : (p(), h(A, { key: 1 }, [
            !e.readOnly && e.existingSubscription && !e.managingSubscription ? (p(), h("button", {
              key: 0,
              class: "btn btn-lava",
              onClick: t[17] || (t[17] = (...c) => e.toggleDirection && e.toggleDirection(...c))
            }, "Manage Subscription")) : P("", !0),
            !e.readOnly && !e.isAnnually && e.existingSubscription && !e.managingSubscription && e.subscriptionStore.billingPeriodSavings > 0 ? (p(), h("div", Jwe, [
              a("span", null, [
                t[82] || (t[82] = a("i", { class: "fa-solid fa-duotone fa-info-circle me-2" }, null, -1)),
                a("b", null, "Save " + g(e.currencyCents(e.subscriptionStore.billingPeriodSavings, !1)), 1),
                t[83] || (t[83] = y(" by converting to an Annual Subscription."))
              ]),
              a("button", {
                type: "button",
                class: "btn btn-lava",
                onClick: t[18] || (t[18] = (...c) => e.convertToAnnual && e.convertToAnnual(...c))
              }, "Convert")
            ])) : P("", !0),
            P("", !0)
          ], 64))
        ])
      ]))
    ])
  ], 2);
}
const _we = /* @__PURE__ */ Ae(Pbe, [["render", $we], ["__scopeId", "data-v-f316f684"]]), e2e = me({
  name: "Subscriptions",
  props: {
    stripeKey: String
  },
  components: {
    ContentLoader: Sa,
    SubscriptionManagement: _we
  },
  data() {
    return {
      loadingSubscriptions: !0,
      selectedSubscriptionId: void 0,
      legacy: !1,
      newSubscription: !1
    };
  },
  computed: {
    canManageSubscription() {
      return this.isUser == !1 && this.isClient == !1;
    },
    ...at(Te, vn),
    ...q(Te, ["access", "aclLoaded", "isClient", "isAdmin", "isUser"]),
    ...q(vn, ["courtesyOf", "subscriptions"])
  },
  methods: {
    number: Ve,
    currency: Ze,
    percent: Wt,
    shortDate: cs,
    shortUTCDate: Y4,
    async loadSubscriptions() {
      try {
        this.loadingSubscriptions = !0, await this.subscriptionStore.loadSubscriptions(), this.subscriptions.length > 0 && (this.selectedSubscriptionId = this.subscriptions[0].id, this.legacy = this.subscriptions[0].group != "default");
      } catch (e) {
        Se(e);
      }
      this.loadingSubscriptions = !1;
    },
    openSupport() {
      rf("support");
    }
  },
  mounted() {
    this.aclLoaded.then(async () => await this.loadSubscriptions());
  }
}), t2e = { class: "row" }, s2e = { class: "col" }, a2e = {
  key: 0,
  class: "card border"
}, n2e = { class: "card-body p-5 text-center" }, r2e = {
  key: 1,
  class: "card border"
}, o2e = { class: "card-body p-5 text-center" }, i2e = ["src"], l2e = { class: "fs-5 mb-2" }, d2e = {
  key: 2,
  class: "card border mb-3"
}, c2e = { class: "card-body d-flex flex-row align-items-center" }, u2e = ["src"], p2e = { class: "mb-0" }, h2e = {
  key: 0,
  class: "subscription-management"
};
function m2e(e, t, s, n, r, i) {
  var l, d, c, u, m, f, v;
  const o = pe("subscription-management");
  return p(), h(A, null, [
    t[8] || (t[8] = a("div", { class: "row mb-3" }, [
      a("div", { class: "col" }, [
        a("h2", { class: "fw-bold fs-3 mb-0" }, "Subscriptions")
      ])
    ], -1)),
    a("div", t2e, [
      a("div", s2e, [
        !e.newSubscription && e.subscriptions.length == 0 && !(e.isClient && ((l = e.courtesyOf) != null && l.company)) ? (p(), h("div", a2e, [
          a("div", n2e, [
            t[1] || (t[1] = a("p", { class: "fw-bold fs-4 mb-2" }, "No Active Subscription", -1)),
            t[2] || (t[2] = a("p", { class: "mb-4" }, "Your account does not currently have any active subscriptions/products.", -1)),
            !e.isUser && !e.isClient ? (p(), h("button", {
              key: 0,
              type: "button",
              class: "btn btn-lava",
              onClick: t[0] || (t[0] = (b) => e.newSubscription = !0)
            }, "View Subscription Options")) : P("", !0)
          ])
        ])) : P("", !0),
        e.isClient && e.subscriptions.length == 0 ? (p(), h("div", r2e, [
          a("div", o2e, [
            (d = e.courtesyOf) != null && d.companyLogo ? (p(), h("img", {
              key: 0,
              src: (c = e.courtesyOf) == null ? void 0 : c.companyLogo,
              class: "rounded img-fluid mb-4",
              height: "250",
              width: "250"
            }, null, 8, i2e)) : P("", !0),
            a("p", l2e, [
              t[3] || (t[3] = y("Your Rescover guest user subscription is provided courtesy of ")),
              a("b", null, g((u = e.courtesyOf) == null ? void 0 : u.company), 1),
              t[4] || (t[4] = y("."))
            ]),
            t[5] || (t[5] = a("br", null, null, -1)),
            t[6] || (t[6] = a("button", {
              type: "button",
              class: "btn btn-lava"
            }, "Unlink My Account", -1))
          ])
        ])) : P("", !0),
        e.isUser ? (p(), h("div", d2e, [
          a("div", c2e, [
            (m = e.courtesyOf) != null && m.companyLogo ? (p(), h("img", {
              key: 0,
              src: (f = e.courtesyOf) == null ? void 0 : f.companyLogo,
              class: "rounded me-3",
              width: "80"
            }, null, 8, u2e)) : P("", !0),
            a("div", null, [
              t[7] || (t[7] = a("p", { class: "fw-bold fs-5 mb-0" }, "Sub-account", -1)),
              a("p", p2e, "Your Rescover subscription is provided courtesy of " + g((v = e.courtesyOf) == null ? void 0 : v.company) + ".", 1)
            ])
          ])
        ])) : P("", !0)
      ])
    ]),
    e.subscriptions.length == 0 && !e.isUser && !e.isClient || e.isAdmin || e.isUser ? (p(), h("div", h2e, [
      e.newSubscription || e.selectedSubscriptionId ? (p(), Fe(o, {
        key: 0,
        "stripe-key": e.stripeKey,
        "subscription-id": e.selectedSubscriptionId,
        "read-only": e.isUser,
        legacy: e.legacy,
        "is-child": ""
      }, null, 8, ["stripe-key", "subscription-id", "read-only", "legacy"])) : P("", !0)
    ])) : P("", !0)
  ], 64);
}
const Sls = /* @__PURE__ */ Ae(e2e, [["render", m2e]]), f2e = me({
  name: "Billing",
  inject: {
    rscConfig: {
      from: Zd
    }
  },
  data() {
    return {
      paymentMethods: [],
      invoices: [],
      savingPayment: !1,
      cardHolderName: void 0,
      defaultPaymentMethod: void 0,
      cardType: void 0,
      cardError: void 0,
      cardLoaded: !1,
      deleting: !1,
      deletePmId: void 0,
      failedToGetPaymentMethods: void 0,
      failedToRetrieveInvoices: void 0
    };
  },
  computed: {
    ...at(Te),
    ...q(Te, ["access", "aclLoaded"])
  },
  methods: {
    number: Ve,
    currency: Ze,
    formatDate: sb,
    async loadPaymentMethods() {
      try {
        this.paymentMethods.length = 0;
        const e = await W.api.billing.getPaymentMethods();
        if (e.data.status != de.Success)
          throw new Error(e.data.message);
        this.paymentMethods.push(...e.data.paymentMethods), this.defaultPaymentMethod = e.data.defaultPaymentMethod;
      } catch {
        this.failedToGetPaymentMethods = !0;
      }
    },
    async loadInvoices() {
      try {
        this.invoices.length = 0;
        const e = await W.api.billing.getInvoices();
        if (e.data.status != de.Success)
          throw new Error(e.data.message);
        this.invoices.push(...e.data.invoices);
      } catch {
        this.failedToRetrieveInvoices = !0;
      }
    },
    //#region Stripe Card
    cardChange(e) {
      console.log(`${this.$options.name}.cardChange`, e), e != null && e.complete ? (this.cardType = e.brand, this.cardError = void 0) : e != null && e.error && (this.cardError = e.error.message);
    },
    async savePayment() {
      var s;
      if (console.log(`${this.$options.name}.savePayment`), !this.cardHolderName) {
        this.cardError = "Card holder name required!";
        return;
      }
      this.savingPayment = !0;
      const { paymentMethod: e, error: t } = await this.stripe.createPaymentMethod({
        element: this.cardElement,
        params: {
          billing_details: {
            name: this.cardHolderName
          }
        }
      });
      if (t)
        this.defaultPaymentMethod = void 0, this.cardError = t.message;
      else
        try {
          const n = await W.api.billing.addPaymentMethod(e.id);
          if (n.data.status != de.Success)
            throw new Error(n.data.message);
          this.cardError = void 0, this.defaultPaymentMethod = e.id, this.cardElement.update({ disabled: !0 }), (s = bootstrap.Modal.getOrCreateInstance(this.$refs.modalPayment)) == null || s.hide(), wt("Payment method saved"), await this.loadPaymentMethods();
        } catch (n) {
          this.cardError = n.message;
        }
      this.savingPayment = !1;
    },
    //#endregion
    async setDefaultPaymentMethod(e) {
      console.log(`${this.$options.name}.setDefaultPaymentMethod`, e);
      try {
        await W.api.billing.setDefaultPaymentMethod(e), this.defaultPaymentMethod = e;
      } catch (t) {
        Ns(t), Se("Failed to set default payment method");
      }
    },
    viewPdf(e) {
      window.open(e.pdfUrl, "_blank");
    },
    viewDeletePayment(e) {
      this.deletePmId = e;
      const t = bootstrap.Modal.getOrCreateInstance(this.$refs.modalDeletePayment);
      t == null || t.show();
    },
    async deletePayment() {
      this.deleting = !0;
      try {
        const e = await W.api.billing.removePaymentMethod(this.deletePmId);
        if (e.data.status != de.Success)
          throw new Error(e.data.message);
        const t = bootstrap.Modal.getOrCreateInstance(this.$refs.modalDeletePayment);
        t == null || t.hide(), wt("Payment method deleted"), await this.loadPaymentMethods(), this.deletePmId = void 0;
      } catch (e) {
        Ns(e), Se("Failed to delete payment method");
      }
      this.deleting = !1;
    }
  },
  mounted() {
    this.aclLoaded.then(() => {
      this.loadPaymentMethods(), this.loadInvoices();
    }), Jk(this.rscConfig.StripeKey).then((e) => {
      this.stripe = e;
      const t = {
        base: {
          color: "#32325d",
          fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
          fontSmoothing: "antialiased",
          fontSize: "16px",
          "::placeholder": {
            color: "#aab7c4"
          }
        },
        invalid: {
          color: "#fa755a",
          iconColor: "#fa755a"
        }
      }, s = this.stripe.elements();
      this.$refs.cardElement && !this.cardLoaded && (this.cardElement = s.create("card", {
        style: t,
        iconStyle: "solid"
      }), this.cardElement.mount(this.$refs.cardElement), this.cardElement.on("change", this.cardChange), this.cardLoaded = !0);
    });
  }
}), g2e = { class: "card shadow-sm mb-7" }, v2e = { class: "card-body p-0" }, y2e = {
  key: 0,
  class: "alert alert-warning m-3"
}, b2e = { class: "p-2 p-md-4 border-bottom d-flex justify-content-between border-bottom align-items-center method" }, A2e = { class: "d-flex gap-2 flex-fill flex-column flex-md-row" }, w2e = { class: "d-flex align-items-center" }, C2e = { class: "fw-bold" }, S2e = { class: "flex-fill d-flex justify-content-between align-items-center" }, P2e = {
  key: 0,
  class: "badge rounded-pill badge-lava me-auto"
}, k2e = ["onClick"], E2e = { class: "text-secondary" }, I2e = ["onClick"], T2e = { class: "row" }, O2e = { class: "col" }, R2e = {
  class: "card shadow",
  style: { overflow: "hidden" }
}, L2e = {
  key: 0,
  class: "alert alert-warning m-3"
}, B2e = { class: "table-responsive" }, M2e = { class: "table table-striped table-borderless mb-0" }, x2e = { class: "text-uppercase" }, F2e = ["onClick"], V2e = {
  class: "modal fade",
  id: "modalPayment",
  ref: "modalPayment",
  tabindex: "-1",
  "aria-labelledby": "PaymentModalLabel",
  "aria-hidden": "true"
}, D2e = { class: "modal-dialog modal-dialog-centered" }, N2e = { class: "modal-content bg-gradient-alphabet rounded" }, j2e = { class: "modal-body" }, H2e = { class: "ccPayment" }, U2e = { class: "mb-3" }, z2e = ["disabled"], W2e = { class: "bg-white bg-opacity-50 rounded p-3" }, G2e = {
  id: "card-element",
  ref: "cardElement"
}, Y2e = { class: "modal-footer border-0 pt-0" }, X2e = ["disabled"], q2e = {
  class: "modal fade",
  id: "modalDeletePayment",
  ref: "modalDeletePayment",
  tabindex: "-1",
  "aria-labelledby": "PaymentModalLabel",
  "aria-hidden": "true"
}, Q2e = { class: "modal-dialog modal-dialog-centered" }, K2e = { class: "modal-content bg-gradient-alphabet rounded" }, Z2e = { class: "modal-body" }, J2e = { class: "ccPayment" }, $2e = ["disabled"];
function _2e(e, t, s, n, r, i) {
  return p(), h(A, null, [
    t[13] || (t[13] = a("h2", { class: "fw-bold fs-3" }, "Payment Methods", -1)),
    a("div", g2e, [
      a("div", v2e, [
        e.failedToGetPaymentMethods ? (p(), h("div", y2e, " We ran into a issue retrieving your list of payment methods. Please try again or contact support. ")) : P("", !0),
        (p(!0), h(A, null, D(e.paymentMethods, (o) => (p(), h("div", b2e, [
          a("div", A2e, [
            a("div", w2e, [
              a("i", {
                class: z(["fa-brands text-info fa-2x me-2", "fa-cc-" + o.card.brand])
              }, null, 2),
              a("span", C2e, g(o.card.brand.toUpperCase()) + " ending in " + g(o.card.last4), 1)
            ]),
            a("div", S2e, [
              e.defaultPaymentMethod && o.id == e.defaultPaymentMethod ? (p(), h("span", P2e, "Default")) : (p(), h("button", {
                key: 1,
                onClick: (l) => e.setDefaultPaymentMethod(o.id),
                class: "btn btn-secondary btn-sm set-default d-none me-auto"
              }, "Set as default", 8, k2e)),
              a("div", E2e, " Exp: " + g(o.card.expMonth) + "/" + g(o.card.expYear), 1)
            ])
          ]),
          a("button", {
            onClick: (l) => e.viewDeletePayment(o.id),
            class: "btn btn-outline-danger btn-sm ms-3"
          }, t[3] || (t[3] = [
            a("i", { class: "fa-light fa-trash" }, null, -1)
          ]), 8, I2e)
        ]))), 256))
      ]),
      t[4] || (t[4] = a("div", { class: "card-footer border-0 bg-white d-flex" }, [
        a("button", {
          type: "button",
          "data-bs-toggle": "modal",
          "data-bs-target": "#modalPayment",
          class: "btn btn-eclipse rounded-pill ms-auto"
        }, [
          a("i", { class: "fa-light fa-plus me-2" }),
          y("Add Payment Method ")
        ])
      ], -1))
    ]),
    t[14] || (t[14] = a("h2", { class: "fw-bold fs-3 mb-3" }, "Payment History", -1)),
    a("div", T2e, [
      a("div", O2e, [
        a("div", R2e, [
          e.failedToRetrieveInvoices ? (p(), h("div", L2e, " We ran into a issue retrieving your list of invoices. Please try again or contact support. ")) : P("", !0),
          a("div", B2e, [
            a("table", M2e, [
              t[6] || (t[6] = a("thead", null, [
                a("tr", null, [
                  a("th", null, "Status"),
                  a("th", null, "Invoice #"),
                  a("th", null, "Created"),
                  a("th", null, "Amount"),
                  a("th", null, "Invoice")
                ])
              ], -1)),
              a("tbody", null, [
                (p(!0), h(A, null, D(e.invoices, (o) => (p(), h("tr", null, [
                  a("td", x2e, g(o.status), 1),
                  a("td", null, g(o.number), 1),
                  a("td", null, g(e.formatDate(o.date)), 1),
                  a("td", null, g(e.currency(o.total, !0)), 1),
                  a("td", null, [
                    a("button", {
                      onClick: (l) => e.viewPdf(o),
                      class: "btn btn-sm btn-outline-eclipse"
                    }, t[5] || (t[5] = [
                      a("i", { class: "fa-light fa-file-pdf me-2" }, null, -1),
                      y("PDF ")
                    ]), 8, F2e)
                  ])
                ]))), 256))
              ])
            ])
          ])
        ])
      ])
    ]),
    a("div", V2e, [
      a("div", D2e, [
        a("div", N2e, [
          t[10] || (t[10] = a("div", { class: "modal-header border-0 pb-0" }, [
            a("p", {
              class: "modal-title fw-bold fs-5",
              id: "PaymentModalLabel"
            }, "Payment information"),
            a("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            })
          ], -1)),
          a("div", j2e, [
            a("div", H2e, [
              a("div", U2e, [
                t[7] || (t[7] = a("label", {
                  for: "card-holder-name",
                  class: "form-label"
                }, "Name on Card", -1)),
                V(a("input", {
                  type: "text",
                  "onUpdate:modelValue": t[0] || (t[0] = (o) => e.cardHolderName = o),
                  disabled: e.savingPayment,
                  class: "form-control",
                  id: "card-holder-name"
                }, null, 8, z2e), [
                  [_e, e.cardHolderName]
                ]),
                t[8] || (t[8] = a("small", {
                  id: "emailHelp",
                  class: "form-text text-body-secondary"
                }, "Enter the full name of the person on the card.", -1))
              ]),
              a("div", W2e, [
                a("div", null, [
                  t[9] || (t[9] = a("label", {
                    for: "card-element",
                    class: "form-label"
                  }, "Card to Charge", -1)),
                  a("div", G2e, null, 512),
                  e.cardError ? (p(), h("div", {
                    key: 0,
                    id: "card-errors",
                    class: "text-danger",
                    ref: "cardErrors",
                    role: "alert"
                  }, g(e.cardError), 513)) : P("", !0)
                ])
              ])
            ])
          ]),
          a("div", Y2e, [
            a("button", {
              type: "button",
              onClick: t[1] || (t[1] = (...o) => e.savePayment && e.savePayment(...o)),
              disabled: e.savingPayment,
              id: "card-button",
              ref: "cardButton",
              class: "btn btn-info"
            }, " Save Payment Method ", 8, X2e)
          ])
        ])
      ])
    ], 512),
    a("div", q2e, [
      a("div", Q2e, [
        a("div", K2e, [
          t[12] || (t[12] = a("div", { class: "modal-header border-0 pb-0" }, [
            a("p", {
              class: "modal-title fw-bold fs-5",
              id: "PaymentModalLabel"
            }, "Delete Payment Method"),
            a("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            })
          ], -1)),
          a("div", Z2e, [
            a("div", J2e, [
              t[11] || (t[11] = a("p", null, [
                y(" Are you sure you want to delete this payment method?"),
                a("br"),
                y(" This action cannot be undone. ")
              ], -1)),
              a("button", {
                type: "button",
                onClick: t[2] || (t[2] = (...o) => e.deletePayment && e.deletePayment(...o)),
                id: "card-button",
                disabled: e.deleting,
                class: "btn btn-danger"
              }, " Delete Payment Method ", 8, $2e)
            ])
          ])
        ])
      ])
    ], 512)
  ], 64);
}
const Pls = /* @__PURE__ */ Ae(f2e, [["render", _2e]]), eCe = me({
  name: "BrandAssociation",
  props: {
    apiKey: {
      type: String,
      required: !1
    }
  },
  components: {},
  data() {
    return {
      busy: !1,
      myBrand: void 0,
      linkKey: void 0
    };
  },
  computed: {
    hasBrand() {
      return this.myBrand != null;
    },
    ...at(Te),
    ...q(Te, ["access", "aclLoaded"])
  },
  methods: {
    async getBrand() {
      try {
        const e = await W.api.brand.getBrandInfo();
        if (e.data.status != de.Success)
          throw new Error(e.data.message);
        this.myBrand = e.data.myBrand;
      } catch (e) {
        Se(e);
      }
    },
    async sendLinkKey() {
      this.busy = !0;
      try {
        if (this.linkKey) {
          const e = await W.api.brand.associateAccount(this.linkKey);
          if (e.data.status != de.Success)
            throw new Error(e.data.message);
          this.linkKey = void 0, wt("Link Key sent"), await this.getBrand();
        } else
          Mi("Link key is required");
      } catch (e) {
        Se(e);
      }
      this.busy = !1;
    }
  },
  created() {
  },
  async mounted() {
    this.aclLoaded.then(() => {
      this.getBrand();
    });
  }
}), tCe = { class: "row" }, sCe = { class: "col-lg-8" }, aCe = { class: "card shadow" }, nCe = { class: "card-body" }, rCe = { key: 0 }, oCe = { class: "input-group mb-3" }, iCe = ["disable"], lCe = {
  key: 1,
  class: "alert alert-info mb-3"
}, dCe = {
  key: 2,
  class: "mb-3"
}, cCe = { class: "d-flex justify-content-end mt-2" }, uCe = ["disable"];
function pCe(e, t, s, n, r, i) {
  const o = pe("router-link");
  return p(), h("div", tCe, [
    a("div", sCe, [
      t[10] || (t[10] = a("h2", { class: "fw-bold fs-3 mb-3" }, "Brand Association", -1)),
      a("div", aCe, [
        a("div", nCe, [
          e.hasBrand ? P("", !0) : (p(), h("div", rCe, [
            t[4] || (t[4] = a("p", { class: "card-title fs-5 fw-bold" }, " Brand Linking Key ", -1)),
            a("div", null, [
              t[3] || (t[3] = a("p", { class: "card-text" }, "Enter the code provided by your brand administrator to associate your account.", -1)),
              a("div", oCe, [
                t[2] || (t[2] = a("span", {
                  class: "input-group-text",
                  id: "linkingKey"
                }, [
                  a("i", { class: "fa-light fa-key" })
                ], -1)),
                V(a("input", {
                  type: "text",
                  class: "form-control",
                  name: "linkingKey",
                  "aria-label": "Linking Key",
                  "aria-describedby": "linkingKey",
                  "onUpdate:modelValue": t[0] || (t[0] = (l) => e.linkKey = l),
                  disable: e.busy
                }, null, 8, iCe), [
                  [_e, e.linkKey]
                ])
              ])
            ])
          ])),
          e.hasBrand && e.myBrand.status == "Requested" ? (p(), h("div", lCe, [
            t[5] || (t[5] = a("i", { class: "fa-light fa-info-circle me-2" }, null, -1)),
            y("You have submitted your account for linking with " + g(e.myBrand.name) + ". Once linked, you will receive an email confirmation. ", 1)
          ])) : P("", !0),
          e.hasBrand && e.myBrand.status == "Joined" ? (p(), h("div", dCe, [
            a("p", null, [
              y(" Your account is linked with " + g(e.myBrand.name) + ".", 1),
              t[7] || (t[7] = a("br", null, null, -1)),
              t[8] || (t[8] = y(" Visit the ")),
              N(o, { name: "brand-portal" }, {
                default: ve(() => t[6] || (t[6] = [
                  y("Brand Portal")
                ])),
                _: 1,
                __: [6]
              }),
              t[9] || (t[9] = y(" to view details, obtain your api key, and view website plugins. "))
            ])
          ])) : P("", !0),
          a("div", cCe, [
            e.hasBrand ? P("", !0) : (p(), h("button", {
              key: 0,
              type: "button",
              class: "btn btn-lava",
              onClick: t[1] || (t[1] = (...l) => e.sendLinkKey && e.sendLinkKey(...l)),
              disable: e.busy
            }, " Save ", 8, uCe))
          ])
        ])
      ])
    ])
  ]);
}
const kls = /* @__PURE__ */ Ae(eCe, [["render", pCe]]), hCe = me({
  name: "Integrations",
  inject: {
    rscConfig: {
      from: Zd
    }
  },
  data() {
    return {
      widgetKey: void 0,
      isPrivateKey: !1,
      env: window.api_env,
      cdnBase: `https://${this.rscConfig.CdnDomain}`
    };
  },
  computed: {
    canManageFra() {
      var e, t;
      return ((t = (e = this.access) == null ? void 0 : e.freeRentalAnalysis) == null ? void 0 : t.access) == !0;
    },
    ...at(Te),
    ...q(Te, ["access", "aclLoaded"])
  },
  methods: {
    number: Ve,
    async loadInfo() {
      try {
        var e = await W.api.account.info();
        if (e.data.status != de.Success)
          throw new Error(e.data.message);
        this.widgetKey = e.data.info.widgetApiKey;
      } catch (t) {
        console.error(t);
      }
    },
    openPreviewPpe() {
      const e = this.$refs.previewPpeBody;
      e.firstChild && e.firstChild.remove();
      const t = document.createElement("rental-analysis");
      t.setAttribute("api-key", this.widgetKey), this.env == "local" ? t.setAttribute("env", "dev") : this.env && t.setAttribute("env", this.env), e.appendChild(t), bootstrap.Modal.getOrCreateInstance(this.$refs.previewPpe).show();
    },
    openPreviewFeatured() {
      const e = this.$refs.previewFeaturedBody;
      e.firstChild && e.firstChild.remove();
      const t = document.createElement("curated-properties");
      t.setAttribute("api-key", this.widgetKey), this.env == "local" ? t.setAttribute("env", "dev") : this.env && t.setAttribute("env", this.env), e.appendChild(t), bootstrap.Modal.getOrCreateInstance(this.$refs.previewFeatured).show();
    }
  },
  created() {
  },
  mounted() {
    this.aclLoaded.then(() => {
      this.loadInfo();
    });
  }
}), mCe = { class: "row row-cols-1 g-3" }, fCe = { class: "col" }, gCe = { class: "card shadow" }, vCe = { class: "card-body" }, yCe = {
  key: 0,
  class: "alert alert-warning"
}, bCe = { class: "bg-light rounded p-4" }, ACe = { class: "m-0" }, wCe = { class: "col" }, CCe = { class: "card shadow" }, SCe = { class: "card-header bg-white border-0 py-3 d-flex justify-content-between align-items-center" }, PCe = { class: "card-body" }, kCe = { class: "bg-dark text-white rounded p-4 mb-0" }, ECe = {
  key: 1,
  class: "col"
}, ICe = { class: "card shadow" }, TCe = { class: "card-header bg-white border-0 pb-0 d-flex justify-content-between align-items-center" }, OCe = { class: "card-body" }, RCe = { class: "bg-dark text-white rounded p-4 mb-0" }, LCe = {
  class: "modal fade",
  ref: "previewFeatured",
  id: "previewFeatured",
  tabindex: "-1",
  "aria-labelledby": "previewFeaturedLabel",
  "aria-hidden": "true"
}, BCe = { class: "modal-dialog modal-xl modal-dialog-centered" }, MCe = { class: "modal-content bg-gradient-alphabet rounded" }, xCe = {
  ref: "previewFeaturedBody",
  class: "modal-body"
}, FCe = {
  key: 0,
  class: "modal fade",
  ref: "previewPpe",
  id: "previewPpe",
  tabindex: "-1",
  "aria-labelledby": "previewPpeLabel",
  "aria-hidden": "true"
}, VCe = { class: "modal-dialog modal-xl modal-dialog-centered" }, DCe = { class: "modal-content bg-gradient-alphabet rounded" }, NCe = {
  ref: "previewPpeBody",
  class: "modal-body"
};
function jCe(e, t, s, n, r, i) {
  return p(), h(A, null, [
    a("div", mCe, [
      t[12] || (t[12] = a("div", { class: "col" }, [
        a("h2", { class: "fw-bold fs-3 mb-0" }, "Integrations")
      ], -1)),
      P("", !0),
      a("div", fCe, [
        a("div", gCe, [
          t[5] || (t[5] = a("div", { class: "card-header bg-white border-0 py-3 fw-bold fs-5" }, " Access Keys ", -1)),
          a("div", vCe, [
            e.isPrivateKey ? (p(), h("div", yCe, t[3] || (t[3] = [
              a("i", { class: "fa-light fa-key me-2" }, null, -1),
              y("This key provide API access, keep it safe and secure. ")
            ]))) : P("", !0),
            a("div", bCe, [
              t[4] || (t[4] = a("p", { class: "fw-bold" }, "Widget API Key:", -1)),
              a("pre", ACe, [
                a("code", null, g(e.widgetKey), 1)
              ])
            ])
          ])
        ])
      ]),
      a("div", wCe, [
        a("div", CCe, [
          a("div", SCe, [
            t[6] || (t[6] = a("span", { class: "fw-bold fs-5" }, " Featured Property Widget ", -1)),
            a("button", {
              type: "button",
              onClick: t[0] || (t[0] = (...o) => e.openPreviewFeatured && e.openPreviewFeatured(...o)),
              class: "btn btn-light btn-sm"
            }, "Preview example")
          ]),
          a("div", PCe, [
            t[8] || (t[8] = a("p", null, " Copy and paste this code where you want the Featured Property Widget appear on your site. ", -1)),
            a("pre", kCe, [
              a("code", null, [
                y('<script src="' + g(e.cdnBase) + '/widgets/widgets-lib.min.js"><\/script>', 1),
                t[7] || (t[7] = a("br", null, null, -1)),
                y('<curated-properties api-key="' + g(e.widgetKey) + '"></curated-properties>', 1)
              ])
            ])
          ])
        ])
      ]),
      e.canManageFra ? (p(), h("div", ECe, [
        a("div", ICe, [
          a("div", TCe, [
            t[9] || (t[9] = a("span", { class: "fw-bold fs-5" }, " Property Performance Engine widget ", -1)),
            a("button", {
              type: "button",
              onClick: t[1] || (t[1] = (...o) => e.openPreviewPpe && e.openPreviewPpe(...o)),
              class: "btn btn-light btn-sm"
            }, "Preview example")
          ]),
          a("div", OCe, [
            t[11] || (t[11] = a("p", null, " Copy and paste this code where you want the Property Performance Engine Widget appear on your site. ", -1)),
            a("pre", RCe, [
              a("code", null, [
                y('<script src="' + g(e.cdnBase) + '/widgets/widgets-lib.min.js"><\/script>', 1),
                t[10] || (t[10] = a("br", null, null, -1)),
                y('<rental-analysis api-key="' + g(e.widgetKey) + '"></rental-analysis>', 1)
              ])
            ])
          ])
        ])
      ])) : P("", !0)
    ]),
    a("div", LCe, [
      a("div", BCe, [
        a("div", MCe, [
          t[13] || (t[13] = a("div", { class: "modal-header border-0 pb-0" }, [
            a("span", {
              class: "fw-bold fs-5 modal-title",
              id: "previewFeaturedLabel"
            }, "Featured Properties"),
            a("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            })
          ], -1)),
          a("div", xCe, null, 512)
        ])
      ])
    ], 512),
    e.canManageFra ? (p(), h("div", FCe, [
      a("div", VCe, [
        a("div", DCe, [
          t[14] || (t[14] = a("div", { class: "modal-header border-0 pb-0" }, [
            a("span", {
              class: "fw-bold fs-5 modal-title",
              id: "previewPpeLabel"
            }, "Property Performance Engine"),
            a("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            })
          ], -1)),
          a("div", NCe, null, 512)
        ])
      ])
    ], 512)) : P("", !0)
  ], 64);
}
const Els = /* @__PURE__ */ Ae(hCe, [["render", jCe]]), HCe = me({
  name: "GuidedTourOption",
  props: {},
  components: {},
  data() {
    return {};
  },
  computed: {
    guidedTour: {
      get() {
        return window.localStorage.getItem(De.VariableNames.DisableSearchTour) != "true";
      },
      set(e) {
        window.localStorage.setItem(De.VariableNames.DisableSearchTour, `${!e}`);
      }
    }
  },
  methods: {},
  created() {
  },
  mounted() {
  }
}), UCe = { class: "card shadow" }, zCe = { class: "card-body" }, WCe = { class: "form-check form-switch" };
function GCe(e, t, s, n, r, i) {
  return p(), h("div", UCe, [
    t[3] || (t[3] = a("div", { class: "card-header bg-white fw-bold border-0 pb-0 h5" }, " Guided Tour ", -1)),
    a("div", zCe, [
      t[2] || (t[2] = a("p", null, "Our friendly tour tips will lead you through the highlights of our site.", -1)),
      a("div", WCe, [
        V(a("input", {
          class: "form-check-input",
          type: "checkbox",
          role: "switch",
          id: "checkTour",
          "onUpdate:modelValue": t[0] || (t[0] = (o) => e.guidedTour = o)
        }, null, 512), [
          [Ue, e.guidedTour]
        ]),
        t[1] || (t[1] = a("label", {
          class: "form-check-label",
          for: "checkTour"
        }, "Enable Tour Tips", -1))
      ])
    ])
  ]);
}
const Ils = /* @__PURE__ */ Ae(HCe, [["render", GCe]]), YCe = me({
  name: "ClientRelationships",
  components: {
    DataTable: yn,
    Column: bn
  },
  data() {
    return {
      appBusy: !1,
      errorMessage: void 0,
      loadingClients: !0,
      page: 1,
      pageSize: 25,
      totalClients: 0,
      clients: [],
      invitingClient: !1,
      unlinkingClient: !1,
      newClient: {
        name: "",
        email: "",
        sendInvite: !0
      },
      clientToUnlink: void 0
    };
  },
  computed: {
    appBusy() {
      return this.invitingClient == !0 || this.loadingClients == !0 || this.unlinkingClient == !0;
    },
    ...at(Te),
    ...q(Te, ["access", "aclLoaded"])
  },
  methods: {
    number: Ve,
    date: cs,
    dateTime: nf,
    showSendInvite(e) {
      switch (e.status) {
        case fd.New:
        case fd.Pending:
          return !0;
        default:
          return !1;
      }
    },
    async onPage(e) {
      this.page = e.page + 1, await this.loadClients();
    },
    async onSort(e) {
      console.log(`${this.$options.name}.onSort`, e);
    },
    async loadClients() {
      try {
        this.loadingClients = !0;
        const e = await W.api.accountClients.getClients(this.page, this.pageSize);
        if (e.data.status != de.Success)
          throw new Le(e);
        this.clients.length = 0, this.totalClients = e.data.total, this.clients.push(...e.data.page);
      } catch (e) {
        this.errorMessage = e.message;
      }
      this.loadingClients = !1;
    },
    async addClient() {
      var e;
      try {
        this.invitingClient = !0, this.errorMessage = void 0;
        const t = await W.api.accountClients.addClient(this.newClient);
        if (t.data.status != de.Success)
          throw new Le(t);
        this.newClient.email = "", this.newClient.name = "";
      } catch (t) {
        (!Zt.isModelStateException(t) || !t.showFormErrors(event.target)) && (this.errorMessage = t.message);
        return;
      } finally {
        this.invitingClient = !1;
      }
      (e = bootstrap.Modal.getOrCreateInstance(this.$refs.modalAddClient)) == null || e.hide(), await this.loadClients();
    },
    async unlinkClient() {
      var e;
      try {
        this.unlinkingClient = !0, this.errorMessage = void 0;
        const t = await W.api.accountClients.unlinkClient(this.clientToUnlink.email);
        if (t.data.status != de.Success)
          throw new Le(t);
        await this.loadClients(), (e = bootstrap.Modal.getOrCreateInstance(this.$refs.modalDeleteClient)) == null || e.hide(), this.clientToUnlink = void 0;
      } catch (t) {
        this.errorMessage = t.message;
      }
      this.unlinkingClient = !1;
    },
    verifyUnlink(e) {
      var t;
      this.errorMessage = void 0, this.clientToUnlink = e, (t = bootstrap.Modal.getOrCreateInstance(this.$refs.modalDeleteClient)) == null || t.show();
    },
    async sendInviteToClient(e) {
      try {
        this.invitingClient = !0, this.errorMessage = void 0;
        const t = await W.api.accountClientsInvite.sendInvite({
          email: e.email,
          name: e.name
        });
        if (t.data.status != de.Success)
          throw new Le(t);
        await this.loadClients(), wt("Invite Sent");
      } catch (t) {
        this.errorMessage = t.message;
      }
      this.invitingClient = !1;
    },
    hasIDX(e) {
      return console.log("hasIDX", e), (e.licenses & sp.InvestmentGateway) == sp.InvestmentGateway;
    },
    hasPI(e) {
      return console.log("hasPI", e), (e.licenses & sp.PortfolioInsights) == sp.PortfolioInsights;
    },
    buildPhotoUrl(e) {
      return e.gravatarHash ? `https://gravatar.com/avatar/${e.gravatarHash}?d=https://www.rescover.com/images/default-avatar.jpg` : "https://www.rescover.com/images/default-avatar.jpg";
    }
  },
  mounted() {
    this.aclLoaded.then(this.loadClients);
  }
}), XCe = { class: "row mb-3" }, qCe = { class: "col d-flex gap-2 justify-content-lg-end" }, QCe = ["disabled"], KCe = ["disabled"], ZCe = {
  key: 0,
  class: "alert alert-danger mb-3",
  role: "alert"
}, JCe = { class: "card shadow-sm overflow-hidden" }, $Ce = { class: "bg-accentgreenblue rounded-pill px-3 py-1 text-white" }, _Ce = { class: "d-flex align-items-center" }, eSe = { class: "flex-shrink-0" }, tSe = { class: "avatar rounded-circle overflow-hidden" }, sSe = ["src", "alt"], aSe = { class: "flex-grow-1 ms-3" }, nSe = { class: "d-flex justify-content-start align-items-center" }, rSe = {
  class: "text-truncate fw-bold me-2",
  style: { "max-width": "350px" }
}, oSe = {
  key: 0,
  class: "text-capitalize badge text-bg-warning rounded-pill"
}, iSe = {
  key: 0,
  class: "badge text-bg-primary me-1",
  "data-bs-toggle": "tooltip"
}, lSe = {
  key: 1,
  class: "badge text-bg-info me-1"
}, dSe = ["title"], cSe = ["onClick", "disabled"], uSe = ["onClick", "disabled"], pSe = {
  class: "modal fade",
  ref: "modalDeleteClient",
  id: "modalDeleteClient",
  tabindex: "-1",
  "aria-labelledby": "modalDeleteClientLabel",
  "aria-hidden": "true"
}, hSe = { class: "modal-dialog modal-dialog-centered" }, mSe = { class: "modal-content bg-gradient-alphabet rounded" }, fSe = { class: "modal-body text-center p-5" }, gSe = {
  key: 0,
  class: "alert alert-danger mb-3",
  role: "alert"
}, vSe = { class: "modal-footer pt-0 border-0 justify-content-center" }, ySe = ["disabled"], bSe = ["disabled"], ASe = {
  class: "modal fade",
  id: "modalAddClient",
  tabindex: "-1",
  "aria-labelledby": "modalAddClientLabel",
  "aria-hidden": "true",
  ref: "modalAddClient"
}, wSe = { class: "modal-dialog modal-dialog-centered" }, CSe = { class: "modal-content bg-gradient-alphabet rounded" }, SSe = { class: "modal-header pb-0 border-0" }, PSe = { class: "fs-5 fw-bold modal-title" }, kSe = ["disabled"], ESe = { class: "modal-body py-4" }, ISe = { class: "mb-3" }, TSe = {
  for: "inputName",
  class: "form-label"
}, OSe = ["disabled"], RSe = { class: "mb-3" }, LSe = {
  for: "inputEmail",
  class: "form-label"
}, BSe = { class: "input-group" }, MSe = ["disabled"], xSe = { class: "modal-footer pt-0 border-0 justify-content-end" }, FSe = {
  key: 0,
  version: "1.1",
  id: "L9",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  viewBox: "25 25 50 50",
  height: "30",
  width: "30",
  class: "me-2"
}, VSe = ["disabled"];
function DSe(e, t, s, n, r, i) {
  var c;
  const o = pe("Column"), l = pe("data-table"), d = Za("tooltip");
  return p(), h(A, null, [
    a("div", XCe, [
      t[9] || (t[9] = a("div", { class: "col d-flex align-items-center" }, [
        a("h2", { class: "fw-bold fs-3 mb-0" }, "All Contacts")
      ], -1)),
      a("div", qCe, [
        a("button", {
          type: "button",
          class: "btn btn-outline-accent-glass",
          onClick: t[0] || (t[0] = (...u) => e.loadClients && e.loadClients(...u)),
          disabled: e.loadingClients
        }, t[7] || (t[7] = [
          a("i", { class: "fa-light fa-refresh" }, null, -1)
        ]), 8, QCe),
        a("button", {
          type: "button",
          class: "btn btn-accent-glass",
          "data-bs-toggle": "modal",
          "data-bs-target": "#modalAddClient",
          disabled: e.loadingClients
        }, [
          t[8] || (t[8] = a("i", { class: "fa-light fa-plus me-2" }, null, -1)),
          y(g(e.$t("t-add-client")), 1)
        ], 8, KCe)
      ])
    ]),
    e.errorMessage ? (p(), h("div", ZCe, g(e.errorMessage), 1)) : P("", !0),
    a("div", JCe, [
      N(l, {
        value: e.clients,
        lazy: !0,
        paginator: !0,
        rows: e.pageSize,
        dataKey: "id",
        totalRecords: e.totalClients,
        loading: e.loadingClients,
        paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport",
        stripedRows: "",
        rowsPerPageOptions: [10, 25, 50],
        currentPageReportTemplate: "Showing {first} to {last} of {totalRecords} entries",
        onPage: t[1] || (t[1] = (u) => e.onPage(u)),
        onSort: t[2] || (t[2] = (u) => e.onSort(u)),
        sortField: "created",
        sortOrder: -1
      }, {
        empty: ve(() => [
          y(g(e.$t("t-no-clients-found")), 1)
        ]),
        loading: ve(() => [
          a("div", $Ce, [
            t[10] || (t[10] = a("span", {
              class: "spinner-border spinner-border-sm me-2",
              role: "status",
              "aria-hidden": "false"
            }, null, -1)),
            y(g(e.$t("t-loading-clients")), 1)
          ])
        ]),
        default: ve(() => [
          N(o, {
            field: "name",
            header: "Name"
          }, {
            body: ve((u) => [
              a("div", _Ce, [
                a("div", eSe, [
                  a("div", tSe, [
                    a("img", {
                      src: e.buildPhotoUrl(u.data),
                      alt: u.data.name,
                      class: "avatar-img"
                    }, null, 8, sSe)
                  ])
                ]),
                a("div", aSe, [
                  a("div", nSe, [
                    V((p(), h("div", rSe, [
                      y(g(u.data.name), 1)
                    ])), [
                      [
                        d,
                        u.data.name,
                        void 0,
                        { top: !0 }
                      ]
                    ]),
                    u.data.status == "pending" ? (p(), h("span", oSe, g(u.data.status), 1)) : P("", !0)
                  ]),
                  y(" " + g(u.data.email), 1)
                ])
              ])
            ]),
            _: 1
          }),
          N(o, {
            field: "agentName",
            header: "Agent"
          }),
          N(o, {
            field: "licenses",
            header: "Licenses"
          }, {
            body: ve((u) => [
              e.hasIDX(u.data) ? V((p(), h("span", iSe, t[11] || (t[11] = [
                y("IDX")
              ]))), [
                [
                  d,
                  "Investment Gateway",
                  void 0,
                  { top: !0 }
                ]
              ]) : P("", !0),
              e.hasPI(u.data) ? V((p(), h("span", lSe, t[12] || (t[12] = [
                y("PI")
              ]))), [
                [
                  d,
                  "Portfolio Insights",
                  void 0,
                  { top: !0 }
                ]
              ]) : P("", !0)
            ]),
            _: 1
          }),
          N(o, {
            field: "lastLogin",
            header: "Last Login"
          }, {
            body: ve((u) => [
              a("span", {
                title: e.dateTime(u.data.lastLogin)
              }, g(e.date(u.data.lastLogin)), 9, dSe)
            ]),
            _: 1
          }),
          N(o, {
            headerStyle: "width: 9rem; text-align: center",
            bodyStyle: "text-align: right; overflow: visible; text-wrap: nowrap"
          }, {
            body: ve((u) => [
              a("button", {
                type: "button",
                onClick: (m) => e.verifyUnlink(u.data),
                class: "btn btn-outline-danger btn-sm",
                disabled: e.invitingClient || e.unlinkingClient
              }, [
                t[13] || (t[13] = a("i", { class: "fa-light fa-link-slash me-1" }, null, -1)),
                y(g(e.$t("t-unlink")), 1)
              ], 8, cSe),
              e.showSendInvite(u.data) ? (p(), h("button", {
                key: 0,
                type: "button",
                onClick: (m) => e.sendInviteToClient(u.data),
                class: "btn btn-eclipse btn-sm ms-2",
                disabled: e.invitingClient || e.unlinkingClient
              }, [
                t[14] || (t[14] = a("i", { class: "fa-light fa-envelope me-1" }, null, -1)),
                y(g(e.$t("t-send-invite")), 1)
              ], 8, uSe)) : P("", !0)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["value", "rows", "totalRecords", "loading"])
    ]),
    a("div", pSe, [
      a("div", hSe, [
        a("div", mSe, [
          a("div", fSe, [
            t[15] || (t[15] = a("i", { class: "fa-duotone fa-solid fa-person-circle-xmark mb-3 fa-2xl" }, null, -1)),
            t[16] || (t[16] = a("br", null, null, -1)),
            a("b", null, g(e.$t("t-are-you-sure-unlink")), 1),
            t[17] || (t[17] = a("br", null, null, -1)),
            t[18] || (t[18] = a("br", null, null, -1)),
            y(" " + g((c = e.clientToUnlink) == null ? void 0 : c.name), 1)
          ]),
          e.errorMessage ? (p(), h("div", gSe, g(e.errorMessage), 1)) : P("", !0),
          a("div", vSe, [
            a("button", {
              type: "button",
              class: "btn btn-secondary",
              "data-bs-dismiss": "modal",
              disabled: e.appBusy | e.unlinkingClient
            }, g(e.$t("t-cancel")), 9, ySe),
            a("button", {
              type: "button",
              class: "btn btn-danger",
              onClick: t[3] || (t[3] = (...u) => e.unlinkClient && e.unlinkClient(...u)),
              disabled: e.appBusy | e.unlinkingClient
            }, g(e.$t("t-unlink")), 9, bSe)
          ])
        ])
      ])
    ], 512),
    a("div", ASe, [
      a("div", wSe, [
        a("div", CSe, [
          a("div", SSe, [
            a("p", PSe, g(e.$t("t-add-client")), 1),
            a("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close",
              disabled: e.invitingClient
            }, null, 8, kSe)
          ]),
          a("div", ESe, [
            t[20] || (t[20] = a("div", {
              class: "alert alert-danger mb-3 d-none",
              role: "alert",
              "data-val-summary": ""
            }, null, -1)),
            a("div", ISe, [
              a("label", TSe, g(e.$t("t-clients-name")) + ":", 1),
              V(a("input", {
                type: "text",
                class: "form-control",
                id: "inputName",
                "onUpdate:modelValue": t[4] || (t[4] = (u) => e.newClient.name = u),
                "data-val-id": "name",
                "aria-label": "Client's name",
                disabled: e.appBusy | e.invitingClient
              }, null, 8, OSe), [
                [_e, e.newClient.name]
              ])
            ]),
            a("div", RSe, [
              a("label", LSe, g(e.$t("t-clients-email")) + ":", 1),
              a("div", BSe, [
                t[19] || (t[19] = a("span", {
                  class: "input-group-text",
                  id: "basic-addon1"
                }, [
                  a("i", { class: "fa-light fa-envelope" })
                ], -1)),
                V(a("input", {
                  type: "email",
                  class: "form-control",
                  id: "inputEmail",
                  "onUpdate:modelValue": t[5] || (t[5] = (u) => e.newClient.email = u),
                  "data-val-id": "email",
                  "aria-label": "Email",
                  "aria-describedby": "basic-addon1",
                  disabled: e.appBusy | e.invitingClient
                }, null, 8, MSe), [
                  [_e, e.newClient.email]
                ])
              ])
            ])
          ]),
          a("div", xSe, [
            e.invitingClient ? (p(), h("svg", FSe, t[21] || (t[21] = [
              a("path", {
                fill: "#F26E34",
                d: "M73,50c0-12.7-10.3-23-23-23S27,37.3,27,50 M30.9,50c0-10.5,8.5-19.1,19.1-19.1S69.1,39.5,69.1,50"
              }, [
                a("animateTransform", {
                  attributeName: "transform",
                  attributeType: "XML",
                  type: "rotate",
                  dur: "1s",
                  from: "0 50 50",
                  to: "360 50 50",
                  repeatCount: "indefinite"
                })
              ], -1)
            ]))) : P("", !0),
            a("button", {
              type: "button",
              class: "btn btn-lava",
              onClick: t[6] || (t[6] = (...u) => e.addClient && e.addClient(...u)),
              disabled: e.appBusy | e.invitingClient
            }, g(e.$t("t-add")), 9, VSe)
          ])
        ])
      ])
    ], 512)
  ], 64);
}
const Tls = /* @__PURE__ */ Ae(YCe, [["render", DSe]]), NSe = me({
  name: "PortfolioInsightsClients",
  components: {
    DataTable: yn,
    Column: bn,
    Select: hl
  },
  data() {
    return {
      // appBusy: false,
      errorMessage: void 0,
      loadingClients: !0,
      page: 1,
      pageSize: 25,
      totalClients: 0,
      piClients: [],
      clients: [],
      invitingClient: !1,
      unlinkingClient: !1,
      newClient: {
        name: "",
        email: "",
        sendInvite: !0
      },
      clientToUnlink: void 0,
      isExistingClient: !1,
      existingClientId: void 0,
      sendInvitesTo: [],
      sendInviteClient: void 0,
      searchBy: void 0,
      executing: 0,
      showInactive: !1,
      notifyUnlink: !0
    };
  },
  computed: {
    appBusy() {
      return this.invitingClient || this.loadingClients || this.unlinkingClient;
    },
    hasClients() {
      var e;
      return ((e = this.clients) == null ? void 0 : e.length) > 0;
    },
    isAllSelected() {
      return this.piClients.every((e) => this.sendInvitesTo.some((t) => t == e.id));
    },
    ...at(Te, ba),
    ...q(Te, ["access", "aclLoaded"])
  },
  methods: {
    number: Ve,
    date: cs,
    showSendInvite(e) {
      switch (e.status) {
        case fd.New:
        case fd.Pending:
          return !0;
        default:
          return !1;
      }
    },
    async onPage(e) {
      this.page = e.page + 1, await this.loadPiClients();
    },
    async onSort(e) {
      console.log(`${this.$options.name}.onSort`, e);
    },
    async filterClients() {
      this.page = 1, this.sendInvitesTo.length = 0, await this.loadPiClients();
    },
    async loadPiClients() {
      try {
        this.loadingClients = !0, this.errorMessage = void 0, this.portfolioInsightsStore.clearCurrentPortfolio();
        const e = await W.api.portfolioInsightsClients.getClients(
          this.page > 1 ? this.page : void 0,
          this.pageSize != 25 ? this.pageSize : void 0,
          this.searchBy,
          this.showInactive == !0 ? !0 : void 0
        );
        if (e.data.status != de.Success)
          throw new Le(e);
        this.piClients.length = 0, this.totalClients = e.data.total ?? 0, e.data.page && this.piClients.push(...e.data.page);
      } catch (e) {
        this.errorMessage = e.message;
      } finally {
        this.loadingClients = !1;
      }
    },
    async addClient() {
      var e;
      try {
        if (this.invitingClient = !0, this.errorMessage = void 0, this.isExistingClient && !this.existingClientId) {
          this.errorMessage = "Please choose a client from the list first.";
          return;
        } else if (this.isExistingClient && this.existingClientId) {
          const s = this.clients.find((n) => n.id == this.existingClientId);
          this.newClient.email = (s == null ? void 0 : s.email) ?? "", this.newClient.name = (s == null ? void 0 : s.name) ?? "";
        }
        const t = await W.api.portfolioInsightsClients.addClient(this.newClient);
        if (t.data.status != de.Success)
          throw new Le(t);
        this.newClient.email = "", this.newClient.name = "";
      } catch (t) {
        this.errorMessage = t.message;
        return;
      } finally {
        this.invitingClient = !1;
      }
      (e = bootstrap.Modal.getOrCreateInstance(this.$refs.dialogAddClient)) == null || e.hide(), await this.loadPiClients();
    },
    async unlinkClient() {
      var e;
      try {
        this.unlinkingClient = !0, this.errorMessage = void 0;
        const t = this.notifyUnlink === !1 ? !1 : void 0, s = await W.api.portfolioInsightsClients.unlinkClient(this.clientToUnlink.email, void 0, t);
        if (s.data.status != de.Success)
          throw new Le(s);
        await this.loadPiClients(), (e = bootstrap.Modal.getOrCreateInstance(this.$refs.dialogDeleteClient)) == null || e.hide(), this.clientToUnlink = void 0;
      } catch (t) {
        this.errorMessage = t.message;
      }
      this.unlinkingClient = !1;
    },
    verifyUnlink(e) {
      var t;
      this.errorMessage = void 0, this.clientToUnlink = e, (t = bootstrap.Modal.getOrCreateInstance(this.$refs.dialogDeleteClient)) == null || t.show();
    },
    confirmSendInvites(e) {
      var t;
      e ? (this.sendInviteClient = e, this.sendInvitesTo.length = 0) : this.sendInviteClient = void 0, (t = bootstrap.Modal.getOrCreateInstance(this.$refs.dialogSendInvites)) == null || t.show();
    },
    async sendInvites() {
      var e;
      try {
        this.invitingClient = !0, this.errorMessage = void 0;
        let t;
        if (this.sendInviteClient ? t = await W.api.portfolioInsightsClients.sendClientInvite({
          email: this.sendInviteClient.email,
          name: this.sendInviteClient.name
        }) : t = await W.api.portfolioInsightsClients.sendWelcome(this.sendInvitesTo), t.data.status != de.Success)
          throw new Le(t);
        this.sendInviteClient ? wt("Invite Sent") : wt("Invites Sent"), this.sendInviteClient = void 0, this.sendInvitesTo.length = 0, (e = bootstrap.Modal.getOrCreateInstance(this.$refs.dialogSendInvites)) == null || e.hide();
      } catch (t) {
        this.errorMessage = t.message;
      }
      this.invitingClient = !1;
    },
    async getClients() {
      this.executing++;
      try {
        this.clients.length = 0;
        let e = 1, t = 1;
        for (let s = 0; s < t; s += 100) {
          const n = await W.api.accountClients.getClients(
            e > 1 ? e : void 0,
            100
          );
          if (n.data.status != de.Success)
            throw new Le(n);
          t = n.data.total, this.clients.push(...n.data.page), e++;
        }
      } catch (e) {
        Se(e.message);
      }
      this.executing--;
    },
    managePortfolio(e) {
      e.portfolioTotal > 1 ? this.$router.push({ name: "PI-portfolios", params: { clientId: e.id } }) : this.$router.push({ name: "PI-client-portfolio", params: { clientId: e.id, portfolioId: e.portfolioId } });
    },
    resolvePortfolioUrl(e) {
      var t, s;
      return e.portfolioTotal > 1 ? (t = this.$router.resolve({ name: "PI-portfolios", params: { clientId: e.id } })) == null ? void 0 : t.href : (s = this.$router.resolve({ name: "PI-client-portfolio", params: { clientId: e.id, portfolioId: e.portfolioId } })) == null ? void 0 : s.href;
    },
    portfolioRouteName(e) {
      return e.portfolioTotal > 1 ? "PI-portfolios" : "PI-client-portfolio";
    },
    portfolioRouteParams(e) {
      return e.portfolioTotal > 1 ? {
        clientId: e.id
      } : {
        clientId: e.id,
        portfolioId: e.portfolioId
      };
    },
    toggleSelectAll() {
      this.isAllSelected ? this.sendInvitesTo = this.sendInvitesTo.filter((e) => this.piClients.some((t) => t.id == e) == !1) : this.sendInvitesTo.push(...this.piClients.filter((e) => this.sendInvitesTo.some((t) => t == e.id) == !1).map((e) => e.id));
    },
    toggleSelect(e, t) {
      this.sendInvitesTo.some((s) => s == t.id) == !1 ? this.sendInvitesTo.push(t.id) : this.sendInvitesTo = this.sendInvitesTo.filter((s) => s !== t.id);
    },
    isSelected(e) {
      return this.sendInvitesTo.some((t) => t == e.id);
    },
    buildPhotoUrl(e) {
      return e.gravatarHash ? `https://gravatar.com/avatar/${e.gravatarHash}?d=https://www.rescover.com/images/default-avatar.jpg` : "https://www.rescover.com/images/default-avatar.jpg";
    }
  },
  mounted() {
    this.aclLoaded.then(async () => await this.loadPiClients()).then(async () => await this.getClients());
  }
}), jSe = { class: "row mb-3" }, HSe = { class: "col-md-6 col-xxl-5 d-flex align-items-center" }, USe = { class: "fw-bold fs-3 mb-lg-0" }, zSe = { class: "col-md-6 col-xxl-7" }, WSe = { class: "row g-2 align-items-center" }, GSe = { class: "col-6 col-md-4 col-xxl-4 d-flex justify-content-end justify-content-xxl-start order-2 order-md-1" }, YSe = { class: "form-check form-switch form-switch-lg" }, XSe = ["disabled"], qSe = { class: "col-12 col-md-5 col-xxl-6 order-1 order-md-2" }, QSe = { class: "border rounded bg-white d-flex align-items-center p-1 px-2" }, KSe = ["disabled"], ZSe = { class: "col-6 col-md-3 col-xxl-2 d-flex gap-2 order-3 justify-content-end order-md-3" }, JSe = ["disabled"], $Se = {
  key: 0,
  class: "alert alert-danger mb-3",
  role: "alert"
}, _Se = { class: "card shadow-sm overflow-hidden" }, ePe = { class: "bg-accentgreenblue rounded-pill px-3 py-1 text-white" }, tPe = ["checked"], sPe = ["checked", "onChange"], aPe = { class: "d-flex align-items-center" }, nPe = { class: "flex-shrink-0" }, rPe = { class: "avatar rounded-circle overflow-hidden" }, oPe = ["src", "alt"], iPe = { class: "flex-grow-1 ms-3" }, lPe = { class: "d-flex justify-content-start align-items-center" }, dPe = {
  class: "text-truncate fw-bold me-2",
  style: { "max-width": "350px" }
}, cPe = {
  key: 0,
  class: "text-capitalize badge text-bg-warning rounded-pill"
}, uPe = { class: "text-truncate x name-truncate" }, pPe = ["src"], hPe = { class: "d-flex justify-content-end gap-2" }, mPe = ["onClick", "disabled"], fPe = ["onClick", "disabled"], gPe = {
  class: "modal fade",
  ref: "dialogDeleteClient",
  id: "dialogDeleteClient",
  tabindex: "-1",
  "aria-labelledby": "dialogDeleteClientLabel",
  "aria-hidden": "true"
}, vPe = { class: "modal-dialog modal-dialog-centered" }, yPe = { class: "modal-content bg-gradient-alphabet rounded" }, bPe = { class: "modal-body text-center p-5 pb-3" }, APe = { class: "bg-white bg-opacity-50 rounded-4 d-flex flex-column" }, wPe = {
  class: "p-3",
  style: { "border-bottom": "1px solid rgb(210, 182, 226)" }
}, CPe = { class: "fs-5" }, SPe = { class: "p-3" }, PPe = { class: "row" }, kPe = { class: "col-sm-5" }, EPe = { class: "form-check form-switch form-switch-lg form-switch-double" }, IPe = ["disabled"], TPe = {
  key: 0,
  class: "alert alert-danger mb-0 mt-3",
  role: "alert"
}, OPe = { class: "modal-footer pt-0 border-0 justify-content-center" }, RPe = {
  key: 0,
  version: "1.1",
  id: "L9",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  viewBox: "25 25 50 50",
  height: "30",
  width: "30",
  class: "me-2"
}, LPe = ["disabled"], BPe = ["disabled"], MPe = {
  class: "modal fade",
  ref: "dialogAddClient",
  id: "dialogAddClient",
  tabindex: "-1",
  "aria-labelledby": "dialogAddClientLabel",
  "aria-hidden": "true"
}, xPe = { class: "modal-dialog modal-dialog-centered" }, FPe = { class: "modal-content bg-gradient-alphabet rounded" }, VPe = { class: "modal-header border-0" }, DPe = { class: "fs-5 fw-bold modal-title" }, NPe = ["disabled"], jPe = { class: "modal-body pt-0" }, HPe = {
  key: 0,
  class: "alert alert-danger mb-3",
  role: "alert"
}, UPe = { class: "bg-light bg-opacity-50 rounded p-3" }, zPe = {
  key: 0,
  class: "row mb-3"
}, WPe = { class: "col-sm-7" }, GPe = { class: "form-check form-switch form-switch-lg form-switch-double" }, YPe = ["disabled"], XPe = {
  key: 0,
  class: "row mb-3"
}, qPe = { class: "col-sm-7" }, QPe = ["disabled"], KPe = ["value"], ZPe = { key: 1 }, JPe = { class: "row mb-3" }, $Pe = {
  for: "inputName",
  class: "col-sm-5 col-form-label"
}, _Pe = { class: "col-sm-7" }, e3e = ["disabled"], t3e = { class: "row mb-3" }, s3e = {
  for: "inputEmail",
  class: "col-sm-5 col-form-label"
}, a3e = { class: "col-sm-7" }, n3e = { class: "input-group" }, r3e = ["disabled"], o3e = { class: "row mb-3" }, i3e = { class: "col-sm-7" }, l3e = { class: "form-check form-switch form-switch-lg form-switch-double" }, d3e = ["disabled"], c3e = { class: "modal-footer pt-0 border-0 justify-content-end" }, u3e = {
  key: 0,
  version: "1.1",
  id: "L9",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  viewBox: "25 25 50 50",
  height: "30",
  width: "30",
  class: "me-2"
}, p3e = ["disabled"], h3e = {
  class: "modal fade",
  ref: "dialogSendInvites",
  id: "dialogSendInvites",
  tabindex: "-1",
  "aria-labelledby": "dialogSendInvitesLabel",
  "aria-hidden": "true"
}, m3e = { class: "modal-dialog modal-dialog-centered" }, f3e = { class: "modal-content bg-gradient-alphabet rounded" }, g3e = { class: "modal-body text-center px-5 pb-5 pt-4" }, v3e = { class: "fs-5" }, y3e = { class: "d-flex gap-3 justify-content-center pt-3" }, b3e = {
  type: "button",
  class: "btn btn-outline-secondary",
  "data-bs-dismiss": "modal"
}, A3e = {
  key: 0,
  class: "modal-footer text-center justify-content-center bg-accentgreenblue text-white"
};
function w3e(e, t, s, n, r, i) {
  var u, m;
  const o = pe("Column"), l = pe("router-link"), d = pe("data-table"), c = Za("tooltip");
  return p(), h(A, null, [
    a("div", jSe, [
      a("div", HSe, [
        a("h1", USe, g(e.$t("t-portfolio-insights-clients")), 1)
      ]),
      a("div", zSe, [
        a("div", WSe, [
          a("div", GSe, [
            a("div", YSe, [
              t[18] || (t[18] = a("label", {
                class: "form-check-label",
                for: "switchInactive"
              }, [
                a("div", { class: "d-inline d-md-none d-xxl-inline" }, "Show "),
                y("Inactive")
              ], -1)),
              V(a("input", {
                class: "form-check-input",
                type: "checkbox",
                role: "switch",
                id: "switchInactive",
                "onUpdate:modelValue": t[0] || (t[0] = (f) => e.showInactive = f),
                onChange: t[1] || (t[1] = (...f) => e.loadPiClients && e.loadPiClients(...f)),
                disabled: e.loadingClients
              }, null, 40, XSe), [
                [Ue, e.showInactive]
              ])
            ])
          ]),
          a("div", qSe, [
            a("div", QSe, [
              t[19] || (t[19] = a("i", { class: "fa-duotone fa-magnifying-glass" }, null, -1)),
              V(a("input", {
                type: "text",
                class: "form-control border-0",
                placeholder: "Search by name...",
                "onUpdate:modelValue": t[2] || (t[2] = (f) => e.searchBy = f),
                disabled: e.loadingClients,
                onKeyup: t[3] || (t[3] = wo((...f) => e.filterClients && e.filterClients(...f), ["enter"]))
              }, null, 40, KSe), [
                [_e, e.searchBy]
              ])
            ])
          ]),
          a("div", ZSe, [
            a("button", {
              type: "button",
              class: "btn btn-outline-eclipse",
              onClick: t[4] || (t[4] = (f) => e.confirmSendInvites())
            }, t[20] || (t[20] = [
              a("i", { class: "fa-light fa-envelope" }, null, -1)
            ])),
            a("button", {
              type: "button",
              class: "btn btn-outline-accent-glass",
              onClick: t[5] || (t[5] = (...f) => e.loadPiClients && e.loadPiClients(...f)),
              disabled: e.loadingClients
            }, t[21] || (t[21] = [
              a("i", { class: "fa-light fa-refresh" }, null, -1)
            ]), 8, JSe),
            P("", !0)
          ])
        ])
      ])
    ]),
    e.errorMessage ? (p(), h("div", $Se, g(e.errorMessage), 1)) : P("", !0),
    a("div", _Se, [
      N(d, {
        value: e.piClients,
        lazy: !0,
        paginator: !0,
        rows: e.pageSize,
        dataKey: "id",
        totalRecords: e.totalClients,
        loading: e.loadingClients,
        paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport",
        stripedRows: "",
        rowsPerPageOptions: [10, 25, 50],
        currentPageReportTemplate: "Showing {first} to {last} of {totalRecords} entries",
        onPage: t[7] || (t[7] = (f) => e.onPage(f)),
        onSort: t[8] || (t[8] = (f) => e.onSort(f)),
        sortField: "created",
        sortOrder: -1
      }, {
        empty: ve(() => [
          y(g(e.$t("t-no-clients-found")), 1)
        ]),
        loading: ve(() => [
          a("div", ePe, [
            t[23] || (t[23] = a("span", {
              class: "spinner-border spinner-border-sm me-2",
              role: "status",
              "aria-hidden": "false"
            }, null, -1)),
            y(" " + g(e.$t("t-loading-clients")), 1)
          ])
        ]),
        default: ve(() => [
          N(o, null, {
            header: ve(() => [
              a("input", {
                type: "checkbox",
                class: "form-check-input",
                checked: e.isAllSelected,
                onChange: t[6] || (t[6] = (...f) => e.toggleSelectAll && e.toggleSelectAll(...f))
              }, null, 40, tPe)
            ]),
            body: ve((f) => [
              a("input", {
                type: "checkbox",
                class: "form-check-input",
                checked: e.isSelected(f.data),
                onChange: (v) => e.toggleSelect(v, f.data)
              }, null, 40, sPe)
            ]),
            _: 1
          }),
          N(o, {
            field: "name",
            header: "Name"
          }, {
            body: ve((f) => [
              a("div", aPe, [
                a("div", nPe, [
                  a("div", rPe, [
                    a("img", {
                      src: e.buildPhotoUrl(f.data),
                      alt: f.data.name,
                      class: "avatar-img"
                    }, null, 8, oPe)
                  ])
                ]),
                a("div", iPe, [
                  a("div", lPe, [
                    V((p(), h("div", dPe, [
                      y(g(f.data.name), 1)
                    ])), [
                      [
                        c,
                        f.data.name,
                        void 0,
                        { top: !0 }
                      ]
                    ]),
                    f.data.status == "pending" ? (p(), h("span", cPe, g(f.data.status), 1)) : P("", !0)
                  ]),
                  y(" " + g(f.data.email), 1)
                ])
              ])
            ]),
            _: 1
          }),
          N(o, {
            field: "portfolioName",
            header: "Portfolio"
          }, {
            body: ve((f) => [
              V((p(), h("div", uPe, [
                N(l, {
                  name: e.portfolioRouteName(f.data),
                  params: e.portfolioRouteParams(f.data),
                  target: "_" + f.data.id + "Portfolio"
                }, {
                  default: ve(() => [
                    f.data.portfolioTotal <= 1 ? (p(), h(A, { key: 0 }, [
                      y(g(f.data.portfolioName) + " ", 1),
                      f.data.portfolioRemoteSystem ? (p(), h("img", {
                        key: 0,
                        src: "https://images.rescover.com/content/images/third-party/" + f.data.portfolioRemoteSystem + ".png",
                        height: "16",
                        class: "ms-1"
                      }, null, 8, pPe)) : P("", !0)
                    ], 64)) : (p(), h(A, { key: 1 }, [
                      y(" Multiple (" + g(e.number(f.data.portfolioTotal)) + ") ", 1)
                    ], 64))
                  ]),
                  _: 2
                }, 1032, ["name", "params", "target"])
              ])), [
                [
                  c,
                  f.data.portfolioName,
                  void 0,
                  { top: !0 }
                ]
              ])
            ]),
            _: 1
          }),
          N(o, {
            field: "lastLogin",
            header: "Last Login"
          }, {
            body: ve((f) => [
              y(g(e.date(f.data.lastLogin)), 1)
            ]),
            _: 1
          }),
          N(o, {
            headerStyle: "width: 9rem; text-align: center",
            bodyStyle: "text-align: right; overflow: visible; text-wrap: nowrap"
          }, {
            body: ve((f) => [
              a("div", hPe, [
                e.showSendInvite(f.data) ? V((p(), h("button", {
                  key: 0,
                  type: "button",
                  onClick: (v) => e.confirmSendInvites(f.data),
                  class: "btn btn-eclipse btn-sm",
                  disabled: e.invitingClient || e.unlinkingClient
                }, t[24] || (t[24] = [
                  a("i", { class: "fa-light fa-envelope" }, null, -1)
                ]), 8, mPe)), [
                  [
                    c,
                    "Send Invite...",
                    void 0,
                    { top: !0 }
                  ]
                ]) : P("", !0),
                V((p(), h("button", {
                  type: "button",
                  onClick: (v) => e.verifyUnlink(f.data),
                  class: "btn btn-outline-danger btn-sm",
                  disabled: e.invitingClient || e.unlinkingClient
                }, t[25] || (t[25] = [
                  a("i", { class: "fa-light fa-link-slash" }, null, -1)
                ]), 8, fPe)), [
                  [
                    c,
                    "Unlink...",
                    void 0,
                    { top: !0 }
                  ]
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["value", "rows", "totalRecords", "loading"])
    ]),
    a("div", gPe, [
      a("div", vPe, [
        a("div", yPe, [
          a("div", bPe, [
            t[29] || (t[29] = a("i", { class: "fa-duotone fa-person-circle-xmark mb-3 fa-3xl" }, null, -1)),
            a("p", null, g(e.$t("t-are-you-sure-unlink")), 1),
            a("div", APe, [
              a("div", wPe, [
                a("b", CPe, g((u = e.clientToUnlink) == null ? void 0 : u.name), 1),
                t[26] || (t[26] = a("br", null, null, -1)),
                y(" " + g((m = e.clientToUnlink) == null ? void 0 : m.email), 1)
              ]),
              a("div", SPe, [
                a("div", PPe, [
                  t[28] || (t[28] = a("label", { class: "col-sm-7 col-form-label" }, "Send Removal Notification", -1)),
                  a("div", kPe, [
                    a("div", EPe, [
                      V(a("input", {
                        class: "form-check-input",
                        type: "checkbox",
                        role: "switch",
                        id: "notifyUnlink",
                        "onUpdate:modelValue": t[9] || (t[9] = (f) => e.notifyUnlink = f),
                        disabled: e.appBusy || e.unlinkingClient
                      }, null, 8, IPe), [
                        [Ue, e.notifyUnlink]
                      ]),
                      t[27] || (t[27] = a("label", {
                        class: "form-check-label",
                        for: "notifyUnlink"
                      }, [
                        a("span", null, "No"),
                        y("Yes")
                      ], -1))
                    ])
                  ])
                ])
              ])
            ]),
            e.errorMessage ? (p(), h("div", TPe, g(e.errorMessage), 1)) : P("", !0)
          ]),
          a("div", OPe, [
            e.unlinkingClient ? (p(), h("svg", RPe, t[30] || (t[30] = [
              a("path", {
                fill: "#F26E34",
                d: "M73,50c0-12.7-10.3-23-23-23S27,37.3,27,50 M30.9,50c0-10.5,8.5-19.1,19.1-19.1S69.1,39.5,69.1,50"
              }, [
                a("animateTransform", {
                  attributeName: "transform",
                  attributeType: "XML",
                  type: "rotate",
                  dur: "1s",
                  from: "0 50 50",
                  to: "360 50 50",
                  repeatCount: "indefinite"
                })
              ], -1)
            ]))) : P("", !0),
            a("button", {
              type: "button",
              class: "btn btn-secondary",
              "data-bs-dismiss": "modal",
              disabled: e.appBusy || e.unlinkingClient
            }, g(e.$t("t-cancel")), 9, LPe),
            a("button", {
              type: "button",
              class: "btn btn-danger",
              onClick: t[10] || (t[10] = (...f) => e.unlinkClient && e.unlinkClient(...f)),
              disabled: e.appBusy || e.unlinkingClient
            }, g(e.$t("t-unlink")), 9, BPe)
          ])
        ])
      ])
    ], 512),
    a("div", MPe, [
      a("div", xPe, [
        a("div", FPe, [
          a("div", VPe, [
            a("p", DPe, g(e.$t("t-add-client")), 1),
            a("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close",
              disabled: e.invitingClient
            }, null, 8, NPe)
          ]),
          a("div", jPe, [
            e.errorMessage ? (p(), h("div", HPe, g(e.errorMessage), 1)) : P("", !0),
            a("div", UPe, [
              e.hasClients ? (p(), h("div", zPe, [
                t[32] || (t[32] = a("label", { class: "col-sm-5 col-form-label" }, "Owner", -1)),
                a("div", WPe, [
                  a("div", GPe, [
                    V(a("input", {
                      class: "form-check-input",
                      type: "checkbox",
                      role: "switch",
                      id: "switchMemberType",
                      "onUpdate:modelValue": t[11] || (t[11] = (f) => e.isExistingClient = f),
                      disabled: e.invitingClient
                    }, null, 8, YPe), [
                      [Ue, e.isExistingClient]
                    ]),
                    t[31] || (t[31] = a("label", {
                      class: "form-check-label",
                      for: "switchMemberType"
                    }, [
                      a("span", null, "New"),
                      y("Existing")
                    ], -1))
                  ])
                ])
              ])) : P("", !0),
              N(ks, {
                name: "slide",
                mode: "out-in"
              }, {
                default: ve(() => [
                  e.isExistingClient && e.hasClients ? (p(), h("div", XPe, [
                    t[33] || (t[33] = a("label", {
                      for: "existingClient",
                      class: "col-sm-5 col-form-label"
                    }, "Client:", -1)),
                    a("div", qPe, [
                      V(a("select", {
                        type: "text",
                        class: "form-select",
                        id: "existingClient",
                        "onUpdate:modelValue": t[12] || (t[12] = (f) => e.existingClientId = f),
                        "aria-label": "Client",
                        disabled: e.invitingClient
                      }, [
                        (p(!0), h(A, null, D(e.clients, (f) => (p(), h("option", {
                          value: f.id,
                          key: f.id
                        }, g(f.name) + " (" + g(f.email) + ") ", 9, KPe))), 128))
                      ], 8, QPe), [
                        [We, e.existingClientId]
                      ])
                    ])
                  ])) : (p(), h("div", ZPe, [
                    a("div", JPe, [
                      a("label", $Pe, g(e.$t("t-clients-name")) + ":", 1),
                      a("div", _Pe, [
                        V(a("input", {
                          type: "text",
                          class: "form-control",
                          id: "inputName",
                          "onUpdate:modelValue": t[13] || (t[13] = (f) => e.newClient.name = f),
                          "aria-label": "Client's name",
                          disabled: e.invitingClient
                        }, null, 8, e3e), [
                          [_e, e.newClient.name]
                        ])
                      ])
                    ]),
                    a("div", t3e, [
                      a("label", s3e, g(e.$t("t-clients-email")) + ":", 1),
                      a("div", a3e, [
                        a("div", n3e, [
                          t[34] || (t[34] = a("span", {
                            class: "input-group-text",
                            id: "basic-addon1"
                          }, [
                            a("i", { class: "fa-light fa-envelope" })
                          ], -1)),
                          V(a("input", {
                            type: "email",
                            class: "form-control",
                            id: "inputEmail",
                            "onUpdate:modelValue": t[14] || (t[14] = (f) => e.newClient.email = f),
                            "aria-label": "Email",
                            "aria-describedby": "basic-addon1",
                            disabled: e.invitingClient
                          }, null, 8, r3e), [
                            [_e, e.newClient.email]
                          ])
                        ])
                      ])
                    ])
                  ]))
                ]),
                _: 1
              }),
              a("div", o3e, [
                t[36] || (t[36] = a("label", { class: "col-sm-5 col-form-label" }, "Send Welcome Invite", -1)),
                a("div", i3e, [
                  a("div", l3e, [
                    V(a("input", {
                      class: "form-check-input",
                      type: "checkbox",
                      role: "switch",
                      id: "switchMemberType",
                      "onUpdate:modelValue": t[15] || (t[15] = (f) => e.newClient.sendInvite = f),
                      disabled: e.invitingClient
                    }, null, 8, d3e), [
                      [Ue, e.newClient.sendInvite]
                    ]),
                    t[35] || (t[35] = a("label", {
                      class: "form-check-label",
                      for: "switchMemberType"
                    }, [
                      a("span", null, "No"),
                      y("Yes")
                    ], -1))
                  ])
                ])
              ])
            ])
          ]),
          a("div", c3e, [
            e.invitingClient ? (p(), h("svg", u3e, t[37] || (t[37] = [
              a("path", {
                fill: "#F26E34",
                d: "M73,50c0-12.7-10.3-23-23-23S27,37.3,27,50 M30.9,50c0-10.5,8.5-19.1,19.1-19.1S69.1,39.5,69.1,50"
              }, [
                a("animateTransform", {
                  attributeName: "transform",
                  attributeType: "XML",
                  type: "rotate",
                  dur: "1s",
                  from: "0 50 50",
                  to: "360 50 50",
                  repeatCount: "indefinite"
                })
              ], -1)
            ]))) : P("", !0),
            a("button", {
              type: "button",
              class: "btn btn-lava",
              onClick: t[16] || (t[16] = (...f) => e.addClient && e.addClient(...f)),
              disabled: e.invitingClient
            }, g(e.$t("t-add")), 9, p3e)
          ])
        ])
      ])
    ], 512),
    a("div", h3e, [
      a("div", m3e, [
        a("div", f3e, [
          t[46] || (t[46] = a("div", { class: "modal-header border-0 mb-0" }, [
            a("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            })
          ], -1)),
          a("div", g3e, [
            t[41] || (t[41] = a("i", { class: "fa-duotone fa-envelope mb-3 fa-2xl" }, null, -1)),
            t[42] || (t[42] = a("br", null, null, -1)),
            a("b", v3e, [
              e.sendInviteClient ? (p(), h(A, { key: 0 }, [
                y(" Send invite ")
              ], 64)) : (p(), h(A, { key: 1 }, [
                y(" Send invites ")
              ], 64))
            ]),
            t[43] || (t[43] = a("br", null, null, -1)),
            t[44] || (t[44] = a("br", null, null, -1)),
            a("p", null, [
              t[40] || (t[40] = y(" Send a portfolio insights welcome email to ")),
              e.sendInviteClient ? (p(), h(A, { key: 0 }, [
                a("b", null, g(e.sendInviteClient.name), 1),
                y(" (" + g(e.sendInviteClient.email) + ") ", 1)
              ], 64)) : (p(), h(A, { key: 1 }, [
                t[38] || (t[38] = y(" the ")),
                a("b", null, g(e.number(e.sendInvitesTo.length)), 1),
                t[39] || (t[39] = y(" selected clients. "))
              ], 64))
            ]),
            a("div", y3e, [
              a("button", b3e, g(e.$t("t-cancel")), 1),
              a("button", {
                type: "button",
                class: "btn btn-eclipse",
                onClick: t[17] || (t[17] = (...f) => e.sendInvites && e.sendInvites(...f))
              }, "Invite")
            ])
          ]),
          N(ks, {
            name: "slide",
            mode: "out-in"
          }, {
            default: ve(() => [
              e.invitingClient ? (p(), h("div", A3e, [
                t[45] || (t[45] = a("i", { class: "fa-duotone fa-solid fa-spinner-third fa-spin me-2" }, null, -1)),
                e.sendInviteClient ? (p(), h(A, { key: 0 }, [
                  y(" Sending invite... ")
                ], 64)) : (p(), h(A, { key: 1 }, [
                  y(" Sending invites... ")
                ], 64))
              ])) : P("", !0)
            ]),
            _: 1
          })
        ])
      ])
    ], 512)
  ], 64);
}
const Ols = /* @__PURE__ */ Ae(NSe, [["render", w3e]]), C3e = me({
  name: "InvestmentGatewayClients",
  props: {
    referral: Boolean
  },
  enums: {
    ClientRelationshipType: Il
  },
  directives: {
    Tooltip: Wo
  },
  components: {
    DataTable: yn,
    Column: bn,
    Select: hl,
    Paginator: Vm,
    SaveButton: bb
  },
  data() {
    return {
      errorMessage: void 0,
      loadingClients: !0,
      page: 1,
      pageSize: 25,
      totalClients: 0,
      idxClients: [],
      clients: [],
      invitingClient: !1,
      unlinkingClient: !1,
      newClient: {
        name: "",
        email: "",
        sendInvite: !0,
        type: this.referral ? Il.ReferralPartner : Il.Investor
      },
      clientToUnlink: void 0,
      isExistingClient: !1,
      executing: 0,
      sortField: "name",
      sortOrder: 1,
      clientListTotal: 0,
      clientListPage: 1,
      clientListPageSize: 25,
      clientListFilter: void 0,
      clientListHasMore: !1
    };
  },
  computed: {
    appBusy() {
      return this.invitingClient == !0 || this.loadingClients == !0 || this.unlinkingClient == !0 || this.executing > 0;
    },
    hasClients() {
      var e;
      return ((e = this.clients) == null ? void 0 : e.length) > 0;
    },
    activeInvestors() {
      var e;
      return ((e = this.licenseReport) == null ? void 0 : e.activeInvestors) ?? 0;
    },
    activeReferralPartners() {
      var e;
      return ((e = this.licenseReport) == null ? void 0 : e.activeReferralPartners) ?? 0;
    },
    totalUsedGuestLicenses() {
      var e, t;
      return (((e = this.licenseReport) == null ? void 0 : e.activeInvestors) ?? 0) + (((t = this.licenseReport) == null ? void 0 : t.activeReferralPartners) ?? 0);
    },
    guestUserLicenses() {
      var e;
      return ((e = this.licenseReport) == null ? void 0 : e.guestUserLicenses) ?? 0;
    },
    ...at(Te, ct),
    ...q(Te, ["access", "aclLoaded"]),
    ...q(ct, ["licenseReport"])
  },
  methods: {
    number: Ve,
    date: cs,
    showSendInvite(e) {
      switch (e.status) {
        case fd.New:
        case fd.Pending:
          return !0;
        default:
          return !1;
      }
    },
    async onPage(e) {
      this.page = e.page + 1, await this.loadIdxClients();
    },
    async onSort(e) {
      console.log(`${this.$options.name}.onSort`, this.sortField, this.sortOrder, e), this.loadIdxClients();
    },
    async loadIdxClients() {
      try {
        this.loadingClients = !0, this.errorMessage = void 0;
        let e, t;
        this.sortField == "lastLogin" && (e = QT.LastLogin), this.sortOrder == -1 && (t = KT.Desc);
        const s = await W.api.idxClients.getClients(
          this.page > 1 ? this.page : void 0,
          // default is 1
          this.pageSize != 25 ? this.pageSize : void 0,
          // default is 25
          this.referral ? Il.ReferralPartner : void 0,
          // default is investors
          e,
          t
        );
        if (s.data.status != de.Success)
          throw new Le(s);
        this.idxClients.length = 0, this.totalClients = s.data.total, this.idxClients.push(...s.data.page);
      } catch (e) {
        this.errorMessage = e.message;
      }
      this.loadingClients = !1;
    },
    filterGuests(e) {
      this.clientListFilter = e.value, this.nextClientPage();
    },
    async addClient(e) {
      var t;
      try {
        if (this.invitingClient = !0, this.errorMessage = void 0, this.isExistingClient && !this.newClient.id)
          throw new Zt("Client not selected", { id: ["Please choose a client from the list first."] });
        const s = await W.api.idxClients.addClient(this.newClient);
        if (s.data.status != de.Success)
          throw new Le(s);
        this.newClient.id = void 0, this.newClient.email = "", this.newClient.name = "", this.newClient.type = this.referral ? Il.ReferralPartner : Il.Investor, (t = bootstrap.Modal.getOrCreateInstance(this.$refs.dialogAddClient)) == null || t.hide(), await this.loadIdxClients();
      } catch (s) {
        (!Zt.isModelStateException(s) || !s.showFormErrors(e.target)) && (this.errorMessage = s.message);
      } finally {
        this.invitingClient = !1;
      }
    },
    verifyUnlink(e) {
      var t;
      this.errorMessage = void 0, this.clientToUnlink = e, (t = bootstrap.Modal.getOrCreateInstance(this.$refs.dialogDeleteClient)) == null || t.show();
    },
    async unlinkClient(e) {
      var t, s;
      try {
        if (this.unlinkingClient = !0, this.errorMessage = void 0, Zt.clearModelStateErrors(e.target), !((t = this.clientToUnlink) != null && t.id))
          throw new Zt("Missing identifier for guest user. Please close dialog and try again or contact support.", []);
        const n = await W.api.idxClients.unlinkClient(this.clientToUnlink.id);
        if (n.data.status != de.Success)
          throw new Le(n);
        await this.loadIdxClients(), this.accountStore.fetchLicenseReport(), (s = bootstrap.Modal.getOrCreateInstance(this.$refs.dialogDeleteClient)) == null || s.hide(), this.clientToUnlink = void 0;
      } catch (n) {
        (!Zt.isModelStateException(n) || !n.showFormErrors(e.target)) && (this.errorMessage = n.message);
      } finally {
        this.unlinkingClient = !1;
      }
    },
    async sendInviteToClient(e) {
      try {
        this.invitingClient = !0, this.errorMessage = void 0;
        const t = await W.api.idxClients.sendClientInvite({
          email: e.email,
          name: e.name
        });
        if (t.data.status != de.Success)
          throw new Le(t);
        await this.loadIdxClients(), wt("Invite Sent");
      } catch (t) {
        this.errorMessage = t.message;
      }
      this.invitingClient = !1;
    },
    async nextClientPage(e) {
      this.executing++;
      try {
        (e == null ? void 0 : e.page) >= 0 && (console.log("nextClientPage", e), this.clientListPage = e.page + 1);
        const t = await W.api.accountClients.getClients(
          this.clientListPage > 1 ? this.clientListPage : void 0,
          this.clientListPageSize != 25 ? this.clientListPageSize : void 0,
          void 0,
          void 0,
          void 0,
          void 0,
          this.clientListFilter
        );
        if (t.data.status != de.Success)
          throw new Le(t);
        this.clientListTotal = t.data.total, this.clientListHasMore = t.data.hasMore, this.clients.length = 0, t.data.page && this.clients.push(...t.data.page);
      } catch (t) {
        Se(t.message);
      } finally {
        this.executing--;
      }
    },
    activateStyle(e) {
      return {
        btn: !0,
        "btn-sm": !0,
        "ms-2": !0,
        "btn-outline-success": e.active == !1,
        "btn-outline-danger": e.active == !0
      };
    },
    async updateStatus(e) {
      this.executing++;
      try {
        let t;
        if (e.active ? t = await W.api.accountClients.deactivateGuestClient(e.id) : t = await W.api.accountClients.activateGuestClient(e.id), t.data.status != de.Success)
          throw new Le(t);
        e.active = !e.active;
      } catch (t) {
        Se(t.message);
      }
      this.executing--;
    },
    buildPhotoUrl(e) {
      return e.gravatarHash ? `https://gravatar.com/avatar/${e.gravatarHash}?d=https://www.rescover.com/images/default-avatar.jpg` : "https://www.rescover.com/images/default-avatar.jpg";
    }
  },
  mounted() {
    this.aclLoaded.then(() => this.accountStore.fetchLicenseReport()).then(() => this.loadIdxClients()).then(() => this.nextClientPage());
  }
}), S3e = { class: "row row-cols-2 mb-3" }, P3e = { class: "col d-flex align-items-center" }, k3e = { class: "fw-bold fs-3" }, E3e = { class: "col d-flex gap-2 justify-content-center justify-content-md-end align-items-center" }, I3e = ["disabled"], T3e = ["disabled"], O3e = {
  key: 0,
  class: "alert alert-danger mb-3",
  role: "alert"
}, R3e = { class: "card shadow-sm mb-3" }, L3e = { class: "card-header d-flex bg-transparent border-0 pb-0" }, B3e = { class: "fw-bold" }, M3e = { class: "btn btn-success btn-sm ms-auto" }, x3e = { class: "card-body" }, F3e = { class: "d-flex gap-2 text-center mb-3" }, V3e = { class: "bg-light rounded p-2 flex-fill" }, D3e = { class: "bg-light rounded p-2 flex-fill" }, N3e = { class: "bg-light rounded p-2 flex-fill" }, j3e = { class: "card shadow-sm overflow-hidden" }, H3e = { class: "bg-accentgreenblue rounded-pill px-3 py-1 text-white" }, U3e = { class: "d-flex align-items-center" }, z3e = { class: "flex-shrink-0" }, W3e = { class: "avatar rounded-circle overflow-hidden" }, G3e = ["src", "alt"], Y3e = { class: "flex-grow-1 ms-3" }, X3e = { class: "d-flex justify-content-start align-items-center" }, q3e = {
  class: "text-truncate fw-bold me-2",
  style: { "max-width": "350px" }
}, Q3e = {
  key: 0,
  class: "text-capitalize badge text-bg-warning rounded-pill"
}, K3e = { class: "text-body-secondary" }, Z3e = ["onClick", "disabled"], J3e = {
  key: 0,
  class: "badge text-bg-success"
}, $3e = {
  key: 1,
  class: "badge text-bg-secondary"
}, _3e = ["onClick", "disabled"], e8e = ["onClick", "disabled"], t8e = {
  class: "modal fade",
  ref: "dialogDeleteClient",
  id: "dialogDeleteClient",
  tabindex: "-1",
  "aria-labelledby": "dialogDeleteClientLabel",
  "aria-hidden": "true"
}, s8e = { class: "modal-dialog modal-dialog-centered" }, a8e = { class: "modal-content bg-gradient-alphabet rounded" }, n8e = { class: "modal-body text-center p-5" }, r8e = { class: "text-body-secondary" }, o8e = {
  key: 0,
  class: "alert alert-danger mb-3",
  role: "alert"
}, i8e = { class: "modal-footer pt-0 border-0 justify-content-center" }, l8e = {
  key: 0,
  version: "1.1",
  id: "L9",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  viewBox: "25 25 50 50",
  height: "30",
  width: "30",
  class: "me-2"
}, d8e = ["disabled"], c8e = ["disabled"], u8e = {
  class: "modal fade",
  ref: "dialogAddClient",
  id: "dialogAddClient",
  tabindex: "-1",
  "aria-labelledby": "dialogAddClientLabel",
  "aria-hidden": "true"
}, p8e = { class: "modal-dialog modal-dialog-centered" }, h8e = { class: "modal-content bg-gradient-alphabet rounded" }, m8e = { class: "modal-header" }, f8e = { class: "fs-5 fw-bold modal-title" }, g8e = ["disabled"], v8e = { class: "modal-body py-4" }, y8e = {
  key: 0,
  class: "row mb-3"
}, b8e = { class: "col-sm-8" }, A8e = { class: "form-check form-switch form-switch-lg form-switch-double" }, w8e = {
  key: 0,
  class: "row mb-3"
}, C8e = { class: "col-sm-8" }, S8e = { class: "p-3" }, P8e = { key: 1 }, k8e = { class: "row mb-3" }, E8e = {
  for: "inputName",
  class: "col-sm-4 col-form-label"
}, I8e = { class: "col-sm-8" }, T8e = ["disabled"], O8e = { class: "row mb-3" }, R8e = {
  for: "inputEmail",
  class: "col-sm-4 col-form-label"
}, L8e = { class: "col-sm-8" }, B8e = { class: "input-group" }, M8e = ["disabled"], x8e = { class: "row" }, F8e = {
  for: "inputName",
  class: "col-sm-4 col-form-label"
}, V8e = { class: "col-sm-8" }, D8e = ["disabled"], N8e = ["value"], j8e = ["value"], H8e = { class: "modal-footer pt-0 border-0 justify-content-end" };
function U8e(e, t, s, n, r, i) {
  var f, v;
  const o = pe("Column"), l = pe("data-table"), d = pe("Paginator"), c = pe("Select"), u = pe("save-button"), m = Za("tooltip");
  return p(), h(A, null, [
    a("div", S3e, [
      a("div", P3e, [
        a("h1", k3e, [
          e.referral ? (p(), h(A, { key: 0 }, [
            y(g(e.$t("Referral Partners")), 1)
          ], 64)) : (p(), h(A, { key: 1 }, [
            y(g(e.$t("Investors")), 1)
          ], 64))
        ])
      ]),
      a("div", E3e, [
        V((p(), h("button", {
          type: "button",
          class: "btn btn-outline-accent-glass",
          onClick: t[0] || (t[0] = (...b) => e.loadIdxClients && e.loadIdxClients(...b)),
          disabled: e.loadingClients
        }, t[12] || (t[12] = [
          a("i", { class: "fa-light fa-refresh" }, null, -1)
        ]), 8, I3e)), [
          [
            m,
            "Refresh",
            void 0,
            { top: !0 }
          ]
        ]),
        a("button", {
          type: "button",
          class: "btn btn-accent-glass d-flex flex-shrink-0 align-items-center flex-nowrap",
          "data-bs-toggle": "modal",
          "data-bs-target": "#dialogAddClient",
          disabled: e.loadingClients
        }, [
          t[13] || (t[13] = a("i", { class: "fa-light fa-plus me-2" }, null, -1)),
          y(g(e.$t("t-add-client")), 1)
        ], 8, T3e)
      ])
    ]),
    e.errorMessage ? (p(), h("div", O3e, g(e.errorMessage), 1)) : P("", !0),
    a("div", R3e, [
      a("div", L3e, [
        a("span", B3e, g(e.$t("Guest User License Utilization")), 1),
        a("button", M3e, [
          t[14] || (t[14] = a("i", { class: "fa-light fa-plus me-2" }, null, -1)),
          y(g(e.$t("Add licenses")), 1)
        ])
      ]),
      a("div", x3e, [
        a("div", F3e, [
          a("div", V3e, [
            t[15] || (t[15] = y(" Active Investors: ")),
            a("b", null, g(e.number(e.activeInvestors)), 1)
          ]),
          a("div", D3e, [
            t[16] || (t[16] = y(" Active Referral Partners: ")),
            a("b", null, g(e.number(e.activeReferralPartners)), 1)
          ]),
          a("div", N3e, [
            t[17] || (t[17] = y(" Guest License Utilization: ")),
            a("b", null, g(e.number(e.totalUsedGuestLicenses)) + "/" + g(e.number(e.guestUserLicenses)), 1)
          ])
        ]),
        t[18] || (t[18] = a("p", { class: "mb-0" }, "Guest users will automatically be deactivated if they have not logged in for 180 days. Guest users have full access to Property Suite Pro, with the ability to view properties and create PDF reports which retain the agent's branding and contact information.", -1))
      ])
    ]),
    a("div", j3e, [
      N(l, {
        value: e.idxClients,
        lazy: !0,
        paginator: !0,
        class: "p-datatable",
        rows: e.pageSize,
        dataKey: "id",
        totalRecords: e.totalClients,
        loading: e.loadingClients,
        paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport",
        rowsPerPageOptions: [10, 25, 50],
        currentPageReportTemplate: "Showing {first} to {last} of {totalRecords} entries",
        onPage: t[1] || (t[1] = (b) => e.onPage(b)),
        onSort: t[2] || (t[2] = (b) => e.onSort(b)),
        sortField: e.sortField,
        "onUpdate:sortField": t[3] || (t[3] = (b) => e.sortField = b),
        sortOrder: e.sortOrder,
        "onUpdate:sortOrder": t[4] || (t[4] = (b) => e.sortOrder = b)
      }, {
        empty: ve(() => [
          y(g(e.$t("t-no-clients-found")), 1)
        ]),
        loading: ve(() => [
          a("div", H3e, [
            t[19] || (t[19] = a("span", {
              class: "spinner-border spinner-border-sm me-2",
              role: "status",
              "aria-hidden": "false"
            }, null, -1)),
            y(g(e.$t("t-loading-clients")), 1)
          ])
        ]),
        default: ve(() => [
          N(o, {
            field: "name",
            header: "Name",
            sortable: ""
          }, {
            body: ve((b) => [
              a("div", U3e, [
                a("div", z3e, [
                  a("div", W3e, [
                    a("img", {
                      src: e.buildPhotoUrl(b.data),
                      alt: b.data.name,
                      class: "avatar-img"
                    }, null, 8, G3e)
                  ])
                ]),
                a("div", Y3e, [
                  a("div", X3e, [
                    V((p(), h("div", q3e, [
                      y(g(b.data.name), 1)
                    ])), [
                      [
                        m,
                        b.data.name,
                        void 0,
                        { top: !0 }
                      ]
                    ]),
                    b.data.status == "pending" ? (p(), h("span", Q3e, g(b.data.status), 1)) : P("", !0)
                  ]),
                  a("small", K3e, g(b.data.email), 1)
                ])
              ])
            ]),
            _: 1
          }),
          N(o, {
            field: "type",
            header: "Type"
          }, {
            body: ve((b) => [
              b.data.type == e.ClientRelationshipType.Investor ? (p(), h(A, { key: 0 }, [
                y(" Investor ")
              ], 64)) : b.data.type == e.ClientRelationshipType.ReferralPartner ? (p(), h(A, { key: 1 }, [
                y(" Referral Partner ")
              ], 64)) : P("", !0)
            ]),
            _: 1
          }),
          N(o, {
            field: "agentName",
            header: "Agent"
          }),
          N(o, {
            field: "lastLogin",
            header: "Last Login",
            sortable: ""
          }, {
            body: ve((b) => [
              e.showSendInvite(b.data) || !b.data.lastLogin ? V((p(), h("button", {
                key: 0,
                type: "button",
                onClick: (w) => e.sendInviteToClient(b.data),
                class: "btn btn-eclipse btn-sm",
                disabled: e.invitingClient || e.unlinkingClient
              }, t[20] || (t[20] = [
                a("i", { class: "fa-light fa-envelope" }, null, -1)
              ]), 8, Z3e)), [
                [
                  m,
                  "Resend guest user invite",
                  void 0,
                  { top: !0 }
                ]
              ]) : (p(), h(A, { key: 1 }, [
                y(g(e.date(b.data.lastLogin)), 1)
              ], 64))
            ]),
            _: 1
          }),
          N(o, {
            field: "status",
            header: "License"
          }, {
            body: ve((b) => [
              b.data.active ? (p(), h("span", J3e, "Active")) : (p(), h("span", $3e, "Inactive"))
            ]),
            _: 1
          }),
          N(o, {
            headerStyle: "width: 9rem; text-align: center",
            bodyStyle: "text-align: right; overflow: visible; text-wrap: nowrap"
          }, {
            body: ve((b) => [
              V((p(), h("button", {
                type: "button",
                onClick: (w) => e.verifyUnlink(b.data),
                class: "btn btn-outline-danger btn-sm ms-2",
                disabled: e.invitingClient || e.unlinkingClient
              }, t[21] || (t[21] = [
                a("i", { class: "fa-light fa-link-slash" }, null, -1)
              ]), 8, _3e)), [
                [
                  m,
                  "Remove guest user...",
                  void 0,
                  { top: !0 }
                ]
              ]),
              V((p(), h("button", {
                type: "button",
                class: z(e.activateStyle(b.data)),
                onClick: (w) => e.updateStatus(b.data),
                disabled: e.appBusy
              }, t[22] || (t[22] = [
                a("i", { class: "fa-light fa-power-off" }, null, -1)
              ]), 10, e8e)), [
                [
                  m,
                  b.data.active ? "Deactivate" : "Reactivate",
                  void 0,
                  { top: !0 }
                ]
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["value", "rows", "totalRecords", "loading", "sortField", "sortOrder"])
    ]),
    a("div", t8e, [
      a("div", s8e, [
        a("div", a8e, [
          a("div", n8e, [
            t[23] || (t[23] = a("i", { class: "fa-duotone fa-solid fa-person-circle-xmark mb-3 fa-2xl" }, null, -1)),
            t[24] || (t[24] = a("br", null, null, -1)),
            a("b", null, g(e.$t("t-are-you-sure-unlink")), 1),
            t[25] || (t[25] = a("br", null, null, -1)),
            t[26] || (t[26] = a("br", null, null, -1)),
            y(" " + g((f = e.clientToUnlink) == null ? void 0 : f.name), 1),
            t[27] || (t[27] = a("br", null, null, -1)),
            a("small", r8e, g((v = e.clientToUnlink) == null ? void 0 : v.email), 1)
          ]),
          e.errorMessage ? (p(), h("div", o8e, g(e.errorMessage), 1)) : P("", !0),
          a("div", i8e, [
            e.unlinkingClient ? (p(), h("svg", l8e, t[28] || (t[28] = [
              a("path", {
                fill: "#F26E34",
                d: "M73,50c0-12.7-10.3-23-23-23S27,37.3,27,50 M30.9,50c0-10.5,8.5-19.1,19.1-19.1S69.1,39.5,69.1,50"
              }, [
                a("animateTransform", {
                  attributeName: "transform",
                  attributeType: "XML",
                  type: "rotate",
                  dur: "1s",
                  from: "0 50 50",
                  to: "360 50 50",
                  repeatCount: "indefinite"
                })
              ], -1)
            ]))) : P("", !0),
            a("button", {
              type: "button",
              class: "btn btn-secondary",
              "data-bs-dismiss": "modal",
              disabled: e.appBusy || e.unlinkingClient
            }, g(e.$t("t-cancel")), 9, d8e),
            a("button", {
              type: "button",
              class: "btn btn-danger",
              onClick: t[5] || (t[5] = (...b) => e.unlinkClient && e.unlinkClient(...b)),
              disabled: e.appBusy || e.unlinkingClient
            }, g(e.$t("t-unlink")), 9, c8e)
          ])
        ])
      ])
    ], 512),
    a("div", u8e, [
      a("div", p8e, [
        a("div", h8e, [
          a("div", m8e, [
            a("p", f8e, g(e.$t("Add User")), 1),
            a("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close",
              disabled: e.invitingClient
            }, null, 8, g8e)
          ]),
          a("div", v8e, [
            e.hasClients || e.clientListFilter ? (p(), h("div", y8e, [
              t[30] || (t[30] = a("label", { class: "col-sm-4 col-form-label" }, "Contact", -1)),
              a("div", b8e, [
                a("div", A8e, [
                  V(a("input", {
                    class: "form-check-input",
                    type: "checkbox",
                    role: "switch",
                    id: "switchMemberType",
                    "onUpdate:modelValue": t[6] || (t[6] = (b) => e.isExistingClient = b)
                  }, null, 512), [
                    [Ue, e.isExistingClient]
                  ]),
                  t[29] || (t[29] = a("label", {
                    class: "form-check-label",
                    for: "switchMemberType"
                  }, [
                    a("span", null, "New"),
                    y("Existing")
                  ], -1))
                ])
              ])
            ])) : P("", !0),
            N(ks, {
              name: "slide",
              mode: "out-in"
            }, {
              default: ve(() => [
                e.isExistingClient && (e.hasClients || e.clientListFilter) ? (p(), h("div", w8e, [
                  t[31] || (t[31] = a("label", {
                    for: "existingClientId",
                    class: "col-sm-4 col-form-label"
                  }, "Contact:", -1)),
                  a("div", C8e, [
                    N(c, {
                      modelValue: e.newClient.id,
                      "onUpdate:modelValue": t[7] || (t[7] = (b) => e.newClient.id = b),
                      autoFilterFocus: "",
                      filter: "",
                      onFilter: e.filterGuests,
                      filterFields: ["name", "email"],
                      size: "small",
                      filterValue: e.clientListFilter,
                      options: e.clients,
                      optionLabel: "name",
                      optionValue: "id",
                      appendTo: "self",
                      placeholder: "Select a Guest",
                      class: "form-select",
                      "data-val-id": "id"
                    }, nP({
                      option: ve((b) => {
                        var w, S;
                        return [
                          ((w = b.option.name) == null ? void 0 : w.length) > 0 ? (p(), h(A, { key: 0 }, [
                            y(g(b.option.name), 1)
                          ], 64)) : (p(), h(A, { key: 1 }, [
                            y("No name")
                          ], 64)),
                          ((S = b.option.email) == null ? void 0 : S.length) > 0 ? (p(), h(A, { key: 2 }, [
                            y(" (" + g(b.option.email) + ")", 1)
                          ], 64)) : P("", !0)
                        ];
                      }),
                      _: 2
                    }, [
                      e.clientListTotal > e.clientListPageSize ? {
                        name: "footer",
                        fn: ve(() => [
                          a("div", S8e, [
                            N(d, {
                              rows: e.clientListPageSize,
                              totalRecords: e.clientListTotal,
                              template: "FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink",
                              currentPageReportTemplate: "Showing {first} to {last} of {totalRecords}",
                              onPage: e.nextClientPage
                            }, null, 8, ["rows", "totalRecords", "onPage"])
                          ])
                        ]),
                        key: "0"
                      } : void 0
                    ]), 1032, ["modelValue", "onFilter", "filterValue", "options"])
                  ])
                ])) : (p(), h("div", P8e, [
                  a("div", k8e, [
                    a("label", E8e, g(e.$t("Name")) + ":", 1),
                    a("div", I8e, [
                      V(a("input", {
                        type: "text",
                        class: "form-control",
                        id: "inputName",
                        "onUpdate:modelValue": t[8] || (t[8] = (b) => e.newClient.name = b),
                        "data-val-id": "name",
                        "aria-label": "Client's name",
                        disabled: e.invitingClient
                      }, null, 8, T8e), [
                        [_e, e.newClient.name]
                      ])
                    ])
                  ]),
                  a("div", O8e, [
                    a("label", R8e, g(e.$t("Email")) + ":", 1),
                    a("div", L8e, [
                      a("div", B8e, [
                        t[32] || (t[32] = a("span", {
                          class: "input-group-text",
                          id: "basic-addon1"
                        }, [
                          a("i", { class: "fa-light fa-envelope" })
                        ], -1)),
                        V(a("input", {
                          type: "email",
                          class: "form-control",
                          id: "inputEmail",
                          "onUpdate:modelValue": t[9] || (t[9] = (b) => e.newClient.email = b),
                          "data-val-id": "email",
                          "aria-label": "Email",
                          "aria-describedby": "basic-addon1",
                          disabled: e.invitingClient
                        }, null, 8, M8e), [
                          [_e, e.newClient.email]
                        ])
                      ])
                    ])
                  ])
                ]))
              ]),
              _: 1
            }),
            a("div", null, [
              a("div", x8e, [
                a("label", F8e, g(e.$t("Relationship")) + ":", 1),
                a("div", V8e, [
                  V(a("select", {
                    id: "type",
                    class: "form-select",
                    "onUpdate:modelValue": t[10] || (t[10] = (b) => e.newClient.type = b),
                    disabled: e.invitingClient
                  }, [
                    a("option", {
                      value: e.ClientRelationshipType.Investor
                    }, g(e.$t("Investor")), 9, N8e),
                    a("option", {
                      value: e.ClientRelationshipType.ReferralPartner
                    }, g(e.$t("Referral Partner")), 9, j8e)
                  ], 8, D8e), [
                    [We, e.newClient.type]
                  ])
                ])
              ])
            ]),
            t[33] || (t[33] = a("div", {
              class: "alert alert-danger mt-3 d-none",
              role: "alert",
              "data-val-summary": ""
            }, null, -1))
          ]),
          a("div", H8e, [
            N(u, {
              onClick: e.addClient,
              busy: e.invitingClient,
              "onUpdate:busy": t[11] || (t[11] = (b) => e.invitingClient = b)
            }, {
              default: ve(() => t[34] || (t[34] = [
                y("Add & Send Invitation")
              ])),
              _: 1,
              __: [34]
            }, 8, ["onClick", "busy"])
          ])
        ])
      ])
    ], 512)
  ], 64);
}
const Rls = /* @__PURE__ */ Ae(C3e, [["render", U8e]]), z8e = me({
  name: "ForeclosureData",
  components: {},
  data() {
    return {
      foreclosureLoading: !1,
      foreclosureRecord: void 0
    };
  },
  computed: {
    ...q(Te, ["acl", "aclLoaded"]),
    ...q(qe, ["property"])
  },
  methods: {
    number: Ve,
    currency: Ze,
    percent: Wt,
    formatDate: sb,
    shortDate(e) {
      return e && e != "" ? this.formatDate(new Date(e)) : "";
    },
    async retrieveForeclosureRecord() {
      if (this.property.propId !== null && this.acl.properties.viewPreForeclosure) {
        try {
          this.foreclosureLoading = !0;
          const e = await W.api.records.foreclosure(this.property.propId);
          this.foreclosureRecord = e.data.record;
        } catch (e) {
          console.log("retrieveForeclosureRecord", e);
        }
        this.foreclosureLoading = !1;
      }
    }
  },
  mounted() {
    this.aclLoaded.then(async () => await this.retrieveForeclosureRecord());
  }
}), W8e = {
  key: 0,
  class: "card shadow-sm mb-4"
}, G8e = { class: "locked" }, Y8e = {
  key: 0,
  class: "cta text-center"
}, X8e = { class: "row g-0" }, q8e = { class: "col" }, Q8e = { class: "p-3 border-end" }, K8e = { class: "table table-sm table-borderless m-0" }, Z8e = { class: "p-3 border-top border-end" }, J8e = { class: "table table-sm table-borderless m-0" }, $8e = { class: "col" }, _8e = { class: "p-3" }, e4e = { class: "table table-sm table-borderless m-0" }, t4e = { class: "text-end" }, s4e = { class: "text-end" }, a4e = { class: "text-end" }, n4e = { class: "text-end" }, r4e = { class: "text-end" }, o4e = { class: "text-end" }, i4e = { class: "col" }, l4e = { class: "p-3 border-start-lg-1" }, d4e = { class: "table table-sm table-borderless m-0" }, c4e = { class: "text-end" }, u4e = { class: "text-end" }, p4e = { class: "text-end" }, h4e = { class: "text-end" }, m4e = { class: "text-end" }, f4e = { class: "row g-0" }, g4e = { class: "col" }, v4e = { class: "p-3 border-top border-end" }, y4e = { class: "table table-sm table-borderless m-0" }, b4e = { class: "col" }, A4e = { class: "p-3 border-top" }, w4e = { class: "table table-sm table-borderless m-0" };
function C4e(e, t, s, n, r, i) {
  return e.foreclosureRecord ? (p(), h("div", W8e, [
    t[27] || (t[27] = a("div", { class: "card-header bg-white fw-bold text-start" }, [
      a("span", { class: "fa-stack fa-lg mr-2" }, [
        a("i", { class: "fa-solid fa-circle fa-stack-2x text-skipper" }),
        a("i", { class: "fa-light fa-gavel fa-stack-1x fa-inverse" })
      ]),
      y(" Foreclosure Data ")
    ], -1)),
    a("div", G8e, [
      !e.acl || !e.acl.properties.viewPreForeclosure ? (p(), h("div", Y8e, t[0] || (t[0] = [
        y(" Interested in viewing pre-forclosure data?"),
        a("br", null, null, -1),
        y("Click below to explore this feature and upgrade your subscription! "),
        a("br", null, null, -1),
        a("br", null, null, -1),
        a("a", {
          href: "/features/records",
          class: "btn btn-lava"
        }, "Explore Pre-forclosure", -1)
      ]))) : P("", !0),
      a("div", {
        class: z({ blur: !e.acl || !e.acl.properties.viewPreForeclosure })
      }, [
        a("div", X8e, [
          a("div", q8e, [
            a("div", Q8e, [
              a("table", K8e, [
                a("tbody", null, [
                  a("tr", null, [
                    t[1] || (t[1] = a("th", null, "Borrower", -1)),
                    a("td", null, g(e.foreclosureRecord.borrower), 1)
                  ]),
                  a("tr", null, [
                    t[2] || (t[2] = a("th", null, "Original Loan Amount", -1)),
                    a("td", null, g(e.currency(e.foreclosureRecord.originalLoanAmount)), 1)
                  ])
                ])
              ])
            ]),
            a("div", Z8e, [
              t[7] || (t[7] = a("div", { class: "text-secondary text-opacity-50" }, [
                a("b", null, "LENDER")
              ], -1)),
              a("table", J8e, [
                a("tbody", null, [
                  a("tr", null, [
                    t[3] || (t[3] = a("th", null, "Name", -1)),
                    a("td", null, g(e.foreclosureRecord.lenderName), 1)
                  ]),
                  a("tr", null, [
                    t[5] || (t[5] = a("th", null, "Address", -1)),
                    a("td", null, [
                      y(g(e.foreclosureRecord.lenderAddress), 1),
                      t[4] || (t[4] = a("br", null, null, -1)),
                      y(" " + g(e.foreclosureRecord.lenderCity) + ", " + g(e.foreclosureRecord.lenderState) + " " + g(e.foreclosureRecord.lenderZip), 1)
                    ])
                  ]),
                  a("tr", null, [
                    t[6] || (t[6] = a("th", null, "Phone", -1)),
                    a("td", null, g(e.foreclosureRecord.lenderPhone), 1)
                  ])
                ])
              ])
            ])
          ]),
          a("div", $8e, [
            a("div", _8e, [
              a("table", e4e, [
                a("tbody", null, [
                  a("tr", null, [
                    t[8] || (t[8] = a("th", null, "Payment", -1)),
                    a("td", t4e, g(e.currency(e.foreclosureRecord.payment)), 1)
                  ]),
                  a("tr", null, [
                    t[9] || (t[9] = a("th", null, "Default Amount", -1)),
                    a("td", s4e, g(e.currency(e.foreclosureRecord.defaultAmount)), 1)
                  ]),
                  a("tr", null, [
                    t[10] || (t[10] = a("th", null, "Penalty Interest", -1)),
                    a("td", a4e, g(e.currency(e.foreclosureRecord.penaltyInterest)), 1)
                  ]),
                  a("tr", null, [
                    t[11] || (t[11] = a("th", null, "Loan Balance", -1)),
                    a("td", n4e, g(e.currency(e.foreclosureRecord.loanBalance)), 1)
                  ]),
                  a("tr", null, [
                    t[12] || (t[12] = a("th", null, "Judgment Date", -1)),
                    a("td", r4e, g(e.shortDate(e.foreclosureRecord.judgmentDate)), 1)
                  ]),
                  a("tr", null, [
                    t[13] || (t[13] = a("th", null, "Judgment Amount", -1)),
                    a("td", o4e, g(e.currency(e.foreclosureRecord.judgmentAmount)), 1)
                  ])
                ])
              ])
            ])
          ]),
          a("div", i4e, [
            a("div", l4e, [
              t[20] || (t[20] = a("div", { class: "text-secondary text-opacity-50" }, [
                a("b", null, "AUCTION")
              ], -1)),
              a("table", d4e, [
                a("tbody", null, [
                  a("tr", null, [
                    t[14] || (t[14] = a("th", null, "Courthouse", -1)),
                    a("td", c4e, g(e.foreclosureRecord.courthouse), 1)
                  ]),
                  a("tr", null, [
                    t[16] || (t[16] = a("th", null, "Address", -1)),
                    a("td", u4e, [
                      y(g(e.foreclosureRecord.auctionAddress), 1),
                      t[15] || (t[15] = a("br", null, null, -1)),
                      y(" " + g(e.foreclosureRecord.auctionCity), 1)
                    ])
                  ]),
                  a("tr", null, [
                    t[17] || (t[17] = a("th", null, "Auction Date", -1)),
                    a("td", p4e, g(e.longDate(e.foreclosureRecord.auctionDateTime)), 1)
                  ]),
                  a("tr", null, [
                    t[18] || (t[18] = a("th", null, "Recorded Auction Opening Bid", -1)),
                    a("td", h4e, g(e.currency(e.foreclosureRecord.recordedAuctionOpeningBid)), 1)
                  ]),
                  a("tr", null, [
                    t[19] || (t[19] = a("th", null, "Estimated Value", -1)),
                    a("td", m4e, g(e.currency(e.foreclosureRecord.estimatedValue)), 1)
                  ])
                ])
              ])
            ])
          ])
        ]),
        a("div", f4e, [
          a("div", g4e, [
            a("div", v4e, [
              a("table", y4e, [
                a("tbody", null, [
                  a("tr", null, [
                    t[21] || (t[21] = a("th", null, "Create Date", -1)),
                    a("td", null, g(e.shortDate(e.foreclosureRecord.createDate)), 1)
                  ]),
                  a("tr", null, [
                    t[22] || (t[22] = a("th", null, "Record Last Updated", -1)),
                    a("td", null, g(e.shortDate(e.foreclosureRecord.recordLastUpdated)), 1)
                  ]),
                  a("tr", null, [
                    t[23] || (t[23] = a("th", null, "Publication Date", -1)),
                    a("td", null, g(e.shortDate(e.foreclosureRecord.publicationDate)), 1)
                  ])
                ])
              ])
            ])
          ]),
          a("div", b4e, [
            a("div", A4e, [
              t[26] || (t[26] = a("div", { class: "text-secondary text-opacity-50" }, [
                a("b", null, "FORECLOSURE")
              ], -1)),
              a("table", w4e, [
                a("tbody", null, [
                  a("tr", null, [
                    t[24] || (t[24] = a("th", null, "Instrument Date", -1)),
                    a("td", null, g(e.shortDate(e.foreclosureRecord.foreclosureInstrumentDate)), 1)
                  ]),
                  a("tr", null, [
                    t[25] || (t[25] = a("th", null, "Recording Date", -1)),
                    a("td", null, g(e.shortDate(e.foreclosureRecord.foreclosureRecordingDate)), 1)
                  ])
                ])
              ])
            ])
          ])
        ])
      ], 2)
    ])
  ])) : P("", !0);
}
const Lls = /* @__PURE__ */ Ae(z8e, [["render", C4e]]), S4e = me({
  name: "DateInput",
  props: {
    modelValue: Object,
    orignalValue: Date,
    class: String,
    placeholder: String,
    allowEmpty: Boolean,
    disabled: Boolean,
    locked: Boolean,
    checkUndefined: Boolean,
    invalid: Boolean
  },
  emits: [
    "update:modelValue",
    "change"
  ],
  data() {
    return {
      id: n1(),
      value: void 0,
      _orig: void 0
    };
  },
  watch: {
    modelValue(e) {
      console.log(`${this.$options.name}.watch.model`, e), this.value = e;
    }
  },
  computed: {
    inputGroupClass() {
      return {
        "input-group": !0,
        "input-date": !0,
        "has-validation": this.invalid,
        locked: this.locked == !0,
        changed: (this.orignalValue != null || this.checkUndefined == !0) && this.orignalValue != this.value
      };
    },
    inputClass() {
      const e = {
        "form-control": !0,
        "is-invalid": this.invalid,
        changed: (this.orignalValue != null || this.checkUndefined == !0) && this.orignalValue != this.value,
        locked: this.locked == !0
      };
      return this.class && this.class.split(" ").forEach((t) => e[t] = !0), e;
    },
    formated: {
      get() {
        return this.value ? this.value.toISOString().slice(0, 10) : "";
      },
      set(e) {
        this.allowEmpty == !0 && e == "" ? this.value = void 0 : (rd.test(e) || od.test(e)) && (this.value = new Date(e));
      }
    }
  },
  methods: {
    number: Ve,
    onFocus() {
      console.log(`${this.$options.name}.onFocus`, this._orig, this.value), this._orig = this.value;
    },
    lostFocus() {
      console.log(`${this.$options.name}.lostFocus`, this._orig, this.value), this._orig != this.value && (this.$emit("update:modelValue", this.value), this.$emit("change", this.value)), this._orig = void 0;
    }
  },
  created() {
    this.modelValue && P4e(this.modelValue) && (rd.test(this.modelValue) || od.test(this.modelValue)) ? this.value = new Date(this.modelValue) : this.modelValue && (this.value = this.modelValue);
  }
});
function P4e(e) {
  return e != null && e != null && typeof e == "string" || e instanceof String;
}
const k4e = ["placeholder", "disabled"], E4e = {
  key: 0,
  class: "input-group-text border-start-0 locked ps-0"
};
function I4e(e, t, s, n, r, i) {
  return p(), h("div", {
    class: z(e.inputGroupClass)
  }, [
    t[4] || (t[4] = a("span", { class: "input-group-text" }, [
      a("i", { class: "fa-light fa-calendar" })
    ], -1)),
    V(a("input", {
      type: "date",
      "onUpdate:modelValue": t[0] || (t[0] = (o) => e.formated = o),
      class: z(e.inputClass),
      placeholder: e.placeholder,
      onFocus: t[1] || (t[1] = (...o) => e.onFocus && e.onFocus(...o)),
      onBlur: t[2] || (t[2] = (...o) => e.lostFocus && e.lostFocus(...o)),
      disabled: e.disabled || e.locked,
      "data-clarity-unmask": "true"
    }, null, 42, k4e), [
      [_e, e.formated]
    ]),
    e.locked ? (p(), h("div", E4e, t[3] || (t[3] = [
      a("i", {
        class: "fa-duotone fa-solid fa-lock-keyhole",
        "aria-hidden": "true"
      }, null, -1)
    ]))) : P("", !0)
  ], 2);
}
const Ab = /* @__PURE__ */ Ae(S4e, [["render", I4e]]), T4e = me({
  name: "ExistingInvestment",
  props: {
    analysis: {
      type: String,
      required: !1
    },
    share: {
      type: String,
      required: !1
    }
  },
  emits: [
    "resetListing"
  ],
  components: {
    OverlayPanel: mI,
    NumericalInput: Aa,
    DateInput: Ab
  },
  data() {
    return {
      currentTab: "#cost-basis",
      investmentBasisFound: !1,
      currentFirstYearAsRental: void 0
    };
  },
  computed: {
    askLoanFeesAndCosts() {
      return this.firstYearAsRental == this.purchaseYear;
    },
    daysBetween() {
      return (this.purchaseFacts && Math.round((this.purchaseFacts.loan.date.getTime() - this.purchaseFacts.purchaseDate.getTime()) / 864e5)) ?? 0;
    },
    analysisYears() {
      var e, t;
      return (t = (e = this.purchaseFacts) == null ? void 0 : e.years) == null ? void 0 : t.filter((s) => s.year >= this.firstYearToAnalyze);
    },
    incomeAndVacancyAnalysisYears() {
      var e, t;
      return (t = (e = this.purchaseFacts) == null ? void 0 : e.years) == null ? void 0 : t.filter((s) => s.year >= this.firstYearToAnalyze && s.year < Et);
    },
    ignoreHistoricalOperatingIncome() {
      var e;
      return ((e = this.purchaseFacts) == null ? void 0 : e.ignoreHistoricalOperatingIncome) == !0;
    },
    dontIgnoreHistoricalOperatingIncome: {
      get() {
        var e;
        return !((e = this.purchaseFacts) != null && e.ignoreHistoricalOperatingIncome);
      },
      set(e) {
        this.purchaseFacts.ignoreHistoricalOperatingIncome = !e;
      }
    },
    calculateUsingHistoricalFacts: {
      get() {
        return this.cantAutoPopulate ? !1 : this.isExistingInvestment;
      },
      set(e) {
        this.cantAutoPopulate == !1 && (this.calcParams.investmentStrategy = e ? $n.ExistingInvestment : $n.NewPurchase);
      }
    },
    titleCharges: {
      get() {
        var e;
        return Ve((e = this.purchaseFacts) == null ? void 0 : e.titleCharges);
      },
      set(e) {
        this.purchaseFacts.titleCharges = vs(e);
      }
    },
    rehab: {
      get() {
        var e;
        return (e = this.calcParams) != null && e.rehabamount ? Ve(this.calcParams.rehabamount) : "";
      },
      set(e) {
        this.calcParams.rehabamount = vs(e);
      }
    },
    workingCapital: {
      get() {
        var e;
        return (e = this.calcParams) != null && e.workingCapitalReserve ? Ve(this.calcParams.workingCapitalReserve) : "";
      },
      set(e) {
        this.calcParams.workingCapitalReserve = vs(e);
      }
    },
    loanPayment() {
      var e;
      if ((e = this.purchaseFacts) != null && e.loan)
        return pn(this.purchaseFacts.loan.interestRate / 12, this.purchaseFacts.loan.term * 12, this.purchaseFacts.loan.amount);
    },
    loanDate: {
      get() {
        var e, t;
        return (t = (e = this.purchaseFacts) == null ? void 0 : e.loan) != null && t.date ? this.purchaseFacts.loan.date.toISOString().slice(0, 10) : "";
      },
      set(e) {
        (rd.test(e) || od.test(e)) && (this.purchaseFacts.loan.date = new Date(e)), e == "" && (this.purchaseFacts.loan.date = void 0);
      }
    },
    loanDatePaidOff: {
      get() {
        var e, t;
        return (t = (e = this.purchaseFacts) == null ? void 0 : e.loan) != null && t.datePaidOff ? this.purchaseFacts.loan.datePaidOff.toISOString().slice(0, 10) : "";
      },
      set(e) {
        (rd.test(e) || od.test(e)) && (this.purchaseFacts.loan.datePaidOff = new Date(e)), e == "" && (this.purchaseFacts.loan.datePaidOff = void 0);
      }
    },
    isLoanPaidOff: {
      get() {
        var e, t;
        return ((t = (e = this.purchaseFacts) == null ? void 0 : e.loan) == null ? void 0 : t.isPaidOff) == !0;
      },
      set(e) {
        var t;
        (t = this.purchaseFacts) != null && t.loan && (this.purchaseFacts.loan.isPaidOff = e);
      }
    },
    balancePaidOff() {
      var e, t;
      return (t = (e = this.purchaseFacts) == null ? void 0 : e.loan) == null ? void 0 : t.balancePaidOff;
    },
    hasCurrentLoan: {
      get() {
        var e;
        return ((e = this.purchaseFacts) == null ? void 0 : e.hasCurrentLoan) == !0;
      },
      set(e) {
        this.purchaseFacts && (this.purchaseFacts.hasCurrentLoan = e);
      }
    },
    hasPreviousLoan() {
      var e, t;
      return this.purchaseFacts && ((e = this.purchaseFacts) == null ? void 0 : e.hasPreviousLoan) && ((t = this.purchaseFacts) == null ? void 0 : t.previousLoan) != null;
    },
    previousLoanPayment() {
      var e;
      if ((e = this.purchaseFacts) != null && e.previousLoan)
        return pn(
          this.purchaseFacts.previousLoan.interestRate / 12,
          this.purchaseFacts.previousLoan.term * 12,
          this.purchaseFacts.previousLoan.amount
        );
    },
    previousLoanDate: {
      get() {
        var e, t;
        return (t = (e = this.purchaseFacts) == null ? void 0 : e.previousLoan) != null && t.date ? this.purchaseFacts.previousLoan.date.toISOString().slice(0, 10) : "";
      },
      set(e) {
        (rd.test(e) || od.test(e)) && (this.purchaseFacts.previousLoan.date = new Date(e)), e == "" && (this.purchaseFacts.previousLoan.date = void 0);
      }
    },
    fastForwardAnalysis() {
      var e;
      return this.purchaseFacts && ((e = this.purchaseFacts) == null ? void 0 : e.ignoreHistoricalOperatingIncome);
    },
    costOfSaleFormated: {
      get() {
        return this.calcParams.costofsale ? Ve(this.calcParams.costofsale * 100, 2) : "";
      },
      set(e) {
        this.calcParams.costofsale || (this.calcParams.costofsale = 0), this.calcParams.costofsale = vs(e) / 100;
      }
    },
    rentalIncomeCalculationMethod: {
      get() {
        var e;
        return ((e = this.purchaseFacts) == null ? void 0 : e.rentalIncomeCalculationMethod) ?? dA.MonthlyLessVacancy;
      },
      set(e) {
        this.purchaseFacts.rentalIncomeCalculationMethod = e;
      }
    },
    firstYearAsRental: {
      get() {
        var e;
        return ((e = this.purchaseFacts) == null ? void 0 : e.firstYearAsRental) ?? Et;
      },
      set(e) {
        var s, n;
        const t = (n = (s = this.purchaseFacts) == null ? void 0 : s.years) == null ? void 0 : n.find((r) => r.year == e - 1);
        t && (this.purchaseFacts.investmentBasis = t.propertyValue), this.currentFirstYearAsRental || (this.currentFirstYearAsRental = this.purchaseFacts.firstYearAsRental), this.purchaseFacts.firstYearAsRental = e, this.purchaseFacts.firstYearToAnalyze = e, t || this.$nextTick(() => {
          var i, o;
          const r = (o = (i = this.purchaseFacts) == null ? void 0 : i.years) == null ? void 0 : o.find((l) => l.year == e - 1);
          r && (this.purchaseFacts.investmentBasis = r.propertyValue);
        });
      }
    },
    firstYearToAnalyze: {
      get() {
        var e;
        return ((e = this.purchaseFacts) == null ? void 0 : e.firstYearToAnalyze) ?? 0;
      },
      set(e) {
        this.purchaseFacts.firstYearToAnalyze = e;
      }
    },
    alertMessage() {
      var t, s, n, r, i, o, l, d, c, u, m, f, v;
      const e = [];
      return (this.calcParams.propertyValueEoY ?? 0) <= 0 && e.push("The current EoY Property Value must be valid number and greater than $0"), (((t = this.purchaseFacts) == null ? void 0 : t.investmentBasis) ?? 0) <= 0 && e.push("The first year's initial Property Value must be valid number and greater than $0"), (((s = this.purchaseFacts) == null ? void 0 : s.purchasePrice) ?? 0) <= 0 && e.push("Purchase Price must be valid number and greater than $0"), ((n = this.purchaseFacts) == null ? void 0 : n.purchaseDate) == null && e.push("Purchase Date must be valid date"), ((r = this.purchaseFacts) == null ? void 0 : r.hasCurrentLoan) == !0 && (((i = this.purchaseFacts.loan) == null ? void 0 : i.amount) <= 0 && e.push("Loan Amount must be valid number and greater than $0"), ((o = this.purchaseFacts.loan) == null ? void 0 : o.date) == null && e.push("Loan Date must be valid date"), ((l = this.purchaseFacts.loan) == null ? void 0 : l.term) <= 0 && e.push("Amortization Years must be valid number and greater than 0"), ((d = this.purchaseFacts.loan) == null ? void 0 : d.interestRate) <= 0 && e.push("Loan Interest Rate must be valid number and greater than 0%"), this.askIfPreviousLoan && ((c = this.purchaseFacts) == null ? void 0 : c.hasPreviousLoan) == !0 && (((u = this.purchaseFacts.previousLoan) == null ? void 0 : u.amount) <= 0 && e.push("Previous Loan Amount must be valid number and greater than $0"), ((m = this.purchaseFacts.previousLoan) == null ? void 0 : m.date) == null && e.push("Previous Loan Date must be valid date"), ((f = this.purchaseFacts.previousLoan) == null ? void 0 : f.term) <= 0 && e.push("Previous Amortization Years must be valid number and greater than 0"), ((v = this.purchaseFacts.previousLoan) == null ? void 0 : v.interestRate) <= 0 && e.push("Previous Loan Interest Rate must be valid number and greater than 0%"))), e;
    },
    hasCurrentLoanStyle() {
      var e;
      return {
        "border-top": ((e = this.purchaseFacts) == null ? void 0 : e.hasCurrentLoan) == !0
      };
    },
    yearsList() {
      let e = [], t = this.purchaseYear ?? 1990;
      for (let s = t; s <= Et; s++)
        e.push(s);
      return e;
    },
    analyzeYearsList() {
      let e = [], t = this.firstYearAsRental ?? 1990;
      for (let s = t; s <= Et; s++)
        e.push(s);
      return e;
    },
    cantCalculateSave() {
      var e, t;
      return this.cantAutoPopulate || ((e = this.access) == null ? void 0 : e.isAuthenticated) != !0 && ((t = this.access) == null ? void 0 : t.isIdx) != !0;
    },
    calculateAndSaveStyle() {
      return {
        issue: this.requireCalculateAndSave
      };
    },
    purchaseFactsYears() {
      var s, n, r, i, o;
      const e = Math.max((s = this.purchaseFacts) == null ? void 0 : s.firstYearAsRental, (r = (n = this.purchaseFacts) == null ? void 0 : n.purchaseDate) == null ? void 0 : r.getFullYear()) ?? Et, t = Et - 1;
      return ((o = (i = this.purchaseFacts) == null ? void 0 : i.years) == null ? void 0 : o.filter((l) => l.year >= e && l.year <= t).sort((l, d) => l.year - d.year)) ?? [];
    },
    currentYear() {
      return Et;
    },
    showClearRest() {
      return this.currentTab == "#cost-basis";
    },
    showPrevButton() {
      return this.currentTab == "#value-equity" || this.currentTab == "#loan-details" || this.currentTab == "#income-vacancy" || this.currentTab == "#operating-costs";
    },
    showNextButton() {
      return this.currentTab == "#cost-basis" || this.currentTab == "#loan-details" || this.currentTab == "#value-equity" && this.isRentVsSell == !1 || this.currentTab == "#income-vacancy" && this.fastForwardAnalysis == !1;
    },
    disableNextButton() {
      return !!(this.currentTab == "#income-vacancy" && this.fastForwardAnalysis == !1 && this.cantAutoPopulate);
    },
    showCalculate() {
      return !!(this.currentTab == "#operating-costs" || this.fastForwardAnalysis);
    },
    costBasis() {
      var e, t, s, n, r, i, o, l;
      return this.ignoreHistoricalOperatingIncome ? (((e = this.calcParams) == null ? void 0 : e.propertyValueEoY) ?? 0) + (((t = this.calcParams) == null ? void 0 : t.rehabamount) ?? 0) : ((s = this.purchaseFacts) == null ? void 0 : s.firstYearAsRental) == this.purchaseYear ? (((n = this.purchaseFacts) == null ? void 0 : n.purchasePrice) ?? 0) + (((r = this.purchaseFacts) == null ? void 0 : r.titleCharges) ?? 0) + (((i = this.calcParams) == null ? void 0 : i.rehabamount) ?? 0) : (((o = this.purchaseFacts) == null ? void 0 : o.investmentBasis) ?? 0) + (((l = this.calcParams) == null ? void 0 : l.rehabamount) ?? 0);
    },
    needsAutoCalculate() {
      var e;
      return this.currentFirstYearAsRental != null && this.currentFirstYearAsRental != ((e = this.purchaseFacts) == null ? void 0 : e.firstYearAsRental);
    },
    ...q(Te, ["access", "aclLoaded"]),
    ...q(ct, ["otherIncomeAccounts", "otherExpenseAccounts"]),
    ...q(qe, [
      "purchaseFacts",
      "calcParams",
      "cantAutoPopulate",
      "askIfPreviousLoan",
      "populatingLoans",
      "property",
      "isSyncedExpenses",
      "autoCalculateLoanFees",
      "requireCalculateAndSave",
      "isExistingInvestment",
      "isRentVsSell",
      "purchaseYear",
      "firstAnalyzedYear",
      "isCurrentYear",
      "calculatedResults",
      "isAtPurchase"
    ]),
    ...at(qe)
  },
  watch: {
    purchaseFacts: {
      handler(e, t) {
        this.populatingLoans || !(t != null && t.investmentBasis) && (!(t != null && t.investmentBasis) && !(e != null && e.investmentBasis) || (e == null ? void 0 : e.investmentBasis) != (t == null ? void 0 : t.investmentBasis)) && this.populateInvestmentBasis();
      },
      deep: !0
    },
    "purchaseFacts.purchaseDate"(e, t) {
      var s, n, r;
      e && t && t.getFullYear() == this.firstYearAsRental && (this.firstYearAsRental = e.getFullYear()), this.purchaseFacts && ((s = this.purchaseFacts) != null && s.loan) && (!((n = this.purchaseFacts) != null && n.loan.date) || ((r = this.purchaseFacts) == null ? void 0 : r.loan.date) == t) && (this.purchaseFacts.loan.date = e), e && (this.propertyStore.validateFirstYearAsRental(), this.propertyStore.buildYears(), this.propertyStore.populateLoans());
    },
    "purchaseFacts.hasCurrentLoan"(e) {
      e && this.purchaseFacts && !this.purchaseFacts.loan && (this.purchaseFacts.loan = {}, this.propertyStore.populateLoans());
    },
    "purchaseFacts.firstYearAsRental"(e, t) {
      e != t && this.propertyStore.buildYears();
    },
    "purchaseFacts.hasPreviousLoan"(e) {
      var t;
      e && this.purchaseFacts && ((t = this.purchaseFacts) == null ? void 0 : t.previousLoan) == null && (this.purchaseFacts.previousLoan = {}), this.propertyStore.populateLoans();
    },
    "purchaseFacts.loan.datePaidOff"(e) {
      var t, s, n, r;
      this.propertyStore.populateLoans(!1), (t = this.purchaseFacts) != null && t.loan && (this.purchaseFacts.loan.balancePaidOff = this.propertyStore.calculateLoanPaidOffBalance((s = this.purchaseFacts) == null ? void 0 : s.loan, (n = this.purchaseFacts) == null ? void 0 : n.loan.date, (r = this.purchaseFacts) == null ? void 0 : r.loan.datePaidOff));
    },
    "purchaseFacts.loan.amount"(e) {
      var t;
      this.propertyStore.loading == !1 && this.propertyStore.autoCalculateLoanFees == !0 && ((t = this.purchaseFacts) != null && t.loan) && (this.purchaseFacts.loan.closingCosts = Math.trunc(e * this.calcParams.loanfees));
    },
    "purchaseFacts.loan": {
      handler() {
        var e, t, s, n;
        this.propertyStore.populateLoans(!1), (e = this.purchaseFacts) != null && e.loan && (this.purchaseFacts.loan.balancePaidOff = this.propertyStore.calculateLoanPaidOffBalance((t = this.purchaseFacts) == null ? void 0 : t.loan, (s = this.purchaseFacts) == null ? void 0 : s.loan.date, (n = this.purchaseFacts) == null ? void 0 : n.loan.datePaidOff));
      },
      deep: !0
    },
    "purchaseFacts.previousLoan": {
      handler() {
        this.propertyStore.populateLoans();
      },
      deep: !0
    }
  },
  methods: {
    number: Ve,
    currency: Ze,
    formatDate: cs,
    /** Initialization method that gets called each time modal opens. */
    async editInvestment() {
      var e;
      try {
        await this.propertyStore.initPurchaseFacts(), (e = bootstrap.Modal.getOrCreateInstance(this.$refs.modalExistingInvestment)) == null || e.show();
      } catch (t) {
        Se(t);
      }
    },
    async calculate() {
      var e;
      try {
        (e = bootstrap.Modal.getOrCreateInstance(this.$refs.modalExistingInvestment)) == null || e.hide(), await this.propertyStore.calculate(!0);
      } catch (t) {
        (!Le.isRescoverError(t) || !t.handled) && Se(t);
      } finally {
        this.propertyStore.setRequireCalculateAndSave(!1);
      }
    },
    calculateEquityForYear(e) {
      return this.calculateEquity(e.propertyValue, e.loanBalance);
    },
    calculateEquity(e, t) {
      return e - (t ?? 0) - e * this.calcParams.costofsale;
    },
    async populateInvestmentBasis() {
      var t, s, n, r, i, o, l, d, c, u, m, f, v, b;
      if (this.investmentBasisFound || (((t = this.purchaseFacts) == null ? void 0 : t.investmentBasis) ?? 0) > 0 || !((s = this.purchaseFacts) != null && s.firstYearAsRental) && !((n = this.purchaseFacts) != null && n.purchaseDate))
        return;
      const e = await W.api.calculator.initPurchaseFacts(
        this.property.propId,
        this.calcParams.monthlyRentalYear1,
        (r = this.purchaseFacts) == null ? void 0 : r.purchaseDate,
        (i = this.purchaseFacts) == null ? void 0 : i.purchasePrice,
        (l = (o = this.purchaseFacts) == null ? void 0 : o.loan) == null ? void 0 : l.term,
        (c = (d = this.purchaseFacts) == null ? void 0 : d.loan) == null ? void 0 : c.amount,
        (m = (u = this.purchaseFacts) == null ? void 0 : u.loan) == null ? void 0 : m.interestRate,
        (v = (f = this.purchaseFacts) == null ? void 0 : f.loan) == null ? void 0 : v.date,
        void 0,
        this.calcParams.annualrentalgrowth,
        void 0,
        this.calcParams.propertyValueEoY,
        this.purchaseFacts.firstYearAsRental
      );
      this.purchaseFacts.investmentBasis = (b = e.data.purchaseFacts) == null ? void 0 : b.investmentBasis, this.investmentBasisFound = (this.purchaseFacts.investmentBasis ?? 0) > 0;
    },
    autoPopulateValueEquity(e = !1) {
      var s, n;
      const t = this.isAtPurchase ?? !1 ? (s = this.purchaseFacts) == null ? void 0 : s.purchasePrice : (n = this.purchaseFacts) == null ? void 0 : n.investmentBasis;
      if (!Number.isFinite(t)) {
        Se(new Error("Initial property value is missing or invalid"));
        return;
      }
      if (!Number.isFinite(this.calcParams.propertyValueEoY)) {
        Se(new Error("Current EoY property value is missing or invalid"));
        return;
      }
      this.propertyStore.autoPopulateValueEquity(t, this.firstYearAsRental, this.calcParams.propertyValueEoY, Et, e);
    },
    async autoPopulateIncomeVacancy() {
      (await W.api.calculator.initPurchaseFacts(
        this.property.propId,
        this.calcParams.monthlyRentalYear1,
        this.purchaseFacts.purchaseDate,
        this.purchaseFacts.purchasePrice,
        this.purchaseFacts.loan.term,
        this.purchaseFacts.loan.amount,
        this.purchaseFacts.loan.interestRate,
        this.purchaseFacts.loan.date,
        void 0,
        this.calcParams.annualrentalgrowth,
        void 0,
        this.calcParams.propertyValueEoY,
        this.purchaseFacts.firstYearAsRental
      )).data.purchaseFacts.years.forEach((t) => {
        if (this.firstYearAsRental > t.year) return;
        let s = this.purchaseFacts.years.find((n) => n.year == t.year);
        s || (s = { year: t.year }, this.purchaseFacts.years.push(s)), t.rentalRate && (s.annualRentalIncome = t.rentalRate * 12), s.rentalRate = t.rentalRate, s.vacancyLoss = t.vacancyLoss, s.strRentalRate = t.strRentalRate;
      });
    },
    async autoPopulateOperatingCost() {
      var t, s, n, r, i, o, l, d, c, u;
      (await W.api.calculator.initPurchaseFacts(
        this.property.propId,
        this.calcParams.monthlyRentalYear1,
        (t = this.purchaseFacts) == null ? void 0 : t.purchaseDate,
        (s = this.purchaseFacts) == null ? void 0 : s.purchasePrice,
        (r = (n = this.purchaseFacts) == null ? void 0 : n.loan) == null ? void 0 : r.term,
        (o = (i = this.purchaseFacts) == null ? void 0 : i.loan) == null ? void 0 : o.amount,
        (d = (l = this.purchaseFacts) == null ? void 0 : l.loan) == null ? void 0 : d.interestRate,
        (u = (c = this.purchaseFacts) == null ? void 0 : c.loan) == null ? void 0 : u.date,
        void 0,
        this.calcParams.annualrentalgrowth,
        void 0,
        this.calcParams.propertyValueEoY,
        this.purchaseFacts.firstYearAsRental,
        this.calcParams.propertytax,
        this.calcParams.associationfee
      )).data.purchaseFacts.years.forEach((m) => {
        if (this.firstYearAsRental > m.year) return;
        let f = this.purchaseFacts.years.find((v) => v.year == m.year);
        f || (f = { year: m.year }, this.purchaseFacts.years.push(f)), f.tax = m.tax, this.rentalIncomeCalculationMethod == dA.MonthlyLessVacancy ? (f.capitalExpenditures = m.capitalExpenditures, f.maintenance = m.maintenance, f.management = m.management) : (f.capitalExpenditures = Math.trunc(f.annualRentalIncome * this.calcParams.capitalExpenditures), f.maintenance = Math.trunc(f.annualRentalIncome * this.calcParams.maintenance), (this.calcParams.percentageLongTermFields & U.PropertyManagement) == U.PropertyManagement ? f.management = Math.trunc(f.annualRentalIncome * this.calcParams.managementfee) : f.management = this.calcParams.managementfee), f.insurance = m.insurance, f.associationFees = m.associationFees, f.commission = m.commission, f.utilityExpenses = m.utilityExpenses, f.strCleaningExpenses = m.strCleaningExpenses, f.strConsumableExpenses = m.strConsumableExpenses, f.strFurnishingExpenses = m.strFurnishingExpenses, f.strPlatformServiceFees = m.strPlatformServiceFees, f.strUtilityExpenses = m.strUtilityExpenses;
      });
    },
    viewOperatingCosts() {
      var e;
      (e = bootstrap.Tab.getOrCreateInstance(this.$refs.tabOperatingCosts)) == null || e.show();
    },
    viewPurchaseLoan() {
      var e;
      (e = bootstrap.Tab.getOrCreateInstance(this.$refs.tabCostBasis)) == null || e.show();
    },
    viewValueEquity() {
      var e;
      (e = bootstrap.Tab.getOrCreateInstance(this.$refs.tabValueEquity)) == null || e.show();
    },
    viewLoanDetails() {
      var e;
      (e = bootstrap.Tab.getOrCreateInstance(this.$refs.tabLoanDetails)) == null || e.show();
    },
    viewIncomeVacancy() {
      var e;
      (e = bootstrap.Tab.getOrCreateInstance(this.$refs.tabIncomeVacancy)) == null || e.show();
    },
    tabShow(e) {
      this.currentTab = e.target.dataset.bsTarget;
    },
    resetListing() {
      var e;
      this.$emit("resetListing"), (e = bootstrap.Modal.getOrCreateInstance(this.$refs.modalClearReset)) == null || e.hide();
    },
    isConfirmed(e) {
      return this.propertyStore.isConfirmed(e);
    },
    prevTab() {
      this.currentTab == "#loan-details" ? this.viewPurchaseLoan() : this.currentTab == "#value-equity" ? this.viewLoanDetails() : this.currentTab == "#income-vacancy" ? this.viewValueEquity() : this.currentTab == "#operating-costs" && this.viewIncomeVacancy();
    },
    nextTab() {
      this.currentTab == "#cost-basis" ? this.viewLoanDetails() : this.currentTab == "#loan-details" ? this.viewValueEquity() : this.currentTab == "#value-equity" ? this.viewIncomeVacancy() : this.currentTab == "#income-vacancy" && this.fastForwardAnalysis == !1 && this.viewOperatingCosts();
    },
    popoverInvestment(e) {
      this.$refs.opInvestment.toggle(e);
    },
    popoverPerformance(e) {
      this.$refs.opPerformance.toggle(e);
    },
    autoPopulatePropertyValues() {
      this.cantAutoPopulate || this.autoPopulateValueEquity(!0), this.currentFirstYearAsRental = this.purchaseFacts.firstYearAsRental;
    }
  },
  mounted() {
    this.aclLoaded.then(() => {
      this.$refs.tabCostBasis && this.$refs.tabCostBasis.addEventListener("show.bs.tab", this.tabShow), this.$refs.tabLoanDetails && this.$refs.tabLoanDetails.addEventListener("show.bs.tab", this.tabShow), this.$refs.tabValueEquity && this.$refs.tabValueEquity.addEventListener("show.bs.tab", this.tabShow), this.$refs.tabIncomeVacancy && this.$refs.tabIncomeVacancy.addEventListener("show.bs.tab", this.tabShow), this.$refs.tabOperatingCosts && this.$refs.tabOperatingCosts.addEventListener("show.bs.tab", this.tabShow);
    });
  }
}), O4e = {
  class: "modal fade",
  ref: "modalExistingInvestment",
  id: "modalExistingInvestment",
  tabindex: "-1",
  "aria-labelledby": "modalExistingInvestmentLabel",
  "aria-hidden": "true"
}, R4e = { class: "modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable" }, L4e = { class: "modal-content bg-gradient-alphabet rounded" }, B4e = { class: "bg-white bg-opacity-25 d-none d-lg-block" }, M4e = { class: "row" }, x4e = { class: "col tabs d-flex justify-content-between align-items-end flex-column flex-lg-row" }, F4e = {
  class: "nav nav-tabs ms-lg-3 mx-auto order-2 order-lg-1",
  id: "navigation",
  role: "tablist"
}, V4e = {
  class: "nav-item",
  role: "presentation"
}, D4e = {
  ref: "tabCostBasis",
  class: "nav-link active inv nav-purchase text-reset",
  id: "cost-basis-tab",
  "data-bs-toggle": "tab",
  "data-bs-target": "#cost-basis",
  type: "button",
  role: "tab",
  "aria-controls": "cost-basis",
  "aria-selected": "true"
}, N4e = {
  class: "nav-item",
  role: "presentation"
}, j4e = {
  ref: "tabLoanDetails",
  class: "nav-link inv nav-loan text-reset",
  id: "loan-details-tab",
  "data-bs-toggle": "tab",
  "data-bs-target": "#loan-details",
  type: "button",
  role: "tab",
  "aria-controls": "loan-details",
  "aria-selected": "false"
}, H4e = {
  class: "nav-item",
  role: "presentation"
}, U4e = {
  ref: "tabValueEquity",
  class: "nav-link inv nav-equity text-reset",
  id: "value-equity-tab",
  "data-bs-toggle": "tab",
  "data-bs-target": "#value-equity",
  type: "button",
  role: "tab",
  "aria-controls": "value-equity",
  "aria-selected": "false"
}, z4e = {
  class: "nav-item",
  role: "presentation"
}, W4e = {
  ref: "tabIncomeVacancy",
  class: "nav-link inv nav-vacancy text-reset",
  id: "income-vacancy-tab",
  "data-bs-toggle": "tab",
  "data-bs-target": "#income-vacancy",
  type: "button",
  role: "tab",
  "aria-controls": "income-vacancy",
  "aria-selected": "false"
}, G4e = {
  class: "nav-item",
  role: "presentation"
}, Y4e = { class: "modal-body d-none d-lg-block p-0" }, X4e = {
  key: 0,
  class: "tab-content"
}, q4e = {
  id: "cost-basis",
  class: "tab-pane show active p-4",
  role: "tabpanel",
  "aria-labelledby": "cost-basis-tab",
  tabindex: "0"
}, Q4e = {
  key: 0,
  class: "alert alert-info",
  role: "alert"
}, K4e = {
  key: 1,
  class: "alert alert-warning",
  role: "alert"
}, Z4e = {
  key: 2,
  class: "card bg-alice mb-3"
}, J4e = { class: "card-body" }, $4e = { class: "row g-2" }, _4e = { class: "col-md-1" }, eke = { class: "form-check form-switch form-switch-lg form-switch-basic d-flex" }, tke = { key: 0 }, ske = { class: "card bg-alice mb-3" }, ake = { class: "card-body" }, nke = { class: "row g-2" }, rke = { class: "col-sm-3" }, oke = { class: "col-sm-9 d-flex align-items-center" }, ike = { class: "col-sm-3" }, lke = ["disabled"], dke = ["value"], cke = {
  key: 0,
  class: "col-sm-12 text-end p-0 m-0"
}, uke = { class: "col-sm-9 d-flex align-items-center" }, pke = { class: "col-sm-3" }, hke = {
  key: 0,
  class: "form-control-plaintext text-end fw-bold"
}, mke = ["value"], fke = {
  key: 0,
  class: "alert alert-warning mb-0",
  role: "alert"
}, gke = {
  key: 0,
  class: "alert alert-info",
  role: "alert"
}, vke = {
  key: 1,
  class: "alert alert-info d-flex",
  role: "alert"
}, yke = { class: "list-unstyled mb-0" }, bke = {
  key: 0,
  class: "row g-3 mb-3"
}, Ake = { class: "col-md-6 col-lg-3 mb-3 mb-lg-0" }, wke = { class: "col-md-6 col-lg-3 mb-3 mb-lg-0" }, Cke = {
  key: 1,
  class: "row g-3 mb-3"
}, Ske = { class: "col-form-label col-md-6 col-lg-3 offset-lg-6" }, Pke = { class: "col-md-6 col-lg-3" }, kke = {
  key: 1,
  class: "row g-3 mb-3"
}, Eke = { class: "col-md-6 col-lg-3" }, Ike = { class: "card bg-white bg-opacity-50 mb-3" }, Tke = { class: "card-body" }, Oke = { class: "row g-3" }, Rke = { class: "col-md-6 col-lg-3" }, Lke = { class: "row g-3 mb-3" }, Bke = { class: "col-md-6 col-lg-3 text-end" }, Mke = { class: "form-control-plaintext fw-bold" }, xke = {
  key: 0,
  class: "bg-info-subtle rounded p-3"
}, Fke = { class: "row g-3" }, Vke = { class: "col-sm-2 d-flex justify-content-end" }, Dke = { class: "form-check form-switch form-switch-lg form-switch-basic d-flex" }, Nke = {
  key: 0,
  class: "row g-3"
}, jke = { class: "col-md-4 col-lg-3" }, Hke = {
  id: "loan-details",
  class: "tab-pane",
  role: "tabpanel",
  "aria-labelledby": "loan-details-tab",
  tabindex: "0"
}, Uke = {
  key: 0,
  class: "p-4 pb-0"
}, zke = {
  key: 1,
  class: "p-4 pb-0"
}, Wke = {
  class: "alert alert-warning",
  role: "alert"
}, Gke = { class: "p-4" }, Yke = { class: "card bg-white bg-opacity-50" }, Xke = { class: "card-body" }, qke = { class: "row g-3" }, Qke = { class: "col-form-label col-md-6" }, Kke = { class: "col-md-6 col-lg-3" }, Zke = { class: "form-check form-switch form-switch-lg form-switch-basic ms-5" }, Jke = ["disabled"], $ke = { class: "row g-3" }, _ke = { class: "col-md-6 col-lg-3 mb-3 mb-lg-0" }, e5e = { class: "col-md-6 col-lg-3" }, t5e = { class: "col-md-6 col-lg-3 mb-3 mb-lg-0" }, s5e = ["disabled"], a5e = ["value"], n5e = { class: "col-md-6 col-lg-3" }, r5e = { class: "col-md-6 col-lg-3" }, o5e = { class: "col-md-6 col-lg-3" }, i5e = { class: "form-control-plaintext text-end fw-bold" }, l5e = {
  key: 1,
  class: "card-body border-top"
}, d5e = { class: "row g-3" }, c5e = { class: "col-md-6 col-lg-9" }, u5e = { class: "form-check form-switch form-switch-lg form-switch-basic ms-5" }, p5e = ["disabled"], h5e = { class: "col-md-6 col-lg-3" }, m5e = { class: "col-md-6 col-lg-2 text-end" }, f5e = { class: "form-control-plaintext fw-bold" }, g5e = {
  key: 0,
  class: "card bg-light mt-3"
}, v5e = { class: "card-body" }, y5e = { class: "row g-3" }, b5e = { class: "col-md-6 col-lg-3" }, A5e = { class: "form-check form-switch form-switch-lg form-switch-basic ms-5" }, w5e = ["disabled"], C5e = { class: "row g-3" }, S5e = { class: "col-md-6 col-lg-3 mb-3 mb-lg-0" }, P5e = { class: "col-md-6 col-lg-3" }, k5e = { class: "col-md-6 col-lg-3 mb-3 mb-lg-0" }, E5e = ["disabled"], I5e = ["value"], T5e = { class: "col-md-6 col-lg-3" }, O5e = { class: "col-md-6 col-lg-3" }, R5e = { class: "col-md-6 col-lg-3" }, L5e = { class: "form-control-plaintext text-end fw-bold" }, B5e = {
  id: "value-equity",
  class: "tab-pane",
  role: "tabpanel",
  "aria-labelledby": "value-equity-tab",
  tabindex: "0"
}, M5e = {
  key: 0,
  class: "p-4 pb-0"
}, x5e = {
  key: 1,
  class: "p-4 pb-0"
}, F5e = {
  class: "alert alert-warning",
  role: "alert"
}, V5e = { class: "p-4" }, D5e = { class: "card bg-white bg-opacity-50" }, N5e = { class: "card-body" }, j5e = { class: "row g-3" }, H5e = { class: "col-form-label col-md-6 col-lg-3" }, U5e = { class: "col-md-6 col-lg-3" }, z5e = { class: "col-md-6 col-lg-3" }, W5e = {
  key: 0,
  class: "alert alert-info mb-0 mt-3",
  role: "alert"
}, G5e = { class: "modal-body p-0 mb-3" }, Y5e = { class: "table-scrollable" }, X5e = {
  key: 0,
  class: "table table-borderless table-striped"
}, q5e = { class: "text-center" }, Q5e = { class: "column sticky-top" }, K5e = ["disabled"], Z5e = { class: "column sticky-top" }, J5e = { key: 1 }, $5e = { class: "text-end" }, _5e = { key: 1 }, eEe = { class: "form-control-plaintext text-end" }, tEe = { class: "text-end" }, sEe = { class: "form-control-plaintext text-end" }, aEe = { key: 1 }, nEe = { class: "form-control-plaintext text-end" }, rEe = { class: "text-end" }, oEe = { class: "form-control-plaintext text-end" }, iEe = { key: 1 }, lEe = { class: "form-control-plaintext text-end" }, dEe = { class: "text-end" }, cEe = { class: "form-control-plaintext text-end" }, uEe = { key: 1 }, pEe = { class: "form-control-plaintext text-end" }, hEe = {
  id: "income-vacancy",
  class: "tab-pane",
  role: "tabpanel",
  "aria-labelledby": "income-vacancy-tab",
  tabindex: "0"
}, mEe = {
  key: 0,
  class: "p-4 pb-0"
}, fEe = {
  key: 1,
  class: "p-4 pb-0"
}, gEe = {
  class: "alert alert-warning",
  role: "alert"
}, vEe = { class: "p-4" }, yEe = {
  key: 0,
  class: "card bg-alice mb-3"
}, bEe = { class: "card-body d-flex align-items-center justify-content-center" }, AEe = { class: "ms-5 d-flex gap-3 check-group" }, wEe = ["disabled"], CEe = ["disabled"], SEe = { class: "card bg-light" }, PEe = { class: "card-body" }, kEe = { class: "row g-3" }, EEe = { class: "col-md-6 col-lg-3" }, IEe = { class: "col-md-6 col-lg-3" }, TEe = {
  key: 1,
  class: "alert alert-info mb-0 mt-3",
  role: "alert"
}, OEe = { class: "modal-body p-0" }, REe = { class: "table-scrollable" }, LEe = {
  key: 0,
  class: "table table-borderless table-striped"
}, BEe = { class: "text-center" }, MEe = { class: "column sticky-top" }, xEe = ["disabled"], FEe = { class: "column sticky-top" }, VEe = { key: 0 }, DEe = { class: "text-end" }, NEe = { class: "form-control-plaintext" }, jEe = { key: 1 }, HEe = { key: 2 }, UEe = { class: "text-end" }, zEe = { class: "form-control-plaintext" }, WEe = { class: "text-end" }, GEe = { class: "form-control-plaintext" }, YEe = ["data-year"], XEe = { class: "text-end" }, qEe = {
  class: "tab-pane",
  id: "operating-costs",
  role: "tabpanel",
  "aria-labelledby": "operating-costs-tab",
  tabindex: "0"
}, QEe = {
  key: 0,
  class: "p-4 pb-0"
}, KEe = {
  key: 1,
  class: "p-4 pb-0"
}, ZEe = {
  class: "alert alert-warning",
  role: "alert"
}, JEe = {
  key: 2,
  class: "p-4"
}, $Ee = { class: "modal-body px-0" }, _Ee = { class: "table-scrollable" }, eIe = {
  key: 0,
  class: "table table-borderless table-striped"
}, tIe = { class: "text-center" }, sIe = { class: "column sticky-top" }, aIe = ["disabled"], nIe = { class: "column sticky-top" }, rIe = { key: 0 }, oIe = { key: 1 }, iIe = { key: 2 }, lIe = { key: 3 }, dIe = { key: 4 }, cIe = { key: 5 }, uIe = { key: 6 }, pIe = { key: 7 }, hIe = { key: 8 }, mIe = { key: 9 }, fIe = { class: "modal-footer align-items-center d-none d-lg-flex border-0 pt-0" }, gIe = {
  key: 0,
  type: "button",
  class: "btn btn-outline-danger me-auto",
  "data-bs-toggle": "modal",
  "data-bs-target": "#modalClearReset"
}, vIe = ["disabled"], yIe = ["disabled"], bIe = {
  class: "modal fade",
  ref: "modalClearReset",
  id: "modalClearReset",
  tabindex: "-1",
  "aria-labelledby": "modalmodalClearResetLabel",
  "aria-hidden": "true"
}, AIe = { class: "modal-dialog modal-dialog-centered" }, wIe = { class: "modal-content bg-gradient-alphabet rounded" }, CIe = { class: "modal-body text-center px-5 pb-5 pt-0 d-flex flex-column align-items-center justify-content-center" };
function SIe(e, t, s, n, r, i) {
  var c, u, m, f, v, b, w, S, I, T, x, k, C, O;
  const o = pe("date-input"), l = pe("OverlayPanel"), d = pe("numerical-input");
  return p(), h(A, null, [
    a("div", O4e, [
      a("div", R4e, [
        a("div", L4e, [
          t[140] || (t[140] = a("div", { class: "modal-header border-0 bg-white bg-opacity-25" }, [
            a("p", {
              class: "fs-5 modal-title fw-bold",
              id: "modalExistingInvestmentLabel"
            }, "Financial History"),
            a("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            })
          ], -1)),
          t[141] || (t[141] = a("div", { class: "d-lg-none p-4" }, [
            a("div", {
              class: "alert alert-info text-center p-4",
              role: "alert"
            }, [
              a("i", { class: "fa-light fa-circle-info fa-2x mb-3" }),
              a("br"),
              y(" Please edit "),
              a("b", null, "Financial History"),
              y(" on Desktop for "),
              a("b", null, "better experience"),
              y(". ")
            ])
          ], -1)),
          a("div", B4e, [
            a("div", M4e, [
              a("div", x4e, [
                a("ul", F4e, [
                  a("li", V4e, [
                    a("button", D4e, t[42] || (t[42] = [
                      a("i", { class: "fa-light fa-list-ul d-none d-md-inline-block me-2" }, null, -1),
                      a("span", null, "Cost Basis", -1)
                    ]), 512)
                  ]),
                  a("li", N4e, [
                    a("button", j4e, t[43] || (t[43] = [
                      a("i", { class: "fa-light fa-list-ul d-none d-md-inline-block me-2" }, null, -1),
                      a("span", null, "Loan Details", -1)
                    ]), 512)
                  ]),
                  a("li", H4e, [
                    a("button", U4e, t[44] || (t[44] = [
                      a("i", { class: "fa-light fa-stars icon-tab d-none d-md-inline-block me-2" }, null, -1),
                      a("span", null, "Value & Equity", -1)
                    ]), 512)
                  ]),
                  V(a("li", z4e, [
                    a("button", W4e, t[45] || (t[45] = [
                      a("i", { class: "fa-light fa-coins icon-tab d-none d-md-inline-block me-2" }, null, -1),
                      a("span", null, "Income & Vacancy", -1)
                    ]), 512)
                  ], 512), [
                    [Us, !e.isRentVsSell]
                  ]),
                  V(a("li", G4e, [
                    a("button", {
                      ref: "tabOperatingCosts",
                      class: z(["nav-link inv nav-operating text-reset", { disabled: e.cantAutoPopulate }]),
                      id: "operating-costs-tab",
                      "data-bs-toggle": "tab",
                      "data-bs-target": "#operating-costs",
                      type: "button",
                      role: "tab",
                      "aria-controls": "operating-costs",
                      "aria-selected": "false"
                    }, t[46] || (t[46] = [
                      a("i", { class: "fa-light fa-lightbulb-dollar icon-tab d-none d-md-inline-block me-2" }, null, -1),
                      a("span", null, "Operating Costs", -1)
                    ]), 2)
                  ], 512), [
                    [Us, !e.fastForwardAnalysis && ((c = e.purchaseFacts) == null ? void 0 : c.firstYearToAnalyze) != e.currentYear]
                  ])
                ])
              ])
            ])
          ]),
          a("div", Y4e, [
            e.purchaseFacts ? (p(), h("div", X4e, [
              a("div", q4e, [
                e.requireCalculateAndSave ? (p(), h("div", Q4e, t[47] || (t[47] = [
                  a("div", null, [
                    a("i", { class: "fa-light fa-lightbulb-exclamation-on me-2" }),
                    y("Please review each tab to validate we have accurate information for your property. When complete, click 'Calculate & Save' on the final tab.")
                  ], -1)
                ]))) : P("", !0),
                e.alertMessage.length > 0 ? (p(), h("div", K4e, [
                  (p(!0), h(A, null, D(e.alertMessage, (E) => (p(), h("div", null, [
                    t[48] || (t[48] = a("i", { class: "fa-light fa-triangle-exclamation me-2" }, null, -1)),
                    y(g(E), 1)
                  ]))), 256))
                ])) : P("", !0),
                e.isRentVsSell ? P("", !0) : (p(), h("div", Z4e, [
                  a("div", J4e, [
                    a("div", $4e, [
                      t[50] || (t[50] = a("label", { class: "col-form-label col-md-11 testing" }, " Has current owner placed home in-service as rental? ", -1)),
                      a("div", _4e, [
                        a("div", eke, [
                          V(a("input", {
                            type: "checkbox",
                            "onUpdate:modelValue": t[0] || (t[0] = (E) => e.dontIgnoreHistoricalOperatingIncome = E),
                            class: "form-check-input",
                            id: "historicalOperatingSwitch"
                          }, null, 512), [
                            [Ue, e.dontIgnoreHistoricalOperatingIncome]
                          ]),
                          t[49] || (t[49] = a("label", {
                            class: "form-check-label",
                            for: "historicalOperatingSwitch"
                          }, [
                            a("span", null, "No"),
                            y("Yes ")
                          ], -1))
                        ])
                      ])
                    ])
                  ])
                ])),
                N(ks, {
                  name: "slide",
                  mode: "out-in"
                }, {
                  default: ve(() => [
                    e.ignoreHistoricalOperatingIncome ? (p(), h("div", kke, [
                      t[65] || (t[65] = a("label", { class: "col-form-label col-md-6 col-lg-3 offset-lg-6" }, " Current Value ", -1)),
                      a("div", Eke, [
                        N(d, {
                          modelValue: e.calcParams.propertyValueEoY,
                          "onUpdate:modelValue": t[10] || (t[10] = (E) => e.calcParams.propertyValueEoY = E),
                          currency: ""
                        }, null, 8, ["modelValue"])
                      ])
                    ])) : (p(), h("div", tke, [
                      a("div", ske, [
                        a("div", ake, [
                          a("div", nke, [
                            t[58] || (t[58] = a("label", {
                              for: "estimated",
                              class: "col-form-label col-sm-9"
                            }, " When did you purchase the property? ", -1)),
                            a("div", rke, [
                              N(o, {
                                modelValue: e.purchaseFacts.purchaseDate,
                                "onUpdate:modelValue": t[1] || (t[1] = (E) => e.purchaseFacts.purchaseDate = E),
                                locked: e.isConfirmed("purchaseDate"),
                                class: "text-end"
                              }, null, 8, ["modelValue", "locked"])
                            ]),
                            a("div", oke, [
                              t[53] || (t[53] = a("label", { class: "form-label mb-0" }, " When did the property become an investment? ", -1)),
                              a("button", {
                                type: "button",
                                class: "btn btn-link p-0 text-eclipse ms-2",
                                onClick: t[2] || (t[2] = (...E) => e.popoverInvestment && e.popoverInvestment(...E)),
                                "aria-haspopup": "true",
                                "aria-controls": "overlay_panel"
                              }, t[51] || (t[51] = [
                                a("i", { class: "fa-light fa-circle-question" }, null, -1)
                              ])),
                              N(l, {
                                ref: "opInvestment",
                                appendTo: "#modalExistingInvestment",
                                class: "w-px-300"
                              }, {
                                default: ve(() => t[52] || (t[52] = [
                                  y(" Enter the year the property first become an investment. This sets the basis for your value and equity calculations and determines the available options for analyzing past and current years. ")
                                ])),
                                _: 1,
                                __: [52]
                              }, 512)
                            ]),
                            a("div", ike, [
                              V(a("select", {
                                "onUpdate:modelValue": t[3] || (t[3] = (E) => e.firstYearAsRental = E),
                                class: "form-select text-end locked",
                                disabled: e.isConfirmed("firstRented")
                              }, [
                                (p(!0), h(A, null, D(e.yearsList, (E) => (p(), h("option", {
                                  value: E,
                                  key: E
                                }, [
                                  e.purchaseYear == E ? (p(), h(A, { key: 0 }, [
                                    y(" At Purchase ")
                                  ], 64)) : (p(), h(A, { key: 1 }, [
                                    y(g(E), 1)
                                  ], 64))
                                ], 8, dke))), 128))
                              ], 8, lke), [
                                [We, e.firstYearAsRental]
                              ])
                            ]),
                            N(ks, {
                              name: "slide",
                              mode: "out-in"
                            }, {
                              default: ve(() => [
                                e.needsAutoCalculate ? (p(), h("div", cke, [
                                  a("button", {
                                    type: "button",
                                    class: "btn btn-link pt-0 pb-0",
                                    style: { "font-size": ".90rem" },
                                    onClick: t[4] || (t[4] = (...E) => e.autoPopulatePropertyValues && e.autoPopulatePropertyValues(...E))
                                  }, " Auto estimate " + g(e.firstYearAsRental) + "'s Initial & Property Values ", 1)
                                ])) : P("", !0)
                              ]),
                              _: 1
                            }),
                            a("div", uke, [
                              t[56] || (t[56] = a("label", { class: "form-label mb-0" }, " When do you want to start analyzing the property's financial performance? ", -1)),
                              a("button", {
                                type: "button",
                                class: "btn btn-link p-0 text-eclipse ms-2",
                                onClick: t[5] || (t[5] = (...E) => e.popoverPerformance && e.popoverPerformance(...E)),
                                "aria-haspopup": "true",
                                "aria-controls": "overlay_panel"
                              }, t[54] || (t[54] = [
                                a("i", { class: "fa-light fa-circle-question" }, null, -1)
                              ])),
                              N(l, {
                                ref: "opPerformance",
                                appendTo: "#modalExistingInvestment",
                                class: "w-px-300"
                              }, {
                                default: ve(() => t[55] || (t[55] = [
                                  y(" Choose the starting year for analysis. We'll analyze past and current performance using Rescover's financial model and your default parameters. Estimates for past year income and expense will be generated, but please enter actual data to enhace accuracy. Rescover's financial model will generate a long-term analysis starting from your selected year, incorporating past data and current assumptions, and extending 30 year from the current year. ")
                                ])),
                                _: 1,
                                __: [55]
                              }, 512)
                            ]),
                            a("div", pke, [
                              N(ks, {
                                name: "slide",
                                mode: "out-in"
                              }, {
                                default: ve(() => [
                                  e.analyzeYearsList.length == 1 ? (p(), h("div", hke, [
                                    e.purchaseYear == e.firstYearAsRental ? (p(), h(A, { key: 0 }, [
                                      y(" At Purchase ")
                                    ], 64)) : (p(), h(A, { key: 1 }, [
                                      y(g(e.purchaseFacts.firstYearAsRental), 1)
                                    ], 64))
                                  ])) : V((p(), h("select", {
                                    key: 1,
                                    "onUpdate:modelValue": t[6] || (t[6] = (E) => e.purchaseFacts.firstYearToAnalyze = E),
                                    class: "form-select text-end locked"
                                  }, [
                                    (p(!0), h(A, null, D(e.analyzeYearsList, (E) => (p(), h("option", {
                                      value: E,
                                      key: E
                                    }, [
                                      e.purchaseYear == E ? (p(), h(A, { key: 0 }, [
                                        y(" At Purchase ")
                                      ], 64)) : (p(), h(A, { key: 1 }, [
                                        y(g(E), 1)
                                      ], 64))
                                    ], 8, mke))), 128))
                                  ], 512)), [
                                    [We, e.purchaseFacts.firstYearToAnalyze]
                                  ])
                                ]),
                                _: 1
                              })
                            ]),
                            N(ks, {
                              name: "slide",
                              mode: "out-in"
                            }, {
                              default: ve(() => [
                                e.purchaseFacts.firstYearToAnalyze != e.firstYearAsRental ? (p(), h("div", fke, t[57] || (t[57] = [
                                  a("i", { class: "fa-light fa-lightbulb-exclamation-on me-2" }, null, -1),
                                  y("It won't be possible to calculate IRR if the purchase year is different from the first year to analyze. ")
                                ]))) : P("", !0)
                              ]),
                              _: 1
                            })
                          ])
                        ])
                      ]),
                      N(ks, {
                        name: "slide",
                        mode: "out-in"
                      }, {
                        default: ve(() => [
                          e.purchaseFacts.firstYearToAnalyze == e.currentYear ? (p(), h("div", gke, t[59] || (t[59] = [
                            a("i", { class: "fa-light fa-lightbulb-exclamation-on me-2" }, null, -1),
                            y("We'll estimate this year's performance using Rescover's financial model. You can adjust the financial details on the Parameters tab. ")
                          ]))) : (p(), h("div", vke, [
                            t[62] || (t[62] = a("i", { class: "fa-light fa-lightbulb-exclamation-on me-2 mt-1" }, null, -1)),
                            a("ul", yke, [
                              a("li", null, [
                                y(" For " + g(e.firstAnalyzedYear) + " ", 1),
                                e.firstAnalyzedYear != e.currentYear - 1 ? (p(), h(A, { key: 0 }, [
                                  y(" -" + g(e.currentYear - 1), 1)
                                ], 64)) : P("", !0),
                                t[60] || (t[60] = y(", we'll estimate income and expenses based on your parameters, but for the most accurate analysis, please enter the actual data.")),
                                t[61] || (t[61] = a("br", null, null, -1))
                              ]),
                              a("li", null, " For " + g(e.currentYear) + ", there is no need to enter data for partial months, but please provide the current rental rate. ", 1)
                            ])
                          ]))
                        ]),
                        _: 1
                      }),
                      N(ks, {
                        name: "slide",
                        mode: "out-in"
                      }, {
                        default: ve(() => [
                          e.askLoanFeesAndCosts && !e.ignoreHistoricalOperatingIncome && !e.isRentVsSell ? (p(), h("div", bke, [
                            t[63] || (t[63] = a("label", {
                              for: "estimated",
                              class: "col-form-label col-md-6 col-lg-3 offset-lg-6"
                            }, "Purchase Price", -1)),
                            a("div", Ake, [
                              N(d, {
                                modelValue: e.purchaseFacts.purchasePrice,
                                "onUpdate:modelValue": t[7] || (t[7] = (E) => e.purchaseFacts.purchasePrice = E),
                                currency: "",
                                locked: e.isConfirmed("purchasePrice")
                              }, null, 8, ["modelValue", "locked"])
                            ]),
                            t[64] || (t[64] = a("label", {
                              for: "estimated",
                              class: "col-form-label col-md-6 col-lg-3 offset-lg-6"
                            }, "Acquisition Closing Costs", -1)),
                            a("div", wke, [
                              N(d, {
                                modelValue: e.purchaseFacts.titleCharges,
                                "onUpdate:modelValue": t[8] || (t[8] = (E) => e.purchaseFacts.titleCharges = E),
                                currency: ""
                              }, null, 8, ["modelValue"])
                            ])
                          ])) : !e.askLoanFeesAndCosts && !e.isRentVsSell ? (p(), h("div", Cke, [
                            a("label", Ske, g(e.firstYearAsRental) + " Initial Value ", 1),
                            a("div", Pke, [
                              N(d, {
                                modelValue: e.purchaseFacts.investmentBasis,
                                "onUpdate:modelValue": t[9] || (t[9] = (E) => e.purchaseFacts.investmentBasis = E),
                                currency: ""
                              }, null, 8, ["modelValue"])
                            ])
                          ])) : P("", !0)
                        ]),
                        _: 1
                      })
                    ]))
                  ]),
                  _: 1
                }),
                a("div", Ike, [
                  a("div", Tke, [
                    a("p", null, [
                      e.isRentVsSell || e.ignoreHistoricalOperatingIncome ? (p(), h(A, { key: 0 }, [
                        y(" Will the property require any renovations? ")
                      ], 64)) : (p(), h(A, { key: 1 }, [
                        y(" Did the owner perform any renovations when the property was first rented out? ")
                      ], 64))
                    ]),
                    a("div", Oke, [
                      t[66] || (t[66] = a("label", {
                        for: "estimated",
                        class: "col-form-label col-md-6 col-lg-3 offset-lg-6"
                      }, "Renovation Cost", -1)),
                      a("div", Rke, [
                        N(d, {
                          modelValue: e.calcParams.rehabamount,
                          "onUpdate:modelValue": t[11] || (t[11] = (E) => e.calcParams.rehabamount = E),
                          currency: "",
                          locked: e.isConfirmed("rehab")
                        }, null, 8, ["modelValue", "locked"])
                      ])
                    ])
                  ])
                ]),
                a("div", Lke, [
                  t[67] || (t[67] = a("label", { class: "col-form-label col-md-6 col-lg-3 offset-lg-6" }, " Cost Basis ", -1)),
                  a("div", Bke, [
                    a("div", Mke, g(e.currency(e.costBasis)), 1)
                  ])
                ]),
                N(ks, {
                  name: "slide",
                  mode: "out-in"
                }, {
                  default: ve(() => [
                    e.ignoreHistoricalOperatingIncome ? (p(), h("div", xke, [
                      a("div", Fke, [
                        t[70] || (t[70] = a("label", { class: "col-form-label col-md-6 col-lg-10" }, [
                          a("i", { class: "fa-light fa-lightbulb-exclamation-on me-2" }),
                          y("If you were going to sell the property, would the repair allowance be different than the cost mentioned above?")
                        ], -1)),
                        a("div", Vke, [
                          a("div", Dke, [
                            V(a("input", {
                              type: "checkbox",
                              class: "form-check-input",
                              "onUpdate:modelValue": t[12] || (t[12] = (E) => e.calcParams.rehabAmountSameAsRenting = E)
                            }, null, 512), [
                              [Ue, e.calcParams.rehabAmountSameAsRenting]
                            ]),
                            t[68] || (t[68] = a("label", {
                              class: "form-check-label",
                              for: ""
                            }, [
                              a("span", null, "No"),
                              y("Yes ")
                            ], -1))
                          ])
                        ]),
                        N(ks, {
                          name: "slide",
                          mode: "out-in"
                        }, {
                          default: ve(() => [
                            e.calcParams.rehabAmountSameAsRenting ? (p(), h("div", Nke, [
                              t[69] || (t[69] = a("label", { class: "col-form-label col-md-6 col-lg-9 text-end" }, "What will the renovations to prepare the property for sale cost?", -1)),
                              a("div", jke, [
                                N(d, {
                                  currency: "",
                                  modelValue: e.calcParams.rehabAmountForSelling,
                                  "onUpdate:modelValue": t[13] || (t[13] = (E) => e.calcParams.rehabAmountForSelling = E)
                                }, null, 8, ["modelValue"])
                              ])
                            ])) : P("", !0)
                          ]),
                          _: 1
                        })
                      ])
                    ])) : P("", !0)
                  ]),
                  _: 1
                })
              ]),
              a("div", Hke, [
                e.requireCalculateAndSave ? (p(), h("div", Uke, t[71] || (t[71] = [
                  a("div", {
                    class: "alert alert-info mb-0",
                    role: "alert"
                  }, [
                    a("i", { class: "fa-light fa-lightbulb-exclamation-on me-1" }),
                    y("Please review each tab to validate we have accurate information for your property. When complete, click 'Calculate & Save' on the final tab. ")
                  ], -1)
                ]))) : P("", !0),
                e.alertMessage.length > 0 ? (p(), h("div", zke, [
                  a("div", Wke, [
                    (p(!0), h(A, null, D(e.alertMessage, (E) => (p(), h("div", null, [
                      t[72] || (t[72] = a("i", { class: "fa-light fa-triangle-exclamation me-2" }, null, -1)),
                      y(g(E), 1)
                    ]))), 256))
                  ])
                ])) : P("", !0),
                a("div", Gke, [
                  a("div", Yke, [
                    a("div", Xke, [
                      a("div", qke, [
                        a("label", Qke, [
                          e.isRentVsSell || e.ignoreHistoricalOperatingIncome ? (p(), h(A, { key: 0 }, [
                            y(" Is there a mortgage on the property? ")
                          ], 64)) : (p(), h(A, { key: 1 }, [
                            y(" Has there been a loan on the property during its time as a rental? ")
                          ], 64))
                        ]),
                        a("div", Kke, [
                          a("div", Zke, [
                            V(a("input", {
                              type: "checkbox",
                              name: "hasCurrentLoan",
                              "onUpdate:modelValue": t[14] || (t[14] = (E) => e.hasCurrentLoan = E),
                              class: "form-check-input",
                              id: "hasCurrentLoan",
                              disabled: e.isConfirmed("loanInfo")
                            }, null, 8, Jke), [
                              [Ue, e.hasCurrentLoan]
                            ]),
                            t[73] || (t[73] = a("label", {
                              class: "form-check-label",
                              for: "hasCurrentLoan"
                            }, [
                              a("span", null, "No"),
                              y("Yes ")
                            ], -1))
                          ])
                        ])
                      ])
                    ]),
                    e.hasCurrentLoan && ((u = e.purchaseFacts) != null && u.loan) ? (p(), h("div", {
                      key: 0,
                      class: z(["card-body", e.hasCurrentLoanStyle])
                    }, [
                      a("div", $ke, [
                        t[75] || (t[75] = a("label", {
                          for: "estimated",
                          class: "col-form-label col-md-6 col-lg-3"
                        }, "Loan Amount", -1)),
                        a("div", _ke, [
                          N(d, {
                            modelValue: e.purchaseFacts.loan.amount,
                            "onUpdate:modelValue": t[15] || (t[15] = (E) => e.purchaseFacts.loan.amount = E),
                            currency: "",
                            locked: e.isConfirmed("loanInfo")
                          }, null, 8, ["modelValue", "locked"])
                        ]),
                        t[76] || (t[76] = a("label", {
                          for: "estimated",
                          class: "col-form-label col-md-6 col-lg-3"
                        }, "Loan Date", -1)),
                        a("div", e5e, [
                          N(o, {
                            modelValue: e.purchaseFacts.loan.date,
                            "onUpdate:modelValue": t[16] || (t[16] = (E) => e.purchaseFacts.loan.date = E),
                            locked: e.isConfirmed("loanInfo"),
                            class: "text-end"
                          }, null, 8, ["modelValue", "locked"])
                        ]),
                        t[77] || (t[77] = a("label", {
                          for: "estimated",
                          class: "col-form-label col-md-6 col-lg-3"
                        }, "Amortization Years", -1)),
                        a("div", t5e, [
                          V(a("select", {
                            "onUpdate:modelValue": t[17] || (t[17] = (E) => e.purchaseFacts.loan.term = E),
                            class: "form-select text-end locked",
                            disabled: e.isConfirmed("loanInfo")
                          }, [
                            (p(), h(A, null, D(50, (E) => a("option", { value: E }, g(E), 9, a5e)), 64))
                          ], 8, s5e), [
                            [We, e.purchaseFacts.loan.term]
                          ])
                        ]),
                        t[78] || (t[78] = a("label", {
                          for: "estimated",
                          class: "col-form-label col-md-6 col-lg-3"
                        }, "Interest Rate %", -1)),
                        a("div", n5e, [
                          N(d, {
                            modelValue: e.purchaseFacts.loan.interestRate,
                            "onUpdate:modelValue": t[18] || (t[18] = (E) => e.purchaseFacts.loan.interestRate = E),
                            percent: "",
                            locked: e.isConfirmed("loanInfo")
                          }, null, 8, ["modelValue", "locked"])
                        ]),
                        e.askLoanFeesAndCosts && !e.ignoreHistoricalOperatingIncome && !e.isRentVsSell ? (p(), h(A, { key: 0 }, [
                          t[74] || (t[74] = a("label", {
                            for: "estimated",
                            class: "col-form-label col-md-6 col-lg-3"
                          }, "Loan Fees", -1)),
                          a("div", r5e, [
                            N(d, {
                              modelValue: e.purchaseFacts.loan.closingCosts,
                              "onUpdate:modelValue": t[19] || (t[19] = (E) => e.purchaseFacts.loan.closingCosts = E),
                              currency: "",
                              locked: e.isConfirmed("loanInfo")
                            }, null, 8, ["modelValue", "locked"])
                          ])
                        ], 64)) : P("", !0),
                        t[79] || (t[79] = a("label", { class: "col-form-label col-md-6 col-lg-3" }, "Loan Payment", -1)),
                        a("div", o5e, [
                          a("div", i5e, g(e.currency(e.loanPayment)), 1)
                        ])
                      ])
                    ], 2)) : P("", !0),
                    !e.isRentVsSell && !e.ignoreHistoricalOperatingIncome ? (p(), h("div", l5e, [
                      a("div", d5e, [
                        t[83] || (t[83] = a("label", { class: "col-md-6 col-lg-3 col-form-label" }, "Is the loan paid off?", -1)),
                        a("div", c5e, [
                          a("div", u5e, [
                            V(a("input", {
                              type: "checkbox",
                              "onUpdate:modelValue": t[20] || (t[20] = (E) => e.isLoanPaidOff = E),
                              name: "paidOff",
                              class: "form-check-input",
                              id: "paidOff",
                              disabled: e.isConfirmed("loanPaidOffInfo")
                            }, null, 8, p5e), [
                              [Ue, e.isLoanPaidOff]
                            ]),
                            t[80] || (t[80] = a("label", {
                              class: "form-check-label",
                              for: "paidOff"
                            }, [
                              a("span", null, "No"),
                              y("Yes ")
                            ], -1))
                          ])
                        ]),
                        e.isLoanPaidOff ? (p(), h(A, { key: 0 }, [
                          t[81] || (t[81] = a("label", { class: "col-md-6 col-lg-3 col-form-label" }, "Month/Year Paid Off", -1)),
                          a("div", h5e, [
                            N(o, {
                              modelValue: e.purchaseFacts.loan.datePaidOff,
                              "onUpdate:modelValue": t[21] || (t[21] = (E) => e.purchaseFacts.loan.datePaidOff = E),
                              locked: e.isConfirmed("loanPaidOffInfo"),
                              class: "text-end"
                            }, null, 8, ["modelValue", "locked"])
                          ]),
                          t[82] || (t[82] = a("label", { class: "col-md-6 col-lg-4 col-form-label" }, "Balance/Additional Investment at Pay Off", -1)),
                          a("div", m5e, [
                            a("span", f5e, g(e.currency(e.balancePaidOff)), 1)
                          ])
                        ], 64)) : P("", !0)
                      ])
                    ])) : P("", !0)
                  ]),
                  e.askIfPreviousLoan && !e.isRentVsSell ? (p(), h("div", g5e, [
                    a("div", v5e, [
                      a("div", y5e, [
                        t[85] || (t[85] = a("label", { class: "col-form-label col-md-6" }, " Was there a previous loan on the property during its time as a rental? ", -1)),
                        a("div", b5e, [
                          a("div", A5e, [
                            V(a("input", {
                              type: "checkbox",
                              name: "hasPreviousLoan",
                              "onUpdate:modelValue": t[22] || (t[22] = (E) => e.purchaseFacts.hasPreviousLoan = E),
                              class: "form-check-input",
                              id: "hasPreviousLoan",
                              disabled: e.isConfirmed("previousLoanInfo")
                            }, null, 8, w5e), [
                              [Ue, e.purchaseFacts.hasPreviousLoan]
                            ]),
                            t[84] || (t[84] = a("label", {
                              class: "form-check-label",
                              for: "hasPreviousLoan"
                            }, [
                              a("span", null, "No"),
                              y("Yes ")
                            ], -1))
                          ])
                        ])
                      ])
                    ]),
                    e.askIfPreviousLoan && e.hasPreviousLoan ? (p(), h("div", {
                      key: 0,
                      class: z(["card-body", e.hasCurrentLoanStyle])
                    }, [
                      a("div", C5e, [
                        t[86] || (t[86] = a("label", {
                          for: "estimated",
                          class: "col-form-label col-md-6 col-lg-3"
                        }, "Loan Amount", -1)),
                        a("div", S5e, [
                          N(d, {
                            modelValue: e.purchaseFacts.previousLoan.amount,
                            "onUpdate:modelValue": t[23] || (t[23] = (E) => e.purchaseFacts.previousLoan.amount = E),
                            currency: "",
                            locked: e.isConfirmed("previousLoanInfo")
                          }, null, 8, ["modelValue", "locked"])
                        ]),
                        t[87] || (t[87] = a("label", {
                          for: "estimated",
                          class: "col-form-label col-md-6 col-lg-3"
                        }, "Loan Date", -1)),
                        a("div", P5e, [
                          N(o, {
                            modelValue: e.purchaseFacts.previousLoan.date,
                            "onUpdate:modelValue": t[24] || (t[24] = (E) => e.purchaseFacts.previousLoan.date = E),
                            disabled: e.isConfirmed("previousLoanInfo"),
                            class: "text-end"
                          }, null, 8, ["modelValue", "disabled"])
                        ]),
                        t[88] || (t[88] = a("label", {
                          for: "estimated",
                          class: "col-form-label col-md-6 col-lg-3"
                        }, "Amortization Years", -1)),
                        a("div", k5e, [
                          V(a("select", {
                            "onUpdate:modelValue": t[25] || (t[25] = (E) => e.purchaseFacts.previousLoan.term = E),
                            class: "form-select text-end locked",
                            disabled: e.isConfirmed("previousLoanInfo")
                          }, [
                            (p(), h(A, null, D(50, (E) => a("option", { value: E }, g(E), 9, I5e)), 64))
                          ], 8, E5e), [
                            [We, e.purchaseFacts.previousLoan.term]
                          ])
                        ]),
                        t[89] || (t[89] = a("label", {
                          for: "estimated",
                          class: "col-form-label col-md-6 col-lg-3"
                        }, "Interest Rate %", -1)),
                        a("div", T5e, [
                          N(d, {
                            modelValue: e.purchaseFacts.previousLoan.interestRate,
                            "onUpdate:modelValue": t[26] || (t[26] = (E) => e.purchaseFacts.previousLoan.interestRate = E),
                            percent: "",
                            locked: e.isConfirmed("previousLoanInfo")
                          }, null, 8, ["modelValue", "locked"])
                        ]),
                        t[90] || (t[90] = a("label", {
                          for: "estimated",
                          class: "col-form-label col-md-6 col-lg-3"
                        }, "Loan Fees", -1)),
                        a("div", O5e, [
                          N(d, {
                            modelValue: e.purchaseFacts.previousLoan.closingCosts,
                            "onUpdate:modelValue": t[27] || (t[27] = (E) => e.purchaseFacts.previousLoan.closingCosts = E),
                            currency: "",
                            locked: e.isConfirmed("previousLoanInfo")
                          }, null, 8, ["modelValue", "locked"])
                        ]),
                        t[91] || (t[91] = a("label", { class: "col-form-label col-md-6 col-lg-3" }, "Loan Payment", -1)),
                        a("div", R5e, [
                          a("div", L5e, g(e.currency(e.previousLoanPayment)), 1)
                        ])
                      ])
                    ], 2)) : P("", !0)
                  ])) : P("", !0)
                ])
              ]),
              a("div", B5e, [
                e.requireCalculateAndSave ? (p(), h("div", M5e, t[92] || (t[92] = [
                  a("div", {
                    class: "alert alert-info mb-0",
                    role: "alert"
                  }, [
                    a("i", { class: "fa-light fa-lightbulb-exclamation-on me-1" }),
                    y("Please review each tab to validate we have accurate information for your property. When complete, click 'Calculate & Save' on the final tab. ")
                  ], -1)
                ]))) : P("", !0),
                e.alertMessage.length > 0 ? (p(), h("div", x5e, [
                  a("div", F5e, [
                    (p(!0), h(A, null, D(e.alertMessage, (E) => (p(), h("div", null, [
                      t[93] || (t[93] = a("i", { class: "fa-light fa-triangle-exclamation me-2" }, null, -1)),
                      y(g(E), 1)
                    ]))), 256))
                  ])
                ])) : P("", !0),
                a("div", V5e, [
                  a("div", D5e, [
                    a("div", N5e, [
                      a("div", j5e, [
                        !e.isRentVsSell && !e.isCurrentYear ? (p(), h(A, { key: 0 }, [
                          a("label", H5e, g(e.firstYearAsRental) + " Initial Value ", 1),
                          a("div", U5e, [
                            N(d, {
                              modelValue: e.purchaseFacts.investmentBasis,
                              "onUpdate:modelValue": t[28] || (t[28] = (E) => e.purchaseFacts.investmentBasis = E),
                              currency: ""
                            }, null, 8, ["modelValue"])
                          ])
                        ], 64)) : P("", !0),
                        t[94] || (t[94] = a("label", { class: "col-form-label col-md-6 col-lg-3" }, " Current Value ", -1)),
                        a("div", z5e, [
                          N(d, {
                            modelValue: e.calcParams.propertyValueEoY,
                            "onUpdate:modelValue": t[29] || (t[29] = (E) => e.calcParams.propertyValueEoY = E),
                            currency: ""
                          }, null, 8, ["modelValue"])
                        ])
                      ])
                    ])
                  ]),
                  ((f = (m = e.purchaseFacts) == null ? void 0 : m.years) == null ? void 0 : f.length) == 0 ? (p(), h("div", W5e, t[95] || (t[95] = [
                    a("i", { class: "fa-light fa-circle-info me-2" }, null, -1),
                    y(" Only complete calendar years may be entered. ")
                  ]))) : P("", !0)
                ]),
                a("div", G5e, [
                  a("div", Y5e, [
                    e.isRentVsSell || e.isCurrentYear || ((v = e.purchaseFactsYears) == null ? void 0 : v.length) > 0 ? (p(), h("table", X5e, [
                      a("thead", null, [
                        a("tr", q5e, [
                          a("th", Q5e, [
                            !e.isRentVsSell && !e.isCurrentYear ? (p(), h("button", {
                              key: 0,
                              type: "button",
                              onClick: t[30] || (t[30] = (E) => e.autoPopulateValueEquity()),
                              disabled: e.cantAutoPopulate,
                              class: "btn btn-outline-eclipse btn-sm"
                            }, t[96] || (t[96] = [
                              a("i", { class: "fa-duotone fa-solid fa-wand-sparkles me-2" }, null, -1),
                              y("Estimate Annual Values")
                            ]), 8, K5e)) : P("", !0)
                          ]),
                          !e.isRentVsSell && !e.isCurrentYear ? (p(!0), h(A, { key: 0 }, D(e.purchaseFactsYears, (E) => (p(), h("th", Z5e, g(E.year), 1))), 256)) : (p(), h("th", J5e, g(e.currentYear), 1))
                        ])
                      ]),
                      a("tbody", null, [
                        a("tr", null, [
                          t[97] || (t[97] = a("th", null, [
                            y(" Property Value"),
                            a("br"),
                            a("small", { class: "text-secondary fw-normal" }, "(End of Year Value)")
                          ], -1)),
                          !e.isRentVsSell && !e.isCurrentYear ? (p(!0), h(A, { key: 0 }, D(e.purchaseFactsYears, (E) => (p(), h("td", $5e, [
                            N(d, {
                              modelValue: E.propertyValue,
                              "onUpdate:modelValue": (B) => E.propertyValue = B,
                              currency: ""
                            }, null, 8, ["modelValue", "onUpdate:modelValue"])
                          ]))), 256)) : (p(), h("th", _5e, [
                            a("span", eEe, g(e.currency(e.calcParams.propertyValueEoY)), 1)
                          ]))
                        ]),
                        a("tr", null, [
                          t[98] || (t[98] = a("th", null, [
                            y(" Loan Balance"),
                            a("br"),
                            a("small", { class: "text-secondary fw-normal" }, "(End of Year Value)")
                          ], -1)),
                          !e.isRentVsSell && !e.isCurrentYear ? (p(!0), h(A, { key: 0 }, D(e.purchaseFactsYears, (E) => (p(), h("td", tEe, [
                            a("span", sEe, g(e.currency(E.loanBalance, !1, "N/A")), 1)
                          ]))), 256)) : (p(), h("th", aEe, [
                            a("span", nEe, g(e.currency((b = e.propertyStore.getEoYAmortizationInfo(e.currentYear)) == null ? void 0 : b.remainingPrincipalBeforePayment, !1, "N/A")), 1)
                          ]))
                        ]),
                        a("tr", null, [
                          t[99] || (t[99] = a("th", null, "Cost of Sale", -1)),
                          !e.isRentVsSell && !e.isCurrentYear ? (p(!0), h(A, { key: 0 }, D(e.purchaseFactsYears, (E) => (p(), h("td", rEe, [
                            a("span", oEe, g(e.currency(E.propertyValue * e.calcParams.costofsale)), 1)
                          ]))), 256)) : (p(), h("th", iEe, [
                            a("span", lEe, g(e.currency(e.calcParams.propertyValueEoY * e.calcParams.costofsale)), 1)
                          ]))
                        ]),
                        a("tr", null, [
                          t[100] || (t[100] = a("th", null, "Equity", -1)),
                          !e.isRentVsSell && !e.isCurrentYear ? (p(!0), h(A, { key: 0 }, D(e.purchaseFactsYears, (E) => (p(), h("td", dEe, [
                            a("span", cEe, g(e.currency(e.calculateEquityForYear(E))), 1)
                          ]))), 256)) : (p(), h("th", uEe, [
                            a("span", pEe, g(e.currency(e.calculateEquity(e.calcParams.propertyValueEoY, (w = e.propertyStore.getEoYAmortizationInfo(e.currentYear)) == null ? void 0 : w.remainingPrincipalBeforePayment))), 1)
                          ]))
                        ])
                      ])
                    ])) : P("", !0)
                  ])
                ]),
                P("", !0)
              ]),
              a("div", hEe, [
                e.requireCalculateAndSave ? (p(), h("div", mEe, t[104] || (t[104] = [
                  a("div", {
                    class: "alert alert-info mb-0",
                    role: "alert"
                  }, [
                    a("i", { class: "fa-light fa-lightbulb-exclamation-on me-1" }),
                    y("Please review each tab to validate we have accurate information for your property. When complete, click 'Calculate & Save' on the final tab. ")
                  ], -1)
                ]))) : P("", !0),
                e.alertMessage.length > 0 ? (p(), h("div", fEe, [
                  a("div", gEe, [
                    (p(!0), h(A, null, D(e.alertMessage, (E) => (p(), h("div", null, [
                      t[105] || (t[105] = a("i", { class: "fa-light fa-triangle-exclamation me-2" }, null, -1)),
                      y(g(E), 1)
                    ]))), 256))
                  ])
                ])) : P("", !0),
                a("div", vEe, [
                  e.dontIgnoreHistoricalOperatingIncome && !e.isCurrentYear ? (p(), h("div", yEe, [
                    a("div", bEe, [
                      t[108] || (t[108] = a("span", { class: "fw-bold" }, "Rental Income Calculation Method:", -1)),
                      a("div", AEe, [
                        V(a("input", {
                          type: "radio",
                          class: "btn-check",
                          name: "options",
                          id: "option1",
                          value: "monthlyLessVacancy",
                          "onUpdate:modelValue": t[32] || (t[32] = (E) => e.rentalIncomeCalculationMethod = E),
                          autocomplete: "off",
                          disabled: e.isSyncedExpenses
                        }, null, 8, wEe), [
                          [Mt, e.rentalIncomeCalculationMethod]
                        ]),
                        t[106] || (t[106] = a("label", {
                          class: "btn btn-eclipse",
                          for: "option1"
                        }, "Monthly Rate Less Vacancy", -1)),
                        V(a("input", {
                          type: "radio",
                          class: "btn-check",
                          name: "options",
                          id: "option2",
                          value: "totalAnnualIncome",
                          "onUpdate:modelValue": t[33] || (t[33] = (E) => e.rentalIncomeCalculationMethod = E),
                          autocomplete: "off",
                          disabled: e.isSyncedExpenses
                        }, null, 8, CEe), [
                          [Mt, e.rentalIncomeCalculationMethod]
                        ]),
                        t[107] || (t[107] = a("label", {
                          class: "btn btn-eclipse",
                          for: "option2"
                        }, "Total Annual Income", -1))
                      ])
                    ])
                  ])) : P("", !0),
                  a("div", SEe, [
                    a("div", PEe, [
                      a("div", kEe, [
                        t[109] || (t[109] = a("label", { class: "col-form-label col-md-6 col-lg-3" }, " Current Rental Rate ", -1)),
                        a("div", EEe, [
                          N(d, {
                            modelValue: e.calcParams.monthlyRentalYear1,
                            "onUpdate:modelValue": t[34] || (t[34] = (E) => e.calcParams.monthlyRentalYear1 = E),
                            modelModifiers: { number: !0 },
                            currency: "",
                            locked: e.isSyncedExpenses
                          }, null, 8, ["modelValue", "locked"])
                        ]),
                        t[110] || (t[110] = a("label", { class: "col-form-label col-md-6 col-lg-3" }, " Annual Rental Growth ", -1)),
                        a("div", IEe, [
                          N(d, {
                            modelValue: e.calcParams.annualrentalgrowth,
                            "onUpdate:modelValue": t[35] || (t[35] = (E) => e.calcParams.annualrentalgrowth = E),
                            modelModifiers: { number: !0 },
                            percent: ""
                          }, null, 8, ["modelValue"])
                        ])
                      ])
                    ])
                  ]),
                  ((I = (S = e.purchaseFacts) == null ? void 0 : S.years) == null ? void 0 : I.length) == 0 ? (p(), h("div", TEe, t[111] || (t[111] = [
                    a("i", { class: "fa-light fa-circle-info me-2" }, null, -1),
                    y(" Only complete calendar years may be entered. ")
                  ]))) : P("", !0)
                ]),
                a("div", OEe, [
                  a("div", REe, [
                    ((T = e.incomeAndVacancyAnalysisYears) == null ? void 0 : T.length) > 0 ? (p(), h("table", LEe, [
                      a("thead", null, [
                        a("tr", BEe, [
                          a("th", MEe, [
                            a("button", {
                              type: "button",
                              onClick: t[36] || (t[36] = (...E) => e.autoPopulateIncomeVacancy && e.autoPopulateIncomeVacancy(...E)),
                              disabled: e.cantAutoPopulate || e.isSyncedExpenses,
                              class: "btn btn-outline-eclipse btn-sm"
                            }, t[112] || (t[112] = [
                              a("i", { class: "fa-duotone fa-solid fa-wand-sparkles me-2" }, null, -1),
                              y("Estimate Annual Rates")
                            ]), 8, xEe)
                          ]),
                          (p(!0), h(A, null, D(e.incomeAndVacancyAnalysisYears, (E) => (p(), h("th", FEe, g(E.year), 1))), 256))
                        ])
                      ]),
                      a("tbody", null, [
                        e.rentalIncomeCalculationMethod == "monthlyLessVacancy" ? (p(), h(A, { key: 0 }, [
                          e.calcParams.shortTerm ? P("", !0) : (p(), h("tr", VEe, [
                            t[113] || (t[113] = a("th", null, "Rental Rate", -1)),
                            (p(!0), h(A, null, D(e.incomeAndVacancyAnalysisYears, (E) => (p(), h("td", null, [
                              N(d, {
                                modelValue: E.rentalRate,
                                "onUpdate:modelValue": (B) => E.rentalRate = B,
                                modelModifiers: { number: !0 },
                                currency: "",
                                disabled: E.synced
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
                            ]))), 256))
                          ])),
                          a("tr", null, [
                            t[114] || (t[114] = a("th", null, "Gross Potential Income", -1)),
                            (p(!0), h(A, null, D(e.incomeAndVacancyAnalysisYears, (E) => (p(), h("td", DEe, [
                              a("span", NEe, g(e.currency(E.rentalRate * 12)), 1)
                            ]))), 256))
                          ]),
                          e.calcParams.shortTerm ? P("", !0) : (p(), h("tr", jEe, [
                            t[115] || (t[115] = a("th", null, "Days Vacant", -1)),
                            (p(!0), h(A, null, D(e.incomeAndVacancyAnalysisYears, (E) => (p(), h("td", null, [
                              N(d, {
                                modelValue: E.vacancyLoss,
                                "onUpdate:modelValue": (B) => E.vacancyLoss = B,
                                modelModifiers: { number: !0 },
                                class: "form-control text-end"
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]))), 256))
                          ])),
                          e.calcParams.shortTerm ? P("", !0) : (p(), h("tr", HEe, [
                            t[116] || (t[116] = a("th", null, "Vacancy Loss", -1)),
                            (p(!0), h(A, null, D(e.incomeAndVacancyAnalysisYears, (E) => (p(), h("td", UEe, [
                              a("span", zEe, g(E.rentalRate > 0 ? e.currency(E.rentalRate / 30 * E.vacancyLoss) : ""), 1)
                            ]))), 256))
                          ])),
                          a("tr", null, [
                            t[117] || (t[117] = a("th", null, "Effective Rental Income", -1)),
                            (p(!0), h(A, null, D(e.incomeAndVacancyAnalysisYears, (E) => (p(), h("td", WEe, [
                              a("span", GEe, g(E.rentalRate > 0 ? e.currency(E.rentalRate * 12 - E.rentalRate / 30 * E.vacancyLoss) : ""), 1)
                            ]))), 256))
                          ])
                        ], 64)) : (p(), h(A, { key: 1 }, [
                          (p(!0), h(A, null, D(e.otherIncomeAccounts, (E) => (p(), h("tr", null, [
                            a("th", null, g(E.name), 1),
                            (p(!0), h(A, null, D(e.incomeAndVacancyAnalysisYears, (B) => {
                              var M;
                              return p(), h("td", {
                                class: "text-end",
                                "data-year": B.year
                              }, [
                                (M = B.otherIncomes) != null && M.find((R) => R.id == E.id) ? (p(), Fe(d, {
                                  key: 0,
                                  modelValue: B.otherIncomes.find((R) => R.id == E.id).total,
                                  "onUpdate:modelValue": (R) => B.otherIncomes.find((F) => F.id == E.id).total = R,
                                  currency: "",
                                  disabled: B.synced
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])) : P("", !0)
                              ], 8, YEe);
                            }), 256))
                          ]))), 256)),
                          a("tr", null, [
                            t[118] || (t[118] = a("th", null, "Total Annual Income", -1)),
                            (p(!0), h(A, null, D(e.incomeAndVacancyAnalysisYears, (E) => (p(), h("td", XEe, [
                              N(d, {
                                modelValue: E.annualRentalIncome,
                                "onUpdate:modelValue": (B) => E.annualRentalIncome = B,
                                modelModifiers: { number: !0 },
                                currency: "",
                                disabled: E.synced
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
                            ]))), 256))
                          ])
                        ], 64))
                      ])
                    ])) : P("", !0)
                  ])
                ])
              ]),
              V(a("div", qEe, [
                e.requireCalculateAndSave ? (p(), h("div", QEe, t[119] || (t[119] = [
                  a("div", {
                    class: "alert alert-info mb-0",
                    role: "alert"
                  }, [
                    a("i", { class: "fa-light fa-lightbulb-exclamation-on me-1" }),
                    y("Please review each tab to validate we have accurate information for your property. When complete, click 'Calculate & Save' on the final tab. ")
                  ], -1)
                ]))) : P("", !0),
                e.alertMessage.length > 0 ? (p(), h("div", KEe, [
                  a("div", ZEe, [
                    (p(!0), h(A, null, D(e.alertMessage, (E) => (p(), h("div", null, [
                      t[120] || (t[120] = a("i", { class: "fa-light fa-triangle-exclamation me-2" }, null, -1)),
                      y(g(E), 1)
                    ]))), 256))
                  ])
                ])) : P("", !0),
                ((k = (x = e.purchaseFacts) == null ? void 0 : x.years) == null ? void 0 : k.length) == 0 ? (p(), h("div", JEe, t[121] || (t[121] = [
                  a("div", {
                    class: "alert alert-info mb-0",
                    role: "alert"
                  }, [
                    a("i", { class: "fa-light fa-circle-info me-2" }),
                    y(" Only complete calendar years may be entered. ")
                  ], -1)
                ]))) : P("", !0),
                a("div", $Ee, [
                  a("div", _Ee, [
                    ((O = (C = e.purchaseFacts) == null ? void 0 : C.years) == null ? void 0 : O.length) > 0 ? (p(), h("table", eIe, [
                      a("thead", null, [
                        a("tr", tIe, [
                          a("th", sIe, [
                            a("button", {
                              type: "button",
                              onClick: t[37] || (t[37] = (...E) => e.autoPopulateOperatingCost && e.autoPopulateOperatingCost(...E)),
                              disabled: e.cantAutoPopulate || e.isSyncedExpenses,
                              class: "btn btn-outline-eclipse btn-sm"
                            }, t[122] || (t[122] = [
                              a("i", { class: "fa-duotone fa-wand-sparkles me-2" }, null, -1),
                              y("Auto-Populate Values")
                            ]), 8, aIe)
                          ]),
                          (p(!0), h(A, null, D(e.analysisYears, (E) => (p(), h("th", nIe, g(E.year), 1))), 256))
                        ])
                      ]),
                      a("tbody", null, [
                        e.calcParams.shortTerm ? (p(), h("tr", rIe, [
                          t[123] || (t[123] = a("th", null, "Short Term Average Nightly Rate", -1)),
                          (p(!0), h(A, null, D(e.analysisYears, (E) => (p(), h("td", null, [
                            N(d, {
                              modelValue: E.strRentalRate,
                              "onUpdate:modelValue": (B) => E.strRentalRate = B,
                              currency: "",
                              disabled: E.synced
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
                          ]))), 256))
                        ])) : P("", !0),
                        a("tr", null, [
                          t[124] || (t[124] = a("th", null, "Tax", -1)),
                          (p(!0), h(A, null, D(e.analysisYears, (E) => (p(), h("td", null, [
                            N(d, {
                              modelValue: E.tax,
                              "onUpdate:modelValue": (B) => E.tax = B,
                              modelModifiers: { number: !0 },
                              currency: "",
                              disabled: E.synced
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
                          ]))), 256))
                        ]),
                        a("tr", null, [
                          t[125] || (t[125] = a("th", null, "Insurance", -1)),
                          (p(!0), h(A, null, D(e.analysisYears, (E) => (p(), h("td", null, [
                            N(d, {
                              modelValue: E.insurance,
                              "onUpdate:modelValue": (B) => E.insurance = B,
                              modelModifiers: { number: !0 },
                              currency: "",
                              disabled: E.synced
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
                          ]))), 256))
                        ]),
                        a("tr", null, [
                          t[126] || (t[126] = a("th", null, "Association Fees", -1)),
                          (p(!0), h(A, null, D(e.analysisYears, (E) => (p(), h("td", null, [
                            N(d, {
                              modelValue: E.associationFees,
                              "onUpdate:modelValue": (B) => E.associationFees = B,
                              modelModifiers: { number: !0 },
                              currency: "",
                              disabled: E.synced
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
                          ]))), 256))
                        ]),
                        e.calcParams.shortTerm ? P("", !0) : (p(), h("tr", oIe, [
                          t[127] || (t[127] = a("th", null, "Commission", -1)),
                          (p(!0), h(A, null, D(e.analysisYears, (E) => (p(), h("td", null, [
                            N(d, {
                              modelValue: E.commission,
                              "onUpdate:modelValue": (B) => E.commission = B,
                              modelModifiers: { number: !0 },
                              currency: "",
                              disabled: E.synced
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
                          ]))), 256))
                        ])),
                        e.calcParams.shortTerm ? P("", !0) : (p(), h("tr", iIe, [
                          t[128] || (t[128] = a("th", null, "Management", -1)),
                          (p(!0), h(A, null, D(e.analysisYears, (E) => (p(), h("td", null, [
                            N(d, {
                              modelValue: E.management,
                              "onUpdate:modelValue": (B) => E.management = B,
                              modelModifiers: { number: !0 },
                              currency: "",
                              disabled: E.synced
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
                          ]))), 256))
                        ])),
                        e.calcParams.shortTerm ? P("", !0) : (p(), h("tr", lIe, [
                          t[129] || (t[129] = a("th", null, "Maintenance", -1)),
                          (p(!0), h(A, null, D(e.analysisYears, (E) => (p(), h("td", null, [
                            N(d, {
                              modelValue: E.maintenance,
                              "onUpdate:modelValue": (B) => E.maintenance = B,
                              modelModifiers: { number: !0 },
                              currency: "",
                              disabled: E.synced
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
                          ]))), 256))
                        ])),
                        a("tr", null, [
                          t[130] || (t[130] = a("th", null, "Capital Expenditures", -1)),
                          (p(!0), h(A, null, D(e.analysisYears, (E) => (p(), h("td", null, [
                            N(d, {
                              modelValue: E.capitalExpenditures,
                              "onUpdate:modelValue": (B) => E.capitalExpenditures = B,
                              modelModifiers: { number: !0 },
                              currency: "",
                              disabled: E.synced
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
                          ]))), 256))
                        ]),
                        e.calcParams.shortTerm ? P("", !0) : (p(), h("tr", dIe, [
                          t[131] || (t[131] = a("th", null, "Utility Expenses", -1)),
                          (p(!0), h(A, null, D(e.analysisYears, (E) => (p(), h("td", null, [
                            N(d, {
                              modelValue: E.utilityExpenses,
                              "onUpdate:modelValue": (B) => E.utilityExpenses = B,
                              modelModifiers: { number: !0 },
                              currency: "",
                              disabled: E.synced
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
                          ]))), 256))
                        ])),
                        e.calcParams.shortTerm ? (p(), h("tr", cIe, [
                          t[132] || (t[132] = a("th", null, "Short Term Cleaning Expenses", -1)),
                          (p(!0), h(A, null, D(e.analysisYears, (E) => (p(), h("td", null, [
                            N(d, {
                              modelValue: E.strCleaningExpenses,
                              "onUpdate:modelValue": (B) => E.strCleaningExpenses = B,
                              modelModifiers: { number: !0 },
                              currency: "",
                              disabled: E.synced
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
                          ]))), 256))
                        ])) : P("", !0),
                        e.calcParams.shortTerm ? (p(), h("tr", uIe, [
                          t[133] || (t[133] = a("th", null, "Short Term Consumable Expenses", -1)),
                          (p(!0), h(A, null, D(e.analysisYears, (E) => (p(), h("td", null, [
                            N(d, {
                              modelValue: E.strConsumableExpenses,
                              "onUpdate:modelValue": (B) => E.strConsumableExpenses = B,
                              modelModifiers: { number: !0 },
                              currency: "",
                              disabled: E.synced
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
                          ]))), 256))
                        ])) : P("", !0),
                        e.calcParams.shortTerm ? (p(), h("tr", pIe, [
                          t[134] || (t[134] = a("th", null, "Short Term Furnishing Expenses", -1)),
                          (p(!0), h(A, null, D(e.analysisYears, (E) => (p(), h("td", null, [
                            N(d, {
                              modelValue: E.strFurnishingExpenses,
                              "onUpdate:modelValue": (B) => E.strFurnishingExpenses = B,
                              modelModifiers: { number: !0 },
                              currency: "",
                              disabled: E.synced
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
                          ]))), 256))
                        ])) : P("", !0),
                        e.calcParams.shortTerm ? (p(), h("tr", hIe, [
                          t[135] || (t[135] = a("th", null, "Short Term Platform Service Fees", -1)),
                          (p(!0), h(A, null, D(e.analysisYears, (E) => (p(), h("td", null, [
                            N(d, {
                              modelValue: E.strPlatformServiceFees,
                              "onUpdate:modelValue": (B) => E.strPlatformServiceFees = B,
                              modelModifiers: { number: !0 },
                              currency: "",
                              disabled: E.synced
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
                          ]))), 256))
                        ])) : P("", !0),
                        e.calcParams.shortTerm ? (p(), h("tr", mIe, [
                          t[136] || (t[136] = a("th", null, "Short Term Utility Expenses", -1)),
                          (p(!0), h(A, null, D(e.analysisYears, (E) => (p(), h("td", null, [
                            N(d, {
                              modelValue: E.strUtilityExpenses,
                              "onUpdate:modelValue": (B) => E.strUtilityExpenses = B,
                              modelModifiers: { number: !0 },
                              currency: "",
                              disabled: E.synced
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
                          ]))), 256))
                        ])) : P("", !0)
                      ])
                    ])) : P("", !0)
                  ])
                ])
              ], 512), [
                [Us, !e.fastForwardAnalysis]
              ])
            ])) : P("", !0)
          ]),
          a("div", fIe, [
            e.showClearRest ? (p(), h("button", gIe, t[137] || (t[137] = [
              a("i", { class: "fa-light fa-broom-wide me-2" }, null, -1),
              y("Clear & Reset ")
            ]))) : P("", !0),
            e.showPrevButton ? (p(), h("button", {
              key: 1,
              type: "button",
              class: "order-2 order-lg-1 btn btn-outline-eclipse prev-step me-auto me-lg-0",
              onClick: t[38] || (t[38] = (...E) => e.prevTab && e.prevTab(...E))
            }, t[138] || (t[138] = [
              a("i", { class: "fa-light fa-arrow-left-long me-2" }, null, -1),
              y("Previous ")
            ]))) : P("", !0),
            e.showNextButton ? (p(), h("button", {
              key: 2,
              type: "button",
              class: "order-3 btn btn-eclipse next-step",
              onClick: t[39] || (t[39] = (...E) => e.nextTab && e.nextTab(...E)),
              disabled: e.disableNextButton
            }, t[139] || (t[139] = [
              y(" Next"),
              a("i", { class: "fa-light fa-arrow-right-long ms-2" }, null, -1)
            ]), 8, vIe)) : P("", !0),
            e.showCalculate ? (p(), h("button", {
              key: 3,
              type: "button",
              class: z(["order-3 btn btn-lava btn-calculate ms-2", e.calculateAndSaveStyle]),
              onClick: t[40] || (t[40] = (...E) => e.calculate && e.calculate(...E)),
              disabled: e.cantCalculateSave
            }, " Calculate & Save ", 10, yIe)) : P("", !0)
          ])
        ])
      ])
    ], 512),
    a("div", bIe, [
      a("div", AIe, [
        a("div", wIe, [
          t[145] || (t[145] = a("div", { class: "modal-header border-0" }, [
            a("button", {
              type: "button",
              class: "btn-close",
              "data-bs-toggle": "modal",
              "data-bs-target": "#modalExistingInvestment",
              "aria-label": "Close"
            })
          ], -1)),
          a("div", CIe, [
            t[142] || (t[142] = a("span", { class: "bg-danger rounded-circle mb-4 p-3 text-white" }, [
              a("i", { class: "fa-light fa-broom-wide fa-2xl" })
            ], -1)),
            t[143] || (t[143] = a("p", { class: "fw-bold fs-4 mb-0" }, "Are you sure?", -1)),
            t[144] || (t[144] = a("p", { class: "mb-5" }, "Clicking Clear & Reset below will clear all historical data for this property, remove it from your existing investments, and change the investment strategy to ‘New Purchase’.", -1)),
            a("button", {
              type: "button",
              class: "btn btn-danger",
              onClick: t[41] || (t[41] = (...E) => e.resetListing && e.resetListing(...E))
            }, "Yes, Clear & Reset")
          ])
        ])
      ])
    ], 512)
  ], 64);
}
const Bls = /* @__PURE__ */ Ae(T4e, [["render", SIe]]);
function So(e, t, s, n = 0, r = 0) {
  if (n = typeof n < "u" ? n : 0, r = typeof r < "u" ? r : 0, e !== 0) {
    const i = Math.pow(1 + e, t);
    return -(e * (n + i * s)) / ((-1 + i) * (1 + e * r));
  } else if (t !== 0)
    return -(n + s) / t;
  return 0;
}
function bu(e, t, s, n = 0, r = 0) {
  n = typeof n < "u" ? n : 0, r = typeof r < "u" ? r : 0;
  let i = Math.pow(1 + e, t), o;
  return e ? o = s * (1 + e * r) * (1 - i) / e - n * i : o = -1 * (n + s * t), o;
}
const PIe = me({
  name: "PreForeclosureNotice",
  props: {
    id: {
      type: Number,
      required: !0
    },
    analysis: {
      type: String,
      required: !1
    },
    activeFiling: Object
  },
  emits: ["update:activeFiling"],
  data() {
    return {
      hasPreForeclosure: !1,
      filings: []
    };
  },
  computed: {
    filing() {
      var e;
      if (((e = this.filings) == null ? void 0 : e.length) > 0)
        return this.filings[0];
    },
    openingBid() {
      if (this.filing.openingBid)
        return this.filing.openingBid;
      if (!this.filing.mortgage1Amount || this.filing.mortgage1Amount == 0)
        return;
      let e = 0;
      if (this.filing.estimatedRate && this.filing.nper) {
        let t = this.filing.mortgage1Term;
        t <= 0 && (t = 360);
        const s = So(this.filing.estimatedRate / 12, t, -this.filing.mortgage1Amount);
        e = bu(this.filing.estimatedRate / 12, this.filing.nper, s, -this.filing.mortgage1Amount);
      }
      return e < 0 && (e = 0), e;
    },
    originalBalance() {
      return this.filing.originalBalance ? this.filing.originalBalance : this.filing.mortgage1Amount;
    },
    type() {
      switch (this.filing.type) {
        case xr.Lis:
          return "Lis Pendens";
        case xr.Nod:
          return "Notice of Default";
        case xr.Nos:
          return "Notice of Sale";
        case xr.Nts:
          return "Notice of Trustee's Sale";
        case xr.Reo:
          return "Real Estate Owned";
        default:
          return "Unknown";
      }
    },
    ...q(Te, ["acl", "aclLoaded"]),
    ...q(qe, ["property", "propertyInitialized"])
  },
  methods: {
    number: Ve,
    currency: Ze,
    formatDate: cs,
    async retrievePreForeclosureFilings() {
      var e, t;
      try {
        await this.propertyInitialized;
        let s;
        if ((e = this.property.mlsSource) != null && e.source && ((t = this.property.mlsSource) != null && t.number) ? s = await W.api.preForeclosure.listingFilings(this.property.mlsSource.source, this.property.mlsSource.number) : s = await W.api.preForeclosure.filings(this.id), s.data.status != de.Success)
          throw new Error(s.data.message);
        this.filings.length = 0, s.data.results && this.filings.push(...s.data.results), this.hasPreForeclosure = s.data.hasPreForeclosure == !0, this.$emit("update:activeFiling", this.filing);
      } catch {
      }
    }
  },
  mounted() {
    this.aclLoaded.then(async () => await this.retrievePreForeclosureFilings());
  }
}), kIe = {
  key: 0,
  class: "card shadow-sm mb-3"
}, EIe = { class: "card-body bg-preforeclosure m-2 rounded" }, IIe = { class: "row row-cols-2 row-cols-md-3 fw-bold" }, TIe = { class: "col mb-3" }, OIe = { class: "col mb-3" }, RIe = { class: "text-secondary text-opacity-50 small text-uppercase d-block" }, LIe = { class: "col mb-3" }, BIe = { class: "text-secondary text-opacity-50 small text-uppercase d-block" }, MIe = { class: "col mb-3" }, xIe = { class: "col mb-3" }, FIe = { class: "col mb-3" }, VIe = { class: "col mb-3 mb-md-0" }, DIe = { class: "col" }, NIe = { class: "col" }, jIe = {
  key: 1,
  class: "card mb-3 shadow-sm rounded bg-preforeclosure"
}, HIe = { class: "card-body p-5 d-flex align-items-center flex-column flex-lg-row" }, UIe = {
  key: 0,
  href: "/features/pre-foreclosure",
  class: "btn btn-lava ms-lg-3 flex-shrink-0"
}, zIe = {
  key: 1,
  href: "/account/settings#subscription",
  class: "btn btn-lava ms-lg-3 flex-shrink-0"
}, WIe = {
  key: 2,
  href: "/signup",
  class: "btn btn-lava ms-lg-3 flex-shrink-0"
};
function GIe(e, t, s, n, r, i) {
  var o;
  return e.filing ? (p(), h("div", kIe, [
    t[10] || (t[10] = a("div", {
      class: "card-header bg-transparent border-bottom-0 fw-bold mb-0",
      id: "headingOne"
    }, " Pre-Foreclosure Notice Information ", -1)),
    a("div", EIe, [
      a("div", IIe, [
        a("div", TIe, [
          t[0] || (t[0] = a("small", { class: "text-secondary text-opacity-50 small text-uppercase d-block" }, "Type of Notice", -1)),
          y(" " + g(e.type), 1)
        ]),
        a("div", OIe, [
          a("small", RIe, [
            e.filing.openingBidEstimated ? (p(), h(A, { key: 0 }, [
              y(" Estimated  ")
            ], 64)) : P("", !0),
            t[1] || (t[1] = y("Opening Bid "))
          ]),
          y(" " + g(e.currency(e.openingBid, !1, "N/A", !0)), 1)
        ]),
        a("div", LIe, [
          a("small", BIe, [
            e.filing.originalBalanceEstimated ? (p(), h(A, { key: 0 }, [
              y(" Estimated  ")
            ], 64)) : P("", !0),
            t[2] || (t[2] = y("Original Balance "))
          ]),
          y(" " + g(e.currency(e.originalBalance, !1, "N/A", !0)), 1)
        ]),
        a("div", MIe, [
          t[3] || (t[3] = a("small", { class: "text-secondary text-opacity-50 small text-uppercase d-block" }, "Auction Date", -1)),
          y(" " + g(e.formatDate(e.filing.auctionDate, !0, "N/A")), 1)
        ]),
        a("div", xIe, [
          t[4] || (t[4] = a("small", { class: "text-secondary text-opacity-50 small text-uppercase d-block" }, "Estimated Equity", -1)),
          y(" " + g(e.currency(e.filing.estimatedEquity, !1, "N/A", !0)), 1)
        ]),
        a("div", FIe, [
          t[5] || (t[5] = a("small", { class: "text-secondary text-opacity-50 small text-uppercase d-block" }, "Fees & Interest", -1)),
          y(" " + g(e.currency(e.filing.feesAndInterest, !1, "N/A", !0)), 1)
        ]),
        a("div", VIe, [
          t[6] || (t[6] = a("small", { class: "text-secondary text-opacity-50 small text-uppercase d-block" }, "Auction Address", -1)),
          y(" " + g(e.filing.auctionAddress), 1),
          t[7] || (t[7] = a("br", null, null, -1)),
          y(" " + g(e.filing.auctionCityState), 1)
        ]),
        a("div", DIe, [
          t[8] || (t[8] = a("small", { class: "text-secondary text-opacity-50 small text-uppercase d-block" }, "Loan Date", -1)),
          y(" " + g(e.formatDate(e.filing.loanDate, !0, "N/A")), 1)
        ]),
        a("div", NIe, [
          t[9] || (t[9] = a("small", { class: "text-secondary text-opacity-50 small text-uppercase d-block" }, "Delinquent Amount", -1)),
          y(" " + g(e.currency(e.filing.delinquentAmount, !1, "N/A", !0)), 1)
        ])
      ])
    ])
  ])) : e.hasPreForeclosure && e.acl && ((o = e.acl.properties) == null ? void 0 : o.viewPreForeclosure) != !0 ? (p(), h("div", jIe, [
    a("div", HIe, [
      t[13] || (t[13] = a("div", { class: "flex-shrink-0 mb-3 mb-lg-0" }, [
        a("i", { class: "fa-light fa-gavel fa-2xl" })
      ], -1)),
      t[14] || (t[14] = a("div", { class: "flex-grow-1 ms-lg-3 mb-3 mb-lg-0 text-center text-lg-start" }, [
        a("b", null, "Has Pre-Foreclosure Notice"),
        a("br"),
        y(" Create an account and login to see the notice! ")
      ], -1)),
      e.acl && e.acl.isAnonymous ? (p(), h("a", UIe, t[11] || (t[11] = [
        y("Learn More "),
        a("span", { class: "d-none d-xxl-inline-block" }, " about Pre-Foreclosures", -1)
      ]))) : e.acl && e.acl.brandedPDF ? (p(), h("a", zIe, t[12] || (t[12] = [
        y("Activate Pre-Foreclosure "),
        a("span", { class: "d-none d-xxl-inline-block" }, " Add-on", -1)
      ]))) : (p(), h("a", WIe, "Subscribe"))
    ])
  ])) : P("", !0);
}
const Mls = /* @__PURE__ */ Ae(PIe, [["render", GIe]]), YIe = me({
  name: "InvestmentDetails",
  props: {
    show: {
      type: Boolean,
      default: !1
    }
  },
  components: {
    NumericalInput: Aa,
    DateInput: Ab
  },
  enums: {
    ConfirmedPurchaseFacts: Pt
  },
  watch: {
    show(e) {
      var t, s;
      e ? (t = bootstrap.Modal.getOrCreateInstance(this.$refs.modalInvestmentDetails)) == null || t.show() : (s = bootstrap.Modal.getOrCreateInstance(this.$refs.modalInvestmentDetails)) == null || s.hide();
    },
    "purchaseFacts.hasCurrentLoan"(e) {
      e && this.purchaseFacts && this.purchaseFacts.loan == null && (this.purchaseFacts.loan = {});
    },
    "purchaseFacts.hasPreviousLoan"(e) {
      e && this.purchaseFacts && this.purchaseFacts.previousLoan == null && (this.purchaseFacts.previousLoan = {});
    },
    "purchaseFacts.loan": {
      handler() {
        var e, t, s, n;
        this.propertyStore.populateLoans(!1), (e = this.purchaseFacts) != null && e.loan && (this.purchaseFacts.loan.balancePaidOff = this.propertyStore.calculateLoanPaidOffBalance((t = this.purchaseFacts) == null ? void 0 : t.loan, (s = this.purchaseFacts) == null ? void 0 : s.loan.date, (n = this.purchaseFacts) == null ? void 0 : n.loan.datePaidOff));
      },
      deep: !0
    },
    "purchaseFacts.previousLoan": {
      handler() {
        this.propertyStore.populateLoans();
      },
      deep: !0
    }
  },
  computed: {
    yearsList() {
      var s, n;
      let e = [], t = (((n = (s = this.purchaseFacts) == null ? void 0 : s.purchaseDate) == null ? void 0 : n.getFullYear()) ?? 1991) + 1;
      for (let r = t; r <= Et; r++)
        e.push(r);
      return e;
    },
    loanPayment() {
      var e;
      if ((e = this.purchaseFacts) != null && e.loan)
        return pn(
          this.purchaseFacts.loan.interestRate / 12,
          this.purchaseFacts.loan.term * 12,
          this.purchaseFacts.loan.amount
        );
    },
    previousLoanPayment() {
      var e;
      if ((e = this.purchaseFacts) != null && e.previousLoan)
        return pn(
          this.purchaseFacts.previousLoan.interestRate / 12,
          this.purchaseFacts.previousLoan.term * 12,
          this.purchaseFacts.previousLoan.amount
        );
    },
    canSave() {
      var e, t, s, n, r, i, o, l;
      return !Mg((t = (e = this.purchaseFacts) == null ? void 0 : e.loan) == null ? void 0 : t.date, (n = (s = this.purchaseFacts) == null ? void 0 : s.loan) == null ? void 0 : n.datePaidOff) && !Mg((i = (r = this.purchaseFacts) == null ? void 0 : r.previousLoanloan) == null ? void 0 : i.date, (l = (o = this.purchaseFacts) == null ? void 0 : o.previousLoan) == null ? void 0 : l.datePaidOff);
    },
    ...q(qe, ["purchaseFacts", "calcParams", "property", "purchaseYear"]),
    ...at(qe)
  },
  methods: {
    number: Ve,
    currency: Ze,
    dateGreater: Mg,
    isConfirmed(e) {
      return this.propertyStore.isConfirmed(e);
    },
    async confirm(e, t) {
      e.target.checked ? await this.propertyStore.confirmPurchaseFact(t) : await this.propertyStore.unconfirmPurchaseFact(t);
    },
    async save() {
      var e, t, s, n, r;
      (e = bootstrap.Modal.getOrCreateInstance(this.$refs.modalInvestmentDetails)) == null || e.hide();
      try {
        if (!(((s = (t = this.propertyStore.purchaseFacts) == null ? void 0 : t.years) == null ? void 0 : s.filter((o) => o.year >= this.propertyStore.firstYearAsRental).every((o) => o.propertyValue > 0)) ?? !0)) {
          const o = this.propertyStore.isAtPurchase ? (n = this.propertyStore.purchaseFacts) == null ? void 0 : n.purchasePrice : (r = this.propertyStore.purchaseFacts) == null ? void 0 : r.investmentBasis;
          this.propertyStore.autoPopulateValueEquity(o, this.propertyStore.firstYearAsRental, this.propertyStore.calcParams.propertyValueEoY, Et), Mi("There were some prior years that were missing property values. We auto populated the property values based on the property value at rental and your current EoY property value you have set. Please review the property values for prior years to validated they are correct.", void 0, !0);
        }
        await this.propertyStore.calculate(!0);
      } catch (i) {
        Se(i);
      }
    }
  },
  created() {
  },
  mounted() {
    var e;
    (e = this.$refs.modalInvestmentDetails) == null || e.addEventListener("hidden.bs.modal", (t) => {
      this.$emit("update:show", !1);
    });
  }
});
function Mg(e, t) {
  return !e || !t ? !1 : e > t;
}
const XIe = {
  class: "modal fade",
  ref: "modalInvestmentDetails",
  id: "modalInvestmentDetails",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false",
  tabindex: "-1",
  "aria-labelledby": "modalInvestmentDetailsLabel",
  "aria-hidden": "true"
}, qIe = { class: "modal-dialog modal-lg modal-dialog-centered" }, QIe = { class: "modal-content bg-gradient-alphabet rounded" }, KIe = { class: "modal-header border-0 pb-0" }, ZIe = {
  class: "fs-5 modal-title fw-bold",
  id: "modalInvestmentDetailsLabel"
}, JIe = {
  key: 0,
  class: "modal-body"
}, $Ie = {
  key: 1,
  class: "modal-body"
}, _Ie = { class: "mb-3" }, e6e = { class: "row g-2" }, t6e = { class: "col-5 col-sm-4" }, s6e = { class: "col-1 col-sm-2 text-center" }, a6e = ["checked"], n6e = { class: "col-5 col-sm-4" }, r6e = { class: "col-1 col-sm-2 text-center" }, o6e = ["checked"], i6e = { class: "col-5 col-sm-4" }, l6e = ["disabled"], d6e = ["value"], c6e = ["value"], u6e = { class: "col-1 col-sm-2 text-center" }, p6e = ["checked"], h6e = { class: "col-6 col-form-label" }, m6e = { class: "col-5 col-sm-4" }, f6e = { class: "col-1 col-sm-2 text-center" }, g6e = ["checked"], v6e = { class: "col-5 col-sm-4" }, y6e = { class: "col-1 col-sm-2 text-center" }, b6e = ["checked"], A6e = { class: "card bg-white bg-opacity-50 mb-3" }, w6e = { class: "card-body" }, C6e = { class: "row g-2" }, S6e = { class: "col-4 col-sm-3 d-flex justify-content-end" }, P6e = { class: "form-check form-switch form-switch-lg form-switch-basic mx-auto" }, k6e = ["disabled"], E6e = { class: "col-1 col-sm-2 text-center ps-lg-5" }, I6e = ["checked"], T6e = { class: "card-body border-top" }, O6e = { class: "row g-2" }, R6e = { class: "col-5 col-sm-4" }, L6e = { class: "col-5 col-sm-4" }, B6e = ["disabled"], M6e = ["value"], x6e = { class: "col-5 col-sm-4" }, F6e = { class: "col-5 col-sm-4" }, V6e = { class: "col-5 col-sm-4 text-end fw-bold" }, D6e = { class: "card-body border-top" }, N6e = { class: "row g-2" }, j6e = { class: "col-4 col-sm-3 d-flex justify-content-end" }, H6e = { class: "form-check form-switch form-switch-lg form-switch-basic mx-auto" }, U6e = ["disabled"], z6e = { class: "col-1 col-sm-2 text-center ps-lg-5" }, W6e = ["checked"], G6e = { class: "col-5 col-sm-4" }, Y6e = {
  key: 0,
  class: "col-11 col-sm-10 text-danger text-end small mt-1"
}, X6e = { class: "col-5 col-sm-4 text-end fw-bold" }, q6e = { class: "card bg-white bg-opacity-50" }, Q6e = { class: "card-body" }, K6e = { class: "row g-2" }, Z6e = { class: "col-4 col-sm-3 d-flex justify-content-end" }, J6e = { class: "form-check form-switch form-switch-lg form-switch-basic mx-auto" }, $6e = ["disabled"], _6e = { class: "col-1 col-sm-2 text-center ps-lg-5" }, eTe = ["checked"], tTe = {
  key: 0,
  class: "card-body border-top"
}, sTe = { class: "row g-2" }, aTe = { class: "col-5 col-sm-4" }, nTe = { class: "col-5 col-sm-4" }, rTe = ["disabled"], oTe = ["value"], iTe = { class: "col-5 col-sm-4" }, lTe = { class: "col-5 col-sm-4" }, dTe = { class: "col-5 col-sm-4 text-end fw-bold" }, cTe = { class: "modal-footer border-0 pt-0" }, uTe = ["disabled"];
function pTe(e, t, s, n, r, i) {
  var d, c, u, m, f, v, b, w, S, I, T, x;
  const o = pe("numerical-input"), l = pe("date-input");
  return p(), h("div", XIe, [
    a("div", qIe, [
      a("div", QIe, [
        a("div", KIe, [
          a("div", null, [
            a("p", ZIe, "Investment Details: " + g((c = (d = e.property) == null ? void 0 : d.address) == null ? void 0 : c.street), 1),
            t[26] || (t[26] = a("p", { class: "mb-0" }, "Confirm your property's purchase details to ensure precise financial analysis.", -1))
          ]),
          t[27] || (t[27] = a("button", {
            type: "button",
            class: "btn-close",
            "data-bs-dismiss": "modal",
            "aria-label": "Close"
          }, null, -1))
        ]),
        e.purchaseFacts ? (p(), h("div", $Ie, [
          a("div", _Ie, [
            a("div", e6e, [
              t[29] || (t[29] = a("div", { class: "col-2 offset-10 text-center" }, " Confirm? ", -1)),
              t[30] || (t[30] = a("label", { class: "col-6 col-form-label" }, " Purchase Price ", -1)),
              a("div", t6e, [
                N(o, {
                  currency: "",
                  modelValue: e.purchaseFacts.purchasePrice,
                  "onUpdate:modelValue": t[0] || (t[0] = (k) => e.purchaseFacts.purchasePrice = k),
                  locked: e.isConfirmed(e.ConfirmedPurchaseFacts.PurchasePrice)
                }, null, 8, ["modelValue", "locked"])
              ]),
              a("div", s6e, [
                a("input", {
                  type: "checkbox",
                  class: "form-check-input",
                  checked: e.isConfirmed(e.ConfirmedPurchaseFacts.PurchasePrice),
                  onChange: t[1] || (t[1] = (k) => e.confirm(k, e.ConfirmedPurchaseFacts.PurchasePrice))
                }, null, 40, a6e)
              ]),
              t[31] || (t[31] = a("label", { class: "col-6 col-form-label" }, " Purchase Date ", -1)),
              a("div", n6e, [
                N(l, {
                  modelValue: e.purchaseFacts.purchaseDate,
                  "onUpdate:modelValue": t[2] || (t[2] = (k) => e.purchaseFacts.purchaseDate = k),
                  locked: e.isConfirmed(e.ConfirmedPurchaseFacts.PurchaseDate),
                  class: "text-end"
                }, null, 8, ["modelValue", "locked"])
              ]),
              a("div", r6e, [
                a("input", {
                  type: "checkbox",
                  class: "form-check-input",
                  checked: e.isConfirmed(e.ConfirmedPurchaseFacts.PurchaseDate),
                  onChange: t[3] || (t[3] = (k) => e.confirm(k, e.ConfirmedPurchaseFacts.PurchaseDate))
                }, null, 40, o6e)
              ]),
              t[32] || (t[32] = a("label", { class: "col-6 col-sm-6 col-form-label" }, " What Year Did Property Become an Investment? ", -1)),
              a("div", i6e, [
                V(a("select", {
                  class: "form-select text-end locked",
                  "onUpdate:modelValue": t[4] || (t[4] = (k) => e.purchaseFacts.firstYearAsRental = k),
                  disabled: e.isConfirmed(e.ConfirmedPurchaseFacts.FirstRented)
                }, [
                  e.purchaseYear ? (p(), h("option", {
                    key: 0,
                    value: e.purchaseYear
                  }, "At Purchase", 8, d6e)) : P("", !0),
                  (p(!0), h(A, null, D(e.yearsList, (k) => (p(), h("option", {
                    value: k,
                    key: k
                  }, g(k), 9, c6e))), 128))
                ], 8, l6e), [
                  [We, e.purchaseFacts.firstYearAsRental]
                ])
              ]),
              a("div", u6e, [
                a("input", {
                  type: "checkbox",
                  class: "form-check-input",
                  checked: e.isConfirmed(e.ConfirmedPurchaseFacts.FirstRented),
                  onChange: t[5] || (t[5] = (k) => e.confirm(k, e.ConfirmedPurchaseFacts.FirstRented))
                }, null, 40, p6e)
              ]),
              ((u = e.purchaseFacts) == null ? void 0 : u.firstYearAsRental) != e.purchaseYear ? (p(), h(A, { key: 0 }, [
                a("label", h6e, g(e.purchaseFacts.firstYearAsRental) + " Initial Value ", 1),
                a("div", m6e, [
                  N(o, {
                    currency: "",
                    modelValue: e.purchaseFacts.investmentBasis,
                    "onUpdate:modelValue": t[6] || (t[6] = (k) => e.purchaseFacts.investmentBasis = k),
                    locked: e.isConfirmed(e.ConfirmedPurchaseFacts.InvestmentBasis)
                  }, null, 8, ["modelValue", "locked"])
                ]),
                a("div", f6e, [
                  a("input", {
                    type: "checkbox",
                    class: "form-check-input",
                    checked: e.isConfirmed(e.ConfirmedPurchaseFacts.InvestmentBasis),
                    onChange: t[7] || (t[7] = (k) => e.confirm(k, e.ConfirmedPurchaseFacts.InvestmentBasis))
                  }, null, 40, g6e)
                ])
              ], 64)) : P("", !0),
              t[33] || (t[33] = a("label", { class: "col-sm-12" }, " Did you spend any money on rehab/renovation upon turning the property into a rental? ", -1)),
              t[34] || (t[34] = a("label", { class: "col-6 col-form-label" }, " Rehab Expenses ", -1)),
              a("div", v6e, [
                N(o, {
                  currency: "",
                  modelValue: e.calcParams.rehabamount,
                  "onUpdate:modelValue": t[8] || (t[8] = (k) => e.calcParams.rehabamount = k),
                  locked: e.isConfirmed(e.ConfirmedPurchaseFacts.Rehab)
                }, null, 8, ["modelValue", "locked"])
              ]),
              a("div", y6e, [
                a("input", {
                  type: "checkbox",
                  class: "form-check-input",
                  checked: e.isConfirmed(e.ConfirmedPurchaseFacts.Rehab),
                  onChange: t[9] || (t[9] = (k) => e.confirm(k, e.ConfirmedPurchaseFacts.Rehab))
                }, null, 40, b6e)
              ])
            ])
          ]),
          a("div", A6e, [
            a("div", w6e, [
              a("div", C6e, [
                t[36] || (t[36] = a("label", { class: "col-7 col-form-label" }, " Has there been a loan on the property during its time as a rental? ", -1)),
                a("div", S6e, [
                  a("div", P6e, [
                    V(a("input", {
                      class: "form-check-input",
                      type: "checkbox",
                      role: "switch",
                      id: "switchLoanRental",
                      "onUpdate:modelValue": t[10] || (t[10] = (k) => e.purchaseFacts.hasCurrentLoan = k),
                      disabled: e.isConfirmed(e.ConfirmedPurchaseFacts.LoanInfo)
                    }, null, 8, k6e), [
                      [Ue, e.purchaseFacts.hasCurrentLoan]
                    ]),
                    t[35] || (t[35] = a("label", {
                      class: "form-check-label",
                      for: "switchLoanRental"
                    }, [
                      a("span", null, "No"),
                      y("Yes ")
                    ], -1))
                  ])
                ]),
                a("div", E6e, [
                  a("input", {
                    type: "checkbox",
                    class: "form-check-input",
                    checked: e.isConfirmed(e.ConfirmedPurchaseFacts.LoanInfo),
                    onChange: t[11] || (t[11] = (k) => e.confirm(k, e.ConfirmedPurchaseFacts.LoanInfo))
                  }, null, 40, I6e)
                ])
              ])
            ]),
            e.purchaseFacts.hasCurrentLoan ? (p(), h(A, { key: 0 }, [
              a("div", T6e, [
                a("div", O6e, [
                  t[37] || (t[37] = a("div", { class: "col-sm-12" }, [
                    a("p", { class: "fw-bold" }, "Current / Most Recent Loan Details:")
                  ], -1)),
                  t[38] || (t[38] = a("label", { class: "col-6 col-form-label" }, " Original Loan Amount ", -1)),
                  a("div", R6e, [
                    N(o, {
                      currency: "",
                      modelValue: e.purchaseFacts.loan.amount,
                      "onUpdate:modelValue": t[12] || (t[12] = (k) => e.purchaseFacts.loan.amount = k),
                      locked: e.isConfirmed(e.ConfirmedPurchaseFacts.LoanInfo)
                    }, null, 8, ["modelValue", "locked"])
                  ]),
                  t[39] || (t[39] = a("label", { class: "col-6 col-form-label" }, " Amortization Years ", -1)),
                  a("div", L6e, [
                    V(a("select", {
                      class: "form-select text-end locked",
                      "onUpdate:modelValue": t[13] || (t[13] = (k) => e.purchaseFacts.loan.term = k),
                      disabled: e.isConfirmed(e.ConfirmedPurchaseFacts.LoanInfo)
                    }, [
                      (p(), h(A, null, D(30, (k) => a("option", { value: k }, g(k), 9, M6e)), 64))
                    ], 8, B6e), [
                      [We, e.purchaseFacts.loan.term]
                    ])
                  ]),
                  t[40] || (t[40] = a("label", { class: "col-6 col-form-label" }, " Loan Date ", -1)),
                  a("div", x6e, [
                    N(l, {
                      modelValue: e.purchaseFacts.loan.date,
                      "onUpdate:modelValue": t[14] || (t[14] = (k) => e.purchaseFacts.loan.date = k),
                      locked: e.isConfirmed(e.ConfirmedPurchaseFacts.LoanInfo),
                      class: "text-end"
                    }, null, 8, ["modelValue", "locked"])
                  ]),
                  t[41] || (t[41] = a("label", { class: "col-6 col-form-label" }, " Interest Rate % ", -1)),
                  a("div", F6e, [
                    N(o, {
                      percent: "",
                      modelValue: e.purchaseFacts.loan.interestRate,
                      "onUpdate:modelValue": t[15] || (t[15] = (k) => e.purchaseFacts.loan.interestRate = k),
                      locked: e.isConfirmed(e.ConfirmedPurchaseFacts.LoanInfo)
                    }, null, 8, ["modelValue", "locked"])
                  ]),
                  t[42] || (t[42] = a("label", { class: "col-6 col-form-label" }, " Loan Payment ", -1)),
                  a("div", V6e, g(e.currency(e.loanPayment, 0, "N/A")), 1)
                ])
              ]),
              a("div", D6e, [
                a("div", N6e, [
                  t[46] || (t[46] = a("label", { class: "col-7 col-form-label" }, " Is the loan paid off? ", -1)),
                  a("div", j6e, [
                    a("div", H6e, [
                      V(a("input", {
                        class: "form-check-input",
                        type: "checkbox",
                        role: "switch",
                        id: "switchLoanPaidOff",
                        "onUpdate:modelValue": t[16] || (t[16] = (k) => e.purchaseFacts.loan.isPaidOff = k),
                        disabled: e.isConfirmed(e.ConfirmedPurchaseFacts.LoanPaidOffInfo)
                      }, null, 8, U6e), [
                        [Ue, e.purchaseFacts.loan.isPaidOff]
                      ]),
                      t[43] || (t[43] = a("label", {
                        class: "form-check-label",
                        for: "switchLoanPaidOff"
                      }, [
                        a("span", null, "No"),
                        y("Yes ")
                      ], -1))
                    ])
                  ]),
                  a("div", z6e, [
                    a("input", {
                      type: "checkbox",
                      class: "form-check-input",
                      checked: e.isConfirmed(e.ConfirmedPurchaseFacts.LoanPaidOffInfo),
                      onChange: t[17] || (t[17] = (k) => e.confirm(k, e.ConfirmedPurchaseFacts.LoanPaidOffInfo))
                    }, null, 40, W6e)
                  ]),
                  e.purchaseFacts.loan.isPaidOff ? (p(), h(A, { key: 0 }, [
                    t[44] || (t[44] = a("label", { class: "col-6 col-form-label" }, " Month/Year paid off ", -1)),
                    a("div", G6e, [
                      N(l, {
                        modelValue: e.purchaseFacts.loan.datePaidOff,
                        "onUpdate:modelValue": t[18] || (t[18] = (k) => e.purchaseFacts.loan.datePaidOff = k),
                        locked: e.isConfirmed(e.ConfirmedPurchaseFacts.LoanPaidOffInfo),
                        invalid: e.dateGreater((f = (m = e.purchaseFacts) == null ? void 0 : m.loan) == null ? void 0 : f.date, (b = (v = e.purchaseFacts) == null ? void 0 : v.loan) == null ? void 0 : b.datePaidOff),
                        class: "text-end"
                      }, null, 8, ["modelValue", "locked", "invalid"])
                    ]),
                    e.dateGreater((S = (w = e.purchaseFacts) == null ? void 0 : w.loan) == null ? void 0 : S.date, (T = (I = e.purchaseFacts) == null ? void 0 : I.loan) == null ? void 0 : T.datePaidOff) ? (p(), h("div", Y6e, "Invalid pay off date. Pay off date must be after loan date.")) : P("", !0),
                    t[45] || (t[45] = a("label", { class: "col-6 col-form-label" }, " Additional Investment/Principal Balance at Pay off: ", -1)),
                    a("div", X6e, g(e.currency((x = e.purchaseFacts.loan) == null ? void 0 : x.balancePaidOff, 0, "N/A")), 1)
                  ], 64)) : P("", !0)
                ])
              ])
            ], 64)) : P("", !0)
          ]),
          a("div", q6e, [
            a("div", Q6e, [
              a("div", K6e, [
                t[48] || (t[48] = a("label", { class: "col-7 col-form-label" }, " Was there a previous loan on the property during its time as a rental? ", -1)),
                a("div", Z6e, [
                  a("div", J6e, [
                    V(a("input", {
                      class: "form-check-input",
                      type: "checkbox",
                      role: "switch",
                      id: "switchPreviousLoan",
                      "onUpdate:modelValue": t[19] || (t[19] = (k) => e.purchaseFacts.hasPreviousLoan = k),
                      disabled: e.isConfirmed(e.ConfirmedPurchaseFacts.PreviousLoanInfo)
                    }, null, 8, $6e), [
                      [Ue, e.purchaseFacts.hasPreviousLoan]
                    ]),
                    t[47] || (t[47] = a("label", {
                      class: "form-check-label",
                      for: "switchPreviousLoan"
                    }, [
                      a("span", null, "No"),
                      y("Yes ")
                    ], -1))
                  ])
                ]),
                a("div", _6e, [
                  a("input", {
                    type: "checkbox",
                    class: "form-check-input",
                    checked: e.isConfirmed(e.ConfirmedPurchaseFacts.PreviousLoanInfo),
                    onChange: t[20] || (t[20] = (k) => e.confirm(k, e.ConfirmedPurchaseFacts.PreviousLoanInfo))
                  }, null, 40, eTe)
                ])
              ])
            ]),
            e.purchaseFacts.hasPreviousLoan ? (p(), h("div", tTe, [
              a("div", sTe, [
                t[49] || (t[49] = a("div", { class: "col-sm-12" }, [
                  a("p", { class: "fw-bold" }, "Prior Loan Details:")
                ], -1)),
                t[50] || (t[50] = a("label", { class: "col-6 col-form-label" }, " Original Loan Amount ", -1)),
                a("div", aTe, [
                  N(o, {
                    currency: "",
                    modelValue: e.purchaseFacts.previousLoan.amount,
                    "onUpdate:modelValue": t[21] || (t[21] = (k) => e.purchaseFacts.previousLoan.amount = k),
                    locked: e.isConfirmed(e.ConfirmedPurchaseFacts.PreviousLoanInfo)
                  }, null, 8, ["modelValue", "locked"])
                ]),
                t[51] || (t[51] = a("label", { class: "col-6 col-form-label" }, " Amortization Years ", -1)),
                a("div", nTe, [
                  V(a("select", {
                    class: "form-select text-end locked",
                    "onUpdate:modelValue": t[22] || (t[22] = (k) => e.purchaseFacts.previousLoan.term = k),
                    disabled: e.isConfirmed(e.ConfirmedPurchaseFacts.PreviousLoanInfo)
                  }, [
                    (p(), h(A, null, D(30, (k) => a("option", { value: k }, g(k), 9, oTe)), 64))
                  ], 8, rTe), [
                    [We, e.purchaseFacts.previousLoan.term]
                  ])
                ]),
                t[52] || (t[52] = a("label", { class: "col-6 col-form-label" }, " Loan Date ", -1)),
                a("div", iTe, [
                  N(l, {
                    modelValue: e.purchaseFacts.previousLoan.date,
                    "onUpdate:modelValue": t[23] || (t[23] = (k) => e.purchaseFacts.previousLoan.date = k),
                    locked: e.isConfirmed(e.ConfirmedPurchaseFacts.PreviousLoanInfo),
                    class: "text-end"
                  }, null, 8, ["modelValue", "locked"])
                ]),
                t[53] || (t[53] = a("label", { class: "col-6 col-form-label" }, " Interest Rate % ", -1)),
                a("div", lTe, [
                  N(o, {
                    percent: "",
                    modelValue: e.purchaseFacts.previousLoan.interestRate,
                    "onUpdate:modelValue": t[24] || (t[24] = (k) => e.purchaseFacts.previousLoan.interestRate = k),
                    locked: e.isConfirmed(e.ConfirmedPurchaseFacts.PreviousLoanInfo)
                  }, null, 8, ["modelValue", "locked"])
                ]),
                t[54] || (t[54] = a("label", { class: "col-6 col-form-label" }, " Loan Payment ", -1)),
                a("div", dTe, g(e.currency(e.previousLoanPayment, 0, "N/A")), 1)
              ])
            ])) : P("", !0)
          ])
        ])) : (p(), h("div", JIe, t[28] || (t[28] = [
          a("p", null, "We either have not synced your property's details yet from your property manager's software, or had an issue during syncing. Please try again after a few hours or contact support.", -1)
        ]))),
        a("div", cTe, [
          a("button", {
            type: "button",
            class: "btn btn-lava",
            onClick: t[25] || (t[25] = (...k) => e.save && e.save(...k)),
            disabled: !e.canSave
          }, "Save", 8, uTe)
        ])
      ])
    ])
  ], 512);
}
const wb = /* @__PURE__ */ Ae(YIe, [["render", pTe]]), hTe = me({
  name: "PropertyToolBar",
  components: {
    InvestmentDetails: wb,
    NumericalInput: Aa
  },
  enums: {
    PropertyType: Qa,
    AnalysisMode: Hn,
    TaxMetrics: lv
  },
  props: {
    onBehalfOf: Boolean,
    isShare: Boolean,
    isAnalysisRequest: Boolean,
    usingApiKey: Boolean,
    myMarketplace: Boolean,
    hasChanges: Boolean,
    soldDate: Date,
    investmentDetails: Boolean,
    clientId: Number,
    inPublic: Boolean
  },
  emits: [
    "editInvestment",
    "shareListing",
    "saveFields",
    "update:investmentDetails"
  ],
  data() {
    return {
      showInvestmentDetails: !1,
      email: {
        address: "",
        ccFriend: !1
      },
      isUsingCustomFinancialParams: !1
    };
  },
  computed: {
    //#region Financial History
    canExistingInvestment() {
      var e, t;
      return ((e = this.property) == null ? void 0 : e.propId) > 0 && this.hasExistingInvestmentFeature && !((t = this.access) != null && t.isAnonymous);
    },
    existingInvestmentButtonStyle() {
      var e;
      return {
        exists: this.hasExistingInvestment == !0,
        issue: ((e = this.calculatedResults) == null ? void 0 : e.existingInvestmentNeedsAttention) == !0 || this.requireCalculateAndSave
      };
    },
    existingInvestmentIconStyle() {
      return {
        "fa-light": this.hasExistingInvestment == !1,
        "fa-solid": this.hasExistingInvestment == !0
      };
    },
    //#endregion
    simplifiedViewStyle() {
      return {
        btn: !0,
        "btn-outline-eclipse": this.isAdvancedMode == !0,
        "btn-eclipse": this.isAdvancedMode == !1
      };
    },
    advancedViewStyle() {
      return {
        btn: !0,
        "btn-outline-eclipse": this.isAdvancedMode == !1,
        "btn-eclipse": this.isAdvancedMode == !0
      };
    },
    metricsViewAfterTaxStyle() {
      return {
        btn: !0,
        "btn-outline-eclipse": this.showAfterTax == !1,
        "btn-eclipse": this.showAfterTax == !0
      };
    },
    metricsViewBeforeTaxStyle() {
      return {
        btn: !0,
        "btn-outline-eclipse": this.showAfterTax == !0,
        "btn-eclipse": this.showAfterTax == !1
      };
    },
    //#region Favorite
    showFavorite() {
      return !this.isShare && !this.isAnalysisRequest;
    },
    canFavorite() {
      var e, t;
      return !this.isShare && ((t = (e = this.access) == null ? void 0 : e.properties) == null ? void 0 : t.favoriteProperty) == !0;
    },
    favoriteStyle() {
      var e, t;
      return {
        "fa-light": ((e = this.settings) == null ? void 0 : e.isFavorite) != !0,
        "fa-solid": ((t = this.settings) == null ? void 0 : t.isFavorite) == !0
      };
    },
    //#endregion
    //#region Ignore
    showIgnore() {
      return !this.isShare && !this.isAnalysisRequest;
    },
    canIgnore() {
      var e, t;
      return !this.isShare && ((t = (e = this.access) == null ? void 0 : e.properties) == null ? void 0 : t.favoriteProperty) == !0;
    },
    ignoreButtonStyle() {
      var e;
      return {
        rejected: ((e = this.settings) == null ? void 0 : e.isIgnored) == !0
      };
    },
    ignoreStyle() {
      var e, t;
      return {
        "fa-light": ((e = this.settings) == null ? void 0 : e.isIgnored) != !0,
        "fa-solid": ((t = this.settings) == null ? void 0 : t.isIgnored) == !0
      };
    },
    //#endregion
    //#region Status
    showStatus() {
      var t, s, n, r, i, o;
      if ((s = (t = this.property) == null ? void 0 : t.mlsSource) != null && s.isOffmarket && /sold/i.test((r = (n = this.property) == null ? void 0 : n.mlsSource) == null ? void 0 : r.status) && this.soldDate) {
        var e = ((/* @__PURE__ */ new Date()).getTime() - this.soldDate.getTime()) / (1e3 * 3600 * 24);
        return e <= 90;
      }
      return ((o = (i = this.property) == null ? void 0 : i.mlsSource) == null ? void 0 : o.isOffmarket) != !0;
    },
    statusStyle() {
      var e, t, s, n, r, i, o, l, d, c, u, m;
      return {
        "badge-outline-active": /active/i.test((t = (e = this.property) == null ? void 0 : e.mlsSource) == null ? void 0 : t.status) == !0,
        "badge-outline-pending": ((n = (s = this.property) == null ? void 0 : s.mlsSource) == null ? void 0 : n.status) == "pending",
        "badge-outline-sold": ((i = (r = this.property) == null ? void 0 : r.mlsSource) == null ? void 0 : i.status) == "sold",
        "badge-outline-new": ((l = (o = this.property) == null ? void 0 : o.mlsSource) == null ? void 0 : l.status) == "new",
        "badge-outline-closed": ((c = (d = this.property) == null ? void 0 : d.mlsSource) == null ? void 0 : c.status) == "closed",
        "badge-outline-off-market": ((m = (u = this.property) == null ? void 0 : u.mlsSource) == null ? void 0 : m.status) == "off market"
      };
    },
    //#endregion
    canOtherAnalysisStyles() {
      var e, t, s;
      return ((t = (e = this.access) == null ? void 0 : e.calculator) == null ? void 0 : t.otherAnalysisStyles) == !0 && !((s = this.access) != null && s.isAnonymous);
    },
    showShare() {
      var e;
      return !this.isShare && !this.isAnalysisRequest && !this.onBehalfOf && ((e = this.access) == null ? void 0 : e.isAnonymous) != !0;
    },
    url() {
      return window.location.href;
    },
    propertyType: {
      get() {
        var e;
        return ((e = this.property) == null ? void 0 : e.propertyType) ?? Qa.SingleFamily;
      },
      set(e) {
        e != Qa.SingleFamily && this.calcParams.rentalType == Ut.PadSplit && (this.calcParams.rentalType = Ut.LongTerm), this.property.propertyType = e;
      }
    },
    compareLongTerm: {
      get() {
        var e;
        return (((e = this.calcParams) == null ? void 0 : e.rentalTypeComparisons) & nt.LongTerm) == nt.LongTerm;
      },
      set(e) {
        e ? this.calcParams.rentalTypeComparisons |= nt.LongTerm : this.calcParams.rentalTypeComparisons &= ~nt.LongTerm;
      }
    },
    compareShortTerm: {
      get() {
        var e;
        return (((e = this.calcParams) == null ? void 0 : e.rentalTypeComparisons) & nt.ShortTerm) == nt.ShortTerm;
      },
      set(e) {
        e ? this.calcParams.rentalTypeComparisons |= nt.ShortTerm : this.calcParams.rentalTypeComparisons &= ~nt.ShortTerm;
      }
    },
    comparePadSplit: {
      get() {
        var e;
        return (((e = this.calcParams) == null ? void 0 : e.rentalTypeComparisons) & nt.PadSplit) == nt.PadSplit;
      },
      set(e) {
        e ? this.calcParams.rentalTypeComparisons |= nt.PadSplit : this.calcParams.rentalTypeComparisons &= ~nt.PadSplit;
      }
    },
    //#region Units
    unitCount: {
      get() {
        var e;
        return ((e = this.property) == null ? void 0 : e.unitCount) ?? 0;
      },
      set(e) {
        this.property.unitCount = e;
      }
    },
    requireUnitsMultiFamily() {
      var e;
      return ((e = this.property) == null ? void 0 : e.propertyType) == Qa.MultiFamily;
    },
    requireUnitsCommercial() {
      var e;
      return ((e = this.property) == null ? void 0 : e.propertyType) == Qa.Commercial;
    },
    numberOfUnitsOptionsStyle() {
      return {
        "check-group": this.requireUnitsMultiFamily,
        "gap-2": this.requireUnitsMultiFamily,
        "d-flex": this.requireUnitsMultiFamily,
        "col-lg-9": this.requireUnitsMultiFamily,
        "col-sm-6": this.requireUnitsCommercial
      };
    },
    //#endregion
    isPortfolioInsights() {
      return this.portfolioId != null;
    },
    //#region Featured Property
    canFeature() {
      var e, t, s, n, r;
      return (
        /*!this.inPublic &&*/
        ((e = this.settings) == null ? void 0 : e.featuredType) > 0 || !this.isShare && ((s = (t = this.access) == null ? void 0 : t.properties) == null ? void 0 : s.curate) == !0 && (((r = (n = this.property) == null ? void 0 : n.mlsSource) == null ? void 0 : r.isActive) == !0 || this.myMarketplace == !0)
      );
    },
    featuredForBoth() {
      var e;
      return (((e = this.settings) == null ? void 0 : e.featuredType) & (Ga.Investment | Ga.Residence)) == (Ga.Investment | Ga.Residence);
    },
    featuredResidenceStyle() {
      var t;
      const e = (((t = this.settings) == null ? void 0 : t.featuredType) & Ga.Residence) == Ga.Residence;
      return {
        "fa-solid": e,
        "fa-square-check": e,
        "text-success": e,
        "me-2": !0,
        "fa-light": e != !0,
        "fa-square": e != !0
      };
    },
    featuredInvestmentStyle() {
      var t;
      const e = (((t = this.settings) == null ? void 0 : t.featuredType) & Ga.Investment) == Ga.Investment;
      return {
        "fa-solid": e,
        "fa-square-check": e,
        "text-success": e,
        "me-2": !0,
        "fa-light": e != !0,
        "fa-square": e != !0
      };
    },
    featuredOptionsStyle() {
      var s, n;
      const e = (((s = this.settings) == null ? void 0 : s.featuredType) & Ga.Residence) == Ga.Residence, t = (((n = this.settings) == null ? void 0 : n.featuredType) & Ga.Investment) == Ga.Investment;
      return {
        "fa-stack": !0,
        "feature-one": (e || t) && !this.featuredForBoth,
        "feature-two": this.featuredForBoth
      };
    },
    featuredOptionsFgStyle() {
      var s, n;
      const e = (((s = this.settings) == null ? void 0 : s.featuredType) & Ga.Residence) == Ga.Residence, t = (((n = this.settings) == null ? void 0 : n.featuredType) & Ga.Investment) == Ga.Investment;
      return {
        "fa-light fa-circle-star": !e && !t,
        "fa-solid fa-circle-star fa-inverse text-success": (e || t) && !this.featuredForBoth,
        "fa-solid fa-circle fa-inverse text-success": this.featuredForBoth
      };
    },
    //#endregion
    guarded() {
      return !(this.isAdmin || this.isUser || this.isClient);
    },
    canSaveChanges() {
      return this.access && this.access.isAuthenticated == !0 && window.isIdx != !0;
    },
    dropdownSavestyle() {
      return {
        btn: !0,
        "btn-sm": !0,
        "dropdown-toggle": !0,
        "no-anim": !1,
        "rounded-5": !0,
        disabled: this.calculating || !this.hasChanges,
        "btn-tool": !this.hasChanges,
        "btn-danger": this.hasChanges,
        "btn-blink": this.hasChanges
      };
    },
    ...q(ct, ["account", "isAdvancedMode", "showAfterTax", "accountLoaded"]),
    ...q(ba, ["portfolioId", "portfolioName", "clientName"]),
    ...q(Te, ["access", "isClient", "isAdmin", "isUser", "hasFlipCalculatorFeature", "hasAdvancedCalculatorFeature", "hasRentVsSellFeature", "hasExistingInvestmentFeature", "aclLoaded"]),
    ...q(qe, [
      "calculating",
      "purchaseFacts",
      "calcParams",
      "firstYear",
      "cantAutoPopulate",
      "askIfPreviousLoan",
      "populatingLoans",
      "property",
      "isSaving",
      "settings",
      "hasExistingInvestment",
      "calculatedResults",
      "propertyUnits",
      "requireUnits",
      "totalUnitsAdded",
      "isSyncedExpenses",
      "requireCalculateAndSave",
      "loading",
      "initializing",
      "isActive",
      "isExistingInvestment",
      "sharingProperty",
      "shareUrl"
    ]),
    ...at(Te, qe, ba)
  },
  watch: {
    "calcParams.investmentStrategy"(e) {
      console.log(`${this.$options.name}.watch.calcParams.investmentStrategy`, e, this.loading, this.initializing), !this.initializing && this.changeInvestmentStrategy(e);
    },
    unitCount(e, t) {
      switch (e) {
        case 2:
          this.totalUnitsAdded != 2 && (this.propertyUnits && (this.propertyUnits.length = 0), this.propertyStore.addUnit({ name: "Unit 1", quantity: 1, rentalRate: 0, strRentalRate: 0 }), this.propertyStore.addUnit({ name: "Unit 2", quantity: 1, rentalRate: 0, strRentalRate: 0 }));
          break;
        case 3:
          this.totalUnitsAdded != 3 && (this.propertyUnits && (this.propertyUnits.length = 0), this.propertyStore.addUnit({ name: "Unit 1", quantity: 1, rentalRate: 0, strRentalRate: 0 }), this.propertyStore.addUnit({ name: "Unit 2", quantity: 1, rentalRate: 0, strRentalRate: 0 }), this.propertyStore.addUnit({ name: "Unit 3", quantity: 1, rentalRate: 0, strRentalRate: 0 }));
          break;
        case 4:
          this.totalUnitsAdded != 4 && (this.propertyUnits && (this.propertyUnits.length = 0), this.propertyStore.addUnit({ name: "Unit 1", quantity: 1, rentalRate: 0, strRentalRate: 0 }), this.propertyStore.addUnit({ name: "Unit 2", quantity: 1, rentalRate: 0, strRentalRate: 0 }), this.propertyStore.addUnit({ name: "Unit 3", quantity: 1, rentalRate: 0, strRentalRate: 0 }), this.propertyStore.addUnit({ name: "Unit 4", quantity: 1, rentalRate: 0, strRentalRate: 0 }));
          break;
      }
    },
    investmentDetails(e) {
      this.showInvestmentDetails = e;
    },
    showInvestmentDetails(e) {
      this.$emit("update:investmentDetails", e);
    }
  },
  methods: {
    async changeInvestmentStrategy(e) {
      switch (e) {
        case $n.ExistingInvestment:
          this.purchaseFacts || await this.propertyStore.initPurchaseFacts(), this.propertyStore.setRequireCalculateAndSave(!0);
          break;
        case $n.RentVsSell:
          this.purchaseFacts || await this.propertyStore.initPurchaseFacts(), this.purchaseFacts.ignoreHistoricalOperatingIncome = !0, this.purchaseFacts.firstYearAsRental = Et, this.purchaseFacts.firstYearToAnalyze = Et, this.propertyStore.setRequireCalculateAndSave(!0);
          break;
        case $n.Flip:
          this.propertyStore.calculate();
          break;
        default:
          this.propertyStore.calculate();
          break;
      }
    },
    async favoriteListing() {
      try {
        const e = await this.propertyStore.favoriteListing();
        wt(e);
      } catch (e) {
        Se(e);
      }
    },
    async ignoreListing() {
      try {
        const e = await this.propertyStore.ignoreListing();
        wt(e);
      } catch (e) {
        Se(e);
      }
    },
    async featureProperty(e) {
      try {
        const t = await this.propertyStore.featureProperty(e);
        wt(t);
      } catch (t) {
        Se(t);
      }
    },
    editInvestment() {
      this.$emit("editInvestment");
    },
    async saveShareListing(e = !1) {
      var t;
      await this.shareListing(e), (t = bootstrap.Modal.getOrCreateInstance(this.$refs.modalShareChange)) == null || t.hide();
    },
    async shareListing(e = !1) {
      var t;
      try {
        await this.propertyStore.shareListing(e, this.email.address), wt("Property share has been sent!");
      } catch (s) {
        Se(s);
      }
      (t = bootstrap.Modal.getOrCreateInstance(this.$refs.modalShare)) == null || t.hide();
    },
    async saveFields() {
      var e, t, s, n;
      (e = bootstrap.Dropdown.getOrCreateInstance(this.$refs.dropdownDiscard)) == null || e.hide(), (t = this.$parent) != null && t.saveFields ? await this.$parent.saveFields() : (n = (s = this.$parent) == null ? void 0 : s.$parent) != null && n.saveFields && await this.$parent.$parent.saveFields();
    },
    //#region PDF
    async buildPDF(e = !1) {
      var t, s, n;
      try {
        if (e === !1 && this.hasChanges) {
          (t = bootstrap.Modal.getOrCreateInstance(this.$refs.modalPDF)) == null || t.show();
          return;
        }
        await this.propertyStore.calculate(!0);
        let r;
        if (this.portfolioId ? r = await W.api.pdf.portfolioPropertyAnalysis(this.property.propId, this.portfolioId, this.propertyStore.isShortTerm) : (s = this.property.mlsSource) != null && s.source && ((n = this.property.mlsSource) != null && n.number) ? r = await W.api.pdf.propertyMls(this.property.mlsSource.source, this.property.mlsSource.number, this.propertyStore.isShortTerm) : r = await W.api.pdf.property(this.property.propId, this.propertyStore.isShortTerm), r.data.status != de.Success)
          throw new Error(r.data.message);
        window.open(r.data.location, "_blank");
      } catch (r) {
        Se(r.message);
      }
    },
    async saveViewPDF() {
      var e;
      await this.saveFields(), (e = bootstrap.Modal.getOrCreateInstance(this.$refs.modalPDF)) == null || e.hide(), await this.buildPDF();
    },
    //#endregion
    saveAnalysisStyleChanges() {
      var e;
      try {
        if (Zt.clearModelStateErrors(this.$refs.modalAnalysisStyle), this.propertyType == Qa.MultiFamily && this.unitCount <= 0)
          throw new Zt("Invalid number of units.", {
            propertyTypeMultiFamily: ["Please choose the number of units."]
          });
        if (this.propertyType == Qa.Commercial && this.unitCount <= 0)
          throw new Zt("Invalid number of units.", {
            propertyTypeCommercial: ["Number of units must be greater than 0."]
          });
        (e = bootstrap.Modal.getOrCreateInstance(this.$refs.modalAnalysisStyle)) == null || e.hide();
      } catch (t) {
        (!Zt.isModelStateException(t) || !t.showFormErrors(this.$refs.modalAnalysisStyle)) && Se(t);
      }
    },
    async showDialogCopyLink() {
      var e;
      this.shareUrl || await this.propertyStore.createShareUrl(), (e = bootstrap.Modal.getOrCreateInstance(this.$refs.dialogCopyLink)) == null || e.show();
    },
    async copyShareUrl() {
      await navigator.clipboard.writeText(this.shareUrl);
    },
    showConfigurationDialog() {
      var e;
      (e = bootstrap.Modal.getOrCreateInstance(this.$refs.modalAnalysisStyle)) == null || e.show();
    },
    async discardFields() {
      var e;
      (e = bootstrap.Dropdown.getOrCreateInstance(this.$refs.dropdownDiscard)) == null || e.hide(), this.discard(), await this.propertyStore.calculate();
    },
    async discard() {
      var e;
      this.propertyStore.discarded = !0, await this.propertyStore.resetListing(), ((e = this.calcParams) == null ? void 0 : e.monthlyRentalYear1) > 1 && (this.calcParams.monthlyRentalYear1 = this.propertyStore.monthlyRentalsFirstOriginal);
    }
  }
}), mTe = {
  key: 0,
  class: "toolbar shadow position-relative slide-down"
}, fTe = { class: "container-xl py-2 py-md-3" }, gTe = { class: "row" }, vTe = { class: "col d-lg-none d-flex flex-row justify-content-between toolbar-mobile gap-md-2" }, yTe = { class: "dropdown dropdown-save" }, bTe = { class: "d-none d-sm-inline-block" }, ATe = { class: "dropdown-menu shadow" }, wTe = { key: 0 }, CTe = {
  key: 0,
  class: "dropdown"
}, STe = { class: "dropdown-menu shadow" }, PTe = { key: 0 }, kTe = ["disabled"], ETe = {
  key: 1,
  "data-bs-toggle": "modal",
  "data-bs-target": "#modalFavorite",
  class: "dropdown-item"
}, ITe = { key: 1 }, TTe = ["disabled"], OTe = {
  key: 1,
  "data-bs-toggle": "modal",
  "data-bs-target": "#modalIgnore",
  class: "dropdown-item"
}, RTe = { key: 2 }, LTe = {
  key: 1,
  class: "dropdown me-sm-auto"
}, BTe = ["disabled"], MTe = { class: "dropdown-menu shadow" }, xTe = ["disabled"], FTe = ["disabled"], VTe = ["disabled"], DTe = { key: 0 }, NTe = ["disabled"], jTe = { class: "d-flex list-inline mb-0 align-items-center" }, HTe = {
  key: 0,
  class: "list-inline-item"
}, UTe = {
  key: 1,
  class: "list-inline-item"
}, zTe = {
  key: 2,
  class: "list-inline-item d-flex align-items-center list-badge-status"
}, WTe = {
  key: 2,
  class: "dropdown ms-sm-auto"
}, GTe = ["disabled"], YTe = { class: "dropdown-menu shadow" }, XTe = ["data-bs-target"], qTe = ["href"], QTe = ["href"], KTe = ["disabled"], ZTe = ["disabled"], JTe = { class: "col d-flex flex-row justify-content-between d-none d-lg-flex" }, $Te = { key: 0 }, _Te = { class: "actions d-flex flex-row mb-2 mb-md-0 justify-content-center justify-content-lg-start gap-2" }, e9e = { class: "dropdown dropdown-save" }, t9e = { class: "dropdown-menu shadow" }, s9e = { key: 0 }, a9e = ["disabled"], n9e = ["disabled"], r9e = ["disabled"], o9e = ["disabled"], i9e = { key: 1 }, l9e = { "aria-label": "breadcrumb" }, d9e = { class: "breadcrumb mb-0 justify-content-center justify-content-lg-start" }, c9e = {
  class: "breadcrumb-item",
  title: "Portfolio Insight's Clients"
}, u9e = {
  class: "breadcrumb-item",
  title: "Client"
}, p9e = {
  class: "breadcrumb-item",
  title: "Portfolio"
}, h9e = { class: "breadcrumb-item active" }, m9e = {
  class: "breadcrumb-item",
  title: "Portfolio Insight's Clients"
}, f9e = {
  class: "breadcrumb-item",
  title: "Portfolio"
}, g9e = { class: "breadcrumb-item active" }, v9e = { class: "special d-flex flex-row justify-content-end align-items-center gap-2" }, y9e = ["disabled"], b9e = ["disabled"], A9e = ["disabled"], w9e = ["disabled"], C9e = {
  key: 2,
  class: "dropdown"
}, S9e = ["disabled"], P9e = {
  key: 0,
  class: "fa-solid fa-star fa-stack-1x text-warning",
  style: { "font-size": ".5em" }
}, k9e = { class: "dropdown-menu shadow" }, E9e = ["disabled"], I9e = ["disabled"], T9e = {
  key: 1,
  class: "dropdown"
}, O9e = { class: "dropdown-menu shadow dropdown-menu-end" }, R9e = ["data-bs-target", "disabled"], L9e = ["href"], B9e = ["href"], M9e = ["disabled"], x9e = ["disabled"], F9e = {
  class: "modal fade",
  ref: "modalExistingInvestmentGuard",
  id: "modalExistingInvestmentGuard",
  tabindex: "-1",
  "aria-labelledby": "modalExistingInvestmentGuardLabel",
  "aria-hidden": "true"
}, V9e = {
  class: "modal fade",
  ref: "modalAnalysisStyle",
  id: "modalAnalysisStyle",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false",
  tabindex: "-1",
  "aria-labelledby": "modalAnalysisStyleLabel",
  "aria-hidden": "true"
}, D9e = { class: "modal-dialog modal-lg modal-dialog-centered" }, N9e = { class: "modal-content bg-gradient-alphabet rounded" }, j9e = { class: "modal-header border-0 pb-0" }, H9e = ["disabled"], U9e = {
  key: 0,
  class: "modal-body d-flex flex-column gap-2"
}, z9e = { class: "bg-white bg-opacity-50 rounded p-3" }, W9e = { class: "row" }, G9e = { class: "col-lg-9 d-flex gap-2 check-group" }, Y9e = ["value", "disabled"], X9e = ["value", "disabled"], q9e = { class: "bg-white bg-opacity-50 rounded p-3" }, Q9e = { class: "row g-lg-3" }, K9e = { class: "col-lg-9 d-flex gap-2 check-group" }, Z9e = ["value", "disabled"], J9e = ["value", "disabled"], $9e = { class: "bg-white bg-opacity-50 rounded p-3" }, _9e = { class: "row g-lg-3" }, eOe = {
  key: 0,
  class: "col-lg-12"
}, tOe = { class: "col-lg-5" }, sOe = { class: "mb-3" }, aOe = { class: "d-flex gap-3 check-group" }, nOe = ["disabled"], rOe = ["disabled"], oOe = { class: "d-none d-lg-flex gap-2 check-group" }, iOe = ["disabled"], lOe = ["disabled"], dOe = { class: "bg-white bg-opacity-50 rounded p-3" }, cOe = { class: "row g-lg-3" }, uOe = { class: "col-lg-9" }, pOe = { class: "d-flex gap-3 check-group" }, hOe = ["value", "disabled"], mOe = ["value", "disabled"], fOe = ["value", "disabled"], gOe = {
  key: 0,
  class: "col-12"
}, vOe = { class: "row" }, yOe = ["disabled"], bOe = ["disabled"], AOe = ["disabled"], wOe = ["disabled"], COe = {
  key: 1,
  class: "bg-white bg-opacity-50 rounded p-3"
}, SOe = { class: "row g-lg-3" }, POe = { class: "col-lg-9 d-flex gap-3 check-group" }, kOe = ["disabled"], EOe = ["disabled"], IOe = ["disabled"], TOe = { class: "col-lg-7 d-flex gap-3 align-items-center" }, OOe = {
  key: 0,
  class: "form-check form-check-inline"
}, ROe = ["disabled"], LOe = {
  key: 1,
  class: "form-check form-check-inline"
}, BOe = ["disabled"], MOe = {
  key: 2,
  class: "form-check form-check-inline"
}, xOe = ["disabled"], FOe = { class: "modal-footer border-0 pt-0" }, VOe = ["disabled"], DOe = {
  key: 0,
  class: "modal-footer text-center justify-content-center bg-accentgreenblue text-white"
}, NOe = {
  class: "modal fade",
  ref: "modalShareChange",
  id: "modalShareChange",
  tabindex: "-1",
  "aria-labelledby": "ModalShareChangeLabel",
  "aria-hidden": "true"
}, jOe = { class: "modal-dialog modal-dialog-centered" }, HOe = { class: "modal-content bg-gradient-alphabet rounded" }, UOe = { class: "modal-body" }, zOe = { class: "card border p-3 mb-3" }, WOe = { class: "form-check mb-3" }, GOe = ["disabled"], YOe = { class: "friend-email" }, XOe = { class: "card-deck" }, qOe = { class: "card border" }, QOe = { class: "card-body" }, KOe = ["disabled"], ZOe = { class: "card border" }, JOe = { class: "card-body d-flex flex-column" }, $Oe = ["disabled"], _Oe = {
  class: "modal fade",
  ref: "modalShare",
  id: "modalShare",
  tabindex: "-1",
  "aria-labelledby": "ModalShareLabel",
  "aria-hidden": "true"
}, e7e = { class: "modal-dialog modal-dialog-centered" }, t7e = { class: "modal-content bg-gradient-alphabet rounded" }, s7e = { class: "modal-body" }, a7e = { class: "form-check mb-2" }, n7e = ["disabled"], r7e = { class: "friend-email" }, o7e = { class: "text-end" }, i7e = ["disabled"], l7e = {
  class: "modal fade",
  ref: "modalPDF",
  id: "modalPDF",
  tabindex: "-1",
  "aria-labelledby": "ModalPDFLabel",
  "aria-hidden": "true"
}, d7e = { class: "modal-dialog modal-dialog-centered" }, c7e = { class: "modal-content bg-gradient-alphabet rounded" }, u7e = { class: "modal-body" }, p7e = { class: "card-deck" }, h7e = { class: "card bg-white bg-opacity-50 border-0" }, m7e = { class: "card-body" }, f7e = { class: "card bg-white bg-opacity-50 border-0" }, g7e = { class: "card-body d-flex flex-column" }, v7e = {
  class: "modal fade",
  ref: "dialogCopyLink",
  id: "dialogCopyLink",
  tabindex: "-1",
  "aria-labelledby": "dialogCopyLinkLabel",
  "aria-hidden": "true"
}, y7e = { class: "modal-dialog modal-dialog-centered" }, b7e = { class: "modal-content bg-gradient-alphabet rounded" }, A7e = { class: "modal-body p-4" }, w7e = { class: "d-flex flex-row bg-white border rounded p-2 align-items-center" };
function C7e(e, t, s, n, r, i) {
  var d, c, u;
  const o = pe("router-link"), l = pe("investment-details");
  return p(), h(A, null, [
    N(ks, {
      name: "slide",
      mode: "out-in"
    }, {
      default: ve(() => {
        var m, f, v, b, w, S, I, T, x, k, C, O, E, B;
        return [
          e.calcParams && e.property ? (p(), h("div", mTe, [
            a("div", fTe, [
              a("div", gTe, [
                a("div", vTe, [
                  a("div", yTe, [
                    a("button", {
                      type: "button",
                      "data-bs-toggle": "dropdown",
                      "data-bs-auto-close": "true",
                      "aria-expanded": "false",
                      class: z(e.dropdownSavestyle),
                      ref: "dropdownDiscard"
                    }, [
                      t[55] || (t[55] = a("i", { class: "fa-light fa-floppy-disk me-1 d-sm-none" }, null, -1)),
                      a("span", bTe, [
                        e.hasChanges ? (p(), h(A, { key: 0 }, [
                          y(" Unsaved Changes ")
                        ], 64)) : (p(), h(A, { key: 1 }, [
                          y(" Save ")
                        ], 64))
                      ])
                    ], 2),
                    a("ul", ATe, [
                      e.canSaveChanges ? (p(), h("li", wTe, [
                        a("button", {
                          type: "button",
                          class: "saveFields dropdown-item",
                          onClick: t[0] || (t[0] = (...M) => e.saveFields && e.saveFields(...M))
                        }, t[56] || (t[56] = [
                          a("i", { class: "fa-light fa-floppy-disk me-2" }, null, -1),
                          y("Save Edits")
                        ]))
                      ])) : P("", !0),
                      t[57] || (t[57] = a("li", { class: "dropdown-divider" }, null, -1)),
                      a("li", null, [
                        a("button", {
                          type: "button",
                          class: "dropdown-item",
                          onClick: t[1] || (t[1] = (...M) => e.discardFields && e.discardFields(...M))
                        }, "Discard Edits")
                      ])
                    ])
                  ]),
                  !e.onBehalfOf || e.showFavorite && !e.usingApiKey || e.showIgnore && !e.usingApiKey || e.canFeature && !e.usingApiKey ? (p(), h("div", CTe, [
                    t[63] || (t[63] = a("button", {
                      class: "btn btn-tool btn-sm dropdown-toggle",
                      type: "button",
                      "data-bs-toggle": "dropdown",
                      "aria-expanded": "false"
                    }, [
                      a("i", { class: "fa-light fa-heart me-1 d-sm-none" }),
                      a("span", { class: "d-none d-sm-inline-block" }, "Actions")
                    ], -1)),
                    a("ul", STe, [
                      e.showFavorite && !e.usingApiKey ? (p(), h("li", PTe, [
                        e.canFavorite ? (p(), h("button", {
                          key: 0,
                          onClick: t[2] || (t[2] = (...M) => e.favoriteListing && e.favoriteListing(...M)),
                          class: "mlse-save dropdown-item",
                          disabled: e.isSaving
                        }, [
                          a("i", {
                            class: z(["fa-heart me-2", e.favoriteStyle])
                          }, null, 2),
                          t[58] || (t[58] = y(" Favorite "))
                        ], 8, kTe)) : (p(), h("button", ETe, t[59] || (t[59] = [
                          a("i", { class: "fa-light fa-heart me-2" }, null, -1),
                          y("Favorite ")
                        ])))
                      ])) : P("", !0),
                      e.showIgnore && !e.usingApiKey ? (p(), h("li", ITe, [
                        e.canIgnore ? (p(), h("button", {
                          key: 0,
                          onClick: t[3] || (t[3] = (...M) => e.ignoreListing && e.ignoreListing(...M)),
                          class: z(["mls-ignore dropdown-item", e.ignoreButtonStyle]),
                          disabled: e.isSaving || e.guarded
                        }, [
                          a("i", {
                            class: z(["fa-thumbs-down me-2", e.ignoreStyle])
                          }, null, 2),
                          t[60] || (t[60] = y("Ignore "))
                        ], 10, TTe)) : (p(), h("button", OTe, t[61] || (t[61] = [
                          a("i", { class: "fa-light fa-thumbs-down me-2" }, null, -1),
                          y("Ignore ")
                        ])))
                      ])) : P("", !0),
                      e.canFeature && !e.usingApiKey ? (p(), h("li", RTe, [
                        a("button", {
                          type: "button",
                          onClick: t[4] || (t[4] = (...M) => e.featureProperty && e.featureProperty(...M)),
                          class: "dropdown-item"
                        }, t[62] || (t[62] = [
                          a("i", { class: "fa-light fa-circle-star me-2" }, null, -1),
                          y("Feature ")
                        ]))
                      ])) : P("", !0)
                    ])
                  ])) : P("", !0),
                  e.isClient != !0 ? (p(), h("div", LTe, [
                    a("button", {
                      class: "btn btn-tool btn-sm dropdown-toggle",
                      type: "button",
                      "data-bs-toggle": "dropdown",
                      "aria-expanded": "false",
                      disabled: e.calculating
                    }, t[64] || (t[64] = [
                      a("i", { class: "fa-light fa-screwdriver-wrench me-1 d-sm-none" }, null, -1),
                      a("span", { class: "d-none d-sm-inline-block" }, "Tools", -1)
                    ]), 8, BTe),
                    a("ul", MTe, [
                      a("li", null, [
                        a("button", {
                          type: "button",
                          class: "dropdown-item",
                          "data-bs-toggle": "modal",
                          "data-bs-target": "#modalAnalysisStyle",
                          disabled: e.calculating
                        }, t[65] || (t[65] = [
                          a("i", { class: "fa-light fa-cog me-2" }, null, -1),
                          y("Configuration ")
                        ]), 8, xTe)
                      ]),
                      e.isExistingInvestment ? (p(), h(A, { key: 0 }, [
                        a("li", null, [
                          e.canExistingInvestment || e.hasRentVsSellFeature ? (p(), h("button", {
                            key: 0,
                            type: "button",
                            onClick: t[5] || (t[5] = (...M) => e.editInvestment && e.editInvestment(...M)),
                            class: z(["dropdown-item", e.existingInvestmentButtonStyle]),
                            disabled: e.calculating || e.guarded
                          }, [
                            a("i", {
                              class: z(["fa-circle-dollar me-2", e.existingInvestmentIconStyle])
                            }, null, 2),
                            t[66] || (t[66] = y("Financial History "))
                          ], 10, FTe)) : (p(), h("button", {
                            key: 1,
                            "data-bs-toggle": "modal",
                            "data-bs-target": "#modalExistingInvestmentGuard",
                            class: "dropdown-item",
                            disabled: e.calculating || e.guarded
                          }, t[67] || (t[67] = [
                            a("i", { class: "fa-light fa-circle-dollar me-2" }, null, -1),
                            y("Financial History ")
                          ]), 8, VTe))
                        ]),
                        e.isSyncedExpenses ? (p(), h("li", DTe, [
                          a("button", {
                            type: "button",
                            class: "dropdown-item",
                            onClick: t[6] || (t[6] = (M) => e.showInvestmentDetails = !e.showInvestmentDetails),
                            disabled: e.calculating || e.guarded
                          }, t[68] || (t[68] = [
                            a("i", { class: "fa-light fa-chart-mixed-up-circle-dollar me-2" }, null, -1),
                            y("Investment Details ")
                          ]), 8, NTe)
                        ])) : P("", !0)
                      ], 64)) : P("", !0)
                    ])
                  ])) : P("", !0),
                  a("ul", jTe, [
                    (f = (m = e.property) == null ? void 0 : m.mlsSource) != null && f.isActiveMarketplaceListing ? (p(), h("li", HTe, t[69] || (t[69] = [
                      a("span", { class: "badge rounded-pill fw-normal badge-marketplace" }, [
                        a("i", { class: "fa-light fa-house-flag" })
                      ], -1)
                    ]))) : P("", !0),
                    (b = (v = e.property) == null ? void 0 : v.mlsSource) != null && b.occupied ? (p(), h("li", UTe, t[70] || (t[70] = [
                      a("span", { class: "badge rounded-pill fw-normal badge-tenant" }, [
                        a("i", { class: "fa-light fa-house-chimney-user" })
                      ], -1)
                    ]))) : P("", !0),
                    e.showStatus ? (p(), h("li", zTe, [
                      a("span", {
                        class: z(["badge rounded-pill fw-normal badge-outline text-uppercase text-truncate", e.statusStyle])
                      }, g((S = (w = e.property) == null ? void 0 : w.mlsSource) == null ? void 0 : S.status), 3)
                    ])) : P("", !0)
                  ]),
                  e.showShare ? (p(), h("div", WTe, [
                    a("button", {
                      class: "btn btn-tool btn-sm dropdown-toggle btn-share",
                      type: "button",
                      "data-bs-toggle": "dropdown",
                      "aria-expanded": "false",
                      disabled: e.guarded
                    }, t[71] || (t[71] = [
                      a("i", { class: "fa-light fa-share-nodes me-1 d-sm-none" }, null, -1),
                      a("span", { class: "d-none d-md-inline-block" }, "Share", -1)
                    ]), 8, GTe),
                    a("ul", YTe, [
                      a("li", null, [
                        a("button", {
                          type: "button",
                          "data-bs-target": e.hasChanges ? "#modalShareChange" : "#modalShare",
                          "data-bs-toggle": "modal",
                          class: "dropdown-item"
                        }, t[72] || (t[72] = [
                          a("i", { class: "fa-light fa-envelope me-2" }, null, -1),
                          y("Email ")
                        ]), 8, XTe)
                      ]),
                      a("li", null, [
                        a("button", {
                          type: "button",
                          onClick: t[7] || (t[7] = (...M) => e.showDialogCopyLink && e.showDialogCopyLink(...M)),
                          class: "dropdown-item"
                        }, t[73] || (t[73] = [
                          a("i", { class: "fa-light fa-copy me-2" }, null, -1),
                          y("Copy Link ")
                        ]))
                      ]),
                      t[76] || (t[76] = a("li", null, [
                        a("hr", { class: "dropdown-divider" })
                      ], -1)),
                      t[77] || (t[77] = a("li", null, [
                        a("a", {
                          class: "dropdown-item",
                          href: "https://twitter.com/intent/tweet?text=Awesome!",
                          target: "_blank"
                        }, [
                          a("i", { class: "fa-brands fa-x-twitter me-2" }),
                          y("Twitter ")
                        ])
                      ], -1)),
                      a("li", null, [
                        a("a", {
                          class: "dropdown-item",
                          href: "https://www.linkedin.com/sharing/share-offsite/?url=" + e.url + "&title=Check out this property on Rescover!",
                          target: "_blank"
                        }, t[74] || (t[74] = [
                          a("i", { class: "fa-brands fa-linkedin-in text-linkedin me-2" }, null, -1),
                          y("Linkedin ")
                        ]), 8, qTe)
                      ]),
                      a("li", null, [
                        a("a", {
                          class: "dropdown-item",
                          href: "https://www.facebook.com/sharer/sharer.php?u=" + e.url,
                          target: "_blank"
                        }, t[75] || (t[75] = [
                          a("i", { class: "fa-brands fa-facebook-f text-facebook me-2" }, null, -1),
                          y("Facebook ")
                        ]), 8, QTe)
                      ])
                    ])
                  ])) : P("", !0),
                  (T = (I = e.access) == null ? void 0 : I.properties) != null && T.pdf && !e.isPortfolioInsights ? (p(), h("button", {
                    key: 3,
                    class: "tag btn btn-sm btn-danger rounded-pill btnPDFview",
                    onClick: t[8] || (t[8] = (M) => e.buildPDF()),
                    disabled: e.calculating
                  }, t[78] || (t[78] = [
                    a("i", { class: "fa-light fa-file-pdf" }, null, -1)
                  ]), 8, KTe)) : e.isPortfolioInsights ? P("", !0) : (p(), h("button", {
                    key: 4,
                    "data-bs-toggle": "modal",
                    "data-bs-target": "#modalPdfCta",
                    class: "btn btn-sm btn-danger rounded-pill",
                    disabled: e.calculating
                  }, t[79] || (t[79] = [
                    a("i", { class: "fa-light fa-file-pdf" }, null, -1)
                  ]), 8, ZTe))
                ]),
                a("div", JTe, [
                  e.isPortfolioInsights ? (p(), h("div", i9e, [
                    a("nav", l9e, [
                      a("ol", d9e, [
                        e.clientId ? (p(), h(A, { key: 0 }, [
                          a("li", c9e, [
                            N(o, { name: "portfolio-insights-clients" }, {
                              default: ve(() => t[87] || (t[87] = [
                                a("img", {
                                  src: "https://cdn03.rescover.com/content/images/icons/portfolio-insights.svg",
                                  height: "16",
                                  class: "svg-black me-1",
                                  alt: "Portfolio Insights"
                                }, null, -1),
                                y(" Portfolio Insights ")
                              ])),
                              _: 1,
                              __: [87]
                            })
                          ]),
                          a("li", u9e, [
                            N(o, {
                              name: "PI-portfolios",
                              params: { clientId: e.clientId }
                            }, {
                              default: ve(() => [
                                t[88] || (t[88] = a("i", { class: "fa-duotone fa-solid fa-chart-waterfall me-1" }, null, -1)),
                                y(g(e.clientName), 1)
                              ]),
                              _: 1,
                              __: [88]
                            }, 8, ["params"])
                          ]),
                          a("li", p9e, [
                            N(o, {
                              name: "PI-client-portfolio",
                              params: { clientId: e.clientId, portfolioId: e.portfolioId }
                            }, {
                              default: ve(() => [
                                t[89] || (t[89] = a("i", { class: "fa-duotone fa-solid fa-house-building me-1" }, null, -1)),
                                y(g(e.portfolioName), 1)
                              ]),
                              _: 1,
                              __: [89]
                            }, 8, ["params"])
                          ]),
                          a("li", h9e, g(((k = (x = e.property) == null ? void 0 : x.address) == null ? void 0 : k.street) ?? "-"), 1)
                        ], 64)) : (p(), h(A, { key: 1 }, [
                          a("li", m9e, [
                            N(o, { name: "folio-my-investments-portfolios" }, {
                              default: ve(() => t[90] || (t[90] = [
                                a("img", {
                                  src: "https://cdn03.rescover.com/content/images/icons/portfolio-insights.svg",
                                  height: "16",
                                  class: "svg-black me-1",
                                  alt: "Portfolio Insights"
                                }, null, -1),
                                y(" My Portfolios ")
                              ])),
                              _: 1,
                              __: [90]
                            })
                          ]),
                          a("li", f9e, [
                            N(o, {
                              name: "folio-my-investments-portfolio",
                              params: { portfolioId: e.portfolioId }
                            }, {
                              default: ve(() => [
                                t[91] || (t[91] = a("i", { class: "fa-duotone fa-solid fa-house-building me-1" }, null, -1)),
                                y(g(e.portfolioName), 1)
                              ]),
                              _: 1,
                              __: [91]
                            }, 8, ["params"])
                          ]),
                          a("li", g9e, g(((O = (C = e.property) == null ? void 0 : C.address) == null ? void 0 : O.street) ?? "-"), 1)
                        ], 64))
                      ])
                    ])
                  ])) : (p(), h("div", $Te, [
                    a("div", _Te, [
                      a("div", e9e, [
                        a("button", {
                          type: "button",
                          "data-bs-toggle": "dropdown",
                          "data-bs-auto-close": "true",
                          "aria-expanded": "false",
                          class: z(e.dropdownSavestyle),
                          ref: "dropdownDiscard"
                        }, [
                          e.hasChanges ? (p(), h(A, { key: 0 }, [
                            y(" Unsaved Changes ")
                          ], 64)) : (p(), h(A, { key: 1 }, [
                            y(" Save ")
                          ], 64))
                        ], 2),
                        a("ul", t9e, [
                          e.canSaveChanges ? (p(), h("li", s9e, [
                            a("button", {
                              type: "button",
                              class: "saveFields dropdown-item",
                              onClick: t[9] || (t[9] = (...M) => e.saveFields && e.saveFields(...M))
                            }, t[80] || (t[80] = [
                              a("i", { class: "fa-light fa-floppy-disk me-2" }, null, -1),
                              y("Save Edits")
                            ]))
                          ])) : P("", !0),
                          t[81] || (t[81] = a("li", { class: "dropdown-divider" }, null, -1)),
                          a("li", null, [
                            a("button", {
                              type: "button",
                              class: "dropdown-item",
                              onClick: t[10] || (t[10] = (...M) => e.discardFields && e.discardFields(...M))
                            }, "Discard Edits")
                          ])
                        ])
                      ]),
                      a("button", {
                        type: "button",
                        onClick: t[11] || (t[11] = (...M) => e.showConfigurationDialog && e.showConfigurationDialog(...M)),
                        class: "btn btn-sm btn-tool rounded-pill",
                        "data-bs-togglef": "modal",
                        "data-bs-targetf": "#modalAnalysisStyle",
                        disabled: e.calculating
                      }, t[82] || (t[82] = [
                        a("i", { class: "fa-light fa-cog" }, null, -1),
                        a("span", { class: "ms-2" }, "Configuration", -1)
                      ]), 8, a9e),
                      e.isExistingInvestment ? (p(), h(A, { key: 0 }, [
                        e.canExistingInvestment || e.hasRentVsSellFeature ? (p(), h("button", {
                          key: 0,
                          type: "button",
                          onClick: t[12] || (t[12] = (...M) => e.editInvestment && e.editInvestment(...M)),
                          class: z(["btn btn-sm btn-tool rounded-pill btn-existing-investment", e.existingInvestmentButtonStyle]),
                          disabled: e.calculating || e.guarded
                        }, [
                          a("i", {
                            class: z(["fa-circle-dollar", e.existingInvestmentIconStyle])
                          }, null, 2),
                          t[83] || (t[83] = a("span", { class: "d-none d-lg-inline-block ms-2" }, "Financial", -1)),
                          t[84] || (t[84] = a("span", { class: "d-none d-xxl-inline-block ms-1" }, "History", -1))
                        ], 10, n9e)) : (p(), h("button", {
                          key: 1,
                          "data-bs-toggle": "modal",
                          "data-bs-target": "#modalExistingInvestmentGuard",
                          class: "btn btn-sm btn-tool",
                          disabled: e.calculating || e.guarded
                        }, t[85] || (t[85] = [
                          a("i", { class: "fa-light fa-circle-dollar" }, null, -1),
                          a("span", { class: "d-none d-lg-inline-block ms-2" }, "Financial", -1),
                          a("span", { class: "d-none d-xxl-inline-block ms-1" }, "History", -1)
                        ]), 8, r9e)),
                        e.isSyncedExpenses ? (p(), h("button", {
                          key: 2,
                          type: "button",
                          class: "btn btn-sm btn-tool btn-investment-details",
                          onClick: t[13] || (t[13] = (M) => e.showInvestmentDetails = !e.showInvestmentDetails),
                          disabled: e.calculating || e.guarded
                        }, t[86] || (t[86] = [
                          a("i", { class: "fa-light fa-chart-mixed-up-circle-dollar" }, null, -1),
                          a("span", { class: "d-none d-lg-inline-block ms-2" }, "Investment Details", -1)
                        ]), 8, o9e)) : P("", !0)
                      ], 64)) : P("", !0)
                    ])
                  ])),
                  a("div", null, [
                    a("div", v9e, [
                      e.isPortfolioInsights ? P("", !0) : (p(), h(A, { key: 0 }, [
                        !e.onBehalfOf || e.showFavorite && !e.usingApiKey || e.showIgnore && !e.usingApiKey || e.canFeature && !e.usingApiKey ? (p(), h(A, { key: 0 }, [
                          e.showFavorite && !e.usingApiKey ? (p(), h(A, { key: 0 }, [
                            e.canFavorite ? (p(), h("button", {
                              key: 0,
                              onClick: t[14] || (t[14] = (...M) => e.favoriteListing && e.favoriteListing(...M)),
                              class: "mlse-save btn btn-sm btn-tool",
                              disabled: e.isSaving || e.calculating
                            }, [
                              a("i", {
                                class: z(["fa-heart", e.favoriteStyle])
                              }, null, 2),
                              t[92] || (t[92] = a("span", { class: "d-none d-xl-inline-block ms-2" }, "Favorite", -1))
                            ], 8, y9e)) : (p(), h("button", {
                              key: 1,
                              "data-bs-toggle": "modal",
                              "data-bs-target": "#modalFavorite",
                              class: "btn btn-sm btn-tool",
                              disabled: e.isSaving || e.calculating
                            }, t[93] || (t[93] = [
                              a("i", { class: "fa-light fa-heart" }, null, -1),
                              a("span", { class: "d-none d-xl-inline-block ms-2" }, "Favorite", -1)
                            ]), 8, b9e))
                          ], 64)) : P("", !0),
                          e.showIgnore && !e.usingApiKey ? (p(), h(A, { key: 1 }, [
                            e.canIgnore ? (p(), h("button", {
                              key: 0,
                              onClick: t[15] || (t[15] = (...M) => e.ignoreListing && e.ignoreListing(...M)),
                              class: z(["mls-ignore btn btn-sm btn-tool", e.ignoreButtonStyle]),
                              disabled: e.isSaving || e.calculating || e.guarded
                            }, [
                              a("i", {
                                class: z(["fa-thumbs-down", e.ignoreStyle])
                              }, null, 2),
                              t[94] || (t[94] = a("span", { class: "d-none d-xl-inline-block ms-2" }, "Ignore", -1))
                            ], 10, A9e)) : (p(), h("button", {
                              key: 1,
                              "data-bs-toggle": "modal",
                              "data-bs-target": "#modalIgnore",
                              class: "btn btn-sm btn-tool",
                              disabled: e.isSaving || e.calculating || e.guarded
                            }, t[95] || (t[95] = [
                              a("i", { class: "fa-light fa-thumbs-down" }, null, -1),
                              a("span", { class: "d-none d-xl-inline-block ms-2" }, "Ignore", -1)
                            ]), 8, w9e))
                          ], 64)) : P("", !0),
                          e.canFeature && !e.usingApiKey ? (p(), h("div", C9e, [
                            a("button", {
                              class: "btn btn-sm btn-tool btn-tool-feature rounded-pill dropdown-toggle d-flex align-items-center",
                              type: "button",
                              "data-bs-toggle": "dropdown",
                              "aria-expanded": "false",
                              disabled: e.calculating || e.guarded
                            }, [
                              a("span", {
                                class: z(e.featuredOptionsStyle)
                              }, [
                                e.featuredForBoth ? (p(), h("i", P9e)) : P("", !0),
                                a("i", {
                                  class: z(e.featuredOptionsFgStyle)
                                }, null, 2)
                              ], 2),
                              t[96] || (t[96] = a("span", { class: "d-none d-xl-inline-block ms-2" }, "Feature", -1))
                            ], 8, S9e),
                            a("ul", k9e, [
                              a("li", null, [
                                a("button", {
                                  type: "button",
                                  class: "dropdown-item",
                                  onClick: t[16] || (t[16] = (M) => e.featureProperty(2)),
                                  disabled: e.calculating || e.guarded
                                }, [
                                  a("i", {
                                    class: z(e.featuredResidenceStyle)
                                  }, null, 2),
                                  t[97] || (t[97] = y("Residence "))
                                ], 8, E9e)
                              ]),
                              a("li", null, [
                                a("button", {
                                  type: "button",
                                  class: "dropdown-item",
                                  onClick: t[17] || (t[17] = (M) => e.featureProperty(1)),
                                  disabled: e.calculating || e.guarded
                                }, [
                                  a("i", {
                                    class: z(e.featuredInvestmentStyle)
                                  }, null, 2),
                                  t[98] || (t[98] = y("Investment "))
                                ], 8, I9e)
                              ])
                            ])
                          ])) : P("", !0)
                        ], 64)) : P("", !0),
                        e.showShare ? (p(), h("div", T9e, [
                          a("a", {
                            class: z(["btn btn-sm btn-tool dropdown-toggle", { disabled: e.calculating || e.guarded }]),
                            href: "#",
                            role: "button",
                            "data-bs-toggle": "dropdown",
                            "aria-expanded": "false"
                          }, " Share ", 2),
                          a("ul", O9e, [
                            a("li", null, [
                              a("button", {
                                type: "button",
                                "data-bs-target": e.hasChanges ? "#modalShareChange" : "#modalShare",
                                "data-bs-toggle": "modal",
                                class: "dropdown-item",
                                disabled: e.calculating || e.guarded
                              }, t[99] || (t[99] = [
                                a("i", { class: "fa-light fa-envelope" }, null, -1),
                                a("span", { class: "ms-2" }, "Email", -1)
                              ]), 8, R9e)
                            ]),
                            a("li", null, [
                              a("button", {
                                type: "button",
                                onClick: t[18] || (t[18] = (...M) => e.showDialogCopyLink && e.showDialogCopyLink(...M)),
                                class: "dropdown-item"
                              }, t[100] || (t[100] = [
                                a("i", { class: "fa-light fa-copy me-2" }, null, -1),
                                y("Copy Link ")
                              ]))
                            ]),
                            t[103] || (t[103] = a("li", null, [
                              a("hr", { class: "dropdown-divider" })
                            ], -1)),
                            t[104] || (t[104] = a("li", null, [
                              a("a", {
                                class: "dropdown-item dropdown-item-x",
                                href: "https://twitter.com/intent/tweet?text=Check%20out%20this%20property%20on%20Rescover!!",
                                target: "_blank"
                              }, [
                                a("i", { class: "fa-brands fa-x-twitter" }),
                                a("span", { class: "ms-2" }, "Twitter")
                              ])
                            ], -1)),
                            a("li", null, [
                              a("a", {
                                class: "dropdown-item",
                                href: "https://www.linkedin.com/sharing/share-offsite/?url=" + e.url + "&title=Check%20out%20this%20property%20on%20Rescover!",
                                target: "_blank"
                              }, t[101] || (t[101] = [
                                a("i", { class: "fa-brands fa-linkedin-in text-linkedin" }, null, -1),
                                a("span", { class: "ms-2" }, "Linkedin", -1)
                              ]), 8, L9e)
                            ]),
                            a("li", null, [
                              a("a", {
                                class: "dropdown-item",
                                href: "https://www.facebook.com/sharer/sharer.php?u=" + e.url,
                                target: "_blank"
                              }, t[102] || (t[102] = [
                                a("i", { class: "fa-brands fa-facebook-f text-facebook" }, null, -1),
                                a("span", { class: "ms-2" }, "Facebook", -1)
                              ]), 8, B9e)
                            ])
                          ])
                        ])) : P("", !0)
                      ], 64)),
                      a("div", null, [
                        (B = (E = e.access) == null ? void 0 : E.properties) != null && B.pdf && !e.isPortfolioInsights ? (p(), h("button", {
                          key: 0,
                          class: "tag btn btn-sm btn-danger rounded-pill btnPDFview flex-row d-flex align-items-center",
                          onClick: t[19] || (t[19] = (M) => e.buildPDF()),
                          type: "button",
                          disabled: e.calculating
                        }, t[105] || (t[105] = [
                          a("i", { class: "fa-light fa-file-pdf" }, null, -1),
                          a("span", { class: "d-none d-xl-inline-block ms-2" }, "PDF", -1)
                        ]), 8, M9e)) : e.isPortfolioInsights ? P("", !0) : (p(), h("button", {
                          key: 1,
                          "data-bs-toggle": "modal",
                          "data-bs-target": "#modalPdfCta",
                          class: "tag btn btn-sm btn-danger rounded-pill flex-row d-flex align-items-center",
                          type: "button",
                          disabled: e.calculating
                        }, t[106] || (t[106] = [
                          a("i", { class: "fa-light fa-file-pdf" }, null, -1),
                          a("span", { class: "d-none d-xl-inline-block ms-2" }, "PDF", -1)
                        ]), 8, x9e))
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])) : P("", !0)
        ];
      }),
      _: 1
    }),
    a("div", F9e, t[107] || (t[107] = [
      Bt('<div class="modal-dialog modal-dialog-centered"><div class="modal-content bg-gradient-alphabet rounded"><div class="modal-header border-0 pb-0"><button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button></div><div class="py-4 text-center"><img src="' + fI + '" width="341" height="300" loading="lazy" alt="Financial History" title="Financial History"></div><div class="modal-body text-center"><p class="fs-5 mb-2 fw-bold">Financial History</p><p> Upgrade to a Professional account to edit Financial History. </p><a href="https://www.rescover.com/signup" target="_blank" class="btn btn-lava mt-3">Create an account</a></div></div></div>', 1)
    ]), 512),
    a("div", V9e, [
      a("div", D9e, [
        a("div", N9e, [
          a("div", j9e, [
            t[108] || (t[108] = a("p", {
              class: "fs-5 modal-title fw-bold",
              id: "modalAnalysisStyleLabel"
            }, "Analysis Configuration", -1)),
            a("button", {
              type: "button",
              class: "btn-close",
              onClick: t[20] || (t[20] = (...m) => e.saveAnalysisStyleChanges && e.saveAnalysisStyleChanges(...m)),
              disabled: e.calculating,
              "aria-label": "Close"
            }, null, 8, H9e)
          ]),
          e.account ? (p(), h("div", U9e, [
            a("div", z9e, [
              a("div", W9e, [
                t[111] || (t[111] = a("div", { class: "col-lg-3 col-form-label" }, " Page Layout ", -1)),
                a("div", G9e, [
                  V(a("input", {
                    type: "radio",
                    class: "btn-check",
                    name: "defaultAnalysisMode",
                    id: "simplifiedView",
                    autocomplete: "off",
                    value: e.AnalysisMode.Basic,
                    "onUpdate:modelValue": t[21] || (t[21] = (m) => e.account.defaultAnalysisMode = m),
                    disabled: e.calculating
                  }, null, 8, Y9e), [
                    [Mt, e.account.defaultAnalysisMode]
                  ]),
                  t[109] || (t[109] = a("label", {
                    for: "simplifiedView",
                    class: "btn btn-eclipse"
                  }, "Simplified View", -1)),
                  V(a("input", {
                    type: "radio",
                    class: "btn-check",
                    name: "defaultAnalysisMode",
                    id: "advancedView",
                    autocomplete: "off",
                    value: e.AnalysisMode.Advanced,
                    "onUpdate:modelValue": t[22] || (t[22] = (m) => e.account.defaultAnalysisMode = m),
                    disabled: e.calculating
                  }, null, 8, X9e), [
                    [Mt, e.account.defaultAnalysisMode]
                  ]),
                  t[110] || (t[110] = a("label", {
                    for: "advancedView",
                    class: "btn btn-eclipse"
                  }, "Advanced View", -1))
                ])
              ])
            ]),
            a("div", q9e, [
              a("div", Q9e, [
                t[114] || (t[114] = a("div", { class: "col-lg-3 col-form-label" }, " Metrics View ", -1)),
                a("div", K9e, [
                  V(a("input", {
                    type: "radio",
                    class: "btn-check",
                    name: "defaultTaxMetrics",
                    id: "afterTaxView",
                    autocomplete: "off",
                    value: e.TaxMetrics.After,
                    "onUpdate:modelValue": t[23] || (t[23] = (m) => e.account.defaultTaxMetrics = m),
                    disabled: e.calculating
                  }, null, 8, Z9e), [
                    [Mt, e.account.defaultTaxMetrics]
                  ]),
                  t[112] || (t[112] = a("label", {
                    for: "afterTaxView",
                    class: "btn btn-eclipse"
                  }, "After-tax", -1)),
                  V(a("input", {
                    type: "radio",
                    class: "btn-check",
                    name: "defaultTaxMetrics",
                    id: "beforeTaxView",
                    autocomplete: "off",
                    value: e.TaxMetrics.Before,
                    "onUpdate:modelValue": t[24] || (t[24] = (m) => e.account.defaultTaxMetrics = m),
                    disabled: e.calculating
                  }, null, 8, J9e), [
                    [Mt, e.account.defaultTaxMetrics]
                  ]),
                  t[113] || (t[113] = a("label", {
                    for: "beforeTaxView",
                    class: "btn btn-eclipse"
                  }, "Before-tax", -1))
                ])
              ])
            ]),
            a("div", $9e, [
              a("div", _9e, [
                e.guarded ? (p(), h("div", eOe, t[115] || (t[115] = [
                  Bt('<div class="bg-gradient-periwinkle rounded p-3 d-flex justify-content-between align-items-center gap-2 shadow mb-3"><div class="avatar-sm bg-eclipse flex-shrink-0 rounded d-flex align-items-center justify-content-center"><i class="fa-solid fa-rocket fa-inverse fa-lg"></i></div><p class="mb-0"><b>Upgrade to Property Suite Pro</b> to access additional calculator modes, property types, and more!</p><a href="/pricing" class="btn btn-eclipse">Upgrade</a></div>', 1)
                ]))) : P("", !0),
                t[123] || (t[123] = a("div", { class: "col-lg-3 col-form-label" }, " Calculator Mode ", -1)),
                a("div", tOe, [
                  a("div", sOe, [
                    t[118] || (t[118] = a("div", { class: "calculator-title d-flex align-items-center mb-2" }, [
                      a("div", { class: "line" }),
                      a("div", { class: "text px-2 text-muted" }, "NEW INVESTMENT"),
                      a("div", { class: "line" })
                    ], -1)),
                    a("div", aOe, [
                      V(a("input", {
                        type: "radio",
                        class: "btn-check",
                        name: "calculatorMode",
                        id: "newPurchase",
                        autocomplete: "off",
                        value: "newPurchase",
                        "onUpdate:modelValue": t[25] || (t[25] = (m) => e.calcParams.investmentStrategy = m),
                        disabled: e.calculating
                      }, null, 8, nOe), [
                        [Mt, e.calcParams.investmentStrategy]
                      ]),
                      t[116] || (t[116] = a("label", {
                        class: "btn btn-eclipse",
                        for: "newPurchase"
                      }, "Standard Purchase", -1)),
                      V(a("input", {
                        type: "radio",
                        class: "btn-check",
                        name: "calculatorMode",
                        id: "flipBrrrr",
                        autocomplete: "off",
                        value: "flip",
                        "onUpdate:modelValue": t[26] || (t[26] = (m) => e.calcParams.investmentStrategy = m),
                        disabled: e.calculating || !e.hasFlipCalculatorFeature || e.guarded
                      }, null, 8, rOe), [
                        [Mt, e.calcParams.investmentStrategy]
                      ]),
                      t[117] || (t[117] = a("label", {
                        class: "btn btn-eclipse",
                        for: "flipBrrrr"
                      }, "Flip/BRRRR", -1))
                    ])
                  ]),
                  a("div", null, [
                    t[121] || (t[121] = a("div", { class: "calculator-title d-flex align-items-center mb-2" }, [
                      a("div", { class: "line" }),
                      a("div", { class: "text px-2 text-muted" }, "EXISTING INVESTMENT"),
                      a("div", { class: "line" })
                    ], -1)),
                    a("div", oOe, [
                      V(a("input", {
                        type: "radio",
                        class: "btn-check",
                        name: "calculatorMode",
                        id: "calculatorModeRent",
                        autocomplete: "off",
                        value: "rentVsSell",
                        "onUpdate:modelValue": t[27] || (t[27] = (m) => e.calcParams.investmentStrategy = m),
                        disabled: !e.hasRentVsSellFeature || e.calculating || e.guarded
                      }, null, 8, iOe), [
                        [Mt, e.calcParams.investmentStrategy]
                      ]),
                      t[119] || (t[119] = a("label", {
                        class: "btn btn-eclipse",
                        for: "calculatorModeRent"
                      }, "Rent vs Sell", -1)),
                      V(a("input", {
                        type: "radio",
                        class: "btn-check",
                        name: "calculatorMode",
                        id: "existingInvestment",
                        autocomplete: "off",
                        value: "existingInvestment",
                        "onUpdate:modelValue": t[28] || (t[28] = (m) => e.calcParams.investmentStrategy = m),
                        disabled: !e.canExistingInvestment || e.calculating || e.guarded
                      }, null, 8, lOe), [
                        [Mt, e.calcParams.investmentStrategy]
                      ]),
                      t[120] || (t[120] = a("label", {
                        class: "btn btn-eclipse",
                        for: "existingInvestment"
                      }, "Performance Review", -1))
                    ]),
                    t[122] || (t[122] = a("div", {
                      class: "d-flex flex-row d-lg-none alert alert-info mb-0",
                      role: "alert"
                    }, [
                      a("i", {
                        class: "fa-light fa-circle-info me-2 mt-1",
                        "aria-hidden": "true"
                      }),
                      a("span", null, [
                        y("Please manage "),
                        a("b", null, "Existing Investment"),
                        y(" on Desktop.")
                      ])
                    ], -1))
                  ])
                ])
              ])
            ]),
            a("div", dOe, [
              a("div", cOe, [
                t[131] || (t[131] = a("div", { class: "col-lg-3 col-form-label" }, " Property Type ", -1)),
                a("div", uOe, [
                  a("div", pOe, [
                    V(a("input", {
                      type: "radio",
                      class: "btn-check",
                      name: "propertyType",
                      id: "propertyTypeSingleFamily",
                      value: e.PropertyType.SingleFamily,
                      autocomplete: "off",
                      "onUpdate:modelValue": t[29] || (t[29] = (m) => e.propertyType = m),
                      disabled: e.calculating
                    }, null, 8, hOe), [
                      [Mt, e.propertyType]
                    ]),
                    t[124] || (t[124] = a("label", {
                      class: "btn btn-eclipse",
                      for: "propertyTypeSingleFamily"
                    }, "Single Family", -1)),
                    V(a("input", {
                      type: "radio",
                      class: "btn-check",
                      name: "propertyType",
                      id: "propertyTypeMultiFamily",
                      value: e.PropertyType.MultiFamily,
                      autocomplete: "off",
                      "onUpdate:modelValue": t[30] || (t[30] = (m) => e.propertyType = m),
                      disabled: e.calculating || !e.hasAdvancedCalculatorFeature || e.guarded
                    }, null, 8, mOe), [
                      [Mt, e.propertyType]
                    ]),
                    t[125] || (t[125] = a("label", {
                      class: "btn btn-eclipse",
                      for: "propertyTypeMultiFamily"
                    }, "2-4 Family", -1)),
                    V(a("input", {
                      type: "radio",
                      class: "btn-check",
                      name: "propertyType",
                      id: "propertyTypeCommercial",
                      value: e.PropertyType.Commercial,
                      autocomplete: "off",
                      "onUpdate:modelValue": t[31] || (t[31] = (m) => e.propertyType = m),
                      disabled: e.calculating || !e.hasAdvancedCalculatorFeature || e.guarded
                    }, null, 8, fOe), [
                      [Mt, e.propertyType]
                    ]),
                    t[126] || (t[126] = a("label", {
                      class: "btn btn-eclipse",
                      for: "propertyTypeCommercial"
                    }, "Commercial", -1))
                  ])
                ]),
                N(ks, {
                  name: "slide",
                  mode: "out-in"
                }, {
                  default: ve(() => [
                    e.requireUnitsMultiFamily || e.requireUnitsCommercial ? (p(), h("div", gOe, [
                      a("div", vOe, [
                        t[130] || (t[130] = a("div", { class: "col-lg-3 col-form-label" }, " Number of Units ", -1)),
                        a("div", {
                          class: z(e.numberOfUnitsOptionsStyle)
                        }, [
                          e.requireUnitsMultiFamily ? (p(), h(A, { key: 0 }, [
                            V(a("input", {
                              type: "radio",
                              class: "btn-check",
                              name: "numberUnits",
                              id: "propertyTypeDuplex",
                              value: 2,
                              autocomplete: "off",
                              "onUpdate:modelValue": t[32] || (t[32] = (m) => e.unitCount = m),
                              disabled: e.calculating || e.guarded
                            }, null, 8, yOe), [
                              [Mt, e.unitCount]
                            ]),
                            t[127] || (t[127] = a("label", {
                              class: "btn btn-eclipse",
                              for: "propertyTypeDuplex"
                            }, "Duplex", -1)),
                            V(a("input", {
                              type: "radio",
                              class: "btn-check",
                              name: "numberUnits",
                              id: "propertyTypeTriplex",
                              value: 3,
                              autocomplete: "off",
                              "onUpdate:modelValue": t[33] || (t[33] = (m) => e.unitCount = m),
                              disabled: e.calculating || e.guarded
                            }, null, 8, bOe), [
                              [Mt, e.unitCount]
                            ]),
                            t[128] || (t[128] = a("label", {
                              class: "btn btn-eclipse",
                              for: "propertyTypeTriplex"
                            }, "Triplex", -1)),
                            V(a("input", {
                              type: "radio",
                              class: "btn-check",
                              name: "numberUnits",
                              id: "propertyTypeQuadruplex",
                              value: 4,
                              autocomplete: "off",
                              "onUpdate:modelValue": t[34] || (t[34] = (m) => e.unitCount = m),
                              disabled: e.calculating || e.guarded
                            }, null, 8, AOe), [
                              [Mt, e.unitCount]
                            ]),
                            t[129] || (t[129] = a("label", {
                              class: "btn btn-eclipse",
                              for: "propertyTypeQuadruplex"
                            }, "Quadruplex", -1))
                          ], 64)) : P("", !0),
                          e.requireUnitsCommercial ? V((p(), h("input", {
                            key: 1,
                            type: "text",
                            class: "form-control",
                            "onUpdate:modelValue": t[35] || (t[35] = (m) => e.unitCount = m),
                            disabled: e.calculating
                          }, null, 8, wOe)), [
                            [_e, e.unitCount]
                          ]) : P("", !0)
                        ], 2)
                      ])
                    ])) : P("", !0)
                  ]),
                  _: 1
                }),
                t[132] || (t[132] = a("template", null, [
                  a("div", { class: "col-lg-3 col-form-label" }, " Sub-Type "),
                  a("div", { class: "col-lg-9" }, [
                    a("select", { class: "form-select" }, [
                      a("option", null, "Apartment Community"),
                      a("option", null, "two"),
                      a("option", null, "three")
                    ])
                  ])
                ], -1))
              ])
            ]),
            P("", !0),
            e.calcParams ? (p(), h("div", COe, [
              a("div", SOe, [
                t[140] || (t[140] = a("div", { class: "col-lg-3 col-form-label" }, " Rental Type ", -1)),
                a("div", POe, [
                  V(a("input", {
                    type: "radio",
                    class: "btn-check",
                    name: "rentalType",
                    id: "checkLongTerm",
                    autocomplete: "off",
                    value: "long-term",
                    "onUpdate:modelValue": t[36] || (t[36] = (m) => e.calcParams.rentalType = m),
                    disabled: e.calculating
                  }, null, 8, kOe), [
                    [Mt, e.calcParams.rentalType]
                  ]),
                  t[134] || (t[134] = a("label", {
                    class: "btn btn-eclipse",
                    for: "checkLongTerm"
                  }, [
                    a("i", {
                      class: "fa-light fa-calendar-range me-2",
                      "aria-hidden": "true"
                    }),
                    y("Long-Term")
                  ], -1)),
                  V(a("input", {
                    type: "radio",
                    class: "btn-check",
                    name: "rentalType",
                    id: "checkShortTerm",
                    autocomplete: "off",
                    value: "short-term",
                    "onUpdate:modelValue": t[37] || (t[37] = (m) => e.calcParams.rentalType = m),
                    disabled: !e.canOtherAnalysisStyles || e.calculating || e.guarded
                  }, null, 8, EOe), [
                    [Mt, e.calcParams.rentalType]
                  ]),
                  t[135] || (t[135] = a("label", {
                    class: "btn btn-eclipse",
                    for: "checkShortTerm"
                  }, [
                    a("i", {
                      class: "fa-light fa-timer me-2",
                      "aria-hidden": "true"
                    }),
                    y("Short-Term")
                  ], -1)),
                  V(a("input", {
                    type: "radio",
                    class: "btn-check",
                    name: "rentalType",
                    id: "checkPadSplit",
                    autocomplete: "off",
                    value: "pad-split",
                    "onUpdate:modelValue": t[38] || (t[38] = (m) => e.calcParams.rentalType = m),
                    disabled: !e.canOtherAnalysisStyles || e.calculating || e.propertyType != e.PropertyType.SingleFamily || e.guarded
                  }, null, 8, IOe), [
                    [Mt, e.calcParams.rentalType]
                  ]),
                  t[136] || (t[136] = a("label", {
                    class: "btn btn-eclipse align-items-center d-flex",
                    for: "checkPadSplit"
                  }, [
                    a("img", {
                      src: nn,
                      alt: "PadSplit",
                      title: "PadSplit",
                      loading: "lazy",
                      class: "img-fluid",
                      width: "85"
                    })
                  ], -1))
                ]),
                t[141] || (t[141] = a("div", { class: "col-lg-5 col-form-label" }, " Compare Against Other Rental Types? ", -1)),
                a("div", TOe, [
                  ((d = e.calcParams) == null ? void 0 : d.rentalType) != "long-term" ? (p(), h("div", OOe, [
                    V(a("input", {
                      class: "form-check-input",
                      type: "checkbox",
                      id: "longTerm",
                      "onUpdate:modelValue": t[39] || (t[39] = (m) => e.compareLongTerm = m),
                      disabled: !e.canOtherAnalysisStyles || e.calculating || e.guarded
                    }, null, 8, ROe), [
                      [Ue, e.compareLongTerm]
                    ]),
                    t[137] || (t[137] = a("label", {
                      class: "form-check-label",
                      for: "longTerm"
                    }, "Long-Term", -1))
                  ])) : P("", !0),
                  ((c = e.calcParams) == null ? void 0 : c.rentalType) != "short-term" ? (p(), h("div", LOe, [
                    V(a("input", {
                      class: "form-check-input",
                      type: "checkbox",
                      id: "shortTerm",
                      "onUpdate:modelValue": t[40] || (t[40] = (m) => e.compareShortTerm = m),
                      disabled: !e.canOtherAnalysisStyles || e.calculating || e.guarded
                    }, null, 8, BOe), [
                      [Ue, e.compareShortTerm]
                    ]),
                    t[138] || (t[138] = a("label", {
                      class: "form-check-label",
                      for: "shortTerm"
                    }, "Short-Term", -1))
                  ])) : P("", !0),
                  ((u = e.calcParams) == null ? void 0 : u.rentalType) != "pad-split" ? (p(), h("div", MOe, [
                    V(a("input", {
                      class: "form-check-input",
                      type: "checkbox",
                      id: "padSplit",
                      "onUpdate:modelValue": t[41] || (t[41] = (m) => e.comparePadSplit = m),
                      disabled: !e.canOtherAnalysisStyles || e.calculating || e.guarded
                    }, null, 8, xOe), [
                      [Ue, e.comparePadSplit]
                    ]),
                    t[139] || (t[139] = a("label", {
                      class: "form-check-label",
                      for: "padSplit"
                    }, "PadSplit", -1))
                  ])) : P("", !0)
                ])
              ])
            ])) : P("", !0),
            P("", !0)
          ])) : P("", !0),
          a("div", FOe, [
            a("button", {
              type: "button",
              class: "btn btn-lava",
              onClick: t[42] || (t[42] = (...m) => e.saveAnalysisStyleChanges && e.saveAnalysisStyleChanges(...m)),
              disabled: e.calculating
            }, "Close", 8, VOe)
          ]),
          N(ks, {
            name: "slide",
            mode: "out-in"
          }, {
            default: ve(() => [
              e.calculating ? (p(), h("div", DOe, t[143] || (t[143] = [
                a("i", { class: "fa-duotone fa-solid fa-spinner-third fa-spin me-2" }, null, -1),
                y("Calculator Running... ")
              ]))) : P("", !0)
            ]),
            _: 1
          })
        ])
      ])
    ], 512),
    a("div", NOe, [
      a("div", jOe, [
        a("div", HOe, [
          t[150] || (t[150] = a("div", { class: "modal-header border-0 pb-0" }, [
            a("p", {
              class: "modal-title fs-5 fw-bold",
              id: "ModalShareChangeLabel"
            }, "Share Property Info"),
            a("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            })
          ], -1)),
          a("div", UOe, [
            a("div", zOe, [
              t[146] || (t[146] = a("p", null, [
                y(" Sharing this listing to "),
                a("b", null, "your Email"),
                y(". ")
              ], -1)),
              a("div", WOe, [
                V(a("input", {
                  class: "form-check-input",
                  type: "checkbox",
                  "onUpdate:modelValue": t[43] || (t[43] = (m) => e.email.ccFriend = m),
                  value: "",
                  id: "friendCheck",
                  disabled: e.sharingProperty
                }, null, 8, GOe), [
                  [Ue, e.email.ccFriend]
                ]),
                t[144] || (t[144] = a("label", {
                  class: "form-check-label",
                  for: "friendCheck"
                }, " Add additional recipients ", -1))
              ]),
              V(a("div", YOe, [
                V(a("input", {
                  type: "text",
                  class: "form-control",
                  "onUpdate:modelValue": t[44] || (t[44] = (m) => e.email.address = m),
                  placeholder: "Email addresses",
                  "aria-describedby": "friendEmailHelp"
                }, null, 512), [
                  [_e, e.email.address]
                ]),
                t[145] || (t[145] = a("small", {
                  id: "friendEmailHelp",
                  class: "form-text text-secondary text-opacity-50"
                }, "Separated by commas.", -1))
              ], 512), [
                [Us, e.email.ccFriend]
              ])
            ]),
            t[149] || (t[149] = a("div", {
              class: "alert alert-warning mt-3",
              role: "alert"
            }, [
              a("i", { class: "fa-light fa-exclamation-triangle me-2" }),
              y("This listing's financial model uses custom parameters. ")
            ], -1)),
            a("div", XOe, [
              a("div", qOe, [
                a("div", QOe, [
                  t[147] || (t[147] = a("p", null, [
                    y(" If you would like the recipient to see these parameters and save them to your account, click "),
                    a("b", null, "Save & Send Email"),
                    y(" below. ")
                  ], -1)),
                  a("button", {
                    onClick: t[45] || (t[45] = (m) => e.saveShareListing(!0)),
                    class: "btn btn-outline-lava btn-block me-2",
                    disabled: e.sharingProperty
                  }, "Save & Send Email", 8, KOe)
                ])
              ]),
              a("div", ZOe, [
                a("div", JOe, [
                  t[148] || (t[148] = a("p", null, "To send without custom parameters, click Send Email", -1)),
                  a("button", {
                    onClick: t[46] || (t[46] = (m) => e.shareListing(!0)),
                    class: "btn btn-outline-lava btn-block mt-auto",
                    disabled: e.sharingProperty
                  }, "Send Email", 8, $Oe)
                ])
              ])
            ])
          ])
        ])
      ])
    ], 512),
    a("div", _Oe, [
      a("div", e7e, [
        a("div", t7e, [
          t[154] || (t[154] = a("div", { class: "modal-header border-0 pb-0" }, [
            a("p", {
              class: "modal-title fs-5 fw-bold",
              id: "ModalShareLabel"
            }, "Share Property Info"),
            a("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            })
          ], -1)),
          a("div", s7e, [
            t[153] || (t[153] = a("p", null, [
              y(" Sharing this listing to "),
              a("b", null, "your Email"),
              y(". ")
            ], -1)),
            a("div", a7e, [
              V(a("input", {
                class: "form-check-input",
                type: "checkbox",
                "onUpdate:modelValue": t[47] || (t[47] = (m) => e.email.ccFriend = m),
                id: "friendCheck",
                disabled: e.sharingProperty
              }, null, 8, n7e), [
                [Ue, e.email.ccFriend]
              ]),
              t[151] || (t[151] = a("label", {
                class: "form-check-label",
                for: "friendCheck"
              }, " Add additional recipients ", -1))
            ]),
            V(a("div", r7e, [
              V(a("input", {
                type: "text",
                class: "form-control",
                "onUpdate:modelValue": t[48] || (t[48] = (m) => e.email.address = m),
                placeholder: "Email addresses",
                "aria-describedby": "emailHelp"
              }, null, 512), [
                [_e, e.email.address]
              ]),
              t[152] || (t[152] = a("small", {
                id: "emailHelp",
                class: "form-text text-secondary text-opacity-50"
              }, "Separated by commas.", -1))
            ], 512), [
              [Us, e.email.ccFriend]
            ]),
            a("div", o7e, [
              a("button", {
                onClick: t[49] || (t[49] = (m) => e.shareListing(!0)),
                class: "btn btn-lava",
                type: "button",
                disabled: e.sharingProperty
              }, "Send Email", 8, i7e)
            ])
          ])
        ])
      ])
    ], 512),
    a("div", l7e, [
      a("div", d7e, [
        a("div", c7e, [
          t[160] || (t[160] = a("div", { class: "modal-header border-0 pb-0" }, [
            a("p", {
              class: "modal-title fs-5 fw-bold",
              id: "ModalPDFLabel"
            }, "Create PDF"),
            a("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            })
          ], -1)),
          a("div", u7e, [
            t[159] || (t[159] = a("div", {
              class: "alert alert-warning",
              role: "alert"
            }, [
              a("i", { class: "fa-light fa-exclamation-triangle me-2" }),
              y("You have unsaved changes. ")
            ], -1)),
            a("div", p7e, [
              a("div", h7e, [
                a("div", m7e, [
                  t[156] || (t[156] = a("p", null, [
                    y(" If you would like to save your changes before viewing the PDF, click "),
                    a("b", null, "Save & View PDF"),
                    y(" below. ")
                  ], -1)),
                  a("button", {
                    class: "btn btn-sm btn-outline-lava btn-block",
                    onClick: t[50] || (t[50] = (...m) => e.saveViewPDF && e.saveViewPDF(...m))
                  }, t[155] || (t[155] = [
                    a("i", { class: "fa-light fa-file-pdf me-2" }, null, -1),
                    y("Save & View PDF ")
                  ]))
                ])
              ]),
              a("div", f7e, [
                a("div", g7e, [
                  t[158] || (t[158] = a("p", null, [
                    y(" To view PDF without saving changes, click "),
                    a("b", null, "View PDF"),
                    y(". ")
                  ], -1)),
                  a("button", {
                    class: "buildPDF tag btn btn-sm btn-outline-lava btn-block mt-auto",
                    onClick: t[51] || (t[51] = (m) => e.buildPDF(!0))
                  }, t[157] || (t[157] = [
                    a("i", { class: "fa-light fa-file-pdf me-2" }, null, -1),
                    y("View PDF ")
                  ]))
                ])
              ])
            ])
          ])
        ])
      ])
    ], 512),
    N(l, {
      show: e.showInvestmentDetails,
      "onUpdate:show": t[52] || (t[52] = (m) => e.showInvestmentDetails = m)
    }, null, 8, ["show"]),
    a("div", v7e, [
      a("div", y7e, [
        a("div", b7e, [
          t[164] || (t[164] = a("div", { class: "modal-header border-0 pb-0" }, [
            a("p", {
              class: "modal-title fs-5 fw-bold",
              id: "dialogCopyLinkLabel"
            }, "Share Link"),
            a("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            })
          ], -1)),
          a("div", A7e, [
            t[163] || (t[163] = a("label", {
              class: "form-label",
              for: "button-copy"
            }, "Copy your link or share it!", -1)),
            a("div", w7e, [
              t[162] || (t[162] = a("i", { class: "fa-light fa-link ps-2" }, null, -1)),
              V(a("input", {
                type: "text",
                class: "form-control border-0",
                placeholder: "",
                "aria-label": "Property Link",
                "aria-describedby": "button-copy",
                "onUpdate:modelValue": t[53] || (t[53] = (m) => e.shareUrl = m),
                readonly: ""
              }, null, 512), [
                [_e, e.shareUrl]
              ]),
              a("button", {
                class: "btn btn-lava d-flex align-items-center",
                type: "button",
                id: "button-copy",
                onClick: t[54] || (t[54] = (...m) => e.copyShareUrl && e.copyShareUrl(...m))
              }, t[161] || (t[161] = [
                a("i", { class: "fa-light fa-check me-2" }, null, -1),
                y("Copy")
              ]))
            ])
          ])
        ])
      ])
    ], 512)
  ], 64);
}
const xls = /* @__PURE__ */ Ae(hTe, [["render", C7e]]), S7e = me({
  name: "AnalysisRequestHeader",
  props: {
    analysis: {
      type: String,
      required: !1
    }
  },
  directives: {
    Tooltip: Wo
  },
  emits: [
    "save"
  ],
  components: {},
  data() {
    return {
      busy: !1,
      shareAnalysisModel: {
        message: null,
        attachPdf: !1,
        includeSchedulingLink: !1
      }
    };
  },
  computed: {
    requestorEmail() {
      var e;
      if ((e = this.analysisRequestInfo) != null && e.email)
        return `mailto:${this.analysisRequestInfo.email}`;
    },
    canManageLeads() {
      var e, t;
      return ((t = (e = this.acl) == null ? void 0 : e.leads) == null ? void 0 : t.leads) == !0 && this.isClient != !0;
    },
    ...q(Te, ["acl", "aclLoaded", "isClient", "isAdmin", "isUser"]),
    ...q(bm, ["view", "analysisRequestInfo", "managementTerritory", "hasSchedulingLink", "messageTemplate"]),
    ...at(bm)
  },
  methods: {
    number: Ve,
    date: cs,
    currency: Ze,
    percent: Wt,
    async retrieveAnalysisRequest() {
      if (this.analysis)
        try {
          !await this.analysisRequestsStore.getCurrentRequest() && this.analysisRequestsStore.analysisRequestsError && Se(this.analysisRequestsStore.analysisRequestsError), !await this.analysisRequestsStore.getCurrentClientValue() && this.analysisRequestsStore.analysisRequestsError && Se(this.analysisRequestsStore.analysisRequestsError);
        } catch (e) {
          Se(e);
        }
    },
    save() {
      this.$emit("save");
    },
    verifySend() {
      var e;
      this.shareAnalysisModel.attachPdf = !1, this.shareAnalysisModel.message = this.messageTemplate, (e = bootstrap.Modal.getOrCreateInstance(this.$refs.modalRequestSend)) == null || e.show();
    },
    async sendRequest() {
      var t;
      try {
        this.busy = !0;
        var e = await this.analysisRequestsStore.shareRequest(this.analysisRequestInfo.token, this.shareAnalysisModel);
        this.analysisRequestInfo.sent = e, e && wt("Email sent successfully");
      } catch (s) {
        Se(s.message);
      }
      (t = bootstrap.Modal.getOrCreateInstance(this.$refs.modalRequestSend)) == null || t.hide(), this.busy = !1;
    },
    async archiveRequest() {
      try {
        this.busy = !0;
        const e = await this.analysisRequestsStore.archiveRequest(this.analysisRequestInfo.id);
        this.analysisRequestInfo.archived = e, e && wt("Request archived successfully");
      } catch (e) {
        Se(e.message);
      }
      this.busy = !1;
    },
    async trackView() {
      try {
        this.analysis && await this.analysisRequestsStore.trackCurrentView();
      } catch {
      }
    },
    async viewOriginal() {
      var e;
      try {
        await this.analysisRequestsStore.getRequestView(this.analysisRequestInfo.token), (e = bootstrap.Modal.getOrCreateInstance(this.$refs.modalFreeRentalAnalysis)) == null || e.show();
      } finally {
      }
    }
  },
  created() {
  },
  mounted() {
    this.aclLoaded.then(this.trackView).then(async () => {
      var e;
      try {
        this.analysis && ((e = this.acl) == null ? void 0 : e.isAuthenticated) == !0 && await this.analysisRequestsStore.getSettings();
      } catch (t) {
        Se(t.message);
      }
    }).then(this.retrieveAnalysisRequest), document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach((e) => new bootstrap.Tooltip(e));
  }
}), P7e = {
  key: 0,
  class: "toolbar-analysis-request-info py-2 shadow"
}, k7e = { class: "container-xl" }, E7e = { class: "row g-2" }, I7e = { class: "col-12 col-md-6 col-lg-5 col-xl-7" }, T7e = { class: "bg-white py-1 px-2 rounded d-flex align-items-center justify-content-start justify-content-md-center flex-column flex-md-row" }, O7e = { class: "label-requested d-flex flex-row" }, R7e = { class: "text-truncate" }, L7e = { class: "text-capitalize" }, B7e = ["href"], M7e = { class: "badge rounded-pill text-bg-success ms-2" }, x7e = {
  key: 1,
  role: "button",
  "data-bs-toggle": "modal",
  "data-bs-target": "#modalPortfolioFinder"
}, F7e = { class: "badge rounded-pill text-bg-success ms-2" }, V7e = {
  key: 2,
  class: "badge rounded-pill text-bg-secondary ms-2"
}, D7e = ["title"], N7e = { class: "col-6 col-md-3 col-xl-2 text-center" }, j7e = { class: "bg-white py-1 px-2 rounded text-center" }, H7e = { class: "col-6 col-md-3 col-lg-4 col-xl-3 text-end" }, U7e = { class: "list-inline mb-0" }, z7e = { class: "list-inline-item" }, W7e = { class: "list-inline-item" }, G7e = { class: "fa-light fa-floppy-disk" }, Y7e = { class: "list-inline-item" }, X7e = { class: "list-inline-item" }, q7e = ["disabled"], Q7e = {
  class: "modal fade",
  id: "modalRequestSend",
  ref: "modalRequestSend",
  tabindex: "-1",
  "aria-labelledby": "modalRequestSendLabel",
  "aria-hidden": "true"
}, K7e = { class: "modal-dialog" }, Z7e = { class: "modal-content bg-gradient-alphabet rounded" }, J7e = {
  key: 0,
  class: "modal-body"
}, $7e = { class: "mb-3" }, _7e = {
  class: "form-label",
  for: "bdmMessage"
}, eRe = { class: "mb-3" }, tRe = {
  class: "form-label",
  for: "bdmMessage"
}, sRe = { class: "mb-3" }, aRe = { class: "form-check mb-3" }, nRe = { class: "form-check mb-3" }, rRe = ["disabled"], oRe = {
  class: "form-check-label",
  for: "checkScheduling"
}, iRe = {
  key: 0,
  class: "fa-light fa-info-circle ms-2",
  "data-bs-toggle": "tooltip",
  "data-bs-title": "You can add a Scheduling Link on you Account Settings"
}, lRe = { class: "d-flex justify-content-end" }, dRe = ["disabled"], cRe = {
  class: "modal fade",
  id: "modalFreeRentalAnalysis",
  ref: "modalFreeRentalAnalysis",
  tabindex: "-1",
  "aria-labelledby": "modalFreeRentalAnalysisLabel",
  "aria-hidden": "true"
}, uRe = { class: "modal-dialog modal-dialog-centered" }, pRe = { class: "modal-content bg-gradient-alphabet rounded" }, hRe = { class: "modal-body d-flex flex-column gap-3" }, mRe = { class: "bg-white bg-opacity-50 rounded p-2" }, fRe = {
  class: "table table-borderless table-sm mb-0 table-transparent",
  style: { "table-layout": "fixed" }
}, gRe = { class: "bg-white bg-opacity-50 rounded p-2" }, vRe = {
  class: "table table-borderless table-sm table-transparent mb-0",
  style: { "table-layout": "fixed" }
}, yRe = { class: "bg-white bg-opacity-50 rounded p-2" }, bRe = {
  class: "table table-borderless table-sm mb-0 table-transparent",
  style: { "table-layout": "fixed" }
}, ARe = { class: "bg-white bg-opacity-50 rounded p-2" }, wRe = {
  class: "table table-borderless table-sm mb-0 table-transparent",
  style: { "table-layout": "fixed" }
};
function CRe(e, t, s, n, r, i) {
  var l, d, c, u, m, f, v, b, w, S, I, T, x, k, C, O, E, B, M, R, F, L, j, H, te;
  const o = Za("tooltip");
  return e.analysisRequestInfo && ((l = e.acl) != null && l.isAuthenticated) ? (p(), h("div", P7e, [
    a("div", k7e, [
      a("div", E7e, [
        a("div", I7e, [
          a("div", T7e, [
            a("div", O7e, [
              a("div", R7e, [
                t[8] || (t[8] = y("Requested by ")),
                a("b", L7e, g((d = e.analysisRequestInfo) == null ? void 0 : d.name), 1)
              ]),
              ((c = e.analysisRequestInfo) == null ? void 0 : c.currentOwner) == !0 && e.canManageLeads ? (p(), h("a", {
                key: 0,
                href: "/portfolio-finder/" + e.analysisRequestInfo.ownerId
              }, [
                V((p(), h("span", M7e, t[9] || (t[9] = [
                  a("i", { class: "fa-light fa-house-circle-check" }, null, -1)
                ]))), [
                  [
                    o,
                    "Current property owner",
                    void 0,
                    { top: !0 }
                  ]
                ])
              ], 8, B7e)) : ((u = e.analysisRequestInfo) == null ? void 0 : u.currentOwner) == !0 && e.canManageLeads == !1 ? (p(), h("span", x7e, [
                V((p(), h("span", F7e, t[10] || (t[10] = [
                  a("i", { class: "fa-light fa-house-circle-check" }, null, -1)
                ]))), [
                  [
                    o,
                    "Current property owner",
                    void 0,
                    { top: !0 }
                  ]
                ])
              ])) : P("", !0),
              ((m = e.analysisRequestInfo) == null ? void 0 : m.currentOwner) == !1 ? V((p(), h("span", V7e, t[11] || (t[11] = [
                a("i", { class: "fa-light fa-house-circle-xmark" }, null, -1)
              ]))), [
                [
                  o,
                  "Current property owner",
                  void 0,
                  { top: !0 }
                ]
              ]) : P("", !0)
            ]),
            ((f = e.analysisRequestInfo) == null ? void 0 : f.assignedTo) != null ? (p(), h("div", {
              key: 0,
              class: "label-assigned text-truncate",
              title: e.analysisRequestInfo.assignedTo.firstName + " " + e.analysisRequestInfo.assignedTo.lastName
            }, [
              t[12] || (t[12] = y(" Assigned to ")),
              a("b", null, g(e.analysisRequestInfo.assignedTo.firstName) + " " + g(e.analysisRequestInfo.assignedTo.lastName), 1)
            ], 8, D7e)) : P("", !0)
          ])
        ]),
        a("div", N7e, [
          a("div", j7e, [
            t[13] || (t[13] = a("small", { class: "text-secondary text-opacity-50 me-md-2" }, [
              a("span", { class: "d-none d-xxl-inline-block" }, "MANAGEMENT"),
              y(" TERRITORY: ")
            ], -1)),
            a("b", null, g(e.number(e.managementTerritory)), 1)
          ])
        ]),
        a("div", H7e, [
          a("ul", U7e, [
            a("li", z7e, [
              V((p(), h("button", {
                type: "button",
                class: "btn btn-outline-eclipse btn-sm",
                onClick: t[0] || (t[0] = (...re) => e.viewOriginal && e.viewOriginal(...re))
              }, t[14] || (t[14] = [
                a("i", { class: "fa-light fa-memo-circle-info" }, null, -1)
              ]))), [
                [
                  o,
                  "View Rental Analysis",
                  void 0,
                  { top: !0 }
                ]
              ])
            ]),
            a("li", W7e, [
              a("button", {
                type: "button",
                class: "btn btn-outline-eclipse btn-sm",
                onClick: t[1] || (t[1] = (...re) => e.save && e.save(...re))
              }, [
                V(a("i", G7e, null, 512), [
                  [
                    o,
                    "Save",
                    void 0,
                    { top: !0 }
                  ]
                ]),
                t[15] || (t[15] = a("span", { class: "d-none d-xxl-inline-block ms-2" }, "Save", -1))
              ])
            ]),
            a("li", Y7e, [
              V((p(), h("button", {
                type: "button",
                class: "btn btn-outline-eclipse btn-sm",
                onClick: t[2] || (t[2] = (...re) => e.verifySend && e.verifySend(...re))
              }, t[16] || (t[16] = [
                a("i", { class: "fa-light fa-envelope" }, null, -1),
                a("span", { class: "d-none d-xxl-inline-block ms-2" }, "Send", -1)
              ]))), [
                [
                  o,
                  "Send",
                  void 0,
                  { top: !0 }
                ]
              ])
            ]),
            a("li", X7e, [
              V((p(), h("button", {
                type: "button",
                class: "btn btn-outline-eclipse btn-sm",
                onClick: t[3] || (t[3] = (...re) => e.archiveRequest && e.archiveRequest(...re)),
                disabled: ((v = e.analysisRequestInfo) == null ? void 0 : v.archived) == !0
              }, t[17] || (t[17] = [
                a("i", { class: "fa-light fa-box-archive" }, null, -1),
                a("span", { class: "d-none d-xxl-inline-block ms-2" }, "Archive", -1)
              ]), 8, q7e)), [
                [
                  o,
                  "Archive",
                  void 0,
                  { top: !0 }
                ]
              ])
            ])
          ])
        ])
      ])
    ]),
    a("div", Q7e, [
      a("div", K7e, [
        a("div", Z7e, [
          t[26] || (t[26] = a("div", { class: "modal-header border-0 pb-0" }, [
            a("p", { class: "modal-title fw-bold fs-5 mb-3" }, " Send to Prospect "),
            a("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            })
          ], -1)),
          e.analysisRequestInfo ? (p(), h("div", J7e, [
            a("div", $7e, [
              a("label", _7e, [
                t[18] || (t[18] = y("To ")),
                t[19] || (t[19] = a("br", null, null, -1)),
                a("b", null, g((b = e.analysisRequestInfo) == null ? void 0 : b.name), 1)
              ])
            ]),
            a("div", eRe, [
              a("label", tRe, [
                t[20] || (t[20] = y("Email ")),
                t[21] || (t[21] = a("br", null, null, -1)),
                a("b", null, g((w = e.analysisRequestInfo) == null ? void 0 : w.email), 1)
              ])
            ]),
            a("div", sRe, [
              t[22] || (t[22] = a("label", {
                class: "form-label",
                for: "bdmMessage"
              }, "Message", -1)),
              V(a("textarea", {
                class: "form-control",
                rows: "3",
                id: "bdmMessage",
                "onUpdate:modelValue": t[4] || (t[4] = (re) => e.shareAnalysisModel.message = re)
              }, null, 512), [
                [_e, e.shareAnalysisModel.message]
              ])
            ]),
            a("div", aRe, [
              V(a("input", {
                class: "form-check-input",
                type: "checkbox",
                "onUpdate:modelValue": t[5] || (t[5] = (re) => e.shareAnalysisModel.attachPdf = re),
                id: "checkPDF"
              }, null, 512), [
                [Ue, e.shareAnalysisModel.attachPdf]
              ]),
              t[23] || (t[23] = a("label", {
                class: "form-check-label",
                for: "checkPDF"
              }, " Include PDF with email ", -1))
            ]),
            a("div", nRe, [
              V(a("input", {
                class: "form-check-input",
                type: "checkbox",
                "onUpdate:modelValue": t[6] || (t[6] = (re) => e.shareAnalysisModel.includeSchedulingLink = re),
                id: "checkScheduling",
                disabled: !e.hasSchedulingLink
              }, null, 8, rRe), [
                [Ue, e.shareAnalysisModel.includeSchedulingLink]
              ]),
              a("label", oRe, [
                t[24] || (t[24] = y(" Include Scheduling Link ")),
                e.hasSchedulingLink ? P("", !0) : (p(), h("i", iRe))
              ])
            ]),
            a("div", lRe, [
              a("button", {
                type: "button",
                class: "btn btn-lava",
                onClick: t[7] || (t[7] = (...re) => e.sendRequest && e.sendRequest(...re)),
                disabled: e.busy
              }, t[25] || (t[25] = [
                a("i", { class: "fa-light fa-envelope me-2" }, null, -1),
                y("Send")
              ]), 8, dRe)
            ])
          ])) : P("", !0)
        ])
      ])
    ], 512),
    t[45] || (t[45] = Bt('<div class="modal fade" id="modalPortfolioFinder" tabindex="-1" aria-labelledby="modalPortfolioFinderLabel" aria-hidden="true"><div class="modal-dialog modal-dialog-centered"><div class="modal-content bg-gradient-alphabet rounded"><div class="modal-header border-0 pb-0"><button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button></div><div class="px-4 pb-4 text-center"><img src="' + Xk + '" alt="Portfolio finder" title="Portfolio finder" width="416" height="370" loading="lazy"></div><div class="modal-body text-center"><p class="fs-5 mb-2 fw-bold">View Target on Portfolio Finder</p><p> Investigate the entire portfolio of leads who complete your rental analysis form and discover the whales you want to work with most. </p><a href="/enterprise/portfolio-finder" class="btn btn-lava mt-3">Learn more  <span class="d-none d-xxl-inline-block">about Portfolio Finder</span></a></div></div></div></div>', 1)),
    a("div", cRe, [
      a("div", uRe, [
        a("div", pRe, [
          t[43] || (t[43] = a("div", { class: "modal-header border-0 pb-0" }, [
            a("span", { class: "fs-5 modal-title fw-bold" }, " Rental Analysis "),
            a("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            })
          ], -1)),
          a("div", hRe, [
            a("div", mRe, [
              a("table", fRe, [
                a("tbody", null, [
                  a("tr", null, [
                    t[27] || (t[27] = a("th", null, " Address: ", -1)),
                    a("td", null, g((S = e.view) == null ? void 0 : S.addressSearched), 1)
                  ]),
                  a("tr", null, [
                    t[28] || (t[28] = a("th", null, " Name: ", -1)),
                    a("td", null, g((I = e.view) == null ? void 0 : I.name), 1)
                  ]),
                  a("tr", null, [
                    t[29] || (t[29] = a("th", null, " Email: ", -1)),
                    a("td", null, g((T = e.view) == null ? void 0 : T.email), 1)
                  ]),
                  a("tr", null, [
                    t[30] || (t[30] = a("th", null, " Phone: ", -1)),
                    a("td", null, g((x = e.view) == null ? void 0 : x.phone), 1)
                  ]),
                  a("tr", null, [
                    t[31] || (t[31] = a("th", null, " I am the current the property owner ", -1)),
                    a("td", null, [
                      (k = e.view) != null && k.currentOwner ? (p(), h(A, { key: 0 }, [
                        y(" Yes ")
                      ], 64)) : (p(), h(A, { key: 1 }, [
                        y(" No ")
                      ], 64))
                    ])
                  ]),
                  a("tr", null, [
                    t[32] || (t[32] = a("th", null, " Is this a short term rental/AirBNB property? ", -1)),
                    a("td", null, [
                      (C = e.view) != null && C.isShortTermRental ? (p(), h(A, { key: 0 }, [
                        y(" Yes ")
                      ], 64)) : (p(), h(A, { key: 1 }, [
                        y(" No ")
                      ], 64))
                    ])
                  ])
                ])
              ])
            ]),
            a("div", gRe, [
              a("table", vRe, [
                a("tbody", null, [
                  a("tr", null, [
                    t[33] || (t[33] = a("th", null, " Purchased Date: ", -1)),
                    a("td", null, g(e.date((O = e.view) == null ? void 0 : O.purchaseDate)), 1)
                  ]),
                  a("tr", null, [
                    t[34] || (t[34] = a("th", null, " Purchased Price: ", -1)),
                    a("td", null, g(e.currency((E = e.view) == null ? void 0 : E.purchaseAmount)), 1)
                  ])
                ])
              ])
            ]),
            a("div", yRe, [
              a("table", bRe, [
                a("tbody", null, [
                  a("tr", null, [
                    t[35] || (t[35] = a("th", null, " Do you currently have a loan? ", -1)),
                    a("td", null, [
                      (B = e.view) != null && B.hasCurrentLoan ? (p(), h(A, { key: 0 }, [
                        y(" Yes ")
                      ], 64)) : (p(), h(A, { key: 1 }, [
                        y(" No ")
                      ], 64))
                    ])
                  ]),
                  a("tr", null, [
                    t[36] || (t[36] = a("th", null, " Loan Date: ", -1)),
                    a("td", null, g(e.date((M = e.view) == null ? void 0 : M.loanDate)), 1)
                  ]),
                  a("tr", null, [
                    t[37] || (t[37] = a("th", null, " Loan Amount: ", -1)),
                    a("td", null, g(e.currency((R = e.view) == null ? void 0 : R.loanAmount)), 1)
                  ]),
                  a("tr", null, [
                    t[38] || (t[38] = a("th", null, " Interest Rate %: ", -1)),
                    a("td", null, g(e.percent((F = e.view) == null ? void 0 : F.loanInterestRate)), 1)
                  ]),
                  a("tr", null, [
                    t[39] || (t[39] = a("th", null, " Amortization Years: ", -1)),
                    a("td", null, g(e.number((L = e.view) == null ? void 0 : L.loanAmortizationYears)), 1)
                  ])
                ])
              ])
            ]),
            a("div", ARe, [
              a("table", wRe, [
                a("tbody", null, [
                  a("tr", null, [
                    t[40] || (t[40] = a("th", null, " Is the property currently in service as a rental property? ", -1)),
                    a("td", null, [
                      (j = e.view) != null && j.isCurrentRental ? (p(), h(A, { key: 0 }, [
                        y(" Yes ")
                      ], 64)) : (p(), h(A, { key: 1 }, [
                        y(" No ")
                      ], 64))
                    ])
                  ]),
                  a("tr", null, [
                    t[41] || (t[41] = a("th", null, " First Full Year as a Rental? ", -1)),
                    a("td", null, g((H = e.view) == null ? void 0 : H.firstYearAsRental), 1)
                  ]),
                  a("tr", null, [
                    t[42] || (t[42] = a("th", null, " Current Rental Rate? ", -1)),
                    a("td", null, g(e.currency((te = e.view) == null ? void 0 : te.currentRentalRate)), 1)
                  ])
                ])
              ])
            ])
          ]),
          t[44] || (t[44] = a("div", { class: "modal-footer border-0 pt-0" }, [
            a("button", {
              type: "button",
              class: "btn btn-secondary",
              "data-bs-dismiss": "modal"
            }, "Close")
          ], -1))
        ])
      ])
    ], 512)
  ])) : P("", !0);
}
const Fls = /* @__PURE__ */ Ae(S7e, [["render", CRe]]), SRe = me({
  name: "FeaturedInvestmentOpportunities",
  props: {},
  components: {},
  data() {
    return {
      featured: []
    };
  },
  computed: {
    ...q(Te, ["access", "aclLoaded"])
  },
  methods: {
    number: Ve,
    currency: Ze,
    percent: Wt
  },
  created() {
  },
  mounted() {
    this.aclLoaded.then(async () => {
      const e = await W.api.folio.getFeatured(Ga.Investment, 1, 10);
      e.data.page && (this.featured.length = 0, this.featured.push(...e.data.page.slice(0, 5)));
    });
  }
}), PRe = {
  key: 0,
  class: "card shadow-sm"
}, kRe = { class: "card-body" }, ERe = { class: "table-responsive" }, IRe = { class: "table table-sm" }, TRe = { class: "d-flex align-items-center" }, ORe = { class: "flex-shrink-0" }, RRe = ["src"], LRe = { class: "flex-grow-1 ms-3" }, BRe = { class: "list-inline m-0" }, MRe = { class: "list-inline-item" }, xRe = { class: "list-inline-item" }, FRe = { class: "list-inline-item" }, VRe = { class: "list-inline-item" }, DRe = { class: "card-footer text-end bg-white border-0" };
function NRe(e, t, s, n, r, i) {
  const o = pe("router-link");
  return e.featured.length > 0 ? (p(), h("div", PRe, [
    t[8] || (t[8] = a("div", { class: "card-header fw-bold border-0 bg-white fs-5 text-body-secondary pb-0" }, " Featured Investment Opportunities ", -1)),
    a("div", kRe, [
      a("div", ERe, [
        a("table", IRe, [
          t[6] || (t[6] = a("thead", null, [
            a("tr", null, [
              a("th", null, "Address"),
              a("th", null, "List Prices"),
              a("th", null, "Investment"),
              a("th", null, "Rental Rate"),
              a("th", null, "Cap"),
              a("th", null, "CoC"),
              a("th", null, "IRR"),
              a("th")
            ])
          ], -1)),
          a("tbody", null, [
            (p(!0), h(A, null, D(e.featured, (l) => (p(), h("tr", null, [
              a("td", null, [
                a("div", TRe, [
                  a("div", ORe, [
                    a("img", {
                      src: l.photo,
                      alt: "...",
                      width: "48",
                      height: "48",
                      class: "img-fluid rounded"
                    }, null, 8, RRe)
                  ]),
                  a("div", LRe, [
                    N(o, {
                      to: l.url
                    }, {
                      default: ve(() => [
                        y(g(l.address), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"]),
                    t[4] || (t[4] = a("br", null, null, -1)),
                    a("ul", BRe, [
                      a("li", MRe, [
                        t[0] || (t[0] = a("i", { class: "fa-light fa-ruler-triangle me-1" }, null, -1)),
                        y(" " + g(e.number(l.sqFt)) + " SF", 1)
                      ]),
                      a("li", xRe, [
                        t[1] || (t[1] = a("i", { class: "fa-light fa-bed me-1" }, null, -1)),
                        y(g(e.number(l.bedrooms)), 1)
                      ]),
                      a("li", FRe, [
                        t[2] || (t[2] = a("i", { class: "fa-light fa-shower me-1" }, null, -1)),
                        y(g(e.number(l.bathrooms)), 1)
                      ]),
                      a("li", VRe, [
                        t[3] || (t[3] = a("i", { class: "fa-light fa-cake-candles me-1" }, null, -1)),
                        y(g(e.number(l.yearBuilt)), 1)
                      ])
                    ])
                  ])
                ])
              ]),
              a("td", null, g(e.currency(l.listPrice)), 1),
              a("td", null, g(e.currency(l.initialInvestment)), 1),
              a("td", null, g(e.currency(l.rentalRate)), 1),
              a("td", null, g(e.percent(l.capRate)), 1),
              a("td", null, g(e.percent(l.coc)), 1),
              a("td", null, g(e.percent(l.irr)), 1),
              t[5] || (t[5] = a("td", null, [
                a("a", {
                  href: "#",
                  class: "btn btn-success btn-sm"
                }, "View")
              ], -1))
            ]))), 256))
          ])
        ])
      ])
    ]),
    a("div", DRe, [
      N(o, { name: "folio-featured" }, {
        default: ve(() => t[7] || (t[7] = [
          y("View All Featured Properties "),
          a("i", { class: "fa-light fa-arrow-right-long ms-2" }, null, -1)
        ])),
        _: 1,
        __: [7]
      })
    ])
  ])) : P("", !0);
}
const Vls = /* @__PURE__ */ Ae(SRe, [["render", NRe]]), jRe = me({
  name: "MlsListingInfo",
  data() {
    return {
      compLoading: !0
    };
  },
  computed: {
    ...at(qe),
    ...q(Te, ["acl", "aclLoaded"]),
    ...q(qe, ["propertyInitialized", "property"])
  },
  methods: {
    currency: Ze,
    shortDate: cs
  },
  mounted() {
    this.aclLoaded.then(async () => await this.propertyInitialized).finally(() => this.compLoading = !1);
  }
}), HRe = {
  key: 0,
  class: "card shadow-sm"
}, URe = { class: "d-flex align-items-center card-body" }, zRe = ["src", "alt", "title"], WRe = { class: "media-body flex-grow-1 ms-3" }, GRe = { class: "table border-top m-0" }, YRe = { class: "bt-0" };
function XRe(e, t, s, n, r, i) {
  var o, l, d, c, u, m, f, v, b, w, S, I, T, x, k, C, O, E, B, M, R, F, L, j, H;
  return !e.compLoading && ((o = e.property) != null && o.mlsSource) && ((d = (l = e.property) == null ? void 0 : l.mlsSource) == null ? void 0 : d.isOffmarket) != !0 ? (p(), h("div", HRe, [
    a("div", URe, [
      a("img", {
        src: "https://images.rescover.com/mls/images/" + ((u = (c = e.property) == null ? void 0 : c.mlsSource) == null ? void 0 : u.source) + ".png",
        class: "flex-shrink-0",
        alt: (f = (m = e.property) == null ? void 0 : m.mlsSource) == null ? void 0 : f.source,
        title: (b = (v = e.property) == null ? void 0 : v.mlsSource) == null ? void 0 : b.name,
        loading: "lazy",
        height: "70"
      }, null, 8, zRe),
      a("div", WRe, [
        a("b", null, g((S = (w = e.property) == null ? void 0 : w.mlsSource) == null ? void 0 : S.name), 1)
      ])
    ]),
    a("table", GRe, [
      a("tbody", null, [
        a("tr", null, [
          t[0] || (t[0] = a("td", { class: "text-center bt-0" }, [
            a("i", { class: "fa-light fa-dollar-sign" })
          ], -1)),
          t[1] || (t[1] = a("th", {
            class: "bt-0",
            scope: "row"
          }, " List Price: ", -1)),
          a("td", YRe, g(e.currency((T = (I = e.property) == null ? void 0 : I.mlsSource) == null ? void 0 : T.listPrice, 0)), 1)
        ]),
        a("tr", null, [
          t[2] || (t[2] = a("td", { class: "text-center" }, [
            a("i", { class: "fa-light fa-calendar-day" })
          ], -1)),
          t[3] || (t[3] = a("th", { scope: "row" }, " List date: ", -1)),
          a("td", null, g(e.shortDate((k = (x = e.property) == null ? void 0 : x.mlsSource) == null ? void 0 : k.listDate)), 1)
        ]),
        a("tr", null, [
          t[4] || (t[4] = a("td", { class: "text-center" }, [
            a("i", { class: "fa-light fa-calendar-week" })
          ], -1)),
          t[5] || (t[5] = a("th", { scope: "row" }, " Days on Rescover: ", -1)),
          a("td", null, g((O = (C = e.property) == null ? void 0 : C.mlsSource) == null ? void 0 : O.daysOnRescover), 1)
        ]),
        a("tr", null, [
          t[6] || (t[6] = a("td", { class: "text-center" }, [
            a("i", { class: "fa-light fa-database" })
          ], -1)),
          t[7] || (t[7] = a("th", { scope: "row" }, " MLS Source: ", -1)),
          a("td", null, g((M = (B = (E = e.property) == null ? void 0 : E.mlsSource) == null ? void 0 : B.source) == null ? void 0 : M.toUpperCase()), 1)
        ]),
        a("tr", null, [
          t[8] || (t[8] = a("td", { class: "text-center" }, [
            a("i", { class: "fa-light fa-passport" })
          ], -1)),
          t[9] || (t[9] = a("th", { scope: "row" }, " MLS Number: ", -1)),
          a("td", null, g((F = (R = e.property) == null ? void 0 : R.mlsSource) == null ? void 0 : F.number), 1)
        ]),
        a("tr", null, [
          a("td", {
            class: z(["text-center", (L = e.property) != null && L.propId ? "text-success" : ""])
          }, t[10] || (t[10] = [
            a("i", { class: "fa-light fa-calendar-alt" }, null, -1)
          ]), 2),
          t[11] || (t[11] = a("th", { scope: "row" }, " MLS Data Sync: ", -1)),
          a("td", null, g(e.shortDate((H = (j = e.property) == null ? void 0 : j.mlsSource) == null ? void 0 : H.lastSync)), 1)
        ])
      ])
    ])
  ])) : P("", !0);
}
const Dls = /* @__PURE__ */ Ae(jRe, [["render", XRe]]), qRe = me({
  name: "MlsAgentInfo",
  data() {
    return {
      compLoading: !0
    };
  },
  computed: {
    ...at(qe),
    ...q(Te, ["acl", "aclLoaded"]),
    ...q(qe, ["propertyInitialized", "property"])
  },
  methods: {
    currency: Ze,
    shortDate: cs
  },
  mounted() {
    this.aclLoaded.then(async () => await this.propertyInitialized).finally(() => this.compLoading = !1);
  }
}), QRe = {
  key: 0,
  class: "card shadow-sm"
}, KRe = { class: "d-flex align-items-center card-body" }, ZRe = { class: "media-body flex-grow-1 ms-3" }, JRe = { href: "tel:{{property?.mlsSource?.sellingAgent?.cell}}" }, $Re = { href: "tel:{{property?.mlsSource?.sellingAgent?.office}}" }, _Re = { href: "tel:{{property?.mlsSource?.sellingAgent?.broker?.phone}}" }, eLe = { href: "tel:{{property?.mlsSource?.sellingAgent?.broker?.phone}}" };
function tLe(e, t, s, n, r, i) {
  var o, l, d, c, u, m, f, v, b, w, S, I, T, x, k, C, O, E, B, M, R, F, L, j, H, te, re, le, ie, ye, Y, ae, ke, ue, oe, fe, we, Ie, be, Oe, ze, Re, ge, he, Me, Ne, $e, mt, yt, Ct, gt, Ge, Ee, Ce, xe, Pe, it, lt, dt;
  return !e.compLoading && ((o = e.property) != null && o.mlsSource) && ((d = (l = e.property) == null ? void 0 : l.mlsSource) == null ? void 0 : d.isOffmarket) != !0 ? (p(), h("div", QRe, [
    a("div", KRe, [
      t[12] || (t[12] = a("img", {
        src: Hk,
        class: "rounded-circle flex-shrink-0",
        alt: "Avatar",
        title: "Avatar",
        width: "70 ",
        height: "70",
        loading: "lazy"
      }, null, -1)),
      a("div", ZRe, [
        t[10] || (t[10] = a("b", null, "Listing Agent: ", -1)),
        y(g((m = (u = (c = e.property) == null ? void 0 : c.mlsSource) == null ? void 0 : u.sellingAgent) == null ? void 0 : m.firstName) + " " + g((b = (v = (f = e.property) == null ? void 0 : f.mlsSource) == null ? void 0 : v.sellingAgent) == null ? void 0 : b.lastName) + " ", 1),
        t[11] || (t[11] = a("br", null, null, -1)),
        (I = (S = (w = e.property) == null ? void 0 : w.mlsSource) == null ? void 0 : S.sellingAgent) != null && I.cell ? (p(), h(A, { key: 0 }, [
          t[0] || (t[0] = a("b", null, "Agent Mobile: ", -1)),
          a("a", JRe, g((k = (x = (T = e.property) == null ? void 0 : T.mlsSource) == null ? void 0 : x.sellingAgent) == null ? void 0 : k.cell), 1),
          t[1] || (t[1] = a("br", null, null, -1))
        ], 64)) : (E = (O = (C = e.property) == null ? void 0 : C.mlsSource) == null ? void 0 : O.sellingAgent) != null && E.office ? (p(), h(A, { key: 1 }, [
          t[2] || (t[2] = a("b", null, "Agent Office: ", -1)),
          a("a", $Re, g((R = (M = (B = e.property) == null ? void 0 : B.mlsSource) == null ? void 0 : M.sellingAgent) == null ? void 0 : R.office), 1),
          t[3] || (t[3] = a("br", null, null, -1))
        ], 64)) : (H = (j = (L = (F = e.property) == null ? void 0 : F.mlsSource) == null ? void 0 : L.sellingAgent) == null ? void 0 : j.broker) != null && H.phone && ((re = (te = e.property) == null ? void 0 : te.mlsSource) == null ? void 0 : re.isActiveMarketplaceListing) == !1 ? (p(), h(A, { key: 2 }, [
          t[4] || (t[4] = a("b", null, "Broker Phone: ", -1)),
          a("a", _Re, g((Y = (ye = (ie = (le = e.property) == null ? void 0 : le.mlsSource) == null ? void 0 : ie.sellingAgent) == null ? void 0 : ye.broker) == null ? void 0 : Y.phone), 1),
          t[5] || (t[5] = a("br", null, null, -1))
        ], 64)) : (oe = (ue = (ke = (ae = e.property) == null ? void 0 : ae.mlsSource) == null ? void 0 : ke.sellingAgent) == null ? void 0 : ue.broker) != null && oe.phone && ((we = (fe = e.property) == null ? void 0 : fe.mlsSource) == null ? void 0 : we.isActiveMarketplaceListing) == !0 ? (p(), h(A, { key: 3 }, [
          t[6] || (t[6] = a("b", null, "Company Phone: ", -1)),
          a("a", eLe, g((ze = (Oe = (be = (Ie = e.property) == null ? void 0 : Ie.mlsSource) == null ? void 0 : be.sellingAgent) == null ? void 0 : Oe.broker) == null ? void 0 : ze.phone), 1),
          t[7] || (t[7] = a("br", null, null, -1))
        ], 64)) : P("", !0),
        (Me = (he = (ge = (Re = e.property) == null ? void 0 : Re.mlsSource) == null ? void 0 : ge.sellingAgent) == null ? void 0 : he.broker) != null && Me.name && (($e = (Ne = e.property) == null ? void 0 : Ne.mlsSource) == null ? void 0 : $e.isActiveMarketplaceListing) == !0 ? (p(), h(A, { key: 4 }, [
          t[8] || (t[8] = a("b", null, "Company: ", -1)),
          y(" " + g((gt = (Ct = (yt = (mt = e.property) == null ? void 0 : mt.mlsSource) == null ? void 0 : yt.sellingAgent) == null ? void 0 : Ct.broker) == null ? void 0 : gt.name), 1)
        ], 64)) : (xe = (Ce = (Ee = (Ge = e.property) == null ? void 0 : Ge.mlsSource) == null ? void 0 : Ee.sellingAgent) == null ? void 0 : Ce.broker) != null && xe.name ? (p(), h(A, { key: 5 }, [
          t[9] || (t[9] = a("b", null, "Broker: ", -1)),
          y(" " + g((dt = (lt = (it = (Pe = e.property) == null ? void 0 : Pe.mlsSource) == null ? void 0 : it.sellingAgent) == null ? void 0 : lt.broker) == null ? void 0 : dt.name), 1)
        ], 64)) : P("", !0)
      ])
    ])
  ])) : P("", !0);
}
const Nls = /* @__PURE__ */ Ae(qRe, [["render", tLe]]), H2 = 1900, sLe = (/* @__PURE__ */ new Date()).getFullYear(), aLe = me({
  name: "EditPropertyDetailsDialog",
  emits: ["updated"],
  data() {
    return {
      step: 1,
      alerts: []
    };
  },
  computed: {
    poolOption: {
      get() {
        var e, t, s;
        return ((t = (e = this.propertyDetails) == null ? void 0 : e.poolFeatures) == null ? void 0 : t.length) > 0 ? (s = this.propertyDetails) == null ? void 0 : s.poolFeatures[0].trim() : "None";
      },
      set(e) {
        return this.propertyDetails.poolFeatures = [e];
      }
    },
    floorOption: {
      get() {
        var e, t;
        return (e = this.propertyDetails) != null && e.flooring ? (t = this.propertyDetails) == null ? void 0 : t.flooring.split(",")[0].trim() : "None";
      },
      set(e) {
        return this.propertyDetails.flooring = e;
      }
    },
    roofOption: {
      get() {
        var e, t, s;
        return (e = this.propertyDetails) != null && e.roof ? (s = (t = this.propertyDetails) == null ? void 0 : t.roof[0]) == null ? void 0 : s.trim() : "";
      },
      set(e) {
        return this.propertyDetails.roof = [e];
      }
    },
    yearList() {
      return Array.from({ length: sLe - H2 }, (e, t) => H2 + t);
    },
    alertMesage() {
      if (this.squareFootageValid == !1)
        return "It looks like we are missing some important details about this property. Please review and correct the information below.";
      if (this.alerts.length > 0)
        return this.alerts.join(`\r
 `);
    },
    squareFootageStyle() {
      return {
        "is-invalid": this.squareFootageValid == !1
      };
    },
    propertyType: {
      set(e) {
        this.propertyTypeOverriden || (this.propertyDetails.propertyType = e);
      },
      get() {
        var e, t;
        if (this.propertyTypeOverriden)
          switch ((e = this.property) == null ? void 0 : e.propertyType) {
            case Qa.MultiFamily:
              switch (this.property.unitCount) {
                case 2:
                  return "Duplex";
                case 3:
                  return "Triplex";
                case 4:
                  return "Quadruplex";
              }
              return "";
            case Qa.Commercial:
              return "Apartment";
          }
        return (t = this.propertyDetails) == null ? void 0 : t.propertyType;
      }
    },
    ...at(qe),
    ...q(qe, ["property", "propertyTypeOverriden", "squareFootageValid", "propertyDetails", "propertyInitialized"]),
    ...q(Te, ["acl", "aclLoaded"])
  },
  methods: {
    number: Ve,
    async getPropertyDetails() {
      try {
        if (!this.propertyStore.propertyLoaded)
          return;
        await this.propertyStore.getPropertyDetails(), this.squareFootageValid == !1 && this.acl.isAnonymous != !0 && this.$nextTick(() => this.showDialog());
      } catch (e) {
        Se(e);
      }
    },
    async updateProperty() {
      try {
        await this.propertyStore.updatePropertyDetails(), this.step++, this.$emit("updated", this.propertyDetails);
      } catch (e) {
        Se(e);
      }
    },
    showDialog() {
      this.$refs.editPropertiesDialog && bootstrap.Modal.getOrCreateInstance(this.$refs.editPropertiesDialog).show();
    },
    closeDialog() {
      bootstrap.Modal.getOrCreateInstance(this.$refs.editPropertiesDialog).hide(), this.step = 1;
    }
  },
  mounted() {
    this.aclLoaded.then(async () => await this.propertyInitialized).then(async () => await this.getPropertyDetails());
  }
}), nLe = {
  key: 0,
  class: "modal fade",
  ref: "editPropertiesDialog",
  id: "editPropertiesDialog",
  tabindex: "-1",
  "aria-labelledby": "editPropertiesDialogLabel",
  "aria-hidden": "true"
}, rLe = { class: "modal-dialog modal-lg modal-dialog-centered" }, oLe = { class: "modal-content bg-gradient-alphabet rounded" }, iLe = { class: "modal-header" }, lLe = { class: "ms-auto" }, dLe = { class: "text-secondary text-opacity-50" }, cLe = { class: "modal-body p-0" }, uLe = { key: 0 }, pLe = { class: "bg-white bg-opacity-50 p-3 p-md-4 mb-4" }, hLe = {
  key: 0,
  class: "alert alert-warning mt-3 mb-0",
  role: "alert"
}, mLe = { class: "px-4 pb-4" }, fLe = { class: "row row-cols-1 row-cols-md-2 g-0 mb-3" }, gLe = { class: "col listing-photo" }, vLe = { class: "w-100 rounded gallery-banner mlse-gallery d-flex justify-content-center align-items-center launchGallery position-relative overflow-hidden" }, yLe = ["src"], bLe = { class: "col d-flex align-items-baseline p-md-3" }, ALe = { class: "fw-bold fs-5" }, wLe = { class: "row g-3 mb-3" }, CLe = { class: "col-md-6" }, SLe = ["disabled"], PLe = {
  key: 0,
  id: "propertyTypeHelp",
  class: "form-text"
}, kLe = { class: "col-md-6" }, ELe = { class: "input-group has-validation" }, ILe = {
  key: 0,
  id: "squareFootageFeedback",
  class: "invalid-feedback"
}, TLe = { class: "col-md-6" }, OLe = ["value"], RLe = { class: "col-md-6" }, LLe = { class: "col-md-6" }, BLe = { class: "col-md-6" }, MLe = { class: "input-group" }, xLe = { class: "d-flex justify-content-between align-items-center pt-3 border-top mt-5" }, FLe = { key: 1 }, VLe = { class: "bg-white bg-opacity-50 p-4 mb-4" }, DLe = {
  key: 0,
  class: "alert alert-warning mt-3 mb-0",
  role: "alert"
}, NLe = { class: "px-4 pb-4" }, jLe = { class: "row g-3 mb-3" }, HLe = { class: "col-md-6" }, ULe = { class: "col-md-6" }, zLe = { class: "col-md-6" }, WLe = { class: "col-md-6" }, GLe = { class: "col-md-6" }, YLe = { class: "col-md-6" }, XLe = { class: "col-md-6" }, qLe = { class: "col-md-6" }, QLe = { class: "col-md-6" }, KLe = { class: "col-md-6" }, ZLe = { class: "col-md-6" }, JLe = { class: "d-flex justify-content-between align-items-center pt-3 border-top mt-5" }, $Le = { key: 2 }, _Le = { class: "p-10 text-center" };
function eBe(e, t, s, n, r, i) {
  var o, l, d, c, u, m;
  return e.propertyDetails ? (p(), h("div", nLe, [
    a("div", rLe, [
      a("div", oLe, [
        a("div", iLe, [
          t[22] || (t[22] = a("p", {
            class: "modal-title fs-5 fw-bold mb-0",
            id: "editPropertiesDialogLabel"
          }, "Edit Details", -1)),
          a("span", lLe, [
            a("span", dLe, "Step " + g(e.step), 1),
            a("button", {
              type: "button",
              class: "btn-close ms-2",
              "aria-label": "Close",
              onClick: t[0] || (t[0] = (...f) => e.closeDialog && e.closeDialog(...f))
            })
          ])
        ]),
        a("div", cLe, [
          e.step == 1 ? (p(), h("div", uLe, [
            t[39] || (t[39] = a("div", {
              class: "progress rounded-0",
              role: "progressbar",
              "aria-label": "Basic example",
              "aria-valuenow": "33",
              "aria-valuemin": "0",
              "aria-valuemax": "100",
              style: { height: "4px" }
            }, [
              a("div", {
                class: "progress-bar bg-lava",
                style: { width: "33%" }
              })
            ], -1)),
            a("div", pLe, [
              t[23] || (t[23] = a("b", null, "Please verify the property details listed below.", -1)),
              t[24] || (t[24] = a("br", null, null, -1)),
              t[25] || (t[25] = y(" Our property data comes from the MLS and other sources. If anything's wrong, you can correct it here. Updates will be visible to you and anyone you share reports with. ")),
              e.alertMesage ? (p(), h("div", hLe, g(e.alertMesage), 1)) : P("", !0)
            ]),
            a("div", mLe, [
              a("div", fLe, [
                a("div", gLe, [
                  a("div", vLe, [
                    (o = e.property) != null && o.mainPhoto ? (p(), h("img", {
                      key: 0,
                      src: (l = e.property) == null ? void 0 : l.mainPhoto,
                      class: "img-fluid",
                      height: "300",
                      loading: "lazy",
                      alt: "",
                      title: ""
                    }, null, 8, yLe)) : P("", !0)
                  ])
                ]),
                a("div", bLe, [
                  a("div", ALe, [
                    y(g((d = e.propertyDetails) == null ? void 0 : d.address), 1),
                    t[26] || (t[26] = a("br", null, null, -1)),
                    y(" " + g((c = e.propertyDetails) == null ? void 0 : c.city) + ", " + g((u = e.propertyDetails) == null ? void 0 : u.state) + " " + g((m = e.propertyDetails) == null ? void 0 : m.zip), 1)
                  ])
                ])
              ]),
              a("div", wLe, [
                a("div", CLe, [
                  t[29] || (t[29] = a("label", {
                    class: "form-label",
                    for: "propertyType"
                  }, "Property Type", -1)),
                  V(a("select", {
                    class: "form-select",
                    id: "propertyType",
                    "onUpdate:modelValue": t[1] || (t[1] = (f) => e.propertyType = f),
                    disabled: e.propertyTypeOverriden,
                    "aria-describedby": "propertyTypeHelp"
                  }, t[27] || (t[27] = [
                    Bt('<option value="Agriculture">Agriculture</option><option value="Apartment">Apartment</option><option value="Boat Slip">Boat Slip</option><option value="Business">Business</option><option value="Cabin">Cabin</option><option value="Condominium">Condominium</option><option value="Deeded Parking">Deeded Parking</option><option value="Duplex">Duplex</option><option value="Farm">Farm</option><option value="Hotel/Motel">Hotel/Motel</option><option value="Industrial">Industrial</option><option value="Manufactured Home">Manufactured Home</option><option value="Manufactured On Land">Manufactured On Land</option><option value="Mixed Use">Mixed Use</option><option value="Mobile Home">Mobile Home</option><option value="Multi Family">Multi Family</option><option value="Office">Office</option><option value="Own Your Own">Own Your Own</option><option value="Quadruplex">Quadruplex</option><option value="Ranch">Ranch</option><option value="Retail">Retail</option><option value="Single Family Residence">Single Family Residence</option><option value="Stock Cooperative">Stock Cooperative</option><option value="Timeshare">Timeshare</option><option value="Townhouse">Townhouse</option><option value="Triplex">Triplex</option><option value="Unimproved Land">Unimproved Land</option><option value="Warehouse">Warehouse</option>', 28)
                  ]), 8, SLe), [
                    [We, e.propertyType]
                  ]),
                  e.propertyTypeOverriden ? (p(), h("div", PLe, t[28] || (t[28] = [
                    y("Property type applied already within "),
                    a("i", null, "Analysis Style", -1),
                    y(" dialog.")
                  ]))) : P("", !0)
                ]),
                a("div", kLe, [
                  t[31] || (t[31] = a("label", {
                    class: "form-label",
                    for: "squareFootage"
                  }, "Square Footage", -1)),
                  a("div", ELe, [
                    V(a("input", {
                      id: "squareFootage",
                      type: "text",
                      class: z(["form-control", e.squareFootageStyle]),
                      placeholder: "Square Footage",
                      "aria-label": "Square Footage",
                      "aria-describedby": "squareFootageAppend squareFootageFeedback",
                      required: "",
                      "onUpdate:modelValue": t[2] || (t[2] = (f) => e.propertyDetails.sqFt = f)
                    }, null, 2), [
                      [_e, e.propertyDetails.sqFt]
                    ]),
                    t[30] || (t[30] = a("span", {
                      id: "squareFootageAppend",
                      class: "input-group-text"
                    }, "SQ FT", -1)),
                    e.squareFootageValid ? P("", !0) : (p(), h("div", ILe, " Square Footage must be greater than 0! "))
                  ])
                ]),
                a("div", TLe, [
                  t[32] || (t[32] = a("label", {
                    class: "form-label",
                    for: "yearBuilt"
                  }, "Year Built", -1)),
                  V(a("select", {
                    class: "form-select",
                    id: "yearBuilt",
                    "onUpdate:modelValue": t[3] || (t[3] = (f) => e.propertyDetails.yearBuilt = f)
                  }, [
                    (p(!0), h(A, null, D(e.yearList, (f) => (p(), h("option", {
                      value: f,
                      key: f
                    }, g(f), 9, OLe))), 128))
                  ], 512), [
                    [We, e.propertyDetails.yearBuilt]
                  ])
                ]),
                a("div", RLe, [
                  t[34] || (t[34] = a("label", {
                    class: "form-label",
                    for: "bedrooms"
                  }, "Bedrooms", -1)),
                  V(a("select", {
                    class: "form-select",
                    id: "bedrooms",
                    "onUpdate:modelValue": t[4] || (t[4] = (f) => e.propertyDetails.bedrooms = f)
                  }, t[33] || (t[33] = [
                    Bt('<option value="0">Unknown</option><option value="1">1</option><option value="2">2</option><option value="3">3</option><option value="4">4</option><option value="5">5</option><option value="6">6</option><option value="7">7</option><option value="8">8</option><option value="9">9</option><option value="10">10</option><option value="11">11</option><option value="12">12</option><option value="13">13</option><option value="14">14</option><option value="15">15</option><option value="16">16</option><option value="17">17</option><option value="18">18</option><option value="19">19</option><option value="20">20</option>', 21)
                  ]), 512), [
                    [We, e.propertyDetails.bedrooms]
                  ])
                ]),
                a("div", LLe, [
                  t[36] || (t[36] = a("label", {
                    class: "form-label",
                    for: "bathrooms"
                  }, "Bathrooms", -1)),
                  V(a("select", {
                    class: "form-select",
                    id: "bathrooms",
                    "onUpdate:modelValue": t[5] || (t[5] = (f) => e.propertyDetails.bathrooms = f)
                  }, t[35] || (t[35] = [
                    a("option", { value: 0 }, "Unknown", -1),
                    a("option", { value: 1 }, "1", -1),
                    a("option", { value: 2 }, "2", -1),
                    a("option", { value: 2.1 }, "2.1", -1),
                    a("option", { value: 3 }, "3", -1),
                    a("option", { value: 3.1 }, "3.1", -1),
                    a("option", { value: 3.2 }, "3.2", -1),
                    a("option", { value: 4 }, "4", -1),
                    a("option", { value: 4.1 }, "4.1", -1),
                    a("option", { value: 4.2 }, "4.2", -1),
                    a("option", { value: 4.3 }, "4.3", -1),
                    a("option", { value: 5 }, "5", -1),
                    a("option", { value: 5.1 }, "5.1", -1),
                    a("option", { value: 5.2 }, "5.2", -1),
                    a("option", { value: 5.3 }, "5.3", -1),
                    a("option", { value: 6 }, "6", -1),
                    a("option", { value: 6.1 }, "6.1", -1),
                    a("option", { value: 6.2 }, "6.2", -1),
                    a("option", { value: 6.3 }, "6.3", -1)
                  ]), 512), [
                    [We, e.propertyDetails.bathrooms]
                  ])
                ]),
                a("div", BLe, [
                  t[38] || (t[38] = a("label", {
                    class: "form-label",
                    for: "lotSize"
                  }, "Lot Size", -1)),
                  a("div", MLe, [
                    V(a("input", {
                      type: "text",
                      class: "form-control",
                      placeholder: "Lot Size",
                      "aria-label": "Lot Size",
                      id: "lotSize",
                      "onUpdate:modelValue": t[6] || (t[6] = (f) => e.propertyDetails.lotSize = f)
                    }, null, 512), [
                      [_e, e.propertyDetails.lotSize]
                    ]),
                    t[37] || (t[37] = a("span", { class: "input-group-text" }, "SQ FT", -1))
                  ])
                ])
              ]),
              a("div", xLe, [
                a("button", {
                  type: "button",
                  class: "btn btn-lava ms-auto",
                  onClick: t[7] || (t[7] = (f) => e.step++)
                }, "Next")
              ])
            ])
          ])) : P("", !0),
          e.step == 2 ? (p(), h("div", FLe, [
            t[68] || (t[68] = a("div", {
              class: "progress rounded-0",
              role: "progressbar",
              "aria-label": "Basic example",
              "aria-valuenow": "66",
              "aria-valuemin": "0",
              "aria-valuemax": "100",
              style: { height: "4px" }
            }, [
              a("div", {
                class: "progress-bar bg-lava",
                style: { width: "66%" }
              })
            ], -1)),
            a("div", VLe, [
              t[40] || (t[40] = a("b", null, "Please verify the property details listed below.", -1)),
              t[41] || (t[41] = a("br", null, null, -1)),
              t[42] || (t[42] = y(" Our property data comes from the MLS and other sources. If anything's wrong, you can correct it here. Updates will be visible to you and anyone you share reports with. ")),
              e.alertMesage ? (p(), h("div", DLe, g(e.alertMesage), 1)) : P("", !0)
            ]),
            a("div", NLe, [
              a("div", jLe, [
                a("div", HLe, [
                  t[44] || (t[44] = a("label", {
                    class: "form-label",
                    for: "stories"
                  }, "Stories", -1)),
                  V(a("select", {
                    class: "form-select",
                    id: "stories",
                    "onUpdate:modelValue": t[8] || (t[8] = (f) => e.propertyDetails.stories = f)
                  }, t[43] || (t[43] = [
                    Bt('<option value="0">Unknown</option><option value="1">1</option><option value="2">2</option><option value="3">3</option><option value="4">4</option><option value="5">5</option><option value="6">6</option>', 7)
                  ]), 512), [
                    [We, e.propertyDetails.stories]
                  ])
                ]),
                a("div", ULe, [
                  t[46] || (t[46] = a("label", {
                    class: "form-label",
                    for: "garage"
                  }, "Garage", -1)),
                  V(a("select", {
                    class: "form-select",
                    id: "garage",
                    "onUpdate:modelValue": t[9] || (t[9] = (f) => e.propertyDetails.garageSpaces = f)
                  }, t[45] || (t[45] = [
                    Bt('<option value="0">None</option><option value="1">1</option><option value="2">2</option><option value="3">3</option><option value="4">4</option><option value="5">5</option><option value="6">6</option><option value="7">7</option><option value="8">8</option><option value="9">9</option><option value="10">10</option>', 11)
                  ]), 512), [
                    [We, e.propertyDetails.garageSpaces]
                  ])
                ]),
                a("div", zLe, [
                  t[48] || (t[48] = a("label", {
                    class: "form-label",
                    for: "style"
                  }, "Style", -1)),
                  V(a("select", {
                    class: "form-select",
                    id: "style",
                    "onUpdate:modelValue": t[10] || (t[10] = (f) => e.propertyDetails.style = f)
                  }, t[47] || (t[47] = [
                    Bt('<option value="A-Frame">A-Frame</option><option value="Antique">Antique</option><option value="Bungalow">Bungalow</option><option value="Cabin">Cabin</option><option value="Cape Cod">Cape Cod</option><option value="Chalet">Chalet</option><option value="Colonial">Colonial</option><option value="Commercial">Commercial</option><option value="Condo/Apartment">Condo/Apartment</option><option value="Contemporary">Contemporary</option><option value="Conventional">Conventional</option><option value="Cottage">Cottage</option><option value="Decker">Decker</option><option value="Dome">Dome</option><option value="Duplex Double">Duplex Double</option><option value="Duplex Single">Duplex Single</option><option value="Dutch Colonial">Dutch Colonial</option><option value="English">English</option><option value="European">European</option><option value="Farm House">Farm House</option><option value="French">French</option><option value="Gambrel">Gambrel</option><option value="Garrison">Garrison</option><option value="Georgian">Georgian</option><option value="Loft">Loft</option><option value="Log Home">Log Home</option><option value="Manufactured">Manufactured</option><option value="Mediterranean">Mediterranean</option><option value="Mobile Home">Mobile Home</option><option value="Modern">Modern</option><option value="Mountain">Mountain</option><option value="New Tradition">New Tradition</option><option value="Other">Other</option><option value="Penthouse">Penthouse</option><option value="Quadraplex">Quadraplex</option><option value="Raised Ranch">Raised Ranch</option><option value="Rambler">Rambler</option><option value="Ranch">Ranch</option><option value="Revival">Revival</option><option value="Row">Row</option><option value="Rustic">Rustic</option><option value="Southwestern">Southwestern</option><option value="Spanish">Spanish</option><option value="Split Entry">Split Entry</option><option value="Split Level">Split Level</option><option value="Stack">Stack</option><option value="Studio">Studio</option><option value="Townhouse">Townhouse</option><option value="Traditional">Traditional</option><option value="Triplex">Triplex</option><option value="Tudor">Tudor</option><option value="Unknown">Unknown</option><option value="Victorian">Victorian</option>', 53)
                  ]), 512), [
                    [We, e.propertyDetails.style]
                  ])
                ]),
                a("div", WLe, [
                  t[50] || (t[50] = a("label", {
                    class: "form-label",
                    for: "pool"
                  }, "Pool", -1)),
                  V(a("select", {
                    class: "form-select",
                    id: "pool",
                    "onUpdate:modelValue": t[11] || (t[11] = (f) => e.poolOption = f)
                  }, t[49] || (t[49] = [
                    Bt('<option value="">None</option><option value="Above Ground">Above Ground</option><option value="Association">Association</option><option value="Black Bottom">Black Bottom</option><option value="Cabana">Cabana</option><option value="Community">Community</option><option value="Diving Board">Diving Board</option><option value="Electric Heat">Electric Heat</option><option value="ENERGY STAR Qualified pool pump">ENERGY STAR Qualified pool pump</option><option value="Fenced">Fenced</option><option value="Fiberglass">Fiberglass</option><option value="Filtered">Filtered</option><option value="Gas Heat">Gas Heat</option><option value="Gunite">Gunite</option><option value="Heated">Heated</option><option value="Indoor">Indoor</option><option value="Infinity">Infinity</option><option value="In Ground">In Ground</option><option value="Lap">Lap</option><option value="Liner">Liner</option><option value="None">None</option><option value="Other">Other</option><option value="Outdoor Pool">Outdoor Pool</option><option value="Pool/Spa Combo">Pool/Spa Combo</option><option value="Pool Cover">Pool Cover</option><option value="Pool Sweep">Pool Sweep</option><option value="Private">Private</option><option value="Salt Water">Salt Water</option><option value="Screen Enclosure">Screen Enclosure</option><option value="See Remarks">See Remarks</option><option value="Solar Cover">Solar Cover</option><option value="Solar Heat">Solar Heat</option><option value="Sport">Sport</option><option value="Tile">Tile</option><option value="Vinyl">Vinyl</option><option value="Waterfall">Waterfall</option>', 36)
                  ]), 512), [
                    [We, e.poolOption]
                  ])
                ]),
                t[65] || (t[65] = a("div", { class: "col-12" }, [
                  a("hr", { class: "mb-5" }),
                  a("span", { class: "fw-bold text-secondary text-opacity-50" }, "INTERIOR DETAILS")
                ], -1)),
                a("div", GLe, [
                  t[52] || (t[52] = a("label", {
                    class: "form-label",
                    id: "flooring"
                  }, "Flooring", -1)),
                  V(a("select", {
                    class: "form-select",
                    id: "flooring",
                    "onUpdate:modelValue": t[12] || (t[12] = (f) => e.floorOption = f)
                  }, t[51] || (t[51] = [
                    Bt('<option value="">None</option><option value="Adobe">Adobe</option><option value="Bamboo">Bamboo</option><option value="Brick">Brick</option><option value="Carpet">Carpet</option><option value="Ceramic Tile">Ceramic Tile</option><option value="Clay">Clay</option><option value="Combination">Combination</option><option value="Concrete">Concrete</option><option value="Cork">Cork</option><option value="CRI Green Label Plus Certified Carpet">CRI Green Label Plus Certified Carpet</option><option value="Dirt">Dirt</option><option value="FloorScore(r) Certified Flooring">FloorScore(r) Certified Flooring</option><option value="FSC or SFI Certified Source Hardwood">FSC or SFI Certified Source Hardwood</option><option value="Granite">Granite</option><option value="Hardwood">Hardwood</option><option value="Laminate">Laminate</option><option value="Linoleum">Linoleum</option><option value="Marble">Marble</option><option value="None">None</option><option value="Other">Other</option><option value="Painted/Stained">Painted/Stained</option><option value="Parquet">Parquet</option><option value="Pavers">Pavers</option><option value="Reclaimed Wood">Reclaimed Wood</option><option value="See Remarks">See Remarks</option><option value="Simulated Wood">Simulated Wood</option><option value="Slate">Slate</option><option value="Softwood">Softwood</option><option value="Stamped">Stamped</option><option value="Stone">Stone</option><option value="Sustainable">Sustainable</option><option value="Terrazzo">Terrazzo</option><option value="Tile">Tile</option><option value="Varies">Varies</option><option value="Vinyl">Vinyl</option><option value="Wood">Wood</option>', 37)
                  ]), 512), [
                    [We, e.floorOption]
                  ])
                ]),
                a("div", YLe, [
                  t[54] || (t[54] = a("label", {
                    class: "form-label",
                    for: "cooling"
                  }, "Cooling", -1)),
                  V(a("select", {
                    class: "form-select",
                    id: "cooling",
                    "onUpdate:modelValue": t[13] || (t[13] = (f) => e.propertyDetails.cooling = f)
                  }, t[53] || (t[53] = [
                    Bt('<option value="">None</option><option value="Attic Fan">Attic Fan</option><option value="Ceiling Fan(s)">Ceiling Fan(s)</option><option value="Central Air">Central Air</option><option value="Dual">Dual</option><option value="Ductless">Ductless</option><option value="Electric">Electric</option><option value="ENERGY STAR Qualified Equipment">ENERGY STAR Qualified Equipment</option><option value="Evaporative Cooling">Evaporative Cooling</option><option value="Exhaust Fan">Exhaust Fan</option><option value="Gas">Gas</option><option value="Geothermal">Geothermal</option><option value="Heat Pump">Heat Pump</option><option value="Humidity Control">Humidity Control</option><option value="Multi Units">Multi Units</option><option value="None">None</option><option value="Other">Other</option><option value="Roof Turbine(s)">Roof Turbine(s)</option><option value="Separate Meters">Separate Meters</option><option value="Varies by Unit">Varies by Unit</option><option value="Wall/Window Unit(s)">Wall/Window Unit(s)</option><option value="Wall Unit(s)">Wall Unit(s)</option><option value="Whole House Fan">Whole House Fan</option><option value="Window Unit(s)">Window Unit(s)</option><option value="Zoned">Zoned</option>', 25)
                  ]), 512), [
                    [We, e.propertyDetails.cooling]
                  ])
                ]),
                a("div", XLe, [
                  t[56] || (t[56] = a("label", {
                    class: "form-label",
                    for: "heating"
                  }, "Heating", -1)),
                  V(a("select", {
                    class: "form-select",
                    id: "heating",
                    "onUpdate:modelValue": t[14] || (t[14] = (f) => e.propertyDetails.heating = f)
                  }, t[55] || (t[55] = [
                    Bt('<option value="">None</option><option value="Active Solar">Active Solar</option><option value="Baseboard">Baseboard</option><option value="Ceiling">Ceiling</option><option value="Central">Central</option><option value="Coal">Coal</option><option value="Coal Stove">Coal Stove</option><option value="Ductless">Ductless</option><option value="Electric">Electric</option><option value="ENERGY STAR/ACCA RSI Qualified Installation">ENERGY STAR/ACCA RSI Qualified Installation</option><option value="ENERGY STAR Qualified Equipment">ENERGY STAR Qualified Equipment</option><option value="Exhaust Fan">Exhaust Fan</option><option value="Fireplace(s)">Fireplace(s)</option><option value="Fireplace Insert">Fireplace Insert</option><option value="Floor Furnace">Floor Furnace</option><option value="Forced Air">Forced Air</option><option value="Geothermal">Geothermal</option><option value="Gravity">Gravity</option><option value="Heat Pump">Heat Pump</option><option value="Hot Water">Hot Water</option><option value="Humidity Control">Humidity Control</option><option value="Kerosene">Kerosene</option><option value="Natural Gas">Natural Gas</option><option value="None">None</option><option value="Oil">Oil</option><option value="Other">Other</option><option value="Passive Solar">Passive Solar</option><option value="Pellet Stove">Pellet Stove</option><option value="Propane">Propane</option><option value="Propane Stove">Propane Stove</option><option value="Radiant">Radiant</option><option value="Radiant Ceiling">Radiant Ceiling</option><option value="Radiant Floor">Radiant Floor</option><option value="See Remarks">See Remarks</option><option value="Separate Meters">Separate Meters</option><option value="Solar">Solar</option><option value="Space Heater">Space Heater</option><option value="Steam">Steam</option><option value="Varies by Unit">Varies by Unit</option><option value="Wall Furnace">Wall Furnace</option><option value="Wood">Wood</option><option value="Wood Stove">Wood Stove</option><option value="Zoned">Zoned</option>', 43)
                  ]), 512), [
                    [We, e.propertyDetails.heating]
                  ])
                ]),
                a("div", qLe, [
                  t[58] || (t[58] = a("label", {
                    class: "form-label",
                    id: "fireplace"
                  }, "Fireplace", -1)),
                  V(a("select", {
                    class: "form-select",
                    id: "fireplace",
                    "onUpdate:modelValue": t[15] || (t[15] = (f) => e.propertyDetails.fireplaces = f)
                  }, t[57] || (t[57] = [
                    Bt('<option value="0">None</option><option value="1">1</option><option value="2">2</option><option value="3">3</option><option value="4">4</option><option value="5">5</option>', 6)
                  ]), 512), [
                    [We, e.propertyDetails.fireplaces]
                  ])
                ]),
                t[66] || (t[66] = a("div", { class: "col-12" }, [
                  a("hr", { class: "mb-5" }),
                  a("span", { class: "fw-bold text-secondary text-opacity-50" }, "EXTERIOR DETAILS")
                ], -1)),
                a("div", QLe, [
                  t[60] || (t[60] = a("label", {
                    class: "form-label",
                    for: "foundation"
                  }, "Foundation", -1)),
                  V(a("select", {
                    class: "form-select",
                    id: "foundation",
                    "onUpdate:modelValue": t[16] || (t[16] = (f) => e.propertyDetails.foundation = f)
                  }, t[59] || (t[59] = [
                    Bt('<option value="">Other</option><option value="Block">Block</option><option value="Brick/Mortar">Brick/Mortar</option><option value="Combination">Combination</option><option value="Concrete Perimeter">Concrete Perimeter</option><option value="None">None</option><option value="Other">Other</option><option value="Permanent">Permanent</option><option value="Pillar/Post/Pier">Pillar/Post/Pier</option><option value="Raised">Raised</option><option value="See Remarks">See Remarks</option><option value="Slab">Slab</option><option value="Stone">Stone</option>', 13)
                  ]), 512), [
                    [We, e.propertyDetails.foundation]
                  ])
                ]),
                a("div", KLe, [
                  t[62] || (t[62] = a("label", {
                    class: "form-label",
                    for: "construction"
                  }, "Construction", -1)),
                  V(a("select", {
                    class: "form-select",
                    id: "construction",
                    "onUpdate:modelValue": t[17] || (t[17] = (f) => e.propertyDetails.construction = f)
                  }, t[61] || (t[61] = [
                    Bt('<option value="">Unknown</option><option value="Adobe">Adobe</option><option value="Aluminum Siding">Aluminum Siding</option><option value="Asbestos">Asbestos</option><option value="Asphalt">Asphalt</option><option value="Attic/Crawl Hatchway(s) Insulated">Attic/Crawl Hatchway(s) Insulated</option><option value="Batts Insulation">Batts Insulation</option><option value="Block">Block</option><option value="Blown-In Insulation">Blown-In Insulation</option><option value="Board &amp; Batten Siding">Board &amp; Batten Siding</option><option value="Brick">Brick</option><option value="Brick Veneer">Brick Veneer</option><option value="Cedar">Cedar</option><option value="Cement Siding">Cement Siding</option><option value="Clapboard">Clapboard</option><option value="Concrete">Concrete</option><option value="Ducts Professionally Air-Sealed">Ducts Professionally Air-Sealed</option><option value="Exterior Duct-Work is Insulated">Exterior Duct-Work is Insulated</option><option value="Fiber Cement">Fiber Cement</option><option value="Fiberglass Siding">Fiberglass Siding</option><option value="Foam Insulation">Foam Insulation</option><option value="Frame">Frame</option><option value="Glass">Glass</option><option value="HardiPlank Type">HardiPlank Type</option><option value="ICAT Recessed Lighting">ICAT Recessed Lighting</option><option value="ICFs (Insulated Concrete Forms)">ICFs (Insulated Concrete Forms)</option><option value="Lap Siding">Lap Siding</option><option value="Log">Log</option><option value="Log Siding">Log Siding</option><option value="Low VOC Insulation">Low VOC Insulation</option><option value="Masonite">Masonite</option><option value="Metal Siding">Metal Siding</option><option value="Natural Building">Natural Building</option><option value="Other">Other</option><option value="Plaster">Plaster</option><option value="Radiant Barrier">Radiant Barrier</option><option value="Rammed Earth">Rammed Earth</option><option value="Recycled/Bio-Based Insulation">Recycled/Bio-Based Insulation</option><option value="Redwood Siding">Redwood Siding</option><option value="See Remarks">See Remarks</option><option value="Shake Siding">Shake Siding</option><option value="Shingle Siding">Shingle Siding</option><option value="Slump Block">Slump Block</option><option value="Spray Foam Insulation">Spray Foam Insulation</option><option value="Steel Siding">Steel Siding</option><option value="Stone">Stone</option><option value="Stone Veneer">Stone Veneer</option><option value="Straw">Straw</option><option value="Stucco">Stucco</option><option value="Synthetic Stucco">Synthetic Stucco</option><option value="Unknown">Unknown</option><option value="Vertical Siding">Vertical Siding</option><option value="Vinyl Siding">Vinyl Siding</option><option value="Wood Siding">Wood Siding</option>', 54)
                  ]), 512), [
                    [We, e.propertyDetails.construction]
                  ])
                ]),
                a("div", ZLe, [
                  t[64] || (t[64] = a("label", {
                    class: "form-label",
                    for: "roof"
                  }, "Roof", -1)),
                  V(a("select", {
                    class: "form-select",
                    id: "roof",
                    "onUpdate:modelValue": t[18] || (t[18] = (f) => e.roofOption = f)
                  }, t[63] || (t[63] = [
                    Bt('<option value="">Unknown</option><option value="Aluminum">Aluminum</option><option value="Asbestos Shingle">Asbestos Shingle</option><option value="Asphalt">Asphalt</option><option value="Bahama">Bahama</option><option value="Barrel">Barrel</option><option value="Bituthene">Bituthene</option><option value="Built-Up">Built-Up</option><option value="Composition">Composition</option><option value="Concrete">Concrete</option><option value="Copper">Copper</option><option value="Elastomeric">Elastomeric</option><option value="Fiberglass">Fiberglass</option><option value="Flat">Flat</option><option value="Flat Tile">Flat Tile</option><option value="Foam">Foam</option><option value="Green Roof">Green Roof</option><option value="Mansard">Mansard</option><option value="Membrane">Membrane</option><option value="Metal">Metal</option><option value="Mixed">Mixed</option><option value="None">None</option><option value="Other">Other</option><option value="Rolled/Hot Mop">Rolled/Hot Mop</option><option value="Rubber">Rubber</option><option value="See Remarks">See Remarks</option><option value="Shake">Shake</option><option value="Shingle">Shingle</option><option value="Slate">Slate</option><option value="Spanish Tile">Spanish Tile</option><option value="Stone">Stone</option><option value="Synthetic">Synthetic</option><option value="Tar/Gravel">Tar/Gravel</option><option value="Tile">Tile</option><option value="Wood">Wood</option>', 35)
                  ]), 512), [
                    [We, e.roofOption]
                  ])
                ])
              ]),
              a("div", JLe, [
                a("button", {
                  type: "button",
                  class: "btn btn-light",
                  onClick: t[19] || (t[19] = (f) => e.step--)
                }, t[67] || (t[67] = [
                  a("i", { class: "fa-light fa-angle-left me-2" }, null, -1),
                  y(" Go back")
                ])),
                a("button", {
                  type: "button",
                  class: "btn btn-lava",
                  onClick: t[20] || (t[20] = (...f) => e.updateProperty && e.updateProperty(...f))
                }, "Confirm Details")
              ])
            ])
          ])) : P("", !0),
          e.step == 3 ? (p(), h("div", $Le, [
            t[71] || (t[71] = a("div", {
              class: "progress rounded-0",
              role: "progressbar",
              "aria-label": "Basic example",
              "aria-valuenow": "100",
              "aria-valuemin": "0",
              "aria-valuemax": "100",
              style: { height: "4px" }
            }, [
              a("div", {
                class: "progress-bar bg-lava",
                style: { width: "100%" }
              })
            ], -1)),
            a("div", _Le, [
              t[69] || (t[69] = a("i", { class: "fa-duotone fa-solid fa-circle-check fa-2xl text-success mb-5" }, null, -1)),
              t[70] || (t[70] = a("p", null, [
                a("span", { class: "fs-5 fw-bold" }, "Property Details Updated"),
                a("br")
              ], -1)),
              a("button", {
                type: "button",
                class: "btn btn-lava",
                "aria-label": "Close",
                onClick: t[21] || (t[21] = (...f) => e.closeDialog && e.closeDialog(...f))
              }, "Close")
            ])
          ])) : P("", !0)
        ])
      ])
    ])
  ], 512)) : P("", !0);
}
const jls = /* @__PURE__ */ Ae(aLe, [["render", eBe]]), oc = !0, tBe = me({
  name: "RentalRate",
  props: {
    analysis: {
      type: String,
      required: !1
    },
    share: {
      type: String,
      required: !1
    },
    source: {
      type: String,
      required: !1
    }
  },
  emits: [
    "saveFields"
  ],
  data() {
    return {
      loading: !0,
      chartsInit: !1,
      rentalRate: void 0,
      metricsByZip: void 0,
      metricsByNeighborhood: void 0,
      metricsByCounty: void 0,
      metricsByState: void 0,
      loadingValues: !0,
      hasData: !0,
      propertyType: void 0,
      highValueWarining: !1,
      nonSingleFamilyWarning: !1,
      noAVMSourceWarning: !1,
      rentalRateForecastSettings: {
        enableThreshold: !1,
        rentalOffset: 0,
        rentalThreshold: 0
      },
      rentalRateMetric: 0,
      rentalLowMetric: 0,
      rentalHighMetric: 0,
      thresholdHigh: 0,
      thresholdLow: 0,
      lockedRentalRate: void 0
    };
  },
  components: {
    ContentLoader: Sa
  },
  watch: {
    "property.propId"() {
      this.loadRentalMetrics();
    },
    "property.mlsSource.mlsNumber"() {
      this.loadRentalMetrics();
    },
    "property.address.zip"() {
      this.loadZipRentalMetrics();
    },
    "property.address.state"() {
      this.loadStateRentalMetrics();
    },
    "property.address.county"() {
      this.loadCountyRentalMetrics();
    },
    monthlyRental: {
      async handler(e) {
        await this.refreshChart();
      }
    },
    "calcParams.monthlyRentalYear1"(e) {
      !this.lockedRentalRate && e > 0 && (this.lockedRentalRate = this.calcParams.monthlyRentalYear1);
    },
    async thresholdReached(e) {
      e == !0 && this.loading == !1 && wt("AVM Rental Rate tile has changed to Professional Rental Rate Forecast"), await this.refreshChart();
    }
  },
  computed: {
    showCard() {
      return this.hasData == !0 && (!this.propertyType || this.propertyType == Xt.SingleFamily || this.propertyType == Xt.MultiFamily || this.propertyType == Xt.Residential24Family || this.propertyType == Xt.Unknown);
    },
    haveAccess() {
      var e, t, s, n;
      return (((t = (e = this.property) == null ? void 0 : e.mlsSource) == null ? void 0 : t.isActiveMarketplaceListing) == !0 || ((n = (s = this.acl) == null ? void 0 : s.properties) == null ? void 0 : n.propertyMetrics) == !0) && (this.isAdmin || this.isUser || this.isClient);
    },
    isEnterprise() {
      var e, t, s, n, r;
      return ((e = this.acl) == null ? void 0 : e.portfolioInsights) == !0 || ((s = (t = this.acl) == null ? void 0 : t.leads) == null ? void 0 : s.leads) == !0 || ((r = (n = this.acl) == null ? void 0 : n.freeRentalAnalysis) == null ? void 0 : r.access) == !0;
    },
    isLocked() {
      var e, t, s;
      return ((e = this.acl) == null ? void 0 : e.isAnalysis) == !0 || ((t = this.acl) == null ? void 0 : t.isIdx) == !0 || ((s = this.acl) == null ? void 0 : s.isShare) == !0;
    },
    monthlyRental() {
      var e;
      if (this.isLocked && this.lockedRentalRate > 0)
        return this.lockedRentalRate;
      if (((e = this.calcParams) == null ? void 0 : e.monthlyRentalYear1) > 0)
        return this.calcParams.monthlyRentalYear1;
    },
    isCustomRate() {
      var e;
      return ((e = this.calcParams) == null ? void 0 : e.customRentalAvm) == !0;
    },
    thresholdReached() {
      return !1;
    },
    rentalRateRaw() {
      var e, t, s, n, r, i;
      return console.log(`${this.$options.name}.rentalRateRaw`, (e = this.calcParams) == null ? void 0 : e.customRentalAvm, (t = this.calcParams) == null ? void 0 : t.rentalAvmValue, this.monthlyRental, (s = this.rentalRate) == null ? void 0 : s.rate), this.analysis ? this.calcParams.rentalAvmValue ?? ((n = this.rentalRate) == null ? void 0 : n.rate) ?? 0 : (
        /*this.thresholdReached == true &&*/
        ((r = this.calcParams) == null ? void 0 : r.customRentalAvm) == !0 ? this.calcParams.rentalAvmValue ?? this.monthlyRental ?? 0 : this.thresholdReached == !0 ? this.monthlyRental ?? 0 : ((i = this.rentalRate) == null ? void 0 : i.rate) ?? 0
      );
    },
    rentalRateFormated: {
      get() {
        return Ve(this.rentalRateRaw, 2);
      },
      set(e) {
        vh(e) ? this.calcParams.rentalAvmValue = void 0 : this.calcParams.rentalAvmValue = vs(e);
      }
    },
    rentalRateLowRaw() {
      var e, t;
      return (
        /*this.thresholdReached == true &&*/
        ((e = this.calcParams) == null ? void 0 : e.customRentalAvm) == !0 ? this.calcParams.rentalAvmLow ?? this.monthlyRental - this.rentalRateForecastSettings.rentalOffset : this.thresholdReached ? this.monthlyRental - this.rentalRateForecastSettings.rentalOffset : ((t = this.rentalRate) == null ? void 0 : t.low) ?? 0
      );
    },
    rentalRateLow: {
      get() {
        var e, t;
        return ((e = this.calcParams) == null ? void 0 : e.customRentalAvm) == !0 ? Ve(this.calcParams.rentalAvmLow, 2) : this.thresholdReached ? Ve(this.rentalRateLowRaw, 2) : Ve(((t = this.rentalRate) == null ? void 0 : t.low) ?? 0, 2);
      },
      set(e) {
        vh(e) ? this.calcParams.rentalAvmLow = void 0 : this.calcParams.rentalAvmLow = vs(e);
      }
    },
    rentalRateHighRaw() {
      var e, t;
      return (
        /*this.thresholdReached == true &&*/
        ((e = this.calcParams) == null ? void 0 : e.customRentalAvm) == !0 ? this.calcParams.rentalAvmHigh ?? this.monthlyRental + this.rentalRateForecastSettings.rentalOffset : this.thresholdReached ? this.monthlyRental + this.rentalRateForecastSettings.rentalOffset : ((t = this.rentalRate) == null ? void 0 : t.high) ?? 0
      );
    },
    rentalRateHigh: {
      get() {
        var e, t;
        return ((e = this.calcParams) == null ? void 0 : e.customRentalAvm) == !0 ? Ve(this.calcParams.rentalAvmHigh, 2) : this.thresholdReached ? Ve(this.rentalRateHighRaw, 2) : Ve(((t = this.rentalRate) == null ? void 0 : t.high) ?? 0, 2);
      },
      set(e) {
        vh(e) ? this.calcParams.rentalAvmHigh = void 0 : this.calcParams.rentalAvmHigh = vs(e);
      }
    },
    accessStyle() {
      return {
        "bg-light": this.haveAccess,
        "bg-gradient-periwinkle": this.haveAccess == !1
      };
    },
    ...q(Te, ["acl", "aclLoaded", "isClient", "isAdmin", "isUser"]),
    ...q(qe, ["property", "calcParams", "propertyInitialized"])
  },
  methods: {
    shortDate: cs,
    currency: Ze,
    number: Ve,
    percent: Wt,
    async loadRentalMetrics() {
      var e, t, s, n, r;
      this.loadingValues = !0;
      try {
        oc && console.info(`${this.$options.name}.loadRentalMetrics`);
        let i;
        if ((e = this.property) != null && e.propId)
          i = await W.api.property.rentalRate(this.property.propId);
        else if ((s = (t = this.property) == null ? void 0 : t.mlsSource) != null && s.source && ((r = (n = this.property) == null ? void 0 : n.mlsSource) != null && r.number))
          i = await W.api.property.rentalRateMls(this.property.mlsSource.source, this.property.mlsSource.number);
        else {
          oc && console.info(`${this.$options.name}.loadRentalMetrics no IDs for property yet`);
          return;
        }
        this.rentalRate = i.data.metrics, this.hasData = this.rentalRate != null, this.hasData == !0 && (this.rentalRateMetric = i.data.metrics.rate, this.rentalLowMetric = i.data.metrics.low, this.rentalHighMetric = i.data.metrics.high, this.propertyType = i.data.propertyType, await this.refreshChart());
      } catch (i) {
        console.error(`${this.$options.name}.loadRentalMetrics`, i);
      }
      this.loadingValues = !1;
    },
    async loadZipRentalMetrics() {
      var e, t;
      this.loadingValues = !0;
      try {
        if (oc && console.info(`${this.$options.name}.loadZipRentalMetrics`), !((t = (e = this.property) == null ? void 0 : e.address) != null && t.zip))
          return;
        const s = await W.api.geo.rentalMetricsByZip(this.property.address.zip);
        this.metricsByZip = s.data.metrics, await this.refreshChart();
      } catch (s) {
        console.error(`${this.$options.name}.loadZipRentalMetrics`, s);
      }
      this.loadingValues = !1;
    },
    async loadCountyRentalMetrics() {
      var e, t, s, n;
      this.loadingValues = !0;
      try {
        if (oc && console.info(`${this.$options.name}.loadCountyRentalMetrics`), !((t = (e = this.property) == null ? void 0 : e.address) != null && t.state) || !((n = (s = this.property) == null ? void 0 : s.address) != null && n.county))
          return;
        const r = await W.api.geo.rentalMetricsByCounty(this.property.address.state, this.property.address.county);
        this.metricsByCounty = r.data.metrics, await this.refreshChart();
      } catch (r) {
        console.error(`${this.$options.name}.loadCountyRentalMetrics`, r);
      }
      this.loadingValues = !1;
    },
    async loadStateRentalMetrics() {
      var e, t;
      this.loadingValues = !0;
      try {
        if (oc && console.info(`${this.$options.name}.loadStateRentalMetrics`), !((t = (e = this.property) == null ? void 0 : e.address) != null && t.state))
          return;
        const s = await W.api.geo.rentalMetricsByState(this.property.address.state);
        this.metricsByState = s.data.metrics, await this.refreshChart();
      } catch (s) {
        console.error(`${this.$options.name}.loadStateRentalMetrics`, s);
      }
      this.loadingValues = !1;
    },
    async initCharts() {
      await this.initChartsLock.runExclusive(async () => {
        if (console.info(`${this.$options.name}.initCharts START`), this.affIdxZipChart == null && this.$refs.rrAffZipChart) {
          let e = this.$refs.rrAffZipChart.getContext("2d");
          this.affIdxZipChart = new Rt(e, {
            type: "doughnut",
            data: {
              labels: [
                "Subject",
                "Zip High"
              ],
              datasets: [{
                backgroundColor: [
                  De.Colors.grey1,
                  De.Colors.grey3
                ],
                borderWidth: 0,
                borderRadius: 40,
                data: [80, 40]
              }]
            },
            options: {
              maintainAspectRatio: !1,
              cutout: "75%",
              plugins: {
                tooltip: {
                  enabled: !1
                },
                legend: {
                  display: !1,
                  position: "bottom"
                }
              }
            }
          });
        }
        if (this.affIdxNeighborhoodChart == null && this.$refs.rrAffNeighborhoodChart) {
          let e = this.$refs.rrAffNeighborhoodChart.getContext("2d");
          this.affIdxNeighborhoodChart = new Rt(e, {
            type: "doughnut",
            data: {
              labels: [
                "Subject",
                "Zip High"
              ],
              datasets: [{
                backgroundColor: [
                  De.Colors.grey1,
                  De.Colors.grey3
                ],
                borderWidth: 0,
                borderRadius: 40,
                data: [90, 110]
              }]
            },
            options: {
              maintainAspectRatio: !1,
              cutout: "75%",
              plugins: {
                tooltip: {
                  enabled: !1
                },
                legend: {
                  display: !1,
                  position: "bottom"
                }
              }
            }
          });
        }
        if (this.affIdxCountyChart == null && this.$refs.rrAffCountyChart) {
          let e = this.$refs.rrAffCountyChart.getContext("2d");
          this.affIdxCountyChart = new Rt(e, {
            type: "doughnut",
            data: {
              labels: [
                "Subject",
                "Zip High"
              ],
              datasets: [{
                backgroundColor: [
                  De.Colors.grey1,
                  De.Colors.grey3
                ],
                borderWidth: 0,
                borderRadius: 40,
                data: [50, 75]
              }]
            },
            options: {
              maintainAspectRatio: !1,
              cutout: "75%",
              plugins: {
                tooltip: {
                  enabled: !1
                },
                legend: {
                  display: !1,
                  position: "bottom"
                }
              }
            }
          });
        }
        if (this.rntMktSatZipChart == null && this.$refs.rrMarketZipChart) {
          let e = this.$refs.rrMarketZipChart.getContext("2d");
          this.rntMktSatZipChart = new Rt(e, {
            type: "doughnut",
            data: {
              labels: [
                "Subject",
                "Zip High"
              ],
              datasets: [{
                backgroundColor: [
                  De.Colors.grey1,
                  De.Colors.grey3
                ],
                borderWidth: 0,
                borderRadius: 40,
                data: [60, 40]
              }]
            },
            options: {
              maintainAspectRatio: !1,
              cutout: "75%",
              plugins: {
                tooltip: {
                  enabled: !1
                },
                legend: {
                  display: !1,
                  position: "bottom"
                }
              }
            }
          });
        }
        if (this.rntMktSatNeighborhoodChart == null && this.$refs.rrMarketNeighborhoodChart) {
          let e = this.$refs.rrMarketNeighborhoodChart.getContext("2d");
          this.rntMktSatNeighborhoodChart = new Rt(e, {
            type: "doughnut",
            data: {
              labels: [
                "Subject",
                "Zip High"
              ],
              datasets: [{
                backgroundColor: [
                  De.Colors.grey1,
                  De.Colors.grey3
                ],
                borderWidth: 0,
                borderRadius: 40,
                data: [80, 20]
              }]
            },
            options: {
              maintainAspectRatio: !1,
              cutout: "75%",
              plugins: {
                tooltip: {
                  enabled: !1
                },
                legend: {
                  display: !1,
                  position: "bottom"
                }
              }
            }
          });
        }
        if (this.rntMktSatCountyChart == null && this.$refs.rrMarketCountyChart) {
          let e = this.$refs.rrMarketCountyChart.getContext("2d");
          this.rntMktSatCountyChart = new Rt(e, {
            type: "doughnut",
            data: {
              labels: [
                "Subject",
                "Zip High"
              ],
              datasets: [{
                backgroundColor: [
                  De.Colors.grey1,
                  De.Colors.grey3
                ],
                borderWidth: 0,
                borderRadius: 40,
                data: [75, 25]
              }]
            },
            options: {
              maintainAspectRatio: !1,
              cutout: "75%",
              plugins: {
                tooltip: {
                  enabled: !1
                },
                legend: {
                  display: !1,
                  position: "bottom"
                }
              }
            }
          });
        }
        if (this.rrBarChart == null && this.$refs.rrBarChart) {
          let e = this.$refs.rrBarChart.getContext("2d");
          this.rrBarChart = new Rt(e, {
            type: "bar",
            data: {
              labels: [
                "Subject",
                "Zip Median",
                "County Median"
              ],
              datasets: [
                {
                  backgroundColor: [
                    De.Colors.grey1,
                    De.Colors.grey2,
                    De.Colors.grey3
                  ],
                  borderWidth: 0,
                  borderRadius: 5,
                  data: [
                    1468,
                    3068,
                    2820
                  ]
                }
              ]
            },
            options: {
              maintainAspectRatio: !1,
              plugins: {
                tooltip: {
                  enabled: !1
                },
                legend: {
                  display: !1
                }
              },
              layout: {
                padding: {
                  right: 50
                }
              },
              indexAxis: "y",
              scales: {
                x: {
                  grid: {
                    display: !1
                  },
                  ticks: {
                    callback: function(t, s, n) {
                      return Ze(t);
                    }
                  }
                }
              }
            },
            plugins: [
              {
                id: "alwaysShowTooltip",
                afterDraw(t, s, n) {
                  const { ctx: r } = t;
                  r.save(), t.data.datasets.forEach((i, o) => {
                    t.getDatasetMeta(o).data.forEach((l, d) => {
                      const { x: c, y: u } = l.tooltipPosition(), m = t.data.datasets[o].data[d];
                      r.font = "12px Arial", r.fillStyle = "Black", r.fillText(Ze(m), c + 5, u + 6), r.restore();
                    });
                  });
                }
              }
            ]
          });
        }
        console.info(`${this.$options.name}.initCharts END`), this.chartsInit = !0;
      });
    },
    async refreshChart() {
      var e, t;
      if (console.info(`${this.$options.name}.refreshChart`, this.thresholdReached, this.rentalRateRaw, (e = this.rentalRate) == null ? void 0 : e.rate), (this.affIdxZipChart == null || this.rntMktSatZipChart == null || this.rrBarChart == null || this.affIdxCountyChart == null || this.rntMktSatCountyChart == null || this.affIdxNeighborhoodChart == null || this.rntMktSatNeighborhoodChart == null) && await this.initCharts(), this.thresholdReached || this.isCustomRate ? this.rrBarChart && (this.rrBarChart.data.datasets[0].backgroundColor[0] = De.Colors.ChartDarkBlue, this.rrBarChart.data.datasets[0].data[0] = this.rentalRateRaw, this.rrBarChart.update()) : this.rrBarChart && (this.rrBarChart.data.datasets[0].backgroundColor[0] = De.Colors.ChartDarkBlue, this.rrBarChart.data.datasets[0].data[0] = ((t = this.rentalRate) == null ? void 0 : t.rate) ?? 0, this.rrBarChart.update()), this.metricsByZip && this.affIdxZipChart && this.rntMktSatZipChart && this.rrBarChart) {
        this.affIdxZipChart.data.datasets[0].backgroundColor[0] = De.Colors.ChartGreen, this.affIdxZipChart.data.datasets[0].data[0] = this.metricsByZip.affordabilityIndex, this.affIdxZipChart.data.datasets[0].backgroundColor[1] = De.Colors.ChartGray, this.affIdxZipChart.data.datasets[0].data[1] = 200 - this.metricsByZip.affordabilityIndex, this.affIdxZipChart.update();
        const s = Math.trunc(this.metricsByZip.rentalMarketSaturation * 100);
        this.rntMktSatZipChart.data.datasets[0].backgroundColor[0] = De.Colors.ChartGreen, this.rntMktSatZipChart.data.datasets[0].data[0] = s, this.rntMktSatZipChart.data.datasets[0].backgroundColor[1] = De.Colors.ChartGray, this.rntMktSatZipChart.data.datasets[0].data[1] = 100 - s, this.rntMktSatZipChart.update(), this.rrBarChart.data.datasets[0].backgroundColor[1] = De.Colors.ChartLiteOrange, this.rrBarChart.data.datasets[0].data[1] = this.metricsByZip.median, this.rrBarChart.update();
      }
      if (this.metricsByCounty && this.affIdxCountyChart && this.rntMktSatCountyChart && this.rrBarChart) {
        this.affIdxCountyChart.data.datasets[0].backgroundColor[0] = De.Colors.ChartLiteBlue, this.affIdxCountyChart.data.datasets[0].data[0] = this.metricsByCounty.affordabilityIndex, this.affIdxCountyChart.data.datasets[0].backgroundColor[1] = De.Colors.ChartGray, this.affIdxCountyChart.data.datasets[0].data[1] = 200 - this.metricsByCounty.affordabilityIndex, this.affIdxCountyChart.update();
        const s = Math.trunc(this.metricsByCounty.rentalMarketSaturation * 100);
        this.rntMktSatCountyChart.data.datasets[0].backgroundColor[0] = De.Colors.ChartLiteBlue, this.rntMktSatCountyChart.data.datasets[0].data[0] = s, this.rntMktSatCountyChart.data.datasets[0].backgroundColor[1] = De.Colors.ChartGray, this.rntMktSatCountyChart.data.datasets[0].data[1] = 100 - s, this.rntMktSatCountyChart.update(), this.rrBarChart.data.datasets[0].backgroundColor[2] = De.Colors.ChartTurquoise, this.rrBarChart.data.datasets[0].data[2] = this.metricsByCounty.median, this.rrBarChart.update();
      }
      if (this.metricsByState && this.affIdxNeighborhoodChart && this.rntMktSatNeighborhoodChart) {
        this.affIdxNeighborhoodChart.data.datasets[0].backgroundColor[0] = De.Colors.ChartLiteBlue, this.affIdxNeighborhoodChart.data.datasets[0].data[0] = this.metricsByState.affordabilityIndex, this.affIdxNeighborhoodChart.data.datasets[0].backgroundColor[1] = De.Colors.ChartGray, this.affIdxNeighborhoodChart.data.datasets[0].data[1] = 200 - this.metricsByState.affordabilityIndex, this.affIdxNeighborhoodChart.update();
        const s = Math.trunc(this.metricsByState.rentalMarketSaturation * 100);
        this.rntMktSatNeighborhoodChart.data.datasets[0].backgroundColor[0] = De.Colors.ChartLiteBlue, this.rntMktSatNeighborhoodChart.data.datasets[0].data[0] = s, this.rntMktSatNeighborhoodChart.data.datasets[0].backgroundColor[1] = De.Colors.ChartGray, this.rntMktSatNeighborhoodChart.data.datasets[0].data[1] = 100 - s, this.rntMktSatNeighborhoodChart.update();
      }
    },
    openCommunityTab() {
      $("#community-tab").tab("show"), $("#navigation.nav-tabs li .nav-link").removeClass("active"), $("#community-tab").addClass("active");
    },
    loadWarnings() {
      console.info("RentalRate.loadWarnings", this.rentalRate), this.propertyType && (this.nonSingleFamilyWarning = this.propertyType != Xt.SingleFamily), this.metricsByZip && this.rentalRate ? this.highValueWarining = this.rentalRate.rate * 100 / this.metricsByZip.median > 150 : this.metricsByCounty && this.rentalRate && (this.highValueWarining = this.rentalRate.rate * 100 / this.metricsByCounty.median > 150), this.rentalRate && (this.noAVMSourceWarning = this.rentalRate.source != "AVM");
    },
    async getAvmAdjustmentSettings() {
      try {
        if (this.acl.isAnonymous) return;
        var e = await W.api.account.getAvmAdjustmentSettings();
        if (e.data.status != de.Success)
          throw new Error(e.data.message);
        this.rentalRateForecastSettings = e.data, this.thresholdHigh = this.rentalRateMetric + this.rentalRateMetric * this.rentalRateForecastSettings.rentalThreshold, this.thresholdLow = this.rentalRateMetric - this.rentalRateMetric * this.rentalRateForecastSettings.rentalThreshold;
      } catch (t) {
        console.error(`${this.$options.name}.getAvmAdjustmentSettings`, t);
      }
    },
    save() {
      var e, t;
      ((e = this.calcParams) == null ? void 0 : e.customRentalAvm) == !0 && (this.calcParams.rentalAvmValue = this.rentalRateRaw, this.calcParams.rentalAvmHigh = this.rentalRateHighRaw, this.calcParams.rentalAvmLow = this.rentalRateLowRaw), this.$emit("saveFields", ""), (t = bootstrap.Modal.getOrCreateInstance(this.$refs.modalEditForecast)) == null || t.hide();
    }
  },
  created() {
    console.info("RentalRate.created", this.$props.analysis, this.$props.share), this.initChartsLock = new xa();
  },
  mounted() {
    console.info("RentalRate.mounted", this.calcParams), this.aclLoaded.then(async () => await this.propertyInitialized).then(async () => {
      this.haveAccess && await this.initCharts().then(async () => {
        await Promise.allSettled([
          this.loadZipRentalMetrics(),
          this.loadCountyRentalMetrics(),
          this.loadStateRentalMetrics()
        ]);
      }), await this.loadRentalMetrics().then(async () => await this.getAvmAdjustmentSettings());
    }).finally(() => {
      this.loadWarnings(), this.loading = !1;
    });
  }
}), sBe = "data:image/png;base64,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", $k = "data:image/png;base64,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", aBe = { class: "card shadow-sm" }, nBe = { class: "card-header d-flex flex-column flex-sm-row align-items-center justify-content-between bg-white border-0 pb-0" }, rBe = { class: "text-center text-lg-start fw-bold" }, oBe = {
  key: 0,
  class: "text-center text-lg-end text-muted text-small"
}, iBe = { class: "card-body d-flex flex-column gap-3" }, lBe = {
  key: 0,
  class: "bg-secondary-subtle p-2 rounded-3 d-flex gap-2 align-items-center"
}, dBe = {
  key: 0,
  type: "button",
  class: "btn btn-light btn-sm rounded-pill",
  "data-bs-toggle": "modal",
  "data-bs-target": "#dialogRrNonSingleFamily"
}, cBe = {
  key: 1,
  type: "button",
  class: "btn btn-light btn-sm rounded-pill",
  "data-bs-toggle": "modal",
  "data-bs-target": "#dialogMedianUsed"
}, uBe = {
  key: 2,
  type: "button",
  class: "btn btn-light btn-sm rounded-pill",
  "data-bs-toggle": "modal",
  "data-bs-target": "#dialogHighValue"
}, pBe = {
  key: 1,
  class: "small"
}, hBe = {
  key: 2,
  class: "small mb-3"
}, mBe = { class: "d-flex justify-content-between flex-column flex-md-row gap-3" }, fBe = { class: "bg-light rounded" }, gBe = { key: 0 }, vBe = {
  key: 1,
  class: "d-flex justify-content-around flex-row flex-md-column"
}, yBe = ["title"], bBe = {
  key: 0,
  class: "fw-bold fs-5 d-block lh-sm"
}, ABe = {
  key: 0,
  class: "text-black text-opacity-25 text-small ms-1 m-lg-0"
}, wBe = {
  key: 1,
  class: "fw-bold fs-5"
}, CBe = { class: "border-bottom border-bottom-white p-3" }, SBe = {
  key: 0,
  class: "text-dark fw-bold"
}, PBe = {
  key: 1,
  class: "text-dark fw-bold"
}, kBe = {
  key: 2,
  class: "text-dark fw-bold"
}, EBe = {
  key: 0,
  class: "p-3"
}, IBe = {
  key: 0,
  class: "text-dark fw-bold"
}, TBe = {
  key: 1,
  class: "text-dark fw-bold"
}, OBe = {
  key: 2,
  class: "text-dark fw-bold"
}, RBe = {
  key: 0,
  class: "position-relative",
  style: { height: "250px", width: "100%" }
}, LBe = {
  class: "rrBarChart",
  ref: "rrBarChart"
}, BBe = {
  key: 1,
  class: "position-absolute"
}, MBe = {
  key: 2,
  class: "text-center p-3"
}, xBe = {
  key: 3,
  class: "d-flex justify-content-between flex-column flex-xl-row gap-3"
}, FBe = { class: "bg-light p-3 rounded flex-grow-1" }, VBe = { class: "fw-bold" }, DBe = {
  key: 0,
  class: "text-lava"
}, NBe = { class: "d-flex justify-content-between" }, jBe = { class: "chart-container text-center" }, HBe = {
  class: "chart-doughnut position-relative mb-3",
  style: { height: "100px", width: "100px" }
}, UBe = {
  class: "rrAffZipChart",
  ref: "rrAffZipChart"
}, zBe = {
  key: 0,
  class: "position-absolute fw-bold"
}, WBe = {
  key: 1,
  class: "position-absolute fw-bold"
}, GBe = { class: "chart-container text-center" }, YBe = {
  class: "chart-doughnut position-relative mb-3",
  style: { height: "100px", width: "100px" }
}, XBe = {
  class: "rrAffCountyChart",
  ref: "rrAffCountyChart"
}, qBe = {
  key: 0,
  class: "position-absolute fw-bold"
}, QBe = {
  key: 1,
  class: "position-absolute fw-bold"
}, KBe = { class: "text-center chart-container" }, ZBe = {
  class: "chart-doughnut position-relative mb-3",
  style: { height: "100px", width: "100px" }
}, JBe = {
  class: "rrAffNeighborhoodChart",
  ref: "rrAffNeighborhoodChart"
}, $Be = {
  key: 0,
  class: "position-absolute fw-bold"
}, _Be = {
  key: 1,
  class: "position-absolute fw-bold"
}, eMe = { class: "bg-light p-3 rounded flex-grow-1" }, tMe = { class: "d-flex justify-content-between" }, sMe = { class: "chart-container text-center" }, aMe = {
  class: "chart-doughnut position-relative mb-3",
  style: { height: "100px", width: "100px" }
}, nMe = {
  class: "rrMarketZipChart",
  ref: "rrMarketZipChart"
}, rMe = {
  key: 0,
  class: "position-absolute fw-bold"
}, oMe = {
  key: 1,
  class: "position-absolute fw-bold"
}, iMe = { class: "chart-container text-center" }, lMe = {
  class: "chart-doughnut position-relative mb-3",
  style: { height: "100px", width: "100px" }
}, dMe = {
  class: "rrMarketCountyChart",
  ref: "rrMarketCountyChart"
}, cMe = {
  key: 0,
  class: "position-absolute fw-bold"
}, uMe = {
  key: 1,
  class: "position-absolute fw-bold"
}, pMe = { class: "chart-container text-center" }, hMe = {
  class: "chart-doughnut position-relative mb-3",
  style: { height: "100px", width: "100px" }
}, mMe = {
  class: "rrMarketNeighborhoodChart",
  ref: "rrMarketNeighborhoodChart"
}, fMe = {
  key: 0,
  class: "position-absolute fw-bold"
}, gMe = {
  key: 1,
  class: "position-absolute fw-bold"
}, vMe = {
  class: "text-center",
  role: "tablist"
}, yMe = {
  key: 0,
  class: "card-footer bg-white d-flex justify-content-end"
}, bMe = {
  key: 0,
  type: "button",
  class: "btn btn-outline-eclipse btn-sm",
  "data-bs-toggle": "modal",
  "data-bs-target": "#modalEditForecast"
}, AMe = {
  key: 1,
  type: "button",
  class: "btn btn-outline-eclipse btn-sm",
  "data-bs-toggle": "modal",
  "data-bs-target": "#modalRRAdjustmentGuard"
}, wMe = {
  class: "modal fade",
  id: "modalEditForecast",
  tabindex: "-1",
  "aria-labelledby": "modalEditForecastLabel",
  "aria-hidden": "true",
  ref: "modalEditForecast"
}, CMe = { class: "modal-dialog modal-dialog-centered" }, SMe = { class: "modal-content bg-gradient-alphabet rounded" }, PMe = { class: "modal-body" }, kMe = { class: "row g-3" }, EMe = { class: "col-sm-3" }, IMe = { class: "form-check form-switch form-switch-lg form-switch-basic" }, TMe = { class: "col-sm-8" }, OMe = { class: "input-group" }, RMe = ["disabled"], LMe = { class: "col-sm-4" }, BMe = { class: "input-group" }, MMe = ["disabled"], xMe = { class: "col-sm-4" }, FMe = { class: "input-group" }, VMe = ["disabled"], DMe = { class: "col-12" }, NMe = { class: "form-check" }, jMe = { class: "modal-footer border-0 pt-0" }, HMe = {
  key: 1,
  class: "modal fade",
  id: "modalRRAdjustmentGuard",
  tabindex: "-1",
  "aria-labelledby": "modalRRAdjustmentGuardLabel",
  "aria-hidden": "true"
};
function UMe(e, t, s, n, r, i) {
  var l, d, c, u, m, f;
  const o = pe("content-loader");
  return p(), h(A, null, [
    e.showCard ? (p(), h(A, { key: 0 }, [
      a("div", aBe, [
        a("div", nBe, [
          a("div", rBe, [
            e.thresholdReached || e.isCustomRate ? (p(), h(A, { key: 0 }, [
              y(g(e.source) + " Rental Rate Estimate ", 1)
            ], 64)) : (p(), h(A, { key: 1 }, [
              y(" Rental Rate AVM Prediction ")
            ], 64))
          ]),
          e.rentalRate && e.rentalRate.valuationDate && e.thresholdReached == !1 && e.isCustomRate == !1 ? (p(), h("div", oBe, " Last Updated: " + g(e.shortDate(e.rentalRate.valuationDate)), 1)) : P("", !0)
        ]),
        a("div", iBe, [
          e.highValueWarining && e.thresholdReached == !1 && e.isCustomRate == !1 || e.nonSingleFamilyWarning && e.thresholdReached == !1 && e.isCustomRate == !1 || e.noAVMSourceWarning && e.thresholdReached == !1 && e.isCustomRate == !1 ? (p(), h("div", lBe, [
            t[10] || (t[10] = a("span", { class: "fw-bold" }, "Conditions:", -1)),
            e.nonSingleFamilyWarning && e.thresholdReached == !1 && e.isCustomRate == !1 ? (p(), h("button", dBe, t[7] || (t[7] = [
              a("i", { class: "fa-duotone fa-solid fa-buildings me-1" }, null, -1),
              y("Non Single Family")
            ]))) : P("", !0),
            e.noAVMSourceWarning && e.thresholdReached == !1 && e.isCustomRate == !1 ? (p(), h("button", cBe, t[8] || (t[8] = [
              a("i", { class: "fa-duotone fa-solid fa-box-dollar me-1" }, null, -1),
              y("Median $/SF Used")
            ]))) : P("", !0),
            e.highValueWarining && e.thresholdReached == !1 && e.isCustomRate == !1 ? (p(), h("button", uBe, t[9] || (t[9] = [
              a("i", { class: "fa-duotone fa-solid fa-gauge-high me-1" }, null, -1),
              y("High Value")
            ]))) : P("", !0)
          ])) : P("", !0),
          e.thresholdReached == !1 && e.isCustomRate == !1 ? (p(), h("p", pBe, "Automated Valuation Modeling (AVM) uses machine learning algorithms to predict the rental rate for the subject property. These values are updated as often as monthly, based on closed transactions of similar properties in the area. Adjustments to the rental rate in the Rescover calculator will not affect the figures displayed on this card.")) : (p(), h("p", hBe, "This estimate has been carefully adjusted to reflect a deep understanding of the local rental market, integrating expert insights and analysis for a more accurate rental rate approximation for the subject property.")),
          a("div", mBe, [
            a("div", fBe, [
              e.rentalRate ? (p(), h("div", vBe, [
                a("div", {
                  class: "border-bottom border-bottom-white p-3",
                  title: (l = e.rentalRate) == null ? void 0 : l.source
                }, [
                  t[11] || (t[11] = a("span", { class: "text-secondary text-opacity-50 fw-bold small d-block" }, "RENTAL RATE", -1)),
                  e.rentalRate ? (p(), h("span", bBe, [
                    y(g(e.currency(e.rentalRateRaw)) + " ", 1),
                    (d = e.rentalRate) != null && d.rate && ((c = e.rentalRate) != null && c.squareFeet) ? (p(), h("small", ABe, "(" + g(e.currency(e.rentalRate.rate / e.rentalRate.squareFeet, !0)) + "/SF)", 1)) : P("", !0)
                  ])) : (p(), h("span", wBe, "N/A"))
                ], 8, yBe),
                a("div", CBe, [
                  t[12] || (t[12] = a("span", { class: "text-secondary text-opacity-50 fw-bold small" }, "RANGE", -1)),
                  t[13] || (t[13] = a("br", null, null, -1)),
                  e.rentalRate && e.haveAccess ? (p(), h("span", SBe, g(e.currency(e.rentalRateLowRaw)) + " - " + g(e.currency(e.rentalRateHighRaw)), 1)) : e.rentalRate ? (p(), h("span", kBe, "Upgrade!")) : (p(), h("span", PBe, "N/A"))
                ]),
                e.thresholdReached == !1 && e.isCustomRate == !1 ? (p(), h("div", EBe, [
                  t[14] || (t[14] = a("span", { class: "text-secondary text-opacity-50 fw-bold small" }, "CONFIDENCE SCORE", -1)),
                  t[15] || (t[15] = a("br", null, null, -1)),
                  e.rentalRate && e.haveAccess ? (p(), h("span", IBe, g(e.percent(e.rentalRate.confidence)), 1)) : e.rentalRate ? (p(), h("span", OBe, "Upgrade!")) : (p(), h("span", TBe, "N/A"))
                ])) : P("", !0)
              ])) : (p(), h("div", gBe, [
                N(o, {
                  speed: 2,
                  width: 344,
                  height: 168,
                  class: "d-sm-none"
                }),
                N(o, {
                  speed: 2,
                  width: 470,
                  height: 87,
                  class: "d-none d-sm-block d-md-none"
                }),
                N(o, {
                  speed: 2,
                  width: 650,
                  height: 87,
                  class: "d-none d-md-block d-lg-none"
                }),
                N(o, {
                  speed: 2,
                  width: 490,
                  height: 87,
                  class: "d-none d-lg-block d-xl-none"
                }),
                N(o, {
                  speed: 2,
                  width: 158,
                  height: 248,
                  class: "d-none d-xl-block img-fluid"
                })
              ]))
            ]),
            a("div", {
              class: z(["rounded flex-grow-1 chart-container chart-container_doughnut position-relative", e.accessStyle])
            }, [
              e.haveAccess ? (p(), h("div", RBe, [
                a("canvas", LBe, null, 512)
              ])) : !e.rentalRate && !e.haveAccess ? (p(), h("div", BBe, [
                N(o, {
                  speed: 2,
                  width: 344,
                  height: 239,
                  class: "d-sm-none"
                }),
                N(o, {
                  speed: 2,
                  width: 490,
                  height: 214,
                  class: "d-none d-sm-block d-md-none"
                }),
                N(o, {
                  speed: 2,
                  width: 650,
                  height: 214,
                  class: "d-none d-md-block d-lg-none"
                }),
                N(o, {
                  speed: 2,
                  width: 490,
                  height: 214,
                  class: "d-none d-lg-block d-xl-none"
                }),
                N(o, {
                  speed: 2,
                  width: 537,
                  height: 248,
                  class: "d-none d-xl-block img-fluid"
                })
              ])) : (p(), h("div", MBe, t[16] || (t[16] = [
                a("img", {
                  src: sBe,
                  alt: "Rental Rate",
                  title: "Rental Rate",
                  height: "346",
                  width: "568",
                  class: "img-fluid",
                  loading: "lazy"
                }, null, -1),
                a("p", { class: "fw-bold fs-5" }, [
                  y(" With a Property Suite Pro account you can view"),
                  a("br", { class: "d-none d-xxl-block" }),
                  y(" detailed rental metrics and comparisons. ")
                ], -1),
                a("a", {
                  href: "/account/settings",
                  class: "btn btn-eclipse"
                }, "Activate Rental Analytics!", -1)
              ])))
            ], 2)
          ]),
          e.haveAccess ? (p(), h("div", xBe, [
            a("div", FBe, [
              a("p", VBe, [
                t[17] || (t[17] = y(" Affordability Index: ")),
                e.rentalRate ? (p(), h("span", DBe, g(e.number(e.rentalRate.affordabilityIndex)), 1)) : P("", !0)
              ]),
              a("div", NBe, [
                a("div", jBe, [
                  a("div", HBe, [
                    a("canvas", UBe, null, 512),
                    e.metricsByZip ? (p(), h("span", zBe, g(e.number(e.metricsByZip.affordabilityIndex)), 1)) : (p(), h("span", WBe, "N/A"))
                  ]),
                  t[18] || (t[18] = a("span", { class: "chart-caption" }, "Zip", -1))
                ]),
                a("div", GBe, [
                  a("div", YBe, [
                    a("canvas", XBe, null, 512),
                    e.metricsByCounty ? (p(), h("span", qBe, g(e.number(e.metricsByCounty.affordabilityIndex)), 1)) : (p(), h("span", QBe, "N/A"))
                  ]),
                  t[19] || (t[19] = a("span", { class: "chart-caption" }, "County", -1))
                ]),
                a("div", KBe, [
                  a("div", ZBe, [
                    a("canvas", JBe, null, 512),
                    e.metricsByState ? (p(), h("span", $Be, g(e.number(e.metricsByState.affordabilityIndex)), 1)) : (p(), h("span", _Be, "N/A"))
                  ]),
                  t[20] || (t[20] = a("span", { class: "chart-caption text-truncate" }, "State", -1))
                ])
              ])
            ]),
            a("div", eMe, [
              t[24] || (t[24] = a("p", { class: "fw-bold" }, " Rental Market Saturation ", -1)),
              a("div", tMe, [
                a("div", sMe, [
                  a("div", aMe, [
                    a("canvas", nMe, null, 512),
                    e.metricsByZip ? (p(), h("span", rMe, g(e.percent(e.metricsByZip.rentalMarketSaturation)), 1)) : (p(), h("span", oMe, "N/A"))
                  ]),
                  t[21] || (t[21] = a("span", { class: "chart-caption" }, "Zip", -1))
                ]),
                a("div", iMe, [
                  a("div", lMe, [
                    a("canvas", dMe, null, 512),
                    e.metricsByCounty ? (p(), h("span", cMe, g(e.percent(e.metricsByCounty.rentalMarketSaturation)), 1)) : (p(), h("span", uMe, "N/A"))
                  ]),
                  t[22] || (t[22] = a("span", { class: "chart-caption" }, "County", -1))
                ]),
                a("div", pMe, [
                  a("div", hMe, [
                    a("canvas", mMe, null, 512),
                    e.metricsByState ? (p(), h("span", fMe, g(e.percent(e.metricsByState.rentalMarketSaturation)), 1)) : (p(), h("span", gMe, "N/A"))
                  ]),
                  t[23] || (t[23] = a("span", { class: "chart-caption text-truncate" }, "State", -1))
                ])
              ])
            ])
          ])) : P("", !0),
          a("div", vMe, [
            a("a", {
              class: "text-lava nav-link",
              href: "#",
              onClick: t[0] || (t[0] = (...v) => e.openCommunityTab && e.openCommunityTab(...v))
            }, t[25] || (t[25] = [
              y(" Click to view more Community info "),
              a("i", { class: "fa-light fa-angle-right ms-2" }, null, -1)
            ]))
          ])
        ]),
        e.isLocked ? P("", !0) : (p(), h("div", yMe, [
          e.isEnterprise ? (p(), h("button", bMe, "Edit")) : (p(), h("button", AMe, "Edit Rental Rate"))
        ]))
      ]),
      a("div", wMe, [
        a("div", CMe, [
          a("div", SMe, [
            t[37] || (t[37] = a("div", { class: "modal-header border-0 pb-0" }, [
              a("p", {
                class: "modal-title mb-0 fw-bold fs-5",
                id: "modalEditForecastLabel"
              }, "Edit Rental Rate"),
              a("button", {
                type: "button",
                class: "btn-close",
                "data-bs-dismiss": "modal",
                "aria-label": "Close"
              })
            ], -1)),
            a("div", PMe, [
              a("div", kMe, [
                t[33] || (t[33] = a("label", {
                  class: "col-sm-9 col-form-label",
                  for: "flexSwitchCheckDefault"
                }, "Overwrite AVM Estimate With Custom Values", -1)),
                a("div", EMe, [
                  a("div", IMe, [
                    V(a("input", {
                      class: "form-check-input",
                      type: "checkbox",
                      role: "switch",
                      id: "flexSwitchCheckDefault",
                      "onUpdate:modelValue": t[1] || (t[1] = (v) => e.calcParams.customRentalAvm = v)
                    }, null, 512), [
                      [Ue, e.calcParams.customRentalAvm]
                    ]),
                    t[26] || (t[26] = a("label", {
                      class: "form-check-label",
                      for: "flexSwitchCheckDefault"
                    }, [
                      y("Yes"),
                      a("span", null, "No")
                    ], -1))
                  ])
                ]),
                t[34] || (t[34] = a("label", {
                  for: "inputRentalRate",
                  class: "col-sm-4 col-form-label"
                }, "Rental Rate", -1)),
                a("div", TMe, [
                  a("div", OMe, [
                    t[27] || (t[27] = a("span", {
                      class: "input-group-text",
                      id: "basic-addon1"
                    }, "$", -1)),
                    V(a("input", {
                      type: "text",
                      id: "inputRentalRate",
                      class: "form-control text-end",
                      "aria-describedby": "basic-addon1",
                      "onUpdate:modelValue": t[2] || (t[2] = (v) => e.rentalRateFormated = v),
                      disabled: ((u = e.calcParams) == null ? void 0 : u.customRentalAvm) != !0
                    }, null, 8, RMe), [
                      [_e, e.rentalRateFormated]
                    ])
                  ])
                ]),
                t[35] || (t[35] = a("label", {
                  for: "inputRange",
                  class: "col-sm-4 col-form-label"
                }, "Range", -1)),
                a("div", LMe, [
                  t[29] || (t[29] = a("label", {
                    for: "inputRange",
                    class: "col-sm-2 col-form-label"
                  }, "Low", -1)),
                  a("div", BMe, [
                    t[28] || (t[28] = a("span", {
                      class: "input-group-text",
                      id: "basic-addon2"
                    }, "$", -1)),
                    V(a("input", {
                      type: "text",
                      id: "inputRange",
                      class: "form-control text-end",
                      "aria-describedby": "basic-addon2",
                      "onUpdate:modelValue": t[3] || (t[3] = (v) => e.rentalRateLow = v),
                      disabled: ((m = e.calcParams) == null ? void 0 : m.customRentalAvm) != !0
                    }, null, 8, MMe), [
                      [_e, e.rentalRateLow]
                    ])
                  ])
                ]),
                a("div", xMe, [
                  t[31] || (t[31] = a("label", {
                    for: "inputRangeHigh",
                    class: "col-sm-2 col-form-label"
                  }, "High", -1)),
                  a("div", FMe, [
                    t[30] || (t[30] = a("span", {
                      class: "input-group-text",
                      id: "basic-addon3"
                    }, "$", -1)),
                    V(a("input", {
                      type: "text",
                      id: "inputRangeHigh",
                      class: "form-control text-end",
                      "aria-describedby": "basic-addon3",
                      "onUpdate:modelValue": t[4] || (t[4] = (v) => e.rentalRateHigh = v),
                      disabled: ((f = e.calcParams) == null ? void 0 : f.customRentalAvm) != !0
                    }, null, 8, VMe), [
                      [_e, e.rentalRateHigh]
                    ])
                  ])
                ]),
                a("div", DMe, [
                  a("div", NMe, [
                    V(a("input", {
                      class: "form-check-input",
                      type: "checkbox",
                      value: "",
                      id: "flexCheckDefault",
                      "onUpdate:modelValue": t[5] || (t[5] = (v) => e.calcParams.hideRentalForecastData = v)
                    }, null, 512), [
                      [Ue, e.calcParams.hideRentalForecastData]
                    ]),
                    t[32] || (t[32] = a("label", {
                      class: "form-check-label",
                      for: "flexCheckDefault"
                    }, " Hide rental rate estimate data from PDFs and property sharing URLs ", -1))
                  ])
                ])
              ])
            ]),
            a("div", jMe, [
              t[36] || (t[36] = a("button", {
                type: "button",
                class: "btn btn-light me-auto",
                "data-bs-dismiss": "modal"
              }, "Close", -1)),
              a("button", {
                type: "button",
                onClick: t[6] || (t[6] = (...v) => e.save && e.save(...v)),
                class: "btn btn-lava"
              }, "Save Forecast")
            ])
          ])
        ])
      ], 512),
      t[38] || (t[38] = Bt('<div class="modal fade" id="dialogRrNonSingleFamily" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true"><div class="modal-dialog modal-dialog-centered"><div class="modal-content bg-gradient-alphabet rounded"><div class="text-center p-5"><i class="fa-duotone fa-solid fa-buildings mb-3 fa-3xl"></i><br><button type="button" class="btn-close position-absolute top-10 end-10" data-bs-dismiss="modal" aria-label="Close"></button><b class="fs-5">Non Single Family</b><br><br> Expect lower accuracy in AVM predictions for non-single-family properties. Please utilize local market knowledge and validate the rental rate employed in this analysis. </div></div></div></div><div class="modal fade" id="dialogMedianUsed" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true"><div class="modal-dialog modal-dialog-centered"><div class="modal-content bg-gradient-alphabet rounded"><div class="text-center p-5"><i class="fa-duotone fa-solid fa-box-dollar mb-3 fa-3xl"></i><br><button type="button" class="btn-close position-absolute top-10 end-10" data-bs-dismiss="modal" aria-label="Close"></button><b class="fs-5">Median $/SF Used</b><br><br> A precise Automated Valuation Model (AVM) prediction for the subject property is unavailable. Instead, the median value per square foot of comparable properties in the region has been generated. It is recommended to leverage local market expertise in order to adjust and confirm the rental rate used in this analysis. </div></div></div></div><div class="modal fade" id="dialogHighValue" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true"><div class="modal-dialog modal-dialog-centered"><div class="modal-content bg-gradient-alphabet rounded"><div class="text-center p-5"><i class="fa-duotone fa-solid fa-gauge-high mb-3 fa-3xl"></i><br><button type="button" class="btn-close position-absolute top-10 end-10" data-bs-dismiss="modal" aria-label="Close"></button><b class="fs-5">Above Average Characteristics</b><br><br> AVM Predictions for spacious and/or high-value residences will exhibit lower accuracy compared to properties that are closer to the average quality and condition within the vicinity. It is essential to assess individual property conditions thoroughly and utilize local market knowledge to modify and validate the rental rate employed in this analysis. </div></div></div></div>', 3))
    ], 64)) : P("", !0),
    e.isEnterprise ? P("", !0) : (p(), h("div", HMe, t[39] || (t[39] = [
      Bt('<div class="modal-dialog modal-dialog-centered"><div class="modal-content bg-gradient-alphabet rounded"><div class="modal-header border-0 pb-0"><button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button></div><div class="py-4 text-center"><img src="' + $k + '" height="300"></div><div class="modal-body text-center"><p class="fs-5 mb-2 fw-bold">Rental Rate Adjustment</p><p> Upgrade to an Enterprise account to edit the Rental Rate. </p><a href="https://www.rescover.com/contact" target="_blank" class="btn btn-lava mt-3">Contact Sales today to Get Started!</a></div></div></div>', 1)
    ])))
  ], 64);
}
const Hls = /* @__PURE__ */ Ae(tBe, [["render", UMe]]), xg = !0, zMe = me({
  name: "PropertyValue",
  props: {
    analysis: {
      type: String,
      required: !1
    },
    share: {
      type: String,
      required: !1
    },
    discarded: {
      type: Boolean,
      default: !1
    },
    source: {
      type: String,
      required: !1
    }
  },
  emits: [
    "saveFields"
  ],
  data() {
    return {
      chartsInit: !1,
      propertyValue: void 0,
      metricsByZip: void 0,
      metricsByNeighborhood: void 0,
      metricsByCounty: void 0,
      metricsByState: void 0,
      loadingValues: !0,
      noData: !1,
      propertyType: void 0,
      rentalRateForecastSettings: {
        enableThreshold: !1,
        saleOffset: 0,
        saleThreshold: 0
      }
      //overwriteAvm: undefined,
    };
  },
  components: {
    ContentLoader: Sa
  },
  watch: {
    "property.mlsSource.isActiveMarketplaceListing"(e) {
      e && (this.loadZipRentalMetrics(), this.loadCountyRentalMetrics());
    },
    "property.propId"() {
      this.loadPropertyValue();
    },
    "property.address.zip"() {
      this.loadZipRentalMetrics();
    },
    "property.address.county"() {
      this.loadCountyRentalMetrics();
    },
    discarded: {
      handler: async function(t) {
      }
    }
  },
  computed: {
    showCard() {
      return this.noData == !1 && (!this.propertyType || this.propertyType == Xt.SingleFamily || this.propertyType == Xt.MultiFamily || this.propertyType == Xt.Residential24Family || this.propertyType == Xt.Unknown);
    },
    isLocked() {
      var e, t, s;
      return ((e = this.acl) == null ? void 0 : e.isAnalysis) == !0 || ((t = this.acl) == null ? void 0 : t.isIdx) == !0 || ((s = this.acl) == null ? void 0 : s.isShare) == !0;
    },
    isEnterprise() {
      var e, t, s, n, r;
      return ((e = this.acl) == null ? void 0 : e.portfolioInsights) == !0 || ((s = (t = this.acl) == null ? void 0 : t.leads) == null ? void 0 : s.leads) == !0 || ((r = (n = this.acl) == null ? void 0 : n.freeRentalAnalysis) == null ? void 0 : r.access) == !0;
    },
    saleValueRaw() {
      var e, t, s, n;
      return ((e = this.calcParams) == null ? void 0 : e.customSaleAvm) == !0 ? ((t = this.calcParams) == null ? void 0 : t.saleAvmValue) ?? ((s = this.propertyValue) == null ? void 0 : s.rate) ?? 0 : ((n = this.propertyValue) == null ? void 0 : n.rate) ?? 0;
    },
    saleValue: {
      get() {
        return Ve(this.saleValueRaw, 2);
      },
      set(e) {
        this.calcParams.saleAvmValue = vs(e);
      }
    },
    saleLowRaw() {
      var e, t, s;
      return ((e = this.calcParams) == null ? void 0 : e.customSaleAvm) == !0 ? this.calcParams.saleAvmLow ?? ((t = this.propertyValue) == null ? void 0 : t.low) ?? 0 : ((s = this.propertyValue) == null ? void 0 : s.low) ?? 0;
    },
    saleLow: {
      get() {
        return Ve(this.saleLowRaw, 2);
      },
      set(e) {
        this.calcParams.saleAvmLow = vs(e);
      }
    },
    saleHighRaw() {
      var e, t, s;
      return ((e = this.calcParams) == null ? void 0 : e.customSaleAvm) == !0 ? this.calcParams.saleAvmHigh ?? ((t = this.propertyValue) == null ? void 0 : t.low) ?? 0 : ((s = this.propertyValue) == null ? void 0 : s.high) ?? 0;
    },
    saleHigh: {
      get() {
        return Ve(this.saleHighRaw, 2);
      },
      set(e) {
        this.calcParams.saleAvmHigh = vs(e);
      }
    },
    accessStyle() {
      return {
        "bg-light": this.haveAccess,
        "bg-gradient-periwinkle": this.haveAccess == !1
      };
    },
    haveAccess() {
      var e, t, s, n;
      return (((t = (e = this.property) == null ? void 0 : e.mlsSource) == null ? void 0 : t.isActiveMarketplaceListing) == !0 || ((n = (s = this.acl) == null ? void 0 : s.properties) == null ? void 0 : n.propertyMetrics) == !0) && (this.isAdmin || this.isUser || this.isClient);
    },
    ...q(Te, ["acl", "aclLoaded", "isClient", "isAdmin", "isUser"]),
    ...q(qe, ["property", "calcParams", "isMarketplace"])
  },
  methods: {
    shortDate: cs,
    currency: Ze,
    shortCurrency: ka,
    number: Ve,
    percent: Wt,
    async loadPropertyValue() {
      var e;
      this.loadingValues = !0;
      try {
        if (xg && console.log(`${this.$options.name}.loadPropertyValue`), !((e = this.property) != null && e.propId))
          return;
        const t = await W.api.property.propertyValue(this.property.propId);
        this.propertyValue = t.data.metrics, this.propertyType = t.data.propertyType, this.noData = this.propertyValue == null, this.pValueBarChart == null && await this.initCharts(), this.pValueBarChart && this.propertyValue && (this.pValueBarChart.data.datasets[0].backgroundColor[0] = De.Colors.ChartDarkBlue, this.pValueBarChart.data.datasets[0].data[0] = this.saleValueRaw, this.pValueBarChart.update());
      } catch (t) {
        console.error(`${this.$options.name}.loadPropertyValue`, t);
      }
      this.loadingValues = !1;
    },
    async loadZipRentalMetrics() {
      var e, t;
      this.loadingValues = !0;
      try {
        if (xg && console.log(`${this.$options.name}.loadZipRentalMetrics`), !((t = (e = this.property) == null ? void 0 : e.address) != null && t.zip))
          return;
        const s = await W.api.geo.propertyValueMetricsByZip(this.property.address.zip);
        this.metricsByZip = s.data.metrics, this.pValueBarChart == null && await this.initCharts(), this.metricsByZip && this.pValueBarChart && (this.pValueBarChart.data.datasets[0].backgroundColor[1] = De.Colors.ChartLiteOrange, this.pValueBarChart.data.datasets[0].data[1] = this.metricsByZip.median, this.pValueBarChart.update());
      } catch (s) {
        console.error(`${this.$options.name}.loadZipRentalMetrics`, s);
      }
      this.loadingValues = !1;
    },
    async loadCountyRentalMetrics() {
      var e, t, s, n;
      this.loadingValues = !0;
      try {
        if (xg && console.log(`${this.$options.name}.loadCountyRentalMetrics`), !((t = (e = this.property) == null ? void 0 : e.address) != null && t.state) || !((n = (s = this.property) == null ? void 0 : s.address) != null && n.county))
          return;
        const r = await W.api.geo.propertyValueMetricsByCounty(this.property.address.state, this.property.address.county);
        this.metricsByCounty = r.data.metrics, this.pValueBarChart == null && await this.initCharts(), this.metricsByCounty && this.pValueBarChart && (this.pValueBarChart.data.datasets[0].backgroundColor[2] = De.Colors.ChartTurquoise, this.pValueBarChart.data.datasets[0].data[2] = this.metricsByCounty.median, this.pValueBarChart.update());
      } catch (r) {
        console.error(`${this.$options.name}.loadCountyRentalMetrics`, r);
      }
      this.loadingValues = !1;
    },
    async initCharts() {
      await this.initChartsLock.runExclusive(async () => {
        try {
          if (this.chartsInit) return;
          if (this.pValueBarChart == null && this.$refs.pValueBarChart) {
            let e = this.$refs.pValueBarChart.getContext("2d");
            this.pValueBarChart = new Rt(e, {
              type: "bar",
              data: {
                labels: [
                  "Subject",
                  "Zip Median",
                  "County Median"
                ],
                datasets: [{
                  backgroundColor: [
                    De.Colors.grey1,
                    De.Colors.grey2,
                    De.Colors.grey3
                  ],
                  borderWidth: 0,
                  borderRadius: 5,
                  data: [
                    250123,
                    301123,
                    312123
                  ]
                }]
              },
              options: {
                maintainAspectRatio: !1,
                plugins: {
                  tooltip: {
                    enabled: !1
                  },
                  legend: {
                    display: !1
                  }
                },
                indexAxis: "y",
                scales: {
                  x: {
                    grid: {
                      display: !1
                    },
                    ticks: {
                      callback: function(t, s, n) {
                        return Ze(t);
                      }
                    }
                  }
                },
                layout: {
                  padding: {
                    right: 80
                  }
                }
              },
              plugins: [
                {
                  id: "alwaysShowTooltip",
                  afterDraw(t, s, n) {
                    const { ctx: r } = t;
                    r.save(), t.data.datasets.forEach((i, o) => {
                      t.getDatasetMeta(o).data.forEach((l, d) => {
                        const { x: c, y: u } = l.tooltipPosition(), m = t.data.datasets[o].data[d];
                        r.font = "12px Arial", r.fillStyle = "Black", r.fillText(Ze(m), c + 5, u + 6), r.restore();
                      });
                    });
                  }
                }
              ]
            });
          }
          this.chartsInit = !0;
        } catch (e) {
          console.error(`${this.$options.name}.initCharts`, e);
        }
      });
    },
    async getAvmAdjustmentSettings() {
      var t;
      try {
        if ((t = this.acl) != null && t.isAnonymous) return;
        var e = await W.api.account.getAvmAdjustmentSettings();
        if (e.data.status != de.Success)
          throw new Error(e.data.message);
        this.rentalRateForecastSettings = e.data;
      } catch (s) {
        console.error(`${this.$options.name}.getAvmAdjustmentSettings`, s);
      }
    },
    save() {
      this.$emit("saveFields", "");
      const e = bootstrap.Modal.getOrCreateInstance(this.$refs.modalEditSaleForecast);
      e == null || e.hide();
    }
  },
  created() {
    this.initChartsLock = new xa();
  },
  mounted() {
    try {
      this.aclLoaded.then(() => {
        this.initCharts().then(async () => {
          this.haveAccess && (this.loadZipRentalMetrics(), this.loadCountyRentalMetrics());
        }).then(this.loadPropertyValue).then(this.getAvmAdjustmentSettings);
      });
    } catch (e) {
      console.error(`${this.$options.name}.mounted`, e);
    }
  }
}), WMe = "data:image/png;base64,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", GMe = { class: "card shadow-sm" }, YMe = { class: "card-header d-flex flex-column flex-sm-row align-items-center justify-content-between bg-white border-0 pb-0" }, XMe = { class: "text-center text-lg-start fw-bold" }, qMe = {
  key: 0,
  class: "text-center text-lg-end text-muted text-small"
}, QMe = { class: "card-body" }, KMe = { class: "d-flex justify-content-between flex-column flex-md-row gap-3" }, ZMe = { class: "bg-light rounded" }, JMe = { key: 0 }, $Me = {
  key: 1,
  class: "d-flex justify-content-around flex-row flex-md-column"
}, _Me = { class: "border-bottom border-bottom-white p-3" }, exe = {
  key: 0,
  class: "fw-bold fs-5 d-block lh-sm"
}, txe = {
  key: 0,
  class: "text-black text-opacity-25 text-small ms-1 m-lg-0"
}, sxe = {
  key: 1,
  class: "fw-bold fs-5"
}, axe = { class: "border-bottom border-bottom-white p-3" }, nxe = {
  key: 0,
  class: "text-dark fw-bold"
}, rxe = ["title"], oxe = ["title"], ixe = {
  key: 1,
  class: "text-dark fw-bold"
}, lxe = {
  key: 2,
  class: "text-dark fw-bold"
}, dxe = {
  key: 0,
  class: "p-3"
}, cxe = {
  key: 0,
  class: "text-dark fw-bold"
}, uxe = {
  key: 1,
  class: "text-dark fw-bold"
}, pxe = {
  key: 2,
  class: "text-dark fw-bold"
}, hxe = {
  key: 0,
  class: "position-relative",
  style: { height: "250px", width: "100%" }
}, mxe = {
  class: "rrBarChart",
  ref: "pValueBarChart"
}, fxe = {
  key: 1,
  class: "position-absolute"
}, gxe = {
  key: 2,
  class: "text-center p-3"
}, vxe = {
  key: 0,
  class: "card-footer bg-white d-flex justify-content-end"
}, yxe = {
  key: 0,
  type: "button",
  class: "btn btn-outline-eclipse btn-sm",
  "data-bs-toggle": "modal",
  "data-bs-target": "#modalEditSaleForecast"
}, bxe = {
  key: 1,
  type: "button",
  class: "btn btn-outline-eclipse btn-sm",
  "data-bs-toggle": "modal",
  "data-bs-target": "#modalRRAdjustmentGuard"
}, Axe = {
  class: "modal fade",
  id: "modalEditSaleForecast",
  tabindex: "-1",
  "aria-labelledby": "modalEditSaleForecastLabel",
  "aria-hidden": "true",
  ref: "modalEditSaleForecast"
}, wxe = { class: "modal-dialog modal-dialog-centered" }, Cxe = { class: "modal-content bg-gradient-alphabet rounded" }, Sxe = { class: "modal-body" }, Pxe = { class: "row g-3" }, kxe = { class: "col-sm-3" }, Exe = { class: "form-check form-switch form-switch-lg form-switch-basic" }, Ixe = { class: "col-sm-8" }, Txe = { class: "input-group" }, Oxe = ["disabled"], Rxe = { class: "col-sm-4" }, Lxe = { class: "input-group" }, Bxe = ["disabled"], Mxe = { class: "col-sm-4" }, xxe = { class: "input-group" }, Fxe = ["disabled"], Vxe = { class: "col-12" }, Dxe = { class: "form-check" }, Nxe = { class: "modal-footer border-0 pt-0" }, jxe = {
  key: 1,
  class: "modal fade",
  id: "modalRRAdjustmentGuard",
  tabindex: "-1",
  "aria-labelledby": "modalRRAdjustmentGuardLabel",
  "aria-hidden": "true"
};
function Hxe(e, t, s, n, r, i) {
  var l, d, c, u, m, f;
  const o = pe("content-loader");
  return p(), h(A, null, [
    e.showCard ? (p(), h(A, { key: 0 }, [
      a("div", GMe, [
        a("div", YMe, [
          a("div", XMe, [
            ((l = e.calcParams) == null ? void 0 : l.customSaleAvm) != !0 ? (p(), h(A, { key: 0 }, [
              y(" Property Value AVM Prediction ")
            ], 64)) : (p(), h(A, { key: 1 }, [
              y(g(e.source) + " Property Value Estimate ", 1)
            ], 64))
          ]),
          (d = e.propertyValue) != null && d.valuationDate ? (p(), h("div", qMe, " Last Updated: " + g(e.shortDate(e.propertyValue.valuationDate)), 1)) : P("", !0)
        ]),
        a("div", QMe, [
          a("div", KMe, [
            a("div", ZMe, [
              e.loadingValues ? (p(), h("div", JMe, [
                N(o, {
                  speed: 2,
                  width: 344,
                  height: 168,
                  class: "d-sm-none"
                }),
                N(o, {
                  speed: 2,
                  width: 470,
                  height: 87,
                  class: "d-none d-sm-block d-md-none"
                }),
                N(o, {
                  speed: 2,
                  width: 650,
                  height: 87,
                  class: "d-none d-md-block d-lg-none"
                }),
                N(o, {
                  speed: 2,
                  width: 490,
                  height: 87,
                  class: "d-none d-lg-block d-xl-none"
                }),
                N(o, {
                  speed: 2,
                  width: 158,
                  height: 248,
                  class: "d-none d-xl-block img-fluid"
                })
              ])) : (p(), h("div", $Me, [
                a("div", _Me, [
                  t[6] || (t[6] = a("span", { class: "text-secondary text-opacity-50 fw-bold small d-block" }, "VALUE", -1)),
                  e.propertyValue ? (p(), h("span", exe, [
                    y(g(e.currency(e.saleValueRaw)) + " ", 1),
                    e.saleValueRaw && e.propertyValue.squareFeet ? (p(), h("span", txe, "(" + g(e.currency(e.saleValueRaw / e.propertyValue.squareFeet)) + "/SF)", 1)) : P("", !0)
                  ])) : (p(), h("span", sxe, "N/A"))
                ]),
                a("div", axe, [
                  t[8] || (t[8] = a("span", { class: "text-secondary text-opacity-50 fw-bold small" }, "RANGE", -1)),
                  t[9] || (t[9] = a("br", null, null, -1)),
                  e.propertyValue && e.haveAccess ? (p(), h("span", nxe, [
                    a("span", {
                      title: e.currency(e.propertyValue.low)
                    }, g(e.shortCurrency(e.saleLowRaw)), 9, rxe),
                    t[7] || (t[7] = y(" - ")),
                    a("span", {
                      title: e.currency(e.propertyValue.high)
                    }, g(e.shortCurrency(e.saleHighRaw)), 9, oxe)
                  ])) : e.propertyValue ? (p(), h("span", lxe, "Upgrade!")) : (p(), h("span", ixe, "N/A"))
                ]),
                ((c = e.calcParams) == null ? void 0 : c.customSaleAvm) != !0 ? (p(), h("div", dxe, [
                  t[10] || (t[10] = a("span", { class: "text-secondary text-opacity-50 fw-bold small" }, "CONFIDENCE SCORE", -1)),
                  t[11] || (t[11] = a("br", null, null, -1)),
                  e.propertyValue && e.haveAccess ? (p(), h("span", cxe, g(e.percent(e.propertyValue.confidence)), 1)) : e.propertyValue ? (p(), h("span", pxe, "Upgrade!")) : (p(), h("span", uxe, "N/A"))
                ])) : P("", !0)
              ]))
            ]),
            a("div", {
              class: z(["rounded flex-grow-1 chart-container chart-container_doughnut position-relative", e.accessStyle])
            }, [
              e.haveAccess ? (p(), h("div", hxe, [
                a("canvas", mxe, null, 512)
              ])) : e.loadingValues ? (p(), h("div", fxe, [
                N(o, {
                  speed: 2,
                  width: 344,
                  height: 239,
                  class: "d-sm-none"
                }),
                N(o, {
                  speed: 2,
                  width: 490,
                  height: 214,
                  class: "d-none d-sm-block d-md-none"
                }),
                N(o, {
                  speed: 2,
                  width: 650,
                  height: 214,
                  class: "d-none d-md-block d-lg-none"
                }),
                N(o, {
                  speed: 2,
                  width: 490,
                  height: 214,
                  class: "d-none d-lg-block d-xl-none"
                }),
                N(o, {
                  speed: 2,
                  width: 537,
                  height: 248,
                  class: "d-none d-xl-block img-fluid"
                })
              ])) : (p(), h("div", gxe, t[12] || (t[12] = [
                a("img", {
                  src: WMe,
                  alt: "Property Value AVM",
                  title: "Property Value AVM",
                  height: "216",
                  width: "478",
                  class: "img-fluid",
                  loading: "lazy"
                }, null, -1),
                a("p", { class: "fw-bold fs-5" }, [
                  y(" With a Property Suite Pro account you can view"),
                  a("br", { class: "d-none d-xxl-block" }),
                  y(" surrounding area median prices. ")
                ], -1),
                a("a", {
                  href: "/account/settings",
                  class: "btn btn-eclipse"
                }, "Activate Property Values!", -1)
              ])))
            ], 2)
          ])
        ]),
        e.isLocked ? P("", !0) : (p(), h("div", vxe, [
          e.isEnterprise ? (p(), h("button", yxe, "Edit")) : (p(), h("button", bxe, "Edit Rental Rate"))
        ]))
      ]),
      a("div", Axe, [
        a("div", wxe, [
          a("div", Cxe, [
            t[24] || (t[24] = a("div", { class: "modal-header border-0 pb-0" }, [
              a("p", {
                class: "modal-title mb-0 fw-bold fs-5",
                id: "modalEditSaleForecastLabel"
              }, "Edit Property Value"),
              a("button", {
                type: "button",
                class: "btn-close",
                "data-bs-dismiss": "modal",
                "aria-label": "Close"
              })
            ], -1)),
            a("div", Sxe, [
              a("div", Pxe, [
                t[20] || (t[20] = a("label", {
                  class: "col-sm-9 col-form-label",
                  for: "flexSwitchCheckDefault"
                }, "Overwrite AVM Estimate With Custom Values", -1)),
                a("div", kxe, [
                  a("div", Exe, [
                    V(a("input", {
                      class: "form-check-input",
                      type: "checkbox",
                      role: "switch",
                      id: "flexSwitchCheckDefault",
                      "onUpdate:modelValue": t[0] || (t[0] = (v) => e.calcParams.customSaleAvm = v)
                    }, null, 512), [
                      [Ue, e.calcParams.customSaleAvm]
                    ]),
                    t[13] || (t[13] = a("label", {
                      class: "form-check-label",
                      for: "flexSwitchCheckDefault"
                    }, [
                      y("Yes"),
                      a("span", null, "No")
                    ], -1))
                  ])
                ]),
                t[21] || (t[21] = a("label", {
                  for: "inputRentalRate",
                  class: "col-sm-4 col-form-label"
                }, "Value", -1)),
                a("div", Ixe, [
                  a("div", Txe, [
                    t[14] || (t[14] = a("span", {
                      class: "input-group-text",
                      id: "basic-addon1"
                    }, "$", -1)),
                    V(a("input", {
                      type: "text",
                      id: "inputRentalRate",
                      class: "form-control text-end",
                      "aria-describedby": "basic-addon1",
                      "onUpdate:modelValue": t[1] || (t[1] = (v) => e.saleValue = v),
                      disabled: ((u = e.calcParams) == null ? void 0 : u.customSaleAvm) == !1
                    }, null, 8, Oxe), [
                      [_e, e.saleValue]
                    ])
                  ])
                ]),
                t[22] || (t[22] = a("label", {
                  for: "inputRange",
                  class: "col-sm-4 col-form-label"
                }, "Range", -1)),
                a("div", Rxe, [
                  t[16] || (t[16] = a("label", {
                    for: "inputRange",
                    class: "col-sm-2 col-form-label"
                  }, "Low", -1)),
                  a("div", Lxe, [
                    t[15] || (t[15] = a("span", {
                      class: "input-group-text",
                      id: "basic-addon2"
                    }, "$", -1)),
                    V(a("input", {
                      type: "text",
                      id: "inputRange",
                      class: "form-control text-end",
                      "aria-describedby": "basic-addon2",
                      "onUpdate:modelValue": t[2] || (t[2] = (v) => e.saleLow = v),
                      disabled: ((m = e.calcParams) == null ? void 0 : m.customSaleAvm) == !1
                    }, null, 8, Bxe), [
                      [_e, e.saleLow]
                    ])
                  ])
                ]),
                a("div", Mxe, [
                  t[18] || (t[18] = a("label", {
                    for: "inputRangeHigh",
                    class: "col-sm-2 col-form-label"
                  }, "High", -1)),
                  a("div", xxe, [
                    t[17] || (t[17] = a("span", {
                      class: "input-group-text",
                      id: "basic-addon3"
                    }, "$", -1)),
                    V(a("input", {
                      type: "text",
                      id: "inputRangeHigh",
                      class: "form-control text-end",
                      "aria-describedby": "basic-addon3",
                      "onUpdate:modelValue": t[3] || (t[3] = (v) => e.saleHigh = v),
                      disabled: ((f = e.calcParams) == null ? void 0 : f.customSaleAvm) == !1
                    }, null, 8, Fxe), [
                      [_e, e.saleHigh]
                    ])
                  ])
                ]),
                a("div", Vxe, [
                  a("div", Dxe, [
                    V(a("input", {
                      class: "form-check-input",
                      type: "checkbox",
                      value: "",
                      id: "flexCheckDefault",
                      "onUpdate:modelValue": t[4] || (t[4] = (v) => e.calcParams.hideSaleForecastData = v)
                    }, null, 512), [
                      [Ue, e.calcParams.hideSaleForecastData]
                    ]),
                    t[19] || (t[19] = a("label", {
                      class: "form-check-label",
                      for: "flexCheckDefault"
                    }, " Hide property value estimate from PDFs and property sharing URLs ", -1))
                  ])
                ])
              ])
            ]),
            a("div", Nxe, [
              t[23] || (t[23] = a("button", {
                type: "button",
                class: "btn btn-light me-auto",
                "data-bs-dismiss": "modal"
              }, "Close", -1)),
              a("button", {
                type: "button",
                onClick: t[5] || (t[5] = (...v) => e.save && e.save(...v)),
                class: "btn btn-lava"
              }, "Save Forecast")
            ])
          ])
        ])
      ], 512)
    ], 64)) : P("", !0),
    e.isEnterprise ? P("", !0) : (p(), h("div", jxe, t[25] || (t[25] = [
      Bt('<div class="modal-dialog modal-dialog-centered"><div class="modal-content bg-gradient-alphabet rounded"><div class="modal-header border-0 pb-0"><button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button></div><div class="py-4 text-center"><img src="' + $k + '" height="300"></div><div class="modal-body text-center"><p class="fs-5 mb-2 fw-bold">Rental Rate Adjustment</p><p> Upgrade to an Enterprise account to edit the Rental Rate. </p><a href="https://www.rescover.com/contact" target="_blank" class="btn btn-lava mt-3">Contact Sales today to Get Started!</a></div></div></div>', 1)
    ])))
  ], 64);
}
const Uls = /* @__PURE__ */ Ae(zMe, [["render", Hxe]]), Uxe = me({
  name: "MlsHistory",
  computed: {
    ...at(qe),
    ...q(Te, ["acl", "aclLoaded"]),
    ...q(qe, ["propertyInitialized", "mlsHistory"])
  },
  methods: {
    currency: Ze,
    shortDate: cs,
    async retrieveMlsHistory() {
      var e;
      if (!((e = this.acl) != null && e.isAnonymous))
        try {
          console.log("retrieveMlsHistory"), await this.propertyStore.retrieveMlsHistory();
        } catch (t) {
          Se(t.message, jo.Right, !0);
        }
    }
  },
  mounted() {
    this.aclLoaded.then(async () => await this.propertyInitialized).then(async () => await this.retrieveMlsHistory());
  }
}), zxe = "data:image/png;base64,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", Wxe = { class: "card shadow-sm card-mls-history" }, Gxe = {
  key: 0,
  class: "bg-gradient-periwinkle d-flex flex-column flex-md-row justify-content-between align-items-center"
}, Yxe = {
  key: 1,
  class: "card-body"
}, Xxe = {
  key: 2,
  class: "card-body-scroll"
}, qxe = { class: "table table-borderless mb-0" }, Qxe = { class: "border-top" }, Kxe = { class: "pb-0" }, Zxe = { class: "pb-0" }, Jxe = { class: "pb-0 text-end" }, $xe = {
  colspan: "2",
  class: "pt-0 text-secondary text-opacity-75"
}, _xe = { class: "text-end pt-0 text-secondary-subtle" };
function eFe(e, t, s, n, r, i) {
  var o;
  return p(), h("div", Wxe, [
    t[4] || (t[4] = a("div", { class: "card-header bg-white font-weight-bold" }, " MLS History ", -1)),
    (o = e.acl) != null && o.isAnonymous ? (p(), h("div", Gxe, t[0] || (t[0] = [
      Bt('<div class="px-4 py-3 order-last order-md-first text-center text-md-start"><p class="fw-bold fs-5"> With an account you can view MLS price history. </p><a href="/signup" class="btn btn-lava"> Activate MLS History! </a></div><div class="d-none d-md-block"><img src="' + zxe + '" alt="MLS History table" title="MLS History table" height="330" width="300" class="img-fluid" loading="lazy"></div>', 2)
    ]))) : e.mlsHistory.length == 0 ? (p(), h("div", Yxe, " No MLS history available ")) : (p(), h("div", Xxe, [
      a("table", qxe, [
        t[3] || (t[3] = a("thead", null, [
          a("tr", { class: "border-bottom" }, [
            a("th", null, " Date "),
            a("th", null, " Action "),
            a("th", { class: "text-end" }, " Price ")
          ])
        ], -1)),
        a("tbody", null, [
          (p(!0), h(A, null, D(e.mlsHistory, (l) => (p(), h(A, null, [
            a("tr", Qxe, [
              a("td", Kxe, g(e.shortDate(l.date)), 1),
              a("td", Zxe, g(l.status), 1),
              a("td", Jxe, g(e.currency(l.price)), 1)
            ]),
            a("tr", null, [
              a("td", $xe, " Source: " + g(l.broker), 1),
              a("td", _xe, [
                y(" (" + g(e.currency(l.priceSqft)), 1),
                t[1] || (t[1] = a("small", null, "/SF", -1)),
                t[2] || (t[2] = y(") "))
              ])
            ])
          ], 64))), 256))
        ])
      ])
    ]))
  ]);
}
const zls = /* @__PURE__ */ Ae(Uxe, [["render", eFe]]), tFe = me({
  name: "BrandingHeader",
  computed: {
    mlsEntitled() {
      var e, t;
      return ((t = (e = this.acl) == null ? void 0 : e.mls) == null ? void 0 : t.entitled) == !0;
    },
    companyLogoUrl() {
      var e;
      return (e = this.branding) == null ? void 0 : e.companyLogoUrl;
    },
    headshotPhotoUrl() {
      var e;
      return (e = this.branding) == null ? void 0 : e.headshotPhotoUrl;
    },
    ...q(Te, ["acl", "aclLoaded"]),
    ...q(ct, ["branding"]),
    ...at(ct)
  },
  methods: {
    number: Ve,
    async loadBranding() {
      var e;
      if (((e = this.acl) == null ? void 0 : e.brandedPortal) == !0 && this.mlsEntitled == !0)
        try {
          this.accountStore.branding || await this.accountStore.fetchBranding();
        } catch (t) {
          Se(t);
        }
    }
  },
  mounted() {
    this.aclLoaded.then(async () => await this.loadBranding());
  }
}), sFe = {
  key: 0,
  class: "card shadow-sm bg-eclipse text-white"
}, aFe = { class: "d-flex align-items-center card-body" }, nFe = ["src"], rFe = { class: "media-body flex-grow-1 ms-3" }, oFe = { class: "m-0" }, iFe = { class: "fs-5" }, lFe = { class: "text-white text-opacity-50 fw-bold" };
function dFe(e, t, s, n, r, i) {
  return e.mlsEntitled && e.branding ? (p(), h("div", sFe, [
    a("div", aFe, [
      e.branding && e.branding.hasHeadshot ? (p(), h("img", {
        key: 0,
        src: e.headshotPhotoUrl,
        class: "rounded-circle flex-shrink-0",
        alt: "User's avatar",
        title: "User's avatar",
        loading: "lazy",
        height: "70"
      }, null, 8, nFe)) : P("", !0),
      a("div", rFe, [
        t[1] || (t[1] = a("p", null, "Your Real Estate Professional", -1)),
        a("p", oFe, [
          a("b", iFe, g(e.branding.agentFirstName) + " " + g(e.branding.agentLastName), 1),
          t[0] || (t[0] = a("br", null, null, -1)),
          a("span", lFe, g(e.branding.company), 1)
        ])
      ])
    ])
  ])) : P("", !0);
}
const cFe = /* @__PURE__ */ Ae(tFe, [["render", dFe]]), uFe = me({
  name: "PropertyDetails",
  props: {
    apiKey: {
      type: String,
      required: !1
    }
  },
  emits: ["editDetails"],
  computed: {
    source() {
      var e;
      return (e = this.propertyDetails) != null && e.source ? this.propertyDetails.source : "Rescover";
    },
    pool() {
      var e, t;
      return (e = this.propertyDetails) != null && e.poolFeatures ? (t = this.propertyDetails) == null ? void 0 : t.poolFeatures.join(", ") : "N/A";
    },
    floorOption() {
      var e, t;
      return (e = this.propertyDetails) != null && e.flooring ? (t = this.propertyDetails) == null ? void 0 : t.flooring.split(",")[0].trim() : "None";
    },
    roofOption() {
      var e, t, s;
      return (e = this.propertyDetails) != null && e.roof ? (s = (t = this.propertyDetails) == null ? void 0 : t.roof[0]) == null ? void 0 : s.trim() : "";
    },
    canEditDetails() {
      return this.acl.isAnonymous != !0 && (this.isAdmin || this.isUser || this.isClient) && this.isActiveMlsListing == !1;
    },
    propertyType() {
      var e, t;
      if (this.propertyTypeOverriden)
        switch ((e = this.property) == null ? void 0 : e.propertyType) {
          case Qa.MultiFamily:
            switch (this.property.unitCount) {
              case 2:
                return "Duplex";
              case 3:
                return "Triplex";
              case 4:
                return "Quadruplex";
            }
            return "";
          case Qa.Commercial:
            return "Apartment";
        }
      return (t = this.propertyDetails) == null ? void 0 : t.propertyType;
    },
    isActiveMlsListing() {
      var e, t, s, n, r, i;
      return ((t = (e = this.property) == null ? void 0 : e.mlsSource) == null ? void 0 : t.isActive) == !0 || ((n = (s = this.property) == null ? void 0 : s.mlsSource) == null ? void 0 : n.isActiveMarketplaceListing) == !0 || ((i = (r = this.property) == null ? void 0 : r.mlsSource) == null ? void 0 : i.isPending) == !0;
    },
    ...at(qe),
    ...q(qe, ["property", "propertyTypeOverriden", "propertyDetails", "propertyInitialized"]),
    ...q(Te, ["acl", "aclLoaded", "isClient", "isAdmin", "isUser"])
  },
  methods: {
    number: Ve,
    async getPropertyDetails() {
      try {
        await this.propertyStore.getPropertyDetails();
      } catch (e) {
        Se(e);
      }
    },
    editDetails() {
      this.$emit("editDetails", this.propertyDetails);
    }
  },
  mounted() {
    this.aclLoaded.then(async () => await this.propertyInitialized).then(() => {
      this.propertyStore.propId && this.getPropertyDetails();
    });
  }
}), Cb = "data:image/png;base64,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", pFe = {
  key: 0,
  class: "card card-property-details shadow-sm"
}, hFe = { class: "card-header bg-white d-flex flex-column" }, mFe = { class: "d-flex justify-content-between align-items-center" }, fFe = { class: "text-secondary text-opacity-50" }, gFe = { class: "table m-0" }, vFe = { class: "text-truncate" }, yFe = { class: "text-truncate" }, bFe = { class: "text-truncate" }, AFe = { class: "text-truncate" }, wFe = { class: "text-truncate" }, CFe = { class: "text-truncate" }, SFe = { class: "text-truncate" }, PFe = { class: "text-truncate" }, kFe = { class: "text-truncate" }, EFe = { class: "text-truncate" }, IFe = { class: "text-truncate" }, TFe = { class: "text-truncate" }, OFe = { class: "text-truncate" }, RFe = { class: "text-truncate" }, LFe = { class: "text-truncate" }, BFe = { class: "text-truncate" }, MFe = { class: "text-truncate" };
function xFe(e, t, s, n, r, i) {
  return p(), Fe(ks, {
    name: "slide",
    mode: "out-in"
  }, {
    default: ve(() => {
      var o, l, d, c, u, m, f, v, b, w, S, I, T;
      return [
        e.propertyDetails ? (p(), h("div", pFe, [
          a("div", hFe, [
            a("div", mFe, [
              t[2] || (t[2] = a("span", { class: "fw-bold" }, "Property Details", -1)),
              e.canEditDetails ? (p(), h("button", {
                key: 0,
                type: "button",
                class: "btn btn-sm btn-lava ms-auto",
                onClick: t[0] || (t[0] = (...x) => e.editDetails && e.editDetails(...x))
              }, t[1] || (t[1] = [
                a("i", { class: "fa-light fa-pencil me-1" }, null, -1),
                y(" Edit Details")
              ]))) : P("", !0)
            ]),
            a("span", fFe, "Source: " + g(e.source), 1)
          ]),
          a("table", gFe, [
            a("tbody", null, [
              a("tr", null, [
                t[3] || (t[3] = a("td", { class: "text-center" }, [
                  a("i", { class: "fa-light fa-house-building" })
                ], -1)),
                t[4] || (t[4] = a("th", null, " Property Type: ", -1)),
                a("td", vFe, g(e.propertyType), 1)
              ]),
              a("tr", null, [
                t[5] || (t[5] = a("td", { class: "text-center" }, [
                  a("img", {
                    src: Cb,
                    height: "18",
                    width: "18",
                    class: "img-fluid",
                    alt: "Blueprint",
                    title: "Blueprint"
                  })
                ], -1)),
                t[6] || (t[6] = a("th", null, " Square Footage: ", -1)),
                a("td", yFe, g(e.number((o = e.propertyDetails) == null ? void 0 : o.sqFt)), 1)
              ]),
              a("tr", null, [
                t[7] || (t[7] = a("td", { class: "text-center" }, [
                  a("i", { class: "fa-light fa-birthday-cake" })
                ], -1)),
                t[8] || (t[8] = a("th", null, " Year Built: ", -1)),
                a("td", bFe, g((l = e.propertyDetails) == null ? void 0 : l.yearBuilt), 1)
              ]),
              a("tr", null, [
                t[9] || (t[9] = a("td", { class: "text-center" }, [
                  a("i", { class: "fa-light fa-bed" })
                ], -1)),
                t[10] || (t[10] = a("th", null, " Bedrooms: ", -1)),
                a("td", AFe, g(e.number((d = e.propertyDetails) == null ? void 0 : d.bedrooms)), 1)
              ]),
              a("tr", null, [
                t[11] || (t[11] = a("td", { class: "text-center" }, [
                  a("i", { class: "fa-light fa-bath" })
                ], -1)),
                t[12] || (t[12] = a("th", null, " Bathrooms: ", -1)),
                a("td", wFe, g((c = e.propertyDetails) == null ? void 0 : c.bathrooms), 1)
              ]),
              a("tr", null, [
                t[13] || (t[13] = a("td", { class: "text-center" }, [
                  a("i", { class: "fa-light fa-book" })
                ], -1)),
                t[14] || (t[14] = a("th", null, " Stories: ", -1)),
                a("td", CFe, g((u = e.propertyDetails) == null ? void 0 : u.stories), 1)
              ]),
              a("tr", null, [
                t[15] || (t[15] = a("td", { class: "text-center" }, [
                  a("i", { class: "fa-light fa-car-garage" })
                ], -1)),
                t[16] || (t[16] = a("th", null, " Garage: ", -1)),
                a("td", SFe, g((m = e.propertyDetails) == null ? void 0 : m.garageSpaces), 1)
              ]),
              a("tr", null, [
                t[17] || (t[17] = a("td", { class: "text-center" }, [
                  a("i", { class: "fa-light fa-square" })
                ], -1)),
                t[18] || (t[18] = a("th", null, " Lot Size: ", -1)),
                a("td", PFe, g((f = e.propertyDetails) == null ? void 0 : f.lotSize), 1)
              ]),
              a("tr", null, [
                t[19] || (t[19] = a("td", { class: "text-center" }, [
                  a("i", { class: "fa-light fa-home-lg-alt" })
                ], -1)),
                t[20] || (t[20] = a("th", null, " Style: ", -1)),
                a("td", kFe, g((v = e.propertyDetails) == null ? void 0 : v.style), 1)
              ]),
              a("tr", null, [
                t[21] || (t[21] = a("td", { class: "text-center" }, [
                  a("i", { class: "fa-light fa-arrow-to-bottom" })
                ], -1)),
                t[22] || (t[22] = a("th", null, " Foundation: ", -1)),
                a("td", EFe, g((b = e.propertyDetails) == null ? void 0 : b.foundation), 1)
              ]),
              a("tr", null, [
                t[23] || (t[23] = a("td", { class: "text-center" }, [
                  a("i", { class: "fa-light fa-tools" })
                ], -1)),
                t[24] || (t[24] = a("th", null, " Construction: ", -1)),
                a("td", IFe, g((w = e.propertyDetails) == null ? void 0 : w.construction), 1)
              ]),
              a("tr", null, [
                t[25] || (t[25] = a("td", { class: "text-center" }, [
                  a("i", { class: "fa-light fa-hard-hat" })
                ], -1)),
                t[26] || (t[26] = a("th", null, " Roof: ", -1)),
                a("td", TFe, g(e.roofOption), 1)
              ]),
              a("tr", null, [
                t[27] || (t[27] = a("td", { class: "text-center" }, [
                  a("i", { class: "fa-light fa-layer-group" })
                ], -1)),
                t[28] || (t[28] = a("th", null, " Flooring: ", -1)),
                a("td", OFe, g(e.floorOption), 1)
              ]),
              a("tr", null, [
                t[29] || (t[29] = a("td", { class: "text-center" }, [
                  a("i", { class: "fa-light fa-temperature-frigid" })
                ], -1)),
                t[30] || (t[30] = a("th", null, " Cooling: ", -1)),
                a("td", RFe, g((S = e.propertyDetails) == null ? void 0 : S.cooling), 1)
              ]),
              a("tr", null, [
                t[31] || (t[31] = a("td", { class: "text-center" }, [
                  a("i", { class: "fa-light fa-fire" })
                ], -1)),
                t[32] || (t[32] = a("th", null, " Heating: ", -1)),
                a("td", LFe, g((I = e.propertyDetails) == null ? void 0 : I.heating), 1)
              ]),
              a("tr", null, [
                t[33] || (t[33] = a("td", { class: "text-center" }, [
                  a("i", { class: "fa-light fa-fireplace" })
                ], -1)),
                t[34] || (t[34] = a("th", null, " Fireplace: ", -1)),
                a("td", BFe, g((T = e.propertyDetails) == null ? void 0 : T.fireplaces), 1)
              ]),
              a("tr", null, [
                t[35] || (t[35] = a("td", { class: "text-center" }, [
                  a("i", { class: "fa-light fa-swimmer" })
                ], -1)),
                t[36] || (t[36] = a("th", null, " Pool: ", -1)),
                a("td", MFe, g(e.pool), 1)
              ])
            ])
          ])
        ])) : P("", !0)
      ];
    }),
    _: 1
  });
}
const Wls = /* @__PURE__ */ Ae(uFe, [["render", xFe]]), FFe = me({
  name: "PropertyFiles",
  props: {
    propId: {
      type: Number,
      required: !0
    },
    analysis: {
      type: String,
      required: !1
    }
  },
  components: {},
  data() {
    return {
      files: []
    };
  },
  computed: {
    ...q(Te, ["acl", "aclLoaded"]),
    ...q(qe, ["property", "propertyInitialized"])
  },
  methods: {
    number: Ve,
    fileSize: W4,
    async retrieveFiles() {
      var e, t;
      try {
        await this.propertyInitialized;
        let s;
        if ((e = this.property.mlsSource) != null && e.source && ((t = this.property.mlsSource) != null && t.number) ? s = await W.api.mls.getListingFiles(this.property.mlsSource.source, this.property.mlsSource.number) : s = await W.api.homes.getPropertyFiles(this.propId), s.data.status != de.Success)
          throw new Error(s.data.message);
        this.files.length = 0, s.data.files && this.files.push(...s.data.files);
      } catch {
      }
    }
  },
  mounted() {
    this.aclLoaded.then(async () => {
      var e;
      ((e = this.acl) == null ? void 0 : e.isAnonymous) != !0 && await this.retrieveFiles();
    });
  }
}), VFe = {
  key: 0,
  class: "card shadow-sm"
}, DFe = { class: "card-body" }, NFe = { class: "table table-sm" }, jFe = ["href"];
function HFe(e, t, s, n, r, i) {
  return e.files.length > 0 ? (p(), h("div", VFe, [
    t[2] || (t[2] = a("div", { class: "card-header border-0 bg-white fw-bold pb-0 d-flex align-items-center justify-content-between" }, " Attachments ", -1)),
    a("div", DFe, [
      a("table", NFe, [
        t[1] || (t[1] = a("thead", null, [
          a("tr", null, [
            a("th"),
            a("th", null, "Filename"),
            a("th", null, "Size"),
            a("th")
          ])
        ], -1)),
        a("tbody", null, [
          (p(!0), h(A, null, D(e.files, (o) => (p(), h("tr", null, [
            t[0] || (t[0] = a("td", null, [
              a("i", { class: "fa-light fa-file" })
            ], -1)),
            a("td", null, g(o.filename), 1),
            a("td", null, g(e.fileSize(o.size, 1)), 1),
            a("td", null, [
              a("a", {
                href: o.url,
                target: "_blank",
                class: "btn btn-outline-eclipse btn-sm"
              }, " Download ", 8, jFe)
            ])
          ]))), 256))
        ])
      ])
    ])
  ])) : P("", !0);
}
const Gls = /* @__PURE__ */ Ae(FFe, [["render", HFe]]), UFe = me({
  name: "PropertyPhotos",
  computed: {
    canSeeMore() {
      return this.photos.length > 5;
    },
    ...q(Te, ["acl", "aclLoaded"]),
    ...q(qe, ["photos", "photoSource"]),
    ...at(qe)
  },
  methods: {
    number: Ve,
    showInitialPreview(e) {
      return e > 0 && e <= 4 || this.photos.length == 1;
    },
    buildStyle(e) {
      return {
        "col-6": !0,
        "col-md-3": !0,
        "mb-0": e > 2,
        "mb-3 mb-sm-0": e <= 2
      };
    },
    buildThumbnail(e) {
      return e + "?tr=n-thumb1";
    },
    async loadPropertyPhotos() {
      try {
        await this.propertyStore.retrievePhotos();
      } catch (e) {
        Se(e);
      }
    }
  },
  mounted() {
    this.aclLoaded.then(async () => await this.loadPropertyPhotos());
  }
}), zFe = {
  key: 0,
  class: "accordion d-print-none",
  id: "accordionExample"
}, WFe = { class: "card shadow-sm" }, GFe = {
  class: "card-header bg-white border-bottom-0 justify-content-between d-flex align-items-center mb-0",
  id: "headingOne"
}, YFe = { class: "text-start" }, XFe = { class: "text-secondary text-opacity-50" }, qFe = {
  key: 0,
  class: "btn btn-link text-decoration-none text-dark shadow-none collapsed",
  type: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#collapseOne",
  "aria-expanded": "true",
  "aria-controls": "collapseOne"
}, QFe = { class: "card-body pt-0" }, KFe = { class: "row" }, ZFe = ["href", "data-key"], JFe = ["src"], $Fe = {
  id: "collapseOne",
  class: "collapse",
  "aria-labelledby": "headingOne",
  "data-parent": "#accordionExample"
}, _Fe = { class: "card-body pt-0" }, eVe = { class: "mlse-gallery mlse-grid row" }, tVe = {
  key: 0,
  class: "col-6 col-md-3 mb-3"
}, sVe = ["href", "data-key"], aVe = ["src"];
function nVe(e, t, s, n, r, i) {
  return e.photos.length ? (p(), h("div", zFe, [
    a("div", WFe, [
      a("div", GFe, [
        a("div", YFe, [
          t[0] || (t[0] = a("span", { class: "fw-bold" }, "Photo Gallery", -1)),
          t[1] || (t[1] = a("br", null, null, -1)),
          a("span", XFe, "Source: " + g(e.photoSource), 1)
        ]),
        e.canSeeMore ? (p(), h("button", qFe, t[2] || (t[2] = [
          a("span", { class: "closed" }, [
            y(" See more"),
            a("i", { class: "fa-light fa-angle-right ms-2" })
          ], -1),
          a("span", { class: "opened" }, [
            y(" See less"),
            a("i", { class: "fa-light fa-angle-up ms-2" })
          ], -1)
        ]))) : P("", !0)
      ]),
      a("div", QFe, [
        a("div", KFe, [
          (p(!0), h(A, null, D(e.photos, (o, l) => (p(), h(A, { key: l }, [
            e.showInitialPreview(l) ? (p(), h("div", {
              key: 0,
              class: z(e.buildStyle(l))
            }, [
              a("a", {
                "data-fancybox": "gallery",
                "data-click-content": "nextOrClose",
                href: o,
                "data-key": l
              }, [
                a("img", {
                  src: e.buildThumbnail(o),
                  alt: "Property image",
                  title: "Property image",
                  loading: "lazy",
                  class: "img-fluid rounded"
                }, null, 8, JFe)
              ], 8, ZFe)
            ], 2)) : P("", !0)
          ], 64))), 128))
        ])
      ]),
      a("div", $Fe, [
        a("div", _Fe, [
          a("div", eVe, [
            (p(!0), h(A, null, D(e.photos, (o, l) => (p(), h(A, { key: l }, [
              Number(l) > 4 ? (p(), h("div", tVe, [
                a("a", {
                  "data-fancybox": "gallery",
                  "data-click-content": "nextOrClose",
                  href: o,
                  "data-key": l
                }, [
                  a("img", {
                    src: e.buildThumbnail(o),
                    alt: "Property image",
                    title: "Property image",
                    loading: "lazy",
                    class: "img-fluid rounded"
                  }, null, 8, aVe)
                ], 8, sVe)
              ])) : P("", !0)
            ], 64))), 128))
          ])
        ])
      ])
    ])
  ])) : P("", !0);
}
const Yls = /* @__PURE__ */ Ae(UFe, [["render", nVe]]), rVe = me({
  name: "Instances",
  components: {
    Select: hl
  },
  data() {
    return {
      selectedCity: null,
      cities: [
        { name: "Default", code: "NY" },
        { name: "02/22/2024", code: "RM" },
        { name: "02/20/2024", code: "LDN" },
        { name: "01/15/2024", code: "LDN" },
        { name: "12/12/2023", code: "LDN" }
      ]
    };
  },
  computed: {
    ...q(Te, ["access", "aclLoaded"])
  },
  methods: {
    number: Ve
  },
  mounted() {
    this.aclLoaded.then(() => {
    });
  }
}), oVe = { class: "card shadow-sm" }, iVe = { class: "card-body d-flex align-items-center" }, lVe = { key: 0 }, dVe = { key: 1 }, cVe = { class: "d-flex justify-content-between w-100" };
function uVe(e, t, s, n, r, i) {
  const o = pe("Select");
  return p(), h(A, null, [
    a("div", oVe, [
      a("div", iVe, [
        t[2] || (t[2] = a("span", { class: "fw-bold" }, "Property Instances", -1)),
        N(o, {
          modelValue: e.selectedCity,
          "onUpdate:modelValue": t[0] || (t[0] = (l) => e.selectedCity = l),
          options: e.cities,
          filter: "",
          optionLabel: "name",
          placeholder: "Select an instance",
          class: "ms-auto flex-grow-1 ms-4"
        }, {
          value: ve((l) => [
            l.value ? (p(), h("div", lVe, g(l.value.name), 1)) : (p(), h("span", dVe, g(l.placeholder), 1))
          ]),
          option: ve((l) => [
            a("div", cVe, [
              a("span", null, g(l.option.name), 1),
              t[1] || (t[1] = a("button", {
                type: "button",
                class: "btn btn-link btn-sm text-dark",
                "data-bs-toggle": "modal",
                "data-bs-target": "#dialogEditInstance"
              }, [
                a("i", { class: "fa-duotone fa-solid fa-pencil" })
              ], -1))
            ])
          ]),
          _: 1
        }, 8, ["modelValue", "options"])
      ])
    ]),
    t[3] || (t[3] = Bt('<div class="modal fade" id="dialogEditInstance" tabindex="-1" aria-labelledby="dialogEditInstanceLabel" aria-hidden="true"><div class="modal-dialog modal-dialog-centered modal-sm"><div class="modal-content bg-gradient-alphabet rounded"><div class="modal-header pb-0 border-0"><span class="modal-title fs-5 fw-bold" id="dialogEditInstanceLabel">Edit Instance</span><button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button></div><div class="modal-body"><div><label class="form-label">Name</label><input type="text" class="form-control"></div></div><div class="modal-footer border-0 pt-0"><button type="button" class="btn btn-lava">Rename</button></div></div></div></div>', 1))
  ], 64);
}
const Xls = /* @__PURE__ */ Ae(rVe, [["render", uVe]]), pVe = me({
  name: "HomesProperty",
  emits: [
    "selectProperty",
    "viewProperty",
    "propSelected",
    "deleteProperty"
  ],
  props: {
    property: {
      type: Object,
      required: !0
    },
    index: {
      type: Number
    },
    selected: {
      type: Boolean,
      default: !1
    },
    showButtons: {
      type: Boolean,
      default: !0
    },
    showBadges: {
      type: Boolean,
      default: !0
    },
    googleApi: {
      type: String,
      required: !0
    }
  },
  data() {
    return {
      prop: void 0,
      isSaving: !1
    };
  },
  components: {
    ContentLoader: Sa
  },
  computed: {
    streetView() {
      var e, t, s, n;
      return `https://maps.googleapis.com/maps/api/streetview?return_error_code=true&size=400x248&location=${encodeURIComponent((e = this.prop) == null ? void 0 : e.address)}%20${encodeURIComponent((t = this.prop) == null ? void 0 : t.city)},${encodeURIComponent((s = this.prop) == null ? void 0 : s.state)}%20${encodeURIComponent((n = this.prop) == null ? void 0 : n.postalCode)}&fov=80&key=${this.googleApi}`;
    },
    listingClasses() {
      var e, t, s, n, r, i, o, l;
      return {
        col: !0,
        "listing-tile": !0,
        "listing-blue-chip": ((e = this.prop) == null ? void 0 : e.blueChip) == !0,
        selected: this.selected == !0,
        favorite: ((t = this.prop) == null ? void 0 : t.favorite) == !0,
        pending: ((s = this.prop) == null ? void 0 : s.isPending) == !0,
        active: ((n = this.prop) == null ? void 0 : n.isActive) == !0,
        offmarket: ((r = this.prop) == null ? void 0 : r.isOffmarket) == !0,
        ignored: ((i = this.prop) == null ? void 0 : i.ignore) == !0,
        tenant: ((o = this.prop) == null ? void 0 : o.occupied) == !0,
        preforeclosure: ((l = this.prop) == null ? void 0 : l.hasForeclosure) == !0
      };
    },
    photoStyle() {
      var e;
      return {
        "background-image": (e = this.prop) != null && e.photo ? `url(${this.prop.photo.replace(/\(/gi, "%28").replace(/\)/gi, "%29")}?tr=n-listingthumb1)` : `url(${this.streetView})`
      };
    },
    isNewlyListed() {
      var e, t;
      return ((e = this.prop) == null ? void 0 : e.listDate) && ol((t = this.prop) == null ? void 0 : t.listDate) < 7;
    },
    showChange() {
      var e, t;
      switch ((e = this.prop) == null ? void 0 : e.changeType) {
        case Xh.PriceDecrease:
          if ((t = this.prop) != null && t.changed && ol(this.prop.changed) < 7)
            return !0;
          break;
      }
      return !1;
    },
    changeText() {
      var e;
      switch ((e = this.prop) == null ? void 0 : e.changeType) {
        case Xh.PriceDecrease:
          return "Reduced!";
      }
      return "";
    },
    guarded() {
      var e, t, s;
      return !((e = this.property) != null && e.isActiveMarketplaceListing) && !((s = (t = this.access) == null ? void 0 : t.mls) != null && s.hasEntitlements) && !this.isAdmin && !this.isUser;
    },
    ...q(Te, ["access", "aclLoaded", "isClient", "isAdmin", "isUser"])
  },
  methods: {
    currency: Ze,
    number: Ve,
    percent: Wt,
    shortDate: cs,
    hoursSince: cf,
    timeSince: db,
    dec2(e, t) {
      return (t == null || t == null) && (t = 2), (+e).toFixed(t).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    urlSlug(e) {
      return ci(e, { camelCase: !1 });
    },
    selectProperty() {
      console.log("selectProperty", this.prop), this.$emit("selectProperty", this.prop);
    },
    viewProperty() {
      console.log("viewProperty", this.prop), this.$emit("viewProperty", this.prop);
    },
    propSelected(e) {
      var t, s, n;
      this.$emit("propSelected", {
        id: (t = this.prop) == null ? void 0 : t.propId,
        mlsSource: (s = this.prop) == null ? void 0 : s.mlsSource,
        mlsNumber: (n = this.prop) == null ? void 0 : n.mlsNumber,
        checked: e.target.checked
      });
    },
    async favoriteProperty() {
      try {
        await this.favoriteLock.runExclusive(async () => {
          var t, s;
          if (this.isSaving = !0, !((t = this.prop) != null && t.propId))
            throw new Le("Failed to favorite property.");
          let e;
          if ((s = this.prop) != null && s.favorite ? e = await W.api.folio.removeFavorite(this.prop.propId) : e = await W.api.folio.addFavorite(this.prop.propId), e.data.status != de.Success)
            throw new Le(e);
          this.prop.favorite = !this.prop.favorite, wt(e.data.message);
        });
      } catch (e) {
        Se(e);
      }
      this.isSaving = !1;
    },
    async ignoreProperty() {
      try {
        await this.ignoreLock.runExclusive(async () => {
          var t;
          if (this.isSaving = !0, !((t = this.prop) != null && t.propId))
            throw new Le("Failed to ignore property.");
          let e;
          if (this.prop.ignore ? e = await W.api.folio.removeIgnore(this.prop.propId) : e = await W.api.folio.addIgnore(this.prop.propId), e.data.status != de.Success)
            throw new Le(e);
          this.prop.ignore = !this.prop.ignore, wt(e.data.message);
        });
      } catch (e) {
        Se(e);
      }
      this.isSaving = !1;
    },
    deleteProperty() {
      var e, t, s;
      console.log("deleteProperty", (e = this.prop) == null ? void 0 : e.propId), this.$emit("deleteProperty", (t = this.prop) == null ? void 0 : t.propId, (s = this.prop) == null ? void 0 : s.queryString);
    }
  },
  created() {
    this.favoriteLock = new xa(), this.ignoreLock = new xa(), this.prop = this.property;
  },
  mounted() {
    document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach((e) => new bootstrap.Tooltip(e));
  }
}), hVe = ["href", "id"], mVe = { class: "card h-100" }, fVe = { class: "listing-photo" }, gVe = { class: "overflow-hidden" }, vVe = { class: "position-absolute top-10 start-10 d-flex align-items-start flex-column" }, yVe = {
  key: 0,
  class: "badge rounded-pill text-bg-eclipse"
}, bVe = {
  key: 1,
  class: "badge rounded-pill text-bg-preforeclosure"
}, AVe = {
  key: 2,
  class: "badge rounded-pill text-bg-eclipse banner-edits"
}, wVe = {
  key: 3,
  class: "badge rounded-pill text-bg-success"
}, CVe = {
  key: 0,
  class: "position-absolute top-10 end-10 d-flex align-items-end flex-column"
}, SVe = {
  key: 0,
  class: "badge rounded-pill text-bg-status mb-2"
}, PVe = ["disabled"], kVe = {
  key: 2,
  class: "racetrack list-inline m-0"
}, EVe = { class: "list-inline-item" }, IVe = ["disabled"], TVe = { class: "list-inline-item" }, OVe = ["disabled"], RVe = { class: "listing-description" }, LVe = { class: "listing-photo-pricing" }, BVe = { class: "d-flex justify-content-between align-items-center p-2 listing-list-price" }, MVe = { class: "prop-currency" }, xVe = { key: 0 }, FVe = { class: "fs-5 fw-bold" }, VVe = { key: 1 }, DVe = { class: "fs-5 fw-bold" }, NVe = {
  key: 2,
  class: "flex-column text-start lh-1"
}, jVe = { class: "fs-5 fw-bold" }, HVe = { class: "text-danger fw-bold small" }, UVe = { class: "fw-normal ms-1" }, zVe = { key: 3 }, WVe = { class: "fs-5 fw-bold" }, GVe = { key: 4 }, YVe = { class: "fs-5 fw-bold" }, XVe = { key: 5 }, qVe = { class: "fs-5 fw-bold" }, QVe = {
  key: 0,
  class: "list-inline ms-auto mb-0 text-end prop-badges"
}, KVe = {
  key: 0,
  class: "list-inline-item"
}, ZVe = {
  key: 1,
  class: "list-inline-item"
}, JVe = {
  key: 2,
  class: "list-inline-item"
}, $Ve = {
  key: 3,
  class: "list-inline-item"
}, _Ve = {
  key: 0,
  class: "position-absolute top-0 bottom-0 start-0 end-0 d-flex justify-content-center align-items-center flex-row gap-2 z-10 p-2"
}, eDe = { class: "guard-data d-flex align-items-center justify-content-around" }, tDe = {
  key: 0,
  class: "listing-auction-date"
}, sDe = { class: "d-block fs-5 fw-bold" }, aDe = {
  key: 1,
  class: "listing-opening-bid"
}, nDe = { class: "d-block fs-5 fw-bold" }, rDe = {
  key: 2,
  class: "listing-estimated-equity d-none"
}, oDe = { class: "d-block fs-5 fw-bold" }, iDe = {
  key: 0,
  class: "listing-investment"
}, lDe = { class: "d-block fs-5 fw-bold" }, dDe = {
  key: 1,
  class: "listing-capRate"
}, cDe = { class: "d-block fs-5 fw-bold" }, uDe = {
  key: 2,
  class: "listing-irr"
}, pDe = { class: "d-block fs-5 fw-bold" }, hDe = { class: "listing-footer p-2" }, mDe = { class: "listing-address mb-0 text-truncate" }, fDe = { class: "listing-description_price listing-price" }, gDe = { class: "ps-md-3" }, vDe = {
  key: 0,
  class: "d-block"
}, yDe = { class: "list-inline m-0 text-small listing-features" }, bDe = {
  key: 0,
  class: "list-inline-item"
}, ADe = { class: "list-inline-item" }, wDe = { class: "list-inline-item" }, CDe = {
  key: 1,
  class: "list-inline-item"
}, SDe = {
  key: 2,
  class: "list-inline-item"
}, PDe = { class: "listing-courtesy text-center text-small text-truncate border-top" }, kDe = { key: 0 }, EDe = { key: 1 };
function IDe(e, t, s, n, r, i) {
  var o, l, d, c, u, m, f, v, b, w, S, I, T, x, k, C, O, E, B, M, R, F, L, j, H, te, re, le, ie, ye, Y, ae, ke, ue, oe, fe, we, Ie, be, Oe, ze, Re, ge, he, Me, Ne, $e, mt, yt, Ct, gt, Ge, Ee, Ce, xe, Pe, it, lt, dt, vt, It;
  return p(), h("a", {
    href: e.property.url,
    id: e.property.id,
    onClick: t[4] || (t[4] = mn((...Dt) => e.selectProperty && e.selectProperty(...Dt), ["prevent", "stop"])),
    class: z(e.listingClasses)
  }, [
    a("div", mVe, [
      a("div", fVe, [
        a("div", gVe, [
          a("div", {
            class: "listing-photo_photo",
            style: rn(e.photoStyle)
          }, null, 4)
        ]),
        a("div", vVe, [
          e.showChange ? (p(), h("span", yVe, [
            t[5] || (t[5] = a("i", { class: "fa-light fa-arrow-down-long me-1" }, null, -1)),
            y(g(e.changeText), 1)
          ])) : P("", !0),
          (o = e.prop) != null && o.hasForeclosure ? (p(), h("div", bVe, " Pre-Foreclosure ")) : P("", !0),
          (l = e.prop) != null && l.tweaked ? (p(), h("span", AVe, t[6] || (t[6] = [
            a("i", { class: "fa-light fa-pencil me-1" }, null, -1),
            y("Custom Edits ")
          ]))) : P("", !0),
          e.isNewlyListed ? (p(), h("span", wVe, " NEW " + g(e.timeSince((d = e.prop) == null ? void 0 : d.listDate)) + " Ago ", 1)) : P("", !0)
        ]),
        e.showBadges && ((c = e.prop) != null && c.isActive || (u = e.prop) != null && u.isPending || ((m = e.prop) == null ? void 0 : m.status) == "Incomplete") ? (p(), h("div", CVe, [
          (f = e.prop) != null && f.status ? (p(), h("span", SVe, [
            y(g(e.prop.status) + " ", 1),
            e.prop.status == "Incomplete" ? (p(), h("button", {
              key: 0,
              onClick: t[0] || (t[0] = mn((...Dt) => e.deleteProperty && e.deleteProperty(...Dt), ["stop"])),
              type: "button",
              class: "btn btn-sm btn-delete ms-1 rounded-circle",
              disabled: e.isSaving
            }, t[7] || (t[7] = [
              a("i", { class: "fa-light fa-trash" }, null, -1)
            ]), 8, PVe)) : P("", !0)
          ])) : P("", !0)
        ])) : P("", !0),
        e.showButtons && ((v = e.property) != null && v.isActiveMarketplaceListing) && !e.showButtons ? (p(), h("button", {
          key: 1,
          type: "button",
          onClick: t[1] || (t[1] = (...Dt) => e.viewProperty && e.viewProperty(...Dt)),
          class: "btn btn-eclipse btn-sm viewListingBtn"
        }, "View Property")) : P("", !0),
        e.showButtons ? (p(), h("ul", kVe, [
          a("li", EVe, [
            a("button", {
              type: "button",
              onClick: t[2] || (t[2] = mn((...Dt) => e.favoriteProperty && e.favoriteProperty(...Dt), ["stop"])),
              class: "mlse-save btn btn-sm rounded-circle",
              "data-bs-toggle": "tooltip",
              title: "Favorite/Unfavorite listing",
              disabled: e.isSaving
            }, [
              a("i", {
                class: z(["fa-heart", { "fa-light": !((b = e.prop) != null && b.favorite), "fa-solid": (w = e.prop) == null ? void 0 : w.favorite }])
              }, null, 2)
            ], 8, IVe)
          ]),
          a("li", TVe, [
            a("button", {
              type: "button",
              onClick: t[3] || (t[3] = mn((...Dt) => e.ignoreProperty && e.ignoreProperty(...Dt), ["stop"])),
              class: z(["mls-ignore btn btn-sm btn-light rounded-circle", { rejected: (S = e.prop) == null ? void 0 : S.ignore }]),
              "data-bs-toggle": "tooltip",
              title: "Ignore Property",
              disabled: e.isSaving
            }, [
              a("i", {
                class: z(["fa-thumbs-down", { "fa-light": !((I = e.prop) != null && I.ignore), "fa-solid": (T = e.prop) == null ? void 0 : T.ignore }])
              }, null, 2)
            ], 10, OVe)
          ])
        ])) : P("", !0)
      ]),
      a("div", RVe, [
        a("div", LVe, [
          a("div", BVe, [
            a("div", MVe, [
              (x = e.prop) != null && x.isOffmarket && !((k = e.prop) != null && k.purchasePrice) ? (p(), h("span", xVe, [
                a("b", FVe, g(e.currency((C = e.prop) == null ? void 0 : C.propertyValue)), 1)
              ])) : (O = e.prop) != null && O.isOffmarket && ((E = e.prop) != null && E.purchasePrice) ? (p(), h("span", VVe, [
                a("b", DVe, g(e.currency((B = e.prop) == null ? void 0 : B.purchasePrice)), 1)
              ])) : !((M = e.prop) != null && M.isOffmarket) && !((R = e.prop) != null && R.isRental) && (((F = e.prop) == null ? void 0 : F.listPrice) ?? 0) > 0 && ((L = e.prop) != null && L.changeAmount) && e.showChange ? (p(), h("div", NVe, [
                a("b", jVe, g(e.currency(e.prop.listPrice)), 1),
                a("div", HVe, [
                  y(g(e.currency(e.prop.changeAmount)) + " ", 1),
                  a("small", UVe, [
                    t[8] || (t[8] = a("i", { class: "fa-light fa-arrow-down-long me-1" }, null, -1)),
                    y(" " + g(e.timeSince(e.prop.changed)), 1)
                  ])
                ])
              ])) : !((j = e.prop) != null && j.isOffmarket) && !((H = e.prop) != null && H.isRental) && (((te = e.prop) == null ? void 0 : te.listPrice) ?? 0) > 0 ? (p(), h("span", zVe, [
                a("b", WVe, g(e.currency((re = e.prop) == null ? void 0 : re.listPrice)), 1)
              ])) : !((le = e.prop) != null && le.isOffmarket) && ((ie = e.prop) != null && ie.isRental) && ((ye = e.prop) != null && ye.purchasePrice) ? (p(), h("span", GVe, [
                a("b", YVe, g(e.currency(e.prop.purchasePrice)), 1)
              ])) : !((Y = e.prop) != null && Y.isOffmarket) && ((ae = e.prop) != null && ae.isRental) && !((ke = e.prop) != null && ke.purchasePrice) ? (p(), h("span", XVe, [
                a("b", qVe, g(e.currency(e.prop.propertyValue)), 1)
              ])) : P("", !0)
            ]),
            (ue = e.prop) != null && ue.isFeatured || (oe = e.prop) != null && oe.blueChip || (fe = e.prop) != null && fe.hasValueAdded || (we = e.prop) != null && we.occupied ? (p(), h("ul", QVe, [
              e.prop.isFeatured ? (p(), h("li", KVe, t[9] || (t[9] = [
                a("span", { class: "badge rounded-pill text-bg-featured" }, "Featured", -1)
              ]))) : P("", !0),
              e.prop.blueChip ? (p(), h("li", ZVe, t[10] || (t[10] = [
                a("span", { class: "badge rounded-pill text-bg-bluechip" }, "Blue Chip", -1)
              ]))) : P("", !0),
              e.prop.hasValueAdded ? (p(), h("li", JVe, t[11] || (t[11] = [
                a("span", { class: "badge rounded-pill text-bg-valueadd" }, "Value-Add", -1)
              ]))) : P("", !0),
              e.prop.occupied ? (p(), h("li", $Ve, t[12] || (t[12] = [
                a("span", { class: "badge rounded-pill text-bg-tenantoccupied" }, "Tenant Occupied", -1)
              ]))) : P("", !0)
            ])) : P("", !0)
          ])
        ]),
        a("div", {
          class: z(["listing-stats quickStats p-2 bg-alice", { "guard-wrapper": e.guarded }])
        }, [
          e.guarded ? (p(), h("div", _Ve, t[13] || (t[13] = [
            a("span", { class: "fa-stack" }, [
              a("i", { class: "fa-solid fa-circle fa-stack-2x text-eclipse" }),
              a("i", { class: "fa-solid fa-user-plus fa-stack-1x fa-inverse" })
            ], -1),
            a("small", null, "Subscribe to view Investment Metrics", -1)
          ]))) : P("", !0),
          a("div", eDe, [
            (Ie = e.prop) != null && Ie.isForeclosure ? (p(), h(A, { key: 0 }, [
              (be = e.prop) != null && be.auctionDate ? (p(), h("div", tDe, [
                t[14] || (t[14] = a("span", { class: "stats-label text-secondary text-opacity-50" }, "Auction Date", -1)),
                a("span", sDe, g(e.shortDate(e.prop.auctionDate)), 1)
              ])) : P("", !0),
              (Oe = e.prop) != null && Oe.openingBid ? (p(), h("div", aDe, [
                t[15] || (t[15] = a("span", { class: "stats-label text-secondary text-opacity-50" }, "Opening Bid", -1)),
                a("span", nDe, g(e.currency(e.prop.openingBid)), 1)
              ])) : P("", !0),
              (ze = e.prop) != null && ze.estimatedEquity ? (p(), h("div", rDe, [
                t[16] || (t[16] = a("span", { class: "stats-label text-secondary text-opacity-50" }, "Estimated Equity", -1)),
                a("span", oDe, g(e.currency(e.prop.estimatedEquity)), 1)
              ])) : P("", !0)
            ], 64)) : (p(), h(A, { key: 1 }, [
              (Re = e.prop) != null && Re.initialInvestment ? (p(), h("div", iDe, [
                t[17] || (t[17] = a("span", { class: "stats-label text-secondary text-opacity-50" }, "Investment", -1)),
                a("span", lDe, g(e.currency(e.prop.initialInvestment)), 1)
              ])) : P("", !0),
              (((ge = e.prop) == null ? void 0 : ge.capRate) ?? 0) > 0 ? (p(), h("div", dDe, [
                t[18] || (t[18] = a("span", { class: "stats-label text-secondary text-opacity-50" }, "Cap Rate", -1)),
                a("span", cDe, g(e.percent((he = e.prop) == null ? void 0 : he.capRate, 1)), 1)
              ])) : P("", !0),
              (((Me = e.prop) == null ? void 0 : Me.irr) ?? 0) > 0 ? (p(), h("div", uDe, [
                t[19] || (t[19] = a("span", { class: "stats-label text-secondary text-opacity-50" }, "IRR:", -1)),
                a("span", pDe, g(e.percent((Ne = e.prop) == null ? void 0 : Ne.irr, 1)), 1)
              ])) : P("", !0)
            ], 64))
          ])
        ], 2),
        a("div", hDe, [
          a("p", mDe, [
            y(g(($e = e.prop) == null ? void 0 : $e.address) + " ", 1),
            a("span", null, g((mt = e.prop) == null ? void 0 : mt.city) + ", " + g((yt = e.prop) == null ? void 0 : yt.state) + "  " + g((Ct = e.prop) == null ? void 0 : Ct.postalCode), 1)
          ]),
          a("div", fDe, [
            a("span", null, [
              t[20] || (t[20] = y(" List price: ")),
              a("b", null, g(e.currency((gt = e.prop) == null ? void 0 : gt.listPrice)), 1)
            ]),
            a("span", gDe, [
              t[21] || (t[21] = y(" IRR: ")),
              a("b", null, g(e.percent((Ge = e.prop) == null ? void 0 : Ge.irr, 1)), 1)
            ]),
            (Ee = e.prop) != null && Ee.isPending ? (p(), h("span", vDe, [
              t[22] || (t[22] = y(" Date Modified: ")),
              a("b", null, g(e.shortDate(e.prop.mlsModified)), 1)
            ])) : P("", !0)
          ]),
          a("ul", yDe, [
            (Ce = e.prop) != null && Ce.sqFt ? (p(), h("li", bDe, [
              t[23] || (t[23] = a("i", { class: "fa-light fa-home me-1" }, null, -1)),
              y(" " + g(e.number(e.prop.sqFt, 0)) + " SF ", 1)
            ])) : P("", !0),
            a("li", ADe, [
              t[24] || (t[24] = a("i", { class: "fa-light fa-bed me-1" }, null, -1)),
              y(" " + g((xe = e.prop) == null ? void 0 : xe.bedrooms) + " ", 1),
              t[25] || (t[25] = a("span", { class: "visually-hidden" }, "Beds", -1))
            ]),
            a("li", wDe, [
              t[26] || (t[26] = a("i", { class: "fa-light fa-bath me-1" }, null, -1)),
              y(" " + g((Pe = e.prop) == null ? void 0 : Pe.bathrooms) + " ", 1),
              t[27] || (t[27] = a("span", { class: "visually-hidden" }, "Baths", -1))
            ]),
            (((it = e.prop) == null ? void 0 : it.yearBuilt) ?? 0) > 0 ? (p(), h("li", CDe, [
              t[28] || (t[28] = a("i", { class: "fa-light fa-birthday-cake me-1" }, null, -1)),
              y(" " + g((lt = e.prop) == null ? void 0 : lt.yearBuilt), 1)
            ])) : P("", !0),
            !((dt = e.prop) != null && dt.isOffmarket) && ((vt = e.prop) != null && vt.dom) ? (p(), h("li", SDe, [
              t[29] || (t[29] = a("i", { class: "fa-light fa-calendar-alt me-1" }, null, -1)),
              y(" " + g(e.number(e.prop.dom)) + " DoM ", 1)
            ])) : P("", !0)
          ])
        ]),
        a("div", PDe, [
          (It = e.prop) != null && It.courtesyOf ? (p(), h("span", kDe, "Listed by " + g(e.prop.courtesyOf), 1)) : (p(), h("span", EDe, " "))
        ])
      ])
    ])
  ], 10, hVe);
}
const qls = /* @__PURE__ */ Ae(pVe, [["render", IDe]]);
function TDe(e, t) {
  var s = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (!s) {
    if (Array.isArray(e) || (s = Sb(e)) || t) {
      s && (e = s);
      var n = 0, r = function() {
      };
      return { s: r, n: function() {
        return n >= e.length ? { done: !0 } : { done: !1, value: e[n++] };
      }, e: function(c) {
        throw c;
      }, f: r };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var i, o = !0, l = !1;
  return { s: function() {
    s = s.call(e);
  }, n: function() {
    var c = s.next();
    return o = c.done, c;
  }, e: function(c) {
    l = !0, i = c;
  }, f: function() {
    try {
      o || s.return == null || s.return();
    } finally {
      if (l) throw i;
    }
  } };
}
function fy(e) {
  var t = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
  return fy = function(n) {
    if (n === null || !RDe(n)) return n;
    if (typeof n != "function") throw new TypeError("Super expression must either be null or a function");
    if (t !== void 0) {
      if (t.has(n)) return t.get(n);
      t.set(n, r);
    }
    function r() {
      return ODe(n, arguments, Au(this).constructor);
    }
    return r.prototype = Object.create(n.prototype, { constructor: { value: r, enumerable: !1, writable: !0, configurable: !0 } }), wu(r, n);
  }, fy(e);
}
function ODe(e, t, s) {
  if (Pb()) return Reflect.construct.apply(null, arguments);
  var n = [null];
  n.push.apply(n, t);
  var r = new (e.bind.apply(e, n))();
  return s && wu(r, s.prototype), r;
}
function RDe(e) {
  try {
    return Function.toString.call(e).indexOf("[native code]") !== -1;
  } catch {
    return typeof e == "function";
  }
}
function dl(e, t) {
  return MDe(e) || BDe(e, t) || Sb(e, t) || LDe();
}
function LDe() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function BDe(e, t) {
  var s = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (s != null) {
    var n, r, i, o, l = [], d = !0, c = !1;
    try {
      if (i = (s = s.call(e)).next, t === 0) {
        if (Object(s) !== s) return;
        d = !1;
      } else for (; !(d = (n = i.call(s)).done) && (l.push(n.value), l.length !== t); d = !0) ;
    } catch (u) {
      c = !0, r = u;
    } finally {
      try {
        if (!d && s.return != null && (o = s.return(), Object(o) !== o)) return;
      } finally {
        if (c) throw r;
      }
    }
    return l;
  }
}
function MDe(e) {
  if (Array.isArray(e)) return e;
}
function Qu(e) {
  return VDe(e) || FDe(e) || Sb(e) || xDe();
}
function xDe() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Sb(e, t) {
  if (e) {
    if (typeof e == "string") return gy(e, t);
    var s = {}.toString.call(e).slice(8, -1);
    return s === "Object" && e.constructor && (s = e.constructor.name), s === "Map" || s === "Set" ? Array.from(e) : s === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(s) ? gy(e, t) : void 0;
  }
}
function FDe(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function VDe(e) {
  if (Array.isArray(e)) return gy(e);
}
function gy(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var s = 0, n = Array(t); s < t; s++) n[s] = e[s];
  return n;
}
function jt(e, t, s) {
  return t = Au(t), DDe(e, Pb() ? Reflect.construct(t, s || [], Au(e).constructor) : t.apply(e, s));
}
function DDe(e, t) {
  if (t && (St(t) == "object" || typeof t == "function")) return t;
  if (t !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
  return Vd(e);
}
function Vd(e) {
  if (e === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Pb() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (Pb = function() {
    return !!e;
  })();
}
function Au(e) {
  return Au = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, Au(e);
}
function Ht(e, t) {
  if (typeof t != "function" && t !== null) throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && wu(e, t);
}
function wu(e, t) {
  return wu = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(s, n) {
    return s.__proto__ = n, s;
  }, wu(e, t);
}
function ce() {
  ce = function() {
    return t;
  };
  var e, t = {}, s = Object.prototype, n = s.hasOwnProperty, r = typeof Symbol == "function" ? Symbol : {}, i = r.iterator || "@@iterator", o = r.asyncIterator || "@@asyncIterator", l = r.toStringTag || "@@toStringTag";
  function d(R, F, L, j) {
    return Object.defineProperty(R, F, { value: L, enumerable: !j, configurable: !j, writable: !j });
  }
  try {
    d({}, "");
  } catch {
    d = function(L, j, H) {
      return L[j] = H;
    };
  }
  function c(R, F, L, j) {
    var H = F && F.prototype instanceof f ? F : f, te = Object.create(H.prototype);
    return d(te, "_invoke", /* @__PURE__ */ function(re, le, ie) {
      var ye = 1;
      return function(Y, ae) {
        if (ye === 3) throw Error("Generator is already running");
        if (ye === 4) {
          if (Y === "throw") throw ae;
          return { value: e, done: !0 };
        }
        for (ie.method = Y, ie.arg = ae; ; ) {
          var ke = ie.delegate;
          if (ke) {
            var ue = C(ke, ie);
            if (ue) {
              if (ue === m) continue;
              return ue;
            }
          }
          if (ie.method === "next") ie.sent = ie._sent = ie.arg;
          else if (ie.method === "throw") {
            if (ye === 1) throw ye = 4, ie.arg;
            ie.dispatchException(ie.arg);
          } else ie.method === "return" && ie.abrupt("return", ie.arg);
          ye = 3;
          var oe = u(re, le, ie);
          if (oe.type === "normal") {
            if (ye = ie.done ? 4 : 2, oe.arg === m) continue;
            return { value: oe.arg, done: ie.done };
          }
          oe.type === "throw" && (ye = 4, ie.method = "throw", ie.arg = oe.arg);
        }
      };
    }(R, L, new B(j || [])), !0), te;
  }
  function u(R, F, L) {
    try {
      return { type: "normal", arg: R.call(F, L) };
    } catch (j) {
      return { type: "throw", arg: j };
    }
  }
  t.wrap = c;
  var m = {};
  function f() {
  }
  function v() {
  }
  function b() {
  }
  var w = {};
  d(w, i, function() {
    return this;
  });
  var S = Object.getPrototypeOf, I = S && S(S(M([])));
  I && I !== s && n.call(I, i) && (w = I);
  var T = b.prototype = f.prototype = Object.create(w);
  function x(R) {
    ["next", "throw", "return"].forEach(function(F) {
      d(R, F, function(L) {
        return this._invoke(F, L);
      });
    });
  }
  function k(R, F) {
    function L(H, te, re, le) {
      var ie = u(R[H], R, te);
      if (ie.type !== "throw") {
        var ye = ie.arg, Y = ye.value;
        return Y && St(Y) == "object" && n.call(Y, "__await") ? F.resolve(Y.__await).then(function(ae) {
          L("next", ae, re, le);
        }, function(ae) {
          L("throw", ae, re, le);
        }) : F.resolve(Y).then(function(ae) {
          ye.value = ae, re(ye);
        }, function(ae) {
          return L("throw", ae, re, le);
        });
      }
      le(ie.arg);
    }
    var j;
    d(this, "_invoke", function(H, te) {
      function re() {
        return new F(function(le, ie) {
          L(H, te, le, ie);
        });
      }
      return j = j ? j.then(re, re) : re();
    }, !0);
  }
  function C(R, F) {
    var L = F.method, j = R.i[L];
    if (j === e) return F.delegate = null, L === "throw" && R.i.return && (F.method = "return", F.arg = e, C(R, F), F.method === "throw") || L !== "return" && (F.method = "throw", F.arg = new TypeError("The iterator does not provide a '" + L + "' method")), m;
    var H = u(j, R.i, F.arg);
    if (H.type === "throw") return F.method = "throw", F.arg = H.arg, F.delegate = null, m;
    var te = H.arg;
    return te ? te.done ? (F[R.r] = te.value, F.next = R.n, F.method !== "return" && (F.method = "next", F.arg = e), F.delegate = null, m) : te : (F.method = "throw", F.arg = new TypeError("iterator result is not an object"), F.delegate = null, m);
  }
  function O(R) {
    this.tryEntries.push(R);
  }
  function E(R) {
    var F = R[4] || {};
    F.type = "normal", F.arg = e, R[4] = F;
  }
  function B(R) {
    this.tryEntries = [[-1]], R.forEach(O, this), this.reset(!0);
  }
  function M(R) {
    if (R != null) {
      var F = R[i];
      if (F) return F.call(R);
      if (typeof R.next == "function") return R;
      if (!isNaN(R.length)) {
        var L = -1, j = function H() {
          for (; ++L < R.length; ) if (n.call(R, L)) return H.value = R[L], H.done = !1, H;
          return H.value = e, H.done = !0, H;
        };
        return j.next = j;
      }
    }
    throw new TypeError(St(R) + " is not iterable");
  }
  return v.prototype = b, d(T, "constructor", b), d(b, "constructor", v), v.displayName = d(b, l, "GeneratorFunction"), t.isGeneratorFunction = function(R) {
    var F = typeof R == "function" && R.constructor;
    return !!F && (F === v || (F.displayName || F.name) === "GeneratorFunction");
  }, t.mark = function(R) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(R, b) : (R.__proto__ = b, d(R, l, "GeneratorFunction")), R.prototype = Object.create(T), R;
  }, t.awrap = function(R) {
    return { __await: R };
  }, x(k.prototype), d(k.prototype, o, function() {
    return this;
  }), t.AsyncIterator = k, t.async = function(R, F, L, j, H) {
    H === void 0 && (H = Promise);
    var te = new k(c(R, F, L, j), H);
    return t.isGeneratorFunction(F) ? te : te.next().then(function(re) {
      return re.done ? re.value : te.next();
    });
  }, x(T), d(T, l, "Generator"), d(T, i, function() {
    return this;
  }), d(T, "toString", function() {
    return "[object Generator]";
  }), t.keys = function(R) {
    var F = Object(R), L = [];
    for (var j in F) L.unshift(j);
    return function H() {
      for (; L.length; ) if ((j = L.pop()) in F) return H.value = j, H.done = !1, H;
      return H.done = !0, H;
    };
  }, t.values = M, B.prototype = { constructor: B, reset: function(F) {
    if (this.prev = this.next = 0, this.sent = this._sent = e, this.done = !1, this.delegate = null, this.method = "next", this.arg = e, this.tryEntries.forEach(E), !F) for (var L in this) L.charAt(0) === "t" && n.call(this, L) && !isNaN(+L.slice(1)) && (this[L] = e);
  }, stop: function() {
    this.done = !0;
    var F = this.tryEntries[0][4];
    if (F.type === "throw") throw F.arg;
    return this.rval;
  }, dispatchException: function(F) {
    if (this.done) throw F;
    var L = this;
    function j(Y) {
      re.type = "throw", re.arg = F, L.next = Y;
    }
    for (var H = L.tryEntries.length - 1; H >= 0; --H) {
      var te = this.tryEntries[H], re = te[4], le = this.prev, ie = te[1], ye = te[2];
      if (te[0] === -1) return j("end"), !1;
      if (!ie && !ye) throw Error("try statement without catch or finally");
      if (te[0] != null && te[0] <= le) {
        if (le < ie) return this.method = "next", this.arg = e, j(ie), !0;
        if (le < ye) return j(ye), !1;
      }
    }
  }, abrupt: function(F, L) {
    for (var j = this.tryEntries.length - 1; j >= 0; --j) {
      var H = this.tryEntries[j];
      if (H[0] > -1 && H[0] <= this.prev && this.prev < H[2]) {
        var te = H;
        break;
      }
    }
    te && (F === "break" || F === "continue") && te[0] <= L && L <= te[2] && (te = null);
    var re = te ? te[4] : {};
    return re.type = F, re.arg = L, te ? (this.method = "next", this.next = te[2], m) : this.complete(re);
  }, complete: function(F, L) {
    if (F.type === "throw") throw F.arg;
    return F.type === "break" || F.type === "continue" ? this.next = F.arg : F.type === "return" ? (this.rval = this.arg = F.arg, this.method = "return", this.next = "end") : F.type === "normal" && L && (this.next = L), m;
  }, finish: function(F) {
    for (var L = this.tryEntries.length - 1; L >= 0; --L) {
      var j = this.tryEntries[L];
      if (j[2] === F) return this.complete(j[4], j[3]), E(j), m;
    }
  }, catch: function(F) {
    for (var L = this.tryEntries.length - 1; L >= 0; --L) {
      var j = this.tryEntries[L];
      if (j[0] === F) {
        var H = j[4];
        if (H.type === "throw") {
          var te = H.arg;
          E(j);
        }
        return te;
      }
    }
    throw Error("illegal catch attempt");
  }, delegateYield: function(F, L, j) {
    return this.delegate = { i: M(F), r: L, n: j }, this.method === "next" && (this.arg = e), m;
  } }, t;
}
function U2(e, t, s, n, r, i, o) {
  try {
    var l = e[i](o), d = l.value;
  } catch (c) {
    return void s(c);
  }
  l.done ? t(d) : Promise.resolve(d).then(n, r);
}
function Qe(e) {
  return function() {
    var t = this, s = arguments;
    return new Promise(function(n, r) {
      var i = e.apply(t, s);
      function o(d) {
        U2(i, n, r, o, l, "next", d);
      }
      function l(d) {
        U2(i, n, r, o, l, "throw", d);
      }
      o(void 0);
    });
  };
}
function z2(e, t) {
  var s = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), s.push.apply(s, n);
  }
  return s;
}
function ys(e) {
  for (var t = 1; t < arguments.length; t++) {
    var s = arguments[t] != null ? arguments[t] : {};
    t % 2 ? z2(Object(s), !0).forEach(function(n) {
      wm(e, n, s[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(s)) : z2(Object(s)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(s, n));
    });
  }
  return e;
}
function wm(e, t, s) {
  return (t = _k(t)) in e ? Object.defineProperty(e, t, { value: s, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = s, e;
}
function St(e) {
  "@babel/helpers - typeof";
  return St = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, St(e);
}
function je(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function W2(e, t) {
  for (var s = 0; s < t.length; s++) {
    var n = t[s];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, _k(n.key), n);
  }
}
function He(e, t, s) {
  return t && W2(e.prototype, t), s && W2(e, s), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function _k(e) {
  var t = NDe(e, "string");
  return St(t) == "symbol" ? t : t + "";
}
function NDe(e, t) {
  if (St(e) != "object" || !e) return e;
  var s = e[Symbol.toPrimitive];
  if (s !== void 0) {
    var n = s.call(e, t);
    if (St(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var jDe = /* @__PURE__ */ function() {
  function e() {
    je(this, e);
  }
  return He(e, null, [{
    key: "render",
    value: function(s, n) {
      var r = document.createElement("div");
      r.id = "error-view", r.innerText = n, s.replaceChildren(r);
    }
  }]);
}(), HDe = /* @__PURE__ */ function() {
  function e() {
    je(this, e);
  }
  return He(e, null, [{
    key: "onLoad",
    value: function(s) {
      s.innerHTML = '<div id="loading-validate-key-property"></div>';
    }
  }, {
    key: "createElements",
    value: function() {
      var s = document.createElement("div");
      return s.id = "validate-property-key-view", s;
    }
  }, {
    key: "render",
    value: function(s, n, r) {
      var i = e.createElements(), o = {
        onSuccess: n,
        onFail: jDe.render.bind(this, s, "Your 'key' has failed authentication"),
        onLoad: e.onLoad.bind(this, i)
      };
      r.key && r.verifyKey(r.key, o), s.replaceChildren(i);
    }
  }]);
}(), za = /* @__PURE__ */ function() {
  function e() {
    je(this, e);
  }
  return He(e, null, [{
    key: "unsetStyle",
    value: function(s, n) {
      var r = Object.keys(n).reduce(function(i, o) {
        return i[o] = "", i;
      }, {});
      Object.assign(s.style, r);
    }
  }, {
    key: "unsetActivityCSSMouseStates",
    value: function(s, n) {
      n.click && e.unsetStyle(s, n.click), n.hover && e.unsetStyle(s, n.hover);
    }
  }, {
    key: "unsetAllCSSMouseStates",
    value: function(s, n) {
      e.unsetActivityCSSMouseStates(s, n), n.default && e.unsetStyle(s, n.default);
    }
    // if you want to asdd default styling - use pure css classes
  }, {
    key: "processStateful",
    value: function(s) {
      var n = s.default || {}, r = Object.assign(JSON.parse(JSON.stringify(n)), s == null ? void 0 : s.hover), i = Object.assign(JSON.parse(JSON.stringify(r)), s == null ? void 0 : s.click);
      return {
        default: n,
        hover: r,
        click: i
      };
    }
  }, {
    key: "mergeStatefulStyles",
    value: function(s) {
      var n = {
        default: {},
        hover: {},
        click: {}
      };
      return s.forEach(function(r) {
        n.default = Object.assign(n.default, r.default), n.hover = Object.assign(n.hover, r.hover), n.click = Object.assign(n.click, r.click);
      }), n;
    }
  }, {
    key: "overwriteDefaultWithAlreadyApplied",
    value: function(s, n) {
      Object.keys(s.default || []).forEach(function(r) {
        var i, o = r;
        n.style[o] && (i = s.default) != null && i[o] && (s.default[r] = n.style[o]);
      });
    }
  }, {
    key: "applyToStyleIfNotDefined",
    value: function(s, n) {
      for (var r in n) {
        var i = n[r];
        s[r] === "" && i && (s[r] = i);
      }
    }
  }]);
}(), vy = /* @__PURE__ */ function() {
  function e() {
    je(this, e);
  }
  return He(e, null, [{
    key: "attemptAppendStyleSheetToHead",
    value: function(s) {
      if (!(s.fontFamily && s.fontFamily !== e.DEFAULT_FONT_FAMILY)) {
        var n = document.getElementsByTagName("head")[0];
        if (!Array.from(n.getElementsByTagName("link")).some(function(i) {
          return i.getAttribute("href") === e.FONT_URL;
        })) {
          var r = document.createElement("link");
          r.rel = "stylesheet", r.href = e.FONT_URL, n.appendChild(r);
        }
      }
    }
  }]);
}();
vy.FONT_URL = "https://fonts.googleapis.com/css2?family=Inter:wght@400;600&display=swap", vy.DEFAULT_FONT_FAMILY = "'Inter', sans-serif, Avenir, Helvetica, Arial";
var e5 = vy, t5 = /* @__PURE__ */ function() {
  function e() {
    je(this, e);
  }
  return He(e, null, [{
    key: "apply",
    value: function(s, n) {
      if (n) try {
        e.applyStyleSheet(s, n);
      } catch {
        e.addStyleElement(s, n);
      }
    }
  }, {
    key: "applyStyleSheet",
    value: function(s, n) {
      var r = new CSSStyleSheet();
      r.replaceSync(s), n.adoptedStyleSheets.push(r);
    }
  }, {
    key: "addStyleElement",
    value: function(s, n) {
      var r = document.createElement("style");
      r.innerHTML = s, n.appendChild(r);
    }
  }, {
    key: "applyDefaultStyleToComponent",
    value: function(s, n) {
      n && za.applyToStyleIfNotDefined(s, n), za.applyToStyleIfNotDefined(s, e.DEFAULT_COMPONENT_STYLE);
    }
  }]);
}();
t5.DEFAULT_COMPONENT_STYLE = {
  height: "350px",
  width: "320px",
  borderTop: "1px solid #cacaca",
  borderRight: "1px solid #cacaca",
  borderLeft: "1px solid #cacaca",
  borderBottom: "1px solid #cacaca",
  fontFamily: e5.DEFAULT_FONT_FAMILY,
  fontSize: "0.9rem",
  backgroundColor: "white",
  position: "relative",
  // this is used to prevent inputAreaStyle background color from going beyond the container's rounded border
  // it will cause issues if there are elements that are meant to be outside of the chat component and in
  // that instance they should overwrite this
  // this is also causing the chat to squeeze when there is no space
  overflow: "hidden"
};
var Fg = t5, s5 = /* @__PURE__ */ function() {
  function e() {
    je(this, e);
  }
  return He(e, null, [{
    key: "buildElement",
    value: function() {
      var s = document.createElement("div");
      s.classList.add("tooltip");
      var n = document.createElement("span");
      return n.classList.add("tooltip-text"), s.appendChild(n), s;
    }
  }, {
    key: "tryCreateConfig",
    value: function(s, n) {
      if (n) return typeof n == "boolean" ? {
        text: s
      } : {
        text: n.text || s,
        timeout: n.timeout || 0,
        style: n.style
      };
    }
  }, {
    key: "traverseParentUntilContainer",
    value: function(s) {
      for (var n = s; n.parentElement; ) n = n.parentElement;
      return n;
    }
  }, {
    key: "setPosition",
    value: function(s, n) {
      var r = n.getRootNode().host.getBoundingClientRect(), i = s.getBoundingClientRect(), o = n.getBoundingClientRect().width / 2, l = i.left + i.width / 2;
      n.style.left = "".concat(l - o - r.left, "px"), n.style.top = "".concat(i.top - 36 - r.top, "px");
      var d = n.getBoundingClientRect();
      d.left < r.left ? n.style.left = "".concat(e.OVERFLOW_NEW_POSITION_PX, "px") : d.right > r.right && (n.style.left = "".concat(r.width - d.width - e.OVERFLOW_NEW_POSITION_PX, "px"));
    }
  }, {
    key: "display",
    value: function(s, n, r) {
      return r || (r = e.traverseParentUntilContainer(s).nextSibling), n.text && (r.children[0].textContent = n.text), {
        timeout: setTimeout(function() {
          r.style.visibility = "visible", e.setPosition(s, r), n.style && Object.assign(r.style, n.style);
        }, n.timeout || 0),
        element: r
      };
    }
  }, {
    key: "hide",
    value: function(s, n) {
      clearTimeout(s.timeout), s.element.style.visibility = "hidden", n.style && za.unsetStyle(s.element, n.style), s.element.style.left = "", s.element.style.top = "";
    }
  }]);
}();
s5.OVERFLOW_NEW_POSITION_PX = 4;
var Ho = s5, kh = /* @__PURE__ */ He(function e() {
  je(this, e);
});
kh.IS_SAFARI = /^((?!chrome|android).)*safari/i.test(navigator.userAgent), kh.IS_CHROMIUM = window.chrome, kh.IS_MOBILE = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
var el = kh, qa = /* @__PURE__ */ function(e) {
  return e.ESCAPE = "Escape", e.ENTER = "Enter", e.TAB = "Tab", e.ARROW_UP = "ArrowUp", e.ARROW_DOWN = "ArrowDown", e.ARROW_RIGHT = "ArrowRight", e.ARROW_LEFT = "ArrowLeft", e.BACKSPACE = "Backspace", e.DELETE = "Delete", e.META = "Meta", e.CONTROL = "Control", e;
}(qa || {}), a5 = /* @__PURE__ */ function() {
  function e() {
    je(this, e);
  }
  return He(e, null, [{
    key: "add",
    value: (
      // prettier-ignore
      function(s, n, r, i) {
        r !== void 0 && s.addEventListener("keydown", e.onKeyDown.bind(this, r)), s.oninput = e.onInput.bind(this, r, i), s.addEventListener("paste", function(o) {
          var l;
          o.preventDefault(), (l = o.clipboardData) != null && l.files.length && n.addFilesToAnyType(Array.from(o.clipboardData.files));
        });
      }
    )
    // preventing insertion early for a nicer UX
    // prettier-ignore
  }, {
    key: "onKeyDown",
    value: function(s, n) {
      var r = n.target.textContent;
      r && r.length >= s && !e.PERMITTED_KEYS.has(n.key) && !e.isKeyCombinationPermitted(n) && n.preventDefault();
    }
  }, {
    key: "isKeyCombinationPermitted",
    value: function(s) {
      return s.key === "a" ? s.ctrlKey || s.metaKey : !1;
    }
  }, {
    key: "onInput",
    value: function(s, n, r) {
      var i = r.target, o = i.textContent || "";
      s !== void 0 && o.length > s && (i.textContent = o.substring(0, s), kb.focusEndOfInput(i)), n == null || n();
    }
  }]);
}();
a5.PERMITTED_KEYS = /* @__PURE__ */ new Set([qa.BACKSPACE, qa.DELETE, qa.ARROW_RIGHT, qa.ARROW_LEFT, qa.ARROW_DOWN, qa.ARROW_UP, qa.META, qa.CONTROL, qa.ENTER]);
var UDe = a5, zDe = /* @__PURE__ */ function() {
  function e() {
    je(this, e);
  }
  return He(e, null, [{
    key: "sanitizePastedTextContent",
    value: function(s) {
      var n, r;
      s.preventDefault();
      var i = (n = s.clipboardData) == null ? void 0 : n.getData("text/plain");
      i && ((r = document.execCommand) == null || r.call(document, "insertText", !1, i));
    }
  }]);
}(), n5 = /* @__PURE__ */ function() {
  function e(t, s, n) {
    var r = this;
    je(this, e);
    var i, o;
    this._isComposing = !1;
    var l = e.processConfig(s, t.textInput);
    this.elementRef = e.createContainerElement((i = l == null ? void 0 : l.styles) == null ? void 0 : i.container), this._config = l, this.inputElementRef = this.createInputElement(), this.elementRef.appendChild(this.inputElementRef), t.setPlaceholderText = this.setPlaceholderText.bind(this), t.setPlaceholderText(((o = this._config.placeholder) == null ? void 0 : o.text) || "Ask me anything!"), setTimeout(function() {
      UDe.add(r.inputElementRef, n, r._config.characterLimit, t._validationHandler), r._onInput = s.onInput;
    });
  }
  return He(e, [{
    key: "clear",
    value: (
      // this also similarly prevents scroll up
      function() {
        var s, n, r = window.scrollY;
        this.inputElementRef.classList.contains("text-input-disabled") || (Object.assign(this.inputElementRef.style, (s = this._config.placeholder) == null ? void 0 : s.style), this.inputElementRef.textContent = "", kb.focusEndOfInput(this.inputElementRef), (n = this._onInput) == null || n.call(this, !1)), el.IS_CHROMIUM && window.scrollTo({
          top: r
        });
      }
    )
  }, {
    key: "createInputElement",
    value: function() {
      var s, n, r, i, o = document.createElement("div");
      return o.id = e.TEXT_INPUT_ID, o.classList.add("text-input-styling"), o.role = "textbox", el.IS_CHROMIUM && e.preventAutomaticScrollUpOnNewLine(o), typeof this._config.disabled == "boolean" && this._config.disabled === !0 ? (o.contentEditable = "false", o.classList.add("text-input-disabled"), o.setAttribute("aria-disabled", "true")) : (o.contentEditable = "true", o.removeAttribute("aria-disabled"), this.addEventListeners(o)), Object.assign(o.style, (s = this._config.styles) == null ? void 0 : s.text), Object.assign(o.style, (n = this._config.placeholder) == null ? void 0 : n.style), (i = (r = this._config.placeholder) == null ? void 0 : r.style) != null && i.color || o.setAttribute("textcolor", ""), o;
    }
  }, {
    key: "removePlaceholderStyle",
    value: function() {
      var s, n, r, i;
      !this.inputElementRef.classList.contains("text-input-disabled") && (s = this._config.placeholder) != null && s.style && (za.unsetStyle(this.inputElementRef, (n = this._config.placeholder) == null ? void 0 : n.style), Object.assign(this.inputElementRef.style, (i = (r = this._config) == null ? void 0 : r.styles) == null ? void 0 : i.text));
    }
  }, {
    key: "addEventListeners",
    value: function(s) {
      var n = this, r, i;
      (r = this._config.styles) != null && r.focus && (s.onfocus = function() {
        var o;
        return Object.assign(n.elementRef.style, (o = n._config.styles) == null ? void 0 : o.focus);
      }, s.onblur = this.onBlur.bind(this, this._config.styles.focus, (i = this._config.styles) == null ? void 0 : i.container)), s.addEventListener("keydown", this.onKeydown.bind(this)), s.addEventListener("input", this.onInput.bind(this)), s.addEventListener("paste", zDe.sanitizePastedTextContent), s.addEventListener("compositionstart", function() {
        return n._isComposing = !0;
      }), s.addEventListener("compositionend", function() {
        return n._isComposing = !1;
      });
    }
  }, {
    key: "onBlur",
    value: function(s, n) {
      za.unsetStyle(this.elementRef, s), n && Object.assign(this.elementRef.style, n);
    }
  }, {
    key: "onKeydown",
    value: function(s) {
      var n;
      s.key === qa.ENTER && !el.IS_MOBILE && !this._isComposing && !s.ctrlKey && !s.shiftKey && (s.preventDefault(), (n = this.submit) == null || n.call(this));
    }
  }, {
    key: "onInput",
    value: function() {
      var s, n;
      this.isTextInputEmpty() ? Object.assign(this.inputElementRef.style, (s = this._config.placeholder) == null ? void 0 : s.style) : this.removePlaceholderStyle(), (n = this._onInput) == null || n.call(this, !0);
    }
  }, {
    key: "setPlaceholderText",
    value: function(s) {
      this.inputElementRef.setAttribute("deep-chat-placeholder-text", s), this.inputElementRef.setAttribute("aria-label", s);
    }
  }, {
    key: "isTextInputEmpty",
    value: function() {
      return this.inputElementRef.textContent === "";
    }
  }], [{
    key: "processConfig",
    value: function(s, n) {
      var r, i, o, l;
      return n ?? (n = {}), (r = n.disabled) !== null && r !== void 0 || (n.disabled = s.isTextInputDisabled), (i = n.placeholder) !== null && i !== void 0 || (n.placeholder = {}), (o = (l = n.placeholder).text) !== null && o !== void 0 || (l.text = s.textInputPlaceholderText), n;
    }
  }, {
    key: "createContainerElement",
    value: function(s) {
      var n = document.createElement("div");
      return n.id = "text-input-container", Object.assign(n.style, s), n;
    }
    // this is is a bug fix where if the browser is scrolled down and the user types in text that creates new line
    // the browser scrollbar will move up which leads to undesirable UX.
    // More details in this Stack Overflow question:
    // https://stackoverflow.com/questions/76285135/prevent-automatic-scroll-when-text-is-inserted-into-contenteditable-div
    // prettier-ignore
  }, {
    key: "preventAutomaticScrollUpOnNewLine",
    value: function(s) {
      var n;
      s.addEventListener("keydown", function() {
        n = window.scrollY;
      }), s.addEventListener("input", function() {
        n !== window.scrollY && window.scrollTo({
          top: n
        });
      });
    }
  }]);
}();
n5.TEXT_INPUT_ID = "text-input";
var r5 = n5, kb = /* @__PURE__ */ function() {
  function e() {
    je(this, e);
  }
  return He(e, null, [{
    key: "focusEndOfInput",
    value: function(s) {
      var n = document.createRange();
      n.selectNodeContents(s), n.collapse(!1);
      var r = window.getSelection();
      r == null || r.removeAllRanges(), r == null || r.addRange(n);
    }
  }, {
    key: "focusFromParentElement",
    value: function(s) {
      var n = s.querySelector("#".concat(r5.TEXT_INPUT_ID));
      n && (el.IS_SAFARI && n.focus(), e.focusEndOfInput(n));
    }
  }]);
}();
function G2(e) {
  return e.charAt(0).toUpperCase() + e.slice(1);
}
function WDe(e) {
  return e && JSON.stringify(e);
}
function Eb(e, t, s, n) {
  var r = `
`.concat(G2(t), " message: ").concat(JSON.stringify(e), ` 
`), i = s ? "".concat(G2(t), " message after interceptor: ").concat(WDe(n), ` 
`) : "";
  return r + i;
}
function GDe(e, t, s, n) {
  return "".concat(Eb(e, t, s, n), "Make sure the ").concat(t, ` message is using the Response format: https://deepchat.dev/docs/connect/#Response 
You can also augment it using the responseInterceptor property: https://deepchat.dev/docs/interceptors#responseInterceptor`);
}
function YDe(e, t, s) {
  var n = "response";
  return "".concat(Eb(e, n, t, s), "Make sure the ").concat(n, ' message is using the {text: string} format, e.g: {text: "Model Response"}');
}
function XDe(e, t) {
  var s = "request";
  return "".concat(Eb(e, s, t), "Make sure the ").concat(s, ' message is using the {body: {text: string}} format, e.g: {body: {text: "Model Response"}}');
}
var Y2 = `Make sure the events are using {text: string} or {html: string} format.
You can also augment them using the responseInterceptor property: https://deepchat.dev/docs/interceptors#responseInterceptor`, Ys = {
  INVALID_KEY: "Invalid API Key",
  CONNECTION_FAILED: "Failed to connect",
  INVALID_RESPONSE: GDe,
  INVALID_MODEL_REQUEST: XDe,
  INVALID_MODEL_RESPONSE: YDe,
  INVALID_STREAM_ARRAY_RESPONSE: "Multi-response arrays are not supported for streaming",
  INVALID_STREAM_EVENT: Y2,
  INVALID_STREAM_EVENT_MIX: "Cannot mix {text: string} and {html: string} responses.",
  NO_VALID_STREAM_EVENTS_SENT: `No valid stream events were sent.
`.concat(Y2),
  READABLE_STREAM_CONNECTION_ERROR: "Readable Stream connection error."
}, o5 = /* @__PURE__ */ function() {
  function e() {
    je(this, e);
  }
  return He(e, null, [{
    key: "addElements",
    value: function(s) {
      for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++)
        r[i - 1] = arguments[i];
      r.forEach(function(o) {
        return s.appendChild(o);
      });
    }
  }, {
    key: "isScrollbarAtBottomOfElement",
    value: function(s) {
      var n = s.scrollHeight, r = s.clientHeight, i = s.scrollTop, o = n - r;
      return i >= o - e.CODE_SNIPPET_GENERATION_JUMP;
    }
  }, {
    key: "cloneElement",
    value: function(s) {
      var n = s.cloneNode(!0);
      return s.parentNode.replaceChild(n, s), n;
    }
  }, {
    key: "scrollToBottom",
    value: function(s) {
      var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
      n ? s.scrollTo({
        left: 0,
        top: s.scrollHeight,
        behavior: "smooth"
      }) : s.scrollTop = s.scrollHeight;
    }
  }, {
    key: "scrollToTop",
    value: function(s) {
      s.scrollTop = 0;
    }
  }]);
}();
o5.CODE_SNIPPET_GENERATION_JUMP = 0.5;
var Ln = o5, i5 = /* @__PURE__ */ function() {
  function e() {
    je(this, e);
  }
  return He(e, null, [{
    key: "speak",
    value: function(s, n) {
      if (window.SpeechSynthesisUtterance) {
        var r = new SpeechSynthesisUtterance(s);
        Object.assign(r, n), speechSynthesis.speak(r);
      }
    }
  }, {
    key: "processConfig",
    value: function(s, n) {
      var r = {};
      setTimeout(function() {
        if (St(s) == "object" && (s.lang && (r.lang = s.lang), s.pitch && (r.pitch = s.pitch), s.rate && (r.rate = s.rate), s.volume && (r.volume = s.volume), s.voiceName)) {
          var i = window.speechSynthesis.getVoices().find(function(o) {
            var l;
            return o.name.toLocaleLowerCase() === ((l = s.voiceName) == null ? void 0 : l.toLocaleLowerCase());
          });
          i && (r.voice = i);
        }
        n(r);
      }, e.LOAD_VOICES_MS);
    }
  }]);
}();
i5.LOAD_VOICES_MS = 200;
var Eh = i5, yy = /* @__PURE__ */ function() {
  function e() {
    je(this, e);
  }
  return He(e, null, [{
    key: "colorToHex",
    value: function(s) {
      var n = document.createElement("div");
      return n.style.color = s, document.body.appendChild(n), "#".concat(window.getComputedStyle(n).color.match(/\d+/g).map(function(r) {
        return parseInt(r).toString(16).padStart(2, "0");
      }).join(""));
    }
  }, {
    key: "setDots",
    value: function(s, n) {
      var r, i, o, l;
      if ((l = (o = (i = (r = n == null ? void 0 : n.loading) == null ? void 0 : r.message) == null ? void 0 : i.styles) == null ? void 0 : o.bubble) != null && l.color) {
        var d = e.colorToHex(n.loading.message.styles.bubble.color);
        s.style.setProperty("--loading-message-color", d), s.style.setProperty("--loading-message-color-fade", "".concat(d, "33"));
      } else s.style.setProperty("--loading-message-color", "#848484"), s.style.setProperty("--loading-message-color-fade", "#55555533");
    }
  }, {
    key: "setRing",
    value: function(s, n) {
      var r = n || {}, i = r.color, o = r.width, l = r.height, d = r.margin, c = r.border;
      if (i) {
        var u = e.colorToHex(i);
        s.style.setProperty("--loading-history-color", u);
      } else s.style.setProperty("--loading-history-color", "#dbdbdb");
      s.style.setProperty("--loading-history-height", l || "57px"), s.style.setProperty("--loading-history-width", o || "57px"), s.style.setProperty("--loading-history-margin", d || "7px"), s.style.setProperty("--loading-history-border", c || "6px solid");
    }
  }]);
}();
yy.BUBBLE_CLASS = "deep-chat-loading-message-bubble", yy.DOTS_CONTAINER_CLASS = "deep-chat-loading-message-dots-container";
var qi = yy, by = /* @__PURE__ */ function() {
  function e() {
    je(this, e);
  }
  return He(e, null, [{
    key: "setElementProps",
    value: (
      // prettier-ignore
      function(s, n, r, i) {
        var o;
        r !== "loading" && (s.applyCustomStyles(n, i, !0, (o = s.messageStyles) == null ? void 0 : o[r]), n.bubbleElement.classList.add(e.FILE_BUBBLE_CLASS));
      }
    )
    // prettier-ignore
  }, {
    key: "addMessage",
    value: function(s, n, r, i, o) {
      e.setElementProps(s, n, r, i), o || (s.appendOuterContainerElemet(n.outerContainer), s.focusMode || (s.elementRef.scrollTop = s.elementRef.scrollHeight));
    }
  }, {
    key: "wrapInLink",
    value: function(s, n, r) {
      var i = document.createElement("a");
      return i.href = n, i.download = r || e.DEFAULT_FILE_NAME, i.target = "_blank", i.appendChild(s), i;
    }
  }, {
    key: "isNonLinkableDataUrl",
    value: function(s, n) {
      return !n.startsWith("data") || s === "image" ? !1 : s === "any" && n.startsWith("data:text/javascript") || !n.startsWith("data:image") && !n.startsWith("data:application");
    }
  }, {
    key: "processContent",
    value: function(s, n, r, i) {
      return !r || e.isNonLinkableDataUrl(s, r) ? n : e.wrapInLink(n, r, i);
    }
  }, {
    key: "waitToLoadThenScroll",
    value: function(s) {
      setTimeout(function() {
        s.scrollTop = s.scrollHeight;
      }, 60);
    }
  }, {
    key: "scrollDownOnImageLoad",
    value: function(s, n) {
      if (s.startsWith("data")) e.waitToLoadThenScroll(n);
      else try {
        fetch(s, {
          mode: "no-cors"
        }).catch(function() {
        }).finally(function() {
          e.waitToLoadThenScroll(n);
        });
      } catch {
        n.scrollTop = n.scrollHeight;
      }
    }
    // The strategy is to emit the actual file reference in the `onMessage` event for the user to inspect it
    // But it is not actually used by anything in the chat, hence it is removed when adding a message
    // after the body has been stringified and parsed - the file reference will disappear, hence this readds it
  }, {
    key: "reAddFileRefToObject",
    value: function(s, n) {
      var r;
      (r = s.files) == null || r.forEach(function(i, o) {
        var l;
        i.ref && (l = n.files) != null && l[o] && (n.files[o].ref = i.ref);
      });
    }
    // the chat does not use the actual file
  }, {
    key: "removeFileRef",
    value: function(s) {
      var n = ys({}, s);
      return delete n.ref, n;
    }
  }, {
    key: "isAudioFile",
    value: function(s) {
      var n = /\.(mp3|ogg|wav|aac|webm|4a)$/i, r = s.type, i = s.src;
      return r === "audio" || (i == null ? void 0 : i.startsWith("data:audio")) || i && n.test(i);
    }
  }, {
    key: "isImageFile",
    value: function(s) {
      var n = s.type, r = s.src;
      return n === "image" || (r == null ? void 0 : r.startsWith("data:image")) || r && e.isImageFileExtension(r);
    }
  }, {
    key: "isImageFileExtension",
    value: function(s) {
      return /\.(jpg|jpeg|png|gif|bmp)$/i.test(s);
    }
  }]);
}();
by.DEFAULT_FILE_NAME = "file", by.FILE_BUBBLE_CLASS = "file-message";
var cn = by, xn = /* @__PURE__ */ function() {
  function e() {
    je(this, e);
  }
  return He(e, null, [{
    key: "checkForContainerStyles",
    value: function(s, n) {
      var r = s.containerStyle;
      r && (Object.assign(n.style, r), console.error("The containerStyle property is deprecated since version 1.3.14."), console.error("Please change to using the style property instead: https://deepchat.dev/docs/styles#style"));
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  }, {
    key: "handleResponseProperty",
    value: function(s) {
      return console.error("The {result: ....} response object type is deprecated since version 1.3.0."), console.error("Please change to using the new response object: https://deepchat.dev/docs/connect#Response"), s.result;
    }
  }, {
    key: "processHistory",
    value: function(s) {
      var n = s.initialMessages;
      if (n) return console.error("The initialMessages property is deprecated since version 2.0.0."), console.error("Please change to using the history property instead: https://deepchat.dev/docs/messages/#history"), n;
    }
  }, {
    key: "processHistoryFile",
    value: function(s) {
      var n = s.file;
      n && (console.error("The file property in MessageContent is deprecated since version 1.3.17."), console.error("Please change to using the files array property: https://deepchat.dev/docs/messages/#MessageContent"), s.files = [n]);
    }
  }, {
    key: "processValidateInput",
    value: function(s) {
      var n = s.validateMessageBeforeSending;
      if (n) return console.error("The validateMessageBeforeSending property is deprecated since version 1.3.24."), console.error("Please change to using validateInput: https://deepchat.dev/docs/interceptors#validateInput"), n;
    }
  }, {
    key: "processSubmitUserMessage",
    value: function(s) {
      return console.error("The submitUserMessage(text: string) argument string type is deprecated since version 1.4.4."), console.error("Please change to using the new argument type: https://deepchat.dev/docs/methods#submitUserMessage"), {
        text: s
      };
    }
  }, {
    key: "flagHTMLUpdateClass",
    value: function(s) {
      var n;
      (n = s.children[0]) != null && n.classList.contains("deep-chat-update-message") && (console.error('The "deep-chat-update-message" html class is deprecated since version 1.4.4.'), console.error("Please change to using {..., overwrite: true} object: https://deepchat.dev/docs/connect#Response"));
    }
  }, {
    key: "processConnect",
    value: function(s) {
      var n = s;
      n.request && (n.connect ? Object.assign(n.connect, n.request) : n.connect = n.request, console.error("The request property is deprecated since version 2.0.0."), console.error("Please see the connect object: https://deepchat.dev/docs/connect#connect-1"));
    }
  }, {
    key: "checkForStream",
    value: function(s) {
      var n = s.stream;
      if (n) return console.error("The stream property has been moved to the connect object in version 2.0.0."), console.error("Please see the connect object: https://deepchat.dev/docs/connect#connect-1"), n;
    }
  }, {
    key: "fireOnNewMessage",
    value: function(s, n) {
      var r, i = s;
      i.onNewMessage && (console.error("The onNewMessage event has been deprecated since version 2.0.0."), console.error("Please see the onMessage event: https://deepchat.dev/docs/events#onMessage"), (r = i.onNewMessage) == null || r.call(i, n)), s.dispatchEvent(new CustomEvent("new-message", {
        detail: n
      }));
    }
  }, {
    key: "processFileConfigConnect",
    value: function(s) {
      var n = s;
      n.request && (console.error("The request property in file configuration is deprecated since version 2.0.0."), console.error("Please use the connect property instead: https://deepchat.dev/docs/files"), n.connect || (n.connect = n.request));
    }
  }, {
    key: "processMessageStyles",
    value: function(s) {
      if (s) {
        var n = JSON.parse(JSON.stringify(s)), r = n.loading;
        return r && (r.outerContainer || r.innerContainer || r.bubble || r.media) && (console.error("The loading message styles are defined using LoadingMessageStyles interface since version 2.1.0."), console.error("Check it out here: https://deepchat.dev/docs/messages/styles#LoadingMessageStyles"), n.loading = {
          message: {
            styles: r
          }
        }), n;
      }
    }
  }, {
    key: "processDemo",
    value: function(s) {
      return typeof s == "boolean" || s.displayLoadingBubble && (console.error("The demo displayLoadingBubble property is deprecated since version 2.1.0."), console.error("Please use displayLoading instead: https://deepchat.dev/docs/modes#demo"), s.displayLoading = {
        message: !0
      }), s;
    }
  }]);
}(), Ib = /* @__PURE__ */ function() {
  function e() {
    je(this, e);
  }
  return He(e, null, [{
    key: "mouseUp",
    value: function(s, n) {
      za.unsetAllCSSMouseStates(s, n), Object.assign(s.style, n.default), Object.assign(s.style, n.hover);
    }
  }, {
    key: "mouseDown",
    value: function(s, n) {
      Object.assign(s.style, n.click);
    }
  }, {
    key: "mouseLeave",
    value: function(s, n) {
      za.unsetAllCSSMouseStates(s, n), Object.assign(s.style, n.default);
    }
  }, {
    key: "mouseEnter",
    value: function(s, n) {
      Object.assign(s.style, n.hover);
    }
  }, {
    key: "add",
    value: function(s, n) {
      s.addEventListener("mouseenter", e.mouseEnter.bind(this, s, n)), s.addEventListener("mouseleave", e.mouseLeave.bind(this, s, n)), s.addEventListener("mousedown", e.mouseDown.bind(this, s, n)), s.addEventListener("mouseup", e.mouseUp.bind(this, s, n));
    }
  }]);
}(), qDe = "deep-chat-temporary-message", QDe = "deep-chat-suggestion-button", Ay = {
  "deep-chat-button": {
    styles: {
      default: {
        backgroundColor: "white",
        padding: "5px",
        paddingLeft: "7px",
        paddingRight: "7px",
        border: "1px solid #c2c2c2",
        borderRadius: "6px",
        cursor: "pointer"
      },
      hover: {
        backgroundColor: "#fafafa"
      },
      click: {
        backgroundColor: "#f1f1f1"
      }
    }
  }
}, X2 = Object.keys(Ay), ld = /* @__PURE__ */ function() {
  function e() {
    je(this, e);
  }
  return He(e, null, [{
    key: "applySuggestionEvent",
    value: function(s, n) {
      setTimeout(function() {
        n.addEventListener("click", function() {
          var r, i;
          (i = s.submitUserMessage) == null || i.call(s, {
            text: ((r = n.textContent) == null ? void 0 : r.trim()) || ""
          });
        });
      });
    }
  }, {
    key: "isElementTemporary",
    value: function(s) {
      var n;
      return s ? (n = s.bubbleElement.children[0]) == null ? void 0 : n.classList.contains(qDe) : !1;
    }
  }, {
    key: "doesElementContainDeepChatClass",
    value: function(s) {
      return X2.find(function(n) {
        return s.classList.contains(n);
      });
    }
  }, {
    key: "applyEvents",
    value: function(s, n) {
      var r = Ay[n].events;
      Object.keys(r || []).forEach(function(i) {
        s.addEventListener(i, r == null ? void 0 : r[i]);
      });
    }
  }, {
    key: "getProcessedStyles",
    value: function(s, n, r) {
      var i = Array.from(n.classList).reduce(function(c, u) {
        var m, f = (m = s[u]) == null ? void 0 : m.styles;
        return f && s[u].styles && c.push(f), c;
      }, []), o = Ay[r].styles;
      if (o) {
        var l = JSON.parse(JSON.stringify(o));
        l.default && za.overwriteDefaultWithAlreadyApplied(l, n), i.unshift(l);
      }
      var d = za.mergeStatefulStyles(i);
      return za.processStateful(d);
    }
  }, {
    key: "applyDeepChatUtilities",
    value: function(s, n, r) {
      X2.forEach(function(o) {
        var l = r.getElementsByClassName(o);
        Array.from(l || []).forEach(function(d) {
          var c = e.getProcessedStyles(n, d, o);
          Oo.applyStylesToElement(d, c), e.applyEvents(d, o);
        });
      });
      var i = r.getElementsByClassName(QDe);
      Array.from(i).forEach(function(o) {
        return e.applySuggestionEvent(s, o);
      });
    }
  }]);
}(), Oo = /* @__PURE__ */ function() {
  function e() {
    je(this, e);
  }
  return He(e, null, [{
    key: "applyStylesToElement",
    value: function(s, n) {
      var r = za.processStateful(n);
      Ib.add(s, r), Object.assign(s.style, r.default);
    }
  }, {
    key: "applyEventsToElement",
    value: function(s, n) {
      Object.keys(n).forEach(function(r) {
        var i = n[r];
        i && s.addEventListener(r, i);
      });
    }
  }, {
    key: "applyClassUtilitiesToElement",
    value: function(s, n) {
      var r = n.events, i = n.styles;
      r && e.applyEventsToElement(s, r), i && !ld.doesElementContainDeepChatClass(s) && e.applyStylesToElement(s, i);
    }
  }, {
    key: "applyCustomClassUtilities",
    value: function(s, n) {
      Object.keys(s).forEach(function(r) {
        var i = n.getElementsByClassName(r);
        Array.from(i).forEach(function(o) {
          s[r] && e.applyClassUtilitiesToElement(o, s[r]);
        });
      });
    }
  }, {
    key: "apply",
    value: function(s, n) {
      ld.applyDeepChatUtilities(s, s.htmlClassUtilities, n), e.applyCustomClassUtilities(s.htmlClassUtilities, n);
    }
  }, {
    key: "traverseNodes",
    value: function(s, n) {
      s.nodeType === Node.ELEMENT_NODE && n.push(s.outerHTML), s.childNodes.forEach(function(r) {
        e.traverseNodes(r, n);
      });
    }
  }, {
    key: "splitHTML",
    value: function(s) {
      var n = new DOMParser().parseFromString(s, "text/html"), r = [];
      return n.body.childNodes.forEach(function(i) {
        e.traverseNodes(i, r);
      }), r;
    }
  }, {
    key: "isTemporaryBasedOnHTML",
    value: function(s) {
      var n = document.createElement("div");
      return n.innerHTML = s, ld.isElementTemporary({
        outerContainer: n,
        bubbleElement: n,
        innerContainer: n
      });
    }
    // useful for removing event listeners
  }, {
    key: "replaceElementWithNewClone",
    value: function(s, n) {
      var r, i = (n || s).cloneNode(!0);
      return (r = s.parentNode) == null || r.replaceChild(i, s), i;
    }
  }]);
}(), l5 = /* @__PURE__ */ function() {
  function e() {
    je(this, e);
  }
  return He(e, null, [{
    key: "addElement",
    value: function(s, n) {
      s.appendOuterContainerElemet(n), s.focusMode || (s.elementRef.scrollTop = s.elementRef.scrollHeight);
    }
  }, {
    key: "createElements",
    value: function(s, n, r, i) {
      var o = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !1, l = s.createMessageElementsOnOrientation("", r, i, o);
      return l.bubbleElement.classList.add(e.HTML_BUBBLE_CLASS), l.bubbleElement.innerHTML = n, l;
    }
  }, {
    key: "overwriteElements",
    value: function(s, n, r) {
      r.bubbleElement.innerHTML = n, Oo.apply(s, r.outerContainer), xn.flagHTMLUpdateClass(r.bubbleElement);
    }
    // prettier-ignore
  }, {
    key: "overwrite",
    value: function(s, n, r, i) {
      var o = s.messageToElements, l = Ft.overwriteMessage(o, i, n, r, "html", e.HTML_BUBBLE_CLASS);
      return l && e.overwriteElements(s, n, l), l;
    }
  }, {
    key: "create",
    value: function(s, n, r) {
      var i = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1, o, l = e.createElements(s, n, r, i);
      return Ft.fillEmptyMessageElement(l.bubbleElement, n), Oo.apply(s, l.outerContainer), xn.flagHTMLUpdateClass(l.bubbleElement), s.applyCustomStyles(l, r, !1, (o = s.messageStyles) == null ? void 0 : o.html), l;
    }
  }, {
    key: "add",
    value: function(s, n, r, i) {
      var o = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !1;
      if (i != null && i.status) {
        var l = this.overwrite(s, n, r, s.messageElementRefs);
        if (l) return l;
        i.status = !1;
      }
      if (!(o && s.messageElementRefs.length > 0 && Oo.isTemporaryBasedOnHTML(n))) {
        var d = e.create(s, n, r, o);
        return o || e.addElement(s, d.outerContainer), d;
      }
    }
  }]);
}();
l5.HTML_BUBBLE_CLASS = "html-message";
var mi = l5, Vp;
function d5(e) {
  return Vp = Vp || document.createElement("textarea"), Vp.innerHTML = "&" + e + ";", Vp.value;
}
var KDe = Object.prototype.hasOwnProperty;
function ZDe(e, t) {
  return e ? KDe.call(e, t) : !1;
}
function c5(e) {
  var t = [].slice.call(arguments, 1);
  return t.forEach(function(s) {
    if (s) {
      if (St(s) != "object") throw new TypeError(s + "must be object");
      Object.keys(s).forEach(function(n) {
        e[n] = s[n];
      });
    }
  }), e;
}
var JDe = /\\([\\!"#$%&'()*+,.\/:;<=>?@[\]^_`{|}~-])/g;
function Cu(e) {
  return e.indexOf("\\") < 0 ? e : e.replace(JDe, "$1");
}
function u5(e) {
  return !(e >= 55296 && e <= 57343 || e >= 64976 && e <= 65007 || (e & 65535) === 65535 || (e & 65535) === 65534 || e >= 0 && e <= 8 || e === 11 || e >= 14 && e <= 31 || e >= 127 && e <= 159 || e > 1114111);
}
function wy(e) {
  if (e > 65535) {
    e -= 65536;
    var t = 55296 + (e >> 10), s = 56320 + (e & 1023);
    return String.fromCharCode(t, s);
  }
  return String.fromCharCode(e);
}
var $De = /&([a-z#][a-z0-9]{1,31});/gi, _De = /^#((?:x[a-f0-9]{1,8}|[0-9]{1,8}))/i;
function eNe(e, t) {
  var s = 0, n = d5(t);
  return t !== n ? n : t.charCodeAt(0) === 35 && _De.test(t) && (s = t[1].toLowerCase() === "x" ? parseInt(t.slice(2), 16) : parseInt(t.slice(1), 10), u5(s)) ? wy(s) : e;
}
function cl(e) {
  return e.indexOf("&") < 0 ? e : e.replace($De, eNe);
}
var tNe = /[&<>"]/, sNe = /[&<>"]/g, aNe = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;"
};
function nNe(e) {
  return aNe[e];
}
function Bn(e) {
  return tNe.test(e) ? e.replace(sNe, nNe) : e;
}
var xt = {};
xt.blockquote_open = function() {
  return `<blockquote>
`;
};
xt.blockquote_close = function(e, t) {
  return "</blockquote>" + Cl(e, t);
};
xt.code = function(e, t) {
  return e[t].block ? "<pre><code>" + Bn(e[t].content) + "</code></pre>" + Cl(e, t) : "<code>" + Bn(e[t].content) + "</code>";
};
xt.fence = function(e, t, s, n, r) {
  var i = e[t], o = "", l = s.langPrefix, d = "", c, u, m;
  if (i.params) {
    if (c = i.params.split(/\s+/g), u = c.join(" "), ZDe(r.rules.fence_custom, c[0])) return r.rules.fence_custom[c[0]](e, t, s, n, r);
    d = Bn(cl(Cu(u))), o = ' class="' + l + d + '"';
  }
  return s.highlight ? m = s.highlight.apply(s.highlight, [i.content].concat(c)) || Bn(i.content) : m = Bn(i.content), "<pre><code" + o + ">" + m + "</code></pre>" + Cl(e, t);
};
xt.fence_custom = {};
xt.heading_open = function(e, t) {
  return "<h" + e[t].hLevel + ">";
};
xt.heading_close = function(e, t) {
  return "</h" + e[t].hLevel + `>
`;
};
xt.hr = function(e, t, s) {
  return (s.xhtmlOut ? "<hr />" : "<hr>") + Cl(e, t);
};
xt.bullet_list_open = function() {
  return `<ul>
`;
};
xt.bullet_list_close = function(e, t) {
  return "</ul>" + Cl(e, t);
};
xt.list_item_open = function() {
  return "<li>";
};
xt.list_item_close = function() {
  return `</li>
`;
};
xt.ordered_list_open = function(e, t) {
  var s = e[t], n = s.order > 1 ? ' start="' + s.order + '"' : "";
  return "<ol" + n + `>
`;
};
xt.ordered_list_close = function(e, t) {
  return "</ol>" + Cl(e, t);
};
xt.paragraph_open = function(e, t) {
  return e[t].tight ? "" : "<p>";
};
xt.paragraph_close = function(e, t) {
  var s = !(e[t].tight && t && e[t - 1].type === "inline" && !e[t - 1].content);
  return (e[t].tight ? "" : "</p>") + (s ? Cl(e, t) : "");
};
xt.link_open = function(e, t, s) {
  var n = e[t].title ? ' title="' + Bn(cl(e[t].title)) + '"' : "", r = s.linkTarget ? ' target="' + s.linkTarget + '"' : "";
  return '<a href="' + Bn(e[t].href) + '"' + n + r + ">";
};
xt.link_close = function() {
  return "</a>";
};
xt.image = function(e, t, s) {
  var n = ' src="' + Bn(e[t].src) + '"', r = e[t].title ? ' title="' + Bn(cl(e[t].title)) + '"' : "", i = ' alt="' + (e[t].alt ? Bn(cl(Cu(e[t].alt))) : "") + '"', o = s.xhtmlOut ? " /" : "";
  return "<img" + n + i + r + o + ">";
};
xt.table_open = function() {
  return `<table>
`;
};
xt.table_close = function() {
  return `</table>
`;
};
xt.thead_open = function() {
  return `<thead>
`;
};
xt.thead_close = function() {
  return `</thead>
`;
};
xt.tbody_open = function() {
  return `<tbody>
`;
};
xt.tbody_close = function() {
  return `</tbody>
`;
};
xt.tr_open = function() {
  return "<tr>";
};
xt.tr_close = function() {
  return `</tr>
`;
};
xt.th_open = function(e, t) {
  var s = e[t];
  return "<th" + (s.align ? ' style="text-align:' + s.align + '"' : "") + ">";
};
xt.th_close = function() {
  return "</th>";
};
xt.td_open = function(e, t) {
  var s = e[t];
  return "<td" + (s.align ? ' style="text-align:' + s.align + '"' : "") + ">";
};
xt.td_close = function() {
  return "</td>";
};
xt.strong_open = function() {
  return "<strong>";
};
xt.strong_close = function() {
  return "</strong>";
};
xt.em_open = function() {
  return "<em>";
};
xt.em_close = function() {
  return "</em>";
};
xt.del_open = function() {
  return "<del>";
};
xt.del_close = function() {
  return "</del>";
};
xt.ins_open = function() {
  return "<ins>";
};
xt.ins_close = function() {
  return "</ins>";
};
xt.mark_open = function() {
  return "<mark>";
};
xt.mark_close = function() {
  return "</mark>";
};
xt.sub = function(e, t) {
  return "<sub>" + Bn(e[t].content) + "</sub>";
};
xt.sup = function(e, t) {
  return "<sup>" + Bn(e[t].content) + "</sup>";
};
xt.hardbreak = function(e, t, s) {
  return s.xhtmlOut ? `<br />
` : `<br>
`;
};
xt.softbreak = function(e, t, s) {
  return s.breaks ? s.xhtmlOut ? `<br />
` : `<br>
` : `
`;
};
xt.text = function(e, t) {
  return Bn(e[t].content);
};
xt.htmlblock = function(e, t) {
  return e[t].content;
};
xt.htmltag = function(e, t) {
  return e[t].content;
};
xt.abbr_open = function(e, t) {
  return '<abbr title="' + Bn(cl(e[t].title)) + '">';
};
xt.abbr_close = function() {
  return "</abbr>";
};
xt.footnote_ref = function(e, t) {
  var s = Number(e[t].id + 1).toString(), n = "fnref" + s;
  return e[t].subId > 0 && (n += ":" + e[t].subId), '<sup class="footnote-ref"><a href="#fn' + s + '" id="' + n + '">[' + s + "]</a></sup>";
};
xt.footnote_block_open = function(e, t, s) {
  var n = s.xhtmlOut ? `<hr class="footnotes-sep" />
` : `<hr class="footnotes-sep">
`;
  return n + `<section class="footnotes">
<ol class="footnotes-list">
`;
};
xt.footnote_block_close = function() {
  return `</ol>
</section>
`;
};
xt.footnote_open = function(e, t) {
  var s = Number(e[t].id + 1).toString();
  return '<li id="fn' + s + '"  class="footnote-item">';
};
xt.footnote_close = function() {
  return `</li>
`;
};
xt.footnote_anchor = function(e, t) {
  var s = Number(e[t].id + 1).toString(), n = "fnref" + s;
  return e[t].subId > 0 && (n += ":" + e[t].subId), ' <a href="#' + n + '" class="footnote-backref">↩</a>';
};
xt.dl_open = function() {
  return `<dl>
`;
};
xt.dt_open = function() {
  return "<dt>";
};
xt.dd_open = function() {
  return "<dd>";
};
xt.dl_close = function() {
  return `</dl>
`;
};
xt.dt_close = function() {
  return `</dt>
`;
};
xt.dd_close = function() {
  return `</dd>
`;
};
function p5(e, t) {
  return ++t >= e.length - 2 ? t : e[t].type === "paragraph_open" && e[t].tight && e[t + 1].type === "inline" && e[t + 1].content.length === 0 && e[t + 2].type === "paragraph_close" && e[t + 2].tight ? p5(e, t + 2) : t;
}
var Cl = xt.getBreak = function(e, t) {
  return t = p5(e, t), t < e.length && e[t].type === "list_item_close" ? "" : `
`;
};
function Tb() {
  this.rules = c5({}, xt), this.getBreak = xt.getBreak;
}
Tb.prototype.renderInline = function(e, t, s) {
  for (var n = this.rules, r = e.length, i = 0, o = ""; r--; ) o += n[e[i].type](e, i++, t, s, this);
  return o;
};
Tb.prototype.render = function(e, t, s) {
  for (var n = this.rules, r = e.length, i = -1, o = ""; ++i < r; ) e[i].type === "inline" ? o += this.renderInline(e[i].children, t, s) : o += n[e[i].type](e, i, t, s, this);
  return o;
};
function Gn() {
  this.__rules__ = [], this.__cache__ = null;
}
Gn.prototype.__find__ = function(e) {
  for (var t = this.__rules__.length, s = -1; t--; ) if (this.__rules__[++s].name === e) return s;
  return -1;
};
Gn.prototype.__compile__ = function() {
  var e = this, t = [""];
  e.__rules__.forEach(function(s) {
    s.enabled && s.alt.forEach(function(n) {
      t.indexOf(n) < 0 && t.push(n);
    });
  }), e.__cache__ = {}, t.forEach(function(s) {
    e.__cache__[s] = [], e.__rules__.forEach(function(n) {
      n.enabled && (s && n.alt.indexOf(s) < 0 || e.__cache__[s].push(n.fn));
    });
  });
};
Gn.prototype.at = function(e, t, s) {
  var n = this.__find__(e), r = s || {};
  if (n === -1) throw new Error("Parser rule not found: " + e);
  this.__rules__[n].fn = t, this.__rules__[n].alt = r.alt || [], this.__cache__ = null;
};
Gn.prototype.before = function(e, t, s, n) {
  var r = this.__find__(e), i = n || {};
  if (r === -1) throw new Error("Parser rule not found: " + e);
  this.__rules__.splice(r, 0, {
    name: t,
    enabled: !0,
    fn: s,
    alt: i.alt || []
  }), this.__cache__ = null;
};
Gn.prototype.after = function(e, t, s, n) {
  var r = this.__find__(e), i = n || {};
  if (r === -1) throw new Error("Parser rule not found: " + e);
  this.__rules__.splice(r + 1, 0, {
    name: t,
    enabled: !0,
    fn: s,
    alt: i.alt || []
  }), this.__cache__ = null;
};
Gn.prototype.push = function(e, t, s) {
  var n = s || {};
  this.__rules__.push({
    name: e,
    enabled: !0,
    fn: t,
    alt: n.alt || []
  }), this.__cache__ = null;
};
Gn.prototype.enable = function(e, t) {
  e = Array.isArray(e) ? e : [e], t && this.__rules__.forEach(function(s) {
    s.enabled = !1;
  }), e.forEach(function(s) {
    var n = this.__find__(s);
    if (n < 0) throw new Error("Rules manager: invalid rule name " + s);
    this.__rules__[n].enabled = !0;
  }, this), this.__cache__ = null;
};
Gn.prototype.disable = function(e) {
  e = Array.isArray(e) ? e : [e], e.forEach(function(t) {
    var s = this.__find__(t);
    if (s < 0) throw new Error("Rules manager: invalid rule name " + t);
    this.__rules__[s].enabled = !1;
  }, this), this.__cache__ = null;
};
Gn.prototype.getRules = function(e) {
  return this.__cache__ === null && this.__compile__(), this.__cache__[e] || [];
};
function rNe(e) {
  e.inlineMode ? e.tokens.push({
    type: "inline",
    content: e.src.replace(/\n/g, " ").trim(),
    level: 0,
    lines: [0, 1],
    children: []
  }) : e.block.parse(e.src, e.options, e.env, e.tokens);
}
function Sl(e, t, s, n, r) {
  this.src = e, this.env = n, this.options = s, this.parser = t, this.tokens = r, this.pos = 0, this.posMax = this.src.length, this.level = 0, this.pending = "", this.pendingLevel = 0, this.cache = [], this.isInLabel = !1, this.linkLevel = 0, this.linkContent = "", this.labelUnmatchedScopes = 0;
}
Sl.prototype.pushPending = function() {
  this.tokens.push({
    type: "text",
    content: this.pending,
    level: this.pendingLevel
  }), this.pending = "";
};
Sl.prototype.push = function(e) {
  this.pending && this.pushPending(), this.tokens.push(e), this.pendingLevel = this.level;
};
Sl.prototype.cacheSet = function(e, t) {
  for (var s = this.cache.length; s <= e; s++) this.cache.push(0);
  this.cache[e] = t;
};
Sl.prototype.cacheGet = function(e) {
  return e < this.cache.length ? this.cache[e] : 0;
};
function Su(e, t) {
  var s, n, r, i = -1, o = e.posMax, l = e.pos, d = e.isInLabel;
  if (e.isInLabel) return -1;
  if (e.labelUnmatchedScopes) return e.labelUnmatchedScopes--, -1;
  for (e.pos = t + 1, e.isInLabel = !0, s = 1; e.pos < o; ) {
    if (r = e.src.charCodeAt(e.pos), r === 91) s++;
    else if (r === 93 && (s--, s === 0)) {
      n = !0;
      break;
    }
    e.parser.skipToken(e);
  }
  return n ? (i = e.pos, e.labelUnmatchedScopes = 0) : e.labelUnmatchedScopes = s - 1, e.pos = l, e.isInLabel = d, i;
}
function oNe(e, t, s, n) {
  var r, i, o, l, d, c;
  if (e.charCodeAt(0) !== 42 || e.charCodeAt(1) !== 91 || e.indexOf("]:") === -1 || (r = new Sl(e, t, s, n, []), i = Su(r, 1), i < 0 || e.charCodeAt(i + 1) !== 58)) return -1;
  for (l = r.posMax, o = i + 2; o < l && r.src.charCodeAt(o) !== 10; o++) ;
  return d = e.slice(2, i), c = e.slice(i + 2, o).trim(), c.length === 0 ? -1 : (n.abbreviations || (n.abbreviations = {}), St(n.abbreviations[":" + d]) > "u" && (n.abbreviations[":" + d] = c), o);
}
function iNe(e) {
  var t = e.tokens, s, n, r, i;
  if (!e.inlineMode) {
    for (s = 1, n = t.length - 1; s < n; s++) if (t[s - 1].type === "paragraph_open" && t[s].type === "inline" && t[s + 1].type === "paragraph_close") {
      for (r = t[s].content; r.length && (i = oNe(r, e.inline, e.options, e.env), !(i < 0)); ) r = r.slice(i).trim();
      t[s].content = r, r.length || (t[s - 1].tight = !0, t[s + 1].tight = !0);
    }
  }
}
function Cy(e) {
  var t = cl(e);
  try {
    t = decodeURI(t);
  } catch {
  }
  return encodeURI(t);
}
function h5(e, t) {
  var s, n, r, i = t, o = e.posMax;
  if (e.src.charCodeAt(t) === 60) {
    for (t++; t < o; ) {
      if (s = e.src.charCodeAt(t), s === 10) return !1;
      if (s === 62) return r = Cy(Cu(e.src.slice(i + 1, t))), e.parser.validateLink(r) ? (e.pos = t + 1, e.linkContent = r, !0) : !1;
      if (s === 92 && t + 1 < o) {
        t += 2;
        continue;
      }
      t++;
    }
    return !1;
  }
  for (n = 0; t < o && (s = e.src.charCodeAt(t), !(s === 32 || s < 32 || s === 127)); ) {
    if (s === 92 && t + 1 < o) {
      t += 2;
      continue;
    }
    if (s === 40 && (n++, n > 1) || s === 41 && (n--, n < 0)) break;
    t++;
  }
  return i === t || (r = Cu(e.src.slice(i, t)), !e.parser.validateLink(r)) ? !1 : (e.linkContent = r, e.pos = t, !0);
}
function m5(e, t) {
  var s, n = t, r = e.posMax, i = e.src.charCodeAt(t);
  if (i !== 34 && i !== 39 && i !== 40) return !1;
  for (t++, i === 40 && (i = 41); t < r; ) {
    if (s = e.src.charCodeAt(t), s === i) return e.pos = t + 1, e.linkContent = Cu(e.src.slice(n + 1, t)), !0;
    if (s === 92 && t + 1 < r) {
      t += 2;
      continue;
    }
    t++;
  }
  return !1;
}
function f5(e) {
  return e.trim().replace(/\s+/g, " ").toUpperCase();
}
function lNe(e, t, s, n) {
  var r, i, o, l, d, c, u, m, f;
  if (e.charCodeAt(0) !== 91 || e.indexOf("]:") === -1 || (r = new Sl(e, t, s, n, []), i = Su(r, 0), i < 0 || e.charCodeAt(i + 1) !== 58)) return -1;
  for (l = r.posMax, o = i + 2; o < l && (d = r.src.charCodeAt(o), !(d !== 32 && d !== 10)); o++) ;
  if (!h5(r, o)) return -1;
  for (u = r.linkContent, o = r.pos, c = o, o = o + 1; o < l && (d = r.src.charCodeAt(o), !(d !== 32 && d !== 10)); o++) ;
  for (o < l && c !== o && m5(r, o) ? (m = r.linkContent, o = r.pos) : (m = "", o = c); o < l && r.src.charCodeAt(o) === 32; ) o++;
  return o < l && r.src.charCodeAt(o) !== 10 ? -1 : (f = f5(e.slice(1, i)), St(n.references[f]) > "u" && (n.references[f] = {
    title: m,
    href: u
  }), o);
}
function dNe(e) {
  var t = e.tokens, s, n, r, i;
  if (e.env.references = e.env.references || {}, !e.inlineMode) {
    for (s = 1, n = t.length - 1; s < n; s++) if (t[s].type === "inline" && t[s - 1].type === "paragraph_open" && t[s + 1].type === "paragraph_close") {
      for (r = t[s].content; r.length && (i = lNe(r, e.inline, e.options, e.env), !(i < 0)); ) r = r.slice(i).trim();
      t[s].content = r, r.length || (t[s - 1].tight = !0, t[s + 1].tight = !0);
    }
  }
}
function cNe(e) {
  var t = e.tokens, s, n, r;
  for (n = 0, r = t.length; n < r; n++) s = t[n], s.type === "inline" && e.inline.parse(s.content, e.options, e.env, s.children);
}
function uNe(e) {
  var t, s, n, r, i, o, l, d, c, u = 0, m = !1, f = {};
  if (e.env.footnotes && (e.tokens = e.tokens.filter(function(v) {
    return v.type === "footnote_reference_open" ? (m = !0, d = [], c = v.label, !1) : v.type === "footnote_reference_close" ? (m = !1, f[":" + c] = d, !1) : (m && d.push(v), !m);
  }), !!e.env.footnotes.list)) {
    for (o = e.env.footnotes.list, e.tokens.push({
      type: "footnote_block_open",
      level: u++
    }), t = 0, s = o.length; t < s; t++) {
      for (e.tokens.push({
        type: "footnote_open",
        id: t,
        level: u++
      }), o[t].tokens ? (l = [], l.push({
        type: "paragraph_open",
        tight: !1,
        level: u++
      }), l.push({
        type: "inline",
        content: "",
        level: u,
        children: o[t].tokens
      }), l.push({
        type: "paragraph_close",
        tight: !1,
        level: --u
      })) : o[t].label && (l = f[":" + o[t].label]), e.tokens = e.tokens.concat(l), e.tokens[e.tokens.length - 1].type === "paragraph_close" ? i = e.tokens.pop() : i = null, r = o[t].count > 0 ? o[t].count : 1, n = 0; n < r; n++) e.tokens.push({
        type: "footnote_anchor",
        id: t,
        subId: n,
        level: u
      });
      i && e.tokens.push(i), e.tokens.push({
        type: "footnote_close",
        level: --u
      });
    }
    e.tokens.push({
      type: "footnote_block_close",
      level: --u
    });
  }
}
var q2 = ` 
()[]'".,!?-`;
function Vg(e) {
  return e.replace(/([-()\[\]{}+?*.$\^|,:#<!\\])/g, "\\$1");
}
function pNe(e) {
  var t, s, n, r, i, o, l, d, c, u, m, f, v = e.tokens;
  if (e.env.abbreviations) {
    for (e.env.abbrRegExp || (f = "(^|[" + q2.split("").map(Vg).join("") + "])(" + Object.keys(e.env.abbreviations).map(function(b) {
      return b.substr(1);
    }).sort(function(b, w) {
      return w.length - b.length;
    }).map(Vg).join("|") + ")($|[" + q2.split("").map(Vg).join("") + "])", e.env.abbrRegExp = new RegExp(f, "g")), u = e.env.abbrRegExp, s = 0, n = v.length; s < n; s++) if (v[s].type === "inline") {
      for (r = v[s].children, t = r.length - 1; t >= 0; t--) if (i = r[t], i.type === "text") {
        for (d = 0, o = i.content, u.lastIndex = 0, c = i.level, l = []; m = u.exec(o); ) u.lastIndex > d && l.push({
          type: "text",
          content: o.slice(d, m.index + m[1].length),
          level: c
        }), l.push({
          type: "abbr_open",
          title: e.env.abbreviations[":" + m[2]],
          level: c++
        }), l.push({
          type: "text",
          content: m[2],
          level: c
        }), l.push({
          type: "abbr_close",
          level: --c
        }), d = u.lastIndex - m[3].length;
        l.length && (d < o.length && l.push({
          type: "text",
          content: o.slice(d),
          level: c
        }), v[s].children = r = [].concat(r.slice(0, t), l, r.slice(t + 1)));
      }
    }
  }
}
var hNe = /\+-|\.\.|\?\?\?\?|!!!!|,,|--/, mNe = /\((c|tm|r|p)\)/ig, fNe = {
  c: "©",
  r: "®",
  p: "§",
  tm: "™"
};
function gNe(e) {
  return e.indexOf("(") < 0 ? e : e.replace(mNe, function(t, s) {
    return fNe[s.toLowerCase()];
  });
}
function vNe(e) {
  var t, s, n, r, i;
  if (e.options.typographer) {
    for (i = e.tokens.length - 1; i >= 0; i--) if (e.tokens[i].type === "inline") for (r = e.tokens[i].children, t = r.length - 1; t >= 0; t--) s = r[t], s.type === "text" && (n = s.content, n = gNe(n), hNe.test(n) && (n = n.replace(/\+-/g, "±").replace(/\.{2,}/g, "…").replace(/([?!])…/g, "$1..").replace(/([?!]){4,}/g, "$1$1$1").replace(/,{2,}/g, ",").replace(/(^|[^-])---([^-]|$)/mg, "$1—$2").replace(/(^|\s)--(\s|$)/mg, "$1–$2").replace(/(^|[^-\s])--([^-\s]|$)/mg, "$1–$2")), s.content = n);
  }
}
var yNe = /['"]/, Q2 = /['"]/g, bNe = /[-\s()\[\]]/, K2 = "’";
function Z2(e, t) {
  return t < 0 || t >= e.length ? !1 : !bNe.test(e[t]);
}
function Fl(e, t, s) {
  return e.substr(0, t) + s + e.substr(t + 1);
}
function ANe(e) {
  var t, s, n, r, i, o, l, d, c, u, m, f, v, b, w, S, I;
  if (e.options.typographer) {
    for (I = [], w = e.tokens.length - 1; w >= 0; w--) if (e.tokens[w].type === "inline") {
      for (S = e.tokens[w].children, I.length = 0, t = 0; t < S.length; t++) if (s = S[t], !(s.type !== "text" || yNe.test(s.text))) {
        for (l = S[t].level, v = I.length - 1; v >= 0 && !(I[v].level <= l); v--) ;
        I.length = v + 1, n = s.content, i = 0, o = n.length;
        e: for (; i < o && (Q2.lastIndex = i, r = Q2.exec(n), !!r); ) {
          if (d = !Z2(n, r.index - 1), i = r.index + 1, b = r[0] === "'", c = !Z2(n, i), !c && !d) {
            b && (s.content = Fl(s.content, r.index, K2));
            continue;
          }
          if (m = !c, f = !d, f) {
            for (v = I.length - 1; v >= 0 && (u = I[v], !(I[v].level < l)); v--) if (u.single === b && I[v].level === l) {
              u = I[v], b ? (S[u.token].content = Fl(S[u.token].content, u.pos, e.options.quotes[2]), s.content = Fl(s.content, r.index, e.options.quotes[3])) : (S[u.token].content = Fl(S[u.token].content, u.pos, e.options.quotes[0]), s.content = Fl(s.content, r.index, e.options.quotes[1])), I.length = v;
              continue e;
            }
          }
          m ? I.push({
            token: t,
            pos: r.index,
            single: b,
            level: l
          }) : f && b && (s.content = Fl(s.content, r.index, K2));
        }
      }
    }
  }
}
var Dg = [["block", rNe], ["abbr", iNe], ["references", dNe], ["inline", cNe], ["footnote_tail", uNe], ["abbr2", pNe], ["replacements", vNe], ["smartquotes", ANe]];
function g5() {
  this.options = {}, this.ruler = new Gn();
  for (var e = 0; e < Dg.length; e++) this.ruler.push(Dg[e][0], Dg[e][1]);
}
g5.prototype.process = function(e) {
  var t, s, n;
  for (n = this.ruler.getRules(""), t = 0, s = n.length; t < s; t++) n[t](e);
};
function Pl(e, t, s, n, r) {
  var i, o, l, d, c, u, m;
  for (this.src = e, this.parser = t, this.options = s, this.env = n, this.tokens = r, this.bMarks = [], this.eMarks = [], this.tShift = [], this.blkIndent = 0, this.line = 0, this.lineMax = 0, this.tight = !1, this.parentType = "root", this.ddIndent = -1, this.level = 0, this.result = "", o = this.src, u = 0, m = !1, l = d = u = 0, c = o.length; d < c; d++) {
    if (i = o.charCodeAt(d), !m) if (i === 32) {
      u++;
      continue;
    } else m = !0;
    (i === 10 || d === c - 1) && (i !== 10 && d++, this.bMarks.push(l), this.eMarks.push(d), this.tShift.push(u), m = !1, u = 0, l = d + 1);
  }
  this.bMarks.push(o.length), this.eMarks.push(o.length), this.tShift.push(0), this.lineMax = this.bMarks.length - 1;
}
Pl.prototype.isEmpty = function(e) {
  return this.bMarks[e] + this.tShift[e] >= this.eMarks[e];
};
Pl.prototype.skipEmptyLines = function(e) {
  for (var t = this.lineMax; e < t && !(this.bMarks[e] + this.tShift[e] < this.eMarks[e]); e++) ;
  return e;
};
Pl.prototype.skipSpaces = function(e) {
  for (var t = this.src.length; e < t && this.src.charCodeAt(e) === 32; e++) ;
  return e;
};
Pl.prototype.skipChars = function(e, t) {
  for (var s = this.src.length; e < s && this.src.charCodeAt(e) === t; e++) ;
  return e;
};
Pl.prototype.skipCharsBack = function(e, t, s) {
  if (e <= s) return e;
  for (; e > s; ) if (t !== this.src.charCodeAt(--e)) return e + 1;
  return e;
};
Pl.prototype.getLines = function(e, t, s, n) {
  var r, i, o, l, d, c = e;
  if (e >= t) return "";
  if (c + 1 === t) return i = this.bMarks[c] + Math.min(this.tShift[c], s), o = n ? this.eMarks[c] + 1 : this.eMarks[c], this.src.slice(i, o);
  for (l = new Array(t - e), r = 0; c < t; c++, r++) d = this.tShift[c], d > s && (d = s), d < 0 && (d = 0), i = this.bMarks[c] + d, c + 1 < t || n ? o = this.eMarks[c] + 1 : o = this.eMarks[c], l[r] = this.src.slice(i, o);
  return l.join("");
};
function wNe(e, t, s) {
  var n, r;
  if (e.tShift[t] - e.blkIndent < 4) return !1;
  for (r = n = t + 1; n < s; ) {
    if (e.isEmpty(n)) {
      n++;
      continue;
    }
    if (e.tShift[n] - e.blkIndent >= 4) {
      n++, r = n;
      continue;
    }
    break;
  }
  return e.line = n, e.tokens.push({
    type: "code",
    content: e.getLines(t, r, 4 + e.blkIndent, !0),
    block: !0,
    lines: [t, e.line],
    level: e.level
  }), !0;
}
function CNe(e, t, s, n) {
  var r, i, o, l, d, c = !1, u = e.bMarks[t] + e.tShift[t], m = e.eMarks[t];
  if (u + 3 > m || (r = e.src.charCodeAt(u), r !== 126 && r !== 96) || (d = u, u = e.skipChars(u, r), i = u - d, i < 3) || (o = e.src.slice(u, m).trim(), o.indexOf("`") >= 0)) return !1;
  if (n) return !0;
  for (l = t; l++, !(l >= s || (u = d = e.bMarks[l] + e.tShift[l], m = e.eMarks[l], u < m && e.tShift[l] < e.blkIndent)); ) if (e.src.charCodeAt(u) === r && !(e.tShift[l] - e.blkIndent >= 4) && (u = e.skipChars(u, r), !(u - d < i) && (u = e.skipSpaces(u), !(u < m)))) {
    c = !0;
    break;
  }
  return i = e.tShift[t], e.line = l + (c ? 1 : 0), e.tokens.push({
    type: "fence",
    params: o,
    content: e.getLines(t + 1, l, i, !0),
    lines: [t, e.line],
    level: e.level
  }), !0;
}
function SNe(e, t, s, n) {
  var r, i, o, l, d, c, u, m, f, v, b, w = e.bMarks[t] + e.tShift[t], S = e.eMarks[t];
  if (w > S || e.src.charCodeAt(w++) !== 62 || e.level >= e.options.maxNesting) return !1;
  if (n) return !0;
  for (e.src.charCodeAt(w) === 32 && w++, d = e.blkIndent, e.blkIndent = 0, l = [e.bMarks[t]], e.bMarks[t] = w, w = w < S ? e.skipSpaces(w) : w, i = w >= S, o = [e.tShift[t]], e.tShift[t] = w - e.bMarks[t], m = e.parser.ruler.getRules("blockquote"), r = t + 1; r < s && (w = e.bMarks[r] + e.tShift[r], S = e.eMarks[r], !(w >= S)); r++) {
    if (e.src.charCodeAt(w++) === 62) {
      e.src.charCodeAt(w) === 32 && w++, l.push(e.bMarks[r]), e.bMarks[r] = w, w = w < S ? e.skipSpaces(w) : w, i = w >= S, o.push(e.tShift[r]), e.tShift[r] = w - e.bMarks[r];
      continue;
    }
    if (i) break;
    for (b = !1, f = 0, v = m.length; f < v; f++) if (m[f](e, r, s, !0)) {
      b = !0;
      break;
    }
    if (b) break;
    l.push(e.bMarks[r]), o.push(e.tShift[r]), e.tShift[r] = -1337;
  }
  for (c = e.parentType, e.parentType = "blockquote", e.tokens.push({
    type: "blockquote_open",
    lines: u = [t, 0],
    level: e.level++
  }), e.parser.tokenize(e, t, r), e.tokens.push({
    type: "blockquote_close",
    level: --e.level
  }), e.parentType = c, u[1] = e.line, f = 0; f < o.length; f++) e.bMarks[f + t] = l[f], e.tShift[f + t] = o[f];
  return e.blkIndent = d, !0;
}
function PNe(e, t, s, n) {
  var r, i, o, l = e.bMarks[t], d = e.eMarks[t];
  if (l += e.tShift[t], l > d || (r = e.src.charCodeAt(l++), r !== 42 && r !== 45 && r !== 95)) return !1;
  for (i = 1; l < d; ) {
    if (o = e.src.charCodeAt(l++), o !== r && o !== 32) return !1;
    o === r && i++;
  }
  return i < 3 ? !1 : (n || (e.line = t + 1, e.tokens.push({
    type: "hr",
    lines: [t, e.line],
    level: e.level
  })), !0);
}
function J2(e, t) {
  var s, n, r;
  return n = e.bMarks[t] + e.tShift[t], r = e.eMarks[t], n >= r || (s = e.src.charCodeAt(n++), s !== 42 && s !== 45 && s !== 43) || n < r && e.src.charCodeAt(n) !== 32 ? -1 : n;
}
function $2(e, t) {
  var s, n = e.bMarks[t] + e.tShift[t], r = e.eMarks[t];
  if (n + 1 >= r || (s = e.src.charCodeAt(n++), s < 48 || s > 57)) return -1;
  for (; ; ) {
    if (n >= r) return -1;
    if (s = e.src.charCodeAt(n++), !(s >= 48 && s <= 57)) {
      if (s === 41 || s === 46) break;
      return -1;
    }
  }
  return n < r && e.src.charCodeAt(n) !== 32 ? -1 : n;
}
function kNe(e, t) {
  var s, n, r = e.level + 2;
  for (s = t + 2, n = e.tokens.length - 2; s < n; s++) e.tokens[s].level === r && e.tokens[s].type === "paragraph_open" && (e.tokens[s + 2].tight = !0, e.tokens[s].tight = !0, s += 2);
}
function ENe(e, t, s, n) {
  var r, i, o, l, d, c, u, m, f, v, b, w, S, I, T, x, k, C, O = !0, E, B, M, R;
  if ((m = $2(e, t)) >= 0) S = !0;
  else if ((m = J2(e, t)) >= 0) S = !1;
  else return !1;
  if (e.level >= e.options.maxNesting) return !1;
  if (w = e.src.charCodeAt(m - 1), n) return !0;
  for (T = e.tokens.length, S ? (u = e.bMarks[t] + e.tShift[t], b = Number(e.src.substr(u, m - u - 1)), e.tokens.push({
    type: "ordered_list_open",
    order: b,
    lines: k = [t, 0],
    level: e.level++
  })) : e.tokens.push({
    type: "bullet_list_open",
    lines: k = [t, 0],
    level: e.level++
  }), r = t, x = !1, E = e.parser.ruler.getRules("list"); r < s && (I = e.skipSpaces(m), f = e.eMarks[r], I >= f ? v = 1 : v = I - m, v > 4 && (v = 1), v < 1 && (v = 1), i = m - e.bMarks[r] + v, e.tokens.push({
    type: "list_item_open",
    lines: C = [t, 0],
    level: e.level++
  }), l = e.blkIndent, d = e.tight, o = e.tShift[t], c = e.parentType, e.tShift[t] = I - e.bMarks[t], e.blkIndent = i, e.tight = !0, e.parentType = "list", e.parser.tokenize(e, t, s, !0), (!e.tight || x) && (O = !1), x = e.line - t > 1 && e.isEmpty(e.line - 1), e.blkIndent = l, e.tShift[t] = o, e.tight = d, e.parentType = c, e.tokens.push({
    type: "list_item_close",
    level: --e.level
  }), r = t = e.line, C[1] = r, I = e.bMarks[t], !(r >= s || e.isEmpty(r) || e.tShift[r] < e.blkIndent)); ) {
    for (R = !1, B = 0, M = E.length; B < M; B++) if (E[B](e, r, s, !0)) {
      R = !0;
      break;
    }
    if (R) break;
    if (S) {
      if (m = $2(e, r), m < 0) break;
    } else if (m = J2(e, r), m < 0) break;
    if (w !== e.src.charCodeAt(m - 1)) break;
  }
  return e.tokens.push({
    type: S ? "ordered_list_close" : "bullet_list_close",
    level: --e.level
  }), k[1] = r, e.line = r, O && kNe(e, T), !0;
}
function INe(e, t, s, n) {
  var r, i, o, l, d, c = e.bMarks[t] + e.tShift[t], u = e.eMarks[t];
  if (c + 4 > u || e.src.charCodeAt(c) !== 91 || e.src.charCodeAt(c + 1) !== 94 || e.level >= e.options.maxNesting) return !1;
  for (l = c + 2; l < u; l++) {
    if (e.src.charCodeAt(l) === 32) return !1;
    if (e.src.charCodeAt(l) === 93) break;
  }
  return l === c + 2 || l + 1 >= u || e.src.charCodeAt(++l) !== 58 ? !1 : (n || (l++, e.env.footnotes || (e.env.footnotes = {}), e.env.footnotes.refs || (e.env.footnotes.refs = {}), d = e.src.slice(c + 2, l - 2), e.env.footnotes.refs[":" + d] = -1, e.tokens.push({
    type: "footnote_reference_open",
    label: d,
    level: e.level++
  }), r = e.bMarks[t], i = e.tShift[t], o = e.parentType, e.tShift[t] = e.skipSpaces(l) - l, e.bMarks[t] = l, e.blkIndent += 4, e.parentType = "footnote", e.tShift[t] < e.blkIndent && (e.tShift[t] += e.blkIndent, e.bMarks[t] -= e.blkIndent), e.parser.tokenize(e, t, s, !0), e.parentType = o, e.blkIndent -= 4, e.tShift[t] = i, e.bMarks[t] = r, e.tokens.push({
    type: "footnote_reference_close",
    level: --e.level
  })), !0);
}
function TNe(e, t, s, n) {
  var r, i, o, l = e.bMarks[t] + e.tShift[t], d = e.eMarks[t];
  if (l >= d || (r = e.src.charCodeAt(l), r !== 35 || l >= d)) return !1;
  for (i = 1, r = e.src.charCodeAt(++l); r === 35 && l < d && i <= 6; ) i++, r = e.src.charCodeAt(++l);
  return i > 6 || l < d && r !== 32 ? !1 : (n || (d = e.skipCharsBack(d, 32, l), o = e.skipCharsBack(d, 35, l), o > l && e.src.charCodeAt(o - 1) === 32 && (d = o), e.line = t + 1, e.tokens.push({
    type: "heading_open",
    hLevel: i,
    lines: [t, e.line],
    level: e.level
  }), l < d && e.tokens.push({
    type: "inline",
    content: e.src.slice(l, d).trim(),
    level: e.level + 1,
    lines: [t, e.line],
    children: []
  }), e.tokens.push({
    type: "heading_close",
    hLevel: i,
    level: e.level
  })), !0);
}
function ONe(e, t, s) {
  var n, r, i, o = t + 1;
  return o >= s || e.tShift[o] < e.blkIndent || e.tShift[o] - e.blkIndent > 3 || (r = e.bMarks[o] + e.tShift[o], i = e.eMarks[o], r >= i) || (n = e.src.charCodeAt(r), n !== 45 && n !== 61) || (r = e.skipChars(r, n), r = e.skipSpaces(r), r < i) ? !1 : (r = e.bMarks[t] + e.tShift[t], e.line = o + 1, e.tokens.push({
    type: "heading_open",
    hLevel: n === 61 ? 1 : 2,
    lines: [t, e.line],
    level: e.level
  }), e.tokens.push({
    type: "inline",
    content: e.src.slice(r, e.eMarks[t]).trim(),
    level: e.level + 1,
    lines: [t, e.line - 1],
    children: []
  }), e.tokens.push({
    type: "heading_close",
    hLevel: n === 61 ? 1 : 2,
    level: e.level
  }), !0);
}
var v5 = {};
["article", "aside", "button", "blockquote", "body", "canvas", "caption", "col", "colgroup", "dd", "div", "dl", "dt", "embed", "fieldset", "figcaption", "figure", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "header", "hgroup", "hr", "iframe", "li", "map", "object", "ol", "output", "p", "pre", "progress", "script", "section", "style", "table", "tbody", "td", "textarea", "tfoot", "th", "tr", "thead", "ul", "video"].forEach(function(e) {
  v5[e] = !0;
});
var RNe = /^<([a-zA-Z]{1,15})[\s\/>]/, LNe = /^<\/([a-zA-Z]{1,15})[\s>]/;
function BNe(e) {
  var t = e | 32;
  return t >= 97 && t <= 122;
}
function MNe(e, t, s, n) {
  var r, i, o, l = e.bMarks[t], d = e.eMarks[t], c = e.tShift[t];
  if (l += c, !e.options.html || c > 3 || l + 2 >= d || e.src.charCodeAt(l) !== 60) return !1;
  if (r = e.src.charCodeAt(l + 1), r === 33 || r === 63) {
    if (n) return !0;
  } else if (r === 47 || BNe(r)) {
    if (r === 47) {
      if (i = e.src.slice(l, d).match(LNe), !i) return !1;
    } else if (i = e.src.slice(l, d).match(RNe), !i) return !1;
    if (v5[i[1].toLowerCase()] !== !0) return !1;
    if (n) return !0;
  } else return !1;
  for (o = t + 1; o < e.lineMax && !e.isEmpty(o); ) o++;
  return e.line = o, e.tokens.push({
    type: "htmlblock",
    level: e.level,
    lines: [t, e.line],
    content: e.getLines(t, o, 0, !0)
  }), !0;
}
function Ng(e, t) {
  var s = e.bMarks[t] + e.blkIndent, n = e.eMarks[t];
  return e.src.substr(s, n - s);
}
function xNe(e, t, s, n) {
  var r, i, o, l, d, c, u, m, f, v, b;
  if (t + 2 > s || (d = t + 1, e.tShift[d] < e.blkIndent) || (o = e.bMarks[d] + e.tShift[d], o >= e.eMarks[d]) || (r = e.src.charCodeAt(o), r !== 124 && r !== 45 && r !== 58) || (i = Ng(e, t + 1), !/^[-:| ]+$/.test(i)) || (c = i.split("|"), c <= 2)) return !1;
  for (m = [], l = 0; l < c.length; l++) {
    if (f = c[l].trim(), !f) {
      if (l === 0 || l === c.length - 1) continue;
      return !1;
    }
    if (!/^:?-+:?$/.test(f)) return !1;
    f.charCodeAt(f.length - 1) === 58 ? m.push(f.charCodeAt(0) === 58 ? "center" : "right") : f.charCodeAt(0) === 58 ? m.push("left") : m.push("");
  }
  if (i = Ng(e, t).trim(), i.indexOf("|") === -1 || (c = i.replace(/^\||\|$/g, "").split("|"), m.length !== c.length)) return !1;
  if (n) return !0;
  for (e.tokens.push({
    type: "table_open",
    lines: v = [t, 0],
    level: e.level++
  }), e.tokens.push({
    type: "thead_open",
    lines: [t, t + 1],
    level: e.level++
  }), e.tokens.push({
    type: "tr_open",
    lines: [t, t + 1],
    level: e.level++
  }), l = 0; l < c.length; l++) e.tokens.push({
    type: "th_open",
    align: m[l],
    lines: [t, t + 1],
    level: e.level++
  }), e.tokens.push({
    type: "inline",
    content: c[l].trim(),
    lines: [t, t + 1],
    level: e.level,
    children: []
  }), e.tokens.push({
    type: "th_close",
    level: --e.level
  });
  for (e.tokens.push({
    type: "tr_close",
    level: --e.level
  }), e.tokens.push({
    type: "thead_close",
    level: --e.level
  }), e.tokens.push({
    type: "tbody_open",
    lines: b = [t + 2, 0],
    level: e.level++
  }), d = t + 2; d < s && !(e.tShift[d] < e.blkIndent || (i = Ng(e, d).trim(), i.indexOf("|") === -1)); d++) {
    for (c = i.replace(/^\||\|$/g, "").split("|"), e.tokens.push({
      type: "tr_open",
      level: e.level++
    }), l = 0; l < c.length; l++) e.tokens.push({
      type: "td_open",
      align: m[l],
      level: e.level++
    }), u = c[l].substring(c[l].charCodeAt(0) === 124 ? 1 : 0, c[l].charCodeAt(c[l].length - 1) === 124 ? c[l].length - 1 : c[l].length).trim(), e.tokens.push({
      type: "inline",
      content: u,
      level: e.level,
      children: []
    }), e.tokens.push({
      type: "td_close",
      level: --e.level
    });
    e.tokens.push({
      type: "tr_close",
      level: --e.level
    });
  }
  return e.tokens.push({
    type: "tbody_close",
    level: --e.level
  }), e.tokens.push({
    type: "table_close",
    level: --e.level
  }), v[1] = b[1] = d, e.line = d, !0;
}
function Dp(e, t) {
  var s, n, r = e.bMarks[t] + e.tShift[t], i = e.eMarks[t];
  return r >= i || (n = e.src.charCodeAt(r++), n !== 126 && n !== 58) || (s = e.skipSpaces(r), r === s) || s >= i ? -1 : s;
}
function FNe(e, t) {
  var s, n, r = e.level + 2;
  for (s = t + 2, n = e.tokens.length - 2; s < n; s++) e.tokens[s].level === r && e.tokens[s].type === "paragraph_open" && (e.tokens[s + 2].tight = !0, e.tokens[s].tight = !0, s += 2);
}
function VNe(e, t, s, n) {
  var r, i, o, l, d, c, u, m, f, v, b, w, S, I;
  if (n) return e.ddIndent < 0 ? !1 : Dp(e, t) >= 0;
  if (u = t + 1, e.isEmpty(u) && ++u > s || e.tShift[u] < e.blkIndent || (r = Dp(e, u), r < 0) || e.level >= e.options.maxNesting) return !1;
  c = e.tokens.length, e.tokens.push({
    type: "dl_open",
    lines: d = [t, 0],
    level: e.level++
  }), o = t, i = u;
  e: for (; ; ) {
    for (I = !0, S = !1, e.tokens.push({
      type: "dt_open",
      lines: [o, o],
      level: e.level++
    }), e.tokens.push({
      type: "inline",
      content: e.getLines(o, o + 1, e.blkIndent, !1).trim(),
      level: e.level + 1,
      lines: [o, o],
      children: []
    }), e.tokens.push({
      type: "dt_close",
      level: --e.level
    }); ; ) {
      if (e.tokens.push({
        type: "dd_open",
        lines: l = [u, 0],
        level: e.level++
      }), w = e.tight, f = e.ddIndent, m = e.blkIndent, b = e.tShift[i], v = e.parentType, e.blkIndent = e.ddIndent = e.tShift[i] + 2, e.tShift[i] = r - e.bMarks[i], e.tight = !0, e.parentType = "deflist", e.parser.tokenize(e, i, s, !0), (!e.tight || S) && (I = !1), S = e.line - i > 1 && e.isEmpty(e.line - 1), e.tShift[i] = b, e.tight = w, e.parentType = v, e.blkIndent = m, e.ddIndent = f, e.tokens.push({
        type: "dd_close",
        level: --e.level
      }), l[1] = u = e.line, u >= s || e.tShift[u] < e.blkIndent) break e;
      if (r = Dp(e, u), r < 0) break;
      i = u;
    }
    if (u >= s || (o = u, e.isEmpty(o)) || e.tShift[o] < e.blkIndent || (i = o + 1, i >= s) || (e.isEmpty(i) && i++, i >= s) || e.tShift[i] < e.blkIndent || (r = Dp(e, i), r < 0)) break;
  }
  return e.tokens.push({
    type: "dl_close",
    level: --e.level
  }), d[1] = u, e.line = u, I && FNe(e, c), !0;
}
function DNe(e, t) {
  var s, n, r, i, o, l = t + 1, d;
  if (s = e.lineMax, l < s && !e.isEmpty(l)) {
    for (d = e.parser.ruler.getRules("paragraph"); l < s && !e.isEmpty(l); l++) if (!(e.tShift[l] - e.blkIndent > 3)) {
      for (r = !1, i = 0, o = d.length; i < o; i++) if (d[i](e, l, s, !0)) {
        r = !0;
        break;
      }
      if (r) break;
    }
  }
  return n = e.getLines(t, l, e.blkIndent, !1).trim(), e.line = l, n.length && (e.tokens.push({
    type: "paragraph_open",
    tight: !1,
    lines: [t, e.line],
    level: e.level
  }), e.tokens.push({
    type: "inline",
    content: n,
    level: e.level + 1,
    lines: [t, e.line],
    children: []
  }), e.tokens.push({
    type: "paragraph_close",
    tight: !1,
    level: e.level
  })), !0;
}
var Np = [["code", wNe], ["fences", CNe, ["paragraph", "blockquote", "list"]], ["blockquote", SNe, ["paragraph", "blockquote", "list"]], ["hr", PNe, ["paragraph", "blockquote", "list"]], ["list", ENe, ["paragraph", "blockquote"]], ["footnote", INe, ["paragraph"]], ["heading", TNe, ["paragraph", "blockquote"]], ["lheading", ONe], ["htmlblock", MNe, ["paragraph", "blockquote"]], ["table", xNe, ["paragraph"]], ["deflist", VNe, ["paragraph"]], ["paragraph", DNe]];
function Ob() {
  this.ruler = new Gn();
  for (var e = 0; e < Np.length; e++) this.ruler.push(Np[e][0], Np[e][1], {
    alt: (Np[e][2] || []).slice()
  });
}
Ob.prototype.tokenize = function(e, t, s) {
  for (var n = this.ruler.getRules(""), r = n.length, i = t, o = !1, l, d; i < s && (e.line = i = e.skipEmptyLines(i), !(i >= s || e.tShift[i] < e.blkIndent)); ) {
    for (d = 0; d < r && (l = n[d](e, i, s, !1), !l); d++) ;
    if (e.tight = !o, e.isEmpty(e.line - 1) && (o = !0), i = e.line, i < s && e.isEmpty(i)) {
      if (o = !0, i++, i < s && e.parentType === "list" && e.isEmpty(i)) break;
      e.line = i;
    }
  }
};
var NNe = /[\n\t]/g, jNe = /\r[\n\u0085]|[\u2424\u2028\u0085]/g, HNe = /\u00a0/g;
Ob.prototype.parse = function(e, t, s, n) {
  var r, i = 0, o = 0;
  if (!e) return [];
  e = e.replace(HNe, " "), e = e.replace(jNe, `
`), e.indexOf("	") >= 0 && (e = e.replace(NNe, function(l, d) {
    var c;
    return e.charCodeAt(d) === 10 ? (i = d + 1, o = 0, l) : (c = "    ".slice((d - i - o) % 4), o = d - i + 1, c);
  })), r = new Pl(e, this, t, s, n), this.tokenize(r, r.line, r.lineMax);
};
function UNe(e) {
  switch (e) {
    case 10:
    case 92:
    case 96:
    case 42:
    case 95:
    case 94:
    case 91:
    case 93:
    case 33:
    case 38:
    case 60:
    case 62:
    case 123:
    case 125:
    case 36:
    case 37:
    case 64:
    case 126:
    case 43:
    case 61:
    case 58:
      return !0;
    default:
      return !1;
  }
}
function zNe(e, t) {
  for (var s = e.pos; s < e.posMax && !UNe(e.src.charCodeAt(s)); ) s++;
  return s === e.pos ? !1 : (t || (e.pending += e.src.slice(e.pos, s)), e.pos = s, !0);
}
function WNe(e, t) {
  var s, n, r = e.pos;
  if (e.src.charCodeAt(r) !== 10) return !1;
  if (s = e.pending.length - 1, n = e.posMax, !t) if (s >= 0 && e.pending.charCodeAt(s) === 32)
    if (s >= 1 && e.pending.charCodeAt(s - 1) === 32) {
      for (var i = s - 2; i >= 0; i--) if (e.pending.charCodeAt(i) !== 32) {
        e.pending = e.pending.substring(0, i + 1);
        break;
      }
      e.push({
        type: "hardbreak",
        level: e.level
      });
    } else e.pending = e.pending.slice(0, -1), e.push({
      type: "softbreak",
      level: e.level
    });
  else e.push({
    type: "softbreak",
    level: e.level
  });
  for (r++; r < n && e.src.charCodeAt(r) === 32; ) r++;
  return e.pos = r, !0;
}
var Rb = [];
for (var _2 = 0; _2 < 256; _2++) Rb.push(0);
"\\!\"#$%&'()*+,./:;<=>?@[]^_`{|}~-".split("").forEach(function(e) {
  Rb[e.charCodeAt(0)] = 1;
});
function GNe(e, t) {
  var s, n = e.pos, r = e.posMax;
  if (e.src.charCodeAt(n) !== 92) return !1;
  if (n++, n < r) {
    if (s = e.src.charCodeAt(n), s < 256 && Rb[s] !== 0) return t || (e.pending += e.src[n]), e.pos += 2, !0;
    if (s === 10) {
      for (t || e.push({
        type: "hardbreak",
        level: e.level
      }), n++; n < r && e.src.charCodeAt(n) === 32; ) n++;
      return e.pos = n, !0;
    }
  }
  return t || (e.pending += "\\"), e.pos++, !0;
}
function YNe(e, t) {
  var s, n, r, i, o, l = e.pos, d = e.src.charCodeAt(l);
  if (d !== 96) return !1;
  for (s = l, l++, n = e.posMax; l < n && e.src.charCodeAt(l) === 96; ) l++;
  for (r = e.src.slice(s, l), i = o = l; (i = e.src.indexOf("`", o)) !== -1; ) {
    for (o = i + 1; o < n && e.src.charCodeAt(o) === 96; ) o++;
    if (o - i === r.length) return t || e.push({
      type: "code",
      content: e.src.slice(l, i).replace(/[ \n]+/g, " ").trim(),
      block: !1,
      level: e.level
    }), e.pos = o, !0;
  }
  return t || (e.pending += r), e.pos += r.length, !0;
}
function XNe(e, t) {
  var s, n, r, i = e.posMax, o = e.pos, l, d;
  if (e.src.charCodeAt(o) !== 126 || t || o + 4 >= i || e.src.charCodeAt(o + 1) !== 126 || e.level >= e.options.maxNesting || (l = o > 0 ? e.src.charCodeAt(o - 1) : -1, d = e.src.charCodeAt(o + 2), l === 126) || d === 126 || d === 32 || d === 10) return !1;
  for (n = o + 2; n < i && e.src.charCodeAt(n) === 126; ) n++;
  if (n > o + 3) return e.pos += n - o, t || (e.pending += e.src.slice(o, n)), !0;
  for (e.pos = o + 2, r = 1; e.pos + 1 < i; ) {
    if (e.src.charCodeAt(e.pos) === 126 && e.src.charCodeAt(e.pos + 1) === 126 && (l = e.src.charCodeAt(e.pos - 1), d = e.pos + 2 < i ? e.src.charCodeAt(e.pos + 2) : -1, d !== 126 && l !== 126 && (l !== 32 && l !== 10 ? r-- : d !== 32 && d !== 10 && r++, r <= 0))) {
      s = !0;
      break;
    }
    e.parser.skipToken(e);
  }
  return s ? (e.posMax = e.pos, e.pos = o + 2, t || (e.push({
    type: "del_open",
    level: e.level++
  }), e.parser.tokenize(e), e.push({
    type: "del_close",
    level: --e.level
  })), e.pos = e.posMax + 2, e.posMax = i, !0) : (e.pos = o, !1);
}
function qNe(e, t) {
  var s, n, r, i = e.posMax, o = e.pos, l, d;
  if (e.src.charCodeAt(o) !== 43 || t || o + 4 >= i || e.src.charCodeAt(o + 1) !== 43 || e.level >= e.options.maxNesting || (l = o > 0 ? e.src.charCodeAt(o - 1) : -1, d = e.src.charCodeAt(o + 2), l === 43) || d === 43 || d === 32 || d === 10) return !1;
  for (n = o + 2; n < i && e.src.charCodeAt(n) === 43; ) n++;
  if (n !== o + 2) return e.pos += n - o, t || (e.pending += e.src.slice(o, n)), !0;
  for (e.pos = o + 2, r = 1; e.pos + 1 < i; ) {
    if (e.src.charCodeAt(e.pos) === 43 && e.src.charCodeAt(e.pos + 1) === 43 && (l = e.src.charCodeAt(e.pos - 1), d = e.pos + 2 < i ? e.src.charCodeAt(e.pos + 2) : -1, d !== 43 && l !== 43 && (l !== 32 && l !== 10 ? r-- : d !== 32 && d !== 10 && r++, r <= 0))) {
      s = !0;
      break;
    }
    e.parser.skipToken(e);
  }
  return s ? (e.posMax = e.pos, e.pos = o + 2, t || (e.push({
    type: "ins_open",
    level: e.level++
  }), e.parser.tokenize(e), e.push({
    type: "ins_close",
    level: --e.level
  })), e.pos = e.posMax + 2, e.posMax = i, !0) : (e.pos = o, !1);
}
function QNe(e, t) {
  var s, n, r, i = e.posMax, o = e.pos, l, d;
  if (e.src.charCodeAt(o) !== 61 || t || o + 4 >= i || e.src.charCodeAt(o + 1) !== 61 || e.level >= e.options.maxNesting || (l = o > 0 ? e.src.charCodeAt(o - 1) : -1, d = e.src.charCodeAt(o + 2), l === 61) || d === 61 || d === 32 || d === 10) return !1;
  for (n = o + 2; n < i && e.src.charCodeAt(n) === 61; ) n++;
  if (n !== o + 2) return e.pos += n - o, t || (e.pending += e.src.slice(o, n)), !0;
  for (e.pos = o + 2, r = 1; e.pos + 1 < i; ) {
    if (e.src.charCodeAt(e.pos) === 61 && e.src.charCodeAt(e.pos + 1) === 61 && (l = e.src.charCodeAt(e.pos - 1), d = e.pos + 2 < i ? e.src.charCodeAt(e.pos + 2) : -1, d !== 61 && l !== 61 && (l !== 32 && l !== 10 ? r-- : d !== 32 && d !== 10 && r++, r <= 0))) {
      s = !0;
      break;
    }
    e.parser.skipToken(e);
  }
  return s ? (e.posMax = e.pos, e.pos = o + 2, t || (e.push({
    type: "mark_open",
    level: e.level++
  }), e.parser.tokenize(e), e.push({
    type: "mark_close",
    level: --e.level
  })), e.pos = e.posMax + 2, e.posMax = i, !0) : (e.pos = o, !1);
}
function eC(e) {
  return e >= 48 && e <= 57 || e >= 65 && e <= 90 || e >= 97 && e <= 122;
}
function tC(e, t) {
  var s = t, n, r, i, o = !0, l = !0, d = e.posMax, c = e.src.charCodeAt(t);
  for (n = t > 0 ? e.src.charCodeAt(t - 1) : -1; s < d && e.src.charCodeAt(s) === c; ) s++;
  return s >= d && (o = !1), i = s - t, i >= 4 ? o = l = !1 : (r = s < d ? e.src.charCodeAt(s) : -1, (r === 32 || r === 10) && (o = !1), (n === 32 || n === 10) && (l = !1), c === 95 && (eC(n) && (o = !1), eC(r) && (l = !1))), {
    can_open: o,
    can_close: l,
    delims: i
  };
}
function KNe(e, t) {
  var s, n, r, i, o, l, d, c = e.posMax, u = e.pos, m = e.src.charCodeAt(u);
  if (m !== 95 && m !== 42 || t) return !1;
  if (d = tC(e, u), s = d.delims, !d.can_open) return e.pos += s, t || (e.pending += e.src.slice(u, e.pos)), !0;
  if (e.level >= e.options.maxNesting) return !1;
  for (e.pos = u + s, l = [s]; e.pos < c; ) {
    if (e.src.charCodeAt(e.pos) === m) {
      if (d = tC(e, e.pos), n = d.delims, d.can_close) {
        for (i = l.pop(), o = n; i !== o; ) {
          if (o < i) {
            l.push(i - o);
            break;
          }
          if (o -= i, l.length === 0) break;
          e.pos += i, i = l.pop();
        }
        if (l.length === 0) {
          s = i, r = !0;
          break;
        }
        e.pos += n;
        continue;
      }
      d.can_open && l.push(n), e.pos += n;
      continue;
    }
    e.parser.skipToken(e);
  }
  return r ? (e.posMax = e.pos, e.pos = u + s, t || ((s === 2 || s === 3) && e.push({
    type: "strong_open",
    level: e.level++
  }), (s === 1 || s === 3) && e.push({
    type: "em_open",
    level: e.level++
  }), e.parser.tokenize(e), (s === 1 || s === 3) && e.push({
    type: "em_close",
    level: --e.level
  }), (s === 2 || s === 3) && e.push({
    type: "strong_close",
    level: --e.level
  })), e.pos = e.posMax + s, e.posMax = c, !0) : (e.pos = u, !1);
}
var ZNe = /\\([ \\!"#$%&'()*+,.\/:;<=>?@[\]^_`{|}~-])/g;
function JNe(e, t) {
  var s, n, r = e.posMax, i = e.pos;
  if (e.src.charCodeAt(i) !== 126 || t || i + 2 >= r || e.level >= e.options.maxNesting) return !1;
  for (e.pos = i + 1; e.pos < r; ) {
    if (e.src.charCodeAt(e.pos) === 126) {
      s = !0;
      break;
    }
    e.parser.skipToken(e);
  }
  return !s || i + 1 === e.pos || (n = e.src.slice(i + 1, e.pos), n.match(/(^|[^\\])(\\\\)*\s/)) ? (e.pos = i, !1) : (e.posMax = e.pos, e.pos = i + 1, t || e.push({
    type: "sub",
    level: e.level,
    content: n.replace(ZNe, "$1")
  }), e.pos = e.posMax + 1, e.posMax = r, !0);
}
var $Ne = /\\([ \\!"#$%&'()*+,.\/:;<=>?@[\]^_`{|}~-])/g;
function _Ne(e, t) {
  var s, n, r = e.posMax, i = e.pos;
  if (e.src.charCodeAt(i) !== 94 || t || i + 2 >= r || e.level >= e.options.maxNesting) return !1;
  for (e.pos = i + 1; e.pos < r; ) {
    if (e.src.charCodeAt(e.pos) === 94) {
      s = !0;
      break;
    }
    e.parser.skipToken(e);
  }
  return !s || i + 1 === e.pos || (n = e.src.slice(i + 1, e.pos), n.match(/(^|[^\\])(\\\\)*\s/)) ? (e.pos = i, !1) : (e.posMax = e.pos, e.pos = i + 1, t || e.push({
    type: "sup",
    level: e.level,
    content: n.replace($Ne, "$1")
  }), e.pos = e.posMax + 1, e.posMax = r, !0);
}
function eje(e, t) {
  var s, n, r, i, o, l, d, c, u = !1, m = e.pos, f = e.posMax, v = e.pos, b = e.src.charCodeAt(v);
  if (b === 33 && (u = !0, b = e.src.charCodeAt(++v)), b !== 91 || e.level >= e.options.maxNesting || (s = v + 1, n = Su(e, v), n < 0)) return !1;
  if (l = n + 1, l < f && e.src.charCodeAt(l) === 40) {
    for (l++; l < f && (c = e.src.charCodeAt(l), !(c !== 32 && c !== 10)); l++) ;
    if (l >= f) return !1;
    for (v = l, h5(e, l) ? (i = e.linkContent, l = e.pos) : i = "", v = l; l < f && (c = e.src.charCodeAt(l), !(c !== 32 && c !== 10)); l++) ;
    if (l < f && v !== l && m5(e, l)) for (o = e.linkContent, l = e.pos; l < f && (c = e.src.charCodeAt(l), !(c !== 32 && c !== 10)); l++) ;
    else o = "";
    if (l >= f || e.src.charCodeAt(l) !== 41) return e.pos = m, !1;
    l++;
  } else {
    if (e.linkLevel > 0) return !1;
    for (; l < f && (c = e.src.charCodeAt(l), !(c !== 32 && c !== 10)); l++) ;
    if (l < f && e.src.charCodeAt(l) === 91 && (v = l + 1, l = Su(e, l), l >= 0 ? r = e.src.slice(v, l++) : l = v - 1), r || (St(r) > "u" && (l = n + 1), r = e.src.slice(s, n)), d = e.env.references[f5(r)], !d) return e.pos = m, !1;
    i = d.href, o = d.title;
  }
  return t || (e.pos = s, e.posMax = n, u ? e.push({
    type: "image",
    src: i,
    title: o,
    alt: e.src.substr(s, n - s),
    level: e.level
  }) : (e.push({
    type: "link_open",
    href: i,
    title: o,
    level: e.level++
  }), e.linkLevel++, e.parser.tokenize(e), e.linkLevel--, e.push({
    type: "link_close",
    level: --e.level
  }))), e.pos = l, e.posMax = f, !0;
}
function tje(e, t) {
  var s, n, r, i, o = e.posMax, l = e.pos;
  return l + 2 >= o || e.src.charCodeAt(l) !== 94 || e.src.charCodeAt(l + 1) !== 91 || e.level >= e.options.maxNesting || (s = l + 2, n = Su(e, l + 1), n < 0) ? !1 : (t || (e.env.footnotes || (e.env.footnotes = {}), e.env.footnotes.list || (e.env.footnotes.list = []), r = e.env.footnotes.list.length, e.pos = s, e.posMax = n, e.push({
    type: "footnote_ref",
    id: r,
    level: e.level
  }), e.linkLevel++, i = e.tokens.length, e.parser.tokenize(e), e.env.footnotes.list[r] = {
    tokens: e.tokens.splice(i)
  }, e.linkLevel--), e.pos = n + 1, e.posMax = o, !0);
}
function sje(e, t) {
  var s, n, r, i, o = e.posMax, l = e.pos;
  if (l + 3 > o || !e.env.footnotes || !e.env.footnotes.refs || e.src.charCodeAt(l) !== 91 || e.src.charCodeAt(l + 1) !== 94 || e.level >= e.options.maxNesting) return !1;
  for (n = l + 2; n < o; n++) {
    if (e.src.charCodeAt(n) === 32 || e.src.charCodeAt(n) === 10) return !1;
    if (e.src.charCodeAt(n) === 93) break;
  }
  return n === l + 2 || n >= o || (n++, s = e.src.slice(l + 2, n - 1), St(e.env.footnotes.refs[":" + s]) > "u") ? !1 : (t || (e.env.footnotes.list || (e.env.footnotes.list = []), e.env.footnotes.refs[":" + s] < 0 ? (r = e.env.footnotes.list.length, e.env.footnotes.list[r] = {
    label: s,
    count: 0
  }, e.env.footnotes.refs[":" + s] = r) : r = e.env.footnotes.refs[":" + s], i = e.env.footnotes.list[r].count, e.env.footnotes.list[r].count++, e.push({
    type: "footnote_ref",
    id: r,
    subId: i,
    level: e.level
  })), e.pos = n, e.posMax = o, !0);
}
var aje = ["coap", "doi", "javascript", "aaa", "aaas", "about", "acap", "cap", "cid", "crid", "data", "dav", "dict", "dns", "file", "ftp", "geo", "go", "gopher", "h323", "http", "https", "iax", "icap", "im", "imap", "info", "ipp", "iris", "iris.beep", "iris.xpc", "iris.xpcs", "iris.lwz", "ldap", "mailto", "mid", "msrp", "msrps", "mtqp", "mupdate", "news", "nfs", "ni", "nih", "nntp", "opaquelocktoken", "pop", "pres", "rtsp", "service", "session", "shttp", "sieve", "sip", "sips", "sms", "snmp", "soap.beep", "soap.beeps", "tag", "tel", "telnet", "tftp", "thismessage", "tn3270", "tip", "tv", "urn", "vemmi", "ws", "wss", "xcon", "xcon-userid", "xmlrpc.beep", "xmlrpc.beeps", "xmpp", "z39.50r", "z39.50s", "adiumxtra", "afp", "afs", "aim", "apt", "attachment", "aw", "beshare", "bitcoin", "bolo", "callto", "chrome", "chrome-extension", "com-eventbrite-attendee", "content", "cvs", "dlna-playsingle", "dlna-playcontainer", "dtn", "dvb", "ed2k", "facetime", "feed", "finger", "fish", "gg", "git", "gizmoproject", "gtalk", "hcp", "icon", "ipn", "irc", "irc6", "ircs", "itms", "jar", "jms", "keyparc", "lastfm", "ldaps", "magnet", "maps", "market", "message", "mms", "ms-help", "msnim", "mumble", "mvn", "notes", "oid", "palm", "paparazzi", "platform", "proxy", "psyc", "query", "res", "resource", "rmi", "rsync", "rtmp", "secondlife", "sftp", "sgn", "skype", "smb", "soldat", "spotify", "ssh", "steam", "svn", "teamspeak", "things", "udp", "unreal", "ut2004", "ventrilo", "view-source", "webcal", "wtai", "wyciwyg", "xfire", "xri", "ymsgr"], nje = /^<([a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*)>/, rje = /^<([a-zA-Z.\-]{1,25}):([^<>\x00-\x20]*)>/;
function oje(e, t) {
  var s, n, r, i, o, l = e.pos;
  return e.src.charCodeAt(l) !== 60 || (s = e.src.slice(l), s.indexOf(">") < 0) ? !1 : (n = s.match(rje), n ? aje.indexOf(n[1].toLowerCase()) < 0 || (i = n[0].slice(1, -1), o = Cy(i), !e.parser.validateLink(i)) ? !1 : (t || (e.push({
    type: "link_open",
    href: o,
    level: e.level
  }), e.push({
    type: "text",
    content: i,
    level: e.level + 1
  }), e.push({
    type: "link_close",
    level: e.level
  })), e.pos += n[0].length, !0) : (r = s.match(nje), r ? (i = r[0].slice(1, -1), o = Cy("mailto:" + i), e.parser.validateLink(o) ? (t || (e.push({
    type: "link_open",
    href: o,
    level: e.level
  }), e.push({
    type: "text",
    content: i,
    level: e.level + 1
  }), e.push({
    type: "link_close",
    level: e.level
  })), e.pos += r[0].length, !0) : !1) : !1));
}
function gf(e, t) {
  return e = e.source, t = t || "", function s(n, r) {
    return n ? (r = r.source || r, e = e.replace(n, r), s) : new RegExp(e, t);
  };
}
var ije = /[a-zA-Z_:][a-zA-Z0-9:._-]*/, lje = /[^"'=<>`\x00-\x20]+/, dje = /'[^']*'/, cje = /"[^"]*"/, uje = gf(/(?:unquoted|single_quoted|double_quoted)/)("unquoted", lje)("single_quoted", dje)("double_quoted", cje)(), pje = gf(/(?:\s+attr_name(?:\s*=\s*attr_value)?)/)("attr_name", ije)("attr_value", uje)(), hje = gf(/<[A-Za-z][A-Za-z0-9]*attribute*\s*\/?>/)("attribute", pje)(), mje = /<\/[A-Za-z][A-Za-z0-9]*\s*>/, fje = /<!---->|<!--(?:-?[^>-])(?:-?[^-])*-->/, gje = /<[?].*?[?]>/, vje = /<![A-Z]+\s+[^>]*>/, yje = /<!\[CDATA\[[\s\S]*?\]\]>/, bje = gf(/^(?:open_tag|close_tag|comment|processing|declaration|cdata)/)("open_tag", hje)("close_tag", mje)("comment", fje)("processing", gje)("declaration", vje)("cdata", yje)();
function Aje(e) {
  var t = e | 32;
  return t >= 97 && t <= 122;
}
function wje(e, t) {
  var s, n, r, i = e.pos;
  return !e.options.html || (r = e.posMax, e.src.charCodeAt(i) !== 60 || i + 2 >= r) || (s = e.src.charCodeAt(i + 1), s !== 33 && s !== 63 && s !== 47 && !Aje(s)) || (n = e.src.slice(i).match(bje), !n) ? !1 : (t || e.push({
    type: "htmltag",
    content: e.src.slice(i, i + n[0].length),
    level: e.level
  }), e.pos += n[0].length, !0);
}
var Cje = /^&#((?:x[a-f0-9]{1,8}|[0-9]{1,8}));/i, Sje = /^&([a-z][a-z0-9]{1,31});/i;
function Pje(e, t) {
  var s, n, r, i = e.pos, o = e.posMax;
  if (e.src.charCodeAt(i) !== 38) return !1;
  if (i + 1 < o) {
    if (s = e.src.charCodeAt(i + 1), s === 35) {
      if (r = e.src.slice(i).match(Cje), r) return t || (n = r[1][0].toLowerCase() === "x" ? parseInt(r[1].slice(1), 16) : parseInt(r[1], 10), e.pending += u5(n) ? wy(n) : wy(65533)), e.pos += r[0].length, !0;
    } else if (r = e.src.slice(i).match(Sje), r) {
      var l = d5(r[1]);
      if (r[1] !== l) return t || (e.pending += l), e.pos += r[0].length, !0;
    }
  }
  return t || (e.pending += "&"), e.pos++, !0;
}
var jg = [["text", zNe], ["newline", WNe], ["escape", GNe], ["backticks", YNe], ["del", XNe], ["ins", qNe], ["mark", QNe], ["emphasis", KNe], ["sub", JNe], ["sup", _Ne], ["links", eje], ["footnote_inline", tje], ["footnote_ref", sje], ["autolink", oje], ["htmltag", wje], ["entity", Pje]];
function vf() {
  this.ruler = new Gn();
  for (var e = 0; e < jg.length; e++) this.ruler.push(jg[e][0], jg[e][1]);
  this.validateLink = kje;
}
vf.prototype.skipToken = function(e) {
  var t = this.ruler.getRules(""), s = t.length, n = e.pos, r, i;
  if ((i = e.cacheGet(n)) > 0) {
    e.pos = i;
    return;
  }
  for (r = 0; r < s; r++) if (t[r](e, !0)) {
    e.cacheSet(n, e.pos);
    return;
  }
  e.pos++, e.cacheSet(n, e.pos);
};
vf.prototype.tokenize = function(e) {
  for (var t = this.ruler.getRules(""), s = t.length, n = e.posMax, r, i; e.pos < n; ) {
    for (i = 0; i < s && (r = t[i](e, !1), !r); i++) ;
    if (r) {
      if (e.pos >= n) break;
      continue;
    }
    e.pending += e.src[e.pos++];
  }
  e.pending && e.pushPending();
};
vf.prototype.parse = function(e, t, s, n) {
  var r = new Sl(e, this, t, s, n);
  this.tokenize(r);
};
function kje(e) {
  var t = ["vbscript", "javascript", "file", "data"], s = e.trim().toLowerCase();
  return s = cl(s), !(s.indexOf(":") !== -1 && t.indexOf(s.split(":")[0]) !== -1);
}
var Eje = {
  options: {
    html: !1,
    // Enable HTML tags in source
    xhtmlOut: !1,
    // Use '/' to close single tags (<br />)
    breaks: !1,
    // Convert '\n' in paragraphs into <br>
    langPrefix: "language-",
    // CSS language prefix for fenced blocks
    linkTarget: "",
    // set target to open link in
    // Enable some language-neutral replacements + quotes beautification
    typographer: !1,
    // Double + single quotes replacement pairs, when typographer enabled,
    // and smartquotes on. Set doubles to '«»' for Russian, '„“' for German.
    quotes: "“”‘’",
    // Highlighter function. Should return escaped HTML,
    // or '' if input not changed
    //
    // function (/*str, lang*/) { return ''; }
    //
    highlight: null,
    maxNesting: 20
    // Internal protection, recursion limit
  },
  components: {
    core: {
      rules: ["block", "inline", "references", "replacements", "smartquotes", "references", "abbr2", "footnote_tail"]
    },
    block: {
      rules: ["blockquote", "code", "fences", "footnote", "heading", "hr", "htmlblock", "lheading", "list", "paragraph", "table"]
    },
    inline: {
      rules: ["autolink", "backticks", "del", "emphasis", "entity", "escape", "footnote_ref", "htmltag", "links", "newline", "text"]
    }
  }
}, Ije = {
  options: {
    html: !1,
    // Enable HTML tags in source
    xhtmlOut: !1,
    // Use '/' to close single tags (<br />)
    breaks: !1,
    // Convert '\n' in paragraphs into <br>
    langPrefix: "language-",
    // CSS language prefix for fenced blocks
    linkTarget: "",
    // set target to open link in
    // Enable some language-neutral replacements + quotes beautification
    typographer: !1,
    // Double + single quotes replacement pairs, when typographer enabled,
    // and smartquotes on. Set doubles to '«»' for Russian, '„“' for German.
    quotes: "“”‘’",
    // Highlighter function. Should return escaped HTML,
    // or '' if input not changed
    //
    // function (/*str, lang*/) { return ''; }
    //
    highlight: null,
    maxNesting: 20
    // Internal protection, recursion limit
  },
  components: {
    // Don't restrict core/block/inline rules
    core: {},
    block: {},
    inline: {}
  }
}, Tje = {
  options: {
    html: !0,
    // Enable HTML tags in source
    xhtmlOut: !0,
    // Use '/' to close single tags (<br />)
    breaks: !1,
    // Convert '\n' in paragraphs into <br>
    langPrefix: "language-",
    // CSS language prefix for fenced blocks
    linkTarget: "",
    // set target to open link in
    // Enable some language-neutral replacements + quotes beautification
    typographer: !1,
    // Double + single quotes replacement pairs, when typographer enabled,
    // and smartquotes on. Set doubles to '«»' for Russian, '„“' for German.
    quotes: "“”‘’",
    // Highlighter function. Should return escaped HTML,
    // or '' if input not changed
    //
    // function (/*str, lang*/) { return ''; }
    //
    highlight: null,
    maxNesting: 20
    // Internal protection, recursion limit
  },
  components: {
    core: {
      rules: ["block", "inline", "references", "abbr2"]
    },
    block: {
      rules: ["blockquote", "code", "fences", "heading", "hr", "htmlblock", "lheading", "list", "paragraph"]
    },
    inline: {
      rules: ["autolink", "backticks", "emphasis", "entity", "escape", "htmltag", "links", "newline", "text"]
    }
  }
}, Oje = {
  default: Eje,
  full: Ije,
  commonmark: Tje
};
function y5(e, t, s) {
  this.src = t, this.env = s, this.options = e.options, this.tokens = [], this.inlineMode = !1, this.inline = e.inline, this.block = e.block, this.renderer = e.renderer, this.typographer = e.typographer;
}
function Ur(e, t) {
  typeof e != "string" && (t = e, e = "default"), t && t.linkify != null && console.warn(`linkify option is removed. Use linkify plugin instead:

import Remarkable from 'remarkable';
import linkify from 'remarkable/linkify';
new Remarkable().use(linkify)
`), this.inline = new vf(), this.block = new Ob(), this.core = new g5(), this.renderer = new Tb(), this.ruler = new Gn(), this.options = {}, this.configure(Oje[e]), this.set(t || {});
}
Ur.prototype.set = function(e) {
  c5(this.options, e);
};
Ur.prototype.configure = function(e) {
  var t = this;
  if (!e) throw new Error("Wrong `remarkable` preset, check name/content");
  e.options && t.set(e.options), e.components && Object.keys(e.components).forEach(function(s) {
    e.components[s].rules && t[s].ruler.enable(e.components[s].rules, !0);
  });
};
Ur.prototype.use = function(e, t) {
  return e(this, t), this;
};
Ur.prototype.parse = function(e, t) {
  var s = new y5(this, e, t);
  return this.core.process(s), s.tokens;
};
Ur.prototype.render = function(e, t) {
  return t = t || {}, this.renderer.render(this.parse(e, t), this.options, t);
};
Ur.prototype.parseInline = function(e, t) {
  var s = new y5(this, e, t);
  return s.inlineMode = !0, this.core.process(s), s.tokens;
};
Ur.prototype.renderInline = function(e, t) {
  return t = t || {}, this.renderer.render(this.parseInline(e, t), this.options, t);
};
var b5 = /* @__PURE__ */ function() {
  function e() {
    je(this, e);
  }
  return He(e, null, [{
    key: "instantiate",
    value: function(s) {
      if (s) return new Ur(ys(ys({}, e.DEFAULT_PROPERTIES), s));
      if (window.hljs) {
        var n = window.hljs;
        return new Ur({
          highlight: function(i, o) {
            if (o && n.getLanguage(o)) try {
              return n.highlight(i, {
                language: o
              }).value;
            } catch {
              console.error("failed to setup the highlight dependency");
            }
            try {
              return n.highlightAuto(i).value;
            } catch {
              console.error("failed to automatically highlight messages");
            }
            return "";
          },
          html: !1,
          // Enable HTML tags in source
          xhtmlOut: !1,
          // Use '/' to close single tags (<br />)
          breaks: !0,
          // Convert '\n' in paragraphs into <br>
          langPrefix: "language-",
          // CSS language prefix for fenced blocks
          linkTarget: "_blank",
          // set target to open in a new tab
          typographer: !0
          // Enable smartypants and other sweet transforms
        });
      } else return new Ur(e.DEFAULT_PROPERTIES);
    }
  }, {
    key: "createNew",
    value: function(s) {
      var n = e.instantiate(s);
      return n.inline.validateLink = function() {
        return !0;
      }, n;
    }
  }]);
}();
b5.DEFAULT_PROPERTIES = {
  breaks: !0,
  linkTarget: "_blank"
  // set target to open in a new tab
};
var Sy = b5, Rje = /* @__PURE__ */ function() {
  function e(t) {
    je(this, e), this.storageKey = "deep-chat-storage", this.maxMessages = 1e3, St(t) == "object" && (t.key && (this.storageKey = t.key), t.maxMessages && (this.maxMessages = t.maxMessages), t.clear = this.clear.bind(this));
  }
  return He(e, [{
    key: "get",
    value: function() {
      var s = localStorage.getItem(this.storageKey);
      return s ? JSON.parse(s) : [];
    }
  }, {
    key: "addMessages",
    value: function(s) {
      var n = s.length - this.maxMessages;
      n < 0 && (n = 0);
      var r = s.slice(n, s.length);
      localStorage.setItem(this.storageKey, JSON.stringify(r));
    }
  }, {
    key: "clear",
    value: function() {
      localStorage.removeItem(this.storageKey);
    }
  }]);
}(), Ih = /* @__PURE__ */ function() {
  function e() {
    je(this, e);
  }
  return He(e, null, [{
    key: "applyCustomStylesToElements",
    value: function(s, n, r) {
      if (r && (Object.assign(s.outerContainer.style, r.outerContainer), Object.assign(s.innerContainer.style, r.innerContainer), Object.assign(s.bubbleElement.style, r.bubble), n)) {
        var i = s.bubbleElement.children[0], o = i.tagName.toLocaleLowerCase() !== "a" ? i : i.children[0];
        Object.assign(o.style, r.media);
      }
    }
  }, {
    key: "applySideStyles",
    value: function(s, n, r, i) {
      i && (e.applyCustomStylesToElements(s, r, i.shared), n === Ft.USER_ROLE ? e.applyCustomStylesToElements(s, r, i.user) : (e.applyCustomStylesToElements(s, r, i.ai), e.applyCustomStylesToElements(s, r, i[n])));
    }
  }, {
    key: "isElementsStyles",
    value: function(s) {
      return !!(s.outerContainer || s.innerContainer || s.bubble || s.media);
    }
    // prettier-ignore
  }, {
    key: "applyCustomStyles",
    value: function(s, n, r, i, o) {
      var l;
      o && s.default !== o ? e.isElementsStyles(o) ? (e.applyCustomStylesToElements(n, i, (l = s.default) == null ? void 0 : l.shared), e.applyCustomStylesToElements(n, i, o)) : (e.applySideStyles(n, r, i, s.default), e.applySideStyles(n, r, i, o)) : e.applySideStyles(n, r, i, s.default);
    }
    // prettier-ignore
  }, {
    key: "extractParticularSharedStyles",
    value: function(s, n) {
      if (n != null && n.shared) {
        var r = n.shared, i = {
          outerContainer: {},
          innerContainer: {},
          bubble: {},
          media: {}
        };
        return s.forEach(function(o) {
          var l, d, c, u;
          i.outerContainer[o] = ((l = r.outerContainer) == null ? void 0 : l[o]) || "", i.innerContainer[o] = ((d = r.innerContainer) == null ? void 0 : d[o]) || "", i.bubble[o] = ((c = r.bubble) == null ? void 0 : c[o]) || "", i.media[o] = ((u = r.media) == null ? void 0 : u[o]) || "";
        }), i;
      }
    }
  }]);
}(), Pu = /* @__PURE__ */ function() {
  function e() {
    je(this, e);
  }
  return He(e, null, [{
    key: "onMessage",
    value: function(s, n, r) {
      var i, o = JSON.parse(JSON.stringify({
        message: n,
        isHistory: r,
        isInitial: r
      }));
      cn.reAddFileRefToObject(n, o.message), (i = s.onMessage) == null || i.call(s, o), s.dispatchEvent(new CustomEvent("message", {
        detail: o
      })), xn.fireOnNewMessage(s, o);
    }
  }, {
    key: "onClearMessages",
    value: function(s) {
      var n;
      (n = s.onClearMessages) == null || n.call(s), s.dispatchEvent(new CustomEvent("clear-messages"));
    }
  }, {
    key: "onRender",
    value: function(s) {
      var n;
      (n = s.onComponentRender) == null || n.call(s, s), s.dispatchEvent(new CustomEvent("render", {
        detail: s
      }));
    }
  }, {
    key: "onInput",
    value: function(s, n, r) {
      var i, o, l = JSON.parse(JSON.stringify({
        content: n,
        isUser: r
      }));
      n.files && cn.reAddFileRefToObject({
        files: (i = n.files) == null ? void 0 : i.map(function(d) {
          return {
            ref: d
          };
        })
      }, l.content), (o = s.onInput) == null || o.call(s, l), s.dispatchEvent(new CustomEvent("input", {
        detail: l
      }));
    }
  }, {
    key: "onError",
    value: function(s, n) {
      var r;
      (r = s.onError) == null || r.call(s, n), s.dispatchEvent(new CustomEvent("error", {
        detail: n
      }));
    }
  }]);
}(), Th = /* @__PURE__ */ function() {
  function e() {
    je(this, e);
  }
  return He(e, null, [{
    key: "generateLoadingRingElement",
    value: function() {
      var s = document.createElement("div");
      return s.classList.add("loading-history"), s.appendChild(document.createElement("div")), s.appendChild(document.createElement("div")), s.appendChild(document.createElement("div")), s.appendChild(document.createElement("div")), s;
    }
  }, {
    key: "apply",
    value: function(s, n, r) {
      qi.setRing(n.bubbleElement, r == null ? void 0 : r.bubble), r != null && r.bubble && (r = JSON.parse(JSON.stringify(r)), delete r.bubble), s.applyCustomStyles(n, "history", !1, r);
    }
  }, {
    key: "addLoadHistoryMessage",
    value: function(s, n) {
      var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0, i, o, l, d, c, u, m, f;
      s.bubbleElement.classList.add(e.CLASS);
      var v = r ? e.FULL_VIEW_CLASS : e.SMALL_CLASS;
      s.outerContainer.classList.add(v);
      var b = r ? (d = (l = (o = (i = n.messageStyles) == null ? void 0 : i.loading) == null ? void 0 : o.history) == null ? void 0 : l.full) == null ? void 0 : d.styles : (f = (m = (u = (c = n.messageStyles) == null ? void 0 : c.loading) == null ? void 0 : u.history) == null ? void 0 : m.small) == null ? void 0 : f.styles;
      e.apply(n, s, b), n.elementRef.prepend(s.outerContainer);
    }
  }, {
    key: "createDefaultElements",
    value: function(s) {
      var n = s.createMessageElements("", Ft.AI_ROLE), r = n.bubbleElement, i = e.generateLoadingRingElement();
      return r.appendChild(i), n;
    }
  }, {
    key: "addMessage",
    value: function(s) {
      var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0, r, i, o, l, d = (l = (o = (i = (r = s.messageStyles) == null ? void 0 : r.loading) == null ? void 0 : i.history) == null ? void 0 : o.full) == null ? void 0 : l.html, c = d ? mi.createElements(s, d, Ft.AI_ROLE, !0, !0) : e.createDefaultElements(s);
      return e.addLoadHistoryMessage(c, s, n), Ft.softRemRoleElements(c.innerContainer, s.avatar, s.name), c;
    }
  }, {
    key: "tryChangeViewToSmall",
    value: function(s, n) {
      var r, i, o, l, d, c, u, m;
      if (n != null && n.outerContainer.classList.contains(e.FULL_VIEW_CLASS)) {
        n.outerContainer.classList.replace(e.FULL_VIEW_CLASS, e.SMALL_CLASS);
        var f = (l = (o = (i = (r = s.messageStyles) == null ? void 0 : r.loading) == null ? void 0 : i.history) == null ? void 0 : o.small) == null ? void 0 : l.styles;
        f && e.apply(s, n, f);
        var v = (m = (u = (c = (d = s.messageStyles) == null ? void 0 : d.loading) == null ? void 0 : c.history) == null ? void 0 : u.small) == null ? void 0 : m.html;
        return v && (n.bubbleElement.innerHTML = v), !0;
      }
      return !1;
    }
  }, {
    key: "changeFullViewToSmall",
    value: function(s) {
      var n = s.messageElementRefs[s.messageElementRefs.length - 1];
      e.tryChangeViewToSmall(s, n) || e.tryChangeViewToSmall(s, s.messageElementRefs[0]);
    }
  }]);
}();
Th.CLASS = "loading-history-message", Th.FULL_VIEW_CLASS = "loading-history-message-full-view", Th.SMALL_CLASS = "loading-history-message-small";
var tl = Th, A5 = /* @__PURE__ */ function() {
  function e() {
    je(this, e);
  }
  return He(e, null, [{
    key: "setFade",
    value: function(s, n) {
      s.style.transitionDuration = typeof n == "number" ? "".concat(n, "ms") : "".concat(e.DEFAULT_FADE_MS, "ms");
    }
  }, {
    key: "fadeAnimation",
    value: function() {
      var t = Qe(/* @__PURE__ */ ce().mark(function n(r, i) {
        var o;
        return ce().wrap(function(d) {
          for (; ; ) switch (d.prev = d.next) {
            case 0:
              return r.style.opacity = "0", o = typeof i == "number" ? i : e.DEFAULT_FADE_MS, d.next = 4, new Promise(function(c) {
                setTimeout(function() {
                  return c();
                }, o);
              });
            case 4:
              r.style.opacity = "1";
            case 5:
            case "end":
              return d.stop();
          }
        }, n);
      }));
      function s(n, r) {
        return t.apply(this, arguments);
      }
      return s;
    }()
  }]);
}();
A5.DEFAULT_FADE_MS = 500;
var w5 = A5, sC = "data:image/svg+xml,%3c?xml%20version='1.0'%20encoding='iso-8859-1'?%3e%3csvg%20fill='%23000000'%20version='1.1'%20id='Layer_1'%20xmlns='http://www.w3.org/2000/svg'%20xmlns:xlink='http://www.w3.org/1999/xlink'%20viewBox='0%200%2032%2032'%20xml:space='preserve'%3e%3cpath%20d='M23,30.36H9c-2.404,0-4.36-1.956-4.36-4.36V15c0-2.404,1.956-4.36,4.36-4.36h3.659%20c0.167-1.566,1.415-2.813,2.981-2.981V5.333c-1.131-0.174-2-1.154-2-2.333c0-1.301,1.059-2.36,2.36-2.36%20c1.302,0,2.36,1.059,2.36,2.36c0,1.179-0.869,2.159-2,2.333V7.66c1.566,0.167,2.814,1.415,2.981,2.981H23%20c2.404,0,4.36,1.956,4.36,4.36v11C27.36,28.404,25.404,30.36,23,30.36z%20M9,11.36c-2.007,0-3.64,1.633-3.64,3.64v11%20c0,2.007,1.633,3.64,3.64,3.64h14c2.007,0,3.64-1.633,3.64-3.64V15c0-2.007-1.633-3.64-3.64-3.64H9z%20M13.384,10.64h5.231%20C18.439,9.354,17.334,8.36,16,8.36C14.667,8.36,13.561,9.354,13.384,10.64z%20M16,1.36c-0.904,0-1.64,0.736-1.64,1.64%20S15.096,4.64,16,4.64c0.904,0,1.64-0.736,1.64-1.64S16.904,1.36,16,1.36z%20M20,27.36h-8c-1.301,0-2.36-1.059-2.36-2.36%20s1.059-2.36,2.36-2.36h8c1.302,0,2.36,1.059,2.36,2.36S21.302,27.36,20,27.36z%20M12,23.36c-0.904,0-1.64,0.735-1.64,1.64%20s0.736,1.64,1.64,1.64h8c0.904,0,1.64-0.735,1.64-1.64s-0.735-1.64-1.64-1.64H12z%20M31,23.86h-2c-0.199,0-0.36-0.161-0.36-0.36V15%20c0-0.199,0.161-0.36,0.36-0.36h2c0.199,0,0.36,0.161,0.36,0.36v8.5C31.36,23.699,31.199,23.86,31,23.86z%20M29.36,23.14h1.279v-7.78%20H29.36V23.14z%20M3,23.86H1c-0.199,0-0.36-0.161-0.36-0.36V15c0-0.199,0.161-0.36,0.36-0.36h2c0.199,0,0.36,0.161,0.36,0.36v8.5%20C3.36,23.699,3.199,23.86,3,23.86z%20M1.36,23.14h1.28v-7.78H1.36V23.14z%20M20,20.36c-1.302,0-2.36-1.059-2.36-2.36%20s1.059-2.36,2.36-2.36s2.36,1.059,2.36,2.36C22.36,19.302,21.302,20.36,20,20.36z%20M20,16.36c-0.904,0-1.64,0.736-1.64,1.64%20s0.735,1.64,1.64,1.64s1.64-0.735,1.64-1.64S20.904,16.36,20,16.36z%20M12,20.36c-1.301,0-2.36-1.059-2.36-2.36s1.059-2.36,2.36-2.36%20s2.36,1.059,2.36,2.36C14.36,19.302,13.301,20.36,12,20.36z%20M12,16.36c-0.904,0-1.64,0.736-1.64,1.64s0.736,1.64,1.64,1.64%20s1.64-0.735,1.64-1.64S12.904,16.36,12,16.36z'/%3e%3crect%20style='fill:none;'%20width='32'%20height='32'/%3e%3c/svg%3e", Py = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAPoAAAD6CAMAAAC/MqoPAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAgY0hSTQAAeiYAAICEAAD6AAAAgOgAAHUwAADqYAAAOpgAABdwnLpRPAAAADNQTFRF////9vX18vLy/Pz86enp4+Li2tnZ1tbWzczM+fn57Ozs4N/f09LS0M/P5uXl7+/v3dzcwtncCAAAAAFiS0dEAIgFHUgAAAAJcEhZcwAAAEgAAABIAEbJaz4AAAZNSURBVHja7d3bdtsqEABQYABZSLH9/3+ZpnUsIcF5iOM6PfElNoMHMfPQdq3GmL0GkLhEUqLaUExnOtOZznSmM53pTGc605nOdKYznelMZzrTmV4LXSqllKyJDkob26xWq8Zae/iH0QoWTm9d1xur4WuypQJtTd+5dqn0VjcxzNO5/57mEBvdLo8Oron6aseWOjYOFkVvjQs3DmgyONMuht52EfztP+4hdu0i6LCO808/M8c1lE/fuPGej41uUzgdtoO/75N+2ELJ9I3b3//hPXbiMenm3pR/Jt4USgcLBIp4Bh10gqKVhvLo0klCxeSky96nKcj3siw6pJIL4XsoiQ7apyvMY/V3HHrSRioLopvEhSpTCn2TPEuwKYMOIX0tAxRBf/Hpa+lfSqBv9gi1FPsNfTrMAiVmIE/vJhz61FGnQxRIEYE4vfNYdN8Rp6MlHaHotHTn8ejekaZPAjEmyvQWdZFTtYTpXqCGJ0zvcek9Yfoel76nS0ffv1NMp1ca+pkgyfRCGind4L7OWWc605l+cxjsyhqy9AGbPpClc1/nvl5VX0c/3Alk6RU3+Am7shNZ+h6bvidLr7jBB+zKBrL0irOOudmIUDzTmf5gIP+iEuXtRuTVaEmY/oZLfyNMrzjryPc0gerMTdpVg0tvjJUU6bLPcGOoUv46SLL6Wi8yhLf06C7TUyekI0efRaaYqdFltkeNpPumRPSMDxgBYvSM035FrKAmH72hRW99PrpvSdEHkTEGUvSsK3yKVDkuJ92RohcZaehzzirPpOg+J92Tolfc4Cumx5xVXpGiZ34+ICX6W84qv5GiR5NPbiIpOv6BCoSvSkTX+eiaGP092zINvBOj4x8mSf9FqejvNo/cvpOji19ZbmviL0GPLsYMFzgzCor0+Bv/ePDvSJKOb9dJ5UlnbnEHiHgzv6cdTpJOWuc/u3FEucLDOL75xGtBiefrcwgoC9NDSH/jkH6pAuXmBqPQ9HSUPVdZBH1GGOrMXAQdYxcKZfxAoK+KKBKFLosoEoX+u4giUehz8jlcnAuhp78I46yDYNAd+QLR6K+pr+yvxdBTHyVDubQh0UfSxaHSd0lbvNkVRE87JGOtc+PQd2QLQ6fHhJkKsSh6yg13tO08JPprsgrrXWH0dJd2vH1MLPprot4eXoujpzrdhngiD40ek2y92lggPcnWa8qN1Yz0BFuvZhRl0uOfR0v4Ewuli/Bg4Qr3lArqGdndQ3UPO1EunXYwnelMZzrTmc50pjOd6UxnOtOZznSmM53pTGf6kuj6oedFKV0s3fX6sX1S3bsi6a4PD7+/YAqYeBw6pIB/4qEgOqxdSPbGiim4NRRCbzs3Jj0L4UfXtQXQVRfn5IdA/Bw7RZzurEV6EtdsLeGXkIPuA+K1UoVeA0l62zmN/LqfSSft9KkepmoRuvi3nd5uKNFB9zbbXEANqdr941XO0NJx2v2jdJenpf+/3bvn0ts16ph+sd6hX7dPo2+2cZzE02Ia43bzDHqr+2Evnhz74ZHU30ffbKOeng1/NPV30Ns1gYQnSP2P6e65Pfxc6h02XZqXQCjhJ6kPL6bFo4NrGvAU4UII4SE2P1vQuZkuOxckVfehisF1MjUddN/MZBN+kvq5uf0O/xa66gyNS9ktMWlz44rO1Z8C19i5FPdHzPamXn+F3hryPfxMr78+4F+kq22kO6Rf6fUQt+puuustyWv4rbG3l/duztFB96GYoe1cTBdXMr+nw9qVM6ZfxOvzezff0nXi/ZOndvrR6Zvpm0c3h6nhdb+5iS7tsIim/qXZD9+97/Jf+rpZ5BET1ayv0GUzLhEuhBBjIy/RdVPgndutIRt9nt7p5cKFEEJ3Z+jQFDZL+XnMDXxHB73gxn5s9Kc3d3/pFciFkN/QTSXHJpX5l66gDrkQoP6hL3xsPw39la4qOiV8tH78XeSbue6N9mvWa6J/ybpc1CT1Wnh5Qq9meP8IOKH3ddH7E/ri1iYux/SXDrXR4UiPdck/wUpU+FtPf6/orja6O9KL3l56LOvVxe5Ib2qjN0d6Vbex4ghWlU3bPqI90If66MNng680FNpbJijH6kCvaF3uMzQ3+IrpFerV4Y9dffQdN3im10ivbuImhD3Qq5u4HdZkua8znelMZ/pS4z9CPVKkxowNxgAAACV0RVh0ZGF0ZTpjcmVhdGUAMjAxNy0wMy0yN1QxNTo0NToxNSswMDowMN1xSg4AAAAldEVYdGRhdGU6bW9kaWZ5ADIwMTctMDMtMjdUMTU6NDU6MTUrMDA6MDCsLPKyAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAABJRU5ErkJggg==", C5 = /* @__PURE__ */ function() {
  function e(t) {
    je(this, e), this.className = t;
  }
  return He(e, [{
    key: "tryHide",
    value: function(s) {
      var n;
      (n = s.getElementsByClassName(this.className)[0].style).visibility || (n.visibility = "hidden");
    }
  }, {
    key: "tryReveal",
    value: function(s) {
      s.getElementsByClassName(this.className)[0].style.visibility = "";
    }
  }, {
    key: "trySoftRem",
    value: function(s) {
      s.getElementsByClassName(this.className)[0].classList.add("role-hidden");
    }
  }]);
}(), Lje = /* @__PURE__ */ function(e) {
  function t(s) {
    var n;
    return je(this, t), n = jt(this, t, ["avatar-container"]), n._avatars = s, n;
  }
  return Ht(t, e), He(t, [{
    key: "addBesideMsg",
    value: function(n, r) {
      var i = typeof this._avatars == "boolean" ? void 0 : this._avatars, o = this.createAvatar(r, i), l = this.getPosition(r, i);
      o.classList.add(l === "left" ? "left-item-position" : "right-item-position"), n.insertAdjacentElement(l === "left" ? "beforebegin" : "afterend", o);
    }
  }, {
    key: "createAvatar",
    value: function(n, r) {
      var i, o, l, d, c, u = document.createElement("img");
      n === Ft.USER_ROLE ? (u.src = ((i = r == null ? void 0 : r.user) == null ? void 0 : i.src) || ((o = r == null ? void 0 : r.default) == null ? void 0 : o.src) || Py, u.onerror = t.errorFallback.bind(this, Py)) : (u.src = ((l = r == null ? void 0 : r[n]) == null ? void 0 : l.src) || ((d = r == null ? void 0 : r.ai) == null ? void 0 : d.src) || ((c = r == null ? void 0 : r.default) == null ? void 0 : c.src) || sC, u.onerror = t.errorFallback.bind(this, sC)), u.classList.add("avatar"), u.alt = "".concat(n, " avatar");
      var m = document.createElement("div");
      return m.classList.add(this.className), m.appendChild(u), r && t.applyCustomStyles(m, u, r, n), m;
    }
  }, {
    key: "getPosition",
    value: function(n, r) {
      var i, o, l, d, c, u, m = (o = (i = r == null ? void 0 : r[n]) == null ? void 0 : i.styles) == null ? void 0 : o.position;
      return n !== Ft.USER_ROLE && (m ?? (m = (d = (l = r == null ? void 0 : r.ai) == null ? void 0 : l.styles) == null ? void 0 : d.position)), m ?? (m = (u = (c = r == null ? void 0 : r.default) == null ? void 0 : c.styles) == null ? void 0 : u.position), m ?? (m = n === Ft.USER_ROLE ? "right" : "left"), m;
    }
  }], [{
    key: "errorFallback",
    value: function(n, r) {
      var i = r.target;
      i.onerror = null, i.src = n;
    }
  }, {
    key: "applyCustomStylesToElements",
    value: function(n, r, i) {
      Object.assign(n.style, i.container), Object.assign(r.style, i.avatar);
    }
  }, {
    key: "applyCustomStyles",
    value: function(n, r, i, o) {
      var l, d, c, u;
      if ((l = i.default) != null && l.styles && t.applyCustomStylesToElements(n, r, i.default.styles), o === Ft.USER_ROLE) (d = i.user) != null && d.styles && t.applyCustomStylesToElements(n, r, i.user.styles);
      else {
        (c = i.ai) != null && c.styles && t.applyCustomStylesToElements(n, r, i.ai.styles);
        var m = (u = i[o]) == null ? void 0 : u.styles;
        m && t.applyCustomStylesToElements(n, r, m);
      }
    }
  }]);
}(C5), Bje = /* @__PURE__ */ function(e) {
  function t(s) {
    var n;
    return je(this, t), n = jt(this, t, ["name"]), n._names = s, n;
  }
  return Ht(t, e), He(t, [{
    key: "addBesideMsg",
    value: function(n, r) {
      var i = typeof this._names == "boolean" ? {} : this._names, o = this.createName(r, i), l = t.getPosition(r, i);
      o.classList.add(l === "left" ? "left-item-position" : "right-item-position"), n.insertAdjacentElement(l === "left" ? "beforebegin" : "afterend", o);
    }
  }, {
    key: "createName",
    value: function(n, r) {
      var i = document.createElement("div");
      return i.classList.add(this.className), i.textContent = t.getNameText(n, r), t.applyStyle(i, n, r), i;
    }
  }], [{
    key: "getPosition",
    value: function(n, r) {
      var i, o, l, d = (i = r == null ? void 0 : r[n]) == null ? void 0 : i.position;
      return n !== Ft.USER_ROLE && (d ?? (d = (o = r == null ? void 0 : r.ai) == null ? void 0 : o.position)), d ?? (d = (l = r == null ? void 0 : r.default) == null ? void 0 : l.position), d ?? (d = n === Ft.USER_ROLE ? "right" : "left"), d;
    }
  }, {
    key: "applyStyle",
    value: function(n, r, i) {
      var o, l, d, c;
      Object.assign(n.style, (o = i.default) == null ? void 0 : o.style), r === Ft.USER_ROLE ? Object.assign(n.style, (l = i.user) == null ? void 0 : l.style) : (Object.assign(n.style, (d = i.ai) == null ? void 0 : d.style), Object.assign(n.style, (c = i[r]) == null ? void 0 : c.style));
    }
  }, {
    key: "getNameText",
    value: function(n, r) {
      var i, o, l, d, c, u;
      return n === Ft.USER_ROLE ? ((i = r.user) == null ? void 0 : i.text) || ((o = r.default) == null ? void 0 : o.text) || "User" : n === Ft.AI_ROLE ? ((l = r.ai) == null ? void 0 : l.text) || ((d = r.default) == null ? void 0 : d.text) || "AI" : ((c = r[n]) == null ? void 0 : c.text) || ((u = r.default) == null ? void 0 : u.text) || n;
    }
  }]);
}(C5), Oh = /* @__PURE__ */ function() {
  function e(t) {
    var s = this;
    je(this, e);
    var n;
    this.messageElementRefs = [], this.htmlClassUtilities = {}, this.messageToElements = [], this.elementRef = e.createContainerElement(), this.messageStyles = xn.processMessageStyles(t.messageStyles), this._remarkable = Sy.createNew(t.remarkable), t.avatars && (this.avatar = new Lje(t.avatars)), t.names && (this.name = new Bje(t.names)), t.browserStorage && (this.browserStorage = new Rje(t.browserStorage)), this._onMessage = Pu.onMessage.bind(this, t), t.htmlClassUtilities && (this.htmlClassUtilities = t.htmlClassUtilities), this.focusMode = t.focusMode, this.focusMode || (this._lastGroupMessagesElement = document.createElement("div")), typeof this.focusMode != "boolean" && (n = this.focusMode) != null && n.fade && w5.setFade(this.elementRef, this.focusMode.fade), setTimeout(function() {
      s.submitUserMessage = t.submitUserMessage;
    });
  }
  return He(e, [{
    key: "addNewTextMessage",
    value: function(s, n, r) {
      var i = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1;
      if (r != null && r.status) {
        var o = this.overwriteText(n, s, this.messageElementRefs);
        if (o) return o;
        r.status = !1;
      }
      var l = i ? this.createAndPrependNewMessageElement(s, n, i) : this.createAndAppendNewMessageElement(s, n);
      return l.bubbleElement.classList.add(e.TEXT_BUBBLE_CLASS), this.applyCustomStyles(l, n, !1), Ft.fillEmptyMessageElement(l.bubbleElement, s), l;
    }
    // prettier-ignore
  }, {
    key: "overwriteText",
    value: function(s, n, r) {
      var i = Ft.overwriteMessage(this.messageToElements, r, n, s, "text", e.TEXT_BUBBLE_CLASS);
      return i && this.renderText(i.bubbleElement, n), i;
    }
  }, {
    key: "createAndAppendNewMessageElement",
    value: function(s, n) {
      return this.focusMode ? this.appendNewMessageElementFocusMode(s, n) : this.createAndAppendNewMessageElementDefault(s, n);
    }
  }, {
    key: "appendNewMessageElementFocusMode",
    value: function(s, n) {
      var r, i = this.createNewMessageElement(s, n);
      if (this.appendOuterContainerElemet(i.outerContainer, n), n === "user") {
        var o = typeof this.focusMode != "boolean" && ((r = this.focusMode) == null ? void 0 : r.scroll);
        Ln.scrollToBottom(this.elementRef, o);
      }
      return i;
    }
  }, {
    key: "createNewGroupElementFocusMode",
    value: function() {
      var s;
      (s = this._lastGroupMessagesElement) == null || s.classList.remove(e.LAST_GROUP_MESSAGES_ACTIVE);
      var n = document.createElement("div");
      this._lastGroupMessagesElement && n.classList.add(e.LAST_GROUP_MESSAGES_ACTIVE), this._lastGroupMessagesElement = n;
    }
  }, {
    key: "createAndAppendNewMessageElementDefault",
    value: function(s, n) {
      var r = this, i = this.createNewMessageElement(s, n);
      return this.appendOuterContainerElemet(i.outerContainer), setTimeout(function() {
        return Ln.scrollToBottom(r.elementRef);
      }), i;
    }
  }, {
    key: "appendOuterContainerElemet",
    value: function(s, n) {
      var r;
      this.focusMode && (n === "user" || !this._lastGroupMessagesElement) && this.createNewGroupElementFocusMode(), (r = this._lastGroupMessagesElement) == null || r.appendChild(s), this.elementRef.appendChild(this._lastGroupMessagesElement);
    }
  }, {
    key: "createAndPrependNewMessageElement",
    value: function(s, n, r) {
      var i = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1, o, l = this.createNewMessageElement(s, n, r, i);
      if (r && (o = this.elementRef.firstChild) != null && o.classList.contains(e.INTRO_CLASS)) {
        this.elementRef.firstChild.insertAdjacentElement("afterend", l.outerContainer);
        var d = this.messageElementRefs[0];
        this.messageElementRefs[0] = this.messageElementRefs[1], this.messageElementRefs[1] = d;
      } else this.elementRef.insertBefore(l.outerContainer, this.elementRef.firstChild);
      return l;
    }
  }, {
    key: "createMessageElementsOnOrientation",
    value: function(s, n, r) {
      var i = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1;
      return r ? this.createAndPrependNewMessageElement(s, n, !0, i) : this.createNewMessageElement(s, n, i);
    }
  }, {
    key: "createNewMessageElement",
    value: function(s, n) {
      var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, i = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1, o;
      i || (o = this._introPanel) == null || o.hide();
      var l = this.messageElementRefs[this.messageElementRefs.length - 1];
      return tl.changeFullViewToSmall(this), !r && e.isTemporaryElement(l) && (this.revealRoleElementsIfTempRemoved(l, n), this.removeLastMessage()), this.createMessageElements(s, n, r);
    }
    // this can be tested by having an ai message, then a temp ai message with html that submits new user message:
    // https://github.com/OvidijusParsiunas/deep-chat/issues/258
    // prettier-ignore
  }, {
    key: "revealRoleElementsIfTempRemoved",
    value: function(s, n) {
      if ((this.avatar || this.name) && ld.isElementTemporary(s)) {
        var r = this.messageElementRefs[this.messageElementRefs.length - 2];
        r && this.messageToElements.length > 0 && !s.bubbleElement.classList.contains(Ft.getRoleClass(n)) && Ft.revealRoleElements(r.innerContainer, this.avatar, this.name);
      }
    }
  }, {
    key: "createElements",
    value: function(s, n) {
      var r = e.createBaseElements(n), i = r.outerContainer, o = r.innerContainer, l = r.bubbleElement;
      return i.appendChild(o), this.addInnerContainerElements(l, s, n), r;
    }
  }, {
    key: "createMessageElements",
    value: function(s, n) {
      var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, i = this.createElements(s, n);
      return Ft.updateRefArr(this.messageElementRefs, i, r), Ft.classifyRoleMessages(this.messageElementRefs, n), i;
    }
  }, {
    key: "addInnerContainerElements",
    value: (
      // prettier-ignore
      function(s, n, r) {
        var i = this.messageElementRefs[this.messageElementRefs.length - 1];
        return Ft.areOuterContainerClassRolesSame(r, i) && !this.isLastMessageError() && Ft.hideRoleElements(i.innerContainer, this.avatar, this.name), s.classList.add("message-bubble", Ft.getRoleClass(r), r === Ft.USER_ROLE ? "user-message-text" : "ai-message-text"), this.renderText(s, n), Ft.addRoleElements(s, r, this.avatar, this.name), {
          bubbleElement: s
        };
      }
    )
    // prettier-ignore
  }, {
    key: "applyCustomStyles",
    value: function(s, n, r, i) {
      s && this.messageStyles && Ih.applyCustomStyles(this.messageStyles, s, n, r, i);
    }
  }, {
    key: "removeMessage",
    value: function(s) {
      s.outerContainer.remove();
      var n = this.messageElementRefs.findIndex(function(r) {
        return r === s;
      });
      this.messageElementRefs.splice(n, 1);
    }
  }, {
    key: "removeLastMessage",
    value: function() {
      this.messageElementRefs[this.messageElementRefs.length - 1].outerContainer.remove(), this.messageElementRefs.pop();
    }
  }, {
    key: "isLastMessageError",
    value: function() {
      var s;
      return (s = Ft.getLastMessageBubbleElement(this.elementRef)) == null ? void 0 : s.classList.contains(Ft.ERROR_MESSAGE_TEXT_CLASS);
    }
  }, {
    key: "sendClientUpdate",
    value: function(s) {
      var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, r;
      (r = this._onMessage) == null || r.call(this, s, n);
    }
  }, {
    key: "renderText",
    value: function(s, n) {
      s.innerHTML = this._remarkable.render(n), s.innerText.trim().length === 0 && (s.innerText = n);
    }
    // this is mostly used for enabling highlight.js to highlight code if it downloads later
  }, {
    key: "refreshTextMessages",
    value: function(s) {
      var n = this;
      this._remarkable = Sy.createNew(s), this.messageToElements.forEach(function(r) {
        r[1].text && r[0].text && n.renderText(r[1].text.bubbleElement, r[0].text);
      });
    }
  }], [{
    key: "createContainerElement",
    value: function() {
      var s = document.createElement("div");
      return s.id = "messages", s;
    }
  }, {
    key: "isTemporaryElement",
    value: function(s) {
      return e.isLoadingMessage(s) || ld.isElementTemporary(s);
    }
  }, {
    key: "createBaseElements",
    value: function(s) {
      var n = document.createElement("div"), r = document.createElement("div");
      r.classList.add("inner-message-container"), n.appendChild(r), n.classList.add("outer-message-container"), n.classList.add(Ft.buildRoleOuterContainerClass(s));
      var i = document.createElement("div");
      return i.classList.add("message-bubble"), r.appendChild(i), {
        outerContainer: n,
        innerContainer: r,
        bubbleElement: i
      };
    }
  }, {
    key: "createMessageContent",
    value: function(s) {
      var n = s.text, r = s.files, i = s.html, o = s.custom, l = s._sessionId, d = s.role, c = {
        role: d || Ft.AI_ROLE
      };
      return n && (c.text = n), r && (c.files = r), i && (c.html = i), !n && !r && !i && (c.text = ""), o && (c.custom = o), l && (c._sessionId = l), c;
    }
  }, {
    key: "isLoadingMessage",
    value: function(s) {
      return s == null ? void 0 : s.bubbleElement.classList.contains(qi.BUBBLE_CLASS);
    }
  }]);
}();
Oh.TEXT_BUBBLE_CLASS = "text-message", Oh.INTRO_CLASS = "deep-chat-intro", Oh.LAST_GROUP_MESSAGES_ACTIVE = "deep-chat-last-group-messages-active";
var Vr = Oh, fo = /* @__PURE__ */ function() {
  function e() {
    je(this, e);
  }
  return He(e, null, [{
    key: "getLastElementsByClass",
    value: function(s, n, r) {
      for (var i = function() {
        var c = s[l];
        if (c.bubbleElement.classList.contains(n[0]) && !n.slice(1).find(function(u) {
          return !c.bubbleElement.classList.contains(u);
        })) if (r) {
          if (!r.find(function(u) {
            return c.bubbleElement.classList.contains(u);
          })) return {
            v: c
          };
        } else return {
          v: c
        };
      }, o, l = s.length - 1; l >= 0; l -= 1)
        if (o = i(), o) return o.v;
    }
  }, {
    key: "getLastMessage",
    value: function(s, n, r) {
      for (var i = s.length - 1; i >= 0; i -= 1) if (s[i][0].role === n) if (r) {
        if (s[i][0][r]) return s[i][0];
      } else return s[i][0];
    }
  }, {
    key: "getLastTextToElement",
    value: function(s, n) {
      for (var r = s.length - 1; r >= 0; r -= 1) if (s[r][0] === n) return s[r];
    }
    // IMPORTANT: If the overwrite message does not contain a role property it will look for the last 'ai' role message
    // and if messages have custom roles, it will still look to update the last 'ai' role message
    // prettier-ignore
  }, {
    key: "overwriteMessage",
    value: function(s, n, r, i, o, l) {
      var d = e.getLastElementsByClass(n, [e.getRoleClass(i), l], [qi.BUBBLE_CLASS]), c = e.getLastMessage(s, i, o);
      return c && (c[o] = r), d;
    }
  }, {
    key: "getRoleClass",
    value: function(s) {
      return "".concat(s, "-message");
    }
    // makes sure the bubble has dimensions when there is no text
  }, {
    key: "fillEmptyMessageElement",
    value: function(s, n) {
      n.trim().length === 0 && (s.classList.add(e.EMPTY_MESSAGE_CLASS), s.innerHTML = '<div style="color:#00000000">.</div>');
    }
  }, {
    key: "unfillEmptyMessageElement",
    value: function(s, n) {
      s.classList.contains(e.EMPTY_MESSAGE_CLASS) && n.trim().length > 0 && s.replaceChildren();
    }
  }, {
    key: "getLastMessageBubbleElement",
    value: function(s) {
      var n, r, i, o;
      return (o = Array.from(((i = (r = (n = e.getLastMessageElement(s)) == null ? void 0 : n.children) == null ? void 0 : r[0]) == null ? void 0 : i.children) || []).map(function(l) {
        return Array.from((l == null ? void 0 : l.children) || []).find(function(d) {
          return d.classList.contains("message-bubble");
        });
      })) == null ? void 0 : o[0];
    }
  }, {
    key: "getLastMessageElement",
    value: function(s) {
      return s.children[s.children.length - 1];
    }
  }, {
    key: "addRoleElements",
    value: function(s, n, r, i) {
      r == null || r.addBesideMsg(s, n), i == null || i.addBesideMsg(s, n);
    }
  }, {
    key: "hideRoleElements",
    value: function(s, n, r) {
      n == null || n.tryHide(s), r == null || r.tryHide(s);
    }
  }, {
    key: "revealRoleElements",
    value: function(s, n, r) {
      n == null || n.tryReveal(s), r == null || r.tryReveal(s);
    }
  }, {
    key: "softRemRoleElements",
    value: function(s, n, r) {
      n == null || n.trySoftRem(s), r == null || r.trySoftRem(s);
    }
  }, {
    key: "updateRefArr",
    value: function(s, n, r) {
      r ? s.unshift(n) : s.push(n);
    }
  }, {
    key: "buildRoleOuterContainerClass",
    value: function(s) {
      return "".concat(e.OUTER_CONTAINER_CLASS_ROLE_PREFIX).concat(s);
    }
  }, {
    key: "addNewPositionClasses",
    value: function(s, n) {
      var r;
      s.outerContainer.classList.remove(e.POSITION_TOP_MESSAGE_CLASS, e.POSITION_MIDDLE_MESSAGE_CLASS, e.POSITION_BOTTOM_MESSAGE_CLASS), (r = s.outerContainer.classList).add.apply(r, Qu(n));
    }
  }, {
    key: "getNumberOfElements",
    value: function(s) {
      var n = 0;
      return s.text !== void 0 && (n += 1), s.html !== void 0 && (n += 1), s.files && (n += s.files.length), n;
    }
  }, {
    key: "filterdMessageElements",
    value: function(s, n) {
      return s.filter(function(r) {
        return r.bubbleElement.classList.contains(n);
      });
    }
  }, {
    key: "findMessageElements",
    value: function(s, n) {
      return s.find(function(r) {
        return r.bubbleElement.classList.contains(n);
      });
    }
  }, {
    key: "generateMessageBodyElements",
    value: function(s, n) {
      var r = {};
      return s.text && (r.text = e.findMessageElements(n, Vr.TEXT_BUBBLE_CLASS)), s.html && (r.html = e.findMessageElements(n, mi.HTML_BUBBLE_CLASS)), s.files && (r.files = e.filterdMessageElements(n, cn.FILE_BUBBLE_CLASS)), r;
    }
  }, {
    key: "generateMessageBody",
    value: function(s, n) {
      var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, i = e.getNumberOfElements(s), o = r ? n.slice(0, i) : n.slice(n.length - i);
      return e.generateMessageBodyElements(s, o);
    }
    // if role not present - traverse all, if present - traverse last messages
  }, {
    key: "classifyRoleMessages",
    value: function(s, n) {
      for (var r = n ? e.buildRoleOuterContainerClass(n) : void 0, i = s.length - 1; i >= 0; i -= 1)
        if (n || (r = Array.from(s[i].outerContainer.classList).find(function(f) {
          return f.startsWith(e.OUTER_CONTAINER_CLASS_ROLE_PREFIX);
        })), !!r) {
          var o = s[i], l = o.outerContainer.classList.contains(r), d = s[i - 1], c = s[i + 1], u = d == null ? void 0 : d.outerContainer.classList.contains(r), m = c == null ? void 0 : c.outerContainer.classList.contains(r);
          if (l) !u && m ? e.addNewPositionClasses(o, [e.POSITION_TOP_MESSAGE_CLASS]) : u && m ? e.addNewPositionClasses(o, [e.POSITION_MIDDLE_MESSAGE_CLASS]) : u && !m ? e.addNewPositionClasses(o, [e.POSITION_BOTTOM_MESSAGE_CLASS]) : !u && !m && e.addNewPositionClasses(o, [e.POSITION_TOP_MESSAGE_CLASS, e.POSITION_BOTTOM_MESSAGE_CLASS]);
          else if (n) break;
        }
    }
  }, {
    key: "areOuterContainerClassRolesSame",
    value: function(s, n) {
      return n ? Array.from(n.outerContainer.classList).find(function(r) {
        return r.startsWith(e.OUTER_CONTAINER_CLASS_ROLE_PREFIX);
      }) === e.buildRoleOuterContainerClass(s) : !1;
    }
  }, {
    key: "resetAllRoleElements",
    value: function(s, n, r) {
      if (!(!n && !r)) {
        var i = "";
        s.forEach(function(o, l) {
          o.bubbleElement.classList.contains(e.ERROR_MESSAGE_TEXT_CLASS) || e.revealRoleElements(o.innerContainer, n, r);
          var d = Array.from(o.outerContainer.classList).find(function(c) {
            return c.startsWith(e.OUTER_CONTAINER_CLASS_ROLE_PREFIX);
          });
          i === d && e.hideRoleElements(s[l - 1].innerContainer, n, r), i = d;
        });
      }
    }
    // this is a workaround to prevent JSON.parse(JSON.stringify()) from removing the files' 'ref' property values
    // and 'custom' property value if it is not shallow copyable
    // note - structuredClone can fix this but it doesn't have good legacy compatibility
  }, {
    key: "deepCloneMessagesWithReferences",
    value: function(s) {
      return s.map(function(n) {
        return e.processMessageContent(n);
      });
    }
  }, {
    key: "processMessageContent",
    value: function(s) {
      if (s == null || St(s) != "object") return s;
      if (Array.isArray(s)) return s.map(function(r) {
        return e.processMessageContent(r);
      });
      var n = {};
      return Object.entries(s).forEach(function(r) {
        var i = dl(r, 2), o = i[0], l = i[1];
        o === "ref" && l instanceof File || o === "custom" ? n[o] = l : l !== null && St(l) == "object" ? n[o] = e.processMessageContent(l) : n[o] = l;
      }), n;
    }
  }]);
}();
fo.AI_ROLE = "ai", fo.USER_ROLE = "user", fo.ERROR_MESSAGE_TEXT_CLASS = "error-message-text", fo.OUTER_CONTAINER_CLASS_ROLE_PREFIX = "deep-chat-outer-container-role-", fo.EMPTY_MESSAGE_CLASS = "empty-message", fo.POSITION_TOP_MESSAGE_CLASS = "deep-chat-top-message", fo.POSITION_MIDDLE_MESSAGE_CLASS = "deep-chat-middle-message", fo.POSITION_BOTTOM_MESSAGE_CLASS = "deep-chat-bottom-message";
var Ft = fo, Rh = /* @__PURE__ */ function() {
  function e(t, s) {
    je(this, e), this._fileAdded = !1, this._streamType = "", this._hasStreamEnded = !1, this._partialText = "", this._messages = t, St(s) == "object" && (this._partialRender = s.partialRender, this._customWrappers = s.htmlWrappers);
  }
  return He(e, [{
    key: "upsertStreamedMessage",
    value: function(s) {
      if (!this._hasStreamEnded) {
        if ((s == null ? void 0 : s.text) === void 0 && (s == null ? void 0 : s.html) === void 0) return console.error(Ys.INVALID_STREAM_EVENT);
        s != null && s.custom && this._message && (this._message.custom = s.custom);
        var n = (s == null ? void 0 : s.text) || (s == null ? void 0 : s.html) || "", r = Ln.isScrollbarAtBottomOfElement(this._messages.elementRef), i = (s == null ? void 0 : s.text) !== void 0 ? "text" : "html";
        if (!this._elements && !this._message) this.setInitialState(i, n, s == null ? void 0 : s.role);
        else {
          if (this._streamType !== i) return console.error(Ys.INVALID_STREAM_EVENT_MIX);
          this.updateBasedOnType(n, i, s == null ? void 0 : s.overwrite);
        }
        r && Ln.scrollToBottom(this._messages.elementRef);
      }
    }
  }, {
    key: "setInitialState",
    value: function(s, n, r) {
      var i, o, l;
      this._streamType = s, r ?? (r = Ft.AI_ROLE);
      var d = ((i = this._customWrappers) == null ? void 0 : i[r]) || ((o = this._customWrappers) == null ? void 0 : o.default), c = d ? "" : n;
      this._elements = s === "text" ? this._messages.addNewTextMessage(c, r) : mi.add(this._messages, c, r), this._elements && (this._elements.bubbleElement.classList.add(e.MESSAGE_CLASS), this._activeMessageRole = r, this._message = wm({
        role: this._activeMessageRole
      }, s, c), this._messages.messageToElements.push([this._message, wm({}, s, this._elements)]), (l = this._messages.browserStorage) == null || l.addMessages(this._messages.messageToElements.map(function(u) {
        var m = dl(u, 1), f = m[0];
        return f;
      })), d && this.setTargetWrapperIfNeeded(this._elements, n, this._streamType, d));
    }
  }, {
    key: "setTargetWrapperIfNeeded",
    value: function(s, n, r, i) {
      s.bubbleElement.innerHTML = i, this._targetWrapper = s.bubbleElement.getElementsByClassName(e.TARGET_WRAPPER_CLASS)[0], this._elements && Oo.apply(this._messages, this._elements.bubbleElement), this.updateBasedOnType(n, r);
    }
  }, {
    key: "updateBasedOnType",
    value: function(s, n) {
      var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, i, o = this._targetWrapper || ((i = this._elements) == null ? void 0 : i.bubbleElement);
      this._partialRender || Ft.unfillEmptyMessageElement(o, s), (n === "text" ? this.updateText : this.updateHTML).bind(this)(s, o, r);
    }
  }, {
    key: "updateText",
    value: function(s, n, r) {
      this._message && (this._message.text = r ? s : this._message.text + s, this._partialRender && this.isNewPartialRenderParagraph(n, r) && this.partialRenderNewParagraph(n), this._partialBubble ? this.partialRenderBubbleUpdate(s) : this._messages.renderText(n, this._message.text));
    }
  }, {
    key: "isNewPartialRenderParagraph",
    value: function(s, n) {
      var r, i;
      return n ? (s.innerHTML = "", !0) : this._partialBubble ? this._partialText && ((i = this._partialText) == null ? void 0 : i.indexOf(e.PARTIAL_RENDER_TEXT_MARK)) > -1 : ((r = this._message) == null ? void 0 : r.text) && this._message.text.indexOf(e.PARTIAL_RENDER_TEXT_MARK) > -1;
    }
  }, {
    key: "partialRenderNewParagraph",
    value: function(s) {
      this._partialText = "", this._partialBubble = document.createElement("div"), this._partialBubble.classList.add("partial-render-message"), s.appendChild(this._partialBubble);
    }
  }, {
    key: "partialRenderBubbleUpdate",
    value: function(s) {
      this._partialText += s, this._messages.renderText(this._partialBubble, this._partialText);
    }
  }, {
    key: "updateHTML",
    value: function(s, n, r) {
      if (this._message) if (r) this._message.html = s, n.innerHTML = s;
      else {
        var i = document.createElement("span");
        i.innerHTML = s, n.appendChild(i), this._message.html = (n == null ? void 0 : n.innerHTML) || "";
      }
    }
  }, {
    key: "finaliseStreamedMessage",
    value: function() {
      var s;
      if (!(this._endStreamAfterOperation || !this._message) && !(this._fileAdded && !this._elements)) {
        if (!this._elements) throw Error(Ys.NO_VALID_STREAM_EVENTS_SENT);
        (s = this._elements.bubbleElement) != null && s.classList.contains(e.MESSAGE_CLASS) && (this._streamType === "text" ? this._messages.textToSpeech && Eh.speak(this._message.text || "", this._messages.textToSpeech) : this._streamType === "html" && this._elements && Oo.apply(this._messages, this._elements.outerContainer), this._elements.bubbleElement.classList.remove(e.MESSAGE_CLASS), this._message && (this._targetWrapper && (this._message.html = this._elements.bubbleElement.children[0].outerHTML, this._streamType === "text" && delete this._message.text), this._messages.sendClientUpdate(Vr.createMessageContent(this._message), !1)), this._hasStreamEnded = !0);
      }
    }
  }, {
    key: "markFileAdded",
    value: function() {
      this._fileAdded = !0;
    }
  }, {
    key: "newMessage",
    value: function() {
      this.finaliseStreamedMessage(), this._elements = void 0, delete this._message, this._fileAdded = !1, this._hasStreamEnded = !1, this._activeMessageRole = void 0;
    }
    // prettier-ignore
  }, {
    key: "endStreamAfterFileDownloaded",
    value: function() {
      var t = Qe(/* @__PURE__ */ ce().mark(function n(r, i) {
        var o, l, d;
        return ce().wrap(function(u) {
          for (; ; ) switch (u.prev = u.next) {
            case 0:
              return this._endStreamAfterOperation = !0, u.next = 3, i();
            case 3:
              o = u.sent, l = o.text, d = o.files, l && this.updateBasedOnType(l, "text", !0), this._endStreamAfterOperation = !1, this.finaliseStreamedMessage(), d && r.addNewMessage({
                files: d
              });
            case 7:
            case "end":
              return u.stop();
          }
        }, n, this);
      }));
      function s(n, r) {
        return t.apply(this, arguments);
      }
      return s;
    }()
  }]);
}();
Rh.MESSAGE_CLASS = "streamed-message", Rh.PARTIAL_RENDER_TEXT_MARK = `

`, Rh.TARGET_WRAPPER_CLASS = "stream-wrapper";
var fi = Rh, S5 = /* @__PURE__ */ function() {
  function e() {
    je(this, e);
  }
  return He(e, null, [{
    key: "tempRemoveContentHeader",
    value: (
      // need to pass stringifyBody boolean separately as binding is throwing an error for some reason
      // prettier-ignore
      function() {
        var t = Qe(/* @__PURE__ */ ce().mark(function n(r, i, o) {
          var l, d;
          return ce().wrap(function(u) {
            for (; ; ) switch (u.prev = u.next) {
              case 0:
                if (r != null && r.headers) {
                  u.next = 2;
                  break;
                }
                throw new Error("Request settings have not been set up");
              case 2:
                return l = r.headers[e.CONTENT_TYPE], delete r.headers[e.CONTENT_TYPE], u.prev = 4, u.next = 7, i(o);
              case 7:
                d = u.sent, u.next = 13;
                break;
              case 10:
                throw u.prev = 10, u.t0 = u.catch(4), r.headers[e.CONTENT_TYPE] = l, u.t0;
              case 13:
                return u.abrupt("return", (r.headers[e.CONTENT_TYPE] = l, d));
              case 14:
              case "end":
                return u.stop();
            }
          }, n, null, [[4, 10]]);
        }));
        function s(n, r, i) {
          return t.apply(this, arguments);
        }
        return s;
      }()
    )
  }, {
    key: "displayError",
    value: function(s, n) {
      var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "Service error, please try again.";
      if (console.error(n), St(n) == "object") return n instanceof Error ? s.addNewErrorMessage("service", n.message) : Array.isArray(n) || typeof n.error == "string" ? s.addNewErrorMessage("service", n) : Object.keys(n).length === 0 ? s.addNewErrorMessage("service", r) : s.addNewErrorMessage("service", JSON.stringify(n));
      s.addNewErrorMessage("service", n);
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  }, {
    key: "fetch",
    value: function(t) {
      function s(n, r, i, o) {
        return t.apply(this, arguments);
      }
      return s.toString = function() {
        return t.toString();
      }, s;
    }(function(t, s, n, r) {
      var i, o, l = {
        method: ((i = t.connectSettings) == null ? void 0 : i.method) || "POST",
        headers: s
      };
      return l.method !== "GET" && (l.body = n ? JSON.stringify(r) : r), t.connectSettings.credentials && (l.credentials = t.connectSettings.credentials), fetch(((o = t.connectSettings) == null ? void 0 : o.url) || t.url || "", l);
    })
  }, {
    key: "processResponseByType",
    value: function(s) {
      var n = s.headers.get("content-type");
      return n != null && n.includes("application/json") ? s.json() : n != null && n.includes("text/plain") || !n ? s : s.blob();
    }
  }, {
    key: "processRequestInterceptor",
    value: function() {
      var t = Qe(/* @__PURE__ */ ce().mark(function n(r, i) {
        var o, l, d, c;
        return ce().wrap(function(m) {
          for (; ; ) switch (m.prev = m.next) {
            case 0:
              return m.next = 2, (o = r.requestInterceptor) == null ? void 0 : o.call(r, i);
            case 2:
              if (m.t0 = m.sent, m.t0) {
                m.next = 5;
                break;
              }
              m.t0 = i;
            case 5:
              return l = m.t0, d = l, c = l, m.abrupt("return", {
                body: d.body,
                headers: d.headers,
                error: c.error
              });
            case 9:
            case "end":
              return m.stop();
          }
        }, n);
      }));
      function s(n, r) {
        return t.apply(this, arguments);
      }
      return s;
    }()
  }, {
    key: "validateResponseFormat",
    value: function(s, n) {
      if (!s) return !1;
      var r = Array.isArray(s) ? s : [s];
      return n && r.length > 1 ? (console.error(Ys.INVALID_STREAM_ARRAY_RESPONSE), !1) : !r.find(function(i) {
        return St(i) != "object" || !(typeof i.error == "string" || typeof i.text == "string" || typeof i.html == "string" || Array.isArray(i.files));
      });
    }
  }, {
    key: "onInterceptorError",
    value: function(s, n, r) {
      s.addNewErrorMessage("service", n), r == null || r();
    }
    // prettier-ignore
  }, {
    key: "basicResponseProcessing",
    value: function() {
      var t = Qe(/* @__PURE__ */ ce().mark(function n(r, i) {
        var o, l, d, c, u, m, f, v, b, w, S = arguments;
        return ce().wrap(function(T) {
          for (; ; ) switch (T.prev = T.next) {
            case 0:
              if (o = S.length > 2 && S[2] !== void 0 ? S[2] : {}, l = o.io, d = o.displayError, c = d === void 0 ? !0 : d, u = o.useRI, m = u === void 0 ? !0 : u, l != null && l.extractResultData) {
                T.next = 4;
                break;
              }
              return T.abrupt("return", i);
            case 4:
              return f = m ? l.deepChat.responseInterceptor : void 0, T.next = 7, f == null ? void 0 : f(i);
            case 7:
              if (T.t0 = T.sent, T.t0) {
                T.next = 10;
                break;
              }
              T.t0 = i;
            case 10:
              return v = T.t0, T.next = 13, l.extractResultData(v);
            case 13:
              if (b = T.sent, !(!b || St(b) != "object" && !Array.isArray(b))) {
                T.next = 17;
                break;
              }
              return c && (w = Ys.INVALID_RESPONSE(i, "response", !!f, v), e.displayError(r, w)), T.abrupt("return");
            case 17:
              return T.abrupt("return", b);
            case 18:
            case "end":
              return T.stop();
          }
        }, n);
      }));
      function s(n, r) {
        return t.apply(this, arguments);
      }
      return s;
    }()
  }]);
}();
S5.CONTENT_TYPE = "Content-Type";
var Kt = S5;
function Mje(e, t) {
  return ky.apply(this, arguments);
}
function ky() {
  return ky = Qe(/* @__PURE__ */ ce().mark(function e(t, s) {
    var n, r;
    return ce().wrap(function(o) {
      for (; ; ) switch (o.prev = o.next) {
        case 0:
          n = t.getReader();
        case 1:
          return o.next = 3, n.read();
        case 3:
          if ((r = o.sent).done) {
            o.next = 7;
            break;
          }
          s(r.value);
        case 5:
          o.next = 1;
          break;
        case 7:
        case "end":
          return o.stop();
      }
    }, e);
  })), ky.apply(this, arguments);
}
function xje(e) {
  var t, s, n, r = !1;
  return function(i) {
    t === void 0 ? (t = i, s = 0, n = -1) : t = Vje(t, i);
    for (var o = t.length, l = 0; s < o; ) {
      r && (t[s] === 10 && (l = ++s), r = !1);
      for (var d = -1; s < o && d === -1; ++s) switch (t[s]) {
        case 58:
          n === -1 && (n = s - l);
          break;
        case 13:
          r = !0;
        case 10:
          d = s;
          break;
      }
      if (d === -1) break;
      e(t.subarray(l, d), n), l = s, n = -1;
    }
    l === o ? t = void 0 : l !== 0 && (t = t.subarray(l), s -= l);
  };
}
function Fje(e, t, s) {
  var n = aC(), r = new TextDecoder();
  return function(i, o) {
    if (i.length === 0) s == null || s(n), n = aC();
    else if (o > 0) {
      var l = r.decode(i.subarray(0, o)), d = o + (i[o + 1] === 32 ? 2 : 1), c = r.decode(i.subarray(d));
      switch (l) {
        case "data":
          n.data = n.data ? n.data + `
` + c : c;
          break;
        case "event":
          n.event = c;
          break;
        case "id":
          e(n.id = c);
          break;
        case "retry":
          var u = parseInt(c, 10);
          isNaN(u) || t(n.retry = u);
          break;
      }
    }
  };
}
function Vje(e, t) {
  var s = new Uint8Array(e.length + t.length);
  return s.set(e), s.set(t, e.length), s;
}
function aC() {
  return {
    data: "",
    event: "",
    id: "",
    retry: void 0
  };
}
var Dje = function(t, s) {
  var n = {};
  for (var r in t) Object.prototype.hasOwnProperty.call(t, r) && s.indexOf(r) < 0 && (n[r] = t[r]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function") for (var i = 0, r = Object.getOwnPropertySymbols(t); i < r.length; i++) s.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(t, r[i]) && (n[r[i]] = t[r[i]]);
  return n;
}, Ey = "text/event-stream", Nje = 1e3, nC = "last-event-id";
function jje(e, t) {
  var s = t.signal, n = t.headers, r = t.onopen, i = t.onmessage, o = t.onclose, l = t.onerror, d = t.openWhenHidden, c = t.fetch, u = Dje(t, ["signal", "headers", "onopen", "onmessage", "onclose", "onerror", "openWhenHidden", "fetch"]);
  return new Promise(function(m, f) {
    var v = Object.assign({}, n);
    v.accept || (v.accept = Ey);
    var b;
    function w() {
      b.abort(), document.hidden || C();
    }
    d || document.addEventListener("visibilitychange", w);
    var S = Nje, I = 0;
    function T() {
      document.removeEventListener("visibilitychange", w), window.clearTimeout(I), b.abort();
    }
    s == null || s.addEventListener("abort", function() {
      T(), m();
    });
    var x = c ?? window.fetch, k = r ?? Hje;
    function C() {
      return O.apply(this, arguments);
    }
    function O() {
      return O = Qe(/* @__PURE__ */ ce().mark(function E() {
        var B, M, R;
        return ce().wrap(function(L) {
          for (; ; ) switch (L.prev = L.next) {
            case 0:
              return b = new AbortController(), L.prev = 1, L.next = 4, x(e, Object.assign(Object.assign({}, u), {
                headers: v,
                signal: b.signal
              }));
            case 4:
              return M = L.sent, L.next = 7, k(M);
            case 7:
              return L.next = 9, Mje(M.body, xje(Fje(function(j) {
                j ? v[nC] = j : delete v[nC];
              }, function(j) {
                S = j;
              }, i)));
            case 9:
              o == null || o(), T(), m(), L.next = 17;
              break;
            case 14:
              if (L.prev = 14, L.t0 = L.catch(1), !b.signal.aborted) try {
                R = (B = l == null ? void 0 : l(L.t0)) !== null && B !== void 0 ? B : S, window.clearTimeout(I), I = window.setTimeout(C, R);
              } catch (j) {
                T(), f(j);
              }
            case 17:
            case "end":
              return L.stop();
          }
        }, E, null, [[1, 14]]);
      })), O.apply(this, arguments);
    }
    C();
  });
}
function Hje(e) {
  var t = e.headers.get("content-type");
  if (!(t != null && t.startsWith(Ey))) throw new Error("Expected content-type to be ".concat(Ey, ", Actual: ").concat(t));
}
var Da = /* @__PURE__ */ function() {
  function e() {
    je(this, e);
  }
  return He(e, null, [{
    key: "request",
    value: (
      // prettier-ignore
      function() {
        var t = Qe(/* @__PURE__ */ ce().mark(function n(r, i, o) {
          var l, d, c, u, m, f, v, b, w, S, I, T, x, k, C, O = arguments;
          return ce().wrap(function(B) {
            for (; ; ) switch (B.prev = B.next) {
              case 0:
                return l = O.length > 3 && O[3] !== void 0 ? O[3] : !0, d = O.length > 4 && O[4] !== void 0 ? O[4] : !1, b = {
                  body: i,
                  headers: (c = r.connectSettings) == null ? void 0 : c.headers
                }, B.next = 5, Kt.processRequestInterceptor(r.deepChat, b);
              case 5:
                if (w = B.sent, S = w.body, I = w.headers, T = w.error, !T) {
                  B.next = 11;
                  break;
                }
                return B.abrupt("return", Kt.onInterceptorError(o, T, r.streamHandlers.onClose));
              case 11:
                if (!((u = r.connectSettings) != null && u.handler)) {
                  B.next = 13;
                  break;
                }
                return B.abrupt("return", Lb.stream(r, S, o));
              case 13:
                if (((m = r.connectSettings) == null ? void 0 : m.url) !== Uo.URL) {
                  B.next = 15;
                  break;
                }
                return B.abrupt("return", Uo.requestStream(o, r));
              case 15:
                return x = new fi(o, r.stream), k = Kt.fetch.bind(this, r, I, l), C = {
                  method: ((f = r.connectSettings) == null ? void 0 : f.method) || "POST",
                  headers: I,
                  credentials: (v = r.connectSettings) == null ? void 0 : v.credentials,
                  body: l ? JSON.stringify(S) : S
                }, B.abrupt("return", (St(r.stream) == "object" && r.stream.readable ? e.handleReadableStream(r, o, x, C, d, k, S) : e.handleEventStream(r, o, x, C, d, k, S), x));
              case 17:
              case "end":
                return B.stop();
            }
          }, n, this);
        }));
        function s(n, r, i) {
          return t.apply(this, arguments);
        }
        return s;
      }()
    )
    // prettier-ignore
  }, {
    key: "handleReadableStream",
    value: function(s, n, r, i, o, l, d) {
      var c, u = s.streamHandlers, m = u.onOpen, f = u.onClose, v = u.abortStream, b = !1;
      fetch(((c = s.connectSettings) == null ? void 0 : c.url) || s.url || "", i).then(/* @__PURE__ */ function() {
        var w = Qe(/* @__PURE__ */ ce().mark(function S(I) {
          var T, x, k, C, O, E, B, M, R, F, L;
          return ce().wrap(function(H) {
            for (; ; ) switch (H.prev = H.next) {
              case 0:
                if (I.body) {
                  H.next = 2;
                  break;
                }
                throw new Error(Ys.READABLE_STREAM_CONNECTION_ERROR);
              case 2:
                k = I.body.getReader(), C = new TextDecoder(), m(), O = !1;
              case 5:
                if (!(!O && !b)) {
                  H.next = 26;
                  break;
                }
                return H.next = 8, k.read();
              case 8:
                if (E = H.sent, B = E.value, M = E.done, O = M, !O) {
                  H.next = 15;
                  break;
                }
                e.handleClose(s, r, f, o), H.next = 24;
                break;
              case 15:
                return R = C.decode(B, {
                  stream: !0
                }), H.next = 18, (x = (T = s.deepChat).responseInterceptor) == null ? void 0 : x.call(T, R);
              case 18:
                if (H.t0 = H.sent, H.t0) {
                  H.next = 21;
                  break;
                }
                H.t0 = R;
              case 21:
                F = H.t0, L = St(F) == "object" ? F : {
                  text: R
                }, e.handleMessage(s, n, r, f, L, l, d);
              case 24:
                H.next = 5;
                break;
              case 26:
              case "end":
                return H.stop();
            }
          }, S);
        }));
        return function(S) {
          return w.apply(this, arguments);
        };
      }()).catch(function(w) {
        e.handleError(s, n, w);
      }), v.abort = function() {
        b = !0;
      };
    }
    // prettier-ignore
  }, {
    key: "handleEventStream",
    value: function(s, n, r, i, o, l, d) {
      var c, u = s.streamHandlers, m = u.onOpen, f = u.onClose, v = u.abortStream;
      jje(((c = s.connectSettings) == null ? void 0 : c.url) || s.url || "", ys(ys({}, i), {}, {
        openWhenHidden: !0,
        // keep stream open when browser tab not open
        onopen: function(w) {
          return Qe(/* @__PURE__ */ ce().mark(function S() {
            return ce().wrap(function(T) {
              for (; ; ) switch (T.prev = T.next) {
                case 0:
                  if (!w.ok) {
                    T.next = 2;
                    break;
                  }
                  return T.abrupt("return", m());
                case 2:
                  return T.next = 4, Kt.processResponseByType(w);
                case 4:
                  throw T.sent;
                case 5:
                case "end":
                  return T.stop();
              }
            }, S);
          }))();
        },
        onmessage: function(w) {
          return Qe(/* @__PURE__ */ ce().mark(function S() {
            var I, T, x, k;
            return ce().wrap(function(O) {
              for (; ; ) switch (O.prev = O.next) {
                case 0:
                  if (JSON.stringify(w.data) === JSON.stringify("[DONE]")) {
                    O.next = 9;
                    break;
                  }
                  try {
                    x = JSON.parse(w.data);
                  } catch {
                    x = {};
                  }
                  return O.next = 4, (T = (I = s.deepChat).responseInterceptor) == null ? void 0 : T.call(I, x);
                case 4:
                  if (O.t0 = O.sent, O.t0) {
                    O.next = 7;
                    break;
                  }
                  O.t0 = x;
                case 7:
                  k = O.t0, e.handleMessage(s, n, r, f, k, l, d);
                case 9:
                case "end":
                  return O.stop();
              }
            }, S);
          }))();
        },
        onerror: function(w) {
          throw f(), w;
        },
        onclose: function() {
          e.handleClose(s, r, f, o);
        },
        signal: v.signal
      })).catch(function(b) {
        e.handleError(s, n, b);
      });
    }
    //prettier-ignore
  }, {
    key: "handleMessage",
    value: function(s, n, r, i, o, l, d) {
      var c;
      (c = s.extractResultData) == null || c.call(s, o, l, d).then(function(u) {
        s.asyncCallInProgress && u && u.text !== "" ? (e.simulate(n, s.streamHandlers, u), i(), s.asyncCallInProgress = !1) : e.upsertWFiles(n, r.upsertStreamedMessage.bind(r), r, u);
      }).catch(function(u) {
        return Kt.displayError(n, u);
      });
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  }, {
    key: "handleError",
    value: function(s, n, r) {
      var i;
      n.isLastMessageError() || (i = s.extractResultData) == null || i.call(s, r).then(function() {
        Kt.displayError(n, r);
      }).catch(function(o) {
        Kt.displayError(n, o);
      });
    }
  }, {
    key: "handleClose",
    value: function(s, n, r, i) {
      if (!s.asyncCallInProgress) try {
        n.finaliseStreamedMessage(), r();
      } catch (o) {
        if (!i) throw o;
      }
    }
    // io is only passed for demo to simulate a real stream
  }, {
    key: "simulate",
    value: function() {
      var t = Qe(/* @__PURE__ */ ce().mark(function n(r, i, o, l) {
        var d, c, u, m, f, v;
        return ce().wrap(function(w) {
          for (; ; ) switch (w.prev = w.next) {
            case 0:
              return d = i, w.next = 3, Kt.basicResponseProcessing(r, o, {
                io: l,
                useRI: !1
              });
            case 3:
              if (w.sent) {
                w.next = 5;
                break;
              }
              return w.abrupt("return", i.onClose());
            case 5:
              if (Array.isArray(o) && (o = o[0]), !o.files) {
                w.next = 10;
                break;
              }
              return w.next = 8, Kt.basicResponseProcessing(r, {
                files: o.files
              }, {
                io: l
              });
            case 8:
              c = w.sent, r.addNewMessage(ys({
                sendUpdate: !1,
                ignoreText: !0
              }, c), !1);
            case 10:
              o.text && (i.onOpen(), u = o.text.split(""), m = new fi(r, l == null ? void 0 : l.stream), e.populateMessages(r, u, m, d, "text", 0, l)), o.html && (i.onOpen(), f = Oo.splitHTML(o.html), f.length === 0 && (f = o.html.split("")), v = new fi(r, l == null ? void 0 : l.stream), e.populateMessages(r, f, v, d, "html", 0, l)), o.error && (Kt.displayError(r, o.error), i.onClose());
            case 13:
            case "end":
              return w.stop();
          }
        }, n);
      }));
      function s(n, r, i, o) {
        return t.apply(this, arguments);
      }
      return s;
    }()
    // prettier-ignore
    // io is only passed for demo to simulate a real stream
  }, {
    key: "populateMessages",
    value: function() {
      var t = Qe(/* @__PURE__ */ ce().mark(function n(r, i, o, l, d, c, u) {
        var m, f, v;
        return ce().wrap(function(w) {
          for (; ; ) switch (w.prev = w.next) {
            case 0:
              if (m = i[c], !m) {
                w.next = 10;
                break;
              }
              return w.next = 4, Kt.basicResponseProcessing(r, wm({}, d, m), {
                io: u
              });
            case 4:
              f = w.sent, e.upsertWFiles(r, o.upsertStreamedMessage.bind(o), o, f), v = setTimeout(function() {
                e.populateMessages(r, i, o, l, d, c + 1, u);
              }, l.simulationInterim || 6), l.abortStream.abort = function() {
                e.abort(v, o, l.onClose);
              }, w.next = 11;
              break;
            case 10:
              o.finaliseStreamedMessage(), l.onClose();
            case 11:
            case "end":
              return w.stop();
          }
        }, n);
      }));
      function s(n, r, i, o, l, d, c) {
        return t.apply(this, arguments);
      }
      return s;
    }()
  }, {
    key: "isSimulation",
    value: function(s) {
      return St(s) == "object" && !!s.simulation;
    }
  }, {
    key: "isSimulatable",
    value: function(s, n) {
      return e.isSimulation(s) && n && (n.text || n.html);
    }
  }, {
    key: "abort",
    value: function(s, n, r) {
      clearTimeout(s), n.finaliseStreamedMessage(), r();
    }
  }, {
    key: "upsertWFiles",
    value: function(s, n, r, i) {
      if (i && Array.isArray(i) && (i = i[0]), i != null && i.text || i != null && i.html) {
        var o = n(i);
        r ?? (r = o || void 0);
      }
      i != null && i.files && (s.addNewMessage({
        files: i.files
      }), r == null || r.markFileAdded());
    }
  }]);
}(), P5 = /* @__PURE__ */ function() {
  function e() {
    je(this, e);
  }
  return He(e, null, [{
    key: "generateResponse",
    value: function(s) {
      var n = s[s.length - 1][0];
      if (n.files && n.files.length > 0) {
        if (n.files.length > 1) return "These are interesting files!";
        var r = n.files[0];
        return r.src && r.src.startsWith("data:image/gif") ? "That is a nice gif!" : r.type === "image" ? "That is a nice image!" : r.type === "audio" ? "I like the sound of that!" : "That is an interesting file!";
      }
      if (n.text) {
        if (n.text.charAt(n.text.length - 1) === "?") return "I'm sorry but I can't answer that question...";
        if (n.text.includes("updog")) return "What's updog?";
      }
      return "Hi there! This is a demo response!";
    }
  }, {
    key: "getCustomResponse",
    value: function(s, n) {
      return typeof s == "function" ? s(n) : s;
    }
  }, {
    key: "getResponse",
    value: function(s) {
      var n = s.customDemoResponse, r = s.messageToElements;
      return n ? e.getCustomResponse(n, r[r.length - 1][0]) : {
        text: e.generateResponse(r)
      };
    }
    // timeout is used to simulate a timeout for a response to come back
  }, {
    key: "request",
    value: function(s, n) {
      var r = e.getResponse(n);
      setTimeout(/* @__PURE__ */ Qe(/* @__PURE__ */ ce().mark(function i() {
        var o, l, d;
        return ce().wrap(function(u) {
          for (; ; ) switch (u.prev = u.next) {
            case 0:
              return u.next = 2, Kt.basicResponseProcessing(n, r, {
                io: s
              });
            case 2:
              if (o = u.sent, o) {
                u.next = 5;
                break;
              }
              return u.abrupt("return", s.completionsHandlers.onFinish());
            case 5:
              l = Array.isArray(o) ? o : [o], d = l.find(function(m) {
                return typeof m.error == "string";
              }), d ? (n.addNewErrorMessage("service", d.error), s.completionsHandlers.onFinish()) : Da.isSimulatable(s.stream, o) ? Da.simulate(n, s.streamHandlers, o) : (l.forEach(function(m) {
                return n.addNewMessage(m);
              }), s.completionsHandlers.onFinish());
            case 7:
            case "end":
              return u.stop();
          }
        }, i);
      })), 400);
    }
    // timeout is used to simulate a timeout for a response to come back
  }, {
    key: "requestStream",
    value: function(s, n) {
      setTimeout(function() {
        var r = e.getResponse(s);
        Da.simulate(s, n.streamHandlers, r, n);
      }, 400);
    }
  }]);
}();
P5.URL = "deep-chat-demo";
var Uo = P5, ku = /* @__PURE__ */ function() {
  function e() {
    je(this, e);
  }
  return He(e, null, [{
    key: "setup",
    value: function(s) {
      s.permittedErrorPrefixes = ["Connection error", "Error in server message"], s.websocket = "pending";
    }
  }, {
    key: "isElementPresentInDOM",
    value: function(s) {
      return s.getRootNode({
        composed: !0
      }) instanceof Document;
    }
  }, {
    key: "createConnection",
    value: function(s, n) {
      if (e.isElementPresentInDOM(s.deepChat)) {
        var r = s.connectSettings.websocket;
        if (r) {
          if (s.connectSettings.handler) return Lb.websocket(s, n);
          try {
            var i = typeof r != "boolean" ? r : void 0, o = new WebSocket(s.connectSettings.url || "", i);
            s.websocket = o, s.websocket.onopen = function() {
              var l, d;
              n.removeError(), s.websocket && St(s.websocket) == "object" && e.assignListeners(s, o, n), (d = (l = s.deepChat)._validationHandler) == null || d.call(l);
            }, s.websocket.onerror = function(l) {
              console.error(l), e.retryConnection(s, n);
            };
          } catch (l) {
            console.error(l), e.retryConnection(s, n);
          }
        }
      }
    }
  }, {
    key: "retryConnection",
    value: function(s, n) {
      var r, i;
      (i = (r = s.deepChat)._validationHandler) == null || i.call(r), e.isElementPresentInDOM(s.deepChat) && (s.websocket = "pending", n.isLastMessageError() || n.addNewErrorMessage("service", "Connection error"), setTimeout(function() {
        e.createConnection(s, n);
      }, 5e3));
    }
  }, {
    key: "assignListeners",
    value: function(s, n, r) {
      var i = this, o = {};
      n.onmessage = /* @__PURE__ */ function() {
        var l = Qe(/* @__PURE__ */ ce().mark(function d(c) {
          var u, m, f, v, b, w;
          return ce().wrap(function(I) {
            for (; ; ) switch (I.prev = I.next) {
              case 0:
                if (!s.extractResultData) {
                  I.next = 22;
                  break;
                }
                return I.prev = 1, u = JSON.parse(c.data), I.next = 5, Kt.basicResponseProcessing(r, u, {
                  io: s,
                  displayError: !1
                });
              case 5:
                if (m = I.sent, m) {
                  I.next = 8;
                  break;
                }
                throw Error(Ys.INVALID_RESPONSE(u, "server", !!s.deepChat.responseInterceptor, m));
              case 8:
                if (!Da.isSimulation(s.stream)) {
                  I.next = 13;
                  break;
                }
                f = e.stream.bind(i, s, r, o), v = o[u.role || Ft.AI_ROLE], Da.upsertWFiles(r, f, v, m), I.next = 17;
                break;
              case 13:
                if (b = Array.isArray(m) ? m : [m], w = b.find(function(T) {
                  return typeof T.error == "string";
                }), !w) {
                  I.next = 16;
                  break;
                }
                throw w.error;
              case 16:
                b.forEach(function(T) {
                  return r.addNewMessage(T);
                });
              case 17:
                I.next = 22;
                break;
              case 19:
                I.prev = 19, I.t0 = I.catch(1), Kt.displayError(r, I.t0, "Error in server message");
              case 22:
              case "end":
                return I.stop();
            }
          }, d, null, [[1, 19]]);
        }));
        return function(d) {
          return l.apply(this, arguments);
        };
      }(), n.onclose = function() {
        console.error("Connection closed"), r.isLastMessageError() || r.addNewErrorMessage("service", "Connection error"), s.stream && s.streamHandlers.abortStream.abort(), e.createConnection(s, r);
      };
    }
  }, {
    key: "sendWebsocket",
    value: function() {
      var t = Qe(/* @__PURE__ */ ce().mark(function n(r, i, o) {
        var l, d, c, u, m, f, v, b, w, S = arguments;
        return ce().wrap(function(T) {
          for (; ; ) switch (T.prev = T.next) {
            case 0:
              if (l = S.length > 3 && S[3] !== void 0 ? S[3] : !0, ((d = r.connectSettings) == null ? void 0 : d.url) !== Uo.URL) {
                T.next = 3;
                break;
              }
              return T.abrupt("return", Uo.request(r, o));
            case 3:
              if (u = r.websocket, !(!u || u === "pending")) {
                T.next = 6;
                break;
              }
              return T.abrupt("return");
            case 6:
              return m = {
                body: i,
                headers: (c = r.connectSettings) == null ? void 0 : c.headers
              }, T.next = 9, Kt.processRequestInterceptor(r.deepChat, m);
            case 9:
              if (f = T.sent, v = f.body, b = f.error, !b) {
                T.next = 14;
                break;
              }
              return T.abrupt("return", o.addNewErrorMessage("service", b));
            case 14:
              if (e.isWebSocket(u)) {
                T.next = 16;
                break;
              }
              return T.abrupt("return", u.newUserMessage.listener(v));
            case 16:
              w = l ? JSON.stringify(v) : v, u.readyState === void 0 || u.readyState !== u.OPEN ? (console.error("Connection is not open"), o.isLastMessageError() || o.addNewErrorMessage("service", "Connection error")) : (u.send(JSON.stringify(w)), r.completionsHandlers.onFinish());
            case 18:
            case "end":
              return T.stop();
          }
        }, n);
      }));
      function s(n, r, i) {
        return t.apply(this, arguments);
      }
      return s;
    }()
  }, {
    key: "canSendMessage",
    value: function(s) {
      return s ? s === "pending" ? !1 : e.isWebSocket(s) ? s.readyState !== void 0 && s.readyState === s.OPEN : s.isOpen : !0;
    }
    // if false then it is the internal websocket handler
  }, {
    key: "isWebSocket",
    value: function(s) {
      return s.send !== void 0;
    }
  }, {
    key: "stream",
    value: function(s, n, r, i) {
      if (i) {
        var o = s.stream.simulation;
        if (typeof o == "string") {
          var l, d = i.role || Ft.AI_ROLE, c = r[d];
          i.text === o || i.html === o ? (c == null || c.finaliseStreamedMessage(), delete r[d]) : ((l = r[d]) !== null && l !== void 0 || (r[d] = new fi(n, s.stream)), r[d].upsertStreamedMessage(i));
        } else Da.simulate(n, s.streamHandlers, i);
      }
    }
  }]);
}(), Lb = /* @__PURE__ */ function() {
  function e() {
    je(this, e);
  }
  return He(e, null, [{
    key: "request",
    value: function() {
      var t = Qe(/* @__PURE__ */ ce().mark(function n(r, i, o) {
        var l, d, c, u, m;
        return ce().wrap(function(v) {
          for (; ; ) switch (v.prev = v.next) {
            case 0:
              c = !0, u = /* @__PURE__ */ function() {
                var b = Qe(/* @__PURE__ */ ce().mark(function w(S) {
                  var I, T, x;
                  return ce().wrap(function(C) {
                    for (; ; ) switch (C.prev = C.next) {
                      case 0:
                        if (c) {
                          C.next = 2;
                          break;
                        }
                        return C.abrupt("return");
                      case 2:
                        return c = !1, C.next = 5, Kt.basicResponseProcessing(o, S, {
                          io: r,
                          displayError: !1
                        });
                      case 5:
                        I = C.sent, I ? (T = Array.isArray(I) ? I : [I], x = T.find(function(O) {
                          return typeof O.error == "string";
                        }), x ? (console.error(x.error), o.addNewErrorMessage("service", x.error), r.completionsHandlers.onFinish()) : Da.isSimulatable(r.stream, I) ? Da.simulate(o, r.streamHandlers, I) : (T.forEach(function(O) {
                          return o.addNewMessage(O);
                        }), r.completionsHandlers.onFinish())) : (console.error(Ys.INVALID_RESPONSE(S, "server", !!r.deepChat.responseInterceptor, I)), o.addNewErrorMessage("service", "Error in server message"), r.completionsHandlers.onFinish());
                      case 7:
                      case "end":
                        return C.stop();
                    }
                  }, w);
                }));
                return function(S) {
                  return b.apply(this, arguments);
                };
              }(), m = e.generateOptionalSignals(), (d = (l = r.connectSettings).handler) == null || d.call(l, i, ys(ys({}, m), {}, {
                onResponse: u
              }));
            case 3:
            case "end":
              return v.stop();
          }
        }, n);
      }));
      function s(n, r, i) {
        return t.apply(this, arguments);
      }
      return s;
    }()
  }, {
    key: "attemptToFinaliseStream",
    value: function(s, n) {
      try {
        var r = n.messageElementRefs[n.messageElementRefs.length - 1];
        Vr.isLoadingMessage(r) ? n.removeLastMessage() : s.finaliseStreamedMessage();
      } catch (i) {
        console.error(i), n.addNewErrorMessage("service", i);
      }
    }
    // prettier-ignore
  }, {
    key: "stream",
    value: function(s, n, r) {
      var i, o, l = !0, d = !1, c = new fi(r, s.stream), u = function() {
        d || !l || (s.streamHandlers.onOpen(), d = !0);
      }, m = function() {
        l && (e.attemptToFinaliseStream(c, r), s.streamHandlers.onClose(), l = !1);
      }, f = /* @__PURE__ */ function() {
        var b = Qe(/* @__PURE__ */ ce().mark(function w(S) {
          var I, T;
          return ce().wrap(function(k) {
            for (; ; ) switch (k.prev = k.next) {
              case 0:
                if (l) {
                  k.next = 2;
                  break;
                }
                return k.abrupt("return");
              case 2:
                return k.next = 4, Kt.basicResponseProcessing(r, S, {
                  io: s,
                  displayError: !1
                });
              case 4:
                I = k.sent, I ? I.error ? (e.streamError(I.error, c, s, r), l = !1) : Da.upsertWFiles(r, c.upsertStreamedMessage.bind(c), c, I) : (T = Ys.INVALID_RESPONSE(S, "server", !!s.deepChat.responseInterceptor, I), e.streamError(T, c, s, r), l = !1);
              case 6:
              case "end":
                return k.stop();
            }
          }, w);
        }));
        return function(S) {
          return b.apply(this, arguments);
        };
      }();
      s.streamHandlers.abortStream.abort = function() {
        e.attemptToFinaliseStream(c, r), s.streamHandlers.onClose(), l = !1;
      };
      var v = e.generateOptionalSignals();
      (o = (i = s.connectSettings).handler) == null || o.call(i, n, ys(ys({}, v), {}, {
        onOpen: u,
        onResponse: f,
        onClose: m,
        stopClicked: s.streamHandlers.stopClicked
      }));
    }
  }, {
    key: "streamError",
    value: function(s, n, r, i) {
      console.error(s), n.finaliseStreamedMessage(), i.addNewErrorMessage("service", s), r.streamHandlers.onClose();
    }
    // prettier-ignore
  }, {
    key: "websocket",
    value: function(s, n) {
      var r = this, i, o, l = {
        isOpen: !1,
        newUserMessage: {
          listener: function() {
          }
        },
        roleToStream: {}
      };
      s.websocket = l;
      var d = function() {
        n.removeError(), l.isOpen = !0;
      }, c = function() {
        l.isOpen = !1;
      }, u = /* @__PURE__ */ function() {
        var f = Qe(/* @__PURE__ */ ce().mark(function v(b) {
          var w, S, I, T, x, k;
          return ce().wrap(function(O) {
            for (; ; ) switch (O.prev = O.next) {
              case 0:
                if (l.isOpen) {
                  O.next = 2;
                  break;
                }
                return O.abrupt("return");
              case 2:
                return O.next = 4, Kt.basicResponseProcessing(n, b, {
                  io: s,
                  displayError: !1
                });
              case 4:
                w = O.sent, w ? (S = Array.isArray(w) ? w : [w], I = S.find(function(E) {
                  return typeof E.error == "string";
                }), I ? (console.error(I.error), n.isLastMessageError() || n.addNewErrorMessage("service", I.error)) : Da.isSimulation(s.stream) ? (T = w, x = ku.stream.bind(r, s, n, l.roleToStream), k = l.roleToStream[T.role || Ft.AI_ROLE], Da.upsertWFiles(n, x, k, T)) : S.forEach(function(E) {
                  return n.addNewMessage(E);
                })) : (console.error(Ys.INVALID_RESPONSE(b, "server", !!s.deepChat.responseInterceptor, w)), n.addNewErrorMessage("service", "Error in server message"));
              case 6:
              case "end":
                return O.stop();
            }
          }, v);
        }));
        return function(b) {
          return f.apply(this, arguments);
        };
      }(), m = e.generateOptionalSignals();
      (o = (i = s.connectSettings).handler) == null || o.call(i, void 0, ys(ys({}, m), {}, {
        onOpen: d,
        onResponse: u,
        onClose: c,
        newUserMessage: l.newUserMessage
      }));
    }
  }, {
    key: "generateOptionalSignals",
    value: function() {
      return {
        onClose: function() {
        },
        onOpen: function() {
        },
        stopClicked: {
          listener: function() {
          }
        },
        newUserMessage: {
          listener: function() {
          }
        }
      };
    }
  }]);
}(), ha = /* @__PURE__ */ function() {
  function e() {
    je(this, e);
  }
  return He(e, null, [{
    key: "request",
    value: (
      // prettier-ignore
      function() {
        var t = Qe(/* @__PURE__ */ ce().mark(function n(r, i, o) {
          var l, d, c, u, m, f, v, b, w, S, I, T, x = arguments;
          return ce().wrap(function(C) {
            for (; ; ) switch (C.prev = C.next) {
              case 0:
                return l = x.length > 3 && x[3] !== void 0 ? x[3] : !0, m = {
                  body: i,
                  headers: (d = r.connectSettings) == null ? void 0 : d.headers
                }, C.next = 4, Kt.processRequestInterceptor(r.deepChat, m);
              case 4:
                if (f = C.sent, v = f.body, b = f.headers, w = f.error, S = r.completionsHandlers.onFinish, !w) {
                  C.next = 11;
                  break;
                }
                return C.abrupt("return", Kt.onInterceptorError(o, w, S));
              case 11:
                if (!((c = r.connectSettings) != null && c.handler)) {
                  C.next = 13;
                  break;
                }
                return C.abrupt("return", Lb.request(r, v, o));
              case 13:
                if (((u = r.connectSettings) == null ? void 0 : u.url) !== Uo.URL) {
                  C.next = 15;
                  break;
                }
                return C.abrupt("return", Uo.request(r, o));
              case 15:
                I = !0, T = Kt.fetch.bind(this, r, b, l), T(v).then(function(O) {
                  return I = !!O.ok, O;
                }).then(function(O) {
                  return Kt.processResponseByType(O);
                }).then(/* @__PURE__ */ function() {
                  var O = Qe(/* @__PURE__ */ ce().mark(function E(B) {
                    var M, R, F, L;
                    return ce().wrap(function(H) {
                      for (; ; ) switch (H.prev = H.next) {
                        case 0:
                          if (r.extractResultData) {
                            H.next = 2;
                            break;
                          }
                          return H.abrupt("return");
                        case 2:
                          return H.next = 4, (R = (M = r.deepChat).responseInterceptor) == null ? void 0 : R.call(M, B);
                        case 4:
                          if (H.t0 = H.sent, H.t0) {
                            H.next = 7;
                            break;
                          }
                          H.t0 = B;
                        case 7:
                          return F = H.t0, H.next = 10, r.extractResultData(F, T, v);
                        case 10:
                          if (L = H.sent, I) {
                            H.next = 13;
                            break;
                          }
                          throw B;
                        case 13:
                          if (!(!L || St(L) != "object" && !Array.isArray(L))) {
                            H.next = 15;
                            break;
                          }
                          throw Error(Ys.INVALID_RESPONSE(B, "response", !!r.deepChat.responseInterceptor, F));
                        case 15:
                          L.makingAnotherRequest || (Da.isSimulatable(r.stream, L) ? Da.simulate(o, r.streamHandlers, L) : ((Array.isArray(L) ? L : [L]).forEach(function(te) {
                            return o.addNewMessage(te);
                          }), S()));
                        case 16:
                        case "end":
                          return H.stop();
                      }
                    }, E);
                  }));
                  return function(E) {
                    return O.apply(this, arguments);
                  };
                }()).catch(function(O) {
                  Kt.displayError(o, O), S();
                });
              case 18:
              case "end":
                return C.stop();
            }
          }, n, this);
        }));
        function s(n, r, i) {
          return t.apply(this, arguments);
        }
        return s;
      }()
    )
  }, {
    key: "executePollRequest",
    value: function(s, n, r, i) {
      var o = s.completionsHandlers.onFinish;
      fetch(n, r).then(function(l) {
        return l.json();
      }).then(/* @__PURE__ */ function() {
        var l = Qe(/* @__PURE__ */ ce().mark(function d(c) {
          var u, m, f;
          return ce().wrap(function(b) {
            for (; ; ) switch (b.prev = b.next) {
              case 0:
                if (s.extractPollResultData) {
                  b.next = 2;
                  break;
                }
                return b.abrupt("return");
              case 2:
                return b.t0 = s, b.next = 5, (m = (u = s.deepChat).responseInterceptor) == null ? void 0 : m.call(u, c);
              case 5:
                if (b.t1 = b.sent, b.t1) {
                  b.next = 8;
                  break;
                }
                b.t1 = c;
              case 8:
                return b.t2 = b.t1, b.next = 11, b.t0.extractPollResultData.call(b.t0, b.t2);
              case 11:
                f = b.sent, f.timeoutMS ? setTimeout(function() {
                  e.executePollRequest(s, n, r, i);
                }, f.timeoutMS) : Da.isSimulatable(s.stream, f) ? Da.simulate(i, s.streamHandlers, f) : (i.addNewMessage(f), o());
              case 13:
              case "end":
                return b.stop();
            }
          }, d);
        }));
        return function(d) {
          return l.apply(this, arguments);
        };
      }()).catch(function(l) {
        Kt.displayError(i, l), o();
      });
    }
    // prettier-ignore
  }, {
    key: "poll",
    value: function() {
      var t = Qe(/* @__PURE__ */ ce().mark(function n(r, i, o) {
        var l, d, c, u, m, f, v, b, w, S, I, T, x, k = arguments;
        return ce().wrap(function(O) {
          for (; ; ) switch (O.prev = O.next) {
            case 0:
              return l = k.length > 3 && k[3] !== void 0 ? k[3] : !0, m = {
                body: i,
                headers: (d = r.connectSettings) == null ? void 0 : d.headers
              }, O.next = 4, Kt.processRequestInterceptor(r.deepChat, m);
            case 4:
              if (f = O.sent, v = f.body, b = f.headers, w = f.error, !w) {
                O.next = 10;
                break;
              }
              return O.abrupt("return", Kt.onInterceptorError(o, w));
            case 10:
              S = ((c = r.connectSettings) == null ? void 0 : c.url) || r.url || "", I = ((u = r.connectSettings) == null ? void 0 : u.method) || "POST", T = l ? JSON.stringify(v) : v, x = {
                method: I,
                body: T,
                headers: b
              }, r.connectSettings.credentials && (x.credentials = r.connectSettings.credentials), e.executePollRequest(r, S, x, o);
            case 12:
            case "end":
              return O.stop();
          }
        }, n);
      }));
      function s(n, r, i) {
        return t.apply(this, arguments);
      }
      return s;
    }()
    // prettier-ignore
  }, {
    key: "verifyKey",
    value: function(s, n, r, i, o, l, d, c, u) {
      if (s === "") return l(Ys.INVALID_KEY);
      d(), fetch(n, {
        method: i,
        headers: r,
        body: u || null
      }).then(function(m) {
        return Kt.processResponseByType(m);
      }).then(function(m) {
        c(m, s, o, l);
      }).catch(function(m) {
        l(Ys.CONNECTION_FAILED), console.error(m);
      });
    }
  }]);
}(), k5 = /* @__PURE__ */ function() {
  function e(t, s, n) {
    je(this, e), this._isLoading = !1, this._isPaginationComplete = !1, this._index = 0, this._messages = s, n.fetchHistory && this.fetchHistory(n.fetchHistory), t.loadHistory && this.setupLoadHistoryOnScroll(t.loadHistory), this.setupInitialHistory(t);
  }
  return He(e, [{
    key: "fetchHistory",
    value: function() {
      var t = Qe(/* @__PURE__ */ ce().mark(function n(r) {
        var i = this, o, l;
        return ce().wrap(function(c) {
          for (; ; ) switch (c.prev = c.next) {
            case 0:
              return o = tl.addMessage(this._messages), c.next = 3, r();
            case 3:
              l = c.sent, this._messages.removeMessage(o), e.displayIntroMessages(this._messages.messageElementRefs), l.forEach(function(u) {
                return i._messages.addAnyMessage(u, !0);
              }), setTimeout(function() {
                return Ln.scrollToBottom(i._messages.elementRef);
              }, 0);
            case 5:
            case "end":
              return c.stop();
          }
        }, n, this);
      }));
      function s(n) {
        return t.apply(this, arguments);
      }
      return s;
    }()
  }, {
    key: "processLoadedHistory",
    value: function(s) {
      var n = this, r, i = this._messages, o = i.messageElementRefs, l = i.messageToElements, d = i.elementRef, c = (r = o.find(function(m) {
        return !m.outerContainer.classList.contains(Vr.INTRO_CLASS);
      })) == null ? void 0 : r.outerContainer, u = d.scrollTop;
      s == null || s.reverse().map(function(m) {
        var f = n._messages.addAnyMessage(ys(ys({}, m), {}, {
          sendUpdate: !0
        }), !0, !0);
        if (f) {
          var v = Ft.generateMessageBody(f, o, !0);
          l.unshift([f, v]);
        }
        return f;
      }).filter(function(m) {
        return !!m;
      }).reverse().forEach(function(m) {
        return n._messages.sendClientUpdate(m, !0);
      }), c && (d.scrollTop = u + c.offsetTop - 40);
    }
  }, {
    key: "populateMessages",
    value: function(s, n) {
      this._messages.removeMessage(s), this._isPaginationComplete = n.findIndex(function(c) {
        return !c;
      }) < 0;
      var r = n.filter(function(c) {
        return !!c;
      });
      this.processLoadedHistory(r);
      var i = this._messages, o = i.messageElementRefs, l = i.avatar, d = i.name;
      Ft.resetAllRoleElements(o, l, d);
    }
  }, {
    key: "setupLoadHistoryOnScroll",
    value: function() {
      var t = Qe(/* @__PURE__ */ ce().mark(function n(r) {
        var i = this;
        return ce().wrap(function(l) {
          for (; ; ) switch (l.prev = l.next) {
            case 0:
              this._messages.elementRef.onscroll = /* @__PURE__ */ Qe(/* @__PURE__ */ ce().mark(function d() {
                var c, u;
                return ce().wrap(function(f) {
                  for (; ; ) switch (f.prev = f.next) {
                    case 0:
                      if (!(!i._isLoading && !i._isPaginationComplete && i._messages.elementRef.scrollTop === 0)) {
                        f.next = 13;
                        break;
                      }
                      return i._isLoading = !0, c = tl.addMessage(i._messages, !1), f.prev = 3, f.next = 6, r(i._index++);
                    case 6:
                      u = f.sent, i.populateMessages(c, u), i._isLoading = !1, f.next = 13;
                      break;
                    case 10:
                      f.prev = 10, f.t0 = f.catch(3), i._messages.removeMessage(c), i._isPaginationComplete = !0, i._messages.addNewErrorMessage("service", e.FAILED_ERROR_MESSAGE, !0), console.error(f.t0);
                    case 13:
                    case "end":
                      return f.stop();
                  }
                }, d, null, [[3, 10]]);
              }));
            case 1:
            case "end":
              return l.stop();
          }
        }, n, this);
      }));
      function s(n) {
        return t.apply(this, arguments);
      }
      return s;
    }()
  }, {
    key: "populateInitialHistory",
    value: function(s) {
      var n = this;
      s.forEach(function(r) {
        xn.processHistoryFile(r), n._messages.addAnyMessage(r, !0);
      });
    }
  }, {
    key: "loadInitialHistory",
    value: function() {
      var t = Qe(/* @__PURE__ */ ce().mark(function n(r) {
        var i = this, o, l, d;
        return ce().wrap(function(u) {
          for (; ; ) switch (u.prev = u.next) {
            case 0:
              return this._isLoading = !0, o = tl.addMessage(this._messages), u.prev = 2, u.next = 5, r(this._index++);
            case 5:
              l = u.sent, d = this._messages.elementRef.scrollTop, this.populateMessages(o, l), d === 0 && setTimeout(function() {
                return Ln.scrollToBottom(i._messages.elementRef);
              }, 0), u.next = 13;
              break;
            case 10:
              u.prev = 10, u.t0 = u.catch(2), this._messages.removeMessage(o), this._isPaginationComplete = !0, this._messages.addNewErrorMessage("service", e.FAILED_ERROR_MESSAGE, !0), console.error(u.t0);
            case 13:
              e.displayIntroMessages(this._messages.messageElementRefs), this._isLoading = !1;
            case 14:
            case "end":
              return u.stop();
          }
        }, n, this, [[2, 10]]);
      }));
      function s(n) {
        return t.apply(this, arguments);
      }
      return s;
    }()
  }, {
    key: "setupInitialHistory",
    value: function() {
      var t = Qe(/* @__PURE__ */ ce().mark(function n(r) {
        var i, o;
        return ce().wrap(function(d) {
          for (; ; ) switch (d.prev = d.next) {
            case 0:
              r.loadHistory && this.loadInitialHistory(r.loadHistory), o = r.history || xn.processHistory(r) || ((i = this._messages.browserStorage) == null ? void 0 : i.get()), o && (this.populateInitialHistory(o), this._index += 1);
            case 3:
            case "end":
              return d.stop();
          }
        }, n, this);
      }));
      function s(n) {
        return t.apply(this, arguments);
      }
      return s;
    }()
  }], [{
    key: "addErrorPrefix",
    value: function(s) {
      var n;
      (n = s.permittedErrorPrefixes) !== null && n !== void 0 || (s.permittedErrorPrefixes = []), s.permittedErrorPrefixes.push(e.FAILED_ERROR_MESSAGE);
    }
  }, {
    key: "displayIntroMessages",
    value: function(s) {
      for (var n = 0; n < s.length; n += 1) {
        var r = s[0];
        if (r.outerContainer.classList.contains(Vr.INTRO_CLASS)) r.outerContainer.style.display = "";
        else break;
      }
    }
  }]);
}();
k5.FAILED_ERROR_MESSAGE = "Failed to load history";
var Bb = k5, yf = /* @__PURE__ */ function() {
  function e() {
    je(this, e);
  }
  return He(e, null, [{
    key: "getCharacterLimitMessages",
    value: function(s, n) {
      var r;
      if (n === -1) return s;
      var i = 0, o = s.length - 1;
      for (o; o >= 0; o -= 1) {
        var l = (r = s[o]) == null ? void 0 : r.text;
        if (l !== void 0 && (i += l.length, i > n)) {
          s[o].text = l.substring(0, l.length - (i - n));
          break;
        }
      }
      return s.slice(Math.max(o, 0));
    }
  }, {
    key: "getMaxMessages",
    value: function(s, n) {
      return s.slice(Math.max(s.length - n, 0));
    }
    // if maxMessages is not defined we send all messages
    // if maxMessages above 0 we send that number
    // if maxMessages 0 or below we send only what is in the request
  }, {
    key: "processMessages",
    value: function(s, n, r) {
      return n !== void 0 ? n > 0 && (s = e.getMaxMessages(s, n)) : s = [s[s.length - 1]], s = JSON.parse(JSON.stringify(s)), r === void 0 ? s : e.getCharacterLimitMessages(s, r);
    }
  }]);
}(), Uje = /* @__PURE__ */ function() {
  function e() {
    je(this, e);
  }
  return He(e, null, [{
    key: "parseConfig",
    value: (
      // prettier-ignore
      function(s, n, r, i) {
        var o, l = {
          files: n
        };
        if (St(i) == "object") {
          xn.processFileConfigConnect(i);
          var d = i.files, c = i.connect, u = i.button;
          d && (d.infoModal && (l.files.infoModal = d.infoModal, (o = d.infoModal) != null && o.textMarkDown && (l.infoModalTextMarkUp = r.render(d.infoModal.textMarkDown))), d.acceptedFormats && (l.files.acceptedFormats = d.acceptedFormats), d.maxNumberOfFiles && (l.files.maxNumberOfFiles = d.maxNumberOfFiles)), l.button = u, c && (c.headers || c.method || c.url || c.credentials || s.headers || s.method || s.url || s.credentials) && (l.connect = {
            url: (c == null ? void 0 : c.url) || s.url,
            method: (c == null ? void 0 : c.method) || s.method,
            headers: (c == null ? void 0 : c.headers) || s.headers,
            credentials: (c == null ? void 0 : c.credentials) || s.credentials
          });
        }
        return l;
      }
    )
  }, {
    key: "processMixedFiles",
    value: function(s, n, r) {
      if (r) {
        var i = {
          acceptedFormats: ""
        };
        s.fileTypes.mixedFiles = e.parseConfig(s.connectSettings, i, n, r);
      }
    }
    // needs to be set after audio to overwrite maxNumberOfFiles
    // prettier-ignore
  }, {
    key: "processMicrophone",
    value: function(s, n, r, i) {
      var o, l, d, c, u, m, f, v, b = ys({
        acceptedFormats: "audio/*"
      }, ((d = s.fileTypes.audio) == null ? void 0 : d.files) || {});
      r && (navigator.mediaDevices.getUserMedia !== void 0 ? (s.recordAudio = e.parseConfig(s.connectSettings, b, n, r), St(r) == "object" && r.files && ((o = (c = s.recordAudio).files) !== null && o !== void 0 || (c.files = {}), s.recordAudio.files.format = (u = r.files) == null ? void 0 : u.format, s.recordAudio.files.maxDurationSeconds = (m = r.files) == null ? void 0 : m.maxDurationSeconds, (f = s.fileTypes.audio) != null && f.files && ((l = (v = s.fileTypes.audio.files).maxNumberOfFiles) !== null && l !== void 0 || (v.maxNumberOfFiles = r.files.maxNumberOfFiles)))) : i || (s.fileTypes.audio = e.parseConfig(s.connectSettings, b, n, r)));
    }
    // prettier-ignore
  }, {
    key: "processAudioConfig",
    value: function(s, n, r, i) {
      if (!(!r && !i)) {
        var o = ys({
          acceptedFormats: "audio/*"
        }, (i == null ? void 0 : i.files) || {});
        s.fileTypes.audio = e.parseConfig(s.connectSettings, o, n, r);
      }
    }
    // prettier-ignore
  }, {
    key: "processGifConfig",
    value: function(s, n, r, i) {
      if (!(!r && !i)) {
        var o = ys({
          acceptedFormats: "image/gif"
        }, (i == null ? void 0 : i.files) || {});
        s.fileTypes.gifs = e.parseConfig(s.connectSettings, o, n, r);
      }
    }
    // needs to be set after images to overwrite maxNumberOfFiles
    // prettier-ignore
  }, {
    key: "processCamera",
    value: function(s, n, r, i) {
      var o, l, d, c, u, m = ys({
        acceptedFormats: "image/*"
      }, ((l = s.fileTypes.images) == null ? void 0 : l.files) || {});
      r && (navigator.mediaDevices.getUserMedia !== void 0 ? (s.camera = e.parseConfig(s.connectSettings, m, n, r), St(r) == "object" && (s.camera.modalContainerStyle = r.modalContainerStyle, r.files && ((o = (d = s.camera).files) !== null && o !== void 0 || (d.files = {}), s.camera.files.format = (c = r.files) == null ? void 0 : c.format, s.camera.files.dimensions = (u = r.files) == null ? void 0 : u.dimensions))) : i || (s.fileTypes.images = e.parseConfig(s.connectSettings, m, n, r)));
    }
    // prettier-ignore
  }, {
    key: "processImagesConfig",
    value: function(s, n, r, i) {
      if (!(!r && !i)) {
        var o = ys({
          acceptedFormats: "image/*"
        }, (i == null ? void 0 : i.files) || {});
        s.fileTypes.images = e.parseConfig(s.connectSettings, o, n, r);
      }
    }
    // default for direct service
  }, {
    key: "populateDefaultFileIO",
    value: function(s, n) {
      var r, i, o, l, d;
      s && ((r = s.files) !== null && r !== void 0 || (s.files = {}), (i = (l = s.files).acceptedFormats) !== null && i !== void 0 || (l.acceptedFormats = n), (o = (d = s.files).maxNumberOfFiles) !== null && o !== void 0 || (d.maxNumberOfFiles = 1));
    }
  }, {
    key: "set",
    value: function(s, n, r) {
      e.populateDefaultFileIO(r == null ? void 0 : r.audio, ".4a,.mp3,.webm,.mp4,.mpga,.wav,.mpeg,.m4a"), e.populateDefaultFileIO(r == null ? void 0 : r.images, ".png,.jpg");
      var i = Sy.createNew(s.remarkable);
      e.processImagesConfig(n, i, s.images, r == null ? void 0 : r.images), e.processCamera(n, i, s.camera, s.images), e.processGifConfig(n, i, s.gifs, r == null ? void 0 : r.gifs), e.processAudioConfig(n, i, s.audio, r == null ? void 0 : r.audio), e.processMicrophone(n, i, s.microphone, s.audio), e.processMixedFiles(n, i, s.mixedFiles);
    }
  }]);
}(), Cm = /* @__PURE__ */ function() {
  function e(t, s, n) {
    var r;
    je(this, e);
    var i, o, l, d, c;
    this.rawBody = {}, this.validateKeyProperty = !1, this.canSendMessage = e.canSendMessage, this.connectSettings = {}, this.fileTypes = {}, this.completionsHandlers = {}, this.streamHandlers = {}, this.deepChat = t, this.demo = n, Object.assign(this.rawBody, (i = t.connect) == null ? void 0 : i.additionalBodyProps), this.totalMessagesMaxCharLength = (o = t == null ? void 0 : t.requestBodyLimits) == null ? void 0 : o.totalMessagesMaxCharLength, this.maxMessages = (l = t == null ? void 0 : t.requestBodyLimits) == null ? void 0 : l.maxMessages, Uje.set(t, this, s), t.connect && (this.connectSettings = t.connect), this.demo && ((r = (d = this.connectSettings).url) !== null && r !== void 0 || (d.url = Uo.URL)), this.connectSettings.websocket && ku.setup(this), this.stream = ((c = this.deepChat.connect) == null ? void 0 : c.stream) || xn.checkForStream(this.deepChat), t.loadHistory && Bb.addErrorPrefix(this);
  }
  return He(e, [{
    key: "verifyKey",
    value: function(s, n) {
    }
  }, {
    key: "getServiceIOByType",
    value: function(s) {
      if (s.type.startsWith("audio") && this.fileTypes.audio) return this.fileTypes.audio;
      if (s.type.startsWith("image")) {
        if (this.fileTypes.gifs && s.type.endsWith("/gif")) return this.fileTypes.gifs;
        if (this.fileTypes.images) return this.fileTypes.images;
        if (this.camera) return this.camera;
      }
      return this.fileTypes.mixedFiles;
    }
  }, {
    key: "request",
    value: function() {
      var t = Qe(/* @__PURE__ */ ce().mark(function n(r, i) {
        var o, l = arguments;
        return ce().wrap(function(c) {
          for (; ; ) switch (c.prev = c.next) {
            case 0:
              return o = l.length > 2 && l[2] !== void 0 ? l[2] : !0, c.abrupt("return", this.stream && !Da.isSimulation(this.stream) ? Da.request(this, r, i, o) : ha.request(this, r, i, o));
            case 2:
            case "end":
              return c.stop();
          }
        }, n, this);
      }));
      function s(n, r) {
        return t.apply(this, arguments);
      }
      return s;
    }()
  }, {
    key: "callAPIWithText",
    value: function() {
      var t = Qe(/* @__PURE__ */ ce().mark(function n(r, i) {
        var o, l, d, c, u, m, f, v;
        return ce().wrap(function(w) {
          for (; ; ) switch (w.prev = w.next) {
            case 0:
              return f = ys({
                messages: i
              }, this.rawBody), v = !1, (d = this.connectSettings.headers) != null && d["Content-Type"] || ((o = (c = this.connectSettings).headers) !== null && o !== void 0 || (c.headers = {}), (l = (u = this.connectSettings.headers)["Content-Type"]) !== null && l !== void 0 || (u["Content-Type"] = "application/json"), v = !0), w.next = 5, this.request(f, r);
            case 5:
              v && ((m = this.connectSettings.headers) == null || delete m["Content-Type"]);
            case 6:
            case "end":
              return w.stop();
          }
        }, n, this);
      }));
      function s(n, r) {
        return t.apply(this, arguments);
      }
      return s;
    }()
  }, {
    key: "callApiWithFiles",
    value: function() {
      var t = Qe(/* @__PURE__ */ ce().mark(function n(r, i, o) {
        var l, d, c;
        return ce().wrap(function(m) {
          for (; ; ) switch (m.prev = m.next) {
            case 0:
              return l = e.createCustomFormDataBody(this.rawBody, i, o), d = this.connectSettings, c = this.getServiceIOByType(o[0]), this.connectSettings = (c == null ? void 0 : c.connect) || this.connectSettings, m.next = 4, this.request(l, r, !1);
            case 4:
              this.connectSettings = d;
            case 5:
            case "end":
              return m.stop();
          }
        }, n, this);
      }));
      function s(n, r, i) {
        return t.apply(this, arguments);
      }
      return s;
    }()
  }, {
    key: "callServiceAPI",
    value: function() {
      var t = Qe(/* @__PURE__ */ ce().mark(function n(r, i, o) {
        return ce().wrap(function(d) {
          for (; ; ) switch (d.prev = d.next) {
            case 0:
              o ? this.callApiWithFiles(r, i, o) : this.callAPIWithText(r, i);
            case 1:
            case "end":
              return d.stop();
          }
        }, n, this);
      }));
      function s(n, r, i) {
        return t.apply(this, arguments);
      }
      return s;
    }()
    // prettier-ignore
  }, {
    key: "callAPI",
    value: function() {
      var t = Qe(/* @__PURE__ */ ce().mark(function n(r, i) {
        var o, l, d;
        return ce().wrap(function(u) {
          for (; ; ) switch (u.prev = u.next) {
            case 0:
              if (this.connectSettings) {
                u.next = 2;
                break;
              }
              throw new Error("Request settings have not been set up");
            case 2:
              l = yf.processMessages(i.messageToElements.map(function(m) {
                var f = dl(m, 1), v = f[0];
                return v;
              }), this.maxMessages, this.totalMessagesMaxCharLength), this.connectSettings.websocket && (!this.connectSettings.handler || this.connectSettings.url !== Uo.URL) ? (d = ys({
                messages: l
              }, this.rawBody), r.files && (o = this.getServiceIOByType(r.files[0])) != null && o.connect ? this.callApiWithFiles(i, l, r.files) : ku.sendWebsocket(this, d, i, !1)) : this.callServiceAPI(i, l, r.files);
            case 4:
            case "end":
              return u.stop();
          }
        }, n, this);
      }));
      function s(n, r) {
        return t.apply(this, arguments);
      }
      return s;
    }()
  }, {
    key: "extractResultData",
    value: function() {
      var t = Qe(/* @__PURE__ */ ce().mark(function n(r) {
        return ce().wrap(function(o) {
          for (; ; ) switch (o.prev = o.next) {
            case 0:
              if (!r.result) {
                o.next = 2;
                break;
              }
              return o.abrupt("return", xn.handleResponseProperty(r));
            case 2:
              if (!Kt.validateResponseFormat(r, !!this.stream)) {
                o.next = 4;
                break;
              }
              return o.abrupt("return", r);
            case 4:
            case "end":
              return o.stop();
          }
        }, n, this);
      }));
      function s(n) {
        return t.apply(this, arguments);
      }
      return s;
    }()
  }, {
    key: "isDirectConnection",
    value: function() {
      return !1;
    }
  }, {
    key: "isWebModel",
    value: function() {
      return !1;
    }
  }, {
    key: "isCustomView",
    value: function() {
      return !1;
    }
  }], [{
    key: "canSendMessage",
    value: function(s, n, r) {
      return r ? !0 : !!(s && s.trim() !== "") || !!(n && n.length > 0);
    }
  }, {
    key: "createCustomFormDataBody",
    value: function(s, n, r) {
      var i = new FormData();
      r.forEach(function(d) {
        return i.append("files", d);
      }), Object.keys(s).forEach(function(d) {
        return i.append(d, String(s[d]));
      });
      var o = 0;
      n.slice(0, n.length - 1).forEach(function(d) {
        i.append("message".concat(o += 1), JSON.stringify(d));
      });
      var l = n[n.length - 1];
      return l.text && (delete l.files, i.append("message".concat(o += 1), JSON.stringify(l))), i;
    }
  }]);
}(), tn = /* @__PURE__ */ function(e) {
  function t(s, n, r, i, o) {
    var l;
    je(this, t);
    var d;
    return l = jt(this, t, [s, o]), l.insertKeyPlaceholderText = "API Key", l.keyHelpUrl = "", Object.assign(l.rawBody, (d = s.connect) == null ? void 0 : d.additionalBodyProps), l._keyVerificationDetails = n, l._buildHeadersFunc = r, i && l.setApiKeyProperties(i), l.connectSettings = l.buildConnectSettings(l.key || "", s.connect), l;
  }
  return Ht(t, e), He(t, [{
    key: "setApiKeyProperties",
    value: function(n) {
      this.key = n.key, n.validateKeyProperty && (this.validateKeyProperty = n.validateKeyProperty);
    }
  }, {
    key: "buildConnectSettings",
    value: function(n, r) {
      var i, o = r ?? {};
      return (i = o.headers) !== null && i !== void 0 || (o.headers = {}), Object.assign(o.headers, this._buildHeadersFunc(n)), o;
    }
  }, {
    key: "keyAuthenticated",
    value: function(n, r) {
      this.connectSettings = this.buildConnectSettings(r, this.connectSettings), this.key = r, n();
    }
    // prettier-ignore
  }, {
    key: "verifyKey",
    value: function(n, r) {
      var i = this._keyVerificationDetails, o = i.url, l = i.method, d = i.handleVerificationResult, c = i.createHeaders, u = i.body, m = (c == null ? void 0 : c(n)) || this._buildHeadersFunc(n);
      ha.verifyKey(n, o, m, l, this.keyAuthenticated.bind(this, r.onSuccess), r.onFail, r.onLoad, d, u);
    }
  }, {
    key: "isDirectConnection",
    value: function() {
      return !0;
    }
  }]);
}(Cm), zje = /* @__PURE__ */ function() {
  function e() {
    je(this, e);
  }
  return He(e, null, [{
    key: "waitForPropertiesToBeUpdatedBeforeRender",
    value: function(s) {
      s._propUpdated_ = !1, setTimeout(function() {
        s._propUpdated_ ? e.waitForPropertiesToBeUpdatedBeforeRender(s) : (s._waitingToRender_ = !1, s.onRender());
      });
    }
  }, {
    key: "attemptRender",
    value: function(s) {
      s._propUpdated_ = !0, s._waitingToRender_ || (s._waitingToRender_ = !0, e.waitForPropertiesToBeUpdatedBeforeRender(s));
    }
  }]);
}(), Iy = /* @__PURE__ */ function(e) {
  function t() {
    var s;
    return je(this, t), s = jt(this, t), s._waitingToRender_ = !1, s._propUpdated_ = !1, Object.keys(t._attributeToProperty_).forEach(function(n) {
      var r = t._attributeToProperty_[n];
      s.constructPropertyAccessors(r), s.hasOwnProperty(n) || s.constructPropertyAccessors(r, n);
    }), s;
  }
  return Ht(t, e), He(t, [{
    key: "constructPropertyAccessors",
    value: (
      // need to be called here as accessors need to be set for the class instance
      function(n, r) {
        var i;
        Object.defineProperty(this, r || n, {
          get: function() {
            return i;
          },
          set: function(l) {
            i = l, r ? this[n] = l : zje.attemptRender(this);
          }
        });
      }
    )
  }, {
    key: "attributeChangedCallback",
    value: function(n, r, i) {
      if (r !== i) {
        var o = t._attributes_[n](i), l = t._attributeToProperty_[n];
        this[l] = o;
      }
    }
  }, {
    key: "onRender",
    value: function() {
    }
  }], [{
    key: "observedAttributes",
    get: function() {
      return Object.keys(t._attributes_) || [];
    }
  }]);
}(/* @__PURE__ */ fy(HTMLElement));
Iy._attributes_ = {}, Iy._attributeToProperty_ = {};
var Wje = Iy, Gje = `<?xml version="1.0" standalone="no"?>
<svg version="1.1"
	xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd" xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
	xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="0.9em" height="0.9em"
	viewBox="0 0 1200 1200" enable-background="new 0 0 1200 1200">
		<path d="
			M669.727,273.516c-22.891-2.476-46.15-3.895-69.727-4.248c-103.025,0.457-209.823,25.517-310.913,73.536
			c-75.058,37.122-148.173,89.529-211.67,154.174C46.232,529.978,6.431,577.76,0,628.74c0.76,44.162,48.153,98.67,77.417,131.764
			c59.543,62.106,130.754,113.013,211.67,154.174c2.75,1.335,5.51,2.654,8.276,3.955l-75.072,131.102l102.005,60.286l551.416-960.033
			l-98.186-60.008L669.727,273.516z M902.563,338.995l-74.927,129.857c34.47,44.782,54.932,100.006,54.932,159.888
			c0,149.257-126.522,270.264-282.642,270.264c-6.749,0-13.29-0.728-19.922-1.172l-49.585,85.84c22.868,2.449,45.99,4.233,69.58,4.541
			c103.123-0.463,209.861-25.812,310.84-73.535c75.058-37.122,148.246-89.529,211.743-154.174
			c31.186-32.999,70.985-80.782,77.417-131.764c-0.76-44.161-48.153-98.669-77.417-131.763
			c-59.543-62.106-130.827-113.013-211.743-154.175C908.108,341.478,905.312,340.287,902.563,338.995L902.563,338.995z
			M599.927,358.478c6.846,0,13.638,0.274,20.361,0.732l-58.081,100.561c-81.514,16.526-142.676,85.88-142.676,168.897
			c0,20.854,3.841,40.819,10.913,59.325c0.008,0.021-0.008,0.053,0,0.074l-58.228,100.854
			c-34.551-44.823-54.932-100.229-54.932-160.182C317.285,479.484,443.808,358.477,599.927,358.478L599.927,358.478z M768.896,570.513
			L638.013,797.271c81.076-16.837,141.797-85.875,141.797-168.603C779.81,608.194,775.724,588.729,768.896,570.513L768.896,570.513z"
			/>
</svg>
`, Yje = `<?xml version="1.0" standalone="no"?>
<svg version="1.1"
	xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd" xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
	xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="0.9em" height="0.9em"
	viewBox="0 0 1200 1200" enable-background="new 0 0 1200 1200">
		<path id="path6686" inkscape:connector-curvature="0" d="M779.843,599.925c0,95.331-80.664,172.612-180.169,172.612
			c-99.504,0-180.168-77.281-180.168-172.612c0-95.332,80.664-172.612,180.168-172.612
			C699.179,427.312,779.843,504.594,779.843,599.925z M600,240.521c-103.025,0.457-209.814,25.538-310.904,73.557
			c-75.058,37.122-148.206,89.496-211.702,154.141C46.208,501.218,6.431,549,0,599.981c0.76,44.161,48.13,98.669,77.394,131.763
			c59.543,62.106,130.786,113.018,211.702,154.179c94.271,45.751,198.616,72.092,310.904,73.557
			c103.123-0.464,209.888-25.834,310.866-73.557c75.058-37.122,148.243-89.534,211.74-154.179
			c31.185-32.999,70.962-80.782,77.394-131.763c-0.76-44.161-48.13-98.671-77.394-131.764
			c-59.543-62.106-130.824-112.979-211.74-154.141C816.644,268.36,712.042,242.2,600,240.521z M599.924,329.769
			c156.119,0,282.675,120.994,282.675,270.251c0,149.256-126.556,270.25-282.675,270.25S317.249,749.275,317.249,600.02
			C317.249,450.763,443.805,329.769,599.924,329.769L599.924,329.769z"/>
</svg>
`, Ro = /* @__PURE__ */ function() {
  function e() {
    je(this, e);
  }
  return He(e, null, [{
    key: "createSVGElement",
    value: function(s) {
      return new DOMParser().parseFromString(s, "image/svg+xml").documentElement;
    }
  }]);
}(), E5 = /* @__PURE__ */ function() {
  function e() {
    je(this, e);
  }
  return He(e, null, [{
    key: "changeVisibility",
    value: (
      // prettier-ignore
      function(s, n, r, i) {
        i.target.id === e.VISIBLE_ICON_ID ? (n.style.display = "none", r.style.display = "block", s.type = "password") : (n.style.display = "block", r.style.display = "none", s.type = "text");
      }
    )
  }, {
    key: "createIconElement",
    value: function(s, n) {
      var r = Ro.createSVGElement(s);
      return r.id = n, r.classList.add("visibility-icon"), r;
    }
    // prettier-ignore
  }, {
    key: "create",
    value: function(s) {
      var n = document.createElement("div");
      n.id = "visibility-icon-container";
      var r = e.createIconElement(Yje, e.VISIBLE_ICON_ID);
      r.style.display = "none", n.appendChild(r);
      var i = e.createIconElement(Gje, "not-visible-icon");
      return n.appendChild(i), n.onclick = e.changeVisibility.bind(this, s, r, i), n;
    }
  }]);
}();
E5.VISIBLE_ICON_ID = "visible-icon";
var Xje = E5, qje = /* @__PURE__ */ function() {
  function e() {
    je(this, e);
  }
  return He(e, null, [{
    key: "createCautionText",
    value: function() {
      var s = document.createElement("a");
      return s.classList.add("insert-key-input-help-text"), s.innerText = "Please exercise CAUTION when inserting your API key outside of deepchat.dev or localhost!!", s;
    }
  }, {
    key: "createHelpLink",
    value: function(s) {
      var n = document.createElement("a");
      return n.classList.add("insert-key-input-help-text"), n.href = s, n.innerText = "Find more info here", n.target = "_blank", n;
    }
  }, {
    key: "createFailText",
    value: function() {
      var s = document.createElement("div");
      return s.id = "insert-key-input-invalid-text", s.style.display = "none", s;
    }
  }, {
    key: "createHelpTextContainer",
    value: function(s) {
      var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0, r = document.createElement("div");
      r.id = "insert-key-help-text-container";
      var i = document.createElement("div");
      i.id = "insert-key-help-text-contents";
      var o = e.createFailText();
      if (i.appendChild(o), s) {
        var l = e.createHelpLink(s);
        i.appendChild(l);
      }
      if (n === !0) {
        var d = e.createCautionText();
        i.appendChild(d);
      }
      return r.appendChild(i), {
        helpTextContainerElement: r,
        failTextElement: o
      };
    }
  }, {
    key: "onFail",
    value: function(s, n, r, i) {
      s.classList.replace("insert-key-input-valid", "insert-key-input-invalid"), r.innerText = i, r.style.display = "block", n.innerText = "Start", s.classList.remove("loading");
    }
  }, {
    key: "onLoad",
    value: function(s, n) {
      s.classList.add("loading"), n.innerHTML = '<div id="loading-key"></div>';
    }
    // prettier-ignore
  }, {
    key: "verifyKey",
    value: function(s, n, r) {
      var i = s.value.trim();
      r.verifyKey(i, n);
    }
    // prettier-ignore
  }, {
    key: "addVerificationEvents",
    value: function(s, n, r, i, o) {
      var l = {
        onSuccess: i,
        onFail: e.onFail.bind(this, s, n, r),
        onLoad: e.onLoad.bind(this, s, n)
      }, d = e.verifyKey.bind(this, s, l, o);
      n.onclick = d, s.onkeydown = function(c) {
        !s.classList.contains("loading") && c.key === qa.ENTER && d();
      };
    }
  }, {
    key: "createStartButton",
    value: function() {
      var s = document.createElement("div");
      return s.id = "start-button", s.innerText = "Start", s;
    }
  }, {
    key: "onInputFocus",
    value: function(s) {
      s.target.classList.replace("insert-key-input-invalid", "insert-key-input-valid");
    }
  }, {
    key: "createInput",
    value: function(s) {
      var n = document.createElement("div");
      n.id = "insert-key-input-container";
      var r = document.createElement("input");
      return r.id = "insert-key-input", r.placeholder = s || "API Key", r.type = "password", r.classList.add("insert-key-input-valid"), r.onfocus = e.onInputFocus, n.appendChild(r), n;
    }
    // prettier-ignore
  }, {
    key: "createContents",
    value: function(s, n) {
      var r, i = document.createElement("div");
      i.id = "insert-key-contents";
      var o = e.createInput(n.insertKeyPlaceholderText), l = o.children[0], d = Xje.create(l);
      o.appendChild(d), i.appendChild(o);
      var c = e.createStartButton(), u = e.createHelpTextContainer(n.keyHelpUrl, (r = n.deepChat._insertKeyViewStyles) == null ? void 0 : r.displayCautionText), m = u.helpTextContainerElement, f = u.failTextElement;
      return i.appendChild(c), i.appendChild(m), e.addVerificationEvents(l, c, f, s, n), i;
    }
  }, {
    key: "createElements",
    value: function(s, n) {
      var r = document.createElement("div");
      r.id = "insert-key-view";
      var i = e.createContents(s, n);
      return r.appendChild(i), r;
    }
  }, {
    key: "render",
    value: function(s, n, r) {
      var i = e.createElements(n, r);
      s.replaceChildren(i);
    }
  }]);
}(), jc = /* @__PURE__ */ function() {
  function e() {
    je(this, e);
  }
  return He(e, null, [{
    key: "enableButtons",
    value: function(s, n) {
      var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
      window.webLLM ? (s && (s.disabled = !1), n && (n.disabled = !1)) : r < Mb.MODULE_SEARCH_LIMIT_S * 4 && setTimeout(function() {
        return e.enableButtons(s, n, r + 1);
      }, 250);
    }
    // prettier-ignore
  }, {
    key: "setUpInitial",
    value: function(s, n, r, i) {
      var o = (n == null ? void 0 : n.downloadClass) || e.DOWNLOAD_BUTTON_CLASS, l = (n == null ? void 0 : n.uploadClass) || e.UPLOAD_BUTTON_CLASS, d = (n == null ? void 0 : n.fileInputClass) || e.FILE_INPUT_CLASS;
      return setTimeout(function() {
        var c = r == null ? void 0 : r.getElementsByClassName(o)[0], u = r == null ? void 0 : r.getElementsByClassName(d)[0], m = r == null ? void 0 : r.getElementsByClassName(l)[0];
        c && (c.onclick = function() {
          return s();
        }), u && (u.onchange = function() {
          u.files && u.files.length > 0 && s(u.files);
        }), m && (m.onclick = function() {
          return u.click();
        }), (c || m) && e.enableButtons(c, m);
      }), (n == null ? void 0 : n.initialHtml) || `<div>
        Download or upload a web model that will run entirely on your browser: <br/> 
        <button disabled class="`.concat(o, ` deep-chat-button deep-chat-web-model-button">Download</button>
        `).concat(i ? "" : '<input type="file" class="'.concat(d, `" hidden multiple />
          <button disabled class="`).concat(l, ' deep-chat-button deep-chat-web-model-button">Upload</button>'), `
      </div>`);
    }
  }, {
    key: "exportFile",
    value: function(s) {
      for (var n = document.createElement("a"), r = 4, i = function(d) {
        setTimeout(function() {
          for (var c = d * r, u = c; u < Math.min(c + r, s.length); u += 1) {
            var m = URL.createObjectURL(s[u]);
            n.href = m, n.download = s[u].name, document.body.appendChild(n), n.click(), URL.revokeObjectURL(m);
          }
        }, 500 * d);
      }, o = 0; o < s.length / r; o += 1)
        i(o);
    }
    // prettier-ignore
  }, {
    key: "setUpAfterLoad",
    value: function(s, n, r, i) {
      var o = (n == null ? void 0 : n.exportFilesClass) || e.EXPORT_BUTTON_CLASS;
      return setTimeout(function() {
        var l = r == null ? void 0 : r.getElementsByClassName(o)[0];
        l && (l.onclick = function() {
          return e.exportFile(s);
        });
      }), (n == null ? void 0 : n.afterLoadHtml) || `<div>
        Model loaded successfully and has been cached for future requests.
        `.concat(i ? "" : '<br/> <button style="margin-top: 5px" class="'.concat(o, ' deep-chat-button">Export</button>'), `
      </div>`);
    }
  }]);
}();
jc.DOWNLOAD_BUTTON_CLASS = "deep-chat-download-button", jc.UPLOAD_BUTTON_CLASS = "deep-chat-upload-button", jc.FILE_INPUT_CLASS = "deep-chat-file-input", jc.EXPORT_BUTTON_CLASS = "deep-chat-export-button";
var rC = jc, oC = {
  model_list: [
    // Llama-2
    {
      model_url: "https://huggingface.co/mlc-ai/Llama-2-7b-chat-hf-q4f32_1-MLC/resolve/main/",
      local_id: "Llama-2-7b-chat-hf-q4f32_1",
      model_lib_url: "https://raw.githubusercontent.com/mlc-ai/binary-mlc-llm-libs/main/Llama-2-7b-chat-hf/Llama-2-7b-chat-hf-q4f32_1-ctx4k_cs1k-webgpu.wasm",
      vram_required_MB: 9109.03,
      low_resource_required: !1
    },
    {
      model_url: "https://huggingface.co/mlc-ai/Llama-2-7b-chat-hf-q4f16_1-MLC/resolve/main/",
      local_id: "Llama-2-7b-chat-hf-q4f16_1",
      model_lib_url: "https://raw.githubusercontent.com/mlc-ai/binary-mlc-llm-libs/main/Llama-2-7b-chat-hf/Llama-2-7b-chat-hf-q4f16_1-ctx4k_cs1k-webgpu.wasm",
      vram_required_MB: 6749.02,
      low_resource_required: !1,
      required_features: ["shader-f16"]
    },
    {
      model_url: "https://huggingface.co/mlc-ai/Llama-2-7b-chat-hf-q4f16_1-MLC/resolve/main/",
      local_id: "Llama-2-7b-chat-hf-q4f16_1-1k",
      model_lib_url: "https://raw.githubusercontent.com/mlc-ai/binary-mlc-llm-libs/main/Llama-2-7b-chat-hf/Llama-2-7b-chat-hf-q4f16_1-ctx1k-webgpu.wasm",
      vram_required_MB: 4618.52,
      low_resource_required: !1,
      required_features: ["shader-f16"]
    },
    {
      model_url: "https://huggingface.co/mlc-ai/Llama-2-13b-chat-hf-q4f16_1-MLC/resolve/main/",
      local_id: "Llama-2-13b-chat-hf-q4f16_1",
      model_lib_url: "https://raw.githubusercontent.com/mlc-ai/binary-mlc-llm-libs/main/Llama-2-13b-chat-hf/Llama-2-13b-chat-hf-q4f16_1-ctx4k_cs1k-webgpu.wasm",
      vram_required_MB: 11814.09,
      low_resource_required: !1,
      required_features: ["shader-f16"]
    },
    {
      model_url: "https://huggingface.co/mlc-ai/Llama-2-70b-chat-hf-q4f16_1-MLC/resolve/main/",
      local_id: "Llama-2-70b-chat-hf-q4f16_1",
      model_lib_url: "https://raw.githubusercontent.com/mlc-ai/binary-mlc-llm-libs/main/Llama-2-70b-chat-hf/Llama-2-70b-chat-hf-q4f16_1-ctx4k_cs1k-webgpu.wasm",
      vram_required_MB: 43729.05,
      low_resource_required: !1,
      required_features: ["shader-f16"]
    },
    // RedPajama
    {
      model_url: "https://huggingface.co/mlc-ai/RedPajama-INCITE-Chat-3B-v1-q4f16_1-MLC/resolve/main/",
      local_id: "RedPajama-INCITE-Chat-3B-v1-q4f16_1",
      model_lib_url: "https://raw.githubusercontent.com/mlc-ai/binary-mlc-llm-libs/main/RedPajama-INCITE-Chat-3B-v1/RedPajama-INCITE-Chat-3B-v1-q4f16_1-ctx2k-webgpu.wasm",
      vram_required_MB: 2972.09,
      low_resource_required: !1,
      required_features: ["shader-f16"]
    },
    {
      model_url: "https://huggingface.co/mlc-ai/RedPajama-INCITE-Chat-3B-v1-q4f32_1-MLC/resolve/main/",
      local_id: "RedPajama-INCITE-Chat-3B-v1-q4f32_1",
      model_lib_url: "https://raw.githubusercontent.com/mlc-ai/binary-mlc-llm-libs/main/RedPajama-INCITE-Chat-3B-v1/RedPajama-INCITE-Chat-3B-v1-q4f32_1-ctx2k-webgpu.wasm",
      vram_required_MB: 3928.09,
      low_resource_required: !1
    },
    {
      model_url: "https://huggingface.co/mlc-ai/RedPajama-INCITE-Chat-3B-v1-q4f16_1-MLC/resolve/main/",
      local_id: "RedPajama-INCITE-Chat-3B-v1-q4f16_1-1k",
      model_lib_url: "https://raw.githubusercontent.com/mlc-ai/binary-mlc-llm-libs/main/RedPajama-INCITE-Chat-3B-v1/RedPajama-INCITE-Chat-3B-v1-q4f16_1-ctx1k-webgpu.wasm",
      vram_required_MB: 2041.09,
      low_resource_required: !0,
      required_features: ["shader-f16"]
    },
    {
      model_url: "https://huggingface.co/mlc-ai/RedPajama-INCITE-Chat-3B-v1-q4f32_1-MLC/resolve/main/",
      local_id: "RedPajama-INCITE-Chat-3B-v1-q4f32_1-1k",
      model_lib_url: "https://raw.githubusercontent.com/mlc-ai/binary-mlc-llm-libs/main/RedPajama-INCITE-Chat-3B-v1/RedPajama-INCITE-Chat-3B-v1-q4f32_1-ctx1k-webgpu.wasm",
      vram_required_MB: 2558.09,
      low_resource_required: !0
    },
    // Mistral variants
    {
      model_url: "https://huggingface.co/mlc-ai/WizardMath-7B-V1.1-q4f16_1-MLC/resolve/main/",
      local_id: "WizardMath-7B-V1.1-q4f16_1",
      model_lib_url: "https://raw.githubusercontent.com/mlc-ai/binary-mlc-llm-libs/main/Mistral-7B-Instruct-v0.2/Mistral-7B-Instruct-v0.2-q4f16_1-sw4k_cs1k-webgpu.wasm",
      vram_required_MB: 6079.02,
      low_resource_required: !1,
      required_features: ["shader-f16"]
    },
    {
      model_url: "https://huggingface.co/mlc-ai/Mistral-7B-Instruct-v0.2-q4f16_1-MLC/resolve/main/",
      local_id: "Mistral-7B-Instruct-v0.2-q4f16_1",
      model_lib_url: "https://raw.githubusercontent.com/mlc-ai/binary-mlc-llm-libs/main/Mistral-7B-Instruct-v0.2/Mistral-7B-Instruct-v0.2-q4f16_1-sw4k_cs1k-webgpu.wasm",
      vram_required_MB: 6079.02,
      low_resource_required: !1,
      required_features: ["shader-f16"]
    },
    {
      model_url: "https://huggingface.co/mlc-ai/OpenHermes-2.5-Mistral-7B-q4f16_1-MLC/resolve/main/",
      local_id: "OpenHermes-2.5-Mistral-7B-q4f16_1",
      model_lib_url: "https://raw.githubusercontent.com/mlc-ai/binary-mlc-llm-libs/main/Mistral-7B-Instruct-v0.2/Mistral-7B-Instruct-v0.2-q4f16_1-sw4k_cs1k-webgpu.wasm",
      vram_required_MB: 6079.02,
      low_resource_required: !1,
      required_features: ["shader-f16"]
    },
    {
      model_url: "https://huggingface.co/mlc-ai/NeuralHermes-2.5-Mistral-7B-q4f16_1-MLC/resolve/main/",
      local_id: "NeuralHermes-2.5-Mistral-7B-q4f16_1",
      model_lib_url: "https://raw.githubusercontent.com/mlc-ai/binary-mlc-llm-libs/main/Mistral-7B-Instruct-v0.2/Mistral-7B-Instruct-v0.2-q4f16_1-sw4k_cs1k-webgpu.wasm",
      vram_required_MB: 6079.02,
      low_resource_required: !1,
      required_features: ["shader-f16"]
    },
    // TinyLlama
    {
      model_url: "https://huggingface.co/mlc-ai/TinyLlama-1.1B-Chat-v0.4-q0f16-MLC/resolve/main/",
      local_id: "TinyLlama-1.1B-Chat-v0.4-q0f16",
      model_lib_url: "https://raw.githubusercontent.com/mlc-ai/binary-mlc-llm-libs/main/TinyLlama-1.1B-Chat-v0.4/TinyLlama-1.1B-Chat-v0.4-q0f16-ctx2k-webgpu.wasm",
      vram_required_MB: 5063.52,
      low_resource_required: !1,
      required_features: ["shader-f16"]
    },
    {
      model_url: "https://huggingface.co/mlc-ai/TinyLlama-1.1B-Chat-v0.4-q0f32-MLC/resolve/main/",
      local_id: "TinyLlama-1.1B-Chat-v0.4-q0f32",
      model_lib_url: "https://raw.githubusercontent.com/mlc-ai/binary-mlc-llm-libs/main/TinyLlama-1.1B-Chat-v0.4/TinyLlama-1.1B-Chat-v0.4-q0f32-ctx2k-webgpu.wasm",
      vram_required_MB: 5394.53,
      low_resource_required: !1
    },
    {
      model_url: "https://huggingface.co/mlc-ai/TinyLlama-1.1B-Chat-v0.4-q4f16_1-MLC/resolve/main/",
      local_id: "TinyLlama-1.1B-Chat-v0.4-q4f16_1-1k",
      model_lib_url: "https://raw.githubusercontent.com/mlc-ai/binary-mlc-llm-libs/main/TinyLlama-1.1B-Chat-v0.4/TinyLlama-1.1B-Chat-v0.4-q4f16_1-ctx1k-webgpu.wasm",
      vram_required_MB: 899.11,
      low_resource_required: !0,
      required_features: ["shader-f16"]
    },
    {
      model_url: "https://huggingface.co/mlc-ai/TinyLlama-1.1B-Chat-v0.4-q4f32_1-MLC/resolve/main/",
      local_id: "TinyLlama-1.1B-Chat-v0.4-q4f32_1-1k",
      model_lib_url: "https://raw.githubusercontent.com/mlc-ai/binary-mlc-llm-libs/main/TinyLlama-1.1B-Chat-v0.4/TinyLlama-1.1B-Chat-v0.4-q4f32_1-ctx1k-webgpu.wasm",
      vram_required_MB: 992.11,
      low_resource_required: !0
    }
  ],
  use_web_worker: !0
}, Gl = /* @__PURE__ */ function(e) {
  function t(s) {
    var n;
    je(this, t);
    var r, i;
    return n = jt(this, t, [s]), n._isModelLoaded = !1, n._isModelLoading = !1, n._loadOnFirstMessage = !1, n._webModel = {}, n.permittedErrorPrefixes = [t.MULTIPLE_MODELS_ERROR, t.WEB_LLM_NOT_FOUND_ERROR, t.GENERIC_ERROR], n._conversationHistory = [], St(s.webModel) == "object" && (n._webModel = s.webModel), (r = n._webModel.load) != null && r.clearCache && t.clearAllCache(), n.findModelInWindow(s), n.canSendMessage = n.canSubmit.bind(Vd(n)), n._chatEl = (i = s.shadowRoot) == null ? void 0 : i.children[0], s.history && t.setUpHistory(n._conversationHistory, s.history), n;
  }
  return Ht(t, e), He(t, [{
    key: "setUpMessages",
    value: function(n) {
      var r = this;
      this._messages = n, this._removeIntro = function() {
        n.removeIntroductoryMessage(), r._removeIntro = void 0;
      };
    }
  }, {
    key: "findModelInWindow",
    value: function(n) {
      var r = this, i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, o;
      window.webLLM ? this.configureInit(this.shouldAddIntroMessage(n.introMessage)) : i > t.MODULE_SEARCH_LIMIT_S ? ((o = this._messages) == null || o.addNewErrorMessage("service", t.WEB_LLM_NOT_FOUND_ERROR), console.error("The deep-chat-web-llm module has not been attached to the window object. Please see the following guide:"), console.error("https://deepchat.dev/examples/externalModules")) : setTimeout(function() {
        return r.findModelInWindow(n, i + 1);
      }, 1e3);
    }
  }, {
    key: "shouldAddIntroMessage",
    value: function(n) {
      var r;
      return !n && this._webModel && ((r = this._webModel.introMessage) == null ? void 0 : r.displayed) !== !1;
    }
  }, {
    key: "scrollToTop",
    value: function(n) {
      var r = this, i;
      ((i = this._webModel.introMessage) == null ? void 0 : i.autoScroll) !== !1 && setTimeout(function() {
        var o, l;
        (o = r._messages) != null && o.elementRef && Ln.scrollToTop((l = r._messages) == null ? void 0 : l.elementRef);
      }, n);
    }
    // prettier-ignore
  }, {
    key: "getIntroMessage",
    value: function(n) {
      if (!(!this.shouldAddIntroMessage(n) || !this._chatEl)) {
        var r = rC.setUpInitial(this.init.bind(this), this._webModel.introMessage, this._chatEl, !!this._webModel.worker);
        return this.scrollToTop(1), {
          role: Ft.AI_ROLE,
          html: r,
          sendUpdate: !1
        };
      }
    }
  }, {
    key: "configureInit",
    value: function() {
      var s = Qe(/* @__PURE__ */ ce().mark(function r(i) {
        var o;
        return ce().wrap(function(d) {
          for (; ; ) switch (d.prev = d.next) {
            case 0:
              if (o = this._webModel.load, !o) {
                d.next = 8;
                break;
              }
              if (!o.onInit) {
                d.next = 5;
                break;
              }
              return this.init(), d.abrupt("return");
            case 5:
              if (!o.onMessage) {
                d.next = 8;
                break;
              }
              return this._loadOnFirstMessage = !0, d.abrupt("return");
            case 8:
              i || this.init();
            case 9:
            case "end":
              return d.stop();
          }
        }, r, this);
      }));
      function n(r) {
        return s.apply(this, arguments);
      }
      return n;
    }()
  }, {
    key: "init",
    value: function() {
      var s = Qe(/* @__PURE__ */ ce().mark(function r(i) {
        var o, l;
        return ce().wrap(function(c) {
          for (; ; ) switch (c.prev = c.next) {
            case 0:
              if ((o = this._messages) == null || o.removeError(), l = this.attemptToCreateChat(), c.t0 = l, !c.t0) {
                c.next = 6;
                break;
              }
              return c.next = 6, this.loadModel(l, i);
            case 6:
            case "end":
              return c.stop();
          }
        }, r, this);
      }));
      function n(r) {
        return s.apply(this, arguments);
      }
      return n;
    }()
  }, {
    key: "attemptToCreateChat",
    value: function() {
      var n;
      if (t.chat) {
        (n = this._messages) == null || n.addNewErrorMessage("service", t.MULTIPLE_MODELS_ERROR), console.error(t.MULTIPLE_MODELS_ERROR);
        return;
      }
      if (!(this._isModelLoaded || this._isModelLoading)) {
        var r = this._webModel.worker;
        return oC.use_web_worker && r ? new window.webLLM.ChatWorkerClient(r) : new window.webLLM.ChatModule();
      }
    }
  }, {
    key: "getConfig",
    value: function() {
      var n, r = t.DEFAULT_MODEL;
      this._webModel.model && (r = this._webModel.model);
      var i = JSON.parse(JSON.stringify(oC));
      if (this._webModel.urls) {
        var o = i.model_list.find(function(l) {
          return l.local_id = r;
        });
        o && (this._webModel.urls.model && (o.model_url = this._webModel.urls.model), this._webModel.urls.wasm && (o.model_lib_url = this._webModel.urls.wasm));
      }
      return (n = this._webModel.load) != null && n.skipCache && (i.use_cache = !1), {
        model: r,
        appConfig: i
      };
    }
    // prettier-ignore
  }, {
    key: "loadModel",
    value: function() {
      var s = Qe(/* @__PURE__ */ ce().mark(function r(i, o) {
        var l = this, d, c, u, m, f, v, b, w, S, I, T, x, k, C, O;
        return ce().wrap(function(B) {
          for (; ; ) switch (B.prev = B.next) {
            case 0:
              return this.scrollToTop(), t.chat = i, this._isModelLoading = !0, w = ((d = this._webModel.introMessage) == null ? void 0 : d.displayed) === !1, S = function(R) {
                var F;
                (F = l._messages) == null || F.addNewMessage({
                  html: "<div>".concat(R.text, "</div>"),
                  overwrite: !0,
                  sendUpdate: !1
                }), w && (setTimeout(function() {
                  var L;
                  return Ln.scrollToBottom((L = l._messages) == null ? void 0 : L.elementRef);
                }), w = !1);
              }, t.chat.setInitProgressCallback(S), B.prev = 4, T = this.getConfig(), x = T.model, k = T.appConfig, C = {}, this._webModel.instruction && (C.conv_config = {
                system: this._webModel.instruction
              }), this._conversationHistory.length > 0 && (C.conversation_history = this._conversationHistory), B.next = 10, t.chat.reload(x, C, k, o);
            case 10:
              I = B.sent, B.next = 16;
              break;
            case 13:
              return B.prev = 13, B.t0 = B.catch(4), B.abrupt("return", this.unloadChat(B.t0));
            case 16:
              (u = (c = this.deepChat)._validationHandler) == null || u.call(c), (m = this._webModel.introMessage) != null && m.removeAfterLoad ? this._webModel.introMessage.displayed === !1 ? (v = this._messages) == null || v.removeLastMessage() : (b = this._removeIntro) == null || b.call(this) : (O = rC.setUpAfterLoad(I, this._webModel.introMessage, this._chatEl, !!this._webModel.worker), (f = this._messages) == null || f.addNewMessage({
                html: O,
                overwrite: !0,
                sendUpdate: !1
              })), this._isModelLoaded = !0, this._isModelLoading = !1;
            case 18:
            case "end":
              return B.stop();
          }
        }, r, this, [[4, 13]]);
      }));
      function n(r, i) {
        return s.apply(this, arguments);
      }
      return n;
    }()
  }, {
    key: "unloadChat",
    value: function() {
      var s = Qe(/* @__PURE__ */ ce().mark(function r(i) {
        var o;
        return ce().wrap(function(d) {
          for (; ; ) switch (d.prev = d.next) {
            case 0:
              if ((o = this._messages) == null || o.addNewErrorMessage("service", t.GENERIC_ERROR), console.error(i), this._isModelLoaded = !1, this._isModelLoading = !1, d.t0 = t.chat, !d.t0) {
                d.next = 9;
                break;
              }
              return d.next = 8, t.chat.unload();
            case 8:
              t.chat = void 0;
            case 9:
            case "end":
              return d.stop();
          }
        }, r, this);
      }));
      function n(r) {
        return s.apply(this, arguments);
      }
      return n;
    }()
  }, {
    key: "immediateResp",
    value: function() {
      var s = Qe(/* @__PURE__ */ ce().mark(function r(i, o, l) {
        var d, c;
        return ce().wrap(function(m) {
          for (; ; ) switch (m.prev = m.next) {
            case 0:
              return m.next = 2, l.generate(o, void 0, 0);
            case 2:
              return m.t0 = m.sent, d = {
                text: m.t0
              }, m.next = 6, t.processResponse(this.deepChat, i, d);
            case 6:
              c = m.sent, c && c.forEach(function(f) {
                return i.addNewMessage(f);
              }), this.completionsHandlers.onFinish();
            case 8:
            case "end":
              return m.stop();
          }
        }, r, this);
      }));
      function n(r, i, o) {
        return s.apply(this, arguments);
      }
      return n;
    }()
  }, {
    key: "streamResp",
    value: function() {
      var s = Qe(/* @__PURE__ */ ce().mark(function r(i, o, l) {
        var d = this, c;
        return ce().wrap(function(m) {
          for (; ; ) switch (m.prev = m.next) {
            case 0:
              return this.streamHandlers.abortStream.abort = function() {
                l.interruptGenerate();
              }, this.streamHandlers.onOpen(), c = new fi(i), m.next = 4, l.generate(o, /* @__PURE__ */ function() {
                var f = Qe(/* @__PURE__ */ ce().mark(function v(b, w) {
                  var S;
                  return ce().wrap(function(T) {
                    for (; ; ) switch (T.prev = T.next) {
                      case 0:
                        return T.next = 2, t.processResponse(d.deepChat, i, {
                          text: w
                        });
                      case 2:
                        S = T.sent, S && c.upsertStreamedMessage({
                          text: S[0].text,
                          overwrite: !0
                        });
                      case 4:
                      case "end":
                        return T.stop();
                    }
                  }, v);
                }));
                return function(v, b) {
                  return f.apply(this, arguments);
                };
              }());
            case 4:
              c.finaliseStreamedMessage(), this.streamHandlers.onClose();
            case 6:
            case "end":
              return m.stop();
          }
        }, r, this);
      }));
      function n(r, i, o) {
        return s.apply(this, arguments);
      }
      return n;
    }()
  }, {
    key: "generateRespByType",
    value: function() {
      var s = Qe(/* @__PURE__ */ ce().mark(function r(i, o, l, d) {
        var c;
        return ce().wrap(function(m) {
          for (; ; ) switch (m.prev = m.next) {
            case 0:
              if (m.prev = 0, !l) {
                m.next = 6;
                break;
              }
              return m.next = 4, this.streamResp(i, o, d);
            case 4:
              m.next = 8;
              break;
            case 6:
              return m.next = 8, this.immediateResp(i, o, d);
            case 8:
              m.next = 13;
              break;
            case 10:
              m.prev = 10, m.t0 = m.catch(0), (c = this._messages) == null || c.addNewErrorMessage("service"), console.log(m.t0);
            case 13:
            case "end":
              return m.stop();
          }
        }, r, this, [[0, 10]]);
      }));
      function n(r, i, o, l) {
        return s.apply(this, arguments);
      }
      return n;
    }()
  }, {
    key: "generateResp",
    value: function() {
      var s = Qe(/* @__PURE__ */ ce().mark(function r(i, o, l) {
        var d, c, u, m, f, v, b;
        return ce().wrap(function(S) {
          for (; ; ) switch (S.prev = S.next) {
            case 0:
              return d = o[o.length - 1].text, S.next = 3, Kt.processRequestInterceptor(this.deepChat, {
                body: {
                  text: d
                }
              });
            case 3:
              c = S.sent, u = c.body, m = c.error, f = !!this.stream;
              try {
                m ? (Kt.displayError(i, new Error(m)), (f ? this.streamHandlers.onClose : this.completionsHandlers.onFinish)()) : !u || !u.text ? (v = Ys.INVALID_MODEL_REQUEST({
                  body: u
                }, !1), console.error(v), b = f ? this.streamHandlers.onClose : this.completionsHandlers.onFinish, Kt.onInterceptorError(i, v, b)) : this.generateRespByType(i, u.text, !!this.stream, l);
              } catch (I) {
                this.unloadChat(I);
              }
            case 8:
            case "end":
              return S.stop();
          }
        }, r, this);
      }));
      function n(r, i, o) {
        return s.apply(this, arguments);
      }
      return n;
    }()
  }, {
    key: "callServiceAPI",
    value: function() {
      var s = Qe(/* @__PURE__ */ ce().mark(function r(i, o) {
        var l, d;
        return ce().wrap(function(u) {
          for (; ; ) switch (u.prev = u.next) {
            case 0:
              if (this._isModelLoaded) {
                u.next = 7;
                break;
              }
              if (!this._loadOnFirstMessage) {
                u.next = 6;
                break;
              }
              return u.next = 4, this.init();
            case 4:
              u.next = 7;
              break;
            case 6:
              return u.abrupt("return");
            case 7:
              !t.chat || this._isModelLoading || ((l = this._webModel.introMessage) != null && l.removeAfterMessage && ((d = this._removeIntro) == null || d.call(this)), i.addLoadingMessage(), this.generateResp(i, o, t.chat));
            case 8:
            case "end":
              return u.stop();
          }
        }, r, this);
      }));
      function n(r, i) {
        return s.apply(this, arguments);
      }
      return n;
    }()
  }, {
    key: "canSubmit",
    value: function(n) {
      return !(n != null && n.trim()) || this._isModelLoading ? !1 : this._loadOnFirstMessage ? !0 : !!this._isModelLoaded;
    }
  }, {
    key: "isWebModel",
    value: function() {
      return !0;
    }
  }], [{
    key: "setUpHistory",
    value: function(n, r) {
      r.forEach(function(i, o) {
        if (i.role === Ft.USER_ROLE && i.text) {
          var l = r[o + 1];
          l != null && l.text && l.role !== Ft.USER_ROLE && n.push([i.text, l.text]);
        }
      });
    }
  }, {
    key: "processResponse",
    value: function() {
      var s = Qe(/* @__PURE__ */ ce().mark(function r(i, o, l) {
        var d, c, u, m, f, v;
        return ce().wrap(function(w) {
          for (; ; ) switch (w.prev = w.next) {
            case 0:
              return w.next = 2, (d = i.responseInterceptor) == null ? void 0 : d.call(i, l);
            case 2:
              if (w.t0 = w.sent, w.t0) {
                w.next = 5;
                break;
              }
              w.t0 = l;
            case 5:
              if (u = w.t0, !((c = i.connect) != null && c.stream && Array.isArray(u) && u.length > 1)) {
                w.next = 9;
                break;
              }
              return console.error(Ys.INVALID_STREAM_ARRAY_RESPONSE), w.abrupt("return");
            case 9:
              if (m = Array.isArray(u) ? u : [u], f = m.find(function(S) {
                return typeof S.error == "string";
              }), !f) {
                w.next = 15;
                break;
              }
              return Kt.displayError(o, new Error(f.error)), w.abrupt("return");
            case 15:
              if (!m.find(function(S) {
                return !S || !S.text;
              })) {
                w.next = 19;
                break;
              }
              return v = Ys.INVALID_MODEL_RESPONSE(l, !!i.responseInterceptor, u), Kt.displayError(o, new Error(v)), w.abrupt("return");
            case 19:
              return w.abrupt("return", m);
            case 20:
            case "end":
              return w.stop();
          }
        }, r);
      }));
      function n(r, i, o) {
        return s.apply(this, arguments);
      }
      return n;
    }()
  }, {
    key: "clearAllCache",
    value: function() {
      t.clearCache("webllm/model"), t.clearCache("webllm/wasm");
    }
  }, {
    key: "clearCache",
    value: function(n) {
      caches.open(n).then(function(r) {
        r.keys().then(function(i) {
          i.forEach(function(o) {
            r.delete(o);
          });
        });
      });
    }
  }]);
}(Cm);
Gl.GENERIC_ERROR = "Error, please check the [troubleshooting](https://deepchat.dev/docs/webModel#troubleshooting) section of documentation for help.", Gl.MULTIPLE_MODELS_ERROR = "Cannot run multiple web models", Gl.WEB_LLM_NOT_FOUND_ERROR = "WebLLM module not found", Gl.DEFAULT_MODEL = "Llama-2-7b-chat-hf-q4f32_1", Gl.MODULE_SEARCH_LIMIT_S = 5;
var Mb = Gl, iC = /* @__PURE__ */ function() {
  function e() {
    je(this, e);
  }
  return He(e, null, [{
    key: "buildHeaders",
    value: function(s) {
      return {
        Authorization: "Bearer ".concat(s),
        "Content-Type": "application/json"
        // bigcode/santacoder expects this so adding just-in-case
      };
    }
    // prettier-ignore
  }, {
    key: "handleVerificationResult",
    value: function(s, n, r, i) {
      var o = s;
      Array.isArray(o.error) && o.error[0] === "Error in `parameters`: field required" ? r(n) : i(Ys.INVALID_KEY);
    }
  }, {
    key: "buildKeyVerificationDetails",
    value: function() {
      return {
        url: "https://api-inference.huggingface.co/models/gpt2",
        method: "POST",
        handleVerificationResult: e.handleVerificationResult
      };
    }
  }]);
}(), I5 = /* @__PURE__ */ function(e) {
  function t(s, n, r, i, o, l) {
    var d;
    return je(this, t), d = jt(this, t, [s, iC.buildKeyVerificationDetails(), iC.buildHeaders, o, l]), d.insertKeyPlaceholderText = "Hugging Face Token", d.keyHelpUrl = "https://huggingface.co/settings/tokens", d.introPanelMarkUp = `
    <div style="width: 100%; text-align: center; margin-left: -10px"><b>Hugging Face</b></div>
    <p>First message may take an extented amount of time to complete as the model needs to be initialized.</p>`, d.permittedErrorPrefixes = ["Authorization header"], d.url = "".concat(t.URL_PREFIX).concat(r), d.textInputPlaceholderText = n, St(i) == "object" && (i.model && (d.url = "".concat(t.URL_PREFIX).concat(i.model)), i.options && (d.rawBody.options = i.options), i.parameters && (d.rawBody.parameters = i.parameters)), d;
  }
  return Ht(t, e), He(t, [{
    key: "preprocessBody",
    value: function(n, r, i) {
      var o, l = JSON.parse(JSON.stringify(n)), d = r[r.length - 1].text;
      if (d) return (o = l.options) !== null && o !== void 0 || (l.options = {}), l.options.wait_for_model = !0, ys({
        inputs: d
      }, l);
    }
  }, {
    key: "callServiceAPI",
    value: function() {
      var s = Qe(/* @__PURE__ */ ce().mark(function r(i, o, l) {
        var d;
        return ce().wrap(function(u) {
          for (; ; ) switch (u.prev = u.next) {
            case 0:
              if (this.connectSettings) {
                u.next = 2;
                break;
              }
              throw new Error("Request settings have not been set up");
            case 2:
              d = this.preprocessBody(this.rawBody, o, l), ha.request(this, d, i);
            case 4:
            case "end":
              return u.stop();
          }
        }, r, this);
      }));
      function n(r, i, o) {
        return s.apply(this, arguments);
      }
      return n;
    }()
  }]);
}(tn);
I5.URL_PREFIX = "https://api-inference.huggingface.co/models/";
var kl = I5, xb = /* @__PURE__ */ function(e) {
  function t(s, n, r, i, o, l) {
    var d;
    return je(this, t), d = jt(this, t, [s, n, r, i, o, l]), d.isTextInputDisabled = !0, d.canSendMessage = t.canSendFile, d;
  }
  return Ht(t, e), He(t, [{
    key: "preprocessBody",
    value: function(n, r, i) {
      return i[0];
    }
    // prettier-ignore
  }, {
    key: "callServiceAPI",
    value: function() {
      var s = Qe(/* @__PURE__ */ ce().mark(function r(i, o, l) {
        return ce().wrap(function(c) {
          for (; ; ) switch (c.prev = c.next) {
            case 0:
              if (this.connectSettings) {
                c.next = 2;
                break;
              }
              throw new Error("Request settings have not been set up");
            case 2:
              if (l != null && l[0]) {
                c.next = 4;
                break;
              }
              throw new Error("No file was added");
            case 4:
              ha.poll(this, l[0], i, !1);
            case 5:
            case "end":
              return c.stop();
          }
        }, r, this);
      }));
      function n(r, i, o) {
        return s.apply(this, arguments);
      }
      return n;
    }()
  }], [{
    key: "canSendFile",
    value: function(n, r) {
      return !!(r != null && r[0]);
    }
  }]);
}(kl), Qje = /* @__PURE__ */ function(e) {
  function t(s) {
    je(this, t);
    var n, r, i, o = (r = (n = s.directConnection) == null ? void 0 : n.huggingFace) == null ? void 0 : r.audioClassification, l = (i = s.directConnection) == null ? void 0 : i.huggingFace;
    return jt(this, t, [s, "Attach an audio file", "ehcalabres/wav2vec2-lg-xlsr-en-speech-emotion-recognition", o, l, {
      audio: {}
    }]);
  }
  return Ht(t, e), He(t, [{
    key: "extractPollResultData",
    value: function() {
      var s = Qe(/* @__PURE__ */ ce().mark(function r(i) {
        var o;
        return ce().wrap(function(d) {
          for (; ; ) switch (d.prev = d.next) {
            case 0:
              if (!i.estimated_time) {
                d.next = 2;
                break;
              }
              return d.abrupt("return", {
                timeoutMS: (i.estimated_time + 1) * 1e3
              });
            case 2:
              if (!i.error) {
                d.next = 4;
                break;
              }
              throw i.error;
            case 4:
              return d.abrupt("return", {
                text: ((o = i[0]) == null ? void 0 : o.label) || ""
              });
            case 5:
            case "end":
              return d.stop();
          }
        }, r);
      }));
      function n(r) {
        return s.apply(this, arguments);
      }
      return n;
    }()
  }]);
}(xb), Kje = /* @__PURE__ */ function(e) {
  function t(s) {
    je(this, t);
    var n, r, i, o = (r = (n = s.directConnection) == null ? void 0 : n.huggingFace) == null ? void 0 : r.imageClassification, l = (i = s.directConnection) == null ? void 0 : i.huggingFace;
    return jt(this, t, [s, "Attach an image file", "google/vit-base-patch16-224", o, l, {
      images: {}
    }]);
  }
  return Ht(t, e), He(t, [{
    key: "extractPollResultData",
    value: function() {
      var s = Qe(/* @__PURE__ */ ce().mark(function r(i) {
        var o;
        return ce().wrap(function(d) {
          for (; ; ) switch (d.prev = d.next) {
            case 0:
              if (!i.estimated_time) {
                d.next = 2;
                break;
              }
              return d.abrupt("return", {
                timeoutMS: (i.estimated_time + 1) * 1e3
              });
            case 2:
              if (!i.error) {
                d.next = 4;
                break;
              }
              throw i.error;
            case 4:
              return d.abrupt("return", {
                text: ((o = i[0]) == null ? void 0 : o.label) || ""
              });
            case 5:
            case "end":
              return d.stop();
          }
        }, r);
      }));
      function n(r) {
        return s.apply(this, arguments);
      }
      return n;
    }()
  }]);
}(xb), Ku = "data:image/png;base64,", Si = /* @__PURE__ */ function() {
  function e() {
    je(this, e);
  }
  return He(e, null, [{
    key: "buildHeaders",
    value: function(s) {
      return {
        Authorization: "Bearer ".concat(s),
        "Content-Type": "application/json"
      };
    }
    // prettier-ignore
  }, {
    key: "handleVerificationResult",
    value: function(s, n, r, i) {
      s.message ? i(Ys.INVALID_KEY) : r(n);
    }
  }, {
    key: "buildKeyVerificationDetails",
    value: function() {
      return {
        url: "https://api.stability.ai/v1/engines/list",
        method: "GET",
        handleVerificationResult: e.handleVerificationResult
      };
    }
  }]);
}(), bf = /* @__PURE__ */ function(e) {
  function t(s, n, r, i, o) {
    var l;
    return je(this, t), l = jt(this, t, [s, n, r, i, o]), l.insertKeyPlaceholderText = "Stability AI API Key", l.keyHelpUrl = "https://platform.stability.ai/docs/getting-started/authentication", l.permittedErrorPrefixes = ["Incorrect", "invalid_"], l;
  }
  return Ht(t, e), He(t);
}(tn), Zje = /* @__PURE__ */ function(e) {
  function t(s) {
    var n;
    je(this, t);
    var r, i = JSON.parse(JSON.stringify(s.directConnection)), o = i == null ? void 0 : i.stabilityAI, l = {
      images: {
        files: {
          acceptedFormats: ".png",
          maxNumberOfFiles: 1
        }
      }
    };
    n = jt(this, t, [s, Si.buildKeyVerificationDetails(), Si.buildHeaders, o, l]), n.url = "https://api.stability.ai/v1/generation/esrgan-v1-x2plus/image-to-image/upscale", n.textInputPlaceholderText = "Describe image changes", n.introPanelMarkUp = `
    <div style="width: 100%; text-align: center; margin-left: -10px"><b>Stability AI</b></div>
    <div style="width: 100%; text-align: center; margin-left: -10px; margin-top: 5px"><b>Image to Image Upscale</b></div>
    <p>Upload an image to generate a new one with higher resolution.</p>
    <p>Click <a href="https://platform.stability.ai/">here</a> for more info.</p>`;
    var d = (r = i == null ? void 0 : i.stabilityAI) == null ? void 0 : r.imageToImageUpscale;
    return St(d) == "object" && (d.engine_id && (n.url = "https://api.stability.ai/v1/generation/".concat(d.engine_id, "/image-to-image/upscale")), t.cleanConfig(d), Object.assign(n.rawBody, d)), n.canSendMessage = t.canSendFileMessage, n;
  }
  return Ht(t, e), He(t, [{
    key: "createFormDataBody",
    value: function(n, r) {
      var i = new FormData();
      return i.append("image", r), Object.keys(n).forEach(function(o) {
        i.append(o, String(n[o]));
      }), i;
    }
    // prettier-ignore
  }, {
    key: "callServiceAPI",
    value: function() {
      var s = Qe(/* @__PURE__ */ ce().mark(function r(i, o, l) {
        var d;
        return ce().wrap(function(u) {
          for (; ; ) switch (u.prev = u.next) {
            case 0:
              if (this.connectSettings) {
                u.next = 2;
                break;
              }
              throw new Error("Request settings have not been set up");
            case 2:
              if (l) {
                u.next = 4;
                break;
              }
              throw new Error("Image was not found");
            case 4:
              d = this.createFormDataBody(this.rawBody, l[0]), Kt.tempRemoveContentHeader(this.connectSettings, ha.request.bind(this, this, d, i), !1);
            case 6:
            case "end":
              return u.stop();
          }
        }, r, this);
      }));
      function n(r, i, o) {
        return s.apply(this, arguments);
      }
      return n;
    }()
  }, {
    key: "extractResultData",
    value: function() {
      var s = Qe(/* @__PURE__ */ ce().mark(function r(i) {
        return ce().wrap(function(l) {
          for (; ; ) switch (l.prev = l.next) {
            case 0:
              if (!i.message) {
                l.next = 2;
                break;
              }
              throw i.message;
            case 2:
              return l.abrupt("return", {
                files: i.artifacts.map(function(d) {
                  return {
                    src: "".concat(Ku).concat(d.base64),
                    type: "image"
                  };
                })
              });
            case 3:
            case "end":
              return l.stop();
          }
        }, r);
      }));
      function n(r) {
        return s.apply(this, arguments);
      }
      return n;
    }()
  }], [{
    key: "cleanConfig",
    value: function(n) {
      delete n.engine_id;
    }
  }, {
    key: "canSendFileMessage",
    value: function(n, r) {
      return !!(r != null && r[0]);
    }
  }]);
}(bf), Jje = /* @__PURE__ */ function(e) {
  function t(s) {
    var n;
    je(this, t);
    var r, i = JSON.parse(JSON.stringify(s.directConnection)), o = i == null ? void 0 : i.stabilityAI, l = {
      images: {
        files: {
          acceptedFormats: ".png",
          maxNumberOfFiles: 2
        }
      }
    };
    n = jt(this, t, [s, Si.buildKeyVerificationDetails(), Si.buildHeaders, o, l]), n.url = "https://api.stability.ai/v1/generation/stable-diffusion-xl-1024-v1-0/image-to-image/masking", n._maskSource = "MASK_IMAGE_WHITE", n.textInputPlaceholderText = "Describe image changes", n.introPanelMarkUp = `
    <div style="width: 100%; text-align: center; margin-left: -10px"><b>Stability AI</b></div>
    <div style="width: 100%; text-align: center; margin-left: -10px; margin-top: 5px"><b>Image to Image Masking</b></div>
    <p>Upload an image, its mask image to create a new one based on the changes you have described for the mask area.</p>
    <p>Click <a href="https://platform.stability.ai/">here</a> for more info.</p>`;
    var d = (r = i == null ? void 0 : i.stabilityAI) == null ? void 0 : r.imageToImageMasking;
    return St(d) == "object" && (d.engine_id && (n.url = "https://api.stability.ai/v1/generation/".concat(d.engine_id, "/image-to-image/masking")), d.weight !== void 0 && d.weight !== null && (n._imageWeight = d.weight), d.mask_source !== void 0 && d.mask_source !== null && (n._maskSource = d.mask_source), t.cleanConfig(d), Object.assign(n.rawBody, d)), n.canSendMessage = t.canSendFileTextMessage, n;
  }
  return Ht(t, e), He(t, [{
    key: "createFormDataBody",
    value: function(n, r, i, o) {
      var l = new FormData();
      return l.append("init_image", r), l.append("mask_source", String(this._maskSource)), l.append("mask_image", i), o && o !== "" && l.append("text_prompts[0][text]", o), this._imageWeight !== void 0 && this._imageWeight !== null && l.append("text_prompts[0][weight]", String(this._imageWeight)), Object.keys(n).forEach(function(d) {
        l.append(d, String(n[d]));
      }), l.get("weight") === void 0 && l.append("weight", String(1)), l;
    }
    // prettier-ignore
  }, {
    key: "callServiceAPI",
    value: function() {
      var s = Qe(/* @__PURE__ */ ce().mark(function r(i, o, l) {
        var d, c, u, m;
        return ce().wrap(function(v) {
          for (; ; ) switch (v.prev = v.next) {
            case 0:
              if (this.connectSettings) {
                v.next = 2;
                break;
              }
              throw new Error("Request settings have not been set up");
            case 2:
              if (!(!l || !l[0] || !l[1])) {
                v.next = 4;
                break;
              }
              throw new Error("Image was not found");
            case 4:
              u = (c = (d = o[o.length - 1]) == null ? void 0 : d.text) == null ? void 0 : c.trim(), m = this.createFormDataBody(this.rawBody, l[0], l[1], u), Kt.tempRemoveContentHeader(this.connectSettings, ha.request.bind(this, this, m, i), !1);
            case 6:
            case "end":
              return v.stop();
          }
        }, r, this);
      }));
      function n(r, i, o) {
        return s.apply(this, arguments);
      }
      return n;
    }()
  }, {
    key: "extractResultData",
    value: function() {
      var s = Qe(/* @__PURE__ */ ce().mark(function r(i) {
        return ce().wrap(function(l) {
          for (; ; ) switch (l.prev = l.next) {
            case 0:
              if (!i.message) {
                l.next = 2;
                break;
              }
              throw i.message;
            case 2:
              return l.abrupt("return", {
                files: i.artifacts.map(function(d) {
                  return {
                    src: "".concat(Ku).concat(d.base64),
                    type: "image"
                  };
                })
              });
            case 3:
            case "end":
              return l.stop();
          }
        }, r);
      }));
      function n(r) {
        return s.apply(this, arguments);
      }
      return n;
    }()
  }], [{
    key: "cleanConfig",
    value: function(n) {
      delete n.engine_id, delete n.weight;
    }
  }, {
    key: "canSendFileTextMessage",
    value: function(n, r) {
      return !!(r != null && r[0]) && !!(n && n.trim() !== "");
    }
  }]);
}(bf), $je = /* @__PURE__ */ function(e) {
  function t(s) {
    je(this, t);
    var n, r, i, o = (r = (n = s.directConnection) == null ? void 0 : n.huggingFace) == null ? void 0 : r.audioSpeechRecognition, l = (i = s.directConnection) == null ? void 0 : i.huggingFace;
    return jt(this, t, [s, "Attach an audio file", "facebook/wav2vec2-large-960h-lv60-self", o, l, {
      audio: {}
    }]);
  }
  return Ht(t, e), He(t, [{
    key: "extractPollResultData",
    value: function() {
      var s = Qe(/* @__PURE__ */ ce().mark(function r(i) {
        return ce().wrap(function(l) {
          for (; ; ) switch (l.prev = l.next) {
            case 0:
              if (!i.estimated_time) {
                l.next = 2;
                break;
              }
              return l.abrupt("return", {
                timeoutMS: (i.estimated_time + 1) * 1e3
              });
            case 2:
              if (!i.error) {
                l.next = 4;
                break;
              }
              throw i.error;
            case 4:
              return l.abrupt("return", {
                text: i.text || ""
              });
            case 5:
            case "end":
              return l.stop();
          }
        }, r);
      }));
      function n(r) {
        return s.apply(this, arguments);
      }
      return n;
    }()
  }]);
}(xb), _je = /* @__PURE__ */ function(e) {
  function t(s) {
    je(this, t);
    var n, r, i, o = (r = (n = s.directConnection) == null ? void 0 : n.huggingFace) == null ? void 0 : r.textGeneration, l = (i = s.directConnection) == null ? void 0 : i.huggingFace;
    return jt(this, t, [s, "Once upon a time", "gpt2", o, l]);
  }
  return Ht(t, e), He(t, [{
    key: "extractResultData",
    value: function() {
      var s = Qe(/* @__PURE__ */ ce().mark(function r(i) {
        var o;
        return ce().wrap(function(d) {
          for (; ; ) switch (d.prev = d.next) {
            case 0:
              if (!i.error) {
                d.next = 2;
                break;
              }
              throw i.error;
            case 2:
              return d.abrupt("return", {
                text: ((o = i[0]) == null ? void 0 : o.generated_text) || ""
              });
            case 3:
            case "end":
              return d.stop();
          }
        }, r);
      }));
      function n(r) {
        return s.apply(this, arguments);
      }
      return n;
    }()
  }]);
}(kl), eHe = /* @__PURE__ */ function(e) {
  function t(s) {
    var n;
    je(this, t);
    var r, i, o, l = (i = (r = s.directConnection) == null ? void 0 : r.huggingFace) == null ? void 0 : i.questionAnswer, d = (o = s.directConnection) == null ? void 0 : o.huggingFace;
    return n = jt(this, t, [s, "Ask a question", "bert-large-uncased-whole-word-masking-finetuned-squad", l, d]), n.permittedErrorPrefixes = ["Authorization header", "Error in"], n._context = l.context, n;
  }
  return Ht(t, e), He(t, [{
    key: "preprocessBody",
    value: function(n, r) {
      var i = r[r.length - 1].text;
      if (i) return {
        inputs: {
          question: i,
          context: this._context,
          options: {
            wait_for_model: !0
          }
        }
      };
    }
  }, {
    key: "extractResultData",
    value: function() {
      var s = Qe(/* @__PURE__ */ ce().mark(function r(i) {
        return ce().wrap(function(l) {
          for (; ; ) switch (l.prev = l.next) {
            case 0:
              if (!i.error) {
                l.next = 2;
                break;
              }
              throw i.error;
            case 2:
              return l.abrupt("return", {
                text: i.answer || ""
              });
            case 3:
            case "end":
              return l.stop();
          }
        }, r);
      }));
      function n(r) {
        return s.apply(this, arguments);
      }
      return n;
    }()
  }]);
}(kl), tHe = /* @__PURE__ */ function(e) {
  function t(s) {
    je(this, t);
    var n, r, i, o = (r = (n = s.directConnection) == null ? void 0 : n.huggingFace) == null ? void 0 : r.summarization, l = (i = s.directConnection) == null ? void 0 : i.huggingFace;
    return jt(this, t, [s, "Insert text to summarize", "facebook/bart-large-cnn", o, l]);
  }
  return Ht(t, e), He(t, [{
    key: "extractResultData",
    value: function() {
      var s = Qe(/* @__PURE__ */ ce().mark(function r(i) {
        var o;
        return ce().wrap(function(d) {
          for (; ; ) switch (d.prev = d.next) {
            case 0:
              if (!i.error) {
                d.next = 2;
                break;
              }
              throw i.error;
            case 2:
              return d.abrupt("return", {
                text: ((o = i[0]) == null ? void 0 : o.summary_text) || ""
              });
            case 3:
            case "end":
              return d.stop();
          }
        }, r);
      }));
      function n(r) {
        return s.apply(this, arguments);
      }
      return n;
    }()
  }]);
}(kl), sHe = /* @__PURE__ */ function(e) {
  function t(s) {
    var n, r;
    je(this, t);
    var i, o, l, d = (o = (i = s.directConnection) == null ? void 0 : i.huggingFace) == null ? void 0 : o.conversation, c = (l = s.directConnection) == null ? void 0 : l.huggingFace;
    return r = jt(this, t, [s, "Ask me anything!", "facebook/blenderbot-400M-distill", d, c]), (n = r.maxMessages) !== null && n !== void 0 || (r.maxMessages = -1), r;
  }
  return Ht(t, e), He(t, [{
    key: "processMessages",
    value: function(n) {
      var r = n.filter(function(c) {
        return c.text;
      }), i = r[r.length - 1].text, o = r.slice(0, r.length - 1);
      if (i) {
        var l = o.filter(function(c) {
          return c.role === "user";
        }).map(function(c) {
          return c.text;
        }), d = o.filter(function(c) {
          return c.role === "ai";
        }).map(function(c) {
          return c.text;
        });
        return {
          past_user_inputs: l,
          generated_responses: d,
          mostRecentMessageText: i
        };
      }
    }
    // prettier-ignore
  }, {
    key: "preprocessBody",
    value: function(n, r) {
      var i, o = JSON.parse(JSON.stringify(n)), l = this.processMessages(r);
      if (l) return (i = o.options) !== null && i !== void 0 || (o.options = {}), o.options.wait_for_model = !0, ys({
        inputs: {
          past_user_inputs: l.past_user_inputs,
          generated_responses: l.generated_responses,
          text: l.mostRecentMessageText
        }
      }, o);
    }
  }, {
    key: "extractResultData",
    value: function() {
      var s = Qe(/* @__PURE__ */ ce().mark(function r(i) {
        return ce().wrap(function(l) {
          for (; ; ) switch (l.prev = l.next) {
            case 0:
              if (!i.error) {
                l.next = 2;
                break;
              }
              throw i.error;
            case 2:
              return l.abrupt("return", {
                text: i.generated_text || ""
              });
            case 3:
            case "end":
              return l.stop();
          }
        }, r);
      }));
      function n(r) {
        return s.apply(this, arguments);
      }
      return n;
    }()
  }]);
}(kl), aHe = /* @__PURE__ */ function(e) {
  function t(s) {
    var n;
    je(this, t);
    var r, i = JSON.parse(JSON.stringify(s.directConnection)), o = i.stabilityAI, l = {
      images: {
        files: {
          acceptedFormats: ".png",
          maxNumberOfFiles: 1
        }
      }
    };
    n = jt(this, t, [s, Si.buildKeyVerificationDetails(), Si.buildHeaders, o, l]), n.url = "https://api.stability.ai/v1/generation/stable-diffusion-v1-6/image-to-image", n.textInputPlaceholderText = "Describe image changes", n.introPanelMarkUp = `
    <div style="width: 100%; text-align: center; margin-left: -10px"><b>Stability AI: Image to Image</b></div>
    <p>Upload an image to create a new one with the changes you have described.</p>
    <p>Click <a href="https://platform.stability.ai/">here</a> for more info.</p>`;
    var d = (r = i.stabilityAI) == null ? void 0 : r.imageToImage;
    return St(d) == "object" && (d.engine_id && (n.url = "https://api.stability.ai/v1/generation/".concat(d.engine_id, "/text-to-image")), d.weight !== void 0 && d.weight !== null && (n._imageWeight = d.weight), t.cleanConfig(d), Object.assign(n.rawBody, d)), n.canSendMessage = t.canSendFileTextMessage, n;
  }
  return Ht(t, e), He(t, [{
    key: "createFormDataBody",
    value: function(n, r, i) {
      var o = new FormData();
      return o.append("init_image", r), i && i !== "" && o.append("text_prompts[0][text]", i), this._imageWeight !== void 0 && this._imageWeight !== null && o.append("text_prompts[0][weight]", String(this._imageWeight)), Object.keys(n).forEach(function(l) {
        o.append(l, String(n[l]));
      }), o.get("weight") === void 0 && o.append("weight", String(1)), o;
    }
    // prettier-ignore
  }, {
    key: "callServiceAPI",
    value: function() {
      var s = Qe(/* @__PURE__ */ ce().mark(function r(i, o, l) {
        var d, c, u, m;
        return ce().wrap(function(v) {
          for (; ; ) switch (v.prev = v.next) {
            case 0:
              if (this.connectSettings) {
                v.next = 2;
                break;
              }
              throw new Error("Request settings have not been set up");
            case 2:
              if (l) {
                v.next = 4;
                break;
              }
              throw new Error("Image was not found");
            case 4:
              u = (c = (d = o[o.length - 1]) == null ? void 0 : d.text) == null ? void 0 : c.trim(), m = this.createFormDataBody(this.rawBody, l[0], u), Kt.tempRemoveContentHeader(this.connectSettings, ha.request.bind(this, this, m, i), !1);
            case 6:
            case "end":
              return v.stop();
          }
        }, r, this);
      }));
      function n(r, i, o) {
        return s.apply(this, arguments);
      }
      return n;
    }()
  }, {
    key: "extractResultData",
    value: function() {
      var s = Qe(/* @__PURE__ */ ce().mark(function r(i) {
        return ce().wrap(function(l) {
          for (; ; ) switch (l.prev = l.next) {
            case 0:
              if (!i.message) {
                l.next = 2;
                break;
              }
              throw i.message;
            case 2:
              return l.abrupt("return", {
                files: i.artifacts.map(function(d) {
                  return {
                    src: "".concat(Ku).concat(d.base64),
                    type: "image"
                  };
                })
              });
            case 3:
            case "end":
              return l.stop();
          }
        }, r);
      }));
      function n(r) {
        return s.apply(this, arguments);
      }
      return n;
    }()
  }], [{
    key: "cleanConfig",
    value: function(n) {
      delete n.engine_id, delete n.weight;
    }
  }, {
    key: "canSendFileTextMessage",
    value: function(n, r) {
      return !!(r != null && r[0]) && !!(n && n.trim() !== "");
    }
  }]);
}(bf), nHe = /* @__PURE__ */ function(e) {
  function t(s) {
    je(this, t);
    var n, r, i, o = (r = (n = s.directConnection) == null ? void 0 : n.huggingFace) == null ? void 0 : r.translation, l = (i = s.directConnection) == null ? void 0 : i.huggingFace;
    return jt(this, t, [s, "Insert text to translate", "Helsinki-NLP/opus-tatoeba-en-ja", o, l]);
  }
  return Ht(t, e), He(t, [{
    key: "extractResultData",
    value: function() {
      var s = Qe(/* @__PURE__ */ ce().mark(function r(i) {
        var o;
        return ce().wrap(function(d) {
          for (; ; ) switch (d.prev = d.next) {
            case 0:
              if (!i.error) {
                d.next = 2;
                break;
              }
              throw i.error;
            case 2:
              return d.abrupt("return", {
                text: ((o = i[0]) == null ? void 0 : o.translation_text) || ""
              });
            case 3:
            case "end":
              return d.stop();
          }
        }, r);
      }));
      function n(r) {
        return s.apply(this, arguments);
      }
      return n;
    }()
  }]);
}(kl), rHe = /* @__PURE__ */ function(e) {
  function t(s) {
    var n;
    je(this, t);
    var r, i = JSON.parse(JSON.stringify(s.directConnection)), o = i.stabilityAI;
    n = jt(this, t, [s, Si.buildKeyVerificationDetails(), Si.buildHeaders, o]), n.url = "https://api.stability.ai/v1/generation/stable-diffusion-v1-6/text-to-image", n.textInputPlaceholderText = "Describe an image", n.introPanelMarkUp = `
    <div style="width: 100%; text-align: center; margin-left: -10px"><b>Stability AI: Text to Image</b></div>
    <p>Insert text to generate an image.</p>
    <p>Click <a href="https://platform.stability.ai/">here</a> for more info.</p>`;
    var l = (r = i.stabilityAI) == null ? void 0 : r.textToImage;
    return St(l) == "object" && (l.engine_id && (n.url = "https://api.stability.ai/v1/generation/".concat(l.engine_id, "/text-to-image")), l.weight !== void 0 && l.weight !== null && (n._imageWeight = l.weight), t.cleanConfig(l), Object.assign(n.rawBody, l)), n.canSendMessage = t.canSendTextMessage, n;
  }
  return Ht(t, e), He(t, [{
    key: "preprocessBody",
    value: function(n, r) {
      var i = JSON.parse(JSON.stringify(n)), o = {
        text: r
      };
      return this._imageWeight && (o.weight = this._imageWeight), i.text_prompts = [o], i;
    }
  }, {
    key: "callServiceAPI",
    value: function() {
      var s = Qe(/* @__PURE__ */ ce().mark(function r(i, o) {
        var l;
        return ce().wrap(function(c) {
          for (; ; ) switch (c.prev = c.next) {
            case 0:
              if (this.connectSettings) {
                c.next = 2;
                break;
              }
              throw new Error("Request settings have not been set up");
            case 2:
              l = this.preprocessBody(this.rawBody, o[o.length - 1].text), ha.request(this, l, i);
            case 4:
            case "end":
              return c.stop();
          }
        }, r, this);
      }));
      function n(r, i) {
        return s.apply(this, arguments);
      }
      return n;
    }()
  }, {
    key: "extractResultData",
    value: function() {
      var s = Qe(/* @__PURE__ */ ce().mark(function r(i) {
        return ce().wrap(function(l) {
          for (; ; ) switch (l.prev = l.next) {
            case 0:
              if (!i.message) {
                l.next = 2;
                break;
              }
              throw i.message;
            case 2:
              return l.abrupt("return", {
                files: i.artifacts.map(function(d) {
                  return {
                    src: "".concat(Ku).concat(d.base64),
                    type: "image"
                  };
                })
              });
            case 3:
            case "end":
              return l.stop();
          }
        }, r);
      }));
      function n(r) {
        return s.apply(this, arguments);
      }
      return n;
    }()
  }], [{
    key: "cleanConfig",
    value: function(n) {
      delete n.engine_id, delete n.weight;
    }
  }, {
    key: "canSendTextMessage",
    value: function(n) {
      return !!(n && n.trim() !== "");
    }
  }]);
}(bf), oHe = /* @__PURE__ */ function(e) {
  function t(s) {
    var n;
    je(this, t);
    var r, i, o, l = (i = (r = s.directConnection) == null ? void 0 : r.huggingFace) == null ? void 0 : i.fillMask, d = (o = s.directConnection) == null ? void 0 : o.huggingFace;
    return n = jt(this, t, [s, "The goal of life is [MASK].", "bert-base-uncased", l, d]), n.introPanelMarkUp = `
    <div style="width: 100%; text-align: center; margin-left: -10px"><b>Hugging Face</b></div>
    <p>Insert a sentence with the word [MASK] and the model will try to fill it for you. E.g. I want [MASK].</p>
    <p>First message may take an extented amount of time to complete as the model needs to be initialized.</p>`, n.permittedErrorPrefixes = ["Authorization header", "No mask_token"], n;
  }
  return Ht(t, e), He(t, [{
    key: "extractResultData",
    value: function() {
      var s = Qe(/* @__PURE__ */ ce().mark(function r(i) {
        var o;
        return ce().wrap(function(d) {
          for (; ; ) switch (d.prev = d.next) {
            case 0:
              if (!i.error) {
                d.next = 2;
                break;
              }
              throw i.error;
            case 2:
              return d.abrupt("return", {
                text: ((o = i[0]) == null ? void 0 : o.sequence) || ""
              });
            case 3:
            case "end":
              return d.stop();
          }
        }, r);
      }));
      function n(r) {
        return s.apply(this, arguments);
      }
      return n;
    }()
  }]);
}(kl), Ty = /* @__PURE__ */ function() {
  function e() {
    je(this, e);
  }
  return He(e, null, [{
    key: "buildHeaders",
    value: function(s) {
      return {
        Authorization: "Bearer ".concat(s),
        "Content-Type": "application/json"
      };
    }
    // prettier-ignore
  }, {
    key: "handleVerificationResult",
    value: function(s, n, r, i) {
      var o = s;
      o.error ? o.error.code === "invalid_api_key" ? i(Ys.INVALID_KEY) : i(Ys.CONNECTION_FAILED) : r(n);
    }
  }, {
    key: "buildKeyVerificationDetails",
    value: function() {
      return {
        url: "https://api.openai.com/v1/models",
        method: "GET",
        handleVerificationResult: e.handleVerificationResult
      };
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  }, {
    key: "directFetch",
    value: function() {
      var t = Qe(/* @__PURE__ */ ce().mark(function n(r, i, o) {
        var l, d, c = arguments;
        return ce().wrap(function(m) {
          for (; ; ) switch (m.prev = m.next) {
            case 0:
              return l = c.length > 3 && c[3] !== void 0 ? c[3] : !0, r.connectSettings.method = o, m.next = 4, Kt.fetch(r, r.connectSettings.headers, l, i).then(function(f) {
                return Kt.processResponseByType(f);
              });
            case 4:
              if (d = m.sent, !d.error) {
                m.next = 7;
                break;
              }
              throw d.error.message;
            case 7:
              return m.abrupt("return", d);
            case 8:
            case "end":
              return m.stop();
          }
        }, n);
      }));
      function s(n, r, i) {
        return t.apply(this, arguments);
      }
      return s;
    }()
  }]);
}();
Ty.FUNCTION_TOOL_RESP_ERROR = "Response object must either be {response: string}[] for each individual function or {text: string} for a direct response, see https://deepchat.dev/docs/directConnection/OpenAI#FunctionHandler.", Ty.FUNCTION_TOOL_RESP_ARR_ERROR = "Arrays are not accepted in handler responses";
var La = Ty, Oy = /* @__PURE__ */ function() {
  function e() {
    je(this, e);
  }
  return He(e, null, [{
    key: "storeFiles",
    value: function() {
      var t = Qe(/* @__PURE__ */ ce().mark(function n(r, i, o, l) {
        var d, c, u, m;
        return ce().wrap(function(v) {
          for (; ; ) switch (v.prev = v.next) {
            case 0:
              if (d = r.connectSettings.headers, d) {
                v.next = 3;
                break;
              }
              return v.abrupt("return");
            case 3:
              return r.url = l, c = d[Kt.CONTENT_TYPE], delete d[Kt.CONTENT_TYPE], u = o.map(/* @__PURE__ */ function() {
                var b = Qe(/* @__PURE__ */ ce().mark(function w(S) {
                  var I;
                  return ce().wrap(function(x) {
                    for (; ; ) switch (x.prev = x.next) {
                      case 0:
                        return I = new FormData(), x.abrupt("return", (I.append("purpose", "assistants"), I.append("file", S), new Promise(function(k) {
                          k(La.directFetch(r, I, "POST", !1));
                        })));
                      case 2:
                      case "end":
                        return x.stop();
                    }
                  }, w);
                }));
                return function(w) {
                  return b.apply(this, arguments);
                };
              }()), v.prev = 7, v.next = 10, Promise.all(u);
            case 10:
              return m = v.sent.map(function(b) {
                return {
                  id: b.id,
                  name: b.filename
                };
              }), v.abrupt("return", (d[Kt.CONTENT_TYPE] = c, m));
            case 14:
              throw v.prev = 14, v.t0 = v.catch(7), d[Kt.CONTENT_TYPE] = c, Kt.displayError(i, v.t0), r.completionsHandlers.onFinish(), v.t0;
            case 17:
            case "end":
              return v.stop();
          }
        }, n, null, [[7, 14]]);
      }));
      function s(n, r, i, o) {
        return t.apply(this, arguments);
      }
      return s;
    }()
  }, {
    key: "getType",
    value: function(s, n) {
      var r = s[n].path;
      return !r || r.endsWith("png") ? "image" : "any";
    }
  }, {
    key: "getFiles",
    value: function() {
      var t = Qe(/* @__PURE__ */ ce().mark(function n(r, i, o, l) {
        var d, c;
        return ce().wrap(function(m) {
          for (; ; ) switch (m.prev = m.next) {
            case 0:
              return d = i.map(function(f) {
                var v = f.fileId;
                return r.url = "".concat(o).concat(v).concat(l), new Promise(function(b) {
                  b(La.directFetch(r, void 0, "GET", !1));
                });
              }), m.next = 3, Promise.all(d);
            case 3:
              return c = m.sent.map(function(f, v) {
                return new Promise(function(b) {
                  var w = new FileReader();
                  w.readAsDataURL(f), w.onload = function(S) {
                    b({
                      src: S.target.result,
                      name: i[v].name,
                      type: e.getType(i, v)
                    });
                  };
                });
              }), m.next = 6, Promise.all(c);
            case 6:
              return m.abrupt("return", m.sent);
            case 7:
            case "end":
              return m.stop();
          }
        }, n);
      }));
      function s(n, r, i, o) {
        return t.apply(this, arguments);
      }
      return s;
    }()
  }, {
    key: "getFileName",
    value: function(s) {
      var n = s.split("/");
      return n[n.length - 1];
    }
    // prettier-ignore
  }, {
    key: "getFilesAndNewText",
    value: function() {
      var t = Qe(/* @__PURE__ */ ce().mark(function n(r, i, o, l, d) {
        var c, u, m, f, v;
        return ce().wrap(function(w) {
          for (; ; ) switch (w.prev = w.next) {
            case 0:
              if (f = o.getFilesPrefix, v = o.getFilesPostfix, w.t0 = i.length > 0, !w.t0) {
                w.next = 7;
                break;
              }
              return w.next = 5, e.getFiles(r, i, f, v);
            case 5:
              m = w.sent, (c = d == null ? void 0 : d.text) != null && c.value && m.forEach(function(S, I) {
                var T;
                if (S.src) {
                  var x = i[I].path;
                  (T = d == null ? void 0 : d.text) != null && T.value && x && (d.text.value = d.text.value.replace(x, S.src));
                }
              });
            case 7:
              return w.abrupt("return", (u = d == null ? void 0 : d.text) != null && u.value ? {
                text: d.text.value,
                role: l
              } : {
                files: m,
                role: l
              });
            case 8:
            case "end":
              return w.stop();
          }
        }, n);
      }));
      function s(n, r, i, o, l) {
        return t.apply(this, arguments);
      }
      return s;
    }()
    // Noticed an issue where text contains a sandbox hyperlink to a csv, but no annotation provided
    // To reproduce use the following text:
    // give example data for a csv and create a suitable bar chart for it with a link
    // Don't think it can be fixed and it is something on OpenAI side of things
    // prettier-ignore
  }, {
    key: "getFileDetails",
    value: function(s, n) {
      var r, i = [];
      return (r = n == null ? void 0 : n.text) != null && r.value && s.content.forEach(function(o) {
        var l, d;
        (d = (l = o.text) == null ? void 0 : l.annotations) == null || d.forEach(function(c) {
          var u;
          c.text && c.text.startsWith("sandbox:") && (u = c.file_path) != null && u.file_id && i.push({
            path: c.text,
            fileId: c.file_path.file_id,
            name: e.getFileName(c.text)
          });
        });
      }), n != null && n.image_file && i.push({
        fileId: n.image_file.file_id
      }), i;
    }
    // prettier-ignore
  }, {
    key: "getFilesAndText",
    value: function() {
      var t = Qe(/* @__PURE__ */ ce().mark(function n(r, i, o, l) {
        var d;
        return ce().wrap(function(u) {
          for (; ; ) switch (u.prev = u.next) {
            case 0:
              return d = e.getFileDetails(i, l), u.next = 3, e.getFilesAndNewText(r, d, o, i.role, l);
            case 3:
              return u.abrupt("return", u.sent);
            case 4:
            case "end":
              return u.stop();
          }
        }, n);
      }));
      function s(n, r, i, o) {
        return t.apply(this, arguments);
      }
      return s;
    }()
  }, {
    key: "parseResult",
    value: function(s, n) {
      var r = [];
      if (n) r = s.data;
      else for (var i = 0; i < s.data.length; i += 1) {
        var o = s.data[i];
        if (o.role === "assistant") r.push(o);
        else break;
      }
      return r.reverse();
    }
    // test this using this prompt and it should give 2 text mesages and a file:
    // "give example data for a csv and create a suitable bar chart"
  }, {
    key: "parseMessages",
    value: function(s, n, r) {
      var i = [];
      return n.forEach(/* @__PURE__ */ function() {
        var o = Qe(/* @__PURE__ */ ce().mark(function l(d) {
          return ce().wrap(function(u) {
            for (; ; ) switch (u.prev = u.next) {
              case 0:
                d.content.filter(function(m) {
                  return !!m.text || !!m.image_file;
                }).sort(function(m) {
                  return m.text ? -1 : m.image_file ? 1 : 0;
                }).forEach(/* @__PURE__ */ function() {
                  var m = Qe(/* @__PURE__ */ ce().mark(function f(v) {
                    return ce().wrap(function(w) {
                      for (; ; ) switch (w.prev = w.next) {
                        case 0:
                          i.push(e.getFilesAndText(s, d, r, v));
                        case 1:
                        case "end":
                          return w.stop();
                      }
                    }, f);
                  }));
                  return function(f) {
                    return m.apply(this, arguments);
                  };
                }());
              case 1:
              case "end":
                return u.stop();
            }
          }, l);
        }));
        return function(l) {
          return o.apply(this, arguments);
        };
      }()), Promise.all(i);
    }
  }, {
    key: "processStreamMessages",
    value: function() {
      var t = Qe(/* @__PURE__ */ ce().mark(function n(r, i, o) {
        return ce().wrap(function(d) {
          for (; ; ) switch (d.prev = d.next) {
            case 0:
              return d.abrupt("return", e.parseMessages(r, [{
                content: i,
                role: "assistant"
              }], o));
            case 1:
            case "end":
              return d.stop();
          }
        }, n);
      }));
      function s(n, r, i) {
        return t.apply(this, arguments);
      }
      return s;
    }()
    // prettier-ignore
  }, {
    key: "processAPIMessages",
    value: function() {
      var t = Qe(/* @__PURE__ */ ce().mark(function n(r, i, o, l) {
        var d;
        return ce().wrap(function(u) {
          for (; ; ) switch (u.prev = u.next) {
            case 0:
              return d = e.parseResult(i, o), u.abrupt("return", e.parseMessages(r, d, l));
            case 2:
            case "end":
              return u.stop();
          }
        }, n);
      }));
      function s(n, r, i, o) {
        return t.apply(this, arguments);
      }
      return s;
    }()
  }]);
}();
Oy.FILES_WITH_TEXT_ERROR = "content with type `text` must have `text` values", Oy.FUNCTION_TOOL_RESP_ERROR = "Response must contain an array of strings for each individual function/tool_call, see https://deepchat.dev/docs/directConnection/OpenAI/#assistant-functions.";
var Di = Oy, T5 = /* @__PURE__ */ function(e) {
  function t(s, n, r, i, o, l) {
    var d;
    if (je(this, t), d = jt(this, t, [s, i, o, l]), d.insertKeyPlaceholderText = "OpenAI API Key", d.keyHelpUrl = "https://platform.openai.com/account/api-keys", d.url = "", d.permittedErrorPrefixes = ["Incorrect", "Please send text", Bb.FAILED_ERROR_MESSAGE], d.shouldFetchHistory = !1, d._searchedForThreadId = !1, d._config = {}, d._newAssistantDetails = {
      model: "gpt-4"
    }, d._waitingForStreamResponse = !1, d._isSSEStream = !1, d.urlSegments = r, St(n) == "object") {
      d._config = n;
      var c = d._config, u = c.new_assistant, m = c.thread_id, f = c.load_thread_history;
      Object.assign(d._newAssistantDetails, u), m && (d.sessionId = m), f && (d.shouldFetchHistory = !0);
    }
    return d.maxMessages = 1, d._isSSEStream = !!(d.stream && (St(d.stream) != "object" || !d.stream.simulation)), d;
  }
  return Ht(t, e), He(t, [{
    key: "fetchHistoryFunc",
    value: function() {
      var s = Qe(/* @__PURE__ */ ce().mark(function r() {
        var i = this, o;
        return ce().wrap(function(d) {
          for (; ; ) switch (d.prev = d.next) {
            case 0:
              return setTimeout(function() {
                return i.deepChat.disableSubmitButton();
              }, 2), d.prev = 1, d.next = 4, this.getThreadMessages(this.sessionId, !0);
            case 4:
              return o = d.sent, d.abrupt("return", (this.deepChat.disableSubmitButton(!1), o));
            case 8:
              return d.prev = 8, d.t0 = d.catch(1), d.abrupt("return", [{
                error: "Failed to fetch history"
              }]);
            case 11:
            case "end":
              return d.stop();
          }
        }, r, this, [[1, 8]]);
      }));
      function n() {
        return s.apply(this, arguments);
      }
      return n;
    }()
  }, {
    key: "processMessage",
    value: function(n, r) {
      var i = this.totalMessagesMaxCharLength || -1, o = yf.getCharacterLimitMessages(n, i)[0];
      if (r && r.length > 0) {
        var l = this.filesToolType;
        if (typeof this.filesToolType == "function") {
          var d = this.filesToolType(r.map(function(u) {
            var m = u.name;
            return m;
          }));
          d === "code_interpreter" || d === "file_search" || d === "images" ? l = d : (console.error('Tool type "'.concat(d, '" is not valid')), console.error('Expected "code_interpreter" or "file_search" or "images". Going to default to "images"'));
        }
        if (l === "file_search") return t.processAttachmentsMessage(o, r, "file_search");
        if (l === "code_interpreter") return t.processAttachmentsMessage(o, r, "code_interpreter");
        if (r.find(function(u) {
          var m = u.name;
          return !cn.isImageFileExtension(m);
        })) console.error("The uploaded files contained a non-image file"), console.error('Make sure only images can be uploaded or define a "code_interpreter" or "file_search" value in the "files_tool_type" property'), console.warn('Make sure your existing assistant supports these "tools" or specify them in the "new_assistant" property');
        else {
          var c = t.processImageMessage(o, r);
          if (c) return c;
        }
      }
      return {
        content: o.text || "",
        role: "user"
      };
    }
  }, {
    key: "createNewThreadMessages",
    value: function(n, r, i) {
      var o = JSON.parse(JSON.stringify(n)), l = this.processMessage(r, i);
      return o.thread = {
        messages: [l]
      }, o;
    }
  }, {
    key: "callService",
    value: function(n, r, i) {
      if (this._messages = n, this.sessionId) {
        this.url = "".concat(this.urlSegments.threadsPrefix, "/").concat(this.sessionId, "/messages").concat(this.urlSegments.createMessagePostfix);
        var o = this.processMessage(r, i);
        ha.request(this, o, n);
      } else {
        this.url = "".concat(this.urlSegments.threadsPrefix, "/runs").concat(this.urlSegments.threadsPosfix);
        var l = this.createNewThreadMessages(this.rawBody, r, i);
        this._isSSEStream ? this.createStreamRun(l) : ha.request(this, l, n);
      }
    }
  }, {
    key: "callServiceAPI",
    value: function() {
      var s = Qe(/* @__PURE__ */ ce().mark(function r(i, o, l) {
        var d, c, u;
        return ce().wrap(function(f) {
          for (; ; ) switch (f.prev = f.next) {
            case 0:
              if (this._waitingForStreamResponse = !1, !!this.connectSettings) {
                f.next = 2;
                break;
              }
              throw new Error("Request settings have not been set up");
            case 2:
              if (!((d = (c = this.rawBody).assistant_id) !== null && d !== void 0)) {
                f.next = 6;
                break;
              }
              f.next = 12;
              break;
            case 6:
              if (f.t0 = this._config.assistant_id, f.t0) {
                f.next = 11;
                break;
              }
              return f.next = 10, this.createNewAssistant();
            case 10:
              f.t0 = f.sent;
            case 11:
              c.assistant_id = f.t0;
            case 12:
              if (this._searchedForThreadId || this.searchPreviousMessagesForThreadId(i.messageToElements), !l) {
                f.next = 19;
                break;
              }
              return f.next = 16, Di.storeFiles(this, i, l, this.urlSegments.storeFiles);
            case 16:
              f.t1 = f.sent, f.next = 20;
              break;
            case 19:
              f.t1 = void 0;
            case 20:
              u = f.t1, this.connectSettings.method = "POST", this.callService(i, o, u);
            case 22:
            case "end":
              return f.stop();
          }
        }, r, this);
      }));
      function n(r, i, o) {
        return s.apply(this, arguments);
      }
      return n;
    }()
  }, {
    key: "createNewAssistant",
    value: function() {
      var s = Qe(/* @__PURE__ */ ce().mark(function r() {
        var i;
        return ce().wrap(function(l) {
          for (; ; ) switch (l.prev = l.next) {
            case 0:
              return l.prev = 0, this.url = this.urlSegments.newAssistantUrl, l.next = 4, La.directFetch(this, JSON.parse(JSON.stringify(this._newAssistantDetails)), "POST");
            case 4:
              return i = l.sent, l.abrupt("return", (this._config.assistant_id = i.id, this._config.assistant_id));
            case 8:
              l.prev = 8, l.t0 = l.catch(0), console.error(l.t0), console.error("Failed to create a new assistant");
            case 11:
            case "end":
              return l.stop();
          }
        }, r, this, [[0, 8]]);
      }));
      function n() {
        return s.apply(this, arguments);
      }
      return n;
    }()
  }, {
    key: "searchPreviousMessagesForThreadId",
    value: function(n) {
      var r = n.find(function(i) {
        var o = dl(i, 1), l = o[0];
        return l._sessionId;
      });
      r && (this.sessionId = r[0]._sessionId), this._searchedForThreadId = !0;
    }
    // prettier-ignore
  }, {
    key: "extractResultData",
    value: function() {
      var s = Qe(/* @__PURE__ */ ce().mark(function r(i) {
        var o, l, d;
        return ce().wrap(function(u) {
          for (; ; ) switch (u.prev = u.next) {
            case 0:
              if (!(this._waitingForStreamResponse || this._isSSEStream && this.sessionId)) {
                u.next = 4;
                break;
              }
              return u.next = 3, this.handleStream(i);
            case 3:
              return u.abrupt("return", u.sent);
            case 4:
              if (!i.error) {
                u.next = 6;
                break;
              }
              throw i.error.message.startsWith(Di.FILES_WITH_TEXT_ERROR) ? Error("Please send text with your file(s)") : i.error.message;
            case 6:
              return u.next = 8, this.assignThreadAndRun(i);
            case 8:
              return l = "".concat(this.urlSegments.threadsPrefix, "/").concat(this.sessionId, "/runs/").concat(this.run_id).concat(this.urlSegments.threadsPosfix), d = {
                method: "GET",
                headers: (o = this.connectSettings) == null ? void 0 : o.headers
              }, u.abrupt("return", (ha.executePollRequest(this, l, d, this._messages), {
                makingAnotherRequest: !0
              }));
            case 10:
            case "end":
              return u.stop();
          }
        }, r, this);
      }));
      function n(r) {
        return s.apply(this, arguments);
      }
      return n;
    }()
  }, {
    key: "assignThreadAndRun",
    value: function() {
      var s = Qe(/* @__PURE__ */ ce().mark(function r(i) {
        var o;
        return ce().wrap(function(d) {
          for (; ; ) switch (d.prev = d.next) {
            case 0:
              if (!this.sessionId) {
                d.next = 8;
                break;
              }
              return this.url = "".concat(this.urlSegments.threadsPrefix, "/").concat(this.sessionId, "/runs").concat(this.urlSegments.threadsPosfix), d.next = 4, La.directFetch(this, JSON.parse(JSON.stringify(this.rawBody)), "POST");
            case 4:
              o = d.sent, this.run_id = o.id, d.next = 9;
              break;
            case 8:
              this.sessionId = i.thread_id, this.run_id = i.id, this._messages && this._messages.messageToElements.length > 0 && (this._messages.messageToElements[this._messages.messageToElements.length - 1][0]._sessionId = this.sessionId);
            case 9:
            case "end":
              return d.stop();
          }
        }, r, this);
      }));
      function n(r) {
        return s.apply(this, arguments);
      }
      return n;
    }()
  }, {
    key: "getThreadMessages",
    value: function() {
      var s = Qe(/* @__PURE__ */ ce().mark(function r(i) {
        var o, l, d, c, u = arguments;
        return ce().wrap(function(f) {
          for (; ; ) switch (f.prev = f.next) {
            case 0:
              return o = u.length > 1 && u[1] !== void 0 ? u[1] : !1, this.url = "".concat(this.urlSegments.threadsPrefix, "/").concat(i, "/messages?").concat(this.urlSegments.listMessagesPostfix), f.next = 4, La.directFetch(this, {}, "GET");
            case 4:
              if (c = f.sent, f.t0 = !o && this.deepChat.responseInterceptor, !f.t0) {
                f.next = 10;
                break;
              }
              return f.next = 9, (d = (l = this.deepChat).responseInterceptor) == null ? void 0 : d.call(l, c);
            case 9:
              c = f.sent;
            case 10:
              return f.abrupt("return", Di.processAPIMessages(this, c, o, this.urlSegments));
            case 11:
            case "end":
              return f.stop();
          }
        }, r, this);
      }));
      function n(r) {
        return s.apply(this, arguments);
      }
      return n;
    }()
  }, {
    key: "extractPollResultData",
    value: function() {
      var s = Qe(/* @__PURE__ */ ce().mark(function r(i) {
        var o = this, l, d, c, u, m, f, v, b;
        return ce().wrap(function(S) {
          for (; ; ) switch (S.prev = S.next) {
            case 0:
              if (d = i.status, c = i.required_action, !(d === "queued" || d === "in_progress")) {
                S.next = 3;
                break;
              }
              return S.abrupt("return", {
                timeoutMS: t.POLLING_TIMEOUT_MS
              });
            case 3:
              if (!(d === "completed" && this._messages)) {
                S.next = 11;
                break;
              }
              return S.next = 6, this.getThreadMessages(i.thread_id);
            case 6:
              return u = S.sent, m = u.shift(), f = m.text, v = m.files, S.abrupt("return", (setTimeout(function() {
                u.forEach(function(I) {
                  return o.deepChat.addMessage(I);
                });
              }), {
                text: f,
                _sessionId: this.sessionId,
                files: v
              }));
            case 11:
              if (b = (l = c == null ? void 0 : c.submit_tool_outputs) == null ? void 0 : l.tool_calls, !(d === "requires_action" && b)) {
                S.next = 16;
                break;
              }
              return S.next = 15, this.handleTools(b);
            case 15:
              return S.abrupt("return", S.sent);
            case 16:
              throw Error("Thread run status: ".concat(d));
            case 17:
            case "end":
              return S.stop();
          }
        }, r, this);
      }));
      function n(r) {
        return s.apply(this, arguments);
      }
      return n;
    }()
    // prettier-ignore
  }, {
    key: "handleTools",
    value: function() {
      var s = Qe(/* @__PURE__ */ ce().mark(function r(i) {
        var o, l, d, c, u, m;
        return ce().wrap(function(v) {
          for (; ; ) switch (v.prev = v.next) {
            case 0:
              if (this.functionHandler) {
                v.next = 2;
                break;
              }
              throw Error("Please define the `function_handler` property inside the [openAI](https://deepchat.dev/docs/directConnection/openAI#Assistant) object.");
            case 2:
              return o = i.map(function(b) {
                return {
                  name: b.function.name,
                  arguments: b.function.arguments
                };
              }), v.next = 5, this.functionHandler(o);
            case 5:
              if (l = v.sent, !(!Array.isArray(l) || i.length !== l.length)) {
                v.next = 8;
                break;
              }
              throw Error(Di.FUNCTION_TOOL_RESP_ERROR);
            case 8:
              return v.next = 10, Promise.all(l);
            case 10:
              if (d = v.sent, !d.find(function(b) {
                return typeof b != "string";
              })) {
                v.next = 13;
                break;
              }
              throw Error(Di.FUNCTION_TOOL_RESP_ERROR);
            case 13:
              if (c = d.map(function(b, w) {
                return {
                  tool_call_id: i[w].id,
                  output: b
                };
              }), u = "".concat(this.urlSegments.threadsPrefix, "/").concat(this.sessionId), m = "/runs/".concat(this.run_id, "/submit_tool_outputs").concat(this.urlSegments.threadsPosfix), this.url = "".concat(u).concat(m), !this._isSSEStream) {
                v.next = 20;
                break;
              }
              return v.next = 18, this.createStreamRun({
                tool_outputs: c
              });
            case 18:
              v.next = 22;
              break;
            case 20:
              return v.next = 22, La.directFetch(this, {
                tool_outputs: c
              }, "POST");
            case 22:
              return v.abrupt("return", {
                timeoutMS: t.POLLING_TIMEOUT_MS
              });
            case 23:
            case "end":
              return v.stop();
          }
        }, r, this);
      }));
      function n(r) {
        return s.apply(this, arguments);
      }
      return n;
    }()
  }, {
    key: "handleStream",
    value: function() {
      var s = Qe(/* @__PURE__ */ ce().mark(function r(i) {
        var o, l, d, c;
        return ce().wrap(function(m) {
          for (; ; ) switch (m.prev = m.next) {
            case 0:
              if (d = (l = (o = i.required_action) == null ? void 0 : o.submit_tool_outputs) == null ? void 0 : l.tool_calls, !(i.status === "requires_action" && d)) {
                m.next = 6;
                break;
              }
              return this.run_id = i.id, m.next = 5, this.handleTools(d);
            case 5:
              return m.abrupt("return", m.sent);
            case 6:
              if (!this._waitingForStreamResponse) {
                m.next = 8;
                break;
              }
              return m.abrupt("return", this.parseStreamResult(i));
            case 8:
              return this._isSSEStream && this.sessionId && (this.url = "".concat(this.urlSegments.threadsPrefix, "/").concat(this.sessionId, "/runs").concat(this.urlSegments.threadsPosfix), c = JSON.parse(JSON.stringify(this.rawBody)), this.createStreamRun(c)), m.abrupt("return", {
                makingAnotherRequest: !0
              });
            case 10:
            case "end":
              return m.stop();
          }
        }, r, this);
      }));
      function n(r) {
        return s.apply(this, arguments);
      }
      return n;
    }()
    // prettier-ignore
  }, {
    key: "parseStreamResult",
    value: function() {
      var s = Qe(/* @__PURE__ */ ce().mark(function r(i) {
        var o, l, d, c, u, m, f, v, b, w;
        return ce().wrap(function(I) {
          for (; ; ) switch (I.prev = I.next) {
            case 0:
              if (!(i.content && i.content.length > 0 && this._messages)) {
                I.next = 5;
                break;
              }
              if (m = i.content.find(function(T) {
                return T.text;
              }), !((o = m == null ? void 0 : m.text) != null && o.annotations && m.text.annotations.length > 0)) {
                I.next = 5;
                break;
              }
              return f = i.content.find(function(T) {
                return !!T.text;
              }) || i.content[0], v = Di.getFilesAndText.bind(this, this, {
                role: "assistant",
                content: i.content
              }, this.urlSegments, f), I.abrupt("return", ((l = this._messageStream) == null || l.endStreamAfterFileDownloaded(this._messages, v), {
                text: ""
              }));
            case 5:
              if (!((d = i.delta) != null && d.content)) {
                I.next = 14;
                break;
              }
              if (!(i.delta.content.length > 1)) {
                I.next = 13;
                break;
              }
              if (b = i.delta.content.find(function(T) {
                return T.text;
              }), !((c = b == null ? void 0 : b.text) != null && c.annotations && b.text.annotations.length === 0)) {
                I.next = 13;
                break;
              }
              return I.next = 11, Di.processStreamMessages(this, i.delta.content, this.urlSegments);
            case 11:
              return w = I.sent, I.abrupt("return", {
                text: w[0].text,
                files: w[1].files
              });
            case 13:
              return I.abrupt("return", {
                text: (u = i.delta.content[0].text) == null ? void 0 : u.value
              });
            case 14:
              return I.abrupt("return", (!this.sessionId && i.thread_id && (this.sessionId = i.thread_id), {
                makingAnotherRequest: !0
              }));
            case 15:
            case "end":
              return I.stop();
          }
        }, r, this);
      }));
      function n(r) {
        return s.apply(this, arguments);
      }
      return n;
    }()
    // https://platform.openai.com/docs/api-reference/assistants-streaming
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  }, {
    key: "createStreamRun",
    value: function() {
      var s = Qe(/* @__PURE__ */ ce().mark(function r(i) {
        return ce().wrap(function(l) {
          for (; ; ) switch (l.prev = l.next) {
            case 0:
              return i.stream = !0, this._waitingForStreamResponse = !0, l.next = 4, Da.request(this, i, this._messages, !0, !0);
            case 4:
              this._messageStream = l.sent;
            case 5:
            case "end":
              return l.stop();
          }
        }, r, this);
      }));
      function n(r) {
        return s.apply(this, arguments);
      }
      return n;
    }()
  }], [{
    key: "processImageMessage",
    value: function(n, r) {
      var i = r == null ? void 0 : r.filter(function(o) {
        return cn.isImageFileExtension(o.name);
      }).map(function(o) {
        return {
          type: "image_file",
          image_file: {
            file_id: o.id
          }
        };
      });
      if (i && i.length > 0) return n.text && n.text.length > 0 && i.push({
        type: "text",
        text: n.text
      }), {
        content: i,
        role: "user"
      };
    }
  }, {
    key: "processAttachmentsMessage",
    value: function(n, r, i) {
      return {
        attachments: r.map(function(o) {
          return {
            tools: [{
              type: i
            }],
            file_id: o.id
          };
        }),
        content: [{
          type: "text",
          text: n.text
        }],
        role: "user"
      };
    }
  }]);
}(tn);
T5.POLLING_TIMEOUT_MS = 500;
var O5 = T5, iHe = /* @__PURE__ */ function(e) {
  function t(s) {
    var n, r, i;
    je(this, t);
    var o, l, d, c, u, m = JSON.parse(JSON.stringify(s.directConnection)), f = m.openAI, v = (o = m.openAI) == null ? void 0 : o.assistant, b = t.buildUrlSegments(v);
    if (i = jt(this, t, [s, v, b, La.buildKeyVerificationDetails(), La.buildHeaders, f]), (n = (l = i.connectSettings).headers) !== null && n !== void 0 || (l.headers = {}), (r = (d = i.connectSettings.headers)["OpenAI-Beta"]) !== null && r !== void 0 || (d["OpenAI-Beta"] = "assistants=v2"), i.shouldFetchHistory && i.sessionId && (i.fetchHistory = i.fetchHistoryFunc.bind(Vd(i))), St(v) == "object") {
      var w = (u = (c = s.directConnection) == null ? void 0 : c.openAI) == null ? void 0 : u.assistant, S = w.function_handler, I = w.files_tool_type;
      S && (i.functionHandler = S), I && (i.filesToolType = I);
    }
    return i;
  }
  return Ht(t, e), He(t, null, [{
    key: "buildUrlSegments",
    value: function(n) {
      var r = St(n) == "object" && n.custom_base_url || "https://api.openai.com/v1";
      return {
        threadsPrefix: "".concat(r, "/threads"),
        threadsPosfix: "",
        newAssistantUrl: "".concat(r, "/assistants"),
        createMessagePostfix: "",
        listMessagesPostfix: "order=desc",
        storeFiles: "".concat(r, "/files"),
        getFilesPrefix: "".concat(r, "/files/"),
        getFilesPostfix: "/content"
      };
    }
  }]);
}(O5), lC = /* @__PURE__ */ function() {
  function e() {
    je(this, e);
  }
  return He(e, null, [{
    key: "buildHeaders",
    value: function(s) {
      return {
        Authorization: "Bearer ".concat(s),
        "Content-Type": "application/json",
        accept: "application/json"
      };
    }
    // prettier-ignore
  }, {
    key: "handleVerificationResult",
    value: function(s, n, r, i) {
      var o;
      (o = s.message) != null && o.includes("invalid request: prompt must be at least 1 token long") ? r(n) : i(Ys.INVALID_KEY);
    }
  }, {
    key: "buildKeyVerificationDetails",
    value: function() {
      return {
        url: "https://api.cohere.ai/v1/generate",
        method: "POST",
        handleVerificationResult: e.handleVerificationResult,
        body: JSON.stringify({
          prompt: ""
        })
      };
    }
  }]);
}(), Fb = /* @__PURE__ */ function(e) {
  function t(s, n, r, i, o) {
    var l;
    return je(this, t), l = jt(this, t, [s, lC.buildKeyVerificationDetails(), lC.buildHeaders, o]), l.insertKeyPlaceholderText = "Cohere API Key", l.keyHelpUrl = "https://dashboard.cohere.ai/api-keys", l.permittedErrorPrefixes = ["invalid"], l.url = n, l.textInputPlaceholderText = r, i && St(i) == "object" && Object.assign(l.rawBody, i), l;
  }
  return Ht(t, e), He(t);
}(tn), lHe = /* @__PURE__ */ function(e) {
  function t(s) {
    je(this, t);
    var n, r, i, o = (r = (n = s.directConnection) == null ? void 0 : n.cohere) == null ? void 0 : r.textGeneration, l = (i = s.directConnection) == null ? void 0 : i.cohere;
    return jt(this, t, [s, "https://api.cohere.ai/v1/generate", "Once upon a time", o, l]);
  }
  return Ht(t, e), He(t, [{
    key: "preprocessBody",
    value: function(n, r) {
      var i = JSON.parse(JSON.stringify(n)), o = r[r.length - 1].text;
      if (o) return ys({
        prompt: o
      }, i);
    }
  }, {
    key: "callServiceAPI",
    value: function() {
      var s = Qe(/* @__PURE__ */ ce().mark(function r(i, o) {
        var l;
        return ce().wrap(function(c) {
          for (; ; ) switch (c.prev = c.next) {
            case 0:
              if (this.connectSettings) {
                c.next = 2;
                break;
              }
              throw new Error("Request settings have not been set up");
            case 2:
              l = this.preprocessBody(this.rawBody, o), ha.request(this, l, i);
            case 4:
            case "end":
              return c.stop();
          }
        }, r, this);
      }));
      function n(r, i) {
        return s.apply(this, arguments);
      }
      return n;
    }()
  }, {
    key: "extractResultData",
    value: function() {
      var s = Qe(/* @__PURE__ */ ce().mark(function r(i) {
        var o;
        return ce().wrap(function(d) {
          for (; ; ) switch (d.prev = d.next) {
            case 0:
              if (!i.message) {
                d.next = 2;
                break;
              }
              throw i.message;
            case 2:
              return d.abrupt("return", {
                text: ((o = i.generations) == null ? void 0 : o[0].text) || ""
              });
            case 3:
            case "end":
              return d.stop();
          }
        }, r);
      }));
      function n(r) {
        return s.apply(this, arguments);
      }
      return n;
    }()
  }]);
}(Fb), R5 = /* @__PURE__ */ function() {
  function e() {
    je(this, e);
  }
  return He(e, null, [{
    key: "buildHeaders",
    value: function(s) {
      return {
        "api-key": s,
        "Content-Type": "application/json"
      };
    }
  }, {
    key: "buildKeyVerificationDetails",
    value: function(s) {
      return {
        url: "".concat(s.endpoint, "/openai/models?api-version=").concat(s.version),
        method: "GET",
        handleVerificationResult: La.handleVerificationResult
      };
    }
  }, {
    key: "validateURLDetails",
    value: function(s) {
      var n = s.endpoint, r = s.version, i = s.deploymentId;
      return n && r && i;
    }
  }]);
}();
R5.URL_DETAILS_ERROR_MESSAGE = "Please define the Azure URL Details. [More Information](https://deepchat.dev/docs/directConnection/Azure)";
var Dr = R5, Ry = /* @__PURE__ */ function(e) {
  function t(s) {
    var n, r;
    je(this, t);
    var i, o, l, d, c, u, m, f, v = JSON.parse(JSON.stringify(s.directConnection)), b = v.azure, w = (i = v.azure) == null ? void 0 : i.openAI, S = (w == null ? void 0 : w.urlDetails) || {}, I = "".concat((o = w == null ? void 0 : w.urlDetails) == null ? void 0 : o.endpoint, "/openai/"), T = "?api-version=".concat((l = w == null ? void 0 : w.urlDetails) == null ? void 0 : l.version), x = {
      threadsPrefix: "".concat(I).concat(t.THREAD_RESOURCE),
      threadsPosfix: T,
      newAssistantUrl: "".concat(I).concat(t.NEW_ASSISTANT_RESOURCE).concat(T),
      createMessagePostfix: T,
      listMessagesPostfix: "order=desc&api-version=".concat((d = w == null ? void 0 : w.urlDetails) == null ? void 0 : d.version),
      storeFiles: "".concat(I, "files").concat(T),
      getFilesPrefix: "".concat(I, "files/"),
      getFilesPostfix: "/content".concat(T)
    };
    if (r = jt(this, t, [s, w == null ? void 0 : w.assistant, x, Dr.buildKeyVerificationDetails(S), Dr.buildHeaders, b]), r.permittedErrorPrefixes = [Dr.URL_DETAILS_ERROR_MESSAGE], r.insertKeyPlaceholderText = "Azure OpenAI API Key", r.keyHelpUrl = "https://learn.microsoft.com/en-us/answers/questions/1193991/how-to-get-the-value-of-openai-api-key", r.isTextInputDisabled = !1, St(w == null ? void 0 : w.assistant) == "object") {
      var k = (m = (u = (c = s.directConnection) == null ? void 0 : c.azure) == null ? void 0 : u.openAI) == null ? void 0 : m.assistant, C = k.function_handler, O = k.files_tool_type;
      C && (r.functionHandler = C), O && (r.filesToolType = O);
    }
    return Dr.validateURLDetails(S) ? (n = (f = r.connectSettings).headers) !== null && n !== void 0 || (f.headers = {}) : (r.isTextInputDisabled = !0, r.canSendMessage = function() {
      return !1;
    }, setTimeout(function() {
      s.addMessage({
        error: Dr.URL_DETAILS_ERROR_MESSAGE
      });
    })), r;
  }
  return Ht(t, e), He(t);
}(O5);
Ry.THREAD_RESOURCE = "threads", Ry.NEW_ASSISTANT_RESOURCE = "assistants";
var dHe = Ry, cHe = /* @__PURE__ */ function(e) {
  function t(s) {
    je(this, t);
    var n, r, i, o = (r = (n = s.directConnection) == null ? void 0 : n.cohere) == null ? void 0 : r.summarization, l = (i = s.directConnection) == null ? void 0 : i.cohere;
    return jt(this, t, [s, "https://api.cohere.ai/v1/summarize", "Insert text to summarize", o, l]);
  }
  return Ht(t, e), He(t, [{
    key: "preprocessBody",
    value: function(n, r) {
      var i = JSON.parse(JSON.stringify(n)), o = r[r.length - 1].text;
      if (o) return ys({
        text: o
      }, i);
    }
  }, {
    key: "callServiceAPI",
    value: function() {
      var s = Qe(/* @__PURE__ */ ce().mark(function r(i, o) {
        var l;
        return ce().wrap(function(c) {
          for (; ; ) switch (c.prev = c.next) {
            case 0:
              if (this.connectSettings) {
                c.next = 2;
                break;
              }
              throw new Error("Request settings have not been set up");
            case 2:
              l = this.preprocessBody(this.rawBody, o), ha.request(this, l, i);
            case 4:
            case "end":
              return c.stop();
          }
        }, r, this);
      }));
      function n(r, i) {
        return s.apply(this, arguments);
      }
      return n;
    }()
  }, {
    key: "extractResultData",
    value: function() {
      var s = Qe(/* @__PURE__ */ ce().mark(function r(i) {
        return ce().wrap(function(l) {
          for (; ; ) switch (l.prev = l.next) {
            case 0:
              if (!i.message) {
                l.next = 2;
                break;
              }
              throw i.message;
            case 2:
              return l.abrupt("return", {
                text: i.summary || ""
              });
            case 3:
            case "end":
              return l.stop();
          }
        }, r);
      }));
      function n(r) {
        return s.apply(this, arguments);
      }
      return n;
    }()
  }]);
}(Fb), Ha = /* @__PURE__ */ function() {
  function e() {
    je(this, e);
  }
  return He(e, null, [{
    key: "addAttributes",
    value: function(s) {
      s.role = "button", s.setAttribute("tabindex", "0");
    }
  }, {
    key: "addAriaBusy",
    value: function(s) {
      s.setAttribute("aria-busy", "true");
    }
  }, {
    key: "removeAriaBusy",
    value: function(s) {
      s.removeAttribute("aria-busy");
    }
  }, {
    key: "addAriaDisabled",
    value: function(s) {
      s.setAttribute("aria-disabled", "true");
    }
  }, {
    key: "removeAriaDisabled",
    value: function(s) {
      s.removeAttribute("aria-disabled");
    }
  }, {
    key: "removeAriaAttributes",
    value: function(s) {
      e.removeAriaBusy(s), e.removeAriaDisabled(s);
    }
  }]);
}(), L5 = `<?xml version="1.0" encoding="iso-8859-1"?>
<svg height="1.4em" width="1.4em" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
	 viewBox="0 0 490.9 490.9" xml:space="preserve">
	<g>
		<g>
			<path d="M245.5,322.9c53,0,96.2-43.2,96.2-96.2V96.2c0-53-43.2-96.2-96.2-96.2s-96.2,43.2-96.2,96.2v130.5
				C149.3,279.8,192.5,322.9,245.5,322.9z M173.8,96.2c0-39.5,32.2-71.7,71.7-71.7s71.7,32.2,71.7,71.7v130.5
				c0,39.5-32.2,71.7-71.7,71.7s-71.7-32.2-71.7-71.7V96.2z"/>
			<path d="M94.4,214.5c-6.8,0-12.3,5.5-12.3,12.3c0,85.9,66.7,156.6,151.1,162.8v76.7h-63.9c-6.8,0-12.3,5.5-12.3,12.3
				s5.5,12.3,12.3,12.3h152.3c6.8,0,12.3-5.5,12.3-12.3s-5.5-12.3-12.3-12.3h-63.9v-76.7c84.4-6.3,151.1-76.9,151.1-162.8
				c0-6.8-5.5-12.3-12.3-12.3s-12.3,5.5-12.3,12.3c0,76.6-62.3,138.9-138.9,138.9s-138.9-62.3-138.9-138.9
				C106.6,220,101.2,214.5,94.4,214.5z"/>
		</g>
	</g>
</svg>
`, Lh = /* @__PURE__ */ function() {
  function e() {
    je(this, e);
  }
  return He(e, null, [{
    key: "createTextElement",
    value: function(s) {
      var n = document.createElement("div");
      return n.classList.add(e.INPUT_BUTTON_INNER_TEXT_CLASS), n.innerText = s, n;
    }
  }, {
    key: "tryAddSVGElement",
    value: function(s, n, r, i) {
      r ? s.push(Ro.createSVGElement(r)) : r !== "" && i && s.push(n);
    }
  }, {
    key: "createCustomElements",
    value: function(s, n, r) {
      var i, o, l = r == null ? void 0 : r[s], d = (i = l == null ? void 0 : l.text) == null ? void 0 : i.content, c = (o = l == null ? void 0 : l.svg) == null ? void 0 : o.content, u = [];
      return e.tryAddSVGElement(u, n, c, d), d && u.push(e.createTextElement(d)), u.length > 0 ? u : void 0;
    }
  }, {
    key: "reassignClassBasedOnChildren",
    value: function(s, n) {
      s.classList.remove(e.INPUT_BUTTON_SVG_CLASS, e.INPUT_BUTTON_SVG_TEXT_CLASS), n.find(function(r) {
        return r.classList.contains(e.INPUT_BUTTON_INNER_TEXT_CLASS);
      }) ? n.length > 1 && s.classList.add(e.INPUT_BUTTON_SVG_TEXT_CLASS) : s.classList.add(e.INPUT_BUTTON_SVG_CLASS);
    }
  }]);
}();
Lh.INPUT_BUTTON_SVG_TEXT_CLASS = "input-button-svg-text", Lh.INPUT_BUTTON_INNER_TEXT_CLASS = "text-button", Lh.INPUT_BUTTON_SVG_CLASS = "input-button-svg";
var gi = Lh, ru = /* @__PURE__ */ function() {
  function e() {
    je(this, e);
  }
  return He(e, null, [{
    key: "parseSVGTextElements",
    value: function(s) {
      return {
        svg: s.find(function(n) {
          return n.tagName.toLowerCase() === "svg";
        }),
        text: s.find(function(n) {
          return n.tagName.toLowerCase() === "div";
        })
      };
    }
  }]);
}(), un = /* @__PURE__ */ function() {
  function e() {
    je(this, e);
  }
  return He(e, null, [{
    key: "unsetAllCSS",
    value: function(s, n) {
      var r, i;
      n.container && za.unsetAllCSSMouseStates(s, n.container);
      var o = ru.parseSVGTextElements(Array.from(s.children)), l = o.svg, d = o.text;
      (r = n.svg) != null && r.styles && l && za.unsetAllCSSMouseStates(l, n.svg.styles), (i = n.text) != null && i.styles && d && za.unsetAllCSSMouseStates(d, n.text.styles);
    }
  }, {
    key: "unsetActionCSS",
    value: function(s, n) {
      var r, i;
      n.container && za.unsetActivityCSSMouseStates(s, n.container);
      var o = ru.parseSVGTextElements(Array.from(s.children)), l = o.svg, d = o.text;
      (r = n.svg) != null && r.styles && l && za.unsetActivityCSSMouseStates(l, n.svg.styles), (i = n.text) != null && i.styles && d && za.unsetActivityCSSMouseStates(d, n.text.styles);
    }
  }, {
    key: "setElementsCSS",
    value: function(s, n, r) {
      var i, o, l, d, c;
      Object.assign(s.style, (i = n.container) == null ? void 0 : i[r]);
      var u = ru.parseSVGTextElements(Array.from(s.children)), m = u.svg, f = u.text;
      m && Object.assign(m.style, (l = (o = n.svg) == null ? void 0 : o.styles) == null ? void 0 : l[r]), f && Object.assign(f.style, (c = (d = n.text) == null ? void 0 : d.styles) == null ? void 0 : c[r]);
    }
  }, {
    key: "setElementCssUpToState",
    value: function(s, n, r) {
      e.setElementsCSS(s, n, "default"), r !== "default" && (e.setElementsCSS(s, n, "hover"), r !== "hover" && e.setElementsCSS(s, n, "click"));
    }
  }]);
}(), El = /* @__PURE__ */ function() {
  function e(t, s, n, r, i, o) {
    je(this, e), this._mouseState = {
      state: "default"
    }, this.isCustom = !1, Ha.addAttributes(t), this.elementRef = t, this.svg = Ro.createSVGElement(s), this.customStyles = i, this.position = n, this._tooltipSettings = r, this.dropupText = o;
  }
  return He(e, [{
    key: "buttonMouseLeave",
    value: function(s) {
      var n;
      this._mouseState.state = "default", ((n = this._activeTooltip) == null ? void 0 : n.element.style.visibility) === "visible" && this._tooltipSettings && Ho.hide(this._activeTooltip, this._tooltipSettings), s && (un.unsetAllCSS(this.elementRef, s), un.setElementsCSS(this.elementRef, s, "default"));
    }
  }, {
    key: "buttonMouseEnter",
    value: function(s) {
      var n;
      this._mouseState.state = "hover", this._tooltipSettings && (this._activeTooltip = Ho.display(this.elementRef, this._tooltipSettings, (n = this._activeTooltip) == null ? void 0 : n.element)), s && un.setElementsCSS(this.elementRef, s, "hover");
    }
  }, {
    key: "buttonMouseUp",
    value: function(s) {
      s && un.unsetActionCSS(this.elementRef, s), this.buttonMouseEnter(s);
    }
  }, {
    key: "buttonMouseDown",
    value: function(s) {
      this._mouseState.state = "click", s && un.setElementsCSS(this.elementRef, s, "click");
    }
    // be careful not to use onclick as that is used for button functionality
  }, {
    key: "setEvents",
    value: function(s) {
      this.elementRef.onmousedown = this.buttonMouseDown.bind(this, s), this.elementRef.onmouseup = this.buttonMouseUp.bind(this, s), this.elementRef.onmouseenter = this.buttonMouseEnter.bind(this, s), this.elementRef.onmouseleave = this.buttonMouseLeave.bind(this, s);
    }
  }, {
    key: "unsetCustomStateStyles",
    value: function(s) {
      if (this.customStyles) for (var n = 0; n < s.length; n += 1) {
        var r = s[n], i = r && this.customStyles[r];
        i && un.unsetActionCSS(this.elementRef, i);
      }
    }
  }, {
    key: "reapplyStateStyle",
    value: function(s, n) {
      if (this.customStyles) {
        n && this.unsetCustomStateStyles(n);
        var r = this.customStyles[s];
        r && un.setElementCssUpToState(this.elementRef, r, this._mouseState.state), this.setEvents(r);
      }
    }
  }, {
    key: "changeElementsByState",
    value: function(s) {
      var n;
      (n = this.elementRef).replaceChildren.apply(n, Qu(s)), gi.reassignClassBasedOnChildren(this.elementRef, s);
    }
  }, {
    key: "buildDefaultIconElement",
    value: function(s) {
      var n = this.svg.cloneNode(!0);
      return n.id = s, [n];
    }
  }, {
    key: "createInnerElements",
    value: function(s, n, r) {
      var i = gi.createCustomElements(n, this.svg, r);
      if (i && i.length > 0) {
        if (this.position === "dropup-menu") {
          var o = this.svg.cloneNode(!0);
          o.id = i[0] === this.svg ? s : "dropup-menu-item-icon-element-custom", i[0] = o;
        }
        return i;
      }
      return this.buildDefaultIconElement(s);
    }
  }]);
}(), B5 = /* @__PURE__ */ function(e) {
  function t(s) {
    var n;
    je(this, t);
    var r, i, o = ((i = (r = s == null ? void 0 : s.default) == null ? void 0 : r.svg) == null ? void 0 : i.content) || t.EMPTY_SVG;
    return n = jt(this, t, [document.createElement("div"), o, void 0, void 0, s]), n.isActive = !1, n._innerElements = n.createInnerElementsForStates(n.customStyles), n.changeToDefault(), n;
  }
  return Ht(t, e), He(t, [{
    key: "createInnerElementsForStates",
    value: function(n) {
      return {
        default: this.createInnerButtonElements("default", n),
        active: this.createInnerButtonElements("active", n),
        unavailable: this.createInnerButtonElements("unavailable", n)
      };
    }
  }, {
    key: "createInnerButtonElements",
    value: function(n, r) {
      return gi.createCustomElements(n, this.svg, r) || [this.svg];
    }
  }, {
    key: "changeState",
    value: function(n) {
      this.changeElementsByState(n), this.elementRef.classList.replace(gi.INPUT_BUTTON_SVG_CLASS, "deep-chat-openai-realtime-button");
    }
  }, {
    key: "changeToActive",
    value: function() {
      this.changeState(this._innerElements.active), this.reapplyStateStyle("active", ["unavailable", "default"]), this.isActive = !0;
    }
  }, {
    key: "changeToDefault",
    value: function() {
      var n, r, i, o;
      this.changeState(this._innerElements.default), (n = this.customStyles) != null && n.active && un.unsetAllCSS(this.elementRef, (r = this.customStyles) == null ? void 0 : r.active), (i = this.customStyles) != null && i.unavailable && un.unsetAllCSS(this.elementRef, (o = this.customStyles) == null ? void 0 : o.unavailable), this.reapplyStateStyle("default", ["active", "unavailable"]), this.isActive = !1;
    }
  }, {
    key: "changeToUnavailable",
    value: function() {
      var n, r, i, o;
      this.changeState(this._innerElements.unavailable), (n = this.customStyles) != null && n.active && un.unsetAllCSS(this.elementRef, (r = this.customStyles) == null ? void 0 : r.active), (i = this.customStyles) != null && i.default && un.unsetAllCSS(this.elementRef, (o = this.customStyles) == null ? void 0 : o.default), this.reapplyStateStyle("unavailable", ["default", "active"]), this.isActive = !1;
    }
  }]);
}(El);
B5.EMPTY_SVG = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"></svg>';
var dC = B5, go = /* @__PURE__ */ function() {
  function e() {
    je(this, e);
  }
  return He(e, null, [{
    key: "setPropertyValueIfDoesNotExist",
    value: function(s, n, r) {
      var i, o, l = n[0];
      n.length === 1 ? (i = s[l]) !== null && i !== void 0 || (s[l] = r) : ((o = s[l]) !== null && o !== void 0 || (s[l] = {}), n.shift(), e.setPropertyValueIfDoesNotExist(s[l], n, r));
    }
  }, {
    key: "setPropertyValue",
    value: function(s, n, r) {
      var i, o = n[0];
      n.length === 1 ? s[o] = r : ((i = s[o]) !== null && i !== void 0 || (s[o] = {}), n.shift(), e.setPropertyValue(s[o], n, r));
    }
  }, {
    key: "getObjectValue",
    value: function(s, n) {
      var r = n[0], i = s[r];
      return i === void 0 || n.length === 1 ? i : e.getObjectValue(i, n.slice(1));
    }
  }, {
    key: "overwritePropertyObjectFromAnother",
    value: function(s, n, r) {
      var i = e.getObjectValue(n, r);
      if (i) {
        var o = ys(ys({}, i), e.getObjectValue(s, r) || {});
        e.setPropertyValue(s, r, o);
      }
    }
  }, {
    key: "isJson",
    value: function(s) {
      try {
        return JSON.stringify(s), !0;
      } catch {
        return !1;
      }
    }
    // prettier-ignore
  }, {
    key: "assignPropertyFromOneToAnother",
    value: function(s, n, r) {
      var i;
      (i = n[s]) !== null && i !== void 0 || (n[s] = {}), Object.assign(n[s], r == null ? void 0 : r[s]);
    }
  }]);
}(), Ly = /* @__PURE__ */ He(function e() {
  je(this, e);
});
Ly.SESSION_STARTED = "sts-session-started", Ly.SESSION_STOPPED = "sts-session-stopped";
var cC = Ly, M5 = `<?xml version="1.0" encoding="utf-8"?>
<svg viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg">
  <path d="M5.92 24.096q0 1.088 0.928 1.728 0.512 0.288 1.088 0.288 0.448 0 0.896-0.224l16.16-8.064q0.48-0.256 0.8-0.736t0.288-1.088-0.288-1.056-0.8-0.736l-16.16-8.064q-0.448-0.224-0.896-0.224-0.544 0-1.088 0.288-0.928 0.608-0.928 1.728v16.16z"></path>
</svg>`, By = `<?xml version="1.0" encoding="utf-8"?>
<svg viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg">
<path d="M5.92 24.096q0 0.832 0.576 1.408t1.44 0.608h16.128q0.832 0 1.44-0.608t0.576-1.408v-16.16q0-0.832-0.576-1.44t-1.44-0.576h-16.128q-0.832 0-1.44 0.576t-0.576 1.44v16.16z"></path>
</svg>`, Hc = /* @__PURE__ */ function(e) {
  function t(s) {
    var n, r;
    je(this, t);
    var i, o, l, d, c = JSON.parse(JSON.stringify(s.directConnection)), u = t.getKey(s);
    r = jt(this, t, [s, La.buildKeyVerificationDetails(), La.buildHeaders, {
      key: u
    }]), r.insertKeyPlaceholderText = "OpenAI API Key", r.keyHelpUrl = "https://platform.openai.com/account/api-keys", r._microphoneButton = null, r._toggleButton = null, r._errorElement = null, r._loadingElement = null, r._pc = null, r._mediaStream = null, r._isMuted = !1;
    var m = (i = c.openAI) == null ? void 0 : i.realtime;
    if (St(m) == "object") {
      r._avatarConfig = m.avatar, r._ephemeralKey = m.ephemeralKey, r._errorConfig = m.error, r._loadingConfig = m.loading, Object.assign(r.rawBody, m.config);
      var f = (l = (o = s.directConnection) == null ? void 0 : o.openAI) == null ? void 0 : l.realtime, v = f.config || {}, b = v.function_handler;
      b && (r._functionHandler = b), r._events = m.events, f.methods = r.generateMethods();
    }
    return (n = (d = r.rawBody).model) !== null && n !== void 0 || (d.model = "gpt-4o-realtime-preview-2024-12-17"), r._avatarConfig = t.buildAvatarConfig(m), r._buttonsConfig = t.buildButtonsConfig(m), r._avatarEl = t.createAvatar(r._avatarConfig), r._containerEl = r.createContainer(), r._deepChat = s, r;
  }
  return Ht(t, e), He(t, [{
    key: "setUpView",
    value: (
      // called after API key was inserted
      function(n, r) {
        n.style.display = "none", r.appendChild(this._containerEl), this.setup();
      }
    )
  }, {
    key: "setup",
    value: function() {
      var s = Qe(/* @__PURE__ */ ce().mark(function r() {
        var i, o, l, d;
        return ce().wrap(function(u) {
          for (; ; ) switch (u.prev = u.next) {
            case 0:
              if (o = (i = this._deepChat.directConnection) == null ? void 0 : i.openAI, o) {
                u.next = 3;
                break;
              }
              return u.abrupt("return");
            case 3:
              if (l = o == null ? void 0 : o.realtime, !(St(l) != "object" || !l.autoStart && !l.autoFetchEphemeralKey)) {
                u.next = 6;
                break;
              }
              return u.abrupt("return");
            case 6:
              d = this.key || o.key, (l.fetchEphemeralKey || d) && l.autoStart && (this.changeToUnavailable(), this.displayLoading()), this.fetchEphemeralKey(l.autoStart);
            case 8:
            case "end":
              return u.stop();
          }
        }, r, this);
      }));
      function n() {
        return s.apply(this, arguments);
      }
      return n;
    }()
  }, {
    key: "fetchEphemeralKey",
    value: function() {
      var s = Qe(/* @__PURE__ */ ce().mark(function r(i) {
        var o, l, d, c, u, m;
        return ce().wrap(function(v) {
          for (; ; ) switch (v.prev = v.next) {
            case 0:
              if (l = (o = this._deepChat.directConnection) == null ? void 0 : o.openAI, d = St(l == null ? void 0 : l.realtime) == "object" ? l == null ? void 0 : l.realtime.fetchEphemeralKey : void 0, c = l == null ? void 0 : l.realtime, u = this.key || l.key, St(c) != "object") {
                v.next = 26;
                break;
              }
              if (this._ephemeralKey) {
                v.next = 23;
                break;
              }
              if (v.prev = 3, !d) {
                v.next = 12;
                break;
              }
              return m = d(), m.then && (this._retrievingEphemeralKey = m), v.next = 9, m;
            case 9:
              this._ephemeralKey = v.sent, v.next = 18;
              break;
            case 12:
              if (v.t0 = u, !v.t0) {
                v.next = 18;
                break;
              }
              return this._retrievingEphemeralKey = this.getEphemeralKey(u), v.next = 17, this._retrievingEphemeralKey;
            case 17:
              this._ephemeralKey = v.sent;
            case 18:
              v.next = 23;
              break;
            case 20:
              v.prev = 20, v.t1 = v.catch(3), this.displayFailedToRetrieveEphemeralKey(v.t1);
            case 23:
              this._ephemeralKey && (i ? this.init(this._ephemeralKey) : this.changeToAvailable()), v.next = 38;
              break;
            case 26:
              if (!u) {
                v.next = 38;
                break;
              }
              return v.prev = 27, this._retrievingEphemeralKey = this.getEphemeralKey(u), v.next = 31, this._retrievingEphemeralKey;
            case 31:
              this._ephemeralKey = v.sent, i && this.init(this._ephemeralKey), v.next = 38;
              break;
            case 35:
              v.prev = 35, v.t2 = v.catch(27), this.displayFailedToRetrieveEphemeralKey(v.t2);
            case 38:
            case "end":
              return v.stop();
          }
        }, r, this, [[3, 20], [27, 35]]);
      }));
      function n(r) {
        return s.apply(this, arguments);
      }
      return n;
    }()
  }, {
    key: "getEphemeralKey",
    value: function() {
      var s = Qe(/* @__PURE__ */ ce().mark(function r(i) {
        return ce().wrap(function(l) {
          for (; ; ) switch (l.prev = l.next) {
            case 0:
              return l.next = 2, fetch("https://api.openai.com/v1/realtime/sessions", {
                method: "POST",
                body: JSON.stringify(this.rawBody),
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer ".concat(i)
                }
              });
            case 2:
              return l.next = 4, l.sent.json();
            case 4:
              return l.abrupt("return", l.sent.client_secret.value);
            case 5:
            case "end":
              return l.stop();
          }
        }, r, this);
      }));
      function n(r) {
        return s.apply(this, arguments);
      }
      return n;
    }()
  }, {
    key: "generateMethods",
    value: function() {
      var n = this;
      return {
        updateConfig: function(i) {
          var o;
          (o = n._dc) == null || o.send(JSON.stringify({
            type: "session.update",
            session: i
          }));
        },
        sendMessage: function(i, o) {
          var l = o || "system", d = {
            role: l,
            type: "message",
            content: [{
              type: l === "system" || l === "user" ? "input_text" : "text",
              text: i
            }]
          };
          n.sendMessage(d);
        }
      };
    }
  }, {
    key: "createContainer",
    value: function() {
      var n = document.createElement("div");
      return n.id = "deep-chat-openai-realtime-container", n.appendChild(this.createAvatarContainer()), n.appendChild(this.createButtonsContainer()), n.appendChild(this.createError()), n;
    }
  }, {
    key: "createAvatarContainer",
    value: function() {
      var n, r, i = document.createElement("div");
      return i.id = "deep-chat-openai-realtime-avatar-container", Object.assign(i.style, (r = (n = this._avatarConfig) == null ? void 0 : n.styles) == null ? void 0 : r.container), i.appendChild(this._avatarEl), i;
    }
  }, {
    key: "createButtonsContainer",
    value: function() {
      var n, r = document.createElement("div");
      r.id = "deep-chat-openai-realtime-buttons-container", Object.assign(r.style, (n = this._buttonsConfig) == null ? void 0 : n.container), this._microphoneButton = this.createMicophoneButton();
      var i = t.createButtonContainer(this._microphoneButton.elementRef);
      this._toggleButton = this.createToggleButton();
      var o = t.createButtonContainer(this._toggleButton.elementRef);
      return r.appendChild(i), r.appendChild(o), r.appendChild(this.createLoading()), r;
    }
  }, {
    key: "createMicophoneButton",
    value: function() {
      var n = this, r, i = new dC((r = this._buttonsConfig) == null ? void 0 : r.microphone);
      return i.elementRef.classList.add(t.BUTTON_DEFAULT, "deep-chat-openai-realtime-microphone"), i.elementRef.onclick = function() {
        i.isActive ? (n.toggleMicorphone(!0), i.elementRef.classList.replace(t.MICROPHONE_ACTIVE, t.BUTTON_DEFAULT), i.changeToDefault(), n._isMuted = !1) : (n.toggleMicorphone(!1), i.elementRef.classList.replace(t.BUTTON_DEFAULT, t.MICROPHONE_ACTIVE), Ha.removeAriaAttributes(i.elementRef), i.changeToActive(), n._isMuted = !0);
      }, i;
    }
  }, {
    key: "toggleMicorphone",
    value: function(n) {
      var r;
      (r = this._mediaStream) == null || r.getAudioTracks().forEach(function(i) {
        return i.enabled = n;
      });
    }
  }, {
    key: "createToggleButton",
    value: function() {
      var n = this, r, i = new dC((r = this._buttonsConfig) == null ? void 0 : r.toggle);
      return i.elementRef.classList.add(t.BUTTON_DEFAULT, "deep-chat-openai-realtime-toggle"), i.elementRef.onclick = /* @__PURE__ */ Qe(/* @__PURE__ */ ce().mark(function o() {
        var l, d;
        return ce().wrap(function(u) {
          for (; ; ) switch (u.prev = u.next) {
            case 0:
              if (!i.isActive) {
                u.next = 4;
                break;
              }
              i.changeToDefault(), n.stop(), u.next = 30;
              break;
            case 4:
              if (u.prev = 4, !n._ephemeralKey) {
                u.next = 11;
                break;
              }
              return n.displayLoading(), u.next = 9, n.init(n._ephemeralKey);
            case 9:
              u.next = 25;
              break;
            case 11:
              if (!n._retrievingEphemeralKey) {
                u.next = 22;
                break;
              }
              return n.displayLoading(), u.next = 15, n._retrievingEphemeralKey;
            case 15:
              if (d = u.sent, u.t0 = (l = n._toggleButton) != null && l.isActive, !u.t0) {
                u.next = 20;
                break;
              }
              return u.next = 20, n.init(d);
            case 20:
              u.next = 25;
              break;
            case 22:
              return n.displayLoading(), u.next = 25, n.fetchEphemeralKey(!0);
            case 25:
              u.next = 30;
              break;
            case 27:
              u.prev = 27, u.t1 = u.catch(4), console.error("Failed to start conversation:", u.t1), n.displayError(), n.hideLoading();
            case 30:
            case "end":
              return u.stop();
          }
        }, o, null, [[4, 27]]);
      })), i;
    }
  }, {
    key: "init",
    value: function() {
      var s = Qe(/* @__PURE__ */ ce().mark(function r(i) {
        var o = this, l, d, c, u, m, f, v, b;
        return ce().wrap(function(S) {
          for (; ; ) switch (S.prev = S.next) {
            case 0:
              return l = new RTCPeerConnection(), this._pc = l, d = document.createElement("audio"), d.autoplay = !0, c = new AudioContext(), u = c.createAnalyser(), u.fftSize = 256, m = new Uint8Array(u.frequencyBinCount), this._pc.ontrack = /* @__PURE__ */ function() {
                var I = Qe(/* @__PURE__ */ ce().mark(function T(x) {
                  var k;
                  return ce().wrap(function(O) {
                    for (; ; ) switch (O.prev = O.next) {
                      case 0:
                        if (!x.streams[0]) {
                          O.next = 11;
                          break;
                        }
                        if (d.srcObject = x.streams[0], k = c.createMediaStreamSource(x.streams[0]), O.t0 = c.state === "suspended", !O.t0) {
                          O.next = 7;
                          break;
                        }
                        return O.next = 7, c.resume();
                      case 7:
                        k.connect(u), o.monitorFrequencies(u, m), O.next = 12;
                        break;
                      case 11:
                        console.error("No streams found in the ontrack event."), o.displayError();
                      case 12:
                      case "end":
                        return O.stop();
                    }
                  }, T);
                }));
                return function(T) {
                  return I.apply(this, arguments);
                };
              }(), S.next = 10, navigator.mediaDevices.getUserMedia({
                audio: !0
              }).then(function(I) {
                var T;
                l === o._pc && (o._mediaStream = I, (T = o._pc) == null || T.addTrack(o._mediaStream.getTracks()[0]), o._isMuted && o.toggleMicorphone(!1));
              }).catch(function(I) {
                console.error("Error accessing microphone:", I), o.displayError();
              });
            case 10:
              return this._dc = this._pc.createDataChannel("oai-events"), this._dc.addEventListener("message", /* @__PURE__ */ function() {
                var I = Qe(/* @__PURE__ */ ce().mark(function T(x) {
                  var k, C, O, E, B, M, R;
                  return ce().wrap(function(L) {
                    for (; ; ) switch (L.prev = L.next) {
                      case 0:
                        if (E = JSON.parse(x.data), E.type !== "session.created") {
                          L.next = 5;
                          break;
                        }
                        o.removeUnavailable(), o._toggleButton && (Ha.removeAriaAttributes(o._toggleButton.elementRef), o._toggleButton.changeToActive()), (C = (k = o._events) == null ? void 0 : k.started) == null || C.call(k), o._deepChat.dispatchEvent(new CustomEvent(cC.SESSION_STARTED)), o.hideLoading(), L.next = 20;
                        break;
                      case 5:
                        if (E.type !== "response.done") {
                          L.next = 19;
                          break;
                        }
                        if (B = (O = JSON.parse(x.data).response.output) == null ? void 0 : O[0], (B == null ? void 0 : B.type) !== "function_call") {
                          L.next = 17;
                          break;
                        }
                        return M = B.name, R = B.call_id, L.prev = 9, L.next = 12, o.handleTool(M, B.arguments, R);
                      case 12:
                        L.next = 17;
                        break;
                      case 14:
                        L.prev = 14, L.t0 = L.catch(9), o.stopOnError(L.t0);
                      case 17:
                        L.next = 20;
                        break;
                      case 19:
                        E.type === "error" ? o.stopOnError(E.error.message) : E.type === "invalid_request_error" ? o.stopOnError(E.message) : E.type;
                      case 20:
                      case "end":
                        return L.stop();
                    }
                  }, T, null, [[9, 14]]);
                }));
                return function(T) {
                  return I.apply(this, arguments);
                };
              }()), S.prev = 12, S.next = 15, this._pc.createOffer();
            case 15:
              if (f = S.sent, S.t0 = l !== this._pc, S.t0) {
                S.next = 21;
                break;
              }
              return S.next = 20, this._pc.setLocalDescription(f);
            case 20:
              S.t0 = l !== this._pc;
            case 21:
              if (!S.t0) {
                S.next = 23;
                break;
              }
              return S.abrupt("return");
            case 23:
              return S.next = 25, fetch("https://api.openai.com/v1/realtime", {
                method: "POST",
                body: f.sdp,
                headers: {
                  Authorization: "Bearer ".concat(i),
                  "Content-Type": "application/sdp"
                }
              });
            case 25:
              if (v = S.sent, l === this._pc) {
                S.next = 28;
                break;
              }
              return S.abrupt("return");
            case 28:
              return S.next = 30, v.text();
            case 30:
              if (S.t1 = S.sent, b = {
                type: "answer",
                sdp: S.t1
              }, S.t2 = l !== this._pc, S.t2) {
                S.next = 37;
                break;
              }
              return S.next = 36, this._pc.setRemoteDescription(b);
            case 36:
              S.t2 = l !== this._pc;
            case 37:
              if (!S.t2) {
                S.next = 39;
                break;
              }
              return S.abrupt("return");
            case 39:
              S.next = 44;
              break;
            case 41:
              S.prev = 41, S.t3 = S.catch(12), console.error(S.t3), this.displayError();
            case 44:
            case "end":
              return S.stop();
          }
        }, r, this, [[12, 41]]);
      }));
      function n(r) {
        return s.apply(this, arguments);
      }
      return n;
    }()
    // there is a bug where sometimes upon refreshing the browser too many times the frequencyData is all 0s
    // in such instance please wait and refresh at a later time
  }, {
    key: "monitorFrequencies",
    value: function(n, r) {
      var i = this, o = function(l) {
        function d() {
          return l.apply(this, arguments);
        }
        return d.toString = function() {
          return l.toString();
        }, d;
      }(function() {
        var l;
        n.getByteFrequencyData(r);
        var d = r.reduce(function(v, b) {
          return v + b;
        }, 0), c = r.length * 255, u = d / c * 100, m = 1, f = m + u / 100 * (((l = i._avatarConfig) == null ? void 0 : l.maxScale) - m);
        i._avatarEl.style.transform = "scale(".concat(f, ")"), requestAnimationFrame(o);
      });
      o();
    }
  }, {
    key: "stopOnError",
    value: function(n) {
      this.stop(), console.error(n), this.displayError();
    }
  }, {
    key: "stop",
    value: function() {
      var n, r, i;
      (n = this._mediaStream) == null || n.getTracks().forEach(function(o) {
        return o.stop();
      }), this._mediaStream = null, this._pc && (this._pc.close(), this._pc = null, (i = (r = this._events) == null ? void 0 : r.stopped) == null || i.call(r), this._deepChat.dispatchEvent(new CustomEvent(cC.SESSION_STOPPED)), this._dc = void 0);
    }
  }, {
    key: "changeToUnavailable",
    value: function() {
      this._microphoneButton && t.changeButtonToUnavailable(this._microphoneButton), this._toggleButton && t.changeButtonToUnavailable(this._toggleButton);
    }
  }, {
    key: "changeToAvailable",
    value: function() {
      this._microphoneButton && t.changeButtonToAvailable(this._microphoneButton), this._toggleButton && t.changeButtonToAvailable(this._toggleButton);
    }
  }, {
    key: "removeUnavailable",
    value: function() {
      this._microphoneButton && t.removeButtonUnavailable(this._microphoneButton), this._toggleButton && t.removeButtonUnavailable(this._toggleButton);
    }
  }, {
    key: "createError",
    value: function() {
      var n, r = document.createElement("div");
      return r.id = "deep-chat-openai-realtime-error", Object.assign(r.style, (n = this._errorConfig) == null ? void 0 : n.style), this._errorElement = r, r;
    }
  }, {
    key: "displayFailedToRetrieveEphemeralKey",
    value: function(n) {
      console.error("Failed to retrieve ephemeral key"), console.error(n), this.displayError();
    }
  }, {
    key: "displayError",
    value: function() {
      var n;
      this._errorElement && (this._errorElement.style.display = "block", this._errorElement.textContent = ((n = this._errorConfig) == null ? void 0 : n.text) || "Error", this.changeToUnavailable()), this.hideLoading();
    }
  }, {
    key: "createLoading",
    value: function() {
      var n, r, i = document.createElement("div");
      return i.id = "deep-chat-openai-realtime-loading", this._loadingElement = i, (n = this._loadingConfig) != null && n.html && (this._loadingElement.innerHTML = this._loadingConfig.html), Object.assign(i.style, (r = this._loadingConfig) == null ? void 0 : r.style), i.style.display = "none", i;
    }
  }, {
    key: "displayLoading",
    value: function() {
      var n, r, i;
      this._toggleButton && (this._toggleButton.changeToActive(), this._toggleButton.elementRef.classList.add(t.BUTTON_LOADING), Ha.removeAriaDisabled(this._toggleButton.elementRef), Ha.addAriaBusy(this._toggleButton.elementRef)), (typeof ((n = this._loadingConfig) == null ? void 0 : n.display) != "boolean" || this._loadingConfig.display) && this._loadingElement && (this._loadingElement.style.display = "block", (r = this._loadingConfig) != null && r.html || (this._loadingElement.textContent = ((i = this._loadingConfig) == null ? void 0 : i.text) || "Loading"));
    }
  }, {
    key: "hideLoading",
    value: function() {
      this._toggleButton && (this._toggleButton.elementRef.classList.remove(t.BUTTON_LOADING), Ha.removeAriaBusy(this._toggleButton.elementRef)), this._loadingElement && (this._loadingElement.style.display = "none");
    }
    // https://platform.openai.com/docs/guides/function-calling?api-mode=responses
  }, {
    key: "handleTool",
    value: function() {
      var s = Qe(/* @__PURE__ */ ce().mark(function r(i, o, l) {
        var d, c;
        return ce().wrap(function(m) {
          for (; ; ) switch (m.prev = m.next) {
            case 0:
              if (this._functionHandler) {
                m.next = 2;
                break;
              }
              throw Error("Please define the `function_handler` property inside the [openAI](https://deepchat.dev/docs/directConnection/OpenAI/OpenAIRealtime#OpenAIRealtimeFunction) object.");
            case 2:
              return m.next = 4, this._functionHandler({
                name: i,
                arguments: o
              });
            case 4:
              if (d = m.sent, !(St(d) != "object" || !go.isJson(d))) {
                m.next = 7;
                break;
              }
              throw Error('The `function_handler` response must be a JSON object, e.g. {response: "My response"}');
            case 7:
              c = {
                type: "function_call_output",
                call_id: l,
                output: JSON.stringify(d)
              }, this.sendMessage(c);
            case 9:
            case "end":
              return m.stop();
          }
        }, r, this);
      }));
      function n(r, i, o) {
        return s.apply(this, arguments);
      }
      return n;
    }()
    // https://platform.openai.com/docs/api-reference/realtime-client-events/conversation/item/create
  }, {
    key: "sendMessage",
    value: function(n) {
      if (this._dc) {
        var r = JSON.stringify({
          type: "conversation.item.create",
          item: n
        });
        this._dc.send(r);
        var i = {
          type: "response.create"
        };
        this._dc.send(JSON.stringify(i));
      }
    }
  }, {
    key: "isCustomView",
    value: function() {
      return !0;
    }
  }], [{
    key: "getKey",
    value: function(n) {
      var r = n.directConnection.openAI;
      if (r != null && r.key) return r.key;
      var i = r == null ? void 0 : r.realtime;
      if (St(i) == "object" && (i.ephemeralKey || i.fetchEphemeralKey)) return "placeholder";
    }
  }, {
    key: "buildAvatarConfig",
    value: function(n) {
      var r = St(n) == "object" && n.avatar ? JSON.parse(JSON.stringify(n.avatar)) : {};
      return r.maxScale = r.maxScale && r.maxScale >= 1 ? r.maxScale : 2.5, r;
    }
  }, {
    key: "buildButtonsConfig",
    value: function(n) {
      var r, i, o, l, d, c, u, m, f, v, b, w, S, I, T, x, k, C, O, E, B, M, R, F, L, j, H = St(n) == "object" && n.buttons ? JSON.parse(JSON.stringify(n.buttons)) : {};
      return (I = (S = (w = H.microphone) == null ? void 0 : w.default) == null ? void 0 : S.text) != null && I.content || ((r = H.microphone) !== null && r !== void 0 || (H.microphone = {}), (i = (T = H.microphone).default) !== null && i !== void 0 || (T.default = {}), (o = (x = H.microphone.default).svg) !== null && o !== void 0 || (x.svg = {}), (l = (k = H.microphone.default.svg).content) !== null && l !== void 0 || (k.content = L5)), (E = (O = (C = H.toggle) == null ? void 0 : C.default) == null ? void 0 : O.text) != null && E.content || ((d = H.toggle) !== null && d !== void 0 || (H.toggle = {}), (c = (B = H.toggle).default) !== null && c !== void 0 || (B.default = {}), (u = (M = H.toggle.default).svg) !== null && u !== void 0 || (M.svg = {}), (m = (R = H.toggle.default.svg).content) !== null && m !== void 0 || (R.content = M5), (f = (F = H.toggle).active) !== null && f !== void 0 || (F.active = {}), (v = (L = H.toggle.active).svg) !== null && v !== void 0 || (L.svg = {}), (b = (j = H.toggle.active.svg).content) !== null && b !== void 0 || (j.content = By)), H;
    }
  }, {
    key: "createAvatar",
    value: function(n) {
      var r, i = document.createElement("img");
      return i.id = "deep-chat-openai-realtime-avatar", Object.assign(i.style, (r = n == null ? void 0 : n.styles) == null ? void 0 : r.image), i.src = (n == null ? void 0 : n.src) || Py, i;
    }
  }, {
    key: "createButtonContainer",
    value: function(n) {
      var r = document.createElement("div");
      return r.classList.add("deep-chat-openai-realtime-button-container"), r.appendChild(n), r;
    }
  }, {
    key: "changeButtonToUnavailable",
    value: function(n) {
      n.elementRef.classList.add(t.UNAVAILABLE), Ha.removeAriaBusy(n.elementRef), Ha.addAriaDisabled(n.elementRef), n.changeToUnavailable();
    }
  }, {
    key: "changeButtonToAvailable",
    value: function(n) {
      t.removeButtonUnavailable(n), n.changeToDefault();
    }
  }, {
    key: "removeButtonUnavailable",
    value: function(n) {
      Ha.removeAriaDisabled(n.elementRef), n.elementRef.classList.remove(t.UNAVAILABLE);
    }
  }]);
}(tn);
Hc.BUTTON_DEFAULT = "deep-chat-openai-realtime-button-default", Hc.BUTTON_LOADING = "deep-chat-openai-realtime-button-loading", Hc.MICROPHONE_ACTIVE = "deep-chat-openai-realtime-microphone-active", Hc.UNAVAILABLE = "deep-chat-openai-realtime-button-unavailable";
var uHe = Hc, My = /* @__PURE__ */ function(e) {
  function t(s) {
    var n, r, i;
    je(this, t);
    var o, l, d, c = JSON.parse(JSON.stringify(s.directConnection)), u = c == null ? void 0 : c.openAI;
    i = jt(this, t, [s, La.buildKeyVerificationDetails(), La.buildHeaders, u]), i.insertKeyPlaceholderText = "OpenAI API Key", i.keyHelpUrl = "https://platform.openai.com/account/api-keys", i.url = "https://api.openai.com/v1/audio/speech", i.permittedErrorPrefixes = ["Invalid"], i.introPanelMarkUp = `
    <div style="width: 100%; text-align: center; margin-left: -10px"><b>OpenAI : Text To Speech</b></div>
    <p>Generate an audio file based on your text input.</p>
    <p>Click <a href="https://platform.openai.com/docs/guides/text-to-speech">here</a> for more information.</p>`;
    var m = (o = c == null ? void 0 : c.openAI) == null ? void 0 : o.textToSpeech;
    return St(m) == "object" && Object.assign(i.rawBody, m), (n = (l = i.rawBody).model) !== null && n !== void 0 || (l.model = t.DEFAULT_MODEL), (r = (d = i.rawBody).voice) !== null && r !== void 0 || (d.voice = t.DEFAULT_VOIDE), i.textInputPlaceholderText = "Insert text to generate audio", i.rawBody.response_format = "mp3", i;
  }
  return Ht(t, e), He(t, [{
    key: "preprocessBody",
    value: function(n, r) {
      var i, o, l = JSON.parse(JSON.stringify(n)), d = (o = (i = r[r.length - 1]) == null ? void 0 : i.text) == null ? void 0 : o.trim();
      return d && d !== "" && (l.input = d), l;
    }
  }, {
    key: "callServiceAPI",
    value: function() {
      var s = Qe(/* @__PURE__ */ ce().mark(function r(i, o) {
        var l, d;
        return ce().wrap(function(u) {
          for (; ; ) switch (u.prev = u.next) {
            case 0:
              if ((l = this.connectSettings) != null && l.headers) {
                u.next = 2;
                break;
              }
              throw new Error("Request settings have not been set up");
            case 2:
              this.url = this.connectSettings.url || this.url, d = this.preprocessBody(this.rawBody, o), ha.request(this, d, i);
            case 5:
            case "end":
              return u.stop();
          }
        }, r, this);
      }));
      function n(r, i) {
        return s.apply(this, arguments);
      }
      return n;
    }()
  }, {
    key: "extractResultData",
    value: function() {
      var s = Qe(/* @__PURE__ */ ce().mark(function r(i) {
        return ce().wrap(function(l) {
          for (; ; ) switch (l.prev = l.next) {
            case 0:
              if (!(i instanceof Blob)) {
                l.next = 2;
                break;
              }
              return l.abrupt("return", new Promise(function(d) {
                var c = new FileReader();
                c.readAsDataURL(i), c.onload = function(u) {
                  d({
                    files: [{
                      src: u.target.result,
                      type: "audio"
                    }]
                  });
                };
              }));
            case 2:
              if (!i.error) {
                l.next = 4;
                break;
              }
              throw i.error.message;
            case 4:
              return l.abrupt("return", {
                error: "error"
              });
            case 5:
            case "end":
              return l.stop();
          }
        }, r);
      }));
      function n(r) {
        return s.apply(this, arguments);
      }
      return n;
    }()
  }]);
}(tn);
My.DEFAULT_MODEL = "tts-1", My.DEFAULT_VOIDE = "alloy";
var pHe = My, Bh = /* @__PURE__ */ function(e) {
  function t(s) {
    var n, r;
    je(this, t);
    var i, o, l = JSON.parse(JSON.stringify(s.directConnection)), d = l == null ? void 0 : l.openAI;
    r = jt(this, t, [s, La.buildKeyVerificationDetails(), La.buildHeaders, d, {
      audio: {}
    }]), r.insertKeyPlaceholderText = "OpenAI API Key", r.keyHelpUrl = "https://platform.openai.com/account/api-keys", r.introPanelMarkUp = `
    <div style="width: 100%; text-align: center; margin-left: -10px"><b>OpenAI : Speech To Text</b></div>
    <p><b>Upload an audio file</b> to transcribe it into text. You can optionally provide text to guide the audio
      processing.
    <p>Click <a href="https://platform.openai.com/docs/guides/speech-to-text">here</a> for more info.</p>`, r.url = "", r.permittedErrorPrefixes = ["Invalid"], r.textInputPlaceholderText = "Upload an audio file", r._service_url = t.AUDIO_TRANSCRIPTIONS_URL;
    var c = (i = l == null ? void 0 : l.openAI) == null ? void 0 : i.audio;
    return St(c) == "object" && (r.processConfig(c), t.cleanConfig(c), Object.assign(r.rawBody, c)), (n = (o = r.rawBody).model) !== null && n !== void 0 || (o.model = t.DEFAULT_MODEL), r.rawBody.response_format = "json", r.canSendMessage = t.canSendFileMessage, r;
  }
  return Ht(t, e), He(t, [{
    key: "processConfig",
    value: function(n) {
      n != null && n.type && n.type === "translation" && (this._service_url = t.AUDIO_TRANSLATIONS_URL, delete n.language);
    }
  }, {
    key: "preprocessBody",
    value: function(n, r) {
      var i, o, l = JSON.parse(JSON.stringify(n)), d = (o = (i = r[r.length - 1]) == null ? void 0 : i.text) == null ? void 0 : o.trim();
      return d && d !== "" && (l.prompt = d), l;
    }
    // prettier-ignore
  }, {
    key: "callServiceAPI",
    value: function() {
      var s = Qe(/* @__PURE__ */ ce().mark(function r(i, o, l) {
        var d, c, u;
        return ce().wrap(function(f) {
          for (; ; ) switch (f.prev = f.next) {
            case 0:
              if ((d = this.connectSettings) != null && d.headers) {
                f.next = 2;
                break;
              }
              throw new Error("Request settings have not been set up");
            case 2:
              if (l != null && l[0]) {
                f.next = 4;
                break;
              }
              throw new Error("No file was added");
            case 4:
              this.url = this.connectSettings.url || this._service_url, c = this.preprocessBody(this.rawBody, o), u = t.createFormDataBody(c, l[0]), Kt.tempRemoveContentHeader(this.connectSettings, ha.request.bind(this, this, u, i), !1);
            case 7:
            case "end":
              return f.stop();
          }
        }, r, this);
      }));
      function n(r, i, o) {
        return s.apply(this, arguments);
      }
      return n;
    }()
  }, {
    key: "extractResultData",
    value: function() {
      var s = Qe(/* @__PURE__ */ ce().mark(function r(i) {
        return ce().wrap(function(l) {
          for (; ; ) switch (l.prev = l.next) {
            case 0:
              if (!i.error) {
                l.next = 2;
                break;
              }
              throw i.error.message;
            case 2:
              return l.abrupt("return", {
                text: i.text
              });
            case 3:
            case "end":
              return l.stop();
          }
        }, r);
      }));
      function n(r) {
        return s.apply(this, arguments);
      }
      return n;
    }()
  }], [{
    key: "canSendFileMessage",
    value: function(n, r) {
      return !!(r != null && r[0]);
    }
  }, {
    key: "cleanConfig",
    value: function(n) {
      delete n.type;
    }
  }, {
    key: "createFormDataBody",
    value: function(n, r) {
      var i = new FormData();
      return i.append("file", r), Object.keys(n).forEach(function(o) {
        i.append(o, String(n[o]));
      }), i;
    }
  }]);
}(tn);
Bh.AUDIO_TRANSCRIPTIONS_URL = "https://api.openai.com/v1/audio/transcriptions", Bh.AUDIO_TRANSLATIONS_URL = "https://api.openai.com/v1/audio/translations", Bh.DEFAULT_MODEL = "whisper-1";
var hHe = Bh, ul = /* @__PURE__ */ function() {
  function e() {
    je(this, e);
  }
  return He(e, null, [{
    key: "buildTextToSpeechHeaders",
    value: function(s, n) {
      return {
        "Ocp-Apim-Subscription-Key": n,
        "Content-Type": "application/ssml+xml",
        "X-Microsoft-OutputFormat": s
      };
    }
  }, {
    key: "buildSpeechToTextHeaders",
    value: function(s) {
      return {
        "Ocp-Apim-Subscription-Key": s,
        Accept: "application/json"
      };
    }
    // prettier-ignore
  }, {
    key: "handleSpeechVerificationResult",
    value: function(s, n, r, i) {
      s.error ? i(Ys.INVALID_KEY) : r(n);
    }
  }, {
    key: "buildSpeechKeyVerificationDetails",
    value: function(s) {
      return {
        url: "https://".concat(s, ".api.cognitive.microsoft.com/sts/v1.0/issuetoken"),
        method: "POST",
        createHeaders: function(r) {
          return {
            "Ocp-Apim-Subscription-Key": "".concat(r)
          };
        },
        handleVerificationResult: e.handleSpeechVerificationResult
      };
    }
  }, {
    key: "buildSummarizationHeader",
    value: function(s) {
      return {
        "Ocp-Apim-Subscription-Key": s,
        "Content-Type": "application/json"
      };
    }
    // prettier-ignore
  }, {
    key: "handleLanguageVerificationResult",
    value: function(s, n, r, i) {
      var o;
      ((o = s.error) == null ? void 0 : o.code) === "401" ? i(Ys.INVALID_KEY) : r(n);
    }
  }, {
    key: "buildLanguageKeyVerificationDetails",
    value: function(s) {
      return {
        url: "".concat(s, "/language/analyze-text/jobs?api-version=2022-10-01-preview"),
        method: "POST",
        createHeaders: function(r) {
          return {
            "Ocp-Apim-Subscription-Key": "".concat(r)
          };
        },
        handleVerificationResult: e.handleLanguageVerificationResult
      };
    }
    // prettier-ignore
  }, {
    key: "handleTranslationVerificationResult",
    value: function(s, n, r, i) {
      s.json().then(function(o) {
        !Array.isArray(o) && o.error.code === 401e3 ? i(Ys.INVALID_KEY) : r(n);
      });
    }
  }, {
    key: "buildTranslationKeyVerificationDetails",
    value: function(s) {
      return {
        url: "https://api.cognitive.microsofttranslator.com/translate?api-version=3.0&to=es",
        method: "POST",
        createHeaders: function(r) {
          return e.buildTranslationHeaders(s, r);
        },
        handleVerificationResult: e.handleTranslationVerificationResult
      };
    }
  }, {
    key: "buildTranslationHeaders",
    value: function(s, n) {
      var r = {
        "Ocp-Apim-Subscription-Key": n,
        "Content-Type": "application/json"
      };
      return s && (r["Ocp-Apim-Subscription-Region"] = s), r;
    }
  }]);
}(), mHe = /* @__PURE__ */ function(e) {
  function t(s, n, r, i, o) {
    var l;
    return je(this, t), l = jt(this, t, [s, ul.buildLanguageKeyVerificationDetails(r), n, i, o]), l.insertKeyPlaceholderText = "Azure Language Subscription Key", l.keyHelpUrl = // eslint-disable-next-line max-len
    "https://learn.microsoft.com/en-us/azure/api-management/api-management-subscriptions#create-and-manage-subscriptions-in-azure-portal", l.permittedErrorPrefixes = ["Access"], l;
  }
  return Ht(t, e), He(t);
}(tn), x5 = /* @__PURE__ */ function(e) {
  function t(s) {
    var n, r;
    je(this, t);
    var i, o, l, d, c = (o = (i = s.directConnection) == null ? void 0 : i.azure) == null ? void 0 : o.summarization, u = (l = s.directConnection) == null ? void 0 : l.azure;
    return r = jt(this, t, [s, ul.buildSummarizationHeader, c.endpoint, u]), r.permittedErrorPrefixes = [t.ENDPOINT_ERROR_MESSAGE], r.url = "", r.textInputPlaceholderText = "Insert text to summarize", r.isTextInputDisabled = !1, c.endpoint ? ((n = (d = r.rawBody).language) !== null && n !== void 0 || (d.language = "en"), Object.assign(r.rawBody, c), r.url = "".concat(c.endpoint, "/language/analyze-text/jobs?api-version=2022-10-01-preview")) : (r.isTextInputDisabled = !0, r.canSendMessage = function() {
      return !1;
    }, setTimeout(function() {
      s.addMessage({
        error: t.ENDPOINT_ERROR_MESSAGE
      });
    })), r;
  }
  return Ht(t, e), He(t, [{
    key: "preprocessBody",
    value: function(n, r) {
      var i = r[r.length - 1].text;
      if (i) return {
        analysisInput: {
          documents: [{
            id: "1",
            language: n.language,
            text: i
          }]
        },
        tasks: [{
          kind: "ExtractiveSummarization"
        }]
      };
    }
  }, {
    key: "callServiceAPI",
    value: function() {
      var s = Qe(/* @__PURE__ */ ce().mark(function r(i, o) {
        var l;
        return ce().wrap(function(c) {
          for (; ; ) switch (c.prev = c.next) {
            case 0:
              if (this.connectSettings) {
                c.next = 2;
                break;
              }
              throw new Error("Request settings have not been set up");
            case 2:
              l = this.preprocessBody(this.rawBody, o), ha.request(this, l, i), this.messages = i;
            case 4:
            case "end":
              return c.stop();
          }
        }, r, this);
      }));
      function n(r, i) {
        return s.apply(this, arguments);
      }
      return n;
    }()
  }, {
    key: "extractResultData",
    value: function() {
      var s = Qe(/* @__PURE__ */ ce().mark(function r(i) {
        var o, l, d;
        return ce().wrap(function(u) {
          for (; ; ) switch (u.prev = u.next) {
            case 0:
              if (!i.error) {
                u.next = 2;
                break;
              }
              throw i.error.message;
            case 2:
              return this.messages && this.completionsHandlers && (l = i.headers.get("operation-location"), d = {
                method: "GET",
                headers: (o = this.connectSettings) == null ? void 0 : o.headers
              }, ha.executePollRequest(this, l, d, this.messages)), u.abrupt("return", {
                makingAnotherRequest: !0
              });
            case 4:
            case "end":
              return u.stop();
          }
        }, r, this);
      }));
      function n(r) {
        return s.apply(this, arguments);
      }
      return n;
    }()
  }, {
    key: "extractPollResultData",
    value: function() {
      var s = Qe(/* @__PURE__ */ ce().mark(function r(i) {
        var o, l, d, c;
        return ce().wrap(function(m) {
          for (; ; ) switch (m.prev = m.next) {
            case 0:
              if (!i.error) {
                m.next = 2;
                break;
              }
              throw i.error;
            case 2:
              if (i.status !== "running") {
                m.next = 4;
                break;
              }
              return m.abrupt("return", {
                timeoutMS: 2e3
              });
            case 4:
              if (!(i.errors.length > 0)) {
                m.next = 6;
                break;
              }
              throw i.errors[0];
            case 6:
              if (!(i.tasks.items[0].results.errors.length > 0)) {
                m.next = 8;
                break;
              }
              throw i.tasks.items[0].results.errors[0];
            case 8:
              o = "", l = TDe(i.tasks.items[0].results.documents[0].sentences);
              try {
                for (l.s(); !(d = l.n()).done; )
                  c = d.value, o += c.text;
              } catch (f) {
                l.e(f);
              } finally {
                l.f();
              }
              return m.abrupt("return", {
                text: o || ""
              });
            case 12:
            case "end":
              return m.stop();
          }
        }, r);
      }));
      function n(r) {
        return s.apply(this, arguments);
      }
      return n;
    }()
  }]);
}(mHe);
x5.ENDPOINT_ERROR_MESSAGE = // eslint-disable-next-line max-len
"Please define the azure endpoint. [More Information](https://deepchat.dev/docs/directConnection/Azure#Summarization)";
var fHe = x5, Hg = /* @__PURE__ */ function() {
  function e() {
    je(this, e);
  }
  return He(e, null, [{
    key: "poll",
    value: function() {
      var t = Qe(/* @__PURE__ */ ce().mark(function n(r, i) {
        var o, l, d, c;
        return ce().wrap(function(m) {
          for (; ; ) switch (m.prev = m.next) {
            case 0:
              return o = {
                authorization: r,
                "content-type": "application/json"
              }, m.t0 = "https://api.assemblyai.com/v2/transcript/", m.next = 4, fetch("https://api.assemblyai.com/v2/transcript", {
                method: "POST",
                body: JSON.stringify({
                  audio_url: i
                }),
                headers: o
              });
            case 4:
              return m.next = 6, m.sent.json();
            case 6:
              m.t1 = m.sent.id, l = m.t0.concat.call(m.t0, m.t1);
            case 8:
              if (d) {
                m.next = 24;
                break;
              }
              return m.next = 11, fetch(l, {
                headers: o
              });
            case 11:
              return m.next = 13, m.sent.json();
            case 13:
              if (c = m.sent, c.status !== "completed") {
                m.next = 18;
                break;
              }
              d = c, m.next = 22;
              break;
            case 18:
              if (c.status !== "error") {
                m.next = 20;
                break;
              }
              throw new Error("Transcription failed: ".concat(c.error));
            case 20:
              return m.next = 22, new Promise(function(f) {
                return setTimeout(f, 3e3);
              });
            case 22:
              m.next = 8;
              break;
            case 24:
              return m.abrupt("return", d);
            case 25:
            case "end":
              return m.stop();
          }
        }, n);
      }));
      function s(n, r) {
        return t.apply(this, arguments);
      }
      return s;
    }()
  }, {
    key: "buildHeaders",
    value: function(s) {
      return {
        Authorization: s,
        "Content-Type": "application/octet-stream"
      };
    }
    // prettier-ignore
  }, {
    key: "handleVerificationResult",
    value: function(s, n, r, i) {
      var o = s;
      o.error ? o.error.code === "invalid_api_key" ? i(Ys.INVALID_KEY) : i(Ys.CONNECTION_FAILED) : r(n);
    }
  }, {
    key: "buildKeyVerificationDetails",
    value: function() {
      return {
        url: "https://api.assemblyai.com/v2/upload",
        method: "POST",
        handleVerificationResult: e.handleVerificationResult
      };
    }
  }]);
}(), gHe = /* @__PURE__ */ function(e) {
  function t(s) {
    var n;
    je(this, t);
    var r, i = (r = s.directConnection) == null ? void 0 : r.assemblyAI;
    return n = jt(this, t, [s, Hg.buildKeyVerificationDetails(), Hg.buildHeaders, i, {
      audio: {}
    }]), n.insertKeyPlaceholderText = "AssemblyAI API Key", n.keyHelpUrl = "https://www.assemblyai.com/app/account", n.introPanelMarkUp = `
    <div style="width: 100%; text-align: center; margin-left: -10px"><b>AssemblyAI Audio</b></div>
    <p><b>Upload an audio file</b> to transcribe it into text.
    <p>
      Click <a href="https://www.assemblyai.com/docs/Guides/transcribing_an_audio_file#get-started">here</a> for more info.
    </p>`, n.url = "https://api.assemblyai.com/v2/upload", n.isTextInputDisabled = !0, n.textInputPlaceholderText = "Upload an audio file", n.permittedErrorPrefixes = ["Authentication", "Invalid"], n.canSendMessage = t.canFileSendMessage, n;
  }
  return Ht(t, e), He(t, [{
    key: "callServiceAPI",
    value: function() {
      var s = Qe(/* @__PURE__ */ ce().mark(function r(i, o, l) {
        var d;
        return ce().wrap(function(u) {
          for (; ; ) switch (u.prev = u.next) {
            case 0:
              if ((d = this.connectSettings) != null && d.headers) {
                u.next = 2;
                break;
              }
              throw new Error("Request settings have not been set up");
            case 2:
              if (l != null && l[0]) {
                u.next = 4;
                break;
              }
              throw new Error("No file was added");
            case 4:
              ha.request(this, l[0], i, !1);
            case 5:
            case "end":
              return u.stop();
          }
        }, r, this);
      }));
      function n(r, i, o) {
        return s.apply(this, arguments);
      }
      return n;
    }()
  }, {
    key: "extractResultData",
    value: function() {
      var s = Qe(/* @__PURE__ */ ce().mark(function r(i) {
        var o, l, d;
        return ce().wrap(function(u) {
          for (; ; ) switch (u.prev = u.next) {
            case 0:
              if (!i.error) {
                u.next = 2;
                break;
              }
              throw i.error;
            case 2:
              return d = (l = (o = this.connectSettings) == null ? void 0 : o.headers) == null ? void 0 : l.Authorization, u.next = 5, Hg.poll(d, i.upload_url);
            case 5:
              return u.t0 = u.sent.text, u.abrupt("return", {
                text: u.t0
              });
            case 7:
            case "end":
              return u.stop();
          }
        }, r, this);
      }));
      function n(r) {
        return s.apply(this, arguments);
      }
      return n;
    }()
  }], [{
    key: "canFileSendMessage",
    value: function(n, r) {
      return !!(r != null && r[0]);
    }
  }]);
}(tn), F5 = /* @__PURE__ */ function(e) {
  function t(s, n, r, i, o) {
    var l;
    return je(this, t), l = jt(this, t, [s, ul.buildSpeechKeyVerificationDetails(r), n, i, o]), l.insertKeyPlaceholderText = "Azure Speech Subscription Key", l.keyHelpUrl = // eslint-disable-next-line max-len
    "https://learn.microsoft.com/en-us/azure/api-management/api-management-subscriptions#create-and-manage-subscriptions-in-azure-portal", l;
  }
  return Ht(t, e), He(t);
}(tn), xy = /* @__PURE__ */ function(e) {
  function t(s) {
    var n, r, i, o;
    je(this, t);
    var l, d, c, u, m, f, v = (d = (l = s.directConnection) == null ? void 0 : l.azure) == null ? void 0 : d.textToSpeech, b = (c = s.directConnection) == null ? void 0 : c.azure;
    return o = jt(this, t, [s, ul.buildTextToSpeechHeaders.bind({}, (v == null ? void 0 : v.outputFormat) || "audio-16khz-128kbitrate-mono-mp3"), v.region, b]), o.permittedErrorPrefixes = [t.REGION_ERROR_MESSAGE], o.introPanelMarkUp = `
    <div style="width: 100%; text-align: center; margin-left: -10px"><b>Azure Text To Speech</b></div>
    <p>Insert text to synthesize it to audio.
    <p>
      Click <a href="`.concat(t.HELP_LINK, `">here</a> for more info.
    </p>`), o.isTextInputDisabled = !1, o.url = "", v.region ? (Object.assign(o.rawBody, v), (n = (u = o.rawBody).lang) !== null && n !== void 0 || (u.lang = "en-US"), (r = (m = o.rawBody).name) !== null && r !== void 0 || (m.name = "en-US-JennyNeural"), (i = (f = o.rawBody).gender) !== null && i !== void 0 || (f.gender = "Female"), o.url = "https://".concat(v.region, ".tts.speech.microsoft.com/cognitiveservices/v1")) : (o.isTextInputDisabled = !0, o.canSendMessage = function() {
      return !1;
    }, setTimeout(function() {
      s.addMessage({
        error: t.REGION_ERROR_MESSAGE
      });
    })), o;
  }
  return Ht(t, e), He(t, [{
    key: "preprocessBody",
    value: function(n, r) {
      var i = r[r.length - 1].text;
      if (i) return "<speak version='1.0' xml:lang='".concat(n.lang, `'>
      <voice xml:lang='`).concat(n.lang, "' xml:gender='").concat(n.gender, "' name='").concat(n.name, `'>
        `).concat(i, `
      </voice>
    </speak>`);
    }
  }, {
    key: "callServiceAPI",
    value: function() {
      var s = Qe(/* @__PURE__ */ ce().mark(function r(i, o) {
        var l;
        return ce().wrap(function(c) {
          for (; ; ) switch (c.prev = c.next) {
            case 0:
              if (this.connectSettings) {
                c.next = 2;
                break;
              }
              throw new Error("Request settings have not been set up");
            case 2:
              l = this.preprocessBody(this.rawBody, o), ha.request(this, l, i, !1);
            case 4:
            case "end":
              return c.stop();
          }
        }, r, this);
      }));
      function n(r, i) {
        return s.apply(this, arguments);
      }
      return n;
    }()
  }, {
    key: "extractResultData",
    value: function() {
      var s = Qe(/* @__PURE__ */ ce().mark(function r(i) {
        return ce().wrap(function(l) {
          for (; ; ) switch (l.prev = l.next) {
            case 0:
              return l.abrupt("return", new Promise(function(d) {
                var c = new FileReader();
                c.readAsDataURL(i), c.onload = function(u) {
                  d({
                    files: [{
                      src: u.target.result,
                      type: "audio"
                    }]
                  });
                };
              }));
            case 1:
            case "end":
              return l.stop();
          }
        }, r);
      }));
      function n(r) {
        return s.apply(this, arguments);
      }
      return n;
    }()
  }]);
}(F5);
xy.HELP_LINK = // eslint-disable-next-line max-len
"https://learn.microsoft.com/en-GB/azure/cognitive-services/speech-service/get-started-text-to-speech?tabs=windows%2Cterminal&pivots=programming-language-rest", xy.REGION_ERROR_MESSAGE = // eslint-disable-next-line max-len
"Please define a region config property. [More Information](https://deepchat.dev/docs/directConnection/Azure#TextToSpeech)";
var vHe = xy, Fy = /* @__PURE__ */ function(e) {
  function t(s) {
    var n;
    je(this, t);
    var r, i, o, l = (i = (r = s.directConnection) == null ? void 0 : r.azure) == null ? void 0 : i.speechToText, d = (o = s.directConnection) == null ? void 0 : o.azure, c = {
      audio: {
        files: {
          acceptedFormats: ".wav,.ogg"
        }
      }
    };
    if (n = jt(this, t, [s, ul.buildSpeechToTextHeaders, l.region, d, c]), n.permittedErrorPrefixes = [t.REGION_ERROR_MESSAGE], n.introPanelMarkUp = `
    <div style="width: 100%; text-align: center; margin-left: -10px"><b>Azure Speech To Text</b></div>
    <p><b>Upload a .wav or .ogg audio file</b> to transcribe it into text.
    <p>
      Click <a href="`.concat(t.HELP_LINK, `">here</a> for more info.
    </p>`), n.url = "", n.isTextInputDisabled = !0, n.textInputPlaceholderText = "Upload an audio file", !l.region) n.isTextInputDisabled = !0, n.canSendMessage = function() {
      return !1;
    }, setTimeout(function() {
      s.addMessage({
        error: t.REGION_ERROR_MESSAGE
      });
    });
    else {
      n.canSendMessage = t.canFileSendMessage;
      var u = l.lang || "en-US";
      n.url = "https://".concat(l.region, ".stt.speech.microsoft.com/speech/recognition/conversation/cognitiveservices/v1?language=").concat(u, "&format=detailed"), n.recordAudio = void 0;
    }
    return n;
  }
  return Ht(t, e), He(t, [{
    key: "callServiceAPI",
    value: function() {
      var s = Qe(/* @__PURE__ */ ce().mark(function r(i, o, l) {
        var d, c;
        return ce().wrap(function(m) {
          for (; ; ) switch (m.prev = m.next) {
            case 0:
              if ((d = this.connectSettings) != null && d.headers) {
                m.next = 2;
                break;
              }
              throw new Error("Request settings have not been set up");
            case 2:
              if (l != null && l[0]) {
                m.next = 4;
                break;
              }
              throw new Error("No file was added");
            case 4:
              (c = this.connectSettings) != null && c.headers && (this.connectSettings.headers["Content-Type"] = l[0].name.toLocaleLowerCase().endsWith(".wav") ? "audio/wav; codecs=audio/pcm; samplerate=16000" : "audio/ogg; codecs=opus"), ha.request(this, l[0], i, !1);
            case 5:
            case "end":
              return m.stop();
          }
        }, r, this);
      }));
      function n(r, i, o) {
        return s.apply(this, arguments);
      }
      return n;
    }()
  }, {
    key: "extractResultData",
    value: function() {
      var s = Qe(/* @__PURE__ */ ce().mark(function r(i) {
        return ce().wrap(function(l) {
          for (; ; ) switch (l.prev = l.next) {
            case 0:
              if (!i.error) {
                l.next = 2;
                break;
              }
              throw i.error;
            case 2:
              return l.abrupt("return", {
                text: i.DisplayText || ""
              });
            case 3:
            case "end":
              return l.stop();
          }
        }, r);
      }));
      function n(r) {
        return s.apply(this, arguments);
      }
      return n;
    }()
  }], [{
    key: "canFileSendMessage",
    value: function(n, r) {
      return !!(r != null && r[0]);
    }
  }]);
}(F5);
Fy.HELP_LINK = // eslint-disable-next-line max-len
"https://learn.microsoft.com/en-GB/azure/cognitive-services/speech-service/get-started-text-to-speech?tabs=windows%2Cterminal&pivots=programming-language-rest", Fy.REGION_ERROR_MESSAGE = // eslint-disable-next-line max-len
"Please define a region config property. [More Information](https://deepchat.dev/docs/directConnection/Azure#SpeechToText)";
var yHe = Fy, bHe = /* @__PURE__ */ function(e) {
  function t(s) {
    var n;
    je(this, t);
    var r, i, o, l = (i = (r = s.directConnection) == null ? void 0 : r.azure) == null ? void 0 : i.translation, d = (o = s.directConnection) == null ? void 0 : o.azure;
    return n = jt(this, t, [s, ul.buildTranslationKeyVerificationDetails(l.region), ul.buildTranslationHeaders.bind({}, l == null ? void 0 : l.region), d]), n.insertKeyPlaceholderText = "Azure Translate Subscription Key", n.keyHelpUrl = // eslint-disable-next-line max-len
    "https://learn.microsoft.com/en-us/azure/api-management/api-management-subscriptions#create-and-manage-subscriptions-in-azure-portal", n.url = "", n.url = "https://api.cognitive.microsofttranslator.com/translate?api-version=3.0&to=".concat(l.language || "es"), n;
  }
  return Ht(t, e), He(t, [{
    key: "preprocessBody",
    value: function(n) {
      var r = n[n.length - 1].text;
      if (r) return [{
        Text: r
      }];
    }
  }, {
    key: "callServiceAPI",
    value: function() {
      var s = Qe(/* @__PURE__ */ ce().mark(function r(i, o) {
        var l;
        return ce().wrap(function(c) {
          for (; ; ) switch (c.prev = c.next) {
            case 0:
              if (this.connectSettings) {
                c.next = 2;
                break;
              }
              throw new Error("Request settings have not been set up");
            case 2:
              l = this.preprocessBody(o), ha.request(this, l, i);
            case 4:
            case "end":
              return c.stop();
          }
        }, r, this);
      }));
      function n(r, i) {
        return s.apply(this, arguments);
      }
      return n;
    }()
  }, {
    key: "extractResultData",
    value: function() {
      var s = Qe(/* @__PURE__ */ ce().mark(function r(i) {
        var o;
        return ce().wrap(function(d) {
          for (; ; ) switch (d.prev = d.next) {
            case 0:
              if (!Array.isArray(i)) {
                d.next = 2;
                break;
              }
              return d.abrupt("return", {
                text: ((o = i[0].translations) == null ? void 0 : o[0].text) || ""
              });
            case 2:
              throw i.error;
            case 3:
            case "end":
              return d.stop();
          }
        }, r);
      }));
      function n(r) {
        return s.apply(this, arguments);
      }
      return n;
    }()
  }]);
}(tn), V5 = /* @__PURE__ */ function(e) {
  function t(s, n, r, i, o) {
    var l, d, c;
    je(this, t);
    var u, m, f, v, b, w = JSON.parse(JSON.stringify(s.directConnection)), S = n || La.buildKeyVerificationDetails(), I = r || La.buildHeaders, T = i || w.openAI;
    c = jt(this, t, [s, S, I, T]), c.insertKeyPlaceholderText = "OpenAI API Key", c.keyHelpUrl = "https://platform.openai.com/account/api-keys", c.url = "https://api.openai.com/v1/chat/completions", c.permittedErrorPrefixes = ["Incorrect"], c.asyncCallInProgress = !1, c._systemMessage = t.generateSystemMessage("You are a helpful assistant.");
    var x = o || ((u = w.openAI) == null ? void 0 : u.chat);
    if (St(x) == "object") {
      x.system_prompt && (c._systemMessage = t.generateSystemMessage(x.system_prompt));
      var k = (v = (f = (m = s.directConnection) == null ? void 0 : m.openAI) == null ? void 0 : f.chat) == null ? void 0 : v.function_handler;
      k && (c._functionHandler = k), c.cleanConfig(x), Object.assign(c.rawBody, x);
    }
    return (l = c.maxMessages) !== null && l !== void 0 || (c.maxMessages = -1), (d = (b = c.rawBody).model) !== null && d !== void 0 || (b.model = "gpt-4o"), c;
  }
  return Ht(t, e), He(t, [{
    key: "cleanConfig",
    value: function(n) {
      delete n.system_prompt, delete n.function_handler;
    }
  }, {
    key: "preprocessBody",
    value: (
      // prettier-ignore
      function(n, r) {
        var i, o = JSON.parse(JSON.stringify(n)), l = yf.getCharacterLimitMessages(r, this.totalMessagesMaxCharLength ? this.totalMessagesMaxCharLength - this._systemMessage.content.length : -1).map(function(d) {
          return {
            content: t.getContent(d),
            role: d.role === Ft.USER_ROLE ? "user" : "assistant"
          };
        });
        return r.find(function(d) {
          return d.files && d.files.length > 0;
        }) && ((i = o.max_tokens) !== null && i !== void 0 || (o.max_tokens = 300)), o.messages = [this._systemMessage].concat(Qu(l)), o;
      }
    )
  }, {
    key: "callServiceAPI",
    value: function() {
      var s = Qe(/* @__PURE__ */ ce().mark(function r(i, o) {
        var l, d;
        return ce().wrap(function(u) {
          for (; ; ) switch (u.prev = u.next) {
            case 0:
              if (this.connectSettings) {
                u.next = 2;
                break;
              }
              throw new Error("Request settings have not been set up");
            case 2:
              l = this.preprocessBody(this.rawBody, o), d = this.stream, d && (St(d) != "object" || !d.simulation) || l.stream ? (l.stream = !0, Da.request(this, l, i)) : ha.request(this, l, i);
            case 4:
            case "end":
              return u.stop();
          }
        }, r, this);
      }));
      function n(r, i) {
        return s.apply(this, arguments);
      }
      return n;
    }()
    // prettier-ignore
  }, {
    key: "extractResultData",
    value: function() {
      var s = Qe(/* @__PURE__ */ ce().mark(function r(i, o, l) {
        var d, c, u, m;
        return ce().wrap(function(v) {
          for (; ; ) switch (v.prev = v.next) {
            case 0:
              if (!i.error) {
                v.next = 2;
                break;
              }
              throw i.error.message;
            case 2:
              return v.abrupt("return", (c = (d = i.choices) == null ? void 0 : d[0]) != null && c.delta ? this.extractStreamResult(i.choices[0], o, l) : (m = (u = i.choices) == null ? void 0 : u[0]) != null && m.message ? i.choices[0].message.tool_calls ? this.handleTools(i.choices[0].message, o, l) : {
                text: i.choices[0].message.content
              } : {
                text: ""
              });
            case 3:
            case "end":
              return v.stop();
          }
        }, r, this);
      }));
      function n(r, i, o) {
        return s.apply(this, arguments);
      }
      return n;
    }()
  }, {
    key: "extractStreamResult",
    value: function() {
      var s = Qe(/* @__PURE__ */ ce().mark(function r(i, o, l) {
        var d = this, c, u, m;
        return ce().wrap(function(v) {
          for (; ; ) switch (v.prev = v.next) {
            case 0:
              if (c = i.delta, u = i.finish_reason, u !== "tool_calls") {
                v.next = 7;
                break;
              }
              return this.asyncCallInProgress = !0, m = {
                tool_calls: this._streamToolCalls
              }, v.abrupt("return", (this._streamToolCalls = void 0, this.handleTools(m, o, l)));
            case 7:
              c != null && c.tool_calls && (this._streamToolCalls ? c.tool_calls.forEach(function(b, w) {
                d._streamToolCalls && (d._streamToolCalls[w].function.arguments += b.function.arguments);
              }) : this._streamToolCalls = c.tool_calls);
            case 8:
              return v.abrupt("return", {
                text: (c == null ? void 0 : c.content) || ""
              });
            case 9:
            case "end":
              return v.stop();
          }
        }, r, this);
      }));
      function n(r, i, o) {
        return s.apply(this, arguments);
      }
      return n;
    }()
    // prettier-ignore
  }, {
    key: "handleTools",
    value: function() {
      var s = Qe(/* @__PURE__ */ ce().mark(function r(i, o, l) {
        var d, c, u, m, f, v, b, w, S, I, T, x;
        return ce().wrap(function(C) {
          for (; ; ) switch (C.prev = C.next) {
            case 0:
              if (!(!i.tool_calls || !o || !l || !this._functionHandler)) {
                C.next = 2;
                break;
              }
              throw Error("Please define the `function_handler` property inside the [openAI](https://deepchat.dev/docs/directConnection/openAI#Chat) object.");
            case 2:
              return v = JSON.parse(JSON.stringify(l)), b = i.tool_calls.map(function(O) {
                return {
                  name: O.function.name,
                  arguments: O.function.arguments
                };
              }), C.next = 6, (d = this._functionHandler) == null ? void 0 : d.call(this, b);
            case 6:
              if (w = C.sent, Array.isArray(w)) {
                C.next = 20;
                break;
              }
              if (!w.text) {
                C.next = 19;
                break;
              }
              return S = {
                text: w.text
              }, C.next = 12, (u = (c = this.deepChat).responseInterceptor) == null ? void 0 : u.call(c, S);
            case 12:
              if (C.t0 = C.sent, C.t0) {
                C.next = 15;
                break;
              }
              C.t0 = S;
            case 15:
              if (I = C.t0, !Array.isArray(I)) {
                C.next = 18;
                break;
              }
              throw Error(La.FUNCTION_TOOL_RESP_ARR_ERROR);
            case 18:
              return C.abrupt("return", I);
            case 19:
              throw Error(La.FUNCTION_TOOL_RESP_ERROR);
            case 20:
              return C.next = 22, Promise.all(w);
            case 22:
              if (T = C.sent, v.messages.push({
                tool_calls: i.tool_calls,
                role: "assistant",
                content: null
              }), !(!T.find(function(O) {
                var E = O.response;
                return typeof E != "string";
              }) && b.length === T.length)) {
                C.next = 43;
                break;
              }
              return T.forEach(function(O, E) {
                var B, M = (B = i.tool_calls) == null ? void 0 : B[E];
                v == null || v.messages.push({
                  role: "tool",
                  tool_call_id: M == null ? void 0 : M.id,
                  name: M == null ? void 0 : M.function.name,
                  content: O.response
                });
              }), delete v.tools, delete v.tool_choice, delete v.stream, C.prev = 25, C.next = 28, o == null ? void 0 : o(v).then(function(O) {
                return Kt.processResponseByType(O);
              });
            case 28:
              return x = C.sent, C.next = 31, (f = (m = this.deepChat).responseInterceptor) == null ? void 0 : f.call(m, x);
            case 31:
              if (C.t1 = C.sent, C.t1) {
                C.next = 34;
                break;
              }
              C.t1 = x;
            case 34:
              if (x = C.t1, !x.error) {
                C.next = 37;
                break;
              }
              throw x.error.message;
            case 37:
              return C.abrupt("return", {
                text: x.choices[0].message.content || ""
              });
            case 40:
              throw C.prev = 40, C.t2 = C.catch(25), this.asyncCallInProgress = !1, C.t2;
            case 43:
              throw Error(La.FUNCTION_TOOL_RESP_ERROR);
            case 44:
            case "end":
              return C.stop();
          }
        }, r, this, [[25, 40]]);
      }));
      function n(r, i, o) {
        return s.apply(this, arguments);
      }
      return n;
    }()
  }], [{
    key: "generateSystemMessage",
    value: function(n) {
      return {
        role: "system",
        content: n
      };
    }
  }, {
    key: "getContent",
    value: function(n) {
      if (n.files && n.files.length > 0) {
        var r = n.files.map(function(i) {
          return {
            type: "image_url",
            image_url: {
              url: i.src
            }
          };
        });
        return n.text && n.text.trim().length > 0 && r.unshift({
          type: "text",
          text: n.text
        }), r;
      }
      return n.text;
    }
  }]);
}(tn), AHe = /* @__PURE__ */ function(e) {
  function t(s) {
    var n;
    je(this, t);
    var r, i, o, l, d, c, u, m = JSON.parse(JSON.stringify(s.directConnection)), f = m.azure, v = ((i = (r = m.azure) == null ? void 0 : r.openAI) == null ? void 0 : i.urlDetails) || {}, b = (l = (o = m.azure) == null ? void 0 : o.openAI) == null ? void 0 : l.chat;
    if (n = jt(this, t, [s, Dr.buildKeyVerificationDetails(v), Dr.buildHeaders, f, b]), n.permittedErrorPrefixes = [Dr.URL_DETAILS_ERROR_MESSAGE], n.isTextInputDisabled = !1, St(b) == "object") {
      var w = (u = (c = (d = s.directConnection) == null ? void 0 : d.azure) == null ? void 0 : c.openAI) == null ? void 0 : u.chat, S = w.function_handler;
      S && (n._functionHandler = S);
    }
    return Dr.validateURLDetails(v) ? n.url = t.buildURL(v) : (n.isTextInputDisabled = !0, n.canSendMessage = function() {
      return !1;
    }, setTimeout(function() {
      s.addMessage({
        error: Dr.URL_DETAILS_ERROR_MESSAGE
      });
    })), n;
  }
  return Ht(t, e), He(t, null, [{
    key: "buildURL",
    value: function(n) {
      var r = n.endpoint, i = n.deploymentId, o = n.version;
      return "".concat(r, "/openai/deployments/").concat(i, "/chat/completions?api-version=").concat(o);
    }
  }]);
}(V5), Mh = /* @__PURE__ */ function(e) {
  function t(s) {
    var n;
    je(this, t);
    var r, i = s.directConnection, o = i == null ? void 0 : i.openAI, l = {
      images: {
        files: {
          acceptedFormats: ".png",
          maxNumberOfFiles: 2
        }
      }
    };
    n = jt(this, t, [s, La.buildKeyVerificationDetails(), La.buildHeaders, o, l]), n.insertKeyPlaceholderText = "OpenAI API Key", n.keyHelpUrl = "https://platform.openai.com/account/api-keys", n.introPanelMarkUp = `
    <div style="width: 100%; text-align: center; margin-left: -10px"><b>OpenAI DALL·E</b></div>
    <p><b>Insert text</b> to generate an image.</p>
    <p><b>Upload 1</b> PNG image to generate its variation and optionally insert text to specify the change.</p>
    <p><b>Upload 2</b> PNG images where the second is a copy of the first with a transparent area where the edit should
      take place and text to specify the edit.</p>
    <p>Click <a href="https://platform.openai.com/docs/guides/images/introduction">here</a> for more info.</p>`, n.url = "", n.permittedErrorPrefixes = ["Incorrect", "Invalid input image"];
    var d = (r = i == null ? void 0 : i.openAI) == null ? void 0 : r.images;
    if (n.camera) {
      var c = St(d) == "object" && d.size ? Number.parseInt(d.size) : 1024;
      n.camera.files = {
        dimensions: {
          width: c,
          height: c
        }
      };
    }
    return St(d) == "object" && Object.assign(n.rawBody, d), n.canSendMessage = t.canFileSendMessage, n;
  }
  return Ht(t, e), He(t, [{
    key: "preprocessBody",
    value: function(n, r) {
      var i = JSON.parse(JSON.stringify(n));
      return r && r !== "" && (i.prompt = r), i;
    }
    // prettier-ignore
  }, {
    key: "callApiWithImage",
    value: function(n, r, i) {
      var o, l, d, c = (l = (o = r[r.length - 1]) == null ? void 0 : o.text) == null ? void 0 : l.trim();
      if (i[1] || c && c !== "") {
        this.url = t.IMAGE_EDIT_URL;
        var u = this.preprocessBody(this.rawBody, c);
        d = t.createFormDataBody(u, i[0], i[1]);
      } else this.url = t.IMAGE_VARIATIONS_URL, d = t.createFormDataBody(this.rawBody, i[0]);
      Kt.tempRemoveContentHeader(this.connectSettings, ha.request.bind(this, this, d, n), !1);
    }
  }, {
    key: "callServiceAPI",
    value: function() {
      var s = Qe(/* @__PURE__ */ ce().mark(function r(i, o, l) {
        var d, c;
        return ce().wrap(function(m) {
          for (; ; ) switch (m.prev = m.next) {
            case 0:
              if ((d = this.connectSettings) != null && d.headers) {
                m.next = 2;
                break;
              }
              throw new Error("Request settings have not been set up");
            case 2:
              if (!(l != null && l[0])) {
                m.next = 6;
                break;
              }
              this.callApiWithImage(i, o, l), m.next = 11;
              break;
            case 6:
              if (this.connectSettings) {
                m.next = 8;
                break;
              }
              throw new Error("Request settings have not been set up");
            case 8:
              this.url = t.IMAGE_GENERATION_URL, c = this.preprocessBody(this.rawBody, o[o.length - 1].text), ha.request(this, c, i);
            case 11:
            case "end":
              return m.stop();
          }
        }, r, this);
      }));
      function n(r, i, o) {
        return s.apply(this, arguments);
      }
      return n;
    }()
  }, {
    key: "extractResultData",
    value: function() {
      var s = Qe(/* @__PURE__ */ ce().mark(function r(i) {
        return ce().wrap(function(l) {
          for (; ; ) switch (l.prev = l.next) {
            case 0:
              if (!i.error) {
                l.next = 2;
                break;
              }
              throw i.error.message;
            case 2:
              return l.abrupt("return", {
                files: i.data.map(function(d) {
                  return d.url ? {
                    src: d.url,
                    type: "image"
                  } : {
                    src: "".concat(Ku).concat(d.b64_json),
                    type: "image"
                  };
                })
              });
            case 3:
            case "end":
              return l.stop();
          }
        }, r);
      }));
      function n(r) {
        return s.apply(this, arguments);
      }
      return n;
    }()
    // private static readonly MODAL_MARKDOWN = `
    // 1 image:
    // - With text - edits image based on the text
    // - No text - creates a variation of the image
    // 2 images:
    // - The second image needs to be a copy of the first with a transparent area where the edit should take place.
    // Add text to describe the required modification.
    // Click here for [more info](https://platform.openai.com/docs/guides/images/introduction).
    //   `;
  }], [{
    key: "canFileSendMessage",
    value: function(n, r) {
      return !!(r != null && r[0]) || !!(n && n.trim() !== "");
    }
  }, {
    key: "createFormDataBody",
    value: function(n, r, i) {
      var o = new FormData();
      return o.append("image", r), i && o.append("mask", i), Object.keys(n).forEach(function(l) {
        o.append(l, String(n[l]));
      }), o;
    }
  }]);
}(tn);
Mh.IMAGE_GENERATION_URL = "https://api.openai.com/v1/images/generations", Mh.IMAGE_VARIATIONS_URL = "https://api.openai.com/v1/images/variations", Mh.IMAGE_EDIT_URL = "https://api.openai.com/v1/images/edits";
var wHe = Mh, CHe = /* @__PURE__ */ function(e) {
  function t(s) {
    var n, r;
    je(this, t);
    var i, o = JSON.parse(JSON.stringify(s.directConnection)), l = (i = o.cohere) == null ? void 0 : i.chat, d = o.cohere;
    return r = jt(this, t, [s, "https://api.cohere.ai/v1/chat", "Ask me anything!", l, d]), St(l) == "object" && Object.assign(r.rawBody, l), (n = r.maxMessages) !== null && n !== void 0 || (r.maxMessages = -1), r;
  }
  return Ht(t, e), He(t, [{
    key: "preprocessBody",
    value: function(n, r) {
      var i = JSON.parse(JSON.stringify(n)), o = r.filter(function(l) {
        return l.text;
      });
      return i.query = o[o.length - 1].text, i.chat_history = o.slice(0, o.length - 1).map(function(l) {
        return {
          text: l.text,
          user_name: l.role === "ai" ? "CHATBOT" : "USER"
        };
      }), i;
    }
  }, {
    key: "callServiceAPI",
    value: function() {
      var s = Qe(/* @__PURE__ */ ce().mark(function r(i, o) {
        var l;
        return ce().wrap(function(c) {
          for (; ; ) switch (c.prev = c.next) {
            case 0:
              if (this.connectSettings) {
                c.next = 2;
                break;
              }
              throw new Error("Request settings have not been set up");
            case 2:
              l = this.preprocessBody(this.rawBody, o), ha.request(this, l, i);
            case 4:
            case "end":
              return c.stop();
          }
        }, r, this);
      }));
      function n(r, i) {
        return s.apply(this, arguments);
      }
      return n;
    }()
  }, {
    key: "extractResultData",
    value: function() {
      var s = Qe(/* @__PURE__ */ ce().mark(function r(i) {
        return ce().wrap(function(l) {
          for (; ; ) switch (l.prev = l.next) {
            case 0:
              if (!i.message) {
                l.next = 2;
                break;
              }
              throw i.message;
            case 2:
              return l.abrupt("return", {
                text: i.text
              });
            case 3:
            case "end":
              return l.stop();
          }
        }, r);
      }));
      function n(r) {
        return s.apply(this, arguments);
      }
      return n;
    }()
  }]);
}(Fb), uC = /* @__PURE__ */ function() {
  function e() {
    je(this, e);
  }
  return He(e, null, [{
    key: "buildHeaders",
    value: function(s) {
      return {
        Authorization: "Bearer ".concat(s),
        "Content-Type": "application/json",
        accept: "application/json"
      };
    }
    // prettier-ignore
  }, {
    key: "handleVerificationResult",
    value: function(s, n, r, i) {
      var o;
      (o = s.message) != null && o.includes("invalid request: prompt must be at least 1 token long") ? r(n) : i(Ys.INVALID_KEY);
    }
  }, {
    key: "buildKeyVerificationDetails",
    value: function() {
      return {
        url: "https://api.mistral.ai/v1/models",
        method: "GET",
        handleVerificationResult: e.handleVerificationResult
      };
    }
  }]);
}(), SHe = /* @__PURE__ */ function(e) {
  function t(s) {
    var n, r, i;
    je(this, t);
    var o, l = JSON.parse(JSON.stringify(s.directConnection)).mistral;
    return i = jt(this, t, [s, uC.buildKeyVerificationDetails(), uC.buildHeaders, l]), i.insertKeyPlaceholderText = "Mistral API Key", i.keyHelpUrl = "https://console.mistral.ai/api-keys/", i.url = "https://api.mistral.ai/v1/chat/completions", i.permittedErrorPrefixes = ["invalid"], l && (i.cleanConfig(l), Object.assign(i.rawBody, l)), (n = i.maxMessages) !== null && n !== void 0 || (i.maxMessages = -1), (r = (o = i.rawBody).model) !== null && r !== void 0 || (o.model = "open-mistral-7b"), i;
  }
  return Ht(t, e), He(t, [{
    key: "cleanConfig",
    value: function(n) {
      delete n.key;
    }
    // build a single string for user
  }, {
    key: "preprocessBody",
    value: function(n, r) {
      var i = JSON.parse(JSON.stringify(n)), o = r.filter(function(l) {
        return l.text;
      });
      return i.messages = o.slice(0, o.length - 1).map(function(l) {
        return {
          text: l.text,
          user_name: l.role === "ai" ? "system" : "user"
        };
      }), i;
    }
  }, {
    key: "callServiceAPI",
    value: function() {
      var s = Qe(/* @__PURE__ */ ce().mark(function r(i, o) {
        var l;
        return ce().wrap(function(c) {
          for (; ; ) switch (c.prev = c.next) {
            case 0:
              if (this.connectSettings) {
                c.next = 2;
                break;
              }
              throw new Error("Request settings have not been set up");
            case 2:
              l = this.preprocessBody(this.rawBody, o), ha.request(this, l, i);
            case 4:
            case "end":
              return c.stop();
          }
        }, r, this);
      }));
      function n(r, i) {
        return s.apply(this, arguments);
      }
      return n;
    }()
  }, {
    key: "extractResultData",
    value: function() {
      var s = Qe(/* @__PURE__ */ ce().mark(function r(i) {
        return ce().wrap(function(l) {
          for (; ; ) switch (l.prev = l.next) {
            case 0:
              if (!i.message) {
                l.next = 2;
                break;
              }
              throw i.message;
            case 2:
              return l.abrupt("return", {
                text: i.text
              });
            case 3:
            case "end":
              return l.stop();
          }
        }, r);
      }));
      function n(r) {
        return s.apply(this, arguments);
      }
      return n;
    }()
  }]);
}(tn), pC = /* @__PURE__ */ function() {
  function e() {
    je(this, e);
  }
  return He(e, null, [{
    key: "buildHeaders",
    value: function() {
      return {
        "Content-Type": "application/json"
      };
    }
    // prettier-ignore
  }, {
    key: "handleVerificationResult",
    value: function(s, n, r, i) {
      var o, l = s;
      l.error ? l.error.code === 403 || (o = l.error.message) != null && o.includes("API key") ? i(Ys.INVALID_KEY) : i(Ys.CONNECTION_FAILED) : r(n);
    }
  }, {
    key: "buildKeyVerificationDetails",
    value: function() {
      return {
        url: "https://generativelanguage.googleapis.com/v1beta/models?key=",
        method: "GET",
        handleVerificationResult: e.handleVerificationResult
      };
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  }, {
    key: "directFetch",
    value: function() {
      var t = Qe(/* @__PURE__ */ ce().mark(function n(r, i, o) {
        var l, d, c = arguments;
        return ce().wrap(function(m) {
          for (; ; ) switch (m.prev = m.next) {
            case 0:
              return l = c.length > 3 && c[3] !== void 0 ? c[3] : !0, r.connectSettings.method = o, m.next = 4, Kt.fetch(r, r.connectSettings.headers, l, i).then(function(f) {
                return Kt.processResponseByType(f);
              });
            case 4:
              if (d = m.sent, !d.error) {
                m.next = 7;
                break;
              }
              throw d.error.message;
            case 7:
              return m.abrupt("return", d);
            case 8:
            case "end":
              return m.stop();
          }
        }, n);
      }));
      function s(n, r, i) {
        return t.apply(this, arguments);
      }
      return s;
    }()
  }]);
}(), PHe = /* @__PURE__ */ function(e) {
  function t(s) {
    var n, r;
    je(this, t);
    var i, o = JSON.parse(JSON.stringify(s.directConnection)), l = o.gemini, d = (i = o.gemini) == null ? void 0 : i.chat, c;
    r = jt(this, t, [s, pC.buildKeyVerificationDetails(), pC.buildHeaders, l]), r.insertKeyPlaceholderText = "Gemini API Key", r.keyHelpUrl = "https://aistudio.google.com/app/apikey", r.url = "https://generativelanguage.googleapis.com/v1beta/models/gemini-2.0-flash:generateContent", r.permittedErrorPrefixes = ["API_KEY_INVALID"], St(d) == "object" && (d.systemInstruction && (c = d.systemInstruction), d.model && (r.url = "https://generativelanguage.googleapis.com/v1beta/models/".concat(d.model, ":generateContent")));
    var u = "".concat(r.url, "?key=").concat(l == null ? void 0 : l.key);
    return r.url = u, Object.defineProperty(r, "_systemInstruction", {
      value: c,
      writable: !1
    }), St(d) == "object" && (r.cleanConfig(d), Object.assign(r.rawBody, d)), (n = r.maxMessages) !== null && n !== void 0 || (r.maxMessages = -1), r;
  }
  return Ht(t, e), He(t, [{
    key: "cleanConfig",
    value: function(n) {
      delete n.systemInstruction, delete n.model;
    }
  }, {
    key: "preprocessBody",
    value: (
      // prettier-ignore
      function(n, r) {
        var i, o = JSON.parse(JSON.stringify(n)), l = yf.getCharacterLimitMessages(r, this.totalMessagesMaxCharLength ? this.totalMessagesMaxCharLength - (((i = this._systemInstruction) == null ? void 0 : i.length) || 0) : -1).map(function(d) {
          return t.getContent(d);
        });
        return o.contents = l, this._systemInstruction && (o.systemInstruction = {
          parts: [{
            text: this._systemInstruction
          }]
        }), o;
      }
    )
  }, {
    key: "callServiceAPI",
    value: function() {
      var s = Qe(/* @__PURE__ */ ce().mark(function r(i, o) {
        var l, d;
        return ce().wrap(function(u) {
          for (; ; ) switch (u.prev = u.next) {
            case 0:
              if (this.connectSettings) {
                u.next = 2;
                break;
              }
              throw new Error("Request settings have not been set up");
            case 2:
              l = this.preprocessBody(this.rawBody, o), d = this.stream, d && (St(d) != "object" || !d.simulation) || l.stream ? (l.stream = !0, Da.request(this, l, i)) : ha.request(this, l, i);
            case 4:
            case "end":
              return u.stop();
          }
        }, r, this);
      }));
      function n(r, i) {
        return s.apply(this, arguments);
      }
      return n;
    }()
  }, {
    key: "extractResultData",
    value: function() {
      var s = Qe(/* @__PURE__ */ ce().mark(function r(i) {
        var o, l, d, c, u;
        return ce().wrap(function(f) {
          for (; ; ) switch (f.prev = f.next) {
            case 0:
              if (!i.error) {
                f.next = 2;
                break;
              }
              throw i.error.message || "Gemini API Error";
            case 2:
              return f.abrupt("return", (u = (c = (d = (l = (o = i.candidates) == null ? void 0 : o[0]) == null ? void 0 : l.content) == null ? void 0 : d.parts) == null ? void 0 : c[0]) != null && u.text ? {
                text: i.candidates[0].content.parts[0].text
              } : {
                text: ""
              });
            case 3:
            case "end":
              return f.stop();
          }
        }, r);
      }));
      function n(r) {
        return s.apply(this, arguments);
      }
      return n;
    }()
  }], [{
    key: "getContent",
    value: function(n) {
      var r = [];
      return n.text && n.text.trim().length > 0 && r.push({
        text: n.text
      }), n.files && n.files.length > 0 && n.files.forEach(function(i) {
        if (i.src && i.src.includes("data:")) {
          var o = i.src.split(","), l = dl(o, 2), d = l[0], c = l[1];
          r.push({
            inlineData: {
              mimeType: d.replace("data:", "").replace(";base64", ""),
              data: c
            }
          });
        }
      }), {
        parts: r,
        role: n.role === Ft.USER_ROLE ? "user" : "model"
      };
    }
  }]);
}(tn), kHe = /* @__PURE__ */ function() {
  function e() {
    je(this, e);
  }
  return He(e, null, [{
    key: "create",
    value: (
      // this should only be called when no _activeService is set or is demo as otherwise we don't want to reconnect
      function(s) {
        var n = s.directConnection, r = s.connect, i = s.demo, o = s.webModel;
        if (o) return new Mb(s);
        if (n) {
          if (n.openAI) return n.openAI.images ? new wHe(s) : n.openAI.speechToText ? new hHe(s) : n.openAI.textToSpeech ? new pHe(s) : n.openAI.assistant ? new iHe(s) : n.openAI.realtime ? new uHe(s) : new V5(s);
          if (n.assemblyAI) return new gHe(s);
          if (n.cohere) return n.cohere.textGeneration ? new lHe(s) : n.cohere.summarization ? new cHe(s) : new CHe(s);
          if (n.huggingFace) return n.huggingFace.textGeneration ? new _je(s) : n.huggingFace.summarization ? new tHe(s) : n.huggingFace.translation ? new nHe(s) : n.huggingFace.fillMask ? new oHe(s) : n.huggingFace.questionAnswer ? new eHe(s) : n.huggingFace.audioSpeechRecognition ? new $je(s) : n.huggingFace.audioClassification ? new Qje(s) : n.huggingFace.imageClassification ? new Kje(s) : new sHe(s);
          if (n.azure) {
            if (n.azure.openAI) {
              if (n.azure.openAI.chat) return new AHe(s);
              if (n.azure.openAI.assistant) return new dHe(s);
            }
            if (n.azure.speechToText) return new yHe(s);
            if (n.azure.textToSpeech) return new vHe(s);
            if (n.azure.summarization) return new fHe(s);
            if (n.azure.translation) return new bHe(s);
          }
          if (n.stabilityAI) return n.stabilityAI.imageToImage ? new aHe(s) : n.stabilityAI.imageToImageUpscale ? new Zje(s) : n.stabilityAI.imageToImageMasking ? new Jje(s) : new rHe(s);
          if (n.mistral) return new SHe(s);
          if (n.gemini) return new PHe(s);
        }
        return r && Object.keys(r).length > 0 && !i ? new Cm(s) : new Cm(s, void 0, i || !0);
      }
    )
  }]);
}(), D5 = /* @__PURE__ */ He(function e() {
  je(this, e);
});
D5.attibutes = {
  string: function(t) {
    return t;
  },
  number: function(t) {
    return parseFloat(t);
  },
  boolean: function(t) {
    return t === "true";
  },
  object: function(t) {
    return JSON.parse(t);
  },
  array: function(t) {
    return JSON.parse(t);
  },
  function: function(t) {
    return new Function("return ".concat(t))();
  }
};
var EHe = D5;
function rs(e) {
  return function(t, s) {
    Object.defineProperty(t, s, {});
    var n = t.constructor, r = s.toLocaleLowerCase();
    n._attributes_[r] = EHe.attibutes[e], n._attributeToProperty_[r] = s;
  };
}
var IHe = /* @__PURE__ */ function() {
  function e(t, s, n) {
    je(this, e), this._isDisplayed = !1, t ? (this._elementRef = this.createIntroPanelWithChild(t, n), this._isDisplayed = !0) : s && (this._elementRef = this.createInternalIntroPanel(s, n), this._isDisplayed = !0);
  }
  return He(e, [{
    key: "createIntroPanelWithChild",
    value: function(s, n) {
      var r = e.createIntroPanel(n);
      return s.style.display === "none" && (s.style.display = "block"), r.appendChild(s), r;
    }
  }, {
    key: "createInternalIntroPanel",
    value: function(s, n) {
      var r = e.createIntroPanel(n);
      return r.id = "internal-intro-panel", r.innerHTML = s, r;
    }
  }, {
    key: "hide",
    value: function() {
      this._isDisplayed && this._elementRef && (this._elementRef.style.display = "none", this._isDisplayed = !1);
    }
  }, {
    key: "display",
    value: function() {
      !this._isDisplayed && this._elementRef && (this._elementRef.style.display = "", this._isDisplayed = !0);
    }
  }], [{
    key: "createIntroPanel",
    value: function(s) {
      var n = document.createElement("div");
      return n.classList.add("intro-panel"), Object.assign(n.style, s), n;
    }
  }]);
}(), THe = `<?xml version="1.0" encoding="iso-8859-1"?>
<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" 
	 viewBox="50 30 420 450" xml:space="preserve">
<g filter="brightness(0) saturate(100%) invert(16%) sepia(0%) saturate(1942%) hue-rotate(215deg) brightness(99%) contrast(93%)">
	<g>
		<path d="M447.933,103.629c-0.034-3.076-1.224-6.09-3.485-8.352L352.683,3.511c-0.004-0.004-0.007-0.005-0.011-0.008
			C350.505,1.338,347.511,0,344.206,0H89.278C75.361,0,64.04,11.32,64.04,25.237v461.525c0,13.916,11.32,25.237,25.237,25.237
			h333.444c13.916,0,25.237-11.32,25.237-25.237V103.753C447.96,103.709,447.937,103.672,447.933,103.629z M356.194,40.931
			l50.834,50.834h-49.572c-0.695,0-1.262-0.567-1.262-1.262V40.931z M423.983,486.763c0,0.695-0.566,1.261-1.261,1.261H89.278
			c-0.695,0-1.261-0.566-1.261-1.261V25.237c0-0.695,0.566-1.261,1.261-1.261h242.94v66.527c0,13.916,11.322,25.239,25.239,25.239
			h66.527V486.763z"/>
	</g>
</g>
<g>
	<g>
		<path d="M362.088,164.014H149.912c-6.62,0-11.988,5.367-11.988,11.988c0,6.62,5.368,11.988,11.988,11.988h212.175
			c6.62,0,11.988-5.368,11.988-11.988C374.076,169.381,368.707,164.014,362.088,164.014z"/>
	</g>
</g>
<g>
	<g>
		<path d="M362.088,236.353H149.912c-6.62,0-11.988,5.368-11.988,11.988c0,6.62,5.368,11.988,11.988,11.988h212.175
			c6.62,0,11.988-5.368,11.988-11.988C374.076,241.721,368.707,236.353,362.088,236.353z"/>
	</g>
</g>
<g>
	<g>
		<path d="M362.088,308.691H149.912c-6.62,0-11.988,5.368-11.988,11.988c0,6.621,5.368,11.988,11.988,11.988h212.175
			c6.62,0,11.988-5.367,11.988-11.988C374.076,314.06,368.707,308.691,362.088,308.691z"/>
	</g>
</g>
<g>
	<g>
		<path d="M256,381.031H149.912c-6.62,0-11.988,5.368-11.988,11.988c0,6.621,5.368,11.988,11.988,11.988H256
			c6.62,0,11.988-5.367,11.988-11.988C267.988,386.398,262.62,381.031,256,381.031z"/>
	</g>
</g>
</svg>`, xh = /* @__PURE__ */ function() {
  function e() {
    je(this, e);
  }
  return He(e, null, [{
    key: "createImage",
    value: function(s, n, r) {
      var i = new Image();
      return i.src = s.src, r && cn.scrollDownOnImageLoad(i.src, n), cn.processContent("image", i, i.src, s.name);
    }
    // WORK - image still does not scroll down when loaded
  }, {
    key: "createImageMessage",
    value: function(s, n, r, i) {
      var o = e.createImage(n, s.elementRef, !i && !s.focusMode), l = s.createNewMessageElement("", r);
      return l.bubbleElement.appendChild(o), l.bubbleElement.classList.add(e.IMAGE_BUBBLE_CLASS), {
        type: "image",
        elements: l
      };
    }
  }, {
    key: "createAudioElement",
    value: function(s, n) {
      var r = document.createElement("audio");
      return r.src = s.src, r.classList.add("audio-player"), r.controls = !0, el.IS_SAFARI && (r.classList.add("audio-player-safari"), r.classList.add(n === Ft.USER_ROLE ? "audio-player-safari-right" : "audio-player-safari-left")), r;
    }
  }, {
    key: "createNewAudioMessage",
    value: function(s, n, r, i) {
      var o = e.createAudioElement(n, r), l = s.createMessageElementsOnOrientation("", r, i);
      return l.bubbleElement.appendChild(o), l.bubbleElement.classList.add(e.AUDIO_BUBBLE_CLASS), {
        type: "audio",
        elements: l
      };
    }
  }, {
    key: "createAnyFile",
    value: function(s) {
      var n = document.createElement("div");
      n.classList.add("any-file-message-contents");
      var r = document.createElement("div");
      r.classList.add("any-file-message-icon-container");
      var i = Ro.createSVGElement(THe);
      i.classList.add("any-file-message-icon"), r.appendChild(i);
      var o = document.createElement("div");
      return o.classList.add("any-file-message-text"), o.textContent = s.name || cn.DEFAULT_FILE_NAME, n.appendChild(r), n.appendChild(o), cn.processContent("any", n, s.src, o.textContent);
    }
  }, {
    key: "createNewAnyFileMessage",
    value: function(s, n, r, i) {
      var o = s.createMessageElementsOnOrientation("", r, i), l = e.createAnyFile(n);
      return o.bubbleElement.classList.add(e.ANY_FILE_BUBBLE_CLASS), o.bubbleElement.appendChild(l), {
        type: "file",
        elements: o
      };
    }
  }, {
    key: "createMessages",
    value: function(s, n, r) {
      var i = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1;
      return n.map(function(o) {
        return o.ref && (o = cn.removeFileRef(o)), cn.isAudioFile(o) ? e.createNewAudioMessage(s, o, r, i) : cn.isImageFile(o) ? e.createImageMessage(s, o, r, i) : e.createNewAnyFileMessage(s, o, r, i);
      });
    }
    // no overwrite previous message logic as it is complex to track which files are to be overwritten
  }, {
    key: "addMessages",
    value: function(s, n, r, i) {
      e.createMessages(s, n, r, i).forEach(function(o) {
        var l = o.type, d = o.elements;
        cn.addMessage(s, d, l, r, i);
      });
    }
  }]);
}();
xh.IMAGE_BUBBLE_CLASS = "image-message", xh.AUDIO_BUBBLE_CLASS = "audio-message", xh.ANY_FILE_BUBBLE_CLASS = "any-file-message";
var N5 = xh, OHe = /* @__PURE__ */ function() {
  function e() {
    je(this, e);
  }
  return He(e, null, [{
    key: "removeElements",
    value: function(s, n) {
      if (n) {
        var r = s.findIndex(function(i) {
          return i === n;
        });
        s.splice(r, 1), n == null || n.outerContainer.remove();
      }
    }
  }, {
    key: "removeFilesMessages",
    value: function(s, n) {
      var r;
      (r = n[1].files) == null || r.forEach(function(i) {
        e.removeElements(s.messageElementRefs, i);
      }), delete n[0].files, delete n[1].files;
    }
  }, {
    key: "removeTextHTMLMessage",
    value: function(s, n, r) {
      var i = n[1][r];
      e.removeElements(s.messageElementRefs, i), delete n[0][r], delete n[1][r];
    }
  }, {
    key: "updateHTMLMessage",
    value: function(s, n, r) {
      var i, o, l;
      if (n[1].html) mi.overwriteElements(s, r, n[1].html);
      else {
        var d = mi.create(s, r, n[0].role), c = ((o = n[1].files) == null ? void 0 : o[((i = n[1].files) == null ? void 0 : i.length) - 1]) || n[1].text, u = c.outerContainer.nextSibling;
        (l = u == null ? void 0 : u.parentElement) == null || l.insertBefore(d.outerContainer, u), s.messageElementRefs.splice(s.messageElementRefs.length - 1, 1);
        var m = s.messageElementRefs.findIndex(function(f) {
          return f === c;
        });
        s.messageElementRefs.splice(m + 1, 0, d), n[1].html = d;
      }
      n[0].html = r;
    }
    // finds beforeElement, creates new elements, remove old and adds new ones
  }, {
    key: "updateFileMessages",
    value: function(s, n, r) {
      var i, o, l = n[0].role, d = N5.createMessages(s, r, l), c = n[1].html, u = ((o = n[1].files) == null ? void 0 : o[((i = n[1].files) == null ? void 0 : i.length) - 1]) || n[1].text, m = c || u, f = s.messageElementRefs.findIndex(function(b) {
        return b === m;
      });
      u && (f += 1);
      var v = (c == null ? void 0 : c.outerContainer) || (u == null ? void 0 : u.outerContainer.nextSibling);
      d.forEach(function(b, w) {
        var S = b.type, I = b.elements, T;
        cn.setElementProps(s, I, S, l), (T = v.parentElement) == null || T.insertBefore(I.outerContainer, v), s.messageElementRefs.splice(s.messageElementRefs.length - 1, 1), s.messageElementRefs.splice(f + w, 0, I);
      }), e.removeFilesMessages(s, n), n[1].files = d.map(function(b) {
        var w = b.elements;
        return w;
      }), n[0].files = r;
    }
  }, {
    key: "updateTextMessage",
    value: function(s, n, r) {
      var i, o;
      if (n[1].text) s.renderText(n[1].text.bubbleElement, r);
      else {
        var l = s.createElements(r, n[0].role), d = ((i = n[1].files) == null ? void 0 : i[0]) || n[1].html;
        (o = d.outerContainer.parentElement) == null || o.insertBefore(l.outerContainer, d.outerContainer);
        var c = s.messageElementRefs.findIndex(function(u) {
          return u === d;
        });
        s.messageElementRefs.splice(c, 0, l), n[1].text = l;
      }
      n[0].text = r;
    }
  }, {
    key: "isElementActive",
    value: function(s) {
      var n, r;
      return Vy.isActiveElement((n = s.text) == null ? void 0 : n.bubbleElement.classList) || Vy.isActiveElement((r = s.html) == null ? void 0 : r.bubbleElement.classList);
    }
    // note that overwrite and 'deep-chat-temporary-message' are used to remove a message
  }, {
    key: "update",
    value: function(s, n, r) {
      var i = s.messageToElements[r];
      if (i) {
        if (e.isElementActive(i[1])) return console.error("Cannot update a message that is being streamed");
        n.text && e.updateTextMessage(s, i, n.text), n.files ? e.updateFileMessages(s, i, n.files) : e.removeFilesMessages(s, i), n.html && e.updateHTMLMessage(s, i, n.html), !n.text && i[1].text && e.removeTextHTMLMessage(s, i, "text"), !n.html && i[1].html && e.removeTextHTMLMessage(s, i, "html");
        var o = s.messageElementRefs, l = s.avatar, d = s.name;
        Ft.classifyRoleMessages(o), Ft.resetAllRoleElements(o, l, d);
      } else console.error("Message index not found. Please use the `getMessages` method to find the correct index");
    }
  }]);
}(), RHe = /* @__PURE__ */ function() {
  function e() {
    je(this, e);
  }
  return He(e, null, [{
    key: "getText",
    value: function(s, n) {
      var r;
      if (!s.directConnection && !s.connect && !s.webModel && !s.demo) return `Connect to any API using the [connect](https://deepchat.dev/docs/connect#connect-1) property or a popular service via [directConnection](https://deepchat.dev/docs/directConnection/#directConnection).
 Host AI entirely on your browser via a [webModel](https://deepchat.dev/docs/webModel).
 To get started checkout the [Start](https://deepchat.dev/start) page and live code [examples](https://deepchat.dev/examples/frameworks).
 To remove this message set the [demo](https://deepchat.dev/docs/modes#demo) property to true.`;
      if (s.directConnection) {
        if (!n.isDirectConnection()) return `Please define a valid service inside
          the [directConnection](https://deepchat.dev/docs/directConnection/#directConnection) object.`;
        var i = (r = s.directConnection.openAI) == null ? void 0 : r.chat;
        if (St(i) == "object" && i.tools && !i.function_handler) return "Please define the `function_handler` property inside the openAI [chat](https://deepchat.dev/docs/directConnection/openAI#Chat) object.";
      } else if (s.connect && !s.connect.url && !s.connect.handler) return "Please define a `url` or a `handler` property inside the [connect](https://deepchat.dev/docs/connect#connect-1) object.";
      return null;
    }
  }]);
}(), Vy = /* @__PURE__ */ function(e) {
  function t(s, n, r) {
    var i;
    je(this, t);
    var o, l;
    i = jt(this, t, [s]);
    var d = n.permittedErrorPrefixes, c = n.introPanelMarkUp, u = n.demo;
    return i._errorMessageOverrides = (o = s.errorMessages) == null ? void 0 : o.overrides, i._onClearMessages = Pu.onClearMessages.bind(i, s), i._onError = Pu.onError.bind(i, s), i._isLoadingMessageAllowed = t.getDefaultDisplayLoadingMessage(s, n), St(s.displayLoadingBubble) == "object" && s.displayLoadingBubble.toggle && (s.displayLoadingBubble.toggle = i.setLoadingToggle.bind(i)), i._permittedErrorPrefixes = d, i.addSetupMessageIfNeeded(s, n) || i.populateIntroPanel(r, c, s.introPanelStyle), u && i.prepareDemo(xn.processDemo(u), s.loadHistory), i.addIntroductoryMessages(s, n), new Bb(s, i, n), i._displayServiceErrorMessages = (l = s.errorMessages) == null ? void 0 : l.displayServiceErrorMessages, s.getMessages = function() {
      return Ft.deepCloneMessagesWithReferences(i.messageToElements.map(function(m) {
        var f = dl(m, 1), v = f[0];
        return v;
      }));
    }, s.clearMessages = i.clearMessages.bind(i, n), s.refreshMessages = i.refreshTextMessages.bind(i, s.remarkable), s.scrollToBottom = Ln.scrollToBottom.bind(i, i.elementRef), s.addMessage = function(m, f) {
      i.addAnyMessage(ys(ys({}, m), {}, {
        sendUpdate: !!f
      }), !f);
    }, s.updateMessage = function(m, f) {
      return OHe.update(i, m, f);
    }, n.isWebModel() && n.setUpMessages(i), s.textToSpeech && Eh.processConfig(s.textToSpeech, function(m) {
      i.textToSpeech = m;
    }), i;
  }
  return Ht(t, e), He(t, [{
    key: "setLoadingToggle",
    value: function() {
      var n = this.messageElementRefs[this.messageElementRefs.length - 1];
      Vr.isLoadingMessage(n) ? this.removeLastMessage() : this.addLoadingMessage(!0);
    }
  }, {
    key: "prepareDemo",
    value: function(n, r) {
      var i;
      if (St(n) == "object") {
        if (!r && n.displayLoading) {
          var o = n.displayLoading.history;
          o != null && o.small && tl.addMessage(this, !1), o != null && o.full && tl.addMessage(this);
        }
        n.displayErrors && (n.displayErrors.default && this.addNewErrorMessage("", ""), n.displayErrors.service && this.addNewErrorMessage("service", ""), n.displayErrors.speechToText && this.addNewErrorMessage("speechToText", "")), (i = n.displayLoading) != null && i.message && this.addLoadingMessage(), n.response && (this.customDemoResponse = n.response);
      }
    }
  }, {
    key: "addSetupMessageIfNeeded",
    value: function(n, r) {
      var i = RHe.getText(n, r);
      if (i) {
        var o = this.createAndAppendNewMessageElement(i, Ft.AI_ROLE);
        this.applyCustomStyles(o, Ft.AI_ROLE, !1);
      }
      return !!i;
    }
    // WORK - const file for deep chat classes
  }, {
    key: "addIntroductoryMessages",
    value: function(n, r) {
      var i = this;
      n != null && n.shadowRoot && (this._introMessage = n.introMessage);
      var o = this._introMessage;
      r != null && r.isWebModel() && (o ?? (o = r.getIntroMessage(o)));
      var l = !(n != null && n.history) && !!(n != null && n.loadHistory || r != null && r.fetchHistory);
      o && (Array.isArray(o) ? o.forEach(function(d, c) {
        if (c !== 0) {
          var u = i.messageElementRefs[i.messageElementRefs.length - 1].innerContainer;
          Ft.hideRoleElements(u, i.avatar, i.name);
        }
        i.addIntroductoryMessage(d, l);
      }) : this.addIntroductoryMessage(o, l));
    }
  }, {
    key: "addIntroductoryMessage",
    value: function(n, r) {
      var i, o;
      return n != null && n.text ? o = this.createAndAppendNewMessageElement(n.text, Ft.AI_ROLE) : n != null && n.html && (o = mi.add(this, n.html, Ft.AI_ROLE)), o && (this.applyCustomStyles(o, Ft.AI_ROLE, !1, (i = this.messageStyles) == null ? void 0 : i.intro), o.outerContainer.classList.add(Vr.INTRO_CLASS), r && (o.outerContainer.style.display = "none")), o;
    }
  }, {
    key: "removeIntroductoryMessage",
    value: function() {
      var n = this.messageElementRefs[0];
      n.outerContainer.classList.contains(Vr.INTRO_CLASS) && (n.outerContainer.remove(), this.messageElementRefs.shift());
    }
  }, {
    key: "addAnyMessage",
    value: function(n) {
      var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
      return n.error ? this.addNewErrorMessage("service", n.error, i) : this.addNewMessage(n, r, i);
    }
  }, {
    key: "tryAddTextMessage",
    value: function(n, r, i) {
      var o = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1, l = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !1;
      !i.ignoreText && n.text !== void 0 && i.text !== null && (this.addNewTextMessage(n.text, n.role, r, l), !o && this.textToSpeech && n.role !== Ft.USER_ROLE && Eh.speak(n.text, this.textToSpeech));
    }
  }, {
    key: "tryAddFileMessages",
    value: function(n) {
      var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
      n.files && Array.isArray(n.files) && N5.addMessages(this, n.files, n.role, r);
    }
  }, {
    key: "tryAddHTMLMessage",
    value: function(n, r) {
      var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
      if (n.html !== void 0 && n.html !== null) {
        var o = mi.add(this, n.html, n.role, r, i);
        !i && ld.isElementTemporary(o) && delete n.html;
      }
    }
    // this should not be activated by streamed messages
  }, {
    key: "addNewMessage",
    value: function(n) {
      var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, o, l;
      n.role !== Ft.USER_ROLE && ((o = this._hiddenAttachments) == null || o.removeHiddenFiles());
      var d = t.createMessageContent(n), c = {
        status: n.overwrite
      };
      return i ? (this.tryAddHTMLMessage(d, c, i), this.tryAddFileMessages(d, i), this.tryAddTextMessage(d, c, n, r, i)) : (this.tryAddTextMessage(d, c, n, r, i), this.tryAddFileMessages(d, i), this.tryAddHTMLMessage(d, c, i)), this.isValidMessageContent(d) && !i && (this.updateStateOnMessage(d, n.overwrite, n.sendUpdate, r), r || (l = this.browserStorage) == null || l.addMessages(this.messageToElements.map(function(u) {
        var m = dl(u, 1), f = m[0];
        return f;
      }))), d;
    }
  }, {
    key: "isValidMessageContent",
    value: function(n) {
      return n.text || n.html || n.files && n.files.length > 0;
    }
  }, {
    key: "updateStateOnMessage",
    value: function(n, r) {
      var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0, o = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1;
      if (!r) {
        var l = Ft.generateMessageBody(n, this.messageElementRefs);
        this.messageToElements.push([n, l]);
      }
      i && this.sendClientUpdate(n, o);
    }
    // prettier-ignore
  }, {
    key: "removeMessageOnError",
    value: function() {
      var n = this.messageElementRefs[this.messageElementRefs.length - 1], r = n == null ? void 0 : n.bubbleElement;
      (r != null && r.classList.contains(fi.MESSAGE_CLASS) && r.textContent === "" || t.isTemporaryElement(n)) && this.removeLastMessage();
    }
    // prettier-ignore
  }, {
    key: "addNewErrorMessage",
    value: function(n, r) {
      var i = this, o = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, l, d, c, u, m, f;
      (l = this._hiddenAttachments) == null || l.readdHiddenFiles(), this.removeMessageOnError();
      var v = this.getPermittedMessage(r) || ((d = this._errorMessageOverrides) == null ? void 0 : d[n]) || ((c = this._errorMessageOverrides) == null ? void 0 : c.default) || "Error, please try again.", b = this.createMessageElementsOnOrientation(v, "error", o);
      Ft.hideRoleElements(b.innerContainer, this.avatar, this.name);
      var w = b.bubbleElement, S = b.outerContainer;
      w.classList.add(Ft.ERROR_MESSAGE_TEXT_CLASS), this.renderText(w, v);
      var I = Ih.extractParticularSharedStyles(["fontSize", "fontFamily"], (u = this.messageStyles) == null ? void 0 : u.default);
      Ih.applyCustomStylesToElements(b, !1, I), Ih.applyCustomStylesToElements(b, !1, (m = this.messageStyles) == null ? void 0 : m.error), o || this.appendOuterContainerElemet(S), this.textToSpeech && Eh.speak(v, this.textToSpeech), (f = this._onError) == null || f.call(this, v), setTimeout(function() {
        return Ln.scrollToBottom(i.elementRef);
      });
    }
  }, {
    key: "getPermittedMessage",
    value: function(n) {
      if (n)
        for (var r = t.extractErrorMessages(n), i = 0; i < r.length; i += 1) {
          var o = r[i];
          if (typeof o == "string") {
            if (this._displayServiceErrorMessages) return o;
            if (this._permittedErrorPrefixes) {
              var l = t.checkPermittedErrorPrefixes(this._permittedErrorPrefixes, o);
              if (l) return l;
            }
          }
        }
    }
  }, {
    key: "removeError",
    value: function() {
      this.isLastMessageError() && Ft.getLastMessageElement(this.elementRef).remove();
    }
  }, {
    key: "addDefaultLoadingMessage",
    value: function() {
      var n = this.createMessageElements("", Ft.AI_ROLE), r = n.bubbleElement;
      n.bubbleElement.classList.add(qi.DOTS_CONTAINER_CLASS);
      var i = document.createElement("div");
      return i.classList.add("loading-message-dots"), r.appendChild(i), qi.setDots(r, this.messageStyles), n;
    }
  }, {
    key: "addLoadingMessage",
    value: function() {
      var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1, r, i, o, l, d, c, u = this.messageElementRefs[this.messageElementRefs.length - 1];
      if (!(Vr.isLoadingMessage(u) || !n && !this._isLoadingMessageAllowed)) {
        var m = (o = (i = (r = this.messageStyles) == null ? void 0 : r.loading) == null ? void 0 : i.message) == null ? void 0 : o.html, f = m ? mi.createElements(this, m, Ft.AI_ROLE, !1) : this.addDefaultLoadingMessage();
        this.appendOuterContainerElemet(f.outerContainer), f.bubbleElement.classList.add(qi.BUBBLE_CLASS), this.applyCustomStyles(f, Ft.AI_ROLE, !1, (c = (d = (l = this.messageStyles) == null ? void 0 : l.loading) == null ? void 0 : d.message) == null ? void 0 : c.styles), this.focusMode || Ln.scrollToBottom(this.elementRef);
      }
    }
  }, {
    key: "populateIntroPanel",
    value: function(n, r, i) {
      (n || r) && (this._introPanel = new IHe(n, r, i), this._introPanel._elementRef && (Oo.apply(this, this._introPanel._elementRef), this.elementRef.appendChild(this._introPanel._elementRef)));
    }
  }, {
    key: "addMultipleFiles",
    value: function() {
      var s = Qe(/* @__PURE__ */ ce().mark(function r(i, o) {
        return ce().wrap(function(d) {
          for (; ; ) switch (d.prev = d.next) {
            case 0:
              return d.abrupt("return", (this._hiddenAttachments = o, Promise.all((i || []).map(function(c) {
                return new Promise(function(u) {
                  if (!c.type || c.type === "any") {
                    var m = c.file.name || cn.DEFAULT_FILE_NAME;
                    u({
                      name: m,
                      type: "any",
                      ref: c.file
                    });
                  } else {
                    var f = new FileReader();
                    f.readAsDataURL(c.file), f.onload = function() {
                      u({
                        src: f.result,
                        type: c.type,
                        ref: c.file
                      });
                    };
                  }
                });
              }))));
            case 1:
            case "end":
              return d.stop();
          }
        }, r, this);
      }));
      function n(r, i) {
        return s.apply(this, arguments);
      }
      return n;
    }()
  }, {
    key: "clearMessages",
    value: (
      // WORK - update all message classes to use deep-chat prefix
      function(n, r) {
        var i, o, l, d, c = [];
        this.messageElementRefs.forEach(function(m) {
          t.isActiveElement(m.bubbleElement.classList) ? c.push(m) : m.outerContainer.remove();
        }), Array.from(this.elementRef.children).forEach(function(m) {
          var f, v = (f = m.children[0]) == null ? void 0 : f.children[0];
          v != null && v.classList.contains(Ft.ERROR_MESSAGE_TEXT_CLASS) && m.remove();
        }), this.messageElementRefs = c;
        var u = this.messageToElements.filter(function(m) {
          return m[1].text && t.isActiveElement(m[1].text.bubbleElement.classList) || m[1].html && t.isActiveElement(m[1].html.bubbleElement.classList);
        });
        (i = this.messageToElements).splice.apply(i, [0, this.messageToElements.length].concat(Qu(u))), r !== !1 && ((o = this._introPanel) != null && o._elementRef && this._introPanel.display(), this.addIntroductoryMessages()), (l = this.browserStorage) == null || l.clear(), (d = this._onClearMessages) == null || d.call(this), delete n.sessionId;
      }
    )
  }], [{
    key: "getDefaultDisplayLoadingMessage",
    value: function(n, r) {
      var i;
      return r.websocket ? !!n.displayLoadingBubble : (i = St(n.displayLoadingBubble) == "object" || n.displayLoadingBubble) !== null && i !== void 0 ? i : !0;
    }
  }, {
    key: "checkPermittedErrorPrefixes",
    value: function(n, r) {
      for (var i = 0; i < n.length; i += 1) if (r.startsWith(n[i])) return r;
    }
  }, {
    key: "extractErrorMessages",
    value: function(n) {
      return Array.isArray(n) ? n : n instanceof Error ? [n.message] : typeof n == "string" ? [n] : St(n) == "object" && n.error ? [n.error] : [];
    }
  }, {
    key: "isActiveElement",
    value: function(n) {
      return n ? n.contains(qi.BUBBLE_CLASS) || n.contains(tl.CLASS) || n.contains(fi.MESSAGE_CLASS) : !1;
    }
  }]);
}(Vr), Uc = /* @__PURE__ */ function() {
  function e() {
    je(this, e);
  }
  return He(e, null, [{
    key: "adjustInputPadding",
    value: function(s, n) {
      n["inside-left"].length > 0 && s.classList.add("text-input-inner-left-adjustment"), n["inside-right"].length > 0 && s.classList.add("text-input-inner-right-adjustment");
    }
  }, {
    key: "adjustForOutsideButton",
    value: function(s, n, r) {
      r["outside-right"].length === 0 && r["outside-left"].length > 0 ? (s[0].classList.add(e.INPUT_OUTSIDE_LEFT_SMALL_ADJUSTMENT_CLASS), n.classList.add(e.INPUT_OUTSIDE_LEFT_SMALL_ADJUSTMENT_CLASS)) : r["outside-left"].length === 0 && r["outside-right"].length > 0 && (s[3].classList.add(e.INPUT_OUTSIDE_RIGHT_SMALL_ADJUSTMENT_CLASS), n.classList.add(e.INPUT_OUTSIDE_RIGHT_SMALL_ADJUSTMENT_CLASS));
    }
    // when submit is the only button
    // when submit button is outside by itself - we increase the height for a better look
  }, {
    key: "adjustOutsideSubmit",
    value: function(s, n, r) {
      if (!(r["inside-left"].length > 0 || r["inside-right"].length > 0)) {
        if (r["outside-right"].length === 0 && r["outside-left"].length > 0) return s[0].classList.add(e.INPUT_OUTSIDE_LEFT_ADJUSTMENT_CLASS), n.classList.add(e.INPUT_OUTSIDE_LEFT_ADJUSTMENT_CLASS), r["outside-left"].map(function(i) {
          return i.button.elementRef.classList.add("submit-button-enlarged");
        });
        if (r["outside-left"].length === 0 && r["outside-right"].length > 0) return s[3].classList.add(e.INPUT_OUTSIDE_RIGHT_ADJUSTMENT_CLASS), n.classList.add(e.INPUT_OUTSIDE_RIGHT_ADJUSTMENT_CLASS), r["outside-right"].map(function(i) {
          return i.button.elementRef.classList.add("submit-button-enlarged");
        });
      }
    }
    // prettier-ignore
  }, {
    key: "set",
    value: function(s, n, r, i) {
      e.adjustOutsideSubmit(n, r, i) || e.adjustForOutsideButton(n, r, i), e.adjustInputPadding(s, i);
    }
  }]);
}();
Uc.INPUT_OUTSIDE_LEFT_ADJUSTMENT_CLASS = "text-input-container-left-adjustment", Uc.INPUT_OUTSIDE_RIGHT_ADJUSTMENT_CLASS = "text-input-container-right-adjustment", Uc.INPUT_OUTSIDE_LEFT_SMALL_ADJUSTMENT_CLASS = "text-input-container-left-small-adjustment", Uc.INPUT_OUTSIDE_RIGHT_SMALL_ADJUSTMENT_CLASS = "text-input-container-right-small-adjustment";
var LHe = Uc, Sm = /* @__PURE__ */ function() {
  function e() {
    je(this, e);
  }
  return He(e, null, [{
    key: "create",
    value: function() {
      return Array.from({
        length: 4
      }).map(function(s, n) {
        var r = document.createElement("div");
        return r.classList.add("input-button-container"), (n === 0 || n === 3) && r.classList.add("outer-button-container"), (n === 1 || n === 2) && r.classList.add("inner-button-container"), r;
      });
    }
  }, {
    key: "add",
    value: function(s, n) {
      s.insertBefore(n[1], s.firstChild), s.insertBefore(n[0], s.firstChild), s.appendChild(n[2]), s.appendChild(n[3]);
    }
  }, {
    key: "getContainerIndex",
    value: function(s) {
      return s === "outside-left" ? 0 : s === "inside-left" ? 1 : s === "inside-right" ? 2 : 3;
    }
  }, {
    key: "addButton",
    value: function(s, n, r) {
      n.classList.add(r);
      var i = e.getContainerIndex(r);
      s[i].appendChild(n), i === 3 && n.classList.add("outside-right");
    }
  }]);
}(), hC = ["camera", "gifs", "images", "audio", "mixedFiles", "submit", "microphone"], BHe = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22" fill="none">
  <rect x="2.5" y="2.5" width="17" height="17" rx="2" stroke="#000000" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`, Fh = /* @__PURE__ */ function() {
  function e() {
    je(this, e);
  }
  return He(e, null, [{
    key: "addItemEvents",
    value: function(s, n, r, i) {
      Ib.add(n, i), n.addEventListener("click", function() {
        r.click();
      }), n.addEventListener("mouseenter", function(o) {
        s.highlightedItem = o.target;
      }), n.addEventListener("mouseleave", function() {
        s.highlightedItem = void 0;
      });
    }
  }, {
    key: "createItemText",
    value: function(s, n) {
      var r = document.createElement("div");
      return Object.assign(r.style, n), r.classList.add(e.TEXT_CLASS), r.textContent = s || "File", r;
    }
  }, {
    key: "createItemIcon",
    value: function(s, n) {
      var r = document.createElement("div");
      return Object.assign(r.style, n), r.classList.add(e.ICON_CLASS), r.appendChild(s), r;
    }
  }, {
    key: "populateItem",
    value: function(s, n, r) {
      var i = s.elementRef, o = s.dropupText, l = s.svg, d = s.customStyles, c = i.children[0], u = d && Object.values(d).find(function(m) {
        var f;
        return ((f = m.svg) == null ? void 0 : f.content) === "";
      });
      c.classList.contains(gi.INPUT_BUTTON_INNER_TEXT_CLASS) ? (u || n.appendChild(e.createItemIcon(l, r == null ? void 0 : r.iconContainer)), n.appendChild(e.createItemText(c.textContent, r == null ? void 0 : r.text))) : (u || n.appendChild(e.createItemIcon(i.children[0], r == null ? void 0 : r.iconContainer)), n.appendChild(e.createItemText(o, r == null ? void 0 : r.text)));
    }
  }, {
    key: "createItem",
    value: function(s, n, r) {
      var i, o = document.createElement("div");
      Object.assign(o.style, (i = r == null ? void 0 : r.item) == null ? void 0 : i.default), e.populateItem(n, o, r), o.classList.add(e.MENU_ITEM_CLASS);
      var l = n.elementRef;
      if (n.isCustom) n.setDropupItem(o);
      else {
        var d = za.processStateful((r == null ? void 0 : r.item) || {});
        e.addItemEvents(s, o, l, d);
      }
      return o;
    }
  }]);
}();
Fh.MENU_ITEM_CLASS = "dropup-menu-item", Fh.TEXT_CLASS = "dropup-menu-item-text", Fh.ICON_CLASS = "dropup-menu-item-icon";
var _o = Fh, Yl = /* @__PURE__ */ function(e) {
  function t(s, n, r, i) {
    var o;
    je(this, t);
    var l, d, c, u, m, f, v = ((u = (c = (d = (l = s == null ? void 0 : s.styles) == null ? void 0 : l.button) == null ? void 0 : d.default) == null ? void 0 : c.text) == null ? void 0 : u.content) || "Custom ".concat(n), b = BHe, w = Ho.tryCreateConfig("Custom ".concat(n), s == null ? void 0 : s.tooltip);
    return o = jt(this, t, [t.createButtonElement(), b, s == null ? void 0 : s.position, w, ((m = s == null ? void 0 : s.styles) == null ? void 0 : m.button) || w && {}, v]), o._state = "default", o.isCustom = !0, o._innerElements = o.createInnerElementsForStates(o.customStyles), o._menuStyles = i, o._onClick = s.onClick, o._dropupStyles = (f = s.styles) == null ? void 0 : f.dropup, o.setSetState(s), o.addClickListener(r), o.changeState(s.initialState, !0), o;
  }
  return Ht(t, e), He(t, [{
    key: "createInnerElementsForStates",
    value: function(n) {
      var r = "custom-icon", i = this.createInnerElements(r, "default", n);
      return {
        default: i,
        active: this.genStateInnerElements(r, "active", i, n),
        disabled: this.genStateInnerElements(r, "disabled", i, n)
      };
    }
  }, {
    key: "setSetState",
    value: function(n) {
      var r = this;
      n.setState = function(i) {
        i === "default" && r.changeToDefault(), i === "active" && r.changeToActive(), i === "disabled" && r.changeToDisabled();
      };
    }
  }, {
    key: "addClickListener",
    value: function(n) {
      var r = this;
      this.elementRef.addEventListener("click", function() {
        var i, o = (i = r._onClick) == null ? void 0 : i.call(r, r._state);
        n == null || n(), (o === "default" || o === "active" || o === "disabled") && r.changeState(o);
      });
    }
  }, {
    key: "changeState",
    value: function(n, r) {
      n === "disabled" ? this.changeToDisabled(r) : n === "active" ? this.changeToActive(r) : this.changeToDefault(r);
    }
  }, {
    key: "applyDropupContentStyles",
    value: function(n) {
      var r = Array.from(this.elementRef.children);
      if (n != null && n.text) {
        var i = r.find(function(l) {
          return l.classList.contains(_o.TEXT_CLASS);
        });
        i && Object.assign(i.style, n.text);
      }
      if (n != null && n.iconContainer) {
        var o = r.find(function(l) {
          return l.classList.contains(_o.ICON_CLASS);
        });
        o && Object.assign(o.style, n.iconContainer);
      }
    }
  }, {
    key: "resetDropupItem",
    value: function(n) {
      var r, i, o;
      this.elementRef = Oo.replaceElementWithNewClone(this.elementRef, this._originalElementRef), this.elementRef.innerHTML = "", ((r = n == null ? void 0 : n.svg) == null ? void 0 : r.content) === "" || this.elementRef.appendChild(_o.createItemIcon(this.svg, (i = this._menuStyles) == null ? void 0 : i.iconContainer)), this.elementRef.appendChild(_o.createItemText(this.dropupText, (o = this._menuStyles) == null ? void 0 : o.text));
    }
  }, {
    key: "assignDropupItemStyle",
    value: function(n, r) {
      var i;
      this.elementRef.parentElement && this._originalElementRef && this.resetDropupItem(r), this.applyDropupContentStyles(n), Object.assign(this.elementRef.style, (i = n == null ? void 0 : n.item) == null ? void 0 : i.default);
      var o = za.processStateful((n == null ? void 0 : n.item) || {});
      Ib.add(this.elementRef, o), this.addClickListener();
    }
  }, {
    key: "changeToDefault",
    value: function(n) {
      var r, i, o, l, d, c;
      !n && this._state === "default" || (this.elementRef.classList.contains(_o.MENU_ITEM_CLASS) ? this.assignDropupItemStyle((r = this._dropupStyles) == null ? void 0 : r.default, (i = this.customStyles) == null ? void 0 : i.default) : (this.changeElementsByState(this._innerElements.default), (o = this.customStyles) != null && o.active && un.unsetAllCSS(this.elementRef, (l = this.customStyles) == null ? void 0 : l.active), (d = this.customStyles) != null && d.disabled && un.unsetAllCSS(this.elementRef, (c = this.customStyles) == null ? void 0 : c.disabled), this.reapplyStateStyle("default", ["active", "disabled"])), this.elementRef.classList.remove(t.DISABLED_CONTAINER_CLASS, t.ACTIVE_CONTAINER_CLASS), this.elementRef.classList.add(t.DEFAULT_CONTAINER_CLASS), Ha.removeAriaDisabled(this.elementRef), this._state = "default");
    }
  }, {
    key: "changeToActive",
    value: function(n) {
      var r, i;
      !n && this._state === "active" || (this.elementRef.classList.contains(_o.MENU_ITEM_CLASS) ? this.assignDropupItemStyle((r = this._dropupStyles) == null ? void 0 : r.active, (i = this.customStyles) == null ? void 0 : i.active) : (this.changeElementsByState(this._innerElements.active), this.reapplyStateStyle("active", ["disabled", "default"])), this.elementRef.classList.remove(t.DISABLED_CONTAINER_CLASS, t.DEFAULT_CONTAINER_CLASS), this.elementRef.classList.add(t.ACTIVE_CONTAINER_CLASS), Ha.removeAriaDisabled(this.elementRef), this._state = "active");
    }
  }, {
    key: "changeToDisabled",
    value: function(n) {
      var r, i, o, l, d, c;
      !n && this._state === "disabled" || (this.elementRef.classList.contains(_o.MENU_ITEM_CLASS) ? this.assignDropupItemStyle((r = this._dropupStyles) == null ? void 0 : r.disabled, (i = this.customStyles) == null ? void 0 : i.disabled) : (this.changeElementsByState(this._innerElements.disabled), (o = this.customStyles) != null && o.active && un.unsetAllCSS(this.elementRef, (l = this.customStyles) == null ? void 0 : l.active), (d = this.customStyles) != null && d.default && un.unsetAllCSS(this.elementRef, (c = this.customStyles) == null ? void 0 : c.default), this.reapplyStateStyle("disabled", ["default", "active"])), this.elementRef.classList.remove(t.ACTIVE_CONTAINER_CLASS, t.DEFAULT_CONTAINER_CLASS), this.elementRef.classList.add(t.DISABLED_CONTAINER_CLASS), Ha.addAriaDisabled(this.elementRef), this._state = "disabled");
    }
    // called after class is initialised
  }, {
    key: "setDropupItem",
    value: function(n) {
      this.elementRef = n, this._originalElementRef = n.cloneNode(!0), this.changeState(this._state, !0);
    }
  }, {
    key: "genStateInnerElements",
    value: function(n, r, i, o) {
      var l, d, c, u, m = this.createInnerElements(n, r, o), f = (d = (l = o == null ? void 0 : o[r]) == null ? void 0 : l.svg) == null ? void 0 : d.content, v = (u = (c = o == null ? void 0 : o[r]) == null ? void 0 : c.text) == null ? void 0 : u.content;
      if (f === void 0 || v === void 0) {
        var b = ru.parseSVGTextElements(i), w = b.svg, S = b.text, I = ru.parseSVGTextElements(m), T = I.svg, x = I.text, k = [];
        t.addToInnerElements(k, f, w, T), t.addToInnerElements(k, v, S, x), m = k;
      }
      return m;
    }
  }], [{
    key: "createButtonElement",
    value: function() {
      var n = document.createElement("div");
      return n.classList.add("input-button", t.BUTTON_CLASS), n;
    }
  }, {
    key: "addToInnerElements",
    value: function(n, r, i, o) {
      r === void 0 && i ? n.push(i.cloneNode(!0)) : o && n.push(o);
    }
  }, {
    key: "add",
    value: function(n, r) {
      var i = n.customButtons, o = n.focusInput, l = n.dropupStyles;
      i == null || i.forEach(function(d, c) {
        var u = {
          button: new t(d, c + 1, o, l == null ? void 0 : l.menu)
        };
        r["".concat(t.INDICATOR_PREFIX).concat(c + 1)] = u;
      });
    }
  }]);
}(El);
Yl.INDICATOR_PREFIX = "custom", Yl.BUTTON_CLASS = "custom-button", Yl.DISABLED_CONTAINER_CLASS = "custom-button-container-disabled", Yl.DEFAULT_CONTAINER_CLASS = "custom-button-container-default", Yl.ACTIVE_CONTAINER_CLASS = "custom-button-container-active";
var ou = Yl, MHe = `<?xml version="1.0" encoding="utf-8"?>
<svg viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg">
    <path d="M16 0c-8.836 0-16 7.163-16 16s7.163 16 16 16c8.837 0 16-7.163 16-16s-7.163-16-16-16zM16 30.032c-7.72 0-14-6.312-14-14.032s6.28-14 14-14 14 6.28 14 14-6.28 14.032-14 14.032zM23 15h-6v-6c0-0.552-0.448-1-1-1s-1 0.448-1 1v6h-6c-0.552 0-1 0.448-1 1s0.448 1 1 1h6v6c0 0.552 0.448 1 1 1s1-0.448 1-1v-6h6c0.552 0 1-0.448 1-1s-0.448-1-1-1z"></path>
</svg>`, mC = /* @__PURE__ */ function() {
  function e() {
    je(this, e);
  }
  return He(e, null, [{
    key: "focusItemWhenOnEdge",
    value: function(s, n) {
      var r = n ? s.children[0] : s.children[s.children.length - 1];
      e.focusSiblingItem(r, s, n, !0);
    }
    // isEdgeItem means is it a start or end item
    // prettier-ignore
  }, {
    key: "focusSiblingItem",
    value: function(s, n, r) {
      var i = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1, o = i ? s : s[r ? "nextSibling" : "previousSibling"];
      o ? (s.dispatchEvent(new MouseEvent("mouseleave")), o.dispatchEvent(new MouseEvent("mouseenter"))) : (s.dispatchEvent(new MouseEvent("mouseleave")), e.focusItemWhenOnEdge(n, r));
    }
  }]);
}(), xHe = /* @__PURE__ */ function() {
  function e(t, s) {
    var n = this;
    je(this, e);
    var r;
    this._isOpen = !0, this._styles = s, this.elementRef = e.createElement((r = this._styles) == null ? void 0 : r.container), this.close(), setTimeout(function() {
      return n.addWindowEvents(t);
    });
  }
  return He(e, [{
    key: "open",
    value: function() {
      this.elementRef.style.display = "block", this._isOpen = !0;
    }
  }, {
    key: "close",
    value: function() {
      this._isOpen && (this.elementRef.style.display = "none", this._isOpen = !1);
    }
  }, {
    key: "toggle",
    value: function() {
      this._isOpen ? this.close() : this.open();
    }
  }, {
    key: "addItem",
    value: function(s) {
      var n = _o.createItem(this, s, this._styles);
      this.elementRef.appendChild(n);
    }
    // prettier-ignore
  }, {
    key: "addWindowEvents",
    value: function(s) {
      this.clickEvent = this.windowClick.bind(this, s), window.addEventListener("click", this.clickEvent), this.keyDownEvent = this.windowKeyDown.bind(this, s), window.addEventListener("keydown", this.keyDownEvent);
    }
  }, {
    key: "windowClick",
    value: function(s, n) {
      var r;
      !s.isConnected && this.clickEvent ? window.removeEventListener("click", this.clickEvent) : s.parentElement !== ((r = n.target.shadowRoot) == null ? void 0 : r.children[0]) && this.close();
    }
    // prettier-ignore
  }, {
    key: "windowKeyDown",
    value: function(s, n) {
      var r, i, o;
      !s.isConnected && this.keyDownEvent ? window.removeEventListener("keydown", this.keyDownEvent) : this._isOpen && (n.key === qa.ESCAPE ? (this.close(), (r = this.highlightedItem) == null || r.dispatchEvent(new MouseEvent("mouseleave"))) : n.key === qa.ENTER ? ((i = this.highlightedItem) == null || i.click(), (o = this.highlightedItem) == null || o.dispatchEvent(new MouseEvent("mouseleave"))) : n.key === qa.ARROW_DOWN ? mC.focusSiblingItem(this.highlightedItem || this.elementRef.children[this.elementRef.children.length - 1], this.elementRef, !0) : n.key === qa.ARROW_UP && mC.focusSiblingItem(this.highlightedItem || this.elementRef.children[0], this.elementRef, !1));
    }
  }], [{
    key: "createElement",
    value: function(s) {
      var n = document.createElement("div");
      return n.id = "dropup-menu", Object.assign(n.style, s), n;
    }
  }]);
}(), j5 = /* @__PURE__ */ function(e) {
  function t(s, n) {
    var r;
    je(this, t);
    var i, o, l = Ho.tryCreateConfig("Options", (i = n == null ? void 0 : n.button) == null ? void 0 : i.tooltip);
    r = jt(this, t, [t.createButtonElement(), MHe, void 0, l, {
      styles: (o = n == null ? void 0 : n.button) == null ? void 0 : o.styles
    }]);
    var d = r.createInnerElementsForStates(r.customStyles);
    return r._menu = new xHe(s, n == null ? void 0 : n.menu), r.addClickEvent(), r.buttonContainer = t.createButtonContainer(), r.changeElementsByState(d.styles), r.buttonContainer.appendChild(r.elementRef), r.elementRef.classList.add(t.BUTTON_ICON_CLASS), r.buttonContainer.appendChild(r._menu.elementRef), r.reapplyStateStyle("styles"), r.addContainerEvents(s), r;
  }
  return Ht(t, e), He(t, [{
    key: "createInnerElementsForStates",
    value: function(n) {
      return {
        styles: this.createInnerElements("dropup-icon", "styles", n)
      };
    }
  }, {
    key: "addClickEvent",
    value: function() {
      this.elementRef.onclick = this._menu.toggle.bind(this._menu);
    }
  }, {
    key: "addItem",
    value: function(n) {
      this._menu.addItem(n);
    }
  }, {
    key: "addContainerEvents",
    value: function(n) {
      var r = this;
      n.addEventListener("click", function(i) {
        var o = i.target.classList;
        !o.contains(t.BUTTON_ICON_CLASS) && !o.contains(ou.DISABLED_CONTAINER_CLASS) && r._menu.close();
      });
    }
  }], [{
    key: "createButtonElement",
    value: function() {
      var n = document.createElement("div");
      return n.classList.add("input-button"), n;
    }
  }, {
    key: "createButtonContainer",
    value: function() {
      var n = document.createElement("div");
      return n.id = "dropup-container", n;
    }
  }, {
    key: "getPosition",
    value: function(n, r) {
      var i, o;
      return (i = r == null ? void 0 : r.button) != null && i.position ? (o = r == null ? void 0 : r.button) == null ? void 0 : o.position : n["outside-left"].length > 0 && n["outside-right"].length === 0 ? "outside-right" : "outside-left";
    }
  }]);
}(El);
j5.BUTTON_ICON_CLASS = "dropup-button";
var fC = j5, FHe = /* @__PURE__ */ function() {
  function e() {
    je(this, e);
  }
  return He(e, null, [{
    key: "addToDropup",
    value: (
      // prettier-ignore
      function(s, n, r, i) {
        var o = new fC(r, i);
        hC.forEach(function(d) {
          var c = n["dropup-menu"].findIndex(function(m) {
            return m.buttonType === d;
          }), u = n["dropup-menu"][c];
          u && (o.addItem(u.button), n["dropup-menu"].splice(c, 1));
        }), n["dropup-menu"].forEach(function(d) {
          var c = d.button;
          return o.addItem(c);
        });
        var l = fC.getPosition(n, i);
        Sm.addButton(s, o.buttonContainer, l), n[l].push({});
      }
    )
  }, {
    key: "addToSideContainer",
    value: function(s, n) {
      ["inside-left", "inside-right", "outside-left", "outside-right"].forEach(function(r) {
        var i = r;
        n[i].forEach(function(o) {
          Sm.addButton(s, o.button.elementRef, i);
        });
      });
    }
  }, {
    key: "setPosition",
    value: function(s, n, r) {
      var i = ys(ys({}, s[n]), {}, {
        buttonType: n
      });
      r.push(i), delete s[n];
    }
  }, {
    key: "createPositionsToButtonsObj",
    value: function() {
      return {
        "dropup-menu": [],
        "outside-left": [],
        "inside-left": [],
        "inside-right": [],
        "outside-right": []
      };
    }
    // prettier-ignore
  }, {
    key: "generatePositionToButtons",
    value: function(s) {
      var n = e.createPositionsToButtonsObj();
      Object.keys(s).forEach(function(i) {
        var o, l = (o = s[i]) == null ? void 0 : o.button.position;
        l && e.setPosition(s, i, n[l]);
      }), n["inside-right"].length === 0 && s.submit && e.setPosition(s, "submit", n["inside-right"]), n["outside-right"].length === 0 && (s.submit ? e.setPosition(s, "submit", n["outside-right"]) : s.microphone ? e.setPosition(s, "microphone", n["outside-right"]) : s.camera ? e.setPosition(s, "camera", n["outside-right"]) : s["".concat(ou.INDICATOR_PREFIX, "1")] && e.setPosition(s, "".concat(ou.INDICATOR_PREFIX, "1"), n["outside-right"])), s.submit && e.setPosition(s, "submit", n["outside-left"].length === 0 ? n["outside-left"] : n["inside-right"]), s.microphone && e.setPosition(s, "microphone", n["outside-left"].length === 0 ? n["outside-left"] : n["inside-right"]);
      var r = Object.keys(s);
      return r.length > 1 || n["dropup-menu"].length > 0 ? (hC.forEach(function(i) {
        s[i] && n["dropup-menu"].push(ys(ys({}, s[i]), {}, {
          buttonType: i
        }));
      }), r.forEach(function(i) {
        var o = i;
        o.startsWith(ou.INDICATOR_PREFIX) && s[o] && n["dropup-menu"].push(ys(ys({}, s[o]), {}, {
          customType: o
        }));
      })) : r.length === 1 && e.setPosition(s, r[0], n["outside-right"].length === 0 ? n["outside-right"] : n["outside-left"]), n;
    }
    // prettier-ignore
  }, {
    key: "addButtons",
    value: function(s, n, r, i) {
      var o = e.generatePositionToButtons(n);
      return e.addToSideContainer(s, o), o["dropup-menu"].length > 0 && e.addToDropup(s, o, r, i), o;
    }
  }]);
}(), VHe = `<?xml version="1.0" encoding="utf-8"?>
<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M20 10.9696L11.9628 18.5497C10.9782 19.4783 9.64274 20 8.25028 20C6.85782 20 5.52239 19.4783 4.53777 18.5497C3.55315 17.6211 3 16.3616 3 15.0483C3 13.7351 3.55315 12.4756 4.53777 11.547L12.575 3.96687C13.2314 3.34779 14.1217 3 15.05 3C15.9783 3 16.8686 3.34779 17.525 3.96687C18.1814 4.58595 18.5502 5.4256 18.5502 6.30111C18.5502 7.17662 18.1814 8.01628 17.525 8.63535L9.47904 16.2154C9.15083 16.525 8.70569 16.6989 8.24154 16.6989C7.77738 16.6989 7.33224 16.525 7.00403 16.2154C6.67583 15.9059 6.49144 15.4861 6.49144 15.0483C6.49144 14.6106 6.67583 14.1907 7.00403 13.8812L14.429 6.88674" stroke="#000000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`, DHe = `<?xml version="1.0" encoding="utf-8"?>
<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
  <path d="M20,15.2928932 L20,5.5 C20,4.67157288 19.3284271,4 18.5,4 L5.5,4 C4.67157288,4 4,4.67157288 4,5.5 L4,12.2928932 L7.14644661,9.14644661 C7.34170876,8.95118446 7.65829124,8.95118446 7.85355339,9.14644661 L13.5,14.7928932 L16.1464466,12.1464466 C16.3417088,11.9511845 16.6582912,11.9511845 16.8535534,12.1464466 L20,15.2928932 Z M20,16.7071068 L16.5,13.2071068 L13.8535534,15.8535534 C13.6582912,16.0488155 13.3417088,16.0488155 13.1464466,15.8535534 L7.5,10.2071068 L4,13.7071068 L4,18.5 C4,19.3284271 4.67157288,20 5.5,20 L18.5,20 C19.3284271,20 20,19.3284271 20,18.5 L20,16.7071068 Z M3,5.5 C3,4.11928813 4.11928813,3 5.5,3 L18.5,3 C19.8807119,3 21,4.11928813 21,5.5 L21,18.5 C21,19.8807119 19.8807119,21 18.5,21 L5.5,21 C4.11928813,21 3,19.8807119 3,18.5 L3,5.5 Z M15,6 L17,6 C17.5522847,6 18,6.44771525 18,7 L18,9 C18,9.55228475 17.5522847,10 17,10 L15,10 C14.4477153,10 14,9.55228475 14,9 L14,7 C14,6.44771525 14.4477153,6 15,6 Z M15,7 L15,9 L17,9 L17,7 L15,7 Z"/>
</svg>
`, NHe = `<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="-49.49 -49.49 593.87 593.87" stroke-width="3.95908" transform="rotate(0)">
  <g stroke-width="0"></g>
  <g stroke-linecap="round" stroke-linejoin="round" stroke-width="0.98977"></g>
  <g>
    <g>
      <g>
        <path d="M163.205,76.413v293.301c-3.434-3.058-7.241-5.867-11.486-8.339c-21.38-12.452-49.663-15.298-77.567-7.846 c-49.038,13.096-80.904,54.519-71.038,92.337c4.019,15.404,14.188,28.221,29.404,37.087c13.553,7.894,29.87,11.933,47.115,11.933 c9.962,0,20.231-1.356,30.447-4.087c42.74-11.406,72.411-44.344,72.807-77.654h0.011v-0.162c0.002-0.166,0-0.331,0-0.496V187.072 l290.971-67.3v178.082c-3.433-3.055-7.238-5.863-11.481-8.334c-21.385-12.452-49.654-15.308-77.567-7.846 c-49.038,13.087-80.904,54.519-71.038,92.356c4.019,15.385,14.183,28.212,29.404,37.067c13.548,7.894,29.875,11.933,47.115,11.933 c9.962,0,20.231-1.356,30.452-4.087c42.74-11.413,72.411-44.346,72.804-77.654h0.004v-0.065c0.003-0.236,0.001-0.469,0-0.704V0 L163.205,76.413z M104.999,471.779c-22.543,6.038-45.942,3.846-62.572-5.846c-10.587-6.163-17.591-14.817-20.255-25.038 c-7.144-27.375,18.452-58.029,57.062-68.346c8.409-2.25,16.938-3.346,25.188-3.346c13.87,0,26.962,3.115,37.389,9.192 c10.587,6.163,17.591,14.817,20.255,25.029c0.809,3.102,1.142,6.248,1.139,9.4v0.321h0.014 C162.99,437.714,139.082,462.678,104.999,471.779z M182.898,166.853V92.067l290.971-67.298v74.784L182.898,166.853z M415.677,399.923c-22.558,6.038-45.942,3.837-62.587-5.846c-10.587-6.163-17.587-14.817-20.25-25.019 c-7.144-27.385,18.452-58.058,57.058-68.365c8.414-2.25,16.942-3.346,25.192-3.346c13.875,0,26.962,3.115,37.385,9.192 c10.596,6.163,17.596,14.817,20.26,25.029v0.01c0.796,3.05,1.124,6.144,1.135,9.244v0.468h0.02 C473.668,365.851,449.763,390.814,415.677,399.923z">
        </path>
      </g>
    </g>
  </g>
</svg>`, jHe = `<?xml version="1.0" encoding="UTF-8" standalone="no"?>
<svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 5.9266752 5.6408391" height="21.31971" width="22.4">
  <g>
    <path d="m 5.2564627,1.548212 c -3.1136005,-0.4796804 -1.5568006,-0.2398402 0,0 z M 2.0001198,2.0922063 c 0.1556781,0 0.2657489,0.020893 0.3917849,0.080366 0.081154,0.038347 0.1153492,0.134065 0.076377,0.2138602 -0.038973,0.07979 -0.1363527,0.1134129 -0.2175069,0.075091 -0.078199,-0.036919 -0.1407455,-0.048792 -0.250655,-0.048792 -0.2260486,0 -0.3921482,0.2042182 -0.3921482,0.4801409 0,0.2761822 0.1663188,0.4810688 0.3921482,0.4810688 0.1117901,0 0.2064255,-0.046133 0.255659,-0.1284198 l 0.00162,-0.00389 V 3.0534032 l -0.098011,1.75e-4 c -0.081844,0 -0.1495979,-0.059305 -0.1612403,-0.1365887 l -0.00175,-0.023683 c 0,-0.08047 0.060311,-0.1470874 0.1389194,-0.1585331 l 0.024085,-0.00195 h 0.2612303 c 0.081842,0 0.149598,0.059305 0.1612404,0.1365891 l 0.00175,0.023683 -3.398e-4,0.3968809 v 0 l -0.00168,0.014211 v 0 l -0.00553,0.023034 v 0 l -0.00532,0.014145 c -0.098178,0.22826 -0.3236506,0.3528713 -0.5706303,0.3528713 -0.4240855,0 -0.7181621,-0.3622714 -0.7181621,-0.8016063 0,-0.4391857 0.2940275,-0.8006848 0.7181621,-0.8006848 z m 1.2034759,0.031275 c 0.081843,0 0.1495977,0.059305 0.1612403,0.1365891 l 0.00175,0.023683 v 1.2211775 c 0,0.088516 -0.07298,0.1602721 -0.1630073,0.1602721 -0.081841,0 -0.1495972,-0.059305 -0.1612397,-0.1365892 L 3.040589,3.5049308 V 2.2837527 c 0,-0.088516 0.07298,-0.1602721 0.1630067,-0.1602714 z m 0.7813442,0 0.5209469,0.00195 c 0.090025,3.048e-4 0.1627543,0.072306 0.1624458,0.1608234 -2.809e-4,0.08047 -0.06083,0.1468798 -0.1394772,0.158066 l -0.024092,0.00195 -0.3575326,-0.0013 v 0.4497782 l 0.2928918,2.27e-4 c 0.081842,0 0.1495979,0.059305 0.1612403,0.136589 l 0.00175,0.023683 c 0,0.080469 -0.06031,0.1470871 -0.1389193,0.1585393 l -0.024092,0.00195 -0.2928919,-2.336e-4 1.563e-4,0.2860316 c 0,0.080471 -0.06031,0.1470873 -0.1389193,0.1585395 l -0.024085,0.00195 c -0.081843,0 -0.1495979,-0.059305 -0.1612403,-0.1365826 l -0.00175,-0.023691 V 2.2841354 c 2.798e-4,-0.08047 0.060829,-0.1468797 0.1394758,-0.1580594 z"/>
    <path d="m 5.0894191,1.0943261 c 0,-0.21918999 -0.177687,-0.39686999 -0.396876,-0.39686999 h -3.43959 c -0.2191879,0 -0.391262,0.1777519 -0.3968759,0.39686999 l -0.027082,3.4379266 c 0.040152,0.2939927 0.4235456,0.409415 0.4235456,0.409415 l 3.4785583,-0.00851 c 0,0 0.3008506,-0.1402998 0.3236271,-0.4201576 0.042911,-0.5272495 0.034693,-1.6106146 0.034693,-3.4186761 z m -4.49792494,0 c 0,-0.36530999 0.29614504,-0.66145999 0.66145894,-0.66145999 h 3.43959 c 0.365314,0 0.66146,0.29615 0.66146,0.66145999 v 3.43959 c 0,0.36532 -0.296146,0.66146 -0.66146,0.66146 h -3.43959 c -0.3653139,0 -0.66145894,-0.29614 -0.66145894,-0.66146 z"/>
  </g>
</svg>
`, HHe = {
  images: {
    id: "upload-images-icon",
    svgString: DHe,
    dropupText: "Image"
  },
  gifs: {
    id: "upload-gifs-icon",
    svgString: jHe,
    dropupText: "GIF"
  },
  audio: {
    id: "upload-audio-icon",
    svgString: NHe,
    dropupText: "Audio"
  },
  mixedFiles: {
    id: "upload-mixed-files-icon",
    svgString: VHe,
    dropupText: "File"
  }
}, H5 = /* @__PURE__ */ function(e) {
  function t(s) {
    var n;
    je(this, t), (s == null ? void 0 : s.position) === "dropup-menu" && (s.position = "outside-right");
    var r = Ho.tryCreateConfig("Microphone", s == null ? void 0 : s.tooltip);
    return n = jt(this, t, [t.createMicrophoneElement(), L5, s == null ? void 0 : s.position, r, s]), n.isActive = !1, n._innerElements = n.createInnerElementsForStates(n.customStyles), n.changeToDefault(), n;
  }
  return Ht(t, e), He(t, [{
    key: "createInnerElementsForStates",
    value: function(n) {
      var r = "microphone-icon";
      return {
        default: this.createInnerElements(r, "default", n),
        active: this.createInnerElements(r, "active", n),
        unsupported: this.createInnerElements(r, "unsupported", n),
        commandMode: this.createInnerElements(r, "commandMode", n)
      };
    }
  }, {
    key: "changeToActive",
    value: function() {
      this.changeElementsByState(this._innerElements.active), this.toggleIconFilter("active"), this.reapplyStateStyle("active", ["default", "commandMode"]), this.isActive = !0;
    }
  }, {
    key: "changeToDefault",
    value: function() {
      this.changeElementsByState(this._innerElements.default), this.toggleIconFilter("default"), this.reapplyStateStyle("default", ["active", "commandMode"]), this.isActive = !1;
    }
  }, {
    key: "changeToCommandMode",
    value: function() {
      this.changeElementsByState(this._innerElements.commandMode), this.toggleIconFilter("command"), this.reapplyStateStyle("commandMode", ["active"]);
    }
  }, {
    key: "changeToUnsupported",
    value: function() {
      this.changeElementsByState(this._innerElements.unsupported), this.elementRef.classList.add("unsupported-microphone"), this.reapplyStateStyle("unsupported", ["active"]);
    }
  }, {
    key: "toggleIconFilter",
    value: function(n) {
      var r = this.elementRef.children[0];
      if (r.tagName.toLocaleLowerCase() === "svg") switch (n) {
        case "default":
          r.classList.remove("active-microphone-icon", "command-microphone-icon"), r.classList.add("default-microphone-icon");
          break;
        case "active":
          r.classList.remove("default-microphone-icon", "command-microphone-icon"), r.classList.add("active-microphone-icon");
          break;
        case "command":
          r.classList.remove("active-microphone-icon", "default-microphone-icon"), r.classList.add("command-microphone-icon");
          break;
      }
    }
  }], [{
    key: "createMicrophoneElement",
    value: function() {
      var n = document.createElement("div");
      return n.id = "microphone-button", n.classList.add("input-button"), n;
    }
  }]);
}(El);
function UHe(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var jp = {}, ic = {}, lc = {}, dc = {}, cc = {}, gC;
function Af() {
  if (gC) return cc;
  gC = 1, Object.defineProperty(cc, "__esModule", {
    value: !0
  }), cc.Text = void 0;
  var e = /* @__PURE__ */ function() {
    function t() {
      je(this, t);
    }
    return He(t, null, [{
      key: "capitalize",
      value: function(n) {
        return n.replace(t.FIRST_CHAR_REGEX, function(r) {
          return r.toUpperCase();
        });
      }
    }, {
      key: "lineBreak",
      value: function(n) {
        return n.replace(t.DOUBLE_LINE, "<p></p>").replace(t.ONE_LINE, "<br>");
      }
    }, {
      key: "isCharDefined",
      value: function(n) {
        return n !== void 0 && n !== " " && n !== " " && n !== `
` && n !== "";
      }
    }, {
      key: "breakupIntoWordsArr",
      value: function(n) {
        return n.split(/(\W+)/);
      }
    }]);
  }();
  return cc.Text = e, e.FIRST_CHAR_REGEX = /\S/, e.DOUBLE_LINE = /\n\n/g, e.ONE_LINE = /\n/g, cc;
}
var vC;
function U5() {
  if (vC) return dc;
  vC = 1, Object.defineProperty(dc, "__esModule", {
    value: !0
  }), dc.Translate = void 0;
  var e = Af(), t = /* @__PURE__ */ function() {
    function s() {
      je(this, s);
    }
    return He(s, null, [{
      key: "translate",
      value: function(r, i) {
        for (var o = e.Text.breakupIntoWordsArr(r), l = 0; l < o.length; l += 1) i[o[l]] && (o[l] = i[o[l]]);
        return o.join("");
      }
    }]);
  }();
  return dc.Translate = t, dc;
}
var yC;
function zHe() {
  if (yC) return lc;
  yC = 1, Object.defineProperty(lc, "__esModule", {
    value: !0
  }), lc.WebSpeechTranscript = void 0;
  var e = U5(), t = /* @__PURE__ */ function() {
    function s() {
      je(this, s);
    }
    return He(s, null, [{
      key: "extract",
      value: function(r, i, o) {
        for (var l = "", d = r.resultIndex; d < r.results.length; ++d) {
          var c = r.results[d][0].transcript;
          o && (c = e.Translate.translate(c, o)), r.results[d].isFinal ? i += c : l += c;
        }
        return {
          interimTranscript: l,
          finalTranscript: i,
          newText: l || i
        };
      }
    }, {
      key: "extractSafari",
      value: function(r, i, o) {
        for (var l = "", d = "", c = r.resultIndex; c < r.results.length; ++c) {
          var u = r.results[c][0].transcript;
          o && (u = e.Translate.translate(u, o)), l += u;
        }
        return {
          interimTranscript: d,
          finalTranscript: l,
          newText: d || l
        };
      }
    }]);
  }();
  return lc.WebSpeechTranscript = t, lc;
}
var uc = {}, bC;
function Vb() {
  if (bC) return uc;
  bC = 1, Object.defineProperty(uc, "__esModule", {
    value: !0
  }), uc.Browser = void 0;
  var e = /* @__PURE__ */ He(function t() {
    je(this, t);
  });
  return uc.Browser = e, e.IS_SAFARI = function() {
    return e._IS_SAFARI === void 0 && (e._IS_SAFARI = /^((?!chrome|android).)*safari/i.test(navigator.userAgent)), e._IS_SAFARI;
  }, uc;
}
var pc = {}, hc = {}, AC;
function WHe() {
  if (AC) return hc;
  AC = 1, Object.defineProperty(hc, "__esModule", {
    value: !0
  }), hc.EventListeners = void 0;
  var e = /* @__PURE__ */ function() {
    function t() {
      je(this, t);
    }
    return He(t, null, [{
      key: "getElementIfFocusedOnAvailable",
      value: function(n, r) {
        return Array.isArray(n) ? n.find(function(i) {
          return r === i;
        }) : r === n ? n : void 0;
      }
    }, {
      key: "keyDownWindow",
      value: function(n) {
        var r = this;
        n.element && t.getElementIfFocusedOnAvailable(n.element, document.activeElement) && (t.KEY_DOWN_TIMEOUT !== null && clearTimeout(t.KEY_DOWN_TIMEOUT), t.KEY_DOWN_TIMEOUT = setTimeout(function() {
          t.KEY_DOWN_TIMEOUT = null, r.resetRecording(n);
        }, 500));
      }
    }, {
      key: "mouseDownWindow",
      value: function(n, r) {
        this.mouseDownElement = t.getElementIfFocusedOnAvailable(n, r.target);
      }
    }, {
      key: "mouseUpWindow",
      value: function(n) {
        this.mouseDownElement && this.resetRecording(n), this.mouseDownElement = void 0;
      }
    }, {
      key: "add",
      value: function(n, r) {
        var i = (r == null ? void 0 : r.insertInCursorLocation) === void 0 || (r == null ? void 0 : r.insertInCursorLocation);
        r != null && r.element && i && (n.mouseDownEvent = t.mouseDownWindow.bind(n, r.element), document.addEventListener("mousedown", n.mouseDownEvent), n.mouseUpEvent = t.mouseUpWindow.bind(n, r), document.addEventListener("mouseup", n.mouseUpEvent), n.keyDownEvent = t.keyDownWindow.bind(n, r), document.addEventListener("keydown", n.keyDownEvent));
      }
    }, {
      key: "remove",
      value: function(n) {
        document.removeEventListener("mousedown", n.mouseDownEvent), document.removeEventListener("mouseup", n.mouseUpEvent), document.removeEventListener("keydown", n.keyDownEvent);
      }
    }]);
  }();
  return hc.EventListeners = e, e.KEY_DOWN_TIMEOUT = null, hc;
}
var mc = {}, wC;
function GHe() {
  if (wC) return mc;
  wC = 1, Object.defineProperty(mc, "__esModule", {
    value: !0
  }), mc.PreResultUtils = void 0;
  var e = /* @__PURE__ */ function() {
    function t() {
      je(this, t);
    }
    return He(t, null, [{
      key: "process",
      value: function(n, r, i, o, l) {
        var d = o == null ? void 0 : o(r, i);
        return d ? (setTimeout(function() {
          d.restart ? n.resetRecording(l) : d.stop && n.stop();
        }), (d.stop || d.restart) && d.removeNewText) : !1;
      }
    }]);
  }();
  return mc.PreResultUtils = e, mc;
}
var fc = {}, gc = {}, CC;
function z5() {
  if (CC) return gc;
  CC = 1, Object.defineProperty(gc, "__esModule", {
    value: !0
  }), gc.AutoScroll = void 0;
  var e = /* @__PURE__ */ function() {
    function t() {
      je(this, t);
    }
    return He(t, null, [{
      key: "changeStateIfNeeded",
      value: function(n, r) {
        r && !n.isCursorAtEnd && (n.endPadding = "", n.scrollingSpan.innerHTML = "&nbsp;");
      }
    }, {
      key: "scrollGeneric",
      value: function(n, r) {
        n.isCursorAtEnd ? r.scrollTop = r.scrollHeight : n.scrollingSpan.scrollIntoView({
          block: "nearest"
        });
      }
      // primitives don't need to be scrolled except in safari
      // they can only safely be scrolled to the end
    }, {
      key: "scrollSafariPrimitiveToEnd",
      value: function(n) {
        n.scrollLeft = n.scrollWidth, n.scrollTop = n.scrollHeight;
      }
    }, {
      key: "isElementOverflown",
      value: function(n) {
        return n.scrollHeight > n.clientHeight || n.scrollWidth > n.clientWidth;
      }
    }, {
      key: "isRequired",
      value: function(n, r) {
        return n && t.isElementOverflown(r);
      }
    }]);
  }();
  return gc.AutoScroll = e, gc;
}
var vc = {}, SC;
function wf() {
  if (SC) return vc;
  SC = 1, Object.defineProperty(vc, "__esModule", {
    value: !0
  }), vc.Elements = void 0;
  var e = /* @__PURE__ */ function() {
    function t() {
      je(this, t);
    }
    return He(t, null, [{
      key: "isPrimitiveElement",
      value: function(n) {
        return n.tagName === "INPUT" || n.tagName === "TEXTAREA";
      }
    }, {
      key: "createInterimSpan",
      value: function() {
        var n = document.createElement("span");
        return n.style.color = "grey", n.style.pointerEvents = "none", n;
      }
    }, {
      key: "createGenericSpan",
      value: function() {
        var n = document.createElement("span");
        return n.style.pointerEvents = "none", n;
      }
    }, {
      key: "appendSpans",
      value: function(n, r) {
        if (n.spansPopulated = !0, n.insertInCursorLocation && document.activeElement === r) {
          var i = window.getSelection();
          if (i != null && i.focusNode) {
            var o = i.getRangeAt(0);
            o.insertNode(n.scrollingSpan), o.insertNode(n.interimSpan), o.insertNode(n.finalSpan), o.collapse(!1), i.removeAllRanges(), i.addRange(o);
            return;
          }
        }
        r.appendChild(n.finalSpan), r.appendChild(n.interimSpan), r.appendChild(n.scrollingSpan);
      }
    }, {
      key: "applyCustomColors",
      value: function(n, r) {
        r.interim && (n.interimSpan.style.color = r.interim), r.final && (n.finalSpan.style.color = r.final);
      }
    }, {
      key: "isInsideShadowDOM",
      value: function(n) {
        return n.getRootNode() instanceof ShadowRoot;
      }
    }]);
  }();
  return vc.Elements = e, vc;
}
var yc = {}, PC;
function Cf() {
  if (PC) return yc;
  PC = 1, Object.defineProperty(yc, "__esModule", {
    value: !0
  }), yc.Cursor = void 0;
  var e = /* @__PURE__ */ function() {
    function t() {
      je(this, t);
    }
    return He(t, null, [{
      key: "setOffsetForGeneric",
      value: function(n, r) {
        for (var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, o = 0, l = 0; l < n.childNodes.length; l += 1) {
          var d = n.childNodes[l];
          if (d.childNodes.length > 0) {
            var c = t.setOffsetForGeneric(d, r, i);
            if (c === -1) return -1;
            i += c;
          } else if (d.textContent !== null) {
            if (i + d.textContent.length > r) {
              var u = document.createRange();
              u.setStart(d, r - i), u.collapse(!0);
              var m = window.getSelection();
              return m == null || m.removeAllRanges(), m == null || m.addRange(u), n.focus(), -1;
            }
            i += d.textContent.length, o += d.textContent.length;
          }
        }
        return o;
      }
    }, {
      key: "focusEndOfGeneric",
      value: function(n) {
        var r = document.createRange();
        r.selectNodeContents(n), r.collapse(!1);
        var i = window.getSelection();
        i && (i.removeAllRanges(), i.addRange(r));
      }
    }, {
      key: "setOffsetForSafariGeneric",
      value: function(n, r) {
        var i = window.getSelection();
        if (i) {
          var o = t.getGenericElementCursorOffset(n, i, !0);
          t.setOffsetForGeneric(n, o + r);
        }
      }
      // set to automatically scroll to cursor (scroll does not work in Safari)
    }, {
      key: "setOffsetForPrimitive",
      value: function(n, r, i) {
        i && n.blur(), n.setSelectionRange(r, r), n.focus();
      }
      // Scroll Input in Safari - does not work for TextArea and uses span which can have a different style
      // private static getCursorOffsetFromLeft(inputElement: HTMLInputElement, position: number) {
      //   // Get the value of the input element up to the cursor position
      //   const valueUpToCursor = inputElement.value.substring(0, position);
      //   // Create a temporary span element to measure the width of the text
      //   const tempSpan = document.createElement('span');
      //   tempSpan.textContent = valueUpToCursor;
      //   tempSpan.style.visibility = 'hidden';
      //   tempSpan.style.position = 'absolute';
      //   document.body.appendChild(tempSpan);
      //   // Measure the width of the text up to the cursor position
      //   const offsetWidth = tempSpan.offsetWidth;
      //   const offsetHeight = tempSpan.offsetHeight;
      //   // Clean up the temporary span element
      //   document.body.removeChild(tempSpan);
      //   return {left: offsetWidth, top: offsetHeight};
      // }
    }, {
      key: "getGenericElementCursorOffset",
      value: function(n, r, i) {
        var o = 0;
        if (r.rangeCount > 0) {
          var l = r.getRangeAt(0), d = l.cloneRange();
          d.selectNodeContents(n), i ? d.setEnd(l.startContainer, l.startOffset) : d.setEnd(l.endContainer, l.endOffset), o = d.toString().length;
        }
        return o;
      }
    }]);
  }();
  return yc.Cursor = e, yc;
}
var kC;
function W5() {
  if (kC) return fc;
  kC = 1, Object.defineProperty(fc, "__esModule", {
    value: !0
  }), fc.CommandUtils = void 0;
  var e = z5(), t = wf(), s = Vb(), n = Cf(), r = Af(), i = /* @__PURE__ */ function() {
    function o() {
      je(this, o);
    }
    return He(o, null, [{
      key: "processCommand",
      value: function(d, c) {
        return (!c || !c.caseSensitive) && (d = d.toLowerCase()), (c == null ? void 0 : c.substrings) === !1 ? r.Text.breakupIntoWordsArr(d) : d;
      }
    }, {
      key: "process",
      value: function(d) {
        var c;
        return ((c = d.settings) === null || c === void 0 ? void 0 : c.caseSensitive) === !0 ? d : Object.keys(d).reduce(function(u, m) {
          var f = d[m];
          return u[m] = typeof f == "string" ? o.processCommand(f, d.settings) : f, u;
        }, {});
      }
    }, {
      key: "toggleCommandModeOn",
      value: function(d) {
        var c;
        d.isWaitingForCommand = !0, (c = d.onCommandModeTrigger) === null || c === void 0 || c.call(d, !0);
      }
    }, {
      key: "toggleCommandModeOff",
      value: function(d) {
        var c;
        d.isWaitingForCommand && ((c = d.onCommandModeTrigger) === null || c === void 0 || c.call(d, !1), d.isWaitingForCommand = !1);
      }
    }, {
      key: "setText",
      value: function(d, c, u, m) {
        o.toggleCommandModeOff(d), t.Elements.isPrimitiveElement(m) ? (m.value = u, d.isTargetInShadow || n.Cursor.setOffsetForPrimitive(m, u.length, !0), s.Browser.IS_SAFARI() && d.autoScroll && e.AutoScroll.scrollSafariPrimitiveToEnd(m)) : (m.textContent = u, d.isTargetInShadow || n.Cursor.focusEndOfGeneric(m), setTimeout(function() {
          return e.AutoScroll.scrollGeneric(d, m);
        })), d.resetRecording(c);
      }
    }, {
      key: "checkIfMatchesSubstring",
      value: function(d, c) {
        return c.includes(d);
      }
    }, {
      key: "checkIfMatchesWord",
      value: function(d, c, u) {
        for (var m = d, f = u.length - 1; f >= 0; f -= 1) {
          for (var v = f, b = m.length - 1; u[v] === m[b] && b >= 0; ) v -= 1, b -= 1;
          if (b < 0) return !0;
        }
        return !1;
      }
      // prettier-ignore
    }, {
      key: "execCommand",
      value: function(d, c, u, m, f) {
        var v, b, w, S = d.commands;
        if (!(!S || !m || !u)) {
          var I = ((v = S.settings) === null || v === void 0 ? void 0 : v.caseSensitive) === !0 ? c : c.toLowerCase(), T = r.Text.breakupIntoWordsArr(I), x = ((b = S.settings) === null || b === void 0 ? void 0 : b.substrings) === !1 ? o.checkIfMatchesWord : o.checkIfMatchesSubstring;
          if (S.commandMode && x(S.commandMode, I, T)) return d.setInterimColorToFinal(), setTimeout(function() {
            return o.toggleCommandModeOn(d);
          }), {
            doNotProcessTranscription: !1
          };
          if (!(S.commandMode && !d.isWaitingForCommand)) {
            if (S.stop && x(S.stop, I, T)) return o.toggleCommandModeOff(d), setTimeout(function() {
              return d.stop();
            }), {
              doNotProcessTranscription: !1
            };
            if (S.pause && x(S.pause, I, T)) return o.toggleCommandModeOff(d), d.setInterimColorToFinal(), setTimeout(function() {
              var k;
              d.isPaused = !0, (k = d.onPauseTrigger) === null || k === void 0 || k.call(d, !0);
            }), {
              doNotProcessTranscription: !1
            };
            if (S.resume && x(S.resume, I, T)) return d.isPaused = !1, (w = d.onPauseTrigger) === null || w === void 0 || w.call(d, !1), o.toggleCommandModeOff(d), d.resetRecording(u), {
              doNotProcessTranscription: !0
            };
            if (S.reset && x(S.reset, I, T)) return f !== void 0 && o.setText(d, u, f, m), {
              doNotProcessTranscription: !0
            };
            if (S.removeAllText && x(S.removeAllText, I, T)) return o.setText(d, u, "", m), {
              doNotProcessTranscription: !0
            };
          }
        }
      }
    }]);
  }();
  return fc.CommandUtils = i, fc;
}
var bc = {}, EC;
function YHe() {
  if (EC) return bc;
  EC = 1, Object.defineProperty(bc, "__esModule", {
    value: !0
  }), bc.Highlight = void 0;
  var e = wf(), t = Cf(), s = /* @__PURE__ */ function() {
    function n() {
      je(this, n);
    }
    return He(n, null, [{
      key: "setStateForPrimitive",
      value: function(i, o) {
        var l, d;
        o.selectionStart !== null && (l = o.selectionStart), o.selectionEnd !== null && (d = o.selectionEnd), i.isHighlighted = l !== d;
      }
    }, {
      key: "setStateForGeneric",
      value: function(i, o) {
        var l = window.getSelection();
        if (l != null && l.focusNode) {
          var d = t.Cursor.getGenericElementCursorOffset(o, l, !0), c = t.Cursor.getGenericElementCursorOffset(o, l, !1);
          i.isHighlighted = d !== c;
        }
      }
    }, {
      key: "setState",
      value: function(i, o) {
        document.activeElement === o && (e.Elements.isPrimitiveElement(o) ? n.setStateForPrimitive(i, o) : n.setStateForGeneric(i, o));
      }
    }, {
      key: "removeForGeneric",
      value: function(i, o) {
        var l = window.getSelection();
        if (l) {
          var d = t.Cursor.getGenericElementCursorOffset(o, l, !0);
          l.deleteFromDocument(), t.Cursor.setOffsetForGeneric(o, d), i.isHighlighted = !1;
        }
      }
    }, {
      key: "removeForPrimitive",
      value: function(i, o) {
        var l = o.selectionStart, d = o.selectionEnd, c = o.value;
        if (l && d) {
          var u = c.substring(0, l) + c.substring(d);
          o.value = u, t.Cursor.setOffsetForPrimitive(o, l, i.autoScroll);
        }
        i.isHighlighted = !1;
      }
    }]);
  }();
  return bc.Highlight = s, bc;
}
var Ac = {}, IC;
function XHe() {
  if (IC) return Ac;
  IC = 1, Object.defineProperty(Ac, "__esModule", {
    value: !0
  }), Ac.Padding = void 0;
  var e = wf(), t = Cf(), s = Af(), n = /* @__PURE__ */ function() {
    function r() {
      je(this, r);
    }
    return He(r, null, [{
      key: "setStateForPrimitiveElement",
      value: function(o, l) {
        if (document.activeElement === l && l.selectionStart !== null) {
          var d = l.selectionStart, c = l.value[d - 1], u = l.selectionEnd === null ? d : l.selectionEnd, m = l.value[u];
          s.Text.isCharDefined(c) && (o.startPadding = " ", o.numberOfSpacesBeforeNewText = 1), s.Text.isCharDefined(m) && (o.endPadding = " ", o.numberOfSpacesAfterNewText = 1), o.isCursorAtEnd = l.value.length === u;
          return;
        }
        var f = l.value[l.value.length - 1];
        s.Text.isCharDefined(f) && (o.startPadding = " ", o.numberOfSpacesBeforeNewText = 1), o.isCursorAtEnd = !0;
      }
    }, {
      key: "setStateForGenericElement",
      value: function(o, l) {
        var d, c, u;
        if (document.activeElement === l) {
          var m = window.getSelection();
          if (m != null && m.focusNode) {
            var f = t.Cursor.getGenericElementCursorOffset(l, m, !0), v = (d = l.textContent) === null || d === void 0 ? void 0 : d[f - 1], b = t.Cursor.getGenericElementCursorOffset(l, m, !1), w = (c = l.textContent) === null || c === void 0 ? void 0 : c[b];
            s.Text.isCharDefined(v) && (o.startPadding = " "), s.Text.isCharDefined(w) && (o.endPadding = " "), o.isCursorAtEnd = ((u = l.textContent) === null || u === void 0 ? void 0 : u.length) === b;
            return;
          }
        }
        var S = l.innerText.charAt(l.innerText.length - 1);
        s.Text.isCharDefined(S) && (o.startPadding = " "), o.isCursorAtEnd = !0;
      }
    }, {
      key: "setState",
      value: function(o, l) {
        e.Elements.isPrimitiveElement(l) ? r.setStateForPrimitiveElement(o, l) : r.setStateForGenericElement(o, l);
      }
    }, {
      key: "adjustStateAfterRecodingPrimitiveElement",
      value: function(o, l) {
        if (o.primitiveTextRecorded = !0, o.insertInCursorLocation && document.activeElement === l && (l.selectionEnd !== null && (o.endPadding = o.endPadding + l.value.slice(l.selectionEnd)), l.selectionStart !== null)) {
          o.startPadding = l.value.slice(0, l.selectionStart) + o.startPadding;
          return;
        }
        o.startPadding = l.value + o.startPadding;
      }
    }, {
      key: "adjustSateForNoTextPrimitiveElement",
      value: function(o) {
        o.numberOfSpacesBeforeNewText === 1 && (o.startPadding = o.startPadding.substring(0, o.startPadding.length - 1), o.numberOfSpacesBeforeNewText = 0), o.numberOfSpacesAfterNewText === 1 && (o.endPadding = o.endPadding.substring(1), o.numberOfSpacesAfterNewText = 0);
      }
    }]);
  }();
  return Ac.Padding = n, Ac;
}
var TC;
function G5() {
  if (TC) return pc;
  TC = 1, Object.defineProperty(pc, "__esModule", {
    value: !0
  }), pc.Speech = void 0;
  var e = WHe(), t = GHe(), s = W5(), n = z5(), r = YHe(), i = wf(), o = XHe(), l = Vb(), d = Cf(), c = Af(), u = /* @__PURE__ */ function() {
    function m() {
      je(this, m), this.finalTranscript = "", this.interimSpan = i.Elements.createInterimSpan(), this.finalSpan = i.Elements.createGenericSpan(), this.scrollingSpan = i.Elements.createGenericSpan(), this.isCursorAtEnd = !1, this.spansPopulated = !1, this.startPadding = "", this.endPadding = "", this.numberOfSpacesBeforeNewText = 0, this.numberOfSpacesAfterNewText = 0, this.isHighlighted = !1, this.primitiveTextRecorded = !1, this.recognizing = !1, this._displayInterimResults = !0, this.insertInCursorLocation = !0, this.autoScroll = !0, this.isRestarting = !1, this.isPaused = !1, this.isWaitingForCommand = !1, this.isTargetInShadow = !1, this.cannotBeStopped = !1, this.resetState();
    }
    return He(m, [{
      key: "prepareBeforeStart",
      value: function(v) {
        var b, w;
        if (v != null && v.element) if (e.EventListeners.add(this, v), Array.isArray(v.element)) {
          var S = v.element.find(function(I) {
            return I === document.activeElement;
          }) || v.element[0];
          if (!S) return;
          this.prepare(S);
        } else this.prepare(v.element);
        (v == null ? void 0 : v.displayInterimResults) !== void 0 && (this._displayInterimResults = v.displayInterimResults), v != null && v.textColor && (this._finalTextColor = (b = v == null ? void 0 : v.textColor) === null || b === void 0 ? void 0 : b.final, i.Elements.applyCustomColors(this, v.textColor)), (v == null ? void 0 : v.insertInCursorLocation) !== void 0 && (this.insertInCursorLocation = v.insertInCursorLocation), (v == null ? void 0 : v.autoScroll) !== void 0 && (this.autoScroll = v.autoScroll), this._onResult = v == null ? void 0 : v.onResult, this._onPreResult = v == null ? void 0 : v.onPreResult, this._onStart = v == null ? void 0 : v.onStart, this._onStop = v == null ? void 0 : v.onStop, this._onError = v == null ? void 0 : v.onError, this.onCommandModeTrigger = v == null ? void 0 : v.onCommandModeTrigger, this.onPauseTrigger = v == null ? void 0 : v.onPauseTrigger, this._options = v, !((w = this._options) === null || w === void 0) && w.commands && (this.commands = s.CommandUtils.process(this._options.commands));
      }
    }, {
      key: "prepare",
      value: function(v) {
        o.Padding.setState(this, v), r.Highlight.setState(this, v), this.isTargetInShadow = i.Elements.isInsideShadowDOM(v), i.Elements.isPrimitiveElement(v) ? (this._primitiveElement = v, this._originalText = this._primitiveElement.value) : (this._genericElement = v, this._originalText = this._genericElement.textContent);
      }
      // there was an attempt to optimize this by not having to restart the service and just reset state:
      // unfortunately it did not work because the service would still continue firing the intermediate and final results
      // into the new position
    }, {
      key: "resetRecording",
      value: function(v) {
        this.isRestarting = !0, this.stop(!0), this.resetState(!0), this.start(v, !0);
      }
      // prettier-ignore
    }, {
      key: "updateElements",
      value: function(v, b, w) {
        var S, I = c.Text.capitalize(b);
        if (!(this.finalTranscript === I && v === "")) {
          t.PreResultUtils.process(this, w, v === "", this._onPreResult, this._options) && (v = "", w = "");
          var T = this.commands && s.CommandUtils.execCommand(this, w, this._options, this._primitiveElement || this._genericElement, this._originalText);
          if (T) {
            if (T.doNotProcessTranscription) return;
            v = "", w = "";
          }
          if (!(this.isPaused || this.isWaitingForCommand)) {
            (S = this._onResult) === null || S === void 0 || S.call(this, w, v === ""), this.finalTranscript = I, this._displayInterimResults || (v = "");
            var x = this.finalTranscript === "" && v === "";
            this._primitiveElement ? this.updatePrimitiveElement(this._primitiveElement, v, x) : this._genericElement && this.updateGenericElement(this._genericElement, v, x);
          }
        }
      }
      // prettier-ignore
      // remember that padding values here contain actual text left and right
    }, {
      key: "updatePrimitiveElement",
      value: function(v, b, w) {
        this.isHighlighted && r.Highlight.removeForPrimitive(this, v), this.primitiveTextRecorded || o.Padding.adjustStateAfterRecodingPrimitiveElement(this, v), w && o.Padding.adjustSateForNoTextPrimitiveElement(this);
        var S = this.startPadding + this.finalTranscript + b;
        if (v.value = S + this.endPadding, !this.isTargetInShadow) {
          var I = S.length + this.numberOfSpacesAfterNewText;
          d.Cursor.setOffsetForPrimitive(v, I, this.autoScroll);
        }
        this.autoScroll && l.Browser.IS_SAFARI() && this.isCursorAtEnd && n.AutoScroll.scrollSafariPrimitiveToEnd(v);
      }
    }, {
      key: "updateGenericElement",
      value: function(v, b, w) {
        this.isHighlighted && r.Highlight.removeForGeneric(this, v), this.spansPopulated || i.Elements.appendSpans(this, v);
        var S = (w ? "" : this.startPadding) + c.Text.lineBreak(this.finalTranscript);
        this.finalSpan.innerHTML = S;
        var I = n.AutoScroll.isRequired(this.autoScroll, v);
        n.AutoScroll.changeStateIfNeeded(this, I);
        var T = c.Text.lineBreak(b) + (w ? "" : this.endPadding);
        this.interimSpan.innerHTML = T, l.Browser.IS_SAFARI() && this.insertInCursorLocation && d.Cursor.setOffsetForSafariGeneric(v, S.length + T.length), I && n.AutoScroll.scrollGeneric(this, v), w && (this.scrollingSpan.innerHTML = "");
      }
    }, {
      key: "finalise",
      value: function(v) {
        this._genericElement && (v ? (this.finalSpan = i.Elements.createGenericSpan(), this.setInterimColorToFinal(), this.interimSpan = i.Elements.createInterimSpan(), this.scrollingSpan = i.Elements.createGenericSpan()) : this._genericElement.textContent = this._genericElement.textContent, this.spansPopulated = !1), e.EventListeners.remove(this);
      }
    }, {
      key: "setInterimColorToFinal",
      value: function() {
        this.interimSpan.style.color = this._finalTextColor || "black";
      }
    }, {
      key: "resetState",
      value: function(v) {
        this._primitiveElement = void 0, this._genericElement = void 0, this.finalTranscript = "", this.finalSpan.innerHTML = "", this.interimSpan.innerHTML = "", this.scrollingSpan.innerHTML = "", this.startPadding = "", this.endPadding = "", this.isHighlighted = !1, this.primitiveTextRecorded = !1, this.numberOfSpacesBeforeNewText = 0, this.numberOfSpacesAfterNewText = 0, v || (this.stopTimeout = void 0);
      }
    }, {
      key: "setStateOnStart",
      value: function() {
        var v;
        this.recognizing = !0, this.isRestarting ? this.isRestarting = !1 : (v = this._onStart) === null || v === void 0 || v.call(this);
      }
    }, {
      key: "setStateOnStop",
      value: function() {
        var v;
        this.recognizing = !1, this.isRestarting || (v = this._onStop) === null || v === void 0 || v.call(this);
      }
    }, {
      key: "setStateOnError",
      value: function(v) {
        var b;
        (b = this._onError) === null || b === void 0 || b.call(this, v), this.recognizing = !1;
      }
    }]);
  }();
  return pc.Speech = u, pc;
}
var OC;
function qHe() {
  if (OC) return ic;
  OC = 1, Object.defineProperty(ic, "__esModule", {
    value: !0
  }), ic.WebSpeech = void 0;
  var e = zHe(), t = Vb(), s = G5(), n = /* @__PURE__ */ function(r) {
    function i() {
      return je(this, i), jt(this, i);
    }
    return Ht(i, r), He(i, [{
      key: "start",
      value: function(l) {
        var d;
        this._extractText === void 0 && (this._extractText = t.Browser.IS_SAFARI() ? e.WebSpeechTranscript.extractSafari : e.WebSpeechTranscript.extract), this.validate() && (this.prepareBeforeStart(l), this.instantiateService(l), (d = this._service) === null || d === void 0 || d.start(), this._translations = l == null ? void 0 : l.translations);
      }
    }, {
      key: "validate",
      value: function() {
        return i.getAPI() ? !0 : (this.error("Speech Recognition is unsupported"), !1);
      }
    }, {
      key: "instantiateService",
      value: function(l) {
        var d, c, u = i.getAPI();
        this._service = new u(), this._service.continuous = !0, this._service.interimResults = (d = l == null ? void 0 : l.displayInterimResults) !== null && d !== void 0 ? d : !0, this._service.lang = ((c = l == null ? void 0 : l.language) === null || c === void 0 ? void 0 : c.trim()) || "en-US", this.setEvents();
      }
    }, {
      key: "setEvents",
      value: function() {
        var l = this;
        this._service && (this._service.onstart = function() {
          l.setStateOnStart();
        }, this._service.onerror = function(d) {
          t.Browser.IS_SAFARI() && d.message === "Another request is started" || d.error === "aborted" && l.isRestarting || d.error !== "no-speech" && l.error(d.message || d.error);
        }, this._service.onaudioend = function() {
          l.setStateOnStop();
        }, this._service.onend = function() {
          l._stopping = !1;
        }, this._service.onresult = function(d) {
          if (St(d.results) > "u" && l._service) l._service.onend = null, l._service.stop();
          else if (l._extractText && !l._stopping) {
            var c = l._extractText(d, l.finalTranscript, l._translations), u = c.interimTranscript, m = c.finalTranscript, f = c.newText;
            l.updateElements(u, m, f);
          }
        });
      }
    }, {
      key: "stop",
      value: function(l) {
        var d;
        this._stopping = !0, (d = this._service) === null || d === void 0 || d.stop(), this.finalise(l);
      }
    }, {
      key: "error",
      value: function(l) {
        console.error(l), this.setStateOnError(l), this.stop();
      }
    }], [{
      key: "getAPI",
      value: function() {
        return window.webkitSpeechRecognition || window.SpeechRecognition;
      }
    }]);
  }(s.Speech);
  return ic.WebSpeech = n, ic;
}
var wc = {}, RC;
function QHe() {
  if (RC) return wc;
  RC = 1, Object.defineProperty(wc, "__esModule", {
    value: !0
  }), wc.GlobalState = void 0;
  var e = /* @__PURE__ */ function() {
    function t() {
      je(this, t);
    }
    return He(t, null, [{
      key: "doubleClickDetector",
      value: function() {
        return t.doubleClickPending ? !0 : (t.doubleClickPending = !0, setTimeout(function() {
          t.doubleClickPending = !1;
        }, 300), !1);
      }
    }]);
  }();
  return wc.GlobalState = e, e.doubleClickPending = !1, wc;
}
var Cc = {}, Sc = {}, LC;
function KHe() {
  if (LC) return Sc;
  LC = 1, Object.defineProperty(Sc, "__esModule", {
    value: !0
  }), Sc.PreventConnectionStop = void 0;
  var e = /* @__PURE__ */ function() {
    function t() {
      je(this, t);
    }
    return He(t, null, [{
      key: "applyPrevention",
      value: function(n) {
        clearTimeout(n._manualConnectionStopPrevention), n.cannotBeStopped = !0, n._manualConnectionStopPrevention = setTimeout(function() {
          n.cannotBeStopped = !1;
        }, 800);
      }
    }, {
      key: "clearPrevention",
      value: function(n) {
        clearTimeout(n._manualConnectionStopPrevention), n.cannotBeStopped = !1;
      }
    }]);
  }();
  return Sc.PreventConnectionStop = e, Sc;
}
var Pc = {}, Hp = {}, BC;
function ZHe() {
  return BC || (BC = 1, Object.defineProperty(Hp, "__esModule", {
    value: !0
  }), Hp.README_URL = void 0, Hp.README_URL = "https://github.com/OvidijusParsiunas/speech-to-element"), Hp;
}
var MC;
function JHe() {
  if (MC) return Pc;
  MC = 1, Object.defineProperty(Pc, "__esModule", {
    value: !0
  }), Pc.AzureSpeechConfig = void 0;
  var e = ZHe(), t = /* @__PURE__ */ function() {
    function s() {
      je(this, s);
    }
    return He(s, null, [{
      key: "validateOptions",
      value: function(r, i) {
        return i ? !i.subscriptionKey && !i.token && !i.retrieveToken ? (r("Please define a 'subscriptionKey', 'token' or 'retrieveToken' property - more info: ".concat(e.README_URL)), !1) : i.region ? !0 : (r("Please define a 'region' property - more info: ".concat(e.README_URL)), !1) : (r("Please provide subscription details - more info: ".concat(e.README_URL)), !1);
      }
    }, {
      key: "getNewSpeechConfig",
      value: function() {
        var n = Qe(/* @__PURE__ */ ce().mark(function i(o, l) {
          return ce().wrap(function(c) {
            for (; ; ) switch (c.prev = c.next) {
              case 0:
                if (!l.region) {
                  c.next = 2;
                  break;
                }
                return c.abrupt("return", l.subscriptionKey ? o.fromSubscription(l.subscriptionKey.trim(), l.region.trim()) : l.token ? o.fromAuthorizationToken(l.token.trim(), l.region.trim()) : l.retrieveToken ? l.retrieveToken().then(function(u) {
                  return l.region ? o.fromAuthorizationToken((u == null ? void 0 : u.trim()) || "", l.region.trim()) : null;
                }).catch(function(u) {
                  return console.error(u), null;
                }) : null);
              case 2:
              case "end":
                return c.stop();
            }
          }, i);
        }));
        function r(i, o) {
          return n.apply(this, arguments);
        }
        return r;
      }()
    }, {
      key: "process",
      value: function(r, i) {
        i.endpointId && (r.endpointId = i.endpointId.trim()), i.language && (r.speechRecognitionLanguage = i.language.trim());
      }
    }, {
      key: "get",
      value: function() {
        var n = Qe(/* @__PURE__ */ ce().mark(function i(o, l) {
          var d;
          return ce().wrap(function(u) {
            for (; ; ) switch (u.prev = u.next) {
              case 0:
                return u.next = 2, s.getNewSpeechConfig(o, l);
              case 2:
                return d = u.sent, u.abrupt("return", (d && s.process(d, l), d));
              case 4:
              case "end":
                return u.stop();
            }
          }, i);
        }));
        function r(i, o) {
          return n.apply(this, arguments);
        }
        return r;
      }()
    }]);
  }();
  return Pc.AzureSpeechConfig = t, Pc;
}
var kc = {}, xC;
function $He() {
  if (xC) return kc;
  xC = 1, Object.defineProperty(kc, "__esModule", {
    value: !0
  }), kc.StopTimeout = void 0;
  var e = /* @__PURE__ */ function() {
    function t() {
      je(this, t);
    }
    return He(t, null, [{
      key: "set",
      value: function(n) {
        n.stopTimeout = setTimeout(function() {
          return n.stop();
        }, n.stopTimeoutMS);
      }
    }, {
      key: "reset",
      value: function(n, r) {
        n.stopTimeoutMS = r || t.DEFAULT_MS, t.stop(n), t.set(n);
      }
    }, {
      key: "stop",
      value: function(n) {
        n.stopTimeout && clearTimeout(n.stopTimeout);
      }
    }]);
  }();
  return kc.StopTimeout = e, e.DEFAULT_MS = 2e4, kc;
}
var Ec = {}, FC;
function _He() {
  if (FC) return Ec;
  FC = 1, Object.defineProperty(Ec, "__esModule", {
    value: !0
  }), Ec.AzureAudioConfig = void 0;
  var e = /* @__PURE__ */ function() {
    function t() {
      je(this, t);
    }
    return He(t, null, [{
      key: "get",
      value: function(n, r) {
        return r ? n.fromMicrophoneInput(r) : n.fromDefaultMicrophoneInput();
      }
    }]);
  }();
  return Ec.AzureAudioConfig = e, Ec;
}
var Ic = {}, VC;
function eUe() {
  if (VC) return Ic;
  VC = 1, Object.defineProperty(Ic, "__esModule", {
    value: !0
  }), Ic.AzureTranscript = void 0;
  var e = U5(), t = /* @__PURE__ */ function() {
    function s() {
      je(this, s);
    }
    return He(s, null, [{
      key: "extract",
      value: (
        // newText is used to only send new text in onResult as finalTranscript is continuously accumulated
        function(r, i, o, l) {
          return l && (r = e.Translate.translate(r, l)), o ? {
            interimTranscript: "",
            finalTranscript: i + r,
            newText: r
          } : {
            interimTranscript: r,
            finalTranscript: i,
            newText: r
          };
        }
      )
    }]);
  }();
  return Ic.AzureTranscript = t, Ic;
}
var DC;
function tUe() {
  if (DC) return Cc;
  DC = 1, Object.defineProperty(Cc, "__esModule", {
    value: !0
  }), Cc.Azure = void 0;
  var e = KHe(), t = JHe(), s = $He(), n = _He(), r = eUe(), i = G5(), o = /* @__PURE__ */ function(l) {
    function d() {
      var c;
      return je(this, d), c = jt(this, d, arguments), c._newTextPadding = "", c;
    }
    return Ht(d, l), He(d, [{
      key: "start",
      value: function(u, m) {
        this._newTextPadding = "", this.stopTimeout === void 0 && s.StopTimeout.reset(this, u == null ? void 0 : u.stopAfterSilenceMs), this.prepareBeforeStart(u), this.startAsync(u), m || e.PreventConnectionStop.applyPrevention(this);
      }
    }, {
      key: "startAsync",
      value: function() {
        var c = Qe(/* @__PURE__ */ ce().mark(function m(f) {
          var v;
          return ce().wrap(function(w) {
            for (; ; ) switch (w.prev = w.next) {
              case 0:
                if (w.t0 = this.validate(f), !w.t0) {
                  w.next = 6;
                  break;
                }
                return w.next = 4, this.instantiateService(f);
              case 4:
                this._translations = f == null ? void 0 : f.translations, (v = this._service) === null || v === void 0 || v.startContinuousRecognitionAsync(function() {
                }, this.error);
              case 6:
              case "end":
                return w.stop();
            }
          }, m, this);
        }));
        function u(m) {
          return c.apply(this, arguments);
        }
        return u;
      }()
    }, {
      key: "validate",
      value: function(u) {
        return d.getAPI() ? t.AzureSpeechConfig.validateOptions(this.error.bind(this), u) : (this.moduleNotFound(), !1);
      }
    }, {
      key: "instantiateService",
      value: function() {
        var c = Qe(/* @__PURE__ */ ce().mark(function m(f) {
          var v, b, w, S, I, T, x, k, C;
          return ce().wrap(function(E) {
            for (; ; ) switch (E.prev = E.next) {
              case 0:
                return v = d.getAPI(), b = n.AzureAudioConfig.get(v.AudioConfig, f.deviceId), E.next = 4, t.AzureSpeechConfig.get(v.SpeechConfig, f);
              case 4:
                w = E.sent, w ? (f.autoLanguage && f.autoLanguage.languages.length > 0 ? (I = f.autoLanguage, T = I.type, x = I.languages, k = x.slice(0, T === "Continuous" ? 10 : 4), C = v.AutoDetectSourceLanguageConfig.fromLanguages(k), T === "Continuous" && (C.mode = 1), S = v.SpeechRecognizer.FromConfig(w, C, b)) : S = new v.SpeechRecognizer(w, b), this.setEvents(S), this._service = S, f.retrieveToken && this.retrieveTokenInterval(f.retrieveToken)) : this.error("Unable to contact Azure server");
              case 6:
              case "end":
                return E.stop();
            }
          }, m, this);
        }));
        function u(m) {
          return c.apply(this, arguments);
        }
        return u;
      }()
    }, {
      key: "setEvents",
      value: function(u) {
        u.recognizing = this.onRecognizing.bind(this), u.recognized = this.onRecognized.bind(this), u.sessionStarted = this.onSessionStarted.bind(this), u.canceled = this.onCanceled.bind(this), u.sessionStopped = this.onSessionStopped.bind(this);
      }
      // prettier-ignore
    }, {
      key: "onRecognizing",
      value: function(u, m) {
        if (!this._stopping) {
          var f = r.AzureTranscript.extract(this._newTextPadding + m.result.text, this.finalTranscript, !1, this._translations), v = f.interimTranscript, b = f.finalTranscript, w = f.newText;
          s.StopTimeout.reset(this, this.stopTimeoutMS), this.updateElements(v, b, w);
        }
      }
      // prettier-ignore
    }, {
      key: "onRecognized",
      value: function(u, m) {
        var f = m.result;
        switch (f.reason) {
          case window.SpeechSDK.ResultReason.Canceled:
            break;
          case window.SpeechSDK.ResultReason.RecognizedSpeech:
            if (f.text && !this._stopping) {
              var v = r.AzureTranscript.extract(this._newTextPadding + f.text, this.finalTranscript, !0, this._translations), b = v.interimTranscript, w = v.finalTranscript, S = v.newText;
              s.StopTimeout.reset(this, this.stopTimeoutMS), this.updateElements(b, w, S), w !== "" && (this._newTextPadding = " ");
            }
            break;
        }
      }
    }, {
      key: "onCanceled",
      value: function(u, m) {
        m.reason === window.SpeechSDK.CancellationReason.Error && this.error(m.errorDetails);
      }
    }, {
      key: "onSessionStarted",
      value: function() {
        e.PreventConnectionStop.clearPrevention(this), this.setStateOnStart();
      }
    }, {
      key: "onSessionStopped",
      value: function() {
        this._retrieveTokenInterval || clearInterval(this._retrieveTokenInterval), this._stopping = !1, this.setStateOnStop();
      }
    }, {
      key: "retrieveTokenInterval",
      value: function(u) {
        var m = this;
        this._retrieveTokenInterval = setInterval(function() {
          u == null || u().then(function(f) {
            m._service && (m._service.authorizationToken = (f == null ? void 0 : f.trim()) || "");
          }).catch(function(f) {
            m.error(f);
          });
        }, 1e4);
      }
    }, {
      key: "stop",
      value: function(u) {
        var m;
        !u && this._retrieveTokenInterval && clearInterval(this._retrieveTokenInterval), this._stopping = !0, (m = this._service) === null || m === void 0 || m.stopContinuousRecognitionAsync(), s.StopTimeout.stop(this), this.finalise(u);
      }
    }, {
      key: "moduleNotFound",
      value: function() {
        console.error("speech recognition module not found:"), console.error(`please install the 'microsoft-cognitiveservices-speech-sdk' npm package or add a script tag: <script src="https://aka.ms/csspeech/jsbrowserpackageraw"><\/script>`), this.setStateOnError("speech recognition module not found");
      }
    }, {
      key: "error",
      value: function(u) {
        this._retrieveTokenInterval && clearInterval(this._retrieveTokenInterval), console.error(u), this.setStateOnError(u), this.stop();
      }
    }], [{
      key: "getAPI",
      value: function() {
        return window.SpeechSDK;
      }
    }]);
  }(i.Speech);
  return Cc.Azure = o, Cc;
}
var NC;
function sUe() {
  if (NC) return jp;
  NC = 1, Object.defineProperty(jp, "__esModule", {
    value: !0
  });
  var e = qHe(), t = W5(), s = QHe(), n = tUe(), r = /* @__PURE__ */ function() {
    function i() {
      je(this, i);
    }
    return He(i, null, [{
      key: "toggle",
      value: function(l, d) {
        var c, u, m = l.toLocaleLowerCase().trim();
        !((c = s.GlobalState.service) === null || c === void 0) && c.recognizing ? this.stop() : m === "webspeech" ? i.startWebSpeech(d) : m === "azure" ? i.startAzure(d) : (console.error("service not found - must be either 'webspeech' or 'azure'"), (u = d == null ? void 0 : d.onError) === null || u === void 0 || u.call(d, "service not found - must be either 'webspeech' or 'azure'"));
      }
    }, {
      key: "startWebSpeech",
      value: function(l) {
        i.stop() || (s.GlobalState.service = new e.WebSpeech(), s.GlobalState.service.start(l));
      }
    }, {
      key: "isWebSpeechSupported",
      value: function() {
        return !!e.WebSpeech.getAPI();
      }
    }, {
      key: "startAzure",
      value: function(l) {
        var d;
        i.stop() || !((d = s.GlobalState.service) === null || d === void 0) && d.cannotBeStopped || (s.GlobalState.service = new n.Azure(), s.GlobalState.service.start(l));
      }
    }, {
      key: "stop",
      value: function() {
        var l;
        return s.GlobalState.doubleClickDetector() ? !0 : (!((l = s.GlobalState.service) === null || l === void 0) && l.recognizing && s.GlobalState.service.stop(), !1);
      }
    }, {
      key: "endCommandMode",
      value: function() {
        s.GlobalState.service && t.CommandUtils.toggleCommandModeOff(s.GlobalState.service);
      }
    }]);
  }();
  return jp.default = r, jp;
}
var aUe = sUe(), Vh = /* @__PURE__ */ UHe(aUe), nUe = /* @__PURE__ */ function() {
  function e(t, s) {
    je(this, e), this._silenceMS = 2e3, this._stop = !0, typeof s == "boolean" && s === !1 && (this._stop = !1), typeof t == "number" && (this._silenceMS = t);
  }
  return He(e, [{
    key: "setSilenceTimeout",
    value: function(s, n) {
      var r = this;
      this._silenceTimeout = setTimeout(function() {
        var i;
        (i = s.submit) == null || i.call(s), Vh.stop(), r._stop || setTimeout(n, Db.MICROPHONE_RESET_TIMEOUT_MS);
      }, this._silenceMS);
    }
  }, {
    key: "clearSilenceTimeout",
    value: function() {
      this._silenceTimeout && clearTimeout(this._silenceTimeout);
    }
  }, {
    key: "resetSilenceTimeout",
    value: function(s, n) {
      this.clearSilenceTimeout(), this.setSilenceTimeout(s, n);
    }
  }, {
    key: "onPause",
    value: function(s, n, r) {
      s ? this.resetSilenceTimeout(n, r) : this.clearSilenceTimeout();
    }
  }]);
}(), Y5 = /* @__PURE__ */ function(e) {
  function t(s, n, r) {
    var i;
    je(this, t);
    var o = St(s.speechToText) == "object" ? s.speechToText : {};
    i = jt(this, t, [o == null ? void 0 : o.button]);
    var l = i.processConfiguration(n, s.speechToText), d = l.serviceName, c = l.processedConfig;
    if (i._addErrorMessage = r, d === "webspeech" && !Vh.isWebSpeechSupported()) i.changeToUnsupported();
    else {
      var u = !s.textInput || !s.textInput.disabled;
      i.elementRef.onclick = i.buttonClick.bind(i, n, u, d, c);
    }
    return setTimeout(function() {
      i._validationHandler = s._validationHandler;
    }), i;
  }
  return Ht(t, e), He(t, [{
    key: "processConfiguration",
    value: function(n, r) {
      var i, o, l, d, c, u, m = St(r) == "object" ? r : {}, f = St(m.webSpeech) == "object" ? m.webSpeech : {}, v = m.azure || {}, b = ys(ys({
        displayInterimResults: (i = m.displayInterimResults) !== null && i !== void 0 ? i : void 0,
        textColor: (o = m.textColor) !== null && o !== void 0 ? o : void 0,
        translations: (l = m.translations) !== null && l !== void 0 ? l : void 0,
        commands: (d = m.commands) !== null && d !== void 0 ? d : void 0,
        events: (c = m.events) !== null && c !== void 0 ? c : void 0
      }, f), v), w = (u = m.commands) == null ? void 0 : u.submit;
      return w && (b.onPreResult = function(S) {
        return S.toLowerCase().includes(w) ? (setTimeout(function() {
          var I;
          return (I = n.submit) == null ? void 0 : I.call(n);
        }), Vh.endCommandMode(), {
          restart: !0,
          removeNewText: !0
        }) : null;
      }), m.submitAfterSilence && (this._silenceSubmit = new nUe(m.submitAfterSilence, m.stopAfterSubmit)), {
        serviceName: t.getServiceName(m),
        processedConfig: b
      };
    }
  }, {
    key: "buttonClick",
    value: function(n, r, i, o) {
      var l = this, d = o == null ? void 0 : o.events;
      n.removePlaceholderStyle(), Vh.toggle(i, ys({
        insertInCursorLocation: !1,
        element: r ? n.inputElementRef : void 0,
        onError: function() {
          var u;
          l.onError(), (u = l._silenceSubmit) == null || u.clearSilenceTimeout();
        },
        onStart: function() {
          var u;
          l.changeToActive(), (u = d == null ? void 0 : d.onStart) == null || u.call(d);
        },
        onStop: function() {
          var u, m, f;
          (u = l._validationHandler) == null || u.call(l), (m = l._silenceSubmit) == null || m.clearSilenceTimeout(), l.changeToDefault(), (f = d == null ? void 0 : d.onStop) == null || f.call(d);
        },
        onPauseTrigger: function(u) {
          var m, f;
          (m = l._silenceSubmit) == null || m.onPause(u, n, l.elementRef.onclick), (f = d == null ? void 0 : d.onPauseTrigger) == null || f.call(d, u);
        },
        onPreResult: function(u, m) {
          var f;
          (f = d == null ? void 0 : d.onPreResult) == null || f.call(d, u, m);
        },
        onResult: function(u, m) {
          var f, v, b;
          m && ((f = l._validationHandler) == null || f.call(l)), (v = l._silenceSubmit) == null || v.resetSilenceTimeout(n, l.elementRef.onclick), (b = d == null ? void 0 : d.onResult) == null || b.call(d, u, m);
        },
        onCommandModeTrigger: function(u) {
          var m;
          l.onCommandModeTrigger(u), (m = d == null ? void 0 : d.onCommandModeTrigger) == null || m.call(d, u);
        }
      }, o));
    }
  }, {
    key: "onCommandModeTrigger",
    value: function(n) {
      n ? this.changeToCommandMode() : this.changeToActive();
    }
  }, {
    key: "onError",
    value: function() {
      this._addErrorMessage("speechToText", "speech input error");
    }
  }], [{
    key: "getServiceName",
    value: function(n) {
      return n.azure ? "azure" : "webspeech";
    }
  }, {
    key: "toggleSpeechAfterSubmit",
    value: function(n) {
      var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
      n.click(), r || setTimeout(function() {
        return n.click();
      }, t.MICROPHONE_RESET_TIMEOUT_MS);
    }
  }]);
}(H5);
Y5.MICROPHONE_RESET_TIMEOUT_MS = 300;
var Db = Y5, Nb = /* @__PURE__ */ function() {
  function e(t, s, n, r, i) {
    var o = this;
    je(this, e), this._attachments = [], this._fileCountLimit = 99, this._acceptedFormat = "", this._hiddenAttachments = /* @__PURE__ */ new Set(), n.maxNumberOfFiles && (this._fileCountLimit = n.maxNumberOfFiles), this._toggleContainerDisplay = r, this._fileAttachmentsContainerRef = i, n.acceptedFormats && (this._acceptedFormat = n.acceptedFormats), setTimeout(function() {
      o._validationHandler = t._validationHandler, o._onInput = s.onInput;
    });
  }
  return He(e, [{
    key: "attemptAddFile",
    value: function(s, n) {
      var r;
      return e.isFileTypeValid(s, this._acceptedFormat) ? (this.addAttachmentBasedOnType(s, n, !0), (r = this._onInput) == null || r.call(this, !0), !0) : !1;
    }
  }, {
    key: "addAttachmentBasedOnType",
    value: function(s, n, r) {
      var i = e.getTypeFromBlob(s);
      if (i === "image") {
        var o = e.createImageAttachment(n);
        this.addFileAttachment(s, "image", o, r);
      } else if (i === "audio") {
        var l = Dy.createAudioAttachment(n);
        this.addFileAttachment(s, "audio", l, r);
      } else {
        var d = e.createAnyFileAttachment(s.name);
        this.addFileAttachment(s, "any", d, r);
      }
    }
  }, {
    key: "addFileAttachment",
    value: function(s, n, r, i) {
      var o, l = e.createContainer(r);
      if (this._attachments.length >= this._fileCountLimit) {
        var d = this._attachments[this._attachments.length - 1].removeButton;
        d == null || d.click();
        var c = this._fileAttachmentsContainerRef.children;
        this._fileAttachmentsContainerRef.insertBefore(l, c[0]);
      } else this._fileAttachmentsContainerRef.appendChild(l);
      var u = {
        file: s,
        attachmentContainerElement: l,
        fileType: n
      };
      return i && (u.removeButton = this.createRemoveAttachmentButton(u), l.appendChild(u.removeButton)), this._toggleContainerDisplay(!0), this._attachments.push(u), this._fileAttachmentsContainerRef.scrollTop = this._fileAttachmentsContainerRef.scrollHeight, (o = this._validationHandler) == null || o.call(this), u;
    }
  }, {
    key: "createRemoveAttachmentButton",
    value: function(s) {
      var n = document.createElement("div");
      n.classList.add("remove-file-attachment-button"), n.onclick = this.removeAttachment.bind(this, s);
      var r = document.createElement("div");
      return r.classList.add("x-icon"), r.innerText = "×", n.appendChild(r), n;
    }
  }, {
    key: "removeAttachment",
    value: function(s, n) {
      var r, i;
      (r = this._onInput) == null || r.call(this, !!(n != null && n.isTrusted));
      var o = this._attachments.findIndex(function(d) {
        return d === s;
      }), l = this._attachments[o].attachmentContainerElement;
      this._attachments.splice(o, 1), Dy.stopAttachmentPlayback(l), l.remove(), this._toggleContainerDisplay(!1), (i = this._validationHandler) == null || i.call(this);
    }
  }, {
    key: "getFiles",
    value: function() {
      return Array.from(this._attachments).map(function(s) {
        return {
          file: s.file,
          type: s.fileType
        };
      });
    }
  }, {
    key: "hideAttachments",
    value: function() {
      var s = this;
      this._hiddenAttachments.clear(), this._attachments.forEach(function(n) {
        setTimeout(function() {
          var r;
          return (r = n.removeButton) == null ? void 0 : r.click();
        }), s._hiddenAttachments.add(n);
      });
    }
  }, {
    key: "removeAttachments",
    value: function() {
      this._attachments.forEach(function(s) {
        setTimeout(function() {
          var n;
          return (n = s.removeButton) == null ? void 0 : n.click();
        });
      }), this._hiddenAttachments.clear();
    }
  }, {
    key: "readdAttachments",
    value: function() {
      var s = this, n;
      Array.from(this._hiddenAttachments).forEach(function(r) {
        s._fileAttachmentsContainerRef.appendChild(r.attachmentContainerElement), s._attachments.push(r);
      }), (n = this._onInput) == null || n.call(this, !1), this._hiddenAttachments.clear();
    }
  }], [{
    key: "isFileTypeValid",
    value: function(s, n) {
      if (n === "") return !0;
      for (var r = n.split(","), i = 0; i < r.length; i++) {
        var o = r[i].trim();
        if (s.type === o) return !0;
        if (o.startsWith(".")) {
          var l = o.slice(1);
          if (s.name.endsWith(l)) return !0;
        } else if (s.name.endsWith(o) || o.endsWith("/*") && s.type.startsWith(o.slice(0, -2))) return !0;
      }
      return !1;
    }
  }, {
    key: "getTypeFromBlob",
    value: function(s) {
      var n = s.type;
      return n.startsWith("image") ? "image" : n.startsWith("audio") ? "audio" : "any";
    }
  }, {
    key: "createImageAttachment",
    value: function(s) {
      var n = new Image();
      return n.src = s, n.classList.add("image-attachment"), n;
    }
  }, {
    key: "createAnyFileAttachment",
    value: function(s) {
      var n = document.createElement("div");
      n.classList.add("border-bound-attachment"), el.IS_SAFARI && n.classList.add("border-bound-attachment-safari");
      var r = document.createElement("div");
      r.classList.add("any-file-attachment-text");
      var i = document.createElement("div");
      return i.classList.add("file-attachment-text-container"), i.appendChild(r), r.textContent = s, n.appendChild(i), n;
    }
  }, {
    key: "createContainer",
    value: function(s) {
      var n = document.createElement("div");
      return n.classList.add("file-attachment"), n.appendChild(s), n;
    }
  }]);
}(), X5 = /* @__PURE__ */ function(e) {
  function t(s, n, r, i, o) {
    return je(this, t), jt(this, t, [s, n, r, i, o]);
  }
  return Ht(t, e), He(t, [{
    key: "createTimer",
    value: function(n, r) {
      var i = this, o = 0, l = r !== void 0 && r < t.TIMER_LIMIT_S ? r : t.TIMER_LIMIT_S;
      return setInterval(function() {
        var d;
        o += 1, o === l && ((d = i.stopPlaceholderCallback) == null || d.call(i), i.clearTimer()), o === 600 && n.classList.add("audio-placeholder-text-4-digits");
        var c = Math.floor(o / 60), u = (o % 60).toString().padStart(2, "0");
        n.textContent = "".concat(c, ":").concat(u);
      }, 1e3);
    }
  }, {
    key: "createPlaceholderAudioAttachment",
    value: function(n) {
      var r = t.createAudioContainer(), i = document.createElement("div");
      i.classList.add("audio-placeholder-text-3-digits");
      var o = document.createElement("div");
      o.classList.add("file-attachment-text-container", "audio-placeholder-text-3-digits-container"), o.appendChild(i);
      var l = Ro.createSVGElement(By);
      return l.classList.add("attachment-icon", "stop-icon", "not-removable-attachment-icon"), i.textContent = "0:00", this._activePlaceholderTimer = this.createTimer(i, n), r.appendChild(o), this.addPlaceholderAudioAttachmentEvents(r, l, o), r;
    }
  }, {
    key: "addPlaceholderAudioAttachmentEvents",
    value: function(n, r, i) {
      var o = this, l = function() {
        return n.replaceChildren(r);
      };
      n.addEventListener("mouseenter", l);
      var d = function() {
        return n.replaceChildren(i);
      };
      n.addEventListener("mouseleave", d);
      var c = function() {
        var m;
        return (m = o.stopPlaceholderCallback) == null ? void 0 : m.call(o);
      };
      n.addEventListener("click", c);
    }
  }, {
    key: "addPlaceholderAttachment",
    value: function(n, r) {
      var i = this.createPlaceholderAudioAttachment(r);
      this._activePlaceholderAttachment = this.addFileAttachment(new File([], ""), "audio", i, !1), this.stopPlaceholderCallback = n;
    }
    // prettier-ignore
  }, {
    key: "completePlaceholderAttachment",
    value: function(n, r) {
      var i = this._activePlaceholderAttachment;
      i && (i.file = n, t.addAudioElements(i.attachmentContainerElement.children[0], r), i.removeButton = this.createRemoveAttachmentButton(i), i.attachmentContainerElement.appendChild(i.removeButton), this._activePlaceholderAttachment = void 0, this.clearTimer());
    }
  }, {
    key: "removePlaceholderAttachment",
    value: function() {
      this._activePlaceholderAttachment && (this.removeAttachment(this._activePlaceholderAttachment), this._activePlaceholderAttachment = void 0, this.clearTimer());
    }
  }, {
    key: "clearTimer",
    value: function() {
      this._activePlaceholderTimer !== void 0 && (clearInterval(this._activePlaceholderTimer), this._activePlaceholderTimer = void 0, this.stopPlaceholderCallback = void 0);
    }
  }], [{
    key: "createAudioContainer",
    value: function() {
      var n = document.createElement("div");
      return n.classList.add("border-bound-attachment", "audio-attachment-icon-container"), el.IS_SAFARI && n.classList.add("border-bound-attachment-safari"), n;
    }
  }, {
    key: "addAudioElements",
    value: function(n, r) {
      var i = n.parentElement ? Ln.cloneElement(n) : n, o = document.createElement("audio");
      o.src = r;
      var l = Ro.createSVGElement(M5);
      l.classList.add("attachment-icon", "play-icon");
      var d = Ro.createSVGElement(By);
      d.classList.add("attachment-icon", "stop-icon"), i.replaceChildren(l), o.onplay = function() {
        i.replaceChildren(d);
      }, o.onpause = function() {
        i.replaceChildren(l), o.currentTime = 0;
      }, o.onended = function() {
        i.replaceChildren(l);
      }, i.onclick = function() {
        o.paused ? o.play() : o.pause();
      };
    }
  }, {
    key: "createAudioAttachment",
    value: function(n) {
      var r = t.createAudioContainer();
      return t.addAudioElements(r, n), r;
    }
  }, {
    key: "stopAttachmentPlayback",
    value: function(n) {
      var r, i, o;
      (o = (i = (r = n.children[0]) == null ? void 0 : r.children) == null ? void 0 : i[0]) != null && o.classList.contains("stop-icon") && n.children[0].click();
    }
  }]);
}(Nb);
X5.TIMER_LIMIT_S = 5999;
var Dy = X5, rUe = /* @__PURE__ */ function() {
  function e() {
    je(this, e);
  }
  return He(e, null, [{
    key: "create",
    value: (
      // prettier-ignore
      function(s, n, r, i, o, l) {
        return l === "audio" ? new Dy(s, n, r, i, o) : new Nb(s, n, r, i, o);
      }
    )
  }]);
}(), jb = /* @__PURE__ */ function() {
  function e(t, s, n) {
    je(this, e), this._fileAttachmentsTypes = [], this.elementRef = this.createAttachmentContainer();
    var r = St(n) == "object" && !!n.displayFileAttachmentContainer;
    this.toggleContainerDisplay(r), t.appendChild(this.elementRef), s && Object.assign(this.elementRef.style, s);
  }
  return He(e, [{
    key: "addType",
    value: function(s, n, r, i) {
      var o = rUe.create(s, n, r, this.toggleContainerDisplay.bind(this), this.elementRef, i);
      return this._fileAttachmentsTypes.push(o), o;
    }
  }, {
    key: "createAttachmentContainer",
    value: function() {
      var s = document.createElement("div");
      return s.id = "file-attachment-container", s;
    }
  }, {
    key: "toggleContainerDisplay",
    value: function(s) {
      s ? this.elementRef.style.display = "block" : this.elementRef.children.length === 0 && (this.elementRef.style.display = "none");
    }
  }, {
    key: "getAllFileData",
    value: function() {
      var s = this._fileAttachmentsTypes.map(function(n) {
        return n.getFiles();
      }).flat();
      return s.length > 0 ? s : void 0;
    }
  }, {
    key: "completePlaceholders",
    value: function() {
      var t = Qe(/* @__PURE__ */ ce().mark(function n() {
        return ce().wrap(function(i) {
          for (; ; ) switch (i.prev = i.next) {
            case 0:
              return i.next = 2, Promise.all(this._fileAttachmentsTypes.map(/* @__PURE__ */ function() {
                var o = Qe(/* @__PURE__ */ ce().mark(function l(d) {
                  var c;
                  return ce().wrap(function(m) {
                    for (; ; ) switch (m.prev = m.next) {
                      case 0:
                        return m.abrupt("return", (c = d.stopPlaceholderCallback) == null ? void 0 : c.call(d));
                      case 1:
                      case "end":
                        return m.stop();
                    }
                  }, l);
                }));
                return function(l) {
                  return o.apply(this, arguments);
                };
              }()));
            case 2:
            case "end":
              return i.stop();
          }
        }, n, this);
      }));
      function s() {
        return t.apply(this, arguments);
      }
      return s;
    }()
  }, {
    key: "addFilesToAnyType",
    value: function(s) {
      e.addFilesToType(s, this._fileAttachmentsTypes);
    }
  }, {
    key: "hideFiles",
    value: function() {
      this._fileAttachmentsTypes.forEach(function(s) {
        return s.hideAttachments();
      }), this.elementRef.replaceChildren(), this.toggleContainerDisplay(!1);
    }
  }, {
    key: "removeHiddenFiles",
    value: function() {
      this._fileAttachmentsTypes.forEach(function(s) {
        return s.removeAttachments();
      });
    }
  }, {
    key: "readdHiddenFiles",
    value: function() {
      this._fileAttachmentsTypes.forEach(function(s) {
        return s.readdAttachments();
      }), this.toggleContainerDisplay(!0);
    }
  }, {
    key: "getNumberOfTypes",
    value: function() {
      return this._fileAttachmentsTypes.length;
    }
  }], [{
    key: "addFilesToType",
    value: function(s, n) {
      s.forEach(function(r) {
        var i = new FileReader();
        i.readAsDataURL(r), i.onload = function(o) {
          for (var l = 0; l < n.length && !n[l].attemptAddFile(r, o.target.result); l += 1) ;
        };
      });
    }
  }]);
}(), q5 = /* @__PURE__ */ function() {
  function e(t, s, n) {
    je(this, e), this._isOpen = !1, this._contentRef = e.createModalContent(s, n == null ? void 0 : n.backgroundColor), this._buttonPanel = e.createButtonPanel(n == null ? void 0 : n.backgroundColor), this._elementRef = e.createContainer(this._contentRef, n), this._elementRef.appendChild(this._buttonPanel), t.appendChild(this._elementRef), this._backgroundPanelRef = e.createDarkBackgroundPanel(), t.appendChild(this._backgroundPanelRef), this.addWindowEvents(t);
  }
  return He(e, [{
    key: "isOpen",
    value: function() {
      return this._isOpen;
    }
  }, {
    key: "addButtons",
    value: function() {
      for (var s = this, n = arguments.length, r = new Array(n), i = 0; i < n; i++)
        r[i] = arguments[i];
      r.forEach(function(o) {
        Ha.addAttributes(o), s._buttonPanel.appendChild(o);
      });
    }
  }, {
    key: "close",
    value: function() {
      var s = this;
      this._elementRef.classList.remove("show-modal"), this._elementRef.classList.add("hide-modal"), this._backgroundPanelRef.classList.remove("show-modal-background"), this._backgroundPanelRef.classList.add("hide-modal-background"), this._isOpen = !1, setTimeout(function() {
        s._elementRef.style.display = "none", s._backgroundPanelRef.style.display = "none";
      }, e.MODAL_CLOSE_TIMEOUT_MS);
    }
  }, {
    key: "displayModalElements",
    value: function() {
      this._elementRef.style.display = "flex", this._elementRef.classList.remove("hide-modal"), this._elementRef.classList.add("show-modal"), this._backgroundPanelRef.style.display = "block", this._backgroundPanelRef.classList.remove("hide-modal-background"), this._backgroundPanelRef.classList.add("show-modal-background"), this._isOpen = !0;
    }
  }, {
    key: "openTextModal",
    value: function(s) {
      this._contentRef.innerHTML = s, this.displayModalElements();
    }
  }, {
    key: "addCloseButton",
    value: function(s, n, r) {
      var i = this, o = n ? e.createSVGButton(s) : e.createTextButton(s);
      return this.addButtons(o), o.onclick = function() {
        i.close(), setTimeout(function() {
          r == null || r();
        }, 140);
      }, o;
    }
  }, {
    key: "addWindowEvents",
    value: function(s) {
      this.keyDownEvent = this.windowKeyDown.bind(this, s), window.addEventListener("keydown", this.keyDownEvent);
    }
  }, {
    key: "windowKeyDown",
    value: function(s, n) {
      var r, i;
      !s.isConnected && this.keyDownEvent ? window.removeEventListener("keydown", this.keyDownEvent) : this._isOpen && (n.key === qa.ESCAPE ? (this.close(), (r = this.extensionCloseCallback) == null || r.call(this)) : n.key === qa.ENTER && (this.close(), (i = this.extensionCloseCallback) == null || i.call(this)));
    }
  }], [{
    key: "createContainer",
    value: function(s, n) {
      var r = document.createElement("div");
      return r.classList.add("modal"), r.appendChild(s), n && delete n.backgroundColor, Object.assign(r.style, n), r;
    }
  }, {
    key: "createModalContent",
    value: function(s, n) {
      var r, i = document.createElement("div");
      return (r = i.classList).add.apply(r, Qu(s)), n && (i.style.backgroundColor = n), document.createElement("div").appendChild(i), i;
    }
  }, {
    key: "createButtonPanel",
    value: function(s) {
      var n = document.createElement("div");
      return n.classList.add("modal-button-panel"), s && (n.style.backgroundColor = s), n;
    }
  }, {
    key: "createDarkBackgroundPanel",
    value: function() {
      var s = document.createElement("div");
      return s.id = "modal-background-panel", s;
    }
  }, {
    key: "createTextButton",
    value: function(s) {
      var n = document.createElement("div");
      return n.classList.add("modal-button"), n.textContent = s, n;
    }
  }, {
    key: "createSVGButton",
    value: function(s) {
      var n = document.createElement("div");
      n.classList.add("modal-button", "modal-svg-button");
      var r = Ro.createSVGElement(s);
      return r.classList.add("modal-svg-button-icon"), n.appendChild(r), n;
    }
  }, {
    key: "createTextModalFunc",
    value: function(s, n, r) {
      var i;
      if (St(n) == "object" && (i = n.files) != null && i.infoModal) {
        var o = new e(s, ["modal-content"], n.files.infoModal.containerStyle);
        return o.addCloseButton("OK", !1, r), o.openTextModal.bind(o, n.infoModalTextMarkUp || "");
      }
    }
  }]);
}();
q5.MODAL_CLOSE_TIMEOUT_MS = 190;
var zc = q5, oUe = /* @__PURE__ */ function(e) {
  function t(s, n, r, i, o, l) {
    var d;
    je(this, t);
    var c, u, m, f, v, b, w, S, I, T, x = (c = r == null ? void 0 : r.button) == null ? void 0 : c.position, k = ((f = (m = (u = r == null ? void 0 : r.button) == null ? void 0 : u.styles) == null ? void 0 : m.text) == null ? void 0 : f.content) || l, C = Ho.tryCreateConfig("Upload File", (v = r == null ? void 0 : r.button) == null ? void 0 : v.tooltip);
    d = jt(this, t, [t.createButtonElement(), o, x, C, r.button, k]);
    var O = d.createInnerElementsForStates(i, d.customStyles);
    return d._inputElement = t.createInputElement((b = r == null ? void 0 : r.files) == null ? void 0 : b.acceptedFormats), d.addClickEvent(s, r), d.changeElementsByState(O.styles), d.reapplyStateStyle("styles"), d._fileAttachmentsType = n, d._openModalOnce = ((S = (w = r.files) == null ? void 0 : w.infoModal) == null ? void 0 : S.openModalOnce) === !1 || (T = (I = r.files) == null ? void 0 : I.infoModal) == null ? void 0 : T.openModalOnce, d;
  }
  return Ht(t, e), He(t, [{
    key: "createInnerElementsForStates",
    value: function(n, r) {
      return {
        styles: this.createInnerElements(n, "styles", r)
      };
    }
  }, {
    key: "triggerImportPrompt",
    value: function(n) {
      n.onchange = this.import.bind(this, n), n.click();
    }
  }, {
    key: "import",
    value: function(n) {
      jb.addFilesToType(Array.from(n.files || []), [this._fileAttachmentsType]), n.value = "";
    }
  }, {
    key: "addClickEvent",
    value: function(n, r) {
      var i = this.triggerImportPrompt.bind(this, this._inputElement), o = zc.createTextModalFunc(n, r, i);
      this.elementRef.onclick = this.click.bind(this, o);
    }
  }, {
    key: "click",
    value: function(n) {
      n && (this._openModalOnce === void 0 || this._openModalOnce === !0) ? (n(), this._openModalOnce === !0 && (this._openModalOnce = !1)) : this.triggerImportPrompt(this._inputElement);
    }
  }], [{
    key: "createInputElement",
    value: function(n) {
      var r = document.createElement("input");
      return r.type = "file", r.accept = n || "", r.hidden = !0, r.multiple = !0, r;
    }
  }, {
    key: "createButtonElement",
    value: function() {
      var n = document.createElement("div");
      return n.classList.add("input-button"), n;
    }
  }]);
}(El), jC = /* @__PURE__ */ function() {
  function e() {
    je(this, e);
  }
  return He(e, null, [{
    key: "create",
    value: function(s, n, r) {
      var i = e.createElement(r);
      e.addEvents(i, s, n), s.appendChild(i);
    }
  }, {
    key: "createElement",
    value: function(s) {
      var n = document.createElement("div");
      return n.id = "drag-and-drop", St(s) == "object" && Object.assign(n.style, s), n;
    }
  }, {
    key: "addEvents",
    value: function(s, n, r) {
      n.ondragenter = function(i) {
        i.preventDefault(), e.display(s);
      }, s.ondragleave = function(i) {
        i.preventDefault(), e.hide(s);
      }, s.ondragover = function(i) {
        i.preventDefault();
      }, s.ondrop = function(i) {
        i.preventDefault(), e.uploadFile(r, i), e.hide(s);
      };
    }
  }, {
    key: "uploadFile",
    value: function(s, n) {
      var r, i = (r = n.dataTransfer) == null ? void 0 : r.files;
      i && s.addFilesToAnyType(Array.from(i));
    }
  }, {
    key: "display",
    value: function(s) {
      s.style.display = "block";
    }
  }, {
    key: "hide",
    value: function(s) {
      s.style.display = "none";
    }
  }, {
    key: "isEnabled",
    value: function(s, n) {
      return n !== void 0 && n === !1 ? !1 : !!n || s.getNumberOfTypes() > 0;
    }
  }]);
}(), iUe = /* @__PURE__ */ function() {
  function e() {
    je(this, e);
  }
  return He(e, null, [{
    key: "validate",
    value: (
      // prettier-ignore
      function(s, n, r, i, o) {
        var l = s(r, i, o);
        return l ? n.changeToSubmitIcon() : n.changeToDisabledIcon(), l;
      }
    )
    // prettier-ignore
  }, {
    key: "useValidationFunc",
    value: function() {
      var t = Qe(/* @__PURE__ */ ce().mark(function n(r, i, o, l) {
        var d, c, u;
        return ce().wrap(function(f) {
          for (; ; ) switch (f.prev = f.next) {
            case 0:
              return d = i.isTextInputEmpty() ? "" : i.inputElementRef.textContent, f.next = 3, o.completePlaceholders();
            case 3:
              return c = o.getAllFileData(), u = c == null ? void 0 : c.map(function(v) {
                return v.file;
              }), f.abrupt("return", e.validate(r, l, d, u));
            case 5:
            case "end":
              return f.stop();
          }
        }, n);
      }));
      function s(n, r, i, o) {
        return t.apply(this, arguments);
      }
      return s;
    }()
    // prettier-ignore
  }, {
    key: "useValidationFuncProgrammatic",
    value: function() {
      var t = Qe(/* @__PURE__ */ ce().mark(function n(r, i, o) {
        var l, d;
        return ce().wrap(function(u) {
          for (; ; ) switch (u.prev = u.next) {
            case 0:
              return d = (l = i.files) == null ? void 0 : l.map(function(m) {
                return m.file;
              }), u.abrupt("return", e.validate(r, o, i.text, d, !0));
            case 2:
            case "end":
              return u.stop();
          }
        }, n);
      }));
      function s(n, r, i) {
        return t.apply(this, arguments);
      }
      return s;
    }()
  }, {
    key: "validateWebsocket",
    value: function(s, n) {
      var r = s.websocket, i = s.connectSettings;
      return r && i.url !== Uo.URL && !ku.canSendMessage(r) ? (n.changeToDisabledIcon(), !1) : !0;
    }
    // prettier-ignore
  }, {
    key: "attach",
    value: function(s, n, r, i, o) {
      var l = s.validateInput || xn.processValidateInput(s);
      s._validationHandler = /* @__PURE__ */ function() {
        var d = Qe(/* @__PURE__ */ ce().mark(function c(u) {
          var m;
          return ce().wrap(function(v) {
            for (; ; ) switch (v.prev = v.next) {
              case 0:
                if (!(o.status.loadingActive || o.status.requestInProgress || n.isSubmitProgrammaticallyDisabled === !0 || !e.validateWebsocket(n, o))) {
                  v.next = 2;
                  break;
                }
                return v.abrupt("return", !1);
              case 2:
                return m = l || n.canSendMessage, v.abrupt("return", m ? u ? e.useValidationFuncProgrammatic(m, u, o) : e.useValidationFunc(m, r, i, o) : null);
              case 4:
              case "end":
                return v.stop();
            }
          }, c);
        }));
        return function(c) {
          return d.apply(this, arguments);
        };
      }();
    }
  }]);
}(), Q5 = /* @__PURE__ */ function() {
  function e() {
    je(this, e);
  }
  return He(e, null, [{
    key: "getFileName",
    value: function(s, n) {
      var r = /* @__PURE__ */ new Date(), i = String(r.getHours()).padStart(2, "0"), o = String(r.getMinutes()).padStart(2, "0"), l = String(r.getSeconds()).padStart(2, "0");
      return "".concat(s, "-").concat(i, "-").concat(o, "-").concat(l, ".").concat(n);
    }
  }]);
}(), lUe = /* @__PURE__ */ function(e) {
  function t(s, n) {
    var r;
    je(this, t);
    var i, o;
    return r = jt(this, t, [n.button]), r._waitingForBrowserApproval = !1, r._audioType = s, r._extension = ((i = n.files) == null ? void 0 : i.format) || "mp3", r._maxDurationSeconds = (o = n.files) == null ? void 0 : o.maxDurationSeconds, r.elementRef.onclick = r.buttonClick.bind(Vd(r)), r;
  }
  return Ht(t, e), He(t, [{
    key: "buttonClick",
    value: function() {
      this._waitingForBrowserApproval || (this.isActive ? this.stop() : (this._waitingForBrowserApproval = !0, this.record()));
    }
  }, {
    key: "stop",
    value: function() {
      var n = this;
      return new Promise(function(r) {
        var i, o;
        n.changeToDefault(), (i = n._mediaRecorder) == null || i.stop(), (o = n._mediaStream) == null || o.getTracks().forEach(function(l) {
          return l.stop();
        }), setTimeout(function() {
          r();
        }, 10);
      });
    }
  }, {
    key: "record",
    value: function() {
      var n = this;
      navigator.mediaDevices.getUserMedia({
        audio: !0
      }).then(function(r) {
        n.changeToActive(), n._mediaRecorder = new MediaRecorder(r), n._audioType.addPlaceholderAttachment(n.stop.bind(n), n._maxDurationSeconds), n._mediaStream = r, n._mediaRecorder.addEventListener("dataavailable", function(i) {
          n.createFile(i);
        }), n._mediaRecorder.start();
      }).catch(function(r) {
        console.error(r), n.stop();
      }).finally(function() {
        n._waitingForBrowserApproval = !1;
      });
    }
  }, {
    key: "createFile",
    value: function(n) {
      var r = this, i = new Blob([n.data], {
        type: "audio/".concat(this._extension)
      }), o = Q5.getFileName(this._newFilePrefix || "audio", this._extension), l = new File([i], o, {
        type: i.type
      }), d = new FileReader();
      d.readAsDataURL(l), d.onload = function(c) {
        r._audioType.completePlaceholderAttachment(l, c.target.result);
      };
    }
  }]);
}(H5), dUe = `<?xml version="1.0" standalone="no"?>
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.0//EN" "http://www.w3.org/TR/2001/REC-SVG-20010904/DTD/svg10.dtd">
<svg xmlns="http://www.w3.org/2000/svg" stroke="currentColor" fill="none" stroke-width="1" viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round">
  <line x1="22" y1="2" x2="11" y2="14"></line>
  <polygon points="22 2 15 22 11 14 2 10 22 2"></polygon>
</svg>
`, HC = /* @__PURE__ */ function() {
  function e() {
    je(this, e);
  }
  return He(e, null, [{
    key: "resetSubmit",
    value: function(s, n) {
      n ? s.unsetCustomStateStyles(["loading", "submit"]) : s.unsetCustomStateStyles(["stop", "loading", "submit"]), s.reapplyStateStyle("submit");
    }
  }, {
    key: "overwriteDefaultStyleWithSubmit",
    value: function(s, n) {
      if (s.submit) {
        var r = JSON.parse(JSON.stringify(s[n] || {}));
        go.overwritePropertyObjectFromAnother(r, s.submit, ["container", "default"]), go.overwritePropertyObjectFromAnother(r, s.submit, ["text", "styles", "default"]), go.overwritePropertyObjectFromAnother(r, s.submit, ["svg", "styles", "default"]), s[n] = r;
      }
    }
    // prettier-ignore
  }, {
    key: "setUpDisabledButton",
    value: function(s) {
      go.setPropertyValueIfDoesNotExist(s, ["submit", "container", "default", "backgroundColor"], ""), go.setPropertyValueIfDoesNotExist(s, ["disabled", "container", "default", "backgroundColor"], "unset"), go.setPropertyValueIfDoesNotExist(s.submit, ["svg", "styles", "default", "filter"], ""), go.setPropertyValueIfDoesNotExist(s.disabled, ["svg", "styles", "default", "filter"], "brightness(0) saturate(100%) invert(70%) sepia(0%) saturate(5564%) hue-rotate(207deg) brightness(100%) contrast(97%)"), go.setPropertyValueIfDoesNotExist(s.disabled, ["text", "styles", "default", "color"], "grey"), e.overwriteDefaultStyleWithSubmit(s, "disabled");
    }
  }, {
    key: "process",
    value: function(s) {
      var n = JSON.parse(JSON.stringify(s || {}));
      return e.overwriteDefaultStyleWithSubmit(n, "loading"), e.overwriteDefaultStyleWithSubmit(n, "stop"), s != null && s.alwaysEnabled || e.setUpDisabledButton(n), n;
    }
  }]);
}(), Dh = /* @__PURE__ */ function(e) {
  function t(s, n, r, i, o, l) {
    var d;
    je(this, t);
    var c = HC.process(s.submitButtonStyles), u = dUe, m = Ho.tryCreateConfig("Submit", c == null ? void 0 : c.tooltip);
    return d = jt(this, t, [t.createButtonContainerElement(), u, c == null ? void 0 : c.position, m, c]), d._isSVGLoadingIconOverriden = !1, d.status = {
      requestInProgress: !1,
      loadingActive: !1
    }, d._messages = r, d._textInput = n, d._fileAttachments = o, d._innerElements = d.createInnerElementsForStates(), d._abortStream = new AbortController(), d._stopClicked = {
      listener: function() {
      }
    }, d._serviceIO = i, d._alwaysEnabled = !!(c != null && c.alwaysEnabled), s.disableSubmitButton = d.disableSubmitButton.bind(Vd(d), i), d.attemptOverwriteLoadingStyle(s), l.microphone && d.setUpSpeechToText(l.microphone.button, s.speechToText), setTimeout(function() {
      var f;
      d._validationHandler = s._validationHandler, d.assignHandlers(d._validationHandler), (f = d._validationHandler) == null || f.call(Vd(d));
    }), d;
  }
  return Ht(t, e), He(t, [{
    key: "createInnerElementsForStates",
    value: function() {
      var n = this.createCustomElements(), r = n.submit, i = n.loading, o = n.stop;
      return {
        submit: r,
        loading: i || [t.createLoadingIconElement()],
        stop: o || [t.createStopIconElement()],
        disabled: this.createDisabledIconElement(r)
      };
    }
  }, {
    key: "createCustomElements",
    value: function() {
      var n = this, r = gi.createCustomElements("submit", this.svg, this.customStyles), i = {
        loading: void 0,
        stop: void 0
      };
      return Object.keys(i).forEach(function(o) {
        var l = o, d = gi.createCustomElements(l, n.svg, n.customStyles);
        d && (i[l] = d);
      }), i.submit = r || this.buildDefaultIconElement("submit-icon"), i;
    }
  }, {
    key: "createDisabledIconElement",
    value: function(n) {
      return gi.createCustomElements("disabled", this.svg, this.customStyles) || [n[0].cloneNode(!0)];
    }
    // prettier-ignore
  }, {
    key: "attemptOverwriteLoadingStyle",
    value: function(n) {
      var r, i, o, l, d, c, u, m, f;
      if (!((i = (r = this.customStyles) == null ? void 0 : r.submit) != null && i.svg || (d = (l = (o = this.customStyles) == null ? void 0 : o.loading) == null ? void 0 : l.svg) != null && d.content || (m = (u = (c = this.customStyles) == null ? void 0 : c.loading) == null ? void 0 : u.text) != null && m.content) && (n.displayLoadingBubble === void 0 || n.displayLoadingBubble === !0)) {
        var v = document.createElement("style");
        v.textContent = `
        .loading-button > * {
          filter: brightness(0) saturate(100%) invert(72%) sepia(0%) saturate(3044%) hue-rotate(322deg) brightness(100%)
            contrast(96%) !important;
        }`, (f = n.shadowRoot) == null || f.appendChild(v), this._isSVGLoadingIconOverriden = !0;
      }
    }
  }, {
    key: "assignHandlers",
    value: function(n) {
      this._serviceIO.completionsHandlers = {
        onFinish: this.resetSubmit.bind(this, n)
      }, this._serviceIO.streamHandlers = {
        onOpen: this.changeToStopIcon.bind(this),
        onClose: this.resetSubmit.bind(this, n),
        abortStream: this._abortStream,
        stopClicked: this._stopClicked
      };
      var r = this._serviceIO.stream;
      St(r) == "object" && typeof r.simulation == "number" && (this._serviceIO.streamHandlers.simulationInterim = r.simulation);
    }
  }, {
    key: "setUpSpeechToText",
    value: function(n, r) {
      this._microphoneButton = n, this._stopSTTAfterSubmit = St(r) == "object" ? r.stopAfterSubmit : !1;
    }
  }, {
    key: "resetSubmit",
    value: function(n) {
      this.status.requestInProgress = !1, this.status.loadingActive = !1, n();
    }
  }, {
    key: "submitFromInput",
    value: function() {
      var s = Qe(/* @__PURE__ */ ce().mark(function r() {
        var i, o;
        return ce().wrap(function(d) {
          for (; ; ) switch (d.prev = d.next) {
            case 0:
              return d.next = 2, this._fileAttachments.completePlaceholders();
            case 2:
              i = this._fileAttachments.getAllFileData(), this._textInput.isTextInputEmpty() ? this.attemptSubmit({
                text: "",
                files: i
              }) : (o = this._textInput.inputElementRef.innerText.trim(), this.attemptSubmit({
                text: o,
                files: i
              }));
            case 4:
            case "end":
              return d.stop();
          }
        }, r, this);
      }));
      function n() {
        return s.apply(this, arguments);
      }
      return n;
    }()
  }, {
    key: "programmaticSubmit",
    value: function() {
      var s = Qe(/* @__PURE__ */ ce().mark(function r(i) {
        var o = this, l;
        return ce().wrap(function(c) {
          for (; ; ) switch (c.prev = c.next) {
            case 0:
              typeof i == "string" && (i = xn.processSubmitUserMessage(i)), l = {
                text: i.text
              }, i.files && (l.files = Array.from(i.files).map(function(u) {
                return {
                  file: u,
                  type: Nb.getTypeFromBlob(u)
                };
              })), i.custom && (l.custom = i.custom), setTimeout(function() {
                return o.attemptSubmit(l, !0);
              });
            case 3:
            case "end":
              return c.stop();
          }
        }, r);
      }));
      function n(r) {
        return s.apply(this, arguments);
      }
      return n;
    }()
    // TO-DO - should be disabled when loading history
  }, {
    key: "attemptSubmit",
    value: function() {
      var s = Qe(/* @__PURE__ */ ce().mark(function r(i) {
        var o, l, d, c, u, m, f, v = arguments;
        return ce().wrap(function(w) {
          for (; ; ) switch (w.prev = w.next) {
            case 0:
              return o = v.length > 1 && v[1] !== void 0 ? v[1] : !1, w.next = 3, (l = this._validationHandler) == null ? void 0 : l.call(this, o ? i : void 0);
            case 3:
              if (w.t0 = w.sent, w.t1 = !1, w.t0 !== w.t1) {
                w.next = 7;
                break;
              }
              return w.abrupt("return");
            case 7:
              if (this.changeToLoadingIcon(), this._textInput.clear(), w.t2 = typeof this._messages.focusMode != "boolean" && (d = this._messages.focusMode) != null && d.fade, !w.t2) {
                w.next = 13;
                break;
              }
              return w.next = 13, w5.fadeAnimation(this._messages.elementRef, this._messages.focusMode.fade);
            case 13:
              return w.next = 15, this.addNewMessage(i);
            case 15:
              return this._serviceIO.isWebModel() || this._messages.addLoadingMessage(), m = (c = i.files) == null ? void 0 : c.map(function(S) {
                return S.file;
              }), f = {
                text: i.text === "" ? void 0 : i.text,
                files: m
              }, w.next = 19, this._serviceIO.callAPI(f, this._messages);
            case 19:
              (u = this._fileAttachments) == null || u.hideFiles();
            case 20:
            case "end":
              return w.stop();
          }
        }, r, this);
      }));
      function n(r) {
        return s.apply(this, arguments);
      }
      return n;
    }()
  }, {
    key: "addNewMessage",
    value: function() {
      var s = Qe(/* @__PURE__ */ ce().mark(function r(i) {
        var o, l, d, c;
        return ce().wrap(function(m) {
          for (; ; ) switch (m.prev = m.next) {
            case 0:
              if (o = i.text, l = i.files, d = i.custom, c = {
                role: Ft.USER_ROLE,
                custom: d
              }, o && (c.text = o), m.t0 = l, !m.t0) {
                m.next = 8;
                break;
              }
              return m.next = 7, this._messages.addMultipleFiles(l, this._fileAttachments);
            case 7:
              c.files = m.sent;
            case 8:
              this._serviceIO.sessionId && (c._sessionId = this._serviceIO.sessionId), Object.keys(c).length > 0 && this._messages.addNewMessage(c);
            case 10:
            case "end":
              return m.stop();
          }
        }, r, this);
      }));
      function n(r) {
        return s.apply(this, arguments);
      }
      return n;
    }()
  }, {
    key: "stopStream",
    value: function() {
      var n;
      this._abortStream.abort(), (n = this._stopClicked) == null || n.listener(), this._validationHandler && this.resetSubmit(this._validationHandler);
    }
  }, {
    key: "changeToStopIcon",
    value: function() {
      this._serviceIO.websocket || (this.elementRef.classList.remove(t.LOADING_CLASS, t.DISABLED_CLASS, t.SUBMIT_CLASS), Ha.removeAriaAttributes(this.elementRef), this.changeElementsByState(this._innerElements.stop), this.reapplyStateStyle("stop", ["loading", "submit"]), this.elementRef.onclick = this.stopStream.bind(this), this.status.loadingActive = !1);
    }
  }, {
    key: "changeToLoadingIcon",
    value: function() {
      this._serviceIO.websocket || (this._isSVGLoadingIconOverriden || this.changeElementsByState(this._innerElements.loading), this.elementRef.classList.remove(t.SUBMIT_CLASS, t.DISABLED_CLASS), Ha.removeAriaDisabled(this.elementRef), this.elementRef.classList.add(t.LOADING_CLASS), Ha.addAriaBusy(this.elementRef), this.reapplyStateStyle("loading", ["submit"]), this.elementRef.onclick = function() {
      }, this.status.requestInProgress = !0, this.status.loadingActive = !0);
    }
    // called every time when user triggers an input via ValidationHandler - hence use class to check if not already present
  }, {
    key: "changeToSubmitIcon",
    value: function() {
      var n = this;
      this.elementRef.classList.contains(t.SUBMIT_CLASS) || (this.elementRef.classList.remove(t.LOADING_CLASS, t.DISABLED_CLASS), Ha.removeAriaAttributes(this.elementRef), this.elementRef.classList.add(t.SUBMIT_CLASS), this.changeElementsByState(this._innerElements.submit), HC.resetSubmit(this, this.status.loadingActive), this.elementRef.onclick = function() {
        var r;
        n.submitFromInput(), (r = n._microphoneButton) != null && r.isActive && Db.toggleSpeechAfterSubmit(n._microphoneButton.elementRef, !!n._stopSTTAfterSubmit);
      });
    }
    // called every time when user triggers an input via ValidationHandler - hence use class to check if not already present
  }, {
    key: "changeToDisabledIcon",
    value: function() {
      var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1;
      this._alwaysEnabled && !n ? this.changeToSubmitIcon() : this.elementRef.classList.contains(t.DISABLED_CLASS) || (this.elementRef.classList.remove(t.LOADING_CLASS, t.SUBMIT_CLASS), Ha.removeAriaBusy(this.elementRef), this.elementRef.classList.add(t.DISABLED_CLASS), Ha.addAriaDisabled(this.elementRef), this.changeElementsByState(this._innerElements.disabled), this.reapplyStateStyle("disabled", ["submit"]), this.elementRef.onclick = function() {
      });
    }
  }, {
    key: "disableSubmitButton",
    value: function(n, r) {
      var i;
      n.isSubmitProgrammaticallyDisabled = r !== !1, !(this.status.requestInProgress || this.status.loadingActive) && (r === !1 ? (i = this._validationHandler) == null || i.call(this) : this.changeToDisabledIcon(!0));
    }
  }], [{
    key: "createButtonContainerElement",
    value: function() {
      var n = document.createElement("div");
      return n.classList.add("input-button"), n;
    }
  }, {
    key: "createLoadingIconElement",
    value: function() {
      var n = document.createElement("div");
      return n.classList.add("loading-submit-button"), n;
    }
  }, {
    key: "createStopIconElement",
    value: function() {
      var n = document.createElement("div");
      return n.id = "stop-icon", n;
    }
  }]);
}(El);
Dh.SUBMIT_CLASS = "submit-button", Dh.LOADING_CLASS = "loading-button", Dh.DISABLED_CLASS = "disabled-button";
var cUe = Dh, uUe = `<?xml version="1.0" encoding="utf-8"?>
<svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
  <path d="M27.1 14.313V5.396L24.158 8.34c-2.33-2.325-5.033-3.503-8.11-3.503C9.902 4.837 4.901 9.847 4.899 16c.001 6.152 5.003 11.158 11.15 11.16 4.276 0 9.369-2.227 10.836-8.478l.028-.122h-3.23l-.022.068c-1.078 3.242-4.138 5.421-7.613 5.421a8 8 0 0 1-5.691-2.359A7.993 7.993 0 0 1 8 16.001c0-4.438 3.611-8.049 8.05-8.049 2.069 0 3.638.58 5.924 2.573l-3.792 3.789H27.1z"/>
</svg>
`, pUe = `<?xml version="1.0" encoding="utf-8"?>
<svg viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg">
  <path d="M0 16q0 3.264 1.28 6.208t3.392 5.12 5.12 3.424 6.208 1.248 6.208-1.248 5.12-3.424 3.392-5.12 1.28-6.208-1.28-6.208-3.392-5.12-5.088-3.392-6.24-1.28q-3.264 0-6.208 1.28t-5.12 3.392-3.392 5.12-1.28 6.208zM4 16q0-3.264 1.6-6.016t4.384-4.352 6.016-1.632 6.016 1.632 4.384 4.352 1.6 6.016-1.6 6.048-4.384 4.352-6.016 1.6-6.016-1.6-4.384-4.352-1.6-6.048z"></path>
</svg>
`, hUe = `<?xml version="1.0" encoding="utf-8"?>
<svg viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg">
  <path d="M195.2 195.2a64 64 0 0 1 90.496 0L512 421.504 738.304 195.2a64 64 0 0 1 90.496 90.496L602.496 512 828.8 738.304a64 64 0 0 1-90.496 90.496L512 602.496 285.696 828.8a64 64 0 0 1-90.496-90.496L421.504 512 195.2 285.696a64 64 0 0 1 0-90.496z"/>
</svg>`, mUe = `<?xml version="1.0" encoding="utf-8"?>
<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M4.89163 13.2687L9.16582 17.5427L18.7085 8" stroke="#000000" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`, fUe = /* @__PURE__ */ function(e) {
  function t(s, n, r, i) {
    var o;
    je(this, t), o = jt(this, t, [s, ["modal-content", "modal-camera-content"], r]), o._stopped = !1, o._format = "image/png", o._canvas = document.createElement("canvas"), o._canvas.classList.add("camera-modal-canvas");
    var l = o.addButtonsAndTheirEvents(n), d = l.captureButton, c = l.submitButton;
    return o._captureButton = d, o._submitButton = c, o._captureIcon = o._captureButton.children[0], o._refreshIcon = Ro.createSVGElement(uUe), o._refreshIcon.classList.add("modal-svg-button-icon", "modal-svg-refresh-icon"), (i == null ? void 0 : i.format) === "jpeg" && (o._format = "image/jpeg"), i != null && i.dimensions && (o._dimensions = i.dimensions), o._contentRef.appendChild(o._canvas), o.extensionCloseCallback = o.stop, o;
  }
  return Ht(t, e), He(t, [{
    key: "addButtonsAndTheirEvents",
    value: function(n) {
      var r = zc.createSVGButton(pUe);
      r.classList.add("modal-svg-camera-button"), r.children[0].classList.add("modal-svg-camera-icon");
      var i = this.addCloseButton(hUe, !0);
      i.classList.add("modal-svg-close-button"), i.children[0].classList.add("modal-svg-close-icon");
      var o = zc.createSVGButton(mUe);
      return o.classList.add("modal-svg-submit-button"), this.addButtons(r, o), this.addButtonEvents(r, i, o, n), {
        captureButton: r,
        submitButton: o
      };
    }
    // prettier-ignore
  }, {
    key: "addButtonEvents",
    value: function(n, r, i, o) {
      var l = this;
      n.onclick = function() {
        l.capture();
      }, r.addEventListener("click", this.stop.bind(this)), i.onclick = function() {
        var d = l.getFile();
        d && jb.addFilesToType([d], [o]), l.stop(), l.close();
      };
    }
  }, {
    key: "stop",
    value: function() {
      var n = this;
      this._mediaStream && this._mediaStream.getTracks().forEach(function(r) {
        return r.stop();
      }), this._stopped = !0, setTimeout(function() {
        n._captureButton.replaceChildren(n._captureIcon), n._captureButton.classList.replace("modal-svg-refresh-button", "modal-svg-camera-button");
        var r = n._canvas.getContext("2d");
        r == null || r.clearRect(0, 0, n._canvas.width, n._canvas.height);
      }, zc.MODAL_CLOSE_TIMEOUT_MS);
    }
  }, {
    key: "start",
    value: function() {
      var n = this;
      this._dataURL = void 0, this._submitButton.classList.add("modal-svg-submit-disabled"), this._stopped = !1, navigator.mediaDevices.getUserMedia({
        video: this._dimensions || !0
      }).then(function(r) {
        if (n._mediaStream = r, !n.isOpen()) return n.stop();
        var i = document.createElement("video");
        i.srcObject = r, i.play(), requestAnimationFrame(n.updateCanvas.bind(n, i, n._canvas));
      }).catch(function(r) {
        console.error(r), n.stop(), n.close();
      });
    }
  }, {
    key: "capture",
    value: function() {
      this._dataURL ? (this._captureButton.replaceChildren(this._captureIcon), this._captureButton.classList.replace("modal-svg-refresh-button", "modal-svg-camera-button"), this._submitButton.classList.add("modal-svg-submit-disabled"), this._dataURL = void 0) : (this._captureButton.replaceChildren(this._refreshIcon), this._captureButton.classList.replace("modal-svg-camera-button", "modal-svg-refresh-button"), this._submitButton.classList.remove("modal-svg-submit-disabled"), this._dataURL = this._canvas.toDataURL());
    }
  }, {
    key: "getFile",
    value: function() {
      if (this._dataURL) {
        for (var n = atob(this._dataURL.split(",")[1]), r = new Array(n.length), i = 0; i < n.length; i++) r[i] = n.charCodeAt(i);
        var o = new Uint8Array(r), l = new Blob([o], {
          type: this._format
        }), d = this._format === "image/jpeg" ? "jpeg" : "png", c = Q5.getFileName(this._newFilePrefix || "photo", d);
        return new File([l], c, {
          type: l.type
        });
      }
    }
  }, {
    key: "updateCanvas",
    value: function(n, r) {
      if (!this._stopped) {
        if (!this._dataURL) {
          r.width = n.videoWidth, r.height = n.videoHeight;
          var i = r.getContext("2d");
          i == null || i.drawImage(n, 0, 0, r.width, r.height);
        }
        requestAnimationFrame(this.updateCanvas.bind(this, n, r));
      }
    }
  }, {
    key: "openCameraModal",
    value: function(n) {
      this.displayModalElements(), n.start();
    }
    // prettier-ignore
  }], [{
    key: "createCameraModalFunc",
    value: function(n, r, i, o) {
      var l = new t(n, r, i, o);
      return l.openCameraModal.bind(l, l);
    }
  }]);
}(zc), gUe = `<?xml version="1.0" encoding="utf-8"?>
<svg viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg">
  <path d="M29 7h-4.599l-2.401-4h-12l-2.4 4h-4.6c-1 0-3 1-3 2.969v16.031c0 1.657 1.5 3 2.792 3h26.271c1.313 0 2.938-1.406 2.938-2.968v-16.032c0-1-1-3-3-3zM30 26.032c0 0.395-0.639 0.947-0.937 0.969h-26.265c-0.232-0.019-0.797-0.47-0.797-1v-16.031c0-0.634 0.851-0.953 1-0.969h5.732l2.4-4h9.802l1.785 3.030 0.55 0.97h5.731c0.705 0 0.99 0.921 1 1v16.032zM16 10c-3.866 0-7 3.134-7 7s3.134 7 7 7 7-3.134 7-7-3.134-7-7-7zM16 22c-2.757 0-5-2.243-5-5s2.243-5 5-5 5 2.243 5 5-2.243 5-5 5z"></path>
</svg>`, vUe = /* @__PURE__ */ function(e) {
  function t(s, n, r) {
    var i;
    je(this, t);
    var o, l, d, c, u, m, f = (o = r == null ? void 0 : r.button) == null ? void 0 : o.position, v = ((c = (d = (l = r == null ? void 0 : r.button) == null ? void 0 : l.styles) == null ? void 0 : d.text) == null ? void 0 : c.content) || "Photo", b = Ho.tryCreateConfig("Camera", (u = r == null ? void 0 : r.button) == null ? void 0 : u.tooltip), w = ((m = r == null ? void 0 : r.button) == null ? void 0 : m.styles) || {};
    i = jt(this, t, [t.createButtonElement(), gUe, f, b, w, v]);
    var S = i.createInnerElementsForStates(i.customStyles);
    return r && i.addClickEvent(s, n, r.modalContainerStyle, r.files), i.changeElementsByState(S.styles), i.reapplyStateStyle("styles"), i;
  }
  return Ht(t, e), He(t, [{
    key: "createInnerElementsForStates",
    value: function(n) {
      return {
        styles: this.createInnerElements("camera-icon", "styles", n)
      };
    }
  }, {
    key: "addClickEvent",
    value: (
      // prettier-ignore
      function(n, r, i, o) {
        var l = fUe.createCameraModalFunc(n, r, i, o);
        this.elementRef.onclick = l;
      }
    )
  }], [{
    key: "createButtonElement",
    value: function() {
      var n = document.createElement("div");
      return n.classList.add("input-button"), n;
    }
  }]);
}(El), yUe = /* @__PURE__ */ function() {
  function e(t, s, n, r) {
    je(this, e), this.elementRef = e.createPanelElement(t.inputAreaStyle);
    var i = {}, o = this.createFileUploadComponents(t, n, r, i), l = new r5(t, n, o);
    t.speechToText && !i.microphone && (i.microphone = {
      button: new Db(t, l, s.addNewErrorMessage.bind(s))
    });
    var d = new cUe(t, l, s, n, o, i);
    l.submit = d.submitFromInput.bind(d), iUe.attach(t, n, l, o, d), t.submitUserMessage = d.programmaticSubmit.bind(d), i.submit = {
      button: d
    }, t.customButtons && ou.add(t, i), e.addElements(this.elementRef, l, i, r, o, t.dropupStyles), e.assignOnInput(t, n, o, l);
  }
  return He(e, [{
    key: "createFileUploadComponents",
    value: (
      // prettier-ignore
      function(s, n, r, i) {
        var o, l, d, c, u = new jb(this.elementRef, s.attachmentContainerStyle, n.demo);
        if (e.createUploadButtons(s, n, n.fileTypes || {}, u, r, i), (o = n.camera) != null && o.files) {
          var m = ((l = i.images) == null ? void 0 : l.fileType) || u.addType(s, n, n.camera.files, "images");
          i.camera = {
            button: new vUe(r, m, n.camera)
          };
        }
        if ((d = n.recordAudio) != null && d.files) {
          var f = ((c = i.audio) == null ? void 0 : c.fileType) || u.addType(s, n, n.recordAudio.files, "audio");
          i.microphone = {
            button: new lUe(f, n.recordAudio)
          };
        }
        return jC.isEnabled(u, s.dragAndDrop) && jC.create(r, u, s.dragAndDrop), u;
      }
    )
    // prettier-ignore
  }], [{
    key: "createPanelElement",
    value: function(s) {
      var n = document.createElement("div");
      return n.id = "input", Object.assign(n.style, s), n;
    }
  }, {
    key: "createUploadButtons",
    value: function(s, n, r, i, o, l) {
      Object.keys(r).forEach(function(d) {
        var c = d, u = r[c];
        if (u.files) {
          var m = i.addType(s, n, u.files, c), f = HHe[c], v = f.id, b = f.svgString, w = f.dropupText, S = new oUe(o, m, u, v, b, w);
          l[c] = {
            button: S,
            fileType: m
          };
        }
      });
    }
    // prettier-ignore
  }, {
    key: "addElements",
    value: function(s, n, r, i, o, l) {
      Ln.addElements(s, n.elementRef);
      var d = Sm.create(), c = FHe.addButtons(d, r, i, l);
      LHe.set(n.inputElementRef, d, o.elementRef, c), Sm.add(s, d);
    }
  }, {
    key: "assignOnInput",
    value: function(s, n, r, i) {
      n.onInput = function(o) {
        setTimeout(function() {
          var l = r.getAllFileData(), d = {
            text: i.inputElementRef.innerText.trim()
          };
          l && (d.files = l.map(function(c) {
            return c.file;
          })), Pu.onInput(s, d, o);
        });
      };
    }
  }]);
}(), bUe = /* @__PURE__ */ function() {
  function e() {
    je(this, e);
  }
  return He(e, null, [{
    key: "createElements",
    value: function(s, n, r) {
      var i = document.createElement("div");
      i.id = "chat-view";
      var o = new Vy(s, n, r);
      n.websocket && ku.createConnection(n, o);
      var l = new yUe(s, o, n, i);
      return Ln.addElements(i, o.elementRef, l.elementRef), i;
    }
  }, {
    key: "render",
    value: function(s, n, r, i) {
      var o = e.createElements(s, r, i);
      n.replaceChildren(o), r.isCustomView() && r.setUpView(o, n);
    }
  }]);
}(), AUe = `#validate-property-key-view{height:100%;position:relative;display:flex;justify-content:center;align-items:center;padding:8px}#loading-validate-key-property{display:inline-block;width:50px;height:50px}#loading-validate-key-property:after{content:" ";display:block;width:38px;height:38px;margin:1px;border-radius:50%;border:5px solid #5fb2ff;border-color:#5fb2ff transparent #5fb2ff transparent;animation:loading-spinner 1.4s linear infinite}#deep-chat-openai-realtime-container{height:100%;width:100%}#deep-chat-openai-realtime-avatar-container{height:60%;width:100%;display:flex;justify-content:center;align-items:center}#deep-chat-openai-realtime-avatar{border-radius:50%;height:110px;border:1px solid rgb(215,215,215);padding:8px;-webkit-user-select:none;user-select:none;margin-top:20px}#deep-chat-openai-realtime-buttons-container{height:40%;display:flex;position:relative}.deep-chat-openai-realtime-button-container{height:100%;width:50%;display:flex;justify-content:center;align-items:center}.deep-chat-openai-realtime-button{width:70px;height:70px;border-radius:50%;display:flex;justify-content:center;align-items:center;cursor:pointer}.deep-chat-openai-realtime-button-default{background-color:#e3e3e3}.deep-chat-openai-realtime-button-default:hover{background-color:#d4d4d4}.deep-chat-openai-realtime-button-default:active{background-color:#c5c5c5}.deep-chat-openai-realtime-button-loading{opacity:.7;pointer-events:none}.deep-chat-openai-realtime-microphone-active{background-color:#ffe7e7}.deep-chat-openai-realtime-microphone-active:hover{background-color:#ffdede}.deep-chat-openai-realtime-microphone-active:active{background-color:#ffd2d2}.deep-chat-openai-realtime-microphone>*{height:30px;width:30px}.deep-chat-openai-realtime-microphone-active>*{filter:brightness(0) saturate(100%) invert(35%) sepia(60%) saturate(1360%) hue-rotate(325deg) brightness(95%) contrast(92%)}.deep-chat-openai-realtime-toggle>*{height:32px;width:32px;padding-left:3px;filter:brightness(0) saturate(100%) invert(22%) sepia(0%) saturate(4537%) hue-rotate(208deg) brightness(105%) contrast(91%)}.deep-chat-openai-realtime-button-unavailable{opacity:.45;pointer-events:none}#deep-chat-openai-realtime-error{color:red;position:absolute;top:calc(50% + 40px);left:50%;transform:translate(-50%,-50%);font-size:17px}#deep-chat-openai-realtime-loading{position:absolute;font-size:15px;top:50%;left:50%;transform:translate(-50%,-50%)}#insert-key-view{height:100%;position:relative}#insert-key-contents{text-align:center;position:absolute;top:44%;left:50%;transform:translate(-50%,-50%);width:82%;display:flex;max-width:700px}#insert-key-title{margin-bottom:15px}#insert-key-input-container{margin-right:2.7em;width:calc(100% - 80px)}#insert-key-input{padding:.3em 1.7em .3em .3em;border-width:1px;border-style:solid;border-radius:3px;width:100%;font-size:inherit}.insert-key-input-valid{border-color:gray}.insert-key-input-invalid{border-color:red}#visibility-icon-container{position:relative;float:right;cursor:pointer;-webkit-user-select:none;user-select:none}.visibility-icon{filter:brightness(0) saturate(100%) invert(63%) sepia(1%) saturate(9%) hue-rotate(43deg) brightness(98%) contrast(92%);position:absolute;right:-1.7em;top:-1.43em}#visible-icon{top:-1.4em}.visibility-icon:hover{filter:unset}.visibility-icon>*{pointer-events:none}#start-button{border:1px solid grey;color:#454545;border-radius:4px;width:3em;display:flex;justify-content:center;align-items:center;cursor:pointer;padding:.28em .3em;-webkit-user-select:none;user-select:none;background-color:#fff}#start-button:hover{background-color:#f2f2f2}#start-button:active{background-color:#d2d2d2}#insert-key-help-text-container{width:100%;position:absolute;margin-top:32px;margin-bottom:20px}#insert-key-help-text-contents{width:100%;position:absolute}#insert-key-input-invalid-text{display:block;margin-top:1em;margin-bottom:.5em;color:red}.insert-key-input-help-text{display:block;margin-top:16px}#loading-key{display:inline-block;width:16px;height:16px}#loading-key:after{content:" ";display:block;width:11px;height:11px;margin:1px;border-radius:50%;border:2px solid #0084ff;border-color:#0084ff transparent #0084ff transparent;animation:loading-spinner 1.2s linear infinite}#error-view{color:red;font-size:1.2em;line-height:1.3em;margin-top:-5px;text-align:center;height:100%;display:flex;justify-content:center;align-items:center;padding-left:8px;padding-right:8px}@keyframes loading-spinner{0%{transform:rotate(0)}to{transform:rotate(360deg)}}.intro-panel{position:absolute;display:flex;justify-content:center;right:0;bottom:0;left:0;margin:auto;height:fit-content;top:-2.5em}#internal-intro-panel{width:250px;height:min-content;display:block;border-radius:5px;overflow:auto;border:1px solid rgb(203,203,203);padding:10px;max-height:calc(100% - 6.8em)}#internal-intro-panel>p{margin-block-start:.8em;margin-block-end:.8em}pre code.hljs{display:block;overflow-x:auto;padding:1em}code.hljs{padding:3px 5px}/*!
  Theme: a11y-dark
  Author: @ericwbailey
  Maintainer: @ericwbailey

  Based on the Tomorrow Night Eighties theme: https://github.com/isagalaev/highlight.js/blob/master/src/styles/tomorrow-night-eighties.css
*/.hljs{background:#2b2b2b;color:#f8f8f2}.hljs-comment,.hljs-quote{color:#d4d0ab}.hljs-deletion,.hljs-name,.hljs-regexp,.hljs-selector-class,.hljs-selector-id,.hljs-tag,.hljs-template-variable,.hljs-variable{color:#ffa07a}.hljs-built_in,.hljs-link,.hljs-literal,.hljs-meta,.hljs-number,.hljs-params,.hljs-type{color:#f5ab35}.hljs-attribute{color:gold}.hljs-addition,.hljs-bullet,.hljs-string,.hljs-symbol{color:#abe338}.hljs-section,.hljs-title{color:#00e0e0}.hljs-keyword,.hljs-selector-tag{color:#dcc6e0}.hljs-emphasis{font-style:italic}.hljs-strong{font-weight:700}@media screen and (-ms-high-contrast: active){.hljs-addition,.hljs-attribute,.hljs-built_in,.hljs-bullet,.hljs-comment,.hljs-link,.hljs-literal,.hljs-meta,.hljs-number,.hljs-params,.hljs-quote,.hljs-string,.hljs-symbol,.hljs-type{color:highlight}.hljs-keyword,.hljs-selector-tag{font-weight:700}}#messages{overflow:auto}.outer-message-container:last-child{margin-bottom:5px}.inner-message-container{display:flex;margin-left:auto;margin-right:auto;width:calc(97.5% - 24px);max-width:100%}.message-bubble{margin-top:10px;word-wrap:break-word;width:fit-content;max-width:60%;border-radius:10px;padding:.42em .55em;height:fit-content;line-height:1.26em}.user-message-text{color:#fff;background-color:#0084ff;margin-right:0;margin-left:auto}.ai-message-text{color:#000;background-color:#e4e6eb;margin-left:0;margin-right:auto}.deep-chat-last-group-messages-active{height:100%}.loading-history-message-full-view{position:absolute;height:70%;width:100%;display:flex;align-items:center}.loading-history-message-small{height:20px;margin-bottom:30px}.loading-history-message-small>div>div{scale:.6}.loading-history-message{margin-top:0;width:100%;max-width:100%;display:flex;justify-content:center;background-color:unset}.loading-history{width:70px}.loading-history div{position:absolute;width:var(--loading-history-width);height:var(--loading-history-height);margin:var(--loading-history-margin);border:var(--loading-history-border);border-radius:50%;animation:loading-spinner 1.2s cubic-bezier(.5,0,.5,1) infinite;border-color:var(--loading-history-color) transparent transparent transparent}.loading-history div:nth-child(1){animation-delay:-.45s}.loading-history div:nth-child(2){animation-delay:-.3s}.loading-history div:nth-child(3){animation-delay:-.15s}.html-message{max-width:unset}.error-message-text{margin:14px auto 10px;background-color:#f4c0c0;color:#474747;text-align:center;max-width:95%}.deep-chat-loading-message-dots-container{width:1em;padding:.6em .75em .6em 1.3em}.loading-message-dots{position:relative;width:.45em;height:.45em;border-radius:5px;background-color:var(--loading-message-color);color:var(--loading-message-color);animation:loading-message-dots 1s infinite linear alternate;animation-delay:.5s}.loading-message-dots:before,.loading-message-dots:after{content:"";display:inline-block;position:absolute;top:0}.loading-message-dots:before{left:-.7em;width:.45em;height:.45em;border-radius:5px;background-color:var(--loading-message-color);color:var(--loading-message-color);animation:loading-message-dots 1s infinite alternate;animation-delay:0s}.loading-message-dots:after{left:.7em;width:.45em;height:.45em;border-radius:5px;background-color:var(--loading-message-color);color:var(--loading-message-color);animation:loading-message-dots 1s infinite alternate;animation-delay:1s}@keyframes loading-message-dots{0%{background-color:var(--loading-message-color)}50%,to{background-color:var(--loading-message-color-fade)}}.message-bubble>p:first-child,.message-bubble>.partial-render-message>p:first-child,.stream-wrapper>p:first-child{margin-top:0}.message-bubble>p:last-child,.message-bubble>.partial-render-message:last-child>p,.stream-wrapper>p:last-child{margin-bottom:0}pre{overflow:auto;display:block;word-break:break-all;word-wrap:break-word;border-radius:7px;background:#2b2b2b;color:#f8f8f2;margin-top:.8em;margin-bottom:.8em;padding:.6em;font-size:.9em;line-height:1.5em}.image-message{padding:0;display:flex;background-color:#ddd}.image-message>*,.image-message>*>*{width:100%;border-radius:8px;display:flex}.audio-message{width:60%;max-width:300px;height:2.2em;max-height:54px;padding:0;background-color:unset}.audio-player{width:100%;height:100%}.audio-player-safari{height:fit-content;width:40px}.audio-player-safari-left{float:left}.audio-player-safari-right{float:right}.any-file-message{padding:1px}.any-file-message-contents{display:flex}.any-file-message-icon-container{width:1.3em;min-width:1.3em;position:relative;border-radius:4px;margin-left:6px;margin-right:2px}.any-file-message-icon{background-color:#fff;border-radius:4px;position:absolute;width:1em;height:1.25em;padding:1px;margin-top:auto;margin-bottom:auto;top:0;bottom:0}.any-file-message-text{padding-top:5px;overflow-wrap:anywhere;padding-bottom:5px;padding-right:7px}.message-bubble>a{color:inherit}.left-item-position{margin-right:10px}.right-item-position{margin-left:10px}.role-hidden{display:none}.avatar{padding-top:5px;width:1.5em;height:1.5em;border-radius:1px}.avatar-container{margin-top:9px}.name{margin-top:16px;font-size:15px}#drag-and-drop{position:absolute;display:none;z-index:10;height:calc(100% - 10px);width:calc(100% - 10px);background-color:#70c6ff4d;border:5px dashed #6dafff}#file-attachment-container{position:absolute;height:3.6em;width:calc(80% - 4px);top:-2.5em;border-radius:5px;overflow:auto;text-align:left;background-color:#d7d7d73b;padding-left:4px}.file-attachment{width:2.85em;height:2.85em;display:inline-flex;margin-right:.6em;margin-bottom:.44em;margin-top:4px;position:relative;background-color:#fff;border-radius:5px}.image-attachment{width:100%;height:100%;object-fit:cover;border-radius:5px}.border-bound-attachment{width:calc(100% - 2px);height:calc(100% - 2px);border:1px solid #c3c3c3;border-radius:5px;overflow:hidden}.border-bound-attachment-safari{width:calc(100% - 1px);height:calc(100% - 1px)}.audio-attachment-icon-container{cursor:pointer}.audio-attachment-icon-container:hover{background-color:#f8f8f8}.attachment-icon{left:0;right:0;bottom:0;top:2px;margin:auto;position:absolute;width:25px;-webkit-user-select:none;user-select:none}.not-removable-attachment-icon{top:0;right:0;bottom:0;left:0}.play-icon{filter:brightness(0) saturate(100%) invert(17%) sepia(0%) saturate(1392%) hue-rotate(67deg) brightness(98%) contrast(97%)}.stop-icon{filter:brightness(0) saturate(100%) invert(29%) sepia(90%) saturate(1228%) hue-rotate(198deg) brightness(93%) contrast(98%)}.audio-placeholder-text-3-digits{padding-left:.26rem}.audio-placeholder-text-4-digits{padding-left:.1rem}.any-file-attachment{padding:2px 0}.file-attachment-text-container{position:absolute;width:inherit;display:flex;align-items:center;height:100%;top:-1px}.audio-placeholder-text-3-digits-container{padding-top:1px;cursor:default}.any-file-attachment-text{text-overflow:ellipsis;white-space:nowrap;overflow:hidden;padding-left:.13em;margin-left:auto;margin-right:auto}.remove-file-attachment-button{height:1.25em;width:1.25em;border:1px solid #cfcfcf;border-radius:25px;background-color:#fff;top:-4px;right:-5px;position:absolute;display:flex;justify-content:center;cursor:pointer;-webkit-user-select:none;user-select:none}.remove-file-attachment-button:hover{background-color:#e4e4e4}.remove-file-attachment-button:active{background-color:#d7d7d7}.x-icon{color:#4e4e4e;top:-.075em;position:relative;font-size:1.05em}.modal{display:none;flex-direction:column;align-items:center;justify-content:center;position:absolute;width:80%;max-width:420px;max-height:80%;margin:auto;top:0;right:0;bottom:0;left:0;z-index:3}.modal-content{border-top:1px solid rgb(217,217,217);border-left:1px solid rgb(217,217,217);border-right:1px solid rgb(217,217,217);border-top-left-radius:inherit;border-top-right-radius:inherit;background-color:#fff;overflow-y:auto;height:fit-content;max-height:calc(100% - 3.3em);width:100%}.modal-content>p{margin-left:1em;margin-right:1em}.modal-content>ul{margin-right:1em}.modal-button-panel{height:3.3em;border:1px solid;border-color:rgb(223,223,223) rgb(217,217,217) rgb(217,217,217);border-bottom-left-radius:inherit;border-bottom-right-radius:inherit;background-color:#fff;text-align:center;justify-content:center;display:flex;width:100%}.modal-button{min-width:2.5em;text-align:center;color:#fff;border-radius:5px;padding:.4em .4em .3em;height:1.25em;background-color:#3279b2;top:0;bottom:0;cursor:pointer;-webkit-user-select:none;user-select:none;margin:auto .31em}.modal-button:hover{background-color:#276da7}.modal-button:active{background-color:#1b5687}.modal-svg-button{padding:0 0 2px;width:2em;height:1.8em}.modal-svg-button-icon{width:100%;height:100%;filter:brightness(0) saturate(100%) invert(100%) sepia(15%) saturate(4%) hue-rotate(346deg) brightness(101%) contrast(102%)}#modal-background-panel{position:absolute;width:100%;height:100%;background-color:#00000042;z-index:2;display:none}.show-modal-background{animation:fadeInBackground .3s ease-in-out}@keyframes fadeInBackground{0%{opacity:0}to{opacity:1}}.show-modal{animation:fadeInModal .3s ease-in-out}@keyframes fadeInModal{0%{opacity:0;scale:.95}to{opacity:1;scale:1}}.hide-modal-background{animation:fadeOutBackground .2s ease-in-out}@keyframes fadeOutBackground{0%{opacity:1}to{opacity:0}}.hide-modal{animation:fadeOutModal .2s ease-in-out}@keyframes fadeOutModal{0%{opacity:1;scale:1}to{opacity:0;scale:.95}}.modal-camera-content{overflow:hidden;text-align:center;border:unset;height:100%;background-color:#2a2a2a;display:flex;justify-content:center}.camera-modal-canvas{max-width:100%;max-height:100%;margin-top:auto;margin-bottom:auto}.modal-svg-submit-button{background-color:green}.modal-svg-submit-button:hover{background-color:#007500}.modal-svg-submit-button:active{background-color:#006500}.modal-svg-submit-disabled{pointer-events:none;background-color:#747474}.modal-svg-close-button{height:1.56em;padding-top:.37em;padding-bottom:0;background-color:#c13e3e}.modal-svg-close-button:hover{background-color:#b43434}.modal-svg-close-button:active{background-color:#972929}.modal-svg-close-icon{width:80%;height:80%}.modal-svg-camera-button{height:1.6em;padding-top:.38em;padding-bottom:0}.modal-svg-camera-icon{height:76%}.modal-svg-refresh-icon{height:105%}.modal-svg-refresh-button{height:1.66em;padding-top:.11em;padding-bottom:.21em}.input-button-container{position:relative;z-index:1}.inside-right{position:absolute;right:calc(10% + .35em);bottom:.85em}.inside-left{position:absolute;left:calc(10% + .35em);bottom:.85em}.outside-left{position:absolute;right:calc(11px - .55em);bottom:.88em}.outside-right{position:absolute;left:calc(11px - .55em);bottom:.88em}#upload-images-icon{position:absolute;pointer-events:none;width:1.45em;height:1.45em;left:.11em;bottom:.08em;filter:brightness(0) saturate(100%) invert(43%) sepia(0%) saturate(740%) hue-rotate(77deg) brightness(99%) contrast(92%)}#upload-gifs-icon{position:absolute;pointer-events:none;width:1.5em;height:1.48em;left:.07em;bottom:.08em;filter:brightness(0) saturate(100%) invert(49%) sepia(0%) saturate(2586%) hue-rotate(12deg) brightness(93%) contrast(90%)}#upload-audio-icon{position:absolute;pointer-events:none;width:1.21em;height:1.21em;left:.17em;bottom:.2em;filter:brightness(0) saturate(100%) invert(15%) sepia(0%) saturate(337%) hue-rotate(125deg) brightness(91%) contrast(94%);transform:scaleX(.95)}#camera-icon{position:absolute;pointer-events:none;width:1.21em;height:1.21em;left:.23em;bottom:.2em;filter:brightness(0) saturate(100%) invert(52%) sepia(0%) saturate(161%) hue-rotate(164deg) brightness(91%) contrast(92%);transform:scaleX(.95)}#upload-mixed-files-icon{position:absolute;pointer-events:none;width:1.21em;height:1.21em;left:.25em;bottom:.2em;filter:brightness(0) saturate(100%) invert(53%) sepia(0%) saturate(36%) hue-rotate(74deg) brightness(98%) contrast(93%);transform:scaleX(.95)}#interim-text{color:gray}#microphone-button{padding-top:.5px}.outer-button-container>#microphone-button{padding-bottom:1px}#microphone-icon{position:absolute;pointer-events:none;width:1.21em;height:1.21em;left:.25em;bottom:.25em}.default-microphone-icon{filter:brightness(0) saturate(100%) invert(32%) sepia(0%) saturate(924%) hue-rotate(46deg) brightness(95%) contrast(99%)}.active-microphone-icon{filter:brightness(0) saturate(100%) invert(10%) sepia(97%) saturate(7495%) hue-rotate(0deg) brightness(101%) contrast(107%);border-radius:10px}.command-microphone-icon{filter:brightness(0) saturate(100%) invert(42%) sepia(96%) saturate(1067%) hue-rotate(77deg) brightness(99%) contrast(102%)}.unsupported-microphone{display:none}#submit-icon{height:100%;filter:brightness(0) saturate(100%) invert(32%) sepia(0%) saturate(924%) hue-rotate(46deg) brightness(95%) contrast(99%);width:1.21em}#stop-icon{background-color:#acacac;position:absolute;width:.95em;height:.95em;left:.35em;bottom:.35em;border-radius:2px}.submit-button-enlarged{scale:1.1;margin-right:.3em;margin-left:.3em}.loading-submit-button{position:relative;left:calc(-9990px + .275em);width:.22em;height:.22em;border-radius:5px;background-color:#848484;color:#848484;box-shadow:9990px 0 #848484,calc(9990px + .44em) 0 0 0 #848484,calc(9990px + .8em) 0 0 0 #848484;animation:loading-submit-button 1.5s infinite linear;bottom:-.75em}@keyframes loading-submit-button{0%{box-shadow:9990px 0 #848484,calc(9990px + .44em) 0 0 0 #848484,calc(9990px + .8em) 0 0 0 #848484}16.667%{box-shadow:9990px -6px #848484,calc(9990px + .44em) 0 0 0 #848484,calc(9990px + .8em) 0 0 0 #848484}33.333%{box-shadow:9990px 0 #848484,calc(9990px + .44em) 0 0 0 #848484,calc(9990px + .8em) 0 0 0 #848484}50%{box-shadow:9990px 0 #848484,calc(9990px + .44em) -6px 0 0 #848484,calc(9990px + .8em) 0 0 0 #848484}66.667%{box-shadow:9990px 0 #848484,calc(9990px + .44em) 0 0 0 #848484,calc(9990px + .8em) 0 0 0 #848484}83.333%{box-shadow:9990px 0 #848484,calc(9990px + .44em) 0 0 0 #848484,calc(9990px + .8em) -6px 0 0 #848484}to{box-shadow:9990px 0 #848484,calc(9990px + .44em) 0 0 0 #848484,calc(9990px + .8em) 0 0 0 #848484}}.tooltip{position:absolute;visibility:hidden;z-index:1;pointer-events:none;padding:5px 7px;background-color:#333;border-radius:5px;width:max-content}.tooltip-text{color:#fff;font-size:13px}.input-button{border-radius:4px;cursor:pointer;margin-bottom:.2em;-webkit-user-select:none;user-select:none}.input-button-svg{width:1.65em;height:1.65em}.input-button-svg-text{padding:1px;height:1.65em;display:flex}.input-button-svg-text>svg{padding:.22rem}.input-button-svg-text>div{margin-left:2px}.input-button:hover,.input-button:focus-visible{background-color:#9c9c9c2e}.input-button:active{background-color:#9c9c9c5e}.input-button:active:not(:hover){background-color:transparent}.loading-button{cursor:auto}.loading-button:hover{background-color:unset}.text-button{filter:unset!important;display:flex;justify-content:center;align-items:center;margin-left:4px;margin-right:4px;height:1.6em;width:max-content}#custom-icon{height:100%;width:1.2em}.custom-button-container-default{color:#505050}.custom-button-container-default>.dropup-menu-item-icon{color:unset}.custom-button-container-default>svg{filter:brightness(0) saturate(100%) invert(39%) sepia(1%) saturate(0%) hue-rotate(83deg) brightness(93%) contrast(90%)}.custom-button-container-default>.dropup-menu-item-icon>svg{position:absolute;left:.2em}.custom-button-container-active{background-color:#edf7ff;color:#0285ff}.custom-button-container-active:hover,.custom-button-container-active:focus-visible{background-color:#def0ff}.custom-button-container-active:active{background-color:#d2eaff}.custom-button-container-active>svg{filter:brightness(0) saturate(100%) invert(32%) sepia(34%) saturate(4196%) hue-rotate(196deg) brightness(107%) contrast(104%)}.custom-button-container-disabled{color:#aeaeae;cursor:auto}.custom-button-container-disabled>div{pointer-events:none}.custom-button-container-disabled:hover,.custom-button-container-disabled:focus-visible{background-color:transparent}.custom-button-container-disabled:active{background-color:transparent}.custom-button-container-disabled>svg{filter:brightness(0) saturate(100%) invert(67%) sepia(0%) saturate(818%) hue-rotate(28deg) brightness(102%) contrast(100%)}#text-input-container{background-color:#fff;width:80%;display:flex;border:1px solid #0000001a;border-radius:5px;margin-top:.8em;margin-bottom:.8em;box-shadow:#959da533 0 1px 12px;overflow-y:auto;max-height:200px;position:relative}.text-input-container-left-adjustment{margin-left:1.5em}.text-input-container-right-adjustment{margin-right:1.5em}.text-input-container-left-small-adjustment{margin-left:1.1em}.text-input-container-left-small-adjustment>.outside-left{right:calc(14px - .55em)}.text-input-container-right-small-adjustment{margin-right:1.1em}.text-input-container-right-small-adjustment>.outside-right{left:calc(14px - .55em)}#text-input{text-align:left;outline:none;word-wrap:break-word;line-break:auto}.text-input-styling{padding:.4em .5em;overflow:overlay;width:100%}.text-input-inner-left-adjustment{padding-left:2.2em}.text-input-inner-right-adjustment{padding-right:2em}.text-input-disabled{pointer-events:none;-webkit-user-select:none;user-select:none}[contenteditable]:empty:before{content:attr(deep-chat-placeholder-text);pointer-events:none}[contenteditable][textcolor]:empty:before{color:gray}.outside-right>#dropup-menu,.inside-right>#dropup-menu{right:0}#dropup-icon{position:absolute;pointer-events:none;width:1.16em;height:1.2em;left:.265em;bottom:.43em;filter:brightness(0) saturate(100%) invert(54%) sepia(0%) saturate(724%) hue-rotate(6deg) brightness(92%) contrast(90%)}.dropup-button>*{pointer-events:none}#dropup-menu{background-color:#fff;position:absolute;transform:translateY(-100%);border-radius:5px;z-index:1;top:-.49em;box-shadow:#0003 -1px 2px 10px,#0000001a 0 2px 4px;cursor:pointer;-webkit-user-select:none;user-select:none}.dropup-menu-item{height:1.4em;padding:.28em .84em .28em .35em;display:flex;position:relative}.dropup-menu-item:hover,.dropup-menu-item:focus-visible{background-color:#f3f3f3}.dropup-menu-item:active{background-color:#ebebeb}.dropup-menu-item:active:not(:hover){background-color:transparent}.dropup-menu-item:first-child{padding-top:.49em;border-top-left-radius:inherit;border-top-right-radius:inherit}.dropup-menu-item:last-child{padding-bottom:.45em;border-bottom-left-radius:inherit;border-bottom-right-radius:inherit}.dropup-menu-item-icon{width:1.39em;position:relative}.dropup-menu-item-icon>svg{bottom:0!important;top:0!important;margin-bottom:auto;margin-top:auto}#dropup-menu-item-icon-element-custom{position:absolute;pointer-events:none;width:1.21em;height:1.21em;left:.28em;filter:brightness(0) saturate(100%) invert(15%) sepia(0%) saturate(337%) hue-rotate(125deg) brightness(91%) contrast(94%)}.dropup-menu-item-text{margin-left:.56em;margin-top:.08em;width:max-content}#input{width:100%;display:inline-flex;text-align:center;margin-left:auto;margin-right:auto;margin-top:auto;position:relative;justify-content:center}#chat-view{height:100%;display:grid;grid-template-columns:100%}::-webkit-scrollbar{width:9px;height:9px}::-webkit-scrollbar-thumb{background-color:#d0d0d0;border-radius:5px}::-webkit-scrollbar-track{background-color:#f2f2f2}.deep-chat-web-model-button{margin-top:10px;margin-bottom:5px;margin-left:1px}:host{all:initial;display:table-cell}#container{height:inherit;width:inherit;overflow:hidden}`, wUe = Object.defineProperty, os = function(t, s, n, r) {
  for (var i = void 0, o = t.length - 1, l; o >= 0; o--) (l = t[o]) && (i = l(s, n, i) || i);
  return i && wUe(s, n, i), i;
}, as = /* @__PURE__ */ function(e) {
  function t() {
    var s;
    je(this, t);
    var n;
    return s = jt(this, t), s.getMessages = function() {
      return [];
    }, s.submitUserMessage = function() {
      return console.warn("submitUserMessage failed - please wait for chat view to render before calling this property.");
    }, s.addMessage = function() {
      return console.warn("addMessage failed - please wait for chat view to render before calling this property.");
    }, s.updateMessage = function() {
    }, s.clearMessages = function() {
    }, s.focusInput = function() {
      return kb.focusFromParentElement(s._elementRef);
    }, s.refreshMessages = function() {
    }, s.scrollToBottom = function() {
    }, s.disableSubmitButton = function() {
    }, s.setPlaceholderText = function() {
    }, s._hasBeenRendered = !1, s._auxiliaryStyleApplied = !1, s._elementRef = document.createElement("div"), s._elementRef.id = "container", s.attachShadow({
      mode: "open"
    }).appendChild(s._elementRef), (n = s.shadowRoot) == null || n.appendChild(Ho.buildElement()), Fg.apply(AUe, s.shadowRoot), setTimeout(function() {
      s._hasBeenRendered || s.onRender();
    }, 20), s;
  }
  return Ht(t, e), He(t, [{
    key: "changeToChatView",
    value: function() {
      this._activeService && (this._activeService.validateKeyProperty = !1), this.onRender();
    }
    // prettier-ignore
  }, {
    key: "onRender",
    value: function() {
      var n;
      e5.attemptAppendStyleSheetToHead(this.style), xn.processConnect(this), (!this._activeService || this._activeService.demo) && (this._activeService = kHe.create(this)), this.auxiliaryStyle && !this._auxiliaryStyleApplied && (Fg.apply(this.auxiliaryStyle, this.shadowRoot), this._auxiliaryStyleApplied = !0), Fg.applyDefaultStyleToComponent(this.style, this.chatStyle), xn.checkForContainerStyles(this, this._elementRef), this._activeService.key && this._activeService.validateKeyProperty ? HDe.render(this._elementRef, this.changeToChatView.bind(this), this._activeService) : !(this._activeService instanceof tn) || this._activeService.key ? ((n = this._childElement) !== null && n !== void 0 || (this._childElement = this.children[0]), bUe.render(this, this._elementRef, this._activeService, this._childElement)) : this._activeService instanceof tn && qje.render(this._elementRef, this.changeToChatView.bind(this), this._activeService), this._hasBeenRendered || Pu.onRender(this), this._hasBeenRendered = !0;
    }
  }, {
    key: "disconnectedCallback",
    value: function() {
      Mb.chat = void 0;
    }
  }]);
}(Wje);
os([rs("object")], as.prototype, "connect");
os([rs("object")], as.prototype, "directConnection");
os([rs("object")], as.prototype, "webModel");
os([rs("object")], as.prototype, "requestBodyLimits");
os([rs("function")], as.prototype, "requestInterceptor");
os([rs("function")], as.prototype, "responseInterceptor");
os([rs("function")], as.prototype, "validateInput");
os([rs("function")], as.prototype, "loadHistory");
os([rs("object")], as.prototype, "chatStyle");
os([rs("object")], as.prototype, "attachmentContainerStyle");
os([rs("object")], as.prototype, "dropupStyles");
os([rs("object")], as.prototype, "inputAreaStyle");
os([rs("object")], as.prototype, "textInput");
os([rs("object")], as.prototype, "submitButtonStyles");
os([rs("object")], as.prototype, "customButtons");
os([rs("string")], as.prototype, "auxiliaryStyle");
os([rs("array")], as.prototype, "history");
os([rs("object")], as.prototype, "browserStorage");
os([rs("object")], as.prototype, "introMessage");
os([rs("object")], as.prototype, "avatars");
os([rs("object")], as.prototype, "names");
os([rs("object")], as.prototype, "displayLoadingBubble");
os([rs("object")], as.prototype, "errorMessages");
os([rs("object")], as.prototype, "messageStyles");
os([rs("object")], as.prototype, "textToSpeech");
os([rs("object")], as.prototype, "speechToText");
os([rs("object")], as.prototype, "images");
os([rs("object")], as.prototype, "gifs");
os([rs("object")], as.prototype, "camera");
os([rs("object")], as.prototype, "audio");
os([rs("object")], as.prototype, "microphone");
os([rs("object")], as.prototype, "mixedFiles");
os([rs("object")], as.prototype, "dragAndDrop");
os([rs("object")], as.prototype, "introPanelStyle");
os([rs("object")], as.prototype, "htmlClassUtilities");
os([rs("object")], as.prototype, "remarkable");
os([rs("object")], as.prototype, "focusMode");
os([rs("function")], as.prototype, "onMessage");
os([rs("function")], as.prototype, "onClearMessages");
os([rs("function")], as.prototype, "onComponentRender");
os([rs("function")], as.prototype, "onInput");
os([rs("function")], as.prototype, "onError");
os([rs("object")], as.prototype, "demo");
os([rs("object")], as.prototype, "_insertKeyViewStyles");
customElements.define("deep-chat", as);
const CUe = me({
  name: "PropertyResi",
  props: {},
  directives: {
    Tooltip: Wo
  },
  components: {},
  data() {
    return {
      resiChat: !1,
      chatThreadId: void 0,
      chatEnd: !1,
      chatBottom: !1,
      chatPopped: !1,
      chatMinimized: !1
    };
  },
  computed: {
    //#region Resy
    directConnection() {
      var e;
      return this.chatThreadId || (this.chatThreadId = Go(`chatThread_${(e = this.property) == null ? void 0 : e.propId}`)), {
        openAI: {
          key: "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",
          assistant: {
            assistant_id: "asst_U4UwtHhFOJ1zXlm4WfgQaSG0",
            thread_id: this.chatThreadId,
            load_thread_history: !0,
            function_handler: async (t) => await t.map(async (s) => {
              var n, r, i, o, l, d, c, u, m, f, v, b, w, S, I, T, x, k, C, O, E, B, M, R, F, L, j, H;
              try {
                const te = JSON.parse(s.arguments);
                switch (console.log(`${this.$options.name}.deepChat.function_handler`, s.name, te), s.name) {
                  case "propertyVitals": {
                    const re = this.propertyVitals();
                    return console.log(`${this.$options.name}.propertyVitals`, JSON.parse(JSON.stringify(re))), JSON.stringify(re);
                  }
                  case "calculatedYears": {
                    if (!((n = this.calculatedResults) != null && n.normalized))
                      return "It seems that the calculator has not been run yet.";
                    const re = {
                      normalized: jr((r = this.calculatedResults) == null ? void 0 : r.normalized),
                      raw: jr((i = this.calculatedResults) == null ? void 0 : i.raw)
                    };
                    return console.log(`${this.$options.name}.calculatedYears`, JSON.parse(JSON.stringify(re))), JSON.stringify(re);
                  }
                  case "get_down_payment_percentage":
                  case "getDownPaymentPercentage":
                    return `${this.propertyStore.downpayment}`;
                  case "set_down_payment_percentage":
                  case "setDownPaymentPercentage":
                    if ("down_payment_percent" in te) {
                      let re = vs(te.down_payment_percent);
                      return re > 1 ? "Please call all functions with percentage numbers formated as decimal percntages rather than human readable whole numbers." : (this.propertyStore.setDownpayment(re), this.propertyStore.forceUpdateValues(), await this.propertyStore.calculate(), `Downpayment was set to ${Wt(this.propertyStore.downpayment)}`);
                    }
                    return "The down_payment_percent argument is missing.";
                  case "analysisConfiguration": {
                    const re = {
                      primaryMetricsView: (o = this.account) == null ? void 0 : o.defaultTaxMetrics,
                      calculatorMode: (l = this.propertyStore.calcParams) == null ? void 0 : l.investmentStrategy,
                      propertyType: (d = this.propertyStore.property) == null ? void 0 : d.propertyType,
                      rentalType: (c = this.propertyStore.calcParams) == null ? void 0 : c.rentalType
                    };
                    return ((u = this.property) == null ? void 0 : u.propertyType) != Qa.SingleFamily && (re.unitCount = (m = this.property) == null ? void 0 : m.unitCount), ((f = this.propertyStore.calcParams) == null ? void 0 : f.rentalType) != Ut.LongTerm && is((v = this.propertyStore.calcParams) == null ? void 0 : v.rentalTypeComparisons, nt.LongTerm) && (re.compareLongTerm = !0), ((b = this.propertyStore.calcParams) == null ? void 0 : b.rentalType) != Ut.ShortTerm && is((w = this.propertyStore.calcParams) == null ? void 0 : w.rentalTypeComparisons, nt.ShortTerm) && (re.compareShortTerm = !0), ((S = this.propertyStore.calcParams) == null ? void 0 : S.rentalType) != Ut.PadSplit && is((I = this.propertyStore.calcParams) == null ? void 0 : I.rentalTypeComparisons, nt.PadSplit) && (re.comparePadSplit = !0), console.log(`${this.$options.name}.analysisConfiguration`, JSON.parse(JSON.stringify(re))), JSON.stringify(re);
                  }
                  case "primaryParameters": {
                    const re = {
                      purchasePrice: (T = this.propertyStore.calcParams) == null ? void 0 : T.purchaseprice,
                      acquisitionClosingCosts: (x = this.propertyStore.calcParams) == null ? void 0 : x.titlecharges,
                      holdPeriodAuto: ((k = this.propertyStore.holdPeriod) == null ? void 0 : k.holdPeriod) == 0,
                      holdPeriod: (C = this.propertyStore.holdPeriod) == null ? void 0 : C.holdPeriod,
                      dispositionClosingCosts: (O = this.propertyStore.calcParams) == null ? void 0 : O.costofsale,
                      downpayment: this.propertyStore.downpayment,
                      loanFees: (E = this.propertyStore.calcParams) == null ? void 0 : E.loanfees,
                      interestRate: (B = this.propertyStore.calcParams) == null ? void 0 : B.interestrate,
                      loanAmortizationYears: this.propertyStore.calcParams.loanterm,
                      interestOnlyLoan: this.propertyStore.calcParams.interestOnlyLoan,
                      interestOnlyTerm: this.propertyStore.calcParams.interestOnlyTerm,
                      afterTaxAnalysis: this.propertyStore.calcParams.afterTaxAnalysis,
                      propertyTax: this.propertyStore.calcParams.propertytax,
                      hoa: this.propertyStore.calcParams.associationfee
                    };
                    return (((M = this.propertyStore.calcParams) == null ? void 0 : M.rentalType) == Ut.LongTerm || is((R = this.propertyStore.calcParams) == null ? void 0 : R.rentalTypeComparisons, nt.LongTerm)) && (re.longTermParameters = {
                      rehabExpenses: this.propertyStore.calcParams.rehabamount,
                      rehabStartupVacancy: this.propertyStore.calcParams.rehabdays,
                      afterRepairValue: this.propertyStore.calcParams.arv,
                      rentalRate: this.propertyStore.calcParams.monthlyRentalYear1,
                      otherIncome: this.propertyStore.calcParams.otherIncome,
                      vacancyType: this.propertyStore.calcParams.vacancyType,
                      averageLengthOfStay: this.propertyStore.calcParams.averagelengthofstay,
                      averageTimeBetweenTenants: this.propertyStore.calcParams.timebetweentenants,
                      annualVacancy: this.propertyStore.calcParams.percentVacancy,
                      currentTenantRemaining: this.propertyStore.calcParams.currentTenantRemaining,
                      propertyInsurance: this.propertyStore.calcParams.propertyinsurance,
                      propertyManagement: this.propertyStore.calcParams.managementfee,
                      propertyManagementIsPercent: is(this.propertyStore.calcParams.percentageLongTermFields, U.PropertyManagement),
                      leaseCommission: this.propertyStore.calcParams.leasecommission,
                      leaseRenewalFee: this.propertyStore.calcParams.leaserenewalfee,
                      propertyMaintenance: this.propertyStore.calcParams.maintenance,
                      utilityExpenses: this.propertyStore.calcParams.utilityExpenses,
                      otherExpenses: this.propertyStore.calcParams.otherExpense,
                      capitalExpenditures: this.propertyStore.calcParams.capitalExpenditures,
                      annualRentalRateIncrease: this.propertyStore.calcParams.annualrentalgrowth,
                      annualExpenseInflation: this.propertyStore.calcParams.annualexpensegrowth,
                      annualPropertyAppreciation: this.propertyStore.calcParams.propertyappreciation
                    }), (((F = this.propertyStore.calcParams) == null ? void 0 : F.rentalType) == Ut.ShortTerm || is((L = this.propertyStore.calcParams) == null ? void 0 : L.rentalTypeComparisons, nt.ShortTerm)) && (re.shortTermParameters = {
                      rehabExpenses: this.propertyStore.calcParams.strRehabAmount,
                      rehabStartupVacancy: this.propertyStore.calcParams.strRehabDays,
                      afterRepairValue: this.propertyStore.calcParams.strArv,
                      rentalRate: this.propertyStore.calcParams.strRentalRate,
                      otherIncome: this.propertyStore.calcParams.strOtherIncome,
                      daysAvailablePerYear: this.propertyStore.calcParams.strDaysAvailablePerYear,
                      daysOccupiedPerYear: this.propertyStore.calcParams.strDaysOccupiedPerYear,
                      propertyInsurance: this.propertyStore.calcParams.strPropertyInsurance,
                      propertyManagement: this.propertyStore.calcParams.strManagementFee,
                      propertyManagementIsPercent: is(this.propertyStore.calcParams.percentageShortTermFields, U.PropertyManagement),
                      leaseCommission: this.propertyStore.calcParams.strLeaseCommission,
                      leaseRenewalFee: this.propertyStore.calcParams.strLeaseRenewalFee,
                      propertyMaintenance: this.propertyStore.calcParams.strMaintenance,
                      utilityExpenses: this.propertyStore.calcParams.strUtilityExpenses,
                      otherExpenses: this.propertyStore.calcParams.strOtherExpense,
                      capitalExpenditures: this.propertyStore.calcParams.strCapitalExpenditures,
                      annualRentalRateIncrease: this.propertyStore.calcParams.strAnnualRentalGrowth,
                      annualExpenseInflation: this.propertyStore.calcParams.strAnnualExpenseGrowth,
                      annualPropertyAppreciation: this.propertyStore.calcParams.strPropertyAppreciation
                    }), (((j = this.propertyStore.calcParams) == null ? void 0 : j.rentalType) == Ut.PadSplit || is((H = this.propertyStore.calcParams) == null ? void 0 : H.rentalTypeComparisons, nt.PadSplit)) && (re.padSplitParameters = {
                      rehabExpenses: this.propertyStore.calcParams.padSplitRehabAmount,
                      rehabStartupVacancy: this.propertyStore.calcParams.padSplitRehabDays,
                      afterRepairValue: this.propertyStore.calcParams.padSplitArv,
                      rentalRate: this.propertyStore.calcParams.padSplitRentalRate,
                      otherIncome: this.propertyStore.calcParams.padSplitOtherIncome,
                      annualVacancyRate: this.propertyStore.calcParams.padSplitAnnualVacancyRate,
                      averageLengthOfStay: this.propertyStore.calcParams.padSplitAverageLengthOfStay,
                      propertyInsurance: this.propertyStore.calcParams.padSplitPropertyInsurance,
                      propertyManagement: this.propertyStore.calcParams.padSplitManagementFee,
                      propertyManagementIsPercent: is(this.propertyStore.calcParams.percentagePadSplitFields, U.PropertyManagement),
                      leaseCommission: this.propertyStore.calcParams.padSplitLeaseCommission,
                      leaseRenewalFee: this.propertyStore.calcParams.padSplitLeaseRenewalFee,
                      propertyMaintenance: this.propertyStore.calcParams.padSplitMaintenance,
                      utilityExpenses: this.propertyStore.calcParams.padSplitUtilityExpenses,
                      otherExpenses: this.propertyStore.calcParams.padSplitOtherExpense,
                      capitalExpenditures: this.propertyStore.calcParams.padSplitCapitalExpenditures,
                      annualRentalRateIncrease: this.propertyStore.calcParams.padSplitAnnualRentalGrowth,
                      annualExpenseInflation: this.propertyStore.calcParams.padSplitAnnualExpenseGrowth,
                      annualPropertyAppreciation: this.propertyStore.calcParams.padSplitPropertyAppreciation
                    }), console.log(`${this.$options.name}.primaryParameters`, JSON.parse(JSON.stringify(re))), JSON.stringify(re);
                  }
                  default:
                    return Se(`Function ${s.name} not implemented`), "Function not implemented";
                }
              } catch (te) {
                return console.error(te), "Hmm, we seemed to have ran into a problem attempting that function.";
              }
            })
          }
        }
      };
    },
    chatTextInput() {
      return {
        styles: {
          container: {
            width: "100%",
            margin: "0",
            border: "unset",
            borderTop: "1px solid #d5d5d5",
            borderRadius: "0px",
            boxShadow: "unset"
          },
          text: {
            fontSize: "1.05em",
            paddingTop: "11px",
            paddingBottom: "13px",
            paddingLeft: "50px",
            paddingRight: "2.4em"
          }
        },
        disabled: !1,
        placeholder: {
          text: "Ask me anything...",
          style: {
            color: "#bcbcbc"
          }
        }
      };
    },
    chatMessageStyles() {
      return {
        default: {
          user: {
            bubble: {
              backgroundColor: "#ff5e19",
              color: "#fff",
              fontSize: "14px",
              maxWidth: "90%"
            }
          },
          ai: {
            bubble: {
              backgroundColor: "#fff",
              color: "#000",
              fontSize: "14px",
              maxWidth: "90%"
            }
          }
        }
      };
    },
    //chatCustomButtons(): CustomButtons {
    //   return {
    //      position: "inside-left",
    //      styles: {
    //         button: {
    //            default: {
    //               container: {
    //                  default: {
    //                     border: "1px solid #e2e2e2",
    //                     borderRadius: "10px",
    //                     marginBottom: "4px"
    //                  }
    //               },
    //               svg: {
    //                  content: ''
    //               },
    //               text: {
    //                  content: "Search"
    //               }
    //            }
    //         }
    //      }
    //   }
    //},
    chatSubmitButtonStyles() {
      return {
        submit: {
          container: {
            default: {
              transform: "scale(1.21)",
              marginBottom: "-3px",
              marginRight: "0.4em"
            }
          }
        }
      };
    },
    //#endregion
    //#region Chat
    chatStyles() {
      return {
        "chat-default": !this.chatPopped,
        "chat-minimized": this.chatMinimized,
        "chat-end": this.chatEnd,
        "chat-bottom": this.chatBottom
      };
    },
    //#endregion
    ...at(qe),
    ...q(qe, ["calcParams", "firstProformaYearData", "property", "calculatedResults"]),
    ...q(ct, ["account"]),
    ...q(Te, ["access", "aclLoaded"])
  },
  methods: {
    number: Ve,
    minimizeChat() {
      this.chatMinimized = !0, this.chatPopped = !0;
    },
    moveChatBottom() {
      this.chatBottom = !0, this.chatEnd = !1, this.chatPopped = !0;
    },
    moveChatEnd() {
      this.chatEnd = !0, this.chatBottom = !1;
    },
    maximizeChat() {
      this.chatBottom = !0, this.chatPopped = !0;
    },
    restoreChat() {
      this.chatBottom = !1, this.chatPopped = !1, this.chatEnd = !1;
    },
    chatMaximized() {
      this.chatMinimized = !1;
    },
    //#region Resy
    chatMessage(e) {
      var t, s, n, r, i;
      console.log(`${this.$options.name}.chatMessage`, e, (s = (t = e == null ? void 0 : e.detail) == null ? void 0 : t.message) == null ? void 0 : s._sessionId), (r = (n = e == null ? void 0 : e.detail) == null ? void 0 : n.message) != null && r._sessionId && eo(`chatThread_${(i = this.property) == null ? void 0 : i.propId}`, e.detail.message._sessionId);
    },
    propertyVitals() {
      var t, s, n, r, i, o, l, d, c, u, m;
      return {
        investmentStrategy: this.calcParams.investmentStrategy,
        taxMetricsView: (t = this.account) == null ? void 0 : t.defaultTaxMetrics,
        propertyType: (s = this.property) == null ? void 0 : s.propertyType,
        purchasePrice: this.calcParams.purchaseprice,
        rentalRate: this.calcParams.monthlyRentalYear1,
        capRate: this.propertyStore.capRate,
        holdPeriod: (n = this.propertyStore.holdPeriod) == null ? void 0 : n.holdPeriod,
        coc: this.propertyStore.coc,
        cocAfterTax: this.propertyStore.cocAfterTax,
        irr: (r = this.propertyStore.holdPeriod) == null ? void 0 : r.irr,
        irrAfterTax: (i = this.propertyStore.holdPeriod) == null ? void 0 : i.irrAfterTax,
        initialInvestment: this.propertyStore.initialInvestment,
        totalInvestmentWithShortFall: this.propertyStore.totalInvestmentWithShortFall,
        totalInvestmentWithShortFallAfterTax: this.propertyStore.totalInvestmentWithShortFallAfterTax,
        downpayment: this.propertyStore.downpayment,
        accumulationOfWealth: this.propertyStore.accumulationOfWealth,
        accumulationOfWealthAfterTax: this.propertyStore.accumulationOfWealthAfterTax,
        totalShortfall: this.propertyStore.totalShortfall,
        totalShortfallAfterTax: this.propertyStore.totalShortfallAfterTax,
        titleCharges: (o = this.calculatedResults) == null ? void 0 : o.titleCharges,
        rehab: (l = this.calculatedResults) == null ? void 0 : l.rehab,
        totalCost: (d = this.calculatedResults) == null ? void 0 : d.totalCost,
        loanAmount: this.propertyStore.loanAmount,
        loanFees: (c = this.calculatedResults) == null ? void 0 : c.loanFeesAmount,
        propertyTax: this.propertyStore.estimatedPropertyTax,
        propertyInsurance: this.propertyStore.estimatedPropertyInsurance,
        mortgagePayment: this.propertyStore.mortgagePayment,
        monthlyCashFlow: (u = this.firstProformaYearData) == null ? void 0 : u.monthlyCashFlow,
        monthlyCashFlowAfterTax: (m = this.firstProformaYearData) == null ? void 0 : m.monthlyCashFlowAfterTax
      };
    }
    //#endregion
  },
  mounted() {
    this.aclLoaded.then(() => {
      Hr("c", (e) => {
        this.resiChat = !this.resiChat;
      }, !0, !1, !1, !0, !0), q4((e) => {
        this.resiChat = !this.resiChat;
      }, !0, !0, "aside", !1);
    });
  }
}), UC = "data:image/png;base64,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", SUe = {
  key: 0,
  class: "chat-container mt-4"
}, PUe = { class: "card-header bg-eclipse text-light d-flex align-items-center" }, kUe = { class: "ms-auto d-flex gap-2" };
function EUe(e, t, s, n, r, i) {
  const o = pe("deep-chat"), l = Za("tooltip");
  return e.resiChat ? (p(), h("div", SUe, [
    e.chatMinimized ? (p(), h("div", {
      key: 0,
      onClick: t[0] || (t[0] = (...d) => e.chatMaximized && e.chatMaximized(...d)),
      class: z(["position-fixed btn-chat", e.chatStyles])
    }, t[6] || (t[6] = [
      a("div", { class: "avatar avatar-sm rounded-circle bg-light" }, [
        a("img", {
          src: UC,
          width: "40",
          height: "40",
          class: "img-fluid"
        })
      ], -1)
    ]), 2)) : P("", !0),
    a("div", {
      class: z(["card overflow-hidden card-resi", e.chatStyles])
    }, [
      a("div", PUe, [
        t[12] || (t[12] = a("div", { class: "d-flex fw-bold flex-row align-items-center" }, [
          a("div", { class: "avatar avatar-sm rounded-circle bg-light me-2" }, [
            a("img", {
              src: UC,
              width: "40",
              height: "40",
              class: "img-fluid"
            })
          ]),
          a("span", null, [
            y("Resi AI "),
            a("i", { class: "fa-light fa-sparkles" })
          ])
        ], -1)),
        a("div", kUe, [
          V((p(), h("button", {
            type: "button",
            class: "btn btn-sm btn-link text-white",
            onClick: t[1] || (t[1] = (...d) => e.minimizeChat && e.minimizeChat(...d))
          }, t[7] || (t[7] = [
            a("i", { class: "fa-light fa-window-minimize" }, null, -1),
            a("span", { class: "visually-hidden" }, "Minimize Resi AI", -1)
          ]))), [
            [Us, e.chatPopped],
            [
              l,
              "Minimize Resi Chat",
              void 0,
              { left: !0 }
            ]
          ]),
          V((p(), h("button", {
            type: "button",
            class: "btn btn-sm btn-link text-white",
            onClick: t[2] || (t[2] = (...d) => e.moveChatBottom && e.moveChatBottom(...d))
          }, t[8] || (t[8] = [
            a("i", { class: "fa-light fa-expand" }, null, -1),
            a("span", { class: "visually-hidden" }, "Pop Resi AI", -1)
          ]))), [
            [Us, !e.chatPopped],
            [
              l,
              "Pop Resi Chat",
              void 0,
              { left: !0 }
            ]
          ]),
          V((p(), h("button", {
            type: "button",
            class: "btn btn-sm btn-link text-white",
            onClick: t[3] || (t[3] = (...d) => e.restoreChat && e.restoreChat(...d))
          }, t[9] || (t[9] = [
            a("i", { class: "fa-light fa-compress" }, null, -1),
            a("span", { class: "visually-hidden" }, "Restore Resi AI", -1)
          ]))), [
            [Us, e.chatPopped],
            [
              l,
              "Restore Resi Chat",
              void 0,
              { left: !0 }
            ]
          ]),
          V((p(), h("button", {
            type: "button",
            class: "btn btn-sm btn-link text-white",
            onClick: t[4] || (t[4] = (...d) => e.moveChatBottom && e.moveChatBottom(...d))
          }, t[10] || (t[10] = [
            a("i", { class: "fa-light fa-arrow-down-to-line" }, null, -1),
            a("span", { class: "visually-hidden" }, "Move Resi AI bottom", -1)
          ]))), [
            [Us, e.chatPopped && e.chatEnd],
            [
              l,
              "Dock Resi Chat to the bottom",
              void 0,
              { bottom: !0 }
            ]
          ]),
          V((p(), h("button", {
            type: "button",
            class: "btn btn-sm btn-link text-white",
            onClick: t[5] || (t[5] = (...d) => e.moveChatEnd && e.moveChatEnd(...d))
          }, t[11] || (t[11] = [
            a("i", { class: "fa-light fa-arrow-right-to-line" }, null, -1),
            a("span", { class: "visually-hidden" }, "Move Resi AI End", -1)
          ]))), [
            [Us, e.chatPopped && e.chatBottom],
            [
              l,
              "Dock Resi Chat to the right",
              void 0,
              { bottom: !0 }
            ]
          ])
        ])
      ]),
      N(o, {
        style: { width: "100%", height: "400px", background: "#f2f2f2" },
        onMessage: e.chatMessage,
        textInput: e.chatTextInput,
        submitButtonStyles: e.chatSubmitButtonStyles,
        directConnection: e.directConnection,
        messageStyles: e.chatMessageStyles,
        customButtons: [
          {
            position: "inside-left",
            styles: {
              button: {
                default: {
                  container: {
                    default: { border: "1px solid #e2e2e2", borderRadius: "10px", padding: "5px", top: "4px" }
                  },
                  svg: {
                    content: `
 <svg xmlns="http://www.w3.org/2000/svg" viewBox="-0 0 512 512">
 <path d="M69.4 210.6C89.8 126.5 165.6 64 256 64c71.1 0 133.1 38.6 166.3 96L368 160c-8.8 0-16 7.2-16 16s7.2 16 16 16l80.7 0 15.3 0c8.8 0 16-7.2 16-16l0-96c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 60.6C408.8 75.5 337.5 32 256 32C149.6 32 60.5 106.2 37.7 205.6C35.5 215.2 43.1 224 53 224c7.9 0 14.6-5.7 16.5-13.4zm373.2 90.9C422.2 385.5 346.4 448 256 448c-71.1 0-133.1-38.6-166.3-96l54.5 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-80.9 0-15.1 0c-8.8 0-16 7.2-16 16l0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-60.2C103.4 436.6 174.7 480 256 480c106.4 0 195.5-74.2 218.3-173.6c2.2-9.6-5.4-18.4-15.3-18.4c-7.9 0-14.6 5.7-16.5 13.4z"/>
  </svg>`
                  },
                  text: {
                    content: ""
                  }
                }
              }
            }
          }
        ]
      }, null, 8, ["onMessage", "textInput", "submitButtonStyles", "directConnection", "messageStyles"])
    ], 2)
  ])) : P("", !0);
}
const Qls = /* @__PURE__ */ Ae(CUe, [["render", EUe]]);
Rt.register(Xr, qr, Qr, Kr, Zr, Jr, $r);
const IUe = "#23B14C", TUe = "#C02323", OUe = "#820401", RUe = "#00A2E8", zC = "#132844", WC = "#DE542C", GC = new xa(), LUe = me({
  name: "PerformanceCharts",
  props: {
    annualCashFlow: Boolean,
    netEquity: Boolean
  },
  emits: [
    "infoPopover"
  ],
  data() {
    return {
      currentMode: void 0,
      chartsInitialized: !1,
      chart1Data: void 0,
      chart1Options: void 0,
      chart2Data: void 0,
      chart2Options: void 0,
      chart3Data: void 0,
      chart3Options: void 0,
      chart4Data: void 0,
      chart4Options: void 0
    };
  },
  watch: {
    yearRentalTypeValues() {
      this.calculating || this.updateCharts();
    },
    isAdvancedMode(e) {
      this.updateCharts();
    }
  },
  computed: {
    calculatingClasses() {
      return {
        card: !0,
        "shadow-sm": !0,
        "position-relative": !0,
        "overflow-hidden": !0,
        calculating: this.calculating
      };
    },
    chartsStyle() {
      return {
        row: !0,
        "chart-data": !0,
        "row-cols-md-2": !0,
        "row-cols-xl-3": !0
      };
    },
    isAdvancedMode() {
      var e;
      return ((e = this.account) == null ? void 0 : e.defaultAnalysisMode) == Hn.Advanced;
    },
    showOnePercentRule() {
      return this.isAdvancedMode == !1 || this.isExistingInvestment && this.hasInvestmentGap == !0;
    },
    yearRentalTypeValues() {
      var e, t, s, n, r, i;
      switch (this.calcParams.rentalType) {
        case Ut.LongTerm:
          return (t = (e = this.calculatedResults) == null ? void 0 : e.normalized) == null ? void 0 : t.filter((o) => o.fiscalYear >= this.firstAnalyzedYear).sort((o, l) => o.fiscalYear - l.fiscalYear);
        case Ut.ShortTerm:
          return (n = (s = this.calculatedResults) == null ? void 0 : s.shortTerm) == null ? void 0 : n.filter((o) => o.fiscalYear >= this.firstAnalyzedYear).sort((o, l) => o.fiscalYear - l.fiscalYear);
        case Ut.PadSplit:
          return (i = (r = this.calculatedResults) == null ? void 0 : r.padSplit) == null ? void 0 : i.filter((o) => o.fiscalYear >= this.firstAnalyzedYear).sort((o, l) => o.fiscalYear - l.fiscalYear);
      }
    },
    yearRentalTypeRawValues() {
      var e, t, s, n, r, i;
      switch (this.calcParams.rentalType) {
        case Ut.LongTerm:
          return (t = (e = this.calculatedResults) == null ? void 0 : e.raw) == null ? void 0 : t.filter((o) => o.fiscalYear >= this.firstAnalyzedYear).sort((o, l) => o.fiscalYear - l.fiscalYear);
        case Ut.ShortTerm:
          return (n = (s = this.calculatedResults) == null ? void 0 : s.shortTerm) == null ? void 0 : n.filter((o) => o.fiscalYear >= this.firstAnalyzedYear).sort((o, l) => o.fiscalYear - l.fiscalYear);
        case Ut.PadSplit:
          return (i = (r = this.calculatedResults) == null ? void 0 : r.padSplit) == null ? void 0 : i.filter((o) => o.fiscalYear >= this.firstAnalyzedYear).sort((o, l) => o.fiscalYear - l.fiscalYear);
        default:
          return [];
      }
    },
    hasT12() {
      return this.mpod.length > 0;
    },
    mpod() {
      var e, t;
      return ((t = (e = this.purchaseFacts) == null ? void 0 : e.mpod) == null ? void 0 : t.filter((s) => s.year <= Et).sort((s, n) => s.year - n.year || s.month - n.month)) ?? [];
    },
    mpodAnnualCashFlow() {
      return this.mpod.reduce((e, { cashFlow: t }) => e + t, 0);
    },
    ...q(Te, ["access"]),
    ...q(ct, ["accountLoaded", "account"]),
    ...q(qe, ["calculating", "calcParams", "calculatedResults", "hideIrr", "hasInvestmentGap", "firstAnalyzedYear", "purchaseFacts", "isExistingInvestment"]),
    ...at(qe)
  },
  methods: {
    number: Ve,
    getChartBackgroundColors(e, t, s = !1, n) {
      return [
        ...e.filter((r) => r.fiscalYear < Et && s !== !0).map((r) => t(r) ? (n == null ? void 0 : n.pastNegative) ?? WC : (n == null ? void 0 : n.pastPositive) ?? RUe),
        ...e.filter((r) => r.fiscalYear == Et && s !== !0).map((r) => t(r) ? (n == null ? void 0 : n.presentNegative) ?? OUe : (n == null ? void 0 : n.presentPositive) ?? zC),
        ...e.filter((r) => r.fiscalYear > Et || s === !0).map((r) => t(r) ? (n == null ? void 0 : n.futureNegative) ?? TUe : (n == null ? void 0 : n.futurePositive) ?? IUe)
      ];
    },
    async expandYears(e) {
      const t = e.target, s = t.id, n = $(window).height(), r = $(window).width(), i = 100, o = n - i, l = r - i;
      let d, c;
      switch (await this.refreshCharts(30), s) {
        case "chart1":
          d = this.$refs.chartModal1, c = this.$refs.chart1;
          break;
        case "chart2":
          d = this.$refs.chart2Modal, c = this.$refs.chart2;
          break;
        case "chart3":
          d = this.$refs.chart3Modal, c = this.$refs.chart3;
          break;
        case "chart4":
          d = this.$refs.chartModal4, c = this.$refs.chart4;
          break;
      }
      if (d.classList.contains("modal") === !1) {
        d.classList.add("modal", "fade", "show"), d.style.display = "block", d.style.paddingRight = "17px", d.firstElementChild.classList.add("modal-dialog", "modal-dialog-centered", "modal-xl"), d.firstElementChild.firstElementChild.classList.add("pop", "modal-content");
        const u = document.createElement("div");
        u.id = "modalBackdrop", u.classList.add("modal-backdrop", "fade", "show"), document.body.appendChild(u), d.firstElementChild.firstElementChild.lastElementChild.classList.remove("d-none");
      }
      return c.style.top = `${i}`, c.style.left = `${i}`, c.style.width = `${l - i}`, c.style.height = `${o - i}`, t.classList.add("selected"), !1;
    },
    initCharts() {
      if (this.annualCashFlow) {
        if (this.$refs.chart1 && !this.chart1) {
          const e = tr("bar", this.chart1Data, this.chart1Options, [Rd()]);
          this.chart1 = new Rt(this.$refs.chart1, e);
        }
      } else if (this.$refs.chart1 && !this.chart1) {
        const e = tr("bar", this.chart1Data, this.chart1Options);
        this.chart1 = new Rt(this.$refs.chart1, e);
      }
      if (this.$refs.chart2 && !this.chart2) {
        const e = tr("line", this.chart2Data, this.chart2Options);
        this.chart2 = new Rt(this.$refs.chart2, e);
      }
      if (this.$refs.chart3 && !this.chart3) {
        const e = tr("line", this.chart3Data, this.chart3Options);
        this.chart3 = new Rt(this.$refs.chart3, e);
      }
      if (this.netEquity && this.$refs.chart4 && !this.chart4) {
        const e = tr("bar", this.chart4Data, this.chart4Options, [Rd()]);
        this.chart4 = new Rt(this.$refs.chart4, e);
      } else if (this.$refs.chart4 && !this.chart4) {
        const e = tr("bar", this.chart4Data, this.chart4Options);
        this.chart4 = new Rt(this.$refs.chart4, e);
      }
      this.chartsInitialized = !0, this.refreshCharts(10);
    },
    async setChartOptions() {
      await this.accountLoaded, await GC.runExclusive(() => {
        var e, t;
        this.currentMode != ((e = this.account) == null ? void 0 : e.defaultAnalysisMode) && (this.annualCashFlow ? (this.chart1Data ?? (this.chart1Data = Ld()), this.chart1Options = Bd()) : (this.chart1Data ?? (this.chart1Data = lk()), this.chart1Options = dk()), this.chart2Data ?? (this.chart2Data = ck()), this.chart2Options = uk(), this.chart3Data ?? (this.chart3Data = lf()), this.chart3Options = df(), this.netEquity ? (this.chart4Data ?? (this.chart4Data = Ld()), this.chart4Options = Bd()) : (this.chart4Data ?? (this.chart4Data = pk()), this.chart4Options = hk()), this.currentMode = (t = this.account) == null ? void 0 : t.defaultAnalysisMode, this.chartsInitialized || this.initCharts());
      });
    },
    async refreshCharts(e = 10) {
      await GC.runExclusive(async () => {
        var l, d, c, u, m;
        await this.accountLoaded, ((l = this.account) == null ? void 0 : l.defaultAnalysisMode) != Hn.Advanced && e <= 10 && (e = 7);
        let t = Et, s = (((d = this.yearRentalTypeValues) == null ? void 0 : d.filter((f) => f.fiscalYear <= t).length) ?? 0) - 1;
        s < 0 && (s = 0);
        const n = ((c = this.yearRentalTypeRawValues) == null ? void 0 : c.slice(s, s + e)) ?? [], r = ((u = this.yearRentalTypeValues) == null ? void 0 : u.slice(s, s + e)) ?? [], i = {
          futurePositive: De.Colors.Charts.DarkEclipse,
          futureNegative: De.Colors.Charts.LightSlateGrey,
          presentPositive: De.Colors.Charts.DarkEclipse,
          presentNegative: De.Colors.Charts.LightSlateGrey,
          pastPositive: De.Colors.Charts.DarkEclipse,
          pastNegative: De.Colors.Charts.LightSlateGrey
        }, o = {
          futurePositive: De.Colors.Charts.BeeCluster,
          futureNegative: De.Colors.Charts.PeachYellow,
          presentPositive: De.Colors.Charts.BeeCluster,
          presentNegative: De.Colors.Charts.PeachYellow,
          pastPositive: De.Colors.Charts.BeeCluster,
          pastNegative: De.Colors.Charts.PeachYellow
        };
        if (this.annualCashFlow && this.chart1Data && r.length > 0) {
          if (this.hasT12) {
            this.chart1Data.labels = ["T-12", ...r.map((v) => `'${v.fiscalYear - 2e3}`)], this.chart1Data.datasets[0].data = [this.mpodAnnualCashFlow, ...r.map((v) => Math.trunc(v.cashFlowBeforeTax))], this.chart1Data.datasets[1].data = [void 0, ...r.map((v) => Math.trunc(v.cashFlowAfterTax))];
            let f = zC;
            this.mpodAnnualCashFlow < 0 && (f = WC), this.chart1Data.datasets[0].backgroundColor = [f, ...this.getChartBackgroundColors(r, (v) => v.cashFlowBeforeTax < 0, !0, i)], this.chart1Data.datasets[1].backgroundColor = [f, ...this.getChartBackgroundColors(r, (v) => v.cashFlowAfterTax < 0, !0, o)];
          } else
            this.chart1Data.labels = r.map((f) => `'${f.fiscalYear - 2e3}`), this.chart1Data.datasets[0].data = r.map((f) => Math.trunc(f.cashFlowBeforeTax)), this.chart1Data.datasets[0].backgroundColor = this.getChartBackgroundColors(r, (f) => f.cashFlowBeforeTax < 0, !1, i), this.chart1Data.datasets[1].data = r.map((f) => Math.trunc(f.cashFlowAfterTax)), this.chart1Data.datasets[1].backgroundColor = this.getChartBackgroundColors(r, (f) => f.cashFlowAfterTax < 0, !1, o);
          this.chart1.update();
        } else this.chart1Data && r.length > 0 && (this.chart1Data.labels = r.map((f) => `'${f.fiscalYear - 2e3}`), this.chart1Data.datasets[0].backgroundColor = "#003f5c", this.chart1Data.datasets[0].data = r.map((f) => f.effectiveIncome), this.chart1Data.datasets.length == 1 ? console.warn("chart1Data in wrong mode") : (this.chart1Data.datasets[1].backgroundColor = "#ffa600", this.chart1Data.datasets[1].data = r.map((f) => f.totalExpenses), this.chart1Data.datasets[2].backgroundColor = "#bc5090", this.chart1Data.datasets[2].data = r.map((f) => f.annualCashFlow)), this.chart1.update());
        if (!this.showOnePercentRule && this.chart2Data && ((m = this.yearRentalTypeRawValues) == null ? void 0 : m.length) > 0)
          this.chart2Data.labels = r.map((f) => `'${f.fiscalYear - 2e3}`), this.chart2Data.datasets[0].label = "IRR", this.chart2Data.datasets[0].borderColor = De.Colors.Charts.DarkEclipse, this.chart2Data.datasets[1].label = "IRR After Tax", this.chart2Data.datasets[1].borderColor = De.Colors.Charts.BeeCluster, this.chart2Data.datasets[0].data = r.map((f) => f.irr), this.chart2Data.datasets[0].backgroundColor = De.Colors.Charts.DarkEclipse, this.chart2Data.datasets[1].data = r.map((f) => f.irrAfterTax), this.chart2Data.datasets[1].backgroundColor = De.Colors.Charts.BeeCluster, this.chart2Data.datasets[2].data = r.map((f) => f.netGainOnInvestment), this.chart2Data.datasets[2].backgroundColor = this.getChartBackgroundColors(r, (f) => (f.netGainOnInvestment ?? 0) < 0), this.chart2Data.datasets[1].hidden = !1, this.chart2Data.datasets[2].hidden = !1, this.chart2.update(), this.chart2.resize();
        else if (this.chart2Data && (n == null ? void 0 : n.length) > 0) {
          for (let f = 0; f < this.chart2Data.datasets.length; f++)
            this.chart2Data.datasets[f].hidden = !0;
          this.chart2.resize(), this.chart2.update();
        }
        this.chart3Data && (r == null ? void 0 : r.length) > 0 && (this.chart3Data.labels = r.map((f) => `'${f.fiscalYear - 2e3}`), this.chart3Data.datasets[0].backgroundColor = De.Colors.Charts.DarkEclipse, this.chart3Data.datasets[0].borderColor = De.Colors.Charts.DarkEclipse, this.chart3Data.datasets[0].data = r.map((f) => f.coc), this.chart3Data.datasets[2].backgroundColor = "#bc5090", this.chart3Data.datasets[2].borderColor = "#bc5090", this.chart3Data.datasets[2].data = r.map((f) => f.roe), this.chart3Data.datasets[1].backgroundColor = De.Colors.Charts.BeeCluster, this.chart3Data.datasets[1].borderColor = De.Colors.Charts.BeeCluster, this.chart3Data.datasets[1].data = r.map((f) => f.cocAfterTax), this.chart3.update(), this.chart3.resize()), this.netEquity && this.chart4Data && n.length > 0 ? (this.chart4Data.labels = n.map((f) => `'${f.fiscalYear - 2e3}`), this.chart4Data.datasets[0].data = n.map((f) => f.netEquity), this.chart4Data.datasets[0].backgroundColor = this.getChartBackgroundColors(n, (f) => f.netEquity < 0), this.chart4.update(), this.chart4.resize()) : this.chart4Data && this.chart4 && n.length > 0 && (this.chart4Data.labels = this.chartData.years.slice(s, s + e).map((f) => `'${f - 2e3}`), this.chart4Data.datasets[0].backgroundColor = "#003f5c", this.chart4Data.datasets[0].borderColor = "#003f5c", this.chart4Data.datasets[0].pointBorderColor = "#003f5c", this.chart4Data.datasets[0].pointBackgroundColor = "#003f5c", this.chart4Data.datasets[0].data = r.map((f) => f.grossWealthAccumulation), this.chart4Data.datasets[1].backgroundColor = "#58508d", this.chart4Data.datasets[1].data = r.map((f) => f.cumCashFlow), this.chart4Data.datasets[2].backgroundColor = "#bc5090", this.chart4Data.datasets[2].data = n.map((f) => f.initialEquity), this.chart4Data.datasets[3].backgroundColor = "#ff6361", this.chart4Data.datasets[3].data = n.map((f) => f.netAppreciation), this.chart4Data.datasets[4].backgroundColor = "#ffa600", this.chart4Data.datasets[4].data = n.map((f) => f.principalReduction), this.chart4.update(), this.chart4.resize());
      }).catch((t) => {
        Ns(t);
      });
    },
    updateCharts() {
      this.yearRentalTypeValues && this.setChartOptions().then(async () => await this.refreshCharts());
    },
    closeChartModal(e) {
      const t = e.target, s = t.dataset.chartId;
      let n, r;
      switch (s) {
        case "chart1":
          n = this.$refs.chartModal1, r = this.$refs.chart1;
          break;
        case "chart2":
          n = this.$refs.chart2Modal, r = this.$refs.chart2;
          break;
        case "chart3":
          n = this.$refs.chart3Modal, r = this.$refs.chart3;
          break;
        case "chart4":
          n = this.$refs.chartModal4, r = this.$refs.chart4;
          break;
      }
      n.classList.remove("modal", "fade", "show"), n.removeAttribute("style"), n.firstElementChild.classList.remove("modal-dialog", "modal-dialog-centered", "modal-xl"), n.firstElementChild.firstElementChild.classList.remove("pop", "modal-content"), document.getElementById("modalBackdrop").remove(), t.classList.add("d-none"), r.style.height = "580px", this.refreshCharts(10);
    },
    async showFinancialAnalysisTab(e) {
      e.target.dataset.bsTarget == "#proforma" && await this.accountLoaded.then(async () => await this.setChartOptions());
    },
    infoPopover(e) {
      this.$emit("infoPopover", e);
    }
  },
  created() {
    this.accountLoaded.then(() => this.setChartOptions()), this.propertyStore.addCalculatorEventListener(this.updateCharts), document.addEventListener("shown.bs.tab", this.showFinancialAnalysisTab);
  }
}), BUe = {
  key: 0,
  class: "calculating-animation position-absolute top-50 start-50 translate-middle text-center"
}, MUe = { class: "col" }, xUe = {
  class: "mini-chart",
  ref: "chartModal1"
}, FUe = { class: "text-truncate mb-3" }, VUe = {
  class: "chart",
  style: { position: "relative" }
}, DUe = {
  "data-id": "chart1",
  class: "performance-chart",
  id: "chart1",
  ref: "chart1",
  height: "140"
}, NUe = { class: "chart-legend" }, jUe = { class: "list-inline" }, HUe = { class: "col" }, UUe = {
  class: "mini-chart",
  ref: "chart3Modal"
}, zUe = { class: "text-truncate mb-3" }, WUe = {
  class: "chart",
  style: { position: "relative" }
}, GUe = {
  "data-id": "chart3",
  class: "performance-chart",
  id: "chart3",
  ref: "chart3",
  height: "140"
}, YUe = { class: "col position-relative" }, XUe = {
  key: 0,
  class: "chart2-overlay d-flex align-items-center justify-content-center"
}, qUe = {
  class: "mini-chart",
  ref: "chart2Modal"
}, QUe = { class: "text-truncate mb-3" }, KUe = {
  class: "chart",
  style: { position: "relative" }
}, ZUe = {
  "data-id": "chart2",
  class: "performance-chart",
  id: "chart2",
  ref: "chart2",
  height: "140"
};
function JUe(e, t, s, n, r, i) {
  return p(), h(A, null, [
    a("div", {
      class: z(e.calculatingClasses)
    }, [
      e.calculating ? (p(), h("div", BUe, t[9] || (t[9] = [
        a("i", { class: "fa-duotone fa-solid fa-compass fa-spin fa-lg text-eclipse" }, null, -1),
        a("br", null, null, -1),
        a("small", null, "Calculating", -1)
      ]))) : P("", !0),
      a("div", {
        class: z(e.chartsStyle)
      }, [
        a("div", MUe, [
          a("div", xUe, [
            a("div", null, [
              a("div", null, [
                a("div", FUe, [
                  e.annualCashFlow ? (p(), h(A, { key: 0 }, [
                    t[10] || (t[10] = y(" Annual Cash Flow ")),
                    a("i", {
                      class: "fa-light fa-question-circle info-pop ms-2",
                      onClick: t[0] || (t[0] = (...o) => e.infoPopover && e.infoPopover(...o)),
                      "data-title": "Annual Cash Flow",
                      "data-html": "true",
                      "data-render": "true",
                      "data-pop": "annualCashFlow"
                    }),
                    t[11] || (t[11] = a("div", { class: "d-none info-pop-annualCashFlow" }, [
                      a("p", null, " This chart shows how much profit or loss you generate each year after paying all property expenses, including mortgage. It helps you visualize whether or not the property is self-sustaining and the inflection point for when it is expected to become cash flow positive. ")
                    ], -1))
                  ], 64)) : (p(), h(A, { key: 1 }, [
                    y(" Income & Expenses ")
                  ], 64))
                ]),
                a("a", {
                  href: "javascript:void(0);",
                  class: "expandYears",
                  onClick: t[1] || (t[1] = (...o) => e.expandYears && e.expandYears(...o))
                }, [
                  a("div", VUe, [
                    a("canvas", DUe, null, 512)
                  ]),
                  t[12] || (t[12] = a("span", { class: "visually-hidden" }, "INE chart", -1))
                ]),
                a("div", NUe, [
                  a("ul", jUe, [
                    e.annualCashFlow ? (p(), h(A, { key: 1 }, [
                      t[14] || (t[14] = a("li", { class: "list-inline-item" }, [
                        a("span", { class: "btcf" }),
                        y("Before Tax Cash Flow")
                      ], -1)),
                      t[15] || (t[15] = a("li", { class: "list-inline-item" }, [
                        a("span", { class: "atcf" }),
                        y("After Tax Cash Flow")
                      ], -1))
                    ], 64)) : (p(), h(A, { key: 0 }, [
                      t[13] || (t[13] = Bt('<li class="list-inline-item"><span class="eri"></span>Effective Rental Income</li><li class="list-inline-item"><span class="te"></span>Total Expenses</li><li class="list-inline-item"><span class="acf"></span>Annual Cash Flow</li>', 3))
                    ], 64))
                  ])
                ]),
                a("button", {
                  type: "button",
                  class: "close d-none btn-close position-absolute top-15 end-15",
                  onClick: t[2] || (t[2] = (...o) => e.closeChartModal && e.closeChartModal(...o)),
                  "data-chart-id": "chart1",
                  "aria-hidden": "true",
                  "aria-label": "close"
                })
              ])
            ])
          ], 512)
        ]),
        a("div", HUe, [
          a("div", UUe, [
            a("div", null, [
              a("div", null, [
                a("div", zUe, [
                  t[16] || (t[16] = y(" Return on Investment")),
                  a("i", {
                    class: "fa-light fa-question-circle info-pop ms-2",
                    onClick: t[3] || (t[3] = (...o) => e.infoPopover && e.infoPopover(...o)),
                    "data-title": "Return on Investment",
                    "data-html": "true",
                    "data-render": "true",
                    "data-pop": "returnOnInvestment"
                  }),
                  t[17] || (t[17] = a("div", { class: "d-none info-pop-returnOnInvestment" }, [
                    a("p", null, " This graph compares two ways to measure your annual return: "),
                    a("ul", null, [
                      a("li", null, [
                        a("b", null, "Cash on Cash:"),
                        y(" How much income you earn relative to your original cash invested (down payment, closing costs, etc.). ")
                      ]),
                      a("li", null, [
                        a("b", null, "Return on Equity:"),
                        y(" How much income you earn based on your current equity (the portion of the property you actually own). ")
                      ])
                    ]),
                    a("p", null, " Watching both lines helps you decide if it's time to sell, refinance, or keep building equity. ")
                  ], -1))
                ]),
                a("a", {
                  href: "javascript:void(0);",
                  class: "expandYears",
                  onClick: t[4] || (t[4] = (...o) => e.expandYears && e.expandYears(...o))
                }, [
                  a("div", WUe, [
                    a("canvas", GUe, null, 512)
                  ]),
                  t[18] || (t[18] = a("span", { class: "visually-hidden" }, "CoC chart", -1))
                ]),
                t[19] || (t[19] = Bt('<div class="chart-legend"><ul class="list-inline"><li class="list-inline-item"><span class="atcf"></span>After Tax Cash on Cash </li><li class="list-inline-item"><span class="coc"></span>Before Tax Cash on Cash </li><li class="list-inline-item"><span class="re"></span>Return on Equity </li></ul></div>', 1)),
                a("button", {
                  type: "button",
                  class: "close position-absolute top-15 end-15 d-none btn-close",
                  onClick: t[5] || (t[5] = (...o) => e.closeChartModal && e.closeChartModal(...o)),
                  "data-chart-id": "chart3",
                  "aria-hidden": "true",
                  "aria-label": "close"
                })
              ])
            ])
          ], 512)
        ]),
        V(a("div", YUe, [
          e.showOnePercentRule ? (p(), h("div", XUe, t[20] || (t[20] = [
            a("div", { class: "badge text-bg-success rounded-pill" }, [
              a("i", { class: "fa-duotone fa-solid fa-warning me-2" }),
              y("IRR Chart cannot be shown ")
            ], -1)
          ]))) : P("", !0),
          a("div", qUe, [
            a("div", null, [
              a("div", null, [
                a("div", QUe, [
                  t[21] || (t[21] = y(" IRR & Net Gain ")),
                  a("i", {
                    class: "fa-light fa-question-circle info-pop ms-2",
                    onClick: t[6] || (t[6] = (...o) => e.infoPopover && e.infoPopover(...o)),
                    "data-title": "IRR & Net Gain",
                    "data-html": "true",
                    "data-render": "true",
                    "data-pop": "irrNetGain"
                  }),
                  t[22] || (t[22] = a("div", { class: "d-none info-pop-irrNetGain" }, [
                    a("p", null, " Here we see: "),
                    a("ul", null, [
                      a("li", null, [
                        a("b", null, "Internal Rate of Return (IRR):"),
                        y(" An annualized percentage that factors in when you receive cash flows and the sale proceeds. ")
                      ]),
                      a("li", null, [
                        a("b", null, "Net Gain:"),
                        y(" The total dollar profit after subtracting your initial investment."),
                        a("br"),
                        y("A higher IRR often signals a more profitable or faster-paying investment, while Net Gain shows the overall profit you walk away with. ")
                      ])
                    ]),
                    a("p", null, " A higher IRR often signals a more profitable or faster-paying investment, while Net Gain shows your overall bottom line. However, IRR can peak early. If your IRR still beats other investment options, holding a property longer—even if the IRR seems stagnant—may increase your Net Gain in the end. Decide when you’re satisfied with your total profit before selling, especially if good investment properties are hard to find. ")
                  ], -1))
                ]),
                a("a", {
                  href: "javascript:void(0);",
                  class: "expandYears",
                  onClick: t[7] || (t[7] = (...o) => e.expandYears && e.expandYears(...o))
                }, [
                  a("div", KUe, [
                    a("canvas", ZUe, null, 512)
                  ]),
                  t[23] || (t[23] = a("span", { class: "visually-hidden" }, " IRR chart ", -1))
                ]),
                t[24] || (t[24] = Bt('<div class="chart-legend"><ul class="list-inline"><li class="list-inline-item"><span class="irr"></span> Internal Rate of Return </li><li class="list-inline-item"><span class="ng"></span> Net Gain </li></ul></div>', 1)),
                a("button", {
                  type: "button",
                  class: "close position-absolute top-15 end-15 d-none btn-close",
                  onClick: t[8] || (t[8] = (...o) => e.closeChartModal && e.closeChartModal(...o)),
                  "data-chart-id": "chart2",
                  "aria-hidden": "true",
                  "aria-label": "close"
                })
              ])
            ])
          ], 512)
        ], 512), [
          [Us, e.isAdvancedMode]
        ])
      ], 2)
    ], 2),
    t[25] || (t[25] = Bt('<div class="modal fade" id="modalNotEnoughData" tabindex="-1" aria-labelledby="modalNotEnoughDataLabel" aria-hidden="true"><div class="modal-dialog modal-dialog-centered"><div class="modal-content bg-gradient-alphabet rounded"><div class="modal-header border-0"><button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button></div><div class="modal-body"><p class="modal-title fs-5 fw-bold" id="modalNotEnoughDataLabel">Not enough data</p><p> Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas viverra lectus nec risus vehicula, quis maximus libero sagittis. Pellentesque tincidunt velit sapien, vitae finibus turpis consequat non. Ut sed fringilla turpis, ac facilisis massa. Donec sagittis orci a erat porttitor, eu porttitor dui ultrices. Duis aliquet tempus tellus in mattis. Duis vitae ultrices purus. Sed risus felis, dapibus eget felis eget, bibendum efficitur ex. Mauris tempor scelerisque arcu tristique venenatis. Duis dignissim imperdiet tortor at congue. Integer nec finibus tellus. Nam nec aliquam libero. Mauris porttitor efficitur sollicitudin. </p><p> Fusce eget dui dignissim, sagittis elit id, efficitur risus. In pretium id ante id facilisis. Sed vel bibendum mi. Fusce interdum ut quam nec maximus. Duis ante ex, aliquet viverra libero vitae, rutrum cursus nibh. Nullam metus orci, accumsan sit amet mauris vel, interdum malesuada elit. Nunc quam mi, dignissim vitae imperdiet ac, malesuada non libero. Ut ac elementum massa. Vestibulum consequat, nibh vel dictum interdum, orci lectus bibendum ligula, ut egestas erat velit ut tortor. </p></div></div></div></div>', 1))
  ], 64);
}
const $Ue = /* @__PURE__ */ Ae(LUe, [["render", JUe]]), _Ue = me({
  name: "TotalInvestment",
  computed: {
    calculatingClasses() {
      return {
        card: !0,
        "h-100": !0,
        "card-initial-investment": !0,
        "shadow-sm": !0,
        "card-proforma": !0,
        calculating: this.calculating
      };
    },
    title() {
      return this.isExistingInvestment ? "Initial Investment" : "Initial Investment Summary";
    },
    shortTerm() {
      return this.isShortTerm && this.calculatedResults.shortTerm != null && this.calculatedResults.shortTerm.length > 1;
    },
    rehabExpense() {
      var e, t, s, n, r;
      return this.isShortTerm ? ((t = (e = this.calculatedResults) == null ? void 0 : e.shortTermSummary) == null ? void 0 : t.rehab) ?? 0 : this.isPadSplit ? ((n = (s = this.calculatedResults) == null ? void 0 : s.padSplitSummary) == null ? void 0 : n.rehab) ?? 0 : ((r = this.calculatedResults) == null ? void 0 : r.rehab) ?? 0;
    },
    workingCapital() {
      var e, t, s, n, r, i, o, l, d, c;
      return this.isShortTerm ? (((t = (e = this.calculatedResults) == null ? void 0 : e.shortTermSummary) == null ? void 0 : t.stabilizationReserve) ?? 0) + (((n = (s = this.calculatedResults) == null ? void 0 : s.shortTermSummary) == null ? void 0 : n.workingCapitalReserve) ?? 0) : this.isPadSplit ? (((i = (r = this.calculatedResults) == null ? void 0 : r.padSplitSummary) == null ? void 0 : i.stabilizationReserve) ?? 0) + (((l = (o = this.calculatedResults) == null ? void 0 : o.padSplitSummary) == null ? void 0 : l.workingCapitalReserve) ?? 0) : (((d = this.calculatedResults) == null ? void 0 : d.stabilizationReserve) ?? 0) + (((c = this.calculatedResults) == null ? void 0 : c.workingCapitalReserve) ?? 0);
    },
    propertyValue() {
      var e, t, s, n, r, i;
      if (this.ignoreHistoricalOperatingIncome && ((s = (t = (e = this.calculatedResults) == null ? void 0 : e.existingInvestmentSummary) == null ? void 0 : t.previousYear) == null ? void 0 : s.propertyValue) != null)
        return this.calculatedResults.existingInvestmentSummary.previousYear.propertyValue;
      if (this.delayedInService && ((i = (r = (n = this.calculatedResults) == null ? void 0 : n.existingInvestmentSummary) == null ? void 0 : r.serviceStartEoY) == null ? void 0 : i.propertyValue) != null)
        return this.calculatedResults.existingInvestmentSummary.serviceStartEoY.propertyValue;
    },
    costOfSale() {
      var e, t, s, n, r, i;
      if (this.ignoreHistoricalOperatingIncome && ((s = (t = (e = this.calculatedResults) == null ? void 0 : e.existingInvestmentSummary) == null ? void 0 : t.previousYear) == null ? void 0 : s.costOfSale) != null)
        return this.calculatedResults.existingInvestmentSummary.previousYear.costOfSale;
      if (this.delayedInService && ((i = (r = (n = this.calculatedResults) == null ? void 0 : n.existingInvestmentSummary) == null ? void 0 : r.serviceStartEoY) == null ? void 0 : i.costOfSale) != null)
        return this.calculatedResults.existingInvestmentSummary.serviceStartEoY.costOfSale;
    },
    investmentBasis() {
      var e, t;
      return (t = (e = this.calculatedResults) == null ? void 0 : e.existingInvestmentSummary) == null ? void 0 : t.investmentBasis;
    },
    totalCost() {
      return this.isExistingInvestment ? Ws(this.calculatedResults.purchasePrice, 0) + Ws(this.calculatedResults.titleCharges, 0) + this.rehabExpense : this.propertyStore.costBasis;
    },
    ...at(qe),
    ...q(qe, [
      "purchaseFacts",
      "calcParams",
      "calculatedResults",
      "calculating",
      "ignoreHistoricalOperatingIncome",
      "delayedInService",
      "initialInvestment",
      "isExistingInvestment",
      "firstYearAsRental",
      "purchaseYear",
      "isAtPurchase",
      "isShortTerm",
      "isPadSplit",
      "initialInvestmentDescribed",
      "costBasis"
    ])
  },
  methods: {
    number: Ve,
    currency: Ze
  },
  created() {
  },
  mounted() {
  }
}), eze = { class: "card-header bg-eclipse text-white rounded rounded-bottom-0 fw-bold text-uppercase text-center text-sm-start" }, tze = { class: "card-body p-0 overflow-hidden position-relative" }, sze = {
  key: 0,
  class: "calculating-animation position-absolute top-50 start-50 translate-middle text-center"
}, aze = { class: "table-data" }, nze = { class: "table table-sm mb-0" }, rze = { class: "text-end" }, oze = { class: "text-end" }, ize = { class: "text-end" }, lze = { class: "text-end" }, dze = { class: "text-end" }, cze = { class: "table-total" }, uze = {
  class: "fw-bold text-end",
  title: "Investment Basis Total"
}, pze = { class: "text-end" }, hze = { class: "text-end" }, mze = { class: "text-end" }, fze = { class: "bg-light fw-bold text-end" }, gze = { class: "text-end" }, vze = { class: "text-end" }, yze = { key: 0 }, bze = { class: "text-end" }, Aze = { class: "table-total" }, wze = ["title"], Cze = {
  key: 0,
  class: "alert alert-info rounded-top-0 lh-sm mb-0",
  role: "alert"
};
function Sze(e, t, s, n, r, i) {
  var o, l, d, c, u, m, f, v, b;
  return p(), h("div", {
    class: z(e.calculatingClasses)
  }, [
    a("div", eze, g(e.title), 1),
    a("div", tze, [
      e.calculating ? (p(), h("div", sze, t[0] || (t[0] = [
        a("i", { class: "fa-duotone fa-solid fa-compass fa-spin fa-lg text-eclipse" }, null, -1),
        a("br", null, null, -1),
        a("small", null, "Calculating", -1)
      ]))) : P("", !0),
      a("div", aze, [
        a("table", nze, [
          a("tbody", null, [
            e.isExistingInvestment && !e.isAtPurchase ? (p(), h(A, { key: 0 }, [
              a("tr", null, [
                t[1] || (t[1] = a("td", null, "Property Value", -1)),
                a("td", rze, g(e.currency((o = e.investmentBasis) == null ? void 0 : o.propertyValue)), 1)
              ]),
              a("tr", null, [
                t[2] || (t[2] = a("td", null, "Loan Balance", -1)),
                a("td", oze, g(e.currency((l = e.investmentBasis) == null ? void 0 : l.loanBalance)), 1)
              ]),
              a("tr", null, [
                t[3] || (t[3] = a("td", null, "Cost of Sale", -1)),
                a("td", ize, g(e.currency((d = e.investmentBasis) == null ? void 0 : d.costOfSale)), 1)
              ]),
              a("tr", null, [
                t[4] || (t[4] = a("td", null, "Rehab Expense", -1)),
                a("td", lze, g(e.currency((c = e.investmentBasis) == null ? void 0 : c.rehabAmount)), 1)
              ]),
              a("tr", null, [
                t[5] || (t[5] = a("td", null, "Working Capital", -1)),
                a("td", dze, g(e.currency((u = e.investmentBasis) == null ? void 0 : u.workingCapitalReserve)), 1)
              ]),
              a("tr", cze, [
                t[6] || (t[6] = a("th", { class: "fw-bold" }, "Total Investment", -1)),
                a("th", uze, g(e.currency((m = e.investmentBasis) == null ? void 0 : m.total)), 1)
              ])
            ], 64)) : (p(), h(A, { key: 1 }, [
              a("tr", null, [
                t[7] || (t[7] = a("td", null, "Purchase Price", -1)),
                a("td", pze, g(e.currency(e.calculatedResults.purchasePrice)), 1)
              ]),
              a("tr", null, [
                t[8] || (t[8] = a("td", null, "Plus: Title Charges", -1)),
                a("td", hze, g(e.currency(e.calculatedResults.titleCharges)), 1)
              ]),
              a("tr", null, [
                t[9] || (t[9] = a("td", null, "Plus: Rehab Expense", -1)),
                a("td", mze, g(e.currency(e.rehabExpense)), 1)
              ]),
              a("tr", null, [
                t[10] || (t[10] = a("th", { class: "bg-light fw-bold" }, "Total Cost", -1)),
                a("th", fze, g(e.currency(e.totalCost)), 1)
              ]),
              a("tr", null, [
                t[11] || (t[11] = a("td", null, "Less: Loan Amount", -1)),
                a("td", gze, "(" + g(e.currency(e.calculatedResults.loanAmount)) + ")", 1)
              ]),
              a("tr", null, [
                t[12] || (t[12] = a("td", null, "Plus: Loan Fees", -1)),
                a("td", vze, g(e.currency(e.calculatedResults.loanFeesAmount)), 1)
              ]),
              ((v = (f = e.purchaseFacts) == null ? void 0 : f.loan) == null ? void 0 : v.balancePaidOff) > 0 ? (p(), h("tr", yze, [
                t[13] || (t[13] = a("td", null, "Plus: Additional Principal Pay Down", -1)),
                a("td", bze, g(e.currency((b = e.purchaseFacts.loan) == null ? void 0 : b.balancePaidOff, 0, "N/A")), 1)
              ])) : P("", !0),
              a("tr", Aze, [
                t[14] || (t[14] = a("th", { class: "fw-bold" }, "Initial Investment", -1)),
                a("th", {
                  class: "fw-bold text-end",
                  title: e.initialInvestmentDescribed
                }, g(e.currency(e.initialInvestment, !1, "-")), 9, wze)
              ])
            ], 64))
          ])
        ]),
        e.isExistingInvestment && !e.isAtPurchase ? (p(), h("div", Cze, t[15] || (t[15] = [
          a("small", null, [
            a("i", { class: "fa-light fa-circle-info me-1" }),
            y("For properties previously purchased, but not yet in-service as a rental, the current equity is considered the intial investment. This is the amount you could alternatively extract from the asset and depoly into another investment. ")
          ], -1)
        ]))) : P("", !0)
      ])
    ])
  ], 2);
}
const Hb = /* @__PURE__ */ Ae(_Ue, [["render", Sze]]), Pze = me({
  name: "FlipInitialInvestment",
  props: {},
  components: {},
  data() {
    return {};
  },
  computed: {
    flipIsPermanentLoan() {
      return this.flipParams.purchaseMethod == Vt.PermanentLoan;
    },
    carryingCostBudget() {
      return this.flipBridgeCarryingCost * (this.flipDispositionMonth + 1) - this.flipProRatedTax;
    },
    ...at(qe),
    ...q(Te, ["access", "aclLoaded"]),
    ...q(qe, ["flipResults", "flipTotalCosts", "flipTotalCashInvested", "flipBridgeCarryingCost", "flipDispositionMonth", "flipProRatedTax", "flipParams", "flipHasBridgeLoan", "flipLoanFees", "flipLoanAmount"])
  },
  methods: {
    currency: Ze
  },
  created() {
  },
  mounted() {
  }
}), kze = { class: "card shadow-sm flex-fill" }, Eze = { class: "table table-sm" }, Ize = { class: "text-end" }, Tze = { class: "text-end" }, Oze = { class: "text-end" }, Rze = { key: 0 }, Lze = { class: "text-end" }, Bze = { class: "bg-light fw-bold text-end" }, Mze = { key: 1 }, xze = { class: "text-end" }, Fze = { key: 0 }, Vze = { key: 1 }, Dze = { class: "text-end" }, Nze = { class: "bg-light fw-bold text-end" };
function jze(e, t, s, n, r, i) {
  var o, l, d;
  return p(), h("div", kze, [
    t[9] || (t[9] = a("div", { class: "card-header bg-eclipse text-white rounded rounded-bottom-0 fw-bold text-center text-sm-start" }, " INITIAL INVESTMENT ", -1)),
    a("table", Eze, [
      a("tbody", null, [
        a("tr", null, [
          t[0] || (t[0] = a("td", null, " Purchase Price ", -1)),
          a("td", Ize, g(e.currency((o = e.flipResults) == null ? void 0 : o.purchasePrice)), 1)
        ]),
        a("tr", null, [
          t[1] || (t[1] = a("td", null, " Plus: Rehab ", -1)),
          a("td", Tze, g(e.currency((l = e.flipResults) == null ? void 0 : l.rehab)), 1)
        ]),
        a("tr", null, [
          t[2] || (t[2] = a("td", null, " Plus: Acquisition Closing Costs ", -1)),
          a("td", Oze, g(e.currency((d = e.flipResults) == null ? void 0 : d.acquisitionClosingCosts)), 1)
        ]),
        e.flipLoanFees > 0 ? (p(), h("tr", Rze, [
          t[3] || (t[3] = a("th", null, " Plus: Loan Fees ", -1)),
          a("th", Lze, g(e.currency(e.flipLoanFees)), 1)
        ])) : P("", !0),
        a("tr", null, [
          t[4] || (t[4] = a("th", { class: "bg-light fw-bold" }, " Initial Project Cost ", -1)),
          a("th", Bze, g(e.currency(e.flipTotalCosts)), 1)
        ]),
        e.flipLoanAmount > 0 ? (p(), h("tr", Mze, [
          a("th", null, [
            t[5] || (t[5] = y(" Less: ")),
            e.flipHasBridgeLoan ? (p(), h(A, { key: 0 }, [
              y(" Bridge ")
            ], 64)) : (p(), h(A, { key: 1 }, [
              y(" Permanent ")
            ], 64)),
            t[6] || (t[6] = y(" Loan Amount "))
          ]),
          a("th", xze, g(e.currency(e.flipLoanAmount)), 1)
        ])) : P("", !0),
        a("tr", null, [
          a("th", null, [
            t[7] || (t[7] = y(" Plus: Carrying Cost Reserve ")),
            e.flipParams.includeTaxInCashRequired ? (p(), h("small", Fze, "(Incl. Prop Tax)")) : (p(), h("small", Vze, "(Excl. Prop Tax)"))
          ]),
          a("th", Dze, g(e.currency(e.carryingCostBudget)), 1)
        ]),
        a("tr", null, [
          t[8] || (t[8] = a("th", { class: "bg-light fw-bold" }, " Total Cash Required ", -1)),
          a("th", Nze, g(e.currency(e.flipTotalCashInvested)), 1)
        ])
      ])
    ])
  ]);
}
const Zu = /* @__PURE__ */ Ae(Pze, [["render", jze]]), Hze = me({
  name: "KpiTotalInvestment",
  components: {
    ContentLoader: Sa,
    TotalInvestment: Hb,
    FlipInitialInvestment: Zu
  },
  emits: [
    "infoPopover"
  ],
  computed: {
    mainStyle() {
      return {
        blur: !this.haveAccess,
        "d-flex": this.haveAccess,
        "justify-content-center": this.haveAccess,
        "align-items-center": this.haveAccess,
        "h-100": this.haveAccess
      };
    },
    haveAccess() {
      var e, t;
      return this.isMarketplace || ((t = (e = this.acl) == null ? void 0 : e.properties) == null ? void 0 : t.financialAnalysis) == !0;
    },
    initialInvestment() {
      var e, t, s;
      return this.isFlip ? this.propertyStore.flipTotalCashInvested : this.isExistingInvestment && !this.isAtPurchase ? (t = (e = this.calculatedResults) == null ? void 0 : e.existingInvestmentSummary) == null ? void 0 : t.investmentBasis.total : (s = this.propertyStore) == null ? void 0 : s.initialInvestment;
    },
    initialInvestmentDescribed() {
      var e;
      return this.isFlip ? "Total Cash Invested for Flip" : this.isExistingInvestment && !this.isAtPurchase ? "Existing Investment Investment Basis" : (e = this.propertyStore) == null ? void 0 : e.initialInvestmentDescribed;
    },
    totalShortfall() {
      return this.showAfterTax ? this.propertyStore.totalShortfallAfterTax : this.propertyStore.totalShortfall;
    },
    totalInvestmentWithShortFall() {
      return this.showAfterTax ? this.propertyStore.totalInvestmentWithShortFallAfterTax : this.propertyStore.totalInvestmentWithShortFall;
    },
    ...at(qe),
    ...q(ct, ["showAfterTax"]),
    ...q(Te, ["acl", "aclLoaded"]),
    ...q(qe, [
      "calcParams",
      "calculatedResults",
      "isMarketplace",
      "isExistingInvestment",
      "flipTotalCashInvested",
      "flipNetInvestmentAfterRefi",
      "isFlip",
      "flipResults",
      "isAtPurchase",
      "isShortTerm",
      "isPadSplit",
      "refiCashOut",
      "hasShortFall"
    ])
  },
  methods: {
    currency: Ze,
    shortfallCurrencyStyle(e) {
      return {
        "text-danger": e > 0
      };
    },
    infoPopover(e) {
      this.$emit("infoPopover", e);
    }
  }
}), Uze = {
  key: 1,
  class: "flex-fill"
}, zze = { class: "d-flex justify-content-between gap-2" }, Wze = { class: "d-none info-pop-initialInvestment" }, Gze = ["title"], Yze = { class: "d-flex justify-content-between gap-2" }, Xze = { class: "d-flex justify-content-between border-top" }, qze = { class: "fw-bold" }, Qze = { class: "fw-bold fs-5" };
function Kze(e, t, s, n, r, i) {
  var c, u;
  const o = pe("content-loader"), l = pe("total-investment", !0), d = pe("flip-initial-investment");
  return p(), h("div", {
    class: z(e.mainStyle)
  }, [
    e.calculatedResults ? (p(), h("div", Uze, [
      t[21] || (t[21] = a("div", { class: "icon-shape bg-eclipse border-radius-md text-white d-flex justify-content-center align-items-center mb-3 mx-auto ms-md-0" }, [
        a("i", { class: "fa-light fa-lg fa-sack-dollar" })
      ], -1)),
      a("div", zze, [
        a("div", null, [
          t[5] || (t[5] = y(" Initial Investment")),
          a("i", {
            class: "fa-light fa-question-circle info-pop ms-2",
            onClick: t[0] || (t[0] = (...m) => e.infoPopover && e.infoPopover(...m)),
            "data-title": "Initial Investment",
            "data-html": "true",
            "data-render": "true",
            "data-pop": "initialInvestment"
          }),
          a("div", Wze, [
            t[3] || (t[3] = a("p", null, [
              a("b", null, "Initial Investment"),
              y(" is the total amount of money you put in upfront to purchase and prepare the property—like your down payment, closing costs, and any immediate repairs or improvements. This figure helps you see how much of your own cash is tied up before rental income (or other revenue) starts coming in. ")
            ], -1)),
            t[4] || (t[4] = a("p", null, " The initial investment for the property on this page is summarized in the table below: ", -1)),
            e.isFlip ? (p(), Fe(d, { key: 1 })) : (p(), Fe(l, { key: 0 }))
          ])
        ]),
        a("div", {
          class: "fw-bold fs-5",
          title: e.initialInvestmentDescribed
        }, [
          e.isFlip ? (p(), h(A, { key: 0 }, [
            y(g(e.currency(e.flipTotalCashInvested)), 1)
          ], 64)) : e.isExistingInvestment && !e.isAtPurchase ? (p(), h(A, { key: 1 }, [
            y(g(e.currency((u = (c = e.calculatedResults) == null ? void 0 : c.existingInvestmentSummary) == null ? void 0 : u.investmentBasis.total)), 1)
          ], 64)) : (p(), h(A, { key: 2 }, [
            y(g(e.currency(e.initialInvestment)), 1)
          ], 64))
        ], 8, Gze)
      ]),
      a("div", Yze, [
        a("div", null, [
          e.isFlip && e.refiCashOut < 0 ? (p(), h(A, { key: 0 }, [
            t[8] || (t[8] = y(" Refi Cash In & Cash Flow Shortfall ")),
            e.showAfterTax ? (p(), h(A, { key: 0 }, [
              t[6] || (t[6] = a("br", { class: "d-xl-none" }, null, -1)),
              t[7] || (t[7] = y("(After-tax)"))
            ], 64)) : P("", !0)
          ], 64)) : e.isFlip && e.refiCashOut > 0 ? (p(), h(A, { key: 1 }, [
            t[11] || (t[11] = y(" Refi Cash Out & Cash Flow Shortfall  ")),
            e.showAfterTax ? (p(), h(A, { key: 0 }, [
              t[9] || (t[9] = a("br", { class: "d-xl-none" }, null, -1)),
              t[10] || (t[10] = y("(After-tax) "))
            ], 64)) : P("", !0)
          ], 64)) : e.isFlip ? (p(), h(A, { key: 2 }, [
            t[14] || (t[14] = y(" Cash Flow Shortfall  ")),
            e.showAfterTax ? (p(), h(A, { key: 0 }, [
              t[12] || (t[12] = a("br", { class: "d-xl-none" }, null, -1)),
              t[13] || (t[13] = y("(After-tax) "))
            ], 64)) : P("", !0)
          ], 64)) : (p(), h(A, { key: 3 }, [
            t[17] || (t[17] = y(" Cash Flow Shortfall  ")),
            e.showAfterTax ? (p(), h(A, { key: 0 }, [
              t[15] || (t[15] = a("br", { class: "d-xl-none" }, null, -1)),
              t[16] || (t[16] = y("(After-tax) "))
            ], 64)) : P("", !0),
            a("i", {
              class: "fa-light fa-question-circle info-pop ms-2",
              onClick: t[1] || (t[1] = (...m) => e.infoPopover && e.infoPopover(...m)),
              "data-title": "Cash Flow Shortfall",
              "data-html": "true",
              "data-render": "true",
              "data-pop": "shortFall"
            }),
            t[18] || (t[18] = a("div", { class: "d-none info-pop-shortFall" }, [
              a("p", null, [
                a("b", null, "Cash Flow Shortfall"),
                y(" is the total amount you’ll have to cover out of pocket when the property’s expenses exceed its rental income during your ownership. It isn’t paid at closing (unlike your down payment and other initial costs), but it’s essential to budget for if monthly rent won’t cover the mortgage and other expenses. Refinancing at a lower interest rate or increasing rental income in the future may reduce or eliminate this shortfall, but based on current assumptions, this figure shows how much you might need to set aside. ")
              ])
            ], -1))
          ], 64))
        ]),
        a("div", {
          class: z(["fw-bold fs-5", e.shortfallCurrencyStyle(e.totalShortfall)])
        }, [
          e.isFlip ? (p(), h(A, { key: 0 }, [
            y(g(e.currency(e.totalShortfall + -e.refiCashOut)), 1)
          ], 64)) : (p(), h(A, { key: 1 }, [
            y(g(e.currency(e.totalShortfall)), 1)
          ], 64))
        ], 2)
      ]),
      a("div", Xze, [
        a("div", qze, [
          t[19] || (t[19] = y(" Total Investment ")),
          e.showAfterTax ? (p(), h(A, { key: 0 }, [
            y("(After-tax)")
          ], 64)) : P("", !0),
          a("i", {
            class: "fa-light fa-question-circle info-pop ms-2",
            onClick: t[2] || (t[2] = (...m) => e.infoPopover && e.infoPopover(...m)),
            "data-title": "Total Investment",
            "data-html": "true",
            "data-render": "true",
            "data-pop": "totalInvestment"
          }),
          t[20] || (t[20] = a("div", { class: "d-none info-pop-totalInvestment" }, [
            a("p", null, [
              a("b", null, "Total Investment"),
              y(" is the combined amount of your "),
              a("b", null, "Initial Investment"),
              y(" (like the down payment, closing costs, and initial repairs) plus any "),
              a("b", null, "Cash Flow Shortfall"),
              y(" you may need to cover if your rental income doesn’t meet expenses. This sum represents all the money you’ll personally invest over the entire period you own the property. ")
            ])
          ], -1))
        ]),
        a("div", Qze, g(e.currency(e.totalInvestmentWithShortFall)), 1)
      ])
    ])) : (p(), Fe(o, {
      key: 0,
      speed: 2,
      width: 344,
      height: 239,
      class: "d-sm-none"
    }))
  ], 2);
}
const Zze = /* @__PURE__ */ Ae(Hze, [["render", Kze]]), Jze = me({
  name: "KpiHoldPeriod",
  components: {
    ContentLoader: Sa
  },
  emits: [
    "infoPopover"
  ],
  computed: {
    holdYear() {
      var e, t, s, n, r, i;
      return this.isHoldYearAuto ? this.isShortTerm ? (s = (t = this.calculatedResults) == null ? void 0 : t.shortTermSummary) == null ? void 0 : s.idealHoldYear : this.isPadSplit ? (r = (n = this.calculatedResults) == null ? void 0 : n.padSplitSummary) == null ? void 0 : r.idealHoldYear : (i = this.calculatedResults) == null ? void 0 : i.idealHoldYear : (e = this.calculatedResults) == null ? void 0 : e.hold;
    },
    mainStyle() {
      return {
        blur: !this.haveAccess,
        "kpi-holdperiod": !0,
        "d-flex": !0,
        "justify-content-center": !0,
        "align-items-start": !0,
        "h-100": !0,
        "text-center": !0
      };
    },
    haveAccess() {
      var e, t;
      return this.isMarketplace || ((t = (e = this.acl) == null ? void 0 : e.properties) == null ? void 0 : t.financialAnalysis) == !0;
    },
    yearOfHold() {
      var e, t, s, n, r, i, o, l, d;
      return this.isShortTerm ? (s = (t = (e = this.calculatedResults) == null ? void 0 : e.shortTerm) == null ? void 0 : t.find((c) => c.year == this.holdYear)) == null ? void 0 : s.fiscalYear : this.isPadSplit ? (i = (r = (n = this.calculatedResults) == null ? void 0 : n.padSplit) == null ? void 0 : r.find((c) => c.year == this.holdYear)) == null ? void 0 : i.fiscalYear : (d = (l = (o = this.calculatedResults) == null ? void 0 : o.normalized) == null ? void 0 : l.find((c) => c.year == this.holdYear)) == null ? void 0 : d.fiscalYear;
    },
    currentYear() {
      return Et;
    },
    ...q(Te, ["acl"]),
    ...q(qe, ["calculatedResults", "isShortTerm", "isMarketplace", "isHoldYearAuto", "isPadSplit"])
  },
  methods: {
    currency: Ze,
    infoPopover(e) {
      this.$emit("infoPopover", e);
    }
  }
}), $ze = { key: 1 }, _ze = { class: "fw-bold fs-5" }, eWe = { class: "fs-6 text-body-secondary" };
function tWe(e, t, s, n, r, i) {
  const o = pe("content-loader");
  return p(), h(A, null, [
    a("div", {
      class: z(e.mainStyle)
    }, [
      e.calculatedResults ? (p(), h("div", $ze, [
        t[2] || (t[2] = a("div", { class: "icon-shape bg-eclipse border-radius-md text-white d-flex justify-content-center align-items-center mb-3 mx-auto" }, [
          a("i", { class: "fa-light fa-lg fa-clock" })
        ], -1)),
        e.isHoldYearAuto ? (p(), h(A, { key: 0 }, [
          y(" Ideal ")
        ], 64)) : P("", !0),
        t[3] || (t[3] = y(" Hold Period")),
        a("i", {
          class: "fa-light fa-question-circle info-pop ms-2",
          onClick: t[0] || (t[0] = (...l) => e.infoPopover && e.infoPopover(...l)),
          "data-title": "Hold Period",
          "data-html": "true",
          "data-render": "true",
          "data-pop": "HoldPeriod"
        }),
        t[4] || (t[4] = a("div", { class: "d-none info-pop-HoldPeriod" }, [
          a("p", null, [
            a("b", null, "Hold Period"),
            y(' is the length of time you plan to own (or "hold") a property before selling. It starts on the purchase date and ends when you exit the investment. Planning the hold period helps you estimate potential returns, assess risks, and schedule maintenance or improvements within that timeframe. ')
          ])
        ], -1)),
        t[5] || (t[5] = a("br", null, null, -1)),
        a("span", _ze, g(e.holdYear) + " Years ", 1),
        e.yearOfHold ? (p(), h(A, { key: 1 }, [
          t[1] || (t[1] = a("br", null, null, -1)),
          a("small", eWe, "(" + g(e.currentYear + (e.holdYear - 1)) + ")", 1)
        ], 64)) : P("", !0)
      ])) : (p(), Fe(o, {
        key: 0,
        speed: 2,
        width: 344,
        height: 239,
        class: "d-sm-none"
      }))
    ], 2),
    t[6] || (t[6] = a("div", { class: "triangle" }, null, -1))
  ], 64);
}
const sWe = /* @__PURE__ */ Ae(Jze, [["render", tWe]]), aWe = me({
  name: "KpiNetGainOnInvestment",
  components: {
    ContentLoader: Sa,
    TotalInvestment: Hb,
    FlipInitialInvestment: Zu
  },
  emits: [
    "infoPopover"
  ],
  computed: {
    mainStyle() {
      return {
        blur: !this.haveAccess,
        "d-flex": this.haveAccess,
        "justify-content-center": this.haveAccess,
        "align-items-center": this.haveAccess,
        "h-100": this.haveAccess
      };
    },
    haveAccess() {
      return this.isMarketplace || this.hasFinancialAnalysisFeature == !0;
    },
    totalInvestmentWithShortFall() {
      var e, t, s, n, r, i, o, l;
      return this.isFlip ? (((t = (e = this.calculatedResults) == null ? void 0 : e.longTermSummary) == null ? void 0 : t.totalShortfall) ?? 0) + this.initialInvestment : this.isExistingInvestment && !this.isAtPurchase ? (((n = (s = this.calculatedResults) == null ? void 0 : s.longTermSummary) == null ? void 0 : n.totalShortfall) ?? 0) + ((i = (r = this.calculatedResults) == null ? void 0 : r.existingInvestmentSummary) == null ? void 0 : i.investmentBasis.total) : (((l = (o = this.calculatedResults) == null ? void 0 : o.longTermSummary) == null ? void 0 : l.totalShortfall) ?? 0) + this.initialInvestment;
    },
    initialInvestment() {
      var e, t;
      return this.isFlip ? this.propertyStore.flipTotalCashInvested : this.isExistingInvestment && !this.isAtPurchase ? (t = (e = this.calculatedResults) == null ? void 0 : e.existingInvestmentSummary) == null ? void 0 : t.investmentBasis.total : this.propertyStore.initialInvestment;
    },
    accumulationOfWealth() {
      return this.showAfterTax ? this.propertyStore.accumulationOfWealthAfterTax : this.propertyStore.accumulationOfWealth;
    },
    netGainOnInvestment() {
      return this.showAfterTax ? this.propertyStore.netGainOnInvestmentAfterTax : this.propertyStore.netGainOnInvestment;
    },
    ...at(qe),
    ...q(ct, ["showAfterTax"]),
    ...q(Te, ["acl", "hasFinancialAnalysisFeature"]),
    ...q(qe, ["calculatedResults", "isShortTerm", "isPadSplit", "isMarketplace", "isFlip", "flipTotalCashInvested", "isExistingInvestment", "isAtPurchase"])
  },
  methods: {
    currency: Ze,
    currencyStyle(e) {
      return {
        "text-success": e > 0,
        "text-danger": e < 0
      };
    },
    infoPopover(e) {
      this.$emit("infoPopover", e);
    }
  }
}), nWe = "data:image/jpeg;base64,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", rWe = {
  key: 0,
  class: "card card-locked shadow-sm h-100 d-flex align-items-center justify-content-center"
}, oWe = {
  key: 1,
  class: "flex-fill"
}, iWe = { class: "d-flex justify-content-between" }, lWe = { class: "fw-bold fs-5" }, dWe = { class: "d-flex justify-content-between" }, cWe = { class: "d-none info-pop-initialInvestment" }, uWe = { class: "fw-bold fs-5" }, pWe = { class: "d-flex justify-content-between border-top" }, hWe = { class: "fw-bold" }, mWe = { class: "fw-bold fs-5" };
function fWe(e, t, s, n, r, i) {
  const o = pe("content-loader"), l = pe("total-investment"), d = pe("flip-initial-investment");
  return e.haveAccess ? (p(), h("div", {
    key: 1,
    class: z(e.mainStyle)
  }, [
    e.calculatedResults ? (p(), h("div", oWe, [
      t[11] || (t[11] = a("div", { class: "icon-shape bg-eclipse border-radius-md text-white d-flex justify-content-center align-items-center mb-3 mx-auto ms-md-0" }, [
        a("i", { class: "fa-light fa-lg fa-hand-holding-usd" })
      ], -1)),
      a("div", iWe, [
        a("div", null, [
          t[4] || (t[4] = y(" Accumulation of Wealth ")),
          e.showAfterTax ? (p(), h(A, { key: 0 }, [
            y("(After-tax)")
          ], 64)) : P("", !0),
          a("i", {
            class: "fa-light fa-question-circle info-pop ms-2",
            onClick: t[0] || (t[0] = (...c) => e.infoPopover && e.infoPopover(...c)),
            "data-title": "Accumulation of Wealth",
            "data-html": "true",
            "data-render": "true",
            "data-pop": "accumulationOfWealth"
          }),
          t[5] || (t[5] = a("div", { class: "d-none info-pop-accumulationOfWealth" }, [
            a("p", null, [
              a("b", null, "Accumulation of Wealth"),
              y(" is the total of all cash flows (income minus expenses) during ownership plus the net proceeds when you sell. ")
            ])
          ], -1))
        ]),
        a("div", lWe, g(e.currency(e.accumulationOfWealth)), 1)
      ]),
      a("div", dWe, [
        a("div", null, [
          t[8] || (t[8] = y(" Less: Initial Investment")),
          a("i", {
            class: "fa-light fa-question-circle info-pop ms-2",
            onClick: t[1] || (t[1] = (...c) => e.infoPopover && e.infoPopover(...c)),
            "data-title": "Initial Investment",
            "data-html": "true",
            "data-render": "true",
            "data-pop": "initialInvestment"
          }),
          a("div", cWe, [
            t[6] || (t[6] = a("p", null, [
              a("b", null, "Initial Investment"),
              y(" is the total amount of money you put in upfront to purchase and prepare the property—like your down payment, closing costs, and any immediate repairs or improvements. This figure helps you see how much of your own cash is tied up before rental income (or other revenue) starts coming in. ")
            ], -1)),
            t[7] || (t[7] = a("p", null, " The initial investment for the property on this page is summarized in the table below: ", -1)),
            e.isFlip ? (p(), Fe(d, { key: 1 })) : (p(), Fe(l, { key: 0 }))
          ])
        ]),
        a("div", uWe, g(e.currency(-e.initialInvestment)), 1)
      ]),
      a("div", pWe, [
        a("div", hWe, [
          t[9] || (t[9] = y(" Net Gain on Investment ")),
          e.showAfterTax ? (p(), h(A, { key: 0 }, [
            y("(After-tax)")
          ], 64)) : P("", !0),
          a("i", {
            class: "fa-light fa-question-circle info-pop ms-2",
            onClick: t[2] || (t[2] = (...c) => e.infoPopover && e.infoPopover(...c)),
            "data-title": "Net Gain on Investment",
            "data-html": "true",
            "data-render": "true",
            "data-pop": "netGainOnInvestment"
          }),
          t[10] || (t[10] = a("div", { class: "d-none info-pop-netGainOnInvestment" }, [
            a("p", null, [
              a("b", null, "Net Gain on Investment"),
              y(" is how much you actually profit after subtracting your "),
              a("b", null, "Initial Investment"),
              y(" from the "),
              a("b", null, "Accumulation of Wealth"),
              y(". ")
            ])
          ], -1))
        ]),
        a("div", mWe, [
          a("span", {
            class: z(e.currencyStyle(e.accumulationOfWealth - e.initialInvestment))
          }, g(e.currency(e.accumulationOfWealth - e.initialInvestment)), 3)
        ])
      ])
    ])) : (p(), Fe(o, {
      key: 0,
      speed: 2,
      width: 344,
      height: 239,
      class: "d-sm-none"
    }))
  ], 2)) : (p(), h("div", rWe, t[3] || (t[3] = [
    Bt('<div class="d-flex justify-content-between align-items-center flex-row flex-md-column flex-lg-row"><div class="text-center"><img src="' + nWe + '" alt="KPIs" title="KPIs" height="285" width="400" class="img-fluid" loading="lazy"></div><div class="text-center text-md-start d-flex flex-column justify-content-center align-items-center align-items-lg-start p-4"><p class="fw-bold fs-5"> Create an account<br class="d-none d-lg-block"> to view KPIs! </p><a href="/signup" class="btn btn-lava">Activate KPIs!</a><br> Net Gain on Investment </div></div>', 1)
  ])));
}
const gWe = /* @__PURE__ */ Ae(aWe, [["render", fWe]]), vWe = me({
  name: "MonthlyOwnershipCosts",
  components: {
    ContentLoader: Sa
  },
  computed: {
    calculatingClasses() {
      return {
        card: !0,
        "flex-fill": !0,
        "card-monthly-ownership-costs": !0,
        "shadow-sm": !0,
        "card-proforma": !0,
        calculating: this.calculating
      };
    },
    proposedCost() {
      var e, t, s, n;
      return this.isExistingInvestment ? (e = this.purchaseFacts) == null ? void 0 : e.purchasePrice : (t = this.calculatedResults) != null && t.purchasePrice ? this.calculatedResults.purchasePrice : (n = (s = this.property) == null ? void 0 : s.financial) == null ? void 0 : n.propertyValue;
    },
    calcYear() {
      return Xu >= 11 ? Et + 1 : Et;
    },
    totalEstimatedMonthlyCost() {
      if (this.estimatedPropertyInsurance && this.estimatedPropertyTax && this.mortgagePayment >= 0)
        return this.estimatedPropertyInsurance + this.estimatedPropertyTax + this.mortgagePayment;
    },
    ...q(qe, ["calculating", "property", "calcParams", "isExistingInvestment", "purchaseFacts", "calculatedResults", "isShortTerm", "isPadSplit", "mortgagePayment", "estimatedPropertyTax", "estimatedPropertyInsurance"])
  },
  methods: {
    currency: Ze
  }
}), yWe = { class: "card-body p-0 overflow-hidden position-relative" }, bWe = {
  key: 0,
  class: "calculating-animation position-absolute top-50 start-50 translate-middle text-center"
}, AWe = { class: "table-data" }, wWe = { class: "table table-sm" }, CWe = { class: "text-end" }, SWe = { class: "text-end" }, PWe = { class: "text-end" }, kWe = { class: "table-total" }, EWe = { class: "fw-bold text-end" };
function IWe(e, t, s, n, r, i) {
  return p(), h("div", {
    class: z(e.calculatingClasses)
  }, [
    t[5] || (t[5] = a("div", { class: "card-header bg-eclipse text-white rounded rounded-bottom-0 fw-bold text-center text-sm-start" }, " MONTHLY OWNERSHIP COSTS ", -1)),
    a("div", yWe, [
      e.calculating ? (p(), h("div", bWe, t[0] || (t[0] = [
        a("i", { class: "fa-duotone fa-solid fa-compass fa-spin fa-lg text-eclipse" }, null, -1),
        a("br", null, null, -1),
        a("small", null, "Calculating", -1)
      ]))) : P("", !0),
      a("div", AWe, [
        a("table", wWe, [
          a("tbody", null, [
            a("tr", null, [
              t[1] || (t[1] = a("td", null, " Mortgage Payment (P&I) ", -1)),
              a("td", CWe, g(e.currency(e.mortgagePayment)), 1)
            ]),
            a("tr", null, [
              t[2] || (t[2] = a("td", null, " Property Tax ", -1)),
              a("td", SWe, g(e.currency(e.estimatedPropertyTax)), 1)
            ]),
            a("tr", null, [
              t[3] || (t[3] = a("td", null, " Property Insurance ", -1)),
              a("td", PWe, g(e.currency(e.estimatedPropertyInsurance)), 1)
            ])
          ]),
          a("tfoot", null, [
            a("tr", kWe, [
              t[4] || (t[4] = a("th", { class: "fw-bold" }, " Total Monthly Costs ", -1)),
              a("th", EWe, g(e.currency(e.totalEstimatedMonthlyCost)), 1)
            ])
          ])
        ])
      ])
    ])
  ], 2);
}
const TWe = /* @__PURE__ */ Ae(vWe, [["render", IWe]]), OWe = me({
  name: "KpiMonthlyCashFlow",
  components: {
    ContentLoader: Sa
  },
  computed: {
    haveAccess() {
      var e, t;
      return this.isMarketplace || ((t = (e = this.acl) == null ? void 0 : e.properties) == null ? void 0 : t.financialAnalysis) == !0;
    },
    calculatingClasses() {
      return {
        calculating: this.calculating,
        card: !0,
        "card-monthly-cash-flow": !0,
        "flex-fill": !0,
        "shadow-sm": !0,
        "guard-wrapper": !this.haveAccess
      };
    },
    mainStyle() {
      return {
        "guard-data": !this.haveAccess
      };
    },
    raw() {
      var e, t;
      return ((t = (e = this.calculatedResults) == null ? void 0 : e.raw) == null ? void 0 : t.find((s) => s.year == this.firstProformaYear)) ?? {};
    },
    monthlyCashFlow() {
      var e, t, s, n, r, i, o, l, d;
      return this.isShortTerm ? (s = (t = (e = this.calculatedResults) == null ? void 0 : e.shortTerm) == null ? void 0 : t.find((c) => c.year == this.firstProformaYear)) == null ? void 0 : s.monthlyCashFlow : this.isPadSplit ? (i = (r = (n = this.calculatedResults) == null ? void 0 : n.padSplit) == null ? void 0 : r.find((c) => c.year == this.firstProformaYear)) == null ? void 0 : i.monthlyCashFlow : (d = (l = (o = this.calculatedResults) == null ? void 0 : o.normalized) == null ? void 0 : l.find((c) => c.year == this.firstProformaYear)) == null ? void 0 : d.monthlyCashFlow;
    },
    monthlyCashFlowAfterTax() {
      var e, t, s, n, r, i, o, l, d;
      return this.isShortTerm ? (s = (t = (e = this.calculatedResults) == null ? void 0 : e.shortTerm) == null ? void 0 : t.find((c) => c.year == this.firstProformaYear)) == null ? void 0 : s.monthlyCashFlowAfterTax : this.isPadSplit ? (i = (r = (n = this.calculatedResults) == null ? void 0 : n.padSplit) == null ? void 0 : r.find((c) => c.year == this.firstProformaYear)) == null ? void 0 : i.monthlyCashFlowAfterTax : (d = (l = (o = this.calculatedResults) == null ? void 0 : o.normalized) == null ? void 0 : l.find((c) => c.year == this.firstProformaYear)) == null ? void 0 : d.monthlyCashFlowAfterTax;
    },
    ...q(Te, ["acl"]),
    ...q(qe, ["calculatedResults", "isShortTerm", "isPadSplit", "isMarketplace", "firstProformaYear", "calculating"])
  },
  methods: {
    currency: Ze,
    currencyStyle(e) {
      return {
        "fw-bold": !0,
        "fs-5": !0,
        "text-success": e > 0,
        "text-danger": e < 0
      };
    }
  }
}), RWe = { class: "card-body p-0 position-relative overflow-hidden" }, LWe = {
  key: 0,
  class: "calculating-animation position-absolute top-50 start-50 translate-middle text-center"
}, BWe = {
  key: 1,
  class: "position-absolute top-0 bottom-0 start-0 end-0 d-flex justify-content-center align-items-center flex-row gap-1 text-center z-10"
};
function MWe(e, t, s, n, r, i) {
  return p(), h("div", {
    class: z(e.calculatingClasses)
  }, [
    N(ks, {
      name: "slide-fade",
      mode: "out-in"
    }, {
      default: ve(() => [
        a("div", null, [
          a("div", RWe, [
            e.calculating ? (p(), h("div", LWe, t[0] || (t[0] = [
              a("i", { class: "fa-duotone fa-solid fa-compass fa-spin fa-lg text-eclipse" }, null, -1),
              a("br", null, null, -1),
              a("small", null, "Calculating", -1)
            ]))) : P("", !0),
            e.haveAccess ? P("", !0) : (p(), h("div", BWe, t[1] || (t[1] = [
              a("span", { class: "fa-stack me-2" }, [
                a("i", {
                  class: "fa-solid fa-circle fa-stack-2x text-eclipse",
                  "aria-hidden": "true"
                }),
                a("i", {
                  class: "fa-solid fa-user-plus fa-stack-1x fa-inverse",
                  "aria-hidden": "true"
                })
              ], -1),
              a("div", null, "Subscribe to view Investment Metrics", -1)
            ]))),
            a("div", {
              class: z(["p-3 kpi-data d-flex flex-row", e.mainStyle])
            }, [
              t[5] || (t[5] = a("div", { class: "icon-shape bg-eclipse border-radius-md text-white d-flex justify-content-center align-items-center me-3" }, [
                a("i", { class: "fa-light fa-lg fa-envelope-open-dollar" })
              ], -1)),
              a("div", null, [
                y(g(e.raw.fiscalYear) + " Monthly Cash Flow", 1),
                t[2] || (t[2] = a("br", null, null, -1)),
                t[3] || (t[3] = y(" Before Tax: ")),
                a("b", {
                  class: z(e.currencyStyle(e.monthlyCashFlow))
                }, g(e.currency(e.monthlyCashFlow)), 3),
                t[4] || (t[4] = y("  After Tax: ")),
                a("b", {
                  class: z(e.currencyStyle(e.monthlyCashFlowAfterTax))
                }, g(e.currency(e.monthlyCashFlowAfterTax)), 3)
              ])
            ], 2)
          ])
        ])
      ]),
      _: 1
    })
  ], 2);
}
const xWe = /* @__PURE__ */ Ae(OWe, [["render", MWe]]), FWe = me({
  name: "UnitMix",
  components: {
    ContentLoader: Sa
  },
  computed: {
    ...q(qe, ["propertyUnits", "calcParams", "property", "unitsTotalRentalRate"])
  },
  methods: {
    number: Ve,
    currency: Ze
  }
}), VWe = { class: "card shadow-sm h-100" }, DWe = { class: "unit-data-commercial-scroll position-relative" }, NWe = { class: "unit-data-body-lg" }, jWe = { class: "table mb-0" }, HWe = { key: 0 }, UWe = { class: "w-16 text-center" }, zWe = { class: "w-58 text-start" }, WWe = { class: "d-block text-truncate" }, GWe = { class: "w-25 text-end" }, YWe = { class: "unit-data-footer position-absolute bg-white rounded-2 rounded-top-0 bottom-0 end-0 border-top fw-bold w-100 container-fluid py-1" }, XWe = { class: "row" }, qWe = { class: "col-5 col-lg-6 text-end pe-4 col-xl-6 col-xxl-5" };
function QWe(e, t, s, n, r, i) {
  return p(), h("div", VWe, [
    t[2] || (t[2] = a("div", { class: "card-header bg-alice fw-bold border-0 text-uppercase text-center text-sm-start" }, " Unit Mix ", -1)),
    a("div", DWe, [
      t[1] || (t[1] = Bt('<div class="unit-data-header position-absolute bg-white top-0 end-0 border-bottom fw-bold text-small w-100 container-fluid py-1"><div class="row"><div class="col-2 text-center"><span class="d-none d-xxl-block">Qty</span><span class="d-xxl-none">#</span></div><div class="col-7">Name</div><div class="col-3 text-end">Rate</div></div></div>', 1)),
      a("div", NWe, [
        a("table", jWe, [
          e.propertyUnits ? (p(), h("tbody", HWe, [
            (p(!0), h(A, null, D(e.propertyUnits, (o) => (p(), h("tr", null, [
              a("td", UWe, g(e.number(o.quantity)), 1),
              a("td", zWe, [
                a("span", WWe, g(o.name), 1)
              ]),
              a("td", GWe, g(e.currency(o.rentalRate)), 1)
            ]))), 256))
          ])) : P("", !0)
        ])
      ]),
      a("div", YWe, [
        a("div", XWe, [
          t[0] || (t[0] = a("div", { class: "col-7 col-lg-6 col-xl-6 col-xxl-7" }, " Total Monthly Rent: ", -1)),
          a("div", qWe, g(e.currency(e.unitsTotalRentalRate)), 1)
        ])
      ])
    ])
  ]);
}
const KWe = /* @__PURE__ */ Ae(FWe, [["render", QWe]]);
var ZWe = { value: () => {
} };
function K5() {
  for (var e = 0, t = arguments.length, s = {}, n; e < t; ++e) {
    if (!(n = arguments[e] + "") || n in s || /[\s.]/.test(n)) throw new Error("illegal type: " + n);
    s[n] = [];
  }
  return new Nh(s);
}
function Nh(e) {
  this._ = e;
}
function JWe(e, t) {
  return e.trim().split(/^|\s+/).map(function(s) {
    var n = "", r = s.indexOf(".");
    if (r >= 0 && (n = s.slice(r + 1), s = s.slice(0, r)), s && !t.hasOwnProperty(s)) throw new Error("unknown type: " + s);
    return { type: s, name: n };
  });
}
Nh.prototype = K5.prototype = {
  constructor: Nh,
  on: function(e, t) {
    var s = this._, n = JWe(e + "", s), r, i = -1, o = n.length;
    if (arguments.length < 2) {
      for (; ++i < o; ) if ((r = (e = n[i]).type) && (r = $We(s[r], e.name))) return r;
      return;
    }
    if (t != null && typeof t != "function") throw new Error("invalid callback: " + t);
    for (; ++i < o; )
      if (r = (e = n[i]).type) s[r] = YC(s[r], e.name, t);
      else if (t == null) for (r in s) s[r] = YC(s[r], e.name, null);
    return this;
  },
  copy: function() {
    var e = {}, t = this._;
    for (var s in t) e[s] = t[s].slice();
    return new Nh(e);
  },
  call: function(e, t) {
    if ((r = arguments.length - 2) > 0) for (var s = new Array(r), n = 0, r, i; n < r; ++n) s[n] = arguments[n + 2];
    if (!this._.hasOwnProperty(e)) throw new Error("unknown type: " + e);
    for (i = this._[e], n = 0, r = i.length; n < r; ++n) i[n].value.apply(t, s);
  },
  apply: function(e, t, s) {
    if (!this._.hasOwnProperty(e)) throw new Error("unknown type: " + e);
    for (var n = this._[e], r = 0, i = n.length; r < i; ++r) n[r].value.apply(t, s);
  }
};
function $We(e, t) {
  for (var s = 0, n = e.length, r; s < n; ++s)
    if ((r = e[s]).name === t)
      return r.value;
}
function YC(e, t, s) {
  for (var n = 0, r = e.length; n < r; ++n)
    if (e[n].name === t) {
      e[n] = ZWe, e = e.slice(0, n).concat(e.slice(n + 1));
      break;
    }
  return s != null && e.push({ name: t, value: s }), e;
}
var Ny = "http://www.w3.org/1999/xhtml";
const XC = {
  svg: "http://www.w3.org/2000/svg",
  xhtml: Ny,
  xlink: "http://www.w3.org/1999/xlink",
  xml: "http://www.w3.org/XML/1998/namespace",
  xmlns: "http://www.w3.org/2000/xmlns/"
};
function Sf(e) {
  var t = e += "", s = t.indexOf(":");
  return s >= 0 && (t = e.slice(0, s)) !== "xmlns" && (e = e.slice(s + 1)), XC.hasOwnProperty(t) ? { space: XC[t], local: e } : e;
}
function _We(e) {
  return function() {
    var t = this.ownerDocument, s = this.namespaceURI;
    return s === Ny && t.documentElement.namespaceURI === Ny ? t.createElement(e) : t.createElementNS(s, e);
  };
}
function eGe(e) {
  return function() {
    return this.ownerDocument.createElementNS(e.space, e.local);
  };
}
function Z5(e) {
  var t = Sf(e);
  return (t.local ? eGe : _We)(t);
}
function tGe() {
}
function Ub(e) {
  return e == null ? tGe : function() {
    return this.querySelector(e);
  };
}
function sGe(e) {
  typeof e != "function" && (e = Ub(e));
  for (var t = this._groups, s = t.length, n = new Array(s), r = 0; r < s; ++r)
    for (var i = t[r], o = i.length, l = n[r] = new Array(o), d, c, u = 0; u < o; ++u)
      (d = i[u]) && (c = e.call(d, d.__data__, u, i)) && ("__data__" in d && (c.__data__ = d.__data__), l[u] = c);
  return new zn(n, this._parents);
}
function aGe(e) {
  return e == null ? [] : Array.isArray(e) ? e : Array.from(e);
}
function nGe() {
  return [];
}
function J5(e) {
  return e == null ? nGe : function() {
    return this.querySelectorAll(e);
  };
}
function rGe(e) {
  return function() {
    return aGe(e.apply(this, arguments));
  };
}
function oGe(e) {
  typeof e == "function" ? e = rGe(e) : e = J5(e);
  for (var t = this._groups, s = t.length, n = [], r = [], i = 0; i < s; ++i)
    for (var o = t[i], l = o.length, d, c = 0; c < l; ++c)
      (d = o[c]) && (n.push(e.call(d, d.__data__, c, o)), r.push(d));
  return new zn(n, r);
}
function $5(e) {
  return function() {
    return this.matches(e);
  };
}
function _5(e) {
  return function(t) {
    return t.matches(e);
  };
}
var iGe = Array.prototype.find;
function lGe(e) {
  return function() {
    return iGe.call(this.children, e);
  };
}
function dGe() {
  return this.firstElementChild;
}
function cGe(e) {
  return this.select(e == null ? dGe : lGe(typeof e == "function" ? e : _5(e)));
}
var uGe = Array.prototype.filter;
function pGe() {
  return Array.from(this.children);
}
function hGe(e) {
  return function() {
    return uGe.call(this.children, e);
  };
}
function mGe(e) {
  return this.selectAll(e == null ? pGe : hGe(typeof e == "function" ? e : _5(e)));
}
function fGe(e) {
  typeof e != "function" && (e = $5(e));
  for (var t = this._groups, s = t.length, n = new Array(s), r = 0; r < s; ++r)
    for (var i = t[r], o = i.length, l = n[r] = [], d, c = 0; c < o; ++c)
      (d = i[c]) && e.call(d, d.__data__, c, i) && l.push(d);
  return new zn(n, this._parents);
}
function eE(e) {
  return new Array(e.length);
}
function gGe() {
  return new zn(this._enter || this._groups.map(eE), this._parents);
}
function Pm(e, t) {
  this.ownerDocument = e.ownerDocument, this.namespaceURI = e.namespaceURI, this._next = null, this._parent = e, this.__data__ = t;
}
Pm.prototype = {
  constructor: Pm,
  appendChild: function(e) {
    return this._parent.insertBefore(e, this._next);
  },
  insertBefore: function(e, t) {
    return this._parent.insertBefore(e, t);
  },
  querySelector: function(e) {
    return this._parent.querySelector(e);
  },
  querySelectorAll: function(e) {
    return this._parent.querySelectorAll(e);
  }
};
function vGe(e) {
  return function() {
    return e;
  };
}
function yGe(e, t, s, n, r, i) {
  for (var o = 0, l, d = t.length, c = i.length; o < c; ++o)
    (l = t[o]) ? (l.__data__ = i[o], n[o] = l) : s[o] = new Pm(e, i[o]);
  for (; o < d; ++o)
    (l = t[o]) && (r[o] = l);
}
function bGe(e, t, s, n, r, i, o) {
  var l, d, c = /* @__PURE__ */ new Map(), u = t.length, m = i.length, f = new Array(u), v;
  for (l = 0; l < u; ++l)
    (d = t[l]) && (f[l] = v = o.call(d, d.__data__, l, t) + "", c.has(v) ? r[l] = d : c.set(v, d));
  for (l = 0; l < m; ++l)
    v = o.call(e, i[l], l, i) + "", (d = c.get(v)) ? (n[l] = d, d.__data__ = i[l], c.delete(v)) : s[l] = new Pm(e, i[l]);
  for (l = 0; l < u; ++l)
    (d = t[l]) && c.get(f[l]) === d && (r[l] = d);
}
function AGe(e) {
  return e.__data__;
}
function wGe(e, t) {
  if (!arguments.length) return Array.from(this, AGe);
  var s = t ? bGe : yGe, n = this._parents, r = this._groups;
  typeof e != "function" && (e = vGe(e));
  for (var i = r.length, o = new Array(i), l = new Array(i), d = new Array(i), c = 0; c < i; ++c) {
    var u = n[c], m = r[c], f = m.length, v = CGe(e.call(u, u && u.__data__, c, n)), b = v.length, w = l[c] = new Array(b), S = o[c] = new Array(b), I = d[c] = new Array(f);
    s(u, m, w, S, I, v, t);
    for (var T = 0, x = 0, k, C; T < b; ++T)
      if (k = w[T]) {
        for (T >= x && (x = T + 1); !(C = S[x]) && ++x < b; ) ;
        k._next = C || null;
      }
  }
  return o = new zn(o, n), o._enter = l, o._exit = d, o;
}
function CGe(e) {
  return typeof e == "object" && "length" in e ? e : Array.from(e);
}
function SGe() {
  return new zn(this._exit || this._groups.map(eE), this._parents);
}
function PGe(e, t, s) {
  var n = this.enter(), r = this, i = this.exit();
  return typeof e == "function" ? (n = e(n), n && (n = n.selection())) : n = n.append(e + ""), t != null && (r = t(r), r && (r = r.selection())), s == null ? i.remove() : s(i), n && r ? n.merge(r).order() : r;
}
function kGe(e) {
  for (var t = e.selection ? e.selection() : e, s = this._groups, n = t._groups, r = s.length, i = n.length, o = Math.min(r, i), l = new Array(r), d = 0; d < o; ++d)
    for (var c = s[d], u = n[d], m = c.length, f = l[d] = new Array(m), v, b = 0; b < m; ++b)
      (v = c[b] || u[b]) && (f[b] = v);
  for (; d < r; ++d)
    l[d] = s[d];
  return new zn(l, this._parents);
}
function EGe() {
  for (var e = this._groups, t = -1, s = e.length; ++t < s; )
    for (var n = e[t], r = n.length - 1, i = n[r], o; --r >= 0; )
      (o = n[r]) && (i && o.compareDocumentPosition(i) ^ 4 && i.parentNode.insertBefore(o, i), i = o);
  return this;
}
function IGe(e) {
  e || (e = TGe);
  function t(m, f) {
    return m && f ? e(m.__data__, f.__data__) : !m - !f;
  }
  for (var s = this._groups, n = s.length, r = new Array(n), i = 0; i < n; ++i) {
    for (var o = s[i], l = o.length, d = r[i] = new Array(l), c, u = 0; u < l; ++u)
      (c = o[u]) && (d[u] = c);
    d.sort(t);
  }
  return new zn(r, this._parents).order();
}
function TGe(e, t) {
  return e < t ? -1 : e > t ? 1 : e >= t ? 0 : NaN;
}
function OGe() {
  var e = arguments[0];
  return arguments[0] = this, e.apply(null, arguments), this;
}
function RGe() {
  return Array.from(this);
}
function LGe() {
  for (var e = this._groups, t = 0, s = e.length; t < s; ++t)
    for (var n = e[t], r = 0, i = n.length; r < i; ++r) {
      var o = n[r];
      if (o) return o;
    }
  return null;
}
function BGe() {
  let e = 0;
  for (const t of this) ++e;
  return e;
}
function MGe() {
  return !this.node();
}
function xGe(e) {
  for (var t = this._groups, s = 0, n = t.length; s < n; ++s)
    for (var r = t[s], i = 0, o = r.length, l; i < o; ++i)
      (l = r[i]) && e.call(l, l.__data__, i, r);
  return this;
}
function FGe(e) {
  return function() {
    this.removeAttribute(e);
  };
}
function VGe(e) {
  return function() {
    this.removeAttributeNS(e.space, e.local);
  };
}
function DGe(e, t) {
  return function() {
    this.setAttribute(e, t);
  };
}
function NGe(e, t) {
  return function() {
    this.setAttributeNS(e.space, e.local, t);
  };
}
function jGe(e, t) {
  return function() {
    var s = t.apply(this, arguments);
    s == null ? this.removeAttribute(e) : this.setAttribute(e, s);
  };
}
function HGe(e, t) {
  return function() {
    var s = t.apply(this, arguments);
    s == null ? this.removeAttributeNS(e.space, e.local) : this.setAttributeNS(e.space, e.local, s);
  };
}
function UGe(e, t) {
  var s = Sf(e);
  if (arguments.length < 2) {
    var n = this.node();
    return s.local ? n.getAttributeNS(s.space, s.local) : n.getAttribute(s);
  }
  return this.each((t == null ? s.local ? VGe : FGe : typeof t == "function" ? s.local ? HGe : jGe : s.local ? NGe : DGe)(s, t));
}
function tE(e) {
  return e.ownerDocument && e.ownerDocument.defaultView || e.document && e || e.defaultView;
}
function zGe(e) {
  return function() {
    this.style.removeProperty(e);
  };
}
function WGe(e, t, s) {
  return function() {
    this.style.setProperty(e, t, s);
  };
}
function GGe(e, t, s) {
  return function() {
    var n = t.apply(this, arguments);
    n == null ? this.style.removeProperty(e) : this.style.setProperty(e, n, s);
  };
}
function YGe(e, t, s) {
  return arguments.length > 1 ? this.each((t == null ? zGe : typeof t == "function" ? GGe : WGe)(e, t, s ?? "")) : Dd(this.node(), e);
}
function Dd(e, t) {
  return e.style.getPropertyValue(t) || tE(e).getComputedStyle(e, null).getPropertyValue(t);
}
function XGe(e) {
  return function() {
    delete this[e];
  };
}
function qGe(e, t) {
  return function() {
    this[e] = t;
  };
}
function QGe(e, t) {
  return function() {
    var s = t.apply(this, arguments);
    s == null ? delete this[e] : this[e] = s;
  };
}
function KGe(e, t) {
  return arguments.length > 1 ? this.each((t == null ? XGe : typeof t == "function" ? QGe : qGe)(e, t)) : this.node()[e];
}
function sE(e) {
  return e.trim().split(/^|\s+/);
}
function zb(e) {
  return e.classList || new aE(e);
}
function aE(e) {
  this._node = e, this._names = sE(e.getAttribute("class") || "");
}
aE.prototype = {
  add: function(e) {
    var t = this._names.indexOf(e);
    t < 0 && (this._names.push(e), this._node.setAttribute("class", this._names.join(" ")));
  },
  remove: function(e) {
    var t = this._names.indexOf(e);
    t >= 0 && (this._names.splice(t, 1), this._node.setAttribute("class", this._names.join(" ")));
  },
  contains: function(e) {
    return this._names.indexOf(e) >= 0;
  }
};
function nE(e, t) {
  for (var s = zb(e), n = -1, r = t.length; ++n < r; ) s.add(t[n]);
}
function rE(e, t) {
  for (var s = zb(e), n = -1, r = t.length; ++n < r; ) s.remove(t[n]);
}
function ZGe(e) {
  return function() {
    nE(this, e);
  };
}
function JGe(e) {
  return function() {
    rE(this, e);
  };
}
function $Ge(e, t) {
  return function() {
    (t.apply(this, arguments) ? nE : rE)(this, e);
  };
}
function _Ge(e, t) {
  var s = sE(e + "");
  if (arguments.length < 2) {
    for (var n = zb(this.node()), r = -1, i = s.length; ++r < i; ) if (!n.contains(s[r])) return !1;
    return !0;
  }
  return this.each((typeof t == "function" ? $Ge : t ? ZGe : JGe)(s, t));
}
function eYe() {
  this.textContent = "";
}
function tYe(e) {
  return function() {
    this.textContent = e;
  };
}
function sYe(e) {
  return function() {
    var t = e.apply(this, arguments);
    this.textContent = t ?? "";
  };
}
function aYe(e) {
  return arguments.length ? this.each(e == null ? eYe : (typeof e == "function" ? sYe : tYe)(e)) : this.node().textContent;
}
function nYe() {
  this.innerHTML = "";
}
function rYe(e) {
  return function() {
    this.innerHTML = e;
  };
}
function oYe(e) {
  return function() {
    var t = e.apply(this, arguments);
    this.innerHTML = t ?? "";
  };
}
function iYe(e) {
  return arguments.length ? this.each(e == null ? nYe : (typeof e == "function" ? oYe : rYe)(e)) : this.node().innerHTML;
}
function lYe() {
  this.nextSibling && this.parentNode.appendChild(this);
}
function dYe() {
  return this.each(lYe);
}
function cYe() {
  this.previousSibling && this.parentNode.insertBefore(this, this.parentNode.firstChild);
}
function uYe() {
  return this.each(cYe);
}
function pYe(e) {
  var t = typeof e == "function" ? e : Z5(e);
  return this.select(function() {
    return this.appendChild(t.apply(this, arguments));
  });
}
function hYe() {
  return null;
}
function mYe(e, t) {
  var s = typeof e == "function" ? e : Z5(e), n = t == null ? hYe : typeof t == "function" ? t : Ub(t);
  return this.select(function() {
    return this.insertBefore(s.apply(this, arguments), n.apply(this, arguments) || null);
  });
}
function fYe() {
  var e = this.parentNode;
  e && e.removeChild(this);
}
function gYe() {
  return this.each(fYe);
}
function vYe() {
  var e = this.cloneNode(!1), t = this.parentNode;
  return t ? t.insertBefore(e, this.nextSibling) : e;
}
function yYe() {
  var e = this.cloneNode(!0), t = this.parentNode;
  return t ? t.insertBefore(e, this.nextSibling) : e;
}
function bYe(e) {
  return this.select(e ? yYe : vYe);
}
function AYe(e) {
  return arguments.length ? this.property("__data__", e) : this.node().__data__;
}
function wYe(e) {
  return function(t) {
    e.call(this, t, this.__data__);
  };
}
function CYe(e) {
  return e.trim().split(/^|\s+/).map(function(t) {
    var s = "", n = t.indexOf(".");
    return n >= 0 && (s = t.slice(n + 1), t = t.slice(0, n)), { type: t, name: s };
  });
}
function SYe(e) {
  return function() {
    var t = this.__on;
    if (t) {
      for (var s = 0, n = -1, r = t.length, i; s < r; ++s)
        i = t[s], (!e.type || i.type === e.type) && i.name === e.name ? this.removeEventListener(i.type, i.listener, i.options) : t[++n] = i;
      ++n ? t.length = n : delete this.__on;
    }
  };
}
function PYe(e, t, s) {
  return function() {
    var n = this.__on, r, i = wYe(t);
    if (n) {
      for (var o = 0, l = n.length; o < l; ++o)
        if ((r = n[o]).type === e.type && r.name === e.name) {
          this.removeEventListener(r.type, r.listener, r.options), this.addEventListener(r.type, r.listener = i, r.options = s), r.value = t;
          return;
        }
    }
    this.addEventListener(e.type, i, s), r = { type: e.type, name: e.name, value: t, listener: i, options: s }, n ? n.push(r) : this.__on = [r];
  };
}
function kYe(e, t, s) {
  var n = CYe(e + ""), r, i = n.length, o;
  if (arguments.length < 2) {
    var l = this.node().__on;
    if (l) {
      for (var d = 0, c = l.length, u; d < c; ++d)
        for (r = 0, u = l[d]; r < i; ++r)
          if ((o = n[r]).type === u.type && o.name === u.name)
            return u.value;
    }
    return;
  }
  for (l = t ? PYe : SYe, r = 0; r < i; ++r) this.each(l(n[r], t, s));
  return this;
}
function oE(e, t, s) {
  var n = tE(e), r = n.CustomEvent;
  typeof r == "function" ? r = new r(t, s) : (r = n.document.createEvent("Event"), s ? (r.initEvent(t, s.bubbles, s.cancelable), r.detail = s.detail) : r.initEvent(t, !1, !1)), e.dispatchEvent(r);
}
function EYe(e, t) {
  return function() {
    return oE(this, e, t);
  };
}
function IYe(e, t) {
  return function() {
    return oE(this, e, t.apply(this, arguments));
  };
}
function TYe(e, t) {
  return this.each((typeof t == "function" ? IYe : EYe)(e, t));
}
function* OYe() {
  for (var e = this._groups, t = 0, s = e.length; t < s; ++t)
    for (var n = e[t], r = 0, i = n.length, o; r < i; ++r)
      (o = n[r]) && (yield o);
}
var iE = [null];
function zn(e, t) {
  this._groups = e, this._parents = t;
}
function Ju() {
  return new zn([[document.documentElement]], iE);
}
function RYe() {
  return this;
}
zn.prototype = Ju.prototype = {
  constructor: zn,
  select: sGe,
  selectAll: oGe,
  selectChild: cGe,
  selectChildren: mGe,
  filter: fGe,
  data: wGe,
  enter: gGe,
  exit: SGe,
  join: PGe,
  merge: kGe,
  selection: RYe,
  order: EGe,
  sort: IGe,
  call: OGe,
  nodes: RGe,
  node: LGe,
  size: BGe,
  empty: MGe,
  each: xGe,
  attr: UGe,
  style: YGe,
  property: KGe,
  classed: _Ge,
  text: aYe,
  html: iYe,
  raise: dYe,
  lower: uYe,
  append: pYe,
  insert: mYe,
  remove: gYe,
  clone: bYe,
  datum: AYe,
  on: kYe,
  dispatch: TYe,
  [Symbol.iterator]: OYe
};
function qC(e) {
  return typeof e == "string" ? new zn([[document.querySelector(e)]], [document.documentElement]) : new zn([[e]], iE);
}
function Wb(e, t, s) {
  e.prototype = t.prototype = s, s.constructor = e;
}
function lE(e, t) {
  var s = Object.create(e.prototype);
  for (var n in t) s[n] = t[n];
  return s;
}
function $u() {
}
var Eu = 0.7, km = 1 / Eu, dd = "\\s*([+-]?\\d+)\\s*", Iu = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", zr = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", LYe = /^#([0-9a-f]{3,8})$/, BYe = new RegExp(`^rgb\\(${dd},${dd},${dd}\\)$`), MYe = new RegExp(`^rgb\\(${zr},${zr},${zr}\\)$`), xYe = new RegExp(`^rgba\\(${dd},${dd},${dd},${Iu}\\)$`), FYe = new RegExp(`^rgba\\(${zr},${zr},${zr},${Iu}\\)$`), VYe = new RegExp(`^hsl\\(${Iu},${zr},${zr}\\)$`), DYe = new RegExp(`^hsla\\(${Iu},${zr},${zr},${Iu}\\)$`), QC = {
  aliceblue: 15792383,
  antiquewhite: 16444375,
  aqua: 65535,
  aquamarine: 8388564,
  azure: 15794175,
  beige: 16119260,
  bisque: 16770244,
  black: 0,
  blanchedalmond: 16772045,
  blue: 255,
  blueviolet: 9055202,
  brown: 10824234,
  burlywood: 14596231,
  cadetblue: 6266528,
  chartreuse: 8388352,
  chocolate: 13789470,
  coral: 16744272,
  cornflowerblue: 6591981,
  cornsilk: 16775388,
  crimson: 14423100,
  cyan: 65535,
  darkblue: 139,
  darkcyan: 35723,
  darkgoldenrod: 12092939,
  darkgray: 11119017,
  darkgreen: 25600,
  darkgrey: 11119017,
  darkkhaki: 12433259,
  darkmagenta: 9109643,
  darkolivegreen: 5597999,
  darkorange: 16747520,
  darkorchid: 10040012,
  darkred: 9109504,
  darksalmon: 15308410,
  darkseagreen: 9419919,
  darkslateblue: 4734347,
  darkslategray: 3100495,
  darkslategrey: 3100495,
  darkturquoise: 52945,
  darkviolet: 9699539,
  deeppink: 16716947,
  deepskyblue: 49151,
  dimgray: 6908265,
  dimgrey: 6908265,
  dodgerblue: 2003199,
  firebrick: 11674146,
  floralwhite: 16775920,
  forestgreen: 2263842,
  fuchsia: 16711935,
  gainsboro: 14474460,
  ghostwhite: 16316671,
  gold: 16766720,
  goldenrod: 14329120,
  gray: 8421504,
  green: 32768,
  greenyellow: 11403055,
  grey: 8421504,
  honeydew: 15794160,
  hotpink: 16738740,
  indianred: 13458524,
  indigo: 4915330,
  ivory: 16777200,
  khaki: 15787660,
  lavender: 15132410,
  lavenderblush: 16773365,
  lawngreen: 8190976,
  lemonchiffon: 16775885,
  lightblue: 11393254,
  lightcoral: 15761536,
  lightcyan: 14745599,
  lightgoldenrodyellow: 16448210,
  lightgray: 13882323,
  lightgreen: 9498256,
  lightgrey: 13882323,
  lightpink: 16758465,
  lightsalmon: 16752762,
  lightseagreen: 2142890,
  lightskyblue: 8900346,
  lightslategray: 7833753,
  lightslategrey: 7833753,
  lightsteelblue: 11584734,
  lightyellow: 16777184,
  lime: 65280,
  limegreen: 3329330,
  linen: 16445670,
  magenta: 16711935,
  maroon: 8388608,
  mediumaquamarine: 6737322,
  mediumblue: 205,
  mediumorchid: 12211667,
  mediumpurple: 9662683,
  mediumseagreen: 3978097,
  mediumslateblue: 8087790,
  mediumspringgreen: 64154,
  mediumturquoise: 4772300,
  mediumvioletred: 13047173,
  midnightblue: 1644912,
  mintcream: 16121850,
  mistyrose: 16770273,
  moccasin: 16770229,
  navajowhite: 16768685,
  navy: 128,
  oldlace: 16643558,
  olive: 8421376,
  olivedrab: 7048739,
  orange: 16753920,
  orangered: 16729344,
  orchid: 14315734,
  palegoldenrod: 15657130,
  palegreen: 10025880,
  paleturquoise: 11529966,
  palevioletred: 14381203,
  papayawhip: 16773077,
  peachpuff: 16767673,
  peru: 13468991,
  pink: 16761035,
  plum: 14524637,
  powderblue: 11591910,
  purple: 8388736,
  rebeccapurple: 6697881,
  red: 16711680,
  rosybrown: 12357519,
  royalblue: 4286945,
  saddlebrown: 9127187,
  salmon: 16416882,
  sandybrown: 16032864,
  seagreen: 3050327,
  seashell: 16774638,
  sienna: 10506797,
  silver: 12632256,
  skyblue: 8900331,
  slateblue: 6970061,
  slategray: 7372944,
  slategrey: 7372944,
  snow: 16775930,
  springgreen: 65407,
  steelblue: 4620980,
  tan: 13808780,
  teal: 32896,
  thistle: 14204888,
  tomato: 16737095,
  turquoise: 4251856,
  violet: 15631086,
  wheat: 16113331,
  white: 16777215,
  whitesmoke: 16119285,
  yellow: 16776960,
  yellowgreen: 10145074
};
Wb($u, Tu, {
  copy(e) {
    return Object.assign(new this.constructor(), this, e);
  },
  displayable() {
    return this.rgb().displayable();
  },
  hex: KC,
  // Deprecated! Use color.formatHex.
  formatHex: KC,
  formatHex8: NYe,
  formatHsl: jYe,
  formatRgb: ZC,
  toString: ZC
});
function KC() {
  return this.rgb().formatHex();
}
function NYe() {
  return this.rgb().formatHex8();
}
function jYe() {
  return dE(this).formatHsl();
}
function ZC() {
  return this.rgb().formatRgb();
}
function Tu(e) {
  var t, s;
  return e = (e + "").trim().toLowerCase(), (t = LYe.exec(e)) ? (s = t[1].length, t = parseInt(t[1], 16), s === 6 ? JC(t) : s === 3 ? new On(t >> 8 & 15 | t >> 4 & 240, t >> 4 & 15 | t & 240, (t & 15) << 4 | t & 15, 1) : s === 8 ? Up(t >> 24 & 255, t >> 16 & 255, t >> 8 & 255, (t & 255) / 255) : s === 4 ? Up(t >> 12 & 15 | t >> 8 & 240, t >> 8 & 15 | t >> 4 & 240, t >> 4 & 15 | t & 240, ((t & 15) << 4 | t & 15) / 255) : null) : (t = BYe.exec(e)) ? new On(t[1], t[2], t[3], 1) : (t = MYe.exec(e)) ? new On(t[1] * 255 / 100, t[2] * 255 / 100, t[3] * 255 / 100, 1) : (t = xYe.exec(e)) ? Up(t[1], t[2], t[3], t[4]) : (t = FYe.exec(e)) ? Up(t[1] * 255 / 100, t[2] * 255 / 100, t[3] * 255 / 100, t[4]) : (t = VYe.exec(e)) ? eS(t[1], t[2] / 100, t[3] / 100, 1) : (t = DYe.exec(e)) ? eS(t[1], t[2] / 100, t[3] / 100, t[4]) : QC.hasOwnProperty(e) ? JC(QC[e]) : e === "transparent" ? new On(NaN, NaN, NaN, 0) : null;
}
function JC(e) {
  return new On(e >> 16 & 255, e >> 8 & 255, e & 255, 1);
}
function Up(e, t, s, n) {
  return n <= 0 && (e = t = s = NaN), new On(e, t, s, n);
}
function HYe(e) {
  return e instanceof $u || (e = Tu(e)), e ? (e = e.rgb(), new On(e.r, e.g, e.b, e.opacity)) : new On();
}
function jy(e, t, s, n) {
  return arguments.length === 1 ? HYe(e) : new On(e, t, s, n ?? 1);
}
function On(e, t, s, n) {
  this.r = +e, this.g = +t, this.b = +s, this.opacity = +n;
}
Wb(On, jy, lE($u, {
  brighter(e) {
    return e = e == null ? km : Math.pow(km, e), new On(this.r * e, this.g * e, this.b * e, this.opacity);
  },
  darker(e) {
    return e = e == null ? Eu : Math.pow(Eu, e), new On(this.r * e, this.g * e, this.b * e, this.opacity);
  },
  rgb() {
    return this;
  },
  clamp() {
    return new On(sl(this.r), sl(this.g), sl(this.b), Em(this.opacity));
  },
  displayable() {
    return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
  },
  hex: $C,
  // Deprecated! Use color.formatHex.
  formatHex: $C,
  formatHex8: UYe,
  formatRgb: _C,
  toString: _C
}));
function $C() {
  return `#${Qi(this.r)}${Qi(this.g)}${Qi(this.b)}`;
}
function UYe() {
  return `#${Qi(this.r)}${Qi(this.g)}${Qi(this.b)}${Qi((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function _C() {
  const e = Em(this.opacity);
  return `${e === 1 ? "rgb(" : "rgba("}${sl(this.r)}, ${sl(this.g)}, ${sl(this.b)}${e === 1 ? ")" : `, ${e})`}`;
}
function Em(e) {
  return isNaN(e) ? 1 : Math.max(0, Math.min(1, e));
}
function sl(e) {
  return Math.max(0, Math.min(255, Math.round(e) || 0));
}
function Qi(e) {
  return e = sl(e), (e < 16 ? "0" : "") + e.toString(16);
}
function eS(e, t, s, n) {
  return n <= 0 ? e = t = s = NaN : s <= 0 || s >= 1 ? e = t = NaN : t <= 0 && (e = NaN), new fr(e, t, s, n);
}
function dE(e) {
  if (e instanceof fr) return new fr(e.h, e.s, e.l, e.opacity);
  if (e instanceof $u || (e = Tu(e)), !e) return new fr();
  if (e instanceof fr) return e;
  e = e.rgb();
  var t = e.r / 255, s = e.g / 255, n = e.b / 255, r = Math.min(t, s, n), i = Math.max(t, s, n), o = NaN, l = i - r, d = (i + r) / 2;
  return l ? (t === i ? o = (s - n) / l + (s < n) * 6 : s === i ? o = (n - t) / l + 2 : o = (t - s) / l + 4, l /= d < 0.5 ? i + r : 2 - i - r, o *= 60) : l = d > 0 && d < 1 ? 0 : o, new fr(o, l, d, e.opacity);
}
function zYe(e, t, s, n) {
  return arguments.length === 1 ? dE(e) : new fr(e, t, s, n ?? 1);
}
function fr(e, t, s, n) {
  this.h = +e, this.s = +t, this.l = +s, this.opacity = +n;
}
Wb(fr, zYe, lE($u, {
  brighter(e) {
    return e = e == null ? km : Math.pow(km, e), new fr(this.h, this.s, this.l * e, this.opacity);
  },
  darker(e) {
    return e = e == null ? Eu : Math.pow(Eu, e), new fr(this.h, this.s, this.l * e, this.opacity);
  },
  rgb() {
    var e = this.h % 360 + (this.h < 0) * 360, t = isNaN(e) || isNaN(this.s) ? 0 : this.s, s = this.l, n = s + (s < 0.5 ? s : 1 - s) * t, r = 2 * s - n;
    return new On(
      Ug(e >= 240 ? e - 240 : e + 120, r, n),
      Ug(e, r, n),
      Ug(e < 120 ? e + 240 : e - 120, r, n),
      this.opacity
    );
  },
  clamp() {
    return new fr(tS(this.h), zp(this.s), zp(this.l), Em(this.opacity));
  },
  displayable() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
  },
  formatHsl() {
    const e = Em(this.opacity);
    return `${e === 1 ? "hsl(" : "hsla("}${tS(this.h)}, ${zp(this.s) * 100}%, ${zp(this.l) * 100}%${e === 1 ? ")" : `, ${e})`}`;
  }
}));
function tS(e) {
  return e = (e || 0) % 360, e < 0 ? e + 360 : e;
}
function zp(e) {
  return Math.max(0, Math.min(1, e || 0));
}
function Ug(e, t, s) {
  return (e < 60 ? t + (s - t) * e / 60 : e < 180 ? s : e < 240 ? t + (s - t) * (240 - e) / 60 : t) * 255;
}
const cE = (e) => () => e;
function WYe(e, t) {
  return function(s) {
    return e + s * t;
  };
}
function GYe(e, t, s) {
  return e = Math.pow(e, s), t = Math.pow(t, s) - e, s = 1 / s, function(n) {
    return Math.pow(e + n * t, s);
  };
}
function YYe(e) {
  return (e = +e) == 1 ? uE : function(t, s) {
    return s - t ? GYe(t, s, e) : cE(isNaN(t) ? s : t);
  };
}
function uE(e, t) {
  var s = t - e;
  return s ? WYe(e, s) : cE(isNaN(e) ? t : e);
}
const sS = function e(t) {
  var s = YYe(t);
  function n(r, i) {
    var o = s((r = jy(r)).r, (i = jy(i)).r), l = s(r.g, i.g), d = s(r.b, i.b), c = uE(r.opacity, i.opacity);
    return function(u) {
      return r.r = o(u), r.g = l(u), r.b = d(u), r.opacity = c(u), r + "";
    };
  }
  return n.gamma = e, n;
}(1);
function ni(e, t) {
  return e = +e, t = +t, function(s) {
    return e * (1 - s) + t * s;
  };
}
var Hy = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, zg = new RegExp(Hy.source, "g");
function XYe(e) {
  return function() {
    return e;
  };
}
function qYe(e) {
  return function(t) {
    return e(t) + "";
  };
}
function QYe(e, t) {
  var s = Hy.lastIndex = zg.lastIndex = 0, n, r, i, o = -1, l = [], d = [];
  for (e = e + "", t = t + ""; (n = Hy.exec(e)) && (r = zg.exec(t)); )
    (i = r.index) > s && (i = t.slice(s, i), l[o] ? l[o] += i : l[++o] = i), (n = n[0]) === (r = r[0]) ? l[o] ? l[o] += r : l[++o] = r : (l[++o] = null, d.push({ i: o, x: ni(n, r) })), s = zg.lastIndex;
  return s < t.length && (i = t.slice(s), l[o] ? l[o] += i : l[++o] = i), l.length < 2 ? d[0] ? qYe(d[0].x) : XYe(t) : (t = d.length, function(c) {
    for (var u = 0, m; u < t; ++u) l[(m = d[u]).i] = m.x(c);
    return l.join("");
  });
}
var aS = 180 / Math.PI, Uy = {
  translateX: 0,
  translateY: 0,
  rotate: 0,
  skewX: 0,
  scaleX: 1,
  scaleY: 1
};
function pE(e, t, s, n, r, i) {
  var o, l, d;
  return (o = Math.sqrt(e * e + t * t)) && (e /= o, t /= o), (d = e * s + t * n) && (s -= e * d, n -= t * d), (l = Math.sqrt(s * s + n * n)) && (s /= l, n /= l, d /= l), e * n < t * s && (e = -e, t = -t, d = -d, o = -o), {
    translateX: r,
    translateY: i,
    rotate: Math.atan2(t, e) * aS,
    skewX: Math.atan(d) * aS,
    scaleX: o,
    scaleY: l
  };
}
var Wp;
function KYe(e) {
  const t = new (typeof DOMMatrix == "function" ? DOMMatrix : WebKitCSSMatrix)(e + "");
  return t.isIdentity ? Uy : pE(t.a, t.b, t.c, t.d, t.e, t.f);
}
function ZYe(e) {
  return e == null || (Wp || (Wp = document.createElementNS("http://www.w3.org/2000/svg", "g")), Wp.setAttribute("transform", e), !(e = Wp.transform.baseVal.consolidate())) ? Uy : (e = e.matrix, pE(e.a, e.b, e.c, e.d, e.e, e.f));
}
function hE(e, t, s, n) {
  function r(c) {
    return c.length ? c.pop() + " " : "";
  }
  function i(c, u, m, f, v, b) {
    if (c !== m || u !== f) {
      var w = v.push("translate(", null, t, null, s);
      b.push({ i: w - 4, x: ni(c, m) }, { i: w - 2, x: ni(u, f) });
    } else (m || f) && v.push("translate(" + m + t + f + s);
  }
  function o(c, u, m, f) {
    c !== u ? (c - u > 180 ? u += 360 : u - c > 180 && (c += 360), f.push({ i: m.push(r(m) + "rotate(", null, n) - 2, x: ni(c, u) })) : u && m.push(r(m) + "rotate(" + u + n);
  }
  function l(c, u, m, f) {
    c !== u ? f.push({ i: m.push(r(m) + "skewX(", null, n) - 2, x: ni(c, u) }) : u && m.push(r(m) + "skewX(" + u + n);
  }
  function d(c, u, m, f, v, b) {
    if (c !== m || u !== f) {
      var w = v.push(r(v) + "scale(", null, ",", null, ")");
      b.push({ i: w - 4, x: ni(c, m) }, { i: w - 2, x: ni(u, f) });
    } else (m !== 1 || f !== 1) && v.push(r(v) + "scale(" + m + "," + f + ")");
  }
  return function(c, u) {
    var m = [], f = [];
    return c = e(c), u = e(u), i(c.translateX, c.translateY, u.translateX, u.translateY, m, f), o(c.rotate, u.rotate, m, f), l(c.skewX, u.skewX, m, f), d(c.scaleX, c.scaleY, u.scaleX, u.scaleY, m, f), c = u = null, function(v) {
      for (var b = -1, w = f.length, S; ++b < w; ) m[(S = f[b]).i] = S.x(v);
      return m.join("");
    };
  };
}
var JYe = hE(KYe, "px, ", "px)", "deg)"), $Ye = hE(ZYe, ", ", ")", ")"), Nd = 0, Wc = 0, Tc = 0, mE = 1e3, Im, Gc, Tm = 0, pl = 0, Pf = 0, Ou = typeof performance == "object" && performance.now ? performance : Date, fE = typeof window == "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(e) {
  setTimeout(e, 17);
};
function Gb() {
  return pl || (fE(_Ye), pl = Ou.now() + Pf);
}
function _Ye() {
  pl = 0;
}
function Om() {
  this._call = this._time = this._next = null;
}
Om.prototype = gE.prototype = {
  constructor: Om,
  restart: function(e, t, s) {
    if (typeof e != "function") throw new TypeError("callback is not a function");
    s = (s == null ? Gb() : +s) + (t == null ? 0 : +t), !this._next && Gc !== this && (Gc ? Gc._next = this : Im = this, Gc = this), this._call = e, this._time = s, zy();
  },
  stop: function() {
    this._call && (this._call = null, this._time = 1 / 0, zy());
  }
};
function gE(e, t, s) {
  var n = new Om();
  return n.restart(e, t, s), n;
}
function eXe() {
  Gb(), ++Nd;
  for (var e = Im, t; e; )
    (t = pl - e._time) >= 0 && e._call.call(void 0, t), e = e._next;
  --Nd;
}
function nS() {
  pl = (Tm = Ou.now()) + Pf, Nd = Wc = 0;
  try {
    eXe();
  } finally {
    Nd = 0, sXe(), pl = 0;
  }
}
function tXe() {
  var e = Ou.now(), t = e - Tm;
  t > mE && (Pf -= t, Tm = e);
}
function sXe() {
  for (var e, t = Im, s, n = 1 / 0; t; )
    t._call ? (n > t._time && (n = t._time), e = t, t = t._next) : (s = t._next, t._next = null, t = e ? e._next = s : Im = s);
  Gc = e, zy(n);
}
function zy(e) {
  if (!Nd) {
    Wc && (Wc = clearTimeout(Wc));
    var t = e - pl;
    t > 24 ? (e < 1 / 0 && (Wc = setTimeout(nS, e - Ou.now() - Pf)), Tc && (Tc = clearInterval(Tc))) : (Tc || (Tm = Ou.now(), Tc = setInterval(tXe, mE)), Nd = 1, fE(nS));
  }
}
function rS(e, t, s) {
  var n = new Om();
  return t = t == null ? 0 : +t, n.restart((r) => {
    n.stop(), e(r + t);
  }, t, s), n;
}
var aXe = K5("start", "end", "cancel", "interrupt"), nXe = [], vE = 0, oS = 1, Wy = 2, jh = 3, iS = 4, Gy = 5, Hh = 6;
function kf(e, t, s, n, r, i) {
  var o = e.__transition;
  if (!o) e.__transition = {};
  else if (s in o) return;
  rXe(e, s, {
    name: t,
    index: n,
    // For context during callback.
    group: r,
    // For context during callback.
    on: aXe,
    tween: nXe,
    time: i.time,
    delay: i.delay,
    duration: i.duration,
    ease: i.ease,
    timer: null,
    state: vE
  });
}
function Yb(e, t) {
  var s = br(e, t);
  if (s.state > vE) throw new Error("too late; already scheduled");
  return s;
}
function to(e, t) {
  var s = br(e, t);
  if (s.state > jh) throw new Error("too late; already running");
  return s;
}
function br(e, t) {
  var s = e.__transition;
  if (!s || !(s = s[t])) throw new Error("transition not found");
  return s;
}
function rXe(e, t, s) {
  var n = e.__transition, r;
  n[t] = s, s.timer = gE(i, 0, s.time);
  function i(c) {
    s.state = oS, s.timer.restart(o, s.delay, s.time), s.delay <= c && o(c - s.delay);
  }
  function o(c) {
    var u, m, f, v;
    if (s.state !== oS) return d();
    for (u in n)
      if (v = n[u], v.name === s.name) {
        if (v.state === jh) return rS(o);
        v.state === iS ? (v.state = Hh, v.timer.stop(), v.on.call("interrupt", e, e.__data__, v.index, v.group), delete n[u]) : +u < t && (v.state = Hh, v.timer.stop(), v.on.call("cancel", e, e.__data__, v.index, v.group), delete n[u]);
      }
    if (rS(function() {
      s.state === jh && (s.state = iS, s.timer.restart(l, s.delay, s.time), l(c));
    }), s.state = Wy, s.on.call("start", e, e.__data__, s.index, s.group), s.state === Wy) {
      for (s.state = jh, r = new Array(f = s.tween.length), u = 0, m = -1; u < f; ++u)
        (v = s.tween[u].value.call(e, e.__data__, s.index, s.group)) && (r[++m] = v);
      r.length = m + 1;
    }
  }
  function l(c) {
    for (var u = c < s.duration ? s.ease.call(null, c / s.duration) : (s.timer.restart(d), s.state = Gy, 1), m = -1, f = r.length; ++m < f; )
      r[m].call(e, u);
    s.state === Gy && (s.on.call("end", e, e.__data__, s.index, s.group), d());
  }
  function d() {
    s.state = Hh, s.timer.stop(), delete n[t];
    for (var c in n) return;
    delete e.__transition;
  }
}
function oXe(e, t) {
  var s = e.__transition, n, r, i = !0, o;
  if (s) {
    t = t == null ? null : t + "";
    for (o in s) {
      if ((n = s[o]).name !== t) {
        i = !1;
        continue;
      }
      r = n.state > Wy && n.state < Gy, n.state = Hh, n.timer.stop(), n.on.call(r ? "interrupt" : "cancel", e, e.__data__, n.index, n.group), delete s[o];
    }
    i && delete e.__transition;
  }
}
function iXe(e) {
  return this.each(function() {
    oXe(this, e);
  });
}
function lXe(e, t) {
  var s, n;
  return function() {
    var r = to(this, e), i = r.tween;
    if (i !== s) {
      n = s = i;
      for (var o = 0, l = n.length; o < l; ++o)
        if (n[o].name === t) {
          n = n.slice(), n.splice(o, 1);
          break;
        }
    }
    r.tween = n;
  };
}
function dXe(e, t, s) {
  var n, r;
  if (typeof s != "function") throw new Error();
  return function() {
    var i = to(this, e), o = i.tween;
    if (o !== n) {
      r = (n = o).slice();
      for (var l = { name: t, value: s }, d = 0, c = r.length; d < c; ++d)
        if (r[d].name === t) {
          r[d] = l;
          break;
        }
      d === c && r.push(l);
    }
    i.tween = r;
  };
}
function cXe(e, t) {
  var s = this._id;
  if (e += "", arguments.length < 2) {
    for (var n = br(this.node(), s).tween, r = 0, i = n.length, o; r < i; ++r)
      if ((o = n[r]).name === e)
        return o.value;
    return null;
  }
  return this.each((t == null ? lXe : dXe)(s, e, t));
}
function Xb(e, t, s) {
  var n = e._id;
  return e.each(function() {
    var r = to(this, n);
    (r.value || (r.value = {}))[t] = s.apply(this, arguments);
  }), function(r) {
    return br(r, n).value[t];
  };
}
function yE(e, t) {
  var s;
  return (typeof t == "number" ? ni : t instanceof Tu ? sS : (s = Tu(t)) ? (t = s, sS) : QYe)(e, t);
}
function uXe(e) {
  return function() {
    this.removeAttribute(e);
  };
}
function pXe(e) {
  return function() {
    this.removeAttributeNS(e.space, e.local);
  };
}
function hXe(e, t, s) {
  var n, r = s + "", i;
  return function() {
    var o = this.getAttribute(e);
    return o === r ? null : o === n ? i : i = t(n = o, s);
  };
}
function mXe(e, t, s) {
  var n, r = s + "", i;
  return function() {
    var o = this.getAttributeNS(e.space, e.local);
    return o === r ? null : o === n ? i : i = t(n = o, s);
  };
}
function fXe(e, t, s) {
  var n, r, i;
  return function() {
    var o, l = s(this), d;
    return l == null ? void this.removeAttribute(e) : (o = this.getAttribute(e), d = l + "", o === d ? null : o === n && d === r ? i : (r = d, i = t(n = o, l)));
  };
}
function gXe(e, t, s) {
  var n, r, i;
  return function() {
    var o, l = s(this), d;
    return l == null ? void this.removeAttributeNS(e.space, e.local) : (o = this.getAttributeNS(e.space, e.local), d = l + "", o === d ? null : o === n && d === r ? i : (r = d, i = t(n = o, l)));
  };
}
function vXe(e, t) {
  var s = Sf(e), n = s === "transform" ? $Ye : yE;
  return this.attrTween(e, typeof t == "function" ? (s.local ? gXe : fXe)(s, n, Xb(this, "attr." + e, t)) : t == null ? (s.local ? pXe : uXe)(s) : (s.local ? mXe : hXe)(s, n, t));
}
function yXe(e, t) {
  return function(s) {
    this.setAttribute(e, t.call(this, s));
  };
}
function bXe(e, t) {
  return function(s) {
    this.setAttributeNS(e.space, e.local, t.call(this, s));
  };
}
function AXe(e, t) {
  var s, n;
  function r() {
    var i = t.apply(this, arguments);
    return i !== n && (s = (n = i) && bXe(e, i)), s;
  }
  return r._value = t, r;
}
function wXe(e, t) {
  var s, n;
  function r() {
    var i = t.apply(this, arguments);
    return i !== n && (s = (n = i) && yXe(e, i)), s;
  }
  return r._value = t, r;
}
function CXe(e, t) {
  var s = "attr." + e;
  if (arguments.length < 2) return (s = this.tween(s)) && s._value;
  if (t == null) return this.tween(s, null);
  if (typeof t != "function") throw new Error();
  var n = Sf(e);
  return this.tween(s, (n.local ? AXe : wXe)(n, t));
}
function SXe(e, t) {
  return function() {
    Yb(this, e).delay = +t.apply(this, arguments);
  };
}
function PXe(e, t) {
  return t = +t, function() {
    Yb(this, e).delay = t;
  };
}
function kXe(e) {
  var t = this._id;
  return arguments.length ? this.each((typeof e == "function" ? SXe : PXe)(t, e)) : br(this.node(), t).delay;
}
function EXe(e, t) {
  return function() {
    to(this, e).duration = +t.apply(this, arguments);
  };
}
function IXe(e, t) {
  return t = +t, function() {
    to(this, e).duration = t;
  };
}
function TXe(e) {
  var t = this._id;
  return arguments.length ? this.each((typeof e == "function" ? EXe : IXe)(t, e)) : br(this.node(), t).duration;
}
function OXe(e, t) {
  if (typeof t != "function") throw new Error();
  return function() {
    to(this, e).ease = t;
  };
}
function RXe(e) {
  var t = this._id;
  return arguments.length ? this.each(OXe(t, e)) : br(this.node(), t).ease;
}
function LXe(e, t) {
  return function() {
    var s = t.apply(this, arguments);
    if (typeof s != "function") throw new Error();
    to(this, e).ease = s;
  };
}
function BXe(e) {
  if (typeof e != "function") throw new Error();
  return this.each(LXe(this._id, e));
}
function MXe(e) {
  typeof e != "function" && (e = $5(e));
  for (var t = this._groups, s = t.length, n = new Array(s), r = 0; r < s; ++r)
    for (var i = t[r], o = i.length, l = n[r] = [], d, c = 0; c < o; ++c)
      (d = i[c]) && e.call(d, d.__data__, c, i) && l.push(d);
  return new zo(n, this._parents, this._name, this._id);
}
function xXe(e) {
  if (e._id !== this._id) throw new Error();
  for (var t = this._groups, s = e._groups, n = t.length, r = s.length, i = Math.min(n, r), o = new Array(n), l = 0; l < i; ++l)
    for (var d = t[l], c = s[l], u = d.length, m = o[l] = new Array(u), f, v = 0; v < u; ++v)
      (f = d[v] || c[v]) && (m[v] = f);
  for (; l < n; ++l)
    o[l] = t[l];
  return new zo(o, this._parents, this._name, this._id);
}
function FXe(e) {
  return (e + "").trim().split(/^|\s+/).every(function(t) {
    var s = t.indexOf(".");
    return s >= 0 && (t = t.slice(0, s)), !t || t === "start";
  });
}
function VXe(e, t, s) {
  var n, r, i = FXe(t) ? Yb : to;
  return function() {
    var o = i(this, e), l = o.on;
    l !== n && (r = (n = l).copy()).on(t, s), o.on = r;
  };
}
function DXe(e, t) {
  var s = this._id;
  return arguments.length < 2 ? br(this.node(), s).on.on(e) : this.each(VXe(s, e, t));
}
function NXe(e) {
  return function() {
    var t = this.parentNode;
    for (var s in this.__transition) if (+s !== e) return;
    t && t.removeChild(this);
  };
}
function jXe() {
  return this.on("end.remove", NXe(this._id));
}
function HXe(e) {
  var t = this._name, s = this._id;
  typeof e != "function" && (e = Ub(e));
  for (var n = this._groups, r = n.length, i = new Array(r), o = 0; o < r; ++o)
    for (var l = n[o], d = l.length, c = i[o] = new Array(d), u, m, f = 0; f < d; ++f)
      (u = l[f]) && (m = e.call(u, u.__data__, f, l)) && ("__data__" in u && (m.__data__ = u.__data__), c[f] = m, kf(c[f], t, s, f, c, br(u, s)));
  return new zo(i, this._parents, t, s);
}
function UXe(e) {
  var t = this._name, s = this._id;
  typeof e != "function" && (e = J5(e));
  for (var n = this._groups, r = n.length, i = [], o = [], l = 0; l < r; ++l)
    for (var d = n[l], c = d.length, u, m = 0; m < c; ++m)
      if (u = d[m]) {
        for (var f = e.call(u, u.__data__, m, d), v, b = br(u, s), w = 0, S = f.length; w < S; ++w)
          (v = f[w]) && kf(v, t, s, w, f, b);
        i.push(f), o.push(u);
      }
  return new zo(i, o, t, s);
}
var zXe = Ju.prototype.constructor;
function WXe() {
  return new zXe(this._groups, this._parents);
}
function GXe(e, t) {
  var s, n, r;
  return function() {
    var i = Dd(this, e), o = (this.style.removeProperty(e), Dd(this, e));
    return i === o ? null : i === s && o === n ? r : r = t(s = i, n = o);
  };
}
function bE(e) {
  return function() {
    this.style.removeProperty(e);
  };
}
function YXe(e, t, s) {
  var n, r = s + "", i;
  return function() {
    var o = Dd(this, e);
    return o === r ? null : o === n ? i : i = t(n = o, s);
  };
}
function XXe(e, t, s) {
  var n, r, i;
  return function() {
    var o = Dd(this, e), l = s(this), d = l + "";
    return l == null && (d = l = (this.style.removeProperty(e), Dd(this, e))), o === d ? null : o === n && d === r ? i : (r = d, i = t(n = o, l));
  };
}
function qXe(e, t) {
  var s, n, r, i = "style." + t, o = "end." + i, l;
  return function() {
    var d = to(this, e), c = d.on, u = d.value[i] == null ? l || (l = bE(t)) : void 0;
    (c !== s || r !== u) && (n = (s = c).copy()).on(o, r = u), d.on = n;
  };
}
function QXe(e, t, s) {
  var n = (e += "") == "transform" ? JYe : yE;
  return t == null ? this.styleTween(e, GXe(e, n)).on("end.style." + e, bE(e)) : typeof t == "function" ? this.styleTween(e, XXe(e, n, Xb(this, "style." + e, t))).each(qXe(this._id, e)) : this.styleTween(e, YXe(e, n, t), s).on("end.style." + e, null);
}
function KXe(e, t, s) {
  return function(n) {
    this.style.setProperty(e, t.call(this, n), s);
  };
}
function ZXe(e, t, s) {
  var n, r;
  function i() {
    var o = t.apply(this, arguments);
    return o !== r && (n = (r = o) && KXe(e, o, s)), n;
  }
  return i._value = t, i;
}
function JXe(e, t, s) {
  var n = "style." + (e += "");
  if (arguments.length < 2) return (n = this.tween(n)) && n._value;
  if (t == null) return this.tween(n, null);
  if (typeof t != "function") throw new Error();
  return this.tween(n, ZXe(e, t, s ?? ""));
}
function $Xe(e) {
  return function() {
    this.textContent = e;
  };
}
function _Xe(e) {
  return function() {
    var t = e(this);
    this.textContent = t ?? "";
  };
}
function eqe(e) {
  return this.tween("text", typeof e == "function" ? _Xe(Xb(this, "text", e)) : $Xe(e == null ? "" : e + ""));
}
function tqe(e) {
  return function(t) {
    this.textContent = e.call(this, t);
  };
}
function sqe(e) {
  var t, s;
  function n() {
    var r = e.apply(this, arguments);
    return r !== s && (t = (s = r) && tqe(r)), t;
  }
  return n._value = e, n;
}
function aqe(e) {
  var t = "text";
  if (arguments.length < 1) return (t = this.tween(t)) && t._value;
  if (e == null) return this.tween(t, null);
  if (typeof e != "function") throw new Error();
  return this.tween(t, sqe(e));
}
function nqe() {
  for (var e = this._name, t = this._id, s = AE(), n = this._groups, r = n.length, i = 0; i < r; ++i)
    for (var o = n[i], l = o.length, d, c = 0; c < l; ++c)
      if (d = o[c]) {
        var u = br(d, t);
        kf(d, e, s, c, o, {
          time: u.time + u.delay + u.duration,
          delay: 0,
          duration: u.duration,
          ease: u.ease
        });
      }
  return new zo(n, this._parents, e, s);
}
function rqe() {
  var e, t, s = this, n = s._id, r = s.size();
  return new Promise(function(i, o) {
    var l = { value: o }, d = { value: function() {
      --r === 0 && i();
    } };
    s.each(function() {
      var c = to(this, n), u = c.on;
      u !== e && (t = (e = u).copy(), t._.cancel.push(l), t._.interrupt.push(l), t._.end.push(d)), c.on = t;
    }), r === 0 && i();
  });
}
var oqe = 0;
function zo(e, t, s, n) {
  this._groups = e, this._parents = t, this._name = s, this._id = n;
}
function AE() {
  return ++oqe;
}
var co = Ju.prototype;
zo.prototype = {
  constructor: zo,
  select: HXe,
  selectAll: UXe,
  selectChild: co.selectChild,
  selectChildren: co.selectChildren,
  filter: MXe,
  merge: xXe,
  selection: WXe,
  transition: nqe,
  call: co.call,
  nodes: co.nodes,
  node: co.node,
  size: co.size,
  empty: co.empty,
  each: co.each,
  on: DXe,
  attr: vXe,
  attrTween: CXe,
  style: QXe,
  styleTween: JXe,
  text: eqe,
  textTween: aqe,
  remove: jXe,
  tween: cXe,
  delay: kXe,
  duration: TXe,
  ease: RXe,
  easeVarying: BXe,
  end: rqe,
  [Symbol.iterator]: co[Symbol.iterator]
};
function iqe(e) {
  return ((e *= 2) <= 1 ? e * e * e : (e -= 2) * e * e + 2) / 2;
}
var lqe = {
  time: null,
  // Set on use.
  delay: 0,
  duration: 250,
  ease: iqe
};
function dqe(e, t) {
  for (var s; !(s = e.__transition) || !(s = s[t]); )
    if (!(e = e.parentNode))
      throw new Error(`transition ${t} not found`);
  return s;
}
function cqe(e) {
  var t, s;
  e instanceof zo ? (t = e._id, e = e._name) : (t = AE(), (s = lqe).time = Gb(), e = e == null ? null : e + "");
  for (var n = this._groups, r = n.length, i = 0; i < r; ++i)
    for (var o = n[i], l = o.length, d, c = 0; c < l; ++c)
      (d = o[c]) && kf(d, e, t, c, o, s || dqe(d, t));
  return new zo(n, this._parents, e, t);
}
Ju.prototype.interrupt = iXe;
Ju.prototype.transition = cqe;
function Yc(e, t, s) {
  this.k = e, this.x = t, this.y = s;
}
Yc.prototype = {
  constructor: Yc,
  scale: function(e) {
    return e === 1 ? this : new Yc(this.k * e, this.x, this.y);
  },
  translate: function(e, t) {
    return e === 0 & t === 0 ? this : new Yc(this.k, this.x + this.k * e, this.y + this.k * t);
  },
  apply: function(e) {
    return [e[0] * this.k + this.x, e[1] * this.k + this.y];
  },
  applyX: function(e) {
    return e * this.k + this.x;
  },
  applyY: function(e) {
    return e * this.k + this.y;
  },
  invert: function(e) {
    return [(e[0] - this.x) / this.k, (e[1] - this.y) / this.k];
  },
  invertX: function(e) {
    return (e - this.x) / this.k;
  },
  invertY: function(e) {
    return (e - this.y) / this.k;
  },
  rescaleX: function(e) {
    return e.copy().domain(e.range().map(this.invertX, this).map(e.invert, e));
  },
  rescaleY: function(e) {
    return e.copy().domain(e.range().map(this.invertY, this).map(e.invert, e));
  },
  toString: function() {
    return "translate(" + this.x + "," + this.y + ") scale(" + this.k + ")";
  }
};
Yc.prototype;
const uqe = me({
  name: "KpiRentalRateAffordability",
  components: {
    ContentLoader: Sa
  },
  watch: {
    affordabilityIndex(e) {
      this.refreshGauge();
    }
  },
  computed: {
    haveAccess() {
      var e, t;
      return this.isMarketplace || ((t = (e = this.acl) == null ? void 0 : e.properties) == null ? void 0 : t.financialAnalysis) == !0;
    },
    calculatingClasses() {
      return {
        calculating: this.calculating,
        card: !0,
        "bg-kpi": !0,
        "shadow-sm": !0,
        "card-rentalrateaffordability": !0
      };
    },
    mainStyle() {
      return {
        blur: !this.haveAccess
      };
    },
    affordabilityIndex() {
      var e, t, s, n, r, i, o, l, d;
      return this.isShortTerm ? (s = (t = (e = this.calculatedResults) == null ? void 0 : e.shortTerm) == null ? void 0 : t.find((c) => c.year == this.firstProformaYear)) == null ? void 0 : s.affordabilityIndex : this.isPadSplit ? (i = (r = (n = this.calculatedResults) == null ? void 0 : n.padSplit) == null ? void 0 : r.find((c) => c.year == this.firstProformaYear)) == null ? void 0 : i.affordabilityIndex : (d = (l = (o = this.calculatedResults) == null ? void 0 : o.normalized) == null ? void 0 : l.find((c) => c.year == this.firstProformaYear)) == null ? void 0 : d.affordabilityIndex;
    },
    medianIncome() {
      var e;
      return (e = this.calculatedResults) == null ? void 0 : e.medianIncome;
    },
    medianIncomeBasedOn() {
      var e;
      return `Based on median income for ${(e = this.calculatedResults) == null ? void 0 : e.medianIncomeBasedOn}`;
    },
    rentalRate() {
      var e;
      return (e = this.calculatedResults) == null ? void 0 : e.monthlyRentalYear1;
    },
    ...q(Te, ["acl"]),
    ...q(qe, ["calculatedResults", "isShortTerm", "isPadSplit", "isMarketplace", "calculating", "firstProformaYear"])
  },
  methods: {
    number: Ve,
    currency: Ze,
    percent: Wt,
    buildGauge() {
      this.gauge = qC(this.$refs.linearGauge);
      let e = parseFloat(this.gauge.style("width"));
      window.onresize = this.refreshGauge, window.onscroll = this.refreshGauge;
      const t = 40;
      let s = e;
      const n = 0;
      let r = s * (this.affordabilityIndex / 200);
      r > s - 20 && (r = s - 20);
      let i = {
        top: n + t + 35
      };
      const o = qC(this.$refs.linearGauge).append("svg").attr("width", "100%").attr("height", "80"), l = o.append("svg:defs").append("svg:linearGradient").attr("id", "gradient").attr("x1", "0%").attr("y1", "0%").attr("x2", "100%").attr("y2", "0%").attr("spreadMethod", "pad");
      l.append("svg:stop").attr("offset", "0%").attr("stop-color", "#c00").attr("stop-opacity", 1), l.append("svg:stop").attr("offset", "15%").attr("stop-color", "#c00").attr("stop-opacity", 1), l.append("svg:stop").attr("offset", "35%").attr("stop-color", "yellow").attr("stop-opacity", 1), l.append("svg:stop").attr("offset", "40%").attr("stop-color", "yellow").attr("stop-opacity", 1), l.append("svg:stop").attr("offset", "75%").attr("stop-color", "#0c0").attr("stop-opacity", 1), o.append("g").append("rect").attr("x", 0).attr("y", n).attr("width", "100%").attr("height", t).attr("rx", 10).style("fill", "url(#gradient)"), o.append("g").append("text").attr("x", 0).attr("y", i.top).attr("font-size", 14).text("0"), o.append("g").append("text").classed("rightPrcnt", !0).attr("x", s).attr("y", i.top).attr("font-size", 14).attr("text-anchor", "end").text("200"), this.gaugeText = o.append("g").append("text").attr("font-weight", "bold").attr("font-family", "Montserrat").attr("font-size", 20), (isNaN(r) || r < 0) && (r = 2e3);
      const d = o.append("g");
      d.append("line").attr("x1", r).attr("y1", n).attr("x2", r).attr("y2", t + n).attr("stroke-width", 2).attr("stroke", "black"), d.append("circle").attr("cx", r).attr("cy", (t + n) / 2).attr("r", 5), this.gaugeText.classed("rightLabel", !0).attr("x", r).attr("y", t + n + 20).attr("text-anchor", "middle").text(this.affordabilityIndex);
    },
    refreshGauge() {
      try {
        if (!this.gauge || !this.gaugeText)
          return;
        const e = parseFloat(this.gauge.style("width")), t = 40, s = 0, n = e;
        let r = n * (this.affordabilityIndex / 200);
        r > n - 20 && (r = n - 20), (isNaN(r) || r < 0) && (r = 2e3);
        const i = {
          top: s + t + 35,
          right: 10,
          bottom: 0,
          left: 10
        };
        this.gauge.select("line").attr("x1", r).attr("y1", s).attr("x2", r).attr("y2", t + s), this.gauge.select("circle").attr("cx", r).attr("cy", (t + s) / 2), this.gauge.select(".rightLabel").attr("x", n).text("width: " + e), this.gauge.select(".rightPrcnt").attr("x", n), this.gaugeText.attr("x", r).attr("y", t + s + 20).text(this.affordabilityIndex);
      } catch (e) {
        console.error("refreshGauge", e);
      }
    }
  },
  mounted() {
    this.buildGauge();
  }
}), pqe = {
  key: 0,
  class: "calculating-animation position-absolute top-50 start-50 translate-middle text-center"
}, hqe = {
  key: 2,
  class: "card-body kpi-data d-flex flex-row"
}, mqe = {
  id: "linear-gauge",
  ref: "linearGauge"
}, fqe = { class: "card-footer kpi-data small bg-transparent" }, gqe = ["title"];
function vqe(e, t, s, n, r, i) {
  const o = pe("content-loader");
  return p(), h("div", {
    class: z(e.calculatingClasses)
  }, [
    a("div", {
      class: z(e.mainStyle)
    }, [
      e.calculating ? (p(), h("div", pqe, t[0] || (t[0] = [
        a("i", { class: "fa-duotone fa-solid fa-compass fa-spin fa-lg text-eclipse" }, null, -1),
        a("br", null, null, -1),
        a("small", null, "Calculating", -1)
      ]))) : P("", !0),
      e.calculatedResults ? (p(), h("div", hqe, [
        t[3] || (t[3] = a("div", { class: "icon-shape bg-eclipse border-radius-md text-white d-flex justify-content-center align-items-center me-3 flex-shrink-0" }, [
          a("i", { class: "fa-light fa-lg fa-scale-balanced" })
        ], -1)),
        a("div", null, [
          t[1] || (t[1] = a("div", null, "Rental Rate Affordability", -1)),
          t[2] || (t[2] = a("div", { class: "small text-body-secondary mb-3" }, "A score of 100 means the monthly rent is exactly one-third of the local median monthly income. Values above 100 are more affordable, and values below 100 are less affordable.", -1)),
          a("div", mqe, null, 512)
        ])
      ])) : (p(), Fe(o, {
        key: 1,
        speed: 2,
        width: 344,
        height: 239,
        class: "d-sm-none"
      })),
      a("div", fqe, [
        t[4] || (t[4] = y(" A tenant earning the median income of ")),
        a("span", { title: e.medianIncomeBasedOn }, g(e.currency(e.medianIncome / 12)) + "/mo", 9, gqe),
        y(" would spend approximately " + g(e.percent(e.rentalRate / (e.medianIncome / 12))) + " of their income on rent each month. ", 1)
      ])
    ], 2)
  ], 2);
}
const yqe = /* @__PURE__ */ Ae(uqe, [["render", vqe], ["__scopeId", "data-v-676e182f"]]), bqe = me({
  name: "KpiGrossRentMultiplier",
  components: {
    ContentLoader: Sa
  },
  computed: {
    haveAccess() {
      var e, t;
      return this.isMarketplace || ((t = (e = this.acl) == null ? void 0 : e.properties) == null ? void 0 : t.financialAnalysis) == !0;
    },
    calculatingClasses() {
      return {
        active: this.calculating,
        card: !0,
        "bg-kpi": !0,
        "shadow-sm": !0
      };
    },
    mainStyle() {
      return {
        blur: !this.haveAccess
      };
    },
    grossRentMultiplier() {
      var e, t, s, n, r, i, o, l, d;
      return this.isShortTerm ? ((s = (t = (e = this.calculatedResults) == null ? void 0 : e.shortTerm) == null ? void 0 : t.find((c) => c.year == this.firstProformaYear)) == null ? void 0 : s.grossRentMultiplier) ?? 0 : this.isPadSplit ? ((i = (r = (n = this.calculatedResults) == null ? void 0 : n.padSplit) == null ? void 0 : r.find((c) => c.year == this.firstProformaYear)) == null ? void 0 : i.grossRentMultiplier) ?? 0 : ((d = (l = (o = this.calculatedResults) == null ? void 0 : o.normalized) == null ? void 0 : l.find((c) => c.year == this.firstProformaYear)) == null ? void 0 : d.grossRentMultiplier) ?? 0;
    },
    ...q(Te, ["acl", "aclLoaded"]),
    ...q(qe, ["calculatedResults", "isShortTerm", "isPadSplit", "isMarketplace", "calculating", "firstProformaYear"])
  },
  methods: {
    number: Ve
  }
}), Aqe = {
  key: 1,
  class: "card-body kpi-data d-flex flex-row"
}, wqe = { class: "fw-bold fs-5" };
function Cqe(e, t, s, n, r, i) {
  const o = pe("content-loader");
  return p(), h("div", {
    class: z(e.calculatingClasses)
  }, [
    a("div", {
      class: z(e.mainStyle)
    }, [
      t[3] || (t[3] = a("div", { class: "loading-financial position-absolute top-50 start-50 translate-middle text-center" }, [
        a("i", { class: "fa-duotone fa-solid fa-compass fa-spin fa-lg text-eclipse" }),
        a("br"),
        a("small", null, "Calculating")
      ], -1)),
      e.calculatedResults ? (p(), h("div", Aqe, [
        t[2] || (t[2] = a("div", { class: "icon-shape bg-eclipse border-radius-md text-white d-flex justify-content-center align-items-center me-3" }, [
          a("i", { class: "fa-light fa-lg fa-chart-line-up" })
        ], -1)),
        a("div", null, [
          t[0] || (t[0] = y(" Gross Rent Multiplier")),
          t[1] || (t[1] = a("br", null, null, -1)),
          a("b", wqe, g(e.number(e.grossRentMultiplier, 1)), 1)
        ])
      ])) : (p(), Fe(o, {
        key: 0,
        speed: 2,
        width: 344,
        height: 239,
        class: "d-sm-none"
      }))
    ], 2)
  ], 2);
}
const Sqe = /* @__PURE__ */ Ae(bqe, [["render", Cqe]]), Pqe = me({
  name: "CashFlow",
  computed: {
    isOnlyLongTerm() {
      return this.isLongTerm && this.rentalTypes.length <= 1;
    },
    colSpan() {
      return this.isAdvancedMode ? this.isOnlyLongTerm ? 3 : this.rentalTypes.length + 1 : 2;
    },
    calculatingClasses() {
      return {
        card: !0,
        "card-cash-flow": !0,
        "card-proforma": !0,
        "shadow-sm": !0,
        calculating: this.calculating
      };
    },
    normalized() {
      var e, t;
      return ((t = (e = this.calculatedResults) == null ? void 0 : e.normalized) == null ? void 0 : t.find((s) => s.year == this.firstProformaYear)) ?? {};
    },
    raw() {
      var e, t;
      return ((t = (e = this.calculatedResults) == null ? void 0 : e.raw) == null ? void 0 : t.find((s) => s.year == this.firstProformaYear)) ?? {};
    },
    shortTerm() {
      var e, t;
      return ((t = (e = this.calculatedResults) == null ? void 0 : e.shortTerm) == null ? void 0 : t.find((s) => s.year == this.firstProformaYear)) ?? {};
    },
    padSplit() {
      var e, t;
      return ((t = (e = this.calculatedResults) == null ? void 0 : e.padSplit) == null ? void 0 : t.find((s) => s.year == this.firstProformaYear)) ?? {};
    },
    normalizeds() {
      return this.calculatedResults.normalized ? this.calculatedResults.normalized.filter((e) => e.fiscalYear >= this.firstAnalyzedYear).sort((e, t) => e.fiscalYear - t.fiscalYear) : [];
    },
    raws() {
      return this.calculatedResults.raw ? this.calculatedResults.raw.filter((e) => e.fiscalYear >= this.firstAnalyzedYear).sort((e, t) => e.fiscalYear - t.fiscalYear) : [];
    },
    shortTerms() {
      return this.calculatedResults.shortTerm ? this.calculatedResults.shortTerm.filter((e) => e.fiscalYear >= this.firstAnalyzedYear).sort((e, t) => e.fiscalYear - t.fiscalYear) : [];
    },
    padSplits() {
      return this.calculatedResults.padSplit ? this.calculatedResults.padSplit.filter((e) => e.fiscalYear >= this.firstAnalyzedYear).sort((e, t) => e.fiscalYear - t.fiscalYear) : [];
    },
    mainTableStyle() {
      return {
        table: !0,
        "table-sm": !0,
        "text-small": !0,
        "mlse-values": !0,
        regListing: !0,
        tabla: !0,
        "mlse-table": !0,
        "mlse-cash-flow": !0,
        "mode-basic": this.isAdvancedMode != !0,
        "mode-advanced": this.isAdvancedMode == !0
      };
    },
    hasAnyPlatformServiceFees() {
      var e, t, s, n, r, i, o, l, d;
      return this.hasShortTerm ? ((t = (e = this.purchaseFacts) == null ? void 0 : e.years) == null ? void 0 : t.some((c) => c.platformServiceFees != null && c.platformServiceFees != 0)) || ((s = this.shortTerms) == null ? void 0 : s.some((c) => c.platformServiceFees != null && c.platformServiceFees != 0)) : this.hasPadSplit ? ((r = (n = this.purchaseFacts) == null ? void 0 : n.years) == null ? void 0 : r.some((c) => c.platformServiceFees != null && c.platformServiceFees != 0)) || ((i = this.padSplits) == null ? void 0 : i.some((c) => c.platformServiceFees != null && c.platformServiceFees != 0)) : ((l = (o = this.purchaseFacts) == null ? void 0 : o.years) == null ? void 0 : l.some((c) => c.platformServiceFees != null && c.platformServiceFees != 0)) || ((d = this.raws) == null ? void 0 : d.some((c) => c.platformServiceFees != null && c.platformServiceFees != 0));
    },
    hasAnyFurnishingExpenses() {
      var e, t, s, n, r, i, o, l, d;
      return this.hasShortTerm ? ((t = (e = this.purchaseFacts) == null ? void 0 : e.years) == null ? void 0 : t.some((c) => c.furnishingExpenses != null && c.furnishingExpenses != 0)) || ((s = this.shortTerms) == null ? void 0 : s.some((c) => c.furnishingExpenses != null && c.furnishingExpenses != 0)) : this.hasPadSplit ? ((r = (n = this.purchaseFacts) == null ? void 0 : n.years) == null ? void 0 : r.some((c) => c.furnishingExpenses != null && c.furnishingExpenses != 0)) || ((i = this.padSplits) == null ? void 0 : i.some((c) => c.furnishingExpenses != null && c.furnishingExpenses != 0)) : ((l = (o = this.purchaseFacts) == null ? void 0 : o.years) == null ? void 0 : l.some((c) => c.furnishingExpenses != null && c.furnishingExpenses != 0)) || ((d = this.raws) == null ? void 0 : d.some((c) => c.furnishingExpenses != null && c.furnishingExpenses != 0));
    },
    hasAnyConsumableExpenses() {
      var e, t, s, n, r, i, o, l, d;
      return this.hasShortTerm ? ((t = (e = this.purchaseFacts) == null ? void 0 : e.years) == null ? void 0 : t.some((c) => c.consumableExpenses != null && c.consumableExpenses != 0)) || ((s = this.shortTerms) == null ? void 0 : s.some((c) => c.consumableExpenses != null && c.consumableExpenses != 0)) : this.hasPadSplit ? ((r = (n = this.purchaseFacts) == null ? void 0 : n.years) == null ? void 0 : r.some((c) => c.consumableExpenses != null && c.consumableExpenses != 0)) || ((i = this.padSplits) == null ? void 0 : i.some((c) => c.consumableExpenses != null && c.consumableExpenses != 0)) : ((l = (o = this.purchaseFacts) == null ? void 0 : o.years) == null ? void 0 : l.some((c) => c.consumableExpenses != null && c.consumableExpenses != 0)) || ((d = this.raws) == null ? void 0 : d.some((c) => c.consumableExpenses != null && c.consumableExpenses != 0));
    },
    hasAnyCleaningExpenses() {
      var e, t, s, n, r, i, o, l, d;
      return this.hasShortTerm ? ((t = (e = this.purchaseFacts) == null ? void 0 : e.years) == null ? void 0 : t.some((c) => c.cleaningExpenses != null && c.cleaningExpenses != 0)) || ((s = this.shortTerms) == null ? void 0 : s.some((c) => c.cleaningExpenses != null && c.cleaningExpenses != 0)) : this.hasPadSplit ? ((r = (n = this.purchaseFacts) == null ? void 0 : n.years) == null ? void 0 : r.some((c) => c.cleaningExpenses != null && c.cleaningExpenses != 0)) || ((i = this.padSplits) == null ? void 0 : i.some((c) => c.cleaningExpenses != null && c.cleaningExpenses != 0)) : ((l = (o = this.purchaseFacts) == null ? void 0 : o.years) == null ? void 0 : l.some((c) => c.cleaningExpenses != null && c.cleaningExpenses != 0)) || ((d = this.raws) == null ? void 0 : d.some((c) => c.cleaningExpenses != null && c.cleaningExpenses != 0));
    },
    hasT12() {
      return this.mpod.length > 0;
    },
    mpod() {
      var e, t;
      return ((t = (e = this.purchaseFacts) == null ? void 0 : e.mpod) == null ? void 0 : t.filter((s) => s.year <= Et).sort((s, n) => s.year - n.year || s.month - n.month)) ?? [];
    },
    ...q(ct, ["otherExpenseAccounts", "otherIncomeAccounts", "incomeAccounts", "otherNonOperatingExpenseAccounts", "account", "isAdvancedMode"]),
    ...q(Te, ["access", "aclLoaded"]),
    ...q(qe, [
      "calculating",
      "hasShortTermResults",
      "calculatedResults",
      "calcParams",
      "firstProformaYear",
      "isLongTerm",
      "isShortTerm",
      "isPadSplit",
      "rentalTypes",
      "hasLongTerm",
      "hasShortTerm",
      "hasPadSplit",
      "purchaseFacts",
      "firstAnalyzedYear"
    ])
  },
  methods: {
    number: Ve,
    currency: Ze,
    shortCurrency: ka,
    percent: Wt,
    currencyStyle(e) {
      return {
        "last adv-annualcashflow": !0,
        positive: e > 0,
        negative: e < 0
      };
    },
    yearValues(e) {
      switch (e) {
        case Ut.LongTerm:
          return this.normalized;
        case Ut.ShortTerm:
          return this.shortTerm;
        case Ut.PadSplit:
          return this.padSplit;
      }
    },
    advancedView(e) {
      return this.isAdvancedMode ? e : e / 12;
    },
    hasAnyValues(e) {
      var t, s, n, r, i, o, l, d, c;
      return this.hasShortTerm ? ((s = (t = this.purchaseFacts) == null ? void 0 : t.years) == null ? void 0 : s.some((u) => {
        var m;
        return ((m = u.otherExpenses) == null ? void 0 : m.some((f) => f.id == e.id && f.total != null && f.total != 0)) == !0;
      })) || ((n = this.shortTerms) == null ? void 0 : n.some((u) => {
        var m;
        return ((m = u.otherExpenses) == null ? void 0 : m.some((f) => f.id == e.id && f.total != null && f.total != 0)) == !0;
      })) : this.hasPadSplit ? ((i = (r = this.purchaseFacts) == null ? void 0 : r.years) == null ? void 0 : i.some((u) => {
        var m;
        return ((m = u.otherExpenses) == null ? void 0 : m.some((f) => f.id == e.id && f.total != null && f.total != 0)) == !0;
      })) || ((o = this.padSplits) == null ? void 0 : o.some((u) => {
        var m;
        return ((m = u.otherExpenses) == null ? void 0 : m.some((f) => f.id == e.id && f.total != null && f.total != 0)) == !0;
      })) : ((d = (l = this.purchaseFacts) == null ? void 0 : l.years) == null ? void 0 : d.some((u) => {
        var m;
        return ((m = u.otherExpenses) == null ? void 0 : m.some((f) => f.id == e.id && f.total != null && f.total != 0)) == !0;
      })) || ((c = this.raws) == null ? void 0 : c.some((u) => {
        var m;
        return ((m = u.otherExpenses) == null ? void 0 : m.some((f) => f.id == e.id && f.total != null && f.total != 0)) == !0;
      }));
    },
    getOtherExpenseRaw(e) {
      var t, s, n, r;
      return (r = (n = (s = (t = this.raws) == null ? void 0 : t.find((i) => i.fiscalYear == this.firstProformaYear)) == null ? void 0 : s.otherExpenses) == null ? void 0 : n.find((i) => i.id == e)) == null ? void 0 : r.total;
    },
    getOtherExpenseNormalized(e) {
      var t, s, n, r;
      return (r = (n = (s = (t = this.normalizeds) == null ? void 0 : t.find((i) => i.fiscalYear == this.firstProformaYear)) == null ? void 0 : s.otherExpenses) == null ? void 0 : n.find((i) => i.id == e)) == null ? void 0 : r.total;
    },
    yearValuesOtherExpense(e, t) {
      var s, n, r, i, o, l, d, c, u;
      switch (t) {
        case Ut.LongTerm:
          return (r = (n = (s = this.normalized) == null ? void 0 : s.otherExpenses) == null ? void 0 : n.find((m) => m.id == e)) == null ? void 0 : r.total;
        case Ut.ShortTerm:
          return (l = (o = (i = this.shortTerm) == null ? void 0 : i.otherExpenses) == null ? void 0 : o.find((m) => m.id == e)) == null ? void 0 : l.total;
        case Ut.PadSplit:
          return (u = (c = (d = this.padSplit) == null ? void 0 : d.otherExpenses) == null ? void 0 : c.find((m) => m.id == e)) == null ? void 0 : u.total;
      }
    },
    t12(e) {
      switch (e) {
        case "effectiveIncome":
          return this.mpod.reduce((t, { effectiveIncome: s }) => t + s, 0);
        case "propertyTax":
          return this.mpod.reduce((t, { tax: s }) => t + s, 0);
        case "propertyInsurance":
          return this.mpod.reduce((t, { insurance: s }) => t + s, 0);
        case "hoa":
          return this.mpod.reduce((t, { associationFees: s }) => t + s, 0);
        case "propertyManagement":
          return this.mpod.reduce((t, { management: s }) => t + s, 0);
        case "leasingCommissions":
          return this.mpod.reduce((t, { commission: s }) => t + s, 0);
        case "platformServiceFees":
          return this.mpod.reduce((t, { platformServiceFees: s }) => t + s, 0);
        case "propertyMaintenance":
          return this.mpod.reduce((t, { maintenance: s }) => t + s, 0);
        case "utilityExpenses":
          return this.mpod.reduce((t, { utilityExpenses: s }) => t + s, 0);
        case "otherExpense":
          return this.mpod.reduce((t, { otherExpense: s }) => t + s, 0);
        case "furnishingExpenses":
          return this.mpod.reduce((t, { furnishingExpenses: s }) => t + s, 0);
        case "consumableExpenses":
          return this.mpod.reduce((t, { consumableExpenses: s }) => t + s, 0);
        case "cleaningExpenses":
          return this.mpod.reduce((t, { cleaningExpenses: s }) => t + s, 0);
        case "totalExpenses":
          return this.mpod.reduce((t, { totalOperatingExpenses: s }) => t + s, 0);
        case "noi":
          return this.mpod.reduce((t, { netOperatingIncome: s }) => t + s, 0);
        case "annualDebtService":
          return this.mpod.reduce((t, { debtService: s }) => t + s, 0);
        case "capitalExpenditures":
          return this.mpod.reduce((t, { capitalExpenditures: s }) => t + s, 0);
        case "totalNonOperatingExpenses":
          return this.mpod.reduce((t, { totalNonOperatingExpenses: s }) => t + s, 0);
        case "annualCashFlow":
          return this.mpod.reduce((t, { cashFlow: s }) => t + s, 0);
      }
    },
    getOtherExpenseT12(e) {
      return this.mpod.reduce((t, { otherExpenses: s }) => {
        var n;
        return t + (((n = s == null ? void 0 : s.find((r) => r.id == e)) == null ? void 0 : n.total) ?? 0);
      }, 0);
    }
  }
}), kqe = { class: "card-header bg-eclipse text-white rounded rounded-bottom-0 fw-bold text-center text-sm-start" }, Eqe = { class: "card-body p-0 position-relative overflow-hidden" }, Iqe = {
  key: 0,
  class: "calculating-animation position-absolute top-50 start-50 translate-middle text-center"
}, Tqe = { class: "table-wrap table-data" }, Oqe = {
  key: 0,
  class: "text-end"
}, Rqe = {
  scope: "col",
  class: "norm text-center"
}, Lqe = {
  scope: "col",
  class: "text-center"
}, Bqe = {
  scope: "col",
  class: "norm text-center"
}, Mqe = ["colspan"], xqe = { class: "tb-space" }, Fqe = { rel: "grosspotential" }, Vqe = { key: 0 }, Dqe = { key: 0 }, Nqe = { class: "table-total table-divider" }, jqe = { rel: "eri" }, Hqe = { key: 0 }, Uqe = ["colspan"], zqe = { class: "tb-space" }, Wqe = { key: 0 }, Gqe = { key: 0 }, Yqe = { key: 0 }, Xqe = { key: 0 }, qqe = { key: 0 }, Qqe = { key: 0 }, Kqe = { key: 0 }, Zqe = { key: 0 }, Jqe = { key: 0 }, $qe = { key: 0 }, _qe = { key: 1 }, eQe = { key: 0 }, tQe = { key: 2 }, sQe = { key: 0 }, aQe = { key: 3 }, nQe = { key: 0 }, rQe = { key: 0 }, oQe = { rel: "cleaningExpenses" }, iQe = { key: 0 }, lQe = { class: "table-divider" }, dQe = { key: 0 }, cQe = { class: "tb-space" }, uQe = { class: "table-total styled-dark-finances fw-bold" }, pQe = {
  key: 0,
  class: "fw-bold"
}, hQe = { class: "fw-bold" }, mQe = ["colspan"], fQe = { class: "tb-space" }, gQe = { rel: "annualdebtservice" }, vQe = {
  key: 0,
  class: "fw-bold"
}, yQe = {
  key: 0,
  class: "fw-bold"
}, bQe = { class: "last" }, AQe = { class: "table-total table-divider" }, wQe = {
  key: 0,
  class: "fw-bold"
}, CQe = { class: "norm fw-bold" }, SQe = { class: "table-total styled-dark-finances fw-bold" }, PQe = {
  key: 0,
  class: "fw-bold"
}, kQe = { class: "norm fw-bold" };
function EQe(e, t, s, n, r, i) {
  return p(), h("div", {
    class: z(e.calculatingClasses)
  }, [
    a("div", kqe, [
      e.hasT12 ? (p(), h(A, { key: 0 }, [
        y(" CASH FLOW ")
      ], 64)) : e.isAdvancedMode ? (p(), h(A, { key: 1 }, [
        y(" CASH FLOW YEAR " + g(e.raw.fiscalYear), 1)
      ], 64)) : (p(), h(A, { key: 2 }, [
        y(" MONTHLY CASH FLOW ")
      ], 64))
    ]),
    a("div", Eqe, [
      e.calculating ? (p(), h("div", Iqe, t[0] || (t[0] = [
        a("i", { class: "fa-duotone fa-solid fa-compass fa-spin fa-lg text-eclipse" }, null, -1),
        a("br", null, null, -1),
        a("small", null, "Calculating", -1)
      ]))) : P("", !0),
      a("div", Tqe, [
        a("table", {
          class: z(e.mainTableStyle)
        }, [
          a("thead", null, [
            e.isAdvancedMode && e.isOnlyLongTerm || e.rentalTypes.length > 1 ? (p(), h("tr", Oqe, [
              t[1] || (t[1] = a("th", { scope: "col" }, " ", -1)),
              e.isOnlyLongTerm ? (p(), h(A, { key: 0 }, [
                a("th", Rqe, [
                  e.hasT12 ? (p(), h(A, { key: 0 }, [
                    y(" T-12 ")
                  ], 64)) : (p(), h(A, { key: 1 }, [
                    y(" Raw ")
                  ], 64))
                ]),
                a("th", Lqe, [
                  e.hasT12 ? (p(), h(A, { key: 0 }, [
                    y(" Proforma ")
                  ], 64)) : (p(), h(A, { key: 1 }, [
                    y(" Normalized ")
                  ], 64))
                ])
              ], 64)) : (p(!0), h(A, { key: 1 }, D(e.rentalTypes, (o) => (p(), h("th", Bqe, [
                o == "long-term" ? (p(), h(A, { key: 0 }, [
                  y(" Long Term ")
                ], 64)) : o == "short-term" ? (p(), h(A, { key: 1 }, [
                  y(" Short Term ")
                ], 64)) : o == "pad-split" ? (p(), h(A, { key: 2 }, [
                  y(" PadSplit ")
                ], 64)) : P("", !0)
              ]))), 256))
            ])) : P("", !0),
            a("tr", null, [
              a("th", {
                colspan: e.colSpan,
                class: "table-alice fw-bold"
              }, " INCOME ", 8, Mqe)
            ])
          ]),
          a("tbody", xqe, [
            a("tr", null, [
              a("th", Fqe, [
                e.isAdvancedMode ? (p(), h(A, { key: 0 }, [
                  y(" Gross Potential Income ")
                ], 64)) : (p(), h(A, { key: 1 }, [
                  y(" Potential Rental Income ")
                ], 64))
              ]),
              e.isOnlyLongTerm ? (p(), h(A, { key: 0 }, [
                e.isAdvancedMode ? (p(), h("td", Vqe, [
                  e.hasT12 ? (p(), h(A, { key: 0 }, [
                    y(g(e.currency(e.t12("effectiveIncome"))), 1)
                  ], 64)) : (p(), h(A, { key: 1 }, [
                    y(g(e.currency(e.raw.grossPotential)), 1)
                  ], 64))
                ])) : P("", !0),
                a("td", null, g(e.currency(e.advancedView(e.normalized.grossPotential))), 1)
              ], 64)) : (p(!0), h(A, { key: 1 }, D(e.rentalTypes, (o) => (p(), h("td", null, g(e.currency(e.advancedView(e.yearValues(o).grossPotential))), 1))), 256))
            ]),
            a("tr", null, [
              t[2] || (t[2] = a("th", { rel: "vacancyloss" }, " Vacancy Loss", -1)),
              e.isOnlyLongTerm ? (p(), h(A, { key: 0 }, [
                e.isAdvancedMode ? (p(), h("td", Dqe, [
                  e.hasT12 ? (p(), h(A, { key: 0 }, [], 64)) : (p(), h(A, { key: 1 }, [
                    y(g(e.currency(-(e.raw.vacancyLoss + e.raw.rehabVacancyLoss))), 1)
                  ], 64))
                ])) : P("", !0),
                a("td", null, g(e.currency(e.advancedView(-(e.normalized.vacancyLoss + e.normalized.rehabVacancyLoss)))), 1)
              ], 64)) : (p(!0), h(A, { key: 1 }, D(e.rentalTypes, (o) => (p(), h("td", null, g(e.currency(-e.advancedView(e.yearValues(o).vacancyLoss + e.yearValues(o).rehabVacancyLoss))), 1))), 256))
            ]),
            a("tr", Nqe, [
              a("th", jqe, [
                e.isAdvancedMode ? (p(), h(A, { key: 0 }, [
                  y(" Effective Rental Income ")
                ], 64)) : (p(), h(A, { key: 1 }, [
                  y(" Effective Income ")
                ], 64))
              ]),
              e.isOnlyLongTerm ? (p(), h(A, { key: 0 }, [
                e.isAdvancedMode ? (p(), h("th", Hqe, [
                  e.hasT12 ? (p(), h(A, { key: 0 }, [
                    y(g(e.currency(e.t12("effectiveIncome"))), 1)
                  ], 64)) : (p(), h(A, { key: 1 }, [
                    y(g(e.currency(e.raw.effectiveIncome)), 1)
                  ], 64))
                ])) : P("", !0),
                a("th", null, g(e.currency(e.advancedView(e.normalized.effectiveIncome))), 1)
              ], 64)) : (p(!0), h(A, { key: 1 }, D(e.rentalTypes, (o) => (p(), h("th", null, g(e.currency(e.advancedView(e.yearValues(o).effectiveIncome))), 1))), 256))
            ])
          ]),
          a("thead", null, [
            a("tr", null, [
              a("th", {
                colspan: e.colSpan,
                class: "table-alice fw-bold"
              }, " OPERATING EXPENSES ", 8, Uqe)
            ])
          ]),
          a("tbody", zqe, [
            a("tr", null, [
              t[3] || (t[3] = a("th", { rel: "propertytax" }, "Property Tax", -1)),
              e.isOnlyLongTerm ? (p(), h(A, { key: 0 }, [
                e.isAdvancedMode ? (p(), h("td", Wqe, [
                  e.hasT12 ? (p(), h(A, { key: 0 }, [
                    y(g(e.currency(e.t12("propertyTax"))), 1)
                  ], 64)) : (p(), h(A, { key: 1 }, [
                    y(g(e.currency(e.raw.propertyTax)), 1)
                  ], 64))
                ])) : P("", !0),
                a("td", null, g(e.currency(e.advancedView(e.normalized.propertyTax))), 1)
              ], 64)) : (p(!0), h(A, { key: 1 }, D(e.rentalTypes, (o) => (p(), h("td", null, g(e.currency(e.advancedView(e.yearValues(o).propertyTax))), 1))), 256))
            ]),
            a("tr", null, [
              t[4] || (t[4] = a("th", { rel: "propertyinsurance" }, "Property Insurance", -1)),
              e.isOnlyLongTerm ? (p(), h(A, { key: 0 }, [
                e.isAdvancedMode ? (p(), h("td", Gqe, [
                  e.hasT12 ? (p(), h(A, { key: 0 }, [
                    y(g(e.currency(e.t12("propertyInsurance"))), 1)
                  ], 64)) : (p(), h(A, { key: 1 }, [
                    y(g(e.currency(e.raw.propertyInsurance)), 1)
                  ], 64))
                ])) : P("", !0),
                a("td", null, g(e.currency(e.advancedView(e.normalized.propertyInsurance))), 1)
              ], 64)) : (p(!0), h(A, { key: 1 }, D(e.rentalTypes, (o) => (p(), h("td", null, g(e.currency(e.advancedView(e.yearValues(o).propertyInsurance))), 1))), 256))
            ]),
            a("tr", null, [
              t[5] || (t[5] = a("th", { rel: "hoa" }, "HOA", -1)),
              e.isOnlyLongTerm ? (p(), h(A, { key: 0 }, [
                e.isAdvancedMode ? (p(), h("td", Yqe, [
                  e.hasT12 ? (p(), h(A, { key: 0 }, [
                    y(g(e.currency(e.t12("hoa"))), 1)
                  ], 64)) : (p(), h(A, { key: 1 }, [
                    y(g(e.currency(e.raw.hoa)), 1)
                  ], 64))
                ])) : P("", !0),
                a("td", null, g(e.currency(e.advancedView(e.normalized.hoa))), 1)
              ], 64)) : (p(!0), h(A, { key: 1 }, D(e.rentalTypes, (o) => (p(), h("td", null, g(e.currency(e.advancedView(e.yearValues(o).hoa))), 1))), 256))
            ]),
            a("tr", null, [
              t[6] || (t[6] = a("th", { rel: "propertymanagement" }, "Property Management", -1)),
              e.isOnlyLongTerm ? (p(), h(A, { key: 0 }, [
                e.isAdvancedMode ? (p(), h("td", Xqe, [
                  e.hasT12 ? (p(), h(A, { key: 0 }, [
                    y(g(e.currency(e.t12("propertyManagement"))), 1)
                  ], 64)) : (p(), h(A, { key: 1 }, [
                    y(g(e.currency(e.raw.propertyManagement)), 1)
                  ], 64))
                ])) : P("", !0),
                a("td", null, g(e.currency(e.advancedView(e.normalized.propertyManagement))), 1)
              ], 64)) : (p(!0), h(A, { key: 1 }, D(e.rentalTypes, (o) => (p(), h("td", null, g(e.currency(e.advancedView(e.yearValues(o).propertyManagement))), 1))), 256))
            ]),
            a("tr", null, [
              t[7] || (t[7] = a("th", { rel: "leasingcommissions" }, "Leasing Commissions", -1)),
              e.isOnlyLongTerm ? (p(), h(A, { key: 0 }, [
                e.isAdvancedMode ? (p(), h("td", qqe, [
                  e.hasT12 ? (p(), h(A, { key: 0 }, [
                    y(g(e.currency(e.t12("leasingCommissions"))), 1)
                  ], 64)) : (p(), h(A, { key: 1 }, [
                    y(g(e.currency(e.raw.leasingCommissions)), 1)
                  ], 64))
                ])) : P("", !0),
                a("td", null, g(e.currency(e.advancedView(e.normalized.leasingCommissions))), 1)
              ], 64)) : (p(!0), h(A, { key: 1 }, D(e.rentalTypes, (o) => (p(), h("td", null, g(e.currency(e.advancedView(e.yearValues(o).leasingCommissions))), 1))), 256))
            ]),
            e.hasAnyPlatformServiceFees ? (p(), h("tr", Qqe, [
              t[8] || (t[8] = a("th", { rel: "platformServiceFees" }, "Platform/Booking Fees", -1)),
              e.isOnlyLongTerm ? (p(), h(A, { key: 0 }, [
                e.isAdvancedMode ? (p(), h("td", Kqe, [
                  e.hasT12 ? (p(), h(A, { key: 0 }, [
                    y(g(e.currency(e.t12("platformServiceFees"))), 1)
                  ], 64)) : (p(), h(A, { key: 1 }, [
                    y(g(e.currency(e.raw.platformServiceFees)), 1)
                  ], 64))
                ])) : P("", !0),
                a("td", null, g(e.currency(e.advancedView(e.normalized.platformServiceFees))), 1)
              ], 64)) : (p(!0), h(A, { key: 1 }, D(e.rentalTypes, (o) => (p(), h("td", null, g(e.currency(e.advancedView(e.yearValues(o).platformServiceFees))), 1))), 256))
            ])) : P("", !0),
            a("tr", null, [
              t[9] || (t[9] = a("th", { rel: "propertymaintenance" }, "Property Maintenance", -1)),
              e.isOnlyLongTerm ? (p(), h(A, { key: 0 }, [
                e.isAdvancedMode ? (p(), h("td", Zqe, [
                  e.hasT12 ? (p(), h(A, { key: 0 }, [
                    y(g(e.currency(e.t12("propertyMaintenance"))), 1)
                  ], 64)) : (p(), h(A, { key: 1 }, [
                    y(g(e.currency(e.raw.propertyMaintenance)), 1)
                  ], 64))
                ])) : P("", !0),
                a("td", null, g(e.currency(e.advancedView(e.normalized.propertyMaintenance))), 1)
              ], 64)) : (p(!0), h(A, { key: 1 }, D(e.rentalTypes, (o) => (p(), h("td", null, g(e.currency(e.advancedView(e.yearValues(o).propertyMaintenance))), 1))), 256))
            ]),
            a("tr", null, [
              t[10] || (t[10] = a("th", { rel: "utilityExpenses" }, "Utility Expenses", -1)),
              e.isOnlyLongTerm ? (p(), h(A, { key: 0 }, [
                e.isAdvancedMode ? (p(), h("td", Jqe, [
                  e.hasT12 ? (p(), h(A, { key: 0 }, [
                    y(g(e.currency(e.t12("utilityExpenses"))), 1)
                  ], 64)) : (p(), h(A, { key: 1 }, [
                    y(g(e.currency(e.raw.utilityExpenses)), 1)
                  ], 64))
                ])) : P("", !0),
                a("td", null, g(e.currency(e.advancedView(e.normalized.utilityExpenses))), 1)
              ], 64)) : (p(!0), h(A, { key: 1 }, D(e.rentalTypes, (o) => (p(), h("td", null, g(e.currency(e.advancedView(e.yearValues(o).utilityExpenses))), 1))), 256))
            ]),
            a("tr", null, [
              t[11] || (t[11] = a("th", { rel: "otherExpense" }, "Other Expenses", -1)),
              e.isOnlyLongTerm ? (p(), h(A, { key: 0 }, [
                e.isAdvancedMode ? (p(), h("td", $qe, [
                  e.hasT12 ? (p(), h(A, { key: 0 }, [
                    y(g(e.currency(e.t12("otherExpense"))), 1)
                  ], 64)) : (p(), h(A, { key: 1 }, [
                    y(g(e.currency(e.raw.otherExpense)), 1)
                  ], 64))
                ])) : P("", !0),
                a("td", null, g(e.currency(e.advancedView(e.normalized.otherExpense))), 1)
              ], 64)) : (p(!0), h(A, { key: 1 }, D(e.rentalTypes, (o) => (p(), h("td", null, g(e.currency(e.advancedView(e.yearValues(o).otherExpense))), 1))), 256))
            ]),
            e.hasAnyFurnishingExpenses ? (p(), h("tr", _qe, [
              t[12] || (t[12] = a("th", { rel: "furnishingExpenses" }, "Furnishing Expenses", -1)),
              e.isOnlyLongTerm ? (p(), h(A, { key: 0 }, [
                e.isAdvancedMode ? (p(), h("td", eQe, [
                  e.hasT12 ? (p(), h(A, { key: 0 }, [
                    y(g(e.currency(e.t12("furnishingExpenses"))), 1)
                  ], 64)) : (p(), h(A, { key: 1 }, [
                    y(g(e.currency(e.raw.furnishingExpenses)), 1)
                  ], 64))
                ])) : P("", !0),
                a("td", null, g(e.currency(e.advancedView(e.normalized.furnishingExpenses))), 1)
              ], 64)) : (p(!0), h(A, { key: 1 }, D(e.rentalTypes, (o) => (p(), h("td", null, g(e.currency(e.advancedView(e.yearValues(o).furnishingExpenses))), 1))), 256))
            ])) : P("", !0),
            e.hasAnyConsumableExpenses ? (p(), h("tr", tQe, [
              t[13] || (t[13] = a("th", { rel: "consumableExpenses" }, "Consumable Expenses", -1)),
              e.isOnlyLongTerm ? (p(), h(A, { key: 0 }, [
                e.isAdvancedMode ? (p(), h("td", sQe, [
                  e.hasT12 ? (p(), h(A, { key: 0 }, [
                    y(g(e.currency(e.t12("consumableExpenses"))), 1)
                  ], 64)) : (p(), h(A, { key: 1 }, [
                    y(g(e.currency(e.raw.consumableExpenses)), 1)
                  ], 64))
                ])) : P("", !0),
                a("td", null, g(e.currency(e.advancedView(e.normalized.consumableExpenses))), 1)
              ], 64)) : (p(!0), h(A, { key: 1 }, D(e.rentalTypes, (o) => (p(), h("td", null, g(e.currency(e.advancedView(e.yearValues(o).consumableExpenses))), 1))), 256))
            ])) : P("", !0),
            e.hasAnyCleaningExpenses ? (p(), h("tr", aQe, [
              t[14] || (t[14] = a("th", { rel: "cleaningExpenses" }, "Cleaning Expenses", -1)),
              e.isOnlyLongTerm ? (p(), h(A, { key: 0 }, [
                e.isAdvancedMode ? (p(), h("td", nQe, [
                  e.hasT12 ? (p(), h(A, { key: 0 }, [
                    y(g(e.currency(e.t12("cleaningExpenses"))), 1)
                  ], 64)) : (p(), h(A, { key: 1 }, [
                    y(g(e.currency(e.raw.cleaningExpenses)), 1)
                  ], 64))
                ])) : P("", !0),
                a("td", null, g(e.currency(e.advancedView(e.normalized.cleaningExpenses))), 1)
              ], 64)) : (p(!0), h(A, { key: 1 }, D(e.rentalTypes, (o) => (p(), h("td", null, g(e.currency(e.advancedView(e.yearValues(o).cleaningExpenses))), 1))), 256))
            ])) : P("", !0),
            (p(!0), h(A, null, D(e.otherExpenseAccounts, (o) => (p(), h(A, null, [
              e.hasAnyValues(o) ? (p(), h("tr", rQe, [
                a("th", oQe, g(o.name), 1),
                e.isOnlyLongTerm ? (p(), h(A, { key: 0 }, [
                  e.isAdvancedMode ? (p(), h("td", iQe, [
                    e.hasT12 ? (p(), h(A, { key: 0 }, [
                      y(g(e.currency(e.getOtherExpenseT12(o.id))), 1)
                    ], 64)) : (p(), h(A, { key: 1 }, [
                      y(g(e.currency(e.getOtherExpenseRaw(o.id))), 1)
                    ], 64))
                  ])) : P("", !0),
                  a("td", null, g(e.currency(e.advancedView(e.getOtherExpenseNormalized(o.id)))), 1)
                ], 64)) : (p(!0), h(A, { key: 1 }, D(e.rentalTypes, (l) => (p(), h("td", null, g(e.currency(e.advancedView(e.yearValuesOtherExpense(o.id, l)))), 1))), 256))
              ])) : P("", !0)
            ], 64))), 256)),
            a("tr", lQe, [
              t[15] || (t[15] = a("th", { rel: "totalExpenses fw-bold" }, [
                a("strong", null, "Total Expenses")
              ], -1)),
              e.isOnlyLongTerm ? (p(), h(A, { key: 0 }, [
                e.isAdvancedMode ? (p(), h("th", dQe, [
                  e.hasT12 ? (p(), h(A, { key: 0 }, [
                    y(g(e.currency(e.t12("totalExpenses"))), 1)
                  ], 64)) : (p(), h(A, { key: 1 }, [
                    y(g(e.currency(e.raw.totalExpenses)), 1)
                  ], 64))
                ])) : P("", !0),
                a("th", null, g(e.currency(e.advancedView(e.normalized.totalExpenses))), 1)
              ], 64)) : (p(!0), h(A, { key: 1 }, D(e.rentalTypes, (o) => (p(), h("td", null, g(e.currency(e.advancedView(e.yearValues(o).totalExpenses))), 1))), 256))
            ])
          ]),
          a("tbody", cQe, [
            a("tr", uQe, [
              t[16] || (t[16] = a("th", { rel: "noi" }, " Net Operating Income ", -1)),
              e.isOnlyLongTerm ? (p(), h(A, { key: 0 }, [
                e.isAdvancedMode ? (p(), h("td", pQe, [
                  e.hasT12 ? (p(), h("div", {
                    key: 0,
                    class: z(e.currencyStyle(e.t12("noi")))
                  }, g(e.currency(e.t12("noi"))), 3)) : (p(), h("div", {
                    key: 1,
                    class: z(e.currencyStyle(e.raw.noi))
                  }, g(e.currency(e.raw.noi)), 3))
                ])) : P("", !0),
                a("td", hQe, [
                  a("div", {
                    class: z(e.currencyStyle(e.normalized.noi))
                  }, g(e.currency(e.advancedView(e.normalized.noi))), 3)
                ])
              ], 64)) : (p(!0), h(A, { key: 1 }, D(e.rentalTypes, (o) => (p(), h("td", null, [
                a("div", {
                  class: z(e.currencyStyle(e.yearValues(o).noi))
                }, g(e.currency(e.advancedView(e.yearValues(o).noi))), 3)
              ]))), 256))
            ])
          ]),
          a("thead", null, [
            a("tr", null, [
              a("th", {
                colspan: e.colSpan,
                class: "table-alice fw-bold"
              }, " NON OPERATING EXPENSES ", 8, mQe)
            ])
          ]),
          a("tbody", fQe, [
            a("tr", null, [
              a("th", gQe, [
                e.isAdvancedMode ? (p(), h(A, { key: 0 }, [
                  y(" Annual ")
                ], 64)) : (p(), h(A, { key: 1 }, [
                  y(" Monthly ")
                ], 64)),
                t[17] || (t[17] = y(" Debt Service "))
              ]),
              e.isOnlyLongTerm ? (p(), h(A, { key: 0 }, [
                e.isAdvancedMode ? (p(), h("td", vQe, [
                  e.hasT12 ? (p(), h(A, { key: 0 }, [
                    y(g(e.currency(e.t12("annualDebtService"))), 1)
                  ], 64)) : (p(), h(A, { key: 1 }, [
                    y(g(e.currency(e.raw.annualDebtService)), 1)
                  ], 64))
                ])) : P("", !0),
                a("td", null, g(e.currency(e.advancedView(e.normalized.annualDebtService))), 1)
              ], 64)) : (p(!0), h(A, { key: 1 }, D(e.rentalTypes, (o) => (p(), h("td", null, g(e.currency(e.advancedView(e.yearValues(o).annualDebtService))), 1))), 256))
            ]),
            a("tr", null, [
              t[18] || (t[18] = a("th", { rel: "capitalExpenditures" }, "Capital Expenditures", -1)),
              e.isOnlyLongTerm ? (p(), h(A, { key: 0 }, [
                e.isAdvancedMode ? (p(), h("td", yQe, [
                  e.hasT12 ? (p(), h(A, { key: 0 }, [
                    y(g(e.currency(e.t12("capitalExpenditures"))), 1)
                  ], 64)) : (p(), h(A, { key: 1 }, [
                    y(g(e.currency(e.raw.capitalExpenditures)), 1)
                  ], 64))
                ])) : P("", !0),
                a("td", null, [
                  a("div", bQe, g(e.currency(e.advancedView(e.normalized.capitalExpenditures))), 1)
                ])
              ], 64)) : (p(!0), h(A, { key: 1 }, D(e.rentalTypes, (o) => (p(), h("td", null, g(e.currency(e.advancedView(e.yearValues(o).capitalExpenditures))), 1))), 256))
            ]),
            a("tr", AQe, [
              t[19] || (t[19] = a("th", { rel: "totalNonOperatingExpenses" }, " Total Non Operating Expenses ", -1)),
              e.isOnlyLongTerm ? (p(), h(A, { key: 0 }, [
                e.isAdvancedMode ? (p(), h("th", wQe, [
                  e.hasT12 ? (p(), h(A, { key: 0 }, [
                    y(g(e.currency(e.t12("totalNonOperatingExpenses"))), 1)
                  ], 64)) : (p(), h(A, { key: 1 }, [
                    y(g(e.currency(e.raw.totalNonOperatingExpenses)), 1)
                  ], 64))
                ])) : P("", !0),
                a("th", CQe, g(e.currency(e.advancedView(e.raw.totalNonOperatingExpenses))), 1)
              ], 64)) : (p(!0), h(A, { key: 1 }, D(e.rentalTypes, (o) => (p(), h("td", null, g(e.currency(e.advancedView(e.yearValues(o).totalNonOperatingExpenses))), 1))), 256))
            ])
          ]),
          a("tbody", null, [
            a("tr", SQe, [
              t[20] || (t[20] = a("th", { rel: "annualcashflow" }, [
                a("strong", null, " Total Cash Flow ")
              ], -1)),
              e.isOnlyLongTerm ? (p(), h(A, { key: 0 }, [
                e.isAdvancedMode ? (p(), h("th", PQe, [
                  e.hasT12 ? (p(), h("div", {
                    key: 0,
                    class: z(e.currencyStyle(e.t12("annualCashFlow")))
                  }, g(e.currency(e.t12("annualCashFlow"))), 3)) : (p(), h("div", {
                    key: 1,
                    class: z(e.currencyStyle(e.raw.annualCashFlow))
                  }, g(e.currency(e.raw.annualCashFlow)), 3))
                ])) : P("", !0),
                a("th", kQe, [
                  a("div", {
                    class: z(e.currencyStyle(e.normalized.annualCashFlow))
                  }, g(e.currency(e.advancedView(e.normalized.annualCashFlow))), 3)
                ])
              ], 64)) : (p(!0), h(A, { key: 1 }, D(e.rentalTypes, (o) => (p(), h("td", null, [
                a("div", {
                  class: z(e.currencyStyle(e.yearValues(o).annualCashFlow))
                }, g(e.currency(e.advancedView(e.yearValues(o).annualCashFlow))), 3)
              ]))), 256))
            ])
          ])
        ], 2)
      ])
    ])
  ], 2);
}
const IQe = /* @__PURE__ */ Ae(Pqe, [["render", EQe]]);
function so(e, t = 4, s = !1) {
  return {
    proforma: e.isProformaYear == !1,
    premium: s ? e.year == t : e.year > t
  };
}
const TQe = me({
  name: "FinancialOverview",
  emits: [
    "infoPopover"
  ],
  computed: {
    calculatingClasses() {
      return {
        card: !0,
        "card-financial-overview": !0,
        "shadow-sm": !0,
        "card-proforma": !0,
        calculating: this.calculating,
        "card-guarded": this.haveAccess == !1
      };
    },
    haveAccess() {
      var e, t;
      return this.isMarketplace || ((t = (e = this.acl) == null ? void 0 : e.properties) == null ? void 0 : t.financialAnalysis) == !0;
    },
    isAdvancedMode() {
      var e;
      return ((e = this.account) == null ? void 0 : e.defaultAnalysisMode) == Hn.Advanced;
    },
    yearsToShow() {
      return this.isAdvancedMode ? 30 : 5;
    },
    mainTableStyle() {
      return {
        table: !0,
        "table-sm": !0,
        "text-small": !0,
        "mode-basic": this.isAdvancedMode != !0,
        "mode-advanced": this.isAdvancedMode == !0
      };
    },
    yearRentalTypeValues() {
      var e, t, s, n, r, i;
      switch (this.calcParams.rentalType) {
        case Ut.LongTerm:
          return (t = (e = this.calculatedResults) == null ? void 0 : e.normalized) == null ? void 0 : t.filter((o) => o.fiscalYear >= this.firstTableYear).sort((o, l) => o.fiscalYear - l.fiscalYear).slice(0, this.yearsToShow);
        case Ut.ShortTerm:
          return (n = (s = this.calculatedResults) == null ? void 0 : s.shortTerm) == null ? void 0 : n.filter((o) => o.fiscalYear >= this.firstTableYear).sort((o, l) => o.fiscalYear - l.fiscalYear).slice(0, this.yearsToShow);
        case Ut.PadSplit:
          return (i = (r = this.calculatedResults) == null ? void 0 : r.padSplit) == null ? void 0 : i.filter((o) => o.fiscalYear >= this.firstTableYear).sort((o, l) => o.fiscalYear - l.fiscalYear).slice(0, this.yearsToShow);
      }
    },
    ...q(ct, ["account"]),
    ...q(Te, ["acl"]),
    ...q(qe, ["calculating", "calcParams", "calculatedResults", "isMarketplace", "isPadSplit", "firstAnalyzedYear", "firstTableYear"])
  },
  methods: {
    number: Ve,
    currency: Ze,
    shortNumber: vr,
    shortCurrency: ka,
    analysisYearStyle: so,
    infoPopover(e) {
      this.$emit("infoPopover", e);
    }
  }
}), OQe = { class: "card-body p-0 position-relative overflow-hidden" }, RQe = {
  key: 0,
  class: "calculating-animation position-absolute top-50 start-50 translate-middle text-center"
}, LQe = { class: "table-wrap table-data" }, BQe = ["data-access"], MQe = { class: "text-end" }, xQe = ["data-year"], FQe = { rel: "propertyvalue" }, VQe = ["data-year"], DQe = ["title"], NQe = ["data-year"], jQe = ["title"], HQe = { rel: "rentalRate" }, UQe = ["data-year"], zQe = ["title"], WQe = { rel: "monthlycashflow" }, GQe = ["data-year"], YQe = ["title"], XQe = { rel: "grossWealthAccumulation" }, qQe = ["data-year"], QQe = ["title"], KQe = { rel: "netgaininvestment" }, ZQe = ["data-year"], JQe = ["title"], $Qe = {
  key: 1,
  class: "d-flex justify-content-between shadow m-2 mt-xxl-2 m-xxl-4 flex-shrink-0 bg-gradient-periwinkle card-guard rounded-4 p-3 text-center order-last order-sm-first d-flex flex-row align-items-center gap-3"
};
function _Qe(e, t, s, n, r, i) {
  return p(), h("div", {
    class: z(e.calculatingClasses)
  }, [
    t[18] || (t[18] = a("div", { class: "card-header bg-eclipse text-white rounded rounded-bottom-0 fw-bold text-center text-sm-start" }, " FINANCIAL OVERVIEW ", -1)),
    a("div", OQe, [
      e.calculating ? (p(), h("div", RQe, t[5] || (t[5] = [
        a("i", { class: "fa-duotone fa-solid fa-compass fa-spin fa-lg text-eclipse" }, null, -1),
        a("br", null, null, -1),
        a("small", null, "Calculating", -1)
      ]))) : P("", !0),
      a("div", LQe, [
        a("table", {
          class: z(e.mainTableStyle),
          "data-access": !e.haveAccess
        }, [
          a("thead", null, [
            a("tr", MQe, [
              t[6] || (t[6] = a("th", null, " ", -1)),
              (p(!0), h(A, null, D(e.yearRentalTypeValues, (o) => (p(), h("th", {
                class: z(["table-column", e.analysisYearStyle(o)]),
                "data-year": o.year
              }, [
                o.fiscalYear ? (p(), h(A, { key: 0 }, [
                  y(g(o.fiscalYear), 1)
                ], 64)) : (p(), h(A, { key: 1 }, [
                  y(" Year " + g(o.year), 1)
                ], 64))
              ], 10, xQe))), 256))
            ])
          ]),
          a("tbody", null, [
            a("tr", null, [
              a("th", FQe, [
                t[7] || (t[7] = y(" Property Value")),
                a("i", {
                  class: "fa-light fa-question-circle ms-2 info-pop",
                  onClick: t[0] || (t[0] = (...o) => e.infoPopover && e.infoPopover(...o)),
                  "data-title": "Property Value & Appreciation",
                  "data-html": "true",
                  "data-render": "true",
                  "data-pop": "propertyValue"
                }),
                t[8] || (t[8] = a("div", { class: "d-none info-pop-propertyValue" }, [
                  a("p", null, [
                    y("The property value displayed in this table shows the expected appreciation you will realize over the next 30 years. "),
                    a("br"),
                    a("br"),
                    y("The "),
                    a("b", null, "Annual Property Appreciation %"),
                    y(" specified on the model tab is the amount that the estimated property value grows by each year.")
                  ])
                ], -1))
              ]),
              (p(!0), h(A, null, D(e.yearRentalTypeValues, (o) => (p(), h("td", {
                class: z(["table-column", e.analysisYearStyle(o)]),
                "data-year": o.year
              }, [
                a("div", {
                  class: "table-content table-grey adv-propertyvalue",
                  title: e.currency(o.propertyValue)
                }, g(e.shortCurrency(o.propertyValue)), 9, DQe)
              ], 10, VQe))), 256))
            ]),
            a("tr", null, [
              t[9] || (t[9] = a("th", { rel: "totalAppreciation" }, " Appreciation ", -1)),
              (p(!0), h(A, null, D(e.yearRentalTypeValues, (o) => (p(), h("td", {
                class: z(["table-column", e.analysisYearStyle(o)]),
                "data-year": o.year
              }, [
                a("div", {
                  class: "table-content table-grey adv-totalAppreciation",
                  title: e.currency(o.totalAppreciation)
                }, g(e.shortCurrency(o.totalAppreciation)), 9, jQe)
              ], 10, NQe))), 256))
            ]),
            a("tr", null, [
              a("th", HQe, [
                e.isPadSplit ? (p(), h(A, { key: 1 }, [
                  y(" Average Weekly Rate ")
                ], 64)) : (p(), h(A, { key: 0 }, [
                  y(" Rental Rate ")
                ], 64)),
                a("i", {
                  class: "fa-light fa-question-circle ms-2 info-pop",
                  onClick: t[1] || (t[1] = (...o) => e.infoPopover && e.infoPopover(...o)),
                  "data-title": "Rental Rate & Escalations",
                  "data-html": "true",
                  "data-render": "true",
                  "data-pop": "rentalRate"
                }),
                t[10] || (t[10] = a("div", { class: "d-none info-pop-rentalRate" }, [
                  a("p", null, [
                    y(" The rental rate displayed in this table shows the expected future rental rates you will achieve over the next 30 years."),
                    a("br"),
                    a("br"),
                    y("The Annual Rental Growth Rate specified on the model tab is the amount that the estimated rental rate grows by each year. ")
                  ])
                ], -1))
              ]),
              (p(!0), h(A, null, D(e.yearRentalTypeValues, (o) => (p(), h("td", {
                class: z(["table-column", e.analysisYearStyle(o)]),
                "data-year": o.year
              }, [
                a("div", {
                  class: "table-content table-grey adv-rentalRate",
                  title: e.currency(o.rentalRate)
                }, g(e.shortCurrency(o.rentalRate)), 9, zQe)
              ], 10, UQe))), 256))
            ]),
            a("tr", null, [
              a("th", WQe, [
                t[11] || (t[11] = y(" Monthly Cash Flow")),
                a("i", {
                  class: "fa-light fa-question-circle ms-2 info-pop",
                  onClick: t[2] || (t[2] = (...o) => e.infoPopover && e.infoPopover(...o)),
                  "data-title": "Monthly Cash Flow",
                  "data-html": "true",
                  "data-render": "true",
                  "data-pop": "monthlyCashFlow"
                }),
                t[12] || (t[12] = a("div", { class: "d-none info-pop-monthlyCashFlow" }, [
                  a("p", null, " Monthly cash flow is the average amount expected to receive each month after operating expenses and debt service are paid. ")
                ], -1))
              ]),
              (p(!0), h(A, null, D(e.yearRentalTypeValues, (o) => (p(), h("td", {
                class: z(["table-column", e.analysisYearStyle(o)]),
                "data-year": o.year
              }, [
                a("div", {
                  class: "table-content table-grey adv-monthlycashflow",
                  title: e.currency(o.monthlyCashFlow)
                }, g(e.shortCurrency(o.monthlyCashFlow)), 9, YQe)
              ], 10, GQe))), 256))
            ]),
            a("tr", null, [
              a("th", XQe, [
                t[13] || (t[13] = y(" Gross Wealth Accumulation")),
                a("i", {
                  class: "fa-light fa-question-circle ms-2 info-pop",
                  onClick: t[3] || (t[3] = (...o) => e.infoPopover && e.infoPopover(...o)),
                  "data-title": "Gross Wealth Accumulation",
                  "data-html": "true",
                  "data-render": "true",
                  "data-pop": "grossWealthAccumulation"
                }),
                t[14] || (t[14] = a("div", { class: "d-none info-pop-grossWealthAccumulation" }, [
                  a("p", null, [
                    y(" Gross Wealth Accumulation is the amount you would expect to receive at the end of each year, including cumulative cash flow, and the gross proceeds at the sale of the home. "),
                    a("br"),
                    a("br"),
                    y("In some cases, the costs to sell the home, as well as the expenses related to vacancy and leasing commissions, will cause your total return to be less than the total investment in the first few years. ")
                  ])
                ], -1))
              ]),
              (p(!0), h(A, null, D(e.yearRentalTypeValues, (o) => (p(), h("td", {
                class: z(["table-column", e.analysisYearStyle(o)]),
                "data-year": o.year
              }, [
                a("div", {
                  class: "table-content table-grey adv-grossWealthAccumulation",
                  title: e.currency(o.grossWealthAccumulation)
                }, g(e.shortCurrency(o.grossWealthAccumulation)), 9, QQe)
              ], 10, qQe))), 256))
            ]),
            a("tr", null, [
              a("th", KQe, [
                t[15] || (t[15] = y(" Net Gain on Investment")),
                a("i", {
                  class: "fa-light fa-question-circle ms-2 info-pop",
                  onClick: t[4] || (t[4] = (...o) => e.infoPopover && e.infoPopover(...o)),
                  "data-title": "Net Gain on Investment",
                  "data-html": "true",
                  "data-render": "true",
                  "data-pop": "netGainOnInvestment"
                }),
                t[16] || (t[16] = a("div", { class: "d-none info-pop-netGainOnInvestment" }, [
                  a("p", null, [
                    a("b", null, "Net Gain on Investment"),
                    y(' is the total profit (or loss) you see after accounting for every dollar spent—like the purchase price, repairs, and other costs—and every dollar earned from rental income or a future sale. Essentially, it answers, "How much did I actually make from this property when all’s said and done?" ')
                  ])
                ], -1))
              ]),
              (p(!0), h(A, null, D(e.yearRentalTypeValues, (o) => (p(), h("th", {
                class: z(["table-column", e.analysisYearStyle(o)]),
                "data-year": o.year
              }, [
                a("div", {
                  class: "table-content table-grey adv-grossWealthAccumulation strong",
                  title: e.currency(o.netGainOnInvestment)
                }, g(e.shortCurrency(o.netGainOnInvestment)), 9, JQe)
              ], 10, ZQe))), 256))
            ])
          ])
        ], 10, BQe)
      ]),
      e.haveAccess ? P("", !0) : (p(), h("div", $Qe, t[17] || (t[17] = [
        a("div", { class: "fw-bold fs-5" }, "View our full 30 year analysis with an account!", -1),
        a("a", {
          href: "/signup",
          class: "btn btn-eclipse flex-shrink-0"
        }, "Activate Full Analysis!", -1)
      ])))
    ])
  ], 2);
}
const eKe = /* @__PURE__ */ Ae(TQe, [["render", _Qe]]), ed = {
  NORMALIZED: "NORMALIZED",
  RAW: "RAW"
}, tKe = me({
  name: "CashFlowSummary",
  data() {
    return {
      apodType: ed.NORMALIZED,
      showRaw: !1
    };
  },
  computed: {
    calculatingClasses() {
      return {
        card: !0,
        "card-cash-flow-summary": !0,
        "shadow-sm": !0,
        "card-proforma": !0,
        calculating: this.calculating,
        "card-guarded": this.haveAccess == !1
      };
    },
    normalized() {
      return this.calculatedResults.normalized ? this.calculatedResults.normalized.filter((e) => e.fiscalYear >= this.firstTableYear).sort((e, t) => e.fiscalYear - t.fiscalYear).slice(0, this.yearsToShow) : [];
    },
    raw() {
      return this.calculatedResults.raw ? this.calculatedResults.raw.filter((e) => e.fiscalYear >= this.firstTableYear).sort((e, t) => e.fiscalYear - t.fiscalYear).slice(0, this.yearsToShow) : [];
    },
    shortTerm() {
      return this.calculatedResults.shortTerm ? this.calculatedResults.shortTerm.filter((e) => e.fiscalYear >= this.firstTableYear).sort((e, t) => e.fiscalYear - t.fiscalYear).slice(0, this.yearsToShow) : [];
    },
    haveAccess() {
      var e, t;
      return this.isMarketplace || ((t = (e = this.acl) == null ? void 0 : e.properties) == null ? void 0 : t.financialAnalysis) == !0;
    },
    yearsToShow() {
      return this.isAdvancedMode ? 30 : 5;
    },
    mainTableStyle() {
      return {
        table: !0,
        "table-sm": !0,
        "text-small": !0,
        "mode-basic": this.isAdvancedMode != !0,
        "mode-advanced": this.isAdvancedMode == !0
      };
    },
    ...q(ct, ["account", "isAdvancedMode"]),
    ...q(Te, ["acl", "aclLoaded"]),
    ...q(qe, ["calculating", "calculatedResults", "isMarketplace", "hasShortTermResults", "firstAnalyzedYear", "firstTableYear"])
  },
  methods: {
    number: Ve,
    currency: Ze,
    shortCurrency: ka,
    analysisYearStyle: so,
    currencyStyle(e) {
      return {
        positive: e > 0,
        negative: e < 0
      };
    }
  },
  watch: {
    hasShortTermResults(e) {
      e && (this.apodType = ed.RAW);
    }
  }
}), sKe = { class: "card-body p-0 position-relative overflow-hidden" }, aKe = {
  key: 0,
  class: "calculating-animation position-absolute top-50 start-50 translate-middle text-center"
}, nKe = { class: "table-wrap table-data" }, rKe = { class: "text-end" }, oKe = ["data-year"], iKe = ["data-year"], lKe = ["title"], dKe = ["data-year"], cKe = ["title"], uKe = ["data-year"], pKe = ["title"], hKe = { class: "table-divider" }, mKe = ["data-year"], fKe = ["title"], gKe = ["data-year"], vKe = ["title"], yKe = ["data-year"], bKe = ["title"], AKe = { class: "table-total styled-finances fw-bold table-divider" }, wKe = ["data-year"], CKe = ["title"], SKe = ["data-year"], PKe = ["title"], kKe = {
  key: 1,
  class: "d-flex justify-content-between shadow m-2 mt-xxl-2 m-xxl-4 flex-shrink-0 bg-gradient-periwinkle card-guard rounded-4 p-3 text-center order-last order-sm-first d-flex flex-row align-items-center gap-3"
};
function EKe(e, t, s, n, r, i) {
  return p(), h("div", {
    class: z(e.calculatingClasses)
  }, [
    t[8] || (t[8] = a("div", { class: "card-header bg-eclipse text-white fw-bold text-center text-sm-start rounded rounded-bottom-0" }, [
      a("div", { class: "flex-grow-1" }, " CASH FLOW SUMMARY ")
    ], -1)),
    a("div", sKe, [
      e.calculating ? (p(), h("div", aKe, t[0] || (t[0] = [
        a("i", { class: "fa-duotone fa-solid fa-compass fa-spin fa-lg text-eclipse" }, null, -1),
        a("br", null, null, -1),
        a("small", null, "Calculating", -1)
      ]))) : P("", !0),
      a("div", nKe, [
        a("table", {
          class: z(e.mainTableStyle)
        }, [
          a("thead", null, [
            a("tr", rKe, [
              t[1] || (t[1] = a("th", null, " ", -1)),
              (p(!0), h(A, null, D(e.raw, (o) => (p(), h("th", {
                class: z(["table-column", e.analysisYearStyle(o)]),
                "data-year": o.year
              }, [
                o.fiscalYear ? (p(), h(A, { key: 0 }, [
                  y(g(o.fiscalYear), 1)
                ], 64)) : (p(), h(A, { key: 1 }, [
                  y(" Year " + g(o.year), 1)
                ], 64))
              ], 10, oKe))), 256))
            ])
          ]),
          a("tbody", null, [
            a("tr", null, [
              t[2] || (t[2] = a("th", { rel: "effectiveIncome" }, "Effective Income", -1)),
              e.hasShortTermResults ? (p(!0), h(A, { key: 1 }, D(e.shortTerm, (o) => (p(), h("td", {
                class: z(["table-column", e.analysisYearStyle(o)]),
                "data-year": o.year
              }, [
                a("div", {
                  class: "table-content adv-effectiveIncome",
                  title: e.currency(o.effectiveIncome)
                }, g(e.shortCurrency(o.effectiveIncome)), 9, cKe)
              ], 10, dKe))), 256)) : (p(!0), h(A, { key: 0 }, D(e.showRaw ? e.raw : e.normalized, (o) => (p(), h("td", {
                class: z(["table-column", e.analysisYearStyle(o)]),
                "data-year": o.year
              }, [
                a("div", {
                  class: "table-content adv-effectiveIncome",
                  title: e.currency(o.effectiveIncome)
                }, g(e.shortCurrency(o.effectiveIncome)), 9, lKe)
              ], 10, iKe))), 256))
            ]),
            a("tr", null, [
              t[3] || (t[3] = a("th", { rel: "totalnonoperating" }, "Operating Expenses", -1)),
              (p(!0), h(A, null, D(e.showRaw ? e.raw : e.normalized, (o) => (p(), h("td", {
                class: "table-column",
                "data-year": o.year
              }, [
                a("div", {
                  class: "table-content adv-totalexpenses",
                  title: e.currency(o.totalexpenses)
                }, g(e.shortCurrency(o.totalexpenses)), 9, pKe)
              ], 8, uKe))), 256))
            ]),
            a("tr", hKe, [
              t[4] || (t[4] = a("th", { rel: "noi" }, [
                a("strong", null, "Net Operating Income")
              ], -1)),
              e.hasShortTermResults ? (p(!0), h(A, { key: 1 }, D(e.shortTerm, (o) => (p(), h("td", {
                class: z(["table-column", e.analysisYearStyle(o)]),
                "data-year": o.year
              }, [
                a("div", {
                  class: z(["table-content table-grey adv-noi", e.currencyStyle(o.noi)]),
                  title: e.currency(o.noi)
                }, g(e.shortCurrency(o.noi)), 11, vKe)
              ], 10, gKe))), 256)) : (p(!0), h(A, { key: 0 }, D(e.showRaw ? e.raw : e.normalized, (o) => (p(), h("td", {
                class: z(["table-column", e.analysisYearStyle(o)]),
                "data-year": o.year
              }, [
                a("div", {
                  class: z(["table-content table-grey adv-noi", e.currencyStyle(o.noi)]),
                  title: e.currency(o.noi)
                }, g(e.shortCurrency(o.noi)), 11, fKe)
              ], 10, mKe))), 256))
            ]),
            a("tr", null, [
              t[5] || (t[5] = a("th", { rel: "totalnonoperating" }, "Non Operating Expenses", -1)),
              (p(!0), h(A, null, D(e.raw, (o) => (p(), h("th", {
                class: "table-column",
                "data-year": o.year
              }, [
                a("div", {
                  class: "table-content adv-totalexpenses",
                  title: e.currency(o.totalNonOperatingExpenses)
                }, g(e.shortCurrency(o.totalNonOperatingExpenses)), 9, bKe)
              ], 8, yKe))), 256))
            ]),
            a("tr", AKe, [
              t[6] || (t[6] = a("th", { rel: "annualcashflow" }, [
                a("strong", null, "Annual Cash Flow")
              ], -1)),
              e.hasShortTermResults ? (p(!0), h(A, { key: 1 }, D(e.shortTerm, (o) => (p(), h("th", {
                class: z(["table-column", e.analysisYearStyle(o)]),
                "data-year": o.year
              }, [
                a("div", {
                  class: z(["table-content last adv-annualcashflow", e.currencyStyle(o.annualCashFlow)]),
                  title: e.currency(o.annualCashFlow)
                }, g(e.shortCurrency(o.annualCashFlow)), 11, PKe)
              ], 10, SKe))), 256)) : (p(!0), h(A, { key: 0 }, D(e.showRaw ? e.raw : e.normalized, (o) => (p(), h("th", {
                class: z(["table-column", e.analysisYearStyle(o)]),
                "data-year": o.year
              }, [
                a("div", {
                  class: z(["table-content last adv-annualcashflow", e.currencyStyle(o.annualcashflow)]),
                  title: e.currency(o.annualcashflow)
                }, g(e.shortCurrency(o.annualcashflow)), 11, CKe)
              ], 10, wKe))), 256))
            ])
          ])
        ], 2)
      ]),
      e.haveAccess ? P("", !0) : (p(), h("div", kKe, t[7] || (t[7] = [
        a("div", { class: "fw-bold fs-5" }, "View our full 30 year analysis with an account!", -1),
        a("a", {
          href: "/signup",
          class: "btn btn-eclipse"
        }, "Activate Full Analysis!", -1)
      ])))
    ])
  ], 2);
}
const IKe = /* @__PURE__ */ Ae(tKe, [["render", EKe]]), TKe = me({
  name: "ValueEquity",
  computed: {
    calculatingClasses() {
      return {
        card: !0,
        "card-value-equity": !0,
        "shadow-sm": !0,
        "card-proforma": !0,
        calculating: this.calculating,
        "card-guarded": this.haveAccess == !1,
        "card-basic": this.isAdvancedMode == !1,
        "card-advanced": this.isAdvancedMode == !0
      };
    },
    normalized() {
      return this.calculatedResults.normalized ? this.calculatedResults.normalized.filter((e) => e.fiscalYear >= this.firstTableYear).sort((e, t) => e.fiscalYear - t.fiscalYear).slice(0, this.yearsToShow) : [];
    },
    raw() {
      return this.calculatedResults.raw ? this.calculatedResults.raw.filter((e) => e.fiscalYear >= this.firstTableYear).sort((e, t) => e.fiscalYear - t.fiscalYear).slice(0, this.yearsToShow) : [];
    },
    shortTerm() {
      return this.calculatedResults.shortTerm ? this.calculatedResults.shortTerm.filter((e) => e.fiscalYear >= this.firstTableYear).sort((e, t) => e.fiscalYear - t.fiscalYear).slice(0, this.yearsToShow) : [];
    },
    haveAccess() {
      var e, t, s, n;
      return ((t = (e = this.property) == null ? void 0 : e.mlsSource) == null ? void 0 : t.isActiveMarketplaceListing) == !0 || ((n = (s = this.acl) == null ? void 0 : s.properties) == null ? void 0 : n.financialAnalysis) == !0;
    },
    mainTableStyle() {
      return {
        table: !0,
        "table-sm": !0,
        "text-small": !0,
        "mode-basic": this.isAdvancedMode != !0,
        "mode-advanced": this.isAdvancedMode == !0
      };
    },
    tableYears() {
      var e;
      return ((e = this.rentalTypeResultYears) == null ? void 0 : e.filter((t) => t.fiscalYear >= this.firstTableYear).sort((t, s) => t.fiscalYear - s.fiscalYear).slice(0, this.yearsToShow)) ?? [];
    },
    ...q(ct, ["account", "isAdvancedMode"]),
    ...q(Te, ["acl", "aclLoaded"]),
    ...q(qe, ["calculating", "calculatedResults", "property", "hasShortTermResults", "calcParams", "isMarketplace", "purchaseFacts", "firstAnalyzedYear", "isExistingInvestment", "firstTableYear", "yearsToShow", "rentalTypeResultYears"])
  },
  methods: {
    currency: Ze,
    shortNumber: vr,
    shortCurrency: ka,
    analysisYearStyle: so
  }
}), OKe = {
  key: 0,
  class: "calculating-animation position-absolute top-50 start-50 translate-middle text-center"
}, RKe = { class: "table-wrap table-data" }, LKe = { class: "text-end" }, BKe = ["data-year"], MKe = { class: "table-alice" }, xKe = ["colspan"], FKe = { class: "tb-space" }, VKe = ["data-year"], DKe = ["title"], NKe = ["data-year"], jKe = ["title"], HKe = { class: "table-total table-divider fw-bold" }, UKe = ["data-year"], zKe = ["title"], WKe = { class: "table-alice" }, GKe = ["colspan"], YKe = { class: "tb-space" }, XKe = ["data-year"], qKe = ["title"], QKe = ["data-year"], KKe = ["title"], ZKe = ["data-year"], JKe = ["title"], $Ke = ["data-year"], _Ke = ["title"], eZe = { class: "table-total table-divider fw-bold" }, tZe = ["data-year"], sZe = ["title"], aZe = { class: "table-alice" }, nZe = ["colspan"], rZe = { class: "tb-space" }, oZe = ["data-year"], iZe = ["title"], lZe = ["data-year"], dZe = ["title"], cZe = { class: "table-total table-divider fw-bold" }, uZe = ["data-year"], pZe = ["title"], hZe = ["data-year"], mZe = ["title"], fZe = { class: "table-alice" }, gZe = ["colspan"], vZe = { class: "tb-space" }, yZe = ["data-year"], bZe = ["title"], AZe = ["data-year"], wZe = ["title"], CZe = { class: "table-total table-divider fw-bold" }, SZe = ["data-year"], PZe = ["title"], kZe = { class: "table-total" }, EZe = ["data-year"], IZe = ["title"], TZe = {
  key: 1,
  class: "d-flex justify-content-center align-items-center shadow m-2 m-xxl-4 mt-xxl-2 flex-shrink-0 flex-column flex-sm-row bg-gradient-periwinkle card-guard rounded-4 p-3 p-xxl-4 text-center d-flex gap-3"
};
function OZe(e, t, s, n, r, i) {
  return p(), h("div", {
    class: z(e.calculatingClasses)
  }, [
    t[23] || (t[23] = a("div", { class: "card-header bg-eclipse text-white rounded rounded-bottom-0 fw-bold text-center text-sm-start" }, " EQUITY & TAX ANALYSIS ", -1)),
    a("div", {
      class: z(e.modeStyle)
    }, [
      e.calculating ? (p(), h("div", OKe, t[0] || (t[0] = [
        a("i", { class: "fa-duotone fa-solid fa-compass fa-spin fa-lg text-eclipse" }, null, -1),
        a("br", null, null, -1),
        a("small", null, "Calculating", -1)
      ]))) : P("", !0),
      a("div", RKe, [
        a("table", {
          class: z(e.mainTableStyle)
        }, [
          a("thead", null, [
            a("tr", LKe, [
              t[1] || (t[1] = a("th", null, " ", -1)),
              (p(!0), h(A, null, D(e.tableYears, (o) => (p(), h("th", {
                class: z(["table-column", e.analysisYearStyle(o)]),
                "data-year": o.year
              }, [
                o.fiscalYear ? (p(), h(A, { key: 0 }, [
                  y(g(o.fiscalYear), 1)
                ], 64)) : (p(), h(A, { key: 1 }, [
                  y(" Year " + g(o.year), 1)
                ], 64))
              ], 10, BKe))), 256))
            ]),
            a("tr", MKe, [
              t[2] || (t[2] = a("th", null, " COST BASIS ", -1)),
              a("td", {
                colspan: e.normalized.length
              }, " ", 8, xKe)
            ])
          ]),
          a("tbody", FKe, [
            a("tr", null, [
              t[3] || (t[3] = a("th", { rel: "costBasis" }, "Original Cost Basis", -1)),
              (p(!0), h(A, null, D(e.tableYears, (o) => (p(), h("td", {
                class: z(["table-column", e.analysisYearStyle(o)]),
                "data-year": o.year
              }, [
                a("div", {
                  class: "table-content adv-costBasis",
                  title: e.currency(o.costBasis)
                }, g(e.shortCurrency(o.costBasis)), 9, DKe)
              ], 10, VKe))), 256))
            ]),
            a("tr", null, [
              t[4] || (t[4] = a("th", { rel: "capitalImprovements" }, "Plus: Capital Improvements", -1)),
              (p(!0), h(A, null, D(e.tableYears, (o) => (p(), h("td", {
                class: z(["table-column", e.analysisYearStyle(o)]),
                "data-year": o.year
              }, [
                a("div", {
                  class: "table-content adv-capitalImprovements",
                  title: e.currency(o.capitalImprovements)
                }, g(e.shortCurrency(o.capitalImprovements)), 9, jKe)
              ], 10, NKe))), 256))
            ]),
            a("tr", HKe, [
              t[5] || (t[5] = a("th", { rel: "adjustedCostBasis" }, "Adjusted Cost Basis", -1)),
              (p(!0), h(A, null, D(e.tableYears, (o) => (p(), h("td", {
                class: z(["table-column", e.analysisYearStyle(o)]),
                "data-year": o.year
              }, [
                a("div", {
                  class: "table-content adv-adjustedCostBasis",
                  title: e.currency(o.adjustedCostBasis)
                }, g(e.shortCurrency(o.adjustedCostBasis)), 9, zKe)
              ], 10, UKe))), 256))
            ])
          ]),
          a("thead", null, [
            a("tr", WKe, [
              t[6] || (t[6] = a("th", null, " VALUE & EQUITY ", -1)),
              a("td", {
                colspan: e.normalized.length
              }, " ", 8, GKe)
            ])
          ]),
          a("tbody", YKe, [
            a("tr", null, [
              t[7] || (t[7] = a("th", { rel: "totalAppreciation" }, "Total Appreciation", -1)),
              (p(!0), h(A, null, D(e.tableYears, (o) => (p(), h("td", {
                class: z(["table-column", e.analysisYearStyle(o)]),
                "data-year": o.year
              }, [
                a("div", {
                  class: "table-content adv-totalAppreciation",
                  title: e.currency(o.totalAppreciation)
                }, g(e.shortCurrency(o.totalAppreciation)), 9, qKe)
              ], 10, XKe))), 256))
            ]),
            a("tr", null, [
              t[8] || (t[8] = a("th", { rel: "propertyValue" }, "Property Market Value (EoY)", -1)),
              (p(!0), h(A, null, D(e.tableYears, (o) => (p(), h("td", {
                class: z(["table-column", e.analysisYearStyle(o)]),
                "data-year": o.year
              }, [
                a("div", {
                  class: "table-content adv-propertyvalue",
                  title: e.currency(o.propertyValue)
                }, g(e.shortCurrency(o.propertyValue)), 9, KKe)
              ], 10, QKe))), 256))
            ]),
            a("tr", null, [
              t[9] || (t[9] = a("th", { rel: "loanBalance" }, "Loan Balance", -1)),
              (p(!0), h(A, null, D(e.tableYears, (o) => (p(), h("td", {
                class: z(["table-column", e.analysisYearStyle(o)]),
                "data-year": o.year
              }, [
                a("div", {
                  class: "table-content adv-loanbalance",
                  title: e.currency(o.loanBalance)
                }, g(e.shortCurrency(o.loanBalance)), 9, JKe)
              ], 10, ZKe))), 256))
            ]),
            a("tr", null, [
              t[10] || (t[10] = a("th", { rel: "costOfSale" }, "Cost of Sale", -1)),
              (p(!0), h(A, null, D(e.tableYears, (o) => (p(), h("td", {
                class: z(["table-column", e.analysisYearStyle(o)]),
                "data-year": o.year
              }, [
                a("div", {
                  class: "table-content adv-costofsale",
                  title: e.currency(o.costOfSale)
                }, g(e.shortCurrency(o.costOfSale)), 9, _Ke)
              ], 10, $Ke))), 256))
            ]),
            a("tr", eZe, [
              t[11] || (t[11] = a("th", { rel: "netEquity" }, " Net Equity (EoY) ", -1)),
              (p(!0), h(A, null, D(e.tableYears, (o) => (p(), h("th", {
                class: z(["table-column", e.analysisYearStyle(o)]),
                "data-year": o.year
              }, [
                a("div", {
                  class: "table-content adv-netequity",
                  title: e.currency(o.netEquity)
                }, g(e.shortCurrency(o.netEquity)), 9, sZe)
              ], 10, tZe))), 256))
            ])
          ]),
          a("thead", null, [
            a("tr", aZe, [
              t[12] || (t[12] = a("th", null, " TAX BASIS ", -1)),
              a("td", {
                colspan: e.normalized.length
              }, " ", 8, nZe)
            ])
          ]),
          a("tbody", rZe, [
            a("tr", null, [
              t[13] || (t[13] = a("th", { rel: "adjustedTaxBasis" }, "Adjusted Tax Basis (BoY)", -1)),
              (p(!0), h(A, null, D(e.tableYears, (o) => (p(), h("td", {
                class: z(["table-column", e.analysisYearStyle(o)]),
                "data-year": o.year
              }, [
                a("div", {
                  class: "table-content adv-adjustedTaxBasis",
                  title: e.currency(o.adjustedTaxBasis)
                }, g(e.shortCurrency(o.adjustedTaxBasis)), 9, iZe)
              ], 10, oZe))), 256))
            ]),
            a("tr", null, [
              t[14] || (t[14] = a("th", { rel: "improvementDepreciation" }, "Less: Annual Depreciation", -1)),
              (p(!0), h(A, null, D(e.tableYears, (o) => (p(), h("td", {
                class: z(["table-column", e.analysisYearStyle(o)]),
                "data-year": o.year
              }, [
                a("div", {
                  class: "table-content adv-improvementDepreciation",
                  title: e.currency(o.improvementDepreciation)
                }, g(e.shortCurrency(o.improvementDepreciation)), 9, dZe)
              ], 10, lZe))), 256))
            ]),
            a("tr", cZe, [
              t[15] || (t[15] = a("th", { rel: "adjustedTaxBasisEoY" }, "Adjusted Tax Basis (EoY)", -1)),
              (p(!0), h(A, null, D(e.tableYears, (o) => (p(), h("td", {
                class: z(["table-column", e.analysisYearStyle(o)]),
                "data-year": o.year
              }, [
                a("div", {
                  class: "table-content adv-adjustedTaxBasisEoY",
                  title: e.currency(o.adjustedTaxBasisEoY)
                }, g(e.shortCurrency(o.adjustedTaxBasisEoY)), 9, pZe)
              ], 10, uZe))), 256))
            ]),
            a("tr", null, [
              t[16] || (t[16] = a("th", { rel: "accumulatedDepreciation" }, "Accumulated Depreciation", -1)),
              (p(!0), h(A, null, D(e.tableYears, (o) => (p(), h("td", {
                class: z(["table-column", e.analysisYearStyle(o)]),
                "data-year": o.year
              }, [
                a("div", {
                  class: "table-content adv-accumulatedDepreciation",
                  title: e.currency(o.accumulatedDepreciation)
                }, g(e.shortCurrency(o.accumulatedDepreciation)), 9, mZe)
              ], 10, hZe))), 256))
            ])
          ]),
          a("thead", null, [
            a("tr", fZe, [
              t[17] || (t[17] = a("th", null, " TAX LIABILITIES IF SOLD ", -1)),
              a("td", {
                colspan: e.normalized.length
              }, " ", 8, gZe)
            ])
          ]),
          a("tbody", vZe, [
            a("tr", null, [
              t[18] || (t[18] = a("th", { rel: "depreciationRecapture" }, "Depreciation Recapture", -1)),
              (p(!0), h(A, null, D(e.tableYears, (o) => (p(), h("td", {
                class: z(["table-column", e.analysisYearStyle(o)]),
                "data-year": o.year
              }, [
                a("div", {
                  class: "table-content adv-depreciationRecapture",
                  title: e.currency(o.depreciationRecapture)
                }, g(e.shortCurrency(o.depreciationRecapture)), 9, bZe)
              ], 10, yZe))), 256))
            ]),
            a("tr", null, [
              t[19] || (t[19] = a("th", { rel: "capitalGainsLiability" }, "Capital Gains Liability", -1)),
              (p(!0), h(A, null, D(e.tableYears, (o) => (p(), h("td", {
                class: z(["table-column", e.analysisYearStyle(o)]),
                "data-year": o.year
              }, [
                a("div", {
                  class: "table-content adv-capitalGainsLiability",
                  title: e.currency(o.capitalGainsLiability)
                }, g(e.shortCurrency(o.capitalGainsLiability)), 9, wZe)
              ], 10, AZe))), 256))
            ]),
            a("tr", CZe, [
              t[20] || (t[20] = a("th", { rel: "totalTaxLiability" }, "Total Tax Liability (If Sold)", -1)),
              (p(!0), h(A, null, D(e.tableYears, (o) => (p(), h("td", {
                class: z(["table-column", e.analysisYearStyle(o)]),
                "data-year": o.year
              }, [
                a("div", {
                  class: "table-content adv-totalTaxLiability",
                  title: e.currency(o.totalTaxLiability)
                }, g(e.shortCurrency(o.totalTaxLiability)), 9, PZe)
              ], 10, SZe))), 256))
            ])
          ]),
          a("tbody", null, [
            a("tr", kZe, [
              t[21] || (t[21] = a("th", { rel: "netEquityAfterTax" }, " Net Equity (After-Tax) ", -1)),
              (p(!0), h(A, null, D(e.tableYears, (o) => (p(), h("th", {
                class: z(["table-column", e.analysisYearStyle(o)]),
                "data-year": o.year
              }, [
                a("div", {
                  class: "table-content adv-netEquityAfterTax",
                  title: e.currency(o.netEquityAfterTax)
                }, g(e.shortCurrency(o.netEquityAfterTax)), 9, IZe)
              ], 10, EZe))), 256))
            ])
          ])
        ], 2)
      ]),
      e.haveAccess ? P("", !0) : (p(), h("div", TZe, t[22] || (t[22] = [
        a("div", { class: "fw-bold fs-5" }, "View our full 30 year analysis with an account!", -1),
        a("a", {
          href: "/signup",
          class: "btn btn-eclipse"
        }, "Activate Full Analysis!", -1)
      ])))
    ], 2)
  ], 2);
}
const RZe = /* @__PURE__ */ Ae(TKe, [["render", OZe]]), lS = /* @__PURE__ */ new Date(), LZe = me({
  name: "FinancialIndicators",
  emits: [
    "infoPopover"
  ],
  data() {
    return {
      tooltipHoldPeriod: 0
    };
  },
  watch: {
    "calculatedResults.hold"() {
      this.tooltipHoldPeriod = this.calculatedResults.hold;
    }
  },
  computed: {
    //#region Tooltip Data
    fastForwardAnalysis() {
      var e;
      return ((e = this.purchaseFacts) == null ? void 0 : e.ignoreHistoricalOperatingIncome) == !0;
    },
    capRatePriceValue() {
      var e, t, s, n, r, i, o, l, d, c;
      return this.fastForwardAnalysis && ((e = this.calculatedResults) != null && e.existingInvestmentSummary) ? this.calculatedResults.existingInvestmentSummary.prevYearPropertyValue : this.isShortTerm ? (n = (s = (t = this.calculatedResults) == null ? void 0 : t.shortTerm) == null ? void 0 : s.find((u) => u.year == this.firstProformaYear)) == null ? void 0 : n.propertyValue : this.isPadSplit ? (o = (i = (r = this.calculatedResults) == null ? void 0 : r.padSplit) == null ? void 0 : i.find((u) => u.year == this.firstProformaYear)) == null ? void 0 : o.propertyValue : (c = (d = (l = this.calculatedResults) == null ? void 0 : l.normalized) == null ? void 0 : d.find((u) => u.year == this.firstProformaYear)) == null ? void 0 : c.propertyValue;
    },
    capRate() {
      var e, t, s, n, r, i, o, l, d;
      return this.isShortTerm ? (s = (t = (e = this.calculatedResults) == null ? void 0 : e.shortTerm) == null ? void 0 : t.find((c) => c.year == this.firstProformaYear)) == null ? void 0 : s.capRate : this.isPadSplit ? (i = (r = (n = this.calculatedResults) == null ? void 0 : n.padSplit) == null ? void 0 : r.find((c) => c.year == this.firstProformaYear)) == null ? void 0 : i.capRate : (d = (l = (o = this.calculatedResults) == null ? void 0 : o.normalized) == null ? void 0 : l.find((c) => c.year == this.firstProformaYear)) == null ? void 0 : d.capRate;
    },
    NOI() {
      var e, t, s, n, r, i, o, l, d;
      return this.isShortTerm ? (s = (t = (e = this.calculatedResults) == null ? void 0 : e.shortTerm) == null ? void 0 : t.find((c) => c.year == this.firstProformaYear)) == null ? void 0 : s.noi : this.isPadSplit ? (i = (r = (n = this.calculatedResults) == null ? void 0 : n.padSplit) == null ? void 0 : r.find((c) => c.year == this.firstProformaYear)) == null ? void 0 : i.noi : (d = (l = (o = this.calculatedResults) == null ? void 0 : o.normalized) == null ? void 0 : l.find((c) => c.year == this.firstProformaYear)) == null ? void 0 : d.noi;
    },
    firstProformaYearData() {
      var e, t, s, n, r, i;
      return this.isShortTerm ? (t = (e = this.calculatedResults) == null ? void 0 : e.shortTerm) == null ? void 0 : t.find((o) => o.year == this.firstProformaYear) : this.isPadSplit ? (n = (s = this.calculatedResults) == null ? void 0 : s.padSplit) == null ? void 0 : n.find((o) => o.year == this.firstProformaYear) : (i = (r = this.calculatedResults) == null ? void 0 : r.normalized) == null ? void 0 : i.find((o) => o.year == this.firstProformaYear);
    },
    capRatePriceLabel() {
      return this.fastForwardAnalysis ? "Property Value" : "Total Cost";
    },
    irrCashflow() {
      var e, t, s, n, r, i, o, l;
      return this.isShortTerm ? ((s = (t = (e = this.calculatedResults) == null ? void 0 : e.shortTermSummary) == null ? void 0 : t.irrCashFlow) == null ? void 0 : s.slice(0, this.tooltipHoldPeriod + 1)) ?? [] : this.isPadSplit ? ((i = (r = (n = this.calculatedResults) == null ? void 0 : n.padSplitSummary) == null ? void 0 : r.irrCashFlow) == null ? void 0 : i.slice(0, this.tooltipHoldPeriod + 1)) ?? [] : ((l = (o = this.calculatedResults) == null ? void 0 : o.irrCashFlow) == null ? void 0 : l.slice(0, this.tooltipHoldPeriod + 1)) ?? [];
    },
    getHoldIrr() {
      var e, t, s;
      return ((s = (t = (e = this.calculatedResults) == null ? void 0 : e.normalized) == null ? void 0 : t.find((n) => n.fiscalYear == this.holdYear)) == null ? void 0 : s.irr) ?? 0;
    },
    //#endregion
    calculatingClasses() {
      return {
        card: !0,
        "card-financial-indicators": !0,
        "shadow-sm": !0,
        "card-proforma": !0,
        calculating: this.calculating,
        "card-guarded": this.haveAccess == !1
      };
    },
    haveAccess() {
      var e, t;
      return this.isMarketplace || ((t = (e = this.acl) == null ? void 0 : e.properties) == null ? void 0 : t.financialAnalysis) == !0;
    },
    holdYear() {
      return Et + this.tooltipHoldPeriod;
    },
    mainTableStyle() {
      return {
        table: !0,
        "table-sm": !0,
        "text-small": !0,
        "mode-advanced": !0
      };
    },
    yearRentalTypeValues() {
      var e, t, s, n, r, i;
      switch (this.calcParams.rentalType) {
        case Ut.LongTerm:
          return ((t = (e = this.calculatedResults) == null ? void 0 : e.normalized) == null ? void 0 : t.filter((o) => o.fiscalYear >= this.firstTableYear).sort((o, l) => o.fiscalYear - l.fiscalYear).slice(0, this.yearsToShow)) ?? [];
        case Ut.ShortTerm:
          return ((n = (s = this.calculatedResults) == null ? void 0 : s.shortTerm) == null ? void 0 : n.filter((o) => o.fiscalYear >= this.firstTableYear).sort((o, l) => o.fiscalYear - l.fiscalYear).slice(0, this.yearsToShow)) ?? [];
        case Ut.PadSplit:
          return ((i = (r = this.calculatedResults) == null ? void 0 : r.padSplit) == null ? void 0 : i.filter((o) => o.fiscalYear >= this.firstTableYear).sort((o, l) => o.fiscalYear - l.fiscalYear).slice(0, this.yearsToShow)) ?? [];
        default:
          return [];
      }
    },
    yearRentalTypeRawValues() {
      var e, t, s, n, r, i;
      switch (this.calcParams.rentalType) {
        case Ut.LongTerm:
          return ((t = (e = this.calculatedResults) == null ? void 0 : e.raw) == null ? void 0 : t.filter((o) => o.fiscalYear >= this.firstTableYear).sort((o, l) => o.fiscalYear - l.fiscalYear).slice(0, this.yearsToShow)) ?? [];
        case Ut.ShortTerm:
          return ((n = (s = this.calculatedResults) == null ? void 0 : s.shortTerm) == null ? void 0 : n.filter((o) => o.fiscalYear >= this.firstTableYear).sort((o, l) => o.fiscalYear - l.fiscalYear).slice(0, this.yearsToShow)) ?? [];
        case Ut.PadSplit:
          return ((i = (r = this.calculatedResults) == null ? void 0 : r.padSplit) == null ? void 0 : i.filter((o) => o.fiscalYear >= this.firstTableYear).sort((o, l) => o.fiscalYear - l.fiscalYear).slice(0, this.yearsToShow)) ?? [];
        default:
          return [];
      }
    },
    yearsToShow() {
      return this.isAdvancedMode ? 30 : 5;
    },
    isAdvancedMode() {
      var e;
      return ((e = this.account) == null ? void 0 : e.defaultAnalysisMode) == Hn.Advanced;
    },
    tooltipHoldYear() {
      return (this.firstAnalyzedYear > 0 ? this.firstAnalyzedYear : lS.getFullYear()) + (this.tooltipHoldPeriod - 1);
    },
    ...q(ct, ["account"]),
    ...q(Te, ["acl", "aclLoaded"]),
    ...q(qe, [
      "calculating",
      "calculatedResults",
      "calcParams",
      "isShortTerm",
      "isPadSplit",
      "isMarketplace",
      "hasShortTermResults",
      "purchaseFacts",
      "firstAnalyzedYear",
      "isExistingInvestment",
      "firstProformaYear",
      "firstTableYear",
      "blueChipCriteria"
    ])
  },
  methods: {
    number: Ve,
    currency: Ze,
    percent: Wt,
    analysisYearStyle: so,
    infoPopover(e) {
      this.$emit("infoPopover", e);
    },
    //#region Tooltip Data
    getHoldNetEquity(e) {
      var t, s, n, r, i, o, l, d, c;
      if (e == this.tooltipHoldPeriod)
        return this.isShortTerm ? (n = (s = (t = this.calculatedResults) == null ? void 0 : t.shortTerm) == null ? void 0 : s.find((u) => u.fiscalYear == this.tooltipHoldYear)) == null ? void 0 : n.netEquity : this.isPadSplit ? (o = (i = (r = this.calculatedResults) == null ? void 0 : r.padSplit) == null ? void 0 : i.find((u) => u.fiscalYear == this.tooltipHoldYear)) == null ? void 0 : o.netEquity : (c = (d = (l = this.calculatedResults) == null ? void 0 : l.raw) == null ? void 0 : d.find((u) => u.fiscalYear == this.tooltipHoldYear)) == null ? void 0 : c.netEquity;
    },
    getIrrYear(e) {
      return e == 0 ? 0 : (this.firstAnalyzedYear > 0 ? this.firstAnalyzedYear : lS.getFullYear()) + (e - 1);
    }
    //#endregion
  },
  mounted() {
    var e;
    this.tooltipHoldPeriod = ((e = this.calculatedResults) == null ? void 0 : e.hold) ?? 0;
  }
}), BZe = { class: "card-body p-0 position-relative overflow-hidden" }, MZe = {
  key: 0,
  class: "calculating-animation position-absolute top-50 start-50 translate-middle text-center"
}, xZe = { class: "table-wrap table-data" }, FZe = { class: "text-end" }, VZe = ["data-year"], DZe = { "data-group": "normalized" }, NZe = { rel: "capRate" }, jZe = { class: "d-none info-pop-capRate" }, HZe = { class: "eq-c mb-3 text-center" }, UZe = { class: "fraction" }, zZe = { class: "fdn" }, WZe = { class: "eq-c mb-3 text-center" }, GZe = { class: "fraction" }, YZe = { class: "fup" }, XZe = { class: "fdn" }, qZe = { class: "eq-c mb-3 text-center" }, QZe = { class: "fraction" }, KZe = { class: "fup" }, ZZe = { class: "fdn" }, JZe = ["data-year"], $Ze = {
  key: 0,
  class: "normalizedcaprate"
}, _Ze = { "data-group": "normalized" }, eJe = { rel: "cocperc" }, tJe = { class: "d-none info-pop-coc" }, sJe = { class: "eq-c mb-3 text-center" }, aJe = { class: "fraction" }, nJe = { class: "fup" }, rJe = { class: "fdn" }, oJe = ["data-year"], iJe = { class: "table-content table-grey adv-cocperc" }, lJe = { "data-group": "normalized" }, dJe = ["data-year"], cJe = { class: "table-content table-grey adv-cocAfterTax" }, uJe = { "data-group": "raw" }, pJe = { rel: "irrperc" }, hJe = { class: "d-none info-pop-irrr" }, mJe = { class: "eq-c mb-4 text-center" }, fJe = { class: "table table-sm table-light table-hover table-t" }, gJe = { class: "table-group-divider" }, vJe = { class: "text-end" }, yJe = { class: "text-end" }, bJe = { class: "row mb-3" }, AJe = { class: "col-sm-8" }, wJe = ["value"], CJe = ["data-year"], SJe = { class: "table-content table-grey adv-irrperc" }, PJe = { "data-group": "raw" }, kJe = ["data-year"], EJe = { class: "table-content table-grey adv-irrAfterTax" }, IJe = { "data-group": "normalized" }, TJe = { rel: "normROEperc" }, OJe = ["data-year"], RJe = { class: "table-content table-grey adv-normROEperc" }, LJe = { "data-group": "normalized" }, BJe = { rel: "normLtvperc" }, MJe = ["data-year"], xJe = { class: "table-content table-grey adv-normLtvperc" }, FJe = { "data-group": "normalized" }, VJe = { rel: "debtCoveragerawnum" }, DJe = ["data-year"], NJe = { class: "table-content table-grey adv-debtCoveragerawnum" }, jJe = { "data-group": "normalized" }, HJe = { rel: "operatingExpenseRatioperc" }, UJe = ["data-year"], zJe = { class: "table-content table-grey adv-operatingExpenseRatioperc" }, WJe = {
  key: 1,
  class: "d-flex justify-content-between shadow m-2 mt-xxl-2 m-xxl-4 flex-shrink-0 bg-gradient-periwinkle card-guard rounded-4 p-3 text-center order-last order-sm-first d-flex flex-row align-items-center gap-3"
};
function GJe(e, t, s, n, r, i) {
  var o, l, d, c, u, m, f;
  return p(), h("div", {
    class: z(e.calculatingClasses)
  }, [
    t[58] || (t[58] = a("div", { class: "card-header bg-eclipse text-white rounded rounded-bottom-0 fw-bold text-center text-sm-start" }, " FINANCIAL INDICATORS ", -1)),
    a("div", BZe, [
      e.calculating ? (p(), h("div", MZe, t[8] || (t[8] = [
        a("i", { class: "fa-duotone fa-compass fa-spin fa-lg text-eclipse" }, null, -1),
        a("br", null, null, -1),
        a("small", null, "Calculating", -1)
      ]))) : P("", !0),
      a("div", xZe, [
        a("table", {
          class: z(e.mainTableStyle)
        }, [
          a("thead", null, [
            a("tr", FZe, [
              t[9] || (t[9] = a("th", null, " ", -1)),
              (p(!0), h(A, null, D(e.yearRentalTypeValues, (v) => (p(), h("th", {
                key: v.year,
                class: z(["table-column", e.analysisYearStyle(v)]),
                "data-year": v.year
              }, [
                v.fiscalYear ? (p(), h(A, { key: 0 }, [
                  y(g(v.fiscalYear), 1)
                ], 64)) : (p(), h(A, { key: 1 }, [
                  y(" Year " + g(v.year), 1)
                ], 64))
              ], 10, VZe))), 128))
            ])
          ]),
          a("tbody", null, [
            a("tr", DZe, [
              a("th", NZe, [
                t[25] || (t[25] = y(" Cap Rate")),
                a("i", {
                  class: "fa-light fa-question-circle ms-2 info-pop",
                  onClick: t[0] || (t[0] = (...v) => e.infoPopover && e.infoPopover(...v)),
                  "data-title": "Cap Rate",
                  "data-html": "true",
                  "data-render": "true",
                  "data-pop": "capRate"
                }),
                a("div", jZe, [
                  t[20] || (t[20] = a("p", null, "Capitalization Rate, or Cap Rate for short, is the rate which your capital is returned after the first year.", -1)),
                  a("p", null, [
                    t[10] || (t[10] = y(" Your Cap Rate gauge reflects a goal of ")),
                    a("b", null, g(e.percent((o = e.blueChipCriteria) == null ? void 0 : o.minCapRate)), 1),
                    t[11] || (t[11] = y(". You can adjust your Cap Rate goal in ")),
                    t[12] || (t[12] = a("a", { href: "/account/settings#blue-chip-criteriaTab" }, "Settings - Blue Chip Criteria", -1)),
                    t[13] || (t[13] = y(". "))
                  ]),
                  t[21] || (t[21] = a("p", null, "The formula for cap rate is:", -1)),
                  a("div", HZe, [
                    a("div", UZe, [
                      t[14] || (t[14] = a("span", { class: "fup" }, "Net Operating Income", -1)),
                      t[15] || (t[15] = a("span", { class: "bar" }, "/", -1)),
                      a("span", zZe, g(e.capRatePriceLabel), 1)
                    ]),
                    t[16] || (t[16] = y("= Cap Rate % "))
                  ]),
                  t[22] || (t[22] = a("p", null, "Using the value from the analysis on this page, the Cap rate is calculated as follows:", -1)),
                  a("div", WZe, [
                    a("div", GZe, [
                      a("span", YZe, [
                        a("span", null, g(e.currency(e.NOI)), 1)
                      ]),
                      t[17] || (t[17] = a("span", { class: "bar" }, "/", -1)),
                      a("span", XZe, [
                        a("span", null, g(e.currency(e.capRatePriceValue)), 1)
                      ])
                    ]),
                    t[18] || (t[18] = y("= ")),
                    a("span", null, g(e.percent(e.capRate, 1)), 1)
                  ]),
                  t[23] || (t[23] = Bt('<p>When used in conjunction with NOI, cap rate can also be used to determine a property&#39;s value. The formula to determine property value based on a known cap rate is as follows:</p><div class="eq-c mb-3 text-center"><div class="fraction"><span class="fup"> NOI </span><span class="bar">/</span><span class="fdn"> Cap Rate </span></div>= Property Value </div>', 2)),
                  a("p", null, "Using the NOI of the property on this page, and an " + g(e.percent(e.capRate, 1)) + " cap rate, the market value is calculated as follows:", 1),
                  a("div", qZe, [
                    a("div", QZe, [
                      a("span", KZe, [
                        a("span", null, g(e.currency(e.NOI)), 1)
                      ]),
                      t[19] || (t[19] = a("span", { class: "bar" }, "/", -1)),
                      a("span", ZZe, g(e.percent(e.capRate, 1)), 1)
                    ]),
                    y("= " + g(e.currency(e.capRatePriceValue)), 1)
                  ]),
                  t[24] || (t[24] = a("p", null, [
                    y(" Continue to learn more!:"),
                    a("br"),
                    a("a", {
                      href: "/dictionary",
                      class: "text-lava"
                    }, "Rescover Investment Term Library")
                  ], -1))
                ])
              ]),
              (p(!0), h(A, null, D(e.yearRentalTypeValues, (v) => (p(), h("td", {
                key: v.year,
                class: z(["table-column", e.analysisYearStyle(v, 1, !0)]),
                "data-year": v.year
              }, [
                v.year == e.firstProformaYear ? (p(), h("span", $Ze, g(e.percent(v.capRate, 1)), 1)) : (p(), h(A, { key: 1 }, [
                  y(" - ")
                ], 64))
              ], 10, JZe))), 128))
            ]),
            a("tr", _Ze, [
              a("th", eJe, [
                t[35] || (t[35] = y(" CoC")),
                a("i", {
                  class: "fa-light fa-question-circle ms-2 info-pop",
                  onClick: t[1] || (t[1] = (...v) => e.infoPopover && e.infoPopover(...v)),
                  "data-title": "Cash on Cash Return (CoC)",
                  "data-html": "true",
                  "data-render": "true",
                  "data-pop": "coc"
                }),
                a("div", tJe, [
                  t[32] || (t[32] = a("p", null, "Cash on Cash (CoC) Return is the amount of cash flow you receive in one year compared to the amount of cash invested.", -1)),
                  a("p", null, [
                    t[26] || (t[26] = y("Your Cash on Cash gauge reflects a goal of ")),
                    a("b", null, g(e.percent((l = e.blueChipCriteria) == null ? void 0 : l.minCoC)), 1),
                    t[27] || (t[27] = y(". You can adjust your CoC goal in ")),
                    t[28] || (t[28] = a("a", { href: "/account/settings#blue-chip-criteriaTab" }, "Settings - Blue Chip Criteria", -1)),
                    t[29] || (t[29] = y("."))
                  ]),
                  t[33] || (t[33] = Bt('<p>The formula for Cash on Cash Return is:</p><div class="eq-c mb-3 text-center"><div class="fraction"><span class="fup">Annual Cash Flow</span><span class="bar">/</span><span class="fdn">Total Investment</span></div>= CoC % </div><p>Using the value from the analysis on this page, the CoC Return is calculated as follows:</p>', 3)),
                  a("div", sJe, [
                    a("div", aJe, [
                      a("span", nJe, g(e.currency((d = e.firstProformaYearData) == null ? void 0 : d.annualCashFlow, !1, "-")), 1),
                      t[30] || (t[30] = a("span", { class: "bar" }, "/", -1)),
                      a("span", rJe, [
                        a("span", null, g(e.currency((u = (c = e.calculatedResults) == null ? void 0 : c.longTermSummary) == null ? void 0 : u.initialInvestment, !1, "-")), 1)
                      ])
                    ]),
                    t[31] || (t[31] = y("= ")),
                    a("span", null, g(e.percent((m = e.firstProformaYearData) == null ? void 0 : m.coc, 1, "-")), 1)
                  ]),
                  t[34] || (t[34] = a("p", null, [
                    y(" Continue to learn more!:"),
                    a("br"),
                    a("a", {
                      href: "/dictionary",
                      class: "text-lava"
                    }, "Rescover Investment Term Library")
                  ], -1))
                ])
              ]),
              (p(!0), h(A, null, D(e.yearRentalTypeValues, (v) => (p(), h("td", {
                key: v.year,
                class: z(["table-column", e.analysisYearStyle(v)]),
                "data-year": v.year
              }, [
                a("div", iJe, g(e.percent(v.coc, 1, "N/A")), 1)
              ], 10, oJe))), 128))
            ]),
            a("tr", lJe, [
              t[36] || (t[36] = a("th", { rel: "cocAfterTax" }, " CoC After Tax ", -1)),
              (p(!0), h(A, null, D(e.yearRentalTypeValues, (v) => (p(), h("td", {
                key: v.year,
                class: z(["table-column", e.analysisYearStyle(v)]),
                "data-year": v.year
              }, [
                a("div", cJe, g(e.percent(v.cocAfterTax, 1, "N/A")), 1)
              ], 10, dJe))), 128))
            ]),
            a("tr", uJe, [
              a("th", pJe, [
                t[47] || (t[47] = y(" IRR")),
                a("i", {
                  class: "fa-light fa-question-circle ms-2 info-pop",
                  onClick: t[2] || (t[2] = (...v) => e.infoPopover && e.infoPopover(...v)),
                  "data-title": "Internal Rate of Return (IRR)",
                  "data-html": "true",
                  "data-render": "true",
                  "data-pop": "irrr"
                }),
                a("div", hJe, [
                  t[43] || (t[43] = a("p", null, [
                    a("b", null, "Internal Rate of Return (IRR)"),
                    y(" measures how much, on average, you earn annually from a property—factoring in both the amount of money you invest and when you get money back (like rental income or sale proceeds). ")
                  ], -1)),
                  a("p", null, [
                    t[37] || (t[37] = y(" Your IRR gauge reflects an IRR goal of ")),
                    a("b", null, g(e.percent((f = e.blueChipCriteria) == null ? void 0 : f.minIRR)), 1),
                    t[38] || (t[38] = y(". You can adjust your IRR goal in ")),
                    t[39] || (t[39] = a("a", { href: "/account/settings#blue-chip-criteriaTab" }, "Settings - Blue Chip Criteria", -1)),
                    t[40] || (t[40] = y(". "))
                  ]),
                  t[44] || (t[44] = Bt('<p> While cap rate and cash on cash measure the value and performance of a property annually, IRR takes into consideration appreciation, amortization, and the time value of money. </p><p> Because earlier cash flow is &quot;worth more&quot; in IRR terms, a faster exit can increase IRR even if you end up with less total profit. That&#39;s why it&#39;s helpful to look at both IRR and total wealth accumulation when deciding how long to hold the property. </p><p> The formula for IRR is quite complex. It is not something you would ordinarily calculator without a financial calculator or spreadsheet. </p><p> To setup an IRR calculation, you need to know your initial investment, the cash flows received each year during the investment, and the sales proceeds at disposition. This information is placed in a t-bar chart, in the format below: </p><div class="eq-c mb-4 text-center"><table class="table table-sm table-light table-hover table-t"><thead><tr><th>Period</th><th>Cash Flow</th><th>+</th><th>Sales Proceeds</th></tr></thead><tbody class="table-group-divider"><tr><th>0</th><td class="text-end">(Initial Investment)</td><td></td><td></td></tr><tr><th>1</th><td>CF 1</td><td></td><td></td></tr><tr><th><svg width="18px" height="101px" viewBox="0 0 18 101" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><path d="M8.36417631,100.544545 C8.71303532,100.893404 9.28696468,100.893404 9.63582369,100.544545 L17.7383557,92.4420131 C18.0872148,92.0931541 18.0872148,91.5192248 17.7383557,91.1703657 C17.3894967,90.8215067 16.8155674,90.8215067 16.4667083,91.1703657 L9.90028134,97.7367927 L9.90028134,0.900281338 C9.90028134,0.405126602 9.49515474,4.26325641e-14 9,4.26325641e-14 C8.50484526,4.26325641e-14 8.09971866,0.405126602 8.09971866,0.900281338 L8.09971866,97.7367927 L1.53329165,91.1703657 C1.18443264,90.8215067 0.610503282,90.8215067 0.261644264,91.1703657 C-0.0872147546,91.5192248 -0.0872147546,92.0931541 0.261644264,92.4420131 L8.36417631,100.544545 Z" id="Path" fill="#000000" fill-rule="nonzero"></path></svg></th><td class="align-middle">CF x</td><td></td><td></td></tr><tr><th>7</th><td>CF 7</td><td>+</td><td>Sales Proceeds</td></tr></tbody></table></div><p>A t-bar chart populated with the values from the property analysis on this page looks as follows:</p>', 6)),
                  a("div", mJe, [
                    a("table", fJe, [
                      t[41] || (t[41] = a("thead", null, [
                        a("tr", null, [
                          a("th", null, "EoY"),
                          a("th", null, "Cash Flows"),
                          a("th", null, "Sale Proceeds")
                        ])
                      ], -1)),
                      a("tbody", gJe, [
                        (p(!0), h(A, null, D(e.irrCashflow, (v, b) => (p(), h("tr", { key: b }, [
                          a("th", null, g(e.getIrrYear(b)), 1),
                          a("td", vJe, g(e.currency(v, !1)), 1),
                          a("td", yJe, g(e.currency(e.getHoldNetEquity(b), !1, "")), 1)
                        ]))), 128))
                      ])
                    ])
                  ]),
                  a("p", null, [
                    a("strong", null, "IRR = " + g(e.percent(e.getHoldIrr, 1)), 1)
                  ]),
                  t[45] || (t[45] = a("p", null, "Adjust the hold period below to see how it affects the IRR", -1)),
                  a("div", bJe, [
                    t[42] || (t[42] = a("label", {
                      class: "col-sm-4 col-form-label fw-bold",
                      for: "holdPeriodTable"
                    }, "Hold Period", -1)),
                    a("div", AJe, [
                      V(a("select", {
                        "onUpdate:modelValue": t[3] || (t[3] = (v) => e.tooltipHoldPeriod = v),
                        id: "holdPeriodTable",
                        class: "form-select"
                      }, [
                        (p(), h(A, null, D(30, (v) => a("option", {
                          value: v,
                          key: v
                        }, g(v) + " Years", 9, wJe)), 64))
                      ], 512), [
                        [We, e.tooltipHoldPeriod]
                      ])
                    ])
                  ]),
                  t[46] || (t[46] = a("p", { class: "my-4" }, [
                    y(" Continue to learn more!:"),
                    a("br"),
                    a("a", {
                      href: "/dictionary",
                      class: "text-lava"
                    }, "Rescover Investment Term Library")
                  ], -1))
                ])
              ]),
              (p(!0), h(A, null, D(e.yearRentalTypeValues, (v) => (p(), h("td", {
                key: v.year,
                class: z(["table-column", e.analysisYearStyle(v)]),
                "data-year": v.year
              }, [
                a("div", SJe, g(e.percent(v.irr, 1)), 1)
              ], 10, CJe))), 128))
            ]),
            a("tr", PJe, [
              t[48] || (t[48] = a("th", { rel: "irrAfterTax" }, " IRR After Tax ", -1)),
              (p(!0), h(A, null, D(e.yearRentalTypeValues, (v) => (p(), h("td", {
                key: v.year,
                class: z(["table-column", e.analysisYearStyle(v)]),
                "data-year": v.year
              }, [
                a("div", EJe, g(e.percent(v.irrAfterTax, 1)), 1)
              ], 10, kJe))), 128))
            ]),
            a("tr", IJe, [
              a("th", TJe, [
                t[49] || (t[49] = y(" RoE")),
                a("i", {
                  class: "fa-light fa-question-circle ms-2 info-pop",
                  onClick: t[4] || (t[4] = (...v) => e.infoPopover && e.infoPopover(...v)),
                  "data-title": "Return on Equity (RoE)",
                  "data-html": "true",
                  "data-render": "true",
                  "data-pop": "roe"
                }),
                t[50] || (t[50] = a("div", { class: "d-none info-pop-roe" }, [
                  a("p", null, [
                    a("b", null, "Return on Equity (RoE)"),
                    y(" measures how effectively the property’s equity—what you actually own after subtracting any loans—is working to generate profit. In simpler terms, it’s how much money you earn (net profit) each year for every dollar of your own equity in the property. As you pay down the mortgage and the property potentially appreciates, your equity grows, and tracking RoE can help you decide whether to keep, refinance, or sell. ")
                  ])
                ], -1))
              ]),
              (p(!0), h(A, null, D(e.yearRentalTypeValues, (v) => (p(), h("td", {
                key: v.year,
                class: z(["table-column", e.analysisYearStyle(v)]),
                "data-year": v.year
              }, [
                a("div", RJe, g(e.percent(v.roe, 1)), 1)
              ], 10, OJe))), 128))
            ]),
            a("tr", LJe, [
              a("th", BJe, [
                t[51] || (t[51] = y(" LTV")),
                a("i", {
                  class: "fa-light fa-question-circle ms-2 info-pop",
                  onClick: t[5] || (t[5] = (...v) => e.infoPopover && e.infoPopover(...v)),
                  "data-title": "Loan to Value (LTV)",
                  "data-html": "true",
                  "data-render": "true",
                  "data-pop": "ltv"
                }),
                t[52] || (t[52] = a("div", { class: "d-none info-pop-ltv" }, [
                  a("p", null, [
                    a("b", null, "Loan to Value (LTV)"),
                    y(" compares how much you owe on the property (your loan balance) to its market value. For example, if you borrow $80,000 on a $100,000 home, your LTV is 80%. As you pay down your mortgage (amortization) and the property’s value changes, your LTV adjusts each year—giving you insight into how quickly you’re building equity or reaching a target LTV for refinancing. ")
                  ])
                ], -1))
              ]),
              (p(!0), h(A, null, D(e.yearRentalTypeValues, (v) => (p(), h("td", {
                key: v.year,
                class: z(["table-column", e.analysisYearStyle(v)]),
                "data-year": v.year
              }, [
                a("div", xJe, g(e.percent(v.ltv)), 1)
              ], 10, MJe))), 128))
            ]),
            a("tr", FJe, [
              a("th", VJe, [
                t[53] || (t[53] = y(" Debt Coverage Ratio")),
                a("i", {
                  class: "fa-light fa-question-circle ms-2 info-pop",
                  onClick: t[6] || (t[6] = (...v) => e.infoPopover && e.infoPopover(...v)),
                  "data-title": "Debt Coverage Ratio (DCR)",
                  "data-html": "true",
                  "data-render": "true",
                  "data-pop": "dcr"
                }),
                t[54] || (t[54] = a("div", { class: "d-none info-pop-dcr" }, [
                  a("p", null, [
                    a("b", null, "Debt Coverage Ratio (DCR)"),
                    y(" shows how easily the property’s income can cover its mortgage each month. It’s calculated by taking the property’s net operating income and comparing it to the total debt payments. A DCR above 1.0 indicates you’re earning enough to pay the loan, while a higher ratio (e.g., 1.2) means you have a cushion for unexpected costs. Lenders often look at DCR to decide whether the property is a safe investment. ")
                  ])
                ], -1))
              ]),
              (p(!0), h(A, null, D(e.yearRentalTypeValues, (v) => (p(), h("td", {
                key: v.year,
                class: z(["table-column", e.analysisYearStyle(v)]),
                "data-year": v.year
              }, [
                a("div", NJe, g(e.number(v.debtCoverageRatio, 2)), 1)
              ], 10, DJe))), 128))
            ]),
            a("tr", jJe, [
              a("th", HJe, [
                t[55] || (t[55] = y(" OPEX Ratio")),
                a("i", {
                  class: "fa-light fa-question-circle ms-2 info-pop",
                  onClick: t[7] || (t[7] = (...v) => e.infoPopover && e.infoPopover(...v)),
                  "data-title": "Operating Expense Ratio (OPEX ratio)",
                  "data-html": "true",
                  "data-render": "true",
                  "data-pop": "opex"
                }),
                t[56] || (t[56] = a("div", { class: "d-none info-pop-opex" }, [
                  a("p", null, [
                    a("b", null, "Operating Expense Ratio (OPEX ratio)"),
                    y(" shows what fraction of your rental income is spent on property-related costs—like maintenance, utilities, insurance, and property taxes. It’s calculated by dividing your total operating expenses by the property’s income. A lower OPEX ratio typically means you’re keeping expenses under control and retaining more profit. ")
                  ])
                ], -1))
              ]),
              (p(!0), h(A, null, D(e.yearRentalTypeValues, (v) => (p(), h("td", {
                key: v.year,
                class: z(["table-column", e.analysisYearStyle(v)]),
                "data-year": v.year
              }, [
                a("div", zJe, g(e.percent(v.operatingExpenseRatio)), 1)
              ], 10, UJe))), 128))
            ])
          ])
        ], 2)
      ]),
      e.haveAccess ? P("", !0) : (p(), h("div", WJe, t[57] || (t[57] = [
        a("div", { class: "fw-bold fs-5" }, "View our full 30 year analysis with an account!", -1),
        a("a", {
          href: "/signup",
          class: "btn btn-eclipse flex-shrink-0"
        }, "Activate Full Analysis!", -1)
      ])))
    ])
  ], 2);
}
const YJe = /* @__PURE__ */ Ae(LZe, [["render", GJe]]), XJe = me({
  name: "APOD",
  emits: [
    "infoPopover"
  ],
  data() {
    return {
      apodType: ed.NORMALIZED,
      currentYear: Et,
      showRaw: !1
    };
  },
  computed: {
    calculatingClasses() {
      return {
        card: !0,
        "card-apod": !0,
        "shadow-sm": !0,
        "card-proforma": !0,
        calculating: this.calculating,
        "card-guarded": this.haveAccess == !1,
        "card-advanced": !0
      };
    },
    normalized() {
      var e, t;
      return ((t = (e = this.calculatedResults) == null ? void 0 : e.normalized) == null ? void 0 : t.filter((s) => s.fiscalYear >= this.firstTableYear).sort((s, n) => s.fiscalYear - n.fiscalYear)) ?? [];
    },
    raw() {
      var e, t;
      return ((t = (e = this.calculatedResults) == null ? void 0 : e.raw) == null ? void 0 : t.filter((s) => s.fiscalYear >= this.firstTableYear).sort((s, n) => s.fiscalYear - n.fiscalYear)) ?? [];
    },
    shortTerm() {
      var e, t;
      return ((t = (e = this.calculatedResults) == null ? void 0 : e.shortTerm) == null ? void 0 : t.filter((s) => s.fiscalYear >= this.firstTableYear).sort((s, n) => s.fiscalYear - n.fiscalYear)) ?? [];
    },
    padSplit() {
      var e, t;
      return ((t = (e = this.calculatedResults) == null ? void 0 : e.padSplit) == null ? void 0 : t.filter((s) => s.fiscalYear >= this.firstTableYear).sort((s, n) => s.fiscalYear - n.fiscalYear)) ?? [];
    },
    haveAccess() {
      var e, t;
      return this.isMarketplace || ((t = (e = this.acl) == null ? void 0 : e.properties) == null ? void 0 : t.financialAnalysis) == !0;
    },
    showExistingInvestment() {
      var e, t;
      return ((t = (e = this.acl) == null ? void 0 : e.calculator) == null ? void 0 : t.existingInvestment) == !0;
    },
    canExistingInvestment() {
      var e, t;
      return ((t = (e = this.acl) == null ? void 0 : e.calculator) == null ? void 0 : t.existingInvestment) == !0 && this.isClient != !0 && this.isExistingInvestment == !0;
    },
    hasOtherIncome() {
      return this.isShortTerm ? this.shortTerm.some((e) => (e.otherIncome ?? 0) > 0) : this.isPadSplit ? this.padSplit.some((e) => (e.otherIncome ?? 0) > 0) : this.raw.some((e) => (e.otherIncome ?? 0) > 0);
    },
    hasAnyPlatformServiceFees() {
      var e, t, s, n, r, i, o, l, d;
      return this.isShortTerm ? ((t = (e = this.purchaseFacts) == null ? void 0 : e.years) == null ? void 0 : t.some((c) => c.platformServiceFees != null && c.platformServiceFees != 0)) || ((s = this.shortTerm) == null ? void 0 : s.some((c) => c.platformServiceFees != null && c.platformServiceFees != 0)) : this.isPadSplit ? ((r = (n = this.purchaseFacts) == null ? void 0 : n.years) == null ? void 0 : r.some((c) => c.platformServiceFees != null && c.platformServiceFees != 0)) || ((i = this.padSplit) == null ? void 0 : i.some((c) => c.platformServiceFees != null && c.platformServiceFees != 0)) : ((l = (o = this.purchaseFacts) == null ? void 0 : o.years) == null ? void 0 : l.some((c) => c.platformServiceFees != null && c.platformServiceFees != 0)) || ((d = this.raw) == null ? void 0 : d.some((c) => c.platformServiceFees != null && c.platformServiceFees != 0));
    },
    hasAnyFurnishingExpenses() {
      var e, t, s, n, r, i, o, l, d;
      return this.isShortTerm ? ((t = (e = this.purchaseFacts) == null ? void 0 : e.years) == null ? void 0 : t.some((c) => c.furnishingExpenses != null && c.furnishingExpenses != 0)) || ((s = this.shortTerm) == null ? void 0 : s.some((c) => c.furnishingExpenses != null && c.furnishingExpenses != 0)) : this.isPadSplit ? ((r = (n = this.purchaseFacts) == null ? void 0 : n.years) == null ? void 0 : r.some((c) => c.furnishingExpenses != null && c.furnishingExpenses != 0)) || ((i = this.padSplit) == null ? void 0 : i.some((c) => c.furnishingExpenses != null && c.furnishingExpenses != 0)) : ((l = (o = this.purchaseFacts) == null ? void 0 : o.years) == null ? void 0 : l.some((c) => c.furnishingExpenses != null && c.furnishingExpenses != 0)) || ((d = this.raw) == null ? void 0 : d.some((c) => c.furnishingExpenses != null && c.furnishingExpenses != 0));
    },
    hasAnyConsumableExpenses() {
      var e, t, s, n, r, i, o, l, d;
      return this.isShortTerm ? ((t = (e = this.purchaseFacts) == null ? void 0 : e.years) == null ? void 0 : t.some((c) => c.consumableExpenses != null && c.consumableExpenses != 0)) || ((s = this.shortTerm) == null ? void 0 : s.some((c) => c.consumableExpenses != null && c.consumableExpenses != 0)) : this.isPadSplit ? ((r = (n = this.purchaseFacts) == null ? void 0 : n.years) == null ? void 0 : r.some((c) => c.consumableExpenses != null && c.consumableExpenses != 0)) || ((i = this.padSplit) == null ? void 0 : i.some((c) => c.consumableExpenses != null && c.consumableExpenses != 0)) : ((l = (o = this.purchaseFacts) == null ? void 0 : o.years) == null ? void 0 : l.some((c) => c.consumableExpenses != null && c.consumableExpenses != 0)) || ((d = this.raw) == null ? void 0 : d.some((c) => c.consumableExpenses != null && c.consumableExpenses != 0));
    },
    hasAnyCleaningExpenses() {
      var e, t, s, n, r, i, o, l, d;
      return this.isShortTerm ? ((t = (e = this.purchaseFacts) == null ? void 0 : e.years) == null ? void 0 : t.some((c) => c.cleaningExpenses != null && c.cleaningExpenses != 0)) || ((s = this.shortTerm) == null ? void 0 : s.some((c) => c.cleaningExpenses != null && c.cleaningExpenses != 0)) : this.isPadSplit ? ((r = (n = this.purchaseFacts) == null ? void 0 : n.years) == null ? void 0 : r.some((c) => c.cleaningExpenses != null && c.cleaningExpenses != 0)) || ((i = this.padSplit) == null ? void 0 : i.some((c) => c.cleaningExpenses != null && c.cleaningExpenses != 0)) : ((l = (o = this.purchaseFacts) == null ? void 0 : o.years) == null ? void 0 : l.some((c) => c.cleaningExpenses != null && c.cleaningExpenses != 0)) || ((d = this.raw) == null ? void 0 : d.some((c) => c.cleaningExpenses != null && c.cleaningExpenses != 0));
    },
    ...q(ct, ["otherExpenseAccounts", "otherIncomeAccounts", "incomeAccounts", "otherNonOperatingExpenseAccounts"]),
    ...q(Te, ["acl", "aclLoaded", "isClient", "isAdmin", "isUser"]),
    ...q(qe, [
      "calculating",
      "calculatedResults",
      "calcParams",
      "isMarketplace",
      "purchaseFacts",
      "firstAnalyzedYear",
      "isExistingInvestment",
      "rentalTypes",
      "ignoreHistoricalOperatingIncome",
      "isLongTerm",
      "hasLongTerm",
      "isShortTerm",
      "isPadSplit",
      "firstTableYear"
    ])
  },
  methods: {
    number: Ve,
    currency: Ze,
    percent: Wt,
    shortNumber: vr,
    shortCurrency: ka,
    analysisYearStyle: so,
    infoPopover(e) {
      this.$emit("infoPopover", e);
    },
    toggleApod(e) {
      this.showRaw = e.target.checked, this.apodType = this.showRaw ? ed.RAW : ed.NORMALIZED;
    },
    currencyStyle(e) {
      return {
        positive: (e ?? 0) > 0,
        negative: (e ?? 0) < 0
      };
    },
    editInvestment() {
      $("#modalExistingInvestment").on("show.bs.modal", function() {
        $("#value-operating-costs-tab").tab("show");
      }).modal("show");
    },
    getOtherExpense(e, t, s) {
      var n, r, i, o, l, d, c, u, m, f, v, b, w, S, I, T, x;
      if (!(!e || !t))
        return s ? this.isShortTerm ? (m = (u = (c = (d = this.shortTerm) == null ? void 0 : d.find((k) => k.fiscalYear == t)) == null ? void 0 : c.otherExpenses) == null ? void 0 : u.find((k) => k.id == e)) == null ? void 0 : m.total : this.isPadSplit ? (w = (b = (v = (f = this.padSplit) == null ? void 0 : f.find((k) => k.fiscalYear == t)) == null ? void 0 : v.otherExpenses) == null ? void 0 : b.find((k) => k.id == e)) == null ? void 0 : w.total : (x = (T = (I = (S = this.raw) == null ? void 0 : S.find((k) => k.fiscalYear == t)) == null ? void 0 : I.otherExpenses) == null ? void 0 : T.find((k) => k.id == e)) == null ? void 0 : x.total : (l = (o = (i = (r = (n = this.purchaseFacts) == null ? void 0 : n.years) == null ? void 0 : r.find((k) => k.year == t)) == null ? void 0 : i.otherExpenses) == null ? void 0 : o.find((k) => k.id == e)) == null ? void 0 : l.total;
    },
    getOtherNonOperatingExpenseExpense(e, t, s) {
      var n, r, i, o, l, d, c, u, m, f, v, b, w, S, I, T, x;
      if (!(!e || !t))
        return s ? this.isShortTerm ? (m = (u = (c = (d = this.shortTerm) == null ? void 0 : d.find((k) => k.fiscalYear == t)) == null ? void 0 : c.otherNonOperatingExpenses) == null ? void 0 : u.find((k) => k.id == e)) == null ? void 0 : m.total : this.isPadSplit ? (w = (b = (v = (f = this.padSplit) == null ? void 0 : f.find((k) => k.fiscalYear == t)) == null ? void 0 : v.otherNonOperatingExpenses) == null ? void 0 : b.find((k) => k.id == e)) == null ? void 0 : w.total : (x = (T = (I = (S = this.raw) == null ? void 0 : S.find((k) => k.fiscalYear == t)) == null ? void 0 : I.otherNonOperatingExpenses) == null ? void 0 : T.find((k) => k.id == e)) == null ? void 0 : x.total : (l = (o = (i = (r = (n = this.purchaseFacts) == null ? void 0 : n.years) == null ? void 0 : r.find((k) => k.year == t)) == null ? void 0 : i.otherExpenses) == null ? void 0 : o.find((k) => k.id == e)) == null ? void 0 : l.total;
    },
    getShortTermOtherExpense(e, t, s) {
      var n, r, i, o, l, d, c, u, m;
      if (!(!e || !t))
        return s ? (m = (u = (c = (d = this.shortTerm) == null ? void 0 : d.find((f) => f.fiscalYear == t)) == null ? void 0 : c.otherExpenses) == null ? void 0 : u.find((f) => f.id == e)) == null ? void 0 : m.total : (l = (o = (i = (r = (n = this.purchaseFacts) == null ? void 0 : n.years) == null ? void 0 : r.find((f) => f.year == t)) == null ? void 0 : i.otherExpenses) == null ? void 0 : o.find((f) => f.id == e)) == null ? void 0 : l.total;
    },
    getPadSplitOtherExpense(e, t, s) {
      var n, r, i, o, l, d, c, u, m;
      if (!(!e || !t))
        return s ? (m = (u = (c = (d = this.padSplit) == null ? void 0 : d.find((f) => f.fiscalYear == t)) == null ? void 0 : c.otherExpenses) == null ? void 0 : u.find((f) => f.id == e)) == null ? void 0 : m.total : (l = (o = (i = (r = (n = this.purchaseFacts) == null ? void 0 : n.years) == null ? void 0 : r.find((f) => f.year == t)) == null ? void 0 : i.otherExpenses) == null ? void 0 : o.find((f) => f.id == e)) == null ? void 0 : l.total;
    },
    getOtherIncome(e, t, s) {
      var n, r, i, o, l, d, c, u, m;
      if (!(!e || !t))
        return s ? (m = (u = (c = (d = this.raw) == null ? void 0 : d.find((f) => f.fiscalYear == t)) == null ? void 0 : c.otherIncomes) == null ? void 0 : u.find((f) => f.id == e)) == null ? void 0 : m.total : (l = (o = (i = (r = (n = this.purchaseFacts) == null ? void 0 : n.years) == null ? void 0 : r.find((f) => f.year == t)) == null ? void 0 : i.otherIncomes) == null ? void 0 : o.find((f) => f.id == e)) == null ? void 0 : l.total;
    },
    getShortTermOtherIncome(e, t, s) {
      var n, r, i, o, l, d, c, u, m;
      if (!(!e || !t))
        return s ? (m = (u = (c = (d = this.shortTerm) == null ? void 0 : d.find((f) => f.fiscalYear == t)) == null ? void 0 : c.otherIncomes) == null ? void 0 : u.find((f) => f.id == e)) == null ? void 0 : m.total : (l = (o = (i = (r = (n = this.purchaseFacts) == null ? void 0 : n.years) == null ? void 0 : r.find((f) => f.year == t)) == null ? void 0 : i.otherIncomes) == null ? void 0 : o.find((f) => f.id == e)) == null ? void 0 : l.total;
    },
    getPadSplitOtherIncome(e, t, s) {
      var n, r, i, o, l, d, c, u, m;
      if (!(!e || !t))
        return s ? (m = (u = (c = (d = this.padSplit) == null ? void 0 : d.find((f) => f.fiscalYear == t)) == null ? void 0 : c.otherIncomes) == null ? void 0 : u.find((f) => f.id == e)) == null ? void 0 : m.total : (l = (o = (i = (r = (n = this.purchaseFacts) == null ? void 0 : n.years) == null ? void 0 : r.find((f) => f.year == t)) == null ? void 0 : i.otherIncomes) == null ? void 0 : o.find((f) => f.id == e)) == null ? void 0 : l.total;
    },
    getIncome(e, t) {
      var s, n, r, i, o, l;
      if (!(!t || t >= Et))
        switch (e) {
          case "rental-income":
            return (r = (n = (s = this.purchaseFacts) == null ? void 0 : s.years) == null ? void 0 : n.find((d) => d.year == t)) == null ? void 0 : r.annualRentalIncome;
          case "other-income":
            return (l = (o = (i = this.purchaseFacts) == null ? void 0 : i.years) == null ? void 0 : o.find((d) => d.year == t)) == null ? void 0 : l.otherIncome;
        }
    },
    hasAnyValues(e) {
      var t, s, n, r, i, o, l, d, c;
      return this.isShortTerm ? ((s = (t = this.purchaseFacts) == null ? void 0 : t.years) == null ? void 0 : s.some((u) => {
        var m;
        return ((m = u.otherExpenses) == null ? void 0 : m.some((f) => f.id == e.id && f.total != null && f.total != 0)) == !0;
      })) || ((n = this.shortTerm) == null ? void 0 : n.some((u) => {
        var m;
        return ((m = u.otherExpenses) == null ? void 0 : m.some((f) => f.id == e.id && f.total != null && f.total != 0)) == !0;
      })) : this.isPadSplit ? ((i = (r = this.purchaseFacts) == null ? void 0 : r.years) == null ? void 0 : i.some((u) => {
        var m;
        return ((m = u.otherExpenses) == null ? void 0 : m.some((f) => f.id == e.id && f.total != null && f.total != 0)) == !0;
      })) || ((o = this.padSplit) == null ? void 0 : o.some((u) => {
        var m;
        return ((m = u.otherExpenses) == null ? void 0 : m.some((f) => f.id == e.id && f.total != null && f.total != 0)) == !0;
      })) : ((d = (l = this.purchaseFacts) == null ? void 0 : l.years) == null ? void 0 : d.some((u) => {
        var m;
        return ((m = u.otherExpenses) == null ? void 0 : m.some((f) => f.id == e.id && f.total != null && f.total != 0)) == !0;
      })) || ((c = this.raw) == null ? void 0 : c.some((u) => {
        var m;
        return ((m = u.otherExpenses) == null ? void 0 : m.some((f) => f.id == e.id && f.total != null && f.total != 0)) == !0;
      }));
    },
    hasAnyNonOperatingExpenseValues(e) {
      var t, s, n, r, i, o, l, d, c;
      return this.isShortTerm ? ((s = (t = this.purchaseFacts) == null ? void 0 : t.years) == null ? void 0 : s.some((u) => {
        var m;
        return ((m = u.otherExpenses) == null ? void 0 : m.some((f) => f.id == e.id && f.total != null && f.total != 0)) == !0;
      })) || ((n = this.shortTerm) == null ? void 0 : n.some((u) => {
        var m;
        return ((m = u.otherNonOperatingExpenses) == null ? void 0 : m.some((f) => f.id == e.id && f.total != null && f.total != 0)) == !0;
      })) : this.isPadSplit ? ((i = (r = this.purchaseFacts) == null ? void 0 : r.years) == null ? void 0 : i.some((u) => {
        var m;
        return ((m = u.otherExpenses) == null ? void 0 : m.some((f) => f.id == e.id && f.total != null && f.total != 0)) == !0;
      })) || ((o = this.padSplit) == null ? void 0 : o.some((u) => {
        var m;
        return ((m = u.otherNonOperatingExpenses) == null ? void 0 : m.some((f) => f.id == e.id && f.total != null && f.total != 0)) == !0;
      })) : ((d = (l = this.purchaseFacts) == null ? void 0 : l.years) == null ? void 0 : d.some((u) => {
        var m;
        return ((m = u.otherExpenses) == null ? void 0 : m.some((f) => f.id == e.id && f.total != null && f.total != 0)) == !0;
      })) || ((c = this.raw) == null ? void 0 : c.some((u) => {
        var m;
        return ((m = u.otherNonOperatingExpenses) == null ? void 0 : m.some((f) => f.id == e.id && f.total != null && f.total != 0)) == !0;
      }));
    },
    hasAnyIncomeValues(e) {
      var t, s, n, r, i, o, l, d, c;
      return this.isShortTerm ? ((s = (t = this.purchaseFacts) == null ? void 0 : t.years) == null ? void 0 : s.some((u) => {
        var m;
        return ((m = u.otherIncomes) == null ? void 0 : m.some((f) => f.id == e.id && f.total != null && f.total != 0)) == !0;
      })) || ((n = this.shortTerm) == null ? void 0 : n.some((u) => {
        var m;
        return ((m = u.otherIncomes) == null ? void 0 : m.some((f) => f.id == e.id && f.total != null && f.total != 0)) == !0;
      })) : this.isPadSplit ? ((i = (r = this.purchaseFacts) == null ? void 0 : r.years) == null ? void 0 : i.some((u) => {
        var m;
        return ((m = u.otherIncomes) == null ? void 0 : m.some((f) => f.id == e.id && f.total != null && f.total != 0)) == !0;
      })) || ((o = this.padSplit) == null ? void 0 : o.some((u) => {
        var m;
        return ((m = u.otherIncomes) == null ? void 0 : m.some((f) => f.id == e.id && f.total != null && f.total != 0)) == !0;
      })) : ((d = (l = this.purchaseFacts) == null ? void 0 : l.years) == null ? void 0 : d.some((u) => {
        var m;
        return ((m = u.otherIncomes) == null ? void 0 : m.some((f) => f.id == e.id && f.total != null && f.total != 0)) == !0;
      })) || ((c = this.raw) == null ? void 0 : c.some((u) => {
        var m;
        return ((m = u.otherIncomes) == null ? void 0 : m.some((f) => f.id == e.id && f.total != null && f.total != 0)) == !0;
      }));
    },
    buildToolTip(e, t, s) {
      let n = this.currency(e);
      return e && s && s > 0 && t == !1 && (n += ` (${this.percent(e / s)} of Effective Income)`), n;
    }
  },
  watch: {
    isShortTerm(e) {
      e && (this.apodType = ed.RAW);
    }
  }
}), qb = "data:image/png;base64,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", qJe = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAASwAAADwCAYAAAC69lmVAAAABGdBTUEAALGPC/xhBQAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAABLKADAAQAAAABAAAA8AAAAAB88eEgAAArH0lEQVR4Ae2dCdwP1f7Hvzy24i+PVrtS2bKGEpWIor0ochXuLd1yRZulsr6qS0QpV71CUWSp6CqXkspSiluWyHJRkchayH7+3++pM2Z+y/Ob3/PM/H7zG5/zes0zZ845c+ac95z5zPcs83uI4EAABEAABEAABEAABEAABEAABEAABEAABEAABEAABEAABEAABEAABEAABEAABEAABEAABEAABEAABEAABEAABEAABEAABEAABEAABEAABEAABEAABEAABEAABEAABEAABNwTyOc+aZ5Spuo6eSokTgYBEAg2Ab+EJFG+ieKDTQ2lAwEQSAsBr4UjVn6RYZHHaak4LgoCIJB5BLwSj8h87Mfx/HZa9jT2cPhBAARAwCLghVDY8zB+s5cLGX/k3irEnx4THxmOYxAAARDQBPIqEvbzjV/28fxyUROnCxDj2IRjDwIgAAIOApHi4YhMcGA/1/hl79g2bdpU7ZxzzulcqFChZvny5SvH8cUS5ItoEAABEIhJIH/M0OQCY4rVY489Vvjw4cMjKlSosKRw4cJdWayqcrYQq+TYIjUIgICNgBEbW5ArrznPvhe/bPn/8Y9/FB4+fPiMrKysJq5yQyIQAAEQcEHACI6LpI4k5jzZ2zex2PIdPHhwBFtVXRxn4AAEQAAE8kggN13CeGKlhWv16tXVWazuyWO5cDoIgAAIRBHIjWBFZcIBlpXFY1ad+NirfGNdC2EgAAInKQEvhMUSK2aYj62rZicpS1QbBEDAZwK5FSyHSP1ZRgnL/+fSBZ+LjexBAARORgLJCpaIUixnCRgLVtFYCRAGAiAAAnklkKxgRV7PEiqOMP7INDgGARAAAU8I5EWw7NaWESt7mCcFRCYgAAIgYAjkRrCMOEkekX6TL/YgAAIg4DmB3AhWToWAhZUTHcSBAAjkiYBXgmUsrcALllKKdu/eTbLPyf322285RTviJK94+R07doz27t3rSJ8JB6nmJEx+/fVXOn78eCbgscroBycr8xgeuV4ybTNGFmkJ8oqTV4KVFgjJXFREqkePHnTuuedS9erV6YILLqAnn3yS+DMiRzbjx4+nevXqUeXKlalq1arUu3dv4o+4HWnsB1OmTKEyZcpQw4YN7cG0efNm6tixI5133nk6H7nmyJEj4wqb4+Q0HqSa09GjRzWXWrVqUZUqVej888+ne+65h7Zt25ZGCokv7SWnAQMGUOnSpaO2xYsXWwU5cOAAdevWTTOStnnppZfSu+++a8UH1eM1p2TrKRaUiFwWbwV4K8TbKbzJUobivGWzkgbOsZWjbrzxRlWqVCnVqlUrxSKkWGD08aOPPmqV96WXXtJhLFjq8ccfV9ddd50+vuOOO6w0ds///vc/ValSJZ3mkksusaJY4NSVV16pWMjUE088oV577TV1/fXX63QsWla6oHlSzUnq36dPH82lWbNmatCgQequu+7Sx02bNlXCMYjOa05t27ZV/IWIbqPSTmW777771P79+3X15XrSbqX93nrrrZoZC7w+njBhQhARWeX28rkTTqwxSTm7YBXkMzNCsObNm6dvrjwM3OXQMHfs2KEFhS0udeTIEbV9+3bFb3fFFpH2SyJ++1tCN2vWLH2e+XPo0CF19dVXK2k4devWVXbB+uKLL/T1OnXqZJKrXbt26bDLLrvMCguaJ9Wc2IrSTISdXZweeughHf6f//wnaIh0ebzmVKdOHd3O4lX2rbfe0jzat29vtd/vv/9elStXTlWrVk3xkEO8U9Ma7genvHYJAz9mJXLcuHFj+uSTT+jll18mXtiqFbp48eLaL10ScZ9//jnxG42aN29OZ555pg7jn8chVnXtnz17tt6bP2wN0LfffktDhw4l/hzJBOv92WefrfeSn3Fi0oszcSY8SPtUc9qwYYOu/llnnUUFC8r77w8nXR5x69ev/yMgYH+95CTjdj///DOx8NC+ffuIX55Rtf3www91mLRF037Lly+v27V0uZYsWRJ1ThAC/OCUV8EKApeEZShQoABdeOGFVKRIESvt/PnziU1t4rcbSfyWLVt0XNmyZa004uG3mD7+6aefrHBpQGPGjKG//OUvxFaWFW48FStWpEaNGtGCBQtoyJAh9P7779ODDz5I+fPnJ35LmmSB26eaE3eDNIOvv/6afvnlF+2XQXfzgMpLJYjOS07fffedruLEiRN1G5UxvNatW5MRc4ncunWrThPZNs2xvW3qhAH54wcnGYc66Rx350gsJHEiJOLkLScuOztb780fc2wajaTr3r07ycPWr18/kyxqP27cOLr88stpxIgRVpwMJt92223WcdA9fnPiMRlq0qSJtn5F4Fu0aEHr1q2jFStWaDTcVQw6Il2+vHCSCR2xusVKl5fjV199RYsWLaJbbrmFFi5cSMWKFSMjSKYtGiglS5bUXtN2TXhQ915wOiksLPsN5E69ni1cs2YN8RgT8eCujj7lFJk7IBKodmeOJV7e/g888IBepvDCCy9Q0aKxP5sUa4EHR7XVIKL197//XTfGV199lQYPHmzPPrD+VHCSygvHa6+9VnN/7733yHSdZdZVrOKgu7xwkrpJt0ksTB73pKlTp9Ly5cv1TKC0ITkWZ9qmiJvdmWMTb48Lmt8rTiedYIllNX36dC1UAwcOtO6rvO3F8eC4FWY/lmnnadOm6bGu008/nd544w1tnYmFxgP4tHPnTn28bNkymjlzJq1cuZJatmxJkydP1ssneNCeZEyMZyL1WIXjIgE8SAUnqfYZZ5xBY8eO1eNVYllJwxZOOVmvQcKVF06x6iHd4JtvvllHibUpTpbNiItsm9LmxJm2qw8C+scrTidVl3DUqFE0evRokjU/r7zyin4wzP01Y1UykG53IjziZJBTREuc/e2nA/78I2/EG264wRoENdabRIv5LtddunQpffPNN/rNaj83SP5UcbLXWQbdZc2bjN2IRVqzZk17dCD9eeUUr1LGcjddQDNWtWrVKrJ3k+1tM15eQQj3i5ObukUua5DpscCvw+K3tjJTw7L+igVHghxOptVr166tlzpwd1HHcfdE8diKnlLmt78Ok7UxPLPj2HgRn6pfv74Ok0T8NtHn9O/fX58jf37//Xe9BELW0sj6raC6VHKyM+AFu5qZLPsQVkF3XnHiyR7Fs3xWdaUdmvV/c+bM0eE8eaPZ8BiftfxDzpG2JLxknVZQndeckl2WIOnNJt1J+yaLSbMYnLNPxYHpdp999pme0ZMlDLKaWqaOZYZQnMwcSpdEZvZkjKlv3756EJQX6ukBUHmLyUygrICP57jR6PEtGYcQt3btWt0dlDGGdu3a6bylSyjWlYxZSDfRTE/HyzMd4anmZOooVi0vrNVfFLzzzjsOK8KkCdLeS068YJb4/yAQLzQmXoSsx7LEkpJ2Il9RGHfTTTfp9njxxRdTjRo19LDGnj179KTO7bffbpIFau8Hp2QrKGIlIiXiJAtnMsLC4i6GfhvJGynWxmu0rBfU66+/rheCSjpeD6R69uypeODdio/lEavNvnBU0vBnFXp1O5vz+pqyKLVXr16K183EyiIQYengxN/FaSuBu9yKl4AEgkOiQnjJ6b///a9q06aNtuylzfHnYIrH75RwsTux7Pnf5+nFzZKuQYMGisXdniRwfj84iQAl44x1ZYQrIyysZCpo0srb67TTTsuzJSTWnCwOlIH6MDqvOIWRjb1OiTjJN62y0DhRO5GZavn4WdpmGF0iThCsMN511AkEQkpALCQ4EAABEMgIAhCsjLhNKCQIgIAQgGChHYAACGQMAQhWxtwqFBQEQACChTYAAiCQMQQgWBlzq1BQEAABCBbaAAiAQMYQgGBlzK1CQUEABCBYaAMgAAIZQwCClTG3CgUFARCAYKENgAAIZAwBT3/Aj//1UE/50BcOBEAABPwggI+f/aCKPEEABHwhgC6hL1iRKQiAgB8EIFh+UEWeIAACvhCAYPmCFZmCAAj4QQCC5QdV5AkCIOALAQiWL1iRKQiAgB8EIFh+UEWeIAACvhCAYPmCFZmCAAj4QQCC5QdV5AkCIOALAQiWL1iRKQiAgB8EIFh+UEWeIAACvhCAYPmCFZmCAAj4QQCC5QdV5AkCIOALgdAI1rRp02jy5Mm+QApTpuDk7m6CUzA5hUawVq5cmZDwjh076ODBgzmmO3DgAO3atSvHNJkc6RWnw4cP0/bt2zMZRY5l94oT2hORm+fOr/YkP0cjIpfFW0HeCvN2Cm9FeSvOW7ZKoTt69KgaMWKEqlmzpipVqpQqX768at++vVq3bp2jFGx5qbp16+o0ZcqUUXfeeaf68ccfHWlWrVqlbr75ZlW6dGmdrmHDhmrOnDmONPaDjz76SFWqVEmNHj3aHqyPpSzbtm1zhHPDVW3atFGNGzdWfAMdcX4feMlp69atqnPnzqps2bKa00UXXaTGjx8ftwr8glAtWrRQderUcaQRbmHmhPaklJvnLtn2xBqTlAuUYD377LOqRo0ais131bZtWzVu3Dj12GOPqb59+1oPx/vvv68frhdeeEFt3LhRzZ8/X4tG8+bN1fHjx3U6EZDatWurDh06qOXLl6s1a9aorl27agFcvXq1lZfxbNiwQVWuXFk9/PDDJsjax3oQ+e2hy1e/fn31008/WWlT5fGKk9SjWbNm6tprr1Wff/65Eg5PP/20Fp5PPvkkZnUefPBBdd5557kSrLBwQntSys1zl5v2lJRaceJACVatWrXUmDFj9IMi1osITaS79dZb1ZNPPukIFstJ3u5r167V4WPHjlWXXHKJEoDGiVVy/vnnq2HDhpkgvd+3b5+68sor1W233eZIbxJFCpbkIxaJlFUEMx3OK06ffvqpFuqff/7ZUQ3h0adPH0eYHAhXscDkZZHIwgoTJ7Qnpdw8d7lpT57+RHKy6pfX9MWKFaPFixdTx44daffu3ZSdnR2V5dtvvx0VduzYMR1WsKD0aok6deqkN31g+yPpChUqZAshYouBWNjo1VdfJXO+I4HtgJ9Z6tGjBy1atIjeeecdqlixoi02dV6vOF1xxRX03XffOQouLPbu3Uvc1XaEf/nllzRw4ECaMGECscBRvnzyrovtwsYJ7YnIzXOXm/aU0YPu3bt3p5kzZxJ37+iHH36g/fv3x34iIkLlIeI3fo4CMnXqVOK3Pl1//fXW2TILOWvWLLrwwguJu4/E3VB6/fXXyQiglZA9IlJSvtmzZ9Obb75JVatWtUen1O8Hpy1bttC7775L7dq1o+rVq+uXhqkUj9/RvffeS48++ijxmJ0JjrkPOydTabQn0i+veM+d2/ZkeLrdB6pLKN2OFStWqIceesgaLOcHSG3atEmiYrqXXnpJd/XYUogZL4EyYHrBBReoUaNGWWn4n2vo7o10r1577TU9Fvb888/r8ZlevXpZ6UyXULpAFSpUUE2bNlU8m2bFp8vjNacpU6aoBg0aqCpVqqhJkyYpFm1dNelWs8ire+65x6oqP6x60sMKYM/JwknqjPakVKLnzm17citUJl3gBEsahDwkMqAtfeJGjRopNjUlOMrJ2ILM7C1cuDAqzgTIILsM5HN3xgTpvRn3+vrrrx3h5sHjLqkON8cyS7h+/XrF1odq2bKlklnCdDsvOZm6GF7SIMWxVaVkhlXqL+N9sr3xxht6UkP8hw4d0ulOFk6GD9pTzs+dbhT8x/CK156MELndB1Kw5OGQqXNxc+fO1QPqkVaNPCAiVgsWLNDpYv3htTdaYCIbl6SVGUgZhI90S5Ys0dczQmZ/ECXt0qVLtRUmA+/GConMI1XHeeUkgieiE+l69+6tWrVqpYPFspQJjXibWMPiwsxJV5D/oD39cZ/jPXe5aU8ZPYZlFi7KgHuJEiW06O7cuZOKFClCJUuWtET4xRdfJJ7a131otsCscLtn2bJl1Lp1az0uxbOK9ijt5y6iHiPbvHmzI04WGObPn5/4pjjCzQGv/yJ+OIktNBo0aJAJTuneK068ZEQz4uUgjvJzF5xkYF+cDLbzbKhje+655+icc87RYUOGDHGcaw7CxEnqhPZElOi5y017kgWgyTixsOJtIn75+/fv3zOZDHObli0l4vVAesZOVq/zYlHKysqiAQMG6Bm/yy+/XGctD4uIlQwCn3rqqcQmp57pktkuETV50NgK0oPH3BXUA/j2NLJSmReTEi+UpHnz5ulBfhlAl1kvGYCXmTCZFZKBf3GSF3dN6b777qOiRWU9LWkxkwf2mWeeoTPOOIN4zZcOT8UfLzmVK1eOeNxOsz733HP1FwFsuusZoX79+pGIuoh3gQIFHJuwlnLcf//9Ol7qHWZOaE9Ebp673LSnZJ+ZQHUJZ8yYobsisnpduiCy+HPkyJFK1vSIk8H3eF0TCZf1QeKuueaauOmuvvpqnUb+SJdKBpN5eYJOL2uM5HpHjhyx0kR2dawI9gwfPlwvRpVuayqdV5ykzB9//LHil4HFS8areLYwx+rkNOguTCNdpnNCe3L33Ml9T7Y9iQAl4+zWlbao+GSzF2sti8uQ8g/xJk6cSLwIlNi6S6YuuU4ryxh41jDmuq9cZ5qCE73kJJanLPsoXly+yAqX85KTGzJoT0Ru21NGLxw1jYFFMqXrnKTrGWuRqilPUPdecpLudVidl5zcMEJ7Ij1c44ZVKCwsNxVFGhAAgcwnkNGzhJmPHzUAARBIhgAEKxlaSAsCIJBWAhCstOLHxUEABJIhAMFKhhbSggAIpJUABCut+HFxEACBZAhAsJKhhbQgAAJpJQDBSit+XBwEQCAZAhCsZGghLQiAQFoJQLDSih8XBwEQSIYABCsZWkgLAiCQVgKefkv4/fff95SPguFAAARAwA8C+JbQD6rIEwRAwBcC6BL6ghWZggAI+EEAguUHVeQJAiDgCwEIli9YkSkIgIAfBCBYflBFniAAAr4QgGD5ghWZggAI+EEAguUHVeQJAiDgCwEIli9YkSkIgIAfBCBYflBFniAAAr4QgGD5ghWZggAI+EEAguUHVeQJAiDgCwEIli9YkSkIgIAfBCBYflBFniAAAr4QCL1gTZs2jSZPnuwLvDBlCk7u7iY4pZdT6AVr5cqVrggfPnyY5F+Un6wOnNzdeXDKLE7yczQiclm8FeStMG+n8FaUt+K8ZfNDn3Z39OhRNWLECFWzZk1VqlQpVb58edW+fXu1bt26qLKxUKlHHnlEp/v222+j4u0BBw4cUGXKlNFpJV+zvfTSS1ay0aNH6/Bt27ZZYeKRc9u0aaMaN26sduzY4YhL1wE4uSMPTsHh5OkP+LFgBcINHz6cxo8fT/369SMx4a+55hpavXo1TZgwgQYMGGCV8ZdffqG//e1v9M0331hhOXkkj/z589PLL7+s95K2QIEC1LBhw5xOoyNHjlDnzp1p06ZNNGPGDDr99NNzTJ+qSHByRxqcgsPJXUlOpMoIC6tWrVpqzJgx+rUgVs2aNWuiXhH866iqbt266qabblLTp093ZWGx4KmmTZtG5WUPiLSw5O3MYqWkTBs3brQnTbsfnNzdAnAKDqdQjmEVK1aMFi9eTMePH6fdu3dTdnb2Ccn901e6dGnq3bu3tsDOOeecqPhYAatWraKLLrqI9u3bR3v27ImVxBHGt5l69OhBixYtokmTJlHFihUd8ek+ACd3dwCcgsMplILVvXt3mjlzJjVv3px++OEH2r9/fxRx6cq1bt1ad+miIuME8BgXvfPOO3ThhRdStWrVqE6dOvTaa6/FTC0iJeWYPXs2vfnmm1S1atWY6dIZCE7u6INTcDi5K8mJVBnRJRQDdsWKFeqhhx5SbEnp7l67du0UjyHFtG2/+OILV13C9evXq+XLlysWQLV161Y1dOhQfZ50KY0zXUIWM1WhQgXdhdy+fbuJDtwenNzdEnAKBqcTUuTOlzGCJXhlBrB+/frq008/VY0aNVJXXHFFTOpuBSvWybfccou68847rSgjWDJLKAJXvXp11bJlSz1LaCUKmAec3N0QcEo/p1B2CY32mvErFioaOHAg8bIGkplBL52Mf8X712aVKlXSs5U86E9du3bVY2peXturvMDJHUlwSj+nUAoWd8E0WWlgJUqU0P6dO3dSkSJFqGTJku6ou0jFb1xasmQJ8XqvuKl5JpLY6qI5c+bQoEGD4qZLRwQ4uaMOTsHhFDrBWrBgAXE3kAYPHqzXV8ngOo8xabHo0qULZWXJmtc/nFhGvIiT9u7dqwNE4OT44MGD+lhm+GSdljiZIbzhhhv0Zz6ynmrp0qV6bZXMGHbr1k2nifdHBv+lPLJ+6/XXX4+XLKXh4OQONzgFi5O70pxIlRFjWLw4U7Vq1cpalV67dm01cuRIJWui7K5Dhw560NysWDf7V155RSeTNVf16tVTvDxCsTCpvn37qipVquhzZPV827Zto1bP28ew7NcSPy9A1Kvu586dGxmVlmNwcocdnILDSQQoGSfpzSbWmX0T0yWLq7YrmQz9TDtx4kRau3Yt9e/fP1eXkS6frOWSrqRxcixWmHQtxXoLgwMnd3cRnNLPKRxPXByOLJ55Wv9UqFChqJzl05yzzjorKjyTA8DJ3d0Dp/RzCrWF5Q4vUoEACGQKgdANumcKeJQTBEAgeQIQrOSZ4QwQAIE0EYBgpQk8LgsCIJA8AQhW8sxwBgiAQJoIQLDSBB6XBQEQSJ4ABCt5ZjgDBEAgTQQgWGkCj8uCAAgkTwCClTwznAECIJAmAhCsNIHHZUEABJInAMFKnhnOAAEQSBMBT78l5P9E0zPej9mlqX64LAiAQIgI4FvCEN1MVAUEwk4AXcKw32HUDwRCRACCFaKbiaqAQNgJQLDCfodRPxAIEQEIVohuJqoCAmEnAMEK+x1G/UAgRAQgWCG6magKCISdAAQr7HcY9QOBEBGAYIXoZqIqIBB2AhCssN9h1A8EQkQAghWim4mqgEDYCUCwwn6HUT8QCBEBCFaIbiaqAgJhJxAawZo2bRpNnjw57Pcrz/UDJ3cIwSmYnEIjWCtXrkxIeMeOHXTw4MGE6RIlOHbsGO3atStRskDGe8np6NGjJCzC6LzklIgP2tMfhPxoT/JzNCJyWbwV5K0wb6fwVpS34rxlqxQ6rqAaMWKEqlmzpipVqpQqX768at++vVq3bp2jFGx5qbp16+o0ZcqUUXfeeaf68ccfHWnsB8uWLVMVK1ZU/fr1swcrFjv18MMPq/PPP1/n1aBBA/X+++870owePVrHbdu2zRF+4MAB1aZNG9W4cWPFwumI8/vAD07vvfeeOu+889Q///lPR/H/9a9/6frL/Yi1/fvf/9bpTxZOUlm0p1Iq0XPntj2xxiTlAiVYzz77rKpRo4Zi8121bdtWjRs3Tj322GOqb9++1kMkglK2bFn1wgsvqI0bN6r58+dr0WjevLk6fvy4lc54du7cqerVq6cfxkjBuv3221X9+vXVRx99pDZs2KCGDh2q854xY4Y5XcV6EA8fPqzLJ+f+9NNPVtpUebzkxNaAFilpgOXKlYsSrK1bt6oPPvgganv88cf1C8XUP+yczL1Fe8r5uUu2PSWlVpw4UIJVq1YtNWbMGN02xHpZs2aNaSfW/tZbb1VPPvmkdSyeOXPm6Lf/2rVrHeFiiUg+HTt2VHfddZfDwpo9e7Y+5+uvv3ac88gjj6iLL75YW18SEfkgSp6dO3dWUlYRzHQ4Lzl16tRJVa9eXc2dO1fXKdLCilW/I0eOqEaNGikRLePCzknqifaU+LlLtj1l9BhWsWLFaPHixcSWEu3evZuys7OjBPjtt9+mgQMHOsLNuEvBgtKrPeGeeuop2rJlCz3//PMnAv/0schR5cqVqXbt2o64O+64g9hqoFhjHtxmqUePHrRo0SKaNGkScTfTcW6qDrzkxF1u+vDDD6lp06Yk9XPjZDKELS/q1q1bzORh5CQVRXtK/Nwl2548/U33mK3Rx8Du3bvTgw8+SOvXr6fNmzfT/v376cwzz0x4xQkTJlCdOnUcAsLdOpLwmTNnUvHiMhzndD/88ANxN8gZyEfc3dRhPCZGbGlZ8SJS8+bNI7bMtFhVrVrViku1x0tOzZo1S6r4MskxbNgwYiuTzjrrrKhzw8oJ7SnqVuvnK/K5S7Y9ZYRgffXVV47ZvUsvvZTEOmrdujVVqVKFeOyKvvvuO7rsssuoSZMm9Mwzz1CFChWiiXHIqFGj6Msvv9TCZBKsXr2aeDCdnnvuOW1FmXD7nsci9LXsYeI/7bTTdJDE251YdTKTWKlSJeKxHnuUb36/OeWm4GPHjiWecKAHHngg5ulh5IT2FH2rYz130am8D0nLGNb111+vuCtmbSwE3Is44WRQWwa0P/30Uz1WcsUVV5yItPn44VEsIGrhwoVW6J49exQLoOrZs6fat2+ftclsY58+ffSxjEXIzKIMukc6trz02BZbZjrKPjbDlp8e72nZsqWSWUK/nZ+cYpVdZmdzGsPau3ev4heK4hdB1Olh5YT2FHWrVaznLjqV0rP9idpTspKWFsGKVTl7mCwhaNGihQ6SwWCZTt++fbs9iR4MF7FasGCBI5ytEp0+1hS8CeOunerVq5cWNsfJfCCzjpJu+fLlOsr+IErA0qVL9YyjDLzLjEg6XV44xSp3IsF6+umntWD/9ttvUaeHlRPak7vnLqpBcICb9pTRg+4sSlpwZcC9RIkS2i9dsyJFilDJkiUtMX7xxReJp/Z1H5pnq6xw8fASBtq0aRPxDJ5jk761jLtIuHQzb7zxRuL/u0iff/6543wZTJduH8+cOcLNAa//In44SQbtBw0aZIJTuveCU7IFZnGkV199lbp27Uoy6J/IhYUT2pO75y5Re4iMN+0pI8awIgsvx2wpkcww3H///XrwvECBAjR9+nQtCl26dKGsLFnbSnpcSsamJJ1U+t1339Xh8kfGvM4++2wqVKiQFWY8+fPnJ8mzcGFZG0vUsGFDuuqqq3Q+vP6KeNEkTZ06lWRwVQRJ0sdzvOaLBg8eTLwEQpf17rvvjpfU83AvOUnhDh06RGwx6XLK7KyMT8kXBDKmaMbzJHL48OF68oKnrXVaN3/Cwgntyd1zJ20i2fbkph3Z0wSqSygLNlu1aqVX0Uq3TMa5Ro4cqde/iMnJllOO3T1ZTBrPRa7DknSy0v3RRx9VvLxB58sipmbNmuXIIrKrY4/kh1gvnpRuayqdl5ymTJkSk+kNN9xgVUnWm8kqeBZ0KyzSE3ZOkfVFezrx5YP9uUu2PYkAJeMkvdnEpLBvYtJk8Y1K+Ud2EydOJF4ESv379+ci+O+4jtrKiLX8wf+r5/4KqeaU+5Km98xUc0J7cn+/4/dj3OeR9pRyw1O5zilfvnwx12qlHUSCAqSaU4LiBDY61ZzQntw3hVBYWO6ri5QgAAKZTCAUFlYm3wCUHQRAwD0BCJZ7VkgJAiCQZgIQrDTfAFweBEDAPQEIlntWSAkCIJBmAhCsNN8AXB4EQMA9AQiWe1ZICQIgkGYCEKw03wBcHgRAwD0BCJZ7VkgJAiCQZgIQrDTfAFweBEDAPQEIlntWSAkCIJBmAp7+vAz/XlTPX3/9Nc1VwuVBAATCSgDfEob1zqJeIBBCAugShvCmokogEFYCEKyw3lnUCwRCSACCFcKbiiqBQFgJQLDCemdRLxAIIQEIVghvKqoEAmElAMEK651FvUAghAQgWCG8qagSCISVAAQrrHcW9QKBEBKAYIXwpqJKIBBWAhCssN5Z1AsEQkgAghXCm4oqgUBYCUCwwnpnUS8QCCGBk0qwduzYQffdd18Ib6O3VQIndzzBKfWcTirB4p+/od9++80d5RxSHTt2jLZt20bHjx/PIVXmRnnFSQgIoyNHjmQujBxK7hUntKccIOcxSn6ORkQui7eCvBXm7RTeivJWnLdsFUA3f/581axZM1W6dGlVqlQp1bRpU/X222/HLemyZctUxYoVVb9+/Rxp9u/fr3r37q3jJJ9KlSqpp59+Wh09etRKN3r0aH0NFjQrTDwHDhxQbdq0UY0bN1b8ZnbEBeXADaepU6fq+kn97Rs/vFHV2LRpk7rqqqtUo0aNouLCzsleYbSn+M9dsu3J0x/wY8EKnFu5ciW1b9+eunTpQjfffDOtWrWKateuTePHj6cWLVpQsWLFHGXetWsX/fWvf6X8+aONz4cffpi++uorevnll6ly5cr02Wef0RNPPEFFixalbt26OfKxH4iF0blzZ+IHmGbMmEGnn366PToQfrechF+DBg00T1PwEiVKUPny5c2h3i9YsIDuvfdeYpGncuXKOeLiHYSJk6kj2lPOz12y7clwdbvPOAvr8ccfVzfddJN+4bFIqaFDh9pffg6/WEpiBXXs2FHdddddDgvr559/1pbVF1984TiHhUo1adLECou0HCRPFitVq1YttXHjRitd0DxuOd1+++3queeey7H4U6ZMUSxg6qmnntIWqRsLK2ycBBDaU+LnLtn2FG1GuJWuDElXvHhx2rBhA23fvp327NlD2dnZcUvODxht2bKFnn/++ag0Z599NrHg0CWXXOKI40ZJhQoVcoSZA26z1KNHD1q0aBFNmjSJuJtpogK3d8tJ3ogXXXQRyYDzoUOHYtajfv369Oabb1KfPn1iWqqRJ4WRk9QR7Snxc5d0e4psPGE7lu6gdO/YCiIet6Lff/+d5AGJdNJVmzBhAo0dO5bk4XXjRARnz56tu5qR6UWkunfvruPl4a1atWpkkkAdu+EkEw07d+7U3duaNWsSj+HRddddR998842jLiLMPFbnCIt3EEZOUle0p8TPnR/tKbKdZVyXkMVJsWWlhg0bprtlMlB86aWXqg8++ECitGOV1wPo3MhMUFSX0Ir403Pw4EHFY2K6u3n48GEr2nQJ69SpoypUqKAH+FnYrPggexJx4jEmxWN4SgbYZRJBuEkXulq1auqXX36JWTXpaubUJQwjJ7SnP5qCH+0pUpASHWekYJkn6e6771bTp09XPACvypYtq7799lstZiJgPXv2VPv27bM2tjgUd2n0sYxF2J2IVbt27VTz5s31+fY4I1gyS7h+/XpVvXp11bJlS/2A29MF2R+LU7zyihjLS+Ctt96KmSSRYIWNkzykaE/OpuBlewr9GJZdgbkxEQ9+06hRo+jUU0+lxYsX07p160jW08is4QUXXGBtH3/8MY0bN04f83S/lY10KTt06KDHcHhwmU477TQrLtIjXSbJd82aNdS1a9eMWbcVi1Nk3cyxzHgWLFiQ9u7da4KS3oeJE9pT9O33sj2FXrBknMk4ASeD7mxJEVtJxOuyqF69enq5gQyo2zdet6XHaiRMxr/EyRS9jPXIw8nrR0im8xO5unXrEltdNGfOHBo0aFCi5GmLT8QpXsFkmYcsR5AXQV5cWDihPf3RCvxqT6FehyUP0jXXXEPcLaMHHnhAzxKKtTNkyBA9YMwLSDXdWLN8MlBfoEABKlxY1saSXiEvYiVrqXr16kVigRknFkarVq3izohx15EGDx5MjzzyiJ4pZBPZnBqIvVtOIrwiUJ06ddJrq1asWEH9+/cnqV/k7KnMIooTi1RWcpvjkiVLhp4T2pO75y437SnZBybjxrB4SYPiB0xxd0+PtcjqdBnDkrGXnFzkOqwXX3zRsbLbvspb/GyJ6ezsY1iR+Q8fPlyvT5o7d25kVNqP3XCSwWQZ2+OFoJoFL55VAwcOVPIFgN2xSMVltXXrVp00zJzsLIwf7Sn6uctNexIBSsZJerNJd9K+yec6WXyDdiWTYarS/vrrr9oSWLhwobacUnXdTLuOG07SnZZu9RlnnJFp1fOsvG44eXaxDM7IDadk2lOou4T2+yxQatSoAbGyQ4nhd8OpSJEiJNvJ7NxwOpn5mLq74ZRMezppLCwDEHsQAIHMJSBdury46CXjeckN54IACIBADgTyIlgQqxzAIgoEQMB7AnkRLFMaCJchgT0IgICvBLwQLEcBeZZwvyMAByAAAiDgEQGvBEusLL3xIsHNHpUN2YAACICAg4BXgmUylY9855kD7EEABEDASwK5ESxjTUk5Iv20ZMmSCRwezv/O4CV55AUCIJA0gdysw5KL5LjanVe3Pvt///d/f026NDgBBEAABHIgkBsLy56dsbDs++M33njjE/zzufPtCeEHARAAgbwSSFawRJhiObtgqU8++eQQf8F/B/8My1hOjO5hLGIIAwEQSJpAsl1CuYA5J7JbKMcigPIRtOz1NmvWrKr80yMd+N9pNeGfaymTL18++R+GcCAAAiCQNAEjPsmcaM4xgmWEyuwtseJM7X57euO3X1fC4EAABEAgLgGvfq3BdBVN1zCyGyjhIl5GlCIFy4THLSgiQAAEQCA3giXiIwJjRMpOUcJErEScjGjZ0xthihQsk4eJN8fYgwAIgIBFIDeCZZ38p8cuXHaxMqJmLCsjXHJaPMGKzBvHIAACIGARyItFY861740QJdpLAcx5VmHgAQEQAIGcCHhlYYn42C0t+zWNZWVEzMRBsAwJ7EEABFwRyKto2M83ftnH80uhTJwpYOSxCcceBEAABBwEvBALex7Gb/ZyMeOP3DsKYksXGY5jEAABENAEjIjkFUdkPvbjeH77Ne1p7OHwgwAIgIBFwGuhiJVfZFjksVUYeEAABEAgJwJ+iUeifBPF51RmxIEACJykBFIlHKm6zkl6G1FtEAABEAABEAABEAABEAABEAABEAABEAABEAABEAABEAABEAABEAABEAABEAABEAABEAABEAABEAABEEhM4P8BdclXHL3tNc0AAAAASUVORK5CYII=", QJe = { class: "card-header bg-eclipse text-white fw-bold d-flex justify-content-center align-items-center flex-column flex-sm-row text-center text-sm-start rounded rounded-bottom-0" }, KJe = { class: "flex-grow-1" }, ZJe = {
  key: 0,
  class: "badge rounded-pill badge-lava ms-2 apod-type"
}, JJe = {
  key: 1,
  class: "badge rounded-pill badge-lava ms-2 apod-type"
}, $Je = { class: "ms-md-auto d-flex justify-content-between align-items-center mt-2 mt-sm-0" }, _Je = { class: "form-check form-switch" }, e$e = ["disabled"], t$e = { class: "card-body position-relative p-0 overflow-hidden d-flex justify-content-around flex-column flex-lg-row" }, s$e = {
  key: 0,
  class: "calculating-animation position-absolute top-50 start-50 translate-middle text-center"
}, a$e = { class: "table table-sm text-small tabla table-table table-apod table-values regListing mode-advanced" }, n$e = { class: "text-end" }, r$e = ["data-year"], o$e = { class: "table-alice" }, i$e = ["colspan"], l$e = { class: "tb-space" }, d$e = ["data-year"], c$e = ["title"], u$e = ["data-year"], p$e = ["title"], h$e = ["data-year"], m$e = ["title"], f$e = ["data-year"], g$e = ["title"], v$e = ["data-year"], y$e = ["title"], b$e = ["data-year"], A$e = ["title"], w$e = { key: 0 }, C$e = ["data-year"], S$e = ["title"], P$e = { key: 1 }, k$e = ["data-year"], E$e = ["title"], I$e = ["data-year"], T$e = ["title"], O$e = ["data-year"], R$e = ["title"], L$e = { key: 0 }, B$e = { rel: "otherIncome" }, M$e = ["data-year"], x$e = ["title"], F$e = ["data-year"], V$e = ["title"], D$e = ["data-year"], N$e = ["title"], j$e = { class: "table-total table-divider" }, H$e = ["data-year"], U$e = ["title"], z$e = ["data-year"], W$e = ["title"], G$e = ["data-year"], Y$e = ["title"], X$e = { class: "table-alice" }, q$e = ["colspan"], Q$e = { class: "tb-space" }, K$e = ["data-year"], Z$e = ["title"], J$e = ["data-year"], $$e = ["title"], _$e = ["data-year"], e_e = ["title"], t_e = ["data-year"], s_e = ["title"], a_e = ["data-year"], n_e = ["title"], r_e = ["data-year"], o_e = ["title"], i_e = ["data-year"], l_e = ["title"], d_e = ["data-year"], c_e = ["title"], u_e = ["data-year"], p_e = ["title"], h_e = ["data-year"], m_e = ["title"], f_e = { key: 0 }, g_e = ["data-year"], v_e = ["title"], y_e = ["data-year"], b_e = ["title"], A_e = ["data-year"], w_e = ["title"], C_e = { key: 1 }, S_e = ["data-year"], P_e = ["title"], k_e = ["data-year"], E_e = ["title"], I_e = ["data-year"], T_e = ["title"], O_e = ["data-year"], R_e = ["title"], L_e = ["data-year"], B_e = ["title"], M_e = ["data-year"], x_e = ["title"], F_e = ["data-year"], V_e = ["title"], D_e = ["data-year"], N_e = ["title"], j_e = ["data-year"], H_e = ["title"], U_e = ["data-year"], z_e = ["title"], W_e = ["data-year"], G_e = ["title"], Y_e = ["data-year"], X_e = ["title"], q_e = { key: 2 }, Q_e = ["data-year"], K_e = ["title"], Z_e = ["data-year"], J_e = ["title"], $_e = ["data-year"], __e = ["title"], eet = { key: 3 }, tet = ["data-year"], set = ["title"], aet = ["data-year"], net = ["title"], ret = ["data-year"], oet = ["title"], iet = { key: 4 }, det = ["data-year"], cet = ["title"], uet = ["data-year"], pet = ["title"], het = ["data-year"], met = ["title"], fet = { key: 0 }, get = { rel: "cleaningExpenses" }, vet = ["data-year"], yet = ["title"], bet = ["data-year"], Aet = ["title"], wet = ["data-year"], Cet = ["title"], Pet = { class: "table-divider" }, ket = ["data-year"], Eet = ["title"], Iet = ["data-year"], Tet = ["title"], Oet = ["data-year"], Ret = ["title"], Let = { class: "tb-space" }, Bet = { class: "table-total styled-dark-finances fw-bold" }, Met = ["data-year"], xet = ["title"], Fet = ["data-year"], Vet = ["title"], Det = ["data-year"], Net = ["title"], jet = ["data-year"], Het = ["title"], Uet = ["data-year"], zet = ["title"], Wet = { class: "table-divider fw-bold" }, Get = ["data-year"], Yet = ["title"], Xet = ["data-year"], qet = ["title"], Qet = { class: "table-alice" }, Ket = ["colspan"], Zet = { class: "tb-space" }, Jet = { class: "table-total fw-bold" }, $et = ["data-year"], _et = ["title"], ett = ["data-year"], ttt = ["title"], stt = ["data-year"], att = ["title"], ntt = ["data-year"], rtt = ["title"], ott = ["data-year"], itt = ["title"], ltt = ["data-year"], dtt = ["title"], ctt = ["data-year"], utt = ["title"], ptt = { key: 0 }, htt = { rel: "cleaningExpenses" }, mtt = ["data-year"], ftt = ["title"], gtt = ["data-year"], vtt = ["title"], ytt = ["data-year"], btt = ["title"], Att = { class: "table-total table-divider" }, wtt = ["data-year"], Ctt = ["title"], Stt = ["data-year"], Ptt = ["title"], ktt = ["data-year"], Ett = ["title"], Itt = { rel: "taxLiability" }, Ttt = ["data-year"], Ott = ["title"], Rtt = { class: "tb-space" }, Ltt = { class: "table-total styled-dark-finances fw-bold" }, Btt = ["data-year"], Mtt = ["title"], xtt = ["data-year"], Ftt = ["title"], Vtt = ["data-year"], Dtt = ["title"], Ntt = {
  key: 1,
  class: "flex-shrink-0 d-flex justify-content-center align-items-center shadow m-2 m-xxl-4 flex-column flex-sm-row flex-xl-column bg-gradient-periwinkle card-guard rounded-4"
};
function jtt(e, t, s, n, r, i) {
  var o, l, d, c;
  return p(), h("div", {
    class: z(e.calculatingClasses)
  }, [
    a("div", QJe, [
      a("div", KJe, [
        t[2] || (t[2] = y(" ANNUAL PROPERTY OPERATING DATA (APOD) ")),
        e.isShortTerm ? (p(), h("span", JJe, "Short Term")) : (p(), h("span", ZJe, g(e.apodType), 1)),
        e.showExistingInvestment && e.canExistingInvestment ? (p(), h("button", {
          key: 2,
          class: "btn btn-sm btn-outline-eclipse ms-2",
          type: "button",
          onClick: t[0] || (t[0] = (...u) => e.editInvestment && e.editInvestment(...u))
        }, "Edit Income and Expenses")) : P("", !0)
      ]),
      a("div", $Je, [
        a("div", _Je, [
          a("input", {
            type: "checkbox",
            class: "form-check-input",
            id: "toggleApod",
            onClick: t[1] || (t[1] = (...u) => e.toggleApod && e.toggleApod(...u)),
            disabled: e.isShortTerm
          }, null, 8, e$e),
          t[3] || (t[3] = a("label", {
            class: "form-check-label text-white",
            for: "toggleApod"
          }, " Raw data ", -1))
        ])
      ])
    ]),
    a("div", t$e, [
      e.calculating ? (p(), h("div", s$e, t[4] || (t[4] = [
        a("i", { class: "fa-duotone fa-solid fa-compass fa-spin fa-lg text-eclipse" }, null, -1),
        a("br", null, null, -1),
        a("small", null, "Calculating", -1)
      ]))) : P("", !0),
      a("div", {
        class: z(["table-wrap table-data", { "table-guarded": !e.haveAccess }])
      }, [
        a("table", a$e, [
          a("thead", null, [
            a("tr", n$e, [
              t[5] || (t[5] = a("th", null, " ", -1)),
              (p(!0), h(A, null, D(e.normalized, (u) => (p(), h("th", {
                class: z(["table-column", e.analysisYearStyle(u)]),
                "data-year": u.year,
                key: u.year
              }, [
                u.fiscalYear ? (p(), h(A, { key: 0 }, [
                  y(g(u.fiscalYear), 1)
                ], 64)) : (p(), h(A, { key: 1 }, [
                  y(" Year " + g(u.year), 1)
                ], 64))
              ], 10, r$e))), 128))
            ]),
            a("tr", o$e, [
              t[6] || (t[6] = a("th", null, "INCOME", -1)),
              a("td", {
                colspan: e.normalized.length
              }, " ", 8, i$e)
            ])
          ]),
          a("tbody", l$e, [
            a("tr", null, [
              t[7] || (t[7] = a("th", { rel: "potentialrentalincome" }, "Potential Rental Income", -1)),
              e.isShortTerm ? (p(!0), h(A, { key: 0 }, D(e.shortTerm, (u) => (p(), h("td", {
                class: z(["table-column", e.analysisYearStyle(u)]),
                "data-year": u.year,
                key: u.year
              }, [
                a("div", {
                  class: "table-content table-grey adv-potentialrentalincome",
                  title: e.currency(u.potentialRentalIncome)
                }, [
                  u.isProformaYear ? (p(), h(A, { key: 0 }, [
                    y(g(e.shortCurrency(u.potentialRentalIncome)), 1)
                  ], 64)) : (p(), h(A, { key: 1 }, [
                    y(" N/A ")
                  ], 64))
                ], 8, c$e)
              ], 10, d$e))), 128)) : e.isPadSplit ? (p(!0), h(A, { key: 1 }, D(e.padSplit, (u) => (p(), h("td", {
                class: z(["table-column", e.analysisYearStyle(u)]),
                "data-year": u.year,
                key: u.year
              }, [
                a("div", {
                  class: "table-content table-grey adv-potentialrentalincome",
                  title: e.currency(u.potentialRentalIncome)
                }, [
                  u.isProformaYear ? (p(), h(A, { key: 0 }, [
                    y(g(e.shortCurrency(u.potentialRentalIncome)), 1)
                  ], 64)) : (p(), h(A, { key: 1 }, [
                    y(" N/A ")
                  ], 64))
                ], 8, p$e)
              ], 10, u$e))), 128)) : (p(!0), h(A, { key: 2 }, D(e.raw, (u) => (p(), h("td", {
                class: z(["table-column", e.analysisYearStyle(u)]),
                "data-year": u.year,
                key: u.year
              }, [
                a("div", {
                  class: "table-content table-grey adv-potentialrentalincome",
                  title: e.currency(u.potentialRentalIncome)
                }, [
                  u.isProformaYear ? (p(), h(A, { key: 0 }, [
                    y(g(e.shortCurrency(u.potentialRentalIncome)), 1)
                  ], 64)) : (p(), h(A, { key: 1 }, [
                    y(" N/A ")
                  ], 64))
                ], 8, m$e)
              ], 10, h$e))), 128))
            ]),
            a("tr", null, [
              t[8] || (t[8] = a("th", { rel: "vacancyloss" }, "Less: Vacancy Loss", -1)),
              e.isShortTerm ? (p(!0), h(A, { key: 0 }, D(e.shortTerm, (u) => (p(), h("td", {
                class: z(["table-column", e.analysisYearStyle(u)]),
                "data-year": u.year,
                key: u.year
              }, [
                a("div", {
                  class: "table-content table-grey adv-vacancyloss",
                  title: e.currency((u.vacancyLoss ?? 0) + (u.rehabVacancyLoss ?? 0))
                }, [
                  u.isProformaYear ? (p(), h(A, { key: 0 }, [
                    y(g(e.shortCurrency(-((u.vacancyLoss ?? 0) + (u.rehabVacancyLoss ?? 0)))), 1)
                  ], 64)) : (p(), h(A, { key: 1 }, [
                    y(" N/A ")
                  ], 64))
                ], 8, g$e)
              ], 10, f$e))), 128)) : e.isPadSplit ? (p(!0), h(A, { key: 1 }, D(e.padSplit, (u) => (p(), h("td", {
                class: z(["table-column", e.analysisYearStyle(u)]),
                "data-year": u.year,
                key: u.year
              }, [
                a("div", {
                  class: "table-content table-grey adv-vacancyloss",
                  title: e.currency((u.vacancyLoss ?? 0) + (u.rehabVacancyLoss ?? 0))
                }, [
                  u.isProformaYear ? (p(), h(A, { key: 0 }, [
                    y(g(e.shortCurrency(-((u.vacancyLoss ?? 0) + (u.rehabVacancyLoss ?? 0)))), 1)
                  ], 64)) : (p(), h(A, { key: 1 }, [
                    y(" N/A ")
                  ], 64))
                ], 8, y$e)
              ], 10, v$e))), 128)) : (p(!0), h(A, { key: 2 }, D(e.showRaw ? e.raw : e.normalized, (u) => (p(), h("td", {
                class: z(["table-column", e.analysisYearStyle(u)]),
                "data-year": u.year,
                key: u.year
              }, [
                a("div", {
                  class: "table-content table-grey adv-vacancyloss",
                  title: e.currency((u.vacancyLoss ?? 0) + (u.rehabVacancyLoss ?? 0))
                }, [
                  u.isProformaYear ? (p(), h(A, { key: 0 }, [
                    y(g(e.shortCurrency(-((u.vacancyLoss ?? 0) + (u.rehabVacancyLoss ?? 0)))), 1)
                  ], 64)) : (p(), h(A, { key: 1 }, [
                    y(" N/A ")
                  ], 64))
                ], 8, A$e)
              ], 10, b$e))), 128))
            ]),
            e.isExistingInvestment && !e.ignoreHistoricalOperatingIncome ? (p(), h("tr", w$e, [
              t[9] || (t[9] = a("th", { rel: "cleaningExpenses" }, "Rental Income", -1)),
              (p(!0), h(A, null, D(e.raw, (u) => (p(), h("td", {
                class: z(["table-column", e.analysisYearStyle(u)]),
                "data-year": u.year,
                key: u.year
              }, [
                a("div", {
                  class: "table-content table-grey adv-cleaningExpenses",
                  title: e.currency(e.getIncome("rental-income", u.fiscalYear))
                }, g(e.shortCurrency(e.getIncome("rental-income", u.fiscalYear))), 9, S$e)
              ], 10, C$e))), 128))
            ])) : P("", !0),
            e.hasOtherIncome ? (p(), h("tr", P$e, [
              t[10] || (t[10] = a("th", { rel: "cleaningExpenses" }, "Other Income", -1)),
              e.isShortTerm ? (p(!0), h(A, { key: 0 }, D(e.shortTerm, (u) => (p(), h("td", {
                class: z(["table-column", e.analysisYearStyle(u)]),
                "data-year": u.year,
                key: u.year
              }, [
                a("div", {
                  class: "table-content table-grey adv-cleaningExpenses",
                  title: e.currency(u.otherIncome)
                }, g(e.shortCurrency(u.otherIncome)), 9, E$e)
              ], 10, k$e))), 128)) : e.isPadSplit ? (p(!0), h(A, { key: 1 }, D(e.padSplit, (u) => (p(), h("td", {
                class: z(["table-column", e.analysisYearStyle(u)]),
                "data-year": u.year,
                key: u.year
              }, [
                a("div", {
                  class: "table-content table-grey adv-cleaningExpenses",
                  title: e.currency(u.otherIncome)
                }, g(e.shortCurrency(u.otherIncome)), 9, T$e)
              ], 10, I$e))), 128)) : (p(!0), h(A, { key: 2 }, D(e.raw, (u) => (p(), h("td", {
                class: z(["table-column", e.analysisYearStyle(u)]),
                "data-year": u.year,
                key: u.year
              }, [
                a("div", {
                  class: "table-content table-grey adv-cleaningExpenses",
                  title: e.currency(u.otherIncome)
                }, g(e.shortCurrency(u.otherIncome)), 9, R$e)
              ], 10, O$e))), 128))
            ])) : P("", !0),
            (p(!0), h(A, null, D(e.otherIncomeAccounts, (u) => (p(), h(A, null, [
              e.hasAnyIncomeValues(u) ? (p(), h("tr", L$e, [
                a("th", B$e, g(u.name), 1),
                e.isShortTerm ? (p(!0), h(A, { key: 0 }, D(e.shortTerm, (m) => (p(), h("td", {
                  "data-year": m.year,
                  class: z(e.analysisYearStyle(m)),
                  key: m.year
                }, [
                  a("div", {
                    class: "adv-otherIncome",
                    title: e.currency(e.getShortTermOtherIncome(u.id, m.fiscalYear, m.isProformaYear))
                  }, g(e.shortCurrency(e.getShortTermOtherIncome(u.id, m.fiscalYear, m.isProformaYear))), 9, x$e)
                ], 10, M$e))), 128)) : e.isPadSplit ? (p(!0), h(A, { key: 1 }, D(e.padSplit, (m) => (p(), h("td", {
                  "data-year": m.year,
                  class: z(e.analysisYearStyle(m)),
                  key: m.year
                }, [
                  a("div", {
                    class: "adv-otherIncome",
                    title: e.currency(e.getPadSplitOtherIncome(u.id, m.fiscalYear, m.isProformaYear))
                  }, g(e.shortCurrency(e.getPadSplitOtherIncome(u.id, m.fiscalYear, m.isProformaYear))), 9, V$e)
                ], 10, F$e))), 128)) : (p(!0), h(A, { key: 2 }, D(e.raw, (m) => (p(), h("td", {
                  "data-year": m.year,
                  class: z(e.analysisYearStyle(m)),
                  key: m.year
                }, [
                  a("div", {
                    class: "adv-otherIncome",
                    title: e.currency(e.getOtherIncome(u.id, m.fiscalYear, m.isProformaYear))
                  }, g(e.shortCurrency(e.getOtherIncome(u.id, m.fiscalYear, m.isProformaYear))), 9, N$e)
                ], 10, D$e))), 128))
              ])) : P("", !0)
            ], 64))), 256)),
            a("tr", j$e, [
              t[11] || (t[11] = a("th", { rel: "effectiveincome" }, " Effective Income ", -1)),
              e.isShortTerm ? (p(!0), h(A, { key: 0 }, D(e.shortTerm, (u) => (p(), h("th", {
                class: z(["table-column", e.analysisYearStyle(u)]),
                "data-year": u.year,
                key: u.year
              }, [
                a("div", {
                  class: "table-content adv-effectiveincome",
                  title: e.currency(u.effectiveIncome)
                }, g(e.shortCurrency(u.effectiveIncome)), 9, U$e)
              ], 10, H$e))), 128)) : e.isPadSplit ? (p(!0), h(A, { key: 1 }, D(e.padSplit, (u) => (p(), h("th", {
                class: z(["table-column", e.analysisYearStyle(u)]),
                "data-year": u.year,
                key: u.year
              }, [
                a("div", {
                  class: "table-content adv-effectiveincome",
                  title: e.currency(u.effectiveIncome)
                }, g(e.shortCurrency(u.effectiveIncome)), 9, W$e)
              ], 10, z$e))), 128)) : (p(!0), h(A, { key: 2 }, D(e.showRaw ? e.raw : e.normalized, (u) => (p(), h("th", {
                class: z(["table-column", e.analysisYearStyle(u)]),
                "data-year": u.year,
                key: u.year
              }, [
                a("div", {
                  class: "table-content adv-effectiveincome",
                  title: e.currency(u.effectiveIncome)
                }, g(e.shortCurrency(u.effectiveIncome)), 9, Y$e)
              ], 10, G$e))), 128))
            ])
          ]),
          a("thead", null, [
            a("tr", X$e, [
              t[12] || (t[12] = a("th", null, " OPERATING EXPENSES ", -1)),
              a("td", {
                colspan: e.normalized.length
              }, " ", 8, q$e)
            ])
          ]),
          a("tbody", Q$e, [
            a("tr", null, [
              t[13] || (t[13] = a("th", { rel: "propertytax" }, "Property Tax", -1)),
              e.isShortTerm ? (p(!0), h(A, { key: 0 }, D(e.shortTerm, (u) => (p(), h("td", {
                class: z(["table-column", e.analysisYearStyle(u)]),
                "data-year": u.year,
                key: u.year
              }, [
                a("div", {
                  class: "table-content table-grey adv-propertytax",
                  title: e.buildToolTip(u.propertyTax, u.isProformaYear, u.effectiveIncome)
                }, g(e.shortCurrency(u.propertyTax)), 9, Z$e)
              ], 10, K$e))), 128)) : e.isPadSplit ? (p(!0), h(A, { key: 1 }, D(e.padSplit, (u) => (p(), h("td", {
                class: z(["table-column", e.analysisYearStyle(u)]),
                "data-year": u.year,
                key: u.year
              }, [
                a("div", {
                  class: "table-content table-grey adv-propertytax",
                  title: e.buildToolTip(u.propertyTax, u.isProformaYear, u.effectiveIncome)
                }, g(e.shortCurrency(u.propertyTax)), 9, $$e)
              ], 10, J$e))), 128)) : (p(!0), h(A, { key: 2 }, D(e.raw, (u) => (p(), h("td", {
                class: z(["table-column", e.analysisYearStyle(u)]),
                "data-year": u.year,
                key: u.year
              }, [
                a("div", {
                  class: "table-content table-grey adv-propertytax",
                  title: e.buildToolTip(u.propertyTax, u.isProformaYear, u.effectiveIncome)
                }, g(e.shortCurrency(u.propertytax)), 9, e_e)
              ], 10, _$e))), 128))
            ]),
            a("tr", null, [
              t[14] || (t[14] = a("th", { rel: "propertyinsurance" }, "Property Insurance", -1)),
              e.isShortTerm ? (p(!0), h(A, { key: 0 }, D(e.shortTerm, (u) => (p(), h("td", {
                class: z(["table-column", e.analysisYearStyle(u)]),
                "data-year": u.year,
                key: u.year
              }, [
                a("div", {
                  class: "table-content table-grey adv-propertyinsurance",
                  title: e.buildToolTip(u.propertyInsurance, u.isProformaYear, u.effectiveIncome)
                }, g(e.shortCurrency(u.propertyInsurance)), 9, s_e)
              ], 10, t_e))), 128)) : e.isPadSplit ? (p(!0), h(A, { key: 1 }, D(e.padSplit, (u) => (p(), h("td", {
                class: z(["table-column", e.analysisYearStyle(u)]),
                "data-year": u.year,
                key: u.year
              }, [
                a("div", {
                  class: "table-content table-grey adv-propertyinsurance",
                  title: e.buildToolTip(u.propertyInsurance, u.isProformaYear, u.effectiveIncome)
                }, g(e.shortCurrency(u.propertyInsurance)), 9, n_e)
              ], 10, a_e))), 128)) : (p(!0), h(A, { key: 2 }, D(e.raw, (u) => (p(), h("td", {
                class: z(["table-column", e.analysisYearStyle(u)]),
                "data-year": u.year,
                key: u.year
              }, [
                a("div", {
                  class: "table-content table-grey adv-propertyinsurance",
                  title: e.buildToolTip(u.propertyInsurance, u.isProformaYear, u.effectiveIncome)
                }, g(e.shortCurrency(u.propertyInsurance)), 9, o_e)
              ], 10, r_e))), 128))
            ]),
            a("tr", null, [
              t[15] || (t[15] = a("th", { rel: "hoa" }, "HOA", -1)),
              (p(!0), h(A, null, D(e.raw, (u) => (p(), h("td", {
                class: z(["table-column", e.analysisYearStyle(u)]),
                "data-year": u.year,
                key: u.year
              }, [
                a("div", {
                  class: "table-content table-grey adv-hoa",
                  title: e.buildToolTip(u.hoa, u.isProformaYear, u.effectiveIncome)
                }, g(e.shortCurrency(u.hoa)), 9, l_e)
              ], 10, i_e))), 128))
            ]),
            a("tr", null, [
              t[16] || (t[16] = a("th", { rel: "propertymanagement" }, "Property Management", -1)),
              e.isShortTerm ? (p(!0), h(A, { key: 0 }, D(e.shortTerm, (u) => (p(), h("td", {
                class: z(["table-column", e.analysisYearStyle(u)]),
                "data-year": u.year,
                key: u.year
              }, [
                a("div", {
                  class: "table-content table-grey adv-propertymanagement",
                  title: e.buildToolTip(u.propertyManagement, u.isProformaYear, u.effectiveIncome)
                }, g(e.shortCurrency(u.propertyManagement)), 9, c_e)
              ], 10, d_e))), 128)) : e.isPadSplit ? (p(!0), h(A, { key: 1 }, D(e.padSplit, (u) => (p(), h("td", {
                class: z(["table-column", e.analysisYearStyle(u)]),
                "data-year": u.year,
                key: u.year
              }, [
                a("div", {
                  class: "table-content table-grey adv-propertymanagement",
                  title: e.buildToolTip(u.propertyManagement, u.isProformaYear, u.effectiveIncome)
                }, g(e.shortCurrency(u.propertyManagement)), 9, p_e)
              ], 10, u_e))), 128)) : (p(!0), h(A, { key: 2 }, D(e.showRaw ? e.raw : e.normalized, (u) => (p(), h("td", {
                class: z(["table-column", e.analysisYearStyle(u)]),
                "data-year": u.year,
                key: u.year
              }, [
                a("div", {
                  class: "table-content table-grey adv-propertymanagement",
                  title: e.buildToolTip(u.propertyManagement, u.isProformaYear, u.effectiveIncome)
                }, g(e.shortCurrency(u.propertyManagement)), 9, m_e)
              ], 10, h_e))), 128))
            ]),
            e.isLongTerm ? (p(), h("tr", f_e, [
              t[17] || (t[17] = a("th", { rel: "leasingcommissions" }, "Leasing Commissions", -1)),
              e.isShortTerm ? (p(!0), h(A, { key: 0 }, D(e.shortTerm, (u) => (p(), h("td", {
                class: z(["table-column", e.analysisYearStyle(u)]),
                "data-year": u.year,
                key: u.year
              }, [
                a("div", {
                  class: "table-content table-grey adv-leasingcommissions",
                  title: e.buildToolTip(u.leasingCommissions, u.isProformaYear, u.effectiveIncome)
                }, g(e.shortCurrency(u.leasingCommissions)), 9, v_e)
              ], 10, g_e))), 128)) : e.isPadSplit ? (p(!0), h(A, { key: 1 }, D(e.padSplit, (u) => (p(), h("td", {
                class: z(["table-column", e.analysisYearStyle(u)]),
                "data-year": u.year,
                key: u.year
              }, [
                a("div", {
                  class: "table-content table-grey adv-leasingcommissions",
                  title: e.buildToolTip(u.leasingCommissions, u.isProformaYear, u.effectiveIncome)
                }, g(e.shortCurrency(u.leasingCommissions)), 9, b_e)
              ], 10, y_e))), 128)) : (p(!0), h(A, { key: 2 }, D(e.showRaw ? e.raw : e.normalized, (u) => (p(), h("td", {
                class: z(["table-column", e.analysisYearStyle(u)]),
                "data-year": u.year,
                key: u.year
              }, [
                a("div", {
                  class: "table-content table-grey adv-leasingcommissions",
                  title: e.buildToolTip(u.leasingCommissions, u.isProformaYear, u.effectiveIncome)
                }, g(e.shortCurrency(u.leasingCommissions)), 9, w_e)
              ], 10, A_e))), 128))
            ])) : P("", !0),
            e.hasAnyPlatformServiceFees ? (p(), h("tr", C_e, [
              t[18] || (t[18] = a("th", { rel: "platformServiceFees" }, "Platform/Booking Fees", -1)),
              e.isShortTerm ? (p(!0), h(A, { key: 0 }, D(e.shortTerm, (u) => (p(), h("td", {
                class: z(["table-column", e.analysisYearStyle(u)]),
                "data-year": u.year,
                key: u.year
              }, [
                a("div", {
                  class: "table-content table-grey adv-platformServiceFees",
                  title: e.buildToolTip(u.platformServiceFees, u.isProformaYear, u.effectiveIncome)
                }, g(e.shortCurrency(u.platformServiceFees)), 9, P_e)
              ], 10, S_e))), 128)) : e.isPadSplit ? (p(!0), h(A, { key: 1 }, D(e.padSplit, (u) => (p(), h("td", {
                class: z(["table-column", e.analysisYearStyle(u)]),
                "data-year": u.year,
                key: u.year
              }, [
                a("div", {
                  class: "table-content table-grey adv-platformServiceFees",
                  title: e.buildToolTip(u.platformServiceFees, u.isProformaYear, u.effectiveIncome)
                }, g(e.shortCurrency(u.platformServiceFees)), 9, E_e)
              ], 10, k_e))), 128)) : (p(!0), h(A, { key: 2 }, D(e.showRaw ? e.raw : e.normalized, (u) => (p(), h("td", {
                class: z(["table-column", e.analysisYearStyle(u)]),
                "data-year": u.year,
                key: u.year
              }, [
                a("div", {
                  class: "table-content table-grey adv-platformServiceFees",
                  title: e.buildToolTip(u.platformServiceFees, u.isProformaYear, u.effectiveIncome)
                }, g(e.shortCurrency(u.platformServiceFees)), 9, T_e)
              ], 10, I_e))), 128))
            ])) : P("", !0),
            a("tr", null, [
              t[19] || (t[19] = a("th", { rel: "propertymaintenance" }, "Property Maintenance", -1)),
              e.isShortTerm ? (p(!0), h(A, { key: 0 }, D(e.shortTerm, (u) => (p(), h("td", {
                class: z(["table-column", e.analysisYearStyle(u)]),
                "data-year": u.year,
                key: u.year
              }, [
                a("div", {
                  class: "table-content table-grey adv-propertymaintenance",
                  title: e.buildToolTip(u.propertyMaintenance, u.isProformaYear, u.effectiveIncome)
                }, g(e.shortCurrency(u.propertyMaintenance)), 9, R_e)
              ], 10, O_e))), 128)) : e.isPadSplit ? (p(!0), h(A, { key: 1 }, D(e.padSplit, (u) => (p(), h("td", {
                class: z(["table-column", e.analysisYearStyle(u)]),
                "data-year": u.year,
                key: u.year
              }, [
                a("div", {
                  class: "table-content table-grey adv-propertymaintenance",
                  title: e.buildToolTip(u.propertyMaintenance, u.isProformaYear, u.effectiveIncome)
                }, g(e.shortCurrency(u.propertyMaintenance)), 9, B_e)
              ], 10, L_e))), 128)) : (p(!0), h(A, { key: 2 }, D(e.raw, (u) => (p(), h("td", {
                class: z(["table-column", e.analysisYearStyle(u)]),
                "data-year": u.year,
                key: u.year
              }, [
                a("div", {
                  class: "table-content table-grey adv-propertymaintenance",
                  title: e.buildToolTip(u.propertyMaintenance, u.isProformaYear, u.effectiveIncome)
                }, g(e.shortCurrency(u.propertyMaintenance)), 9, x_e)
              ], 10, M_e))), 128))
            ]),
            a("tr", null, [
              t[20] || (t[20] = a("th", { rel: "utilityExpenses" }, "Utility Expenses", -1)),
              e.isShortTerm ? (p(!0), h(A, { key: 0 }, D(e.shortTerm, (u) => (p(), h("td", {
                class: z(["table-column", e.analysisYearStyle(u)]),
                "data-year": u.year,
                key: u.year
              }, [
                a("div", {
                  class: "table-content table-grey adv-utilityExpenses",
                  title: e.buildToolTip(u.utilityExpenses, u.isProformaYear, u.effectiveIncome)
                }, g(e.shortCurrency(u.utilityExpenses)), 9, V_e)
              ], 10, F_e))), 128)) : e.isPadSplit ? (p(!0), h(A, { key: 1 }, D(e.padSplit, (u) => (p(), h("td", {
                class: z(["table-column", e.analysisYearStyle(u)]),
                "data-year": u.year,
                key: u.year
              }, [
                a("div", {
                  class: "table-content table-grey adv-utilityExpenses",
                  title: e.buildToolTip(u.utilityExpenses, u.isProformaYear, u.effectiveIncome)
                }, g(e.shortCurrency(u.utilityExpenses)), 9, N_e)
              ], 10, D_e))), 128)) : (p(!0), h(A, { key: 2 }, D(e.raw, (u) => (p(), h("td", {
                class: z(["table-column", e.analysisYearStyle(u)]),
                "data-year": u.year,
                key: u.year
              }, [
                a("div", {
                  class: "table-content table-grey adv-utilityExpenses",
                  title: e.buildToolTip(u.utilityExpenses, u.isProformaYear, u.effectiveIncome)
                }, g(e.shortCurrency(u.utilityExpenses)), 9, H_e)
              ], 10, j_e))), 128))
            ]),
            a("tr", null, [
              t[21] || (t[21] = a("th", { rel: "otherExpenses" }, "Other Expenses", -1)),
              e.isShortTerm ? (p(!0), h(A, { key: 0 }, D(e.shortTerm, (u) => (p(), h("td", {
                class: z(["table-column", e.analysisYearStyle(u)]),
                "data-year": u.year,
                key: u.year
              }, [
                a("div", {
                  class: "table-content table-grey adv-utilityExpenses",
                  title: e.buildToolTip(u.otherExpense, u.isProformaYear, u.effectiveIncome)
                }, g(e.shortCurrency(u.otherExpense)), 9, z_e)
              ], 10, U_e))), 128)) : e.isPadSplit ? (p(!0), h(A, { key: 1 }, D(e.padSplit, (u) => (p(), h("td", {
                class: z(["table-column", e.analysisYearStyle(u)]),
                "data-year": u.year,
                key: u.year
              }, [
                a("div", {
                  class: "table-content table-grey adv-utilityExpenses",
                  title: e.buildToolTip(u.otherExpense, u.isProformaYear, u.effectiveIncome)
                }, g(e.shortCurrency(u.otherExpense)), 9, G_e)
              ], 10, W_e))), 128)) : (p(!0), h(A, { key: 2 }, D(e.raw, (u) => (p(), h("td", {
                class: z(["table-column", e.analysisYearStyle(u)]),
                "data-year": u.year,
                key: u.year
              }, [
                a("div", {
                  class: "table-content table-grey adv-utilityExpenses",
                  title: e.buildToolTip(u.otherExpense, u.isProformaYear, u.effectiveIncome)
                }, g(e.shortCurrency(u.otherExpense)), 9, X_e)
              ], 10, Y_e))), 128))
            ]),
            e.hasAnyFurnishingExpenses ? (p(), h("tr", q_e, [
              t[22] || (t[22] = a("th", { rel: "furnishingExpenses" }, "Furnishing Expenses", -1)),
              e.isShortTerm ? (p(!0), h(A, { key: 0 }, D(e.shortTerm, (u) => (p(), h("td", {
                class: z(["table-column", e.analysisYearStyle(u)]),
                "data-year": u.year,
                key: u.year
              }, [
                a("div", {
                  class: "table-content table-grey adv-furnishingExpenses",
                  title: e.buildToolTip(u.furnishingExpenses, u.isProformaYear, u.effectiveIncome)
                }, g(e.shortCurrency(u.furnishingExpenses)), 9, K_e)
              ], 10, Q_e))), 128)) : e.isPadSplit ? (p(!0), h(A, { key: 1 }, D(e.padSplit, (u) => (p(), h("td", {
                class: z(["table-column", e.analysisYearStyle(u)]),
                "data-year": u.year,
                key: u.year
              }, [
                a("div", {
                  class: "table-content table-grey adv-furnishingExpenses",
                  title: e.buildToolTip(u.furnishingExpenses, u.isProformaYear, u.effectiveIncome)
                }, g(e.shortCurrency(u.furnishingExpenses)), 9, J_e)
              ], 10, Z_e))), 128)) : (p(!0), h(A, { key: 2 }, D(e.raw, (u) => (p(), h("td", {
                class: z(["table-column", e.analysisYearStyle(u)]),
                "data-year": u.year,
                key: u.year
              }, [
                a("div", {
                  class: "table-content table-grey adv-furnishingExpenses",
                  title: e.buildToolTip(u.furnishingExpenses, u.isProformaYear, u.effectiveIncome)
                }, g(e.shortCurrency(u.furnishingExpenses)), 9, __e)
              ], 10, $_e))), 128))
            ])) : P("", !0),
            e.hasAnyConsumableExpenses ? (p(), h("tr", eet, [
              t[23] || (t[23] = a("th", { rel: "consumableExpenses" }, "Consumable Expenses", -1)),
              e.isShortTerm ? (p(!0), h(A, { key: 0 }, D(e.shortTerm, (u) => (p(), h("td", {
                class: z(["table-column", e.analysisYearStyle(u)]),
                "data-year": u.year,
                key: u.year
              }, [
                a("div", {
                  class: "table-content table-grey adv-consumableExpenses",
                  title: e.buildToolTip(u.consumableExpenses, u.isProformaYear, u.effectiveIncome)
                }, g(e.shortCurrency(u.consumableExpenses)), 9, set)
              ], 10, tet))), 128)) : e.isPadSplit ? (p(!0), h(A, { key: 1 }, D(e.padSplit, (u) => (p(), h("td", {
                class: z(["table-column", e.analysisYearStyle(u)]),
                "data-year": u.year,
                key: u.year
              }, [
                a("div", {
                  class: "table-content table-grey adv-consumableExpenses",
                  title: e.buildToolTip(u.consumableExpenses, u.isProformaYear, u.effectiveIncome)
                }, g(e.shortCurrency(u.consumableExpenses)), 9, net)
              ], 10, aet))), 128)) : (p(!0), h(A, { key: 2 }, D(e.raw, (u) => (p(), h("td", {
                class: z(["table-column", e.analysisYearStyle(u)]),
                "data-year": u.year,
                key: u.year
              }, [
                a("div", {
                  class: "table-content table-grey adv-consumableExpenses",
                  title: e.buildToolTip(u.consumableExpenses, u.isProformaYear, u.effectiveIncome)
                }, g(e.shortCurrency(u.consumableExpenses)), 9, oet)
              ], 10, ret))), 128))
            ])) : P("", !0),
            e.hasAnyCleaningExpenses ? (p(), h("tr", iet, [
              t[24] || (t[24] = a("th", { rel: "cleaningExpenses" }, "Cleaning Expenses", -1)),
              e.isShortTerm ? (p(!0), h(A, { key: 0 }, D(e.shortTerm, (u) => (p(), h("td", {
                class: z(["table-column", e.analysisYearStyle(u)]),
                "data-year": u.year,
                key: u.year
              }, [
                a("div", {
                  class: "table-content table-grey adv-cleaningExpenses",
                  title: e.buildToolTip(u.cleaningExpenses, u.isProformaYear, u.effectiveIncome)
                }, g(e.shortCurrency(u.cleaningExpenses)), 9, cet)
              ], 10, det))), 128)) : e.isPadSplit ? (p(!0), h(A, { key: 1 }, D(e.padSplit, (u) => (p(), h("td", {
                class: z(["table-column", e.analysisYearStyle(u)]),
                "data-year": u.year,
                key: u.year
              }, [
                a("div", {
                  class: "table-content table-grey adv-cleaningExpenses",
                  title: e.buildToolTip(u.cleaningExpenses, u.isProformaYear, u.effectiveIncome)
                }, g(e.shortCurrency(u.cleaningExpenses)), 9, pet)
              ], 10, uet))), 128)) : (p(!0), h(A, { key: 2 }, D(e.raw, (u) => (p(), h("td", {
                class: z(["table-column", e.analysisYearStyle(u)]),
                "data-year": u.year,
                key: u.year
              }, [
                a("div", {
                  class: "table-content table-grey adv-cleaningExpenses",
                  title: e.buildToolTip(u.cleaningExpenses, u.isProformaYear, u.effectiveIncome)
                }, g(e.shortCurrency(u.cleaningExpenses)), 9, met)
              ], 10, het))), 128))
            ])) : P("", !0),
            (p(!0), h(A, null, D(e.otherExpenseAccounts, (u) => (p(), h(A, null, [
              e.hasAnyValues(u) ? (p(), h("tr", fet, [
                a("th", get, g(u.name), 1),
                e.isShortTerm ? (p(!0), h(A, { key: 0 }, D(e.shortTerm, (m) => (p(), h("td", {
                  class: z(["table-column", e.analysisYearStyle(m)]),
                  "data-year": m.year,
                  key: m.year
                }, [
                  a("div", {
                    class: "adv-cleaningExpenses",
                    title: e.buildToolTip(e.getOtherExpense(u.id, m.fiscalYear, m.isProformaYear), m.isProformaYear, m.effectiveIncome)
                  }, g(e.shortCurrency(e.getOtherExpense(u.id, m.fiscalYear, m.isProformaYear))), 9, yet)
                ], 10, vet))), 128)) : e.isPadSplit ? (p(!0), h(A, { key: 1 }, D(e.padSplit, (m) => (p(), h("td", {
                  class: z(["table-column", e.analysisYearStyle(m)]),
                  "data-year": m.year,
                  key: m.year
                }, [
                  a("div", {
                    class: "adv-cleaningExpenses",
                    title: e.buildToolTip(e.getOtherExpense(u.id, m.fiscalYear, m.isProformaYear), m.isProformaYear, m.effectiveIncome)
                  }, g(e.shortCurrency(e.getOtherExpense(u.id, m.fiscalYear, m.isProformaYear))), 9, Aet)
                ], 10, bet))), 128)) : (p(!0), h(A, { key: 2 }, D(e.raw, (m) => (p(), h("td", {
                  class: z(["table-column", e.analysisYearStyle(m)]),
                  "data-year": m.year,
                  key: m.year
                }, [
                  a("div", {
                    class: "adv-cleaningExpenses",
                    title: e.buildToolTip(e.getOtherExpense(u.id, m.fiscalYear, m.isProformaYear), m.isProformaYear, m.effectiveIncome)
                  }, g(e.shortCurrency(e.getOtherExpense(u.id, m.fiscalYear, m.isProformaYear))), 9, Cet)
                ], 10, wet))), 128))
              ])) : P("", !0)
            ], 64))), 256)),
            a("tr", Pet, [
              t[25] || (t[25] = a("th", { rel: "totalexpenses" }, [
                a("strong", null, "Total Expenses")
              ], -1)),
              e.isShortTerm ? (p(!0), h(A, { key: 0 }, D(e.shortTerm, (u) => (p(), h("th", {
                class: z(["table-column", e.analysisYearStyle(u)]),
                "data-year": u.year,
                key: u.year
              }, [
                a("div", {
                  class: "adv-totalexpenses",
                  title: e.buildToolTip(u.totalExpenses, u.isProformaYear, u.effectiveIncome)
                }, g(e.shortCurrency(u.totalExpenses)), 9, Eet)
              ], 10, ket))), 128)) : e.isPadSplit ? (p(!0), h(A, { key: 1 }, D(e.padSplit, (u) => (p(), h("th", {
                class: z(["table-column", e.analysisYearStyle(u)]),
                "data-year": u.year,
                key: u.year
              }, [
                a("div", {
                  class: "adv-totalexpenses",
                  title: e.buildToolTip(u.totalExpenses, u.isProformaYear, u.effectiveIncome)
                }, g(e.shortCurrency(u.totalExpenses)), 9, Tet)
              ], 10, Iet))), 128)) : (p(!0), h(A, { key: 2 }, D(e.showRaw ? e.raw : e.normalized, (u) => (p(), h("th", {
                class: z(["table-column", e.analysisYearStyle(u)]),
                "data-year": u.year,
                key: u.year
              }, [
                a("div", {
                  class: "adv-totalexpenses",
                  title: e.buildToolTip(u.totalexpenses, u.isProformaYear, u.effectiveIncome)
                }, g(e.shortCurrency(u.totalexpenses)), 9, Ret)
              ], 10, Oet))), 128))
            ])
          ]),
          a("tbody", Let, [
            a("tr", Bet, [
              t[26] || (t[26] = a("th", { rel: "noi" }, "Net Operating Income", -1)),
              e.isShortTerm ? (p(!0), h(A, { key: 0 }, D(e.shortTerm, (u) => (p(), h("td", {
                class: z(["table-column", e.analysisYearStyle(u)]),
                "data-year": u.year,
                key: u.year
              }, [
                a("div", {
                  class: "adv-noi",
                  title: e.buildToolTip(u.noi, u.isProformaYear, u.effectiveIncome)
                }, g(e.shortCurrency(u.noi)), 9, xet)
              ], 10, Met))), 128)) : e.isPadSplit ? (p(!0), h(A, { key: 1 }, D(e.padSplit, (u) => (p(), h("td", {
                class: z(["table-column", e.analysisYearStyle(u)]),
                "data-year": u.year,
                key: u.year
              }, [
                a("div", {
                  class: "adv-noi",
                  title: e.buildToolTip(u.noi, u.isProformaYear, u.effectiveIncome)
                }, g(e.shortCurrency(u.noi)), 9, Vet)
              ], 10, Fet))), 128)) : (p(!0), h(A, { key: 2 }, D(e.showRaw ? e.raw : e.normalized, (u) => (p(), h("td", {
                class: z(["table-column", e.analysisYearStyle(u)]),
                "data-year": u.year,
                key: u.year
              }, [
                a("div", {
                  class: "adv-noi",
                  title: e.buildToolTip(u.noi, u.isProformaYear, u.effectiveIncome)
                }, g(e.shortCurrency(u.noi)), 9, Net)
              ], 10, Det))), 128))
            ]),
            a("tr", null, [
              t[27] || (t[27] = a("th", { rel: "mortgageInterest" }, "Less: Mortgage Interest", -1)),
              (p(!0), h(A, null, D(e.raw, (u) => (p(), h("td", {
                class: z(["table-column", e.analysisYearStyle(u)]),
                "data-year": u.year,
                key: u.year
              }, [
                a("div", {
                  class: z(["adv-mortgageInterest", e.currencyStyle(u.mortgageInterest)]),
                  title: e.buildToolTip(u.mortgageInterest, u.isProformaYear, u.effectiveIncome)
                }, g(e.shortCurrency(u.mortgageInterest)), 11, Het)
              ], 10, jet))), 128))
            ]),
            a("tr", null, [
              t[28] || (t[28] = a("th", { rel: "improvementDepreciation" }, "Less: Depreciation", -1)),
              (p(!0), h(A, null, D(e.raw, (u) => (p(), h("td", {
                class: z(["table-column", e.analysisYearStyle(u)]),
                "data-year": u.year,
                key: u.year
              }, [
                a("div", {
                  class: z(["adv-improvementDepreciation", e.currencyStyle(u.improvementDepreciation)]),
                  title: e.buildToolTip(u.improvementDepreciation, u.isProformaYear, u.effectiveIncome)
                }, g(e.shortCurrency(u.improvementDepreciation)), 11, zet)
              ], 10, Uet))), 128))
            ]),
            a("tr", Wet, [
              t[29] || (t[29] = a("th", { rel: "taxableIncome" }, [
                a("strong", null, "Taxable Income")
              ], -1)),
              (p(!0), h(A, null, D(e.showRaw ? e.raw : e.normalized, (u) => (p(), h("td", {
                class: z(["table-column", e.analysisYearStyle(u)]),
                "data-year": u.year,
                key: u.year
              }, [
                a("div", {
                  class: z(["adv-taxableIncome", e.currencyStyle(u.taxableIncome)]),
                  title: e.buildToolTip(u.taxableIncome, u.isProformaYear, u.effectiveIncome)
                }, g(e.shortCurrency(u.taxableIncome)), 11, Yet)
              ], 10, Get))), 128))
            ]),
            a("tr", null, [
              t[30] || (t[30] = a("th", { rel: "taxLiability" }, "Tax Liability", -1)),
              (p(!0), h(A, null, D(e.showRaw ? e.raw : e.normalized, (u) => (p(), h("td", {
                class: z(["table-column", e.analysisYearStyle(u)]),
                "data-year": u.year,
                key: u.year
              }, [
                a("div", {
                  class: z(["adv-taxLiability", e.currencyStyle(u.taxLiability)]),
                  title: e.buildToolTip(u.taxLiability, u.isProformaYear, u.effectiveIncome)
                }, g(e.shortCurrency(u.taxLiability)), 11, qet)
              ], 10, Xet))), 128))
            ])
          ]),
          a("thead", null, [
            a("tr", Qet, [
              t[31] || (t[31] = a("th", null, " CASH FLOW ", -1)),
              a("td", {
                colspan: e.normalized.length
              }, " ", 8, Ket)
            ])
          ]),
          a("tbody", Zet, [
            a("tr", Jet, [
              t[32] || (t[32] = a("th", { rel: "noi" }, "Net Operating Income", -1)),
              e.isShortTerm ? (p(!0), h(A, { key: 0 }, D(e.shortTerm, (u) => (p(), h("td", {
                class: z(["table-column", e.analysisYearStyle(u)]),
                "data-year": u.year,
                key: u.year
              }, [
                a("div", {
                  class: "adv-noi",
                  title: e.buildToolTip(u.noi, u.isProformaYear, u.effectiveIncome)
                }, g(e.shortCurrency(u.noi)), 9, _et)
              ], 10, $et))), 128)) : e.isPadSplit ? (p(!0), h(A, { key: 1 }, D(e.padSplit, (u) => (p(), h("td", {
                class: z(["table-column", e.analysisYearStyle(u)]),
                "data-year": u.year,
                key: u.year
              }, [
                a("div", {
                  class: "adv-noi",
                  title: e.buildToolTip(u.noi, u.isProformaYear, u.effectiveIncome)
                }, g(e.shortCurrency(u.noi)), 9, ttt)
              ], 10, ett))), 128)) : (p(!0), h(A, { key: 2 }, D(e.showRaw ? e.raw : e.normalized, (u) => (p(), h("td", {
                class: z(["table-column", e.analysisYearStyle(u)]),
                "data-year": u.year,
                key: u.year
              }, [
                a("div", {
                  class: "adv-noi",
                  title: e.buildToolTip(u.noi, u.isProformaYear, u.effectiveIncome)
                }, g(e.shortCurrency(u.noi)), 9, att)
              ], 10, stt))), 128))
            ]),
            a("tr", null, [
              t[33] || (t[33] = a("th", { rel: "annualdebtservice" }, "Less: Annual Debt Service", -1)),
              (p(!0), h(A, null, D(e.raw, (u) => (p(), h("td", {
                class: z(["table-column", e.analysisYearStyle(u)]),
                "data-year": u.year,
                key: u.year
              }, [
                a("div", {
                  class: "table-content table-grey adv-annualdebtservice",
                  title: e.currency(u.annualdebtservice)
                }, g(e.shortCurrency(u.annualdebtservice)), 9, rtt)
              ], 10, ntt))), 128))
            ]),
            a("tr", null, [
              t[34] || (t[34] = a("th", { rel: "capitalExpenditures" }, "Less: Capital Expenditures", -1)),
              e.isShortTerm ? (p(!0), h(A, { key: 0 }, D(e.shortTerm, (u) => (p(), h("td", {
                "data-year": u.year,
                class: z(e.analysisYearStyle(u)),
                key: u.year
              }, [
                a("div", {
                  class: "table-content table-grey adv-capitalExpenditures",
                  title: e.currency(u.capitalExpenditures)
                }, g(e.shortCurrency(u.capitalExpenditures)), 9, itt)
              ], 10, ott))), 128)) : e.isPadSplit ? (p(!0), h(A, { key: 1 }, D(e.padSplit, (u) => (p(), h("td", {
                "data-year": u.year,
                class: z(e.analysisYearStyle(u)),
                key: u.year
              }, [
                a("div", {
                  class: "table-content table-grey adv-capitalExpenditures",
                  title: e.currency(u.capitalExpenditures)
                }, g(e.shortCurrency(u.capitalExpenditures)), 9, dtt)
              ], 10, ltt))), 128)) : (p(!0), h(A, { key: 2 }, D(e.raw, (u) => (p(), h("td", {
                "data-year": u.year,
                class: z(e.analysisYearStyle(u)),
                key: u.year
              }, [
                a("div", {
                  class: "table-content table-grey adv-capitalExpenditures",
                  title: e.currency(u.capitalExpenditures)
                }, g(e.shortCurrency(u.capitalExpenditures)), 9, utt)
              ], 10, ctt))), 128))
            ]),
            (p(!0), h(A, null, D(e.otherNonOperatingExpenseAccounts, (u) => (p(), h(A, null, [
              e.hasAnyNonOperatingExpenseValues(u) ? (p(), h("tr", ptt, [
                a("th", htt, g(u.name), 1),
                e.isShortTerm ? (p(!0), h(A, { key: 0 }, D(e.shortTerm, (m) => (p(), h("td", {
                  class: z(["table-column", e.analysisYearStyle(m)]),
                  "data-year": m.year,
                  key: m.year
                }, [
                  a("div", {
                    class: "adv-cleaningExpenses",
                    title: e.currency(e.getOtherNonOperatingExpenseExpense(u.id, m.fiscalYear, m.isProformaYear))
                  }, g(e.shortCurrency(e.getOtherNonOperatingExpenseExpense(u.id, m.fiscalYear, m.isProformaYear))), 9, ftt)
                ], 10, mtt))), 128)) : e.isPadSplit ? (p(!0), h(A, { key: 1 }, D(e.padSplit, (m) => (p(), h("td", {
                  class: z(["table-column", e.analysisYearStyle(m)]),
                  "data-year": m.year,
                  key: m.year
                }, [
                  a("div", {
                    class: "adv-cleaningExpenses",
                    title: e.currency(e.getOtherNonOperatingExpenseExpense(u.id, m.fiscalYear, m.isProformaYear))
                  }, g(e.shortCurrency(e.getOtherNonOperatingExpenseExpense(u.id, m.fiscalYear, m.isProformaYear))), 9, vtt)
                ], 10, gtt))), 128)) : (p(!0), h(A, { key: 2 }, D(e.showRaw ? e.raw : e.normalized, (m) => (p(), h("td", {
                  class: z(["table-column", e.analysisYearStyle(m)]),
                  "data-year": m.year,
                  key: m.year
                }, [
                  a("div", {
                    class: "adv-cleaningExpenses",
                    title: e.currency(e.getOtherNonOperatingExpenseExpense(u.id, m.fiscalYear, m.isProformaYear))
                  }, g(e.shortCurrency(e.getOtherNonOperatingExpenseExpense(u.id, m.fiscalYear, m.isProformaYear))), 9, btt)
                ], 10, ytt))), 128))
              ])) : P("", !0)
            ], 64))), 256)),
            P("", !0),
            a("tr", Att, [
              t[36] || (t[36] = a("th", { rel: "cashFlowBeforeTax" }, "Cash Flow Before Taxes", -1)),
              e.isShortTerm ? (p(!0), h(A, { key: 0 }, D(e.shortTerm, (u) => (p(), h("th", {
                "data-year": u.year,
                class: z(e.analysisYearStyle(u)),
                key: u.year
              }, [
                a("div", {
                  class: "adv-cashFlowBeforeTax",
                  title: e.currency(u.cashFlowBeforeTax)
                }, g(e.shortCurrency(u.cashFlowBeforeTax)), 9, Ctt)
              ], 10, wtt))), 128)) : e.isPadSplit ? (p(!0), h(A, { key: 1 }, D(e.padSplit, (u) => (p(), h("th", {
                "data-year": u.year,
                class: z(e.analysisYearStyle(u)),
                key: u.year
              }, [
                a("div", {
                  class: "adv-cashFlowBeforeTax",
                  title: e.currency(u.cashFlowBeforeTax)
                }, g(e.shortCurrency(u.cashFlowBeforeTax)), 9, Ptt)
              ], 10, Stt))), 128)) : (p(!0), h(A, { key: 2 }, D(e.showRaw ? e.raw : e.normalized, (u) => (p(), h("th", {
                "data-year": u.year,
                class: z(e.analysisYearStyle(u)),
                key: u.year
              }, [
                a("div", {
                  class: z(["adv-cashFlowBeforeTax", e.currencyStyle(u.cashFlowBeforeTax)]),
                  title: e.currency(u.cashFlowBeforeTax)
                }, g(e.shortCurrency(u.cashFlowBeforeTax)), 11, Ett)
              ], 10, ktt))), 128))
            ]),
            a("tr", null, [
              a("th", Itt, [
                t[37] || (t[37] = y(" Less: Tax Liability ")),
                (l = (o = e.calcParams) == null ? void 0 : o.afterTaxAnalysis) != null && l.marginalIncomeTaxRate ? (p(), h(A, { key: 0 }, [
                  y(" (" + g(e.percent((c = (d = e.calcParams) == null ? void 0 : d.afterTaxAnalysis) == null ? void 0 : c.marginalIncomeTaxRate)) + ") ", 1)
                ], 64)) : P("", !0)
              ]),
              (p(!0), h(A, null, D(e.showRaw ? e.raw : e.normalized, (u) => (p(), h("td", {
                class: z(["table-column", e.analysisYearStyle(u)]),
                "data-year": u.year,
                key: u.year
              }, [
                a("div", {
                  class: z(["adv-taxLiability", e.currencyStyle(u.taxLiability)]),
                  title: e.buildToolTip(u.taxLiability, u.isProformaYear, u.effectiveIncome)
                }, g(e.shortCurrency(u.taxLiability)), 11, Ott)
              ], 10, Ttt))), 128))
            ])
          ]),
          a("tbody", Rtt, [
            a("tr", Ltt, [
              t[38] || (t[38] = a("th", { rel: "cashFlowAfterTax" }, [
                a("strong", null, "Cash Flow After Taxes")
              ], -1)),
              e.isShortTerm ? (p(!0), h(A, { key: 0 }, D(e.shortTerm, (u) => (p(), h("th", {
                class: z(["table-column", e.analysisYearStyle(u)]),
                "data-year": u.year,
                key: u.year
              }, [
                a("div", {
                  class: z(["table-content last adv-cashFlowAfterTax", e.currencyStyle(u.cashFlowAfterTax)]),
                  title: e.currency(u.cashFlowAfterTax)
                }, g(e.shortCurrency(u.cashFlowAfterTax)), 11, Mtt)
              ], 10, Btt))), 128)) : e.isPadSplit ? (p(!0), h(A, { key: 1 }, D(e.padSplit, (u) => (p(), h("th", {
                class: z(["table-column", e.analysisYearStyle(u)]),
                "data-year": u.year,
                key: u.year
              }, [
                a("div", {
                  class: z(["table-content last adv-cashFlowAfterTax", e.currencyStyle(u.cashFlowAfterTax)]),
                  title: e.currency(u.cashFlowAfterTax)
                }, g(e.shortCurrency(u.cashFlowAfterTax)), 11, Ftt)
              ], 10, xtt))), 128)) : (p(!0), h(A, { key: 2 }, D(e.showRaw ? e.raw : e.normalized, (u) => (p(), h("th", {
                class: z(["table-column", e.analysisYearStyle(u)]),
                "data-year": u.year,
                key: u.year
              }, [
                a("div", {
                  class: z(["table-content last adv-cashFlowAfterTax", e.currencyStyle(u.cashFlowAfterTax)]),
                  title: e.currency(u.cashFlowAfterTax)
                }, g(e.shortCurrency(u.cashFlowAfterTax)), 11, Dtt)
              ], 10, Vtt))), 128))
            ])
          ])
        ])
      ], 2),
      e.haveAccess ? P("", !0) : (p(), h("div", Ntt, t[39] || (t[39] = [
        Bt('<div class="p-4 order-last order-sm-first order-lg-last d-flex flex-column align-items-center justify-content-between"><div class="fw-bold fs-5 text-center text-sm-start text-lg-center mb-2">View our full 30 year analysis with an account!</div><a href="/signup" class="btn btn-eclipse">Activate Full Analysis!</a></div><div class="d-sm-none d-lg-block order-first order-sm-last order-lg-first"><img src="' + qb + '" alt="Financial APOD table" title="Financial APOD table" height="240" width="426" class="img-fluid" loading="lazy"></div><div class="d-none d-sm-flex d-lg-none order-first order-sm-last order-lg-first"><img src="' + qJe + '" alt="Financial Overview table" title="Financial Overview table" height="290" width="300" class="img-fluid" loading="lazy"></div>', 3)
      ])))
    ])
  ], 2);
}
const Htt = /* @__PURE__ */ Ae(XJe, [["render", jtt]]), Utt = me({
  name: "InvestmentBasis",
  computed: {
    calculatingClasses() {
      return {
        card: !0,
        "card-investment-basis": !0,
        "shadow-sm": !0,
        "card-proforma": !0,
        calculating: this.calculating,
        "card-guarded": this.haveAccess == !1,
        "card-advanced": this.isAdvancedMode == !0
      };
    },
    haveAccess() {
      var e, t;
      return this.isMarketplace || ((t = (e = this.acl) == null ? void 0 : e.properties) == null ? void 0 : t.financialAnalysis) == !0;
    },
    hasNoChange() {
      var t, s, n, r;
      const e = ((s = (t = this.yearRentalTypeValues) == null ? void 0 : t.find((i) => !0)) == null ? void 0 : s.capitalInvestedEnd) ?? NaN;
      return ((n = this.yearRentalTypeValues) == null ? void 0 : n.every((i) => i.capitalInvestedEnd != e)) == !0 || ((r = this.yearRentalTypeValues) == null ? void 0 : r.some((i) => i.capitalInvestedEnd != i.capitalInvestedEnd)) == !0;
    },
    isAdvancedMode() {
      var e;
      return ((e = this.account) == null ? void 0 : e.defaultAnalysisMode) == Hn.Advanced;
    },
    yearsToShow() {
      return this.isAdvancedMode ? this.calculatedResults.raw.length : 5;
    },
    mainTableStyle() {
      return {
        table: !0,
        "table-sm": !0,
        "text-small": !0,
        //'mode-basic': this.isAdvancedMode != true,
        "mode-advanced": !0
      };
    },
    yearRentalTypeValues() {
      var e, t, s, n, r, i;
      switch (this.calcParams.rentalType) {
        case Ut.LongTerm:
          return (t = (e = this.calculatedResults) == null ? void 0 : e.normalized) == null ? void 0 : t.filter((o) => o.fiscalYear >= this.firstTableYear).sort((o, l) => o.fiscalYear - l.fiscalYear).slice(0, this.yearsToShow);
        case Ut.ShortTerm:
          return (n = (s = this.calculatedResults) == null ? void 0 : s.shortTerm) == null ? void 0 : n.filter((o) => o.fiscalYear >= this.firstTableYear).sort((o, l) => o.fiscalYear - l.fiscalYear).slice(0, this.yearsToShow);
        case Ut.PadSplit:
          return (i = (r = this.calculatedResults) == null ? void 0 : r.padSplit) == null ? void 0 : i.filter((o) => o.fiscalYear >= this.firstTableYear).sort((o, l) => o.fiscalYear - l.fiscalYear).slice(0, this.yearsToShow);
      }
    },
    ...q(ct, ["account"]),
    ...q(Te, ["acl"]),
    ...q(qe, ["calculating", "calculatedResults", "calcParams", "isMarketplace", "firstAnalyzedYear", "firstTableYear"])
  },
  methods: {
    currency: Ze,
    shortNumber: vr,
    shortCurrency: ka,
    analysisYearStyle: so
  }
}), ztt = { class: "card-body position-relative p-0 overflow-hidden d-flex justify-content-around flex-column flex-lg-row" }, Wtt = {
  key: 0,
  class: "calculating-animation position-absolute top-50 start-50 translate-middle text-center"
}, Gtt = { class: "table-wrap table-data" }, Ytt = { class: "text-end" }, Xtt = ["data-year"], qtt = ["data-year"], Qtt = ["title"], Ktt = ["data-year"], Ztt = ["title"], Jtt = ["data-year"], $tt = ["title"], _tt = { class: "table-total" }, est = ["data-year"], tst = ["title"], sst = {
  key: 1,
  class: "d-flex justify-content-center align-items-center shadow m-2 m-xxl-4 flex-shrink-0 flex-column flex-sm-row bg-gradient-periwinkle card-guard rounded-4"
};
function ast(e, t, s, n, r, i) {
  return p(), Fe(ks, {
    name: "slide",
    mode: "out-in"
  }, {
    default: ve(() => [
      e.hasNoChange ? P("", !0) : (p(), h("div", {
        key: 0,
        class: z(e.calculatingClasses)
      }, [
        t[7] || (t[7] = a("div", { class: "card-header bg-eclipse text-white rounded rounded-bottom-0 text-center text-sm-start fw-bold" }, " INVESTMENT BASIS ", -1)),
        a("div", ztt, [
          e.calculating ? (p(), h("div", Wtt, t[0] || (t[0] = [
            a("i", { class: "fa-duotone fa-solid fa-compass fa-spin fa-lg text-eclipse" }, null, -1),
            a("br", null, null, -1),
            a("small", null, "Calculating", -1)
          ]))) : P("", !0),
          a("div", Gtt, [
            a("table", {
              class: z(e.mainTableStyle)
            }, [
              a("thead", null, [
                a("tr", Ytt, [
                  t[1] || (t[1] = a("th", null, " ", -1)),
                  (p(!0), h(A, null, D(e.yearRentalTypeValues, (o) => (p(), h("th", {
                    class: z(["table-column", e.analysisYearStyle(o)]),
                    "data-year": o.year
                  }, [
                    o.fiscalYear ? (p(), h(A, { key: 0 }, [
                      y(g(o.fiscalYear), 1)
                    ], 64)) : (p(), h(A, { key: 1 }, [
                      y(" Year " + g(o.year), 1)
                    ], 64))
                  ], 10, Xtt))), 256))
                ])
              ]),
              a("tbody", null, [
                a("tr", null, [
                  t[2] || (t[2] = a("th", { rel: "capitalinvested" }, [
                    y(" Capital Invested "),
                    a("span", { class: "small d-block" }, "(Beginning of Year)")
                  ], -1)),
                  (p(!0), h(A, null, D(e.yearRentalTypeValues, (o) => (p(), h("td", {
                    class: z(["table-column", e.analysisYearStyle(o)]),
                    "data-year": o.year
                  }, [
                    a("div", {
                      class: "table-content adv-capitalinvested",
                      title: e.currency(o.capitalInvestedStart)
                    }, g(e.shortCurrency(o.capitalInvestedStart)), 9, Qtt)
                  ], 10, qtt))), 256))
                ]),
                a("tr", null, [
                  t[3] || (t[3] = a("th", { rel: "reficashinout" }, " Refi Cash In/Out ", -1)),
                  (p(!0), h(A, null, D(e.yearRentalTypeValues, (o) => (p(), h("td", {
                    class: z(["table-column", e.analysisYearStyle(o)]),
                    "data-year": o.year
                  }, [
                    a("div", {
                      class: "table-content adv-reficashinout",
                      title: e.currency(o.refiCashInOut)
                    }, g(e.shortCurrency(o.refiCashInOut, "N/A")), 9, Ztt)
                  ], 10, Ktt))), 256))
                ]),
                a("tr", null, [
                  t[4] || (t[4] = a("th", { rel: "capitalinout" }, " Capital In/Out ", -1)),
                  (p(!0), h(A, null, D(e.yearRentalTypeValues, (o) => (p(), h("td", {
                    class: z(["table-column", e.analysisYearStyle(o)]),
                    "data-year": o.year
                  }, [
                    a("div", {
                      class: "table-content adv-capitalinout",
                      title: e.currency(o.capitalInOut)
                    }, g(e.shortCurrency(o.capitalInOut)), 9, $tt)
                  ], 10, Jtt))), 256))
                ]),
                a("tr", _tt, [
                  t[5] || (t[5] = a("th", {
                    rel: "caiptalinvestedend",
                    class: "fw-bold"
                  }, [
                    y(" Capital Invested "),
                    a("span", { class: "small d-block" }, "(End of Year)")
                  ], -1)),
                  (p(!0), h(A, null, D(e.yearRentalTypeValues, (o) => (p(), h("th", {
                    class: z(["table-column", e.analysisYearStyle(o)]),
                    "data-year": o.year
                  }, [
                    a("div", {
                      class: "table-content adv-caiptalinvestedend strong",
                      title: e.currency(o.capitalInvestedEnd)
                    }, g(e.shortCurrency(o.capitalInvestedEnd)), 9, tst)
                  ], 10, est))), 256))
                ])
              ])
            ], 2)
          ]),
          e.haveAccess ? P("", !0) : (p(), h("div", sst, t[6] || (t[6] = [
            a("div", { class: "p-3 p-xxl-4 text-center order-last order-sm-first" }, [
              a("div", { class: "fw-bold fs-5 mb-3" }, "View our full 30 year analysis with an account!"),
              a("a", {
                href: "/signup",
                class: "btn btn-eclipse"
              }, "Activate Full Analysis!")
            ], -1)
          ])))
        ])
      ], 2))
    ]),
    _: 1
  });
}
const nst = /* @__PURE__ */ Ae(Utt, [["render", ast]]), rst = me({
  name: "InvestmentTrajectory",
  computed: {
    calculatingClasses() {
      return {
        card: !0,
        "card-investment-trajectory": !0,
        "shadow-sm": !0,
        "card-proforma": !0,
        calculating: this.calculating,
        "card-guarded": this.haveAccess == !1,
        "card-advanced": this.isAdvancedMode == !0
      };
    },
    haveAccess() {
      var e, t;
      return this.isMarketplace || ((t = (e = this.acl) == null ? void 0 : e.properties) == null ? void 0 : t.financialAnalysis) == !0;
    },
    yearRentalTypeValues() {
      var e, t, s, n, r, i;
      switch (this.calcParams.rentalType) {
        case Ut.LongTerm:
          return ((t = (e = this.calculatedResults) == null ? void 0 : e.normalized) == null ? void 0 : t.filter((o) => o.fiscalYear >= this.firstTableYear).sort((o, l) => o.fiscalYear - l.fiscalYear).slice(0, this.yearsToShow)) ?? [];
        case Ut.ShortTerm:
          return ((n = (s = this.calculatedResults) == null ? void 0 : s.shortTerm) == null ? void 0 : n.filter((o) => o.fiscalYear >= this.firstTableYear).sort((o, l) => o.fiscalYear - l.fiscalYear).slice(0, this.yearsToShow)) ?? [];
        case Ut.PadSplit:
          return ((i = (r = this.calculatedResults) == null ? void 0 : r.padSplit) == null ? void 0 : i.filter((o) => o.fiscalYear >= this.firstTableYear).sort((o, l) => o.fiscalYear - l.fiscalYear).slice(0, this.yearsToShow)) ?? [];
        default:
          return [];
      }
    },
    yearRentalTypeRawValues() {
      var e, t, s, n, r, i;
      switch (this.calcParams.rentalType) {
        case Ut.LongTerm:
          return ((t = (e = this.calculatedResults) == null ? void 0 : e.raw) == null ? void 0 : t.filter((o) => o.fiscalYear >= this.firstTableYear).sort((o, l) => o.fiscalYear - l.fiscalYear).slice(0, this.yearsToShow)) ?? [];
        case Ut.ShortTerm:
          return ((n = (s = this.calculatedResults) == null ? void 0 : s.shortTerm) == null ? void 0 : n.filter((o) => o.fiscalYear >= this.firstTableYear).sort((o, l) => o.fiscalYear - l.fiscalYear).slice(0, this.yearsToShow)) ?? [];
        case Ut.PadSplit:
          return ((i = (r = this.calculatedResults) == null ? void 0 : r.padSplit) == null ? void 0 : i.filter((o) => o.fiscalYear >= this.firstTableYear).sort((o, l) => o.fiscalYear - l.fiscalYear).slice(0, this.yearsToShow)) ?? [];
        default:
          return [];
      }
    },
    yearsToShow() {
      return this.isAdvancedMode ? 30 : 5;
    },
    mainTableStyle() {
      return {
        table: !0,
        "table-sm": !0,
        "text-small": !0,
        //'mode-basic': this.isAdvancedMode != true,
        "mode-advanced": this.isAdvancedMode == !0
      };
    },
    isAdvancedMode() {
      var e;
      return ((e = this.account) == null ? void 0 : e.defaultAnalysisMode) == Hn.Advanced;
    },
    ...q(ct, ["account"]),
    ...q(Te, ["acl"]),
    ...q(qe, ["calculating", "calculatedResults", "property", "calcParams", "isMarketplace", "firstAnalyzedYear", "firstTableYear", "isFlip"])
  },
  methods: {
    currency: Ze,
    shortNumber: vr,
    shortCurrency: ka,
    analysisYearStyle: so,
    currencyStyle(e) {
      return {
        positive: (e ?? 0) > 0,
        negative: (e ?? 0) < 0
      };
    }
  }
}), ost = { class: "card-body position-relative p-0 overflow-hidden d-flex justify-content-around flex-column flex-lg-row" }, ist = {
  key: 0,
  class: "calculating-animation position-absolute top-50 start-50 translate-middle text-center"
}, lst = { class: "table-wrap table-data" }, dst = { class: "text-end" }, cst = ["data-year"], ust = { class: "table-alice" }, pst = ["colspan"], hst = { class: "tb-space" }, mst = ["data-year"], fst = ["title"], gst = ["data-year"], vst = ["title"], yst = { class: "table-total table-divider" }, bst = ["data-year"], Ast = ["title"], wst = ["data-year"], Cst = ["title"], Sst = { class: "tb-space" }, Pst = { class: "table-total styled-dark-finances fw-bold" }, kst = ["data-year"], Est = ["title"], Ist = { class: "table-alice" }, Tst = ["colspan"], Ost = { class: "tb-space" }, Rst = ["data-year"], Lst = ["title"], Bst = ["data-year"], Mst = ["title"], xst = { class: "table-total table-divider" }, Fst = ["data-year"], Vst = ["title"], Dst = ["data-year"], Nst = ["title"], jst = { class: "tb-space" }, Hst = { class: "table-total styled-dark-finances fw-bold" }, Ust = ["data-year"], zst = ["title"], Wst = {
  key: 1,
  class: "d-flex justify-content-center align-items-center shadow m-2 m-xxl-4 flex-shrink-0 flex-row flex-sm-column bg-gradient-periwinkle card-guard rounded-4 p-3 p-xxl-4 text-center"
};
function Gst(e, t, s, n, r, i) {
  return p(), h("div", {
    class: z(e.calculatingClasses)
  }, [
    t[15] || (t[15] = a("div", { class: "card-header bg-eclipse text-white rounded rounded-bottom-0 text-center text-sm-start fw-bold" }, " INVESTMENT TRAJECTORY ", -1)),
    a("div", ost, [
      e.calculating ? (p(), h("div", ist, t[0] || (t[0] = [
        a("i", { class: "fa-duotone fa-solid fa-compass fa-spin fa-lg text-eclipse" }, null, -1),
        a("br", null, null, -1),
        a("small", null, "Calculating", -1)
      ]))) : P("", !0),
      a("div", lst, [
        a("table", {
          class: z(e.mainTableStyle)
        }, [
          a("thead", null, [
            a("tr", dst, [
              t[1] || (t[1] = a("th", null, " ", -1)),
              (p(!0), h(A, null, D(e.yearRentalTypeValues, (o) => (p(), h("th", {
                class: z(["table-column", e.analysisYearStyle(o)]),
                "data-year": o.year
              }, [
                o.fiscalYear ? (p(), h(A, { key: 0 }, [
                  y(g(o.fiscalYear), 1)
                ], 64)) : (p(), h(A, { key: 1 }, [
                  y(" Year " + g(o.year), 1)
                ], 64))
              ], 10, cst))), 256))
            ])
          ]),
          a("thead", null, [
            a("tr", ust, [
              t[2] || (t[2] = a("th", null, " Net Gain Before Tax ", -1)),
              a("td", {
                colspan: e.yearRentalTypeValues.length
              }, " ", 8, pst)
            ])
          ]),
          a("tbody", hst, [
            a("tr", null, [
              t[3] || (t[3] = a("th", { rel: "netequity" }, " Net Equity ", -1)),
              (p(!0), h(A, null, D(e.yearRentalTypeRawValues, (o) => (p(), h("td", {
                class: z(["table-column", e.analysisYearStyle(o)]),
                "data-year": o.year
              }, [
                a("div", {
                  class: "cell-content adv-netequity",
                  title: e.currency(o.netEquity)
                }, g(e.shortCurrency(o.netEquity)), 9, fst)
              ], 10, mst))), 256))
            ]),
            a("tr", null, [
              t[4] || (t[4] = a("th", { rel: "cumCashFlow" }, " Cummulative Cash Flow ", -1)),
              (p(!0), h(A, null, D(e.yearRentalTypeValues, (o) => (p(), h("td", {
                class: z(["table-column", e.analysisYearStyle(o)]),
                "data-year": o.year
              }, [
                a("div", {
                  class: "cell-content adv-cumCashFlow",
                  title: e.currency(o.cumCashFlow)
                }, g(e.shortCurrency(o.cumCashFlow)), 9, vst)
              ], 10, gst))), 256))
            ]),
            a("tr", yst, [
              t[5] || (t[5] = a("th", { rel: "grossWealthAccumulation" }, " Gross Wealth Accumulation ", -1)),
              (p(!0), h(A, null, D(e.yearRentalTypeValues, (o) => (p(), h("th", {
                class: z(["table-column", e.analysisYearStyle(o)]),
                "data-year": o.year
              }, [
                a("div", {
                  class: "cell-content adv-grossWealthAccumulation",
                  title: e.currency(o.grossWealthAccumulation)
                }, g(e.shortCurrency(o.grossWealthAccumulation)), 9, Ast)
              ], 10, bst))), 256))
            ]),
            a("tr", null, [
              t[6] || (t[6] = a("th", { rel: "initialInvestment" }, " Less: Net Investment ", -1)),
              (p(!0), h(A, null, D(e.yearRentalTypeValues, (o) => (p(), h("th", {
                class: z(["table-column", e.analysisYearStyle(o)]),
                "data-year": o.year
              }, [
                a("div", {
                  class: "cell-content adv-initialInvestment",
                  title: e.currency(e.isFlip ? o.capitalInvestedEnd : o.initialInvestment)
                }, [
                  e.isFlip ? (p(), h(A, { key: 0 }, [
                    y(g(e.shortCurrency(o.capitalInvestedEnd)), 1)
                  ], 64)) : (p(), h(A, { key: 1 }, [
                    y(g(e.shortCurrency(o.initialInvestment)), 1)
                  ], 64))
                ], 8, Cst)
              ], 10, wst))), 256))
            ])
          ]),
          a("tbody", Sst, [
            a("tr", Pst, [
              t[7] || (t[7] = a("th", { rel: "netGainOnInvestment" }, " Net Gain on Investment ", -1)),
              (p(!0), h(A, null, D(e.yearRentalTypeValues, (o) => (p(), h("th", {
                class: z(["table-column", e.analysisYearStyle(o)]),
                "data-year": o.year
              }, [
                a("div", {
                  class: z(["cell-content adv-netGainOnInvestment", e.currencyStyle(o.netGainOnInvestment)]),
                  title: e.currency(o.netGainOnInvestment)
                }, g(e.shortCurrency(o.netGainOnInvestment)), 11, Est)
              ], 10, kst))), 256))
            ])
          ]),
          a("thead", null, [
            a("tr", Ist, [
              t[8] || (t[8] = a("th", null, " Net Gain After Tax ", -1)),
              a("td", {
                colspan: e.yearRentalTypeValues.length
              }, " ", 8, Tst)
            ])
          ]),
          a("tbody", Ost, [
            a("tr", null, [
              t[9] || (t[9] = a("th", { rel: "netEquityAfterTax" }, " Net Equity ", -1)),
              (p(!0), h(A, null, D(e.yearRentalTypeRawValues, (o) => (p(), h("td", {
                class: z(["table-column", e.analysisYearStyle(o)]),
                "data-year": o.year
              }, [
                a("div", {
                  class: "cell-content adv-netEquityAfterTax",
                  title: e.currency(o.netEquityAfterTax)
                }, g(e.shortCurrency(o.netEquityAfterTax)), 9, Lst)
              ], 10, Rst))), 256))
            ]),
            a("tr", null, [
              t[10] || (t[10] = a("th", { rel: "cumCashFlowAfterTax" }, " Cummulative Cash Flow ", -1)),
              (p(!0), h(A, null, D(e.yearRentalTypeValues, (o) => (p(), h("td", {
                class: z(["table-column", e.analysisYearStyle(o)]),
                "data-year": o.year
              }, [
                a("div", {
                  class: "cell-content adv-cumCashFlowAfterTax",
                  title: e.currency(o.cumCashFlowAfterTax)
                }, g(e.shortCurrency(o.cumCashFlowAfterTax)), 9, Mst)
              ], 10, Bst))), 256))
            ]),
            a("tr", xst, [
              t[11] || (t[11] = a("th", { rel: "grossWealthAccumulationAfterTax" }, " Gross Wealth Accumulation ", -1)),
              (p(!0), h(A, null, D(e.yearRentalTypeValues, (o) => (p(), h("th", {
                class: z(["table-column", e.analysisYearStyle(o)]),
                "data-year": o.year
              }, [
                a("div", {
                  class: "cell-content adv-grossWealthAccumulationAfterTax",
                  title: e.currency(o.grossWealthAccumulationAfterTax)
                }, g(e.shortCurrency(o.grossWealthAccumulationAfterTax)), 9, Vst)
              ], 10, Fst))), 256))
            ]),
            a("tr", null, [
              t[12] || (t[12] = a("th", { rel: "totalreturn" }, " Less: Net Investment ", -1)),
              (p(!0), h(A, null, D(e.yearRentalTypeValues, (o) => (p(), h("th", {
                class: z(["table-column", e.analysisYearStyle(o)]),
                "data-year": o.year
              }, [
                a("div", {
                  class: "cell-content adv-totalreturn",
                  title: e.currency(e.isFlip ? o.capitalInvestedEnd : o.initialInvestment)
                }, [
                  e.isFlip ? (p(), h(A, { key: 0 }, [
                    y(g(e.shortCurrency(o.capitalInvestedEnd)), 1)
                  ], 64)) : (p(), h(A, { key: 1 }, [
                    y(g(e.shortCurrency(o.initialInvestment)), 1)
                  ], 64))
                ], 8, Nst)
              ], 10, Dst))), 256))
            ])
          ]),
          a("tbody", jst, [
            a("tr", Hst, [
              t[13] || (t[13] = a("th", { rel: "netGainOnInvestmentAfterTax" }, " Net Gain on Investment ", -1)),
              (p(!0), h(A, null, D(e.yearRentalTypeValues, (o) => (p(), h("th", {
                class: z(["table-column", e.analysisYearStyle(o)]),
                "data-year": o.year
              }, [
                a("div", {
                  class: z(["cell-content adv-netGainOnInvestmentAfterTax", e.currencyStyle(o.netGainOnInvestmentAfterTax)]),
                  title: e.currency(o.netGainOnInvestmentAfterTax)
                }, g(e.shortCurrency(o.netGainOnInvestmentAfterTax)), 11, zst)
              ], 10, Ust))), 256))
            ])
          ])
        ], 2)
      ]),
      e.haveAccess ? P("", !0) : (p(), h("div", Wst, t[14] || (t[14] = [
        a("div", { class: "fw-bold fs-5 mb-lg-2" }, "View our full 30 year analysis with an account!", -1),
        a("a", {
          href: "/signup",
          class: "btn btn-eclipse"
        }, "Activate Full Analysis!", -1)
      ])))
    ])
  ], 2);
}
const Yst = /* @__PURE__ */ Ae(rst, [["render", Gst]]), Xst = me({
  name: "RefinanceCashInOut",
  computed: {
    cashOut() {
      var t, s, n, r;
      const e = ((t = this.flipResults) == null ? void 0 : t.permanentLoanAmount) - ((s = this.flipResults) == null ? void 0 : s.bridgeLoanAmount) - ((n = this.flipResults) == null ? void 0 : n.permanentLoanAmount) * ((r = this.calcParams) == null ? void 0 : r.loanfees);
      return Math.trunc(e) === 0 ? 0 : e;
    },
    ...at(qe),
    ...q(Te, ["access", "aclLoaded"]),
    ...q(qe, ["flipResults", "flipParams", "flipTotalCosts", "calculatedResults", "flipDispositionMonth", "flipBridgeCarryingCost", "flipTotalCashInvested", "calcParams", "flipProRatedTax", "flipHasBridgeLoan"])
  },
  methods: {
    currency: Ze,
    currencyStyle(e) {
      return {
        "text-success": e > 0,
        "text-danger": e < 0
      };
    }
  }
}), qst = { class: "card shadow-sm" }, Qst = { class: "table table-sm" }, Kst = { class: "text-end" }, Zst = { key: 0 }, Jst = { class: "text-end" }, $st = { class: "text-end" }, _st = {
  scope: "col",
  class: "bg-light fw-bold"
};
function eat(e, t, s, n, r, i) {
  var o, l, d, c;
  return p(), h("div", qst, [
    t[3] || (t[3] = a("div", { class: "card-header bg-eclipse text-white rounded rounded-bottom-0 fw-bold text-center text-sm-start" }, " REFINANCE CASH IN/OUT ", -1)),
    a("table", Qst, [
      a("tbody", null, [
        a("tr", null, [
          t[0] || (t[0] = a("td", null, " Permanent Loan Amount ", -1)),
          a("td", Kst, g(e.currency((o = e.flipResults) == null ? void 0 : o.permanentLoanAmount)), 1)
        ]),
        e.flipHasBridgeLoan ? (p(), h("tr", Zst, [
          t[1] || (t[1] = a("td", null, " Less: Bridge Loan Payoff ", -1)),
          a("td", Jst, g(e.currency((l = e.flipResults) == null ? void 0 : l.bridgeLoanAmount)), 1)
        ])) : P("", !0),
        a("tr", null, [
          t[2] || (t[2] = a("td", null, " Less: Permanent Loan Fees ", -1)),
          a("td", $st, g(e.currency(((d = e.flipResults) == null ? void 0 : d.permanentLoanAmount) * ((c = e.calcParams) == null ? void 0 : c.loanfees))), 1)
        ]),
        a("tr", null, [
          a("th", _st, [
            e.cashOut > 0 ? (p(), h(A, { key: 0 }, [
              y(" Cash Out ")
            ], 64)) : (p(), h(A, { key: 1 }, [
              y(" Cash In ")
            ], 64))
          ]),
          a("th", {
            scope: "col",
            class: z(["bg-light fw-bold text-end", e.currencyStyle(e.cashOut)])
          }, g(e.currency(e.cashOut)), 3)
        ])
      ])
    ])
  ]);
}
const wE = /* @__PURE__ */ Ae(Xst, [["render", eat]]), tat = me({
  name: "PostRefinanceInvestmentBasis",
  computed: {
    ...at(qe),
    ...q(Te, ["access", "aclLoaded"]),
    ...q(qe, [
      "flipResults",
      "flipParams",
      "flipTotalCosts",
      "calculatedResults",
      "flipDispositionMonth",
      "flipBridgeCarryingCost",
      "flipTotalCashInvested",
      "calcParams",
      "flipProRatedTax",
      "flipHasBridgeLoan",
      "flipCashInOut",
      "flipYear1Shortfall",
      "flipNetInvestmentAfterRefi"
    ])
  },
  methods: {
    currency: Ze
  }
}), sat = { class: "card shadow-sm" }, aat = { class: "table table-sm" }, nat = { class: "text-end" }, rat = { class: "text-end" }, oat = { class: "text-end" }, iat = { class: "bg-light fw-bold text-end" };
function lat(e, t, s, n, r, i) {
  return p(), h("div", sat, [
    t[4] || (t[4] = a("div", { class: "card-header bg-eclipse text-white rounded rounded-bottom-0 fw-bold text-center text-sm-start" }, " POST REFINANCE INVESTMENT BASIS ", -1)),
    a("table", aat, [
      a("tbody", null, [
        a("tr", null, [
          t[0] || (t[0] = a("td", null, " Initial Cash Investment ", -1)),
          a("td", nat, g(e.currency(e.flipTotalCashInvested)), 1)
        ]),
        a("tr", null, [
          a("td", null, [
            e.flipCashInOut > 0 ? (p(), h(A, { key: 0 }, [
              y(" Less: Cash Out ")
            ], 64)) : (p(), h(A, { key: 1 }, [
              y(" Less: Cash In ")
            ], 64))
          ]),
          a("td", rat, g(e.currency(e.flipCashInOut)), 1)
        ]),
        a("tr", null, [
          a("td", null, [
            e.flipYear1Shortfall > 0 ? (p(), h(A, { key: 0 }, [
              t[1] || (t[1] = y(" Plus: Year 1 Shortfall ")),
              t[2] || (t[2] = a("small", null, "(Exceeding Carrying Cost Budget)", -1))
            ], 64)) : (p(), h(A, { key: 1 }, [
              y(" Less: Carrying Costs Budget Surplus ")
            ], 64))
          ]),
          a("td", oat, [
            e.flipYear1Shortfall > 0 ? (p(), h(A, { key: 0 }, [
              y(g(e.currency(e.flipYear1Shortfall)), 1)
            ], 64)) : (p(), h(A, { key: 1 }, [
              y(g(e.currency(-e.flipYear1Shortfall)), 1)
            ], 64))
          ])
        ]),
        a("tr", null, [
          t[3] || (t[3] = a("th", { class: "bg-light fw-bold" }, " Net Investment After Refinance ", -1)),
          a("th", iat, g(e.currency(e.flipNetInvestmentAfterRefi)), 1)
        ])
      ])
    ])
  ]);
}
const CE = /* @__PURE__ */ Ae(tat, [["render", lat]]), dat = me({
  name: "ProformaTab",
  props: {
    analysis: String,
    share: String
  },
  components: {
    PerformanceCharts: $Ue,
    CashFlowSummary: IKe,
    InvestmentBasis: nst,
    CashFlow: IQe,
    TotalInvestment: Hb,
    KpiTotalInvestment: Zze,
    KpiHoldPeriod: sWe,
    KpiNetGainOnInvestment: gWe,
    MonthlyOwnershipCosts: TWe,
    UnitMix: KWe,
    KpiMonthlyCashFlow: xWe,
    KpiRentalRateAffordability: yqe,
    KpiGrossRentMultiplier: Sqe,
    FinancialOverview: eKe,
    FinancialIndicators: YJe,
    apod: Htt,
    ValueEquity: RZe,
    InvestmentTrajectory: Yst,
    FlipInitialInvestment: Zu,
    RefinanceCash: wE,
    PostRefinanceInvestmentBasis: CE
  },
  emits: [
    "infoPopover"
  ],
  computed: {
    haveAccessKpi() {
      var e, t;
      return this.isMarketplace || ((t = (e = this.access) == null ? void 0 : e.properties) == null ? void 0 : t.financialAnalysis) == !0;
    },
    calculatingClasses() {
      return {
        active: this.calculating
      };
    },
    containerClasses() {
      var e;
      return {
        "container-xl": !0,
        "container-jumbo": ((e = this.account) == null ? void 0 : e.defaultAnalysisMode) == Hn.Advanced
      };
    },
    isAdvancedMode() {
      var e;
      return ((e = this.account) == null ? void 0 : e.defaultAnalysisMode) == Hn.Advanced;
    },
    rowAccessInitialInvStyle() {
      return {
        "order-1 order-md-1 order-lg-1": !0,
        "col-md-6 col-xl-4": this.haveAccessKpi,
        "col-md-6": !this.haveAccessKpi
      };
    },
    rowAccessMonthlyOwnerStyle() {
      return {
        "order-2 order-md-3 order-lg-2 gap-3 d-flex flex-column": !0,
        "flex-md-row flex-xl-column col-md-12 col-xl-4": this.haveAccessKpi,
        "col-md-6": !this.haveAccessKpi
      };
    },
    haveAccess() {
      var e, t;
      return (((t = (e = this.property) == null ? void 0 : e.mlsSource) == null ? void 0 : t.isActiveMarketplaceListing) == !0 || this.hasAdvanced) && (this.isAdmin || this.isUser || this.isClient);
    },
    ...at(qe),
    ...q(ct, ["account"]),
    ...q(Te, ["access", "aclLoaded", "hasAdvanced", "isClient", "isAdmin", "isUser"]),
    ...q(qe, ["isMarketplace", "calculating", "requireUnits", "calculatedResults", "calcParams", "isShortTerm", "property", "isExistingInvestment", "purchaseFacts", "isFlip", "isPadSplit", "isSyncedExpenses"])
  },
  methods: {
    currency: Ze,
    infoPopover(e) {
      this.$emit("infoPopover", e);
    }
  }
}), cat = "data:image/png;base64,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", uat = "data:image/png;base64,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", pat = {
  key: 0,
  class: "row mb-4"
}, hat = {
  class: "row g-4 mb-4",
  id: "graphs"
}, mat = { class: "col" }, fat = { class: "row mb-3" }, gat = { class: "col-12" }, vat = {
  key: 0,
  class: "card card-locked shadow-sm h-100 d-flex align-items-center justify-content-center bg-gradient-periwinkle"
}, yat = { class: "card-body p-0" }, bat = { class: "row g-0 justify-content-lg-between kpi-data kpi-crumbs" }, Aat = { class: "col-md-4" }, wat = { class: "col-md-3 col-lg-4 position-relative pt-5 pt-md-0" }, Cat = { class: "col-md-5 col-lg-4" }, Sat = { class: "row g-4 mb-4" }, Pat = {
  key: 0,
  class: "col-md-6 col-xl-4"
}, kat = {
  key: 0,
  class: "col-md-6 col-xl-4 d-flex flex-column gap-3 order-3 order-md-2 order-lg-3"
}, Eat = {
  key: 0,
  class: "row g-4"
}, Iat = { class: "col-12 col-xl-5" }, Tat = {
  key: 1,
  class: "row row-cols-1 row-cols-md-2 row-cols-xl-1 g-4"
}, Oat = { class: "col" }, Rat = { class: "col" }, Lat = { class: "col-12 col-xl-7" }, Bat = { class: "row g-4" }, Mat = { class: "col-md-6 col-xl-12" }, xat = { class: "col-md-6 col-xl-12" }, Fat = { class: "col-12" }, Vat = {
  key: 1,
  class: "row g-4 mb-4"
}, Dat = { class: "col-md-6 col-lg-5 d-flex flex-column gap-4" }, Nat = { class: "col-md-6 col-lg-7 d-flex flex-column gap-4" }, jat = { class: "col-12" }, Hat = { class: "col-12" }, Uat = { class: "col-12" }, zat = { class: "col-12" };
function Wat(e, t, s, n, r, i) {
  const o = pe("performance-charts"), l = pe("kpi-total-investment"), d = pe("kpi-hold-period"), c = pe("kpi-net-gain-on-investment"), u = pe("total-investment"), m = pe("flip-initial-investment"), f = pe("monthly-ownership-costs"), v = pe("kpi-monthly-cash-flow"), b = pe("kpi-rental-rate-affordability"), w = pe("unit-mix"), S = pe("cash-flow"), I = pe("refinance-cash"), T = pe("post-refinance-investment-basis"), x = pe("financial-overview"), k = pe("cash-flow-summary"), C = pe("value-equity"), O = pe("financial-indicators"), E = pe("apod"), B = pe("investment-basis"), M = pe("investment-trajectory");
  return p(), h("div", {
    class: z(e.containerClasses)
  }, [
    e.haveAccess ? (p(), h(A, { key: 1 }, [
      a("div", hat, [
        a("div", mat, [
          N(o, {
            "annual-cash-flow": "",
            "net-equity": "",
            onInfoPopover: e.infoPopover
          }, null, 8, ["onInfoPopover"])
        ])
      ]),
      a("div", fat, [
        a("div", gat, [
          e.haveAccessKpi ? (p(), h("div", {
            key: 1,
            class: z(["card shadow-sm bg-kpi", e.calculatingClasses])
          }, [
            a("div", yat, [
              t[2] || (t[2] = a("div", { class: "loading-financial position-absolute top-50 start-50 translate-middle text-center" }, [
                a("i", { class: "fa-duotone fa-solid fa-compass fa-spin fa-lg text-eclipse" }),
                a("br"),
                a("small", null, "Calculating")
              ], -1)),
              a("div", bat, [
                a("div", Aat, [
                  N(l, { onInfoPopover: e.infoPopover }, null, 8, ["onInfoPopover"])
                ]),
                a("div", wat, [
                  N(d, { onInfoPopover: e.infoPopover }, null, 8, ["onInfoPopover"])
                ]),
                a("div", Cat, [
                  N(c, { onInfoPopover: e.infoPopover }, null, 8, ["onInfoPopover"])
                ])
              ])
            ])
          ], 2)) : (p(), h("div", vat, t[1] || (t[1] = [
            Bt('<div class="d-flex justify-content-between align-items-center flex-row"><div class="text-center"><img src="' + uat + '" alt="KPIs" title="KPIs" width="300" height="214" class="img-fluid" loading="lazy"></div><div class="d-flex flex-column justify-content-center align-items-center align-items-lg-start p-4"><p class="fw-bold fs-5"> Create an account<br class="d-none d-lg-block"> to view KPIs! </p><a href="/signup" class="btn btn-eclipse">Activate KPIs!</a></div></div>', 1)
          ])))
        ])
      ]),
      a("div", Sat, [
        a("div", {
          class: z(e.rowAccessInitialInvStyle)
        }, [
          N(ks, {
            name: "slide-fade",
            mode: "out-in"
          }, {
            default: ve(() => [
              e.isFlip ? (p(), Fe(m, { key: 1 })) : (p(), Fe(u, { key: 0 }))
            ]),
            _: 1
          })
        ], 2),
        a("div", {
          class: z(e.rowAccessMonthlyOwnerStyle)
        }, [
          N(f),
          e.isAdvancedMode && !e.isFlip ? (p(), Fe(v, { key: 0 })) : P("", !0)
        ], 2),
        e.haveAccessKpi && !e.isAdvancedMode ? (p(), h("div", Pat, [
          N(ks, {
            name: "slide-fade",
            mode: "out-in"
          }, {
            default: ve(() => [
              e.isFlip ? !e.isPadSplit && !e.isShortTerm ? (p(), Fe(b, { key: 1 })) : P("", !0) : (p(), Fe(v, { key: 0 }))
            ]),
            _: 1
          })
        ])) : P("", !0),
        e.isAdvancedMode ? (p(), h(A, { key: 1 }, [
          e.requireUnits || e.haveAccessKpi ? (p(), h("div", kat, [
            e.requireUnits ? (p(), Fe(w, { key: 0 })) : e.haveAccessKpi ? (p(), h(A, { key: 1 }, [
              !e.isPadSplit && !e.isShortTerm ? (p(), Fe(b, { key: 0 })) : P("", !0)
            ], 64)) : P("", !0)
          ])) : P("", !0)
        ], 64)) : P("", !0)
      ]),
      e.isAdvancedMode ? (p(), h("div", Vat, [
        a("div", Dat, [
          e.isFlip ? (p(), h(A, { key: 1 }, [
            N(I),
            N(T)
          ], 64)) : (p(), Fe(S, {
            key: 0,
            "calculated-results": e.calculatedResults,
            analysis: e.analysis,
            share: e.share,
            calculating: e.calculating,
            "is-short-term": e.isShortTerm,
            "calc-params": e.calcParams,
            onInfoPopover: e.infoPopover
          }, null, 8, ["calculated-results", "analysis", "share", "calculating", "is-short-term", "calc-params", "onInfoPopover"]))
        ]),
        a("div", Nat, [
          N(x, {
            "calculated-results": e.calculatedResults,
            analysis: e.analysis,
            share: e.share,
            calculating: e.calculating,
            "is-short-term": e.isShortTerm,
            "is-marketplace": e.isMarketplace,
            onInfoPopover: e.infoPopover
          }, null, 8, ["calculated-results", "analysis", "share", "calculating", "is-short-term", "is-marketplace", "onInfoPopover"]),
          N(O, {
            "calculated-results": e.calculatedResults,
            analysis: e.analysis,
            share: e.share,
            calculating: e.calculating,
            "is-short-term": e.isShortTerm,
            "is-marketplace": e.isMarketplace,
            "calc-params": e.calcParams,
            "purchase-facts": e.purchaseFacts,
            onInfoPopover: e.infoPopover
          }, null, 8, ["calculated-results", "analysis", "share", "calculating", "is-short-term", "is-marketplace", "calc-params", "purchase-facts", "onInfoPopover"])
        ]),
        a("div", jat, [
          N(E, {
            "calculated-results": e.calculatedResults,
            analysis: e.analysis,
            share: e.share,
            calculating: e.calculating,
            "is-short-term": e.isShortTerm,
            "is-marketplace": e.isMarketplace,
            "calc-params": e.calcParams,
            "is-existing-investment": e.isExistingInvestment,
            onInfoPopover: e.infoPopover
          }, null, 8, ["calculated-results", "analysis", "share", "calculating", "is-short-term", "is-marketplace", "calc-params", "is-existing-investment", "onInfoPopover"])
        ]),
        a("div", Hat, [
          N(B)
        ]),
        a("div", Uat, [
          N(C)
        ]),
        a("div", zat, [
          N(M)
        ])
      ])) : (p(), h("div", Eat, [
        a("div", Iat, [
          e.isFlip ? (p(), h("div", Tat, [
            a("div", Oat, [
              N(I)
            ]),
            a("div", Rat, [
              N(T)
            ])
          ])) : (p(), Fe(S, {
            key: 0,
            "calculated-results": e.calculatedResults,
            analysis: e.analysis,
            share: e.share,
            calculating: e.calculating,
            "calc-params": e.calcParams,
            "is-short-term": e.isShortTerm,
            onInfoPopover: e.infoPopover
          }, null, 8, ["calculated-results", "analysis", "share", "calculating", "calc-params", "is-short-term", "onInfoPopover"]))
        ]),
        a("div", Lat, [
          a("div", Bat, [
            a("div", Mat, [
              N(x, {
                "calculated-results": e.calculatedResults,
                analysis: e.analysis,
                share: e.share,
                calculating: e.calculating,
                "is-short-term": e.isShortTerm,
                "is-marketplace": e.isMarketplace,
                onInfoPopover: e.infoPopover
              }, null, 8, ["calculated-results", "analysis", "share", "calculating", "is-short-term", "is-marketplace", "onInfoPopover"])
            ]),
            a("div", xat, [
              N(k)
            ]),
            a("div", Fat, [
              N(C)
            ])
          ])
        ])
      ]))
    ], 64)) : (p(), h("div", pat, t[0] || (t[0] = [
      Bt('<div class="col"><div class="card bg-gradient-periwinkle shadow-sm guard p-4 p-lg-5"><div class="row"><div class="col-lg-6"><img class="img-fluid" src="' + cat + '" alt="Leasing and Resale Expenses" title="Leasing and Resale Expenses" loading="lazy"></div><div class="col-lg-6 d-flex justify-content-center align-items-lg-start align-items-center text-center text-lg-start flex-column"><p class="fw-bold fs-5"> Unlock our full set of Proforma data! </p><a href="/account/settings" class="btn btn-eclipse">Activate Proforma Charts</a></div></div></div></div>', 1)
    ])))
  ], 2);
}
const Kls = /* @__PURE__ */ Ae(dat, [["render", Wat]]), Gat = me({
  name: "ProjectedAccumulationOfWealth",
  emits: [
    "infoPopover"
  ],
  computed: {
    calculatingClasses() {
      return {
        active: this.calculating
      };
    },
    normalized() {
      var e;
      return (e = this.calculatedResults) != null && e.normalized ? this.calculatedResults.normalized.filter((t) => t.fiscalYear > 0).sort((t, s) => t.fiscalYear - s.fiscalYear) : [];
    },
    raw() {
      var e;
      return (e = this.calculatedResults) != null && e.raw ? this.calculatedResults.raw.filter((t) => t.fiscalYear > 0).sort((t, s) => t.fiscalYear - s.fiscalYear) : [];
    },
    shortTerm() {
      var e;
      return (e = this.calculatedResults) != null && e.shortTerm ? this.calculatedResults.shortTerm.filter((t) => t.fiscalYear > 0).sort((t, s) => t.fiscalYear - s.fiscalYear) : [];
    },
    haveAccess() {
      var e, t;
      return this.isMarketplace || ((t = (e = this.acl) == null ? void 0 : e.properties) == null ? void 0 : t.financialAnalysis) == !0;
    },
    ...q(Te, ["acl", "aclLoaded"]),
    ...q(qe, ["hasShortTermResults", "calculatedResults", "calculating", "isMarketplace"])
  },
  methods: {
    currency: Ze,
    shortNumber: vr,
    shortCurrency: ka,
    analysisYearStyle: so,
    infoPopover(e) {
      this.$emit("infoPopover", e);
    }
  }
}), Yat = { class: "table table-sm text-small tabla mlse-table mlse-wealth mlse-values regListing show10" }, Xat = { class: "text-end" }, qat = ["data-year"], Qat = { rel: "initialequity" }, Kat = ["data-year"], Zat = ["title"], Jat = ["data-year"], $at = ["title"], _at = { rel: "netappreciation" }, ent = ["data-year"], tnt = ["title"], snt = ["data-year"], ant = ["title"], nnt = ["data-year"], rnt = ["title"], ont = ["data-year"], int = ["title"], lnt = ["data-year"], dnt = ["title"], cnt = { class: "table-total" }, unt = ["data-year"], pnt = ["title"], hnt = ["data-year"], mnt = ["title"], fnt = {
  key: 0,
  class: "d-flex justify-content-center flex-column align-items-center guard shadow m-4 flex-shrink-0 text-center"
};
function gnt(e, t, s, n, r, i) {
  return p(), h("div", {
    class: z(["card mb-4 shadow-sm", e.calculatingClasses])
  }, [
    t[14] || (t[14] = a("div", {
      class: "loading-financial d-flex justify-content-center flex-column align-items-center h-100",
      style: { display: "none" }
    }, [
      a("span", {
        class: "spinner-border spinner-border-sm mb-2",
        role: "status",
        "aria-hidden": "false"
      }),
      y("Calculating ")
    ], -1)),
    t[15] || (t[15] = a("div", { class: "text-center text-sm-start card-header bg-alice fw-bold border-0 text-uppercase d-flex align-items-center justify-content-center justify-content-md-between flex-column flex-sm-row" }, " Projected Accumulation of Wealth ", -1)),
    a("div", {
      class: z(["table-wrap", { "table-guarded": !e.haveAccess }])
    }, [
      a("table", Yat, [
        a("thead", null, [
          a("tr", Xat, [
            t[2] || (t[2] = a("th", null, " ", -1)),
            (p(!0), h(A, null, D(e.normalized, (o) => (p(), h("th", {
              class: z(["mlse-column", e.analysisYearStyle(o)]),
              "data-year": o.year
            }, [
              o.fiscalYear ? (p(), h(A, { key: 0 }, [
                y(g(o.fiscalYear), 1)
              ], 64)) : (p(), h(A, { key: 1 }, [
                y(" Year " + g(o.year), 1)
              ], 64))
            ], 10, qat))), 256))
          ])
        ]),
        a("tbody", null, [
          a("tr", null, [
            a("th", Qat, [
              t[3] || (t[3] = a("i", { class: "fa-duotone fa-solid fa-circle me-2 text-table-3" }, null, -1)),
              t[4] || (t[4] = y("Initial Equity ")),
              a("i", {
                class: "fa-light fa-question-circle ms-1 info-pop",
                onClick: t[0] || (t[0] = (...o) => e.infoPopover && e.infoPopover(...o)),
                "data-title": "Initial Equity",
                "data-html": "true",
                "data-render": "true",
                "data-pop": "initialEquity"
              }),
              t[5] || (t[5] = a("div", { class: "d-none info-pop-initialEquity" }, [
                a("p", null, [
                  y(" The end of year property value, less estimated resale closing costs is the initial equity."),
                  a("br"),
                  a("br"),
                  y("Initial equity in the first few years may be less than the investment amount, but does not grow to exceed the initial investment."),
                  a("br"),
                  a("br"),
                  y("Once you have achieved net equity in excess of the initial investment, it is displayed in the Appreciation row. ")
                ])
              ], -1))
            ]),
            e.hasShortTermResults ? (p(!0), h(A, { key: 1 }, D(e.shortTerm, (o) => (p(), h("td", {
              class: z(["mlse-column", e.analysisYearStyle(o)]),
              "data-year": o.year
            }, [
              a("div", {
                class: "mlse-content mlse-grey adv-initialequity",
                title: e.currency(o.initialEquity)
              }, g(e.shortCurrency(o.initialEquity)), 9, $at)
            ], 10, Jat))), 256)) : (p(!0), h(A, { key: 0 }, D(e.raw, (o) => (p(), h("td", {
              class: z(["mlse-column", e.analysisYearStyle(o)]),
              "data-year": o.year
            }, [
              a("div", {
                class: "mlse-content mlse-grey adv-initialequity",
                title: e.currency(o.initialequity)
              }, g(e.shortCurrency(o.initialequity)), 9, Zat)
            ], 10, Kat))), 256))
          ]),
          a("tr", null, [
            a("th", _at, [
              t[6] || (t[6] = a("i", { class: "fa-duotone fa-solid fa-circle me-2 text-table-4" }, null, -1)),
              t[7] || (t[7] = y("Appreciation ")),
              a("i", {
                class: "fa-light fa-question-circle ms-1 info-pop",
                onClick: t[1] || (t[1] = (...o) => e.infoPopover && e.infoPopover(...o)),
                "data-title": "Appreciation (Net of Sales Cost)",
                "data-html": "true",
                "data-render": "true",
                "data-pop": "appreciation"
              }),
              t[8] || (t[8] = a("div", { class: "d-none info-pop-appreciation" }, [
                a("p", null, [
                  y(" As your property appreciates each year, you will have enough equity to sell and cover the expense of closing costs without losing a portion of your initial investment."),
                  a("br"),
                  a("br"),
                  y("The amount you are estimated to receive if you sold the house, less closing costs and initial investment is your appreciation. ")
                ])
              ], -1)),
              t[9] || (t[9] = a("span", { class: "small d-block" }, "(Net of Sales Cost)", -1))
            ]),
            e.hasShortTermResults ? (p(!0), h(A, { key: 1 }, D(e.shortTerm, (o) => (p(), h("td", {
              class: z(["mlse-column", e.analysisYearStyle(o)]),
              "data-year": o.year
            }, [
              a("div", {
                class: "mlse-content mlse-grey adv-netappreciation",
                title: e.currency(o.netAppreciation)
              }, g(e.shortCurrency(o.netAppreciation)), 9, ant)
            ], 10, snt))), 256)) : (p(!0), h(A, { key: 0 }, D(e.raw, (o) => (p(), h("td", {
              class: z(["mlse-column", e.analysisYearStyle(o)]),
              "data-year": o.year
            }, [
              a("div", {
                class: "mlse-content mlse-grey adv-netappreciation",
                title: e.currency(o.netappreciation)
              }, g(e.shortCurrency(o.netappreciation)), 9, tnt)
            ], 10, ent))), 256))
          ]),
          a("tr", null, [
            t[10] || (t[10] = a("th", { rel: "principalreduction" }, [
              a("i", { class: "fa-duotone fa-solid fa-circle me-2 text-table-5" }),
              y("Cumulative Principal Reduction ")
            ], -1)),
            (p(!0), h(A, null, D(e.raw, (o) => (p(), h("td", {
              class: z(["mlse-column", e.analysisYearStyle(o)]),
              "data-year": o.year
            }, [
              a("div", {
                class: "mlse-content mlse-grey adv-principalreduction",
                title: e.currency(o.principalreduction)
              }, g(e.shortCurrency(o.principalreduction)), 9, rnt)
            ], 10, nnt))), 256))
          ]),
          a("tr", null, [
            t[11] || (t[11] = a("th", { rel: "cumcashflow" }, [
              a("i", { class: "fa-duotone fa-solid fa-circle me-2 text-table-2" }),
              y("Cumulative Cash Flow ")
            ], -1)),
            e.hasShortTermResults ? (p(!0), h(A, { key: 1 }, D(e.shortTerm, (o) => (p(), h("td", {
              class: z(["mlse-column", e.analysisYearStyle(o)]),
              "data-year": o.year
            }, [
              a("div", {
                class: "mlse-content mlse-grey adv-cumcashflow",
                title: e.currency(o.cumCashFlow)
              }, g(e.shortCurrency(o.cumCashFlow)), 9, dnt)
            ], 10, lnt))), 256)) : (p(!0), h(A, { key: 0 }, D(e.raw, (o) => (p(), h("td", {
              class: z(["mlse-column", e.analysisYearStyle(o)]),
              "data-year": o.year
            }, [
              a("div", {
                class: "mlse-content mlse-grey adv-cumcashflow",
                title: e.currency(o.cumcashflow)
              }, g(e.shortCurrency(o.cumcashflow)), 9, int)
            ], 10, ont))), 256))
          ]),
          a("tr", cnt, [
            t[12] || (t[12] = a("th", { rel: "grossWealthAccumulation" }, [
              a("strong", null, "Total")
            ], -1)),
            e.hasShortTermResults ? (p(!0), h(A, { key: 1 }, D(e.shortTerm, (o) => (p(), h("th", {
              class: z(["mlse-column", e.analysisYearStyle(o)]),
              "data-year": o.year
            }, [
              a("div", {
                class: "mlse-content mlse-grey adv-grossWealthAccumulation strong",
                title: e.currency(o.grossWealthAccumulation)
              }, g(e.shortCurrency(o.grossWealthAccumulation)), 9, mnt)
            ], 10, hnt))), 256)) : (p(!0), h(A, { key: 0 }, D(e.raw, (o) => (p(), h("th", {
              class: z(["mlse-column", e.analysisYearStyle(o)]),
              "data-year": o.year
            }, [
              a("div", {
                class: "mlse-content mlse-grey adv-grossWealthAccumulation strong",
                title: e.currency(o.grossWealthAccumulation)
              }, g(e.shortCurrency(o.grossWealthAccumulation)), 9, pnt)
            ], 10, unt))), 256))
          ])
        ])
      ]),
      e.haveAccess ? P("", !0) : (p(), h("div", fnt, t[13] || (t[13] = [
        Bt('<div><img src="' + qb + '" alt="Financial APOD table" title="Financial APOD table" height="240" width="426" class="img-fluid" loading="lazy"></div><div class="p-4"><p class="fw-bold fs-5">View our full 30 year analysis<br class="d-none d-lg-block"> with an account!</p><a href="/signup" class="btn btn-lava">Activate Full Analysis!</a></div>', 2)
      ])))
    ], 2)
  ], 2);
}
const Zls = /* @__PURE__ */ Ae(Gat, [["render", gnt]]), vnt = me({
  name: "AppreciationAndPrincipalReduction",
  computed: {
    calculatingClasses() {
      return {
        active: this.calculating
      };
    },
    raw() {
      return this.calculatedResults.raw ? this.calculatedResults.raw.filter((e) => e.fiscalYear > 0).sort((e, t) => e.fiscalYear - t.fiscalYear) : [];
    },
    shortTerm() {
      return this.calculatedResults.shortTerm ? this.calculatedResults.shortTerm.filter((e) => e.fiscalYear > 0).sort((e, t) => e.fiscalYear - t.fiscalYear) : [];
    },
    haveAccess() {
      var e, t;
      return this.isMarketplace || ((t = (e = this.access) == null ? void 0 : e.properties) == null ? void 0 : t.financialAnalysis) == !0;
    },
    ...q(Te, ["access", "aclLoaded"]),
    ...q(qe, ["hasShortTermResults", "calculating", "isMarketplace", "calculatedResults"])
  },
  methods: {
    currency: Ze,
    shortNumber: vr,
    shortCurrency: ka,
    analysisYearStyle: so
  }
}), ynt = { class: "table table-sm text-small tabla mlse-table mlse-appreciation mlse-values regListing show10" }, bnt = { class: "text-end" }, Ant = ["data-year"], wnt = ["data-year"], Cnt = { class: "mlse-content mlse-grey adv-propertyvalue" }, Snt = ["data-year"], Pnt = { class: "mlse-content mlse-grey adv-propertyvalue" }, knt = ["data-year"], Ent = { class: "mlse-content mlse-grey adv-loanbalance" }, Int = ["data-year"], Tnt = { class: "mlse-content mlse-grey adv-costofsale" }, Ont = ["data-year"], Rnt = { class: "mlse-content mlse-grey adv-costofsale" }, Lnt = ["data-year"], Bnt = { class: "mlse-content mlse-grey adv-netequity" }, Mnt = ["data-year"], xnt = { class: "mlse-content mlse-grey adv-netequity" }, Fnt = {
  key: 0,
  class: "d-flex justify-content-center flex-column align-items-center guard shadow m-4 flex-shrink-0 text-center"
};
function Vnt(e, t, s, n, r, i) {
  return p(), h("div", {
    class: z(["card mb-4 shadow-sm", e.calculatingClasses])
  }, [
    t[6] || (t[6] = a("div", {
      class: "loading-financial d-flex justify-content-center flex-column align-items-center h-100",
      style: { display: "none" }
    }, [
      a("span", {
        class: "spinner-border spinner-border-sm mb-2",
        role: "status",
        "aria-hidden": "false"
      }),
      y("Calculating ")
    ], -1)),
    t[7] || (t[7] = a("div", { class: "card-header bg-alice fw-bold border-0 text-uppercase d-flex flex-column flex-sm-row align-items-center justify-content-center justify-content-md-between text-center text-sm-start" }, " Appreciation and Principal Reduction ", -1)),
    a("div", {
      class: z(["table-wrap", { "table-guarded": !e.haveAccess }])
    }, [
      a("table", ynt, [
        a("thead", null, [
          a("tr", bnt, [
            t[0] || (t[0] = a("th", { class: "text-start" }, [
              a("strong", null, "(End Of Year)")
            ], -1)),
            (p(!0), h(A, null, D(e.raw, (o) => (p(), h("th", {
              class: z(["mlse-column", e.analysisYearStyle(o)]),
              "data-year": o.year
            }, [
              o.fiscalYear ? (p(), h(A, { key: 0 }, [
                y(g(o.fiscalYear), 1)
              ], 64)) : (p(), h(A, { key: 1 }, [
                y(" Year " + g(o.year), 1)
              ], 64))
            ], 10, Ant))), 256))
          ])
        ]),
        a("tbody", null, [
          a("tr", null, [
            t[1] || (t[1] = a("th", { rel: "propertyvalue" }, "Property Value", -1)),
            e.hasShortTermResults ? (p(!0), h(A, { key: 1 }, D(e.shortTerm, (o) => (p(), h("td", {
              class: z(["mlse-column", e.analysisYearStyle(o)]),
              "data-year": o.year
            }, [
              a("div", Pnt, g(e.shortCurrency(o.propertyValue)), 1)
            ], 10, Snt))), 256)) : (p(!0), h(A, { key: 0 }, D(e.raw, (o) => (p(), h("td", {
              class: z(["mlse-column", e.analysisYearStyle(o)]),
              "data-year": o.year
            }, [
              a("div", Cnt, g(e.shortCurrency(o.propertyvalue)), 1)
            ], 10, wnt))), 256))
          ]),
          a("tr", null, [
            t[2] || (t[2] = a("th", { rel: "loanbalance" }, "Loan Balance", -1)),
            (p(!0), h(A, null, D(e.raw, (o) => (p(), h("td", {
              class: z(["mlse-column", e.analysisYearStyle(o)]),
              "data-year": o.year
            }, [
              a("div", Ent, g(e.shortCurrency(o.loanbalance)), 1)
            ], 10, knt))), 256))
          ]),
          a("tr", null, [
            t[3] || (t[3] = a("th", { rel: "costofsale" }, "Cost of Sale", -1)),
            e.hasShortTermResults ? (p(!0), h(A, { key: 1 }, D(e.shortTerm, (o) => (p(), h("td", {
              class: z(["mlse-column", e.analysisYearStyle(o)]),
              "data-year": o.year
            }, [
              a("div", Rnt, g(e.shortCurrency(o.costOfSale)), 1)
            ], 10, Ont))), 256)) : (p(!0), h(A, { key: 0 }, D(e.raw, (o) => (p(), h("td", {
              class: z(["mlse-column", e.analysisYearStyle(o)]),
              "data-year": o.year
            }, [
              a("div", Tnt, g(e.shortCurrency(o.costofsale)), 1)
            ], 10, Int))), 256))
          ]),
          a("tr", null, [
            t[4] || (t[4] = a("th", { rel: "netequity" }, "Net Equity", -1)),
            e.hasShortTermResults ? (p(!0), h(A, { key: 1 }, D(e.shortTerm, (o) => (p(), h("td", {
              class: z(["mlse-column", e.analysisYearStyle(o)]),
              "data-year": o.year
            }, [
              a("div", xnt, g(e.shortCurrency(o.netEquity)), 1)
            ], 10, Mnt))), 256)) : (p(!0), h(A, { key: 0 }, D(e.raw, (o) => (p(), h("td", {
              class: z(["mlse-column", e.analysisYearStyle(o)]),
              "data-year": o.year
            }, [
              a("div", Bnt, g(e.shortCurrency(o.netequity)), 1)
            ], 10, Lnt))), 256))
          ])
        ])
      ]),
      e.haveAccess ? P("", !0) : (p(), h("div", Fnt, t[5] || (t[5] = [
        Bt('<div><img src="' + qb + '" alt="Financial APOD table" title="Financial APOD table" height="240" width="426" class="img-fluid" loading="lazy"></div><div class="p-4"><p class="fw-bold fs-5">View our full 30 year analysis<br class="d-none d-lg-block"> with an account!</p><a href="/signup" class="btn btn-lava">Activate Full Analysis!</a></div>', 2)
      ])))
    ], 2)
  ], 2);
}
const Jls = /* @__PURE__ */ Ae(vnt, [["render", Vnt]]), Dnt = me({
  name: "CashFlowComparison",
  computed: {
    calculatingClasses() {
      return {
        card: !0,
        "card-cash-flow": !0,
        "shadow-sm": !0,
        calculating: this.calculating
      };
    },
    normalized() {
      var e, t;
      return ((t = (e = this.calculatedResults) == null ? void 0 : e.normalized) == null ? void 0 : t.find((s) => s.year == this.firstProformaYear)) ?? {};
    },
    raw() {
      var e, t;
      return ((t = (e = this.calculatedResults) == null ? void 0 : e.raw) == null ? void 0 : t.find((s) => s.year == this.firstProformaYear)) ?? {};
    },
    shortTerm() {
      var e, t;
      return ((t = (e = this.calculatedResults) == null ? void 0 : e.shortTerm) == null ? void 0 : t.find((s) => s.year == this.firstProformaYear)) ?? {};
    },
    padSplit() {
      var e, t;
      return ((t = (e = this.calculatedResults) == null ? void 0 : e.padSplit) == null ? void 0 : t.find((s) => s.year == this.firstProformaYear)) ?? {};
    },
    mainTableStyle() {
      return {
        table: !0,
        "table-sm": !0,
        //'text-small': true,
        "mlse-values": !0,
        regListing: !0,
        tabla: !0,
        "mlse-table": !0,
        "mlse-cash-flow": !0,
        "mode-advanced": !0
      };
    },
    colSpan() {
      return this.rentalTypes.length + 1;
    },
    ...q(qe, ["calculating", "calculatedResults", "firstProformaYear", "rentalTypes"])
  },
  methods: {
    number: Ve,
    currency: Ze,
    shortCurrency: ka,
    percent: Wt,
    currencyStyle(e) {
      return {
        "last adv-annualcashflow": !0,
        positive: e > 0,
        negative: e < 0
      };
    },
    yearValues(e) {
      switch (e) {
        case Ut.LongTerm:
          return this.normalized;
        case Ut.ShortTerm:
          return this.shortTerm;
        case Ut.PadSplit:
          return this.padSplit;
      }
    }
  }
}), Nnt = { class: "card-header bg-eclipse text-white rounded rounded-bottom-0 fw-bold text-center text-sm-start" }, jnt = { class: "card-body p-0 position-relative overflow-hidden" }, Hnt = { class: "text-end" }, Unt = { class: "text-center align-middle" }, znt = {
  key: 2,
  src: nn,
  alt: "PadSplit",
  title: "PadSplit",
  loading: "lazy",
  class: "img-fluid",
  width: "85"
}, Wnt = ["colspan"], Gnt = { class: "tb-space" }, Ynt = { class: "text-end" }, Xnt = { class: "adv-grosspotential" }, qnt = { class: "text-end" }, Qnt = { class: "adv-vacancyloss" }, Knt = { class: "table-total table-divider" }, Znt = { class: "fw-bold text-end" }, Jnt = { class: "adv-eri" }, $nt = ["colspan"], _nt = { class: "tb-space" }, ert = { class: "text-end" }, trt = { class: "adv-propertytax" }, srt = { class: "text-end" }, art = { class: "adv-propertyinsurance" }, nrt = { class: "text-end" }, rrt = { class: "adv-hoa" }, ort = { class: "text-end" }, irt = { class: "adv-propertymanagement" }, lrt = { class: "text-end" }, drt = { class: "adv-leasingcommissions" }, crt = { class: "text-end" }, urt = { class: "adv-platformServiceFees" }, prt = { class: "text-end" }, hrt = { class: "adv-propertymaintenance" }, mrt = { class: "text-end" }, frt = { class: "adv-utilityExpenses" }, grt = { class: "text-end" }, vrt = { class: "adv-furnishingExpenses" }, yrt = { class: "text-end" }, brt = { class: "adv-consumableExpenses" }, Art = { class: "text-end" }, wrt = { class: "adv-cleaningExpenses" }, Crt = { class: "table-divider" }, Srt = { class: "fw-bold text-end" }, Prt = { class: "adv-totalexpenses" }, krt = ["colspan"], Ert = { class: "bg-light table-divider" }, Irt = { class: "fw-bold text-end" }, Trt = { class: "adv-noi" }, Ort = { class: "text-end" }, Rrt = { class: "adv-annualdebtservice" }, Lrt = { class: "table-total styled-finances table-divider" }, Brt = { class: "fw-bold text-end" };
function Mrt(e, t, s, n, r, i) {
  return p(), h("div", {
    class: z(e.calculatingClasses)
  }, [
    a("div", Nnt, " CASH FLOW YEAR " + g(e.raw.fiscalYear), 1),
    a("div", jnt, [
      t[19] || (t[19] = a("div", { class: "calculating-animation position-absolute top-50 start-50 translate-middle text-center" }, [
        a("i", { class: "fa-duotone fa-solid fa-compass fa-spin fa-lg text-eclipse" }),
        a("br"),
        a("small", null, "Calculating")
      ], -1)),
      a("div", null, [
        a("table", {
          class: z(e.mainTableStyle)
        }, [
          a("thead", null, [
            a("tr", Hnt, [
              t[0] || (t[0] = a("th", { scope: "col" }, " ", -1)),
              (p(!0), h(A, null, D(e.rentalTypes, (o) => (p(), h("th", Unt, [
                o == "long-term" ? (p(), h(A, { key: 0 }, [
                  y(" Long Term ")
                ], 64)) : o == "short-term" ? (p(), h(A, { key: 1 }, [
                  y(" Short Term ")
                ], 64)) : o == "pad-split" ? (p(), h("img", znt)) : P("", !0)
              ]))), 256))
            ]),
            a("tr", null, [
              a("th", {
                colspan: e.colSpan,
                class: "table-alice fw-bold"
              }, " RENTAL INCOME ", 8, Wnt)
            ])
          ]),
          a("tbody", Gnt, [
            a("tr", null, [
              t[1] || (t[1] = a("th", {
                rel: "grosspotential",
                class: "fw-normal"
              }, " Gross Potential Income ", -1)),
              (p(!0), h(A, null, D(e.rentalTypes, (o) => (p(), h("td", Ynt, [
                a("div", Xnt, g(e.currency(e.yearValues(o).grossPotential)), 1)
              ]))), 256))
            ]),
            a("tr", null, [
              t[2] || (t[2] = a("th", {
                rel: "vacancyloss",
                class: "fw-normal"
              }, "Vacancy Loss", -1)),
              (p(!0), h(A, null, D(e.rentalTypes, (o) => (p(), h("td", qnt, [
                a("div", Qnt, g(e.currency(e.yearValues(o).vacancyLoss + e.yearValues(o).rehabVacancyLoss)), 1)
              ]))), 256))
            ]),
            a("tr", Knt, [
              t[3] || (t[3] = a("th", { rel: "eri" }, [
                a("strong", null, " Effective Rental Income ")
              ], -1)),
              (p(!0), h(A, null, D(e.rentalTypes, (o) => (p(), h("th", Znt, [
                a("div", Jnt, g(e.currency(e.yearValues(o).effectiveIncome)), 1)
              ]))), 256))
            ])
          ]),
          a("thead", null, [
            a("tr", null, [
              a("th", {
                colspan: e.colSpan,
                class: "table-alice fw-bold"
              }, " OPERATING EXPENSES ", 8, $nt)
            ])
          ]),
          a("tbody", _nt, [
            a("tr", null, [
              t[4] || (t[4] = a("th", {
                rel: "propertytax",
                class: "fw-normal"
              }, "Property Tax", -1)),
              (p(!0), h(A, null, D(e.rentalTypes, (o) => (p(), h("td", ert, [
                a("div", trt, g(e.currency(e.yearValues(o).propertyTax)), 1)
              ]))), 256))
            ]),
            a("tr", null, [
              t[5] || (t[5] = a("th", {
                rel: "propertyinsurance",
                class: "fw-normal"
              }, "Property Insurance", -1)),
              (p(!0), h(A, null, D(e.rentalTypes, (o) => (p(), h("td", srt, [
                a("div", art, g(e.currency(e.yearValues(o).propertyInsurance)), 1)
              ]))), 256))
            ]),
            a("tr", null, [
              t[6] || (t[6] = a("th", {
                rel: "hoa",
                class: "fw-normal"
              }, "HOA", -1)),
              (p(!0), h(A, null, D(e.rentalTypes, (o) => (p(), h("td", nrt, [
                a("div", rrt, g(e.currency(e.yearValues(o).hoa)), 1)
              ]))), 256))
            ]),
            a("tr", null, [
              t[7] || (t[7] = a("th", {
                rel: "propertymanagement",
                class: "fw-normal"
              }, "Property Management", -1)),
              (p(!0), h(A, null, D(e.rentalTypes, (o) => (p(), h("td", ort, [
                a("div", irt, g(e.currency(e.yearValues(o).propertyManagement)), 1)
              ]))), 256))
            ]),
            a("tr", null, [
              t[8] || (t[8] = a("th", {
                rel: "leasingcommissions",
                class: "fw-normal"
              }, "Leasing Commissions", -1)),
              (p(!0), h(A, null, D(e.rentalTypes, (o) => (p(), h("td", lrt, [
                a("div", drt, g(e.currency(e.yearValues(o).leasingCommissions)), 1)
              ]))), 256))
            ]),
            a("tr", null, [
              t[9] || (t[9] = a("th", {
                rel: "platformServiceFees",
                class: "fw-normal"
              }, "Platform Service Fees", -1)),
              (p(!0), h(A, null, D(e.rentalTypes, (o) => (p(), h("td", crt, [
                a("div", urt, g(e.currency(e.yearValues(o).platformServiceFees)), 1)
              ]))), 256))
            ]),
            a("tr", null, [
              t[10] || (t[10] = a("th", {
                rel: "propertymaintenance",
                class: "fw-normal"
              }, "Property Maintenance", -1)),
              (p(!0), h(A, null, D(e.rentalTypes, (o) => (p(), h("td", prt, [
                a("div", hrt, g(e.currency(e.yearValues(o).propertyMaintenance)), 1)
              ]))), 256))
            ]),
            a("tr", null, [
              t[11] || (t[11] = a("th", {
                rel: "utilityExpenses",
                class: "fw-normal"
              }, "Utility Expenses", -1)),
              (p(!0), h(A, null, D(e.rentalTypes, (o) => (p(), h("td", mrt, [
                a("div", frt, g(e.currency(e.yearValues(o).utilityExpenses)), 1)
              ]))), 256))
            ]),
            a("tr", null, [
              t[12] || (t[12] = a("th", {
                rel: "furnishingExpenses",
                class: "fw-normal"
              }, "Furnishing Expenses", -1)),
              (p(!0), h(A, null, D(e.rentalTypes, (o) => (p(), h("td", grt, [
                a("div", vrt, g(e.currency(e.yearValues(o).furnishingExpenses)), 1)
              ]))), 256))
            ]),
            a("tr", null, [
              t[13] || (t[13] = a("th", {
                rel: "consumableExpenses",
                class: "fw-normal"
              }, "Consumable Expenses", -1)),
              (p(!0), h(A, null, D(e.rentalTypes, (o) => (p(), h("td", yrt, [
                a("div", brt, g(e.currency(e.yearValues(o).consumableExpenses)), 1)
              ]))), 256))
            ]),
            a("tr", null, [
              t[14] || (t[14] = a("th", {
                rel: "cleaningExpenses",
                class: "fw-normal"
              }, "Cleaning Expenses", -1)),
              (p(!0), h(A, null, D(e.rentalTypes, (o) => (p(), h("td", Art, [
                a("div", wrt, g(e.currency(e.yearValues(o).cleaningExpenses)), 1)
              ]))), 256))
            ]),
            a("tr", Crt, [
              t[15] || (t[15] = a("th", {
                rel: "totalexpenses",
                class: "fw-bold"
              }, " Total Expenses ", -1)),
              (p(!0), h(A, null, D(e.rentalTypes, (o) => (p(), h("th", Srt, [
                a("div", Prt, g(e.currency(e.yearValues(o).totalExpenses)), 1)
              ]))), 256))
            ])
          ]),
          a("thead", null, [
            a("tr", null, [
              a("th", {
                colspan: e.colSpan,
                class: "table-alice fw-bold"
              }, " NET INCOME ", 8, krt)
            ])
          ]),
          a("tbody", null, [
            a("tr", Ert, [
              t[16] || (t[16] = a("th", {
                rel: "noi",
                class: "fw-bold"
              }, "Net Operating Income", -1)),
              (p(!0), h(A, null, D(e.rentalTypes, (o) => (p(), h("th", Irt, [
                a("div", Trt, g(e.currency(e.yearValues(o).noi)), 1)
              ]))), 256))
            ]),
            a("tr", null, [
              t[17] || (t[17] = a("th", {
                rel: "annualdebtservice",
                class: "fw-normal"
              }, "Annual Debt Service", -1)),
              (p(!0), h(A, null, D(e.rentalTypes, (o) => (p(), h("td", Ort, [
                a("div", Rrt, g(e.currency(e.yearValues(o).annualDebtService)), 1)
              ]))), 256))
            ]),
            a("tr", Lrt, [
              t[18] || (t[18] = a("th", {
                rel: "annualcashflow",
                class: "fw-bold"
              }, [
                a("strong", null, "Annual Cash Flow")
              ], -1)),
              (p(!0), h(A, null, D(e.rentalTypes, (o) => (p(), h("th", Brt, [
                a("div", {
                  class: z(e.currencyStyle(e.yearValues(o).annualCashFlow))
                }, g(e.currency(e.yearValues(o).annualCashFlow)), 3)
              ]))), 256))
            ])
          ])
        ], 2)
      ])
    ])
  ], 2);
}
const xrt = /* @__PURE__ */ Ae(Dnt, [["render", Mrt]]), Frt = me({
  name: "CoCReturnComparison",
  computed: {
    calculatingClasses() {
      return {
        "card shadow-sm": !0,
        "card-str-comparison": !0,
        "shadow-sm": !0,
        calculating: this.calculating
      };
    },
    firstProformaYearNormalized() {
      var e, t;
      return (t = (e = this.calculatedResults) == null ? void 0 : e.normalized) == null ? void 0 : t.find((s) => s.year == this.firstProformaYear);
    },
    firstProformaYearShortTerm() {
      var e, t;
      return (t = (e = this.calculatedResults) == null ? void 0 : e.shortTerm) == null ? void 0 : t.find((s) => s.year == this.firstProformaYear);
    },
    firstProformaYearPadSplit() {
      var e, t;
      return (t = (e = this.calculatedResults) == null ? void 0 : e.padSplit) == null ? void 0 : t.find((s) => s.year == this.firstProformaYear);
    },
    hasLongTerm() {
      var e;
      return this.isLongTerm || (((e = this.calcParams) == null ? void 0 : e.rentalTypeComparisons) & nt.LongTerm) == nt.LongTerm;
    },
    hasShortTermResults() {
      var e;
      return this.isShortTerm || (((e = this.calcParams) == null ? void 0 : e.rentalTypeComparisons) & nt.ShortTerm) == nt.ShortTerm;
    },
    hasPadSplitResults() {
      var e;
      return this.isPadSplit || (((e = this.calcParams) == null ? void 0 : e.rentalTypeComparisons) & nt.PadSplit) == nt.PadSplit;
    },
    ...at(qe),
    ...q(qe, ["calculating", "calculatedResults", "firstProformaYear", "calcParams", "isLongTerm", "isShortTerm", "isPadSplit"])
  },
  methods: {
    percent: Wt
  }
}), Vrt = { class: "card-body position-relative overflow-hidden" }, Drt = { class: "row g-3 kpi-data" }, Nrt = {
  key: 0,
  class: "col text-center"
}, jrt = { class: "fw-bold fs-5" }, Hrt = {
  key: 1,
  class: "col text-center"
}, Urt = { class: "fw-bold fs-5" }, zrt = {
  key: 2,
  class: "col text-center"
}, Wrt = { class: "fw-bold fs-5" };
function Grt(e, t, s, n, r, i) {
  var o, l, d;
  return p(), h("div", {
    class: z(e.calculatingClasses)
  }, [
    t[7] || (t[7] = a("div", { class: "card-header bg-eclipse text-white fw-bold border-0 text-uppercase text-center rounded rounded-bottom-0" }, " CASH ON CASH RETURN ", -1)),
    a("div", Vrt, [
      t[6] || (t[6] = a("div", { class: "calculating-animation position-absolute top-50 start-50 translate-middle text-center" }, [
        a("i", { class: "fa-duotone fa-solid fa-compass fa-spin fa-lg text-eclipse" }),
        a("br"),
        a("small", null, "Calculating")
      ], -1)),
      a("div", Drt, [
        e.hasLongTerm ? (p(), h("div", Nrt, [
          t[0] || (t[0] = y(" Long Term")),
          t[1] || (t[1] = a("br", null, null, -1)),
          a("span", jrt, g(e.percent((o = e.firstProformaYearNormalized) == null ? void 0 : o.coc, 1)), 1)
        ])) : P("", !0),
        e.hasShortTermResults ? (p(), h("div", Hrt, [
          t[2] || (t[2] = y(" Short Term")),
          t[3] || (t[3] = a("br", null, null, -1)),
          a("span", Urt, g(e.percent((l = e.firstProformaYearShortTerm) == null ? void 0 : l.coc, 1)), 1)
        ])) : P("", !0),
        e.hasPadSplitResults ? (p(), h("div", zrt, [
          t[4] || (t[4] = a("img", {
            src: nn,
            alt: "PadSplit",
            title: "PadSplit",
            loading: "lazy",
            class: "img-fluid",
            width: "85"
          }, null, -1)),
          t[5] || (t[5] = a("br", null, null, -1)),
          a("span", Wrt, g(e.percent((d = e.firstProformaYearPadSplit) == null ? void 0 : d.coc, 1)), 1)
        ])) : P("", !0)
      ])
    ])
  ], 2);
}
const Yrt = /* @__PURE__ */ Ae(Frt, [["render", Grt]]), Xrt = me({
  name: "MonthlyCashFlowComparison",
  computed: {
    calculatingClasses() {
      return {
        "card shadow-sm": !0,
        "card-str-comparison": !0,
        "shadow-sm": !0,
        calculating: this.calculating
      };
    },
    monthlyCashFlow() {
      var e;
      return (e = this.firstProformaYearNormalized) != null && e.monthlycashflow ? this.firstProformaYearNormalized.monthlycashflow : "-";
    },
    strMonthlyCashFlow() {
      var e;
      return (e = this.firstProformaYearShortTerm) != null && e.monthlyCashFlow ? this.firstProformaYearShortTerm.monthlyCashFlow : "-";
    },
    padSplitMonthlyCashFlow() {
      var e;
      return (e = this.firstProformaYearPadSplit) != null && e.monthlyCashFlow ? this.firstProformaYearPadSplit.monthlyCashFlow : "-";
    },
    firstProformaYearNormalized() {
      var e, t;
      return (t = (e = this.calculatedResults) == null ? void 0 : e.normalized) == null ? void 0 : t.find((s) => s.year == this.firstProformaYear);
    },
    firstProformaYearShortTerm() {
      var e, t;
      return (t = (e = this.calculatedResults) == null ? void 0 : e.shortTerm) == null ? void 0 : t.find((s) => s.year == this.firstProformaYear);
    },
    firstProformaYearPadSplit() {
      var e, t;
      return (t = (e = this.calculatedResults) == null ? void 0 : e.padSplit) == null ? void 0 : t.find((s) => s.year == this.firstProformaYear);
    },
    hasLongTerm() {
      var e;
      return this.isLongTerm || (((e = this.calcParams) == null ? void 0 : e.rentalTypeComparisons) & nt.LongTerm) == nt.LongTerm;
    },
    hasShortTermResults() {
      var e;
      return this.isShortTerm || (((e = this.calcParams) == null ? void 0 : e.rentalTypeComparisons) & nt.ShortTerm) == nt.ShortTerm;
    },
    hasPadSplitResults() {
      var e;
      return this.isPadSplit || (((e = this.calcParams) == null ? void 0 : e.rentalTypeComparisons) & nt.PadSplit) == nt.PadSplit;
    },
    ...at(qe),
    ...q(qe, ["calculating", "calculatedResults", "firstProformaYear", "calcParams", "isLongTerm", "isShortTerm", "isPadSplit"])
  },
  methods: {
    currency: Ze
  }
}), qrt = { class: "card-body position-relative overflow-hidden" }, Qrt = { class: "row g-3 kpi-data" }, Krt = {
  key: 0,
  class: "col text-center"
}, Zrt = { class: "fw-bold fs-5" }, Jrt = {
  key: 1,
  class: "col text-center"
}, $rt = { class: "fw-bold fs-5" }, _rt = {
  key: 2,
  class: "col text-center"
}, eot = { class: "fw-bold fs-5" };
function tot(e, t, s, n, r, i) {
  return p(), h("div", {
    class: z(e.calculatingClasses)
  }, [
    t[7] || (t[7] = a("div", { class: "card-header bg-eclipse text-white fw-bold border-0 text-uppercase text-center rounded rounded-bottom-0" }, " MONTHLY CASH FLOW ", -1)),
    a("div", qrt, [
      t[6] || (t[6] = a("div", { class: "calculating-animation position-absolute top-50 start-50 translate-middle text-center" }, [
        a("i", { class: "fa-duotone fa-solid fa-compass fa-spin fa-lg text-eclipse" }),
        a("br"),
        a("small", null, "Calculating")
      ], -1)),
      a("div", Qrt, [
        e.hasLongTerm ? (p(), h("div", Krt, [
          t[0] || (t[0] = y(" Long Term")),
          t[1] || (t[1] = a("br", null, null, -1)),
          a("span", Zrt, g(e.currency(e.monthlyCashFlow)), 1)
        ])) : P("", !0),
        e.hasShortTermResults ? (p(), h("div", Jrt, [
          t[2] || (t[2] = y(" Short Term")),
          t[3] || (t[3] = a("br", null, null, -1)),
          a("span", $rt, g(e.currency(e.strMonthlyCashFlow)), 1)
        ])) : P("", !0),
        e.hasPadSplitResults ? (p(), h("div", _rt, [
          t[4] || (t[4] = a("img", {
            src: nn,
            alt: "PadSplit",
            title: "PadSplit",
            loading: "lazy",
            class: "img-fluid",
            width: "85"
          }, null, -1)),
          t[5] || (t[5] = a("br", null, null, -1)),
          a("span", eot, g(e.currency(e.padSplitMonthlyCashFlow)), 1)
        ])) : P("", !0)
      ])
    ])
  ], 2);
}
const sot = /* @__PURE__ */ Ae(Xrt, [["render", tot]]), aot = me({
  name: "NetGainComparison",
  computed: {
    calculatingClasses() {
      return {
        "card shadow-sm": !0,
        "card-str-comparison": !0,
        "shadow-sm": !0,
        calculating: this.calculating
      };
    },
    hold() {
      var e;
      return this.isHoldYearAuto ? this.calculatedResults.idealHoldYear : (e = this.calcParams) == null ? void 0 : e.hold;
    },
    holdPeriodNormalized() {
      var e, t;
      return (t = (e = this.calculatedResults) == null ? void 0 : e.normalized) == null ? void 0 : t.find((s) => s.year == this.hold);
    },
    holdPeriodShortTerm() {
      var e, t;
      return (t = (e = this.calculatedResults) == null ? void 0 : e.shortTerm) == null ? void 0 : t.find((s) => s.year == this.hold);
    },
    holdPeriodPadSplit() {
      var e, t;
      return (t = (e = this.calculatedResults) == null ? void 0 : e.padSplit) == null ? void 0 : t.find((s) => s.year == this.hold);
    },
    ...at(qe),
    ...q(qe, ["calculating", "calculatedResults", "firstAnalyzedYear", "calcParams", "isLongTerm", "isShortTerm", "isPadSplit", "firstProformaYear", "isHoldYearAuto", "hasLongTerm", "hasShortTerm", "hasPadSplit"])
  },
  methods: {
    shortCurrency: ka
  }
}), not = { class: "card-body position-relative overflow-hidden" }, rot = { class: "row g-3 kpi-data" }, oot = {
  key: 0,
  class: "col text-center"
}, iot = { class: "fw-bold fs-5" }, lot = {
  key: 1,
  class: "col text-center"
}, dot = { class: "fw-bold fs-5" }, cot = {
  key: 2,
  class: "col text-center"
}, uot = { class: "fw-bold fs-5" };
function pot(e, t, s, n, r, i) {
  var o, l, d, c, u, m;
  return p(), h("div", {
    class: z(e.calculatingClasses)
  }, [
    t[7] || (t[7] = a("div", { class: "card-header bg-eclipse text-white fw-bold border-0 text-uppercase text-center rounded rounded-bottom-0" }, " NET GAIN ON INVESTMENT ", -1)),
    a("div", not, [
      t[6] || (t[6] = a("div", { class: "calculating-animation position-absolute top-50 start-50 translate-middle text-center" }, [
        a("i", { class: "fa-duotone fa-solid fa-compass fa-spin fa-lg text-eclipse" }),
        a("br"),
        a("small", null, "Calculating")
      ], -1)),
      a("div", rot, [
        e.hasLongTerm ? (p(), h("div", oot, [
          t[0] || (t[0] = y(" Long Term")),
          t[1] || (t[1] = a("br", null, null, -1)),
          a("span", iot, g(e.shortCurrency(((o = e.holdPeriodNormalized) == null ? void 0 : o.grossWealthAccumulation) - ((l = e.holdPeriodNormalized) == null ? void 0 : l.capitalInvestedEnd), "-")), 1)
        ])) : P("", !0),
        e.hasShortTerm ? (p(), h("div", lot, [
          t[2] || (t[2] = y(" Short Term")),
          t[3] || (t[3] = a("br", null, null, -1)),
          a("span", dot, g(e.shortCurrency(((d = e.holdPeriodShortTerm) == null ? void 0 : d.grossWealthAccumulation) - ((c = e.holdPeriodShortTerm) == null ? void 0 : c.capitalInvestedEnd), "-")), 1)
        ])) : P("", !0),
        e.hasPadSplit ? (p(), h("div", cot, [
          t[4] || (t[4] = a("img", {
            src: nn,
            alt: "PadSplit",
            title: "PadSplit",
            loading: "lazy",
            class: "img-fluid",
            width: "85"
          }, null, -1)),
          t[5] || (t[5] = a("br", null, null, -1)),
          a("span", uot, g(e.shortCurrency(((u = e.holdPeriodPadSplit) == null ? void 0 : u.grossWealthAccumulation) - ((m = e.holdPeriodPadSplit) == null ? void 0 : m.capitalInvestedEnd), "-")), 1)
        ])) : P("", !0)
      ])
    ])
  ], 2);
}
const hot = /* @__PURE__ */ Ae(aot, [["render", pot]]), mot = me({
  name: "TotalInvestmentComparison",
  computed: {
    calculatingClasses() {
      return {
        "card shadow-sm": !0,
        "card-str-comparison": !0,
        "shadow-sm": !0,
        calculating: this.calculating
      };
    },
    hasLongTerm() {
      var e;
      return this.isLongTerm || (((e = this.calcParams) == null ? void 0 : e.rentalTypeComparisons) & nt.LongTerm) == nt.LongTerm;
    },
    hasShortTermResults() {
      var e;
      return this.isShortTerm || (((e = this.calcParams) == null ? void 0 : e.rentalTypeComparisons) & nt.ShortTerm) == nt.ShortTerm;
    },
    hasPadSplitResults() {
      var e;
      return this.isPadSplit || (((e = this.calcParams) == null ? void 0 : e.rentalTypeComparisons) & nt.PadSplit) == nt.PadSplit;
    },
    ...at(qe),
    ...q(qe, ["calculating", "calculatedResults", "initialInvestmentLongTerm", "initialInvestmentShortTerm", "initialInvestmentPadSplit", "calcParams", "isLongTerm", "isShortTerm", "isPadSplit"])
  },
  methods: {
    currency: Ze
  }
}), fot = { class: "card-body position-relative overflow-hidden" }, got = { class: "row g-3 kpi-data" }, vot = {
  key: 0,
  class: "col text-center"
}, yot = { class: "fw-bold fs-5" }, bot = {
  key: 1,
  class: "col text-center"
}, Aot = { class: "fw-bold fs-5" }, wot = {
  key: 2,
  class: "col text-center"
}, Cot = { class: "fw-bold fs-5" };
function Sot(e, t, s, n, r, i) {
  return p(), h("div", {
    class: z(e.calculatingClasses)
  }, [
    t[7] || (t[7] = a("div", { class: "card-header bg-eclipse text-white fw-bold border-0 text-uppercase text-center rounded rounded-bottom-0" }, " TOTAL INVESTMENT ", -1)),
    a("div", fot, [
      t[6] || (t[6] = a("div", { class: "calculating-animation position-absolute top-50 start-50 translate-middle text-center" }, [
        a("i", { class: "fa-duotone fa-solid fa-compass fa-spin fa-lg text-eclipse" }),
        a("br"),
        a("small", null, "Calculating")
      ], -1)),
      a("div", got, [
        e.hasLongTerm ? (p(), h("div", vot, [
          t[0] || (t[0] = y(" Long Term")),
          t[1] || (t[1] = a("br", null, null, -1)),
          a("span", yot, g(e.currency(e.initialInvestmentLongTerm)), 1)
        ])) : P("", !0),
        e.hasShortTermResults ? (p(), h("div", bot, [
          t[2] || (t[2] = y(" Short Term")),
          t[3] || (t[3] = a("br", null, null, -1)),
          a("span", Aot, g(e.currency(e.initialInvestmentShortTerm)), 1)
        ])) : P("", !0),
        e.hasPadSplitResults ? (p(), h("div", wot, [
          t[4] || (t[4] = a("img", {
            src: nn,
            alt: "PadSplit",
            title: "PadSplit",
            loading: "lazy",
            class: "img-fluid",
            width: "85"
          }, null, -1)),
          t[5] || (t[5] = a("br", null, null, -1)),
          a("span", Cot, g(e.currency(e.initialInvestmentPadSplit)), 1)
        ])) : P("", !0)
      ])
    ])
  ], 2);
}
const Pot = /* @__PURE__ */ Ae(mot, [["render", Sot]]), kot = me({
  name: "ScenariosTab",
  components: {
    CashFlowComparison: xrt,
    CocReturnComparison: Yrt,
    MonthlyCashFlowComparison: sot,
    NetGainComparison: hot,
    TotalInvestmentComparison: Pot
  }
}), Eot = {
  class: "tab-pane py-4 wave",
  id: "financial-scenarios",
  role: "tabpanel",
  "aria-labelledby": "financial-scenarios-tab"
}, Iot = { class: "container-fluid container-xl" }, Tot = { class: "row g-4 mb-4" }, Oot = { class: "col-md-5" }, Rot = { class: "col-md-7 gap-4 d-flex flex-column" };
function Lot(e, t, s, n, r, i) {
  const o = pe("cash-flow-comparison"), l = pe("total-investment-comparison"), d = pe("monthly-cash-flow-comparison"), c = pe("coc-return-comparison"), u = pe("net-gain-comparison");
  return p(), h("div", Eot, [
    a("div", Iot, [
      a("div", Tot, [
        t[0] || (t[0] = a("div", { class: "col-12" }, [
          a("h2", { class: "fw-bold fs-5" }, "Rental Method financial Performance Comparison")
        ], -1)),
        a("div", Oot, [
          N(o)
        ]),
        a("div", Rot, [
          N(l),
          N(d),
          N(c),
          N(u)
        ])
      ])
    ])
  ]);
}
const $ls = /* @__PURE__ */ Ae(kot, [["render", Lot]]), Bot = me({
  name: "RentalScenarioInvestmentBasis",
  computed: {
    investmentBasis() {
      var e, t;
      return (t = (e = this.calculatedResults) == null ? void 0 : e.existingInvestmentSummary) == null ? void 0 : t.investmentBasis;
    },
    ...q(qe, ["calcParams", "calculatedResults", "ignoreHistoricalOperatingIncome"])
  },
  methods: {
    currency: Ze
  }
}), Mot = { class: "card shadow-sm" }, xot = { class: "table table-sm table-financial" }, Fot = { class: "text-end" }, Vot = { class: "text-end" }, Dot = { class: "text-end" }, Not = { class: "table-total" }, jot = {
  class: "bg-light fw-bold text-end",
  scope: "row"
}, Hot = { class: "text-end" }, Uot = { class: "text-end" }, zot = { class: "table-total" }, Wot = {
  class: "bg-light fw-bold text-end",
  scope: "row"
};
function Got(e, t, s, n, r, i) {
  var o, l, d, c, u, m, f;
  return p(), h("div", Mot, [
    t[7] || (t[7] = a("div", { class: "card-header bg-eclipse text-white rounded rounded-bottom-0 fw-bold text-center text-sm-start" }, " RENTAL SCENARIO - INVESTMENT BASIS ", -1)),
    a("table", xot, [
      a("tbody", null, [
        a("tr", null, [
          t[0] || (t[0] = a("th", {
            class: "fw-normal",
            scope: "row"
          }, "Current Value", -1)),
          a("td", Fot, g(e.currency((o = e.investmentBasis) == null ? void 0 : o.propertyValue)), 1)
        ]),
        a("tr", null, [
          t[1] || (t[1] = a("th", {
            class: "fw-normal",
            scope: "row"
          }, "Less: Loan Balance", -1)),
          a("td", Vot, g(e.currency((l = e.investmentBasis) == null ? void 0 : l.loanBalance)), 1)
        ]),
        a("tr", null, [
          t[2] || (t[2] = a("th", {
            class: "fw-normal",
            scope: "row"
          }, "Less: Cost of Sale", -1)),
          a("td", Dot, g(e.currency((d = e.investmentBasis) == null ? void 0 : d.costOfSale)), 1)
        ]),
        a("tr", Not, [
          t[3] || (t[3] = a("th", {
            class: "bg-light fw-bold",
            scope: "row"
          }, "Current Equity", -1)),
          a("th", jot, g(e.currency((c = e.investmentBasis) == null ? void 0 : c.netEquity)), 1)
        ]),
        a("tr", null, [
          t[4] || (t[4] = a("th", {
            class: "fw-normal",
            scope: "row"
          }, "Plus: Rehab Expense", -1)),
          a("td", Hot, g(e.currency((u = e.investmentBasis) == null ? void 0 : u.rehabAmount)), 1)
        ]),
        a("tr", null, [
          t[5] || (t[5] = a("th", {
            class: "fw-normal",
            scope: "row"
          }, "Plus: Working Capital", -1)),
          a("td", Uot, g(e.currency((m = e.investmentBasis) == null ? void 0 : m.workingCapitalReserve)), 1)
        ]),
        a("tr", zot, [
          t[6] || (t[6] = a("th", {
            class: "bg-light fw-bold",
            scope: "row"
          }, "Investment Basis", -1)),
          a("th", Wot, g(e.currency((f = e.investmentBasis) == null ? void 0 : f.total)), 1)
        ])
      ])
    ])
  ]);
}
const Yot = /* @__PURE__ */ Ae(Bot, [["render", Got]]), Xot = me({
  name: "SellAndReinvest",
  computed: {
    investmentBasis() {
      var e, t;
      return (t = (e = this.calculatedResults) == null ? void 0 : e.existingInvestmentSummary) == null ? void 0 : t.investmentBasis;
    },
    ...q(qe, ["rehabAmountForSelling", "sellInvestmentBasis", "calculatedResults"])
  },
  methods: {
    currency: Ze
  }
}), qot = { class: "card shadow-sm" }, Qot = { class: "table table-sm table-financial" }, Kot = { class: "text-end" }, Zot = { class: "text-end" }, Jot = { class: "table-total" }, $ot = { class: "bg-light fw-bold text-end" };
function _ot(e, t, s, n, r, i) {
  var o;
  return p(), h("div", qot, [
    t[3] || (t[3] = a("div", { class: "card-header bg-eclipse text-white rounded rounded-bottom-0 fw-bold text-center text-sm-start" }, " SELL AND REINVEST - INVESTMENT BASIS ", -1)),
    a("table", Qot, [
      a("tbody", null, [
        a("tr", null, [
          t[0] || (t[0] = a("th", { class: "fw-normal" }, "Current Equity", -1)),
          a("td", Kot, g(e.currency((o = e.investmentBasis) == null ? void 0 : o.netEquity, 0, "-")), 1)
        ]),
        a("tr", null, [
          t[1] || (t[1] = a("th", { class: "fw-normal" }, "Less: Repair Allowance", -1)),
          a("td", Zot, g(e.currency(e.rehabAmountForSelling, 0, "-")), 1)
        ]),
        a("tr", Jot, [
          t[2] || (t[2] = a("th", { class: "bg-light fw-bold" }, "Investment Basis", -1)),
          a("th", $ot, g(e.currency(e.sellInvestmentBasis, 0, "-")), 1)
        ])
      ])
    ])
  ]);
}
const eit = /* @__PURE__ */ Ae(Xot, [["render", _ot]]), tit = { class: "row g-0 justify-content-lg-between kpi-data kpi-crumbs" }, sit = { class: "col-lg-4" }, ait = { class: "d-flex justify-content-center align-items-start h-100" }, nit = { class: "flex-fill" }, rit = { class: "d-flex flex-column flex-lg-row mb-lg-3 align-items-center align-items-lg-start" }, oit = { class: "icon-shape bg-eclipse border-radius-md text-white d-flex justify-content-center align-items-center me-lg-3" }, iit = {
  key: 0,
  class: "fa-light fa-lg fa-house-circle-check",
  "aria-hidden": "true"
}, lit = {
  key: 1,
  class: "fa-light fa-lg fa-chart-mixed-up-circle-dollar",
  "aria-hidden": "true"
}, dit = { class: "fw-bold" }, cit = { class: "text-center" }, uit = { class: "fw-bold fs-5" }, pit = { class: "col-lg-5 position-relative pt-5 pt-md-0" }, hit = { class: "kpi-holdperiod d-flex justify-content-center align-items-center h-100 text-center" }, mit = { class: "fw-bold fs-5" }, fit = { class: "text-body-secondary" }, git = { class: "col-lg-3" }, vit = { class: "d-flex justify-content-center align-items-start h-100" }, yit = { class: "flex-fill text-center" }, bit = { class: "fs-5 fw-bold" }, Ait = /* @__PURE__ */ me({
  name: "SuggestionMaximumWealthAccumulation",
  __name: "SuggestionMaximumWealthAccumulation",
  setup(e) {
    const t = qe(), { comparisons: s, sellInvestmentBasis: n, accumulationOfWealth: r, holdYear: i, alternativeOne: o, alternativeTwo: l, alternativeThree: d, calculatedResults: c } = Mm(t);
    function u(b, w) {
      if (!b || b.length === 0)
        return;
      let S = b[0];
      for (let I = 1; I < b.length; I++)
        w(b[I]) > w(S) && (S = b[I]);
      return S;
    }
    const m = Ke(() => u(s.value.filter((b) => b.id == o.value || b.id == l.value || b.id == d.value), (b) => t.alternativeWealthAccumulation(b.id) - n.value)), f = Ke(() => !(m.value && t.alternativeWealthAccumulation(m.value.id) > r.value)), v = Ke(() => {
      var b, w;
      return (w = (b = c.value) == null ? void 0 : b.existingInvestmentSummary) == null ? void 0 : w.investmentBasis;
    });
    return (b, w) => {
      var S, I, T;
      return p(), h("div", tit, [
        a("div", sit, [
          a("div", ait, [
            a("div", nit, [
              a("div", rit, [
                a("div", oit, [
                  f.value ? (p(), h("i", iit)) : (p(), h("i", lit))
                ]),
                a("span", dit, [
                  w[0] || (w[0] = y(" Max Return:")),
                  w[1] || (w[1] = a("br", null, null, -1)),
                  f.value ? (p(), h(A, { key: 0 }, [
                    y(" Rental Method ")
                  ], 64)) : (p(), h(A, { key: 1 }, [
                    y(g((S = m.value) == null ? void 0 : S.name), 1)
                  ], 64))
                ]),
                w[2] || (w[2] = a("br", null, null, -1))
              ]),
              a("div", cit, [
                a("span", uit, g(st(Ze)(st(n))), 1),
                w[3] || (w[3] = a("br", null, null, -1)),
                w[4] || (w[4] = a("span", null, "Initial Investment", -1))
              ])
            ])
          ])
        ]),
        a("div", pit, [
          a("div", hit, [
            a("div", null, [
              w[5] || (w[5] = a("div", { class: "icon-shape bg-eclipse border-radius-md text-white d-flex justify-content-center align-items-center mb-3 mx-auto" }, [
                a("i", {
                  class: "fa-light fa-lg fa-clock",
                  "aria-hidden": "true"
                })
              ], -1)),
              a("span", mit, g(st(i)) + " Years", 1),
              w[6] || (w[6] = a("br", null, null, -1)),
              w[7] || (w[7] = y(" Hold Period")),
              w[8] || (w[8] = a("br", null, null, -1)),
              a("small", fit, "(" + g(st(Et) + (st(i) - 1)) + ")", 1)
            ])
          ]),
          w[9] || (w[9] = a("div", { class: "triangle" }, null, -1))
        ]),
        a("div", git, [
          a("div", vit, [
            a("div", yit, [
              w[10] || (w[10] = a("div", { class: "icon-shape bg-eclipse border-radius-md text-white d-flex justify-content-center align-items-center mb-3 mx-auto" }, [
                a("i", {
                  class: "fa-light fa-lg fa-money-bill-trend-up",
                  "aria-hidden": "true"
                })
              ], -1)),
              a("span", bit, [
                f.value ? (p(), h(A, { key: 0 }, [
                  y(g(st(Ze)(st(r) - ((I = v.value) == null ? void 0 : I.total))), 1)
                ], 64)) : m.value ? (p(), h(A, { key: 1 }, [
                  y(g(st(Ze)(st(t).alternativeWealthAccumulation((T = m.value) == null ? void 0 : T.id) - st(n))), 1)
                ], 64)) : P("", !0)
              ]),
              w[11] || (w[11] = a("br", null, null, -1)),
              w[12] || (w[12] = a("span", null, "Net Gain", -1))
            ])
          ])
        ])
      ]);
    };
  }
}), wit = me({
  name: "InvestmentAlternative",
  components: {
    NumericalInput: Aa
  },
  computed: {
    alternativeOneInvestment() {
      return this.comparisons.find((e) => e.id == this.alternativeOne);
    },
    alternativeTwoInvestment() {
      return this.comparisons.find((e) => e.id == this.alternativeTwo);
    },
    alternativeThreeInvestment() {
      return this.comparisons.find((e) => e.id == this.alternativeThree);
    },
    ...at(qe),
    ...q(Te, ["access", "aclLoaded", "hasRentVsSellFeature"]),
    ...q(qe, ["comparisons"]),
    ...xm(qe, ["alternativeOne", "alternativeTwo", "alternativeThree"])
  },
  methods: {
    number: Ve,
    percent: Wt,
    async getInvestmentComparisons() {
      try {
        this.hasRentVsSellFeature && await this.propertyStore.getInvestmentComparisons();
      } catch (e) {
        Se(e);
      }
    }
  },
  mounted() {
    this.aclLoaded.then(async () => await this.getInvestmentComparisons());
  }
}), Cit = { class: "table table-borderless table-sm mb-0" }, Sit = ["value"], Pit = { class: "text-center align-middle" }, kit = { class: "text-center align-middle" }, Eit = ["value"], Iit = { class: "text-center align-middle" }, Tit = { class: "text-center align-middle" }, Oit = ["value"], Rit = { class: "text-center align-middle" }, Lit = { class: "text-center align-middle" };
function Bit(e, t, s, n, r, i) {
  var l, d, c, u, m, f;
  const o = pe("numerical-input");
  return p(), h("table", Cit, [
    t[6] || (t[6] = a("thead", null, [
      a("tr", null, [
        a("th"),
        a("th", {
          colspan: "2",
          class: "text-center"
        }, " Historical Information "),
        a("th")
      ]),
      a("tr", { class: "text-center" }, [
        a("th", null, " Comparative Investments "),
        a("th", null, " 10-Year "),
        a("th", null, " 30-Year "),
        a("th", null, " Expected Average Annual Return ")
      ])
    ], -1)),
    a("tbody", null, [
      a("tr", null, [
        a("td", null, [
          V(a("select", {
            class: "form-select",
            "onUpdate:modelValue": t[0] || (t[0] = (v) => e.alternativeOne = v)
          }, [
            (p(!0), h(A, null, D(e.comparisons, (v) => (p(), h("option", {
              value: v.id
            }, g(v.shortName), 9, Sit))), 256))
          ], 512), [
            [We, e.alternativeOne]
          ])
        ]),
        a("td", Pit, g(e.percent((l = e.alternativeOneInvestment) == null ? void 0 : l.tenYearAvgReturn, 1)), 1),
        a("td", kit, g(e.percent((d = e.alternativeOneInvestment) == null ? void 0 : d.thirtyYearAvgReturn, 1)), 1),
        a("td", null, [
          e.alternativeOneInvestment ? (p(), Fe(o, {
            key: 0,
            percent: "",
            modelValue: e.alternativeOneInvestment.forwardLookingReturn,
            "onUpdate:modelValue": t[1] || (t[1] = (v) => e.alternativeOneInvestment.forwardLookingReturn = v)
          }, null, 8, ["modelValue"])) : P("", !0)
        ])
      ]),
      a("tr", null, [
        a("td", null, [
          V(a("select", {
            class: "form-select",
            "onUpdate:modelValue": t[2] || (t[2] = (v) => e.alternativeTwo = v)
          }, [
            (p(!0), h(A, null, D(e.comparisons, (v) => (p(), h("option", {
              value: v.id
            }, g(v.shortName), 9, Eit))), 256))
          ], 512), [
            [We, e.alternativeTwo]
          ])
        ]),
        a("td", Iit, g(e.percent((c = e.alternativeTwoInvestment) == null ? void 0 : c.tenYearAvgReturn, 1)), 1),
        a("td", Tit, g(e.percent((u = e.alternativeTwoInvestment) == null ? void 0 : u.thirtyYearAvgReturn, 1)), 1),
        a("td", null, [
          e.alternativeTwoInvestment ? (p(), Fe(o, {
            key: 0,
            percent: "",
            modelValue: e.alternativeTwoInvestment.forwardLookingReturn,
            "onUpdate:modelValue": t[3] || (t[3] = (v) => e.alternativeTwoInvestment.forwardLookingReturn = v)
          }, null, 8, ["modelValue"])) : P("", !0)
        ])
      ]),
      a("tr", null, [
        a("td", null, [
          V(a("select", {
            class: "form-select",
            "onUpdate:modelValue": t[4] || (t[4] = (v) => e.alternativeThree = v)
          }, [
            (p(!0), h(A, null, D(e.comparisons, (v) => (p(), h("option", {
              value: v.id
            }, g(v.shortName), 9, Oit))), 256))
          ], 512), [
            [We, e.alternativeThree]
          ])
        ]),
        a("td", Rit, g(e.percent((m = e.alternativeThreeInvestment) == null ? void 0 : m.tenYearAvgReturn, 1)), 1),
        a("td", Lit, g(e.percent((f = e.alternativeThreeInvestment) == null ? void 0 : f.thirtyYearAvgReturn, 1)), 1),
        a("td", null, [
          e.alternativeThreeInvestment ? (p(), Fe(o, {
            key: 0,
            percent: "",
            modelValue: e.alternativeThreeInvestment.forwardLookingReturn,
            "onUpdate:modelValue": t[5] || (t[5] = (v) => e.alternativeThreeInvestment.forwardLookingReturn = v)
          }, null, 8, ["modelValue"])) : P("", !0)
        ])
      ])
    ])
  ]);
}
const Mit = /* @__PURE__ */ Ae(wit, [["render", Bit]]), dS = De.Colors.Charts.Green, cS = De.Colors.Charts.Purple, uS = De.Colors.Charts.Yellow, pS = De.Colors.Charts.DarkBlue, xit = me({
  name: "WealthAccumulation",
  components: {
    //   Chart: PrimeChart,
  },
  data() {
    return {
      chartData: void 0,
      chartOptions: {
        responsive: !0,
        maintainAspectRatio: !0,
        plugins: {
          title: {
            display: !1
            //text: 'Cash on Cash Return'
          },
          legend: {
            display: !0,
            position: "top",
            maxHeight: 100,
            labels: {
              boxWidth: 10
            }
          },
          tooltip: {
            mode: "index",
            intersect: !1,
            callbacks: {
              label: function(e) {
                let t = e.dataset.label;
                const s = ": " + Ze(e.dataset.data[e.dataIndex]);
                return t += s, t;
              },
              title: function(e) {
                return "Year " + e[0].label;
              }
            }
          }
        },
        scales: {
          x: {
            title: {
              display: !0,
              text: "Years"
            }
          },
          y: {
            title: {
              display: !0,
              text: "Wealth Accumulation ($)"
            },
            stacked: !1,
            beginAtZero: !0
            //ticks: {
            //    callback: function (value, index, values) {
            //        return formatters.percent(value as number);
            //    }
            //}
          }
        }
      }
    };
  },
  watch: {
    alternativeOne() {
      this.refreshChart();
    },
    alternativeTwo() {
      this.refreshChart();
    },
    alternativeThree() {
      this.refreshChart();
    },
    calculatedResults() {
      this.refreshChart();
    }
  },
  computed: {
    alternativeOneInvestment() {
      return this.comparisons.find((e) => e.id == this.alternativeOne);
    },
    alternativeTwoInvestment() {
      return this.comparisons.find((e) => e.id == this.alternativeTwo);
    },
    alternativeThreeInvestment() {
      return this.comparisons.find((e) => e.id == this.alternativeThree);
    },
    ...at(qe),
    ...q(Te, ["access", "aclLoaded"]),
    ...q(qe, ["accumulationOfWealth", "holdYear", "alternativeOne", "alternativeTwo", "alternativeThree", "comparisons", "sellInvestmentBasis", "calculatedResults", "rehabAmountForSelling", "holdYear"])
  },
  methods: {
    number: Ve,
    currency: Ze,
    initCharts(e) {
      var s, n, r;
      this.chartData = {
        labels: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
        datasets: [
          {
            label: "Rental Investment",
            data: [0, 1e3, 2e3, 3e3, 4e3, 5e3, 6e3, 7e3, 8e3, 9e3],
            type: "line",
            backgroundColor: dS,
            borderColor: dS,
            borderWidth: 1,
            pointRadius: 1,
            fill: !1,
            tension: 0.4
          },
          {
            label: (s = this.alternativeOneInvestment) == null ? void 0 : s.name,
            data: [0, 1e3, 2e3, 3e3, 4e3, 5e3, 6e3, 7e3, 8e3, 9e3],
            type: "line",
            backgroundColor: cS,
            borderColor: cS,
            borderWidth: 1,
            pointRadius: 1,
            fill: !1,
            tension: 0.4
          },
          {
            label: (n = this.alternativeTwoInvestment) == null ? void 0 : n.name,
            data: [0, 1e3, 2e3, 3e3, 4e3, 5e3, 6e3, 7e3, 8e3, 9e3],
            type: "line",
            backgroundColor: uS,
            borderColor: uS,
            borderWidth: 1,
            pointRadius: 1,
            fill: !1,
            tension: 0.4
          },
          {
            label: (r = this.alternativeThreeInvestment) == null ? void 0 : r.name,
            data: [0, 1e3, 2e3, 3e3, 4e3, 5e3, 6e3, 7e3, 8e3, 9e3],
            type: "line",
            backgroundColor: pS,
            borderColor: pS,
            borderWidth: 1,
            pointRadius: 1,
            fill: !1,
            tension: 0.4
          }
        ]
      };
      const t = {
        type: "line",
        data: this.chartData,
        options: this.chartOptions
      };
      e && this.$refs.chart1 && !this.chart && (this.chart = new Rt(this.$refs.chart1, t));
    },
    showRentVsSellTab(e) {
      e.target.dataset.bsTarget == "#rent-vs-sell" && (this.initCharts(!0), this.refreshChart());
    },
    refreshChart() {
      var e;
      this.chartData || this.initCharts(), this.chartData.datasets[0].data = this.calculatedResults.normalized.map((t) => t.grossWealthAccumulation).slice(0, 10), this.alternativeOneInvestment && (this.chartData.datasets[1].label = this.alternativeOneInvestment.name, this.chartData.datasets[1].data = [...Array(this.holdYear).keys()].map((t) => this.propertyStore.alternativeWealthAccumulation(this.alternativeOneInvestment.id, t + 1))), this.alternativeTwoInvestment && (this.chartData.datasets[2].label = this.alternativeTwoInvestment.name, this.chartData.datasets[2].data = [...Array(this.holdYear).keys()].map((t) => this.propertyStore.alternativeWealthAccumulation(this.alternativeTwoInvestment.id, t + 1))), this.alternativeThreeInvestment && (this.chartData.datasets[3].label = this.alternativeThreeInvestment.name, this.chartData.datasets[3].data = [...Array(this.holdYear).keys()].map((t) => this.propertyStore.alternativeWealthAccumulation(this.alternativeThreeInvestment.id, t + 1))), (e = this.chart) == null || e.update();
    }
  },
  mounted() {
    this.initCharts(), document.addEventListener("shown.bs.tab", this.showRentVsSellTab);
  }
}), Fit = { class: "card shadow-sm mb-3" }, Vit = { class: "card-body text-center" }, Dit = { class: "row row-cols-2 row-cols-lg-4 g-3" }, Nit = { class: "col" }, jit = { class: "fw-bold fs-4" }, Hit = { class: "col" }, Uit = { class: "fw-bold fs-4" }, zit = { class: "col" }, Wit = { class: "fw-bold fs-4" }, Git = { class: "col" }, Yit = { class: "fw-bold fs-4" }, Xit = {
  "data-id": "chart1",
  class: "irrChart",
  id: "chart1",
  ref: "chart1",
  height: "200"
};
function qit(e, t, s, n, r, i) {
  var o, l, d, c, u, m;
  return pe("chart"), p(), h(A, null, [
    a("div", Fit, [
      a("div", {
        class: "card-header bg-eclipse text-white rounded rounded-bottom-0 fw-bold",
        onClick: t[0] || (t[0] = (...f) => e.refreshChart && e.refreshChart(...f))
      }, g(e.holdYear) + "-YEAR ESTIMATED WEALTH ACCUMULATION ", 1),
      a("div", Vit, [
        a("div", Dit, [
          a("div", Nit, [
            t[1] || (t[1] = y(" Rental Scenario")),
            t[2] || (t[2] = a("br", null, null, -1)),
            a("span", jit, g(e.currency(e.accumulationOfWealth)), 1)
          ]),
          a("div", Hit, [
            y(g((o = e.alternativeOneInvestment) == null ? void 0 : o.name), 1),
            t[3] || (t[3] = a("br", null, null, -1)),
            a("span", Uit, g(e.currency(e.propertyStore.alternativeWealthAccumulation((l = e.alternativeOneInvestment) == null ? void 0 : l.id), 0, "N/A")), 1)
          ]),
          a("div", zit, [
            y(g((d = e.alternativeTwoInvestment) == null ? void 0 : d.name), 1),
            t[4] || (t[4] = a("br", null, null, -1)),
            a("span", Wit, g(e.currency(e.propertyStore.alternativeWealthAccumulation((c = e.alternativeTwoInvestment) == null ? void 0 : c.id), 0, "N/A")), 1)
          ]),
          a("div", Git, [
            y(g((u = e.alternativeThreeInvestment) == null ? void 0 : u.name), 1),
            t[5] || (t[5] = a("br", null, null, -1)),
            a("span", Yit, g(e.currency(e.propertyStore.alternativeWealthAccumulation((m = e.alternativeThreeInvestment) == null ? void 0 : m.id), 0, "N/A")), 1)
          ])
        ])
      ])
    ]),
    P("", !0),
    a("div", null, [
      a("canvas", Xit, null, 512)
    ])
  ], 64);
}
const Qit = /* @__PURE__ */ Ae(xit, [["render", qit]]), Kit = { class: "table-wrapped" }, Zit = { class: "table table-sm table-financial table-investment-options mode-advanced" }, Jit = { class: "border-start text-end pe-3" }, $it = { class: "border-start text-center" }, _it = { class: "border-start text-end pe-3" }, elt = { class: "border-start text-end pe-3" }, tlt = { class: "fw-normal" }, slt = { class: "border-start text-end pe-3" }, alt = { class: "border-start text-center" }, nlt = { class: "border-start text-end pe-3" }, rlt = { class: "border-start text-end pe-3" }, olt = { class: "border-start cell-notes" }, ilt = { class: "fw-normal" }, llt = { class: "border-start text-end pe-3" }, dlt = { class: "border-start text-center" }, clt = { class: "border-start text-end pe-3" }, ult = { class: "border-start text-end pe-3" }, plt = { class: "border-start cell-notes" }, hlt = { class: "fw-normal" }, mlt = { class: "border-start text-end pe-3" }, flt = { class: "border-start text-center" }, glt = { class: "border-start text-end pe-3" }, vlt = { class: "border-start text-end pe-3" }, ylt = { class: "border-start cell-notes" }, blt = /* @__PURE__ */ me({
  name: "InvestmentOptions",
  __name: "InvestmentOptions",
  setup(e) {
    const t = qe(), { alternativeOne: s, alternativeTwo: n, alternativeThree: r, comparisons: i, sellInvestmentBasis: o, accumulationOfWealth: l, calcParams: d, calculatedResults: c, isHoldYearAuto: u } = Mm(t), m = Ke(() => i.value.find((S) => S.id == s.value)), f = Ke(() => i.value.find((S) => S.id == n.value)), v = Ke(() => i.value.find((S) => S.id == r.value)), b = Ke(() => {
      var I, T, x;
      let S = d.value.hold;
      return u.value && (S = c.value.idealHoldYear), (x = (T = (I = c.value) == null ? void 0 : I.normalized) == null ? void 0 : T.find((k) => k.year == S)) == null ? void 0 : x.irr;
    }), w = Ke(() => {
      var S, I;
      return (I = (S = c.value) == null ? void 0 : S.existingInvestmentSummary) == null ? void 0 : I.investmentBasis;
    });
    return (S, I) => {
      var T, x, k, C, O, E, B, M, R, F, L, j, H, te, re, le, ie;
      return p(), h("div", Kit, [
        a("table", Zit, [
          I[2] || (I[2] = a("thead", null, [
            a("tr", null, [
              a("th", null, "Investment Option"),
              a("th", { class: "text-center" }, "Investment Basis"),
              a("th", { class: "text-center" }, "Annualized Return"),
              a("th", { class: "text-center" }, "Wealth Accumulation"),
              a("th", { class: "text-center" }, "Net Gain"),
              a("th", { class: "cell-notes" }, "Notes")
            ])
          ], -1)),
          a("tbody", null, [
            a("tr", null, [
              I[0] || (I[0] = a("th", { class: "fw-normal" }, "Rental Investment", -1)),
              a("td", Jit, g(st(Ze)((T = w.value) == null ? void 0 : T.total, 0, "-")), 1),
              a("td", $it, g(st(Wt)(b.value)), 1),
              a("td", _it, g(st(Ze)(st(l))), 1),
              a("td", elt, g(st(Ze)(st(l) - ((x = w.value) == null ? void 0 : x.total))), 1),
              I[1] || (I[1] = a("td", { class: "border-start cell-notes" }, "Includes cash flow, appreciation, amortization.", -1))
            ]),
            a("tr", null, [
              a("th", tlt, g((k = m.value) == null ? void 0 : k.name), 1),
              a("td", slt, g(st(Ze)(st(o))), 1),
              a("td", alt, g(st(Wt)((C = m.value) == null ? void 0 : C.forwardLookingReturn, 1)), 1),
              a("td", nlt, g(st(Ze)(st(t).alternativeWealthAccumulation((O = m.value) == null ? void 0 : O.id), 0, "N/A")), 1),
              a("td", rlt, g(st(Ze)(st(t).alternativeWealthAccumulation((E = m.value) == null ? void 0 : E.id) - st(o), 0, "N/A")), 1),
              a("td", olt, g((B = m.value) == null ? void 0 : B.notes), 1)
            ]),
            a("tr", null, [
              a("th", ilt, g((M = f.value) == null ? void 0 : M.name), 1),
              a("td", llt, g(st(Ze)(st(o))), 1),
              a("td", dlt, g(st(Wt)((R = f.value) == null ? void 0 : R.forwardLookingReturn, 1)), 1),
              a("td", clt, g(st(Ze)(st(t).alternativeWealthAccumulation((F = f.value) == null ? void 0 : F.id), 0, "N/A")), 1),
              a("td", ult, g(st(Ze)(st(t).alternativeWealthAccumulation((L = f.value) == null ? void 0 : L.id) - st(o), 0, "N/A")), 1),
              a("td", plt, g((j = f.value) == null ? void 0 : j.notes), 1)
            ]),
            a("tr", null, [
              a("th", hlt, g((H = v.value) == null ? void 0 : H.name), 1),
              a("td", mlt, g(st(Ze)(st(o))), 1),
              a("td", flt, g(st(Wt)((te = v.value) == null ? void 0 : te.forwardLookingReturn, 1)), 1),
              a("td", glt, g(st(Ze)(st(t).alternativeWealthAccumulation((re = v.value) == null ? void 0 : re.id), 0, "N/A")), 1),
              a("td", vlt, g(st(Ze)(st(t).alternativeWealthAccumulation((le = v.value) == null ? void 0 : le.id) - st(o), 0, "N/A")), 1),
              a("td", ylt, g((ie = v.value) == null ? void 0 : ie.notes), 1)
            ])
          ])
        ])
      ]);
    };
  }
}), Alt = { class: "container" }, wlt = { class: "row g-3" }, Clt = { class: "col-lg-4 d-flex flex-column gap-3" }, Slt = { class: "col-lg-8" }, Plt = { class: "row d-flex gap-3" }, klt = { class: "col" }, Elt = { class: "card shadow-sm flex-fill" }, Ilt = { class: "card-body p-0" }, Tlt = { class: "col-12" }, Olt = { class: "card shadow-sm" }, Rlt = { class: "col-12" }, Llt = { class: "col-12" }, Blt = { class: "card shadow-sm" }, _ls = /* @__PURE__ */ me({
  name: "RentVsSellTab",
  __name: "RentVsSellTab",
  setup(e) {
    const t = Te(), { access: s, aclLoaded: n } = Mm(t);
    return (r, i) => (p(), h("div", Alt, [
      a("div", wlt, [
        a("div", Clt, [
          N(Yot),
          N(eit)
        ]),
        a("div", Slt, [
          a("div", Plt, [
            a("div", klt, [
              a("div", Elt, [
                i[0] || (i[0] = a("div", { class: "card-header bg-eclipse text-white rounded rounded-bottom-0 fw-bold text-center text-sm-start" }, " SUGGESTION FOR MAXIMUM WEALTH ACCUMULATION ", -1)),
                a("div", Ilt, [
                  N(Ait)
                ])
              ])
            ]),
            a("div", Tlt, [
              a("div", Olt, [
                i[1] || (i[1] = a("div", { class: "card-header bg-eclipse text-white rounded rounded-bottom-0 fw-bold text-center text-sm-start" }, " INVESTMENT ALTERNATIVE SELECTION ", -1)),
                N(Mit),
                i[2] || (i[2] = a("div", { class: "card-footer bg-white border-0 text-center" }, [
                  a("a", {
                    href: "/",
                    target: "_blank",
                    class: "btn btn-link btn-sm"
                  }, [
                    y("View our knowledgebase article about these comparisons and sources for historial financial performance. "),
                    a("i", { class: "fa-light fa-arrow-up-right-from-square ms-2" })
                  ])
                ], -1))
              ])
            ])
          ])
        ]),
        a("div", Rlt, [
          N(Qit)
        ]),
        a("div", Llt, [
          a("div", Blt, [
            i[3] || (i[3] = a("div", { class: "card-header bg-eclipse text-white rounded rounded-bottom-0 fw-bold text-center text-sm-start" }, " INVESTMENT OPTIONS COMPARISON TABLE ", -1)),
            N(blt)
          ])
        ])
      ])
    ]));
  }
}), hS = [
  De.Colors.Charts.Green,
  De.Colors.Charts.Red,
  De.Colors.Charts.Blue,
  De.Colors.Charts.Black,
  De.Colors.Charts.Softblue,
  De.Colors.Charts.Orange,
  De.Colors.Charts.Yellow,
  De.Colors.Charts.Purple,
  De.Colors.Charts.Grey1,
  De.Colors.Charts.Grey2,
  De.Colors.Charts.Grey3
], Mlt = me({
  name: "Map",
  props: {
    mapHeight: {
      type: Number,
      required: !1
    }
  },
  data() {
    return {
      //#region Map
      listingsMapOptions: void 0,
      center: void 0,
      currentZoom: 10
      //#endregion
    };
  },
  computed: {
    mapStyle() {
      return {
        height: (this.mapHeight ?? 0) > 400 ? `${this.mapHeight}px` : "400px"
      };
    },
    ...q(Te, ["acl", "aclLoaded"]),
    ...q(qe, ["property", "propertyInitialized", "hasSchools", "schoolInfo", "isMarketplace"]),
    ...at(qe)
  },
  methods: {
    number: Ve,
    getSchoolColor(e) {
      return hS[e % hS.length];
    },
    swatchStyle(e) {
      return {
        backgroundColor: this.getSchoolColor(e)
      };
    },
    async retrieveSchoolInfo(e) {
      var t;
      try {
        if (!this.propertyStore.propertyLoaded)
          return;
        await this.propertyStore.retrieveSchoolInfo(e);
        const s = new En();
        (t = this.schoolInfo) == null || t.forEach((n, r) => {
          const i = {
            title: n.name,
            position: {
              lat: n.lat,
              lng: n.lon
            },
            animation: google.maps.Animation.DROP,
            icon: {
              scaledSize: new google.maps.Size(48, 43),
              url: "/images/map/pin-school-elementary.png?v3"
            },
            map: this.map,
            visible: !0
          }, o = new google.maps.Marker(i);
          this.mapMarkers.set(n.nces_code, o);
          const l = s.parseGeoJsonGeometry(this.map, n.boundary, void 0, n.centerLat, n.centerLon, this.getSchoolColor(r));
          this.mapLegend.set(n.nces_code, l);
        });
      } catch (s) {
        Se(s);
      }
    },
    toggleLegend(e) {
      const t = this.mapMarkers.get(e.nces_code), s = this.mapLegend.get(e.nces_code);
      let n = !1;
      Array.isArray(s) == !0 ? s.forEach((r) => {
        n = r.getVisible(), r.setVisible(!n);
      }) : s && (n = s.getVisible(), s.setVisible(!n)), t && t.setVisible(!n);
    },
    //#region Map
    async mapInit() {
      var t, s, n, r, i, o;
      if (this.center = {
        lat: ((s = (t = this.property) == null ? void 0 : t.address) == null ? void 0 : s.latitude) ?? 30.173937,
        lng: ((r = (n = this.property) == null ? void 0 : n.address) == null ? void 0 : r.longitude) ?? -95.505836
      }, this.listingsMapOptions = {
        zoom: 12,
        //center: pLocation,
        restriction: {
          latLngBounds: De.Map.UsBounds
        },
        styles: De.Map.Styles.Default
      }, this.map = this.$refs.gMap.$mapObject, this.center) {
        const l = {
          title: (o = (i = this.property) == null ? void 0 : i.address) == null ? void 0 : o.address,
          position: this.center,
          animation: google.maps.Animation.DROP,
          icon: "/images/map/pin-active.png?v3",
          map: this.map
        };
        new google.maps.Marker(l);
      } else
        console.error("No geo location given for property!");
      const e = this.$refs.listingMapLegend;
      this.map.controls[google.maps.ControlPosition.RIGHT_TOP].push(e);
    }
    //#endregion
  },
  mounted() {
    console.log(`${this.$options.name}.mounted`), this.mapLegend = /* @__PURE__ */ new Map(), this.mapMarkers = /* @__PURE__ */ new Map(), this.aclLoaded.then(async () => await this.propertyInitialized).then(async () => await this.$gmapApiPromiseLazy()).then(async () => await this.mapInit()).then(async () => {
      var e, t;
      ((t = (e = this.acl) == null ? void 0 : e.properties) != null && t.schoolsRating || this.isMarketplace) && await this.retrieveSchoolInfo(!0);
    }).catch((e) => {
      Se(e);
    });
  }
}), xlt = {
  id: "legend",
  ref: "listingMapLegend",
  class: "position-absolute m-2 p-2 rounded shadow-sm"
}, Flt = ["onClick"];
function Vlt(e, t, s, n, r, i) {
  const o = pe("GMapMap");
  return p(), h("div", {
    id: "listingMa",
    class: "card shadow-sm overflow-hidden",
    style: rn(e.mapStyle)
  }, [
    N(o, {
      ref: "gMap",
      class: "h-100 w-100",
      "map-id": "2ddbbe0dd6bcf8f9",
      center: e.center,
      options: e.listingsMapOptions
    }, {
      default: ve(() => [
        V(a("div", xlt, [
          t[0] || (t[0] = a("h3", { class: "fs-6 fw-bold text-secondary" }, "SUMMARY", -1)),
          (p(!0), h(A, null, D(e.schoolInfo, (l, d) => (p(), h("div", {
            class: "legSchool",
            onClick: (c) => e.toggleLegend(l)
          }, [
            a("span", {
              class: "swatch",
              style: rn(e.swatchStyle(d))
            }, " ", 4),
            y(" " + g(l.name), 1)
          ], 8, Flt))), 256))
        ], 512), [
          [Us, e.hasSchools]
        ])
      ]),
      _: 1
    }, 8, ["center", "options"])
  ], 4);
}
const eds = /* @__PURE__ */ Ae(Mlt, [["render", Vlt]]), Dlt = me({
  name: "SchoolInformation",
  computed: {
    ...q(Te, ["access", "aclLoaded"]),
    ...q(qe, ["property", "propertyInitialized", "schoolLoading", "hasSchools", "elementary", "intermediate", "jrHigh", "high", "schoolInfo"])
  },
  methods: {
    number: Ve
  }
}), Nlt = {
  id: "schoolsTable",
  ref: "schoolsTable",
  class: "gap-3 d-flex flex-column"
}, jlt = {
  key: 0,
  class: "loading-school-card row"
}, Hlt = { class: "card shadow-sm" }, Ult = { class: "row g-0" }, zlt = { class: "col-md-8" }, Wlt = { class: "p-2" }, Glt = { class: "school-name text-truncate" }, Ylt = ["href"], Xlt = { class: "address-list text-truncate" }, qlt = { class: "col-md-4" }, Qlt = { class: "p-2 text-md-end d-flex justify-content-center align-items-center bg-black bg-opacity-10 rounded-end rounded-bottom-0 h-100" }, Klt = { class: "row g-0" }, Zlt = { class: "col-6 col-md p-2 border-bottom order-2" }, Jlt = { class: "fs-5 fw-bold" }, $lt = { class: "col-6 col-md p-2 border-start border-bottom order-3" }, _lt = { class: "fs-5 fw-bold text-capitalize" }, edt = { class: "col-6 col-md p-2 border-start border-bottom order-4" }, tdt = {
  key: 0,
  class: "fs-5 fw-bold"
}, sdt = { class: "col-6 col-md-4 p-2 border-start border-bottom order-5" }, adt = {
  key: 0,
  class: "fs-5 fw-bold"
}, ndt = { class: "col-6 p-2 border-start order-6" }, rdt = {
  key: 0,
  class: "fs-5 fw-bold"
}, odt = { class: "col-6 p-2 border-start order-7" }, idt = {
  key: 0,
  class: "fs-5 fw-bold"
}, ldt = {
  key: 2,
  class: "no-schools"
};
function ddt(e, t, s, n, r, i) {
  var o, l, d, c, u, m, f, v, b, w;
  return p(), h("div", Nlt, [
    ((l = (o = e.access) == null ? void 0 : o.properties) != null && l.schoolsRating || ((c = (d = e.property) == null ? void 0 : d.mlsSource) == null ? void 0 : c.isActiveMarketplaceListing) == !0) && e.schoolLoading ? (p(), h("div", jlt, t[0] || (t[0] = [
      a("div", { class: "col" }, [
        a("div", {
          class: "card shadow-sm bg-white",
          style: { height: "220px" }
        }, [
          a("div", { class: "loading-school d-flex justify-content-center flex-column align-items-center h-100" }, [
            a("span", {
              class: "spinner-border spinner-border-sm mb-2",
              role: "status",
              "aria-hidden": "false"
            }),
            y("Retrieving Schools ")
          ])
        ])
      ], -1)
    ]))) : P("", !0),
    ((m = (u = e.access) == null ? void 0 : u.properties) != null && m.schoolsRating || ((v = (f = e.property) == null ? void 0 : f.mlsSource) == null ? void 0 : v.isActiveMarketplaceListing) == !0) && e.hasSchools ? (p(!0), h(A, { key: 1 }, D(e.schoolInfo, (S) => (p(), h("div", Hlt, [
      a("div", {
        class: z("rounded-2 rounded-bottom-0 circle-rating-" + S.rating)
      }, [
        a("div", Ult, [
          a("div", zlt, [
            a("div", Wlt, [
              a("div", Glt, [
                a("a", {
                  href: S.overview_url,
                  class: "fs-5 fw-bold text-decoration-none",
                  target: "_blank"
                }, [
                  t[1] || (t[1] = a("i", { class: "fa-light fa-arrow-up-right-from-square me-2 fa-sm" }, null, -1)),
                  y(g(S.name), 1)
                ], 8, Ylt)
              ]),
              a("div", Xlt, [
                y(g(S.district_name) + " ", 1),
                t[2] || (t[2] = a("i", { class: "fa-solid fa-circle-small px-2 text-black-50 text-small" }, null, -1)),
                y(" " + g(S.street), 1)
              ])
            ])
          ]),
          a("div", qlt, [
            a("div", Qlt, [
              t[4] || (t[4] = a("div", {
                class: "text-small me-2 text-md-end d-none d-md-block",
                style: { "line-height": "17px" }
              }, [
                y(" GreatSchools"),
                a("br"),
                y("Rating ")
              ], -1)),
              a("div", {
                class: z("circle-rating circle-rating-small bg-white text-dark rating-" + S.rating)
              }, [
                y(g(S.rating) + " ", 1),
                t[3] || (t[3] = a("span", null, " /10", -1))
              ], 2)
            ])
          ])
        ])
      ], 2),
      a("div", Klt, [
        a("div", Zlt, [
          t[5] || (t[5] = a("small", { class: "text-dark-50" }, "GRADES", -1)),
          t[6] || (t[6] = a("br", null, null, -1)),
          a("span", Jlt, g(S.level), 1)
        ]),
        a("div", $lt, [
          t[7] || (t[7] = a("small", { class: "text-dark-50" }, "TYPE", -1)),
          t[8] || (t[8] = a("br", null, null, -1)),
          a("span", _lt, g(S.type), 1)
        ]),
        a("div", edt, [
          t[9] || (t[9] = a("small", { class: "text-dark-50" }, "STUDENTS", -1)),
          t[10] || (t[10] = a("br", null, null, -1)),
          S.census && S.census.enrollment ? (p(), h("span", tdt, g(e.number(S.census.enrollment.value)), 1)) : P("", !0)
        ]),
        a("div", sdt, [
          t[11] || (t[11] = a("small", { class: "text-dark-50" }, "STUDENTS PER TEACHER", -1)),
          t[12] || (t[12] = a("br", null, null, -1)),
          S.census && S.census.studentTeacherRatio ? (p(), h("span", adt, g(S.census.studentTeacherRatio.value), 1)) : P("", !0)
        ]),
        a("div", ndt, [
          t[13] || (t[13] = a("small", { class: "text-dark-50" }, "3+ YEAR TEACHERS", -1)),
          t[14] || (t[14] = a("br", null, null, -1)),
          S.census && S.census.percentageTeachers3PlusYearsExperience ? (p(), h("span", rdt, g(S.census.percentageTeachers3PlusYearsExperience.value) + "%", 1)) : P("", !0)
        ]),
        a("div", odt, [
          t[15] || (t[15] = a("small", { class: "text-dark-50" }, "REDUCED LUNCH", -1)),
          t[16] || (t[16] = a("br", null, null, -1)),
          S.census && S.census.percentFreeReducedLunch ? (p(), h("span", idt, g(S.census.percentFreeReducedLunch.value) + "%", 1)) : P("", !0)
        ])
      ])
    ]))), 256)) : P("", !0),
    (w = (b = e.access) == null ? void 0 : b.properties) != null && w.schoolsRating && !e.hasSchools && !e.schoolLoading ? (p(), h("div", ldt, t[17] || (t[17] = [
      a("div", {
        class: "card shadow-sm",
        style: { "min-height": "223px", overflow: "hidden" }
      }, [
        a("div", { class: "card-body d-flex justify-content-center align-items-center" }, [
          a("div", { class: "text-center" }, [
            a("i", {
              class: "fa-light fa-school fa-2x",
              "aria-hidden": "true"
            }),
            a("br"),
            a("b", null, "No Schools Information Found")
          ])
        ])
      ], -1)
    ]))) : P("", !0)
  ], 512);
}
const tds = /* @__PURE__ */ Ae(Dlt, [["render", ddt]]);
Rt.register(eI);
const Cr = "#DADADA", Wg = "#D0D0D0", cdt = me({
  name: "CommunityData",
  props: {
    communityLoading: {
      type: Boolean,
      required: !1,
      default: !0
    },
    isMarketplace: {
      type: Boolean,
      required: !1,
      default: !1
    }
  },
  emits: [
    "update:communityLoading"
  ],
  components: {},
  data() {
    return {
      _communityLoading: !0,
      communityData: void 0,
      chartsInit: !1,
      //#region ViewPort Observer
      inViewportOnce: !1,
      inViewportActive: !0,
      inViewportThreshold: [0, 1],
      inViewport: {
        // Public props
        now: void 0,
        // Is in viewport
        fully: void 0,
        // Is fully in viewport
        above: void 0,
        // Is partially or fully above the viewport
        below: void 0,
        // Is partially or fully below the viewport
        // Internal props
        listening: !1,
        maxThreshold: 1
      }
      //#endregion
    };
  },
  watch: {
    _communityLoading(e) {
      this.$emit("update:communityLoading", e);
    },
    async "inViewport.now"(e) {
      e && (this.initCharts(), await this.retrieveCommunityData());
    }
  },
  computed: {
    popPercentMale() {
      return this.communityData && this.communityData.population ? this.percent(this.communityData.population.male / (this.communityData.population.male + this.communityData.population.female), 0) : "-";
    },
    popPercentFemale() {
      return this.communityData && this.communityData.population ? this.percent(this.communityData.population.female / (this.communityData.population.male + this.communityData.population.female), 0) : "-";
    },
    popPercentOwnerOccupiedDwellings() {
      return this.communityData && this.communityData.ownerOccupiedDwellings ? this.percent(this.communityData.ownerOccupiedDwellings / (this.communityData.ownerOccupiedDwellings + this.communityData.renterOccupiedDwellings), 0) : "-";
    },
    popPercentSelerOccupiedDwellings() {
      return this.communityData && this.communityData.renterOccupiedDwellings ? this.percent(this.communityData.renterOccupiedDwellings / (this.communityData.ownerOccupiedDwellings + this.communityData.renterOccupiedDwellings), 0) : "-";
    },
    popPercentBlueCollar() {
      return this.communityData && this.communityData.blueCollarWorkers ? this.percent(this.communityData.blueCollarWorkers / (this.communityData.blueCollarWorkers + this.communityData.whiteCollarWorkers), 0) : "-";
    },
    popPercentWhiteCollar() {
      return this.communityData && this.communityData.whiteCollarWorkers ? this.percent(this.communityData.whiteCollarWorkers / (this.communityData.blueCollarWorkers + this.communityData.whiteCollarWorkers), 0) : "-";
    },
    hasAccess() {
      var e, t;
      return (((t = (e = this.acl) == null ? void 0 : e.properties) == null ? void 0 : t.communityData) == !0 || this.isMarketplace) && (this.isAdmin || this.isUser || this.isClient);
    },
    //#region ViewPort Observer
    /** Add the maxThreshold to the @inViewportThreshold prop so that the handler is fired for elements that are taller than the viewport */
    inViewportThresholdWithMax() {
      const e = typeof this.inViewportThreshold == "object" ? this.inViewportThreshold : [this.inViewportThreshold];
      return Array.from(e).includes(this.inViewport.maxThreshold) ? e : e.concat(this.inViewport.maxThreshold);
    },
    //#endregion
    ...q(Te, ["acl", "aclLoaded", "isClient", "isAdmin", "isUser"]),
    ...q(qe, ["property", "propertyInitialized"])
  },
  methods: {
    number: Ve,
    currency: Ze,
    percent: Wt,
    initCharts() {
      this.chartsInit || (this.chartsInit = !0, this.$refs.ageChart && (this.communityCharts.ageChartCtx = this.$refs.ageChart.getContext("2d"), this.communityCharts.ageChart = new Rt(this.communityCharts.ageChartCtx, {
        type: "bar",
        data: {
          datasets: [{
            data: [2153, 2266, 2511, 2604, 2258, 2283, 2694, 3028, 2796, 2290, 1827, 1527, 1357, 1239, 1147, 1024, 781, 691],
            backgroundColor: Cr,
            borderRadius: 15
          }],
          labels: [
            "0-4",
            "5-9",
            "10-14",
            "15-19",
            "20-24",
            "25-29",
            "30-34",
            "35-39",
            "40-44",
            "45-49",
            "50-54",
            "55-59",
            "60-64",
            "65-69",
            "70-74",
            "75-79",
            "80-84",
            "85+"
          ]
        },
        options: {
          indexAxis: "y",
          maintainAspectRatio: !1,
          animations: {
            x: {
              duration: 3e3,
              from: 0
            }
          },
          plugins: {
            legend: {
              display: !1
            }
          }
        }
      })), this.$refs.blueCollarChart && (this.communityCharts.blueCollarChartCtx = this.$refs.blueCollarChart.getContext("2d"), this.communityCharts.blueCollarChart = new Rt(this.communityCharts.blueCollarChartCtx, {
        type: "doughnut",
        data: {
          datasets: [{
            data: [50, 50],
            backgroundColor: [
              Cr,
              Wg
            ]
          }],
          labels: [
            "Blue Collar",
            "White Collar"
          ]
        },
        options: {
          maintainAspectRatio: !1,
          plugins: {
            legend: {
              display: !0,
              position: "bottom",
              align: "center",
              reverse: !0
            }
          },
          cutout: "80%"
        }
      })), this.$refs.ethnicityChart && (this.communityCharts.ethnicityChartCtx = this.$refs.ethnicityChart.getContext("2d"), this.communityCharts.ethnicityChart = new Rt(this.communityCharts.ethnicityChartCtx, {
        type: "bar",
        data: {
          datasets: [{
            data: [57, 1125, 3443, 11, 4647, 3994, 4847, 3858, 309],
            backgroundColor: Cr,
            borderRadius: 15
          }],
          labels: [
            "American Indian",
            "Asian",
            "Black",
            "Hawaiian",
            "Hispanic",
            "Non-Hispanic",
            "Multi",
            "White",
            "Other"
          ]
        },
        options: {
          indexAxis: "y",
          maintainAspectRatio: !1,
          animations: {
            x: {
              duration: 3e3,
              from: 0
            }
          },
          plugins: {
            legend: {
              display: !1
            }
          }
        }
      })), this.$refs.timeToWorkChart && (this.communityCharts.timeToWorkChartCtx = this.$refs.timeToWorkChart.getContext("2d"), this.communityCharts.timeToWorkChart = new Rt(this.communityCharts.timeToWorkChartCtx, {
        type: "pie",
        data: {
          datasets: [{
            data: [30113, 134355, 225869, 262145, 358370, 447555, 219533, 262118],
            backgroundColor: [
              "rgba(89, 89, 89, 1)",
              "rgba(89, 89, 89, 0.9)",
              "rgba(89, 89, 89, 0.8)",
              "rgba(89, 89, 89, 0.7)",
              "rgba(89, 89, 89, 0.6)",
              "rgba(89, 89, 89, 0.5)",
              "rgba(89, 89, 89, 0.4)",
              "rgba(89, 89, 89, 0.3)"
            ]
          }],
          labels: [
            "Less than 5 min",
            "5 to 10 min",
            "10 to 15 min",
            "15 to 20 min",
            "20 to 30 min",
            "30 to 45 min",
            "45 to 60 min",
            "Grater than 60 min"
          ]
        },
        options: {
          maintainAspectRatio: !1,
          plugins: {
            legend: {
              display: !0,
              position: "left"
            }
          }
        }
      })), this.$refs.ownerDwellingsChart && (this.communityCharts.ownerDwellingsChartCtx = this.$refs.ownerDwellingsChart.getContext("2d"), this.communityCharts.ownerDwellingsChart = new Rt(this.communityCharts.ownerDwellingsChartCtx, {
        type: "doughnut",
        data: {
          datasets: [{
            data: [500, 500],
            backgroundColor: [
              Cr,
              Wg
            ]
          }],
          labels: [
            "Owner",
            "Renter"
          ]
        },
        options: {
          maintainAspectRatio: !1,
          plugins: {
            legend: {
              display: !0,
              position: "bottom",
              align: "center",
              reverse: !0
            }
          },
          cutout: "80%"
        }
      })), this.$refs.populationChart && (this.communityCharts.populationChartCtx = this.$refs.populationChart.getContext("2d"), this.communityCharts.populationChart = new Rt(this.communityCharts.populationChartCtx, {
        type: "doughnut",
        data: {
          datasets: [{
            data: [17462, 18537],
            backgroundColor: [
              Cr,
              Wg
            ]
          }],
          labels: [
            "Male",
            "Female"
          ]
        },
        options: {
          maintainAspectRatio: !1,
          plugins: {
            legend: {
              display: !0,
              position: "bottom",
              align: "center",
              reverse: !0
            }
          },
          cutout: "80%"
        }
      })), this.$refs.householdIncomeChart && (this.communityCharts.householdIncomeChartCtx = this.$refs.householdIncomeChart.getContext("2d"), this.communityCharts.householdIncomeChart = new Rt(this.communityCharts.householdIncomeChartCtx, {
        type: "bar",
        data: {
          datasets: [{
            data: [2375, 1469, 1630, 1459, 1576, 1705, 1705, 1174, 207, 42, 15, 1],
            backgroundColor: Cr,
            borderRadius: 15
          }],
          labels: [
            "$0-$20,000",
            "$20,001-$30,000",
            "$30,001-$40,000",
            "$40,001-$50,000",
            "$50,001-$60,000",
            "$60,001-$75,000",
            "$75,001-$100,000",
            "$100,001-$150,000",
            "$150,001-$200,000",
            "$200,001-$250,000",
            "$250,001-$500,000",
            "$500,001+"
          ]
        },
        options: {
          indexAxis: "y",
          maintainAspectRatio: !1,
          animations: {
            x: {
              duration: 3e3,
              from: 0
            }
          },
          plugins: {
            legend: {
              display: !1
            }
          }
        }
      })), this.$refs.educationChart && (this.communityCharts.educationChartCtx = this.$refs.educationChart.getContext("2d"), this.communityCharts.educationChart = new Rt(this.communityCharts.educationChartCtx, {
        type: "bar",
        data: {
          datasets: [{
            data: [3116, 2325, 8395, 4977, 2048, 2105, 2315, 772],
            backgroundColor: Cr,
            borderRadius: 15
          }],
          labels: [
            "Less than 9th Grade",
            "Some High School",
            "High School Graduate",
            "Some College",
            "Associate Degree",
            "Bachelor's Degree",
            "Graduate Degree"
          ]
        },
        options: {
          maintainAspectRatio: !1,
          plugins: {
            legend: {
              display: !1
            }
          }
        }
      })), this.$refs.transportationToWorkChart && (this.communityCharts.transportationToWorkChartCtx = this.$refs.transportationToWorkChart.getContext("2d"), this.communityCharts.transportationToWorkChart = new Rt(this.communityCharts.transportationToWorkChartCtx, {
        type: "bar",
        data: {
          datasets: [{
            data: [95, 1262, 4910, 50, 600, 700, 38, 720],
            backgroundColor: Cr,
            borderRadius: 15
          }],
          labels: [
            "Bicycle",
            "Carpool",
            "Solo Divers",
            "Work at Home",
            "Motorcycle",
            "Public Transportation",
            "Walk",
            "Other Means"
          ]
        },
        options: {
          indexAxis: "y",
          maintainAspectRatio: !1,
          animations: {
            y: {
              duration: 3e3,
              from: 0
            }
          },
          plugins: {
            legend: {
              display: !1
            }
          }
        }
      })), this.$refs.employeeChart && (this.communityCharts.employeeChartCtx = this.$refs.employeeChart.getContext("2d"), this.communityCharts.employeeChart = new Rt(this.communityCharts.employeeChartCtx, {
        type: "bar",
        data: {
          datasets: [{
            data: [542, 0, 22, 87, 0, 2038, 4043, 1142, 0, 2801, 0, 0, 0, 0, 0, 0, 85, 0, 0, 3544, 0, 1069, 0],
            backgroundColor: Cr,
            borderRadius: 15
          }],
          // These labels appear in the legend and in the tooltips when hovering different arcs
          labels: [
            "Arts, design, etc.",
            "Business",
            "Building maintenance",
            "Admin Support",
            "Computer and mathematical science",
            "Construction",
            "Social Services",
            "Education",
            "Architecture and Engineering",
            "Food and Service",
            "Healthcare Support",
            "Healhtcare Practitioners",
            "Maintenance & Repair",
            "Legal Occupations",
            "Military",
            "Personal Care & Service",
            "Farming, Forestry, and Fishing",
            "Production",
            "Protective Services",
            "Sales Professionals",
            "Life, physical, and social science",
            "Transportation",
            "Executives, Managers, Administrators"
          ]
        },
        options: {
          indexAxis: "y",
          maintainAspectRatio: !1,
          animations: {
            y: {
              duration: 3e3,
              from: 0
            }
          },
          plugins: {
            legend: {
              display: !1
            }
          }
        }
      })), this.$refs.hoseholdExpendituresChart && (this.communityCharts.hoseholdExpendituresChartCtx = this.$refs.hoseholdExpendituresChart.getContext("2d"), this.communityCharts.hoseholdExpendituresChart = new Rt(this.communityCharts.hoseholdExpendituresChartCtx, {
        type: "bar",
        data: {
          datasets: [{
            data: [92, 94, 90, 92, 92, 93, 93, 97, 93, 93, 93, 94, 92, 92, 94, 92, 91],
            backgroundColor: Cr,
            borderRadius: 15
          }],
          labels: [
            "Apparel",
            "Charitable Contribution",
            "Education",
            "Entertainment",
            "Food and Beverages",
            "Gifts",
            "Health Care",
            "Shelter",
            "Household Furnishes and Equipment",
            "Household Operations",
            "Personal Insurance",
            "Miscellaneous Expenses",
            "Personal Care",
            "Reading",
            "Tobacco",
            "Transportation",
            "Utilities"
          ]
        },
        options: {
          indexAxis: "y",
          maintainAspectRatio: !1,
          animations: {
            y: {
              duration: 3e3,
              from: 0
            }
          },
          plugins: {
            legend: {
              display: !1
            }
          }
        }
      })));
    },
    async retrieveCommunityData() {
      var e, t;
      try {
        if (await this.propertyInitialized, (t = (e = this.property) == null ? void 0 : e.address) != null && t.zip && this.hasAccess) {
          if (this._communityLoading = !0, !this.communityData) {
            const s = await W.api.community.zip(this.property.address.zip);
            this.communityData = s.data.data;
          }
          this.communityCharts.ageChart.data.datasets[0].backgroundColor = "rgba(33, 183, 168, 1)", this.communityCharts.ageChart.data.datasets[0].data = [
            this.communityData.ages.age00_04 ?? 0,
            this.communityData.ages.age05_09 ?? 0,
            this.communityData.ages.age10_14 ?? 0,
            this.communityData.ages.age15_19 ?? 0,
            this.communityData.ages.age20_24 ?? 0,
            this.communityData.ages.age25_29 ?? 0,
            this.communityData.ages.age30_34 ?? 0,
            this.communityData.ages.age35_39 ?? 0,
            this.communityData.ages.age40_44 ?? 0,
            this.communityData.ages.age45_49 ?? 0,
            this.communityData.ages.age50_54 ?? 0,
            this.communityData.ages.age55_59 ?? 0,
            this.communityData.ages.age60_64 ?? 0,
            this.communityData.ages.age65_69 ?? 0,
            this.communityData.ages.age70_74 ?? 0,
            this.communityData.ages.age75_79 ?? 0,
            this.communityData.ages.age80_84 ?? 0,
            this.communityData.ages.age85plus ?? 0
          ], this.communityCharts.ageChart.update(), this.communityCharts.blueCollarChart.data.datasets[0].data = [
            this.communityData.blueCollarWorkers,
            this.communityData.whiteCollarWorkers
          ], this.communityCharts.blueCollarChart.data.datasets[0].backgroundColor = [
            "rgba(242,110,52, 1)",
            "rgba(33, 183, 168, 1)"
          ], this.communityCharts.blueCollarChart.update(), this.communityCharts.timeToWorkChart.data.datasets[0].backgroundColor = [
            "rgba(33, 183, 168, 1.0)",
            "rgba(33, 183, 168, 0.9)",
            "rgba(33, 183, 168, 0.8)",
            "rgba(33, 183, 168, 0.7)",
            "rgba(33, 183, 168, 0.6)",
            "rgba(33, 183, 168, 0.5)",
            "rgba(33, 183, 168, 0.4)",
            "rgba(33, 183, 168, 0.3)"
          ], this.communityCharts.timeToWorkChart.data.datasets[0].data = [
            this.communityData.travel.toWork0_5 ?? 0,
            this.communityData.travel.toWork5_10 ?? 0,
            this.communityData.travel.toWork10_15 ?? 0,
            this.communityData.travel.toWork15_20 ?? 0,
            this.communityData.travel.toWork20_30 ?? 0,
            this.communityData.travel.toWork30_45 ?? 0,
            this.communityData.travel.toWork45_60 ?? 0,
            this.communityData.travel.toWork60plus ?? 0
          ], this.communityCharts.timeToWorkChart.update(), this.communityCharts.ownerDwellingsChart.data.datasets[0].data = [
            this.communityData.occupied.owner ?? 0,
            this.communityData.occupied.renter ?? 0
          ], this.communityCharts.ownerDwellingsChart.data.datasets[0].backgroundColor = [
            "rgba(242,110,52, 1)",
            "rgba(33, 183, 168, 1)"
          ], this.communityCharts.ownerDwellingsChart.update(), this.communityCharts.populationChart.data.datasets[0].data = [
            this.communityData.population.male ?? 0,
            this.communityData.population.female ?? 0
          ], this.communityCharts.populationChart.data.datasets[0].backgroundColor = [
            "rgba(242,110,52, 1)",
            "rgba(33, 183, 168, 1)"
          ], this.communityCharts.populationChart.update(), this.communityCharts.householdIncomeChart.data.datasets[0].backgroundColor = "rgba(242,110,52, 1)", this.communityCharts.householdIncomeChart.data.datasets[0].data = [
            this.communityData.householdIncome.income00_20 ?? 0,
            this.communityData.householdIncome.income20_30 ?? 0,
            this.communityData.householdIncome.income30_40 ?? 0,
            this.communityData.householdIncome.income40_50 ?? 0,
            this.communityData.householdIncome.income50_60 ?? 0,
            this.communityData.householdIncome.income60_75 ?? 0,
            this.communityData.householdIncome.income75_100 ?? 0,
            this.communityData.householdIncome.income100_150 ?? 0,
            this.communityData.householdIncome.income150_200 ?? 0,
            this.communityData.householdIncome.income200_250 ?? 0,
            this.communityData.householdIncome.income250_500 ?? 0,
            this.communityData.householdIncome.income500plus ?? 0
          ], this.communityCharts.householdIncomeChart.update(), this.communityCharts.educationChart.data.datasets[0].backgroundColor = "rgba(242,110,52, 1)", this.communityCharts.educationChart.data.datasets[0].data = [
            this.communityData.education.lessThanGrade9 ?? 0,
            this.communityData.education.someHighSchool ?? 0,
            this.communityData.education.highSchool ?? 0,
            this.communityData.education.someCollege ?? 0,
            this.communityData.education.associateDegree ?? 0,
            this.communityData.education.bachelorsDegree ?? 0,
            this.communityData.education.graduateDegree ?? 0
          ], this.communityCharts.educationChart.update(), this.communityCharts.transportationToWorkChart.data.datasets[0].backgroundColor = "rgba(33, 183, 168, 1)", this.communityCharts.transportationToWorkChart.data.datasets[0].data = [
            this.communityData.travel.byBicycle ?? 0,
            this.communityData.travel.byCarpool ?? 0,
            this.communityData.travel.bySoloDrivers ?? 0,
            this.communityData.travel.byWorkAtHome ?? 0,
            this.communityData.travel.byMotorcycle ?? 0,
            this.communityData.travel.byPublic ?? 0,
            this.communityData.travel.byWalk ?? 0,
            this.communityData.travel.byOtherMeans ?? 0
          ], this.communityCharts.transportationToWorkChart.update(), this.communityCharts.employeeChart.data.datasets[0].backgroundColor = "rgba(242,110,52, 1)", this.communityCharts.employeeChart.data.datasets[0].data = [
            this.communityData.occupation.arts ?? 0,
            this.communityData.occupation.business ?? 0,
            this.communityData.occupation.buildingMaintenance ?? 0,
            this.communityData.occupation.adminSupport ?? 0,
            this.communityData.occupation.computerScience ?? 0,
            this.communityData.occupation.construction ?? 0,
            this.communityData.occupation.socialServices ?? 0,
            this.communityData.occupation.education ?? 0,
            this.communityData.occupation.engineering ?? 0,
            this.communityData.occupation.foodService ?? 0,
            this.communityData.occupation.healthcareSupport ?? 0,
            this.communityData.occupation.healhtcarePractitioners ?? 0,
            this.communityData.occupation.maintenanceRepair ?? 0,
            this.communityData.occupation.legal ?? 0,
            this.communityData.occupation.military ?? 0,
            this.communityData.occupation.personalCare ?? 0,
            this.communityData.occupation.farming ?? 0,
            this.communityData.occupation.production ?? 0,
            this.communityData.occupation.protectiveServices ?? 0,
            this.communityData.occupation.salesProfessionals ?? 0,
            this.communityData.occupation.lifeScience ?? 0,
            this.communityData.occupation.transportation ?? 0,
            this.communityData.occupation.executives ?? 0
          ], this.communityCharts.employeeChart.update(), this.communityCharts.hoseholdExpendituresChart.data.datasets[0].backgroundColor = "rgba(242,110,52, 1)", this.communityCharts.hoseholdExpendituresChart.data.datasets[0].data = [
            this.communityData.expenditure.apparel ?? 0,
            this.communityData.expenditure.charitable ?? 0,
            this.communityData.expenditure.education ?? 0,
            this.communityData.expenditure.entertainment ?? 0,
            this.communityData.expenditure.food ?? 0,
            this.communityData.expenditure.gifts ?? 0,
            this.communityData.expenditure.healthCare ?? 0,
            this.communityData.expenditure.shelter ?? 0,
            this.communityData.expenditure.householdFurnishes ?? 0,
            this.communityData.expenditure.householdOperations ?? 0,
            this.communityData.expenditure.personalInsurance ?? 0,
            this.communityData.expenditure.miscellaneous ?? 0,
            this.communityData.expenditure.personalCare ?? 0,
            this.communityData.expenditure.reading ?? 0,
            this.communityData.expenditure.tobacco ?? 0,
            this.communityData.expenditure.transportation ?? 0,
            this.communityData.expenditure.utilities ?? 0
          ], this.communityCharts.hoseholdExpendituresChart.update();
        }
        this._communityLoading = !1;
      } catch (s) {
        console.error(`${this.$options.name}.retrieveCommunityData`, s), this._communityLoading = !1;
      }
    },
    //#region ViewPort Observer
    // https://github.com/BKWLD/vue-in-viewport-mixin
    // TODO: Migrate ViewPort Observer to plugin or mixin
    /** Re-init */
    reInitInViewportMixin() {
      return this.removeInViewportHandlers(), this.inViewportInit();
    },
    /** Instantiate */
    inViewportInit() {
      if (this.inViewportActive)
        return this.addInViewportHandlers();
    },
    /** Add listeners */
    addInViewportHandlers() {
      if (!this.inViewport.listening)
        return this.inViewport.listening = !0, this.inViewportObserver = new IntersectionObserver(this.updateInViewport, {
          root: void 0,
          rootMargin: this.inViewportRootMargin,
          threshold: this.inViewportThresholdWithMax
        }), this.inViewportObserver.observe(this.$el);
    },
    /** Remove listeners */
    removeInViewportHandlers() {
      this.inViewport.listening && (this.inViewport.listening = !1, this.inViewportObserver && this.inViewportObserver.disconnect(), this.inViewportObserver && delete this.inViewportObserver);
    },
    /** Handle state changes.  There should only ever be one entry and we're destructuring the properties we care about since they have long names. */
    updateInViewport(e, t) {
      const s = e[0].boundingClientRect, n = e[0].rootBounds;
      if (!s || !n)
        return this.removeInViewportHandlers();
      if (this.inViewport.maxThreshold = s.height > 0 ? Math.min(1, n.height / s.height) : 1, this.inViewport.now = s.top <= n.bottom && s.bottom > n.top, this.inViewport.above = s.top < n.top, this.inViewport.below = s.bottom > n.bottom + 1, this.inViewport.fully = s.height > n.height ? s.top <= n.top && s.bottom >= n.bottom + 1 : !this.inViewport.above && !this.inViewport.below, this.inViewportOnce && this.inViewport.now)
        return this.removeInViewportHandlers();
    }
    //#endregion
  },
  created() {
    this.communityCharts = {};
  },
  mounted() {
    this.aclLoaded.then(() => {
      this._communityLoading = !1, this.$nextTick(() => this.inViewportInit());
    });
  },
  unmounted() {
    return this.removeInViewportHandlers();
  }
}), udt = "data:image/jpeg;base64,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", pdt = { class: "container-xl" }, hdt = { class: "row mb-3" }, mdt = {
  key: 0,
  class: "col text-end"
}, fdt = {
  key: 0,
  class: "card card-locked shadow-sm bg-gradient-periwinkle p-4 p-lg-5"
}, gdt = {
  key: 1,
  class: "row g-3"
}, vdt = { class: "col-md-6 col-lg-3 col-xl-4" }, ydt = { class: "card shadow-sm" }, bdt = { class: "card-body" }, Adt = { class: "row" }, wdt = { class: "graph col" }, Cdt = { class: "position-relative" }, Sdt = { class: "graph-inside position-absolute text-center" }, Pdt = { class: "graph-inside_numbers" }, kdt = {
  class: "chart-container",
  style: { position: "relative", height: "300px", width: "100%" }
}, Edt = {
  ref: "ownerDwellingsChart",
  "data-id": "ownerDwellingsChart",
  class: "ownerDwellingsChart",
  id: "ownerDwellingsChart"
}, Idt = { class: "col-md-6 col-lg-3 col-xl-4" }, Tdt = { class: "card shadow-sm" }, Odt = { class: "card-body" }, Rdt = { class: "row" }, Ldt = { class: "graph col" }, Bdt = { class: "position-relative" }, Mdt = { class: "graph-inside position-absolute text-center" }, xdt = { class: "graph-inside_numbers" }, Fdt = {
  class: "chart-container",
  style: { position: "relative", height: "300px", width: "100%" }
}, Vdt = {
  ref: "blueCollarChart",
  "data-id": "blueCollarChart",
  class: "blueCollarChart",
  id: "blueCollarChart"
}, Ddt = { class: "col-md-12 col-lg-6 col-xl-4" }, Ndt = { class: "card shadow-sm" }, jdt = { class: "graph card-body" }, Hdt = {
  class: "chart-container",
  style: { position: "relative", height: "325px", width: "100%" }
}, Udt = {
  ref: "householdIncomeChart",
  class: "householdIncomeChart"
}, zdt = { class: "col-md-6 col-lg-9 col-xl-8" }, Wdt = { class: "card shadow-sm" }, Gdt = { class: "graph card-body" }, Ydt = {
  class: "chart-container",
  style: { position: "relative", height: "300px", width: "100%" }
}, Xdt = {
  class: "educationChart",
  ref: "educationChart"
}, qdt = { class: "col-md-6 col-lg-3 col-xl-4" }, Qdt = { class: "card shadow-sm" }, Kdt = { class: "card-body" }, Zdt = { class: "row" }, Jdt = { class: "graph col" }, $dt = { class: "position-relative" }, _dt = { class: "graph-inside position-absolute text-center" }, ect = { class: "graph-inside_numbers" }, tct = {
  class: "chart-container",
  style: { position: "relative", height: "300px", width: "100%" }
}, sct = {
  ref: "populationChart",
  class: "femaleChart"
}, act = { class: "col-md-6" }, nct = { class: "card shadow-sm" }, rct = { class: "graph card-body" }, oct = {
  class: "chart-container",
  style: { position: "relative", height: "380px", width: "100%" }
}, ict = {
  class: "timeToWorkChart",
  ref: "timeToWorkChart"
}, lct = { class: "col-md-6" }, dct = { class: "card shadow-sm" }, cct = { class: "graph card-body" }, uct = {
  class: "chart-container",
  style: { position: "relative", height: "380px", width: "100%" }
}, pct = {
  class: "transportationToWorkChart",
  ref: "transportationToWorkChart"
}, hct = { class: "col-12" }, mct = { class: "card shadow-sm" }, fct = { class: "graph card-body" }, gct = {
  class: "chart-container",
  style: { position: "relative", height: "715px", width: "100%" }
}, vct = {
  class: "hoseholdExpendituresChart",
  ref: "hoseholdExpendituresChart"
}, yct = { class: "col-sm-6 col-lg-5" }, bct = { class: "card shadow-sm" }, Act = { class: "graph card-body" }, wct = {
  class: "chart-container",
  style: { position: "relative", height: "530px", width: "100%" }
}, Cct = {
  ref: "ageChart",
  "data-id": "ageChart",
  class: "ageChart",
  id: "ageChart"
}, Sct = { class: "col-sm-6 col-lg-7" }, Pct = { class: "card shadow-sm" }, kct = { class: "graph card-body" }, Ect = {
  class: "chart-container",
  style: { position: "relative", height: "900px", width: "100%" }
}, Ict = {
  class: "employeeChart",
  ref: "employeeChart"
}, Tct = {
  key: 2,
  class: "row d-none"
}, Oct = { class: "col" }, Rct = { class: "card shadow-sm mb-4 mb-md-0 d-flex justify-content-center align-items-center" }, Lct = { class: "table m-0" }, Bct = { class: "text-end" }, Mct = { class: "text-end" }, xct = { class: "text-end" }, Fct = { class: "text-end" }, Vct = { class: "text-end" }, Dct = { class: "text-end" }, Nct = { class: "text-end" }, jct = { class: "col" }, Hct = { class: "card shadow-sm d-flex justify-content-center align-items-center" }, Uct = { class: "table m-0" }, zct = { class: "text-end" }, Wct = { class: "text-end" }, Gct = { class: "text-end" }, Yct = { class: "text-end" }, Xct = { class: "text-end" }, qct = { class: "text-end" }, Qct = { class: "text-end" };
function Kct(e, t, s, n, r, i) {
  return p(), h("div", pdt, [
    a("div", hdt, [
      t[1] || (t[1] = a("div", { class: "col" }, [
        a("h2", { class: "fw-bold fs-5" }, "Community Data")
      ], -1)),
      e.communityData ? (p(), h("div", mdt, [
        t[0] || (t[0] = a("b", null, "Demographic Area:", -1)),
        y(" " + g(e.communityData.location) + " " + g(e.communityData.locationType), 1)
      ])) : P("", !0)
    ]),
    e.hasAccess ? (p(), h("div", gdt, [
      a("div", vdt, [
        a("div", ydt, [
          t[7] || (t[7] = a("div", { class: "card-header bg-white border-0 fw-bold pb-0 text-uppercase" }, [
            y(" Owner vs Renter"),
            a("br"),
            y("Occupied Dwellings ")
          ], -1)),
          a("div", bdt, [
            a("div", Adt, [
              a("div", wdt, [
                a("div", Cdt, [
                  a("div", Sdt, [
                    t[6] || (t[6] = a("div", { class: "mb-2" }, [
                      a("i", { class: "fa-light fa-house-user fa-3x" })
                    ], -1)),
                    a("span", Pdt, [
                      t[3] || (t[3] = a("i", { class: "fa-solid fa-circle me-1 dot-small dot-accent-glass" }, null, -1)),
                      y(" " + g(e.popPercentSelerOccupiedDwellings), 1),
                      t[4] || (t[4] = a("span", { class: "mx-2" }, "|", -1)),
                      t[5] || (t[5] = a("i", { class: "fa-solid fa-circle me-1 dot-small dot-lava" }, null, -1)),
                      y(" " + g(e.popPercentOwnerOccupiedDwellings), 1)
                    ])
                  ]),
                  a("div", kdt, [
                    a("canvas", Edt, null, 512)
                  ])
                ])
              ])
            ])
          ])
        ])
      ]),
      a("div", Idt, [
        a("div", Tdt, [
          t[12] || (t[12] = a("div", { class: "card-header bg-white border-0 fw-bold pb-0 text-uppercase" }, [
            y(" blue vs white"),
            a("br"),
            y("collar Jobs ")
          ], -1)),
          a("div", Odt, [
            a("div", Rdt, [
              a("div", Ldt, [
                a("div", Bdt, [
                  a("div", Mdt, [
                    t[11] || (t[11] = a("div", { class: "mb-2" }, [
                      a("i", { class: "fa-light fa-user-hard-hat fa-3x" })
                    ], -1)),
                    a("span", xdt, [
                      t[8] || (t[8] = a("i", { class: "fa-solid fa-circle me-1 dot-small dot-accent-glass" }, null, -1)),
                      y(" " + g(e.popPercentWhiteCollar), 1),
                      t[9] || (t[9] = a("span", { class: "mx-2" }, "|", -1)),
                      t[10] || (t[10] = a("i", { class: "fa-solid fa-circle me-1 dot-small dot-lava" }, null, -1)),
                      y(" " + g(e.popPercentBlueCollar), 1)
                    ])
                  ]),
                  a("div", Fdt, [
                    a("canvas", Vdt, null, 512)
                  ])
                ])
              ])
            ])
          ])
        ])
      ]),
      a("div", Ddt, [
        a("div", Ndt, [
          t[13] || (t[13] = a("div", { class: "card-header bg-white border-0 fw-bold pb-0 text-uppercase" }, "household income", -1)),
          a("div", jdt, [
            a("div", Hdt, [
              a("canvas", Udt, null, 512)
            ])
          ])
        ])
      ]),
      a("div", zdt, [
        a("div", Wdt, [
          t[14] || (t[14] = a("div", { class: "card-header bg-white border-0 fw-bold pb-0 text-uppercase" }, "education", -1)),
          a("div", Gdt, [
            a("div", Ydt, [
              a("canvas", Xdt, null, 512)
            ])
          ])
        ])
      ]),
      a("div", qdt, [
        a("div", Qdt, [
          t[19] || (t[19] = a("div", { class: "card-header bg-white border-0 fw-bold pb-0 text-uppercase" }, "Population", -1)),
          a("div", Kdt, [
            a("div", Zdt, [
              a("div", Jdt, [
                a("div", $dt, [
                  a("div", _dt, [
                    t[18] || (t[18] = a("div", { class: "mb-2" }, [
                      a("i", { class: "fa-light fa-female fa-3x me-2" }),
                      a("i", { class: "fa-light fa-male fa-3x" })
                    ], -1)),
                    a("span", ect, [
                      t[15] || (t[15] = a("i", { class: "fa-solid fa-circle me-1 dot-small dot-accent-glass" }, null, -1)),
                      y(" " + g(e.popPercentFemale) + " ", 1),
                      t[16] || (t[16] = a("span", { class: "mx-2" }, "|", -1)),
                      t[17] || (t[17] = a("i", { class: "fa-solid fa-circle me-1 dot-small dot-lava" }, null, -1)),
                      y(" " + g(e.popPercentMale), 1)
                    ])
                  ]),
                  a("div", tct, [
                    a("canvas", sct, null, 512)
                  ])
                ])
              ])
            ])
          ])
        ])
      ]),
      a("div", act, [
        a("div", nct, [
          t[20] || (t[20] = a("div", { class: "card-header bg-white border-0 fw-bold pb-0 text-uppercase" }, "travel time to work", -1)),
          a("div", rct, [
            a("div", oct, [
              a("canvas", ict, null, 512)
            ])
          ])
        ])
      ]),
      a("div", lct, [
        a("div", dct, [
          t[21] || (t[21] = a("div", { class: "card-header bg-white border-0 fw-bold pb-0 text-uppercase" }, "type of transportation to work", -1)),
          a("div", cct, [
            a("div", uct, [
              a("canvas", pct, null, 512)
            ])
          ])
        ])
      ]),
      a("div", hct, [
        a("div", mct, [
          t[22] || (t[22] = a("div", { class: "card-header bg-white border-0 fw-bold pb-0 text-uppercase" }, "Household expenditures", -1)),
          a("div", fct, [
            a("div", gct, [
              a("canvas", vct, null, 512)
            ])
          ])
        ])
      ]),
      a("div", yct, [
        a("div", bct, [
          t[23] || (t[23] = a("div", { class: "card-header bg-white border-0 fw-bold pb-0 text-uppercase" }, "age", -1)),
          a("div", Act, [
            a("div", wct, [
              a("canvas", Cct, null, 512)
            ])
          ])
        ])
      ]),
      a("div", Sct, [
        a("div", Pct, [
          t[24] || (t[24] = a("div", { class: "card-header bg-white border-0 fw-bold pb-0 text-uppercase" }, "employee count", -1)),
          a("div", kct, [
            a("div", Ect, [
              a("canvas", Ict, null, 512)
            ])
          ])
        ])
      ])
    ])) : (p(), h("div", fdt, t[2] || (t[2] = [
      Bt('<div class="row"><div class="col-md-5"><img class="img-fluid" src="' + udt + '" alt="Own vs rent dwellings" title="Own vs rent dwellings" height="452" width="586" loading="lazy"></div><div class="col-md-7 text-center text-lg-start d-flex align-items-center align-items-lg-start justify-content-center flex-column"><p class="fw-bold fs-5"> View neighborhood demographics and<br class="d-none d-xl-block"> community data with an account! </p><a href="/signup" class="btn btn-eclipse">Activate Community Data!</a><br><br><a href="/features/community"> Learn more about community data <i class="fa-light fa-angle-right ms-2"></i></a></div></div>', 1)
    ]))),
    e.communityData ? (p(), h("div", Tct, [
      a("div", Oct, [
        a("div", Rct, [
          a("table", Lct, [
            a("tbody", null, [
              a("tr", null, [
                t[25] || (t[25] = a("td", { class: "text-center" }, [
                  a("i", { class: "fa-light fa-users" })
                ], -1)),
                t[26] || (t[26] = a("th", null, " Population: ", -1)),
                a("td", Bct, g(e.number(e.communityData.population)), 1)
              ]),
              a("tr", null, [
                t[27] || (t[27] = a("td", { class: "text-center" }, [
                  a("i", { class: "fa-light fa-users" })
                ], -1)),
                t[28] || (t[28] = a("th", null, " Population Growth ", -1)),
                a("td", Mct, g(e.number(e.communityData.populationGrowth)), 1)
              ]),
              a("tr", null, [
                t[29] || (t[29] = a("td", { class: "text-center" }, [
                  a("i", { class: "fa-light fa-money-bill" })
                ], -1)),
                t[30] || (t[30] = a("th", null, " Median Income ", -1)),
                a("td", xct, g(e.currency(e.communityData.medianIncome)), 1)
              ]),
              a("tr", null, [
                t[31] || (t[31] = a("td", { class: "text-center" }, [
                  a("i", { class: "fa-light fa-users-class" })
                ], -1)),
                t[32] || (t[32] = a("th", null, " Average Family Size ", -1)),
                a("td", Fct, g(e.number(e.communityData.averageFamilySize, 1)), 1)
              ]),
              a("tr", null, [
                t[33] || (t[33] = a("td", { class: "text-center" }, [
                  a("i", { class: "fa-light fa-user-graduate" })
                ], -1)),
                t[34] || (t[34] = a("th", null, " People with College Degree ", -1)),
                a("td", Vct, g(e.number(e.communityData.peopleWithCollegeDegree)), 1)
              ]),
              a("tr", null, [
                t[35] || (t[35] = a("td", { class: "text-center" }, [
                  a("i", { class: "fa-light fa-user-hard-hat" })
                ], -1)),
                t[36] || (t[36] = a("th", null, " Blue Collar Workers ", -1)),
                a("td", Dct, g(e.number(e.communityData.blueCollarWorkers)), 1)
              ]),
              a("tr", null, [
                t[37] || (t[37] = a("td", { class: "text-center" }, [
                  a("i", { class: "fa-light fa-user-hard-hat" })
                ], -1)),
                t[38] || (t[38] = a("th", null, " White Collar Workers ", -1)),
                a("td", Nct, g(e.number(e.communityData.whiteCollarWorkers)), 1)
              ])
            ])
          ])
        ])
      ]),
      a("div", jct, [
        a("div", Hct, [
          a("table", Uct, [
            a("tbody", null, [
              a("tr", null, [
                t[39] || (t[39] = a("td", { class: "text-center" }, [
                  a("i", { class: "fa-light fa-house" })
                ], -1)),
                t[40] || (t[40] = a("th", null, " Average Annual Housing Expense ", -1)),
                a("td", zct, g(e.currency(e.communityData.averageAnnualHousingExpense)), 1)
              ]),
              a("tr", null, [
                t[41] || (t[41] = a("td", { class: "text-center" }, [
                  a("i", { class: "fa-light fa-faucet-drip" })
                ], -1)),
                t[42] || (t[42] = a("th", null, " Average Annual Utilities Expense ", -1)),
                a("td", Wct, g(e.currency(e.communityData.averageAnnualUtilitiesExpense)), 1)
              ]),
              a("tr", null, [
                t[43] || (t[43] = a("td", { class: "text-center" }, [
                  a("i", { class: "fa-light fa-sack-dollar" })
                ], -1)),
                t[44] || (t[44] = a("th", null, " Total Annual Household Expenditure ", -1)),
                a("td", Gct, g(e.currency(e.communityData.totalAnnualHouseholdExpenditure)), 1)
              ]),
              a("tr", null, [
                t[45] || (t[45] = a("td", { class: "text-center" }, [
                  a("i", { class: "fa-light fa-house-user" })
                ], -1)),
                t[46] || (t[46] = a("th", null, " Owner Occupied Dwellings ", -1)),
                a("td", Yct, g(e.number(e.communityData.ownerOccupiedDwellings)), 1)
              ]),
              a("tr", null, [
                t[47] || (t[47] = a("td", { class: "text-center" }, [
                  a("i", { class: "fa-light fa-house-user" })
                ], -1)),
                t[48] || (t[48] = a("th", null, " Renter Occupied Dwellings ", -1)),
                a("td", Xct, g(e.number(e.communityData.renterOccupiedDwellings)), 1)
              ]),
              a("tr", null, [
                t[49] || (t[49] = a("td", { class: "text-center" }, [
                  a("i", { class: "fa-light fa-people-arrows" })
                ], -1)),
                t[50] || (t[50] = a("th", null, " Annual Residential Turnover ", -1)),
                a("td", qct, g(e.number(e.communityData.annualResidentialTurnover)), 1)
              ]),
              a("tr", null, [
                t[51] || (t[51] = a("td", { class: "text-center" }, [
                  a("i", { class: "fa-light fa-user" })
                ], -1)),
                t[52] || (t[52] = a("th", null, " Gross Rental Estimate - 3 Bed Apartment ", -1)),
                a("td", Qct, g(e.number(e.communityData.grossRentalEstimate)), 1)
              ])
            ])
          ])
        ])
      ])
    ])) : P("", !0)
  ]);
}
const sds = /* @__PURE__ */ Ae(cdt, [["render", Kct]]), Zct = me({
  name: "OwnerContactInfo",
  props: {
    mlsSource: String,
    mlsNumber: String
  },
  data() {
    return {
      skipTrace: void 0,
      owner: void 0,
      busy: !1,
      traced: !1
    };
  },
  components: {
    // ContentLoader,
    // FacebookLoader,
    // CodeLoader,
    // ListLoader,
    // InstagramLoader,
  },
  computed: {
    showSkipTraceCard() {
      var e, t, s;
      return (((e = this.access) == null ? void 0 : e.isAuthenticated) && !this.isClient || this.canViewSkipTrace && this.skipTraced && ((t = this.owner) == null ? void 0 : t.first)) && (((s = this.property) == null ? void 0 : s.propId) ?? 0) > 0;
    },
    canSkipTrace() {
      var e, t, s;
      return ((e = this.access) == null ? void 0 : e.isAnonymous) != !0 && ((s = (t = this.access) == null ? void 0 : t.properties) == null ? void 0 : s.skipTrace) == !0;
    },
    canViewSkipTrace() {
      var e, t, s;
      return ((e = this.access) == null ? void 0 : e.isShare) || ((t = this.access) == null ? void 0 : t.isAnalysis) || ((s = this.access) == null ? void 0 : s.isIdx);
    },
    skipTraceCapable() {
      var e;
      return this.isClient != !0 && ((e = this.property) == null ? void 0 : e.propId) > 0;
    },
    skipTraced() {
      var e;
      return ((e = this.skipTrace) == null ? void 0 : e.traced) == !0;
    },
    ...q(Te, ["access", "aclLoaded", "isClient", "isAdmin", "isUser"]),
    ...q(qe, ["property", "propertyInitialized"])
  },
  methods: {
    currency: Ze,
    number: Ve,
    percent: Wt,
    async showConfirmSkipTraceModal() {
      var e;
      this.canSkipTrace && (Go("skip-trace-confirmed") == "true" ? this.skipTraceProp() : (e = bootstrap.Modal.getOrCreateInstance(this.$refs.confirmSkipTraceModal)) == null || e.show());
    },
    async skipTraceProp() {
      var e, t;
      if (this.canSkipTrace) {
        (e = bootstrap.Modal.getOrCreateInstance(this.$refs.confirmSkipTraceModal)) == null || e.hide(), eo("skip-trace-confirmed", !0);
        try {
          this.busy = !0;
          const s = await W.api.homes.skipTraceOwnerName(this.property.propId, {});
          if (s.data.status != de.Success)
            throw new Le(s);
          this.skipTrace = s.data, this.traced = !this.skipTrace.traced, (t = this.skipTrace) != null && t.traced ? wt("Skip traced succeeded!") : Mi("Skip trace found no results.");
        } catch (s) {
          Se(s);
        }
        this.busy = !1;
      }
    },
    async tracedContacts() {
      if (this.canSkipTrace)
        try {
          const e = await W.api.homes.getOwnerNames(this.property.propId);
          if (e.data.status != de.Success)
            throw new Le(e);
        } catch (e) {
          Se(e);
        }
    }
  },
  mounted() {
    this.aclLoaded.then(() => {
      this.propertyInitialized.then(async () => await this.tracedContacts());
    });
  }
}), Jct = "data:image/png;base64,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", $ct = {
  key: 0,
  class: "card shadow-sm mb-4"
}, _ct = {
  key: 0,
  class: "card-header bg-white fw-bold d-flex justify-content-between"
}, eut = { class: "locked" }, tut = {
  key: 0,
  class: "d-flex flex-column flex-md-row justify-content-between align-items-center"
}, sut = { key: 0 }, aut = { key: 1 }, nut = { class: "d-flex flex-column flex-md-row justify-content-between mt-2" }, rut = {
  key: 0,
  class: "table table-sm mb-0 rounded-lg bg-light table-borderless me-md-3"
}, out = { key: 1 }, iut = {
  key: 0,
  class: "fa-light fa-ban text-danger ms-1"
}, lut = { key: 3 }, dut = { key: 1 }, cut = {
  key: 2,
  class: "flex-shrink-0 mt-2 mt-md-0 d-flex align-items-center"
}, uut = { class: "me-2" }, put = {
  key: 0,
  class: "fa-duotone fa-spinner-third fa-spin"
}, hut = ["disabled"], mut = { key: 0 }, fut = { key: 1 }, gut = {
  key: 1,
  class: "modal fade",
  id: "confirmSkipTraceModal",
  ref: "confirmSkipTraceModal",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}, vut = { class: "modal-dialog modal-dialog-centered" }, yut = { class: "modal-content bg-gradient-alphabet rounded" }, but = { class: "modal-body text-center px-5 pb-5 pt-4" }, Aut = { class: "d-flex gap-3 justify-content-center pt-3" }, wut = {
  key: 0,
  class: "modal-footer text-center justify-content-center bg-accentgreenblue text-white"
};
function Cut(e, t, s, n, r, i) {
  return p(), h(A, null, [
    e.showSkipTraceCard ? (p(), h("div", $ct, [
      e.canSkipTrace || e.canViewSkipTrace ? (p(), h("div", _ct, t[2] || (t[2] = [
        a("span", null, [
          a("i", { class: "fa-light fa-id-card-clip me-2" }),
          y("Owner Contact Info")
        ], -1)
      ]))) : P("", !0),
      a("div", eut, [
        !e.canSkipTrace && !e.canViewSkipTrace ? (p(), h("div", tut, t[3] || (t[3] = [
          Bt('<div class="p-4 order-last order-md-first text-center text-md-start"><p class="fw-bold fs-5">Skip trace owner contact info with a Property Suite subscription!</p><a href="/account/settings" class="btn btn-lava">Activate Contact Info!</a><br><br><a href="/features/records" class="text-lava"> Learn more about property records <i class="fa-light fa-angle-double-right ms-2"></i></a></div><div class="d-none d-md-block"><img src="' + Jct + '" alt="Owner contact info" title="Owner contact info" height="330" width="300" class="img-fluid" loading="lazy"></div>', 2)
        ]))) : (p(), h("div", {
          key: 1,
          class: z(["card-content card-body", { "card-extended": !e.canSkipTrace }])
        }, [
          t[12] || (t[12] = a("p", { class: "text-secondary" }, [
            a("b", null, "TRACED CONTACTS")
          ], -1)),
          a("div", null, [
            e.owner && (e.owner.first || e.owner.last) ? (p(), h("div", sut, [
              t[4] || (t[4] = a("b", null, "Owner 1:", -1)),
              y(" " + g(e.owner.first) + " " + g(e.owner.last), 1)
            ])) : P("", !0),
            e.owner && (e.owner.first || e.owner.last) ? (p(), h("div", aut, [
              t[5] || (t[5] = a("b", null, "Owner 2:", -1)),
              y(" " + g(e.owner.first) + " " + g(e.owner.last), 1)
            ])) : P("", !0)
          ]),
          a("div", nut, [
            e.skipTraced ? (p(), h("table", rut, [
              e.skipTrace.emails && e.skipTrace.emails.length > 0 ? (p(!0), h(A, { key: 0 }, D(e.skipTrace.emails, (o) => (p(), h("tr", { key: o }, [
                t[6] || (t[6] = a("th", null, "Email", -1)),
                a("td", null, g(o), 1)
              ]))), 128)) : (p(), h("tr", out, t[7] || (t[7] = [
                a("th", null, "Email", -1),
                a("td", null, [
                  a("span", null, [
                    a("i", { class: "fa-duotone fa-triangle-exclamation text-warning me-2" }),
                    y("No email found")
                  ])
                ], -1)
              ]))),
              e.skipTrace.phones && e.skipTrace.phones.length > 0 ? (p(!0), h(A, { key: 2 }, D(e.skipTrace.phones, (o) => (p(), h("tr", {
                key: o.number
              }, [
                t[8] || (t[8] = a("th", null, "Phone", -1)),
                a("td", null, [
                  y(g(o.number), 1),
                  o.doNotCall ? (p(), h("i", iut)) : P("", !0)
                ])
              ]))), 128)) : (p(), h("tr", lut, t[9] || (t[9] = [
                a("th", null, "Phone", -1),
                a("td", null, [
                  a("span", null, [
                    a("i", { class: "fa-duotone fa-triangle-exclamation text-warning me-2" }),
                    y("No phone found")
                  ])
                ], -1)
              ])))
            ])) : e.traced ? (p(), h("span", dut, t[10] || (t[10] = [
              a("i", { class: "fa-duotone fa-triangle-exclamation text-warning me-2" }, null, -1),
              y("No contact information was found via skip trace.")
            ]))) : P("", !0),
            e.traced ? P("", !0) : (p(), h("div", cut, [
              a("div", uut, [
                e.busy ? (p(), h("i", put)) : P("", !0)
              ]),
              a("button", {
                class: "btn btn-sm btn-outline-eclipse",
                onClick: t[0] || (t[0] = (...o) => e.showConfirmSkipTraceModal && e.showConfirmSkipTraceModal(...o)),
                disabled: !e.canSkipTrace || e.skipTraced || e.busy
              }, [
                t[11] || (t[11] = a("i", { class: "fa-solid fa-search-location me-2" }, null, -1)),
                e.skipTraced ? (p(), h("span", mut, "Traced")) : (p(), h("span", fut, "Skip Trace"))
              ], 8, hut)
            ]))
          ])
        ], 2))
      ])
    ])) : P("", !0),
    e.showSkipTraceCard ? (p(), h("div", gut, [
      a("div", vut, [
        a("div", yut, [
          t[21] || (t[21] = a("div", { class: "modal-header border-0 mb-0" }, [
            a("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            })
          ], -1)),
          a("div", but, [
            t[14] || (t[14] = a("i", { class: "fa-duotone fa-search-location mb-3 fa-2x" }, null, -1)),
            t[15] || (t[15] = a("br", null, null, -1)),
            t[16] || (t[16] = a("b", { class: "fs-5" }, "Skip Trace Fee Acknowledgement", -1)),
            t[17] || (t[17] = a("br", null, null, -1)),
            t[18] || (t[18] = a("br", null, null, -1)),
            t[19] || (t[19] = a("p", null, " By initiating a skip trace, you acknowledge you'll be charged a flat fee of 8 cents if any phone numbers or email addresses are found. If no results are found, you won't be charged. ", -1)),
            a("div", Aut, [
              t[13] || (t[13] = a("button", {
                type: "button",
                class: "btn btn-outline-secondary",
                "data-bs-dismiss": "modal"
              }, "Cancel", -1)),
              a("button", {
                type: "button",
                class: "btn btn-lava",
                onClick: t[1] || (t[1] = (...o) => e.skipTraceProp && e.skipTraceProp(...o))
              }, "Confirm")
            ])
          ]),
          e.busy ? (p(), h("div", wut, t[20] || (t[20] = [
            a("i", { class: "fa-duotone fa-solid fa-spinner-third fa-spin me-2" }, null, -1),
            y("Skip Tracing Contact... ")
          ]))) : P("", !0)
        ])
      ])
    ], 512)) : P("", !0)
  ], 64);
}
const ads = /* @__PURE__ */ Ae(Zct, [["render", Cut]]), Sut = me({
  props: {
    annualRevenue: Number,
    isProperty: Boolean,
    propId: Number
  },
  emits: [
    "interface",
    "created"
  ],
  data() {
    return {
      isLoading: !0,
      crm_assign_to: void 0,
      pipeline_id: void 0,
      source_id: void 0,
      stage_id: void 0
    };
  },
  computed: {
    inCRM() {
      var e, t;
      return ((e = this.owner) == null ? void 0 : e.crmId) != null && ((t = this.owner) == null ? void 0 : t.crmId) != "";
    },
    crmButtonStyles() {
      return {
        btn: !0,
        "ms-auto": !0,
        "btn-warning": this.inCRM,
        "btn-success": !this.inCRM
      };
    },
    ...at(Mn),
    ...q(Mn, ["crmUsers", "crmPipelines", "crmStages", "crmSettings"]),
    ...q(Ba, ["owner", "ownerLoaded", "leadName"])
  },
  methods: {
    advertiseInterface() {
      this.$emit("interface", {
        updateLead: this.updateLead
      });
    },
    async loadOwner() {
      var e, t;
      try {
        if (this.isLoading = !0, await this.crmStore.fetchSettings(), this.source_id = this.crmSettings.defaultOwnerSource, (e = this.owner) != null && e.crmId) {
          const s = await W.api.crm.getLead(bt.LeadSimple, this.owner.id);
          if (s.data.status != de.Success && s.data.errorId == _n.CrmLeadNotFound) {
            Se("Lead not found in CRM.<br /><br />Please login to your CRM and verify the lead still exists for the selected pipeline. Saving the lead will cause the lead to be recreated if it does not exist, or moved to the selected pipeline.", jo.Right, !0), this.owner.crmId = void 0, this.crm_assign_to = this.crmSettings.defaultOwnerAssignee, this.pipeline_id = this.crmSettings.defaultOwnerPipeline, this.stage_id = this.crmSettings.defaultOwnerStage;
            return;
          }
          if (s.data.status != de.Success)
            throw new Le(s);
          (t = s.data) != null && t.lead && (this.crm_assign_to = s.data.lead.assignId, this.pipeline_id = s.data.lead.pipelineId, this.stage_id = s.data.lead.stageId);
        } else
          this.crm_assign_to = this.crmSettings.defaultOwnerAssignee, this.pipeline_id = this.crmSettings.defaultOwnerPipeline, this.stage_id = this.crmSettings.defaultOwnerStage;
      } catch (s) {
        Se(s);
      } finally {
        this.isLoading = !1;
      }
    },
    async loadUsers() {
      try {
        this.isLoading = !0, await this.crmStore.fetchCrmUsers();
      } catch (e) {
        Se(e);
      } finally {
        this.isLoading = !1;
      }
    },
    async loadPipelines() {
      try {
        this.isLoading = !0, await this.crmStore.fetchCrmPipelines();
      } catch (e) {
        Se(e);
      } finally {
        this.isLoading = !1;
      }
    },
    async loadStages() {
      try {
        this.isLoading = !0, this.pipeline_id && await this.crmStore.fetchCrmStages(this.pipeline_id);
      } catch (e) {
        Se(e);
      } finally {
        this.isLoading = !1;
      }
    },
    async updateLead() {
      console.log("updateLead"), this.inCRM && await this.createLead();
    },
    async createLead() {
      console.log("createLead");
      let e = !1, t = this.crmPipelines.find((n) => n.id == this.pipeline_id), s = this.crmStages.find((n) => n.id == this.stage_id);
      if (t || (Se("Please choose a valid pipeline."), e = !0), s || (Se("Please choose a valid stage."), e = !0), this.crm_assign_to || (Se("Please choose a user to assign the lead to."), e = !0), !e)
        try {
          if (this.isLoading = !0, this.isProperty) {
            const n = {
              lead: {
                assignId: this.crm_assign_to,
                annualRevenue: this.annualRevenue ? Math.trunc(this.annualRevenue) : void 0,
                additionalProperties: {
                  PipelineId: this.pipeline_id,
                  StageId: this.stage_id,
                  SourceId: this.source_id
                }
              }
            }, r = await this.crmStore.createPropertyOwnerLead(this.propId, n);
            this.$emit("created", r);
          } else {
            let n = this.annualRevenue;
            const r = await W.api.portfolioFinder.getClientValue(this.owner.id, Xt.SingleFamily);
            if (r.data.status != de.Success)
              throw new Le(r);
            n = r.data.annualManagementFees;
            const i = await W.api.portfolioFinder.setName(this.owner.id, this.leadName);
            if (i.data.status != de.Success)
              throw new Le(i);
            const o = {
              lead: {
                crmId: this.owner.crmId,
                assignId: this.crm_assign_to,
                company: this.leadName,
                firstName: this.owner.firstName,
                lastName: this.owner.lastName,
                addressStreet: this.owner.address,
                addressCity: this.owner.city,
                addressState: this.owner.state,
                addressZIP: this.owner.zip,
                annualRevenue: n ? Math.trunc(n) : void 0,
                additionalProperties: {
                  PipelineId: this.pipeline_id,
                  StageId: this.stage_id,
                  SourceId: this.source_id
                }
              }
            };
            this.propId && (o.lead.additionalProperties.propId = `${this.propId}`);
            const l = await this.crmStore.createLead(this.owner.id, o);
            this.owner.crmId ? wt("Lead updated successfully!") : wt("Lead created successfully!"), this.owner.crmId = l.crmId, this.$emit("created", l);
          }
        } catch (n) {
          console.log("error", n), Se(n);
        } finally {
          this.isLoading = !1;
        }
    }
  },
  watch: {
    pipeline_id(e, t) {
      console.log("watch.pipeline_id", e, t), t != null && (this.stage_id = ""), this.loadStages();
    }
  },
  mounted() {
    this.isProperty ? this.loadOwner() : this.ownerLoaded.then(async () => await this.loadOwner()), this.crmStore.fetchSettings().then(async () => await this.loadUsers()).then(async () => await this.loadPipelines()), this.advertiseInterface();
  }
}), Put = { class: "card-body" }, kut = { class: "row row-cols-lg-auto g-2 g-md-3" }, Eut = { class: "col-12 d-flex align-items-center border-end flex-fill justify-content-center" }, Iut = { class: "col-12 flex-fill" }, Tut = ["disabled"], Out = ["value"], Rut = { class: "col-12 col-md-6 flex-fill" }, Lut = ["disabled"], But = ["value"], Mut = { class: "col-12 col-md-6 flex-fill" }, xut = ["disabled"], Fut = ["value"], Vut = { class: "col-12 align-items-end d-flex flex-fill" }, Dut = ["disabled"];
function Nut(e, t, s, n, r, i) {
  return p(), h("div", Put, [
    a("div", kut, [
      a("div", Eut, [
        t[6] || (t[6] = a("img", {
          src: gI,
          class: "img-fluid",
          alt: "Lead Simple",
          title: "Lead Simple",
          width: "150"
        }, null, -1)),
        e.inCRM ? (p(), h(A, { key: 0 }, [
          t[4] || (t[4] = a("br", null, null, -1)),
          t[5] || (t[5] = a("i", {
            class: "fa-duotone fa-user-check text-success ms-2",
            title: "Lead is in CRM"
          }, null, -1))
        ], 64)) : P("", !0)
      ]),
      a("div", Iut, [
        t[8] || (t[8] = a("label", { class: "form-label" }, "Assignee", -1)),
        V(a("select", {
          "onUpdate:modelValue": t[0] || (t[0] = (o) => e.crm_assign_to = o),
          class: "form-select",
          disabled: e.isLoading || !e.owner && !e.isProperty || e.crmUsers.length == 0
        }, [
          t[7] || (t[7] = a("option", {
            disabled: "",
            value: "",
            selected: ""
          }, "Please select one", -1)),
          (p(!0), h(A, null, D(e.crmUsers, (o) => (p(), h("option", {
            value: o.id
          }, g(o.name), 9, Out))), 256))
        ], 8, Tut), [
          [We, e.crm_assign_to]
        ])
      ]),
      a("div", Rut, [
        t[10] || (t[10] = a("label", { class: "form-label" }, "Pipeline", -1)),
        V(a("select", {
          "onUpdate:modelValue": t[1] || (t[1] = (o) => e.pipeline_id = o),
          class: "form-select",
          disabled: e.isLoading || !e.owner && !e.isProperty || e.crmPipelines.length == 0
        }, [
          t[9] || (t[9] = a("option", {
            disabled: "",
            value: "",
            selected: ""
          }, "Please select one", -1)),
          (p(!0), h(A, null, D(e.crmPipelines, (o) => (p(), h("option", {
            value: o.id
          }, g(o.name), 9, But))), 256))
        ], 8, Lut), [
          [We, e.pipeline_id]
        ])
      ]),
      a("div", Mut, [
        t[12] || (t[12] = a("label", { class: "form-label" }, "Stage", -1)),
        V(a("select", {
          "onUpdate:modelValue": t[2] || (t[2] = (o) => e.stage_id = o),
          class: "form-select",
          disabled: e.isLoading || !e.owner && !e.isProperty || e.crmStages.length == 0
        }, [
          t[11] || (t[11] = a("option", {
            disabled: "",
            value: ""
          }, "Please select one", -1)),
          (p(!0), h(A, null, D(e.crmStages, (o) => (p(), h("option", {
            value: o.id
          }, g(o.name), 9, Fut))), 256))
        ], 8, xut), [
          [We, e.stage_id]
        ])
      ]),
      a("div", Vut, [
        a("button", {
          disabled: e.isLoading || !e.owner && !e.isProperty,
          onClick: t[3] || (t[3] = (...o) => e.createLead && e.createLead(...o)),
          class: z(e.crmButtonStyles)
        }, [
          e.inCRM ? (p(), h(A, { key: 0 }, [
            y(" Update CRM ")
          ], 64)) : (p(), h(A, { key: 1 }, [
            y(" Create in CRM ")
          ], 64))
        ], 10, Dut)
      ])
    ])
  ]);
}
const Qb = /* @__PURE__ */ Ae(Sut, [["render", Nut]]), jut = me({
  name: "TaxAsessorData",
  components: {
    LeadSimple: Qb
  },
  computed: {
    canViewOwner() {
      var e, t;
      return ((t = (e = this.access) == null ? void 0 : e.leads) == null ? void 0 : t.leads) == !0;
    },
    //canAddCrm(): boolean {
    //   return this.isClient != true &&
    //      this.crmProvider == CrmProviders.LeadSimple &&
    //      this.taxInfo?.ownerId;
    //},
    leadName() {
      var e, t, s, n;
      return `${((t = (e = this.taxInfo) == null ? void 0 : e.ownerInfo1) == null ? void 0 : t.firstName) ?? ""} ${((n = (s = this.taxInfo) == null ? void 0 : s.ownerInfo1) == null ? void 0 : n.lastName) ?? ""}`.trim();
    },
    hasAccess() {
      var e, t;
      return (((t = (e = this.access) == null ? void 0 : e.properties) == null ? void 0 : t.taxAssessor) == !0 || this.isMarketplace) && (this.isAdmin || this.isUser || this.isClient);
    },
    ...at(qe, ct, Ba),
    ...q(Te, ["access", "aclLoaded", "isClient", "isAdmin", "isUser"]),
    ...q(qe, ["taxInfo", "isMarketplace", "propId", "propertyInitialized"]),
    ...q(ct, ["crmProvider"])
  },
  methods: {
    number: Ve,
    currency: Ze,
    formatDate: cs,
    shortDate(e) {
      return this.formatDate(e, !1, "Unknown");
    }
    //addToCRM() {
    //   bootstrap.Modal.getOrCreateInstance(this.$refs.dialogAddToCRM as HTMLDivElement)?.show();
    //},
    //closeCrmDialog() {
    //   bootstrap.Modal.getOrCreateInstance(this.$refs.dialogAddToCRM as HTMLDivElement)?.hide();
    //},
  },
  mounted() {
    this.aclLoaded.then(async () => await this.propertyInitialized).then(async () => await this.propertyStore.retrieveCountyInfo()).then(async () => {
      var e;
      (e = this.taxInfo) != null && e.assignedId && await this.portfolioFinderStore.loadOwner(this.taxInfo.assignedId);
    });
  }
}), Hut = "data:image/png;base64,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", Uut = { class: "card shadow-sm overflow-hidden" }, zut = {
  key: 0,
  class: "card-header bg-white fw-bold d-flex justify-content-between"
}, Wut = {
  key: 0,
  class: "text-secondary text-opacity-50 fw-normal"
}, Gut = {
  key: 1,
  class: "d-flex flex-column flex-md-row justify-content-between align-items-end bg-gradient-periwinkle"
}, Yut = { class: "row g-0" }, Xut = { class: "col-lg-7" }, qut = { class: "p-3" }, Qut = { class: "table table-sm table-borderless m-0" }, Kut = { key: 0 }, Zut = { key: 0 }, Jut = { key: 0 }, $ut = { key: 0 }, _ut = { key: 0 }, ept = { key: 1 }, tpt = { key: 0 }, spt = { class: "m-0" }, apt = { key: 0 }, npt = { key: 0 }, rpt = { key: 0 }, opt = { class: "col border-start-lg-1 d-flex flex-column" }, ipt = { class: "p-3" }, lpt = { key: 0 }, dpt = { key: 1 }, cpt = { class: "row g-0" }, upt = { class: "col-lg-3" }, ppt = { class: "border-top p-3 d-flex align-items-center h-100" }, hpt = { key: 0 }, mpt = { class: "col" }, fpt = { class: "p-3 border-top border-start-md-1" }, gpt = { class: "d-flex flex-column flex-md-row justify-content-between" }, vpt = { class: "mb-3 mb-md-0" }, ypt = { key: 0 }, bpt = { class: "mb-3 mb-md-0" }, Apt = { key: 0 }, wpt = { key: 0 };
function Cpt(e, t, s, n, r, i) {
  var o, l, d, c, u, m, f;
  return p(), h("div", Uut, [
    e.hasAccess ? (p(), h("div", zut, [
      t[0] || (t[0] = a("span", null, [
        a("i", { class: "fal fa-file-invoice-dollar me-2" }),
        y("Tax Assessor Data")
      ], -1)),
      e.taxInfo ? (p(), h("span", Wut, "Tax Year " + g(e.taxInfo.taxYear), 1)) : P("", !0)
    ])) : P("", !0),
    e.hasAccess ? (p(), h("div", {
      key: 2,
      class: z(["card-content", { "card-extended": !e.access || !((o = e.access.properties) != null && o.taxAssessor) }])
    }, [
      a("div", Yut, [
        a("div", Xut, [
          a("div", qut, [
            t[10] || (t[10] = a("div", { class: "text-secondary text-opacity-50 d-flex justify-content-between align-items-center mb-2" }, [
              a("b", null, "OWNER")
            ], -1)),
            a("table", Qut, [
              a("tbody", null, [
                a("tr", null, [
                  t[2] || (t[2] = a("th", null, "Name 1", -1)),
                  e.taxInfo ? (p(), h("td", Kut, g((l = e.taxInfo.ownerInfo1) == null ? void 0 : l.firstName) + "  " + g((d = e.taxInfo.ownerInfo1) == null ? void 0 : d.lastName), 1)) : P("", !0)
                ]),
                e.taxInfo && e.taxInfo.ownerInfo2 ? (p(), h("tr", Zut, [
                  t[3] || (t[3] = a("th", null, "Name 2", -1)),
                  e.taxInfo ? (p(), h("td", Jut, g(e.taxInfo.ownerInfo2.firstName) + "  " + g(e.taxInfo.ownerInfo2.lastName), 1)) : P("", !0)
                ])) : P("", !0),
                a("tr", null, [
                  t[4] || (t[4] = a("th", null, "Absentee Owner?", -1)),
                  e.taxInfo ? (p(), h("td", $ut, [
                    e.taxInfo.absenteeOwner ? (p(), h("span", _ut, "Yes")) : (p(), h("span", ept, "No"))
                  ])) : P("", !0)
                ]),
                a("tr", null, [
                  t[6] || (t[6] = a("th", null, "Owner Mailing Address", -1)),
                  e.taxInfo ? (p(), h("td", tpt, [
                    a("address", spt, [
                      y(g((c = e.taxInfo.ownerAddress) == null ? void 0 : c.address), 1),
                      t[5] || (t[5] = a("br", null, null, -1)),
                      y(" " + g((u = e.taxInfo.ownerAddress) == null ? void 0 : u.city) + ", " + g((m = e.taxInfo.ownerAddress) == null ? void 0 : m.state) + " " + g((f = e.taxInfo.ownerAddress) == null ? void 0 : f.zip), 1)
                    ])
                  ])) : P("", !0)
                ]),
                a("tr", null, [
                  t[7] || (t[7] = a("th", null, "County", -1)),
                  e.taxInfo ? (p(), h("td", apt, g(e.taxInfo.county), 1)) : P("", !0)
                ]),
                a("tr", null, [
                  t[8] || (t[8] = a("th", null, "Purchase Date", -1)),
                  e.taxInfo ? (p(), h("td", npt, g(e.shortDate(e.taxInfo.purchaseDate)), 1)) : P("", !0)
                ]),
                a("tr", null, [
                  t[9] || (t[9] = a("th", null, "Purchased Amount", -1)),
                  e.taxInfo && e.taxInfo.purchaseAmount > 0 ? (p(), h("td", rpt, g(e.currency(e.taxInfo.purchaseAmount)), 1)) : P("", !0)
                ])
              ])
            ])
          ])
        ]),
        a("div", opt, [
          a("div", ipt, [
            t[11] || (t[11] = a("div", { class: "text-secondary text-opacity-50" }, [
              a("b", null, "LEGAL")
            ], -1)),
            t[12] || (t[12] = a("b", null, "Legal Description:", -1)),
            t[13] || (t[13] = a("br", null, null, -1)),
            e.taxInfo ? (p(), h("span", lpt, g(e.taxInfo.legalDescription), 1)) : P("", !0),
            t[14] || (t[14] = a("br", null, null, -1)),
            t[15] || (t[15] = a("br", null, null, -1)),
            t[16] || (t[16] = a("b", null, "Legal Subdivision:", -1)),
            t[17] || (t[17] = a("br", null, null, -1)),
            e.taxInfo ? (p(), h("span", dpt, g(e.taxInfo.legalSubdivision), 1)) : P("", !0)
          ])
        ])
      ]),
      a("div", cpt, [
        a("div", upt, [
          a("div", ppt, [
            a("div", null, [
              t[18] || (t[18] = a("b", null, "Property Type", -1)),
              t[19] || (t[19] = a("br", null, null, -1)),
              e.taxInfo ? (p(), h("span", hpt, g(e.taxInfo.propertyUsage), 1)) : P("", !0)
            ])
          ])
        ]),
        a("div", mpt, [
          a("div", fpt, [
            t[26] || (t[26] = a("div", { class: "text-secondary text-opacity-50" }, [
              a("b", null, "ASSESSED VALUE")
            ], -1)),
            a("div", gpt, [
              a("div", vpt, [
                t[20] || (t[20] = a("b", null, "Land", -1)),
                t[21] || (t[21] = a("br", null, null, -1)),
                e.taxInfo ? (p(), h("span", ypt, g(e.currency(e.taxInfo.assessedValueLand)), 1)) : P("", !0)
              ]),
              a("div", bpt, [
                t[22] || (t[22] = a("b", null, "Improvement", -1)),
                t[23] || (t[23] = a("br", null, null, -1)),
                e.taxInfo ? (p(), h("span", Apt, g(e.currency(e.taxInfo.assessedValueImprovement)), 1)) : P("", !0)
              ]),
              a("div", null, [
                t[24] || (t[24] = a("b", null, "Total", -1)),
                t[25] || (t[25] = a("br", null, null, -1)),
                e.taxInfo ? (p(), h("span", wpt, g(e.currency(e.taxInfo.assessedValueTotal)), 1)) : P("", !0)
              ])
            ])
          ])
        ])
      ])
    ], 2)) : (p(), h("div", Gut, t[1] || (t[1] = [
      Bt('<div class="px-4 py-3 order-last order-md-first text-center text-md-start"><p class="fw-bold fs-5">View property data from our assessor database with an account!</p><a href="/signup" class="btn btn-eclipse">Activate Tax Data!</a><br><br><a href="/features/records"> Learn more about property records <i class="fal fa-angle-double-right ms-2"></i></a></div><div class="d-none d-md-block"><img src="' + Hut + '" alt="Tax assesor data" title="Tax assesor data" height="330" width="300" class="img-fluid" loading="lazy"></div>', 2)
    ])))
  ]);
}
const Spt = /* @__PURE__ */ Ae(jut, [["render", Cpt]]), Ppt = me({
  name: "CurrentPropertyRecords",
  computed: {
    mortgage1EstimatedPayment() {
      if (!this.mortgage1 || this.mortgage1.amount == 0)
        return 0;
      let e = 0;
      return this.mortgage1 && this.mortgage1.rate && (e = So(this.mortgage1.rate / 12, this.mortgage1.term, -this.mortgage1.amount)), e;
    },
    mortgage1EstimatedBalance() {
      if (!this.mortgage1 || this.mortgage1.amount == 0)
        return;
      let e = 0;
      if (this.mortgage1 && this.mortgage1.rate && this.mortgageRecord.nper) {
        const t = So(this.mortgage1.rate / 12, this.mortgage1.term, -this.mortgage1.amount);
        e = bu(this.mortgage1.rate / 12, this.mortgageRecord.nper, t, -this.mortgage1.amount);
      }
      return e < 0 && (e = 0), e;
    },
    mortgage2EstimatedPayment() {
      if (!this.mortgage2 || this.mortgage2.amount == 0)
        return 0;
      let e = 0;
      return this.mortgage2 && this.mortgage2.rate && (e = So(this.mortgage2.rate / 12, this.mortgage2.term, -this.mortgage2.amount)), e;
    },
    mortgage2EstimatedBalance() {
      if (!this.mortgage2 || this.mortgage2.amount == 0)
        return;
      let e = 0;
      if (this.mortgage2 && this.mortgage2.rate && this.mortgageRecord.nper) {
        const t = So(this.mortgage2.rate / 12, this.mortgage2.term, -this.mortgage2.amount);
        e = bu(this.mortgage2.rate / 12, this.mortgageRecord.nper, t, -this.mortgage2.amount);
      }
      return e < 0 && (e = 0), e;
    },
    hasAccess() {
      var e, t;
      return (((t = (e = this.access) == null ? void 0 : e.properties) == null ? void 0 : t.records) == !0 || this.isMarketplace) && (this.isAdmin || this.isUser || this.isClient);
    },
    ...at(qe),
    ...q(Te, ["access", "aclLoaded", "isClient", "isAdmin", "isUser"]),
    ...q(qe, ["mortgage1", "mortgage2", "mortgageRecord", "mortgage1TermEstimated", "mortgage2TermEstimated", "isMarketplace", "property", "propertyInitialized"])
  },
  methods: {
    number: Ve,
    currency: Ze,
    percent: Wt,
    formatDate: cs,
    shortDate(e) {
      return e && e != "" ? this.formatDate(new Date(e)) : "";
    }
  },
  mounted() {
    this.aclLoaded.then(async () => await this.propertyInitialized).then(async () => await this.propertyStore.retrieveMortgageRecord());
  }
}), kpt = "data:image/png;base64,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", Ept = { class: "card shadow-sm overflow-hidden" }, Ipt = {
  key: 0,
  class: "card-header bg-white fw-bold border-0"
}, Tpt = {
  key: 1,
  class: "d-flex flex-column flex-md-row justify-content-between align-items-end bg-gradient-periwinkle"
}, Opt = { id: "mortgage-1" }, Rpt = { class: "card-header d-flex justify-content-between align-items-center card-header-middle border-top rounded-0 flex-column flex-md-row" }, Lpt = { key: 0 }, Bpt = { class: "text-secondary text-opacity-50" }, Mpt = {
  key: 1,
  class: "text-secondary text-opacity-50"
}, xpt = {
  key: 0,
  class: "card-body pt-0"
}, Fpt = { class: "card card-estimated bg-light mb-3" }, Vpt = { class: "row" }, Dpt = { class: "col" }, Npt = { class: "p-3" }, jpt = { class: "fw-bold fs-5" }, Hpt = { class: "col border-start-lg-1" }, Upt = { class: "p-3" }, zpt = { class: "fw-bold fs-5" }, Wpt = { class: "estimated-label" }, Gpt = { class: "col border-start-lg-1" }, Ypt = { class: "p-3" }, Xpt = { class: "fw-bold fs-5" }, qpt = { class: "row" }, Qpt = { class: "col-lg-6" }, Kpt = { class: "table table-sm table-borderless m-0" }, Zpt = { class: "text-end" }, Jpt = { key: 0 }, $pt = { class: "text-end" }, _pt = { class: "text-end" }, eht = { class: "col-lg-6" }, tht = { class: "table table-sm table-borderless m-0" }, sht = { class: "text-end" }, aht = { class: "text-end" }, nht = { class: "text-end" }, rht = {
  key: 0,
  id: "mortgage-2"
}, oht = { class: "card-body" }, iht = { class: "card card-estimated bg-light mb-3" }, lht = { class: "row" }, dht = { class: "col" }, cht = { class: "p-3" }, uht = { class: "fw-bold fs-5" }, pht = { class: "col border-start-lg-1" }, hht = { class: "p-3" }, mht = { class: "fw-bold fs-5" }, fht = { class: "estimated-label" }, ght = { class: "col border-start-lg-1" }, vht = { class: "p-3" }, yht = { class: "fw-bold fs-5" }, bht = { class: "row" }, Aht = { class: "col-md-6" }, wht = { class: "table table-sm table-borderless m-0" }, Cht = { class: "text-end" }, Sht = { key: 0 }, Pht = { class: "text-end" }, kht = { class: "text-end" }, Eht = { class: "col-md-6" }, Iht = { class: "table table-sm table-borderless m-0" }, Tht = { class: "text-end" }, Oht = { class: "text-end" }, Rht = { class: "text-end" }, Lht = {
  key: 0,
  class: "modal fade",
  id: "modalMortgage",
  tabindex: "-1",
  "aria-labelledby": "modalMortgage",
  "aria-hidden": "true"
}, Bht = { class: "modal-dialog modal-lg modal-dialog-centered" }, Mht = { class: "modal-content bg-gradient-alphabet rounded" }, xht = { class: "modal-header border-0 pb-0" }, Fht = {
  class: "modal-title fs-5 fw-bold",
  id: "exampleModalLabel"
}, Vht = { class: "modal-body p-0" }, Dht = { class: "p-3" }, Nht = { class: "row" }, jht = { class: "col-md-6 border-end" }, Hht = { class: "table table-sm table-borderless m-0 table-transparent" }, Uht = { class: "text-end" }, zht = { class: "text-end" }, Wht = { class: "text-end" }, Ght = { class: "text-end" }, Yht = { class: "col-md-6" }, Xht = { class: "table table-sm table-borderless m-0 table-transparent" }, qht = { class: "text-end" }, Qht = { class: "text-end" }, Kht = { class: "text-end" }, Zht = {
  key: 0,
  class: "p-3 border-top"
}, Jht = { class: "row" }, $ht = { class: "col-md-12" }, _ht = { class: "card-estimated bg-white bg-opacity-50 rounded d-flex" }, emt = { class: "p-3 flex-fill" }, tmt = { class: "fw-bold fs-5" }, smt = { class: "p-3 flex-fill border-start border-end" }, amt = { class: "fw-bold fs-5" }, nmt = { class: "estimated-label" }, rmt = { class: "p-3 flex-fill" }, omt = { class: "fw-bold fs-5" }, imt = { class: "col-md-6" }, lmt = { class: "p-3" }, dmt = { class: "table table-sm table-borderless m-0 table-transparent" }, cmt = { class: "text-end" }, umt = { class: "text-end" }, pmt = { class: "text-end" }, hmt = { class: "text-end" }, mmt = { class: "col-md-6 border-start-md-1" }, fmt = { class: "p-3" }, gmt = { class: "table table-sm table-borderless m-0 table-transparent" }, vmt = { class: "text-end" }, ymt = { key: 0 }, bmt = { class: "text-end" }, Amt = { class: "text-end" }, wmt = { class: "text-end" }, Cmt = { class: "text-end" }, Smt = {
  key: 1,
  class: "p-3 border-top"
}, Pmt = { class: "row" }, kmt = { class: "col-md-12" }, Emt = { class: "card-estimated bg-white bg-opacity-50 rounded d-flex" }, Imt = { class: "p-3 flex-fill" }, Tmt = { class: "fw-bold fs-5" }, Omt = { class: "p-3 flex-fill border-start border-end" }, Rmt = { class: "fw-bold fs-5" }, Lmt = { class: "estimated-label" }, Bmt = { class: "p-3 flex-fill" }, Mmt = { class: "fw-bold fs-5" }, xmt = { class: "col-md-6" }, Fmt = { class: "p-3" }, Vmt = { class: "table table-sm table-borderless m-0 table-transparent" }, Dmt = { class: "text-end" }, Nmt = { class: "text-end" }, jmt = { class: "text-end" }, Hmt = { class: "text-end" }, Umt = { class: "col-md-6 border-start-md-1" }, zmt = { class: "p-3" }, Wmt = { class: "table table-sm table-borderless m-0 table-transparent" }, Gmt = { class: "text-end" }, Ymt = { key: 0 }, Xmt = { class: "text-end" }, qmt = { class: "text-end" }, Qmt = { class: "text-end" }, Kmt = { class: "text-end" };
function Zmt(e, t, s, n, r, i) {
  var o, l, d, c, u;
  return p(), h(A, null, [
    a("div", Ept, [
      e.hasAccess ? (p(), h("div", Ipt, t[0] || (t[0] = [
        a("div", { class: "fw-bold" }, [
          a("i", { class: "fa-light fa-cabinet-filing me-2" }),
          y("Current Property Records ")
        ], -1)
      ]))) : P("", !0),
      e.hasAccess ? (p(), h("div", {
        key: 2,
        class: z(["card-content", { "card-extended": !e.access || !((o = e.access.properties) != null && o.records) }])
      }, [
        a("div", Opt, [
          a("div", Rpt, [
            t[3] || (t[3] = a("div", { class: "mb-2 mb-md-0" }, [
              a("i", { class: "fa-light fa-envelope-open-dollar me-2" }),
              y(" 1st Mortgage ")
            ], -1)),
            e.mortgageRecord ? (p(), h("span", Lpt, [
              a("small", Bpt, " Last updated: " + g(e.shortDate(e.mortgageRecord.lastUpdated)), 1),
              t[2] || (t[2] = a("button", {
                type: "button",
                class: "btn btn-link text-eclipse btn-sm ms-4 no-anim",
                "data-bs-toggle": "modal",
                "data-bs-target": "#modalMortgage"
              }, [
                y(" View All Data"),
                a("i", { class: "fa-light fa-angle-right ms-2" })
              ], -1))
            ])) : (p(), h("small", Mpt, " No Record Found "))
          ]),
          e.mortgage1 ? (p(), h("div", xpt, [
            a("div", Fpt, [
              a("div", Vpt, [
                a("div", Dpt, [
                  a("div", Npt, [
                    a("span", jpt, g(e.currency(e.mortgage1EstimatedBalance, !1, "N/A")), 1),
                    t[4] || (t[4] = a("br", null, null, -1)),
                    t[5] || (t[5] = a("span", { class: "estimated-label" }, "Est. Balance", -1))
                  ])
                ]),
                a("div", Hpt, [
                  a("div", Upt, [
                    a("span", zpt, g(e.percent(e.mortgage1.rate, 2)), 1),
                    t[7] || (t[7] = a("br", null, null, -1)),
                    a("span", Wpt, [
                      e.mortgage1.rateEstimated ? (p(), h(A, { key: 0 }, [
                        y(" Est. ")
                      ], 64)) : P("", !0),
                      t[6] || (t[6] = y("Interest Rate "))
                    ])
                  ])
                ]),
                a("div", Gpt, [
                  a("div", Ypt, [
                    a("span", Xpt, g(e.currency(e.mortgage1EstimatedPayment, !1, "N/A", !0)), 1),
                    t[8] || (t[8] = a("br", null, null, -1)),
                    t[9] || (t[9] = a("span", { class: "estimated-label" }, "Est. Monthly Payment", -1))
                  ])
                ])
              ])
            ]),
            a("div", qpt, [
              a("div", Qpt, [
                a("table", Kpt, [
                  a("tbody", null, [
                    a("tr", null, [
                      t[10] || (t[10] = a("th", null, "Amount", -1)),
                      a("td", Zpt, g(e.currency(e.mortgage1.amount)), 1)
                    ]),
                    a("tr", null, [
                      a("th", null, [
                        t[11] || (t[11] = y("Term")),
                        e.mortgage1TermEstimated ? (p(), h("span", Jpt, "(Estimated)")) : P("", !0)
                      ]),
                      a("td", $pt, g(e.mortgage1.term), 1)
                    ]),
                    a("tr", null, [
                      t[12] || (t[12] = a("th", null, "Lender Name", -1)),
                      a("td", _pt, g(e.mortgage1.lenderNameFull), 1)
                    ])
                  ])
                ])
              ]),
              a("div", eht, [
                a("table", tht, [
                  a("tbody", null, [
                    a("tr", null, [
                      t[13] || (t[13] = a("th", null, "Instrument Date", -1)),
                      a("td", sht, g(e.shortDate((l = e.mortgageRecord) == null ? void 0 : l.instrumentDate)), 1)
                    ]),
                    a("tr", null, [
                      t[14] || (t[14] = a("th", null, "Document Type", -1)),
                      a("td", aht, g((d = e.mortgageRecord) == null ? void 0 : d.typeDescription), 1)
                    ]),
                    a("tr", null, [
                      t[15] || (t[15] = a("th", null, "Classification", -1)),
                      a("td", nht, g(e.mortgage1.lenderInfoEntityClassification), 1)
                    ])
                  ])
                ])
              ])
            ])
          ])) : P("", !0)
        ]),
        e.mortgage2 ? (p(), h("div", rht, [
          t[28] || (t[28] = a("div", { class: "card-header d-flex justify-content-between align-items-center card-header-middle pb-0 border-top rounded-0" }, [
            a("div", null, [
              a("i", { class: "fa-light fa-envelope-open-dollar me-2" }),
              y(" 2nd Mortgage ")
            ]),
            a("button", {
              type: "button",
              class: "btn btn-outline-eclipse btn-sm",
              "data-bs-toggle": "modal",
              "data-bs-target": "#modalMortgage"
            }, [
              y(" View all data "),
              a("i", { class: "fa-light fa-external-link ms-2" })
            ])
          ], -1)),
          a("div", oht, [
            a("div", iht, [
              a("div", lht, [
                a("div", dht, [
                  a("div", cht, [
                    a("span", uht, g(e.currency(e.mortgage2EstimatedBalance, !1, "N/A")), 1),
                    t[16] || (t[16] = a("br", null, null, -1)),
                    t[17] || (t[17] = a("span", { class: "estimated-label" }, "Est. Balance", -1))
                  ])
                ]),
                a("div", pht, [
                  a("div", hht, [
                    a("span", mht, g(e.percent(e.mortgage2.rate, 2)), 1),
                    t[19] || (t[19] = a("br", null, null, -1)),
                    a("span", fht, [
                      e.mortgage2.rateEstimated ? (p(), h(A, { key: 0 }, [
                        y(" Est. ")
                      ], 64)) : P("", !0),
                      t[18] || (t[18] = y("Interest Rate "))
                    ])
                  ])
                ]),
                a("div", ght, [
                  a("div", vht, [
                    a("span", yht, g(e.currency(e.mortgage2EstimatedPayment, !1, "N/A", !0)), 1),
                    t[20] || (t[20] = a("br", null, null, -1)),
                    t[21] || (t[21] = a("span", { class: "estimated-label" }, "Est. Monthly Payment", -1))
                  ])
                ])
              ])
            ]),
            a("div", bht, [
              a("div", Aht, [
                a("table", wht, [
                  a("tbody", null, [
                    a("tr", null, [
                      t[22] || (t[22] = a("th", null, "Amount", -1)),
                      a("td", Cht, g(e.currency(e.mortgage2.amount)), 1)
                    ]),
                    a("tr", null, [
                      a("th", null, [
                        t[23] || (t[23] = y("Term")),
                        e.mortgage2TermEstimated ? (p(), h("span", Sht, "(Estimated)")) : P("", !0)
                      ]),
                      a("td", Pht, g(e.mortgage2.term), 1)
                    ]),
                    a("tr", null, [
                      t[24] || (t[24] = a("th", null, "Lender Name", -1)),
                      a("td", kht, g(e.mortgage2.lenderNameFull), 1)
                    ])
                  ])
                ])
              ]),
              a("div", Eht, [
                a("table", Iht, [
                  a("tbody", null, [
                    a("tr", null, [
                      t[25] || (t[25] = a("th", null, "Instrument Date", -1)),
                      a("td", Tht, g(e.shortDate((c = e.mortgageRecord) == null ? void 0 : c.instrumentDate)), 1)
                    ]),
                    a("tr", null, [
                      t[26] || (t[26] = a("th", null, "Document Type", -1)),
                      a("td", Oht, g((u = e.mortgageRecord) == null ? void 0 : u.typeDescription), 1)
                    ]),
                    a("tr", null, [
                      t[27] || (t[27] = a("th", null, "Classification", -1)),
                      a("td", Rht, g(e.mortgage2.lenderInfoEntityClassification), 1)
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])) : P("", !0)
      ], 2)) : (p(), h("div", Tpt, t[1] || (t[1] = [
        Bt('<div class="p-4 order-last order-md-first text-center text-md-start"><p class="fw-bold fs-5">Research courthouse records with a Property Suite Pro account!</p><a href="/account/settings" class="btn btn-eclipse">Activate Courthouse Records!</a><br><br><a href="/features/records"> Learn more about property records <i class="fa-light fa-angle-double-right ms-2"></i></a></div><div class="d-none d-md-block"><img src="' + kpt + '" alt="Current Property Records" title="Current Property Records" height="330" width="300" class="img-fluid" loading="lazy"></div>', 2)
      ])))
    ]),
    e.mortgageRecord ? (p(), h("div", Lht, [
      a("div", Bht, [
        a("div", Mht, [
          a("div", xht, [
            a("p", Fht, g(e.mortgageRecord.typeDescription), 1),
            t[29] || (t[29] = a("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            }, null, -1))
          ]),
          a("div", Vht, [
            a("div", Dht, [
              a("div", Nht, [
                t[37] || (t[37] = a("div", { class: "col-md-12" }, [
                  a("div", { class: "text-secondary text-opacity-75" }, [
                    a("b", null, "DOCUMENT RECORDING")
                  ])
                ], -1)),
                a("div", jht, [
                  a("table", Hht, [
                    a("tbody", null, [
                      a("tr", null, [
                        t[30] || (t[30] = a("th", null, "County", -1)),
                        a("td", Uht, g(e.mortgageRecord.county) + ", " + g(e.mortgageRecord.state), 1)
                      ]),
                      a("tr", null, [
                        t[31] || (t[31] = a("th", null, "Instrument Date", -1)),
                        a("td", zht, g(e.shortDate(e.mortgageRecord.instrumentDate)), 1)
                      ]),
                      a("tr", null, [
                        t[32] || (t[32] = a("th", null, "Recording Date", -1)),
                        a("td", Wht, g(e.shortDate(e.mortgageRecord.recordingDate)), 1)
                      ]),
                      a("tr", null, [
                        t[33] || (t[33] = a("th", null, "Transfer Info Purchase Type", -1)),
                        a("td", Ght, g(e.mortgageRecord.transferInfoPurchaseType), 1)
                      ])
                    ])
                  ])
                ]),
                a("div", Yht, [
                  a("table", Xht, [
                    a("tbody", null, [
                      a("tr", null, [
                        t[34] || (t[34] = a("th", null, "Grantor", -1)),
                        a("td", qht, g(e.mortgageRecord.grantor1Name), 1)
                      ]),
                      a("tr", null, [
                        t[35] || (t[35] = a("th", null, "Grantee", -1)),
                        a("td", Qht, g(e.mortgageRecord.grantee1First) + " " + g(e.mortgageRecord.grantee1Last), 1)
                      ]),
                      a("tr", null, [
                        t[36] || (t[36] = a("th", null, "Vesting", -1)),
                        a("td", Kht, g(e.mortgageRecord.granteeInfoVesting1), 1)
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            e.mortgage1 ? (p(), h("div", Zht, [
              a("div", Jht, [
                t[54] || (t[54] = a("div", { class: "col-md-12 text-secondary text-opacity-75 pb-3" }, [
                  a("i", { class: "fa-light fa-envelope-open-dollar me-2" }),
                  y(" 1st Mortgage ")
                ], -1)),
                a("div", $ht, [
                  a("div", _ht, [
                    a("div", emt, [
                      a("span", tmt, g(e.currency(e.mortgage1EstimatedBalance, !1, "N/A")), 1),
                      t[38] || (t[38] = a("br", null, null, -1)),
                      t[39] || (t[39] = a("span", { class: "estimated-label" }, "Est. Balance", -1))
                    ]),
                    a("div", smt, [
                      a("span", amt, g(e.percent(e.mortgage1.rate, 2)), 1),
                      t[41] || (t[41] = a("br", null, null, -1)),
                      a("span", nmt, [
                        e.mortgage1.rateEstimated ? (p(), h(A, { key: 0 }, [
                          y(" Est. ")
                        ], 64)) : P("", !0),
                        t[40] || (t[40] = y("Interest Rate "))
                      ])
                    ]),
                    a("div", rmt, [
                      a("span", omt, g(e.currency(e.mortgage1EstimatedPayment, !1, "N/A", !0)), 1),
                      t[42] || (t[42] = a("br", null, null, -1)),
                      t[43] || (t[43] = a("span", { class: "estimated-label" }, "Est. Monthly Payment", -1))
                    ])
                  ])
                ]),
                a("div", imt, [
                  a("div", lmt, [
                    a("table", dmt, [
                      a("tbody", null, [
                        a("tr", null, [
                          t[44] || (t[44] = a("th", null, "Lender Name", -1)),
                          a("td", cmt, g(e.mortgage1.lenderNameFull), 1)
                        ]),
                        a("tr", null, [
                          t[46] || (t[46] = a("th", null, "Lender Address", -1)),
                          a("td", umt, [
                            y(g(e.mortgage1.lenderAddress), 1),
                            t[45] || (t[45] = a("br", null, null, -1)),
                            y(" " + g(e.mortgage1.lenderCity) + ", " + g(e.mortgage1.lenderState) + " " + g(e.mortgage1.lenderZIP), 1)
                          ])
                        ]),
                        a("tr", null, [
                          t[47] || (t[47] = a("th", null, "Classification", -1)),
                          a("td", pmt, g(e.mortgage1.lenderInfoEntityClassification), 1)
                        ]),
                        a("tr", null, [
                          t[48] || (t[48] = a("th", null, "Lender Info Seller Carry Back", -1)),
                          a("td", hmt, g(e.mortgage1.lenderInfoSellerCarryBack), 1)
                        ])
                      ])
                    ])
                  ])
                ]),
                a("div", mmt, [
                  a("div", fmt, [
                    a("table", gmt, [
                      a("tbody", null, [
                        a("tr", null, [
                          t[49] || (t[49] = a("th", null, "Amount", -1)),
                          a("td", vmt, g(e.currency(e.mortgage1.amount)), 1)
                        ]),
                        a("tr", null, [
                          a("th", null, [
                            t[50] || (t[50] = y("Term")),
                            e.mortgage1TermEstimated ? (p(), h("span", ymt, "(Estimated)")) : P("", !0)
                          ]),
                          a("td", bmt, g(e.mortgage1.term), 1)
                        ]),
                        a("tr", null, [
                          t[51] || (t[51] = a("th", null, " Type ", -1)),
                          a("td", Amt, g(e.mortgage1.type), 1)
                        ]),
                        a("tr", null, [
                          t[52] || (t[52] = a("th", null, "Rate Type", -1)),
                          a("td", wmt, g(e.mortgage1.rateType), 1)
                        ]),
                        a("tr", null, [
                          t[53] || (t[53] = a("th", null, "Recording Date", -1)),
                          a("td", Cmt, g(e.shortDate(e.mortgage1.recordingDate)), 1)
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ])) : P("", !0),
            e.mortgage2 ? (p(), h("div", Smt, [
              a("div", Pmt, [
                t[71] || (t[71] = a("div", { class: "col-md-12 text-secondary text-opacity-75 pb-3" }, [
                  a("i", { class: "fa-light fa-envelope-open-dollar me-2" }),
                  y(" 2nd Mortgage ")
                ], -1)),
                a("div", kmt, [
                  a("div", Emt, [
                    a("div", Imt, [
                      a("span", Tmt, g(e.currency(e.mortgage2EstimatedBalance, !1, "N/A")), 1),
                      t[55] || (t[55] = a("br", null, null, -1)),
                      t[56] || (t[56] = a("span", { class: "estimated-label" }, "Est. Balance", -1))
                    ]),
                    a("div", Omt, [
                      a("span", Rmt, g(e.percent(e.mortgage2.rate, 2)), 1),
                      t[58] || (t[58] = a("br", null, null, -1)),
                      a("span", Lmt, [
                        e.mortgage1.rateEstimated ? (p(), h(A, { key: 0 }, [
                          y(" Est. ")
                        ], 64)) : P("", !0),
                        t[57] || (t[57] = y("Interest Rate "))
                      ])
                    ]),
                    a("div", Bmt, [
                      a("span", Mmt, g(e.currency(e.mortgage2EstimatedPayment, !1, "N/A", !0)), 1),
                      t[59] || (t[59] = a("br", null, null, -1)),
                      t[60] || (t[60] = a("span", { class: "estimated-label" }, "Est. Monthly Payment", -1))
                    ])
                  ])
                ]),
                a("div", xmt, [
                  a("div", Fmt, [
                    a("table", Vmt, [
                      a("tbody", null, [
                        a("tr", null, [
                          t[61] || (t[61] = a("th", null, "Lender Name", -1)),
                          a("td", Dmt, g(e.mortgage2.lenderNameFull), 1)
                        ]),
                        a("tr", null, [
                          t[63] || (t[63] = a("th", null, "Lender Address", -1)),
                          a("td", Nmt, [
                            y(g(e.mortgage2.lenderAddress), 1),
                            t[62] || (t[62] = a("br", null, null, -1)),
                            y(" " + g(e.mortgage2.lenderCity) + ", " + g(e.mortgage2.lenderState) + " " + g(e.mortgage2.lenderZIP), 1)
                          ])
                        ]),
                        a("tr", null, [
                          t[64] || (t[64] = a("th", null, "Classification", -1)),
                          a("td", jmt, g(e.mortgage2.lenderInfoEntityClassification), 1)
                        ]),
                        a("tr", null, [
                          t[65] || (t[65] = a("th", null, "Lender Info Seller Carry Back", -1)),
                          a("td", Hmt, g(e.mortgage2.lenderInfoSellerCarryBack), 1)
                        ])
                      ])
                    ])
                  ])
                ]),
                a("div", Umt, [
                  a("div", zmt, [
                    a("table", Wmt, [
                      a("tbody", null, [
                        a("tr", null, [
                          t[66] || (t[66] = a("th", null, "Amount", -1)),
                          a("td", Gmt, g(e.currency(e.mortgage2.amount)), 1)
                        ]),
                        a("tr", null, [
                          a("th", null, [
                            t[67] || (t[67] = y("Term")),
                            e.mortgage2TermEstimated ? (p(), h("span", Ymt, "(Estimated)")) : P("", !0)
                          ]),
                          a("td", Xmt, g(e.mortgage2.term), 1)
                        ]),
                        a("tr", null, [
                          t[68] || (t[68] = a("th", null, " Type ", -1)),
                          a("td", qmt, g(e.mortgage2.type), 1)
                        ]),
                        a("tr", null, [
                          t[69] || (t[69] = a("th", null, "Rate Type", -1)),
                          a("td", Qmt, g(e.mortgage2.rateType), 1)
                        ]),
                        a("tr", null, [
                          t[70] || (t[70] = a("th", null, "Recording Date", -1)),
                          a("td", Kmt, g(e.shortDate(e.mortgage2.recordingDate)), 1)
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ])) : P("", !0)
          ])
        ])
      ])
    ])) : P("", !0)
  ], 64);
}
const Jmt = /* @__PURE__ */ Ae(Ppt, [["render", Zmt]]), $mt = me({
  name: "AllPropertyRecords",
  components: {},
  data() {
    return {
      publicRecord: void 0
    };
  },
  computed: {
    mortgage1EstimatedPayment() {
      if (!this.mortgage1 || this.mortgage1.amount == 0)
        return 0;
      let e = 0;
      return this.mortgage1 && this.mortgage1.rate && (e = So(this.mortgage1.rate / 12, this.mortgage1.term, -this.mortgage1.amount)), e;
    },
    mortgage1EstimatedBalance() {
      var t;
      if (!this.mortgage1 || this.mortgage1.amount == 0)
        return;
      let e = 0;
      if (this.mortgage1 && this.mortgage1.rate && ((t = this.publicRecord) != null && t.nper)) {
        const s = So(this.mortgage1.rate / 12, this.mortgage1.term, -this.mortgage1.amount);
        e = bu(this.mortgage1.rate / 12, this.publicRecord.nper, s, -this.mortgage1.amount);
      }
      return e < 0 && (e = 0), e;
    },
    mortgage2EstimatedPayment() {
      if (!this.mortgage2 || this.mortgage2.amount == 0)
        return 0;
      let e = 0;
      return this.mortgage2 && this.mortgage2.rate && (e = So(this.mortgage2.rate / 12, this.mortgage2.term, -this.mortgage2.amount)), e;
    },
    mortgage2EstimatedBalance() {
      var t;
      if (!this.mortgage2 || this.mortgage2.amount == 0)
        return;
      let e = 0;
      if (this.mortgage2 && this.mortgage2.rate && ((t = this.publicRecord) != null && t.nper)) {
        const s = So(this.mortgage2.rate / 12, this.mortgage2.term, -this.mortgage2.amount);
        e = bu(this.mortgage2.rate / 12, this.publicRecord.nper, s, -this.mortgage2.amount);
      }
      return e < 0 && (e = 0), e;
    },
    filteredRecords() {
      return this.publicRecords.filter((e) => {
        var t;
        return e.recordId != ((t = this.mortgageRecord) == null ? void 0 : t.recordId);
      });
    },
    hasAccess() {
      var e, t;
      return (((t = (e = this.access) == null ? void 0 : e.properties) == null ? void 0 : t.records) == !0 || this.isMarketplace) && (this.isAdmin || this.isUser || this.isClient);
    },
    ...at(qe),
    ...q(Te, ["access", "aclLoaded", "isClient", "isAdmin", "isUser"]),
    ...q(qe, ["publicRecords", "mortgage1", "mortgage2", "mortgage1TermEstimated", "mortgage2TermEstimated", "mortgageRecord", "property", "propertyInitialized", "isMarketplace"])
  },
  methods: {
    number: Ve,
    currency: Ze,
    percent: Wt,
    shortDate: cs,
    async showPublicRecord(e) {
      var t, s, n, r;
      if ((t = this.property) != null && t.propId && ((n = (s = this.access) == null ? void 0 : s.properties) != null && n.records))
        try {
          this.publicRecord = await this.propertyStore.getPublicRecord(e), (r = bootstrap.Modal.getOrCreateInstance(this.$refs.modalOwnership)) == null || r.show();
        } catch (i) {
          console.log("showPublicRecord", i);
        }
    }
  },
  mounted() {
    this.aclLoaded.then(async () => await this.propertyInitialized).then(async () => await this.propertyStore.retrievePublicRecords());
  }
}), _mt = {
  key: 0,
  class: "card shadow-sm"
}, eft = { class: "card-body p-0" }, tft = { class: "table table-hover table-sm m-0" }, sft = { class: "text-end" }, aft = ["onClick"], nft = { key: 1 }, rft = {
  class: "modal fade",
  ref: "modalOwnership",
  tabindex: "-1",
  "aria-labelledby": "modalOwnership",
  "aria-hidden": "true"
}, oft = { class: "modal-dialog modal-lg modal-dialog-centered" }, ift = { class: "modal-content bg-gradient-alphabet rounded" }, lft = { class: "modal-header border-0 pb-0" }, dft = {
  key: 0,
  class: "modal-title fs-5 fw-bold",
  id: "exampleModalLabel"
}, cft = { class: "modal-body p-0" }, uft = { class: "p-3" }, pft = { class: "row" }, hft = { class: "col-md-6 border-end" }, mft = { class: "table table-sm table-borderless m-0" }, fft = { class: "text-end" }, gft = { class: "text-end" }, vft = { class: "text-end" }, yft = { class: "text-end" }, bft = { class: "col-md-6" }, Aft = { class: "table table-sm table-borderless m-0" }, wft = { class: "text-end" }, Cft = { class: "text-end" }, Sft = { class: "text-end" }, Pft = {
  key: 0,
  class: "p-3 border-top"
}, kft = { class: "row" }, Eft = { class: "col-md-12" }, Ift = { class: "card-estimated bg-light rounded d-flex" }, Tft = { class: "p-3 flex-fill" }, Oft = { class: "fw-bold fs-5" }, Rft = { class: "p-3 flex-fill border-start border-end" }, Lft = { class: "fw-bold fs-5" }, Bft = { class: "estimated-label" }, Mft = { class: "p-3 flex-fill" }, xft = { class: "fw-bold fs-5" }, Fft = { class: "col-md-6" }, Vft = { class: "p-3" }, Dft = { class: "table table-sm table-borderless m-0" }, Nft = { class: "text-end" }, jft = { class: "text-end" }, Hft = { class: "text-end" }, Uft = { class: "text-end" }, zft = { class: "col-md-6 border-start-md-1" }, Wft = { class: "p-3" }, Gft = { class: "table table-sm table-borderless m-0" }, Yft = { class: "text-end" }, Xft = { key: 0 }, qft = { class: "text-end" }, Qft = { class: "text-end" }, Kft = { class: "text-end" }, Zft = { class: "text-end" }, Jft = {
  key: 1,
  class: "p-3 border-top"
}, $ft = { class: "row" }, _ft = { class: "col-md-12" }, egt = { class: "card-estimated bg-light rounded d-flex" }, tgt = { class: "p-3 flex-fill" }, sgt = { class: "fw-bold fs-5" }, agt = { class: "p-3 flex-fill border-start border-end" }, ngt = { class: "fw-bold fs-5" }, rgt = { class: "estimated-label" }, ogt = { class: "p-3 flex-fill" }, igt = { class: "fw-bold fs-5" }, lgt = { class: "col-md-6" }, dgt = { class: "p-3" }, cgt = { class: "table table-sm table-borderless m-0" }, ugt = { class: "text-end" }, pgt = { class: "text-end" }, hgt = { class: "text-end" }, mgt = { class: "text-end" }, fgt = { class: "col-md-6 border-start-md-1" }, ggt = { class: "p-3" }, vgt = { class: "table table-sm table-borderless m-0" }, ygt = { class: "text-end" }, bgt = { key: 0 }, Agt = { class: "text-end" }, wgt = { class: "text-end" }, Cgt = { class: "text-end" }, Sgt = { class: "text-end" };
function Pgt(e, t, s, n, r, i) {
  var o;
  return p(), h(A, null, [
    e.hasAccess ? (p(), h("div", _mt, [
      t[4] || (t[4] = a("div", { class: "card-header bg-white font-weight-bold" }, [
        a("div", { class: "fw-bold" }, [
          a("i", { class: "fa-light fa-cabinet-filing me-2" }),
          y("Past Property Records ")
        ])
      ], -1)),
      a("div", eft, [
        P("", !0),
        a("div", {
          class: z(["card-content", { "card-extended": !e.access || !((o = e.access.properties) != null && o.records) }])
        }, [
          a("table", tft, [
            t[3] || (t[3] = a("thead", null, [
              a("tr", null, [
                a("th", null, " Type "),
                a("th", null, " Instrument Date "),
                a("th")
              ])
            ], -1)),
            a("tbody", null, [
              e.filteredRecords ? (p(!0), h(A, { key: 0 }, D(e.filteredRecords, (l) => (p(), h("tr", {
                key: l.recordId
              }, [
                a("td", null, g(l.typeDescription), 1),
                a("td", null, g(e.shortDate(l.instrumentDate)), 1),
                a("td", sft, [
                  a("button", {
                    onClick: (d) => e.showPublicRecord(l.recordId),
                    type: "button",
                    class: "btn btn-outline-eclipse btn-sm"
                  }, t[1] || (t[1] = [
                    a("span", { class: "d-none d-md-inline-block" }, "View Record", -1),
                    a("i", { class: "fa-light fa-angle-right ms-2 d-none d-md-inline-block" }, null, -1),
                    a("i", { class: "fal fa-eye d-md-none" }, null, -1)
                  ]), 8, aft)
                ])
              ]))), 128)) : (p(), h("tr", nft, t[2] || (t[2] = [
                a("td", {
                  colspan: "3",
                  class: "text-center"
                }, " No records found ", -1)
              ])))
            ])
          ])
        ], 2)
      ])
    ])) : P("", !0),
    a("div", rft, [
      a("div", oft, [
        a("div", ift, [
          a("div", lft, [
            e.publicRecord ? (p(), h("p", dft, g(e.publicRecord.typeDescription), 1)) : P("", !0),
            t[5] || (t[5] = a("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            }, null, -1))
          ]),
          a("div", cft, [
            e.publicRecord ? (p(), h(A, { key: 0 }, [
              a("div", uft, [
                a("div", pft, [
                  t[13] || (t[13] = a("div", { class: "col-md-12" }, [
                    a("div", { class: "text-secondary text-opacity-50" }, [
                      a("b", null, "DOCUMENT RECORDING")
                    ])
                  ], -1)),
                  a("div", hft, [
                    a("table", mft, [
                      a("tbody", null, [
                        a("tr", null, [
                          t[6] || (t[6] = a("th", null, "County", -1)),
                          a("td", fft, g(e.publicRecord.county) + ", " + g(e.publicRecord.state), 1)
                        ]),
                        a("tr", null, [
                          t[7] || (t[7] = a("th", null, "Instrument Date", -1)),
                          a("td", gft, g(e.shortDate(e.publicRecord.instrumentDate)), 1)
                        ]),
                        a("tr", null, [
                          t[8] || (t[8] = a("th", null, "Recording Date", -1)),
                          a("td", vft, g(e.shortDate(e.publicRecord.recordingDate)), 1)
                        ]),
                        a("tr", null, [
                          t[9] || (t[9] = a("th", null, "Transfer Info Purchase Type", -1)),
                          a("td", yft, g(e.publicRecord.transferInfoPurchaseType), 1)
                        ])
                      ])
                    ])
                  ]),
                  a("div", bft, [
                    a("table", Aft, [
                      a("tbody", null, [
                        a("tr", null, [
                          t[10] || (t[10] = a("th", null, "Grantor", -1)),
                          a("td", wft, g(e.publicRecord.grantor1Name), 1)
                        ]),
                        a("tr", null, [
                          t[11] || (t[11] = a("th", null, "Grantee", -1)),
                          a("td", Cft, g(e.publicRecord.grantee1First) + " " + g(e.publicRecord.grantee1Last), 1)
                        ]),
                        a("tr", null, [
                          t[12] || (t[12] = a("th", null, "Vesting", -1)),
                          a("td", Sft, g(e.publicRecord.granteeInfoVesting1), 1)
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              e.mortgage1 ? (p(), h("div", Pft, [
                a("div", kft, [
                  t[30] || (t[30] = a("div", { class: "col-md-12 text-secondary text-opacity-50 pb-3" }, [
                    a("i", { class: "fa-light fa-envelope-open-dollar me-2" }),
                    y(" 1st Mortgage ")
                  ], -1)),
                  a("div", Eft, [
                    a("div", Ift, [
                      a("div", Tft, [
                        a("span", Oft, g(e.currency(e.mortgage1EstimatedBalance, !1, "N/A")), 1),
                        t[14] || (t[14] = a("br", null, null, -1)),
                        t[15] || (t[15] = a("span", { class: "estimated-label" }, "Est. Balance", -1))
                      ]),
                      a("div", Rft, [
                        a("span", Lft, g(e.percent(e.mortgage1.rate, 2)), 1),
                        t[17] || (t[17] = a("br", null, null, -1)),
                        a("span", Bft, [
                          e.mortgage1.rateEstimated ? (p(), h(A, { key: 0 }, [
                            y(" Est. ")
                          ], 64)) : P("", !0),
                          t[16] || (t[16] = y("Interest Rate "))
                        ])
                      ]),
                      a("div", Mft, [
                        a("span", xft, g(e.currency(e.mortgage1EstimatedPayment, !1, "N/A", !0)), 1),
                        t[18] || (t[18] = a("br", null, null, -1)),
                        t[19] || (t[19] = a("span", { class: "estimated-label" }, "Est. Monthly Payment", -1))
                      ])
                    ])
                  ]),
                  a("div", Fft, [
                    a("div", Vft, [
                      a("table", Dft, [
                        a("tbody", null, [
                          a("tr", null, [
                            t[20] || (t[20] = a("th", null, "Lender Name", -1)),
                            a("td", Nft, g(e.mortgage1.lenderNameFull), 1)
                          ]),
                          a("tr", null, [
                            t[22] || (t[22] = a("th", null, "Lender Address", -1)),
                            a("td", jft, [
                              y(g(e.mortgage1.lenderAddress), 1),
                              t[21] || (t[21] = a("br", null, null, -1)),
                              y(" " + g(e.mortgage1.lenderCity) + ", " + g(e.mortgage1.lenderState) + " " + g(e.mortgage1.lenderZIP), 1)
                            ])
                          ]),
                          a("tr", null, [
                            t[23] || (t[23] = a("th", null, "Classification", -1)),
                            a("td", Hft, g(e.mortgage1.lenderInfoEntityClassification), 1)
                          ]),
                          a("tr", null, [
                            t[24] || (t[24] = a("th", null, "Lender Info Seller Carry Back", -1)),
                            a("td", Uft, g(e.mortgage1.lenderInfoSellerCarryBack), 1)
                          ])
                        ])
                      ])
                    ])
                  ]),
                  a("div", zft, [
                    a("div", Wft, [
                      a("table", Gft, [
                        a("tbody", null, [
                          a("tr", null, [
                            t[25] || (t[25] = a("th", null, "Amount", -1)),
                            a("td", Yft, g(e.currency(e.mortgage1.amount)), 1)
                          ]),
                          a("tr", null, [
                            a("th", null, [
                              t[26] || (t[26] = y("Term")),
                              e.mortgage1TermEstimated ? (p(), h("span", Xft, "(Estimated)")) : P("", !0)
                            ]),
                            a("td", qft, g(e.mortgage1.term), 1)
                          ]),
                          a("tr", null, [
                            t[27] || (t[27] = a("th", null, " Type ", -1)),
                            a("td", Qft, g(e.mortgage1.type), 1)
                          ]),
                          a("tr", null, [
                            t[28] || (t[28] = a("th", null, "Rate Type", -1)),
                            a("td", Kft, g(e.mortgage1.rateType), 1)
                          ]),
                          a("tr", null, [
                            t[29] || (t[29] = a("th", null, "Recording Date", -1)),
                            a("td", Zft, g(e.shortDate(e.mortgage1.recordingDate)), 1)
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ])) : P("", !0),
              e.mortgage2 ? (p(), h("div", Jft, [
                a("div", $ft, [
                  t[47] || (t[47] = a("div", { class: "col-md-12 text-dark text-opacity-25 pb-3" }, [
                    a("i", { class: "fa-light fa-envelope-open-dollar me-2" }),
                    y(" 2nd Mortgage ")
                  ], -1)),
                  a("div", _ft, [
                    a("div", egt, [
                      a("div", tgt, [
                        a("span", sgt, g(e.currency(e.mortgage2EstimatedBalance, !1, "N/A")), 1),
                        t[31] || (t[31] = a("br", null, null, -1)),
                        t[32] || (t[32] = a("span", { class: "estimated-label" }, "Est. Balance", -1))
                      ]),
                      a("div", agt, [
                        a("span", ngt, g(e.percent(e.mortgage2.rate, 2)), 1),
                        t[34] || (t[34] = a("br", null, null, -1)),
                        a("span", rgt, [
                          e.mortgage1.rateEstimated ? (p(), h(A, { key: 0 }, [
                            y(" Est. ")
                          ], 64)) : P("", !0),
                          t[33] || (t[33] = y("Interest Rate "))
                        ])
                      ]),
                      a("div", ogt, [
                        a("span", igt, g(e.currency(e.mortgage2EstimatedPayment, !1, "N/A", !0)), 1),
                        t[35] || (t[35] = a("br", null, null, -1)),
                        t[36] || (t[36] = a("span", { class: "estimated-label" }, "Est. Monthly Payment", -1))
                      ])
                    ])
                  ]),
                  a("div", lgt, [
                    a("div", dgt, [
                      a("table", cgt, [
                        a("tbody", null, [
                          a("tr", null, [
                            t[37] || (t[37] = a("th", null, "Lender Name", -1)),
                            a("td", ugt, g(e.mortgage2.lenderNameFull), 1)
                          ]),
                          a("tr", null, [
                            t[39] || (t[39] = a("th", null, "Lender Address", -1)),
                            a("td", pgt, [
                              y(g(e.mortgage2.lenderAddress), 1),
                              t[38] || (t[38] = a("br", null, null, -1)),
                              y(" " + g(e.mortgage2.lenderCity) + ", " + g(e.mortgage2.lenderState) + " " + g(e.mortgage2.lenderZIP), 1)
                            ])
                          ]),
                          a("tr", null, [
                            t[40] || (t[40] = a("th", null, "Classification", -1)),
                            a("td", hgt, g(e.mortgage2.lenderInfoEntityClassification), 1)
                          ]),
                          a("tr", null, [
                            t[41] || (t[41] = a("th", null, "Lender Info Seller Carry Back", -1)),
                            a("td", mgt, g(e.mortgage2.lenderInfoSellerCarryBack), 1)
                          ])
                        ])
                      ])
                    ])
                  ]),
                  a("div", fgt, [
                    a("div", ggt, [
                      a("table", vgt, [
                        a("tbody", null, [
                          a("tr", null, [
                            t[42] || (t[42] = a("th", null, "Amount", -1)),
                            a("td", ygt, g(e.currency(e.mortgage2.amount)), 1)
                          ]),
                          a("tr", null, [
                            a("th", null, [
                              t[43] || (t[43] = y("Term")),
                              e.mortgage2TermEstimated ? (p(), h("span", bgt, "(Estimated)")) : P("", !0)
                            ]),
                            a("td", Agt, g(e.mortgage2.term), 1)
                          ]),
                          a("tr", null, [
                            t[44] || (t[44] = a("th", null, " Type ", -1)),
                            a("td", wgt, g(e.mortgage2.type), 1)
                          ]),
                          a("tr", null, [
                            t[45] || (t[45] = a("th", null, "Rate Type", -1)),
                            a("td", Cgt, g(e.mortgage2.rateType), 1)
                          ]),
                          a("tr", null, [
                            t[46] || (t[46] = a("th", null, "Recording Date", -1)),
                            a("td", Sgt, g(e.shortDate(e.mortgage2.recordingDate)), 1)
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ])) : P("", !0)
            ], 64)) : P("", !0)
          ])
        ])
      ])
    ], 512)
  ], 64);
}
const kgt = /* @__PURE__ */ Ae($mt, [["render", Pgt]]);
var SE = /* @__PURE__ */ ((e) => (e.OwnerPaid = "ownerPaid", e.ManagerPaid = "managerPaid", e.Combined = "combined", e))(SE || {});
const Egt = me({
  name: "ExpenseLedger",
  enums: {
    ConfirmedPurchaseFacts: Pt,
    ExpenseView: SE
  },
  props: {
    investmentDetails: Boolean
  },
  emits: [
    "update:investmentDetails"
  ],
  components: {
    DataTable: yn,
    Column: bn,
    NumericalInput: Aa,
    DateInput: Ab
  },
  data() {
    return {
      runningTask: 0,
      page: 1,
      pageSize: 25,
      currentView: "ownerPaid",
      editingEntry: !1,
      ledgerEntry: void 0
    };
  },
  watch: {
    async "property.propId"() {
      await this.loadLedger();
    },
    currentView() {
      this.page = 1, this.loadLedger();
    }
  },
  computed: {
    errorMessage() {
      if (this.ledgerErrorMessage)
        return this.ledgerErrorMessage;
    },
    isBusy() {
      return this.runningTask > 0;
    },
    loanPayment() {
      var e, t;
      if (((t = (e = this.purchaseFacts) == null ? void 0 : e.loan) == null ? void 0 : t.interestRate) > 0 && this.purchaseFacts.loan.term > 0 && this.purchaseFacts.loan.amount > 0)
        return pn(
          this.purchaseFacts.loan.interestRate / 12,
          this.purchaseFacts.loan.term * 12,
          this.purchaseFacts.loan.amount
        );
    },
    loanFinalData() {
      var e, t;
      if ((t = (e = this.purchaseFacts) == null ? void 0 : e.loan) != null && t.date && this.purchaseFacts.loan.term > 0)
        return new Date(this.purchaseFacts.loan.date.getFullYear() + this.purchaseFacts.loan.term, this.purchaseFacts.loan.date.getMonth(), this.purchaseFacts.loan.date.getDate());
    },
    askToIncludeExpense() {
      var e, t, s, n;
      return ((t = (e = this.ledgerEntry) == null ? void 0 : e.when) == null ? void 0 : t.getFullYear()) == Et && ((s = this.ledgerEntry) == null ? void 0 : s.categoryType) != ln.PropertyTax && ((n = this.ledgerEntry) == null ? void 0 : n.categoryType) != ln.PropertyInsurance;
    },
    ...q(Te, ["access", "aclLoaded"]),
    ...q(qe, ["purchaseFacts", "property", "accountsLedger", "ledgerErrorMessage", "loadingLedger", "totalLedgerEntries"]),
    ...q(ct, ["expenseAccounts"]),
    ...at(ct, qe)
  },
  methods: {
    currency: Ze,
    number: Ve,
    percent: Wt,
    shortDate: cs,
    date: cs,
    async onPage(e) {
      this.page = e.page + 1, await this.loadLedger();
    },
    getBadgeStyle(e) {
      return {
        badge: !0,
        "text-bg-success": (e & Ar.Synced) == Ar.Synced || (e & Ar.Confirmed) == Ar.Confirmed,
        "text-bg-lava": (e & Ar.Estimated) == Ar.Estimated,
        "bg-secondary": (e & Ar.Calculated) == Ar.Calculated
      };
    },
    hasStatus(e, t) {
      return (e & t) == t;
    },
    editLedger(e) {
      var t;
      e.accountUrl == "loan-payment" ? this.$emit("update:investmentDetails", !0) : (this.editingEntry = !0, this.ledgerEntry = e, this.ledgerEntry.amount = Math.abs(this.ledgerEntry.amount), (t = bootstrap.Modal.getOrCreateInstance(this.$refs.dialogAddOwnerPaid)) == null || t.show());
    },
    showAddLedgerEntry() {
      var e;
      this.editingEntry = !1, this.ledgerEntry = {}, (e = bootstrap.Modal.getOrCreateInstance(this.$refs.dialogAddOwnerPaid)) == null || e.show();
    },
    showInvestmentDetails() {
      this.$emit("update:investmentDetails", !0);
    },
    async loadLedger() {
      this.runningTask++;
      try {
        let e;
        switch (this.currentView) {
          case "managerPaid":
            e = Zp.Synced;
            break;
          case "ownerPaid":
            e = Zp.NotSynced;
            break;
          default:
            e = Zp.All;
            break;
        }
        await this.propertyStore.loadLedger(this.page, this.pageSize, e);
      } catch (e) {
        this.errorMessage = e.message;
      }
      this.runningTask--;
    },
    async addUpdateEntry() {
      var e;
      this.runningTask++;
      try {
        const t = {
          amount: this.ledgerEntry.amount,
          description: this.ledgerEntry.description,
          when: this.ledgerEntry.when,
          includeInExpenses: this.ledgerEntry.includeInExpenses
        };
        await this.propertyStore.addLedgerEntry(this.ledgerEntry.accountUrl, t), await this.loadLedger(), await this.propertyStore.updateMpod(), (e = bootstrap.Modal.getOrCreateInstance(this.$refs.dialogAddOwnerPaid)) == null || e.hide();
      } catch (t) {
        (!Zt.isModelStateException(t) || !t.showFormErrors(this.$refs.dialogAddOwnerPaid)) && Se(t);
      }
      this.runningTask--;
    },
    confirmDeleteEntry(e) {
      var t;
      this.ledgerEntry = e, (t = bootstrap.Modal.getOrCreateInstance(this.$refs.dialogDeleteLedger)) == null || t.show();
    },
    async deleteEntry() {
      var e;
      this.runningTask++;
      try {
        await this.propertyStore.deleteLedgerEntry(this.ledgerEntry.accountUrl, this.ledgerEntry.id), await this.loadLedger(), await this.propertyStore.updateMpod();
      } catch (t) {
        Se(t);
      }
      (e = bootstrap.Modal.getOrCreateInstance(this.$refs.dialogDeleteLedger)) == null || e.hide(), this.runningTask--;
    },
    async confirmEntry() {
      var e;
      this.runningTask++;
      try {
        const t = {
          amount: this.ledgerEntry.amount,
          description: this.ledgerEntry.description,
          when: this.ledgerEntry.when,
          includeInExpenses: this.ledgerEntry.includeInExpenses
        };
        await this.propertyStore.confirmEntry(this.ledgerEntry.accountUrl, this.ledgerEntry.id, t) == !0 && (this.ledgerEntry.status &= ~Ar.Estimated, this.ledgerEntry.status |= Ar.Confirmed, await this.propertyStore.updateMpod());
      } catch (t) {
        Se(t);
      }
      (e = bootstrap.Modal.getOrCreateInstance(this.$refs.dialogAddOwnerPaid)) == null || e.hide(), this.runningTask--;
    },
    showButtons(e) {
      return this.currentView == "ownerPaid" && !(e.accountUrl == "loan-payment" && this.hasStatus(e.status, 8) == !0);
    },
    findCategory(e) {
      var t;
      return e.accountUrl == "loan-payment" ? "Loan Payment" : (t = this.expenseAccounts.find((s) => s.nameUrl == e.accountUrl)) == null ? void 0 : t.name;
    },
    isConfirmed(e) {
      return this.propertyStore.isConfirmed(e);
    }
  },
  mounted() {
    this.aclLoaded.then(async () => await this.accountStore.fetchIncomeExpenseAccounts()).then(async () => await this.loadLedger()).then(() => {
      Hr("L", () => {
        this.currentView = "managerPaid";
      }, !0, !0, !0);
    });
  }
}), Igt = { class: "container" }, Tgt = { class: "row" }, Ogt = { class: "col" }, Rgt = { class: "bg-light d-flex justify-content-center mb-3 rounded gap-3 p-3" }, Lgt = ["value", "disabled"], Bgt = {
  key: 0,
  class: "row mb-3"
}, Mgt = { class: "col-lg-3 text-center text-lg-end" }, xgt = ["disabled"], Fgt = {
  key: 1,
  class: "alert alert-danger",
  role: "alert"
}, Vgt = {
  key: 2,
  class: "card bg-light mb-3"
}, Dgt = { class: "card-body" }, Ngt = { class: "row text-center" }, jgt = { class: "col align-items-center d-flex justify-content-center" }, Hgt = { class: "col align-items-center d-flex justify-content-center" }, Ugt = { class: "col" }, zgt = ["disabled"], Wgt = { class: "card shadow-sm" }, Ggt = ["onClick", "disabled"], Ygt = ["onClick", "disabled"], Xgt = {
  class: "modal fade",
  ref: "dialogAddOwnerPaid",
  id: "dialogAddOwnerPaid",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false",
  tabindex: "-1",
  "aria-labelledby": "dialogAddOwnerPaidLabel",
  "aria-hidden": "true"
}, qgt = { class: "modal-dialog modal-lg modal-dialog-centered" }, Qgt = { class: "modal-content bg-gradient-alphabet rounded" }, Kgt = { class: "modal-header border-0 pb-0" }, Zgt = {
  class: "fs-5 modal-title fw-bold",
  id: "dialogAddOwnerPaidLabel"
}, Jgt = ["disabled"], $gt = { class: "modal-body" }, _gt = {
  key: 0,
  class: "row g-3"
}, evt = { class: "col-sm-8" }, tvt = { class: "form-control-plaintext" }, svt = { class: "col-sm-8" }, avt = ["disabled"], nvt = ["value"], rvt = { class: "col-sm-8" }, ovt = ["disabled"], ivt = { class: "col-sm-4" }, lvt = { class: "col-sm-4" }, dvt = {
  key: 0,
  class: "alert alert-info mb-0"
}, cvt = { class: "row align-items-center" }, uvt = { class: "col-sm-2 justify-content-sm-end d-flex justify-content-center" }, pvt = { class: "form-check form-switch form-switch-lg form-switch-basic" }, hvt = { class: "modal-footer border-0 pt-0" }, mvt = ["disabled"], fvt = ["disabled"], gvt = ["disabled"], vvt = {
  class: "modal fade",
  id: "dialogDeleteLedger",
  ref: "dialogDeleteLedger",
  tabindex: "-1",
  "aria-labelledby": "dialogDeleteLedgerLabel",
  "aria-hidden": "true"
}, yvt = { class: "modal-dialog modal-dialog-centered" }, bvt = { class: "modal-content bg-gradient-alphabet rounded" }, Avt = { class: "modal-body text-center px-5 pb-5 pt-0 d-flex flex-column align-items-center justify-content-center" }, wvt = ["disabled"];
function Cvt(e, t, s, n, r, i) {
  var u, m, f, v, b, w, S, I;
  const o = pe("Column"), l = pe("data-table"), d = pe("date-input"), c = pe("numerical-input");
  return p(), h(A, null, [
    a("div", Igt, [
      a("div", Tgt, [
        a("div", Ogt, [
          t[22] || (t[22] = a("h2", { class: "fw-bold fs-5 mb-3" }, "Ledger", -1)),
          a("div", Rgt, [
            V(a("input", {
              type: "radio",
              class: "btn-check",
              name: "currentViewOptions",
              id: "btncheck1",
              autocomplete: "off",
              value: e.ExpenseView.OwnerPaid,
              "onUpdate:modelValue": t[0] || (t[0] = (T) => e.currentView = T),
              disabled: e.isBusy
            }, null, 8, Lgt), [
              [Mt, e.currentView]
            ]),
            t[12] || (t[12] = a("label", {
              class: "btn btn-outline-eclipse no-anim",
              for: "btncheck1"
            }, "Owner-Paid Expenses", -1))
          ]),
          e.currentView == "ownerPaid" ? (p(), h("div", Bgt, [
            t[14] || (t[14] = a("div", { class: "col" }, [
              a("p", { class: "m-0" }, "The ledger below details estimated expenses not handled by the Property Manager but by the property owner instead. These include additional payments made outside of loans details. Please review each item to confirm, edit, or delete as necessary, ensuring all expenses are marked as confirmed.")
            ], -1)),
            a("div", Mgt, [
              a("button", {
                type: "button",
                class: "btn btn-accent-glass",
                onClick: t[1] || (t[1] = (...T) => e.showAddLedgerEntry && e.showAddLedgerEntry(...T)),
                disabled: e.isBusy
              }, t[13] || (t[13] = [
                a("i", { class: "fa-light fa-plus me-2" }, null, -1),
                y(" Add Owner-Paid Expense")
              ]), 8, xgt)
            ])
          ])) : P("", !0),
          e.errorMessage ? (p(), h("div", Fgt, g(e.errorMessage), 1)) : P("", !0),
          e.currentView == "ownerPaid" && e.purchaseFacts.hasCurrentLoan ? (p(), h("div", Vgt, [
            a("div", Dgt, [
              a("div", Ngt, [
                a("div", jgt, [
                  a("div", null, [
                    t[15] || (t[15] = a("b", null, "Recurring Loan Payment:", -1)),
                    y(" " + g(e.currency(e.loanPayment, 0, "N/A")), 1)
                  ])
                ]),
                a("div", Hgt, [
                  a("div", null, [
                    t[16] || (t[16] = a("b", null, "Repeats monthly until:", -1)),
                    y(" " + g(e.date(e.loanFinalData, !1, "N/A")), 1)
                  ])
                ]),
                a("div", Ugt, [
                  e.isConfirmed(e.ConfirmedPurchaseFacts.LoanInfo) ? P("", !0) : (p(), h("button", {
                    key: 0,
                    type: "button",
                    class: "btn btn-sm btn-outline-eclipse",
                    onClick: t[2] || (t[2] = (...T) => e.showInvestmentDetails && e.showInvestmentDetails(...T)),
                    disabled: e.isBusy
                  }, t[17] || (t[17] = [
                    a("i", { class: "fa-light fa-pencil me-1" }, null, -1),
                    y("Review")
                  ]), 8, zgt))
                ])
              ])
            ])
          ])) : P("", !0),
          a("div", Wgt, [
            N(l, {
              value: e.accountsLedger,
              lazy: !0,
              class: "p-datatable",
              paginator: "",
              rows: e.pageSize,
              dataKey: "id",
              totalRecords: e.totalLedgerEntries,
              loading: e.isBusy,
              paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
              rowsPerPageOptions: [10, 25, 50],
              currentPageReportTemplate: "Showing {first} to {last} of {totalRecords} entries",
              onPage: t[3] || (t[3] = (T) => e.onPage(T))
            }, {
              empty: ve(() => t[18] || (t[18] = [
                y(" No ledger entries found. ")
              ])),
              loading: ve(() => t[19] || (t[19] = [
                a("div", { class: "bg-accentgreenblue rounded-pill px-3 py-1 text-white" }, [
                  a("span", {
                    class: "spinner-border spinner-border-sm me-2",
                    role: "status",
                    "aria-hidden": "false"
                  }),
                  y("Retrieving ledger entries. Please wait... ")
                ], -1)
              ])),
              default: ve(() => [
                N(o, { header: "Date" }, {
                  body: ve((T) => [
                    y(g(e.shortDate(T.data.when)), 1)
                  ]),
                  _: 1
                }),
                N(o, {
                  header: "Description",
                  style: { "max-width": "300px" },
                  class: "text-truncate"
                }, {
                  body: ve((T) => [
                    y(g(T.data.description), 1)
                  ]),
                  _: 1
                }),
                N(o, { header: "Expense Category" }, {
                  body: ve((T) => [
                    y(g(e.findCategory(T.data)), 1)
                  ]),
                  _: 1
                }),
                N(o, { header: "Status" }, {
                  body: ve((T) => [
                    a("span", {
                      class: z(e.getBadgeStyle(T.data.status))
                    }, [
                      e.hasStatus(T.data.status, 1) ? (p(), h(A, { key: 0 }, [
                        y(" Confirmed ")
                      ], 64)) : e.hasStatus(T.data.status, 2) ? (p(), h(A, { key: 1 }, [
                        y(" Synced ")
                      ], 64)) : e.hasStatus(T.data.status, 4) ? (p(), h(A, { key: 2 }, [
                        y(" Estimated ")
                      ], 64)) : e.hasStatus(T.data.status, 8) ? (p(), h(A, { key: 3 }, [
                        y(" Calculated ")
                      ], 64)) : P("", !0)
                    ], 2)
                  ]),
                  _: 1
                }),
                N(o, {
                  header: "Amount",
                  class: "text-end",
                  hidden: e.currentView != e.ExpenseView.OwnerPaid
                }, {
                  body: ve((T) => [
                    y(g(e.currency(T.data.amount, !0, "-", !0)), 1)
                  ]),
                  _: 1
                }, 8, ["hidden"]),
                N(o, {
                  header: "Debit",
                  class: "text-end",
                  hidden: e.currentView == e.ExpenseView.OwnerPaid
                }, {
                  body: ve((T) => [
                    y(g(e.currency(T.data.debit, !0, "-", !0)), 1)
                  ]),
                  _: 1
                }, 8, ["hidden"]),
                N(o, {
                  header: "Credit",
                  class: "text-end",
                  hidden: e.currentView == e.ExpenseView.OwnerPaid
                }, {
                  body: ve((T) => [
                    y(g(e.currency(T.data.credit, !0, "-", !0)), 1)
                  ]),
                  _: 1
                }, 8, ["hidden"]),
                N(o, {
                  header: "Balance",
                  class: "text-end",
                  hidden: e.currentView == e.ExpenseView.OwnerPaid
                }, {
                  body: ve((T) => [
                    y(g(e.currency(T.data.balance, !0, "-", !0)), 1)
                  ]),
                  _: 1
                }, 8, ["hidden"]),
                N(o, {
                  hidden: e.currentView != "ownerPaid"
                }, {
                  body: ve((T) => [
                    e.showButtons(T.data) ? (p(), h(A, { key: 0 }, [
                      a("button", {
                        type: "button",
                        class: "btn btn-sm btn-outline-eclipse",
                        onClick: (x) => e.editLedger(T.data),
                        disabled: e.isBusy
                      }, t[20] || (t[20] = [
                        a("i", { class: "fa-light fa-pencil me-1" }, null, -1),
                        y("Review")
                      ]), 8, Ggt),
                      a("button", {
                        type: "button",
                        class: "btn btn-sm btn-outline-danger ms-2",
                        onClick: (x) => e.confirmDeleteEntry(T.data),
                        disabled: e.isBusy
                      }, t[21] || (t[21] = [
                        a("i", { class: "fa-light fa-trash-can" }, null, -1)
                      ]), 8, Ygt)
                    ], 64)) : P("", !0)
                  ]),
                  _: 1
                }, 8, ["hidden"])
              ]),
              _: 1
            }, 8, ["value", "rows", "totalRecords", "loading"])
          ])
        ])
      ])
    ]),
    a("div", Xgt, [
      a("div", qgt, [
        a("div", Qgt, [
          a("div", Kgt, [
            a("p", Zgt, [
              e.editingEntry ? (p(), h(A, { key: 0 }, [
                y(" Edit ")
              ], 64)) : (p(), h(A, { key: 1 }, [
                y(" Add ")
              ], 64)),
              t[23] || (t[23] = y(" Owner-Paid Expense "))
            ]),
            a("button", {
              type: "button",
              class: "btn-close",
              "data-bs-toggle": "modal",
              "data-bs-target": "#dialogAddOwnerPaid",
              "aria-label": "Close",
              disabled: e.isBusy
            }, null, 8, Jgt)
          ]),
          a("div", $gt, [
            e.ledgerEntry ? (p(), h("div", _gt, [
              t[26] || (t[26] = a("label", { class: "col-sm-4 col-form-label" }, "Property", -1)),
              a("div", evt, [
                a("span", tvt, g((m = (u = e.property) == null ? void 0 : u.address) == null ? void 0 : m.street) + ", " + g((v = (f = e.property) == null ? void 0 : f.address) == null ? void 0 : v.city) + ", " + g((w = (b = e.property) == null ? void 0 : b.address) == null ? void 0 : w.state) + " " + g((I = (S = e.property) == null ? void 0 : S.address) == null ? void 0 : I.zip), 1)
              ]),
              t[27] || (t[27] = a("label", { class: "col-sm-4 col-form-label" }, "Expense Category", -1)),
              a("div", svt, [
                V(a("select", {
                  id: "accountUrl",
                  class: "form-select",
                  "onUpdate:modelValue": t[4] || (t[4] = (T) => e.ledgerEntry.accountUrl = T),
                  disabled: e.isBusy
                }, [
                  (p(!0), h(A, null, D(e.expenseAccounts, (T) => (p(), h("option", {
                    key: T.nameUrl,
                    value: T.nameUrl
                  }, g(T.name), 9, nvt))), 128))
                ], 8, avt), [
                  [We, e.ledgerEntry.accountUrl]
                ])
              ]),
              t[28] || (t[28] = a("label", { class: "col-sm-4 col-form-label" }, "Description", -1)),
              a("div", rvt, [
                V(a("input", {
                  id: "description",
                  type: "text",
                  class: "form-control",
                  "onUpdate:modelValue": t[5] || (t[5] = (T) => e.ledgerEntry.description = T),
                  disabled: e.isBusy
                }, null, 8, ovt), [
                  [_e, e.ledgerEntry.description]
                ])
              ]),
              t[29] || (t[29] = a("label", { class: "col-sm-4 col-form-label" }, "Date / Amount", -1)),
              a("div", ivt, [
                N(d, {
                  id: "when",
                  modelValue: e.ledgerEntry.when,
                  "onUpdate:modelValue": t[6] || (t[6] = (T) => e.ledgerEntry.when = T),
                  "allow-empty": "",
                  class: "text-end",
                  disabled: e.isBusy
                }, null, 8, ["modelValue", "disabled"])
              ]),
              a("div", lvt, [
                N(c, {
                  currency: "",
                  modelValue: e.ledgerEntry.amount,
                  "onUpdate:modelValue": t[7] || (t[7] = (T) => e.ledgerEntry.amount = T),
                  disabled: e.isBusy
                }, null, 8, ["modelValue", "disabled"])
              ]),
              e.askToIncludeExpense ? (p(), h("div", dvt, [
                a("div", cvt, [
                  t[25] || (t[25] = a("label", {
                    class: "form-check-label col text-center text-sm-start mb-2 mb-sm-0",
                    for: "includeInExpenses"
                  }, " Do you want to include this expense in addition to the estimated expenses for this year? ", -1)),
                  a("div", uvt, [
                    a("div", pvt, [
                      V(a("input", {
                        class: "form-check-input",
                        type: "checkbox",
                        role: "switch",
                        id: "includeInExpenses",
                        "onUpdate:modelValue": t[8] || (t[8] = (T) => e.ledgerEntry.includeInExpenses = T)
                      }, null, 512), [
                        [Ue, e.ledgerEntry.includeInExpenses]
                      ]),
                      t[24] || (t[24] = a("label", {
                        class: "form-check-label",
                        for: "includeInExpenses"
                      }, [
                        y("Yes"),
                        a("span", null, "No")
                      ], -1))
                    ])
                  ])
                ])
              ])) : P("", !0)
            ])) : P("", !0)
          ]),
          a("div", hvt, [
            a("button", {
              type: "button",
              class: "btn btn-secondary",
              "data-bs-toggle": "modal",
              "data-bs-target": "#dialogAddOwnerPaid",
              disabled: e.isBusy
            }, "Cancel", 8, mvt),
            e.editingEntry ? (p(), h("button", {
              key: 0,
              type: "button",
              class: "btn btn-success ms-auto",
              onClick: t[9] || (t[9] = (...T) => e.confirmEntry && e.confirmEntry(...T)),
              disabled: e.isBusy
            }, "Confirm", 8, fvt)) : (p(), h("button", {
              key: 1,
              type: "button",
              class: "btn btn-success ms-auto",
              onClick: t[10] || (t[10] = (...T) => e.addUpdateEntry && e.addUpdateEntry(...T)),
              disabled: e.isBusy
            }, "Add", 8, gvt))
          ])
        ])
      ])
    ], 512),
    a("div", vvt, [
      a("div", yvt, [
        a("div", bvt, [
          t[33] || (t[33] = a("div", { class: "modal-header border-0 pb-0" }, [
            a("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            })
          ], -1)),
          a("div", Avt, [
            t[30] || (t[30] = a("span", { class: "bg-danger rounded-circle mb-4 p-3 text-white" }, [
              a("i", { class: "fa-light fa-trash-can fa-2xl" })
            ], -1)),
            t[31] || (t[31] = a("p", { class: "fw-bold fs-4 mb-0" }, "Are you sure?", -1)),
            t[32] || (t[32] = a("p", { class: "mb-5" }, "Are you sure you want to delete this expense? This action cannot be undone.", -1)),
            a("button", {
              onClick: t[11] || (t[11] = (...T) => e.deleteEntry && e.deleteEntry(...T)),
              id: "card-button",
              disabled: e.isBusy,
              class: "btn btn-danger"
            }, " Delete Expense ", 8, wvt)
          ])
        ])
      ])
    ], 512)
  ], 64);
}
const nds = /* @__PURE__ */ Ae(Egt, [["render", Cvt]]), Svt = me({
  name: "IncomeAccounts",
  props: {
    loading: Boolean
  },
  emits: [
    "change"
  ],
  components: {
    NumericalInput: Aa
  },
  data() {
    return {
      editing: !1,
      origUnit: void 0,
      newUnit: {
        name: void 0,
        quantity: 0,
        rentalRate: 0,
        strRentalRate: 0
      },
      modalError: void 0,
      validationErrors: {}
    };
  },
  computed: {
    componentBusy() {
      return this.loading || this.calculating;
    },
    componentBusyAdvanced() {
      return this.loading || this.calculating || this.hasAdvanced != !0;
    },
    cardStyle() {
      return {
        "card-error": this.hasUnitErrors
      };
    },
    modalValidationErrors() {
      var t;
      const e = {};
      return ((t = this.propertyUnits) == null ? void 0 : t.filter((s) => s.name == this.newUnit.name).length) > 1 && (e.UnitName = ["Unit with same name alreday exists"]), e;
    },
    globalValidationErrors() {
      return {
        ...this.validationErrors,
        ...this.modalValidationErrors
      };
    },
    hasModalErrors() {
      return this.modalValidationErrors && Object.keys(this.modalValidationErrors).length > 0;
    },
    hasErrors() {
      return this.globalValidationErrors && Object.keys(this.globalValidationErrors).length > 0;
    },
    isCommercial() {
      var e;
      return ((e = this.property) == null ? void 0 : e.propertyType) == Qa.Commercial;
    },
    isSingle() {
      var e;
      return ((e = this.property) == null ? void 0 : e.propertyType) == Qa.SingleFamily;
    },
    allowEmptyParams() {
      var e, t;
      return this.isExistingInvestment == !0 && ((t = (e = this.purchaseFacts) == null ? void 0 : e.years) == null ? void 0 : t.length) > 0;
    },
    compareLongTerm: {
      get() {
        var e;
        return (((e = this.calcParams) == null ? void 0 : e.rentalTypeComparisons) & nt.LongTerm) == nt.LongTerm;
      },
      set(e) {
        e ? this.calcParams.rentalTypeComparisons |= nt.LongTerm : this.calcParams.rentalTypeComparisons &= ~nt.LongTerm;
      }
    },
    compareShortTerm: {
      get() {
        var e;
        return (((e = this.calcParams) == null ? void 0 : e.rentalTypeComparisons) & nt.ShortTerm) == nt.ShortTerm;
      },
      set(e) {
        e ? this.calcParams.rentalTypeComparisons |= nt.ShortTerm : this.calcParams.rentalTypeComparisons &= ~nt.ShortTerm;
      }
    },
    comparePadSplit: {
      get() {
        var e;
        return (((e = this.calcParams) == null ? void 0 : e.rentalTypeComparisons) & nt.PadSplit) == nt.PadSplit;
      },
      set(e) {
        e ? this.calcParams.rentalTypeComparisons |= nt.PadSplit : this.calcParams.rentalTypeComparisons &= ~nt.PadSplit;
      }
    },
    ...q(Te, ["access", "hasAdvanced", "canOtherAnalysisStyles"]),
    ...q(qe, [
      "propertyUnits",
      "calcParams",
      "calcParamsOrig",
      "property",
      "unitsTotalRentalRate",
      "unitsStrTotalRentalRate",
      "totalUnitsAdded",
      "totalUnitsRequired",
      "hasUnitErrors",
      "calculating",
      "rentalTypes",
      "isExistingInvestment",
      "purchaseFacts"
    ]),
    ...q(ct, ["otherIncomeAccounts"]),
    ...q(Ci, ["notifications"]),
    ...at(Te, qe)
  },
  methods: {
    number: Ve,
    currency: Ze,
    showAddModal() {
      var e;
      this.modalError = void 0, (e = bootstrap.Modal.getOrCreateInstance(this.$refs.modalUnit)) == null || e.show();
    },
    editUnit(e) {
      this.editing = !0, this.origUnit = { ...e }, this.newUnit = e, this.showAddModal();
    },
    addNew() {
      var e;
      if (this.modalError = void 0, this.editing)
        this.editing = !1, this.detectChange();
      else
        try {
          this.propertyStore.addUnit(this.newUnit);
        } catch (t) {
          this.modalError = t.message;
        }
      this.newUnit = {
        name: void 0,
        quantity: 0,
        rentalRate: 0,
        strRentalRate: 0
      }, (e = bootstrap.Modal.getOrCreateInstance(this.$refs.modalUnit)) == null || e.hide();
    },
    removeUnit() {
      this.propertyStore.removeUnit(this.newUnit);
    },
    cancelAddEdit() {
      var e;
      this.origUnit && (this.newUnit.name = this.origUnit.name, this.newUnit.quantity = this.origUnit.quantity, this.newUnit.rentalRate = this.origUnit.rentalRate, this.newUnit.strRentalRate = this.origUnit.strRentalRate, this.origUnit = void 0), (e = bootstrap.Modal.getOrCreateInstance(this.$refs.modalUnit)) == null || e.hide();
    },
    detectChange() {
      this.$emit("change");
    },
    //#region Form Validation
    checkValid(e) {
      return {
        "invalid-feedback": this.globalValidationErrors[e]
      };
    },
    checkValidForm(e) {
      return {
        "is-invalid": this.globalValidationErrors[e]
      };
    },
    errorMessage(e) {
      return this.globalValidationErrors[e].join(" ");
    },
    //#endregion
    accountHasError(e) {
      var t;
      return (t = this.notifications) == null ? void 0 : t.some((s) => pi(s.eventId) && s.properties && s.properties.accountId == e.id);
    },
    showCompareDialog() {
      var e;
      (e = bootstrap.Modal.getOrCreateInstance(this.$refs.dialogCompare)) == null || e.show();
    }
  },
  created() {
  },
  mounted() {
  }
}), Pvt = { class: "d-flex justify-content-between align-items-center mb-3" }, kvt = ["disabled"], Evt = {
  key: 0,
  class: "table-income"
}, Ivt = { class: "table table-sm table-fixed mb-0" }, Tvt = {
  scope: "col",
  class: "table-column-description border-end"
}, Ovt = { class: "d-flex" }, Rvt = {
  key: 0,
  class: "ms-auto"
}, Lvt = { key: 3 }, Bvt = {
  key: 0,
  scope: "col",
  class: "bg-alice border-start border-bottom-0"
}, Mvt = { key: 0 }, xvt = { class: "border-end bg-transparent" }, Fvt = {
  key: 2,
  class: "d-flex gap-2"
}, Vvt = ["rowspan"], Dvt = ["disabled"], Nvt = { class: "align-middle border-end" }, jvt = { class: "d-flex justify-content-between" }, Hvt = {
  class: "text-truncate d-inline-block lh-1",
  style: { width: "135px" }
}, Uvt = ["onClick"], zvt = { key: 0 }, Wvt = { class: "border-end bg-transparent" }, Gvt = {
  key: 2,
  class: "d-flex gap-2"
}, Yvt = ["rowspan"], Xvt = ["disabled"], qvt = { key: 2 }, Qvt = {
  scope: "row",
  class: "align-middle border-end"
}, Kvt = { class: "d-flex" }, Zvt = {
  key: 0,
  class: "ms-2 flex-shrink-0"
}, Jvt = { class: "text-danger" }, $vt = { class: "text-end border-end" }, _vt = { key: 0 }, eyt = ["colspan"], tyt = {
  key: 0,
  class: "d-flex"
}, syt = {
  key: 1,
  class: "d-flex"
}, ayt = {
  key: 2,
  class: "d-flex"
}, nyt = { class: "align-middle border-end" }, ryt = { class: "border-end bg-transparent" }, oyt = {
  key: 0,
  class: "d-flex"
}, iyt = {
  key: 1,
  class: "d-flex"
}, lyt = {
  key: 2,
  class: "d-flex"
}, dyt = {
  ref: "modalUnit",
  class: "modal fade",
  id: "modalUnit",
  tabindex: "-1",
  "aria-labelledby": "modalUnitLabel",
  "aria-hidden": "true"
}, cyt = { class: "modal-dialog dialog-sm modal-dialog-centered" }, uyt = { class: "modal-content bg-gradient-alphabet rounded" }, pyt = { class: "modal-header border-0" }, hyt = {
  class: "modal-title fs-5 fw-bold",
  id: "modalUnitLabel"
}, myt = { class: "modal-body" }, fyt = {
  key: 0,
  class: "alert alert-warning m-0 slide-down",
  role: "alert"
}, gyt = { class: "bg-light rounded p-2 mb-3" }, vyt = { class: "row" }, yyt = { class: "col-6" }, byt = { class: "col-6 text-end" }, Ayt = {
  key: 0,
  class: "form-control-plaintext"
}, wyt = { class: "table table-sm mb-0" }, Cyt = { class: "bg-transparent" }, Syt = { class: "text-end bg-transparent" }, Pyt = {
  key: 0,
  class: "form-control-plaintext"
}, kyt = {
  key: 1,
  class: "form-control-plaintext"
}, Eyt = { class: "modal-footer d-flex border-0" }, Iyt = ["disabled"], Tyt = {
  ref: "dialogCompare",
  class: "modal fade",
  id: "dialogCompare",
  tabindex: "-1",
  "aria-labelledby": "dialogCompareLabel",
  "aria-hidden": "true"
}, Oyt = { class: "modal-dialog modal-dialog-centered" }, Ryt = { class: "modal-content bg-gradient-alphabet rounded" }, Lyt = { class: "modal-body py-5" }, Byt = { class: "row" }, Myt = { class: "col-lg-7 d-flex gap-2" }, xyt = {
  key: 0,
  class: "form-check form-check-inline"
}, Fyt = {
  key: 1,
  class: "form-check form-check-inline"
}, Vyt = {
  key: 2,
  class: "form-check form-check-inline"
}, Dyt = {
  key: 1,
  class: "modal-body p-8 text-center bg-gradient-periwinkle rounded"
};
function Nyt(e, t, s, n, r, i) {
  var l, d, c;
  const o = pe("numerical-input");
  return p(), h(A, null, [
    a("div", Pvt, [
      t[22] || (t[22] = a("span", { class: "fw-bold fs-5" }, "Income", -1)),
      e.totalUnitsAdded < e.totalUnitsRequired ? (p(), h("button", {
        key: 0,
        type: "button",
        class: "btn btn-lava btn-sm",
        onClick: t[0] || (t[0] = (...u) => e.showAddModal && e.showAddModal(...u)),
        disabled: e.componentBusy
      }, t[21] || (t[21] = [
        a("i", { class: "fa-light fa-plus me-2" }, null, -1),
        y("Add Unit ")
      ]), 8, kvt)) : P("", !0)
    ]),
    a("div", {
      class: z(["card shadow-sm card-price-loan unit-data-multi overflow-hidden", e.cardStyle])
    }, [
      e.calcParams ? (p(), h("div", Evt, [
        a("table", Ivt, [
          t[45] || (t[45] = a("colgroup", null, [
            a("col"),
            a("col", { class: "bg-body-secondary" }),
            a("col"),
            a("col", { class: "bg-body-secondary" })
          ], -1)),
          a("thead", null, [
            a("tr", null, [
              a("th", Tvt, [
                a("div", Ovt, [
                  t[23] || (t[23] = a("span", null, "Name", -1)),
                  e.isCommercial ? (p(), h("span", Rvt, "Qty")) : P("", !0)
                ])
              ]),
              (p(!0), h(A, null, D(e.rentalTypes, (u) => (p(), h("th", {
                scope: "col",
                class: z(["text-center bg-transparent border-end", "table-column-" + u])
              }, [
                e.isCommercial ? (p(), h(A, { key: 0 }, [
                  y(" Rental Rate ")
                ], 64)) : u == "long-term" ? (p(), h(A, { key: 1 }, [
                  t[24] || (t[24] = a("i", { class: "fa-light fa-calendar-range me-2" }, null, -1)),
                  t[25] || (t[25] = y("Long Term ")),
                  t[26] || (t[26] = a("br", null, null, -1)),
                  t[27] || (t[27] = a("small", { class: "text-body-tertiary" }, "Monthly Rate", -1))
                ], 64)) : P("", !0),
                u == "short-term" ? (p(), h(A, { key: 2 }, [
                  t[28] || (t[28] = a("i", { class: "fa-light fa-timer me-2" }, null, -1)),
                  t[29] || (t[29] = y("Short Term ")),
                  t[30] || (t[30] = a("br", null, null, -1)),
                  t[31] || (t[31] = a("small", { class: "text-body-tertiary" }, "Average Nightly Rate", -1))
                ], 64)) : P("", !0),
                u == "pad-split" && !e.isCommercial ? (p(), h("div", Lvt, t[32] || (t[32] = [
                  a("div", null, [
                    a("img", {
                      src: nn,
                      alt: "PadSplit",
                      title: "PadSplit",
                      loading: "lazy",
                      class: "img-fluid",
                      width: "85"
                    })
                  ], -1),
                  a("div", { class: "d-flex gap-2 fw-bold" }, [
                    a("div", { class: "w-30" }, [
                      a("small", null, "Rooms")
                    ]),
                    a("div", null, [
                      a("small", null, "Avg Weekly Rate")
                    ])
                  ], -1)
                ]))) : P("", !0)
              ], 2))), 256)),
              e.rentalTypes.length < 2 ? (p(), h("th", Bvt)) : P("", !0)
            ])
          ]),
          a("tbody", null, [
            e.isSingle ? (p(), h("tr", Mvt, [
              t[35] || (t[35] = a("th", {
                scope: "row",
                class: "align-middle border-end"
              }, [
                a("span", { class: "text-truncate d-inline-block lh-1" }, "Rental Income")
              ], -1)),
              (p(!0), h(A, null, D(e.rentalTypes, (u) => {
                var m, f, v, b;
                return p(), h("td", xvt, [
                  u == "long-term" ? (p(), Fe(o, {
                    key: 0,
                    currency: "",
                    type: "text",
                    class: "form-control",
                    modelValue: e.calcParams.monthlyRentalYear1,
                    "onUpdate:modelValue": t[1] || (t[1] = (w) => e.calcParams.monthlyRentalYear1 = w),
                    "orignal-value": (m = e.calcParamsOrig) == null ? void 0 : m.monthlyRentalYear1,
                    onChange: e.detectChange,
                    disabled: e.componentBusy
                  }, null, 8, ["modelValue", "orignal-value", "onChange", "disabled"])) : u == "short-term" ? (p(), Fe(o, {
                    key: 1,
                    currency: "",
                    type: "text",
                    class: "form-control",
                    modelValue: e.calcParams.strRentalRate,
                    "onUpdate:modelValue": t[2] || (t[2] = (w) => e.calcParams.strRentalRate = w),
                    "orignal-value": (f = e.calcParamsOrig) == null ? void 0 : f.strRentalRate,
                    onChange: e.detectChange,
                    disabled: e.componentBusyAdvanced
                  }, null, 8, ["modelValue", "orignal-value", "onChange", "disabled"])) : P("", !0),
                  u == "pad-split" && !e.isCommercial ? (p(), h("div", Fvt, [
                    N(o, {
                      type: "text",
                      class: "form-control w-30",
                      modelValue: e.calcParams.padSplitRooms,
                      "onUpdate:modelValue": t[3] || (t[3] = (w) => e.calcParams.padSplitRooms = w),
                      "orignal-value": (v = e.calcParamsOrig) == null ? void 0 : v.padSplitRooms,
                      onChange: e.detectChange,
                      disabled: e.componentBusyAdvanced
                    }, null, 8, ["modelValue", "orignal-value", "onChange", "disabled"]),
                    N(o, {
                      type: "text",
                      class: "form-control",
                      currency: "",
                      modelValue: e.calcParams.padSplitRentalRate,
                      "onUpdate:modelValue": t[4] || (t[4] = (w) => e.calcParams.padSplitRentalRate = w),
                      "orignal-value": (b = e.calcParamsOrig) == null ? void 0 : b.padSplitRentalRate,
                      onChange: e.detectChange,
                      disabled: e.componentBusyAdvanced
                    }, null, 8, ["modelValue", "orignal-value", "onChange", "disabled"])
                  ])) : P("", !0)
                ]);
              }), 256)),
              e.rentalTypes.length < 2 ? (p(), h("td", {
                key: 0,
                rowspan: 3 + e.otherIncomeAccounts.length,
                class: "bg-alice align-middle text-center px-5 py-3 border-start"
              }, [
                a("button", {
                  type: "button",
                  class: "btn btn-lava mb-4",
                  onClick: t[5] || (t[5] = (...u) => e.showCompareDialog && e.showCompareDialog(...u)),
                  disabled: e.componentBusy
                }, t[33] || (t[33] = [
                  a("i", { class: "fa-light fa-plus me-1" }, null, -1),
                  y("Add Analysis Style ")
                ]), 8, Dvt),
                t[34] || (t[34] = a("p", { class: "mb-0" }, "Compare the performance of multiple analysis syltes by adding an additional analysis style. Options include long term, short term and PadSplit.", -1))
              ], 8, Vvt)) : P("", !0)
            ])) : (p(!0), h(A, { key: 1 }, D(e.propertyUnits, (u, m) => (p(), h("tr", {
              scope: "row",
              key: u.name
            }, [
              a("td", Nvt, [
                a("div", jvt, [
                  a("span", Hvt, g(u.name), 1),
                  a("button", {
                    type: "button",
                    class: "btn btn-white p-0 mb-2 ms-2",
                    onClick: (f) => e.editUnit(u)
                  }, t[36] || (t[36] = [
                    a("i", { class: "fa-light fa-pen-to-square" }, null, -1)
                  ]), 8, Uvt),
                  e.isCommercial ? (p(), h("span", zvt, g(u.quantity), 1)) : P("", !0)
                ])
              ]),
              (p(!0), h(A, null, D(e.rentalTypes, (f) => (p(), h("td", Wvt, [
                f == "long-term" ? (p(), Fe(o, {
                  key: 0,
                  currency: "",
                  modelValue: u.rentalRate,
                  "onUpdate:modelValue": (v) => u.rentalRate = v,
                  onChange: e.detectChange,
                  disabled: e.componentBusy
                }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange", "disabled"])) : f == "short-term" ? (p(), Fe(o, {
                  key: 1,
                  currency: "",
                  modelValue: u.strRentalRate,
                  "onUpdate:modelValue": (v) => u.strRentalRate = v,
                  onChange: e.detectChange,
                  disabled: e.componentBusy
                }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange", "disabled"])) : P("", !0),
                f == "pad-split" && !e.isCommercial ? (p(), h("div", Gvt, [
                  N(o, {
                    class: "form-control w-30",
                    disabled: ""
                  }),
                  N(o, {
                    currency: "",
                    class: "form-control",
                    disabled: ""
                  })
                ])) : P("", !0)
              ]))), 256)),
              e.rentalTypes.length < 2 && m == 0 ? (p(), h("td", {
                key: 0,
                rowspan: e.propertyUnits.length + 3 + e.otherIncomeAccounts.length,
                class: "bg-alice align-middle text-center px-5 py-3 border-start"
              }, [
                a("button", {
                  type: "button",
                  class: "btn btn-lava mb-4",
                  onClick: t[6] || (t[6] = (...f) => e.showCompareDialog && e.showCompareDialog(...f)),
                  disabled: e.componentBusy
                }, t[37] || (t[37] = [
                  a("i", { class: "fa-light fa-plus me-1" }, null, -1),
                  y("Add Analysis Style ")
                ]), 8, Xvt),
                t[38] || (t[38] = a("p", { class: "mb-0" }, "Compare the performance of multiple analysis syltes by adding an additional analysis style. Options include long term, short term and PadSplit.", -1))
              ], 8, Yvt)) : P("", !0)
            ]))), 128)),
            e.isSingle ? P("", !0) : (p(), h("tr", qvt, [
              a("th", Qvt, [
                a("div", Kvt, [
                  t[39] || (t[39] = a("span", { class: "me-auto" }, " Total ", -1)),
                  e.isCommercial ? (p(), h("span", Zvt, [
                    e.totalUnitsAdded == e.totalUnitsRequired ? (p(), h(A, { key: 0 }, [
                      y(g(e.number(e.totalUnitsAdded)), 1)
                    ], 64)) : (p(), h(A, { key: 1 }, [
                      y(g(e.number(e.totalUnitsAdded)) + " / ", 1),
                      a("span", Jvt, g(e.number(e.totalUnitsRequired)), 1)
                    ], 64))
                  ])) : P("", !0)
                ])
              ]),
              (p(!0), h(A, null, D(e.rentalTypes, (u) => (p(), h("th", $vt, [
                u == "long-term" ? (p(), h(A, { key: 0 }, [
                  y(g(e.currency(e.unitsTotalRentalRate)) + " ", 1),
                  e.isCommercial ? P("", !0) : (p(), h("span", _vt, "/month"))
                ], 64)) : u == "short-term" ? (p(), h(A, { key: 1 }, [
                  y(g(e.currency(e.unitsStrTotalRentalRate)) + " /night ", 1)
                ], 64)) : u == "pad-split" && !e.isCommercial ? (p(), h(A, { key: 2 }, [
                  y(" $999,999 /week ")
                ], 64)) : P("", !0)
              ]))), 256))
            ])),
            a("tr", null, [
              a("th", {
                colspan: e.rentalTypes.length + 1,
                scope: "row",
                height: "15",
                class: "border-bottom-0"
              }, " ", 8, eyt)
            ]),
            a("tr", null, [
              t[42] || (t[42] = a("th", {
                scope: "row",
                class: "align-middle border-end"
              }, " Other Income ", -1)),
              (p(!0), h(A, null, D(e.rentalTypes, (u) => {
                var m, f, v;
                return p(), h("td", {
                  class: z(["border-end bg-transparent", "table-column-" + u])
                }, [
                  u == "long-term" ? (p(), h("div", tyt, [
                    N(o, {
                      onChange: e.detectChange,
                      modelValue: e.calcParams.otherIncome,
                      "onUpdate:modelValue": t[7] || (t[7] = (b) => e.calcParams.otherIncome = b),
                      currency: "",
                      "orignal-value": (m = e.calcParamsOrig) == null ? void 0 : m.otherIncome,
                      placeholder: "Not Set",
                      "allow-empty": e.allowEmptyParams,
                      disabled: e.componentBusyAdvanced
                    }, null, 8, ["onChange", "modelValue", "orignal-value", "allow-empty", "disabled"]),
                    t[40] || (t[40] = a("div", { class: "py-2 ms-2" }, "/yr", -1))
                  ])) : u == "short-term" ? (p(), h("div", syt, [
                    N(o, {
                      onChange: e.detectChange,
                      modelValue: e.calcParams.strOtherIncome,
                      "onUpdate:modelValue": t[8] || (t[8] = (b) => e.calcParams.strOtherIncome = b),
                      currency: "",
                      "orignal-value": (f = e.calcParamsOrig) == null ? void 0 : f.strOtherIncome,
                      placeholder: "Not Set",
                      "allow-empty": e.allowEmptyParams,
                      disabled: e.componentBusyAdvanced
                    }, null, 8, ["onChange", "modelValue", "orignal-value", "allow-empty", "disabled"]),
                    t[41] || (t[41] = a("div", { class: "py-2 ms-2" }, "/yr", -1))
                  ])) : u == "pad-split" && !e.isCommercial ? (p(), h("div", ayt, [
                    N(o, {
                      onChange: e.detectChange,
                      modelValue: e.calcParams.padSplitOtherIncome,
                      "onUpdate:modelValue": t[9] || (t[9] = (b) => e.calcParams.padSplitOtherIncome = b),
                      currency: "",
                      "orignal-value": (v = e.calcParamsOrig) == null ? void 0 : v.padSplitOtherIncome,
                      placeholder: "Not Set",
                      "allow-empty": e.allowEmptyParams,
                      disabled: e.componentBusyAdvanced
                    }, null, 8, ["onChange", "modelValue", "orignal-value", "allow-empty", "disabled"])
                  ])) : P("", !0)
                ], 2);
              }), 256))
            ]),
            e.calcParams.otherIncomes && e.otherIncomeAccounts ? (p(!0), h(A, { key: 3 }, D(e.otherIncomeAccounts, (u) => (p(), h(A, null, [
              e.calcParams.otherIncomes.longTerm.some((m) => m.id == u.id) ? (p(), h("tr", {
                key: 0,
                scope: "row",
                class: z({ "has-error": e.accountHasError(u) })
              }, [
                a("th", nyt, g(u.name), 1),
                (p(!0), h(A, null, D(e.rentalTypes, (m) => {
                  var f, v, b;
                  return p(), h("td", ryt, [
                    m == "long-term" ? (p(), h("div", oyt, [
                      N(o, {
                        onChange: e.detectChange,
                        modelValue: e.calcParams.otherIncomes.longTerm.find((w) => w.id == u.id).total,
                        "onUpdate:modelValue": (w) => e.calcParams.otherIncomes.longTerm.find((S) => S.id == u.id).total = w,
                        "orignal-value": (f = e.calcParamsOrig) == null ? void 0 : f.otherIncomes.longTerm.find((w) => w.id == u.id).total,
                        disabled: e.componentBusy,
                        "allow-empty": e.allowEmptyParams,
                        placeholder: "Not Set",
                        currency: ""
                      }, null, 8, ["onChange", "modelValue", "onUpdate:modelValue", "orignal-value", "disabled", "allow-empty"]),
                      t[43] || (t[43] = a("div", { class: "py-2 ms-2" }, "/yr", -1))
                    ])) : m == "short-term" ? (p(), h("div", iyt, [
                      N(o, {
                        onChange: e.detectChange,
                        modelValue: e.calcParams.otherIncomes.shortTerm.find((w) => w.id == u.id).total,
                        "onUpdate:modelValue": (w) => e.calcParams.otherIncomes.shortTerm.find((S) => S.id == u.id).total = w,
                        "orignal-value": (v = e.calcParamsOrig) == null ? void 0 : v.otherIncomes.shortTerm.find((w) => w.id == u.id).total,
                        disabled: e.componentBusy,
                        "allow-empty": e.allowEmptyParams,
                        placeholder: "Not Set",
                        currency: ""
                      }, null, 8, ["onChange", "modelValue", "onUpdate:modelValue", "orignal-value", "disabled", "allow-empty"]),
                      t[44] || (t[44] = a("div", { class: "py-2 ms-2" }, "/yr", -1))
                    ])) : m == "pad-split" && !e.isCommercial ? (p(), h("div", lyt, [
                      N(o, {
                        onChange: e.detectChange,
                        modelValue: e.calcParams.otherIncomes.padSplit.find((w) => w.id == u.id).total,
                        "onUpdate:modelValue": (w) => e.calcParams.otherIncomes.padSplit.find((S) => S.id == u.id).total = w,
                        "orignal-value": (b = e.calcParamsOrig) == null ? void 0 : b.otherIncomes.padSplit.find((w) => w.id == u.id).total,
                        disabled: e.componentBusy,
                        "allow-empty": e.allowEmptyParams,
                        placeholder: "Not Set",
                        currency: ""
                      }, null, 8, ["onChange", "modelValue", "onUpdate:modelValue", "orignal-value", "disabled", "allow-empty"])
                    ])) : P("", !0)
                  ]);
                }), 256))
              ], 2)) : P("", !0)
            ], 64))), 256)) : P("", !0)
          ])
        ])
      ])) : P("", !0)
    ], 2),
    a("div", dyt, [
      a("div", cyt, [
        a("div", uyt, [
          a("div", pyt, [
            a("h1", hyt, [
              e.editing ? (p(), h(A, { key: 1 }, [
                y(" Edit ")
              ], 64)) : (p(), h(A, { key: 0 }, [
                y(" Add ")
              ], 64)),
              t[46] || (t[46] = y(" Unit "))
            ]),
            a("button", {
              type: "button",
              class: "btn-close",
              "aria-label": "Close Add Unit Dialog",
              id: "modalUnitClose",
              onClick: t[10] || (t[10] = (...u) => e.cancelAddEdit && e.cancelAddEdit(...u))
            })
          ]),
          a("div", myt, [
            N(ks, {
              name: "slide",
              mode: "out-in"
            }, {
              default: ve(() => [
                e.modalError ? (p(), h("div", fyt, g(e.modalError), 1)) : P("", !0)
              ]),
              _: 1
            }),
            a("div", gyt, [
              a("div", vyt, [
                t[47] || (t[47] = a("label", { class: "col-sm-6 col-form-label" }, " Name ", -1)),
                a("div", yyt, [
                  V(a("input", {
                    type: "text",
                    class: z(["form-control", e.checkValidForm("UnitName")]),
                    placeholder: "Name",
                    "onUpdate:modelValue": t[11] || (t[11] = (u) => e.newUnit.name = u)
                  }, null, 2), [
                    [_e, e.newUnit.name]
                  ]),
                  e.globalValidationErrors.UnitName ? (p(), h("div", {
                    key: 0,
                    class: z(e.checkValid("UnitName"))
                  }, g(e.errorMessage("UnitName")), 3)) : P("", !0)
                ]),
                t[48] || (t[48] = a("label", { class: "col-sm-6 col-form-label" }, " Qty ", -1)),
                a("div", byt, [
                  e.editing && e.totalUnitsRequired <= 4 ? (p(), h("span", Ayt, g(e.number(e.newUnit.quantity)), 1)) : (p(), Fe(o, {
                    key: 1,
                    class: "form-control",
                    placeholder: "Qty",
                    modelValue: e.newUnit.quantity,
                    "onUpdate:modelValue": t[12] || (t[12] = (u) => e.newUnit.quantity = u)
                  }, null, 8, ["modelValue"]))
                ])
              ])
            ]),
            a("table", wyt, [
              t[60] || (t[60] = a("colgroup", null, [
                a("col"),
                a("col", { class: "bg-body-secondary" }),
                a("col"),
                a("col", { class: "" })
              ], -1)),
              a("thead", null, [
                a("tr", null, [
                  t[57] || (t[57] = a("th", {
                    scope: "col",
                    class: "table-column-description"
                  }, null, -1)),
                  (p(!0), h(A, null, D(e.rentalTypes, (u) => (p(), h("th", {
                    scope: "col",
                    class: z(["text-center bg-transparent", "table-column-" + u])
                  }, [
                    u == "long-term" ? (p(), h(A, { key: 0 }, [
                      t[49] || (t[49] = a("i", { class: "fa-light fa-calendar-range me-2" }, null, -1)),
                      t[50] || (t[50] = y("Long Term ")),
                      t[51] || (t[51] = a("br", null, null, -1)),
                      t[52] || (t[52] = a("small", { class: "text-body-secondary" }, "Monthly", -1))
                    ], 64)) : P("", !0),
                    u == "short-term" ? (p(), h(A, { key: 1 }, [
                      t[53] || (t[53] = a("i", { class: "fa-light fa-calendar-range me-2" }, null, -1)),
                      t[54] || (t[54] = y("Short Term ")),
                      t[55] || (t[55] = a("br", null, null, -1)),
                      t[56] || (t[56] = a("small", { class: "text-body-secondary" }, "Average Nightly", -1))
                    ], 64)) : P("", !0)
                  ], 2))), 256))
                ])
              ]),
              a("tbody", null, [
                a("tr", null, [
                  t[58] || (t[58] = a("th", {
                    scope: "row",
                    class: "align-middle"
                  }, " Rate ", -1)),
                  (p(!0), h(A, null, D(e.rentalTypes, (u) => (p(), h("td", Cyt, [
                    u == "long-term" ? (p(), Fe(o, {
                      key: 0,
                      class: "form-control",
                      placeholder: "Rent",
                      modelValue: e.newUnit.rentalRate,
                      "onUpdate:modelValue": t[13] || (t[13] = (m) => e.newUnit.rentalRate = m),
                      currency: ""
                    }, null, 8, ["modelValue"])) : P("", !0),
                    u == "short-term" ? (p(), Fe(o, {
                      key: 1,
                      class: "form-control",
                      placeholder: "Rent",
                      modelValue: e.newUnit.strRentalRate,
                      "onUpdate:modelValue": t[14] || (t[14] = (m) => e.newUnit.strRentalRate = m),
                      currency: ""
                    }, null, 8, ["modelValue"])) : P("", !0)
                  ]))), 256))
                ]),
                a("tr", null, [
                  t[59] || (t[59] = a("th", {
                    scope: "row",
                    class: "align-middle"
                  }, " Total ", -1)),
                  (p(!0), h(A, null, D(e.rentalTypes, (u) => (p(), h("td", Syt, [
                    u == "long-term" ? (p(), h("span", Pyt, g(e.currency(e.newUnit.quantity * e.newUnit.rentalRate)), 1)) : P("", !0),
                    u == "short-term" ? (p(), h("span", kyt, g(e.currency(e.newUnit.quantity * e.newUnit.strRentalRate)), 1)) : P("", !0)
                  ]))), 256))
                ])
              ])
            ])
          ]),
          a("div", Eyt, [
            a("button", {
              type: "button",
              class: "btn btn-secondary me-auto",
              onClick: t[15] || (t[15] = (...u) => e.cancelAddEdit && e.cancelAddEdit(...u))
            }, "Cancel"),
            e.editing && e.totalUnitsRequired > 4 ? (p(), h("button", {
              key: 0,
              type: "button",
              class: "btn btn-danger",
              onClick: t[16] || (t[16] = (...u) => e.removeUnit && e.removeUnit(...u))
            }, "Remove")) : P("", !0),
            a("button", {
              type: "button",
              class: "btn btn-lava",
              onClick: t[17] || (t[17] = (...u) => e.addNew && e.addNew(...u)),
              disabled: e.hasModalErrors
            }, [
              e.editing ? (p(), h(A, { key: 1 }, [
                y(" Update ")
              ], 64)) : (p(), h(A, { key: 0 }, [
                y(" Add ")
              ], 64)),
              t[61] || (t[61] = y(" Unit "))
            ], 8, Iyt)
          ])
        ])
      ])
    ], 512),
    a("div", Tyt, [
      a("div", Oyt, [
        a("div", Ryt, [
          e.canOtherAnalysisStyles ? (p(), h(A, { key: 0 }, [
            t[66] || (t[66] = a("div", { class: "modal-header border-0 pb-0" }, [
              a("p", {
                class: "modal-title fs-5 fw-bold",
                id: "dialogCompareLabel"
              }, "Analysis Style"),
              a("button", {
                type: "button",
                class: "btn-close",
                "data-bs-dismiss": "modal",
                "aria-label": "Close"
              })
            ], -1)),
            a("div", Lyt, [
              a("div", Byt, [
                t[65] || (t[65] = a("legend", { class: "col-lg-5 col-form-label pt-0" }, " Compare Against Other Rental Types? ", -1)),
                a("div", Myt, [
                  ((l = e.calcParams) == null ? void 0 : l.rentalType) != "long-term" ? (p(), h("div", xyt, [
                    V(a("input", {
                      class: "form-check-input",
                      type: "checkbox",
                      id: "longTerm",
                      "onUpdate:modelValue": t[18] || (t[18] = (u) => e.compareLongTerm = u)
                    }, null, 512), [
                      [Ue, e.compareLongTerm]
                    ]),
                    t[62] || (t[62] = a("label", {
                      class: "form-check-label",
                      for: "longTerm"
                    }, "Long-Term", -1))
                  ])) : P("", !0),
                  ((d = e.calcParams) == null ? void 0 : d.rentalType) != "short-term" ? (p(), h("div", Fyt, [
                    V(a("input", {
                      class: "form-check-input",
                      type: "checkbox",
                      id: "shortTerm",
                      "onUpdate:modelValue": t[19] || (t[19] = (u) => e.compareShortTerm = u)
                    }, null, 512), [
                      [Ue, e.compareShortTerm]
                    ]),
                    t[63] || (t[63] = a("label", {
                      class: "form-check-label",
                      for: "shortTerm"
                    }, "Short-Term", -1))
                  ])) : P("", !0),
                  ((c = e.calcParams) == null ? void 0 : c.rentalType) != "pad-split" ? (p(), h("div", Vyt, [
                    V(a("input", {
                      class: "form-check-input",
                      type: "checkbox",
                      id: "padSplit",
                      "onUpdate:modelValue": t[20] || (t[20] = (u) => e.comparePadSplit = u),
                      disabled: ""
                    }, null, 512), [
                      [Ue, e.comparePadSplit]
                    ]),
                    t[64] || (t[64] = a("label", {
                      class: "form-check-label disabled",
                      for: "padSplit"
                    }, "PadSplit", -1))
                  ])) : P("", !0)
                ])
              ])
            ]),
            t[67] || (t[67] = a("div", { class: "modal-footer border-0 pt-0" }, [
              a("button", {
                type: "button",
                class: "btn btn-lava",
                "data-bs-dismiss": "modal"
              }, "Close")
            ], -1))
          ], 64)) : (p(), h("div", Dyt, t[68] || (t[68] = [
            a("button", {
              type: "button",
              class: "btn-close position-absolute top-10 end-10",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            }, null, -1),
            a("i", { class: "fa-duotone fa-solid fa-rectangle-vertical-history mb-3 fs-2" }, null, -1),
            a("p", { class: "fw-bold fs-5" }, "Analysis Style", -1),
            y(" Upgrade to "),
            a("b", null, "Property Suite Pro", -1),
            y(" to analyze multi-family, STR, rent vs sell, and other advanced analysis styles. ")
          ])))
        ])
      ])
    ], 512)
  ], 64);
}
const jyt = /* @__PURE__ */ Ae(Svt, [["render", Nyt]]), Hyt = me({
  name: "VacancyParameters",
  props: {
    loading: Boolean
  },
  emits: [
    "change"
  ],
  components: {
    NumericalInput: Aa
  },
  computed: {
    componentBusy() {
      return this.loading || this.calculating;
    },
    componentBusyAdvanced() {
      return this.loading || this.calculating || this.hasAdvanced != !0;
    },
    isLongTerm() {
      var e;
      return this.propertyStore.isLongTerm || (((e = this.calcParams) == null ? void 0 : e.rentalTypeComparisons) & nt.LongTerm) == nt.LongTerm;
    },
    isShortTerm() {
      var e;
      return this.propertyStore.isShortTerm || (((e = this.calcParams) == null ? void 0 : e.rentalTypeComparisons) & nt.ShortTerm) == nt.ShortTerm;
    },
    isPadSplit() {
      var e;
      return this.propertyStore.isPadSplit || (((e = this.calcParams) == null ? void 0 : e.rentalTypeComparisons) & nt.PadSplit) == nt.PadSplit;
    },
    ...at(qe),
    ...q(Te, ["access", "aclLoaded", "hasAdvanced"]),
    ...q(qe, ["property", "calcParams", "calcParamsOrig", "isExistingInvestment", "calculating"])
  },
  methods: {
    number: Ve,
    detectChange() {
      this.$emit("change");
    }
  },
  created() {
  },
  mounted() {
  }
}), Uyt = { class: "row row-cols-1 row-cols-md-2 row-cols-xl-3 g-3" }, zyt = {
  key: 0,
  class: "col"
}, Wyt = { class: "card shadow-sm h-100" }, Gyt = { class: "card-body" }, Yyt = { class: "row g-2" }, Xyt = { class: "col-12" }, qyt = {
  class: "btn-group d-flex",
  role: "group",
  "aria-label": "Calculation Type"
}, Qyt = ["disabled"], Kyt = ["disabled"], Zyt = { class: "col-5" }, Jyt = ["disabled"], $yt = ["value"], _yt = { class: "col-7 col-form-label" }, e1t = { class: "col-5" }, t1t = { class: "col-5" }, s1t = ["disabled"], a1t = ["value"], n1t = {
  key: 1,
  class: "col"
}, r1t = { class: "card shadow-sm h-100" }, o1t = { class: "card-body" }, i1t = { class: "row g-2" }, l1t = { class: "col-5" }, d1t = { class: "col-5" }, c1t = {
  key: 2,
  class: "col"
}, u1t = { class: "card shadow-sm h-100" }, p1t = { class: "card-body" }, h1t = { class: "row g-2" }, m1t = { class: "col-sm-5" }, f1t = { class: "col-sm-5" };
function g1t(e, t, s, n, r, i) {
  var c, u, m, f, v, b;
  const o = pe("numerical-input"), l = Za("has-changed"), d = Za("was-changed");
  return p(), h(A, null, [
    t[26] || (t[26] = a("p", { class: "mb-3 fw-bold fs-5" }, " Vacancy ", -1)),
    a("div", Uyt, [
      e.isLongTerm ? (p(), h("div", zyt, [
        a("div", Wyt, [
          a("div", Gyt, [
            t[19] || (t[19] = a("div", { class: "d-flex justify-content-between align-items-center mb-3" }, [
              a("p", { class: "fw-bold m-0" }, [
                a("i", { class: "fa-light fa-calendar-range me-2" }),
                y("Long Term")
              ])
            ], -1)),
            a("div", Yyt, [
              a("div", Xyt, [
                a("div", qyt, [
                  V(a("input", {
                    type: "radio",
                    class: "btn-check",
                    name: "btnCyclic",
                    id: "btnCyclic",
                    autocomplete: "off",
                    value: "cyclical",
                    "onUpdate:modelValue": t[0] || (t[0] = (w) => e.calcParams.vacancyType = w),
                    onChange: t[1] || (t[1] = (...w) => e.detectChange && e.detectChange(...w)),
                    disabled: e.componentBusy
                  }, null, 40, Qyt), [
                    [Mt, e.calcParams.vacancyType]
                  ]),
                  t[14] || (t[14] = a("label", {
                    class: "btn btn-outline-eclipse no-anim",
                    for: "btnCyclic"
                  }, "Cyclical", -1)),
                  V(a("input", {
                    type: "radio",
                    class: "btn-check",
                    name: "btnPercentage",
                    id: "btnPercentage",
                    autocomplete: "off",
                    value: "percentage",
                    "onUpdate:modelValue": t[2] || (t[2] = (w) => e.calcParams.vacancyType = w),
                    onChange: t[3] || (t[3] = (...w) => e.detectChange && e.detectChange(...w)),
                    disabled: e.componentBusy
                  }, null, 40, Kyt), [
                    [Mt, e.calcParams.vacancyType]
                  ]),
                  t[15] || (t[15] = a("label", {
                    class: "btn btn-outline-eclipse no-anim",
                    for: "btnPercentage"
                  }, "Percentage", -1))
                ])
              ]),
              t[17] || (t[17] = a("label", { class: "col-7 col-form-label" }, "Average Length of Stay", -1)),
              a("div", Zyt, [
                V((p(), h("select", {
                  class: "form-select",
                  "onUpdate:modelValue": t[4] || (t[4] = (w) => e.calcParams.averagelengthofstay = w),
                  onChange: t[5] || (t[5] = (...w) => e.detectChange && e.detectChange(...w)),
                  disabled: e.componentBusy
                }, [
                  (p(), h(A, null, D(10, (w) => a("option", { value: w }, g(w) + " Year", 9, $yt)), 64))
                ], 40, Jyt)), [
                  [We, e.calcParams.averagelengthofstay],
                  [l, "calcParams.averagelengthofstay"]
                ])
              ]),
              a("label", _yt, [
                e.calcParams.vacancyType != "percentage" ? (p(), h(A, { key: 0 }, [
                  y(" Average Time Between Tenants (days) ")
                ], 64)) : (p(), h(A, { key: 1 }, [
                  y(" Annual Vacancy % ")
                ], 64))
              ]),
              a("div", e1t, [
                e.calcParams.vacancyType != "percentage" ? (p(), Fe(o, {
                  key: 0,
                  modelValue: e.calcParams.timebetweentenants,
                  "onUpdate:modelValue": t[6] || (t[6] = (w) => e.calcParams.timebetweentenants = w),
                  "original-value": (c = e.calcParamsOrig) == null ? void 0 : c.timebetweentenants,
                  class: "form-control",
                  onChange: e.detectChange,
                  disabled: e.componentBusyAdvanced
                }, null, 8, ["modelValue", "original-value", "onChange", "disabled"])) : (p(), Fe(o, {
                  key: 1,
                  modelValue: e.calcParams.percentVacancy,
                  "onUpdate:modelValue": t[7] || (t[7] = (w) => e.calcParams.percentVacancy = w),
                  percent: "",
                  onChange: e.detectChange
                }, null, 8, ["modelValue", "onChange"]))
              ]),
              t[18] || (t[18] = a("label", { class: "col-7 col-form-label" }, "Current Tenant Remaining?", -1)),
              a("div", t1t, [
                V((p(), h("select", {
                  onChange: t[8] || (t[8] = (...w) => e.detectChange && e.detectChange(...w)),
                  "onUpdate:modelValue": t[9] || (t[9] = (w) => e.calcParams.currentTenantRemaining = w),
                  class: "form-select",
                  disabled: e.componentBusyAdvanced
                }, [
                  t[16] || (t[16] = a("option", { value: 0 }, "No", -1)),
                  (p(), h(A, null, D(3, (w) => a("option", { value: w }, g(w) + " Year", 9, a1t)), 64))
                ], 40, s1t)), [
                  [
                    We,
                    e.calcParams.currentTenantRemaining,
                    void 0,
                    { number: !0 }
                  ],
                  [d, (u = e.calcParamsOrig) == null ? void 0 : u.currentTenantRemaining]
                ])
              ])
            ])
          ])
        ])
      ])) : P("", !0),
      e.isShortTerm ? (p(), h("div", n1t, [
        a("div", r1t, [
          a("div", o1t, [
            t[22] || (t[22] = a("div", { class: "d-flex justify-content-between align-items-center mb-3" }, [
              a("p", { class: "fw-bold m-0" }, [
                a("i", { class: "fa-light fa-timer me-2" }),
                y("Short Term")
              ])
            ], -1)),
            a("div", i1t, [
              t[20] || (t[20] = a("label", { class: "col-7 col-form-label" }, "Days Available per Year", -1)),
              a("div", l1t, [
                N(o, {
                  modelValue: e.calcParams.strDaysAvailablePerYear,
                  "onUpdate:modelValue": t[10] || (t[10] = (w) => e.calcParams.strDaysAvailablePerYear = w),
                  "original-value": (m = e.calcParamsOrig) == null ? void 0 : m.strDaysAvailablePerYear,
                  class: "form-control",
                  onChange: e.detectChange,
                  disabled: e.componentBusyAdvanced
                }, null, 8, ["modelValue", "original-value", "onChange", "disabled"])
              ]),
              t[21] || (t[21] = a("label", { class: "col-7 col-form-label" }, "Days Occupied per Year", -1)),
              a("div", d1t, [
                N(o, {
                  modelValue: e.calcParams.strDaysOccupiedPerYear,
                  "onUpdate:modelValue": t[11] || (t[11] = (w) => e.calcParams.strDaysOccupiedPerYear = w),
                  "original-value": (f = e.calcParamsOrig) == null ? void 0 : f.strDaysOccupiedPerYear,
                  class: "form-control",
                  onChange: e.detectChange,
                  disabled: e.componentBusyAdvanced
                }, null, 8, ["modelValue", "original-value", "onChange", "disabled"])
              ])
            ])
          ])
        ])
      ])) : P("", !0),
      e.isPadSplit ? (p(), h("div", c1t, [
        a("div", u1t, [
          a("div", p1t, [
            t[25] || (t[25] = a("div", { class: "d-flex justify-content-between align-items-center mb-3" }, [
              a("p", { class: "fw-bold m-0" }, [
                a("img", {
                  src: nn,
                  alt: "PadSplit",
                  title: "PadSplit",
                  loading: "lazy",
                  class: "img-fluid",
                  width: "85"
                })
              ])
            ], -1)),
            a("div", h1t, [
              t[23] || (t[23] = a("label", { class: "col-sm-7 col-form-label" }, "Annual Vacancy Rate", -1)),
              a("div", m1t, [
                N(o, {
                  modelValue: e.calcParams.padSplitAnnualVacancyRate,
                  "onUpdate:modelValue": t[12] || (t[12] = (w) => e.calcParams.padSplitAnnualVacancyRate = w),
                  "original-value": (v = e.calcParamsOrig) == null ? void 0 : v.padSplitAnnualVacancyRate,
                  percent: "",
                  class: "form-control",
                  onChange: e.detectChange,
                  disabled: e.componentBusyAdvanced
                }, null, 8, ["modelValue", "original-value", "onChange", "disabled"])
              ]),
              t[24] || (t[24] = a("label", { class: "col-sm-7 col-form-label" }, "Average Length of Stay (Months)", -1)),
              a("div", f1t, [
                N(o, {
                  modelValue: e.calcParams.padSplitAverageLengthOfStay,
                  "onUpdate:modelValue": t[13] || (t[13] = (w) => e.calcParams.padSplitAverageLengthOfStay = w),
                  "original-value": (b = e.calcParamsOrig) == null ? void 0 : b.padSplitAverageLengthOfStay,
                  class: "form-control",
                  onChange: e.detectChange,
                  disabled: e.componentBusyAdvanced
                }, null, 8, ["modelValue", "original-value", "onChange", "disabled"])
              ])
            ])
          ])
        ])
      ])) : P("", !0)
    ])
  ], 64);
}
const v1t = /* @__PURE__ */ Ae(Hyt, [["render", g1t]]), y1t = me({
  name: "SaveParameters",
  props: {
    loading: Boolean
  },
  emits: [
    "reset",
    "save",
    "change"
  ],
  computed: {
    componentBusy() {
      return this.loading || this.calculating;
    },
    componentBusyAdvanced() {
      return this.loading || this.calculating || this.hasAdvanced != !0;
    },
    canResetParameters() {
      var e, t;
      return ((e = this.access) == null ? void 0 : e.isShare) != !0 && ((t = this.access) == null ? void 0 : t.isAnalysis) != !0;
    },
    ...q(Te, ["access", "aclLoaded", "canSaveParameters", "hasAdvanced"]),
    ...q(qe, ["isPmSynced", "calculating"]),
    ...at(qe)
  },
  methods: {
    number: Ve,
    async resetListing() {
      var e;
      try {
        this.isPmSynced ? (await this.propertyStore.resetParamsToDefault(), this.$emit("change"), wt("Property model values reset to your defaults.")) : (this.$emit("reset", !0), (e = bootstrap.Modal.getOrCreateInstance(this.$refs.dialogReset)) == null || e.hide());
      } catch (t) {
        Se(t);
      }
    },
    saveFields() {
      this.$emit("save");
    }
  },
  created() {
  },
  mounted() {
    this.aclLoaded.then(() => {
    });
  }
}), b1t = { class: "alert alert-info mb-0 d-flex align-items-center justify-content-between flex-column flex-lg-row text-center text-lg-start" }, A1t = { class: "d-flex flex-row" }, w1t = {
  key: 0,
  type: "button",
  class: "btn btn-outline-eclipse ms-auto me-2",
  "data-bs-toggle": "modal",
  "data-bs-target": "#dialogReset"
}, C1t = ["disabled"], S1t = {
  key: 0,
  class: "modal fade",
  ref: "dialogReset",
  id: "dialogReset",
  tabindex: "-1",
  "aria-labelledby": "dialogResetLabel",
  "aria-hidden": "true"
}, P1t = { class: "modal-dialog modal-dialog-centered" }, k1t = { class: "modal-content bg-gradient-alphabet rounded" }, E1t = { class: "modal-body text-center px-5 pb-5 pt-0 d-flex flex-column align-items-center justify-content-center" }, I1t = { class: "mb-5" }, T1t = ["disabled"];
function O1t(e, t, s, n, r, i) {
  return p(), h(A, null, [
    a("div", b1t, [
      t[2] || (t[2] = a("div", { class: "mb-2 mb-lg-0" }, [
        a("i", { class: "fa-light fa-info-circle me-2" }),
        y("Changes will display on this page, but will not be saved to your user account until you click "),
        a("b", null, '"Save Changes"'),
        y(". ")
      ], -1)),
      a("div", A1t, [
        e.canResetParameters ? (p(), h("button", w1t, [
          e.isPmSynced ? (p(), h(A, { key: 0 }, [
            y(" Reset to Defaults ")
          ], 64)) : (p(), h(A, { key: 1 }, [
            y(" Reset to orginal ")
          ], 64))
        ])) : P("", !0),
        a("button", {
          type: "button",
          class: "btn btn-bee saveFields",
          onClick: t[0] || (t[0] = (...o) => e.saveFields && e.saveFields(...o)),
          disabled: e.componentBusy || !e.canSaveParameters
        }, "Save Changes", 8, C1t)
      ])
    ]),
    e.canResetParameters ? (p(), h("div", S1t, [
      a("div", P1t, [
        a("div", k1t, [
          t[8] || (t[8] = a("div", { class: "modal-header border-0" }, [
            a("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            })
          ], -1)),
          a("div", E1t, [
            t[6] || (t[6] = a("span", { class: "bg-danger rounded-circle mb-4 p-3 text-white" }, [
              a("i", { class: "fa-light fa-broom-wide fa-2xl" })
            ], -1)),
            t[7] || (t[7] = a("p", { class: "fw-bold fs-4 mb-0" }, "Are you sure?", -1)),
            a("p", I1t, [
              t[3] || (t[3] = y(" Clicking ")),
              e.isPmSynced ? (p(), h(A, { key: 0 }, [
                y(" Reset to Defaults ")
              ], 64)) : (p(), h(A, { key: 1 }, [
                y(" Reset to orginal ")
              ], 64)),
              t[4] || (t[4] = y(" below will clear all historical data for this property, remove it from your existing investments, and change the investment strategy to ‘New Purchase’. "))
            ]),
            a("button", {
              type: "button",
              class: "btn btn-danger",
              onClick: t[1] || (t[1] = (...o) => e.resetListing && e.resetListing(...o)),
              disabled: e.componentBusy
            }, [
              t[5] || (t[5] = y(" Yes, ")),
              e.isPmSynced ? (p(), h(A, { key: 0 }, [
                y(" Reset to Defaults ")
              ], 64)) : (p(), h(A, { key: 1 }, [
                y(" Reset to orginal ")
              ], 64))
            ], 8, T1t)
          ])
        ])
      ])
    ], 512)) : P("", !0)
  ], 64);
}
const R1t = /* @__PURE__ */ Ae(y1t, [["render", O1t]]), L1t = me({
  name: "LoanAmount",
  props: {
    loading: Boolean
  },
  emits: [
    "change"
  ],
  components: {
    NumericalInput: Aa
  },
  computed: {
    componentBusy() {
      return this.loading || this.calculating;
    },
    componentBusyAdvanced() {
      return this.loading || this.calculating || this.hasAdvanced != !0;
    },
    cashPurchaseStyle() {
      return {
        alert: !0,
        "alert-info": !0,
        "text-end": !0,
        "col-12": !0,
        "mt-3": !0,
        "fw-bold": !0,
        "d-none": !this.isCashPurchase
      };
    },
    isCashPurchase() {
      var e;
      return ((e = this.calcParams) == null ? void 0 : e.downpayment) == 1;
    },
    ...q(Te, ["access", "aclLoaded", "hasAdvanced"]),
    ...q(qe, ["calcParams", "calcParamsOrig", "purchaseFacts", "isExistingInvestment", "calculating"]),
    ...at(qe)
  },
  methods: {
    number: Ve,
    currency: Ze,
    detectChange() {
      this.$emit("change");
    },
    downpaymentChange() {
      this.calcParams.loanAmount = Math.trunc(this.calcParams.purchaseprice * (1 - this.calcParams.downpayment)), this.$emit("change");
    },
    loanAmountChange() {
      this.propertyStore.recalculateDownpaymentPercentage(), this.$emit("change");
    },
    async loanByDownPayment() {
      this.isCashPurchase && (this.calcParams.downpayment = this.calcParamsOrig.downpayment, this.downpaymentChange(), this.propertyStore.forceUpdateValues(), this.propertyStore.calculate());
    },
    async loanByAmount() {
      this.isCashPurchase && (this.calcParams.downpayment = this.calcParamsOrig.downpayment, this.downpaymentChange(), this.propertyStore.forceUpdateValues(), this.propertyStore.calculate());
    },
    async noLoan() {
      this.calcParams.downpayment = 1, this.downpaymentChange(), this.propertyStore.forceUpdateValues(), this.propertyStore.calculate();
    }
  }
}), B1t = { class: "card shadow-sm h-100" }, M1t = { key: 0 }, x1t = {
  class: "nav nav-underline gap-1 gap-xl-2 border-bottom",
  id: "nav-payment",
  role: "tablist"
}, F1t = ["disabled"], V1t = ["disabled"], D1t = ["disabled"], N1t = {
  class: "tab-content p-3",
  id: "nav-tabContent"
}, j1t = {
  class: "tab-pane fade show active",
  id: "nav-down",
  role: "tabpanel",
  "aria-labelledby": "nav-down-tab"
}, H1t = { class: "row" }, U1t = { class: "col-5" }, z1t = {
  class: "tab-pane fade",
  id: "nav-loan",
  role: "tabpanel",
  "aria-labelledby": "nav-loan-tab"
}, W1t = { class: "row" }, G1t = { class: "col-5" }, Y1t = { class: "row" }, X1t = { class: "col-5 text-end" }, q1t = { class: "form-control-plaintext" }, Q1t = { class: "card-body" }, K1t = { class: "row g-2" }, Z1t = { class: "col-sm-5" }, J1t = { class: "col-sm-5" }, $1t = { class: "col-sm-5" }, _1t = ["disabled"], ebt = ["value"], tbt = { class: "col-12" }, sbt = { class: "row" }, abt = { class: "col-5 d-flex align-items-center justify-content-center" }, nbt = { class: "form-check form-switch form-switch-lg form-switch-basic" }, rbt = ["disabled"], obt = {
  key: 0,
  class: "row mt-3"
}, ibt = { class: "col-5" }, lbt = ["disabled"], dbt = ["value"];
function cbt(e, t, s, n, r, i) {
  var d, c, u, m, f, v;
  const o = pe("numerical-input"), l = Za("has-changed");
  return p(), h("div", B1t, [
    t[26] || (t[26] = a("div", { class: "card-header bg-white fw-bold pb-0 border-0" }, "Loan", -1)),
    e.isExistingInvestment ? P("", !0) : (p(), h("nav", M1t, [
      a("div", x1t, [
        a("button", {
          type: "button",
          class: "nav-link text-reset border-start-0 blr-0 active",
          id: "nav-down-tab",
          "data-bs-toggle": "tab",
          "data-bs-target": "#nav-down",
          role: "tab",
          "aria-controls": "nav-down",
          "aria-selected": "true",
          onClick: t[0] || (t[0] = (...b) => e.loanByDownPayment && e.loanByDownPayment(...b)),
          disabled: e.componentBusy
        }, t[13] || (t[13] = [
          y(" Down "),
          a("span", { class: "d-none d-md-inline-block" }, "Payment", -1),
          a("span", { class: "d-md-none" }, "Pymt.", -1)
        ]), 8, F1t),
        a("button", {
          type: "button",
          class: "nav-link text-reset",
          id: "nav-loan-tab",
          "data-bs-toggle": "tab",
          "data-bs-target": "#nav-loan",
          role: "tab",
          "aria-controls": "nav-loan",
          "aria-selected": "false",
          onClick: t[1] || (t[1] = (...b) => e.loanByAmount && e.loanByAmount(...b)),
          disabled: e.componentBusy
        }, t[14] || (t[14] = [
          y(" Loan "),
          a("span", { class: "d-none d-md-inline-block" }, "Amount", -1),
          a("span", { class: "d-md-none" }, "Amt.", -1)
        ]), 8, V1t),
        a("button", {
          type: "button",
          class: "nav-link text-reset",
          id: "nav-cash-tab",
          "data-bs-toggle": "tab",
          "data-bs-target": "#nav-cash",
          role: "tab",
          "aria-controls": "nav-cash",
          "aria-selected": "false",
          onClick: t[2] || (t[2] = (...b) => e.noLoan && e.noLoan(...b)),
          disabled: e.componentBusy
        }, " Cash Purchase ", 8, D1t)
      ])
    ])),
    a("div", N1t, [
      e.isExistingInvestment ? (p(), h(A, { key: 1 }, [
        a("div", Y1t, [
          t[18] || (t[18] = a("label", { class: "col-7 col-form-label" }, "Loan Amount", -1)),
          a("div", X1t, [
            a("div", q1t, g(e.currency((m = (u = e.purchaseFacts) == null ? void 0 : u.loan) == null ? void 0 : m.amount)), 1)
          ])
        ]),
        e.isCashPurchase ? (p(), h("div", {
          key: 0,
          class: z(e.cashPurchaseStyle)
        }, "Cash Purchase", 2)) : P("", !0)
      ], 64)) : (p(), h(A, { key: 0 }, [
        a("div", j1t, [
          a("div", H1t, [
            t[15] || (t[15] = a("label", { class: "col-7 col-form-label" }, "Down Payment Percentage", -1)),
            a("div", U1t, [
              N(o, {
                percent: "",
                modelValue: e.calcParams.downpayment,
                "onUpdate:modelValue": t[3] || (t[3] = (b) => e.calcParams.downpayment = b),
                "orignal-value": (d = e.calcParamsOrig) == null ? void 0 : d.downpayment,
                onChange: e.downpaymentChange,
                disabled: e.componentBusy
              }, null, 8, ["modelValue", "orignal-value", "onChange", "disabled"])
            ])
          ]),
          e.isCashPurchase ? (p(), h("div", {
            key: 0,
            class: z(e.cashPurchaseStyle)
          }, "Cash Purchase", 2)) : P("", !0)
        ]),
        a("div", z1t, [
          a("div", W1t, [
            t[16] || (t[16] = a("label", { class: "col-7 col-form-label" }, "Loan Amount", -1)),
            a("div", G1t, [
              N(o, {
                currency: "",
                modelValue: e.calcParams.loanAmount,
                "onUpdate:modelValue": t[4] || (t[4] = (b) => e.calcParams.loanAmount = b),
                "orignal-value": (c = e.calcParamsOrig) == null ? void 0 : c.loanAmount,
                onChange: e.loanAmountChange,
                disabled: e.componentBusy
              }, null, 8, ["modelValue", "orignal-value", "onChange", "disabled"])
            ])
          ]),
          e.isCashPurchase ? (p(), h("div", {
            key: 0,
            class: z(e.cashPurchaseStyle)
          }, "Cash Purchase", 2)) : P("", !0)
        ]),
        t[17] || (t[17] = a("div", {
          class: "tab-pane fade",
          id: "nav-cash",
          role: "tabpanel",
          "aria-labelledby": "nav-cash-tab"
        }, [
          a("div", {
            class: "alert alert-info fw-bold m-0",
            role: "alert"
          }, "100% Down Payment")
        ], -1))
      ], 64))
    ]),
    t[27] || (t[27] = a("div", { class: "card-header bg-white fw-bold pb-0 border-0 border-top" }, "Loan Details", -1)),
    a("div", Q1t, [
      a("div", K1t, [
        t[23] || (t[23] = a("label", { class: "col-sm-7 col-form-label" }, "Loan Fees", -1)),
        a("div", Z1t, [
          N(o, {
            percent: "",
            modelValue: e.calcParams.loanfees,
            "onUpdate:modelValue": t[5] || (t[5] = (b) => e.calcParams.loanfees = b),
            "orignal-value": (f = e.calcParamsOrig) == null ? void 0 : f.loanfees,
            onChange: e.detectChange,
            disabled: e.componentBusy || e.isCashPurchase || e.isExistingInvestment
          }, null, 8, ["modelValue", "orignal-value", "onChange", "disabled"])
        ]),
        t[24] || (t[24] = a("label", { class: "col-sm-7 col-form-label" }, "Interest Rate %", -1)),
        a("div", J1t, [
          N(o, {
            percent: "",
            modelValue: e.calcParams.interestrate,
            "onUpdate:modelValue": t[6] || (t[6] = (b) => e.calcParams.interestrate = b),
            "orignal-value": (v = e.calcParamsOrig) == null ? void 0 : v.interestrate,
            onChange: e.detectChange,
            disabled: e.componentBusy || e.isCashPurchase || e.isExistingInvestment
          }, null, 8, ["modelValue", "orignal-value", "onChange", "disabled"])
        ]),
        t[25] || (t[25] = a("label", { class: "col-sm-7 col-form-label" }, "Amortization Period (years)", -1)),
        a("div", $1t, [
          V(a("select", {
            class: "form-select",
            "onUpdate:modelValue": t[7] || (t[7] = (b) => e.calcParams.loanterm = b),
            disabled: e.componentBusy || e.isCashPurchase || e.isExistingInvestment,
            onChange: t[8] || (t[8] = (...b) => e.detectChange && e.detectChange(...b))
          }, [
            (p(), h(A, null, D(30, (b) => a("option", { value: b }, g(b) + " Years", 9, ebt)), 64))
          ], 40, _1t), [
            [We, e.calcParams.loanterm]
          ])
        ]),
        a("div", tbt, [
          a("div", sbt, [
            t[20] || (t[20] = a("label", { class: "col-7 col-form-label" }, "Interest Only Loan?", -1)),
            a("div", abt, [
              a("div", nbt, [
                V(a("input", {
                  type: "checkbox",
                  "onUpdate:modelValue": t[9] || (t[9] = (b) => e.calcParams.interestOnlyLoan = b),
                  disabled: e.componentBusyAdvanced || e.isExistingInvestment,
                  class: "form-check-input",
                  id: "iolSwitch",
                  onChange: t[10] || (t[10] = (...b) => e.detectChange && e.detectChange(...b))
                }, null, 40, rbt), [
                  [Ue, e.calcParams.interestOnlyLoan],
                  [l, "calcParams.interestOnlyLoan"]
                ]),
                t[19] || (t[19] = a("label", {
                  class: "form-check-label",
                  for: "iolSwitch"
                }, [
                  a("span", null, "No"),
                  y("Yes")
                ], -1))
              ])
            ])
          ]),
          e.calcParams.interestOnlyLoan ? (p(), h("div", obt, [
            t[22] || (t[22] = a("label", { class: "col-7 col-form-label" }, "Interest Only Term", -1)),
            a("div", ibt, [
              V((p(), h("select", {
                "onUpdate:modelValue": t[11] || (t[11] = (b) => e.calcParams.interestOnlyTerm = b),
                class: "form-select",
                onChange: t[12] || (t[12] = (...b) => e.detectChange && e.detectChange(...b)),
                disabled: e.componentBusy
              }, [
                t[21] || (t[21] = a("option", { value: 360 }, "Full Term", -1)),
                (p(), h(A, null, D([3, 6, 9, 12, 18, 24, 36, 48, 60, 72, 84, 96, 108, 120], (b) => a("option", { value: b }, g(b) + " Months", 9, dbt)), 64))
              ], 40, lbt)), [
                [We, e.calcParams.interestOnlyTerm],
                [l, "calcParams.interestOnlyTerm"]
              ])
            ])
          ])) : P("", !0)
        ])
      ])
    ])
  ]);
}
const ubt = /* @__PURE__ */ Ae(L1t, [["render", cbt]]), pbt = me({
  name: "PurchasePriceTransactionCosts",
  props: {
    loading: Boolean
  },
  components: {
    NumericalInput: Aa
  },
  emits: [
    "change"
  ],
  computed: {
    componentBusy() {
      return this.loading || this.calculating;
    },
    componentBusyAdvanced() {
      return this.loading || this.calculating || this.hasAdvanced != !0;
    },
    ...q(Te, ["access", "aclLoaded", "hasAdvanced"]),
    ...q(qe, ["calcParams", "calcParamsOrig", "isExistingInvestment", "property", "calculating"]),
    ...q(ba, ["portfolioId"])
  },
  methods: {
    number: Ve,
    detectChange() {
      this.$emit("change");
    }
  }
}), hbt = { class: "card shadow-sm" }, mbt = { class: "card-header bg-white fw-bold pb-0 border-0" }, fbt = { class: "card-body" }, gbt = { class: "row g-2" }, vbt = { class: "col-sm-5" }, ybt = { class: "col-sm-5" }, bbt = { class: "col-sm-5" };
function Abt(e, t, s, n, r, i) {
  var l, d, c;
  const o = pe("numerical-input");
  return p(), h("div", hbt, [
    a("div", mbt, [
      e.portfolioId ? (p(), h(A, { key: 0 }, [
        y(" Property Value ")
      ], 64)) : (p(), h(A, { key: 1 }, [
        y(" Purchase ")
      ], 64))
    ]),
    a("div", fbt, [
      a("div", gbt, [
        e.isExistingInvestment ? (p(), h(A, { key: 1 }, [
          t[4] || (t[4] = a("label", { class: "col-sm-7 col-form-label" }, "Property Value", -1)),
          a("div", ybt, [
            N(o, {
              currency: "",
              modelValue: e.calcParams.propertyValueEoY,
              "onUpdate:modelValue": t[1] || (t[1] = (u) => e.calcParams.propertyValueEoY = u),
              "orignal-value": (d = e.calcParamsOrig) == null ? void 0 : d.propertyValueEoY,
              onChange: e.detectChange,
              disabled: e.componentBusy
            }, null, 8, ["modelValue", "orignal-value", "onChange", "disabled"])
          ])
        ], 64)) : (p(), h(A, { key: 0 }, [
          t[3] || (t[3] = a("label", { class: "col-sm-7 col-form-label" }, "Purchase Price", -1)),
          a("div", vbt, [
            N(o, {
              currency: "",
              modelValue: e.calcParams.purchaseprice,
              "onUpdate:modelValue": t[0] || (t[0] = (u) => e.calcParams.purchaseprice = u),
              "orignal-value": (l = e.calcParamsOrig) == null ? void 0 : l.purchaseprice,
              onChange: e.detectChange,
              disabled: e.componentBusy
            }, null, 8, ["modelValue", "orignal-value", "onChange", "disabled"])
          ])
        ], 64)),
        e.portfolioId ? P("", !0) : (p(), h(A, { key: 2 }, [
          t[5] || (t[5] = a("label", { class: "col-sm-7 col-form-label" }, "Acquisition Closing Costs", -1)),
          a("div", bbt, [
            N(o, {
              currency: "",
              modelValue: e.calcParams.titlecharges,
              "onUpdate:modelValue": t[2] || (t[2] = (u) => e.calcParams.titlecharges = u),
              "orignal-value": (c = e.calcParamsOrig) == null ? void 0 : c.titlecharges,
              onChange: e.detectChange,
              disabled: e.componentBusyAdvanced || e.isExistingInvestment
            }, null, 8, ["modelValue", "orignal-value", "onChange", "disabled"])
          ])
        ], 64))
      ])
    ])
  ]);
}
const wbt = /* @__PURE__ */ Ae(pbt, [["render", Abt]]), Cbt = me({
  name: "RehabArv",
  props: {
    loading: Boolean
  },
  emits: [
    "change"
  ],
  components: {
    NumericalInput: Aa
  },
  computed: {
    componentBusy() {
      return this.loading || this.calculating;
    },
    componentBusyAdvanced() {
      return this.loading || this.calculating || this.hasAdvanced != !0;
    },
    compareLongTerm: {
      get() {
        var e;
        return (((e = this.calcParams) == null ? void 0 : e.rentalTypeComparisons) & nt.LongTerm) == nt.LongTerm;
      },
      set(e) {
        e ? this.calcParams.rentalTypeComparisons |= nt.LongTerm : this.calcParams.rentalTypeComparisons &= ~nt.LongTerm;
      }
    },
    compareShortTerm: {
      get() {
        var e;
        return (((e = this.calcParams) == null ? void 0 : e.rentalTypeComparisons) & nt.ShortTerm) == nt.ShortTerm;
      },
      set(e) {
        e ? this.calcParams.rentalTypeComparisons |= nt.ShortTerm : this.calcParams.rentalTypeComparisons &= ~nt.ShortTerm;
      }
    },
    comparePadSplit: {
      get() {
        var e;
        return (((e = this.calcParams) == null ? void 0 : e.rentalTypeComparisons) & nt.PadSplit) == nt.PadSplit;
      },
      set(e) {
        e ? this.calcParams.rentalTypeComparisons |= nt.PadSplit : this.calcParams.rentalTypeComparisons &= ~nt.PadSplit;
      }
    },
    ...q(Te, ["access", "aclLoaded", "hasAdvanced", "canOtherAnalysisStyles"]),
    ...q(qe, ["calcParams", "calcParamsOrig", "calculatedResults", "calculating", "rentalTypes", "isExistingInvestment"])
  },
  methods: {
    number: Ve,
    currency: Ze,
    detectChange() {
      this.$emit("change");
    }
  },
  created() {
  },
  mounted() {
    this.aclLoaded.then(() => {
    });
  }
}), Sbt = { class: "card shadow-sm overflow-hidden" }, Pbt = { class: "table-responsive table-rehab-arv" }, kbt = { class: "table table-sm table-fixed mb-0" }, Ebt = { class: "text-center" }, Ibt = {
  key: 2,
  src: nn,
  alt: "PadSplit",
  title: "PadSplit",
  loading: "lazy",
  class: "img-fluid",
  width: "85"
}, Tbt = {
  key: 0,
  scope: "col",
  class: "bg-alice border-start border-bottom-0"
}, Obt = { class: "border-end bg-transparent" }, Rbt = {
  key: 0,
  rowspan: "5",
  class: "bg-alice align-middle text-center p-5"
}, Lbt = ["disabled"], Bbt = { class: "border-end bg-transparent" }, Mbt = { class: "border-end bg-transparent" }, xbt = { class: "border-end bg-transparent" }, Fbt = {
  ref: "dialogCompareRehab",
  class: "modal fade",
  id: "dialogCompareRehab",
  tabindex: "-1",
  "aria-labelledby": "dialogCompareLabel",
  "aria-hidden": "true"
}, Vbt = { class: "modal-dialog modal-dialog-centered" }, Dbt = { class: "modal-content bg-gradient-alphabet rounded" }, Nbt = { class: "modal-body py-5" }, jbt = { class: "row" }, Hbt = { class: "col-lg-7 d-flex gap-2" }, Ubt = {
  key: 0,
  class: "form-check form-check-inline"
}, zbt = {
  key: 1,
  class: "form-check form-check-inline"
}, Wbt = {
  key: 2,
  class: "form-check form-check-inline"
}, Gbt = {
  key: 1,
  class: "modal-body p-8 text-center bg-gradient-periwinkle rounded"
};
function Ybt(e, t, s, n, r, i) {
  var l, d, c;
  const o = pe("numerical-input");
  return p(), h(A, null, [
    t[34] || (t[34] = a("p", { class: "mb-3 fw-bold fs-5" }, " Rehab & ARV ", -1)),
    a("div", Sbt, [
      a("div", Pbt, [
        a("table", kbt, [
          t[26] || (t[26] = a("colgroup", null, [
            a("col"),
            a("col", { class: "bg-body-secondary" }),
            a("col"),
            a("col", { class: "bg-body-secondary" })
          ], -1)),
          a("thead", null, [
            a("tr", Ebt, [
              t[19] || (t[19] = a("th", { class: "table-column-description border-end" }, null, -1)),
              (p(!0), h(A, null, D(e.rentalTypes, (u) => (p(), h("th", {
                scope: "col",
                class: z(["text-center bg-transparent border-end", "table-column-" + u])
              }, [
                u == "long-term" ? (p(), h(A, { key: 0 }, [
                  t[15] || (t[15] = a("i", { class: "fa-light fa-calendar-range me-2" }, null, -1)),
                  t[16] || (t[16] = y("Long Term "))
                ], 64)) : u == "short-term" ? (p(), h(A, { key: 1 }, [
                  t[17] || (t[17] = a("i", { class: "fa-light fa-timer me-2" }, null, -1)),
                  t[18] || (t[18] = y("Short Term "))
                ], 64)) : u == "pad-split" ? (p(), h("img", Ibt)) : P("", !0)
              ], 2))), 256)),
              e.rentalTypes.length < 2 ? (p(), h("th", Tbt)) : P("", !0)
            ])
          ]),
          a("tbody", null, [
            a("tr", null, [
              t[22] || (t[22] = a("th", {
                scope: "row",
                class: "align-middle border-end"
              }, "Rehab Expenses", -1)),
              (p(!0), h(A, null, D(e.rentalTypes, (u) => {
                var m, f, v;
                return p(), h("td", Obt, [
                  u == "long-term" ? (p(), Fe(o, {
                    key: 0,
                    currency: "",
                    modelValue: e.calcParams.rehabamount,
                    "onUpdate:modelValue": t[0] || (t[0] = (b) => e.calcParams.rehabamount = b),
                    "orignal-value": (m = e.calcParamsOrig) == null ? void 0 : m.rehabamount,
                    onChange: e.detectChange,
                    disabled: e.componentBusyAdvanced || e.isExistingInvestment
                  }, null, 8, ["modelValue", "orignal-value", "onChange", "disabled"])) : u == "short-term" ? (p(), Fe(o, {
                    key: 1,
                    currency: "",
                    modelValue: e.calcParams.strRehabAmount,
                    "onUpdate:modelValue": t[1] || (t[1] = (b) => e.calcParams.strRehabAmount = b),
                    "orignal-value": (f = e.calcParamsOrig) == null ? void 0 : f.strRehabAmount,
                    onChange: e.detectChange,
                    disabled: e.componentBusyAdvanced || e.isExistingInvestment
                  }, null, 8, ["modelValue", "orignal-value", "onChange", "disabled"])) : u == "pad-split" ? (p(), Fe(o, {
                    key: 2,
                    currency: "",
                    modelValue: e.calcParams.padSplitRehabAmount,
                    "onUpdate:modelValue": t[2] || (t[2] = (b) => e.calcParams.padSplitRehabAmount = b),
                    "orignal-value": (v = e.calcParamsOrig) == null ? void 0 : v.padSplitRehabAmount,
                    onChange: e.detectChange,
                    disabled: e.componentBusyAdvanced || e.isExistingInvestment
                  }, null, 8, ["modelValue", "orignal-value", "onChange", "disabled"])) : P("", !0)
                ]);
              }), 256)),
              e.rentalTypes.length < 2 ? (p(), h("td", Rbt, [
                a("button", {
                  type: "button",
                  class: "btn btn-lava mb-4",
                  "data-bs-toggle": "modal",
                  "data-bs-target": "#dialogCompareRehab",
                  disabled: e.componentBusy
                }, t[20] || (t[20] = [
                  a("i", { class: "fa-light fa-plus me-1" }, null, -1),
                  y("Add Analysis Style ")
                ]), 8, Lbt),
                t[21] || (t[21] = a("p", null, "Compare the performance of multiple analysis syltes by adding an additional analysis style. Options include long term, short term and PadSplit.", -1))
              ])) : P("", !0)
            ]),
            a("tr", null, [
              t[23] || (t[23] = a("th", {
                scope: "row",
                class: "align-middle border-end"
              }, "Working Capital Reserve", -1)),
              (p(!0), h(A, null, D(e.rentalTypes, (u) => {
                var m, f, v;
                return p(), h("td", Bbt, [
                  u == "long-term" ? (p(), Fe(o, {
                    key: 0,
                    currency: "",
                    modelValue: e.calcParams.workingCapitalReserve,
                    "onUpdate:modelValue": t[3] || (t[3] = (b) => e.calcParams.workingCapitalReserve = b),
                    "orignal-value": (m = e.calcParamsOrig) == null ? void 0 : m.workingCapitalReserve,
                    onChange: e.detectChange,
                    disabled: e.componentBusyAdvanced || e.isExistingInvestment
                  }, null, 8, ["modelValue", "orignal-value", "onChange", "disabled"])) : u == "short-term" ? (p(), Fe(o, {
                    key: 1,
                    currency: "",
                    modelValue: e.calcParams.strWorkingCapitalReserve,
                    "onUpdate:modelValue": t[4] || (t[4] = (b) => e.calcParams.strWorkingCapitalReserve = b),
                    "orignal-value": (f = e.calcParamsOrig) == null ? void 0 : f.strWorkingCapitalReserve,
                    onChange: e.detectChange,
                    disabled: e.componentBusyAdvanced || e.isExistingInvestment
                  }, null, 8, ["modelValue", "orignal-value", "onChange", "disabled"])) : u == "pad-split" ? (p(), Fe(o, {
                    key: 2,
                    currency: "",
                    modelValue: e.calcParams.padSplitWorkingCapitalReserve,
                    "onUpdate:modelValue": t[5] || (t[5] = (b) => e.calcParams.padSplitWorkingCapitalReserve = b),
                    "orignal-value": (v = e.calcParamsOrig) == null ? void 0 : v.padSplitWorkingCapitalReserve,
                    onChange: e.detectChange,
                    disabled: e.componentBusyAdvanced || e.isExistingInvestment
                  }, null, 8, ["modelValue", "orignal-value", "onChange", "disabled"])) : P("", !0)
                ]);
              }), 256))
            ]),
            a("tr", null, [
              t[24] || (t[24] = a("th", {
                scope: "row",
                class: "align-middle border-end"
              }, [
                y(" Rehab/Startup Vacancy (Year 1) "),
                a("i", {
                  class: "fa-solid fa-info-circle d-none",
                  "data-popup": "explain numbers"
                })
              ], -1)),
              (p(!0), h(A, null, D(e.rentalTypes, (u) => {
                var m, f, v;
                return p(), h("td", Mbt, [
                  u == "long-term" ? (p(), Fe(o, {
                    key: 0,
                    class: "form-control",
                    modelValue: e.calcParams.rehabdays,
                    "onUpdate:modelValue": t[6] || (t[6] = (b) => e.calcParams.rehabdays = b),
                    "orignal-value": (m = e.calcParamsOrig) == null ? void 0 : m.rehabdays,
                    onChange: e.detectChange,
                    disabled: e.componentBusyAdvanced || e.isExistingInvestment
                  }, null, 8, ["modelValue", "orignal-value", "onChange", "disabled"])) : u == "short-term" ? (p(), Fe(o, {
                    key: 1,
                    class: "form-control",
                    modelValue: e.calcParams.strRehabDays,
                    "onUpdate:modelValue": t[7] || (t[7] = (b) => e.calcParams.strRehabDays = b),
                    "orignal-value": (f = e.calcParamsOrig) == null ? void 0 : f.strRehabDays,
                    onChange: e.detectChange,
                    disabled: e.componentBusyAdvanced || e.isExistingInvestment
                  }, null, 8, ["modelValue", "orignal-value", "onChange", "disabled"])) : u == "pad-split" ? (p(), Fe(o, {
                    key: 2,
                    class: "form-control",
                    modelValue: e.calcParams.padSplitRehabDays,
                    "onUpdate:modelValue": t[8] || (t[8] = (b) => e.calcParams.padSplitRehabDays = b),
                    "orignal-value": (v = e.calcParamsOrig) == null ? void 0 : v.padSplitRehabDays,
                    onChange: e.detectChange,
                    disabled: e.componentBusyAdvanced || e.isExistingInvestment
                  }, null, 8, ["modelValue", "orignal-value", "onChange", "disabled"])) : P("", !0)
                ]);
              }), 256))
            ]),
            a("tr", null, [
              t[25] || (t[25] = a("th", {
                scope: "row",
                class: "align-middle border-end"
              }, "After Repair Value (ARV)", -1)),
              (p(!0), h(A, null, D(e.rentalTypes, (u) => {
                var m, f, v;
                return p(), h("td", xbt, [
                  u == "long-term" ? (p(), Fe(o, {
                    key: 0,
                    class: "form-control",
                    modelValue: e.calcParams.arv,
                    "onUpdate:modelValue": t[9] || (t[9] = (b) => e.calcParams.arv = b),
                    "orignal-value": (m = e.calcParamsOrig) == null ? void 0 : m.arv,
                    onChange: e.detectChange,
                    disabled: e.componentBusyAdvanced || e.isExistingInvestment
                  }, null, 8, ["modelValue", "orignal-value", "onChange", "disabled"])) : u == "short-term" ? (p(), Fe(o, {
                    key: 1,
                    class: "form-control",
                    modelValue: e.calcParams.strArv,
                    "onUpdate:modelValue": t[10] || (t[10] = (b) => e.calcParams.strArv = b),
                    "orignal-value": (f = e.calcParamsOrig) == null ? void 0 : f.strArv,
                    onChange: e.detectChange,
                    disabled: e.componentBusyAdvanced || e.isExistingInvestment
                  }, null, 8, ["modelValue", "orignal-value", "onChange", "disabled"])) : u == "pad-split" ? (p(), Fe(o, {
                    key: 2,
                    class: "form-control",
                    modelValue: e.calcParams.padSplitArv,
                    "onUpdate:modelValue": t[11] || (t[11] = (b) => e.calcParams.padSplitArv = b),
                    "orignal-value": (v = e.calcParamsOrig) == null ? void 0 : v.padSplitArv,
                    onChange: e.detectChange,
                    disabled: e.componentBusyAdvanced || e.isExistingInvestment
                  }, null, 8, ["modelValue", "orignal-value", "onChange", "disabled"])) : P("", !0)
                ]);
              }), 256))
            ])
          ])
        ])
      ])
    ]),
    a("div", Fbt, [
      a("div", Vbt, [
        a("div", Dbt, [
          e.canOtherAnalysisStyles ? (p(), h(A, { key: 0 }, [
            t[31] || (t[31] = a("div", { class: "modal-header border-0 pb-0" }, [
              a("p", {
                class: "modal-title fs-5 fw-bold",
                id: "dialogCompareLabel"
              }, "Analysis Style"),
              a("button", {
                type: "button",
                class: "btn-close",
                "data-bs-dismiss": "modal",
                "aria-label": "Close"
              })
            ], -1)),
            a("div", Nbt, [
              a("div", jbt, [
                t[30] || (t[30] = a("legend", { class: "col-lg-5 col-form-label pt-0" }, " Compare Against Other Rental Types? ", -1)),
                a("div", Hbt, [
                  ((l = e.calcParams) == null ? void 0 : l.rentalType) != "long-term" ? (p(), h("div", Ubt, [
                    V(a("input", {
                      class: "form-check-input",
                      type: "checkbox",
                      id: "rLongTerm",
                      "onUpdate:modelValue": t[12] || (t[12] = (u) => e.compareLongTerm = u)
                    }, null, 512), [
                      [Ue, e.compareLongTerm]
                    ]),
                    t[27] || (t[27] = a("label", {
                      class: "form-check-label",
                      for: "rLongTerm"
                    }, "Long-Term", -1))
                  ])) : P("", !0),
                  ((d = e.calcParams) == null ? void 0 : d.rentalType) != "short-term" ? (p(), h("div", zbt, [
                    V(a("input", {
                      class: "form-check-input",
                      type: "checkbox",
                      id: "rShortTerm",
                      "onUpdate:modelValue": t[13] || (t[13] = (u) => e.compareShortTerm = u)
                    }, null, 512), [
                      [Ue, e.compareShortTerm]
                    ]),
                    t[28] || (t[28] = a("label", {
                      class: "form-check-label",
                      for: "rShortTerm"
                    }, "Short-Term", -1))
                  ])) : P("", !0),
                  ((c = e.calcParams) == null ? void 0 : c.rentalType) != "pad-split" ? (p(), h("div", Wbt, [
                    V(a("input", {
                      class: "form-check-input",
                      type: "checkbox",
                      id: "rPadSplit",
                      "onUpdate:modelValue": t[14] || (t[14] = (u) => e.comparePadSplit = u)
                    }, null, 512), [
                      [Ue, e.comparePadSplit]
                    ]),
                    t[29] || (t[29] = a("label", {
                      class: "form-check-label",
                      for: "rPadSplit"
                    }, "PadSplit", -1))
                  ])) : P("", !0)
                ])
              ])
            ]),
            t[32] || (t[32] = a("div", { class: "modal-footer border-0 pt-0" }, [
              a("button", {
                type: "button",
                class: "btn btn-lava",
                "data-bs-dismiss": "modal"
              }, "Close")
            ], -1))
          ], 64)) : (p(), h("div", Gbt, t[33] || (t[33] = [
            a("button", {
              type: "button",
              class: "btn-close position-absolute top-10 end-10",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            }, null, -1),
            a("i", { class: "fa-duotone fa-solid fa-rectangle-vertical-history mb-3 fs-2" }, null, -1),
            a("p", { class: "fw-bold fs-5" }, "Analysis Style", -1),
            y(" Upgrade to "),
            a("b", null, "Property Suite Pro", -1),
            y(" to analyze multi-family, STR, rent vs sell, and other advanced analysis styles. ")
          ])))
        ])
      ])
    ], 512)
  ], 64);
}
const Xbt = /* @__PURE__ */ Ae(Cbt, [["render", Ybt]]), qbt = me({
  name: "Resale",
  components: {
    NumericalInput: Aa
  },
  emits: [
    "change"
  ],
  computed: {
    componentBusy() {
      return this.calculating;
    },
    componentBusyAdvanced() {
      return this.calculating || this.hasAdvanced != !0;
    },
    autoHoldPeriod: {
      get() {
        var e;
        return ((e = this.calcParams) == null ? void 0 : e.hold) == 0;
      },
      set(e) {
        e ? this.calcParams.hold = 0 : this.calcParams.hold = 10;
      }
    },
    ...q(Te, ["access", "aclLoaded", "hasAdvanced"]),
    ...q(qe, ["calcParams", "calcParamsOrig", "property", "calculating", "isHoldYearAuto"])
  },
  methods: {
    number: Ve,
    detectChange() {
      this.$emit("change");
    }
  }
}), Qbt = { class: "card shadow-sm" }, Kbt = { class: "card-body" }, Zbt = { class: "row g-2" }, Jbt = { class: "col-6 col-sm-4" }, $bt = { class: "form-check form-switch form-switch-lg form-switch-basic" }, _bt = { class: "col-12 col-sm-4" }, eAt = ["disabled"], tAt = ["value"], sAt = {
  key: 1,
  class: "fw-bold"
}, aAt = { class: "col-sm-5" };
function nAt(e, t, s, n, r, i) {
  var l;
  const o = pe("numerical-input");
  return p(), h("div", Qbt, [
    t[8] || (t[8] = a("div", { class: "card-header bg-white fw-bold pb-0 border-0" }, " Resale ", -1)),
    a("div", Kbt, [
      a("div", Zbt, [
        t[6] || (t[6] = a("label", { class: "col-6 col-sm-4" }, "Hold Period", -1)),
        a("div", Jbt, [
          a("div", $bt, [
            V(a("input", {
              class: "form-check-input",
              type: "checkbox",
              role: "switch",
              id: "holdPeriod",
              "onUpdate:modelValue": t[0] || (t[0] = (d) => e.autoHoldPeriod = d),
              onChange: t[1] || (t[1] = (...d) => e.detectChange && e.detectChange(...d))
            }, null, 544), [
              [Ue, e.autoHoldPeriod]
            ]),
            t[5] || (t[5] = a("label", {
              class: "form-check-label",
              for: "holdPeriod"
            }, "Auto", -1))
          ])
        ]),
        a("div", _bt, [
          e.isHoldYearAuto ? (p(), h("span", sAt, "AUTO")) : V((p(), h("select", {
            key: 0,
            "onUpdate:modelValue": t[2] || (t[2] = (d) => e.calcParams.hold = d),
            onChange: t[3] || (t[3] = (...d) => e.detectChange && e.detectChange(...d)),
            class: "form-select",
            title: "Hold Period Years",
            disabled: e.calculating
          }, [
            (p(), h(A, null, D(30, (d) => a("option", { value: d }, g(d) + " Years", 9, tAt)), 64))
          ], 40, eAt)), [
            [We, e.calcParams.hold]
          ])
        ]),
        t[7] || (t[7] = a("label", { class: "col-sm-7 col-form-label" }, "Disposition Closing Costs", -1)),
        a("div", aAt, [
          N(o, {
            percent: "",
            modelValue: e.calcParams.costofsale,
            "onUpdate:modelValue": t[4] || (t[4] = (d) => e.calcParams.costofsale = d),
            "orignal-value": (l = e.calcParamsOrig) == null ? void 0 : l.costofsale,
            onChange: e.detectChange,
            disabled: e.componentBusyAdvanced
          }, null, 8, ["modelValue", "orignal-value", "onChange", "disabled"])
        ])
      ])
    ])
  ]);
}
const rAt = /* @__PURE__ */ Ae(qbt, [["render", nAt]]), oAt = me({
  name: "InflationAndAppreciation",
  props: {
    loading: Boolean
  },
  emits: [
    "change"
  ],
  components: {
    NumericalInput: Aa
  },
  computed: {
    componentBusy() {
      return this.loading || this.calculating;
    },
    componentBusyAdvanced() {
      return this.loading || this.calculating || this.hasAdvanced != !0;
    },
    compareLongTerm: {
      get() {
        var e;
        return (((e = this.calcParams) == null ? void 0 : e.rentalTypeComparisons) & nt.LongTerm) == nt.LongTerm;
      },
      set(e) {
        e ? this.calcParams.rentalTypeComparisons |= nt.LongTerm : this.calcParams.rentalTypeComparisons &= ~nt.LongTerm;
      }
    },
    compareShortTerm: {
      get() {
        var e;
        return (((e = this.calcParams) == null ? void 0 : e.rentalTypeComparisons) & nt.ShortTerm) == nt.ShortTerm;
      },
      set(e) {
        e ? this.calcParams.rentalTypeComparisons |= nt.ShortTerm : this.calcParams.rentalTypeComparisons &= ~nt.ShortTerm;
      }
    },
    comparePadSplit: {
      get() {
        var e;
        return (((e = this.calcParams) == null ? void 0 : e.rentalTypeComparisons) & nt.PadSplit) == nt.PadSplit;
      },
      set(e) {
        e ? this.calcParams.rentalTypeComparisons |= nt.PadSplit : this.calcParams.rentalTypeComparisons &= ~nt.PadSplit;
      }
    },
    ...q(Te, ["access", "aclLoaded", "hasAdvanced", "canOtherAnalysisStyles"]),
    ...q(qe, ["calcParams", "calcParamsOrig", "calculatedResults", "calculating", "rentalTypes"]),
    ...q(ba, ["portfolioId"])
  },
  methods: {
    number: Ve,
    currency: Ze,
    showCompareDialog() {
      var e;
      (e = bootstrap.Modal.getOrCreateInstance(this.$refs.dialogCompare)) == null || e.show();
    },
    detectChange() {
      this.$emit("change");
    }
  },
  created() {
  },
  mounted() {
    this.aclLoaded.then(() => {
    });
  }
}), iAt = { class: "card shadow-sm overflow-hidden" }, lAt = { class: "table-responsive table-inflation" }, dAt = { class: "table table-sm table-fixed mb-0" }, cAt = {
  key: 2,
  src: nn,
  alt: "PadSplit",
  title: "PadSplit",
  loading: "lazy",
  class: "img-fluid",
  width: "85"
}, uAt = {
  key: 0,
  scope: "col",
  class: "bg-alice border-start border-bottom-0"
}, pAt = { class: "border-end bg-transparent" }, hAt = {
  key: 0,
  rowspan: "3",
  class: "bg-alice align-middle text-center px-5 py-3 border-start border-bottom-0"
}, mAt = ["disabled"], fAt = { class: "border-end bg-transparent" }, gAt = { class: "border-end bg-transparent" }, vAt = {
  ref: "dialogCompare",
  class: "modal fade",
  id: "dialogCompare",
  tabindex: "-1",
  "aria-labelledby": "dialogCompareLabel",
  "aria-hidden": "true"
}, yAt = { class: "modal-dialog modal-dialog-centered" }, bAt = { class: "modal-content bg-gradient-alphabet rounded" }, AAt = { class: "modal-body py-5" }, wAt = { class: "row" }, CAt = { class: "col-lg-7 d-flex gap-2" }, SAt = {
  key: 0,
  class: "form-check form-check-inline"
}, PAt = {
  key: 1,
  class: "form-check form-check-inline"
}, kAt = {
  key: 2,
  class: "form-check form-check-inline"
}, EAt = {
  key: 1,
  class: "modal-body p-8 text-center bg-gradient-periwinkle rounded"
};
function IAt(e, t, s, n, r, i) {
  var l, d, c;
  const o = pe("numerical-input");
  return p(), h(A, null, [
    t[31] || (t[31] = a("p", { class: "mb-3 fw-bold fs-5" }, " Inflation & Appreciation ", -1)),
    a("div", iAt, [
      a("div", lAt, [
        a("table", dAt, [
          t[23] || (t[23] = a("colgroup", null, [
            a("col"),
            a("col", { class: "bg-body-secondary" }),
            a("col"),
            a("col", { class: "bg-body-secondary" })
          ], -1)),
          a("thead", null, [
            a("tr", null, [
              t[17] || (t[17] = a("th", {
                scope: "col",
                class: "table-column-description border-end"
              }, " ", -1)),
              (p(!0), h(A, null, D(e.rentalTypes, (u) => (p(), h("th", {
                scope: "col",
                class: z(["table-column-" + u, "text-center bg-transparent border-end"])
              }, [
                u == "long-term" ? (p(), h(A, { key: 0 }, [
                  t[13] || (t[13] = a("i", { class: "fa-light fa-calendar-range me-2" }, null, -1)),
                  t[14] || (t[14] = y("Long Term "))
                ], 64)) : u == "short-term" ? (p(), h(A, { key: 1 }, [
                  t[15] || (t[15] = a("i", { class: "fa-light fa-timer me-2" }, null, -1)),
                  t[16] || (t[16] = y("Short Term "))
                ], 64)) : u == "pad-split" ? (p(), h("img", cAt)) : P("", !0)
              ], 2))), 256)),
              e.rentalTypes.length < 2 ? (p(), h("th", uAt)) : P("", !0)
            ])
          ]),
          a("tbody", null, [
            a("tr", null, [
              t[20] || (t[20] = a("th", {
                scope: "row",
                class: "border-end"
              }, [
                y(" Annual Rental Rate Increase "),
                a("i", {
                  class: "fa-solid fa-info-circle d-none",
                  "data-popup": "explain numbers"
                })
              ], -1)),
              (p(!0), h(A, null, D(e.rentalTypes, (u) => {
                var m, f, v;
                return p(), h("td", pAt, [
                  u == "long-term" ? (p(), Fe(o, {
                    key: 0,
                    percent: "",
                    modelValue: e.calcParams.annualrentalgrowth,
                    "onUpdate:modelValue": t[0] || (t[0] = (b) => e.calcParams.annualrentalgrowth = b),
                    "orignal-value": (m = e.calcParamsOrig) == null ? void 0 : m.annualrentalgrowth,
                    onChange: e.detectChange,
                    disabled: e.componentBusyAdvanced
                  }, null, 8, ["modelValue", "orignal-value", "onChange", "disabled"])) : P("", !0),
                  u == "short-term" ? (p(), Fe(o, {
                    key: 1,
                    percent: "",
                    modelValue: e.calcParams.strAnnualRentalGrowth,
                    "onUpdate:modelValue": t[1] || (t[1] = (b) => e.calcParams.strAnnualRentalGrowth = b),
                    "orignal-value": (f = e.calcParamsOrig) == null ? void 0 : f.strAnnualRentalGrowth,
                    onChange: e.detectChange,
                    disabled: e.componentBusyAdvanced
                  }, null, 8, ["modelValue", "orignal-value", "onChange", "disabled"])) : P("", !0),
                  u == "pad-split" ? (p(), Fe(o, {
                    key: 2,
                    percent: "",
                    modelValue: e.calcParams.padSplitAnnualRentalGrowth,
                    "onUpdate:modelValue": t[2] || (t[2] = (b) => e.calcParams.padSplitAnnualRentalGrowth = b),
                    "orignal-value": (v = e.calcParamsOrig) == null ? void 0 : v.padSplitAnnualRentalGrowth,
                    onChange: e.detectChange,
                    disabled: e.componentBusyAdvanced
                  }, null, 8, ["modelValue", "orignal-value", "onChange", "disabled"])) : P("", !0)
                ]);
              }), 256)),
              e.rentalTypes.length < 2 ? (p(), h("td", hAt, [
                e.portfolioId ? P("", !0) : (p(), h(A, { key: 0 }, [
                  a("button", {
                    type: "button",
                    class: "btn btn-lava mb-4",
                    onClick: t[3] || (t[3] = (...u) => e.showCompareDialog && e.showCompareDialog(...u)),
                    disabled: e.componentBusy
                  }, t[18] || (t[18] = [
                    a("i", { class: "fa-light fa-plus me-1" }, null, -1),
                    y("Add Analysis Style ")
                  ]), 8, mAt),
                  t[19] || (t[19] = a("p", { class: "mb-0" }, "Compare the performance of multiple analysis syltes by adding an additional analysis style. Options include long term, short term and PadSplit.", -1))
                ], 64))
              ])) : P("", !0)
            ]),
            a("tr", null, [
              t[21] || (t[21] = a("th", {
                scope: "row",
                class: "border-end"
              }, " Annual Expense Inflation ", -1)),
              (p(!0), h(A, null, D(e.rentalTypes, (u) => {
                var m, f, v;
                return p(), h("td", fAt, [
                  u == "long-term" ? (p(), Fe(o, {
                    key: 0,
                    percent: "",
                    modelValue: e.calcParams.annualexpensegrowth,
                    "onUpdate:modelValue": t[4] || (t[4] = (b) => e.calcParams.annualexpensegrowth = b),
                    "orignal-value": (m = e.calcParamsOrig) == null ? void 0 : m.annualexpensegrowth,
                    onChange: e.detectChange,
                    disabled: e.componentBusyAdvanced
                  }, null, 8, ["modelValue", "orignal-value", "onChange", "disabled"])) : P("", !0),
                  u == "short-term" ? (p(), Fe(o, {
                    key: 1,
                    percent: "",
                    modelValue: e.calcParams.strAnnualExpenseGrowth,
                    "onUpdate:modelValue": t[5] || (t[5] = (b) => e.calcParams.strAnnualExpenseGrowth = b),
                    "orignal-value": (f = e.calcParamsOrig) == null ? void 0 : f.strAnnualExpenseGrowth,
                    onChange: e.detectChange,
                    disabled: e.componentBusyAdvanced
                  }, null, 8, ["modelValue", "orignal-value", "onChange", "disabled"])) : P("", !0),
                  u == "pad-split" ? (p(), Fe(o, {
                    key: 2,
                    percent: "",
                    modelValue: e.calcParams.padSplitAnnualExpenseGrowth,
                    "onUpdate:modelValue": t[6] || (t[6] = (b) => e.calcParams.padSplitAnnualExpenseGrowth = b),
                    "orignal-value": (v = e.calcParamsOrig) == null ? void 0 : v.padSplitAnnualExpenseGrowth,
                    onChange: e.detectChange,
                    disabled: e.componentBusyAdvanced
                  }, null, 8, ["modelValue", "orignal-value", "onChange", "disabled"])) : P("", !0)
                ]);
              }), 256))
            ]),
            a("tr", null, [
              t[22] || (t[22] = a("th", {
                scope: "row",
                class: "border-end"
              }, " Annual Property Appreciation ", -1)),
              (p(!0), h(A, null, D(e.rentalTypes, (u) => {
                var m, f, v;
                return p(), h("td", gAt, [
                  u == "long-term" ? (p(), Fe(o, {
                    key: 0,
                    percent: "",
                    modelValue: e.calcParams.propertyappreciation,
                    "onUpdate:modelValue": t[7] || (t[7] = (b) => e.calcParams.propertyappreciation = b),
                    "orignal-value": (m = e.calcParamsOrig) == null ? void 0 : m.propertyappreciation,
                    onChange: e.detectChange,
                    disabled: e.componentBusyAdvanced
                  }, null, 8, ["modelValue", "orignal-value", "onChange", "disabled"])) : P("", !0),
                  u == "short-term" ? (p(), Fe(o, {
                    key: 1,
                    percent: "",
                    modelValue: e.calcParams.strPropertyAppreciation,
                    "onUpdate:modelValue": t[8] || (t[8] = (b) => e.calcParams.strPropertyAppreciation = b),
                    "orignal-value": (f = e.calcParamsOrig) == null ? void 0 : f.strPropertyAppreciation,
                    onChange: e.detectChange,
                    disabled: e.componentBusyAdvanced
                  }, null, 8, ["modelValue", "orignal-value", "onChange", "disabled"])) : P("", !0),
                  u == "pad-split" ? (p(), Fe(o, {
                    key: 2,
                    percent: "",
                    modelValue: e.calcParams.padSplitPropertyAppreciation,
                    "onUpdate:modelValue": t[9] || (t[9] = (b) => e.calcParams.padSplitPropertyAppreciation = b),
                    "orignal-value": (v = e.calcParamsOrig) == null ? void 0 : v.padSplitPropertyAppreciation,
                    onChange: e.detectChange,
                    disabled: e.componentBusyAdvanced
                  }, null, 8, ["modelValue", "orignal-value", "onChange", "disabled"])) : P("", !0)
                ]);
              }), 256))
            ])
          ])
        ])
      ])
    ]),
    a("div", vAt, [
      a("div", yAt, [
        a("div", bAt, [
          e.canOtherAnalysisStyles ? (p(), h(A, { key: 0 }, [
            t[28] || (t[28] = a("div", { class: "modal-header border-bottom-0 pb-0" }, [
              a("p", {
                class: "modal-title fs-5 fw-bold",
                id: "dialogCompareLabel"
              }, "Analysis Style"),
              a("button", {
                type: "button",
                class: "btn-close",
                "data-bs-dismiss": "modal",
                "aria-label": "Close"
              })
            ], -1)),
            a("div", AAt, [
              a("div", wAt, [
                t[27] || (t[27] = a("legend", { class: "col-lg-5 col-form-label pt-0" }, " Compare Against Other Rental Types? ", -1)),
                a("div", CAt, [
                  ((l = e.calcParams) == null ? void 0 : l.rentalType) != "long-term" ? (p(), h("div", SAt, [
                    V(a("input", {
                      class: "form-check-input",
                      type: "checkbox",
                      id: "longTerm",
                      "onUpdate:modelValue": t[10] || (t[10] = (u) => e.compareLongTerm = u)
                    }, null, 512), [
                      [Ue, e.compareLongTerm]
                    ]),
                    t[24] || (t[24] = a("label", {
                      class: "form-check-label",
                      for: "longTerm"
                    }, "Long-Term", -1))
                  ])) : P("", !0),
                  ((d = e.calcParams) == null ? void 0 : d.rentalType) != "short-term" ? (p(), h("div", PAt, [
                    V(a("input", {
                      class: "form-check-input",
                      type: "checkbox",
                      id: "shortTerm",
                      "onUpdate:modelValue": t[11] || (t[11] = (u) => e.compareShortTerm = u)
                    }, null, 512), [
                      [Ue, e.compareShortTerm]
                    ]),
                    t[25] || (t[25] = a("label", {
                      class: "form-check-label",
                      for: "shortTerm"
                    }, "Short-Term", -1))
                  ])) : P("", !0),
                  ((c = e.calcParams) == null ? void 0 : c.rentalType) != "pad-split" ? (p(), h("div", kAt, [
                    V(a("input", {
                      class: "form-check-input",
                      type: "checkbox",
                      id: "padSplit",
                      "onUpdate:modelValue": t[12] || (t[12] = (u) => e.comparePadSplit = u)
                    }, null, 512), [
                      [Ue, e.comparePadSplit]
                    ]),
                    t[26] || (t[26] = a("label", {
                      class: "form-check-label",
                      for: "padSplit"
                    }, "PadSplit", -1))
                  ])) : P("", !0)
                ])
              ])
            ]),
            t[29] || (t[29] = a("div", { class: "modal-footer pt-0 border-0" }, [
              a("button", {
                type: "button",
                class: "btn btn-lava",
                "data-bs-dismiss": "modal"
              }, "Close")
            ], -1))
          ], 64)) : (p(), h("div", EAt, t[30] || (t[30] = [
            a("button", {
              type: "button",
              class: "btn-close position-absolute top-10 end-10",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            }, null, -1),
            a("i", { class: "fa-duotone fa-solid fa-rectangle-vertical-history mb-3 fs-2" }, null, -1),
            a("p", { class: "fw-bold fs-5" }, "Analysis Style", -1),
            y(" Upgrade to "),
            a("b", null, "Property Suite Pro", -1),
            y(" to analyze multi-family, STR, rent vs sell, and other advanced analysis styles. ")
          ])))
        ])
      ])
    ], 512)
  ], 64);
}
const TAt = /* @__PURE__ */ Ae(oAt, [["render", IAt]]), OAt = me({
  name: "ExpenseAccounts",
  props: {
    loading: Boolean
  },
  emits: [
    "change"
  ],
  components: {
    NumericalInput: Aa
  },
  data() {
    return {
      showAllAccounts: !1,
      forceShow: []
    };
  },
  computed: {
    componentBusy() {
      return this.loading || this.calculating;
    },
    componentBusyAdvanced() {
      return this.loading || this.calculating || this.hasAdvanced != !0;
    },
    allowEmptyParams() {
      var e, t;
      return this.isExistingInvestment == !0 && ((t = (e = this.purchaseFacts) == null ? void 0 : e.years) == null ? void 0 : t.length) > 0;
    },
    isManagementFeePercent: {
      get() {
        return (this.calcParams.percentageLongTermFields & U.PropertyManagement) == U.PropertyManagement;
      },
      set(e) {
        e ? this.calcParams.percentageLongTermFields |= U.PropertyManagement : this.calcParams.percentageLongTermFields &= ~U.PropertyManagement;
      }
    },
    isLeasingCommissionsPercent: {
      get() {
        return (this.calcParams.percentageLongTermFields & U.LeasingCommissions) == U.LeasingCommissions;
      },
      set(e) {
        e ? this.calcParams.percentageLongTermFields |= U.LeasingCommissions : this.calcParams.percentageLongTermFields &= ~U.LeasingCommissions;
      }
    },
    isLeaseRenewalFeePercent: {
      get() {
        return (this.calcParams.percentageLongTermFields & U.LeaseRenewalFee) == U.LeaseRenewalFee;
      },
      set(e) {
        e ? this.calcParams.percentageLongTermFields |= U.LeaseRenewalFee : this.calcParams.percentageLongTermFields &= ~U.LeaseRenewalFee;
      }
    },
    isPlatformServiceFeesPercent: {
      get() {
        return (this.calcParams.percentageLongTermFields & U.PlatformServiceFees) == U.PlatformServiceFees;
      },
      set(e) {
        e ? this.calcParams.percentageLongTermFields |= U.PlatformServiceFees : this.calcParams.percentageLongTermFields &= ~U.PlatformServiceFees;
      }
    },
    isMaintenancePercent: {
      get() {
        return (this.calcParams.percentageLongTermFields & U.PropertyMaintenance) == U.PropertyMaintenance;
      },
      set(e) {
        e ? this.calcParams.percentageLongTermFields |= U.PropertyMaintenance : this.calcParams.percentageLongTermFields &= ~U.PropertyMaintenance;
      }
    },
    isUtilityExpensesPercent: {
      get() {
        return (this.calcParams.percentageLongTermFields & U.UtilityExpenses) == U.UtilityExpenses;
      },
      set(e) {
        e ? this.calcParams.percentageLongTermFields |= U.UtilityExpenses : this.calcParams.percentageLongTermFields &= ~U.UtilityExpenses;
      }
    },
    isFurnishingExpensesPercent: {
      get() {
        return (this.calcParams.percentageLongTermFields & U.FurnishingExpenses) == U.FurnishingExpenses;
      },
      set(e) {
        e ? this.calcParams.percentageLongTermFields |= U.FurnishingExpenses : this.calcParams.percentageLongTermFields &= ~U.FurnishingExpenses;
      }
    },
    isConsumableExpensesPercent: {
      get() {
        return (this.calcParams.percentageLongTermFields & U.ConsumableExpenses) == U.ConsumableExpenses;
      },
      set(e) {
        e ? this.calcParams.percentageLongTermFields |= U.ConsumableExpenses : this.calcParams.percentageLongTermFields &= ~U.ConsumableExpenses;
      }
    },
    isCleaningExpensesPercent: {
      get() {
        return (this.calcParams.percentageLongTermFields & U.CleaningExpenses) == U.CleaningExpenses;
      },
      set(e) {
        e ? this.calcParams.percentageLongTermFields |= U.CleaningExpenses : this.calcParams.percentageLongTermFields &= ~U.CleaningExpenses;
      }
    },
    isOtherExpensePercent: {
      get() {
        return (this.calcParams.percentageLongTermFields & U.OtherExpense) == U.OtherExpense;
      },
      set(e) {
        e ? this.calcParams.percentageLongTermFields |= U.OtherExpense : this.calcParams.percentageLongTermFields &= ~U.OtherExpense;
      }
    },
    isCapitalExpendituresPercent: {
      get() {
        return (this.calcParams.percentageLongTermFields & U.CapitalExpenditures) == U.CapitalExpenditures;
      },
      set(e) {
        e ? this.calcParams.percentageLongTermFields |= U.CapitalExpenditures : this.calcParams.percentageLongTermFields &= ~U.CapitalExpenditures;
      }
    },
    //#region Short Term
    isStrManagementFeePercent: {
      get() {
        return (this.calcParams.percentageShortTermFields & U.PropertyManagement) == U.PropertyManagement;
      },
      set(e) {
        e ? this.calcParams.percentageShortTermFields |= U.PropertyManagement : this.calcParams.percentageShortTermFields &= ~U.PropertyManagement;
      }
    },
    isStrLeasingCommissionsPercent: {
      get() {
        return (this.calcParams.percentageShortTermFields & U.LeasingCommissions) == U.LeasingCommissions;
      },
      set(e) {
        e ? this.calcParams.percentageShortTermFields |= U.LeasingCommissions : this.calcParams.percentageShortTermFields &= ~U.LeasingCommissions;
      }
    },
    isStrPlatformServiceFeesPercent: {
      get() {
        return (this.calcParams.percentageShortTermFields & U.PlatformServiceFees) == U.PlatformServiceFees;
      },
      set(e) {
        e ? this.calcParams.percentageShortTermFields |= U.PlatformServiceFees : this.calcParams.percentageShortTermFields &= ~U.PlatformServiceFees;
      }
    },
    isStrMaintenancePercent: {
      get() {
        return (this.calcParams.percentageShortTermFields & U.PropertyMaintenance) == U.PropertyMaintenance;
      },
      set(e) {
        e ? this.calcParams.percentageShortTermFields |= U.PropertyMaintenance : this.calcParams.percentageShortTermFields &= ~U.PropertyMaintenance;
      }
    },
    isStrUtilityExpensesPercent: {
      get() {
        return (this.calcParams.percentageShortTermFields & U.UtilityExpenses) == U.UtilityExpenses;
      },
      set(e) {
        e ? this.calcParams.percentageShortTermFields |= U.UtilityExpenses : this.calcParams.percentageShortTermFields &= ~U.UtilityExpenses;
      }
    },
    isStrFurnishingExpensesPercent: {
      get() {
        return (this.calcParams.percentageShortTermFields & U.FurnishingExpenses) == U.FurnishingExpenses;
      },
      set(e) {
        e ? this.calcParams.percentageShortTermFields |= U.FurnishingExpenses : this.calcParams.percentageShortTermFields &= ~U.FurnishingExpenses;
      }
    },
    isStrConsumableExpensesPercent: {
      get() {
        return (this.calcParams.percentageShortTermFields & U.ConsumableExpenses) == U.ConsumableExpenses;
      },
      set(e) {
        e ? this.calcParams.percentageShortTermFields |= U.ConsumableExpenses : this.calcParams.percentageShortTermFields &= ~U.ConsumableExpenses;
      }
    },
    isStrCleaningExpensesPercent: {
      get() {
        return (this.calcParams.percentageShortTermFields & U.CleaningExpenses) == U.CleaningExpenses;
      },
      set(e) {
        e ? this.calcParams.percentageShortTermFields |= U.CleaningExpenses : this.calcParams.percentageShortTermFields &= ~U.CleaningExpenses;
      }
    },
    isStrOtherExpensePercent: {
      get() {
        return (this.calcParams.percentageShortTermFields & U.OtherExpense) == U.OtherExpense;
      },
      set(e) {
        e ? this.calcParams.percentageShortTermFields |= U.OtherExpense : this.calcParams.percentageShortTermFields &= ~U.OtherExpense;
      }
    },
    isStrCapitalExpendituresPercent: {
      get() {
        return (this.calcParams.percentageShortTermFields & U.CapitalExpenditures) == U.CapitalExpenditures;
      },
      set(e) {
        e ? this.calcParams.percentageShortTermFields |= U.CapitalExpenditures : this.calcParams.percentageShortTermFields &= ~U.CapitalExpenditures;
      }
    },
    //#endregion
    //#region PadSplit
    isPadSplitManagementFeePercent: {
      get() {
        return (this.calcParams.percentagePadSplitFields & U.PropertyManagement) == U.PropertyManagement;
      },
      set(e) {
        e ? this.calcParams.percentagePadSplitFields |= U.PropertyManagement : this.calcParams.percentagePadSplitFields &= ~U.PropertyManagement;
      }
    },
    isPadSplitLeasingCommissionsPercent: {
      get() {
        return (this.calcParams.percentagePadSplitFields & U.LeasingCommissions) == U.LeasingCommissions;
      },
      set(e) {
        e ? this.calcParams.percentagePadSplitFields |= U.LeasingCommissions : this.calcParams.percentagePadSplitFields &= ~U.LeasingCommissions;
      }
    },
    isPadSplitMaintenancePercent: {
      get() {
        return (this.calcParams.percentagePadSplitFields & U.PropertyMaintenance) == U.PropertyMaintenance;
      },
      set(e) {
        e ? this.calcParams.percentagePadSplitFields |= U.PropertyMaintenance : this.calcParams.percentagePadSplitFields &= ~U.PropertyMaintenance;
      }
    },
    isPadSplitUtilityExpensesPercent: {
      get() {
        return (this.calcParams.percentagePadSplitFields & U.UtilityExpenses) == U.UtilityExpenses;
      },
      set(e) {
        e ? this.calcParams.percentagePadSplitFields |= U.UtilityExpenses : this.calcParams.percentagePadSplitFields &= ~U.UtilityExpenses;
      }
    },
    isPadSplitFurnishingExpensesPercent: {
      get() {
        return (this.calcParams.percentagePadSplitFields & U.FurnishingExpenses) == U.FurnishingExpenses;
      },
      set(e) {
        e ? this.calcParams.percentagePadSplitFields |= U.FurnishingExpenses : this.calcParams.percentagePadSplitFields &= ~U.FurnishingExpenses;
      }
    },
    isPadSplitConsumableExpensesPercent: {
      get() {
        return (this.calcParams.percentagePadSplitFields & U.ConsumableExpenses) == U.ConsumableExpenses;
      },
      set(e) {
        e ? this.calcParams.percentagePadSplitFields |= U.ConsumableExpenses : this.calcParams.percentagePadSplitFields &= ~U.ConsumableExpenses;
      }
    },
    isPadSplitCleaningExpensesPercent: {
      get() {
        return (this.calcParams.percentagePadSplitFields & U.CleaningExpenses) == U.CleaningExpenses;
      },
      set(e) {
        e ? this.calcParams.percentagePadSplitFields |= U.CleaningExpenses : this.calcParams.percentagePadSplitFields &= ~U.CleaningExpenses;
      }
    },
    isPadSplitOtherExpensePercent: {
      get() {
        return (this.calcParams.percentagePadSplitFields & U.OtherExpense) == U.OtherExpense;
      },
      set(e) {
        e ? this.calcParams.percentagePadSplitFields |= U.OtherExpense : this.calcParams.percentagePadSplitFields &= ~U.OtherExpense;
      }
    },
    isPadSplitCapitalExpendituresPercent: {
      get() {
        return (this.calcParams.percentagePadSplitFields & U.CapitalExpenditures) == U.CapitalExpenditures;
      },
      set(e) {
        e ? this.calcParams.percentagePadSplitFields |= U.CapitalExpenditures : this.calcParams.percentagePadSplitFields &= ~U.CapitalExpenditures;
      }
    },
    //#endregion
    compareLongTerm: {
      get() {
        var e;
        return (((e = this.calcParams) == null ? void 0 : e.rentalTypeComparisons) & nt.LongTerm) == nt.LongTerm;
      },
      set(e) {
        e ? this.calcParams.rentalTypeComparisons |= nt.LongTerm : this.calcParams.rentalTypeComparisons &= ~nt.LongTerm;
      }
    },
    compareShortTerm: {
      get() {
        var e;
        return (((e = this.calcParams) == null ? void 0 : e.rentalTypeComparisons) & nt.ShortTerm) == nt.ShortTerm;
      },
      set(e) {
        e ? this.calcParams.rentalTypeComparisons |= nt.ShortTerm : this.calcParams.rentalTypeComparisons &= ~nt.ShortTerm;
      }
    },
    comparePadSplit: {
      get() {
        var e;
        return (((e = this.calcParams) == null ? void 0 : e.rentalTypeComparisons) & nt.PadSplit) == nt.PadSplit;
      },
      set(e) {
        e ? this.calcParams.rentalTypeComparisons |= nt.PadSplit : this.calcParams.rentalTypeComparisons &= ~nt.PadSplit;
      }
    },
    ...q(Te, ["access", "aclLoaded", "hasAdvanced", "canOtherAnalysisStyles", "canManageIEAccounts"]),
    ...q(ct, ["otherExpenseAccounts", "otherNonOperatingExpenseAccounts", "otherIncomeAccounts", "incomeAccounts"]),
    ...q(qe, ["calcParams", "calcParamsOrig", "purchaseFacts", "calculating", "isExistingInvestment", "rentalTypes"]),
    ...q(Ci, ["notifications"]),
    ...q(ba, ["portfolioId"])
  },
  methods: {
    number: Ve,
    detectChange() {
      this.$emit("change");
    },
    showAccount(e) {
      var t, s, n, r, i;
      return this.showAllAccounts || this.forceShow.find((o) => o == e.id) != null || ((s = (t = this.calcParams.otherExpenses) == null ? void 0 : t.longTerm.find((o) => o.id == e.id)) == null ? void 0 : s.total) > 0 || ((r = (n = this.calcParams.otherExpenses) == null ? void 0 : n.shortTerm.find((o) => o.id == e.id)) == null ? void 0 : r.total) > 0 || ((i = this.notifications) == null ? void 0 : i.some((o) => pi(o.eventId) && o.properties.accountId == `${e.id}`));
    },
    addAccount(e) {
      var t;
      this.forceShow.find((s) => s == e.id) || this.forceShow.push(e.id), (t = bootstrap.Modal.getOrCreateInstance(this.$refs.dialogAccounts)) == null || t.hide();
    },
    accountHasError(e) {
      var t;
      return (t = this.notifications) == null ? void 0 : t.some((s) => pi(s.eventId) && s.properties.accountId == `${e.id}`);
    },
    showCompareDialog() {
      var e;
      (e = bootstrap.Modal.getOrCreateInstance(this.$refs.dialogCompare)) == null || e.show();
    }
  },
  created() {
  },
  mounted() {
    this.aclLoaded.then(() => {
    });
  }
}), RAt = { class: "card shadow-sm overflow-hidden" }, LAt = { class: "table-responsive table-operating-expenses" }, BAt = { class: "table table-sm table-fixed mb-0" }, MAt = {
  key: 2,
  src: nn,
  alt: "PadSplit",
  title: "PadSplit",
  loading: "lazy",
  class: "img-fluid",
  width: "85"
}, xAt = {
  key: 0,
  scope: "col",
  class: "bg-alice border-start border-bottom-0"
}, FAt = {
  key: 0,
  class: "border-end bg-transparent"
}, VAt = ["colspan"], DAt = ["rowspan"], NAt = ["disabled"], jAt = {
  key: 0,
  class: "border-end bg-transparent"
}, HAt = { class: "border-end bg-transparent" }, UAt = { class: "border-end bg-transparent" }, zAt = { class: "faded text-dark text-opacity-25" }, WAt = { class: "align-middle border-end bg-transparent" }, GAt = {
  key: 1,
  class: "faded text-dark text-opacity-25"
}, YAt = { class: "align-middle border-end bg-transparent" }, XAt = {
  key: 1,
  class: "faded text-dark text-opacity-25"
}, qAt = { class: "align-middle border-end bg-transparent" }, QAt = {
  key: 3,
  class: "faded text-dark text-opacity-25"
}, KAt = { class: "align-middle border-end bg-transparent" }, ZAt = { class: "align-middle border-end bg-transparent" }, JAt = { class: "align-middle border-end bg-transparent" }, $At = { class: "align-middle border-end bg-transparent" }, _At = { class: "align-middle border-end bg-transparent" }, e0t = {
  scope: "row",
  class: "align-middle border-end"
}, t0t = { class: "align-middle border-end" }, s0t = { class: "align-middle border-end bg-transparent" }, a0t = ["colspan"], n0t = { class: "d-flex justify-content-start gap-2 p-2" }, r0t = ["disabled"], o0t = ["disabled"], i0t = ["disabled"], l0t = {
  key: 0,
  class: "bg-alice border-start"
}, d0t = {
  ref: "dialogAccounts",
  class: "modal fade",
  id: "dialogAccounts",
  tabindex: "-1",
  "aria-labelledby": "dialogAccountsLabel",
  "aria-hidden": "true"
}, c0t = { class: "modal-dialog modal-dialog-centered" }, u0t = { class: "modal-content bg-gradient-alphabet rounded" }, p0t = { class: "modal-body rounded-top-0" }, h0t = { class: "bg-white bg-opacity-50 rounded shadow mt-4 mb-3 p-2" }, m0t = {
  key: 0,
  class: "table mb-0 table-transparent"
}, f0t = { key: 0 }, g0t = {
  key: 0,
  class: "badge rounded-pill text-bg-lava me-2"
}, v0t = { class: "text-end" }, y0t = ["onClick"], b0t = {
  key: 1,
  class: "modal-body p-8 text-center rounded"
}, A0t = {
  ref: "dialogCompare",
  class: "modal fade",
  id: "dialogCompare",
  tabindex: "-1",
  "aria-labelledby": "dialogCompareLabel",
  "aria-hidden": "true"
}, w0t = { class: "modal-dialog modal-dialog-centered" }, C0t = { class: "modal-content bg-gradient-alphabet rounded" }, S0t = { class: "modal-body py-5" }, P0t = { class: "row" }, k0t = { class: "col-lg-7 d-flex gap-2" }, E0t = {
  key: 0,
  class: "form-check form-check-inline"
}, I0t = {
  key: 1,
  class: "form-check form-check-inline"
}, T0t = {
  key: 2,
  class: "form-check form-check-inline"
}, O0t = {
  key: 1,
  class: "modal-body p-8 text-center rounded"
};
function R0t(e, t, s, n, r, i) {
  var l, d, c, u, m;
  const o = pe("numerical-input");
  return p(), h(A, null, [
    t[95] || (t[95] = a("p", { class: "mb-3 fw-bold fs-5" }, " Operating Expenses ", -1)),
    a("div", RAt, [
      a("div", LAt, [
        a("table", BAt, [
          t[83] || (t[83] = a("colgroup", null, [
            a("col"),
            a("col", { class: "bg-body-secondary" }),
            a("col"),
            a("col", { class: "bg-body-secondary" })
          ], -1)),
          a("thead", null, [
            a("tr", null, [
              t[66] || (t[66] = a("th", {
                scope: "col",
                class: "table-column-description border-end"
              }, " ", -1)),
              (p(!0), h(A, null, D(e.rentalTypes, (f) => (p(), h("th", {
                scope: "col",
                class: z(["text-center bg-transparent border-end", "table-column-" + f])
              }, [
                f == "long-term" ? (p(), h(A, { key: 0 }, [
                  t[62] || (t[62] = a("i", { class: "fa-light fa-calendar-range me-2" }, null, -1)),
                  t[63] || (t[63] = y("Long Term "))
                ], 64)) : f == "short-term" ? (p(), h(A, { key: 1 }, [
                  t[64] || (t[64] = a("i", { class: "fa-light fa-timer me-2" }, null, -1)),
                  t[65] || (t[65] = y("Short Term "))
                ], 64)) : f == "pad-split" ? (p(), h("img", MAt)) : P("", !0)
              ], 2))), 256)),
              e.rentalTypes.length < 2 && !e.portfolioId ? (p(), h("th", xAt)) : P("", !0)
            ])
          ]),
          a("tbody", null, [
            a("tr", null, [
              t[69] || (t[69] = a("th", {
                scope: "row",
                class: "align-middle border-end"
              }, "Property Tax", -1)),
              e.rentalTypes.length > 0 ? (p(), h("td", FAt, [
                N(o, {
                  onChange: e.detectChange,
                  modelValue: e.calcParams.propertytax,
                  "onUpdate:modelValue": t[0] || (t[0] = (f) => e.calcParams.propertytax = f),
                  currency: "",
                  "orignal-value": (l = e.calcParamsOrig) == null ? void 0 : l.propertytax,
                  placeholder: "Not Set",
                  "allow-empty": e.allowEmptyParams,
                  disabled: e.componentBusy
                }, null, 8, ["onChange", "modelValue", "orignal-value", "allow-empty", "disabled"])
              ])) : P("", !0),
              e.rentalTypes.length > 1 ? (p(), h("td", {
                key: 1,
                rowspan: "2",
                colspan: e.rentalTypes.length - 1,
                class: "align-middle text-body-tertiary text-center border-end"
              }, "This operating expense is constant across all rental types.", 8, VAt)) : P("", !0),
              e.rentalTypes.length < 2 && !e.portfolioId ? (p(), h("td", {
                key: 2,
                rowspan: 13 + e.otherExpenseAccounts.length,
                class: "bg-alice align-middle text-center px-5 py-3 border-end border-bottom-0"
              }, [
                e.portfolioId ? P("", !0) : (p(), h(A, { key: 0 }, [
                  a("button", {
                    type: "button",
                    class: "btn btn-lava mb-4",
                    onClick: t[1] || (t[1] = (...f) => e.showCompareDialog && e.showCompareDialog(...f)),
                    disabled: e.componentBusy
                  }, t[67] || (t[67] = [
                    a("i", { class: "fa-light fa-plus me-1" }, null, -1),
                    y("Add Analysis Style ")
                  ]), 8, NAt),
                  t[68] || (t[68] = a("p", { class: "mb-0" }, "Compare the performance of multiple analysis syltes by adding an additional analysis style. Options include long term, short term and PadSplit.", -1))
                ], 64))
              ], 8, DAt)) : P("", !0)
            ]),
            a("tr", null, [
              t[70] || (t[70] = a("th", {
                scope: "row",
                class: "align-middle border-end"
              }, "HOA", -1)),
              e.rentalTypes.length > 0 ? (p(), h("td", jAt, [
                N(o, {
                  onChange: e.detectChange,
                  modelValue: e.calcParams.associationfee,
                  "onUpdate:modelValue": t[2] || (t[2] = (f) => e.calcParams.associationfee = f),
                  currency: "",
                  "orignal-value": (d = e.calcParamsOrig) == null ? void 0 : d.associationfee,
                  placeholder: "Not Set",
                  "allow-empty": e.allowEmptyParams,
                  disabled: e.componentBusy
                }, null, 8, ["onChange", "modelValue", "orignal-value", "allow-empty", "disabled"])
              ])) : P("", !0)
            ]),
            a("tr", null, [
              t[71] || (t[71] = a("th", {
                scope: "row",
                class: "align-middle border-end"
              }, "Property Insurance", -1)),
              (p(!0), h(A, null, D(e.rentalTypes, (f) => {
                var v, b, w;
                return p(), h("td", HAt, [
                  f == "long-term" ? (p(), Fe(o, {
                    key: 0,
                    onChange: e.detectChange,
                    modelValue: e.calcParams.propertyinsurance,
                    "onUpdate:modelValue": t[3] || (t[3] = (S) => e.calcParams.propertyinsurance = S),
                    currency: "",
                    "orignal-value": (v = e.calcParamsOrig) == null ? void 0 : v.propertyinsurance,
                    placeholder: "Not Set",
                    "allow-empty": e.allowEmptyParams,
                    disabled: e.componentBusy
                  }, null, 8, ["onChange", "modelValue", "orignal-value", "allow-empty", "disabled"])) : f == "short-term" ? (p(), Fe(o, {
                    key: 1,
                    onChange: e.detectChange,
                    modelValue: e.calcParams.strPropertyInsurance,
                    "onUpdate:modelValue": t[4] || (t[4] = (S) => e.calcParams.strPropertyInsurance = S),
                    currency: "",
                    "orignal-value": (b = e.calcParamsOrig) == null ? void 0 : b.strPropertyInsurance,
                    placeholder: "Not Set",
                    "allow-empty": e.allowEmptyParams,
                    disabled: e.componentBusy
                  }, null, 8, ["onChange", "modelValue", "orignal-value", "allow-empty", "disabled"])) : f == "pad-split" ? (p(), Fe(o, {
                    key: 2,
                    onChange: e.detectChange,
                    modelValue: e.calcParams.padSplitPropertyInsurance,
                    "onUpdate:modelValue": t[5] || (t[5] = (S) => e.calcParams.padSplitPropertyInsurance = S),
                    currency: "",
                    "orignal-value": (w = e.calcParamsOrig) == null ? void 0 : w.padSplitPropertyInsurance,
                    placeholder: "Not Set",
                    "allow-empty": e.allowEmptyParams,
                    disabled: e.componentBusy
                  }, null, 8, ["onChange", "modelValue", "orignal-value", "allow-empty", "disabled"])) : P("", !0)
                ]);
              }), 256))
            ]),
            a("tr", null, [
              t[72] || (t[72] = a("th", {
                scope: "row",
                class: "align-middle border-end"
              }, "Property Management", -1)),
              (p(!0), h(A, null, D(e.rentalTypes, (f) => {
                var v, b, w;
                return p(), h("td", UAt, [
                  f == "long-term" ? (p(), Fe(o, {
                    key: 0,
                    onChange: e.detectChange,
                    modelValue: e.calcParams.managementfee,
                    "onUpdate:modelValue": t[6] || (t[6] = (S) => e.calcParams.managementfee = S),
                    percent: e.isManagementFeePercent,
                    "onUpdate:percent": t[7] || (t[7] = (S) => e.isManagementFeePercent = S),
                    "orignal-value": (v = e.calcParamsOrig) == null ? void 0 : v.managementfee,
                    placeholder: "Not Set",
                    "optional-type": "",
                    "allow-empty": e.allowEmptyParams,
                    disabled: e.componentBusyAdvanced
                  }, null, 8, ["onChange", "modelValue", "percent", "orignal-value", "allow-empty", "disabled"])) : f == "short-term" ? (p(), Fe(o, {
                    key: 1,
                    onChange: e.detectChange,
                    modelValue: e.calcParams.strManagementFee,
                    "onUpdate:modelValue": t[8] || (t[8] = (S) => e.calcParams.strManagementFee = S),
                    percent: e.isStrManagementFeePercent,
                    "onUpdate:percent": t[9] || (t[9] = (S) => e.isStrManagementFeePercent = S),
                    "orignal-value": (b = e.calcParamsOrig) == null ? void 0 : b.strManagementFee,
                    placeholder: "Not Set",
                    "optional-type": "",
                    "allow-empty": e.allowEmptyParams,
                    disabled: e.componentBusyAdvanced
                  }, null, 8, ["onChange", "modelValue", "percent", "orignal-value", "allow-empty", "disabled"])) : f == "pad-split" ? (p(), Fe(o, {
                    key: 2,
                    onChange: e.detectChange,
                    modelValue: e.calcParams.padSplitManagementFee,
                    "onUpdate:modelValue": t[10] || (t[10] = (S) => e.calcParams.padSplitManagementFee = S),
                    percent: e.isPadSplitManagementFeePercent,
                    "onUpdate:percent": t[11] || (t[11] = (S) => e.isPadSplitManagementFeePercent = S),
                    "orignal-value": (w = e.calcParamsOrig) == null ? void 0 : w.padSplitManagementFee,
                    placeholder: "Not Set",
                    "optional-type": "",
                    "allow-empty": e.allowEmptyParams,
                    disabled: e.componentBusyAdvanced
                  }, null, 8, ["onChange", "modelValue", "percent", "orignal-value", "allow-empty", "disabled"])) : P("", !0),
                  a("span", zAt, [
                    e.isManagementFeePercent && f == "long-term" ? (p(), h(A, { key: 0 }, [
                      y(" (% of one month's rent) ")
                    ], 64)) : f == "long-term" ? (p(), h(A, { key: 1 }, [
                      y(" (Monthly fee while occupied) ")
                    ], 64)) : P("", !0),
                    e.isStrManagementFeePercent && f == "short-term" ? (p(), h(A, { key: 2 }, [
                      y(" (% of effective income) ")
                    ], 64)) : f == "short-term" ? (p(), h(A, { key: 3 }, [
                      y(" (Monthly fixed fee) ")
                    ], 64)) : P("", !0),
                    e.isPadSplitManagementFeePercent && f == "pad-split" ? (p(), h(A, { key: 4 }, [
                      y(" (% of effective income) ")
                    ], 64)) : f == "pad-split" ? (p(), h(A, { key: 5 }, [
                      y(" (Monthly fixed fee) ")
                    ], 64)) : P("", !0)
                  ])
                ]);
              }), 256))
            ]),
            a("tr", null, [
              t[73] || (t[73] = a("th", {
                scope: "row",
                class: "align-middle border-end"
              }, "Lease Commission", -1)),
              (p(!0), h(A, null, D(e.rentalTypes, (f) => {
                var v;
                return p(), h("td", WAt, [
                  f == "long-term" ? (p(), Fe(o, {
                    key: 0,
                    onChange: e.detectChange,
                    modelValue: e.calcParams.leasecommission,
                    "onUpdate:modelValue": t[12] || (t[12] = (b) => e.calcParams.leasecommission = b),
                    "optional-type": "",
                    percent: e.isLeasingCommissionsPercent,
                    "onUpdate:percent": t[13] || (t[13] = (b) => e.isLeasingCommissionsPercent = b),
                    "orignal-value": (v = e.calcParamsOrig) == null ? void 0 : v.leasecommission,
                    placeholder: "Not Set",
                    "allow-empty": e.allowEmptyParams,
                    disabled: e.componentBusyAdvanced
                  }, null, 8, ["onChange", "modelValue", "percent", "orignal-value", "allow-empty", "disabled"])) : P("", !0),
                  e.isLeasingCommissionsPercent && f == "long-term" ? (p(), h("span", GAt, "(one months rent)")) : P("", !0)
                ]);
              }), 256))
            ]),
            a("tr", null, [
              t[74] || (t[74] = a("th", {
                scope: "row",
                class: "align-middle border-end"
              }, "Lease Renewal Fee", -1)),
              (p(!0), h(A, null, D(e.rentalTypes, (f) => {
                var v;
                return p(), h("td", YAt, [
                  f == "long-term" ? (p(), Fe(o, {
                    key: 0,
                    onChange: e.detectChange,
                    modelValue: e.calcParams.leaserenewalfee,
                    "onUpdate:modelValue": t[14] || (t[14] = (b) => e.calcParams.leaserenewalfee = b),
                    "optional-type": "",
                    percent: e.isLeaseRenewalFeePercent,
                    "onUpdate:percent": t[15] || (t[15] = (b) => e.isLeaseRenewalFeePercent = b),
                    "orignal-value": (v = e.calcParamsOrig) == null ? void 0 : v.leaserenewalfee,
                    placeholder: "Not Set",
                    "allow-empty": e.allowEmptyParams,
                    disabled: e.componentBusyAdvanced
                  }, null, 8, ["onChange", "modelValue", "percent", "orignal-value", "allow-empty", "disabled"])) : P("", !0),
                  e.isLeaseRenewalFeePercent && f == "long-term" ? (p(), h("span", XAt, "(one months rent)")) : P("", !0)
                ]);
              }), 256))
            ]),
            a("tr", null, [
              t[75] || (t[75] = a("th", {
                scope: "row",
                class: "align-middlev border-end"
              }, "Platform/Booking Fees", -1)),
              (p(!0), h(A, null, D(e.rentalTypes, (f) => {
                var v, b, w;
                return p(), h("td", qAt, [
                  f == "long-term" ? (p(), Fe(o, {
                    key: 0,
                    onChange: e.detectChange,
                    modelValue: e.calcParams.platformServiceFees,
                    "onUpdate:modelValue": t[16] || (t[16] = (S) => e.calcParams.platformServiceFees = S),
                    "optional-type": "",
                    percent: e.isPlatformServiceFeesPercent,
                    "onUpdate:percent": t[17] || (t[17] = (S) => e.isPlatformServiceFeesPercent = S),
                    "orignal-value": (v = e.calcParamsOrig) == null ? void 0 : v.platformServiceFees,
                    placeholder: "Not Set",
                    "allow-empty": e.allowEmptyParams,
                    disabled: e.componentBusyAdvanced
                  }, null, 8, ["onChange", "modelValue", "percent", "orignal-value", "allow-empty", "disabled"])) : f == "short-term" ? (p(), Fe(o, {
                    key: 1,
                    onChange: e.detectChange,
                    modelValue: e.calcParams.strPlatformServiceFees,
                    "onUpdate:modelValue": t[18] || (t[18] = (S) => e.calcParams.strPlatformServiceFees = S),
                    "optional-type": "",
                    percent: e.isStrPlatformServiceFeesPercent,
                    "onUpdate:percent": t[19] || (t[19] = (S) => e.isStrPlatformServiceFeesPercent = S),
                    "orignal-value": (b = e.calcParamsOrig) == null ? void 0 : b.strPlatformServiceFees,
                    placeholder: "Not Set",
                    "allow-empty": e.allowEmptyParams,
                    disabled: e.componentBusyAdvanced
                  }, null, 8, ["onChange", "modelValue", "percent", "orignal-value", "allow-empty", "disabled"])) : f == "pad-split" ? (p(), Fe(o, {
                    key: 2,
                    onChange: e.detectChange,
                    modelValue: e.calcParams.padSplitBookingFeeDays,
                    "onUpdate:modelValue": t[20] || (t[20] = (S) => e.calcParams.padSplitBookingFeeDays = S),
                    "orignal-value": (w = e.calcParamsOrig) == null ? void 0 : w.padSplitBookingFeeDays,
                    placeholder: "Not Set",
                    "allow-empty": e.allowEmptyParams,
                    disabled: e.componentBusyAdvanced
                  }, null, 8, ["onChange", "modelValue", "orignal-value", "allow-empty", "disabled"])) : P("", !0),
                  f == "pad-split" ? (p(), h("span", QAt, "(Days from each reservation)")) : P("", !0)
                ]);
              }), 256))
            ]),
            a("tr", null, [
              t[76] || (t[76] = a("th", {
                scope: "row",
                class: "align-middle border-end"
              }, [
                y("Property Maintenance"),
                a("br"),
                a("span", { class: "faded text-dark text-opacity-25" }, "(% of Gross Income)")
              ], -1)),
              (p(!0), h(A, null, D(e.rentalTypes, (f) => {
                var v, b, w;
                return p(), h("td", KAt, [
                  f == "long-term" ? (p(), Fe(o, {
                    key: 0,
                    onChange: e.detectChange,
                    modelValue: e.calcParams.maintenance,
                    "onUpdate:modelValue": t[21] || (t[21] = (S) => e.calcParams.maintenance = S),
                    "optional-type": "",
                    percent: e.isMaintenancePercent,
                    "onUpdate:percent": t[22] || (t[22] = (S) => e.isMaintenancePercent = S),
                    "orignal-value": (v = e.calcParamsOrig) == null ? void 0 : v.maintenance,
                    placeholder: "Not Set",
                    "allow-empty": e.allowEmptyParams,
                    disabled: e.componentBusyAdvanced
                  }, null, 8, ["onChange", "modelValue", "percent", "orignal-value", "allow-empty", "disabled"])) : f == "short-term" ? (p(), Fe(o, {
                    key: 1,
                    onChange: e.detectChange,
                    modelValue: e.calcParams.strMaintenance,
                    "onUpdate:modelValue": t[23] || (t[23] = (S) => e.calcParams.strMaintenance = S),
                    "optional-type": "",
                    percent: e.isStrMaintenancePercent,
                    "onUpdate:percent": t[24] || (t[24] = (S) => e.isStrMaintenancePercent = S),
                    "orignal-value": (b = e.calcParamsOrig) == null ? void 0 : b.strMaintenance,
                    placeholder: "Not Set",
                    "allow-empty": e.allowEmptyParams,
                    disabled: e.componentBusyAdvanced
                  }, null, 8, ["onChange", "modelValue", "percent", "orignal-value", "allow-empty", "disabled"])) : f == "pad-split" ? (p(), Fe(o, {
                    key: 2,
                    onChange: e.detectChange,
                    modelValue: e.calcParams.padSplitMaintenance,
                    "onUpdate:modelValue": t[25] || (t[25] = (S) => e.calcParams.padSplitMaintenance = S),
                    "optional-type": "",
                    percent: e.isPadSplitMaintenancePercent,
                    "onUpdate:percent": t[26] || (t[26] = (S) => e.isPadSplitMaintenancePercent = S),
                    "orignal-value": (w = e.calcParamsOrig) == null ? void 0 : w.padSplitMaintenance,
                    placeholder: "Not Set",
                    "allow-empty": e.allowEmptyParams,
                    disabled: e.componentBusyAdvanced
                  }, null, 8, ["onChange", "modelValue", "percent", "orignal-value", "allow-empty", "disabled"])) : P("", !0)
                ]);
              }), 256))
            ]),
            a("tr", null, [
              t[77] || (t[77] = a("th", {
                scope: "row",
                class: "align-middle border-end"
              }, "Utility Expenses", -1)),
              (p(!0), h(A, null, D(e.rentalTypes, (f) => {
                var v, b, w;
                return p(), h("td", ZAt, [
                  f == "long-term" ? (p(), Fe(o, {
                    key: 0,
                    onChange: e.detectChange,
                    modelValue: e.calcParams.utilityExpenses,
                    "onUpdate:modelValue": t[27] || (t[27] = (S) => e.calcParams.utilityExpenses = S),
                    "optional-type": "",
                    percent: e.isUtilityExpensesPercent,
                    "onUpdate:percent": t[28] || (t[28] = (S) => e.isUtilityExpensesPercent = S),
                    "orignal-value": (v = e.calcParamsOrig) == null ? void 0 : v.utilityExpenses,
                    placeholder: "Not Set",
                    "allow-empty": e.allowEmptyParams,
                    disabled: e.componentBusy
                  }, null, 8, ["onChange", "modelValue", "percent", "orignal-value", "allow-empty", "disabled"])) : f == "short-term" ? (p(), Fe(o, {
                    key: 1,
                    onChange: e.detectChange,
                    modelValue: e.calcParams.strUtilityExpenses,
                    "onUpdate:modelValue": t[29] || (t[29] = (S) => e.calcParams.strUtilityExpenses = S),
                    "optional-type": "",
                    percent: e.isStrUtilityExpensesPercent,
                    "onUpdate:percent": t[30] || (t[30] = (S) => e.isStrUtilityExpensesPercent = S),
                    "orignal-value": (b = e.calcParamsOrig) == null ? void 0 : b.strUtilityExpenses,
                    placeholder: "Not Set",
                    "allow-empty": e.allowEmptyParams,
                    disabled: e.componentBusy
                  }, null, 8, ["onChange", "modelValue", "percent", "orignal-value", "allow-empty", "disabled"])) : f == "pad-split" ? (p(), Fe(o, {
                    key: 2,
                    onChange: e.detectChange,
                    modelValue: e.calcParams.padSplitUtilityExpenses,
                    "onUpdate:modelValue": t[31] || (t[31] = (S) => e.calcParams.padSplitUtilityExpenses = S),
                    "optional-type": "",
                    percent: e.isPadSplitUtilityExpensesPercent,
                    "onUpdate:percent": t[32] || (t[32] = (S) => e.isPadSplitUtilityExpensesPercent = S),
                    "orignal-value": (w = e.calcParamsOrig) == null ? void 0 : w.padSplitUtilityExpenses,
                    placeholder: "Not Set",
                    "allow-empty": e.allowEmptyParams,
                    disabled: e.componentBusy
                  }, null, 8, ["onChange", "modelValue", "percent", "orignal-value", "allow-empty", "disabled"])) : P("", !0)
                ]);
              }), 256))
            ]),
            a("tr", null, [
              t[78] || (t[78] = a("th", {
                scope: "row",
                class: "align-middle border-end"
              }, "Furnishing Expenses", -1)),
              (p(!0), h(A, null, D(e.rentalTypes, (f) => {
                var v, b, w;
                return p(), h("td", JAt, [
                  f == "long-term" ? (p(), Fe(o, {
                    key: 0,
                    onChange: e.detectChange,
                    modelValue: e.calcParams.furnishingExpenses,
                    "onUpdate:modelValue": t[33] || (t[33] = (S) => e.calcParams.furnishingExpenses = S),
                    "optional-type": "",
                    percent: e.isFurnishingExpensesPercent,
                    "onUpdate:percent": t[34] || (t[34] = (S) => e.isFurnishingExpensesPercent = S),
                    "orignal-value": (v = e.calcParamsOrig) == null ? void 0 : v.furnishingExpenses,
                    placeholder: "Not Set",
                    "allow-empty": e.allowEmptyParams,
                    disabled: e.componentBusy
                  }, null, 8, ["onChange", "modelValue", "percent", "orignal-value", "allow-empty", "disabled"])) : f == "short-term" ? (p(), Fe(o, {
                    key: 1,
                    onChange: e.detectChange,
                    modelValue: e.calcParams.strFurnishingExpenses,
                    "onUpdate:modelValue": t[35] || (t[35] = (S) => e.calcParams.strFurnishingExpenses = S),
                    "optional-type": "",
                    percent: e.isStrFurnishingExpensesPercent,
                    "onUpdate:percent": t[36] || (t[36] = (S) => e.isStrFurnishingExpensesPercent = S),
                    "orignal-value": (b = e.calcParamsOrig) == null ? void 0 : b.strFurnishingExpenses,
                    placeholder: "Not Set",
                    "allow-empty": e.allowEmptyParams,
                    disabled: e.componentBusy
                  }, null, 8, ["onChange", "modelValue", "percent", "orignal-value", "allow-empty", "disabled"])) : f == "pad-split" ? (p(), Fe(o, {
                    key: 2,
                    onChange: e.detectChange,
                    modelValue: e.calcParams.padSplitFurnishingExpenses,
                    "onUpdate:modelValue": t[37] || (t[37] = (S) => e.calcParams.padSplitFurnishingExpenses = S),
                    "optional-type": "",
                    percent: e.isPadSplitFurnishingExpensesPercent,
                    "onUpdate:percent": t[38] || (t[38] = (S) => e.isPadSplitFurnishingExpensesPercent = S),
                    "orignal-value": (w = e.calcParamsOrig) == null ? void 0 : w.padSplitFurnishingExpenses,
                    placeholder: "Not Set",
                    "allow-empty": e.allowEmptyParams,
                    disabled: e.componentBusy
                  }, null, 8, ["onChange", "modelValue", "percent", "orignal-value", "allow-empty", "disabled"])) : P("", !0)
                ]);
              }), 256))
            ]),
            a("tr", null, [
              t[79] || (t[79] = a("th", {
                scope: "row",
                class: "align-middle border-end"
              }, "Consumable Expenses", -1)),
              (p(!0), h(A, null, D(e.rentalTypes, (f) => {
                var v, b, w;
                return p(), h("td", $At, [
                  f == "long-term" ? (p(), Fe(o, {
                    key: 0,
                    onChange: e.detectChange,
                    modelValue: e.calcParams.consumableExpenses,
                    "onUpdate:modelValue": t[39] || (t[39] = (S) => e.calcParams.consumableExpenses = S),
                    "optional-type": "",
                    percent: e.isConsumableExpensesPercent,
                    "onUpdate:percent": t[40] || (t[40] = (S) => e.isConsumableExpensesPercent = S),
                    "orignal-value": (v = e.calcParamsOrig) == null ? void 0 : v.consumableExpenses,
                    placeholder: "Not Set",
                    "allow-empty": e.allowEmptyParams,
                    disabled: e.componentBusy
                  }, null, 8, ["onChange", "modelValue", "percent", "orignal-value", "allow-empty", "disabled"])) : f == "short-term" ? (p(), Fe(o, {
                    key: 1,
                    onChange: e.detectChange,
                    modelValue: e.calcParams.strConsumableExpenses,
                    "onUpdate:modelValue": t[41] || (t[41] = (S) => e.calcParams.strConsumableExpenses = S),
                    "optional-type": "",
                    percent: e.isStrConsumableExpensesPercent,
                    "onUpdate:percent": t[42] || (t[42] = (S) => e.isStrConsumableExpensesPercent = S),
                    "orignal-value": (b = e.calcParamsOrig) == null ? void 0 : b.strConsumableExpenses,
                    placeholder: "Not Set",
                    "allow-empty": e.allowEmptyParams,
                    disabled: e.componentBusy
                  }, null, 8, ["onChange", "modelValue", "percent", "orignal-value", "allow-empty", "disabled"])) : f == "pad-split" ? (p(), Fe(o, {
                    key: 2,
                    onChange: e.detectChange,
                    modelValue: e.calcParams.padSplitConsumableExpenses,
                    "onUpdate:modelValue": t[43] || (t[43] = (S) => e.calcParams.padSplitConsumableExpenses = S),
                    "optional-type": "",
                    percent: e.isPadSplitConsumableExpensesPercent,
                    "onUpdate:percent": t[44] || (t[44] = (S) => e.isPadSplitConsumableExpensesPercent = S),
                    "orignal-value": (w = e.calcParamsOrig) == null ? void 0 : w.padSplitConsumableExpenses,
                    placeholder: "Not Set",
                    "allow-empty": e.allowEmptyParams,
                    disabled: e.componentBusy
                  }, null, 8, ["onChange", "modelValue", "percent", "orignal-value", "allow-empty", "disabled"])) : P("", !0)
                ]);
              }), 256))
            ]),
            a("tr", null, [
              t[80] || (t[80] = a("th", {
                scope: "row",
                class: "align-middle border-end"
              }, "Cleaning Expenses", -1)),
              (p(!0), h(A, null, D(e.rentalTypes, (f) => {
                var v, b, w;
                return p(), h("td", _At, [
                  f == "long-term" ? (p(), Fe(o, {
                    key: 0,
                    onChange: e.detectChange,
                    modelValue: e.calcParams.cleaningExpenses,
                    "onUpdate:modelValue": t[45] || (t[45] = (S) => e.calcParams.cleaningExpenses = S),
                    "optional-type": "",
                    percent: e.isCleaningExpensesPercent,
                    "onUpdate:percent": t[46] || (t[46] = (S) => e.isCleaningExpensesPercent = S),
                    "orignal-value": (v = e.calcParamsOrig) == null ? void 0 : v.cleaningExpenses,
                    placeholder: "Not Set",
                    "allow-empty": e.allowEmptyParams,
                    disabled: e.componentBusy
                  }, null, 8, ["onChange", "modelValue", "percent", "orignal-value", "allow-empty", "disabled"])) : f == "short-term" ? (p(), Fe(o, {
                    key: 1,
                    onChange: e.detectChange,
                    modelValue: e.calcParams.strCleaningExpenses,
                    "onUpdate:modelValue": t[47] || (t[47] = (S) => e.calcParams.strCleaningExpenses = S),
                    "optional-type": "",
                    percent: e.isStrCleaningExpensesPercent,
                    "onUpdate:percent": t[48] || (t[48] = (S) => e.isStrCleaningExpensesPercent = S),
                    "orignal-value": (b = e.calcParamsOrig) == null ? void 0 : b.strCleaningExpenses,
                    placeholder: "Not Set",
                    "allow-empty": e.allowEmptyParams,
                    disabled: e.componentBusy
                  }, null, 8, ["onChange", "modelValue", "percent", "orignal-value", "allow-empty", "disabled"])) : f == "pad-split" ? (p(), Fe(o, {
                    key: 2,
                    onChange: e.detectChange,
                    modelValue: e.calcParams.padSplitCleaningExpenses,
                    "onUpdate:modelValue": t[49] || (t[49] = (S) => e.calcParams.padSplitCleaningExpenses = S),
                    "optional-type": "",
                    percent: e.isPadSplitCleaningExpensesPercent,
                    "onUpdate:percent": t[50] || (t[50] = (S) => e.isPadSplitCleaningExpensesPercent = S),
                    "orignal-value": (w = e.calcParamsOrig) == null ? void 0 : w.padSplitCleaningExpenses,
                    placeholder: "Not Set",
                    "allow-empty": e.allowEmptyParams,
                    disabled: e.componentBusy
                  }, null, 8, ["onChange", "modelValue", "percent", "orignal-value", "allow-empty", "disabled"])) : P("", !0)
                ]);
              }), 256))
            ]),
            e.calcParams.otherExpenses && e.otherExpenseAccounts ? (p(!0), h(A, { key: 0 }, D(e.otherExpenseAccounts, (f) => (p(), h(A, null, [
              e.showAccount(f) ? (p(), h("tr", {
                key: 0,
                class: z({ "has-error": e.accountHasError(f) })
              }, [
                a("th", e0t, g(f.name), 1),
                (p(!0), h(A, null, D(e.rentalTypes, (v) => {
                  var b, w, S;
                  return p(), h("td", t0t, [
                    v == "long-term" ? (p(), Fe(o, {
                      key: 0,
                      onChange: e.detectChange,
                      modelValue: e.calcParams.otherExpenses.longTerm.find((I) => I.id == f.id).total,
                      "onUpdate:modelValue": (I) => e.calcParams.otherExpenses.longTerm.find((T) => T.id == f.id).total = I,
                      percent: e.calcParams.otherExpenses.longTerm.find((I) => I.id == f.id).percentage,
                      "onUpdate:percent": (I) => e.calcParams.otherExpenses.longTerm.find((T) => T.id == f.id).percentage = I,
                      "orignal-value": (b = e.calcParamsOrig) == null ? void 0 : b.otherExpenses.longTerm.find((I) => I.id == f.id).total,
                      disabled: e.componentBusy,
                      "allow-empty": e.allowEmptyParams,
                      placeholder: "Not Set",
                      "optional-type": ""
                    }, null, 8, ["onChange", "modelValue", "onUpdate:modelValue", "percent", "onUpdate:percent", "orignal-value", "disabled", "allow-empty"])) : v == "short-term" ? (p(), Fe(o, {
                      key: 1,
                      onChange: e.detectChange,
                      modelValue: e.calcParams.otherExpenses.shortTerm.find((I) => I.id == f.id).total,
                      "onUpdate:modelValue": (I) => e.calcParams.otherExpenses.shortTerm.find((T) => T.id == f.id).total = I,
                      percent: e.calcParams.otherExpenses.shortTerm.find((I) => I.id == f.id).percentage,
                      "onUpdate:percent": (I) => e.calcParams.otherExpenses.shortTerm.find((T) => T.id == f.id).percentage = I,
                      "orignal-value": (w = e.calcParamsOrig) == null ? void 0 : w.otherExpenses.shortTerm.find((I) => I.id == f.id).total,
                      disabled: e.componentBusy,
                      "allow-empty": e.allowEmptyParams,
                      placeholder: "Not Set",
                      "optional-type": ""
                    }, null, 8, ["onChange", "modelValue", "onUpdate:modelValue", "percent", "onUpdate:percent", "orignal-value", "disabled", "allow-empty"])) : v == "pad-split" ? (p(), Fe(o, {
                      key: 2,
                      onChange: e.detectChange,
                      modelValue: e.calcParams.otherExpenses.padSplit.find((I) => I.id == f.id).total,
                      "onUpdate:modelValue": (I) => e.calcParams.otherExpenses.padSplit.find((T) => T.id == f.id).total = I,
                      percent: e.calcParams.otherExpenses.padSplit.find((I) => I.id == f.id).percentage,
                      "onUpdate:percent": (I) => e.calcParams.otherExpenses.padSplit.find((T) => T.id == f.id).percentage = I,
                      "orignal-value": (S = e.calcParamsOrig) == null ? void 0 : S.otherExpenses.padSplit.find((I) => I.id == f.id).total,
                      disabled: e.componentBusy,
                      "allow-empty": e.allowEmptyParams,
                      placeholder: "Not Set",
                      "optional-type": ""
                    }, null, 8, ["onChange", "modelValue", "onUpdate:modelValue", "percent", "onUpdate:percent", "orignal-value", "disabled", "allow-empty"])) : P("", !0)
                  ]);
                }), 256))
              ], 2)) : P("", !0)
            ], 64))), 256)) : P("", !0),
            a("tr", null, [
              t[81] || (t[81] = a("th", {
                scope: "row",
                class: "align-middle border-end"
              }, "Other Expenses", -1)),
              (p(!0), h(A, null, D(e.rentalTypes, (f) => {
                var v, b, w;
                return p(), h("td", s0t, [
                  f == "long-term" ? (p(), Fe(o, {
                    key: 0,
                    onChange: e.detectChange,
                    modelValue: e.calcParams.otherExpense,
                    "onUpdate:modelValue": t[51] || (t[51] = (S) => e.calcParams.otherExpense = S),
                    "optional-type": "",
                    percent: e.isOtherExpensePercent,
                    "onUpdate:percent": t[52] || (t[52] = (S) => e.isOtherExpensePercent = S),
                    "orignal-value": (v = e.calcParamsOrig) == null ? void 0 : v.otherExpense,
                    placeholder: "Not Set",
                    "allow-empty": e.allowEmptyParams,
                    disabled: e.componentBusy
                  }, null, 8, ["onChange", "modelValue", "percent", "orignal-value", "allow-empty", "disabled"])) : f == "short-term" ? (p(), Fe(o, {
                    key: 1,
                    onChange: e.detectChange,
                    modelValue: e.calcParams.strOtherExpense,
                    "onUpdate:modelValue": t[53] || (t[53] = (S) => e.calcParams.strOtherExpense = S),
                    "optional-type": "",
                    percent: e.isStrOtherExpensePercent,
                    "onUpdate:percent": t[54] || (t[54] = (S) => e.isStrOtherExpensePercent = S),
                    "orignal-value": (b = e.calcParamsOrig) == null ? void 0 : b.strOtherExpense,
                    placeholder: "Not Set",
                    "allow-empty": e.allowEmptyParams,
                    disabled: e.componentBusy
                  }, null, 8, ["onChange", "modelValue", "percent", "orignal-value", "allow-empty", "disabled"])) : f == "pad-split" ? (p(), Fe(o, {
                    key: 2,
                    onChange: e.detectChange,
                    modelValue: e.calcParams.padSplitOtherExpense,
                    "onUpdate:modelValue": t[55] || (t[55] = (S) => e.calcParams.padSplitOtherExpense = S),
                    "optional-type": "",
                    percent: e.isPadSplitOtherExpensePercent,
                    "onUpdate:percent": t[56] || (t[56] = (S) => e.isPadSplitOtherExpensePercent = S),
                    "orignal-value": (w = e.calcParamsOrig) == null ? void 0 : w.padSplitOtherExpense,
                    placeholder: "Not Set",
                    "allow-empty": e.allowEmptyParams,
                    disabled: e.componentBusy
                  }, null, 8, ["onChange", "modelValue", "percent", "orignal-value", "allow-empty", "disabled"])) : P("", !0)
                ]);
              }), 256))
            ])
          ]),
          a("tfoot", null, [
            a("tr", null, [
              a("td", {
                colspan: e.rentalTypes.length + 1,
                class: "border-end"
              }, [
                a("div", n0t, [
                  e.showAllAccounts ? (p(), h("button", {
                    key: 1,
                    onClick: t[58] || (t[58] = (f) => e.showAllAccounts = !e.showAllAccounts),
                    class: "btn btn-sm btn-success",
                    disabled: e.componentBusy
                  }, "Show Accounts with Values", 8, o0t)) : (p(), h("button", {
                    key: 0,
                    onClick: t[57] || (t[57] = (f) => e.showAllAccounts = !e.showAllAccounts),
                    class: "btn btn-sm btn-success",
                    disabled: e.componentBusy
                  }, "Show all Accounts", 8, r0t)),
                  a("button", {
                    type: "button",
                    class: "btn btn-sm btn-success",
                    "data-bs-toggle": "modal",
                    "data-bs-target": "#dialogAccounts",
                    disabled: e.componentBusy
                  }, t[82] || (t[82] = [
                    a("i", { class: "fa fa-plus me-2" }, null, -1),
                    y("Add Account")
                  ]), 8, i0t)
                ])
              ], 8, a0t),
              e.rentalTypes.length < 2 && !e.portfolioId ? (p(), h("td", l0t)) : P("", !0)
            ])
          ])
        ])
      ])
    ]),
    a("div", d0t, [
      a("div", c0t, [
        a("div", u0t, [
          e.canManageIEAccounts ? (p(), h(A, { key: 0 }, [
            t[86] || (t[86] = a("div", { class: "modal-header pb-0 border-0" }, [
              a("p", {
                class: "modal-title fs-5 fw-bold",
                id: "dialogAccountsLabel"
              }, "Accounts"),
              a("button", {
                type: "button",
                class: "btn-close",
                "data-bs-dismiss": "modal",
                "aria-label": "Close"
              })
            ], -1)),
            a("div", p0t, [
              t[85] || (t[85] = a("p", null, [
                y(" Add accounts to the operating expenses table, if you need to create a new Custom Expense Account you can "),
                a("a", { href: "/account/refresh#income-expense-accountsTab" }, "click here"),
                y(". ")
              ], -1)),
              a("div", h0t, [
                e.calcParams.otherExpenses && e.otherExpenseAccounts ? (p(), h("table", m0t, [
                  a("tbody", null, [
                    (p(!0), h(A, null, D(e.otherExpenseAccounts, (f) => (p(), h(A, null, [
                      e.showAccount(f) ? P("", !0) : (p(), h("tr", f0t, [
                        a("td", null, [
                          f.isCustom ? (p(), h("span", g0t, "Custom")) : P("", !0),
                          y(" " + g(f.name), 1)
                        ]),
                        a("td", v0t, [
                          a("button", {
                            type: "button",
                            class: "btn btn-sm btn-outline-success",
                            onClick: (v) => e.addAccount(f)
                          }, t[84] || (t[84] = [
                            a("i", { class: "fa fa-plus me-2" }, null, -1),
                            y("Add")
                          ]), 8, y0t)
                        ])
                      ]))
                    ], 64))), 256))
                  ])
                ])) : P("", !0)
              ])
            ])
          ], 64)) : (p(), h("div", b0t, t[87] || (t[87] = [
            a("button", {
              type: "button",
              class: "btn-close position-absolute top-10 end-10",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            }, null, -1),
            a("i", { class: "fa-duotone fa-solid fa-rectangle-vertical-history mb-3 fa-3x" }, null, -1),
            a("p", { class: "fw-bold fs-5" }, "Add Account", -1),
            y(" Upgrade to "),
            a("b", null, "Property Suite Pro", -1),
            y(" to analyze multi-family, STR, rent vs sell, and other advanced analysis styles. ")
          ])))
        ])
      ])
    ], 512),
    a("div", A0t, [
      a("div", w0t, [
        a("div", C0t, [
          e.canOtherAnalysisStyles ? (p(), h(A, { key: 0 }, [
            t[92] || (t[92] = a("div", { class: "modal-header border-0" }, [
              a("p", {
                class: "modal-title fs-5 fw-bold",
                id: "dialogCompareLabel"
              }, "Analysis Style"),
              a("button", {
                type: "button",
                class: "btn-close",
                "data-bs-dismiss": "modal",
                "aria-label": "Close"
              })
            ], -1)),
            a("div", S0t, [
              a("div", P0t, [
                t[91] || (t[91] = a("legend", { class: "col-lg-5 col-form-label pt-0" }, " Compare Against Other Rental Types? ", -1)),
                a("div", k0t, [
                  ((c = e.calcParams) == null ? void 0 : c.rentalType) != "long-term" ? (p(), h("div", E0t, [
                    V(a("input", {
                      class: "form-check-input",
                      type: "checkbox",
                      id: "longTerm",
                      "onUpdate:modelValue": t[59] || (t[59] = (f) => e.compareLongTerm = f)
                    }, null, 512), [
                      [Ue, e.compareLongTerm]
                    ]),
                    t[88] || (t[88] = a("label", {
                      class: "form-check-label",
                      for: "longTerm"
                    }, "Long-Term", -1))
                  ])) : P("", !0),
                  ((u = e.calcParams) == null ? void 0 : u.rentalType) != "short-term" ? (p(), h("div", I0t, [
                    V(a("input", {
                      class: "form-check-input",
                      type: "checkbox",
                      id: "shortTerm",
                      "onUpdate:modelValue": t[60] || (t[60] = (f) => e.compareShortTerm = f)
                    }, null, 512), [
                      [Ue, e.compareShortTerm]
                    ]),
                    t[89] || (t[89] = a("label", {
                      class: "form-check-label",
                      for: "shortTerm"
                    }, "Short-Term", -1))
                  ])) : P("", !0),
                  ((m = e.calcParams) == null ? void 0 : m.rentalType) != "pad-split" ? (p(), h("div", T0t, [
                    V(a("input", {
                      class: "form-check-input",
                      type: "checkbox",
                      id: "padSplit",
                      "onUpdate:modelValue": t[61] || (t[61] = (f) => e.comparePadSplit = f)
                    }, null, 512), [
                      [Ue, e.comparePadSplit]
                    ]),
                    t[90] || (t[90] = a("label", {
                      class: "form-check-label",
                      for: "padSplit"
                    }, "PadSplit", -1))
                  ])) : P("", !0)
                ])
              ])
            ]),
            t[93] || (t[93] = a("div", { class: "modal-footer border-0" }, [
              a("button", {
                type: "button",
                class: "btn btn-lava",
                "data-bs-dismiss": "modal"
              }, "Close")
            ], -1))
          ], 64)) : (p(), h("div", O0t, t[94] || (t[94] = [
            a("button", {
              type: "button",
              class: "btn-close position-absolute top-10 end-10",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            }, null, -1),
            a("i", { class: "fa-duotone fa-solid fa-rectangle-vertical-history mb-3 fa-3x" }, null, -1),
            a("p", { class: "fw-bold fs-5" }, "Analysis Style", -1),
            y(" Upgrade to "),
            a("b", null, "Property Suite Pro", -1),
            y(" to analyze multi-family, STR, rent vs sell, and other advanced analysis styles. ")
          ])))
        ])
      ])
    ], 512)
  ], 64);
}
const L0t = /* @__PURE__ */ Ae(OAt, [["render", R0t]]), B0t = me({
  name: "NonOperatingExpenses",
  props: {
    loading: Boolean
  },
  emits: [
    "change"
  ],
  components: {
    NumericalInput: Aa
  },
  data() {
    return {
      showAllAccounts: !1,
      forceShow: []
    };
  },
  computed: {
    componentBusy() {
      return this.loading || this.calculating;
    },
    componentBusyAdvanced() {
      return this.loading || this.calculating || this.hasAdvanced != !0;
    },
    allowEmptyParams() {
      var e, t;
      return this.isExistingInvestment == !0 && ((t = (e = this.purchaseFacts) == null ? void 0 : e.years) == null ? void 0 : t.length) > 0;
    },
    isManagementFeePercent: {
      get() {
        return (this.calcParams.percentageLongTermFields & U.PropertyManagement) == U.PropertyManagement;
      },
      set(e) {
        e ? this.calcParams.percentageLongTermFields |= U.PropertyManagement : this.calcParams.percentageLongTermFields &= ~U.PropertyManagement;
      }
    },
    isLeasingCommissionsPercent: {
      get() {
        return (this.calcParams.percentageLongTermFields & U.LeasingCommissions) == U.LeasingCommissions;
      },
      set(e) {
        e ? this.calcParams.percentageLongTermFields |= U.LeasingCommissions : this.calcParams.percentageLongTermFields &= ~U.LeasingCommissions;
      }
    },
    isLeaseRenewalFeePercent: {
      get() {
        return (this.calcParams.percentageLongTermFields & U.LeaseRenewalFee) == U.LeaseRenewalFee;
      },
      set(e) {
        e ? this.calcParams.percentageLongTermFields |= U.LeaseRenewalFee : this.calcParams.percentageLongTermFields &= ~U.LeaseRenewalFee;
      }
    },
    isPlatformServiceFeesPercent: {
      get() {
        return (this.calcParams.percentageLongTermFields & U.PlatformServiceFees) == U.PlatformServiceFees;
      },
      set(e) {
        e ? this.calcParams.percentageLongTermFields |= U.PlatformServiceFees : this.calcParams.percentageLongTermFields &= ~U.PlatformServiceFees;
      }
    },
    isMaintenancePercent: {
      get() {
        return (this.calcParams.percentageLongTermFields & U.PropertyMaintenance) == U.PropertyMaintenance;
      },
      set(e) {
        e ? this.calcParams.percentageLongTermFields |= U.PropertyMaintenance : this.calcParams.percentageLongTermFields &= ~U.PropertyMaintenance;
      }
    },
    isUtilityExpensesPercent: {
      get() {
        return (this.calcParams.percentageLongTermFields & U.UtilityExpenses) == U.UtilityExpenses;
      },
      set(e) {
        e ? this.calcParams.percentageLongTermFields |= U.UtilityExpenses : this.calcParams.percentageLongTermFields &= ~U.UtilityExpenses;
      }
    },
    isFurnishingExpensesPercent: {
      get() {
        return (this.calcParams.percentageLongTermFields & U.FurnishingExpenses) == U.FurnishingExpenses;
      },
      set(e) {
        e ? this.calcParams.percentageLongTermFields |= U.FurnishingExpenses : this.calcParams.percentageLongTermFields &= ~U.FurnishingExpenses;
      }
    },
    isConsumableExpensesPercent: {
      get() {
        return (this.calcParams.percentageLongTermFields & U.ConsumableExpenses) == U.ConsumableExpenses;
      },
      set(e) {
        e ? this.calcParams.percentageLongTermFields |= U.ConsumableExpenses : this.calcParams.percentageLongTermFields &= ~U.ConsumableExpenses;
      }
    },
    isCleaningExpensesPercent: {
      get() {
        return (this.calcParams.percentageLongTermFields & U.CleaningExpenses) == U.CleaningExpenses;
      },
      set(e) {
        e ? this.calcParams.percentageLongTermFields |= U.CleaningExpenses : this.calcParams.percentageLongTermFields &= ~U.CleaningExpenses;
      }
    },
    isOtherExpensePercent: {
      get() {
        return (this.calcParams.percentageLongTermFields & U.OtherExpense) == U.OtherExpense;
      },
      set(e) {
        e ? this.calcParams.percentageLongTermFields |= U.OtherExpense : this.calcParams.percentageLongTermFields &= ~U.OtherExpense;
      }
    },
    isCapitalExpendituresPercent: {
      get() {
        return (this.calcParams.percentageLongTermFields & U.CapitalExpenditures) == U.CapitalExpenditures;
      },
      set(e) {
        e ? this.calcParams.percentageLongTermFields |= U.CapitalExpenditures : this.calcParams.percentageLongTermFields &= ~U.CapitalExpenditures;
      }
    },
    //
    isStrManagementFeePercent: {
      get() {
        return (this.calcParams.percentageShortTermFields & U.PropertyManagement) == U.PropertyManagement;
      },
      set(e) {
        e ? this.calcParams.percentageShortTermFields |= U.PropertyManagement : this.calcParams.percentageShortTermFields &= ~U.PropertyManagement;
      }
    },
    isStrLeasingCommissionsPercent: {
      get() {
        return (this.calcParams.percentageShortTermFields & U.LeasingCommissions) == U.LeasingCommissions;
      },
      set(e) {
        e ? this.calcParams.percentageShortTermFields |= U.LeasingCommissions : this.calcParams.percentageShortTermFields &= ~U.LeasingCommissions;
      }
    },
    isStrPlatformServiceFeesPercent: {
      get() {
        return (this.calcParams.percentageShortTermFields & U.PlatformServiceFees) == U.PlatformServiceFees;
      },
      set(e) {
        e ? this.calcParams.percentageShortTermFields |= U.PlatformServiceFees : this.calcParams.percentageShortTermFields &= ~U.PlatformServiceFees;
      }
    },
    isStrMaintenancePercent: {
      get() {
        return (this.calcParams.percentageShortTermFields & U.PropertyMaintenance) == U.PropertyMaintenance;
      },
      set(e) {
        e ? this.calcParams.percentageShortTermFields |= U.PropertyMaintenance : this.calcParams.percentageShortTermFields &= ~U.PropertyMaintenance;
      }
    },
    isStrUtilityExpensesPercent: {
      get() {
        return (this.calcParams.percentageShortTermFields & U.UtilityExpenses) == U.UtilityExpenses;
      },
      set(e) {
        e ? this.calcParams.percentageShortTermFields |= U.UtilityExpenses : this.calcParams.percentageShortTermFields &= ~U.UtilityExpenses;
      }
    },
    isStrFurnishingExpensesPercent: {
      get() {
        return (this.calcParams.percentageShortTermFields & U.FurnishingExpenses) == U.FurnishingExpenses;
      },
      set(e) {
        e ? this.calcParams.percentageShortTermFields |= U.FurnishingExpenses : this.calcParams.percentageShortTermFields &= ~U.FurnishingExpenses;
      }
    },
    isStrConsumableExpensesPercent: {
      get() {
        return (this.calcParams.percentageShortTermFields & U.ConsumableExpenses) == U.ConsumableExpenses;
      },
      set(e) {
        e ? this.calcParams.percentageShortTermFields |= U.ConsumableExpenses : this.calcParams.percentageShortTermFields &= ~U.ConsumableExpenses;
      }
    },
    isStrCleaningExpensesPercent: {
      get() {
        return (this.calcParams.percentageShortTermFields & U.CleaningExpenses) == U.CleaningExpenses;
      },
      set(e) {
        e ? this.calcParams.percentageShortTermFields |= U.CleaningExpenses : this.calcParams.percentageShortTermFields &= ~U.CleaningExpenses;
      }
    },
    isStrOtherExpensePercent: {
      get() {
        return (this.calcParams.percentageShortTermFields & U.OtherExpense) == U.OtherExpense;
      },
      set(e) {
        e ? this.calcParams.percentageShortTermFields |= U.OtherExpense : this.calcParams.percentageShortTermFields &= ~U.OtherExpense;
      }
    },
    isStrCapitalExpendituresPercent: {
      get() {
        return (this.calcParams.percentageShortTermFields & U.CapitalExpenditures) == U.CapitalExpenditures;
      },
      set(e) {
        e ? this.calcParams.percentageShortTermFields |= U.CapitalExpenditures : this.calcParams.percentageShortTermFields &= ~U.CapitalExpenditures;
      }
    },
    compareLongTerm: {
      get() {
        var e;
        return (((e = this.calcParams) == null ? void 0 : e.rentalTypeComparisons) & nt.LongTerm) == nt.LongTerm;
      },
      set(e) {
        e ? this.calcParams.rentalTypeComparisons |= nt.LongTerm : this.calcParams.rentalTypeComparisons &= ~nt.LongTerm;
      }
    },
    compareShortTerm: {
      get() {
        var e;
        return (((e = this.calcParams) == null ? void 0 : e.rentalTypeComparisons) & nt.ShortTerm) == nt.ShortTerm;
      },
      set(e) {
        e ? this.calcParams.rentalTypeComparisons |= nt.ShortTerm : this.calcParams.rentalTypeComparisons &= ~nt.ShortTerm;
      }
    },
    comparePadSplit: {
      get() {
        var e;
        return (((e = this.calcParams) == null ? void 0 : e.rentalTypeComparisons) & nt.PadSplit) == nt.PadSplit;
      },
      set(e) {
        e ? this.calcParams.rentalTypeComparisons |= nt.PadSplit : this.calcParams.rentalTypeComparisons &= ~nt.PadSplit;
      }
    },
    ...q(Te, ["access", "aclLoaded", "hasAdvanced", "canOtherAnalysisStyles"]),
    ...q(ct, ["otherExpenseAccounts", "otherNonOperatingExpenseAccounts", "otherIncomeAccounts", "incomeAccounts"]),
    ...q(qe, ["calcParams", "calcParamsOrig", "purchaseFacts", "calculating", "isExistingInvestment", "rentalTypes"]),
    ...q(Ci, ["notifications"]),
    ...q(ba, ["portfolioId"])
  },
  methods: {
    number: Ve,
    detectChange() {
      this.$emit("change");
    },
    showAccount(e) {
      var t;
      return (this.showAllAccounts || this.forceShow.find((s) => s == e.id) || this.calcParams.otherExpenses.longTerm.find((s) => s.id == e.id).total > 0 || this.calcParams.otherExpenses.shortTerm.find((s) => s.id == e.id).total > 0 || ((t = this.notifications) == null ? void 0 : t.some((s) => pi(s.eventId) && s.properties.accountId == e.id))) && this.calcParams.otherExpenses.longTerm.some((s) => s.id == e.id);
    },
    addAccount(e) {
      var t;
      this.forceShow.find((s) => s == e.id) || this.forceShow.push(e.id), (t = bootstrap.Modal.getOrCreateInstance(this.$refs.dialogNonOperatingAccounts)) == null || t.hide();
    },
    accountHasError(e) {
      var t;
      return (t = this.notifications) == null ? void 0 : t.some((s) => pi(s.eventId) && s.properties.accountId == `${e.id}`);
    },
    showCompareDialog() {
      var e;
      (e = bootstrap.Modal.getOrCreateInstance(this.$refs.dialogCompare)) == null || e.show();
    }
  },
  created() {
  },
  mounted() {
    this.aclLoaded.then(() => {
    });
  }
}), M0t = { class: "card shadow-sm overflow-hidden" }, x0t = { class: "table-responsive table-non-operating-expenses" }, F0t = { class: "table mb-0 table-sm table-fixed" }, V0t = {
  key: 2,
  src: nn,
  alt: "PadSplit",
  title: "PadSplit",
  loading: "lazy",
  class: "img-fluid",
  width: "85"
}, D0t = {
  key: 0,
  scope: "col",
  class: "bg-alice border-start border-bottom-0"
}, N0t = { class: "border-end bg-transparent" }, j0t = ["rowspan"], H0t = ["disabled"], U0t = {
  scope: "row",
  class: "align-middle border-end"
}, z0t = { class: "border-end bg-transparent" }, W0t = ["colspan"], G0t = { class: "d-flex justify-content-start gap-2 p-2" }, Y0t = ["disabled"], X0t = ["disabled"], q0t = ["disabled"], Q0t = {
  key: 0,
  class: "bg-alice border-start"
}, K0t = {
  ref: "dialogNonOperatingAccounts",
  class: "modal fade",
  id: "dialogNonOperatingAccounts",
  tabindex: "-1",
  "aria-labelledby": "dialogNonOperatingAccountsLabel",
  "aria-hidden": "true"
}, Z0t = { class: "modal-dialog modal-dialog-centered" }, J0t = { class: "modal-content bg-gradient-alphabet rounded" }, $0t = { class: "modal-body rounded-3 rounded-top-0" }, _0t = {
  key: 0,
  class: "bg-white x rounded shadow mt-4 mb-3 p-3"
}, ewt = { class: "table mb-0" }, twt = { key: 0 }, swt = {
  key: 0,
  class: "badge rounded-pill text-bg-lava me-2"
}, awt = { class: "text-end" }, nwt = ["onClick"], rwt = {
  ref: "dialogCompare",
  class: "modal fade",
  id: "dialogCompare",
  tabindex: "-1",
  "aria-labelledby": "dialogCompareLabel",
  "aria-hidden": "true"
}, owt = { class: "modal-dialog modal-dialog-centered" }, iwt = { class: "modal-content bg-gradient-alphabet rounded" }, lwt = { class: "modal-body py-5" }, dwt = { class: "row" }, cwt = { class: "col-lg-7 d-flex gap-2" }, uwt = {
  key: 0,
  class: "form-check form-check-inline"
}, pwt = {
  key: 1,
  class: "form-check form-check-inline"
}, hwt = {
  key: 2,
  class: "form-check form-check-inline"
}, mwt = {
  key: 1,
  class: "modal-body p-8 text-center rounded"
};
function fwt(e, t, s, n, r, i) {
  var l, d, c;
  const o = pe("numerical-input");
  return p(), h(A, null, [
    t[32] || (t[32] = a("p", { class: "mb-3 fw-bold fs-5" }, " Non-Operating Expenses ", -1)),
    a("div", M0t, [
      a("div", x0t, [
        a("table", F0t, [
          t[21] || (t[21] = a("colgroup", null, [
            a("col"),
            a("col", { class: "bg-body-secondary" }),
            a("col"),
            a("col", { class: "bg-body-secondary" })
          ], -1)),
          a("thead", null, [
            a("tr", null, [
              t[16] || (t[16] = a("th", {
                scope: "col",
                class: "table-column-description border-end"
              }, " ", -1)),
              (p(!0), h(A, null, D(e.rentalTypes, (u) => (p(), h("th", {
                scope: "col",
                class: z(["text-center bg-transparent border-end", "table-column-" + u])
              }, [
                u == "long-term" ? (p(), h(A, { key: 0 }, [
                  t[12] || (t[12] = a("i", { class: "fa-light fa-calendar-range me-2" }, null, -1)),
                  t[13] || (t[13] = y("Long Term "))
                ], 64)) : u == "short-term" ? (p(), h(A, { key: 1 }, [
                  t[14] || (t[14] = a("i", { class: "fa-light fa-timer me-2" }, null, -1)),
                  t[15] || (t[15] = y("Short Term "))
                ], 64)) : u == "pad-split" ? (p(), h("img", V0t)) : P("", !0)
              ], 2))), 256)),
              e.rentalTypes.length < 2 && !e.portfolioId ? (p(), h("th", D0t)) : P("", !0)
            ])
          ]),
          a("tbody", null, [
            a("tr", null, [
              t[19] || (t[19] = a("th", {
                scope: "row",
                class: "border-end"
              }, [
                y(" Capital Expenditures"),
                a("br"),
                a("span", { class: "faded text-dark text-opacity-25" }, "(of gross income)")
              ], -1)),
              (p(!0), h(A, null, D(e.rentalTypes, (u) => {
                var m, f, v;
                return p(), h("td", N0t, [
                  u == "long-term" ? (p(), Fe(o, {
                    key: 0,
                    onChange: e.detectChange,
                    modelValue: e.calcParams.capitalExpenditures,
                    "onUpdate:modelValue": t[0] || (t[0] = (b) => e.calcParams.capitalExpenditures = b),
                    "optional-type": "",
                    percent: e.isCapitalExpendituresPercent,
                    "onUpdate:percent": t[1] || (t[1] = (b) => e.isCapitalExpendituresPercent = b),
                    "orignal-value": (m = e.calcParamsOrig) == null ? void 0 : m.capitalExpenditures,
                    placeholder: "Not Set",
                    "allow-empty": e.allowEmptyParams,
                    disabled: e.componentBusyAdvanced
                  }, null, 8, ["onChange", "modelValue", "percent", "orignal-value", "allow-empty", "disabled"])) : u == "short-term" ? (p(), Fe(o, {
                    key: 1,
                    onChange: e.detectChange,
                    modelValue: e.calcParams.strCapitalExpenditures,
                    "onUpdate:modelValue": t[2] || (t[2] = (b) => e.calcParams.strCapitalExpenditures = b),
                    "optional-type": "",
                    percent: e.isStrCapitalExpendituresPercent,
                    "onUpdate:percent": t[3] || (t[3] = (b) => e.isStrCapitalExpendituresPercent = b),
                    "orignal-value": (f = e.calcParamsOrig) == null ? void 0 : f.strCapitalExpenditures,
                    placeholder: "Not Set",
                    "allow-empty": e.allowEmptyParams,
                    disabled: e.componentBusyAdvanced
                  }, null, 8, ["onChange", "modelValue", "percent", "orignal-value", "allow-empty", "disabled"])) : u == "pad-split" ? (p(), Fe(o, {
                    key: 2,
                    onChange: e.detectChange,
                    modelValue: e.calcParams.padSplitCapitalExpenditures,
                    "onUpdate:modelValue": t[4] || (t[4] = (b) => e.calcParams.padSplitCapitalExpenditures = b),
                    "optional-type": "",
                    percent: e.isStrCapitalExpendituresPercent,
                    "onUpdate:percent": t[5] || (t[5] = (b) => e.isStrCapitalExpendituresPercent = b),
                    "orignal-value": (v = e.calcParamsOrig) == null ? void 0 : v.padSplitCapitalExpenditures,
                    placeholder: "Not Set",
                    "allow-empty": e.allowEmptyParams,
                    disabled: e.componentBusyAdvanced
                  }, null, 8, ["onChange", "modelValue", "percent", "orignal-value", "allow-empty", "disabled"])) : P("", !0)
                ]);
              }), 256)),
              e.rentalTypes.length < 2 && !e.portfolioId ? (p(), h("td", {
                key: 0,
                rowspan: e.rentalTypes.length,
                class: "bg-alice align-middle text-center px-5 py-3 border-start border-bottom-0"
              }, [
                e.portfolioId ? P("", !0) : (p(), h(A, { key: 0 }, [
                  a("button", {
                    type: "button",
                    class: "btn btn-lava mb-4",
                    onClick: t[6] || (t[6] = (...u) => e.showCompareDialog && e.showCompareDialog(...u)),
                    disabled: e.componentBusy
                  }, t[17] || (t[17] = [
                    a("i", { class: "fa-light fa-plus me-1" }, null, -1),
                    y("Add Analysis Style ")
                  ]), 8, H0t),
                  t[18] || (t[18] = a("p", { class: "mb-0" }, "Compare the performance of multiple analysis syltes by adding an additional analysis style. Options include long term, short term and PadSplit.", -1))
                ], 64))
              ], 8, j0t)) : P("", !0)
            ]),
            e.calcParams.otherExpenses && e.otherNonOperatingExpenseAccounts ? (p(!0), h(A, { key: 0 }, D(e.otherNonOperatingExpenseAccounts, (u) => (p(), h(A, {
              key: u.id
            }, [
              e.showAccount(u) ? (p(), h("tr", {
                key: 0,
                class: z({ "has-error": e.accountHasError(u) })
              }, [
                a("th", U0t, g(u.name), 1),
                (p(!0), h(A, null, D(e.rentalTypes, (m) => {
                  var f, v, b;
                  return p(), h("td", z0t, [
                    m == "long-term" ? (p(), Fe(o, {
                      key: 0,
                      onChange: e.detectChange,
                      modelValue: e.calcParams.otherExpenses.longTerm.find((w) => w.id == u.id).total,
                      "onUpdate:modelValue": (w) => e.calcParams.otherExpenses.longTerm.find((S) => S.id == u.id).total = w,
                      percent: e.calcParams.otherExpenses.longTerm.find((w) => w.id == u.id).percentage,
                      "onUpdate:percent": (w) => e.calcParams.otherExpenses.longTerm.find((S) => S.id == u.id).percentage = w,
                      "orignal-value": (f = e.calcParamsOrig) == null ? void 0 : f.otherExpenses.longTerm.find((w) => w.id == u.id).total,
                      disabled: e.componentBusy,
                      "allow-empty": e.allowEmptyParams,
                      placeholder: "Not Set",
                      "optional-type": ""
                    }, null, 8, ["onChange", "modelValue", "onUpdate:modelValue", "percent", "onUpdate:percent", "orignal-value", "disabled", "allow-empty"])) : m == "short-term" ? (p(), Fe(o, {
                      key: 1,
                      onChange: e.detectChange,
                      modelValue: e.calcParams.otherExpenses.shortTerm.find((w) => w.id == u.id).total,
                      "onUpdate:modelValue": (w) => e.calcParams.otherExpenses.shortTerm.find((S) => S.id == u.id).total = w,
                      percent: e.calcParams.otherExpenses.shortTerm.find((w) => w.id == u.id).percentage,
                      "onUpdate:percent": (w) => e.calcParams.otherExpenses.shortTerm.find((S) => S.id == u.id).percentage = w,
                      "orignal-value": (v = e.calcParamsOrig) == null ? void 0 : v.otherExpenses.shortTerm.find((w) => w.id == u.id).total,
                      disabled: e.componentBusy,
                      "allow-empty": e.allowEmptyParams,
                      placeholder: "Not Set",
                      "optional-type": ""
                    }, null, 8, ["onChange", "modelValue", "onUpdate:modelValue", "percent", "onUpdate:percent", "orignal-value", "disabled", "allow-empty"])) : m == "pad-split" ? (p(), Fe(o, {
                      key: 2,
                      onChange: e.detectChange,
                      modelValue: e.calcParams.otherExpenses.padSplit.find((w) => w.id == u.id).total,
                      "onUpdate:modelValue": (w) => e.calcParams.otherExpenses.padSplit.find((S) => S.id == u.id).total = w,
                      percent: e.calcParams.otherExpenses.padSplit.find((w) => w.id == u.id).percentage,
                      "onUpdate:percent": (w) => e.calcParams.otherExpenses.padSplit.find((S) => S.id == u.id).percentage = w,
                      "orignal-value": (b = e.calcParamsOrig) == null ? void 0 : b.otherExpenses.padSplit.find((w) => w.id == u.id).total,
                      disabled: e.componentBusy,
                      "allow-empty": e.allowEmptyParams,
                      placeholder: "Not Set",
                      "optional-type": ""
                    }, null, 8, ["onChange", "modelValue", "onUpdate:modelValue", "percent", "onUpdate:percent", "orignal-value", "disabled", "allow-empty"])) : P("", !0)
                  ]);
                }), 256))
              ], 2)) : P("", !0)
            ], 64))), 128)) : P("", !0)
          ]),
          a("tfoot", null, [
            a("tr", null, [
              a("td", {
                colspan: e.rentalTypes.length + 1,
                class: "border-end"
              }, [
                a("div", G0t, [
                  e.showAllAccounts ? (p(), h("button", {
                    key: 1,
                    onClick: t[8] || (t[8] = (u) => e.showAllAccounts = !e.showAllAccounts),
                    class: "btn btn-sm btn-success",
                    disabled: e.componentBusy
                  }, "Show Accounts with Values", 8, X0t)) : (p(), h("button", {
                    key: 0,
                    onClick: t[7] || (t[7] = (u) => e.showAllAccounts = !e.showAllAccounts),
                    class: "btn btn-sm btn-success",
                    disabled: e.componentBusy
                  }, "Show all Accounts", 8, Y0t)),
                  a("button", {
                    type: "button",
                    class: "btn btn-sm btn-success",
                    "data-bs-toggle": "modal",
                    "data-bs-target": "#dialogNonOperatingAccounts",
                    disabled: e.componentBusy
                  }, t[20] || (t[20] = [
                    a("i", { class: "fa fa-plus me-2" }, null, -1),
                    y("Add Account")
                  ]), 8, q0t)
                ])
              ], 8, W0t),
              e.rentalTypes.length < 2 && !e.portfolioId ? (p(), h("td", Q0t)) : P("", !0)
            ])
          ])
        ])
      ])
    ]),
    a("div", K0t, [
      a("div", Z0t, [
        a("div", J0t, [
          t[24] || (t[24] = a("div", { class: "modal-header pb-0 border-0" }, [
            a("p", {
              class: "modal-title fs-5 fw-bold",
              id: "dialogNonOperatingAccountsLabel"
            }, "Accounts"),
            a("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            })
          ], -1)),
          a("div", $0t, [
            t[23] || (t[23] = a("p", null, [
              y(" Add accounts to the Non-Operating Expenses table, if you need to create a new Custom Expense Account you can "),
              a("a", { href: "/account/refresh#income-expense-accountsTab" }, "click here"),
              y(". ")
            ], -1)),
            e.calcParams.otherExpenses && e.otherNonOperatingExpenseAccounts ? (p(), h("div", _0t, [
              a("table", ewt, [
                a("tbody", null, [
                  (p(!0), h(A, null, D(e.otherNonOperatingExpenseAccounts, (u) => (p(), h(A, null, [
                    e.showAccount(u) ? P("", !0) : (p(), h("tr", twt, [
                      a("td", null, [
                        u.isCustom ? (p(), h("span", swt, "Custom")) : P("", !0),
                        y(" " + g(u.name), 1)
                      ]),
                      a("td", awt, [
                        a("button", {
                          type: "button",
                          class: "btn btn-sm btn-outline-success",
                          onClick: (m) => e.addAccount(u)
                        }, t[22] || (t[22] = [
                          a("i", { class: "fa fa-plus me-2" }, null, -1),
                          y("Add")
                        ]), 8, nwt)
                      ])
                    ]))
                  ], 64))), 256))
                ])
              ])
            ])) : P("", !0)
          ])
        ])
      ])
    ], 512),
    a("div", rwt, [
      a("div", owt, [
        a("div", iwt, [
          e.canOtherAnalysisStyles ? (p(), h(A, { key: 0 }, [
            t[29] || (t[29] = a("div", { class: "modal-header border-0 pb-0" }, [
              a("p", {
                class: "modal-title fs-5 fw-bold",
                id: "dialogCompareLabel"
              }, "Analysis Style"),
              a("button", {
                type: "button",
                class: "btn-close",
                "data-bs-dismiss": "modal",
                "aria-label": "Close"
              })
            ], -1)),
            a("div", lwt, [
              a("div", dwt, [
                t[28] || (t[28] = a("legend", { class: "col-lg-5 col-form-label pt-0" }, " Compare Against Other Rental Types? ", -1)),
                a("div", cwt, [
                  ((l = e.calcParams) == null ? void 0 : l.rentalType) != "long-term" ? (p(), h("div", uwt, [
                    V(a("input", {
                      class: "form-check-input",
                      type: "checkbox",
                      id: "longTerm",
                      "onUpdate:modelValue": t[9] || (t[9] = (u) => e.compareLongTerm = u)
                    }, null, 512), [
                      [Ue, e.compareLongTerm]
                    ]),
                    t[25] || (t[25] = a("label", {
                      class: "form-check-label",
                      for: "longTerm"
                    }, "Long-Term", -1))
                  ])) : P("", !0),
                  ((d = e.calcParams) == null ? void 0 : d.rentalType) != "short-term" ? (p(), h("div", pwt, [
                    V(a("input", {
                      class: "form-check-input",
                      type: "checkbox",
                      id: "shortTerm",
                      "onUpdate:modelValue": t[10] || (t[10] = (u) => e.compareShortTerm = u)
                    }, null, 512), [
                      [Ue, e.compareShortTerm]
                    ]),
                    t[26] || (t[26] = a("label", {
                      class: "form-check-label",
                      for: "shortTerm"
                    }, "Short-Term", -1))
                  ])) : P("", !0),
                  ((c = e.calcParams) == null ? void 0 : c.rentalType) != "pad-split" ? (p(), h("div", hwt, [
                    V(a("input", {
                      class: "form-check-input",
                      type: "checkbox",
                      id: "padSplit",
                      "onUpdate:modelValue": t[11] || (t[11] = (u) => e.comparePadSplit = u)
                    }, null, 512), [
                      [Ue, e.comparePadSplit]
                    ]),
                    t[27] || (t[27] = a("label", {
                      class: "form-check-label",
                      for: "padSplit"
                    }, "PadSplit", -1))
                  ])) : P("", !0)
                ])
              ])
            ]),
            t[30] || (t[30] = a("div", { class: "modal-footer border-0 pt-0" }, [
              a("button", {
                type: "button",
                class: "btn btn-lava",
                "data-bs-dismiss": "modal"
              }, "Close")
            ], -1))
          ], 64)) : (p(), h("div", mwt, t[31] || (t[31] = [
            a("button", {
              type: "button",
              class: "btn-close position-absolute top-10 end-10",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            }, null, -1),
            a("i", { class: "fa-duotone fa-solid fa-rectangle-vertical-history mb-3 fs-2" }, null, -1),
            a("p", { class: "fw-bold fs-5" }, "Analysis Style", -1),
            y(" Upgrade to "),
            a("b", null, "Property Suite Pro", -1),
            y(" to analyze multi-family, STR, rent vs sell, and other advanced analysis styles. ")
          ])))
        ])
      ])
    ], 512)
  ], 64);
}
const gwt = /* @__PURE__ */ Ae(B0t, [["render", fwt]]), vwt = me({
  name: "AfterTaxAnalysis",
  props: {},
  components: {
    NumericalInput: Aa
  },
  emits: [
    "change"
  ],
  data() {
    return {
      //improvements: 0.8,
      //depreciationTerm: 27.5,
      //marginalIncomeTaxRate: 0.37,
      //depreciationRecaptureTaxRate: 0.25,
      //capitalGainsTaxRate: 0.20,
    };
  },
  watch: {
    "calcParams.afterTaxAnalysis"() {
      var e, t, s, n, r, i;
      (e = this.calcParams) != null && e.afterTaxAnalysis && ((t = this.calcParams.afterTaxAnalysis).improvements ?? (t.improvements = 0.8), (s = this.calcParams.afterTaxAnalysis).depreciationTerm ?? (s.depreciationTerm = 27.5), (n = this.calcParams.afterTaxAnalysis).marginalIncomeTaxRate ?? (n.marginalIncomeTaxRate = 0.37), (r = this.calcParams.afterTaxAnalysis).depreciationRecaptureTaxRate ?? (r.depreciationRecaptureTaxRate = 0.25), (i = this.calcParams.afterTaxAnalysis).capitalGainsTaxRate ?? (i.capitalGainsTaxRate = 0.2));
    }
  },
  computed: {
    improvementValue() {
      var e, t;
      return (e = this.calcParams.afterTaxAnalysis) != null && e.improvements ? this.costBasis * ((t = this.calcParams.afterTaxAnalysis) == null ? void 0 : t.improvements) : this.costBasis;
    },
    annualDepreciation() {
      var e, t;
      if (((e = this.calcParams.afterTaxAnalysis) == null ? void 0 : e.depreciationTerm) > 0)
        return this.improvementValue / ((t = this.calcParams.afterTaxAnalysis) == null ? void 0 : t.depreciationTerm);
    },
    ...q(Te, ["access", "aclLoaded"]),
    ...q(qe, ["costBasis", "calcParams", "calculating"])
  },
  methods: {
    number: Ve,
    currency: Ze,
    detectChange() {
      this.$emit("change");
    }
  },
  created() {
  },
  mounted() {
    this.aclLoaded.then(() => {
    });
  }
}), ywt = {
  key: 0,
  class: "row row-cols-1 row-cols-md-2 g-3"
}, bwt = { class: "col" }, Awt = { class: "card shadow-sm overflow-hidden" }, wwt = { class: "card-body" }, Cwt = { class: "row g-2" }, Swt = { class: "col-5" }, Pwt = { class: "col-5" }, kwt = { class: "col-5" }, Ewt = { class: "col" }, Iwt = { class: "card shadow-sm overflow-hidden" }, Twt = { class: "card-body" }, Owt = { class: "row g-2" }, Rwt = { class: "col-5" }, Lwt = ["disabled"], Bwt = { class: "col-5" }, Mwt = { class: "card-body" }, xwt = { class: "row g-2" }, Fwt = { class: "col-5" }, Vwt = { class: "col-5 text-end" }, Dwt = { class: "form-control-plaintext" }, Nwt = { class: "col-5 text-end" }, jwt = { class: "form-control-plaintext" }, Hwt = { class: "col-5 text-end" }, Uwt = { class: "form-control-plaintext" };
function zwt(e, t, s, n, r, i) {
  var l;
  const o = pe("numerical-input");
  return p(), h(A, null, [
    t[19] || (t[19] = a("p", { class: "mb-3 fw-bold fs-5" }, " After-Tax Analysis ", -1)),
    (l = e.calcParams) != null && l.afterTaxAnalysis ? (p(), h("div", ywt, [
      a("div", bwt, [
        a("div", Awt, [
          t[9] || (t[9] = a("div", { class: "card-header bg-white fw-bold pb-0 border-0" }, "Income Tax Rates", -1)),
          a("div", wwt, [
            a("div", Cwt, [
              t[6] || (t[6] = a("label", { class: "col-7 col-form-label" }, "Marginal Income Tax Rate", -1)),
              a("div", Swt, [
                N(o, {
                  percent: "",
                  modelValue: e.calcParams.afterTaxAnalysis.marginalIncomeTaxRate,
                  "onUpdate:modelValue": t[0] || (t[0] = (d) => e.calcParams.afterTaxAnalysis.marginalIncomeTaxRate = d),
                  disabled: e.calculating,
                  onChange: e.detectChange
                }, null, 8, ["modelValue", "disabled", "onChange"])
              ]),
              t[7] || (t[7] = a("label", { class: "col-7 col-form-label" }, "Depreciation Recapture Tax Rate", -1)),
              a("div", Pwt, [
                N(o, {
                  percent: "",
                  modelValue: e.calcParams.afterTaxAnalysis.depreciationRecaptureTaxRate,
                  "onUpdate:modelValue": t[1] || (t[1] = (d) => e.calcParams.afterTaxAnalysis.depreciationRecaptureTaxRate = d),
                  disabled: e.calculating,
                  onChange: e.detectChange
                }, null, 8, ["modelValue", "disabled", "onChange"])
              ]),
              t[8] || (t[8] = a("label", { class: "col-7 col-form-label" }, "Capital Gains Tax Rate", -1)),
              a("div", kwt, [
                N(o, {
                  percent: "",
                  modelValue: e.calcParams.afterTaxAnalysis.capitalGainsTaxRate,
                  "onUpdate:modelValue": t[2] || (t[2] = (d) => e.calcParams.afterTaxAnalysis.capitalGainsTaxRate = d),
                  disabled: e.calculating,
                  onChange: e.detectChange
                }, null, 8, ["modelValue", "disabled", "onChange"])
              ])
            ])
          ])
        ])
      ]),
      a("div", Ewt, [
        a("div", Iwt, [
          t[17] || (t[17] = a("div", { class: "card-header bg-white fw-bold pb-0 border-0" }, "Improvements & Depreciation", -1)),
          a("div", Twt, [
            a("div", Owt, [
              t[11] || (t[11] = a("label", { class: "col-7 col-form-label" }, "Property Type", -1)),
              a("div", Rwt, [
                V(a("select", {
                  class: "form-select",
                  "onUpdate:modelValue": t[3] || (t[3] = (d) => e.calcParams.afterTaxAnalysis.depreciationTerm = d),
                  disabled: e.calculating,
                  onChange: t[4] || (t[4] = (...d) => e.detectChange && e.detectChange(...d))
                }, t[10] || (t[10] = [
                  a("option", { value: 27.5 }, "Residential", -1),
                  a("option", { value: 39 }, "Commercial", -1)
                ]), 40, Lwt), [
                  [We, e.calcParams.afterTaxAnalysis.depreciationTerm]
                ])
              ]),
              t[12] || (t[12] = a("label", { class: "col-7 col-form-label" }, "Depreciation Term", -1)),
              a("div", Bwt, g(e.number(e.calcParams.afterTaxAnalysis.depreciationTerm, 1)) + " Years ", 1)
            ])
          ]),
          t[18] || (t[18] = a("div", { class: "card-header bg-white fw-bold pb-0 border-0 border-top" }, "Improvement Portion of Cost Basis", -1)),
          a("div", Mwt, [
            a("div", xwt, [
              t[13] || (t[13] = a("label", { class: "col-7 col-form-label" }, "Improvements", -1)),
              a("div", Fwt, [
                N(o, {
                  percent: "",
                  modelValue: e.calcParams.afterTaxAnalysis.improvements,
                  "onUpdate:modelValue": t[5] || (t[5] = (d) => e.calcParams.afterTaxAnalysis.improvements = d),
                  disabled: e.calculating,
                  onChange: e.detectChange
                }, null, 8, ["modelValue", "disabled", "onChange"])
              ]),
              t[14] || (t[14] = a("label", { class: "col-7 col-form-label" }, "Cost Basis", -1)),
              a("div", Vwt, [
                a("span", Dwt, g(e.currency(e.costBasis)), 1)
              ]),
              t[15] || (t[15] = a("label", { class: "col-7 col-form-label" }, "Improvement Value", -1)),
              a("div", Nwt, [
                a("span", jwt, g(e.currency(e.improvementValue)), 1)
              ]),
              t[16] || (t[16] = a("label", { class: "col-7 col-form-label" }, "Annual Depreciation", -1)),
              a("div", Hwt, [
                a("span", Uwt, g(e.currency(e.annualDepreciation)), 1)
              ])
            ])
          ])
        ])
      ])
    ])) : P("", !0)
  ], 64);
}
const Wwt = /* @__PURE__ */ Ae(vwt, [["render", zwt]]), Gwt = me({
  name: "ParametersTab",
  props: {
    loading: Boolean
  },
  emits: [
    "editInvestment",
    "resetListing",
    "saveFields",
    "change"
  ],
  components: {
    IncomeAccounts: jyt,
    VacancyParameters: v1t,
    LoanAmount: ubt,
    SaveParameters: R1t,
    PurchasePriceTransactionCosts: wbt,
    RehabArvStabilization: Xbt,
    Resale: rAt,
    InflationAndAppreciation: TAt,
    ExpenseAccounts: L0t,
    NonOperatingExpenses: gwt,
    AfterTaxAnalysis: Wwt
  },
  computed: {
    componentBusy() {
      return this.loading || this.calculating;
    },
    componentBusyAdvanced() {
      return this.loading || this.calculating || this.hasAdvanced != !0;
    },
    showExistingInvestment() {
      var e, t, s;
      return ((t = (e = this.access) == null ? void 0 : e.calculator) == null ? void 0 : t.existingInvestment) == !0 && ((s = this.property) == null ? void 0 : s.propId) != null;
    },
    isShare() {
      var e;
      return ((e = this.access) == null ? void 0 : e.isShare) == !0;
    },
    isAnalysis() {
      var e;
      return ((e = this.access) == null ? void 0 : e.isAnalysis) == !0;
    },
    autoHoldPeriod: {
      get() {
        return this.calcParams.hold == 0;
      },
      set(e) {
        e ? this.calcParams.hold = 0 : this.calcParams.hold = 10;
      }
    },
    incomeIssue() {
      var e;
      return this.hasUnitErrors || ((e = this.notifications) == null ? void 0 : e.some((t) => {
        if (pi(t.eventId) && "accountId" in t.properties) {
          const s = Number(t.properties.accountId);
          return this.incomeAccounts.some((n) => n.id == s);
        }
        return !1;
      }));
    },
    expenseIssue() {
      var e;
      return (e = this.notifications) == null ? void 0 : e.some((t) => {
        if (pi(t.eventId) && "accountId" in t.properties) {
          const s = Number(t.properties.accountId);
          return this.expenseAccounts.some((n) => n.nonOperating == !1 && n.id == s);
        }
        return !1;
      });
    },
    nonOpExpenseIssue() {
      var e;
      return (e = this.notifications) == null ? void 0 : e.some((t) => {
        if (pi(t.eventId) && "accountId" in t.properties) {
          const s = Number(t.properties.accountId);
          return console.log(`${this.$options.name}.nonOpExpenseIssue`, this.nonOperatingExpenseAccounts, t, s), this.nonOperatingExpenseAccounts.some((n) => n.nonOperating == !0 && n.id == s);
        }
        return !1;
      });
    },
    hasAccess() {
      return (this.hasAdvanced || this.isMarketplace || this.isShare || this.isAnalysis) && (this.isAdmin || this.isUser || this.isClient);
    },
    ...q(Te, ["access", "aclLoaded", "hasAdvanced", "isAnonymous", "isClient", "isAdmin", "isUser"]),
    ...q(qe, ["calcParams", "isExistingInvestment", "property", "calculating", "isHoldYearAuto", "hasUnitErrors", "isMarketplace"]),
    ...q(ct, ["incomeAccounts", "expenseAccounts", "nonOperatingExpenseAccounts"]),
    ...q(Ci, ["notifications"]),
    ...q(ba, ["portfolioId"])
  },
  methods: {
    number: Ve,
    editInvestment() {
      this.$emit("editInvestment");
    },
    detectChange() {
      this.$emit("change");
    },
    resetListing(e = !1) {
      this.$emit("resetListing", e);
    },
    saveFields() {
      this.$emit("saveFields");
    }
  },
  created() {
  },
  mounted() {
    this.aclLoaded.then(() => {
    });
  }
}), Ywt = "data:image/png;base64,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", Xwt = { class: "container-xl" }, qwt = {
  key: 0,
  class: "alert alert-info d-flex justify-content-between align-items-center flex-column flex-lg-row text-center text-lg-auto mb-3",
  role: "alert"
}, Qwt = { class: "row mb-3" }, Kwt = {
  class: "col-12 col-lg-3",
  "aria-label": "Parameters navigation",
  id: "parametersTabs",
  role: "tablist"
}, Zwt = { class: "dropdown d-xl-none mb-3" }, Jwt = { class: "dropdown-menu shadow" }, $wt = {
  type: "button",
  class: "dropdown-item",
  ref: "purchaseTab",
  id: "purchase-tab",
  "data-bs-toggle": "tab",
  "data-bs-target": "#purchase",
  role: "tab",
  "aria-controls": "purchase",
  "aria-selected": "true"
}, _wt = { key: 0 }, e2t = {
  type: "button",
  class: "dropdown-item",
  ref: "rehabTab",
  id: "rehab-tab",
  "data-bs-toggle": "tab",
  "data-bs-target": "#rehab",
  role: "tab",
  "aria-controls": "rehab",
  "aria-selected": "false"
}, t2t = {
  type: "button",
  class: "dropdown-item",
  ref: "afterTaxTab",
  id: "after-tax-tab",
  "data-bs-toggle": "tab",
  "data-bs-target": "#after-tax",
  role: "tab",
  "aria-controls": "after-tax",
  "aria-selected": "false"
}, s2t = { key: 1 }, a2t = {
  type: "button",
  class: "dropdown-item",
  ref: "incomeTab",
  id: "income-tab",
  "data-bs-toggle": "tab",
  "data-bs-target": "#income",
  role: "tab",
  "aria-controls": "income",
  "aria-selected": "false"
}, n2t = {
  type: "button",
  class: "dropdown-item",
  ref: "vacancyTab",
  id: "vacancy-tab",
  "data-bs-toggle": "tab",
  "data-bs-target": "#vacancy",
  role: "tab",
  "aria-controls": "vacancy",
  "aria-selected": "false"
}, r2t = {
  type: "button",
  class: "dropdown-item",
  ref: "expensesTab",
  id: "expenses-tab",
  "data-bs-toggle": "tab",
  "data-bs-target": "#expenses",
  role: "tab",
  "aria-controls": "expenses",
  "aria-selected": "false"
}, o2t = { key: 0 }, i2t = {
  type: "button",
  class: "dropdown-item",
  ref: "inflationTab",
  id: "inflation-tab",
  "data-bs-toggle": "tab",
  "data-bs-target": "#inflation",
  role: "tab",
  "aria-controls": "inflation",
  "aria-selected": "false"
}, l2t = { class: "list-group d-none d-xl-flex" }, d2t = {
  type: "button",
  class: "list-group-item list-group-item-action active",
  id: "purchase-tab",
  "data-bs-toggle": "tab",
  "data-bs-target": "#purchase",
  role: "tab",
  "aria-controls": "purchase",
  "aria-selected": "true"
}, c2t = {
  key: 0,
  type: "button",
  class: "list-group-item list-group-item-action",
  id: "rehab-tab",
  "data-bs-toggle": "tab",
  "data-bs-target": "#rehab",
  role: "tab",
  "aria-controls": "rehab",
  "aria-selected": "false"
}, u2t = {
  key: 1,
  type: "button",
  class: "list-group-item list-group-item-action",
  id: "income-tab",
  "data-bs-toggle": "tab",
  "data-bs-target": "#income",
  role: "tab",
  "aria-controls": "income",
  "aria-selected": "false"
}, p2t = { key: 0 }, h2t = {
  type: "button",
  class: "list-group-item list-group-item-action",
  id: "expenses-tab",
  "data-bs-toggle": "tab",
  "data-bs-target": "#expenses",
  role: "tab",
  "aria-controls": "expenses",
  "aria-selected": "false"
}, m2t = { key: 0 }, f2t = { class: "col-12 col-lg-9" }, g2t = {
  key: 0,
  class: "row mb-3"
}, v2t = { class: "col" }, y2t = { class: "card shadow-sm guard p-5 bg-gradient-periwinkle" }, b2t = { class: "row" }, A2t = { class: "col-lg-6 text-center text-lg-start d-flex justify-content-center flex-column align-items-center align-items-lg-start" }, w2t = {
  key: 1,
  class: "tab-content"
}, C2t = {
  class: "tab-pane active",
  id: "purchase",
  role: "tabpanel",
  "aria-labelledby": "purchase-tab",
  tabindex: "0"
}, S2t = { class: "row row-cols-1 row-cols-md-2 g-3" }, P2t = { class: "col-md-12 fw-bold fs-5" }, k2t = { class: "col d-flex flex-column gap-3" }, E2t = {
  key: 0,
  class: "col"
}, I2t = {
  key: 0,
  class: "tab-pane",
  id: "rehab",
  role: "tabpanel",
  "aria-labelledby": "rehab-tab",
  tabindex: "0"
}, T2t = {
  class: "tab-pane",
  id: "after-tax",
  role: "tabpanel",
  "aria-labelledby": "after-tax-tab",
  tabindex: "0"
}, O2t = {
  key: 1,
  class: "tab-pane",
  id: "income",
  role: "tabpanel",
  "aria-labelledby": "income-tab",
  tabindex: "0"
}, R2t = {
  class: "tab-pane",
  id: "vacancy",
  role: "tabpanel",
  "aria-labelledby": "vacancy-tab",
  tabindex: "0"
}, L2t = {
  class: "tab-pane",
  id: "expenses",
  role: "tabpanel",
  "aria-labelledby": "expenses-tab",
  tabindex: "0"
}, B2t = {
  class: "tab-pane",
  id: "inflation",
  role: "tabpanel",
  "aria-labelledby": "inflation-tab",
  tabindex: "0"
}, M2t = {
  key: 0,
  class: "row save-row"
}, x2t = { class: "col mb-3 mb-md-0" };
function F2t(e, t, s, n, r, i) {
  var I;
  const o = pe("purchase-price-transaction-costs"), l = pe("resale"), d = pe("loan-amount"), c = pe("rehab-arv-stabilization"), u = pe("after-tax-analysis"), m = pe("income-accounts"), f = pe("vacancy-parameters"), v = pe("expense-accounts"), b = pe("non-operating-expenses"), w = pe("inflation-and-appreciation"), S = pe("save-parameters");
  return p(), h("div", Xwt, [
    !e.portfolioId && e.showExistingInvestment && e.isExistingInvestment ? (p(), h("div", qwt, [
      t[1] || (t[1] = a("div", { class: "mb-2 mb-lg-0" }, [
        a("i", { class: "fa-light fa-circle-info me-2" }),
        y("Greyed out fields below are editable through the "),
        a("b", null, "Financial History"),
        y(" interface. ")
      ], -1)),
      a("div", null, [
        a("button", {
          type: "button",
          class: "btn btn-eclipse btn-sm",
          onClick: t[0] || (t[0] = (...T) => e.editInvestment && e.editInvestment(...T))
        }, "Edit Financial History")
      ])
    ])) : P("", !0),
    a("form", null, [
      a("div", Qwt, [
        a("div", Kwt, [
          a("div", Zwt, [
            t[4] || (t[4] = a("button", {
              class: "btn btn-outline-eclipse dropdown-toggle",
              type: "button",
              "data-bs-toggle": "dropdown",
              "aria-expanded": "false"
            }, " Select a Parameter Category ", -1)),
            a("ul", Jwt, [
              a("li", null, [
                a("button", $wt, [
                  e.portfolioId ? (p(), h(A, { key: 0 }, [
                    y(" Property Value & Resale ")
                  ], 64)) : (p(), h(A, { key: 1 }, [
                    y(" Purchase, Loan, & Resale ")
                  ], 64))
                ], 512)
              ]),
              e.portfolioId ? P("", !0) : (p(), h("li", _wt, [
                a("button", e2t, "Rehab & ARV", 512)
              ])),
              a("li", null, [
                a("button", t2t, "After-Tax Analysis", 512)
              ]),
              e.portfolioId ? P("", !0) : (p(), h("li", s2t, [
                a("button", a2t, "Income", 512)
              ])),
              a("li", null, [
                a("button", n2t, "Vacancy", 512)
              ]),
              a("li", null, [
                a("button", r2t, [
                  t[3] || (t[3] = y("Expenses ")),
                  e.expenseIssue || e.nonOpExpenseIssue ? (p(), h("span", o2t, t[2] || (t[2] = [
                    a("i", { class: "fa-duotone fa-solid fa-triangle-exclamation text-warning me-2" }, null, -1)
                  ]))) : P("", !0)
                ], 512)
              ]),
              a("li", null, [
                a("button", i2t, "Inflation & Appreciation", 512)
              ])
            ])
          ]),
          a("div", l2t, [
            a("button", d2t, [
              t[5] || (t[5] = a("div", { class: "icon-list-group-spacing-20 me-2 text-center" }, [
                a("i", { class: "fa-light fa-house-laptop" })
              ], -1)),
              a("b", null, [
                e.portfolioId ? (p(), h(A, { key: 0 }, [
                  y(" Property Value & Resale ")
                ], 64)) : (p(), h(A, { key: 1 }, [
                  y(" Purchase, Loan, & Resale ")
                ], 64))
              ])
            ]),
            e.portfolioId ? P("", !0) : (p(), h("button", c2t, t[6] || (t[6] = [
              a("div", { class: "icon-list-group-spacing-20 me-2 text-center" }, [
                a("i", { class: "fa-light fa-lightbulb-dollar" })
              ], -1),
              a("b", null, "Rehab & ARV", -1)
            ]))),
            t[15] || (t[15] = a("button", {
              type: "button",
              class: "list-group-item list-group-item-action",
              id: "after-tax-tab",
              "data-bs-toggle": "tab",
              "data-bs-target": "#after-tax",
              role: "tab",
              "aria-controls": "after-tax",
              "aria-selected": "false"
            }, [
              a("div", { class: "icon-list-group-spacing-20 me-2 text-center" }, [
                a("i", { class: "fa-light fa-hand-holding-circle-dollar" })
              ]),
              a("b", null, "After-Tax Analysis")
            ], -1)),
            e.portfolioId ? P("", !0) : (p(), h("button", u2t, [
              t[8] || (t[8] = a("div", { class: "icon-list-group-spacing-20 me-2 text-center" }, [
                a("i", { class: "fa-light fa-coins" })
              ], -1)),
              t[9] || (t[9] = a("b", null, "Income", -1)),
              t[10] || (t[10] = y()),
              e.incomeIssue ? (p(), h("span", p2t, t[7] || (t[7] = [
                a("i", { class: "fa-duotone fa-solid fa-triangle-exclamation text-warning me-2" }, null, -1)
              ]))) : P("", !0)
            ])),
            t[16] || (t[16] = a("button", {
              type: "button",
              class: "list-group-item list-group-item-action",
              id: "vacancy-tab",
              "data-bs-toggle": "tab",
              "data-bs-target": "#vacancy",
              role: "tab",
              "aria-controls": "vacancy",
              "aria-selected": "false"
            }, [
              a("div", { class: "icon-list-group-spacing-20 me-2 text-center" }, [
                a("i", { class: "fa-light fa-magnifying-glass-location" })
              ]),
              a("b", null, "Vacancy")
            ], -1)),
            a("button", h2t, [
              t[12] || (t[12] = a("div", { class: "icon-list-group-spacing-20 me-2 text-center" }, [
                a("i", { class: "fa-light fa-hand-holding-circle-dollar" })
              ], -1)),
              t[13] || (t[13] = a("b", null, "Expenses", -1)),
              t[14] || (t[14] = y()),
              e.expenseIssue || e.nonOpExpenseIssue ? (p(), h("span", m2t, t[11] || (t[11] = [
                a("i", { class: "fa-duotone fa-solid fa-triangle-exclamation text-warning me-2" }, null, -1)
              ]))) : P("", !0)
            ]),
            t[17] || (t[17] = a("button", {
              type: "button",
              class: "list-group-item list-group-item-action",
              id: "inflation-tab",
              "data-bs-toggle": "tab",
              "data-bs-target": "#inflation",
              role: "tab",
              "aria-controls": "inflation",
              "aria-selected": "false"
            }, [
              a("div", { class: "icon-list-group-spacing-20 me-2 text-center" }, [
                a("i", { class: "fa-light fa-filter-circle-dollar" })
              ]),
              a("b", null, "Inflation & Appreciation")
            ], -1))
          ])
        ]),
        a("div", f2t, [
          e.hasAccess ? (p(), h("div", w2t, [
            a("div", C2t, [
              a("div", S2t, [
                a("div", P2t, [
                  e.portfolioId ? (p(), h(A, { key: 0 }, [
                    y(" Property Value & Resale ")
                  ], 64)) : (p(), h(A, { key: 1 }, [
                    y(" Purchase, Loan, & Resale ")
                  ], 64))
                ]),
                a("div", k2t, [
                  N(o, { onChange: e.detectChange }, null, 8, ["onChange"]),
                  N(l, { onChange: e.detectChange }, null, 8, ["onChange"])
                ]),
                e.portfolioId ? P("", !0) : (p(), h("div", E2t, [
                  N(d, { onChange: e.detectChange }, null, 8, ["onChange"])
                ]))
              ])
            ]),
            e.portfolioId ? P("", !0) : (p(), h("div", I2t, [
              N(c, { onChange: e.detectChange }, null, 8, ["onChange"])
            ])),
            a("div", T2t, [
              N(u, { onChange: e.detectChange }, null, 8, ["onChange"])
            ]),
            e.portfolioId ? P("", !0) : (p(), h("div", O2t, [
              N(m, { onChange: e.detectChange }, null, 8, ["onChange"])
            ])),
            a("div", R2t, [
              N(f, { onChange: e.detectChange }, null, 8, ["onChange"])
            ]),
            a("div", L2t, [
              N(v, { onChange: e.detectChange }, null, 8, ["onChange"]),
              t[23] || (t[23] = a("br", null, null, -1)),
              t[24] || (t[24] = a("br", null, null, -1)),
              N(b, { onChange: e.detectChange }, null, 8, ["onChange"])
            ]),
            a("div", B2t, [
              N(w, { onChange: e.detectChange }, null, 8, ["onChange"])
            ])
          ])) : (p(), h("div", g2t, [
            a("div", v2t, [
              a("div", y2t, [
                a("div", b2t, [
                  t[22] || (t[22] = a("div", { class: "col-lg-6" }, [
                    a("img", {
                      class: "img-fluid",
                      src: Ywt,
                      alt: "Leasing and Resale Expenses",
                      title: "Leasing and Resale Expenses",
                      height: "435",
                      width: "641",
                      loading: "lazy"
                    })
                  ], -1)),
                  a("div", A2t, [
                    e.isAnonymous && ((I = e.property) != null && I.isActiveMarketplaceListing) ? (p(), h(A, { key: 0 }, [
                      t[18] || (t[18] = a("p", { class: "fw-bold fs-5" }, " Create an account to edit advanced financial parameters of Marketplace Listings ", -1)),
                      t[19] || (t[19] = a("a", {
                        href: "/signup",
                        class: "btn btn-eclipse"
                      }, "Activate Advanced Parameters!", -1))
                    ], 64)) : (p(), h(A, { key: 1 }, [
                      t[20] || (t[20] = a("p", { class: "fw-bold fs-5" }, " Unlock our full set of financial model controls! ", -1)),
                      t[21] || (t[21] = a("a", {
                        href: "/account/settings",
                        class: "btn btn-eclipse"
                      }, "Activate Advanced Parameters!", -1))
                    ], 64))
                  ])
                ])
              ])
            ])
          ]))
        ])
      ]),
      e.hasAccess && !e.isAnalysis && !e.isShare ? (p(), h("div", M2t, [
        t[25] || (t[25] = a("div", { class: "col-12 alerta" }, null, -1)),
        a("div", x2t, [
          N(S, {
            onReset: e.resetListing,
            onSave: e.saveFields,
            onChange: e.detectChange
          }, null, 8, ["onReset", "onSave", "onChange"])
        ])
      ])) : P("", !0)
    ])
  ]);
}
const rds = /* @__PURE__ */ Ae(Gwt, [["render", F2t]]), V2t = me({
  name: "PortfolioFinderLite",
  components: {
    LeadSimple: Qb
  },
  props: {
    mlsSource: String,
    mlsNumber: String
  },
  data() {
    return {
      showComponent: !1,
      loading: !0,
      skipTraceStats: void 0,
      busy: !1,
      traced: !1,
      skipTracing: !1,
      skipTraceConfirmed: Go("skip-trace-confirmed-v2") == "true",
      emails: [],
      phoneNumbers: [],
      emailSelected: void 0,
      phoneSelected: void 0,
      honorDncStatus: !0,
      owners: [],
      selectedOwner: void 0,
      selectedKey: void 0,
      totalProperties: 1,
      totalNames: 1,
      singleFamily: void 0,
      residential24Family: void 0,
      updateOwnerName: !0
    };
  },
  computed: {
    showSkipTraceCard() {
      var e, t, s;
      return (((e = this.access) == null ? void 0 : e.isAuthenticated) && this.isClient != !0 || this.canViewSkipTrace && ((t = this.owner) == null ? void 0 : t.owner1FirstName)) && ((s = this.property) == null ? void 0 : s.propId) > 0;
    },
    canSkipTrace() {
      var e, t, s;
      return ((e = this.access) == null ? void 0 : e.isAnonymous) != !0 && ((s = (t = this.access) == null ? void 0 : t.properties) == null ? void 0 : s.skipTrace) == !0;
    },
    canViewSkipTrace() {
      var e, t, s;
      return ((e = this.access) == null ? void 0 : e.isShare) || ((t = this.access) == null ? void 0 : t.isAnalysis) || ((s = this.access) == null ? void 0 : s.isIdx);
    },
    skipTraceCapable() {
      var e;
      return this.isClient != !0 && ((e = this.property) == null ? void 0 : e.propId) > 0;
    },
    canViewOwner() {
      var e, t;
      return ((t = (e = this.access) == null ? void 0 : e.leads) == null ? void 0 : t.leads) == !0;
    },
    canAddCrm() {
      var e;
      return this.isClient != !0 && this.crmProvider == bt.LeadSimple && ((e = this.taxInfo) == null ? void 0 : e.ownerId);
    },
    skipTracingStyles() {
      return {
        "skip-tracing": this.skipTracing,
        "modal-content": !0,
        "bg-gradient-alphabet": !0
      };
    },
    skipTraceName() {
      if (this.emails.length > 0)
        return `${this.emails[0].firstName} ${this.emails[0].lastName}`;
      if (this.phoneNumbers.length > 0)
        return `${this.phoneNumbers[0].firstName} ${this.phoneNumbers[0].lastName}`;
    },
    skipTraceLitigator() {
      return this.emails.some((e) => e.litigator) || this.phoneNumbers.some((e) => e.litigator);
    },
    warnCrmDnc() {
      var e;
      return this.honorDncStatus == !1 && ((e = this.phoneSelected) == null ? void 0 : e.doNotCall) == !0;
    },
    annualManagementFeeValue() {
      var e, t;
      return (((e = this.singleFamily) == null ? void 0 : e.annualManagementFees) ?? 0) + (((t = this.residential24Family) == null ? void 0 : t.annualManagementFees) ?? 0);
    },
    clientLifetimeValue() {
      var e;
      return this.annualManagementFeeValue * (((e = this.userInfo) == null ? void 0 : e.expectedClientTenure) ?? 3);
    },
    calculatingClasses() {
      return {
        card: !0,
        "card-cash-flow": !0,
        "shadow-sm": !0,
        calculating: this.loading
      };
    },
    ...q(Te, ["access", "aclLoaded", "isClient", "isAdmin", "isUser"]),
    ...q(qe, ["property", "propertyInitialized", "taxInfo", "taxInfoInitialized"]),
    ...q(ct, ["crmProvider", "userInfo"]),
    ...q(Ba, ["owner", "ownerLoaded"])
  },
  watch: {
    showComponent(e) {
      e && this.$nextTick(() => {
        this.setupAccordion();
      });
    }
  },
  methods: {
    currency: Ze,
    number: Ve,
    percent: Wt,
    date: cs,
    addToCRM() {
      var e;
      (e = bootstrap.Modal.getOrCreateInstance(this.$refs.dialogAddToCRM)) == null || e.show();
    },
    closeCrmDialog() {
      var e;
      (e = bootstrap.Modal.getOrCreateInstance(this.$refs.dialogAddToCRM)) == null || e.hide();
    },
    async showConfirmSkipTraceModal() {
      var e;
      (e = bootstrap.Modal.getOrCreateInstance(this.$refs.confirmSkipTraceModal)) == null || e.show(), this.updateOwnerName = !1, this.skipTraceConfirmed && this.skipTraceProp();
    },
    async hideConfirmSkipTraceModal() {
      var e;
      (e = bootstrap.Modal.getOrCreateInstance(this.$refs.confirmSkipTraceModal)) == null || e.hide();
    },
    async skipTraceProp() {
      try {
        eo("skip-trace-confirmed-v2", !0), this.skipTraceConfirmed = !0, this.skipTracing = !0, this.emails.length = 0, this.phoneNumbers.length = 0, this.emailSelected = void 0, this.phoneSelected = void 0;
        let e = !0;
        const t = await W.api.homes.skipTraceOwnerName(this.property.propId, this.selectedOwner);
        if (t.data.status != de.Success)
          throw new Error(t.data.message);
        this.emails.push(...t.data.emails), this.phoneNumbers.push(...t.data.phoneNumbers), this.emails.length > 0 && (this.emailSelected = this.emails[0]), this.phoneNumbers.length > 0 && (this.phoneSelected = this.phoneNumbers[0]), this.honorDncStatus = t.data.honorDncStatus, this.updateOwnerName = this.skipTraceName != this.getDisplayName(this.selectedOwner), this.skipTraceStats && t.data.skipTrace && (this.skipTraceStats.credits = t.data.skipTrace.credits, this.skipTraceStats.creditsConsumed = t.data.skipTrace.creditsConsumed, this.skipTraceStats.available = t.data.skipTrace.available);
      } catch (e) {
        Se(e);
      }
      this.skipTracing = !1;
    },
    async updateContactSkip() {
      var e;
      this.selectedOwner.litigator = this.skipTraceLitigator, this.phoneSelected ? (this.selectedOwner.phone = this.phoneSelected.phone, this.selectedOwner.dnc = this.phoneSelected.doNotCall) : (this.selectedOwner.phone = "", this.selectedOwner.dnc = !1), this.emailSelected ? this.selectedOwner.email = this.emailSelected.email : this.selectedOwner.email = "", this.updateOwnerName && (this.emails.length > 0 && (this.selectedOwner.first = this.emails[0].firstName, this.selectedOwner.last = this.emails[0].lastName), this.phoneNumbers.length > 0 && (this.selectedOwner.first = this.phoneNumbers[0].firstName, this.selectedOwner.last = this.phoneNumbers[0].lastName)), await this.saveContactEdit(), (e = bootstrap.Modal.getOrCreateInstance(this.$refs.confirmSkipTraceModal)) == null || e.hide();
    },
    async saveContactEdit() {
      try {
        this.isBusy = !0;
        const e = await W.api.homes.updateOwnerName(this.property.propId, this.selectedOwner);
        if (e.data.status != de.Success)
          throw new Error(e.data.message);
        this.selectedOwner.key = e.data.owner.key, this.selectedOwner.firstName = e.data.owner.first, this.selectedOwner.lastName = e.data.owner.last, this.selectedOwner.phone = e.data.owner.phone, this.selectedOwner.phoneDNC = e.data.owner.dnc, this.selectedOwner.email = e.data.owner.email, this.selectedOwner.litigator = e.data.owner.litigator, this.selectedOwner.skipTraced = e.data.owner.skipTraced;
      } catch (e) {
        Se(e);
      }
      this.isBusy = !1;
    },
    async getOwnerNames() {
      if (this.canSkipTrace)
        try {
          if (!this.property.propId || this.property.isCustom)
            return;
          const e = await W.api.homes.getOwnerNames(this.property.propId);
          if (e.data.status != de.Success)
            throw new Le(e);
          this.owners = e.data.names, this.selectedKey = e.data.selectedKey, this.totalProperties = e.data.totalProperties, this.totalNames = e.data.totalNames, this.skipTraceStats = e.data.skipTrace;
        } catch (e) {
          console.error(e);
        }
    },
    selectOwner(e, t) {
      var s;
      this.selectedOwner = e, (s = bootstrap.Collapse.getOrCreateInstance(`#collapse${t}`)) == null || s.show();
    },
    isSelectedOwner(e) {
      var t;
      return console.log("isSelectedOwner", this.selectedOwner, e), ((t = this.selectedOwner) == null ? void 0 : t.key) == e.key;
    },
    emailChanged(e) {
      var t;
      console.log("emailChanged", e, this.emailSelected), ((t = this.emailSelected) == null ? void 0 : t.email) == e.email && (this.emailSelected = void 0);
    },
    phoneChanged(e) {
      var t;
      console.log("phoneChanged", e, this.phoneSelected), ((t = this.phoneSelected) == null ? void 0 : t.phone) == e.phone && (this.phoneSelected = void 0);
    },
    loadClientValues() {
      W.api.portfolioFinder.getClientValue(this.owner.id, Xt.SingleFamily).then((e) => this.singleFamily = e.data), W.api.portfolioFinder.getClientValue(this.owner.id, Xt.Residential24Family).then((e) => this.residential24Family = e.data);
    },
    getDisplayName(e) {
      return e != null && e.first && (e != null && e.last) ? `${e.first} ${e.last}` : e != null && e.isCompany ? e.companyName : (e == null ? void 0 : e.companyName) ?? (e == null ? void 0 : e.first) ?? (e == null ? void 0 : e.last) ?? "Unknown";
    },
    selectedOwnerStyle(e) {
      return {
        selected: this.isSelectedOwner(e),
        btn: !0,
        "btn-xs": !0,
        "btn-check-skip-trace": !0,
        rounded: !0,
        "me-2": !0,
        "no-anim": !0
      };
    },
    setupAccordion() {
      var e, t;
      if (this.selectedKey) {
        const s = this.owners.findIndex((n) => n.key == this.selectedKey);
        s >= 0 && (this.selectedOwner = this.owners[s], (e = bootstrap.Collapse.getOrCreateInstance(`#collapse${s}`)) == null || e.show());
      } else this.owners.length > 0 && (this.selectedOwner = this.owners[0], (t = bootstrap.Collapse.getOrCreateInstance("#collapse0")) == null || t.show());
    }
  },
  mounted() {
    this.aclLoaded.then(async () => await this.propertyInitialized).then(async () => await this.getOwnerNames()).then(async () => await this.taxInfoInitialized).then(() => {
      var e, t, s, n;
      return this.showComponent = this.property.isCustom != !0 && (this.isAdmin || this.isUser || ((e = this.access) == null ? void 0 : e.client)) && this.access.isIdx != !0 && (((s = (t = this.access) == null ? void 0 : t.leads) == null ? void 0 : s.lite) == !0 || !((n = this.taxInfo) != null && n.investor));
    }).then(() => {
      this.showComponent && this.$nextTick(() => {
        this.setupAccordion();
      });
    }).then(async () => {
      var e;
      (e = this.taxInfo) != null && e.investor && (await this.ownerLoaded, await this.loadClientValues());
    }).finally(() => {
      this.loading = !1;
    }), Hr("P", (e) => {
      var t;
      this.showComponent = (this.isAdmin || this.isUser || ((t = this.access) == null ? void 0 : t.client)) && !this.showComponent;
    }, !0, !0, !0);
  }
}), D2t = { class: "card-header bg-white fw-bold d-flex justify-content-between align-items-center flex-column flex-lg-row gap-2" }, N2t = {
  key: 0,
  class: "badge text-bg-success"
}, j2t = { class: "locked" }, H2t = { class: "card-body p-0" }, U2t = { class: "row g-0" }, z2t = { class: "col-lg-8" }, W2t = { class: "p-2 d-flex flex-column gap-2 h-100" }, G2t = {
  class: "accordion gap-2 d-flex flex-column",
  id: "accordionExample",
  ref: "accordion"
}, Y2t = { class: "accordion-header d-flex align-items-center p-2" }, X2t = ["data-bs-target", "aria-controls", "onClick"], q2t = ["id"], Q2t = { class: "accordion-body p-2 pt-0" }, K2t = { class: "table table-sm table-borderless table-transparent mb-0" }, Z2t = {
  key: 0,
  rowspan: "2",
  class: "text-xsmall align-middle border-start text-center"
}, J2t = {
  key: 0,
  class: "fa-light fa-ban text-danger ms-2"
}, $2t = { class: "d-flex gap-2 justify-content-between mt-auto" }, _2t = {
  key: 0,
  type: "button",
  class: "btn btn-sm btn-outline-eclipse"
}, eCt = {
  key: 1,
  class: "flex-shrink-0 d-flex align-items-center"
}, tCt = ["disabled"], sCt = {
  key: 0,
  class: "fa-duotone fa-solid fa-spinner-third fa-spin me-2"
}, aCt = {
  key: 1,
  class: "fa-duotone fa-solid fa-search-location me-2"
}, nCt = { class: "col-lg-4 border-start-lg border-top border-top-lg-0" }, rCt = { class: "d-flex flex-row flex-lg-column g-2 flex-wrap" }, oCt = { class: "col-6 col-lg-12" }, iCt = { class: "p-2" }, lCt = { class: "col-6 col-lg-12" }, dCt = { class: "p-2" }, cCt = { class: "bg-light rounded p-2 text-center" }, uCt = { class: "text-success fw-bold fs-5" }, pCt = { class: "col-12 p-2 d-flex align-items-center" }, hCt = ["href"], mCt = {
  key: 1,
  class: "modal fade",
  ref: "dialogAddToCRM",
  id: "dialogAddToCRM",
  tabindex: "-1",
  "aria-labelledby": "dialogAddToCRMLabel",
  "aria-hidden": "true"
}, fCt = { class: "modal-dialog modal-dialog-centered" }, gCt = { class: "modal-content bg-gradient-alphabet rounded" }, vCt = { class: "modal-body" }, yCt = {
  class: "modal fade",
  id: "confirmSkipTraceModal",
  ref: "confirmSkipTraceModal",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}, bCt = {
  key: 0,
  class: "modal-dialog modal-dialog-centered"
}, ACt = { class: "modal-content bg-gradient-alphabet rounded" }, wCt = { class: "modal-body text-center px-5 pb-5 pt-4" }, CCt = { class: "d-flex gap-3 justify-content-center pt-3" }, SCt = {
  key: 1,
  class: "modal-dialog modal-lg modal-dialog-centered"
}, PCt = { class: "modal-body pb-0" }, kCt = { class: "bg-light bg-opacity-75 rounded d-flex justify-content-between w-100 mb-3" }, ECt = { class: "p-3 flex-fill text-center" }, ICt = { class: "border-start p-3 flex-fill d-flex align-items-center justify-content-center border-start-alphabet" }, TCt = {
  key: 0,
  class: "badge text-bg-accent text-uppercase ms-auto",
  title: "Indicating whether the person is on the TCPA litigators list"
}, OCt = { class: "d-flex justify-content-between gap-3" }, RCt = { class: "bg-light bg-opacity-75 rounded flex-fill overflow-hidden" }, LCt = {
  key: 0,
  class: "table table-sm table-borderless table-striped mb-0 table-skip-trace"
}, BCt = { class: "text-center align-middle" }, MCt = ["id", "value", "onClick"], xCt = ["for"], FCt = { class: "align-middle" }, VCt = ["for"], DCt = {
  key: 1,
  class: "d-flex flex-column justify-content-center align-items-center h-100 p-4"
}, NCt = { class: "bg-light bg-opacity-70 rounded flex-fill overflow-hidden" }, jCt = {
  key: 0,
  class: "table table-sm table-borderless table-striped mb-0 table-skip-trace"
}, HCt = { class: "text-center align-middle" }, UCt = ["id", "value", "onClick"], zCt = ["for"], WCt = { class: "align-end" }, GCt = ["for"], YCt = { class: "align-middle text-end" }, XCt = { class: "align-middle text-center" }, qCt = {
  key: 0,
  class: "fa-duotone fa-solid fa-check text-success"
}, QCt = { class: "align-middle text-center" }, KCt = {
  key: 0,
  class: "fa-duotone fa-solid fa-check text-success"
}, ZCt = { class: "align-middle text-end" }, JCt = { class: "align-middle text-center" }, $Ct = {
  key: 0,
  title: "Registered in Do Not Call registry.",
  class: "fa-regular fa-ban text-danger"
}, _Ct = {
  key: 1,
  class: "d-flex flex-column justify-content-center align-items-center h-100 p-4"
}, eSt = { class: "modal-footer bg-transparent border-0 flex-column gap-2" }, tSt = { class: "d-flex justify-content-between flex-row gap-3 w-100" }, sSt = { class: "bg-light bg-opacity-75 py-2 px-3 flex-fill rounded d-flex gap-3 align-items-center" }, aSt = {
  key: 0,
  class: "badge text-bg-secondary text-small"
}, nSt = {
  key: 1,
  class: "badge text-bg-secondary text-small"
}, rSt = {
  key: 2,
  class: "badge text-bg-secondary text-small"
}, oSt = {
  key: 3,
  class: "badge text-bg-secondary text-small"
}, iSt = {
  key: 0,
  class: "modal-footer bg-warning-subtle justify-content-center"
}, lSt = {
  key: 0,
  class: "text-center justify-content-center position-absolute top-0 h-100 w-100 d-flex align-items-center justify-content-center"
}, dSt = {
  key: 2,
  class: "modal-dialog modal-dialog-centered"
};
function cSt(e, t, s, n, r, i) {
  var l, d, c, u, m, f, v, b, w;
  const o = pe("lead-simple");
  return p(), h(A, null, [
    e.showComponent ? (p(), h("div", {
      key: 0,
      class: z(e.calculatingClasses)
    }, [
      a("div", D2t, [
        t[8] || (t[8] = a("span", null, [
          a("i", { class: "fa-light fa-id-card-clip me-2" }),
          y("Porfolio Finder Lite")
        ], -1)),
        e.skipTraceStats ? (p(), h("span", N2t, [
          t[7] || (t[7] = y(" Available Free Credits: ")),
          a("b", null, [
            ((l = e.skipTraceStats) == null ? void 0 : l.available) == ((d = e.skipTraceStats) == null ? void 0 : d.credits) ? (p(), h(A, { key: 0 }, [
              y(g((c = e.skipTraceStats) == null ? void 0 : c.credits), 1)
            ], 64)) : (p(), h(A, { key: 1 }, [
              y(g((u = e.skipTraceStats) == null ? void 0 : u.available) + "/" + g((m = e.skipTraceStats) == null ? void 0 : m.credits), 1)
            ], 64))
          ])
        ])) : P("", !0)
      ]),
      a("div", j2t, [
        a("div", {
          class: z(["card-content", { "card-extended": !e.canSkipTrace }])
        }, [
          a("div", H2t, [
            t[23] || (t[23] = a("div", { class: "calculating-animation position-absolute top-50 start-50 translate-middle text-center" }, [
              a("i", { class: "fa-duotone fa-solid fa-compass fa-spin fa-lg text-eclipse" })
            ], -1)),
            a("div", U2t, [
              a("div", z2t, [
                a("div", W2t, [
                  a("div", G2t, [
                    (p(!0), h(A, null, D(e.owners, (S, I) => (p(), h("div", {
                      class: "accordion-item bg-light rounded",
                      key: I
                    }, [
                      a("div", Y2t, [
                        a("button", {
                          for: "uno",
                          "data-bs-toggle": "collapse",
                          "data-bs-target": "#collapse" + I,
                          "aria-expanded": "true",
                          "aria-controls": "#collapse" + I,
                          onClick: (T) => e.selectOwner(S, I),
                          class: z(e.selectedOwnerStyle(S))
                        }, t[9] || (t[9] = [
                          a("i", { class: "fa fa-check" }, null, -1)
                        ]), 10, X2t),
                        a("label", null, [
                          a("b", null, "Owner " + g(I + 1) + ":", 1),
                          y(" " + g(e.getDisplayName(S)), 1)
                        ])
                      ]),
                      a("div", {
                        id: "collapse" + I,
                        class: "accordion-collapse collapse pt-0",
                        "data-bs-parent": "#accordionExample"
                      }, [
                        a("div", Q2t, [
                          a("table", K2t, [
                            a("tbody", null, [
                              a("tr", null, [
                                t[12] || (t[12] = a("th", null, "Email", -1)),
                                a("td", null, g(S.email), 1),
                                S.skipTraced ? (p(), h("td", Z2t, [
                                  t[10] || (t[10] = y("Traced")),
                                  t[11] || (t[11] = a("br", null, null, -1)),
                                  y(g(e.date(S.skipTraced)), 1)
                                ])) : P("", !0)
                              ]),
                              a("tr", null, [
                                t[13] || (t[13] = a("th", null, "Phone", -1)),
                                a("td", null, [
                                  y(g(S.phone) + " ", 1),
                                  S.dnc ? (p(), h("i", J2t)) : P("", !0)
                                ])
                              ])
                            ])
                          ])
                        ])
                      ], 8, q2t)
                    ]))), 128))
                  ], 512),
                  a("div", $2t, [
                    e.traced ? (p(), h("button", _2t, t[14] || (t[14] = [
                      a("i", { class: "fa-solid fa-search-location me-2" }, null, -1),
                      y("Skip Trace Selected")
                    ]))) : (p(), h("div", eCt, [
                      a("button", {
                        class: "btn btn-sm btn-outline-eclipse",
                        onClick: t[0] || (t[0] = (...S) => e.showConfirmSkipTraceModal && e.showConfirmSkipTraceModal(...S)),
                        disabled: !e.canSkipTrace || e.busy || !e.selectedOwner
                      }, [
                        e.busy ? (p(), h("i", sCt)) : (p(), h("i", aCt)),
                        t[15] || (t[15] = a("span", null, "Skip Trace", -1))
                      ], 8, tCt)
                    ])),
                    e.canAddCrm ? (p(), h("button", {
                      key: 2,
                      type: "button",
                      class: "btn btn-accent-glass btn-sm",
                      onClick: t[1] || (t[1] = (...S) => e.addToCRM && e.addToCRM(...S))
                    }, "Add to CRM")) : P("", !0)
                  ])
                ])
              ]),
              a("div", nCt, [
                a("div", rCt, [
                  t[22] || (t[22] = a("div", { class: "col-12 p-2 fw-bold" }, " Portfolio Info ", -1)),
                  a("div", oCt, [
                    a("div", iCt, [
                      a("div", null, [
                        t[16] || (t[16] = y("Properties: ")),
                        a("b", null, g(e.number(e.totalProperties)), 1)
                      ]),
                      a("div", null, [
                        t[17] || (t[17] = y("Names: ")),
                        a("b", null, g(e.number(e.totalNames)), 1)
                      ])
                    ])
                  ]),
                  a("div", lCt, [
                    a("div", dCt, [
                      a("div", cCt, [
                        t[18] || (t[18] = a("span", { class: "text-xsmall text-body-tertiary text-uppercase" }, "Client Lifetime Value", -1)),
                        t[19] || (t[19] = a("br", null, null, -1)),
                        a("span", uCt, g(e.currency(e.clientLifetimeValue)), 1)
                      ])
                    ])
                  ]),
                  a("div", pCt, [
                    (f = e.taxInfo) != null && f.investor ? (p(), h("a", {
                      key: 0,
                      href: "/portfolio-finder/" + e.taxInfo.ownerId,
                      class: "btn btn-sm btn-lava"
                    }, "View Owner's Portfolio", 8, hCt)) : (p(), h(A, { key: 1 }, [
                      t[20] || (t[20] = a("i", { class: "fa-duotone fa-circle-info me-2" }, null, -1)),
                      t[21] || (t[21] = y("Owner is not a known investor "))
                    ], 64))
                  ])
                ])
              ])
            ])
          ])
        ], 2)
      ])
    ], 2)) : P("", !0),
    e.canAddCrm ? (p(), h("div", mCt, [
      a("div", fCt, [
        a("div", gCt, [
          t[24] || (t[24] = a("div", { class: "modal-header border-0 pb-0" }, [
            a("p", {
              class: "modal-title fs-5 fw-bold",
              id: "dialogAddToCRMLabel"
            }, "Add to CRM"),
            a("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            })
          ], -1)),
          a("div", vCt, [
            N(o, {
              "prop-id": (v = e.property) == null ? void 0 : v.propId,
              "annual-revenue": e.clientLifetimeValue,
              "is-property": "",
              onCreated: e.closeCrmDialog
            }, null, 8, ["prop-id", "annual-revenue", "onCreated"])
          ])
        ])
      ])
    ], 512)) : P("", !0),
    a("div", yCt, [
      e.skipTraceConfirmed ? e.skipTracing || e.phoneNumbers.length > 0 || e.emails.length > 0 ? (p(), h("div", SCt, [
        a("div", {
          class: z(e.skipTracingStyles)
        }, [
          t[48] || (t[48] = a("div", { class: "modal-header justify-content-center flex-column border-0 bg-transparent pb-0" }, [
            a("div", { class: "fs-5 fw-bold" }, "Select Phone Number and Email")
          ], -1)),
          a("div", PCt, [
            a("div", kCt, [
              a("div", ECt, [
                t[32] || (t[32] = y(" Skip Traced Name: ")),
                a("b", null, g(e.getDisplayName(e.selectedOwner)), 1)
              ]),
              a("div", ICt, [
                a("span", null, [
                  t[33] || (t[33] = y("Name from Skip Trace: ")),
                  a("b", null, g(e.skipTraceName), 1)
                ]),
                e.skipTraceLitigator ? (p(), h("div", TCt, "Known Litigator")) : P("", !0)
              ])
            ]),
            a("div", OCt, [
              a("div", RCt, [
                e.emails.length > 0 ? (p(), h("table", LCt, [
                  t[35] || (t[35] = a("thead", null, [
                    a("tr", null, [
                      a("th"),
                      a("th", null, "Email Addresses")
                    ])
                  ], -1)),
                  a("tbody", null, [
                    (p(!0), h(A, null, D(e.emails, (S, I) => (p(), h("tr", {
                      key: S.email
                    }, [
                      a("td", BCt, [
                        V(a("input", {
                          type: "radio",
                          class: "btn-check",
                          id: "email" + I,
                          autocomplete: "off",
                          name: "emails",
                          value: S,
                          "onUpdate:modelValue": t[4] || (t[4] = (T) => e.emailSelected = T),
                          onClick: (T) => e.emailChanged(S)
                        }, null, 8, MCt), [
                          [Mt, e.emailSelected]
                        ]),
                        a("label", {
                          class: "btn btn-xs rounded",
                          for: "email" + I
                        }, t[34] || (t[34] = [
                          a("i", { class: "fa fa-check" }, null, -1)
                        ]), 8, xCt)
                      ]),
                      a("td", FCt, [
                        a("label", {
                          for: "email" + I
                        }, g(S.email), 9, VCt)
                      ])
                    ]))), 128))
                  ])
                ])) : (p(), h("div", DCt, t[36] || (t[36] = [
                  a("i", { class: "fa-duotone fa-solid fa-circle-exclamation mb-3 fa-2x" }, null, -1),
                  a("b", { class: "fs-5" }, "No data", -1),
                  a("p", { class: "mb-0" }, " Skip Trace couldn't find any emails. ", -1)
                ])))
              ]),
              a("div", NCt, [
                e.phoneNumbers.length > 0 ? (p(), h("table", jCt, [
                  t[38] || (t[38] = a("thead", null, [
                    a("tr", null, [
                      a("th"),
                      a("th", null, "Phone Numbers"),
                      a("th", {
                        class: "text-end",
                        title: "Last known date the phone number was associated with the property owner"
                      }, "Last Seen"),
                      a("th", {
                        class: "text-end",
                        title: "Indicating that a connection was made to the number for at least 6 seconds"
                      }, "Tested"),
                      a("th", {
                        class: "text-end",
                        title: "Indicating that the phone number was reached at least once in the last 3 months"
                      }, "Reachable"),
                      a("th", { class: "text-end" }, "Score"),
                      a("th", { class: "text-center" }, [
                        a("i", { class: "fa-duotone fa-solid fa-phone-volume" })
                      ])
                    ])
                  ], -1)),
                  a("tbody", null, [
                    (p(!0), h(A, null, D(e.phoneNumbers, (S, I) => (p(), h("tr", {
                      key: S.phone
                    }, [
                      a("td", HCt, [
                        V(a("input", {
                          type: "radio",
                          class: "btn-check",
                          id: "phone" + I,
                          autocomplete: "off",
                          name: "phones",
                          value: S,
                          "onUpdate:modelValue": t[5] || (t[5] = (T) => e.phoneSelected = T),
                          onClick: (T) => e.phoneChanged(S)
                        }, null, 8, UCt), [
                          [Mt, e.phoneSelected]
                        ]),
                        a("label", {
                          class: "btn btn-xs rounded",
                          for: "phone" + I
                        }, t[37] || (t[37] = [
                          a("i", { class: "fa fa-check" }, null, -1)
                        ]), 8, zCt)
                      ]),
                      a("td", WCt, [
                        a("label", {
                          for: "phone" + I
                        }, g(S.phone), 9, GCt)
                      ]),
                      a("td", YCt, g(e.date(S.lastSeen, !1)), 1),
                      a("td", XCt, [
                        S.tested ? (p(), h("i", qCt)) : P("", !0)
                      ]),
                      a("td", QCt, [
                        S.reachable ? (p(), h("i", KCt)) : P("", !0)
                      ]),
                      a("td", ZCt, g(e.percent(S.score / 100)), 1),
                      a("td", JCt, [
                        S.doNotCall ? (p(), h("i", $Ct)) : P("", !0)
                      ])
                    ]))), 128))
                  ])
                ])) : (p(), h("div", _Ct, t[39] || (t[39] = [
                  a("i", { class: "fa-duotone fa-solid fa-circle-exclamation mb-3 fa-2x" }, null, -1),
                  a("b", { class: "fs-5" }, "No data", -1),
                  a("p", { class: "mb-0" }, " Skip Trace couldn't find any phone numbers. ", -1)
                ])))
              ])
            ])
          ]),
          a("div", eSt, [
            t[45] || (t[45] = a("div", { class: "bg-light bg-opacity-75 w-100 py-2 px-3 text-end rounded" }, [
              a("div", { class: "form-check form-check-reverse form-switch" }, [
                a("input", {
                  class: "form-check-input",
                  type: "checkbox",
                  role: "switch",
                  id: "flexSwitchCheckDefault",
                  checked: ""
                }),
                a("label", {
                  class: "form-check-label",
                  for: "flexSwitchCheckDefault"
                }, "Update owner name from skip trace")
              ])
            ], -1)),
            a("div", tSt, [
              a("div", sSt, [
                t[44] || (t[44] = a("b", null, "Selected:", -1)),
                (b = e.emailSelected) != null && b.email ? (p(), h("span", aSt, [
                  t[40] || (t[40] = a("i", { class: "fa-duotone fa-solid fa-envelope me-2" }, null, -1)),
                  y(g(e.emailSelected.email), 1)
                ])) : (p(), h("span", nSt, t[41] || (t[41] = [
                  a("i", { class: "fa-duotone fa-solid fa-envelope me-2" }, null, -1),
                  y("None selected")
                ]))),
                (w = e.phoneSelected) != null && w.phone ? (p(), h("span", rSt, [
                  t[42] || (t[42] = a("i", { class: "fa-duotone fa-solid fa-phone me-2" }, null, -1)),
                  y(g(e.phoneSelected.phone), 1)
                ])) : (p(), h("span", oSt, t[43] || (t[43] = [
                  a("i", { class: "fa-duotone fa-solid fa-phone me-2" }, null, -1),
                  y("None selected")
                ])))
              ]),
              a("button", {
                type: "button",
                class: "btn btn-lava",
                onClick: t[6] || (t[6] = (...S) => e.updateContactSkip && e.updateContactSkip(...S))
              }, "Save")
            ])
          ]),
          N(ks, {
            name: "slide",
            mode: "out-in"
          }, {
            default: ve(() => [
              e.warnCrmDnc ? (p(), h("div", iSt, t[46] || (t[46] = [
                a("i", { class: "fa-duotone fa-solid fa-info-circle me-2" }, null, -1),
                y("The selected phone number is on DNC and will not be sent to your CRM. You can update this in settings. ")
              ]))) : P("", !0)
            ]),
            _: 1
          }),
          e.skipTracing ? (p(), h("div", lSt, t[47] || (t[47] = [
            a("i", { class: "fa-duotone fa-solid fa-spinner-third fa-spin me-2" }, null, -1),
            y("Skip Tracing Contact... ")
          ]))) : P("", !0)
        ], 2)
      ])) : (p(), h("div", dSt, t[49] || (t[49] = [
        Bt('<div class="modal-content bg-gradient-alphabet rounded"><div class="modal-header border-0 mb-0 bg-transparent"><button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button></div><div class="modal-body text-center px-5 pb-5 pt-4"><i class="fa-duotone fa-solid fa-circle-exclamation mb-3 fa-2x"></i><br><b class="fs-5">No data</b><br><br><p><b>Skip trace found no results.</b><br> If there are multiple recorded owner names, try one of the other names.<br><br> (Company names usually will not find results.) </p><div class="d-flex gap-3 justify-content-center pt-3"><button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button></div></div></div>', 1)
      ]))) : (p(), h("div", bCt, [
        a("div", ACt, [
          t[31] || (t[31] = a("div", { class: "modal-header border-0 mb-0 bg-transparent" }, [
            a("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            })
          ], -1)),
          a("div", wCt, [
            t[25] || (t[25] = a("i", { class: "fa-duotone fa-search-location mb-3 fa-2x" }, null, -1)),
            t[26] || (t[26] = a("br", null, null, -1)),
            t[27] || (t[27] = a("b", { class: "fs-5" }, "Skip Trace Fee Acknowledgement", -1)),
            t[28] || (t[28] = a("br", null, null, -1)),
            t[29] || (t[29] = a("br", null, null, -1)),
            t[30] || (t[30] = a("p", null, " By initiating a skip trace, you acknowledge you'll be charged a flat fee of 8 cents if any phone numbers or email addresses are found. If no results are found, you won't be charged. ", -1)),
            a("div", CCt, [
              a("button", {
                type: "button",
                class: "btn btn-secondary",
                onClick: t[2] || (t[2] = (...S) => e.hideConfirmSkipTraceModal && e.hideConfirmSkipTraceModal(...S))
              }, "Cancel"),
              a("button", {
                type: "button",
                class: "btn btn-lava",
                onClick: t[3] || (t[3] = (...S) => e.skipTraceProp && e.skipTraceProp(...S))
              }, " Confirm ")
            ])
          ])
        ])
      ]))
    ], 512)
  ], 64);
}
const uSt = /* @__PURE__ */ Ae(V2t, [["render", cSt]]), pSt = me({
  name: "SkipTraceDialog",
  props: {
    message: String
  },
  data() {
    return {
      skipTraceConfirmed: Go("skip-trace-confirmed-v2") == "true",
      skipTracing: !1,
      emails: [],
      emailSelected: void 0,
      phoneNumbers: [],
      phoneSelected: void 0,
      currentContact: void 0,
      updateOwnerName: !0,
      honorDncStatus: !0
    };
  },
  emits: {
    traceComplete: (e) => !0,
    cancelled: () => !0
  },
  computed: {
    skipTracingStyles() {
      return {
        "skip-tracing": this.skipTracing,
        "modal-content": !0,
        "bg-gradient-alphabet": !0
      };
    },
    skipTraceName() {
      if (this.emails.length > 0)
        return `${this.emails[0].firstName} ${this.emails[0].lastName}`;
      if (this.phoneNumbers.length > 0)
        return `${this.phoneNumbers[0].firstName} ${this.phoneNumbers[0].lastName}`;
    },
    skipTraceLitigator() {
      return this.emails.some((e) => e.litigator) || this.phoneNumbers.some((e) => e.litigator);
    },
    warnCrmDnc() {
      var e;
      return this.honorDncStatus == !1 && ((e = this.phoneSelected) == null ? void 0 : e.doNotCall) == !0;
    },
    ...q(Te, ["access", "aclLoaded"]),
    ...q(Ba, ["owner", "skipTraceStats"])
  },
  methods: {
    number: Ve,
    percent: Wt,
    date: cs,
    async showConfirmSkipTraceModal(e) {
      var t;
      this.currentContact = e, (t = bootstrap.Modal.getOrCreateInstance(this.$refs.confirmSkipTraceModal)) == null || t.show(), this.updateOwnerName = !1, this.skipTraceConfirmed && this.skipTraceContact();
    },
    async hideConfirmSkipTraceModal() {
      var e;
      this.currentContact = void 0, (e = bootstrap.Modal.getOrCreateInstance(this.$refs.confirmSkipTraceModal)) == null || e.hide(), this.$emit("cancelled");
    },
    async skipTraceContact() {
      try {
        eo("skip-trace-confirmed-v2", !0), this.skipTraceConfirmed = !0, this.skipTracing = !0, this.emails.length = 0, this.phoneNumbers.length = 0, this.emailSelected = void 0, this.phoneSelected = void 0;
        const e = this.currentContact;
        let t = !0;
        e.id && (t = !1);
        const s = await W.api.portfolioFinder.skipTraceContact(this.owner.id, e.id ?? e.priority, t);
        if (s.data.status != de.Success)
          throw new Le(s);
        this.emails.push(...s.data.emails), this.phoneNumbers.push(...s.data.phoneNumbers), this.emails.length > 0 && (this.emailSelected = this.emails[0]), this.phoneNumbers.length > 0 && (this.phoneSelected = this.phoneNumbers[0]), this.honorDncStatus = s.data.honorDncStatus, e.id = s.data.contact.id, e.skipTracedOn = s.data.contact.skipTracedOn, this.updateOwnerName = this.skipTraceName != this.getDisplayName(this.currentContact), this.skipTraceStats && s.data.skipTrace && (this.skipTraceStats.credits = s.data.skipTrace.credits, this.skipTraceStats.creditsConsumed = s.data.skipTrace.creditsConsumed, this.skipTraceStats.available = s.data.skipTrace.available);
      } catch (e) {
        Se(e);
      }
      this.skipTracing = !1;
    },
    async updateContactSkip() {
      var e;
      this.currentContact.litigator = this.skipTraceLitigator, this.phoneSelected ? (this.currentContact.phone = this.phoneSelected.phone, this.currentContact.phoneDNC = this.phoneSelected.doNotCall) : (this.currentContact.phone = "", this.currentContact.phoneDNC = !1), this.emailSelected ? this.currentContact.email = this.emailSelected.email : this.currentContact.email = "", this.updateOwnerName && (this.emails.length > 0 && (this.currentContact.firstName = this.emails[0].firstName, this.currentContact.lastName = this.emails[0].lastName), this.phoneNumbers.length > 0 && (this.currentContact.firstName = this.phoneNumbers[0].firstName, this.currentContact.lastName = this.phoneNumbers[0].lastName)), this.$emit("traceComplete", this.currentContact), (e = bootstrap.Modal.getOrCreateInstance(this.$refs.confirmSkipTraceModal)) == null || e.hide();
    },
    getDisplayName(e) {
      return e != null && e.firstName && (e != null && e.lastName) ? `${e.firstName} ${e.lastName}` : (
        /*contact?.companyName ?? */
        (e == null ? void 0 : e.firstName) ?? (e == null ? void 0 : e.lastName) ?? "Unknown"
      );
    },
    emailChanged(e) {
      var t;
      ((t = this.emailSelected) == null ? void 0 : t.email) == e.email && (this.emailSelected = void 0);
    },
    phoneChanged(e) {
      var t;
      ((t = this.phoneSelected) == null ? void 0 : t.phone) == e.phone && (this.phoneSelected = void 0);
    }
  },
  mounted() {
    this.aclLoaded.then(() => {
    });
  }
}), hSt = {
  class: "modal fade",
  id: "confirmSkipTraceModal",
  ref: "confirmSkipTraceModal",
  "data-bs-backdrop": "static",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}, mSt = {
  key: 0,
  class: "modal-dialog modal-dialog-centered"
}, fSt = { class: "modal-content bg-gradient-alphabet rounded" }, gSt = { class: "modal-header border-0 mb-0 bg-transparent" }, vSt = { class: "modal-body text-center px-5 pb-5 pt-4" }, ySt = { class: "d-flex gap-3 justify-content-center pt-3" }, bSt = {
  key: 1,
  class: "modal-dialog modal-lg modal-dialog-centered"
}, ASt = { class: "modal-header justify-content-center flex-column border-0 bg-transparent pb-0" }, wSt = { class: "fs-5 fw-bold" }, CSt = { class: "modal-body pb-0" }, SSt = { class: "bg-light bg-opacity-75 rounded d-flex justify-content-between w-100 mb-3" }, PSt = { class: "p-3 flex-fill text-center" }, kSt = { class: "border-start p-3 flex-fill d-flex align-items-center justify-content-center border-start-alphabet" }, ESt = {
  key: 0,
  class: "badge text-bg-accent text-uppercase ms-auto",
  title: "Indicating whether the person is on the TCPA litigators list"
}, ISt = { class: "d-flex justify-content-between gap-3" }, TSt = { class: "bg-light bg-opacity-75 rounded flex-fill overflow-hidden" }, OSt = {
  key: 0,
  class: "table table-sm table-borderless table-striped mb-0 table-skip-trace"
}, RSt = { class: "text-center align-middle" }, LSt = ["id", "value", "onClick"], BSt = ["for"], MSt = { class: "align-middle" }, xSt = ["for"], FSt = {
  key: 1,
  class: "d-flex flex-column justify-content-center align-items-center h-100 p-4"
}, VSt = { class: "bg-light bg-opacity-70 rounded flex-fill overflow-hidden" }, DSt = {
  key: 0,
  class: "table table-sm table-borderless table-striped mb-0 table-skip-trace"
}, NSt = { class: "text-center align-middle" }, jSt = ["id", "value", "onClick"], HSt = ["for"], USt = { class: "align-end" }, zSt = ["for"], WSt = { class: "align-middle text-end" }, GSt = { class: "align-middle text-center" }, YSt = {
  key: 0,
  class: "fa-duotone fa-solid fa-check text-success"
}, XSt = { class: "align-middle text-center" }, qSt = {
  key: 0,
  class: "fa-duotone fa-solid fa-check text-success"
}, QSt = { class: "align-middle text-end" }, KSt = { class: "align-middle text-center" }, ZSt = {
  key: 0,
  title: "Registered in Do Not Call registry.",
  class: "fa-regular fa-ban text-danger"
}, JSt = {
  key: 1,
  class: "d-flex flex-column justify-content-center align-items-center h-100 p-4"
}, $St = { class: "modal-footer bg-transparent border-0 justify-content-between" }, _St = {
  key: 0,
  class: "bg-light bg-opacity-75 w-100 py-2 px-3 text-end rounded"
}, ePt = { class: "form-check form-check-reverse form-switch" }, tPt = { class: "bg-light bg-opacity-75 py-2 px-3 flex-fill rounded d-flex gap-3 align-items-center" }, sPt = {
  key: 0,
  class: "badge text-bg-secondary text-small"
}, aPt = {
  key: 1,
  class: "badge text-bg-secondary text-small"
}, nPt = {
  key: 2,
  class: "badge text-bg-secondary text-small"
}, rPt = {
  key: 3,
  class: "badge text-bg-secondary text-small"
}, oPt = {
  key: 0,
  class: "modal-footer bg-warning-subtle justify-content-center"
}, iPt = {
  key: 0,
  class: "text-center justify-content-center position-absolute top-0 h-100 w-100 d-flex align-items-center justify-content-center"
}, lPt = {
  key: 2,
  class: "modal-dialog modal-dialog-centered"
};
function dPt(e, t, s, n, r, i) {
  var o, l;
  return p(), h("div", hSt, [
    e.skipTraceConfirmed ? e.skipTracing || e.phoneNumbers.length > 0 || e.emails.length > 0 ? (p(), h("div", bSt, [
      a("div", {
        class: z(e.skipTracingStyles)
      }, [
        a("div", ASt, [
          a("div", wSt, [
            t[14] || (t[14] = y(" Select Phone Number and Email ")),
            a("button", {
              type: "button",
              class: "btn-close",
              onClick: t[3] || (t[3] = (...d) => e.hideConfirmSkipTraceModal && e.hideConfirmSkipTraceModal(...d)),
              "aria-label": "Close"
            })
          ])
        ]),
        a("div", CSt, [
          a("div", SSt, [
            a("div", PSt, [
              t[15] || (t[15] = y(" Skip Traced Name: ")),
              a("b", null, g(e.getDisplayName(e.currentContact)), 1)
            ]),
            a("div", kSt, [
              a("span", null, [
                t[16] || (t[16] = y("Name from Skip Trace: ")),
                a("b", null, g(e.skipTraceName), 1)
              ]),
              e.skipTraceLitigator ? (p(), h("div", ESt, "Known Litigator")) : P("", !0)
            ])
          ]),
          a("div", ISt, [
            a("div", TSt, [
              e.emails.length > 0 ? (p(), h("table", OSt, [
                t[18] || (t[18] = a("thead", null, [
                  a("tr", null, [
                    a("th"),
                    a("th", null, "Email Addresses")
                  ])
                ], -1)),
                a("tbody", null, [
                  (p(!0), h(A, null, D(e.emails, (d, c) => (p(), h("tr", {
                    key: d.email
                  }, [
                    a("td", RSt, [
                      V(a("input", {
                        type: "radio",
                        class: "btn-check",
                        id: "email" + c,
                        autocomplete: "off",
                        name: "emails",
                        value: d,
                        "onUpdate:modelValue": t[4] || (t[4] = (u) => e.emailSelected = u),
                        onClick: (u) => e.emailChanged(d)
                      }, null, 8, LSt), [
                        [Mt, e.emailSelected]
                      ]),
                      a("label", {
                        class: "btn btn-xs rounded",
                        for: "email" + c
                      }, t[17] || (t[17] = [
                        a("i", { class: "fa fa-check" }, null, -1)
                      ]), 8, BSt)
                    ]),
                    a("td", MSt, [
                      a("label", {
                        for: "email" + c
                      }, g(d.email), 9, xSt)
                    ])
                  ]))), 128))
                ])
              ])) : (p(), h("div", FSt, t[19] || (t[19] = [
                a("i", { class: "fa-duotone fa-solid fa-circle-exclamation mb-3 fa-2x" }, null, -1),
                a("b", { class: "fs-5" }, "No data", -1),
                a("p", { class: "mb-0" }, " Skip Trace couldn't find any emails. ", -1)
              ])))
            ]),
            a("div", VSt, [
              e.phoneNumbers.length > 0 ? (p(), h("table", DSt, [
                t[21] || (t[21] = a("thead", null, [
                  a("tr", null, [
                    a("th"),
                    a("th", null, "Phone Numbers"),
                    a("th", {
                      class: "text-end",
                      title: "Last known date the phone number was associated with the property owner"
                    }, "Last Seen"),
                    a("th", {
                      class: "text-end",
                      title: "Indicating that a connection was made to the number for at least 6 seconds"
                    }, "Tested"),
                    a("th", {
                      class: "text-end",
                      title: "Indicating that the phone number was reached at least once in the last 3 months"
                    }, "Reachable"),
                    a("th", { class: "text-end" }, "Score"),
                    a("th", { class: "text-center" }, [
                      a("i", { class: "fa-duotone fa-solid fa-phone-volume" })
                    ])
                  ])
                ], -1)),
                a("tbody", null, [
                  (p(!0), h(A, null, D(e.phoneNumbers, (d, c) => (p(), h("tr", {
                    key: d.phone
                  }, [
                    a("td", NSt, [
                      V(a("input", {
                        type: "radio",
                        class: "btn-check",
                        id: "phone" + c,
                        autocomplete: "off",
                        name: "phones",
                        value: d,
                        "onUpdate:modelValue": t[5] || (t[5] = (u) => e.phoneSelected = u),
                        onClick: (u) => e.phoneChanged(d)
                      }, null, 8, jSt), [
                        [Mt, e.phoneSelected]
                      ]),
                      a("label", {
                        class: "btn btn-xs rounded",
                        for: "phone" + c
                      }, t[20] || (t[20] = [
                        a("i", { class: "fa fa-check" }, null, -1)
                      ]), 8, HSt)
                    ]),
                    a("td", USt, [
                      a("label", {
                        for: "phone" + c
                      }, g(d.phone), 9, zSt)
                    ]),
                    a("td", WSt, g(e.date(d.lastSeen, !1)), 1),
                    a("td", GSt, [
                      d.tested ? (p(), h("i", YSt)) : P("", !0)
                    ]),
                    a("td", XSt, [
                      d.reachable ? (p(), h("i", qSt)) : P("", !0)
                    ]),
                    a("td", QSt, g(e.percent(d.score / 100)), 1),
                    a("td", KSt, [
                      d.doNotCall ? (p(), h("i", ZSt)) : P("", !0)
                    ])
                  ]))), 128))
                ])
              ])) : (p(), h("div", JSt, t[22] || (t[22] = [
                a("i", { class: "fa-duotone fa-solid fa-circle-exclamation mb-3 fa-2x" }, null, -1),
                a("b", { class: "fs-5" }, "No data", -1),
                a("p", { class: "mb-0" }, " Skip Trace couldn't find any phone numbers. ", -1)
              ])))
            ])
          ])
        ]),
        a("div", $St, [
          e.skipTraceName != e.getDisplayName(e.currentContact) ? (p(), h("div", _St, [
            a("div", ePt, [
              V(a("input", {
                class: "form-check-input",
                type: "checkbox",
                role: "switch",
                id: "flexSwitchCheckDefault",
                "onUpdate:modelValue": t[6] || (t[6] = (d) => e.updateOwnerName = d)
              }, null, 512), [
                [Ue, e.updateOwnerName]
              ]),
              t[23] || (t[23] = a("label", {
                class: "form-check-label",
                for: "flexSwitchCheckDefault"
              }, "Update owner name from skip trace", -1))
            ])
          ])) : P("", !0),
          a("div", tPt, [
            t[28] || (t[28] = a("b", null, "Selected:", -1)),
            (o = e.emailSelected) != null && o.email ? (p(), h("span", sPt, [
              t[24] || (t[24] = a("i", { class: "fa-duotone fa-solid fa-envelope me-2" }, null, -1)),
              y(g(e.emailSelected.email), 1)
            ])) : (p(), h("span", aPt, t[25] || (t[25] = [
              a("i", { class: "fa-duotone fa-solid fa-envelope me-2" }, null, -1),
              y("None selected")
            ]))),
            (l = e.phoneSelected) != null && l.phone ? (p(), h("span", nPt, [
              t[26] || (t[26] = a("i", { class: "fa-duotone fa-solid fa-phone me-2" }, null, -1)),
              y(g(e.phoneSelected.phone), 1)
            ])) : (p(), h("span", rPt, t[27] || (t[27] = [
              a("i", { class: "fa-duotone fa-solid fa-phone me-2" }, null, -1),
              y("None selected")
            ])))
          ]),
          a("button", {
            type: "button",
            class: "btn btn-lava",
            onClick: t[7] || (t[7] = (...d) => e.updateContactSkip && e.updateContactSkip(...d))
          }, "Save")
        ]),
        N(ks, {
          name: "slide",
          mode: "out-in"
        }, {
          default: ve(() => [
            e.warnCrmDnc ? (p(), h("div", oPt, t[29] || (t[29] = [
              a("i", { class: "fa-duotone fa-solid fa-info-circle me-2" }, null, -1),
              y("The selected phone number is on DNC and will not be sent to your CRM. You can update this in settings. ")
            ]))) : P("", !0)
          ]),
          _: 1
        }),
        e.skipTracing ? (p(), h("div", iPt, t[30] || (t[30] = [
          a("i", { class: "fa-duotone fa-solid fa-spinner-third fa-spin me-2" }, null, -1),
          y("Skip Tracing Contact... ")
        ]))) : P("", !0)
      ], 2)
    ])) : (p(), h("div", lPt, t[31] || (t[31] = [
      Bt('<div class="modal-content bg-gradient-alphabet rounded"><div class="modal-header border-0 mb-0 bg-transparent"><button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button></div><div class="modal-body text-center px-5 pb-5 pt-4"><i class="fa-duotone fa-solid fa-circle-exclamation mb-3 fa-2x"></i><br><b class="fs-5">No data</b><br><br><p><b>Skip trace found no results.</b><br> If there are multiple recorded owner names, try one of the other names.<br><br> (Company names usually will not find results.) </p><div class="d-flex gap-3 justify-content-center pt-3"><button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button></div></div></div>', 1)
    ]))) : (p(), h("div", mSt, [
      a("div", fSt, [
        a("div", gSt, [
          a("button", {
            type: "button",
            class: "btn-close",
            onClick: t[0] || (t[0] = (...d) => e.hideConfirmSkipTraceModal && e.hideConfirmSkipTraceModal(...d)),
            "aria-label": "Close"
          })
        ]),
        a("div", vSt, [
          t[8] || (t[8] = a("i", { class: "fa-duotone fa-search-location mb-3 fa-2x" }, null, -1)),
          t[9] || (t[9] = a("br", null, null, -1)),
          t[10] || (t[10] = a("b", { class: "fs-5" }, "Skip Trace Fee Acknowledgement", -1)),
          t[11] || (t[11] = a("br", null, null, -1)),
          t[12] || (t[12] = a("br", null, null, -1)),
          t[13] || (t[13] = a("p", null, " By initiating a skip trace, you acknowledge you'll be charged a flat fee of 8 cents if any phone numbers or email addresses are found. If no results are found, you won't be charged. ", -1)),
          a("div", ySt, [
            a("button", {
              type: "button",
              class: "btn btn-secondary",
              onClick: t[1] || (t[1] = (...d) => e.hideConfirmSkipTraceModal && e.hideConfirmSkipTraceModal(...d))
            }, "Cancel"),
            a("button", {
              type: "button",
              class: "btn btn-lava",
              onClick: t[2] || (t[2] = (...d) => e.skipTraceContact && e.skipTraceContact(...d))
            }, " Confirm ")
          ])
        ])
      ])
    ]))
  ], 512);
}
const cPt = /* @__PURE__ */ Ae(pSt, [["render", dPt]]), uPt = me({
  name: "ContactCard",
  props: {},
  components: {
    SkipTraceDialog: cPt
  },
  data() {
    return {
      skipTracing: !1,
      currentContact: void 0,
      editingContact: !1
    };
  },
  computed: {
    firstContact() {
      if (this.leadContacts.length > 0)
        return this.leadContacts[0];
    },
    ...at(Ba),
    ...q(Ba, ["ownerParties", "loadingOwnerNames", "owner", "leadContacts", "ownerLoaded", "traceHistory", "skipTraceStats"]),
    ...q(Te, ["access", "aclLoaded"])
  },
  watch: {
    owner() {
      this.portfolioFinderStore.refreshOwnerContacts();
    }
  },
  methods: {
    number: Ve,
    percent: Wt,
    date: cs,
    showPhone(e, t) {
      if ((!e.phone || e.phone == "") && (!e.cell || e.cell == ""))
        switch (t) {
          case 1:
            return !0;
          default:
            return !1;
        }
      switch (t) {
        case 1:
          return !(!e.phone || e.phone == "");
        case 2:
          return !(!e.cell || e.cell == "");
        default:
          return !1;
      }
    },
    crmButtonStyles(e) {
      return {
        "btn-warning": e.crmId,
        "btn-success": !e.crmId
      };
    },
    editContact(e, t) {
      var n;
      this.currentContact = void 0;
      const s = this.leadContacts.find(function(r) {
        return e > 0 ? r.id == e : r.priority == t;
      });
      this.currentContact = s, (n = bootstrap.Modal.getOrCreateInstance(this.$refs.modalEditContact)) == null || n.show();
    },
    async saveContactEdit(e = void 0) {
      var t;
      try {
        this.isBusy = !0;
        const s = await W.api.portfolioFinder.updateContact(this.owner.id, this.firstContact);
        if (s.data.status != de.Success)
          throw new Error(s.data.message);
        this.firstContact.id = s.data.contact.id, this.firstContact.firstName = s.data.contact.firstName, this.firstContact.lastName = s.data.contact.lastName, this.firstContact.phone = s.data.contact.phone, this.firstContact.phoneDNC = s.data.contact.phoneDNC, this.firstContact.cell = s.data.contact.cell, this.firstContact.cellDNC = s.data.contact.cellDNC, this.firstContact.email = s.data.contact.email, this.firstContact.litigator = s.data.contact.litigator, this.firstContact.skipTracedOn = s.data.contact.skipTracedOn, this.firstContact.resetContact = void 0;
      } catch (s) {
        Se(s);
      }
      (t = bootstrap.Modal.getOrCreateInstance(this.$refs.modalEditContact)) == null || t.hide(), this.editingContact = !1, this.currentContact = void 0, this.isBusy = !1;
    },
    setName(e) {
      e.companyName ? (this.currentContact.resetContact = this.currentContact.lastName != e.companyName, this.currentContact.firstName = e.first, this.currentContact.lastName = e.companyName) : (this.currentContact.resetContact = this.currentContact.firstName != e.first || this.currentContact.lastName != e.last, this.currentContact.firstName = e.first, this.currentContact.lastName = e.last);
    },
    contactNameChanged() {
      this.currentContact.resetContact = !0;
    },
    async showConfirmSkipTraceModal(e) {
      this.currentContact = e, this.skipTracing = !0, this.$refs.skipTrace.showConfirmSkipTraceModal(e);
    },
    async createInCrm(e) {
      this.isBusy = !0;
      let t = !0;
      e.id && (t = !1), this.$emit("createContact", e.id ?? e.priority, t, this.updateContact);
    },
    async updateContact(e) {
      try {
        const t = this.leadContacts.find(function(s) {
          return s.id && s.id == e.id || s.priority == e.priority;
        });
        t.id = e.id, t.crmId = e.crmId, t.phone = e.phone, t.phoneDNC = e.phoneDNC, t.cell = e.cell, t.cellDNC = e.cellDNC, t.email = e.email;
      } catch (t) {
        let s = new Cs("Update Contact Error", t.message);
        s.stay = !0, Ss(s);
      }
      this.isBusy = !1;
    }
  },
  mounted() {
    this.ownerLoaded.then(async () => await this.portfolioFinderStore.refreshOwnerContacts());
  }
}), pPt = { class: "info-contacts" }, hPt = {
  key: 0,
  class: "d-flex flex-column flex-lg-row justify-content-between info-contacts_contact bg-light rounded border overflow-hidden"
}, mPt = { class: "table m-0 table-borderless small table-transparent" }, fPt = { class: "border-bottom" }, gPt = { class: "d-flex align-items-center" }, vPt = ["disabled"], yPt = {
  key: 0,
  class: "badge text-bg-accent ms-auto",
  title: "Indicating whether the person is on the TCPA litigators list"
}, bPt = {
  key: 1,
  class: "input-group"
}, APt = { key: 0 }, wPt = {
  key: 0,
  title: "Registered in Do Not Call registry.",
  class: "fa-regular fa-ban text-danger ms-2"
}, CPt = { key: 1 }, SPt = {
  key: 0,
  class: "fa-regular fa-ban text-danger"
}, PPt = { class: "flex-shrink-0 ms-0 d-flex flex-row flex-xl-column align-items-center justify-content-center border-start-lg border-top p-2 gap-2 border-top-lg-0" }, kPt = { class: "d-flex flex-row gap-2 flex-shrink-0" }, EPt = ["disabled"], IPt = ["disabled"], TPt = {
  key: 0,
  class: "alert alert-success mb-0 text-xsmall p-2 text-center w-100"
}, OPt = {
  class: "modal fade",
  ref: "modalEditContact",
  id: "modalEditContact",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}, RPt = { class: "modal-dialog modal-dialog-centered" }, LPt = { class: "modal-content bg-gradient-alphabet rounded" }, BPt = { class: "modal-body" }, MPt = { class: "row" }, xPt = { class: "col" }, FPt = { class: "mb-3" }, VPt = { class: "mb-3" }, DPt = { class: "col" }, NPt = { class: "list-unstyled m-0 reduced-list" }, jPt = ["onClick"], HPt = { class: "modal-footer border-0 pt-0" };
function UPt(e, t, s, n, r, i) {
  var l, d, c, u, m;
  const o = pe("skip-trace-dialog");
  return p(), h(A, null, [
    t[24] || (t[24] = a("div", { class: "fs-6 fw-bold mb-0 text-secondary text-xsmall mb-2" }, " SELECTED CONTACT ", -1)),
    a("div", pPt, [
      e.firstContact ? (p(), h("div", hPt, [
        a("table", mPt, [
          a("tbody", null, [
            a("tr", fPt, [
              t[13] || (t[13] = a("th", {
                width: "60",
                class: "align-middle"
              }, "Name:", -1)),
              a("td", gPt, [
                !e.editingContact || !e.firstContact ? (p(), h(A, { key: 0 }, [
                  a("span", null, g(e.firstContact.firstName) + " " + g(e.firstContact.lastName), 1),
                  a("button", {
                    type: "button",
                    onClick: t[0] || (t[0] = (f) => e.editingContact = !0),
                    class: "btn btn-sm btn-link text-eclipse",
                    disabled: e.isBusy || !e.firstContact
                  }, t[12] || (t[12] = [
                    a("i", { class: "fa-light fa-user-edit ms-2" }, null, -1)
                  ]), 8, vPt),
                  e.firstContact.litigator ? (p(), h("span", yPt, "Known Litigator")) : P("", !0)
                ], 64)) : (p(), h("div", bPt, [
                  V(a("input", {
                    type: "text",
                    class: "form-control form-control-sm",
                    placeholder: "First name",
                    "onUpdate:modelValue": t[1] || (t[1] = (f) => e.firstContact.firstName = f)
                  }, null, 512), [
                    [_e, e.firstContact.firstName]
                  ]),
                  V(a("input", {
                    type: "text",
                    class: "form-control form-control-sm",
                    placeholder: "Last name",
                    "onUpdate:modelValue": t[2] || (t[2] = (f) => e.firstContact.lastName = f)
                  }, null, 512), [
                    [_e, e.firstContact.lastName]
                  ]),
                  a("button", {
                    type: "button",
                    class: "btn btn-sm btn-lava",
                    onClick: t[3] || (t[3] = (...f) => e.saveContactEdit && e.saveContactEdit(...f))
                  }, "Save")
                ]))
              ])
            ]),
            a("tr", null, [
              t[14] || (t[14] = a("th", { width: "60" }, "Email:", -1)),
              a("td", null, [
                e.firstContact.skipTracedOn && !e.firstContact.email ? (p(), h(A, { key: 0 }, [
                  y(" No Trace Found ")
                ], 64)) : (p(), h(A, { key: 1 }, [
                  y(g(e.firstContact.email), 1)
                ], 64))
              ])
            ]),
            e.showPhone(e.firstContact, 1) ? (p(), h("tr", APt, [
              t[15] || (t[15] = a("th", { width: "60" }, "Phone:", -1)),
              a("td", null, [
                e.firstContact.skipTracedOn && !e.firstContact.phone ? (p(), h(A, { key: 0 }, [
                  y(" No Trace Found ")
                ], 64)) : (p(), h(A, { key: 1 }, [
                  y(g(e.firstContact.phone) + " ", 1),
                  e.firstContact.phoneDNC ? (p(), h("i", wPt)) : P("", !0)
                ], 64))
              ])
            ])) : P("", !0),
            e.showPhone(e.firstContact, 2) ? (p(), h("tr", CPt, [
              t[16] || (t[16] = a("th", { width: "80" }, "Phone:", -1)),
              a("td", null, [
                y(g(e.firstContact.cell) + " ", 1),
                e.firstContact.cellDNC ? (p(), h("i", SPt)) : P("", !0)
              ])
            ])) : P("", !0)
          ])
        ]),
        a("div", PPt, [
          a("div", kPt, [
            a("button", {
              type: "button",
              onClick: t[4] || (t[4] = (f) => e.showConfirmSkipTraceModal(e.firstContact)),
              disabled: e.skipTracing,
              class: "btn btn-outline-eclipse btn-sm text-small"
            }, " Skip Trace ", 8, EPt),
            e.manageContact ? (p(), h("button", {
              key: 0,
              type: "button",
              onClick: t[5] || (t[5] = (f) => e.createInCrm(e.firstContact)),
              class: z(["btn btn-success btn-sm text-small", e.crmButtonStyles(e.firstContact)]),
              disabled: e.skipTracing
            }, [
              e.firstContact.crmId ? (p(), h(A, { key: 0 }, [
                y(" Update CRM ")
              ], 64)) : (p(), h(A, { key: 1 }, [
                y(" Create in CRM ")
              ], 64))
            ], 10, IPt)) : P("", !0)
          ]),
          e.skipTraceStats ? (p(), h("div", TPt, [
            t[17] || (t[17] = y(" Available Free ")),
            t[18] || (t[18] = a("br", { class: "d-none d-lg-inline-block" }, null, -1)),
            t[19] || (t[19] = y(" Credits ")),
            a("b", null, [
              ((l = e.skipTraceStats) == null ? void 0 : l.available) == ((d = e.skipTraceStats) == null ? void 0 : d.credits) ? (p(), h(A, { key: 0 }, [
                y(g((c = e.skipTraceStats) == null ? void 0 : c.credits), 1)
              ], 64)) : (p(), h(A, { key: 1 }, [
                y(g((u = e.skipTraceStats) == null ? void 0 : u.available) + "/" + g((m = e.skipTraceStats) == null ? void 0 : m.credits), 1)
              ], 64))
            ])
          ])) : P("", !0)
        ])
      ])) : P("", !0)
    ]),
    a("div", OPt, [
      a("div", RPt, [
        a("div", LPt, [
          t[23] || (t[23] = a("div", { class: "modal-header border-0 pb-0" }, [
            a("p", { class: "fs-5 modal-title" }, "Edit Contact:")
          ], -1)),
          a("div", BPt, [
            a("div", MPt, [
              a("div", xPt, [
                a("div", FPt, [
                  t[20] || (t[20] = a("label", {
                    for: "firstname",
                    class: "form-label"
                  }, "First Name", -1)),
                  e.currentContact ? V((p(), h("input", {
                    key: 0,
                    type: "text",
                    class: "form-control",
                    "onUpdate:modelValue": t[6] || (t[6] = (f) => e.currentContact.firstName = f),
                    onChange: t[7] || (t[7] = (...f) => e.contactNameChanged && e.contactNameChanged(...f)),
                    placeholder: "First Name"
                  }, null, 544)), [
                    [_e, e.currentContact.firstName]
                  ]) : P("", !0)
                ]),
                a("div", VPt, [
                  t[21] || (t[21] = a("label", {
                    for: "firstname",
                    class: "form-label"
                  }, "Last Name", -1)),
                  e.currentContact ? V((p(), h("input", {
                    key: 0,
                    type: "text",
                    class: "form-control",
                    "onUpdate:modelValue": t[8] || (t[8] = (f) => e.currentContact.lastName = f),
                    onChange: t[9] || (t[9] = (...f) => e.contactNameChanged && e.contactNameChanged(...f)),
                    placeholder: "Last Name"
                  }, null, 544)), [
                    [_e, e.currentContact.lastName]
                  ]) : P("", !0)
                ])
              ]),
              a("div", DPt, [
                t[22] || (t[22] = a("p", { class: "fw-bold fs-6 text-xsmall text-secondary" }, "RECORDED OWNER NAMES", -1)),
                a("ul", NPt, [
                  (p(!0), h(A, null, D(e.ownerParties, (f) => (p(), h("li", null, [
                    a("span", {
                      onClick: (v) => e.setName(f),
                      role: "button",
                      class: "btn-link text-reset"
                    }, [
                      f.companyName ? (p(), h(A, { key: 0 }, [
                        y(g(f.companyName), 1)
                      ], 64)) : (p(), h(A, { key: 1 }, [
                        y(g(f.first) + " " + g(f.last), 1)
                      ], 64))
                    ], 8, jPt)
                  ]))), 256))
                ])
              ])
            ])
          ]),
          a("div", HPt, [
            a("button", {
              type: "button",
              onClick: t[10] || (t[10] = (...f) => e.saveContactEdit && e.saveContactEdit(...f)),
              class: "btn btn-lava"
            }, "Save")
          ])
        ])
      ])
    ], 512),
    N(o, {
      ref: "skipTrace",
      onTraceComplete: e.saveContactEdit,
      onCancelled: t[11] || (t[11] = (f) => e.skipTracing = !1)
    }, null, 8, ["onTraceComplete"])
  ], 64);
}
const PE = /* @__PURE__ */ Ae(uPt, [["render", UPt]]), zPt = me({
  name: "RecordedOwnerNames",
  props: {
    id: Number
  },
  components: {
    ContentLoader: Sa
  },
  data() {
    return {};
  },
  watch: {
    "owner.id"(e) {
      try {
        console.log("NamesId.owner changed", this.owner.id);
      } catch (t) {
        Se(t);
      }
    },
    id(e) {
      try {
        e && this.portfolioFinderStore.refreshOwnerNames(e);
      } catch (t) {
        Se(t);
      }
    },
    owner() {
      console.log("Names.owner changed", this.owner.id), this.portfolioFinderStore.refreshOwnerNames(this.owner.id);
    }
  },
  computed: {
    firstContact() {
      if (this.leadContacts.length > 0)
        return this.leadContacts[0];
    },
    selectedValue() {
      var e, t;
      return `${(e = this.firstContact) == null ? void 0 : e.firstName}${(t = this.firstContact) == null ? void 0 : t.lastName}`.trim();
    },
    ...at(Ba),
    ...q(Ba, ["ownerParties", "loadingOwnerNames", "owner", "leadContacts", "ownerLoaded"]),
    ...q(Te, ["access", "aclLoaded"])
  },
  methods: {
    number: Ve,
    date: cs,
    getValue(e) {
      return e.companyName ? `${e.first ?? ""}${e.companyName ?? ""}`.trim() : `${e.first ?? ""}${e.last ?? ""}`.trim();
    },
    async setName(e) {
      try {
        e.companyName ? (this.firstContact.resetContact = this.firstContact.lastName != e.companyName, this.firstContact.firstName = e.first, this.firstContact.lastName = e.companyName) : (this.firstContact.resetContact = this.firstContact.firstName != e.first || this.firstContact.lastName != e.last, this.firstContact.firstName = e.first, this.firstContact.lastName = e.last), this.firstContact.resetContact = !0, await this.saveContactEdit();
      } catch {
        Se(error);
      }
    },
    async saveContactEdit() {
      try {
        const e = await W.api.portfolioFinder.updateContact(this.owner.id, this.firstContact);
        if (e.data.status != de.Success)
          throw new Le(e);
        this.firstContact.id = e.data.contact.id, this.firstContact.firstName = e.data.contact.firstName, this.firstContact.lastName = e.data.contact.lastName, this.firstContact.phone = e.data.contact.phone, this.firstContact.phoneDNC = e.data.contact.phoneDNC, this.firstContact.cell = e.data.contact.cell, this.firstContact.cellDNC = e.data.contact.cellDNC, this.firstContact.email = e.data.contact.email, this.firstContact.litigator = e.data.contact.litigator, this.firstContact.skipTracedOn = e.data.contact.skipTracedOn, this.firstContact.resetContact = void 0;
      } catch (e) {
        Se(e);
      }
    }
  },
  mounted() {
    this.ownerLoaded.then(async () => await this.portfolioFinderStore.loadOwnerNames(this.owner.id));
  }
}), WPt = { class: "fs-6 fw-bold text-secondary text-xsmall mb-2" }, GPt = { key: 0 }, YPt = { class: "bg-white rounded border recorded-property-table-scroll mb-3" }, XPt = { class: "table table-sm table-striped table-skip-trace mb-0" }, qPt = ["value"], QPt = ["onClick"], KPt = { class: "text-center" }, ZPt = { class: "text-center" }, JPt = {
  key: 0,
  class: "fa-light fa-check text-success"
}, $Pt = { class: "text-center" }, _Pt = {
  key: 0,
  class: "fa-light fa-check text-success"
}, e3t = { class: "text-end" };
function t3t(e, t, s, n, r, i) {
  const o = pe("content-loader");
  return p(), h(A, null, [
    a("div", WPt, [
      t[1] || (t[1] = y(" RECORDED PROPERTY OWNER NAMES ")),
      e.owner ? (p(), h("span", GPt, "(" + g(e.number(e.ownerParties.length)) + ")", 1)) : P("", !0),
      t[2] || (t[2] = a("i", {
        title: "Recorded Owner Names",
        class: "fa-light fa-info-circle ms-1",
        "data-bs-toggle": "popover",
        "data-bs-content": "All names associated with this lead are listed here. The names are sorted by the date used, with the most recently used names first.",
        "data-bs-trigger": "focus",
        tabindex: "-1"
      }, null, -1))
    ]),
    e.loadingOwnerNames ? (p(), Fe(o, {
      key: 0,
      width: 400,
      height: 100,
      speed: 50
    }, {
      default: ve(() => t[3] || (t[3] = [
        a("rect", {
          x: "0",
          y: "0",
          rx: "3",
          ry: "3",
          width: "60",
          height: "8"
        }, null, -1),
        a("rect", {
          x: "73",
          y: "0",
          rx: "3",
          ry: "3",
          width: "80",
          height: "8"
        }, null, -1),
        a("rect", {
          x: "166",
          y: "0",
          rx: "3",
          ry: "3",
          width: "70",
          height: "8"
        }, null, -1),
        a("rect", {
          x: "249",
          y: "0",
          rx: "3",
          ry: "3",
          width: "80",
          height: "8"
        }, null, -1),
        a("rect", {
          x: "0",
          y: "12",
          rx: "3",
          ry: "3",
          width: "60",
          height: "8"
        }, null, -1),
        a("rect", {
          x: "73",
          y: "12",
          rx: "3",
          ry: "3",
          width: "80",
          height: "8"
        }, null, -1),
        a("rect", {
          x: "166",
          y: "12",
          rx: "3",
          ry: "3",
          width: "70",
          height: "8"
        }, null, -1),
        a("rect", {
          x: "249",
          y: "12",
          rx: "3",
          ry: "3",
          width: "80",
          height: "8"
        }, null, -1),
        a("rect", {
          x: "0",
          y: "24",
          rx: "3",
          ry: "3",
          width: "60",
          height: "8"
        }, null, -1),
        a("rect", {
          x: "73",
          y: "24",
          rx: "3",
          ry: "3",
          width: "80",
          height: "8"
        }, null, -1),
        a("rect", {
          x: "166",
          y: "24",
          rx: "3",
          ry: "3",
          width: "70",
          height: "8"
        }, null, -1),
        a("rect", {
          x: "249",
          y: "24",
          rx: "3",
          ry: "3",
          width: "80",
          height: "8"
        }, null, -1),
        a("rect", {
          x: "0",
          y: "36",
          rx: "3",
          ry: "3",
          width: "60",
          height: "8"
        }, null, -1),
        a("rect", {
          x: "73",
          y: "36",
          rx: "3",
          ry: "3",
          width: "80",
          height: "8"
        }, null, -1),
        a("rect", {
          x: "166",
          y: "36",
          rx: "3",
          ry: "3",
          width: "70",
          height: "8"
        }, null, -1),
        a("rect", {
          x: "249",
          y: "36",
          rx: "3",
          ry: "3",
          width: "80",
          height: "8"
        }, null, -1)
      ])),
      _: 1,
      __: [3]
    })) : (p(), h(A, { key: 1 }, [
      a("div", YPt, [
        a("table", XPt, [
          t[5] || (t[5] = a("thead", null, [
            a("tr", null, [
              a("th"),
              a("th", null, "Properties"),
              a("th", null, "Name"),
              a("th", null, "Company"),
              a("th", null, "Mailing"),
              a("th", { class: "text-end" }, "Traced")
            ])
          ], -1)),
          a("tbody", null, [
            (p(!0), h(A, null, D(e.ownerParties, (l, d) => (p(), h("tr", { key: d }, [
              a("td", null, [
                V(a("input", {
                  type: "radio",
                  value: e.getValue(l),
                  "onUpdate:modelValue": t[0] || (t[0] = (c) => e.selectedValue = c),
                  class: "btn-check",
                  autocomplete: "off",
                  name: "ownerPartiesChks"
                }, null, 8, qPt), [
                  [Mt, e.selectedValue]
                ]),
                a("label", {
                  class: "btn btn-xs rounded",
                  onClick: mn((c) => e.setName(l), ["stop"])
                }, t[4] || (t[4] = [
                  a("i", { class: "fa fa-check" }, null, -1)
                ]), 8, QPt)
              ]),
              a("td", KPt, g(e.number(l.total)), 1),
              a("td", null, [
                l.companyName ? (p(), h(A, { key: 0 }, [
                  y(g(l.companyName), 1)
                ], 64)) : (p(), h(A, { key: 1 }, [
                  y(g(l.first) + " " + g(l.last), 1)
                ], 64))
              ]),
              a("td", ZPt, [
                l.isCompany ? (p(), h("i", JPt)) : P("", !0)
              ]),
              a("td", $Pt, [
                l.mailing ? (p(), h("i", _Pt)) : P("", !0)
              ]),
              a("td", e3t, g(e.date(l.skipTraced)), 1)
            ]))), 128))
          ])
        ])
      ]),
      t[6] || (t[6] = a("div", { class: "alert alert-info text-small mb-0" }, [
        a("i", { class: "fa-light fa-info-circle me-2" }),
        y("Skip traced information is retained for 90 days from date of skip trace. ")
      ], -1))
    ], 64))
  ], 64);
}
const kE = /* @__PURE__ */ Ae(zPt, [["render", t3t]]), s3t = me({
  name: "PorftolioFinderInfo",
  props: {},
  components: {
    ContactCard: PE,
    RecordedOwnerNames: kE,
    LeadSimple: Qb
  },
  data() {
    return {
      loading: !0,
      showComponent: !1
    };
  },
  computed: {
    favoriteStyle() {
      var e;
      return {
        btn: !0,
        "btn-sm": !0,
        "btn-outline-eclipse": !0,
        "ms-auto": !0,
        "btn-favorited": ((e = this.owner) == null ? void 0 : e.isFavorite) == !0
      };
    },
    favoriteIconStyle() {
      var e, t;
      return {
        "fa-heart": !0,
        "fa-solid": ((e = this.owner) == null ? void 0 : e.isFavorite) == !0,
        "fa-light": ((t = this.owner) == null ? void 0 : t.isFavorite) == !1
      };
    },
    calculatingClasses() {
      return {
        card: !0,
        "shadow-sm": !0,
        calculating: this.loading
      };
    },
    ...q(Ba, ["owner", "ownerLoading", "ownerNamesLoaded"]),
    ...q(qe, ["taxInfo", "taxInfoInitialized", "property", "propertyInitialized"]),
    ...q(Te, ["access", "aclLoaded", "isClient", "isAdmin", "isUser"]),
    ...q(ct, ["userInfo"])
  },
  methods: {
    number: Ve,
    addToCRM() {
      var e;
      (e = bootstrap.Modal.getOrCreateInstance(this.$refs.dialogAddToCRM)) == null || e.show();
    },
    closeCrmDialog() {
      var e;
      (e = bootstrap.Modal.getOrCreateInstance(this.$refs.dialogAddToCRM)) == null || e.hide();
    },
    async setFavorite() {
      try {
        this.owner.isFavorite ? (await W.api.portfolioFinder.removeFavoriteOwner(this.owner.id), this.owner.isFavorite = !1) : (await W.api.portfolioFinder.favoriteOwner(this.owner.id), this.owner.isFavorite = !0, wt("Target added to Favorite Targets"));
      } catch (e) {
        Se(e);
      }
    }
  },
  created() {
  },
  mounted() {
    this.aclLoaded.then(async () => await this.taxInfoInitialized).then(async () => await this.propertyInitialized).then(() => {
      var e, t, s, n;
      return this.showComponent = this.property.isCustom != !0 && (this.isAdmin || this.isUser || ((e = this.access) == null ? void 0 : e.client)) && ((s = (t = this.access) == null ? void 0 : t.leads) == null ? void 0 : s.lite) != !0 && ((n = this.taxInfo) == null ? void 0 : n.investor);
    }).then(async () => {
      var e;
      (e = this.taxInfo) != null && e.investor && await this.ownerNamesLoaded;
    }).finally(() => {
      this.loading = !1;
    }), Hr("P", (e) => {
      var t;
      this.showComponent = (this.isAdmin || this.isUser || ((t = this.access) == null ? void 0 : t.client)) && !this.showComponent;
    }, !0, !0, !0);
  }
}), a3t = { class: "card-body" }, n3t = { class: "d-flex justify-content-between gap-2 bg-light mt-2 rounded p-2" }, r3t = {
  class: "modal fade",
  ref: "dialogAddToCRM",
  id: "dialogAddToCRM",
  tabindex: "-1",
  "aria-labelledby": "dialogAddToCRMLabel",
  "aria-hidden": "true"
}, o3t = { class: "modal-dialog modal-dialog-centered" }, i3t = { class: "modal-content bg-gradient-alphabet rounded" }, l3t = { class: "modal-body" };
function d3t(e, t, s, n, r, i) {
  var c;
  const o = pe("contact-card"), l = pe("recorded-owner-names"), d = pe("lead-simple");
  return p(), h(A, null, [
    e.showComponent ? (p(), h("div", {
      key: 0,
      class: z(e.calculatingClasses)
    }, [
      t[4] || (t[4] = a("div", { class: "card-header bg-white fw-bold d-flex justify-content-between" }, [
        a("span", null, [
          a("i", { class: "fa-light fa-address-card me-2" }),
          y("Porfolio Finder Info")
        ])
      ], -1)),
      a("div", a3t, [
        t[3] || (t[3] = a("div", { class: "calculating-animation position-absolute top-50 start-50 translate-middle text-center" }, [
          a("i", { class: "fa-duotone fa-solid fa-compass fa-spin fa-lg text-eclipse" })
        ], -1)),
        N(o),
        a("div", n3t, [
          a("button", {
            type: "button",
            class: z(e.favoriteStyle),
            onClick: t[0] || (t[0] = (...u) => e.setFavorite && e.setFavorite(...u)),
            "aria-controls": "favorite"
          }, [
            a("i", {
              class: z(e.favoriteIconStyle)
            }, null, 2),
            t[2] || (t[2] = a("span", { class: "ms-2 d-none d-md-inline-block" }, "Favorite Target", -1))
          ], 2),
          a("button", {
            type: "button",
            class: "btn btn-sm btn-accent-glass",
            onClick: t[1] || (t[1] = (...u) => e.addToCRM && e.addToCRM(...u))
          }, "Add to CRM")
        ]),
        N(l)
      ])
    ], 2)) : P("", !0),
    a("div", r3t, [
      a("div", o3t, [
        a("div", i3t, [
          t[5] || (t[5] = a("div", { class: "modal-header border-0 pb-0" }, [
            a("p", {
              class: "modal-title fs-5 fw-bold",
              id: "dialogAddToCRMLabel"
            }, "Add to CRM"),
            a("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            })
          ], -1)),
          a("div", l3t, [
            ((c = e.userInfo) == null ? void 0 : c.crmProvider) == "lead-simple" ? (p(), Fe(d, { key: 0 })) : P("", !0)
          ])
        ])
      ])
    ], 512)
  ], 64);
}
const c3t = /* @__PURE__ */ Ae(s3t, [["render", d3t]]), u3t = me({
  components: {
    ContentLoader: Sa
  },
  data() {
    return {
      isLoaded: !1,
      inPmArea: 0,
      investmentHomes: 0,
      annualManagementFees: 0,
      values: {
        singleFamily: {},
        residential24Family: {},
        multifamily: {},
        commercial: {},
        retail: {},
        mobileHomeParks: {},
        rvParksCampground: {},
        selfStorage: {}
      }
    };
  },
  computed: {
    annualManagementFeeValue() {
      var e, t;
      return (((e = this.values.singleFamily) == null ? void 0 : e.annualManagementFees) ?? 0) + (((t = this.values.residential24Family) == null ? void 0 : t.annualManagementFees) ?? 0);
    },
    clientLifetimeValue() {
      var e;
      return this.annualManagementFeeValue * (((e = this.userInfo) == null ? void 0 : e.expectedClientTenure) ?? 3);
    },
    ...q(ct, ["userInfo"]),
    ...q(Ba, ["owner", "ownerLoaded"])
  },
  methods: {
    number: Ve,
    currency: Ze,
    safeCurrency(e) {
      return isNaN(e) == !1 ? e == 0 ? "-" : this.currency(e) : "";
    },
    safeNumber(e) {
      return isNaN(e) == !1 ? this.number(e) : "";
    },
    loadClientValues() {
      W.api.portfolioFinder.getClientValue(this.owner.id, Xt.SingleFamily).then((e) => this.values.singleFamily = e.data), W.api.portfolioFinder.getClientValue(this.owner.id, Xt.Residential24Family).then((e) => this.values.residential24Family = e.data);
    }
  },
  mounted() {
    this.ownerLoaded.then(() => this.loadClientValues()).then(() => this.isLoaded = !0);
  }
}), p3t = { class: "table table-sm" }, h3t = { class: "text-center" }, m3t = { class: "text-center" }, f3t = { class: "text-center" }, g3t = { class: "text-center" }, v3t = { class: "text-center" }, y3t = { class: "text-center" }, b3t = { class: "bg-kpi border rounded text-center" }, A3t = { class: "row g-0 d-flex justify-content-between kpi-crumbs" }, w3t = { class: "col-md-5 col-xl-4" }, C3t = { class: "d-flex justify-content-center align-items-center h-100" }, S3t = { class: "fs-5 fw-bold" }, P3t = { class: "col-md-4 position-relative" }, k3t = { class: "kpi-middle d-flex justify-content-center align-items-center h-100" }, E3t = { class: "fs-5 fw-bold" }, I3t = { class: "col-md-3 col-xl-4" }, T3t = { class: "d-flex justify-content-center align-items-center h-100" }, O3t = { class: "fs-5 fw-bold text-success" };
function R3t(e, t, s, n, r, i) {
  var l;
  const o = pe("content-loader");
  return e.isLoaded ? (p(), h(A, { key: 1 }, [
    a("table", p3t, [
      t[3] || (t[3] = a("thead", null, [
        a("tr", null, [
          a("th", { class: "border-top-0" }),
          a("th", { class: "border-top-0" }, "IN PM AREA"),
          a("th", { class: "border-top-0" }, "AVG Rental Rate"),
          a("th", { class: "border-top-0" }, "Annual MGMT Value")
        ])
      ], -1)),
      a("tbody", null, [
        a("tr", null, [
          t[1] || (t[1] = a("td", null, "Single Family", -1)),
          a("td", h3t, g(e.safeNumber(e.values.singleFamily.inPmArea)), 1),
          a("td", m3t, g(e.safeCurrency(e.values.singleFamily.avgRentalRate)), 1),
          a("td", f3t, g(e.safeCurrency(e.values.singleFamily.annualManagementFees)), 1)
        ]),
        a("tr", null, [
          t[2] || (t[2] = a("td", null, "2-4 Family", -1)),
          a("td", g3t, g(e.safeNumber(e.values.residential24Family.inPmArea)), 1),
          a("td", v3t, g(e.safeCurrency(e.values.residential24Family.avgRentalRate)), 1),
          a("td", y3t, g(e.safeCurrency(e.values.residential24Family.annualManagementFees)), 1)
        ])
      ])
    ]),
    a("div", b3t, [
      a("div", A3t, [
        a("div", w3t, [
          a("div", C3t, [
            a("div", null, [
              t[4] || (t[4] = a("div", { class: "text-xsmall fw-bold text-body-secondary" }, "TOTAL ANNUAL MANAGEMENT FEE VALUE", -1)),
              a("div", S3t, g(e.currency(e.annualManagementFeeValue)), 1)
            ])
          ])
        ]),
        a("div", P3t, [
          a("div", k3t, [
            a("div", null, [
              t[5] || (t[5] = a("div", { class: "text-xsmall fw-bold text-body-secondary" }, [
                y("EXPECTED CLIENT"),
                a("br", { class: "d-none d-xl-inline-block" }),
                y(" TENURE")
              ], -1)),
              a("div", E3t, g(e.number((l = this.userInfo) == null ? void 0 : l.expectedClientTenure, 0, "-")) + " YEARS", 1)
            ])
          ]),
          t[6] || (t[6] = a("div", { class: "triangle" }, null, -1))
        ]),
        a("div", I3t, [
          a("div", T3t, [
            a("div", null, [
              t[7] || (t[7] = a("div", { class: "text-xsmall fw-bold text-body-secondary" }, [
                y("CLIENT LIFETIME"),
                a("br", { class: "d-none d-xl-inline-block" }),
                y(" VALUE")
              ], -1)),
              a("div", O3t, g(e.currency(e.clientLifetimeValue)), 1)
            ])
          ])
        ])
      ])
    ])
  ], 64)) : (p(), Fe(o, {
    key: 0,
    width: 280,
    height: 109,
    speed: 2
  }, {
    default: ve(() => t[0] || (t[0] = [
      a("rect", {
        x: "0",
        y: "0",
        rx: "3",
        ry: "3",
        width: "60",
        height: "6"
      }, null, -1),
      a("rect", {
        x: "73",
        y: "0",
        rx: "3",
        ry: "3",
        width: "220",
        height: "6"
      }, null, -1),
      a("rect", {
        x: "0",
        y: "14",
        rx: "3",
        ry: "3",
        width: "60",
        height: "6"
      }, null, -1),
      a("rect", {
        x: "73",
        y: "14",
        rx: "3",
        ry: "3",
        width: "220",
        height: "6"
      }, null, -1),
      a("rect", {
        x: "0",
        y: "28",
        rx: "3",
        ry: "3",
        width: "60",
        height: "6"
      }, null, -1),
      a("rect", {
        x: "73",
        y: "28",
        rx: "3",
        ry: "3",
        width: "220",
        height: "6"
      }, null, -1),
      a("rect", {
        x: "0",
        y: "42",
        rx: "3",
        ry: "3",
        width: "60",
        height: "6"
      }, null, -1),
      a("rect", {
        x: "73",
        y: "42",
        rx: "3",
        ry: "3",
        width: "220",
        height: "6"
      }, null, -1)
    ])),
    _: 1,
    __: [0]
  }));
}
const EE = /* @__PURE__ */ Ae(u3t, [["render", R3t]]), L3t = me({
  name: "PorftolioFinderTargetValue",
  props: {},
  components: {
    ClientLifetimeValue: EE
  },
  data() {
    return {
      loading: !0,
      showComponent: !1
    };
  },
  computed: {
    favoriteStyle() {
      var e;
      return {
        btn: !0,
        "btn-sm": !0,
        "btn-outline-eclipse": !0,
        "ms-auto": !0,
        "btn-favorited": ((e = this.owner) == null ? void 0 : e.isFavorite) == !0
      };
    },
    favoriteIconStyle() {
      var e, t;
      return {
        "fa-heart": !0,
        "fa-solid": ((e = this.owner) == null ? void 0 : e.isFavorite) == !0,
        "fa-light": ((t = this.owner) == null ? void 0 : t.isFavorite) == !1
      };
    },
    calculatingClasses() {
      return {
        card: !0,
        "shadow-sm": !0,
        calculating: this.loading
      };
    },
    ...q(Ba, ["owner", "ownerLoading", "leadName", "isLoading", "markers", "markersLoading", "ownerNamesLoaded"]),
    ...q(qe, ["taxInfo", "taxInfoInitialized", "property", "propertyInitialized"]),
    ...q(Te, ["access", "aclLoaded", "isClient", "isAdmin", "isUser"]),
    ...q(ct, ["userInfo"])
  },
  methods: {
    number: Ve,
    async showGuardDialog() {
      var e;
      (e = bootstrap.Modal.getOrCreateInstance(this.$refs.guardDialog)) == null || e.show();
    }
  },
  mounted() {
    this.aclLoaded.then(async () => await this.taxInfoInitialized).then(async () => await this.propertyInitialized).then(() => {
      var e, t, s, n;
      return this.showComponent = this.property.isCustom != !0 && (this.isAdmin || this.isUser || ((e = this.access) == null ? void 0 : e.client)) && ((s = (t = this.access) == null ? void 0 : t.leads) == null ? void 0 : s.lite) != !0 && ((n = this.taxInfo) == null ? void 0 : n.investor);
    }).then(async () => {
      var e;
      (e = this.taxInfo) != null && e.investor && await this.ownerNamesLoaded;
    }).finally(() => {
      this.loading = !1;
    }), Hr("P", (e) => {
      var t;
      this.showComponent = (this.isAdmin || this.isUser || ((t = this.access) == null ? void 0 : t.client)) && !this.showComponent;
    }, !0, !0, !0);
  }
}), B3t = { class: "card-body" }, M3t = {
  key: 0,
  class: "card-footer bg-transparent border-0 d-flex justify-content-between pt-0"
}, x3t = ["href"], F3t = {
  class: "modal fade",
  id: "guardDialog",
  ref: "guardDialog",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
};
function V3t(e, t, s, n, r, i) {
  var l;
  const o = pe("client-lifetime-value");
  return p(), h(A, null, [
    e.showComponent ? (p(), h("div", {
      key: 0,
      class: z(e.calculatingClasses)
    }, [
      t[2] || (t[2] = a("div", { class: "card-header bg-white fw-bold d-flex justify-content-between" }, [
        a("span", null, [
          a("i", { class: "fa-light fa-id-card-clip me-2" }),
          y("Porfolio Finder Target Value")
        ])
      ], -1)),
      a("div", B3t, [
        t[0] || (t[0] = a("div", { class: "calculating-animation position-absolute top-50 start-50 translate-middle text-center" }, [
          a("i", { class: "fa-duotone fa-solid fa-compass fa-spin fa-lg text-eclipse" })
        ], -1)),
        a("div", null, [
          N(o)
        ]),
        t[1] || (t[1] = a("div", { class: "text-small text-body-secondary text-center pt-2" }, [
          y(" Client Lifetime Value includes all absentee owned homes in your Company Territory. Edit your Company Territory in "),
          a("a", { href: "/account/settings#company-territoryTab" }, "settings"),
          y(". ")
        ], -1))
      ]),
      (l = e.taxInfo) != null && l.ownerId ? (p(), h("div", M3t, [
        a("a", {
          href: "/portfolio-finder/" + e.taxInfo.ownerId,
          class: "btn btn-sm btn-lava"
        }, "View Owner's Portfolio", 8, x3t)
      ])) : P("", !0)
    ], 2)) : P("", !0),
    a("div", F3t, t[3] || (t[3] = [
      Bt('<div class="modal-dialog modal-dialog-centered"><div class="modal-content bg-gradient-alphabet rounded"><div class="modal-header border-0 mb-0"><button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button></div><div class="modal-body text-center px-5 pb-5 pt-4"><i class="fa-duotone fa-id-card-clip mb-3 fa-3xl"></i><br><b class="fs-5">Portfolio Finder</b><br><br><p> To view the full details of this owner and their portfolio, upgrade to Portfolio Finder. </p><p><b>Ready to start a free trial?</b><br>Click here for 30 days of Portfolio Finder.</p><div class="d-flex gap-3 justify-content-center pt-3"><button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal">Cancel</button><button type="button" class="btn btn-lava">Start Free Trial</button></div></div></div></div>', 1)
    ]), 512)
  ], 64);
}
const D3t = /* @__PURE__ */ Ae(L3t, [["render", V3t]]), N3t = me({
  name: "RecordsTab",
  props: {
    disablePortfolioFinder: Boolean
  },
  components: {
    PortfolioFinderLite: uSt,
    PortfolioFinderInfo: c3t,
    PortfolioFinderTargetValue: D3t,
    TaxAsessorData: Spt,
    CurrentPropertyRecords: Jmt,
    AllPropertyRecords: kgt
  },
  data() {
    return {};
  },
  computed: {
    ...q(Te, ["access", "aclLoaded"])
  },
  methods: {
    number: Ve
  },
  created() {
  },
  mounted() {
    this.aclLoaded.then(() => {
    });
  }
}), j3t = { class: "container-xl" }, H3t = { class: "row row-cols-1 row-cols-md-2" }, U3t = { class: "col d-flex flex-column gap-3" }, z3t = { class: "col col-mortgage d-flex flex-column gap-3" };
function W3t(e, t, s, n, r, i) {
  pe("foreclosure-data");
  const o = pe("portfolio-finder-info"), l = pe("portfolio-finder-lite"), d = pe("tax-asessor-data"), c = pe("portfolio-finder-target-value"), u = pe("current-property-records"), m = pe("all-property-records");
  return p(), h("div", j3t, [
    P("", !0),
    a("div", H3t, [
      a("div", U3t, [
        e.disablePortfolioFinder ? P("", !0) : (p(), Fe(o, { key: 0 })),
        e.disablePortfolioFinder ? P("", !0) : (p(), Fe(l, { key: 1 })),
        N(d)
      ]),
      a("div", z3t, [
        e.disablePortfolioFinder ? P("", !0) : (p(), Fe(c, { key: 0 })),
        N(u),
        N(m)
      ])
    ])
  ]);
}
const ods = /* @__PURE__ */ Ae(N3t, [["render", W3t]]), Sr = 1e3, G3t = "#DADADA", Y3t = me({
  name: "NetProfit",
  props: {},
  components: {},
  data() {
    return {
      chartData: void 0
    };
  },
  computed: {
    shortTerm() {
      var e, t;
      return (((t = (e = this.calculatedResults) == null ? void 0 : e.shortTerm) == null ? void 0 : t.length) ?? 0) > 1;
    },
    ...q(ct, ["account", "isAdvancedMode"]),
    ...q(Te, ["access", "aclLoaded"]),
    ...q(qe, ["calcParams", "calculatedResults"]),
    ...at(qe)
  },
  methods: {
    number: Ve,
    initCharts(e) {
      const t = {
        type: "bar",
        data: {
          labels: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
          datasets: [
            {
              label: "Net Profit",
              data: [15 * Sr, 16 * Sr, 17 * Sr, 18 * Sr, 19 * Sr, 20 * Sr, 21 * Sr, 22 * Sr, 23 * Sr, 24 * Sr],
              backgroundColor: G3t
            }
          ]
        },
        options: {
          responsive: !0,
          maintainAspectRatio: !0,
          plugins: {
            title: {
              display: !1,
              text: "Income & Expenses"
            },
            legend: {
              display: !1,
              position: "bottom",
              maxHeight: 100,
              labels: {
                boxWidth: 10
              }
            },
            tooltip: {
              mode: "index",
              intersect: !1,
              callbacks: {
                label: function(s) {
                  let n = s.dataset.label;
                  const r = ": " + Ze(s.dataset.data[s.dataIndex]);
                  return n += r, n;
                }
              }
            }
          },
          scales: {
            y: {
              beginAtZero: !0,
              ticks: {
                callback: function(s, n, r) {
                  return Ze(s);
                }
              }
            }
          }
        }
      };
      e && this.$refs.chart1 && !this.financialCharts.ineChart && (this.financialCharts.ineChart = new Rt(this.$refs.chart1, t));
    },
    showFinancialAnalysisTab(e) {
      e.target.dataset.bsTarget == "#financial-flip" && this.initCharts(!0);
    }
  },
  created() {
    this.financialCharts = {};
  },
  mounted() {
    document.addEventListener("shown.bs.tab", this.showFinancialAnalysisTab);
  }
}), X3t = {
  class: "mini-chart",
  ref: "chartModal1"
}, q3t = {
  "data-id": "chart1",
  class: "ineChart",
  id: "chart1",
  ref: "chart1",
  height: "200"
};
function Q3t(e, t, s, n, r, i) {
  return p(), h("div", X3t, [
    t[0] || (t[0] = a("div", { class: "text-center mb-3" }, " Annual Cash Flow ", -1)),
    a("canvas", q3t, null, 512)
  ], 512);
}
const K3t = /* @__PURE__ */ Ae(Y3t, [["render", Q3t]]), Z3t = "#DADADA", J3t = {
  id: "gaugeNeedle",
  afterDatasetDraw(e, t, s) {
    const { ctx: n, config: r, data: i, chartArea: { top: o, bottom: l, left: d, right: c, width: u, height: m } } = e;
    n.save(), console.log(i);
    const f = i.datasets[0].needleValue, v = i.datasets[0].data.reduce((w, S) => w + S, 0), b = Math.PI + 1 / v * f * Math.PI;
    console.log("angle: ", b);
  }
}, $3t = () => ({
  type: "doughnut",
  data: {
    labels: [],
    datasets: [{
      data: [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
      backgroundColor: [Z3t]
    }]
  },
  options: {
    circumference: 180,
    rotation: -90,
    cutoutPercentage: 60,
    responsive: !1,
    plugins: {
      tooltip: {
        enabled: !0,
        callbacks: {
          label(e) {
            return e.label;
          }
        }
      },
      legend: {
        display: !1
      },
      title: {
        display: !1
      },
      centerText: {
        datasetIndex: 0,
        fontWeight: "700",
        fontSize: "16px",
        font: "Lato, sans-serif",
        yAdjust: -5
      }
    },
    animation: {
      animateScale: !1,
      animateRotate: !0
    }
  },
  plugins: [
    K4,
    J3t
  ]
}), _3t = me({
  name: "CostArv",
  props: {},
  components: {},
  data() {
    return {};
  },
  computed: {
    ...q(Te, ["access", "aclLoaded"])
  },
  methods: {
    number: Ve
  },
  created() {
  },
  mounted() {
    this.charts = {
      capRateDonutChart: new Rt(this.$refs.capScaleChart, $3t())
    };
  }
}), e8t = {
  id: "capScaleChart",
  ref: "capScaleChart",
  height: "200",
  width: "200"
};
function t8t(e, t, s, n, r, i) {
  return p(), h(A, null, [
    t[0] || (t[0] = a("div", { class: "text-center mb-3" }, "Cost / ARV %", -1)),
    a("canvas", e8t, null, 512)
  ], 64);
}
const s8t = /* @__PURE__ */ Ae(_3t, [["render", t8t]]), a8t = me({
  name: "GrossSalesProceeds",
  computed: {
    months() {
      return [...Array(13).keys()].filter((e) => e > 0);
    },
    ...at(qe),
    ...q(Te, ["access", "aclLoaded"]),
    ...q(qe, ["flipResults", "flipParams", "flipAmortizationSchedule"])
  },
  methods: {
    currency: Ze,
    loanPayoff(e) {
      var t, s, n, r, i;
      return ((t = this.flipParams) == null ? void 0 : t.purchaseMethod) == Vt.Cash ? 0 : ((s = this.flipParams) == null ? void 0 : s.purchaseMethod) == Vt.PermanentLoan ? this.propertyStore.flipPayoff(e) : (r = (n = this.flipParams) == null ? void 0 : n.bridgeLoan) != null && r.interestOnly ? (i = this.flipResults) == null ? void 0 : i.bridgeLoanAmount : this.propertyStore.flipPayoff(e);
    },
    grossSalesProceeds(e) {
      var t, s;
      return ((t = this.flipResults) == null ? void 0 : t.afterRepairValue) - ((s = this.flipResults) == null ? void 0 : s.resaleCosts) - this.loanPayoff(e);
    }
  }
}), n8t = { class: "table-wrap" }, r8t = { class: "table table-sm text-small mode-advanced mlse-gross-sales-proceeds" }, o8t = { class: "mlse-column" }, i8t = { class: "mlse-column" }, l8t = { class: "mlse-column" }, d8t = { class: "mlse-column" }, c8t = { class: "table-total" }, u8t = { class: "mlse-column" }, p8t = { key: 0 };
function h8t(e, t, s, n, r, i) {
  return p(), h("div", n8t, [
    a("table", r8t, [
      a("thead", null, [
        a("tr", null, [
          t[0] || (t[0] = a("th", null, null, -1)),
          (p(!0), h(A, null, D(e.months, (o) => (p(), h("th", o8t, " Month " + g(o), 1))), 256))
        ])
      ]),
      a("tbody", null, [
        a("tr", null, [
          t[1] || (t[1] = a("th", null, " Sales Price ", -1)),
          (p(!0), h(A, null, D(e.months, (o) => {
            var l, d;
            return p(), h("td", i8t, [
              o > ((l = e.flipParams) == null ? void 0 : l.monthsUntilSold) ? (p(), h(A, { key: 0 }, [
                y(g(e.currency((d = e.flipResults) == null ? void 0 : d.afterRepairValue)), 1)
              ], 64)) : P("", !0)
            ]);
          }), 256))
        ]),
        a("tr", null, [
          t[2] || (t[2] = a("th", null, " Resale Costs ", -1)),
          (p(!0), h(A, null, D(e.months, (o) => {
            var l, d;
            return p(), h("td", l8t, [
              o > ((l = e.flipParams) == null ? void 0 : l.monthsUntilSold) ? (p(), h(A, { key: 0 }, [
                y(g(e.currency((d = e.flipResults) == null ? void 0 : d.resaleCosts)), 1)
              ], 64)) : P("", !0)
            ]);
          }), 256))
        ]),
        a("tr", null, [
          t[3] || (t[3] = a("th", null, " Loan Payoff ", -1)),
          (p(!0), h(A, null, D(e.months, (o) => {
            var l;
            return p(), h("td", d8t, [
              o > ((l = e.flipParams) == null ? void 0 : l.monthsUntilSold) ? (p(), h(A, { key: 0 }, [
                y(g(e.currency(e.loanPayoff(o))), 1)
              ], 64)) : P("", !0)
            ]);
          }), 256))
        ]),
        a("tr", c8t, [
          t[4] || (t[4] = a("th", null, [
            a("b", null, "Gross Sales Proceeds")
          ], -1)),
          (p(!0), h(A, null, D(e.months, (o) => {
            var l;
            return p(), h("td", u8t, [
              o > ((l = e.flipParams) == null ? void 0 : l.monthsUntilSold) ? (p(), h("b", p8t, g(e.currency(e.grossSalesProceeds(o))), 1)) : P("", !0)
            ]);
          }), 256))
        ])
      ])
    ])
  ]);
}
const m8t = /* @__PURE__ */ Ae(a8t, [["render", h8t]]), f8t = me({
  name: "NetProfitTable",
  computed: {
    months() {
      return [...Array(13).keys()].filter((e) => e > 0);
    },
    ...at(qe),
    ...q(Te, ["access", "aclLoaded"]),
    ...q(qe, ["flipResults", "flipParams", "flipAmortizationSchedule", "flipTotalCashInvested", "flipBridgeCarryingCost"])
  },
  methods: {
    currency: Ze,
    percent: Wt,
    loanPayoff(e) {
      var t, s, n, r, i;
      return ((t = this.flipParams) == null ? void 0 : t.purchaseMethod) == Vt.Cash ? 0 : ((s = this.flipParams) == null ? void 0 : s.purchaseMethod) == Vt.PermanentLoan ? this.propertyStore.flipPayoff(e) : (r = (n = this.flipParams) == null ? void 0 : n.bridgeLoan) != null && r.interestOnly ? (i = this.flipResults) == null ? void 0 : i.bridgeLoanAmount : this.propertyStore.flipPayoff(e);
    },
    grossSalesProceeds(e) {
      var t, s;
      return ((t = this.flipResults) == null ? void 0 : t.afterRepairValue) - ((s = this.flipResults) == null ? void 0 : s.resaleCosts) - this.loanPayoff(e);
    },
    netProfit(e) {
      return this.grossSalesProceeds(e) - this.flipTotalCashInvested - this.flipBridgeCarryingCost * e;
    }
  }
}), g8t = { class: "table-wrap" }, v8t = { class: "table table-sm text-small mode-advanced mlse-net-profit" }, y8t = { class: "mlse-column" }, b8t = { class: "mlse-column" }, A8t = { class: "mlse-column" }, w8t = { class: "mlse-column" }, C8t = { class: "table-total" }, S8t = { class: "mlse-column" }, P8t = { class: "mlse-column" }, k8t = { class: "mlse-column" }, E8t = { class: "table-total" }, I8t = { class: "mlse-column" }, T8t = { class: "mlse-column" }, O8t = { class: "mlse-column" };
function R8t(e, t, s, n, r, i) {
  return p(), h("div", g8t, [
    a("table", v8t, [
      a("thead", null, [
        a("tr", null, [
          t[0] || (t[0] = a("th", null, null, -1)),
          (p(!0), h(A, null, D(e.months, (o) => (p(), h("th", y8t, " Month " + g(o), 1))), 256))
        ])
      ]),
      a("tbody", null, [
        a("tr", null, [
          t[1] || (t[1] = a("th", null, " Sales Price ", -1)),
          (p(!0), h(A, null, D(e.months, (o) => {
            var l, d;
            return p(), h("td", b8t, [
              o > ((l = e.flipParams) == null ? void 0 : l.monthsUntilSold) ? (p(), h(A, { key: 0 }, [
                y(g(e.currency((d = e.flipResults) == null ? void 0 : d.afterRepairValue)), 1)
              ], 64)) : P("", !0)
            ]);
          }), 256))
        ]),
        a("tr", null, [
          t[2] || (t[2] = a("th", null, " Resale Costs ", -1)),
          (p(!0), h(A, null, D(e.months, (o) => {
            var l, d;
            return p(), h("td", A8t, [
              o > ((l = e.flipParams) == null ? void 0 : l.monthsUntilSold) ? (p(), h(A, { key: 0 }, [
                y(g(e.currency((d = e.flipResults) == null ? void 0 : d.resaleCosts)), 1)
              ], 64)) : P("", !0)
            ]);
          }), 256))
        ]),
        a("tr", null, [
          t[3] || (t[3] = a("th", null, " Loan Payoff ", -1)),
          (p(!0), h(A, null, D(e.months, (o) => {
            var l;
            return p(), h("td", w8t, [
              o > ((l = e.flipParams) == null ? void 0 : l.monthsUntilSold) ? (p(), h(A, { key: 0 }, [
                y(g(e.currency(e.loanPayoff(o))), 1)
              ], 64)) : P("", !0)
            ]);
          }), 256))
        ]),
        a("tr", C8t, [
          t[4] || (t[4] = a("th", null, " Gross Sales Proceeds ", -1)),
          (p(!0), h(A, null, D(e.months, (o) => {
            var l;
            return p(), h("td", S8t, [
              o > ((l = e.flipParams) == null ? void 0 : l.monthsUntilSold) ? (p(), h(A, { key: 0 }, [
                y(g(e.currency(e.grossSalesProceeds(o))), 1)
              ], 64)) : P("", !0)
            ]);
          }), 256))
        ]),
        a("tr", null, [
          t[5] || (t[5] = a("th", null, " Less: Initial Investment ", -1)),
          (p(!0), h(A, null, D(e.months, (o) => {
            var l;
            return p(), h("td", P8t, [
              o > ((l = e.flipParams) == null ? void 0 : l.monthsUntilSold) ? (p(), h(A, { key: 0 }, [
                y(g(e.currency(e.flipTotalCashInvested)), 1)
              ], 64)) : P("", !0)
            ]);
          }), 256))
        ]),
        a("tr", null, [
          t[6] || (t[6] = a("th", null, " Less: Cumulative Carrying Costs ", -1)),
          (p(!0), h(A, null, D(e.months, (o) => (p(), h("td", k8t, g(e.currency(e.flipBridgeCarryingCost * o)), 1))), 256))
        ]),
        a("tr", E8t, [
          t[7] || (t[7] = a("th", null, [
            a("b", null, "Net Profit")
          ], -1)),
          (p(!0), h(A, null, D(e.months, (o) => {
            var l;
            return p(), h("td", I8t, [
              o > ((l = e.flipParams) == null ? void 0 : l.monthsUntilSold) ? (p(), h(A, { key: 0 }, [
                y(g(e.currency(e.netProfit(o))), 1)
              ], 64)) : P("", !0)
            ]);
          }), 256))
        ]),
        a("tr", null, [
          t[8] || (t[8] = a("th", null, " Net Profit Per Month ", -1)),
          (p(!0), h(A, null, D(e.months, (o) => {
            var l;
            return p(), h("td", T8t, [
              o > ((l = e.flipParams) == null ? void 0 : l.monthsUntilSold) ? (p(), h(A, { key: 0 }, [
                y(g(e.currency(e.netProfit(o) / o)), 1)
              ], 64)) : P("", !0)
            ]);
          }), 256))
        ]),
        a("tr", null, [
          t[9] || (t[9] = a("th", null, " ROI ", -1)),
          (p(!0), h(A, null, D(e.months, (o) => {
            var l;
            return p(), h("td", O8t, [
              o > ((l = e.flipParams) == null ? void 0 : l.monthsUntilSold) ? (p(), h(A, { key: 0 }, [
                y(g(e.percent(e.netProfit(o) / e.flipTotalCashInvested)), 1)
              ], 64)) : P("", !0)
            ]);
          }), 256))
        ])
      ])
    ])
  ]);
}
const L8t = /* @__PURE__ */ Ae(f8t, [["render", R8t]]), B8t = me({
  name: "Kpis",
  computed: {
    ...q(Te, ["access", "aclLoaded"])
  },
  methods: {
    number: Ve
  }
}), M8t = { class: "d-flex justify-content-between align-items-center h-100" };
function x8t(e, t, s, n, r, i) {
  return p(), h("div", M8t, t[0] || (t[0] = [
    Bt('<div><span class="fa-stack fa-2x"><i class="fa-solid fa-square fa-stack-2x text-eclipse"></i><i class="fa-light fa-hand-holding-dollar fa-stack-1x fa-inverse"></i></span><div class="text-small text-uppercase text-secondary"> Total Investment </div><div class="fw-bold fs-6"> $63,699.00 </div></div><div class="px-2"><i class="fa-light fa-xmark"></i></div><div><span class="fa-stack fa-2x"><i class="fa-solid fa-square fa-stack-2x text-eclipse"></i><i class="fa-light fa-hand-holding-dollar fa-stack-1x fa-inverse"></i></span><div class="text-small text-uppercase text-secondary"> Hold Period </div><div class="fw-bold fs-6"> $63,699.00 </div></div><div class="px-2"><i class="fa-light fa-equals"></i></div><div><span class="fa-stack fa-2x"><i class="fa-solid fa-square fa-stack-2x text-eclipse"></i><i class="fa-light fa-hand-holding-dollar fa-stack-1x fa-inverse"></i></span><div class="text-small text-uppercase text-secondary"> Net Profit </div><div class="fw-bold fs-6"> $63,699.00 </div></div>', 5)
  ]));
}
const F8t = /* @__PURE__ */ Ae(B8t, [["render", x8t]]), V8t = me({
  name: "NetProtfitMiniTable",
  computed: {
    ...at(qe),
    ...q(Te, ["access", "aclLoaded"]),
    ...q(qe, ["flipResults", "flipParams", "flipDispositionMonth", "flipBridgeCarryingCost", "flipTotalCashInvested", "flipProRatedTax", "flipHasBridgeLoan", "flipNetProfit"])
  },
  methods: {
    currency: Ze,
    loanPayoff(e) {
      var t, s, n, r, i;
      return ((t = this.flipParams) == null ? void 0 : t.purchaseMethod) == Vt.Cash ? 0 : ((s = this.flipParams) == null ? void 0 : s.purchaseMethod) == Vt.PermanentLoan ? this.propertyStore.flipPayoff(e) : (r = (n = this.flipParams) == null ? void 0 : n.bridgeLoan) != null && r.interestOnly ? (i = this.flipResults) == null ? void 0 : i.bridgeLoanAmount : this.propertyStore.flipPayoff(e);
    }
  }
}), D8t = { class: "table table-sm" }, N8t = { class: "text-end" }, j8t = { class: "text-end" }, H8t = { key: 0 }, U8t = { class: "text-end" }, z8t = { key: 0 }, W8t = { class: "text-end" }, G8t = { class: "text-end" }, Y8t = { class: "bg-light fw-bold text-end" };
function X8t(e, t, s, n, r, i) {
  var o, l;
  return p(), h("table", D8t, [
    a("tbody", null, [
      a("tr", null, [
        t[0] || (t[0] = a("td", null, " ARV ", -1)),
        a("td", N8t, g(e.currency((o = e.flipResults) == null ? void 0 : o.afterRepairValue)), 1)
      ]),
      a("tr", null, [
        t[1] || (t[1] = a("td", null, " Less: Resale Costs ", -1)),
        a("td", j8t, g(e.currency((l = e.flipResults) == null ? void 0 : l.resaleCosts)), 1)
      ]),
      N(ks, {
        name: "slide",
        mode: "out-in"
      }, {
        default: ve(() => [
          e.flipParams.includeTaxInCashRequired ? P("", !0) : (p(), h("tr", H8t, [
            t[2] || (t[2] = a("td", null, " Less: Pro-Rated Property Tax ", -1)),
            a("td", U8t, g(e.currency(e.flipProRatedTax)), 1)
          ]))
        ]),
        _: 1
      }),
      N(ks, {
        name: "slide",
        mode: "out-in"
      }, {
        default: ve(() => [
          e.flipHasBridgeLoan ? (p(), h("tr", z8t, [
            t[3] || (t[3] = a("td", null, " Less: Loan Payoff ", -1)),
            a("td", W8t, g(e.currency(e.loanPayoff(e.flipDispositionMonth + 1))), 1)
          ])) : P("", !0)
        ]),
        _: 1
      }),
      a("tr", null, [
        t[4] || (t[4] = a("td", null, " Less: Initial Investment ", -1)),
        a("td", G8t, g(e.currency(e.flipTotalCashInvested)), 1)
      ]),
      a("tr", null, [
        t[5] || (t[5] = a("th", { class: "bg-light fw-bold" }, " Net Profit ", -1)),
        a("th", Y8t, g(e.currency(e.flipNetProfit)), 1)
      ])
    ])
  ]);
}
const q8t = /* @__PURE__ */ Ae(V8t, [["render", X8t]]), Q8t = me({
  name: "EditCarryingCosts",
  props: {
    show: Boolean,
    loading: Boolean
  },
  components: {
    NumericalInput: Aa
  },
  emits: [
    "update:show",
    "change"
  ],
  data() {
    return {};
  },
  computed: {
    componentBusy() {
      return this.loading || this.calculating;
    },
    componentBusyAdvanced() {
      return this.loading || this.calculating || this.hasAdvanced != !0;
    },
    allowEmptyParams() {
      var e, t;
      return this.isExistingInvestment == !0 && (((t = (e = this.purchaseFacts) == null ? void 0 : e.years) == null ? void 0 : t.length) ?? 0) > 0;
    },
    //#region Is Percents
    isManagementFeePercent: {
      get() {
        return (this.calcParams.percentageLongTermFields & U.PropertyManagement) == U.PropertyManagement;
      },
      set(e) {
        e ? this.calcParams.percentageLongTermFields |= U.PropertyManagement : this.calcParams.percentageLongTermFields &= ~U.PropertyManagement;
      }
    },
    isLeasingCommissionsPercent: {
      get() {
        return (this.calcParams.percentageLongTermFields & U.LeasingCommissions) == U.LeasingCommissions;
      },
      set(e) {
        e ? this.calcParams.percentageLongTermFields |= U.LeasingCommissions : this.calcParams.percentageLongTermFields &= ~U.LeasingCommissions;
      }
    },
    isLeaseRenewalFeePercent: {
      get() {
        return (this.calcParams.percentageLongTermFields & U.LeaseRenewalFee) == U.LeaseRenewalFee;
      },
      set(e) {
        e ? this.calcParams.percentageLongTermFields |= U.LeaseRenewalFee : this.calcParams.percentageLongTermFields &= ~U.LeaseRenewalFee;
      }
    },
    isPlatformServiceFeesPercent: {
      get() {
        return (this.calcParams.percentageLongTermFields & U.PlatformServiceFees) == U.PlatformServiceFees;
      },
      set(e) {
        e ? this.calcParams.percentageLongTermFields |= U.PlatformServiceFees : this.calcParams.percentageLongTermFields &= ~U.PlatformServiceFees;
      }
    },
    isMaintenancePercent: {
      get() {
        return (this.calcParams.percentageLongTermFields & U.PropertyMaintenance) == U.PropertyMaintenance;
      },
      set(e) {
        e ? this.calcParams.percentageLongTermFields |= U.PropertyMaintenance : this.calcParams.percentageLongTermFields &= ~U.PropertyMaintenance;
      }
    },
    isUtilityExpensesPercent: {
      get() {
        return (this.calcParams.percentageLongTermFields & U.UtilityExpenses) == U.UtilityExpenses;
      },
      set(e) {
        e ? this.calcParams.percentageLongTermFields |= U.UtilityExpenses : this.calcParams.percentageLongTermFields &= ~U.UtilityExpenses;
      }
    },
    isFurnishingExpensesPercent: {
      get() {
        return (this.calcParams.percentageLongTermFields & U.FurnishingExpenses) == U.FurnishingExpenses;
      },
      set(e) {
        e ? this.calcParams.percentageLongTermFields |= U.FurnishingExpenses : this.calcParams.percentageLongTermFields &= ~U.FurnishingExpenses;
      }
    },
    isConsumableExpensesPercent: {
      get() {
        return (this.calcParams.percentageLongTermFields & U.ConsumableExpenses) == U.ConsumableExpenses;
      },
      set(e) {
        e ? this.calcParams.percentageLongTermFields |= U.ConsumableExpenses : this.calcParams.percentageLongTermFields &= ~U.ConsumableExpenses;
      }
    },
    isCleaningExpensesPercent: {
      get() {
        return (this.calcParams.percentageLongTermFields & U.CleaningExpenses) == U.CleaningExpenses;
      },
      set(e) {
        e ? this.calcParams.percentageLongTermFields |= U.CleaningExpenses : this.calcParams.percentageLongTermFields &= ~U.CleaningExpenses;
      }
    },
    isOtherExpensePercent: {
      get() {
        return (this.calcParams.percentageLongTermFields & U.OtherExpense) == U.OtherExpense;
      },
      set(e) {
        e ? this.calcParams.percentageLongTermFields |= U.OtherExpense : this.calcParams.percentageLongTermFields &= ~U.OtherExpense;
      }
    },
    isCapitalExpendituresPercent: {
      get() {
        return (this.calcParams.percentageLongTermFields & U.CapitalExpenditures) == U.CapitalExpenditures;
      },
      set(e) {
        e ? this.calcParams.percentageLongTermFields |= U.CapitalExpenditures : this.calcParams.percentageLongTermFields &= ~U.CapitalExpenditures;
      }
    },
    //#endregion
    //#region Includes
    includePropertyTax: {
      get() {
        return (this.flipParams.carryingCostExpenses & U.PropertyTax) == U.PropertyTax;
      },
      set(e) {
        e ? this.flipParams.carryingCostExpenses |= U.PropertyTax : this.flipParams.carryingCostExpenses &= ~U.PropertyTax;
      }
    },
    includePropertyManagement: {
      get() {
        return (this.flipParams.carryingCostExpenses & U.PropertyManagement) == U.PropertyManagement;
      },
      set(e) {
        e ? this.flipParams.carryingCostExpenses |= U.PropertyManagement : this.flipParams.carryingCostExpenses &= ~U.PropertyManagement;
      }
    },
    includeAssociationFees: {
      get() {
        return (this.flipParams.carryingCostExpenses & U.AssociationFees) == U.AssociationFees;
      },
      set(e) {
        e ? this.flipParams.carryingCostExpenses |= U.AssociationFees : this.flipParams.carryingCostExpenses &= ~U.AssociationFees;
      }
    },
    includePropertyInsurance: {
      get() {
        return (this.flipParams.carryingCostExpenses & U.PropertyInsurance) == U.PropertyInsurance;
      },
      set(e) {
        e ? this.flipParams.carryingCostExpenses |= U.PropertyInsurance : this.flipParams.carryingCostExpenses &= ~U.PropertyInsurance;
      }
    },
    includeLeasingCommissions: {
      get() {
        return (this.flipParams.carryingCostExpenses & U.LeasingCommissions) == U.LeasingCommissions;
      },
      set(e) {
        e ? this.flipParams.carryingCostExpenses |= U.LeasingCommissions : this.flipParams.carryingCostExpenses &= ~U.LeasingCommissions;
      }
    },
    includeLeaseRenewalFee: {
      get() {
        return (this.flipParams.carryingCostExpenses & U.LeaseRenewalFee) == U.LeaseRenewalFee;
      },
      set(e) {
        e ? this.flipParams.carryingCostExpenses |= U.LeaseRenewalFee : this.flipParams.carryingCostExpenses &= ~U.LeaseRenewalFee;
      }
    },
    includePlatformServiceFees: {
      get() {
        return (this.flipParams.carryingCostExpenses & U.PlatformServiceFees) == U.PlatformServiceFees;
      },
      set(e) {
        e ? this.flipParams.carryingCostExpenses |= U.PlatformServiceFees : this.flipParams.carryingCostExpenses &= ~U.PlatformServiceFees;
      }
    },
    includePropertyMaintenance: {
      get() {
        return (this.flipParams.carryingCostExpenses & U.PropertyMaintenance) == U.PropertyMaintenance;
      },
      set(e) {
        e ? this.flipParams.carryingCostExpenses |= U.PropertyMaintenance : this.flipParams.carryingCostExpenses &= ~U.PropertyMaintenance;
      }
    },
    includeUtilityExpenses: {
      get() {
        return (this.flipParams.carryingCostExpenses & U.UtilityExpenses) == U.UtilityExpenses;
      },
      set(e) {
        e ? this.flipParams.carryingCostExpenses |= U.UtilityExpenses : this.flipParams.carryingCostExpenses &= ~U.UtilityExpenses;
      }
    },
    includeFurnishingExpenses: {
      get() {
        return (this.flipParams.carryingCostExpenses & U.FurnishingExpenses) == U.FurnishingExpenses;
      },
      set(e) {
        e ? this.flipParams.carryingCostExpenses |= U.FurnishingExpenses : this.flipParams.carryingCostExpenses &= ~U.FurnishingExpenses;
      }
    },
    includeConsumableExpenses: {
      get() {
        return (this.flipParams.carryingCostExpenses & U.ConsumableExpenses) == U.ConsumableExpenses;
      },
      set(e) {
        e ? this.flipParams.carryingCostExpenses |= U.ConsumableExpenses : this.flipParams.carryingCostExpenses &= ~U.ConsumableExpenses;
      }
    },
    includeCleaningExpenses: {
      get() {
        return (this.flipParams.carryingCostExpenses & U.CleaningExpenses) == U.CleaningExpenses;
      },
      set(e) {
        e ? this.flipParams.carryingCostExpenses |= U.CleaningExpenses : this.flipParams.carryingCostExpenses &= ~U.CleaningExpenses;
      }
    },
    includeOtherExpense: {
      get() {
        return (this.flipParams.carryingCostExpenses & U.OtherExpense) == U.OtherExpense;
      },
      set(e) {
        e ? this.flipParams.carryingCostExpenses |= U.OtherExpense : this.flipParams.carryingCostExpenses &= ~U.OtherExpense;
      }
    },
    //#endregion
    ...at(qe),
    ...q(Te, ["access", "aclLoaded", "hasAdvanced"]),
    ...q(qe, ["calcParams", "calcParamsOrig", "calculating", "isExistingInvestment", "purchaseFacts", "flipParams"]),
    ...q(ct, ["otherExpenseAccounts", "otherNonOperatingExpenseAccounts", "otherIncomeAccounts", "incomeAccounts"]),
    ...q(Ci, ["notifications"])
  },
  watch: {
    show(e) {
      var t, s;
      e ? (t = bootstrap.Modal.getOrCreateInstance(this.$refs.dialogEditCarryingCosts)) == null || t.show() : (s = bootstrap.Modal.getOrCreateInstance(this.$refs.dialogEditCarryingCosts)) == null || s.hide();
    }
  },
  methods: {
    number: Ve,
    currency: Ze,
    detectChange() {
      this.$emit("change");
    },
    accountHasError(e) {
      var t;
      return (t = this.notifications) == null ? void 0 : t.some((s) => s.eventId == _n.IncomeExpenseAccountNotSet && s.properties && s.properties.accountId == e.id);
    },
    isIncluded(e) {
      return this.flipParams.carryingCostOtherExpenses.some((t) => t == e);
    },
    include(e, t) {
      e.target.checked ? this.flipParams.carryingCostOtherExpenses.push(t) : this.flipParams.carryingCostOtherExpenses = this.flipParams.carryingCostOtherExpenses.filter((s) => s != t);
    }
  },
  mounted() {
    var e;
    (e = this.$refs.dialogEditCarryingCosts) == null || e.addEventListener("hide.bs.modal", () => {
      this.$emit("update:show", !1);
    });
  }
}), K8t = {
  class: "modal fade",
  id: "dialogEditCarryingCosts",
  ref: "dialogEditCarryingCosts",
  tabindex: "-1",
  "aria-labelledby": "dialogEditCarryingCostsLabel",
  "aria-hidden": "true"
}, Z8t = { class: "modal-dialog modal-dialog-centered modal-lg" }, J8t = { class: "modal-content bg-gradient-alphabet rounded" }, $8t = { class: "modal-body" }, _8t = { class: "bg-white bg-opacity-50 rounded p-2" }, e4t = { class: "table table-sm table-fixed table-transparent" }, t4t = { class: "d-flex align-items-center justify-content-center ms-lg-5" }, s4t = { class: "form-check form-switch form-switch-lg form-switch-basic" }, a4t = { class: "d-flex align-items-center justify-content-center ms-lg-5" }, n4t = { class: "form-check form-switch form-switch-lg form-switch-basic" }, r4t = { class: "d-flex align-items-center justify-content-center ms-lg-5" }, o4t = { class: "form-check form-switch form-switch-lg form-switch-basic" }, i4t = { class: "text-dark text-opacity-25 text-small faded" }, l4t = { class: "d-flex align-items-center justify-content-center ms-lg-5" }, d4t = { class: "form-check form-switch form-switch-lg form-switch-basic" }, c4t = {
  key: 0,
  class: "faded text-dark text-opacity-25"
}, u4t = { class: "d-flex align-items-center justify-content-center ms-lg-5" }, p4t = { class: "form-check form-switch form-switch-lg form-switch-basic" }, h4t = {
  key: 0,
  class: "faded text-dark text-opacity-25"
}, m4t = { class: "d-flex align-items-center justify-content-center ms-lg-5" }, f4t = { class: "form-check form-switch form-switch-lg form-switch-basic" }, g4t = { class: "d-flex align-items-center justify-content-center ms-lg-5" }, v4t = { class: "form-check form-switch form-switch-lg form-switch-basic" }, y4t = { class: "d-flex align-items-center justify-content-center ms-lg-5" }, b4t = { class: "form-check form-switch form-switch-lg form-switch-basic" }, A4t = { class: "d-flex align-items-center justify-content-center ms-lg-5" }, w4t = { class: "form-check form-switch form-switch-lg form-switch-basic" }, C4t = { class: "d-flex align-items-center justify-content-center ms-lg-5" }, S4t = { class: "form-check form-switch form-switch-lg form-switch-basic" }, P4t = { class: "d-flex align-items-center justify-content-center ms-lg-5" }, k4t = { class: "form-check form-switch form-switch-lg form-switch-basic" }, E4t = { class: "d-flex align-items-center justify-content-center ms-lg-5" }, I4t = { class: "form-check form-switch form-switch-lg form-switch-basic" }, T4t = { class: "d-flex align-items-center justify-content-center ms-lg-5" }, O4t = { class: "form-check form-switch form-switch-lg form-switch-basic" }, R4t = { class: "align-middle" }, L4t = { class: "d-flex align-items-center justify-content-center ms-lg-5" }, B4t = { class: "form-check form-switch form-switch-lg form-switch-basic" }, M4t = ["value", "onChange"];
function x4t(e, t, s, n, r, i) {
  var l, d, c, u, m, f, v, b, w, S, I, T, x;
  const o = pe("numerical-input");
  return p(), h("div", K8t, [
    a("div", Z8t, [
      a("div", J8t, [
        t[66] || (t[66] = a("div", { class: "modal-header border-0 pb-0" }, [
          a("p", {
            class: "modal-title fw-bold fs-5",
            id: "dialogEditCarryingCostsLabel"
          }, "Edit Carrying Costs"),
          a("button", {
            type: "button",
            class: "btn-close",
            "data-bs-dismiss": "modal",
            "aria-label": "Close"
          })
        ], -1)),
        a("div", $8t, [
          t[65] || (t[65] = a("p", null, "Select which expenses apply to your flip during the holding period before the property is sold. While all expenses are automatically included in the BRRRR scenario once the property is rented, some costs (like property management or leasing fees) may not apply during the flip. We've pre-selected the most common expenses for flips, but you can adjust them as needed to fit your specific situation.", -1)),
          a("div", _8t, [
            a("table", e4t, [
              t[64] || (t[64] = a("thead", null, [
                a("tr", null, [
                  a("th"),
                  a("th", { class: "text-center fw-bold" }, " Long Term "),
                  a("th", { class: "text-center fw-bold" }, " Include? ")
                ])
              ], -1)),
              a("tbody", null, [
                a("tr", null, [
                  t[37] || (t[37] = a("td", { class: "align-middle" }, " Property Tax ", -1)),
                  a("td", null, [
                    N(o, {
                      onChange: e.detectChange,
                      modelValue: e.calcParams.propertytax,
                      "onUpdate:modelValue": t[0] || (t[0] = (k) => e.calcParams.propertytax = k),
                      currency: "",
                      "orignal-value": (l = e.calcParamsOrig) == null ? void 0 : l.propertytax,
                      placeholder: "Not Set",
                      "allow-empty": e.allowEmptyParams,
                      disabled: e.componentBusy
                    }, null, 8, ["onChange", "modelValue", "orignal-value", "allow-empty", "disabled"])
                  ]),
                  a("td", null, [
                    a("div", t4t, [
                      a("div", s4t, [
                        V(a("input", {
                          type: "checkbox",
                          class: "form-check-input",
                          id: "autoCalculateSwitch",
                          "onUpdate:modelValue": t[1] || (t[1] = (k) => e.includePropertyTax = k)
                        }, null, 512), [
                          [Ue, e.includePropertyTax]
                        ]),
                        t[36] || (t[36] = a("label", {
                          class: "form-check-label",
                          for: "autoCalculateSwitch"
                        }, [
                          a("span", null, "No"),
                          y("Yes")
                        ], -1))
                      ])
                    ])
                  ])
                ]),
                a("tr", null, [
                  t[39] || (t[39] = a("td", { class: "align-middle" }, " HOA ", -1)),
                  a("td", null, [
                    N(o, {
                      onChange: e.detectChange,
                      modelValue: e.calcParams.associationfee,
                      "onUpdate:modelValue": t[2] || (t[2] = (k) => e.calcParams.associationfee = k),
                      currency: "",
                      "orignal-value": (d = e.calcParamsOrig) == null ? void 0 : d.associationfee,
                      placeholder: "Not Set",
                      "allow-empty": e.allowEmptyParams,
                      disabled: e.componentBusy
                    }, null, 8, ["onChange", "modelValue", "orignal-value", "allow-empty", "disabled"])
                  ]),
                  a("td", null, [
                    a("div", a4t, [
                      a("div", n4t, [
                        V(a("input", {
                          type: "checkbox",
                          class: "form-check-input",
                          id: "autoCalculateSwitch",
                          "onUpdate:modelValue": t[3] || (t[3] = (k) => e.includeAssociationFees = k)
                        }, null, 512), [
                          [Ue, e.includeAssociationFees]
                        ]),
                        t[38] || (t[38] = a("label", {
                          class: "form-check-label",
                          for: "autoCalculateSwitch"
                        }, [
                          a("span", null, "No"),
                          y("Yes")
                        ], -1))
                      ])
                    ])
                  ])
                ]),
                a("tr", null, [
                  t[41] || (t[41] = a("td", { class: "align-middle" }, " Property Insurance ", -1)),
                  a("td", null, [
                    N(o, {
                      onChange: e.detectChange,
                      modelValue: e.calcParams.propertyinsurance,
                      "onUpdate:modelValue": t[4] || (t[4] = (k) => e.calcParams.propertyinsurance = k),
                      currency: "",
                      "orignal-value": (c = e.calcParamsOrig) == null ? void 0 : c.propertyinsurance,
                      placeholder: "Not Set",
                      "allow-empty": e.allowEmptyParams,
                      disabled: e.componentBusy
                    }, null, 8, ["onChange", "modelValue", "orignal-value", "allow-empty", "disabled"])
                  ]),
                  a("td", null, [
                    a("div", r4t, [
                      a("div", o4t, [
                        V(a("input", {
                          type: "checkbox",
                          class: "form-check-input",
                          id: "autoCalculateSwitch",
                          "onUpdate:modelValue": t[5] || (t[5] = (k) => e.includePropertyInsurance = k)
                        }, null, 512), [
                          [Ue, e.includePropertyInsurance]
                        ]),
                        t[40] || (t[40] = a("label", {
                          class: "form-check-label",
                          for: "autoCalculateSwitch"
                        }, [
                          a("span", null, "No"),
                          y("Yes")
                        ], -1))
                      ])
                    ])
                  ])
                ]),
                a("tr", null, [
                  t[43] || (t[43] = a("td", { class: "align-middle" }, " Property Management ", -1)),
                  a("td", null, [
                    N(o, {
                      onChange: e.detectChange,
                      modelValue: e.calcParams.managementfee,
                      "onUpdate:modelValue": t[6] || (t[6] = (k) => e.calcParams.managementfee = k),
                      percent: e.isManagementFeePercent,
                      "onUpdate:percent": t[7] || (t[7] = (k) => e.isManagementFeePercent = k),
                      "orignal-value": (u = e.calcParamsOrig) == null ? void 0 : u.managementfee,
                      placeholder: "Not Set",
                      "optional-type": "",
                      "allow-empty": e.allowEmptyParams,
                      disabled: e.componentBusyAdvanced
                    }, null, 8, ["onChange", "modelValue", "percent", "orignal-value", "allow-empty", "disabled"]),
                    a("span", i4t, [
                      e.isManagementFeePercent ? (p(), h(A, { key: 0 }, [
                        y(" (% of one month's rent) ")
                      ], 64)) : (p(), h(A, { key: 1 }, [
                        y(" (Monthly fee while occupied) ")
                      ], 64))
                    ])
                  ]),
                  a("td", null, [
                    a("div", l4t, [
                      a("div", d4t, [
                        V(a("input", {
                          type: "checkbox",
                          class: "form-check-input",
                          id: "autoCalculateSwitch",
                          "onUpdate:modelValue": t[8] || (t[8] = (k) => e.includePropertyManagement = k)
                        }, null, 512), [
                          [Ue, e.includePropertyManagement]
                        ]),
                        t[42] || (t[42] = a("label", {
                          class: "form-check-label",
                          for: "autoCalculateSwitch"
                        }, [
                          a("span", null, "No"),
                          y("Yes")
                        ], -1))
                      ])
                    ])
                  ])
                ]),
                a("tr", null, [
                  t[45] || (t[45] = a("td", { class: "align-middle" }, " Lease Commission ", -1)),
                  a("td", null, [
                    N(o, {
                      onChange: e.detectChange,
                      modelValue: e.calcParams.leasecommission,
                      "onUpdate:modelValue": t[9] || (t[9] = (k) => e.calcParams.leasecommission = k),
                      "optional-type": "",
                      percent: e.isLeasingCommissionsPercent,
                      "onUpdate:percent": t[10] || (t[10] = (k) => e.isLeasingCommissionsPercent = k),
                      "orignal-value": (m = e.calcParamsOrig) == null ? void 0 : m.leasecommission,
                      placeholder: "Not Set",
                      "allow-empty": e.allowEmptyParams,
                      disabled: e.componentBusyAdvanced
                    }, null, 8, ["onChange", "modelValue", "percent", "orignal-value", "allow-empty", "disabled"]),
                    e.isLeasingCommissionsPercent ? (p(), h("span", c4t, "(one months rent)")) : P("", !0)
                  ]),
                  a("td", null, [
                    a("div", u4t, [
                      a("div", p4t, [
                        V(a("input", {
                          type: "checkbox",
                          class: "form-check-input",
                          id: "autoCalculateSwitch",
                          "onUpdate:modelValue": t[11] || (t[11] = (k) => e.includeLeasingCommissions = k)
                        }, null, 512), [
                          [Ue, e.includeLeasingCommissions]
                        ]),
                        t[44] || (t[44] = a("label", {
                          class: "form-check-label",
                          for: "autoCalculateSwitch"
                        }, [
                          a("span", null, "No"),
                          y("Yes")
                        ], -1))
                      ])
                    ])
                  ])
                ]),
                a("tr", null, [
                  t[47] || (t[47] = a("td", { class: "align-middle" }, " Lease Renewal Fee ", -1)),
                  a("td", null, [
                    N(o, {
                      onChange: e.detectChange,
                      modelValue: e.calcParams.leaserenewalfee,
                      "onUpdate:modelValue": t[12] || (t[12] = (k) => e.calcParams.leaserenewalfee = k),
                      "optional-type": "",
                      percent: e.isLeaseRenewalFeePercent,
                      "onUpdate:percent": t[13] || (t[13] = (k) => e.isLeaseRenewalFeePercent = k),
                      "orignal-value": (f = e.calcParamsOrig) == null ? void 0 : f.leaserenewalfee,
                      placeholder: "Not Set",
                      "allow-empty": e.allowEmptyParams,
                      disabled: e.componentBusyAdvanced
                    }, null, 8, ["onChange", "modelValue", "percent", "orignal-value", "allow-empty", "disabled"]),
                    e.isLeaseRenewalFeePercent ? (p(), h("span", h4t, "(one months rent)")) : P("", !0)
                  ]),
                  a("td", null, [
                    a("div", m4t, [
                      a("div", f4t, [
                        V(a("input", {
                          type: "checkbox",
                          class: "form-check-input",
                          id: "autoCalculateSwitch",
                          "onUpdate:modelValue": t[14] || (t[14] = (k) => e.includeLeaseRenewalFee = k)
                        }, null, 512), [
                          [Ue, e.includeLeaseRenewalFee]
                        ]),
                        t[46] || (t[46] = a("label", {
                          class: "form-check-label",
                          for: "autoCalculateSwitch"
                        }, [
                          a("span", null, "No"),
                          y("Yes")
                        ], -1))
                      ])
                    ])
                  ])
                ]),
                a("tr", null, [
                  t[49] || (t[49] = a("td", { class: "align-middle" }, " Platform Services Fees ", -1)),
                  a("td", null, [
                    N(o, {
                      onChange: e.detectChange,
                      modelValue: e.calcParams.platformServiceFees,
                      "onUpdate:modelValue": t[15] || (t[15] = (k) => e.calcParams.platformServiceFees = k),
                      "optional-type": "",
                      percent: e.isPlatformServiceFeesPercent,
                      "onUpdate:percent": t[16] || (t[16] = (k) => e.isPlatformServiceFeesPercent = k),
                      "orignal-value": (v = e.calcParamsOrig) == null ? void 0 : v.platformServiceFees,
                      placeholder: "Not Set",
                      "allow-empty": e.allowEmptyParams,
                      disabled: e.componentBusyAdvanced
                    }, null, 8, ["onChange", "modelValue", "percent", "orignal-value", "allow-empty", "disabled"])
                  ]),
                  a("td", null, [
                    a("div", g4t, [
                      a("div", v4t, [
                        V(a("input", {
                          type: "checkbox",
                          class: "form-check-input",
                          id: "autoCalculateSwitch",
                          "onUpdate:modelValue": t[17] || (t[17] = (k) => e.includePlatformServiceFees = k)
                        }, null, 512), [
                          [Ue, e.includePlatformServiceFees]
                        ]),
                        t[48] || (t[48] = a("label", {
                          class: "form-check-label",
                          for: "autoCalculateSwitch"
                        }, [
                          a("span", null, "No"),
                          y("Yes")
                        ], -1))
                      ])
                    ])
                  ])
                ]),
                a("tr", null, [
                  t[51] || (t[51] = a("td", { class: "align-middle" }, [
                    y(" Property Maintenance"),
                    a("br"),
                    a("span", { class: "text-dark text-opacity-25 text-small" }, "(% of Gross Income)")
                  ], -1)),
                  a("td", null, [
                    N(o, {
                      onChange: e.detectChange,
                      modelValue: e.calcParams.maintenance,
                      "onUpdate:modelValue": t[18] || (t[18] = (k) => e.calcParams.maintenance = k),
                      "optional-type": "",
                      percent: e.isMaintenancePercent,
                      "onUpdate:percent": t[19] || (t[19] = (k) => e.isMaintenancePercent = k),
                      "orignal-value": (b = e.calcParamsOrig) == null ? void 0 : b.maintenance,
                      placeholder: "Not Set",
                      "allow-empty": e.allowEmptyParams,
                      disabled: e.componentBusyAdvanced
                    }, null, 8, ["onChange", "modelValue", "percent", "orignal-value", "allow-empty", "disabled"])
                  ]),
                  a("td", null, [
                    a("div", y4t, [
                      a("div", b4t, [
                        V(a("input", {
                          type: "checkbox",
                          class: "form-check-input",
                          id: "autoCalculateSwitch",
                          "onUpdate:modelValue": t[20] || (t[20] = (k) => e.includePropertyMaintenance = k)
                        }, null, 512), [
                          [Ue, e.includePropertyMaintenance]
                        ]),
                        t[50] || (t[50] = a("label", {
                          class: "form-check-label",
                          for: "autoCalculateSwitch"
                        }, [
                          a("span", null, "No"),
                          y("Yes")
                        ], -1))
                      ])
                    ])
                  ])
                ]),
                a("tr", null, [
                  t[53] || (t[53] = a("td", { class: "align-middle" }, " Utility Expenses ", -1)),
                  a("td", null, [
                    N(o, {
                      onChange: e.detectChange,
                      modelValue: e.calcParams.utilityExpenses,
                      "onUpdate:modelValue": t[21] || (t[21] = (k) => e.calcParams.utilityExpenses = k),
                      "optional-type": "",
                      percent: e.isUtilityExpensesPercent,
                      "onUpdate:percent": t[22] || (t[22] = (k) => e.isUtilityExpensesPercent = k),
                      "orignal-value": (w = e.calcParamsOrig) == null ? void 0 : w.utilityExpenses,
                      placeholder: "Not Set",
                      "allow-empty": e.allowEmptyParams,
                      disabled: e.componentBusy
                    }, null, 8, ["onChange", "modelValue", "percent", "orignal-value", "allow-empty", "disabled"])
                  ]),
                  a("td", null, [
                    a("div", A4t, [
                      a("div", w4t, [
                        V(a("input", {
                          type: "checkbox",
                          class: "form-check-input",
                          id: "autoCalculateSwitch",
                          "onUpdate:modelValue": t[23] || (t[23] = (k) => e.includeUtilityExpenses = k)
                        }, null, 512), [
                          [Ue, e.includeUtilityExpenses]
                        ]),
                        t[52] || (t[52] = a("label", {
                          class: "form-check-label",
                          for: "autoCalculateSwitch"
                        }, [
                          a("span", null, "No"),
                          y("Yes")
                        ], -1))
                      ])
                    ])
                  ])
                ]),
                a("tr", null, [
                  t[55] || (t[55] = a("td", { class: "align-middle" }, " Furnishing Expenses ", -1)),
                  a("td", null, [
                    N(o, {
                      onChange: e.detectChange,
                      modelValue: e.calcParams.furnishingExpenses,
                      "onUpdate:modelValue": t[24] || (t[24] = (k) => e.calcParams.furnishingExpenses = k),
                      "optional-type": "",
                      percent: e.isFurnishingExpensesPercent,
                      "onUpdate:percent": t[25] || (t[25] = (k) => e.isFurnishingExpensesPercent = k),
                      "orignal-value": (S = e.calcParamsOrig) == null ? void 0 : S.furnishingExpenses,
                      placeholder: "Not Set",
                      "allow-empty": e.allowEmptyParams,
                      disabled: e.componentBusy
                    }, null, 8, ["onChange", "modelValue", "percent", "orignal-value", "allow-empty", "disabled"])
                  ]),
                  a("td", null, [
                    a("div", C4t, [
                      a("div", S4t, [
                        V(a("input", {
                          type: "checkbox",
                          class: "form-check-input",
                          id: "autoCalculateSwitch",
                          "onUpdate:modelValue": t[26] || (t[26] = (k) => e.includeFurnishingExpenses = k)
                        }, null, 512), [
                          [Ue, e.includeFurnishingExpenses]
                        ]),
                        t[54] || (t[54] = a("label", {
                          class: "form-check-label",
                          for: "autoCalculateSwitch"
                        }, [
                          a("span", null, "No"),
                          y("Yes")
                        ], -1))
                      ])
                    ])
                  ])
                ]),
                a("tr", null, [
                  t[57] || (t[57] = a("td", { class: "align-middle" }, " Consumable Expenses ", -1)),
                  a("td", null, [
                    N(o, {
                      onChange: e.detectChange,
                      modelValue: e.calcParams.consumableExpenses,
                      "onUpdate:modelValue": t[27] || (t[27] = (k) => e.calcParams.consumableExpenses = k),
                      "optional-type": "",
                      percent: e.isConsumableExpensesPercent,
                      "onUpdate:percent": t[28] || (t[28] = (k) => e.isConsumableExpensesPercent = k),
                      "orignal-value": (I = e.calcParamsOrig) == null ? void 0 : I.consumableExpenses,
                      placeholder: "Not Set",
                      "allow-empty": e.allowEmptyParams,
                      disabled: e.componentBusy
                    }, null, 8, ["onChange", "modelValue", "percent", "orignal-value", "allow-empty", "disabled"])
                  ]),
                  a("td", null, [
                    a("div", P4t, [
                      a("div", k4t, [
                        V(a("input", {
                          type: "checkbox",
                          class: "form-check-input",
                          id: "autoCalculateSwitch",
                          "onUpdate:modelValue": t[29] || (t[29] = (k) => e.includeConsumableExpenses = k)
                        }, null, 512), [
                          [Ue, e.includeConsumableExpenses]
                        ]),
                        t[56] || (t[56] = a("label", {
                          class: "form-check-label",
                          for: "autoCalculateSwitch"
                        }, [
                          a("span", null, "No"),
                          y("Yes")
                        ], -1))
                      ])
                    ])
                  ])
                ]),
                a("tr", null, [
                  t[59] || (t[59] = a("td", { class: "align-middle" }, " Cleaning Expenses ", -1)),
                  a("td", null, [
                    N(o, {
                      onChange: e.detectChange,
                      modelValue: e.calcParams.cleaningExpenses,
                      "onUpdate:modelValue": t[30] || (t[30] = (k) => e.calcParams.cleaningExpenses = k),
                      "optional-type": "",
                      percent: e.isCleaningExpensesPercent,
                      "onUpdate:percent": t[31] || (t[31] = (k) => e.isCleaningExpensesPercent = k),
                      "orignal-value": (T = e.calcParamsOrig) == null ? void 0 : T.cleaningExpenses,
                      placeholder: "Not Set",
                      "allow-empty": e.allowEmptyParams,
                      disabled: e.componentBusy
                    }, null, 8, ["onChange", "modelValue", "percent", "orignal-value", "allow-empty", "disabled"])
                  ]),
                  a("td", null, [
                    a("div", E4t, [
                      a("div", I4t, [
                        V(a("input", {
                          type: "checkbox",
                          class: "form-check-input",
                          id: "autoCalculateSwitch",
                          "onUpdate:modelValue": t[32] || (t[32] = (k) => e.includeCleaningExpenses = k)
                        }, null, 512), [
                          [Ue, e.includeCleaningExpenses]
                        ]),
                        t[58] || (t[58] = a("label", {
                          class: "form-check-label",
                          for: "autoCalculateSwitch"
                        }, [
                          a("span", null, "No"),
                          y("Yes")
                        ], -1))
                      ])
                    ])
                  ])
                ]),
                a("tr", null, [
                  t[61] || (t[61] = a("td", { class: "align-middle" }, " Other Expenses ", -1)),
                  a("td", null, [
                    N(o, {
                      onChange: e.detectChange,
                      modelValue: e.calcParams.otherExpense,
                      "onUpdate:modelValue": t[33] || (t[33] = (k) => e.calcParams.otherExpense = k),
                      "optional-type": "",
                      percent: e.isOtherExpensePercent,
                      "onUpdate:percent": t[34] || (t[34] = (k) => e.isOtherExpensePercent = k),
                      "orignal-value": (x = e.calcParamsOrig) == null ? void 0 : x.otherExpense,
                      placeholder: "Not Set",
                      "allow-empty": e.allowEmptyParams,
                      disabled: e.componentBusy
                    }, null, 8, ["onChange", "modelValue", "percent", "orignal-value", "allow-empty", "disabled"])
                  ]),
                  a("td", null, [
                    a("div", T4t, [
                      a("div", O4t, [
                        V(a("input", {
                          type: "checkbox",
                          class: "form-check-input",
                          id: "autoCalculateSwitch",
                          "onUpdate:modelValue": t[35] || (t[35] = (k) => e.includeOtherExpense = k)
                        }, null, 512), [
                          [Ue, e.includeOtherExpense]
                        ]),
                        t[60] || (t[60] = a("label", {
                          class: "form-check-label",
                          for: "autoCalculateSwitch"
                        }, [
                          a("span", null, "No"),
                          y("Yes")
                        ], -1))
                      ])
                    ])
                  ])
                ]),
                t[63] || (t[63] = a("tr", null, [
                  a("th", {
                    class: "align-middle",
                    colspan: "3"
                  }, [
                    a("b", null, "Other Custom Expenses")
                  ])
                ], -1)),
                e.calcParams.otherExpenses && e.otherExpenseAccounts ? (p(!0), h(A, { key: 0 }, D(e.otherExpenseAccounts, (k) => {
                  var C;
                  return p(), h("tr", {
                    class: z({ "has-error": e.accountHasError(k) })
                  }, [
                    a("td", R4t, g(k.name), 1),
                    a("td", null, [
                      N(o, {
                        onChange: e.detectChange,
                        modelValue: e.calcParams.otherExpenses.longTerm.find((O) => O.id == k.id).total,
                        "onUpdate:modelValue": (O) => e.calcParams.otherExpenses.longTerm.find((E) => E.id == k.id).total = O,
                        percent: e.calcParams.otherExpenses.longTerm.find((O) => O.id == k.id).percentage,
                        "onUpdate:percent": (O) => e.calcParams.otherExpenses.longTerm.find((E) => E.id == k.id).percentage = O,
                        "orignal-value": (C = e.calcParamsOrig) == null ? void 0 : C.otherExpenses.longTerm.find((O) => O.id == k.id).total,
                        disabled: e.componentBusy,
                        "allow-empty": e.allowEmptyParams,
                        placeholder: "Not Set",
                        "optional-type": ""
                      }, null, 8, ["onChange", "modelValue", "onUpdate:modelValue", "percent", "onUpdate:percent", "orignal-value", "disabled", "allow-empty"])
                    ]),
                    a("td", null, [
                      a("div", L4t, [
                        a("div", B4t, [
                          a("input", {
                            type: "checkbox",
                            class: "form-check-input",
                            id: "autoCalculateSwitch",
                            value: e.isIncluded(k.id),
                            onChange: (O) => e.include(O, k.id)
                          }, null, 40, M4t),
                          t[62] || (t[62] = a("label", {
                            class: "form-check-label",
                            for: "autoCalculateSwitch"
                          }, [
                            a("span", null, "No"),
                            y("Yes")
                          ], -1))
                        ])
                      ])
                    ])
                  ], 2);
                }), 256)) : P("", !0)
              ])
            ])
          ])
        ])
      ])
    ])
  ], 512);
}
const IE = /* @__PURE__ */ Ae(Q8t, [["render", x4t]]), F4t = me({
  name: "PurchaseMethod",
  props: {},
  components: {
    NumericalInput: Aa,
    EditCarryingCosts: IE
  },
  data() {
    return {
      isPurchaseLoan: !1,
      showCarryingCostsDialog: !1
    };
  },
  computed: {
    isCashPurchase: {
      get() {
        return this.flipParams.purchaseMethod == Vt.Cash;
      },
      set(e) {
        e && (this.flipParams.purchaseMethod = Vt.Cash);
      }
    },
    isPermanentLoan: {
      get() {
        return this.flipParams.purchaseMethod == Vt.PermanentLoan;
      },
      set(e) {
        e && (this.flipParams.purchaseMethod = Vt.PermanentLoan);
      }
    },
    isBridgeLoan: {
      get() {
        return this.flipParams.purchaseMethod == Vt.BridgeToPermanentLoan;
      },
      set(e) {
        e && (this.flipParams.purchaseMethod = Vt.BridgeToPermanentLoan);
      }
    },
    isRenovationCostSquareFootage: {
      get() {
        return this.flipParams.renovationCostMethod == $p.PerSquareFoot;
      },
      set(e) {
        e ? this.flipParams.renovationCostMethod = $p.PerSquareFoot : this.flipParams.renovationCostMethod = $p.TotalCost;
      }
    },
    hasLoan() {
      return this.flipParams.purchaseMethod == Vt.PermanentLoan || this.flipParams.purchaseMethod == Vt.BridgeToPermanentLoan;
    },
    ...at(qe),
    ...q(Te, ["access", "aclLoaded"]),
    ...q(qe, ["flipParams", "calcParams", "calcParamsOrig", "calculating", "flipResults", "flipHasBridgeLoan", "flipLoanPayment"])
  },
  watch: {
    "flipParams.purchaseMethod"(e) {
      e == Vt.CashToPermanentLoan && (this.flipParams.cashOutIfPossible = !0);
    }
  },
  methods: {
    number: Ve,
    currency: Ze,
    async calculate() {
      try {
        this.propertyStore.forceUpdateValues(), this.propertyStore.setHasChanges(), await this.propertyStore.calculate();
      } catch (e) {
        Se(e);
      }
    },
    loanAmountChange() {
      this.propertyStore.recalculateDownpaymentPercentage();
    },
    editCarryingCosts() {
      this.showCarryingCostsDialog = !0;
    }
  }
}), V4t = { class: "d-flex justify-content-center align-items-center gap-2 mb-3 flex-column flex-lg-row" }, D4t = { class: "d-flex gap-2" }, N4t = {
  class: "btn-group",
  role: "group",
  "aria-label": "Basic checkbox toggle button group"
}, j4t = ["disabled"], H4t = ["disabled"], U4t = ["disabled"], z4t = ["disabled"], W4t = { class: "row row-cols-1 row-cols-md-2 g-3" }, G4t = { class: "col" }, Y4t = { class: "card bg-light h-100" }, X4t = { class: "card-body" }, q4t = { class: "row g-2" }, Q4t = { class: "col-sm-5" }, K4t = { class: "col-sm-7 col-form-label" }, Z4t = { class: "form-check form-switch form-switch-double form-switch-sm form-switch-persf" }, J4t = ["disabled"], $4t = { class: "col-sm-5" }, _4t = { class: "col-sm-5" }, ekt = { class: "col-sm-4 d-flex align-items-center justify-content-end justify-content-xxl-center" }, tkt = { class: "form-check form-switch form-switch-lg form-switch-basic" }, skt = ["disabled"], akt = { class: "col-12 text-body-secondary text-small px-lg-0" }, nkt = { class: "col" }, rkt = { class: "card bg-light h-100" }, okt = { class: "card-body" }, ikt = { class: "row g-2" }, lkt = { class: "col-sm-5" }, dkt = { class: "col-sm-5" }, ckt = { class: "col-sm-5" }, ukt = {
  key: 0,
  class: "col"
}, pkt = { class: "card bg-alice h-100" }, hkt = { class: "card-body" }, mkt = { class: "row g-2" }, fkt = { class: "col-sm-5 d-flex align-items-center justify-content-end justify-content-xxl-center" }, gkt = { class: "form-check form-switch form-switch-lg form-switch-basic" }, vkt = ["disabled"], ykt = {
  key: 0,
  class: "row g-2"
}, bkt = { class: "col-sm-5" }, Akt = { class: "col-sm-5 d-flex align-items-center justify-content-end justify-content-xxl-center" }, wkt = { class: "form-check form-switch form-switch-lg form-switch-basic" }, Ckt = ["disabled"], Skt = { class: "col-sm-5 d-flex align-items-center justify-content-end justify-content-xxl-center" }, Pkt = { class: "form-check form-switch form-switch-lg form-switch-basic" }, kkt = ["disabled"], Ekt = { class: "col-sm-5 d-flex align-items-center justify-content-end justify-content-xxl-center" }, Ikt = { class: "form-check form-switch form-switch-lg form-switch-basic" }, Tkt = ["disabled"], Okt = { class: "col-sm-5 text-end form-control-plaintext" }, Rkt = {
  key: 1,
  class: "row g-2"
}, Lkt = { class: "col-sm-5" }, Bkt = {
  key: 0,
  class: "col"
}, Mkt = { class: "card bg-light h-100" }, xkt = { class: "card-body" }, Fkt = { class: "row g-2" }, Vkt = { class: "col-sm-5" }, Dkt = { class: "col-sm-5 d-flex align-items-center justify-content-end justify-content-xxl-center" }, Nkt = { class: "form-check form-switch form-switch-lg form-switch-basic" }, jkt = ["disabled"], Hkt = { class: "col-sm-5" }, Ukt = ["disabled"], zkt = ["value"], Wkt = { class: "col-sm-5" }, Gkt = ["disabled"], Ykt = ["value"], Xkt = { class: "col-sm-5" }, qkt = { class: "col-sm-5 text-end form-control-plaintext" }, Qkt = {
  key: 0,
  class: "col"
}, Kkt = { class: "card bg-light h-100" }, Zkt = { class: "card-body" }, Jkt = { class: "row g-2" }, $kt = { class: "col-sm-5" }, _kt = { class: "col-sm-5 d-flex align-items-center justify-content-end justify-content-xxl-center" }, e5t = { class: "form-check form-switch form-switch-lg form-switch-basic" }, t5t = ["disabled"], s5t = { class: "col-sm-5" }, a5t = ["disabled"], n5t = ["value"], r5t = { class: "col-sm-5" }, o5t = { class: "col-sm-5" }, i5t = { class: "col-sm-5 text-end form-control-plaintext" };
function l5t(e, t, s, n, r, i) {
  const o = pe("numerical-input"), l = pe("edit-carrying-costs"), d = Za("has-changed");
  return p(), h(A, null, [
    a("div", V4t, [
      t[50] || (t[50] = a("div", { class: "fw-bold me-lg-2" }, " Acquisition Method: ", -1)),
      a("div", D4t, [
        a("div", N4t, [
          V(a("input", {
            type: "radio",
            class: "btn-check",
            name: "options",
            id: "CashPurchase",
            autocomplete: "off",
            value: "cash",
            "onUpdate:modelValue": t[0] || (t[0] = (c) => e.flipParams.purchaseMethod = c),
            onChange: t[1] || (t[1] = (...c) => e.calculate && e.calculate(...c)),
            disabled: e.calculating
          }, null, 40, j4t), [
            [Mt, e.flipParams.purchaseMethod]
          ]),
          t[46] || (t[46] = a("label", {
            class: "btn btn-sm btn-outline-eclipse no-anim",
            for: "CashPurchase"
          }, "Cash", -1)),
          V(a("input", {
            type: "radio",
            class: "btn-check",
            name: "options",
            id: "CashPermanent",
            autocomplete: "off",
            value: "cash-to-permanent-loan",
            "onUpdate:modelValue": t[2] || (t[2] = (c) => e.flipParams.purchaseMethod = c),
            onChange: t[3] || (t[3] = (...c) => e.calculate && e.calculate(...c)),
            disabled: e.calculating
          }, null, 40, H4t), [
            [Mt, e.flipParams.purchaseMethod]
          ]),
          t[47] || (t[47] = a("label", {
            class: "btn btn-sm btn-outline-eclipse no-anim",
            for: "CashPermanent"
          }, "Cash to Permanent", -1)),
          V(a("input", {
            type: "radio",
            class: "btn-check",
            name: "options",
            id: "BridgeLoan",
            autocomplete: "off",
            value: "bridge-to-permanent-loan",
            "onUpdate:modelValue": t[4] || (t[4] = (c) => e.flipParams.purchaseMethod = c),
            onChange: t[5] || (t[5] = (...c) => e.calculate && e.calculate(...c)),
            disabled: e.calculating
          }, null, 40, U4t), [
            [Mt, e.flipParams.purchaseMethod]
          ]),
          t[48] || (t[48] = a("label", {
            class: "btn btn-sm btn-outline-eclipse no-anim",
            for: "BridgeLoan"
          }, "Bridge to Permanent", -1)),
          V(a("input", {
            type: "radio",
            class: "btn-check",
            name: "options",
            id: "PermanentLoan",
            autocomplete: "off",
            value: "permanent-loan",
            "onUpdate:modelValue": t[6] || (t[6] = (c) => e.flipParams.purchaseMethod = c),
            onChange: t[7] || (t[7] = (...c) => e.calculate && e.calculate(...c)),
            disabled: e.calculating
          }, null, 40, z4t), [
            [Mt, e.flipParams.purchaseMethod]
          ]),
          t[49] || (t[49] = a("label", {
            class: "btn btn-sm btn-outline-eclipse no-anim",
            for: "PermanentLoan"
          }, "Permanent Loan", -1))
        ])
      ])
    ]),
    a("div", W4t, [
      a("div", G4t, [
        a("div", Y4t, [
          t[58] || (t[58] = a("div", { class: "card-header bg-eclipse text-white rounded rounded-bottom-0 fw-bold text-center text-sm-start" }, " ACQUISITION AND PROJECT COST ", -1)),
          a("div", X4t, [
            a("div", q4t, [
              t[55] || (t[55] = a("label", { class: "col-sm-7 col-form-label" }, "Purchase Price", -1)),
              a("div", Q4t, [
                N(o, {
                  currency: "",
                  modelValue: e.calcParams.purchaseprice,
                  "onUpdate:modelValue": t[8] || (t[8] = (c) => e.calcParams.purchaseprice = c),
                  onChange: e.calculate,
                  disabled: e.calculating
                }, null, 8, ["modelValue", "onChange", "disabled"])
              ]),
              a("label", K4t, [
                t[52] || (t[52] = y(" Renovation Cost ")),
                a("div", Z4t, [
                  V(a("input", {
                    class: "form-check-input",
                    type: "checkbox",
                    role: "switch",
                    id: "flexSwitchCheckDefault",
                    "onUpdate:modelValue": t[9] || (t[9] = (c) => e.isRenovationCostSquareFootage = c),
                    onChange: t[10] || (t[10] = (...c) => e.calculate && e.calculate(...c)),
                    disabled: e.calculating
                  }, null, 40, J4t), [
                    [Ue, e.isRenovationCostSquareFootage]
                  ]),
                  t[51] || (t[51] = a("label", {
                    class: "form-check-label",
                    for: "flexSwitchCheckDefault"
                  }, [
                    y("Per SF"),
                    a("span", null, "Total Cost")
                  ], -1))
                ])
              ]),
              a("div", $4t, [
                N(o, {
                  currency: "",
                  modelValue: e.flipParams.renovationCost,
                  "onUpdate:modelValue": t[11] || (t[11] = (c) => e.flipParams.renovationCost = c),
                  onChange: e.calculate,
                  disabled: e.calculating
                }, null, 8, ["modelValue", "onChange", "disabled"])
              ]),
              t[56] || (t[56] = a("label", { class: "col-sm-7 col-form-label" }, "Acquisition Closing Costs", -1)),
              a("div", _4t, [
                N(o, {
                  currency: "",
                  modelValue: e.calcParams.titlecharges,
                  "onUpdate:modelValue": t[12] || (t[12] = (c) => e.calcParams.titlecharges = c),
                  onChange: e.calculate,
                  disabled: e.calculating
                }, null, 8, ["modelValue", "onChange", "disabled"])
              ]),
              t[57] || (t[57] = a("label", { class: "col-sm-8 col-form-label" }, "Include Pro-Rated Property Tax in Cash Required?", -1)),
              a("div", ekt, [
                a("div", tkt, [
                  V(a("input", {
                    type: "checkbox",
                    class: "form-check-input",
                    id: "taxSwitch",
                    "onUpdate:modelValue": t[13] || (t[13] = (c) => e.flipParams.includeTaxInCashRequired = c),
                    onChange: t[14] || (t[14] = (...c) => e.calculate && e.calculate(...c)),
                    disabled: e.calculating
                  }, null, 40, skt), [
                    [Ue, e.flipParams.includeTaxInCashRequired]
                  ]),
                  t[53] || (t[53] = a("label", {
                    class: "form-check-label",
                    for: "taxSwitch"
                  }, [
                    a("span", null, "No"),
                    y("Yes")
                  ], -1))
                ])
              ]),
              a("div", akt, [
                t[54] || (t[54] = y(" * Monthly carrying costs include operating expenses from parameters tab. ")),
                a("a", {
                  href: "#",
                  onClick: t[15] || (t[15] = (...c) => e.editCarryingCosts && e.editCarryingCosts(...c)),
                  class: "text-info pe-auto"
                }, "Edit Carrying Costs")
              ])
            ])
          ])
        ])
      ]),
      a("div", nkt, [
        a("div", rkt, [
          t[62] || (t[62] = a("div", { class: "card-header bg-eclipse text-white rounded rounded-bottom-0 fw-bold text-center text-sm-start" }, " REHAB & DISPOSITION TIME FRAME ", -1)),
          a("div", okt, [
            a("div", ikt, [
              t[59] || (t[59] = a("label", { class: "col-sm-7 col-form-label" }, "After Repair Value", -1)),
              a("div", lkt, [
                N(o, {
                  currency: "",
                  modelValue: e.flipParams.afterRepairValue,
                  "onUpdate:modelValue": t[16] || (t[16] = (c) => e.flipParams.afterRepairValue = c),
                  onChange: e.calculate,
                  disabled: e.calculating
                }, null, 8, ["modelValue", "onChange", "disabled"])
              ]),
              t[60] || (t[60] = a("label", { class: "col-sm-7 col-form-label" }, "Estimated Rehab/Sale Time Frame (months)", -1)),
              a("div", dkt, [
                N(o, {
                  modelValue: e.flipParams.monthsUntilSold,
                  "onUpdate:modelValue": t[17] || (t[17] = (c) => e.flipParams.monthsUntilSold = c),
                  onChange: e.calculate,
                  disabled: e.calculating
                }, null, 8, ["modelValue", "onChange", "disabled"])
              ]),
              t[61] || (t[61] = a("label", { class: "col-sm-7 col-form-label" }, "Disposition Closing Costs", -1)),
              a("div", ckt, [
                N(o, {
                  percent: "",
                  modelValue: e.calcParams.costofsale,
                  "onUpdate:modelValue": t[18] || (t[18] = (c) => e.calcParams.costofsale = c),
                  onChange: e.calculate,
                  disabled: e.calculating
                }, null, 8, ["modelValue", "onChange", "disabled"])
              ])
            ])
          ])
        ])
      ]),
      e.hasLoan ? (p(), h("div", ukt, [
        a("div", pkt, [
          t[74] || (t[74] = a("div", { class: "card-header bg-eclipse text-white rounded rounded-bottom-0 fw-bold text-center text-sm-start" }, " LOAN AMOUNT ", -1)),
          a("div", hkt, [
            a("div", mkt, [
              t[64] || (t[64] = a("label", { class: "col-sm-7 col-form-label" }, "Auto Calculate Loan Amount?", -1)),
              a("div", fkt, [
                a("div", gkt, [
                  V(a("input", {
                    type: "checkbox",
                    class: "form-check-input",
                    id: "autoCalculateSwitch",
                    "onUpdate:modelValue": t[19] || (t[19] = (c) => e.flipParams.autoCalculateLoanAmount = c),
                    onChange: t[20] || (t[20] = (...c) => e.calculate && e.calculate(...c)),
                    disabled: e.calculating
                  }, null, 40, vkt), [
                    [Ue, e.flipParams.autoCalculateLoanAmount]
                  ]),
                  t[63] || (t[63] = a("label", {
                    class: "form-check-label",
                    for: "autoCalculateSwitch"
                  }, [
                    a("span", null, "No"),
                    y("Yes")
                  ], -1))
                ])
              ])
            ]),
            N(ks, {
              name: "slide",
              mode: "out-in"
            }, {
              default: ve(() => {
                var c;
                return [
                  e.flipParams.autoCalculateLoanAmount ? (p(), h("div", ykt, [
                    t[68] || (t[68] = a("label", { class: "col-sm-7 col-form-label" }, "Loan to Price Limit (LTP)", -1)),
                    a("div", bkt, [
                      N(o, {
                        percent: "",
                        modelValue: e.flipParams.loanToPriceLimit,
                        "onUpdate:modelValue": t[21] || (t[21] = (u) => e.flipParams.loanToPriceLimit = u),
                        onChange: e.calculate,
                        disabled: e.calculating
                      }, null, 8, ["modelValue", "onChange", "disabled"])
                    ]),
                    t[69] || (t[69] = a("label", { class: "col-sm-7 col-form-label" }, "Include Acquisition Closing Costs", -1)),
                    a("div", Akt, [
                      a("div", wkt, [
                        V(a("input", {
                          type: "checkbox",
                          class: "form-check-input",
                          id: "autoCalculateSwitch",
                          "onUpdate:modelValue": t[22] || (t[22] = (u) => e.flipParams.includeAcquisitionClosingCosts = u),
                          onChange: t[23] || (t[23] = (...u) => e.calculate && e.calculate(...u)),
                          disabled: e.calculating
                        }, null, 40, Ckt), [
                          [Ue, e.flipParams.includeAcquisitionClosingCosts]
                        ]),
                        t[65] || (t[65] = a("label", {
                          class: "form-check-label",
                          for: "autoCalculateSwitch"
                        }, [
                          a("span", null, "No"),
                          y("Yes")
                        ], -1))
                      ])
                    ]),
                    t[70] || (t[70] = a("label", { class: "col-sm-7 col-form-label" }, "Include Rehab", -1)),
                    a("div", Skt, [
                      a("div", Pkt, [
                        V(a("input", {
                          type: "checkbox",
                          class: "form-check-input",
                          id: "autoCalculateSwitch",
                          "onUpdate:modelValue": t[24] || (t[24] = (u) => e.flipParams.includeRehab = u),
                          onChange: t[25] || (t[25] = (...u) => e.calculate && e.calculate(...u)),
                          disabled: e.calculating
                        }, null, 40, kkt), [
                          [Ue, e.flipParams.includeRehab]
                        ]),
                        t[66] || (t[66] = a("label", {
                          class: "form-check-label",
                          for: "autoCalculateSwitch"
                        }, [
                          a("span", null, "No"),
                          y("Yes")
                        ], -1))
                      ])
                    ]),
                    t[71] || (t[71] = a("label", { class: "col-sm-7 col-form-label" }, "Include Loan Fees", -1)),
                    a("div", Ekt, [
                      a("div", Ikt, [
                        V(a("input", {
                          type: "checkbox",
                          class: "form-check-input",
                          id: "autoCalculateSwitch",
                          "onUpdate:modelValue": t[26] || (t[26] = (u) => e.flipParams.includeLoanFees = u),
                          onChange: t[27] || (t[27] = (...u) => e.calculate && e.calculate(...u)),
                          disabled: e.calculating
                        }, null, 40, Tkt), [
                          [Ue, e.flipParams.includeLoanFees]
                        ]),
                        t[67] || (t[67] = a("label", {
                          class: "form-check-label",
                          for: "autoCalculateSwitch"
                        }, [
                          a("span", null, "No"),
                          y("Yes")
                        ], -1))
                      ])
                    ]),
                    t[72] || (t[72] = a("label", { class: "col-sm-7 col-form-label" }, "Loan Amount", -1)),
                    a("div", Okt, [
                      a("b", null, g(e.currency((c = e.flipResults) == null ? void 0 : c.bridgeLoanAmount)), 1)
                    ])
                  ])) : (p(), h("div", Rkt, [
                    t[73] || (t[73] = a("label", { class: "col-sm-7 col-form-label" }, "Loan Amount", -1)),
                    a("div", Lkt, [
                      e.flipHasBridgeLoan ? (p(), Fe(o, {
                        key: 0,
                        currency: "",
                        modelValue: e.flipParams.bridgeLoan.loanAmount,
                        "onUpdate:modelValue": t[28] || (t[28] = (u) => e.flipParams.bridgeLoan.loanAmount = u),
                        onChange: e.calculate,
                        disabled: e.calculating
                      }, null, 8, ["modelValue", "onChange", "disabled"])) : (p(), Fe(o, {
                        key: 1,
                        currency: "",
                        modelValue: e.flipParams.permanentLoan.loanAmount,
                        "onUpdate:modelValue": t[29] || (t[29] = (u) => e.flipParams.permanentLoan.loanAmount = u),
                        onChange: e.calculate,
                        disabled: e.calculating
                      }, null, 8, ["modelValue", "onChange", "disabled"]))
                    ])
                  ]))
                ];
              }),
              _: 1
            })
          ])
        ])
      ])) : P("", !0),
      N(ks, {
        name: "slide",
        mode: "out-in"
      }, {
        default: ve(() => {
          var c, u;
          return [
            e.isPermanentLoan ? (p(), h("div", Bkt, [
              a("div", Mkt, [
                t[83] || (t[83] = a("div", { class: "card-header bg-eclipse text-white rounded rounded-bottom-0 fw-bold text-center text-sm-start" }, " PERMANENT LOAN ", -1)),
                a("div", xkt, [
                  a("div", Fkt, [
                    t[78] || (t[78] = a("label", { class: "col-sm-7 col-form-label" }, "Interest Rate %", -1)),
                    a("div", Vkt, [
                      N(o, {
                        percent: "",
                        modelValue: e.calcParams.interestrate,
                        "onUpdate:modelValue": t[30] || (t[30] = (m) => e.calcParams.interestrate = m),
                        "orignal-value": (c = e.calcParamsOrig) == null ? void 0 : c.interestrate,
                        onChange: e.calculate,
                        disabled: e.calculating
                      }, null, 8, ["modelValue", "orignal-value", "onChange", "disabled"])
                    ]),
                    t[79] || (t[79] = a("label", { class: "col-sm-7 col-form-label" }, "Interest Only Loan?", -1)),
                    a("div", Dkt, [
                      a("div", Nkt, [
                        V(a("input", {
                          type: "checkbox",
                          "onUpdate:modelValue": t[31] || (t[31] = (m) => e.calcParams.interestOnlyLoan = m),
                          onChange: t[32] || (t[32] = (...m) => e.calculate && e.calculate(...m)),
                          disabled: e.calculating,
                          class: "form-check-input",
                          id: "iolSwitch"
                        }, null, 40, jkt), [
                          [Ue, e.calcParams.interestOnlyLoan],
                          [d, "calcParams.interestOnlyLoan"]
                        ]),
                        t[75] || (t[75] = a("label", {
                          class: "form-check-label",
                          for: "iolSwitch"
                        }, [
                          a("span", null, "No"),
                          y("Yes")
                        ], -1))
                      ])
                    ]),
                    t[80] || (t[80] = a("label", { class: "col-sm-7 col-form-label" }, "Amortization Period", -1)),
                    a("div", Hkt, [
                      V(a("select", {
                        class: "form-select",
                        "onUpdate:modelValue": t[33] || (t[33] = (m) => e.calcParams.loanterm = m),
                        onChange: t[34] || (t[34] = (...m) => e.calculate && e.calculate(...m)),
                        disabled: e.calculating
                      }, [
                        (p(), h(A, null, D(30, (m) => a("option", { value: m }, g(m) + " Years", 9, zkt)), 64))
                      ], 40, Ukt), [
                        [We, e.calcParams.loanterm]
                      ])
                    ]),
                    e.calcParams.interestOnlyLoan ? (p(), h(A, { key: 0 }, [
                      t[77] || (t[77] = a("label", { class: "col-sm-7 col-form-label" }, "Loan Term (Months)", -1)),
                      a("div", Wkt, [
                        V((p(), h("select", {
                          "onUpdate:modelValue": t[35] || (t[35] = (m) => e.calcParams.interestOnlyTerm = m),
                          class: "form-select",
                          onChange: t[36] || (t[36] = (...m) => e.calculate && e.calculate(...m)),
                          disabled: e.calculating
                        }, [
                          t[76] || (t[76] = a("option", { value: 360 }, "Full Term", -1)),
                          (p(), h(A, null, D([3, 6, 9, 12, 18, 24, 36, 48, 60, 72, 84, 96, 108, 120], (m) => a("option", { value: m }, g(m) + " Months", 9, Ykt)), 64))
                        ], 40, Gkt)), [
                          [We, e.calcParams.interestOnlyTerm],
                          [d, "calcParams.interestOnlyTerm"]
                        ])
                      ])
                    ], 64)) : P("", !0),
                    t[81] || (t[81] = a("label", { class: "col-sm-7 col-form-label" }, "Loan Fees", -1)),
                    a("div", Xkt, [
                      N(o, {
                        percent: "",
                        modelValue: e.calcParams.loanfees,
                        "onUpdate:modelValue": t[37] || (t[37] = (m) => e.calcParams.loanfees = m),
                        "orignal-value": (u = e.calcParamsOrig) == null ? void 0 : u.loanfees,
                        onChange: e.calculate,
                        disabled: e.calculating
                      }, null, 8, ["modelValue", "orignal-value", "onChange", "disabled"])
                    ]),
                    t[82] || (t[82] = a("label", { class: "col-sm-7 col-form-label" }, "Loan Payment", -1)),
                    a("div", qkt, [
                      a("b", null, g(e.currency(e.flipLoanPayment)), 1)
                    ])
                  ])
                ])
              ])
            ])) : P("", !0)
          ];
        }),
        _: 1
      }),
      N(ks, {
        name: "slide",
        mode: "out-in"
      }, {
        default: ve(() => {
          var c, u;
          return [
            e.isBridgeLoan ? (p(), h("div", Qkt, [
              a("div", Kkt, [
                t[91] || (t[91] = a("div", { class: "card-header bg-eclipse text-white rounded rounded-bottom-0 fw-bold text-center text-sm-start" }, " BRIDGE LOAN ", -1)),
                a("div", Zkt, [
                  a("div", Jkt, [
                    t[86] || (t[86] = a("label", { class: "col-sm-7 col-form-label" }, "Interest Rate %", -1)),
                    a("div", $kt, [
                      N(o, {
                        percent: "",
                        modelValue: e.flipParams.bridgeLoan.interestRate,
                        "onUpdate:modelValue": t[38] || (t[38] = (m) => e.flipParams.bridgeLoan.interestRate = m),
                        onChange: e.calculate,
                        disabled: e.calculating
                      }, null, 8, ["modelValue", "onChange", "disabled"])
                    ]),
                    t[87] || (t[87] = a("label", { class: "col-sm-7 col-form-label" }, "Interest Only Loan?", -1)),
                    a("div", _kt, [
                      a("div", e5t, [
                        V(a("input", {
                          type: "checkbox",
                          "onUpdate:modelValue": t[39] || (t[39] = (m) => e.flipParams.bridgeLoan.interestOnly = m),
                          class: "form-check-input",
                          id: "iolSwitch",
                          onChange: t[40] || (t[40] = (...m) => e.calculate && e.calculate(...m)),
                          disabled: e.calculating
                        }, null, 40, t5t), [
                          [Ue, e.flipParams.bridgeLoan.interestOnly]
                        ]),
                        t[84] || (t[84] = a("label", {
                          class: "form-check-label",
                          for: "iolSwitch"
                        }, [
                          a("span", null, "No"),
                          y("Yes")
                        ], -1))
                      ])
                    ]),
                    (u = (c = e.flipParams) == null ? void 0 : c.bridgeLoan) != null && u.interestOnly ? P("", !0) : (p(), h(A, { key: 0 }, [
                      t[85] || (t[85] = a("label", { class: "col-sm-7 col-form-label" }, "Amortization Period", -1)),
                      a("div", s5t, [
                        V(a("select", {
                          class: "form-select",
                          "onUpdate:modelValue": t[41] || (t[41] = (m) => e.flipParams.bridgeLoan.amortizationYears = m),
                          onChange: t[42] || (t[42] = (...m) => e.calculate && e.calculate(...m)),
                          disabled: e.calculating
                        }, [
                          (p(), h(A, null, D(30, (m) => a("option", { value: m }, g(m) + " Years", 9, n5t)), 64))
                        ], 40, a5t), [
                          [We, e.flipParams.bridgeLoan.amortizationYears]
                        ])
                      ])
                    ], 64)),
                    t[88] || (t[88] = a("label", { class: "col-sm-7 col-form-label" }, "Loan Term (Months)", -1)),
                    a("div", r5t, [
                      N(o, {
                        modelValue: e.flipParams.bridgeLoan.loanTerm,
                        "onUpdate:modelValue": t[43] || (t[43] = (m) => e.flipParams.bridgeLoan.loanTerm = m),
                        onChange: e.calculate,
                        disabled: e.calculating
                      }, null, 8, ["modelValue", "onChange", "disabled"])
                    ]),
                    t[89] || (t[89] = a("label", { class: "col-sm-7 col-form-label" }, "Loan Fees", -1)),
                    a("div", o5t, [
                      N(o, {
                        percent: "",
                        modelValue: e.flipParams.bridgeLoan.loanFees,
                        "onUpdate:modelValue": t[44] || (t[44] = (m) => e.flipParams.bridgeLoan.loanFees = m),
                        onChange: e.calculate,
                        disabled: e.calculating
                      }, null, 8, ["modelValue", "onChange", "disabled"])
                    ]),
                    t[90] || (t[90] = a("label", { class: "col-sm-7 col-form-label" }, "Loan Payment", -1)),
                    a("div", i5t, [
                      a("b", null, g(e.currency(e.flipLoanPayment)), 1)
                    ])
                  ])
                ])
              ])
            ])) : P("", !0)
          ];
        }),
        _: 1
      })
    ]),
    N(l, {
      show: e.showCarryingCostsDialog,
      "onUpdate:show": t[45] || (t[45] = (c) => e.showCarryingCostsDialog = c)
    }, null, 8, ["show"])
  ], 64);
}
const d5t = /* @__PURE__ */ Ae(F4t, [["render", l5t]]), c5t = me({
  name: "FlipTab",
  components: {
    NetProfit: K3t,
    CostArv: s8t,
    GrossSalesProceeds: m8t,
    NetProfitTable: L8t,
    Kpis: F8t,
    InitialInvestment: Zu,
    NetProfitMiniTable: q8t,
    PurchaseMethod: d5t
  },
  computed: {
    ...at(qe),
    ...q(Te, ["access", "aclLoaded"]),
    ...q(qe, ["flipResults", "flipParams", "flipTotalCosts", "calculatedResults", "flipDispositionMonth", "flipBridgeCarryingCost", "flipTotalCashInvested", "flipNetProfit"])
  },
  methods: {
    currency: Ze,
    loanPayoff(e) {
      var t, s, n, r, i;
      return ((t = this.flipParams) == null ? void 0 : t.purchaseMethod) == Vt.Cash ? 0 : ((s = this.flipParams) == null ? void 0 : s.purchaseMethod) == Vt.PermanentLoan ? this.propertyStore.flipPayoff(e) : (r = (n = this.flipParams) == null ? void 0 : n.bridgeLoan) != null && r.interestOnly ? (i = this.flipResults) == null ? void 0 : i.bridgeLoanAmount : this.propertyStore.flipPayoff(e);
    }
  }
}), u5t = { class: "container-xl" }, p5t = { class: "row g-3" }, h5t = { class: "col-lg-4 d-flex flex-column flex-md-row flex-xl-column gap-3" }, m5t = { class: "card shadow-sm flex-fill" }, f5t = { class: "col-lg-8" }, g5t = { class: "card shadow-sm" }, v5t = { class: "card-body" }, y5t = { class: "col-12" }, b5t = { class: "card shadow-sm" }, A5t = { class: "card-body p-0 position-relative overflow-hidden" };
function w5t(e, t, s, n, r, i) {
  pe("net-profit"), pe("cost-arv"), pe("kpis");
  const o = pe("initial-investment"), l = pe("net-profit-mini-table"), d = pe("purchase-method"), c = pe("net-profit-table");
  return p(), h("div", u5t, [
    a("div", p5t, [
      P("", !0),
      a("div", h5t, [
        N(o),
        a("div", m5t, [
          t[0] || (t[0] = a("div", { class: "card-header bg-eclipse text-white rounded rounded-bottom-0 fw-bold text-center text-sm-start" }, " NET PROFIT ", -1)),
          N(l)
        ])
      ]),
      a("div", f5t, [
        a("div", g5t, [
          a("div", v5t, [
            N(d)
          ])
        ])
      ]),
      a("div", y5t, [
        a("div", b5t, [
          t[1] || (t[1] = a("div", { class: "card-header bg-eclipse text-white rounded rounded-bottom-0 fw-bold text-center text-sm-start" }, " NET PROFIT - FLIP ONLY ", -1)),
          a("div", A5t, [
            N(c)
          ])
        ])
      ])
    ])
  ]);
}
const ids = /* @__PURE__ */ Ae(c5t, [["render", w5t]]), uo = 1e3, C5t = "#DADADA", S5t = me({
  name: "AnnualCashFlow",
  props: {},
  components: {},
  data() {
    return {
      chartData: void 0
    };
  },
  computed: {
    ...q(Te, ["access", "aclLoaded"])
  },
  methods: {
    number: Ve,
    initCharts(e) {
      const t = {
        type: "bar",
        data: {
          labels: [18, 19, 20, 21, 22, 23, 24],
          datasets: [
            {
              label: "Annual Cash Flow",
              data: [0 * uo, 1 * uo, 2 * uo, 3 * uo, 4 * uo, 5 * uo, 6 * uo, 7 * uo, 8 * uo],
              backgroundColor: C5t
            }
          ]
        },
        options: {
          responsive: !0,
          maintainAspectRatio: !0,
          plugins: {
            title: {
              display: !1,
              text: "Income & Expenses"
            },
            legend: {
              display: !1,
              position: "bottom",
              maxHeight: 100,
              labels: {
                boxWidth: 10
              }
            },
            tooltip: {
              mode: "index",
              intersect: !1,
              callbacks: {
                label: function(s) {
                  let n = s.dataset.label;
                  const r = ": " + Ze(s.dataset.data[s.dataIndex]);
                  return n += r, n;
                }
              }
            }
          },
          scales: {
            y: {
              beginAtZero: !0,
              ticks: {
                callback: function(s, n, r) {
                  return Ze(s);
                }
              }
            }
          }
        }
      };
      this.financialCharts.ineChart = new Rt(this.$refs.chart1, t);
    },
    showFinancialAnalysisTab(e) {
      e.target.dataset.bsTarget == "#financial-flip-rent" && this.initCharts(!0);
    }
  },
  created() {
    this.financialCharts = {};
  },
  mounted() {
    document.addEventListener("shown.bs.tab", this.showFinancialAnalysisTab);
  }
}), P5t = {
  "data-id": "chart1",
  class: "ineChart",
  id: "chart1",
  ref: "chart1",
  height: "200"
};
function k5t(e, t, s, n, r, i) {
  return p(), h(A, null, [
    t[0] || (t[0] = a("div", { class: "text-center mb-3" }, " Annual Cash Flow ", -1)),
    a("canvas", P5t, null, 512)
  ], 64);
}
const E5t = /* @__PURE__ */ Ae(S5t, [["render", k5t]]), mS = "#DADADA", I5t = me({
  name: "Net Equity",
  props: {},
  components: {},
  data() {
    return {
      chartData: void 0
    };
  },
  computed: {
    ...q(Te, ["access", "aclLoaded"])
  },
  methods: {
    number: Ve,
    initCharts() {
      let e = {
        type: "line",
        data: {
          labels: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
          datasets: [{
            label: "IRR",
            data: [0, 0, 24e-4, 0.052, 0.0647, 0.0828, 0.0859, 0.0943, 0.0945, 0.0988],
            type: "line",
            backgroundColor: mS,
            borderColor: mS,
            borderWidth: 1,
            pointRadius: 1,
            fill: !1,
            tension: 0.4
          }]
        },
        options: {
          responsive: !0,
          maintainAspectRatio: !0,
          plugins: {
            title: {
              display: !1,
              text: "Internal Rate of Return"
            },
            legend: {
              display: !1,
              position: "bottom",
              maxHeight: 100,
              labels: {
                boxWidth: 10
              }
            },
            tooltip: {
              mode: "index",
              intersect: !1,
              callbacks: {
                label: function(t) {
                  let s = t.dataset.label;
                  const n = ": " + Wt(t.dataset.data[t.dataIndex], 1);
                  return s += n, s;
                }
              }
            }
          },
          scales: {
            y: {
              stacked: !1,
              beginAtZero: !0,
              ticks: {
                callback: function(t, s, n) {
                  return Wt(t);
                }
              }
            }
          }
        }
      };
      this.financialCharts.cocChart = new Rt(this.$refs.cocChart, e);
    },
    showFinancialAnalysisTab(e) {
      e.target.dataset.bsTarget == "#financial-flip-rent" && this.initCharts();
    }
  },
  created() {
    this.financialCharts = {};
  },
  mounted() {
    document.addEventListener("shown.bs.tab", this.showFinancialAnalysisTab);
  }
}), T5t = {
  "data-id": "cocChart",
  id: "cocChart",
  ref: "cocChart",
  height: "188"
};
function O5t(e, t, s, n, r, i) {
  return p(), h(A, null, [
    t[0] || (t[0] = a("div", { class: "text-center mb-3" }, " Return of Investment ", -1)),
    a("canvas", T5t, null, 512),
    t[1] || (t[1] = Bt('<ul class="list-inline chart-legend text-center"><li class="list-inline-item"><span class="coc"></span>Cash on Cash </li><li class="list-inline-item"><span class="re"></span>Return on Equity </li></ul>', 1))
  ], 64);
}
const R5t = /* @__PURE__ */ Ae(I5t, [["render", O5t]]), po = 1e3, L5t = "#DADADA", B5t = me({
  name: "NetEquity",
  props: {},
  components: {},
  data() {
    return {
      chartData: void 0
    };
  },
  computed: {
    ...q(Te, ["access", "aclLoaded"])
  },
  methods: {
    number: Ve,
    initCharts() {
      const e = {
        type: "bar",
        data: {
          labels: [18, 19, 20, 21, 22, 23, 24],
          datasets: [
            {
              label: "Net Equity",
              data: [0 * po, 1 * po, 2 * po, 3 * po, 4 * po, 5 * po, 6 * po, 7 * po, 8 * po],
              backgroundColor: L5t
            }
          ]
        },
        options: {
          responsive: !0,
          maintainAspectRatio: !0,
          plugins: {
            title: {
              display: !1,
              text: "Income & Expenses"
            },
            legend: {
              display: !1,
              position: "bottom",
              maxHeight: 100,
              labels: {
                boxWidth: 10
              }
            },
            tooltip: {
              mode: "index",
              intersect: !1,
              callbacks: {
                label: function(t) {
                  let s = t.dataset.label;
                  const n = ": " + Ze(t.dataset.data[t.dataIndex]);
                  return s += n, s;
                }
              }
            }
          },
          scales: {
            y: {
              beginAtZero: !0,
              ticks: {
                callback: function(t) {
                  return Ze(t);
                }
              }
            }
          }
        }
      };
      this.financialCharts.ineChart = new Rt(this.$refs.chart1, e);
    },
    showFinancialAnalysisTab(e) {
      e.target.dataset.bsTarget == "#financial-flip-rent" && this.initCharts();
    }
  },
  created() {
    this.financialCharts = {};
  },
  mounted() {
    document.addEventListener("shown.bs.tab", this.showFinancialAnalysisTab);
  }
}), M5t = {
  "data-id": "chart1",
  class: "ineChart",
  id: "chart1",
  ref: "chart1",
  height: "200"
};
function x5t(e, t, s, n, r, i) {
  return p(), h(A, null, [
    t[0] || (t[0] = a("div", { class: "text-center mb-3" }, " Net Equity ", -1)),
    a("canvas", M5t, null, 512)
  ], 64);
}
const F5t = /* @__PURE__ */ Ae(B5t, [["render", x5t]]), V5t = me({
  name: "FinanceMethod",
  props: {},
  components: {
    NumericalInput: Aa,
    EditCarryingCosts: IE
  },
  data() {
    return {
      showCarryingCostsDialog: !1
    };
  },
  watch: {
    "calcParams.monthlyRentalYear1"(e) {
      this.flipParams.afterRepairRentPrice = e;
    }
  },
  computed: {
    isMaxLTVLoanAmount: {
      get() {
        return this.flipParams.permanentLoan.loanAmountMethod == Jp.MaxLtv;
      },
      set(e) {
        e ? this.flipParams.permanentLoan.loanAmountMethod = Jp.MaxLtv : this.flipParams.permanentLoan.loanAmountMethod = Jp.Fixed;
      }
    },
    financingOptionsLocked() {
      return this.flipParams.purchaseMethod == Vt.PermanentLoan;
    },
    acquisitionMethod() {
      var e;
      switch ((e = this.flipParams) == null ? void 0 : e.purchaseMethod) {
        case Vt.BridgeToPermanentLoan:
          return "Bridge to Permanent";
        case Vt.Cash:
          return "Cash";
        case Vt.CashToPermanentLoan:
          return "Cash to Permanent";
        case Vt.PermanentLoan:
          return "Permanent Laon";
      }
      return "N/A";
    },
    hasLoan() {
      return this.flipParams.purchaseMethod == Vt.PermanentLoan || this.flipParams.purchaseMethod == Vt.CashToPermanentLoan || this.flipParams.purchaseMethod == Vt.BridgeToPermanentLoan;
    },
    editLoan() {
      return this.flipParams.purchaseMethod == Vt.CashToPermanentLoan || this.flipParams.purchaseMethod == Vt.BridgeToPermanentLoan;
    },
    isCash() {
      var e;
      return ((e = this.flipParams) == null ? void 0 : e.purchaseMethod) == Vt.Cash;
    },
    isBridgeToPermanentLoan() {
      var e;
      return ((e = this.flipParams) == null ? void 0 : e.purchaseMethod) == Vt.BridgeToPermanentLoan;
    },
    isCashToPermanent() {
      var e;
      return ((e = this.flipParams) == null ? void 0 : e.purchaseMethod) == Vt.CashToPermanentLoan;
    },
    isPermanentLoan() {
      var e;
      return ((e = this.flipParams) == null ? void 0 : e.purchaseMethod) == Vt.PermanentLoan;
    },
    ...at(qe),
    ...q(Te, ["access", "aclLoaded"]),
    ...q(qe, ["flipParams", "calcParams", "calcParamsOrig", "flipResults", "calculating"])
  },
  methods: {
    currency: Ze,
    percent: Wt,
    async calculate() {
      try {
        this.propertyStore.forceUpdateValues(), await this.propertyStore.calculate();
      } catch (e) {
        Se(e);
      }
    },
    editCarryingCosts() {
      this.showCarryingCostsDialog = !0;
    }
  }
}), D5t = { class: "d-flex justify-content-center align-items-center gap-2 mb-3 flex-column flex-lg-row" }, N5t = { class: "fw-bold me-lg-2" }, j5t = { class: "row row-cols-1 row-cols-md-2 g-3" }, H5t = { class: "col" }, U5t = { class: "card bg-alice h-100" }, z5t = { class: "card-body" }, W5t = { class: "row g-2" }, G5t = { class: "col-sm-5" }, Y5t = { class: "col-sm-5" }, X5t = { class: "col-12 form-text" }, q5t = { class: "col" }, Q5t = {
  key: 0,
  class: "card bg-light h-100"
}, K5t = { class: "card-body" }, Z5t = { class: "row g-2" }, J5t = { class: "col-sm-5" }, $5t = { class: "col-5 col-lg-7 d-flex justify-content-end" }, _5t = { class: "form-check form-switch form-switch-double form-switch-lg form-switch-maxltv align-items-center d-flex" }, eEt = ["disabled"], tEt = { class: "col-sm-5" }, sEt = { class: "col-sm-5 d-flex justify-content-end" }, aEt = { class: "form-check form-switch form-switch-basic form-switch-lg" }, nEt = ["disabled"], rEt = { class: "col-5" }, oEt = {
  key: 1,
  class: "form-control-plaintext text-end"
}, iEt = {
  key: 0,
  class: "col-lg-12"
}, lEt = { class: "card bg-light h-100" }, dEt = { class: "card-body" }, cEt = { class: "row row-cols-1 row-cols-lg-2" }, uEt = { class: "col" }, pEt = { class: "row g-2 mb-sm-2 mb-lg-0" }, hEt = { class: "col-5" }, mEt = { key: 1 }, fEt = { class: "col-5 d-flex align-items-center justify-content-end" }, gEt = {
  key: 0,
  class: "form-check form-switch form-switch-lg form-switch-basic"
}, vEt = ["disabled"], yEt = { key: 1 }, bEt = { class: "col-5" }, AEt = ["disabled"], wEt = ["value"], CEt = { class: "col-5" }, SEt = { key: 1 }, PEt = { class: "col" }, kEt = { class: "row g-2" }, EEt = { class: "col-5" }, IEt = ["disabled"], TEt = ["value"], OEt = { key: 1 };
function REt(e, t, s, n, r, i) {
  var c, u, m, f;
  const o = pe("numerical-input"), l = pe("edit-carrying-costs"), d = Za("has-changed");
  return p(), h(A, null, [
    a("div", D5t, [
      a("div", N5t, " Acquisition Method: " + g(e.acquisitionMethod), 1)
    ]),
    a("div", j5t, [
      a("div", H5t, [
        a("div", U5t, [
          t[22] || (t[22] = a("div", { class: "card-header bg-eclipse text-white rounded rounded-bottom-0 fw-bold text-center text-sm-start" }, " REHAB & VACANCY TIME FRAME ", -1)),
          a("div", z5t, [
            a("div", W5t, [
              t[20] || (t[20] = a("label", { class: "col-sm-7 col-form-label" }, "Estimated Rehab/Vacancy Time Frame (months)", -1)),
              a("div", G5t, [
                N(o, {
                  class: "text-end",
                  modelValue: e.flipParams.monthsUntilRent,
                  "onUpdate:modelValue": t[0] || (t[0] = (v) => e.flipParams.monthsUntilRent = v),
                  onChange: e.calculate,
                  disabled: e.calculating
                }, null, 8, ["modelValue", "onChange", "disabled"])
              ]),
              t[21] || (t[21] = a("label", { class: "col-sm-7 col-form-label" }, "After Repair Rental Rate", -1)),
              a("div", Y5t, [
                N(o, {
                  currency: "",
                  modelValue: e.calcParams.monthlyRentalYear1,
                  "onUpdate:modelValue": t[1] || (t[1] = (v) => e.calcParams.monthlyRentalYear1 = v),
                  onChange: e.calculate,
                  disabled: e.calculating
                }, null, 8, ["modelValue", "onChange", "disabled"])
              ]),
              a("div", X5t, [
                t[19] || (t[19] = y(" * Monthly carrying costs include operating expenses from Parameters tab. ")),
                a("a", {
                  href: "#",
                  onClick: t[2] || (t[2] = (...v) => e.editCarryingCosts && e.editCarryingCosts(...v)),
                  class: "text-info pe-auto"
                }, "Edit Carrying Costs")
              ])
            ])
          ])
        ])
      ]),
      a("div", q5t, [
        e.isBridgeToPermanentLoan || e.isCashToPermanent ? (p(), h("div", Q5t, [
          t[30] || (t[30] = a("div", { class: "card-header bg-eclipse text-white rounded rounded-bottom-0 fw-bold text-center text-sm-start" }, " REFI TIME FRAME & LOAN AMOUNT ", -1)),
          a("div", K5t, [
            a("div", Z5t, [
              t[25] || (t[25] = a("label", { class: "col-sm-7 col-form-label" }, "Months Until Refinance", -1)),
              a("div", J5t, [
                N(o, {
                  class: "text-end",
                  modelValue: e.flipParams.monthsUntilRefinance,
                  "onUpdate:modelValue": t[3] || (t[3] = (v) => e.flipParams.monthsUntilRefinance = v),
                  onChange: e.calculate,
                  disabled: e.calculating
                }, null, 8, ["modelValue", "onChange", "disabled"])
              ]),
              t[26] || (t[26] = a("label", { class: "col-7 col-lg-5 col-form-label" }, "Loan Amount", -1)),
              a("div", $5t, [
                a("div", _5t, [
                  V(a("input", {
                    class: "form-check-input",
                    type: "checkbox",
                    role: "switch",
                    id: "flexSwitchCheckDefault",
                    "onUpdate:modelValue": t[4] || (t[4] = (v) => e.isMaxLTVLoanAmount = v),
                    onChange: t[5] || (t[5] = (...v) => e.calculate && e.calculate(...v)),
                    disabled: e.calculating
                  }, null, 40, eEt), [
                    [Ue, e.isMaxLTVLoanAmount]
                  ]),
                  t[23] || (t[23] = a("label", {
                    class: "form-check-label",
                    for: "flexSwitchCheckDefault"
                  }, [
                    y("LTV"),
                    a("span", null, "Fixed")
                  ], -1))
                ])
              ]),
              t[27] || (t[27] = a("label", { class: "col-sm-7 col-form-label" }, " Max LTV ", -1)),
              a("div", tEt, [
                N(o, {
                  percent: "",
                  modelValue: e.flipParams.maxLTV,
                  "onUpdate:modelValue": t[6] || (t[6] = (v) => e.flipParams.maxLTV = v),
                  onChange: e.calculate,
                  disabled: e.calculating || !e.isMaxLTVLoanAmount
                }, null, 8, ["modelValue", "onChange", "disabled"])
              ]),
              t[28] || (t[28] = a("label", { class: "col-sm-7 col-form-label" }, "Allow cash-out refinance?", -1)),
              a("div", sEt, [
                a("div", aEt, [
                  V(a("input", {
                    class: "form-check-input",
                    type: "checkbox",
                    role: "switch",
                    id: "flexSwitchCheckDefault",
                    "onUpdate:modelValue": t[7] || (t[7] = (v) => e.flipParams.cashOutIfPossible = v),
                    onChange: t[8] || (t[8] = (...v) => e.calculate && e.calculate(...v)),
                    disabled: e.calculating || !e.isMaxLTVLoanAmount || e.isCashToPermanent
                  }, null, 40, nEt), [
                    [Ue, e.flipParams.cashOutIfPossible]
                  ]),
                  t[24] || (t[24] = a("label", {
                    class: "form-check-label",
                    for: "flexSwitchCheckDefault"
                  }, [
                    y("Yes"),
                    a("span", null, "No")
                  ], -1))
                ])
              ]),
              t[29] || (t[29] = a("label", { class: "col-7 col-form-label" }, "Loan Amount", -1)),
              a("div", rEt, [
                e.isMaxLTVLoanAmount ? (p(), h("div", oEt, [
                  a("b", null, g(e.currency((u = e.flipResults) == null ? void 0 : u.permanentLoanAmount, 0, "N/A")), 1)
                ])) : (p(), Fe(o, {
                  key: 0,
                  currency: "",
                  modelValue: e.calcParams.loanAmount,
                  "onUpdate:modelValue": t[9] || (t[9] = (v) => e.calcParams.loanAmount = v),
                  "orignal-value": (c = e.calcParamsOrig) == null ? void 0 : c.loanAmount,
                  onChange: e.loanAmountChange,
                  disabled: e.calculating
                }, null, 8, ["modelValue", "orignal-value", "onChange", "disabled"]))
              ])
            ])
          ])
        ])) : P("", !0)
      ]),
      e.hasLoan ? (p(), h("div", iEt, [
        a("div", lEt, [
          t[38] || (t[38] = a("div", { class: "card-header bg-eclipse text-white rounded rounded-bottom-0 fw-bold text-center text-sm-start" }, " PERMANENT LOAN ", -1)),
          a("div", dEt, [
            a("div", cEt, [
              a("div", uEt, [
                a("div", pEt, [
                  t[34] || (t[34] = a("label", { class: "col-7 col-form-label" }, "Interest Rate %", -1)),
                  a("div", hEt, [
                    e.editLoan ? (p(), Fe(o, {
                      key: 0,
                      percent: "",
                      modelValue: e.calcParams.interestrate,
                      "onUpdate:modelValue": t[10] || (t[10] = (v) => e.calcParams.interestrate = v),
                      "orignal-value": (m = e.calcParamsOrig) == null ? void 0 : m.interestrate,
                      onChange: e.calculate,
                      disabled: e.calculating
                    }, null, 8, ["modelValue", "orignal-value", "onChange", "disabled"])) : (p(), h("b", mEt, g(e.percent(e.calcParams.interestrate)), 1))
                  ]),
                  t[35] || (t[35] = a("label", { class: "col-7 col-form-label" }, "Interest Only Loan?", -1)),
                  a("div", fEt, [
                    e.editLoan ? (p(), h("div", gEt, [
                      V(a("input", {
                        type: "checkbox",
                        "onUpdate:modelValue": t[11] || (t[11] = (v) => e.calcParams.interestOnlyLoan = v),
                        onChange: t[12] || (t[12] = (...v) => e.calculate && e.calculate(...v)),
                        disabled: e.calculating,
                        class: "form-check-input",
                        id: "iolSwitch"
                      }, null, 40, vEt), [
                        [Ue, e.calcParams.interestOnlyLoan],
                        [d, "calcParams.interestOnlyLoan"]
                      ]),
                      t[31] || (t[31] = a("label", {
                        class: "form-check-label",
                        for: "iolSwitch"
                      }, [
                        a("span", null, "No"),
                        y("Yes")
                      ], -1))
                    ])) : (p(), h("b", yEt, [
                      e.calcParams.interestOnlyLoan ? (p(), h(A, { key: 0 }, [
                        y(" Yes ")
                      ], 64)) : (p(), h(A, { key: 1 }, [
                        y(" No ")
                      ], 64))
                    ]))
                  ]),
                  e.calcParams.interestOnlyLoan ? (p(), h(A, { key: 0 }, [
                    t[33] || (t[33] = a("label", { class: "col-7 col-form-label" }, "Interest Only Term", -1)),
                    a("div", bEt, [
                      e.editLoan ? V((p(), h("select", {
                        key: 0,
                        "onUpdate:modelValue": t[13] || (t[13] = (v) => e.calcParams.interestOnlyTerm = v),
                        class: "form-select",
                        onChange: t[14] || (t[14] = (...v) => e.calculate && e.calculate(...v)),
                        disabled: e.calculating
                      }, [
                        t[32] || (t[32] = a("option", { value: 360 }, "Full Term", -1)),
                        (p(), h(A, null, D([3, 6, 9, 12, 18, 24, 36, 48, 60, 72, 84, 96, 108, 120], (v) => a("option", { value: v }, g(v) + " Months", 9, wEt)), 64))
                      ], 40, AEt)), [
                        [We, e.calcParams.interestOnlyTerm],
                        [d, "calcParams.interestOnlyTerm"]
                      ]) : e.calcParams.interestOnlyTerm == 360 ? (p(), h(A, { key: 1 }, [
                        y(" Full Term ")
                      ], 64)) : (p(), h(A, { key: 2 }, [
                        y(g(e.calcParams.interestOnlyTerm) + " Months ", 1)
                      ], 64))
                    ])
                  ], 64)) : P("", !0),
                  t[36] || (t[36] = a("label", { class: "col-7 col-form-label" }, "Loan Fees", -1)),
                  a("div", CEt, [
                    e.editLoan ? (p(), Fe(o, {
                      key: 0,
                      percent: "",
                      modelValue: e.calcParams.loanfees,
                      "onUpdate:modelValue": t[15] || (t[15] = (v) => e.calcParams.loanfees = v),
                      "orignal-value": (f = e.calcParamsOrig) == null ? void 0 : f.loanfees,
                      onChange: e.calculate,
                      disabled: e.calculating
                    }, null, 8, ["modelValue", "orignal-value", "onChange", "disabled"])) : (p(), h("b", SEt, g(e.percent(e.calcParams.loanfees)), 1))
                  ])
                ])
              ]),
              a("div", PEt, [
                a("div", kEt, [
                  t[37] || (t[37] = a("label", { class: "col-7 col-form-label" }, "Amortization Period", -1)),
                  a("div", EEt, [
                    e.editLoan ? V((p(), h("select", {
                      key: 0,
                      class: "form-select",
                      "onUpdate:modelValue": t[16] || (t[16] = (v) => e.calcParams.loanterm = v),
                      onChange: t[17] || (t[17] = (...v) => e.calculate && e.calculate(...v)),
                      disabled: e.calculating
                    }, [
                      (p(), h(A, null, D(30, (v) => a("option", { value: v }, g(v) + " Years", 9, TEt)), 64))
                    ], 40, IEt)), [
                      [We, e.calcParams.loanterm]
                    ]) : (p(), h("b", OEt, g(e.calcParams.loanterm) + " Years", 1))
                  ])
                ])
              ])
            ])
          ])
        ])
      ])) : P("", !0)
    ]),
    N(l, {
      show: e.showCarryingCostsDialog,
      "onUpdate:show": t[18] || (t[18] = (v) => e.showCarryingCostsDialog = v)
    }, null, 8, ["show"])
  ], 64);
}
const LEt = /* @__PURE__ */ Ae(V5t, [["render", REt]]), BEt = me({
  name: "Proforma",
  computed: {
    months() {
      return [...Array(13).keys()].filter((e) => e > 0);
    },
    firstYear() {
      var e, t;
      return (t = (e = this.calculatedResults) == null ? void 0 : e.raw) == null ? void 0 : t.find((s) => s.isProformaYear && s.year == 1);
    },
    carryingCostBudget() {
      return this.flipBridgeCarryingCost * (this.flipDispositionMonth + 1) - this.flipProRatedTax;
    },
    annualCashFlowFromOperations() {
      let e = 0;
      for (let t = 1; t <= 12; t++)
        e += this.cashFlowFromOperations(t);
      return e;
    },
    annualCarryingCostBudget() {
      let e = 0;
      for (let t = 1; t <= 12; t++)
        e += this.carryingCostBudgetForMonth(t);
      return e;
    },
    proformaYear() {
      var e, t, s;
      return (s = (t = (e = this.calculatedResults) == null ? void 0 : e.flip) == null ? void 0 : t.proformaYears) == null ? void 0 : s.find((n) => !0);
    },
    proformaYearMonths() {
      var e, t;
      return ((t = (e = this.proformaYear) == null ? void 0 : e.months) == null ? void 0 : t.sort((s, n) => s.month - n.month)) ?? [];
    },
    ...at(qe),
    ...q(Te, ["access", "aclLoaded"]),
    ...q(qe, ["flipResults", "flipParams", "flipAmortizationSchedule", "flipTotalCashInvested", "flipBridgeCarryingCost", "calculatedResults", "flipDispositionMonth", "flipProRatedTax"])
  },
  methods: {
    currency: Ze,
    loanPayment(e) {
      return e < (this.flipParams.monthsUntilRefinance ?? 0) ? this.propertyStore.flipBridgeLoanPayment ?? 0 : this.flipParams.purchaseMethod == Vt.PermanentLoan || this.flipParams.purchaseMethod == Vt.BridgeToPermanentLoan || this.flipParams.purchaseMethod == Vt.CashToPermanentLoan ? this.propertyStore.flipLoanPayment ?? 0 : 0;
    },
    vacancyLoss(e) {
      return e <= (this.flipParams.monthsUntilRent ?? 0) ? this.flipParams.afterRepairRentPrice ?? 0 : 0;
    },
    effectiveRentalIncome(e) {
      return (this.flipParams.afterRepairRentPrice ?? 0) - this.vacancyLoss(e);
    },
    totalOperatingExpenses(e) {
      var s, n, r, i, o, l, d;
      let t = (((s = this.firstYear) == null ? void 0 : s.propertyTax) ?? 0) + (((n = this.firstYear) == null ? void 0 : n.propertyInsurance) ?? 0) + (((r = this.firstYear) == null ? void 0 : r.hoa) ?? 0);
      return t += ((i = this.firstYear) == null ? void 0 : i.utilityExpenses) ?? 0, e > (this.flipParams.monthsUntilRent ?? 0) && (t += ((o = this.firstYear) == null ? void 0 : o.propertyManagement) ?? 0), t /= 12, e == (((l = this.flipParams) == null ? void 0 : l.monthsUntilRent) ?? 0) + 1 && (t += ((d = this.firstYear) == null ? void 0 : d.leasingCommissions) ?? 0), t;
    },
    cashFlowFromOperations(e) {
      return this.effectiveRentalIncome(e) - this.totalOperatingExpenses(e) - this.loanPayment(e);
    },
    carryingCostBudgetBalance(e) {
      if (e == 0)
        return this.carryingCostBudget;
      let t = 0;
      for (let n = 1; n <= e; n++) {
        const r = this.cashFlowFromOperations(n);
        r < 0 && (t += r);
      }
      const s = this.carryingCostBudget + t;
      return console.log("carryingCostBudgetBalance", e, s, this.carryingCostBudget, t), s < 0 ? 0 : s;
    },
    carryingCostBudgetForMonth(e) {
      const t = this.carryingCostBudgetBalance(e - 1), s = this.cashFlowFromOperations(e);
      return console.log("carryingCostBudgetForMonth", e, t, s), s > 0 ? 0 : Math.abs(s) > t || t == 0 ? t : Math.abs(s);
    },
    currencyStyle(e) {
      return {
        positive: (e ?? 0) > 0,
        negative: (e ?? 0) < 0
      };
    }
  }
}), MEt = { class: "card shadow-sm" }, xEt = { class: "card-body p-0 position-relative overflow-hidden" }, FEt = { class: "table-wrap" }, VEt = { class: "table table-sm text-small mlse-table mlse-apod mlse-values mode-advanced" }, DEt = { class: "text-end" }, NEt = { class: "mlse-column" }, jEt = { class: "tb-space" }, HEt = { class: "mlse-column" }, UEt = { class: "mlse-column" }, zEt = { class: "mlse-column" }, WEt = { class: "mlse-column" }, GEt = { class: "table-total table-divider" }, YEt = { class: "mlse-column" }, XEt = { class: "mlse-column" }, qEt = { class: "tb-space" }, QEt = { class: "mlse-column" }, KEt = { class: "mlse-column" }, ZEt = { class: "mlse-column" }, JEt = { class: "mlse-column" }, $Et = { class: "mlse-column" }, _Et = { class: "mlse-column" }, eIt = { class: "mlse-column" }, tIt = { class: "mlse-column" }, sIt = { class: "mlse-column" }, aIt = { class: "mlse-column" }, nIt = { class: "mlse-column" }, rIt = { class: "mlse-column" }, oIt = { class: "table-total table-divider" }, iIt = { class: "mlse-column" }, lIt = { class: "mlse-column" }, dIt = { class: "tb-space" }, cIt = { class: "table-total styled-dark-finances fw-bold" }, uIt = { class: "mlse-column" }, pIt = { class: "mlse-column" }, hIt = { class: "tb-space" }, mIt = { class: "mlse-column" }, fIt = { class: "mlse-column" }, gIt = { class: "table-total" }, vIt = { class: "mlse-column" }, yIt = { class: "mlse-column" }, bIt = { class: "mlse-column" }, AIt = { class: "mlse-column" }, wIt = { class: "table-total" }, CIt = { class: "mlse-column" }, SIt = { class: "mlse-column" }, PIt = { class: "mlse-column" };
function kIt(e, t, s, n, r, i) {
  var o, l, d, c, u, m, f, v, b, w, S, I, T, x, k;
  return p(), h("div", MEt, [
    t[22] || (t[22] = a("div", { class: "card-header bg-eclipse text-white rounded rounded-bottom-0 fw-bold text-center text-sm-start" }, " FLIP-TO-RENT YEAR 1 PROFORMA ", -1)),
    a("div", xEt, [
      a("div", FEt, [
        a("table", VEt, [
          a("thead", null, [
            a("tr", DEt, [
              t[0] || (t[0] = a("th", null, null, -1)),
              (p(!0), h(A, null, D(e.proformaYearMonths, (C) => (p(), h("th", NEt, " Month " + g(C.month), 1))), 256)),
              t[1] || (t[1] = a("th", { class: "mlse-column" }, " Year 1 Total ", -1))
            ]),
            t[2] || (t[2] = a("tr", { class: "table-alice" }, [
              a("th", null, "INCOME"),
              a("td", { colspan: "30" }, " ")
            ], -1))
          ]),
          a("tbody", jEt, [
            a("tr", null, [
              t[3] || (t[3] = a("th", { rel: "potentialrentalincome" }, " Potential Rental Income ", -1)),
              (p(!0), h(A, null, D(e.proformaYearMonths, (C) => (p(), h("td", HEt, g(e.currency(C.potentialRentalIncome)), 1))), 256)),
              a("th", UEt, [
                a("b", null, g(e.currency((o = e.proformaYear) == null ? void 0 : o.potentialRentalIncome)), 1)
              ])
            ]),
            a("tr", null, [
              t[4] || (t[4] = a("th", { rel: "vacancyloss" }, " Vacancy Loss ", -1)),
              (p(!0), h(A, null, D(e.proformaYearMonths, (C) => (p(), h("td", zEt, g(e.currency(C.vacancyLoss)), 1))), 256)),
              a("th", WEt, [
                a("b", null, g(e.currency((l = e.proformaYear) == null ? void 0 : l.vacancyLoss)), 1)
              ])
            ]),
            a("tr", GEt, [
              t[5] || (t[5] = a("th", { rel: "effectiverentalincome" }, " Effective Rental Income ", -1)),
              (p(!0), h(A, null, D(e.proformaYearMonths, (C) => (p(), h("td", YEt, [
                a("b", null, g(e.currency(C.effectiveRentalIncome)), 1)
              ]))), 256)),
              a("th", XEt, [
                a("b", null, g(e.currency((d = e.proformaYear) == null ? void 0 : d.effectiveRentalIncome)), 1)
              ])
            ])
          ]),
          t[20] || (t[20] = a("thead", null, [
            a("tr", { class: "table-alice" }, [
              a("th", null, "OPERATING EXPENSES"),
              a("td", { colspan: "30" }, " ")
            ])
          ], -1)),
          a("tbody", qEt, [
            a("tr", null, [
              t[6] || (t[6] = a("th", { rel: "propertytax" }, " Property Tax ", -1)),
              (p(!0), h(A, null, D(e.proformaYearMonths, (C) => (p(), h("td", QEt, g(e.currency(C.propertyTax)), 1))), 256)),
              a("th", KEt, [
                a("b", null, g(e.currency((c = e.proformaYear) == null ? void 0 : c.propertyTax)), 1)
              ])
            ]),
            a("tr", null, [
              t[7] || (t[7] = a("th", { rel: "propertyinsurance" }, " Property Insurance ", -1)),
              (p(!0), h(A, null, D(e.proformaYearMonths, (C) => (p(), h("td", ZEt, g(e.currency(C.propertyInsurance)), 1))), 256)),
              a("th", JEt, [
                a("b", null, g(e.currency((u = e.proformaYear) == null ? void 0 : u.propertyInsurance)), 1)
              ])
            ]),
            a("tr", null, [
              t[8] || (t[8] = a("th", { rel: "hoa" }, " HOA ", -1)),
              (p(!0), h(A, null, D(e.proformaYearMonths, (C) => (p(), h("td", $Et, g(e.currency(C.hoa)), 1))), 256)),
              a("th", _Et, [
                a("b", null, g(e.currency((m = e.proformaYear) == null ? void 0 : m.hoa)), 1)
              ])
            ]),
            a("tr", null, [
              t[9] || (t[9] = a("th", { rel: "propertymanagement" }, " Property Management ", -1)),
              (p(!0), h(A, null, D(e.proformaYearMonths, (C) => (p(), h("td", eIt, g(e.currency(C.propertyManagement)), 1))), 256)),
              a("th", tIt, [
                a("b", null, g(e.currency((f = e.proformaYear) == null ? void 0 : f.propertyManagement)), 1)
              ])
            ]),
            a("tr", null, [
              t[10] || (t[10] = a("th", { rel: "leasingcomissions" }, " Leasing Commissions ", -1)),
              (p(!0), h(A, null, D(e.proformaYearMonths, (C) => (p(), h("td", sIt, g(e.currency(C.leasingCommissions)), 1))), 256)),
              a("th", aIt, [
                a("b", null, g(e.currency((v = e.proformaYear) == null ? void 0 : v.leasingCommissions)), 1)
              ])
            ]),
            a("tr", null, [
              t[11] || (t[11] = a("th", { rel: "utilities" }, " Utilities ", -1)),
              (p(!0), h(A, null, D(e.proformaYearMonths, (C) => (p(), h("td", nIt, g(e.currency(C.utilities)), 1))), 256)),
              a("th", rIt, [
                a("b", null, g(e.currency((b = e.proformaYear) == null ? void 0 : b.utilities)), 1)
              ])
            ]),
            a("tr", oIt, [
              t[12] || (t[12] = a("th", { rel: "totalOperatingExpenses" }, [
                a("b", null, "Total Operating Expenses")
              ], -1)),
              (p(!0), h(A, null, D(e.proformaYearMonths, (C) => (p(), h("td", iIt, [
                a("b", null, g(e.currency(C.totalOperatingExpenses)), 1)
              ]))), 256)),
              a("th", lIt, [
                a("b", null, g(e.currency((w = e.proformaYear) == null ? void 0 : w.totalOperatingExpenses)), 1)
              ])
            ])
          ]),
          a("tbody", dIt, [
            a("tr", cIt, [
              t[13] || (t[13] = a("th", { rel: "netOperatingIncome" }, " Net Operating Income ", -1)),
              (p(!0), h(A, null, D(e.proformaYearMonths, (C) => (p(), h("td", uIt, [
                a("div", {
                  class: z(["adv-netOperatingIncome", e.currencyStyle(C.netOperatingIncome)])
                }, g(e.currency(C.netOperatingIncome)), 3)
              ]))), 256)),
              a("th", pIt, [
                a("b", null, g(e.currency((S = e.proformaYear) == null ? void 0 : S.netOperatingIncome)), 1)
              ])
            ])
          ]),
          t[21] || (t[21] = a("thead", null, [
            a("tr", { class: "table-alice" }, [
              a("th", null, "NON OPERATING EXPENSES"),
              a("td", { colspan: "30" }, " ")
            ])
          ], -1)),
          a("tbody", hIt, [
            a("tr", null, [
              t[14] || (t[14] = a("th", { rel: "loanPayment" }, " Loan Payment ", -1)),
              (p(!0), h(A, null, D(e.proformaYearMonths, (C) => (p(), h("td", mIt, g(e.currency(C.loanPayment)), 1))), 256)),
              a("th", fIt, [
                a("b", null, g(e.currency((I = e.proformaYear) == null ? void 0 : I.loanPayment)), 1)
              ])
            ]),
            a("tr", gIt, [
              t[15] || (t[15] = a("th", { rel: "cashFlowFromOperations" }, [
                a("b", null, "Cash Flow from Operations")
              ], -1)),
              (p(!0), h(A, null, D(e.proformaYearMonths, (C) => (p(), h("td", vIt, [
                a("b", null, g(e.currency(C.cashFlowFromOperations)), 1)
              ]))), 256)),
              a("th", yIt, [
                a("b", null, g(e.currency((T = e.proformaYear) == null ? void 0 : T.cashFlowFromOperations)), 1)
              ])
            ]),
            a("tr", null, [
              t[16] || (t[16] = a("th", { rel: "carryingCostReserveUtilization" }, " Carrying Cost Reserve Utilization ", -1)),
              (p(!0), h(A, null, D(e.proformaYearMonths, (C) => (p(), h("td", bIt, g(e.currency(C.carryingCostReserveUtilization)), 1))), 256)),
              a("th", AIt, [
                a("b", null, g(e.currency((x = e.proformaYear) == null ? void 0 : x.carryingCostReserveUtilization)), 1)
              ])
            ]),
            a("tr", wIt, [
              t[17] || (t[17] = a("th", { rel: "netCashFlow" }, [
                a("b", null, "Net Cash Flow")
              ], -1)),
              (p(!0), h(A, null, D(e.proformaYearMonths, (C) => (p(), h("td", CIt, [
                a("b", null, g(e.currency(C.netCashFlow)), 1)
              ]))), 256)),
              a("th", SIt, [
                a("b", null, g(e.currency((k = e.proformaYear) == null ? void 0 : k.netCashFlow)), 1)
              ])
            ]),
            a("tr", null, [
              t[18] || (t[18] = a("th", { rel: "carryingCostReserveValance" }, " Carrying Cost Reserve Balance ", -1)),
              (p(!0), h(A, null, D(e.proformaYearMonths, (C) => (p(), h("td", PIt, g(e.currency(C.carryingCostReserveBalance)), 1))), 256)),
              t[19] || (t[19] = a("th", { class: "mlse-column" }, null, -1))
            ])
          ])
        ])
      ])
    ])
  ]);
}
const EIt = /* @__PURE__ */ Ae(BEt, [["render", kIt]]), IIt = me({
  name: "InvestmentBasisAfterRefi",
  computed: {
    hasLoan() {
      return this.flipParams.purchaseMethod == Vt.CashToPermanentLoan || this.flipParams.purchaseMethod == Vt.BridgeToPermanentLoan;
    },
    ...at(qe),
    ...q(Te, ["access", "aclLoaded"]),
    ...q(qe, [
      "flipResults",
      "flipParams",
      "flipTotalCosts",
      "calculatedResults",
      "flipDispositionMonth",
      "flipBridgeCarryingCost",
      "flipTotalCashInvested",
      "calcParams",
      "flipProRatedTax",
      "flipHasBridgeLoan",
      "flipYear1Shortfall",
      "flipInvestmentBasisAsRental"
    ])
  },
  methods: {
    currency: Ze
  }
}), TIt = { class: "card shadow-sm" }, OIt = { class: "table table-sm" }, RIt = { class: "text-end" }, LIt = { class: "text-end" }, BIt = { key: 0 }, MIt = { class: "text-end" }, xIt = { class: "text-end" }, FIt = { class: "text-end" }, VIt = { class: "bg-light fw-bold text-end" };
function DIt(e, t, s, n, r, i) {
  var o, l, d, c;
  return p(), h("div", TIt, [
    t[7] || (t[7] = a("div", { class: "card-header bg-eclipse text-white rounded rounded-bottom-0 fw-bold text-center text-sm-start" }, " FLIP-TO-RENT INVESTMENT BASIS ", -1)),
    a("table", OIt, [
      a("tbody", null, [
        a("tr", null, [
          t[0] || (t[0] = a("td", null, " Initial Cash Investment ", -1)),
          a("td", RIt, g(e.currency(e.flipTotalCashInvested)), 1)
        ]),
        e.hasLoan ? (p(), h(A, { key: 0 }, [
          a("tr", null, [
            t[1] || (t[1] = a("td", null, " Less: Permanent Loan Amount ", -1)),
            a("td", LIt, g(e.currency((o = e.flipResults) == null ? void 0 : o.permanentLoanAmount)), 1)
          ]),
          e.flipHasBridgeLoan ? (p(), h("tr", BIt, [
            t[2] || (t[2] = a("td", null, " Plus: Bridge Loan Payoff ", -1)),
            a("td", MIt, g(e.currency((l = e.flipResults) == null ? void 0 : l.bridgeLoanAmount)), 1)
          ])) : P("", !0),
          a("tr", null, [
            t[3] || (t[3] = a("td", null, " Plus: Permanent Loan Fees ", -1)),
            a("td", xIt, g(e.currency(((d = e.flipResults) == null ? void 0 : d.permanentLoanAmount) * ((c = e.calcParams) == null ? void 0 : c.loanfees))), 1)
          ])
        ], 64)) : P("", !0),
        a("tr", null, [
          a("td", null, [
            e.flipYear1Shortfall > 0 ? (p(), h(A, { key: 0 }, [
              t[4] || (t[4] = y(" Plus: Year 1 Shortfall ")),
              t[5] || (t[5] = a("small", null, "(Exceeding Carrying Cost Budget)", -1))
            ], 64)) : (p(), h(A, { key: 1 }, [
              y(" Less: Carrying Costs Budget Surplus ")
            ], 64))
          ]),
          a("td", FIt, [
            e.flipYear1Shortfall > 0 ? (p(), h(A, { key: 0 }, [
              y(g(e.currency(e.flipYear1Shortfall)), 1)
            ], 64)) : (p(), h(A, { key: 1 }, [
              y(g(e.currency(-e.flipYear1Shortfall)), 1)
            ], 64))
          ])
        ]),
        a("tr", null, [
          t[6] || (t[6] = a("th", { class: "bg-light fw-bold" }, " Investment Basis as Rental ", -1)),
          a("th", VIt, g(e.currency(e.flipInvestmentBasisAsRental)), 1)
        ])
      ])
    ])
  ]);
}
const NIt = /* @__PURE__ */ Ae(IIt, [["render", DIt]]), jIt = me({
  name: "FlipRentTab",
  props: {},
  components: {
    AnnualCashFlow: E5t,
    ReturnOnInvestment: R5t,
    NetEquity: F5t,
    FinanceMethod: LEt,
    ProForma: EIt,
    InitialInvestment: Zu,
    InvestmentBasisAfterRefi: NIt,
    RefinanceCash: wE,
    PostRefinanceInvestmentBasis: CE
  },
  data() {
    return {};
  },
  computed: {
    investmentBasisAfterRefi() {
      var t, s, n, r;
      const e = this.flipTotalCashInvested + ((t = this.flipResults) == null ? void 0 : t.bridgeLoanAmount) + ((s = this.flipResults) == null ? void 0 : s.permanentLoanAmount) * ((n = this.calcParams) == null ? void 0 : n.loanfees) - ((r = this.flipResults) == null ? void 0 : r.permanentLoanAmount);
      return e < 1 ? 0 : e;
    },
    isCash() {
      var e;
      return ((e = this.flipParams) == null ? void 0 : e.purchaseMethod) == Vt.Cash;
    },
    ...at(qe),
    ...q(Te, ["access", "aclLoaded"]),
    ...q(qe, ["flipResults", "flipParams", "flipTotalCosts", "calculatedResults", "flipDispositionMonth", "flipBridgeCarryingCost", "flipTotalCashInvested", "calcParams"])
  },
  methods: {
    currency: Ze
  }
}), HIt = { class: "container-xl" }, UIt = { class: "row g-3" }, zIt = { class: "col-lg-4" }, WIt = { class: "row g-3" }, GIt = { class: "col-12" }, YIt = {
  key: 0,
  class: "col-12"
}, XIt = { class: "col-md-6 col-xl-12" }, qIt = { class: "col-md-6 col-xl-12" }, QIt = { class: "col-lg-8" }, KIt = { class: "card shadow-sm" }, ZIt = { class: "card-body" }, JIt = { class: "col-12" };
function $It(e, t, s, n, r, i) {
  pe("annual-cash-flow"), pe("return-on-investment"), pe("net-equity");
  const o = pe("initial-investment"), l = pe("investment-basis-after-refi"), d = pe("refinance-cash"), c = pe("post-refinance-investment-basis"), u = pe("finance-method"), m = pe("pro-forma");
  return p(), h("div", HIt, [
    a("div", UIt, [
      P("", !0),
      a("div", zIt, [
        a("div", WIt, [
          a("div", GIt, [
            N(o)
          ]),
          e.isCash ? (p(), h("div", YIt, [
            N(l)
          ])) : (p(), h(A, { key: 1 }, [
            a("div", XIt, [
              N(d)
            ]),
            a("div", qIt, [
              N(c)
            ])
          ], 64))
        ])
      ]),
      a("div", QIt, [
        a("div", KIt, [
          a("div", ZIt, [
            N(u)
          ])
        ])
      ]),
      a("div", JIt, [
        N(m)
      ])
    ])
  ]);
}
const lds = /* @__PURE__ */ Ae(jIt, [["render", $It]]), _It = me({
  name: "RentvineInformation",
  props: {
    portfolioId: String
  },
  components: {
    ProgressBar: _y
  },
  data() {
    return {};
  },
  computed: {
    calculatingClasses() {
      return {
        card: !0,
        "shadow-sm": !0,
        calculating: this.calculating || this.portfoliosLoading
      };
    },
    statusStyles() {
      var e, t;
      return {
        "text-bg-success": this.isActive && ((e = this.currentLease) == null ? void 0 : e.start) != null,
        "text-bg-danger": this.isActive && ((t = this.currentLease) == null ? void 0 : t.start) == null,
        "text-bg-secondary": !this.isActive,
        badge: !0,
        "ms-lg-auto": !0
      };
    },
    mpod() {
      var e, t;
      return ((t = (e = this.purchaseFacts) == null ? void 0 : e.mpod) == null ? void 0 : t.filter((s) => s.year <= Et).sort((s, n) => s.year - n.year || s.month - n.month)) ?? [];
    },
    t12IncomeMonths() {
      return this.mpod.filter((e) => !e.noIncome).reduce((e, t) => e + 1, 0);
    },
    lastMonthIncome() {
      if (this.mpod.length > 0)
        return this.mpod[this.mpod.length - 1].effectiveIncome;
    },
    lastMonthIncomePercent() {
      return this.calcParams.monthlyRentalYear1 > 0 ? Math.trunc(this.lastMonthIncome / this.calcParams.monthlyRentalYear1 * 100) : 0;
    },
    t12GrossIncome() {
      return this.mpod.reduce((e, t) => e + t.effectiveIncome, 0);
    },
    t12GrossIncomePercent() {
      if (this.calcParams.monthlyRentalYear1 > 0 && this.t12IncomeMonths > 0) {
        const e = this.t12GrossIncome / (this.calcParams.monthlyRentalYear1 * this.t12IncomeMonths);
        return e > 0 && e < 0.01 ? 1 : Math.trunc(e * 100);
      }
      return 0;
    },
    ...at(ba),
    ...q(Te, ["access", "aclLoaded"]),
    ...q(qe, ["property", "calcParams", "propertyInitialized", "calculating", "purchaseFacts"]),
    ...q(ba, ["currentLease", "isActive", "portfoliosLoading"])
  },
  methods: {
    currency: Ze,
    date: cs,
    progressStatus(e) {
      return e >= 95 ? "success" : e >= 80 ? "warning" : "danger";
    }
  },
  created() {
  },
  mounted() {
    this.propertyInitialized.then(async () => {
      this.portfolioId && await this.portfolioInsightsStore.getPortfolioProperty(this.property.propId);
    });
  }
}), TE = "/images/logo-rentvine.svg", e6t = {
  key: 0,
  class: "calculating-animation position-absolute top-50 start-50 translate-middle text-center"
}, t6t = { class: "d-flex align-items-center flex-lg-row" }, s6t = { class: "border-start-lg-1 px-4 pb-4 p-lg-4 d-flex flex-column flex-fill" }, a6t = { class: "row" }, n6t = { class: "col" }, r6t = { class: "col-5 text-end" }, o6t = { class: "row" }, i6t = { class: "col" }, l6t = { class: "col-5" }, d6t = { class: "row" }, c6t = { class: "col" }, u6t = { class: "col-5" };
function p6t(e, t, s, n, r, i) {
  var l;
  const o = pe("ProgressBar");
  return e.portfolioId ? (p(), h("div", {
    key: 0,
    class: z(e.calculatingClasses)
  }, [
    e.calculating || e.portfoliosLoading ? (p(), h("div", e6t, t[0] || (t[0] = [
      a("i", { class: "fa-duotone fa-solid fa-compass fa-spin fa-lg text-eclipse" }, null, -1),
      a("br", null, null, -1),
      a("small", null, "Calculating", -1)
    ]))) : P("", !0),
    a("div", t6t, [
      t[6] || (t[6] = a("div", { class: "p-4 h-100 d-flex align-items-center" }, [
        a("img", {
          src: TE,
          alt: "rentvine",
          title: "rentvine",
          class: "img-fluid",
          width: "138",
          height: "20"
        })
      ], -1)),
      a("div", s6t, [
        a("div", a6t, [
          a("div", n6t, [
            t[1] || (t[1] = y(" Lease: ")),
            a("b", null, [
              e.currentLease ? (p(), h(A, { key: 0 }, [
                y(g(e.date(e.currentLease.start)) + " - " + g(e.date(e.currentLease.end)), 1)
              ], 64)) : (p(), h(A, { key: 1 }, [
                y(" Vacant ")
              ], 64))
            ]),
            t[2] || (t[2] = a("br", null, null, -1)),
            t[3] || (t[3] = y(" Rental Rate: ")),
            a("b", null, g(e.currency(e.calcParams.monthlyRentalYear1)), 1)
          ]),
          a("div", r6t, [
            a("span", {
              class: z(e.statusStyles)
            }, [
              (l = e.currentLease) != null && l.start ? (p(), h(A, { key: 0 }, [
                y(" Occupied ")
              ], 64)) : e.isActive ? (p(), h(A, { key: 1 }, [
                y(" Vacant ")
              ], 64)) : (p(), h(A, { key: 2 }, [
                y(" Inactive ")
              ], 64))
            ], 2)
          ])
        ]),
        a("div", o6t, [
          a("div", i6t, [
            t[4] || (t[4] = y("Last Month Income: ")),
            a("b", null, g(e.currency(e.lastMonthIncome)), 1)
          ]),
          a("div", l6t, [
            N(o, {
              value: e.lastMonthIncomePercent,
              class: z(e.progressStatus(e.lastMonthIncomePercent))
            }, null, 8, ["value", "class"])
          ])
        ]),
        a("div", d6t, [
          a("div", c6t, [
            t[5] || (t[5] = y("T-12 Gross Income: ")),
            a("b", null, g(e.currency(e.t12GrossIncome)), 1)
          ]),
          a("div", u6t, [
            N(o, {
              value: e.t12GrossIncomePercent,
              class: z(e.progressStatus(e.t12GrossIncomePercent))
            }, null, 8, ["value", "class"])
          ])
        ])
      ])
    ])
  ], 2)) : P("", !0);
}
const h6t = /* @__PURE__ */ Ae(_It, [["render", p6t]]), m6t = me({
  name: "AcquisitionAndValue",
  props: {},
  emits: [
    "saveFields"
  ],
  components: {
    InvestmentDetails: wb,
    NumericalInput: Aa,
    ProgressBar: _y
  },
  data() {
    return {
      showInvestmentDetails: !1
    };
  },
  computed: {
    calculatingClasses() {
      return {
        card: !0,
        "shadow-sm": !0,
        calculating: this.calculating
      };
    },
    loanPayment() {
      var e;
      if ((e = this.purchaseFacts) != null && e.loan)
        return pn(
          this.purchaseFacts.loan.interestRate / 12,
          this.purchaseFacts.loan.term * 12,
          this.purchaseFacts.loan.amount
        );
    },
    netEquity() {
      var e, t, s;
      return (s = (t = (e = this.calculatedResults) == null ? void 0 : e.existingInvestmentSummary) == null ? void 0 : t.currentYear) == null ? void 0 : s.netEquity;
    },
    duration() {
      var l, d;
      const e = new Date((l = this.purchaseFacts) == null ? void 0 : l.firstYearAsRental, 1, 1) - ((d = this.purchaseFacts) == null ? void 0 : d.purchaseDate.getTime()), t = Math.floor(e / 1e3), s = Math.floor(t / 60), n = Math.floor(s / 60), r = Math.floor(n / 24), i = Math.floor(r / 30);
      return {
        years: Math.floor(i / 12),
        months: i % 12
      };
    },
    currentYear() {
      return Et;
    },
    currentMonth() {
      return Xu;
    },
    loanBalance() {
      var n, r, i;
      if (!((n = this.purchaseFacts) != null && n.hasCurrentLoan))
        return;
      const e = 12 - this.purchaseFacts.loan.date.getMonth(), t = this.purchaseFacts.loan.date.getFullYear(), s = e + (this.currentYear - t) * 12;
      return (i = (r = this.amortizationSchedule) == null ? void 0 : r.find((o) => o.month == s)) == null ? void 0 : i.remainingPrincipalBeforePayment;
    },
    principalReduction() {
      var e, t, s, n, r, i, o;
      if ((e = this.purchaseFacts) != null && e.hasCurrentLoan && ((s = (t = this.purchaseFacts) == null ? void 0 : t.loan) == null ? void 0 : s.amount) > 0)
        return (((r = (n = this.purchaseFacts) == null ? void 0 : n.loan) == null ? void 0 : r.amount) - this.loanBalance) / ((o = (i = this.purchaseFacts) == null ? void 0 : i.loan) == null ? void 0 : o.amount);
    },
    principalReductionWhole() {
      return Math.trunc(this.principalReduction * 100);
    },
    ...q(Te, ["access", "aclLoaded"]),
    ...q(qe, ["calculating", "purchaseFacts", "calcParams", "calculatedResults", "property", "purchaseYear", "isAtPurchase", "isCurrentYear", "cantAutoPopulate", "firstYearAsRental", "purchaseFactsYears", "amortizationSchedule"]),
    ...at(qe)
  },
  methods: {
    number: Ve,
    currency: Ze,
    date: cs,
    formatDuration: af,
    percent: Wt,
    //#region Shared
    calculateEquityForYear(e) {
      return this.calculateEquity(e.propertyValue, e.loanBalance);
    },
    calculateEquity(e, t) {
      return e - (t ?? 0) - e * this.calcParams.costofsale;
    },
    autoPopulateValueEquity() {
      var t, s;
      const e = this.isAtPurchase ? (t = this.purchaseFacts) == null ? void 0 : t.purchasePrice : (s = this.purchaseFacts) == null ? void 0 : s.investmentBasis;
      this.propertyStore.autoPopulateValueEquity(e, this.firstYearAsRental, this.calcParams.propertyValueEoY, Et);
    },
    //#endregion
    saveFields() {
      this.$emit("saveFields"), bootstrap.Modal.getOrCreateInstance(this.$refs.dialogPropertyValue).hide();
    }
  },
  created() {
  },
  mounted() {
    this.aclLoaded.then(() => {
    });
  }
}), f6t = "/images/icon-break-line.svg", g6t = {
  key: 0,
  class: "calculating-animation position-absolute top-50 start-50 translate-middle text-center"
}, v6t = { class: "card-body d-flex justify-content-between border-bottom flex-column flex-md-row gap-3" }, y6t = { class: "text-center" }, b6t = { class: "fs-5 fw-bold" }, A6t = { class: "text-body-secondary" }, w6t = {
  key: 0,
  class: "text-center d-flex flex-column align-items-center justify-content-center position-relative"
}, C6t = { class: "text-center d-flex flex-column align-items-center justify-content-center position-relative" }, S6t = { class: "text-body-secondary" }, P6t = { class: "text-center" }, k6t = { class: "fs-5 fw-bold" }, E6t = { class: "text-body-secondary" }, I6t = { class: "text-center" }, T6t = { class: "fs-5 fw-bold" }, O6t = { class: "text-body-secondary" }, R6t = { class: "card-body p-0" }, L6t = { class: "row" }, B6t = { class: "col" }, M6t = { class: "py-3 px-2" }, x6t = { class: "row" }, F6t = { class: "col fw-bold" }, V6t = { class: "row" }, D6t = { class: "col fw-bold" }, N6t = { class: "row" }, j6t = { class: "col fw-bold" }, H6t = { class: "row" }, U6t = { class: "col fw-bold" }, z6t = { class: "row" }, W6t = { class: "col fw-bold" }, G6t = { class: "col-12 mt-1" }, Y6t = { class: "p-3 col-4 border-start text-center d-flex align-items-center justify-content-center" }, X6t = { class: "fs-5 fw-bold" }, q6t = { class: "text-body-secondary" }, Q6t = { class: "card-footer d-flex justify-content-between bg-white" }, K6t = {
  class: "modal fade",
  ref: "dialogPropertyValue",
  id: "dialogPropertyValueEquity",
  tabindex: "-1",
  "aria-labelledby": "dialogPropertyValueLabel",
  "aria-hidden": "true"
}, Z6t = { class: "modal-dialog modal-dialog-centered modal-lg" }, J6t = { class: "modal-content bg-gradient-alphabet rounded" }, $6t = {
  key: 0,
  class: "p-4 pb-0"
}, _6t = {
  class: "alert alert-warning",
  role: "alert"
}, eTt = { class: "card bg-white bg-opacity-50 mx-3 mb-3" }, tTt = { class: "card-body" }, sTt = { class: "row g-3" }, aTt = { class: "col-form-label col-md-6 col-lg-4 fw-bold" }, nTt = { class: "col-md-6 col-lg-2 d-flex align-items-center justify-content-center" }, rTt = { class: "col-md-6 col-lg-3" }, oTt = {
  key: 1,
  class: "alert alert-info",
  role: "alert"
}, iTt = { class: "modal-body p-0" }, lTt = { class: "table-scrollable" }, dTt = {
  key: 0,
  class: "table table-borderless table-striped"
}, cTt = { class: "text-center" }, uTt = { class: "column sticky-top" }, pTt = ["disabled"], hTt = { class: "column sticky-top" }, mTt = { key: 1 }, fTt = { class: "text-end" }, gTt = { key: 1 }, vTt = { class: "form-control-plaintext text-end" }, yTt = { class: "text-end" }, bTt = { class: "form-control-plaintext text-end" }, ATt = { key: 1 }, wTt = { class: "form-control-plaintext text-end" }, CTt = { class: "text-end" }, STt = { class: "form-control-plaintext text-end" }, PTt = { key: 1 }, kTt = { class: "form-control-plaintext text-end" }, ETt = { class: "text-end" }, ITt = { class: "form-control-plaintext text-end" }, TTt = { key: 1 }, OTt = { class: "form-control-plaintext text-end" }, RTt = { class: "modal-footer" };
function LTt(e, t, s, n, r, i) {
  var c, u, m, f, v, b, w, S, I, T, x, k, C, O, E, B, M, R, F, L, j, H;
  const o = pe("ProgressBar"), l = pe("numerical-input"), d = pe("investment-details");
  return p(), h(A, null, [
    a("div", {
      class: z(e.calculatingClasses)
    }, [
      t[19] || (t[19] = a("div", { class: "card-header bg-eclipse text-white rounded rounded-bottom-0 fw-bold text-center text-sm-start" }, " ACQUISITION & VALUE ", -1)),
      e.calculating ? (p(), h("div", g6t, t[5] || (t[5] = [
        a("i", { class: "fa-duotone fa-solid fa-compass fa-spin fa-lg text-eclipse" }, null, -1),
        a("br", null, null, -1),
        a("small", null, "Calculating", -1)
      ]))) : P("", !0),
      a("div", null, [
        a("div", v6t, [
          a("div", y6t, [
            t[6] || (t[6] = a("div", null, "Purchase", -1)),
            a("div", b6t, g(e.currency((c = e.purchaseFacts) == null ? void 0 : c.purchasePrice)), 1),
            a("small", A6t, g(e.date((u = e.purchaseFacts) == null ? void 0 : u.purchaseDate)), 1)
          ]),
          e.isAtPurchase ? (p(), h("div", w6t, t[7] || (t[7] = [
            a("small", { class: "text-body-secondary" }, "Purchased as Investment Property", -1)
          ]))) : (p(), h(A, { key: 1 }, [
            a("div", C6t, [
              t[8] || (t[8] = a("div", { class: "mb-2" }, [
                a("img", {
                  src: f6t,
                  class: "img-fluid",
                  width: "190",
                  title: "break line"
                })
              ], -1)),
              a("small", S6t, g(e.formatDuration(e.duration)), 1)
            ]),
            a("div", P6t, [
              t[9] || (t[9] = a("div", null, "Rental", -1)),
              a("div", k6t, g(e.currency((m = e.purchaseFacts) == null ? void 0 : m.investmentBasis)), 1),
              a("small", E6t, "1/1/" + g((f = e.purchaseFacts) == null ? void 0 : f.firstYearAsRental), 1)
            ])
          ], 64)),
          a("div", I6t, [
            t[10] || (t[10] = a("div", null, "Current EoY Value", -1)),
            a("div", T6t, g(e.currency(e.calcParams.propertyValueEoY)), 1),
            a("small", O6t, g(e.currentYear), 1)
          ])
        ]),
        a("div", R6t, [
          a("div", L6t, [
            a("div", B6t, [
              a("div", M6t, [
                a("div", x6t, [
                  t[11] || (t[11] = a("div", { class: "col-6" }, "Loan Date:", -1)),
                  a("div", F6t, [
                    (v = e.purchaseFacts) != null && v.hasCurrentLoan && ((b = e.purchaseFacts) != null && b.loan) ? (p(), h(A, { key: 0 }, [
                      y(g(e.date((S = (w = e.purchaseFacts) == null ? void 0 : w.loan) == null ? void 0 : S.date)), 1)
                    ], 64)) : (p(), h(A, { key: 1 }, [
                      y(" Owned Free & Clear - No Loan ")
                    ], 64))
                  ])
                ]),
                (I = e.purchaseFacts) != null && I.hasCurrentLoan && ((T = e.purchaseFacts) != null && T.loan) ? (p(), h(A, { key: 0 }, [
                  a("div", V6t, [
                    t[12] || (t[12] = a("div", { class: "col-6" }, "Original Amount:", -1)),
                    a("div", D6t, g(e.currency((k = (x = e.purchaseFacts) == null ? void 0 : x.loan) == null ? void 0 : k.amount)), 1)
                  ]),
                  a("div", N6t, [
                    t[13] || (t[13] = a("div", { class: "col-6" }, "Interest Rate:", -1)),
                    a("div", j6t, g(e.percent((O = (C = e.purchaseFacts) == null ? void 0 : C.loan) == null ? void 0 : O.interestRate, 1)), 1)
                  ]),
                  a("div", H6t, [
                    t[14] || (t[14] = a("div", { class: "col-6" }, "Payment (P&I):", -1)),
                    a("div", U6t, g(e.currency(e.loanPayment)), 1)
                  ]),
                  a("div", z6t, [
                    t[15] || (t[15] = a("div", { class: "col-6" }, " Total Principal Reduction: ", -1)),
                    a("div", W6t, g(e.percent(e.principalReduction)), 1),
                    a("div", G6t, [
                      N(o, {
                        value: e.principalReductionWhole,
                        showValue: !1,
                        style: { height: "10px" }
                      }, null, 8, ["value"])
                    ])
                  ])
                ], 64)) : P("", !0)
              ])
            ]),
            a("div", Y6t, [
              a("div", null, [
                t[16] || (t[16] = a("div", null, "Current Equity", -1)),
                a("div", X6t, g(e.currency(e.netEquity)), 1),
                a("small", q6t, g(e.currentMonth) + " / " + g(e.currentYear), 1)
              ])
            ])
          ])
        ]),
        a("div", Q6t, [
          a("button", {
            type: "button",
            class: "btn btn-sm btn-light rounded-pill",
            onClick: t[0] || (t[0] = (te) => e.showInvestmentDetails = !0)
          }, t[17] || (t[17] = [
            a("i", { class: "fa-light fa-file-invoice-dollar me-2" }, null, -1),
            y("Edit Purchase Information")
          ])),
          t[18] || (t[18] = a("button", {
            type: "button",
            class: "btn btn-sm btn-light rounded-pill",
            "data-bs-toggle": "modal",
            "data-bs-target": "#dialogPropertyValueEquity"
          }, [
            a("i", { class: "fa-light fa-chart-mixed-up-circle-dollar me-2" }),
            y("Edit Property Value")
          ], -1))
        ])
      ])
    ], 2),
    a("div", K6t, [
      a("div", Z6t, [
        a("div", J6t, [
          t[28] || (t[28] = a("div", { class: "modal-header border-0 pb-2" }, [
            a("p", {
              class: "modal-title fs-5 fw-bold",
              id: "dialogPropertyValueLabel"
            }, "Property Value & Equity"),
            a("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            })
          ], -1)),
          ((E = e.alertMessage) == null ? void 0 : E.length) > 0 ? (p(), h("div", $6t, [
            a("div", _6t, [
              (p(!0), h(A, null, D(e.alertMessage, (te) => (p(), h("div", null, [
                t[20] || (t[20] = a("i", { class: "fa-light fa-triangle-exclamation me-2" }, null, -1)),
                y(g(te), 1)
              ]))), 256))
            ])
          ])) : P("", !0),
          a("div", eTt, [
            a("div", tTt, [
              a("div", sTt, [
                a("label", aTt, [
                  e.isAtPurchase ? (p(), h(A, { key: 0 }, [
                    y(" Value at Purchase ")
                  ], 64)) : (p(), h(A, { key: 1 }, [
                    y(" Value When First Rented ")
                  ], 64))
                ]),
                a("div", nTt, [
                  e.isAtPurchase ? (p(), h(A, { key: 0 }, [
                    y(g(e.currency((B = e.purchaseFacts) == null ? void 0 : B.purchasePrice)), 1)
                  ], 64)) : (p(), h(A, { key: 1 }, [
                    y(g(e.currency((M = e.purchaseFacts) == null ? void 0 : M.investmentBasis)), 1)
                  ], 64))
                ]),
                t[21] || (t[21] = a("label", { class: "col-form-label col-md-6 col-lg-3 fw-bold border-start text-center" }, " Current Value ", -1)),
                a("div", rTt, [
                  N(l, {
                    modelValue: e.calcParams.propertyValueEoY,
                    "onUpdate:modelValue": t[1] || (t[1] = (te) => e.calcParams.propertyValueEoY = te),
                    currency: ""
                  }, null, 8, ["modelValue"])
                ])
              ])
            ])
          ]),
          ((F = (R = e.purchaseFacts) == null ? void 0 : R.years) == null ? void 0 : F.length) == 0 ? (p(), h("div", oTt, t[22] || (t[22] = [
            a("i", { class: "fa-light fa-circle-info me-2" }, null, -1),
            y(" Only complete calendar years may be entered. ")
          ]))) : P("", !0),
          a("div", iTt, [
            a("div", lTt, [
              ((L = e.purchaseFactsYears) == null ? void 0 : L.length) > 0 ? (p(), h("table", dTt, [
                a("thead", null, [
                  a("tr", cTt, [
                    a("th", uTt, [
                      a("button", {
                        type: "button",
                        onClick: t[2] || (t[2] = (te) => e.autoPopulateValueEquity()),
                        disabled: e.cantAutoPopulate,
                        class: "btn btn-outline-eclipse btn-sm"
                      }, t[23] || (t[23] = [
                        a("i", { class: "fa-duotone fa-solid fa-wand-sparkles me-2" }, null, -1),
                        y("Estimate Annual Values")
                      ]), 8, pTt)
                    ]),
                    e.isCurrentYear ? (p(), h("th", mTt, g(e.currentYear), 1)) : (p(!0), h(A, { key: 0 }, D(e.purchaseFactsYears, (te) => (p(), h("th", hTt, g(te.year), 1))), 256))
                  ])
                ]),
                a("tbody", null, [
                  a("tr", null, [
                    t[24] || (t[24] = a("th", null, [
                      y(" Property Value"),
                      a("br"),
                      a("small", { class: "text-secondary fw-normal" }, "(End of Year Value)")
                    ], -1)),
                    e.isCurrentYear ? (p(), h("th", gTt, [
                      a("span", vTt, g(e.currency(e.calcParams.propertyValueEoY)), 1)
                    ])) : (p(!0), h(A, { key: 0 }, D(e.purchaseFactsYears, (te) => (p(), h("td", fTt, [
                      N(l, {
                        modelValue: te.propertyValue,
                        "onUpdate:modelValue": (re) => te.propertyValue = re,
                        currency: ""
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]))), 256))
                  ]),
                  a("tr", null, [
                    t[25] || (t[25] = a("th", null, [
                      y(" Loan Balance"),
                      a("br"),
                      a("small", { class: "text-secondary fw-normal" }, "(End of Year Value)")
                    ], -1)),
                    e.isCurrentYear ? (p(), h("th", ATt, [
                      a("span", wTt, g(e.currency((j = e.propertyStore.getEoYAmortizationInfo(e.currentYear)) == null ? void 0 : j.remainingPrincipalBeforePayment, !1, "N/A")), 1)
                    ])) : (p(!0), h(A, { key: 0 }, D(e.purchaseFactsYears, (te) => (p(), h("td", yTt, [
                      a("span", bTt, g(e.currency(te.loanBalance, !1, "N/A")), 1)
                    ]))), 256))
                  ]),
                  a("tr", null, [
                    t[26] || (t[26] = a("th", null, "Cost of Sale", -1)),
                    e.isCurrentYear ? (p(), h("th", PTt, [
                      a("span", kTt, g(e.currency(e.calcParams.propertyValueEoY * e.calcParams.costofsale)), 1)
                    ])) : (p(!0), h(A, { key: 0 }, D(e.purchaseFactsYears, (te) => (p(), h("td", CTt, [
                      a("span", STt, g(e.currency(te.propertyValue * e.calcParams.costofsale)), 1)
                    ]))), 256))
                  ]),
                  a("tr", null, [
                    t[27] || (t[27] = a("th", null, "Equity", -1)),
                    e.isCurrentYear ? (p(), h("th", TTt, [
                      a("span", OTt, g(e.currency(e.calculateEquity(e.calcParams.propertyValueEoY, (H = e.propertyStore.getEoYAmortizationInfo(e.currentYear)) == null ? void 0 : H.remainingPrincipalBeforePayment))), 1)
                    ])) : (p(!0), h(A, { key: 0 }, D(e.purchaseFactsYears, (te) => (p(), h("td", ETt, [
                      a("span", ITt, g(e.currency(e.calculateEquityForYear(te))), 1)
                    ]))), 256))
                  ])
                ])
              ])) : P("", !0)
            ])
          ]),
          a("div", RTt, [
            a("button", {
              type: "button",
              class: "btn btn-lava",
              onClick: t[3] || (t[3] = (...te) => e.saveFields && e.saveFields(...te))
            }, "Calculate & Save")
          ])
        ])
      ])
    ], 512),
    N(d, {
      show: e.showInvestmentDetails,
      "onUpdate:show": t[4] || (t[4] = (te) => e.showInvestmentDetails = te)
    }, null, 8, ["show"])
  ], 64);
}
const BTt = /* @__PURE__ */ Ae(m6t, [["render", LTt]]);
Rt.register(
  Xr,
  Kr,
  Qr,
  qr,
  Jr,
  $r,
  Zr,
  Pi,
  ki,
  Ei,
  Ii,
  Ti,
  Oi
);
const MTt = me({
  name: "DistributionsPaid",
  props: {},
  components: {},
  data() {
    return {
      charts: {
        distributions: null,
        trustBalance: null,
        equity: null,
        principalReduction: null,
        cashFlow: null,
        expenseBreakdown: null
      }
    };
  },
  computed: {
    ...q(Te, ["access", "aclLoaded"])
  },
  methods: {
    number: Ve,
    initCharts() {
      this.createDistributionsChart(), this.createTrustBalanceChart(), this.createEquityChart(), this.createPrincipalReductionChart(), this.createCashFlowChart(), this.createExpenseBreakdownChart();
    },
    createDistributionsChart() {
      const e = ["Jul", "Aug", "Sep", "Oct", "Nov", "Dec", "Jan", "Feb", "Mar", "Apr", "May", "Jun"], t = [200, 200, 0, 0, 200, 200, 200, 1750, 200, 0, 200, 0], s = this.$refs.distributionsChart;
      s && (this.charts.distributions = new Rt(s, {
        type: "bar",
        data: {
          labels: e,
          datasets: [{
            label: "Monthly Distributions",
            data: t,
            backgroundColor: "#31ad6f",
            barThickness: 15
          }]
        },
        options: {
          responsive: !0,
          maintainAspectRatio: !1,
          plugins: {
            legend: {
              display: !1
            }
          },
          scales: {
            y: {
              beginAtZero: !0,
              grid: {
                display: !0,
                drawBorder: !1
              },
              ticks: {
                display: !1
              }
            },
            x: {
              grid: {
                display: !1
              }
            }
          }
        }
      }));
    },
    createTrustBalanceChart() {
      const e = [
        {
          label: "Security Deposit",
          value: 2200,
          color: "#6c757d"
        },
        {
          label: "Repair Reserve",
          value: 500,
          color: "#ffc107"
        },
        {
          label: "Available for Distribution",
          value: 900,
          color: "#31ad6f"
        }
      ], t = this.$refs.trustBalanceChart;
      t && (this.charts.trustBalance = new Rt(t, {
        type: "bar",
        data: {
          labels: ["Trust Account Balance"],
          datasets: e.map((s) => ({
            label: s.label,
            data: [s.value],
            backgroundColor: s.color,
            barPercentage: 1,
            categoryPercentage: 1
          }))
        },
        options: {
          indexAxis: "y",
          responsive: !0,
          maintainAspectRatio: !1,
          plugins: {
            legend: {
              display: !1
            },
            tooltip: {
              enabled: !0,
              callbacks: {
                title: function() {
                  return "Trust Account Balance";
                },
                label: function(s) {
                  return `${s.dataset.label}: $${s.raw.toLocaleString()}`;
                }
              }
            }
          },
          scales: {
            x: {
              stacked: !0,
              grid: {
                display: !1
              },
              ticks: {
                callback: function(s) {
                  return "$" + s;
                }
              }
            },
            y: {
              stacked: !0,
              grid: {
                display: !1
              },
              ticks: {
                display: !1
              }
            }
          },
          animation: {
            onComplete: () => {
              this.positionTrustBalanceLines(), this.drawTrustBalanceLabels();
            }
          }
        }
      }));
    },
    drawTrustBalanceLabels() {
      const e = this.charts.trustBalance;
      if (!e) return;
      const t = e.ctx, s = e.data.datasets;
      t.save(), t.fillStyle = "white", t.font = "bold 12px Arial", t.textAlign = "center", t.textBaseline = "middle";
      let n = 0;
      const r = e.chartArea, i = 3600, o = r.right - r.left;
      s.forEach((l, d) => {
        const u = e.getDatasetMeta(d).data[0], m = l.data[0], f = m / i * o, v = r.left + n + f / 2, b = u.y;
        f > 60 && t.fillText(`$${m}`, v, b), n += f;
      }), t.restore();
    },
    positionTrustBalanceLines() {
      const e = this.charts.trustBalance;
      if (!e) return;
      const t = e.chartArea, s = t.right - t.left, n = this.$refs.thresholdLine;
      n && (n.style.left = `${t.left + s * 0.75}px`);
      const r = this.$refs.balanceLine;
      r && (r.style.left = `${t.right}px`, r.style.right = "auto");
    },
    createEquityChart() {
      const e = ["2024", "2025", "2026", "2027", "2028", "2029", "2030", "2031", "2032", "2033"], t = [2e5, 185e3, 17e4, 155e3, 14e4, 125e3, 11e4, 95e3, 8e4, 65e3], s = [55e4, 57e4, 59e4, 61e4, 63e4, 65e4, 67e4, 69e4, 71e4, 73e4], n = this.$refs.equityChart;
      n && (this.charts.equity = new Rt(n, {
        type: "line",
        data: {
          labels: e,
          datasets: [
            {
              label: "Loan Balance",
              data: t,
              backgroundColor: "rgba(52, 174, 242, 0.7)",
              borderColor: "rgba(52, 174, 242, 0.8)",
              borderWidth: 1,
              fill: "origin",
              order: 3
            },
            {
              label: "Property Value",
              data: s,
              backgroundColor: "rgba(49, 173, 111, 0.8)",
              borderColor: "#2196F3",
              borderWidth: 2,
              fill: "-1",
              // Fill to the previous dataset (Loan Balance)
              pointRadius: 0,
              pointHoverRadius: 4,
              order: 1
            }
          ]
        },
        options: {
          responsive: !0,
          maintainAspectRatio: !1,
          interaction: {
            mode: "index",
            intersect: !1
          },
          plugins: {
            legend: {
              position: "top",
              align: "start",
              labels: {
                usePointStyle: !0,
                pointStyle: "line",
                generateLabels: function(r) {
                  return [
                    {
                      text: "Property Value",
                      fillStyle: "transparent",
                      strokeStyle: "#2196F3",
                      lineWidth: 2
                    },
                    {
                      text: "Equity",
                      fillStyle: "rgba(49, 173, 111, 0.8)",
                      strokeStyle: "rgba(49, 173, 111, 0.9)"
                    },
                    {
                      text: "Loan Balance",
                      fillStyle: "rgba(52, 174, 242, 0.7)",
                      strokeStyle: "rgba(52, 174, 242, 0.8)"
                    }
                  ];
                }
              }
            },
            tooltip: {
              callbacks: {
                label: function(r) {
                  if (r.datasetIndex === 0)
                    return `Loan Balance: $${r.raw.toLocaleString()}`;
                  {
                    const i = t[r.dataIndex], o = r.raw, l = o - i;
                    return [
                      `Property Value: $${o.toLocaleString()}`,
                      `Equity: $${l.toLocaleString()}`
                    ];
                  }
                }
              }
            }
          },
          scales: {
            x: {
              grid: {
                display: !0,
                color: "rgba(0,0,0,0.1)"
              },
              title: {
                display: !0,
                text: "Year"
              }
            },
            y: {
              beginAtZero: !0,
              grid: {
                display: !0,
                color: "rgba(0,0,0,0.1)"
              },
              title: {
                display: !0,
                text: "Dollars"
              },
              ticks: {
                callback: function(r) {
                  return "$" + r / 1e3 + "k";
                }
              }
            }
          }
        }
      }));
    },
    createPrincipalReductionChart() {
      const e = this.$refs.principalReductionChart;
      e && (this.charts.principalReduction = new Rt(e, {
        type: "bar",
        data: {
          labels: ["Principal Reduction"],
          datasets: [
            {
              label: "Reduced",
              data: [38],
              backgroundColor: "#31ad6f",
              barPercentage: 1,
              categoryPercentage: 1
            },
            {
              label: "Remaining",
              data: [62],
              backgroundColor: "#e9ecef",
              barPercentage: 1,
              categoryPercentage: 1
            }
          ]
        },
        options: {
          indexAxis: "y",
          responsive: !0,
          maintainAspectRatio: !1,
          plugins: {
            legend: {
              display: !1
            },
            tooltip: {
              callbacks: {
                label: function(t) {
                  return `${t.dataset.label}: ${t.raw}%`;
                }
              }
            }
          },
          scales: {
            x: {
              stacked: !0,
              display: !1,
              max: 100
            },
            y: {
              stacked: !0,
              display: !1
            }
          }
        }
      }));
    },
    createCashFlowChart() {
      const e = this.$refs.cashFlowChart;
      e && (this.charts.cashFlow = new Rt(e, {
        type: "bar",
        data: {
          labels: ["Income", `Operating
Expenses`, `Debt
Service`, "Net Cash Flow"],
          datasets: [
            // Base/positioning bars (transparent)
            {
              label: "Base",
              data: [0, 10900, 5900, 0],
              backgroundColor: "transparent",
              borderColor: "transparent",
              barThickness: 80,
              order: 1
            },
            // Visible value bars
            {
              label: "Values",
              data: [26400, 15500, 5e3, 5900],
              backgroundColor: ["#2196F3", "#FF9800", "#17a2b8", "#31ad6f"],
              barThickness: 80,
              order: 2
            }
          ]
        },
        options: {
          responsive: !0,
          maintainAspectRatio: !1,
          plugins: {
            legend: {
              display: !1
            },
            tooltip: {
              filter: function(d) {
                return d.datasetIndex === 1;
              },
              callbacks: {
                label: function(d) {
                  const c = ["Income", "Operating Expenses", "Debt Service", "Net Cash Flow"], m = [26400, -15500, -5e3, 5900][d.dataIndex];
                  return `${c[d.dataIndex]}: $${Math.abs(m).toLocaleString()}`;
                }
              }
            }
          },
          scales: {
            x: {
              stacked: !0,
              grid: {
                display: !1
              }
            },
            y: {
              stacked: !0,
              beginAtZero: !0,
              max: 3e4,
              ticks: {
                callback: function(d) {
                  return "$" + d / 1e3 + "k";
                }
              },
              grid: {
                display: !0,
                color: "rgba(0,0,0,0.1)"
              }
            }
          }
        }
      }));
    },
    createExpenseBreakdownChart() {
      const e = this.$refs.expenseBreakdownChart;
      e && (this.charts.expenseBreakdown = new Rt(e, {
        type: "doughnut",
        data: {
          labels: ["Taxes", "Maintenance", "Management", "Insurance", "Other", "Debt Service", "Deficit"],
          datasets: [{
            data: [12, 10, 8, 4, 3, 62, 21],
            backgroundColor: [
              "#ffc107",
              "#ff6b35",
              "#dc3545",
              "#e91e63",
              "#17a2b8",
              "#17a2b8",
              "#20c997"
            ],
            borderWidth: 2,
            borderColor: "#fff"
          }]
        },
        options: {
          responsive: !0,
          maintainAspectRatio: !1,
          cutout: "60%",
          plugins: {
            legend: {
              display: !1
            },
            tooltip: {
              callbacks: {
                label: function(t) {
                  return t.label + ": " + t.parsed + "%";
                }
              }
            }
          }
        }
      }));
    }
  },
  created() {
  },
  mounted() {
    this.initCharts(), this.aclLoaded.then(() => {
    });
  }
}), xTt = { class: "card h-100 shadow-sm" }, FTt = { class: "card-body" }, VTt = { style: { height: "150px" } }, DTt = { ref: "distributionsChart" };
function NTt(e, t, s, n, r, i) {
  return p(), h("div", xTt, [
    t[1] || (t[1] = a("div", { class: "card-header bg-eclipse text-white rounded rounded-bottom-0 fw-bold text-uppercase text-center text-sm-start" }, " Distributions Paid (T-12) ", -1)),
    t[2] || (t[2] = a("div", { class: "card-body border-bottom" }, [
      a("div", { class: "text-success fw-bold fs-2" }, "$4,135"),
      a("div", { class: "text-muted" }, "Paid out to you in the past 12 months")
    ], -1)),
    a("div", FTt, [
      t[0] || (t[0] = a("p", { class: "fw-bold" }, "Monthly Distributions", -1)),
      a("div", VTt, [
        a("canvas", DTt, null, 512)
      ])
    ]),
    t[3] || (t[3] = Bt('<div class="card-body d-flex justify-content-between gap-2 text-center"><div class="border p-2 flex-fill rounded"><div class="fw-bold">8 of 12</div><div class="small text-muted">Months Paid</div></div><div class="border p-2 flex-fill rounded"><div class="fw-bold">$345</div><div class="small text-muted">Avg / Month</div></div><div class="border p-2 flex-fill rounded"><div class="fw-bold">$1,750 (Feb)</div><div class="small text-muted">Largest Month</div></div></div>', 1))
  ]);
}
const jTt = /* @__PURE__ */ Ae(MTt, [["render", NTt]]);
Rt.register(
  Xr,
  Kr,
  Qr,
  qr,
  Jr,
  $r,
  Zr,
  Pi,
  ki,
  Ei,
  Ii,
  Ti,
  Oi
);
const HTt = me({
  name: "TrustAccountBalance",
  props: {},
  components: {},
  data() {
    return {
      charts: {
        distributions: null,
        trustBalance: null,
        equity: null,
        principalReduction: null,
        cashFlow: null,
        expenseBreakdown: null
      }
    };
  },
  computed: {
    ...q(Te, ["access", "aclLoaded"])
  },
  methods: {
    number: Ve,
    initCharts() {
      this.createDistributionsChart(), this.createTrustBalanceChart(), this.createEquityChart(), this.createPrincipalReductionChart(), this.createCashFlowChart(), this.createExpenseBreakdownChart();
    },
    createDistributionsChart() {
      const e = ["Jul", "Aug", "Sep", "Oct", "Nov", "Dec", "Jan", "Feb", "Mar", "Apr", "May", "Jun"], t = [200, 200, 0, 0, 200, 200, 200, 1750, 200, 0, 200, 0], s = this.$refs.distributionsChart;
      s && (this.charts.distributions = new Rt(s, {
        type: "bar",
        data: {
          labels: e,
          datasets: [{
            label: "Monthly Distributions",
            data: t,
            backgroundColor: "#31ad6f",
            barThickness: 15
          }]
        },
        options: {
          responsive: !0,
          maintainAspectRatio: !1,
          plugins: {
            legend: {
              display: !1
            }
          },
          scales: {
            y: {
              beginAtZero: !0,
              grid: {
                display: !0,
                drawBorder: !1
              },
              ticks: {
                display: !1
              }
            },
            x: {
              grid: {
                display: !1
              }
            }
          }
        }
      }));
    },
    createTrustBalanceChart() {
      const e = [
        {
          label: "Security Deposit",
          value: 2200,
          color: "#6c757d"
        },
        {
          label: "Repair Reserve",
          value: 500,
          color: "#ffc107"
        },
        {
          label: "Available for Distribution",
          value: 900,
          color: "#31ad6f"
        }
      ], t = this.$refs.trustBalanceChart;
      t && (this.charts.trustBalance = new Rt(t, {
        type: "bar",
        data: {
          labels: ["Trust Account Balance"],
          datasets: e.map((s) => ({
            label: s.label,
            data: [s.value],
            backgroundColor: s.color,
            barPercentage: 1,
            categoryPercentage: 1
          }))
        },
        options: {
          indexAxis: "y",
          responsive: !0,
          maintainAspectRatio: !1,
          plugins: {
            legend: {
              display: !1
            },
            tooltip: {
              enabled: !0,
              callbacks: {
                title: function() {
                  return "Trust Account Balance";
                },
                label: function(s) {
                  return `${s.dataset.label}: $${s.raw.toLocaleString()}`;
                }
              }
            }
          },
          scales: {
            x: {
              stacked: !0,
              grid: {
                display: !1
              },
              ticks: {
                callback: function(s) {
                  return "$" + s;
                }
              }
            },
            y: {
              stacked: !0,
              grid: {
                display: !1
              },
              ticks: {
                display: !1
              }
            }
          },
          animation: {
            onComplete: () => {
              this.positionTrustBalanceLines(), this.drawTrustBalanceLabels();
            }
          }
        }
      }));
    },
    drawTrustBalanceLabels() {
      const e = this.charts.trustBalance;
      if (!e) return;
      const t = e.ctx, s = e.data.datasets;
      t.save(), t.fillStyle = "white", t.font = "bold 12px Arial", t.textAlign = "center", t.textBaseline = "middle";
      let n = 0;
      const r = e.chartArea, i = 3600, o = r.right - r.left;
      s.forEach((l, d) => {
        const u = e.getDatasetMeta(d).data[0], m = l.data[0], f = m / i * o, v = r.left + n + f / 2, b = u.y;
        f > 60 && t.fillText(`$${m}`, v, b), n += f;
      }), t.restore();
    },
    positionTrustBalanceLines() {
      const e = this.charts.trustBalance;
      if (!e) return;
      const t = e.chartArea, s = t.right - t.left, n = this.$refs.thresholdLine;
      n && (n.style.left = `${t.left + s * 0.75}px`);
      const r = this.$refs.balanceLine;
      r && (r.style.left = `${t.right}px`, r.style.right = "auto");
    },
    createEquityChart() {
      const e = ["2024", "2025", "2026", "2027", "2028", "2029", "2030", "2031", "2032", "2033"], t = [2e5, 185e3, 17e4, 155e3, 14e4, 125e3, 11e4, 95e3, 8e4, 65e3], s = [55e4, 57e4, 59e4, 61e4, 63e4, 65e4, 67e4, 69e4, 71e4, 73e4], n = this.$refs.equityChart;
      n && (this.charts.equity = new Rt(n, {
        type: "line",
        data: {
          labels: e,
          datasets: [
            {
              label: "Loan Balance",
              data: t,
              backgroundColor: "rgba(52, 174, 242, 0.7)",
              borderColor: "rgba(52, 174, 242, 0.8)",
              borderWidth: 1,
              fill: "origin",
              order: 3
            },
            {
              label: "Property Value",
              data: s,
              backgroundColor: "rgba(49, 173, 111, 0.8)",
              borderColor: "#2196F3",
              borderWidth: 2,
              fill: "-1",
              // Fill to the previous dataset (Loan Balance)
              pointRadius: 0,
              pointHoverRadius: 4,
              order: 1
            }
          ]
        },
        options: {
          responsive: !0,
          maintainAspectRatio: !1,
          interaction: {
            mode: "index",
            intersect: !1
          },
          plugins: {
            legend: {
              position: "top",
              align: "start",
              labels: {
                usePointStyle: !0,
                pointStyle: "line",
                generateLabels: function(r) {
                  return [
                    {
                      text: "Property Value",
                      fillStyle: "transparent",
                      strokeStyle: "#2196F3",
                      lineWidth: 2
                    },
                    {
                      text: "Equity",
                      fillStyle: "rgba(49, 173, 111, 0.8)",
                      strokeStyle: "rgba(49, 173, 111, 0.9)"
                    },
                    {
                      text: "Loan Balance",
                      fillStyle: "rgba(52, 174, 242, 0.7)",
                      strokeStyle: "rgba(52, 174, 242, 0.8)"
                    }
                  ];
                }
              }
            },
            tooltip: {
              callbacks: {
                label: function(r) {
                  if (r.datasetIndex === 0)
                    return `Loan Balance: $${r.raw.toLocaleString()}`;
                  {
                    const i = t[r.dataIndex], o = r.raw, l = o - i;
                    return [
                      `Property Value: $${o.toLocaleString()}`,
                      `Equity: $${l.toLocaleString()}`
                    ];
                  }
                }
              }
            }
          },
          scales: {
            x: {
              grid: {
                display: !0,
                color: "rgba(0,0,0,0.1)"
              },
              title: {
                display: !0,
                text: "Year"
              }
            },
            y: {
              beginAtZero: !0,
              grid: {
                display: !0,
                color: "rgba(0,0,0,0.1)"
              },
              title: {
                display: !0,
                text: "Dollars"
              },
              ticks: {
                callback: function(r) {
                  return "$" + r / 1e3 + "k";
                }
              }
            }
          }
        }
      }));
    },
    createPrincipalReductionChart() {
      const e = this.$refs.principalReductionChart;
      e && (this.charts.principalReduction = new Rt(e, {
        type: "bar",
        data: {
          labels: ["Principal Reduction"],
          datasets: [
            {
              label: "Reduced",
              data: [38],
              backgroundColor: "#31ad6f",
              barPercentage: 1,
              categoryPercentage: 1
            },
            {
              label: "Remaining",
              data: [62],
              backgroundColor: "#e9ecef",
              barPercentage: 1,
              categoryPercentage: 1
            }
          ]
        },
        options: {
          indexAxis: "y",
          responsive: !0,
          maintainAspectRatio: !1,
          plugins: {
            legend: {
              display: !1
            },
            tooltip: {
              callbacks: {
                label: function(t) {
                  return `${t.dataset.label}: ${t.raw}%`;
                }
              }
            }
          },
          scales: {
            x: {
              stacked: !0,
              display: !1,
              max: 100
            },
            y: {
              stacked: !0,
              display: !1
            }
          }
        }
      }));
    },
    createCashFlowChart() {
      const e = this.$refs.cashFlowChart;
      e && (this.charts.cashFlow = new Rt(e, {
        type: "bar",
        data: {
          labels: ["Income", `Operating
Expenses`, `Debt
Service`, "Net Cash Flow"],
          datasets: [
            // Base/positioning bars (transparent)
            {
              label: "Base",
              data: [0, 10900, 5900, 0],
              backgroundColor: "transparent",
              borderColor: "transparent",
              barThickness: 80,
              order: 1
            },
            // Visible value bars
            {
              label: "Values",
              data: [26400, 15500, 5e3, 5900],
              backgroundColor: ["#2196F3", "#FF9800", "#17a2b8", "#31ad6f"],
              barThickness: 80,
              order: 2
            }
          ]
        },
        options: {
          responsive: !0,
          maintainAspectRatio: !1,
          plugins: {
            legend: {
              display: !1
            },
            tooltip: {
              filter: function(d) {
                return d.datasetIndex === 1;
              },
              callbacks: {
                label: function(d) {
                  const c = ["Income", "Operating Expenses", "Debt Service", "Net Cash Flow"], m = [26400, -15500, -5e3, 5900][d.dataIndex];
                  return `${c[d.dataIndex]}: $${Math.abs(m).toLocaleString()}`;
                }
              }
            }
          },
          scales: {
            x: {
              stacked: !0,
              grid: {
                display: !1
              }
            },
            y: {
              stacked: !0,
              beginAtZero: !0,
              max: 3e4,
              ticks: {
                callback: function(d) {
                  return "$" + d / 1e3 + "k";
                }
              },
              grid: {
                display: !0,
                color: "rgba(0,0,0,0.1)"
              }
            }
          }
        }
      }));
    },
    createExpenseBreakdownChart() {
      const e = this.$refs.expenseBreakdownChart;
      e && (this.charts.expenseBreakdown = new Rt(e, {
        type: "doughnut",
        data: {
          labels: ["Taxes", "Maintenance", "Management", "Insurance", "Other", "Debt Service", "Deficit"],
          datasets: [{
            data: [12, 10, 8, 4, 3, 62, 21],
            backgroundColor: [
              "#ffc107",
              "#ff6b35",
              "#dc3545",
              "#e91e63",
              "#17a2b8",
              "#17a2b8",
              "#20c997"
            ],
            borderWidth: 2,
            borderColor: "#fff"
          }]
        },
        options: {
          responsive: !0,
          maintainAspectRatio: !1,
          cutout: "60%",
          plugins: {
            legend: {
              display: !1
            },
            tooltip: {
              callbacks: {
                label: function(t) {
                  return t.label + ": " + t.parsed + "%";
                }
              }
            }
          }
        }
      }));
    }
  },
  created() {
  },
  mounted() {
    this.initCharts(), this.aclLoaded.then(() => {
    });
  }
}), UTt = { class: "card h-100 shadow-sm" }, zTt = { class: "card-body border-bottom justify-content-center d-flex flex-column" }, WTt = { style: { height: "80px", position: "relative" } }, GTt = { ref: "trustBalanceChart" }, YTt = {
  ref: "thresholdLine",
  class: "position-absolute",
  style: { top: "0", bottom: "0", width: "2px", "background-color": "blue", "z-index": "10" }
}, XTt = {
  ref: "balanceLine",
  class: "position-absolute",
  style: { top: "0", bottom: "0", right: "0", width: "2px", "background-color": "green", "z-index": "10" }
};
function qTt(e, t, s, n, r, i) {
  return p(), h("div", UTt, [
    t[1] || (t[1] = a("div", { class: "card-header bg-eclipse text-white rounded rounded-bottom-0 fw-bold text-uppercase text-center text-sm-start" }, " Trust Account Balance ", -1)),
    t[2] || (t[2] = a("div", { class: "card-body border-bottom flex-grow-0" }, [
      a("div", null, [
        y("Current Balance: "),
        a("span", { class: "fw-bold" }, "$3,600")
      ])
    ], -1)),
    a("div", zTt, [
      a("div", WTt, [
        a("canvas", GTt, null, 512),
        a("div", YTt, null, 512),
        a("div", XTt, null, 512)
      ]),
      t[0] || (t[0] = Bt('<div class="d-flex flex-wrap mt-4 gap-2"><div><i class="fa-solid fa-square text-secondary me-1"></i> Security Deposit </div><div><i class="fa-solid fa-square text-warning me-1"></i> Repair Reserve </div><div><i class="fa-solid fa-square text-success me-1"></i> Available for Distribution </div><div><i class="fa-solid fa-pipe text-primary me-1"></i> Minimum Threshold </div><div><i class="fa-solid fa-pipe text-success me-1"></i> Current Balance </div></div>', 1))
    ]),
    t[3] || (t[3] = Bt('<div class="card-body flex-grow-0"><div class="d-flex justify-content-between"><div>Most recent Distribution:</div><div class="d-flex"><div class="me-4">5/15/2025</div><div class="fw-bold">$345</div></div></div><div class="d-flex justify-content-between"><div>Upcoming Distribution:</div><div class="fw-bold">$900</div></div></div>', 1))
  ]);
}
const QTt = /* @__PURE__ */ Ae(HTt, [["render", qTt]]);
Rt.register(
  Xr,
  Kr,
  Qr,
  qr,
  Jr,
  $r,
  Zr,
  Pi,
  ki,
  Ei,
  Ii,
  Ti,
  Oi
);
const KTt = me({
  name: "EquityValueForecast",
  data() {
    return {};
  },
  watch: {
    years() {
      this.refreshChart();
    }
  },
  computed: {
    holdYearValues() {
      return this.rentalTypeResultYears.find((e) => e.fiscalYear == this.holdYear + Et - 1);
    },
    equityGain() {
      var e;
      return ((e = this.holdYearValues) == null ? void 0 : e.netEquity) - this.netEquity;
    },
    currentYear() {
      return Et;
    },
    years() {
      return this.rentalTypeResultYears.filter((e) => e.fiscalYear >= Et).sort((e, t) => e.fiscalYear - t.fiscalYear).slice(0, this.holdYear);
    },
    ...q(Te, ["access", "aclLoaded"]),
    ...q(qe, ["propertyValue", "netEquity", "rentalTypeResultYears", "holdYear", "calcParams"])
  },
  methods: {
    number: Ve,
    percent: Wt,
    currency: Ze,
    initCharts() {
      this.createEquityChart();
    },
    refreshChart() {
      if (!this.equity) return;
      const e = this.years.map((r) => `${r.fiscalYear}`) ?? [], t = this.years.map((r) => r.loanBalance) ?? [], s = this.years.map((r) => r.loanBalance + r.costOfSale) ?? [], n = this.years.map((r) => r.propertyValue) ?? [];
      this.equity.data.labels = e, this.equity.data.datasets[0].data = t, this.equity.data.datasets[1].data = s, this.equity.data.datasets[2].data = n, this.equity.update();
    },
    createEquityChart() {
      const e = this.years.map((i) => `${i.fiscalYear}`) ?? [], t = this.years.map((i) => i.loanBalance) ?? [], s = this.years.map((i) => i.loanBalance + i.costOfSale) ?? [], n = this.years.map((i) => i.propertyValue) ?? [], r = this.$refs.equityChart;
      r && (this.equity = new Rt(r, {
        type: "line",
        data: {
          labels: e,
          datasets: [
            {
              label: "Loan Balance",
              data: t,
              backgroundColor: "rgba(52, 174, 242, 0.7)",
              //'blue'
              borderColor: "rgba(52, 174, 242, 0.8)",
              borderWidth: 1,
              fill: "origin",
              pointRadius: 0,
              pointHoverRadius: 4,
              order: 3
            },
            {
              label: "Cost of Sale",
              data: s,
              backgroundColor: "rgba(255, 193, 7, 0.7)",
              // Gold
              borderColor: "rgba(255, 193, 7, 0.8)",
              borderWidth: 1,
              fill: "-1",
              pointRadius: 0,
              pointHoverRadius: 4,
              order: 2
            },
            {
              label: "Property Value",
              data: n,
              backgroundColor: "rgba(49, 173, 111, 0.8)",
              //'green'
              borderColor: "#132844",
              borderWidth: 2,
              fill: "-1",
              pointRadius: 0,
              pointHoverRadius: 4,
              order: 1
            }
          ]
        },
        options: {
          responsive: !0,
          maintainAspectRatio: !1,
          interaction: {
            mode: "index",
            intersect: !1
          },
          plugins: {
            legend: {
              position: "top",
              align: "center",
              labels: {
                usePointStyle: !0,
                pointStyle: "line",
                generateLabels: function(i) {
                  return [
                    {
                      text: "Property Value",
                      fillStyle: "#132844",
                      strokeStyle: "#132844",
                      lineWidth: 2
                    },
                    {
                      text: "Equity",
                      fillStyle: "rgba(49, 173, 111, 0.8)",
                      strokeStyle: "rgba(49, 173, 111, 0.9)"
                    },
                    {
                      text: "Cost of Sale",
                      fillStyle: "rgba(255, 193, 7, 0.8)",
                      strokeStyle: "rgba(255, 193, 7, 0.9)"
                    },
                    {
                      text: "Loan Balance",
                      fillStyle: "rgba(52, 174, 242, 0.7)",
                      strokeStyle: "rgba(52, 174, 242, 0.8)"
                    }
                  ];
                }
              }
            },
            tooltip: {
              callbacks: {
                label: function(i) {
                  if (i.datasetIndex === 0) {
                    const o = t[i.dataIndex], l = n[i.dataIndex];
                    return [
                      `Loan Balance: ${Ze(o)}`,
                      `Property Value: ${Ze(l)}`
                    ];
                  } else if (i.datasetIndex === 1) {
                    const o = t[i.dataIndex], l = s[i.dataIndex];
                    return [
                      `Cost of Sale: ${Ze(l - o)}`
                    ];
                  } else if (i.datasetIndex === 2) {
                    const o = t[i.dataIndex], d = n[i.dataIndex] - o;
                    return [
                      `Equity: $${Ze(d)}`
                      //`Equity: $${formatters.currency(equity)}`
                    ];
                  }
                }
              }
            }
          },
          scales: {
            x: {
              grid: {
                display: !0,
                color: "rgba(0,0,0,0.1)"
              },
              title: {
                display: !0,
                text: "Year"
              }
            },
            y: {
              beginAtZero: !0,
              grid: {
                display: !0,
                color: "rgba(0,0,0,0.1)"
              },
              title: {
                display: !0,
                text: "Dollars"
              },
              ticks: {
                callback: function(i) {
                  return "$" + i / 1e3 + "k";
                }
              }
            }
          }
        },
        plugins: [
          {
            id: "customLabels",
            afterDraw: (i) => {
              const o = i.ctx, l = i.chartArea, d = i.data.datasets;
              i.getDatasetMeta(0), o.save(), o.fillStyle = "rgba(255, 255, 255, 0.8)", o.font = "bold 18px Arial", o.textAlign = "center", o.textBaseline = "middle", o.shadowColor = "rgba(0, 0, 0, 0.5)", o.shadowBlur = 5, o.shadowOffsetX = 2, o.shadowOffsetY = 2;
              const c = (l.left + l.right) / 2, u = Math.floor(d[0].data.length / 2), m = i.scales.y, f = d[0].data[u], v = d[1].data[u], b = d[2].data[u], w = m.getPixelForValue(f), S = m.getPixelForValue(v), I = m.getPixelForValue(b), T = m.getPixelForValue(0), x = (T + w) / 2, k = (w + S) / 2, C = (S + I) / 2, O = 30;
              Math.abs(T - w) > O && o.fillText("Loan Balance", c, x), Math.abs(w - S) > O && o.fillText("Cost of Sale", c, k), Math.abs(S - I) > O && o.fillText("Net Equity", c, C), o.restore();
            }
          }
        ]
      }));
    }
  },
  mounted() {
    this.aclLoaded.then(() => {
      this.initCharts();
    });
  }
}), ZTt = { class: "card h-100 shadow-sm" }, JTt = { class: "card-body text-center pb-0" }, $Tt = { class: "row row-cols-2 row-cols-xxl-4 g-3" }, _Tt = { class: "col" }, e9t = { class: "border p-2 flex-fill rounded" }, t9t = { class: "fs-4 fw-bold text-primary" }, s9t = { class: "col" }, a9t = { class: "border p-2 flex-fill rounded" }, n9t = { class: "fs-4 fw-bold" }, r9t = { class: "col" }, o9t = { class: "border p-2 flex-fill rounded" }, i9t = { class: "small text-muted" }, l9t = { class: "fs-4 fw-bold" }, d9t = { class: "col" }, c9t = { class: "border p-2 flex-fill rounded" }, u9t = { class: "small text-muted" }, p9t = { class: "card-body" }, h9t = { class: "small text-muted" }, m9t = {
  class: "mt-4",
  style: { height: "280px" }
}, f9t = { ref: "equityChart" };
function g9t(e, t, s, n, r, i) {
  var o;
  return p(), h("div", ZTt, [
    a("div", {
      class: "card-header bg-eclipse text-white rounded rounded-bottom-0 fw-bold text-uppercase text-center text-sm-start",
      onClick: t[0] || (t[0] = (...l) => e.refreshChart && e.refreshChart(...l))
    }, g(e.holdYear) + "-Year Equity & Value Forecast ", 1),
    a("div", JTt, [
      a("div", $Tt, [
        a("div", _Tt, [
          a("div", e9t, [
            t[1] || (t[1] = a("div", { class: "small text-muted" }, "Current Value", -1)),
            a("div", t9t, g(e.currency(e.propertyValue)), 1)
          ])
        ]),
        a("div", s9t, [
          a("div", a9t, [
            t[2] || (t[2] = a("div", { class: "small text-muted" }, "Current Equity", -1)),
            a("div", n9t, g(e.currency(e.netEquity)), 1)
          ])
        ]),
        a("div", r9t, [
          a("div", o9t, [
            a("div", i9t, "Projected Equity (" + g(e.currentYear + (e.holdYear - 1)) + ")", 1),
            a("div", l9t, g(e.currency((o = e.holdYearValues) == null ? void 0 : o.netEquity)), 1)
          ])
        ]),
        a("div", d9t, [
          a("div", c9t, [
            a("div", u9t, g(e.holdYear) + "-Year Equity Gain", 1),
            a("div", {
              class: z(["fs-4 fw-bold", { "text-success": e.equityGain >= 0, "text-danger": e.equityGain < 0 }])
            }, g(e.currency(e.equityGain)), 3)
          ])
        ])
      ])
    ]),
    a("div", p9t, [
      a("div", h9t, "Assumes " + g(e.percent(e.calcParams.propertyappreciation, 1, "-")) + " annual appreciation & scheduled loan amortization", 1),
      a("div", m9t, [
        a("canvas", f9t, null, 512)
      ])
    ])
  ]);
}
const v9t = /* @__PURE__ */ Ae(KTt, [["render", g9t]]);
Rt.register(
  Xr,
  Kr,
  Qr,
  qr,
  Jr,
  $r,
  Zr,
  Pi,
  ki,
  Ei,
  Ii,
  Ti,
  Oi
);
const y9t = me({
  name: "PurchaseAndLoan",
  emits: [
    "saveFields"
  ],
  components: {
    InvestmentDetails: wb,
    NumericalInput: Aa,
    ProgressBar: _y
  },
  data() {
    return {
      showInvestmentDetails: !1
    };
  },
  computed: {
    duration() {
      var c, u, m;
      let e = new Date((c = this.purchaseFacts) == null ? void 0 : c.firstYearAsRental, 1, 1);
      this.isAtPurchase && (e = (u = this.purchaseFacts) == null ? void 0 : u.purchaseDate);
      let t = e - ((m = this.purchaseFacts) == null ? void 0 : m.purchaseDate.getTime());
      const s = Math.floor(t / 31556952e3);
      s > 0 && (t -= s * 31556952e3);
      const n = Math.floor(t / 2629746e3);
      n > 0 && (t -= n * 2629746e3);
      const r = Math.floor(t / 6048e5);
      r > 0 && (t -= r * 6048e5);
      const i = Math.floor(t / 864e5);
      i > 0 && (t -= i * 864e5);
      const o = Math.floor(t / 36e5);
      o > 0 && (t -= o * 36e5);
      const l = Math.floor(t / 6e4);
      l > 0 && (t -= l * 6e4);
      const d = Math.floor(t / 1e3);
      return {
        years: s,
        months: n % 12,
        weeks: r,
        days: i,
        hours: o,
        minutes: l,
        seconds: d
      };
    },
    loanPayment() {
      var e;
      if ((e = this.purchaseFacts) != null && e.loan)
        return pn(
          this.purchaseFacts.loan.interestRate / 12,
          this.purchaseFacts.loan.term * 12,
          this.purchaseFacts.loan.amount
        );
    },
    currentYear() {
      return Et;
    },
    currentMonth() {
      return Xu;
    },
    loanBalance() {
      var n, r, i;
      if (!((n = this.purchaseFacts) != null && n.hasCurrentLoan))
        return;
      const e = 12 - this.purchaseFacts.loan.date.getMonth(), t = this.purchaseFacts.loan.date.getFullYear(), s = e + (this.currentYear - t) * 12;
      return (i = (r = this.amortizationSchedule) == null ? void 0 : r.find((o) => o.month == s)) == null ? void 0 : i.remainingPrincipalBeforePayment;
    },
    principalReduction() {
      var e, t, s;
      return (e = this.purchaseFacts) != null && e.hasCurrentLoan && ((s = (t = this.purchaseFacts) == null ? void 0 : t.loan) == null ? void 0 : s.amount) > 0 ? (this.purchaseFacts.loan.amount - this.loanBalance) / this.purchaseFacts.loan.amount : 0;
    },
    principalReductionWhole() {
      return Math.trunc(this.principalReduction * 100);
    },
    ...q(Te, ["access", "aclLoaded"]),
    ...q(qe, ["calculating", "purchaseFacts", "calcParams", "calculatedResults", "property", "purchaseYear", "isAtPurchase", "isCurrentYear", "cantAutoPopulate", "firstYearAsRental", "purchaseFactsYears", "amortizationSchedule"]),
    ...at(qe)
  },
  methods: {
    number: Ve,
    currency: Ze,
    percent: Wt,
    date: cs,
    formatDuration: af,
    initCharts() {
      this.createPrincipalReductionChart();
    },
    createPrincipalReductionChart() {
      const e = this.$refs.principalReductionChart;
      e && (this.principalReductionChart = new Rt(e, {
        type: "bar",
        data: {
          labels: ["Principal Reduction"],
          datasets: [
            {
              label: "Reduced",
              data: [this.principalReduction * 100],
              backgroundColor: "#31ad6f",
              barPercentage: 1,
              categoryPercentage: 1
            },
            {
              label: "Remaining",
              data: [(1 - this.principalReduction) * 100],
              backgroundColor: "#e9ecef",
              barPercentage: 1,
              categoryPercentage: 1
            }
          ]
        },
        options: {
          indexAxis: "y",
          responsive: !0,
          maintainAspectRatio: !1,
          plugins: {
            legend: {
              display: !1
            },
            tooltip: {
              enabled: !1,
              callbacks: {
                label: function(t) {
                  return `${t.dataset.label}: ${t.raw}%`;
                }
              }
            }
          },
          scales: {
            x: {
              stacked: !0,
              display: !1,
              max: 100
            },
            y: {
              stacked: !0,
              display: !1
            }
          }
        }
      }));
    },
    //#region Shared
    calculateEquityForYear(e) {
      return this.calculateEquity(e.propertyValue, e.loanBalance);
    },
    calculateEquity(e, t) {
      return e - (t ?? 0) - e * this.calcParams.costofsale;
    },
    autoPopulateValueEquity() {
      var t, s;
      const e = this.isAtPurchase ? (t = this.purchaseFacts) == null ? void 0 : t.purchasePrice : (s = this.purchaseFacts) == null ? void 0 : s.investmentBasis;
      this.propertyStore.autoPopulateValueEquity(e, this.firstYearAsRental, this.calcParams.propertyValueEoY, Et);
    },
    //#endregion
    saveFields() {
      this.$emit("saveFields"), bootstrap.Modal.getOrCreateInstance(this.$refs.dialogPropertyValue).hide();
    }
  },
  mounted() {
    this.aclLoaded.then(() => {
      this.initCharts();
    });
  }
}), b9t = { class: "card h-100 shadow-sm" }, A9t = { class: "card-body pb-0" }, w9t = { class: "row" }, C9t = { class: "col-6" }, S9t = { class: "fs-3 fw-bold" }, P9t = { class: "text-muted" }, k9t = {
  key: 0,
  class: "col-6 text-end"
}, E9t = { class: "fs-3 fw-bold" }, I9t = { class: "text-muted" }, T9t = { class: "d-flex justify-content-center align-items-center my-3" }, O9t = { class: "mx-3 fs-5 fw-bold" }, R9t = {
  key: 0,
  class: "text-body-secondary"
}, L9t = { class: "card-body pt-0" }, B9t = { class: "border rounded p-3" }, M9t = { class: "row row-cols-2 g-3" }, x9t = { class: "col" }, F9t = { class: "fw-bold" }, V9t = { class: "col text-end" }, D9t = { class: "fw-bold" }, N9t = { class: "col" }, j9t = { class: "fw-bold" }, H9t = { class: "col text-end" }, U9t = { class: "fw-bold" }, z9t = { class: "card-body" }, W9t = { class: "d-flex justify-content-between align-items-center" }, G9t = { class: "fa-5 fw-bold" }, Y9t = { class: "d-flex justify-content-between align-items-center" }, X9t = { class: "fs-5 fw-bold" }, q9t = { style: { height: "30px", "margin-top": "10px" } }, Q9t = { class: "card-body d-flex justify-content-between" }, K9t = {
  class: "modal fade",
  ref: "dialogPropertyValue",
  id: "dialogPropertyValueEquity",
  tabindex: "-1",
  "aria-labelledby": "dialogPropertyValueLabel",
  "aria-hidden": "true"
}, Z9t = { class: "modal-dialog modal-dialog-centered modal-lg" }, J9t = { class: "modal-content bg-gradient-alphabet rounded" }, $9t = { class: "card bg-white bg-opacity-50 mx-3 mb-3" }, _9t = { class: "card-body" }, eOt = { class: "row g-3" }, tOt = { class: "col-form-label col-md-6 col-lg-4 fw-bold" }, sOt = { class: "col-md-6 col-lg-2 d-flex align-items-center justify-content-center" }, aOt = { class: "col-md-6 col-lg-3" }, nOt = {
  key: 0,
  class: "alert alert-info",
  role: "alert"
}, rOt = { class: "modal-body p-0" }, oOt = { class: "table-scrollable" }, iOt = {
  key: 0,
  class: "table table-borderless table-striped"
}, lOt = { class: "text-center" }, dOt = { class: "column sticky-top" }, cOt = ["disabled"], uOt = { class: "column sticky-top" }, pOt = { key: 1 }, hOt = { class: "text-end" }, mOt = { key: 1 }, fOt = { class: "form-control-plaintext text-end" }, gOt = { class: "text-end" }, vOt = { class: "form-control-plaintext text-end" }, yOt = { key: 1 }, bOt = { class: "form-control-plaintext text-end" }, AOt = { class: "text-end" }, wOt = { class: "form-control-plaintext text-end" }, COt = { key: 1 }, SOt = { class: "form-control-plaintext text-end" }, POt = { class: "text-end" }, kOt = { class: "form-control-plaintext text-end" }, EOt = { key: 1 }, IOt = { class: "form-control-plaintext text-end" }, TOt = { class: "modal-footer" };
function OOt(e, t, s, n, r, i) {
  var c, u, m, f, v, b, w, S, I, T, x, k, C, O, E, B, M, R, F;
  const o = pe("ProgressBar"), l = pe("numerical-input"), d = pe("investment-details");
  return p(), h(A, null, [
    a("div", b9t, [
      t[17] || (t[17] = a("div", { class: "card-header bg-eclipse text-white rounded rounded-bottom-0 fw-bold text-uppercase text-center text-sm-start" }, " Purchase & Loan ", -1)),
      a("div", A9t, [
        a("div", w9t, [
          a("div", C9t, [
            t[5] || (t[5] = a("p", { class: "fs-6 mb-0" }, "Purchase", -1)),
            a("div", S9t, g(e.currency((c = e.purchaseFacts) == null ? void 0 : c.purchasePrice)), 1),
            a("div", P9t, g(e.date((u = e.purchaseFacts) == null ? void 0 : u.purchaseDate)), 1)
          ]),
          e.isAtPurchase ? P("", !0) : (p(), h("div", k9t, [
            t[6] || (t[6] = a("p", { class: "fs-6 mb-0" }, "Rental", -1)),
            a("div", E9t, g(e.currency((m = e.purchaseFacts) == null ? void 0 : m.investmentBasis)), 1),
            a("div", I9t, "1/1/" + g((f = e.purchaseFacts) == null ? void 0 : f.firstYearAsRental), 1)
          ]))
        ])
      ]),
      a("div", T9t, [
        t[7] || (t[7] = a("hr", { class: "flex-grow-1" }, null, -1)),
        a("div", O9t, [
          e.isAtPurchase ? (p(), h("small", R9t, "Purchased as Investment Property")) : (p(), h(A, { key: 1 }, [
            y(g(e.formatDuration(e.duration)), 1)
          ], 64))
        ]),
        t[8] || (t[8] = a("hr", { class: "flex-grow-1" }, null, -1))
      ]),
      a("div", L9t, [
        a("div", B9t, [
          a("div", M9t, [
            a("div", x9t, [
              t[9] || (t[9] = a("div", { class: "small text-muted" }, "Loan Date:", -1)),
              a("div", F9t, [
                (v = e.purchaseFacts) != null && v.hasCurrentLoan && ((b = e.purchaseFacts) != null && b.loan) ? (p(), h(A, { key: 0 }, [
                  y(g(e.date((S = (w = e.purchaseFacts) == null ? void 0 : w.loan) == null ? void 0 : S.date)), 1)
                ], 64)) : (p(), h(A, { key: 1 }, [
                  y(" Owned Free & Clear - No Loan ")
                ], 64))
              ])
            ]),
            a("div", V9t, [
              t[10] || (t[10] = a("div", { class: "small text-muted mt-2" }, "Interest Rate:", -1)),
              a("div", D9t, g(e.percent((T = (I = e.purchaseFacts) == null ? void 0 : I.loan) == null ? void 0 : T.interestRate, 1, "-")), 1)
            ]),
            a("div", N9t, [
              t[11] || (t[11] = a("div", { class: "small text-muted" }, "Original Amount:", -1)),
              a("div", j9t, g(e.currency((k = (x = e.purchaseFacts) == null ? void 0 : x.loan) == null ? void 0 : k.amount)), 1)
            ]),
            a("div", H9t, [
              t[12] || (t[12] = a("div", { class: "small text-muted mt-2" }, "Payment (P&I):", -1)),
              a("div", U9t, g(e.currency(e.loanPayment)), 1)
            ])
          ])
        ])
      ]),
      a("div", z9t, [
        a("div", W9t, [
          t[13] || (t[13] = a("div", null, "Total Principal Reduction:", -1)),
          a("div", G9t, g(e.percent(e.principalReduction)), 1)
        ]),
        a("div", Y9t, [
          t[14] || (t[14] = a("div", null, "Current Balance:", -1)),
          a("div", X9t, g(e.currency(e.loanBalance)), 1)
        ]),
        a("div", q9t, [
          N(o, {
            value: e.principalReductionWhole,
            showValue: !1,
            style: { height: "10px" }
          }, null, 8, ["value"])
        ])
      ]),
      a("div", Q9t, [
        a("button", {
          class: "btn btn-outline-eclipse btn-sm me-2",
          onClick: t[0] || (t[0] = (L) => e.showInvestmentDetails = !0)
        }, t[15] || (t[15] = [
          a("i", { class: "bi bi-pencil" }, null, -1),
          y(" Edit Purchase Information ")
        ])),
        t[16] || (t[16] = a("button", {
          class: "btn btn-outline-eclipse btn-sm",
          "data-bs-toggle": "modal",
          "data-bs-target": "#dialogPropertyValueEquity"
        }, [
          a("i", { class: "bi bi-house" }),
          y(" Edit Property Value ")
        ], -1))
      ])
    ]),
    a("div", K9t, [
      a("div", Z9t, [
        a("div", J9t, [
          t[25] || (t[25] = a("div", { class: "modal-header border-0 pb-2" }, [
            a("p", {
              class: "modal-title fs-5 fw-bold",
              id: "dialogPropertyValueLabel"
            }, "Property Value & Equity"),
            a("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            })
          ], -1)),
          a("div", $9t, [
            a("div", _9t, [
              a("div", eOt, [
                a("label", tOt, [
                  e.isAtPurchase ? (p(), h(A, { key: 0 }, [
                    y(" Value at Purchase ")
                  ], 64)) : (p(), h(A, { key: 1 }, [
                    y(" Value When First Rented ")
                  ], 64))
                ]),
                a("div", sOt, [
                  e.isAtPurchase ? (p(), h(A, { key: 0 }, [
                    y(g(e.currency((C = e.purchaseFacts) == null ? void 0 : C.purchasePrice)), 1)
                  ], 64)) : (p(), h(A, { key: 1 }, [
                    y(g(e.currency((O = e.purchaseFacts) == null ? void 0 : O.investmentBasis)), 1)
                  ], 64))
                ]),
                t[18] || (t[18] = a("label", { class: "col-form-label col-md-6 col-lg-3 fw-bold border-start text-center" }, " Current Value ", -1)),
                a("div", aOt, [
                  N(l, {
                    modelValue: e.calcParams.propertyValueEoY,
                    "onUpdate:modelValue": t[1] || (t[1] = (L) => e.calcParams.propertyValueEoY = L),
                    currency: ""
                  }, null, 8, ["modelValue"])
                ])
              ])
            ])
          ]),
          ((B = (E = e.purchaseFacts) == null ? void 0 : E.years) == null ? void 0 : B.length) == 0 ? (p(), h("div", nOt, t[19] || (t[19] = [
            a("i", { class: "fa-light fa-circle-info me-2" }, null, -1),
            y(" Only complete calendar years may be entered. ")
          ]))) : P("", !0),
          a("div", rOt, [
            a("div", oOt, [
              ((M = e.purchaseFactsYears) == null ? void 0 : M.length) > 0 ? (p(), h("table", iOt, [
                a("thead", null, [
                  a("tr", lOt, [
                    a("th", dOt, [
                      a("button", {
                        type: "button",
                        onClick: t[2] || (t[2] = (L) => e.autoPopulateValueEquity()),
                        disabled: e.cantAutoPopulate,
                        class: "btn btn-outline-eclipse btn-sm"
                      }, t[20] || (t[20] = [
                        a("i", { class: "fa-duotone fa-solid fa-wand-sparkles me-2" }, null, -1),
                        y("Estimate Annual Values")
                      ]), 8, cOt)
                    ]),
                    e.isCurrentYear ? (p(), h("th", pOt, g(e.currentYear), 1)) : (p(!0), h(A, { key: 0 }, D(e.purchaseFactsYears, (L) => (p(), h("th", uOt, g(L.year), 1))), 256))
                  ])
                ]),
                a("tbody", null, [
                  a("tr", null, [
                    t[21] || (t[21] = a("th", null, [
                      y(" Property Value"),
                      a("br"),
                      a("small", { class: "text-secondary fw-normal" }, "(End of Year Value)")
                    ], -1)),
                    e.isCurrentYear ? (p(), h("th", mOt, [
                      a("span", fOt, g(e.currency(e.calcParams.propertyValueEoY)), 1)
                    ])) : (p(!0), h(A, { key: 0 }, D(e.purchaseFactsYears, (L) => (p(), h("td", hOt, [
                      N(l, {
                        modelValue: L.propertyValue,
                        "onUpdate:modelValue": (j) => L.propertyValue = j,
                        currency: ""
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]))), 256))
                  ]),
                  a("tr", null, [
                    t[22] || (t[22] = a("th", null, [
                      y(" Loan Balance"),
                      a("br"),
                      a("small", { class: "text-secondary fw-normal" }, "(End of Year Value)")
                    ], -1)),
                    e.isCurrentYear ? (p(), h("th", yOt, [
                      a("span", bOt, g(e.currency((R = e.propertyStore.getEoYAmortizationInfo(e.currentYear)) == null ? void 0 : R.remainingPrincipalBeforePayment, !1, "N/A")), 1)
                    ])) : (p(!0), h(A, { key: 0 }, D(e.purchaseFactsYears, (L) => (p(), h("td", gOt, [
                      a("span", vOt, g(e.currency(L.loanBalance, !1, "N/A")), 1)
                    ]))), 256))
                  ]),
                  a("tr", null, [
                    t[23] || (t[23] = a("th", null, "Cost of Sale", -1)),
                    e.isCurrentYear ? (p(), h("th", COt, [
                      a("span", SOt, g(e.currency(e.calcParams.propertyValueEoY * e.calcParams.costofsale)), 1)
                    ])) : (p(!0), h(A, { key: 0 }, D(e.purchaseFactsYears, (L) => (p(), h("td", AOt, [
                      a("span", wOt, g(e.currency(L.propertyValue * e.calcParams.costofsale)), 1)
                    ]))), 256))
                  ]),
                  a("tr", null, [
                    t[24] || (t[24] = a("th", null, "Equity", -1)),
                    e.isCurrentYear ? (p(), h("th", EOt, [
                      a("span", IOt, g(e.currency(e.calculateEquity(e.calcParams.propertyValueEoY, (F = e.propertyStore.getEoYAmortizationInfo(e.currentYear)) == null ? void 0 : F.remainingPrincipalBeforePayment))), 1)
                    ])) : (p(!0), h(A, { key: 0 }, D(e.purchaseFactsYears, (L) => (p(), h("td", POt, [
                      a("span", kOt, g(e.currency(e.calculateEquityForYear(L))), 1)
                    ]))), 256))
                  ])
                ])
              ])) : P("", !0)
            ])
          ]),
          a("div", TOt, [
            a("button", {
              type: "button",
              class: "btn btn-lava",
              onClick: t[3] || (t[3] = (...L) => e.saveFields && e.saveFields(...L))
            }, "Calculate & Save")
          ])
        ])
      ])
    ], 512),
    N(d, {
      show: e.showInvestmentDetails,
      "onUpdate:show": t[4] || (t[4] = (L) => e.showInvestmentDetails = L)
    }, null, 8, ["show"])
  ], 64);
}
const ROt = /* @__PURE__ */ Ae(y9t, [["render", OOt]]);
Rt.register(
  Xr,
  Kr,
  Qr,
  qr,
  Jr,
  $r,
  Zr,
  Pi,
  ki,
  Ei,
  Ii,
  Ti,
  Oi
);
const LOt = me({
  name: "NetCashFlow",
  props: {},
  components: {},
  data() {
    return {};
  },
  watch: {
    t12CashFlow() {
      this.refreshChart();
    }
  },
  computed: {
    t12CashFlow() {
      var e, t;
      return ((t = (e = this.purchaseFacts) == null ? void 0 : e.mpod) == null ? void 0 : t.reduce((s, n) => s + n.cashFlow, 0)) ?? 0;
    },
    ...q(Te, ["access", "aclLoaded"]),
    ...q(qe, ["calculatedResults", "purchaseFacts", "coc"])
  },
  methods: {
    number: Ve,
    currency: Ze,
    percent: Wt,
    initCharts() {
      this.createCashFlowChart();
    },
    refreshChart() {
      var c, u, m, f, v, b, w, S;
      if (!this.cashFlow) return;
      const e = ((u = (c = this.purchaseFacts) == null ? void 0 : c.mpod) == null ? void 0 : u.reduce((I, T) => I + T.effectiveIncome, 0)) ?? 0, t = ((f = (m = this.purchaseFacts) == null ? void 0 : m.mpod) == null ? void 0 : f.reduce((I, T) => I + T.totalOperatingExpenses, 0)) ?? 0, s = ((b = (v = this.purchaseFacts) == null ? void 0 : v.mpod) == null ? void 0 : b.reduce((I, T) => I + T.debtService, 0)) ?? 0, n = ((S = (w = this.purchaseFacts) == null ? void 0 : w.mpod) == null ? void 0 : S.reduce((I, T) => I + T.totalNonOperatingExpenses - T.debtService, 0)) ?? 0, r = e - t - n - s, o = e - t, l = o - s, d = l - n;
      this.cashFlow.data.datasets[0].data = [
        [0, e],
        [o, e],
        [l, o],
        [d, l],
        [0, r]
      ], this.cashFlow.update();
    },
    createCashFlowChart() {
      var t, s, n, r, i, o, l, d;
      const e = this.$refs.cashFlowChart;
      if (e) {
        const c = ((s = (t = this.purchaseFacts) == null ? void 0 : t.mpod) == null ? void 0 : s.reduce((T, x) => T + x.effectiveIncome, 0)) ?? 0, u = ((r = (n = this.purchaseFacts) == null ? void 0 : n.mpod) == null ? void 0 : r.reduce((T, x) => T + x.totalOperatingExpenses, 0)) ?? 0, m = ((o = (i = this.purchaseFacts) == null ? void 0 : i.mpod) == null ? void 0 : o.reduce((T, x) => T + x.debtService, 0)) ?? 0, f = ((d = (l = this.purchaseFacts) == null ? void 0 : l.mpod) == null ? void 0 : d.reduce((T, x) => T + x.totalNonOperatingExpenses - x.debtService, 0)) ?? 0, v = c - u - f - m, w = c - u, S = w - m, I = S - f;
        this.cashFlow = new Rt(e, {
          type: "bar",
          data: {
            labels: ["Income", `Operating
Expenses`, `Debt
Service`, "NOE", "Net Cash Flow"],
            datasets: [
              {
                label: "Values",
                // Top (Height)
                data: [
                  [0, c],
                  [w, c],
                  [S, w],
                  [I, S],
                  [0, v]
                ],
                backgroundColor: ["#2196F3", "rgb(255, 193, 7)", "#17a2b8", "rgb(255, 107, 53)", v >= 0 ? "#31ad6f" : "rgb(220, 53, 69)"],
                barThickness: 80,
                order: 2
              }
            ]
          },
          options: {
            responsive: !0,
            maintainAspectRatio: !1,
            plugins: {
              legend: {
                display: !1
              },
              tooltip: {
                filter: function(T) {
                  return T.datasetIndex === 1;
                },
                callbacks: {
                  label: function(T) {
                    const x = ["Income", "Operating Expenses", "Debt Service", "NoE", "Net Cash Flow"], C = [c, -u, -m, -f, v][T.dataIndex];
                    return `${x[T.dataIndex]}: $${Math.abs(C).toLocaleString()}`;
                  }
                }
              }
            },
            scales: {
              x: {
                stacked: !0,
                grid: {
                  display: !1
                }
              },
              y: {
                stacked: !0,
                beginAtZero: !1,
                min: -1e4,
                max: 21e3,
                ticks: {
                  callback: function(T) {
                    return "$" + T / 1e3 + "k";
                  }
                },
                grid: {
                  display: !0,
                  color: "rgba(0,0,0,0.1)"
                }
              }
            }
          }
        });
      }
    }
  },
  mounted() {
    this.aclLoaded.then(() => {
      this.initCharts();
    });
  }
}), BOt = { class: "card h-100 shadow-sm" }, MOt = { class: "card-body border-bottom" }, xOt = { class: "fs-3 fw-bold" }, FOt = { class: "d-flex justify-content-between" }, VOt = { class: "card-body" }, DOt = { style: { height: "300px" } }, NOt = { ref: "cashFlowChart" };
function jOt(e, t, s, n, r, i) {
  return p(), h("div", BOt, [
    t[3] || (t[3] = a("div", { class: "card-header bg-eclipse text-white rounded rounded-bottom-0 fw-bold text-uppercase text-center text-sm-start" }, " Net Cash Flow ", -1)),
    a("div", MOt, [
      a("div", xOt, [
        t[0] || (t[0] = y(" T-12 Cash Flow: ")),
        a("span", {
          class: z({ "text-success": e.t12CashFlow > 0, "text-danger": e.t12CashFlow < 0 })
        }, g(e.currency(e.t12CashFlow)), 3)
      ]),
      a("div", FOt, [
        a("div", null, [
          t[1] || (t[1] = y("Cash-on-Cash Return: ")),
          a("span", {
            class: z(["fw-bold", { "text-success": e.coc > 0, "text-danger": e.coc < 0 }])
          }, g(e.percent(e.coc, 1)), 3)
        ]),
        t[2] || (t[2] = a("div", null, "T-12 Cash-Flow Waterfall (Bridge-to-Zero)", -1))
      ])
    ]),
    a("div", VOt, [
      a("div", DOt, [
        a("canvas", NOt, null, 512)
      ])
    ])
  ]);
}
const HOt = /* @__PURE__ */ Ae(LOt, [["render", jOt]]), UOt = me({
  name: "LeaseInformation",
  props: {
    portfolioId: String
  },
  components: {},
  data() {
    return {};
  },
  computed: {
    statusStyles() {
      var e, t;
      return {
        "text-bg-success": this.isActive && ((e = this.currentLease) == null ? void 0 : e.start) != null,
        "text-bg-danger": this.isActive && ((t = this.currentLease) == null ? void 0 : t.start) == null,
        "text-bg-secondary": !this.isActive,
        badge: !0,
        "ms-lg-auto": !0
      };
    },
    ...at(ba),
    ...q(Te, ["access", "aclLoaded"]),
    ...q(qe, ["property", "calcParams", "propertyInitialized", "calculating", "purchaseFacts"]),
    ...q(ba, ["currentLease", "isActive", "portfoliosLoading"])
  },
  methods: {
    number: Ve,
    currency: Ze,
    date: cs
  },
  mounted() {
    this.propertyInitialized.then(async () => {
      this.portfolioId && await this.portfolioInsightsStore.getPortfolioProperty(this.property.propId);
    });
  }
}), zOt = {
  key: 0,
  class: "card shadow-sm lease-card"
}, WOt = { class: "card-body d-flex flex-row flex-md-column flex-xl-row justify-content-between gap-2" }, GOt = { class: "flex-shrink-0" }, YOt = { class: "fw-bold" }, XOt = { class: "fw-bold" }, qOt = { class: "text-end d-flex flex-column flex-md-row flex-xl-column gap-2 align-items-center align-items-md-start justify-content-between align-items-xl-end" }, QOt = { class: "d-flex flex-column text-decoration-none" };
function KOt(e, t, s, n, r, i) {
  var o;
  return e.portfolioId ? (p(), h("div", zOt, [
    t[5] || (t[5] = a("div", { class: "card-header bg-eclipse text-white rounded rounded-bottom-0 fw-bold text-uppercase text-center text-sm-start" }, " Lease Information ", -1)),
    a("div", WOt, [
      a("div", GOt, [
        a("div", null, [
          t[0] || (t[0] = y(" Lease: ")),
          a("span", YOt, [
            e.currentLease ? (p(), h(A, { key: 0 }, [
              y(g(e.date(e.currentLease.start)) + " - " + g(e.date(e.currentLease.end)), 1)
            ], 64)) : (p(), h(A, { key: 1 }, [
              y(" Vacant ")
            ], 64))
          ])
        ]),
        a("div", null, [
          t[1] || (t[1] = y("Rental Rate: ")),
          a("span", XOt, g(e.currency(e.calcParams.monthlyRentalYear1)), 1)
        ]),
        t[2] || (t[2] = a("div", null, [
          y("Move In Date: "),
          a("span", { class: "fw-bold" }, "-")
        ], -1)),
        t[3] || (t[3] = a("div", null, [
          y("Security Deposit: "),
          a("span", { class: "fw-bold" }, "-")
        ], -1))
      ]),
      a("div", qOt, [
        a("span", {
          class: z(e.statusStyles)
        }, [
          (o = e.currentLease) != null && o.start ? (p(), h(A, { key: 0 }, [
            y(" Occupied ")
          ], 64)) : e.isActive ? (p(), h(A, { key: 1 }, [
            y(" Vacant ")
          ], 64)) : (p(), h(A, { key: 2 }, [
            y(" Inactive ")
          ], 64))
        ], 2),
        a("a", QOt, [
          P("", !0),
          t[4] || (t[4] = a("img", {
            src: TE,
            alt: "rentvine",
            title: "rentvine",
            class: "img-fluid",
            width: "104",
            height: "15"
          }, null, -1))
        ])
      ])
    ])
  ])) : P("", !0);
}
const ZOt = /* @__PURE__ */ Ae(UOt, [["render", KOt]]);
Rt.register(
  Xr,
  Kr,
  Qr,
  qr,
  Jr,
  $r,
  Zr,
  Pi,
  ki,
  Ei,
  Ii,
  Ti,
  Oi
);
const JOt = me({
  name: "AnnualTaxBenefits",
  props: {},
  components: {},
  data() {
    return {};
  },
  computed: {
    improvementDepreciation() {
      var e;
      return (e = this.raw.find(() => !0)) == null ? void 0 : e.improvementDepreciation;
    },
    ...q(Te, ["access", "aclLoaded"]),
    ...q(qe, ["raw", "calcParams"])
  },
  methods: {
    number: Ve,
    currency: Ze,
    percent: Wt
  },
  mounted() {
    this.aclLoaded.then(() => {
    });
  }
}), $Ot = { class: "card shadow-sm tax-benefits-card flex-fill" }, _Ot = { class: "card-body d-flex align-items-center justify-content-center flex-column" }, e7t = { class: "fs-2 fw-bold text-primary" }, t7t = { class: "text-success fw-bold" };
function s7t(e, t, s, n, r, i) {
  var o, l, d, c;
  return p(), h("div", $Ot, [
    t[1] || (t[1] = a("div", { class: "card-header bg-eclipse text-white rounded rounded-bottom-0 fw-bold text-uppercase text-center text-sm-start" }, " Annual Tax Benefits ", -1)),
    a("div", _Ot, [
      a("div", e7t, g(e.currency(e.improvementDepreciation)), 1),
      t[0] || (t[0] = a("small", { class: "text-body-secondary mb-3" }, "Taxable Income Reduction From Depreciation", -1)),
      a("div", t7t, "Est. " + g(e.currency(((l = (o = e.calcParams) == null ? void 0 : o.afterTaxAnalysis) == null ? void 0 : l.marginalIncomeTaxRate) * e.improvementDepreciation)) + " tax saved (" + g(e.percent((c = (d = e.calcParams) == null ? void 0 : d.afterTaxAnalysis) == null ? void 0 : c.marginalIncomeTaxRate)) + " bracket)", 1)
    ])
  ]);
}
const a7t = /* @__PURE__ */ Ae(JOt, [["render", s7t]]);
Rt.register(
  Xr,
  Kr,
  Qr,
  qr,
  Jr,
  $r,
  Zr,
  Pi,
  ki,
  Ei,
  Ii,
  Ti,
  Oi
);
const n7t = me({
  name: "IncomeAndExpenseBreakdown",
  props: {},
  components: {},
  data() {
    return {};
  },
  watch: {
    totalExpenses() {
      this.refreshChart();
    },
    income() {
      this.refreshChart();
    }
  },
  computed: {
    income() {
      var e, t;
      return ((t = (e = this.purchaseFacts) == null ? void 0 : e.mpod) == null ? void 0 : t.reduce((s, n) => s + n.effectiveIncome, 0)) ?? 0;
    },
    totalExpenses() {
      var e, t;
      return ((t = (e = this.purchaseFacts) == null ? void 0 : e.mpod) == null ? void 0 : t.reduce((s, n) => s + n.totalOperatingExpenses + n.totalNonOperatingExpenses, 0)) ?? 0;
    },
    tax() {
      var e, t;
      return ((t = (e = this.purchaseFacts) == null ? void 0 : e.mpod) == null ? void 0 : t.reduce((s, n) => s + n.tax, 0)) ?? 0;
    },
    insurance() {
      var e, t;
      return ((t = (e = this.purchaseFacts) == null ? void 0 : e.mpod) == null ? void 0 : t.reduce((s, n) => s + n.insurance, 0)) ?? 0;
    },
    maintenance() {
      var e, t;
      return ((t = (e = this.purchaseFacts) == null ? void 0 : e.mpod) == null ? void 0 : t.reduce((s, n) => s + n.maintenance, 0)) ?? 0;
    },
    management() {
      var e, t;
      return ((t = (e = this.purchaseFacts) == null ? void 0 : e.mpod) == null ? void 0 : t.reduce((s, n) => s + n.management, 0)) ?? 0;
    },
    debtService() {
      var e, t;
      return ((t = (e = this.purchaseFacts) == null ? void 0 : e.mpod) == null ? void 0 : t.reduce((s, n) => s + n.debtService, 0)) ?? 0;
    },
    otherExpenses() {
      return this.totalExpenses - (this.tax + this.insurance + this.maintenance + this.management + this.debtService);
    },
    ...q(Te, ["access", "aclLoaded"]),
    ...q(qe, ["purchaseFacts"])
  },
  methods: {
    number: Ve,
    currency: Ze,
    percent: Wt,
    initCharts() {
      this.createExpenseBreakdownChart();
    },
    refreshChart() {
      this.expenseBreakdown && (console.debug("refreshChart"), this.expenseBreakdown.data.datasets[0].data = [
        this.tax / this.income,
        this.maintenance / this.income,
        this.management / this.income,
        this.insurance / this.income,
        this.otherExpenses / this.income,
        this.debtService / this.income
      ], this.expenseBreakdown.update());
    },
    createExpenseBreakdownChart() {
      const e = this.$refs.expenseBreakdownChart;
      e && (this.expenseBreakdown = new Rt(e, {
        type: "doughnut",
        data: {
          labels: ["Taxes", "Maintenance", "Management", "Insurance", "Other", "Debt Service"],
          datasets: [{
            data: [
              this.tax / this.income,
              this.maintenance / this.income,
              this.management / this.income,
              this.insurance / this.income,
              this.otherExpenses / this.income,
              this.debtService / this.income
            ],
            backgroundColor: [
              "#ffc107",
              "#ff6b35",
              "#31ad6f",
              "#6210b0",
              "#dc3545",
              "#17a2b8"
            ],
            borderWidth: 2,
            borderColor: "#fff"
          }]
        },
        options: {
          responsive: !0,
          maintainAspectRatio: !1,
          cutout: "60%",
          plugins: {
            legend: {
              display: !1
            },
            tooltip: {
              callbacks: {
                label: function(t) {
                  return t.label + ": " + Wt(t.raw);
                }
              }
            }
          }
        }
      }));
    }
  },
  mounted() {
    this.aclLoaded.then(() => {
      this.initCharts();
    });
  }
}), r7t = { class: "card h-100 shadow-sm" }, o7t = { class: "card-body" }, i7t = { class: "row g-3" }, l7t = { class: "col-md-6" }, d7t = { style: { height: "300px", position: "relative" } }, c7t = { ref: "expenseBreakdownChart" }, u7t = { class: "position-absolute top-50 start-50 translate-middle text-center" }, p7t = { class: "h4 fw-bold" }, h7t = { class: "small text-muted" }, m7t = { class: "col-md-6" }, f7t = { class: "table-responsive" }, g7t = { class: "table table-sm" };
function v7t(e, t, s, n, r, i) {
  return p(), h("div", r7t, [
    t[15] || (t[15] = a("div", { class: "card-header bg-eclipse text-white rounded rounded-bottom-0 fw-bold text-uppercase text-center text-sm-start" }, " Income & Expense Breakdown ", -1)),
    a("div", o7t, [
      a("div", i7t, [
        a("div", l7t, [
          a("div", d7t, [
            a("canvas", c7t, null, 512),
            a("div", u7t, [
              t[0] || (t[0] = a("div", { class: "fw-bold" }, "Income", -1)),
              a("div", p7t, g(e.currency(e.income)), 1),
              a("div", h7t, "Expenses " + g(e.percent(e.totalExpenses / e.income)) + " of income", 1)
            ])
          ])
        ]),
        a("div", m7t, [
          a("div", f7t, [
            a("table", g7t, [
              t[13] || (t[13] = a("thead", null, [
                a("tr", null, [
                  a("th", { width: "" }, "Category"),
                  a("th", null, "Subject"),
                  a("th", null, "Benchmark")
                ])
              ], -1)),
              a("tbody", null, [
                a("tr", null, [
                  t[1] || (t[1] = a("td", null, [
                    a("i", {
                      class: "fa-solid fa-square me-2",
                      style: { color: "#ffc107" }
                    }),
                    y("Taxes")
                  ], -1)),
                  a("td", null, g(e.percent(e.tax / e.income)), 1),
                  t[2] || (t[2] = a("td", null, "-", -1))
                ]),
                a("tr", null, [
                  t[3] || (t[3] = a("td", null, [
                    a("i", {
                      class: "fa-solid fa-square me-2",
                      style: { color: "#ff6b35" }
                    }),
                    y("Maintenance ")
                  ], -1)),
                  a("td", null, g(e.percent(e.maintenance / e.income)), 1),
                  t[4] || (t[4] = a("td", null, "-", -1))
                ]),
                a("tr", null, [
                  t[5] || (t[5] = a("td", null, [
                    a("i", {
                      class: "fa-solid fa-square me-2",
                      style: { color: "#31ad6f" }
                    }),
                    y("Management ")
                  ], -1)),
                  a("td", null, g(e.percent(e.management / e.income)), 1),
                  t[6] || (t[6] = a("td", null, "-", -1))
                ]),
                a("tr", null, [
                  t[7] || (t[7] = a("td", null, [
                    a("i", {
                      class: "fa-solid fa-square me-2",
                      style: { color: "#6210b0" }
                    }),
                    y("Insurance ")
                  ], -1)),
                  a("td", null, g(e.percent(e.insurance / e.income)), 1),
                  t[8] || (t[8] = a("td", null, "-", -1))
                ]),
                a("tr", null, [
                  t[9] || (t[9] = a("td", null, [
                    a("i", {
                      class: "fa-solid fa-square me-2",
                      style: { color: "#17a2b8" }
                    }),
                    y("Debt Service ")
                  ], -1)),
                  a("td", null, g(e.percent(e.debtService / e.income)), 1),
                  t[10] || (t[10] = a("td", null, "-", -1))
                ]),
                a("tr", null, [
                  t[11] || (t[11] = a("td", null, [
                    a("i", {
                      class: "fa-solid fa-square me-2",
                      style: { color: "#dc3545" }
                    }),
                    y("Other ")
                  ], -1)),
                  a("td", null, g(e.percent(e.otherExpenses / e.income)), 1),
                  t[12] || (t[12] = a("td", null, "-", -1))
                ])
              ]),
              t[14] || (t[14] = a("tbody", null, [
                a("tr", null, [
                  a("td", { colspan: "3" }, [
                    a("small", { class: "text-secondary fst-italic text-small" }, "* Percent of Income")
                  ])
                ])
              ], -1))
            ])
          ])
        ])
      ])
    ])
  ]);
}
const y7t = /* @__PURE__ */ Ae(n7t, [["render", v7t]]);
Rt.register(
  Xr,
  Kr,
  Qr,
  qr,
  Jr,
  $r,
  Zr,
  Pi,
  ki,
  Ei,
  Ii,
  Ti,
  Oi
);
const b7t = me({
  name: "PortfolioBenchmarkSummary",
  props: {},
  components: {},
  data() {
    return {
      charts: {
        distributions: null,
        trustBalance: null,
        equity: null,
        principalReduction: null,
        cashFlow: null,
        expenseBreakdown: null
      }
    };
  },
  computed: {
    operatingExpenseRatio() {
      var s, n, r, i;
      const e = ((n = (s = this.purchaseFacts) == null ? void 0 : s.mpod) == null ? void 0 : n.reduce((o, l) => o + l.effectiveIncome, 0)) ?? 0;
      return (((i = (r = this.purchaseFacts) == null ? void 0 : r.mpod) == null ? void 0 : i.reduce((o, l) => o + l.totalOperatingExpenses, 0)) ?? 0) / e;
    },
    maintenance() {
      var e, t;
      return ((t = (e = this.purchaseFacts) == null ? void 0 : e.mpod) == null ? void 0 : t.reduce((s, n) => s + n.maintenance, 0)) ?? 0;
    },
    ...q(Te, ["access", "aclLoaded"]),
    ...q(qe, ["rentalSF", "purchaseFacts", "coc"])
  },
  methods: {
    number: Ve,
    currency: Ze,
    percent: Wt
  },
  mounted() {
    this.aclLoaded.then(() => {
    });
  }
}), A7t = { class: "card h-100 shadow-sm benchmarks-card" }, w7t = { class: "card-body" }, C7t = { class: "table-responsive" }, S7t = { class: "table table-sm benchmarks-table" }, P7t = { class: "text-center tabular-nums" }, k7t = { class: "text-center tabular-nums" }, E7t = { class: "text-center tabular-nums" }, I7t = { class: "text-center tabular-nums" };
function T7t(e, t, s, n, r, i) {
  return p(), h("div", A7t, [
    t[16] || (t[16] = a("div", { class: "card-header bg-eclipse text-white rounded rounded-bottom-0 fw-bold text-uppercase text-center text-sm-start" }, " Portfolio Benchmark Summary ", -1)),
    a("div", w7t, [
      t[15] || (t[15] = a("small", { class: "text-body-secondary" }, "How this property stacks up against your management portfolio averages", -1)),
      a("div", C7t, [
        a("table", S7t, [
          t[13] || (t[13] = a("thead", null, [
            a("tr", { class: "border-bottom" }, [
              a("th", { class: "fw-semibold text-sm" }, "Metric"),
              a("th", { class: "text-center fw-semibold text-sm" }, "This Property"),
              a("th", { class: "text-center fw-semibold text-sm" }, "Portfolio Avg"),
              a("th", {
                class: "text-center",
                style: { width: "24px" }
              })
            ])
          ], -1)),
          a("tbody", null, [
            t[12] || (t[12] = a("tr", null, [
              a("td", { class: "fw-normal" }, "Vacancy Rate"),
              a("td", { class: "text-center tabular-nums" }, "-"),
              a("td", { class: "text-center tabular-nums" }, "-"),
              a("td", { class: "text-center" }, [
                a("i", { class: "fa-solid fa-square text-info" })
              ])
            ], -1)),
            a("tr", null, [
              t[0] || (t[0] = a("td", { class: "fw-normal" }, "Rent per SF", -1)),
              a("td", P7t, g(e.currency(e.rentalSF, 2, "-")), 1),
              t[1] || (t[1] = a("td", { class: "text-center tabular-nums" }, "-", -1)),
              t[2] || (t[2] = a("td", { class: "text-center" }, [
                a("i", { class: "fa-solid fa-square text-info" })
              ], -1))
            ]),
            a("tr", null, [
              t[3] || (t[3] = a("td", { class: "fw-normal" }, "Operating Expense Ratio", -1)),
              a("td", k7t, g(e.percent(e.operatingExpenseRatio)), 1),
              t[4] || (t[4] = a("td", { class: "text-center tabular-nums" }, "-", -1)),
              t[5] || (t[5] = a("td", { class: "text-center" }, [
                a("i", { class: "fa-solid fa-square text-info" })
              ], -1))
            ]),
            a("tr", null, [
              t[6] || (t[6] = a("td", { class: "fw-normal" }, "Cash-on-Cash Return", -1)),
              a("td", E7t, g(e.percent(e.coc, 1)), 1),
              t[7] || (t[7] = a("td", { class: "text-center tabular-nums" }, "-", -1)),
              t[8] || (t[8] = a("td", { class: "text-center" }, [
                a("i", { class: "fa-solid fa-square text-info" })
              ], -1))
            ]),
            a("tr", null, [
              t[9] || (t[9] = a("td", { class: "fw-normal" }, "Maintenance $/Yr", -1)),
              a("td", I7t, g(e.currency(e.maintenance)), 1),
              t[10] || (t[10] = a("td", { class: "text-center tabular-nums" }, "-", -1)),
              t[11] || (t[11] = a("td", { class: "text-center" }, [
                a("i", { class: "fa-solid fa-square text-info" })
              ], -1))
            ])
          ]),
          t[14] || (t[14] = a("tbody", null, [
            a("tr", null, [
              a("td", { colspan: "4" }, [
                a("small", { class: "text-secondary fst-italic text-small" }, "* Portfolio benchmarks coming soon!")
              ])
            ])
          ], -1))
        ])
      ])
    ])
  ]);
}
const O7t = /* @__PURE__ */ Ae(b7t, [["render", T7t]]), R7t = me({
  name: "MPOD",
  computed: {
    calculatingClasses() {
      return {
        card: !0,
        "card-apod": !0,
        "shadow-sm": !0,
        "card-proforma": !0,
        calculating: this.calculating,
        "card-guarded": this.haveAccess == !1,
        "card-advanced": !0
      };
    },
    mpod() {
      var e, t;
      return ((t = (e = this.purchaseFacts) == null ? void 0 : e.mpod) == null ? void 0 : t.filter((s) => s.year <= Et).sort((s, n) => s.year - n.year || s.month - n.month)) ?? [];
    },
    hasOtherIncome() {
      return this.mpod.some((e) => e.otherIncome != null && e.otherIncome != 0);
    },
    hasAnyPlatformServiceFees() {
      var e, t;
      return (t = (e = this.purchaseFacts) == null ? void 0 : e.mpod) == null ? void 0 : t.some((s) => s.platformServiceFees != null && s.platformServiceFees != 0);
    },
    hasAnyFurnishingExpenses() {
      var e, t;
      return (t = (e = this.purchaseFacts) == null ? void 0 : e.mpod) == null ? void 0 : t.some((s) => s.furnishingExpenses != null && s.furnishingExpenses != 0);
    },
    hasAnyConsumableExpenses() {
      var e, t;
      return (t = (e = this.purchaseFacts) == null ? void 0 : e.mpod) == null ? void 0 : t.some((s) => s.consumableExpenses != null && s.consumableExpenses != 0);
    },
    hasAnyCleaningExpenses() {
      var e, t;
      return (t = (e = this.purchaseFacts) == null ? void 0 : e.mpod) == null ? void 0 : t.some((s) => s.cleaningExpenses != null && s.cleaningExpenses != 0);
    },
    haveAccess() {
      var e, t;
      return this.isMarketplace || ((t = (e = this.acl) == null ? void 0 : e.properties) == null ? void 0 : t.financialAnalysis) == !0;
    },
    ...q(ct, ["otherExpenseAccounts", "otherIncomeAccounts", "incomeAccounts", "otherNonOperatingExpenseAccounts"]),
    ...q(Te, ["acl", "aclLoaded"]),
    ...q(qe, [
      "calculating",
      "calculatedResults",
      "calcParams",
      "isMarketplace",
      "purchaseFacts",
      "firstAnalyzedYear",
      "isExistingInvestment",
      "rentalTypes",
      "ignoreHistoricalOperatingIncome",
      "isLongTerm",
      "hasLongTerm",
      "isShortTerm",
      "isPadSplit",
      "firstTableYear"
    ])
  },
  methods: {
    number: Ve,
    month: G4,
    currency: Ze,
    percent: Wt,
    shortNumber: vr,
    shortCurrency: ka,
    analysisYearStyle: so,
    mpodSum(e) {
      return this.mpod.reduce((t, s) => e(s) + t, 0);
    },
    hasAnyIncomeValues(e) {
      var t, s;
      return (s = (t = this.purchaseFacts) == null ? void 0 : t.mpod) == null ? void 0 : s.some((n) => {
        var r;
        return ((r = n.otherIncomes) == null ? void 0 : r.some((i) => i.id == e.id && i.total != null && i.total != 0)) == !0;
      });
    },
    getOtherIncome(e, t, s) {
      var n, r, i, o, l;
      return (l = (o = (i = (r = (n = this.purchaseFacts) == null ? void 0 : n.mpod) == null ? void 0 : r.find((d) => d.year == t && d.month == s)) == null ? void 0 : i.otherIncomes) == null ? void 0 : o.find((d) => d.id == e)) == null ? void 0 : l.total;
    },
    hasAnyValues(e) {
      var t, s;
      return (s = (t = this.purchaseFacts) == null ? void 0 : t.mpod) == null ? void 0 : s.some((n) => {
        var r;
        return ((r = n.otherExpenses) == null ? void 0 : r.some((i) => i.id == e.id && i.total != null && i.total != 0 && i.nonOperating != !0)) == !0;
      });
    },
    getOtherExpense(e, t, s) {
      var n, r, i, o, l;
      return (l = (o = (i = (r = (n = this.purchaseFacts) == null ? void 0 : n.mpod) == null ? void 0 : r.find((d) => d.year == t && d.month == s)) == null ? void 0 : i.otherExpenses) == null ? void 0 : o.find((d) => d.id == e)) == null ? void 0 : l.total;
    },
    hasAnyNonOperatingExpenseValues(e) {
      var t, s;
      return (s = (t = this.purchaseFacts) == null ? void 0 : t.mpod) == null ? void 0 : s.some((n) => {
        var r;
        return ((r = n.otherExpenses) == null ? void 0 : r.some((i) => i.id == e.id && i.total != null && i.total != 0 && i.nonOperating == !0)) == !0;
      });
    },
    getOtherNonOperatingExpenseExpense(e, t, s) {
      var n, r, i, o, l;
      return (l = (o = (i = (r = (n = this.purchaseFacts) == null ? void 0 : n.mpod) == null ? void 0 : r.find((d) => d.year == t)) == null ? void 0 : i.otherExpenses) == null ? void 0 : o.find((d) => d.id == e)) == null ? void 0 : l.total;
    },
    currencyStyle(e) {
      return {
        positive: e > 0,
        negative: e < 0
      };
    },
    editInvestment() {
      $("#modalExistingInvestment").on("show.bs.modal", function() {
        $("#value-operating-costs-tab").tab("show");
      }).modal("show");
    }
  }
}), L7t = { class: "card-header bg-eclipse text-white fw-bold d-flex justify-content-md-between flex-column flex-sm-row text-center text-sm-start rounded rounded-bottom-0 align-items-center" }, B7t = { class: "card-body p-0 position-relative overflow-hidden" }, M7t = {
  key: 0,
  class: "calculating-animation position-absolute top-50 start-50 translate-middle text-center"
}, x7t = { class: "table table-sm text-small tabla table-table table-apod table-values regListing mode-advanced" }, F7t = { class: "text-end" }, V7t = { class: "tb-space" }, D7t = { class: "table-content table-grey adv-rentalIncome" }, N7t = {
  rel: "rentalIncome",
  class: "table-column fw-bold"
}, j7t = { key: 0 }, H7t = ["title"], U7t = {
  rel: "otherIncome",
  class: "table-column fw-bold"
}, z7t = { key: 0 }, W7t = { rel: "otherIncome" }, G7t = ["title"], Y7t = {
  rel: "otherIncome",
  class: "table-column fw-bold"
}, X7t = { class: "table-total table-divider" }, q7t = ["title"], Q7t = {
  rel: "effectiveIncome",
  class: "table-column fw-bold"
}, K7t = { class: "tb-space" }, Z7t = ["title"], J7t = {
  rel: "propertytax",
  class: "table-column fw-bold"
}, $7t = ["title"], _7t = {
  rel: "propertyinsurance",
  class: "table-column fw-bold"
}, eRt = ["title"], tRt = {
  rel: "hoa",
  class: "table-column fw-bold"
}, sRt = ["title"], aRt = {
  rel: "propertymanagement",
  class: "table-column fw-bold"
}, nRt = { key: 0 }, rRt = ["title"], oRt = {
  rel: "leasingcommissions",
  class: "table-column fw-bold"
}, iRt = { key: 1 }, lRt = ["title"], dRt = {
  rel: "platformServiceFees",
  class: "table-column fw-bold"
}, cRt = ["title"], uRt = {
  rel: "propertymaintenance",
  class: "table-column fw-bold"
}, pRt = ["title"], hRt = {
  rel: "utilityExpenses",
  class: "table-column fw-bold"
}, mRt = ["title"], fRt = {
  rel: "otherExpenses",
  class: "table-column fw-bold"
}, gRt = { key: 2 }, vRt = ["title"], yRt = {
  rel: "furnishingExpenses",
  class: "table-column fw-bold"
}, bRt = { key: 3 }, ARt = ["title"], wRt = {
  rel: "consumableExpenses",
  class: "table-column fw-bold"
}, CRt = { key: 4 }, SRt = ["title"], PRt = {
  rel: "cleaningExpenses",
  class: "table-column fw-bold"
}, kRt = { key: 0 }, ERt = { rel: "otherExpenses" }, IRt = ["title"], TRt = {
  rel: "otherExpenses",
  class: "table-column fw-bold"
}, ORt = { class: "table-divider" }, RRt = ["title"], LRt = {
  rel: "totalexpenses",
  class: "table-column fw-bold"
}, BRt = { class: "table-total styled-dark-finances fw-bold" }, MRt = ["title"], xRt = {
  rel: "noi",
  class: "table-column fw-bold"
}, FRt = { class: "tb-space" }, VRt = ["title"], DRt = {
  rel: "debtservice",
  class: "table-column fw-bold"
}, NRt = ["title"], jRt = {
  rel: "capitalExpenditures",
  class: "table-column fw-bold"
}, HRt = { key: 0 }, URt = { rel: "otherNonOperatingExpense" }, zRt = ["title"], WRt = {
  rel: "otherNonOperatingExpense",
  class: "table-column fw-bold"
}, GRt = { class: "table-total table-divider" }, YRt = ["title"], XRt = {
  rel: "totalNonOperatingExpenses",
  class: "table-column"
}, qRt = { class: "table-total styled-dark-finances fw-bold" }, QRt = ["title"], KRt = {
  rel: "cashflow",
  class: "table-column fw-bold"
};
function ZRt(e, t, s, n, r, i) {
  return p(), h("div", {
    class: z(e.calculatingClasses)
  }, [
    a("div", L7t, [
      t[1] || (t[1] = a("span", { class: "mb-2 mb-md-0" }, "TRAILING 12 MONTH INCOME AND EXPENSE", -1)),
      P("", !0)
    ]),
    a("div", B7t, [
      e.calculating ? (p(), h("div", M7t, t[2] || (t[2] = [
        a("i", { class: "fa-duotone fa-solid fa-compass fa-spin fa-lg text-eclipse" }, null, -1),
        a("br", null, null, -1),
        a("small", null, "Calculating", -1)
      ]))) : P("", !0),
      a("div", {
        class: z(["table-wrap table-data", { "table-guarded": !e.haveAccess }])
      }, [
        a("table", x7t, [
          a("thead", null, [
            a("tr", F7t, [
              t[3] || (t[3] = a("th", null, " ", -1)),
              (p(!0), h(A, null, D(e.mpod, (o) => (p(), h("th", {
                class: "table-column",
                key: o.year + o.month
              }, g(e.month(o.month)) + " `" + g(o.year - 2e3), 1))), 128)),
              t[4] || (t[4] = a("th", { class: "table-column" }, "Total", -1))
            ]),
            t[5] || (t[5] = a("tr", { class: "table-alice" }, [
              a("th", null, "INCOME"),
              a("td", { colspan: "13" }, " ")
            ], -1))
          ]),
          a("tbody", V7t, [
            a("tr", null, [
              t[6] || (t[6] = a("th", { rel: "rentalIncome" }, "Rental Income", -1)),
              (p(!0), h(A, null, D(e.mpod, (o) => (p(), h("td", {
                class: "table-column",
                key: o.year + o.month
              }, [
                a("div", D7t, [
                  o.noIncome ? (p(), h(A, { key: 0 }, [
                    y(" - ")
                  ], 64)) : (p(), h(A, { key: 1 }, [
                    y(g(e.shortCurrency(o.rentalIncome)), 1)
                  ], 64))
                ])
              ]))), 128)),
              a("th", N7t, g(e.shortCurrency(e.mpodSum((o) => o.rentalIncome))), 1)
            ]),
            e.hasOtherIncome ? (p(), h("tr", j7t, [
              t[7] || (t[7] = a("th", { rel: "otherIncome" }, "Other Income", -1)),
              (p(!0), h(A, null, D(e.mpod, (o) => (p(), h("td", {
                class: "table-column",
                key: o.year + o.month
              }, [
                a("div", {
                  class: "table-content table-grey adv-cleaningExpenses",
                  title: e.currency(o.otherIncome)
                }, [
                  o.noIncome ? (p(), h(A, { key: 0 }, [
                    y(" - ")
                  ], 64)) : (p(), h(A, { key: 1 }, [
                    y(g(e.shortCurrency(o.otherIncome)), 1)
                  ], 64))
                ], 8, H7t)
              ]))), 128)),
              a("th", U7t, g(e.shortCurrency(e.mpodSum((o) => o.otherIncome))), 1)
            ])) : P("", !0),
            (p(!0), h(A, null, D(e.otherIncomeAccounts, (o) => (p(), h(A, null, [
              e.hasAnyIncomeValues(o) ? (p(), h("tr", z7t, [
                a("th", W7t, g(o.name), 1),
                (p(!0), h(A, null, D(e.mpod, (l) => (p(), h("td", {
                  class: "table-column",
                  key: l.year + l.month
                }, [
                  a("div", {
                    class: "adv-otherIncome",
                    title: e.currency(e.getOtherIncome(o.id, l.year, l.month))
                  }, [
                    l.noIncome ? (p(), h(A, { key: 0 }, [
                      y(" - ")
                    ], 64)) : (p(), h(A, { key: 1 }, [
                      y(g(e.shortCurrency(e.getOtherIncome(o.id, l.year, l.month))), 1)
                    ], 64))
                  ], 8, G7t)
                ]))), 128)),
                a("th", Y7t, g(e.shortCurrency(e.mpodSum((l) => e.getOtherIncome(o.id, l.year, l.month)))), 1)
              ])) : P("", !0)
            ], 64))), 256)),
            a("tr", X7t, [
              t[8] || (t[8] = a("th", { rel: "effectiveincome" }, [
                a("strong", null, "Effective Income")
              ], -1)),
              (p(!0), h(A, null, D(e.mpod, (o) => (p(), h("th", {
                class: "table-column",
                key: o.year + o.month
              }, [
                a("div", {
                  class: "table-content adv-effectiveincome",
                  title: e.currency(o.effectiveIncome)
                }, [
                  o.noIncome ? (p(), h(A, { key: 0 }, [
                    y(" - ")
                  ], 64)) : (p(), h(A, { key: 1 }, [
                    y(g(e.shortCurrency(o.effectiveIncome)), 1)
                  ], 64))
                ], 8, q7t)
              ]))), 128)),
              a("th", Q7t, g(e.shortCurrency(e.mpodSum((o) => o.effectiveIncome))), 1)
            ])
          ]),
          t[27] || (t[27] = a("thead", null, [
            a("tr", { class: "table-alice" }, [
              a("th", null, " OPERATING EXPENSES "),
              a("td", { colspan: "13" }, " ")
            ])
          ], -1)),
          a("tbody", K7t, [
            a("tr", null, [
              t[9] || (t[9] = a("th", { rel: "propertytax" }, "Property Tax", -1)),
              (p(!0), h(A, null, D(e.mpod, (o) => (p(), h("td", {
                class: "table-column",
                key: o.year + o.month
              }, [
                a("div", {
                  class: "table-content table-grey adv-propertytax",
                  title: e.currency(o.tax)
                }, [
                  o.noIncome ? (p(), h(A, { key: 0 }, [
                    y(" - ")
                  ], 64)) : (p(), h(A, { key: 1 }, [
                    y(g(e.shortCurrency(o.tax)), 1)
                  ], 64))
                ], 8, Z7t)
              ]))), 128)),
              a("th", J7t, g(e.shortCurrency(e.mpodSum((o) => o.tax))), 1)
            ]),
            a("tr", null, [
              t[10] || (t[10] = a("th", { rel: "propertyinsurance" }, "Property Insurance", -1)),
              (p(!0), h(A, null, D(e.mpod, (o) => (p(), h("td", {
                class: "table-column",
                key: o.year + o.month
              }, [
                a("div", {
                  class: "table-content table-grey adv-propertyinsurance",
                  title: e.currency(o.insurance)
                }, [
                  o.noIncome ? (p(), h(A, { key: 0 }, [
                    y(" - ")
                  ], 64)) : (p(), h(A, { key: 1 }, [
                    y(g(e.shortCurrency(o.insurance)), 1)
                  ], 64))
                ], 8, $7t)
              ]))), 128)),
              a("th", _7t, g(e.shortCurrency(e.mpodSum((o) => o.insurance))), 1)
            ]),
            a("tr", null, [
              t[11] || (t[11] = a("th", { rel: "hoa" }, "HOA", -1)),
              (p(!0), h(A, null, D(e.mpod, (o) => (p(), h("td", {
                class: "table-column",
                key: o.year + o.month
              }, [
                a("div", {
                  class: "table-content table-grey adv-hoa",
                  title: e.currency(o.associationFees)
                }, [
                  o.noIncome ? (p(), h(A, { key: 0 }, [
                    y(" - ")
                  ], 64)) : (p(), h(A, { key: 1 }, [
                    y(g(e.shortCurrency(o.associationFees)), 1)
                  ], 64))
                ], 8, eRt)
              ]))), 128)),
              a("th", tRt, g(e.shortCurrency(e.mpodSum((o) => o.associationFees))), 1)
            ]),
            a("tr", null, [
              t[12] || (t[12] = a("th", { rel: "propertymanagement" }, "Property Management", -1)),
              (p(!0), h(A, null, D(e.mpod, (o) => (p(), h("td", {
                class: "table-column",
                key: o.year + o.month
              }, [
                a("div", {
                  class: "table-content table-grey adv-propertymanagement",
                  title: e.currency(o.management)
                }, [
                  o.noIncome ? (p(), h(A, { key: 0 }, [
                    y(" - ")
                  ], 64)) : (p(), h(A, { key: 1 }, [
                    y(g(e.shortCurrency(o.management)), 1)
                  ], 64))
                ], 8, sRt)
              ]))), 128)),
              a("th", aRt, g(e.shortCurrency(e.mpodSum((o) => o.management))), 1)
            ]),
            e.isLongTerm ? (p(), h("tr", nRt, [
              t[13] || (t[13] = a("th", { rel: "leasingcommissions" }, "Leasing Commissions", -1)),
              (p(!0), h(A, null, D(e.mpod, (o) => (p(), h("td", {
                class: "table-column",
                key: o.year + o.month
              }, [
                a("div", {
                  class: "table-content table-grey adv-leasingcommissions",
                  title: e.currency(o.commission)
                }, [
                  o.noIncome ? (p(), h(A, { key: 0 }, [
                    y(" - ")
                  ], 64)) : (p(), h(A, { key: 1 }, [
                    y(g(e.shortCurrency(o.commission)), 1)
                  ], 64))
                ], 8, rRt)
              ]))), 128)),
              a("th", oRt, g(e.shortCurrency(e.mpodSum((o) => o.commission))), 1)
            ])) : P("", !0),
            e.hasAnyPlatformServiceFees ? (p(), h("tr", iRt, [
              t[14] || (t[14] = a("th", { rel: "platformServiceFees" }, "Platform/Booking Fees", -1)),
              (p(!0), h(A, null, D(e.mpod, (o) => (p(), h("td", {
                class: "table-column",
                key: o.year + o.month
              }, [
                a("div", {
                  class: "table-content table-grey adv-platformServiceFees",
                  title: e.currency(o.platformServiceFees)
                }, [
                  o.noIncome ? (p(), h(A, { key: 0 }, [
                    y(" - ")
                  ], 64)) : (p(), h(A, { key: 1 }, [
                    y(g(e.shortCurrency(o.platformServiceFees)), 1)
                  ], 64))
                ], 8, lRt)
              ]))), 128)),
              a("th", dRt, g(e.shortCurrency(e.mpodSum((o) => o.platformServiceFees))), 1)
            ])) : P("", !0),
            a("tr", null, [
              t[15] || (t[15] = a("th", { rel: "propertymaintenance" }, "Property Maintenance", -1)),
              (p(!0), h(A, null, D(e.mpod, (o) => (p(), h("td", {
                class: "table-column",
                key: o.year + o.month
              }, [
                a("div", {
                  class: "table-content table-grey adv-propertymaintenance",
                  title: e.currency(o.maintenance)
                }, [
                  o.noIncome ? (p(), h(A, { key: 0 }, [
                    y(" - ")
                  ], 64)) : (p(), h(A, { key: 1 }, [
                    y(g(e.shortCurrency(o.maintenance)), 1)
                  ], 64))
                ], 8, cRt)
              ]))), 128)),
              a("th", uRt, g(e.shortCurrency(e.mpodSum((o) => o.maintenance))), 1)
            ]),
            a("tr", null, [
              t[16] || (t[16] = a("th", { rel: "utilityExpenses" }, "Utility Expenses", -1)),
              (p(!0), h(A, null, D(e.mpod, (o) => (p(), h("td", {
                class: "table-column",
                key: o.year + o.month
              }, [
                a("div", {
                  class: "table-content table-grey adv-utilityExpenses",
                  title: e.currency(o.utilityExpenses)
                }, [
                  o.noIncome ? (p(), h(A, { key: 0 }, [
                    y(" - ")
                  ], 64)) : (p(), h(A, { key: 1 }, [
                    y(g(e.shortCurrency(o.utilityExpenses)), 1)
                  ], 64))
                ], 8, pRt)
              ]))), 128)),
              a("th", hRt, g(e.shortCurrency(e.mpodSum((o) => o.utilityExpenses))), 1)
            ]),
            a("tr", null, [
              t[17] || (t[17] = a("th", { rel: "otherExpenses" }, "Other Expenses", -1)),
              (p(!0), h(A, null, D(e.mpod, (o) => (p(), h("td", {
                class: "table-column",
                key: o.year + o.month
              }, [
                a("div", {
                  class: "table-content table-grey adv-otherExpenses",
                  title: e.currency(o.otherExpense)
                }, [
                  o.noIncome ? (p(), h(A, { key: 0 }, [
                    y(" - ")
                  ], 64)) : (p(), h(A, { key: 1 }, [
                    y(g(e.shortCurrency(o.otherExpense)), 1)
                  ], 64))
                ], 8, mRt)
              ]))), 128)),
              a("th", fRt, g(e.shortCurrency(e.mpodSum((o) => o.otherExpense))), 1)
            ]),
            e.hasAnyFurnishingExpenses ? (p(), h("tr", gRt, [
              t[18] || (t[18] = a("th", { rel: "furnishingExpenses" }, "Furnishing Expenses", -1)),
              (p(!0), h(A, null, D(e.mpod, (o) => (p(), h("td", {
                class: "table-column",
                key: o.year + o.month
              }, [
                a("div", {
                  class: "table-content table-grey adv-furnishingExpenses",
                  title: e.currency(o.furnishingExpenses)
                }, [
                  o.noIncome ? (p(), h(A, { key: 0 }, [
                    y(" - ")
                  ], 64)) : (p(), h(A, { key: 1 }, [
                    y(g(e.shortCurrency(o.furnishingExpenses)), 1)
                  ], 64))
                ], 8, vRt)
              ]))), 128)),
              a("th", yRt, g(e.shortCurrency(e.mpodSum((o) => o.furnishingExpenses))), 1)
            ])) : P("", !0),
            e.hasAnyConsumableExpenses ? (p(), h("tr", bRt, [
              t[19] || (t[19] = a("th", { rel: "consumableExpenses" }, "Consumable Expenses", -1)),
              (p(!0), h(A, null, D(e.mpod, (o) => (p(), h("td", {
                class: "table-column",
                key: o.year + o.month
              }, [
                a("div", {
                  class: "table-content table-grey adv-consumableExpenses",
                  title: e.currency(o.consumableExpenses)
                }, [
                  o.noIncome ? (p(), h(A, { key: 0 }, [
                    y(" - ")
                  ], 64)) : (p(), h(A, { key: 1 }, [
                    y(g(e.shortCurrency(o.consumableExpenses)), 1)
                  ], 64))
                ], 8, ARt)
              ]))), 128)),
              a("th", wRt, g(e.shortCurrency(e.mpodSum((o) => o.consumableExpenses))), 1)
            ])) : P("", !0),
            e.hasAnyCleaningExpenses ? (p(), h("tr", CRt, [
              t[20] || (t[20] = a("th", { rel: "cleaningExpenses" }, "Cleaning Expenses", -1)),
              (p(!0), h(A, null, D(e.mpod, (o) => (p(), h("td", {
                class: "table-column",
                key: o.year + o.month
              }, [
                a("div", {
                  class: "table-content table-grey adv-cleaningExpenses",
                  title: e.currency(o.cleaningExpenses)
                }, [
                  o.noIncome ? (p(), h(A, { key: 0 }, [
                    y(" - ")
                  ], 64)) : (p(), h(A, { key: 1 }, [
                    y(g(e.shortCurrency(o.cleaningExpenses)), 1)
                  ], 64))
                ], 8, SRt)
              ]))), 128)),
              a("th", PRt, g(e.shortCurrency(e.mpodSum((o) => o.cleaningExpenses))), 1)
            ])) : P("", !0),
            (p(!0), h(A, null, D(e.otherExpenseAccounts, (o) => (p(), h(A, null, [
              e.hasAnyValues(o) ? (p(), h("tr", kRt, [
                a("th", ERt, g(o.name), 1),
                (p(!0), h(A, null, D(e.mpod, (l) => (p(), h("td", {
                  class: "table-column",
                  key: l.year + l.month
                }, [
                  a("div", {
                    class: "adv-otherExpenses",
                    title: e.currency(e.getOtherExpense(o.id, l.year, l.month))
                  }, [
                    l.noIncome ? (p(), h(A, { key: 0 }, [
                      y(" - ")
                    ], 64)) : (p(), h(A, { key: 1 }, [
                      y(g(e.shortCurrency(e.getOtherExpense(o.id, l.year, l.month))), 1)
                    ], 64))
                  ], 8, IRt)
                ]))), 128)),
                a("th", TRt, g(e.shortCurrency(e.mpodSum((l) => e.getOtherExpense(o.id, l.year, l.month)))), 1)
              ])) : P("", !0)
            ], 64))), 256)),
            a("tr", ORt, [
              t[21] || (t[21] = a("th", {
                rel: "totalexpenses",
                class: "pb-3"
              }, [
                a("strong", null, "Total Expenses")
              ], -1)),
              (p(!0), h(A, null, D(e.mpod, (o) => (p(), h("th", {
                class: "table-column",
                key: o.year + o.month
              }, [
                a("div", {
                  class: "adv-totalExpenses",
                  title: e.currency(o.totalOperatingExpenses)
                }, [
                  o.noIncome ? (p(), h(A, { key: 0 }, [
                    y(" - ")
                  ], 64)) : (p(), h(A, { key: 1 }, [
                    y(g(e.shortCurrency(o.totalOperatingExpenses)), 1)
                  ], 64))
                ], 8, RRt)
              ]))), 128)),
              a("th", LRt, g(e.shortCurrency(e.mpodSum((o) => o.totalOperatingExpenses))), 1)
            ]),
            a("tr", BRt, [
              t[22] || (t[22] = a("th", { rel: "noi" }, "Net Operating Income", -1)),
              (p(!0), h(A, null, D(e.mpod, (o) => (p(), h("td", {
                class: "table-column",
                key: o.year + o.month
              }, [
                a("div", {
                  class: z(["adv-noi", e.currencyStyle(o.netOperatingIncome)]),
                  title: e.currency(o.netOperatingIncome)
                }, [
                  o.noIncome ? (p(), h(A, { key: 0 }, [
                    y(" - ")
                  ], 64)) : (p(), h(A, { key: 1 }, [
                    y(g(e.shortCurrency(o.netOperatingIncome)), 1)
                  ], 64))
                ], 10, MRt)
              ]))), 128)),
              a("th", xRt, [
                a("span", {
                  class: z(e.currencyStyle(e.mpodSum((o) => o.netOperatingIncome)))
                }, g(e.shortCurrency(e.mpodSum((o) => o.netOperatingIncome))), 3)
              ])
            ])
          ]),
          t[28] || (t[28] = a("thead", null, [
            a("tr", { class: "table-alice" }, [
              a("th", null, " NON OPERATING EXPENSES "),
              a("td", { colspan: "13" }, " ")
            ])
          ], -1)),
          a("tbody", FRt, [
            a("tr", null, [
              t[23] || (t[23] = a("th", { rel: "debtservice" }, "Debt Service", -1)),
              (p(!0), h(A, null, D(e.mpod, (o) => (p(), h("td", {
                class: "table-column",
                key: o.year + o.month
              }, [
                a("div", {
                  class: "table-content table-grey adv-debtservice",
                  title: e.currency(o.debtService)
                }, [
                  o.noIncome ? (p(), h(A, { key: 0 }, [
                    y(" - ")
                  ], 64)) : (p(), h(A, { key: 1 }, [
                    y(g(e.shortCurrency(o.debtService)), 1)
                  ], 64))
                ], 8, VRt)
              ]))), 128)),
              a("th", DRt, g(e.shortCurrency(e.mpodSum((o) => o.debtService))), 1)
            ]),
            a("tr", null, [
              t[24] || (t[24] = a("th", { rel: "capitalExpenditures" }, "Capital Expenditures", -1)),
              (p(!0), h(A, null, D(e.mpod, (o) => (p(), h("td", {
                class: "table-column",
                key: o.year + o.month
              }, [
                a("div", {
                  class: "table-content table-grey adv-capitalExpenditures",
                  title: e.currency(o.capitalExpenditures)
                }, [
                  o.noIncome ? (p(), h(A, { key: 0 }, [
                    y(" - ")
                  ], 64)) : (p(), h(A, { key: 1 }, [
                    y(g(e.shortCurrency(o.capitalExpenditures)), 1)
                  ], 64))
                ], 8, NRt)
              ]))), 128)),
              a("th", jRt, g(e.shortCurrency(e.mpodSum((o) => o.capitalExpenditures))), 1)
            ]),
            (p(!0), h(A, null, D(e.otherNonOperatingExpenseAccounts, (o) => (p(), h(A, null, [
              e.hasAnyNonOperatingExpenseValues(o) ? (p(), h("tr", HRt, [
                a("th", URt, g(o.name), 1),
                (p(!0), h(A, null, D(e.mpod, (l) => (p(), h("td", {
                  class: "table-column",
                  key: l.year + l.month
                }, [
                  a("div", {
                    class: "adv-otherNonOperatingExpense",
                    title: e.currency(e.getOtherNonOperatingExpenseExpense(o.id, l.year, l.month))
                  }, [
                    l.noIncome ? (p(), h(A, { key: 0 }, [
                      y(" - ")
                    ], 64)) : (p(), h(A, { key: 1 }, [
                      y(g(e.shortCurrency(e.getOtherNonOperatingExpenseExpense(o.id, l.year, l.month))), 1)
                    ], 64))
                  ], 8, zRt)
                ]))), 128)),
                a("th", WRt, g(e.shortCurrency(e.mpodSum((l) => e.getOtherNonOperatingExpenseExpense(o.id, l.year, l.month)))), 1)
              ])) : P("", !0)
            ], 64))), 256)),
            a("tr", GRt, [
              t[25] || (t[25] = a("th", {
                rel: "totalNonOperatingExpenses",
                class: "pb-3"
              }, "Total Non Operating Expenses", -1)),
              (p(!0), h(A, null, D(e.mpod, (o) => (p(), h("th", {
                class: "table-column",
                key: o.year + o.month
              }, [
                a("div", {
                  class: "adv-totalNonOperatingExpenses",
                  title: e.currency(o.totalNonOperatingExpenses)
                }, [
                  o.noIncome ? (p(), h(A, { key: 0 }, [
                    y(" - ")
                  ], 64)) : (p(), h(A, { key: 1 }, [
                    y(g(e.shortCurrency(o.totalNonOperatingExpenses)), 1)
                  ], 64))
                ], 8, YRt)
              ]))), 128)),
              a("th", XRt, g(e.shortCurrency(e.mpodSum((o) => o.totalNonOperatingExpenses))), 1)
            ]),
            a("tr", qRt, [
              t[26] || (t[26] = a("th", { rel: "cashflow" }, [
                a("strong", null, "Net Cash Flow")
              ], -1)),
              (p(!0), h(A, null, D(e.mpod, (o) => (p(), h("th", {
                class: "table-column",
                key: o.year + o.month
              }, [
                a("div", {
                  class: z(["table-content last adv-cashflow", e.currencyStyle(o.cashFlow)]),
                  title: e.currency(o.cashFlow)
                }, [
                  o.noIncome ? (p(), h(A, { key: 0 }, [
                    y(" - ")
                  ], 64)) : (p(), h(A, { key: 1 }, [
                    y(g(e.shortCurrency(o.cashFlow)), 1)
                  ], 64))
                ], 10, QRt)
              ]))), 128)),
              a("th", KRt, [
                a("span", {
                  class: z(e.currencyStyle(e.mpodSum((o) => o.cashFlow)))
                }, g(e.shortCurrency(e.mpodSum((o) => o.cashFlow))), 3)
              ])
            ])
          ])
        ])
      ], 2)
    ])
  ], 2);
}
const JRt = /* @__PURE__ */ Ae(R7t, [["render", ZRt]]), $Rt = me({
  name: "AssetReviewTab",
  emits: [
    "saveFields"
  ],
  components: {
    RentvineInformation: h6t,
    AcquisitionAndValue: BTt,
    DistributionsPaid: jTt,
    TrustAccountBalance: QTt,
    EquityValueForecast: v9t,
    PurchaseAndLoan: ROt,
    NetCashFlow: HOt,
    LeaseInformation: ZOt,
    AnnualTaxBenefits: a7t,
    IncomeAndExpenseBreakdown: y7t,
    PortfolioBenchmarkSummary: O7t,
    BrandingHeader: cFe,
    mpod: JRt
  },
  computed: {
    ...q(ba, ["portfolioId"]),
    ...q(Te, ["previewMode", "hasBrandedPortalFeature"])
  },
  methods: {
    saveFields() {
      this.$emit("saveFields");
    }
  }
}), _Rt = { class: "container-lg container-fluid" }, eLt = { class: "row g-3" }, tLt = { class: "col-md-7" }, sLt = { class: "col-md-5" }, aLt = { class: "col-lg-7" }, nLt = { class: "col-lg-5 d-flex flex-column flex-md-row flex-lg-column gap-3" }, rLt = { class: "col-lg-7" }, oLt = { class: "col-lg-5" }, iLt = { class: "col-lg-12" };
function lLt(e, t, s, n, r, i) {
  const o = pe("equity-value-forecast"), l = pe("purchase-and-loan"), d = pe("net-cash-flow"), c = pe("lease-information"), u = pe("annual-tax-benefits"), m = pe("income-and-expense-breakdown"), f = pe("portfolio-benchmark-summary"), v = pe("mpod");
  return p(), h("div", _Rt, [
    a("div", eLt, [
      a("div", tLt, [
        N(o)
      ]),
      a("div", sLt, [
        N(l, { onSaveFields: e.saveFields }, null, 8, ["onSaveFields"])
      ]),
      a("div", aLt, [
        N(d)
      ]),
      a("div", nLt, [
        N(c, { "portfolio-id": e.portfolioId }, null, 8, ["portfolio-id"]),
        N(u)
      ]),
      a("div", rLt, [
        N(m)
      ]),
      a("div", oLt, [
        N(f)
      ]),
      a("div", iLt, [
        N(v)
      ])
    ])
  ]);
}
const dds = /* @__PURE__ */ Ae($Rt, [["render", lLt]]);
var cr = /* @__PURE__ */ ((e) => (e.ListPrice = "list-price", e.MlsModified = "mls-modified", e.DoM = "dom", e.IRR = "irr", e))(cr || {});
const cds = {
  mounted: function(e, t) {
    const s = function(n) {
      t != null && t.value && t.value(n, e) && window.removeEventListener("scroll", s);
    };
    window.addEventListener("scroll", s);
  }
};
function uds() {
  var e, t;
  document.body.scrollTop > 60 || document.documentElement.scrollTop > 60 ? (e = document.querySelector("#id > #navbar")) == null || e.classList.add("sticky") : (t = document.querySelector("#id > #navbar")) == null || t.classList.remove("sticky");
}
const OE = {
  mounted: function(e, t) {
    const s = function(n) {
      t.value(n, e) && window.removeEventListener("resize", s);
    };
    window.addEventListener("resize", s);
  }
}, dLt = (e, t) => t.filter((s) => {
  const { text: n } = e;
  if (typeof s.rule == "string")
    return n && !new RegExp(s.rule).test(n);
  if (s.rule instanceof RegExp)
    return n && !s.rule.test(n);
  if ({}.toString.call(s.rule) === "[object Function]")
    return s.rule(e);
}).map((s) => s.classes), cd = (e) => JSON.parse(JSON.stringify(e)), RE = (e, t, s = [], n) => {
  e.text === void 0 && (e = { text: e });
  const r = dLt(e, s), i = t.findIndex((c) => c === e), o = cd(t), l = i !== -1 ? o.splice(i, 1)[0] : cd(e);
  return (n ? n(o, l) : o.map((c) => c.text).indexOf(l.text) !== -1) && r.push("ti-duplicate"), r.length === 0 ? r.push("ti-valid") : r.push("ti-invalid"), r;
}, Xl = (e, t, s = [], n) => {
  e.text === void 0 && (e = { text: e });
  const r = cd(e);
  return r.tiClasses = RE(e, t, s), r;
}, cLt = (e, t = []) => e.map((s) => Xl(s, e, t)), uLt = me({
  name: "TagInput",
  props: {
    scope: {
      type: Object,
      required: !0
    }
  }
}), pLt = ["maxlength"];
function hLt(e, t, s, n, r, i) {
  return e.scope.edit ? V((p(), h("input", {
    key: 0,
    "onUpdate:modelValue": t[0] || (t[0] = (o) => e.scope.tag.text = o),
    maxlength: e.scope.maxlength,
    type: "text",
    class: "ti-tag-input",
    size: "1",
    onInput: t[1] || (t[1] = (o) => e.scope.validateTag(e.scope.index, o)),
    onBlur: t[2] || (t[2] = (o) => e.scope.performCancelEdit(e.scope.index)),
    onKeydown: t[3] || (t[3] = (o) => e.scope.performSaveEdit(e.scope.index, o)),
    autocomplete: "off"
  }, null, 40, pLt)), [
    [_e, e.scope.tag.text]
  ]) : P("", !0);
}
const mLt = /* @__PURE__ */ Ae(uLt, [["render", hLt], ["__scopeId", "data-v-1680645a"]]), fS = (e) => !e.some((t) => {
  const s = !t.text;
  s && console.warn('Missing property "text"', t);
  let n = !1;
  return t.classes && (n = typeof t.classes != "string"), n && console.warn('Property "classes" must be type of string', t), s || n;
}), gS = (e) => !e.some((t) => {
  if (typeof t == "number") {
    const s = isFinite(t) && Math.floor(t) === t;
    return s || console.warn("Only numerics are allowed for this prop. Found:", t), !s;
  } else if (typeof t == "string") {
    const s = /\W|[a-z]|!\d/i.test(t);
    return s || console.warn("Only alpha strings are allowed for this prop. Found:", t), !s;
  } else
    return console.warn("Only numeric and string values are allowed. Found:", t), !1;
}), fLt = {
  /**
   * @description Property to bind a model to the input.
     If the user changes the input value, the model updates, too.
     If the user presses enter with an valid input,
     a new tag is created with the value of this model.
     After creating the new tag, the model is cleared.
   * @property {props}
   * @required
   * @type {String}
   * @model
   * @default ''
   */
  modelValue: {
    type: String,
    default: "",
    required: !0
  },
  /**
   * @description Pass an array containing objects like in the example below.
     The properties 'style' and 'class' are optional. Of course it is possible to add custom
     properties to a tag object. vue-tags-input won't change the key and value.
   * @property {props}
   * @type {Array}
   * @sync
   * @default []
   * @example
    {
    &emsp;text: 'My tag value', &#47;* The visible text on display *&#47;
    &emsp;style: 'background-color: #ccc', &#47;* Adding inline styles is possible *&#47;
    &emsp;classes: 'custom-class another', &#47;* The value will be added as css classes *&#47;
    }
   */
  tags: {
    type: Object,
    default: () => [],
    validator: fS
  },
  /**
   * @description Expects an array containing objects inside. The objects
    can have the same properties as a tag object.
   * @property {props}
   * @type {Array}
   * @default []
   */
  autocompleteItems: {
    type: Array,
    default: () => [],
    validator: fS
  },
  /**
   * @description Defines whether a tag is editable after creation or not.
   * @property {props}
   * @type {Boolean}
   * @default false
   */
  allowEditTags: {
    type: Boolean,
    default: !1
  },
  /**
   * @description Defines if duplicate autocomplete items are filtered out from the view or not.
   * @property {props}
   * @type {Boolean}
   * @default true
   */
  autocompleteFilterDuplicates: {
    default: !0,
    type: Boolean
  },
  /**
   * @description If it's true, the user can add tags only via the autocomplete layer.
   * @property {props}
   * @type {Boolean}
   * @default false
   */
  addOnlyFromAutocomplete: {
    type: Boolean,
    default: !1
  },
  /**
   * @description The minimum character length which is required
     until the autocomplete layer is shown. If set to 0,
     then it'll be shown on focus.
   * @property {props}
   * @type {Number}
   * @default 1
   */
  autocompleteMinLength: {
    type: Number,
    default: 1
  },
  /**
   * @description If it's true, the autocomplete layer is always shown, regardless if
     an input or an autocomplete items exists.
   * @property {props}
   * @type {Boolean}
   * @default false
   */
  autocompleteAlwaysOpen: {
    type: Boolean,
    default: !1
  },
  /**
   * @description Property to disable vue-tags-input.
   * @property {props}
   * @type {Boolean}
   * @default false
   */
  disabled: {
    type: Boolean,
    default: !1
  },
  /**
   * @description The placeholder text which is shown in the input, when it's empty.
   * @property {props}
   * @type {String}
   * @default Add Tag
   */
  placeholder: {
    type: String,
    default: "Add Tag"
  },
  /**
   * @description Custom trigger key codes can be registrated. If the user presses one of these,
     a tag will be generated out of the input value. Can be either a numeric keyCode or the key
     as a string.
   * @property {props}
   * @type {Array}
   * @default [13]
   * @example add-on-key="[13, ':', ';']"
   */
  addOnKey: {
    type: Array,
    default: () => [13],
    validator: gS
  },
  /**
   * @description Custom trigger key codes can be registrated. If the user edits a tag
     and presses one of these, the edited tag will be saved.
     Can be either a numeric keyCode or the key as a string.
   * @property {props}
   * @type {Array}
   * @default [13]
   * @example save-on-key="[13, ':', ';']"
   */
  saveOnKey: {
    type: Array,
    default: () => [13],
    validator: gS
  },
  /**
   * @description The maximum amount the tags array is allowed to hold.
   * @property {props}
   * @type {Number}
   */
  maxTags: {
    type: Number
  },
  /**
   * @description The maximum amount of characters the input is allowed to hold.
   * @property {props}
   * @type {Number}
   */
  maxlength: {
    type: Number
  },
  /**
   * @description Pass an array containing objects like in the example below.
     The property 'classes' will be added as css classes, if the property 'rule' matches the text
     of a tag, an autocomplete item or the input. The property 'rule' can be type of
     RegExp or function. If the property 'disableAdd' is 'true', the item can't be added
     to the tags array, if the appropriated rule matches.
   * @property {props}
   * @type {Array}
   * @default []
   * @example
    {
    &ensp;classes: 'class', &#47;* css class *&#47;
    &ensp;rule: /^([^0-9]*)$/, &#47;* RegExp *&#47;
    }, {
    &ensp;classes: 'no-braces', &#47;* css class *&#47;
    &ensp;rule(text) { &#47;* function with text as param *&#47;
    &ensp;&ensp;return text.indexOf('{') !== -1 || text.indexOf('}') !== -1;
    &ensp;},
    &ensp;disableAdd: true, &#47;* if the rule matches, the item cannot be added *&#47;,
    },
   */
  validation: {
    type: Object,
    default: () => [],
    validator(e) {
      return !e.some((t) => {
        const s = !t.rule;
        s && console.warn('Property "rule" is missing', t);
        const n = t.rule && (typeof t.rule == "string" || t.rule instanceof RegExp || {}.toString.call(t.rule) === "[object Function]");
        n || console.warn(
          "A rule must be type of string, RegExp or function. Found:",
          JSON.stringify(t.rule)
        );
        const r = !t.classes;
        r && console.warn('Property "classes" is missing', t);
        const i = t.type && typeof t.type != "string";
        return i && console.warn('Property "type" must be type of string. Found:', t), !n || s || r || i;
      });
    }
  },
  /**
   * @description Defines the characters which splits a text into different pieces,
     to generate tags out of this pieces.
   * @property {props}
   * @type {Array}
   * @default [';']
   * @example
     separators: [';', ',']
     input: some; user input, has random; commas, an,d semicolons
     will split into: some - user input - has random - commas - an - d semicolons
   */
  separators: {
    type: Array,
    default: () => [";"],
    validator(e) {
      return !e.some((t) => {
        const s = typeof t != "string";
        return s && console.warn("Separators must be type of string. Found:", t), s;
      });
    }
  },
  /**
   * @description If it's true, the user can't add or save a tag,
     if another exists, with the same text value.
   * @property {props}
   * @type {Boolean}
   * @default true
   */
  avoidAddingDuplicates: {
    type: Boolean,
    default: !0
  },
  /**
   * @description If the input holds a value and loses the focus,
     a tag will be generated out of this value, if possible.
   * @property {props}
   * @type {Boolean}
   * @default true
   */
  addOnBlur: {
    type: Boolean,
    default: !0
  },
  /**
   * @description Custom function to detect duplicates. If the function returns 'true',
    the tag will be marked as duplicate.
   * @property {props}
   * @type {Function}
   * @param {Array} tagsarray The Array of tags minus the one which is edited/created.
   * @param {Object} tag The tag which is edited or should be added to the tags array.
   * @example
     // The duplicate function to recreate the default behaviour, would look like this:
     isDuplicate(tags, tag) {
     &ensp;return tags.map(t => t.text).indexOf(tag.text) !== -1;
    }
   */
  isDuplicate: {
    type: Function,
    default: null
  },
  /**
   * @description If it's true, the user can paste into the input element and
     vue-tags-input will create tags out of the incoming text.
   * @property {props}
   * @type {Boolean}
   * @default true
   */
  addFromPaste: {
    type: Boolean,
    default: !0
  },
  /**
   * @description Defines if it's possible to delete tags by pressing backspace.
     If so and the user wants to delete a tag,
     the tag gets the css class 'deletion-mark' for 1 second.
     If the user presses backspace again in that time period,
     the tag is removed from the tags array and the view.
   * @property {props}
   * @type {Boolean}
   * @default true
   */
  deleteOnBackspace: {
    default: !0,
    type: Boolean
  }
}, gLt = me({
  name: "VueTagsInput",
  components: {
    TagInput: mLt
  },
  props: fLt,
  emits: [
    "before-adding-tag",
    "before-deleting-tag",
    "before-editing-tag",
    "before-saving-tag",
    "max-tags-reached",
    "adding-duplicate",
    "saving-duplicate",
    "tag-clicked",
    "tags-changed",
    "blur",
    "focus",
    "update:modelValue",
    "update:tags"
  ],
  data() {
    return {
      newTag: void 0,
      tagsCopy: void 0,
      tagsEditStatus: void 0,
      deletionMark: void 0,
      deletionMarkTime: void 0,
      selectedItem: void 0,
      focused: void 0
    };
  },
  computed: {
    canAddMore() {
      var e;
      return !this.maxTags || (((e = this.tagsCopy) == null ? void 0 : e.length) ?? 0) < this.maxTags;
    },
    // Property which calculates if the autocomplete should be opened or not
    autocompleteOpen() {
      return this.autocompleteAlwaysOpen ? !0 : this.newTag !== void 0 && this.newTag.length >= this.autocompleteMinLength && this.filteredAutocompleteItems.length > 0 && this.focused;
    },
    // Returns validated autocomplete items. Maybe duplicates are filtered out
    filteredAutocompleteItems() {
      const e = this.$props.autocompleteItems.map((t) => Xl(t, this.$props.tags, this.$props.validation, this.isDuplicate));
      return this.$props.autocompleteFilterDuplicates ? e.filter(this.duplicateFilter) : e;
    }
  },
  methods: {
    createClasses: RE,
    // Returns the index which item should be selected, based on the parameter 'method'
    getSelectedIndex(e) {
      const t = this.filteredAutocompleteItems, s = this.selectedItem, n = t.length - 1;
      if (t.length !== 0)
        return s === void 0 ? 0 : e === "before" && s === 0 ? n : e === "after" && s === n ? 0 : e === "after" ? s + 1 : s - 1;
    },
    selectDefaultItem() {
      this.$props.addOnlyFromAutocomplete && this.filteredAutocompleteItems.length > 0 ? this.selectedItem = 0 : this.selectedItem = void 0;
    },
    selectItem(e, t) {
      e.preventDefault(), this.selectedItem = this.getSelectedIndex(t);
    },
    isSelected(e) {
      return this.selectedItem === e;
    },
    isMarked(e) {
      return this.deletionMark === e;
    },
    // Method which is called when the user presses backspace → remove the last tag
    invokeDelete() {
      var t;
      if (!this.deleteOnBackspace || this.newTag && this.newTag.length > 0)
        return;
      const e = (((t = this.tagsCopy) == null ? void 0 : t.length) ?? 0) - 1;
      this.deletionMark === void 0 ? (this.deletionMarkTime = setTimeout(() => this.deletionMark = void 0, 1e3), this.deletionMark = e) : this.performDeleteTag(e);
    },
    addTagsFromPaste() {
      this.$props.addFromPaste && setTimeout(() => this.performAddTags(this.newTag), 10);
    },
    // Method to call if a tag should switch to it's edit mode
    performEditTag(e) {
      this.$props.allowEditTags && (this.$attrs["before-editing-tag"] || this.editTag(e), this.$emit("before-editing-tag", {
        index: e,
        tag: this.tagsCopy[e],
        editTag: () => this.editTag(e)
      }));
    },
    // Opens the edit mode for a tag and focuses it
    editTag(e) {
      this.$props.allowEditTags && (this.toggleEditMode(e), this.focus(e));
    },
    // Toggles the edit mode for a tag
    toggleEditMode(e) {
      !this.$props.allowEditTags || this.$props.disabled || (this.tagsEditStatus[e] = !this.tagsEditStatus[e]);
    },
    // only called by the @input event from TagInput.
    // Creates a new tag model and applies it to this.tagsCopy[index]
    createChangedTag(e, t) {
      const s = this.tagsCopy[e];
      s.text = t ? t.target.value : this.tagsCopy[e].text, this.tagsCopy[e] = Xl(s, this.tagsCopy, this.$props.validation, this.$props.isDuplicate);
    },
    // Focuses the input of a tag
    focus(e) {
      this.$nextTick(() => {
        const t = this.$refs.tagCenter[e].querySelector("input.ti-tag-input");
        t && t.focus();
      });
    },
    quote(e) {
      return e.replace(/([()[{*+.$^\\|?])/g, "\\$1");
    },
    // Cancels the edit mode for a tag → resets the tag to it's original model!
    cancelEdit(e) {
      this.$props.tags[e] && (this.tagsCopy[e] = cd(
        Xl(this.$props.tags[e], this.$props.tags, this.validation, this.isDuplicate)
      ), this.tagsEditStatus[e] = !1);
    },
    hasForbiddingAddRule(e) {
      return e.some((t) => {
        const s = this.$props.validation.find((n) => t === n.classes);
        return s ? s.disableAdd : !1;
      });
    },
    // Creates multiple tags out of a string, based on the prop separators
    createTagTexts(e) {
      const t = new RegExp(this.$props.separators.map((s) => this.quote(s)).join("|"));
      return e.split(t).map((s) => ({ text: s }));
    },
    // Method to call to delete a tag
    performDeleteTag(e) {
      this.$emit("before-deleting-tag", {
        index: e,
        tag: this.tagsCopy[e],
        deleteTag: () => this.deleteTag(e)
      });
    },
    deleteTag(e) {
      this.disabled || (this.deletionMark = void 0, clearTimeout(this.deletionMarkTime), this.tagsCopy.splice(e, 1), this.$emit("update:tags", this.tagsCopy), this.$emit("tags-changed", this.tagsCopy));
    },
    // Decides whether the input keyCode is one, which is allowed to modify/add tags
    noTriggerKey(e, t) {
      const s = this[t].indexOf(e.keyCode) !== -1 || this[t].indexOf(e.key) !== -1;
      return s && e.preventDefault(), !s;
    },
    validationTrigger(e) {
      const t = e.target.value + (e.type == "keyup" ? "" : e.key);
      return this.validation.filter((n) => n.autoAdd).find((n) => {
        if (typeof n.rule == "string")
          return new RegExp(n.rule).test(t);
        if (n.rule instanceof RegExp)
          return n.rule.test(t);
        if ({}.toString.call(n.rule) === "[object Function]")
          return n.rule(t);
      }) != null;
    },
    autoAddTag(e, t, s) {
      if (this.validationTrigger(t)) {
        let n = [];
        typeof e == "object" && (n = [e]), typeof e == "string" && (n = this.createTagTexts(e)), n = n.filter((r) => r.text.trim().length > 0), n.forEach((r) => {
          r = Xl(r, this.$props.tags, this.$props.validation, this.$props.isDuplicate), this.$props.onBeforeAddingTag || this.addTag(r, s), this.$emit("before-adding-tag", {
            tag: r,
            addTag: () => this.addTag(r, s)
          });
        });
      }
    },
    // Method to call to add a tag
    performAddTags(e, t, s) {
      if (this.disabled || t && this.noTriggerKey(t, "addOnKey"))
        return;
      let n = [];
      typeof e == "object" && (n = [e]), typeof e == "string" && (n = this.createTagTexts(e)), n = n.filter((r) => r.text.trim().length > 0), n.forEach((r) => {
        r = Xl(r, this.$props.tags, this.$props.validation, this.$props.isDuplicate), this.$props.onBeforeAddingTag || this.addTag(r, s), this.$emit("before-adding-tag", {
          tag: r,
          addTag: () => this.addTag(r, s)
        });
      });
    },
    duplicateFilter(e) {
      return this.isDuplicate ? !this.isDuplicate(this.tagsCopy, e) : !this.tagsCopy.find((t) => t.text === e.text);
    },
    addTag(e, t = "new-tag-input") {
      const s = this.filteredAutocompleteItems.map((n) => n.text);
      this.addOnlyFromAutocomplete && s.indexOf(e.text) === -1 || this.$nextTick(() => {
        if (this.$props.maxTags && this.$props.maxTags <= this.tagsCopy.length)
          return this.$emit("max-tags-reached", e);
        if (this.$props.avoidAddingDuplicates && !this.duplicateFilter(e))
          return this.$emit("adding-duplicate", e);
        this.hasForbiddingAddRule(e.tiClasses) || (this.newTag = "", this.$emit("update:modelValue", ""), this.tagsCopy.push(e), this.$emit("update:tags", this.tagsCopy), t === "autocomplete" && this.$refs.newTagInput.focus(), this.$emit("tags-changed", this.tagsCopy));
      });
    },
    // Method to call to save a tag
    performSaveTag(e, t) {
      const s = this.tagsCopy[e];
      this.$props.disabled || t && this.noTriggerKey(t, "addOnKey") || s.text.trim().length !== 0 && (this.$attrs.onBeforeSavingTag || this.saveTag(e, s), this.$emit("before-saving-tag", {
        index: e,
        tag: s,
        saveTag: () => this.saveTag(e, s)
      }));
    },
    saveTag(e, t) {
      if (this.$props.avoidAddingDuplicates) {
        const s = cd(this.tagsCopy), n = s.splice(e, 1)[0];
        if (this.isDuplicate ? this.isDuplicate(s, n) : s.map((i) => i.text).indexOf(n.text) !== -1)
          return this.$emit("saving-duplicate", t);
      }
      this.hasForbiddingAddRule(t.tiClasses) || (this.tagsCopy[e] = t, this.toggleEditMode(e), this.$emit("update:tags", this.tagsCopy), this.$emit("tags-changed", this.tagsCopy));
    },
    tagsEqual() {
      return !this.tagsCopy.some((e, t) => !Uk(e, this.$props.tags[t]));
    },
    updateNewTag(e) {
      const t = e.target.value;
      this.newTag = t, this.$emit("update:modelValue", t);
    },
    initTags() {
      var e;
      ((e = this.tagsCopy) == null ? void 0 : e.length) != this.tags.length && this.tags.forEach((t) => {
        this.$emit("before-adding-tag", {
          tag: t,
          addTag: () => {
          }
        });
      }), this.tagsCopy = cLt(this.$props.tags, this.$props.validation), this.tagsEditStatus = cd(this.$props.tags).map(() => !1), this.tagsEqual() || this.$emit("update:tags", this.tagsCopy);
    },
    blurredOnClick(e) {
      this.$el.contains(e.target) || this.$el.contains(document.activeElement) || this.performBlur();
    },
    performBlur() {
      this.$props.addOnBlur && this.focused && this.performAddTags(this.newTag), this.focused = !1;
    },
    tagClasses(e, t) {
      return [
        {
          "ti-tag": !0,
          "ti-editing": this.tagsEditStatus[t],
          "ti-deletion-mark": this.isMarked(t)
        },
        e.tiClasses,
        e.classes
      ];
    },
    tagScope(e, t) {
      return {
        edit: this.tagsEditStatus[t],
        maxlength: this.maxlength,
        tag: e,
        index: t,
        validateTag: this.createChangedTag,
        performCancelEdit: this.cancelEdit,
        performSaveEdit: this.performSaveTag
      };
    }
  },
  watch: {
    modelValue(e) {
      this.$props.addOnlyFromAutocomplete || (this.selectedItem = void 0), this.newTag = e;
    },
    tags: {
      handler(e, t) {
        this.initTags();
      },
      deep: !0
    },
    autocompleteOpen: "selectDefaultItem"
  },
  created() {
    this.newTag = this.modelValue, this.initTags();
  },
  mounted() {
    this.selectDefaultItem(), document.addEventListener("click", this.blurredOnClick);
  },
  unmounted() {
    document.removeEventListener("click", this.blurredOnClick);
  }
}), vLt = { class: "ti-input d-flex flex-fill" }, yLt = {
  key: 0,
  class: "ti-tags"
}, bLt = ["onClick"], ALt = { class: "ti-content" }, wLt = {
  key: 0,
  class: "ti-tag-left"
}, CLt = ["onClick"], SLt = {
  key: 1,
  class: "ti-tag-right"
}, PLt = { class: "ti-actions" }, kLt = ["onClick"], ELt = ["onClick"], ILt = {
  key: 0,
  class: "ti-new-tag-input-wrapper"
}, TLt = { autocomplete: "off" }, OLt = ["placeholder", "value", "maxlength", "disabled"], RLt = ["onMouseover"], LLt = ["onClick"];
function BLt(e, t, s, n, r, i) {
  const o = pe("tag-input");
  return p(), h("div", {
    class: z(["input-group input-group-search", [{ disabled: e.disabled }, { focus: e.focused }]])
  }, [
    a("div", vLt, [
      e.tagsCopy ? (p(), h("ul", yLt, [
        (p(!0), h(A, null, D(e.tagsCopy, (l, d) => (p(), h("li", {
          key: d,
          style: rn(l.style),
          class: z(e.tagClasses(l, d)),
          tabindex: "0",
          onClick: (c) => e.$emit("tag-clicked", { tag: l, index: d })
        }, [
          a("div", ALt, [
            e.$slots["tag-left"] ? (p(), h("div", wLt, [
              Ot(e.$slots, "tag-left", {
                tag: l,
                index: d,
                edit: e.tagsEditStatus[d],
                performSaveEdit: e.performSaveTag,
                performDelete: e.performDeleteTag,
                performCancelEdit: e.cancelEdit,
                performOpenEdit: e.performEditTag,
                deletionMark: e.isMarked(d)
              })
            ])) : P("", !0),
            a("div", {
              ref_for: !0,
              ref: "tagCenter",
              class: "ti-tag-center"
            }, [
              e.$slots["tag-center"] ? P("", !0) : (p(), h("span", {
                key: 0,
                class: z({ "ti-hidden": e.tagsEditStatus[d] }),
                onClick: (c) => e.performEditTag(d)
              }, g(l.text), 11, CLt)),
              e.$slots["tag-center"] ? P("", !0) : (p(), Fe(o, {
                key: 1,
                scope: e.tagScope(l, d)
              }, null, 8, ["scope"])),
              Ot(e.$slots, "tag-center", {
                tag: l,
                index: d,
                maxlength: e.maxlength,
                edit: e.tagsEditStatus[d],
                performSaveEdit: e.performSaveTag,
                performDelete: e.performDeleteTag,
                performCancelEdit: e.cancelEdit,
                validateTag: e.createChangedTag,
                performOpenEdit: e.performEditTag,
                deletionMark: e.isMarked(d)
              })
            ], 512),
            e.$slots["tag-right"] ? (p(), h("div", SLt, [
              Ot(e.$slots, "tag-right", {
                tag: l,
                index: d,
                edit: e.tagsEditStatus[d],
                performSaveEdit: e.performSaveTag,
                performDelete: e.performDeleteTag,
                performCancelEdit: e.cancelEdit,
                performOpenEdit: e.performEditTag,
                deletionMark: e.isMarked(d)
              })
            ])) : P("", !0)
          ]),
          a("div", PLt, [
            e.$slots["tag-actions"] ? P("", !0) : V((p(), h("i", {
              key: 0,
              class: "ti-icon-undo",
              onClick: (c) => e.cancelEdit(d)
            }, null, 8, kLt)), [
              [Us, e.tagsEditStatus[d]]
            ]),
            e.$slots["tag-actions"] ? P("", !0) : V((p(), h("i", {
              key: 1,
              class: "ti-icon-close",
              onClick: (c) => e.performDeleteTag(d)
            }, null, 8, ELt)), [
              [Us, !e.tagsEditStatus[d]]
            ]),
            e.$slots["tag-actions"] ? Ot(e.$slots, "tag-actions", {
              key: 2,
              tag: l,
              index: d,
              edit: e.tagsEditStatus[d],
              performSaveEdit: e.performSaveTag,
              performDelete: e.performDeleteTag,
              performCancelEdit: e.cancelEdit,
              performOpenEdit: e.performEditTag,
              deletionMark: e.isMarked(d)
            }) : P("", !0)
          ])
        ], 14, bLt))), 128)),
        e.canAddMore ? (p(), h("li", ILt, [
          a("form", TLt, [
            a("input", Rs({ ref: "newTagInput" }, e.$attrs, {
              class: [[e.createClasses(e.newTag, e.tags, e.validation, e.isDuplicate)], "ti-new-tag-input"],
              placeholder: e.placeholder,
              value: e.newTag,
              maxlength: e.maxlength,
              disabled: e.disabled,
              type: "text",
              size: "1",
              autocomplete: "off",
              onKeydown: [
                t[0] || (t[0] = (l) => e.performAddTags(e.filteredAutocompleteItems[e.selectedItem] || e.newTag, l)),
                t[3] || (t[3] = wo((...l) => e.invokeDelete && e.invokeDelete(...l), ["delete"])),
                t[4] || (t[4] = wo((...l) => e.performBlur && e.performBlur(...l), ["tab"])),
                t[5] || (t[5] = wo((l) => e.selectItem(l, "before"), ["38"])),
                t[6] || (t[6] = wo((l) => e.selectItem(l, "after"), ["40"]))
              ],
              onKeyup: t[1] || (t[1] = (l) => e.autoAddTag(e.filteredAutocompleteItems[e.selectedItem] || e.newTag, l)),
              onPaste: t[2] || (t[2] = (...l) => e.addTagsFromPaste && e.addTagsFromPaste(...l)),
              onInput: t[7] || (t[7] = (...l) => e.updateNewTag && e.updateNewTag(...l)),
              onBlur: t[8] || (t[8] = (l) => e.$emit("blur", l)),
              onFocus: t[9] || (t[9] = (l) => {
                e.focused = !0, e.$emit("focus", l);
              }),
              onClick: t[10] || (t[10] = (l) => e.addOnlyFromAutocomplete ? !1 : e.selectedItem = void 0)
            }), null, 16, OLt)
          ])
        ])) : P("", !0)
      ])) : P("", !0)
    ]),
    Ot(e.$slots, "between-elements"),
    e.autocompleteOpen ? (p(), h("div", {
      key: 0,
      class: "ti-autocomplete",
      onMouseout: t[11] || (t[11] = (l) => e.selectedItem = void 0)
    }, [
      Ot(e.$slots, "autocomplete-header"),
      a("ul", null, [
        (p(!0), h(A, null, D(e.filteredAutocompleteItems, (l, d) => (p(), h("li", {
          key: d,
          style: rn(l.style),
          class: z([[
            l.tiClasses,
            l.classes,
            { "ti-selected-item": e.isSelected(d) }
          ], "ti-item"]),
          onMouseover: (c) => e.disabled ? !1 : e.selectedItem = d
        }, [
          e.$slots["autocomplete-item"] ? Ot(e.$slots, "autocomplete-item", {
            key: 1,
            item: l,
            index: d,
            selected: e.isSelected(d),
            performAdd: (c) => e.performAddTags(c, void 0, "autocomplete")
          }) : (p(), h("div", {
            key: 0,
            onClick: (c) => e.performAddTags(l, void 0, "autocomplete")
          }, g(l.text), 9, LLt))
        ], 46, RLt))), 128))
      ]),
      Ot(e.$slots, "autocomplete-footer")
    ], 32)) : P("", !0)
  ], 2);
}
const MLt = /* @__PURE__ */ Ae(gLt, [["render", BLt]]), xLt = me({
  name: "ListingTile",
  inject: {
    rscConfig: {
      from: Zd
    }
  },
  props: {
    listing: {
      type: Object,
      required: !0
    },
    index: {
      type: Number
    },
    selected: {
      type: Boolean,
      default: !1
    }
  },
  emits: [
    "selectListing",
    "viewListing",
    "propSelected"
  ],
  data() {
    return {
      isSaving: !1
    };
  },
  components: {},
  computed: {
    addressFull() {
      var e;
      return (((e = this.listing.unit) == null ? void 0 : e.length) ?? 0) > 0 ? `${this.listing.address} #${this.listing.unit}` : this.listing.address;
    },
    streetView() {
      return "https://maps.googleapis.com/maps/api/streetview?return_error_code=true&size=400x248&location=" + encodeURIComponent(this.listing.address ?? "") + "," + encodeURIComponent(this.listing.city ?? "") + "," + encodeURIComponent(this.listing.state ?? "") + " " + encodeURIComponent(this.listing.postalCode ?? "") + "&fov=80&key=" + this.rscConfig.GoogleApi;
    },
    photoStyle() {
      return {
        "background-image": this.listing.photo ? `url(${this.listing.photo.replace(/\(/gi, "%28").replace(/\)/gi, "%29")}?tr=n-listingthumb1)` : `url(${this.streetView})`
      };
    },
    listingClasses() {
      return {
        col: !0,
        "listing-tile": !0,
        "listing-blue-chip": this.listing.blueChip == !0,
        selected: this.selected == !0,
        favorite: this.listing.favorite == !0,
        pending: this.listing.isPending == !0,
        active: this.listing.isActive == !0,
        offmarket: (this.listing.isActive && this.listing.isPending) == !1,
        ignore: this.listing.ignore == !0,
        tenant: this.listing.occupied == !0,
        preforeclosure: this.listing.hasForeclosure == !0
      };
    },
    filingType() {
      switch (this.listing.foreclosureFilingType) {
        case xr.Lis:
          return "Lis Pendens";
        case xr.Nod:
          return "Notice of Default";
        case xr.Nos:
          return "Notice of Sale";
        case xr.Nts:
          return "Notice of Trustee's Sale";
        case xr.Reo:
          return "Real Estate Owned";
        default:
          return;
      }
    },
    disqualifiedMessages() {
      var e, t, s;
      return (e = this.listing) != null && e.message ? (s = (t = this.listing) == null ? void 0 : t.message) == null ? void 0 : s.join(`\r
`) : "Meets all financial requirements.";
    },
    isNewlyListed() {
      var e, t;
      return ((e = this.listing) == null ? void 0 : e.listDate) && ol((t = this.listing) == null ? void 0 : t.listDate) < 7;
    },
    showChange() {
      var e, t;
      switch ((e = this.listing) == null ? void 0 : e.changeType) {
        case Xh.PriceDecrease:
          if ((t = this.listing) != null && t.changed && ol(this.listing.changed) < 3)
            return !0;
          break;
      }
      return !1;
    },
    changeText() {
      var e;
      switch ((e = this.listing) == null ? void 0 : e.changeType) {
        case Xh.PriceDecrease:
          return "Reduced!";
      }
      return "";
    },
    guarded() {
      var e, t, s;
      return !((e = this.listing) != null && e.isActiveMarketplaceListing) && !((s = (t = this.access) == null ? void 0 : t.mls) != null && s.hasEntitlements) && !this.isAdmin && !this.isUser;
    },
    irr() {
      return this.showAfterTax ? this.listing.irrAfterTax : this.listing.irr;
    },
    coc() {
      return this.showAfterTax ? this.listing.cocAfterTax : this.listing.coc;
    },
    ...q(ct, ["showAfterTax"]),
    ...q(Te, ["access", "aclLoaded", "isClient", "isAdmin", "isUser"]),
    ...q(il, ["mlsSearchCache"]),
    ...at(il)
  },
  methods: {
    currency: Ze,
    number: Ve,
    percent: Wt,
    formatDate: cs,
    hoursSince: cf,
    timeSince: db,
    dec2(e, t) {
      return (t == null || t == null) && (t = 2), (+e).toFixed(t).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    urlSlug(e) {
      return ci(e, { camelCase: !1 });
    },
    selectListing(e) {
      this.$emit("selectListing", this.listing, e);
    },
    viewListing(e) {
      this.$emit("viewListing", this.listing, e);
    },
    propSelected(e) {
      this.$emit("propSelected", {
        id: this.listing.propId,
        checked: e.target.checked
      }, e);
    },
    async favoriteProperty() {
      try {
        await this.favoriteLock.runExclusive(async () => {
          if (this.isSaving = !0, !this.listing.propId)
            throw new Le("Failed to favorite property.");
          let e;
          if (this.listing.favorite ? e = await W.api.folio.removeFavorite(this.listing.propId) : e = await W.api.folio.addFavorite(this.listing.propId), e.data.status != de.Success)
            throw new Le(e);
          this.cacheStore.incrementMlsSearchCache(), this.listing.favorite = !this.listing.favorite, wt(e.data.message);
        });
      } catch (e) {
        Se(e);
      }
      this.isSaving = !1;
    },
    async ignoreProperty() {
      try {
        await this.ignoreLock.runExclusive(async () => {
          if (this.isSaving = !0, !this.listing.propId)
            throw new Le("Failed to ignore property.");
          let e;
          if (this.listing.ignore ? e = await W.api.folio.removeIgnore(this.listing.propId) : e = await W.api.folio.addIgnore(this.listing.propId), e.data.status != de.Success)
            throw new Le(e);
          this.cacheStore.incrementMlsSearchCache(), this.listing.ignore = !this.listing.ignore, wt(e.data.message);
        });
      } catch (e) {
        Se(e);
      }
      this.isSaving = !1;
    }
  },
  created() {
    this.favoriteLock = new xa(), this.ignoreLock = new xa();
  },
  mounted() {
    document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach((e) => new bootstrap.Tooltip(e));
  }
}), FLt = ["href", "id"], VLt = { class: "card h-100" }, DLt = { class: "listing-photo" }, NLt = { class: "position-absolute top-10 start-10 d-flex align-items-start flex-column" }, jLt = {
  key: 0,
  class: "badge rounded-pill text-bg-eclipse"
}, HLt = {
  key: 1,
  class: "badge rounded-pill text-bg-preforeclosure"
}, ULt = {
  key: 2,
  class: "badge rounded-pill text-bg-eclipse banner-edits"
}, zLt = {
  key: 3,
  class: "badge rounded-pill text-bg-success"
}, WLt = {
  key: 0,
  class: "position-absolute top-10 end-10 d-flex align-items-end flex-column"
}, GLt = {
  key: 0,
  class: "badge rounded-pill text-bg-status mb-2"
}, YLt = { class: "racetrack list-inline m-0" }, XLt = { class: "list-inline-item" }, qLt = ["disabled"], QLt = { class: "list-inline-item" }, KLt = ["disabled"], ZLt = { class: "listing-description" }, JLt = { class: "listing-photo-pricing" }, $Lt = { class: "d-flex justify-content-between align-items-center text-center p-2 listing-list-price" }, _Lt = { class: "flex-fill text-center" }, eBt = { key: 0 }, tBt = { class: "fs-5 fw-bold ms-2" }, sBt = { key: 1 }, aBt = { class: "fw-bold" }, nBt = { key: 2 }, rBt = { class: "fs-5 fw-bold" }, oBt = { key: 3 }, iBt = { class: "fs-5 fw-bold" }, lBt = {
  key: 4,
  class: "flex-column text-start lh-1"
}, dBt = { class: "fs-5 fw-bold" }, cBt = { class: "text-danger fw-bold small" }, uBt = { class: "fw-normal ms-1" }, pBt = {
  key: 5,
  class: "text-center"
}, hBt = { class: "d-block fs-5 fw-bold" }, mBt = { key: 6 }, fBt = { class: "fs-5 fw-bold" }, gBt = { key: 7 }, vBt = { class: "fs-5 fw-bold" }, yBt = {
  key: 0,
  class: "list-inline ms-auto"
}, bBt = {
  key: 0,
  class: "list-inline-item"
}, ABt = {
  key: 1,
  class: "list-inline-item"
}, wBt = {
  key: 2,
  class: "list-inline-item"
}, CBt = {
  key: 3,
  class: "list-inline-item"
}, SBt = {
  key: 1,
  class: "flex-fill text-center"
}, PBt = { class: "d-block fs-5 fw-bold" }, kBt = ["title"], EBt = {
  key: 0,
  class: "p-2 bg-alice"
}, IBt = { class: "guard-data row g-0 bg-alice" }, TBt = {
  key: 0,
  class: "listing-auction-date p-2 col-4 text-center"
}, OBt = { class: "d-block fs-5 fw-bold" }, RBt = {
  key: 1,
  class: "listing-opening-bid p-2 col-4 text-center"
}, LBt = { class: "d-block fs-5 fw-bold" }, BBt = {
  key: 2,
  class: "listing-estimated-equity p-2 col-4 text-center"
}, MBt = { class: "d-block fs-5 fw-bold" }, xBt = {
  key: 0,
  class: "listing-capRate p-2 col-4 text-center d-flex align-items-center justify-content-center flex-column"
}, FBt = { class: "d-block fs-5 fw-bold" }, VBt = { class: "col-8 bg-eastern-breeze p-2 text-center" }, DBt = { class: "row g-0" }, NBt = { class: "col-6 listing-coc" }, jBt = { class: "d-block fs-5 fw-bold" }, HBt = {
  key: 0,
  class: "col-6 listing-irr flex-fill"
}, UBt = { class: "d-block fs-5 fw-bold" }, zBt = { class: "col-12 text-center" }, WBt = { class: "text-secondary" }, GBt = { class: "listing-footer p-2 text-center" }, YBt = { class: "listing-address mb-0 text-truncate" }, XBt = { class: "list-inline m-0 text-small" }, qBt = {
  key: 0,
  class: "list-inline-item"
}, QBt = { class: "list-inline-item" }, KBt = { class: "list-inline-item" }, ZBt = {
  key: 1,
  class: "list-inline-item"
}, JBt = {
  key: 2,
  class: "list-inline-item"
}, $Bt = {
  key: 0,
  class: "small bg-lava text-white p-2 rounded mt-2 d-none"
}, _Bt = { class: "listing-courtesy text-center text-small text-truncate border-top" }, eMt = { key: 0 }, tMt = { key: 1 };
function sMt(e, t, s, n, r, i) {
  return p(), h("a", {
    href: e.listing.url,
    id: e.listing.id,
    onClick: t[3] || (t[3] = mn((...o) => e.selectListing && e.selectListing(...o), ["prevent", "stop"])),
    class: z(e.listingClasses)
  }, [
    a("div", VLt, [
      a("div", DLt, [
        a("div", {
          class: "listing-photo_photo",
          style: rn(e.photoStyle)
        }, null, 4),
        a("div", NLt, [
          e.showChange ? (p(), h("div", jLt, [
            t[4] || (t[4] = a("i", { class: "fa-light fa-arrow-down-long me-1" }, null, -1)),
            y(g(e.changeText), 1)
          ])) : P("", !0),
          e.listing.hasForeclosure ? (p(), h("div", HLt, " Pre-Foreclosure ")) : P("", !0),
          e.listing.tweaked ? (p(), h("div", ULt, t[5] || (t[5] = [
            a("i", { class: "fa-light fa-pencil me-1" }, null, -1),
            y("Custom Edits ")
          ]))) : P("", !0),
          e.isNewlyListed ? (p(), h("span", zLt, " NEW " + g(e.timeSince(e.listing.listDate)) + " Ago ", 1)) : P("", !0)
        ]),
        e.listing.isActive || e.listing.isPending || e.listing.status == "Incomplete" ? (p(), h("div", WLt, [
          e.listing.status ? (p(), h("span", GLt, g(e.listing.status), 1)) : P("", !0)
        ])) : P("", !0),
        a("span", {
          onClick: t[0] || (t[0] = mn((...o) => e.viewListing && e.viewListing(...o), ["prevent", "stop"])),
          class: "btn btn-eclipse btn-sm viewListingBtn map-only d-none"
        }, "View Listing"),
        a("ul", YLt, [
          a("li", XLt, [
            a("span", {
              onClick: t[1] || (t[1] = mn((...o) => e.favoriteProperty && e.favoriteProperty(...o), ["prevent", "stop"])),
              class: "mlse-save btn btn-sm rounded-circle",
              "data-bs-toggle": "tooltip",
              title: "Favorite/Unfavorite listing",
              disabled: e.isSaving
            }, [
              a("i", {
                class: z(["fa-heart", { "fa-light": !e.listing.favorite, "fa-solid": e.listing.favorite }])
              }, null, 2)
            ], 8, qLt)
          ]),
          a("li", QLt, [
            a("span", {
              onClick: t[2] || (t[2] = mn((...o) => e.ignoreProperty && e.ignoreProperty(...o), ["prevent", "stop"])),
              class: z(["mls-ignore btn btn-sm btn-light rounded-circle", { rejected: e.listing.ignore }]),
              "data-bs-toggle": "tooltip",
              title: "Ignore Property",
              disabled: e.isSaving
            }, [
              a("i", {
                class: z(["fa-thumbs-down", { "fa-light": !e.listing.ignore, "fa-solid": e.listing.ignore }])
              }, null, 2)
            ], 10, KLt)
          ])
        ])
      ]),
      a("div", ZLt, [
        a("div", JLt, [
          a("div", $Lt, [
            a("div", _Lt, [
              e.listing.isForeclosure ? (p(), h("div", eBt, [
                t[6] || (t[6] = a("small", null, "Opening Bid: ", -1)),
                a("b", tBt, g(e.currency(e.listing.openingBid, !1, "N/A", !0)), 1)
              ])) : e.listing.isForeclosure && e.filingType ? (p(), h("div", sBt, [
                a("b", aBt, g(e.filingType), 1)
              ])) : e.listing.isOffmarket && e.listing.purchasePrice === null ? (p(), h("div", nBt, [
                a("b", rBt, g(e.currency(e.listing.propertyValue)), 1)
              ])) : e.listing.isOffmarket && e.listing.purchasePrice !== null ? (p(), h("div", oBt, [
                a("b", iBt, g(e.currency(e.listing.purchasePrice)), 1)
              ])) : !e.listing.isOffmarket && !e.listing.isRental && (e.listing.listPrice ?? 0) > 0 && e.listing.changeAmount && e.showChange ? (p(), h("div", lBt, [
                a("b", dBt, g(e.currency(e.listing.listPrice)), 1),
                a("div", cBt, [
                  y(g(e.currency(e.listing.changeAmount)) + " ", 1),
                  a("small", uBt, [
                    t[7] || (t[7] = a("i", { class: "fa-light fa-arrow-down-long me-1" }, null, -1)),
                    y(" " + g(e.timeSince(e.listing.changed)), 1)
                  ])
                ])
              ])) : !e.listing.isOffmarket && !e.listing.isRental && (e.listing.listPrice ?? 0) > 0 ? (p(), h("div", pBt, [
                t[8] || (t[8] = a("small", { class: "stats-label text-secondary" }, "LIST PRICE", -1)),
                a("b", hBt, g(e.currency(e.listing.listPrice)), 1)
              ])) : e.listing.isOffmarket === !1 && e.listing.isRental === !0 && e.listing.purchasePrice !== null ? (p(), h("div", mBt, [
                a("b", fBt, g(e.currency(e.listing.purchasePrice)), 1)
              ])) : e.listing.isOffmarket === !1 && e.listing.isRental === !0 && e.listing.purchasePrice === null ? (p(), h("div", gBt, [
                a("b", vBt, g(e.currency(e.listing.propertyValue)), 1)
              ])) : P("", !0)
            ]),
            e.listing.isFeatured || e.listing.blueChip || e.listing.hasValueAdded || e.listing.occupied ? (p(), h("ul", yBt, [
              e.listing.isFeatured ? (p(), h("li", bBt, t[9] || (t[9] = [
                a("span", { class: "badge rounded-pill text-bg-featured" }, " Featured ", -1)
              ]))) : P("", !0),
              e.listing.blueChip ? (p(), h("li", ABt, t[10] || (t[10] = [
                a("span", { class: "badge rounded-pill text-bg-bluechip" }, " Blue Chip ", -1)
              ]))) : P("", !0),
              e.listing.hasValueAdded ? (p(), h("li", wBt, t[11] || (t[11] = [
                a("span", { class: "badge rounded-pill text-bg-valueadd" }, "Value-Add", -1)
              ]))) : P("", !0),
              e.listing.occupied ? (p(), h("li", CBt, t[12] || (t[12] = [
                a("span", { class: "badge rounded-pill text-bg-tenant" }, " Tenant Occupied ", -1)
              ]))) : P("", !0)
            ])) : P("", !0),
            e.listing.initialInvestment ? (p(), h("div", SBt, [
              t[13] || (t[13] = a("small", { class: "stats-label text-secondary" }, "INVESTMENT", -1)),
              a("b", PBt, g(e.currency(e.listing.initialInvestment)), 1)
            ])) : P("", !0)
          ])
        ]),
        a("div", {
          class: z(["listing-stats quickStats", { "guard-wrapper": e.guarded }]),
          title: e.disqualifiedMessages
        }, [
          e.guarded ? (p(), h("div", EBt, t[14] || (t[14] = [
            a("div", { class: "position-absolute top-0 bottom-0 start-0 end-0 d-flex justify-content-center align-items-center flex-row gap-2 z-10 p-2" }, [
              a("span", { class: "fa-stack" }, [
                a("i", { class: "fa-solid fa-circle fa-stack-2x text-eclipse" }),
                a("i", { class: "fa-solid fa-user-plus fa-stack-1x fa-inverse" })
              ]),
              a("small", null, "Subscribe to view Investment Metrics")
            ], -1)
          ]))) : P("", !0),
          a("div", IBt, [
            e.listing.isForeclosure ? (p(), h(A, { key: 0 }, [
              e.listing.auctionDate ? (p(), h("div", TBt, [
                t[15] || (t[15] = a("span", { class: "stats-label text-secondary" }, "Auction Date", -1)),
                a("span", OBt, g(e.formatDate(e.listing.auctionDate)), 1)
              ])) : P("", !0),
              e.listing.openingBid ? (p(), h("div", RBt, [
                t[16] || (t[16] = a("span", { class: "stats-label text-secondary" }, "Opening Bid", -1)),
                a("span", LBt, g(e.currency(e.listing.openingBid, !1, "N/A", !0)), 1)
              ])) : P("", !0),
              e.listing.estimatedEquity ? (p(), h("div", BBt, [
                t[17] || (t[17] = a("span", { class: "stats-label text-secondary" }, "Estimated Equity", -1)),
                a("span", MBt, g(e.currency(e.listing.estimatedEquity)), 1)
              ])) : P("", !0)
            ], 64)) : (p(), h(A, { key: 1 }, [
              e.listing.capRate ? (p(), h("div", xBt, [
                t[18] || (t[18] = a("span", { class: "stats-label text-secondary" }, " Cap Rate ", -1)),
                a("span", FBt, g(e.percent(e.listing.capRate, 1)), 1)
              ])) : P("", !0),
              a("div", VBt, [
                a("div", DBt, [
                  a("div", NBt, [
                    t[19] || (t[19] = a("span", { class: "stats-label text-secondary" }, "CoC", -1)),
                    a("span", jBt, g(e.percent(e.coc, 1)), 1)
                  ]),
                  (e.irr ?? 0) > 0 ? (p(), h("div", HBt, [
                    t[20] || (t[20] = a("span", { class: "stats-label text-secondary" }, " IRR ", -1)),
                    a("span", UBt, g(e.percent(e.irr, 1)), 1)
                  ])) : P("", !0),
                  a("div", zBt, [
                    a("small", WBt, [
                      e.showAfterTax ? (p(), h(A, { key: 0 }, [
                        y(" After Tax ")
                      ], 64)) : (p(), h(A, { key: 1 }, [
                        y(" Before Tax ")
                      ], 64))
                    ])
                  ])
                ])
              ])
            ], 64))
          ])
        ], 10, kBt),
        a("div", GBt, [
          a("p", YBt, [
            y(g(e.addressFull) + " ", 1),
            a("span", null, g(e.listing.city) + ", " + g(e.listing.state) + "  " + g(e.listing.postalCode), 1)
          ]),
          a("ul", XBt, [
            e.listing.sqFt ? (p(), h("li", qBt, [
              t[21] || (t[21] = a("i", { class: "fa-light fa-home me-1" }, null, -1)),
              y(" " + g(e.number(e.listing.sqFt, 0)) + " SF ", 1)
            ])) : P("", !0),
            a("li", QBt, [
              t[22] || (t[22] = a("i", { class: "fa-light fa-bed me-1" }, null, -1)),
              y(" " + g(e.listing.bedrooms) + " ", 1),
              t[23] || (t[23] = a("span", { class: "visually-hidden" }, "Beds", -1))
            ]),
            a("li", KBt, [
              t[24] || (t[24] = a("i", { class: "fa-light fa-bath me-1" }, null, -1)),
              y(" " + g(e.listing.bathrooms) + " ", 1),
              t[25] || (t[25] = a("span", { class: "visually-hidden" }, "Baths", -1))
            ]),
            (e.listing.yearBuilt ?? 0) > 0 ? (p(), h("li", ZBt, [
              t[26] || (t[26] = a("i", { class: "fa-light fa-birthday-cake me-1" }, null, -1)),
              y(" " + g(e.listing.yearBuilt), 1)
            ])) : P("", !0),
            !e.listing.isOffmarket && e.listing.dom ? (p(), h("li", JBt, [
              t[27] || (t[27] = a("i", { class: "fa-light fa-calendar-alt me-1" }, null, -1)),
              y(" " + g(e.listing.dom) + " DoM ", 1)
            ])) : P("", !0)
          ]),
          e.listing.message ? (p(), h("div", $Bt, [
            t[28] || (t[28] = a("strong", null, "The following qualifications were not met:", -1)),
            y(" " + g(e.listing.message), 1)
          ])) : P("", !0)
        ]),
        a("div", _Bt, [
          e.listing.courtesyOf ? (p(), h("span", eMt, "Listed by " + g(e.listing.courtesyOf), 1)) : (p(), h("span", tMt, " "))
        ])
      ])
    ])
  ], 10, FLt);
}
const Kb = /* @__PURE__ */ Ae(xLt, [["render", sMt]]);
let aMt = 0;
const nMt = '<span class="irs"><span class="irs-line" tabindex="0"></span><span class="irs-min">0</span><span class="irs-max">1</span><span class="irs-from">0</span><span class="irs-to">0</span><span class="irs-single">0</span></span><span class="irs-grid"></span>';
class Zb {
  /**
   * Main plugin constructor
   *
   * @param input {HTMLInputElement} link to base input element
   * @param options {config} slider config
   * @param plugin_count {Number}
   * @constructor
   */
  constructor(t, s, n) {
    Xe(this, "VERSION", "3.0.0");
    Xe(this, "input");
    Xe(this, "plugin_count");
    Xe(this, "current_plugin", 0);
    Xe(this, "calc_count", 0);
    Xe(this, "update_tm", null);
    Xe(this, "old_from", 0);
    Xe(this, "old_to", 0);
    Xe(this, "old_min_interval", null);
    Xe(this, "raf_id");
    Xe(this, "dragging", !1);
    Xe(this, "force_redraw", !1);
    Xe(this, "no_diapason", !1);
    Xe(this, "has_tab_index", !0);
    Xe(this, "is_key", !1);
    Xe(this, "is_update", !1);
    Xe(this, "is_start", !0);
    Xe(this, "is_finish", !1);
    Xe(this, "is_active", !1);
    Xe(this, "is_resize", !1);
    Xe(this, "is_click", !1);
    Xe(this, "options");
    Xe(this, "result");
    Xe(this, "update_check");
    Xe(this, "target");
    // cache for links to all DOM elements
    Xe(this, "$cache", {
      win: window,
      body: void 0,
      input: void 0,
      cont: null,
      rs: null,
      min: null,
      max: null,
      from: null,
      to: null,
      single: null,
      bar: null,
      line: null,
      s_single: null,
      s_from: null,
      s_to: null,
      shad_single: null,
      shad_from: null,
      shad_to: null,
      edge: null,
      grid: null,
      grid_labels: []
    });
    // storage for measure variables
    Xe(this, "coords", {
      // left
      x_gap: 0,
      x_pointer: 0,
      // width
      w_rs: 0,
      w_rs_old: 0,
      w_handle: 0,
      // percents
      p_gap: 0,
      p_gap_left: 0,
      p_gap_right: 0,
      p_step: 0,
      p_pointer: 0,
      p_handle: 0,
      p_single_fake: 0,
      p_single_real: 0,
      p_from_fake: 0,
      p_from_real: 0,
      p_to_fake: 0,
      p_to_real: 0,
      p_bar_x: 0,
      p_bar_w: 0,
      // grid
      grid_gap: 0,
      big_num: 0,
      big: [],
      big_w: [],
      big_p: [],
      big_x: []
    });
    // storage for labels measure variables
    Xe(this, "labels", {
      // width
      w_min: 0,
      w_max: 0,
      w_from: 0,
      w_to: 0,
      w_single: 0,
      // percents
      p_min: 0,
      p_max: 0,
      p_from_fake: 0,
      p_from_left: 0,
      p_to_fake: 0,
      p_to_left: 0,
      p_single_fake: 0,
      p_single_left: 0
    });
    var d;
    this.input = t, this.plugin_count = n, s = s || {}, this.$cache.body = document.body, this.$cache.input = t;
    const r = this.$cache.input, i = r.value;
    let o = {
      skin: "flat",
      type: "single",
      min: 10,
      max: 100,
      from: void 0,
      to: void 0,
      step: 1,
      min_interval: 0,
      max_interval: 0,
      drag_interval: !1,
      values: [],
      p_values: [],
      from_fixed: !1,
      from_min: void 0,
      from_max: void 0,
      from_shadow: !1,
      to_fixed: !1,
      to_min: void 0,
      to_max: void 0,
      to_shadow: !1,
      prettify_enabled: !0,
      prettify_separator: " ",
      prettify: void 0,
      force_edges: !1,
      keyboard: !0,
      grid: !1,
      grid_margin: !0,
      grid_num: 4,
      grid_snap: !1,
      hide_min_max: !1,
      hide_from_to: !1,
      prefix: "",
      postfix: "",
      max_postfix: "",
      decorate_both: !0,
      values_separator: " � ",
      input_values_separator: ";",
      disable: !1,
      block: !1,
      extra_classes: "",
      scope: null,
      onStart: void 0,
      onChange: void 0,
      onFinish: void 0,
      onUpdate: void 0
    };
    r.nodeName !== "INPUT" && console && console.warn && console.warn("Base element should be <input>!", r);
    const l = {
      skin: r.dataset.skin,
      type: r.dataset.type,
      min: qn(r.dataset.min),
      max: qn(r.dataset.max),
      from: qn(r.dataset.from),
      to: qn(r.dataset.to),
      step: qn(r.dataset.step),
      min_interval: qn(r.dataset.minInterval),
      max_interval: qn(r.dataset.maxInterval),
      drag_interval: sn(r.dataset.dragInterval),
      values: (d = r.dataset.values) == null ? void 0 : d.split(",").map((c) => parseFloat(c)),
      from_fixed: sn(r.dataset.fromFixed),
      from_min: qn(r.dataset.fromMin),
      from_max: qn(r.dataset.fromMax),
      from_shadow: sn(r.dataset.fromShadow),
      to_fixed: sn(r.dataset.toFixed),
      to_min: qn(r.dataset.toMin),
      to_max: qn(r.dataset.toMax),
      to_shadow: sn(r.dataset.toShadow),
      prettify_enabled: sn(r.dataset.prettifyEnabled),
      prettify_separator: r.dataset.prettifySeparator,
      force_edges: sn(r.dataset.forceEdges),
      keyboard: sn(r.dataset.keyboard),
      grid: sn(r.dataset.grid),
      grid_margin: sn(r.dataset.gridMargin),
      grid_num: qn(r.dataset.gridNum),
      grid_snap: sn(r.dataset.gridSnap),
      hide_min_max: sn(r.dataset.hideMinMax),
      hide_from_to: sn(r.dataset.hideFromTo),
      prefix: r.dataset.prefix,
      postfix: r.dataset.postfix,
      max_postfix: r.dataset.maxPostfix,
      decorate_both: sn(r.dataset.decorateBoth),
      values_separator: r.dataset.valuesSeparator,
      input_values_separator: r.dataset.inputValuesSeparator,
      disable: sn(r.dataset.disable),
      block: sn(r.dataset.block),
      extra_classes: r.dataset.extraClasses
    };
    for (const c in l)
      c in l && (l[c] === void 0 || l[c] === "") && delete l[c];
    if (i !== void 0 && i !== "") {
      const c = i.split(l.input_values_separator ?? s.input_values_separator ?? ";").map((u) => parseFloat(u));
      c[0] && c[0] == +c[0] && (c[0] = +c[0]), c[1] && c[1] == +c[1] && (c[1] = +c[1]), s && s.values && s.values.length ? (o.from = c[0] && s.values.indexOf(c[0]), o.to = c[1] && s.values.indexOf(c[1])) : (o.from = c[0] && +c[0], o.to = c[1] && +c[1]);
    }
    o = Object.assign(o, s), o = Object.assign(o, l), this.options = o, this.update_check = {}, this.validate(), this.result = {
      input: this.$cache.input,
      slider: null,
      min: this.options.min,
      max: this.options.max,
      from: this.options.from,
      from_percent: 0,
      from_value: void 0,
      to: this.options.to,
      to_percent: 0,
      to_value: void 0
    }, this.init();
  }
  /**
   * Static method which allows you to get the IonRangeSlider instance associated with
   * a DOM Input element, or create a new one in case it wasn�t initialised.
   * @param element
   * @param options
   * @returns IonRangeSlider object
   */
  static getOrCreateInstance(t, s) {
    return t.ionRangeSlider || (t.ionRangeSlider = new Zb(t, s, aMt++)), t.ionRangeSlider;
  }
  /**
   * Starts or updates the plugin instance
   *
   * @param [is_update] {boolean}
   */
  init(t = !1) {
    this.no_diapason = !1, this.coords.p_step = this.convertToPercent(this.options.step, !0), this.target = "base", this.toggleInput(), this.append(), this.setMinMax(), t ? (this.force_redraw = !0, this.calc(!0), this.callOnUpdate()) : (this.force_redraw = !0, this.calc(!0), this.callOnStart()), this.updateScene();
  }
  /**
   * Appends slider template to a DOM
   */
  append() {
    const t = '<span class="irs irs--' + this.options.skin + " js-irs-" + this.plugin_count + " " + this.options.extra_classes + '"></span>';
    this.$cache.input.insertAdjacentHTML("beforebegin", t), this.$cache.input.readOnly = !0, this.$cache.cont = this.$cache.input.previousElementSibling, this.result.slider = this.$cache.cont, this.$cache.cont.innerHTML = nMt, this.$cache.rs = this.$cache.cont.querySelector(".irs"), this.$cache.min = this.$cache.cont.querySelector(".irs-min"), this.$cache.max = this.$cache.cont.querySelector(".irs-max"), this.$cache.from = this.$cache.cont.querySelector(".irs-from"), this.$cache.to = this.$cache.cont.querySelector(".irs-to"), this.$cache.single = this.$cache.cont.querySelector(".irs-single"), this.$cache.line = this.$cache.cont.querySelector(".irs-line"), this.$cache.grid = this.$cache.cont.querySelector(".irs-grid"), this.options.type === "single" ? (this.$cache.bar = document.createElement("span"), this.$cache.bar.classList.add("irs-bar", "irs-bar--single"), this.$cache.edge = this.$cache.cont.querySelector(".irs-bar-edge"), this.$cache.shad_single = document.createElement("span"), this.$cache.shad_single.classList.add("irs-shadow", "shadow-single"), this.$cache.s_single = document.createElement("span"), this.$cache.s_single.classList.add("irs-handle", "single"), this.$cache.s_single.innerHTML = "<i></i><i></i><i></i>", this.$cache.from.style.visibility = "hidden", this.$cache.to.style.visibility = "hidden", this.$cache.cont.append(this.$cache.bar, this.$cache.shad_single, this.$cache.s_single)) : (this.$cache.bar = document.createElement("span"), this.$cache.bar.classList.add("irs-bar"), this.$cache.shad_from = document.createElement("span"), this.$cache.shad_from.classList.add("irs-shadow", "shadow-from"), this.$cache.shad_to = document.createElement("span"), this.$cache.shad_to.classList.add("irs-shadow", "shadow-to"), this.$cache.s_from = document.createElement("span"), this.$cache.s_from.classList.add("irs-handle", "from"), this.$cache.s_from.innerHTML = "<i></i><i></i><i></i>", this.$cache.s_to = document.createElement("span"), this.$cache.s_to.classList.add("irs-handle", "to"), this.$cache.s_to.innerHTML = "<i></i><i></i><i></i>", this.$cache.cont.append(this.$cache.bar, this.$cache.shad_from, this.$cache.shad_to, this.$cache.s_from, this.$cache.s_to), this.setTopHandler()), this.options.hide_from_to && (this.$cache.from.style.display = "none", this.$cache.to.style.display = "none", this.$cache.single.style.display = "none"), this.appendGrid(), this.options.disable ? (this.appendDisableMask(), this.$cache.input.disabled = !0) : (this.$cache.input.disabled = !1, this.removeDisableMask(), this.bindEvents()), this.options.disable || (this.options.block ? this.appendDisableMask() : this.removeDisableMask()), this.options.drag_interval && (this.$cache.bar.style.cursor = "ew-resize");
  }
  /**
   * Determine which handler has a priority
   * works only for double slider type
   */
  setTopHandler() {
    var i, o;
    const t = this.options.min ?? 0, s = this.options.max ?? 0, n = this.options.from ?? 0, r = this.options.to ?? 0;
    n > t && r === s ? (i = this.$cache.s_from) == null || i.classList.add("type_last") : r < s && ((o = this.$cache.s_to) == null || o.classList.add("type_last"));
  }
  /**
   * Determine which handles was clicked last
   * and which handler should have hover effect
   *
   * @param target {String}
   */
  changeLevel(t) {
    var s, n, r, i, o, l, d, c, u;
    switch (t) {
      case "single":
        this.coords.p_gap = this.toFixed(this.coords.p_pointer - this.coords.p_single_fake), (s = this.$cache.s_single) == null || s.classList.add("state_hover");
        break;
      case "from":
        this.coords.p_gap = this.toFixed(this.coords.p_pointer - this.coords.p_from_fake), (n = this.$cache.s_from) == null || n.classList.add("state_hover"), (r = this.$cache.s_from) == null || r.classList.add("type_last"), (i = this.$cache.s_to) == null || i.classList.remove("type_last");
        break;
      case "to":
        this.coords.p_gap = this.toFixed(this.coords.p_pointer - this.coords.p_to_fake), (o = this.$cache.s_to) == null || o.classList.add("state_hover"), (l = this.$cache.s_to) == null || l.classList.add("type_last"), (d = this.$cache.s_from) == null || d.classList.remove("type_last");
        break;
      case "both":
        this.coords.p_gap_left = this.toFixed(this.coords.p_pointer - this.coords.p_from_fake), this.coords.p_gap_right = this.toFixed(this.coords.p_to_fake - this.coords.p_pointer), (c = this.$cache.s_to) == null || c.classList.remove("type_last"), (u = this.$cache.s_from) == null || u.classList.remove("type_last");
        break;
    }
  }
  /**
   * Then slider is disabled
   * appends extra layer with opacity
   */
  appendDisableMask() {
    var s, n;
    const t = document.createElement("span");
    t.classList.add("irs-disable-mask"), (s = this.$cache.cont) == null || s.appendChild(t), (n = this.$cache.cont) == null || n.classList.add("irs-disabled");
  }
  /**
   * Then slider is not disabled
   * remove disable mask
   */
  removeDisableMask() {
    var t, s;
    (t = this.$cache.cont) == null || t.querySelectorAll(".irs-disable-mask").forEach((n) => n.remove()), (s = this.$cache.cont) == null || s.classList.remove("irs-disabled");
  }
  /**
   * Remove slider instance
   * and unbind all events
   */
  remove() {
    var t, s;
    (t = this.$cache.cont) == null || t.remove(), this.$cache.cont = null, (s = this.$cache.line) == null || s.removeEventListener("keydown", this.key.bind(this, "keyboard")), this.$cache.body.removeEventListener("touchmove", this.pointerMove.bind(this)), this.$cache.body.removeEventListener("mousemove", this.pointerMove.bind(this)), this.$cache.win.removeEventListener("touchend", this.pointerUp.bind(this)), this.$cache.win.removeEventListener("mouseup", this.pointerUp.bind(this)), vS() && (this.$cache.body.removeEventListener("mouseup", this.pointerUp.bind(this)), this.$cache.body.removeEventListener("mouseleave", this.pointerUp.bind(this))), this.$cache.grid_labels = [], this.coords.big = [], this.coords.big_w = [], this.coords.big_p = [], this.coords.big_x = [], this.raf_id && cancelAnimationFrame(this.raf_id);
  }
  /**
   * bind all slider events
   */
  bindEvents() {
    var t, s, n, r, i, o, l, d, c, u, m, f, v, b, w, S, I, T, x, k, C, O, E, B, M, R, F, L, j, H, te;
    this.no_diapason || (this.$cache.body.addEventListener("touchmove", this.pointerMove.bind(this)), this.$cache.body.addEventListener("mousemove", this.pointerMove.bind(this)), this.$cache.win.addEventListener("touchend", this.pointerUp.bind(this)), this.$cache.win.addEventListener("mouseup", this.pointerUp.bind(this)), (t = this.$cache.line) == null || t.addEventListener("touchstart", this.pointerClick.bind(this, "click")), (s = this.$cache.line) == null || s.addEventListener("mousedown", this.pointerClick.bind(this, "click")), (n = this.$cache.line) == null || n.addEventListener("focus", this.pointerFocus.bind(this)), this.options.drag_interval && this.options.type === "double" ? ((r = this.$cache.bar) == null || r.addEventListener("touchstart", this.pointerDown.bind(this, "both")), (i = this.$cache.bar) == null || i.addEventListener("mousedown", this.pointerDown.bind(this, "both"))) : ((o = this.$cache.bar) == null || o.addEventListener("touchstart", this.pointerClick.bind(this, "click")), (l = this.$cache.bar) == null || l.addEventListener("mousedown", this.pointerClick.bind(this, "click"))), this.options.type === "single" ? ((d = this.$cache.single) == null || d.addEventListener("touchstart", this.pointerDown.bind(this, "single")), (c = this.$cache.s_single) == null || c.addEventListener("touchstart", this.pointerDown.bind(this, "single")), (u = this.$cache.shad_single) == null || u.addEventListener("touchstart", this.pointerClick.bind(this, "click")), (m = this.$cache.single) == null || m.addEventListener("mousedown", this.pointerDown.bind(this, "single")), (f = this.$cache.s_single) == null || f.addEventListener("mousedown", this.pointerDown.bind(this, "single")), (v = this.$cache.edge) == null || v.addEventListener("mousedown", this.pointerClick.bind(this, "click")), (b = this.$cache.shad_single) == null || b.addEventListener("mousedown", this.pointerClick.bind(this, "click"))) : ((w = this.$cache.single) == null || w.addEventListener("touchstart", this.pointerDown.bind(this, null)), (S = this.$cache.single) == null || S.addEventListener("mousedown", this.pointerDown.bind(this, null)), (I = this.$cache.from) == null || I.addEventListener("touchstart", this.pointerDown.bind(this, "from")), (T = this.$cache.s_from) == null || T.addEventListener("touchstart", this.pointerDown.bind(this, "from")), (x = this.$cache.to) == null || x.addEventListener("touchstart", this.pointerDown.bind(this, "to")), (k = this.$cache.s_to) == null || k.addEventListener("touchstart", this.pointerDown.bind(this, "to")), (C = this.$cache.shad_from) == null || C.addEventListener("touchstart", this.pointerClick.bind(this, "click")), (O = this.$cache.shad_to) == null || O.addEventListener("touchstart", this.pointerClick.bind(this, "click")), (E = this.$cache.from) == null || E.addEventListener("mousedown", this.pointerDown.bind(this, "from")), (B = this.$cache.s_from) == null || B.addEventListener("mousedown", this.pointerDown.bind(this, "from")), (M = this.$cache.to) == null || M.addEventListener("mousedown", this.pointerDown.bind(this, "to")), (R = this.$cache.s_to) == null || R.addEventListener("mousedown", this.pointerDown.bind(this, "to")), (F = this.$cache.shad_from) == null || F.addEventListener("mousedown", this.pointerClick.bind(this, "click")), (L = this.$cache.shad_to) == null || L.addEventListener("mousedown", this.pointerClick.bind(this, "click"))), this.options.keyboard && ((j = this.$cache.line) == null || j.addEventListener("keydown", this.key.bind(this, "keyboard"))), vS() && ((H = this.$cache.body) == null || H.addEventListener("mouseup", this.pointerUp.bind(this)), (te = this.$cache.body) == null || te.addEventListener("mouseleave", this.pointerUp.bind(this))));
  }
  /**
   * Focus with tabIndex
   *
   * @param e {Object} event object
   */
  pointerFocus() {
    if (!this.target) {
      let t, s;
      this.options.type === "single" ? s = this.$cache.single : s = this.$cache.from, t = s.getBoundingClientRect().left + window.scrollX, t += parseFloat(getComputedStyle(s, null).width.replace("px", "")) / 2 - 1, this.pointerClick("single", {
        preventDefault: function() {
        },
        pageX: t
      });
    }
  }
  /**
   * Mousemove or touchmove
   * only for handlers
   *
   * @param e {Object} event object
   */
  pointerMove(t) {
    if (!this.dragging)
      return;
    const s = (t == null ? void 0 : t.pageX) || (t == null ? void 0 : t.touches) && (t == null ? void 0 : t.touches[0].pageX);
    this.coords.x_pointer = s - this.coords.x_gap, this.calc();
  }
  /**
   * Mouseup or touchend
   * only for handlers
   *
   * @param e {Object} event object
   */
  pointerUp(t) {
    var s;
    if (this.current_plugin === this.plugin_count) {
      if (this.is_active)
        this.is_active = !1;
      else
        return;
      (s = this.$cache.cont.querySelector(".state_hover")) == null || s.classList.remove("state_hover"), this.force_redraw = !0, this.updateScene(), this.restoreOriginalMinInterval(), (this.$cache.cont.contains(t.target) || this.dragging) && this.callOnFinish(), this.dragging = !1;
    }
  }
  /**
   * Mousedown or touchstart
   * only for handlers
   *
   * @param target {String|null}
   * @param e {Object} event object
   */
  pointerDown(t, s) {
    var r;
    s.preventDefault();
    const n = (s == null ? void 0 : s.pageX) || (s == null ? void 0 : s.touches) && (s == null ? void 0 : s.touches[0].pageX);
    (s == null ? void 0 : s.button) !== 2 && (t === "both" && this.setTempMinInterval(), t || (t = this.target || "from"), this.current_plugin = this.plugin_count, this.target = t, this.is_active = !0, this.dragging = !0, this.coords.x_gap = yS(this.$cache.rs).left, this.coords.x_pointer = n - this.coords.x_gap, this.calcPointerPercent(), this.changeLevel(t), (r = this.$cache.line) == null || r.dispatchEvent(new Event("focus")), this.updateScene());
  }
  /**
   * Mousedown or touchstart
   * for other slider elements, like diapason line
   *
   * @param target {String}
   * @param e {Object} event object
   */
  pointerClick(t, s) {
    var r;
    s.preventDefault();
    const n = (s == null ? void 0 : s.pageX) || (s == null ? void 0 : s.touches) && (s == null ? void 0 : s.touches[0].pageX);
    (s == null ? void 0 : s.button) !== 2 && (this.current_plugin = this.plugin_count, this.target = t, this.is_click = !0, this.coords.x_gap = yS(this.$cache.rs).left, this.coords.x_pointer = +(n - this.coords.x_gap).toFixed(), this.force_redraw = !0, this.calc(), (r = this.$cache.line) == null || r.dispatchEvent(document.createEvent("FocusEvent")));
  }
  /**
   * Keyborard controls for focused slider
   *
   * @param target {String}
   * @param e {Object} event object
   * @returns {boolean|undefined}
   */
  key(t, s) {
    if (!(this.current_plugin !== this.plugin_count || s.altKey || s.ctrlKey || s.shiftKey || s.metaKey)) {
      switch (s.key) {
        case "S":
        // W
        case "A":
        // A
        case "ArrowDown":
        // DOWN
        case "ArrowLeft":
          s.preventDefault(), this.moveByKey(!1);
          break;
        case "W":
        // S
        case "D":
        // D
        case "ArrowUp":
        // UP
        case "ArrowRight":
          s.preventDefault(), this.moveByKey(!0);
          break;
      }
      return !0;
    }
  }
  /**
   * Move by key
   *
   * @param right {boolean} direction to move
   */
  moveByKey(t) {
    let s = this.coords.p_pointer, n = ((this.options.max ?? 0) - (this.options.min ?? 0)) / 100;
    n = (this.options.step ?? 0) / n, t ? s += n : s -= n, this.coords.x_pointer = this.toFixed(this.coords.w_rs / 100 * s), this.is_key = !0, this.calc();
  }
  /**
   * Set visibility and content
   * of Min and Max labels
   */
  setMinMax() {
    if (this.options) {
      if (this.options.hide_min_max) {
        this.$cache.min.style.display = "none", this.$cache.max.style.display = "none";
        return;
      }
      if (this.options.values.length)
        this.$cache.min.innerHTML = this.decorate(this.options.p_values[this.options.min]), this.$cache.max.innerHTML = this.decorate(this.options.p_values[this.options.max]);
      else {
        const t = this._prettify(this.options.min), s = this._prettify(this.options.max);
        this.result.min_pretty = t, this.result.max_pretty = s, this.$cache.min.innerHTML = this.decorate(t, this.options.min), this.$cache.max.innerHTML = this.decorate(s, this.options.max);
      }
      this.labels.w_min = this.$cache.min.getBoundingClientRect().width, this.labels.w_max = this.$cache.max.getBoundingClientRect().width;
    }
  }
  /**
   * Then dragging interval, prevent interval collapsing
   * using min_interval option
   */
  setTempMinInterval() {
    const t = (this.result.to ?? 0) - (this.result.from ?? 0);
    this.old_min_interval === null && (this.old_min_interval = this.options.min_interval), this.options.min_interval = t;
  }
  /**
   * Restore min_interval option to original
   */
  restoreOriginalMinInterval() {
    this.old_min_interval !== null && (this.options.min_interval = this.old_min_interval, this.old_min_interval = null);
  }
  // =============================================================================================================
  // Calculations
  /**
   * All calculations and measures start here
   *
   * @param update {boolean=}
   */
  calc(t) {
    if (!this.options || (this.calc_count++, (this.calc_count === 10 || t) && (this.calc_count = 0, this.coords.w_rs = this.$cache.rs.getBoundingClientRect().width, this.calcHandlePercent()), !this.coords.w_rs))
      return;
    this.calcPointerPercent();
    let s = this.getHandleX();
    switch (this.target === "both" && (this.coords.p_gap = 0, s = this.getHandleX()), this.target === "click" && (this.coords.p_gap = this.coords.p_handle / 2, s = this.getHandleX(), this.options.drag_interval ? this.target = "both_one" : this.target = this.chooseHandle(s)), this.target) {
      case "base":
        {
          const n = (this.options.max - this.options.min) / 100, r = ((this.result.from ?? 0) - this.options.min) / n, i = ((this.result.to ?? 0) - this.options.min) / n;
          this.coords.p_single_real = this.toFixed(r), this.coords.p_from_real = this.toFixed(r), this.coords.p_to_real = this.toFixed(i), this.coords.p_single_real = this.checkDiapason(this.coords.p_single_real, this.options.from_min, this.options.from_max), this.coords.p_from_real = this.checkDiapason(this.coords.p_from_real, this.options.from_min, this.options.from_max), this.coords.p_to_real = this.checkDiapason(this.coords.p_to_real, this.options.to_min, this.options.to_max), this.coords.p_single_fake = this.convertToFakePercent(this.coords.p_single_real), this.coords.p_from_fake = this.convertToFakePercent(this.coords.p_from_real), this.coords.p_to_fake = this.convertToFakePercent(this.coords.p_to_real), this.target = null;
        }
        break;
      case "single":
        if (this.options.from_fixed)
          break;
        this.coords.p_single_real = this.convertToRealPercent(s), this.coords.p_single_real = this.calcWithStep(this.coords.p_single_real), this.coords.p_single_real = this.checkDiapason(this.coords.p_single_real, this.options.from_min, this.options.from_max), this.coords.p_single_fake = this.convertToFakePercent(this.coords.p_single_real);
        break;
      case "from":
        if (this.options.from_fixed)
          break;
        this.coords.p_from_real = this.convertToRealPercent(s), this.coords.p_from_real = this.calcWithStep(this.coords.p_from_real), this.coords.p_from_real > this.coords.p_to_real && (this.coords.p_from_real = this.coords.p_to_real), this.coords.p_from_real = this.checkDiapason(this.coords.p_from_real, this.options.from_min, this.options.from_max), this.coords.p_from_real = this.checkMinInterval(this.coords.p_from_real, this.coords.p_to_real, "from"), this.coords.p_from_real = this.checkMaxInterval(this.coords.p_from_real, this.coords.p_to_real, "from"), this.coords.p_from_fake = this.convertToFakePercent(this.coords.p_from_real);
        break;
      case "to":
        if (this.options.to_fixed)
          break;
        this.coords.p_to_real = this.convertToRealPercent(s), this.coords.p_to_real = this.calcWithStep(this.coords.p_to_real), this.coords.p_to_real < this.coords.p_from_real && (this.coords.p_to_real = this.coords.p_from_real), this.coords.p_to_real = this.checkDiapason(this.coords.p_to_real, this.options.to_min, this.options.to_max), this.coords.p_to_real = this.checkMinInterval(this.coords.p_to_real, this.coords.p_from_real, "to"), this.coords.p_to_real = this.checkMaxInterval(this.coords.p_to_real, this.coords.p_from_real, "to"), this.coords.p_to_fake = this.convertToFakePercent(this.coords.p_to_real);
        break;
      case "both":
        if (this.options.from_fixed || this.options.to_fixed)
          break;
        s = this.toFixed(s + this.coords.p_handle * 1e-3), this.coords.p_from_real = this.convertToRealPercent(s) - this.coords.p_gap_left, this.coords.p_from_real = this.calcWithStep(this.coords.p_from_real), this.coords.p_from_real = this.checkDiapason(this.coords.p_from_real, this.options.from_min, this.options.from_max), this.coords.p_from_real = this.checkMinInterval(this.coords.p_from_real, this.coords.p_to_real, "from"), this.coords.p_from_fake = this.convertToFakePercent(this.coords.p_from_real), this.coords.p_to_real = this.convertToRealPercent(s) + this.coords.p_gap_right, this.coords.p_to_real = this.calcWithStep(this.coords.p_to_real), this.coords.p_to_real = this.checkDiapason(this.coords.p_to_real, this.options.to_min, this.options.to_max), this.coords.p_to_real = this.checkMinInterval(this.coords.p_to_real, this.coords.p_from_real, "to"), this.coords.p_to_fake = this.convertToFakePercent(this.coords.p_to_real);
        break;
      case "both_one":
        {
          if (this.options.from_fixed || this.options.to_fixed)
            break;
          const n = this.convertToRealPercent(s), r = this.result.from_percent, i = this.result.to_percent, o = i - r, l = o / 2;
          let d = n - l, c = n + l;
          d < 0 && (d = 0, c = d + o), c > 100 && (c = 100, d = c - o), this.coords.p_from_real = this.calcWithStep(d), this.coords.p_from_real = this.checkDiapason(this.coords.p_from_real, this.options.from_min, this.options.from_max), this.coords.p_from_fake = this.convertToFakePercent(this.coords.p_from_real), this.coords.p_to_real = this.calcWithStep(c), this.coords.p_to_real = this.checkDiapason(this.coords.p_to_real, this.options.to_min, this.options.to_max), this.coords.p_to_fake = this.convertToFakePercent(this.coords.p_to_real);
        }
        break;
    }
    this.options.type === "single" ? (this.coords.p_bar_x = this.coords.p_handle / 2, this.coords.p_bar_w = this.coords.p_single_fake, this.result.from_percent = this.coords.p_single_real, this.result.from = this.convertToValue(this.coords.p_single_real), this.result.from_pretty = this._prettify(this.result.from), this.options.values.length && (this.result.from_value = this.options.values[this.result.from])) : (this.coords.p_bar_x = this.toFixed(this.coords.p_from_fake + this.coords.p_handle / 2), this.coords.p_bar_w = this.toFixed(this.coords.p_to_fake - this.coords.p_from_fake), this.result.from_percent = this.coords.p_from_real, this.result.from = this.convertToValue(this.coords.p_from_real), this.result.from_pretty = this._prettify(this.result.from), this.result.to_percent = this.coords.p_to_real, this.result.to = this.convertToValue(this.coords.p_to_real), this.result.to_pretty = this._prettify(this.result.to), this.options.values.length && (this.result.from_value = this.options.values[this.result.from], this.result.to_value = this.options.values[this.result.to])), this.calcMinMax(), this.calcLabels();
  }
  /**
   * calculates pointer X in percent
   */
  calcPointerPercent() {
    if (!this.coords.w_rs) {
      this.coords.p_pointer = 0;
      return;
    }
    this.coords.x_pointer < 0 || isNaN(this.coords.x_pointer) ? this.coords.x_pointer = 0 : this.coords.x_pointer > this.coords.w_rs && (this.coords.x_pointer = this.coords.w_rs), this.coords.p_pointer = this.toFixed(this.coords.x_pointer / this.coords.w_rs * 100);
  }
  convertToRealPercent(t) {
    const s = 100 - this.coords.p_handle;
    return t / s * 100;
  }
  convertToFakePercent(t) {
    const s = 100 - this.coords.p_handle;
    return t / 100 * s;
  }
  getHandleX() {
    const t = 100 - this.coords.p_handle;
    let s = this.toFixed(this.coords.p_pointer - this.coords.p_gap);
    return s < 0 ? s = 0 : s > t && (s = t), s;
  }
  calcHandlePercent() {
    this.options.type === "single" ? this.coords.w_handle = this.$cache.s_single.getBoundingClientRect().width : this.coords.w_handle = this.$cache.s_from.getBoundingClientRect().width, this.coords.p_handle = this.toFixed(this.coords.w_handle / this.coords.w_rs * 100);
  }
  /**
   * Find closest handle to pointer click
   *
   * @param real_x {Number}
   * @returns {String}
   */
  chooseHandle(t) {
    if (this.options.type === "single")
      return "single";
    {
      const s = this.coords.p_from_real + (this.coords.p_to_real - this.coords.p_from_real) / 2;
      return t >= s ? this.options.to_fixed ? "from" : "to" : this.options.from_fixed ? "to" : "from";
    }
  }
  /**
   * Measure Min and Max labels width in percent
   */
  calcMinMax() {
    this.coords.w_rs && (this.labels.p_min = this.labels.w_min / this.coords.w_rs * 100, this.labels.p_max = this.labels.w_max / this.coords.w_rs * 100);
  }
  /**
   * Measure labels width and X in percent
   */
  calcLabels() {
    !this.coords.w_rs || this.options.hide_from_to || (this.options.type === "single" ? (this.labels.w_single = this.$cache.single.getBoundingClientRect().width, this.labels.p_single_fake = this.labels.w_single / this.coords.w_rs * 100, this.labels.p_single_left = this.coords.p_single_fake + this.coords.p_handle / 2 - this.labels.p_single_fake / 2, this.labels.p_single_left = this.checkEdges(this.labels.p_single_left, this.labels.p_single_fake)) : (this.labels.w_from = this.$cache.from.getBoundingClientRect().width, this.labels.p_from_fake = this.labels.w_from / this.coords.w_rs * 100, this.labels.p_from_left = this.coords.p_from_fake + this.coords.p_handle / 2 - this.labels.p_from_fake / 2, this.labels.p_from_left = this.toFixed(this.labels.p_from_left), this.labels.p_from_left = this.checkEdges(this.labels.p_from_left, this.labels.p_from_fake), this.labels.w_to = this.$cache.to.getBoundingClientRect().width, this.labels.p_to_fake = this.labels.w_to / this.coords.w_rs * 100, this.labels.p_to_left = this.coords.p_to_fake + this.coords.p_handle / 2 - this.labels.p_to_fake / 2, this.labels.p_to_left = this.toFixed(this.labels.p_to_left), this.labels.p_to_left = this.checkEdges(this.labels.p_to_left, this.labels.p_to_fake), this.labels.w_single = this.$cache.single.getBoundingClientRect().width, this.labels.p_single_fake = this.labels.w_single / this.coords.w_rs * 100, this.labels.p_single_left = (this.labels.p_from_left + this.labels.p_to_left + this.labels.p_to_fake) / 2 - this.labels.p_single_fake / 2, this.labels.p_single_left = this.toFixed(this.labels.p_single_left), this.labels.p_single_left = this.checkEdges(this.labels.p_single_left, this.labels.p_single_fake)));
  }
  // =============================================================================================================
  // Drawings
  /**
   * Main function called in request animation frame
   * to update everything
   */
  updateScene() {
    this.raf_id && (cancelAnimationFrame(this.raf_id), this.raf_id = void 0), clearTimeout(this.update_tm), this.update_tm = null, this.options && (this.drawHandles(), this.is_active ? this.raf_id = requestAnimationFrame(this.updateScene.bind(this)) : this.update_tm = setTimeout(this.updateScene.bind(this), 300));
  }
  /**
   * Draw handles
   */
  drawHandles() {
    this.coords.w_rs = this.$cache.rs.getBoundingClientRect().width, this.coords.w_rs && (this.coords.w_rs !== this.coords.w_rs_old && (this.target = "base", this.is_resize = !0), (this.coords.w_rs !== this.coords.w_rs_old || this.force_redraw) && (this.setMinMax(), this.calc(!0), this.drawLabels(), this.options.grid && (this.calcGridMargin(), this.calcGridLabels()), this.force_redraw = !0, this.coords.w_rs_old = this.coords.w_rs, this.drawShadow()), this.coords.w_rs && (!this.dragging && !this.force_redraw && !this.is_key || ((this.old_from !== this.result.from || this.old_to !== this.result.to || this.force_redraw || this.is_key) && (this.drawLabels(), this.$cache.bar.style.left = this.coords.p_bar_x + "%", this.$cache.bar.style.width = this.coords.p_bar_w + "%", this.options.type === "single" ? (this.$cache.bar.style.left = "0px", this.$cache.bar.style.width = this.coords.p_bar_w + this.coords.p_bar_x + "%", this.$cache.s_single.style.left = this.coords.p_single_fake + "%", this.$cache.single.style.left = this.labels.p_single_left + "%") : (this.$cache.s_from.style.left = this.coords.p_from_fake + "%", this.$cache.s_to.style.left = this.coords.p_to_fake + "%", (this.old_from !== this.result.from || this.force_redraw) && (this.$cache.from.style.left = this.labels.p_from_left + "%"), (this.old_to !== this.result.to || this.force_redraw) && (this.$cache.to.style.left = this.labels.p_to_left + "%"), this.$cache.single.style.left = this.labels.p_single_left + "%"), this.writeToInput(), (this.old_from !== this.result.from || this.old_to !== this.result.to) && !this.is_start && (this.$cache.input.dispatchEvent(new Event("change")), this.$cache.input.dispatchEvent(new Event("input"))), this.old_from = this.result.from, this.old_to = this.result.to, !this.is_resize && !this.is_update && !this.is_start && !this.is_finish && this.callOnChange(), (this.is_key || this.is_click) && (this.is_key = !1, this.is_click = !1, this.callOnFinish()), this.is_update = !1, this.is_resize = !1, this.is_finish = !1), this.is_start = !1, this.is_key = !1, this.is_click = !1, this.force_redraw = !1)));
  }
  /**
   * Draw labels
   * measure labels collisions
   * collapse close labels
   */
  drawLabels() {
    if (!this.options)
      return;
    const t = this.options.values.length, s = this.options.p_values;
    let n, r, i, o, l;
    if (!this.options.hide_from_to)
      if (this.options.type === "single")
        t ? (n = this.decorate(s[this.result.from]), this.$cache.single.innerHTML = n) : (o = this._prettify(this.result.from), n = this.decorate(o, this.result.from), this.$cache.single.innerHTML = n), this.calcLabels(), this.labels.p_single_left < this.labels.p_min + 1 ? this.$cache.min.style.visibility = "hidden" : this.$cache.min.style.visibility = "visible", this.labels.p_single_left + this.labels.p_single_fake > 100 - this.labels.p_max - 1 ? this.$cache.max.style.visibility = "hidden" : this.$cache.max.style.visibility = "visible";
      else {
        t ? (this.options.decorate_both ? (n = this.decorate(s[this.result.from]), n += this.options.values_separator, n += this.decorate(s[this.result.to])) : n = this.decorate(s[this.result.from] + this.options.values_separator + s[this.result.to]), r = this.decorate(s[this.result.from]), i = this.decorate(s[this.result.to]), this.$cache.single.innerHTML = n, this.$cache.from.innerHTML = r, this.$cache.to.innerHTML = i) : (o = this._prettify(this.result.from), l = this._prettify(this.result.to), this.options.decorate_both ? (n = this.decorate(o, this.result.from), n += this.options.values_separator, n += this.decorate(l, this.result.to)) : n = this.decorate(o + this.options.values_separator + l, this.result.to), r = this.decorate(o, this.result.from), i = this.decorate(l, this.result.to), this.$cache.single.innerHTML = n, this.$cache.from.innerHTML = r, this.$cache.to.innerHTML = i), this.calcLabels();
        const d = Math.min(this.labels.p_single_left, this.labels.p_from_left), c = this.labels.p_single_left + this.labels.p_single_fake, u = this.labels.p_to_left + this.labels.p_to_fake;
        let m = Math.max(c, u);
        this.labels.p_from_left + this.labels.p_from_fake >= this.labels.p_to_left ? (this.$cache.from.style.visibility = "hidden", this.$cache.to.style.visibility = "hidden", this.$cache.single.style.visibility = "visible", this.result.from === this.result.to ? (this.target === "from" ? this.$cache.from.style.visibility = "visible" : this.target === "to" ? this.$cache.to.style.visibility = "visible" : this.target || (this.$cache.from.style.visibility = "visible"), this.$cache.single.style.visibility = "hidden", m = u) : (this.$cache.from.style.visibility = "hidden", this.$cache.to.style.visibility = "hidden", this.$cache.single.style.visibility = "visible", m = Math.max(c, u))) : (this.$cache.from.style.visibility = "visible", this.$cache.to.style.visibility = "visible", this.$cache.single.style.visibility = "hidden"), d < this.labels.p_min + 1 ? this.$cache.min.style.visibility = "hidden" : this.$cache.min.style.visibility = "visible", m > 100 - this.labels.p_max - 1 ? this.$cache.max.style.visibility = "hidden" : this.$cache.max.style.visibility = "visible";
      }
  }
  /**
   * Draw shadow intervals
   */
  drawShadow() {
    const t = this.options, s = this.$cache, n = typeof t.from_min == "number" && !isNaN(t.from_min), r = typeof t.from_max == "number" && !isNaN(t.from_max), i = typeof t.to_min == "number" && !isNaN(t.to_min), o = typeof t.to_max == "number" && !isNaN(t.to_max);
    let l, d, c, u;
    t.type === "single" ? t.from_shadow && (n || r) ? (l = this.convertToPercent(n ? t.from_min : t.min), d = this.convertToPercent(r ? t.from_max : t.max) - l, l = this.toFixed(l - this.coords.p_handle / 100 * l), d = this.toFixed(d - this.coords.p_handle / 100 * d), l = l + this.coords.p_handle / 2, s.shad_single.style.display = "block", s.shad_single.style.left = l + "%", s.shad_single.style.width = d + "%") : s.shad_single.style.display = "none" : (t.from_shadow && (n || r) ? (l = this.convertToPercent(n ? t.from_min : t.min), d = this.convertToPercent(r ? t.from_max : t.max) - l, l = this.toFixed(l - this.coords.p_handle / 100 * l), d = this.toFixed(d - this.coords.p_handle / 100 * d), l = l + this.coords.p_handle / 2, s.shad_from.style.display = "block", s.shad_from.style.left = l + "%", s.shad_from.style.width = d + "%") : s.shad_from.style.display = "none", t.to_shadow && (i || o) ? (c = this.convertToPercent(i ? t.to_min : t.min), u = this.convertToPercent(o ? t.to_max : t.max) - c, c = this.toFixed(c - this.coords.p_handle / 100 * c), u = this.toFixed(u - this.coords.p_handle / 100 * u), c = c + this.coords.p_handle / 2, s.shad_to.style.display = "block", s.shad_to.style.left = c + "%", s.shad_to.style.width = u + "%") : s.shad_to.style.display = "none");
  }
  /**
   * Write values to input element
   */
  writeToInput() {
    this.options.type === "single" ? (this.options.values.length ? this.$cache.input.value = `${this.result.from_value}` : this.$cache.input.value = `${this.result.from}`, this.$cache.input.dataset.from = `${this.result.from}`) : (this.options.values.length ? this.$cache.input.value = this.result.from_value + this.options.input_values_separator + this.result.to_value : this.$cache.input.value = this.result.from + this.options.input_values_separator + this.result.to, this.$cache.input.dataset.from = `${this.result.from}`, this.$cache.input.dataset.to = `${this.result.to}`);
  }
  // =============================================================================================================
  // Callbacks
  callOnStart() {
    this.writeToInput(), this.options.onStart && typeof this.options.onStart == "function" && (this.options.scope ? this.options.onStart.call(this.options.scope, this.result) : this.options.onStart(this.result));
  }
  callOnChange() {
    this.writeToInput(), this.options.onChange && typeof this.options.onChange == "function" && (this.options.scope ? this.options.onChange.call(this.options.scope, this.result) : this.options.onChange(this.result));
  }
  callOnFinish() {
    this.writeToInput(), this.options.onFinish && typeof this.options.onFinish == "function" && (this.options.scope ? this.options.onFinish.call(this.options.scope, this.result) : this.options.onFinish(this.result));
  }
  callOnUpdate() {
    this.writeToInput(), this.options.onUpdate && typeof this.options.onUpdate == "function" && (this.options.scope ? this.options.onUpdate.call(this.options.scope, this.result) : this.options.onUpdate(this.result));
  }
  // =============================================================================================================
  // Service methods
  toggleInput() {
    var t;
    this.$cache.input.classList.toggle("irs-hidden-input"), this.has_tab_index ? this.$cache.input.tabIndex = -1 : (t = this.$cache.input) == null || t.removeAttribute("tabindex"), this.has_tab_index = !this.has_tab_index;
  }
  /**
   * Convert real value to percent
   *
   * @param value {Number} X in real
   * @param no_min {boolean=} don't use min value
   * @returns {Number} X in percent
   */
  convertToPercent(t, s) {
    const n = this.options.max - this.options.min, r = n / 100;
    let i;
    if (!n)
      return this.no_diapason = !0, 0;
    s ? i = t : i = t - this.options.min;
    const o = i / r;
    return this.toFixed(o);
  }
  /**
   * Convert percent to real values
   *
   * @param percent {Number} X in percent
   * @returns {Number} X in real
   */
  convertToValue(t) {
    let s = this.options.min, n = this.options.max, r, i, o = 0, l = 0;
    const d = s.toString().split(".")[1], c = n.toString().split(".")[1];
    if (t === 0)
      return this.options.min;
    if (t === 100)
      return this.options.max;
    d && (r = d.length, o = r), c && (i = c.length, o = i), r && i && (o = r >= i ? r : i), s < 0 && (l = Math.abs(s), s = +(s + l).toFixed(o), n = +(n + l).toFixed(o));
    let u = (n - s) / 100 * t + s, m;
    const f = this.options.step.toString().split(".")[1];
    return f ? u = +u.toFixed(f.length) : (u = u / this.options.step, u = u * this.options.step, u = +u.toFixed(0)), l && (u -= l), f ? m = +u.toFixed(f.length) : m = this.toFixed(u), m < this.options.min ? m = this.options.min : m > this.options.max && (m = this.options.max), m;
  }
  /**
   * Round percent value with step
   *
   * @param percent {Number}
   * @returns percent {Number} rounded
   */
  calcWithStep(t) {
    let s = Math.round(t / this.coords.p_step) * this.coords.p_step;
    return s > 100 && (s = 100), t === 100 && (s = 100), this.toFixed(s);
  }
  checkMinInterval(t, s, n) {
    const r = this.options;
    let i;
    if (!r.min_interval)
      return t;
    i = this.convertToValue(t);
    const o = this.convertToValue(s);
    return n === "from" ? o - i < r.min_interval && (i = o - r.min_interval) : i - o < r.min_interval && (i = o + r.min_interval), this.convertToPercent(i);
  }
  checkMaxInterval(t, s, n) {
    const r = this.options;
    let i;
    if (!r.max_interval)
      return t;
    i = this.convertToValue(t);
    const o = this.convertToValue(s);
    return n === "from" ? o - i > r.max_interval && (i = o - r.max_interval) : i - o > r.max_interval && (i = o + r.max_interval), this.convertToPercent(i);
  }
  checkDiapason(t, s, n) {
    let r = this.convertToValue(t);
    const i = this.options;
    return typeof s != "number" && (s = i.min), typeof n != "number" && (n = i.max), r < s && (r = s), r > n && (r = n), this.convertToPercent(r);
  }
  toFixed(t) {
    return +t.toFixed(20);
  }
  _prettify(t) {
    return this.options.prettify_enabled ? this.options.prettify && typeof this.options.prettify == "function" ? this.options.prettify(t) : this.prettify(t) : t;
  }
  prettify(t) {
    return t.toString().replace(/(\d{1,3}(?=(?:\d\d\d)+(?!\d)))/g, "$1" + this.options.prettify_separator);
  }
  checkEdges(t, s) {
    return this.options.force_edges ? (t < 0 ? t = 0 : t > 100 - s && (t = 100 - s), this.toFixed(t)) : this.toFixed(t);
  }
  validate() {
    const t = this.options, s = this.result, n = t.values;
    let r, i;
    if (typeof t.min == "string" && (t.min = +t.min), typeof t.max == "string" && (t.max = +t.max), typeof t.from == "string" && (t.from = +t.from), typeof t.to == "string" && (t.to = +t.to), typeof t.step == "string" && (t.step = +t.step), typeof t.from_min == "string" && (t.from_min = +t.from_min), typeof t.from_max == "string" && (t.from_max = +t.from_max), typeof t.to_min == "string" && (t.to_min = +t.to_min), typeof t.to_max == "string" && (t.to_max = +t.to_max), typeof t.grid_num == "string" && (t.grid_num = +t.grid_num), t.max < t.min && (t.max = t.min), n.length)
      for (t.p_values = [], t.min = 0, t.max = n.length - 1, t.step = 1, t.grid_num = t.max, t.grid_snap = !0, i = 0; i < n.length; i++)
        r = +n[i], isNaN(r) ? r = n[i] : (n[i] = r, r = parseFloat(`${r}`)), t.p_values.push(r);
    (typeof t.from != "number" || isNaN(t.from)) && (t.from = t.min), (typeof t.to != "number" || isNaN(t.to)) && (t.to = t.max), t.type === "single" ? (t.from < t.min && (t.from = t.min), t.from > t.max && (t.from = t.max)) : (t.from < t.min && (t.from = t.min), t.from > t.max && (t.from = t.max), t.to < t.min && (t.to = t.min), t.to > t.max && (t.to = t.max), this.update_check.from && (this.update_check.from !== t.from && t.from > t.to && (t.from = t.to), this.update_check.to !== t.to && t.to < t.from && (t.to = t.from)), t.from > t.to && (t.from = t.to), t.to < t.from && (t.to = t.from)), (typeof t.step != "number" || isNaN(t.step) || !t.step || t.step < 0) && (t.step = 1), typeof t.from_min == "number" && t.from < t.from_min && (t.from = t.from_min), typeof t.from_max == "number" && t.from > t.from_max && (t.from = t.from_max), typeof t.to_min == "number" && t.to < t.to_min && (t.to = t.to_min), typeof t.to_max == "number" && t.from > t.to_max && (t.to = t.to_max), s && (s.min !== t.min && (s.min = t.min), s.max !== t.max && (s.max = t.max), (s.from < s.min || s.from > s.max) && (s.from = t.from), (s.to < s.min || s.to > s.max) && (s.to = t.to)), (typeof t.min_interval != "number" || isNaN(t.min_interval) || !t.min_interval || t.min_interval < 0) && (t.min_interval = 0), (typeof t.max_interval != "number" || isNaN(t.max_interval) || !t.max_interval || t.max_interval < 0) && (t.max_interval = 0), t.min_interval && t.min_interval > t.max - t.min && (t.min_interval = t.max - t.min), t.max_interval && t.max_interval > t.max - t.min && (t.max_interval = t.max - t.min);
  }
  decorate(t, s) {
    let n = "";
    const r = this.options;
    return r.prefix && (n += r.prefix), n += t, r.max_postfix && (r.values.length && t === r.p_values[r.max] || s === r.max) && (n += r.max_postfix, r.postfix && (n += " ")), r.postfix && (n += r.postfix), n;
  }
  updateFrom() {
    this.result.from = this.options.from, this.result.from_percent = this.convertToPercent(this.result.from), this.result.from_pretty = this._prettify(this.result.from), this.options.values && (this.result.from_value = this.options.values[this.result.from]);
  }
  updateTo() {
    this.result.to = this.options.to, this.result.to_percent = this.convertToPercent(this.result.to), this.result.to_pretty = this._prettify(this.result.to), this.options.values && (this.result.to_value = this.options.values[this.result.to]);
  }
  updateResult() {
    this.result.min = this.options.min, this.result.max = this.options.max, this.updateFrom(), this.updateTo();
  }
  // =============================================================================================================
  // Grid
  appendGrid() {
    if (!this.options.grid)
      return;
    const t = this.options, s = t.max - t.min;
    let n, r, i = t.grid_num, o = 0, l = 0, d = 4, c, u, m = 0, f, v = "";
    for (this.calcGridMargin(), t.grid_snap && (i = s / t.step), i > 50 && (i = 50), o = this.toFixed(100 / i), i > 4 && (d = 3), i > 7 && (d = 2), i > 14 && (d = 1), i > 28 && (d = 0), n = 0; n < i + 1; n++) {
      for (c = d, l = this.toFixed(o * n), l > 100 && (l = 100), this.coords.big[n] = l, u = (l - o * (n - 1)) / (c + 1), r = 1; r <= c && l !== 0; r++)
        m = this.toFixed(l - u * r), v += '<span class="irs-grid-pol small" style="left: ' + m + '%"></span>';
      v += '<span class="irs-grid-pol" style="left: ' + l + '%"></span>', f = this.convertToValue(l), t.values.length ? f = t.p_values[f] : f = this._prettify(f), v += '<span class="irs-grid-text js-grid-text-' + n + '" style="left: ' + l + '%">' + f + "</span>";
    }
    this.coords.big_num = Math.ceil(i + 1), this.$cache.cont.classList.add("irs-with-grid"), this.$cache.grid.innerHTML = v, this.cacheGridLabels();
  }
  cacheGridLabels() {
    let t, s;
    const n = this.coords.big_num;
    for (s = 0; s < n; s++)
      t = this.$cache.grid.querySelector(".js-grid-text-" + s), this.$cache.grid_labels.push(t);
    this.calcGridLabels();
  }
  calcGridLabels() {
    let t, s;
    const n = [], r = [], i = this.coords.big_num;
    for (t = 0; t < i; t++)
      this.coords.big_w[t] = this.$cache.grid_labels[t].getBoundingClientRect().width, this.coords.big_p[t] = this.toFixed(this.coords.big_w[t] / this.coords.w_rs * 100), this.coords.big_x[t] = this.toFixed(this.coords.big_p[t] / 2), n[t] = this.toFixed(this.coords.big[t] - this.coords.big_x[t]), r[t] = this.toFixed(n[t] + this.coords.big_p[t]);
    for (this.options.force_edges && (n[0] < -this.coords.grid_gap && (n[0] = -this.coords.grid_gap, r[0] = this.toFixed(n[0] + this.coords.big_p[0]), this.coords.big_x[0] = this.coords.grid_gap), r[i - 1] > 100 + this.coords.grid_gap && (r[i - 1] = 100 + this.coords.grid_gap, n[i - 1] = this.toFixed(r[i - 1] - this.coords.big_p[i - 1]), this.coords.big_x[i - 1] = this.toFixed(this.coords.big_p[i - 1] - this.coords.grid_gap))), this.calcGridCollision(2, n, r), this.calcGridCollision(4, n, r), t = 0; t < i; t++)
      s = this.$cache.grid_labels[t], this.coords.big_x[t] !== Number.POSITIVE_INFINITY && (s.style.marginLeft = -this.coords.big_x[t] + "%");
  }
  // Collisions Calc Beta
  // TODO: Refactor then have plenty of time
  calcGridCollision(t, s, n) {
    let r, i, o;
    const l = this.coords.big_num;
    for (r = 0; r < l && (i = r + t / 2, !(i >= l)); r += t)
      o = this.$cache.grid_labels[i], n[r] <= s[i] ? o.style.visibility = "visible" : o.style.visibility = "hidden";
  }
  calcGridMargin() {
    this.options.grid_margin && (this.coords.w_rs = this.$cache.rs.getBoundingClientRect().width, this.coords.w_rs && (this.options.type === "single" ? this.coords.w_handle = this.$cache.s_single.getBoundingClientRect().width : this.coords.w_handle = this.$cache.s_from.getBoundingClientRect().width, this.coords.p_handle = this.toFixed(this.coords.w_handle / this.coords.w_rs * 100), this.coords.grid_gap = this.toFixed(this.coords.p_handle / 2 - 0.1), this.$cache.grid.style.width = this.toFixed(100 - this.coords.p_handle) + "%", this.$cache.grid.style.left = this.coords.grid_gap + "%"));
  }
  // =============================================================================================================
  // Public methods
  update(t) {
    this.input && (this.is_update = !0, this.options.from = this.result.from, this.options.to = this.result.to, this.update_check.from = this.result.from, this.update_check.to = this.result.to, this.options = Object.assign(this.options, t), this.validate(), this.updateResult(), this.toggleInput(), this.remove(), this.init(!0));
  }
  reset() {
    this.input && (this.updateResult(), this.update());
  }
  destroy() {
    this.input && (this.toggleInput(), this.$cache.input.readOnly = !1, this.input.ionRangeSlider = void 0, this.remove(), this.input = void 0, delete this.options);
  }
}
(function() {
  let e = 0;
  const t = ["ms", "moz", "webkit", "o"];
  for (let s = 0; s < t.length && !window.requestAnimationFrame; ++s) {
    const n = t[s] + "RequestAnimationFrame", r = t[s] + "CancelAnimationFrame", i = t[s] + "CancelRequestAnimationFrame";
    window.requestAnimationFrame = window[n], r in window ? window.cancelAnimationFrame = window[r] : i in window && (window.cancelAnimationFrame = window[i]);
  }
  window.requestAnimationFrame || (window.requestAnimationFrame = function(s) {
    const n = (/* @__PURE__ */ new Date()).getTime(), r = Math.max(0, 16 - (n - e)), i = window.setTimeout(function() {
      s(n + r);
    }, r);
    return e = n + r, i;
  }), window.cancelAnimationFrame || (window.cancelAnimationFrame = function(s) {
    clearTimeout(s);
  });
})();
function vS() {
  const e = navigator.userAgent, t = /msie\s\d+/i;
  let s;
  return e.search(t) > 0 && (s = t.exec(e).toString(), s = s.split(" ")[1], parseInt(s) < 9) ? (document.documentElement.classList.add("lt-ie9"), !0) : !1;
}
function qn(e) {
  if (e)
    return parseFloat(e);
}
function sn(e) {
  if (e)
    return /(true|1)/i.test(e) == !0;
}
function yS(e) {
  const t = e.getBoundingClientRect();
  return {
    top: t.top + window.scrollY,
    left: t.left + window.scrollX
  };
}
const Xc = {
  double: "double",
  single: "single"
}, rMt = me({
  name: "RangeSlider",
  props: {
    modelValue: {
      type: Object
      // JC 03/2025 Remove | any
    },
    type: {
      type: String,
      default: Xc.single
    },
    grid: {
      type: Boolean,
      default: !1
    },
    prettify: {
      type: Boolean,
      default: !1
    },
    percent: {
      type: Boolean,
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    prettifySeparator: {
      type: String
    },
    hideMinMax: {
      type: Boolean
    },
    hideFromTo: {
      type: Boolean
    },
    maxPostfix: {
      type: String
    },
    prefix: {
      type: String
    },
    skin: {
      type: String
    },
    step: {
      type: Number
    },
    min: {
      type: Number
    },
    max: {
      type: Number
    },
    from: {
      type: Number
    },
    to: {
      type: Number
    }
  },
  emits: [
    "update:modelValue",
    "update:from",
    "update:to",
    "change",
    "finish",
    "hitMin",
    "hitMax",
    "initialize"
  ],
  data() {
    return {
      lFrom: void 0,
      lTo: void 0,
      changing: !1,
      tMin: void 0,
      tMax: void 0,
      initialized: !1
    };
  },
  watch: {
    to(e) {
      var t;
      console.log(`${this.$options.name}.watch.to`, e), this.lTo != e && (this.lTo = e, (t = this.slider) == null || t.update({
        to: this.lTo
      }));
    },
    from(e) {
      var t;
      console.log(`${this.$options.name}.watch.from`, e), this.lFrom != e && (this.lFrom = e, (t = this.slider) == null || t.update({
        from: this.lFrom
      }));
    },
    modelValue(e) {
      var t, s;
      if (console.log(`${this.$options.name}.watch.model`, e), e > 0 && this.initialize(e), this.type == Xc.double) {
        const n = e;
        let r = !1;
        this.lFrom != n[0] && (this.lFrom = n[0], r = !0), this.lTo != n[1] && (this.lTo = n[1], r = !0), r && ((t = this.slider) == null || t.update({
          from: this.lFrom,
          to: this.lTo
        }));
      } else this.lFrom != e && (this.lFrom = e, (s = this.slider) == null || s.update({
        from: this.lFrom
      }));
      this.checkMinMaxHit();
    },
    min(e) {
      var t;
      console.log(`${this.$options.name}.watch.min`, e), this.changing == !0 ? this.tMin = e : (t = this.slider) == null || t.update({
        min: e
      });
    },
    max(e) {
      var t;
      console.log(`${this.$options.name}.watch.max`, e), this.changing == !0 ? this.tMax = e : (t = this.slider) == null || t.update({
        max: e
      });
    },
    disabled(e) {
      var t;
      console.log(`${this.$options.name}.watch.disabled`, e), (t = this.slider) == null || t.update({
        disable: e
      });
    }
  },
  methods: {
    sliderChanged(e) {
      if (this.changing = !0, console.log(`${this.$options.name}.sliderChanged`, e), this.type == Xc.double) {
        let t = !1;
        this.lFrom != e.from && (this.lFrom = e.from, this.$emit("update:from", this.lFrom), t = !0), this.lTo != e.to && (this.lTo = e.to, this.$emit("update:to", this.lTo), t = !0), t && (this.$emit("update:modelValue", [this.lFrom, this.lTo]), this.$emit("change", this.lFrom, this.lTo));
      } else
        this.lFrom != e.from && (this.lFrom = e.from, this.$emit("update:modelValue", this.lFrom), this.$emit("change", this.lFrom));
    },
    sliderFinished(e) {
      this.changing = !1, console.log(`${this.$options.name}.sliderFinished`, e), this.slider && (this.tMin || this.tMax) && (this.tMin && this.tMax ? this.slider.update({
        min: this.tMin,
        max: this.tMax
      }) : this.tMin ? this.slider.update({
        min: this.tMin
      }) : this.tMax && this.slider.update({
        max: this.tMax
      }), this.tMin = void 0, this.tMax = void 0), this.checkMinMaxHit(e), this.$emit("finish");
    },
    checkMinMaxHit(e) {
      var t, s;
      console.log(`${this.$options.name}.checkMinMaxHit`, (t = this.slider) == null ? void 0 : t.result), e ?? (e = (s = this.slider) == null ? void 0 : s.result), this.type == Xc.double ? (this.lFrom && this.lFrom <= e.min && this.$emit("hitMin", this.lFrom), this.lTo && this.lTo >= e.max && this.$emit("hitMax", this.lTo)) : (this.lFrom && this.lFrom <= e.min && this.$emit("hitMin", this.lFrom), this.lFrom && this.lFrom >= e.max && this.$emit("hitMax", this.lFrom));
    },
    formatPercent(e) {
      return Wt(e);
    },
    initialize(e) {
      console.log(`${this.$options.name}.initialize`, this.initialized, this.modelValue, e), this.initialized || (this.$emit("initialize", this.modelValue), this.initialized = !0);
    }
  },
  created() {
    console.log(`${this.$options.name}.created`), bS(this.modelValue, this.type) ? this.modelValue && !this.from && !this.to ? (this.lFrom = this.modelValue[0], this.lTo = this.modelValue[1]) : (this.lFrom = this.from, this.lTo = this.to, this.$emit("update:modelValue", [this.lFrom, this.lTo])) : this.lFrom = this.modelValue;
  },
  mounted() {
    console.log(`${this.$options.name}.mounted`), this.slider = Zb.getOrCreateInstance(this.$refs.slider, {
      prettify: this.prettify && this.percent ? this.formatPercent : void 0,
      onChange: this.sliderChanged,
      onFinish: this.sliderFinished
    }), this.modelValue && !bS(this.modelValue, this.type) && this.modelValue > 0 && this.initialize();
  },
  beforeUnmount() {
    this.slider && this.slider.destroy();
  }
});
function bS(e, t) {
  return t == Xc.double;
}
const oMt = ["data-type", "data-grid", "data-step", "data-min", "data-max", "data-from", "data-to", "data-max-postfix", "data-hide-min-max", "data-hide-from-to", "data-block", "data-prettify-enabled", "data-prettify-separator", "data-prefix", "data-skin"];
function iMt(e, t, s, n, r, i) {
  return p(), h("input", {
    type: "text",
    class: "range",
    ref: "slider",
    "data-type": e.type,
    "data-grid": e.grid,
    "data-step": e.step,
    "data-min": e.min,
    "data-max": e.max,
    "data-from": e.lFrom,
    "data-to": e.lTo,
    "data-max-postfix": e.maxPostfix,
    "data-hide-min-max": e.hideMinMax,
    "data-hide-from-to": e.hideFromTo,
    "data-block": e.disabled,
    "data-prettify-enabled": e.prettify,
    "data-prettify-separator": e.prettifySeparator,
    "data-prefix": e.prefix,
    "data-skin": e.skin
  }, null, 8, oMt);
}
const lMt = /* @__PURE__ */ Ae(rMt, [["render", iMt]]), dMt = me({
  name: "Features",
  props: {
    modelValue: {
      type: Object,
      required: !0
    }
  },
  components: {
    RangeSlider: lMt
  },
  emits: [
    "update:modelValue"
  ],
  data() {
    return {
      defaults: {
        minprice: 75e3,
        maxprice: 35e4,
        minsqft: 1e3,
        maxsqft: 4e3,
        minyearbuilt: 2015,
        maxyearbuilt: 2021,
        minbedrooms: 2,
        maxbedrooms: 5,
        minbathrooms: 2,
        maxbathrooms: 4,
        minGarage: 2,
        maxGarage: 5,
        minStories: 1,
        maxStories: 2,
        minFireplaces: 0,
        maxFireplaces: 2,
        minLotSize: 0,
        maxLotSize: 5e4,
        minPriceSqFt: 0,
        maxPriceSqFt: 100,
        pool: 0,
        elementaryRating: 4,
        intermediateRating: 4,
        jrHighRating: 4,
        highSchoolRating: 4
      },
      customPriceRange: !1
    };
  },
  watch: {
    modelValue(e) {
      this.defaults = e;
    },
    defaults: {
      handler() {
        this.$emit("update:modelValue", this.defaults);
      },
      deep: !0
    }
  },
  computed: {
    listPrice: {
      get() {
        return [this.defaults.minprice, this.defaults.maxprice];
      },
      set(e) {
        console.log("listPrice", e);
      }
    },
    sqFt: {
      get() {
        return [this.defaults.minsqft, this.defaults.maxsqft];
      },
      set(e) {
        console.log("sqFt", e);
      }
    },
    yearBuilt: {
      get() {
        return [this.defaults.minyearbuilt, this.defaults.maxyearbuilt];
      },
      set(e) {
        console.log("yearBuilt", e);
      }
    },
    bedrooms: {
      get() {
        return [this.defaults.minbedrooms, this.defaults.maxbedrooms];
      },
      set(e) {
        console.log("bedrooms", e);
      }
    },
    bathrooms: {
      get() {
        return [this.defaults.minbathrooms, this.defaults.maxbathrooms];
      },
      set(e) {
        console.log("bathrooms", e);
      }
    },
    Garage: {
      get() {
        return [this.defaults.minGarage, this.defaults.maxGarage];
      },
      set(e) {
        console.log("Garage", e);
      }
    },
    Stories: {
      get() {
        return [this.defaults.minStories, this.defaults.maxStories];
      },
      set(e) {
        console.log("Stories", e);
      }
    },
    Fireplaces: {
      get() {
        return [this.defaults.minFireplaces, this.defaults.maxFireplaces];
      },
      set(e) {
        console.log("Fireplaces", e);
      }
    },
    LotSize: {
      get() {
        return [this.defaults.minLotSize, this.defaults.maxLotSize];
      },
      set(e) {
        console.log("LotSize", e);
      }
    },
    PriceSqFt: {
      get() {
        return [this.defaults.minPriceSqFt, this.defaults.maxPriceSqFt];
      },
      set(e) {
        console.log("PriceSqFt", e);
      }
    },
    minPrice: {
      get() {
        return Ve(this.defaults.minprice);
      },
      set(e) {
        this.defaults.minprice = vs(e);
      }
    },
    maxPrice: {
      get() {
        return Ve(this.defaults.maxprice);
      },
      set(e) {
        this.defaults.maxprice = vs(e);
      }
    }
  },
  methods: {
    number: Ve,
    showCustomPriceRange(e) {
      this.customPriceRange = e;
    }
  },
  created() {
    this.defaults = this.modelValue;
  },
  mounted() {
  }
}), cMt = { class: "row mb-3" }, uMt = { class: "col-md-6 mb-3 mb-xl-0" }, pMt = { class: "card shadow-sm" }, hMt = { class: "card-body" }, mMt = { class: "mb-3" }, fMt = { class: "mb-3" }, gMt = { class: "mb-3" }, vMt = { class: "mb-3" }, yMt = { class: "mb-3" }, bMt = { class: "mb-3" }, AMt = { class: "mb-3" }, wMt = { class: "mb-3" }, CMt = { class: "col-md-6 mb-3 mb-xl-0" }, SMt = { class: "card shadow-sm" }, PMt = { class: "card-body" }, kMt = { class: "mb-3" }, EMt = { class: "mb-3" }, IMt = { class: "mb-3" }, TMt = { class: "mb-3" };
function OMt(e, t, s, n, r, i) {
  const o = pe("range-slider");
  return p(), h("div", cMt, [
    P("", !0),
    a("div", uMt, [
      a("div", pMt, [
        t[56] || (t[56] = a("div", { class: "card-header bg-white fw-bold pb-0 border-0" }, " Features ", -1)),
        a("div", hMt, [
          a("div", mMt, [
            t[47] || (t[47] = a("label", { class: "form-label" }, " Bedroom Range: ", -1)),
            N(o, {
              type: "double",
              min: 0,
              max: 6,
              modelValue: e.bedrooms,
              "onUpdate:modelValue": t[13] || (t[13] = (l) => e.bedrooms = l),
              from: e.defaults.minbedrooms,
              "onUpdate:from": t[14] || (t[14] = (l) => e.defaults.minbedrooms = l),
              to: e.defaults.maxbedrooms,
              "onUpdate:to": t[15] || (t[15] = (l) => e.defaults.maxbedrooms = l),
              prettify: !0,
              "prettify-separator": "",
              "max-postfix": "+",
              skin: "round"
            }, null, 8, ["modelValue", "from", "to"])
          ]),
          a("div", fMt, [
            t[48] || (t[48] = a("label", { class: "form-label" }, " Bathroom Range: ", -1)),
            N(o, {
              type: "double",
              min: 0,
              max: 5,
              modelValue: e.bathrooms,
              "onUpdate:modelValue": t[16] || (t[16] = (l) => e.bathrooms = l),
              from: e.defaults.minbathrooms,
              "onUpdate:from": t[17] || (t[17] = (l) => e.defaults.minbathrooms = l),
              to: e.defaults.maxbathrooms,
              "onUpdate:to": t[18] || (t[18] = (l) => e.defaults.maxbathrooms = l),
              prettify: !0,
              "prettify-separator": "",
              "max-postfix": "+",
              skin: "round"
            }, null, 8, ["modelValue", "from", "to"])
          ]),
          a("div", gMt, [
            t[49] || (t[49] = a("label", { class: "form-label" }, " Garage Range: ", -1)),
            N(o, {
              type: "double",
              min: 0,
              max: 10,
              modelValue: e.Garage,
              "onUpdate:modelValue": t[19] || (t[19] = (l) => e.Garage = l),
              from: e.defaults.minGarage,
              "onUpdate:from": t[20] || (t[20] = (l) => e.defaults.minGarage = l),
              to: e.defaults.maxGarage,
              "onUpdate:to": t[21] || (t[21] = (l) => e.defaults.maxGarage = l),
              prettify: !0,
              "prettify-separator": "",
              "max-postfix": "+",
              skin: "round"
            }, null, 8, ["modelValue", "from", "to"])
          ]),
          a("div", vMt, [
            t[50] || (t[50] = a("label", { class: "form-label" }, " Stories Range: ", -1)),
            N(o, {
              type: "double",
              min: 0,
              max: 10,
              modelValue: e.Stories,
              "onUpdate:modelValue": t[22] || (t[22] = (l) => e.Stories = l),
              from: e.defaults.minStories,
              "onUpdate:from": t[23] || (t[23] = (l) => e.defaults.minStories = l),
              to: e.defaults.maxStories,
              "onUpdate:to": t[24] || (t[24] = (l) => e.defaults.maxStories = l),
              prettify: !0,
              "prettify-separator": "",
              "max-postfix": "+",
              skin: "round"
            }, null, 8, ["modelValue", "from", "to"])
          ]),
          a("div", yMt, [
            t[51] || (t[51] = a("label", { class: "form-label" }, " Fireplaces Range: ", -1)),
            N(o, {
              type: "double",
              min: 0,
              max: 5,
              modelValue: e.Fireplaces,
              "onUpdate:modelValue": t[25] || (t[25] = (l) => e.Fireplaces = l),
              from: e.defaults.minFireplaces,
              "onUpdate:from": t[26] || (t[26] = (l) => e.defaults.minFireplaces = l),
              to: e.defaults.maxFireplaces,
              "onUpdate:to": t[27] || (t[27] = (l) => e.defaults.maxFireplaces = l),
              prettify: !0,
              "prettify-separator": "",
              "max-postfix": "+",
              skin: "round"
            }, null, 8, ["modelValue", "from", "to"])
          ]),
          a("div", bMt, [
            t[52] || (t[52] = a("label", { class: "form-label" }, " Lot Size Range: ", -1)),
            N(o, {
              type: "double",
              min: 0,
              max: 5e4,
              step: 1e3,
              modelValue: e.LotSize,
              "onUpdate:modelValue": t[28] || (t[28] = (l) => e.LotSize = l),
              from: e.defaults.minLotSize,
              "onUpdate:from": t[29] || (t[29] = (l) => e.defaults.minLotSize = l),
              to: e.defaults.maxLotSize,
              "onUpdate:to": t[30] || (t[30] = (l) => e.defaults.maxLotSize = l),
              prettify: !0,
              "prettify-separator": ",",
              "max-postfix": "+",
              skin: "round"
            }, null, 8, ["modelValue", "from", "to"])
          ]),
          a("div", AMt, [
            t[53] || (t[53] = a("label", { class: "form-label" }, " Price/Sq Ft Range: ", -1)),
            N(o, {
              type: "double",
              min: 0,
              max: 300,
              step: 10,
              modelValue: e.PriceSqFt,
              "onUpdate:modelValue": t[31] || (t[31] = (l) => e.PriceSqFt = l),
              from: e.defaults.minPriceSqFt,
              "onUpdate:from": t[32] || (t[32] = (l) => e.defaults.minPriceSqFt = l),
              to: e.defaults.maxPriceSqFt,
              "onUpdate:to": t[33] || (t[33] = (l) => e.defaults.maxPriceSqFt = l),
              prettify: !0,
              "prettify-separator": ",",
              "max-postfix": "+",
              skin: "round"
            }, null, 8, ["modelValue", "from", "to"])
          ]),
          a("div", wMt, [
            t[55] || (t[55] = a("label", { class: "form-label" }, " Pool: ", -1)),
            V(a("select", {
              id: "prefPool",
              "onUpdate:modelValue": t[34] || (t[34] = (l) => e.defaults.pool = l),
              name: "pool",
              class: "form-select"
            }, t[54] || (t[54] = [
              a("option", { value: 0 }, "No Preference", -1),
              a("option", { value: 1 }, "Yes", -1),
              a("option", { value: 2 }, "No", -1)
            ]), 512), [
              [We, e.defaults.pool]
            ])
          ])
        ])
      ])
    ]),
    a("div", CMt, [
      a("div", SMt, [
        t[61] || (t[61] = a("div", { class: "card-header bg-white fw-bold pb-0 border-0" }, " Minimum School Ratings ", -1)),
        a("div", PMt, [
          a("div", kMt, [
            t[57] || (t[57] = a("label", { class: "form-label" }, "Elementary Min. Rating:", -1)),
            N(o, {
              type: "single",
              grid: !0,
              min: 1,
              max: 10,
              modelValue: e.defaults.elementaryRating,
              "onUpdate:modelValue": t[35] || (t[35] = (l) => e.defaults.elementaryRating = l),
              prettify: !1,
              skin: "round"
            }, null, 8, ["modelValue"])
          ]),
          a("div", EMt, [
            t[58] || (t[58] = a("label", { class: "form-label" }, "Intermediate Min. Rating:", -1)),
            N(o, {
              type: "single",
              grid: !0,
              min: 1,
              max: 10,
              modelValue: e.defaults.intermediateRating,
              "onUpdate:modelValue": t[36] || (t[36] = (l) => e.defaults.intermediateRating = l),
              prettify: !1,
              skin: "round"
            }, null, 8, ["modelValue"])
          ]),
          a("div", IMt, [
            t[59] || (t[59] = a("label", { class: "form-label" }, " Jr High Min. Rating: ", -1)),
            N(o, {
              type: "single",
              grid: !0,
              min: 1,
              max: 10,
              modelValue: e.defaults.jrHighRating,
              "onUpdate:modelValue": t[37] || (t[37] = (l) => e.defaults.jrHighRating = l),
              prettify: !1,
              skin: "round"
            }, null, 8, ["modelValue"])
          ]),
          a("div", TMt, [
            t[60] || (t[60] = a("label", { class: "form-label" }, "High School Min. Rating:", -1)),
            N(o, {
              type: "single",
              grid: !0,
              min: 1,
              max: 10,
              modelValue: e.defaults.highSchoolRating,
              "onUpdate:modelValue": t[38] || (t[38] = (l) => e.defaults.highSchoolRating = l),
              prettify: !1,
              skin: "round"
            }, null, 8, ["modelValue"])
          ])
        ])
      ])
    ])
  ]);
}
const LE = /* @__PURE__ */ Ae(dMt, [["render", OMt]]), RMt = me({
  name: "Performance",
  props: {
    modelValue: {
      type: Object,
      required: !0
    }
  },
  components: {},
  emits: [
    "update:modelValue"
  ],
  data() {
    return {
      defaults: {
        minprice: 75e3,
        maxprice: 35e4,
        minsqft: 1e3,
        maxsqft: 4e3,
        minyearbuilt: 2015,
        maxyearbuilt: 2021,
        minbedrooms: 2,
        maxbedrooms: 5,
        minbathrooms: 2,
        maxbathrooms: 4,
        minGarage: 2,
        maxGarage: 5,
        minStories: 1,
        maxStories: 2,
        minFireplaces: 0,
        maxFireplaces: 2,
        minLotSize: 0,
        maxLotSize: 5e4,
        minPriceSqFt: 0,
        maxPriceSqFt: 100,
        pool: 0,
        elementaryRating: 4,
        intermediateRating: 4,
        jrHighRating: 4,
        highSchoolRating: 4
      }
    };
  },
  watch: {
    modelValue(e) {
      this.defaults = e;
    },
    defaults: {
      handler() {
        this.$emit("update:modelValue", this.defaults);
      },
      deep: !0
    }
  },
  computed: {
    mincaprate: {
      get() {
        return Ve(this.defaults.mincaprate * 100, 2);
      },
      set(e) {
        this.defaults.mincaprate = vs(e) / 100;
      }
    },
    mincoc: {
      get() {
        return Ve(this.defaults.mincoc * 100, 2);
      },
      set(e) {
        this.defaults.mincoc = vs(e) / 100;
      }
    },
    minirr: {
      get() {
        return Ve(this.defaults.minirr * 100, 2);
      },
      set(e) {
        this.defaults.minirr = vs(e) / 100;
      }
    }
  },
  methods: {},
  created() {
    this.defaults = this.modelValue;
  },
  mounted() {
  }
}), LMt = { class: "row mb-4" }, BMt = { class: "col" }, MMt = { class: "card shadow-sm" }, xMt = { class: "card-body" }, FMt = { class: "row" }, VMt = { class: "col-md-4 mb-md-0 mb-3" }, DMt = { class: "input-group" }, NMt = { class: "col-md-4 mb-md-0 mb-3" }, jMt = { class: "input-group" }, HMt = { class: "col-md-4 mb-md-0 mb-3" }, UMt = { class: "input-group" };
function zMt(e, t, s, n, r, i) {
  return p(), h(A, null, [
    t[9] || (t[9] = a("div", { class: "row" }, [
      a("div", { class: "col" }, [
        a("h2", { class: "fw-bold fs-5" }, "Blue Chip House Performance Requirements")
      ])
    ], -1)),
    a("div", LMt, [
      a("div", BMt, [
        a("div", MMt, [
          a("div", xMt, [
            a("div", FMt, [
              a("div", VMt, [
                t[4] || (t[4] = a("label", {
                  for: "mincaprate",
                  class: "form-label"
                }, " Min. Cap Rate ", -1)),
                a("div", DMt, [
                  V(a("input", {
                    type: "text",
                    "onUpdate:modelValue": t[0] || (t[0] = (o) => e.mincaprate = o),
                    class: "form-control"
                  }, null, 512), [
                    [_e, e.mincaprate]
                  ]),
                  t[3] || (t[3] = a("span", { class: "input-group-text" }, "%", -1))
                ])
              ]),
              a("div", NMt, [
                t[6] || (t[6] = a("label", {
                  for: "mincoc",
                  class: "form-label"
                }, " Min. Year 1 Normalized CoC: ", -1)),
                a("div", jMt, [
                  V(a("input", {
                    type: "text",
                    "onUpdate:modelValue": t[1] || (t[1] = (o) => e.mincoc = o),
                    class: "form-control"
                  }, null, 512), [
                    [_e, e.mincoc]
                  ]),
                  t[5] || (t[5] = a("span", { class: "input-group-text" }, "%", -1))
                ])
              ]),
              a("div", HMt, [
                t[8] || (t[8] = a("label", {
                  for: "minirr",
                  class: "form-label"
                }, " Min. IRR %: ", -1)),
                a("div", UMt, [
                  V(a("input", {
                    type: "text",
                    "onUpdate:modelValue": t[2] || (t[2] = (o) => e.minirr = o),
                    class: "form-control"
                  }, null, 512), [
                    [_e, e.minirr]
                  ]),
                  t[7] || (t[7] = a("span", { class: "input-group-text" }, "%", -1))
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ], 64);
}
const BE = /* @__PURE__ */ Ae(RMt, [["render", zMt]]);
var WMt = "2.0.4", Yy = 500, AS = "user-agent", jd = "", wS = "?", Rm = "function", ui = "undefined", Hd = "object", Xy = "string", wn = "browser", Ao = "cpu", Br = "device", hr = "engine", sr = "os", ud = "result", pt = "name", tt = "type", ut = "vendor", ft = "version", Cn = "architecture", Ru = "major", rt = "model", qc = "console", ns = "mobile", qs = "tablet", Fa = "smarttv", Er = "wearable", Gp = "xr", Qc = "embedded", Oc = "inapp", Jb = "brands", zi = "formFactors", $b = "fullVersionList", pd = "platform", _b = "platformVersion", Ef = "bitness", xi = "sec-ch-ua", GMt = xi + "-full-version-list", YMt = xi + "-arch", XMt = xi + "-" + Ef, qMt = xi + "-form-factors", QMt = xi + "-" + ns, KMt = xi + "-" + rt, ME = xi + "-" + pd, ZMt = ME + "-version", xE = [Jb, $b, ns, rt, pd, _b, Cn, zi, Ef], Yp = "Amazon", Vl = "Apple", CS = "ASUS", SS = "BlackBerry", Ni = "Google", PS = "Huawei", Gg = "Lenovo", kS = "Honor", Xp = "LG", Yg = "Microsoft", Xg = "Motorola", qg = "Nvidia", ES = "OnePlus", Qg = "OPPO", Rc = "Samsung", IS = "Sharp", Lc = "Sony", Kg = "Xiaomi", Zg = "Zebra", TS = "Chrome", OS = "Chromium", Ko = "Chromecast", Uh = "Edge", Bc = "Firefox", Mc = "Opera", Jg = "Facebook", RS = "Sogou", Dl = "Mobile ", xc = " Browser", qy = "Windows", JMt = typeof window !== ui, Sn = JMt && window.navigator ? window.navigator : void 0, ii = Sn && Sn.userAgentData ? Sn.userAgentData : void 0, $Mt = function(e, t) {
  var s = {}, n = t;
  if (!Lm(t)) {
    n = {};
    for (var r in t)
      for (var i in t[r])
        n[i] = t[r][i].concat(n[i] ? n[i] : []);
  }
  for (var o in e)
    s[o] = n[o] && n[o].length % 2 === 0 ? n[o].concat(e[o]) : e[o];
  return s;
}, If = function(e) {
  for (var t = {}, s = 0; s < e.length; s++)
    t[e[s].toUpperCase()] = e[s];
  return t;
}, Qy = function(e, t) {
  if (typeof e === Hd && e.length > 0) {
    for (var s in e)
      if (Po(t) == Po(e[s])) return !0;
    return !1;
  }
  return Jd(e) ? Po(t) == Po(e) : !1;
}, Lm = function(e, t) {
  for (var s in e)
    return /^(browser|cpu|device|engine|os)$/.test(s) || (t ? Lm(e[s]) : !1);
}, Jd = function(e) {
  return typeof e === Xy;
}, $g = function(e) {
  if (e) {
    for (var t = [], s = Ud(/\\?\"/g, e).split(","), n = 0; n < s.length; n++)
      if (s[n].indexOf(";") > -1) {
        var r = Bm(s[n]).split(";v=");
        t[n] = { brand: r[0], version: r[1] };
      } else
        t[n] = Bm(s[n]);
    return t;
  }
}, Po = function(e) {
  return Jd(e) ? e.toLowerCase() : e;
}, _g = function(e) {
  return Jd(e) ? Ud(/[^\d\.]/g, e).split(".")[0] : void 0;
}, ko = function(e) {
  for (var t in e) {
    var s = e[t];
    typeof s == Hd && s.length == 2 ? this[s[0]] = s[1] : this[s] = void 0;
  }
  return this;
}, Ud = function(e, t) {
  return Jd(t) ? t.replace(e, jd) : t;
}, Fc = function(e) {
  return Ud(/\\?\"/g, e);
}, Bm = function(e, t) {
  if (Jd(e))
    return e = Ud(/^\s\s*/, e), typeof t === ui ? e : e.substring(0, Yy);
}, ev = function(e, t) {
  if (!(!e || !t))
    for (var s = 0, n, r, i, o, l, d; s < t.length && !l; ) {
      var c = t[s], u = t[s + 1];
      for (n = r = 0; n < c.length && !l && c[n]; )
        if (l = c[n++].exec(e), l)
          for (i = 0; i < u.length; i++)
            d = l[++r], o = u[i], typeof o === Hd && o.length > 0 ? o.length === 2 ? typeof o[1] == Rm ? this[o[0]] = o[1].call(this, d) : this[o[0]] = o[1] : o.length >= 3 && (typeof o[1] === Rm && !(o[1].exec && o[1].test) ? o.length > 3 ? this[o[0]] = d ? o[1].apply(this, o.slice(2)) : void 0 : this[o[0]] = d ? o[1].call(this, d, o[2]) : void 0 : o.length == 3 ? this[o[0]] = d ? d.replace(o[1], o[2]) : void 0 : o.length == 4 ? this[o[0]] = d ? o[3].call(this, d.replace(o[1], o[2])) : void 0 : o.length > 4 && (this[o[0]] = d ? o[3].apply(this, [d.replace(o[1], o[2])].concat(o.slice(4))) : void 0)) : this[o] = d || void 0;
      s += 2;
    }
}, Rr = function(e, t) {
  for (var s in t)
    if (typeof t[s] === Hd && t[s].length > 0) {
      for (var n = 0; n < t[s].length; n++)
        if (Qy(t[s][n], e))
          return s === wS ? void 0 : s;
    } else if (Qy(t[s], e))
      return s === wS ? void 0 : s;
  return t.hasOwnProperty("*") ? t["*"] : e;
}, LS = {
  ME: "4.90",
  "NT 3.51": "3.51",
  "NT 4.0": "4.0",
  2e3: ["5.0", "5.01"],
  XP: ["5.1", "5.2"],
  Vista: "6.0",
  7: "6.1",
  8: "6.2",
  "8.1": "6.3",
  10: ["6.4", "10.0"],
  NT: ""
}, BS = {
  embedded: "Automotive",
  mobile: "Mobile",
  tablet: ["Tablet", "EInk"],
  smarttv: "TV",
  wearable: "Watch",
  xr: ["VR", "XR"],
  "?": ["Desktop", "Unknown"],
  "*": void 0
}, _Mt = {
  Chrome: "Google Chrome",
  Edge: "Microsoft Edge",
  "Edge WebView2": "Microsoft Edge WebView2",
  "Chrome WebView": "Android WebView",
  "Chrome Headless": "HeadlessChrome",
  "Huawei Browser": "HuaweiBrowser",
  "MIUI Browser": "Miui Browser",
  "Opera Mobi": "OperaMobile",
  Yandex: "YaBrowser"
}, MS = {
  browser: [
    [
      // Most common regardless engine
      /\b(?:crmo|crios)\/([\w\.]+)/i
      // Chrome for Android/iOS
    ],
    [ft, [pt, Dl + "Chrome"]],
    [
      /webview.+edge\/([\w\.]+)/i
      // Microsoft Edge
    ],
    [ft, [pt, Uh + " WebView"]],
    [
      /edg(?:e|ios|a)?\/([\w\.]+)/i
    ],
    [ft, [pt, "Edge"]],
    [
      // Presto based
      /(opera mini)\/([-\w\.]+)/i,
      // Opera Mini
      /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,
      // Opera Mobi/Tablet
      /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i
      // Opera
    ],
    [pt, ft],
    [
      /opios[\/ ]+([\w\.]+)/i
      // Opera mini on iphone >= 8.0
    ],
    [ft, [pt, Mc + " Mini"]],
    [
      /\bop(?:rg)?x\/([\w\.]+)/i
      // Opera GX
    ],
    [ft, [pt, Mc + " GX"]],
    [
      /\bopr\/([\w\.]+)/i
      // Opera Webkit
    ],
    [ft, [pt, Mc]],
    [
      // Mixed
      /\bb[ai]*d(?:uhd|[ub]*[aekoprswx]{5,6})[\/ ]?([\w\.]+)/i
      // Baidu
    ],
    [ft, [pt, "Baidu"]],
    [
      /\b(?:mxbrowser|mxios|myie2)\/?([-\w\.]*)\b/i
      // Maxthon
    ],
    [ft, [pt, "Maxthon"]],
    [
      /(kindle)\/([\w\.]+)/i,
      // Kindle
      /(lunascape|maxthon|netfront|jasmine|blazer|sleipnir)[\/ ]?([\w\.]*)/i,
      // Lunascape/Maxthon/Netfront/Jasmine/Blazer/Sleipnir
      // Trident based
      /(avant|iemobile|slim(?:browser|boat|jet))[\/ ]?([\d\.]*)/i,
      // Avant/IEMobile/SlimBrowser/SlimBoat/Slimjet
      /(?:ms|\()(ie) ([\w\.]+)/i,
      // Internet Explorer
      // Blink/Webkit/KHTML based                                         // Flock/RockMelt/Midori/Epiphany/Silk/Skyfire/Bolt/Iron/Iridium/PhantomJS/Bowser/QupZilla/Falkon/LG Browser/Otter/qutebrowser/Dooble
      /(flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|duckduckgo|klar|helio|(?=comodo_)?dragon|otter|dooble|(?:lg |qute)browser)\/([-\w\.]+)/i,
      // Rekonq/Puffin/Brave/Whale/QQBrowserLite/QQ//Vivaldi/DuckDuckGo/Klar/Helio/Dragon
      /(heytap|ovi|115|surf)browser\/([\d\.]+)/i,
      // HeyTap/Ovi/115/Surf
      /(ecosia|weibo)(?:__| \w+@)([\d\.]+)/i
      // Ecosia/Weibo
    ],
    [pt, ft],
    [
      /quark(?:pc)?\/([-\w\.]+)/i
      // Quark
    ],
    [ft, [pt, "Quark"]],
    [
      /\bddg\/([\w\.]+)/i
      // DuckDuckGo
    ],
    [ft, [pt, "DuckDuckGo"]],
    [
      /(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i
      // UCBrowser
    ],
    [ft, [pt, "UCBrowser"]],
    [
      /microm.+\bqbcore\/([\w\.]+)/i,
      // WeChat Desktop for Windows Built-in Browser
      /\bqbcore\/([\w\.]+).+microm/i,
      /micromessenger\/([\w\.]+)/i
      // WeChat
    ],
    [ft, [pt, "WeChat"]],
    [
      /konqueror\/([\w\.]+)/i
      // Konqueror
    ],
    [ft, [pt, "Konqueror"]],
    [
      /trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i
      // IE11
    ],
    [ft, [pt, "IE"]],
    [
      /ya(?:search)?browser\/([\w\.]+)/i
      // Yandex
    ],
    [ft, [pt, "Yandex"]],
    [
      /slbrowser\/([\w\.]+)/i
      // Smart Lenovo Browser
    ],
    [ft, [pt, "Smart " + Gg + xc]],
    [
      /(avast|avg)\/([\w\.]+)/i
      // Avast/AVG Secure Browser
    ],
    [[pt, /(.+)/, "$1 Secure" + xc], ft],
    [
      /\bfocus\/([\w\.]+)/i
      // Firefox Focus
    ],
    [ft, [pt, Bc + " Focus"]],
    [
      /\bopt\/([\w\.]+)/i
      // Opera Touch
    ],
    [ft, [pt, Mc + " Touch"]],
    [
      /coc_coc\w+\/([\w\.]+)/i
      // Coc Coc Browser
    ],
    [ft, [pt, "Coc Coc"]],
    [
      /dolfin\/([\w\.]+)/i
      // Dolphin
    ],
    [ft, [pt, "Dolphin"]],
    [
      /coast\/([\w\.]+)/i
      // Opera Coast
    ],
    [ft, [pt, Mc + " Coast"]],
    [
      /miuibrowser\/([\w\.]+)/i
      // MIUI Browser
    ],
    [ft, [pt, "MIUI" + xc]],
    [
      /fxios\/([\w\.-]+)/i
      // Firefox for iOS
    ],
    [ft, [pt, Dl + Bc]],
    [
      /\bqihoobrowser\/?([\w\.]*)/i
      // 360
    ],
    [ft, [pt, "360"]],
    [
      /\b(qq)\/([\w\.]+)/i
      // QQ
    ],
    [[pt, /(.+)/, "$1Browser"], ft],
    [
      /(oculus|sailfish|huawei|vivo|pico)browser\/([\w\.]+)/i
    ],
    [[pt, /(.+)/, "$1" + xc], ft],
    [
      // Oculus/Sailfish/HuaweiBrowser/VivoBrowser/PicoBrowser
      /samsungbrowser\/([\w\.]+)/i
      // Samsung Internet
    ],
    [ft, [pt, Rc + " Internet"]],
    [
      /metasr[\/ ]?([\d\.]+)/i
      // Sogou Explorer
    ],
    [ft, [pt, RS + " Explorer"]],
    [
      /(sogou)mo\w+\/([\d\.]+)/i
      // Sogou Mobile
    ],
    [[pt, RS + " Mobile"], ft],
    [
      /(electron)\/([\w\.]+) safari/i,
      // Electron-based App
      /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,
      // Tesla
      /m?(qqbrowser|2345(?=browser|chrome|explorer))\w*[\/ ]?v?([\w\.]+)/i
      // QQ/2345
    ],
    [pt, ft],
    [
      /(lbbrowser|rekonq)/i
      // LieBao Browser/Rekonq
    ],
    [pt],
    [
      /ome\/([\w\.]+) \w* ?(iron) saf/i,
      // Iron
      /ome\/([\w\.]+).+qihu (360)[es]e/i
      // 360
    ],
    [ft, pt],
    [
      // WebView
      /((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i
      // Facebook App for iOS & Android
    ],
    [[pt, Jg], ft, [tt, Oc]],
    [
      /(kakao(?:talk|story))[\/ ]([\w\.]+)/i,
      // Kakao App
      /(naver)\(.*?(\d+\.[\w\.]+).*\)/i,
      // Naver InApp
      /(daum)apps[\/ ]([\w\.]+)/i,
      // Daum App
      /safari (line)\/([\w\.]+)/i,
      // Line App for iOS
      /\b(line)\/([\w\.]+)\/iab/i,
      // Line App for Android
      /(alipay)client\/([\w\.]+)/i,
      // Alipay
      /(twitter)(?:and| f.+e\/([\w\.]+))/i,
      // Twitter
      /(instagram|snapchat|klarna)[\/ ]([-\w\.]+)/i
      // Instagram/Snapchat/Klarna
    ],
    [pt, ft, [tt, Oc]],
    [
      /\bgsa\/([\w\.]+) .*safari\//i
      // Google Search Appliance on iOS
    ],
    [ft, [pt, "GSA"], [tt, Oc]],
    [
      /musical_ly(?:.+app_?version\/|_)([\w\.]+)/i
      // TikTok
    ],
    [ft, [pt, "TikTok"], [tt, Oc]],
    [
      /\[(linkedin)app\]/i
      // LinkedIn App for iOS & Android
    ],
    [pt, [tt, Oc]],
    [
      /(chromium)[\/ ]([-\w\.]+)/i
      // Chromium
    ],
    [pt, ft],
    [
      /headlesschrome(?:\/([\w\.]+)| )/i
      // Chrome Headless
    ],
    [ft, [pt, TS + " Headless"]],
    [
      /wv\).+chrome\/([\w\.]+).+edgw\//i
      // Edge WebView2
    ],
    [ft, [pt, Uh + " WebView2"]],
    [
      / wv\).+(chrome)\/([\w\.]+)/i
      // Chrome WebView
    ],
    [[pt, TS + " WebView"], ft],
    [
      /droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i
      // Android Browser
    ],
    [ft, [pt, "Android" + xc]],
    [
      /chrome\/([\w\.]+) mobile/i
      // Chrome Mobile
    ],
    [ft, [pt, Dl + "Chrome"]],
    [
      /(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i
      // Chrome/OmniWeb/Arora/Tizen/Nokia
    ],
    [pt, ft],
    [
      /version\/([\w\.\,]+) .*mobile(?:\/\w+ | ?)safari/i
      // Safari Mobile
    ],
    [ft, [pt, Dl + "Safari"]],
    [
      /iphone .*mobile(?:\/\w+ | ?)safari/i
    ],
    [[pt, Dl + "Safari"]],
    [
      /version\/([\w\.\,]+) .*(safari)/i
      // Safari
    ],
    [ft, pt],
    [
      /webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i
      // Safari < 3.0
    ],
    [pt, [ft, "1"]],
    [
      /(webkit|khtml)\/([\w\.]+)/i
    ],
    [pt, ft],
    [
      // Gecko based
      /(?:mobile|tablet);.*(firefox)\/([\w\.-]+)/i
      // Firefox Mobile
    ],
    [[pt, Dl + Bc], ft],
    [
      /(navigator|netscape\d?)\/([-\w\.]+)/i
      // Netscape
    ],
    [[pt, "Netscape"], ft],
    [
      /(wolvic|librewolf)\/([\w\.]+)/i
      // Wolvic/LibreWolf
    ],
    [pt, ft],
    [
      /mobile vr; rv:([\w\.]+)\).+firefox/i
      // Firefox Reality
    ],
    [ft, [pt, Bc + " Reality"]],
    [
      /ekiohf.+(flow)\/([\w\.]+)/i,
      // Flow
      /(swiftfox)/i,
      // Swiftfox
      /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror)[\/ ]?([\w\.\+]+)/i,
      // IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror
      /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,
      // Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
      /(firefox)\/([\w\.]+)/i,
      // Other Firefox-based
      /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,
      // Mozilla
      // Other
      /(amaya|dillo|doris|icab|ladybird|lynx|mosaic|netsurf|obigo|polaris|w3m|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,
      // Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Obigo/Mosaic/Go/ICE/UP.Browser/Ladybird
      /\b(links) \(([\w\.]+)/i
      // Links
    ],
    [pt, [ft, /_/g, "."]],
    [
      /(cobalt)\/([\w\.]+)/i
      // Cobalt
    ],
    [pt, [ft, /[^\d\.]+./, jd]]
  ],
  cpu: [
    [
      /\b((amd|x|x86[-_]?|wow|win)64)\b/i
      // AMD64 (x64)
    ],
    [[Cn, "amd64"]],
    [
      /(ia32(?=;))/i,
      // IA32 (quicktime)
      /\b((i[346]|x)86)(pc)?\b/i
      // IA32 (x86)
    ],
    [[Cn, "ia32"]],
    [
      /\b(aarch64|arm(v?[89]e?l?|_?64))\b/i
      // ARM64
    ],
    [[Cn, "arm64"]],
    [
      /\b(arm(v[67])?ht?n?[fl]p?)\b/i
      // ARMHF
    ],
    [[Cn, "armhf"]],
    [
      // PocketPC mistakenly identified as PowerPC
      /( (ce|mobile); ppc;|\/[\w\.]+arm\b)/i
    ],
    [[Cn, "arm"]],
    [
      /((ppc|powerpc)(64)?)( mac|;|\))/i
      // PowerPC
    ],
    [[Cn, /ower/, jd, Po]],
    [
      / sun4\w[;\)]/i
      // SPARC
    ],
    [[Cn, "sparc"]],
    [
      /\b(avr32|ia64(?=;)|68k(?=\))|\barm(?=v([1-7]|[5-7]1)l?|;|eabi)|(irix|mips|sparc)(64)?\b|pa-risc)/i
      // IA64, 68K, ARM/64, AVR/32, IRIX/64, MIPS/64, SPARC/64, PA-RISC
    ],
    [[Cn, Po]]
  ],
  device: [
    [
      //////////////////////////
      // MOBILES & TABLETS
      /////////////////////////
      // Samsung
      /\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i
    ],
    [rt, [ut, Rc], [tt, qs]],
    [
      /\b((?:s[cgp]h|gt|sm)-(?![lr])\w+|sc[g-]?[\d]+a?|galaxy nexus)/i,
      /samsung[- ]((?!sm-[lr]|browser)[-\w]+)/i,
      /sec-(sgh\w+)/i
    ],
    [rt, [ut, Rc], [tt, ns]],
    [
      // Apple
      /(?:\/|\()(ip(?:hone|od)[\w, ]*)(?:\/|;)/i
      // iPod/iPhone
    ],
    [rt, [ut, Vl], [tt, ns]],
    [
      /\((ipad);[-\w\),; ]+apple/i,
      // iPad
      /applecoremedia\/[\w\.]+ \((ipad)/i,
      /\b(ipad)\d\d?,\d\d?[;\]].+ios/i
    ],
    [rt, [ut, Vl], [tt, qs]],
    [
      /(macintosh);/i
    ],
    [rt, [ut, Vl]],
    [
      // Sharp
      /\b(sh-?[altvz]?\d\d[a-ekm]?)/i
    ],
    [rt, [ut, IS], [tt, ns]],
    [
      // Honor
      /\b((?:brt|eln|hey2?|gdi|jdn)-a?[lnw]09|(?:ag[rm]3?|jdn2|kob2)-a?[lw]0[09]hn)(?: bui|\)|;)/i
    ],
    [rt, [ut, kS], [tt, qs]],
    [
      /honor([-\w ]+)[;\)]/i
    ],
    [rt, [ut, kS], [tt, ns]],
    [
      // Huawei
      /\b((?:ag[rs][2356]?k?|bah[234]?|bg[2o]|bt[kv]|cmr|cpn|db[ry]2?|jdn2|got|kob2?k?|mon|pce|scm|sht?|[tw]gr|vrd)-[ad]?[lw][0125][09]b?|605hw|bg2-u03|(?:gem|fdr|m2|ple|t1)-[7a]0[1-4][lu]|t1-a2[13][lw]|mediapad[\w\. ]*(?= bui|\)))\b(?!.+d\/s)/i
    ],
    [rt, [ut, PS], [tt, qs]],
    [
      /(?:huawei)([-\w ]+)[;\)]/i,
      /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i
    ],
    [rt, [ut, PS], [tt, ns]],
    [
      // Xiaomi
      /oid[^\)]+; (2[\dbc]{4}(182|283|rp\w{2})[cgl]|m2105k81a?c)(?: bui|\))/i,
      /\b((?:red)?mi[-_ ]?pad[\w- ]*)(?: bui|\))/i
      // Mi Pad tablets
    ],
    [[rt, /_/g, " "], [ut, Kg], [tt, qs]],
    [
      /\b(poco[\w ]+|m2\d{3}j\d\d[a-z]{2})(?: bui|\))/i,
      // Xiaomi POCO
      /\b; (\w+) build\/hm\1/i,
      // Xiaomi Hongmi 'numeric' models
      /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,
      // Xiaomi Hongmi
      /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,
      // Xiaomi Redmi
      /oid[^\)]+; (m?[12][0-389][01]\w{3,6}[c-y])( bui|; wv|\))/i,
      // Xiaomi Redmi 'numeric' models
      /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite|pro)?)(?: bui|\))/i,
      // Xiaomi Mi
      / ([\w ]+) miui\/v?\d/i
    ],
    [[rt, /_/g, " "], [ut, Kg], [tt, ns]],
    [
      // OnePlus
      /droid.+; (cph2[3-6]\d[13579]|((gm|hd)19|(ac|be|in|kb)20|(d[en]|eb|le|mt)21|ne22)[0-2]\d|p[g-k]\w[1m]10)\b/i,
      /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i
    ],
    [rt, [ut, ES], [tt, ns]],
    [
      // OPPO
      /; (\w+) bui.+ oppo/i,
      /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i
    ],
    [rt, [ut, Qg], [tt, ns]],
    [
      /\b(opd2(\d{3}a?))(?: bui|\))/i
    ],
    [rt, [ut, Rr, { OnePlus: ["203", "304", "403", "404", "413", "415"], "*": Qg }], [tt, qs]],
    [
      // BLU
      /(vivo (5r?|6|8l?|go|one|s|x[il]?[2-4]?)[\w\+ ]*)(?: bui|\))/i
      // Vivo series
    ],
    [rt, [ut, "BLU"], [tt, ns]],
    [
      // Vivo
      /; vivo (\w+)(?: bui|\))/i,
      /\b(v[12]\d{3}\w?[at])(?: bui|;)/i
    ],
    [rt, [ut, "Vivo"], [tt, ns]],
    [
      // Realme
      /\b(rmx[1-3]\d{3})(?: bui|;|\))/i
    ],
    [rt, [ut, "Realme"], [tt, ns]],
    [
      // Lenovo
      /(ideatab[-\w ]+|602lv|d-42a|a101lv|a2109a|a3500-hv|s[56]000|pb-6505[my]|tb-?x?\d{3,4}(?:f[cu]|xu|[av])|yt\d?-[jx]?\d+[lfmx])( bui|;|\)|\/)/i,
      /lenovo ?(b[68]0[08]0-?[hf]?|tab(?:[\w- ]+?)|tb[\w-]{6,7})( bui|;|\)|\/)/i
    ],
    [rt, [ut, Gg], [tt, qs]],
    [
      /lenovo[-_ ]?([-\w ]+?)(?: bui|\)|\/)/i
    ],
    [rt, [ut, Gg], [tt, ns]],
    [
      // Motorola
      /\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,
      /\bmot(?:orola)?[- ]([\w\s]+)(\)| bui)/i,
      /((?:moto(?! 360)[-\w\(\) ]+|xt\d{3,4}[cgkosw\+]?[-\d]*|nexus 6)(?= bui|\)))/i
    ],
    [rt, [ut, Xg], [tt, ns]],
    [
      /\b(mz60\d|xoom[2 ]{0,2}) build\//i
    ],
    [rt, [ut, Xg], [tt, qs]],
    [
      // LG
      /((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i
    ],
    [rt, [ut, Xp], [tt, qs]],
    [
      /(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,
      /\blg[-e;\/ ]+(?!.*(?:browser|netcast|android tv|watch|webos))(\w+)/i,
      /\blg-?([\d\w]+) bui/i
    ],
    [rt, [ut, Xp], [tt, ns]],
    [
      // Nokia
      /(nokia) (t[12][01])/i
    ],
    [ut, rt, [tt, qs]],
    [
      /(?:maemo|nokia).*(n900|lumia \d+|rm-\d+)/i,
      /nokia[-_ ]?(([-\w\. ]*))/i
    ],
    [[rt, /_/g, " "], [tt, ns], [ut, "Nokia"]],
    [
      // Google
      /(pixel (c|tablet))\b/i
      // Google Pixel C/Tablet
    ],
    [rt, [ut, Ni], [tt, qs]],
    [
      // Google Pixel
      /droid.+;(?: google)? (g(01[13]a|020[aem]|025[jn]|1b60|1f8f|2ybb|4s1m|576d|5nz6|8hhn|8vou|a02099|c15s|d1yq|e2ae|ec77|gh2x|kv4x|p4bc|pj41|r83y|tt9q|ur25|wvk6)|pixel[\d ]*a?( pro)?( xl)?( fold)?( \(5g\))?)( bui|\))/i
    ],
    [rt, [ut, Ni], [tt, ns]],
    [
      /(google) (pixelbook( go)?)/i
    ],
    [ut, rt],
    [
      // Sony
      /droid.+; (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-\w\w\d\d)(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i
    ],
    [rt, [ut, Lc], [tt, ns]],
    [
      /sony tablet [ps]/i,
      /\b(?:sony)?sgp\w+(?: bui|\))/i
    ],
    [[rt, "Xperia Tablet"], [ut, Lc], [tt, qs]],
    [
      // Amazon
      /(alexa)webm/i,
      /(kf[a-z]{2}wi|aeo(?!bc)\w\w)( bui|\))/i,
      // Kindle Fire without Silk / Echo Show
      /(kf[a-z]+)( bui|\)).+silk\//i
      // Kindle Fire HD
    ],
    [rt, [ut, Yp], [tt, qs]],
    [
      /((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i
      // Fire Phone
    ],
    [[rt, /(.+)/g, "Fire Phone $1"], [ut, Yp], [tt, ns]],
    [
      // BlackBerry
      /(playbook);[-\w\),; ]+(rim)/i
      // BlackBerry PlayBook
    ],
    [rt, ut, [tt, qs]],
    [
      /\b((?:bb[a-f]|st[hv])100-\d)/i,
      /\(bb10; (\w+)/i
      // BlackBerry 10
    ],
    [rt, [ut, SS], [tt, ns]],
    [
      // Asus
      /(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i
    ],
    [rt, [ut, CS], [tt, qs]],
    [
      / (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i
    ],
    [rt, [ut, CS], [tt, ns]],
    [
      // HTC
      /(nexus 9)/i
      // HTC Nexus 9
    ],
    [rt, [ut, "HTC"], [tt, qs]],
    [
      /(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,
      // HTC
      // ZTE
      /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,
      /(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i
      // Alcatel/GeeksPhone/Nexian/Panasonic/Sony
    ],
    [ut, [rt, /_/g, " "], [tt, ns]],
    [
      // TCL
      /tcl (xess p17aa)/i,
      /droid [\w\.]+; ((?:8[14]9[16]|9(?:0(?:48|60|8[01])|1(?:3[27]|66)|2(?:6[69]|9[56])|466))[gqswx])(_\w(\w|\w\w))?(\)| bui)/i
    ],
    [rt, [ut, "TCL"], [tt, qs]],
    [
      /droid [\w\.]+; (418(?:7d|8v)|5087z|5102l|61(?:02[dh]|25[adfh]|27[ai]|56[dh]|59k|65[ah])|a509dl|t(?:43(?:0w|1[adepqu])|50(?:6d|7[adju])|6(?:09dl|10k|12b|71[efho]|76[hjk])|7(?:66[ahju]|67[hw]|7[045][bh]|71[hk]|73o|76[ho]|79w|81[hks]?|82h|90[bhsy]|99b)|810[hs]))(_\w(\w|\w\w))?(\)| bui)/i
    ],
    [rt, [ut, "TCL"], [tt, ns]],
    [
      // itel
      /(itel) ((\w+))/i
    ],
    [[ut, Po], rt, [tt, Rr, { tablet: ["p10001l", "w7001"], "*": "mobile" }]],
    [
      // Acer
      /droid.+; ([ab][1-7]-?[0178a]\d\d?)/i
    ],
    [rt, [ut, "Acer"], [tt, qs]],
    [
      // Meizu
      /droid.+; (m[1-5] note) bui/i,
      /\bmz-([-\w]{2,})/i
    ],
    [rt, [ut, "Meizu"], [tt, ns]],
    [
      // Ulefone
      /; ((?:power )?armor(?:[\w ]{0,8}))(?: bui|\))/i
    ],
    [rt, [ut, "Ulefone"], [tt, ns]],
    [
      // Energizer
      /; (energy ?\w+)(?: bui|\))/i,
      /; energizer ([\w ]+)(?: bui|\))/i
    ],
    [rt, [ut, "Energizer"], [tt, ns]],
    [
      // Cat
      /; cat (b35);/i,
      /; (b15q?|s22 flip|s48c|s62 pro)(?: bui|\))/i
    ],
    [rt, [ut, "Cat"], [tt, ns]],
    [
      // Smartfren
      /((?:new )?andromax[\w- ]+)(?: bui|\))/i
    ],
    [rt, [ut, "Smartfren"], [tt, ns]],
    [
      // Nothing
      /droid.+; (a(in)?(0(15|59|6[35])|142)p?)/i
    ],
    [rt, [ut, "Nothing"], [tt, ns]],
    [
      // Archos
      /; (x67 5g|tikeasy \w+|ac[1789]\d\w+)( b|\))/i,
      /archos ?(5|gamepad2?|([\w ]*[t1789]|hello) ?\d+[\w ]*)( b|\))/i
    ],
    [rt, [ut, "Archos"], [tt, qs]],
    [
      /archos ([\w ]+)( b|\))/i,
      /; (ac[3-6]\d\w{2,8})( b|\))/i
    ],
    [rt, [ut, "Archos"], [tt, ns]],
    [
      // HMD
      /; (n159v)/i
    ],
    [rt, [ut, "HMD"], [tt, ns]],
    [
      // MIXED
      /(imo) (tab \w+)/i,
      // IMO
      /(infinix|tecno) (x1101b?|p904|dp(7c|8d|10a)( pro)?|p70[1-3]a?|p904|t1101)/i
      // Infinix XPad / Tecno
    ],
    [ut, rt, [tt, qs]],
    [
      /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus(?! zenw)|dell|jolla|meizu|motorola|polytron|tecno|micromax|advan)[-_ ]?([-\w]*)/i,
      // BlackBerry/BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Meizu/Motorola/Polytron/Tecno/Micromax/Advan
      /; (blu|hmd|imo|infinix|lava|oneplus|tcl)[_ ]([\w\+ ]+?)(?: bui|\)|; r)/i,
      // BLU/HMD/IMO/Infinix/Lava/OnePlus/TCL
      /(hp) ([\w ]+\w)/i,
      // HP iPAQ
      /(microsoft); (lumia[\w ]+)/i,
      // Microsoft Lumia
      /(oppo) ?([\w ]+) bui/i
      // OPPO
    ],
    [ut, rt, [tt, ns]],
    [
      /(kobo)\s(ereader|touch)/i,
      // Kobo
      /(hp).+(touchpad(?!.+tablet)|tablet)/i,
      // HP TouchPad
      /(kindle)\/([\w\.]+)/i
      // Kindle
    ],
    [ut, rt, [tt, qs]],
    [
      /(surface duo)/i
      // Surface Duo
    ],
    [rt, [ut, Yg], [tt, qs]],
    [
      /droid [\d\.]+; (fp\du?)(?: b|\))/i
      // Fairphone
    ],
    [rt, [ut, "Fairphone"], [tt, ns]],
    [
      /((?:tegranote|shield t(?!.+d tv))[\w- ]*?)(?: b|\))/i
      // Nvidia Tablets
    ],
    [rt, [ut, qg], [tt, qs]],
    [
      /(sprint) (\w+)/i
      // Sprint Phones
    ],
    [ut, rt, [tt, ns]],
    [
      /(kin\.[onetw]{3})/i
      // Microsoft Kin
    ],
    [[rt, /\./g, " "], [ut, Yg], [tt, ns]],
    [
      /droid.+; ([c6]+|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i
      // Zebra
    ],
    [rt, [ut, Zg], [tt, qs]],
    [
      /droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i
    ],
    [rt, [ut, Zg], [tt, ns]],
    [
      ///////////////////
      // SMARTTVS
      ///////////////////
      /smart-tv.+(samsung)/i
      // Samsung
    ],
    [ut, [tt, Fa]],
    [
      /hbbtv.+maple;(\d+)/i
    ],
    [[rt, /^/, "SmartTV"], [ut, Rc], [tt, Fa]],
    [
      /(vizio)(?: |.+model\/)(\w+-\w+)/i,
      // Vizio
      /tcast.+(lg)e?. ([-\w]+)/i
      // LG SmartTV
    ],
    [ut, rt, [tt, Fa]],
    [
      /(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i
    ],
    [[ut, Xp], [tt, Fa]],
    [
      /(apple) ?tv/i
      // Apple TV
    ],
    [ut, [rt, Vl + " TV"], [tt, Fa]],
    [
      /crkey.*devicetype\/chromecast/i
      // Google Chromecast Third Generation
    ],
    [[rt, Ko + " Third Generation"], [ut, Ni], [tt, Fa]],
    [
      /crkey.*devicetype\/([^/]*)/i
      // Google Chromecast with specific device type
    ],
    [[rt, /^/, "Chromecast "], [ut, Ni], [tt, Fa]],
    [
      /fuchsia.*crkey/i
      // Google Chromecast Nest Hub
    ],
    [[rt, Ko + " Nest Hub"], [ut, Ni], [tt, Fa]],
    [
      /crkey/i
      // Google Chromecast, Linux-based or unknown
    ],
    [[rt, Ko], [ut, Ni], [tt, Fa]],
    [
      /(portaltv)/i
      // Facebook Portal TV
    ],
    [rt, [ut, Jg], [tt, Fa]],
    [
      /droid.+aft(\w+)( bui|\))/i
      // Fire TV
    ],
    [rt, [ut, Yp], [tt, Fa]],
    [
      /(shield \w+ tv)/i
      // Nvidia Shield TV
    ],
    [rt, [ut, qg], [tt, Fa]],
    [
      /\(dtv[\);].+(aquos)/i,
      /(aquos-tv[\w ]+)\)/i
      // Sharp
    ],
    [rt, [ut, IS], [tt, Fa]],
    [
      /(bravia[\w ]+)( bui|\))/i
      // Sony
    ],
    [rt, [ut, Lc], [tt, Fa]],
    [
      /(mi(tv|box)-?\w+) bui/i
      // Xiaomi
    ],
    [rt, [ut, Kg], [tt, Fa]],
    [
      /Hbbtv.*(technisat) (.*);/i
      // TechniSAT
    ],
    [ut, rt, [tt, Fa]],
    [
      /\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,
      // Roku
      /hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i
      // HbbTV devices
    ],
    [[ut, /.+\/(\w+)/, "$1", Rr, { LG: "lge" }], [rt, Bm], [tt, Fa]],
    [
      // SmartTV from Unidentified Vendors
      /droid.+; ([\w- ]+) (?:android tv|smart[- ]?tv)/i
    ],
    [rt, [tt, Fa]],
    [
      /\b(android tv|smart[- ]?tv|opera tv|tv; rv:|large screen[\w ]+safari)\b/i
    ],
    [[tt, Fa]],
    [
      ///////////////////
      // CONSOLES
      ///////////////////
      /(playstation \w+)/i
      // Playstation
    ],
    [rt, [ut, Lc], [tt, qc]],
    [
      /\b(xbox(?: one)?(?!; xbox))[\); ]/i
      // Microsoft Xbox
    ],
    [rt, [ut, Yg], [tt, qc]],
    [
      /(ouya)/i,
      // Ouya
      /(nintendo) (\w+)/i,
      // Nintendo
      /(retroid) (pocket ([^\)]+))/i
      // Retroid Pocket
    ],
    [ut, rt, [tt, qc]],
    [
      /droid.+; (shield)( bui|\))/i
      // Nvidia Portable
    ],
    [rt, [ut, qg], [tt, qc]],
    [
      ///////////////////
      // WEARABLES
      ///////////////////
      /\b(sm-[lr]\d\d[0156][fnuw]?s?|gear live)\b/i
      // Samsung Galaxy Watch
    ],
    [rt, [ut, Rc], [tt, Er]],
    [
      /((pebble))app/i,
      // Pebble
      /(asus|google|lg|oppo) ((pixel |zen)?watch[\w ]*)( bui|\))/i
      // Asus ZenWatch / LG Watch / Pixel Watch
    ],
    [ut, rt, [tt, Er]],
    [
      /(ow(?:19|20)?we?[1-3]{1,3})/i
      // Oppo Watch
    ],
    [rt, [ut, Qg], [tt, Er]],
    [
      /(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i
      // Apple Watch
    ],
    [rt, [ut, Vl], [tt, Er]],
    [
      /(opwwe\d{3})/i
      // OnePlus Watch
    ],
    [rt, [ut, ES], [tt, Er]],
    [
      /(moto 360)/i
      // Motorola 360
    ],
    [rt, [ut, Xg], [tt, Er]],
    [
      /(smartwatch 3)/i
      // Sony SmartWatch
    ],
    [rt, [ut, Lc], [tt, Er]],
    [
      /(g watch r)/i
      // LG G Watch R
    ],
    [rt, [ut, Xp], [tt, Er]],
    [
      /droid.+; (wt63?0{2,3})\)/i
    ],
    [rt, [ut, Zg], [tt, Er]],
    [
      ///////////////////
      // XR
      ///////////////////
      /droid.+; (glass) \d/i
      // Google Glass
    ],
    [rt, [ut, Ni], [tt, Gp]],
    [
      /(pico) (4|neo3(?: link|pro)?)/i
      // Pico
    ],
    [ut, rt, [tt, Gp]],
    [
      /(quest( \d| pro)?s?).+vr/i
      // Meta Quest
    ],
    [rt, [ut, Jg], [tt, Gp]],
    [
      /mobile vr; rv.+firefox/i
      // Unidentifiable VR device using Firefox Reality / Wolvic
    ],
    [[tt, Gp]],
    [
      ///////////////////
      // EMBEDDED
      ///////////////////
      /(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i
      // Tesla
    ],
    [ut, [tt, Qc]],
    [
      /(aeobc)\b/i
      // Echo Dot
    ],
    [rt, [ut, Yp], [tt, Qc]],
    [
      /(homepod).+mac os/i
      // Apple HomePod
    ],
    [rt, [ut, Vl], [tt, Qc]],
    [
      /windows iot/i
      // Unidentifiable embedded device using Windows IoT
    ],
    [[tt, Qc]],
    [
      ////////////////////
      // MIXED (GENERIC)
      ///////////////////
      /droid .+?; ([^;]+?)(?: bui|; wv\)|\) applew).+?(mobile|vr|\d) safari/i
    ],
    [rt, [tt, Rr, { mobile: "Mobile", xr: "VR", "*": qs }]],
    [
      /\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i
      // Unidentifiable Tablet
    ],
    [[tt, qs]],
    [
      /(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i
      // Unidentifiable Mobile
    ],
    [[tt, ns]],
    [
      /droid .+?; ([\w\. -]+)( bui|\))/i
      // Generic Android Device
    ],
    [rt, [ut, "Generic"]]
  ],
  engine: [
    [
      /windows.+ edge\/([\w\.]+)/i
      // EdgeHTML
    ],
    [ft, [pt, Uh + "HTML"]],
    [
      /(arkweb)\/([\w\.]+)/i
      // ArkWeb
    ],
    [pt, ft],
    [
      /webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i
      // Blink
    ],
    [ft, [pt, "Blink"]],
    [
      /(presto)\/([\w\.]+)/i,
      // Presto
      /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna|servo)\/([\w\.]+)/i,
      // WebKit/Trident/NetFront/NetSurf/Amaya/Lynx/w3m/Goanna/Servo
      /ekioh(flow)\/([\w\.]+)/i,
      // Flow
      /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,
      // KHTML/Tasman/Links
      /(icab)[\/ ]([23]\.[\d\.]+)/i,
      // iCab
      /\b(libweb)/i
      // LibWeb
    ],
    [pt, ft],
    [
      /ladybird\//i
    ],
    [[pt, "LibWeb"]],
    [
      /rv\:([\w\.]{1,9})\b.+(gecko)/i
      // Gecko
    ],
    [ft, pt]
  ],
  os: [
    [
      // Windows
      /(windows nt) (6\.[23]); arm/i
      // Windows RT
    ],
    [[pt, /N/, "R"], [ft, Rr, LS]],
    [
      /(windows (?:phone|mobile|iot))(?: os)?[\/ ]?([\d\.]*( se)?)/i,
      // Windows IoT/Mobile/Phone
      // Windows NT/3.1/95/98/ME/2000/XP/Vista/7/8/8.1/10/11
      /(windows)[\/ ](1[01]|2000|3\.1|7|8(\.1)?|9[58]|me|server 20\d\d( r2)?|vista|xp)/i
    ],
    [pt, ft],
    [
      /windows nt ?([\d\.\)]*)(?!.+xbox)/i,
      /\bwin(?=3| ?9|n)(?:nt| 9x )?([\d\.;]*)/i
    ],
    [[ft, /(;|\))/g, "", Rr, LS], [pt, qy]],
    [
      /(windows ce)\/?([\d\.]*)/i
      // Windows CE
    ],
    [pt, ft],
    [
      // iOS/macOS
      /[adehimnop]{4,7}\b(?:.*os ([\w]+) like mac|; opera)/i,
      // iOS
      /(?:ios;fbsv\/|iphone.+ios[\/ ])([\d\.]+)/i,
      /cfnetwork\/.+darwin/i
    ],
    [[ft, /_/g, "."], [pt, "iOS"]],
    [
      /(mac os x) ?([\w\. ]*)/i,
      /(macintosh|mac_powerpc\b)(?!.+(haiku|morphos))/i
      // Mac OS
    ],
    [[pt, "macOS"], [ft, /_/g, "."]],
    [
      // Google Chromecast
      /android ([\d\.]+).*crkey/i
      // Google Chromecast, Android-based
    ],
    [ft, [pt, Ko + " Android"]],
    [
      /fuchsia.*crkey\/([\d\.]+)/i
      // Google Chromecast, Fuchsia-based
    ],
    [ft, [pt, Ko + " Fuchsia"]],
    [
      /crkey\/([\d\.]+).*devicetype\/smartspeaker/i
      // Google Chromecast, Linux-based Smart Speaker
    ],
    [ft, [pt, Ko + " SmartSpeaker"]],
    [
      /linux.*crkey\/([\d\.]+)/i
      // Google Chromecast, Legacy Linux-based
    ],
    [ft, [pt, Ko + " Linux"]],
    [
      /crkey\/([\d\.]+)/i
      // Google Chromecast, unknown
    ],
    [ft, [pt, Ko]],
    [
      // Mobile OSes
      /droid ([\w\.]+)\b.+(android[- ]x86)/i
      // Android-x86
    ],
    [ft, pt],
    [
      /(ubuntu) ([\w\.]+) like android/i
      // Ubuntu Touch
    ],
    [[pt, /(.+)/, "$1 Touch"], ft],
    [
      /(harmonyos)[\/ ]?([\d\.]*)/i,
      // HarmonyOS
      // Android/Blackberry/WebOS/QNX/Bada/RIM/KaiOS/Maemo/MeeGo/S40/Sailfish OS/OpenHarmony/Tizen
      /(android|bada|blackberry|kaios|maemo|meego|openharmony|qnx|rim tablet os|sailfish|series40|symbian|tizen)\w*[-\/\.; ]?([\d\.]*)/i
    ],
    [pt, ft],
    [
      /\(bb(10);/i
      // BlackBerry 10
    ],
    [ft, [pt, SS]],
    [
      /(?:symbian ?os|symbos|s60(?=;)|series ?60)[-\/ ]?([\w\.]*)/i
      // Symbian
    ],
    [ft, [pt, "Symbian"]],
    [
      /mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i
      // Firefox OS
    ],
    [ft, [pt, Bc + " OS"]],
    [
      /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i,
      // WebOS
      /webos(?:[ \/]?|\.tv-20(?=2[2-9]))(\d[\d\.]*)/i
    ],
    [ft, [pt, "webOS"]],
    [
      /web0s;.+?(?:chr[o0]me|safari)\/(\d+)/i
      // https://webostv.developer.lge.com/develop/specifications/web-api-and-web-engine
    ],
    [[ft, Rr, { 25: "120", 24: "108", 23: "94", 22: "87", 6: "79", 5: "68", 4: "53", 3: "38", 2: "538", 1: "537", "*": "TV" }], [pt, "webOS"]],
    [
      /watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i
      // watchOS
    ],
    [ft, [pt, "watchOS"]],
    [
      // Google ChromeOS
      /(cros) [\w]+(?:\)| ([\w\.]+)\b)/i
      // Chromium OS
    ],
    [[pt, "Chrome OS"], ft],
    [
      // Smart TVs
      /panasonic;(viera)/i,
      // Panasonic Viera
      /(netrange)mmh/i,
      // Netrange
      /(nettv)\/(\d+\.[\w\.]+)/i,
      // NetTV
      // Console
      /(nintendo|playstation) (\w+)/i,
      // Nintendo/Playstation
      /(xbox); +xbox ([^\);]+)/i,
      // Microsoft Xbox (360, One, X, S, Series X, Series S)
      /(pico) .+os([\w\.]+)/i,
      // Pico
      // Other
      /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,
      // Joli/Palm
      /linux.+(mint)[\/\(\) ]?([\w\.]*)/i,
      // Mint
      /(mageia|vectorlinux|fuchsia|arcaos|arch(?= ?linux))[;l ]([\d\.]*)/i,
      // Mageia/VectorLinux/Fuchsia/ArcaOS/Arch
      /([kxln]?ubuntu|debian|suse|opensuse|gentoo|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire|knoppix)(?: gnu[\/ ]linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,
      // Ubuntu/Debian/SUSE/Gentoo/Slackware/Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus/Raspbian/Plan9/Minix/RISCOS/Contiki/Deepin/Manjaro/elementary/Sabayon/Linspire/Knoppix
      /((?:open)?solaris)[-\/ ]?([\w\.]*)/i,
      // Solaris
      /\b(aix)[; ]([1-9\.]{0,4})/i,
      // AIX
      /(hurd|linux|morphos)(?: (?:arm|x86|ppc)\w*| ?)([\w\.]*)/i,
      // Hurd/Linux/MorphOS
      /(gnu) ?([\w\.]*)/i,
      // GNU
      /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i,
      // FreeBSD/NetBSD/OpenBSD/PC-BSD/GhostBSD/DragonFly
      /(haiku) ?(r\d)?/i
      // Haiku
    ],
    [pt, ft],
    [
      /(sunos) ?([\d\.]*)/i
      // Solaris
    ],
    [[pt, "Solaris"], ft],
    [
      /\b(beos|os\/2|amigaos|openvms|hp-ux|serenityos)/i,
      // BeOS/OS2/AmigaOS/OpenVMS/HP-UX/SerenityOS
      /(unix) ?([\w\.]*)/i
      // UNIX
    ],
    [pt, ft]
  ]
}, qp = function() {
  var e = { init: {}, isIgnore: {}, isIgnoreRgx: {}, toString: {} };
  return ko.call(e.init, [
    [wn, [pt, ft, Ru, tt]],
    [Ao, [Cn]],
    [Br, [tt, rt, ut]],
    [hr, [pt, ft]],
    [sr, [pt, ft]]
  ]), ko.call(e.isIgnore, [
    [wn, [ft, Ru]],
    [hr, [ft]],
    [sr, [ft]]
  ]), ko.call(e.isIgnoreRgx, [
    [wn, / ?browser$/i],
    [sr, / ?os$/i]
  ]), ko.call(e.toString, [
    [wn, [pt, ft]],
    [Ao, [Cn]],
    [Br, [ut, rt]],
    [hr, [pt, ft]],
    [sr, [pt, ft]]
  ]), e;
}(), ext = function(e, t) {
  var s = qp.init[t], n = qp.isIgnore[t] || 0, r = qp.isIgnoreRgx[t] || 0, i = qp.toString[t] || 0;
  function o() {
    ko.call(this, s);
  }
  return o.prototype.getItem = function() {
    return e;
  }, o.prototype.withClientHints = function() {
    return ii ? ii.getHighEntropyValues(xE).then(function(l) {
      return e.setCH(new FE(l, !1)).parseCH().get();
    }) : e.parseCH().get();
  }, o.prototype.withFeatureCheck = function() {
    return e.detectFeature().get();
  }, t != ud && (o.prototype.is = function(l) {
    var d = !1;
    for (var c in this)
      if (this.hasOwnProperty(c) && !Qy(n, c) && Po(r ? Ud(r, this[c]) : this[c]) == Po(r ? Ud(r, l) : l)) {
        if (d = !0, l != ui) break;
      } else if (l == ui && d) {
        d = !d;
        break;
      }
    return d;
  }, o.prototype.toString = function() {
    var l = jd;
    for (var d in i)
      typeof this[i[d]] !== ui && (l += (l ? " " : jd) + this[i[d]]);
    return l || ui;
  }), ii || (o.prototype.then = function(l) {
    var d = this, c = function() {
      for (var m in d)
        d.hasOwnProperty(m) && (this[m] = d[m]);
    };
    c.prototype = {
      is: o.prototype.is,
      toString: o.prototype.toString
    };
    var u = new c();
    return l(u), u;
  }), new o();
};
function FE(e, t) {
  if (e = e || {}, ko.call(this, xE), t)
    ko.call(this, [
      [Jb, $g(e[xi])],
      [$b, $g(e[GMt])],
      [ns, /\?1/.test(e[QMt])],
      [rt, Fc(e[KMt])],
      [pd, Fc(e[ME])],
      [_b, Fc(e[ZMt])],
      [Cn, Fc(e[YMt])],
      [zi, $g(e[qMt])],
      [Ef, Fc(e[XMt])]
    ]);
  else
    for (var s in e)
      this.hasOwnProperty(s) && typeof e[s] !== ui && (this[s] = e[s]);
}
function xS(e, t, s, n) {
  return this.get = function(r) {
    return r ? this.data.hasOwnProperty(r) ? this.data[r] : void 0 : this.data;
  }, this.set = function(r, i) {
    return this.data[r] = i, this;
  }, this.setCH = function(r) {
    return this.uaCH = r, this;
  }, this.detectFeature = function() {
    if (Sn && Sn.userAgent == this.ua)
      switch (this.itemType) {
        case wn:
          Sn.brave && typeof Sn.brave.isBrave == Rm && this.set(pt, "Brave");
          break;
        case Br:
          !this.get(tt) && ii && ii[ns] && this.set(tt, ns), this.get(rt) == "Macintosh" && Sn && typeof Sn.standalone !== ui && Sn.maxTouchPoints && Sn.maxTouchPoints > 2 && this.set(rt, "iPad").set(tt, qs);
          break;
        case sr:
          !this.get(pt) && ii && ii[pd] && this.set(pt, ii[pd]);
          break;
        case ud:
          var r = this.data, i = function(o) {
            return r[o].getItem().detectFeature().get();
          };
          this.set(wn, i(wn)).set(Ao, i(Ao)).set(Br, i(Br)).set(hr, i(hr)).set(sr, i(sr));
      }
    return this;
  }, this.parseUA = function() {
    return this.itemType != ud && ev.call(this.data, this.ua, this.rgxMap), this.itemType == wn && this.set(Ru, _g(this.get(ft))), this;
  }, this.parseCH = function() {
    var r = this.uaCH, i = this.rgxMap;
    switch (this.itemType) {
      case wn:
      case hr:
        var o = r[$b] || r[Jb], l;
        if (o)
          for (var d in o) {
            var c = o[d].brand || o[d], u = o[d].version;
            this.itemType == wn && !/not.a.brand/i.test(c) && (!l || /Chrom/.test(l) && c != OS || l == Uh && /WebView2/.test(c)) && (c = Rr(c, _Mt), l = this.get(pt), l && !/Chrom/.test(l) && /Chrom/.test(c) || this.set(pt, c).set(ft, u).set(Ru, _g(u)), l = c), this.itemType == hr && c == OS && this.set(ft, u);
          }
        break;
      case Ao:
        var m = r[Cn];
        m && (m && r[Ef] == "64" && (m += "64"), ev.call(this.data, m + ";", i));
        break;
      case Br:
        if (r[ns] && this.set(tt, ns), r[rt] && (this.set(rt, r[rt]), !this.get(tt) || !this.get(ut))) {
          var f = {};
          ev.call(f, "droid 9; " + r[rt] + ")", i), !this.get(tt) && f.type && this.set(tt, f.type), !this.get(ut) && f.vendor && this.set(ut, f.vendor);
        }
        if (r[zi]) {
          var v;
          if (typeof r[zi] != "string")
            for (var b = 0; !v && b < r[zi].length; )
              v = Rr(r[zi][b++], BS);
          else
            v = Rr(r[zi], BS);
          this.set(tt, v);
        }
        break;
      case sr:
        var w = r[pd];
        if (w) {
          var S = r[_b];
          w == qy && (S = parseInt(_g(S), 10) >= 13 ? "11" : "10"), this.set(pt, w).set(ft, S);
        }
        this.get(pt) == qy && r[rt] == "Xbox" && this.set(pt, "Xbox").set(ft, void 0);
        break;
      case ud:
        var I = this.data, T = function(x) {
          return I[x].getItem().setCH(r).parseCH().get();
        };
        this.set(wn, T(wn)).set(Ao, T(Ao)).set(Br, T(Br)).set(hr, T(hr)).set(sr, T(sr));
    }
    return this;
  }, ko.call(this, [
    ["itemType", e],
    ["ua", t],
    ["uaCH", n],
    ["rgxMap", s],
    ["data", ext(this, e)]
  ]), this;
}
function Yr(e, t, s) {
  if (typeof e === Hd ? (Lm(e, !0) ? (typeof t === Hd && (s = t), t = e) : (s = e, t = void 0), e = void 0) : typeof e === Xy && !Lm(t, !0) && (s = t, t = void 0), s && typeof s.append === Rm) {
    var n = {};
    s.forEach(function(d, c) {
      n[c] = d;
    }), s = n;
  }
  if (!(this instanceof Yr))
    return new Yr(e, t, s).getResult();
  var r = typeof e === Xy ? e : (
    // Passed user-agent string
    s && s[AS] ? s[AS] : (
      // User-Agent from passed headers
      Sn && Sn.userAgent ? Sn.userAgent : (
        // navigator.userAgent
        jd
      )
    )
  ), i = new FE(s, !0), o = t ? $Mt(MS, t) : MS, l = function(d) {
    return d == ud ? function() {
      return new xS(d, r, o, i).set("ua", r).set(wn, this.getBrowser()).set(Ao, this.getCPU()).set(Br, this.getDevice()).set(hr, this.getEngine()).set(sr, this.getOS()).get();
    } : function() {
      return new xS(d, r, o[d], i).parseUA().get();
    };
  };
  return ko.call(this, [
    ["getBrowser", l(wn)],
    ["getCPU", l(Ao)],
    ["getDevice", l(Br)],
    ["getEngine", l(hr)],
    ["getOS", l(sr)],
    ["getResult", l(ud)],
    ["getUA", function() {
      return r;
    }],
    ["setUA", function(d) {
      return Jd(d) && (r = d.length > Yy ? Bm(d, Yy) : d), this;
    }]
  ]).setUA(r), this;
}
Yr.VERSION = WMt;
Yr.BROWSER = If([pt, ft, Ru, tt]);
Yr.CPU = If([Cn]);
Yr.DEVICE = If([rt, ut, tt, qc, ns, Fa, qs, Er, Qc]);
Yr.ENGINE = Yr.OS = If([pt, ft]);
var Ta = /* @__PURE__ */ ((e) => (e.Tile = "tile", e.Map = "map", e))(Ta || {});
function txt(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function VE(e) {
  return e.split("-")[0];
}
function sxt(e) {
  return e.split("-")[1];
}
const axt = /* @__PURE__ */ new Set(["top", "bottom"]);
function nxt(e) {
  return axt.has(VE(e)) ? "y" : "x";
}
const rxt = /* @__PURE__ */ new Set(["left", "top"]);
async function oxt(e, t) {
  const {
    placement: s,
    platform: n,
    elements: r
  } = e, i = await (n.isRTL == null ? void 0 : n.isRTL(r.floating)), o = VE(s), l = sxt(s), d = nxt(s) === "y", c = rxt.has(o) ? -1 : 1, u = i && d ? -1 : 1, m = txt(t, e);
  let {
    mainAxis: f,
    crossAxis: v,
    alignmentAxis: b
  } = typeof m == "number" ? {
    mainAxis: m,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: m.mainAxis || 0,
    crossAxis: m.crossAxis || 0,
    alignmentAxis: m.alignmentAxis
  };
  return l && typeof b == "number" && (v = l === "end" ? b * -1 : b), d ? {
    x: v * u,
    y: f * c
  } : {
    x: f * c,
    y: v * u
  };
}
const ixt = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var s, n;
      const {
        x: r,
        y: i,
        placement: o,
        middlewareData: l
      } = t, d = await oxt(t, e);
      return o === ((s = l.offset) == null ? void 0 : s.placement) && (n = l.arrow) != null && n.alignmentOffset ? {} : {
        x: r + d.x,
        y: i + d.y,
        data: {
          ...d,
          placement: o
        }
      };
    }
  };
}, lxt = ixt;
function dxt(e, t = 14) {
  return new vI.Tour({
    useModalOverlay: !0,
    steps: e,
    defaultStepOptions: {
      cancelIcon: {
        enabled: !0
      },
      classes: "shepherd-theme-arrows",
      canClickTarget: !1,
      scrollTo: {
        behavior: "smooth",
        block: "center"
      },
      floatingUIOptions: {
        middleware: [
          lxt(t)
        ]
      },
      when: {
        show() {
          const s = this.getTour(), n = this.getElement(), r = n == null ? void 0 : n.querySelector(".shepherd-footer"), i = s.steps.indexOf(this) + 1, o = Math.trunc(i / s.steps.length * 100), l = document.createElement("div");
          {
            l.className = "progress", l.style.height = "20px", l.style.width = "100%", l.style.maxWidth = "215px", l.style.marginRight = "10px", this.options.buttons.length == 1 && (l.style.minWidth = "260px");
            const d = document.createElement("div");
            d.classList.add("progress-bar", "progress-bar-striped", "progress-bar-animated"), d.role = "progressbar", d.ariaLabel = "Tour progress", d.ariaValueMin = "0", d.ariaValueMax = `${s.steps.length}`, d.ariaValueNow = `${i}`, d.style.width = `${o}%`, d.innerText = `${o}%`, l.appendChild(d);
          }
          r && n && r.insertBefore(l, n.querySelector(".shepherd-button"));
        }
      }
    }
    // @ts-ignore
  });
}
const cxt = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path d="M324.5 411.1c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L214.6 256 347.1 123.5c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L192 233.4 59.5 100.9c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L169.4 256 36.9 388.5c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L192 278.6 324.5 411.1z"/></svg>', Pr = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M267.3 244.7c6.2 6.2 6.2 16.4 0 22.6l-160 160c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L233.4 256 84.7 107.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l160 160z"/></svg>', ir = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M52.7 267.3c-6.2-6.2-6.2-16.4 0-22.6l160-160c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L86.6 256 235.3 404.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-160-160z"/></svg>', FS = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M443.3 100.7c6.2 6.2 6.2 16.4 0 22.6l-272 272c-6.2 6.2-16.4 6.2-22.6 0l-144-144c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L160 361.4 420.7 100.7c6.2-6.2 16.4-6.2 22.6 0z"/></svg>', Qn = "btn btn-secondary", kr = "btn btn-lava", VS = "btn btn-success";
function uxt(e) {
  const t = new Array();
  return t.push({
    id: "step-welcome",
    title: "Welcome",
    text: () => `Welcome to our new search interface.  We’ve created an ${t.length - 1}-step guided tour to show you around.   Click proceed to learn about the new interface.`,
    classes: "example-step-extra-class",
    buttons: [
      {
        classes: Qn,
        text: cxt,
        action: e.cancel
      },
      {
        classes: kr,
        text: Pr,
        action: e.nextStep
      }
    ]
  }), t.push({
    id: "step-searchbox",
    //title: () => `Step 1 of ${steps.length - 1}`,
    title: () => "Zip Code Search",
    text: "The zip code of your current location is automatically populated in this search box.  You can edit and add up to 6 zip codes to search.",
    attachTo: {
      element: ".vuetags",
      on: "bottom"
    },
    classes: "example-step-extra-class",
    buttons: [
      {
        classes: Qn,
        text: ir,
        action: e.prevStep
      },
      {
        classes: kr,
        text: Pr,
        action: e.nextStep
      }
    ]
  }), t.push({
    id: "step-featured",
    title: () => "Remove Boundary ",
    text: "Click Remove Boundary to clear the search boundaries.  You’ll then be able to search the visible map area, or draw a polygon to restrict the search boundaries.",
    attachTo: {
      element: "#mapRemove",
      on: "bottom"
    },
    classes: "example-step-extra-class",
    buttons: [
      {
        classes: Qn,
        text: ir,
        action: e.prevStep
      },
      {
        classes: kr,
        text: Pr,
        action: e.nextStep
      }
    ]
  }), t.push({
    id: "step-featured2",
    title: () => "Search Visible Map Area ",
    text: "Click Search This Area to search the visible map area.  If the button is visible but non-functioning, zoom in a little.",
    attachTo: {
      element: "#mapRemove",
      on: "bottom"
    },
    classes: "example-step-extra-class",
    buttons: [
      {
        classes: Qn,
        text: ir,
        action: e.prevStep
      },
      {
        classes: kr,
        text: Pr,
        action: e.nextStep
      }
    ]
  }), t.push({
    id: "step-draw",
    title: () => "Search Custom Map Area",
    text: "With a clear search area, select “Draw Boundary”.  Click the map to set the corners of your polygon.  Complete the polygon or double-click to set the area and search.",
    attachTo: {
      element: "#mapDraw",
      on: "bottom-end"
    },
    classes: "example-step-extra-class",
    buttons: [
      {
        classes: Qn,
        text: ir,
        action: e.prevStep
      },
      {
        classes: kr,
        text: Pr,
        action: e.nextStep
      }
    ]
  }), t.push({
    id: "step-filters",
    title: () => "Narrow Your Results",
    text: 'Use these filters to set your price, minimum beds/baths, home type, and more.  Each time you add a filter, results are filtered.  To remove filters, expand the "more" menu and click "Reset all Filters" at the bottom.',
    attachTo: {
      element: ".toolbar-filters",
      on: "bottom"
    },
    classes: "example-step-extra-class",
    buttons: [
      {
        classes: Qn,
        text: ir,
        action: e.prevStep
      },
      {
        classes: kr,
        text: Pr,
        action: e.nextStep
      }
    ]
  }), t.push({
    id: "step-financial",
    title: () => "Adjust the Financial Model",
    text: 'Expand this menu to customize the parameters our calculator uses to analyze properties for you.  Adjust settings such as interest rate, maintenance expenses, management fees, and more.  To save your parameters your default for future searches, click "Save Defaults" at the bottom.',
    attachTo: {
      element: ".dropdown-parameters",
      on: "bottom"
    },
    classes: "example-step-extra-class",
    buttons: [
      {
        classes: Qn,
        text: ir,
        action: e.prevStep
      },
      {
        classes: kr,
        text: Pr,
        action: e.nextStep
      }
    ]
  }), t.push({
    id: "step-sort",
    title: () => "Sort Your Results",
    text: "Use these controls to change the sort order of your search results.  Sort based on days on market, price, internal rate of return, or date modified.",
    attachTo: {
      element: "#tileSort",
      on: "bottom-end"
    },
    classes: "example-step-extra-class",
    buttons: [
      {
        classes: Qn,
        text: ir,
        action: e.prevStep
      },
      {
        classes: kr,
        text: Pr,
        action: e.nextStep
      }
    ]
  }), t.push({
    id: "step-kpi",
    title: () => "Search Result Stats",
    text: "These counters tell you the total number of active listings in the search area compared to the number of listings that match your filters.  If your filtered results are substantially lower than the total active listings, try loosening your filters to see more results.",
    attachTo: {
      element: ".results-listing-kpis",
      on: "bottom-start"
    },
    classes: "example-step-extra-class",
    buttons: [
      {
        classes: Qn,
        text: ir,
        action: e.prevStep
      },
      {
        classes: kr,
        text: Pr,
        action: e.nextStep
      }
    ]
  }), t.push({
    id: "step-save",
    title: () => "Save Your Search",
    text: "Once you’ve perfected your search, save it here.  You’ll be able to recall it the next time you visit Rescover, as well as receive email updates when new properties meet your criteria.",
    attachTo: {
      element: ".button-save",
      on: "bottom-end"
    },
    classes: "example-step-extra-class",
    buttons: [
      {
        classes: Qn,
        text: ir,
        action: e.prevStep
      },
      {
        classes: kr,
        text: Pr,
        action: e.nextStep
      }
    ]
  }), t.push({
    id: "step-saved",
    title: () => "Recall Your Search",
    text: "Use this drop down to recall your saved searches as well as a few pre-defined searches.  We’ve added a collection of featured and turn-key properties for you to browse.",
    attachTo: {
      element: ".toolbar-desktop .dropdown-searches",
      on: "bottom-start"
    },
    classes: "example-step-extra-class",
    buttons: [
      {
        classes: Qn,
        text: ir,
        action: e.prevStep
      },
      {
        classes: VS,
        text: FS,
        action: e.complete
      }
    ]
  }), t.push({
    id: "step-start",
    title: () => "Start Over",
    text: "Click this button to start over with a new search.",
    attachTo: {
      element: ".navbar-start",
      on: "bottom"
    },
    classes: "example-step-extra-class",
    buttons: [
      {
        classes: Qn,
        text: ir,
        action: e.prevStep
      },
      {
        classes: VS,
        text: FS,
        action: e.complete
      }
    ]
  }), t;
}
const Qp = {
  Featured: -1,
  AgentDefaultSearch: -2
}, pxt = /\/search\/saved\/(?<id>\d+)\/.*/i, DS = {
  fillColor: "#ffff00",
  fillOpacity: 0.2,
  strokeWeight: 2,
  clickable: !1,
  editable: !0,
  zIndex: 1
}, an = (e) => isNaN(e) ? void 0 : Math.trunc(e), hxt = me({
  name: "SearchAdv",
  directives: {
    resize: OE
  },
  enums: {
    MlsSortBy: cr
  },
  components: {
    ListingTile: Kb,
    Features: LE,
    Performance: BE,
    VueTagsAdv: MLt,
    Paginator: Vm,
    NumericalInput: Aa,
    Select: hl,
    Button: yI
  },
  props: {
    marketplaceView: Boolean,
    publicView: Boolean
  },
  data() {
    return {
      initializing: !0,
      navbarHeight: 0,
      footerHeight: 0,
      mainWidth: 0,
      headerHeight: 0,
      selectedSearch: void 0,
      newSearchName: void 0,
      newSearchNameAlert: void 0,
      renameSearch: !1,
      //#region Map
      listingsMapOptions: void 0,
      center: void 0,
      //#endregion
      //#region Zip
      zips: [],
      autocompleteItems: [],
      zipValidation: [
        {
          classes: "zip5-only",
          rule: /^([0-9]{5})$/,
          disableAdd: !0,
          autoAdd: !0
        }
      ],
      //#endregion
      searching: !1,
      noResults: !1,
      totalInArea: void 0,
      filtered: void 0,
      listings: [],
      firstRecord: 0,
      ActivePageSize: 50,
      view: Ta.Map,
      sort_by: cr.DoM,
      sort_asc: !0,
      searchParametersOrig: void 0,
      searchParameters: {
        minPrice: 0,
        maxPrice: 0,
        minSqft: 0,
        maxSqft: 0,
        minYearbuilt: 0,
        maxYearbuilt: 0,
        minBedrooms: 0,
        minBathrooms: 0,
        minGarage: 0,
        maxStories: 0,
        minFireplaces: 0,
        minLotSize: 0,
        maxLotSize: 0,
        pool: 0,
        elementaryRating: 0,
        intermediateRating: 0,
        jrHighRating: 0,
        highSchoolRating: 0
      },
      busyCount: 1,
      searchText: void 0,
      markers: [],
      mapBoundsChanged: !1,
      mapZoomChanged: !1,
      areaChanged: !1,
      includeListings: !0,
      currentZoom: 10,
      currentSquareMiles: 0,
      selectingListing: !1,
      selectedListingTag: void 0,
      currentlyDrawing: !1,
      selectedPolygon: null,
      debugMode: !1,
      saveCurrentSearch: !1,
      savedSearches: [],
      resetingParams: !0,
      locale: void 0,
      currentTourStep: void 0
    };
  },
  watch: {
    searchText: "zipAutoComplete",
    // Filter Parameters
    "searchParameters.maxInvestment": "resetIncludeListings",
    "searchParameters.minCapRate": "resetIncludeListings",
    "searchParameters.minCoC": "resetIncludeListings",
    "searchParameters.minIRR": "resetIncludeListings",
    "searchParameters.minBathrooms": "resetIncludeListings",
    "searchParameters.minBedrooms": "resetIncludeListings",
    "searchParameters.minPrice": "resetIncludeListings",
    "searchParameters.maxPrice": "resetIncludeListings",
    "searchParameters.minSqft": "resetIncludeListings",
    "searchParameters.maxSqft": "resetIncludeListings",
    "searchParameters.minYearbuilt": "resetIncludeListings",
    "searchParameters.maxYearbuilt": "resetIncludeListings",
    "searchParameters.jrHighRating": "resetIncludeListings",
    "searchParameters.highSchoolRating": "resetIncludeListings",
    "searchParameters.intermediateRating": "resetIncludeListings",
    "searchParameters.elementaryRating": "resetIncludeListings",
    "searchParameters.minGarage": "resetIncludeListings",
    "searchParameters.maxStories": "resetIncludeListings",
    "searchParameters.pool": "resetIncludeListings",
    "searchParameters.minFireplaces": "resetIncludeListings",
    "searchParameters.minLotSize": "resetIncludeListings",
    "searchParameters.maxLotSize": "resetIncludeListings",
    // Financial Parameters
    "searchParameters.annualExpenseGrowth": "resetIncludeListings",
    "searchParameters.annualRentalGrowth": "resetIncludeListings",
    "searchParameters.averageLengthOfStay": "resetIncludeListings",
    "searchParameters.costOfSale": "resetIncludeListings",
    "searchParameters.downpayment": "resetIncludeListings",
    "searchParameters.hold": "resetIncludeListings",
    "searchParameters.interestRate": "resetIncludeListings",
    "searchParameters.leaseCommission": "resetIncludeListings",
    "searchParameters.leaseRenewalFee": "resetIncludeListings",
    "searchParameters.loanFees": "resetIncludeListings",
    "searchParameters.amortizationPeriod": "resetIncludeListings",
    "searchParameters.maintenance": "resetIncludeListings",
    "searchParameters.managementFee": "resetIncludeListings",
    "searchParameters.propertyAppreciation": "resetIncludeListings",
    "searchParameters.timeBetweenTenants": "resetIncludeListings",
    "searchParameters.titleCharges": "resetIncludeListings",
    "searchParameters.percentageLongTermFields": "resetIncludeListings",
    "searchParameters.interestOnlyLoan": "resetIncludeListings",
    "searchParameters.interestOnlyTerm": "resetIncludeListings",
    "searchParameters.stabilizationReserve": "resetIncludeListings",
    "searchParameters.workingCapitalReserve": "resetIncludeListings",
    "searchParameters.utilityExpenses": "resetIncludeListings",
    "searchParameters.capitalExpenditures": "resetIncludeListings",
    "searchParameters.maxCashOutLoanLtv": "resetIncludeListings",
    // Other
    "searchParameters.blueChipOnly": "resetIncludeListings",
    "searchParameters.dwellingType": "resetIncludeListings",
    "searchParameters.includeLand": "resetIncludeListings",
    "searchParameters.byPurchasePrice": "resetIncludeListings",
    "searchParameters.daysOnRescover": "resetIncludeListings",
    "searchParameters.marketplaceOnly": "resetIncludeListings"
  },
  computed: {
    featuredSearch() {
      var e;
      return ((e = this.selectedSearch) == null ? void 0 : e.id) == Qp.Featured;
    },
    agentDefaultSearch() {
      var e;
      return ((e = this.selectedSearch) == null ? void 0 : e.id) == Qp.AgentDefaultSearch;
    },
    zipSelected() {
      return this.zips && this.zips.length > 0;
    },
    active() {
      return this.listings.filter((e) => e.isActive).sort(this.sortListing);
    },
    activePaged() {
      const e = this.firstRecord, t = e + this.ActivePageSize;
      return this.listings.filter((s) => s.isActive).sort(this.sortListing).slice(e, t);
    },
    blueChipTotal() {
      return this.listings.filter((e) => e.blueChip == !0).length;
    },
    savedSearchesSorted() {
      return this.savedSearches.sort((e, t) => {
        var s;
        return (s = e.name) == null ? void 0 : s.localeCompare(t.name, this.defaultLocale, { sensitivity: "base" });
      });
    },
    defaultLocale() {
      return this.locale ?? (this.locale = cP("en"));
    },
    viewTypeClasses() {
      return {
        showMap: this.view != Ta.Tile,
        "tile-view": this.view == Ta.Tile
      };
    },
    listingResultsClasses() {
      return document.body.classList.contains("has-navbar-vertical-aside") ? {
        "row-cols-1": this.view != Ta.Tile,
        "row-cols-xxl-2": this.view != Ta.Tile,
        "row-cols-md-2": this.view == Ta.Tile,
        "row-cols-lg-3": this.view == Ta.Tile,
        "row-cols-xl-4": this.view == Ta.Tile,
        "row-cols-jumbo-5": this.view == Ta.Tile,
        "row-cols-kilo-6": this.view == Ta.Tile
      } : {
        "row-cols-xl-2": this.view != Ta.Tile,
        "row-cols-md-2": this.view == Ta.Tile,
        "row-cols-lg-3": this.view == Ta.Tile,
        "row-cols-xl-4": this.view == Ta.Tile,
        "row-cols-jumbo-5": this.view == Ta.Tile,
        "row-cols-kilo-6": this.view == Ta.Tile
      };
    },
    askToUpdateSearchArea() {
      return (this.mapBoundSearch || this.polygonSearch && this.areaChanged) && (this.mapBoundsChanged || this.areaChanged || this.mapZoomChanged) || this.currentTourStep == 3;
    },
    askToRemoveBoundaries() {
      return (this.polygonSearch || this.areaSearch) && this.areaSizeOk && this.currentTourStep != 3;
    },
    areaSizeOk() {
      return this.currentSquareMiles <= 3e3 || this.searchParameters.marketplaceOnly && this.currentSquareMiles <= 76e5 || this.featuredSearch && this.currentSquareMiles <= 76e5;
    },
    canDraw() {
      return this.areaSizeOk;
    },
    mapBoundSearch() {
      return this.zips.length == 0 && this.selectedPolygon == null;
    },
    polygonSearch() {
      return this.selectedPolygon != null;
    },
    areaSearch() {
      return this.zips.length > 0;
    },
    yearRange() {
      const e = (/* @__PURE__ */ new Date()).getFullYear();
      return Array.from({ length: e - 1776 + 1 }, (t, s) => e - s);
    },
    appBusy() {
      return this.busyCount > 0;
    },
    shouldUpdateResults() {
      return (this.mapZoomChanged || this.areaChanged) && this.appBusy == !1 && (this.mapBoundSearch == !1 || this.selectingListing == !0);
    },
    typeHouse: {
      get() {
        return (this.searchParameters.dwellingType & 1) == 1;
      },
      set(e) {
        e ? this.searchParameters.dwellingType |= 1 : this.searchParameters.dwellingType &= -2;
      }
    },
    typeTownhouse: {
      get() {
        return (this.searchParameters.dwellingType & 2) == 2;
      },
      set(e) {
        e ? this.searchParameters.dwellingType |= 2 : this.searchParameters.dwellingType &= -3;
      }
    },
    typeMultiFamily: {
      get() {
        return (this.searchParameters.dwellingType & 4) == 4;
      },
      set(e) {
        e ? this.searchParameters.dwellingType |= 4 : this.searchParameters.dwellingType &= -5;
      }
    },
    typeCondo: {
      get() {
        return (this.searchParameters.dwellingType & 8) == 8;
      },
      set(e) {
        e ? this.searchParameters.dwellingType |= 8 : this.searchParameters.dwellingType &= -9;
      }
    },
    typeManufactured: {
      get() {
        return (this.searchParameters.dwellingType & 64) == 64;
      },
      set(e) {
        e ? this.searchParameters.dwellingType |= 64 : this.searchParameters.dwellingType &= -65;
      }
    },
    typeCommercialOther: {
      get() {
        return (this.searchParameters.dwellingType & 384) == 384;
      },
      set(e) {
        e ? this.searchParameters.dwellingType |= 384 : this.searchParameters.dwellingType &= -385;
      }
    },
    priceFilterLabel() {
      return this.searchParameters.minPrice > 0 && this.searchParameters.maxPrice > 0 ? `${ka(this.searchParameters.minPrice)}-${ka(this.searchParameters.maxPrice)}` : this.searchParameters.minPrice > 0 ? `${ka(this.searchParameters.minPrice)}+` : this.searchParameters.maxPrice > 0 ? `Up to ${ka(this.searchParameters.maxPrice)}` : "Price";
    },
    priceList() {
      return this.searchParameters.byPurchasePrice ? [
        25e3,
        5e4,
        1e5,
        15e4,
        2e5,
        25e4,
        3e5,
        35e4,
        4e5,
        45e4,
        5e5,
        55e4,
        6e5,
        65e4,
        7e5,
        75e4,
        8e5,
        85e4,
        9e5,
        95e4,
        1e6
      ] : [
        25e3,
        5e4,
        75e3,
        1e5,
        125e3,
        15e4,
        175e3,
        2e5,
        225e3,
        25e4
      ];
    },
    interestOnlyTerms() {
      return [3, 6, 9, 12, 18, 24, 36, 48, 60, 72, 84, 96, 108, 120];
    },
    amortizationPeriods() {
      return [...Array(30).keys()].map((n) => n + 1);
    },
    autoHoldPeriod: {
      get() {
        var e;
        return (((e = this.searchParameters) == null ? void 0 : e.hold) ?? 0) == 0;
      },
      set(e) {
        e ? this.searchParameters.hold = 0 : this.searchParameters.hold = this.searchParametersOrig.hold > 0 ? this.searchParametersOrig.hold : 15;
      }
    },
    //#region Perf Params formatting
    downpayment: {
      get() {
        return this.searchParameters.downpayment > 1 ? this.searchParameters.downpayment / 100 : this.searchParameters.downpayment;
      },
      set(e) {
        console.log("downpayment", e), e > 1 ? this.searchParameters.downpayment = e / 100 : this.searchParameters.downpayment = e;
      }
    },
    downpaymentWhole: {
      get() {
        return this.searchParameters.downpayment > 1 ? Math.round(this.searchParameters.downpayment) : Math.round(this.searchParameters.downpayment * 100);
      },
      set(e) {
        console.log("downpaymentWhole", e), isNaN(e) ? this.searchParameters.downpayment = this.searchParameters.downpayment + 1e-5 : this.searchParameters.downpayment = e / 100;
      }
    },
    interestrateWhole: {
      get() {
        return this.number(this.searchParameters.interestRate * 100, 2);
      },
      set(e) {
        Jo(e) == !1 ? (this.searchParameters.interestRate += 1e-5, this.searchParameters.interestRate -= 1e-5) : this.searchParameters.interestRate = vs(e) / 100;
      }
    },
    amortizationPeriod: {
      get() {
        return Math.trunc(this.searchParameters.amortizationPeriod);
      },
      set(e) {
        console.log("amortizationPeriod", e), isNaN(e) ? (this.searchParameters.amortizationPeriod += 1e-5, this.searchParameters.amortizationPeriod -= 1e-5) : this.searchParameters.amortizationPeriod = e;
      }
    },
    loanfeesWhole: {
      get() {
        return this.number(this.searchParameters.loanFees * 100, 1);
      },
      set(e) {
        Jo(e) == !1 ? (this.searchParameters.loanFees += 1e-5, this.searchParameters.loanFees -= 1e-5) : this.searchParameters.loanFees = vs(e) / 100;
      }
    },
    titlecharges: {
      get() {
        return this.number(this.searchParameters.titleCharges);
      },
      set(e) {
        Jo(e) == !1 ? (this.searchParameters.titleCharges += 1e-5, this.searchParameters.titleCharges -= 1e-5) : this.searchParameters.titleCharges = vs(e);
      }
    },
    timebetweentenants: {
      get() {
        return this.number(this.searchParameters.timeBetweenTenants);
      },
      set(e) {
        Jo(e) == !1 ? (this.searchParameters.timeBetweenTenants += 1e-5, this.searchParameters.timeBetweenTenants -= 1e-5) : this.searchParameters.timeBetweenTenants = vs(e);
      }
    },
    maintenanceWhole: {
      get() {
        return this.number(this.searchParameters.maintenance * 100, 1);
      },
      set(e) {
        Jo(e) == !1 ? (this.searchParameters.maintenance += 1e-5, this.searchParameters.maintenance -= 1e-5) : this.searchParameters.maintenance = vs(e) / 100;
      }
    },
    capitalExpendituresWhole: {
      get() {
        return this.number(this.searchParameters.capitalExpenditures * 100, 1);
      },
      set(e) {
        Jo(e) == !1 ? (this.searchParameters.capitalExpenditures += 1e-5, this.searchParameters.capitalExpenditures -= 1e-5) : this.searchParameters.capitalExpenditures = vs(e) / 100;
      }
    },
    leasecommissionWhole: {
      get() {
        return this.searchParameters.leaseCommission > 1 ? Math.round(this.searchParameters.leaseCommission) : Math.round(this.searchParameters.leaseCommission * 100);
      },
      set(e) {
        console.log("leasecommissionWhole", e), isNaN(e) ? (this.searchParameters.leaseCommission += 1e-5, this.searchParameters.leaseCommission -= 1e-5) : this.searchParameters.leaseCommission = e / 100;
      }
    },
    leaserenewalfeeWhole: {
      get() {
        return this.searchParameters.leaseRenewalFee > 1 ? Math.round(this.searchParameters.leaseRenewalFee) : Math.round(this.searchParameters.leaseRenewalFee * 100);
      },
      set(e) {
        console.log("leaserenewalfeeWhole", e), isNaN(e) ? (this.searchParameters.leaseRenewalFee += 1e-5, this.searchParameters.leaseRenewalFee -= 1e-5) : this.searchParameters.leaseRenewalFee = e / 100;
      }
    },
    costofsaleWhole: {
      get() {
        return this.number(this.searchParameters.costOfSale * 100, 1);
      },
      set(e) {
        Jo(e) == !1 ? (this.searchParameters.costOfSale += 1e-5, this.searchParameters.costOfSale -= 1e-5) : this.searchParameters.costOfSale = vs(e) / 100;
      }
    },
    annualRentalGrowth: {
      get() {
        return this.number(this.searchParameters.annualRentalGrowth * 100, 1);
      },
      set(e) {
        this.searchParameters.annualRentalGrowth = vs(e) / 100;
      }
    },
    annualExpenseGrowth: {
      get() {
        return this.number(this.searchParameters.annualExpenseGrowth * 100, 1);
      },
      set(e) {
        this.searchParameters.annualExpenseGrowth = vs(e) / 100;
      }
    },
    propertyAppreciation: {
      get() {
        return this.number(this.searchParameters.propertyAppreciation * 100, 1);
      },
      set(e) {
        this.searchParameters.propertyAppreciation = vs(e) / 100;
      }
    },
    //#endregion
    btnDrawingStyle() {
      return {
        busy: this.currentlyDrawing,
        disabled: this.canDraw == !1
      };
    },
    searchesLabel() {
      var e, t;
      return !this.agentDefaultSearch && ((e = this.selectedSearch) != null && e.name) ? (t = this.selectedSearch) == null ? void 0 : t.name : this.featuredSearch ? "Featured" : "Searches";
    },
    singleStoryOnly: {
      get() {
        return this.searchParameters.maxStories == 1;
      },
      set(e) {
        e ? this.searchParameters.maxStories = 1 : this.searchParameters.maxStories = void 0;
      }
    },
    /** App is NOT busy AND NOT searching AND NOT a system search */
    canSave() {
      return this.appBusy == !1 && this.searching == !1;
    },
    /** Can save AND valid new search name */
    canCreate() {
      return this.canSave && this.validNewSearchName;
    },
    /** Search id is 0 or null. */
    shouldCreateSearch() {
      var e;
      return !((((e = this.selectedSearch) == null ? void 0 : e.id) ?? 0) > 0);
    },
    //btnSaveSearchLabel(): string {
    //    if (this.shouldCreateSearch)
    //        return 'Create Saved Search';
    //    return 'Update Saved Search';
    //},
    btnSaveSearchStyle() {
      return {
        btn: !0,
        "btn-eclipse": !0,
        "flex-fill": this.shouldCreateSearch,
        busy: this.currentlyDrawing,
        disabled: this.canSave == !1
      };
    },
    /** New Search Name is greater than 3 char and not null */
    validNewSearchName() {
      var e;
      return (((e = this.newSearchName) == null ? void 0 : e.length) ?? 0) >= 3;
    },
    btnSaveSearchModelLabel() {
      return this.renameSearch == !0 ? "Rename Search" : "Save New Search";
    },
    subscribeChecked() {
      var e;
      if (((e = this.selectedSearch) == null ? void 0 : e.id) > 0 && this.savedSearches.length > 0) {
        const t = this.savedSearches.find((s) => {
          var n;
          return s.id == ((n = this.selectedSearch) == null ? void 0 : n.id);
        });
        return (t == null ? void 0 : t.subscribed) == !0;
      }
      return !1;
    },
    minCapRate: {
      get() {
        return gh(this.searchParameters.minCapRate) ? "-" : this.number(this.searchParameters.minCapRate * 100, 2);
      },
      set(e) {
        console.log("minCapRate", e), e == "-" ? this.searchParameters.minCapRate = -0 : this.searchParameters.minCapRate = vs(e) / 100;
      }
    },
    minCoC: {
      get() {
        return gh(this.searchParameters.minCoC) ? "-" : this.number(this.searchParameters.minCoC * 100, 2);
      },
      set(e) {
        console.log("minCoC", e), e == "-" ? this.searchParameters.minCoC = -0 : this.searchParameters.minCoC = vs(e) / 100;
      }
    },
    minIRR: {
      get() {
        return gh(this.searchParameters.minIRR) ? "-" : this.number(this.searchParameters.minIRR * 100, 2);
      },
      set(e) {
        console.log("minIRR", e), e == "-" ? this.searchParameters.minIRR = -0 : this.searchParameters.minIRR = vs(e) / 100;
      }
    },
    capRateActive: {
      set(e) {
        e ? this.searchParameters.blueChipFilters |= Va.CapRate : this.searchParameters.blueChipFilters &= -2;
      },
      get() {
        return is(this.searchParameters.blueChipFilters, Va.CapRate);
      }
    },
    cocActive: {
      set(e) {
        e ? this.searchParameters.blueChipFilters |= Va.CashOnCash : this.searchParameters.blueChipFilters &= -3;
      },
      get() {
        return is(this.searchParameters.blueChipFilters, Va.CashOnCash);
      }
    },
    cocAfterTaxActive: {
      set(e) {
        e ? this.searchParameters.blueChipFilters |= Va.CashOnCashAfterTax : this.searchParameters.blueChipFilters &= -9;
      },
      get() {
        return is(this.searchParameters.blueChipFilters, Va.CashOnCashAfterTax);
      }
    },
    irrActive: {
      set(e) {
        e ? this.searchParameters.blueChipFilters |= Va.IRR : this.searchParameters.blueChipFilters &= -5;
      },
      get() {
        return is(this.searchParameters.blueChipFilters, Va.IRR);
      }
    },
    irrAfterTaxActive: {
      set(e) {
        e ? this.searchParameters.blueChipFilters |= Va.IRRAfterTax : this.searchParameters.blueChipFilters &= -17;
      },
      get() {
        return is(this.searchParameters.blueChipFilters, Va.IRRAfterTax);
      }
    },
    isManagementFeePercent: {
      get() {
        return (this.searchParameters.percentageLongTermFields & U.PropertyManagement) == U.PropertyManagement;
      },
      set(e) {
        e ? this.searchParameters.percentageLongTermFields |= U.PropertyManagement : this.searchParameters.percentageLongTermFields &= ~U.PropertyManagement;
      }
    },
    tooltipInfo() {
      return `Displaying ${this.number(this.blueChipTotal)} Blue chip properties of ${this.number(this.filtered)} filtered properties out of ${this.number(this.totalInArea)} total listings.`;
    },
    ...q(Te, ["aclLoaded", "acl", "isClient", "isAdmin", "isUser"]),
    ...q(il, ["mlsSearchCache"]),
    ...at(il)
  },
  methods: {
    number: Ve,
    percent: Wt,
    currency: Ze,
    zipsChanged(e) {
      this.autocompleteItems.length = 0;
    },
    zipAutoComplete() {
      var e;
      ((e = this.searchText) == null ? void 0 : e.length) < 2 || (clearTimeout(this.debounce), this.debounce = setTimeout(async () => {
        var t;
        try {
          if (((t = this.searchText) == null ? void 0 : t.length) < 2)
            return;
          this.autocompleteItems.length = 0;
          const s = await W.api.geo.zipLookup(this.searchText);
          if (s.data.status != de.Success)
            throw new Error(s.data.message);
          this.autocompleteItems.push(...s.data.result.map((n) => ({
            text: n
          })));
        } catch (s) {
          Se(s);
        }
      }, 600));
    },
    async tagDeleted(e) {
      var t;
      if (this.busyCount++, e != null && e.tag) {
        const s = this.map.data.getFeatureById(`${(t = e.tag) == null ? void 0 : t.text}`);
        s && this.map.data.remove(s), e.deleteTag();
      }
      this.zips.length == 0 && (this.searchBounds = this.map.getBounds()), this.mapBoundsChanged = !0, this.areaChanged = !0, this.includeListings = !0, this.busyCount--, this.shouldUpdateResults && await this.searchProperties();
    },
    async tagAdding(e) {
      var s;
      this.busyCount++, this.mapAreaClear(), ((s = this.selectedSearch) == null ? void 0 : s.id) < 0 && !this.initializing && (this.selectedSearch = void 0);
      const t = await W.api.geo.zipInfo([e.tag.text]);
      t.data.status == de.Success && (t.data.result.forEach(this.addMapArea), e.addTag(), this.areaChanged = !0), this.resetIncludeListings(), this.busyCount--, this.shouldUpdateResults && await this.searchProperties();
    },
    //#region Save Searches
    async saveSearch() {
      try {
        if (this.newSearchNameAlert = void 0, this.shouldCreateSearch || this.validNewSearchName)
          if (this.newSearchName) {
            const e = this.savedSearches.find((t) => {
              var s;
              return ((s = t.name) == null ? void 0 : s.localeCompare(this.newSearchName)) === 0;
            });
            if (e && (this.newSearchNameAlert = `Search with name '${e.name}' already exists. Please use a unique name to save the search as.`), this.validNewSearchName || (this.newSearchNameAlert = "Name of saved search must be at least 3 characters."), this.newSearchNameAlert)
              return;
            this.saveCurrentSearch = !0, await this.searchProperties();
          } else
            bootstrap.Modal.getOrCreateInstance(this.$refs.saveSearch).show();
        else
          this.saveCurrentSearch = !0, await this.searchProperties();
      } catch (e) {
        Se(e);
      } finally {
        this.newSearchNameAlert || bootstrap.Modal.getOrCreateInstance(this.$refs.saveSearch).hide();
      }
    },
    saveSearchAs(e) {
      var t;
      this.renameSearch = e, this.newSearchNameAlert = void 0, this.newSearchName = (t = this.selectedSearch) == null ? void 0 : t.name, bootstrap.Modal.getOrCreateInstance(this.$refs.saveSearch).show();
    },
    async deleteSavedSearch() {
      try {
        if ((this.selectedSearch.id ?? 0) <= 0)
          return;
        await W.api.searchMls.deleteSavedSearch(this.selectedSearch.id), this.savedSearches = this.savedSearches.filter((e) => e.id != this.selectedSearch.id), await this.freshSearch();
      } catch (e) {
        Se(e);
      }
    },
    //#endregion
    onPageActive(e) {
      this.ActivePageSize = e.rows;
    },
    handleResize() {
      const e = document.documentElement.clientHeight, t = $("#navbar").outerHeight(), s = $("#resultListingHeader").outerHeight();
      let n = 0;
      $("footer").css("display") == "none" || $("footer").css("visibility") == "hidden" || $("footer").length === 0 ? n = 0 : n = $("footer").outerHeight();
      const r = e - t - s - n + 1, i = $(".searchOptions").outerHeight(), o = r - i;
      if ($(".map, .results-listing").css("height", r + "px").css("top", s + "px"), $("#searchUpdate").css("height", o + "px"), $(".results-listing-container").css("height", o + "px"), $("#listingResults").css("top", t + "px"), document.body.classList.contains("has-navbar-vertical-aside")) {
        const l = $("header").outerWidth();
        $("main").outerWidth();
        const d = $("#resultHeader").outerHeight();
        let c = $("aside").outerWidth();
        document.body.classList.contains("navbar-vertical-aside-closed-mode") || $("#listingResults").css("margin-left", c + "px"), $(".results-listing-container").css("height", o + "px").css("top", d), $("#listingResults").css("width", l + "px");
      }
    },
    sortButtonClass(e) {
      return {
        selected: this.sort_by == e,
        asc: this.sort_by == e && this.sort_asc,
        des: this.sort_by == e && !this.sort_asc
      };
    },
    sortIconClass(e) {
      return {
        "fa-sort-amount-down-alt me-2": this.sort_by == e && this.sort_asc,
        "fa-sort-amount-down me-2": this.sort_by == e && !this.sort_asc
      };
    },
    resetIncludeListings() {
      this.includeListings = !0;
    },
    applyMarkerSelection() {
      const e = document.getElementById(`marker-prop-${this.selectedListingTag}`);
      e == null || e.classList.add("selected");
    },
    //#region Map
    mapInit() {
      this.center = {
        lat: 30.173937,
        lng: -95.505836
      }, this.listingsMapOptions = {
        zoom: this.currentZoom,
        disableDefaultUI: !0,
        streetViewControl: !0,
        streetViewControlOptions: {
          position: google.maps.ControlPosition.LEFT_BOTTOM
        },
        isFractionalZoomEnabled: !1
      }, this.map = this.$refs.gMap.$mapObject, this.map.data.addListener("addfeature", this.updateMapBounds), this.map.data.addListener("removefeature", this.updateMapBounds), this.map.data.setStyle((e) => {
        let t = "black", s = 3;
        switch (e.getProperty("type")) {
          case "clusterBound":
            t = "#0c78b4", s = 3;
            break;
          case "zip":
            t = "#592693";
            break;
        }
        return {
          strokeColor: t,
          strokeWeight: s,
          fillOpacity: 0
        };
      }), this.drawingManager = new google.maps.drawing.DrawingManager({
        map: this.map,
        drawingMode: null,
        drawingControl: !1,
        drawingControlOptions: {
          position: google.maps.ControlPosition.TOP_CENTER,
          drawingModes: [
            google.maps.drawing.OverlayType.POLYGON
          ]
        },
        polygonOptions: DS
      }), this.drawingManager.addListener("polygoncomplete", this.mapAreaSelected);
    },
    onMapClick(e) {
      console.log(`${this.$options.name}.onMapClick`);
    },
    async onMapBoundsChanged(e, t) {
      console.log(`${this.$options.name}.onMapBoundsChanged`, this.mapBoundSearch), this.currentSquareMiles = Math.trunc(google.maps.geometry.spherical.computeArea(e) * 3861e-10);
    },
    async onMapDragEnd() {
      this.mapBoundSearch && (this.mapBoundsChanged = !0);
    },
    async onMapZoomChanged(e) {
      this.mapZoomChanged = this.currentZoom != e, this.currentZoom = e;
    },
    async onMapIdle() {
      this.shouldUpdateResults && (this.mapZoomChanged = !1, await this.searchProperties()), this.selectingListing = !1, this.applyMarkerSelection();
    },
    onPanoVisibleChanged(e) {
      console.log(`${this.$options.name}.onPanoVisibleChanged`, e);
      let t = 2;
      e.getVisible() ? (t = 0, $(".tiles").css({
        "z-index": 3
        // 'height': (listHeight - 180) + 'px'
      })) : $(".tiles").css({
        "z-index": 2
        // 'height': (listHeight) + 'px'
      }), $("#showResults").css("z-index", t);
    },
    viewListing(e) {
      e.queryString ? window.open(e.url + e.queryString + "&search=1", `_${e.id}`) : window.open(e.url, `_${e.id}`);
    },
    selectListing(e) {
      this.viewListing(e), this.selectingListing = !0;
      const t = {
        lat: e.latitude,
        lng: e.longitude
      };
      if (this.map) {
        this.map.panTo(t), this.currentZoom < 15 && this.map.setZoom(17), this.map.panBy(0, 0);
        const s = document.getElementsByClassName("price-tag selected");
        for (let n = 0; n < s.length; n++)
          s.item(n).classList.remove("selected");
        this.selectedListingTag = e.id;
      }
    },
    propMarkerSelected(e, t) {
      const s = this.markers.find((r) => r.id == t), n = document.getElementById(`marker-prop-${this.selectedListingTag}`);
      if (n == null || n.classList.remove("selected"), s) {
        const r = this.listings.findIndex((i) => i.id == s.item.id);
        if (r >= 0)
          if (this.selectedListingTag != s.item.id) {
            this.selectedListingTag = s.item.id, this.applyMarkerSelection();
            const i = Math.ceil((r + 1) / this.ActivePageSize);
            this.firstRecord = (i - 1) * this.ActivePageSize, this.$nextTick(() => {
              const o = document.getElementById(`${s.item.id}`);
              o && o.scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" });
            });
          } else {
            const i = this.active[r];
            window.open(i.url, `_${i.id}`);
          }
      }
    },
    clusterMarkerSelected(e, t) {
      const s = this.markers.find((n) => n.id == t);
      if (s) {
        const n = new google.maps.LatLngBounds();
        En.parseGeoJsonDataGeometry(s.item.points).forEachLatLng((r) => n.extend(r)), n.isEmpty() == !1 && this.map.fitBounds(n, 1);
      }
    },
    //#region Map Controls
    zoomOut() {
      const e = this.map.getZoom();
      this.map.setZoom(e - 1);
    },
    zoomIn() {
      const e = this.map.getZoom();
      this.map.setZoom(e + 1);
    },
    mapController(e) {
      switch (e.target.dataset.type) {
        /* Temporarily disabled
        case "sateliteView":
            map.setMapTypeId('satellite');
            map.setTilt(45);
            //el.addClass('hidden');
            (this.$refs.sateliteView as HTMLButtonElement).classList.add('hidden');
            //$('a[href="mapview"]').removeClass('hidden');
            (this.$refs.mapView as HTMLButtonElement).classList.remove('hidden');
            //determine if 45 degree angle and show rotate button
            this.isTilted = map.getTilt() !== 0;
            break;
        case "rotateView":
            let heading = map.getHeading() || 0;
            map.setHeading(heading + 90);
            break;
        */
        case "mapView":
          this.map.setMapTypeId("roadmap"), this.$refs.mapView.classList.add("hidden"), this.$refs.sateliteView.classList.remove("hidden");
          break;
      }
      return !1;
    },
    //#endregion
    mapAreaClear() {
      this.selectedPolygon && (jr(this.selectedPolygon).setMap(null), this.selectedPolygon = void 0, this.areaChanged = !0);
    },
    async mapAreaSelected(e) {
      this.currentlyDrawing = !1, this.clearAreas(), this.selectedPolygon = e, this.selectedPolygon.getPath().addListener("insert_at", this.mapAreaEdited), this.selectedPolygon.getPath().addListener("remove_at", this.mapAreaEdited), this.selectedPolygon.getPath().addListener("set_at", this.mapAreaEdited), this.drawingManager.setDrawingMode(null), this.areaChanged = !0, this.resetIncludeListings(), await this.searchProperties();
    },
    mapAreaEdited(e) {
      this.areaChanged = !0;
    },
    clusterHoverEnter(e) {
      const t = this.markers.find((s) => s.id == e);
      if (t) {
        const s = En.parseGeoJsonDataGeometry(t.item.points);
        this.map.data.add({
          geometry: s,
          id: "clusterBound",
          properties: {
            type: "clusterBound"
          }
        });
      }
    },
    clusterHoverLeave() {
      const e = this.map.data.getFeatureById("clusterBound");
      e && this.map.data.remove(e);
    },
    //#endregion
    async searchProperties(e) {
      var s, n, r, i, o, l, d, c, u, m, f, v, b, w;
      const t = this.searchParameters;
      if (e && ((s = bootstrap.Dropdown.getInstance(e)) == null || s.hide()), this.currentZoom != 0) {
        this.firstRecord = 0, this.mapZoomChanged = !1, this.mapBoundsChanged = !1, this.areaChanged = !1, this.selectingListing = !1, this.totalInArea = void 0, this.filtered = void 0, this.busyCount++, this.searching = !0;
        try {
          !t.dwellingType & this.searchParameters.dwellingType && (t.dwellingType = this.searchParameters.dwellingType), (t.dwellingType || (n = this.searchParametersOrig) != null && n.dwellingType) && (t.dwellingType |= 2048), (r = this.searchParameters) != null && r.dwellingType && (this.searchParameters.dwellingType &= -3, this.searchParameters.dwellingType &= -9, this.searchParameters.dwellingType &= -17, this.searchParameters.dwellingType &= -33, this.searchParameters.dwellingType &= -65), (t.dwellingType || (i = this.searchParameters) != null && i.dwellingType || !t.dwellingType && t.includeLand) && (t.dwellingType &= -3, t.dwellingType &= -9, t.dwellingType &= -17, t.dwellingType &= -33, t.dwellingType &= -65), this.handleResize();
          const S = this.shouldCreateSearch || this.validNewSearchName;
          let I;
          if (this.featuredSearch) {
            let C = "";
            this.searchBounds ?? (this.searchBounds = new google.maps.LatLngBounds(De.Map.UsBounds));
            const O = this.searchBounds.getNorthEast(), E = this.searchBounds.getSouthWest();
            C += `${O.lat()},${E.lng()};`, C += `${O.lat()},${O.lng()};`, C += `${E.lat()},${O.lng()};`, C += `${E.lat()},${E.lng()}`, I = await W.api.searchMls.areaSearchFeatured(
              C,
              this.currentZoom,
              t.minPrice,
              t.maxPrice,
              t.minBedrooms,
              t.minBathrooms,
              t.minSqft,
              t.maxSqft,
              t.minLotSize,
              t.maxLotSize,
              t.minYearbuilt,
              t.maxYearbuilt,
              t.maxStories,
              t.dwellingType,
              t.blueChipOnly,
              t.byPurchasePrice,
              t.daysOnRescover,
              t.includeLand,
              t.marketplaceOnly,
              void 0,
              // Tenant Occupied
              t.publicMlsOnly,
              t.downpayment,
              t.interestRate,
              an(t.amortizationPeriod),
              t.loanFees,
              t.interestOnlyLoan,
              an(t.interestOnlyTerm),
              an(t.titleCharges),
              t.averageLengthOfStay,
              an(t.timeBetweenTenants),
              t.costOfSale,
              t.annualRentalGrowth,
              t.annualExpenseGrowth,
              t.propertyAppreciation,
              t.stabilizationReserve,
              t.minCapRate,
              t.minCoC,
              t.minCoCAfterTax,
              t.minIRR,
              t.minIRRAfterTax,
              t.hold,
              t.blueChipFilters,
              t.percentageLongTermFields,
              t.managementFee,
              t.leaseCommission,
              t.leaseRenewalFee,
              t.platformServiceFees,
              t.maintenance,
              t.utilityExpenses,
              t.furnishingExpenses,
              t.consumableExpenses,
              t.cleaningExpenses,
              t.otherExpense,
              t.capitalExpenditures,
              void 0,
              //subset.otherIncome,
              t.percentageShortTermFields,
              t.strManagementFee,
              t.strLeaseCommission,
              t.strLeaseRenewalFee,
              t.strPlatformServiceFees,
              t.strMaintenance,
              t.strUtilityExpenses,
              t.strFurnishingExpenses,
              t.strConsumableExpenses,
              t.strCleaningExpenses,
              t.strOtherExpense,
              t.strCapitalExpenditures,
              void 0,
              //subset.strOtherIncome,
              t.strWorkingCapitalReserve,
              t.strDaysOccupiedPerYear,
              t.strDaysAvailablePerYear,
              t.strAnnualRentalGrowth,
              t.strAnnualExpenseGrowth,
              t.strPropertyAppreciation,
              t.percentagePadSplitFields,
              t.padSplitWorkingCapitalReserve,
              t.padSplitAnnualVacancyRate,
              t.padSplitMaintenance,
              t.padSplitFurnishingExpenses,
              t.padSplitConsumableExpenses,
              t.padSplitUtilityExpenses,
              t.padSplitCleaningExpenses,
              void 0,
              // subset.padSplitPlatformServiceFees,
              t.padSplitManagementFee,
              t.padSplitAnnualRentalGrowth,
              t.padSplitAnnualExpenseGrowth,
              t.padSplitPropertyAppreciation,
              void 0,
              // subset.padSplitOtherExpensePercentage, 
              void 0,
              // subset.padSplitLeaseCommission,
              void 0,
              // subset.padSplitLeaseRenewalFee, 
              t.padSplitOtherExpense,
              t.padSplitCapitalExpenditures,
              void 0,
              // subset.padSplitOtherIncome, 
              t.padSplitBookingFeeDays,
              t.padSplitAverageLengthOfStay,
              void 0,
              // subset.otherExpensesLongTerm,
              void 0,
              // subset.otherExpensesShortTerm,
              void 0,
              // subset.otherExpensesPadSplit,
              void 0,
              // subset.otherIncomesLongTerm,
              void 0,
              // subset.otherIncomesShortTerm,
              void 0,
              // subset.otherIncomesPadSplit,
              S || this.renameSearch ? this.newSearchName ?? ((o = this.selectedSearch) == null ? void 0 : o.name) : void 0,
              S && !this.renameSearch || (l = this.selectedSearch) == null ? void 0 : l.id,
              this.includeListings == !1 ? void 0 : this.includeListings,
              this.saveCurrentSearch == !1 ? void 0 : this.saveCurrentSearch,
              this.mapBoundSearch == !1 ? void 0 : this.mapBoundSearch,
              this.mlsSearchCache,
              Dc
            );
          } else if (this.zips.length > 0)
            I = await W.api.searchMls.scopedSearch(
              this.zips.map((C) => C.text),
              this.currentZoom,
              t.minPrice,
              t.maxPrice,
              t.minBedrooms,
              t.minBathrooms,
              t.minSqft,
              t.maxSqft,
              t.minLotSize,
              t.maxLotSize,
              t.minYearbuilt,
              t.maxYearbuilt,
              t.maxStories,
              t.dwellingType,
              t.blueChipOnly,
              t.byPurchasePrice,
              t.daysOnRescover,
              t.includeLand,
              t.marketplaceOnly,
              void 0,
              // Tenant Occupied
              t.publicMlsOnly,
              t.downpayment,
              t.interestRate,
              an(t.amortizationPeriod),
              t.loanFees,
              t.interestOnlyLoan,
              an(t.interestOnlyTerm),
              an(t.titleCharges),
              t.averageLengthOfStay,
              an(t.timeBetweenTenants),
              t.costOfSale,
              t.annualRentalGrowth,
              t.annualExpenseGrowth,
              t.propertyAppreciation,
              t.stabilizationReserve,
              t.minCapRate,
              t.minCoC,
              t.minCoCAfterTax,
              t.minIRR,
              t.minIRRAfterTax,
              t.hold,
              t.blueChipFilters,
              t.percentageLongTermFields,
              t.managementFee,
              t.leaseCommission,
              t.leaseRenewalFee,
              t.platformServiceFees,
              t.maintenance,
              t.utilityExpenses,
              t.furnishingExpenses,
              t.consumableExpenses,
              t.cleaningExpenses,
              t.otherExpense,
              t.capitalExpenditures,
              void 0,
              //subset.otherIncome,
              t.percentageShortTermFields,
              t.strManagementFee,
              t.strLeaseCommission,
              t.strLeaseRenewalFee,
              t.strPlatformServiceFees,
              t.strMaintenance,
              t.strUtilityExpenses,
              t.strFurnishingExpenses,
              t.strConsumableExpenses,
              t.strCleaningExpenses,
              t.strOtherExpense,
              t.strCapitalExpenditures,
              void 0,
              //subset.strOtherIncome,
              t.strWorkingCapitalReserve,
              t.strDaysOccupiedPerYear,
              t.strDaysAvailablePerYear,
              t.strAnnualRentalGrowth,
              t.strAnnualExpenseGrowth,
              t.strPropertyAppreciation,
              t.percentagePadSplitFields,
              t.padSplitWorkingCapitalReserve,
              t.padSplitAnnualVacancyRate,
              t.padSplitMaintenance,
              t.padSplitFurnishingExpenses,
              t.padSplitConsumableExpenses,
              t.padSplitUtilityExpenses,
              t.padSplitCleaningExpenses,
              void 0,
              // subset.padSplitPlatformServiceFees,
              t.padSplitManagementFee,
              t.padSplitAnnualRentalGrowth,
              t.padSplitAnnualExpenseGrowth,
              t.padSplitPropertyAppreciation,
              void 0,
              // subset.padSplitOtherExpensePercentage, 
              void 0,
              // subset.padSplitLeaseCommission,
              void 0,
              // subset.padSplitLeaseRenewalFee, 
              t.padSplitOtherExpense,
              t.padSplitCapitalExpenditures,
              void 0,
              // subset.padSplitOtherIncome, 
              t.padSplitBookingFeeDays,
              t.padSplitAverageLengthOfStay,
              void 0,
              // subset.otherExpensesLongTerm,
              void 0,
              // subset.otherExpensesShortTerm,
              void 0,
              // subset.otherExpensesPadSplit,
              void 0,
              // subset.otherIncomesLongTerm,
              void 0,
              // subset.otherIncomesShortTerm,
              void 0,
              // subset.otherIncomesPadSplit,
              S || this.renameSearch ? this.newSearchName ?? ((d = this.selectedSearch) == null ? void 0 : d.name) : void 0,
              S && !this.renameSearch || (c = this.selectedSearch) == null ? void 0 : c.id,
              this.includeListings == !1 ? void 0 : this.includeListings,
              this.saveCurrentSearch == !1 ? void 0 : this.saveCurrentSearch,
              this.mlsSearchCache,
              Dc
            );
          else {
            let C = "";
            if (this.selectedPolygon)
              this.selectedPolygon.getPath().forEach(function(O) {
                C += `${O.lat()},${O.lng()};`;
              });
            else {
              this.searchBounds ?? (this.searchBounds = new google.maps.LatLngBounds(De.Map.UsBounds));
              const O = this.searchBounds.getNorthEast(), E = this.searchBounds.getSouthWest();
              C += `${O.lat()},${E.lng()};`, C += `${O.lat()},${O.lng()};`, C += `${E.lat()},${O.lng()};`, C += `${E.lat()},${E.lng()}`;
            }
            this.saveCurrentSearch ? (I = await W.api.searchMls.saveAreaSearch(
              C,
              this.currentZoom,
              t.minPrice,
              t.maxPrice,
              t.minBedrooms,
              t.minBathrooms,
              t.minSqft,
              t.maxSqft,
              t.minLotSize,
              t.maxLotSize,
              t.minYearbuilt,
              t.maxYearbuilt,
              t.maxStories,
              t.dwellingType,
              t.blueChipOnly,
              t.byPurchasePrice,
              t.daysOnRescover,
              t.includeLand,
              t.marketplaceOnly,
              void 0,
              // Tenant Occupied
              t.publicMlsOnly,
              t.downpayment,
              t.interestRate,
              an(t.amortizationPeriod),
              t.loanFees,
              t.interestOnlyLoan,
              an(t.interestOnlyTerm),
              an(t.titleCharges),
              t.averageLengthOfStay,
              an(t.timeBetweenTenants),
              t.costOfSale,
              t.annualRentalGrowth,
              t.annualExpenseGrowth,
              t.propertyAppreciation,
              t.stabilizationReserve,
              t.minCapRate,
              t.minCoC,
              t.minCoCAfterTax,
              t.minIRR,
              t.minIRRAfterTax,
              t.hold,
              t.blueChipFilters,
              t.percentageLongTermFields,
              t.managementFee,
              t.leaseCommission,
              t.leaseRenewalFee,
              t.platformServiceFees,
              t.maintenance,
              t.utilityExpenses,
              t.furnishingExpenses,
              t.consumableExpenses,
              t.cleaningExpenses,
              t.otherExpense,
              t.capitalExpenditures,
              void 0,
              //subset.otherIncome,
              t.percentageShortTermFields,
              t.strManagementFee,
              t.strLeaseCommission,
              t.strLeaseRenewalFee,
              t.strPlatformServiceFees,
              t.strMaintenance,
              t.strUtilityExpenses,
              t.strFurnishingExpenses,
              t.strConsumableExpenses,
              t.strCleaningExpenses,
              t.strOtherExpense,
              t.strCapitalExpenditures,
              void 0,
              //subset.strOtherIncome,
              t.strWorkingCapitalReserve,
              t.strDaysOccupiedPerYear,
              t.strDaysAvailablePerYear,
              t.strAnnualRentalGrowth,
              t.strAnnualExpenseGrowth,
              t.strPropertyAppreciation,
              t.percentagePadSplitFields,
              t.padSplitWorkingCapitalReserve,
              t.padSplitAnnualVacancyRate,
              t.padSplitMaintenance,
              t.padSplitFurnishingExpenses,
              t.padSplitConsumableExpenses,
              t.padSplitUtilityExpenses,
              t.padSplitCleaningExpenses,
              void 0,
              // subset.padSplitPlatformServiceFees,
              t.padSplitManagementFee,
              t.padSplitAnnualRentalGrowth,
              t.padSplitAnnualExpenseGrowth,
              t.padSplitPropertyAppreciation,
              void 0,
              // subset.padSplitOtherExpensePercentage, 
              void 0,
              // subset.padSplitLeaseCommission,
              void 0,
              // subset.padSplitLeaseRenewalFee, 
              t.padSplitOtherExpense,
              t.padSplitCapitalExpenditures,
              void 0,
              // subset.padSplitOtherIncome, 
              t.padSplitBookingFeeDays,
              t.padSplitAverageLengthOfStay,
              void 0,
              // subset.otherExpensesLongTerm,
              void 0,
              // subset.otherExpensesShortTerm,
              void 0,
              // subset.otherExpensesPadSplit,
              void 0,
              // subset.otherIncomesLongTerm,
              void 0,
              // subset.otherIncomesShortTerm,
              void 0,
              // subset.otherIncomesPadSplit,
              S || this.renameSearch ? this.newSearchName ?? ((u = this.selectedSearch) == null ? void 0 : u.name) : void 0,
              S && !this.renameSearch || (m = this.selectedSearch) == null ? void 0 : m.id,
              this.includeListings == !1 ? void 0 : this.includeListings,
              this.mapBoundSearch == !1 ? void 0 : this.mapBoundSearch,
              this.mlsSearchCache,
              Dc
            ), this.cacheStore.incrementMlsSearchCache()) : I = await W.api.searchMls.areaSearch(
              C,
              this.currentZoom,
              t.minPrice,
              t.maxPrice,
              t.minBedrooms,
              t.minBathrooms,
              t.minSqft,
              t.maxSqft,
              t.minLotSize,
              t.maxLotSize,
              t.minYearbuilt,
              t.maxYearbuilt,
              t.maxStories,
              t.dwellingType,
              t.blueChipOnly,
              t.byPurchasePrice,
              t.daysOnRescover,
              t.includeLand,
              t.marketplaceOnly,
              void 0,
              // Tenant Occupied
              t.publicMlsOnly,
              t.downpayment,
              t.interestRate,
              an(t.amortizationPeriod),
              t.loanFees,
              t.interestOnlyLoan,
              an(t.interestOnlyTerm),
              an(t.titleCharges),
              t.averageLengthOfStay,
              an(t.timeBetweenTenants),
              t.costOfSale,
              t.annualRentalGrowth,
              t.annualExpenseGrowth,
              t.propertyAppreciation,
              t.stabilizationReserve,
              t.minCapRate,
              t.minCoC,
              t.minCoCAfterTax,
              t.minIRR,
              t.minIRRAfterTax,
              t.hold,
              t.blueChipFilters,
              t.percentageLongTermFields,
              t.managementFee,
              t.leaseCommission,
              t.leaseRenewalFee,
              t.platformServiceFees,
              t.maintenance,
              t.utilityExpenses,
              t.furnishingExpenses,
              t.consumableExpenses,
              t.cleaningExpenses,
              t.otherExpense,
              t.capitalExpenditures,
              void 0,
              //subset.otherIncome,
              t.percentageShortTermFields,
              t.strManagementFee,
              t.strLeaseCommission,
              t.strLeaseRenewalFee,
              t.strPlatformServiceFees,
              t.strMaintenance,
              t.strUtilityExpenses,
              t.strFurnishingExpenses,
              t.strConsumableExpenses,
              t.strCleaningExpenses,
              t.strOtherExpense,
              t.strCapitalExpenditures,
              void 0,
              //subset.strOtherIncome,
              t.strWorkingCapitalReserve,
              t.strDaysOccupiedPerYear,
              t.strDaysAvailablePerYear,
              t.strAnnualRentalGrowth,
              t.strAnnualExpenseGrowth,
              t.strPropertyAppreciation,
              t.percentagePadSplitFields,
              t.padSplitWorkingCapitalReserve,
              t.padSplitAnnualVacancyRate,
              t.padSplitMaintenance,
              t.padSplitFurnishingExpenses,
              t.padSplitConsumableExpenses,
              t.padSplitUtilityExpenses,
              t.padSplitCleaningExpenses,
              void 0,
              // subset.padSplitPlatformServiceFees,
              t.padSplitManagementFee,
              t.padSplitAnnualRentalGrowth,
              t.padSplitAnnualExpenseGrowth,
              t.padSplitPropertyAppreciation,
              void 0,
              // subset.padSplitOtherExpensePercentage, 
              void 0,
              // subset.padSplitLeaseCommission,
              void 0,
              // subset.padSplitLeaseRenewalFee, 
              t.padSplitOtherExpense,
              t.padSplitCapitalExpenditures,
              void 0,
              // subset.padSplitOtherIncome, 
              t.padSplitBookingFeeDays,
              t.padSplitAverageLengthOfStay,
              void 0,
              // subset.otherExpensesLongTerm,
              void 0,
              // subset.otherExpensesShortTerm,
              void 0,
              // subset.otherExpensesPadSplit,
              void 0,
              // subset.otherIncomesLongTerm,
              void 0,
              // subset.otherIncomesShortTerm,
              void 0,
              // subset.otherIncomesPadSplit,
              S || this.renameSearch ? this.newSearchName ?? ((f = this.selectedSearch) == null ? void 0 : f.name) : void 0,
              S && !this.renameSearch || (v = this.selectedSearch) == null ? void 0 : v.id,
              this.includeListings == !1 ? void 0 : this.includeListings,
              this.mapBoundSearch == !1 ? void 0 : this.mapBoundSearch,
              this.mlsSearchCache,
              Dc
            );
          }
          if (I.data.status != de.Success)
            throw new Error(I.data.message);
          if (this.saveCurrentSearch) {
            let C = "saved";
            if (I.data.searchId > 0 && ((b = this.selectedSearch) == null ? void 0 : b.id) != I.data.searchId && (C = "created", this.selectedSearch = {
              id: I.data.searchId,
              name: this.newSearchName
            }, this.savedSearches.push(this.selectedSearch)), this.renameSearch) {
              const E = this.savedSearches.find((B) => {
                var M;
                return B.id == ((M = this.selectedSearch) == null ? void 0 : M.id);
              });
              E && (E.name = this.newSearchName, C = "renamed");
            }
            this.newSearchName = void 0, wt(`Search succefully ${C}.`);
          }
          this.totalInArea = I.data.totalInArea, this.filtered = I.data.filtered;
          const T = this.markers.map((C) => C.id), x = [];
          this.noResults = I.data.mapPoints.length == 0, I.data.mapPoints.forEach((C) => {
            let O = `marker-prop-${C.id}`;
            if (C.isCluster && (O = `marker-cluster-${C.id}`), x.push(O), T.includes(O) == !1) {
              const E = document.createElement("div");
              E.id = O;
              let B = google.maps.CollisionBehavior.REQUIRED, M = 1e3;
              C.isCluster ? (M = 500, B = google.maps.CollisionBehavior.REQUIRED_AND_HIDES_OPTIONAL, E.classList.add("cluster-tag"), E.textContent = vr(C.count)) : (E.classList.add("price-tag"), this.selectedListingTag == C.id && E.classList.add("selected"), E.textContent = ka(C.listPrice));
              const R = new google.maps.marker.AdvancedMarkerElement({
                map: this.map,
                position: {
                  lat: C.lat,
                  lng: C.lng
                },
                content: E,
                collisionBehavior: B,
                zIndex: M,
                /* @ts-ignore */
                gmpClickable: !0
              });
              C.isCluster && (R.element.addEventListener("pointerenter", () => this.clusterHoverEnter(O)), R.element.addEventListener("pointerleave", () => this.clusterHoverLeave())), R.addEventListener("gmp-click", (F) => C.isCluster ? this.clusterMarkerSelected(F.target, O) : this.propMarkerSelected(F.target, O)), this.markers.push({
                id: O,
                marker: R,
                item: C
              });
            } else {
              const E = this.markers.find((B) => B.id == O);
              E && C.isCluster && (E.marker.position = {
                lat: C.lat,
                lng: C.lng
              }, E.marker.content.textContent = vr(C.count), E.item = C);
            }
          });
          let k = T.filter((C) => x.indexOf(C) < 0);
          this.markers.filter((C) => k.includes(C.id)).forEach((C) => {
            jr(C).marker.map = null;
          }), this.markers = this.markers.filter((C) => k.includes(C.id) == !1), ((w = I.data.listings) == null ? void 0 : w.length) >= 0 && (this.listings.length = 0, this.listings.push(...I.data.listings), this.includeListings = !1), await this.$nextTick(() => this.applyMarkerSelection()), this.renameSearch = !1, this.saveCurrentSearch = !1, this.searching = !1;
        } catch (S) {
          Se(S);
        } finally {
          this.searching = !1, this.busyCount--;
        }
      }
    },
    async saveDefaults(e) {
      const t = bootstrap.Dropdown.getInstance(e);
      t == null || t.hide();
      try {
        const s = await W.api.account.updateFinancialParametersDefaults({
          annualExpenseGrowth: this.searchParameters.annualExpenseGrowth,
          annualRentalGrowth: this.searchParameters.annualRentalGrowth,
          capitalExpenditures: this.searchParameters.capitalExpenditures,
          costOfSale: this.searchParameters.costOfSale,
          downPayment: this.searchParameters.downpayment,
          interestOnlyLoan: this.searchParameters.interestOnlyLoan,
          interestOnlyTerm: this.searchParameters.interestOnlyTerm,
          interestRate: this.searchParameters.interestRate,
          leaseCommission: this.searchParameters.leaseCommission,
          leaseRenewalFee: this.searchParameters.leaseRenewalFee,
          loanFees: this.searchParameters.loanFees,
          amortizationPeriod: this.searchParameters.amortizationPeriod,
          maintenance: this.searchParameters.maintenance,
          managementFee: this.searchParameters.managementFee,
          propertyAppreciation: this.searchParameters.propertyAppreciation,
          stabilizationReserve: this.searchParameters.stabilizationReserve,
          timeBetweenTenants: this.searchParameters.timeBetweenTenants,
          titleCharges: this.searchParameters.titleCharges,
          minCapRate: this.searchParameters.minCapRate,
          minCoC: this.searchParameters.minCoC,
          minIRR: this.searchParameters.minIRR
        });
        if (s.data.status != de.Success)
          throw new Error(s.data.message);
        Ss(new Cs(
          "Financial Parameters",
          "Financial parameters saved as new defaults.",
          fn.success
        )), await this.searchProperties();
      } catch (s) {
        Se(s);
      }
    },
    sortListing(e, t) {
      var s, n, r, i, o, l, d, c;
      if (this.sort_asc)
        switch (this.sort_by) {
          case cr.ListPrice:
            return t.listPrice - e.listPrice;
          case cr.MlsModified:
            return (((s = t.mlsModified) == null ? void 0 : s.getTime()) ?? 0) - (((n = e.mlsModified) == null ? void 0 : n.getTime()) ?? 0);
          case cr.DoM:
            return (((r = t.listDate) == null ? void 0 : r.getTime()) ?? 0) - (((i = e.listDate) == null ? void 0 : i.getTime()) ?? 0);
          default:
          case cr.IRR:
            return t.topIRR - e.topIRR;
        }
      else
        switch (this.sort_by) {
          case cr.ListPrice:
            return e.listPrice - t.listPrice;
          case cr.MlsModified:
            return (((o = e.mlsModified) == null ? void 0 : o.getTime()) ?? 0) - (((l = t.mlsModified) == null ? void 0 : l.getTime()) ?? 0);
          case cr.DoM:
            return (((d = e.listDate) == null ? void 0 : d.getTime()) ?? 0) - (((c = t.listDate) == null ? void 0 : c.getTime()) ?? 0);
          default:
          case cr.IRR:
            return e.topIRR - t.topIRR;
        }
    },
    sortTile(e) {
      this.sort_by === e ? this.sort_asc = !this.sort_asc : this.sort_by = e;
    },
    toggleView(e) {
      console.log("toggleView", e.target.checked), this.view = e.target.checked ? Ta.Tile : Ta.Map;
    },
    displayViewTile() {
      this.view = Ta.Tile;
    },
    displayViewMap() {
      this.view = Ta.Map;
    },
    async clearSearchFilters(e) {
      this.resetingParams = !0, this.searchParameters.byPurchasePrice = !0, this.searchParameters.minPrice = 0, this.searchParameters.maxPrice = 0, this.searchParameters.minBedrooms = 0, this.searchParameters.minBathrooms = 0, this.searchParameters.dwellingType = 0, this.searchParameters.minSqft = 0, this.searchParameters.maxSqft = 0, this.searchParameters.minLotSize = 0, this.searchParameters.maxLotSize = 0, this.searchParameters.minYearbuilt = 0, this.searchParameters.maxYearbuilt = 0, this.searchParameters.maxStories = 0, this.searchParameters.daysOnRescover = 0, this.resetIncludeListings(), this.resetingParams = !1, await this.searchProperties(e);
    },
    async undoFinancialParamsChanges(e) {
      this.resetingParams = !0, this.searchParameters = { ...this.searchParametersOrig }, this.resetIncludeListings(), this.resetingParams = !1, await this.searchProperties(e);
    },
    async resetSearchParameters() {
      var e, t, s;
      try {
        this.busyCount++, this.resetingParams = !0, this.newSearchName = void 0, this.$refs.savedSearches.hide();
        let n;
        if (((e = this.selectedSearch) == null ? void 0 : e.id) > 0 ? n = await W.api.searchMls.getSearchParameters((t = this.selectedSearch) == null ? void 0 : t.id) : n = await W.api.searchMls.getSearchParameters(), n.data.status != de.Success)
          throw new Error(n.data.message);
        if (this.searchParameters = n.data.parameters, this.publicView && (this.searchParameters.publicMlsOnly = !0), this.searchParametersOrig = { ...n.data.parameters }, this.marketplaceView)
          return;
        if (n.data.agentsLocation ? this.selectedSearch = {
          id: Qp.AgentDefaultSearch,
          name: "Agent's Default Search Area"
        } : ((s = this.selectedSearch) == null ? void 0 : s.id) > 0 ? this.selectedSearch.name = n.data.name : n.data.id && (this.selectedSearch = {
          id: n.data.id,
          name: n.data.name
        }), this.clearAreas(), n.data.type == Or.Zip)
          await this.$nextTick(() => {
            this.zips.push(...n.data.area.map((r) => ({ text: r })));
          });
        else if (n.data.type == Or.Map || n.data.type == Or.GeoArea) {
          const r = En.parseGeoJsonGeometry(n.data.boundary);
          n.data.mapBound != !0 && (r.setOptions(DS), r.setMap(this.map), r.setEditable(!0));
          const i = new google.maps.LatLngBounds();
          r.getPath().forEach((o) => i.extend(o)), i.isEmpty() == !1 && this.map.fitBounds(i, n.data.mapBound ? 0 : 1), await this.mapAreaSelected(r);
        }
      } catch (n) {
        Se(n);
      } finally {
        this.busyCount--;
      }
      this.resetingParams = !1;
    },
    async searchCurrentLocation() {
      var e;
      if (!((e = this.selectedSearch) != null && e.id)) {
        const t = await Td();
        (t == null ? void 0 : t.status) == de.Success ? (this.myLocaction = {
          lat: t.latitude,
          lng: t.longitude
        }, this.marketplaceView ? this.searchMarketplace() : t.postalCode ? this.zips.push({
          text: t.postalCode
        }) : (this.map.setZoom(11), this.searchThisArea()), this.handleResize()) : navigator.geolocation.getCurrentPosition((s) => {
          this.myLocaction = {
            lat: s.coords.latitude,
            lng: s.coords.longitude
          }, this.map.panTo(this.myLocaction), this.handleResize();
        });
      }
    },
    addMapArea(e) {
      const t = En.parseGeoJsonDataGeometry(e.boundary);
      this.map.data.add({
        geometry: t,
        id: e.zip,
        properties: {
          type: "zip"
        }
      });
    },
    updateMapBounds(e) {
      if (e.feature.getProperty("type") == "clusterBound")
        return;
      const t = new google.maps.LatLngBounds();
      this.map.data.forEach((s) => {
        s.getGeometry().forEachLatLng((n) => {
          t.extend(n);
        });
      }), t.isEmpty() == !1 && this.map.fitBounds(t, 1), this.handleResize();
    },
    async searchThisArea() {
      this.searchBounds = this.map.getBounds(), this.resetIncludeListings(), await this.searchProperties();
    },
    clearAreas() {
      var e;
      this.mapAreaClear(), this.zips.length = 0, (e = this.map) == null || e.data.forEach((t) => this.map.data.remove(t)), this.mapBoundsChanged = !0;
    },
    startDrawing() {
      this.currentlyDrawing = !0, this.drawingManager.setDrawingMode(google.maps.drawing.OverlayType.POLYGON);
    },
    initTour() {
      const e = uxt({
        cancel: () => this.tour.cancel(),
        complete: () => this.tour.complete(),
        nextStep: () => this.tour.next(),
        prevStep: () => this.tour.back()
      });
      this.tour = dxt(e);
      const t = () => {
        this.currentTourStep = void 0, this.map.setOptions({ draggable: !0 }), window.localStorage.setItem(De.VariableNames.DisableSearchTour, "true");
      };
      this.tour.on("start", () => this.map.setOptions({ draggable: !1 })), this.tour.on("complete", t), this.tour.on("cancel", t), this.tour.on("show", (s) => {
        const n = s.step.getTour();
        this.currentTourStep = n.steps.indexOf(s.step);
      });
      try {
        window.localStorage.setItem("t", ""), window.localStorage.getItem(De.VariableNames.DisableSearchTour) != "true" && this.tour.start();
      } catch {
      }
      Hr("T", () => this.tour.start(), !0, !1, !1, !0);
    },
    async loadSavedSearches() {
      var e;
      try {
        const t = await W.api.searchMls.savedSearches();
        if (t.data.status != de.Success)
          throw new Error(t.data.message);
        this.savedSearches.length = 0, t.data.page && this.savedSearches.push(...t.data.page), (e = this.selectedSearch) != null && e.id && this.savedSearches.some((s) => s.id == this.selectedSearch.id) && (this.selectedSearch = this.savedSearches.find((s) => s.id == this.selectedSearch.id));
      } catch (t) {
        this.searching = !1, Se(t);
      }
    },
    async selectSavedSearched() {
      this.searching = !0, await this.resetSearchParameters();
    },
    async refreshResults(e) {
      e && this.resetIncludeListings(), await this.searchProperties();
    },
    async searchFeatured() {
      this.$refs.savedSearches.hide(), this.selectedSearch = {
        id: Qp.Featured,
        name: "Featured"
      }, this.searchParameters.marketplaceOnly = !1, this.clearAreas(), this.map.fitBounds(De.Map.UsBounds, 0), this.searchBounds = this.map.getBounds(), this.resetIncludeListings(), await this.clearSearchFilters();
    },
    async searchMarketplace() {
      this.selectedSearch = void 0, this.searchParameters.marketplaceOnly = !0, this.clearAreas(), this.map.fitBounds(De.Map.UsBounds, 0), this.searchBounds = this.map.getBounds(), this.resetIncludeListings(), this.areaSizeOk ? await this.searchProperties() : this.areaChanged = !0;
    },
    async freshSearch() {
      this.selectedSearch = void 0, this.firstRecord = 0, this.mapZoomChanged = !1, this.mapBoundsChanged = !0, this.searchBounds = this.map.getBounds(), this.areaChanged = !1, this.selectingListing = !1, this.totalInArea = 0, this.filtered = 0, this.includeListings = !0, this.newSearchName = void 0, this.listings.length = 0, this.markers.forEach((e) => {
        jr(e).marker.map = null;
      }), this.markers.length = 0, this.clearAreas();
    },
    async subscribeSavedSearch(e) {
      var t, s;
      if (((t = this.selectedSearch) == null ? void 0 : t.id) > 0)
        try {
          e.target.checked ? await W.api.searchMls.subscribeSavedSearch(this.selectedSearch.id) : await W.api.searchMls.unsubscribeSavedSearch(this.selectedSearch.id), ((s = this.selectedSearch) == null ? void 0 : s.frequency) == cA.Unspecified && (this.selectedSearch.frequency = cA.Daily);
        } catch (n) {
          Se(n);
        }
    }
  },
  mounted() {
    var s;
    const e = pxt.exec(location.pathname);
    (s = e == null ? void 0 : e.groups) != null && s.id && (this.selectedSearch = {
      id: parseInt(e.groups.id),
      name: ""
    }), this.loadSavedSearches(), document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach((n) => new bootstrap.Tooltip(n));
    const t = Yr();
    console.log("uaParser: ", t), t.device && t.device.type && document.body.classList.add("ua-devicetype-" + t.device.type), t.device && (t.device.type == "tablet" || t.device.type == "mobile") && (this.view = Ta.Tile), this.navbarHeight = $("#navbar").outerHeight(), this.$gmapApiPromiseLazy().then(() => this.mapInit()).then(() => this.handleResize()).then(async () => {
      await this.resetSearchParameters().then(() => {
        this.agentDefaultSearch && !this.marketplaceView ? this.searchProperties() : this.searchCurrentLocation();
      });
    }).then(() => this.initTour()).finally(() => this.initializing = !1), Hr("D", (n) => {
      this.debugMode = !this.debugMode;
    }, !0), Hr("V", () => console.log("Rescover vundefined")), this.busyCount--;
  }
}), NS = "data:image/svg+xml,%3c?xml%20version='1.0'%20encoding='UTF-8'?%3e%3csvg%20width='231px'%20height='200px'%20viewBox='0%200%20231%20200'%20version='1.1'%20xmlns='http://www.w3.org/2000/svg'%20xmlns:xlink='http://www.w3.org/1999/xlink'%3e%3ctitle%3eGroup%204%3c/title%3e%3cg%20id='Page-2'%20stroke='none'%20stroke-width='1'%20fill='none'%20fill-rule='evenodd'%3e%3cg%20id='Group-4'%3e%3cpath%20d='M131.534091,191.165369%20C131.961221,191.165369%20132.380404,191.220995%20132.793627,191.330261%20C133.20685,191.441513%20133.560474,191.598458%20133.856484,191.80507%20L133.516767,192.631516%20C133.21281,192.438811%20132.888986,192.291799%20132.545296,192.192467%20C132.201605,192.093134%20131.865861,192.043468%20131.534091,192.043468%20C130.950016,192.043468%20130.510966,192.14876%20130.218929,192.363318%20C129.924905,192.57589%20129.779879,192.852034%20129.779879,193.187778%20C129.779879,193.436109%20129.863318,193.638748%20130.02821,193.79172%20C130.193102,193.946678%20130.397727,194.065877%20130.642085,194.15329%20C130.886443,194.238716%20131.218214,194.330102%20131.637397,194.427448%20C132.181739,194.55658%20132.616815,194.687699%20132.948586,194.818818%20C133.278369,194.949936%20133.56246,195.148601%20133.798872,195.416799%20C134.03727,195.686983%20134.154482,196.046567%20134.154482,196.50151%20C134.154482,196.878973%20134.053163,197.22465%20133.846551,197.536554%20C133.63994,197.852432%20133.326049,198.098776%20132.906866,198.279561%20C132.487683,198.462333%20131.971154,198.553719%20131.359266,198.553719%20C130.814924,198.553719%20130.290448,198.47028%20129.785839,198.301414%20C129.279243,198.132549%20128.881914,197.916004%20128.593849,197.64582%20L128.975286,196.841227%20C129.249444,197.089558%20129.603067,197.29021%20130.032184,197.445168%20C130.4613,197.600127%20130.904323,197.677606%20131.359266,197.677606%20C131.957247,197.677606%20132.404243,197.576287%20132.700254,197.371662%20C132.996265,197.171011%20133.145264,196.89884%20133.145264,196.563096%20C133.145264,196.314765%20133.063811,196.114113%20132.902893,195.957168%20C132.739987,195.804196%20132.539336,195.686983%20132.302924,195.603544%20C132.066513,195.520105%20131.730769,195.428719%20131.29768,195.323427%20C130.753338,195.194294%20130.314288,195.063175%20129.980531,194.932057%20C129.646774,194.800938%20129.362683,194.600286%20129.124285,194.328115%20C128.887873,194.055944%20128.768675,193.690401%20128.768675,193.229498%20C128.768675,192.844088%20128.869994,192.496424%20129.072632,192.186507%20C129.27527,191.878576%20129.583201,191.630245%20129.996424,191.4435%20C130.409647,191.258741%20130.922203,191.165369%20131.534091,191.165369%20Z%20M140.140257,191.165369%20C140.704466,191.165369%20141.220995,191.258741%20141.687858,191.44946%20C142.156707,191.640178%20142.554037,191.918309%20142.883821,192.289812%20L142.21432,192.941434%20C141.671964,192.369278%20140.99253,192.083201%20140.181977,192.083201%20C139.645582,192.083201%20139.158853,192.204387%20138.725763,192.444771%20C138.292673,192.685156%20137.952956,193.016926%20137.708598,193.442069%20C137.46424,193.865226%20137.343055,194.338048%20137.343055,194.860537%20C137.343055,195.383026%20137.46424,195.855849%20137.708598,196.279005%20C137.952956,196.702161%20138.292673,197.033932%20138.725763,197.276303%20C139.158853,197.516688%20139.645582,197.635887%20140.181977,197.635887%20C140.98657,197.635887%20141.664018,197.347823%20142.21432,196.769708%20L142.883821,197.419342%20C142.554037,197.790846%20142.15472,198.07295%20141.681898,198.265655%20C141.211062,198.45836%20140.692546,198.553719%20140.130324,198.553719%20C139.407184,198.553719%20138.755563,198.394787%20138.173474,198.074936%20C137.593373,197.755086%20137.136443,197.31405%20136.806659,196.753814%20C136.476875,196.193579%20136.311983,195.561825%20136.311983,194.860537%20C136.311983,194.157263%20136.476875,193.527495%20136.806659,192.96726%20C137.136443,192.405038%20137.593373,191.965989%20138.179434,191.646138%20C138.763509,191.324301%20139.417117,191.165369%20140.140257,191.165369%20Z%20M148.704704,191.165369%20C149.427845,191.165369%20150.081453,191.324301%20150.665528,191.646138%20C151.251589,191.965989%20151.708519,192.405038%20152.038303,192.96726%20C152.370073,193.527495%20152.534965,194.157263%20152.534965,194.860537%20C152.534965,195.561825%20152.370073,196.193579%20152.038303,196.753814%20C151.708519,197.31405%20151.251589,197.755086%20150.665528,198.074936%20C150.081453,198.394787%20149.427845,198.553719%20148.704704,198.553719%20C147.975604,198.553719%20147.32001,198.394787%20146.733948,198.074936%20C146.149873,197.755086%20145.690957,197.312063%20145.3572,196.747854%20C145.023442,196.185633%20144.856564,195.553878%20144.856564,194.860537%20C144.856564,194.16521%20145.023442,193.535442%20145.3572,192.97322%20C145.690957,192.407025%20146.149873,191.965989%20146.733948,191.646138%20C147.32001,191.324301%20147.975604,191.165369%20148.704704,191.165369%20Z%20M118.096392,191.246821%20C118.861252,191.246821%20119.5387,191.399793%20120.130722,191.701764%20C120.722743,192.003735%20121.181659,192.428878%20121.509456,192.977193%20C121.835267,193.523522%20121.998172,194.151303%20121.998172,194.860537%20C121.998172,195.567784%20121.835267,196.197552%20121.509456,196.743881%20C121.181659,197.29021%20120.722743,197.715353%20120.130722,198.01931%20C119.5387,198.321281%20118.861252,198.472266%20118.096392,198.472266%20L115.052845,198.472266%20L115.052845,191.246821%20L118.096392,191.246821%20Z%20M125.848299,191.246821%20L125.848299,198.472266%20L124.815242,198.472266%20L124.815242,191.246821%20L125.848299,191.246821%20Z%20M155.145423,191.246821%20L157.745947,197.182931%20L160.368325,191.246821%20L161.399396,191.246821%20L158.23069,198.472266%20L157.209552,198.472266%20L154.030912,191.246821%20L155.145423,191.246821%20Z%20M168.654641,191.246821%20L168.654641,192.146774%20L164.587969,192.146774%20L164.587969,194.365861%20L168.209631,194.365861%20L168.209631,195.241974%20L164.587969,195.241974%20L164.587969,197.574301%20L168.799666,197.574301%20L168.799666,198.472266%20L163.556898,198.472266%20L163.556898,191.246821%20L168.654641,191.246821%20Z%20M174.527177,191.246821%20C175.462889,191.246821%20176.19795,191.471313%20176.734345,191.918309%20C177.270741,192.367292%20177.540925,192.981167%20177.540925,193.765893%20C177.540925,194.322155%20177.40186,194.798951%20177.127702,195.190321%20C176.851558,195.581691%20176.460188,195.869755%20175.951605,196.046567%20L177.664097,198.472266%20L176.539654,198.472266%20L174.98212,196.253179%20C174.787428,196.267085%20174.636443,196.275032%20174.527177,196.275032%20L172.741179,196.275032%20L172.741179,198.472266%20L171.710108,198.472266%20L171.710108,191.246821%20L174.527177,191.246821%20Z%20M185.54911,191.246821%20L185.54911,192.146774%20L181.482438,192.146774%20L181.482438,194.365861%20L185.1041,194.365861%20L185.1041,195.241974%20L181.482438,195.241974%20L181.482438,197.574301%20L185.692149,197.574301%20L185.692149,198.472266%20L180.44938,198.472266%20L180.44938,191.246821%20L185.54911,191.246821%20Z%20M191.646138,191.246821%20C192.410998,191.246821%20193.088446,191.399793%20193.680467,191.701764%20C194.272489,192.003735%20194.731405,192.428878%20195.059202,192.977193%20C195.385013,193.523522%20195.547918,194.151303%20195.547918,194.860537%20C195.547918,195.567784%20195.385013,196.197552%20195.059202,196.743881%20C194.731405,197.29021%20194.272489,197.715353%20193.680467,198.01931%20C193.088446,198.321281%20192.410998,198.472266%20191.646138,198.472266%20L188.602591,198.472266%20L188.602591,191.246821%20L191.646138,191.246821%20Z%20M148.704704,192.083201%20C148.176256,192.083201%20147.695486,192.204387%20147.26637,192.444771%20C146.835267,192.685156%20146.499523,193.016926%20146.255165,193.442069%20C146.010807,193.865226%20145.889622,194.338048%20145.889622,194.860537%20C145.889622,195.383026%20146.010807,195.855849%20146.255165,196.279005%20C146.499523,196.702161%20146.835267,197.033932%20147.26637,197.276303%20C147.695486,197.516688%20148.176256,197.635887%20148.704704,197.635887%20C149.23514,197.635887%20149.711936,197.516688%20150.135092,197.276303%20C150.558249,197.033932%20150.892006,196.702161%20151.136364,196.279005%20C151.380722,195.855849%20151.501907,195.383026%20151.501907,194.860537%20C151.501907,194.338048%20151.380722,193.865226%20151.136364,193.442069%20C150.892006,193.016926%20150.558249,192.685156%20150.135092,192.444771%20C149.711936,192.204387%20149.23514,192.083201%20148.704704,192.083201%20Z%20M118.036793,192.146774%20L116.085903,192.146774%20L116.085903,197.574301%20L118.036793,197.574301%20C118.620868,197.574301%20119.13541,197.459075%20119.578433,197.232597%20C120.023442,197.006119%20120.36316,196.688255%20120.605531,196.279005%20C120.845915,195.869755%20120.967101,195.396933%20120.967101,194.860537%20C120.967101,194.322155%20120.845915,193.851319%20120.605531,193.442069%20C120.36316,193.032819%20120.023442,192.714955%20119.578433,192.486491%20C119.13541,192.260013%20118.620868,192.146774%20118.036793,192.146774%20Z%20M191.586538,192.146774%20L189.635648,192.146774%20L189.635648,197.574301%20L191.586538,197.574301%20C192.168627,197.574301%20192.685156,197.459075%20193.128179,197.232597%20C193.573188,197.006119%20193.912905,196.688255%20194.155277,196.279005%20C194.395661,195.869755%20194.516847,195.396933%20194.516847,194.860537%20C194.516847,194.322155%20194.395661,193.851319%20194.155277,193.442069%20C193.912905,193.032819%20193.573188,192.714955%20193.128179,192.486491%20C192.685156,192.260013%20192.168627,192.146774%20191.586538,192.146774%20Z%20M174.495391,192.146774%20L172.741179,192.146774%20L172.741179,195.396933%20L174.495391,195.396933%20C175.148999,195.396933%20175.647648,195.25588%20175.991338,194.97179%20C176.337015,194.691672%20176.507867,194.290369%20176.507867,193.765893%20C176.507867,193.243404%20176.337015,192.842101%20175.991338,192.56397%20C175.647648,192.285839%20175.148999,192.146774%20174.495391,192.146774%20Z%20M34.5021456,151.255563%20C36.9914177,151.255563%2039.2780515,151.821758%2041.362047,152.952161%20C43.4440559,154.084552%2045.1426414,155.646058%2046.4558169,157.638668%20C48.0868563,160.17562%2048.9013827,163.094008%2048.9013827,166.40178%20C48.9013827,166.900429%2048.7543706,167.283853%2048.4603465,167.556024%20C48.1643357,167.826208%2047.8146853,167.963287%2047.4054355,167.963287%20L26.6926256,168.098379%20C26.4641608,168.098379%2026.3191354,168.199698%2026.2496027,168.402336%20C26.1820566,168.606961%2026.1701367,168.777813%2026.2158296,168.912905%20C26.7144787,170.996901%2027.8111093,172.614034%2029.5116815,173.770264%20C31.2082804,174.924507%2033.1432772,175.524476%2035.316672,175.570168%20C36.9020184,175.570168%2038.3383662,175.242371%2039.6296885,174.58479%20C40.9210108,173.929196%2041.9719485,173.011364%2042.7884615,171.83328%20C43.1500318,171.336618%2043.5354418,171.09822%2043.942705,171.12206%20C44.3499682,171.143913%2044.7572314,171.336618%2045.1644946,171.698188%20L47.2703433,173.259695%20C47.6795931,173.577559%2047.8921647,173.949062%2047.9160045,174.380165%20C47.9378576,174.811268%2047.8365385,175.206612%2047.6100604,175.570168%20C46.251192,177.471392%2044.4969803,178.93158%2042.3454387,179.950731%20C40.1958837,180.969882%2037.8297839,181.500318%2035.2491259,181.546011%20C33.1651303,181.546011%2031.2082804,181.172521%2029.3746027,180.42554%20C27.540925,179.67856%2025.9337254,178.637556%2024.5510172,177.30054%20C23.1702956,175.965512%2022.073665,174.370232%2021.2591386,172.512715%20C20.4446122,170.657184%2020.0353624,168.597028%2020.0353624,166.332247%20C20.0353624,164.385331%2020.3969326,162.496027%2021.1220598,160.662349%20C21.8471869,158.826685%2022.8544183,157.209552%2024.143754,155.80499%20C25.4350763,154.402416%2026.9628099,153.291879%2028.7289415,152.477352%20C30.4950731,151.662826%2032.41815,151.255563%2034.5021456,151.255563%20Z%20M4.41433566,151.797918%20C4.8672918,151.797918%205.24078195,151.94493%205.5348061,152.240941%20C5.82883026,152.534965%205.97584234,152.930308%205.97584234,153.426971%20L5.97584234,154.038859%20C5.97584234,154.356723%206.03345518,154.549428%206.14669421,154.616974%20C6.2579466,154.68452%206.41687858,154.6726%206.6215035,154.581214%20C6.82612842,154.491815%207.09631278,154.344803%207.43602988,154.142165%20C7.77574698,153.93754%208.14923713,153.744835%208.55848697,153.56405%20C9.78027654,153.067387%2011.0477591,152.648204%2012.3609345,152.308487%20C13.67411,151.96877%2015.0548315,151.797918%2016.5030992,151.797918%20C16.9103624,151.797918%2017.2719326,151.94493%2017.5897966,152.240941%20C17.9076605,152.534965%2018.0665925,152.908455%2018.0665925,153.359425%20L18.0665925,156.21424%20C18.0665925,156.66521%2017.9076605,157.040687%2017.5897966,157.332724%20C17.2719326,157.628735%2016.9103624,157.775747%2016.5030992,157.775747%20C15.1005245,157.775747%2013.7754291,157.956532%2012.5297997,158.318102%20C11.2841704,158.681659%2010.1875397,159.233948%209.23593452,159.980928%20C8.28631596,160.729895%207.51549587,161.691434%206.92744755,162.86753%20C6.33741259,164.045613%206.02153528,165.450175%205.97584234,167.079228%20L5.97584234,179.440162%20C5.97584234,179.847425%205.82883026,180.210982%205.5348061,180.52686%20C5.24078195,180.844723%204.8672918,181.001669%204.41433566,181.001669%20L1.56150668,181.001669%20C1.10855054,181.001669%200.735060394,180.844723%200.441036236,180.52686%20C0.147012079,180.210982%200,179.847425%200,179.440162%20L0,153.426971%20C0,152.930308%200.147012079,152.534965%200.441036236,152.240941%20C0.735060394,151.94493%201.10855054,151.797918%201.56150668,151.797918%20L4.41433566,151.797918%20Z%20M34.6392244,157.163859%20C33.0975842,157.255245%2031.6373967,157.616815%2030.2566751,158.250556%20C28.8759536,158.884298%2027.8905753,159.879609%2027.302527,161.238477%20C27.2111411,161.464955%2027.2349809,161.6815%2027.3700731,161.884139%20C27.5071519,162.088764%2027.7554832,162.188096%2028.1170534,162.188096%20L41.089876,162.188096%20C41.8587095,162.188096%2042.1308805,161.872219%2041.9044024,161.238477%20C41.4057533,159.835903%2040.4561348,158.816751%2039.0535601,158.18301%20C37.6489987,157.547282%2036.1768913,157.209552%2034.6392244,157.163859%20Z%20M160.51335,15.3428957%20L124.827161,83.0002384%20L115.926,74.0988957%20L115.926971,63.6582168%20L113.934361,61.9218849%20L113.934361,57.0605531%20L110.773601,57.0605531%20L110.773601,59.1683884%20L106.994994,55.8745232%20L101.991,60.1638957%20L92.854021,51.0270979%20L160.51335,15.3428957%20Z'%20id='Combined-Shape'%20fill='%23E77C2B'%3e%3c/path%3e%3cpath%20d='M107.561189,197.119358%20C107.753894,197.119358%20107.912826,197.186904%20108.039971,197.321996%20C108.167117,197.455102%20108.232676,197.62198%20108.232676,197.822632%20C108.232676,197.925938%20108.21877,198.02527%20108.19493,198.120629%20C108.17109,198.217975%20108.125397,198.364987%20108.055865,198.565639%20L107.571122,200%20L106.921488,200%20L107.302924,198.460346%20C107.171805,198.414654%20107.066513,198.333201%20106.989034,198.217975%20C106.909568,198.106723%20106.869835,197.973617%20106.869835,197.822632%20C106.869835,197.614034%20106.935394,197.447155%20107.066513,197.316036%20C107.195645,197.186904%20107.362524,197.119358%20107.561189,197.119358%20Z%20M71.2750318,191.165369%20C71.7021615,191.165369%2072.1233312,191.220995%2072.5345677,191.330261%20C72.9477908,191.441513%2073.3034011,191.598458%2073.5974253,191.80507%20L73.2577082,192.631516%20C72.9557374,192.438811%2072.6319135,192.291799%2072.2882231,192.192467%20C71.9425461,192.093134%2071.6068023,192.043468%2071.2750318,192.043468%20C70.6909568,192.043468%2070.2519072,192.14876%2069.9598697,192.363318%20C69.6678322,192.57589%2069.5228067,192.852034%2069.5228067,193.187778%20C69.5228067,193.436109%2069.6042594,193.638748%2069.7691513,193.79172%20C69.9340432,193.946678%2070.1386682,194.065877%2070.3830261,194.15329%20C70.627384,194.238716%2070.9591545,194.330102%2071.3803242,194.427448%20C71.9226796,194.55658%2072.3597425,194.687699%2072.6895264,194.818818%20C73.0193102,194.949936%2073.3034011,195.148601%2073.5417991,195.416799%20C73.7782104,195.686983%2073.8974094,196.046567%2073.8974094,196.50151%20C73.8974094,196.878973%2073.7941036,197.22465%2073.5874921,197.536554%20C73.3808805,197.852432%2073.0689765,198.098776%2072.6478067,198.279561%20C72.2286236,198.462333%2071.7140814,198.553719%2071.1002066,198.553719%20C70.5578512,198.553719%2070.0313891,198.47028%2069.52678,198.301414%20C69.022171,198.132549%2068.6228544,197.916004%2068.3347902,197.64582%20L68.716227,196.841227%20C68.9923713,197.089558%2069.3440083,197.29021%2069.7751113,197.445168%20C70.2042276,197.600127%2070.6472505,197.677606%2071.1002066,197.677606%20C71.6981882,197.677606%2072.1451844,197.576287%2072.4411952,197.371662%20C72.737206,197.171011%2072.8862047,196.89884%2072.8862047,196.563096%20C72.8862047,196.314765%2072.8047521,196.114113%2072.6438334,195.957168%20C72.4809282,195.804196%2072.2822632,195.686983%2072.0458519,195.603544%20C71.8074539,195.520105%2071.4717101,195.428719%2071.0386205,195.323427%20C70.4942784,195.194294%2070.0572155,195.063175%2069.7234584,194.932057%20C69.3897012,194.800938%2069.1036236,194.600286%2068.8672123,194.328115%20C68.6288144,194.055944%2068.5096154,193.690401%2068.5096154,193.229498%20C68.5096154,192.844088%2068.6129212,192.496424%2068.8155594,192.186507%20C69.0181977,191.878576%2069.3261284,191.630245%2069.7393516,191.4435%20C70.1525747,191.258741%2070.6631437,191.165369%2071.2750318,191.165369%20Z%20M81.4705181,191.246821%20L81.4705181,192.146774%20L78.9951526,192.146774%20L78.9951526,198.472266%20L77.9740146,198.472266%20L77.9740146,192.146774%20L75.4966624,192.146774%20L75.4966624,191.246821%20L81.4705181,191.246821%20Z%20M86.6715671,191.246821%20L89.9535124,198.472266%20L88.8707883,198.472266%20L88.0761284,196.666402%20L84.2359345,196.666402%20L83.4412746,198.472266%20L82.378417,198.472266%20L85.6504291,191.246821%20L86.6715671,191.246821%20Z%20M104.29911,191.246821%20L104.29911,192.146774%20L100.232438,192.146774%20L100.232438,194.365861%20L103.8541,194.365861%20L103.8541,195.241974%20L100.232438,195.241974%20L100.232438,197.574301%20L104.444135,197.574301%20L104.444135,198.472266%20L99.2013668,198.472266%20L99.2013668,191.246821%20L104.29911,191.246821%20Z%20M96.8372537,191.246821%20L96.8372537,192.146774%20L94.3618881,192.146774%20L94.3618881,198.472266%20L93.3387635,198.472266%20L93.3387635,192.146774%20L90.863398,192.146774%20L90.863398,191.246821%20L96.8372537,191.246821%20Z%20M26.5913064,191.246821%20C27.5270184,191.246821%2028.2640655,191.471313%2028.8004609,191.918309%20C29.3368563,192.367292%2029.605054,192.981167%2029.605054,193.765893%20C29.605054,194.322155%2029.4679752,194.798951%2029.1918309,195.190321%20C28.9176732,195.581691%2028.5243166,195.869755%2028.0157343,196.046567%20L29.7282263,198.472266%20L28.6037826,198.472266%20L27.0462492,196.253179%20C26.8535442,196.267085%2026.7005722,196.275032%2026.5913064,196.275032%20L24.8053083,196.275032%20L24.8053083,198.472266%20L23.7742371,198.472266%20L23.7742371,191.246821%20L26.5913064,191.246821%20Z%20M37.613239,191.246821%20L37.613239,192.146774%20L33.5465671,192.146774%20L33.5465671,194.365861%20L37.1702161,194.365861%20L37.1702161,195.241974%20L33.5465671,195.241974%20L33.5465671,197.574301%20L37.7582645,197.574301%20L37.7582645,198.472266%20L32.5154959,198.472266%20L32.5154959,191.246821%20L37.613239,191.246821%20Z%20M43.8672123,191.246821%20L47.147171,198.472266%20L46.0644469,198.472266%20L45.269787,196.666402%20L41.4315798,196.666402%20L40.6369199,198.472266%20L39.5720757,198.472266%20L42.8440877,191.246821%20L43.8672123,191.246821%20Z%20M50.4926891,191.246821%20L50.4926891,197.574301%20L54.4024158,197.574301%20L54.4024158,198.472266%20L49.4596313,198.472266%20L49.4596313,191.246821%20L50.4926891,191.246821%20Z%20M65.9408773,191.246821%20L65.9408773,192.146774%20L61.8742053,192.146774%20L61.8742053,194.365861%20L65.4958678,194.365861%20L65.4958678,195.241974%20L61.8742053,195.241974%20L61.8742053,197.574301%20L66.0859027,197.574301%20L66.0859027,198.472266%20L60.8431341,198.472266%20L60.8431341,191.246821%20L65.9408773,191.246821%20Z%20M43.3506834,192.301732%20L41.79315,195.839955%20L44.9082168,195.839955%20L43.3506834,192.301732%20Z%20M86.1570248,192.301732%20L84.5994914,195.839955%20L87.7145582,195.839955%20L86.1570248,192.301732%20Z%20M26.55952,192.146774%20L24.8053083,192.146774%20L24.8053083,195.396933%20L26.55952,195.396933%20C27.2131278,195.396933%2027.7117769,195.25588%2028.0574539,194.97179%20C28.4011443,194.691672%2028.5719962,194.290369%2028.5719962,193.765893%20C28.5719962,193.243404%2028.4011443,192.842101%2028.0574539,192.56397%20C27.7117769,192.285839%2027.2131278,192.146774%2026.55952,192.146774%20Z%20M223.83781,175.971472%20C223.891449,175.971472%20223.941116,175.995312%20223.986809,176.041004%20C224.034488,176.088684%20224.056341,176.14431%20224.056341,176.20987%20L224.056341,176.6072%20C224.056341,176.672759%20224.034488,176.730372%20223.986809,176.776065%20C223.941116,176.823744%20223.891449,176.845598%20223.83781,176.845598%20L222.387556,176.845598%20C222.256437,176.845598%20222.188891,176.913144%20222.188891,177.044263%20L222.188891,182.249285%20C222.188891,182.300938%20222.169024,182.352591%20222.131278,182.398284%20C222.089558,182.445963%20222.037905,182.467816%20221.970359,182.467816%20L221.553163,182.467816%20C221.487603,182.467816%20221.431977,182.445963%20221.386284,182.398284%20C221.338605,182.352591%20221.314765,182.300938%20221.314765,182.249285%20L221.314765,177.083996%20C221.314765,177.016449%20221.298872,176.960823%20221.265099,176.91513%20C221.231325,176.869437%20221.189606,176.845598%20221.137953,176.845598%20L219.665846,176.845598%20C219.600286,176.845598%20219.548633,176.823744%20219.506914,176.776065%20C219.469167,176.730372%20219.447314,176.672759%20219.447314,176.6072%20L219.447314,176.20987%20C219.447314,176.050938%20219.52082,175.971472%20219.665846,175.971472%20L223.83781,175.971472%20Z%20M225.446996,175.971472%20C225.552289,175.971472%20225.625795,176.023125%20225.665528,176.130404%20L227.552845,180.659965%20C227.594565,180.779164%20227.646217,180.82883%20227.711777,180.808964%20C227.777336,180.789097%20227.825016,180.753338%20227.850842,180.699698%20L229.740146,176.130404%20C229.777893,176.023125%20229.851399,175.971472%20229.956691,175.971472%20L230.373887,175.971472%20C230.532819,175.971472%20230.612285,176.050938%20230.612285,176.20987%20L230.791084,182.249285%20C230.791084,182.300938%20230.771217,182.352591%20230.733471,182.398284%20C230.691751,182.445963%20230.640099,182.467816%20230.574539,182.467816%20L230.157343,182.467816%20C230.08781,182.467816%20230.036157,182.445963%20229.996424,182.398284%20C229.956691,182.352591%20229.936825,182.300938%20229.936825,182.249285%20L229.819612,178.951446%20C229.805706,178.844167%20229.763986,178.790528%20229.698427,178.782581%20C229.632867,178.776621%20229.573268,178.824301%20229.519628,178.93158%20L228.128973,182.328751%20C228.091227,182.422123%20227.997854,182.467816%20227.850842,182.467816%20L227.552845,182.467816%20C227.407819,182.467816%20227.314447,182.422123%20227.274714,182.328751%20L225.846313,178.87198%20C225.804593,178.778608%20225.75294,178.748808%20225.687381,178.782581%20C225.617848,178.816354%20225.580102,178.899793%20225.566195,179.030912%20L225.486729,182.249285%20C225.486729,182.300938%20225.466863,182.352591%20225.429116,182.398284%20C225.387397,182.445963%20225.335744,182.467816%20225.270184,182.467816%20L224.831135,182.467816%20C224.765575,182.467816%20224.711936,182.445963%20224.672203,182.398284%20C224.63247,182.352591%20224.61459,182.300938%20224.61459,182.249285%20L224.811268,176.20987%20C224.811268,176.050938%20224.884774,175.971472%20225.0298,175.971472%20L225.446996,175.971472%20Z%20M127.481325,151.118484%20C129.561348,151.118484%20131.532104,151.491974%20133.389622,152.240941%20C135.245153,152.987921%20136.864272,154.028926%20138.244994,155.363954%20C139.625715,156.700969%20140.712413,158.306182%20141.505086,160.185553%20C142.297759,162.064924%20142.693102,164.11316%20142.693102,166.332247%20C142.693102,168.597028%20142.297759,170.669104%20141.505086,172.546488%20C140.712413,174.427845%20139.625715,176.033058%20138.244994,177.368086%20C136.864272,178.705102%20135.245153,179.746106%20133.389622,180.493086%20C131.67499,181.182607%20129.863871,181.553887%20127.959389,181.606927%20L127.481325,181.613557%20C125.39733,181.613557%20123.426573,181.240067%20121.571043,180.493086%20C119.713525,179.746106%20118.096392,178.705102%20116.713684,177.368086%20C115.332962,176.033058%20114.236332,174.427845%20113.421805,172.546488%20C112.607279,170.669104%20112.198029,168.597028%20112.198029,166.332247%20C112.198029,164.11316%20112.607279,162.064924%20113.421805,160.185553%20C114.236332,158.306182%20115.332962,156.700969%20116.713684,155.363954%20C118.096392,154.028926%20119.713525,152.987921%20121.571043,152.240941%20C123.426573,151.491974%20125.39733,151.118484%20127.481325,151.118484%20Z%20M95.8320089,151.118484%20C98.3669739,151.118484%20100.709234,151.652893%20102.860776,152.71575%20C105.010331,153.778608%20106.766529,155.260648%20108.123411,157.163859%20C108.351875,157.527416%20108.453195,157.922759%20108.431341,158.351875%20C108.407502,158.782978%20108.192943,159.132629%20107.783694,159.4048%20L105.679832,161.033853%20C105.43746,161.247086%20105.175664,161.372907%20104.894443,161.413082%20L104.752213,161.42604%20C104.656315,161.429932%20104.558257,161.42434%20104.458042,161.409329%20C104.005086,161.341783%20103.641529,161.125238%20103.369358,160.763668%20C101.605213,158.363795%2099.0921011,157.163859%2095.8320089,157.163859%20C94.5625397,157.163859%2093.3626033,157.380404%2092.2321996,157.807533%20C91.0998093,158.238636%2090.1025111,158.838605%2089.2422918,159.609425%20C88.3820725,160.378258%2087.7026383,161.341783%2087.2059758,162.496027%20C86.7073268,163.65027%2086.4589955,164.929673%2086.4589955,166.332247%20C86.4589955,167.782502%2086.7073268,169.071837%2087.2059758,170.204228%20C87.7026383,171.336618%2088.3820725,172.298156%2089.2422918,173.09083%20C90.1025111,173.881516%2091.0998093,174.495391%2092.2321996,174.924507%20C93.3626033,175.353624%2094.5625397,175.570168%2095.8320089,175.570168%20C97.4153687,175.570168%2098.8537031,175.254291%20100.145025,174.618563%20C101.434361,173.984822%20102.509139,173.07891%20103.369358,171.900826%20C103.641529,171.539256%20104.005086,171.324698%20104.458042,171.257152%20L104.606746,171.242583%20L104.752213,171.243908%20C105.087859,171.26554%20105.397065,171.416967%20105.679832,171.698188%20L107.783694,173.327241%20C108.192943,173.599412%20108.407502,173.949062%20108.431341,174.380165%20C108.453195,174.811268%20108.351875,175.206612%20108.123411,175.570168%20C106.766529,177.471392%20105.010331,178.9435%20102.860776,179.982517%20C100.843705,180.960322%2098.6590114,181.478907%2096.3050571,181.539911%20L95.8320089,181.546011%20C93.7480134,181.546011%2091.7792435,181.172521%2089.921726,180.42554%20C88.0661952,179.67856%2086.4470757,178.637556%2085.0663541,177.30054%20C83.6856325,175.965512%2082.5870153,174.370232%2081.7724889,172.512715%20C80.9579625,170.657184%2080.5487127,168.597028%2080.5487127,166.332247%20C80.5487127,164.11316%2080.9579625,162.064924%2081.7724889,160.185553%20C82.5870153,158.306182%2083.6856325,156.700969%2085.0663541,155.363954%20C86.4470757,154.028926%2088.0661952,152.987921%2089.921726,152.240941%20C91.7792435,151.491974%2093.7480134,151.118484%2095.8320089,151.118484%20Z%20M187.722505,151.255563%20C190.211777,151.255563%20192.500397,151.821758%20194.582406,152.952161%20C196.664415,154.084552%20198.363001,155.646058%20199.676176,157.638668%20C201.307216,160.17562%20202.121742,163.094008%20202.121742,166.40178%20C202.121742,166.900429%20201.97473,167.283853%20201.680706,167.556024%20C201.384695,167.826208%20201.035045,167.963287%20200.625795,167.963287%20L179.912985,168.098379%20C179.68452,168.098379%20179.539495,168.199698%20179.469962,168.402336%20C179.402416,168.606961%20179.390496,168.777813%20179.436189,168.912905%20C179.934838,170.996901%20181.033455,172.614034%20182.732041,173.770264%20C184.42864,174.924507%20186.363636,175.524476%20188.537031,175.570168%20C190.122378,175.570168%20191.558725,175.242371%20192.850048,174.58479%20C194.14137,173.929196%20195.192308,173.011364%20196.008821,171.83328%20C196.370391,171.336618%20196.755801,171.09822%20197.163064,171.12206%20C197.570327,171.143913%20197.977591,171.336618%20198.384854,171.698188%20L200.490702,173.259695%20C200.899952,173.577559%20201.112524,173.949062%20201.136364,174.380165%20C201.158217,174.811268%20201.056898,175.206612%20200.83042,175.570168%20C199.471551,177.471392%20197.717339,178.93158%20195.565798,179.950731%20C193.559547,180.901939%20191.364661,181.427421%20188.982755,181.530408%20L188.469485,181.546011%20C186.38549,181.546011%20184.42864,181.172521%20182.594962,180.42554%20C180.761284,179.67856%20179.154085,178.637556%20177.771376,177.30054%20C176.390655,175.965512%20175.294024,174.370232%20174.479498,172.512715%20C173.662985,170.657184%20173.255722,168.597028%20173.255722,166.332247%20C173.255722,164.385331%20173.617292,162.496027%20174.342419,160.662349%20C175.067546,158.826685%20176.074777,157.209552%20177.364113,155.80499%20C178.655435,154.402416%20180.183169,153.291879%20181.949301,152.477352%20C183.715432,151.662826%20185.638509,151.255563%20187.722505,151.255563%20Z%20M64.7925938,151.118484%20C66.3322473,151.118484%2067.7487285,151.344962%2069.0380642,151.797918%20C70.3273999,152.250874%2071.4260172,152.874682%2072.3319294,153.665369%20C73.2378417,154.458042%2073.951049,155.375874%2074.4715512,156.416879%20C74.9920534,157.45987%2075.2523045,158.566434%2075.2523045,159.744517%20C75.2523045,160.016688%2075.1609186,160.253099%2074.9801335,160.455737%20C74.8251748,160.632833%2074.6191309,160.732571%2074.3645038,160.757453%20L74.2331532,160.763668%20L70.3611729,160.763668%20C69.9996027,160.763668%2069.7274317,160.662349%2069.5466465,160.455737%20C69.3658614,160.253099%2069.2764622,160.016688%2069.2764622,159.744517%20C69.2307692,159.021376%2068.8572791,158.341942%2068.1559917,157.708201%20C67.4527177,157.072473%2066.3322473,156.756596%2064.7925938,156.756596%20C63.3443261,156.756596%2062.2119358,157.072473%2061.3974094,157.708201%20C60.582883,158.341942%2060.1756198,159.041243%2060.1756198,159.812063%20C60.1756198,160.855054%2060.582883,161.611968%2061.3974094,162.088764%20C62.2119358,162.563573%2063.243007,162.92713%2064.4866497,163.175461%20C65.7322791,163.423792%2067.0692943,163.66219%2068.4957088,163.886682%20C69.9201367,164.11316%2071.2551653,164.49857%2072.5027813,165.040925%20C73.746424,165.585267%2074.7774952,166.38986%2075.5920216,167.452718%20C76.406548,168.517562%2076.8157978,170.023442%2076.8157978,171.968373%20C76.8157978,173.418627%2076.5098538,174.731802%2075.8979657,175.909886%20C75.2860776,177.085982%2074.4477114,178.081294%2073.3848538,178.897807%20C72.3200095,179.712333%2071.0644469,180.346074%2069.6161793,180.799031%20C68.3270643,181.199892%2066.967313,181.423378%2065.5369252,181.468093%20L64.9972187,181.476478%20C63.27678,181.476478%2061.6795137,181.240067%2060.2093929,180.765257%20C58.7372854,180.290448%2057.4459631,179.611014%2056.3374126,178.726955%20C55.2268754,177.842896%2054.3567228,176.780038%2053.7229816,175.534409%20C53.0872537,174.290766%2052.7713764,172.919978%2052.7713764,171.426017%20C52.7713764,171.153846%2052.8607756,170.905515%2053.0435474,170.679037%20C53.2243325,170.454545%2053.4746503,170.33932%2053.7905277,170.33932%20L57.6605213,170.33932%20C58.0240782,170.33932%2058.2962492,170.454545%2058.4770343,170.679037%20C58.6578195,170.905515%2058.7492053,171.153846%2058.7492053,171.426017%20C58.7492053,172.6041%2059.3034806,173.633185%2060.4120312,174.517244%20C61.5205817,175.399317%2063.0721551,175.842339%2065.0647648,175.842339%20C66.9679752,175.842339%2068.3924031,175.478783%2069.3440083,174.755642%20C70.2936268,174.030515%2070.7704228,173.170296%2070.7704228,172.172997%20C70.7704228,171.312778%2070.3611729,170.690957%2069.5466465,170.305547%20C68.7321202,169.922123%2067.7149555,169.604259%2066.4911793,169.353942%20C65.2693897,169.10561%2063.9323744,168.869199%2062.4841068,168.640734%20C61.0338525,168.414256%2059.6988239,168.006993%2058.4770343,167.418945%20C57.2532581,166.830896%2056.2360935,165.99253%2055.4195804,164.905833%20C54.605054,163.819135%2054.1977908,162.325175%2054.1977908,160.423951%20C54.1977908,159.021376%2054.4699619,157.739987%2055.0123172,156.585744%20C55.5566592,155.4315%2056.3036395,154.446122%2057.2532581,153.631596%20C58.2048633,152.817069%2059.3253338,152.195248%2060.6166561,151.764145%20C61.9059917,151.335029%2063.2986332,151.118484%2064.7925938,151.118484%20Z%20M148.263668,151.797918%20C148.670931,151.797918%20149.133821,151.821758%20149.65631,151.865464%20C150.174825,151.913144%20150.548315,152.229021%20150.77678,152.817069%20L157.159886,169.999603%20C157.47775,170.770423%20157.738001,171.165766%20157.942626,171.189606%20C158.145264,171.211459%20158.359822,170.905515%20158.5863,170.271774%20L165.176017,152.817069%20C165.400509,152.229021%20165.773999,151.913144%20166.296488,151.865464%20C166.815003,151.821758%20167.279879,151.797918%20167.687142,151.797918%20L170.2678,151.797918%20C170.812142,151.797918%20171.15186,152.012476%20171.286952,152.443579%20C171.424031,152.874682%20171.400191,153.291879%20171.219406,153.699142%20L161.371583,180.05205%20C161.162526,180.637042%20160.721561,180.951191%20160.050248,180.996061%20L159.877622,181.001669%20L156.142721,181.001669%20C155.779164,181.001669%20155.451367,180.91227%20155.157343,180.729498%20C154.861332,180.550699%20154.670613,180.322235%20154.579228,180.05205%20L144.731405,153.699142%20C144.55062,153.291879%20144.528767,152.874682%20144.663859,152.443579%20C144.798951,152.012476%20145.138668,151.797918%20145.68301,151.797918%20L148.263668,151.797918%20Z%20M211.629847,151.797918%20C212.080817,151.797918%20212.454307,151.94493%20212.750318,152.240941%20C213.044342,152.534965%20213.191354,152.930308%20213.191354,153.426971%20L213.191354,154.038859%20C213.191354,154.356723%20213.24698,154.549428%20213.360219,154.616974%20C213.473458,154.68452%20213.63239,154.6726%20213.837015,154.581214%20C214.039654,154.491815%20214.311825,154.344803%20214.651542,154.142165%20C214.991259,153.93754%20215.364749,153.744835%20215.772012,153.56405%20C216.995788,153.067387%20218.261284,152.648204%20219.57446,152.308487%20C220.889622,151.96877%20222.268357,151.797918%20223.718611,151.797918%20C224.125874,151.797918%20224.487444,151.94493%20224.805308,152.240941%20C225.121186,152.534965%20225.280118,152.908455%20225.280118,153.359425%20L225.280118,156.21424%20C225.280118,156.66521%20225.121186,157.040687%20224.805308,157.332724%20C224.487444,157.628735%20224.125874,157.775747%20223.718611,157.775747%20C222.31405,157.775747%20220.990941,157.956532%20219.745312,158.318102%20C218.499682,158.681659%20217.403051,159.233948%20216.451446,159.980928%20C215.501828,160.729895%20214.729021,161.691434%20214.142959,162.86753%20C213.552924,164.045613%20213.23506,165.450175%20213.191354,167.079228%20L213.191354,179.440162%20C213.191354,179.847425%20213.044342,180.210982%20212.750318,180.52686%20C212.491308,180.80499%20212.172979,180.959918%20211.795329,180.994304%20L211.629847,181.001669%20L208.777018,181.001669%20C208.324062,181.001669%20207.950572,180.844723%20207.656548,180.52686%20C207.360537,180.210982%20207.215512,179.847425%20207.215512,179.440162%20L207.215512,153.426971%20C207.215512,152.930308%20207.360537,152.534965%20207.656548,152.240941%20C207.950572,151.94493%20208.324062,151.797918%20208.777018,151.797918%20L211.629847,151.797918%20Z%20M127.481325,157.163859%20C126.211856,157.163859%20125.01192,157.380404%20123.87953,157.807533%20C122.749126,158.238636%20121.751828,158.838605%20120.891608,159.609425%20C120.031389,160.378258%20119.351955,161.341783%20118.855292,162.496027%20C118.356643,163.65027%20118.108312,164.929673%20118.108312,166.332247%20C118.108312,167.782502%20118.356643,169.081771%20118.855292,170.238001%20C119.351955,171.392244%20120.031389,172.365702%20120.891608,173.158376%20C121.751828,173.949062%20122.749126,174.562937%20123.87953,174.992053%20C125.01192,175.423156%20126.211856,175.637715%20127.481325,175.637715%20C128.746821,175.637715%20129.946758,175.423156%20131.079148,174.992053%20C132.211538,174.562937%20133.19493,173.949062%20134.033296,173.158376%20C134.871662,172.365702%20135.529243,171.392244%20136.004053,170.238001%20C136.478862,169.081771%20136.71726,167.782502%20136.71726,166.332247%20C136.71726,164.929673%20136.478862,163.65027%20136.004053,162.496027%20C135.529243,161.341783%20134.871662,160.378258%20134.033296,159.609425%20C133.19493,158.838605%20132.211538,158.238636%20131.079148,157.807533%20C129.946758,157.380404%20128.746821,157.163859%20127.481325,157.163859%20Z%20M129.152098,165.404482%20C129.835505,166.089876%20129.835505,167.200413%20129.152098,167.883821%20C128.466704,168.569215%20127.356167,168.569215%20126.670772,167.883821%20C125.987365,167.200413%20125.987365,166.089876%20126.670772,165.404482%20C127.356167,164.721074%20128.466704,164.721074%20129.152098,165.404482%20Z%20M187.859584,157.163859%20C186.317943,157.255245%20184.857756,157.616815%20183.479021,158.250556%20C182.096313,158.884298%20181.110935,159.879609%20180.522886,161.238477%20C180.4315,161.464955%20180.45534,161.6815%20180.590432,161.884139%20C180.727511,162.088764%20180.975842,162.188096%20181.337413,162.188096%20L194.310235,162.188096%20C195.079069,162.188096%20195.35124,161.872219%20195.124762,161.238477%20C194.626113,159.835903%20193.676494,158.816751%20192.273919,158.18301%20C190.997045,157.605076%20189.664348,157.27342%20188.27732,157.183566%20L187.859584,157.163859%20Z%20M162.869517,27.3680865%20C171.030674,38.4694851%20175.856246,52.1793547%20175.856246,67.0136682%20C175.856246,82.3749366%20170.687676,96.5291903%20161.994752,107.832214%20L168.958598,127.131675%20L157.912826,123.146456%20L149.658137,120.168598%20C138.355279,128.861058%20124.201407,134.029323%20108.840591,134.029323%20C94.0042912,134.029323%2080.2964081,129.203751%2069.1950095,121.042594%20L77.1416084,116.850763%20C86.3000636,122.689526%2097.1749841,126.072791%20108.840591,126.072791%20C141.457406,126.072791%20167.899714,99.6304832%20167.899714,67.0136682%20C167.899714,55.3500477%20164.516449,44.4731405%20158.677686,35.316672%20L162.869517,27.3680865%20Z%20M92.854021,51.0270979%20L101.990237,60.164%20L98.0630165,63.5330579%20L98.0630165,74.4934043%20L115.926971,74.4934043%20L115.926237,74.1%20L124.827161,83.0002384%20L57.1698188,118.686427%20L92.854021,51.0270979%20Z%20M108.840591,0%20C123.676891,0%20137.384774,4.82557216%20148.48816,12.9867292%20L140.539574,17.1765734%20C131.381119,11.3397966%20120.506198,7.9565321%20108.840591,7.9565321%20C76.2237762,7.9565321%2049.7834552,34.3968531%2049.7834552,67.0136682%20C49.7834552,78.6792753%2053.1667196,89.5561825%2059.0034965,98.712651%20L54.8116656,106.661236%20C46.6505086,95.5598379%2041.8269231,81.8499682%2041.8269231,67.0136682%20C41.8269231,51.6532242%2046.9951505,37.4994529%2055.6876745,26.1967112%20L48.7225842,6.89764781%20L59.7703433,10.8828671%20L68.0227879,13.861352%20C79.3254113,5.16856965%2093.4793227,0%20108.840591,0%20Z'%20id='Combined-Shape'%20fill='%231A1919'%3e%3c/path%3e%3cpath%20d='M109.957088,107.072473%20L109.957088,122.927924%20L107.726081,122.927924%20L107.726081,107.072473%20L109.957088,107.072473%20Z%20M109.957088,11.1013986%20L109.957088,26.95685%20L107.726081,26.95685%20L107.726081,11.1013986%20L109.957088,11.1013986%20Z%20M131.460585,118.159965%20L124.759615,103.790528%20L126.780038,102.846869%20L133.481008,117.218293%20L131.460585,118.159965%20M90.9011443,31.1804673%20L84.2001748,16.8110299%20L86.2205976,15.8693579%20L92.9215671,30.2387953%20L90.9011443,31.1804673%20M150.955579,103.808408%20L138.809202,93.6168945%20L140.243563,91.9083757%20L152.38994,102.099889%20L150.955579,103.808408%20M77.4376192,42.1209472%20L65.2932295,31.9294342%20L66.7275906,30.2209154%20L78.8719803,40.4124285%20L77.4376192,42.1209472%20M162.557613,82.5631755%20L147.244517,78.4587572%20L147.824619,76.3052289%20L163.137715,80.4076605%20L162.557613,82.5631755%20M69.8625238,57.7240941%20L54.5454545,53.6216624%20L55.1195963,51.4661475%20L70.4366656,55.5685791%20L69.8625238,57.7240941%20M148.484186,61.1570248%20L148.09679,58.9617769%20L163.70987,56.2082804%20L164.097266,58.4035283%20L148.484186,61.1570248%20M53.9693261,77.8210426%20L53.5819294,75.6257947%20L69.1989828,72.8722982%20L69.5863795,75.0675461%20L53.9693261,77.8210426'%20id='Combined-Shape'%20fill='%23747470'%3e%3c/path%3e%3c/g%3e%3c/g%3e%3c/svg%3e", mxt = {
  class: "result-listing-header bg-white toolbar p-2",
  id: "resultListingHeader"
}, fxt = { class: "row g-2 align-items-center" }, gxt = { class: "col-9 col-md-10 col-lg-10 col-xl-8 col-xxl-9 col-jumbo-2 col-kilo-3 vuetags order-1" }, vxt = ["disabled"], yxt = { class: "col-3 col-md-2 col-xxl-1 col-jumbo-1 col-kilo-auto text-end order-2 text-nowrap d-grid" }, bxt = ["disabled"], Axt = { class: "col-4 col-xl-2 col-jumbo order-4" }, wxt = { class: "p-1 border-bottom" }, Cxt = ["disabled"], Sxt = {
  key: 0,
  class: "p-3"
}, Pxt = ["disabled"], kxt = ["disabled"], Ext = { class: "col col-jumbo d-none d-xl-flex toolbar-filters gap-2 order-6" }, Ixt = { class: "dropdown dropdown-price" }, Txt = ["disabled"], Oxt = { class: "dropdown-menu shadow" }, Rxt = { class: "p-3 pb-0" }, Lxt = { class: "row g-3 mb-3" }, Bxt = { class: "col mt-2" }, Mxt = { class: "row g-3 mb-3" }, xxt = { class: "col" }, Fxt = ["value"], Vxt = { class: "col" }, Dxt = ["value"], Nxt = {
  key: 0,
  class: "col-12"
}, jxt = { class: "text-secondary" }, Hxt = { class: "d-grid gap-2 px-3 pt-0 pb-2" }, Uxt = ["disabled"], zxt = { class: "dropdown" }, Wxt = ["disabled"], Gxt = { class: "dropdown-menu shadow" }, Yxt = { class: "p-3 pt-1" }, Xxt = {
  class: "btn-group",
  role: "group",
  "aria-label": "Number of beds"
}, qxt = { class: "p-3 pt-1" }, Qxt = {
  class: "btn-group",
  role: "group",
  "aria-label": "Number of baths"
}, Kxt = { class: "d-grid gap-2 px-3 pt-0 pb-2" }, Zxt = { class: "dropdown dropdown-home" }, Jxt = ["disabled"], $xt = { class: "dropdown-menu shadow" }, _xt = { class: "px-3 py-2" }, eFt = { class: "mb-3" }, tFt = { class: "form-check" }, sFt = { class: "form-check" }, aFt = { class: "form-check" }, nFt = { class: "form-check form-switch form-switch-lg" }, rFt = { class: "d-grid gap-2 px-3 pt-0 pb-2" }, oFt = { class: "dropdown dropdown-more" }, iFt = ["disabled"], lFt = { class: "dropdown-menu shadow" }, dFt = { class: "dropdown-container" }, cFt = { class: "p-3 pt-2" }, uFt = { class: "row g-3 mb-3" }, pFt = { class: "col mt-2" }, hFt = { class: "col mt-2" }, mFt = { class: "col mt-2" }, fFt = { class: "col mt-2" }, gFt = { class: "col mt-2" }, vFt = ["value"], yFt = { class: "col mt-2" }, bFt = ["value"], AFt = { class: "mb-3" }, wFt = { class: "form-check" }, CFt = { class: "d-flex justify-content-between gap-2 p-3 pb-2" }, SFt = { class: "dropdown dropdown-parameters" }, PFt = ["disabled"], kFt = { class: "dropdown-menu dropdown-menu-end shadow" }, EFt = { class: "dropdown-container bg-light" }, IFt = { class: "card shadow m-3" }, TFt = { class: "p-3 pt-2" }, OFt = { class: "row g-3" }, RFt = { class: "col d-flex align-items-center" }, LFt = { class: "form-check form-switch" }, BFt = {
  key: 0,
  class: "col-2 d-flex align-items-center justify-content-center"
}, MFt = { class: "col" }, xFt = ["disabled"], FFt = ["value"], VFt = {
  key: 1,
  class: "form-control-plaintext text-end fw-bold small"
}, DFt = { class: "card shadow m-3" }, NFt = { class: "p-3 pt-2" }, jFt = { class: "row g-3" }, HFt = { class: "col-lg-5 d-flex flex-column justify-content-center align-items-center" }, UFt = { class: "form-check form-switch form-switch-lg" }, zFt = { class: "col-lg-7" }, WFt = { class: "col-lg-5 d-flex align-items-end justify-content-center pb-2" }, GFt = { class: "form-check form-switch form-switch-lg" }, YFt = { class: "col-lg-7" }, XFt = { class: "col-lg-5 d-flex align-items-end justify-content-center pb-2" }, qFt = { class: "form-check form-switch form-switch-lg" }, QFt = { class: "col-lg-7" }, KFt = { class: "col-lg-5 d-flex align-items-end justify-content-center pb-2" }, ZFt = { class: "form-check form-switch form-switch-lg" }, JFt = { class: "col-lg-7" }, $Ft = { class: "col-lg-5 d-flex align-items-end justify-content-center pb-2" }, _Ft = { class: "form-check form-switch form-switch-lg" }, eVt = { class: "col-lg-7" }, tVt = { class: "card shadow m-3" }, sVt = { class: "p-3 pt-2" }, aVt = { class: "row g-3" }, nVt = { class: "col-lg-6" }, rVt = { class: "input-group" }, oVt = { class: "col-lg-6" }, iVt = { class: "input-group" }, lVt = { class: "col-lg-6" }, dVt = ["value"], cVt = { class: "col-lg-6" }, uVt = { class: "input-group" }, pVt = { class: "col-lg-6" }, hVt = { class: "form-check form-switch" }, mVt = {
  key: 0,
  class: "col-lg-6"
}, fVt = ["value"], gVt = { class: "card shadow m-3" }, vVt = { class: "p-3 pt-2" }, yVt = { class: "input-group" }, bVt = { class: "card shadow m-3" }, AVt = { class: "p-3 pt-2" }, wVt = { class: "mb-3" }, CVt = { class: "card shadow m-3" }, SVt = { class: "p-3 pt-2" }, PVt = { class: "input-group" }, kVt = { class: "p-3 pt-2" }, EVt = { class: "input-group" }, IVt = { class: "card shadow m-3" }, TVt = { class: "p-3 pt-2" }, OVt = { class: "mb-3" }, RVt = { class: "input-group" }, LVt = { class: "mb-3" }, BVt = { class: "input-group" }, MVt = { class: "input-group" }, xVt = { class: "card shadow m-3" }, FVt = { class: "p-3 pt-2" }, VVt = { class: "mb-3" }, DVt = { class: "card shadow m-3" }, NVt = { class: "p-3 pt-2" }, jVt = { class: "mb-3" }, HVt = { class: "input-group" }, UVt = { class: "mb-3" }, zVt = { class: "input-group" }, WVt = { class: "input-group" }, GVt = { class: "d-flex flex-column p-3 pb-2" }, YVt = { class: "d-flex justify-content-between gap-3" }, XVt = { class: "col col-jumbo d-none d-xl-flex view-toggle order-7" }, qVt = { class: "input-group justify-content-center justify-content-xxl-end justify-content-jumbo-center justify-content-mega-end" }, QVt = ["disabled"], KVt = ["disabled"], ZVt = ["disabled"], JVt = ["disabled"], $Vt = { class: "col col-jumbo d-none d-xl-flex d-jumbo-none d-kilo-flex subscribe-toggle justify-content-center order-8" }, _Vt = { class: "form-check form-switch form-switch-lg mb-0" }, eDt = ["checked", "disabled"], tDt = { class: "col col-jumbo d-none d-xl-flex button-save justify-content-end order-9" }, sDt = { class: "btn-group" }, aDt = ["disabled"], nDt = ["disabled"], rDt = { class: "dropdown-menu shadow" }, oDt = ["disabled"], iDt = ["disabled"], lDt = ["disabled"], dDt = { class: "map position-relative" }, cDt = {
  key: 1,
  class: "loads text-center d-flex flex-column justify-content-center align-items-center position-absolute w-100"
}, uDt = {
  id: "mapRemove",
  class: "position-absolute top-0 start-50 translate-middle anim"
}, pDt = {
  key: 0,
  class: "btn-remove"
}, hDt = {
  key: 1,
  class: "bg-white rounded shadow px-3 py-2"
}, mDt = {
  id: "mapDraw",
  class: "position-absolute anim d-flex justify-content-between gap-2 flex-column"
}, fDt = ["disabled"], gDt = {
  id: "mapControls",
  class: "position-absolute d-flex justify-content-between gap-2 flex-column"
}, vDt = {
  key: 2,
  id: "mapDebug",
  class: "position-absolute d-flex justify-content-between gap-2 flex-row",
  style: { top: "64px", right: "16px", "z-index": "99", background: "cadetblue", color: "darkblue" }
}, yDt = { class: "px-3 py-2" }, bDt = { class: "mb-3" }, ADt = { class: "form-check" }, wDt = { class: "form-check" }, CDt = { class: "form-check" }, SDt = { class: "form-check" }, PDt = { class: "form-check" }, kDt = { class: "form-check" }, EDt = { class: "form-check" }, IDt = { class: "form-check" }, TDt = { class: "form-check" }, ODt = { class: "form-check" }, RDt = { class: "form-check" }, LDt = { class: "form-check" }, BDt = { class: "form-check" }, MDt = { class: "form-check" }, xDt = { class: "form-check" }, FDt = { class: "form-check" }, VDt = { class: "form-check" }, DDt = { class: "form-check" }, NDt = { class: "form-check" }, jDt = { class: "form-check" }, HDt = { class: "form-check" }, UDt = { class: "row mb-3" }, zDt = { class: "col-sm-10" }, WDt = { class: "row mb-3" }, GDt = { class: "col-sm-10" }, YDt = { class: "row mb-3" }, XDt = { class: "col-sm-10" }, qDt = ["value"], QDt = { class: "results-listing" }, KDt = {
  id: "resultHeader",
  class: "views searchOptions position-absolute top-0 bg-white w-100"
}, ZDt = { class: "d-flex result-header w-100" }, JDt = {
  id: "tileSort",
  class: "filter-sort"
}, $Dt = {
  class: "btn-group",
  role: "group",
  "aria-label": "List sorting"
}, _Dt = { class: "toggle-bluechip justify-content-end d-none d-xl-flex" }, eNt = { class: "form-check form-switch form-switch-lg mb-0" }, tNt = ["data-bs-title"], sNt = { class: "fw-bold result-listing_result" }, aNt = {
  key: 0,
  style: { color: "dodgerblue" },
  "data-bs-placement": "bottom",
  "data-bs-title": "Blue Chip properties",
  "data-bs-toggle": "tooltip"
}, nNt = { key: 1 }, rNt = {
  key: 0,
  style: { color: "dodgerblue" }
}, oNt = { key: 1 }, iNt = {
  key: 3,
  class: "fa-duotone fa-solid fa-spinner-third fa-spin"
}, lNt = { key: 4 }, dNt = {
  key: 5,
  class: "fa-duotone fa-solid fa-spinner-third fa-spin"
}, cNt = { class: "results-listing-container position-absolute w-100" }, uNt = { class: "results-listing-cards" }, pNt = {
  key: 0,
  class: "loads d-flex justify-content-center align-items-center text-center py-3 d-lg-none"
}, hNt = {
  key: 1,
  class: "d-flex justify-content-center align-items-center text-center flex-column py-10 gap-3"
}, mNt = { class: "text-lava" }, fNt = {
  key: 2,
  class: "d-flex justify-content-center align-items-center text-center flex-column p-5 py-xl-10 px-xl-20 gap-3"
}, gNt = {
  key: 3,
  class: "results mlse-results mlse-estimator-listings"
}, vNt = { class: "row g-0 row-cols-1" }, yNt = { class: "col" }, bNt = {
  class: "modal fade form",
  ref: "saveSearch",
  id: "saveSearch",
  tabindex: "-1",
  "aria-labelledby": "saveSearchLabel",
  "aria-hidden": "true"
}, ANt = { class: "modal-dialog modal-dialog-centered" }, wNt = { class: "modal-content bg-gradient-alphabet rounded" }, CNt = { class: "modal-body" }, SNt = {
  key: 0,
  class: "alert alert-danger",
  role: "alert"
}, PNt = {
  id: "emailHelp",
  class: "form-text text-end"
}, kNt = { class: "modal-footer border-0" }, ENt = ["disabled"], INt = {
  class: "modal fade",
  id: "modalFilters",
  tabindex: "-1",
  "aria-labelledby": "modalFiltersLabel",
  "aria-hidden": "true"
}, TNt = { class: "modal-dialog modal-fullscreen-sm-down" }, ONt = { class: "modal-content" }, RNt = { class: "modal-body bg-light" }, LNt = {
  class: "accordion mb-4",
  id: "accordionExample"
}, BNt = { class: "accordion-item accordion-item-price card shadow mb-3 border-0" }, MNt = {
  class: "accordion-header",
  id: "headingOne"
}, xNt = {
  id: "collapseOne",
  class: "accordion-collapse collapse show",
  "aria-labelledby": "headingOne",
  "data-bs-parent": "#accordionExample"
}, FNt = { class: "accordion-body pt-0" }, VNt = { class: "row g-3 mb-3" }, DNt = { class: "col mt-2" }, NNt = { class: "row g-1 g-md-3" }, jNt = { class: "col-5" }, HNt = ["value"], UNt = { class: "col-5" }, zNt = ["value"], WNt = { class: "col-12" }, GNt = { class: "text-secondary" }, YNt = { class: "accordion-item card shadow mb-3 border-0" }, XNt = {
  class: "accordion-header",
  id: "headingTwo"
}, qNt = {
  ref: "btnFilters",
  class: "accordion-button rounded fw-bold bg-white border-0 shadow-none collapsed",
  type: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#collapseTwo",
  "aria-expanded": "false",
  "aria-controls": "collapseTwo"
}, QNt = {
  id: "collapseTwo",
  class: "accordion-collapse collapse",
  "aria-labelledby": "headingTwo",
  "data-bs-parent": "#accordionExample"
}, KNt = { class: "accordion-body pt-0" }, ZNt = {
  class: "btn-group mb-3",
  role: "group",
  "aria-label": "Number of beds"
}, JNt = {
  class: "btn-group",
  role: "group",
  "aria-label": "Number of baths"
}, $Nt = {
  class: "btn-group",
  role: "group",
  "aria-label": "Number of baths"
}, _Nt = { class: "accordion-item card shadow mb-3 border-0" }, ejt = {
  class: "accordion-header",
  id: "headingThree"
}, tjt = {
  ref: "btnFilters",
  class: "accordion-button rounded fw-bold bg-white border-0 shadow-none collapsed",
  type: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#collapseThree",
  "aria-expanded": "false",
  "aria-controls": "collapseThree"
}, sjt = {
  id: "collapseThree",
  class: "accordion-collapse collapse",
  "aria-labelledby": "headingThree",
  "data-bs-parent": "#accordionExample"
}, ajt = { class: "accordion-body pt-0" }, njt = { class: "mb-3" }, rjt = { class: "form-check" }, ojt = { class: "form-check" }, ijt = { class: "form-check" }, ljt = { class: "form-check" }, djt = { class: "form-check" }, cjt = { class: "form-check form-switch form-switch-lg" }, ujt = { class: "accordion-item card shadow border-0" }, pjt = {
  class: "accordion-header",
  id: "headingFour"
}, hjt = {
  ref: "btnFilters",
  class: "accordion-button rounded fw-bold bg-white border-0 shadow-none collapsed",
  type: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#collapseFour",
  "aria-expanded": "false",
  "aria-controls": "collapseFour"
}, mjt = {
  id: "collapseFour",
  class: "accordion-collapse collapse",
  "aria-labelledby": "headingFour",
  "data-bs-parent": "#accordionExample"
}, fjt = { class: "accordion-body pt-0" }, gjt = { class: "border-bottom mb-4 pb-4" }, vjt = { class: "row g-3 mb-3" }, yjt = { class: "col-5 mt-2" }, bjt = { class: "col-5 mt-2" }, Ajt = { class: "col-5 mt-2" }, wjt = { class: "col-5 mt-2" }, Cjt = { class: "col-5 mt-2" }, Sjt = ["value"], Pjt = { class: "col-5 mt-2" }, kjt = ["value"], Ejt = { class: "border-bottom mb-4 pb-4" }, Ijt = { class: "form-check" }, Tjt = { class: "modal-footer d-flex justify-content-between align-items-center gap-3" }, Ojt = {
  class: "modal fade",
  id: "modalFinancial",
  tabindex: "-1",
  "aria-labelledby": "modalFinancialLabel",
  "aria-hidden": "true",
  ref: "btnFinancialParametersModal"
}, Rjt = { class: "modal-dialog modal-fullscreen-sm-down" }, Ljt = { class: "modal-content" }, Bjt = { class: "modal-body bg-light" }, Mjt = { class: "row g-3 border-bottom mb-4 pb-4" }, xjt = { class: "col d-flex align-items-center" }, Fjt = { class: "form-check form-switch" }, Vjt = {
  key: 0,
  class: "col-2 d-flex align-items-center justify-content-center"
}, Djt = { class: "col" }, Njt = ["disabled"], jjt = ["value"], Hjt = {
  key: 1,
  class: "form-control-plaintext text-end fw-bold small"
}, Ujt = { class: "row row-cols-2 g-3 border-bottom mb-4 pb-4" }, zjt = { class: "col" }, Wjt = { class: "input-group" }, Gjt = { class: "col" }, Yjt = { class: "input-group" }, Xjt = { class: "col" }, qjt = { class: "input-group" }, Qjt = { class: "row g-3 border-bottom mb-4 pb-4" }, Kjt = { class: "col-6" }, Zjt = { class: "input-group" }, Jjt = { class: "col-6" }, $jt = { class: "input-group" }, _jt = { class: "col-6" }, eHt = { class: "col-6" }, tHt = { class: "input-group" }, sHt = { class: "col-6" }, aHt = { class: "form-check form-switch" }, nHt = {
  key: 0,
  class: "col-6"
}, rHt = ["value"], oHt = { class: "row g-3 border-bottom mb-4 pb-4" }, iHt = { class: "col-6" }, lHt = { class: "input-group" }, dHt = { class: "border-bottom mb-4 pb-4" }, cHt = { class: "mb-3" }, uHt = { class: "border-bottom mb-4 pb-4" }, pHt = { class: "mb-3" }, hHt = { class: "input-group" }, mHt = { class: "input-group" }, fHt = { class: "border-bottom mb-4 pb-4" }, gHt = { class: "mb-3" }, vHt = { class: "input-group" }, yHt = { class: "mb-3" }, bHt = { class: "input-group" }, AHt = { class: "input-group" }, wHt = { class: "border-bottom mb-4 pb-4" }, CHt = { class: "mb-3" }, SHt = { class: "border-bottom mb-4 pb-4" }, PHt = { class: "mb-3" }, kHt = { class: "input-group" }, EHt = { class: "mb-3" }, IHt = { class: "input-group" }, THt = { class: "input-group" }, OHt = { class: "modal-footer" }, RHt = { class: "d-flex flex-column w-100" }, LHt = { class: "d-flex justify-content-between gap-3" }, BHt = { class: "ms-lg-2 d-flex w-100" }, MHt = ["disabled"], xHt = ["disabled"];
function FHt(e, t, s, n, r, i) {
  var v, b, w, S, I, T, x, k;
  const o = pe("vue-tags-adv"), l = pe("Select"), d = pe("numerical-input"), c = pe("GMapMap"), u = pe("listing-tile"), m = pe("paginator"), f = Za("resize");
  return p(), h(A, null, [
    V(a("span", null, null, 512), [
      [f, e.handleResize]
    ]),
    t[450] || (t[450] = Bt('<div id="alerts"></div><span class="titleToggle d-none"><a href="#" class="resetWizard">Searches</a> / Add a Search </span><div class="hideOthers d-none" id="viewSaved"><div class="box"><div class="row gap"><p class="fs-3"> Search Results for <span></span><span class="right">These are the results based on your saved search.</span></p><hr><p id="searchingUpdate" class="text-center d-flex justify-content-center align-items-center">Processing...</p><div class="mlse-results-no mlse-estimator-listings"></div></div></div></div>', 3)),
    a("div", {
      class: z(e.viewTypeClasses),
      id: "listingResults"
    }, [
      a("div", mxt, [
        a("div", fxt, [
          a("div", gxt, [
            N(o, {
              modelValue: e.searchText,
              "onUpdate:modelValue": t[1] || (t[1] = (C) => e.searchText = C),
              tags: e.zips,
              "onUpdate:tags": t[2] || (t[2] = (C) => e.zips = C),
              "max-tags": 6,
              "autocomplete-items": e.autocompleteItems,
              "add-only-from-autocomplete": !1,
              validation: e.zipValidation,
              "add-on-key": [13, " ", ",", ";"],
              placeholder: "ie: 77380",
              separators: [" ", ",", ";"],
              onTagsChanged: e.zipsChanged,
              onBeforeDeletingTag: e.tagDeleted,
              onBeforeAddingTag: e.tagAdding,
              disabled: e.appBusy
            }, {
              "between-elements": ve(() => [
                a("button", {
                  onClick: t[0] || (t[0] = (...C) => e.searchProperties && e.searchProperties(...C)),
                  class: "btn btn-white no-anim btn-sm bg-lava d-flex align-items-center justify-content-center",
                  type: "button",
                  id: "button-addon2",
                  disabled: e.appBusy
                }, t[178] || (t[178] = [
                  a("i", { class: "fa-light fa-magnifying-glass text-white" }, null, -1),
                  a("span", { class: "visually-hidden" }, "Search", -1)
                ]), 8, vxt)
              ]),
              _: 1
            }, 8, ["modelValue", "tags", "autocomplete-items", "validation", "onTagsChanged", "onBeforeDeletingTag", "onBeforeAddingTag", "disabled"])
          ]),
          a("div", yxt, [
            a("button", {
              class: "btn no-anim btn-white-lilac",
              type: "button",
              onClick: t[3] || (t[3] = (...C) => e.freshSearch && e.freshSearch(...C)),
              disabled: e.appBusy,
              title: "Clear"
            }, t[179] || (t[179] = [
              a("i", { class: "fa-duotone fa-solid fa-xmark me-2" }, null, -1),
              y("Clear ")
            ]), 8, bxt)
          ]),
          t[289] || (t[289] = a("div", { class: "col-4 col-jumbo d-grid d-xl-none order-3" }, [
            a("button", {
              type: "button",
              class: "btn btn-white-lilac no-anim",
              "data-bs-toggle": "modal",
              "data-bs-target": "#modalFilters"
            }, [
              a("i", { class: "fa-light fa-sliders-simple me-2" }),
              y("Filters ")
            ])
          ], -1)),
          a("div", Axt, [
            N(l, {
              options: e.savedSearchesSorted,
              modelValue: e.selectedSearch,
              "onUpdate:modelValue": t[7] || (t[7] = (C) => e.selectedSearch = C),
              ref: "savedSearches",
              filter: e.savedSearchesSorted.length > 0,
              "auto-filter-focus": "",
              optionLabel: "name",
              "empty-message": "No saved searches",
              "scroll-height": "24rem",
              placeholder: "Searches",
              class: "w-100",
              disabled: e.appBusy,
              onChange: e.selectSavedSearched
            }, {
              value: ve((C) => [
                y(g(e.searchesLabel), 1)
              ]),
              header: ve(() => [
                a("div", wxt, [
                  a("button", {
                    class: z(["btn btn-link btn-featured text-decoration-none text-dark w-100 text-start", { selected: e.featuredSearch }]),
                    onClick: t[4] || (t[4] = (...C) => e.searchFeatured && e.searchFeatured(...C)),
                    type: "button",
                    disabled: e.appBusy
                  }, "Featured Listings", 10, Cxt)
                ])
              ]),
              footer: ve(() => {
                var C, O, E, B;
                return [
                  e.isClient || e.shouldCreateSearch || ((O = (C = e.selectedSearch) == null ? void 0 : C.name) == null ? void 0 : O.length) > 0 ? (p(), h("div", Sxt, [
                    e.isClient ? (p(), h("button", {
                      key: 0,
                      type: "button",
                      class: "btn btn-eclipse w-100",
                      onClick: t[5] || (t[5] = (...M) => e.resetSearchParameters && e.resetSearchParameters(...M))
                    }, " Default Search ")) : P("", !0),
                    e.shouldCreateSearch ? (p(), h("button", {
                      key: 1,
                      type: "button",
                      "data-bs-toggle": "modal",
                      "data-bs-target": "#saveSearch",
                      class: "btn btn-eclipse launchModal w-100 d-xl-none",
                      disabled: !e.canSave
                    }, t[180] || (t[180] = [
                      a("i", { class: "fa-light fa-plus me-2" }, null, -1),
                      y("Create Saved Search ")
                    ]), 8, Pxt)) : P("", !0),
                    ((B = (E = e.selectedSearch) == null ? void 0 : E.name) == null ? void 0 : B.length) > 0 ? (p(), h("button", {
                      key: 2,
                      type: "button",
                      onClick: t[6] || (t[6] = (...M) => e.saveSearch && e.saveSearch(...M)),
                      disabled: !e.canSave,
                      class: "btn btn-eclipse updateSavedSearch w-100 d-xl-none"
                    }, " Update ", 8, kxt)) : P("", !0)
                  ])) : P("", !0)
                ];
              }),
              _: 1
            }, 8, ["options", "modelValue", "filter", "disabled", "onChange"])
          ]),
          t[290] || (t[290] = a("div", { class: "col-4 col-jumbo d-grid d-xl-none order-5" }, [
            a("button", {
              type: "button",
              class: "btn btn-eclipse no-anim",
              "data-bs-toggle": "modal",
              "data-bs-target": "#modalFinancial"
            }, [
              a("i", { class: "fa-light fa-usd me-2" }),
              y("Financial"),
              a("span", { class: "d-none d-md-inline-block ms-2" }, "Parameters")
            ])
          ], -1)),
          a("div", Ext, [
            a("div", Ixt, [
              a("button", {
                ref: "btnPriceFilter",
                class: "btn btn-white-lilac dropdown-toggle no-anim",
                type: "button",
                "data-bs-toggle": "dropdown",
                "data-bs-auto-close": "outside",
                "aria-expanded": "false",
                disabled: e.appBusy
              }, g(e.priceFilterLabel), 9, Txt),
              a("div", Oxt, [
                a("div", Rxt, [
                  a("div", Lxt, [
                    t[182] || (t[182] = a("div", { class: "col-12 fw-bold" }, " Filter By ", -1)),
                    a("div", Bxt, [
                      V(a("select", {
                        id: "sqft-min",
                        "aria-label": "Filter price by",
                        "onUpdate:modelValue": t[8] || (t[8] = (C) => e.searchParameters.byPurchasePrice = C),
                        class: "form-select"
                      }, t[181] || (t[181] = [
                        a("option", { value: !0 }, "Purchase Price", -1),
                        a("option", { value: !1 }, "Total Investment", -1)
                      ]), 512), [
                        [We, e.searchParameters.byPurchasePrice]
                      ])
                    ])
                  ]),
                  a("div", Mxt, [
                    a("div", xxt, [
                      t[184] || (t[184] = a("label", {
                        for: "priceMinimum",
                        class: "form-label"
                      }, "Minimum", -1)),
                      V(a("select", {
                        class: "form-select",
                        id: "priceMinimum",
                        "onUpdate:modelValue": t[9] || (t[9] = (C) => e.searchParameters.minPrice = C)
                      }, [
                        t[183] || (t[183] = a("option", { value: 0 }, "No Min", -1)),
                        (p(!0), h(A, null, D(e.priceList, (C) => (p(), h("option", { value: C }, g(e.currency(C)), 9, Fxt))), 256))
                      ], 512), [
                        [We, e.searchParameters.minPrice]
                      ])
                    ]),
                    t[187] || (t[187] = a("div", { class: "col-md-1 d-flex align-items-center justify-content-center text-secondary pt-5" }, " - ", -1)),
                    a("div", Vxt, [
                      t[186] || (t[186] = a("label", {
                        for: "priceMaximum",
                        class: "form-label"
                      }, "Maximum", -1)),
                      V(a("select", {
                        class: "form-select",
                        id: "priceMaximum",
                        "onUpdate:modelValue": t[10] || (t[10] = (C) => e.searchParameters.maxPrice = C)
                      }, [
                        t[185] || (t[185] = a("option", { value: 0 }, "No Max", -1)),
                        (p(!0), h(A, null, D(e.priceList, (C) => (p(), h("option", { value: C }, g(e.currency(C)), 9, Dxt))), 256))
                      ], 512), [
                        [We, e.searchParameters.maxPrice]
                      ])
                    ]),
                    e.searchParameters.byPurchasePrice ? P("", !0) : (p(), h("div", Nxt, [
                      a("small", jxt, "Total invesment based on " + g(e.percent(e.downpayment)) + " down payment, plus closing costs. Edit financial parameters to adjust these settings.", 1)
                    ]))
                  ])
                ]),
                a("div", Hxt, [
                  a("button", {
                    type: "button",
                    class: "btn btn-eclipse",
                    onClick: t[11] || (t[11] = (C) => e.searchProperties(e.$refs.btnPriceFilter)),
                    disabled: e.appBusy
                  }, "Apply", 8, Uxt)
                ])
              ])
            ]),
            a("div", zxt, [
              a("button", {
                ref: "btnBedsBathsFilter",
                class: "btn btn-white-lilac dropdown-toggle no-anim",
                type: "button",
                "data-bs-toggle": "dropdown",
                "data-bs-auto-close": "outside",
                "aria-expanded": "false",
                disabled: e.appBusy
              }, " Beds & Baths ", 8, Wxt),
              a("div", Gxt, [
                t[199] || (t[199] = a("div", { class: "dropdown-header fw-bold h6" }, " NUMBER OF BEDS ", -1)),
                a("div", Yxt, [
                  a("div", Xxt, [
                    V(a("input", {
                      type: "radio",
                      class: "btn-check",
                      id: "bedAny",
                      "onUpdate:modelValue": t[12] || (t[12] = (C) => e.searchParameters.minBedrooms = C),
                      value: 0,
                      autocomplete: "off"
                    }, null, 512), [
                      [Mt, e.searchParameters.minBedrooms]
                    ]),
                    t[188] || (t[188] = a("label", {
                      class: "btn btn-outline-eclipse no-anim",
                      for: "bedAny"
                    }, "Any", -1)),
                    V(a("input", {
                      type: "radio",
                      class: "btn-check",
                      id: "bed1",
                      "onUpdate:modelValue": t[13] || (t[13] = (C) => e.searchParameters.minBedrooms = C),
                      value: 1,
                      autocomplete: "off"
                    }, null, 512), [
                      [Mt, e.searchParameters.minBedrooms]
                    ]),
                    t[189] || (t[189] = a("label", {
                      class: "btn btn-outline-eclipse no-anim",
                      for: "bed1"
                    }, "1+", -1)),
                    V(a("input", {
                      type: "radio",
                      class: "btn-check",
                      id: "bed2",
                      "onUpdate:modelValue": t[14] || (t[14] = (C) => e.searchParameters.minBedrooms = C),
                      value: 2,
                      autocomplete: "off"
                    }, null, 512), [
                      [Mt, e.searchParameters.minBedrooms]
                    ]),
                    t[190] || (t[190] = a("label", {
                      class: "btn btn-outline-eclipse no-anim",
                      for: "bed2"
                    }, "2+", -1)),
                    V(a("input", {
                      type: "radio",
                      class: "btn-check",
                      id: "bed3",
                      "onUpdate:modelValue": t[15] || (t[15] = (C) => e.searchParameters.minBedrooms = C),
                      value: 3,
                      autocomplete: "off"
                    }, null, 512), [
                      [Mt, e.searchParameters.minBedrooms]
                    ]),
                    t[191] || (t[191] = a("label", {
                      class: "btn btn-outline-eclipse no-anim",
                      for: "bed3"
                    }, "3+", -1)),
                    V(a("input", {
                      type: "radio",
                      class: "btn-check",
                      id: "bed4",
                      "onUpdate:modelValue": t[16] || (t[16] = (C) => e.searchParameters.minBedrooms = C),
                      value: 4,
                      autocomplete: "off"
                    }, null, 512), [
                      [Mt, e.searchParameters.minBedrooms]
                    ]),
                    t[192] || (t[192] = a("label", {
                      class: "btn btn-outline-eclipse no-anim",
                      for: "bed4"
                    }, "4+", -1)),
                    V(a("input", {
                      type: "radio",
                      class: "btn-check",
                      id: "bed5",
                      "onUpdate:modelValue": t[17] || (t[17] = (C) => e.searchParameters.minBedrooms = C),
                      value: 5,
                      autocomplete: "off"
                    }, null, 512), [
                      [Mt, e.searchParameters.minBedrooms]
                    ]),
                    t[193] || (t[193] = a("label", {
                      class: "btn btn-outline-eclipse no-anim",
                      for: "bed5"
                    }, "5+", -1))
                  ])
                ]),
                t[200] || (t[200] = a("div", { class: "dropdown-header fw-bold h6" }, " NUMBER OF BATHS ", -1)),
                a("div", qxt, [
                  a("div", Qxt, [
                    V(a("input", {
                      type: "radio",
                      class: "btn-check",
                      id: "bathAny",
                      "onUpdate:modelValue": t[18] || (t[18] = (C) => e.searchParameters.minBathrooms = C),
                      value: 0,
                      autocomplete: "off"
                    }, null, 512), [
                      [Mt, e.searchParameters.minBathrooms]
                    ]),
                    t[194] || (t[194] = a("label", {
                      class: "btn btn-outline-eclipse no-anim",
                      for: "bathAny"
                    }, "Any", -1)),
                    V(a("input", {
                      type: "radio",
                      class: "btn-check",
                      id: "bath1",
                      "onUpdate:modelValue": t[19] || (t[19] = (C) => e.searchParameters.minBathrooms = C),
                      value: 1,
                      autocomplete: "off"
                    }, null, 512), [
                      [Mt, e.searchParameters.minBathrooms]
                    ]),
                    t[195] || (t[195] = a("label", {
                      class: "btn btn-outline-eclipse no-anim",
                      for: "bath1"
                    }, "1+", -1)),
                    V(a("input", {
                      type: "radio",
                      class: "btn-check",
                      id: "bath2",
                      "onUpdate:modelValue": t[20] || (t[20] = (C) => e.searchParameters.minBathrooms = C),
                      value: 2,
                      autocomplete: "off"
                    }, null, 512), [
                      [Mt, e.searchParameters.minBathrooms]
                    ]),
                    t[196] || (t[196] = a("label", {
                      class: "btn btn-outline-eclipse no-anim",
                      for: "bath2"
                    }, "2+", -1)),
                    V(a("input", {
                      type: "radio",
                      class: "btn-check",
                      id: "bath3",
                      "onUpdate:modelValue": t[21] || (t[21] = (C) => e.searchParameters.minBathrooms = C),
                      value: 3,
                      autocomplete: "off"
                    }, null, 512), [
                      [Mt, e.searchParameters.minBathrooms]
                    ]),
                    t[197] || (t[197] = a("label", {
                      class: "btn btn-outline-eclipse no-anim",
                      for: "bath3"
                    }, "3+", -1)),
                    V(a("input", {
                      type: "radio",
                      class: "btn-check",
                      id: "bath4",
                      "onUpdate:modelValue": t[22] || (t[22] = (C) => e.searchParameters.minBathrooms = C),
                      value: 4,
                      autocomplete: "off"
                    }, null, 512), [
                      [Mt, e.searchParameters.minBathrooms]
                    ]),
                    t[198] || (t[198] = a("label", {
                      class: "btn btn-outline-eclipse no-anim",
                      for: "bath4"
                    }, "4+", -1))
                  ])
                ]),
                a("div", Kxt, [
                  a("button", {
                    type: "button",
                    class: "btn btn-eclipse",
                    onClick: t[23] || (t[23] = (C) => e.searchProperties(e.$refs.btnBedsBathsFilter))
                  }, "Apply")
                ])
              ])
            ]),
            a("div", Zxt, [
              a("button", {
                ref: "btnHomeTypeFilter",
                class: "btn btn-white-lilac dropdown-toggle no-anim",
                type: "button",
                "data-bs-toggle": "dropdown",
                "data-bs-auto-close": "outside",
                "aria-expanded": "false",
                disabled: e.appBusy
              }, " Home Type ", 8, Jxt),
              a("div", $xt, [
                t[205] || (t[205] = a("div", { class: "dropdown-header fw-bold h6" }, " HOME TYPE ", -1)),
                a("div", _xt, [
                  a("div", eFt, [
                    a("div", tFt, [
                      V(a("input", {
                        class: "form-check-input",
                        name: "homeTypes",
                        type: "checkbox",
                        value: "",
                        id: "typeHouses",
                        "onUpdate:modelValue": t[24] || (t[24] = (C) => e.typeHouse = C)
                      }, null, 512), [
                        [Ue, e.typeHouse]
                      ]),
                      t[201] || (t[201] = a("label", {
                        class: "form-check-label",
                        for: "typeHouses"
                      }, " Single Family ", -1))
                    ]),
                    a("div", sFt, [
                      V(a("input", {
                        class: "form-check-input",
                        name: "homeTypes",
                        type: "checkbox",
                        value: "",
                        id: "typeMultifamily",
                        "onUpdate:modelValue": t[25] || (t[25] = (C) => e.typeMultiFamily = C)
                      }, null, 512), [
                        [Ue, e.typeMultiFamily]
                      ]),
                      t[202] || (t[202] = a("label", {
                        class: "form-check-label",
                        for: "typeMultifamily"
                      }, " Multi-family ", -1))
                    ]),
                    a("div", aFt, [
                      V(a("input", {
                        class: "form-check-input",
                        name: "homeTypes",
                        type: "checkbox",
                        value: "",
                        id: "typeCommercialOther",
                        "onUpdate:modelValue": t[26] || (t[26] = (C) => e.typeCommercialOther = C)
                      }, null, 512), [
                        [Ue, e.typeCommercialOther]
                      ]),
                      t[203] || (t[203] = a("label", {
                        class: "form-check-label",
                        for: "typeCommercialOther"
                      }, " Commercial / Other ", -1))
                    ])
                  ]),
                  a("div", nFt, [
                    V(a("input", {
                      class: "form-check-input",
                      name: "homeTypes",
                      type: "checkbox",
                      role: "switch",
                      id: "typeLots",
                      "onUpdate:modelValue": t[27] || (t[27] = (C) => e.searchParameters.includeLand = C)
                    }, null, 512), [
                      [Ue, e.searchParameters.includeLand]
                    ]),
                    t[204] || (t[204] = a("label", {
                      class: "form-check-label",
                      for: "typeLots"
                    }, "Show Lots/Land", -1))
                  ])
                ]),
                a("div", rFt, [
                  a("button", {
                    type: "button",
                    class: "btn btn-eclipse",
                    onClick: t[28] || (t[28] = (C) => e.searchProperties(e.$refs.btnHomeTypeFilter))
                  }, "Apply")
                ])
              ])
            ]),
            a("div", oFt, [
              a("button", {
                ref: "btnMoreFilter",
                class: "btn btn-white-lilac dropdown-toggle no-anim",
                type: "button",
                "data-bs-toggle": "dropdown",
                "data-bs-auto-close": "outside",
                "aria-expanded": "false",
                disabled: e.appBusy
              }, " More ", 8, iFt),
              a("div", lFt, [
                a("div", dFt, [
                  t[231] || (t[231] = a("div", { class: "dropdown-header fw-bold h6" }, " MORE FILTERS ", -1)),
                  a("div", cFt, [
                    a("div", uFt, [
                      t[218] || (t[218] = a("div", { class: "col-12 fw-bold" }, " Square Feet ", -1)),
                      a("div", pFt, [
                        t[207] || (t[207] = a("label", {
                          for: "inputEmail4",
                          class: "form-label visually-hidden"
                        }, "Minimum", -1)),
                        V(a("select", {
                          id: "sqft-min",
                          "aria-label": "Square feet min",
                          "onUpdate:modelValue": t[29] || (t[29] = (C) => e.searchParameters.minSqft = C),
                          class: "form-select"
                        }, t[206] || (t[206] = [
                          a("option", { value: 0 }, "No Min", -1),
                          a("option", { value: 500 }, "500", -1),
                          a("option", { value: 750 }, "750", -1),
                          a("option", { value: 1e3 }, "1,000", -1),
                          a("option", { value: 1250 }, "1,250", -1),
                          a("option", { value: 1500 }, "1,500", -1),
                          a("option", { value: 1750 }, "1,750", -1),
                          a("option", { value: 2e3 }, "2,000", -1),
                          a("option", { value: 2250 }, "2,250", -1),
                          a("option", { value: 2500 }, "2,500", -1),
                          a("option", { value: 2750 }, "2,750", -1),
                          a("option", { value: 3e3 }, "3,000", -1),
                          a("option", { value: 3500 }, "3,500", -1),
                          a("option", { value: 4e3 }, "4,000", -1),
                          a("option", { value: 5e3 }, "5,000", -1),
                          a("option", { value: 7500 }, "7,500", -1)
                        ]), 512), [
                          [We, e.searchParameters.minSqft]
                        ])
                      ]),
                      t[219] || (t[219] = a("div", { class: "col-md-1 text-center mt-2" }, " - ", -1)),
                      a("div", hFt, [
                        t[209] || (t[209] = a("label", {
                          for: "inputPassword4",
                          class: "form-label visually-hidden"
                        }, "Maximum", -1)),
                        V(a("select", {
                          id: "sqft-max",
                          "aria-label": "Square feet max",
                          "onUpdate:modelValue": t[30] || (t[30] = (C) => e.searchParameters.maxSqft = C),
                          class: "form-select"
                        }, t[208] || (t[208] = [
                          a("option", { value: 0 }, "No Max", -1),
                          a("option", { value: 500 }, "500", -1),
                          a("option", { value: 750 }, "750", -1),
                          a("option", { value: 1e3 }, "1,000", -1),
                          a("option", { value: 1250 }, "1,250", -1),
                          a("option", { value: 1500 }, "1,500", -1),
                          a("option", { value: 1750 }, "1,750", -1),
                          a("option", { value: 2e3 }, "2,000", -1),
                          a("option", { value: 2250 }, "2,250", -1),
                          a("option", { value: 2500 }, "2,500", -1),
                          a("option", { value: 2750 }, "2,750", -1),
                          a("option", { value: 3e3 }, "3,000", -1),
                          a("option", { value: 3500 }, "3,500", -1),
                          a("option", { value: 4e3 }, "4,000", -1),
                          a("option", { value: 5e3 }, "5,000", -1),
                          a("option", { value: 7500 }, "7,500", -1)
                        ]), 512), [
                          [We, e.searchParameters.maxSqft]
                        ])
                      ]),
                      t[220] || (t[220] = a("div", { class: "col-12 fw-bold mt-2" }, " Lot Size ", -1)),
                      a("div", mFt, [
                        t[211] || (t[211] = a("label", {
                          for: "inputEmail4",
                          class: "form-label visually-hidden"
                        }, "Minimum", -1)),
                        V(a("select", {
                          id: "lotSize-min",
                          "aria-label": "Lot size min",
                          "onUpdate:modelValue": t[31] || (t[31] = (C) => e.searchParameters.minLotSize = C),
                          class: "form-select"
                        }, t[210] || (t[210] = [
                          a("option", { value: 0 }, "No Min", -1),
                          a("option", { value: 1e3 }, "1,000 sqft", -1),
                          a("option", { value: 2e3 }, "2,000 sqft", -1),
                          a("option", { value: 3e3 }, "3,000 sqft", -1),
                          a("option", { value: 4e3 }, "4,000 sqft", -1),
                          a("option", { value: 5e3 }, "5,000 sqft", -1),
                          a("option", { value: 7500 }, "7,500 sqft", -1),
                          a("option", { value: 10890 }, "1/4 acre/10,890 sqft", -1),
                          a("option", { value: 21780 }, "1/2 acre", -1),
                          a("option", { value: 43560 }, "1 acre", -1),
                          a("option", { value: 87120 }, "2 acres", -1),
                          a("option", { value: 217800 }, "5 acres", -1),
                          a("option", { value: 435600 }, "10 acres", -1),
                          a("option", { value: 871200 }, "20 acres", -1),
                          a("option", { value: 2178e3 }, "50 acres", -1),
                          a("option", { value: 4356e3 }, "100 acres", -1)
                        ]), 512), [
                          [We, e.searchParameters.minLotSize]
                        ])
                      ]),
                      t[221] || (t[221] = a("div", { class: "col-md-1 text-center mt-2" }, " - ", -1)),
                      a("div", fFt, [
                        t[213] || (t[213] = a("label", {
                          for: "inputPassword4",
                          class: "form-label visually-hidden"
                        }, "Maximum", -1)),
                        V(a("select", {
                          id: "lotSize-max",
                          "aria-label": "Lot size max",
                          "onUpdate:modelValue": t[32] || (t[32] = (C) => e.searchParameters.maxLotSize = C),
                          class: "form-select"
                        }, t[212] || (t[212] = [
                          a("option", { value: 0 }, "No Max", -1),
                          a("option", { value: 1e3 }, "1,000 sqft", -1),
                          a("option", { value: 2e3 }, "2,000 sqft", -1),
                          a("option", { value: 3e3 }, "3,000 sqft", -1),
                          a("option", { value: 4e3 }, "4,000 sqft", -1),
                          a("option", { value: 5e3 }, "5,000 sqft", -1),
                          a("option", { value: 7500 }, "7,500 sqft", -1),
                          a("option", { value: 10890 }, "1/4 acre/10,890 sqft", -1),
                          a("option", { value: 21780 }, "1/2 acre", -1),
                          a("option", { value: 43560 }, "1 acre", -1),
                          a("option", { value: 87120 }, "2 acres", -1),
                          a("option", { value: 217800 }, "5 acres", -1),
                          a("option", { value: 435600 }, "10 acres", -1),
                          a("option", { value: 871200 }, "20 acres", -1),
                          a("option", { value: 2178e3 }, "50 acres", -1),
                          a("option", { value: 4356e3 }, "100 acres", -1)
                        ]), 512), [
                          [We, e.searchParameters.maxLotSize]
                        ])
                      ]),
                      t[222] || (t[222] = a("div", { class: "col-12 fw-bold mt-2" }, " Year Built ", -1)),
                      a("div", gFt, [
                        t[215] || (t[215] = a("label", {
                          for: "inputEmail4",
                          class: "form-label visually-hidden"
                        }, "Minimum", -1)),
                        V(a("select", {
                          id: "Year-Built-min",
                          class: "form-select",
                          "onUpdate:modelValue": t[33] || (t[33] = (C) => e.searchParameters.minYearbuilt = C)
                        }, [
                          t[214] || (t[214] = a("option", { value: 0 }, "No Min", -1)),
                          (p(!0), h(A, null, D(e.yearRange, (C) => (p(), h("option", { value: C }, g(C), 9, vFt))), 256))
                        ], 512), [
                          [We, e.searchParameters.minYearbuilt]
                        ])
                      ]),
                      t[223] || (t[223] = a("div", { class: "col-md-1 text-center mt-2 text-secondary" }, " - ", -1)),
                      a("div", yFt, [
                        t[217] || (t[217] = a("label", {
                          for: "inputPassword4",
                          class: "form-label visually-hidden"
                        }, "Maximum", -1)),
                        V(a("select", {
                          id: "Year-Built-max",
                          class: "form-select",
                          "onUpdate:modelValue": t[34] || (t[34] = (C) => e.searchParameters.maxYearbuilt = C)
                        }, [
                          t[216] || (t[216] = a("option", { value: 0 }, "No Max", -1)),
                          (p(!0), h(A, null, D(e.yearRange, (C) => (p(), h("option", { value: C }, g(C), 9, bFt))), 256))
                        ], 512), [
                          [We, e.searchParameters.maxYearbuilt]
                        ])
                      ])
                    ]),
                    P("", !0),
                    a("div", AFt, [
                      t[226] || (t[226] = a("p", { class: "fw-bold mb-2" }, "Number of Stores", -1)),
                      a("div", wFt, [
                        V(a("input", {
                          class: "form-check-input",
                          type: "checkbox",
                          "onUpdate:modelValue": t[35] || (t[35] = (C) => e.singleStoryOnly = C),
                          id: "singlestoryOnly"
                        }, null, 512), [
                          [Ue, e.singleStoryOnly]
                        ]),
                        t[225] || (t[225] = a("label", {
                          class: "form-check-label",
                          for: "singlestoryOnly"
                        }, " Single-story only ", -1))
                      ])
                    ]),
                    P("", !0),
                    P("", !0),
                    a("div", null, [
                      t[230] || (t[230] = a("label", {
                        class: "fw-bold mb-2",
                        for: "daysOnRescover"
                      }, "Days on Rescover", -1)),
                      V(a("select", {
                        class: "form-select",
                        id: "daysOnRescover",
                        "onUpdate:modelValue": t[36] || (t[36] = (C) => e.searchParameters.daysOnRescover = C)
                      }, t[229] || (t[229] = [
                        a("option", { value: 0 }, "Any", -1),
                        a("option", { value: 1 }, "1 day", -1),
                        a("option", { value: 7 }, "7 days", -1),
                        a("option", { value: 14 }, "14 days", -1),
                        a("option", { value: 30 }, "30 days", -1),
                        a("option", { value: 90 }, "90 days", -1),
                        a("option", { value: 180 }, "6 months", -1),
                        a("option", { value: 365 }, "12 months", -1)
                      ]), 512), [
                        [We, e.searchParameters.daysOnRescover]
                      ])
                    ])
                  ]),
                  a("div", CFt, [
                    a("button", {
                      type: "button",
                      class: "btn btn-outline-eclipse flex-grow-1",
                      onClick: t[37] || (t[37] = (C) => e.clearSearchFilters(e.$refs.btnMoreFilter))
                    }, "Clear all Filters"),
                    a("button", {
                      type: "button",
                      class: "btn btn-eclipse flex-grow-1",
                      onClick: t[38] || (t[38] = (C) => e.searchProperties(e.$refs.btnMoreFilter))
                    }, "Apply")
                  ])
                ])
              ])
            ]),
            a("div", SFt, [
              a("button", {
                ref: "btnFinancialParameters",
                class: "btn btn-white-lilac dropdown-toggle no-anim",
                type: "button",
                "data-bs-toggle": "dropdown",
                "data-bs-auto-close": "outside",
                "aria-expanded": "false",
                disabled: e.appBusy
              }, t[232] || (t[232] = [
                y(" Financial "),
                a("span", { class: "d-none d-giga-inline-block" }, "Parameters", -1)
              ]), 8, PFt),
              a("div", kFt, [
                a("div", EFt, [
                  a("div", IFt, [
                    t[234] || (t[234] = a("div", { class: "dropdown-header fw-bold h6" }, " PROPOSED HOLD PERIOD ", -1)),
                    a("div", TFt, [
                      a("div", OFt, [
                        a("div", RFt, [
                          a("div", LFt, [
                            V(a("input", {
                              class: "form-check-input",
                              type: "checkbox",
                              role: "switch",
                              id: "holdPeriod",
                              "onUpdate:modelValue": t[39] || (t[39] = (C) => e.autoHoldPeriod = C)
                            }, null, 512), [
                              [Ue, e.autoHoldPeriod]
                            ]),
                            t[233] || (t[233] = a("label", {
                              class: "form-check-label",
                              for: "holdPeriod"
                            }, "Auto", -1))
                          ])
                        ]),
                        e.autoHoldPeriod ? P("", !0) : (p(), h("div", BFt, " OR ")),
                        a("div", MFt, [
                          e.autoHoldPeriod ? (p(), h("span", VFt, "AUTO")) : V((p(), h("select", {
                            key: 0,
                            class: "form-select form-select-sm",
                            "onUpdate:modelValue": t[40] || (t[40] = (C) => e.searchParameters.hold = C),
                            disabled: e.appBusy
                          }, [
                            (p(), h(A, null, D(30, (C) => a("option", {
                              value: C,
                              key: C
                            }, g(C) + " Years", 9, FFt)), 64))
                          ], 8, xFt)), [
                            [We, e.searchParameters.hold]
                          ])
                        ])
                      ])
                    ])
                  ]),
                  a("div", DFt, [
                    t[241] || (t[241] = a("div", { class: "dropdown-header fw-bold h6" }, " BLUE CHIP PERFORMANCE REQUIREMENTS ", -1)),
                    a("div", NFt, [
                      a("div", jFt, [
                        a("div", HFt, [
                          t[235] || (t[235] = a("div", { class: "fw-bold text-center" }, " Active ", -1)),
                          a("div", UFt, [
                            V(a("input", {
                              class: "form-check-input",
                              type: "checkbox",
                              role: "switch",
                              id: "capRateActive",
                              "onUpdate:modelValue": t[41] || (t[41] = (C) => e.capRateActive = C)
                            }, null, 512), [
                              [Ue, e.capRateActive]
                            ])
                          ])
                        ]),
                        a("div", zFt, [
                          t[236] || (t[236] = a("label", {
                            for: "bcCapRate",
                            class: "form-label"
                          }, "Cap Rate", -1)),
                          N(d, {
                            percent: "",
                            placeholder: "Not Set",
                            modelValue: e.searchParameters.minCapRate,
                            "onUpdate:modelValue": t[42] || (t[42] = (C) => e.searchParameters.minCapRate = C)
                          }, null, 8, ["modelValue"])
                        ]),
                        a("div", WFt, [
                          a("div", GFt, [
                            V(a("input", {
                              class: "form-check-input",
                              type: "checkbox",
                              role: "switch",
                              id: "cocActive",
                              "onUpdate:modelValue": t[43] || (t[43] = (C) => e.cocActive = C)
                            }, null, 512), [
                              [Ue, e.cocActive]
                            ])
                          ])
                        ]),
                        a("div", YFt, [
                          t[237] || (t[237] = a("label", {
                            for: "bcCoC",
                            class: "form-label"
                          }, "Cash on Cash", -1)),
                          N(d, {
                            percent: "",
                            placeholder: "Not Set",
                            modelValue: e.searchParameters.minCoC,
                            "onUpdate:modelValue": t[44] || (t[44] = (C) => e.searchParameters.minCoC = C)
                          }, null, 8, ["modelValue"])
                        ]),
                        a("div", XFt, [
                          a("div", qFt, [
                            V(a("input", {
                              class: "form-check-input",
                              type: "checkbox",
                              role: "switch",
                              id: "irrActive",
                              "onUpdate:modelValue": t[45] || (t[45] = (C) => e.irrActive = C)
                            }, null, 512), [
                              [Ue, e.irrActive]
                            ])
                          ])
                        ]),
                        a("div", QFt, [
                          t[238] || (t[238] = a("label", {
                            for: "bcIRR",
                            class: "form-label"
                          }, "IRR", -1)),
                          N(d, {
                            percent: "",
                            placeholder: "Not Set",
                            modelValue: e.searchParameters.minIRR,
                            "onUpdate:modelValue": t[46] || (t[46] = (C) => e.searchParameters.minIRR = C)
                          }, null, 8, ["modelValue"])
                        ]),
                        a("div", KFt, [
                          a("div", ZFt, [
                            V(a("input", {
                              class: "form-check-input",
                              type: "checkbox",
                              role: "switch",
                              id: "cocAfterTaxActive",
                              "onUpdate:modelValue": t[47] || (t[47] = (C) => e.cocAfterTaxActive = C)
                            }, null, 512), [
                              [Ue, e.cocAfterTaxActive]
                            ])
                          ])
                        ]),
                        a("div", JFt, [
                          t[239] || (t[239] = a("label", {
                            for: "bcCoC",
                            class: "form-label"
                          }, "Cash on Cash After Tax", -1)),
                          N(d, {
                            percent: "",
                            placeholder: "Not Set",
                            modelValue: e.searchParameters.minCoCAfterTax,
                            "onUpdate:modelValue": t[48] || (t[48] = (C) => e.searchParameters.minCoCAfterTax = C)
                          }, null, 8, ["modelValue"])
                        ]),
                        a("div", $Ft, [
                          a("div", _Ft, [
                            V(a("input", {
                              class: "form-check-input",
                              type: "checkbox",
                              role: "switch",
                              id: "irrAfterTaxActive",
                              "onUpdate:modelValue": t[49] || (t[49] = (C) => e.irrAfterTaxActive = C)
                            }, null, 512), [
                              [Ue, e.irrAfterTaxActive]
                            ])
                          ])
                        ]),
                        a("div", eVt, [
                          t[240] || (t[240] = a("label", {
                            for: "bcIRR",
                            class: "form-label"
                          }, "IRR After Tax", -1)),
                          N(d, {
                            percent: "",
                            placeholder: "Not Set",
                            modelValue: e.searchParameters.minIRRAfterTax,
                            "onUpdate:modelValue": t[50] || (t[50] = (C) => e.searchParameters.minIRRAfterTax = C)
                          }, null, 8, ["modelValue"])
                        ])
                      ])
                    ])
                  ]),
                  a("div", tVt, [
                    t[253] || (t[253] = a("div", { class: "dropdown-header fw-bold h6" }, " LOAN DETAILS ", -1)),
                    a("div", sVt, [
                      a("div", aVt, [
                        a("div", nVt, [
                          t[243] || (t[243] = a("label", {
                            for: "downpayment",
                            class: "form-label"
                          }, "Down Payment", -1)),
                          a("div", rVt, [
                            V(a("input", {
                              type: "text",
                              id: "downpayment",
                              name: "downpayment",
                              "onUpdate:modelValue": t[51] || (t[51] = (C) => e.downpaymentWhole = C),
                              class: "form-control"
                            }, null, 512), [
                              [_e, e.downpaymentWhole]
                            ]),
                            t[242] || (t[242] = a("span", { class: "input-group-text" }, "%", -1))
                          ])
                        ]),
                        a("div", oVt, [
                          t[245] || (t[245] = a("label", {
                            for: "interestrate",
                            class: "form-label"
                          }, "Interest Rate %", -1)),
                          a("div", iVt, [
                            V(a("input", {
                              type: "text",
                              id: "interestrate",
                              name: "interestrate",
                              "onUpdate:modelValue": t[52] || (t[52] = (C) => e.interestrateWhole = C),
                              class: "form-control"
                            }, null, 512), [
                              [_e, e.interestrateWhole]
                            ]),
                            t[244] || (t[244] = a("span", { class: "input-group-text" }, "%", -1))
                          ])
                        ]),
                        a("div", lVt, [
                          t[246] || (t[246] = a("label", {
                            for: "amortizationPeriod",
                            class: "form-label"
                          }, "Amortization Period", -1)),
                          V(a("select", {
                            id: "amortizationPeriod",
                            "onUpdate:modelValue": t[53] || (t[53] = (C) => e.searchParameters.amortizationPeriod = C),
                            class: "form-select"
                          }, [
                            (p(!0), h(A, null, D(e.amortizationPeriods, (C) => (p(), h("option", { value: C }, g(C) + " Years", 9, dVt))), 256))
                          ], 512), [
                            [
                              We,
                              e.searchParameters.amortizationPeriod,
                              void 0,
                              { number: !0 }
                            ]
                          ])
                        ]),
                        a("div", cVt, [
                          t[248] || (t[248] = a("label", {
                            for: "loanfees",
                            class: "form-label"
                          }, "Loan Fees", -1)),
                          a("div", uVt, [
                            V(a("input", {
                              type: "text",
                              id: "loanfees",
                              name: "loanfees",
                              "onUpdate:modelValue": t[54] || (t[54] = (C) => e.loanfeesWhole = C),
                              class: "form-control"
                            }, null, 512), [
                              [_e, e.loanfeesWhole]
                            ]),
                            t[247] || (t[247] = a("span", { class: "input-group-text" }, "%", -1))
                          ])
                        ]),
                        a("div", pVt, [
                          t[250] || (t[250] = a("label", {
                            for: "interestOnlyLoan",
                            class: "form-label"
                          }, "Interest Only Loan?", -1)),
                          a("div", hVt, [
                            V(a("input", {
                              class: "form-check-input",
                              type: "checkbox",
                              "onUpdate:modelValue": t[55] || (t[55] = (C) => e.searchParameters.interestOnlyLoan = C),
                              role: "switch",
                              id: "interestOnlyLoan"
                            }, null, 512), [
                              [Ue, e.searchParameters.interestOnlyLoan]
                            ]),
                            t[249] || (t[249] = a("label", {
                              class: "form-check-label",
                              for: "interestOnlyLoan"
                            }, "Yes", -1))
                          ])
                        ]),
                        e.searchParameters.interestOnlyLoan ? (p(), h("div", mVt, [
                          t[252] || (t[252] = a("label", {
                            for: "interestOnlyTerm",
                            class: "form-label"
                          }, "Interest Only Term", -1)),
                          V(a("select", {
                            id: "interestOnlyTerm",
                            "onUpdate:modelValue": t[56] || (t[56] = (C) => e.searchParameters.interestOnlyTerm = C),
                            class: "form-select"
                          }, [
                            t[251] || (t[251] = a("option", { value: "360" }, "Full Term", -1)),
                            (p(!0), h(A, null, D(e.interestOnlyTerms, (C) => (p(), h("option", { value: C }, g(C) + " Months", 9, fVt))), 256))
                          ], 512), [
                            [
                              We,
                              e.searchParameters.interestOnlyTerm,
                              void 0,
                              { number: !0 }
                            ]
                          ])
                        ])) : P("", !0)
                      ])
                    ])
                  ]),
                  a("div", gVt, [
                    t[256] || (t[256] = a("div", { class: "dropdown-header fw-bold h6" }, " CLOSING COSTS (EXCLUDING LOAN FEES) ", -1)),
                    a("div", vVt, [
                      t[255] || (t[255] = a("label", {
                        for: "inputEmail4",
                        class: "form-label"
                      }, "Title Charges", -1)),
                      a("div", yVt, [
                        t[254] || (t[254] = a("span", { class: "input-group-text" }, "$", -1)),
                        V(a("input", {
                          type: "text",
                          id: "titlecharges",
                          name: "titlecharges",
                          "onUpdate:modelValue": t[57] || (t[57] = (C) => e.titlecharges = C),
                          class: "form-control"
                        }, null, 512), [
                          [_e, e.titlecharges]
                        ])
                      ])
                    ])
                  ]),
                  a("div", bVt, [
                    t[260] || (t[260] = a("div", { class: "dropdown-header fw-bold h6" }, " VACANCY ", -1)),
                    a("div", AVt, [
                      a("div", wVt, [
                        t[258] || (t[258] = a("label", {
                          for: "averagelengthofstay",
                          class: "form-label"
                        }, "Average Length of Stay", -1)),
                        V(a("select", {
                          id: "averagelengthofstay",
                          class: "form-select",
                          "onUpdate:modelValue": t[58] || (t[58] = (C) => e.searchParameters.averageLengthOfStay = C),
                          name: "averagelengthofstay"
                        }, t[257] || (t[257] = [
                          a("option", { value: 1 }, "1 Year", -1),
                          a("option", { value: 2 }, "2 Years", -1),
                          a("option", { value: 3 }, "3 Years", -1),
                          a("option", { value: 4 }, "4 Years", -1),
                          a("option", { value: 5 }, "5 Years", -1),
                          a("option", { value: 6 }, "6 Years", -1),
                          a("option", { value: 7 }, "7 Years", -1),
                          a("option", { value: 8 }, "8 Years", -1),
                          a("option", { value: 9 }, "9 Years", -1),
                          a("option", { value: 10 }, "10 Years", -1)
                        ]), 512), [
                          [We, e.searchParameters.averageLengthOfStay]
                        ])
                      ]),
                      a("div", null, [
                        t[259] || (t[259] = a("label", {
                          for: "timebetweentenants",
                          class: "form-label"
                        }, "Average Time Between Tenants (days)", -1)),
                        V(a("input", {
                          type: "text",
                          id: "timebetweentenants",
                          name: "timebetweentenants",
                          "onUpdate:modelValue": t[59] || (t[59] = (C) => e.timebetweentenants = C),
                          class: "form-control"
                        }, null, 512), [
                          [_e, e.timebetweentenants]
                        ])
                      ])
                    ])
                  ]),
                  a("div", CVt, [
                    t[265] || (t[265] = a("div", { class: "dropdown-header fw-bold h6" }, " Maintenance & Capital Expenditures ", -1)),
                    a("div", SVt, [
                      t[262] || (t[262] = a("label", {
                        for: "maintenance",
                        class: "form-label"
                      }, "Maint. Expense (% of Gross Income)", -1)),
                      a("div", PVt, [
                        V(a("input", {
                          type: "text",
                          id: "maintenance",
                          name: "maintenance",
                          "onUpdate:modelValue": t[60] || (t[60] = (C) => e.maintenanceWhole = C),
                          class: "form-control"
                        }, null, 512), [
                          [_e, e.maintenanceWhole]
                        ]),
                        t[261] || (t[261] = a("span", { class: "input-group-text" }, "%", -1))
                      ])
                    ]),
                    a("div", kVt, [
                      t[264] || (t[264] = a("label", {
                        for: "capitalExpenditure",
                        class: "form-label"
                      }, "Capital Expenditures (% of Gross Income)", -1)),
                      a("div", EVt, [
                        V(a("input", {
                          type: "text",
                          id: "capitalExpenditure",
                          name: "capitalExpenditure",
                          "onUpdate:modelValue": t[61] || (t[61] = (C) => e.capitalExpendituresWhole = C),
                          class: "form-control"
                        }, null, 512), [
                          [_e, e.capitalExpendituresWhole]
                        ]),
                        t[263] || (t[263] = a("span", { class: "input-group-text" }, "%", -1))
                      ])
                    ])
                  ]),
                  a("div", IVt, [
                    t[272] || (t[272] = a("div", { class: "dropdown-header fw-bold h6" }, " LEASING AND RESALE EXPENSES ", -1)),
                    a("div", TVt, [
                      a("div", OVt, [
                        t[267] || (t[267] = a("label", {
                          for: "leasecommission",
                          class: "form-label"
                        }, "Lease Commission (% of 1 month's rent)", -1)),
                        a("div", RVt, [
                          V(a("input", {
                            type: "text",
                            id: "leasecommission",
                            name: "leasecommission",
                            "onUpdate:modelValue": t[62] || (t[62] = (C) => e.leasecommissionWhole = C),
                            class: "form-control"
                          }, null, 512), [
                            [_e, e.leasecommissionWhole]
                          ]),
                          t[266] || (t[266] = a("span", { class: "input-group-text" }, "%", -1))
                        ])
                      ]),
                      a("div", LVt, [
                        t[269] || (t[269] = a("label", {
                          for: "leaserenewalfee",
                          class: "form-label"
                        }, "Lease Renewal Fee (% of 1 month's rent)", -1)),
                        a("div", BVt, [
                          V(a("input", {
                            type: "text",
                            id: "leaserenewalfee",
                            name: "leaserenewalfee",
                            "onUpdate:modelValue": t[63] || (t[63] = (C) => e.leaserenewalfeeWhole = C),
                            class: "form-control"
                          }, null, 512), [
                            [_e, e.leaserenewalfeeWhole]
                          ]),
                          t[268] || (t[268] = a("span", { class: "input-group-text" }, "%", -1))
                        ])
                      ]),
                      a("div", null, [
                        t[271] || (t[271] = a("label", {
                          for: "costofsale",
                          class: "form-label"
                        }, "Cost of Sale %", -1)),
                        a("div", MVt, [
                          V(a("input", {
                            type: "text",
                            id: "costofsale",
                            name: "costofsale",
                            "onUpdate:modelValue": t[64] || (t[64] = (C) => e.costofsaleWhole = C),
                            placeholder: "ie: 8",
                            class: "form-control"
                          }, null, 512), [
                            [_e, e.costofsaleWhole]
                          ]),
                          t[270] || (t[270] = a("span", { class: "input-group-text" }, "%", -1))
                        ])
                      ])
                    ])
                  ]),
                  a("div", xVt, [
                    t[276] || (t[276] = a("div", { class: "dropdown-header fw-bold h6" }, " MANAGEMENT EXPENSES ", -1)),
                    a("div", FVt, [
                      a("div", VVt, [
                        t[274] || (t[274] = a("label", {
                          for: "percentManagementFee",
                          class: "form-label"
                        }, "Monthly Management", -1)),
                        V(a("select", {
                          id: "percentManagementFee",
                          class: "autocalc form-select",
                          "onUpdate:modelValue": t[65] || (t[65] = (C) => e.isManagementFeePercent = C),
                          name: "percentManagementFee"
                        }, t[273] || (t[273] = [
                          a("option", { value: !1 }, "Flat", -1),
                          a("option", { value: !0 }, "Percentage", -1)
                        ]), 512), [
                          [We, e.isManagementFeePercent]
                        ])
                      ]),
                      a("div", null, [
                        t[275] || (t[275] = a("label", {
                          for: "managementfee",
                          class: "form-label"
                        }, "Monthly Management Fee", -1)),
                        N(d, {
                          modelValue: e.searchParameters.managementFee,
                          "onUpdate:modelValue": t[66] || (t[66] = (C) => e.searchParameters.managementFee = C),
                          percent: e.isManagementFeePercent,
                          currency: !e.isManagementFeePercent
                        }, null, 8, ["modelValue", "percent", "currency"])
                      ])
                    ])
                  ]),
                  a("div", DVt, [
                    t[283] || (t[283] = a("div", { class: "dropdown-header fw-bold h6" }, " INFLATION & APPRECIATION ", -1)),
                    a("div", NVt, [
                      a("div", jVt, [
                        t[278] || (t[278] = a("label", {
                          for: "annualrentalgrowth",
                          class: "form-label"
                        }, "Annual Rental Rate Increase", -1)),
                        a("div", HVt, [
                          V(a("input", {
                            id: "annualrentalgrowth",
                            type: "text",
                            name: "annualrentalgrowth",
                            "onUpdate:modelValue": t[67] || (t[67] = (C) => e.annualRentalGrowth = C),
                            class: "form-control"
                          }, null, 512), [
                            [_e, e.annualRentalGrowth]
                          ]),
                          t[277] || (t[277] = a("span", { class: "input-group-text" }, "%", -1))
                        ])
                      ]),
                      a("div", UVt, [
                        t[280] || (t[280] = a("label", {
                          for: "annualexpensegrowth",
                          class: "form-label"
                        }, "Annual Expense Inflation", -1)),
                        a("div", zVt, [
                          V(a("input", {
                            id: "annualexpensegrowth",
                            type: "text",
                            name: "annualexpensegrowth",
                            "onUpdate:modelValue": t[68] || (t[68] = (C) => e.annualExpenseGrowth = C),
                            class: "form-control"
                          }, null, 512), [
                            [_e, e.annualExpenseGrowth]
                          ]),
                          t[279] || (t[279] = a("span", { class: "input-group-text" }, "%", -1))
                        ])
                      ]),
                      a("div", null, [
                        t[282] || (t[282] = a("label", {
                          for: "propertyappreciation",
                          class: "form-label"
                        }, "Annual Property Appreciation", -1)),
                        a("div", WVt, [
                          V(a("input", {
                            type: "text",
                            id: "propertyappreciation",
                            name: "propertyappreciation",
                            "onUpdate:modelValue": t[69] || (t[69] = (C) => e.propertyAppreciation = C),
                            class: "form-control"
                          }, null, 512), [
                            [_e, e.propertyAppreciation]
                          ]),
                          t[281] || (t[281] = a("span", { class: "input-group-text" }, "%", -1))
                        ])
                      ])
                    ])
                  ]),
                  a("div", GVt, [
                    a("button", {
                      type: "button",
                      class: "btn btn-eclipse flex-grow-1 flex-fill mb-2",
                      onClick: t[70] || (t[70] = (C) => e.searchProperties(e.$refs.btnFinancialParameters))
                    }, "Apply"),
                    a("div", YVt, [
                      a("button", {
                        type: "button",
                        class: "btn btn-outline-eclipse flex-fill",
                        onClick: t[71] || (t[71] = (C) => e.undoFinancialParamsChanges(e.$refs.btnFinancialParameters))
                      }, "Undo Changes"),
                      a("button", {
                        type: "button",
                        class: "btn btn-outline-eclipse flex-fill",
                        onClick: t[72] || (t[72] = (C) => e.saveDefaults(e.$refs.btnFinancialParameters))
                      }, "Save Defaults")
                    ])
                  ])
                ])
              ])
            ])
          ]),
          a("div", XVt, [
            a("div", qVt, [
              a("input", {
                type: "radio",
                class: "btn-check",
                name: "options",
                id: "option1",
                autocomplete: "off",
                checked: "",
                onClick: t[73] || (t[73] = (...C) => e.displayViewMap && e.displayViewMap(...C)),
                disabled: e.noResults || e.appBusy
              }, null, 8, QVt),
              a("label", {
                class: "btn btn-outline-eclipse rounded-start no-anim",
                for: "option1",
                disabled: e.noResults || e.appBusy
              }, t[284] || (t[284] = [
                a("i", { class: "fa-duotone fa-solid fa-map" }, null, -1),
                a("span", { class: "d-xl-none d-xxl-inline-block d-jumbo-none d-mega-inline-block ms-1" }, "Map", -1)
              ]), 8, KVt),
              a("input", {
                type: "radio",
                class: "btn-check",
                name: "options",
                id: "option2",
                autocomplete: "off",
                onClick: t[74] || (t[74] = (...C) => e.displayViewTile && e.displayViewTile(...C)),
                disabled: e.noResults || e.appBusy
              }, null, 8, ZVt),
              a("label", {
                class: "btn btn-outline-eclipse no-anim",
                for: "option2",
                disabled: e.noResults || e.appBusy
              }, t[285] || (t[285] = [
                a("i", { class: "fa-duotone fa-solid fa-grid-2" }, null, -1),
                a("span", { class: "d-xl-none d-xxl-inline-block d-jumbo-none d-mega-inline-block ms-1" }, "Tile", -1)
              ]), 8, JVt)
            ])
          ]),
          a("div", $Vt, [
            a("div", _Vt, [
              a("input", {
                type: "checkbox",
                class: "form-check-input",
                id: "toggleSubscribe",
                checked: e.subscribeChecked,
                disabled: e.shouldCreateSearch,
                onChange: t[75] || (t[75] = (C) => e.subscribeSavedSearch(C))
              }, null, 40, eDt),
              t[286] || (t[286] = a("label", {
                class: "form-check-label",
                for: "toggleSubscribe"
              }, "Subscribe", -1))
            ])
          ]),
          a("div", tDt, [
            a("div", sDt, [
              a("button", {
                type: "button",
                class: z(["no-anim text-nowrap", e.btnSaveSearchStyle]),
                onClick: t[76] || (t[76] = (...C) => e.saveSearch && e.saveSearch(...C)),
                disabled: !e.canSave
              }, [
                t[287] || (t[287] = a("i", { class: "fa-light fa-floppy-disk me-1 d-xl-none d-xxl-inline-flex" }, null, -1)),
                e.shouldCreateSearch ? (p(), h(A, { key: 0 }, [
                  y(" Save Search ")
                ], 64)) : (p(), h(A, { key: 1 }, [
                  y(" Save ")
                ], 64))
              ], 10, aDt),
              e.shouldCreateSearch ? P("", !0) : (p(), h(A, { key: 0 }, [
                a("button", {
                  type: "button",
                  class: "btn btn-eclipse dropdown-toggle dropdown-toggle-split no-anim",
                  "data-bs-toggle": "dropdown",
                  "aria-expanded": "false",
                  disabled: !e.canSave
                }, t[288] || (t[288] = [
                  a("span", { class: "visually-hidden" }, "Toggle Dropdown", -1)
                ]), 8, nDt),
                a("ul", rDt, [
                  a("li", null, [
                    a("button", {
                      type: "button",
                      class: "dropdown-item",
                      onClick: t[77] || (t[77] = (C) => e.saveSearchAs(!1)),
                      disabled: !e.canSave
                    }, "Save As...", 8, oDt)
                  ]),
                  a("li", null, [
                    a("button", {
                      type: "button",
                      class: "dropdown-item",
                      onClick: t[78] || (t[78] = (C) => e.saveSearchAs(!0)),
                      disabled: !e.canSave
                    }, "Rename...", 8, iDt)
                  ]),
                  a("li", null, [
                    a("button", {
                      type: "button",
                      class: "dropdown-item",
                      onClick: t[79] || (t[79] = (...C) => e.deleteSavedSearch && e.deleteSavedSearch(...C)),
                      disabled: !e.canSave
                    }, "Delete", 8, lDt)
                  ])
                ])
              ], 64))
            ])
          ])
        ])
      ]),
      a("div", dDt, [
        P("", !0),
        e.searching ? (p(), h("div", cDt, t[292] || (t[292] = [
          Bt('<svg class="loader" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 340 340"><circle cx="170" cy="170" r="160" stroke="#F26E34"></circle><circle cx="170" cy="170" r="135" stroke="#132844"></circle><circle cx="170" cy="170" r="110" stroke="#F26E34"></circle><circle cx="170" cy="170" r="85" stroke="#132844"></circle></svg><br><span class="fw-bold h5 mb-0"> Processing... </span>', 3)
        ]))) : P("", !0),
        a("div", uDt, [
          e.askToUpdateSearchArea ? (p(), h("div", pDt, [
            e.areaSizeOk ? (p(), h("button", {
              key: 0,
              class: "btn btn-white-eclipse shadow ms-2",
              onClick: t[80] || (t[80] = (...C) => e.searchThisArea && e.searchThisArea(...C))
            }, t[293] || (t[293] = [
              a("i", { class: "fa-light fa-magnifying-glass me-2" }, null, -1),
              y("Search this area")
            ]))) : (p(), h("span", hDt, t[294] || (t[294] = [
              a("i", { class: "fa-light fa-circle-exclamation me-2" }, null, -1),
              y(" Zoom in to search area ")
            ])))
          ])) : P("", !0)
        ]),
        a("div", mDt, [
          e.featuredSearch ? P("", !0) : (p(), h("button", {
            key: 0,
            class: z(["btn btn-light shadow-sm", e.btnDrawingStyle]),
            onClick: t[81] || (t[81] = (...C) => e.startDrawing && e.startDrawing(...C)),
            disabled: !e.canDraw,
            title: "Draw boundary"
          }, t[295] || (t[295] = [
            a("i", { class: "fa-light fa-draw-polygon" }, null, -1)
          ]), 10, fDt)),
          e.askToRemoveBoundaries ? (p(), h("button", {
            key: 1,
            class: "btn btn-light shadow-sm",
            title: "Remove all bounds",
            onClick: t[82] || (t[82] = (...C) => e.clearAreas && e.clearAreas(...C))
          }, t[296] || (t[296] = [
            a("i", { class: "fa-light fa-trash-xmark" }, null, -1)
          ]))) : P("", !0)
        ]),
        a("div", gDt, [
          a("button", {
            onClick: t[83] || (t[83] = (...C) => e.zoomOut && e.zoomOut(...C)),
            class: "btn btn-light shadow-sm"
          }, t[297] || (t[297] = [
            a("i", { class: "fa-light fa-minus" }, null, -1),
            a("span", { class: "visually-hidden" }, "Zoom out", -1)
          ])),
          a("button", {
            onClick: t[84] || (t[84] = (...C) => e.zoomIn && e.zoomIn(...C)),
            class: "btn btn-light shadow-sm"
          }, t[298] || (t[298] = [
            a("i", { class: "fa-light fa-plus" }, null, -1),
            a("span", { class: "visually-hidden" }, "Zoom in", -1)
          ])),
          P("", !0),
          P("", !0),
          P("", !0)
        ]),
        e.debugMode ? (p(), h("div", vDt, [
          a("div", yDt, [
            a("div", bDt, [
              a("div", ADt, [
                V(a("input", {
                  class: "form-check-input",
                  type: "checkbox",
                  "onUpdate:modelValue": t[88] || (t[88] = (C) => e.canDraw = C),
                  disabled: ""
                }, null, 512), [
                  [Ue, e.canDraw]
                ]),
                t[302] || (t[302] = a("label", { class: "form-check-label" }, " canDraw ", -1))
              ]),
              a("div", wDt, [
                V(a("input", {
                  class: "form-check-input",
                  type: "checkbox",
                  "onUpdate:modelValue": t[89] || (t[89] = (C) => e.askToUpdateSearchArea = C),
                  disabled: ""
                }, null, 512), [
                  [Ue, e.askToUpdateSearchArea]
                ]),
                t[303] || (t[303] = a("label", { class: "form-check-label" }, " askToUpdateSearchArea ", -1))
              ]),
              a("div", CDt, [
                V(a("input", {
                  class: "form-check-input",
                  type: "checkbox",
                  "onUpdate:modelValue": t[90] || (t[90] = (C) => e.askToRemoveBoundaries = C),
                  disabled: ""
                }, null, 512), [
                  [Ue, e.askToRemoveBoundaries]
                ]),
                t[304] || (t[304] = a("label", { class: "form-check-label" }, " askToRemoveBoundaries ", -1))
              ]),
              a("div", SDt, [
                V(a("input", {
                  class: "form-check-input",
                  type: "checkbox",
                  "onUpdate:modelValue": t[91] || (t[91] = (C) => e.areaSizeOk = C),
                  disabled: ""
                }, null, 512), [
                  [Ue, e.areaSizeOk]
                ]),
                t[305] || (t[305] = a("label", { class: "form-check-label" }, " areaSizeOk ", -1))
              ]),
              a("div", PDt, [
                V(a("input", {
                  class: "form-check-input",
                  type: "checkbox",
                  "onUpdate:modelValue": t[92] || (t[92] = (C) => e.mapBoundSearch = C),
                  disabled: ""
                }, null, 512), [
                  [Ue, e.mapBoundSearch]
                ]),
                t[306] || (t[306] = a("label", { class: "form-check-label" }, " mapBoundSearch ", -1))
              ]),
              a("div", kDt, [
                V(a("input", {
                  class: "form-check-input",
                  type: "checkbox",
                  "onUpdate:modelValue": t[93] || (t[93] = (C) => e.polygonSearch = C),
                  disabled: ""
                }, null, 512), [
                  [Ue, e.polygonSearch]
                ]),
                t[307] || (t[307] = a("label", { class: "form-check-label" }, " polygonSearch ", -1))
              ]),
              a("div", EDt, [
                V(a("input", {
                  class: "form-check-input",
                  type: "checkbox",
                  "onUpdate:modelValue": t[94] || (t[94] = (C) => e.areaSearch = C),
                  disabled: ""
                }, null, 512), [
                  [Ue, e.areaSearch]
                ]),
                t[308] || (t[308] = a("label", { class: "form-check-label" }, " areaSearch ", -1))
              ]),
              a("div", IDt, [
                V(a("input", {
                  class: "form-check-input",
                  type: "checkbox",
                  "onUpdate:modelValue": t[95] || (t[95] = (C) => e.appBusy = C),
                  disabled: ""
                }, null, 512), [
                  [Ue, e.appBusy]
                ]),
                t[309] || (t[309] = a("label", { class: "form-check-label" }, " appBusy ", -1))
              ]),
              a("div", TDt, [
                V(a("input", {
                  class: "form-check-input",
                  type: "checkbox",
                  "onUpdate:modelValue": t[96] || (t[96] = (C) => e.featuredSearch = C),
                  disabled: ""
                }, null, 512), [
                  [Ue, e.featuredSearch]
                ]),
                t[310] || (t[310] = a("label", { class: "form-check-label" }, " featuredSearch ", -1))
              ]),
              a("div", ODt, [
                V(a("input", {
                  class: "form-check-input",
                  type: "checkbox",
                  "onUpdate:modelValue": t[97] || (t[97] = (C) => e.canSave = C),
                  disabled: ""
                }, null, 512), [
                  [Ue, e.canSave]
                ]),
                t[311] || (t[311] = a("label", { class: "form-check-label" }, " canSave ", -1))
              ]),
              a("div", RDt, [
                V(a("input", {
                  class: "form-check-input",
                  type: "checkbox",
                  "onUpdate:modelValue": t[98] || (t[98] = (C) => e.canCreate = C),
                  disabled: ""
                }, null, 512), [
                  [Ue, e.canCreate]
                ]),
                t[312] || (t[312] = a("label", { class: "form-check-label" }, " canCreate ", -1))
              ]),
              a("div", LDt, [
                V(a("input", {
                  class: "form-check-input",
                  type: "checkbox",
                  "onUpdate:modelValue": t[99] || (t[99] = (C) => e.shouldCreateSearch = C),
                  disabled: ""
                }, null, 512), [
                  [Ue, e.shouldCreateSearch]
                ]),
                t[313] || (t[313] = a("label", { class: "form-check-label" }, " shouldCreateSearch ", -1))
              ]),
              a("div", BDt, [
                V(a("input", {
                  class: "form-check-input",
                  type: "checkbox",
                  "onUpdate:modelValue": t[100] || (t[100] = (C) => e.validNewSearchName = C),
                  disabled: ""
                }, null, 512), [
                  [Ue, e.validNewSearchName]
                ]),
                t[314] || (t[314] = a("label", { class: "form-check-label" }, " validNewSearchName ", -1))
              ]),
              a("div", MDt, [
                V(a("input", {
                  class: "form-check-input",
                  type: "checkbox",
                  "onUpdate:modelValue": t[101] || (t[101] = (C) => e.renameSearch = C),
                  disabled: ""
                }, null, 512), [
                  [Ue, e.renameSearch]
                ]),
                t[315] || (t[315] = a("label", { class: "form-check-label" }, " renameSearch ", -1))
              ]),
              a("div", xDt, [
                V(a("input", {
                  class: "form-check-input",
                  type: "checkbox",
                  "onUpdate:modelValue": t[102] || (t[102] = (C) => e.shouldUpdateResults = C),
                  disabled: ""
                }, null, 512), [
                  [Ue, e.shouldUpdateResults]
                ]),
                t[316] || (t[316] = a("label", { class: "form-check-label" }, " shouldUpdateResults ", -1))
              ]),
              a("div", FDt, [
                V(a("input", {
                  class: "form-check-input",
                  type: "checkbox",
                  "onUpdate:modelValue": t[103] || (t[103] = (C) => e.mapZoomChanged = C),
                  disabled: ""
                }, null, 512), [
                  [Ue, e.mapZoomChanged]
                ]),
                t[317] || (t[317] = a("label", { class: "form-check-label" }, " mapZoomChanged ", -1))
              ]),
              a("div", VDt, [
                V(a("input", {
                  class: "form-check-input",
                  type: "checkbox",
                  "onUpdate:modelValue": t[104] || (t[104] = (C) => e.areaChanged = C),
                  disabled: ""
                }, null, 512), [
                  [Ue, e.areaChanged]
                ]),
                t[318] || (t[318] = a("label", { class: "form-check-label" }, " areaChanged ", -1))
              ]),
              a("div", DDt, [
                V(a("input", {
                  class: "form-check-input",
                  type: "checkbox",
                  "onUpdate:modelValue": t[105] || (t[105] = (C) => e.mapBoundsChanged = C),
                  disabled: ""
                }, null, 512), [
                  [Ue, e.mapBoundsChanged]
                ]),
                t[319] || (t[319] = a("label", { class: "form-check-label" }, " mapBoundsChanged ", -1))
              ]),
              a("div", NDt, [
                V(a("input", {
                  class: "form-check-input",
                  type: "checkbox",
                  "onUpdate:modelValue": t[106] || (t[106] = (C) => e.selectingListing = C),
                  disabled: ""
                }, null, 512), [
                  [Ue, e.selectingListing]
                ]),
                t[320] || (t[320] = a("label", { class: "form-check-label" }, " selectingListing ", -1))
              ]),
              a("div", jDt, [
                V(a("input", {
                  class: "form-check-input",
                  type: "checkbox",
                  "onUpdate:modelValue": t[107] || (t[107] = (C) => e.includeListings = C),
                  disabled: ""
                }, null, 512), [
                  [Ue, e.includeListings]
                ]),
                t[321] || (t[321] = a("label", { class: "form-check-label" }, " includeListings ", -1))
              ]),
              a("div", HDt, [
                V(a("input", {
                  class: "form-check-input",
                  type: "checkbox",
                  "onUpdate:modelValue": t[108] || (t[108] = (C) => e.currentlyDrawing = C),
                  disabled: ""
                }, null, 512), [
                  [Ue, e.currentlyDrawing]
                ]),
                t[322] || (t[322] = a("label", { class: "form-check-label" }, " currentlyDrawing ", -1))
              ]),
              a("div", UDt, [
                t[323] || (t[323] = a("label", { class: "col-sm-2 col-form-label" }, "Square Miles", -1)),
                a("div", zDt, g(e.number(e.currentSquareMiles)), 1)
              ]),
              a("div", WDt, [
                t[324] || (t[324] = a("label", { class: "col-sm-2 col-form-label" }, "Zoom", -1)),
                a("div", GDt, [
                  V(a("input", {
                    type: "text",
                    class: "form-control",
                    "onUpdate:modelValue": t[109] || (t[109] = (C) => e.currentZoom = C),
                    disabled: ""
                  }, null, 512), [
                    [_e, e.currentZoom]
                  ])
                ])
              ]),
              a("div", YDt, [
                t[325] || (t[325] = a("label", { class: "col-sm-2 col-form-label" }, "Search Id", -1)),
                a("div", XDt, [
                  a("input", {
                    type: "text",
                    class: "form-control",
                    value: (v = e.selectedSearch) == null ? void 0 : v.id,
                    disabled: ""
                  }, null, 8, qDt)
                ])
              ])
            ])
          ])
        ])) : P("", !0),
        N(c, {
          ref: "gMap",
          class: "mlse-estimator-listings h-100 w-100",
          "map-id": "2ddbbe0dd6bcf8f9",
          center: e.center,
          options: e.listingsMapOptions,
          onClick: e.onMapClick,
          onBounds_changed: e.onMapBoundsChanged,
          onDragend: e.onMapDragEnd,
          onZoom_changed: e.onMapZoomChanged,
          onIdle: e.onMapIdle,
          onPano_visible_changed: e.onPanoVisibleChanged
        }, null, 8, ["center", "options", "onClick", "onBounds_changed", "onDragend", "onZoom_changed", "onIdle", "onPano_visible_changed"])
      ]),
      a("div", QDt, [
        a("div", KDt, [
          a("div", ZDt, [
            a("div", JDt, [
              t[330] || (t[330] = a("span", { class: "me-1 fw-bold d-md-none d-xxl-inline-block" }, "Sort by: ", -1)),
              a("div", $Dt, [
                a("button", {
                  type: "button",
                  onClick: t[110] || (t[110] = (C) => e.sortTile(e.MlsSortBy.DoM)),
                  class: z(["btn btn-sm btn-light no-anim", e.sortButtonClass(e.MlsSortBy.DoM)])
                }, [
                  a("i", {
                    class: z(["fa-duotone fa-solid", e.sortIconClass(e.MlsSortBy.DoM)])
                  }, null, 2),
                  t[326] || (t[326] = y("DoM "))
                ], 2),
                a("button", {
                  type: "button",
                  onClick: t[111] || (t[111] = (C) => e.sortTile(e.MlsSortBy.ListPrice)),
                  class: z(["btn btn-sm btn-light no-anim", e.sortButtonClass(e.MlsSortBy.ListPrice)])
                }, [
                  a("i", {
                    class: z(["fa-duotone fa-solid", e.sortIconClass(e.MlsSortBy.ListPrice)])
                  }, null, 2),
                  t[327] || (t[327] = y("Price "))
                ], 2),
                a("button", {
                  type: "button",
                  onClick: t[112] || (t[112] = (C) => e.sortTile(e.MlsSortBy.IRR)),
                  class: z(["btn btn-sm btn-light no-anim", e.sortButtonClass(e.MlsSortBy.IRR)])
                }, [
                  a("i", {
                    class: z(["fa-duotone fa-solid", e.sortIconClass(e.MlsSortBy.IRR)])
                  }, null, 2),
                  t[328] || (t[328] = y("IRR "))
                ], 2),
                a("button", {
                  type: "button",
                  onClick: t[113] || (t[113] = (C) => e.sortTile(e.MlsSortBy.MlsModified)),
                  class: z(["btn btn-sm btn-light no-anim", e.sortButtonClass(e.MlsSortBy.MlsModified)])
                }, [
                  a("i", {
                    class: z(["fa-duotone fa-solid", e.sortIconClass(e.MlsSortBy.MlsModified)])
                  }, null, 2),
                  t[329] || (t[329] = y("Date modified "))
                ], 2)
              ])
            ]),
            a("div", _Dt, [
              a("div", eNt, [
                V(a("input", {
                  type: "checkbox",
                  class: "form-check-input",
                  id: "showBlueChip",
                  value: "",
                  "onUpdate:modelValue": t[114] || (t[114] = (C) => e.searchParameters.blueChipOnly = C),
                  onChange: t[115] || (t[115] = (C) => e.refreshResults(!0))
                }, null, 544), [
                  [Ue, e.searchParameters.blueChipOnly]
                ]),
                t[331] || (t[331] = a("label", {
                  class: "form-check-label",
                  for: "showBlueChip"
                }, "Only Blue Chip", -1))
              ])
            ]),
            a("div", {
              class: "result-numbers align-items-center d-flex",
              "data-bs-toggle": "tooltip",
              "data-bs-placement": "bottom",
              "data-bs-title": e.tooltipInfo
            }, [
              t[335] || (t[335] = a("span", { class: "me-1 fw-bold d-md-none d-xxl-inline-block" }, " Displaying ", -1)),
              a("span", sNt, [
                e.filtered == e.blueChipTotal && e.blueChipTotal > 0 ? (p(), h("strong", aNt, g(e.number(e.blueChipTotal)), 1)) : e.filtered >= 0 && e.blueChipTotal == 0 ? (p(), h("strong", nNt, g(e.number(e.filtered)), 1)) : e.filtered > e.blueChipTotal && e.blueChipTotal > 0 ? (p(), h(A, { key: 2 }, [
                  e.filtered >= 0 ? (p(), h("strong", rNt, g(e.number(e.blueChipTotal)), 1)) : P("", !0),
                  t[332] || (t[332] = y(" / ")),
                  e.filtered >= 0 ? (p(), h("strong", oNt, g(e.number(e.filtered)), 1)) : P("", !0)
                ], 64)) : (p(), h("i", iNt)),
                t[333] || (t[333] = y(" / ")),
                e.totalInArea >= 0 ? (p(), h("strong", lNt, g(e.number(e.totalInArea)), 1)) : (p(), h("i", dNt)),
                t[334] || (t[334] = a("span", { class: "d-none d-lg-inline-block" }, " Listings", -1))
              ])
            ], 8, tNt)
          ])
        ]),
        a("div", cNt, [
          a("div", uNt, [
            e.searching ? (p(), h("div", pNt, t[336] || (t[336] = [
              Bt('<svg class="loader me-2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 340 340"><circle cx="170" cy="170" r="160" stroke="#F26E34"></circle><circle cx="170" cy="170" r="135" stroke="#132844"></circle><circle cx="170" cy="170" r="110" stroke="#F26E34"></circle><circle cx="170" cy="170" r="85" stroke="#132844"></circle></svg><span class="fw-bold h5 mb-0">Processing...</span>', 2)
            ]))) : e.noResults && e.totalInArea > 0 ? (p(), h("div", hNt, [
              t[341] || (t[341] = a("img", {
                src: NS,
                alt: "Rescover",
                title: "Rescover",
                loading: "lazy",
                height: "155",
                width: "135",
                class: "img-fluid mb-3 mb-lg-0"
              }, null, -1)),
              a("div", null, [
                t[337] || (t[337] = y(" There are ")),
                a("strong", mNt, g(e.number(e.totalInArea)), 1),
                t[338] || (t[338] = y(" active properties in this area,")),
                t[339] || (t[339] = a("br", null, null, -1)),
                t[340] || (t[340] = y("but we could not find any that matched your filter criteria. "))
              ])
            ])) : e.noResults && !e.featuredSearch ? (p(), h("div", fNt, t[342] || (t[342] = [
              a("img", {
                src: NS,
                alt: "Rescover",
                title: "Rescover",
                loading: "lazy",
                height: "155",
                width: "135",
                class: "img-fluid mb-3 mb-lg-0"
              }, null, -1),
              a("div", null, [
                a("p", null, [
                  a("strong", null, " Not finding any active listings? This might be because there are no homes up for sale right now in this area, or we're still in the process of becoming a broker member of the local MLS. ")
                ]),
                a("p", null, " Are you a Realtor searching for listings in this area and also a member of the local MLS? Rescover can connect with your MLS as a vendor and incorporate this data feed into your account. With Investment Gateway, you can explore your MLS, generate custom-branded property reports, offer your clients free access, and even integrate an IDX widget into your website to showcase standout investment properties. Ready to upgrade your service? Start by connecting with our enterprise team today! ")
              ], -1)
            ]))) : P("", !0),
            e.listings.length > 0 ? (p(), h("div", gNt, [
              a("div", {
                id: "results",
                class: z(["row row-cols-1 g-4", e.listingResultsClasses])
              }, [
                (p(!0), h(A, null, D(e.activePaged, (C) => (p(), Fe(u, {
                  key: C.id,
                  listing: C,
                  selected: e.selectedListingTag == C.id,
                  onViewListing: e.viewListing,
                  onSelectListing: e.selectListing
                }, null, 8, ["listing", "selected", "onViewListing", "onSelectListing"]))), 128))
              ], 2),
              a("div", vNt, [
                a("div", yNt, [
                  N(m, {
                    rows: e.ActivePageSize,
                    first: e.firstRecord,
                    "onUpdate:first": t[116] || (t[116] = (C) => e.firstRecord = C),
                    totalRecords: e.active.length,
                    alwaysShow: !1,
                    template: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport",
                    onPage: t[117] || (t[117] = (C) => e.onPageActive(C)),
                    currentPageReportTemplate: "Showing {first} to {last} of {totalRecords} listings"
                  }, null, 8, ["rows", "first", "totalRecords"])
                ])
              ])
            ])) : P("", !0)
          ])
        ])
      ])
    ], 2),
    a("div", bNt, [
      a("div", ANt, [
        a("div", wNt, [
          t[345] || (t[345] = a("div", { class: "modal-header pb-0 border-0" }, [
            a("p", {
              class: "modal-title fw-bold fs-5",
              id: "saveSearchLabel"
            }, "Save Search Query"),
            a("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            })
          ], -1)),
          a("div", CNt, [
            t[344] || (t[344] = a("p", null, "You can save this to your search profile to view later or have lists auto-featured to your inbox daily.", -1)),
            e.newSearchNameAlert ? (p(), h("div", SNt, g(e.newSearchNameAlert), 1)) : P("", !0),
            a("div", null, [
              t[343] || (t[343] = a("label", { class: "form-label" }, "Search name:", -1)),
              V(a("input", {
                type: "text",
                id: "searchName",
                name: "searchName",
                "onUpdate:modelValue": t[118] || (t[118] = (C) => e.newSearchName = C),
                maxlength: "50",
                class: "form-control searchName focus",
                placeholder: "ie: The Woodlands Area"
              }, null, 512), [
                [_e, e.newSearchName]
              ]),
              a("div", PNt, g(50 - (((b = e.newSearchName) == null ? void 0 : b.length) ?? 0)) + " characters remaining.", 1)
            ])
          ]),
          a("div", kNt, [
            a("button", {
              onClick: t[119] || (t[119] = (...C) => e.saveSearch && e.saveSearch(...C)),
              id: "btnSaveSearch",
              class: "btn btn-lava saveSearch",
              disabled: !e.canCreate
            }, g(e.btnSaveSearchModelLabel), 9, ENt)
          ])
        ])
      ])
    ], 512),
    t[451] || (t[451] = Bt('<div class="modal fade" id="modalInfoListings" tabindex="-1" aria-labelledby="modalInfoListingsLabel" aria-hidden="true"><div class="modal-dialog modal-dialog-centered"><div class="modal-content bg-gradient-alphabet rounded"><div class="modal-header pb-0 border-0"><p class="modal-title fw-bold fs-5" id="modalInfoListingsLabel">Information</p><button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button></div><div class="modal-body"> What area active listings and qualified features are... </div></div></div></div>', 1)),
    a("div", INt, [
      a("div", TNt, [
        a("div", ONt, [
          t[397] || (t[397] = a("div", { class: "modal-header" }, [
            a("p", {
              class: "fw-bold modal-title h5",
              id: "modalFiltersLabel"
            }, "Filters"),
            a("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            })
          ], -1)),
          a("div", RNt, [
            a("div", LNt, [
              a("div", BNt, [
                a("h2", MNt, [
                  a("button", {
                    ref: "btnFilters",
                    class: "accordion-button rounded fw-bold bg-white border-0 shadow-none",
                    type: "button",
                    "data-bs-toggle": "collapse",
                    "data-bs-target": "#collapseOne",
                    "aria-expanded": "true",
                    "aria-controls": "collapseOne"
                  }, g(e.priceFilterLabel), 513)
                ]),
                a("div", xNt, [
                  a("div", FNt, [
                    a("div", VNt, [
                      t[347] || (t[347] = a("div", { class: "col-12 fw-bold" }, " Filter By ", -1)),
                      a("div", DNt, [
                        V(a("select", {
                          id: "sqft-min",
                          "aria-label": "Filter price by",
                          "onUpdate:modelValue": t[120] || (t[120] = (C) => e.searchParameters.byPurchasePrice = C),
                          class: "form-select"
                        }, t[346] || (t[346] = [
                          a("option", { value: !0 }, "Purchase Price", -1),
                          a("option", { value: !1 }, "Total Investment", -1)
                        ]), 512), [
                          [We, e.searchParameters.byPurchasePrice]
                        ])
                      ])
                    ]),
                    a("div", NNt, [
                      a("div", jNt, [
                        t[349] || (t[349] = a("label", {
                          for: "priceMinimum",
                          class: "form-label"
                        }, "Minimum", -1)),
                        V(a("select", {
                          class: "form-select",
                          id: "priceMinimum",
                          "onUpdate:modelValue": t[121] || (t[121] = (C) => e.searchParameters.minPrice = C)
                        }, [
                          t[348] || (t[348] = a("option", { value: 0 }, "No Min", -1)),
                          (p(!0), h(A, null, D(e.priceList, (C) => (p(), h("option", { value: C }, g(e.currency(C)), 9, HNt))), 256))
                        ], 512), [
                          [We, e.searchParameters.minPrice]
                        ])
                      ]),
                      t[352] || (t[352] = a("div", { class: "col-2 d-flex align-items-center justify-content-center text-secondary pt-5" }, " - ", -1)),
                      a("div", UNt, [
                        t[351] || (t[351] = a("label", {
                          for: "priceMaximum",
                          class: "form-label"
                        }, "Maximum", -1)),
                        V(a("select", {
                          class: "form-select",
                          id: "priceMaximum",
                          "onUpdate:modelValue": t[122] || (t[122] = (C) => e.searchParameters.maxPrice = C)
                        }, [
                          t[350] || (t[350] = a("option", { value: 0 }, "No Max", -1)),
                          (p(!0), h(A, null, D(e.priceList, (C) => (p(), h("option", { value: C }, g(e.currency(C)), 9, zNt))), 256))
                        ], 512), [
                          [We, e.searchParameters.maxPrice]
                        ])
                      ]),
                      a("div", WNt, [
                        a("small", GNt, "Total invesment based on " + g(e.percent(e.downpayment)) + " down payment, plus closing costs. Edit financial parameters to adjust these settings.", 1)
                      ])
                    ])
                  ])
                ])
              ]),
              a("div", YNt, [
                a("h2", XNt, [
                  a("button", qNt, " Baths & Beds ", 512)
                ]),
                a("div", QNt, [
                  a("div", KNt, [
                    t[364] || (t[364] = a("p", { class: "h6 fw-bold text-secondary" }, "NUMBER OF BEDS", -1)),
                    a("div", ZNt, [
                      V(a("input", {
                        type: "radio",
                        class: "btn-check",
                        id: "bedAny",
                        "onUpdate:modelValue": t[123] || (t[123] = (C) => e.searchParameters.minBedrooms = C),
                        value: 0,
                        autocomplete: "off"
                      }, null, 512), [
                        [Mt, e.searchParameters.minBedrooms]
                      ]),
                      t[353] || (t[353] = a("label", {
                        class: "btn btn-outline-eclipse no-anim",
                        for: "bedAny"
                      }, "Any", -1)),
                      V(a("input", {
                        type: "radio",
                        class: "btn-check",
                        id: "bed1",
                        "onUpdate:modelValue": t[124] || (t[124] = (C) => e.searchParameters.minBedrooms = C),
                        value: 1,
                        autocomplete: "off"
                      }, null, 512), [
                        [Mt, e.searchParameters.minBedrooms]
                      ]),
                      t[354] || (t[354] = a("label", {
                        class: "btn btn-outline-eclipse no-anim",
                        for: "bed1"
                      }, "1+", -1)),
                      V(a("input", {
                        type: "radio",
                        class: "btn-check",
                        id: "bed2",
                        "onUpdate:modelValue": t[125] || (t[125] = (C) => e.searchParameters.minBedrooms = C),
                        value: 2,
                        autocomplete: "off"
                      }, null, 512), [
                        [Mt, e.searchParameters.minBedrooms]
                      ]),
                      t[355] || (t[355] = a("label", {
                        class: "btn btn-outline-eclipse no-anim",
                        for: "bed2"
                      }, "2+", -1)),
                      V(a("input", {
                        type: "radio",
                        class: "btn-check",
                        id: "bed3",
                        "onUpdate:modelValue": t[126] || (t[126] = (C) => e.searchParameters.minBedrooms = C),
                        value: 3,
                        autocomplete: "off"
                      }, null, 512), [
                        [Mt, e.searchParameters.minBedrooms]
                      ]),
                      t[356] || (t[356] = a("label", {
                        class: "btn btn-outline-eclipse no-anim",
                        for: "bed3"
                      }, "3+", -1)),
                      V(a("input", {
                        type: "radio",
                        class: "btn-check",
                        id: "bed4",
                        "onUpdate:modelValue": t[127] || (t[127] = (C) => e.searchParameters.minBedrooms = C),
                        value: 4,
                        autocomplete: "off"
                      }, null, 512), [
                        [Mt, e.searchParameters.minBedrooms]
                      ]),
                      t[357] || (t[357] = a("label", {
                        class: "btn btn-outline-eclipse no-anim",
                        for: "bed4"
                      }, "4+", -1)),
                      V(a("input", {
                        type: "radio",
                        class: "btn-check",
                        id: "bed5",
                        "onUpdate:modelValue": t[128] || (t[128] = (C) => e.searchParameters.minBedrooms = C),
                        value: 5,
                        autocomplete: "off"
                      }, null, 512), [
                        [Mt, e.searchParameters.minBedrooms]
                      ]),
                      t[358] || (t[358] = a("label", {
                        class: "btn btn-outline-eclipse no-anim",
                        for: "bed5"
                      }, "5+", -1))
                    ]),
                    t[365] || (t[365] = a("p", { class: "h6 fw-bold text-secondary" }, "NUMBER OF BATHS", -1)),
                    a("div", JNt, [
                      a("div", $Nt, [
                        V(a("input", {
                          type: "radio",
                          class: "btn-check",
                          id: "bathAny",
                          "onUpdate:modelValue": t[129] || (t[129] = (C) => e.searchParameters.minBathrooms = C),
                          value: 0,
                          autocomplete: "off"
                        }, null, 512), [
                          [Mt, e.searchParameters.minBathrooms]
                        ]),
                        t[359] || (t[359] = a("label", {
                          class: "btn btn-outline-eclipse no-anim",
                          for: "bathAny"
                        }, "Any", -1)),
                        V(a("input", {
                          type: "radio",
                          class: "btn-check",
                          id: "bath1",
                          "onUpdate:modelValue": t[130] || (t[130] = (C) => e.searchParameters.minBathrooms = C),
                          value: 1,
                          autocomplete: "off"
                        }, null, 512), [
                          [Mt, e.searchParameters.minBathrooms]
                        ]),
                        t[360] || (t[360] = a("label", {
                          class: "btn btn-outline-eclipse no-anim",
                          for: "bath1"
                        }, "1+", -1)),
                        V(a("input", {
                          type: "radio",
                          class: "btn-check",
                          id: "bath2",
                          "onUpdate:modelValue": t[131] || (t[131] = (C) => e.searchParameters.minBathrooms = C),
                          value: 2,
                          autocomplete: "off"
                        }, null, 512), [
                          [Mt, e.searchParameters.minBathrooms]
                        ]),
                        t[361] || (t[361] = a("label", {
                          class: "btn btn-outline-eclipse no-anim",
                          for: "bath2"
                        }, "2+", -1)),
                        V(a("input", {
                          type: "radio",
                          class: "btn-check",
                          id: "bath3",
                          "onUpdate:modelValue": t[132] || (t[132] = (C) => e.searchParameters.minBathrooms = C),
                          value: 3,
                          autocomplete: "off"
                        }, null, 512), [
                          [Mt, e.searchParameters.minBathrooms]
                        ]),
                        t[362] || (t[362] = a("label", {
                          class: "btn btn-outline-eclipse no-anim",
                          for: "bath3"
                        }, "3+", -1)),
                        V(a("input", {
                          type: "radio",
                          class: "btn-check",
                          id: "bath4",
                          "onUpdate:modelValue": t[133] || (t[133] = (C) => e.searchParameters.minBathrooms = C),
                          value: 4,
                          autocomplete: "off"
                        }, null, 512), [
                          [Mt, e.searchParameters.minBathrooms]
                        ]),
                        t[363] || (t[363] = a("label", {
                          class: "btn btn-outline-eclipse no-anim",
                          for: "bath4"
                        }, "4+", -1))
                      ])
                    ])
                  ])
                ])
              ]),
              a("div", _Nt, [
                a("h2", ejt, [
                  a("button", tjt, " Home Type ", 512)
                ]),
                a("div", sjt, [
                  a("div", ajt, [
                    a("div", njt, [
                      a("div", rjt, [
                        V(a("input", {
                          class: "form-check-input",
                          name: "homeTypes",
                          type: "checkbox",
                          value: "",
                          id: "typeHouses",
                          "onUpdate:modelValue": t[134] || (t[134] = (C) => e.typeHouse = C)
                        }, null, 512), [
                          [Ue, e.typeHouse]
                        ]),
                        t[366] || (t[366] = a("label", {
                          class: "form-check-label",
                          for: "typeHouses"
                        }, " Houses ", -1))
                      ]),
                      a("div", ojt, [
                        V(a("input", {
                          class: "form-check-input",
                          name: "homeTypes",
                          type: "checkbox",
                          value: "",
                          id: "typeTownhomes",
                          "onUpdate:modelValue": t[135] || (t[135] = (C) => e.typeTownhouse = C)
                        }, null, 512), [
                          [Ue, e.typeTownhouse]
                        ]),
                        t[367] || (t[367] = a("label", {
                          class: "form-check-label",
                          for: "typeTownhomes"
                        }, " Townhomes ", -1))
                      ]),
                      a("div", ijt, [
                        V(a("input", {
                          class: "form-check-input",
                          name: "homeTypes",
                          type: "checkbox",
                          value: "",
                          id: "typeMultifamily",
                          "onUpdate:modelValue": t[136] || (t[136] = (C) => e.typeMultiFamily = C)
                        }, null, 512), [
                          [Ue, e.typeMultiFamily]
                        ]),
                        t[368] || (t[368] = a("label", {
                          class: "form-check-label",
                          for: "typeMultifamily"
                        }, " Multi-family ", -1))
                      ]),
                      a("div", ljt, [
                        V(a("input", {
                          class: "form-check-input",
                          name: "homeTypes",
                          type: "checkbox",
                          value: "",
                          id: "typeCondos",
                          "onUpdate:modelValue": t[137] || (t[137] = (C) => e.typeCondo = C)
                        }, null, 512), [
                          [Ue, e.typeCondo]
                        ]),
                        t[369] || (t[369] = a("label", {
                          class: "form-check-label",
                          for: "typeCondos"
                        }, " Condos/Co-ops ", -1))
                      ]),
                      a("div", djt, [
                        V(a("input", {
                          class: "form-check-input",
                          name: "homeTypes",
                          type: "checkbox",
                          value: "",
                          id: "typeManufactured",
                          "onUpdate:modelValue": t[138] || (t[138] = (C) => e.typeManufactured = C)
                        }, null, 512), [
                          [Ue, e.typeManufactured]
                        ]),
                        t[370] || (t[370] = a("label", {
                          class: "form-check-label",
                          for: "typeManufactured"
                        }, " Manufactured ", -1))
                      ])
                    ]),
                    a("div", cjt, [
                      V(a("input", {
                        class: "form-check-input",
                        name: "homeTypes",
                        type: "checkbox",
                        role: "switch",
                        id: "typeLots",
                        "onUpdate:modelValue": t[139] || (t[139] = (C) => e.searchParameters.includeLand = C)
                      }, null, 512), [
                        [Ue, e.searchParameters.includeLand]
                      ]),
                      t[371] || (t[371] = a("label", {
                        class: "form-check-label",
                        for: "typeLots"
                      }, "Show Lots/Land", -1))
                    ])
                  ])
                ])
              ]),
              a("div", ujt, [
                a("h2", pjt, [
                  a("button", hjt, " More Filters ", 512)
                ]),
                a("div", mjt, [
                  a("div", fjt, [
                    a("div", gjt, [
                      a("div", vjt, [
                        t[384] || (t[384] = a("div", { class: "col-12 fw-bold" }, " Square Feet ", -1)),
                        a("div", yjt, [
                          t[373] || (t[373] = a("label", {
                            for: "inputEmail4",
                            class: "form-label visually-hidden"
                          }, "Minimum", -1)),
                          V(a("select", {
                            id: "sqft-min",
                            "aria-label": "Square feet min",
                            "onUpdate:modelValue": t[140] || (t[140] = (C) => e.searchParameters.minSqft = C),
                            class: "form-select"
                          }, t[372] || (t[372] = [
                            a("option", { value: 0 }, "No Min", -1),
                            a("option", { value: 500 }, "500", -1),
                            a("option", { value: 750 }, "750", -1),
                            a("option", { value: 1e3 }, "1,000", -1),
                            a("option", { value: 1250 }, "1,250", -1),
                            a("option", { value: 1500 }, "1,500", -1),
                            a("option", { value: 1750 }, "1,750", -1),
                            a("option", { value: 2e3 }, "2,000", -1),
                            a("option", { value: 2250 }, "2,250", -1),
                            a("option", { value: 2500 }, "2,500", -1),
                            a("option", { value: 2750 }, "2,750", -1),
                            a("option", { value: 3e3 }, "3,000", -1),
                            a("option", { value: 3500 }, "3,500", -1),
                            a("option", { value: 4e3 }, "4,000", -1),
                            a("option", { value: 5e3 }, "5,000", -1),
                            a("option", { value: 7500 }, "7,500", -1)
                          ]), 512), [
                            [We, e.searchParameters.minSqft]
                          ])
                        ]),
                        t[385] || (t[385] = a("div", { class: "col-2 text-center mt-2" }, " - ", -1)),
                        a("div", bjt, [
                          t[375] || (t[375] = a("label", {
                            for: "inputPassword4",
                            class: "form-label visually-hidden"
                          }, "Maximum", -1)),
                          V(a("select", {
                            id: "sqft-max",
                            "aria-label": "Square feet max",
                            "onUpdate:modelValue": t[141] || (t[141] = (C) => e.searchParameters.maxSqft = C),
                            class: "form-select"
                          }, t[374] || (t[374] = [
                            a("option", { value: 0 }, "No Max", -1),
                            a("option", { value: 500 }, "500", -1),
                            a("option", { value: 750 }, "750", -1),
                            a("option", { value: 1e3 }, "1,000", -1),
                            a("option", { value: 1250 }, "1,250", -1),
                            a("option", { value: 1500 }, "1,500", -1),
                            a("option", { value: 1750 }, "1,750", -1),
                            a("option", { value: 2e3 }, "2,000", -1),
                            a("option", { value: 2250 }, "2,250", -1),
                            a("option", { value: 2500 }, "2,500", -1),
                            a("option", { value: 2750 }, "2,750", -1),
                            a("option", { value: 3e3 }, "3,000", -1),
                            a("option", { value: 3500 }, "3,500", -1),
                            a("option", { value: 4e3 }, "4,000", -1),
                            a("option", { value: 5e3 }, "5,000", -1),
                            a("option", { value: 7500 }, "7,500", -1)
                          ]), 512), [
                            [We, e.searchParameters.maxSqft]
                          ])
                        ]),
                        t[386] || (t[386] = a("div", { class: "col-12 fw-bold mt-2" }, " Lot Size ", -1)),
                        a("div", Ajt, [
                          t[377] || (t[377] = a("label", {
                            for: "inputEmail4",
                            class: "form-label visually-hidden"
                          }, "Minimum", -1)),
                          V(a("select", {
                            id: "lotSize-min",
                            "aria-label": "Lot size min",
                            "onUpdate:modelValue": t[142] || (t[142] = (C) => e.searchParameters.minLotSize = C),
                            class: "form-select"
                          }, t[376] || (t[376] = [
                            a("option", { value: 0 }, "No Min", -1),
                            a("option", { value: 1e3 }, "1,000 sqft", -1),
                            a("option", { value: 2e3 }, "2,000 sqft", -1),
                            a("option", { value: 3e3 }, "3,000 sqft", -1),
                            a("option", { value: 4e3 }, "4,000 sqft", -1),
                            a("option", { value: 5e3 }, "5,000 sqft", -1),
                            a("option", { value: 7500 }, "7,500 sqft", -1),
                            a("option", { value: 10890 }, "1/4 acre/10,890 sqft", -1),
                            a("option", { value: 21780 }, "1/2 acre", -1),
                            a("option", { value: 43560 }, "1 acre", -1),
                            a("option", { value: 87120 }, "2 acres", -1),
                            a("option", { value: 217800 }, "5 acres", -1),
                            a("option", { value: 435600 }, "10 acres", -1),
                            a("option", { value: 871200 }, "20 acres", -1),
                            a("option", { value: 2178e3 }, "50 acres", -1),
                            a("option", { value: 4356e3 }, "100 acres", -1)
                          ]), 512), [
                            [We, e.searchParameters.minLotSize]
                          ])
                        ]),
                        t[387] || (t[387] = a("div", { class: "col-2 text-center mt-2" }, " - ", -1)),
                        a("div", wjt, [
                          t[379] || (t[379] = a("label", {
                            for: "inputPassword4",
                            class: "form-label visually-hidden"
                          }, "Maximum", -1)),
                          V(a("select", {
                            id: "lotSize-max",
                            "aria-label": "Lot size max",
                            "onUpdate:modelValue": t[143] || (t[143] = (C) => e.searchParameters.maxLotSize = C),
                            class: "form-select"
                          }, t[378] || (t[378] = [
                            a("option", { value: 0 }, "No Max", -1),
                            a("option", { value: 1e3 }, "1,000 sqft", -1),
                            a("option", { value: 2e3 }, "2,000 sqft", -1),
                            a("option", { value: 3e3 }, "3,000 sqft", -1),
                            a("option", { value: 4e3 }, "4,000 sqft", -1),
                            a("option", { value: 5e3 }, "5,000 sqft", -1),
                            a("option", { value: 7500 }, "7,500 sqft", -1),
                            a("option", { value: 10890 }, "1/4 acre/10,890 sqft", -1),
                            a("option", { value: 21780 }, "1/2 acre", -1),
                            a("option", { value: 43560 }, "1 acre", -1),
                            a("option", { value: 87120 }, "2 acres", -1),
                            a("option", { value: 217800 }, "5 acres", -1),
                            a("option", { value: 435600 }, "10 acres", -1),
                            a("option", { value: 871200 }, "20 acres", -1),
                            a("option", { value: 2178e3 }, "50 acres", -1),
                            a("option", { value: 4356e3 }, "100 acres", -1)
                          ]), 512), [
                            [We, e.searchParameters.maxLotSize]
                          ])
                        ]),
                        t[388] || (t[388] = a("div", { class: "col-12 fw-bold mt-2" }, " Year Built ", -1)),
                        a("div", Cjt, [
                          t[381] || (t[381] = a("label", {
                            for: "inputEmail4",
                            class: "form-label visually-hidden"
                          }, "Minimum", -1)),
                          V(a("select", {
                            id: "Year-Built-min",
                            class: "form-select",
                            "onUpdate:modelValue": t[144] || (t[144] = (C) => e.searchParameters.minYearbuilt = C)
                          }, [
                            t[380] || (t[380] = a("option", { value: 0 }, "No Min", -1)),
                            (p(!0), h(A, null, D(e.yearRange, (C) => (p(), h("option", { value: C }, g(C), 9, Sjt))), 256))
                          ], 512), [
                            [We, e.searchParameters.minYearbuilt]
                          ])
                        ]),
                        t[389] || (t[389] = a("div", { class: "col-2 text-center mt-2 text-secondary" }, " - ", -1)),
                        a("div", Pjt, [
                          t[383] || (t[383] = a("label", {
                            for: "inputPassword4",
                            class: "form-label visually-hidden"
                          }, "Maximum", -1)),
                          V(a("select", {
                            id: "Year-Built-max",
                            class: "form-select",
                            "onUpdate:modelValue": t[145] || (t[145] = (C) => e.searchParameters.maxYearbuilt = C)
                          }, [
                            t[382] || (t[382] = a("option", { value: 0 }, "No Max", -1)),
                            (p(!0), h(A, null, D(e.yearRange, (C) => (p(), h("option", { value: C }, g(C), 9, kjt))), 256))
                          ], 512), [
                            [We, e.searchParameters.maxYearbuilt]
                          ])
                        ])
                      ])
                    ]),
                    P("", !0),
                    a("div", Ejt, [
                      t[392] || (t[392] = a("p", { class: "fw-bold mb-2" }, "Number of Stores", -1)),
                      a("div", Ijt, [
                        V(a("input", {
                          class: "form-check-input",
                          type: "checkbox",
                          "onUpdate:modelValue": t[146] || (t[146] = (C) => e.singleStoryOnly = C),
                          id: "singlestoryOnly"
                        }, null, 512), [
                          [Ue, e.singleStoryOnly]
                        ]),
                        t[391] || (t[391] = a("label", {
                          class: "form-check-label",
                          for: "singlestoryOnly"
                        }, " Single-story only ", -1))
                      ])
                    ]),
                    P("", !0),
                    P("", !0),
                    a("div", null, [
                      t[396] || (t[396] = a("label", {
                        class: "fw-bold mb-2",
                        for: "daysOnRescover"
                      }, "Days on Rescover", -1)),
                      V(a("select", {
                        class: "form-select",
                        id: "daysOnRescover",
                        "onUpdate:modelValue": t[147] || (t[147] = (C) => e.searchParameters.daysOnRescover = C)
                      }, t[395] || (t[395] = [
                        a("option", { value: 0 }, "Any", -1),
                        a("option", { value: 1 }, "1 day", -1),
                        a("option", { value: 7 }, "7 days", -1),
                        a("option", { value: 14 }, "14 days", -1),
                        a("option", { value: 30 }, "30 days", -1),
                        a("option", { value: 90 }, "90 days", -1),
                        a("option", { value: 180 }, "6 months", -1),
                        a("option", { value: 365 }, "12 months", -1)
                      ]), 512), [
                        [We, e.searchParameters.daysOnRescover]
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ]),
          a("div", Tjt, [
            a("button", {
              type: "button",
              class: "btn btn-outline-eclipse flex-fill",
              onClick: t[148] || (t[148] = (C) => e.clearSearchFilters(e.$refs.btnFilters)),
              "data-bs-dismiss": "modal"
            }, "Clear all Filters"),
            a("button", {
              type: "button",
              class: "btn btn-eclipse flex-fill",
              onClick: t[149] || (t[149] = (C) => e.searchProperties(e.$refs.btnFilters)),
              "data-bs-dismiss": "modal"
            }, "Apply")
          ])
        ])
      ])
    ]),
    a("div", Ojt, [
      a("div", Rjt, [
        a("div", Ljt, [
          t[449] || (t[449] = a("div", { class: "modal-header" }, [
            a("p", {
              class: "fw-bold modal-title h5",
              id: "modalFinancialLabel"
            }, "Financial Parameters"),
            a("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            })
          ], -1)),
          a("div", Bjt, [
            t[440] || (t[440] = a("p", { class: "h6 fw-bold text-secondary" }, "PROPOSED HOLD PERIOD", -1)),
            a("div", Mjt, [
              a("div", xjt, [
                a("div", Fjt, [
                  V(a("input", {
                    class: "form-check-input",
                    type: "checkbox",
                    role: "switch",
                    id: "holdPeriod2",
                    "onUpdate:modelValue": t[150] || (t[150] = (C) => e.autoHoldPeriod = C)
                  }, null, 512), [
                    [Ue, e.autoHoldPeriod]
                  ]),
                  t[398] || (t[398] = a("label", {
                    class: "form-check-label",
                    for: "holdPeriod2"
                  }, "Auto", -1))
                ])
              ]),
              e.autoHoldPeriod ? P("", !0) : (p(), h("div", Vjt, " OR ")),
              a("div", Djt, [
                e.autoHoldPeriod ? (p(), h("span", Hjt, "AUTO")) : V((p(), h("select", {
                  key: 0,
                  class: "form-select form-select-sm",
                  "onUpdate:modelValue": t[151] || (t[151] = (C) => e.searchParameters.hold = C),
                  disabled: e.appBusy
                }, [
                  (p(), h(A, null, D(30, (C) => a("option", {
                    value: C,
                    key: C
                  }, g(C) + " Years", 9, jjt)), 64))
                ], 8, Njt)), [
                  [We, e.searchParameters.hold]
                ])
              ])
            ]),
            t[441] || (t[441] = a("p", { class: "h6 fw-bold text-secondary" }, " BLUE CHIP PERFORMANCE REQUIREMENTS ", -1)),
            a("div", Ujt, [
              a("div", zjt, [
                t[400] || (t[400] = a("label", {
                  for: "bcCapRate",
                  class: "form-label"
                }, "Cap Rate", -1)),
                a("div", Wjt, [
                  V(a("input", {
                    type: "text",
                    id: "bcCapRate",
                    name: "bcCapRate",
                    "onUpdate:modelValue": t[152] || (t[152] = (C) => e.minCapRate = C),
                    class: "form-control"
                  }, null, 512), [
                    [_e, e.minCapRate]
                  ]),
                  t[399] || (t[399] = a("span", { class: "input-group-text" }, "%", -1))
                ])
              ]),
              a("div", Gjt, [
                t[402] || (t[402] = a("label", {
                  for: "bcCoC",
                  class: "form-label"
                }, "Cash on Cash", -1)),
                a("div", Yjt, [
                  V(a("input", {
                    type: "text",
                    id: "bcCoC",
                    name: "bcCoC",
                    "onUpdate:modelValue": t[153] || (t[153] = (C) => e.minCoC = C),
                    class: "form-control"
                  }, null, 512), [
                    [_e, e.minCoC]
                  ]),
                  t[401] || (t[401] = a("span", { class: "input-group-text" }, "%", -1))
                ])
              ]),
              a("div", Xjt, [
                t[404] || (t[404] = a("label", {
                  for: "bcIRR",
                  class: "form-label"
                }, "IRR", -1)),
                a("div", qjt, [
                  V(a("input", {
                    type: "text",
                    id: "bcIRR",
                    name: "bcIRR",
                    "onUpdate:modelValue": t[154] || (t[154] = (C) => e.minIRR = C),
                    class: "form-control"
                  }, null, 512), [
                    [_e, e.minIRR]
                  ]),
                  t[403] || (t[403] = a("span", { class: "input-group-text" }, "%", -1))
                ])
              ])
            ]),
            t[442] || (t[442] = a("p", { class: "h6 fw-bold text-secondary" }, " LOAN DETAILS ", -1)),
            a("div", Qjt, [
              a("div", Kjt, [
                t[406] || (t[406] = a("label", {
                  for: "downpayment",
                  class: "form-label"
                }, "Down Payment", -1)),
                a("div", Zjt, [
                  V(a("input", {
                    type: "text",
                    id: "downpayment",
                    name: "downpayment",
                    "onUpdate:modelValue": t[155] || (t[155] = (C) => e.downpaymentWhole = C),
                    class: "form-control"
                  }, null, 512), [
                    [_e, e.downpaymentWhole]
                  ]),
                  t[405] || (t[405] = a("span", { class: "input-group-text" }, "%", -1))
                ])
              ]),
              a("div", Jjt, [
                t[408] || (t[408] = a("label", {
                  for: "interestrate",
                  class: "form-label"
                }, "Interest Rate %", -1)),
                a("div", $jt, [
                  V(a("input", {
                    type: "text",
                    id: "interestrate",
                    name: "interestrate",
                    "onUpdate:modelValue": t[156] || (t[156] = (C) => e.interestrateWhole = C),
                    class: "form-control"
                  }, null, 512), [
                    [_e, e.interestrateWhole]
                  ]),
                  t[407] || (t[407] = a("span", { class: "input-group-text" }, "%", -1))
                ])
              ]),
              a("div", _jt, [
                t[409] || (t[409] = a("label", {
                  for: "amortizationPeriod",
                  class: "form-label"
                }, "Amortization Period", -1)),
                V(a("input", {
                  type: "text",
                  id: "amortizationPeriod",
                  name: "amortizationPeriod",
                  "onUpdate:modelValue": t[157] || (t[157] = (C) => e.amortizationPeriod = C),
                  class: "form-control"
                }, null, 512), [
                  [_e, e.amortizationPeriod]
                ])
              ]),
              a("div", eHt, [
                t[411] || (t[411] = a("label", {
                  for: "loanfees",
                  class: "form-label"
                }, "Loan Fees", -1)),
                a("div", tHt, [
                  V(a("input", {
                    type: "text",
                    id: "loanfees",
                    name: "loanfees",
                    "onUpdate:modelValue": t[158] || (t[158] = (C) => e.loanfeesWhole = C),
                    class: "form-control"
                  }, null, 512), [
                    [_e, e.loanfeesWhole]
                  ]),
                  t[410] || (t[410] = a("span", { class: "input-group-text" }, "%", -1))
                ])
              ]),
              a("div", sHt, [
                t[413] || (t[413] = a("label", {
                  for: "interestOnlyLoan",
                  class: "form-label"
                }, "Interest Only Loan?", -1)),
                a("div", aHt, [
                  V(a("input", {
                    class: "form-check-input",
                    type: "checkbox",
                    "onUpdate:modelValue": t[159] || (t[159] = (C) => e.searchParameters.interestOnlyLoan = C),
                    role: "switch",
                    id: "interestOnlyLoan"
                  }, null, 512), [
                    [Ue, e.searchParameters.interestOnlyLoan]
                  ]),
                  t[412] || (t[412] = a("label", {
                    class: "form-check-label",
                    for: "interestOnlyLoan"
                  }, "Yes", -1))
                ])
              ]),
              e.searchParameters.interestOnlyLoan ? (p(), h("div", nHt, [
                t[415] || (t[415] = a("label", {
                  for: "interestOnlyTerm",
                  class: "form-label"
                }, "Interest Only Term", -1)),
                V(a("select", {
                  id: "interestOnlyTerm",
                  "onUpdate:modelValue": t[160] || (t[160] = (C) => e.searchParameters.interestOnlyTerm = C),
                  class: "form-select"
                }, [
                  t[414] || (t[414] = a("option", { value: "360" }, "Full Term", -1)),
                  (p(!0), h(A, null, D(e.interestOnlyTerms, (C) => (p(), h("option", { value: C }, g(C) + " Months", 9, rHt))), 256))
                ], 512), [
                  [
                    We,
                    e.searchParameters.interestOnlyTerm,
                    void 0,
                    { number: !0 }
                  ]
                ])
              ])) : P("", !0)
            ]),
            t[443] || (t[443] = a("p", { class: "h6 fw-bold text-secondary" }, " CLOSING COSTS (EXCLUDING LOAN FEES) ", -1)),
            a("div", oHt, [
              t[417] || (t[417] = a("label", {
                for: "inputEmail4",
                class: "col-6 col-form-label"
              }, "Title Charges", -1)),
              a("div", iHt, [
                a("div", lHt, [
                  t[416] || (t[416] = a("span", { class: "input-group-text" }, "$", -1)),
                  V(a("input", {
                    type: "text",
                    id: "titlecharges",
                    name: "titlecharges",
                    "onUpdate:modelValue": t[161] || (t[161] = (C) => e.titlecharges = C),
                    class: "form-control"
                  }, null, 512), [
                    [_e, e.titlecharges]
                  ])
                ])
              ])
            ]),
            t[444] || (t[444] = a("p", { class: "h6 fw-bold text-secondary" }, " VACANCY ", -1)),
            a("div", dHt, [
              a("div", cHt, [
                t[419] || (t[419] = a("label", {
                  for: "averagelengthofstay",
                  class: "form-label"
                }, "Average Length of Stay", -1)),
                V(a("select", {
                  id: "averagelengthofstay",
                  class: "form-select",
                  "onUpdate:modelValue": t[162] || (t[162] = (C) => e.searchParameters.averageLengthOfStay = C),
                  name: "averagelengthofstay"
                }, t[418] || (t[418] = [
                  a("option", { value: 1 }, "1 Year", -1),
                  a("option", { value: 2 }, "2 Years", -1),
                  a("option", { value: 3 }, "3 Years", -1),
                  a("option", { value: 4 }, "4 Years", -1),
                  a("option", { value: 5 }, "5 Years", -1),
                  a("option", { value: 6 }, "6 Years", -1),
                  a("option", { value: 7 }, "7 Years", -1),
                  a("option", { value: 8 }, "8 Years", -1),
                  a("option", { value: 9 }, "9 Years", -1),
                  a("option", { value: 10 }, "10 Years", -1)
                ]), 512), [
                  [We, e.searchParameters.averageLengthOfStay]
                ])
              ]),
              a("div", null, [
                t[420] || (t[420] = a("label", {
                  for: "timebetweentenants",
                  class: "form-label"
                }, "Average Time Between Tenants (days)", -1)),
                V(a("input", {
                  type: "text",
                  id: "timebetweentenants",
                  name: "timebetweentenants",
                  "onUpdate:modelValue": t[163] || (t[163] = (C) => e.timebetweentenants = C),
                  class: "form-control"
                }, null, 512), [
                  [_e, e.timebetweentenants]
                ])
              ])
            ]),
            t[445] || (t[445] = a("p", { class: "h6 fw-bold text-secondary" }, " MAINTENANCE & CAPITAL EXPENDITURES ", -1)),
            a("div", uHt, [
              a("div", pHt, [
                t[422] || (t[422] = a("label", {
                  for: "maintenance",
                  class: "form-label"
                }, "Maint. Expense (% of Gross Income)", -1)),
                a("div", hHt, [
                  V(a("input", {
                    type: "text",
                    id: "maintenance",
                    name: "maintenance",
                    "onUpdate:modelValue": t[164] || (t[164] = (C) => e.maintenanceWhole = C),
                    class: "form-control"
                  }, null, 512), [
                    [_e, e.maintenanceWhole]
                  ]),
                  t[421] || (t[421] = a("span", { class: "input-group-text" }, "%", -1))
                ])
              ]),
              a("div", null, [
                t[424] || (t[424] = a("label", {
                  for: "capitalExpenditure",
                  class: "form-label"
                }, "Capital Expenditures (% of Gross Income)", -1)),
                a("div", mHt, [
                  V(a("input", {
                    type: "text",
                    id: "capitalExpenditure",
                    name: "capitalExpenditure",
                    "onUpdate:modelValue": t[165] || (t[165] = (C) => e.capitalExpendituresWhole = C),
                    class: "form-control"
                  }, null, 512), [
                    [_e, e.capitalExpendituresWhole]
                  ]),
                  t[423] || (t[423] = a("span", { class: "input-group-text" }, "%", -1))
                ])
              ])
            ]),
            t[446] || (t[446] = a("p", { class: "h6 fw-bold text-secondary" }, " LEASING AND RESALE EXPENSES ", -1)),
            a("div", fHt, [
              a("div", gHt, [
                t[426] || (t[426] = a("label", {
                  for: "leasecommission",
                  class: "form-label"
                }, "Lease Commission (% of 1 month's rent)", -1)),
                a("div", vHt, [
                  V(a("input", {
                    type: "text",
                    id: "leasecommission",
                    name: "leasecommission",
                    "onUpdate:modelValue": t[166] || (t[166] = (C) => e.leasecommissionWhole = C),
                    class: "form-control"
                  }, null, 512), [
                    [_e, e.leasecommissionWhole]
                  ]),
                  t[425] || (t[425] = a("span", { class: "input-group-text" }, "%", -1))
                ])
              ]),
              a("div", yHt, [
                t[428] || (t[428] = a("label", {
                  for: "leaserenewalfee",
                  class: "form-label"
                }, "Lease Renewal Fee (% of 1 month's rent)", -1)),
                a("div", bHt, [
                  V(a("input", {
                    type: "text",
                    id: "leaserenewalfee",
                    name: "leaserenewalfee",
                    "onUpdate:modelValue": t[167] || (t[167] = (C) => e.leaserenewalfeeWhole = C),
                    class: "form-control"
                  }, null, 512), [
                    [_e, e.leaserenewalfeeWhole]
                  ]),
                  t[427] || (t[427] = a("span", { class: "input-group-text" }, "%", -1))
                ])
              ]),
              a("div", null, [
                t[430] || (t[430] = a("label", {
                  for: "costofsale",
                  class: "form-label"
                }, "Cost of Sale %", -1)),
                a("div", AHt, [
                  V(a("input", {
                    type: "text",
                    id: "costofsale",
                    name: "costofsale",
                    "onUpdate:modelValue": t[168] || (t[168] = (C) => e.costofsaleWhole = C),
                    placeholder: "ie: 8",
                    class: "form-control"
                  }, null, 512), [
                    [_e, e.costofsaleWhole]
                  ]),
                  t[429] || (t[429] = a("span", { class: "input-group-text" }, "%", -1))
                ])
              ])
            ]),
            t[447] || (t[447] = a("p", { class: "h6 fw-bold text-secondary" }, " MANAGEMENT EXPENSES ", -1)),
            a("div", wHt, [
              a("div", CHt, [
                t[432] || (t[432] = a("label", {
                  for: "percentManagementFee",
                  class: "form-label"
                }, "Monthly Management", -1)),
                V(a("select", {
                  id: "percentManagementFee",
                  class: "autocalc form-select",
                  "onUpdate:modelValue": t[169] || (t[169] = (C) => e.isManagementFeePercent = C),
                  name: "percentManagementFee"
                }, t[431] || (t[431] = [
                  a("option", { value: !1 }, "Flat", -1),
                  a("option", { value: !0 }, "Percentage", -1)
                ]), 512), [
                  [We, e.isManagementFeePercent]
                ])
              ]),
              a("div", null, [
                t[433] || (t[433] = a("label", {
                  for: "managementfee",
                  class: "form-label"
                }, "Monthly Management Fee", -1)),
                N(d, {
                  modelValue: e.searchParameters.managementFee,
                  "onUpdate:modelValue": t[170] || (t[170] = (C) => e.searchParameters.managementFee = C),
                  percent: e.isManagementFeePercent,
                  currency: !e.isManagementFeePercent
                }, null, 8, ["modelValue", "percent", "currency"])
              ])
            ]),
            t[448] || (t[448] = a("p", { class: "h6 fw-bold text-secondary" }, " INFLATION & APPRECIATION ", -1)),
            a("div", SHt, [
              a("div", PHt, [
                t[435] || (t[435] = a("label", {
                  for: "annualrentalgrowth",
                  class: "form-label"
                }, "Annual Rental Rate Increase", -1)),
                a("div", kHt, [
                  V(a("input", {
                    id: "annualrentalgrowth",
                    type: "text",
                    name: "annualrentalgrowth",
                    "onUpdate:modelValue": t[171] || (t[171] = (C) => e.annualRentalGrowth = C),
                    class: "form-control"
                  }, null, 512), [
                    [_e, e.annualRentalGrowth]
                  ]),
                  t[434] || (t[434] = a("span", { class: "input-group-text" }, "%", -1))
                ])
              ]),
              a("div", EHt, [
                t[437] || (t[437] = a("label", {
                  for: "annualexpensegrowth",
                  class: "form-label"
                }, "Annual Expense Inflation", -1)),
                a("div", IHt, [
                  V(a("input", {
                    id: "annualexpensegrowth",
                    type: "text",
                    name: "annualexpensegrowth",
                    "onUpdate:modelValue": t[172] || (t[172] = (C) => e.annualExpenseGrowth = C),
                    class: "form-control"
                  }, null, 512), [
                    [_e, e.annualExpenseGrowth]
                  ]),
                  t[436] || (t[436] = a("span", { class: "input-group-text" }, "%", -1))
                ])
              ]),
              a("div", null, [
                t[439] || (t[439] = a("label", {
                  for: "propertyappreciation",
                  class: "form-label"
                }, "Annual Property Appreciation", -1)),
                a("div", THt, [
                  V(a("input", {
                    type: "text",
                    id: "propertyappreciation",
                    name: "propertyappreciation",
                    "onUpdate:modelValue": t[173] || (t[173] = (C) => e.propertyAppreciation = C),
                    class: "form-control"
                  }, null, 512), [
                    [_e, e.propertyAppreciation]
                  ]),
                  t[438] || (t[438] = a("span", { class: "input-group-text" }, "%", -1))
                ])
              ])
            ])
          ]),
          a("div", OHt, [
            a("div", RHt, [
              a("button", {
                type: "button",
                class: "btn btn-eclipse flex-grow-1 flex-fill mb-2",
                onClick: t[174] || (t[174] = (C) => e.searchProperties(e.$refs.btnFinancialParametersModal))
              }, "Apply"),
              a("div", LHt, [
                a("button", {
                  type: "button",
                  class: "btn btn-outline-eclipse flex-fill",
                  onClick: t[175] || (t[175] = (C) => e.undoFinancialParamsChanges(e.$refs.btnFinancialParametersModal))
                }, "Undo Changes"),
                a("button", {
                  type: "button",
                  class: "btn btn-outline-eclipse flex-fill",
                  onClick: t[176] || (t[176] = (C) => e.saveDefaults(e.$refs.btnFinancialParametersModal))
                }, "Save Defaults")
              ])
            ]),
            a("div", BHt, [
              V(a("button", {
                type: "button",
                "data-bs-toggle": "modal",
                "data-bs-target": "#saveSearch",
                class: "btn btn-lava launchModal flex-fill",
                disabled: !e.canSave
              }, " Save Search ", 8, MHt), [
                [Us, !((w = e.selectedSearch) != null && w.name) || ((I = (S = e.selectedSearch) == null ? void 0 : S.name) == null ? void 0 : I.length) == 0]
              ]),
              V(a("button", {
                type: "button",
                onClick: t[177] || (t[177] = (...C) => e.saveSearch && e.saveSearch(...C)),
                class: "btn btn-lava updateSavedSearch",
                disabled: !e.canSave
              }, " Update ", 8, xHt), [
                [Us, ((T = e.selectedSearch) == null ? void 0 : T.name) && ((k = (x = e.selectedSearch) == null ? void 0 : x.name) == null ? void 0 : k.length) > 0]
              ])
            ])
          ])
        ])
      ])
    ], 512)
  ], 64);
}
const pds = /* @__PURE__ */ Ae(hxt, [["render", FHt]]), tv = {
  Start: "start",
  MapOutlines: "mapOutlines",
  ZipCodes: "zipCodes",
  MlsFeatures: "mlsFeatures",
  ShowResults: "showResults"
}, Nl = {
  EstimatedEquity: "estimated-equity",
  AuctionDate: "auction-date"
}, Kn = {
  Tile: "tile",
  Map: "map"
};
class VHt {
  /**
   * The default render function for the library used by {@link MarkerClusterer}.
   *
   * Currently set to use the following:
   *
   * ```typescript
   * // change color if this cluster has more markers than the mean cluster
   * const color =
   *   count > Math.max(10, stats.clusters.markers.mean)
   *     ? "#ff0000"
   *     : "#0000ff";
   *
   * // create svg url with fill color
   * const svg = window.btoa(`
   * <svg fill="${color}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240">
   *   <circle cx="120" cy="120" opacity=".6" r="70" />
   *   <circle cx="120" cy="120" opacity=".3" r="90" />
   *   <circle cx="120" cy="120" opacity=".2" r="110" />
   *   <circle cx="120" cy="120" opacity=".1" r="130" />
   * </svg>`);
   *
   * // create marker using svg icon
   * return new google.maps.Marker({
   *   position,
   *   icon: {
   *     url: `data:image/svg+xml;base64,${svg}`,
   *     scaledSize: new google.maps.Size(45, 45),
   *   },
   *   label: {
   *     text: String(count),
   *     color: "rgba(255,255,255,0.9)",
   *     fontSize: "12px",
   *   },
   *   // adjust zIndex to be above other markers
   *   zIndex: 1000 + count,
   * });
   * ```
   */
  constructor(t, s) {
    Xe(this, "largeColor", "#800080");
    Xe(this, "smallColor", "#0000ff");
    t && (this.largeColor = t), s && (this.smallColor = s);
  }
  render({ count: t, position: s }, n) {
    const r = t > Math.max(10, n.clusters.markers.mean) ? this.largeColor : this.smallColor, i = window.btoa(`
  <svg fill="${r}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240">
    <circle cx="120" cy="120" opacity=".6" r="70" />
    <circle cx="120" cy="120" opacity=".3" r="90" />
    <circle cx="120" cy="120" opacity=".2" r="110" />
  </svg>`);
    return new google.maps.Marker({
      position: s,
      icon: {
        url: `data:image/svg+xml;base64,${i}`,
        scaledSize: new google.maps.Size(45, 45)
      },
      label: {
        text: String(t),
        color: "rgba(255,255,255,0.9)",
        fontSize: "12px"
      },
      title: `Cluster of ${t} listings`,
      // adjust zIndex to be above other markers
      zIndex: Number(google.maps.Marker.MAX_ZINDEX) + t
    });
  }
}
const DHt = "/images/map/pin-pre-foreclosure.png?v3", NHt = me({
  name: "PreForeclosureSearch",
  enums: {
    SortBy: Nl,
    SearchType: Or,
    SearchStep: tv
  },
  directives: {
    resize: OE
  },
  components: {
    ListingTile: Kb,
    Features: LE,
    Performance: BE,
    VueTagsInput: Wk,
    Paginator: Vm
  },
  props: {
    googleApi: {
      type: String,
      required: !0
    }
  },
  data() {
    return {
      googleMapsSdkReady: !1,
      debounce: void 0,
      access: void 0,
      headerHeight: 0,
      zip: window.zip,
      map: window.map,
      search_name: window.s_name,
      //#region Area Map
      areaMapCenter: void 0,
      areaMapOptions: void 0,
      //#endregion
      //#region Map
      listingsMapOptions: void 0,
      center: void 0,
      defaultMarkerOptions: void 0,
      iconMarkerSelected: void 0,
      isTilted: !1,
      fullScreenMap: !1,
      //#endregion
      //#region Zip
      zips: [],
      autocompleteItems: [],
      zipValidation: [
        {
          classes: "zip5-only",
          rule: /^([0-9]{5})$/,
          disableAdd: !0,
          autoAdd: !0
        }
      ],
      //#endregion
      searching: !1,
      noResults: !1,
      runningCalculator: 0,
      totalInArea: void 0,
      totalWithCriteria: void 0,
      totalQualified: void 0,
      listings: [],
      page: 0,
      pageSize: 50,
      selectedTile: void 0,
      blueChipOnly: !1,
      view: Kn.Map,
      searchType: void 0,
      jsonCoords: [],
      totalListings: 0,
      sort_by: Nl.EstimatedEquity,
      sort_asc: !0,
      currentStep: tv.Start,
      searchParameters: {
        minprice: 75e3,
        maxprice: 35e4,
        minsqft: 1e3,
        maxsqft: 4e3,
        minyearbuilt: 2015,
        maxyearbuilt: 2021,
        minbedrooms: 2,
        maxbedrooms: 5,
        minbathrooms: 2,
        maxbathrooms: 4,
        minGarage: 2,
        maxGarage: 5,
        minStories: 1,
        maxStories: 2,
        minFireplaces: 0,
        maxFireplaces: 2,
        minLotSize: 0,
        maxLotSize: 5e4,
        minPriceSqFt: 0,
        maxPriceSqFt: 100,
        pool: 0,
        elementaryRating: 4,
        intermediateRating: 4,
        jrHighRating: 4,
        highSchoolRating: 4
      },
      states: [],
      state: void 0,
      stateCounties: {},
      counties: [],
      county: void 0
    };
  },
  watch: {
    zip: "zipAutoComplete",
    state: "listCounties"
  },
  computed: {
    areaSelected() {
      return this.jsonCoords.length > 0;
    },
    zipSelected() {
      return this.zips && this.zips.length > 0;
    },
    countySelected() {
      return this.state != null && this.state != "" && this.county != null && this.county != "";
    },
    calculating() {
      return this.runningCalculator > 0;
    },
    qualified() {
      return this.blueChipOnly ? this.listings.filter((e) => e.blueChip == !0).sort(this.sortListing) : [...this.listings].sort(this.sortListing);
    },
    paged() {
      const e = this.page * this.pageSize, t = e + this.pageSize;
      return this.blueChipOnly ? this.listings.filter((s) => s.blueChip == !0).sort(this.sortListing).slice(e, t) : [...this.listings].sort(this.sortListing).slice(e, t);
    },
    blueChip() {
      return this.listings.filter((e) => e.blueChip == !0).sort(this.sortListing);
    },
    viewTypeClasses() {
      return {
        showMap: this.view != Kn.Tile,
        "tile-view": this.view == Kn.Tile
      };
    },
    listingResultsClasses() {
      return {
        //'row-cols-xl-2': (this.view != ViewType.Tile),
        "row-cols-md-2": this.view == Kn.Tile,
        "row-cols-lg-3": this.view == Kn.Tile,
        "row-cols-xl-4": this.view == Kn.Tile,
        "row-cols-xxl-5": this.view == Kn.Tile,
        "row-cols-kilo-6": this.view == Kn.Tile
      };
    },
    ...q(Te, ["isClient", "isAdmin", "isUser"])
  },
  methods: {
    number: Ve,
    zipsChanged(e) {
      this.autocompleteItems.length = 0;
    },
    zipAutoComplete() {
      !this.zip || this.zip.length < 2 || (clearTimeout(this.debounce), this.debounce = setTimeout(async () => {
        try {
          if (!this.zip || this.zip.length < 2)
            return;
          this.autocompleteItems.length = 0;
          const e = await W.api.geo.zipLookup(this.zip);
          if (e.data.status != de.Success)
            throw new Error(e.data.message);
          this.autocompleteItems.push(...e.data.result.map((t) => ({
            text: t
          })));
        } catch (e) {
          let t = new Cs("Zip Lookup Error", e.message);
          t.stay = !0, Ss(t);
        }
      }, 600));
    },
    async saveSearch() {
    },
    activeStepClasses(e) {
      return {
        active: this.currentStep == e
      };
    },
    onPage(e) {
      this.page = e.page, this.pageSize = e.rows;
    },
    handleResize() {
      const e = document.documentElement.clientHeight, t = $("#resultListingHeader").height();
      let s = 0;
      $("footer").css("display") == "none" || $("footer").css("visibility") == "hidden" ? s = 0 : s = $("footer").height();
      const n = e - this.headerHeight - t - s + 1, r = $(".searchOptions").height(), i = n - r;
      $(".map, .results-listing").css("height", n + "px").css("top", t + "px"), $("#searchUpdate").css("height", i + "px");
    },
    sortButtonClass(e) {
      return {
        selected: this.sort_by == e,
        asc: this.sort_by == e && this.sort_asc,
        des: this.sort_by == e && !this.sort_asc
      };
    },
    sortIconClass(e) {
      return {
        "fa-sort-amount-down-alt": this.sort_by == e && this.sort_asc,
        "fa-sort-amount-down": this.sort_by == e && !this.sort_asc
      };
    },
    toggleBlueChip(e) {
      this.blueChipOnly = e.target.checked;
    },
    //#region Area Map
    initAreaMap() {
      this.areaMapCenter = {
        lat: 30.173937,
        lng: -95.505836
      }, console.log("location", this.areaMapCenter), this.areaMapOptions = {
        zoom: 10,
        styles: De.Map.Styles.Default,
        restriction: {
          latLngBounds: De.Map.UsBounds
        }
      }, this.searchMap = this.$refs.areaMap.$mapObject, navigator.geolocation && navigator.geolocation.getCurrentPosition(
        (t) => {
          console.log("location from browser"), this.areaMapCenter = {
            lat: t.coords.latitude,
            lng: t.coords.longitude
          };
        },
        () => {
        }
      );
      const e = new google.maps.drawing.DrawingManager({
        drawingMode: google.maps.drawing.OverlayType.POLYGON,
        drawingControl: !0,
        drawingControlOptions: {
          position: google.maps.ControlPosition.TOP_CENTER,
          drawingModes: [
            google.maps.drawing.OverlayType.POLYGON
          ]
        },
        circleOptions: {
          fillColor: "#ffff00",
          fillOpacity: 0.2,
          strokeWeight: 2,
          clickable: !1,
          editable: !0,
          zIndex: 1
        }
      });
      google.maps.event.addListener(e, "overlaycomplete", (t) => this.mapAreaSelected(t)), google.maps.event.addListener(e, "overlaycomplete", (t) => {
        this.newShape = t.overlay, this.setSelection(this.newShape), google.maps.event.addListener(this.newShape, "click", () => {
          this.setSelection(this.newShape);
        });
      }), e.setMap(this.searchMap);
    },
    clearSelection() {
      this.selectedShape && (this.selectedShape.setMap(null), this.selectedShape.setEditable(!1), this.selectedShape = void 0);
    },
    setSelection(e) {
      this.clearSelection(), this.selectedShape = e, e.setEditable(!0);
    },
    mapAreaSelected(e) {
      this.searchType = Or.Map;
      let t = e.overlay.getPath();
      this.jsonCoords.length = 0;
      for (var s = 0; s < t.getLength(); s++) {
        var n = t.getAt(s);
        this.jsonCoords.push({
          lat: n.lat(),
          lng: n.lng()
        });
      }
    },
    resetMap() {
      this.jsonCoords.length = 0;
    },
    //#endregion
    //#region Map
    mapInit() {
      this.bounds = new google.maps.LatLngBounds(), this.center = {
        lat: 30.173937,
        lng: -95.505836
      }, this.listingsMapOptions = {
        zoom: 10,
        styles: De.Map.Styles.Default,
        disableDefaultUI: !0,
        streetViewControl: !0,
        streetViewControlOptions: {
          position: google.maps.ControlPosition.LEFT_BOTTOM
        },
        restriction: {
          latLngBounds: De.Map.UsBounds
        }
      }, this.defaultMarkerOptions = {
        animation: google.maps.Animation.DROP,
        icon: DHt,
        zIndex: 500,
        visible: !0
      }, this.googleMapsSdkReady = !0;
    },
    onMapClick(e) {
      console.log(`${this.$options.name}.onMapClick`), this.infoWindowClose(void 0, this.selectedMarker);
    },
    onMapBoundsChanged(e, t) {
      var s, n;
      console.log(`${this.$options.name}.onMapBoundsChanged`), this.isTilted = t, t ? (s = this.$refs.rotateView) == null || s.classList.remove("hidden") : (n = this.$refs.rotateView) == null || n.classList.add("hidden");
    },
    onPanoVisibleChanged(e) {
      console.log(`${this.$options.name}.onPanoVisibleChanged`, e);
      let t = 2;
      e.getVisible() ? (t = 0, $(".tiles").css({
        "z-index": 3
        // 'height': (listHeight - 180) + 'px'
      })) : $(".tiles").css({
        "z-index": 2
        // 'height': (listHeight) + 'px'
      }), $("#showResults").css("z-index", t);
    },
    markerSelected(e, t, s) {
      console.log(`${this.$options.name}.markerSelected`, e, t, s), this.selectListing(e);
    },
    infoWindowOpen(e, t) {
      console.log(`${this.$options.name}.infoWindowOpen`, t.getTitle()), t.setIcon(this.iconMarkerSelected ?? t.getIcon()), t.setZIndex(2e3), console.log("selectedMarker set"), this.selectedMarker = t;
    },
    infoWindowClose(e, t) {
      console.log(`${this.$options.name}.infoWindowClose`, e, t.getTitle()), e ? (this.listings.filter((s) => s.propId == e.$attrs.propId).forEach((s) => s.open = !1), this.selectedTile = void 0) : this.selectedTile && (this.listings.filter((s) => s.propId == this.selectedTile).forEach((s) => s.open = !1), this.selectedTile = void 0);
    },
    viewListing(e) {
      console.log("viewListing", e.propId), e && e.queryString ? window.open(e.url + e.queryString, `_${e.id}`) : window.open(e.url, `_${e.id}`);
    },
    selectListing(e) {
      if (console.log(`${this.$options.name}.selectListing`, e.id), this.view == Kn.Tile && this.viewListing(e), this.listings.filter((t) => t.open === !0 && t.id != e.id).forEach((t) => {
        console.log("closing", t.id), t.open = !1;
      }), this.selectedMarker && this.selectedMarker.setZIndex(500), e && this.selectedTile == e.id) {
        e.open = !1;
        return;
      }
      if (e) {
        console.log("opening", e.propId, e.open, !e.open), e.open = !e.open, this.selectedTile = e.id;
        {
          const t = {
            lat: e.latitude,
            lng: e.longitude
          }, s = this.$refs.gMap.$mapObject;
          s && (s.panTo(t), s.setZoom(17), s.panBy(0, 0));
        }
      } else
        console.log("listing not found", e);
    },
    //#endregion
    isListingVisible(e) {
      return !(this.blueChipOnly == !0 && e.qualified == !1);
    },
    async searchProperties() {
      console.log(`${this.$options.name}.searchProperties`, this.searchType), this.listings.length = 0, this.totalInArea = void 0, this.totalWithCriteria = void 0, this.totalQualified = void 0, await this.calculatingLock.runExclusive(async () => {
        this.runningCalculator = 0;
      }), this.currentStep = tv.ShowResults, this.searching = !0, this.handleResize();
      let e = "";
      switch (this.searchType) {
        case Or.Map:
          e = "";
          for (var t = 0; t < this.jsonCoords.length; t++)
            e += `&points=${this.jsonCoords[t].lng},${this.jsonCoords[t].lat}`;
          break;
        case Or.Zip:
          e = this.zips.map((o) => o.text).join(",");
          break;
        case Or.County:
          e = `${this.state},${this.county}`;
          break;
      }
      var s = 50;
      try {
        const o = {
          type: this.searchType,
          query: e,
          pool: this.searchParameters.pool,
          parameters: this.searchParameters
        }, l = await W.api.preForeclosure.search(o);
        if (l.data.status != de.Success)
          throw new Error(l.data.message);
        this.searching = !1;
        var n = l.data.results;
        if (this.totalInArea = l.data.totalArea, this.totalWithCriteria = l.data.total, this.totalWithCriteria == 0) {
          this.noResults = !0;
          return;
        }
        this.totalWithCriteria < s && (s = this.totalWithCriteria), this.totalListings = 0;
        for (let d = 0; d < this.totalWithCriteria; ) {
          var r = d + s;
          r > this.totalWithCriteria && (r = this.totalWithCriteria);
          var i = n.slice(d, r);
          d = d + s, await this.calculatingLock.runExclusive(async () => {
            this.runningCalculator++;
          }), this.calculate(i, this.searchParameters);
        }
      } catch (o) {
        this.searching = !1, Ss(new Cs(
          "Error",
          o.message,
          fn.error
        ));
      }
    },
    async calculate(e, t) {
      var s;
      try {
        const n = {
          ids: e,
          searchPrefs: t
        }, r = await W.api.preForeclosure.calculate(n);
        if (r.data.status != de.Success)
          throw new Error(r.data.message);
        this.listings.push(...r.data.results);
        const i = this.$refs.gMap.$mapObject;
        i && ((s = r.data.results) == null || s.forEach((o) => {
          var l;
          (l = this.bounds) == null || l.extend({
            lat: o.latitude,
            lng: o.longitude
          });
        }), i.fitBounds(this.bounds), i.getZoom() > 14 && i.setZoom(14), i.panBy(0, 0)), await this.pageLock.runExclusive(() => {
          var o;
          this.totalListings += ((o = r.data.results) == null ? void 0 : o.length) ?? 0;
        }), this.handleResize();
      } catch (n) {
        Ss(new Cs(
          "Calculator Error",
          n.message,
          fn.error,
          jo.Center
        ));
      }
      await this.calculatingLock.runExclusive(() => {
        this.runningCalculator > 0 && this.runningCalculator--, this.runningCalculator == 0 && (this.noResults = this.listings.length == 0);
      });
    },
    sortListing(e, t) {
      if (this.sort_asc)
        switch (this.sort_by) {
          case Nl.AuctionDate:
            return t.auctionDate ? e.auctionDate ? t.auctionDate.getTime() - e.auctionDate.getTime() : 1 : -1;
          default:
          case Nl.EstimatedEquity:
            return (t.estimatedEquity ?? 0) - (e.estimatedEquity ?? 0);
        }
      else
        switch (this.sort_by) {
          case Nl.AuctionDate:
            return e.auctionDate ? t.auctionDate ? e.auctionDate.getTime() - t.auctionDate.getTime() : 1 : -1;
          default:
          case Nl.EstimatedEquity:
            return (e.estimatedEquity ?? 0) - (t.estimatedEquity ?? 0);
        }
    },
    sortTile(e) {
      this.sort_by === e ? this.sort_asc = !this.sort_asc : this.sort_by = e;
    },
    async changeStep(e, t, s, n) {
      console.log("changeStep", t, s, n), s && (this.searchType = s), n && await this.resetSearchParameters(), this.currentStep = t;
    },
    toggleView(e) {
      console.log("toggleView", e.target.checked), this.view = e.target.checked ? Kn.Tile : Kn.Map;
    },
    async resetSearchParameters() {
      try {
        const e = await W.api.searchMls.getSearchParameters(this.search_name);
        if (e.data.status != de.Success)
          throw new Error(e.data.message);
        this.searchParameters = e.data.parameters;
      } catch (e) {
        Ss(new Cs(
          "Calculator Error",
          e.message,
          fn.error,
          jo.Center
        ));
      }
    },
    //#region Map Controls
    zoomOut() {
      const e = this.$refs.gMap.$mapObject, t = e.getZoom();
      e.setZoom(t - 1);
    },
    zoomIn() {
      const e = this.$refs.gMap.$mapObject, t = e.getZoom();
      e.setZoom(t + 1);
    },
    mapController(e) {
      const s = e.target.dataset.type, n = this.$refs.gMap.$mapObject;
      switch (s) {
        /* Temporarily disabled
        case "sateliteView":
            map.setMapTypeId('satellite');
            map.setTilt(45);
            //el.addClass('hidden');
            (this.$refs.sateliteView as HTMLButtonElement).classList.add('hidden');
            //$('a[href="mapview"]').removeClass('hidden');
            (this.$refs.mapView as HTMLButtonElement).classList.remove('hidden');
            //determine if 45 degree angle and show rotate button
            this.isTilted = map.getTilt() !== 0;
            break;
        case "rotateView":
            let heading = map.getHeading() || 0;
            map.setHeading(heading + 90);
            break;
        */
        case "mapView":
          n.setMapTypeId("roadmap"), this.$refs.mapView.classList.add("hidden"), this.$refs.sateliteView.classList.remove("hidden");
          break;
      }
      return !1;
    },
    //#endregion
    async listStates() {
      try {
        const e = await W.api.geo.states();
        if (e.data.status != de.Success)
          throw new Error(e.data.message);
        this.states.length = 0, this.states.push(...e.data.states);
      } catch (e) {
        console.error(e);
      }
    },
    async listCounties() {
      try {
        if (!this.stateCounties[this.state]) {
          const e = await W.api.geo.counties(this.state);
          if (e.data.status != de.Success)
            throw new Error(e.data.message);
          this.stateCounties[this.state] = e.data.counties;
        }
        this.counties = this.stateCounties[this.state];
      } catch (e) {
        console.error(e);
      }
    },
    createPosition(e) {
      return new google.maps.LatLng(e.latitude, e.longitude);
    },
    preforeclosurePin() {
      if (this.googleMapsSdkReady)
        return new google.maps.marker.PinElement({
          glyphColor: "#d0ccde",
          background: "#c7bfe5",
          borderColor: "#341539"
        }).element;
    }
  },
  beforeCreate() {
    this.clusterRenderer = new VHt(De.Map.ClusterSmallColor, De.Map.ClusterSmallColor);
  },
  created() {
    this.pageLock = new xa(), this.calculatingLock = new xa();
  },
  async mounted() {
    try {
      const t = await W.api.account.access();
      this.access = t.data.result;
    } catch {
      this.access = {
        leads: {},
        properties: {},
        marketplace: {}
      };
    }
    this.listStates(), await this.resetSearchParameters();
    const e = Yr();
    if (e.browser && e.browser.name && document.body.classList.add("ua-browser-" + e.browser.name), e.device && e.device.type && document.body.classList.add("ua-devicetype-" + e.device.type), $(".nav-search .nav-link").addClass("active"), e.device && (e.device.type == "tablet" || e.device.type == "mobile") && (this.view = Kn.Tile), this.headerHeight = $("#navbar").height(), await this.$gmapApiPromiseLazy(), this.mapInit(), this.initAreaMap(), this.searchMap) {
      const t = await W.api.mls.coverage();
      new En().parseGeoJsonGeometry(this.searchMap, t.data.coverage, void 0, void 0, void 0, De.Colors.Maps.NoCoverage, 0.4);
    }
    if (this.zip && this.zip.length > 0)
      this.searchType = Or.Zip, this.zip.split(",").forEach((t) => {
        this.zips.push({ text: t });
      }), this.zip = "", await this.searchProperties();
    else if (this.map && this.map !== "") {
      this.searchType = Or.Map;
      let t = this.map.split("&points=");
      this.jsonCoords.length = 0;
      for (let s = 0; s < t.length; s++)
        if (t[s] !== "") {
          let n = t[s].split(",");
          this.jsonCoords.push({
            lat: vs(n[1]),
            lng: vs(n[0])
          });
        }
      await this.searchProperties();
    }
  }
}), jHt = "data:image/jpeg;base64,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", HHt = "data:image/jpeg;base64,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", UHt = "data:image/jpeg;base64,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", zHt = { class: "container py-4 py-md-5" }, WHt = { class: "row" }, GHt = {
  key: 0,
  class: "col-lg-3 sidenav"
}, YHt = { class: "nav nav-pills flex-column mls-nav d-none d-sm-block mb-3 mb-lg-0" }, XHt = { class: "col" }, qHt = {
  class: "wizard",
  id: "addSearch"
}, QHt = {
  key: 0,
  class: "wizardLauncher",
  id: "searchBy"
}, KHt = { class: "row row-cols-2 row-cols-md-3" }, ZHt = { id: "mapOutlines" }, JHt = { class: "card shadow-sm mb-3" }, $Ht = { class: "card-body" }, _Ht = { class: "card-text mb-0" }, eUt = { key: 0 }, tUt = { class: "row" }, sUt = { class: "col d-flex justify-content-md-between justify-content-center" }, aUt = ["disabled"], nUt = { class: "col-md-6 d-flex justify-content-md-end justify-content-center mt-2 mt-md-0" }, rUt = ["disabled"], oUt = {
  key: 1,
  id: "zipCodes"
}, iUt = { class: "row" }, lUt = { class: "col" }, dUt = { class: "card shadow-sm mb-3" }, cUt = { class: "row g-0" }, uUt = { class: "col" }, pUt = { class: "card-body" }, hUt = { class: "row" }, mUt = { class: "col-md-8 d-flex justify-content-md-end justify-content-center mt-2 mt-md-0" }, fUt = ["disabled"], gUt = {
  key: 2,
  id: "county"
}, vUt = { class: "row" }, yUt = { class: "col" }, bUt = { class: "card shadow-sm mb-3" }, AUt = { class: "row g-0" }, wUt = { class: "col" }, CUt = { class: "card-body" }, SUt = { class: "row g-3" }, PUt = { class: "col" }, kUt = ["value"], EUt = { class: "col" }, IUt = ["value"], TUt = { class: "row" }, OUt = { class: "col-md-8 d-flex justify-content-md-end justify-content-center mt-2 mt-md-0" }, RUt = ["disabled"], LUt = {
  class: "result-listing-header",
  id: "resultListingHeader"
}, BUt = { class: "container-fluid" }, MUt = { class: "row" }, xUt = { class: "col-md-6 bg-light" }, FUt = { class: "row" }, VUt = { class: "col-6 method bg-white d-flex align-items-center" }, DUt = { class: "p-2" }, NUt = { class: "fw-bold result-listing_result" }, jUt = {
  key: 3,
  class: "fa-duotone fa-solid fa-spinner-third fa-spin"
}, HUt = { class: "col-6" }, UUt = { class: "p-2" }, zUt = { class: "fw-bold result-listing_result" }, WUt = { key: 0 }, GUt = {
  key: 1,
  class: "fa-duotone fa-solid fa-spinner-third fa-spin"
}, YUt = { class: "col-md-6 bg-white d-none d-md-block" }, XUt = { class: "row d-flex align-items-center h-100 py-2 py-md-0" }, qUt = { class: "col text-start" }, QUt = { class: "form-check form-switch form-switch-lg" }, KUt = ["checked", "disabled"], ZUt = { class: "col-2 col-lg-3 col-xl-2 text-end d-none" }, JUt = {
  disabled: "",
  "data-bs-toggle": "modal",
  "data-bs-target": "#saveSearch",
  class: "btn btn-sm btn-outline-eclipse launchModal"
}, $Ut = { class: "results-listing bg-white" }, _Ut = {
  class: "box step form hideOthers",
  id: "showResults"
}, ezt = {
  id: "resultHeader",
  class: "searchOptions"
}, tzt = { class: "views py-3 d-flex justify-content-between flex-column flex-md-row" }, szt = { class: "mb-2 mb-md-0 text-center text-md-start" }, azt = {
  id: "tileSort",
  class: "text-center text-md-start"
}, nzt = {
  class: "btn-group",
  role: "group",
  "aria-label": "List sorting"
}, rzt = {
  key: 0,
  class: "loads d-flex justify-content-center align-items-center text-center py-3 d-lg-none"
}, ozt = {
  key: 1,
  class: "d-flex justify-content-center align-items-center text-center flex-column py-10"
}, izt = {
  key: 0,
  class: "results mlse-results mlse-estimator-listings"
}, lzt = { class: "row g-0 row-cols-1" }, dzt = { class: "map" }, czt = {
  key: 0,
  class: "loads text-center d-flex flex-column justify-content-center align-items-center position-absolute w-100"
}, uzt = { class: "fw-bold h5 mb-0" }, pzt = {
  id: "mapControls",
  class: "position-absolute d-none d-md-block"
}, hzt = {
  class: "modal fade form",
  id: "saveSearch",
  tabindex: "-1",
  "aria-labelledby": "modalSaveResults",
  "aria-hidden": "true"
}, mzt = { class: "modal-dialog" }, fzt = { class: "modal-content bg-gradient-alphabet rounded" }, gzt = { class: "modal-body" }, vzt = { class: "modal-footer" }, yzt = ["disabled"];
function bzt(e, t, s, n, r, i) {
  var b;
  const o = pe("GMapMap"), l = pe("vue-tags-input"), d = pe("listing-tile"), c = pe("paginator"), u = pe("GMapInfoWindow"), m = pe("GMapAdvMarker"), f = pe("GMapCluster"), v = Za("resize");
  return p(), h(A, null, [
    V(a("span", null, null, 512), [
      [v, e.handleResize]
    ]),
    t[75] || (t[75] = Bt('<div id="alerts"></div><span class="titleToggle d-none"><a href="#" class="resetWizard">Searches</a> / Add a Search </span><div class="hideOthers d-none" id="viewSaved"><div class="box"><div class="row gap"><p class="fs-3"> Search Results for <span></span><span class="right">These are the results based on your saved search.</span></p><hr><p id="searchingUpdate" class="text-center d-flex justify-content-center align-items-center">Searching...</p><div class="mlse-results-no mlse-estimator-listings"></div></div></div></div>', 3)),
    a("div", zHt, [
      a("div", WHt, [
        e.currentStep != e.SearchStep.ShowResults ? (p(), h("div", GHt, [
          t[26] || (t[26] = a("h1", { class: "fs-4 fw-bold mb-3" }, "Pre-Foreclosure Search", -1)),
          a("nav", YHt, [
            a("div", {
              class: z(["nav-link nav-area mb-1 mb-lg-3 mls-area", e.activeStepClasses(e.SearchStep.Start)])
            }, t[25] || (t[25] = [
              a("p", { class: "fw-bold fs-6 mb-0 mb-lg-1" }, "Area", -1),
              a("small", { class: "d-none d-lg-block" }, "Define your search area", -1)
            ]), 2)
          ])
        ])) : P("", !0),
        a("div", XHt, [
          a("div", qHt, [
            e.currentStep == e.SearchStep.Start ? (p(), h("div", QHt, [
              a("div", KHt, [
                a("div", {
                  onClick: t[0] || (t[0] = (w) => e.changeStep(w, e.SearchStep.MapOutlines, e.SearchType.Map)),
                  class: "col outlineContainer first",
                  style: { cursor: "pointer" }
                }, t[27] || (t[27] = [
                  a("div", { class: "card shadow-sm mb-3 mb-lg-0 toggleClasses" }, [
                    a("img", {
                      src: jHt,
                      alt: "Search by Outline",
                      title: "Search by Map Area",
                      loading: "lazy",
                      class: "card-img-top"
                    }),
                    a("div", { class: "card-body text-center" }, [
                      y(" Draw "),
                      a("span", { class: "d-none d-md-inline-block" }, "Outlines"),
                      y(" on a Map ")
                    ])
                  ], -1)
                ])),
                a("div", {
                  onClick: t[1] || (t[1] = (w) => e.changeStep(w, e.SearchStep.ZipCodes, e.SearchType.Zip)),
                  class: "col zipContainer",
                  style: { cursor: "pointer" }
                }, t[28] || (t[28] = [
                  a("div", { class: "card shadow-sm mb-3 mb-lg-0 toggleClasses" }, [
                    a("img", {
                      src: HHt,
                      alt: "Search by Zipcodes",
                      title: "Search by Zipcodes",
                      loading: "lazy",
                      class: "card-img-top"
                    }),
                    a("div", { class: "card-body text-center" }, " By Zipcodes ")
                  ], -1)
                ])),
                a("div", {
                  onClick: t[2] || (t[2] = (w) => e.changeStep(w, e.SearchStep.County, e.SearchType.County)),
                  class: "col zipContainer",
                  style: { cursor: "pointer" }
                }, t[29] || (t[29] = [
                  a("div", { class: "card shadow-sm toggleClasses" }, [
                    a("img", {
                      src: UHt,
                      alt: "Search by County",
                      title: "Search by County",
                      loading: "lazy",
                      class: "card-img-top"
                    }),
                    a("div", { class: "card-body text-center" }, " By County ")
                  ], -1)
                ]))
              ])
            ])) : P("", !0),
            V(a("div", ZHt, [
              a("div", JHt, [
                a("div", $Ht, [
                  t[32] || (t[32] = a("p", { class: "fs-5 card-title fw-bold mb-1" }, "Area Map Search", -1)),
                  a("p", _Ht, [
                    e.isClient ? (p(), h(A, { key: 1 }, [
                      t[30] || (t[30] = y(" Draw an outline in the un-masked area below that you want to search. In addition to the MLS ")),
                      (b = e.access) != null && b.courtesyOf ? (p(), h("strong", eUt, g(e.access.courtesyOf.company), 1)) : (p(), h(A, { key: 1 }, [
                        y(" your agent ")
                      ], 64)),
                      t[31] || (t[31] = y(" covers, publicly available Rescover MLS connections are also displayed. If you are interested in analyzing a specific house located outside the MLS coverage area, please go to the dashboard and type the address into the search bar. "))
                    ], 64)) : (p(), h(A, { key: 0 }, [
                      y(" Greyed out areas indicate that Rescover is not authorized to publicly display MLS data. As we become a broker in more states, we will join new MLSs and expand our MLS coverage. If you are a broker, or are working with a broker in an area of no coverage, please contact us to learn how to add your MLS. If you are interested in analyzing a specific house located outside the MLS coverage area, please go to the dashboard and type the address into the search bar. ")
                    ], 64))
                  ]),
                  t[33] || (t[33] = a("div", {
                    class: "alert alert-danger d-none",
                    role: "alert"
                  }, "Area missing, draw an outline anywhere content the map.", -1))
                ]),
                N(o, {
                  id: "map",
                  ref: "areaMap",
                  "map-id": "2ddbbe0dd6bcf8f9",
                  center: e.areaMapCenter,
                  options: e.areaMapOptions
                }, null, 8, ["center", "options"])
              ]),
              a("div", tUt, [
                a("div", sUt, [
                  a("button", {
                    onClick: t[3] || (t[3] = (...w) => e.resetMap && e.resetMap(...w)),
                    class: "btn btn-outline-dark resetMap",
                    disabled: !e.areaSelected
                  }, "Reset Map", 8, aUt)
                ]),
                a("div", nUt, [
                  a("button", {
                    onClick: t[4] || (t[4] = (...w) => e.searchProperties && e.searchProperties(...w)),
                    class: "searchProperties btn btn-accent-lacustral",
                    "aria-disabled": "true",
                    disabled: !e.areaSelected
                  }, t[34] || (t[34] = [
                    y(" Search Now! "),
                    a("i", { class: "fa-light fa-angle-right ms-2" }, null, -1)
                  ]), 8, rUt)
                ])
              ])
            ], 512), [
              [Us, e.currentStep == e.SearchStep.MapOutlines]
            ]),
            e.currentStep == e.SearchStep.ZipCodes ? (p(), h("div", oUt, [
              a("div", iUt, [
                a("div", lUt, [
                  a("div", dUt, [
                    a("div", cUt, [
                      t[37] || (t[37] = a("div", { class: "col-md-4 search-image-zip rounded-start" }, null, -1)),
                      a("div", uUt, [
                        a("div", pUt, [
                          t[35] || (t[35] = a("p", { class: "fs-5 card-title fw-bold mb-1" }, "Entering Zipcodes", -1)),
                          t[36] || (t[36] = a("p", { class: "card-text" }, "You can enter multiple zip codes, pressing space between them.", -1)),
                          N(l, {
                            modelValue: e.zip,
                            "onUpdate:modelValue": t[5] || (t[5] = (w) => e.zip = w),
                            tags: e.zips,
                            "onUpdate:tags": t[6] || (t[6] = (w) => e.zips = w),
                            "max-tags": 12,
                            "autocomplete-items": e.autocompleteItems,
                            "add-only-from-autocomplete": !1,
                            validation: e.zipValidation,
                            "add-on-key": [13, " ", ",", ";"],
                            placeholder: "ie: 77385, 77386",
                            separators: [" ", ",", ";"],
                            onTagsChanged: e.zipsChanged
                          }, null, 8, ["modelValue", "tags", "autocomplete-items", "validation", "onTagsChanged"])
                        ])
                      ])
                    ])
                  ]),
                  a("div", hUt, [
                    t[39] || (t[39] = a("div", { class: "col text-center text-md-start" }, null, -1)),
                    a("div", mUt, [
                      a("button", {
                        onClick: t[7] || (t[7] = (...w) => e.searchProperties && e.searchProperties(...w)),
                        class: "searchProperties btn btn-accent-lacustral btn-next",
                        "aria-disabled": "true",
                        disabled: !e.zipSelected
                      }, t[38] || (t[38] = [
                        y(" Search Now! "),
                        a("i", { class: "fa-light fa-angle-right ms-2" }, null, -1)
                      ]), 8, fUt)
                    ])
                  ])
                ])
              ])
            ])) : P("", !0),
            e.currentStep == "county" ? (p(), h("div", gUt, [
              a("div", vUt, [
                a("div", yUt, [
                  a("div", bUt, [
                    a("div", AUt, [
                      t[44] || (t[44] = a("div", { class: "col-md-4 search-image-county rounded-start" }, null, -1)),
                      a("div", wUt, [
                        a("div", CUt, [
                          t[42] || (t[42] = a("p", { class: "fs-5 card-title fw-bold mb-1" }, "Search Area- County Selection", -1)),
                          t[43] || (t[43] = a("p", null, "Define your search area by selecting a state and county below.", -1)),
                          a("div", SUt, [
                            a("div", PUt, [
                              t[40] || (t[40] = a("label", { class: "form-label" }, "Select a State", -1)),
                              V(a("select", {
                                "onUpdate:modelValue": t[8] || (t[8] = (w) => e.state = w),
                                class: "form-select"
                              }, [
                                (p(!0), h(A, null, D(e.states, (w) => (p(), h("option", {
                                  value: w.abv
                                }, g(w.name), 9, kUt))), 256))
                              ], 512), [
                                [We, e.state]
                              ])
                            ]),
                            a("div", EUt, [
                              t[41] || (t[41] = a("label", { class: "form-label" }, "Select a County", -1)),
                              V(a("select", {
                                "onUpdate:modelValue": t[9] || (t[9] = (w) => e.county = w),
                                class: "form-select"
                              }, [
                                (p(!0), h(A, null, D(e.counties, (w) => (p(), h("option", {
                                  value: w.name
                                }, g(w.name), 9, IUt))), 256))
                              ], 512), [
                                [We, e.county]
                              ])
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]),
                  a("div", TUt, [
                    t[46] || (t[46] = a("div", { class: "col text-center text-md-start" }, null, -1)),
                    a("div", OUt, [
                      a("button", {
                        onClick: t[10] || (t[10] = (...w) => e.searchProperties && e.searchProperties(...w)),
                        class: "searchProperties btn btn-accent-lacustral btn-next",
                        "aria-disabled": "true",
                        disabled: !e.countySelected
                      }, t[45] || (t[45] = [
                        y(" Search Now! "),
                        a("i", { class: "fa-light fa-angle-right ms-2" }, null, -1)
                      ]), 8, RUt)
                    ])
                  ])
                ])
              ])
            ])) : P("", !0),
            V(a("div", {
              class: z(e.viewTypeClasses),
              id: "listingResults"
            }, [
              a("div", LUt, [
                a("div", BUt, [
                  a("div", MUt, [
                    a("div", xUt, [
                      a("div", FUt, [
                        a("div", VUt, [
                          a("div", DUt, [
                            t[51] || (t[51] = a("span", { class: "text-secondary d-block d-lg-none d-xl-block" }, [
                              y(" Search "),
                              a("span", { class: "d-none d-lg-inline-block" }, "Area Method")
                            ], -1)),
                            a("span", NUt, [
                              a("strong", null, [
                                e.searchType == "zip" ? (p(), h(A, { key: 0 }, [
                                  t[47] || (t[47] = y(" Zip ")),
                                  t[48] || (t[48] = a("span", { class: "d-none d-lg-inline-block" }, "Codes", -1))
                                ], 64)) : e.searchType == "map" ? (p(), h(A, { key: 1 }, [
                                  t[49] || (t[49] = y(" Map ")),
                                  t[50] || (t[50] = a("span", { class: "d-none d-lg-inline-block" }, "Area", -1))
                                ], 64)) : e.searchType == "county" ? (p(), h(A, { key: 2 }, [
                                  y(" County ")
                                ], 64)) : (p(), h("i", jUt))
                              ])
                            ])
                          ])
                        ]),
                        a("div", HUt, [
                          a("div", UUt, [
                            t[53] || (t[53] = a("span", { class: "text-secondary d-block" }, [
                              y(" Total "),
                              a("span", { class: "d-none d-xl-inline-block" }, "in Area")
                            ], -1)),
                            a("span", zUt, [
                              e.totalInArea ? (p(), h("strong", WUt, g(e.number(e.totalInArea)), 1)) : (p(), h("i", GUt)),
                              t[52] || (t[52] = a("span", { class: "d-none d-lg-inline-block" }, " Properties", -1))
                            ])
                          ])
                        ])
                      ])
                    ]),
                    a("div", YUt, [
                      a("div", XUt, [
                        a("div", qUt, [
                          a("div", QUt, [
                            a("input", {
                              type: "checkbox",
                              class: "form-check-input",
                              id: "toggleView",
                              checked: e.view == "tile",
                              onChange: t[11] || (t[11] = (...w) => e.toggleView && e.toggleView(...w)),
                              disabled: e.noResults || e.calculating
                            }, null, 40, KUt),
                            t[54] || (t[54] = a("label", {
                              class: "form-check-label",
                              for: "toggleView"
                            }, "Tile View", -1))
                          ])
                        ]),
                        a("div", ZUt, [
                          V(a("button", JUt, t[55] || (t[55] = [
                            a("i", { class: "fa-light fa-save m-0 m-sm-2 m-md-0 me-lg-2" }, null, -1),
                            a("span", { class: "d-none d-lg-inline-block" }, " Save", -1)
                          ]), 512), [
                            [Us, !e.search_name || e.search_name.length == 0]
                          ]),
                          V(a("button", {
                            disabled: "",
                            onClick: t[12] || (t[12] = (...w) => e.saveSearch && e.saveSearch(...w)),
                            class: "btn btn-sm btn-outline-eclipse updateSavedSearch"
                          }, t[56] || (t[56] = [
                            a("i", { class: "fa-light fa-sync" }, null, -1),
                            a("span", { class: "d-none d-lg-inline-block ms-lg-2" }, " Update", -1)
                          ]), 512), [
                            [Us, e.search_name && e.search_name.length > 0]
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              a("div", $Ut, [
                a("div", _Ut, [
                  a("div", ezt, [
                    a("div", tzt, [
                      a("div", szt, [
                        a("button", {
                          onClick: t[13] || (t[13] = (w) => e.changeStep(w, e.SearchStep.Start, void 0, !0)),
                          class: "btn btn-sm btn-outline-dark resetWizard",
                          "data-bs-toggle": "tooltip",
                          "data-title": "Restart",
                          "data-original-title": "Restart",
                          title: "Restart"
                        }, t[57] || (t[57] = [
                          a("i", { class: "fa-light fa-undo-alt" }, null, -1)
                        ]))
                      ]),
                      a("div", azt, [
                        t[60] || (t[60] = a("span", { class: "me-1" }, "Sort by: ", -1)),
                        a("div", nzt, [
                          a("button", {
                            onClick: t[14] || (t[14] = (w) => e.sortTile(e.SortBy.EstimatedEquity)),
                            class: z(["btn btn-sm btn-outline-dark", e.sortButtonClass(e.SortBy.EstimatedEquity)])
                          }, [
                            a("i", {
                              class: z(["fa-duotone fa-solid me-2", e.sortIconClass(e.SortBy.EstimatedEquity)])
                            }, null, 2),
                            t[58] || (t[58] = y("Equity "))
                          ], 2),
                          a("button", {
                            onClick: t[15] || (t[15] = (w) => e.sortTile(e.SortBy.AuctionDate)),
                            class: z(["btn btn-sm btn-outline-dark", e.sortButtonClass(e.SortBy.AuctionDate)])
                          }, [
                            a("i", {
                              class: z(["fa-duotone fa-solid me-2", e.sortIconClass(e.SortBy.AuctionDate)])
                            }, null, 2),
                            t[59] || (t[59] = y("Auction Date "))
                          ], 2)
                        ])
                      ])
                    ])
                  ]),
                  e.searching || e.calculating ? (p(), h("div", rzt, t[61] || (t[61] = [
                    Bt('<svg class="loader me-2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 340 340"><circle cx="170" cy="170" r="160" stroke="#F26E34"></circle><circle cx="170" cy="170" r="135" stroke="#132844"></circle><circle cx="170" cy="170" r="110" stroke="#F26E34"></circle><circle cx="170" cy="170" r="85" stroke="#132844"></circle></svg> <span class="fw-bold h5 mb-0">Calculating...</span>', 3)
                  ]))) : e.noResults ? (p(), h("div", ozt, [
                    t[62] || (t[62] = y(" No properties found within the search parameters.")),
                    t[63] || (t[63] = a("br", null, null, -1)),
                    t[64] || (t[64] = y(" Try expanding your search area or parameters.")),
                    t[65] || (t[65] = a("br", null, null, -1)),
                    a("button", {
                      onClick: t[16] || (t[16] = (w) => e.changeStep(w, e.SearchStep.Start, void 0, !0)),
                      class: "btn btn-lava mt-3 resetWizard"
                    }, "Try another search")
                  ])) : P("", !0)
                ]),
                e.listings.length > 0 ? (p(), h("div", izt, [
                  a("div", {
                    id: "results",
                    class: z(["row row-cols-1", e.listingResultsClasses])
                  }, [
                    (p(!0), h(A, null, D(e.paged, (w) => (p(), Fe(d, {
                      key: w.fcId,
                      listing: w,
                      selected: w.selected === !0,
                      onViewListing: e.viewListing,
                      onSelectListing: e.selectListing,
                      "google-api": e.googleApi
                    }, null, 8, ["listing", "selected", "onViewListing", "onSelectListing", "google-api"]))), 128))
                  ], 2),
                  a("div", lzt, [
                    N(c, {
                      rows: e.pageSize,
                      totalRecords: e.qualified.length,
                      alwaysShow: !1,
                      template: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport",
                      onPage: t[17] || (t[17] = (w) => e.onPage(w)),
                      currentPageReportTemplate: "Showing {first} to {last} of {totalRecords} listings"
                    }, null, 8, ["rows", "totalRecords"])
                  ])
                ])) : P("", !0)
              ]),
              a("div", dzt, [
                e.searching || e.calculating ? (p(), h("div", czt, [
                  t[66] || (t[66] = Bt('<svg class="loader" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 340 340"><circle cx="170" cy="170" r="160" stroke="#F26E34"></circle><circle cx="170" cy="170" r="135" stroke="#132844"></circle><circle cx="170" cy="170" r="110" stroke="#F26E34"></circle><circle cx="170" cy="170" r="85" stroke="#132844"></circle></svg><br>', 2)),
                  a("span", uzt, [
                    e.searching ? (p(), h(A, { key: 0 }, [
                      y(" Searching... ")
                    ], 64)) : e.calculating ? (p(), h(A, { key: 1 }, [
                      y(" Calculating... ")
                    ], 64)) : P("", !0)
                  ])
                ])) : P("", !0),
                a("div", pzt, [
                  a("button", {
                    onClick: t[18] || (t[18] = (...w) => e.zoomOut && e.zoomOut(...w)),
                    class: "btn btn-light shadow-sm"
                  }, t[67] || (t[67] = [
                    a("i", { class: "fa-duotone fa-solid fa-minus" }, null, -1),
                    a("span", { class: "visually-hidden" }, "Zoom out", -1)
                  ])),
                  a("button", {
                    onClick: t[19] || (t[19] = (...w) => e.zoomIn && e.zoomIn(...w)),
                    class: "btn btn-light shadow-sm"
                  }, t[68] || (t[68] = [
                    a("i", { class: "fa-duotone fa-solid fa-plus" }, null, -1),
                    a("span", { class: "visually-hidden" }, "Zoom in", -1)
                  ])),
                  P("", !0),
                  P("", !0),
                  P("", !0)
                ]),
                N(o, {
                  ref: "gMap",
                  class: "mlse-estimator-listings h-100 w-100",
                  "map-id": "2ddbbe0dd6bcf8f9",
                  center: e.center,
                  options: e.listingsMapOptions,
                  onClick: e.onMapClick,
                  onBounds_changed: e.onMapBoundsChanged,
                  onPano_visible_changed: e.onPanoVisibleChanged
                }, {
                  default: ve(() => [
                    N(f, {
                      renderer: e.clusterRenderer,
                      ref: "gCluster"
                    }, {
                      default: ve(() => [
                        (p(!0), h(A, null, D(e.listings, (w) => (p(), Fe(m, {
                          key: w.id,
                          position: { lat: w.latitude, lng: w.longitude },
                          "no-position": "createPosition(listing)",
                          gmpClickable: !0,
                          gmpDraggable: !1,
                          content: e.preforeclosurePin(),
                          "z-index": 1e3,
                          title: w.address,
                          "no-click": "markerSelected($event, m)",
                          "no-options": "defaultMarkerOptions",
                          onClick: (...S) => e.markerSelected(w, ...S)
                        }, {
                          default: ve(() => [
                            N(u, {
                              opened: w.selected === !0,
                              onCloseclick: e.infoWindowClose,
                              onOnCloseclick: e.infoWindowClose,
                              onOpen: e.infoWindowOpen,
                              propId: w.propId
                            }, {
                              default: ve(() => [
                                N(d, {
                                  listing: w,
                                  selected: !0,
                                  onViewListing: e.viewListing,
                                  onSelectListing: e.viewListing,
                                  "google-api": e.googleApi
                                }, null, 8, ["listing", "onViewListing", "onSelectListing", "google-api"])
                              ]),
                              _: 2
                            }, 1032, ["opened", "onCloseclick", "onOnCloseclick", "onOpen", "propId"])
                          ]),
                          _: 2
                        }, 1032, ["position", "content", "title", "onClick"]))), 128))
                      ]),
                      _: 1
                    }, 8, ["renderer"])
                  ]),
                  _: 1
                }, 8, ["center", "options", "onClick", "onBounds_changed", "onPano_visible_changed"])
              ])
            ], 2), [
              [Us, e.currentStep == "showResults" && !e.searching]
            ])
          ])
        ])
      ])
    ]),
    a("div", hzt, [
      a("div", mzt, [
        a("div", fzt, [
          t[74] || (t[74] = a("div", { class: "modal-header pb-0 border-0" }, [
            a("p", {
              class: "modal-title fw-bold fs-5",
              id: "modalSaveResults"
            }, "Save results"),
            a("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            })
          ], -1)),
          a("div", gzt, [
            t[73] || (t[73] = a("p", null, "You can save this to your search profile to view later or have lists auto-featured to your inbox daily.", -1)),
            a("div", null, [
              t[72] || (t[72] = a("label", { class: "form-label" }, "Search name:", -1)),
              V(a("input", {
                type: "text",
                id: "searchName",
                name: "searchName",
                "onUpdate:modelValue": t[23] || (t[23] = (w) => e.search_name = w),
                class: "form-control searchName focus",
                placeholder: "ie: The Woodlands Area"
              }, null, 512), [
                [_e, e.search_name]
              ])
            ])
          ]),
          a("div", vzt, [
            a("button", {
              onClick: t[24] || (t[24] = (...w) => e.saveSearch && e.saveSearch(...w)),
              id: "btnSaveSearch",
              class: "btn btn-lava saveSearch",
              disabled: !e.search_name || e.search_name.length == 0
            }, "Save Search", 8, yzt)
          ])
        ])
      ])
    ]),
    t[76] || (t[76] = Bt('<div class="modal fade" id="modalInfoListings" tabindex="-1" aria-labelledby="modalInformation" aria-hidden="true"><div class="modal-dialog"><div class="modal-content bg-gradient-alphabet rounded"><div class="modal-header pb-0 border-0"><p class="modal-title fw-bold fs-5" id="modalInformation">Information</p><button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button></div><div class="modal-body"> What area listings and qualified features are... </div></div></div></div>', 1))
  ], 64);
}
const hds = /* @__PURE__ */ Ae(NHt, [["render", bzt]]), Azt = "BootstrapVueNext__", DE = (e, t = "") => {
  const s = `${t}___`;
  return `${Azt}ID__${e}__${t ? s : ""}`;
}, wzt = (e) => DE(`${e}__plugin`), sv = wzt("defaults");
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
function td(e, t = {}) {
  const {
    method: s = "parseFloat",
    radix: n,
    nanToZero: r
  } = t;
  return Ke(() => {
    let i = md(e);
    return typeof s == "function" ? i = s(i) : typeof i == "string" && (i = Number[s](i, n)), r && Number.isNaN(i) && (i = 0), i;
  });
}
const Czt = "ArrowDown", Szt = "ArrowLeft", Pzt = "ArrowRight", kzt = "ArrowUp", NE = /_/g, jE = /([a-z])([A-Z])/g, Ezt = /^[0-9]*\.?[0-9]+$/, Izt = /(\s|^)(\w)/g, Tzt = /(\s|^)(\w)/;
function Ozt(e, t = HE("injectSelf")) {
  const { provides: s } = t;
  if (s && e in s)
    return s[e];
}
function HE(e, t) {
  const s = nI();
  if (!s)
    throw new Error(`[Bvn] ${e} must be called from inside a setup function`);
  return s;
}
const Rzt = (e = "") => e.replace(/[^a-z]/gi, "-").replace(/\B([A-Z])/g, "-$1").toLowerCase(), jS = (e) => e !== null && typeof e == "object" && !Array.isArray(e);
function UE(e = {}, t = {}, s) {
  const n = {};
  for (const r in e)
    n[r] = e[r];
  for (const r in t) {
    const i = e[r], o = t[r];
    if (jS(i) && jS(o)) {
      n[r] = UE(i, o);
      continue;
    }
    n[r] = o;
  }
  return n;
}
const Lzt = (e, t) => {
  var s, n;
  return typeof ((s = e.props) == null ? void 0 : s[t]) < "u" || typeof ((n = e.props) == null ? void 0 : n[Rzt(t)]) < "u";
};
function Bzt(e = {}, t) {
  const s = sP(sv, Ds({})), n = HE("useDefaults");
  if (t = t ?? n.type.name ?? n.type.__name, !t)
    throw new Error("[Bvn] Could not determine component name");
  const r = Ke(() => {
    var d;
    return (d = s.value) == null ? void 0 : d[e._as ?? t];
  }), i = new Proxy(e, {
    get(d, c) {
      var u, m, f, v;
      const b = Reflect.get(d, c);
      return c === "class" || c === "style" ? [(u = r.value) == null ? void 0 : u[c], b].filter((w) => w != null) : typeof c == "string" && !Lzt(n.vnode, c) ? ((m = r.value) == null ? void 0 : m[c]) ?? ((v = (f = s.value) == null ? void 0 : f.global) == null ? void 0 : v[c]) ?? b : b;
    }
  }), o = sI();
  aI(() => {
    if (r.value) {
      const d = Object.entries(r.value).filter(
        ([c]) => c.startsWith(c[0].toUpperCase())
      );
      o.value = d.length ? Object.fromEntries(d) : void 0;
    } else
      o.value = void 0;
  });
  function l() {
    const d = Ozt(sv, n);
    rI(
      sv,
      Ke(
        () => o.value ? UE((d == null ? void 0 : d.value) ?? {}, o.value) : d == null ? void 0 : d.value
      )
    );
  }
  return { props: i, provideSubDefaults: l };
}
function ao(e, t) {
  const { props: s, provideSubDefaults: n } = Bzt(e, t);
  return n(), s;
}
const eA = (e, t) => {
  const s = oI();
  return Ke(() => md(e) || DE(s || "", t));
};
me({
  name: "ConditionalTeleport",
  inheritAttrs: !1,
  props: {
    to: {
      type: [String, Object],
      default: null
    },
    disabled: {
      type: Boolean,
      required: !0
    }
  },
  slots: Object,
  setup(e, { slots: t }) {
    return () => {
      var s, n;
      return e.to ? rP(iI, { to: e.to, disabled: e.disabled || !e.to }, [(n = t.default) == null ? void 0 : n.call(t, {})]) : (s = t.default) == null ? void 0 : s.call(t, {});
    };
  }
});
var Mzt = Object.defineProperty, xzt = (e, t, s) => t in e ? Mzt(e, t, { enumerable: !0, configurable: !0, writable: !0, value: s }) : e[t] = s, Zo = (e, t, s) => xzt(e, typeof t != "symbol" ? t + "" : t, s);
class tA {
  constructor(t, s = {}) {
    if (Zo(this, "cancelable", !0), Zo(this, "componentId", null), Zo(this, "_defaultPrevented", !1), Zo(this, "eventType", ""), Zo(this, "nativeEvent", null), Zo(this, "_preventDefault"), Zo(this, "relatedTarget", null), Zo(this, "target", null), !t)
      throw new TypeError(
        `Failed to construct '${this.constructor.name}'. 1 argument required, ${arguments.length} given.`
      );
    Object.assign(this, tA.Defaults, s, { eventType: t }), this._preventDefault = function() {
      this.cancelable && (this.defaultPrevented = !0);
    };
  }
  // Readable by everyone,
  // But only overwritten by inherrited constructors
  get defaultPrevented() {
    return this._defaultPrevented;
  }
  set defaultPrevented(t) {
    this._defaultPrevented = t;
  }
  // I think this is right
  // We want to be able to have it callable to everyone,
  // But only overwritten by inherrited constructors
  get preventDefault() {
    return this._preventDefault;
  }
  // This may not be correct, because it doesn't get correct type inferences in children
  // Ex overwrite this.preventDefault = () => true is valid. Could be a TS issue
  set preventDefault(t) {
    this._preventDefault = t;
  }
  static get Defaults() {
    return {
      cancelable: !0,
      componentId: null,
      eventType: "",
      nativeEvent: null,
      relatedTarget: null,
      target: null
    };
  }
}
const zE = (e, t) => [...t].reduce(
  (s, n) => (s[n] = e[n], s),
  {}
), Pn = (e, t, s) => {
  const n = t.split(/[.[\]]/g);
  let r = e;
  for (const i of n) {
    if (r === null || r === void 0) return s;
    i.trim() !== "" && (r = r[i]);
  }
  return r === void 0 ? s : r;
}, Fzt = (e, t, s) => {
  const n = (d) => {
    if (((m) => m == null || typeof m != "object" && typeof m != "function")(d))
      return d;
    if (typeof d == "function")
      return d.bind({});
    const u = new d.constructor();
    return Object.getOwnPropertyNames(d).forEach((m) => {
      u[m] = d[m];
    }), u;
  }, r = (d, c) => {
    const u = c;
    if (d == null)
      return u;
    const m = Number.parseInt(d);
    return Number.isNaN(m) ? u : m;
  };
  if (!e) return {};
  if (!t || s === void 0) return e;
  const i = t.split(/[.[\]]/g).filter((d) => !!d.trim()), o = (d) => {
    if (i.length > 1) {
      const c = i.shift(), u = r(i[0], null) !== null;
      d[c] = d[c] === void 0 ? u ? [] : {} : d[c], o(d[c]);
    } else
      d[i[0]] = s;
  }, l = n(e);
  return o(l), l;
}, WE = (e, t) => {
  if (e === t)
    return !0;
  if (typeof e != "object" || e === null || typeof t != "object" || t === null)
    return !1;
  const s = Object.keys(e), n = Object.keys(t);
  if (s.length !== n.length)
    return !1;
  for (const r of s)
    if (!n.includes(r) || !WE(e[r], t[r]))
      return !1;
  return !0;
}, HS = (e = []) => {
  const { activeElement: t } = document;
  return t && !(e != null && e.some((s) => s === t)) ? t : null;
}, Vzt = (e) => Ke(() => {
  let t = md(e);
  return t = {
    variant: t.variant ?? null,
    bgVariant: t.bgVariant ?? null,
    textVariant: t.textVariant ?? null,
    borderVariant: t.borderVariant ?? null
  }, {
    [`text-bg-${t.variant}`]: t.variant !== null,
    [`text-${t.textVariant}`]: t.textVariant !== null,
    [`bg-${t.bgVariant}`]: t.bgVariant !== null,
    [`border-${t.borderVariant}`]: t.borderVariant !== null
  };
}), zh = (e) => e.replace(NE, " ").replace(jE, (t, s, n) => `${s} ${n}`).replace(Tzt, (t, s, n) => s + n.toUpperCase()), US = (e) => e.replace(NE, " ").replace(jE, (t, s, n) => `${s} ${n}`).replace(Izt, (t, s, n) => s + n.toUpperCase());
me({
  name: "ConditionalWrapper",
  inheritAttrs: !1,
  props: {
    tag: {
      type: String,
      default: "div"
    },
    skip: {
      type: Boolean,
      required: !0
    }
  },
  slots: Object,
  setup(e, { slots: t, attrs: s }) {
    return () => {
      var n, r;
      return e.skip ? (n = t.default) == null ? void 0 : n.call(t, {}) : rP(e.tag, { ...s }, [(r = t.default) == null ? void 0 : r.call(t, {})]);
    };
  }
});
const Dzt = (e, t = "px") => Ke(() => {
  const s = md(e), n = md(t);
  return Ezt.test(String(s)) ? `${Number(s)}${n}` : s;
}), Nzt = (e) => Ke(() => {
  const t = md(e);
  return t ? `justify-content-${t}` : "";
}), zS = (e, { preventDefault: t = !0, propagation: s = !1, immediatePropagation: n = !1 } = {}) => {
  t && e.preventDefault(), s && e.stopPropagation(), n && e.stopImmediatePropagation();
}, jzt = ["aria-disabled", "aria-label"], WS = 20, GS = 0, GE = /* @__PURE__ */ me({
  __name: "BPagination",
  props: /* @__PURE__ */ hd({
    align: { default: "start" },
    ariaControls: { default: void 0 },
    ariaLabel: { default: "Pagination" },
    disabled: { type: Boolean, default: !1 },
    ellipsisClass: { default: void 0 },
    ellipsisText: { default: "…" },
    firstClass: { default: void 0 },
    firstNumber: { type: Boolean, default: !1 },
    firstText: { default: "«" },
    noEllipsis: { type: Boolean, default: !1 },
    noGotoEndButtons: { type: Boolean, default: !1 },
    labelFirstPage: { default: "Go to first page" },
    labelLastPage: { default: "Go to last page" },
    labelNextPage: { default: "Go to next page" },
    labelPage: { default: "Go to page" },
    labelPrevPage: { default: "Go to previous page" },
    lastClass: { default: void 0 },
    lastNumber: { type: Boolean, default: !1 },
    lastText: { default: "»" },
    limit: { default: 5 },
    nextClass: { default: void 0 },
    nextText: { default: "›" },
    pageClass: { default: void 0 },
    perPage: { default: WS },
    pills: { type: Boolean, default: !1 },
    prevClass: { default: void 0 },
    prevText: { default: "‹" },
    size: { default: void 0 },
    totalRows: { default: GS }
  }, {
    modelValue: {
      default: 1
    },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ hd(["page-click"], ["update:modelValue"]),
  setup(e, { emit: t }) {
    const u = ao(e, "BPagination"), m = t, f = sd(e, "modelValue"), v = rv("_pageElements"), b = td(() => u.limit, { nanToZero: !0, method: "parseInt" }), w = td(() => u.perPage, { nanToZero: !0, method: "parseInt" }), S = td(() => u.totalRows, { nanToZero: !0, method: "parseInt" }), I = td(f, { nanToZero: !0, method: "parseInt" }), T = Ke(() => Math.max(w.value || WS, 1)), x = Ke(() => Math.max(S.value || GS, 0)), k = Ke(() => Math.ceil(x.value / T.value)), C = Ke(() => u.align === "fill"), O = Ke(() => u.align === "fill" ? "start" : u.align), E = Nzt(O), B = (Ce) => Ce === he.value, M = (Ce) => u.disabled ? null : B(Ce) ? "0" : "-1", R = (Ce) => u.disabled || B(Ce) || he.value < 1 || // Check if the number is out of bounds
    Ce < 1 || Ce > k.value, F = Ke(() => R(1)), L = Ke(() => R(he.value - 1)), j = Ke(() => R(k.value)), H = Ke(() => R(he.value + 1)), te = ({
      page: Ce,
      classVal: xe,
      disabled: Pe,
      slotName: it,
      textValue: lt,
      tabIndex: dt,
      label: vt,
      position: It,
      isActive: Dt,
      hidden: ht,
      isSmHidden: _t
    }) => ({
      li: {
        class: [
          "page-item",
          {
            active: Dt,
            disabled: Pe,
            "bv-d-sm-down-none": _t,
            "flex-fill": C.value,
            "d-flex": C.value && !Pe
          },
          xe
        ],
        role: "presentation",
        "aria-hidden": ht
      },
      button: {
        is: Pe ? "span" : "button",
        class: ["page-link", "text-center", { "flex-grow-1": !Pe && C.value }],
        "aria-label": vt,
        "aria-controls": u.ariaControls || void 0,
        "aria-disabled": Pe ? !0 : void 0,
        "aria-posinset": It,
        "aria-setsize": It ? k.value : void 0,
        role: "menuitem",
        type: Pe ? void 0 : "button",
        tabindex: Pe ? void 0 : dt
      },
      text: {
        name: it,
        active: Dt,
        value: lt ?? Ce,
        page: Ce,
        disabled: Pe,
        index: Ce - 1,
        content: lt ? void 0 : Ce
      },
      clickHandler: (fs) => fe(fs, Ce)
    }), re = ({
      page: Ce,
      classVal: xe,
      disabled: Pe,
      slotName: it,
      textValue: lt,
      label: dt
    }) => te({ page: Ce, classVal: xe, disabled: Pe, slotName: it, textValue: lt, label: dt, tabIndex: "-1" }), le = (Ce, xe) => te({
      page: Ce,
      disabled: u.disabled,
      classVal: u.pageClass,
      slotName: "page",
      label: u.labelPage ? `${u.labelPage} ${Ce}` : void 0,
      tabIndex: M(Ce) ?? void 0,
      position: Ce,
      isActive: B(Ce),
      isSmHidden: xe
    }), ie = Ke(
      () => re({
        page: 1,
        disabled: F.value,
        classVal: u.firstClass,
        slotName: "first-text",
        textValue: u.firstText,
        label: u.labelFirstPage
      })
    ), ye = Ke(
      () => re({
        page: Math.max(he.value - 1, 1),
        disabled: L.value,
        classVal: u.prevClass,
        slotName: "prev-text",
        textValue: u.prevText,
        label: u.labelPrevPage
      })
    ), Y = Ke(
      () => re({
        page: Math.min(he.value + 1, k.value),
        disabled: H.value,
        classVal: u.nextClass,
        slotName: "next-text",
        textValue: u.nextText,
        label: u.labelNextPage
      })
    ), ae = Ke(
      () => re({
        page: k.value,
        disabled: j.value,
        classVal: u.lastClass,
        slotName: "last-text",
        textValue: u.lastText,
        label: u.labelLastPage
      })
    ), ke = Ke(() => ({
      li: {
        class: [
          "page-item",
          "disabled",
          "text-center",
          "bv-d-sm-down-none",
          C.value ? "flex-fill" : "",
          u.ellipsisClass
        ],
        role: "separator"
      },
      span: {
        class: ["page-link"]
      }
    })), ue = Ke(() => [
      E.value,
      {
        [`pagination-${u.size}`]: u.size !== void 0,
        "b-pagination-pills": u.pills
      }
    ]), oe = Ke(() => ({
      pageSize: T.value,
      totalRows: S.value,
      numberOfPages: k.value
    })), fe = (Ce, xe) => {
      if (xe === he.value) return;
      const Pe = new tA("page-click", {
        cancelable: !0,
        target: Ce.target
      });
      m("page-click", Pe, xe), !Pe.defaultPrevented && (f.value = xe);
    }, we = (Ce) => {
      const xe = !!(Ce && Ce.nodeType === Node.ELEMENT_NODE), Pe = xe ? Ce.hasAttribute("disabled") : null, it = xe && Ce.classList ? Ce.classList.contains("disabled") : !1;
      return !xe || Ce.disabled || Pe || it;
    }, Ie = () => {
      var Ce;
      return ((Ce = v.value) == null ? void 0 : Ce.map((xe) => xe.children[0]).filter((xe) => {
        if (xe.getAttribute("display") === "none")
          return !1;
        const Pe = xe.getBoundingClientRect();
        return !!(Pe && Pe.height > 0 && Pe.width > 0);
      })) ?? [];
    }, be = () => {
      Vc(() => {
        const Ce = Ie().find((xe) => !we(xe));
        Ce == null || Ce.focus();
      });
    }, Oe = () => {
      Vc(() => {
        var Ce;
        const xe = Ie(), Pe = xe.indexOf(HS());
        Pe > 0 && !we(xe[Pe - 1]) && ((Ce = xe[Pe - 1]) == null || Ce.focus());
      });
    }, ze = () => {
      Vc(() => {
        const Ce = Ie().reverse().find((xe) => !we(xe));
        Ce == null || Ce.focus();
      });
    }, Re = () => {
      Vc(() => {
        var Ce;
        const xe = Ie(), Pe = xe.indexOf(HS());
        Pe < xe.length - 1 && !we(xe[Pe + 1]) && ((Ce = xe[Pe + 1]) == null || Ce.focus());
      });
    }, ge = (Ce) => {
      const { code: xe, shiftKey: Pe } = Ce;
      xe === Szt || xe === kzt ? (zS(Ce), Pe ? be() : Oe()) : (xe === Pzt || xe === Czt) && (zS(Ce), Pe ? ze() : Re());
    }, he = Ke(() => {
      const Ce = I.value || 1;
      return Ce > k.value ? k.value : Ce < 1 ? 1 : Ce;
    });
    Jn(oe, (Ce, xe) => {
      xe.pageSize !== Ce.pageSize && xe.totalRows === Ce.totalRows && (f.value = 1);
    });
    const Me = Ke(() => u.noGotoEndButtons && !u.firstNumber ? 1 : 0), Ne = Ke(() => u.noGotoEndButtons && !u.lastNumber ? 1 : 0), $e = Ke(() => Me.value ? 0 : 1), mt = Ke(() => Ne.value ? 0 : 1), yt = Ke(() => u.firstNumber ? 1 : 0), Ct = Ke(() => u.lastNumber ? 1 : 0), gt = Ke(() => Math.floor(b.value / 2)), Ge = Ke(() => {
      const { value: Ce } = he, xe = Ee.value.map((Pe) => {
        switch (Pe) {
          case -1:
            return { id: Pe, ...ie.value };
          case -2:
            return { id: Pe, ...ye.value };
          case -3:
            return { id: Pe, ...Y.value };
          case -4:
            return { id: Pe, ...ae.value };
          case -5:
          case -6:
            return { id: Pe, ...ke.value };
          default:
            return { id: Pe, ...le(Pe) };
        }
      });
      if (k.value > 3) {
        if (Ce > k.value - gt.value - Ct.value) {
          const Pe = 2 + $e.value;
          xe[Pe] = { id: xe[Pe].id, ...le(xe[Pe].id, !0) };
        }
        if (Ce <= gt.value + yt.value) {
          const Pe = xe.length - (3 + mt.value);
          xe[Pe] = { id: xe[Pe].id, ...le(xe[Pe].id, !0) };
        }
      }
      return xe;
    }), Ee = Ke(() => {
      const Ce = k.value, { value: xe } = he, Pe = b.value, it = u.noEllipsis || Pe <= 3;
      if (Ce < Pe + yt.value + Ct.value)
        return [
          !yt.value && !Me.value ? -1 : null,
          -2,
          ...Array.from({ length: Ce }, (dt, vt) => vt + 1),
          -3,
          !Ct.value && !Ne.value ? -4 : null
        ].filter((dt) => dt !== null);
      const lt = Array.from({ length: Pe + 4 - (Me.value + Ne.value) });
      if (Me.value ? lt[0] = -2 : yt.value ? (lt[0] = -2, lt[1] = 1) : (lt[0] = -1, lt[1] = -2), Ne.value ? lt[lt.length - 1] = -3 : Ct.value ? (lt[lt.length - 1] = -3, lt[lt.length - 2] = Ce) : (lt[lt.length - 1] = -4, lt[lt.length - 2] = -3), xe <= gt.value + yt.value) {
        for (let dt = 1; dt <= Pe; dt++)
          lt[dt + 1 - Me.value] = dt + yt.value;
        it || (lt[lt.length - (2 + mt.value)] = -6);
      }
      if (xe > Ce - gt.value - Ct.value) {
        const dt = Ce - (Pe - 1) - Ct.value;
        for (let vt = 0; vt < Pe; vt++)
          lt[vt + 2 - Me.value] = dt + vt;
        it || (lt[1 + $e.value] = -5);
      }
      if (!lt[2]) {
        const dt = xe - Math.floor(Pe / 2);
        for (let vt = 0; vt < Pe; vt++)
          lt[vt + 2 - Me.value] = dt + vt;
        it || (lt[1 + $e.value] = -5, lt[lt.length - (2 + mt.value)] = -6);
      }
      return lt.filter((dt) => dt !== null);
    });
    return (Ce, xe) => (p(), h("ul", {
      class: z(["pagination", ue.value]),
      role: "menubar",
      "aria-disabled": st(u).disabled,
      "aria-label": st(u).ariaLabel || void 0,
      onKeydown: ge
    }, [
      (p(!0), h(A, null, D(Ge.value, (Pe) => (p(), h("li", Rs({
        key: `page-${Pe.id}`,
        ref_for: !0
      }, Pe.li, {
        ref_for: !0,
        ref: "_pageElements"
      }), [
        Pe.id === -5 || Pe.id === -6 ? (p(), h("span", Rs({
          key: 0,
          ref_for: !0
        }, ke.value.span), [
          Ot(Ce.$slots, "ellipsis-text", {}, () => [
            y(g(st(u).ellipsisText || "..."), 1)
          ])
        ], 16)) : (p(), Fe(lu(Pe.button.is), Rs({
          key: 1,
          ref_for: !0
        }, Pe.button, {
          onClick: Pe.clickHandler
        }), {
          default: ve(() => [
            Ot(Ce.$slots, Pe.text.name, {
              disabled: Pe.text.disabled,
              page: Pe.text.page,
              index: Pe.text.index,
              active: Pe.text.active,
              content: Pe.text.value
            }, () => [
              y(g(Pe.text.value), 1)
            ])
          ]),
          _: 2
        }, 1040, ["onClick"]))
      ], 16))), 128))
    ], 42, jzt));
  }
}), Hzt = "300px", Uzt = /* @__PURE__ */ me({
  __name: "BTableSimple",
  props: {
    bordered: { type: Boolean, default: !1 },
    borderless: { type: Boolean, default: !1 },
    borderVariant: { default: null },
    captionTop: { type: Boolean, default: !1 },
    dark: { type: Boolean, default: !1 },
    fixed: { type: Boolean, default: !1 },
    hover: { type: Boolean, default: !1 },
    id: { default: void 0 },
    noBorderCollapse: { type: Boolean, default: !1 },
    outlined: { type: Boolean, default: !1 },
    responsive: { type: [Boolean, String], default: !1 },
    small: { type: Boolean, default: !1 },
    stacked: { type: [Boolean, String], default: !1 },
    stickyHeader: { type: [Boolean, String, Number], default: !1 },
    striped: { type: Boolean, default: !1 },
    stripedColumns: { type: Boolean, default: !1 },
    variant: { default: null },
    tableAttrs: { default: void 0 },
    tableClass: { default: void 0 }
  },
  setup(e) {
    const s = ao(e, "BTableSimple"), n = eA(() => s.id), r = Vzt(
      Ke(() => ({
        borderVariant: s.borderVariant
      }))
    ), i = Ke(() => [
      s.tableClass,
      "table",
      "b-table",
      r.value,
      {
        border: s.outlined,
        "table-bordered": s.bordered,
        "table-borderless": s.borderless,
        "caption-top": s.captionTop,
        "table-dark": s.dark,
        "table-hover": s.hover,
        "b-table-stacked": s.stacked === !0,
        [`b-table-stacked-${s.stacked}`]: typeof s.stacked == "string",
        "table-striped": s.striped,
        "table-sm": s.small,
        [`table-${s.variant}`]: s.variant !== null,
        "table-striped-columns": s.stripedColumns
      }
    ]), o = Ke(() => ({
      id: n.value,
      class: i.value,
      ...s.tableAttrs
    })), l = Dzt(
      Ke(
        () => (s.stickyHeader === !0 ? Hzt : s.stickyHeader) || NaN
      )
    ), d = Ke(() => s.stickyHeader !== !1), c = Ke(() => s.responsive !== !1 || d.value), u = Ke(
      () => d.value ? { maxHeight: l.value } : void 0
    ), m = Ke(() => ({
      "table-responsive": s.responsive === !0,
      [`table-responsive-${s.responsive}`]: typeof s.responsive == "string",
      "b-table-sticky-header": d.value
    }));
    return (f, v) => c.value ? (p(), h("div", {
      key: 0,
      class: z(m.value),
      style: rn(u.value)
    }, [
      a("table", Mr(oP(o.value)), [
        Ot(f.$slots, "default")
      ], 16)
    ], 6)) : (p(), h("table", Mr(Rs({ key: 1 }, o.value)), [
      Ot(f.$slots, "default")
    ], 16));
  }
}), Ky = (e, t, s) => {
  const n = Pn(e, t);
  return s && typeof s == "function" ? s(n, t, e) : n;
}, Ir = (e) => typeof e == "object" && e !== null, ql = (e) => typeof e == "object" && e !== null && "key" in e, zzt = /* @__PURE__ */ me({
  __name: "BTbody",
  props: {
    variant: { default: null }
  },
  setup(e) {
    const s = ao(e, "BTbody"), n = Ke(() => ({
      [`thead-${s.variant}`]: s.variant !== null
    }));
    return (r, i) => (p(), h("tbody", {
      class: z(n.value)
    }, [
      Ot(r.$slots, "default")
    ], 2));
  }
}), Wzt = ["colspan", "rowspan", "data-label"], Gzt = { key: 0 }, iu = /* @__PURE__ */ me({
  __name: "BTd",
  props: {
    colspan: { default: void 0 },
    rowspan: { default: void 0 },
    stackedHeading: { default: void 0 },
    stickyColumn: { type: Boolean, default: !1 },
    variant: { default: null }
  },
  setup(e) {
    const s = ao(e, "BTd"), n = Ke(() => ({
      [`table-${s.variant}`]: s.variant !== null,
      "b-table-sticky-column": s.stickyColumn,
      "table-b-table-default": s.stickyColumn && s.variant === null
    }));
    return (r, i) => (p(), h("td", {
      class: z(n.value),
      colspan: st(s).colspan,
      rowspan: st(s).rowspan,
      "data-label": st(s).stackedHeading
    }, [
      st(s).stackedHeading ? (p(), h("div", Gzt, [
        Ot(r.$slots, "default")
      ])) : Ot(r.$slots, "default", { key: 1 })
    ], 10, Wzt));
  }
}), YS = /* @__PURE__ */ me({
  __name: "BTfoot",
  props: {
    variant: { default: null }
  },
  setup(e) {
    const s = ao(e, "BTfoot"), n = Ke(() => ({
      [`table-${s.variant}`]: s.variant !== null
    }));
    return (r, i) => (p(), h("tfoot", {
      class: z(n.value)
    }, [
      Ot(r.$slots, "default")
    ], 2));
  }
}), Yzt = ["scope", "colspan", "rowspan", "data-label"], Xzt = { key: 0 }, XS = /* @__PURE__ */ me({
  __name: "BTh",
  props: {
    colspan: { default: void 0 },
    rowspan: { default: void 0 },
    stackedHeading: { default: void 0 },
    stickyColumn: { type: Boolean, default: !1 },
    variant: { default: null },
    scope: { default: void 0 }
  },
  setup(e) {
    const s = ao(e, "BTh"), n = Ke(() => ({
      [`table-${s.variant}`]: s.variant !== null,
      "b-table-sticky-column": s.stickyColumn,
      "table-b-table-default": s.stickyColumn && s.variant === null
    })), r = Ke(
      () => s.scope ? s.scope : s.colspan ? "colgroup" : s.rowspan ? "rowgroup" : "col"
    );
    return (i, o) => (p(), h("th", {
      scope: r.value,
      class: z(n.value),
      colspan: st(s).colspan,
      rowspan: st(s).rowspan,
      "data-label": st(s).stackedHeading
    }, [
      st(s).stackedHeading !== void 0 ? (p(), h("div", Xzt, [
        Ot(i.$slots, "default")
      ])) : Ot(i.$slots, "default", { key: 1 })
    ], 10, Yzt));
  }
}), qzt = /* @__PURE__ */ me({
  __name: "BThead",
  props: {
    variant: { default: null }
  },
  setup(e) {
    const s = ao(e, "BThead"), n = Ke(() => ({
      [`table-${s.variant}`]: s.variant !== null
    }));
    return (r, i) => (p(), h("thead", {
      class: z(n.value)
    }, [
      Ot(r.$slots, "default")
    ], 2));
  }
}), Tr = /* @__PURE__ */ me({
  __name: "BTr",
  props: {
    variant: { default: null }
  },
  setup(e) {
    const s = ao(e, "BTr"), n = Ke(() => ({
      [`table-${s.variant}`]: s.variant !== null
    }));
    return (r, i) => (p(), h("tr", {
      class: z(n.value)
    }, [
      Ot(r.$slots, "default")
    ], 2));
  }
}), Wh = (e) => typeof e == "string" ? US(e) : e.label !== void 0 ? e.label : typeof e.key == "string" ? US(e.key) : e.key, YE = Object.freeze(
  Object.keys({
    bordered: 0,
    borderless: 0,
    borderVariant: 0,
    captionTop: 0,
    dark: 0,
    fixed: 0,
    hover: 0,
    id: 0,
    noBorderCollapse: 0,
    outlined: 0,
    responsive: 0,
    small: 0,
    stacked: 0,
    stickyHeader: 0,
    striped: 0,
    stripedColumns: 0,
    variant: 0,
    tableAttrs: 0,
    tableClass: 0
  })
), Qzt = Object.freeze(
  Object.keys({
    align: 0,
    caption: 0,
    detailsTdClass: 0,
    fieldColumnClass: 0,
    fields: 0,
    footClone: 0,
    footRowVariant: 0,
    footVariant: 0,
    headRowVariant: 0,
    headVariant: 0,
    items: 0,
    labelStacked: 0,
    modelValue: 0,
    primaryKey: 0,
    tbodyClass: 0,
    tbodyTrAttrs: 0,
    tbodyTrClass: 0,
    tfootClass: 0,
    tfootTrClass: 0,
    theadClass: 0,
    theadTrClass: 0
  })
), Gh = (e, t) => e.stacked && e.labelStacked !== !0 ? { "data-label": t } : void 0, Kzt = ["TD", "TH", "TR"], Zzt = [
  "a",
  "a *",
  // Include content inside links
  "button",
  "button *",
  // Include content inside buttons
  "input:not(.disabled):not([disabled])",
  "select:not(.disabled):not([disabled])",
  "textarea:not(.disabled):not([disabled])",
  '[role="link"]',
  '[role="link"] *',
  '[role="button"]',
  '[role="button"] *',
  "[tabindex]:not(.disabled):not([disabled])"
].join(","), jl = (e) => {
  if (!e || !e.target)
    return !1;
  const t = e.target;
  if ("disabled" in t && t.disabled || Kzt.indexOf(t.tagName) !== -1)
    return !1;
  if (t.closest(".dropdown-menu")) return !0;
  const s = t.tagName === "LABEL" ? t : t.closest("label");
  if (s) {
    const n = s.getAttribute("for"), r = n ? document.getElementById(n) : s.querySelector("input, select, textarea");
    if (r && !r.disabled)
      return !0;
  }
  return t.matches(Zzt);
}, Jzt = {
  key: 0,
  class: "b-table-stacked-label"
}, $zt = { class: "d-inline-flex flex-nowrap align-items-center gap-1" }, _zt = { key: 2 }, eWt = /* @__PURE__ */ me({
  __name: "BTableLite",
  props: {
    align: { default: void 0 },
    caption: { default: void 0 },
    detailsTdClass: { default: void 0 },
    fieldColumnClass: { type: [Function, String, Object, Array], default: void 0 },
    fields: { default: () => [] },
    footClone: { type: Boolean, default: !1 },
    footRowVariant: { default: void 0 },
    footVariant: { default: void 0 },
    headRowVariant: { default: void 0 },
    headVariant: { default: void 0 },
    items: { default: () => [] },
    labelStacked: { type: Boolean, default: !1 },
    modelValue: { default: void 0 },
    primaryKey: { default: void 0 },
    tbodyClass: { default: void 0 },
    tbodyTrAttrs: { type: [Function, Object], default: void 0 },
    tbodyTrClass: { type: [Function, String, Array, Object], default: void 0 },
    tfootClass: { default: void 0 },
    tfootTrClass: { default: void 0 },
    theadClass: { default: void 0 },
    theadTrClass: { default: void 0 },
    bordered: { type: Boolean, default: void 0 },
    borderless: { type: Boolean, default: void 0 },
    borderVariant: { default: void 0 },
    captionTop: { type: Boolean, default: void 0 },
    dark: { type: Boolean, default: void 0 },
    fixed: { type: Boolean, default: void 0 },
    hover: { type: Boolean, default: void 0 },
    id: { default: void 0 },
    noBorderCollapse: { type: Boolean, default: void 0 },
    outlined: { type: Boolean, default: void 0 },
    responsive: { type: [Boolean, String], default: void 0 },
    small: { type: Boolean, default: void 0 },
    stacked: { type: [Boolean, String], default: void 0 },
    stickyHeader: { type: [Boolean, String, Number], default: void 0 },
    striped: { type: Boolean, default: void 0 },
    stripedColumns: { type: Boolean, default: void 0 },
    variant: { default: void 0 },
    tableAttrs: {},
    tableClass: { default: void 0 }
  },
  emits: ["head-clicked", "row-clicked", "row-dblclicked", "row-contextmenu", "row-hovered", "row-unhovered", "row-middle-clicked"],
  setup(e, { emit: t }) {
    const n = ao(e, "BTableLite"), r = t, i = iP(), o = eA(() => n.id), l = (R) => [
      R,
      R._showDetails
    ], d = Ds(/* @__PURE__ */ new WeakMap());
    Jn(
      () => n.items,
      (R) => {
        R.forEach((F) => {
          Ir(F) && d.value.set(...l(F));
        });
      },
      { deep: !0, immediate: !0 }
    );
    const c = Ke(() => [
      n.tableClass,
      {
        [`align-${n.align}`]: n.align !== void 0
      }
    ]), u = Ke(() => {
      if (!n.fields.length && n.items.length) {
        const [R] = n.items;
        return R && (Ir(R) || Array.isArray(R)) ? Object.keys(R).map((F) => {
          const L = zh(F);
          return {
            key: F,
            label: L,
            tdAttr: Gh(n, L)
          };
        }) : [{ key: "", _noHeader: !0 }];
      }
      return n.fields.map((R) => {
        if (ql(R)) {
          const L = R.label ?? zh(R.key);
          return {
            ...R,
            tdAttr: { ...Gh(n, L), ...R.tdAttr }
          };
        }
        const F = zh(R);
        return {
          key: R,
          label: F,
          tdAttr: Gh(n, F)
        };
      });
    }), m = Ke(() => u.value.length), f = Ke(() => !(m.value > 0 && u.value.every((R) => R._noHeader === !0))), v = Ke(() => ({
      variant: n.footVariant ?? n.headVariant,
      class: n.tfootClass ?? n.theadClass
    })), b = (R) => i[`foot(${String(R)})`] ? `foot(${String(R)})` : i["foot()"] ? "foot()" : i[`head(${String(R)})`] ? `head(${String(R)})` : "head()", w = (R, F, L) => {
      const j = Pn(R, F);
      return L && typeof L == "function" ? L(j, F, R) : L;
    }, S = (R, F, L) => {
      const j = String(F.key), H = Pn(R, j);
      return F.thAttr && typeof F.thAttr == "function" ? F.thAttr(H, j, R, L) : F.thAttr;
    }, I = (R, F, L = !1) => {
      r("head-clicked", R.key, R, F, L);
    }, T = (R) => {
      if (Ir(R)) {
        const F = d.value.get(R);
        d.value.set(R, !F), R._showDetails = !F;
      }
    }, x = (R) => [
      R.class,
      R.thClass,
      {
        "b-table-sticky-column": R.stickyColumn
      },
      n.fieldColumnClass ? typeof n.fieldColumnClass == "function" ? n.fieldColumnClass(R) : n.fieldColumnClass : null
    ], k = (R, F) => {
      var L, j;
      const H = Pn(F, String(R.key));
      return [
        R.class,
        typeof R.tdClass == "function" ? R.tdClass(H, String(R.key), F) : R.tdClass,
        Ir(F) && (L = F._cellVariants) != null && L[R.key] ? `table-${(j = F._cellVariants) == null ? void 0 : j[R.key]}` : null,
        {
          "b-table-sticky-column": R.stickyColumn
        }
      ];
    }, C = (R, F, L) => {
      L.button === 1 && !jl(L) && r("row-middle-clicked", R, F, L);
    }, O = (R, F) => n.tbodyTrAttrs ? typeof n.tbodyTrAttrs == "function" ? n.tbodyTrAttrs(R, F) : n.tbodyTrAttrs : null, E = (R, F) => n.tbodyTrClass ? typeof n.tbodyTrClass == "function" ? n.tbodyTrClass(R, F) : n.tbodyTrClass : null, B = (R) => `${o.value}__row_${R}`, M = Ke(() => ({
      ...zE(n, YE),
      tableClass: c.value,
      id: o.value
    }));
    return (R, F) => (p(), Fe(Uzt, Mr(oP(M.value)), {
      default: ve(() => [
        V(N(qzt, {
          variant: st(n).headVariant,
          class: z(st(n).theadClass)
        }, {
          default: ve(() => [
            Ot(R.$slots, "thead-top", {
              columns: m.value,
              fields: u.value
            }),
            N(Tr, {
              variant: st(n).headRowVariant,
              class: z(st(n).theadTrClass)
            }, {
              default: ve(() => [
                (p(!0), h(A, null, D(u.value, (L) => (p(), Fe(XS, Rs({
                  key: L.key,
                  scope: L.scope,
                  class: x(L),
                  title: L.headerTitle,
                  variant: L.variant,
                  abbr: L.headerAbbr,
                  style: L.thStyle,
                  ref_for: !0
                }, S(null, L, "top"), {
                  onClick: (j) => I(L, j)
                }), {
                  default: ve(() => [
                    Ot(
                      R.$slots,
                      i[`head(${String(L.key)})`] ? `head(${String(L.key)})` : "head()",
                      {
                        label: L.label,
                        column: L.key,
                        field: L,
                        isFoot: !1
                      },
                      () => [
                        y(g(st(Wh)(L)), 1)
                      ]
                    )
                  ]),
                  _: 2
                }, 1040, ["scope", "class", "title", "variant", "abbr", "style", "onClick"]))), 128))
              ]),
              _: 3
            }, 8, ["variant", "class"]),
            i["thead-sub"] ? (p(), Fe(Tr, { key: 0 }, {
              default: ve(() => [
                (p(!0), h(A, null, D(u.value, (L) => (p(), Fe(iu, {
                  key: L.key,
                  scope: "col",
                  variant: L.variant,
                  class: z([L.class, L.thClass])
                }, {
                  default: ve(() => [
                    Ot(R.$slots, "thead-sub", {
                      items: st(n).items,
                      fields: u.value,
                      field: L
                    }, () => [
                      y(g(L.label), 1)
                    ])
                  ]),
                  _: 2
                }, 1032, ["variant", "class"]))), 128))
              ]),
              _: 3
            })) : P("", !0)
          ]),
          _: 3
        }, 8, ["variant", "class"]), [
          [Us, f.value]
        ]),
        N(zzt, {
          class: z(st(n).tbodyClass)
        }, {
          default: ve(() => [
            Ot(R.$slots, "custom-body", {
              fields: u.value,
              items: st(n).items,
              columns: m.value
            }, () => [
              !st(n).stacked && i["top-row"] ? (p(), Fe(Tr, Rs({
                key: 0,
                class: E(null, "row-top")
              }, O(null, "row-top")), {
                default: ve(() => [
                  Ot(R.$slots, "top-row", {
                    columns: m.value,
                    fields: u.value
                  })
                ]),
                _: 3
              }, 16, ["class"])) : P("", !0),
              (p(!0), h(A, null, D(st(n).items, (L, j) => (p(), h(A, {
                key: st(n).primaryKey && st(Pn)(L, st(n).primaryKey) ? st(Pn)(L, st(n).primaryKey) : j
              }, [
                N(Tr, Rs({
                  id: st(n).primaryKey && st(Pn)(L, st(n).primaryKey) ? B(st(Pn)(L, st(n).primaryKey)) : void 0,
                  class: E(L, "row"),
                  variant: st(Ir)(L) ? L._rowVariant : void 0,
                  ref_for: !0
                }, O(L, "row"), {
                  onClick: (H) => !st(jl)(H) && r("row-clicked", L, j, H),
                  onDblclick: (H) => !st(jl)(H) && r("row-dblclicked", L, j, H),
                  onContextmenu: (H) => !st(jl)(H) && r("row-contextmenu", L, j, H),
                  onMouseenter: (H) => !st(jl)(H) && r("row-hovered", L, j, H),
                  onMouseleave: (H) => !st(jl)(H) && r("row-unhovered", L, j, H),
                  onMousedown: (H) => C(L, j, H)
                }), {
                  default: ve(() => [
                    (p(!0), h(A, null, D(u.value, (H) => {
                      var te;
                      return p(), Fe(iu, Rs({
                        key: H.key,
                        variant: st(Ir)(L) && (te = L._cellVariants) != null && te[H.key] ? null : H.variant,
                        class: k(H, L),
                        ref_for: !0
                      }, w(L, String(H.key), H.tdAttr)), {
                        default: ve(() => [
                          st(n).stacked && st(n).labelStacked ? (p(), h("label", Jzt, g(st(Wh)(H)), 1)) : P("", !0),
                          Ot(
                            R.$slots,
                            i[`cell(${String(H.key)})`] ? `cell(${String(H.key)})` : "cell()",
                            {
                              value: st(Ky)(L, String(H.key), H.formatter),
                              unformatted: st(Pn)(L, String(H.key)),
                              index: j,
                              item: L,
                              field: H,
                              items: R.items,
                              toggleDetails: () => T(L),
                              detailsShowing: st(Ir)(L) ? d.value.get(L) ?? !1 : !1
                            },
                            () => [
                              !i[`cell(${String(H.key)})`] && !i["cell()"] ? (p(), h(A, { key: 0 }, [
                                y(g(st(Ky)(L, String(H.key), H.formatter)), 1)
                              ], 64)) : P("", !0)
                            ]
                          )
                        ]),
                        _: 2
                      }, 1040, ["variant", "class"]);
                    }), 128))
                  ]),
                  _: 2
                }, 1040, ["id", "class", "variant", "onClick", "onDblclick", "onContextmenu", "onMouseenter", "onMouseleave", "onMousedown"]),
                st(Ir)(L) && d.value.get(L) === !0 && i["row-details"] ? (p(), h(A, { key: 0 }, [
                  N(Tr, {
                    "aria-hidden": "true",
                    role: "presentation",
                    class: "d-none"
                  }),
                  N(Tr, Rs({
                    class: E(L, "row-details"),
                    variant: L._rowVariant,
                    ref_for: !0
                  }, O(L, "row-details")), {
                    default: ve(() => [
                      N(iu, {
                        colspan: m.value,
                        class: z(R.detailsTdClass)
                      }, {
                        default: ve(() => [
                          Ot(R.$slots, "row-details", {
                            item: L,
                            toggleDetails: () => T(L),
                            fields: u.value,
                            index: j
                          })
                        ]),
                        _: 2
                      }, 1032, ["colspan", "class"])
                    ]),
                    _: 2
                  }, 1040, ["class", "variant"])
                ], 64)) : P("", !0)
              ], 64))), 128)),
              !st(n).stacked && i["bottom-row"] ? (p(), Fe(Tr, Rs({
                key: 1,
                class: ["bottom-row", E(null, "row-bottom")]
              }, O(null, "row-bottom")), {
                default: ve(() => [
                  Ot(R.$slots, "bottom-row", {
                    columns: m.value,
                    fields: u.value
                  })
                ]),
                _: 3
              }, 16, ["class"])) : P("", !0)
            ])
          ]),
          _: 3
        }, 8, ["class"]),
        st(n).footClone ? (p(), Fe(YS, Mr(Rs({ key: 0 }, v.value)), {
          default: ve(() => [
            N(Tr, {
              variant: st(n).footRowVariant ?? st(n).headRowVariant,
              class: z(st(n).tfootTrClass ?? st(n).theadTrClass)
            }, {
              default: ve(() => [
                (p(!0), h(A, null, D(u.value, (L) => (p(), Fe(XS, Rs({
                  key: L.key,
                  scope: "col",
                  class: x(L),
                  title: L.headerTitle,
                  abbr: L.headerAbbr,
                  style: L.thStyle,
                  variant: L.variant,
                  ref_for: !0
                }, S(null, L, "bottom"), {
                  onClick: (j) => I(L, j, !0)
                }), {
                  default: ve(() => [
                    a("div", $zt, [
                      a("div", null, [
                        Ot(R.$slots, b(L.key), {
                          label: L.label,
                          column: L.key,
                          field: L,
                          isFoot: !0
                        }, () => [
                          y(g(st(Wh)(L)), 1)
                        ])
                      ])
                    ])
                  ]),
                  _: 2
                }, 1040, ["class", "title", "abbr", "style", "variant", "onClick"]))), 128))
              ]),
              _: 3
            }, 8, ["variant", "class"])
          ]),
          _: 3
        }, 16)) : i["custom-foot"] ? (p(), Fe(YS, Mr(Rs({ key: 1 }, v.value)), {
          default: ve(() => [
            Ot(R.$slots, "custom-foot", {
              fields: u.value,
              items: st(n).items,
              columns: m.value
            })
          ]),
          _: 3
        }, 16)) : P("", !0),
        i["table-caption"] || st(n).caption ? (p(), h("caption", _zt, [
          Ot(R.$slots, "table-caption", {}, () => [
            y(g(st(n).caption), 1)
          ])
        ])) : P("", !0)
      ]),
      _: 3
    }, 16));
  }
}), tWt = {
  style: { opacity: 0.4 },
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "currentColor",
  class: "bi bi-arrow-up-short",
  viewBox: "0 0 16 16",
  "aria-hidden": ""
}, sWt = {
  role: "alert",
  "aria-live": "polite"
}, aWt = { class: "text-center my-2" }, XE = /* @__PURE__ */ me({
  __name: "BTable",
  props: /* @__PURE__ */ hd({
    provider: { default: void 0 },
    noProvider: { default: void 0 },
    noProviderPaging: { type: Boolean, default: !1 },
    noProviderSorting: { type: Boolean, default: !1 },
    noProviderFiltering: { type: Boolean, default: !1 },
    mustSort: { type: [Boolean, Array], default: !1 },
    selectable: { type: Boolean, default: !1 },
    multisort: { type: Boolean, default: !1 },
    stickySelect: { type: Boolean, default: !1 },
    selectHead: { type: [Boolean, String], default: !0 },
    selectMode: { default: "multi" },
    selectionVariant: { default: "primary" },
    busyLoadingText: { default: "Loading..." },
    perPage: { default: Number.POSITIVE_INFINITY },
    currentPage: { default: 1 },
    filter: { default: void 0 },
    filterFunction: { type: Function, default: void 0 },
    filterable: { default: void 0 },
    noLocalSorting: { type: Boolean, default: !1 },
    noSelectOnClick: { type: Boolean, default: !1 },
    noSortableIcon: { type: Boolean, default: !1 },
    emptyFilteredText: { default: "There are no records matching your request" },
    emptyText: { default: "There are no records to show" },
    showEmpty: { type: Boolean, default: !1 },
    align: { default: void 0 },
    caption: { default: void 0 },
    detailsTdClass: { default: void 0 },
    fieldColumnClass: { type: [Function, String, Object, Array], default: void 0 },
    fields: { default: () => [] },
    footClone: { type: Boolean, default: void 0 },
    footRowVariant: { default: void 0 },
    footVariant: { default: void 0 },
    headRowVariant: { default: void 0 },
    headVariant: { default: void 0 },
    items: { default: () => [] },
    labelStacked: { type: Boolean, default: void 0 },
    modelValue: { default: void 0 },
    primaryKey: { default: void 0 },
    tbodyClass: { default: void 0 },
    tbodyTrAttrs: {},
    tbodyTrClass: { type: [Function, String, Array, Object], default: void 0 },
    tfootClass: { default: void 0 },
    tfootTrClass: { default: void 0 },
    theadClass: { default: void 0 },
    theadTrClass: { default: void 0 },
    bordered: { type: Boolean, default: void 0 },
    borderless: { type: Boolean, default: void 0 },
    borderVariant: { default: void 0 },
    captionTop: { type: Boolean, default: void 0 },
    dark: { type: Boolean, default: void 0 },
    fixed: { type: Boolean, default: void 0 },
    hover: { type: Boolean, default: void 0 },
    id: { default: void 0 },
    noBorderCollapse: { type: Boolean, default: void 0 },
    outlined: { type: Boolean, default: void 0 },
    responsive: { type: [Boolean, String], default: void 0 },
    small: { type: Boolean, default: void 0 },
    stacked: { type: [Boolean, String], default: void 0 },
    stickyHeader: { type: [Boolean, String, Number], default: void 0 },
    striped: { type: Boolean, default: void 0 },
    stripedColumns: { type: Boolean, default: void 0 },
    variant: { default: void 0 },
    tableAttrs: {}
  }, {
    sortBy: {
      default: void 0
    },
    sortByModifiers: {},
    busy: { type: Boolean, default: !1 },
    busyModifiers: {},
    selectedItems: {
      default: () => []
    },
    selectedItemsModifiers: {}
  }),
  emits: /* @__PURE__ */ hd(["filtered", "head-clicked", "row-clicked", "row-dblclicked", "row-contextmenu", "row-hovered", "row-unhovered", "row-middle-clicked", "row-selected", "row-unselected", "sorted", "change"], ["update:sortBy", "update:busy", "update:selectedItems"]),
  setup(e, { expose: t, emit: s }) {
    const r = ao(e, "BTable"), i = s, o = iP(), l = Ke(
      () => Object.keys(o).filter((oe) => oe.startsWith("cell("))
    ), d = Ke(
      () => Object.keys(o).filter((oe) => oe.startsWith("foot("))
    ), c = sd(e, "sortBy"), u = sd(e, "busy"), m = sd(
      e,
      "selectedItems"
    ), f = eA(() => r.id), v = Ke({
      get: () => new Set(m.value),
      set: (oe) => {
        m.value = [...oe];
      }
    });
    Jn(v, (oe, fe) => {
      Array.from(fe).filter((we) => !oe.has(we)).forEach((we) => {
        i("row-unselected", we);
      }), Array.from(oe).filter((we) => !fe.has(we)).forEach((we) => {
        i("row-selected", we);
      });
    });
    const b = {
      add: (oe) => {
        const fe = new Set(v.value);
        fe.add(oe), v.value = fe;
      },
      clear: () => {
        v.value.forEach((oe) => {
          b.delete(oe);
        });
      },
      delete: (oe) => {
        const fe = new Set(v.value);
        if (r.primaryKey) {
          const we = r.primaryKey;
          m.value.forEach((Ie, be) => {
            const Oe = Pn(Ie, we), ze = Pn(oe, we);
            Oe && ze && Oe === ze && fe.delete(m.value[be]);
          });
        } else
          fe.delete(oe);
        v.value = fe;
      },
      set: (oe) => {
        v.value = new Set(oe);
      },
      has: (oe) => {
        if (!r.primaryKey) return v.value.has(oe);
        const fe = r.primaryKey;
        for (const we of v.value) {
          const Ie = Pn(we, fe), be = Pn(oe, fe);
          if (Ie && be && Ie === be) return !0;
        }
        return !1;
      }
    }, w = Ds([]), S = td(() => r.perPage, { method: "parseInt" }), I = td(() => r.currentPage, { method: "parseInt" }), T = Ke(() => !!r.filter), x = Ke(() => r.provider !== void 0), k = Ke(() => v.value.size > 0), C = Ke(
      () => c.value !== void 0 || r.fields.some(
        (oe) => typeof oe == "object" && oe !== null && oe.sortable === !0
      )
    ), O = Ke(
      () => r.fields.map((oe) => {
        var fe;
        if (!ql(oe)) {
          const be = zh(oe);
          return {
            key: oe,
            label: be,
            tdAttr: Gh(r, be)
          };
        }
        const we = (fe = c.value) == null ? void 0 : fe.find((be) => oe.key === be.key), Ie = C.value === !1 ? void 0 : we === void 0 ? "none" : we.order === "desc" ? "descending" : we.order === "asc" ? "ascending" : "none";
        return {
          ...oe,
          thAttr: {
            "aria-sort": Ie,
            ...oe.thAttr
          }
        };
      })
    ), E = Ke(() => ({
      "b-table-busy": u.value,
      "b-table-selectable": r.selectable,
      "user-select-none": r.selectable && k.value
    })), B = Ke(() => [
      r.tbodyTrClass ? typeof r.tbodyTrClass == "function" ? r.tbodyTrClass(null, "table-busy") : r.tbodyTrClass : null
    ]), M = (oe) => [
      {
        "b-table-sortable-column": C.value && oe.sortable
      }
    ], R = (oe, fe) => [
      {
        [`selected table-${r.selectionVariant}`]: r.selectable && !!oe && b.has(oe)
      },
      r.tbodyTrClass ? typeof r.tbodyTrClass == "function" ? r.tbodyTrClass(oe, fe) : r.tbodyTrClass : null
    ], F = (oe) => typeof oe.sortByFormatted == "function" ? oe.sortByFormatted : oe.formatter, L = (oe, fe) => {
      if (!Ir(oe)) return String(oe);
      const we = O.value.find((be) => ql(be) ? be.key === fe : !1), Ie = Pn(oe, fe);
      if (ql(we) && we.sortByFormatted) {
        const be = F(we);
        if (be)
          return String(Ky(oe, String(we.key), be));
      }
      return typeof Ie == "object" && Ie !== null ? JSON.stringify(Ie) : (Ie == null ? void 0 : Ie.toString()) ?? "";
    }, j = Ke(() => {
      var oe;
      const fe = (oe = c.value) == null ? void 0 : oe.filter((Oe) => !!Oe.order), we = (Oe) => {
        if (typeof Oe == "object" && Oe !== null && Object.keys(Oe).some((ze) => ze.includes("."))) {
          let ze = {};
          for (const Re in Oe)
            Re.includes(".") ? ze = Fzt(ze, Re, Oe[Re]) : ze[Re] = Oe[Re];
          return ze;
        }
        return Oe;
      }, Ie = (Oe) => Ir(Oe) ? Object.entries(Oe).some(([ze, Re]) => {
        var ge, he, Me;
        return Re == null || ze[0] === "_" || !((ge = r.filterable) != null && ge.includes(ze)) && ((he = r.filterable) != null && he.length) ? !1 : r.filterFunction && typeof r.filterFunction == "function" ? r.filterFunction(Oe, r.filter) : (() => {
          const mt = O.value.find((yt) => ql(yt) ? yt.key === ze : !1);
          if (ql(mt) && mt.filterByFormatted) {
            const yt = F(mt);
            if (yt)
              return String(yt(Re, String(mt.key), Oe));
          }
          return typeof Re == "object" ? JSON.stringify(Object.values(Re)) : Re.toString();
        })().toLowerCase().includes(((Me = r.filter) == null ? void 0 : Me.toLowerCase()) ?? "");
      }) : !0, be = (x.value ? w.value : r.items).reduce(
        (Oe, ze) => {
          const Re = we(ze);
          return (!(T.value && (!x.value || r.noProviderFiltering)) || Ie(Re)) && Oe.push(Re), Oe;
        },
        []
      );
      return fe != null && fe.length && (C.value === !0 && !x.value && !r.noLocalSorting || C.value === !0 && x.value && r.noProviderSorting) ? be.sort((Oe, ze) => {
        for (let Re = 0; Re < fe.length; Re++) {
          const { key: ge, comparer: he, order: Me } = fe[Re], Ne = he ? he(Oe, ze, ge) : L(Oe, ge).localeCompare(L(ze, ge), void 0, { numeric: !0 });
          if (Ne !== 0)
            return Me === "asc" ? Ne : -Ne;
        }
        return 0;
      }) : be;
    }), H = Ke(() => ({
      emptyFilteredText: r.emptyFilteredText,
      emptyText: r.emptyText,
      fields: O.value,
      items: j.value
    })), te = Ke(() => Number.isNaN(S.value) || x.value && !r.noProviderPaging ? j.value : j.value.slice(
      (I.value - 1) * (S.value || Number.POSITIVE_INFINITY),
      I.value * (S.value || Number.POSITIVE_INFINITY)
    ));
    Jn(te, (oe) => {
      i("change", oe);
    });
    const re = (oe, fe, we = !1, Ie = !1, be = !1) => {
      if (r.selectable)
        if (r.selectMode === "single" || r.selectMode === "multi") {
          if (we || Ie) return;
          b.has(oe) ? b.delete(oe) : r.selectMode === "single" ? b.set([oe]) : b.add(oe);
        } else if (Ie || be)
          b.has(oe) ? b.delete(oe) : b.add(oe);
        else if (we) {
          const Oe = [...v.value].pop(), ze = j.value.findIndex((Me) => Me === Oe), Re = Math.min(ze, fe), ge = Math.max(ze, fe), he = j.value.slice(Re, ge + 1);
          b.set(he);
        } else
          b.set([oe]);
    }, le = (oe, fe, we) => {
      r.noSelectOnClick === !1 && re(oe, fe, we.shiftKey, we.ctrlKey, we.metaKey), i("row-clicked", oe, fe, we);
    }, ie = (oe) => {
      var fe, we;
      if (!C.value) return;
      const Ie = typeof oe == "object" && oe !== null ? oe.key : oe, be = typeof oe == "object" && oe !== null ? oe.sortable : !1;
      if (!(C.value === !0 && be === !0)) return;
      const Oe = (Ne) => {
        if (Ne === "asc") return "desc";
        if (Ne === void 0 || r.mustSort === !0 || Array.isArray(r.mustSort) && r.mustSort.includes(Ie))
          return "asc";
      }, ze = ((fe = c.value) == null ? void 0 : fe.findIndex((Ne) => Ne.key === Ie)) ?? -1, Re = (we = c.value) == null ? void 0 : we[ze], ge = (
        // If value is new, we default to ascending
        // Otherwise we make a temp copy of the value
        ze === -1 || !Re ? { key: Ie, order: "asc" } : { ...Re }
      ), he = () => {
        const Ne = [...c.value ?? []], $e = ge;
        return ze === -1 ? Ne.push($e) : ($e.order = Oe($e.order), Ne.splice(ze, 1, $e)), c.value = Ne, $e;
      }, Me = () => {
        const Ne = {
          ...ge,
          order: ze === -1 ? ge.order : Oe(ge.order)
        }, $e = (c.value || []).map((mt) => ({
          ...mt,
          order: void 0
        }));
        return ze === -1 ? $e.push(Ne) : $e[ze] = Ne, c.value = $e, Ne;
      };
      i("sorted", r.multisort === !0 ? he() : Me());
    }, ye = (oe, fe, we, Ie = !1) => {
      i("head-clicked", oe, fe, we, Ie), ie(fe);
    }, Y = async () => {
      if (!x.value || r.provider === void 0 || u.value) return;
      u.value = !0;
      const oe = r.provider({
        currentPage: I.value,
        filter: r.filter,
        sortBy: c.value,
        perPage: S.value
      });
      try {
        const fe = oe instanceof Promise ? await oe : oe;
        if (fe === void 0) return;
        w.value = fe;
      } finally {
        u.value = !1;
      }
    }, ae = async (oe, fe, we) => {
      if (WE(fe, we)) return;
      const Ie = (Re) => {
        var ge;
        return ((ge = r.noProvider) == null ? void 0 : ge.includes(Re)) === !0;
      }, be = (oe === "currentPage" || oe === "perPage") && (Ie("paging") || r.noProviderPaging === !0), Oe = oe === "filter" && (Ie("filtering") || r.noProviderFiltering === !0), ze = (oe === "sortBy" || oe === "sortDesc") && (Ie("sorting") || r.noProviderSorting === !0);
      be || Oe || ze || (x.value === !0 && await Y(), oe === "currentPage" || oe === "perPage" || i("filtered", [...j.value]));
    };
    Jn(
      () => r.filter,
      (oe, fe) => {
        ae("filter", oe, fe), !(oe === fe || x.value) && (oe || i("filtered", [...j.value]));
      }
    ), Jn(I, (oe, fe) => {
      ae("currentPage", oe, fe);
    }), Jn(S, (oe, fe) => {
      ae("perPage", oe, fe);
    }), Jn(
      c,
      (oe, fe) => {
        ae("sortBy", oe, fe);
      },
      { deep: !0 }
    ), Jn(
      () => r.provider,
      (oe) => {
        if (oe === void 0) {
          w.value = [];
          return;
        }
        Y();
      }
    ), aP(Y);
    const ke = {
      clearSelected: () => {
        r.selectable && b.clear();
      },
      selectAllRows: () => {
        !r.selectable || r.selectMode === "single" || (v.value = new Set(j.value));
      },
      selectRow: (oe) => {
        if (!r.selectable) return;
        const fe = j.value[oe];
        !fe || b.has(fe) || (r.selectMode === "single" ? b.set([fe]) : b.add(fe));
      },
      unselectRow: (oe) => {
        if (!r.selectable) return;
        const fe = j.value[oe];
        !fe || !b.has(fe) || b.delete(fe);
      },
      isRowSelected: (oe) => {
        if (!r.selectable) return !1;
        const fe = j.value[oe];
        return b.has(fe);
      }
    }, ue = Ke(() => ({
      ...zE(r, [...Qzt, ...YE]),
      tableAttrs: {
        ariaBusy: u.value
      },
      items: te.value,
      fields: O.value,
      tableClass: E.value,
      tbodyTrClass: R,
      fieldColumnClass: M,
      id: f.value
    }));
    return t({
      // The row selection methods are really for compat. Users should probably use the v-model though
      ...ke,
      items: j,
      displayItems: te,
      getStringValue: L,
      refresh: Y
    }), (oe, fe) => (p(), Fe(eWt, Rs(ue.value, {
      onHeadClicked: ye,
      onRowClicked: le,
      onRowDblclicked: fe[0] || (fe[0] = (we, Ie, be) => {
        i("row-dblclicked", we, Ie, be);
      }),
      onRowContextmenu: fe[1] || (fe[1] = (we, Ie, be) => {
        i("row-contextmenu", we, Ie, be);
      }),
      onRowHovered: fe[2] || (fe[2] = (we, Ie, be) => {
        i("row-hovered", we, Ie, be);
      }),
      onRowUnhovered: fe[3] || (fe[3] = (we, Ie, be) => {
        i("row-unhovered", we, Ie, be);
      }),
      onRowMiddleClicked: fe[4] || (fe[4] = (we, Ie, be) => {
        i("row-middle-clicked", we, Ie, be);
      })
    }), nP({
      "custom-body": ve((we) => [
        u.value && o["table-busy"] ? (p(), Fe(Tr, {
          key: 0,
          class: z(["b-table-busy-slot", B.value])
        }, {
          default: ve(() => [
            N(iu, {
              colspan: we.fields.length
            }, {
              default: ve(() => [
                Ot(oe.$slots, "table-busy")
              ]),
              _: 2
            }, 1032, ["colspan"])
          ]),
          _: 2
        }, 1032, ["class"])) : st(r).showEmpty === !0 && j.value.length === 0 ? (p(), Fe(Tr, {
          key: 1,
          class: "b-table-empty-row"
        }, {
          default: ve(() => [
            N(iu, {
              colspan: O.value.length
            }, {
              default: ve(() => [
                a("div", sWt, [
                  a("div", aWt, [
                    T.value ? Ot(oe.$slots, "empty-filtered", Mr(Rs({ key: 0 }, H.value)), () => [
                      y(g(st(r).emptyFilteredText), 1)
                    ]) : Ot(oe.$slots, "empty", Mr(Rs({ key: 1 }, H.value)), () => [
                      y(g(st(r).emptyText), 1)
                    ])
                  ])
                ])
              ]),
              _: 3
            }, 8, ["colspan"])
          ]),
          _: 3
        })) : P("", !0)
      ]),
      _: 2
    }, [
      o["thead-top"] ? {
        name: "thead-top",
        fn: ve((we) => [
          Ot(oe.$slots, "thead-top", Rs(we, {
            clearSelected: ke.clearSelected,
            selectAllRows: ke.selectAllRows,
            fields: O.value
          }))
        ]),
        key: "0"
      } : void 0,
      o["thead-sub"] ? {
        name: "thead-sub",
        fn: ve((we) => [
          Ot(oe.$slots, "thead-sub", Rs(we, { fields: O.value }))
        ]),
        key: "1"
      } : void 0,
      o["top-row"] ? {
        name: "top-row",
        fn: ve((we) => [
          Ot(oe.$slots, "top-row", Rs(we, { fields: O.value }))
        ]),
        key: "2"
      } : void 0,
      o["row-details"] ? {
        name: "row-details",
        fn: ve((we) => [
          Ot(oe.$slots, "row-details", Rs(we, {
            fields: O.value,
            selectRow: (Ie = we.index) => ke.selectRow(Ie),
            unselectRow: (Ie = we.index) => ke.unselectRow(Ie),
            rowSelected: ke.isRowSelected(we.index)
          }))
        ]),
        key: "3"
      } : void 0,
      o["bottom-row"] ? {
        name: "bottom-row",
        fn: ve((we) => [
          Ot(oe.$slots, "bottom-row", Rs(we, { fields: O.value }))
        ]),
        key: "4"
      } : void 0,
      o["custom-foot"] ? {
        name: "custom-foot",
        fn: ve((we) => [
          Ot(oe.$slots, "custom-foot", Rs(we, { fields: O.value }))
        ]),
        key: "5"
      } : void 0,
      o["table-caption"] ? {
        name: "table-caption",
        fn: ve(() => [
          Ot(oe.$slots, "table-caption")
        ]),
        key: "6"
      } : void 0,
      D(l.value, (we) => ({
        name: we,
        fn: ve((Ie) => [
          Ot(oe.$slots, we, Rs(Ie, {
            selectRow: (be = Ie.index) => ke.selectRow(be),
            unselectRow: (be = Ie.index) => ke.unselectRow(be),
            rowSelected: ke.isRowSelected(Ie.index)
          }))
        ])
      })),
      D(d.value, (we) => ({
        name: we,
        fn: ve((Ie) => [
          Ot(oe.$slots, we, Rs(Ie, {
            selectAllRows: ke.selectAllRows,
            clearSelected: ke.clearSelected
          }))
        ])
      })),
      D(O.value, (we) => ({
        name: `head(${String(we.key)})`,
        fn: ve((Ie) => {
          var be, Oe, ze, Re;
          return [
            Ot(
              oe.$slots,
              o[`head(${String(we.key)})`] ? `head(${String(we.key)})` : "head()",
              Rs(Ie, {
                selectAllRows: ke.selectAllRows,
                clearSelected: ke.clearSelected
              }),
              () => [
                y(g(st(Wh)(we)), 1)
              ]
            ),
            C.value && Ie.field.sortable && st(r).noSortableIcon === !1 ? (p(), h(A, { key: 0 }, [
              ((Oe = (be = c.value) == null ? void 0 : be.find((ge) => ge.key === Ie.field.key)) == null ? void 0 : Oe.order) === "asc" ? Ot(
                oe.$slots,
                o[`sortAsc(${String(Ie.field.key)})`] ? `sortAsc(${String(Ie.field.key)})` : "sortAsc()",
                Mr(Rs({ key: 0 }, Ie)),
                () => [
                  fe[5] || (fe[5] = a("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "24",
                    height: "24",
                    fill: "currentColor",
                    class: "bi bi-arrow-up-short",
                    viewBox: "0 0 16 16",
                    "aria-hidden": ""
                  }, [
                    a("path", {
                      "fill-rule": "evenodd",
                      d: "M8 12a.5.5 0 0 0 .5-.5V5.707l2.146 2.147a.5.5 0 0 0 .708-.708l-3-3a.5.5 0 0 0-.708 0l-3 3a.5.5 0 1 0 .708.708L7.5 5.707V11.5a.5.5 0 0 0 .5.5z"
                    })
                  ], -1))
                ]
              ) : ((Re = (ze = c.value) == null ? void 0 : ze.find((ge) => ge.key === Ie.field.key)) == null ? void 0 : Re.order) === "desc" ? Ot(
                oe.$slots,
                o[`sortDesc(${String(Ie.field.key)})`] ? `sortDesc(${String(Ie.field.key)})` : "sortDesc()",
                Mr(Rs({ key: 1 }, Ie)),
                () => [
                  fe[6] || (fe[6] = a("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "24",
                    height: "24",
                    fill: "currentColor",
                    class: "bi bi-arrow-down-short",
                    viewBox: "0 0 16 16",
                    "aria-hidden": ""
                  }, [
                    a("path", {
                      "fill-rule": "evenodd",
                      d: "M8 4a.5.5 0 0 1 .5.5v5.793l2.146-2.147a.5.5 0 0 1 .708.708l-3 3a.5.5 0 0 1-.708 0l-3-3a.5.5 0 1 1 .708-.708L7.5 10.293V4.5A.5.5 0 0 1 8 4z"
                    })
                  ], -1))
                ]
              ) : Ot(
                oe.$slots,
                o[`sortDefault(${String(Ie.field.key)})`] ? `sortDefault(${String(Ie.field.key)})` : "sortDefault()",
                Mr(Rs({ key: 2 }, Ie)),
                () => [
                  (p(), h("svg", tWt, fe[7] || (fe[7] = [
                    a("path", {
                      "fill-rule": "evenodd",
                      d: "M8 12a.5.5 0 0 0 .5-.5V5.707l2.146 2.147a.5.5 0 0 0 .708-.708l-3-3a.5.5 0 0 0-.708 0l-3 3a.5.5 0 1 0 .708.708L7.5 5.707V11.5a.5.5 0 0 0 .5.5z"
                    }, null, -1)
                  ])))
                ]
              )
            ], 64)) : P("", !0)
          ];
        })
      }))
    ]), 1040));
  }
}), qE = {
  BAccordion: "/components/BAccordion",
  BAccordionItem: "/components/BAccordion",
  BAlert: "/components/BAlert",
  BAvatar: "/components/BAvatar",
  BAvatarGroup: "/components/BAvatar",
  BBadge: "/components/BBadge",
  BBreadcrumb: "/components/BBreadcrumb",
  BBreadcrumbItem: "/components/BBreadcrumb",
  BButton: "/components/BButton",
  BButtonGroup: "/components/BButton",
  BButtonToolbar: "/components/BButton",
  BCloseButton: "/components/BButton",
  BCard: "/components/BCard",
  BCardBody: "/components/BCard",
  BCardFooter: "/components/BCard",
  BCardGroup: "/components/BCard",
  BCardHeader: "/components/BCard",
  BCardImg: "/components/BCard",
  BCardSubtitle: "/components/BCard",
  BCardText: "/components/BCard",
  BCardTitle: "/components/BCard",
  BCarousel: "/components/BCarousel",
  BCarouselSlide: "/components/BCarousel",
  BCol: "/components/BContainer",
  BCollapse: "/components/BCollapse",
  BContainer: "/components/BContainer",
  BDropdown: "/components/BDropdown",
  BDropdownDivider: "/components/BDropdown",
  BDropdownForm: "/components/BDropdown",
  BDropdownGroup: "/components/BDropdown",
  BDropdownHeader: "/components/BDropdown",
  BDropdownItem: "/components/BDropdown",
  BDropdownItemButton: "/components/BDropdown",
  BDropdownText: "/components/BDropdown",
  BForm: "/components/BForm",
  BFormCheckbox: "/components/BFormCheckbox",
  BFormCheckboxGroup: "/components/BFormCheckbox",
  BFormDatalist: "/components/BForm",
  BFormFile: "/components/BFormFile",
  BFormFloatingLabel: "/components/BForm",
  BFormGroup: "/components/BFormGroup",
  BFormInput: "/components/BFormInput",
  BFormInvalidFeedback: "/components/BForm",
  BFormRadio: "/components/BFormRadio",
  BFormRadioGroup: "/components/BFormRadio",
  BFormRow: "/components/BForm",
  BFormSelect: "/components/BFormSelect",
  BFormSelectOption: "/components/BFormSelect",
  BFormSelectOptionGroup: "/components/BFormSelect",
  BFormSpinbutton: "/components/BFormSpinbutton",
  BFormTag: "/components/BFormTags",
  BFormTags: "/components/BFormTags",
  BFormText: "/components/BForm",
  BFormTextarea: "/components/BFormTextarea",
  BFormValidFeedback: "/components/BForm",
  BImg: "/components/BImg",
  BInput: "/components/BFormInput",
  BInputGroup: "/components/BInputGroup",
  BInputGroupText: "/components/BInputGroup",
  BListGroup: "/components/BListGroup",
  BListGroupItem: "/components/BListGroup",
  BModal: "/components/BModal",
  BModalOrchestrator: "/components/BModal",
  BNav: "/components/BNav",
  BNavForm: "/components/BNav",
  BNavItem: "/components/BNav",
  BNavItemDropdown: "/components/BNav",
  BNavText: "/components/BNav",
  BNavbar: "/components/BNavbar",
  BNavbarBrand: "/components/BNavbar",
  BNavbarNav: "/components/BNavbar",
  BNavbarToggle: "/components/BNavbar",
  BOffcanvas: "/components/BOffcanvas",
  BOverlay: "/components/BOverlay",
  BPagination: "/components/BPagination",
  BPlaceholder: "/components/BPlaceholder",
  BPlaceholderButton: "/components/BPlaceholder",
  BPlaceholderCard: "/components/BPlaceholder",
  BPlaceholderTable: "/components/BPlaceholder",
  BPlaceholderWrapper: "/components/BPlaceholder",
  BPopover: "/components/BPopover",
  BProgress: "/components/BProgress",
  BRow: "/components/BContainer",
  BSpinner: "/components/BSpinner",
  BTab: "/components/BTabs",
  BTabs: "/components/BTabs",
  BToast: "/components/BToast",
  BToastOrchestrator: "/components/BToast",
  BTooltip: "/components/BTooltip",
  BLink: "/components/BLink",
  BProgressBar: "/components/BProgress",
  BTableSimple: "/components/BTable",
  BTableLite: "/components/BTable",
  BTable: "/components/BTable",
  BTbody: "/components/BTable",
  BTd: "/components/BTable",
  BTh: "/components/BTable",
  BThead: "/components/BTable",
  BTfoot: "/components/BTable",
  BTr: "/components/BTable",
  BPopoverOrchestrator: "/components/BPopover"
}, nWt = Object.freeze(
  Object.keys(qE)
), QE = {
  vBColorMode: "/directives/BColorMode",
  vBModal: "/directives/BModal",
  vBPopover: "/directives/BPopover",
  vBScrollspy: "/directives/BScrollspy",
  vBToggle: "/directives/BToggle",
  vBTooltip: "/directives/BTooltip"
}, rWt = Object.freeze(
  Object.keys(QE)
), oWt = {
  useBreadcrumb: "/composables/useBreadcrumb",
  useColorMode: "/composables/useColorMode",
  useModal: "/composables/useModal",
  useModalController: "/composables/useModalController",
  useScrollspy: "/composables/useScrollspy",
  useToastController: "/composables/useToastController",
  usePopoverController: "/composables/usePopoverController"
};
Object.freeze(
  Object.keys(oWt)
);
const qS = "bootstrap-vue-next", QS = (e, t) => {
  const { all: s, ...n } = e, r = {};
  s && t.forEach((o) => {
    r[o] = s;
  });
  const i = { ...r, ...n };
  return Object.entries(i).filter(([o, l]) => !!l && t.includes(o)).map(([o]) => o);
}, av = /* @__PURE__ */ new Set(), KS = /* @__PURE__ */ new Set();
Object.assign(
  ({
    aliases: e = {},
    directives: t = !0,
    components: s = !0
  } = {}) => {
    const r = QS(typeof s == "boolean" ? { all: s } : s, nWt).reduce(
      (d, c) => (d.set(c, `${qS}${qE[c]}`), d),
      /* @__PURE__ */ new Map()
    ), o = QS(typeof t == "boolean" ? { all: t } : t, rWt).reduce(
      (d, c) => {
        const u = c.toLowerCase().startsWith("v") ? c : `v${c}`;
        return d.set(u, `${qS}${QE[u]}`), d;
      },
      /* @__PURE__ */ new Map()
    );
    return [
      {
        type: "component",
        resolve(d) {
          const c = r.get(d), u = r.get(e[d]);
          if (u) {
            const m = e[d];
            return av.add(m), {
              name: m,
              from: u
            };
          }
          if (c)
            return av.add(d), {
              name: d,
              from: c
            };
        }
      },
      {
        type: "directive",
        resolve(d) {
          const c = `v${d}`, u = o.get(c);
          if (u)
            return KS.add(c), {
              name: c,
              from: u
            };
        }
      }
    ];
  },
  {
    __usedComponents: av,
    __usedDirectives: KS
  }
);
var KE = /* @__PURE__ */ ((e) => (e.zip = "zip", e.counties = "counties", e))(KE || {});
const iWt = me({
  props: {
    isSearching: {
      type: Boolean,
      default: !1
    },
    totalRecords: Number,
    filteredRecords: Number
  },
  enums: {
    tabs: KE
  },
  emits: ["searchLeads"],
  components: {
    AutoComplete: e1
  },
  data() {
    return {
      isLoading: !0,
      currentTab: "zip",
      errors: "",
      owner_name: void 0,
      address: void 0,
      city: void 0,
      state: void 0,
      zip: void 0,
      zip_codes: "",
      selectedState: void 0,
      selectedCounty: void 0,
      propertyType: Xt.SingleFamily,
      min_value: 1,
      max_value: 1e6,
      include_crm: !1,
      min_homes: 3,
      max_homes: 10,
      min_homes_error: void 0,
      // Zip Lookup
      debounce: void 0,
      autocompleteZipcodes: void 0,
      selectedZipcodes: [],
      propertyTypes: [
        {
          id: Xt.Residential24Family,
          name: "2-4 Family"
        },
        {
          id: Xt.Commercial,
          name: "Commercial"
        },
        {
          id: Xt.MobileHomeParks,
          name: "Mobile Home Parks"
        },
        {
          id: Xt.MultiFamily,
          name: "Multifamily"
        },
        {
          id: Xt.Retail,
          name: "Retail"
        },
        {
          id: Xt.RvParksCampground,
          name: "RV Parks/Campgrounds"
        },
        {
          id: Xt.SelfStorage,
          name: "Self Storage"
        },
        {
          id: Xt.SingleFamily,
          name: "Single Family"
        }
      ],
      excludeInStateOwner: !1,
      includeFavorited: !1,
      excludePoBoxMailingAddresses: !1,
      excludeCompanies: !1,
      states: [],
      counties: []
    };
  },
  watch: {
    selectedState(e) {
      e && e.length >= 2 && this.fetchCounties();
    }
  },
  computed: {
    tabZipCodes() {
      return {
        "nav-link": !0,
        active: this.currentTab == "zip",
        show: this.currentTab == "zip"
        /* zip */
      };
    },
    tabCounties() {
      return {
        "nav-link": !0,
        active: this.currentTab == "counties",
        show: this.currentTab == "counties"
        /* counties */
      };
    },
    canSearchZip() {
      var e;
      return this.isLoading == !1 && this.isSearching == !1 && (((e = this.selectedState) == null ? void 0 : e.length) ?? 0) > 0 && this.selectedZipcodes.length > 0;
    },
    canSearchCounty() {
      var e;
      return this.isLoading == !1 && this.isSearching == !1 && (((e = this.selectedCounty) == null ? void 0 : e.length) ?? 0) > 0;
    },
    zipCodesPlaceholder() {
      return this.selectedState ? "Add ZipCode" : "Select a state";
    },
    countyPlaceholder() {
      return this.selectedState ? "Select a county to search." : "Select a state first.";
    },
    minHomesHelp() {
      return this.min_homes_error;
    },
    ...q(Te, ["access", "aclLoaded"])
  },
  methods: {
    currency: Ze,
    number: Ve,
    searchZipcodes(e) {
      !e.query.trim().length || !this.selectedState || (clearTimeout(this.debounce), this.debounce = setTimeout(async () => {
        var t;
        try {
          const s = await W.api.portfolioFinder.zipLookup(this.selectedState, e.query);
          if (s.data.status != de.Success)
            throw new Le(s);
          this.autocompleteZipcodes = ((t = s.data.result) == null ? void 0 : t.map((n) => ({
            name: n
          }))) ?? [];
        } catch (s) {
          Se(s);
        }
      }, 250));
    },
    async initialize() {
      try {
        this.selectedState = localStorage.getItem(De.StorageKeys.PortfolioFinder.LastState) ?? void 0, this.selectedCounty = localStorage.getItem(De.StorageKeys.PortfolioFinder.LastCounty) ?? void 0;
        const e = localStorage.getItem(De.StorageKeys.PortfolioFinder.LastPropertyType);
        e && (this.propertyType = e);
        const t = localStorage.getItem(De.StorageKeys.PortfolioFinder.LastMinProperties);
        t && (this.min_homes = parseInt(t));
        const s = localStorage.getItem(De.StorageKeys.PortfolioFinder.LastMaxProperties);
        s && (this.max_homes = parseInt(s)), await this.fetchStates(), this.selectTab(this.currentTab);
      } catch (e) {
        Se(e);
      }
      this.isLoading = !1;
    },
    async fetchStates() {
      try {
        this.isLoading = !0;
        const e = await W.api.portfolioFinder.states();
        if (e.data.status != de.Success)
          throw new Le(e);
        this.states.length = 0, e.data.states && this.states.push(...e.data.states), !this.selectedState && this.states.length > 0 && (this.selectedState = this.states[0].abv ?? void 0);
      } catch (e) {
        Se(e);
      }
      this.isLoading = !1;
    },
    async fetchCounties() {
      try {
        if (this.isLoading = !0, !this.selectedState || this.selectedState.length < 2)
          return;
        const e = await W.api.portfolioFinder.counties(this.selectedState);
        if (e.data.status != de.Success)
          throw new Le(e);
        this.counties.length = 0, e.data.page && this.counties.push(...e.data.page), this.counties.sort(), this.counties.length > 0 && this.counties.splice(0, 0, { county: "All Counties", state: this.selectedState, key: `${this.selectedState}:*` }), !this.selectedCounty && this.counties.length > 0 && (this.selectedCounty = this.counties[0].county ?? void 0);
      } catch (e) {
        Se(e);
      } finally {
        this.isLoading = !1;
      }
    },
    search(e) {
      this.zip_codes = this.selectedZipcodes.map((t) => t.name).join(","), console.log("search", e, this.zip_codes), this.$emit("searchLeads", {
        type: e,
        owner_name: this.owner_name,
        address: this.address,
        city: this.city,
        state: this.state,
        zip: this.zip,
        zip_codes: this.zip_codes,
        county: this.selectedCounty,
        min_value: this.min_value,
        max_value: this.max_value,
        include_crm: this.include_crm,
        state_option: this.selectedState,
        min_homes: this.min_homes,
        max_homes: this.max_homes,
        propertyType: this.propertyType,
        excludeInStateOwner: this.excludeInStateOwner,
        includeFavorited: this.includeFavorited,
        includePoBoxMailingAddresses: !this.excludePoBoxMailingAddresses,
        excludeCompanies: this.excludeCompanies
      });
    },
    selectTab(e) {
      this.currentTab = e;
      let t;
      switch (e) {
        case "zip":
          t = bootstrap.Tab.getOrCreateInstance(this.$refs.zip);
          break;
        case "counties":
          t = bootstrap.Tab.getOrCreateInstance(this.$refs.counties);
          break;
      }
      t == null || t.show();
    }
  },
  mounted() {
    this.selectTab(this.currentTab), this.initialize().then(() => {
      document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach((e) => new bootstrap.Tooltip(e));
    });
  }
}), lWt = {
  class: "card shadow-sm mb-4",
  style: { overflow: "inherit" }
}, dWt = {
  class: "nav nav-tabs",
  id: "myTab",
  role: "tablist"
}, cWt = {
  class: "nav-item",
  role: "presentation"
}, uWt = {
  class: "nav-item",
  role: "presentation"
}, pWt = {
  key: 0,
  class: "nav-item",
  role: "presentation"
}, hWt = {
  key: 1,
  class: "nav-item",
  role: "presentation"
}, mWt = {
  key: 2,
  class: "nav-item",
  role: "presentation"
}, fWt = {
  class: "tab-content",
  id: "myTabContent"
}, gWt = { class: "card-body" }, vWt = { class: "row g-2" }, yWt = { class: "col-12 col-md-3 col-lg-2" }, bWt = { class: "form-group m-md-0" }, AWt = ["value"], wWt = { class: "col-12 col-md-9 col-lg-6 col-xl-5" }, CWt = { class: "form-group m-md-0" }, SWt = { class: "col-12 col-md-6 col-lg-4 col-xl-2" }, PWt = { class: "form-group m-md-0" }, kWt = ["disabled"], EWt = ["value"], IWt = { class: "col-12 col-md-6 col-lg-4 col-xl-3" }, TWt = { class: "row" }, OWt = { class: "col-6" }, RWt = {
  id: "min_homesHelpBlock",
  class: "form-text text-secondary text-opacity-75"
}, LWt = { class: "col-6" }, BWt = { class: "card-body border-top" }, MWt = { class: "row g-2" }, xWt = { class: "col-2 d-flex gap-2" }, FWt = { class: "dropdown dropdown-filter-exclude" }, VWt = ["disabled"], DWt = {
  class: "dropdown-menu shadow p-2",
  style: { width: "360px" }
}, NWt = { class: "form-check form-switch" }, jWt = ["disabled"], HWt = { class: "form-check form-switch" }, UWt = ["disabled"], zWt = { class: "form-check form-switch" }, WWt = ["disabled"], GWt = { class: "dropdown dropdown-filter-show" }, YWt = ["disabled"], XWt = {
  class: "dropdown-menu shadow p-2",
  style: { width: "270px" }
}, qWt = { class: "form-check form-switch" }, QWt = ["disabled"], KWt = { class: "form-check form-switch" }, ZWt = ["disabled"], JWt = { class: "col-8 text-center" }, $Wt = { key: 0 }, _Wt = { key: 1 }, eGt = { class: "col-2 text-end" }, tGt = ["disabled"], sGt = ["textContent"], aGt = { class: "card-body" }, nGt = { class: "row g-2" }, rGt = { class: "col-sm-6 col-md-2 col-lg-3" }, oGt = { class: "form-group m-md-0" }, iGt = ["disabled"], lGt = ["value"], dGt = { class: "col-sm-6 col-md-3" }, cGt = { class: "form-group m-md-0" }, uGt = ["disabled"], pGt = ["value"], hGt = {
  id: "countyHelpBlock",
  class: "form-text text-secondary text-opacity-75"
}, mGt = { class: "col-sm-5 col-md-3" }, fGt = { class: "form-group m-md-0" }, gGt = ["disabled"], vGt = ["value"], yGt = { class: "col-sm-7 col-md-4 col-lg-3" }, bGt = { class: "row" }, AGt = { class: "col-6 col-sm-0 mb-3 mb-md-0" }, wGt = ["disabled"], CGt = {
  id: "min_homesHelpBlock",
  class: "form-text text-secondary text-opacity-75"
}, SGt = { class: "col-6 col-sm-0 mb-3 mb-md-0" }, PGt = ["disabled"], kGt = { class: "card-body border-top" }, EGt = { class: "row g-2" }, IGt = { class: "col-2 d-flex gap-2" }, TGt = { class: "dropdown dropdown-filter-exclude" }, OGt = ["disabled"], RGt = {
  class: "dropdown-menu shadow p-2",
  style: { width: "360px" }
}, LGt = { class: "form-check form-switch" }, BGt = ["disabled"], MGt = { class: "form-check form-switch" }, xGt = ["disabled"], FGt = { class: "form-check form-switch" }, VGt = ["disabled"], DGt = { class: "dropdown dropdown-filter-show" }, NGt = ["disabled"], jGt = {
  class: "dropdown-menu shadow p-2",
  style: { width: "270px" }
}, HGt = { class: "form-check form-switch" }, UGt = ["disabled"], zGt = { class: "form-check form-switch" }, WGt = ["disabled"], GGt = { class: "col-8 text-center" }, YGt = { key: 0 }, XGt = { key: 1 }, qGt = { class: "col-2 text-end" }, QGt = ["disabled"], KGt = ["textContent"], ZGt = {
  class: "tab-pane fade",
  id: "owner",
  role: "tabpanel",
  "aria-labelledby": "owner-tab",
  tabindex: "0"
}, JGt = { class: "card-body" }, $Gt = { class: "row" }, _Gt = { class: "col" }, eYt = { class: "col d-flex align-items-end" }, tYt = {
  class: "tab-pane fade",
  id: "property",
  role: "tabpanel",
  "aria-labelledby": "property-tab",
  tabindex: "0"
}, sYt = { class: "card-body" }, aYt = { class: "row" }, nYt = { class: "col-md-3" }, rYt = { class: "col-md-2" }, oYt = { class: "col-md-1" }, iYt = { class: "col-md-1" }, lYt = { class: "col d-flex align-items-end" }, dYt = {
  class: "tab-pane fade",
  id: "mailing",
  role: "tabpanel",
  "aria-labelledby": "mailing-tab",
  tabindex: "0"
}, cYt = { class: "card-body" }, uYt = { class: "row" }, pYt = { class: "col-md-3" }, hYt = { class: "col-md-2" }, mYt = { class: "col-md-1" }, fYt = { class: "col-md-1" }, gYt = { class: "col d-flex align-items-end" };
function vYt(e, t, s, n, r, i) {
  var l, d, c, u, m, f;
  const o = pe("AutoComplete");
  return p(), h("div", lWt, [
    a("ul", dWt, [
      a("li", cWt, [
        a("button", {
          id: "zip-tab",
          "data-bs-toggle": "tab",
          "data-bs-target": "#zip",
          type: "button",
          role: "tab",
          "aria-controls": "zip",
          "aria-selected": "true",
          class: z(e.tabZipCodes),
          onClick: t[0] || (t[0] = (v) => e.selectTab(e.tabs.zip))
        }, "Zip Codes", 2)
      ]),
      a("li", uWt, [
        a("button", {
          id: "counties-tab",
          "data-bs-toggle": "tab",
          "data-bs-target": "#counties",
          type: "button",
          role: "tab",
          "aria-controls": "counties",
          "aria-selected": "false",
          class: z(e.tabCounties),
          onClick: t[1] || (t[1] = (v) => e.selectTab(e.tabs.counties))
        }, "County", 2)
      ]),
      (d = (l = e.access) == null ? void 0 : l.leads) != null && d.searchNames ? (p(), h("li", pWt, t[53] || (t[53] = [
        a("button", {
          class: "nav-link",
          id: "owner-tab",
          "data-bs-toggle": "tab",
          "data-bs-target": "#owner",
          type: "button",
          role: "tab",
          "aria-controls": "owner",
          "aria-selected": "false"
        }, "Owner Name", -1)
      ]))) : P("", !0),
      (u = (c = e.access) == null ? void 0 : c.leads) != null && u.searchAddresses ? (p(), h("li", hWt, t[54] || (t[54] = [
        a("button", {
          class: "nav-link",
          id: "property-tab",
          "data-bs-toggle": "tab",
          "data-bs-target": "#property",
          type: "button",
          role: "tab",
          "aria-controls": "property",
          "aria-selected": "false"
        }, "Property Address", -1)
      ]))) : P("", !0),
      (f = (m = e.access) == null ? void 0 : m.leads) != null && f.searchAddresses ? (p(), h("li", mWt, t[55] || (t[55] = [
        a("button", {
          class: "nav-link",
          id: "mailing-tab",
          "data-bs-toggle": "tab",
          "data-bs-target": "#mailing",
          type: "button",
          role: "tab",
          "aria-controls": "mailing",
          "aria-selected": "false"
        }, "Mailing Address", -1)
      ]))) : P("", !0)
    ]),
    a("div", fWt, [
      a("div", {
        class: z(["tab-pane fade", e.tabZipCodes]),
        id: "zip",
        ref: "zip",
        role: "tabpanel",
        "aria-labelledby": "zip-tab",
        tabindex: "0"
      }, [
        a("div", gWt, [
          a("div", vWt, [
            a("div", yWt, [
              a("div", bWt, [
                t[56] || (t[56] = a("label", {
                  for: "selectedState",
                  class: "form-label"
                }, "State", -1)),
                V(a("select", {
                  class: "form-select",
                  id: "selectedState",
                  "onUpdate:modelValue": t[2] || (t[2] = (v) => e.selectedState = v),
                  onOnchange: t[3] || (t[3] = (v) => e.errors = ""),
                  "aria-describedby": "selectedStateHelpBlock"
                }, [
                  (p(!0), h(A, null, D(e.states, (v) => (p(), h("option", {
                    value: v.abv,
                    key: v.abv
                  }, g(v.name), 9, AWt))), 128))
                ], 544), [
                  [We, e.selectedState]
                ]),
                t[57] || (t[57] = a("small", {
                  id: "selectedStateHelpBlock",
                  class: "form-text text-secondary text-opacity-75"
                }, " Select a state to search. ", -1))
              ])
            ]),
            a("div", wWt, [
              a("div", CWt, [
                t[58] || (t[58] = a("label", {
                  for: "zip_codes",
                  class: "form-label"
                }, "Zip Codes", -1)),
                N(o, {
                  multiple: !0,
                  class: "d-block",
                  modelValue: e.selectedZipcodes,
                  "onUpdate:modelValue": t[4] || (t[4] = (v) => e.selectedZipcodes = v),
                  suggestions: e.autocompleteZipcodes,
                  onComplete: t[5] || (t[5] = (v) => e.searchZipcodes(v)),
                  optionLabel: "name",
                  placeholder: e.zipCodesPlaceholder,
                  disabled: !e.selectedState,
                  dataKey: "name",
                  minLength: 2,
                  forceSelection: !0
                }, null, 8, ["modelValue", "suggestions", "placeholder", "disabled"]),
                t[59] || (t[59] = a("small", {
                  id: "zip_codesHelpBlock",
                  class: "form-text text-secondary text-opacity-75"
                }, " Enter up to 4 zip codes. ", -1))
              ])
            ]),
            a("div", SWt, [
              a("div", PWt, [
                t[60] || (t[60] = a("label", {
                  for: "propertyType",
                  class: "form-label"
                }, "Property Type", -1)),
                V(a("select", {
                  class: "form-select",
                  id: "propertyType",
                  "onUpdate:modelValue": t[6] || (t[6] = (v) => e.propertyType = v),
                  onOnchange: t[7] || (t[7] = (v) => e.errors = ""),
                  "aria-describedby": "propertyTypeHelpBlock",
                  disabled: e.isLoading || e.isSearching
                }, [
                  (p(!0), h(A, null, D(e.propertyTypes, (v) => (p(), h("option", {
                    value: v.id,
                    key: v.id
                  }, g(v.name), 9, EWt))), 128))
                ], 40, kWt), [
                  [We, e.propertyType]
                ]),
                t[61] || (t[61] = a("small", {
                  id: "propertyTypeHelpBlock",
                  class: "form-text text-secondary text-opacity-75"
                }, " Property type to filter by. ", -1))
              ])
            ]),
            a("div", IWt, [
              a("div", TWt, [
                a("div", OWt, [
                  t[62] || (t[62] = a("label", {
                    for: "min_homes",
                    class: "form-label"
                  }, [
                    y("Min "),
                    a("span", { class: "d-none d-md-inline-block d-lg-none" }, "Prop."),
                    a("span", { class: "d-md-none d-lg-inline-block" }, "Properties")
                  ], -1)),
                  V(a("input", {
                    type: "number",
                    class: "form-control",
                    placeholder: "Enter min homes...",
                    id: "min_homes",
                    "onUpdate:modelValue": t[8] || (t[8] = (v) => e.min_homes = v),
                    onKeydown: t[9] || (t[9] = (v) => e.min_homes_error = ""),
                    "aria-describedby": "min_homesHelpBlock"
                  }, null, 544), [
                    [_e, e.min_homes]
                  ]),
                  a("small", RWt, g(e.minHomesHelp), 1)
                ]),
                a("div", LWt, [
                  t[63] || (t[63] = a("label", {
                    for: "max_homes",
                    class: "form-label"
                  }, [
                    y("Max "),
                    a("span", { class: "d-none d-md-inline-block d-lg-none" }, "Prop."),
                    a("span", { class: "d-md-none d-lg-inline-block" }, "Properties")
                  ], -1)),
                  V(a("input", {
                    type: "number",
                    class: "form-control",
                    placeholder: "Enter max homes...",
                    id: "max_homes",
                    "onUpdate:modelValue": t[10] || (t[10] = (v) => e.max_homes = v)
                  }, null, 512), [
                    [_e, e.max_homes]
                  ])
                ])
              ])
            ])
          ])
        ]),
        a("div", BWt, [
          a("div", MWt, [
            a("div", xWt, [
              a("div", FWt, [
                a("button", {
                  type: "button",
                  class: "btn btn-outline-secondary dropdown-toggle no-anim",
                  "data-bs-toggle": "dropdown",
                  "aria-expanded": "false",
                  "data-bs-auto-close": "outside",
                  disabled: e.isLoading || e.isSearching
                }, " Exclude ", 8, VWt),
                a("div", DWt, [
                  a("div", NWt, [
                    V(a("input", {
                      type: "checkbox",
                      class: "form-check-input",
                      "onUpdate:modelValue": t[11] || (t[11] = (v) => e.excludeInStateOwner = v),
                      id: "chkInOwnerState",
                      disabled: e.isLoading || e.isSearching
                    }, null, 8, jWt), [
                      [Ue, e.excludeInStateOwner]
                    ]),
                    t[64] || (t[64] = a("div", { class: "d-inline-flex align-items-center" }, [
                      a("label", {
                        class: "form-check-label ms-1 ms-lg-2",
                        for: "chkInOwnerState"
                      }, "Exclude in-state owners"),
                      a("span", {
                        class: "ms-2",
                        "data-bs-toggle": "tooltip",
                        "data-bs-placement": "top",
                        "data-bs-title": "Enabling this filter will exclude owners with a mailing address in the state you have chosen as your state Company Territory settings"
                      }, [
                        a("i", { class: "fa-light fa-info-circle" })
                      ])
                    ], -1))
                  ]),
                  a("div", HWt, [
                    V(a("input", {
                      type: "checkbox",
                      class: "form-check-input",
                      "onUpdate:modelValue": t[12] || (t[12] = (v) => e.excludePoBoxMailingAddresses = v),
                      id: "chkExcludePoBoxMailingAddresses",
                      disabled: e.isLoading || e.isSearching
                    }, null, 8, UWt), [
                      [Ue, e.excludePoBoxMailingAddresses]
                    ]),
                    t[65] || (t[65] = a("div", { class: "d-inline-flex align-items-center" }, [
                      a("label", {
                        class: "form-check-label ms-1 ms-lg-2",
                        for: "chkExcludePoBoxMailingAddresses"
                      }, "Exclude PO Box mailing addresses"),
                      a("span", {
                        class: "ms-2",
                        "data-bs-toggle": "tooltip",
                        "data-bs-placement": "top",
                        "data-bs-title": "Enabling this filter will exclude PO Box mailing addresses"
                      }, [
                        a("i", { class: "fa-light fa-info-circle" })
                      ])
                    ], -1))
                  ]),
                  a("div", zWt, [
                    V(a("input", {
                      type: "checkbox",
                      class: "form-check-input",
                      "onUpdate:modelValue": t[13] || (t[13] = (v) => e.excludeCompanies = v),
                      id: "chkExcludeTargetsWithoutPersonalNames",
                      disabled: e.isLoading || e.isSearching
                    }, null, 8, WWt), [
                      [Ue, e.excludeCompanies]
                    ]),
                    t[66] || (t[66] = a("div", { class: "d-inline-flex align-items-center" }, [
                      a("label", {
                        class: "form-check-label ms-1 ms-lg-2",
                        for: "chkExcludeTargetsWithoutPersonalNames"
                      }, "Exclude Targets Without Personal Names")
                    ], -1))
                  ])
                ])
              ]),
              a("div", GWt, [
                a("button", {
                  type: "button",
                  class: "btn btn-outline-secondary dropdown-toggle no-anim",
                  "data-bs-toggle": "dropdown",
                  "aria-expanded": "false",
                  "data-bs-auto-close": "outside",
                  disabled: e.isLoading || e.isSearching
                }, " Show ", 8, YWt),
                a("div", XWt, [
                  a("div", qWt, [
                    V(a("input", {
                      type: "checkbox",
                      class: "form-check-input",
                      "onUpdate:modelValue": t[14] || (t[14] = (v) => e.include_crm = v),
                      id: "chkInCRM",
                      disabled: e.isLoading || e.isSearching
                    }, null, 8, QWt), [
                      [Ue, e.include_crm]
                    ]),
                    t[67] || (t[67] = a("label", {
                      class: "form-check-label ms-1 ms-lg-2",
                      for: "chkInCRM"
                    }, "Show leads already in CRM", -1))
                  ]),
                  a("div", KWt, [
                    V(a("input", {
                      type: "checkbox",
                      class: "form-check-input",
                      "onUpdate:modelValue": t[15] || (t[15] = (v) => e.includeFavorited = v),
                      id: "chkInFavorite",
                      disabled: e.isLoading || e.isSearching
                    }, null, 8, ZWt), [
                      [Ue, e.includeFavorited]
                    ]),
                    t[68] || (t[68] = a("label", {
                      class: "form-check-label",
                      for: "chkInFavorite"
                    }, "Show favorited targets", -1))
                  ])
                ])
              ])
            ]),
            a("div", JWt, [
              e.isSearching ? (p(), h("span", $Wt, t[69] || (t[69] = [
                a("b", null, "Searching...", -1)
              ]))) : e.filteredRecords > 0 ? (p(), h("span", _Wt, [
                t[71] || (t[71] = y(" Found ")),
                a("b", null, g(e.number(e.filteredRecords)), 1),
                t[72] || (t[72] = y(" targets ")),
                e.filteredRecords < e.totalRecords ? (p(), h(A, { key: 0 }, [
                  t[70] || (t[70] = y(" out of ")),
                  a("b", null, g(e.number(e.totalRecords)), 1)
                ], 64)) : P("", !0)
              ])) : P("", !0)
            ]),
            a("div", eGt, [
              a("button", {
                type: "button",
                class: z(["btn btn-lava", { "is-loading": e.isSearching }]),
                onClick: t[16] || (t[16] = (v) => e.search("zip")),
                disabled: !e.canSearchZip
              }, t[73] || (t[73] = [
                y("Search"),
                a("span", { class: "d-none d-md-inline" }, "Leads", -1)
              ]), 10, tGt)
            ])
          ])
        ]),
        a("span", {
          class: "help is-danger",
          textContent: g(e.errors)
        }, null, 8, sGt)
      ], 2),
      a("div", {
        class: z(["tab-pane fade", e.tabCounties]),
        id: "counties",
        ref: "counties",
        role: "tabpanel",
        "aria-labelledby": "counties-tab",
        tabindex: "0"
      }, [
        a("div", aGt, [
          a("div", nGt, [
            a("div", rGt, [
              a("div", oGt, [
                t[74] || (t[74] = a("label", {
                  for: "selectedState",
                  class: "form-label"
                }, "State", -1)),
                V(a("select", {
                  class: "form-select",
                  id: "selectedState",
                  "onUpdate:modelValue": t[17] || (t[17] = (v) => e.selectedState = v),
                  onOnchange: t[18] || (t[18] = (v) => e.errors = ""),
                  "aria-describedby": "selectedStateHelpBlock",
                  disabled: e.isLoading || e.isSearching
                }, [
                  (p(!0), h(A, null, D(e.states, (v) => (p(), h("option", {
                    value: v.abv,
                    key: v.abv
                  }, g(v.name), 9, lGt))), 128))
                ], 40, iGt), [
                  [We, e.selectedState]
                ]),
                t[75] || (t[75] = a("small", {
                  id: "selectedStateHelpBlock",
                  class: "form-text text-secondary text-opacity-75"
                }, " Select a state to search. ", -1))
              ])
            ]),
            a("div", dGt, [
              a("div", cGt, [
                t[76] || (t[76] = a("label", {
                  for: "selectedCounty",
                  class: "form-label"
                }, "County", -1)),
                V(a("select", {
                  class: "form-select",
                  id: "selectedCounty",
                  "onUpdate:modelValue": t[19] || (t[19] = (v) => e.selectedCounty = v),
                  onOnchange: t[20] || (t[20] = (v) => e.errors = ""),
                  "aria-describedby": "countyHelpBlock",
                  disabled: e.isLoading || e.isSearching || !e.selectedState
                }, [
                  (p(!0), h(A, null, D(e.counties, (v) => (p(), h("option", {
                    value: v.county,
                    key: v.key
                  }, g(v.county), 9, pGt))), 128))
                ], 40, uGt), [
                  [We, e.selectedCounty]
                ]),
                a("small", hGt, g(e.countyPlaceholder), 1)
              ])
            ]),
            a("div", mGt, [
              a("div", fGt, [
                t[77] || (t[77] = a("label", {
                  for: "propertyType",
                  class: "form-label"
                }, "Property Type", -1)),
                V(a("select", {
                  class: "form-select",
                  id: "propertyType",
                  "onUpdate:modelValue": t[21] || (t[21] = (v) => e.propertyType = v),
                  onOnchange: t[22] || (t[22] = (v) => e.errors = ""),
                  "aria-describedby": "propertyTypeHelpBlock",
                  disabled: e.isLoading || e.isSearching
                }, [
                  (p(!0), h(A, null, D(e.propertyTypes, (v) => (p(), h("option", {
                    value: v.id,
                    key: v.id
                  }, g(v.name), 9, vGt))), 128))
                ], 40, gGt), [
                  [We, e.propertyType]
                ]),
                t[78] || (t[78] = a("small", {
                  id: "propertyTypeHelpBlock",
                  class: "form-text text-secondary text-opacity-75"
                }, " Property type to filter by. ", -1))
              ])
            ]),
            a("div", yGt, [
              a("div", bGt, [
                a("div", AGt, [
                  t[79] || (t[79] = a("label", {
                    for: "min_homes",
                    class: "form-label"
                  }, [
                    y("Min "),
                    a("span", { class: "d-none d-md-inline-block d-xl-none" }, "Prop."),
                    a("span", { class: "d-md-none d-xl-inline-block" }, "Properties")
                  ], -1)),
                  V(a("input", {
                    type: "number",
                    class: "form-control",
                    placeholder: "Enter min homes...",
                    id: "min_homes",
                    "onUpdate:modelValue": t[23] || (t[23] = (v) => e.min_homes = v),
                    onKeydown: t[24] || (t[24] = (v) => e.min_homes_error = ""),
                    "aria-describedby": "min_homesHelpBlock",
                    disabled: e.isLoading || e.isSearching
                  }, null, 40, wGt), [
                    [_e, e.min_homes]
                  ]),
                  a("small", CGt, g(e.minHomesHelp), 1)
                ]),
                a("div", SGt, [
                  t[80] || (t[80] = a("label", {
                    for: "max_homes",
                    class: "form-label"
                  }, [
                    y("Max "),
                    a("span", { class: "d-none d-md-inline-block d-xl-none" }, "Prop."),
                    a("span", { class: "d-md-none d-xl-inline-block" }, "Properties")
                  ], -1)),
                  V(a("input", {
                    type: "number",
                    class: "form-control",
                    placeholder: "Enter max homes...",
                    id: "max_homes",
                    "onUpdate:modelValue": t[25] || (t[25] = (v) => e.max_homes = v),
                    disabled: e.isLoading || e.isSearching
                  }, null, 8, PGt), [
                    [_e, e.max_homes]
                  ])
                ])
              ])
            ])
          ])
        ]),
        a("div", kGt, [
          a("div", EGt, [
            a("div", IGt, [
              a("div", TGt, [
                a("button", {
                  type: "button",
                  class: "btn btn-outline-secondary dropdown-toggle no-anim",
                  "data-bs-toggle": "dropdown",
                  "aria-expanded": "false",
                  "data-bs-auto-close": "outside",
                  disabled: e.isLoading || e.isSearching
                }, " Exclude ", 8, OGt),
                a("div", RGt, [
                  a("div", LGt, [
                    V(a("input", {
                      type: "checkbox",
                      class: "form-check-input",
                      "onUpdate:modelValue": t[26] || (t[26] = (v) => e.excludeInStateOwner = v),
                      id: "chkInOwnerState",
                      disabled: e.isLoading || e.isSearching
                    }, null, 8, BGt), [
                      [Ue, e.excludeInStateOwner]
                    ]),
                    t[81] || (t[81] = a("div", { class: "d-flex align-items-center" }, [
                      a("label", {
                        class: "form-check-label ms-1 ms-md-0 ms-lg-2",
                        for: "chkInOwnerState"
                      }, "Exclude in-state owners "),
                      a("span", {
                        class: "ms-2",
                        "data-bs-toggle": "tooltip",
                        "data-bs-placement": "top",
                        title: "Enabling this filter will exclude owners with a mailing address in the state you have chosen as your state Company Territory settings"
                      }, [
                        a("i", { class: "fa-light fa-info-circle" })
                      ])
                    ], -1))
                  ]),
                  a("div", MGt, [
                    V(a("input", {
                      type: "checkbox",
                      class: "form-check-input",
                      "onUpdate:modelValue": t[27] || (t[27] = (v) => e.excludePoBoxMailingAddresses = v),
                      id: "chkExcludePoBoxMailingAddresses",
                      disabled: e.isLoading || e.isSearching
                    }, null, 8, xGt), [
                      [Ue, e.excludePoBoxMailingAddresses]
                    ]),
                    t[82] || (t[82] = a("div", { class: "d-inline-flex align-items-center" }, [
                      a("label", {
                        class: "form-check-label ms-1 ms-lg-2",
                        for: "chkInOwnerState"
                      }, "Exclude PO Box mailing addresses"),
                      a("span", {
                        class: "ms-2",
                        "data-bs-toggle": "tooltip",
                        "data-bs-placement": "top",
                        "data-bs-title": "Enabling this filter will exclude PO Box mailing addresses"
                      }, [
                        a("i", { class: "fa-light fa-info-circle" })
                      ])
                    ], -1))
                  ]),
                  a("div", FGt, [
                    V(a("input", {
                      type: "checkbox",
                      class: "form-check-input",
                      "onUpdate:modelValue": t[28] || (t[28] = (v) => e.excludeCompanies = v),
                      id: "chkExcludeTargetsWithoutPersonalNames",
                      disabled: e.isLoading || e.isSearching
                    }, null, 8, VGt), [
                      [Ue, e.excludeCompanies]
                    ]),
                    t[83] || (t[83] = a("div", { class: "d-inline-flex align-items-center" }, [
                      a("label", {
                        class: "form-check-label ms-1 ms-lg-2",
                        for: "chkExcludeTargetsWithoutPersonalNames"
                      }, "Exclude Targets Without Personal Names")
                    ], -1))
                  ])
                ])
              ]),
              a("div", DGt, [
                a("button", {
                  type: "button",
                  class: "btn btn-outline-secondary dropdown-toggle no-anim",
                  "data-bs-toggle": "dropdown",
                  "aria-expanded": "false",
                  "data-bs-auto-close": "outside",
                  disabled: e.isLoading || e.isSearching
                }, " Show ", 8, NGt),
                a("div", jGt, [
                  a("div", HGt, [
                    V(a("input", {
                      type: "checkbox",
                      class: "form-check-input",
                      "onUpdate:modelValue": t[29] || (t[29] = (v) => e.include_crm = v),
                      id: "chkInCRM",
                      disabled: e.isLoading || e.isSearching
                    }, null, 8, UGt), [
                      [Ue, e.include_crm]
                    ]),
                    t[84] || (t[84] = a("label", {
                      class: "form-check-label ms-1 ms-md-0 ms-lg-2",
                      for: "chkInCRM"
                    }, "Show targets already in CRM", -1))
                  ]),
                  a("div", zGt, [
                    V(a("input", {
                      type: "checkbox",
                      class: "form-check-input",
                      "onUpdate:modelValue": t[30] || (t[30] = (v) => e.includeFavorited = v),
                      id: "chkInFavorite",
                      disabled: e.isLoading || e.isSearching
                    }, null, 8, WGt), [
                      [Ue, e.includeFavorited]
                    ]),
                    t[85] || (t[85] = a("label", {
                      class: "form-check-label",
                      for: "chkInFavorite"
                    }, "Show favorited targets", -1))
                  ])
                ])
              ])
            ]),
            a("div", GGt, [
              e.isSearching ? (p(), h("span", YGt, t[86] || (t[86] = [
                a("b", null, "Searching...", -1)
              ]))) : e.filteredRecords > 0 ? (p(), h("span", XGt, [
                t[88] || (t[88] = y(" Found ")),
                a("b", null, g(e.number(e.filteredRecords)), 1),
                t[89] || (t[89] = y(" targets ")),
                e.filteredRecords < e.totalRecords ? (p(), h(A, { key: 0 }, [
                  t[87] || (t[87] = y(" out of ")),
                  a("b", null, g(e.number(e.totalRecords)), 1)
                ], 64)) : P("", !0)
              ])) : P("", !0)
            ]),
            a("div", qGt, [
              a("button", {
                type: "button",
                class: z(["btn btn-lava btn-block", { "is-loading": e.isSearching }]),
                onClick: t[31] || (t[31] = (v) => e.search("county")),
                disabled: !e.canSearchCounty
              }, t[90] || (t[90] = [
                y("Search"),
                a("span", { class: "d-none d-md-inline" }, " Targets", -1)
              ]), 10, QGt)
            ])
          ])
        ]),
        a("span", {
          class: "help is-danger",
          textContent: g(e.errors)
        }, null, 8, KGt)
      ], 2),
      a("div", ZGt, [
        a("div", JGt, [
          a("div", $Gt, [
            a("div", _Gt, [
              t[91] || (t[91] = a("label", {
                for: "owner_name",
                class: "form-label"
              }, "Owner Name", -1)),
              V(a("input", {
                type: "text",
                placeholder: "Enter owner name...",
                class: "form-control",
                id: "owner_name",
                "onUpdate:modelValue": t[32] || (t[32] = (v) => e.owner_name = v),
                onKeydown: t[33] || (t[33] = (v) => e.errors = "")
              }, null, 544), [
                [_e, e.owner_name]
              ])
            ]),
            a("div", eYt, [
              a("button", {
                class: z(["btn btn-lava", { "is-loading": e.isSearching }]),
                onClick: t[34] || (t[34] = (v) => e.search("names"))
              }, t[92] || (t[92] = [
                y("Search"),
                a("span", { class: "d-none d-md-inline" }, " Leads", -1)
              ]), 2)
            ])
          ])
        ])
      ]),
      a("div", tYt, [
        a("div", sYt, [
          a("div", aYt, [
            t[95] || (t[95] = a("div", { class: "col-md-12" }, [
              a("label", {
                for: "property_address",
                class: "form-label"
              }, "Property Address")
            ], -1)),
            a("div", nYt, [
              V(a("input", {
                type: "text",
                placeholder: "House # + Street Name",
                class: "form-control",
                id: "property_address",
                "onUpdate:modelValue": t[35] || (t[35] = (v) => e.address = v),
                onKeydown: t[36] || (t[36] = (v) => e.errors = "")
              }, null, 544), [
                [_e, e.address]
              ])
            ]),
            a("div", rYt, [
              V(a("input", {
                type: "text",
                placeholder: "City",
                class: "form-control",
                id: "property_city",
                "onUpdate:modelValue": t[37] || (t[37] = (v) => e.city = v),
                onKeydown: t[38] || (t[38] = (v) => e.errors = "")
              }, null, 544), [
                [_e, e.city]
              ])
            ]),
            a("div", oYt, [
              V(a("select", {
                id: "property_state",
                class: "form-select",
                "onUpdate:modelValue": t[39] || (t[39] = (v) => e.state = v),
                onKeydown: t[40] || (t[40] = (v) => e.errors = "")
              }, t[93] || (t[93] = [
                a("option", null, "TX", -1)
              ]), 544), [
                [We, e.state]
              ])
            ]),
            a("div", iYt, [
              V(a("input", {
                type: "text",
                placeholder: "Zip",
                class: "form-control",
                id: "property_zip",
                "onUpdate:modelValue": t[41] || (t[41] = (v) => e.zip = v),
                onKeydown: t[42] || (t[42] = (v) => e.errors = "")
              }, null, 544), [
                [_e, e.zip]
              ])
            ]),
            a("div", lYt, [
              a("button", {
                class: z(["btn btn-lava", { "is-loading": e.isSearching }]),
                onClick: t[43] || (t[43] = (v) => e.search("address"))
              }, t[94] || (t[94] = [
                y("Search"),
                a("span", { class: "d-none d-md-inline" }, " Leads", -1)
              ]), 2)
            ])
          ])
        ])
      ]),
      a("div", dYt, [
        a("div", cYt, [
          a("div", uYt, [
            t[98] || (t[98] = a("div", { class: "col-md-12" }, [
              a("label", {
                for: "owner_mailing",
                class: "form-label"
              }, "Mailing Address")
            ], -1)),
            a("div", pYt, [
              V(a("input", {
                type: "text",
                placeholder: "House # + Street Name",
                class: "form-control",
                id: "mailing_address",
                "onUpdate:modelValue": t[44] || (t[44] = (v) => e.address = v),
                onKeydown: t[45] || (t[45] = (v) => e.errors = "")
              }, null, 544), [
                [_e, e.address]
              ])
            ]),
            a("div", hYt, [
              V(a("input", {
                type: "text",
                placeholder: "City",
                class: "form-control",
                id: "mailing_city",
                "onUpdate:modelValue": t[46] || (t[46] = (v) => e.city = v),
                onKeydown: t[47] || (t[47] = (v) => e.errors = "")
              }, null, 544), [
                [_e, e.city]
              ])
            ]),
            a("div", mYt, [
              V(a("select", {
                id: "mailing_state",
                class: "form-select",
                "onUpdate:modelValue": t[48] || (t[48] = (v) => e.state = v),
                onKeydown: t[49] || (t[49] = (v) => e.errors = "")
              }, t[96] || (t[96] = [
                a("option", null, "TX", -1)
              ]), 544), [
                [We, e.state]
              ])
            ]),
            a("div", fYt, [
              V(a("input", {
                type: "text",
                placeholder: "Zip",
                class: "form-control",
                id: "mailing_zip",
                "onUpdate:modelValue": t[50] || (t[50] = (v) => e.zip = v),
                onKeydown: t[51] || (t[51] = (v) => e.errors = "")
              }, null, 544), [
                [_e, e.zip]
              ])
            ]),
            a("div", gYt, [
              a("button", {
                class: z(["btn btn-lava", { "is-loading": e.isSearching }]),
                onClick: t[52] || (t[52] = (v) => e.search("address"))
              }, t[97] || (t[97] = [
                y("Search"),
                a("span", { class: "d-none d-md-inline" }, " Leads", -1)
              ]), 2)
            ])
          ])
        ])
      ])
    ])
  ]);
}
const yYt = /* @__PURE__ */ Ae(iWt, [["render", vYt]]), bYt = me({
  components: {
    SearchForm: yYt,
    ListLoader: uf,
    BPagination: GE,
    BTable: XE
  },
  directives: {
    Tooltip: Wo
  },
  data() {
    return {
      columns: ["aliasName", "mailAddress", "agent", "filtered", "actions"],
      owners: [],
      loading: !1,
      totalRecords: 0,
      filteredRecords: 0,
      page: 1,
      pageSize: 25,
      sortField: "filtered",
      sortOrder: 0,
      params: {
        type: pP.Zip,
        min_value: 1e5,
        max_value: 1e6,
        include_crm: !1
      }
    };
  },
  computed: {
    startRecord() {
      return this.page == 1 ? 1 : (this.page - 1) * this.pageSize + 1;
    },
    endRecord() {
      return this.page == 1 ? Math.min(this.pageSize, this.filteredRecords) : Math.min((this.page - 1) * this.pageSize + this.pageSize, this.filteredRecords);
    },
    propertyTypeSelected() {
      var e;
      if ((e = this.params) != null && e.propertyType)
        switch (this.params.propertyType) {
          case Xt.SingleFamily:
            return 1;
          case Xt.Commercial:
            return 2;
          case Xt.MobileHomeParks:
            return 3;
          case Xt.MultiFamily:
            return 4;
          case Xt.Residential24Family:
            return 5;
          case Xt.Retail:
            return 6;
          case Xt.RvParksCampground:
            return 7;
          case Xt.SelfStorage:
            return 8;
          default:
            return 1;
        }
      return 1;
    }
  },
  methods: {
    number: Ve,
    async searchLeads(e) {
      var t, s, n, r, i, o, l, d, c, u, m, f, v, b, w;
      this.loading = !0, e && (this.params = e, this.owners.length = 0, this.page = 1, this.pageSize = 25);
      try {
        const S = {
          page: this.page,
          pageSize: this.pageSize,
          sort: this.sortField,
          sortOrder: this.sortOrder,
          type: (t = this.params) == null ? void 0 : t.type,
          state: (s = this.params) == null ? void 0 : s.state_option,
          zipCodes: (r = (n = this.params) == null ? void 0 : n.zip_codes) == null ? void 0 : r.split(","),
          includeCrm: (i = this.params) == null ? void 0 : i.include_crm,
          county: (o = this.params) == null ? void 0 : o.county,
          minHomes: (l = this.params) == null ? void 0 : l.min_homes,
          maxHomes: (d = this.params) == null ? void 0 : d.max_homes,
          propertyType: (c = this.params) == null ? void 0 : c.propertyType,
          excludeInStateOwner: (u = this.params) == null ? void 0 : u.excludeInStateOwner,
          includeFavorited: (m = this.params) == null ? void 0 : m.includeFavorited,
          includePoBoxMailingAddresses: (f = this.params) == null ? void 0 : f.includePoBoxMailingAddresses,
          excludeCompanies: (v = this.params) == null ? void 0 : v.excludeCompanies
        }, I = await W.api.portfolioFinder.search(S);
        if (I.data.status != de.Success)
          throw new Le(I);
        e && (localStorage.setItem(De.StorageKeys.PortfolioFinder.LastState, e.state_option), localStorage.setItem(De.StorageKeys.PortfolioFinder.LastCounty, e.county), localStorage.setItem(De.StorageKeys.PortfolioFinder.LastPropertyType, e.propertyType), localStorage.setItem(De.StorageKeys.PortfolioFinder.LastMinProperties, (b = e.min_homes) == null ? void 0 : b.toString()), localStorage.setItem(De.StorageKeys.PortfolioFinder.LastMaxProperties, (w = e.max_homes) == null ? void 0 : w.toString())), this.owners.length = 0, this.owners.push(...I.data.results), this.filteredRecords = I.data.filtered, this.totalRecords = I.data.total;
      } catch (S) {
        console.error("searchLeads", S);
        const I = S.message;
        I.includes("No state filter applied!") ? Mi(I) : Se(I), this.owners.length = 0, this.totalRecords = 0, this.filteredRecords = 0;
      }
      this.loading = !1;
    },
    async onSort(e) {
      this.sortField = e.sortField, this.sortOrder = e.sortOrder, await this.searchLeads();
    },
    async onPage(e, t) {
      this.page = t, await this.searchLeads();
    },
    async ignoreOwner(e) {
      try {
        console.log("ignoreOwner", e);
        const t = await W.api.portfolioFinder.ignoreOwner(e.id);
        if (t.data.status != de.Success)
          throw new Le(t);
        this.owners = this.owners.filter((s) => s.id !== e.id);
      } catch (t) {
        Se(t);
      }
    },
    rowStyle(e) {
      var t, s;
      return {
        "investor-agent": ((t = e == null ? void 0 : e.agent) == null ? void 0 : t.isInvestorAgent) == !0,
        "agent-pm": ((s = e == null ? void 0 : e.agent) == null ? void 0 : s.isPropertyManager) == !0,
        "owner-fiduciary": (e == null ? void 0 : e.fiduciary) == !0
      };
    },
    generatePropertiesTooltipText(e) {
      var t;
      return ((t = this.params) == null ? void 0 : t.propertyType) == Xt.SingleFamily ? e.item.filtered + " Absentee Properties in Search Area / " + Math.max(e.item.total, e.item.filtered) + " Absentee Properties Total" : e.item.filtered + " Properties in Search Area / " + Math.max(e.item.total, e.item.filtered) + " Properties Total";
    }
  }
}), AYt = {
  key: 0,
  class: "fad fa-user-check text-success",
  title: "Lead is in CRM"
}, wYt = { class: "small m-0" }, CYt = ["title"], SYt = ["onClick"], PYt = {
  key: 0,
  class: "d-flex align-items-center justify-content-between flex-column flex-lg-row"
};
function kYt(e, t, s, n, r, i) {
  const o = pe("search-form"), l = pe("router-link"), d = pe("b-table"), c = pe("b-pagination"), u = Za("tooltip");
  return p(), h(A, null, [
    t[15] || (t[15] = a("h1", { class: "fs-3 fw-bold" }, "Search for Outbound Targets", -1)),
    t[16] || (t[16] = a("p", { class: "mb-md-4" }, "Use the fields below to identify owners of properties you are interested in working with.", -1)),
    a("div", null, [
      N(o, {
        onSearchLeads: e.searchLeads,
        isSearching: e.loading,
        "total-records": e.totalRecords,
        "filtered-records": e.filteredRecords
      }, null, 8, ["onSearchLeads", "isSearching", "total-records", "filtered-records"]),
      t[14] || (t[14] = Bt('<ul class="list-inline mb-4" data-v-673e97ac><li class="list-inline-item me-4" data-v-673e97ac><i class="fa-solid fa-square me-1 text-lava" data-v-673e97ac></i> PM Agent </li><li class="list-inline-item me-4" data-v-673e97ac><i class="fa-solid fa-square me-1 text-info" data-v-673e97ac></i> Investor Agent </li><li class="list-inline-item me-4" data-v-673e97ac><i class="fa-solid fa-square me-1 text-success" data-v-673e97ac></i> Fiduciary </li></ul>', 1)),
      N(d, {
        striped: "",
        hover: "",
        fields: e.columns,
        items: e.owners,
        busy: e.loading,
        "tbody-tr-class": e.rowStyle,
        "primary-key": "ownerId"
      }, {
        "head(aliasName)": ve(() => t[1] || (t[1] = [
          y(" Target Name ")
        ])),
        "head(mailAddress)": ve(() => t[2] || (t[2] = [
          y(" Owner Location ")
        ])),
        "head(agent)": ve(() => t[3] || (t[3] = [
          y(" Recently Used Agent ")
        ])),
        "head(filtered)": ve(() => t[4] || (t[4] = [
          y(" Properties "),
          a("i", {
            class: "fa-light fa-info-circle ms-2",
            "data-bs-toggle": "tooltip",
            "data-bs-placement": "top",
            "data-bs-title": "The fraction represents the quantity of absentee owned properties owned by this target inside the search area relative to the total quantity of absentee properties owned by this target in the US"
          }, null, -1)
        ])),
        "head(actions)": ve(() => t[5] || (t[5] = [
          y("   ")
        ])),
        "cell(aliasName)": ve((m) => [
          N(l, {
            to: { path: "/portfolio-finder/" + m.item.id, query: { pt: e.propertyTypeSelected } },
            target: "_blank"
          }, {
            default: ve(() => [
              m.item.aliasName ? (p(), h(A, { key: 0 }, [
                y(g(m.item.aliasName), 1)
              ], 64)) : (p(), h(A, { key: 1 }, [
                y(g(m.item.owner1.firstName) + " " + g(m.item.owner1.lastName), 1)
              ], 64)),
              t[6] || (t[6] = a("i", { class: "fa-light fa-arrow-up-right-from-square ms-2" }, null, -1))
            ]),
            _: 2,
            __: [6]
          }, 1032, ["to"]),
          m.item.inCrm ? (p(), h("i", AYt)) : P("", !0)
        ]),
        "cell(mailAddress)": ve((m) => [
          a("address", wYt, g(m.item.mailAddress.city) + ", " + g(m.item.mailAddress.state), 1)
        ]),
        "cell(agent)": ve((m) => {
          var f, v;
          return [
            y(g((f = m.item.agent) == null ? void 0 : f.firstName) + " " + g((v = m.item.agent) == null ? void 0 : v.lastName), 1)
          ];
        }),
        "cell(filtered)": ve((m) => [
          a("b", null, g(e.number(m.item.filtered)), 1),
          a("sup", null, "/" + g(e.number(Math.max(m.item.total, m.item.filtered))), 1),
          a("i", {
            class: "fa-light fa-info-circle ms-2",
            "data-bs-toggle": "tooltip",
            "data-bs-placement": "top",
            title: e.generatePropertiesTooltipText(m)
          }, null, 8, CYt)
        ]),
        "cell(actions)": ve((m) => [
          V((p(), h("a", {
            onClick: (f) => e.ignoreOwner(m.item),
            role: "button",
            class: "btn btn-outline-secondary btn-sm"
          }, t[7] || (t[7] = [
            a("i", { class: "fa-duotone fa-solid fa-eye-slash" }, null, -1)
          ]), 8, SYt)), [
            [
              u,
              "Ignore",
              void 0,
              { top: !0 }
            ]
          ])
        ]),
        _: 1
      }, 8, ["fields", "items", "busy", "tbody-tr-class"]),
      e.filteredRecords > 0 ? (p(), h("div", PYt, [
        a("div", null, [
          t[10] || (t[10] = y(" Showing ")),
          a("strong", null, g(e.number(e.startRecord)), 1),
          t[11] || (t[11] = y(" to ")),
          a("strong", null, g(e.number(e.endRecord)), 1),
          t[12] || (t[12] = y(" of ")),
          a("strong", null, g(e.number(e.filteredRecords)), 1),
          t[13] || (t[13] = y(" entries ")),
          e.totalRecords > e.filteredRecords ? (p(), h(A, { key: 0 }, [
            t[8] || (t[8] = y(" (filtered from ")),
            a("strong", null, g(e.number(e.totalRecords)), 1),
            t[9] || (t[9] = y(" total entries) "))
          ], 64)) : P("", !0)
        ]),
        a("div", null, [
          e.filteredRecords > e.pageSize ? (p(), Fe(c, {
            key: 0,
            onPageClick: e.onPage,
            modelValue: e.page,
            "onUpdate:modelValue": t[0] || (t[0] = (m) => e.page = m),
            "total-rows": e.filteredRecords,
            "per-page": e.pageSize,
            "first-number": "",
            "last-number": "",
            align: "end",
            disabled: e.loading
          }, null, 8, ["onPageClick", "modelValue", "total-rows", "per-page", "disabled"])) : P("", !0)
        ])
      ])) : P("", !0)
    ])
  ], 64);
}
const mds = /* @__PURE__ */ Ae(bYt, [["render", kYt], ["__scopeId", "data-v-673e97ac"]]), EYt = me({
  props: {
    item: Object,
    index: Number,
    last: String
  },
  components: {
    ContentLoader: Sa
  },
  data() {
    return {
      cur: null,
      last_type: 0
    };
  },
  computed: {
    isNewType() {
      return this.cur == null && (this.cur = this.last_type), parseInt(this.item.PropertyUseStandardized) != this.cur;
    }
  },
  created() {
    this.last_type = parseInt(this.last);
  },
  mounted() {
    this.$emit("is-new-type", this.item);
  },
  methods: {}
}), IYt = {
  key: 0,
  class: "col-md-12 mt-md-5"
}, TYt = { class: "fs-4 fw-bold pt-md-5 pb-md-3" };
function OYt(e, t, s, n, r, i) {
  return e.isNewType ? (p(), h("div", IYt, [
    a("h2", TYt, g(e.item.PropertyUseStandardized), 1)
  ])) : P("", !0);
}
const fds = /* @__PURE__ */ Ae(EYt, [["render", OYt]]), RYt = me({
  components: {
    DataTable: yn,
    Column: bn
  },
  data() {
    return {
      agents: [],
      loading: !0,
      totalRecords: 0
    };
  },
  created() {
  },
  mounted() {
    this.loadLazyData();
  },
  methods: {
    number: Ve,
    async loadLazyData(e = 1, t = 25) {
      this.loading = !0;
      try {
        const s = await W.api.portfolioFinder.getPropertyManagers();
        if (s.data.status != de.Success)
          throw new Le(s);
        this.agents.length = 0, this.agents.push(...s.data.results), this.totalRecords = this.agents.length;
      } catch (s) {
        Se(s);
      }
      this.loading = !1;
    },
    async onPage(e) {
      await this.loadLazyData(e.page + 1, e.rows);
    }
  }
}), LYt = { class: "card shadow-sm" };
function BYt(e, t, s, n, r, i) {
  const o = pe("Column"), l = pe("data-table");
  return p(), h("div", LYt, [
    N(l, {
      value: e.agents,
      lazy: !0,
      paginator: !0,
      class: "p-datatable-agents",
      rows: 25,
      dataKey: "ownerId",
      totalRecords: e.totalRecords,
      loading: e.loading,
      paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
      rowsPerPageOptions: [10, 25, 50],
      currentPageReportTemplate: "Showing {first} to {last} of {totalRecords} entries",
      onPage: t[0] || (t[0] = (d) => e.onPage(d)),
      onSort: t[1] || (t[1] = (d) => e.onSort(d))
    }, {
      empty: ve(() => t[2] || (t[2] = [
        y(" No agents found marked as PM Agents. ")
      ])),
      loading: ve(() => t[3] || (t[3] = [
        a("div", { class: "bg-accentgreenblue rounded-pill px-3 py-1 text-white" }, [
          a("span", {
            class: "spinner-border spinner-border-sm me-2",
            role: "status",
            "aria-hidden": "false"
          }),
          y("Loading your marked PM Agents. Please wait... ")
        ], -1)
      ])),
      default: ve(() => [
        N(o, {
          field: "firstname",
          header: "Name"
        }, {
          body: ve((d) => [
            y(g(d.data.firstName) + " " + g(d.data.lastName), 1)
          ]),
          _: 1
        }),
        N(o, {
          field: "mls",
          header: "MLS"
        }),
        N(o, {
          field: "broker",
          header: "Broker"
        }),
        N(o, {
          field: "office",
          header: "Office #"
        }),
        N(o, {
          field: "cell",
          header: "Cell #"
        }),
        N(o, {
          field: "total",
          header: "Listings"
        }, {
          body: ve((d) => [
            y(g(e.number(d.data.total)), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["value", "totalRecords", "loading"])
  ]);
}
const gds = /* @__PURE__ */ Ae(RYt, [["render", BYt], ["__scopeId", "data-v-4a199d83"]]), MYt = me({
  emits: ["viewData", "viewAnalysis", "propSelected"],
  props: {
    item: {
      type: Object,
      required: !0
    },
    index: Number,
    googleApi: String
  },
  components: {
    ContentLoader: Sa
  },
  computed: {
    streetView() {
      return "https://maps.googleapis.com/maps/api/streetview?return_error_code=true&size=400x248&location=" + encodeURIComponent(this.item.propertyAddressFull) + "," + encodeURIComponent(this.item.propertyAddressCity) + "," + encodeURIComponent(this.item.propertyAddressState) + " " + encodeURIComponent(this.item.propertyAddressZip) + "&fov=80&key=" + this.googleApi;
    },
    ownerAddress() {
      var e, t;
      return (t = (e = this.owner) == null ? void 0 : e.address) == null ? void 0 : t.toUpperCase();
    },
    photoStyle() {
      return {
        "background-image": this.item.photo ? `url(${this.item.photo})` : `url('${this.streetView}')`
      };
    },
    cardStyle() {
      return {
        //    occupied: this.item.ownerOccupied
      };
    },
    propTypeStyle() {
      var e;
      return (e = this.item.propertyGroupType) == null ? void 0 : e.toString();
    },
    daysToYearsMonths() {
      if (this.item.lenghtOfOwnershipDays == null)
        return "N/A";
      var e = Math.floor(this.item.lenghtOfOwnershipDays / 365), t = Math.floor(this.item.lenghtOfOwnershipDays % 365 / 30);
      return e == 1 && t == 1 ? e + " year, " + t + " month" : e > 1 && t == 1 ? e + " years, " + t + " month" : e == 1 && t > 1 ? e + " year, " + t + " months" : e > 1 && t == 0 ? e + " years" : e == 1 && t == 0 ? e + " year" : e == 0 && t == 1 ? t + " month" : e > 1 && t > 1 ? e + " years, " + t + " months" : t + " months";
    },
    bedroomsCount() {
      var e;
      return this.item.bedroomsCount == 0 ? "N/A" : (e = this.item.bedroomsCount) == null ? void 0 : e.toString();
    },
    bathCount() {
      var e;
      return this.item.bathCount == 0 ? "N/A" : ((e = this.item.bathCount) == null ? void 0 : e.toString()) + "." + this.item.bathPartialCount;
    },
    units() {
      var e;
      return this.item.units == 0 ? "N/A" : (e = this.item.units) == null ? void 0 : e.toString();
    },
    ...at(Ba),
    ...q(Ba, ["owner"])
  },
  methods: {
    shortDate: cs,
    number: Ve,
    currency(e, t = "N/A") {
      return isNaN(e) ? t : Ze(e);
    },
    viewAnalysis() {
      console.log("Property.viewAnalysis", this.item.id), this.$emit("viewAnalysis", this.item.id);
    },
    viewData() {
      console.log("Property.viewData", this.item.id), this.$emit("viewData", this.item.id);
    },
    propSelected(e) {
      console.log("Property.propSelected", this.item.id, e.target.checked), this.$emit("propSelected", {
        id: this.item.id,
        checked: e.target.checked
      });
    },
    listedWhen(e) {
      return this.shortDate(e.split("|")[0]);
    },
    listedAmount(e) {
      return Ze(e.split("|")[1]);
    },
    listedAgent(e) {
      return e.split("|")[2] + " " + e.split("|")[3];
    }
  },
  mounted() {
    document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach((e) => new bootstrap.Tooltip(e));
  },
  data() {
    return {};
  }
}), xYt = { class: "col" }, FYt = { class: "img-card-top" }, VYt = {
  key: 0,
  class: "badge text-bg-lava position-absolute top-10 start-10"
}, DYt = { class: "racetrack" }, NYt = { class: "checkbox" }, jYt = {
  class: "fw-bold",
  style: { "font-size": ".85rem" }
}, HYt = { class: "text-center fw-bold border-bottom p-2" }, UYt = { class: "p-2 text-center" }, zYt = { class: "card-text" }, WYt = { class: "fw-bold text-xsmall text-uppercase text-secondary" }, GYt = { class: "row card-features mt-auto" }, YYt = { class: "col text-center" }, XYt = { class: "list-inline m-0 p-2 border-top" }, qYt = { class: "list-inline-item" }, QYt = { class: "list-inline-item" }, KYt = { class: "list-inline-item" }, ZYt = {
  key: 1,
  class: "list-inline-item",
  "data-bs-toggle": "tooltip",
  "data-bs-title": "Quantity of Units"
}, JYt = { class: "list-inline-item" }, $Yt = { class: "col-12 text-center" }, _Yt = { class: "list-inline m-0 p-2" }, eXt = {
  class: "list-inline-item",
  "data-bs-toggle": "tooltip",
  "data-bs-title": "Length of Ownership"
}, tXt = { class: "row border-top text-center" }, sXt = { class: "col" }, aXt = { class: "p-2" };
function nXt(e, t, s, n, r, i) {
  return p(), h("div", xYt, [
    a("div", {
      class: z(["card card-property shadow-sm h-100", e.cardStyle])
    }, [
      a("div", FYt, [
        e.ownerAddress == e.item.propertyAddressFull ? (p(), h("span", VYt, "Mailing Address")) : P("", !0),
        a("div", DYt, [
          a("label", NYt, [
            V(a("input", {
              type: "checkbox",
              "onUpdate:modelValue": t[0] || (t[0] = (o) => e.item.selected = o),
              onClick: t[1] || (t[1] = (o) => e.propSelected(o))
            }, null, 512), [
              [Ue, e.item.selected]
            ])
          ])
        ]),
        a("div", {
          class: "img-card-top-photo",
          style: rn(e.photoStyle)
        }, null, 4)
      ]),
      a("div", {
        class: z(["card-type py-md-1 p-2", e.propTypeStyle])
      }, [
        a("span", jYt, g(e.item.propertyUse), 1)
      ], 2),
      a("span", HYt, [
        t[4] || (t[4] = a("i", { class: "fa-light fa-user me-2" }, null, -1)),
        y(g(e.item.owner1FirstName) + " " + g(e.item.owner1LastName), 1)
      ]),
      a("div", UYt, [
        a("address", zYt, [
          a("b", null, [
            y(g(e.item.propertyAddressFull), 1),
            t[5] || (t[5] = a("br", null, null, -1)),
            y(" " + g(e.item.propertyAddressCity) + ", " + g(e.item.propertyAddressState) + " " + g(e.item.propertyAddressZip), 1)
          ]),
          t[6] || (t[6] = a("br", null, null, -1)),
          a("span", WYt, g(e.item.situsCounty) + " County", 1)
        ]),
        a("button", {
          class: "btn btn-sm btn-eclipse",
          onClick: t[2] || (t[2] = (...o) => e.viewAnalysis && e.viewAnalysis(...o)),
          tabindex: "-1",
          "aria-disabled": "true"
        }, "Property Analysis"),
        a("button", {
          class: "btn btn-sm btn-eclipse ms-2",
          onClick: t[3] || (t[3] = (...o) => e.viewData && e.viewData(...o)),
          tabindex: "-1",
          "aria-disabled": "true"
        }, "View Data")
      ]),
      a("div", GYt, [
        a("div", YYt, [
          a("ul", XYt, [
            a("li", qYt, [
              t[7] || (t[7] = a("i", { class: "fa-light fa-home me-1" }, null, -1)),
              y(g(e.number(e.item.areaBuilding)) + " SF ", 1)
            ]),
            e.item.propertyGroupType != "multiFamily" ? (p(), h(A, { key: 0 }, [
              a("li", QYt, [
                t[8] || (t[8] = a("i", { class: "fa-light fa-bed me-1" }, null, -1)),
                y(g(e.bedroomsCount), 1)
              ]),
              a("li", KYt, [
                t[9] || (t[9] = a("i", { class: "fa-light fa-bath me-1" }, null, -1)),
                y(g(e.bathCount), 1)
              ])
            ], 64)) : e.item.propertyGroupType == "multiFamily" ? (p(), h("li", ZYt, [
              t[10] || (t[10] = a("i", { class: "fa-light fa-buildings me-1" }, null, -1)),
              y(" " + g(e.units), 1)
            ])) : P("", !0),
            a("li", JYt, [
              t[11] || (t[11] = a("i", { class: "fa-light fa-birthday-cake me-1" }, null, -1)),
              y(g(e.item.yearBuilt), 1)
            ])
          ])
        ]),
        a("div", $Yt, [
          a("ul", _Yt, [
            a("li", eXt, [
              t[12] || (t[12] = a("i", { class: "fa-light fa-file-certificate me-1" }, null, -1)),
              y(" " + g(e.daysToYearsMonths), 1)
            ])
          ])
        ])
      ]),
      a("div", tXt, [
        a("div", sXt, [
          a("div", aXt, [
            t[13] || (t[13] = y(" Predicted Value: ")),
            a("b", null, g(e.currency(e.item.soldPrediction)), 1)
          ])
        ])
      ])
    ], 2)
  ]);
}
const rXt = /* @__PURE__ */ Ae(MYt, [["render", nXt]]), oXt = me({
  name: "OwnersAgents",
  props: {
    crmProvider: String
  },
  components: {
    ListLoader: uf
  },
  watch: {
    "owner.id"(e) {
      try {
        e && this.portfolioFinderStore.loadNextAgents();
      } catch (t) {
        Se(t);
      }
    }
  },
  computed: {
    ...at(Ba),
    ...q(Ba, ["agents", "loadingAgents", "agentsGroups", "isLoading", "owner", "agentHasMore"]),
    ...q(Te, ["access", "aclLoaded"])
  },
  methods: {
    longDate: cs,
    currency: Ze,
    number: Ve,
    async loadNextAgents() {
      try {
        this.portfolioFinderStore.loadNextAgents();
      } catch (e) {
        Se(e);
      }
    },
    genId(e, t) {
      return `${e}${t}`;
    },
    async setPMAgent(e, t) {
      try {
        const s = await W.api.portfolioFinder.setAgent(e.mlsSource, e.agentId, t.target.checked);
        if (s.data.status != de.Success)
          throw new Le(s);
      } catch (s) {
        Se("Set PM Agent Error " + s.message);
      }
    },
    async setInvAgent(e, t) {
      try {
        const s = await W.api.portfolioFinder.setAgent(e.mlsSource, e.agentId, void 0, t.target.checked);
        if (s.data.status != de.Success)
          throw new Le(s);
      } catch (s) {
        Se("Set Investor Agent Error " + s.message);
      }
    },
    async addCrmAgent(e, t) {
      try {
        switch (this.crmProvider) {
          case "active-campaign":
            this.isLoading = !0;
            const s = await W.api.crm.createAgentLead(bt.ActiveCampaign, e.mlsSource, e.agentId);
            if (s.data.status != de.Success)
              throw new Le(s);
            break;
          case "zoho":
            this.isLoading = !0;
            const n = await W.api.crm.createAgentLead(bt.Zoho, e.mlsSource, e.agentId);
            if (n.data.status != de.Success)
              throw new Le(n);
            break;
          case "lead-simple":
            this.isLoading = !0;
            const r = await W.api.crm.createAgentLead(bt.LeadSimple, e.mlsSource, e.agentId);
            if (r.data.status != de.Success)
              throw new Le(r);
            break;
          default:
            return;
        }
        wt("Agent created in CRM.");
      } catch (s) {
        Se("Add CRM Agent Error " + s.message);
      } finally {
        this.isLoading = !1;
      }
    }
  }
}), iXt = {
  key: 1,
  class: "card shadow-sm h-100 my-4 my-md-0"
}, lXt = { class: "table table-sm m-0" }, dXt = { class: "text-center" }, cXt = { colspan: "5" }, uXt = { class: "d-flex flex-column flex-md-row" }, pXt = { class: "row flex-grow-1 mb-2 mb-md-0 align-items-center d-flex" }, hXt = { class: "col-auto" }, mXt = ["href", "aria-controls"], fXt = ["title"], gXt = ["title"], vXt = {
  key: 1,
  class: "col"
}, yXt = {
  key: 2,
  class: "col"
}, bXt = { class: "d-flex justify-content-between justify-content-md-center align-items-center flex-shrink-0 ps-2" }, AXt = {
  key: 0,
  class: "form-check form-switch"
}, wXt = ["onClick", "onUpdate:modelValue", "id"], CXt = ["for"], SXt = {
  key: 1,
  class: "form-check form-switch ms-md-3"
}, PXt = ["onClick", "onUpdate:modelValue", "id"], kXt = ["for"], EXt = ["onClick", "disabled"], IXt = ["id"], TXt = ["href"], OXt = {
  key: 0,
  src: bI,
  height: "24"
}, RXt = {
  key: 1,
  src: AI,
  height: "24"
}, LXt = {
  key: 2,
  src: wI,
  height: "24"
}, BXt = { key: 1 }, MXt = { key: 2 }, xXt = {
  class: "text-center py-5",
  colspan: "6"
};
function FXt(e, t, s, n, r, i) {
  const o = pe("list-loader");
  return e.agentsGroups.length == 0 && e.loadingAgents ? (p(), Fe(o, {
    key: 0,
    speed: 2,
    height: 100
  })) : (p(), h("div", iXt, [
    t[9] || (t[9] = a("div", { class: "p-2 fw-bold" }, [
      a("i", { class: "fa-duotone fa-solid fa-user-secret me-2" }),
      y(" Agents ")
    ], -1)),
    a("table", lXt, [
      e.agentsGroups.length > 0 ? (p(!0), h(A, { key: 0 }, D(e.agentsGroups, (l, d) => (p(), h(A, {
        key: l.agentId
      }, [
        a("tr", null, [
          a("td", dXt, g(l.properties.length), 1),
          a("td", cXt, [
            a("div", uXt, [
              a("div", pXt, [
                a("div", hXt, [
                  a("a", {
                    "data-bs-toggle": "collapse",
                    href: e.genId("#agentGroup", d),
                    role: "button",
                    "aria-expanded": "false",
                    "aria-controls": e.genId("agentGroup", d)
                  }, t[1] || (t[1] = [
                    a("i", { class: "far fa-chevron-right" }, null, -1)
                  ]), 8, mXt)
                ]),
                l.firstName || l.lastName ? (p(), h(A, { key: 0 }, [
                  a("div", {
                    class: "col text-truncate",
                    title: l.firstName + " " + l.lastName
                  }, [
                    t[2] || (t[2] = a("strong", null, "Agent:", -1)),
                    y(" " + g(l.firstName) + " " + g(l.lastName), 1)
                  ], 8, fXt),
                  l.broker ? (p(), h("div", {
                    key: 0,
                    class: "col text-truncate",
                    title: l.broker
                  }, [
                    t[3] || (t[3] = a("strong", null, "Broker:", -1)),
                    y(" " + g(l.broker), 1)
                  ], 8, gXt)) : P("", !0)
                ], 64)) : l.broker ? (p(), h("div", vXt, [
                  t[4] || (t[4] = a("strong", null, "Broker:", -1)),
                  y(" " + g(l.broker), 1)
                ])) : (p(), h("div", yXt, " Unknown "))
              ]),
              a("div", bXt, [
                l.agentId ? (p(), h("div", AXt, [
                  V(a("input", {
                    type: "checkbox",
                    class: "form-check-input",
                    onClick: (c) => e.setInvAgent(l, c),
                    "onUpdate:modelValue": (c) => l.investorManagement = c,
                    id: e.genId("agentInv", d)
                  }, null, 8, wXt), [
                    [Ue, l.investorManagement]
                  ]),
                  a("label", {
                    class: "form-check-label",
                    for: e.genId("agentInv", d)
                  }, "Investor Agent", 8, CXt)
                ])) : P("", !0),
                l.agentId ? (p(), h("div", SXt, [
                  V(a("input", {
                    type: "checkbox",
                    class: "form-check-input",
                    onClick: (c) => e.setPMAgent(l, c),
                    "onUpdate:modelValue": (c) => l.propertyManagement = c,
                    id: e.genId("agentPM", d)
                  }, null, 8, PXt), [
                    [Ue, l.propertyManagement]
                  ]),
                  a("label", {
                    class: "form-check-label",
                    for: e.genId("agentPM", d)
                  }, "PM", 8, kXt)
                ])) : P("", !0),
                a("button", {
                  type: "button",
                  class: "btn btn-success btn-sm ms-md-3",
                  onClick: (c) => e.addCrmAgent(l, c),
                  disabled: !e.isLoading && !e.crmProvider
                }, " Add to CRM ", 8, EXt)
              ])
            ])
          ])
        ]),
        a("tbody", {
          class: "collapse bg-light",
          id: e.genId("agentGroup", d)
        }, [
          t[7] || (t[7] = a("tr", null, [
            a("th"),
            a("th", null, "Property Address"),
            a("th", null, "MLS"),
            a("th", null, "Listing Type"),
            a("th", null, "Listing Date"),
            a("th", null, "Listing Status"),
            a("th", null, "Amount")
          ], -1)),
          (p(!0), h(A, null, D(l.properties, (c) => {
            var u;
            return p(), h("tr", null, [
              t[6] || (t[6] = a("td", null, null, -1)),
              a("td", null, [
                a("a", {
                  href: c.url,
                  target: "_blank"
                }, [
                  y(g(c.address) + " ", 1),
                  t[5] || (t[5] = a("i", { class: "fa-duotone fa-solid fa-external-link ms-md-2" }, null, -1))
                ], 8, TXt)
              ]),
              a("td", null, g((u = c.mlsSource) == null ? void 0 : u.toUpperCase()), 1),
              a("td", null, [
                c.type == "Sale" && c.status == "Active" ? (p(), h("img", OXt)) : c.type == "Sale" && c.status == "Closed" ? (p(), h("img", RXt)) : c.type == "Lease" && c.status == "Active" ? (p(), h("img", LXt)) : (p(), h(A, { key: 3 }, [
                  y(g(c.type), 1)
                ], 64))
              ]),
              a("td", null, g(e.longDate(c.listDate)), 1),
              a("td", null, g(c.status), 1),
              a("td", null, g(e.currency(c.soldPrice)), 1)
            ]);
          }), 256))
        ], 8, IXt)
      ], 64))), 128)) : (p(), h("tr", BXt, t[8] || (t[8] = [
        a("td", {
          class: "text-center py-5",
          colspan: "6"
        }, [
          a("strong", null, "No agents")
        ], -1)
      ]))),
      e.agentHasMore ? (p(), h("tr", MXt, [
        a("td", xXt, [
          a("button", {
            type: "button",
            class: "btn btn-sm btn-outline-eclipse",
            onClick: t[0] || (t[0] = (...l) => e.loadNextAgents && e.loadNextAgents(...l))
          }, "Retrieve more agents...")
        ])
      ])) : P("", !0)
    ])
  ]));
}
const vds = /* @__PURE__ */ Ae(oXt, [["render", FXt]]), VXt = me({
  name: "OwnerProperties",
  components: {
    CodeLoader: pb,
    InstagramLoader: IY,
    Property: rXt,
    Paginator: Vm
  },
  props: {
    id: String,
    googleApi: String
  },
  emits: [],
  data() {
    return {
      propertyType: Xt.SingleFamily,
      InitialLoad: !1,
      showManagementAreaOnly: !0,
      disableShowManagementAreaOnly: !1,
      assignType: "assignExist",
      PropertiesPage: 1,
      PropertiesPageSize: 24,
      customOwners: [],
      createOwnerError: [],
      CurrentProperty: void 0,
      NewOwner: {},
      assignOwnerModel: {},
      validateFormFields: !1,
      busyAssigning: !1
    };
  },
  watch: {
    propertyType: {
      async handler(e, t) {
        var s;
        (s = this.owner) != null && s.id && (this.PropertiesPage = 1, await this.loadProperties());
      }
    },
    showManagementAreaOnly: {
      async handler(e, t) {
        var s;
        (s = this.owner) != null && s.id && (this.PropertiesPage = 1, await this.loadProperties());
      }
    },
    assignType() {
      const e = bootstrap.Collapse.getOrCreateInstance(this.$refs.assignNew), t = bootstrap.Collapse.getOrCreateInstance(this.$refs.assignExist);
      this.assignType == "assignNew" ? (t.hide(), e == null || e.show()) : (e == null || e.hide(), t == null || t.show());
    },
    "owner.id"(e) {
      console.log("owner.id", e), e && (this.loadPropertyGroups(), this.loadProperties());
    }
  },
  computed: {
    selectedPropertyType() {
      return this.propertyTypes.filter((e) => e.type == this.propertyType).find(() => !0);
    },
    isSingleFamily() {
      return this.propertyType == Xt.SingleFamily;
    },
    canCreateOrAssign() {
      return this.busyAssigning == !1 && this.selectedProperties.length > 0 && (this.assignType == "assignExist" && `${this.assignOwnerModel.ownerId}` != "" && this.assignOwnerModel.ownerId != null || this.assignType == "assignNew" && this.isFormValid);
    },
    ownerNameStyle() {
      return {
        "is-invalid": this.isOwnerNameInvalid
      };
    },
    isOwnerNameInvalid() {
      return this.validateFormFields && !this.NewOwner.name && (!this.NewOwner.firstName || !this.NewOwner.lastName);
    },
    isFullAddressInvalid() {
      return this.validateFormFields && (!this.NewOwner.address || !this.NewOwner.city || !this.NewOwner.state || !this.NewOwner.zip);
    },
    isFormValid() {
      return this.validateFormFields == !1 || this.selectedProperties.length > 0 && this.isOwnerNameInvalid == !1 && this.isFullAddressInvalid == !1;
    },
    assignButtonLabel() {
      return this.assignType == "assignNew" ? "Create & Assign" : "Assign";
    },
    ...at(Ba),
    ...q(Ba, [
      "ownerParties",
      "loadingOwnerNames",
      "owner",
      "propertyTypes",
      "properties",
      "propertyTotal",
      "propertyHomesteadCount",
      "propertyFiltered",
      "propertyAbsenteeOwnedCount",
      "propertiesLoading",
      "selectedProperties"
    ])
  },
  methods: {
    number: Ve,
    currency: Ze,
    async loadPropertyGroups() {
      try {
        await this.portfolioFinderStore.refreshPropertyGroups();
      } catch (e) {
        Se(e);
      }
    },
    async loadProperties() {
      try {
        await this.portfolioFinderStore.getProperties(this.PropertiesPage, this.PropertiesPageSize, this.propertyType, this.showManagementAreaOnly), this.propertyFiltered == 0 && this.showManagementAreaOnly == !0 && (this.showManagementAreaOnly = !1, this.disableShowManagementAreaOnly = !0);
      } catch (e) {
        Se(e);
      }
      this.InitialLoad = !0;
    },
    async onPage(e) {
      this.PropertiesPage = e.page + 1, this.PropertiesPageSize = e.rows, await this.loadProperties();
    },
    viewAnalysis(e) {
      this.CurrentProperty = this.properties.find((t) => t.id == e), window.open(t1.format(De.URL.Property.ById, e), `_${e}`);
    },
    viewData(e) {
      this.CurrentProperty = this.properties.find((t) => t.id == e), $("#modalProp").modal("show");
    },
    propSelected(e) {
      let t = this.properties.find((s) => s.id == e.id);
      t && (t.selected = e.checked);
    },
    async assignOwner() {
      var e;
      try {
        if (this.customOwners.length <= 0) {
          const n = await W.api.portfolioFinder.getLeadCustomOwners(1, 100);
          if (n.data.status != de.Success)
            throw new Le(n);
          this.customOwners.length = 0, this.customOwners.push(...n.data.results);
        }
        this.customOwners.length == 0 && (this.assignType = "assignNew");
        let t = this.selectedProperties.sort((n, r) => new Date(n.recordingDate).getDate() - new Date(r.recordingDate).getDate()).find((n) => !0);
        t && (t.owner1Type == "COMPANY" ? (this.NewOwner.name = t.owner1LastName, this.NewOwner.firstName = "", this.NewOwner.lastName = "") : (this.NewOwner.name = "", this.NewOwner.firstName = t.owner1FirstName, this.NewOwner.lastName = t.owner1LastName), this.NewOwner.address = t.propertyAddressFull, this.NewOwner.city = t.propertyAddressCity, this.NewOwner.state = t.propertyAddressState, this.NewOwner.zip = t.propertyAddressZip), this.validateFormFields = !1, this.createOwnerError.length = 0, this.selectedProperties.length <= 0 && this.createOwnerError.push("No properties selected!");
      } catch (t) {
        let s = new Cs("Assign Owner Error", t.message);
        s.stay = !0, Ss(s);
      }
      (e = bootstrap.Modal.getOrCreateInstance(this.$refs.modalAssignOwner)) == null || e.show();
    },
    async createOwner() {
      var e, t;
      console.log("createOwner"), this.validateFormFields = !0, this.busyAssigning = !0;
      try {
        switch (this.assignType) {
          //#region Create New Owner
          case "assignNew":
            if (this.isFormValid == !1) return;
            const s = await this.portfolioFinderStore.createOwner(this.NewOwner);
            wt(`Succefully reassigned ${this.number(this.selectedProperties.length)} properties to new custom owner.`), (e = bootstrap.Modal.getOrCreateInstance(this.$refs.modalAssignOwner)) == null || e.hide(), this.validateFormFields = !1, this.NewOwner = {}, this.customOwners.length = 0, window.open(`/portfolio-finder/${s}`, "_blank");
            break;
          //#endregion
          //#region Assign properties to existing owner.
          case "assignExist":
            await this.portfolioFinderStore.assignOwner(this.assignOwnerModel), wt(`Succefully reassigned ${this.number(this.selectedProperties.length)} properties to existing custom owner.`), (t = bootstrap.Modal.getOrCreateInstance(this.$refs.modalAssignOwner)) == null || t.hide(), this.validateFormFields = !1, this.assignOwnerModel = {};
            break;
        }
      } catch (s) {
        this.createOwnerError.length = 0, this.createOwnerError.push(s.message);
      } finally {
        this.busyAssigning = !1;
      }
    },
    isFormInputInvalid(e) {
      return this.validateFormFields == !0 && (e == null || e == "");
    },
    propertyTypeFromQuery() {
      switch (new URLSearchParams(window.location.search).get("pt")) {
        case "1": {
          this.propertyType = Xt.SingleFamily;
          break;
        }
        case "2": {
          this.propertyType = Xt.Commercial;
          break;
        }
        case "3": {
          this.propertyType = Xt.MobileHomeParks;
          break;
        }
        case "4": {
          this.propertyType = Xt.MultiFamily;
          break;
        }
        case "5": {
          this.propertyType = Xt.Residential24Family;
          break;
        }
        case "6": {
          this.propertyType = Xt.Retail;
          break;
        }
        case "7": {
          this.propertyType = Xt.RvParksCampground;
          break;
        }
        case "8": {
          this.propertyType = Xt.SelfStorage;
          break;
        }
        default:
          this.propertyType = Xt.SingleFamily;
      }
    }
  },
  mounted() {
    this.propertyTypeFromQuery(), this.$nextTick(() => {
      document.querySelectorAll('[data-bs-toggle="popover"]').forEach((e) => bootstrap.Popover.getOrCreateInstance(e));
    });
  }
}), DXt = { class: "row" }, NXt = { class: "col-12 col-lg-3" }, jXt = { class: "mb-xl-8 d-none d-xl-block" }, HXt = { class: "form-check form-switch form-switch-lg" }, UXt = ["disabled"], zXt = { class: "mb-xl-3 d-none d-xl-block" }, WXt = { class: "d-flex gap-2 flex-column" }, GXt = ["value", "id"], YXt = ["for", "title"], XXt = {
  key: 0,
  class: "badge rounded-pill text-bg-warning align-items-center d-flex ms-auto"
}, qXt = {
  class: "d-xl-none card shadow-sm d-flex justify-content-between flex-row p-3 gap-2 mb-3",
  style: { overflow: "inherit" }
}, QXt = { class: "dropdown" }, KXt = {
  class: "dropdown-menu shadow-sm p-4",
  style: { "min-width": "300px" }
}, ZXt = { class: "form-check form-switch form-switch-lg" }, JXt = ["disabled"], $Xt = {
  key: 0,
  class: "dropdown"
}, _Xt = {
  class: "dropdown-menu shadow-sm",
  style: { "min-width": "250px" }
}, eqt = { class: "dropdown-item" }, tqt = { class: "form-check d-flex gap-2" }, sqt = ["value", "id"], aqt = ["for", "title"], nqt = {
  key: 0,
  class: "badge rounded-pill text-bg-warning align-items-center d-flex ms-2 ms-md-auto"
}, rqt = { class: "col" }, oqt = { id: "single" }, iqt = { class: "row mb-3" }, lqt = { class: "col-12 col-md-4" }, dqt = { class: "fs-5 fw-bold m-0" }, cqt = {
  key: 1,
  class: "fa-duotone fa-solid fa-spinner-third fa-spin text-lava"
}, uqt = { class: "col-7 col-md-4 col-xl-3" }, pqt = { key: 0 }, hqt = {
  key: 0,
  class: "ms-2"
}, mqt = {
  key: 1,
  class: "fa-duotone fa-solid fa-spinner-third fa-spin ms-2 text-lava"
}, fqt = { class: "col-5 col-md-4 col-xl-5 text-end" }, gqt = ["disabled"], vqt = { class: "row row-cols-1 row-cols-md-2 row-cols-xxl-3 g-3" }, yqt = { class: "col-md-3" }, bqt = { class: "mb-3" }, Aqt = { class: "row g-3" }, wqt = { class: "col-12" }, Cqt = {
  class: "modal fade",
  id: "modalProp",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}, Sqt = { class: "modal-dialog modal-lg modal-dialog-centered" }, Pqt = {
  key: 0,
  class: "modal-content bg-gradient-alphabet rounded"
}, kqt = { class: "row g-0" }, Eqt = { class: "col-md-6" }, Iqt = { class: "bg-eclipse h-100 w-100 d-flex justify-content-center align-items-center" }, Tqt = ["src"], Oqt = ["src"], Rqt = { class: "col" }, Lqt = { class: "px-md-5 py-md-4 px-4 py-3 bg-alice" }, Bqt = { class: "mb-3" }, Mqt = { class: "fw-bold fs-5" }, xqt = { class: "text-secondary text-xsmall" }, Fqt = { class: "fw-bold fs-6" }, Vqt = { class: "fw-bold fs-6" }, Dqt = { class: "list-inline m-0" }, Nqt = { class: "list-inline-item" }, jqt = { class: "list-inline-item" }, Hqt = { class: "list-inline-item" }, Uqt = { class: "list-inline-item" }, zqt = { class: "row no-gutters" }, Wqt = { class: "col-md-6 text-center" }, Gqt = { class: "border-left p-3" }, Yqt = { class: "row" }, Xqt = { class: "col-6" }, qqt = { class: "col-6" }, Qqt = { class: "col-md-6 text-center" }, Kqt = { class: "border-left p-3" }, Zqt = { class: "row" }, Jqt = { class: "col" }, $qt = { class: "col" }, _qt = { class: "col" }, eQt = { class: "row" }, tQt = { class: "col text-center" }, sQt = { class: "border-top p-3" }, aQt = { class: "row" }, nQt = { class: "col-6 col-md-3 mb-2 mb-md-0" }, rQt = { class: "col-6 col-md-3 mb-2 mb-md-0" }, oQt = { class: "col-6 col-md-3" }, iQt = {
  key: 1,
  class: "col"
}, lQt = {
  ref: "modalAssignOwner",
  class: "modal fade",
  id: "modalAssignOwner",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}, dQt = { class: "modal-dialog modal-dialog-centered" }, cQt = { class: "modal-content bg-gradient-alphabet rounded" }, uQt = {
  ref: "AssignOwnerAccordion",
  id: "AssignOwnerAccordion",
  class: "modal-body"
}, pQt = {
  key: 0,
  class: "alert alert-danger",
  role: "alert"
}, hQt = { key: 1 }, mQt = { class: "card card-body bg-opacity-25 bg-white mb-3" }, fQt = { class: "form-check" }, gQt = {
  ref: "assignExist",
  id: "assignExist",
  class: "collapse show",
  "data-parent": "#AssignOwnerAccordion"
}, vQt = ["disabled"], yQt = ["value"], bQt = { class: "card card-body bg-opacity-25 bg-white" }, AQt = { class: "form-check" }, wQt = {
  ref: "assignNew",
  id: "assignNew",
  class: "collapse",
  "data-parent": "#AssignOwnerAccordion"
}, CQt = { class: "mb-3" }, SQt = ["disabled"], PQt = { class: "row mb-3" }, kQt = { class: "col-md-6" }, EQt = ["disabled"], IQt = { class: "col-md-6" }, TQt = ["disabled"], OQt = { class: "mb-3" }, RQt = ["disabled"], LQt = { class: "row mb-3" }, BQt = { class: "col-md-6" }, MQt = ["disabled"], xQt = { class: "col-md-2" }, FQt = ["disabled"], VQt = { class: "col-md-4" }, DQt = ["disabled"], NQt = { class: "modal-footer border-0 pt-0" }, jQt = ["disabled"], HQt = ["disabled"];
function UQt(e, t, s, n, r, i) {
  var c;
  const o = pe("property"), l = pe("instagram-loader"), d = pe("paginator");
  return p(), h(A, null, [
    a("div", DXt, [
      a("div", NXt, [
        a("div", jXt, [
          t[18] || (t[18] = a("p", { class: "fw-bold mb-2 d-none d-xl-block" }, "PROPERTY FILTER", -1)),
          a("div", HXt, [
            V(a("input", {
              type: "checkbox",
              id: "showManagementAreaOnly",
              "onUpdate:modelValue": t[0] || (t[0] = (u) => e.showManagementAreaOnly = u),
              "data-search-pref": "showManagementAreaOnly",
              class: "form-check-input",
              disabled: e.disableShowManagementAreaOnly
            }, null, 8, UXt), [
              [Ue, e.showManagementAreaOnly]
            ]),
            t[17] || (t[17] = a("label", {
              class: "form-check-label",
              for: "showManagementAreaOnly"
            }, "My Company Territory Only", -1))
          ])
        ]),
        a("div", zXt, [
          t[19] || (t[19] = a("p", { class: "fw-bold mb-2" }, "PROPERTY TYPE", -1)),
          a("div", WXt, [
            e.propertyTypes ? (p(!0), h(A, { key: 0 }, D(e.propertyTypes, (u) => (p(), h("div", {
              class: "form-check m-0 d-flex gap-2",
              key: u.type
            }, [
              V(a("input", {
                class: "form-check-input",
                type: "radio",
                name: "propertyTypes",
                value: u.type,
                id: "check" + u.type,
                "onUpdate:modelValue": t[1] || (t[1] = (m) => e.propertyType = m)
              }, null, 8, GXt), [
                [Mt, e.propertyType]
              ]),
              a("label", {
                class: "form-check-label text-uppercase text-truncate",
                for: "check" + u.type,
                title: u.name
              }, g(u.name), 9, YXt),
              u.total > 0 ? (p(), h("span", XXt, [
                e.showManagementAreaOnly && u.inArea > 0 ? (p(), h(A, { key: 0 }, [
                  y(g(e.number(u.inArea)) + " / ", 1)
                ], 64)) : P("", !0),
                y(" " + g(e.number(u.total)), 1)
              ])) : P("", !0)
            ]))), 128)) : P("", !0)
          ])
        ]),
        a("div", qXt, [
          a("div", QXt, [
            t[21] || (t[21] = a("button", {
              class: "btn btn-outline-secondary dropdown-toggle",
              type: "button",
              "data-bs-toggle": "dropdown",
              "aria-expanded": "false"
            }, " PROPERTY FILTER ", -1)),
            a("div", KXt, [
              a("div", ZXt, [
                V(a("input", {
                  type: "checkbox",
                  id: "showManagementAreaOnly",
                  "onUpdate:modelValue": t[2] || (t[2] = (u) => e.showManagementAreaOnly = u),
                  "data-search-pref": "showManagementAreaOnly",
                  class: "form-check-input",
                  disabled: e.disableShowManagementAreaOnly
                }, null, 8, JXt), [
                  [Ue, e.showManagementAreaOnly]
                ]),
                t[20] || (t[20] = a("label", {
                  class: "form-check-label",
                  for: "showManagementAreaOnly"
                }, "My Company Territory Only", -1))
              ])
            ])
          ]),
          e.propertyTypes ? (p(), h("div", $Xt, [
            t[22] || (t[22] = a("button", {
              class: "btn btn-outline-secondary dropdown-toggle",
              type: "button",
              "data-bs-toggle": "dropdown",
              "aria-expanded": "false"
            }, [
              a("span", { class: "d-none d-md-inline-block" }, "PROPERTY "),
              y("TYPE ")
            ], -1)),
            a("ul", _Xt, [
              (p(!0), h(A, null, D(e.propertyTypes, (u) => (p(), h("li", {
                key: u.type
              }, [
                a("div", eqt, [
                  a("div", tqt, [
                    V(a("input", {
                      class: "form-check-input",
                      type: "radio",
                      name: "propertyTypes",
                      value: u.type,
                      id: "check" + u.type,
                      "onUpdate:modelValue": t[3] || (t[3] = (m) => e.propertyType = m)
                    }, null, 8, sqt), [
                      [Mt, e.propertyType]
                    ]),
                    a("label", {
                      class: "form-check-label text-uppercase text-truncate",
                      for: "check" + u.type,
                      title: u.name
                    }, g(u.name), 9, aqt),
                    u.total > 0 ? (p(), h("span", nqt, [
                      e.showManagementAreaOnly && u.inArea > 0 ? (p(), h(A, { key: 0 }, [
                        y(g(e.number(u.inArea)) + " / ", 1)
                      ], 64)) : P("", !0),
                      y(" " + g(e.number(u.total)), 1)
                    ])) : P("", !0)
                  ])
                ])
              ]))), 128))
            ])
          ])) : P("", !0)
        ]),
        P("", !0)
      ]),
      a("div", rqt, [
        a("div", oqt, [
          a("div", iqt, [
            a("div", lqt, [
              a("h2", dqt, [
                y(g((c = e.selectedPropertyType) == null ? void 0 : c.name) + " (", 1),
                e.InitialLoad ? (p(), h(A, { key: 0 }, [
                  y(g(e.number(e.propertyFiltered, 0, "N/A")), 1)
                ], 64)) : (p(), h("i", cqt)),
                t[24] || (t[24] = y(") "))
              ])
            ]),
            a("div", uqt, [
              e.isSingleFamily ? (p(), h("span", pqt, [
                t[25] || (t[25] = y(" Absentee Owned: ")),
                t[26] || (t[26] = a("i", {
                  title: "All single family properies that are recorded as absentee owned.",
                  class: "fa-light fa-info-circle ms-1",
                  "data-bs-toggle": "tooltip"
                }, null, -1)),
                e.InitialLoad ? (p(), h("span", hqt, g(e.number(e.propertyAbsenteeOwnedCount)), 1)) : (p(), h("i", mqt))
              ])) : P("", !0)
            ]),
            a("div", fqt, [
              a("button", {
                type: "button",
                class: "btn btn-sm btn-outline-eclipse",
                onClick: t[4] || (t[4] = (...u) => e.assignOwner && e.assignOwner(...u)),
                tabindex: "-1",
                disabled: !e.properties,
                role: "tab",
                "aria-controls": "owner",
                "aria-selected": "false"
              }, t[27] || (t[27] = [
                y("Move Selected "),
                a("span", { class: "d-none d-xl-inline-block" }, " Properties to New Target", -1)
              ]), 8, gqt)
            ])
          ]),
          a("div", vqt, [
            e.propertiesLoading ? (p(!0), h(A, { key: 1 }, D(e.PropertiesPageSize, (u) => (p(), h("div", yqt, [
              a("div", bqt, [
                N(l, { speed: 2 })
              ])
            ]))), 256)) : (p(!0), h(A, { key: 0 }, D(e.properties, (u, m) => (p(), Fe(o, {
              key: u.id,
              item: u,
              index: m,
              googleApi: e.googleApi,
              onViewData: e.viewData,
              onViewAnalysis: e.viewAnalysis,
              onPropSelected: e.propSelected
            }, null, 8, ["item", "index", "googleApi", "onViewData", "onViewAnalysis", "onPropSelected"]))), 128))
          ]),
          a("div", Aqt, [
            a("div", wqt, [
              N(d, {
                rows: e.PropertiesPageSize,
                totalRecords: e.propertyFiltered,
                alwaysShow: !1,
                template: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
                rowsPerPageOptions: [24, 48, 72],
                onPage: t[5] || (t[5] = (u) => e.onPage(u)),
                currentPageReportTemplate: "Showing {first} to {last} of {totalRecords} properties"
              }, null, 8, ["rows", "totalRecords"])
            ])
          ])
        ])
      ])
    ]),
    a("div", Cqt, [
      a("div", Sqt, [
        e.CurrentProperty ? (p(), h("div", Pqt, [
          a("div", kqt, [
            a("div", Eqt, [
              a("div", Iqt, [
                e.CurrentProperty.photo ? (p(), h("img", {
                  key: 0,
                  src: e.CurrentProperty.photo,
                  height: "339",
                  width: "400",
                  alt: "Listing Photo",
                  title: "Listing Photo",
                  loading: "lazy",
                  class: "img-fluid"
                }, null, 8, Tqt)) : (p(), h("img", {
                  key: 1,
                  src: "https://maps.googleapis.com/maps/api/streetview?return_error_code=true&size=400x248&location=" + encodeURIComponent(e.CurrentProperty.propertyAddressFull) + "," + encodeURIComponent(e.CurrentProperty.propertyAddressCity) + "," + encodeURIComponent(e.CurrentProperty.propertyAddressState) + " " + encodeURIComponent(e.CurrentProperty.propertyAddressZIP) + "&fov=80&key=" + e.googleApi,
                  alt: "Street View",
                  title: "Street View",
                  loading: "lazy",
                  height: "339",
                  width: "400",
                  class: "img-fluid"
                }, null, 8, Oqt))
              ])
            ]),
            a("div", Rqt, [
              t[41] || (t[41] = a("button", {
                type: "button",
                class: "btn-close position-absolute top-0 end-0 mt-2 me-2",
                "data-bs-dismiss": "modal",
                "aria-label": "Close"
              }, null, -1)),
              a("div", Lqt, [
                a("div", Bqt, [
                  a("p", Mqt, [
                    a("span", xqt, g(e.CurrentProperty.owner1Type), 1),
                    t[28] || (t[28] = a("br", null, null, -1)),
                    y(" " + g(e.CurrentProperty.owner1FirstName) + " " + g(e.CurrentProperty.owner1LastName), 1)
                  ]),
                  a("p", Fqt, [
                    t[29] || (t[29] = a("span", { class: "text-secondary text-xsmall" }, "OWNER ADDRESS", -1)),
                    t[30] || (t[30] = a("br", null, null, -1)),
                    y(" " + g(e.owner.address), 1),
                    t[31] || (t[31] = a("br", null, null, -1)),
                    y(" " + g(e.owner.city) + ", " + g(e.owner.state) + " " + g(e.owner.zip), 1)
                  ]),
                  t[36] || (t[36] = a("hr", null, null, -1)),
                  a("p", Vqt, [
                    t[32] || (t[32] = a("span", { class: "text-secondary text-xsmall" }, "PROPERTY ADDRESS", -1)),
                    t[33] || (t[33] = a("br", null, null, -1)),
                    y(" " + g(e.CurrentProperty.propertyAddressFull), 1),
                    t[34] || (t[34] = a("br", null, null, -1)),
                    y(" " + g(e.CurrentProperty.propertyAddressCity) + ", " + g(e.CurrentProperty.propertyAddressState) + " " + g(e.CurrentProperty.propertyAddressZIP), 1),
                    t[35] || (t[35] = a("br", null, null, -1))
                  ])
                ]),
                a("ul", Dqt, [
                  a("li", Nqt, [
                    t[37] || (t[37] = a("i", { class: "fa-light fa-birthday-cake me-1" }, null, -1)),
                    y(" " + g(e.CurrentProperty.yearBuilt), 1)
                  ]),
                  a("li", jqt, [
                    t[38] || (t[38] = a("i", { class: "fa-light fa-bed me-1" }, null, -1)),
                    y(" " + g(e.CurrentProperty.bedroomsCount), 1)
                  ]),
                  a("li", Hqt, [
                    t[39] || (t[39] = a("i", { class: "fa-light fa-bath me-1" }, null, -1)),
                    y(" " + g(e.number(e.CurrentProperty.bathCount)) + "." + g(e.number(e.CurrentProperty.bathPartialCount)), 1)
                  ]),
                  a("li", Uqt, [
                    t[40] || (t[40] = a("i", { class: "fa-light fa-home me-1" }, null, -1)),
                    y(g(e.number(e.CurrentProperty.areaBuilding)) + " SF ", 1)
                  ])
                ])
              ])
            ])
          ]),
          a("div", zqt, [
            a("div", Wqt, [
              a("div", Gqt, [
                a("div", Yqt, [
                  t[46] || (t[46] = a("div", { class: "col-md-12 fw-bold" }, " RESCOVER DATA ", -1)),
                  a("div", Xqt, [
                    t[42] || (t[42] = y(" Predicted Value")),
                    t[43] || (t[43] = a("br", null, null, -1)),
                    a("b", null, g(e.currency(e.CurrentProperty.soldPrediction)), 1)
                  ]),
                  a("div", qqt, [
                    t[44] || (t[44] = y(" Rental Rate")),
                    t[45] || (t[45] = a("br", null, null, -1)),
                    a("b", null, g(e.currency(e.CurrentProperty.rentalPrediction)), 1)
                  ])
                ])
              ])
            ]),
            a("div", Qqt, [
              a("div", Kqt, [
                a("div", Zqt, [
                  t[53] || (t[53] = a("div", { class: "col-md-12 fw-bold" }, " ASSESSED VALUE ", -1)),
                  a("div", Jqt, [
                    t[47] || (t[47] = y(" Land")),
                    t[48] || (t[48] = a("br", null, null, -1)),
                    y(" " + g(e.currency(e.CurrentProperty.taxAssessedValueLand)), 1)
                  ]),
                  a("div", $qt, [
                    t[49] || (t[49] = y(" Improvement")),
                    t[50] || (t[50] = a("br", null, null, -1)),
                    a("b", null, g(e.currency(e.CurrentProperty.taxAssessedValueImprovements)), 1)
                  ]),
                  a("div", _qt, [
                    t[51] || (t[51] = y(" Total")),
                    t[52] || (t[52] = a("br", null, null, -1)),
                    y(" " + g(e.currency(e.CurrentProperty.taxAssessedValueTotal)), 1)
                  ])
                ])
              ])
            ])
          ]),
          a("div", eQt, [
            a("div", tQt, [
              a("div", sQt, [
                a("div", aQt, [
                  t[61] || (t[61] = a("div", { class: "col-md-12 fw-bold" }, " LAST RENTED ", -1)),
                  e.CurrentProperty.last_rented ? (p(), h(A, { key: 0 }, [
                    a("div", nQt, [
                      t[54] || (t[54] = y(" Date")),
                      t[55] || (t[55] = a("br", null, null, -1)),
                      a("b", null, g(e.listedWhen(e.CurrentProperty.lastRented)), 1)
                    ]),
                    a("div", rQt, [
                      t[56] || (t[56] = y(" Amount")),
                      t[57] || (t[57] = a("br", null, null, -1)),
                      a("b", null, g(e.listedAmount(e.CurrentProperty.lastRented)), 1)
                    ]),
                    a("div", oQt, [
                      t[58] || (t[58] = y(" Listing Agent")),
                      t[59] || (t[59] = a("br", null, null, -1)),
                      a("b", null, g(e.listedAgent(e.CurrentProperty.lastRented)), 1)
                    ]),
                    t[60] || (t[60] = a("div", { class: "col-6 col-md-3" }, [
                      y(" Broker"),
                      a("br"),
                      a("b", null, "--")
                    ], -1))
                  ], 64)) : (p(), h("div", iQt, " N/A "))
                ])
              ])
            ])
          ])
        ])) : P("", !0)
      ])
    ]),
    a("div", lQt, [
      a("div", dQt, [
        a("div", cQt, [
          t[85] || (t[85] = a("div", { class: "modal-header border-0 pb-0" }, [
            a("b", null, "Move Selected Properties to New Target"),
            a("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            })
          ], -1)),
          a("div", uQt, [
            e.createOwnerError.length > 0 ? (p(), h("div", pQt, [
              (p(!0), h(A, null, D(e.createOwnerError, (u) => (p(), h(A, { key: u }, [
                y(g(u) + " ", 1),
                t[62] || (t[62] = a("br", null, null, -1))
              ], 64))), 128))
            ])) : (p(), h("p", hQt, [
              e.customOwners.length > 0 ? (p(), h(A, { key: 0 }, [
                y(" Choose an existing custom target or create ")
              ], 64)) : (p(), h(A, { key: 1 }, [
                y(" Create ")
              ], 64)),
              t[63] || (t[63] = y(" a new target for the ")),
              a("strong", null, g(e.number(e.selectedProperties.length)), 1),
              t[64] || (t[64] = y(" properties you have pre-selected. "))
            ])),
            V(a("div", mQt, [
              a("div", fQt, [
                V(a("input", {
                  class: "form-check-input",
                  type: "radio",
                  name: "assignType",
                  "onUpdate:modelValue": t[6] || (t[6] = (u) => e.assignType = u),
                  id: "assignTypeExist",
                  value: "assignExist"
                }, null, 512), [
                  [Mt, e.assignType]
                ]),
                t[65] || (t[65] = a("label", {
                  class: "form-check-label fw-bold",
                  for: "assignTypeExist"
                }, " Assign to existing custom target ", -1))
              ]),
              a("div", gQt, [
                a("div", null, [
                  t[67] || (t[67] = a("label", {
                    for: "AssignTo",
                    class: "form-label"
                  }, "Assign To", -1)),
                  V(a("select", {
                    id: "AssignTo",
                    "onUpdate:modelValue": t[7] || (t[7] = (u) => e.assignOwnerModel.ownerId = u),
                    class: "form-select",
                    disabled: !e.customOwners || e.busyAssigning
                  }, [
                    t[66] || (t[66] = a("option", {
                      disabled: "",
                      value: ""
                    }, "Please select one", -1)),
                    (p(!0), h(A, null, D(e.customOwners, (u) => (p(), h("option", {
                      value: u.ownerId,
                      key: u.ownerId
                    }, g(u.displayName), 9, yQt))), 128))
                  ], 8, vQt), [
                    [We, e.assignOwnerModel.ownerId]
                  ])
                ])
              ], 512)
            ], 512), [
              [Us, e.customOwners.length > 0]
            ]),
            a("div", bQt, [
              a("div", AQt, [
                V(a("input", {
                  class: "form-check-input",
                  type: "radio",
                  name: "assignType",
                  "onUpdate:modelValue": t[8] || (t[8] = (u) => e.assignType = u),
                  id: "assignTypeNew",
                  value: "assignNew"
                }, null, 512), [
                  [Mt, e.assignType]
                ]),
                t[68] || (t[68] = a("label", {
                  class: "form-check-label fw-bold",
                  for: "assignTypeNew"
                }, " Create New custom target ", -1))
              ]),
              a("div", wQt, [
                a("div", CQt, [
                  t[69] || (t[69] = a("label", {
                    for: "NewOwnerName",
                    class: "form-label"
                  }, "Target Name", -1)),
                  V(a("input", {
                    "onUpdate:modelValue": t[9] || (t[9] = (u) => e.NewOwner.name = u),
                    type: "text",
                    class: z(["form-control", e.ownerNameStyle]),
                    id: "NewOwnerName",
                    placeholder: "Company / Full Name",
                    disabled: e.busyAssigning
                  }, null, 10, SQt), [
                    [_e, e.NewOwner.name]
                  ])
                ]),
                t[82] || (t[82] = a("p", { class: "fw-bold" }, "Contact Name", -1)),
                a("div", PQt, [
                  a("div", kQt, [
                    t[70] || (t[70] = a("label", {
                      for: "NewOwnerFirstName",
                      class: "form-label"
                    }, "First Name", -1)),
                    V(a("input", {
                      "onUpdate:modelValue": t[10] || (t[10] = (u) => e.NewOwner.firstName = u),
                      type: "text",
                      class: z(["form-control", e.ownerNameStyle]),
                      id: "NewOwnerFirstName",
                      placeholder: "First Name",
                      required: "",
                      disabled: e.busyAssigning
                    }, null, 10, EQt), [
                      [_e, e.NewOwner.firstName]
                    ]),
                    t[71] || (t[71] = a("div", { class: "invalid-feedback" }, " Please provide a valid first name. ", -1))
                  ]),
                  a("div", IQt, [
                    t[72] || (t[72] = a("label", {
                      for: "NewOwnerLastName",
                      class: "form-label"
                    }, "Last Name", -1)),
                    V(a("input", {
                      "onUpdate:modelValue": t[11] || (t[11] = (u) => e.NewOwner.lastName = u),
                      type: "text",
                      class: z(["form-control", e.ownerNameStyle]),
                      id: "NewOwnerLastName",
                      placeholder: "Last Name",
                      required: "",
                      disabled: e.busyAssigning
                    }, null, 10, TQt), [
                      [_e, e.NewOwner.lastName]
                    ]),
                    t[73] || (t[73] = a("div", { class: "invalid-feedback" }, " Please provide a valid last name. ", -1))
                  ])
                ]),
                t[83] || (t[83] = a("hr", null, null, -1)),
                t[84] || (t[84] = a("p", { class: "fw-bold" }, "Mailing Address", -1)),
                a("div", OQt, [
                  t[74] || (t[74] = a("label", {
                    for: "NewOwnerAddress",
                    class: "form-label"
                  }, "Address", -1)),
                  V(a("input", {
                    "onUpdate:modelValue": t[12] || (t[12] = (u) => e.NewOwner.address = u),
                    type: "text",
                    class: z(["form-control", { "is-invalid": e.isFormInputInvalid(e.NewOwner.address) }]),
                    id: "NewOwnerAddress",
                    placeholder: "Address",
                    required: "",
                    disabled: e.busyAssigning
                  }, null, 10, RQt), [
                    [_e, e.NewOwner.address]
                  ]),
                  t[75] || (t[75] = a("div", { class: "invalid-feedback" }, " Please provide a valid address. ", -1))
                ]),
                a("div", LQt, [
                  a("div", BQt, [
                    t[76] || (t[76] = a("label", {
                      for: "NewOwnerCity",
                      class: "form-label"
                    }, "City", -1)),
                    V(a("input", {
                      "onUpdate:modelValue": t[13] || (t[13] = (u) => e.NewOwner.city = u),
                      type: "text",
                      class: z(["form-control", { "is-invalid": e.isFormInputInvalid(e.NewOwner.city) }]),
                      id: "NewOwnerCity",
                      placeholder: "City",
                      required: "",
                      disabled: e.busyAssigning
                    }, null, 10, MQt), [
                      [_e, e.NewOwner.city]
                    ]),
                    t[77] || (t[77] = a("div", { class: "invalid-feedback" }, " Please provide a valid city. ", -1))
                  ]),
                  a("div", xQt, [
                    t[78] || (t[78] = a("label", {
                      for: "NewOwnerState",
                      class: "form-label"
                    }, "State", -1)),
                    V(a("input", {
                      "onUpdate:modelValue": t[14] || (t[14] = (u) => e.NewOwner.state = u),
                      type: "text",
                      class: z(["form-control", { "is-invalid": e.isFormInputInvalid(e.NewOwner.state) }]),
                      id: "NewOwnerState",
                      placeholder: "State",
                      required: "",
                      disabled: e.busyAssigning
                    }, null, 10, FQt), [
                      [_e, e.NewOwner.state]
                    ]),
                    t[79] || (t[79] = a("div", { class: "invalid-feedback" }, " Please provide a valid state. ", -1))
                  ]),
                  a("div", VQt, [
                    t[80] || (t[80] = a("label", {
                      for: "NewOwnerZip",
                      class: "form-label"
                    }, "Zip", -1)),
                    V(a("input", {
                      "onUpdate:modelValue": t[15] || (t[15] = (u) => e.NewOwner.zip = u),
                      type: "text",
                      class: z(["form-control", { "is-invalid": e.isFormInputInvalid(e.NewOwner.zip) }]),
                      id: "NewOwnerZip",
                      placeholder: "Zip",
                      required: "",
                      disabled: e.busyAssigning
                    }, null, 10, DQt), [
                      [_e, e.NewOwner.zip]
                    ]),
                    t[81] || (t[81] = a("div", { class: "invalid-feedback" }, " Please provide a valid zip. ", -1))
                  ])
                ])
              ], 512)
            ])
          ], 512),
          a("div", NQt, [
            a("button", {
              type: "button",
              class: "btn btn-outline-eclipse",
              "data-bs-dismiss": "modal",
              disabled: e.busyAssigning
            }, "Cancel", 8, jQt),
            a("button", {
              type: "button",
              class: "btn btn-lava ms-auto",
              onClick: t[16] || (t[16] = (...u) => e.createOwner && e.createOwner(...u)),
              disabled: !e.canCreateOrAssign
            }, g(e.assignButtonLabel), 9, HQt)
          ])
        ])
      ])
    ], 512)
  ], 64);
}
const yds = /* @__PURE__ */ Ae(VXt, [["render", UQt]]), zQt = me({
  name: "OwnerContactInfo",
  components: {
    CodeLoader: pb,
    RecordedOwnerNames: kE,
    ContactCard: PE
  },
  props: {
    id: {
      type: String,
      required: !0
    }
  },
  data() {
    return {
      isBusy: !0,
      ignored: !1
    };
  },
  computed: {
    ...at(Ba),
    ...q(Ba, ["owner"])
  },
  methods: {
    async saveNotes() {
      try {
        this.isBusy = !0;
        const e = await W.api.portfolioFinder.updateNotes(this.owner.id, this.owner.notes);
        if (e.data.status != de.Success)
          throw new Error(e.data.message);
        Ss(new Cs("Lead", "Lead notes updated.", fn.success));
      } catch (e) {
        let t = new Cs("Save Lead Error", e.message);
        Ss(t);
      }
      this.isBusy = !1;
    }
  },
  mounted() {
    this.isBusy = !1;
  }
}), WQt = { class: "card card-contacts shadow-sm" }, GQt = {
  key: 0,
  class: "p-2"
}, YQt = { class: "tab-content" }, XQt = {
  class: "tab-pane active pt-2",
  id: "info",
  role: "tabpanel",
  "aria-labelledby": "info-tab"
}, qQt = { class: "lead-contacts position-relative row row-cols-1 g-0" }, QQt = { class: "col" }, KQt = { class: "p-3" }, ZQt = { class: "col" }, JQt = { class: "p-3 border-top border-top-md-0 border-top-xl-1" }, $Qt = {
  class: "tab-pane pt-2",
  id: "notes",
  role: "tabpanel",
  "aria-labelledby": "notes-tab"
}, _Qt = {
  key: 0,
  class: "card-body"
}, eKt = ["disabled"];
function tKt(e, t, s, n, r, i) {
  const o = pe("code-loader"), l = pe("contact-card"), d = pe("recorded-owner-names");
  return p(), h("div", WQt, [
    e.owner ? (p(), h(A, { key: 1 }, [
      t[3] || (t[3] = a("ul", {
        class: "nav nav-tabs align-items-center bg-light",
        id: "myTab",
        role: "tablist"
      }, [
        a("li", {
          class: "nav-item",
          role: "presentation"
        }, [
          a("a", {
            class: "nav-link active",
            id: "info-tab",
            "data-bs-toggle": "tab",
            href: "#info",
            role: "tab",
            "aria-controls": "info",
            "aria-selected": "true"
          }, " Contact Info ")
        ]),
        a("li", {
          class: "nav-item",
          role: "presentation"
        }, [
          a("a", {
            class: "nav-link",
            id: "notes-tab",
            "data-bs-toggle": "tab",
            href: "#notes",
            role: "tab",
            "aria-controls": "notes",
            "aria-selected": "false"
          }, " Notes ")
        ])
      ], -1)),
      a("div", YQt, [
        a("div", XQt, [
          a("div", qQt, [
            a("div", QQt, [
              a("div", KQt, [
                N(l)
              ])
            ]),
            a("div", ZQt, [
              a("div", JQt, [
                N(d)
              ])
            ])
          ])
        ]),
        a("div", $Qt, [
          e.owner ? (p(), h("div", _Qt, [
            t[2] || (t[2] = a("p", { class: "fs-6 fw-bold" }, [
              a("span", { class: "text-secondary text-xsmall" }, "NOTES")
            ], -1)),
            V(a("textarea", {
              class: "form-control mb-3",
              "onUpdate:modelValue": t[0] || (t[0] = (c) => e.owner.notes = c),
              rows: "4",
              maxlength: "1000"
            }, null, 512), [
              [_e, e.owner.notes]
            ]),
            a("button", {
              type: "button",
              onClick: t[1] || (t[1] = (...c) => e.saveNotes && e.saveNotes(...c)),
              disabled: e.isBusy,
              class: "btn btn-lava"
            }, "Save Note", 8, eKt)
          ])) : P("", !0)
        ])
      ])
    ], 64)) : (p(), h("div", GQt, [
      N(o, {
        speed: 2,
        height: 114
      })
    ]))
  ]);
}
const bds = /* @__PURE__ */ Ae(zQt, [["render", tKt]]), sKt = me({
  components: {},
  data() {
    return {
      pm_investment_props: void 0,
      leadsInArea: void 0,
      unharvestedLeadsInArea: void 0
    };
  },
  async created() {
    await this.loadData();
  },
  mounted() {
  },
  computed: {
    pmInvestmentProps() {
      return this.pm_investment_props ? this.number(this.pm_investment_props) : "-";
    },
    leadsInPmArea() {
      return this.leadsInArea ? this.number(this.leadsInArea) : "-";
    },
    unharvestedLeadsInPmArea() {
      return this.unharvestedLeadsInArea ? this.number(this.unharvestedLeadsInArea) : "-";
    }
  },
  methods: {
    number: Ve,
    async loadData() {
      try {
        const e = await W.api.portfolioFinder.getStats();
        console.log("getStats", e), this.pm_investment_props = e.data.investorOwned, this.leadsInArea = e.data.leadsInArea, this.unharvestedLeadsInArea = e.data.unharvestedLeadsInArea;
      } catch (e) {
        Se(e);
      }
    }
  }
}), aKt = { class: "card shadow bg-alice" }, nKt = { class: "card-body d-flex justify-content-xl-around text-center gap-2 flex-row" }, rKt = { class: "fs-5 fw-bold d-block m-0" }, oKt = { class: "fs-5 fw-bold d-block m-0" }, iKt = { class: "fs-5 fw-bold d-block m-0" };
function lKt(e, t, s, n, r, i) {
  return p(), h("div", aKt, [
    a("div", nKt, [
      a("div", null, [
        t[0] || (t[0] = a("span", { class: "text-secondary text-uppercase small" }, [
          y("Investment Properties"),
          a("br", { class: "d-block d-sm-none" }),
          y(" in Territory")
        ], -1)),
        a("span", rKt, g(e.pmInvestmentProps), 1)
      ]),
      a("div", null, [
        t[1] || (t[1] = a("span", { class: "text-secondary text-uppercase small" }, "Targets in Territory", -1)),
        a("span", oKt, g(e.leadsInPmArea), 1)
      ]),
      a("div", null, [
        t[2] || (t[2] = a("span", { class: "text-secondary text-uppercase small" }, "Unharvested Targets", -1)),
        a("span", iKt, g(e.unharvestedLeadsInPmArea), 1)
      ])
    ]),
    t[3] || (t[3] = a("div", { class: "card-footer bg-alice text-center small text-body-secondary" }, " Territory statistics are based on Single Family property types. ", -1))
  ]);
}
const Ads = /* @__PURE__ */ Ae(sKt, [["render", lKt]]), dKt = me({
  components: {
    DataTable: yn,
    Column: bn
  },
  data() {
    return {
      agents: [],
      loading: !0,
      totalRecords: 0
    };
  },
  created() {
  },
  mounted() {
    this.loadLazyData();
  },
  methods: {
    number: Ve,
    async loadLazyData(e = 1, t = 25) {
      this.loading = !0;
      try {
        const s = await W.api.portfolioFinder.getInvestmentManagers();
        if (s.data.status != de.Success)
          throw new Error(s.data.message);
        this.agents.length = 0, this.agents.push(...s.data.results), this.totalRecords = this.agents.length;
      } catch (s) {
        Se(s);
      }
      this.loading = !1;
    },
    async onPage(e) {
      await this.loadLazyData(e.page + 1, e.rows);
    }
  }
}), cKt = { class: "card shadow-sm" };
function uKt(e, t, s, n, r, i) {
  const o = pe("Column"), l = pe("data-table");
  return p(), h("div", cKt, [
    N(l, {
      value: e.agents,
      lazy: !0,
      paginator: !0,
      class: "p-datatable-agents",
      rows: 25,
      dataKey: "agentId",
      totalRecords: e.totalRecords,
      loading: e.loading,
      paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
      rowsPerPageOptions: [10, 25, 50],
      currentPageReportTemplate: "Showing {first} to {last} of {totalRecords} entries",
      onPage: t[0] || (t[0] = (d) => e.onPage(d)),
      onSort: t[1] || (t[1] = (d) => e.onSort(d))
    }, {
      empty: ve(() => t[2] || (t[2] = [
        y(" No Investor Agents found. ")
      ])),
      loading: ve(() => t[3] || (t[3] = [
        a("div", { class: "bg-accentgreenblue rounded-pill px-3 py-1 text-white" }, [
          a("span", {
            class: "spinner-border spinner-border-sm me-2",
            role: "status",
            "aria-hidden": "false"
          }),
          y("Loading your Investor Agents data. Please wait... ")
        ], -1)
      ])),
      default: ve(() => [
        N(o, {
          field: "firstname",
          header: "Name"
        }, {
          body: ve((d) => [
            y(g(d.data.firstName) + " " + g(d.data.lastName), 1)
          ]),
          _: 1
        }),
        N(o, {
          field: "broker",
          header: "Broker"
        }),
        N(o, {
          field: "office",
          header: "Office #"
        }),
        N(o, {
          field: "cell",
          header: "Cell #"
        }),
        N(o, {
          field: "total",
          header: "Listings"
        }, {
          body: ve((d) => [
            y(g(e.number(d.data.total)), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["value", "totalRecords", "loading"])
  ]);
}
const wds = /* @__PURE__ */ Ae(dKt, [["render", uKt], ["__scopeId", "data-v-343dae6d"]]), pKt = me({
  components: {
    DataTable: yn,
    Column: bn
  },
  data() {
    return {
      owners: [],
      loading: !0,
      totalRecords: 0
    };
  },
  created() {
  },
  mounted() {
    this.loadIgnored();
  },
  methods: {
    number: Ve,
    async loadIgnored(e = 1, t = 25) {
      this.loading = !0;
      try {
        const s = await W.api.portfolioFinder.getIgnored(e, t);
        if (s.data.status != de.Success)
          throw new Le(s);
        this.owners.length = 0, this.owners.push(...s.data.results), this.totalRecords = s.data.total;
      } catch (s) {
        Se(s);
      }
      this.loading = !1;
    },
    async onPage(e) {
      await this.loadIgnored(e.page + 1, e.rows);
    },
    async showOwner(e) {
      try {
        console.log("ignoreOwner", e);
        const t = await W.api.portfolioFinder.removeOwnerIgnore(e.id);
        if (t.data.status != de.Success)
          throw new Le(t);
        this.owners = this.owners.filter((s) => s.id !== e.id);
      } catch (t) {
        Se(t);
      }
    }
  }
}), hKt = { class: "card shadow-sm" }, mKt = ["href"], fKt = { class: "small" }, gKt = ["onClick"];
function vKt(e, t, s, n, r, i) {
  const o = pe("Column"), l = pe("data-table");
  return p(), h("div", hKt, [
    N(l, {
      value: e.owners,
      lazy: !0,
      paginator: !0,
      class: "p-datatable-owners",
      rows: 25,
      dataKey: "OwnerId",
      totalRecords: e.totalRecords,
      loading: e.loading,
      paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
      rowsPerPageOptions: [10, 25, 50],
      currentPageReportTemplate: "Showing {first} to {last} of {totalRecords} entries",
      onPage: t[0] || (t[0] = (d) => e.onPage(d)),
      onSort: t[1] || (t[1] = (d) => e.onSort(d))
    }, {
      empty: ve(() => t[2] || (t[2] = [
        y(" No ignored targets found. ")
      ])),
      loading: ve(() => t[3] || (t[3] = [
        a("div", { class: "bg-accentgreenblue rounded-pill px-3 py-1 text-white" }, [
          a("span", {
            class: "spinner-border spinner-border-sm me-2",
            role: "status",
            "aria-hidden": "false"
          }),
          y(" Loading your ignored targets list. Please wait... ")
        ], -1)
      ])),
      default: ve(() => [
        N(o, {
          field: "OwnerName",
          header: "Target Name"
        }, {
          body: ve((d) => [
            a("a", {
              href: `/portfolio-finder/${d.data.ownerId}`,
              target: "_blank"
            }, g(d.data.leadName), 9, mKt)
          ]),
          _: 1
        }),
        N(o, { header: "Mailing Address" }, {
          body: ve((d) => [
            a("address", fKt, [
              y(g(d.data.street), 1),
              t[4] || (t[4] = a("br", null, null, -1)),
              y(" " + g(d.data.city) + ", " + g(d.data.state) + " " + g(d.data.zip), 1),
              t[5] || (t[5] = a("br", null, null, -1))
            ])
          ]),
          _: 1
        }),
        N(o, {
          field: "broker",
          header: "Recently Used Broker"
        }),
        N(o, {
          field: "agent",
          header: "Agent"
        }),
        N(o, {
          field: "total",
          header: "Qty In Territory"
        }, {
          body: ve((d) => [
            y(g(e.number(d.data.inTerritory)), 1)
          ]),
          _: 1
        }),
        N(o, {
          headerStyle: "width: 4rem; text-align: center",
          bodyStyle: "text-align: center; overflow: visible"
        }, {
          body: ve((d) => [
            a("a", {
              role: "button",
              onClick: (c) => e.showOwner(d.data)
            }, t[6] || (t[6] = [
              a("i", { class: "fa-duotone fa-solid fa-eye" }, null, -1)
            ]), 8, gKt)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["value", "totalRecords", "loading"])
  ]);
}
const Cds = /* @__PURE__ */ Ae(pKt, [["render", vKt], ["__scopeId", "data-v-b5a00ac3"]]), yKt = me({
  components: {
    DataTable: yn,
    Column: bn
  },
  data() {
    return {
      owners: [],
      loading: !0,
      totalRecords: 0
    };
  },
  created() {
  },
  mounted() {
    this.loadLazyData();
  },
  methods: {
    number: Ve,
    async loadLazyData(e = 1, t = 25) {
      this.loading = !0;
      try {
        const s = await W.api.portfolioFinder.getFiduciaryOwners(e, t);
        if (s.data.status != de.Success)
          throw new Error(s.data.message);
        this.owners.length = 0, this.owners.push(...s.data.results), this.totalRecords = s.data.total;
      } catch (s) {
        Se(s);
      }
      this.loading = !1;
    },
    async onPage(e) {
      await this.loadLazyData(e.page + 1, e.rows);
    }
  }
}), bKt = { class: "card shadow-sm" }, AKt = ["href"], wKt = { class: "small" };
function CKt(e, t, s, n, r, i) {
  const o = pe("Column"), l = pe("data-table");
  return p(), h("div", bKt, [
    N(l, {
      value: e.owners,
      lazy: !0,
      paginator: !0,
      class: "p-datatable-owners",
      rows: 25,
      dataKey: "ownerId",
      totalRecords: e.totalRecords,
      loading: e.loading,
      paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
      rowsPerPageOptions: [10, 25, 50],
      currentPageReportTemplate: "Showing {first} to {last} of {totalRecords} entries",
      onPage: t[0] || (t[0] = (d) => e.onPage(d)),
      onSort: t[1] || (t[1] = (d) => e.onSort(d))
    }, {
      empty: ve(() => t[2] || (t[2] = [
        y(" No fiduciary targets found. ")
      ])),
      loading: ve(() => t[3] || (t[3] = [
        a("div", { class: "bg-accentgreenblue rounded-pill px-3 py-1 text-white" }, [
          a("span", {
            class: "spinner-border spinner-border-sm me-2",
            role: "status",
            "aria-hidden": "false"
          }),
          y(" Loading your fiduciary targets. Please wait... ")
        ], -1)
      ])),
      default: ve(() => [
        N(o, {
          field: "OwnerName",
          header: "Target Name"
        }, {
          body: ve((d) => [
            a("a", {
              href: `/portfolio-finder/${d.data.ownerId}`,
              target: "_blank"
            }, g(d.data.leadName), 9, AKt)
          ]),
          _: 1
        }),
        N(o, { header: "Mailing Address" }, {
          body: ve((d) => [
            a("address", wKt, [
              y(g(d.data.street), 1),
              t[4] || (t[4] = a("br", null, null, -1)),
              y(" " + g(d.data.city) + ", " + g(d.data.state) + " " + g(d.data.zip), 1),
              t[5] || (t[5] = a("br", null, null, -1))
            ])
          ]),
          _: 1
        }),
        N(o, {
          field: "broker",
          header: "Recently Used Broker"
        }),
        N(o, {
          field: "agent",
          header: "Agent"
        }),
        N(o, {
          field: "total",
          header: "Qty In Territory"
        }, {
          body: ve((d) => [
            y(g(e.number(d.data.inTerritory)), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["value", "totalRecords", "loading"])
  ]);
}
const Sds = /* @__PURE__ */ Ae(yKt, [["render", CKt], ["__scopeId", "data-v-3650d78a"]]), SKt = me({
  components: {
    DataTable: yn,
    Column: bn
  },
  directives: {
    Tooltip: Wo
  },
  data() {
    return {
      owners: [],
      loading: !1,
      totalRecords: 0,
      skipTracing: !1,
      skipTracingOwner: void 0
    };
  },
  methods: {
    number: Ve,
    async loadFavorites(e = 1, t = 25) {
      this.loading = !0;
      try {
        const s = await W.api.portfolioFinder.getFavorites(e, t);
        if (s.data.status != de.Success)
          throw new Le(s);
        this.owners.length = 0, this.owners.push(...s.data.results), this.totalRecords = s.data.total;
      } catch (s) {
        Se(s);
      }
      this.loading = !1;
    },
    async onPage(e) {
      await this.loadFavorites(e.page + 1, e.rows);
    },
    async removeFavorite(e) {
      try {
        const t = await W.api.portfolioFinder.removeFavoriteOwner(e.id);
        if (t.data.status != de.Success)
          throw new Le(t);
        this.owners = this.owners.filter((s) => s.id !== e.id), wt("Lead has been removed from favorite.");
      } catch (t) {
        Se(t);
      }
    },
    async exportFavorites() {
      try {
        const e = await W.api.portfolioFinder.exportFavorites();
        if (e.data.status != de.Success)
          throw new Le(e);
        window.open(e.data.location, "_blank");
      } catch (e) {
        Se(e);
      }
    },
    async removeAllFavorites() {
      var e;
      try {
        const t = await W.api.portfolioFinder.removeAllFavorite();
        if (t.data.status != de.Success)
          throw new Le(t);
        (e = bootstrap.Modal.getOrCreateInstance(this.$refs.modalDelete)) == null || e.hide(), await this.loadFavorites(), wt("All leads has been removed from favorite.");
      } catch (t) {
        Se(t);
      }
    },
    canSkipTrace(e) {
      return e.skipTracedOn ? ol(e.skipTracedOn, /* @__PURE__ */ new Date()) >= 30 : !0;
    },
    async showConfirmSkipTraceModal(e) {
      var t;
      this.canSkipTrace(e) && (this.skipTracingOwner = e, Go("skip-trace-confirmed-v2") == "true" ? this.skipTraceContact() : (t = bootstrap.Modal.getOrCreateInstance(this.$refs.confirmSkipTraceModal)) == null || t.show());
    },
    async hideConfirmSkipTraceModal() {
      var e;
      this.skipTracingOwner = void 0, (e = bootstrap.Modal.getOrCreateInstance(this.$refs.confirmSkipTraceModal)) == null || e.hide();
    },
    async skipTraceContact() {
      var e;
      try {
        (e = bootstrap.Modal.getOrCreateInstance(this.$refs.confirmSkipTraceModal)) == null || e.hide(), eo("skip-trace-confirmed-v2", !0);
        const t = this.skipTracingOwner;
        this.skipTracingOwner = void 0, this.skipTracing = !0;
        let s = !0;
        t.contactId && (s = !1);
        const n = await W.api.portfolioFinder.skipTraceContact(t.id, t.contactId ?? 1, s);
        if (n.data.status != de.Success)
          throw new Error(n.data.message);
        t.contactId = n.data.contact.id, t.phoneOwner1 = n.data.contact.phone ?? "", t.emailOwner1 = n.data.contact.email ?? "", t.skipTracedOn = n.data.contact.skipTracedOn, !t.phoneOwner1 && !t.emailOwner1 ? Mi("<b>Skip trace found no results.</b><br>If there are multiple recorded owner names, try one of the other names.<br/><br/>(Company names usually will not find results.)") : wt("Skip traced succeeded!");
      } catch (t) {
        Se(t);
      }
      this.skipTracing = !1;
    }
  },
  created() {
  },
  mounted() {
    this.loadFavorites(), document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach((e) => new bootstrap.Tooltip(e));
  }
}), PKt = { class: "d-flex flex-column flex-md-row justify-content-between align-items-center mb-3" }, kKt = { class: "d-flex gap-3" }, EKt = { class: "card shadow-sm" }, IKt = ["href"], TKt = { class: "small" }, OKt = { class: "mb-2" }, RKt = { class: "d-block text-truncate" }, LKt = { key: 0 }, BKt = { class: "fa-duotone fa-solid fa-triangle-exclamation text-warning me-2" }, MKt = { key: 1 }, xKt = { class: "d-block text-truncate" }, FKt = { key: 0 }, VKt = { class: "fa-duotone fa-solid fa-triangle-exclamation text-warning me-2" }, DKt = { key: 1 }, NKt = { class: "d-block text-truncate" }, jKt = { key: 0 }, HKt = { class: "fa-duotone fa-solid fa-triangle-exclamation text-warning me-2" }, UKt = ["disabled", "onClick"], zKt = ["onClick"], WKt = {
  class: "modal fade",
  ref: "modalDelete",
  id: "modalDelete",
  tabindex: "-1",
  "aria-labelledby": "DeleteModal",
  "aria-hidden": "true"
}, GKt = { class: "modal-dialog modal-dialog-centered" }, YKt = { class: "modal-content bg-gradient-alphabet rounded" }, XKt = { class: "modal-body text-center" }, qKt = { class: "d-flex justify-content-center gap-2" }, QKt = {
  class: "modal fade",
  id: "confirmSkipTraceModal",
  ref: "confirmSkipTraceModal",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}, KKt = { class: "modal-dialog modal-dialog-centered" }, ZKt = { class: "modal-content bg-gradient-alphabet rounded" }, JKt = { class: "modal-body text-center px-5 pb-5 pt-4" }, $Kt = { class: "d-flex gap-3 justify-content-center pt-3" }, _Kt = {
  key: 0,
  class: "modal-footer text-center justify-content-center bg-accentgreenblue text-white"
};
function eZt(e, t, s, n, r, i) {
  const o = pe("Column"), l = pe("data-table"), d = Za("tooltip");
  return p(), h(A, null, [
    a("div", PKt, [
      t[8] || (t[8] = a("h1", { class: "fs-3 fw-bold mb-md-0" }, "Favorite Targets", -1)),
      a("div", kKt, [
        a("button", {
          type: "button",
          onClick: t[0] || (t[0] = (...c) => e.exportFavorites && e.exportFavorites(...c)),
          class: "btn btn-outline-eclipse"
        }, t[6] || (t[6] = [
          a("i", { class: "fa-light fa-file-export me-2" }, null, -1),
          y("Export")
        ])),
        t[7] || (t[7] = a("button", {
          type: "button",
          class: "btn btn-outline-danger",
          "data-bs-toggle": "modal",
          "data-bs-target": "#modalDelete"
        }, [
          a("i", { class: "fa-light fa-trash me-2" }),
          y("Delete All")
        ], -1))
      ])
    ]),
    a("div", EKt, [
      N(l, {
        value: e.owners,
        lazy: !0,
        paginator: !0,
        class: "p-datatable-owners",
        rows: 25,
        dataKey: "OwnerId",
        totalRecords: e.totalRecords,
        loading: e.loading,
        paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
        rowsPerPageOptions: [10, 25, 50],
        currentPageReportTemplate: "Showing {first} to {last} of {totalRecords} entries",
        onPage: t[1] || (t[1] = (c) => e.onPage(c)),
        onSort: t[2] || (t[2] = (c) => e.onSort(c))
      }, {
        empty: ve(() => t[9] || (t[9] = [
          y(" No favorite targets yet. ")
        ])),
        loading: ve(() => t[10] || (t[10] = [
          a("div", { class: "bg-accentgreenblue rounded-pill px-3 py-1 text-white" }, [
            a("span", {
              class: "spinner-border spinner-border-sm me-2",
              role: "status",
              "aria-hidden": "false"
            }),
            y("Loading your favorite targets. Please wait... ")
          ], -1)
        ])),
        default: ve(() => [
          N(o, {
            field: "OwnerName",
            header: "Target Name"
          }, {
            body: ve((c) => [
              a("a", {
                href: `/portfolio-finder/${c.data.ownerId}`,
                target: "_blank"
              }, g(c.data.leadName), 9, IKt)
            ]),
            _: 1
          }),
          N(o, { header: "Mailing Address" }, {
            body: ve((c) => [
              a("address", TKt, [
                y(g(c.data.street), 1),
                t[11] || (t[11] = a("br", null, null, -1)),
                y(" " + g(c.data.city) + ", " + g(c.data.state) + " " + g(c.data.zip), 1),
                t[12] || (t[12] = a("br", null, null, -1))
              ])
            ]),
            _: 1
          }),
          N(o, { header: "Contact Info" }, {
            body: ve((c) => [
              a("div", OKt, [
                a("div", RKt, [
                  c.data.emailOwner1 == "" && c.data.phoneOwner1 != "" ? (p(), h("span", LKt, [
                    V(a("i", BKt, null, 512), [
                      [
                        d,
                        "No email information was found via skip trace.",
                        void 0,
                        { top: !0 }
                      ]
                    ]),
                    t[13] || (t[13] = y("No email found"))
                  ])) : P("", !0),
                  c.data.emailOwner1 != "" ? (p(), h("span", MKt, g(c.data.emailOwner1), 1)) : P("", !0)
                ]),
                a("div", xKt, [
                  c.data.phoneOwner1 == "" && c.data.emailOwner1 != "" ? (p(), h("span", FKt, [
                    V(a("i", VKt, null, 512), [
                      [
                        d,
                        "No phone information was found via skip trace.",
                        void 0,
                        { top: !0 }
                      ]
                    ]),
                    t[14] || (t[14] = y("No phone found"))
                  ])) : P("", !0),
                  c.data.phoneOwner1 != "" ? (p(), h("span", DKt, g(c.data.phoneOwner1), 1)) : P("", !0)
                ]),
                a("div", NKt, [
                  c.data.emailOwner1 == "" && c.data.phoneOwner1 == "" && !e.canSkipTrace(c.data) ? (p(), h("span", jKt, [
                    V(a("i", HKt, null, 512), [
                      [
                        d,
                        "No contact information was found via skip trace.",
                        void 0,
                        { top: !0 }
                      ]
                    ]),
                    t[15] || (t[15] = y("No contact info found."))
                  ])) : P("", !0)
                ])
              ]),
              e.canSkipTrace(c.data) ? (p(), h("button", {
                key: 0,
                type: "button",
                class: "btn btn-sm btn-outline-eclipse",
                disabled: e.skipTracing,
                onClick: (u) => e.showConfirmSkipTraceModal(c.data)
              }, "Skip Trace", 8, UKt)) : P("", !0)
            ]),
            _: 1
          }),
          N(o, {
            field: "broker",
            header: "Recently Used Broker"
          }),
          N(o, {
            field: "agent",
            header: "Agent"
          }),
          N(o, {
            field: "total",
            header: "Qty In Territory"
          }, {
            body: ve((c) => [
              y(g(e.number(c.data.inTerritory)), 1)
            ]),
            _: 1
          }),
          N(o, {
            headerStyle: "width: 4rem; text-align: center",
            bodyStyle: "text-align: center; overflow: visible"
          }, {
            body: ve((c) => [
              a("a", {
                role: "button",
                onClick: (u) => e.removeFavorite(c.data),
                class: "text-danger",
                "data-bs-toggle": "tooltip",
                "data-bs-title": "Remove from Favorite Targets"
              }, t[16] || (t[16] = [
                a("i", { class: "fa-light fa-heart-crack" }, null, -1)
              ]), 8, zKt)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["value", "totalRecords", "loading"])
    ]),
    a("div", WKt, [
      a("div", GKt, [
        a("div", YKt, [
          t[20] || (t[20] = a("div", { class: "modal-header border-0 pb-0" }, [
            a("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            })
          ], -1)),
          a("div", XKt, [
            t[18] || (t[18] = a("p", {
              class: "modal-title fw-bold h5",
              id: "DeleteModalLabel"
            }, "Delete All Favorites", -1)),
            t[19] || (t[19] = a("p", { class: "mb-5" }, "Are you sure you want to delete all the favorites?", -1)),
            a("div", qKt, [
              t[17] || (t[17] = a("button", {
                type: "button",
                class: "btn btn-secondary",
                "data-bs-dismiss": "modal"
              }, "Cancel", -1)),
              a("button", {
                type: "button",
                onClick: t[3] || (t[3] = (...c) => e.removeAllFavorites && e.removeAllFavorites(...c)),
                class: "btn btn-danger"
              }, "Delete All")
            ])
          ])
        ])
      ])
    ], 512),
    a("div", QKt, [
      a("div", KKt, [
        a("div", ZKt, [
          t[28] || (t[28] = a("div", { class: "modal-header border-0 mb-0" }, [
            a("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            })
          ], -1)),
          a("div", JKt, [
            t[21] || (t[21] = a("i", { class: "fa-duotone fa-search-location mb-3 fa-2x" }, null, -1)),
            t[22] || (t[22] = a("br", null, null, -1)),
            t[23] || (t[23] = a("b", { class: "fs-5" }, "Skip Trace Fee Acknowledgement", -1)),
            t[24] || (t[24] = a("br", null, null, -1)),
            t[25] || (t[25] = a("br", null, null, -1)),
            t[26] || (t[26] = a("p", null, " By initiating a skip trace, you acknowledge you'll be charged a flat fee of 8 cents if any phone numbers or email addresses are found. If no results are found, you won't be charged. ", -1)),
            a("div", $Kt, [
              a("button", {
                type: "button",
                class: "btn btn-outline-secondary",
                onClick: t[4] || (t[4] = (...c) => e.hideConfirmSkipTraceModal && e.hideConfirmSkipTraceModal(...c))
              }, "Cancel"),
              a("button", {
                type: "button",
                class: "btn btn-lava",
                onClick: t[5] || (t[5] = (...c) => e.skipTraceContact && e.skipTraceContact(...c))
              }, "Confirm")
            ])
          ]),
          e.isBusy ? (p(), h("div", _Kt, t[27] || (t[27] = [
            a("i", { class: "fa-duotone fa-solid fa-spinner-third fa-spin me-2" }, null, -1),
            y("Skip Tracing Contact... ")
          ]))) : P("", !0)
        ])
      ])
    ], 512)
  ], 64);
}
const Pds = /* @__PURE__ */ Ae(SKt, [["render", eZt], ["__scopeId", "data-v-5df57bf3"]]), tZt = me({
  components: {
    DataTable: yn,
    Column: bn
  },
  data() {
    return {
      owners: [],
      loading: !0,
      totalRecords: 0
    };
  },
  created() {
  },
  mounted() {
    this.loadLazyData();
  },
  methods: {
    async loadLazyData(e = 1, t = 25) {
      this.loading = !0;
      try {
        const s = await W.api.portfolioFinder.getLeadCustomOwners(e, t);
        if (s.data.status != de.Success)
          throw new Error(s.data.message);
        this.owners.length = 0, this.owners.push(...s.data.results), this.totalRecords = s.data.total;
      } catch (s) {
        Se(s);
      }
      this.loading = !1;
    },
    async onPage(e) {
      await this.loadLazyData(e.page + 1, e.rows);
    }
  }
}), sZt = { class: "card shadow-sm" }, aZt = ["href"], nZt = { class: "small" };
function rZt(e, t, s, n, r, i) {
  const o = pe("Column"), l = pe("data-table");
  return p(), h("div", sZt, [
    N(l, {
      value: e.owners,
      lazy: !0,
      paginator: !0,
      class: "p-datatable-owners",
      rows: 25,
      dataKey: "ownerId",
      totalRecords: e.totalRecords,
      loading: e.loading,
      paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
      rowsPerPageOptions: [10, 25, 50],
      currentPageReportTemplate: "Showing {first} to {last} of {totalRecords} entries",
      onPage: t[0] || (t[0] = (d) => e.onPage(d)),
      onSort: t[1] || (t[1] = (d) => e.onSort(d))
    }, {
      empty: ve(() => t[2] || (t[2] = [
        y(" No Custom targets found. ")
      ])),
      loading: ve(() => t[3] || (t[3] = [
        a("div", { class: "bg-accentgreenblue rounded-pill px-3 py-1 text-white" }, [
          a("span", {
            class: "spinner-border spinner-border-sm me-2",
            role: "status",
            "aria-hidden": "false"
          }),
          y(" Loading your list of custom targets. Please wait... ")
        ], -1)
      ])),
      default: ve(() => [
        N(o, {
          field: "name",
          header: "Target Name"
        }, {
          body: ve((d) => [
            a("a", {
              href: `/portfolio-finder/${d.data.ownerId}`,
              target: "_blank"
            }, g(d.data.displayName), 9, aZt)
          ]),
          _: 1
        }),
        N(o, {
          field: "FirstName",
          header: "Contact Name"
        }, {
          body: ve((d) => [
            y(g(d.data.firstName) + " " + g(d.data.lastName), 1)
          ]),
          _: 1
        }),
        N(o, { header: "Mailing Address" }, {
          body: ve((d) => [
            a("address", nZt, [
              y(g(d.data.address), 1),
              t[4] || (t[4] = a("br", null, null, -1)),
              y(" " + g(d.data.city) + ", " + g(d.data.state) + " " + g(d.data.zip), 1),
              t[5] || (t[5] = a("br", null, null, -1))
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["value", "totalRecords", "loading"])
  ]);
}
const kds = /* @__PURE__ */ Ae(tZt, [["render", rZt], ["__scopeId", "data-v-68620878"]]), oZt = me({
  components: {
    CodeLoader: pb,
    ContentLoader: Sa
  },
  props: {
    owner: {
      type: Object
    },
    id: String
  },
  emits: [],
  data() {
    return {
      inPmArea: 0,
      investmentHomes: 0,
      annualManagementFees: 0,
      values: {
        singleFamily: {},
        residential24Family: {},
        multifamily: {},
        commercial: {},
        retail: {},
        mobileHomeParks: {},
        rvParksCampground: {},
        selfStorage: {}
      }
    };
  },
  computed: {
    ...q(Ba, ["owner", "ownerLoaded"])
  },
  methods: {
    number: Ve,
    currency: Ze,
    safeCurrency(e) {
      return isNaN(e) == !1 ? e == 0 ? "-" : this.currency(e) : "";
    },
    safeNumber(e) {
      return isNaN(e) == !1 ? this.number(e) : "";
    },
    loadClientValues() {
      W.api.portfolioFinder.getClientValue(this.owner.id, Xt.SingleFamily).then((e) => this.values.singleFamily = e.data), W.api.portfolioFinder.getClientValue(this.owner.id, Xt.Residential24Family).then((e) => this.values.residential24Family = e.data), W.api.portfolioFinder.getClientValue(this.owner.id, Xt.MultiFamily).then((e) => this.values.multifamily = e.data), W.api.portfolioFinder.getClientValue(this.owner.id, Xt.Commercial).then((e) => this.values.commercial = e.data), W.api.portfolioFinder.getClientValue(this.owner.id, Xt.Retail).then((e) => this.values.retail = e.data), W.api.portfolioFinder.getClientValue(this.owner.id, Xt.MobileHomeParks).then((e) => this.values.mobileHomeParks = e.data), W.api.portfolioFinder.getClientValue(this.owner.id, Xt.RvParksCampground).then((e) => this.values.rvParksCampground = e.data), W.api.portfolioFinder.getClientValue(this.owner.id, Xt.SelfStorage).then((e) => this.values.selfStorage = e.data);
    }
  },
  created() {
  },
  mounted() {
    this.ownerLoaded.then(() => this.loadClientValues());
  }
}), iZt = { class: "card shadow-sm client-value" }, lZt = {
  key: 0,
  class: "p-2"
}, dZt = { class: "table table-sm" }, cZt = { class: "text-center" }, uZt = { class: "text-center" }, pZt = { class: "text-center" }, hZt = { class: "text-center" }, mZt = { class: "text-center" }, fZt = { class: "text-center" }, gZt = { class: "text-center" }, vZt = { class: "text-center" }, yZt = { class: "text-center" }, bZt = { class: "text-center" }, AZt = { class: "text-center" }, wZt = { class: "text-center" }, CZt = { class: "text-center" }, SZt = { class: "text-center" }, PZt = { class: "text-center" }, kZt = { class: "text-center" }, EZt = { class: "text-center" }, IZt = { class: "text-center" }, TZt = { class: "text-center" }, OZt = { class: "text-center" }, RZt = { class: "text-center" }, LZt = { class: "text-center" }, BZt = { class: "text-center" }, MZt = { class: "text-center" };
function xZt(e, t, s, n, r, i) {
  var l, d, c, u, m, f, v, b, w, S, I, T, x, k, C, O, E, B, M, R, F, L, j, H;
  const o = pe("content-loader");
  return p(), h("div", iZt, [
    e.annualManagementFees == null ? (p(), h("div", lZt, [
      N(o, {
        width: 280,
        height: 109,
        speed: 2
      }, {
        default: ve(() => t[0] || (t[0] = [
          a("rect", {
            x: "0",
            y: "0",
            rx: "3",
            ry: "3",
            width: "60",
            height: "6"
          }, null, -1),
          a("rect", {
            x: "73",
            y: "0",
            rx: "3",
            ry: "3",
            width: "220",
            height: "6"
          }, null, -1),
          a("rect", {
            x: "0",
            y: "14",
            rx: "3",
            ry: "3",
            width: "60",
            height: "6"
          }, null, -1),
          a("rect", {
            x: "73",
            y: "14",
            rx: "3",
            ry: "3",
            width: "220",
            height: "6"
          }, null, -1),
          a("rect", {
            x: "0",
            y: "28",
            rx: "3",
            ry: "3",
            width: "60",
            height: "6"
          }, null, -1),
          a("rect", {
            x: "73",
            y: "28",
            rx: "3",
            ry: "3",
            width: "220",
            height: "6"
          }, null, -1),
          a("rect", {
            x: "0",
            y: "42",
            rx: "3",
            ry: "3",
            width: "60",
            height: "6"
          }, null, -1),
          a("rect", {
            x: "73",
            y: "42",
            rx: "3",
            ry: "3",
            width: "220",
            height: "6"
          }, null, -1)
        ])),
        _: 1,
        __: [0]
      })
    ])) : (p(), h(A, { key: 1 }, [
      t[10] || (t[10] = a("div", { class: "px-3 pt-2" }, [
        a("p", { class: "fs-6 fw-bold" }, [
          a("span", { class: "text-secondary text-xsmall" }, "TARGET VALUE")
        ])
      ], -1)),
      a("table", dZt, [
        t[9] || (t[9] = a("thead", null, [
          a("tr", null, [
            a("th", { class: "border-top-0" }),
            a("th", { class: "border-top-0" }, "IN PM AREA"),
            a("th", { class: "border-top-0" }, "AVG Rental Rate"),
            a("th", { class: "border-top-0" }, "Annual MGMT Value")
          ])
        ], -1)),
        a("tbody", null, [
          a("tr", null, [
            t[1] || (t[1] = a("td", null, "Single Family", -1)),
            a("td", cZt, g(e.safeNumber((l = e.values.singleFamily) == null ? void 0 : l.inPmArea)), 1),
            a("td", uZt, g(e.safeCurrency((d = e.values.singleFamily) == null ? void 0 : d.avgRentalRate)), 1),
            a("td", pZt, g(e.safeCurrency((c = e.values.singleFamily) == null ? void 0 : c.annualManagementFees)), 1)
          ]),
          a("tr", null, [
            t[2] || (t[2] = a("td", null, "2-4 Family", -1)),
            a("td", hZt, g(e.safeNumber((u = e.values.residential24Family) == null ? void 0 : u.inPmArea)), 1),
            a("td", mZt, g(e.safeCurrency((m = e.values.residential24Family) == null ? void 0 : m.avgRentalRate)), 1),
            a("td", fZt, g(e.safeCurrency((f = e.values.residential24Family) == null ? void 0 : f.annualManagementFees)), 1)
          ]),
          a("tr", null, [
            t[3] || (t[3] = a("td", null, "Multifamily", -1)),
            a("td", gZt, g(e.safeNumber((v = e.values.multifamily) == null ? void 0 : v.inPmArea)), 1),
            a("td", vZt, g(e.safeCurrency((b = e.values.multifamily) == null ? void 0 : b.avgRentalRate)), 1),
            a("td", yZt, g(e.safeCurrency((w = e.values.multifamily) == null ? void 0 : w.annualManagementFees)), 1)
          ]),
          a("tr", null, [
            t[4] || (t[4] = a("td", null, "Commercial", -1)),
            a("td", bZt, g(e.safeNumber((S = e.values.commercial) == null ? void 0 : S.inPmArea)), 1),
            a("td", AZt, g(e.safeCurrency((I = e.values.commercial) == null ? void 0 : I.avgRentalRate)), 1),
            a("td", wZt, g(e.safeCurrency((T = e.values.commercial) == null ? void 0 : T.annualManagementFees)), 1)
          ]),
          a("tr", null, [
            t[5] || (t[5] = a("td", null, "Retail", -1)),
            a("td", CZt, g(e.safeNumber((x = e.values.retail) == null ? void 0 : x.inPmArea)), 1),
            a("td", SZt, g(e.safeCurrency((k = e.values.retail) == null ? void 0 : k.avgRentalRate)), 1),
            a("td", PZt, g(e.safeCurrency((C = e.values.retail) == null ? void 0 : C.annualManagementFees)), 1)
          ]),
          a("tr", null, [
            t[6] || (t[6] = a("td", null, "Mobile Home Parks", -1)),
            a("td", kZt, g(e.safeNumber((O = e.values.mobileHomeParks) == null ? void 0 : O.inPmArea)), 1),
            a("td", EZt, g(e.safeCurrency((E = e.values.mobileHomeParks) == null ? void 0 : E.avgRentalRate)), 1),
            a("td", IZt, g(e.safeCurrency((B = e.values.mobileHomeParks) == null ? void 0 : B.annualManagementFees)), 1)
          ]),
          a("tr", null, [
            t[7] || (t[7] = a("td", null, "RV Parks/Campgrounds", -1)),
            a("td", TZt, g(e.safeNumber((M = e.values.rvParksCampground) == null ? void 0 : M.inPmArea)), 1),
            a("td", OZt, g(e.safeCurrency((R = e.values.rvParksCampground) == null ? void 0 : R.avgRentalRate)), 1),
            a("td", RZt, g(e.safeCurrency((F = e.values.rvParksCampground) == null ? void 0 : F.annualManagementFees)), 1)
          ]),
          a("tr", null, [
            t[8] || (t[8] = a("td", null, "Self Storage", -1)),
            a("td", LZt, g(e.safeNumber((L = e.values.selfStorage) == null ? void 0 : L.inPmArea)), 1),
            a("td", BZt, g(e.safeCurrency((j = e.values.selfStorage) == null ? void 0 : j.avgRentalRate)), 1),
            a("td", MZt, g(e.safeCurrency((H = e.values.selfStorage) == null ? void 0 : H.annualManagementFees)), 1)
          ])
        ])
      ])
    ], 64))
  ]);
}
const Eds = /* @__PURE__ */ Ae(oZt, [["render", xZt]]), FZt = me({
  data() {
    return {};
  },
  methods: {
    toggleSale(e) {
      $("#toggleSale")[0].checked == !0 ? this.showMap(e) : ($("#salesList").show(), $("#salesMap").hide());
    },
    showMap(e) {
      $("#salesMap").show(), $("#salesList").hide();
    }
  },
  mounted() {
    $(document).on("click", "#toggleSale", this.toggleSale);
  }
});
function VZt(e, t, s, n, r, i) {
  return p(), h("div", null, t[0] || (t[0] = [
    a("div", {
      style: { height: "200px" },
      class: "bg-light mb-4"
    }, " hero banner ", -1),
    a("div", { class: "container py-5" }, [
      a("div", { class: "row" }, [
        a("div", { class: "col" }, [
          a("div", { class: "card shadow-sm mb-3" }, [
            a("div", { class: "card-body d-flex align-items-center" }, [
              a("div", { class: "bg-light p-5 rounded-circle mr-3 flex-shrink-0" }),
              a("div", { class: "flex-grow-1" }, [
                a("b", null, "Name Last Name"),
                a("br"),
                y(" Ultimate Real Estate Services ")
              ])
            ])
          ]),
          a("div", { class: "card shadow-sm" }, [
            a("nav", null, [
              a("div", {
                class: "nav nav-tabs",
                id: "nav-tab",
                role: "tablist"
              }, [
                a("a", {
                  class: "nav-link active",
                  id: "nav-sale-tab",
                  "data-bs-toggle": "tab",
                  href: "#nav-sale",
                  role: "tab",
                  "aria-controls": "nav-sale",
                  "aria-selected": "true"
                }, "Homes for sale"),
                a("a", {
                  class: "nav-link",
                  id: "nav-lease-tab",
                  "data-bs-toggle": "tab",
                  href: "#nav-lease",
                  role: "tab",
                  "aria-controls": "nav-lease",
                  "aria-selected": "false"
                }, "Homes for lease")
              ])
            ]),
            a("div", {
              class: "tab-content",
              id: "nav-tabContent"
            }, [
              a("div", {
                class: "tab-pane fade show active",
                id: "nav-sale",
                role: "tabpanel",
                "aria-labelledby": "nav-sale-tab"
              }, [
                a("div", { class: "p-4" }, [
                  a("div", { class: "d-flex justify-content-between" }, [
                    a("div", { class: "font-weight-bold" }, "Properties listed for sale"),
                    a("div", { class: "mb-3" }, [
                      a("div", { class: "custom-control custom-switch" }, [
                        a("input", {
                          type: "checkbox",
                          class: "custom-control-input",
                          id: "toggleSale"
                        }),
                        a("label", {
                          class: "custom-control-label",
                          for: "toggleSale"
                        }, "Map View")
                      ])
                    ])
                  ]),
                  a("div", {
                    id: "salesMap",
                    class: "mb-3 bg-light rounded",
                    style: { height: "400px", display: "none" }
                  }),
                  a("ul", {
                    id: "salesList",
                    class: "list-unstyled"
                  }, [
                    a("li", null, "Property 1"),
                    a("li", null, "Property 2"),
                    a("li", null, "Property 3"),
                    a("li", null, "Property 4"),
                    a("li", null, "Property 5")
                  ])
                ])
              ]),
              a("div", {
                class: "tab-pane fade",
                id: "nav-lease",
                role: "tabpanel",
                "aria-labelledby": "nav-lease-tab"
              }, [
                a("div", { class: "p-4" }, [
                  a("div", { class: "d-flex justify-content-between" }, [
                    a("div", { class: "font-weight-bold" }, "Owner addresses"),
                    a("div", { class: "mb-3" }, [
                      a("div", { class: "custom-control custom-switch" }, [
                        a("input", {
                          type: "checkbox",
                          class: "custom-control-input",
                          id: "toggleSale"
                        }),
                        a("label", {
                          class: "custom-control-label",
                          for: "toggleSale"
                        }, "Map View")
                      ])
                    ])
                  ]),
                  a("div", {
                    id: "leaseMap",
                    class: "mb-3 bg-light rounded",
                    style: { height: "400px", display: "none" }
                  }),
                  a("ul", {
                    id: "leaseList",
                    class: "list-unstyled"
                  }, [
                    a("li", null, "Property 1"),
                    a("li", null, "Property 2"),
                    a("li", null, "Property 3"),
                    a("li", null, "Property 4"),
                    a("li", null, "Property 5")
                  ])
                ])
              ])
            ])
          ])
        ]),
        a("div", { class: "col-md-4" }, [
          a("div", { class: "card shadow-sm mb-3" }, [
            a("div", { class: "card-body" }, [
              a("p", null, [
                a("b", null, "Contact details")
              ]),
              a("div", { class: "d-flex align-items-center mb-2" }, [
                a("i", { class: "fal fa-mobile mr-2 flex-shrink-0" }),
                a("div", { class: "flex-grow-1" }, " (999) 999-9999 ")
              ]),
              a("div", { class: "d-flex align-items-center" }, [
                a("i", { class: "fal fa-starfighter mr-2 flex-shrink-0" }),
                a("div", { class: "flex-grow-1" }, " other contact data ")
              ])
            ]),
            a("div", { class: "card-body border-top" }, " This is the address "),
            a("div", { class: "card-footer bg-white" }, [
              a("a", { href: "#" }, [
                a("i", { class: "fal fa-share-alt mr-2" }),
                y(" Share profile ")
              ])
            ])
          ]),
          a("div", { class: "card shadow-sm" }, [
            a("div", { class: "card-header" }, " Owners they have worked with "),
            a("ul", { class: "list-group list-group-flush" }, [
              a("li", { class: "list-group-item" }, "Owner 1"),
              a("li", { class: "list-group-item" }, "Owner 2"),
              a("li", { class: "list-group-item" }, "Owner 3"),
              a("li", { class: "list-group-item" }, "Owner 4"),
              a("li", { class: "list-group-item" }, "Owner 5")
            ])
          ])
        ])
      ])
    ], -1)
  ]));
}
const Ids = /* @__PURE__ */ Ae(FZt, [["render", VZt]]), DZt = me({
  name: "ActiveCampaignCRM",
  props: {
    owner: Object,
    leadName: String,
    id: String,
    annualRevenue: Number,
    assignTo: String
  },
  emits: [
    "interface",
    "update:assignTo"
  ],
  data() {
    return {
      isLoading: !0,
      crm_users: [],
      leadStatuses: {},
      campaigns: [],
      assign_to: "",
      crm_lead_status: "",
      crm_campaign: ""
    };
  },
  computed: {
    inCRM() {
      return this.owner != null && this.owner.crmId != null && this.owner.crmId != "";
    },
    crmButtonStyles() {
      return {
        "btn-warning": this.inCRM,
        "btn-success": !this.inCRM
      };
    }
  },
  methods: {
    advertiseInterface() {
      this.$emit("interface", {
        updateLead: this.updateLead,
        createContact: this.createContact
      });
    },
    async loadLead() {
      var e, t, s, n;
      try {
        this.isLoading = !0;
        const r = await W.api.crm.getSettings(bt.ActiveCampaign);
        if (r.data.status != de.Success)
          throw new Le(r);
        if (this.assign_to != ((e = r.data.settings) == null ? void 0 : e.defaultOwnerAssignee) && (this.assign_to = ((t = r.data.settings) == null ? void 0 : t.defaultOwnerAssignee) ?? void 0, this.$emit("update:assignTo", this.assign_to)), this.crm_lead_status = r.data.settings.defaultOwnerLeadStatus, this.crm_campaign = r.data.settings.defaultOwnerCampaign, (s = this.owner) != null && s.crmId)
          try {
            const i = await W.api.crm.getLead(bt.ActiveCampaign, this.owner.id);
            if (((n = i.data) == null ? void 0 : n.lead) != null)
              this.assign_to != i.data.lead.assignId && (this.assign_to = i.data.lead.assignId, this.$emit("update:assignTo", this.assign_to)), this.crm_lead_status = i.data.lead.leadStatus;
            else {
              let o = "Lead not found.<br /><br />Please login to your CRM and verify the lead still exists for the selected pipeline. Saving the lead will cause the lead to be recreated if it does not exist, or moved to the selected pipeline.", l = new Cs("ActiveCampaign Error", o);
              l.stay = !0, Ss(l);
            }
          } catch (i) {
            let o = new Cs("ActiveCampaign retrieve lead error", i.message);
            o.stay = !0, Ss(o);
          }
      } catch (r) {
        let i = new Cs("Error", r.message);
        i.stay = !0, Ss(i);
      }
      this.isLoading = !1;
    },
    async loadCrmUsers() {
      this.crm_users.length = 0;
      try {
        const e = await W.api.crm.getUsers(bt.ActiveCampaign);
        if (e.data.status != de.Success)
          throw new Le(e);
        this.crm_users.push(...e.data.results);
      } catch (e) {
        let t = new Cs("ActiveCampaign List Users Error", e.message);
        t.stay = !0, Ss(t);
      }
    },
    async loadCampaigns() {
    },
    async loadStatuses() {
    },
    async updateLead() {
      console.log("updateLead"), this.inCRM && await this.createLead();
    },
    async createLead() {
      console.log("createLead");
      let e = !1;
      if (!this.assign_to) {
        let t = new Cs("Error", "Please choose a user to assign the lead to.");
        Ss(t), e = !0;
      }
      if (!e) {
        this.isLoading = !0;
        try {
          const t = await W.api.leads.setName(this.owner.id, this.leadName);
          if (t.data.status != de.Success)
            throw new Le(t);
          const s = {
            lead: {
              crmId: this.owner.crmId,
              assignId: this.assign_to,
              //company: this.owner.comp,
              firstName: this.owner.firstName,
              lastName: this.owner.lastName,
              addressStreet: this.owner.address,
              addressCity: this.owner.city,
              addressState: this.owner.state,
              addressZIP: this.owner.zip,
              annualRevenue: this.annualRevenue,
              leadStatus: this.crm_lead_status,
              campaign: this.crm_campaign
            }
          }, n = await W.api.crm.createLead(bt.ActiveCampaign, this.owner.id, s);
          if (n.data.status != de.Success)
            throw new Le(n);
          if (this.owner.crmId) {
            let r = new Cs("CRM Update", "Lead updated successfully!", fn.success);
            Ss(r);
          } else {
            let r = new Cs("CRM Create", "Lead created successfully!", fn.success);
            Ss(r);
          }
          this.owner.crmId = n.data.lead.crmId;
        } catch (t) {
          let s = new Cs("ActiveCampaign create lead error", t.message);
          s.stay = !0, Ss(s);
        }
        this.isLoading = !1;
      }
    },
    async createContact(e, t, s) {
      console.log("ActiveCampaign.createContact", e, t);
      let n = !1;
      if (!this.assign_to) {
        let i = new Cs("Error", "Please choose a user to assign the lead to.");
        Ss(i), n = !0;
      }
      if (!n) {
        this.isLoading = !0;
        try {
          let o = (await W.api.leads.getContact(this.owner.id, e, t)).data.contact;
          const l = {
            lead: {
              crmId: o.crmId,
              assignId: this.assign_to,
              //company: this.owner.comp,
              firstName: o.firstName,
              lastName: o.lastName,
              addressStreet: this.owner.address,
              addressCity: this.owner.city,
              addressState: this.owner.state,
              addressZIP: this.owner.zip,
              phone: o.phone,
              cell: o.cell,
              email: o.email,
              annualRevenue: this.annualRevenue,
              leadStatus: this.crm_lead_status,
              campaign: this.crm_campaign
            }
          }, d = await W.api.crm.createLead(bt.ActiveCampaign, this.owner.id, l);
          if (d.data.status != de.Success)
            throw new Le(d);
          const c = d.data.lead.crmId;
          if (o.crmId) {
            let u = new Cs("CRM Update", "Lead contact updated successfully!", fn.success);
            Ss(u);
          } else {
            let u = new Cs("CRM Create", "Lead contact created successfully!", fn.success);
            Ss(u);
          }
          o.crmId = c;
          var r = await W.api.leads.updateContact(this.owner.id, o);
          o = r.data.contact, this.isLoading = !1, s(o);
        } catch (i) {
          let o = new Cs("ActiveCampaign create lead error", i.message);
          o.stay = !0, Ss(o);
        }
        this.isLoading = !1;
      }
    }
  },
  watch: {
    owner: {
      async handler(e, t) {
        console.log("watch.owner", e, t), this.loadLead();
      }
    },
    assign_to: {
      async handler(e, t) {
        this.assignTo != e && this.$emit("update:assignTo", this.assign_to);
      }
    }
  },
  mounted() {
    this.advertiseInterface(), this.loadCrmUsers().then(this.loadCampaigns).then(this.loadStatuses);
  },
  created() {
  }
}), NZt = { class: "card-body" }, jZt = { class: "row row-cols-lg-auto g-2 g-md-3" }, HZt = { class: "col-12 d-flex align-items-center border-end flex-fill justify-content-center" }, UZt = { class: "col-12 flex-fill" }, zZt = ["disabled"], WZt = ["value"];
function GZt(e, t, s, n, r, i) {
  return p(), h("div", NZt, [
    a("div", jZt, [
      a("div", HZt, [
        t[3] || (t[3] = a("img", {
          src: CI,
          class: "img-fluid",
          alt: "Active Campaign",
          title: "Active Campaign",
          width: "150"
        }, null, -1)),
        e.inCRM ? (p(), h(A, { key: 0 }, [
          t[1] || (t[1] = a("br", null, null, -1)),
          t[2] || (t[2] = a("i", {
            class: "fa-duotone fa-user-check text-success ms-2",
            title: "Lead is in CRM"
          }, null, -1))
        ], 64)) : P("", !0)
      ]),
      a("div", UZt, [
        t[5] || (t[5] = a("label", { class: "form-label" }, "Assignee", -1)),
        V(a("select", {
          disabled: e.isLoading || !e.owner || e.crm_users.length == 0,
          "onUpdate:modelValue": t[0] || (t[0] = (o) => e.assign_to = o),
          class: "form-select"
        }, [
          t[4] || (t[4] = a("option", {
            disabled: "",
            value: "",
            selected: ""
          }, "Please select one", -1)),
          (p(!0), h(A, null, D(e.crm_users, (o) => (p(), h("option", {
            value: o.id,
            key: o.id
          }, g(o.name), 9, WZt))), 128))
        ], 8, zZt), [
          [We, e.assign_to]
        ])
      ])
    ])
  ]);
}
const Tds = /* @__PURE__ */ Ae(DZt, [["render", GZt]]), YZt = me({
  name: "ZohoCRM",
  props: {
    owner: Object,
    leadName: String,
    id: String,
    annualRevenue: Number,
    assignTo: String
  },
  emits: [
    "interface",
    "update:assignTo"
  ],
  data() {
    return {
      isLoading: !0,
      crm_users: [],
      leadStatuses: {},
      campaigns: [],
      assign_to: "",
      crm_lead_status: "",
      crm_campaign: ""
    };
  },
  computed: {
    inCRM() {
      return this.owner != null && this.owner.crmId != null && this.owner.crmId != "";
    },
    crmButtonStyles() {
      return {
        "btn-warning": this.inCRM,
        "btn-success": !this.inCRM
      };
    }
  },
  methods: {
    advertiseInterface() {
      this.$emit("interface", {
        updateLead: this.updateLead,
        createContact: this.createContact
      });
    },
    async loadLead() {
      var e;
      try {
        this.isLoading = !0;
        const t = await W.api.crm.getSettings(bt.Zoho);
        if (t.data.status != de.Success)
          throw new Error(t.data.message);
        if (this.assign_to != t.data.settings.defaultOwnerAssignee && (this.assign_to = t.data.settings.defaultOwnerAssignee, this.$emit("update:assignTo", this.assign_to)), this.crm_lead_status = t.data.settings.defaultOwnerLeadStatus, this.crm_campaign = t.data.settings.defaultOwnerCampaign, this.owner.crmId)
          try {
            const s = await W.api.crm.getLead(bt.Zoho, this.owner.id);
            if (((e = s.data) == null ? void 0 : e.lead) != null)
              this.assign_to != s.data.lead.assignId && (this.assign_to = s.data.lead.assignId, this.$emit("update:assignTo", this.assign_to)), this.crm_lead_status = s.data.lead.leadStatus;
            else {
              let n = "Lead not found.<br /><br />Please login to your CRM and verify the lead still exists for the selected pipeline. Saving the lead will cause the lead to be recreated if it does not exist, or moved to the selected pipeline.", r = new Cs("Zoho Error", n);
              r.stay = !0, Ss(r);
            }
          } catch (s) {
            let n = new Cs("Zoho retrieve lead error", s.message);
            n.stay = !0, Ss(n);
          }
      } catch (t) {
        let s = new Cs("Error", t.message);
        s.stay = !0, Ss(s);
      }
      this.isLoading = !1;
    },
    async loadCrmUsers() {
      this.crm_users.length = 0;
      try {
        const e = await W.api.crm.getUsers(bt.Zoho);
        if (e.data.status != de.Success)
          throw new Error(e.data.message);
        this.crm_users.push(...e.data.results);
      } catch (e) {
        let t = new Cs("Zoho List Users Error", e.message);
        t.stay = !0, Ss(t);
      }
    },
    async loadCampaigns() {
      this.isLoading = !0, this.campaigns.length = 0;
      try {
        const e = await W.api.crm.getCampaigns(bt.Zoho);
        if (e.data.status != de.Success)
          throw new Error(e.data.message);
        this.campaigns.push(...e.data.campaigns);
      } catch (e) {
        let t = new Cs("Zoho List Campaigns Error", e.message);
        t.stay = !0, Ss(t);
      }
      this.isLoading = !1;
    },
    async loadStatuses() {
      this.isLoading = !0;
      try {
        const e = await W.api.crm.getFieldOptions(bt.Zoho, "Lead_Status");
        this.leadStatuses = e.data.options;
      } catch (e) {
        let t = new Cs("Zoho List Statuses Error", e.message);
        t.stay = !0, Ss(t);
      }
      this.isLoading = !1;
    },
    async updateLead() {
      console.log("updateLead"), this.inCRM && await this.createLead();
    },
    async createLead() {
      console.log("createLead");
      let e = !1;
      if (!this.assign_to) {
        let t = new Cs("Error", "Please choose a user to assign the lead to.");
        Ss(t), e = !0;
      }
      if (!e) {
        this.isLoading = !0;
        try {
          const t = await W.api.leads.setName(this.id, this.leadName);
          if (t.data.status != de.Success)
            throw new Le(t);
          const s = {
            lead: {
              crmId: this.owner.crmId,
              assignId: this.assign_to,
              //company: this.owner.comp,
              firstName: this.owner.firstName,
              lastName: this.owner.lastName,
              addressStreet: this.owner.address,
              addressCity: this.owner.city,
              addressState: this.owner.state,
              addressZIP: this.owner.zip,
              annualRevenue: this.annualRevenue,
              leadStatus: this.crm_lead_status,
              campaign: this.crm_campaign
            }
          }, n = await W.api.crm.createLead(bt.Zoho, this.owner.id, s);
          if (n.data.status != de.Success)
            throw new Le(n);
          if (this.owner.crmId) {
            let r = new Cs("CRM Update", "Lead updated successfully!", fn.success);
            Ss(r);
          } else {
            let r = new Cs("CRM Create", "Lead created successfully!", fn.success);
            Ss(r);
          }
          this.owner.crmId = n.data.lead.crmId;
        } catch (t) {
          let s = new Cs("Zoho create lead error", t.message);
          s.stay = !0, Ss(s);
        }
        this.isLoading = !1;
      }
    },
    async createContact(e, t, s) {
      console.log("Zoho.createContact", e, t);
      let n = !1;
      if (!this.assign_to) {
        let i = new Cs("Error", "Please choose a user to assign the lead to.");
        Ss(i), n = !0;
      }
      if (!n) {
        this.isLoading = !0;
        try {
          let o = (await W.api.leads.getContact(this.owner.id, e, t)).data.contact;
          const l = {
            lead: {
              crmId: o.crmId,
              assignId: this.assign_to,
              //company: this.owner.comp,
              firstName: o.firstName,
              lastName: o.lastName,
              addressStreet: this.owner.address,
              addressCity: this.owner.city,
              addressState: this.owner.state,
              addressZIP: this.owner.zip,
              phone: o.phone,
              cell: o.cell,
              email: o.email,
              annualRevenue: this.annualRevenue,
              leadStatus: this.crm_lead_status,
              campaign: this.crm_campaign
            }
          }, d = await W.api.crm.createLead(bt.Zoho, this.owner.id, l);
          if (d.data.status != de.Success)
            throw new Le(d);
          const c = d.data.lead.crmId;
          if (o.crmId) {
            let u = new Cs("CRM Update", "Lead contact updated successfully!", fn.success);
            Ss(u);
          } else {
            let u = new Cs("CRM Create", "Lead contact created successfully!", fn.success);
            Ss(u), o.crmId = c;
            var r = await W.api.leads.updateContact(this.owner.id, o);
            o = r.data.contact;
          }
          this.isLoading = !1, s(o);
        } catch (i) {
          let o = new Cs("Zoho create lead error", i.message);
          o.stay = !0, Ss(o);
        }
        this.isLoading = !1;
      }
    }
  },
  watch: {
    owner: {
      async handler(e, t) {
        console.log("watch.owner", e, t), this.loadLead();
      }
    },
    assign_to: {
      async handler(e, t) {
        this.assignTo != e && this.$emit("update:assignTo", this.assign_to);
      }
    }
  },
  mounted() {
    this.advertiseInterface(), this.loadCrmUsers().then(this.loadCampaigns).then(this.loadCampaigns);
  },
  created() {
  }
}), XZt = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQIAAABYCAIAAACRT24iAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDcuMi1jMDAwIDc5LjFiNjVhNzliNCwgMjAyMi8wNi8xMy0yMjowMTowMSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIDIzLjUgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOkM3OTAzQzM2MzI1MjExRUQ4NEFGQkVGMDY4Q0Q4MzVBIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOkM3OTAzQzM3MzI1MjExRUQ4NEFGQkVGMDY4Q0Q4MzVBIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6Qzc5MDNDMzQzMjUyMTFFRDg0QUZCRUYwNjhDRDgzNUEiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6Qzc5MDNDMzUzMjUyMTFFRDg0QUZCRUYwNjhDRDgzNUEiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz5nUrDxAAAdgElEQVR42uxdCVgT19qWNWyBsMpqEAKCKIqiCEjRuoHWDRC0WtHf61atilp/a+ty7dXWKqC32qpVr2vdENSq4IoioAiKCqKy7/sW9rD+X4i/xpkzySSZoLfO+/j48MxM5kxOvvd873u2Uejq6upFg8anDUW6CmjQoGlAgwZNAxo0aBrQoEHTgAYNmgY0aNA0oEGDpgENGm+gLI+bVje0ZpTW55Q3ltS2lNW2VNbzmngdrR2dyooK6qpK+lqqRjpqJrrqbAMN695aZnrqFBZdUNWUXlKfX9lUWtsCpVfV81rbOxUU+KfUVJQMtRnGLDUTlnpfI00bE6aRNoOOABpU0gCi7WFGVdzrysfZ1a+K65tbO0glIwWFfqbMQWzWSDsDV1sDloaKdKVHPi2JeVmRnFubUVJP8iOqyop2ptpDrXSh6BE2+kASOho+WSjIPpkiMav6UlLRndTyMm6LLPdhqiuPdjCa5GQ6dmBv8p9q5LV/tTfhWV6tLEVDloBCpw0zc7bSo2OCpoFkiHpaeuJ+LiQBap/J1oQ59zPLADcLRYGaEYlN51JPxeZRVbSbrcHskWyvwcZ0ZNA0EA9QIL9GZTzJqZHfk4F8XzqO4+tiLvoyj813imuaqS0alNI3XjYedoZ0fNA0QKO8jrc9Iu2vx8U983wuHP0ffPr3N9cmumDizzGvi+vlUTRopA3T+uszVekooWnwHiISi7aGvahrbiNrwJUUDJgMfSZDi6EMlrStoxOsc3VDa2U9j6SHFuDbyXZLxlkjTwEhVx1Lxh/XUlMGxa+vxWCo8DuF4Vs2t7ZX1reW17Xw2jpJlsvSVP3nDIcvhpjSgULT4A02nkv9k4QKh7gfztFzstR1sNDuo69hpKOmpIiV+ECDgsqm1yX1IKuSsmvyKhrF3nZUf6PdgU5go/GnjsfkHrydXVrbzDbQdOHoDemra2vKhKIhiPEXg48vrGpOLeA+zql5lFlVUccTW3Sgp+UmXwc6Vj51GjS0tC86mJSQKcoKa6gqTRhk7O1k4t7PQNLOx8Ss6sinJVeeFFfVt4q4zExP/ciS4RxjLfwpyDOltS0W+hoSlQtpIfZ1RWRySdSzUtHZaaSdwYGFznSn6qdLAwivmXseFFQ1ESoHDZW5npZfurMNZRuNamrtCE8oPBydnV9JWBYoq1PfjID2ntpagJxwMjbv+L1cEXrPurfWmZWuelq0Vfj0aFBS0zw9OE6Eclj4udWS8Ryph73wgMc5FJ39a2RGI6+d6Jpzq9yGWulSXhdgWvZezzh2L5foAnM99Yi1I2kmfFo0AC3k9VNMCUF35CA2a6v/gAEWOvJ4LEhBP4a/iHpain5oBT4TKM8JAiTn1IALellUhzzLNtS8tt6DVkefEA2m7Ix9UcBFnpr7meVmP7m7xv/czflXeBoRE0CiyG/Q9/szKWfi85GnnCxZYavd6dD5JGiw+vjTS0lFyFPbZg6c6danZ54v7nUluPOWNrR/PR8kr5wAOHE/b8v5VOQpXxfzX2YPoqPnbwP0ROvzDwuIOHBgoXOPcQDg3s/g8rqROgTeI2D3g2S5jWR/5cH+9/whyFMXEgovJhbR0fN3zgagy9033UZefXjJsFH9jXr+KXMrGn2C47hNiG4cRQWFc0FuIFTkVPTt1DJIR8hTD/811vAjmKpdXl6ekZGRn59fVlbW2ckfGVRXVzc1NWWz2RwOR0tLS9IbRkZGJiYmKoib0AWRw2AwVFT4LZSJiYmFhYWtra2RkWThcePGjdRUdMo1NDT08fHR1NSUumZaW1sjIiKKitAN1qhRo4YMGUJIA//d8Y+zEU1s8FeDpw0z+1A/dk45nwnIDk0lRT4TBrPlxYRzDwq+O/0cf9yFo//nihEfqkJyc3PDwsKuXr0KNCgpKampee8nU1ZWNjAwgOi0traeNm2at7e3nh5ZHzV//vyjR49K+jy6uroCMkyaNAnC18yMVKj4+/ufP3+e6Oy9e/c+++wzqavo0aNHo0ePbmpC97//9NNP69evR4uiqKelSA58PZ7zATnQq3umXdhqNy01xChyR2eXf2h8cm6tnIr2d7VYMNoKfzwhs+pWSlnPV0V8fPy8efMcHBy+/fbbu3fvpqWlYTgAaG9vLy0tTU5OBqrMmTMHLt68eXNOTg6Z+0vXAMMzwJNcv359xYoVjo6O69atKygoEPspJpMp4mx4eLgsM6AhFRBxQJAzCb3BpvMp+A+ADV3zRb8Pnv2te2uFr3H/IEzYMN0e2TW88WxKT9ZAYWHh8uXLx44de+zYMRE/MB5Aia1bt06YMOHgwYMdHR3yfs7q6uqdO3dCccAKWe7z119/ZWVlSffZiooKUFzSWOSzDwrw0xlAfB9c5PyRWBlgQsTakZoMBBM6u7oCdsfLuP5GBJCVUF7Hg0rrme8eHR0N2mbfvn3NzVJOLAcLsXjx4gULFlRWVvbAA798+XLWrFnQossi/CDdSffZO3fuQDKUhgahV1/jr/humr2uJpXjpqkF3PBHhftuZO6+ln4kOif6RTmZ+W1vYWWkGbGWMCfMCI1/ni8XJvTWUfvfKXb443uupfdASJ0+fTogIIDITUoEyCRwK8gPPfDYoJRAIz158kS6j4PjB+cgUd57qwkvXrxIXlC9C6Ybz0vx4Wiiq/4/o/tSUiPgbk/ez7uUWJRZ1oA5paaiNNLO4Et3tmd/UitdICdcWOPuGxzX0NKOZEJYkPvAPtQPby8aa30sJre09r21pmXcltupZWMG9JZfMF26dAla8fp6wmUVbDZ7/PjxYAAEUhvSBch0kASZmZlELeXSpUuPHz8uWpoLg8PhgKHE9zu1tLRwudznz59HRkYWFyNWoRQVFYWGhh4+fFhVVZrGNCkpCRp1d3fJxitTUlLgO5K//h0Njt7NxZ9eP9WOkh8yIrHo54svK+vRrX5LWwd4TfjnNdh4W8BAFonkwyFmQntHl19onJyYsH6qPX55w3/u5siPBqCFIGSJOAA+4ZtvvvH09NTRwX7Zuro6CIU9e/YgdQU0lj///PO2bdtIPoaRkRH4ciUlJRH2Y//+/Tt27ABi4J0uWBoXFxfpbAY4BElpcPPmzfLycvLXvxFF0MLh51Ebs9QoWXGy869Xa088JeIApp/K+6cYovk8eCaEBblpqCJ+GAET5KGOJg81BXWEOfggvUoiXUceZWVl3333XUlJCf4Ui8XatWtXVFTUlClT8BwAaGtrT5s2DXIChCbyArAZ0ISTlxm1taLq09jYeMuWLeCMNTSw091B1Ugt8QUdPoWFhRIxB/KnREW8ocH1ZwilOMeDTQkH9t+UwOyD6fQJjkslmMuEgY0JE3ICERNAHZG8j0RAVkvUM7lI7b179yYkJOCPgzg5cODAmjVrRDTPAqioqKxbt+7QoUP4gS0QM8CQqioqd1RYtGjRyJEj8cdjYmLa2tqku2d6evr9+/fJXx8fH5+YmIg5KHo08A0NwKfiz/m5WMhYKcAuiTggQGt7p19I/AtyEWxrwgwnZgL5+5CH3whEtdxJpX4AAZzl77//jozsrVu3+vv7S/DMfn6gfwQjvsKA8Hr06BGFzwwGYOLEifiYg4QmOpkIJzFbW1vMQTDKeK2FREdHx+XLl4Upp6mp6e3tjc9RWBo0tXYkZVdjTjhb6ck4U4DX1rnmxFOis0qKCsh+TwHaOjpn7I5PI6eO3uQE1N3gPn6h8WmFdRT+0kbaDPxqh6SsaqL5f1Lj1KlTyKYaYvrrr7+W9G6BgYFz584Vbh1BMkERTk5O1D5237598XyDICbZ4aOrq7t48WIDAwPhg3FxcSR7ybKyskAoCh8BXwG6UfRoCZ8G0F7ilyB+PkDWuUPH7uUgVzaCcw2d6xSz5fOYLaMvrh2JHKAVsMgvJI6kT4CcQOQTILf4hsSRZBRJfO6ANcTQlFArwPLz85HCHVQ+cIDBkLiFgtBcuXIlhJepqenatWsh1Zw9e3bmzJmg6amlASQEfDaA5hncBZmPw5Wurq4eHh7CBysqKsAokxIg168Lj17Dk/j6+oIgFMy2EkUD5O83zFrWqfx/xiHm608bZgahP8XZFPw3S1MVKLFhuv25VW7KSgpIJoBPIBnB/UyZ51e7IRfE8JkQTCUTXDiIyknJp5IG9+7dy8jIwB8fM2bM8OHDpbunvb39iRMnkpKSwMgOHjxYuh5Msaivr8c3vcBbksXBZ0EXTZo0SVn5XXrv6uoC14vsKsAUjRmtA301efJk0Rx4Q4PMUkRHPkSVLHWRWdaAX77M6a0V/NVg/MWgMcKC3JFM6PYJZCPYzlQ7bLWbYEcWJBOo2tEIKkcdl3nw1SgLwOchm0+ID6nDFwLLy8vLxMSklzzx4sUL/JOD1NHX1yd5Bwh6UPNs9ntdESCKYmNjRX8QGP7s2TPhI4LvKzYR8SMGvwSeY6wlQriTwUuUHF850ZboekgLF1a7E+UE/9B4kurI3kwb7kOUE2bueVDf3C77Lw0+BL9BhoidBCQFl8tNS0MsuzM3NwfB0OsjRnFxMXL2BDy2aJP63i/V2grKDawLJkvAnUUENJAnLCxMeJYhk8kEH9WrezRaPA2qG7DziMz1Zd1svai6Ge+JnUUKrQEWOkQ5ATzGjND4V8VkmRBGoI7qmttWHntCye9trof9UfHVKDXKy8vT0xFzNDgcDsTHR8sBCN9t27bhvSwIdE9PT/L3EUQtJAThSaCAW7duQaoR4aYwc+mcuyFgiHgacHGT+I201WSsEXy3CbgmNRUxbxWBnHA+yA2/vZeACX4h8enk9m0HJpwnUEf30irw3WLS9BfpYE0qt7mNqngqKyurrkY8pJmZGejmDxLiSkpKImZe8Hg88NyzZ8/+/fff8TE3YcKEUaNGSVqiu7s7ZrFBZWUlphdIGDdv3sRMHgkICFBTIxXJfOXTjNsKRfY9SPSZ2Chp7+gqrW3RVhezlYtjH9a5IDdQQR2dXXgmgGMGzUPGt/Tn5wT+bAvQQphT+29mHVosaweAHm7GRzOvnaqYq6ioQOZxIyMjBRK7fMsDkKAOHToEJBS2v/AwbW1tBQUFYOjBzEA2QHZtbdiwQYo1DBDBPj4+kAGES7xw4cL8+fPxQ4EtLS2giN4zinZ2EydOJOua+CkDnyNkrmtLQ4QQPB2XT2Y/i8FsMUyIWOtua0KKCWdWusL1mOMxLyvAISD3gSQPfDh2URdzXd3AH5dlRaKMyMrKWrZsmaSfYjAY27dvx/R+kseYMWOsrKyEe8xSUlISEhImT56MuTI5Ofnhw4eYvgQLC7Ljv/J69xk06nhtczwm9ym59QDABFBHSDaC3CLf5zOIzQr0tMR2yXV2yWkytrxBMsV/JDAxMTl8+LAUI31vYW1t7eXlhWn1kUvS4CCX+67D2sDAQGCOJaABPtY6ZX4Fjo6Gymf2iFnTs/Y8INn7CREM+h7pE5rAJ4TGk3y/E3IfjZzyRhm/IL6KKBQrRJYOv9jy4wQIocDAwMjISHALMt5qxowZmNndcNvXr99bGFNaWgraSfgImAqJRsf5NFDH9Y1W1VMwX3LpOA6iM0GScQDICWdXoXNCE6/dNyQev3QB0aWjr4Hv469vkdXO4vuF1BmUvUhOV1cXOWeusbHxIyeAo6NjSEhIdHT00aNHBw2iYCunIUOGYIYLy8rKMD1CmO0toOrAHEs00M6ngQ7OtpZxKaDBUCtd5IwMXlvnjBCy4wBOlqxzq1yRVqWR1z59V1yWOCY08zrwLllFSVY1WF6Hnemlo07ZRq56enr4aTm9utci83i8DxLfGhoa9vb2AwYMcHBwEPyP7DhisVgLFiygcJ4S2CG8vDlz5szb2VZgoCE/CI8nAP3AVEhUiiKyX6iwmpqRoN2BTsidtkDf+5FnQl/dc6vckKcgJ0zbFSd6+DYxqxpvtY1ZsorsgqpmyrvXhKUtcoOTvLy8nllGjOhv6N//ypUr9+/fj+kG/LF582b8ZbGxscHBwdQW7e3tbWNjI3zk+fPnbyfGgjnGKCIfHx/yI9bvaNDHANurA00sflWXNFRmKJ9Z6aqqrIh2uqRnzg3pZgIyJwATpgeLYkLoNcQCawdzmRamQSLKwpWIr0apYWho2K8fYiuQly9fIkeXewCgNCC2oLGHTKXbjSVLlkyYMAFrmTo79+7dK9HyALGwtLQcPXo0Rhy+HasGRSTcNJiamk6ZMkXSIvgBip8XALqF5JCtWNh2z4JGMqF7DinZsWGQWOeJmQCMQq4rWHvyGZ4hbEPNvkYy9TwCe/Hjg8j3j0gH0LWgOvDHIfVHRUXJsnVPQkLCunXrpAhTKBQzkQHkypYtW4APWNdUXb1x40Zq3TzoIswCutu3b+fm5kIpmLkbYI7t7OykoQFyB56EzGqqvkN/M20iJkAwgU8g2fsJ6ujsSjQTIHdN3RUbcuU13Kq+ub28jhf1tNQvND7iEWLx3ix3WfdgRVYOtUufPTw8kKMEly5dknrrHsCJEyd27tw5ceLEqVOnwt8yOo0RI0YsX74cf/zevXsHDhygsDagoGHDhmH04d27dxMTEyFDvj0oGHFD2irxNHCw0MH3pURTupyqf/eMNyQTBL2fJGdJQE4AlUXQXPXadyNz4s8xnv+847nlzrIjj5G7/IJOm+thKePXwVeOhqoSta96gF8dmRCAA4cOHZLysaOjT506xW81GhouX74cGBjo6Oi4b98+WTbwAhog18v/+uuv+JWQUgPsOEbqgPo6cuRIaGio8GoeqDFJzfE7GsBPiH9RQHJuLWYnElmZYK4dFuSG7KLhq5rgOJLjAPCop1eKmmXJbWrDdw29RfBXgxgqMnUTlXFb8NvjOVvrUfvuD7AH+LFSAQ4fPnz16lVJb1haWgqmVnglJOic9PT0lBSZNt4zMjLatGkTfsl/cXHx1q1bpdhiiAheXl59+ryXxkHaYaYYzZo1i/xWrVgaAEY7IHo2zz+keD82SDthq9ErbJq6Z0mQzAnDrflMkGLCx9JxnHGOsi62Oofapg5ZgTIiICAA2V8EjhDa4MePH5O/FZfLXbFiBd4SgO4Sve0KGYwfPx5ugj8eGRkpxZbAROBwOETtwpsuij59vvjiC+lu/oYGEwYhguPk/TzKf1pQDueDCJlAPicAE8JWu0v0zrUl46zXTqZgJ1ZktSArUEbY2NisWrUKeQrc4cyZM0luQ5KRkTFnzhzkxtGgi6ReyyaMNWvW4AfLQGvt2LHj+fPnlNSGgoIC0EDEoBhwANm9JgENjFlqLhxsV2tlPS/8USHlv65jHxbRugKBTyAzNtyre4w5coPn2IHi98kyYDJ2fTX428kUbD0GFYLfcGmEjT5+8yJKsGDBAkxf4VtkZmbOnj17yZIlItIC5I2QkBCIjytXruDPWllZBQUFKSpSMK/MwsJi/fr1+GVx+fn5v/zyC1VDfnij/Bba2trTp0+X+s7vqmDeKIRx3Hn5lTx+3YF9CFfYNLTwfQJJJhhpMw4sdD64yBk0CVLxc4y1IAPc/MFzOkW70iMrZP6ovr3kA11d3eDgYMzg0Vs0NjYeOHBg3LhxEB/ff//92bNnExIS0tLSYmJi/vjjD9BUzs7O0E4jV/BoaWnt3LkTlAZVj+rn5/fll1/ij58+fRoejJIiwIFAKcip5i4uLm5ublLf+d00mPGOxobaDMzua+V1vH03MpeN58iDCaCO/EIQs6kFTAhf427dm1RP/JgBveEfONfUAm5OeWN9S7uqkiLkNztTpgOlvTf7rmeW43angzxAJiNJDScnJ/DEoGqgZUVeUFNTk9AN8veEthPkio+PD4XPqaysDFQEBmZnZ2O6dLZv3+7u7m5tbU2JUYZ2AfPmBPA2IBHJL/IUlQ0AQZMQ0irkymtqu4yE1RHRWjNgwvRdcdmSzAOFcAQy/ONzq6CJtssmcHxdzKnlQElNcwhqx+9VxAusqYKHhwc0qAMHDqTkbsbGxvv37wc1RflzQm6B5CO8o4QAr1+/hsxDcoMWsUWMHTsWc9Dc3FyK1W2ENAhwtUBu0bXwYKKcfuBBxHNIu2fOxWaVNfT6OIB8Axpwz9/VogdKB9lz7dq1RYsWYZbnSgpwGmCsZ82aJafnnDdvHrK75uTJk5LuK4qEYPYoxoSAdQafQxkNAFv9B+AvSius23rhhbySviV/rRlRTvAJjvsYmABfHzk5HFldcgK0eeAEwsPDZ8yYgW9xxQLM5W+//Xb58mVKuoaIAMoEpBG+nxdszI8//kj0Nj6JAB4AGgVhgSfRChtSNACHgO8y6sXfgi6X6HXZ8mYC+AfZV8nIgtNx+fD1ES20jb5cXQGROD5z5kxsbOyWLVscHR3B6Yro9WcwGIaGhtD2X7hwAZLJ0qVLybwYE/k2nYaGBpJzmcCXr1ixAn/82bNnwBDMzfHja3V1daJHtZlMpre3NxErkGjtBuagcP8VolHZM89pxA+38Me/P5PCVFeZ5CSXzZ4EK2z8Q+Pxq7rqmtt8Q/iO2dLwA6zEvZpc8gPqBWeg4/49b8gHoaWioqJLNzZu3FhcXPzkyZPU1NSsrCzhDU/ZbHa/fv2GDh3q4OAg6Tth4c74vVNtbGzIL2QB8VZSUoJ54yCwCCKvsLBQuOMLrDOGGCwWS+w0aX9///T0dMHmHQsXLhT7YCCZfH19MebE3t7+3a+JpPjFxCKiXXhD5zpNcZbXVjnJOTX+ux8gl4DqaKicXelqY8LsyYC7nFQcdBz9/qzdgU6Th368WwbRkEkUCTBtmBly+3J+b9Lx5KN3c+T0NPw5pKvQ84W4TW2Tf4mNeVnRY1UDX5OIAwGuFjQH/k5QECH4ZoTGP8lBzxqfMcJi28yBSDUvO5Kyq2fueUD0XOun2i8cYyXXSuno7AIFSDSlapi13pmVrnTofCo0aG3v9PopJq8CbU85xlo/BgwcLvPG10g84aujeKJHA2O60dfBXE9dHkUnZFZtOpdKtJytr5Fm1HeeyPFvGn9PGvTq3n/BJzgOvzf1W8weyV7uZWMk2wtBkHiczWcC0Vk1FaVvvGz+8bkVhRFZxm3Zez3zz1jCCYUW+hoRa92pfT0ujf8CGgBqGltn/fuhiImfmgzlOR5s+GeqS3HzDI559t6HvDbCxQOm3e+r9Xe1kHH/7aLq5lOxeSfu5zURb8DYz5R56psRNAc+URoI1NHiP5JE21MVJcUJg4y9B5uMtDNAvrtbhBCHKDTTU0c6jcyyhn/sTxSRjgAQmt5OJhMHmwzn6ElkVxpa2mNfVV5LLr7+vLS9Q1Q9ePY3PLDQWfZtXWj8F9NAgO0RLw9HZ4u9jKWpCobByZLlYKHTx0DDmKWGiZ7Orq7K+tbCqqaXRXXJubUJGVXFNc2gN0Dk+LqYI4N15dHku2niX3MLyQH8q1NfXXszJtzQgMnAsAISCygfIFVqARfsR1JWdW2T+H27Foy22jDdno4VmgZvEPW0dOO5FPIb+SsqKBgwVSEcNRjKaqqKbe1djbx2+HhVAw8pdY4sGQ7tLvJWB29l7ZBk1reqsqKeFr9o+AO+o4KCQnNrR0UdD4om/43hDj/6D/QabEwHCk0DrFWAtCCP5Ti9xPVFphXWbYtIe5hR1TNVM324+ffT7WkzQNOAEA/Sq36NykjIpDgi7Uy1r64Xswk4MPC3G5lynWUEbFzhbeNma0DHB00D8biVUnbyft79V5SN7C4bz1n9hfjlpPDIZx/kH4/JpeqVfm8B/n72SPZ4R1oF0TSQEE/zasMTCqNflIPTleU+I2z0/7N0OHIvIxE8vJpcfPdFRZ1sL1wSrCADFQTOno4JmgbSo6OzC5RS7OuKx9k1r4rrm8i9AUlJUaGfKdPJUtfDzkDqrVO4TW3x6ZWxryqf5dVCfiD5cgYNVaV+ZtrOfXXd+hkAAyWiHw2aBuJR29iaUdqQXd5YUtNcxm2pqOM18TpaOzqVFRXUVZX0tVR7s9RMWOpsQw1Oby0TSgfdiqqbs8oa8iqboOhybktVQ2tza0d7Z5eqkqIGQ8lQm2GkA0Wr9TXStDVh0vaXhhxpQIPGfxdoJUCDBk0DGjRoGtCgQdOABg2aBjRo0DSgQYOmAQ0aNA1o0Ph//J8AAwDvyHFZeWQ0UAAAAABJRU5ErkJggg==", qZt = { class: "card-body" }, QZt = { class: "row row-cols-lg-auto g-2 g-md-3" }, KZt = { class: "col-12 d-flex align-items-center border-end flex-fill justify-content-center" }, ZZt = { class: "col-12 flex-fill" }, JZt = ["disabled"], $Zt = ["value"], _Zt = { class: "col-12 col-md-6 flex-fill" }, eJt = ["disabled"], tJt = ["value"], sJt = { class: "col-12 col-md-6 flex-fill" }, aJt = ["disabled"], nJt = ["value"];
function rJt(e, t, s, n, r, i) {
  return p(), h("div", qZt, [
    a("div", QZt, [
      a("div", KZt, [
        t[5] || (t[5] = a("img", {
          src: XZt,
          class: "img-fluid",
          alt: "Zoho CRM",
          title: "Zoho CRM",
          width: "100"
        }, null, -1)),
        e.inCRM ? (p(), h(A, { key: 0 }, [
          t[3] || (t[3] = a("br", null, null, -1)),
          t[4] || (t[4] = a("i", {
            class: "fa-duotone fa-user-check text-success ms-2",
            title: "Lead is in CRM"
          }, null, -1))
        ], 64)) : P("", !0)
      ]),
      a("div", ZZt, [
        t[7] || (t[7] = a("label", { class: "form-label" }, "Assignee", -1)),
        V(a("select", {
          disabled: e.isLoading || !e.owner || e.crm_users.length == 0,
          "onUpdate:modelValue": t[0] || (t[0] = (o) => e.assign_to = o),
          class: "form-control"
        }, [
          t[6] || (t[6] = a("option", {
            disabled: "",
            value: "",
            selected: ""
          }, "Please select one", -1)),
          (p(!0), h(A, null, D(e.crm_users, (o) => (p(), h("option", {
            value: o.id
          }, g(o.name), 9, $Zt))), 256))
        ], 8, JZt), [
          [We, e.assign_to]
        ])
      ]),
      a("div", _Zt, [
        t[9] || (t[9] = a("label", { class: "form-label" }, "Status", -1)),
        V(a("select", {
          disabled: e.isLoading || !e.owner || e.leadStatuses.length == 0,
          "onUpdate:modelValue": t[1] || (t[1] = (o) => e.crm_lead_status = o),
          class: "form-control"
        }, [
          t[8] || (t[8] = a("option", {
            disabled: "",
            value: "",
            selected: ""
          }, "Please select one", -1)),
          (p(!0), h(A, null, D(e.leadStatuses, (o) => (p(), h("option", { value: o }, g(o), 9, tJt))), 256))
        ], 8, eJt), [
          [We, e.crm_lead_status]
        ])
      ]),
      a("div", sJt, [
        t[11] || (t[11] = a("label", { class: "form-label pr-md-0" }, "Campaign", -1)),
        V(a("select", {
          disabled: e.isLoading || !e.owner || e.campaigns.length == 0,
          "onUpdate:modelValue": t[2] || (t[2] = (o) => e.crm_campaign = o),
          class: "form-control"
        }, [
          t[10] || (t[10] = a("option", { value: "" }, "None", -1)),
          (p(!0), h(A, null, D(e.campaigns, (o) => (p(), h("option", {
            value: o.id
          }, g(o.name), 9, nJt))), 256))
        ], 8, aJt), [
          [We, e.crm_campaign]
        ])
      ])
    ])
  ]);
}
const Ods = /* @__PURE__ */ Ae(YZt, [["render", rJt]]), oJt = me({
  components: {
    ClientLifetimeValue: EE
  }
}), iJt = { class: "card shadow-sm client-value" }, lJt = { class: "card-body" };
function dJt(e, t, s, n, r, i) {
  const o = pe("client-lifetime-value");
  return p(), h("div", iJt, [
    t[0] || (t[0] = a("div", { class: "card-header pb-0 fs-6 fw-bold text-secondary text-xsmall bg-transparent border-0" }, " TARGET VALUE ", -1)),
    a("div", lJt, [
      N(o)
    ]),
    t[1] || (t[1] = a("div", { class: "card-body pt-0 text-small text-body-secondary text-center" }, [
      y(" Client Lifetime Value includes all absentee owned homes in your Company Territory. Edit your Company Territory in "),
      a("a", { href: "/account/settings#company-territoryTab" }, "settings"),
      y(". ")
    ], -1))
  ]);
}
const Rds = /* @__PURE__ */ Ae(oJt, [["render", dJt]]), cJt = me({
  name: "TargetName",
  props: {
    id: Number
  },
  components: {},
  data() {
    return {
      targetName: ""
    };
  },
  computed: {
    ...at(Te, Ba, ct),
    ...q(Ba, ["isLoading", "leadName", "owner", "ownerLoaded"]),
    ...q(Te, ["access", "aclLoaded"]),
    ...q(ct, ["userInfo"])
  },
  watch: {
    leadName: {
      handler(e, t) {
        document.title = `Target: ${this.leadName} - Rescover`;
      }
    }
  },
  methods: {
    number: Ve,
    showEditLeadModal() {
      this.targetName = this.leadName;
      const e = bootstrap.Modal.getOrCreateInstance(this.$refs.modalEditLead);
      e == null || e.show();
    },
    hideEditLeadModal() {
      const e = bootstrap.Modal.getOrCreateInstance(this.$refs.modalEditLead);
      e == null || e.hide();
    }
  }
}), uJt = { class: "card shadow-sm mb-3" }, pJt = { class: "p-3" }, hJt = { class: "fs-6 fw-bold" }, mJt = { class: "text-secondary text-xsmall" }, fJt = {
  title: "Lead Name",
  class: "fa-light fa-info-circle ms-1",
  "data-bs-toggle": "popover",
  "data-bs-content": "The lead name in this field is also the lead name used when you create this lead in your CRM.  You can edit the name here if you'd like.",
  "data-bs-trigger": "focus",
  tabindex: "-1"
}, gJt = {
  title: "Lead Name",
  class: "fa-light fa-info-circle ms-1",
  "data-bs-toggle": "popover",
  "data-bs-content": "The lead name is the most recently used name associated with this lead.",
  "data-bs-trigger": "focus",
  tabindex: "-1"
}, vJt = ["disabled"];
function yJt(e, t, s, n, r, i) {
  var o, l;
  return p(), h("div", uJt, [
    a("div", pJt, [
      a("p", hJt, [
        a("span", mJt, [
          t[1] || (t[1] = y(" TARGET NAME ")),
          V(a("i", fJt, null, 512), [
            [Us, ((o = e.userInfo) == null ? void 0 : o.crmProvider) == "lead-simple"]
          ]),
          V(a("i", gJt, null, 512), [
            [Us, ((l = e.userInfo) == null ? void 0 : l.crmProvider) == "zoho"]
          ])
        ])
      ]),
      y(" " + g(e.targetName) + " ", 1),
      a("button", {
        class: "btn btn-link text-eclipse btn-sm py-0",
        disabled: e.isLoading,
        onClick: t[0] || (t[0] = (...d) => e.showEditLeadModal && e.showEditLeadModal(...d))
      }, t[2] || (t[2] = [
        a("i", {
          class: "fa-light fa-edit",
          "data-bs-toggle": "tooltip",
          "data-title": "Edit Lead Name"
        }, null, -1)
      ]), 8, vJt)
    ])
  ]);
}
const Lds = /* @__PURE__ */ Ae(cJt, [["render", yJt]]);
var ZE = /* @__PURE__ */ ((e) => (e.zip = "zip", e.counties = "counties", e))(ZE || {});
const bJt = me({
  props: {
    isSearching: {
      type: Boolean,
      default: !1
    }
  },
  enums: {
    tabs: ZE
  },
  emits: ["searchLeads"],
  components: {
    AutoComplete: e1
  },
  watch: {
    selectedState(e) {
      e && e.length >= 2 && this.fetchCounties();
    }
  },
  data() {
    return {
      isLoading: !0,
      currentTab: "zip",
      errors: "",
      zip_codes: [],
      include_crm: !1,
      selectedCounty: void 0,
      selectedState: void 0,
      // Zip Lookup
      debounce: void 0,
      autocompleteZipcodes: void 0,
      selectedZipcodes: [],
      excludeInStateOwner: !1,
      includeFavorited: !1,
      includeViewed: !1,
      excludePoBoxMailingAddresses: !1,
      excludeCompanies: !1,
      states: [],
      counties: []
    };
  },
  computed: {
    tabZipCodes() {
      return {
        "nav-link": !0,
        active: this.currentTab == "zip",
        show: this.currentTab == "zip"
        /* zip */
      };
    },
    tabCounties() {
      return {
        "nav-link": !0,
        active: this.currentTab == "counties",
        show: this.currentTab == "counties"
        /* counties */
      };
    },
    canSearchZip() {
      var e;
      return this.isLoading == !1 && this.isSearching == !1 && (((e = this.selectedState) == null ? void 0 : e.length) ?? 0) > 0 && this.selectedZipcodes.length > 0;
    },
    canSearchCounty() {
      var e;
      return this.isLoading == !1 && this.isSearching == !1 && (((e = this.selectedCounty) == null ? void 0 : e.length) ?? 0) > 0;
    },
    zipCodesPlaceholder() {
      return this.selectedState ? "Add ZipCode" : "Select a state";
    },
    countyPlaceholder() {
      return this.selectedState ? "Select a county to search." : "Select a state first.";
    },
    ...q(Te, ["access"])
  },
  methods: {
    currency: Ze,
    searchZipcodes(e) {
      !e.query.trim().length || !this.selectedState || (clearTimeout(this.debounce), this.debounce = setTimeout(async () => {
        var t;
        try {
          const s = await W.api.portfolioFinder.zipLookup(this.selectedState, e.query);
          if (s.data.status != de.Success)
            throw new Le(s);
          this.autocompleteZipcodes = ((t = s.data.result) == null ? void 0 : t.map((n) => ({
            name: n
          }))) ?? [];
        } catch (s) {
          Se(s);
        }
      }, 250));
    },
    async initialize() {
      try {
        this.selectedState = localStorage.getItem(De.StorageKeys.PortfolioFinder.LastState) ?? void 0, this.selectedCounty = localStorage.getItem(De.StorageKeys.PortfolioFinder.LastCounty) ?? void 0, await this.fetchStates(), this.selectTab(this.currentTab);
      } catch (e) {
        Se(e);
      }
      this.isLoading = !1;
    },
    async fetchStates() {
      try {
        this.isLoading = !0;
        const e = await W.api.portfolioFinder.states();
        if (e.data.status != de.Success)
          throw new Le(e);
        this.states.length = 0, e.data.states && this.states.push(...e.data.states), !this.selectedState && this.states.length > 0 && (this.selectedState = this.states[0].abv ?? void 0);
      } catch (e) {
        Se(e);
      }
      this.isLoading = !1;
    },
    async fetchCounties() {
      try {
        if (this.isLoading = !0, !this.selectedState || this.selectedState.length < 2)
          return;
        const e = await W.api.portfolioFinder.counties(this.selectedState);
        if (e.data.status != de.Success)
          throw new Le(e);
        this.counties.length = 0, e.data.page && this.counties.push(...e.data.page), this.counties.sort(), this.counties.length > 0 && this.counties.splice(0, 0, { county: "All Counties", state: this.selectedState, key: `${this.selectedState}:*` }), !this.selectedCounty && this.counties.length > 0 && (this.selectedCounty = this.counties[0].county ?? void 0);
      } catch (e) {
        Se(e);
      } finally {
        this.isLoading = !1;
      }
    },
    search(e) {
      const t = this.selectedZipcodes.map((s) => s.name);
      console.log("search", e, t), this.$emit("searchLeads", {
        type: e,
        state: this.selectedState,
        zip_codes: t,
        county: this.selectedCounty,
        include_crm: this.include_crm,
        state_option: this.selectedState,
        excludeInStateOwner: this.excludeInStateOwner,
        includeFavorited: this.includeFavorited,
        includeViewed: this.includeViewed,
        includePoBoxMailingAddresses: !this.excludePoBoxMailingAddresses,
        excludeCompanies: this.excludeCompanies
      });
    },
    selectTab(e) {
      this.currentTab = e;
      let t;
      switch (e) {
        case "zip":
          t = bootstrap.Tab.getOrCreateInstance(this.$refs.zip);
          break;
        case "counties":
          t = bootstrap.Tab.getOrCreateInstance(this.$refs.counties);
          break;
      }
      t == null || t.show();
    }
  },
  mounted() {
    this.selectTab(this.currentTab), this.initialize().then(() => {
      document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach((e) => new bootstrap.Tooltip(e));
    });
  }
}), AJt = {
  class: "card shadow-sm mb-4",
  style: { overflow: "inherit" }
}, wJt = {
  class: "nav nav-tabs",
  id: "myTab",
  role: "tablist"
}, CJt = {
  class: "nav-item",
  role: "presentation"
}, SJt = {
  class: "nav-item",
  role: "presentation"
}, PJt = {
  class: "tab-content",
  id: "rentalScoutTabContent"
}, kJt = { class: "card-body" }, EJt = { class: "row g-2" }, IJt = { class: "col-md-6 col-lg-3" }, TJt = { class: "form-group m-md-0" }, OJt = ["value"], RJt = { class: "col-md-6 col-lg-5" }, LJt = { class: "form-group m-md-0" }, BJt = ["textContent"], MJt = { class: "card-body" }, xJt = { class: "row g-2" }, FJt = { class: "col-md-6 col-lg-3" }, VJt = { class: "form-group m-md-0" }, DJt = ["disabled"], NJt = ["value"], jJt = { class: "col-md-6 col-lg-3" }, HJt = { class: "form-group m-md-0" }, UJt = ["disabled"], zJt = ["value"], WJt = {
  id: "countyHelpBlock",
  class: "form-text text-secondary text-opacity-75"
}, GJt = ["textContent"], YJt = { class: "card-footer" }, XJt = { class: "row g-2" }, qJt = { class: "col d-flex gap-2" }, QJt = { class: "dropdown dropdown-filter-exclude" }, KJt = ["disabled"], ZJt = {
  class: "dropdown-menu shadow p-2",
  style: { width: "360px" }
}, JJt = { class: "form-check form-switch" }, $Jt = ["disabled"], _Jt = { class: "form-check form-switch" }, e$t = ["disabled"], t$t = { class: "form-check form-switch" }, s$t = ["disabled"], a$t = { class: "dropdown dropdown-filter-show" }, n$t = ["disabled"], r$t = {
  class: "dropdown-menu shadow p-2",
  style: { width: "310px" }
}, o$t = { class: "form-check form-switch" }, i$t = ["disabled"], l$t = { class: "form-check form-switch" }, d$t = ["disabled"], c$t = { class: "form-check form-switch" }, u$t = ["disabled"], p$t = { class: "col d-flex justify-content-end gap-2" }, h$t = ["disabled"], m$t = ["disabled"], f$t = {
  key: 0,
  class: "loads text-center d-flex flex-column justify-content-center align-items-center position-fixed w-100 start-0"
};
function g$t(e, t, s, n, r, i) {
  const o = pe("AutoComplete");
  return p(), h(A, null, [
    a("div", AJt, [
      a("ul", wJt, [
        a("li", CJt, [
          a("button", {
            id: "zip-tab",
            "data-bs-toggle": "tab",
            "data-bs-target": "#zip",
            type: "button",
            role: "tab",
            "aria-controls": "zip",
            "aria-selected": "true",
            class: z(e.tabZipCodes),
            onClick: t[0] || (t[0] = (l) => e.selectTab(e.tabs.zip))
          }, "Zip Codes", 2)
        ]),
        a("li", SJt, [
          a("button", {
            id: "counties-tab",
            "data-bs-toggle": "tab",
            "data-bs-target": "#counties",
            type: "button",
            role: "tab",
            "aria-controls": "counties",
            "aria-selected": "false",
            class: z(e.tabCounties),
            onClick: t[1] || (t[1] = (l) => e.selectTab(e.tabs.counties))
          }, "County", 2)
        ])
      ]),
      a("div", PJt, [
        a("div", {
          class: z(["tab-pane fade", e.tabZipCodes]),
          id: "zip",
          ref: "zip",
          role: "tabpanel",
          "aria-labelledby": "zip-tab",
          tabindex: "0"
        }, [
          a("div", kJt, [
            a("div", EJt, [
              a("div", IJt, [
                a("div", TJt, [
                  t[18] || (t[18] = a("label", {
                    for: "selectedState",
                    class: "form-label"
                  }, "State", -1)),
                  V(a("select", {
                    class: "form-select form-select-size",
                    id: "selectedState",
                    "onUpdate:modelValue": t[2] || (t[2] = (l) => e.selectedState = l),
                    onOnchange: t[3] || (t[3] = (l) => e.errors = ""),
                    "aria-describedby": "selectedStateHelpBlock"
                  }, [
                    (p(!0), h(A, null, D(e.states, (l) => (p(), h("option", {
                      value: l.abv,
                      key: l.abv
                    }, g(l.name), 9, OJt))), 128))
                  ], 544), [
                    [We, e.selectedState]
                  ]),
                  t[19] || (t[19] = a("small", {
                    id: "selectedStateHelpBlock",
                    class: "form-text text-secondary text-opacity-75"
                  }, " Select a state to search. ", -1))
                ])
              ]),
              a("div", RJt, [
                a("div", LJt, [
                  t[20] || (t[20] = a("label", {
                    for: "zip_codes",
                    class: "form-label"
                  }, "Zip Codes", -1)),
                  N(o, {
                    multiple: !0,
                    class: "d-block",
                    modelValue: e.selectedZipcodes,
                    "onUpdate:modelValue": t[4] || (t[4] = (l) => e.selectedZipcodes = l),
                    suggestions: e.autocompleteZipcodes,
                    onComplete: t[5] || (t[5] = (l) => e.searchZipcodes(l)),
                    optionLabel: "name",
                    placeholder: e.zipCodesPlaceholder,
                    disabled: !e.selectedState,
                    dataKey: "name",
                    minLength: 2,
                    forceSelection: !0
                  }, null, 8, ["modelValue", "suggestions", "placeholder", "disabled"]),
                  t[21] || (t[21] = a("small", {
                    id: "zip_codesHelpBlock",
                    class: "form-text text-secondary text-opacity-75"
                  }, " Enter up to 4 zip codes. ", -1))
                ])
              ])
            ])
          ]),
          a("span", {
            class: "help is-danger",
            textContent: g(e.errors)
          }, null, 8, BJt)
        ], 2),
        a("div", {
          class: z(["tab-pane fade", e.tabCounties]),
          id: "counties",
          ref: "counties",
          role: "tabpanel",
          "aria-labelledby": "counties-tab",
          tabindex: "0"
        }, [
          a("div", MJt, [
            a("div", xJt, [
              a("div", FJt, [
                a("div", VJt, [
                  t[22] || (t[22] = a("label", {
                    for: "selectedState",
                    class: "form-label"
                  }, "State", -1)),
                  V(a("select", {
                    class: "form-select form-select-size",
                    id: "selectedState",
                    "onUpdate:modelValue": t[6] || (t[6] = (l) => e.selectedState = l),
                    onOnchange: t[7] || (t[7] = (l) => e.errors = ""),
                    "aria-describedby": "selectedStateHelpBlock",
                    disabled: e.isLoading || e.isSearching
                  }, [
                    (p(!0), h(A, null, D(e.states, (l) => (p(), h("option", {
                      value: l.abv,
                      key: l.abv
                    }, g(l.name), 9, NJt))), 128))
                  ], 40, DJt), [
                    [We, e.selectedState]
                  ]),
                  t[23] || (t[23] = a("small", {
                    id: "selectedStateHelpBlock",
                    class: "form-text text-secondary text-opacity-75"
                  }, " Select a state to search. ", -1))
                ])
              ]),
              a("div", jJt, [
                a("div", HJt, [
                  t[24] || (t[24] = a("label", {
                    for: "selectedCounty",
                    class: "form-label"
                  }, "County", -1)),
                  V(a("select", {
                    class: "form-select form-select-size",
                    id: "selectedCounty",
                    "onUpdate:modelValue": t[8] || (t[8] = (l) => e.selectedCounty = l),
                    onOnchange: t[9] || (t[9] = (l) => e.errors = ""),
                    "aria-describedby": "countyHelpBlock",
                    disabled: e.isLoading || e.isSearching || !e.selectedState
                  }, [
                    (p(!0), h(A, null, D(e.counties, (l) => (p(), h("option", {
                      value: l.county,
                      key: l.county
                    }, g(l.county), 9, zJt))), 128))
                  ], 40, UJt), [
                    [We, e.selectedCounty]
                  ]),
                  a("small", WJt, g(e.countyPlaceholder), 1)
                ])
              ])
            ])
          ]),
          a("span", {
            class: "help is-danger",
            textContent: g(e.errors)
          }, null, 8, GJt)
        ], 2)
      ]),
      a("div", YJt, [
        a("div", XJt, [
          a("div", qJt, [
            a("div", QJt, [
              a("button", {
                type: "button",
                class: "btn btn-outline-secondary dropdown-toggle no-anim",
                "data-bs-toggle": "dropdown",
                "aria-expanded": "false",
                "data-bs-auto-close": "outside",
                disabled: e.isLoading || e.isSearching
              }, " Exclude ", 8, KJt),
              a("div", ZJt, [
                a("div", JJt, [
                  V(a("input", {
                    type: "checkbox",
                    class: "form-check-input",
                    "onUpdate:modelValue": t[10] || (t[10] = (l) => e.excludeInStateOwner = l),
                    id: "chkInOwnerState",
                    disabled: e.isLoading || e.isSearching
                  }, null, 8, $Jt), [
                    [Ue, e.excludeInStateOwner]
                  ]),
                  t[25] || (t[25] = a("div", { class: "d-inline-flex align-items-center" }, [
                    a("label", {
                      class: "form-check-label ms-1 ms-lg-2",
                      for: "chkInOwnerState"
                    }, "Exclude in-state owners"),
                    a("span", {
                      class: "ms-2",
                      "data-bs-toggle": "tooltip",
                      "data-bs-placement": "top",
                      "data-bs-title": "Enabling this filter will exclude owners with a mailing address in the state you have chosen as your state Company Territory settings"
                    }, [
                      a("i", { class: "fa-light fa-info-circle" })
                    ])
                  ], -1))
                ]),
                a("div", _Jt, [
                  V(a("input", {
                    type: "checkbox",
                    class: "form-check-input",
                    "onUpdate:modelValue": t[11] || (t[11] = (l) => e.excludePoBoxMailingAddresses = l),
                    id: "chkExcludePoBoxMailingAddresses",
                    disabled: e.isLoading || e.isSearching
                  }, null, 8, e$t), [
                    [Ue, e.excludePoBoxMailingAddresses]
                  ]),
                  t[26] || (t[26] = a("div", { class: "d-inline-flex align-items-center" }, [
                    a("label", {
                      class: "form-check-label ms-1 ms-lg-2",
                      for: "chkExcludePoBoxMailingAddresses"
                    }, "Exclude PO Box mailing addresses"),
                    a("span", {
                      class: "ms-2",
                      "data-bs-toggle": "tooltip",
                      "data-bs-placement": "top",
                      "data-bs-title": "Enabling this filter will exclude PO Box mailing addresses"
                    }, [
                      a("i", { class: "fa-light fa-info-circle" })
                    ])
                  ], -1))
                ]),
                a("div", t$t, [
                  V(a("input", {
                    type: "checkbox",
                    class: "form-check-input",
                    "onUpdate:modelValue": t[12] || (t[12] = (l) => e.excludeCompanies = l),
                    id: "chkExcludeTargetsWithoutPersonalNames",
                    disabled: e.isLoading || e.isSearching
                  }, null, 8, s$t), [
                    [Ue, e.excludeCompanies]
                  ]),
                  t[27] || (t[27] = a("div", { class: "d-inline-flex align-items-center" }, [
                    a("label", {
                      class: "form-check-label ms-1 ms-lg-2",
                      for: "chkExcludeTargetsWithoutPersonalNames"
                    }, "Exclude Targets Without Personal Names")
                  ], -1))
                ])
              ])
            ]),
            a("div", a$t, [
              a("button", {
                type: "button",
                class: "btn btn-outline-secondary dropdown-toggle no-anim",
                "data-bs-toggle": "dropdown",
                "aria-expanded": "false",
                "data-bs-auto-close": "outside",
                disabled: e.isLoading || e.isSearching
              }, " Show ", 8, n$t),
              a("div", r$t, [
                a("div", o$t, [
                  V(a("input", {
                    type: "checkbox",
                    class: "form-check-input",
                    "onUpdate:modelValue": t[13] || (t[13] = (l) => e.include_crm = l),
                    id: "chkInCRM",
                    disabled: e.isLoading || e.isSearching
                  }, null, 8, i$t), [
                    [Ue, e.include_crm]
                  ]),
                  t[28] || (t[28] = a("label", {
                    class: "form-check-label ms-1 ms-lg-2",
                    for: "chkInCRM"
                  }, "Show leads already in CRM", -1))
                ]),
                a("div", l$t, [
                  V(a("input", {
                    type: "checkbox",
                    class: "form-check-input",
                    "onUpdate:modelValue": t[14] || (t[14] = (l) => e.includeViewed = l),
                    id: "chkInFavorite",
                    disabled: e.isLoading || e.isSearching
                  }, null, 8, d$t), [
                    [Ue, e.includeViewed]
                  ]),
                  t[29] || (t[29] = a("label", {
                    class: "form-check-label",
                    for: "chkInFavorite"
                  }, "Show previously viewed properties", -1))
                ]),
                a("div", c$t, [
                  V(a("input", {
                    type: "checkbox",
                    class: "form-check-input",
                    "onUpdate:modelValue": t[15] || (t[15] = (l) => e.includeFavorited = l),
                    id: "chkInFavorite",
                    disabled: e.isLoading || e.isSearching
                  }, null, 8, u$t), [
                    [Ue, e.includeFavorited]
                  ]),
                  t[30] || (t[30] = a("label", {
                    class: "form-check-label",
                    for: "chkInFavorite"
                  }, "Show favorited targets", -1))
                ])
              ])
            ])
          ]),
          a("div", p$t, [
            e.currentTab == "zip" ? (p(), h("button", {
              key: 0,
              type: "button",
              class: z(["btn btn-lava", { "is-loading": e.isSearching }]),
              onClick: t[16] || (t[16] = (l) => e.search("zip")),
              disabled: !e.canSearchZip
            }, t[31] || (t[31] = [
              y("Search"),
              a("span", { class: "d-none d-md-inline" }, " Listings", -1)
            ]), 10, h$t)) : P("", !0),
            e.currentTab == "counties" ? (p(), h("button", {
              key: 1,
              type: "button",
              class: z(["btn btn-lava btn-block", { "is-loading": e.isSearching }]),
              onClick: t[17] || (t[17] = (l) => e.search("county")),
              disabled: !e.canSearchCounty
            }, t[32] || (t[32] = [
              y("Search"),
              a("span", { class: "d-none d-md-inline" }, " Listings", -1)
            ]), 10, m$t)) : P("", !0)
          ])
        ])
      ])
    ]),
    e.isSearching ? (p(), h("div", f$t, t[33] || (t[33] = [
      Bt('<svg class="loader" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 340 340"><circle cx="170" cy="170" r="160" stroke="#F26E34"></circle><circle cx="170" cy="170" r="135" stroke="#132844"></circle><circle cx="170" cy="170" r="110" stroke="#F26E34"></circle><circle cx="170" cy="170" r="85" stroke="#132844"></circle></svg><br><span class="fw-bold h5 mb-0"> Searching... </span>', 3)
    ]))) : P("", !0)
  ], 64);
}
const v$t = /* @__PURE__ */ Ae(bJt, [["render", g$t]]), y$t = me({
  name: "RentalScoutSearch",
  components: {
    SearchForm: v$t,
    ListLoader: uf,
    BPagination: GE,
    BTable: XE
  },
  data() {
    return {
      columns: [
        "address",
        { key: "lastModified", tdClass: "text-end" },
        "ownerName",
        { key: "properties", tdClass: "text-end" },
        "viewed",
        "inCrm",
        "actions"
      ],
      rentals: [],
      loading: !1,
      totalRecords: 0,
      filteredRecords: 0,
      curPage: 1,
      pageSize: 25,
      sortField: "filtered",
      sortOrder: 0,
      params: {
        type: pP.Zip,
        include_crm: !1,
        state: "",
        state_option: "",
        zip_codes: [],
        county: "",
        excludeCompanies: !1,
        excludeInStateOwner: !1,
        includeFavorited: !1,
        includeViewed: !1,
        includePoBoxMailingAddresses: !1
      },
      searched: !1
    };
  },
  computed: {
    startRecord() {
      return this.curPage == 1 ? 1 : (this.curPage - 1) * this.pageSize + 1;
    },
    endRecord() {
      return this.curPage == 1 ? Math.min(this.pageSize, this.filteredRecords) : Math.min((this.curPage - 1) * this.pageSize + this.pageSize, this.filteredRecords);
    }
  },
  methods: {
    number: Ve,
    date: cs,
    async searchLeads(e) {
      var t, s, n, r, i, o, l, d, c, u;
      this.loading = !0, e && (this.params = e, this.rentals.length = 0, this.curPage = 1, this.pageSize = 25);
      try {
        const m = {
          page: this.curPage,
          pageSize: this.pageSize,
          //sort: this.sortField,
          //sortOrder: this.sortOrder,
          type: (t = this.params) == null ? void 0 : t.type,
          state: (s = this.params) == null ? void 0 : s.state_option,
          zipCodes: (n = this.params) == null ? void 0 : n.zip_codes,
          includeCrm: (r = this.params) == null ? void 0 : r.include_crm,
          county: (i = this.params) == null ? void 0 : i.county,
          excludeInStateOwner: (o = this.params) == null ? void 0 : o.excludeInStateOwner,
          includeFavorited: (l = this.params) == null ? void 0 : l.includeFavorited,
          includeViewed: (d = this.params) == null ? void 0 : d.includeViewed,
          includePoBoxMailingAddresses: (c = this.params) == null ? void 0 : c.includePoBoxMailingAddresses,
          excludeCompanies: (u = this.params) == null ? void 0 : u.excludeCompanies
        }, f = await W.api.rentalScout.search(m);
        if (f.data.status != de.Success)
          throw new Le(f);
        this.searched = !0, e && (localStorage.setItem(De.StorageKeys.PortfolioFinder.LastState, e.state_option), localStorage.setItem(De.StorageKeys.PortfolioFinder.LastCounty, e.county)), this.rentals.length = 0, this.rentals.push(...f.data.page), this.filteredRecords = f.data.total, this.totalRecords = f.data.total;
      } catch (m) {
        console.error("searchLeads", m);
        const f = m.message;
        f.includes("No state filter applied!") ? Mi(f) : Se(f), this.rentals.length = 0, this.totalRecords = 0, this.filteredRecords = 0;
      }
      this.loading = !1;
    },
    async onPage(e, t) {
      this.curPage = t, await this.searchLeads();
    },
    rowStyle(e) {
      var t, s;
      return {
        "investor-agent": ((t = e == null ? void 0 : e.agent) == null ? void 0 : t.isInvestorAgent) == !0,
        "agent-pm": ((s = e == null ? void 0 : e.agent) == null ? void 0 : s.isPropertyManager) == !0,
        "owner-fiduciary": (e == null ? void 0 : e.fiduciary) == !0
      };
    },
    getPropertyPhoto(e) {
      const t = {};
      return e && (t.backgroundImage = `url(${e}?tr=n-thumb1)`), t;
    }
  }
}), b$t = { class: "content container-fluid" }, A$t = {
  key: 0,
  class: "mb-3"
}, w$t = { class: "card shadow-sm" }, C$t = { class: "d-flex" }, S$t = { class: "card-photo-sm me-2" }, P$t = { class: "small m-0" }, k$t = { class: "list-inline small" }, E$t = { class: "list-inline-item" }, I$t = { class: "list-inline-item" }, T$t = { class: "list-inline-item" }, O$t = { class: "list-inline-item" }, R$t = {
  key: 0,
  class: "fad fa-check text-success"
}, L$t = {
  key: 0,
  class: "fad fa-user-check text-success",
  title: "Lead is in CRM"
}, B$t = ["href"], M$t = {
  key: 0,
  class: "p-3"
}, x$t = { class: "d-flex align-items-center justify-content-between flex-column flex-lg-row" };
function F$t(e, t, s, n, r, i) {
  const o = pe("search-form"), l = pe("router-link"), d = pe("BTable"), c = pe("b-pagination");
  return p(), h("div", b$t, [
    t[26] || (t[26] = a("h1", { class: "fs-3 fw-bold" }, "Rental Scout", -1)),
    t[27] || (t[27] = a("p", { class: "mb-md-4" }, "Find rental properties in your area!", -1)),
    N(o, {
      onSearchLeads: e.searchLeads,
      isSearching: e.loading
    }, null, 8, ["onSearchLeads", "isSearching"]),
    e.filteredRecords > 0 ? (p(), h("div", A$t, [
      t[3] || (t[3] = y(" Showing ")),
      a("strong", null, g(e.number(e.startRecord)), 1),
      t[4] || (t[4] = y(" to ")),
      a("strong", null, g(e.number(e.endRecord)), 1),
      t[5] || (t[5] = y(" of ")),
      a("strong", null, g(e.number(e.filteredRecords)), 1),
      t[6] || (t[6] = y(" entries ")),
      e.totalRecords > e.filteredRecords ? (p(), h(A, { key: 0 }, [
        t[1] || (t[1] = y(" (filtered from ")),
        a("strong", null, g(e.number(e.totalRecords)), 1),
        t[2] || (t[2] = y(" total entries) "))
      ], 64)) : P("", !0)
    ])) : P("", !0),
    a("div", w$t, [
      N(d, {
        striped: "",
        hover: "",
        fields: e.columns,
        items: e.rentals,
        busy: e.loading,
        "tbody-tr-class": e.rowStyle,
        "primary-key": "rentalId",
        responsive: "",
        class: "mb-0",
        "show-empty": ""
      }, {
        empty: ve((u) => [
          e.searched ? (p(), h(A, { key: 0 }, [
            y(g(u.emptyText), 1)
          ], 64)) : (p(), h(A, { key: 1 }, [
            y(" Please enter a search criteria to find rental properties. ")
          ], 64))
        ]),
        "head(address)": ve(() => t[7] || (t[7] = [
          y(" Property ")
        ])),
        "head(lastModified)": ve(() => t[8] || (t[8] = [
          y(" Last Updated ")
        ])),
        "head(ownerName)": ve(() => t[9] || (t[9] = [
          y(" Owner Name ")
        ])),
        "head(properties)": ve(() => t[10] || (t[10] = [
          y(" Properties ")
        ])),
        "head(viewed)": ve(() => t[11] || (t[11] = [
          y(" Viewed ")
        ])),
        "head(inCrm)": ve(() => t[12] || (t[12] = [
          y(" In CRM ")
        ])),
        "head(actions)": ve(() => t[13] || (t[13] = [
          y(" Original Listing ")
        ])),
        "cell(address)": ve((u) => [
          a("div", C$t, [
            a("div", S$t, [
              a("div", {
                class: "property-image",
                style: rn(e.getPropertyPhoto(u.item.photo))
              }, null, 4)
            ]),
            a("div", null, [
              N(l, {
                to: { path: "/homes/" + u.item.propId, hash: "#recordsTab" },
                target: "_blank"
              }, {
                default: ve(() => {
                  var m;
                  return [
                    a("address", P$t, [
                      y(g((m = u.item.address) == null ? void 0 : m.address), 1),
                      t[14] || (t[14] = a("i", { class: "fa-light fa-arrow-up-right-from-square ms-2" }, null, -1))
                    ])
                  ];
                }),
                _: 2
              }, 1032, ["to"]),
              a("ul", k$t, [
                a("li", E$t, [
                  t[15] || (t[15] = a("img", {
                    src: Cb,
                    height: "14",
                    width: "14",
                    class: "img-fluid me-1",
                    alt: "Blueprint",
                    title: "Blueprint"
                  }, null, -1)),
                  y(g(e.number(u.item.sqFt, void 0, "-")), 1)
                ]),
                a("li", I$t, [
                  t[16] || (t[16] = a("i", { class: "fa-light fa-bed me-1" }, null, -1)),
                  y(g(e.number(u.item.bedrooms, void 0, "-")), 1)
                ]),
                a("li", T$t, [
                  t[17] || (t[17] = a("i", { class: "fa-light fa-bath me-1" }, null, -1)),
                  y(g(e.number(u.item.bathrooms, void 0, "-")), 1)
                ]),
                a("li", O$t, [
                  t[18] || (t[18] = a("i", { class: "fa-light fa-birthday-cake me-1" }, null, -1)),
                  y(g(u.item.yearBuilt), 1)
                ])
              ])
            ])
          ])
        ]),
        "cell(lastModified)": ve((u) => [
          y(g(e.date(u.item.lastModified)), 1)
        ]),
        "cell(ownerName)": ve((u) => [
          y(g(u.item.ownerName), 1)
        ]),
        "cell(viewed)": ve((u) => [
          u.item.viewed ? (p(), h("i", R$t)) : P("", !0)
        ]),
        "cell(inCrm)": ve((u) => [
          u.item.inCrm ? (p(), h("i", L$t)) : P("", !0)
        ]),
        "cell(properties)": ve((u) => [
          y(g(e.number(u.item.properties)), 1)
        ]),
        "cell(actions)": ve((u) => [
          a("a", {
            href: u.item.url,
            target: "_blank"
          }, t[19] || (t[19] = [
            y("View on Zillow"),
            a("i", { class: "fa-light fa-arrow-up-right-from-square ms-2" }, null, -1)
          ]), 8, B$t)
        ]),
        _: 1
      }, 8, ["fields", "items", "busy", "tbody-tr-class"]),
      e.filteredRecords > 0 ? (p(), h("div", M$t, [
        a("div", x$t, [
          a("div", null, [
            t[22] || (t[22] = y(" Showing ")),
            a("strong", null, g(e.number(e.startRecord)), 1),
            t[23] || (t[23] = y(" to ")),
            a("strong", null, g(e.number(e.endRecord)), 1),
            t[24] || (t[24] = y(" of ")),
            a("strong", null, g(e.number(e.filteredRecords)), 1),
            t[25] || (t[25] = y(" entries ")),
            e.totalRecords > e.filteredRecords ? (p(), h(A, { key: 0 }, [
              t[20] || (t[20] = y(" (filtered from ")),
              a("strong", null, g(e.number(e.totalRecords)), 1),
              t[21] || (t[21] = y(" total entries) "))
            ], 64)) : P("", !0)
          ]),
          a("div", null, [
            e.filteredRecords > e.pageSize ? (p(), Fe(c, {
              key: 0,
              onPageClick: e.onPage,
              modelValue: e.curPage,
              "onUpdate:modelValue": t[0] || (t[0] = (u) => e.curPage = u),
              "total-rows": e.filteredRecords,
              "per-page": e.pageSize,
              "first-number": "",
              "last-number": "",
              align: "end",
              disabled: e.loading
            }, null, 8, ["onPageClick", "modelValue", "total-rows", "per-page", "disabled"])) : P("", !0)
          ])
        ])
      ])) : P("", !0)
    ])
  ]);
}
const Bds = /* @__PURE__ */ Ae(y$t, [["render", F$t], ["__scopeId", "data-v-dba3564f"]]), V$t = me({
  name: "FinancialIndicators",
  props: {
    groupId: Number
  },
  components: {},
  data() {
    return {
      financialIndAllYears: !1
    };
  },
  computed: {
    ...at(ba),
    ...q(Te, ["access", "aclLoaded"]),
    ...q(ba, ["financialIndicators"])
  },
  methods: {
    number: Ve,
    percent: Wt,
    currency: Ze,
    shortCurrency: ka,
    getYearType(e) {
      return Et == e ? "current" : Et > e ? "past" : "";
    }
  },
  mounted() {
    console.log(`${this.$options.name}.mounted`, this.groupId), this.aclLoaded.then(async () => {
      await this.portfolioInsightsStore.loadPortfolio(this.groupId);
    });
  }
}), D$t = {
  class: "accordion",
  id: "accordionIndicators"
}, N$t = { class: "accordion-item shadow" }, j$t = {
  id: "collapseIndicators",
  class: "accordion-collapse collapse show",
  "aria-labelledby": "headingIndicators",
  "data-bs-parent": "#accordionIndicators"
}, H$t = { class: "py-2 pe-4 bg-light d-flex justify-content-end" }, U$t = { class: "form-check form-switch form-switch-lg" }, z$t = { class: "accordion-body pt-0 px-0" }, W$t = { class: "table-responsive" }, G$t = ["current-year"], Y$t = { class: "text-end" }, X$t = ["data-year", "current-year"], q$t = ["data-year"], Q$t = ["data-year"], K$t = ["data-year"], Z$t = ["data-year"], J$t = ["data-year"], $$t = ["data-year"];
function _$t(e, t, s, n, r, i) {
  return p(), h("div", D$t, [
    a("div", N$t, [
      t[10] || (t[10] = a("h2", {
        class: "accordion-header",
        id: "headingIndicators"
      }, [
        a("button", {
          class: "accordion-button",
          type: "button",
          "data-bs-toggle": "collapse",
          "data-bs-target": "#collapseIndicators",
          "aria-expanded": "true",
          "aria-controls": "collapseIndicators"
        }, " Financial Indicators ")
      ], -1)),
      a("div", j$t, [
        a("div", H$t, [
          a("div", U$t, [
            V(a("input", {
              class: "form-check-input",
              type: "checkbox",
              role: "switch",
              id: "switchFullYearsIndicators",
              "onUpdate:modelValue": t[0] || (t[0] = (o) => e.financialIndAllYears = o)
            }, null, 512), [
              [Ue, e.financialIndAllYears]
            ]),
            t[1] || (t[1] = a("label", {
              class: "form-check-label",
              for: "switchFullYearsIndicators"
            }, "Show all years", -1))
          ])
        ]),
        a("div", z$t, [
          a("div", W$t, [
            a("table", {
              class: z(["table table-financial table-values regListing", { "table-full-years": e.financialIndAllYears }])
            }, [
              a("colgroup", null, [
                t[2] || (t[2] = a("col", { class: "grey" }, null, -1)),
                (p(!0), h(A, null, D(e.financialIndicators, (o) => (p(), h("col", {
                  "current-year": e.getYearType(o.year)
                }, null, 8, G$t))), 256))
              ]),
              a("thead", null, [
                a("tr", Y$t, [
                  t[3] || (t[3] = a("th", { scope: "col" }, " ", -1)),
                  (p(!0), h(A, null, D(e.financialIndicators, (o) => (p(), h("th", {
                    scope: "col",
                    "data-year": o.yearNumber,
                    "current-year": e.getYearType(o.year)
                  }, g(o.year), 9, X$t))), 256))
                ])
              ]),
              a("tbody", null, [
                a("tr", null, [
                  t[4] || (t[4] = a("th", { scope: "row" }, "CoC", -1)),
                  (p(!0), h(A, null, D(e.financialIndicators, (o) => (p(), h("td", {
                    "data-year": o.yearNumber
                  }, g(e.percent(o.coc)), 9, q$t))), 256))
                ]),
                a("tr", null, [
                  t[5] || (t[5] = a("th", { scope: "row" }, "IRR", -1)),
                  (p(!0), h(A, null, D(e.financialIndicators, (o) => (p(), h("td", {
                    "data-year": o.yearNumber
                  }, g(e.percent(o.irr)), 9, Q$t))), 256))
                ]),
                a("tr", null, [
                  t[6] || (t[6] = a("th", { scope: "row" }, "RoE", -1)),
                  (p(!0), h(A, null, D(e.financialIndicators, (o) => (p(), h("td", {
                    "data-year": o.yearNumber
                  }, g(e.percent(o.roe)), 9, K$t))), 256))
                ]),
                a("tr", null, [
                  t[7] || (t[7] = a("th", { scope: "row" }, "LTV", -1)),
                  (p(!0), h(A, null, D(e.financialIndicators, (o) => (p(), h("td", {
                    "data-year": o.yearNumber
                  }, g(e.percent(o.ltv)), 9, Z$t))), 256))
                ]),
                a("tr", null, [
                  t[8] || (t[8] = a("th", { scope: "row" }, "Debt Coverage Ratio", -1)),
                  (p(!0), h(A, null, D(e.financialIndicators, (o) => (p(), h("td", {
                    "data-year": o.yearNumber
                  }, g(e.number(o.debtCoverageRatio, 2)), 9, J$t))), 256))
                ]),
                a("tr", null, [
                  t[9] || (t[9] = a("th", { scope: "row" }, "OPEX Ratio", -1)),
                  (p(!0), h(A, null, D(e.financialIndicators, (o) => (p(), h("td", {
                    "data-year": o.yearNumber
                  }, g(e.number(o.operatingExpenseRatio, 2)), 9, $$t))), 256))
                ])
              ])
            ], 2)
          ])
        ])
      ])
    ])
  ]);
}
const Mds = /* @__PURE__ */ Ae(V$t, [["render", _$t]]), e_t = me({
  name: "FinancialOverview",
  props: {
    groupId: Number
  },
  components: {},
  data() {
    return {
      financialOverAllYears: !1
    };
  },
  computed: {
    ...q(Te, ["access", "aclLoaded"]),
    ...q(ba, ["financialOverview"]),
    ...at(ba)
  },
  methods: {
    number: Ve,
    currency: Ze,
    shortCurrency: ka,
    getYearType(e) {
      return Et == e ? "current" : Et > e ? "past" : "";
    }
  },
  mounted() {
    this.aclLoaded.then(() => {
      this.portfolioInsightsStore.loadPortfolio(this.groupId);
    });
  }
}), t_t = {
  class: "accordion full-years",
  id: "accordionFinancial"
}, s_t = { class: "accordion-item shadow" }, a_t = {
  id: "collapseFinancial",
  class: "accordion-collapse collapse show",
  "aria-labelledby": "headingFinancial",
  "data-bs-parent": "#accordionFinancial"
}, n_t = { class: "py-2 pe-4 bg-light d-flex justify-content-end" }, r_t = { class: "form-check form-switch form-switch-lg" }, o_t = { class: "accordion-body pt-0 px-0" }, i_t = { class: "table-responsive" }, l_t = ["current-year"], d_t = { class: "text-end" }, c_t = ["data-year", "current-year"], u_t = ["data-year"], p_t = ["title"], h_t = ["data-year"], m_t = ["title"], f_t = ["data-year"], g_t = ["title"], v_t = ["data-year"], y_t = ["title"], b_t = ["data-year"], A_t = ["title"];
function w_t(e, t, s, n, r, i) {
  return p(), h("div", t_t, [
    a("div", s_t, [
      t[9] || (t[9] = a("h2", {
        class: "accordion-header",
        id: "headingFinancial"
      }, [
        a("button", {
          class: "accordion-button",
          type: "button",
          "data-bs-toggle": "collapse",
          "data-bs-target": "#collapseFinancial",
          "aria-expanded": "true",
          "aria-controls": "collapseFinancial"
        }, " Financial Overview ")
      ], -1)),
      a("div", a_t, [
        a("div", n_t, [
          a("div", r_t, [
            V(a("input", {
              class: "form-check-input",
              type: "checkbox",
              role: "switch",
              id: "switchFullYearsOverview",
              "onUpdate:modelValue": t[0] || (t[0] = (o) => e.financialOverAllYears = o)
            }, null, 512), [
              [Ue, e.financialOverAllYears]
            ]),
            t[1] || (t[1] = a("label", {
              class: "form-check-label",
              for: "switchFullYearsOverview"
            }, "Show all years", -1))
          ])
        ]),
        a("div", o_t, [
          a("div", i_t, [
            a("table", {
              class: z(["table table-financial table-values regListing", { "table-full-years": e.financialOverAllYears }]),
              "data-access": "false"
            }, [
              a("colgroup", null, [
                t[2] || (t[2] = a("col", { class: "grey" }, null, -1)),
                (p(!0), h(A, null, D(e.financialOverview, (o) => (p(), h("col", {
                  "current-year": e.getYearType(o.year)
                }, null, 8, l_t))), 256))
              ]),
              a("thead", null, [
                a("tr", d_t, [
                  t[3] || (t[3] = a("th", { scope: "col" }, " ", -1)),
                  (p(!0), h(A, null, D(e.financialOverview, (o) => (p(), h("th", {
                    scope: "col",
                    "data-year": o.yearNumber,
                    "current-year": e.getYearType(o.year)
                  }, g(o.year), 9, c_t))), 256))
                ])
              ]),
              a("tbody", null, [
                a("tr", null, [
                  t[4] || (t[4] = a("th", { scope: "row" }, "Portfolio Value", -1)),
                  (p(!0), h(A, null, D(e.financialOverview, (o) => (p(), h("td", {
                    "data-year": o.yearNumber
                  }, [
                    a("span", {
                      title: e.currency(o.propertyValue)
                    }, g(e.shortCurrency(o.propertyValue)), 9, p_t)
                  ], 8, u_t))), 256))
                ]),
                a("tr", null, [
                  t[5] || (t[5] = a("th", { scope: "row" }, "Rental Rate", -1)),
                  (p(!0), h(A, null, D(e.financialOverview, (o) => (p(), h("td", {
                    "data-year": o.yearNumber
                  }, [
                    a("span", {
                      title: e.currency(o.rentalRate)
                    }, g(e.shortCurrency(o.rentalRate)), 9, m_t)
                  ], 8, h_t))), 256))
                ]),
                a("tr", null, [
                  t[6] || (t[6] = a("th", { scope: "row" }, "Monthly Cash Flow", -1)),
                  (p(!0), h(A, null, D(e.financialOverview, (o) => (p(), h("td", {
                    "data-year": o.yearNumber
                  }, [
                    a("span", {
                      title: e.currency(o.monthlyCashFlow)
                    }, g(e.shortCurrency(o.monthlyCashFlow)), 9, g_t)
                  ], 8, f_t))), 256))
                ]),
                a("tr", null, [
                  t[7] || (t[7] = a("th", { scope: "row" }, "Wealth Accumulation", -1)),
                  (p(!0), h(A, null, D(e.financialOverview, (o) => (p(), h("td", {
                    "data-year": o.yearNumber
                  }, [
                    a("span", {
                      title: e.currency(o.grossWealthAccumulation)
                    }, g(e.shortCurrency(o.grossWealthAccumulation)), 9, y_t)
                  ], 8, v_t))), 256))
                ]),
                a("tr", null, [
                  t[8] || (t[8] = a("th", { scope: "row" }, "Cash Out Equity", -1)),
                  (p(!0), h(A, null, D(e.financialOverview, (o) => (p(), h("td", {
                    "data-year": o.yearNumber
                  }, [
                    a("span", {
                      title: e.currency(o.cashOutEquity > 0 ? o.cashOutEquity : 0)
                    }, g(e.shortCurrency(o.cashOutEquity > 0 ? o.cashOutEquity : 0)), 9, A_t)
                  ], 8, b_t))), 256))
                ])
              ])
            ], 2)
          ])
        ])
      ])
    ])
  ]);
}
const xds = /* @__PURE__ */ Ae(e_t, [["render", w_t]]), C_t = me({
  name: "OwnerChecklist",
  props: {
    groupId: {
      type: Number,
      required: !0
    },
    currentUser: {
      type: Boolean,
      required: !1,
      default: !1
    }
  },
  components: {},
  data() {
    return {
      loadingTasks: !0,
      tasks: [],
      dialogTitle: void 0,
      dialogDescription: void 0
    };
  },
  computed: {
    hasTasks() {
      return this.tasks.length > 0;
    }
  },
  methods: {
    number: Ve,
    async getTasks() {
      try {
        const e = await W.api.portfolioInsights.getOwnerChecklist(this.groupId);
        if (e.data.status != de.Success)
          throw new Le(e);
        this.tasks.length = 0, this.tasks.push(...e.data.page);
      } catch (e) {
        Se(e);
      }
    },
    typeName(e) {
      switch (e.type) {
        case iv.ConfirmInvestmentDetails:
          return "Confirm Investment Details";
        default:
          return "Unknown task type";
      }
    },
    showHelpDialog(e) {
      var t;
      switch (e.type) {
        case iv.ConfirmInvestmentDetails:
          this.dialogTitle = "Investment Details", this.dialogDescription = "Investment Details offer a complete record of your property's initial and ongoing financial commitments. This includes the purchase date, purchase price, financing method, and the point at which it became a rental. The details also encompass the investment basis and your loan payment, ensuring every aspect of property expenses is accounted for. By consolidating information from public records and your input, we ensure the financial analysis of your property is as thorough and accurate as possible.";
          break;
        default:
          this.dialogTitle = "Owner-Paid Expenses", this.dialogDescription = "Owner-Paid Expenses encompass the expenses property owners pay outside of property management involvement. These typically include property taxes, insurance, homeowner's association (HOA) dues, and your loan payment. Integrating your loan payment, which is calculated from your investment details, along with these other expenses, gives a holistic view of your property's financial performance. This integration merges costs reported by your property manager with those they may not be aware of, ensuring a comprehensive understanding of your property's expenses.";
          break;
      }
      (t = bootstrap.Modal.getOrCreateInstance(this.$refs.dialogHelpInfo)) == null || t.show();
    },
    viewTask(e) {
      this.currentUser ? this.$router.push({ name: "folio-my-investments-property", params: { portfolioId: this.groupId, propId: e.propId }, hash: "#ConfirmInvestmentDetails" }) : this.$router.push({ name: "PI-client-property", params: { portfolioId: this.groupId, propId: e.propId }, hash: "#ConfirmInvestmentDetails" });
    }
  },
  created() {
  },
  mounted() {
    this.getTasks();
  }
}), S_t = {
  key: 0,
  class: "accordion",
  id: "accordionOwnerChecklist"
}, P_t = { class: "accordion-item shadow" }, k_t = {
  id: "collapseOwnerChecklist",
  class: "accordion-collapse collapse show",
  "aria-labelledby": "headingOwnerChecklist",
  "data-bs-parent": "#accordionOwnerChecklist"
}, E_t = { class: "accordion-body pt-0" }, I_t = { class: "card-scroll-full" }, T_t = { class: "table-responsive" }, O_t = { class: "table table-sm mb-0" }, R_t = { class: "align-middle" }, L_t = { class: "badge text-bg-warning" }, B_t = ["onClick"], M_t = ["onClick"], x_t = {
  key: 0,
  class: "modal fade",
  ref: "dialogHelpInfo",
  tabindex: "-1",
  "aria-labelledby": "modalInvestmentDetailsLabel",
  "aria-hidden": "true"
}, F_t = { class: "modal-dialog modal-dialog-centered" }, V_t = { class: "modal-content bg-gradient-alphabet rounded" }, D_t = { class: "modal-body pt-0" }, N_t = { class: "fw-bold fs-4" };
function j_t(e, t, s, n, r, i) {
  return p(), h(A, null, [
    N(ks, {
      name: "slide",
      mode: "out-in"
    }, {
      default: ve(() => [
        e.hasTasks ? (p(), h("div", S_t, [
          a("div", P_t, [
            t[3] || (t[3] = a("h2", {
              class: "accordion-header",
              id: "headingOwnerChecklist"
            }, [
              a("button", {
                class: "accordion-button",
                type: "button",
                "data-bs-toggle": "collapse",
                "data-bs-target": "#collapseOwnerChecklist",
                "aria-expanded": "true",
                "aria-controls": "collapseOwnerChecklist"
              }, " Property Owner Checklist ")
            ], -1)),
            a("div", k_t, [
              a("div", E_t, [
                t[2] || (t[2] = a("div", {
                  class: "alert alert-warning",
                  role: "alert"
                }, [
                  a("i", { class: "fa-light fa-warning me-2" }),
                  y("Please review the following checklist items. With your confirmation of the data and assumptions provided, the calculations in the analysis will be more accurate. ")
                ], -1)),
                a("div", I_t, [
                  a("div", T_t, [
                    a("table", O_t, [
                      t[1] || (t[1] = a("thead", null, [
                        a("tr", null, [
                          a("th", null, "Property"),
                          a("th", null, "Task"),
                          a("th")
                        ])
                      ], -1)),
                      a("tbody", null, [
                        (p(!0), h(A, null, D(e.tasks, (o) => (p(), h("tr", null, [
                          a("td", R_t, g(o.address), 1),
                          a("td", null, [
                            a("span", L_t, g(e.typeName(o)), 1),
                            a("button", {
                              type: "button",
                              class: "btn btn-link",
                              onClick: (l) => e.showHelpDialog(o)
                            }, t[0] || (t[0] = [
                              a("i", { class: "fa-light fa-circle-question" }, null, -1)
                            ]), 8, B_t)
                          ]),
                          a("td", null, [
                            a("button", {
                              type: "button",
                              class: "btn btn-success btn-sm",
                              onClick: (l) => e.viewTask(o)
                            }, "View", 8, M_t)
                          ])
                        ]))), 256))
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])) : P("", !0)
      ]),
      _: 1
    }),
    e.hasTasks ? (p(), h("div", x_t, [
      a("div", F_t, [
        a("div", V_t, [
          t[4] || (t[4] = a("div", { class: "modal-header border-0" }, [
            a("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            })
          ], -1)),
          a("div", D_t, [
            a("p", N_t, g(e.dialogTitle), 1),
            a("p", null, g(e.dialogDescription), 1)
          ]),
          t[5] || (t[5] = a("div", { class: "modal-footer border-0" }, [
            a("button", {
              type: "button",
              class: "btn btn-secondary",
              "data-bs-dismiss": "modal"
            }, "Close")
          ], -1))
        ])
      ])
    ], 512)) : P("", !0)
  ], 64);
}
const Fds = /* @__PURE__ */ Ae(C_t, [["render", j_t]]);
Rt.register(qr, Xr, Qr, Kr, Zr, Jr, $r);
const H_t = "#820401", ZS = "#DE542C", U_t = new xa(), z_t = me({
  name: "PerformanceCharts",
  data() {
    return {
      chartsInitialized: !1,
      chartOptionsSet: !1,
      chart1Data: void 0,
      chart1Options: void 0,
      chart2Data: void 0,
      chart2Options: void 0,
      chart3Data: void 0,
      chart3Options: void 0
    };
  },
  watch: {
    financialOverview(e) {
      console.log(`${this.$options.name}.financialOverview`, e), this.refreshCharts();
    }
  },
  computed: {
    ...q(ba, ["financialOverview", "portfolioSummary", "portfolioLoaded"]),
    ...at(ba)
  },
  methods: {
    number: Ve,
    getChartBackgroundColors(e, t, s = !0) {
      return [
        ...e.filter((n) => n.year < Et && s !== !0).map((n) => t(n) ? ZS : De.Colors.Charts.LightBlue),
        ...e.filter((n) => n.year == Et && s !== !0).map((n) => t(n) ? H_t : De.Colors.Charts.DarkBlue),
        ...e.filter((n) => n.year > Et || s === !0).map((n) => t(n) ? De.Colors.Charts.Red : De.Colors.Charts.Green)
      ];
    },
    initCharts() {
      if (console.log(`${this.$options.name}.initCharts`), this.$refs.chart1 && !this.chart1) {
        const e = tr("bar", this.chart1Data, this.chart1Options, [Rd()]);
        this.chart1 = new Rt(this.$refs.chart1, e);
      }
      if (this.$refs.chart2 && !this.chart2) {
        const e = tr("line", this.chart2Data, this.chart2Options);
        this.chart2 = new Rt(this.$refs.chart2, e);
      }
      if (this.$refs.chart3 && !this.chart3) {
        const e = tr("bar", this.chart3Data, this.chart3Options, [Rd()]);
        this.chart3 = new Rt(this.$refs.chart3, e);
      }
      this.chartsInitialized = !0, this.refreshCharts();
    },
    async setChartOptions() {
      console.log(`${this.$options.name}.setChartOptions`), await U_t.runExclusive(() => {
        this.chartOptionsSet || (this.chart1Data = Ld(), this.chart1Data.datasets[0].hidden = !0, this.chart1Data.datasets[1].hidden = !0, this.chart1Options = Bd(), this.chart2Data = lf(), this.chart2Data.datasets[0].hidden = !0, this.chart2Data.datasets[0].borderColor = De.Colors.Charts.Blue, this.chart2Data.datasets[0].borderWidth = 1, this.chart2Data.datasets[0].pointRadius = 3, this.chart2Data.datasets[1].hidden = !0, this.chart2Data.datasets[2].hidden = !0, this.chart2Options = df(), this.chart3Data = Ld(), this.chart3Data.datasets[0].hidden = !0, this.chart3Data.datasets[1].hidden = !0, this.chart3Options = Bd(), this.chartsInitialized || this.initCharts(), this.chartOptionsSet = !0);
      });
    },
    refreshCharts() {
      var i, o, l;
      const e = this.financialOverview.map((d) => d.year);
      let t = Et;
      const s = e.filter((d) => d >= t && d <= t + 6), n = this.financialOverview.filter((d) => d.year >= t && d.year <= t + 6), r = e.filter((d) => d == Et).map((d) => De.Colors.Charts.DarkBlue).concat(e.filter((d) => d > Et).map((d) => De.Colors.Charts.Green));
      if (this.chart1 && ((i = this.financialOverview) == null ? void 0 : i.length) > 0) {
        let d = De.Colors.Charts.DarkBlue;
        this.portfolioSummary.t12CashFlow < 0 && (d = ZS), this.chart1Data.labels = ["T-12", ...s.map((c) => `${c}`)], this.chart1Data.datasets[0].label = void 0, this.chart1Data.datasets[0].backgroundColor = [d, ...this.getChartBackgroundColors(n, (c) => (c.monthlyCashFlow ?? 0) * 12 < 0, !0)], this.chart1Data.datasets[0].data = [this.portfolioSummary.t12CashFlow, ...n.map((c) => Math.trunc((c.monthlyCashFlow ?? 0) * 12))], this.chart1Data.datasets[0].hidden = !1, this.chart1.update(), this.chart1.resize();
      }
      this.chart2 && ((o = this.financialOverview) == null ? void 0 : o.length) > 0 && (this.chart2Data.labels = s.map((d) => `${d}`), this.chart2Data.datasets[0].pointBorderColor = r, this.chart2Data.datasets[0].pointBackgroundColor = r, this.chart2Data.datasets[0].data = n.map((d) => d.coc), this.chart2Data.datasets[0].hidden = !1, this.chart2.update(), this.chart2.resize()), this.chart3 && ((l = this.financialOverview) == null ? void 0 : l.length) > 0 && (this.chart3Data.labels = s.map((d) => `${d}`), this.chart3Data.datasets[0].label = void 0, this.chart3Data.datasets[0].backgroundColor = this.getChartBackgroundColors(n, (d) => (d.netEquity ?? 0) < 0, !1), this.chart3Data.datasets[0].data = n.map((d) => d.netEquity), this.chart3Data.datasets[0].hidden = !1, this.chart3.update(), this.chart3.resize());
    }
  },
  mounted() {
    console.log(`${this.$options.name}.mounted`), this.portfolioLoaded.then(async () => await this.setChartOptions()).then(() => this.refreshCharts());
  }
}), W_t = { class: "card shadow" }, G_t = { class: "card-body" }, Y_t = { class: "row row-cols-lg-3 g-3" }, X_t = { class: "col text-center" }, q_t = {
  class: "chart",
  style: { position: "relative" }
}, Q_t = {
  "data-id": "chart1",
  class: "cashFlowChart",
  id: "chart1",
  ref: "chart1",
  height: "188"
}, K_t = { class: "col text-center" }, Z_t = {
  class: "chart",
  style: { position: "relative" }
}, J_t = {
  "data-id": "chart2",
  class: "cocChart",
  id: "chart2",
  ref: "chart2",
  height: "188"
}, $_t = { class: "col text-center" }, __t = {
  class: "chart",
  style: { position: "relative" }
}, ees = {
  "data-id": "chart3",
  class: "netEquityChart",
  id: "chart3",
  ref: "chart3",
  height: "188"
};
function tes(e, t, s, n, r, i) {
  return p(), h("div", W_t, [
    a("div", G_t, [
      a("div", Y_t, [
        a("div", X_t, [
          t[0] || (t[0] = a("p", { class: "fw-bold" }, "Annual Cash Flow", -1)),
          a("div", q_t, [
            a("canvas", Q_t, null, 512)
          ])
        ]),
        a("div", K_t, [
          t[1] || (t[1] = a("p", { class: "fw-bold" }, "Return on Investment", -1)),
          a("div", Z_t, [
            a("canvas", J_t, null, 512)
          ])
        ]),
        a("div", $_t, [
          t[2] || (t[2] = a("p", { class: "fw-bold" }, "Net Equity", -1)),
          a("div", __t, [
            a("canvas", ees, null, 512)
          ])
        ])
      ])
    ])
  ]);
}
const Vds = /* @__PURE__ */ Ae(z_t, [["render", tes]]), ses = me({
  name: "SummaryView",
  computed: {
    containerStyle() {
      var e, t;
      return {
        row: !0,
        "row-cols-2": !0,
        "row-cols-sm-3": !0,
        "row-cols-lg-4": ((e = this.portfolioSummary) == null ? void 0 : e.hasIrrTimeGap) == !0,
        "row-cols-lg-5": ((t = this.portfolioSummary) == null ? void 0 : t.hasIrrTimeGap) != !0,
        "g-3": !0,
        "g-md-2": !0
      };
    },
    ...q(Te, ["access", "aclLoaded"]),
    ...q(ba, ["portfolioSummary"])
  },
  methods: {
    number: Ve,
    currency: Ze,
    percent: Wt
  },
  mounted() {
    this.aclLoaded.then(() => {
    });
  }
}), aes = { class: "card shadow border" }, nes = { class: "card-body" }, res = { class: "accordion-body pt-0" }, oes = { class: "col" }, ies = { class: "bg-light rounded p-2 text-center h-100" }, les = { class: "fs-5 fw-bold" }, des = { class: "col" }, ces = { class: "bg-light rounded p-2 text-center h-100" }, ues = { class: "fs-5 fw-bold" }, pes = {
  key: 0,
  class: "col"
}, hes = { class: "bg-light rounded p-2 text-center h-100" }, mes = { class: "fs-5 fw-bold" }, fes = { class: "col" }, ges = { class: "bg-light rounded p-2 text-center h-100" }, ves = { class: "fs-5 fw-bold" }, yes = { class: "col" }, bes = { class: "bg-light rounded p-2 text-center h-100" }, Aes = { class: "fs-5 fw-bold" }, wes = { class: "col" }, Ces = { class: "bg-light rounded p-2 text-center h-100" }, Ses = { class: "fs-5 fw-bold" }, Pes = { class: "col" }, kes = { class: "bg-light rounded p-2 text-center h-100" }, Ees = { class: "fs-5 fw-bold" }, Ies = {
  key: 1,
  class: "col"
}, Tes = { class: "bg-light rounded p-2 text-center h-100" }, Oes = { class: "fs-5 fw-bold" }, Res = { class: "col" }, Les = { class: "bg-light rounded p-2 text-center h-100" }, Bes = { class: "fs-5 fw-bold" }, Mes = { class: "col" }, xes = { class: "bg-light rounded p-2 text-center h-100" }, Fes = { class: "fs-5 fw-bold" };
function Ves(e, t, s, n, r, i) {
  var o, l, d, c, u, m, f, v, b, w, S, I, T;
  return p(), h("div", aes, [
    t[20] || (t[20] = a("div", { class: "card-header bg-white fw-bold border-0 fs-6 pb-0" }, " Summary ", -1)),
    a("div", nes, [
      a("div", res, [
        a("div", {
          class: z(e.containerStyle)
        }, [
          a("div", oes, [
            a("div", ies, [
              a("b", les, g(e.currency((o = e.portfolioSummary) == null ? void 0 : o.totalPropertyValue)), 1),
              t[0] || (t[0] = a("br", null, null, -1)),
              t[1] || (t[1] = a("small", { class: "text-uppercase text-xsmall" }, "Portfolio Value", -1))
            ])
          ]),
          a("div", des, [
            a("div", ces, [
              a("b", ues, g(e.currency((l = e.portfolioSummary) == null ? void 0 : l.totalLoanBalance)), 1),
              t[2] || (t[2] = a("br", null, null, -1)),
              t[3] || (t[3] = a("small", { class: "text-uppercase text-xsmall" }, " Total Loan Balance", -1))
            ])
          ]),
          (d = e.portfolioSummary) != null && d.hasIrrTimeGap ? P("", !0) : (p(), h("div", pes, [
            a("div", hes, [
              a("b", mes, g(e.percent((c = e.portfolioSummary) == null ? void 0 : c.ltv)), 1),
              t[4] || (t[4] = a("br", null, null, -1)),
              t[5] || (t[5] = a("small", { class: "text-uppercase text-xsmall" }, "Loan To Value", -1))
            ])
          ])),
          a("div", fes, [
            a("div", ges, [
              a("b", ves, g(e.currency((u = e.portfolioSummary) == null ? void 0 : u.totalNetEquity)), 1),
              t[6] || (t[6] = a("br", null, null, -1)),
              t[7] || (t[7] = a("small", { class: "text-uppercase text-xsmall" }, "Net Equity", -1))
            ])
          ]),
          a("div", yes, [
            a("div", bes, [
              a("b", Aes, g(e.currency((((m = e.portfolioSummary) == null ? void 0 : m.cashOutEquity) ?? 0) > 0 ? (f = e.portfolioSummary) == null ? void 0 : f.cashOutEquity : 0)), 1),
              t[8] || (t[8] = a("br", null, null, -1)),
              t[9] || (t[9] = a("small", { class: "text-uppercase text-xsmall" }, "Cash Out Equity", -1))
            ])
          ]),
          a("div", wes, [
            a("div", Ces, [
              a("b", Ses, g(e.currency((v = e.portfolioSummary) == null ? void 0 : v.initialInvestment)), 1),
              t[10] || (t[10] = a("br", null, null, -1)),
              t[11] || (t[11] = a("small", { class: "text-uppercase text-xsmall" }, "Total Investment", -1))
            ])
          ]),
          a("div", Pes, [
            a("div", kes, [
              a("b", Ees, g(e.percent((b = e.portfolioSummary) == null ? void 0 : b.t12coc, 2)), 1),
              t[12] || (t[12] = a("br", null, null, -1)),
              t[13] || (t[13] = a("small", { class: "text-uppercase text-xsmall" }, "T-12 Portfolio ROI", -1))
            ])
          ]),
          (w = e.portfolioSummary) != null && w.hasIrrTimeGap ? P("", !0) : (p(), h("div", Ies, [
            a("div", Tes, [
              a("b", Oes, g(e.percent((S = e.portfolioSummary) == null ? void 0 : S.irr, 1)), 1),
              t[14] || (t[14] = a("br", null, null, -1)),
              t[15] || (t[15] = a("small", { class: "text-uppercase text-xsmall" }, "Portfolio IRR", -1))
            ])
          ])),
          a("div", Res, [
            a("div", Les, [
              a("b", Bes, g(e.currency((I = e.portfolioSummary) == null ? void 0 : I.t12CashFlow)), 1),
              t[16] || (t[16] = a("br", null, null, -1)),
              t[17] || (t[17] = a("small", { class: "text-uppercase text-xsmall" }, "T-12 Cash flow", -1))
            ])
          ]),
          a("div", Mes, [
            a("div", xes, [
              a("b", Fes, g(e.currency((T = e.portfolioSummary) == null ? void 0 : T.wealthAccumulation)), 1),
              t[18] || (t[18] = a("br", null, null, -1)),
              t[19] || (t[19] = a("small", { class: "text-uppercase text-xsmall" }, "Wealth Accumulation", -1))
            ])
          ])
        ], 2)
      ])
    ])
  ]);
}
const Dds = /* @__PURE__ */ Ae(ses, [["render", Ves]]), Des = me({
  name: "PortfolioInsightsSummary",
  props: {},
  components: {},
  data() {
    return {
      clientCount: void 0,
      propertyCount: void 0,
      aggregateValue: void 0
    };
  },
  computed: {
    ...q(Te, ["access", "aclLoaded"])
  },
  methods: {
    number: Ve
  },
  created() {
  },
  mounted() {
    this.aclLoaded.then(async () => {
      var t, s, n, r;
      const e = await W.api.rentvineIntegration.getSettings();
      this.clientCount = (s = (t = e.data.settings) == null ? void 0 : t.clients) == null ? void 0 : s.imported, this.propertyCount = (r = (n = e.data.settings) == null ? void 0 : n.properties) == null ? void 0 : r.imported;
    });
  }
}), Nes = {
  key: 0,
  class: "card shadow-sm card-na"
}, jes = { class: "card-body" }, Hes = { class: "d-flex justify-content-between gap-3 flex-column flex-lg-row" }, Ues = { class: "bg-light rounded p-3 text-center" }, zes = { class: "fw-bold fs-5" }, Wes = { class: "bg-light rounded p-3 text-center" }, Ges = { class: "fw-bold fs-5" }, Yes = { class: "bg-light rounded p-3 text-center" }, Xes = { class: "fw-bold fs-5" }, qes = { class: "card-footer text-end bg-white border-0" };
function Qes(e, t, s, n, r, i) {
  var l;
  const o = pe("router-link");
  return (l = e.access) != null && l.portfolioInsights ? (p(), h("div", Nes, [
    t[7] || (t[7] = a("div", { class: "card-header fw-bold border-0 bg-white fs-5 text-body-secondary pb-0" }, " Portfolio Insights Summary ", -1)),
    a("div", jes, [
      a("div", Hes, [
        a("div", Ues, [
          a("span", zes, g(e.number(e.clientCount, void 0, "-")), 1),
          t[0] || (t[0] = a("br", null, null, -1)),
          t[1] || (t[1] = a("small", { class: "text-body-secondary" }, "REGISTERED CLIENTS", -1))
        ]),
        a("div", Wes, [
          a("span", Ges, g(e.number(e.propertyCount, void 0, "-")), 1),
          t[2] || (t[2] = a("br", null, null, -1)),
          t[3] || (t[3] = a("small", { class: "text-body-secondary" }, "DOORS IN PORTFOLIOS", -1))
        ]),
        a("div", Yes, [
          a("span", Xes, g(e.number(e.aggregateValue, void 0, "-")), 1),
          t[4] || (t[4] = a("br", null, null, -1)),
          t[5] || (t[5] = a("small", { class: "text-body-secondary" }, "AGGREGATE VALUE", -1))
        ])
      ])
    ]),
    a("div", qes, [
      N(o, { to: "/portfolio-insights/clients" }, {
        default: ve(() => t[6] || (t[6] = [
          y("View Portfolio Insights Dashboard "),
          a("i", { class: "fa-light fa-arrow-right-long ms-2" }, null, -1)
        ])),
        _: 1,
        __: [6]
      })
    ])
  ])) : P("", !0);
}
const Nds = /* @__PURE__ */ Ae(Des, [["render", Qes]]);
let Zy = null;
const Kes = new Promise((e) => Zy = e), Zes = me({
  name: "PropertyLocations",
  components: {},
  data() {
    return {
      mapOptions: void 0,
      center: void 0,
      markers: []
    };
  },
  computed: {
    ...q(Te, ["access", "aclLoaded"]),
    ...q(ba, ["portfolioName", "hasMultiple", "hasAssets", "clientsInfo", "properties", "portfolioInsightsErrorMessage", "portfoliosLoading", "portfolioSummary", "portfolioLoaded"])
  },
  watch: {
    properties() {
      Kes.then(() => {
        var t;
        const e = new google.maps.LatLngBounds();
        (t = this.properties) == null || t.forEach((s) => {
          const n = new google.maps.marker.AdvancedMarkerElement({
            map: this.map,
            position: {
              lat: s.latitude,
              lng: s.longitude
            }
          });
          this.markers.push({
            marker: n,
            item: s
          }), e.extend(n.position);
        }), e.isEmpty() == !1 && (google.maps.event.addListenerOnce(this.map, "bounds_changed", () => {
          this.map.setZoom(Math.min(this.map.getZoom(), 13));
        }), this.$nextTick(() => {
          this.map.fitBounds(e, 1);
        }));
      });
    }
  },
  methods: {
    number: Ve,
    //#region Map Controls
    mapInit() {
      this.center = {
        lat: 30.173937,
        lng: -95.505836
      }, this.mapOptions = {
        zoom: 10,
        //this.currentZoom,
        disableDefaultUI: !0,
        streetViewControl: !0,
        streetViewControlOptions: {
          position: google.maps.ControlPosition.LEFT_BOTTOM
        },
        isFractionalZoomEnabled: !1
      }, this.map = this.$refs.gMap.$mapObject, Zy && Zy(!0);
    },
    zoomOut() {
      const e = this.map.getZoom();
      this.map.setZoom(e - 1);
    },
    zoomIn() {
      const e = this.map.getZoom();
      this.map.setZoom(e + 1);
    }
    //#endregion
  },
  mounted() {
    this.portfolioLoaded.then(async () => await this.$gmapApiPromiseLazy()).then(() => {
      this.mapInit();
    }).catch((e) => {
      Se(e);
    });
  }
}), Jes = { class: "card shadow" }, $es = {
  class: "bg-light d-flex align-items-center justify-content-center position-relative",
  style: { height: "330px", width: "100%" }
}, _es = {
  id: "mapControls",
  class: "position-absolute d-flex justify-content-between gap-2 flex-column",
  style: { "z-index": "100", bottom: "15px", right: "15px" }
};
function ets(e, t, s, n, r, i) {
  const o = pe("GMapMap");
  return p(), h("div", Jes, [
    t[4] || (t[4] = a("div", { class: "card-header bg-white fw-bold border-0 fs-6" }, " Property Locations ", -1)),
    a("div", $es, [
      a("div", _es, [
        a("button", {
          onClick: t[0] || (t[0] = (...l) => e.zoomIn && e.zoomIn(...l)),
          class: "btn btn-light shadow-sm"
        }, t[2] || (t[2] = [
          a("i", { class: "fa-light fa-plus" }, null, -1),
          a("span", { class: "visually-hidden" }, "Zoom in", -1)
        ])),
        a("button", {
          onClick: t[1] || (t[1] = (...l) => e.zoomOut && e.zoomOut(...l)),
          class: "btn btn-light shadow-sm"
        }, t[3] || (t[3] = [
          a("i", { class: "fa-light fa-minus" }, null, -1),
          a("span", { class: "visually-hidden" }, "Zoom out", -1)
        ]))
      ]),
      N(o, {
        ref: "gMap",
        class: "h-100 w-100",
        "map-id": "2ddbbe0dd6bcf8f9",
        center: e.center,
        options: e.mapOptions
      }, null, 8, ["center", "options"])
    ])
  ]);
}
const jds = /* @__PURE__ */ Ae(Zes, [["render", ets]]), tts = me({
  name: "MyCurrentAssets",
  props: {
    clientId: Number,
    googleApi: String
  },
  components: {},
  data() {
    return {
      showDeleted: !1,
      propertyToDelete: void 0
    };
  },
  watch: {
    showDeleted(e) {
      componentDebug && console.log(`${this.$options.name}.showDeleted`, e), this.portfolioInsightsStore.showDeleted = this.showDeleted, this.portfolioInsightsStore.refreshPortfolio();
    }
  },
  computed: {
    ...q(Te, ["access", "aclLoaded"]),
    ...q(ba, ["portfolioName", "hasMultiple", "hasAssets", "clientsInfo", "properties", "portfolioInsightsErrorMessage", "portfoliosLoading", "portfolioSummary", "portfolioId"]),
    ...at(Te, ba)
  },
  methods: {
    number: Ve,
    currency: Ze,
    percent: Wt,
    propertyRowStyle(e) {
      return {
        "has-error": e.missingPurchaseFacts == !0
      };
    },
    viewProperty(e) {
      this.clientId ? this.$router.push({ name: "PI-client-property", params: { clientId: this.clientId, portfolioId: this.portfolioId, propId: e.propId } }) : this.$router.push({ name: "folio-my-investments-property", params: { portfolioId: this.portfolioId, propId: e.propId } });
    },
    getPropertyPhoto(e) {
      return e.photo ? e.photo : this.googleApi ? `https://maps.googleapis.com/maps/api/streetview?return_error_code=true&size=400x248&location=${encodeURIComponent(e.address)}%20${encodeURIComponent(e.city)},${encodeURIComponent(e.state)}%20${encodeURIComponent(e.zip)}&fov=80&key=${this.googleApi}` : "/images/no-image.jpg";
    },
    resolvePropertyUrl(e) {
      return this.clientId ? this.$router.resolve({ name: "PI-client-property", params: { clientId: this.clientId, portfolioId: this.portfolioId, propId: e.propId } }).href : this.$router.resolve({ name: "folio-my-investments-property", params: { portfolioId: this.portfolioId, propId: e.propId } }).href;
    },
    portfolioRouteName(e) {
      return this.clientId ? "PI-client-property" : "folio-my-investments-property";
    },
    portfolioRouteParams(e) {
      return this.clientId ? {
        clientId: this.clientId,
        portfolioId: this.portfolioId,
        propId: e.propId
      } : {
        portfolioId: this.portfolioId,
        propId: e.propId
      };
    },
    async deleteProperty() {
      componentDebug && console.log(`${this.$options.name}.deleteProperty`);
      try {
        const e = await rescoverApi.api.portfolioInsights.removeProperty(this.portfolioId, this.propertyToDelete.propId);
        if (e.data.status != RequestStatus.Success)
          throw new Error(e.data.message);
        this.propertyToDelete = void 0, await this.portfolioInsightsStore.loadPortfolio();
      } catch (e) {
        utils.showError(e);
      }
      bootstrap.Modal.getOrCreateInstance(this.$refs.modalDeleteProperty).hide();
    },
    verifyToDelete(e) {
      this.propertyToDelete = e;
      const t = bootstrap.Modal.getOrCreateInstance(this.$refs.modalDeleteProperty);
      t == null || t.show();
    },
    async restoreProperty(e) {
      componentDebug && console.log(`${this.$options.name}.restoreProperty`);
      try {
        const t = await rescoverApi.api.portfolioInsights.restoreProperty(this.portfolioId, e.propId);
        if (t.data.status != RequestStatus.Success)
          throw new Error(t.data.message);
        await this.portfolioInsightsStore.loadPortfolio();
      } catch (t) {
        utils.showError(t);
      }
    }
  },
  mounted() {
    this.aclLoaded.then(() => {
    });
  }
}), sts = {
  class: "accordion",
  id: "accordionDetails"
}, ats = { class: "accordion-item shadow" }, nts = {
  id: "collapseDetails",
  class: "accordion-collapse collapse show",
  "aria-labelledby": "headingDetails",
  "data-bs-parent": "#accordionDetails"
}, rts = { class: "p-2 bg-light d-flex justify-content-end" }, ots = { class: "form-check form-switch" }, its = ["disabled"], lts = { class: "table-responsive" }, dts = { class: "table table-striped" }, cts = ["onClick"], uts = { class: "d-flex align-items-center" }, pts = { class: "flex-shrink-0" }, hts = { class: "card-photo-sm" }, mts = { class: "flex-grow-1 ms-2 property-info" }, fts = { class: "fw-bold" }, gts = { class: "list-inline text-small m-0" }, vts = { class: "list-inline-item" }, yts = { class: "list-inline-item" }, bts = { class: "list-inline-item" }, Ats = { class: "list-inline-item" }, wts = { class: "align-middle" }, Cts = {
  key: 0,
  class: "fa-light fa-triangle-exclamation text-warning",
  "data-bs-toggle": "tooltip",
  "data-bs-title": "Existing investment data needs attention."
}, Sts = { class: "text-end align-middle" }, Pts = { class: "text-end align-middle" }, kts = { class: "text-end align-middle" }, Ets = { class: "text-end align-middle" }, Its = { class: "text-end align-middle" }, Tts = { class: "text-end align-middle" }, Ots = ["title"], Rts = { class: "text-center end align-middle" }, Lts = {
  class: "modal fade",
  id: "modalDeleteProperty",
  ref: "modalDeleteProperty",
  tabindex: "-1",
  "aria-labelledby": "modalDeletePropertyLabel",
  "aria-hidden": "true"
}, Bts = { class: "modal-dialog modal-dialog-centered" }, Mts = { class: "modal-content bg-gradient-alphabet rounded" }, xts = { class: "modal-body text-center px-8 pt-8" }, Fts = { class: "modal-footer pt-0 pb-8 border-0 justify-content-center" };
function Vts(e, t, s, n, r, i) {
  var l, d, c, u;
  const o = pe("router-link");
  return p(), h(A, null, [
    a("div", sts, [
      a("div", ats, [
        t[11] || (t[11] = a("h2", {
          class: "accordion-header",
          id: "headingDetails"
        }, [
          a("button", {
            class: "accordion-button",
            type: "button",
            "data-bs-toggle": "collapse",
            "data-bs-target": "#collapseDetails",
            "aria-expanded": "true",
            "aria-controls": "collapseDetails"
          }, " My Current Assets ")
        ], -1)),
        a("div", nts, [
          a("div", rts, [
            a("div", ots, [
              V(a("input", {
                "onUpdate:modelValue": t[0] || (t[0] = (m) => e.showDeleted = m),
                class: "form-check-input",
                type: "checkbox",
                role: "switch",
                id: "switchShowDeleted",
                disabled: e.portfoliosLoading
              }, null, 8, its), [
                [Ue, e.showDeleted]
              ]),
              t[2] || (t[2] = a("label", {
                class: "form-check-label",
                for: "switchShowDeleted"
              }, "Show deleted properties", -1))
            ])
          ]),
          a("div", lts, [
            a("table", dts, [
              t[10] || (t[10] = a("thead", null, [
                a("tr", null, [
                  a("th", null, "Address"),
                  a("th"),
                  a("th", { class: "text-end" }, "Value"),
                  a("th", { class: "text-end" }, "Cash Invested"),
                  a("th", { class: "text-end" }, "Net Equity"),
                  a("th", { class: "text-end" }, "Rental Rate"),
                  a("th", { class: "text-end" }, "T-12 Cash Flow"),
                  a("th", { class: "text-end" }, "T-12 ROI"),
                  a("th")
                ])
              ], -1)),
              a("tbody", null, [
                (p(!0), h(A, null, D(e.properties, (m) => (p(), h("tr", {
                  class: z(e.propertyRowStyle(m))
                }, [
                  a("td", {
                    onClick: (f) => e.viewProperty(m),
                    style: { cursor: "pointer", "text-decoration-line": "underline" }
                  }, [
                    a("div", uts, [
                      a("div", pts, [
                        a("div", hts, [
                          a("div", {
                            class: "property-image",
                            style: rn("background-image: url(" + e.getPropertyPhoto(m) + ")")
                          }, null, 4)
                        ])
                      ]),
                      a("div", mts, [
                        N(o, {
                          name: e.portfolioRouteName(m),
                          params: e.portfolioRouteParams(m)
                        }, {
                          default: ve(() => [
                            a("span", fts, g(m.address), 1),
                            t[3] || (t[3] = a("i", { class: "fa-light fa-arrow-up-right-from-square ms-2" }, null, -1))
                          ]),
                          _: 2,
                          __: [3]
                        }, 1032, ["name", "params"]),
                        a("ul", gts, [
                          a("li", vts, [
                            t[4] || (t[4] = a("i", { class: "fa-light fa-ruler-triangle me-1" }, null, -1)),
                            y(g(e.number(m.sqFt)) + " SF", 1)
                          ]),
                          a("li", yts, [
                            t[5] || (t[5] = a("i", { class: "fa-light fa-bed me-1" }, null, -1)),
                            y(g(m.bedrooms), 1)
                          ]),
                          a("li", bts, [
                            t[6] || (t[6] = a("i", { class: "fa-light fa-shower me-1" }, null, -1)),
                            y(g(e.number(m.bathrooms, 1)), 1)
                          ]),
                          a("li", Ats, [
                            t[7] || (t[7] = a("i", { class: "fa-light fa-cake-candles me-1" }, null, -1)),
                            y(g(m.yearBuilt), 1)
                          ])
                        ])
                      ])
                    ])
                  ], 8, cts),
                  a("td", wts, [
                    m.needsCorrections ? (p(), h("i", Cts)) : P("", !0)
                  ]),
                  a("td", Sts, g(e.currency(m.propertyValue)), 1),
                  a("td", Pts, g(e.currency(m.initialInvestment)), 1),
                  a("td", kts, g(e.currency(m.netEquity)), 1),
                  a("td", Ets, g(e.currency(m.rentalRate)), 1),
                  a("td", Its, g(e.currency(m.t12CashFlow)), 1),
                  a("td", Tts, [
                    a("span", {
                      title: e.percent(m.coc, 2)
                    }, g(e.percent(m.coc, 1)), 9, Ots)
                  ]),
                  a("td", Rts, [
                    P("", !0)
                  ])
                ], 2))), 256))
              ])
            ])
          ])
        ])
      ])
    ]),
    a("div", Lts, [
      a("div", Bts, [
        a("div", Mts, [
          a("div", xts, [
            t[16] || (t[16] = a("i", { class: "fa-duotone fa-solid fa-house-circle-xmark mb-3 fa-2xl" }, null, -1)),
            a("p", null, [
              t[12] || (t[12] = a("b", null, "Are you sure you want to delete this property from this portfolio?", -1)),
              t[13] || (t[13] = a("br", null, null, -1)),
              t[14] || (t[14] = a("br", null, null, -1)),
              y(" " + g((l = e.propertyToDelete) == null ? void 0 : l.address), 1),
              t[15] || (t[15] = a("br", null, null, -1)),
              y(g((d = e.propertyToDelete) == null ? void 0 : d.city) + ", " + g((c = e.propertyToDelete) == null ? void 0 : c.state) + " " + g((u = e.propertyToDelete) == null ? void 0 : u.zip), 1)
            ])
          ]),
          a("div", Fts, [
            t[17] || (t[17] = a("button", {
              type: "button",
              class: "btn btn-secondary",
              "data-bs-dismiss": "modal"
            }, "Cancel", -1)),
            a("button", {
              type: "button",
              onClick: t[1] || (t[1] = (...m) => e.deleteProperty && e.deleteProperty(...m)),
              class: "btn btn-danger"
            }, "Delete")
          ])
        ])
      ])
    ], 512)
  ], 64);
}
const Hds = /* @__PURE__ */ Ae(tts, [["render", Vts]]), JS = ["dragenter", "dragover", "dragleave", "drop"], Dts = me({
  name: "DropZone",
  props: {
    analysis: {
      type: String,
      required: !1
    }
  },
  emits: [
    "files-dropped"
  ],
  components: {},
  data() {
    return {
      active: !1,
      inActiveTimeout: void 0
    };
  },
  computed: {},
  methods: {
    onDrop(e) {
      var t;
      this.setInactive(), this.$emit("files-dropped", (t = e.dataTransfer) == null ? void 0 : t.files);
    },
    preventDefaults(e) {
      e.preventDefault();
    },
    setActive() {
      this.active = !0, clearTimeout(this.inActiveTimeout);
    },
    setInactive() {
      this.inActiveTimeout = setTimeout(() => {
        this.active = !1;
      }, 50);
    }
  },
  mounted() {
    console.log(`${this.$options.name}.mounted`), JS.forEach((e) => {
      document.body.addEventListener(e, this.preventDefaults);
    });
  },
  unmounted() {
    console.log(`${this.$options.name}.unmounted`), JS.forEach((e) => {
      document.body.removeEventListener(e, this.preventDefaults);
    });
  }
}), Nts = ["data-active"];
function jts(e, t, s, n, r, i) {
  return p(), h("div", {
    "data-active": e.active,
    onDragenter: t[0] || (t[0] = mn((...o) => e.setActive && e.setActive(...o), ["prevent"])),
    onDragover: t[1] || (t[1] = mn((...o) => e.setActive && e.setActive(...o), ["prevent"])),
    onDragleave: t[2] || (t[2] = mn((...o) => e.setInactive && e.setInactive(...o), ["prevent"])),
    onDrop: t[3] || (t[3] = mn((...o) => e.onDrop && e.onDrop(...o), ["prevent"]))
  }, [
    Ot(e.$slots, "default", { dropZoneActive: e.active })
  ], 40, Nts);
}
const Uds = /* @__PURE__ */ Ae(Dts, [["render", jts]]), Hts = me({
  name: "FileList",
  props: {},
  components: {
    ...q(Te, ["access"])
  },
  data() {
    return {};
  },
  computed: {},
  methods: {
    number: Ve
  }
});
function Uts(e, t, s, n, r, i) {
  return null;
}
const zds = /* @__PURE__ */ Ae(Hts, [["render", Uts]]);
class Wds {
  constructor(t, s) {
    Xe(this, "file");
    Xe(this, "id");
    Xe(this, "filename");
    Xe(this, "url");
    Xe(this, "status");
    Xe(this, "error");
    Xe(this, "size");
    Xe(this, "order");
    t && (this.file = t, this.filename = t.name, this.size = t.size, this.id = `${t.name}-${t.size}-${t.lastModified}-${t.type}`, this.url = URL.createObjectURL(t), this.status = "new"), this.order = s;
  }
}
const zts = me({
  name: "FilePreview",
  props: {
    file: Object,
    hideStatus: {
      type: Boolean,
      default: !1
    }
  },
  emits: [
    "remove"
  ],
  computed: {
    name() {
      return this.file && this.file.file ? this.file.file.name : "";
    },
    imageStyle() {
      var e, t, s;
      return {
        "has-error": ((e = this.file) == null ? void 0 : e.error) != null,
        success: ((t = this.file) == null ? void 0 : t.status) == !0,
        "in-progress": ((s = this.file) == null ? void 0 : s.status) == "loading"
      };
    },
    thumbNail() {
      var e, t;
      return ((t = (e = this.file) == null ? void 0 : e.url) == null ? void 0 : t.startsWith("blob")) == !0 ? this.file.url : `${this.file.url}?tr=n-listingthumb1`;
    }
  },
  methods: {
    remove() {
      this.$emit("remove", this.file);
    }
  }
}), Wts = { class: "image mb-2 d-flex align-items-center justify-content-center rounded" }, Gts = ["src", "alt", "title"], Yts = {
  key: 0,
  class: "d-flex justify-content-between"
};
function Xts(e, t, s, n, r, i) {
  return p(), h("div", {
    class: z(["col mb-2", e.imageStyle])
  }, [
    a("div", Wts, [
      t[1] || (t[1] = Bt('<span class="status-indicator success-indicator"><i class="fa-duotone fa-solid fa-check-circle fs-2"></i></span><span class="status-indicator failure-indicator"><i class="fa-duotone fa-solid fa-triangle-exclamation fs-2"></i></span><span class="status-indicator loading-indicator"><i class="fa-duotone fa-solid fa-spinner fa-spin fs-2"></i></span>', 3)),
      a("img", {
        src: e.thumbNail,
        alt: e.name,
        title: e.name,
        class: "img-fluid shadow rounded"
      }, null, 8, Gts)
    ]),
    e.hideStatus ? P("", !0) : (p(), h("div", Yts, [
      a("button", {
        type: "button",
        onClick: t[0] || (t[0] = (...o) => e.remove && e.remove(...o)),
        class: "btn btn-danger btn-sm"
      }, "Delete")
    ]))
  ], 2);
}
const Gds = /* @__PURE__ */ Ae(zts, [["render", Xts]]), qts = me({
  data() {
    return {
      initialized: !1,
      ownerLat: 0,
      ownerLng: 0
    };
  },
  props: {
    getUserLocation: {
      type: Boolean,
      default: !1
    },
    useStreetView: {
      type: Boolean,
      default: !1
    },
    polylines: Object,
    polygon: Object,
    polygons: {
      type: Array
    },
    layers: Array,
    useReverseGeocode: {
      type: Boolean,
      default: !1
    },
    heatMap: Array,
    addMarkerOnClick: {
      type: Boolean,
      default: !1
    },
    tile: {
      type: String
    },
    customClickFunction: {
      type: Function
    },
    customCenterChangePosition: {
      type: Function
    },
    markers: {
      type: Array
    },
    init: {
      required: !0,
      type: Object
    },
    apiKey: {
      required: !0,
      type: String
    },
    findPlace: {
      type: String
    },
    usePanToBounds: {
      type: Boolean,
      default: !1
    }
  },
  methods: {
    addScripts() {
    },
    async initMap() {
      if (this.$props.useStreetView)
        new google.maps.StreetViewPanorama(this.$refs.mapgeo, {
          position: {
            lat: 37.86926,
            lng: -122.254811
          },
          pov: {
            heading: 165,
            pitch: 0
          },
          zoom: 1
        });
      else {
        if (this.geocoder = new google.maps.Geocoder(), this.$props.getUserLocation) {
          delete this.$props.init.position;
          const s = await Td();
          s != null && s.latitude && (s != null && s.longitude) && (this.$props.init.center = {
            lat: s.latitude,
            lng: s.longitude
          });
        }
        if (this.googleMap = new google.maps.Map(this.$refs.mapgeo, this.$props.init), this.placesService = new google.maps.places.PlacesService(this.googleMap), this.$props.tile) {
          var e = this.$props.tile, t = new google.maps.ImageMapType({
            name: "customtile",
            getTileUrl: function(s, n) {
              var r = e.replace("{x}", `${s.x}`).replace("{y}", `${s.y}`).replace("{z}", `${n}`);
              return r;
            },
            tileSize: new google.maps.Size(256, 256),
            minZoom: 1,
            maxZoom: 20
          });
          this.googleMap.mapTypes.set("customtile", t), this.googleMap.setMapTypeId("customtile");
        }
      }
      this.initialized = !0;
    },
    codeAddress(e, t, s) {
      let n = {
        address: e
      };
      if (!this.geocoder) {
        console.error("geocoder is undefined");
        return;
      }
      this.geocoder.geocode(n, (r, i) => {
        if (i === "OK" && ((r == null ? void 0 : r.length) ?? 0) > 0) {
          var o = new google.maps.Marker({
            map: this.googleMap,
            position: r[0].geometry.location,
            icon: t
          });
          if (s) {
            const l = new google.maps.InfoWindow(s);
            o.addListener("click", () => {
              l.open(this.googleMap, o);
            });
          }
          this.ownerLat = parseFloat(r[0].geometry.location.lat().toFixed(4)), this.ownerLng = parseFloat(r[0].geometry.location.lng().toFixed(4));
        }
      });
    },
    setLayers() {
      this.$props.useStreetView || this.$props.layers && this.googleMap && (this.$props.layers.includes("trafficLayer") && new google.maps.TrafficLayer().setMap(this.googleMap), this.$props.layers.includes("transitLayer") && new google.maps.TransitLayer().setMap(this.googleMap), this.$props.layers.includes("bicycleLayer") && new google.maps.BicyclingLayer().setMap(this.googleMap));
    },
    loadMarkers() {
      if (this.initialized == !0 && !this.$props.useStreetView && this.$props.markers) {
        let e = new google.maps.LatLngBounds();
        this.$props.markers.forEach((t) => {
          let { lat: s, lng: n, content: r, icon: i, address: o, zIndex: l } = t;
          if (o && r) {
            this.codeAddress(o, i, r);
            return;
          }
          if (e.extend({
            lat: s,
            lng: n
          }), s != this.ownerLat && n != this.ownerLng) {
            const d = new google.maps.Marker({
              position: {
                lat: s,
                lng: n
              },
              map: this.googleMap,
              icon: i,
              zIndex: l
            });
            if (this.googleMap, r) {
              const c = new google.maps.InfoWindow(r);
              d.addListener("click", () => {
                c.open(this.googleMap, d);
              });
            }
          }
        }), this.$props.usePanToBounds && this.googleMap && this.googleMap.fitBounds(e);
      }
    },
    setPolylines() {
      this.$props.useStreetView || this.$props.polylines && this.googleMap && new google.maps.Polyline(this.$props.polylines).setMap(this.googleMap);
    },
    //#region Polygons
    setPolygon() {
      this.$props.useStreetView || this.$props.polygon && this.googleMap && new google.maps.Polygon(this.$props.polygon).setMap(this.googleMap);
    },
    loadPolygons() {
      this.$props.useStreetView || this.$props.polygons && this.$props.polygons.forEach((e) => {
        if (e.type === "Feature") {
          let t = null, s = null, n = null;
          e.properties.label && (t = e.properties.label), e.properties.cent_lat && e.properties.cent_long && (s = e.properties.cent_lat, n = e.properties.cent_long), this.parseGeoJsonGeometry(e.geometry, t, s, n);
        } else
          this.parseGeoJsonGeometry(e, null);
      });
    },
    parseGeoJsonGeometry(e, t, s, n) {
      e.type === "Polygon" && this.googleMap ? this.geoJsonPolygonToGPolygon(e.coordinates, t, s, n).setMap(this.googleMap) : e.type === "MultiPolygon" && this.googleMap && e.coordinates.forEach((r) => {
        this.geoJsonPolygonToGPolygon(r, t, s, n).setMap(this.googleMap);
      });
    },
    geoJsonPolygonToGPolygon(e, t, s, n) {
      let r = e.map((c) => c.map((u) => ({
        lng: u[0],
        lat: u[1]
      }))), i = new google.maps.Polygon({
        paths: r,
        strokeColor: "#0082fc",
        strokeOpacity: 0.8,
        strokeWeight: 1,
        fillColor: "#0082fc",
        fillOpacity: 0.15
      });
      if (t && this.googleMap) {
        var o;
        if (s && n)
          o = new google.maps.LatLng(s, n);
        else {
          var l = new google.maps.LatLngBounds(), d = i.getPath();
          d.forEach((u, m) => {
            l.extend(u);
          }), o = l.getCenter();
        }
        mk(t, o, this.googleMap).set("position", o);
      }
      return i;
    },
    //#endregion
    addEvents() {
      !this.$props.useStreetView && this.googleMap && (this.googleMap.addListener("click", (e) => {
        this.$props.addMarkerOnClick && (this.$props.useReverseGeocode && this.geocoder.geocode(
          { location: { lat: e.latLng.lat(), lng: e.latLng.lng() } },
          (t, s) => {
            s == "OK" && ((t == null ? void 0 : t.length) ?? 0) > 0 && this.$emit("geocoding", t[0]);
          }
        ), new google.maps.Marker({
          position: e.latLng,
          map: this.googleMap,
          icon: "https://i.hizliresim.com/dX9CHa.png"
        })), this.$emit("clicked", {
          lat: e.latLng.lat(),
          lng: e.latLng.lng()
        }), this.$props.customClickFunction && this.$props.customClickFunction();
      }), this.googleMap.addListener("center_changed", (e) => {
        this.$emit("center-changed"), this.$props.customCenterChangePosition && this.$props.customCenterChangePosition();
      }));
    },
    checkHeatData() {
      if (!this.$props.useStreetView && this.$props.heatMap) {
        const e = [
          "rgba(0, 255, 255, 0)",
          "rgba(0, 255, 255, 1)",
          "rgba(0, 191, 255, 1)",
          "rgba(0, 127, 255, 1)",
          "rgba(0, 63, 255, 1)",
          "rgba(0, 0, 255, 1)",
          "rgba(0, 0, 223, 1)",
          "rgba(0, 0, 191, 1)",
          "rgba(0, 0, 159, 1)",
          "rgba(0, 0, 127, 1)",
          "rgba(63, 0, 91, 1)",
          "rgba(127, 0, 63, 1)",
          "rgba(191, 0, 31, 1)",
          "rgba(255, 0, 0, 1)"
        ], t = this.$props.heatMap.map(
          (s) => new google.maps.LatLng(s.lat, s.lng)
        );
        this.heatmap = new google.maps.visualization.HeatmapLayer({
          data: t,
          map: this.googleMap
        }), this.heatmap.set("gradient", this.heatmap.get("gradient") ? null : e), this.heatmap.set("radius", this.heatmap.get("radius") ? null : 20), this.heatmap.set("opacity", this.heatmap.get("opacity") ? null : 0.2);
      }
    }
  },
  watch: {
    //new marker added
    markers: {
      deep: !0,
      handler(e, t) {
        this.loadMarkers();
      }
    },
    //new polygon added
    polygons: {
      deep: !0,
      handler(e, t) {
        this.loadPolygons();
      }
    },
    //initiate findPlace api and emit response
    findPlace: {
      deep: !0,
      handler(e, t) {
        var s = {
          // 'formatted_address', 'geometry', 'html_attributions', 'icon', 'opening_hours', 'photos', 'place_id', 'plus_code', 'price_level', 'rating', 'user_ratings_total'
          fields: ["business_status", "name", "place_id", "types"],
          //locationBias: null,
          query: e
        };
        this.placesService.findPlaceFromQuery(s, (n, r) => {
          if (((n == null ? void 0 : n.length) ?? 0) > 0 && r === google.maps.places.PlacesServiceStatus.OK) {
            let i = n[0], o = {
              place_id: i.place_id,
              name: i.name,
              business_status: i.business_status,
              types: i.types
              //formatted_address: r.formatted_address,
              //photo: r.photos[0].getUrl(),
              //rating: {
              //    rate: r.rating,
              //    reviewers: r.user_ratings_total
              //}
            };
            this.$emit("find-place-result", o);
          }
        });
      }
    }
  },
  created() {
  },
  async mounted() {
    this.addScripts(), await this.initMap(), this.loadMarkers(), this.addEvents(), this.checkHeatData(), this.setLayers(), this.setPolylines(), this.setPolygon(), this.loadPolygons();
  }
}), Qts = {
  id: "map",
  ref: "mapgeo",
  style: { height: "calc(100vh - 63px)", width: "100%" }
};
function Kts(e, t, s, n, r, i) {
  return p(), h("div", Qts, null, 512);
}
const Yds = /* @__PURE__ */ Ae(qts, [["render", Kts], ["__scopeId", "data-v-beeb82c3"]]), nv = 3, Zts = me({
  name: "NotificationsBar",
  computed: {
    hasErrorsOrWarnings() {
      return this.errorAlerts.length > 0 || this.warningAlerts.length > 0;
    },
    topNotifications() {
      return [...this.errorAlerts, ...this.warningAlerts].reduce((t, s) => {
        if (t.filter((r) => r.eventId === s.eventId).length == 0)
          return s.total = 1, t.concat([s]);
        {
          const r = t.find((i) => i.eventId === s.eventId);
          return r && r.total++, t;
        }
      }, []).slice(0, nv);
    },
    allNotifications() {
      return [...this.errorAlerts, ...this.warningAlerts];
    },
    moreCount() {
      return [...this.errorAlerts, ...this.warningAlerts].reduce((t, s) => t.find((r) => r.eventId === s.eventId) ? t : t.concat([s]), []).length - nv;
    },
    hasMore() {
      return this.moreCount > nv;
    },
    ...q(Te, ["access", "aclLoaded"]),
    ...q(Ci, ["informationAlerts", "warningAlerts", "errorAlerts", "notifications"])
  },
  methods: {
    number: Ve,
    viewAll() {
      var e;
      (e = bootstrap.Modal.getOrCreateInstance(this.$refs.modalMoreAlerts)) == null || e.show();
    }
  }
}), Jts = {
  key: 0,
  class: "slide-down bg-warning-subtle border-bottom",
  style: { "--bs-border-color": "white" }
}, $ts = { class: "container-fluid container-xl" }, _ts = { class: "row" }, ess = { class: "col" }, tss = { class: "list-unstyled p-3 m-0" }, sss = { key: 0 }, ass = { key: 0 }, nss = {
  class: "modal fade",
  ref: "modalMoreAlerts",
  id: "modalMoreAlerts",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}, rss = { class: "modal-dialog modal-dialog-centered" }, oss = { class: "modal-content bg-gradient-alphabet" }, iss = { class: "modal-body p-5" }, lss = { class: "list-unstyled m-0" };
function dss(e, t, s, n, r, i) {
  return p(), h(A, null, [
    N(ks, {
      name: "slide",
      mode: "out-in"
    }, {
      default: ve(() => [
        e.hasErrorsOrWarnings ? (p(), h("div", Jts, [
          a("div", $ts, [
            a("div", _ts, [
              a("div", ess, [
                a("ul", tss, [
                  (p(!0), h(A, null, D(e.topNotifications, (o) => (p(), h("li", {
                    key: o.id
                  }, [
                    t[1] || (t[1] = a("i", { class: "fa-duotone fa-solid fa-exclamation-triangle me-2" }, null, -1)),
                    a("span", null, [
                      y(g(o.message) + " ", 1),
                      o.total > 1 ? (p(), h("span", sss, "(" + g(o.total) + ")", 1)) : P("", !0)
                    ])
                  ]))), 128)),
                  e.hasMore ? (p(), h("li", ass, [
                    a("button", {
                      type: "button",
                      class: "btn btn-link alert-link ms-2",
                      onClick: t[0] || (t[0] = (...o) => e.viewAll && e.viewAll(...o))
                    }, " View " + g(e.number(e.moreCount)) + " more alerts... ", 1)
                  ])) : P("", !0)
                ])
              ])
            ])
          ])
        ])) : P("", !0)
      ]),
      _: 1
    }),
    a("div", nss, [
      a("div", rss, [
        a("div", oss, [
          a("div", iss, [
            t[3] || (t[3] = a("button", {
              type: "button",
              class: "btn-close position-absolute top-10 end-10",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            }, null, -1)),
            t[4] || (t[4] = a("p", {
              class: "modal-title fs-5 fw-bold mb-3",
              id: "exampleModalLabel"
            }, "Notification Alerts", -1)),
            a("ul", lss, [
              (p(!0), h(A, null, D(e.allNotifications, (o) => (p(), h("li", {
                key: o.id
              }, [
                t[2] || (t[2] = a("i", { class: "fa-duotone fa-solid fa-exclamation-triangle me-2" }, null, -1)),
                a("span", null, g(o.message), 1)
              ]))), 128))
            ])
          ])
        ])
      ])
    ], 512)
  ], 64);
}
const Xds = /* @__PURE__ */ Ae(Zts, [["render", dss]]), css = me({
  name: "SubscriptionOptions",
  props: {
    groupPath: String
  },
  components: {},
  data() {
    return {
      couponCode: void 0,
      invalidCoupon: !1
    };
  },
  computed: {
    signupPath() {
      let e = `/signup/${this.groupPath ?? ""}`;
      return this.couponCode && (e += `?c=${this.couponCode}`), e;
    },
    annually: {
      get() {
        return this.chosenBillingPeriod == Qt.Annually;
      },
      set(e) {
        e ? this.chosenBillingPeriod = Qt.Annually : this.chosenBillingPeriod = Qt.Monthly;
      }
    },
    mainProduct() {
      if (this.mainProducts.length > 0)
        return this.mainProducts[0];
    },
    billingPeriodProductOptions() {
      return this.subscriptionStore.products.filter((e) => {
        var t;
        return e.optionId == ((t = this.mainProduct) == null ? void 0 : t.optionId) && !e.addOn && e.billingPeriod == this.chosenBillingPeriod;
      }).sort((e, t) => e.price - t.price);
    },
    priceStyle() {
      return {
        "fs-3": !0,
        "line-through": this.userAppliedCoupons.length > 0,
        "text-body-tertiary": this.userAppliedCoupons.length == 0
      };
    },
    ...at(vn),
    ...q(vn, ["mainProducts", "userAppliedCoupons", "activeDiscountMonthlyAmount", "currentDiscounts"]),
    ...xm(vn, ["chosenBillingPeriod"])
  },
  methods: {
    number: Ve,
    currency: Ze,
    async applyCoupon() {
      console.log("applyCoupon");
      try {
        this.couponCode && (await this.subscriptionStore.applyCoupon(this.couponCode), this.userAppliedCoupons.length > 0 ? (this.invalidCoupon = !1, this.couponCode = this.userAppliedCoupons.find((e) => !0).code) : this.invalidCoupon = !0);
      } catch (e) {
        Ns(e);
      }
    },
    firstMonthTotal(e) {
      const t = this.subscriptionStore.optionPrice(e) - this.activeDiscountMonthlyAmount;
      return t < 0 ? 0 : t;
    }
  },
  created() {
  },
  mounted() {
    this.subscriptionStore.loadProductGroup(this.groupPath).then(async () => {
      const e = new URLSearchParams(window.location.search);
      this.couponCode = e.get("c"), this.couponCode && await this.applyCoupon();
    });
  }
}), uss = { class: "d-flex justify-content-center align-items-center mb-5" }, pss = { class: "form-check form-switch form-switch-lg form-switch-basic form-switch-psp" }, hss = { class: "tab-content" }, mss = {
  class: "tab-pane fade show active",
  id: "monthly",
  role: "tabpanel",
  "aria-labelledby": "monthly-tab",
  tabindex: "0"
}, fss = { class: "row row-cols-1 row-cols-lg-2 g-3" }, gss = { class: "col" }, vss = { class: "card bg-white shadow" }, yss = { class: "card-body" }, bss = { class: "fs-3 fw-bold mb-2" }, Ass = { class: "mb-5 d-flex gap-3" }, wss = { key: 0 }, Css = { key: 1 }, Sss = {
  key: 3,
  class: "text-lava fs-6"
}, Pss = { class: "list-unstyled mb-5" }, kss = { class: "mb-5" }, Ess = { class: "d-grid" }, Iss = ["href"];
function Tss(e, t, s, n, r, i) {
  return p(), h("div", null, [
    t[4] || (t[4] = a("div", { class: "text-center" }, [
      a("h2", { class: "fs-2 fw-bold mb-7" }, "Subscription Options")
    ], -1)),
    a("div", uss, [
      a("div", pss, [
        V(a("input", {
          class: "form-check-input",
          type: "checkbox",
          role: "switch",
          id: "flexSwitchCheckDefault",
          "onUpdate:modelValue": t[0] || (t[0] = (o) => e.annually = o)
        }, null, 512), [
          [Ue, e.annually]
        ]),
        t[1] || (t[1] = a("label", {
          class: "form-check-label",
          for: "flexSwitchCheckDefault"
        }, [
          y("Yearly"),
          a("span", null, "Monthly")
        ], -1))
      ]),
      t[2] || (t[2] = a("span", { class: "badge text-bg-secondary ms-2" }, " SAVE 20% ", -1))
    ]),
    a("div", hss, [
      a("div", mss, [
        a("div", fss, [
          (p(!0), h(A, null, D(e.billingPeriodProductOptions, (o) => (p(), h("div", gss, [
            a("div", vss, [
              a("div", yss, [
                a("div", bss, g(o.optionName), 1),
                a("div", Ass, [
                  a("div", {
                    class: z(e.priceStyle)
                  }, g(e.currency(e.subscriptionStore.optionPrice(o))) + "/mo ", 3),
                  (p(!0), h(A, null, D(e.currentDiscounts, (l) => (p(), h("div", null, [
                    (l == null ? void 0 : l.durationType) == "once" ? (p(), h("div", wss, " First month ")) : P("", !0),
                    (l == null ? void 0 : l.durationType) == "repeating" ? (p(), h("div", Css, " First " + g(l.duration) + " months ", 1)) : P("", !0),
                    e.firstMonthTotal(o) > 0 ? (p(), h(A, { key: 2 }, [
                      y(g(e.currency(e.firstMonthTotal(o))) + "/mo ", 1)
                    ], 64)) : (p(), h("b", Sss, "FREE!"))
                  ]))), 256))
                ]),
                a("ul", Pss, [
                  (p(!0), h(A, null, D(o.keyPoints, (l, d) => (p(), h("li", { key: d }, [
                    t[3] || (t[3] = a("i", { class: "fa-solid fa-check me-3" }, null, -1)),
                    y(g(l), 1)
                  ]))), 128))
                ]),
                a("p", kss, g(o.desc), 1),
                a("div", Ess, [
                  a("a", {
                    href: e.signupPath,
                    class: "btn btn-lava text-uppercase"
                  }, "Register Now Monthly", 8, Iss)
                ])
              ])
            ])
          ]))), 256))
        ])
      ])
    ])
  ]);
}
const qds = /* @__PURE__ */ Ae(css, [["render", Tss]]), Oss = me({
  name: "InvestmentSpecialist",
  computed: {
    cardTitle() {
      return "YOUR INVESTMENT SPECIALIST";
    },
    propertyViewSponsor() {
      var e, t;
      if ((t = (e = this.propertyStore.property) == null ? void 0 : e.mlsSource) != null && t.source)
        return this.sponsors.find((n) => {
          var r, i;
          return n.mlsShortCode == ((i = (r = this.propertyStore.property) == null ? void 0 : r.mlsSource) == null ? void 0 : i.source);
        });
    },
    firstName() {
      var e;
      return this.propertyViewSponsor ? this.propertyViewSponsor.firstName : this.selectedSponsor ? this.selectedSponsor.firstName : (e = this.branding) == null ? void 0 : e.agentFirstName;
    },
    userTitle() {
      var e;
      return this.propertyViewSponsor ? this.propertyViewSponsor.title : this.selectedSponsor ? this.selectedSponsor.title : (e = this.branding) == null ? void 0 : e.title;
    },
    headshotStyle() {
      var t, s, n;
      const e = {};
      return this.propertyViewSponsor ? e["background-image"] = (t = this.propertyViewSponsor) != null && t.headshotUrl ? `url(${this.propertyViewSponsor.headshotUrl})` : void 0 : this.selectedSponsor ? e["background-image"] = (s = this.selectedSponsor) != null && s.headshotUrl ? `url(${this.selectedSponsor.headshotUrl})` : void 0 : this.branding && (e["background-image"] = (n = this.branding) != null && n.headshotPhotoUrl ? `url(${this.branding.headshotPhotoUrl})` : void 0), e;
    },
    ...q(ct, ["branding", "sponsors", "selectedSponsor"]),
    ...at(qe)
  },
  methods: {}
}), Rss = { class: "card-navbar-user mb-3 mt-2" }, Lss = { class: "card rounded rounded-4 text-center bg-white bg-opacity-10 overflow-hidden" }, Bss = { class: "card-header bg-white bg-opacity-10 text-center px-0 small" }, Mss = { class: "text-white-50 fw-normal small" }, xss = { class: "card-body d-flex flex-column align-items-center" }, Fss = { class: "fs-5 fw-bold text-white" }, Vss = { class: "text-white-50 small" };
function Dss(e, t, s, n, r, i) {
  return p(), h("div", Rss, [
    a("div", Lss, [
      a("div", Bss, [
        a("small", Mss, g(e.cardTitle), 1)
      ]),
      a("div", xss, [
        a("div", {
          class: "avatar avatar-100 mb-2 rounded-circle",
          style: rn(e.headshotStyle)
        }, null, 4),
        a("div", Fss, g(e.firstName), 1),
        a("div", Vss, g(e.userTitle), 1)
      ])
    ])
  ]);
}
const Qds = /* @__PURE__ */ Ae(Oss, [["render", Dss]]), Nss = 60 * 1e3, jss = 5, Hss = 1, Uss = new xa(), zss = me({
  name: "SessionState",
  data() {
    return {
      timer: void 0,
      extending: !1
    };
  },
  computed: {
    ...at(Te),
    ...q(Te, ["access", "aclLoaded"])
  },
  watch: {
    "access.expires"(e) {
      e && this.activateTimer();
    }
  },
  methods: {
    number: Ve,
    async extend() {
      var e;
      this.extending = !0;
      try {
        await Qv(), await this.authStore.refreshAcl();
      } catch {
        Se("Failed to extend your session, you may need to refresh the page or re-login to continue.");
      } finally {
        this.extending = !1, (e = bootstrap.Modal.getOrCreateInstance(this.$refs.sessionExpiringDialog)) == null || e.hide();
      }
    },
    checkExpired() {
      var t, s, n, r;
      if (this.timer = void 0, !((t = this.access) != null && t.expires))
        return;
      console.log("checkExpired", this.access.expires, mm(Date.now(), this.access.expires * 1e3));
      const e = mm(Date.now(), this.access.expires * 1e3);
      e <= Hss ? ((s = bootstrap.Modal.getOrCreateInstance(this.$refs.sessionExpiringDialog)) == null || s.hide(), (n = bootstrap.Modal.getOrCreateInstance(this.$refs.sessionExpiredDialog)) == null || n.show()) : e <= jss && ((r = bootstrap.Modal.getOrCreateInstance(this.$refs.sessionExpiringDialog)) == null || r.show()), this.activateTimer();
    },
    async activateTimer() {
      await Uss.runExclusive(() => {
        document.location.href == "www.rescover.com" && (this.timer || (this.timer = setTimeout(this.checkExpired, Nss)));
      });
    }
  },
  mounted() {
    this.aclLoaded.then(async () => await this.activateTimer());
  }
}), Wss = {
  class: "modal fade",
  ref: "sessionExpiringDialog",
  id: "sessionExpiringDialog",
  tabindex: "-1",
  "aria-labelledby": "sessionExpiringDialogLabel",
  "aria-hidden": "true"
}, Gss = { class: "modal-dialog modal-dialog-centered" }, Yss = { class: "modal-content" }, Xss = { class: "modal-body text-center px-5 pb-5 pt-0 d-flex flex-column align-items-center justify-content-center" }, qss = ["disabled"], Qss = {
  class: "modal fade",
  ref: "sessionExpiredDialog",
  id: "sessionExpiredDialog",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false",
  tabindex: "-1",
  "aria-labelledby": "sessionExpiredDialogLabel",
  "aria-hidden": "true"
};
function Kss(e, t, s, n, r, i) {
  return p(), h(A, null, [
    a("div", Wss, [
      a("div", Gss, [
        a("div", Yss, [
          t[3] || (t[3] = a("div", { class: "modal-header border-0" }, "   ", -1)),
          a("div", Xss, [
            t[1] || (t[1] = a("p", { class: "fw-bold fs-4 mb-0" }, "Are you still there?", -1)),
            t[2] || (t[2] = a("p", { class: "mb-5" }, "Your session is about to expire. Please click the extend button below to extend your session.", -1)),
            a("button", {
              type: "button",
              class: "btn btn-lava",
              onClick: t[0] || (t[0] = (...o) => e.extend && e.extend(...o)),
              disabled: e.extending
            }, "Extend", 8, qss)
          ])
        ])
      ])
    ], 512),
    a("div", Qss, t[4] || (t[4] = [
      Bt('<div class="modal-dialog modal-dialog-centered"><div class="modal-content"><div class="modal-header border-0">   </div><div class="modal-body text-center px-5 pb-5 pt-0 d-flex flex-column align-items-center justify-content-center"><p class="fw-bold fs-4 mb-0">Session expired</p><p class="mb-5">Your session has expired from inactivity. Please login to continue.</p><a class="btn btn-lava" href="/login">Login</a></div></div></div>', 1)
    ]), 512)
  ], 64);
}
const Kds = /* @__PURE__ */ Ae(zss, [["render", Kss]]), Zss = me({
  name: "PermissionsViewer",
  enums: {
    Features: Oa
  },
  data() {
    return {
      viewPermissions: !1
    };
  },
  computed: {
    ...at(Te, ct),
    ...q(ct, ["account"]),
    ...q(Te, ["access", "aclLoaded", "isClient", "isAdmin", "isUser"]),
    ...q(qe, ["isMarketplace"])
  },
  watch: {
    viewPermissions(e) {
      e ? bootstrap.Modal.getOrCreateInstance(this.$refs.sessionExpiringDialog).show() : bootstrap.Modal.getOrCreateInstance(this.$refs.sessionExpiringDialog).hide();
    }
  },
  methods: {
    hasBits: is,
    async refresh() {
      await this.authStore.refreshAcl(), await this.accountStore.getAccountInfo();
    }
  },
  mounted() {
    Hr("A", (e) => {
      this.viewPermissions = !this.viewPermissions;
    }, !0, !1, !1, !0, !0);
  }
}), Jss = {
  class: "modal fade",
  ref: "sessionExpiringDialog",
  id: "sessionExpiringDialog",
  tabindex: "-1",
  "aria-labelledby": "sessionExpiringDialogLabel",
  "aria-hidden": "true"
}, $ss = { class: "modal-dialog modal-dialog-centered" }, _ss = { class: "modal-content bg-gradient-alphabet rounded" }, eas = { class: "modal-body" }, tas = { class: "table table-sm table-striped mb-0 table-transparent" }, sas = { colspan: "4" }, aas = {
  key: 0,
  class: "fa-duotone fa-solid fa-circle-check fa-lg text-success"
}, nas = {
  key: 0,
  class: "fa-duotone fa-solid fa-circle-check fa-lg text-success"
}, ras = {
  key: 0,
  class: "fa-duotone fa-solid fa-circle-check fa-lg text-success"
}, oas = {
  key: 0,
  class: "fa-duotone fa-solid fa-circle-check fa-lg text-success"
}, ias = {
  key: 0,
  class: "fa-duotone fa-solid fa-circle-check fa-lg text-success"
}, las = {
  key: 0,
  class: "fa-duotone fa-solid fa-circle-check fa-lg text-success"
}, das = {
  key: 0,
  class: "fa-duotone fa-solid fa-circle-check fa-lg text-success"
}, cas = {
  key: 0,
  class: "fa-duotone fa-solid fa-circle-check fa-lg text-success"
}, uas = {
  key: 0,
  class: "fa-duotone fa-solid fa-circle-check fa-lg text-success"
}, pas = {
  key: 0,
  class: "fa-duotone fa-solid fa-circle-check fa-lg text-success"
}, has = {
  key: 0,
  class: "fa-duotone fa-solid fa-circle-check fa-lg text-success"
}, mas = {
  key: 0,
  class: "fa-duotone fa-solid fa-circle-check fa-lg text-success"
}, fas = {
  key: 0,
  class: "fa-duotone fa-solid fa-circle-check fa-lg text-success"
}, gas = {
  key: 0,
  class: "fa-duotone fa-solid fa-circle-check fa-lg text-success"
}, vas = {
  key: 0,
  class: "fa-duotone fa-solid fa-circle-check fa-lg text-success"
}, yas = {
  key: 0,
  class: "fa-duotone fa-solid fa-circle-check fa-lg text-success"
}, bas = {
  key: 0,
  class: "fa-duotone fa-solid fa-circle-check fa-lg text-success"
}, Aas = {
  key: 0,
  class: "fa-duotone fa-solid fa-circle-check fa-lg text-success"
}, was = {
  key: 0,
  class: "fa-duotone fa-solid fa-circle-check fa-lg text-success"
}, Cas = {
  key: 0,
  class: "fa-duotone fa-solid fa-circle-check fa-lg text-success"
}, Sas = {
  key: 0,
  class: "fa-duotone fa-solid fa-circle-check fa-lg text-success"
}, Pas = {
  key: 0,
  class: "fa-duotone fa-solid fa-circle-check fa-lg text-success"
}, kas = {
  key: 0,
  class: "fa-duotone fa-solid fa-circle-check fa-lg text-success"
}, Eas = {
  key: 0,
  class: "fa-duotone fa-solid fa-circle-check fa-lg text-success"
}, Ias = {
  key: 0,
  class: "fa-duotone fa-solid fa-circle-check fa-lg text-success"
}, Tas = {
  key: 0,
  class: "fa-duotone fa-solid fa-circle-check fa-lg text-success"
}, Oas = {
  key: 0,
  class: "fa-duotone fa-solid fa-circle-check fa-lg text-success"
}, Ras = {
  key: 0,
  class: "fa-duotone fa-solid fa-circle-check fa-lg text-success"
}, Las = {
  key: 0,
  class: "fa-duotone fa-solid fa-circle-check fa-lg text-success"
}, Bas = {
  key: 0,
  class: "fa-duotone fa-solid fa-circle-check fa-lg text-success"
}, Mas = {
  key: 0,
  class: "fa-duotone fa-solid fa-circle-check fa-lg text-success"
}, xas = {
  key: 0,
  class: "fa-duotone fa-solid fa-circle-check fa-lg text-success"
}, Fas = {
  key: 0,
  class: "fa-duotone fa-solid fa-circle-check fa-lg text-success"
}, Vas = {
  key: 0,
  class: "fa-duotone fa-solid fa-circle-check fa-lg text-success"
}, Das = {
  key: 0,
  class: "fa-duotone fa-solid fa-circle-check fa-lg text-success"
}, Nas = {
  key: 0,
  class: "fa-duotone fa-solid fa-circle-check fa-lg text-success"
}, jas = {
  key: 0,
  class: "fa-duotone fa-solid fa-circle-check fa-lg text-success"
}, Has = {
  key: 0,
  class: "fa-duotone fa-solid fa-circle-check fa-lg text-success"
}, Uas = {
  key: 0,
  class: "fa-duotone fa-solid fa-circle-check fa-lg text-success"
}, zas = {
  key: 0,
  class: "fa-duotone fa-solid fa-circle-check fa-lg text-success"
}, Was = {
  key: 0,
  class: "fa-duotone fa-solid fa-circle-check fa-lg text-success"
}, Gas = {
  key: 0,
  class: "fa-duotone fa-solid fa-circle-check fa-lg text-success"
}, Yas = {
  key: 0,
  class: "fa-duotone fa-solid fa-circle-check fa-lg text-success"
}, Xas = {
  key: 0,
  class: "fa-duotone fa-solid fa-circle-check fa-lg text-success"
}, qas = {
  key: 0,
  class: "fa-duotone fa-solid fa-circle-check fa-lg text-success"
}, Qas = {
  key: 0,
  class: "fa-duotone fa-solid fa-circle-check fa-lg text-success"
}, Kas = {
  key: 0,
  class: "fa-duotone fa-solid fa-circle-check fa-lg text-success"
};
function Zas(e, t, s, n, r, i) {
  var o, l, d, c, u, m, f, v, b, w, S, I, T, x, k, C, O, E, B, M, R, F, L, j, H, te, re, le, ie, ye, Y, ae, ke, ue, oe, fe, we, Ie, be, Oe, ze, Re, ge, he, Me, Ne, $e, mt;
  return p(), h("div", Jss, [
    a("div", $ss, [
      a("div", _ss, [
        a("div", eas, [
          a("table", tas, [
            a("tbody", null, [
              a("tr", null, [
                a("td", sas, [
                  y(g((o = e.account) == null ? void 0 : o.firstName) + " " + g((l = e.account) == null ? void 0 : l.lastName) + " (" + g((d = e.access) == null ? void 0 : d.role) + ")", 1),
                  t[1] || (t[1] = a("br", null, null, -1)),
                  y(" " + g((c = e.account) == null ? void 0 : c.email), 1)
                ])
              ]),
              a("tr", null, [
                t[3] || (t[3] = a("th", null, "Context", -1)),
                a("th", null, [
                  a("button", {
                    type: "button",
                    class: "btn btn-link",
                    onClick: t[0] || (t[0] = (...yt) => e.refresh && e.refresh(...yt))
                  }, t[2] || (t[2] = [
                    a("i", {
                      class: "fa fa-refresh",
                      "aria-hidden": "true"
                    }, null, -1)
                  ]))
                ]),
                t[4] || (t[4] = a("th", null, "Feature Bits", -1)),
                t[5] || (t[5] = a("th", null, null, -1))
              ]),
              a("tr", null, [
                t[6] || (t[6] = a("td", null, "isAdmin", -1)),
                a("td", null, [
                  e.isAdmin ? (p(), h("i", aas)) : P("", !0)
                ]),
                t[7] || (t[7] = a("td", null, "Advanced Calculator", -1)),
                a("td", null, [
                  e.hasBits((u = e.access) == null ? void 0 : u.acl, e.Features.AdvancedCalculator) ? (p(), h("i", nas)) : P("", !0)
                ])
              ]),
              a("tr", null, [
                t[8] || (t[8] = a("td", null, "isUser", -1)),
                a("td", null, [
                  e.isUser ? (p(), h("i", ras)) : P("", !0)
                ]),
                t[9] || (t[9] = a("td", null, "Analyze OffMarket", -1)),
                a("td", null, [
                  e.hasBits((m = e.access) == null ? void 0 : m.acl, e.Features.AnalyzeOffMarket) ? (p(), h("i", oas)) : P("", !0)
                ])
              ]),
              a("tr", null, [
                t[10] || (t[10] = a("td", null, "isClient", -1)),
                a("td", null, [
                  e.isClient ? (p(), h("i", ias)) : P("", !0)
                ]),
                t[11] || (t[11] = a("td", null, "Branded PDF", -1)),
                a("td", null, [
                  e.hasBits((f = e.access) == null ? void 0 : f.acl, e.Features.BrandedPDF) ? (p(), h("i", las)) : P("", !0)
                ])
              ]),
              a("tr", null, [
                t[12] || (t[12] = a("td", null, "isAnonymous", -1)),
                a("td", null, [
                  (v = e.access) != null && v.isAnonymous ? (p(), h("i", das)) : P("", !0)
                ]),
                t[13] || (t[13] = a("td", null, "Branded Portal", -1)),
                a("td", null, [
                  e.hasBits((b = e.access) == null ? void 0 : b.acl, e.Features.BrandedPortal) ? (p(), h("i", cas)) : P("", !0)
                ])
              ]),
              a("tr", null, [
                t[14] || (t[14] = a("td", null, "isAuthenticated", -1)),
                a("td", null, [
                  (w = e.access) != null && w.isAuthenticated ? (p(), h("i", uas)) : P("", !0)
                ]),
                t[15] || (t[15] = a("td", null, "Brand Portal", -1)),
                a("td", null, [
                  e.hasBits((S = e.access) == null ? void 0 : S.acl, e.Features.BrandPortal) ? (p(), h("i", pas)) : P("", !0)
                ])
              ]),
              a("tr", null, [
                t[16] || (t[16] = a("td", null, "isFree", -1)),
                a("td", null, [
                  (I = e.access) != null && I.isFree ? (p(), h("i", has)) : P("", !0)
                ]),
                t[17] || (t[17] = a("td", null, "Existing Investment", -1)),
                a("td", null, [
                  e.hasBits((T = e.access) == null ? void 0 : T.acl, e.Features.ExistingInvestment) ? (p(), h("i", mas)) : P("", !0)
                ])
              ]),
              a("tr", null, [
                t[18] || (t[18] = a("td", null, "isIdx Share", -1)),
                a("td", null, [
                  (x = e.access) != null && x.isIdx ? (p(), h("i", fas)) : P("", !0)
                ]),
                t[19] || (t[19] = a("td", null, "Favorite Property", -1)),
                a("td", null, [
                  e.hasBits((k = e.access) == null ? void 0 : k.acl, e.Features.FavoriteProperty) ? (p(), h("i", gas)) : P("", !0)
                ])
              ]),
              a("tr", null, [
                t[20] || (t[20] = a("td", null, "isShare", -1)),
                a("td", null, [
                  (C = e.access) != null && C.isShare ? (p(), h("i", vas)) : P("", !0)
                ]),
                t[21] || (t[21] = a("td", null, "Feature Properties", -1)),
                a("td", null, [
                  e.hasBits((O = e.access) == null ? void 0 : O.acl, e.Features.FeatureProperties) ? (p(), h("i", yas)) : P("", !0)
                ])
              ]),
              a("tr", null, [
                t[22] || (t[22] = a("td", null, "isAnalysis View", -1)),
                a("td", null, [
                  (E = e.access) != null && E.isAnalysis ? (p(), h("i", bas)) : P("", !0)
                ]),
                t[23] || (t[23] = a("td", null, "Financial Analysis", -1)),
                a("td", null, [
                  e.hasBits((B = e.access) == null ? void 0 : B.acl, e.Features.FinancialAnalysis) ? (p(), h("i", Aas)) : P("", !0)
                ])
              ]),
              a("tr", null, [
                t[24] || (t[24] = a("td", null, "Has MLS Entitlements (Any)", -1)),
                a("td", null, [
                  (R = (M = e.access) == null ? void 0 : M.mls) != null && R.hasEntitlements ? (p(), h("i", was)) : P("", !0)
                ]),
                t[25] || (t[25] = a("td", null, "Flip Calculator", -1)),
                a("td", null, [
                  e.hasBits((F = e.access) == null ? void 0 : F.acl, e.Features.FlipCalculator) ? (p(), h("i", Cas)) : P("", !0)
                ])
              ]),
              a("tr", null, [
                t[26] || (t[26] = a("td", null, "Is Marketplace Prop", -1)),
                a("td", null, [
                  e.isMarketplace ? (p(), h("i", Sas)) : P("", !0)
                ]),
                t[27] || (t[27] = a("td", null, "Free Rental Analysis", -1)),
                a("td", null, [
                  e.hasBits((L = e.access) == null ? void 0 : L.acl, e.Features.FreeRentalAnalysis) ? (p(), h("i", Pas)) : P("", !0)
                ])
              ]),
              a("tr", null, [
                t[28] || (t[28] = a("td", null, null, -1)),
                t[29] || (t[29] = a("td", null, null, -1)),
                t[30] || (t[30] = a("td", null, "Great Schools Rating", -1)),
                a("td", null, [
                  e.hasBits((j = e.access) == null ? void 0 : j.acl, e.Features.GreatSchoolsRating) ? (p(), h("i", kas)) : P("", !0)
                ])
              ]),
              a("tr", null, [
                t[31] || (t[31] = a("td", null, null, -1)),
                t[32] || (t[32] = a("td", null, null, -1)),
                t[33] || (t[33] = a("td", null, "IDX", -1)),
                a("td", null, [
                  e.hasBits((H = e.access) == null ? void 0 : H.acl, e.Features.IDX) ? (p(), h("i", Eas)) : P("", !0)
                ])
              ]),
              a("tr", null, [
                t[34] || (t[34] = a("td", null, null, -1)),
                t[35] || (t[35] = a("td", null, null, -1)),
                t[36] || (t[36] = a("td", null, "Integrations", -1)),
                a("td", null, [
                  e.hasBits((te = e.access) == null ? void 0 : te.acl, e.Features.Integrations) ? (p(), h("i", Ias)) : P("", !0)
                ])
              ]),
              a("tr", null, [
                t[37] || (t[37] = a("td", null, null, -1)),
                t[38] || (t[38] = a("td", null, null, -1)),
                t[39] || (t[39] = a("td", null, "Leads", -1)),
                a("td", null, [
                  e.hasBits((re = e.access) == null ? void 0 : re.acl, e.Features.Leads) ? (p(), h("i", Tas)) : P("", !0)
                ])
              ]),
              a("tr", null, [
                t[40] || (t[40] = a("td", null, null, -1)),
                t[41] || (t[41] = a("td", null, null, -1)),
                t[42] || (t[42] = a("td", null, "Leads Address Search", -1)),
                a("td", null, [
                  e.hasBits((le = e.access) == null ? void 0 : le.acl, e.Features.LeadsAddresses) ? (p(), h("i", Oas)) : P("", !0)
                ])
              ]),
              a("tr", null, [
                t[43] || (t[43] = a("td", null, null, -1)),
                t[44] || (t[44] = a("td", null, null, -1)),
                t[45] || (t[45] = a("td", null, "Leads County Search", -1)),
                a("td", null, [
                  e.hasBits((ie = e.access) == null ? void 0 : ie.acl, e.Features.LeadsCounties) ? (p(), h("i", Ras)) : P("", !0)
                ])
              ]),
              a("tr", null, [
                t[46] || (t[46] = a("td", null, null, -1)),
                t[47] || (t[47] = a("td", null, null, -1)),
                t[48] || (t[48] = a("td", null, "Leads Name Search", -1)),
                a("td", null, [
                  e.hasBits((ye = e.access) == null ? void 0 : ye.acl, e.Features.LeadsNames) ? (p(), h("i", Las)) : P("", !0)
                ])
              ]),
              a("tr", null, [
                t[49] || (t[49] = a("td", null, null, -1)),
                t[50] || (t[50] = a("td", null, null, -1)),
                t[51] || (t[51] = a("td", null, "Leads Search", -1)),
                a("td", null, [
                  e.hasBits((Y = e.access) == null ? void 0 : Y.acl, e.Features.LeadsSearch) ? (p(), h("i", Bas)) : P("", !0)
                ])
              ]),
              a("tr", null, [
                t[52] || (t[52] = a("td", null, null, -1)),
                t[53] || (t[53] = a("td", null, null, -1)),
                t[54] || (t[54] = a("td", null, "Leads Zip Search", -1)),
                a("td", null, [
                  e.hasBits((ae = e.access) == null ? void 0 : ae.acl, e.Features.LeadsZips) ? (p(), h("i", Mas)) : P("", !0)
                ])
              ]),
              a("tr", null, [
                t[55] || (t[55] = a("td", null, null, -1)),
                t[56] || (t[56] = a("td", null, null, -1)),
                t[57] || (t[57] = a("td", null, "Search MLS", -1)),
                a("td", null, [
                  e.hasBits((ke = e.access) == null ? void 0 : ke.acl, e.Features.SearchMls) ? (p(), h("i", xas)) : P("", !0)
                ])
              ]),
              a("tr", null, [
                t[58] || (t[58] = a("td", null, null, -1)),
                t[59] || (t[59] = a("td", null, null, -1)),
                t[60] || (t[60] = a("td", null, "Manage Clients", -1)),
                a("td", null, [
                  e.hasBits((ue = e.access) == null ? void 0 : ue.acl, e.Features.ManageClients) ? (p(), h("i", Fas)) : P("", !0)
                ])
              ]),
              a("tr", null, [
                t[61] || (t[61] = a("td", null, null, -1)),
                t[62] || (t[62] = a("td", null, null, -1)),
                t[63] || (t[63] = a("td", null, "Manage IE Accounts", -1)),
                a("td", null, [
                  e.hasBits((oe = e.access) == null ? void 0 : oe.acl, e.Features.ManageIEAccounts) ? (p(), h("i", Vas)) : P("", !0)
                ])
              ]),
              a("tr", null, [
                t[64] || (t[64] = a("td", null, null, -1)),
                t[65] || (t[65] = a("td", null, null, -1)),
                t[66] || (t[66] = a("td", null, "Manage Sub Accounts", -1)),
                a("td", null, [
                  e.hasBits((fe = e.access) == null ? void 0 : fe.acl, e.Features.ManageSubAccounts) ? (p(), h("i", Das)) : P("", !0)
                ])
              ]),
              a("tr", null, [
                t[67] || (t[67] = a("td", null, null, -1)),
                t[68] || (t[68] = a("td", null, null, -1)),
                t[69] || (t[69] = a("td", null, "Market Data Insights", -1)),
                a("td", null, [
                  e.hasBits((we = e.access) == null ? void 0 : we.acl, e.Features.MarketDataInsights) ? (p(), h("i", Nas)) : P("", !0)
                ])
              ]),
              a("tr", null, [
                t[70] || (t[70] = a("td", null, null, -1)),
                t[71] || (t[71] = a("td", null, null, -1)),
                t[72] || (t[72] = a("td", null, "Add Marketplace Listing", -1)),
                a("td", null, [
                  e.hasBits((Ie = e.access) == null ? void 0 : Ie.acl, e.Features.AddMarketplaceListing) ? (p(), h("i", jas)) : P("", !0)
                ])
              ]),
              a("tr", null, [
                t[73] || (t[73] = a("td", null, null, -1)),
                t[74] || (t[74] = a("td", null, null, -1)),
                t[75] || (t[75] = a("td", null, "Other Analysis Styles", -1)),
                a("td", null, [
                  e.hasBits((be = e.access) == null ? void 0 : be.acl, e.Features.OtherAnalysisStyles) ? (p(), h("i", Has)) : P("", !0)
                ])
              ]),
              a("tr", null, [
                t[76] || (t[76] = a("td", null, null, -1)),
                t[77] || (t[77] = a("td", null, null, -1)),
                t[78] || (t[78] = a("td", null, "PDF", -1)),
                a("td", null, [
                  e.hasBits((Oe = e.access) == null ? void 0 : Oe.acl, e.Features.PDF) ? (p(), h("i", Uas)) : P("", !0)
                ])
              ]),
              a("tr", null, [
                t[79] || (t[79] = a("td", null, null, -1)),
                t[80] || (t[80] = a("td", null, null, -1)),
                t[81] || (t[81] = a("td", null, "Portfolio Insights", -1)),
                a("td", null, [
                  e.hasBits((ze = e.access) == null ? void 0 : ze.acl, e.Features.PortfolioInsights) ? (p(), h("i", zas)) : P("", !0)
                ])
              ]),
              a("tr", null, [
                t[82] || (t[82] = a("td", null, null, -1)),
                t[83] || (t[83] = a("td", null, null, -1)),
                t[84] || (t[84] = a("td", null, "Property Metrics", -1)),
                a("td", null, [
                  e.hasBits((Re = e.access) == null ? void 0 : Re.acl, e.Features.PropertyMetrics) ? (p(), h("i", Was)) : P("", !0)
                ])
              ]),
              a("tr", null, [
                t[85] || (t[85] = a("td", null, null, -1)),
                t[86] || (t[86] = a("td", null, null, -1)),
                t[87] || (t[87] = a("td", null, "Rent Vs Sell", -1)),
                a("td", null, [
                  e.hasBits((ge = e.access) == null ? void 0 : ge.acl, e.Features.RentVsSell) ? (p(), h("i", Gas)) : P("", !0)
                ])
              ]),
              a("tr", null, [
                t[88] || (t[88] = a("td", null, null, -1)),
                t[89] || (t[89] = a("td", null, null, -1)),
                t[90] || (t[90] = a("td", null, "Search PreForeclosure", -1)),
                a("td", null, [
                  e.hasBits((he = e.access) == null ? void 0 : he.acl, e.Features.SearchPreForeclosure) ? (p(), h("i", Yas)) : P("", !0)
                ])
              ]),
              a("tr", null, [
                t[91] || (t[91] = a("td", null, null, -1)),
                t[92] || (t[92] = a("td", null, null, -1)),
                t[93] || (t[93] = a("td", null, "SkipTrace", -1)),
                a("td", null, [
                  e.hasBits((Me = e.access) == null ? void 0 : Me.acl, e.Features.SkipTrace) ? (p(), h("i", Xas)) : P("", !0)
                ])
              ]),
              a("tr", null, [
                t[94] || (t[94] = a("td", null, null, -1)),
                t[95] || (t[95] = a("td", null, null, -1)),
                t[96] || (t[96] = a("td", null, "View Courthouse Records", -1)),
                a("td", null, [
                  e.hasBits((Ne = e.access) == null ? void 0 : Ne.acl, e.Features.ViewCourthouseRecords) ? (p(), h("i", qas)) : P("", !0)
                ])
              ]),
              a("tr", null, [
                t[97] || (t[97] = a("td", null, null, -1)),
                t[98] || (t[98] = a("td", null, null, -1)),
                t[99] || (t[99] = a("td", null, "View PreForeclosure", -1)),
                a("td", null, [
                  e.hasBits(($e = e.access) == null ? void 0 : $e.acl, e.Features.ViewPreForeclosure) ? (p(), h("i", Qas)) : P("", !0)
                ])
              ]),
              a("tr", null, [
                t[100] || (t[100] = a("td", null, null, -1)),
                t[101] || (t[101] = a("td", null, null, -1)),
                t[102] || (t[102] = a("td", null, "View Tax Assessor", -1)),
                a("td", null, [
                  e.hasBits((mt = e.access) == null ? void 0 : mt.acl, e.Features.ViewTaxAssessor) ? (p(), h("i", Kas)) : P("", !0)
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ], 512);
}
const Zds = /* @__PURE__ */ Ae(Zss, [["render", Zas]]), Jas = me({
  name: "SavedSearchUpdates",
  props: {},
  components: {
    LoadingCard: qu
  },
  data() {
    return {
      runningTasks: 0,
      savedSearches: []
    };
  },
  computed: {
    busy() {
      return this.runningTasks > 0;
    },
    ...q(Te, ["access", "aclLoaded"])
  },
  methods: {
    number: Ve,
    currency: ka,
    date: nf,
    formatDuration: af,
    urlSlug(e) {
      return ci(e, { camelCase: !1 });
    },
    getDuration(e) {
      let t = Date.now() - ((e == null ? void 0 : e.getTime()) ?? 0);
      const s = Math.floor(t / 31556952e3);
      s > 0 && (t -= s * 31556952e3);
      const n = Math.floor(t / 2629746e3);
      n > 0 && (t -= n * 2629746e3);
      const r = Math.floor(t / 6048e5);
      r > 0 && (t -= r * 6048e5);
      const i = Math.floor(t / 864e5);
      i > 0 && (t -= i * 864e5);
      const o = Math.floor(t / 36e5);
      o > 0 && (t -= o * 36e5);
      const l = Math.floor(t / 6e4);
      l > 0 && (t -= l * 6e4);
      const d = Math.floor(t / 1e3);
      return {
        years: s,
        months: n % 12,
        weeks: r,
        days: i,
        hours: o,
        minutes: l,
        seconds: d
      };
    }
  },
  mounted() {
    this.aclLoaded.then(async () => {
      try {
        this.runningTasks++;
        const e = await W.api.searchMls.savedSearchStats();
        this.savedSearches.length = 0, this.savedSearches.push(...e.data.page);
      } finally {
        this.runningTasks--;
      }
    });
  }
}), $as = ["aria-busy"], _as = { class: "card-body" }, ens = { class: "table-responsive mb-0" }, tns = { class: "table table-sm" }, sns = ["title"], ans = { key: 0 }, nns = { class: "card-footer text-end bg-white border-0" };
function rns(e, t, s, n, r, i) {
  const o = pe("loading-card"), l = pe("router-link");
  return p(), h("div", {
    class: "card shadow-sm overflow-hidden card-idx",
    "aria-busy": e.busy
  }, [
    N(o),
    t[4] || (t[4] = a("div", { class: "card-header fw-bold border-0 bg-white fs-5 text-body-secondary pb-0 d-flex align-items-center" }, [
      a("img", {
        src: "https://cdn03.rescover.com/content/images/icons/investment-gateway-color.svg",
        height: "20",
        class: "me-2"
      }),
      y("Saved Search Updates ")
    ], -1)),
    a("div", _as, [
      a("div", ens, [
        a("table", tns, [
          t[2] || (t[2] = a("thead", null, [
            a("tr", null, [
              a("th", null, "Search Name"),
              a("th", null, "Last Matched"),
              a("th")
            ])
          ], -1)),
          a("tbody", null, [
            (p(!0), h(A, null, D(e.savedSearches, (d) => (p(), h("tr", null, [
              a("td", null, g(d.name), 1),
              a("td", null, [
                a("span", {
                  title: e.date(d.created)
                }, g(e.formatDuration(e.getDuration(d.created))), 9, sns)
              ]),
              a("td", null, [
                N(l, {
                  name: "search-saved",
                  params: { id: d.id, name: e.urlSlug(d.name) },
                  class: "btn btn-success btn-sm"
                }, {
                  default: ve(() => t[0] || (t[0] = [
                    y("View")
                  ])),
                  _: 2,
                  __: [0]
                }, 1032, ["params"])
              ])
            ]))), 256)),
            e.savedSearches.length == 0 ? (p(), h("tr", ans, t[1] || (t[1] = [
              a("td", { colspan: "3" }, " No recent saved search matches... ", -1)
            ]))) : P("", !0)
          ])
        ])
      ])
    ]),
    a("div", nns, [
      N(l, { name: "search-my-searches" }, {
        default: ve(() => t[3] || (t[3] = [
          y("View All Saved Searches "),
          a("i", { class: "fa-light fa-arrow-right-long ms-2" }, null, -1)
        ])),
        _: 1,
        __: [3]
      })
    ])
  ], 8, $as);
}
const Jds = /* @__PURE__ */ Ae(Jas, [["render", rns]]), ons = me({
  name: "BrandingCardFull",
  computed: {
    companyLogoUrl() {
      var e;
      return (e = this.branding) == null ? void 0 : e.companyLogoUrl;
    },
    headshotPhotoUrl() {
      var e;
      return (e = this.branding) == null ? void 0 : e.headshotPhotoUrl;
    },
    ...q(Te, ["acl", "aclLoaded"]),
    ...q(ct, ["branding"]),
    ...at(ct)
  },
  methods: {
    number: Ve,
    async loadBranding() {
      try {
        this.accountStore.branding || await this.accountStore.fetchBranding();
      } catch (e) {
        Se(e);
      }
    }
  },
  mounted() {
    this.aclLoaded.then(async () => await this.loadBranding());
  }
}), ins = {
  key: 0,
  class: "card shadow-sm bg-eclipse text-white h-100"
}, lns = { class: "card-body d-flex flex-row justify-content-between gap-4 align-items-center" }, dns = { class: "d-flex align-items-center justify-content-start" }, cns = { class: "flex-shrink-0" }, uns = ["src"], pns = { class: "flex-grow-1 ms-3" }, hns = { class: "fs-5 fw-bold" }, mns = { class: "text-white text-opacity-50 fw-bold" }, fns = { class: "list-unstyled m-0 flex-fill" }, gns = { key: 0 }, vns = { key: 1 }, yns = { key: 2 }, bns = { key: 3 };
function Ans(e, t, s, n, r, i) {
  return e.branding ? (p(), h("div", ins, [
    a("div", lns, [
      a("div", dns, [
        a("div", cns, [
          a("img", {
            src: e.headshotPhotoUrl,
            alt: "...",
            width: "70",
            height: "70",
            class: "rounded-circle"
          }, null, 8, uns)
        ]),
        a("div", pns, [
          t[0] || (t[0] = a("small", { class: "text-white-50" }, "Your Real Estate Professional", -1)),
          t[1] || (t[1] = a("br", null, null, -1)),
          a("span", hns, g(e.branding.agentFirstName) + " " + g(e.branding.agentLastName), 1),
          t[2] || (t[2] = a("br", null, null, -1)),
          a("span", mns, g(e.branding.company), 1)
        ])
      ]),
      a("ul", fns, [
        e.branding.email ? (p(), h("li", gns, [
          t[3] || (t[3] = a("i", { class: "fa-light fa-envelope me-2" }, null, -1)),
          y(" " + g(e.branding.email), 1)
        ])) : P("", !0),
        e.branding.cellPhone ? (p(), h("li", vns, [
          t[4] || (t[4] = a("i", { class: "fa-light fa-phone me-2" }, null, -1)),
          y(" " + g(e.branding.cellPhone), 1)
        ])) : P("", !0),
        e.branding.officePhone ? (p(), h("li", yns, [
          t[5] || (t[5] = a("i", { class: "fa-light fa-phone-alt me-2" }, null, -1)),
          y(" " + g(e.branding.officePhone), 1)
        ])) : P("", !0),
        e.branding.website ? (p(), h("li", bns, [
          t[6] || (t[6] = a("i", { class: "fa-light fa-globe me-2" }, null, -1)),
          y(" " + g(e.branding.website), 1)
        ])) : P("", !0)
      ])
    ])
  ])) : P("", !0);
}
const $ds = /* @__PURE__ */ Ae(ons, [["render", Ans]]), wns = me({
  name: "PropertySearch",
  props: {},
  components: {
    LoadingCard: qu,
    AutoComplete: e1
  },
  data() {
    return {
      selectedAddress: void 0,
      filteredAddresses: void 0,
      melissaToken: void 0
    };
  },
  computed: {
    autoCompletePlaceholder() {
      return this.melissaToken ? "Enter Address" : "Loading...";
    },
    ...q(Te, ["access", "aclLoaded"])
  },
  methods: {
    number: Ve,
    urlSlug(e) {
      return e ? ci(e, { camelCase: !1 }) : "";
    },
    async searchAddress(e) {
      var r;
      let t = e.query;
      const s = t == null ? void 0 : t.match(/^(\d+)-(\d+)/i);
      s && s.length > 0 && (t = t.replace(s[0], s[1]));
      let n = await ym.melissaDataApi.api.expressEntry.expressFreeForm({
        format: "json",
        id: this.melissaToken,
        ff: t,
        maxrecords: 30
      });
      ((r = n.data.Results) == null ? void 0 : r.length) == 0 && s && (t = t.replace(s[0], s[2]), n = await ym.melissaDataApi.api.expressEntry.expressFreeForm({
        format: "json",
        id: this.melissaToken,
        ff: t,
        maxrecords: 30
      })), this.filteredAddresses = n.data.Results;
    },
    searchSelect(e) {
      var n, r, i, o, l, d, c, u, m, f, v, b, w, S;
      console.log("searchSelect", e.value), e.value.fullAddress || ((((r = (n = this.selectedAddress) == null ? void 0 : n.Address) == null ? void 0 : r.SuiteCount) ?? 0) > 1 ? this.selectedAddress.fullAddress = this.buildAddress(this.selectedAddress) : this.selectedAddress.fullAddress = `${(i = this.selectedAddress.Address) == null ? void 0 : i.AddressLine1} ${(o = this.selectedAddress.Address) == null ? void 0 : o.City}, ${(l = this.selectedAddress.Address) == null ? void 0 : l.State} ${(d = this.selectedAddress.Address) == null ? void 0 : d.PostalCode}`);
      let t = (u = (c = this.selectedAddress) == null ? void 0 : c.Address) == null ? void 0 : u.PostalCode;
      const s = t == null ? void 0 : t.match(/^(\d+)(-\d+)?/i);
      s && s.length > 0 && (t = s[1]), window.location.href = t1.format(De.URL.Property.ByAddressZip, this.urlSlug((f = (m = this.selectedAddress) == null ? void 0 : m.Address) == null ? void 0 : f.State), this.urlSlug((b = (v = this.selectedAddress) == null ? void 0 : v.Address) == null ? void 0 : b.City), t, this.urlSlug((S = (w = this.selectedAddress) == null ? void 0 : w.Address) == null ? void 0 : S.AddressLine1));
    },
    buildAddress(e) {
      var n, r, i, o, l, d;
      let t = "", s = "";
      return (n = e.Address) != null && n.SuiteName && ((e.Address.SuiteCount ?? 0) > 1 && (s = ` (${e.Address.SuiteCount} entries)`), t = " "), `${(r = e.Address) == null ? void 0 : r.AddressLine1}${t}${(i = e.Address) == null ? void 0 : i.SuiteName}${s} ${(o = e.Address) == null ? void 0 : o.City}, ${(l = e.Address) == null ? void 0 : l.State} ${(d = e.Address) == null ? void 0 : d.PostalCode}`;
    }
  },
  created() {
  },
  mounted() {
    this.aclLoaded.then(async () => {
      await W.api.property.lookupToken().then((e) => {
        var t;
        this.melissaToken = ((t = e.data) == null ? void 0 : t.token) ?? void 0;
      });
    });
  }
}), Cns = { class: "card shadow-sm card-ps" }, Sns = { class: "card-body" };
function Pns(e, t, s, n, r, i) {
  const o = pe("loading-card"), l = pe("auto-complete");
  return p(), h("div", Cns, [
    N(o),
    t[3] || (t[3] = a("div", { class: "card-header fw-bold border-0 bg-white fs-5 text-body-secondary pb-0" }, [
      a("i", { class: "fa-light fa-search me-2" }),
      y("Property Search ")
    ], -1)),
    a("div", Sns, [
      N(l, {
        forceselection: "",
        modelValue: e.selectedAddress,
        "onUpdate:modelValue": t[0] || (t[0] = (d) => e.selectedAddress = d),
        class: "input-group",
        placeholder: e.autoCompletePlaceholder,
        delay: 800,
        "option-label": "fullAddress",
        dropdown: !0,
        "dropdown-mode": "current",
        suggestions: e.filteredAddresses,
        onComplete: t[1] || (t[1] = (d) => e.searchAddress(d)),
        onOptionSelect: t[2] || (t[2] = (d) => e.searchSelect(d)),
        disabled: !e.melissaToken
      }, {
        option: ve((d) => [
          a("div", null, g(e.buildAddress(d.option)), 1)
        ]),
        _: 1
      }, 8, ["modelValue", "placeholder", "suggestions", "disabled"])
    ])
  ]);
}
const _ds = /* @__PURE__ */ Ae(wns, [["render", Pns]]), kns = "#7F7F7F", Ens = "#FFA500", Ins = "#003466";
Rt.register(...tP);
const Tns = /* @__PURE__ */ new Date(), Ons = me({
  name: "MarketReport",
  props: {},
  components: {
    LoadingCard: qu
  },
  data() {
    return {
      runningTasks: 0,
      report: void 0
    };
  },
  computed: {
    busy() {
      return this.runningTasks > 0;
    },
    currentYear() {
      return Tns.getFullYear();
    },
    ...q(Te, ["access", "aclLoaded"]),
    ...q(ct, ["branding"])
  },
  methods: {
    number: Ve,
    currency: Ze,
    percent: Wt,
    valueChangeStyle(e, t) {
      return t === !0 ? {
        "text-danger": (e ?? 0) >= 0,
        "text-success": (e ?? 0) < 0
      } : {
        "text-success": (e ?? 0) >= 0,
        "text-danger": (e ?? 0) < 0
      };
    },
    valueChangeArrow(e) {
      return (e ?? 0) >= 0 ? "https://cdn03.rescover.com/widgets/content/property-view/icons/arrow-up-light.svg" : "https://cdn03.rescover.com/widgets/content/property-view/icons/arrow-down-light.svg";
    },
    initCharts() {
      const e = () => ({
        type: "doughnut",
        data: {
          //labels: [
          //    'Red',
          //    'Yellow',
          //    'Blue'
          //],
          datasets: [{
            data: [25, 25, 50],
            backgroundColor: [
              Ens,
              kns,
              Ins
            ]
          }]
        },
        options: {
          cutout: "60%",
          //responsive: false,
          maintainAspectRatio: !1,
          plugins: {
            tooltip: {
              mode: "index",
              intersect: !0,
              callbacks: {
                label: function(t, s) {
                  return " " + Wt(t.raw);
                }
              }
            },
            legend: {
              display: !1,
              position: "right",
              labels: {
                usePointStyle: !0,
                boxWidth: 6,
                generateLabels: (t) => {
                  const s = t.data.datasets;
                  return s[0].data.map((n, r) => ({
                    text: `${n} ${t.data.labels[r]}`,
                    fillStyle: s[0].backgroundColor[r],
                    index: r
                  }));
                }
              }
            },
            title: {
              display: !1
            }
          },
          animation: {
            animateScale: !1,
            animateRotate: !0
          }
        }
      });
      this.elistSoldPriceChart || (this.elistSoldPriceChart = this.$refs.listSoldPriceScaleChart.getContext("2d"), this.listSoldPriceDonutChart = new Rt(this.elistSoldPriceChart, e()));
    },
    updateChart(e) {
      var t, s, n, r, i, o, l, d, c, u, m, f;
      ((((s = (t = this.report) == null ? void 0 : t.listVsSoldPrice) == null ? void 0 : s.aboveListPricePercent) ?? 0) > 0 || (((r = (n = this.report) == null ? void 0 : n.listVsSoldPrice) == null ? void 0 : r.atListPricePercent) ?? 0) > 0 || (((o = (i = this.report) == null ? void 0 : i.listVsSoldPrice) == null ? void 0 : o.belowListPricePercent) ?? 0) > 0) && (e.data.datasets[0].data[0] = ((d = (l = this.report) == null ? void 0 : l.listVsSoldPrice) == null ? void 0 : d.aboveListPricePercent) ?? 0, e.data.datasets[0].data[1] = ((u = (c = this.report) == null ? void 0 : c.listVsSoldPrice) == null ? void 0 : u.atListPricePercent) ?? 0, e.data.datasets[0].data[2] = ((f = (m = this.report) == null ? void 0 : m.listVsSoldPrice) == null ? void 0 : f.belowListPricePercent) ?? 0, e.update());
    },
    updateChart2(e) {
      var t, s, n, r, i, o, l, d, c, u, m, f;
      ((((s = (t = this.report) == null ? void 0 : t.doMStats) == null ? void 0 : s.daysLT30Percent) ?? 0) > 0 || (((r = (n = this.report) == null ? void 0 : n.doMStats) == null ? void 0 : r.days30to90Percent) ?? 0) > 0 || (((o = (i = this.report) == null ? void 0 : i.doMStats) == null ? void 0 : o.daysGT90Percent) ?? 0) > 0) && (e.data.datasets[0].data[0] = ((d = (l = this.report) == null ? void 0 : l.doMStats) == null ? void 0 : d.daysLT30Percent) ?? 0, e.data.datasets[0].data[1] = ((u = (c = this.report) == null ? void 0 : c.doMStats) == null ? void 0 : u.days30to90Percent) ?? 0, e.data.datasets[0].data[2] = ((f = (m = this.report) == null ? void 0 : m.doMStats) == null ? void 0 : f.daysGT90Percent) ?? 0, e.update());
    },
    async loadMarketReport() {
      try {
        this.runningTasks++;
        const e = await W.api.marketReport.managementTerritory();
        if (e.data.status != de.Success)
          throw new Error(e.data.message);
        this.report = e.data.report, this.initCharts(), this.updateChart(this.listSoldPriceDonutChart);
      } catch (e) {
        console.error("loadMarketReport", e);
      } finally {
        this.runningTasks--;
      }
    }
  },
  mounted() {
    this.aclLoaded.then(async () => await this.loadMarketReport());
  }
}), Rns = ["aria-busy"], Lns = { class: "card-header fw-bold border-0 bg-white fs-5 text-body-secondary pb-0 d-flex align-items-center" }, Bns = { class: "card-body" }, Mns = { class: "row g-3" }, xns = { class: "col" }, Fns = { class: "row row-cols-lg-2 g-3" }, Vns = { class: "col" }, Dns = { class: "bg-light rounded p-2 text-center d-flex align-items-center justify-content-center flex-column h-100" }, Nns = { class: "fw-bold fs-4 lh-1" }, jns = { class: "text-body-secondary" }, Hns = { class: "col" }, Uns = { class: "bg-light rounded" }, zns = { class: "bg-light rounded p-2 text-center d-flex align-items-center justify-content-center flex-column h-100" }, Wns = { class: "text-body-secondary d-block" }, Gns = { class: "fs-4 fw-bold" }, Yns = { class: "d-flex gap-3 align-items-center" }, Xns = ["src"], qns = { class: "col" }, Qns = { class: "bg-light rounded" }, Kns = { class: "bg-light rounded p-2 text-center d-flex align-items-center justify-content-center flex-column h-100" }, Zns = { class: "text-body-secondary d-block" }, Jns = { class: "fs-4 fw-bold" }, $ns = { class: "d-flex gap-3 align-items-center" }, _ns = ["src"], ers = { class: "col" }, trs = { class: "bg-light rounded p-3" }, srs = { class: "row" }, ars = { class: "col-lg-6" }, nrs = {
  class: "bg-light rounded d-flex align-items-center justify-content-center",
  style: { height: "235px" }
}, rrs = {
  id: "listSoldPriceScaleChart",
  ref: "listSoldPriceScaleChart",
  height: "200"
}, ors = { class: "col-lg-6 d-flex align-items-center" }, irs = { class: "list-unstyled m-0" }, lrs = { class: "mb-2" }, drs = { class: "mb-2" };
function crs(e, t, s, n, r, i) {
  var l, d, c, u, m, f, v, b, w, S, I, T, x, k, C, O, E, B, M, R, F, L, j, H, te, re, le, ie, ye, Y, ae, ke, ue, oe, fe, we, Ie, be, Oe;
  const o = pe("loading-card");
  return p(), h("div", {
    class: "card shadow-sm overflow-hidden card-idx",
    "aria-busy": e.busy
  }, [
    N(o),
    a("div", Lns, [
      t[0] || (t[0] = a("img", {
        src: "https://cdn03.rescover.com/content/images/icons/investment-gateway-color.svg",
        height: "20",
        class: "me-2"
      }, null, -1)),
      y(g((l = e.branding) == null ? void 0 : l.company) + " Market Report ", 1)
    ]),
    a("div", Bns, [
      a("div", Mns, [
        a("div", xns, [
          a("div", Fns, [
            a("div", Vns, [
              a("div", Dns, [
                t[1] || (t[1] = a("p", { class: "fw-bold" }, "Median Sold Price", -1)),
                a("div", Nns, g(e.currency((c = (d = e.report) == null ? void 0 : d.medianSoldPrice) == null ? void 0 : c.median)), 1),
                a("small", jns, g(e.currency((m = (u = e.report) == null ? void 0 : u.medianSoldPrice) == null ? void 0 : m.priceSqFt)) + "/SF", 1),
                a("small", {
                  class: z(e.valueChangeStyle((v = (f = e.report) == null ? void 0 : f.medianSoldPrice) == null ? void 0 : v.priceChange))
                }, [
                  a("b", null, g(e.currency((w = (b = e.report) == null ? void 0 : b.medianSoldPrice) == null ? void 0 : w.priceChange)), 1),
                  y(" (" + g(e.percent((I = (S = e.report) == null ? void 0 : S.medianSoldPrice) == null ? void 0 : I.percentChange)) + ")", 1)
                ], 2)
              ])
            ]),
            a("div", Hns, [
              a("div", Uns, [
                a("div", zns, [
                  t[3] || (t[3] = a("p", { class: "fw-bold" }, "Average Days on Market", -1)),
                  a("small", Wns, g((k = (x = (T = e.report) == null ? void 0 : T.avgDoM) == null ? void 0 : x.month) == null ? void 0 : k.toUpperCase()) + " " + g(e.currentYear), 1),
                  a("span", Gns, g(e.number((O = (C = e.report) == null ? void 0 : C.avgDoM) == null ? void 0 : O.lastYearMonthAvgDoM)) + " days", 1),
                  a("div", Yns, [
                    t[2] || (t[2] = a("small", { class: "text-body-secondary fw-bold d-block" }, "CHANGE", -1)),
                    a("small", {
                      class: z(e.valueChangeStyle((B = (E = e.report) == null ? void 0 : E.avgDoM) == null ? void 0 : B.percentChange, !0))
                    }, [
                      y(g(e.percent((R = (M = e.report) == null ? void 0 : M.avgDoM) == null ? void 0 : R.percentChange)) + " ", 1),
                      a("img", {
                        src: e.valueChangeArrow((L = (F = e.report) == null ? void 0 : F.avgDoM) == null ? void 0 : L.percentChange),
                        title: "Amount Changed",
                        alt: "Amount Changed",
                        height: "20",
                        class: "ms-2"
                      }, null, 8, Xns)
                    ], 2)
                  ])
                ])
              ])
            ]),
            a("div", qns, [
              a("div", Qns, [
                a("div", Kns, [
                  t[5] || (t[5] = a("p", { class: "fw-bold" }, "Number of Sold Homes", -1)),
                  a("small", Zns, g((te = (H = (j = e.report) == null ? void 0 : j.soldHomes) == null ? void 0 : H.month) == null ? void 0 : te.toUpperCase()) + " " + g(e.currentYear), 1),
                  a("span", Jns, g(e.number((le = (re = e.report) == null ? void 0 : re.soldHomes) == null ? void 0 : le.currentYearSold)), 1),
                  a("div", $ns, [
                    t[4] || (t[4] = a("small", { class: "text-body-secondary fw-bold d-block" }, "CHANGE", -1)),
                    a("small", {
                      class: z(e.valueChangeStyle((ye = (ie = e.report) == null ? void 0 : ie.soldHomes) == null ? void 0 : ye.percentChange))
                    }, [
                      y(g(e.percent((ae = (Y = e.report) == null ? void 0 : Y.soldHomes) == null ? void 0 : ae.percentChange)) + " ", 1),
                      a("img", {
                        src: e.valueChangeArrow((ue = (ke = e.report) == null ? void 0 : ke.soldHomes) == null ? void 0 : ue.percentChange),
                        title: "Amount Changed",
                        alt: "Amount Changed",
                        height: "20",
                        class: "ms-2"
                      }, null, 8, _ns)
                    ], 2)
                  ])
                ])
              ])
            ]),
            t[6] || (t[6] = a("div", { class: "col" }, [
              a("div", { class: "bg-light rounded p-3 align-items-center d-flex justify-content-center text-small lh-1 h-100 flex-column text-center" }, [
                a("i", { class: "fa-light fa-calendar mb-4 fa-lg" }),
                y(" Based on all homes sold in the last 12 months ")
              ])
            ], -1))
          ])
        ]),
        a("div", ers, [
          a("div", trs, [
            t[19] || (t[19] = a("p", { class: "fw-bold" }, "List Price vs. Sold Price", -1)),
            a("div", srs, [
              a("div", ars, [
                a("div", nrs, [
                  a("canvas", rrs, null, 512)
                ])
              ]),
              a("div", ors, [
                a("ul", irs, [
                  a("li", lrs, [
                    t[7] || (t[7] = a("i", {
                      class: "fa-solid fa-circle-small me-2",
                      style: { color: "orange" }
                    }, null, -1)),
                    a("b", null, g(e.number((fe = (oe = e.report) == null ? void 0 : oe.listVsSoldPrice) == null ? void 0 : fe.aboveListPrice)), 1),
                    t[8] || (t[8] = y(" Homes Were Sold")),
                    t[9] || (t[9] = a("br", null, null, -1)),
                    t[10] || (t[10] = a("b", null, "Under Asking", -1))
                  ]),
                  a("li", drs, [
                    t[11] || (t[11] = a("i", {
                      class: "fa-solid fa-circle-small me-2",
                      style: { color: "darkgrey" }
                    }, null, -1)),
                    a("b", null, g(e.number((Ie = (we = e.report) == null ? void 0 : we.listVsSoldPrice) == null ? void 0 : Ie.atListPrice)), 1),
                    t[12] || (t[12] = y(" Homes Were Sold")),
                    t[13] || (t[13] = a("br", null, null, -1)),
                    t[14] || (t[14] = a("b", null, "At Asking", -1))
                  ]),
                  a("li", null, [
                    t[15] || (t[15] = a("i", {
                      class: "fa-solid fa-circle-small me-2",
                      style: { color: "#003564" }
                    }, null, -1)),
                    a("b", null, g(e.number((Oe = (be = e.report) == null ? void 0 : be.listVsSoldPrice) == null ? void 0 : Oe.belowListPrice)), 1),
                    t[16] || (t[16] = y(" Homes Were Sold")),
                    t[17] || (t[17] = a("br", null, null, -1)),
                    t[18] || (t[18] = a("b", null, "Over Asking", -1))
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ], 8, Rns);
}
const ecs = /* @__PURE__ */ Ae(Ons, [["render", crs]]), urs = me({
  name: "PortfolioFinderTargets",
  props: {},
  components: {
    LoadingCard: qu
  },
  data() {
    return {
      runningTasks: 0,
      investorOwned: void 0,
      targetsInTerritory: void 0,
      unvharvestedTargets: void 0,
      targetsOutOfState: void 0,
      rentalScoutProperties: []
    };
  },
  computed: {
    busy() {
      return this.runningTasks > 0;
    },
    ...q(Te, ["access", "aclLoaded"])
  },
  methods: {
    number: Ve,
    date: cs,
    async loadPortfolioFinderStats() {
      try {
        this.runningTasks++;
        const e = await W.api.portfolioFinder.getStats();
        this.investorOwned = e.data.investorOwned ?? void 0, this.targetsInTerritory = e.data.leadsInArea ?? void 0, this.unvharvestedTargets = e.data.unharvestedLeadsInArea ?? void 0, this.targetsOutOfState = e.data.targetsOutOfState ?? void 0;
      } finally {
        this.runningTasks--;
      }
    },
    async loadRentalScout() {
      try {
        this.runningTasks++;
        const e = await W.api.rentalScout.managementTerritory();
        this.rentalScoutProperties.length = 0, this.rentalScoutProperties.push(...e.data.page);
      } finally {
        this.runningTasks--;
      }
    },
    getPropertyPhoto(e) {
      const t = {};
      return e != null && e.photo && (t.backgroundImage = `url(${e.photo}?tr=n-thumb1)`), t;
    }
  },
  created() {
  },
  mounted() {
    this.aclLoaded.then(() => this.loadRentalScout()).then(() => this.loadPortfolioFinderStats());
  }
}), prs = ["aria-busy"], hrs = { class: "card-body" }, mrs = { class: "row row-cols-2 row-cols-lg-4 mb-3 g-3" }, frs = { class: "col" }, grs = { class: "bg-light rounded p-3 text-center d-flex align-items-center h-100 flex-column justify-content-between" }, vrs = { class: "fw-bold fs-5 mb-1" }, yrs = { class: "col" }, brs = { class: "bg-light rounded p-3 text-center d-flex align-items-center h-100 flex-column justify-content-between" }, Ars = { class: "fw-bold fs-5 mb-1" }, wrs = { class: "col" }, Crs = { class: "bg-light rounded p-3 text-center d-flex align-items-center h-100 flex-column justify-content-between" }, Srs = { class: "fw-bold fs-5 mb-1" }, Prs = { class: "col" }, krs = { class: "bg-light rounded p-3 text-center d-flex align-items-center h-100 flex-column justify-content-between" }, Ers = { class: "fw-bold fs-5 mb-1" }, Irs = { class: "table-responsive" }, Trs = { class: "table table-sm mb-0" }, Ors = { class: "d-flex" }, Rrs = { class: "card-photo-sm me-2" }, Lrs = ["href"], Brs = { class: "small m-0" }, Mrs = { class: "list-inline small" }, xrs = { class: "list-inline-item" }, Frs = { class: "list-inline-item" }, Vrs = { class: "list-inline-item" }, Drs = { class: "list-inline-item" }, Nrs = ["href"], jrs = { class: "card-footer text-end bg-white border-0" };
function Hrs(e, t, s, n, r, i) {
  var d, c;
  const o = pe("loading-card"), l = pe("router-link");
  return (c = (d = e.access) == null ? void 0 : d.leads) != null && c.leads ? (p(), h("div", {
    key: 0,
    class: "card shadow-sm card-pf",
    "aria-busy": e.busy
  }, [
    N(o),
    t[13] || (t[13] = a("div", { class: "card-header fw-bold border-0 bg-white fs-5 text-body-secondary pb-0 d-flex align-items-center" }, [
      a("img", {
        src: "https://cdn03.rescover.com/content/images/icons/portfolio-finder-color.svg",
        height: "20",
        class: "me-2"
      }),
      y("Portfolio Finder Targets ")
    ], -1)),
    a("div", hrs, [
      a("div", mrs, [
        a("div", frs, [
          a("div", grs, [
            a("span", vrs, g(e.number(e.investorOwned, void 0, "-")), 1),
            t[0] || (t[0] = a("small", { class: "text-body-secondary" }, "INVESTMENT PROPERTIES IN TERRITORY", -1))
          ])
        ]),
        a("div", yrs, [
          a("div", brs, [
            a("span", Ars, g(e.number(e.targetsInTerritory, void 0, "-")), 1),
            t[1] || (t[1] = a("small", { class: "text-body-secondary" }, "TARGETS IN TERRITORY", -1))
          ])
        ]),
        a("div", wrs, [
          a("div", Crs, [
            a("span", Srs, g(e.number(e.unvharvestedTargets, void 0, "-")), 1),
            t[2] || (t[2] = a("small", { class: "text-body-secondary" }, "UNVHARVESTED TARGETS", -1))
          ])
        ]),
        a("div", Prs, [
          a("div", krs, [
            a("span", Ers, g(e.number(e.targetsOutOfState, void 0, "-")), 1),
            t[3] || (t[3] = a("small", { class: "text-body-secondary" }, [
              y("OUT OF STATE"),
              a("br"),
              y("PROFESSIONAL INVESTORS")
            ], -1))
          ])
        ])
      ]),
      t[11] || (t[11] = a("p", null, "MLS and property records indicate the investors below have made changes to their portfolio. As they make changes to their portfolio or their properties and needs change, now is the time to make contact.", -1)),
      a("div", Irs, [
        a("table", Trs, [
          t[10] || (t[10] = a("thead", null, [
            a("tr", null, [
              a("th", null, "Property"),
              a("th", null, "Last Updated"),
              a("th", null, "Owner Name"),
              a("th", null, "Properties"),
              a("th")
            ])
          ], -1)),
          a("tbody", null, [
            (p(!0), h(A, null, D(e.rentalScoutProperties, (u) => {
              var m;
              return p(), h("tr", null, [
                a("td", null, [
                  a("div", Ors, [
                    a("div", Rrs, [
                      a("div", {
                        class: "property-image",
                        style: rn(e.getPropertyPhoto(u))
                      }, null, 4)
                    ]),
                    a("div", null, [
                      a("a", {
                        href: "/homes/" + u.propId + "#recordsTab",
                        target: "_blank"
                      }, [
                        a("address", Brs, [
                          y(g((m = u.address) == null ? void 0 : m.address), 1),
                          t[4] || (t[4] = a("i", { class: "fa-light fa-arrow-up-right-from-square ms-2" }, null, -1))
                        ])
                      ], 8, Lrs),
                      a("ul", Mrs, [
                        a("li", xrs, [
                          t[5] || (t[5] = a("img", {
                            src: Cb,
                            height: "14",
                            width: "14",
                            class: "img-fluid me-1",
                            alt: "Blueprint",
                            title: "Blueprint"
                          }, null, -1)),
                          y(g(e.number(u.sqFt, void 0, "-")), 1)
                        ]),
                        a("li", Frs, [
                          t[6] || (t[6] = a("i", { class: "fa-light fa-bed me-1" }, null, -1)),
                          y(g(e.number(u.bedrooms, void 0, "-")), 1)
                        ]),
                        a("li", Vrs, [
                          t[7] || (t[7] = a("i", { class: "fa-light fa-bath me-1" }, null, -1)),
                          y(g(e.number(u.bathrooms, void 0, "-")), 1)
                        ]),
                        a("li", Drs, [
                          t[8] || (t[8] = a("i", { class: "fa-light fa-birthday-cake me-1" }, null, -1)),
                          y(g(u.yearBuilt), 1)
                        ])
                      ])
                    ])
                  ])
                ]),
                a("td", null, g(e.date(u.lastModified)), 1),
                a("td", null, g(u.ownerName), 1),
                a("td", null, g(e.number(u.properties)), 1),
                a("td", null, [
                  a("a", {
                    href: u.url,
                    target: "_blank"
                  }, t[9] || (t[9] = [
                    y("View on Zillow"),
                    a("i", { class: "fa-light fa-arrow-up-right-from-square ms-2" }, null, -1)
                  ]), 8, Nrs)
                ])
              ]);
            }), 256))
          ])
        ])
      ])
    ]),
    a("div", jrs, [
      N(l, { name: "portfolio-finder-search" }, {
        default: ve(() => t[12] || (t[12] = [
          y("Search Investor Targets "),
          a("i", { class: "fa-light fa-arrow-right-long ms-2" }, null, -1)
        ])),
        _: 1,
        __: [12]
      })
    ])
  ], 8, prs)) : P("", !0);
}
const tcs = /* @__PURE__ */ Ae(urs, [["render", Hrs]]), Urs = me({
  name: "ListingsCarousel",
  props: {
    featured: Boolean
  },
  components: {
    ListingTile: Kb,
    Carousel: SI
  },
  data() {
    return {
      rebuild: !1,
      hasZeroFeaturedListing: !1,
      responsiveOptions: [
        {
          breakpoint: "1400px",
          numVisible: 3,
          numScroll: 1
        },
        {
          breakpoint: "1199px",
          numVisible: 2,
          numScroll: 1
        },
        {
          breakpoint: "767px",
          numVisible: 1,
          numScroll: 1
        },
        {
          breakpoint: "575px",
          numVisible: 1,
          numScroll: 1
        }
      ]
    };
  },
  watch: {
    showFeatured(e) {
      e ? this.loadFeaturedListings() : this.loadMarketplace();
    }
  },
  computed: {
    showFeatured: {
      get() {
        return this.cacheStore.listingType == "featured";
      },
      set(e) {
        e ? this.cacheStore.setListingType("featured") : this.cacheStore.setListingType("marketplace");
      }
    },
    busy() {
      return this.featuredListingsBusy || this.marketplaceListingsBusy;
    },
    accordionStyle() {
      return {
        //'accordion-item': true,
        card: !0,
        shadow: !0,
        "card-idx": !this.marketplace,
        "card-na": this.marketplace
      };
    },
    listings() {
      return this.showFeatured ? this.featuredListings : this.marketplaceListings;
    },
    ...at(il),
    ...q(Te, ["access", "aclLoaded"]),
    ...q(il, ["featuredListings", "marketplaceListings", "featuredListingsBusy", "marketplaceListingsBusy"])
  },
  methods: {
    number: Ve,
    async loadFeaturedListings() {
      try {
        this.rebuild = !0, this.$nextTick(async () => {
          this.featuredListings.length == 0 && (await this.cacheStore.loadFeaturedListings(), this.showFeatured = this.featuredListings.length != 0, this.hasZeroFeaturedListing = this.featuredListings.length == 0), this.rebuild = !1;
        });
      } catch (e) {
        console.error(e), this.rebuild = !1;
      }
    },
    async loadMarketplace() {
      try {
        this.rebuild = !0, this.$nextTick(async () => {
          this.marketplaceListings.length == 0 && await this.cacheStore.loadMarketplace(), this.rebuild = !1;
        });
      } catch (e) {
        console.error(e), this.rebuild = !1;
      }
    },
    viewListing(e) {
      const t = this.$router.resolve({
        name: "mls-listing",
        query: e.queryString,
        params: {
          mlsSource: e.mlsSource,
          mlsNumber: e.mlsNumber
        }
      });
      window.open(t.href, `_${e.id}`);
    }
  },
  mounted() {
    this.featured ? this.showFeatured = !0 : this.loadMarketplace();
  }
}), zrs = { class: "card-header border-0 bg-white pb-0 d-flex flex-column flex-lg-row" }, Wrs = {
  key: 2,
  class: "form-check form-switch form-switch-lg form-switch-short form-switch-listing-carousel ms-auto"
}, Grs = ["disabled"], Yrs = { class: "card-body" }, Xrs = { class: "card-footer text-end bg-white border-0" };
function qrs(e, t, s, n, r, i) {
  const o = pe("listing-tile"), l = pe("Carousel"), d = pe("router-link");
  return p(), Fe(ks, {
    name: "slide",
    mode: "out-in"
  }, {
    default: ve(() => [
      e.busy || e.listings.length > 0 ? (p(), h("div", {
        key: 0,
        class: z(e.accordionStyle)
      }, [
        a("div", zrs, [
          e.showFeatured ? (p(), h(A, { key: 1 }, [
            t[3] || (t[3] = a("img", {
              src: "https://cdn03.rescover.com/content/images/icons/investment-gateway-color.svg",
              height: "20",
              class: "me-2 mt-2",
              alt: "Investment Gateway IDX",
              title: "Investment Gateway IDX"
            }, null, -1)),
            t[4] || (t[4] = a("div", { class: "fw-bold fs-5 text-body-secondary" }, [
              y(" Featured Investment Opportunities"),
              a("br", { class: "d-none d-xl-block d-xxl-none" }),
              a("span", { class: "d-none d-xxl-inline-block mx-xxl-2" }, " - "),
              y("Perfect for Expanding Your Portfolio ")
            ], -1))
          ], 64)) : (p(), h(A, { key: 0 }, [
            t[1] || (t[1] = a("img", {
              src: Fm,
              height: "17",
              class: "me-2 mt-1",
              alt: "rescover",
              title: "rescover"
            }, null, -1)),
            t[2] || (t[2] = a("div", { class: "fw-bold fs-5 text-body-secondary" }, " Rescover Marketplace Listings ", -1))
          ], 64)),
          e.hasZeroFeaturedListing ? P("", !0) : (p(), h("div", Wrs, [
            V(a("input", {
              class: "form-check-input",
              type: "checkbox",
              role: "switch",
              id: "flexSwitchCheckDefault",
              "onUpdate:modelValue": t[0] || (t[0] = (c) => e.showFeatured = c),
              disabled: e.busy
            }, null, 8, Grs), [
              [Ue, e.showFeatured]
            ]),
            t[5] || (t[5] = a("label", {
              class: "form-check-label",
              for: "flexSwitchCheckDefault"
            }, [
              y(" Featured"),
              a("span", null, "Marketplace")
            ], -1))
          ]))
        ]),
        a("div", Yrs, [
          e.rebuild ? P("", !0) : (p(), Fe(l, {
            key: 0,
            value: e.listings,
            numVisible: 3,
            numScroll: 1,
            circular: "",
            autoplayInterval: 3e3,
            responsiveOptions: e.responsiveOptions
          }, {
            item: ve((c) => [
              N(o, {
                listing: c.data,
                onViewListing: e.viewListing,
                onSelectListing: e.viewListing
              }, null, 8, ["listing", "onViewListing", "onSelectListing"])
            ]),
            _: 1
          }, 8, ["value", "responsiveOptions"]))
        ]),
        a("div", Xrs, [
          e.showFeatured ? (p(), Fe(d, {
            key: 0,
            name: "marketplace-search"
          }, {
            default: ve(() => t[6] || (t[6] = [
              y("View All Listings "),
              a("i", { class: "fa-light fa-arrow-right-long ms-2" }, null, -1)
            ])),
            _: 1,
            __: [6]
          })) : P("", !0)
        ])
      ], 2)) : P("", !0)
    ]),
    _: 1
  });
}
const scs = /* @__PURE__ */ Ae(Urs, [["render", qrs], ["__scopeId", "data-v-5247adc3"]]), Qrs = "#820401", Krs = "#DE542C";
Rt.register(...tP);
const Zrs = new xa(), Jrs = me({
  name: "PortfolioSummary",
  props: {},
  components: {},
  data() {
    return {
      summary: void 0,
      chartsInitialized: !1,
      chartOptionsSet: !1,
      chart2Data: void 0,
      chart2Options: void 0,
      chart3Data: void 0,
      chart3Options: void 0
    };
  },
  computed: {
    ...q(Te, ["access", "aclLoaded"]),
    ...q(ba, ["financialOverview", "portfolioSummary", "portfolioLoaded"])
  },
  methods: {
    currency: Ze,
    percent: Wt,
    getChartBackgroundColors(e, t, s = !0) {
      return [
        ...e.filter((n) => n.year < Et && s !== !0).map((n) => t(n) ? Krs : De.Colors.Charts.LightBlue),
        ...e.filter((n) => n.year == Et && s !== !0).map((n) => t(n) ? Qrs : De.Colors.Charts.DarkBlue),
        ...e.filter((n) => n.year > Et || s === !0).map((n) => t(n) ? De.Colors.Charts.Red : De.Colors.Charts.Green)
      ];
    },
    initCharts() {
      if (console.log(`${this.$options.name}.initCharts`), this.$refs.chart2 && !this.chart2) {
        const e = tr("line", this.chart2Data, this.chart2Options);
        this.chart2 = new Rt(this.$refs.chart2, e);
      }
      if (this.$refs.chart3 && !this.chart3) {
        const e = tr("bar", this.chart3Data, this.chart3Options, [Rd()]);
        this.chart3 = new Rt(this.$refs.chart3, e);
      }
      this.chartsInitialized = !0, this.refreshCharts();
    },
    async setChartOptions() {
      console.log(`${this.$options.name}.setChartOptions`), await Zrs.runExclusive(() => {
        this.chartOptionsSet || (this.chart2Data = lf(), this.chart2Data.datasets[0].hidden = !0, this.chart2Data.datasets[0].borderColor = De.Colors.Charts.Blue, this.chart2Data.datasets[0].borderWidth = 1, this.chart2Data.datasets[0].pointRadius = 3, this.chart2Data.datasets[1].hidden = !0, this.chart2Options = df(), this.chart3Data = Ld(), this.chart3Data.datasets[0].hidden = !0, this.chart3Options = Bd(), this.chartsInitialized || this.initCharts(), this.chartOptionsSet = !0);
      });
    },
    refreshCharts() {
      var i, o;
      const e = this.financialOverview.map((l) => l.year);
      let t = Et;
      const s = e.filter((l) => l >= t && l <= t + 6), n = this.financialOverview.filter((l) => l.year >= t && l.year <= t + 6), r = e.filter((l) => l == Et).map((l) => De.Colors.Charts.DarkBlue).concat(e.filter((l) => l > Et).map((l) => De.Colors.Charts.Green));
      this.chart2 && ((i = this.financialOverview) == null ? void 0 : i.length) > 0 && (this.chart2Data.labels = s.map((l) => `${l}`), this.chart2Data.datasets[0].pointBorderColor = r, this.chart2Data.datasets[0].pointBackgroundColor = r, this.chart2Data.datasets[0].data = n.map((l) => l.coc), this.chart2Data.datasets[0].hidden = !1, this.chart2.update(), this.chart2.resize()), this.chart3 && ((o = this.financialOverview) == null ? void 0 : o.length) > 0 && (this.chart3Data.labels = s.map((l) => `${l}`), this.chart3Data.datasets[0].backgroundColor = this.getChartBackgroundColors(n, (l) => (l.netEquity ?? 0) < 0, !1), this.chart3Data.datasets[0].data = n.map((l) => l.netEquity), this.chart3Data.datasets[0].hidden = !1, this.chart3Data.datasets[1].hidden = !0, this.chart3.update(), this.chart3.resize());
    }
  },
  mounted() {
    this.aclLoaded.then(async () => {
      const e = await W.api.portfolioInsights.getMySummary();
      this.summary = e.data.summary;
    }), this.portfolioLoaded.then(async () => await this.setChartOptions()).then(() => this.refreshCharts());
  }
}), $rs = {
  key: 0,
  class: "card shadow-sm card-pi"
}, _rs = { class: "card-body" }, eos = { class: "row row-cols-lg-2 g-3 mb-3 text-center" }, tos = { class: "col" }, sos = { class: "bg-light rounded d-flex align-items-center justify-content-center p-3 flex-column" }, aos = { class: "investment-chart" }, nos = {
  id: "listSoldPriceScaleChart",
  ref: "chart2"
}, ros = { class: "col" }, oos = { class: "bg-light rounded d-flex align-items-center justify-content-center p-3 flex-column" }, ios = { class: "investment-chart" }, los = {
  id: "domScaleChart",
  ref: "chart3"
}, dos = { class: "row row-cols-lg-3 g-3" }, cos = { class: "col" }, uos = { class: "bg-light rounded p-3 h-100 text-center" }, pos = { class: "fw-bold fs-5" }, hos = { class: "col" }, mos = { class: "bg-light rounded p-3 h-100 text-center" }, fos = { class: "fw-bold fs-5" }, gos = { class: "col" }, vos = { class: "bg-light rounded p-3 h-100 text-center" }, yos = { class: "fw-bold fs-5" }, bos = { class: "col" }, Aos = { class: "bg-light rounded p-3 h-100 text-center" }, wos = { class: "fw-bold fs-5" }, Cos = { class: "col" }, Sos = { class: "bg-light rounded p-3 h-100 text-center" }, Pos = { class: "fw-bold fs-5" }, kos = { class: "col" }, Eos = { class: "bg-light rounded p-3 h-100 text-center" }, Ios = { class: "fw-bold fs-5" }, Tos = { class: "card-footer text-end bg-white border-0" };
function Oos(e, t, s, n, r, i) {
  var l, d, c, u, m, f, v;
  const o = pe("router-link");
  return ((l = e.summary) == null ? void 0 : l.totalPropertyValue) > 0 ? (p(), h("div", $rs, [
    t[15] || (t[15] = a("div", { class: "card-header fw-bold border-0 bg-white fs-5 text-body-secondary pb-0 d-flex align-items-center" }, [
      a("img", {
        src: "https://cdn03.rescover.com/content/images/icons/portfolio-insights-color.svg",
        height: "20",
        class: "me-2"
      }),
      y("My Investments ")
    ], -1)),
    a("div", _rs, [
      a("div", eos, [
        a("div", tos, [
          a("div", sos, [
            t[0] || (t[0] = a("p", { class: "fw-bold" }, "Return on Investment", -1)),
            a("div", aos, [
              a("canvas", nos, null, 512)
            ])
          ])
        ]),
        a("div", ros, [
          a("div", oos, [
            t[1] || (t[1] = a("p", { class: "fw-bold" }, "Net Equity", -1)),
            a("div", ios, [
              a("canvas", los, null, 512)
            ])
          ])
        ])
      ]),
      a("div", dos, [
        a("div", cos, [
          a("div", uos, [
            a("span", pos, g(e.currency((d = e.summary) == null ? void 0 : d.totalPropertyValue, 0, "-")), 1),
            t[2] || (t[2] = a("br", null, null, -1)),
            t[3] || (t[3] = a("small", { class: "text-secondary" }, "PORFTOLIO VALUE", -1))
          ])
        ]),
        a("div", hos, [
          a("div", mos, [
            a("span", fos, g(e.currency((c = e.summary) == null ? void 0 : c.totalNetEquity, 0, "-")), 1),
            t[4] || (t[4] = a("br", null, null, -1)),
            t[5] || (t[5] = a("small", { class: "text-secondary" }, "NET EQUITY", -1))
          ])
        ]),
        a("div", gos, [
          a("div", vos, [
            a("span", yos, g(e.currency((u = e.summary) == null ? void 0 : u.totalMonthlyCashFlow, 0, "-")), 1),
            t[6] || (t[6] = a("br", null, null, -1)),
            t[7] || (t[7] = a("small", { class: "text-secondary" }, "TOTAL MONTHLY CASH FLOW", -1))
          ])
        ]),
        a("div", bos, [
          a("div", Aos, [
            a("span", wos, g(e.percent((m = e.summary) == null ? void 0 : m.coc, 2, "-")), 1),
            t[8] || (t[8] = a("br", null, null, -1)),
            t[9] || (t[9] = a("small", { class: "text-secondary" }, "PORTFOLIO COC", -1))
          ])
        ]),
        a("div", Cos, [
          a("div", Sos, [
            a("span", Pos, g(e.percent((f = e.summary) == null ? void 0 : f.irr, 2, "-")), 1),
            t[10] || (t[10] = a("br", null, null, -1)),
            t[11] || (t[11] = a("small", { class: "text-secondary" }, "PORTFOLIO IRR", -1))
          ])
        ]),
        a("div", kos, [
          a("div", Eos, [
            a("span", Ios, g(e.currency((v = e.summary) == null ? void 0 : v.wealthAccumulation, 0, "-")), 1),
            t[12] || (t[12] = a("br", null, null, -1)),
            t[13] || (t[13] = a("small", { class: "text-secondary" }, "WEALTH ACCUMULATION", -1))
          ])
        ])
      ])
    ]),
    a("div", Tos, [
      N(o, { name: "folio-my-investments-portfolios" }, {
        default: ve(() => t[14] || (t[14] = [
          y("View My Investment Portfolio "),
          a("i", { class: "fa-light fa-arrow-right-long ms-2" }, null, -1)
        ])),
        _: 1,
        __: [14]
      })
    ])
  ])) : P("", !0);
}
const acs = /* @__PURE__ */ Ae(Jrs, [["render", Oos]]);
let Jy = null;
const Ros = new Promise((e) => Jy = e), Los = me({
  name: "PropertyLocations",
  components: {},
  data() {
    return {
      mapOptions: void 0,
      center: void 0,
      googleMapsSdkReady: !1
    };
  },
  computed: {
    ownerProperties() {
      return this.googleMapsSdkReady ? this.properties : [];
    },
    portfolioInsights() {
      var e;
      return is((e = this.access) == null ? void 0 : e.acl, Oa.PortfolioInsights);
    },
    featured() {
      return this.listingType == "featured" ? this.featuredListings : this.marketplaceListings;
    },
    ...q(Te, ["access", "aclLoaded"]),
    ...q(ba, ["portfolioName", "hasMultiple", "hasAssets", "clientsInfo", "properties", "portfolioInsightsErrorMessage", "portfoliosLoading", "portfolioSummary", "portfolioLoaded"]),
    ...q(il, ["featuredListings", "marketplaceListings", "featuredListingsBusy", "marketplaceListingsBusy", "listingType"])
  },
  watch: {
    properties: {
      deep: !0,
      handler(e, t) {
        this.updateMapBounds();
      }
    },
    featured: {
      deep: !0,
      handler(e, t) {
        this.updateMapBounds();
      }
    }
  },
  methods: {
    number: Ve,
    //#region Map Controls
    mapInit() {
      this.center = {
        lat: 30.173937,
        lng: -95.505836
      }, this.mapOptions = {
        zoom: 10,
        //this.currentZoom,
        disableDefaultUI: !0,
        streetViewControl: !0,
        streetViewControlOptions: {
          position: google.maps.ControlPosition.LEFT_BOTTOM
        },
        isFractionalZoomEnabled: !1
      }, this.$refs.gMap && (this.map = this.$refs.gMap.$mapObject, Jy && Jy(!0), this.googleMapsSdkReady = !0);
    },
    zoomOut() {
      const e = this.map.getZoom();
      this.map.setZoom(e - 1);
    },
    zoomIn() {
      const e = this.map.getZoom();
      this.map.setZoom(e + 1);
    },
    //#endregion
    async updateMapBounds() {
      await Ros.then(() => {
        const e = new google.maps.LatLngBounds();
        [...this.featured, ...this.properties ?? []].forEach((t) => {
          t.latitude && t.longitude && e.extend({
            lat: t.latitude,
            lng: t.longitude
          });
        }), e.isEmpty() == !1 && (google.maps.event.addListenerOnce(this.map, "bounds_changed", () => {
          this.map.setZoom(Math.min(this.map.getZoom(), 13));
        }), this.$nextTick(() => {
          this.map.fitBounds(e, 1);
        }));
      });
    },
    markerClick(e, t) {
      this.center = {
        lat: t.latitude,
        lng: t.longitude
      };
    },
    markerChanged(e, t, s) {
    },
    existingInvestmentPin() {
      if (this.googleMapsSdkReady)
        return new google.maps.marker.PinElement({
          glyphColor: "#b5abda",
          background: "#8e7cc3",
          borderColor: "#8e7cc3"
        }).element;
    },
    featuredPin() {
      if (this.googleMapsSdkReady)
        return new google.maps.marker.PinElement({
          glyphColor: "#cadff3",
          background: "#6fa8dc",
          borderColor: "#6fa8dc"
        }).element;
    },
    featuredTitle(e) {
      return this.listingType == "featured" ? "Featured: " + e.address : "Marketplace: " + e.address;
    }
  },
  mounted() {
    this.aclLoaded.then(async () => {
      this.portfolioInsights && await this.$gmapApiPromiseLazy().then(() => this.mapInit()).catch((e) => {
        Se(e);
      });
    }).then(async () => {
      this.portfolioInsights || await this.$gmapApiPromiseLazy().then(() => this.mapInit()).catch((e) => {
        Se(e);
      });
    });
  }
}), Bos = { class: "card shadow card-na" }, Mos = { class: "card-header bg-white fw-bold border-0 fs-6" }, xos = {
  class: "bg-light d-flex align-items-center justify-content-center position-relative",
  style: { height: "330px", width: "100%" }
}, Fos = {
  id: "mapControls",
  class: "position-absolute d-flex justify-content-between gap-2 flex-column",
  style: { "z-index": "100", bottom: "15px", right: "15px" }
};
function Vos(e, t, s, n, r, i) {
  const o = pe("GMapAdvMarker"), l = pe("GMapMap");
  return p(), h("div", Bos, [
    a("div", Mos, [
      t[2] || (t[2] = a("img", {
        src: Fm,
        height: "17",
        class: "me-2"
      }, null, -1)),
      e.portfolioInsights ? (p(), h(A, { key: 0 }, [
        y(" Assets & Opportunities ")
      ], 64)) : (p(), h(A, { key: 1 }, [
        y(" Investment Opportunities ")
      ], 64))
    ]),
    a("div", xos, [
      a("div", Fos, [
        a("button", {
          onClick: t[0] || (t[0] = (...d) => e.zoomIn && e.zoomIn(...d)),
          class: "btn btn-light shadow-sm"
        }, t[3] || (t[3] = [
          a("i", { class: "fa-light fa-plus" }, null, -1),
          a("span", { class: "visually-hidden" }, "Zoom in", -1)
        ])),
        a("button", {
          onClick: t[1] || (t[1] = (...d) => e.zoomOut && e.zoomOut(...d)),
          class: "btn btn-light shadow-sm"
        }, t[4] || (t[4] = [
          a("i", { class: "fa-light fa-minus" }, null, -1),
          a("span", { class: "visually-hidden" }, "Zoom out", -1)
        ]))
      ]),
      N(l, {
        ref: "gMap",
        class: "h-100 w-100",
        "map-id": "2ddbbe0dd6bcf8f9",
        center: e.center,
        options: e.mapOptions
      }, {
        default: ve(() => [
          (p(!0), h(A, null, D(e.ownerProperties, (d, c) => (p(), Fe(o, {
            key: d.propId,
            position: { lat: d.latitude, lng: d.longitude },
            gmpClickable: !0,
            gmpDraggable: !1,
            title: d.address,
            "z-index": 2e3,
            content: e.existingInvestmentPin(),
            onChange: e.markerChanged,
            onClick: (u) => e.markerClick(u, d)
          }, null, 8, ["position", "title", "content", "onChange", "onClick"]))), 128)),
          (p(!0), h(A, null, D(e.featured, (d, c) => (p(), Fe(o, {
            key: d.id,
            position: { lat: d.latitude, lng: d.longitude },
            gmpClickable: !0,
            gmpDraggable: !1,
            content: e.featuredPin(),
            "z-index": 1e3,
            title: e.featuredTitle(d),
            onClick: (u) => e.markerClick(u, d)
          }, null, 8, ["position", "content", "title", "onClick"]))), 128))
        ]),
        _: 1
      }, 8, ["center", "options"])
    ])
  ]);
}
const ncs = /* @__PURE__ */ Ae(Los, [["render", Vos]]);
let $y = null;
const Dos = new Promise((e) => $y = e), Nos = me({
  name: "MarketplaceListingsLocations",
  components: {},
  data() {
    return {
      googleMapsSdkReady: !1,
      mapOptions: void 0,
      center: void 0,
      listings: []
    };
  },
  computed: {
    ...q(Te, ["access", "aclLoaded"])
  },
  watch: {
    listings: {
      deep: !0,
      handler(e, t) {
        this.updateMapBounds();
      }
    }
  },
  methods: {
    number: Ve,
    //#region Map Controls
    mapInit() {
      this.center = {
        lat: 30.173937,
        lng: -95.505836
      }, this.mapOptions = {
        zoom: 10,
        //this.currentZoom,
        disableDefaultUI: !0,
        streetViewControl: !0,
        streetViewControlOptions: {
          position: google.maps.ControlPosition.LEFT_BOTTOM
        },
        isFractionalZoomEnabled: !1
      }, this.$refs.gMap && (this.map = this.$refs.gMap.$mapObject, $y && $y(!0), this.googleMapsSdkReady = !0);
    },
    zoomOut() {
      const e = this.map.getZoom();
      this.map.setZoom(e - 1);
    },
    zoomIn() {
      const e = this.map.getZoom();
      this.map.setZoom(e + 1);
    },
    //#endregion
    async updateMapBounds() {
      await Dos.then(() => {
        const e = new google.maps.LatLngBounds();
        this.listings.forEach((t) => {
          t.latitude && t.longitude && e.extend({
            lat: t.latitude,
            lng: t.longitude
          });
        }), e.isEmpty() == !1 && (google.maps.event.addListenerOnce(this.map, "bounds_changed", () => {
          this.map.setZoom(Math.min(this.map.getZoom(), 13));
        }), this.$nextTick(() => {
          this.map.fitBounds(e, 1);
        }));
      });
    },
    async loadMarketplace() {
      try {
        const e = await Td(), t = await W.api.marketplace.activeListings(1, 100, e == null ? void 0 : e.latitude, e == null ? void 0 : e.longitude);
        if (t.data.status != de.Success)
          throw new Le(t);
        this.listings.length = 0, this.listings.push(...t.data.properties);
      } catch (e) {
        console.error(e);
      }
    },
    markerTitle(e) {
      return `${e.address}, ${e.city}, ${e.state} ${e.zip}`;
    },
    markerClick(e, t) {
      this.$router.push({
        name: "mls-listing",
        params: {
          mlsSource: t.mlsSource,
          mlsNumber: t.mlsNumber
        }
      }), this.center = {
        lat: t.latitude,
        lng: t.longitude
      };
    },
    markerChanged(e, t, s) {
    },
    existingInvestmentPin() {
      if (this.googleMapsSdkReady)
        return new google.maps.marker.PinElement({
          glyphColor: "#b5abda",
          background: "#8e7cc3",
          borderColor: "#8e7cc3"
        }).element;
    },
    featuredPin() {
      if (this.googleMapsSdkReady)
        return new google.maps.marker.PinElement({
          glyphColor: "#cadff3",
          background: "#6fa8dc",
          borderColor: "#6fa8dc"
        }).element;
    }
  },
  mounted() {
    this.aclLoaded.then(async () => await this.$gmapApiPromiseLazy()).then(() => this.mapInit()).then(async () => await this.loadMarketplace()).catch((e) => {
      Se(e);
    });
  }
}), jos = { class: "card shadow card-na" }, Hos = {
  class: "bg-light d-flex align-items-center justify-content-center position-relative",
  style: { height: "330px", width: "100%" }
}, Uos = {
  id: "mapControls",
  class: "position-absolute d-flex justify-content-between gap-2 flex-column",
  style: { "z-index": "100", bottom: "15px", right: "15px" }
};
function zos(e, t, s, n, r, i) {
  const o = pe("GMapAdvMarker"), l = pe("GMapMap");
  return p(), h("div", jos, [
    t[4] || (t[4] = a("div", { class: "card-header bg-white fw-bold border-0 fs-6" }, [
      a("img", {
        src: Fm,
        height: "17",
        class: "me-2"
      }),
      y(" Rescover Marketplace Listings ")
    ], -1)),
    a("div", Hos, [
      a("div", Uos, [
        a("button", {
          onClick: t[0] || (t[0] = (...d) => e.zoomIn && e.zoomIn(...d)),
          class: "btn btn-light shadow-sm"
        }, t[2] || (t[2] = [
          a("i", { class: "fa-light fa-plus" }, null, -1),
          a("span", { class: "visually-hidden" }, "Zoom in", -1)
        ])),
        a("button", {
          onClick: t[1] || (t[1] = (...d) => e.zoomOut && e.zoomOut(...d)),
          class: "btn btn-light shadow-sm"
        }, t[3] || (t[3] = [
          a("i", { class: "fa-light fa-minus" }, null, -1),
          a("span", { class: "visually-hidden" }, "Zoom out", -1)
        ]))
      ]),
      N(l, {
        ref: "gMap",
        class: "h-100 w-100",
        "map-id": "2ddbbe0dd6bcf8f9",
        center: e.center,
        options: e.mapOptions
      }, {
        default: ve(() => [
          (p(!0), h(A, null, D(e.listings, (d, c) => (p(), Fe(o, {
            key: d.id,
            position: { lat: d.latitude, lng: d.longitude },
            gmpClickable: !0,
            gmpDraggable: !1,
            content: e.featuredPin(),
            "z-index": 1e3,
            title: e.markerTitle(d),
            onClick: (u) => e.markerClick(u, d)
          }, null, 8, ["position", "content", "title", "onClick"]))), 128))
        ]),
        _: 1
      }, 8, ["center", "options"])
    ])
  ]);
}
const rcs = /* @__PURE__ */ Ae(Nos, [["render", zos]]), Wos = me({
  name: "DashboardCheckList",
  props: {},
  components: {
    DataTable: yn,
    Column: bn
  },
  data() {
    return {
      tasks: [],
      loadingTasks: !1,
      totalTasks: 0,
      page: 1,
      pageSize: 5
    };
  },
  computed: {
    ...q(Te, ["access", "aclLoaded"])
  },
  methods: {
    number: Ve,
    typeName(e) {
      switch (e.type) {
        case iv.ConfirmInvestmentDetails:
          return "Confirm Investment Details";
        default:
          return console.warn(`Unknown PropertyGroupTaskType encountered: ${e.type}`), `Unknown Task Type: ${e.type}`;
      }
    },
    async getTasks() {
      try {
        this.loadingTasks = !0;
        const e = await W.api.accountCheckList.getCheckListItems(this.page, this.pageSize);
        if (e.data.status != de.Success)
          throw new Le(e);
        this.totalTasks = e.data.total ?? 0, this.tasks = e.data.page || [];
      } catch (e) {
        Se(e), this.tasks = [], this.totalTasks = 0;
      } finally {
        this.loadingTasks = !1;
      }
    },
    async viewTask(e) {
      e.address ? e.groupId && e.propId ? this.$router.push({ name: "folio-my-investments-property", params: { portfolioId: e.groupId, propId: e.propId }, hash: "#ConfirmInvestmentDetails" }) : console.error("Invalid task parameters for navigation:", e) : this.$router.push({ name: "account-settings", params: {}, hash: "#" + e.fragment });
    },
    onPage(e) {
      this.page = e.page + 1, this.getTasks();
    }
  },
  created() {
  },
  mounted() {
    this.aclLoaded.then(async () => {
      try {
        await this.getTasks();
      } catch (e) {
        console.error("Error during getTasks initialization:", e), Se(e);
      }
    }).catch((e) => {
      console.error("Error during aclLoaded initialization:", e), Se(e);
    });
  }
}), Gos = { class: "card shadow-sm flex-fill loading overflow-hidden card-na" }, Yos = { class: "card-body" }, Xos = ["onClick"];
function qos(e, t, s, n, r, i) {
  const o = pe("loading-card"), l = pe("Column"), d = pe("DataTable");
  return p(), h("div", Gos, [
    N(o),
    t[3] || (t[3] = a("div", { class: "card-header fw-bold border-0 bg-white fs-5 text-body-secondary pb-0 d-flex align-items-center" }, [
      a("img", {
        src: Nk,
        height: "17",
        class: "me-2"
      }),
      y("Account Setup Tasks ")
    ], -1)),
    a("div", Yos, [
      P("", !0),
      N(d, {
        value: e.tasks,
        lazy: !0,
        paginator: !0,
        rows: e.pageSize,
        dataKey: "id",
        totalRecords: e.totalTasks,
        loading: e.loadingTasks,
        paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport",
        stripedRows: "",
        rowsPerPageOptions: [5, 10, 25, 50],
        currentPageReportTemplate: "Showing {first} to {last} of {totalRecords} entries",
        onPage: t[0] || (t[0] = (c) => e.onPage(c))
      }, {
        empty: ve(() => t[1] || (t[1] = [
          y(" All tasks complete ")
        ])),
        loading: ve(() => t[2] || (t[2] = [
          a("div", { class: "bg-accentgreenblue rounded-pill px-3 py-1 text-white" }, [
            a("span", {
              class: "spinner-border spinner-border-sm me-2",
              role: "status",
              "aria-hidden": "false"
            }),
            y(" Loading tasks... ")
          ], -1)
        ])),
        default: ve(() => [
          N(l, { header: "Task" }, {
            body: ve((c) => [
              c.data.address ? (p(), h(A, { key: 1 }, [
                y(g(c.data.address) + " - " + g(e.typeName(c.data)), 1)
              ], 64)) : (p(), h(A, { key: 0 }, [
                y(g(c.data.description), 1)
              ], 64))
            ]),
            _: 1
          }),
          N(l, null, {
            body: ve((c) => [
              a("button", {
                type: "button",
                class: "btn btn-success btn-sm",
                onClick: (u) => e.viewTask(c.data)
              }, "View", 8, Xos)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["value", "rows", "totalRecords", "loading"])
    ])
  ]);
}
const ocs = /* @__PURE__ */ Ae(Wos, [["render", qos]]);
export {
  Htt as APOD,
  Els as AccountSettingsIntegrations,
  Ids as Agent,
  rls as AgentRoster,
  Cs as Alert,
  jo as AlertPosition,
  fn as AlertType,
  kgt as AllPropertyRecords,
  Hn as AnalysisMode,
  Fls as AnalysisRequestHeader,
  Jls as AppreciationAndPrincipalReduction,
  dds as AssetReviewTab,
  Als as Automation,
  lds as BRRRRTab,
  Pls as Billing,
  Sls as BillingSubscriptions,
  AG as BrandAdministrators,
  kls as BrandAssociation,
  fY as BrandIntegrations,
  $G as BrandMembers,
  His as BrandPortal,
  Uis as Branding,
  $ds as BrandingCardFull,
  cFe as BrandingHeader,
  EIt as BrrrrProForma,
  K4 as CenterTextPlugin,
  dX as CircleStencil,
  fd as ClientInviteStatus,
  Tls as ClientRelationships,
  Eds as ClientValue,
  sds as CommunityData,
  Yis as CompanyBranding,
  tu as ComputeAmortizationSchedule,
  Pt as ConfirmedPurchaseFacts,
  Jis as CrmConnection,
  els as CrmIdxSettings,
  _is as CrmPfSettings,
  tls as CrmPpeSettings,
  bt as CrmProviders,
  $is as CrmUsers,
  Jmt as CurrentPropertyRecords,
  kds as CustomOwners,
  ocs as DashboardCheckList,
  rcs as DashboardMarketplaceListingsLocations,
  ncs as DashboardPropertyLocations,
  Ab as DateInput,
  ols as DefaultAgent,
  ils as DefaultSearchArea,
  Iis as DictionaryType,
  Uds as DropZone,
  oU as EasterEgg,
  jls as EditPropertyDetailsDialog,
  _n as ErrorIds,
  Le as Exception,
  Bls as ExistingInvestment,
  nds as ExpenseLedger,
  Pds as Favorites,
  Vls as FeaturedInvestmentOpportunities,
  cls as FeaturedListingAuthority,
  Ga as FeaturedType,
  Oa as Features,
  Sds as FiduciaryOwners,
  zds as FileList,
  Gds as FilePreview,
  YJe as FinancialIndicators,
  Zu as FlipInitialInvestment,
  ids as FlipTab,
  Lls as ForeclosureData,
  xr as ForeclosureFilingType,
  Zp as GLEntryTypes,
  qo as GeoJsonGeometryTypeEnum,
  mls as GlAccountMapping,
  Ar as GlAccountStatus,
  gls as GlNonOperatingExpense,
  fls as GlOperatingExpense,
  Yds as GoogleMap,
  Mz as GoogleMapCluster,
  VHt as GoogleMapColorRenderer,
  RU as GoogleMapMap,
  xU as GoogleMapMarker,
  En as GoogleMapUtility,
  Ils as GuidedTourOption,
  Dc as HandleErrors,
  qls as HomesPropertyTile,
  dls as IdxLeadAssignment,
  Cds as IgnoredOwners,
  ln as IncomeExpenseAccountType,
  Zis as IncomeExpenseAccounts,
  Ra as IncomeOrExpenseType,
  Rls as InvestmentGatewayClients,
  wds as InvestmentManagers,
  Qds as InvestmentSpecialist,
  $n as InvestmentStrategy,
  qis as InvestorsDefaultFinancial,
  Qis as InvestorsDefaultPerformance,
  Zb as IonRangeSlider,
  Ads as LeadStats,
  sp as LicensedProducts,
  Xh as ListingChangeType,
  Tis as ListingStatus,
  Kb as ListingTile,
  scs as ListingsCarousel,
  qu as LoadingCard,
  Gk as LoadingStatus,
  Jp as LoanAmountMethod,
  Qo as ManagementAreaTypes,
  Xis as ManagementTerritory,
  De as Manifest,
  ecs as MarketReport,
  ym as MelissaData,
  uP as MemberStatus,
  pls as MlsAccess,
  Nls as MlsAgentInfo,
  Ois as MlsEntityType,
  zls as MlsHistory,
  hls as MlsIdentifiers,
  Dls as MlsListingInfo,
  pds as MlsSearchAdv,
  cr as MlsSortBy,
  Zt as ModelStateException,
  uls as NeighborhoodsSettings,
  EW as NotificationSeverity,
  Lf as NotificationType,
  Xds as NotificationsBar,
  Aa as NumericalInput,
  bds as OwnerContactInfo,
  yds as OwnerProperties,
  vds as OwnersAgents,
  pn as PMT,
  Ck as Pagination,
  rds as ParametersTab,
  Zds as PermissionsViewer,
  yls as Personalization,
  Tds as PfActiveCampaign,
  Qb as PfLeadSimple,
  Lds as PfTargetName,
  Rds as PfTargetValue,
  Ods as PfZoho,
  vls as PmConnection,
  rXt as PortfolioFinderPropertyTile,
  nls as PortfolioFinderSearchArea,
  tcs as PortfolioFinderTargets,
  Ols as PortfolioInsightsClients,
  Mds as PortfolioInsightsFinancialIndicators,
  xds as PortfolioInsightsFinancialOverview,
  Hds as PortfolioInsightsMyCurrentAssets,
  Fds as PortfolioInsightsOwnerChecklist,
  Vds as PortfolioInsightsPerformanceCharts,
  jds as PortfolioInsightsPropertyLocations,
  Nds as PortfolioInsightsSummary,
  Dds as PortfolioInsightsSummaryView,
  acs as PortfolioSummary,
  Ris as PpeAutoReleaseType,
  bls as PpeLeadAssignment,
  Mls as PreForeclosureNotice,
  hds as PreForeclosureSearch,
  dcs as PrimeVueConfig,
  Kls as ProformaTab,
  Hb as ProformaTotalInvestment,
  Zls as ProjectedAccumulationOfWealth,
  fds as PropGroup,
  Wls as PropertyDetails,
  TW as PropertyErrorType,
  Gls as PropertyFiles,
  iv as PropertyGroupTaskType,
  Xt as PropertyGroupType,
  Xls as PropertyInstances,
  ri as PropertyManagementFeeTypes,
  gds as PropertyManagers,
  Yls as PropertyPhotos,
  Qls as PropertyReszy,
  _ds as PropertySearch,
  FW as PropertyStoreInitializeException,
  xls as PropertyToolBar,
  Qa as PropertyType,
  Uls as PropertyValue,
  Vt as PurchaseMethod,
  lMt as RangeSlider,
  Xc as RangeType,
  Na as RateLimit,
  kE as RecordedOwnerNames,
  ads as RecordsOwnerContactInfo,
  ods as RecordsTab,
  $p as RenovationCostMethod,
  _ls as RentVsSellTab,
  Cls as RentalAnalysisRequests,
  dA as RentalIncomeCalculationMethods,
  Hls as RentalRate,
  Kis as RentalRateAdjustment,
  Bds as RentalScoutSearch,
  v$t as RentalScoutSearchForm,
  Ut as RentalType,
  nt as RentalTypeComparisonTypes,
  cA as ReportFrequency,
  de as RequestStatus,
  bb as SaveButton,
  Jds as SavedSearchUpdates,
  $ls as ScenariosTab,
  Wis as SchedulingUrl,
  tds as SchoolInformation,
  eds as SchoolMap,
  yYt as SearchForm,
  mds as SearchLeads,
  pP as SearchRequestType,
  Or as SearchType,
  Mis as SentryPlugin,
  Kds as SessionState,
  als as SettingsClientValue,
  sls as SkipTraceSettings,
  Nl as SortBy,
  U as StandardIncomeExpenseAccounts,
  t1 as Str,
  _we as SubscriptionManagement,
  qds as SubscriptionOptions,
  mLt as TagInput,
  x$ as TagsInput,
  Spt as TaxAsessorData,
  Gis as TeamMembers,
  Wds as UploadableFile,
  zis as UserOptions,
  Kn as ViewType,
  xis as VueGoogleMapsPlugin,
  MLt as VueTagsAdv,
  Wk as VueTagsInput,
  wls as WidgetSettings,
  lls as ZipCodesSettings,
  _z as addDays,
  bU as clarityIntegration,
  ry as coalesceArray,
  dr as coalesceEmpty,
  Ws as coalesceZero,
  h9 as cookies,
  jis as copySearchParameters,
  Ld as createAnnualCashFlowBarData,
  Bd as createAnnualCashFlowBarOptions,
  pk as createAppreciationOfWealthData,
  hk as createAppreciationOfWealthOptions,
  Rd as createBarMarkerTextPlugin,
  tr as createChartConfig,
  lf as createCoCLineData,
  df as createCoCOptions,
  ck as createIRRAndOnePercentRuleLineData,
  uk as createIRRAndOnePercentRuleLineOptions,
  lk as createIncomeAndExpensesBarData,
  dk as createIncomeAndExpensesBarOptions,
  Ze as currency,
  Yu as currencyOptCents,
  Xu as currentMonth,
  Et as currentYear,
  cs as date,
  rd as dateFormat,
  nf as dateTime,
  $H as dateTimeUTC,
  Y4 as dateUTC,
  ol as daysSince,
  Zj as debounce,
  qz as dummy,
  qj as escapeHtml,
  W4 as fileSize,
  Td as findMyLocation,
  sb as formatDate,
  af as formatDuration,
  Bis as formatters,
  Xz as gaugeOptions,
  dP as getBrowserLocales,
  cP as getDefaultBrowserLocale,
  is as hasBits,
  cf as hoursSince,
  fk as isDstObserved,
  Xj as isEmpty,
  lb as isError,
  pi as isIncomeExpenseAccountError,
  gh as isNegativeZero,
  vm as isText,
  od as isoDateFormat,
  Vis as keys,
  Ma as kilo,
  gk as minutesSince,
  G4 as month,
  Ve as number,
  eW as paginate,
  vs as parse,
  Wt as percent,
  X4 as percentAutoDec,
  Qz as promiseTimeout,
  Qv as refreshToken,
  jn as reportError,
  Dis as rescoverApi,
  OE as resize,
  cds as scroll,
  $z as secondsSince,
  Kz as setDebugConsole,
  ka as shortCurrency,
  vr as shortNumber,
  Ss as showAlert,
  Se as showError,
  wt as showSuccess,
  rf as showTab,
  Mi as showWarning,
  Rl as sortCustom,
  Nis as sortNonOperating,
  Zz as sortNumbers,
  Cg as sortOtherExpense,
  o2 as sortOtherIncome,
  SW as sortOtherNonOperExpense,
  PI as startCountDown,
  rb as stdTimezoneOffset,
  uds as stickyNavBar,
  Kp as storageAvailable,
  Jo as test,
  db as timeSince,
  Kj as totalHours,
  sf as totalMillisecond,
  mm as totalMinutes,
  Zv as totalSeconds,
  pU as trackTabs,
  ct as useAccountStore,
  bm as useAnalysisRequestsStore,
  Te as useAuthStore,
  il as useCacheStore,
  Mn as useCrmStore,
  Ci as useNotificationsStore,
  Ba as usePortfolioFinderStore,
  ba as usePortfolioInsightsStore,
  qe as usePropertyStore,
  vn as useSubscriptionStore,
  Fis as utils,
  Jz as waitTimeout
};
//# sourceMappingURL=rescover-library.js.map
